/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(405);
	module.exports = __webpack_require__(865);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(128);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(252);
	
	var _reduxThunk = __webpack_require__(928);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _Reducer = __webpack_require__(874);
	
	var _Reducer2 = _interopRequireDefault(_Reducer);
	
	var _ProdLogger = __webpack_require__(879);
	
	var _ProdLogger2 = _interopRequireDefault(_ProdLogger);
	
	var _environmentNames = __webpack_require__(244);
	
	var _environmentNames2 = _interopRequireDefault(_environmentNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function getMiddleware() {
	    var middleware = [_reduxThunk2.default];
	
	    if (("production") === _environmentNames2.default.PRODUCTION) {
	        middleware.push(_ProdLogger2.default);
	    } else {
	        var createLogger = __webpack_require__(927);
	
	        var debugLogger = createLogger();
	        middleware.push(debugLogger);
	    }
	
	    return middleware;
	}
	
	var createStoreWithMiddleware = _redux.applyMiddleware.apply(undefined, _toConsumableArray(getMiddleware()))(_redux.createStore);
	
	var storeManager = {
	    store: undefined,
	
	    setStore: function setStore(newStore) {
	        this.store = newStore;
	        return this;
	    },
	    getStore: function getStore() {
	        return this.store;
	    },
	    getState: function getState() {
	        return this.getStore().getState();
	    },
	    configureStore: function configureStore() {
	        var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return createStoreWithMiddleware(_Reducer2.default, initialState);
	    },
	    configureAndSetStore: function configureAndSetStore() {
	        var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var newStore = createStoreWithMiddleware(_Reducer2.default, initialState);
	        this.setStore(newStore);
	        return newStore;
	    }
	};
	
	exports.default = storeManager;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/store/StoreManager.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/store/StoreManager.js"); } } })();

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	    init: function init() {
	        if (_PlatformDetection2.default.isIOS() == true) {
	            this.BROWSER_WIDTH = 226;
	        }
	    },
	
	
	    // canvas properties
	    CANVAS_VERTICAL_TOP_PADDING: 5,
	    CANVAS_VERTICAL_BOTTOM_PADDING: 5,
	    CANVAS_HORIZONTAL_PADDING: 0,
	
	    // menus properties
	    INSERT_MENU_WIDTH: 130,
	    INSERT_MENU_HEIGHT: 180,
	    INSERT_MENU_BUTTON_SIZE: 42,
	    INSERT_MENU_BUTTON_HOVER_COLOR: 'black',
	    INSERT_MENU_BUTTON_COLOR: '#2479BE',
	    SLIDE_MENU_WIDTH: 105,
	    SLIDE_MENU_HEIGHT: 200,
	    SLIDE_MENU_BUTTON_HEIGHT: 40,
	    SLIDE_MENU_COLOR: '#FFFFFF',
	    SLIDE_MENU_HOVER_COLOR: '#EBEBEB',
	    SHAPE_MENU_WIDTH: 116,
	    SHAPE_MENU_BUTTON_HEIGHT: 40,
	    MAIN_MENU_WIDTH: 38,
	    MAIN_RESIZE_BUTTON_WIDTH: 15,
	
	    // browser accordion properties
	    CLIPART_BUTTON_HEIGHT_OLD: 40,
	    CLIPART_BUTTON_HEIGHT: 30,
	    BROWSER_BUTTON_HEIGHT: 30,
	    UNIVERSE_BUTTON_HEIGHT: 38,
	    ANIMATION_STEP: 50,
	    BROWSER_WIDTH: 328,
	    BROWSER_ICON_RIGHT_PADDING: 18,
	    BROWSER_LEFT_PADDING: 20,
	    BROWSER_SELECTED_COLOR: '#434343',
	    CLIPART_BUTTON_COLOR: '#318dcf',
	    BROWSER_COLOR: '#F7F7F7',
	    BROWSER_HOVER_COLOR: '#EBEBEB',
	
	    // buttons holder style
	    BUTTONS_HOLDER_WIDTH: 220,
	    BUTTONS_HOLDER_COLLAPSED_WIDTH: 70,
	    BUTTONS_HOLDER_LEFT_GAP: 7,
	    BUTTONS_HOLDER_TOP_GAP: 8,
	    SLIDE_VIEWER_BUTTONS_GAP: 8,
	
	    // slideViewer properties
	    SLIDE_VIEWER_HORIZONTAL_GAP: 10,
	    SLIDE_VIEWER_BACKGROUND: '#D7D7D7',
	    SLIDE_VIEWER_LIST_BACKGROUND: '#D7D7D7',
	    SLIDE_VIEWER_TOP_GAP: 5,
	    SLIDE_VIEWER_BUTTON_SELECTED_COLOR: '#2196F3',
	    SLIDE_VIEWER_MIDDLE_GAP: 5,
	    SLIDE_VIEWER_BOTTOM_GAP: 5,
	    SLIDE_VIEWER_BUTTON_WIDTH: 40,
	    SLIDE_VIEWER_TOP_LINE_HEIGHT: 0,
	    SLIDE_VIEWER_LIST_HEIGHT: 81,
	    SLIDE_ITEM_WIDTH: 105,
	    SLIDE_GAP: 5,
	    SLIDE_SELECTION_WIDTH: 2,
	    SLIDE_SELECTION_COLOR: '#ff00ff',
	    SLIDE_PADDING_DROP: 50,
	    SLIDE_MENU_BUTTON_TOP_PADDING: 11,
	    SLIDE_MENU_BUTTON_RIGHT_PADDING: 5,
	    SLIDE_FRAME_SELECTED_COLOR: '#2D2D2D',
	    SLIDE_FRAME_HOVER_COLOR: '#0090E8',
	    SLIDE_MENU_BUTTON_SIZE: 30,
	    SHAPE_MENU_BUTTON_SIZE: 30,
	    GROUP_BUTTON_WIDTH: 220,
	    GROUP_BUTTON_HEIGHT: 40,
	    ADD_MUSIC_BACKGROUND: '#F6F6F6',
	    ADD_MUSIC_HEIGHT: 38,
	    ADD_MUSIC_BUTTON_HEIGHT: 28,
	    ADD_MUSIC_BUTTON_WIDTH: 110,
	    STORY_SOUND_BUTTON_WIDTH: 300,
	    ADD_MUSIC_BUTTON_BACKGROUND: '#FFFFFF',
	
	    // preview menu
	    PREVIEW_HEIGHT: 45,
	    PREVIEW_COLOR: '#D7D7D7',
	    PREVIEW_BUTTON_SIZE: 20,
	    PREVIEW_BUTTON_COLOR: '#FFFFFF',
	    PREVIEW_BUTTONS_GAP: 10,
	
	    // recording menu
	    RECORDING_MENU_HEIGHT: 38,
	    RECORDING_MENU_BACKGROUND: '#D7D7D7',
	    RECORDING_BUTTON_HEIGHT: 28,
	    RECORDING_PLAY_BUTTON_WIDTH: 53,
	    RECORDING_DURATION_BUTTON_WIDTH: 70,
	    RECORDING_DURATION_BUTTON_EXPANDED: 190,
	    RECORGING_SLIDER_WIDTH: 125,
	    RECORDING_GAP: 15,
	    RECORDING_RECORD_WIDTH: 98,
	    RECORDING_SOUND_BUTTON_WIDTH: 70,
	
	    //Object Advanced menu
	    OBJECT_ADVANCED_BUTTON_HEIGHT: 50,
	    OBJECT_ADVANCED_MIDDLE_GAP: 20,
	    CONTEXT_HOVER_COLOR: '#0090E8',
	    EFFECTS_PADDING: 20,
	    EFFECTS_BUTTON_HEIGHT: 40,
	    EFFECTS_BUTTON_BORDER_COLOR: '#E1E1E1',
	    EFFECTS_LIST_PADDING: 5,
	    EFFECTS_CORNER_GAP: 15,
	
	    //Styling menu
	    STYLING_TOP_GAP: 20,
	    STYLING_LEFT_GAP: 20,
	    STYLING_BUTTON_HEIGHT: 45,
	    STYLING_SLIDER_HEIGHT: 35,
	    STYLING_THUMB_SIZE: 25,
	
	    //ColorPicker
	    RAINBOW_SELECTOR_SIZE: 24,
	    RAINBOW_SELECTOR_STROKE_WIDTH: 2,
	    RAINBOW_WIDTH: 10,
	    RAINBOW_HEIGHT: 210,
	    COLOR_GRADIENT_SELECTOR_SIZE: 20,
	    COLOR_GRADIENT_SELECTOR_STROKE_WIDTH: 2,
	
	    //Text Styling menu
	    TEXT_STYLING_BUTTON_WIDTH: 50,
	    TEXT_STYLING_BUTTON_HEIGHT: 35,
	
	    //Toggle button
	    TOGGLE_TRACK_WIDTH: 60,
	    TOGGLE_TRACK_HEIGHT: 19,
	    TOGGLE_THUMB_SIZE: 25,
	
	    // keyboard commands
	    MOVE_SHAPE_OFFSET: 5,
	    MOVE_SHAPE_BIG_OFFSET: 15,
	
	    DURATION_SLIDER_COLOR: '#767676',
	
	    MENUS_BORDER_COLOR: '#E1E1E1',
	    SOUND_EVEN_COLOR: '#F0F0F0',
	    SOUND_ODD_COLOR: '#FFFFFF',
	    SOUND_ITEM_HEIGHT: 40,
	    SOUND_ITEMS_GAP: 8,
	
	    MOOD_ITEM_SIZE: 170,
	    MOOD_ITEM_GAP: 10,
	
	    MY_MEDIA_FILES_GAP: 10,
	
	    SHAPE_SIZE: 100,
	    MIND_MAP_NODE_SIZE: 100,
	    IMAGE_SIZE: 250,
	    TEXT_WIDTH: 150,
	    TEXT_HEIGHT: 100,
	    RICH_TEXT_WIDTH: 220,
	    RICH_TEXT_HEIGHT: 45,
	
	    TEXT_PADDING: 0,
	    TEXT_INNER_PADDING: 7,
	    MIN_FONT_SIZE: 5,
	    MAX_FONT_SIZE: 500,
	
	    //Delete Alert
	    DELETE_ALERT_BACKGROUND: '#333333',
	    DELETE_ALERT_BACKGROUND_OPACITY: 0.7,
	    DELETE_ALERT_WIDTH: 550,
	    DELETE_ALERT_TOP_BAR_HEIGHT: 40,
	    DELETE_ALERT_BOTTOM_BAR_HEIGHT: 300,
	    DELETE_ALERT_BUTTON_WIDTH: 100,
	    DELETE_ALERT_BUTTON_HEIGHT: 30,
	    DELETE_ALERT_BUTTON_GAP: 20,
	
	    //Record ToolTip
	    RECORD_TOOLTIP_WIDTH: 198,
	    RECORD_TOOLTIP_STEM_SIZE: 12,
	    RECORD_TOOLTIP_BACKGROUND: '#434343',
	
	    //Navigation Bar
	    DESCRIBE_BOX_WIDTH: 300,
	
	    //AudioEditor
	    AUDIO_TIMELINE_HEIGHT: 50,
	    AUDIO_BORDER: '#5B5B5B',
	    LINE_SIZE: 2,
	    LINE_HOLDER_HEIGHT: 14,
	    LINE_HOLDER_HEIGHT_IOS: 25,
	    SLIDE_EXTENDED_BACKGROUND_COLOR: '#00B2EE',
	    ARROW_SIZE: 20,
	    SOUND_GAP: 7,
	    TITLE_WIDTH: 100,
	    RULER_HEIGHT: 30,
	    DELETE_BUTTON_SIZE: 26,
	    SPLIT_BUTTON_SIZE: 32,
	    AUDIO_MINIMUM_LENGTH: 0.5, // Seconds
	    AUDIO_EDITOR_BUTTON_GAP: 10,
	    AUDIO_CONTROL_POINT_SIZE: 14,
	    AUDIO_CONTROL_POINT_SIZE_IOS: 25,
	    VOLUME_CONTROL_LINE_SIZE: 2,
	
	    CATEGORY_SELECTOR_GAP: 10,
	    CATEGORY_SELECTOR_HEIGHT: 60,
	
	    //AudioTool
	    AUDIO_TIMELINE_BIG_HEIGHT: 70,
	    HEADER_HEIGHT: 120,
	    HEADER_HEIGHT_APP: 120,
	    PLAYER_BAR_HEIGHT: 120,
	    PLAYER_BAR_HEIGHT_FOR_CARTOONIST: 65,
	    PLAYHEAD_SIZE: 40,
	    PLAYHEAD_SIZE_FOR_CARTOONIST: 20,
	    AUDIO_BROWSER_SCROLL_WIDTH: 20,
	
	    AUTO_SCROLL_STEP: 30,
	
	    SEARCH_HEIGHT: function SEARCH_HEIGHT() {
	        if (_PlatformDetection2.default.isIOS()) return this.CLIPART_BUTTON_HEIGHT_OLD;else return this.CLIPART_BUTTON_HEIGHT;
	    }
	};
	
	exports.default = properties;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/constants/Properties.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/constants/Properties.js"); } } })();

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var core = __webpack_require__(74);
	var hide = __webpack_require__(59);
	var redefine = __webpack_require__(60);
	var ctx = __webpack_require__(70);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mouseUtils = {
	    isCanvasAction: false,
	    mouseDownTime: 0,
	    mouseUpTime: 0,
	    isDragEnd: false,
	    isFirstMarkerFocus: true,
	    activeElement: '',
	
	    rejectMouseEvent: function rejectMouseEvent(event) {
	        var isTouchEvent = false;
	
	        if (event.touches != undefined) isTouchEvent = true;
	
	        if (isTouchEvent == true) {
	            // stop touch event ... the also the corresponding mouse event is stopped
	            event.preventDefault();
	        }
	
	        return false;
	    },
	    getTouchPosition: function getTouchPosition(e) {
	        if (e.clientX != undefined) {
	            // is MouseEvent
	            return { x: e.clientX, y: e.clientY };
	        } else {
	            if (e.touches.length > 0) return { x: e.touches[0].clientX, y: e.touches[0].clientY };else return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
	        }
	    },
	    getLocalPosition: function getLocalPosition(e, target) {
	        var isOy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	        var touchPoint, local, global;
	
	        if (isOy) {
	            if (e.offsetY != undefined) // is MouseEvent
	                return e.offsetY;else {
	                if (e.touches.length > 0) touchPoint = e.touches[0];else touchPoint = e.changedTouches[0];
	
	                if (!touchPoint || !target) return 0;
	
	                local = touchPoint.clientY;
	                global = target.getBoundingClientRect().top;
	
	                return local - global;
	            }
	        } else {
	            if (e.offsetX != undefined) // is MouseEvent
	                return e.offsetX;else {
	                if (e.touches.length > 0) touchPoint = e.touches[0];else touchPoint = e.changedTouches[0];
	
	                if (!touchPoint || !target) return 0;
	
	                local = touchPoint.clientX;
	                global = target.getBoundingClientRect().left;
	
	                return local - global;
	            }
	        }
	    },
	
	
	    isChangeSlidePositionMode: false,
	    holdTimerVar: undefined,
	    startDrag: undefined,
	    touchPosition: undefined,
	    refreshScrollFunction: undefined,
	    changeSlideFunction: undefined,
	
	    pressDownAndHold: function pressDownAndHold(callBackfunction, touchPosition, changeSlideFunction) {
	        if (_PlatformDetection2.default.isIOS() == false) return;
	
	        this.changeSlideFunction = changeSlideFunction;
	        this.startDrag = callBackfunction;
	        this.touchPosition = touchPosition;
	
	        //this.resetSlidePositionMode();
	        this.holdTimerVar = setTimeout(this.activateChangeSlidePositionMode.bind(this), 1.5 * 1000);
	    },
	    activateChangeSlidePositionMode: function activateChangeSlidePositionMode() {
	        this.isChangeSlidePositionMode = true;
	        this.holdTimerVar = undefined;
	
	        if (this.startDrag && this.touchPosition) this.startDrag(this.touchPosition);
	    },
	    resetSlidePositionMode: function resetSlidePositionMode(offsetX, offsetY) {
	        if (_PlatformDetection2.default.isIOS() == false) return;
	
	        this.isChangeSlidePositionMode = false;
	
	        if (this.refreshScrollFunction) this.refreshScrollFunction();
	
	        if (this.holdTimerVar) clearTimeout(this.holdTimerVar);
	
	        this.checkIfIsClick(offsetX, offsetY);
	    },
	    checkIfIsClick: function checkIfIsClick(offsetX, offsetY) {
	        var range = 20;
	
	        if (Math.abs(offsetX) < range && Math.abs(offsetY) < range) {
	            // it's a click
	            if (this.changeSlideFunction != undefined) this.changeSlideFunction();
	        }
	    },
	    isActive: function isActive() {
	        if (_PlatformDetection2.default.isIOS() == false) return true;
	
	        return this.isChangeSlidePositionMode;
	    },
	
	
	    isKeyboardShortcut: false,
	
	    setFocusSequence: function setFocusSequence() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        var isSearchContext = _StoreManager2.default.getState().menu.contextMode === _ModeConstants2.default.SEARCH_CONTEXT;
	
	        if (isSearchContext) return;
	
	        setTimeout(function () {
	            var isMainUniverse = _StoreManager2.default.getState().menu.isMainUniverse;
	            var isThemesVisible = _StoreManager2.default.getState().menu.isUniversesVisible;
	            var element;
	
	            if (isMainUniverse) element = document.getElementById('firstUniverseElement');else if (isThemesVisible) element = document.getElementById('firstThemeElement');else element = document.getElementById('backgroundElement');
	
	            if (element) element.focus();
	        }.bind(this), 100);
	    }
	};
	
	exports.default = mouseUtils;
	module.exports = exports["default"];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/MouseUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/MouseUtils.js"); } } })();

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var platformDetection = {
	    //Safari with IOS 13: Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/ 13.0.1 Safari/605.1.15
	    //Safari with IOS < 13: Mozilla/5.0 (iPad; CPU OS 13_1_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Mobile/15E148 Safari/604.1
	    isIOS: function isIOS() {
	        var IOS = navigator.userAgent.match(/iPad/i) != null || navigator.userAgent.indexOf('Mac') != -1 && navigator.maxTouchPoints > 1;
	
	        return IOS;
	    },
	
	    //Windows Chrome : Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/61.0.3163.100 Safari/537.36
	    //WebView IOS: Mozilla/5.0 (iPad; CPU OS 9_3_5 like Mac OS X) AppleWebKit/601 (KHTML, like Gecko) Mobile/13G36
	    isIOSApp: function isIOSApp() {
	        var IOS = navigator.userAgent.match(/iPad/i) != null || navigator.userAgent.indexOf('Mac') != -1 && navigator.maxTouchPoints > 1;
	        var ua = window.navigator.userAgent;
	        var isBrowser = ua.indexOf('Safari') > 0;
	
	        if (IOS && !isBrowser) return true;else return false;
	    },
	    isMac: function isMac() {
	        var ua = window.navigator.userAgent;
	
	        if ((ua.indexOf('Mac') > 0 || ua.indexOf('mac') > 0) && !(navigator.maxTouchPoints > 1)) return true;else return false;
	    },
	    isIE: function isIE() {
	        var ua = window.navigator.userAgent;
	        var msie = ua.indexOf('MSIE '); // IE 10 or older
	        var trident = ua.indexOf('Trident/'); // IE 11
	
	        if (msie > 0 || trident > 0) return true;else return false;
	    },
	    isEdge: function isEdge() {
	        var ua = window.navigator.userAgent;
	
	        if (ua.indexOf('Edg') > 0) return true;else return false;
	    },
	    isFirefox: function isFirefox() {
	        var ua = window.navigator.userAgent;
	
	        if (ua.indexOf('Firefox') > 0) return true;else return false;
	    },
	    isSafari: function isSafari() {
	        if (navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0) return true;else return false;
	    },
	    isChrome: function isChrome() {
	        if (window.chrome && window.chrome.webstore) return true;else return false;
	    },
	    isChromeBook: function isChromeBook() {
	        var ua = window.navigator.userAgent;
	        var chromeBook = ua.indexOf('CrOS');
	
	        if (chromeBook > 0) return true;else return false;
	    },
	    isWindowSourface: function isWindowSourface() {
	        var navigator = window.navigator;
	        var ua = window.navigator.userAgent;
	        var isTouchDevice = 'ontouchstart' in window || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints || ua.indexOf('Touch') != -1 || ua.indexOf('ARM') != -1 || ua.indexOf('Tablet') != -1;
	
	        if (isTouchDevice == true) return true;else return false;
	    },
	    isMixedDevice: function isMixedDevice() {
	        if (this.isChromeBook() == true || this.isWindowSourface() == true) return true;else return false;
	    },
	    isTouchableDevice: function isTouchableDevice() {
	        // var isTouchDevice = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
	        //
	        // if (isTouchDevice)
	        //     return true;
	
	        if (this.isChromeBook() || this.isIOS() == true || this.isWindowSourface() == true) return true;else return false;
	    },
	    isAndroid: function isAndroid() {
	        var ua = window.navigator.userAgent.toLowerCase();
	        var isAndroid = ua.indexOf('android') > -1;
	
	        return isAndroid;
	    },
	    isSafariNonIOS: function isSafariNonIOS() {
	        if (!this.isIOS() && this.isSafari()) return true;else return false;
	    },
	
	    showSafariAlert: false
	};
	
	exports.default = platformDetection;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/PlatformDetection.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/PlatformDetection.js"); } } })();

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.changeSlideMenuPosition = changeSlideMenuPosition;
	exports.setContextTarget = setContextTarget;
	exports.changeContextMode = changeContextMode;
	exports.hideMenus = hideMenus;
	exports.showMenu = showMenu;
	exports.changeStyleTab = changeStyleTab;
	exports.expandEffectsList = expandEffectsList;
	exports.expandFontsList = expandFontsList;
	exports.expandFontSizeList = expandFontSizeList;
	exports.expandFontLineHeight = expandFontLineHeight;
	exports.expandAudioList = expandAudioList;
	exports.selectMyMediaCategory = selectMyMediaCategory;
	exports.showDeleteAlert = showDeleteAlert;
	exports.showAlternativeTextMenu = showAlternativeTextMenu;
	exports.showDeleteTrackAlert = showDeleteTrackAlert;
	exports.showAdvancedModeAlert = showAdvancedModeAlert;
	exports.showExportAlert = showExportAlert;
	exports.showLostSessionAlert = showLostSessionAlert;
	exports.showPreloader = showPreloader;
	exports.showSavePreloader = showSavePreloader;
	exports.showZoomSlides = showZoomSlides;
	exports.showCroppingMenu = showCroppingMenu;
	exports.printMode = printMode;
	exports.printTemplate = printTemplate;
	exports.useImageAsBackground = useImageAsBackground;
	exports.useBackgroundAsImage = useBackgroundAsImage;
	exports.useFrameAsImage = useFrameAsImage;
	exports.useVideoAsBackground = useVideoAsBackground;
	exports.setRecordingStatus = setRecordingStatus;
	exports.showDescription = showDescription;
	exports.exitAlert = exitAlert;
	exports.hasNotAccess = hasNotAccess;
	exports.changeClipartCategory = changeClipartCategory;
	exports.showVideoEditor = showVideoEditor;
	exports.updateControlPoint = updateControlPoint;
	exports.refreshVideoEditor = refreshVideoEditor;
	exports.changeDrawingProperties = changeDrawingProperties;
	exports.groupDrawingShapes = groupDrawingShapes;
	exports.showAudioEditor = showAudioEditor;
	exports.changeAudioTabIndex = changeAudioTabIndex;
	exports.changeCartoonistTabIndex = changeCartoonistTabIndex;
	exports.expandClipartIOSButtons = expandClipartIOSButtons;
	exports.showAudioAlert = showAudioAlert;
	exports.setButtonsHolderWidth = setButtonsHolderWidth;
	exports.updateCurrentSlideContent = updateCurrentSlideContent;
	exports.showRecorder = showRecorder;
	exports.showTextEditor = showTextEditor;
	exports.showMainUniverse = showMainUniverse;
	exports.refreshThemeSelector = refreshThemeSelector;
	exports.refreshTextEditorTool = refreshTextEditorTool;
	exports.refreshShapePosition = refreshShapePosition;
	var types = exports.types = {
	    CHANGE_SLIDE_MENU_POSITION: 'change_slide_menu_position',
	    SET_CONTEXT_TARGET: 'set_context_target',
	    CHANGE_CONTEXT_MODE: 'change_context_mode',
	    HIDE_MENUS: 'hide_menus',
	    SHOW_MENU: 'show_menu',
	    CHANGE_STYLE_TAB: 'change_style_tab',
	    EXPAND_EFFECTS_LIST: 'expand_effects_list',
	    EXPAND_FONTS_LIST: 'expand_fonts_list',
	    EXPAND_FONT_SIZE_LIST: 'expand_font_size_list',
	    EXPAND_FONT_LINE_HEIGHT: 'expand_font_line_height',
	    EXPAND_AUDIO_LIST: 'expand_audio_list',
	    SELECT_MY_MEDIA_CATEGORY: 'select_my_media_category',
	    SHOW_DELETE_ALERT: 'show_delete_alert',
	    SHOW_ALTERNATIVE_TEXT_MENU: 'show_alternative_text_menu',
	    SHOW_DELETE_TRACK_ALERT: 'show_delete_track_alert',
	    SHOW_EXPORT_ALERT: 'show_export_alert',
	    SHOW_PRELOADER: 'show_preloader',
	    SHOW_SAVE_PRELOADER: 'show_save_preloader',
	    SHOW_LOST_SESSION_ALERT: 'show_lost_session_alert',
	    SHOW_ZOOM_SLIDES: 'show_zoom_slides',
	    SHOW_CROPPING_MENU: 'show_cropping_menu',
	    PRINT_MODE: 'print_mode',
	    PRINT_TEMPLATE: 'print_template',
	    USE_IMAGE_AS_BACKGROUND: 'use_image_as_background',
	    USE_BACKGROUND_AS_IMAGE: 'use_background_as_image',
	    USE_FRAME_AS_IMAGE: 'use_frame_as_image',
	    USE_VIDEO_AS_BACKGROUND: 'use_video_as_background',
	    SET_RECORDING_STATUS: 'set_recording_status',
	    SHOW_DESCRIPTION: 'show_description',
	    EXIT_ALERT: 'exit_alert',
	    HAS_NOT_ACCESS: 'hasNotAccess',
	    CHANGE_CLIPART_CATEGORY: 'change_clipart_category',
	    SHOW_VIDEO_EDITOR: 'show_video_editor',
	    UPDATE_CONTROL_POINT: 'update_control_point',
	    REFRESH_VIDEO_EDITOR: 'refresh_video_editor',
	    CHANGE_DRAWING_PROPERTIES: 'change_drawing_properties',
	    GROUP_DRAWING_SHAPES: 'group_drawing_shapes',
	    SHOW_AUDIO_EDITOR: 'show_audio_editor',
	    SHOW_ADVANCED_MODE_ALERT: 'show_advanced_mode_alert',
	    CHANGE_AUDIO_TAB_INDEX: 'change_audio_tab_index',
	    CHANGE_CARTOONIST_TAB_INDEX: 'change_cartoonist_tab_index',
	    EXPAND_CLIPART_IOS_BUTTONS: 'expand_clipart_ios_buttons',
	    SHOW_AUDIO_ALERT: 'show_audio_alert',
	    SET_BUTTONS_HOLDER_WIDTH: 'set_buttons_holder_width',
	    UPDATE_CURRENT_SLIDE_CONTENT: 'update_current_slide_content',
	    SHOW_RECORDER: 'show_recorder',
	    SHOW_TEXT_EDITOR: 'show_text_editor',
	    SHOW_MAIN_UNIVERSE: 'show_main_universe',
	    REFRESH_THEME_SELECTOR: 'refresh_theme_selector',
	    REFRESH_TEXT_EDITOR_TOOL: 'refresh_text_editor_tool',
	    REFRESH_SHAPE_POSITION: 'refresh_shape_position'
	};
	
	function changeSlideMenuPosition(left) {
	    return { type: types.CHANGE_SLIDE_MENU_POSITION, left: left };
	}
	
	function setContextTarget(model) {
	    var visibleShapeMenu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    return { type: types.SET_CONTEXT_TARGET, model: model, visibleShapeMenu: visibleShapeMenu };
	}
	
	function changeContextMode(mode) {
	    return { type: types.CHANGE_CONTEXT_MODE, mode: mode };
	}
	
	function hideMenus(menuTypes) {
	    return { type: types.HIDE_MENUS, menuTypes: menuTypes };
	}
	
	function showMenu(menuType) {
	    return { type: types.SHOW_MENU, menuType: menuType };
	}
	
	function changeStyleTab(selectedTab) {
	    return { type: types.CHANGE_STYLE_TAB, selectedTab: selectedTab };
	}
	
	function expandEffectsList(isExpanded) {
	    return { type: types.EXPAND_EFFECTS_LIST, isExpanded: isExpanded };
	}
	
	function expandFontsList(isExpanded) {
	    return { type: types.EXPAND_FONTS_LIST, isExpanded: isExpanded };
	}
	
	function expandFontSizeList(isExpanded) {
	    return { type: types.EXPAND_FONT_SIZE_LIST, isExpanded: isExpanded };
	}
	
	function expandFontLineHeight(isExpanded) {
	    return { type: types.EXPAND_FONT_LINE_HEIGHT, isExpanded: isExpanded };
	}
	
	function expandAudioList(isExpanded, listType) {
	    return { type: types.EXPAND_AUDIO_LIST, isExpanded: isExpanded, listType: listType };
	}
	
	function selectMyMediaCategory(category) {
	    return { type: types.SELECT_MY_MEDIA_CATEGORY, category: category };
	}
	
	function showDeleteAlert(value) {
	    return { type: types.SHOW_DELETE_ALERT, value: value };
	}
	
	function showAlternativeTextMenu(value) {
	    return { type: types.SHOW_ALTERNATIVE_TEXT_MENU, value: value };
	}
	
	function showDeleteTrackAlert(value) {
	    return { type: types.SHOW_DELETE_TRACK_ALERT, value: value };
	}
	
	function showAdvancedModeAlert(value) {
	    return { type: types.SHOW_ADVANCED_MODE_ALERT, value: value };
	}
	
	function showExportAlert(value) {
	    return { type: types.SHOW_EXPORT_ALERT, value: value };
	}
	
	function showLostSessionAlert(value) {
	    return { type: types.SHOW_LOST_SESSION_ALERT, value: value };
	}
	
	function showPreloader(value) {
	    return { type: types.SHOW_PRELOADER, value: value };
	}
	
	function showSavePreloader(value) {
	    return { type: types.SHOW_SAVE_PRELOADER, value: value };
	}
	
	function showZoomSlides(value) {
	    return { type: types.SHOW_ZOOM_SLIDES, value: value };
	}
	
	function showCroppingMenu(value) {
	    return { type: types.SHOW_CROPPING_MENU, value: value };
	}
	
	function printMode(value) {
	    return { type: types.PRINT_MODE, value: value };
	}
	
	function printTemplate(value) {
	    return { type: types.PRINT_TEMPLATE, value: value };
	}
	
	function useImageAsBackground(value) {
	    return { type: types.USE_IMAGE_AS_BACKGROUND, value: value };
	}
	
	function useBackgroundAsImage(value) {
	    return { type: types.USE_BACKGROUND_AS_IMAGE, value: value };
	}
	
	function useFrameAsImage(value) {
	    return { type: types.USE_FRAME_AS_IMAGE, value: value };
	}
	
	function useVideoAsBackground(value) {
	    return { type: types.USE_VIDEO_AS_BACKGROUND, value: value };
	}
	
	function setRecordingStatus(recordingStatus) {
	    return { type: types.SET_RECORDING_STATUS, recordingStatus: recordingStatus };
	}
	
	function showDescription(value) {
	    return { type: types.SHOW_DESCRIPTION, value: value };
	}
	
	function exitAlert(value) {
	    return { type: types.EXIT_ALERT, value: value };
	}
	
	function hasNotAccess(value) {
	    return { type: types.HAS_NOT_ACCESS, value: value };
	}
	
	function changeClipartCategory(value) {
	    return { type: types.CHANGE_CLIPART_CATEGORY, value: value };
	}
	
	function showVideoEditor(value) {
	    return { type: types.SHOW_VIDEO_EDITOR, value: value };
	}
	
	function updateControlPoint(value) {
	    return { type: types.UPDATE_CONTROL_POINT, value: value };
	}
	
	function refreshVideoEditor(value) {
	    return { type: types.REFRESH_VIDEO_EDITOR, value: value };
	}
	
	function changeDrawingProperties(property, value) {
	    return { type: types.CHANGE_DRAWING_PROPERTIES, property: property, value: value };
	}
	
	function groupDrawingShapes(value) {
	    return { type: types.GROUP_DRAWING_SHAPES, value: value };
	}
	
	function showAudioEditor(value) {
	    return { type: types.SHOW_AUDIO_EDITOR, value: value };
	}
	
	function changeAudioTabIndex(index) {
	    return { type: types.CHANGE_AUDIO_TAB_INDEX, index: index };
	}
	
	function changeCartoonistTabIndex(index) {
	    return { type: types.CHANGE_CARTOONIST_TAB_INDEX, index: index };
	}
	
	function expandClipartIOSButtons(value) {
	    return { type: types.EXPAND_CLIPART_IOS_BUTTONS, value: value };
	}
	
	function showAudioAlert(value, title) {
	    return { type: types.SHOW_AUDIO_ALERT, value: value, title: title };
	}
	
	function setButtonsHolderWidth(value) {
	    return { type: types.SET_BUTTONS_HOLDER_WIDTH, value: value };
	}
	
	function updateCurrentSlideContent(value) {
	    return { type: types.UPDATE_CURRENT_SLIDE_CONTENT, value: value };
	}
	
	function showRecorder(value) {
	    return { type: types.SHOW_RECORDER, value: value };
	}
	
	function showTextEditor(textShape) {
	    return { type: types.SHOW_TEXT_EDITOR, textShape: textShape };
	}
	
	function showMainUniverse(value) {
	    return { type: types.SHOW_MAIN_UNIVERSE, value: value };
	}
	
	function refreshThemeSelector() {
	    return { type: types.REFRESH_THEME_SELECTOR };
	}
	
	function refreshTextEditorTool() {
	    return { type: types.REFRESH_TEXT_EDITOR_TOOL };
	}
	
	function refreshShapePosition(uuid) {
	    return { type: types.REFRESH_SHAPE_POSITION, uuid: uuid };
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/actions/MenuActions.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/actions/MenuActions.js"); } } })();

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _SessionUtils = __webpack_require__(373);
	
	var _SessionUtils2 = _interopRequireDefault(_SessionUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appParameters = {
	    contentItemId: -1,
	    contentRevisionId: -1,
	    submitId: -1,
	    clipartId: -1,
	    exerciseId: -1,
	    assignmentFolderId: -1,
	    collaboration: false,
	    isNewCartoonist: true, // true: load JSon/ false: load xml
	    context: _Configuration2.default.CONTEXT,
	    locale: 'en_US',
	    title: 'Cartoonist',
	    defaultTitle: 'Cartoonist',
	    navBarTitle: 'Cartoonist',
	    newClipartId: -1,
	    masterClipartId: _Configuration2.default.MASTER_CLIPART_ID,
	    thumbnailsUrl: undefined,
	    assetsUrl: undefined,
	    assignmentStatus: undefined,
	    creatorUserId: -1,
	    currentUserId: -1,
	    isEmbedded: false,
	    bundleVersion: '1.0.6',
	    isMasterProduction: false, // should not be overrided,
	    isMaster: false,
	    isExercise: false,
	    isIcsx: false,
	    navBarDescription: 'Description',
	    navBarThumbnailId: -1,
	    iframeSrc: '',
	    playerHref: '', // used to go back from FULLSCREEN mode to PORTFOLIO
	    playerCurrentTime: -1,
	    isFullscreen: false,
	    token: '',
	    urlSchemeId: -1,
	    backToDashboardLink: undefined,
	    downloadId: -1,
	    isExportTab: false,
	    videoClipartId: -1,
	    s3key: undefined,
	    stringId: undefined,
	    isAudioToken: false,
	    isAssignment: false,
	    exerciseThumbnailUrl: undefined,
	    exportId: -1,
	    isExternVideo: false,
	    masterAssignmentId: -1,
	    currentTheme: '',
	    currentMainUniverse: '',
	    currentVideoTheme: '',
	    isTest: false,
	
	    getParameters: function getParameters() {
	        var parameters = this.getJsonFromUrl();
	
	        if (!parameters) return;
	
	        if (parameters.isTest && parameters.isTest.length > 0) this.isTest = this.toBoolean(parameters.isTest);
	
	        if (parameters.token && parameters.token.length > 0 && parameters.token != 'undefined') this.token = parameters.token;
	
	        if (parameters.cartoonistVersion && parameters.cartoonistVersion.length > 0 && parameters.cartoonistVersion != 'undefined') this.bundleVersion = parameters.cartoonistVersion;
	
	        if (parameters.masterAssignmentId && parameters.masterAssignmentId.length > 0 && parameters.masterAssignmentId != 'undefined') this.masterAssignmentId = parameters.masterAssignmentId;
	
	        if (parameters.userId && parameters.userId.length > 0 && parameters.userId != 'undefined') this.currentUserId = parseInt(parameters.userId);
	
	        if (parameters.exportId && parameters.exportId.length > 0 && parameters.exportId != 'undefined') this.exportId = parseInt(parameters.exportId);
	
	        if (parameters.isExternVideo) this.isExternVideo = this.toBoolean(parameters.isExternVideo);
	
	        if (parameters.locale && parameters.locale.length > 0 && parameters.locale != 'undefined') {
	            if (parameters.locale.indexOf('fr_FR') != -1 || parameters.locale.indexOf('es_ES') != -1 || parameters.locale.indexOf('da_DK') != -1) {
	                // for spanish, french, danish users we should load the english translations -- CH-671 and CART-1284
	            } else {
	                this.locale = parameters.locale;
	            }
	
	            if (this.locale === 'no_NO') this.locale = 'nb_NO';
	
	            if (this.locale === 'no_NO_NY') this.locale = 'nn_NO';
	        }
	
	        if (parameters.context && parameters.context.length > 0 && parameters.context != 'undefined') this.context = parameters.context;
	
	        if (parameters.isAudioToken) this.isAudioToken = this.toBoolean(parameters.isAudioToken);
	
	        if (this.isAudioToken) this.context = _ModeConstants2.default.AUDIO_TOOL;
	
	        if (this.context == _ModeConstants2.default.AUDIO_TOOL) {
	            this.title = 'AudioEditor';
	            this.defaultTitle = 'AudioEditor';
	            this.navBarTitle = 'AudioEditor';
	        }
	
	        if (parameters.clipartId && parameters.clipartId.length > 0 && parameters.clipartId != 'undefined') this.clipartId = parseInt(parameters.clipartId);
	
	        if (parameters.submitId && parameters.submitId.length > 0 && parameters.submitId != 'undefined') this.submitId = parseInt(parameters.submitId);
	
	        if (parameters.exerciseId && parameters.exerciseId.length > 0 && parameters.exerciseId != 'undefined') this.exerciseId = parseInt(parameters.exerciseId);
	
	        if (parameters.id && parameters.id.length > 0 && parameters.id != 'undefined') this.contentItemId = parseInt(parameters.id);
	
	        if (parameters.isExercise && parameters.isExercise.length > 0) this.isExercise = this.toBoolean(parameters.isExercise);
	
	        if (parameters.isMaster && parameters.isMaster.length > 0) this.isMaster = this.toBoolean(parameters.isMaster);
	
	        if (parameters.assignmentStatus && parameters.assignmentStatus == 'INVITED' && parameters.title && parameters.title == 'CartoonistMasterSweden') this.isMaster = true;
	
	        // When you click on an exercise, it can have contentItemId > 0 because it was created from another product.
	        // An assignment link ... the only situation when submitId > 0 for a production which wasn't already saved
	
	        if (_Configuration2.default.IS_PROD() == true) {
	            this.masterClipartId = _Configuration2.default.MASTER_CLIPART_ID_PROD;
	
	            if (this.isMaster || this.clipartId == this.masterClipartId || this.clipartId == 62315556 || this.contentItemId == 62344225) {
	                // if is master clipart then as first universe load Ancient Greece
	                // if (this.locale == 'sv_SE')
	                //     this.clipartId = 70622606; // Sweden universe
	                // else
	                this.clipartId = _Configuration2.default.DEFAULT_CLIPART_ID_PROD;
	
	                this.isMasterProduction = true;
	
	                // hack for CH-470 ... this new master universe production wasn't created properly
	                if (this.contentItemId == 62344225) this.contentItemId = -1;
	
	                // A production with submit < 0 can have contentItemId > 0 (it's an exercise based on a production) ... but in this case it's the master so it should be empty
	                if (this.submitId < 0) this.contentItemId = -1;
	            }
	
	            //TODO: Now, the only situation when the master clipart can be overrided is when for the master clipartId is changed and that master production is assigned with link to another user ... then that user can save the master with his own content
	        } else {
	            if (this.isMaster || this.clipartId == this.masterClipartId) {
	                // if is master clipart then as first universe load Ancient Greece
	                // if (this.locale == 'sv_SE')
	                //     this.clipartId = 70622606; // Sweden universe
	                // else
	                this.clipartId = _Configuration2.default.DEFAULT_CLIPART_ID;
	
	                this.isMasterProduction = true;
	
	                if (this.submitId < 0) this.contentItemId = -1;
	            }
	        }
	
	        if (this.token.length > 0) {
	            if (parameters.id && parameters.id.length > 0) this.urlSchemeId = parseInt(parameters.id);
	
	            _SessionUtils2.default.doLogin(this.token, this.urlSchemeId);
	            return;
	        }
	
	        if (this.context == _ModeConstants2.default.DOWNLOAD) {
	            if (parameters.backToDashboardLink && parameters.backToDashboardLink.length > 0) this.backToDashboardLink = parameters.backToDashboardLink;
	
	            if (parameters.downloadId && parameters.downloadId.length > 0) this.downloadId = parseInt(parameters.downloadId);
	
	            if (parameters.isExportTab && parameters.isExportTab.length > 0) this.isExportTab = true;
	
	            return;
	        }
	
	        if (parameters.submitId == undefined && parameters.exerciseId == undefined) this.isIcsx = true;
	
	        if (parameters.title && parameters.title.length > 0 && parameters.title.indexOf('CartoonistMaster') < 0 && parameters.title.indexOf('Cartoonist Master') < 0 && !this.isMaster) this.title = this.getCorrectTitle(parameters.title);
	
	        if (parameters.contentRevisionId && parameters.contentRevisionId.length > 0) this.contentRevisionId = parseInt(parameters.contentRevisionId);
	
	        if (parameters.assignmentStatus && parameters.assignmentStatus.length > 0 && parameters.assignmentStatus.length != 'undefined') this.assignmentStatus = parameters.assignmentStatus;
	
	        if (parameters.embedded && parameters.embedded.length > 0) this.isEmbedded = this.toBoolean(parameters.embedded);
	
	        if (parameters.isFullscreen && parameters.isFullscreen.length > 0) this.isFullscreen = this.toBoolean(parameters.isFullscreen);
	
	        if (parameters.assignmentFolderId && parameters.assignmentFolderId.length > 0) this.assignmentFolderId = parseInt(parameters.assignmentFolderId);
	
	        if (parameters.collaboration && parameters.collaboration.length > 0) this.collaboration = parameters.collaboration;
	
	        if (parameters.playerHref && parameters.playerHref.length > 0) this.playerHref = unescape(parameters.playerHref);
	
	        if (parameters.playerCurrentTime && parameters.playerCurrentTime.length > 0) this.playerCurrentTime = parseFloat(parameters.playerCurrentTime);
	
	        if (this.isPrintMode() == true) return;
	
	        if (_Configuration2.default.LOAD_LOCAL == false) this.getTitle();
	
	        if (_PlatformDetection2.default.isIOS()) _PreviewCommands2.default.isIOSFullScreen = this.isFullscreen;
	    },
	    getCorrectTitle: function getCorrectTitle(title) {
	        if (title.indexOf('<br>') != -1) title = title.replace('<br>', '');
	
	        return title;
	    },
	    toBoolean: function toBoolean(value) {
	        if (value == 'true' || value == true) return true;else return false;
	    },
	    getMode: function getMode() {
	        if (this.context == 'audioTool') return _ModeConstants2.default.AUDIO_TOOL;
	
	        if (this.context == 'audioToolPlayer') return _ModeConstants2.default.AUDIO_TOOL_PLAYER;
	
	        if (this.context == 'download') return _ModeConstants2.default.DOWNLOAD;
	
	        if (this.context == 'edit') return _ModeConstants2.default.EDITOR;else return _ModeConstants2.default.PLAYER;
	    },
	    isCartoonistPlayer: function isCartoonistPlayer() {
	        if (this.context == _ModeConstants2.default.PLAYER || this.context == 'player') return true;else return false;
	    },
	    isPrintMode: function isPrintMode() {
	        if (this.context == 'print') return true;else return false;
	    },
	    getJsonFromUrl: function getJsonFromUrl() {
	        var arg = window.location.search;
	
	        this.iframeSrc = window.location.href;
	        var parameters = arg.substr(1);
	        var result = {};
	
	        parameters.split('&').forEach(function (part) {
	            var item = part.split('=');
	            result[item[0]] = decodeURIComponent(item[1]);
	        });
	
	        return result;
	    },
	    checkType: function checkType(data) {
	        if (data && (data.indexOf('<structureElement') != -1 || data.indexOf('<contentItemXML') != -1)) this.isNewCartoonist = false;
	    },
	    getTitle: function getTitle() {
	        if (this.context == 'edit' || this.context == _ModeConstants2.default.AUDIO_TOOL) {
	            _ApiServiceUtils2.default.executeSafeApiCall(this.executeGetTitleCall.bind(this));
	        }
	    },
	    executeGetTitleCall: function executeGetTitleCall() {
	        var _this = this;
	
	        if (appParameters.submitId < 0) {
	            // is exercise ... so get exercise title
	            if (appParameters.exerciseId > 0) {
	                _ApiService2.default.getExercisesTitle(appParameters.exerciseId).then(function (response) {
	                    return _this.titleResponse(response);
	                });
	            }
	        } else {
	            _ApiService2.default.getSubmitTitle(appParameters.submitId).then(function (response) {
	                return _this.titleResponse(response);
	            });
	        }
	    },
	    titleResponse: function titleResponse(response) {
	        if (response) {
	            if (response.assignment) this.isAssignment = true;
	
	            if (response.title) {
	                // get exercise title
	                this.title = this.getCorrectTitle(response.title);
	                this.navBarTitle = this.title;
	                this.navBarDescription = response.description;
	                this.navBarThumbnailId = response.thumbnailId;
	
	                if (!this.isMaster) this.exerciseThumbnailUrl = response.thumbnailURL;
	            } else {
	                if (response.assignment && response.assignment.title) {
	                    // get assignment title
	                    if (this.title == this.defaultTitle || !this.isExercise) this.title = this.getCorrectTitle(response.assignment.title);
	
	                    this.navBarTitle = this.title;
	                    this.navBarDescription = response.assignment.description;
	                    this.navBarThumbnailId = response.assignment.thumbnail;
	                } else if (response.content && response.content.title) {
	                    // get production title
	                    if (this.title == this.defaultTitle) this.title = this.getCorrectTitle(response.content.title);
	
	                    this.navBarTitle = this.title;
	                    this.navBarDescription = response.content.description;
	
	                    if (response.content.thumbnail > 0) this.navBarThumbnailId = response.content.thumbnail;else this.navBarThumbnailId = response.content.thumbnailId;
	
	                    if (response.content.s3Key) this.s3key = response.content.s3Key;
	                }
	
	                if (response.assignment && response.assignment.creator) this.creatorUserId = response.assignment.creator.id;
	            }
	        }
	    },
	    setCloudfronUrls: function setCloudfronUrls(thumbnailsUrl, assetsUrl) {
	        if (this.thumbnailsUrl != undefined) return;
	
	        this.thumbnailsUrl = 'https://' + thumbnailsUrl + '/staticthumbs/svg/';
	        this.assetsUrl = 'https://' + assetsUrl + '/';
	    },
	    SVG_URL: function SVG_URL() {
	        return 'https://creaza-cartoonist-svg.s3.eu-west-1.amazonaws.com/'; // load from s3 directly
	    },
	    THUMBNAIL_URL: function THUMBNAIL_URL() {
	        if (_Configuration2.default.LOAD_LOCAL == true) return this.stageClipartBucket() + '/staticthumbs/svg/';else {
	            if (this.thumbnailsUrl != undefined) return this.thumbnailsUrl;
	
	            if (_Configuration2.default.IS_PROD() == true) this.thumbnailsUrl = this.clipartBucket() + '/staticthumbs/svg/'; // creaza-clipart.s3.amazonaws.com
	            else this.thumbnailsUrl = this.stageClipartBucket() + '/staticthumbs/svg/'; // creaza-clipart-test.s3.amazonaws.com
	
	            return this.thumbnailsUrl;
	        }
	    },
	    RESOURCES_LOCATION: function RESOURCES_LOCATION() {
	        var bundleVersion = '1.0.2';
	
	        if (this.bundleVersion) bundleVersion = this.bundleVersion;
	
	        if (_Configuration2.default.LOAD_LOCAL == true) return this.staticBucket() + '/releases/1.0.2/';else {
	            if (_Configuration2.default.IS_PROD() == true) return this.staticBucket() + '/releases/' + bundleVersion + '/';else return this.stageStaticBucket() + '/releases/' + bundleVersion + '/';
	        }
	    },
	    getContentItemId: function getContentItemId() {
	        if (this.contentRevisionId > 0) return this.contentRevisionId;else return this.contentItemId;
	    },
	    clipartBucket: function clipartBucket() {
	        return 'https://clipart.creaza.com'; // CNAME
	        // return 'https://d3b76ijxom7qfl.cloudfront.net'; // cloudfront
	        // return 'https://creaza-clipart.s3.amazonaws.com'; // S3
	    },
	    svgBucket: function svgBucket() {
	        return 'https://svg-cartoonist.creaza.com/'; // CNAME
	        // return 'https://d9e59cbjty4wx.cloudfront.net/'; // cloudfront
	        // return 'https://creaza-cartoonist-svg.s3.amazonaws.com'; // S3
	    },
	    staticBucket: function staticBucket() {
	        return 'https://static-cartoonist.creaza.com'; // CNAME
	        // return 'https://d2u42v3s6h8hv7.cloudfront.net'; // cloudfront
	        // return 'https://creaza-static.s3.amazonaws.com/cartoonist'; // S3
	    },
	    stageStaticBucket: function stageStaticBucket() {
	        return 'https://d2gmmubf5igsdk.cloudfront.net';
	    },
	    stageClipartBucket: function stageClipartBucket() {
	        return 'https://d1a6w8sjwfrc1s.cloudfront.net';
	    }
	};
	
	exports.default = appParameters;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/AppParameters.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/AppParameters.js"); } } })();

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _SessionActions = __webpack_require__(120);
	
	var _SessionActions2 = _interopRequireDefault(_SessionActions);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var localesManager = {
	    data: undefined,
	    initialized: false,
	    moods: undefined,
	    themeCategories: undefined,
	    cartoonistCaptions: undefined,
	
	    init: function init() {
	        if (_Configuration2.default.LOAD_LOCAL) {
	            var store = _StoreManager2.default.getStore();
	            store.dispatch(_SessionActions2.default.setCaptionsLoaded());
	
	            return;
	        }
	
	        if (this.initialized) return;
	
	        this.initialized = true;
	
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.EDITOR) {
	            this.loadMoods();
	            this.loadThemeCategories();
	        }
	
	        this.loadCartoonistCaptions();
	    },
	    language: function language() {
	        return _AppParameters2.default.locale;
	    },
	    loadMoods: function loadMoods() {
	        var _this = this;
	
	        _ApiService2.default.loadMoods().then(function (response) {
	            _this.moods = response;
	        });
	    },
	    loadThemeCategories: function loadThemeCategories() {
	        var _this2 = this;
	
	        _ApiService2.default.loadThemeCategories().then(function (response) {
	            _this2.themeCategories = response;
	        });
	    },
	    loadCartoonistCaptions: function loadCartoonistCaptions() {
	        var _this3 = this;
	
	        _ApiService2.default.loadCartoonistCaptions().then(function (response) {
	            _this3.cartoonistCaptions = response;
	
	            var store = _StoreManager2.default.getStore();
	            store.dispatch(_SessionActions2.default.setCaptionsLoaded());
	        });
	    },
	    getTranslation: function getTranslation(captionName, categoryObject) {
	        if (!categoryObject) return captionName;
	
	        var translationsObject = categoryObject[captionName];
	
	        if (!translationsObject) return captionName;
	
	        var translation = translationsObject[this.language()];
	
	        if (translation) return translation;
	
	        var englishTranslation = translationsObject['en_US'];
	
	        if (englishTranslation) return englishTranslation;else return captionName;
	    },
	    getMoodsCaption: function getMoodsCaption(captionName) {
	        return this.getTranslation(captionName, this.moods);
	    },
	    getThemeCategoryCaption: function getThemeCategoryCaption(captionName) {
	        return this.getTranslation(captionName, this.themeCategories);
	    },
	    getCaption: function getCaption(captionName) {
	        var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	        var fullCaption = category.length > 0 ? category + '_' + captionName : captionName;
	
	        if (!this.cartoonistCaptions) return fullCaption;
	
	        var translationsObject = this.cartoonistCaptions[this.language()];
	        var caption;
	
	        if (translationsObject) {
	            caption = translationsObject[fullCaption];
	
	            if (caption) return caption;else return fullCaption;
	        } else {
	            translationsObject = this.cartoonistCaptions['en_US'];
	
	            if (translationsObject) {
	                caption = translationsObject[fullCaption];
	
	                if (caption) return caption;else return fullCaption;
	            } else return fullCaption;
	        }
	    },
	    currentLanguage: function currentLanguage() {
	        return _AppParameters2.default.locale;
	    }
	};
	
	exports.default = localesManager;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/locales/LocalesManager.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/locales/LocalesManager.js"); } } })();

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(880);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(881);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setCurrentSlide = setCurrentSlide;
	exports.updateShapePosition = updateShapePosition;
	exports.updateShapeSize = updateShapeSize;
	exports.updateShapeRotation = updateShapeRotation;
	exports.updateNonRectangularShape = updateNonRectangularShape;
	exports.updateBubbleControlPoint = updateBubbleControlPoint;
	exports.selectShape = selectShape;
	exports.createShape = createShape;
	exports.changeBackgroundContent = changeBackgroundContent;
	exports.updateCurrentSlideThumbnail = updateCurrentSlideThumbnail;
	exports.initSlide = initSlide;
	exports.duplicateShape = duplicateShape;
	exports.deleteShape = deleteShape;
	exports.addVideoShapeDuration = addVideoShapeDuration;
	exports.updateVideoShape = updateVideoShape;
	exports.lockShape = lockShape;
	exports.bringToFront = bringToFront;
	exports.sendToBack = sendToBack;
	exports.bringForward = bringForward;
	exports.sendBackward = sendBackward;
	exports.changeFilter = changeFilter;
	exports.changeSlideDuration = changeSlideDuration;
	exports.changeAlternativeText = changeAlternativeText;
	exports.changeStrokeSize = changeStrokeSize;
	exports.changeShapeOpacity = changeShapeOpacity;
	exports.changeShapeStrokeOpacity = changeShapeStrokeOpacity;
	exports.changeShapeFillColor = changeShapeFillColor;
	exports.changeShapeStrokeColor = changeShapeStrokeColor;
	exports.changeTextProperties = changeTextProperties;
	exports.setShortcutsTarget = setShortcutsTarget;
	exports.moveShape = moveShape;
	exports.updateTextProperties = updateTextProperties;
	exports.setCloneTarget = setCloneTarget;
	exports.updateCurrentSlideIndex = updateCurrentSlideIndex;
	exports.canvasUndoRedoAction = canvasUndoRedoAction;
	exports.changeMood = changeMood;
	exports.selectLastAddedShape = selectLastAddedShape;
	exports.updateTextHeight = updateTextHeight;
	exports.changeShapeFillVisibility = changeShapeFillVisibility;
	exports.changeIsNewShape = changeIsNewShape;
	exports.setSlideSound = setSlideSound;
	exports.setSlideSoundEffect = setSlideSoundEffect;
	exports.changeInteractionState = changeInteractionState;
	exports.updateCurrentSlideMoods = updateCurrentSlideMoods;
	exports.oldTextResized = oldTextResized;
	exports.updateImageHeight = updateImageHeight;
	exports.updateImageSize = updateImageSize;
	exports.updateImageSizeWhenChangeMood = updateImageSizeWhenChangeMood;
	exports.updateHospot = updateHospot;
	exports.updateCroppingHospot = updateCroppingHospot;
	exports.changeShapesPosition = changeShapesPosition;
	exports.selectShapeFromArea = selectShapeFromArea;
	exports.createGroup = createGroup;
	exports.ungroup = ungroup;
	exports.changeVideoProperties = changeVideoProperties;
	exports.changeSlideSoundVolume = changeSlideSoundVolume;
	exports.addAnimation = addAnimation;
	exports.removeAnimation = removeAnimation;
	exports.animate = animate;
	exports.updateStem = updateStem;
	exports.changeShapeType = changeShapeType;
	exports.changeRichTextContent = changeRichTextContent;
	exports.changeTextLineHeight = changeTextLineHeight;
	exports.changeFlip = changeFlip;
	exports.insertImageNode = insertImageNode;
	var types = exports.types = {
	    SET_CURRENT_SLIDE: 'set_current_slide',
	    UPDATE_CURRENT_SLIDE_INDEX: 'update_current_slide_index',
	    UPDATE_SHAPE_POSITION: 'update_shape_position',
	    UPDATE_SHAPE_SIZE: 'update_shape_size',
	    UPDATE_SHAPE_ROTATION: 'update_shape_rotation',
	    UPDATE_NON_RECTANGULAR_SHAPE: 'update_non_rectangular_shape',
	    UPDATE_BUBBLE_CONTROL_POINT: 'update_bubble_control_point',
	    SELECT_SHAPE: 'select_shape',
	    CREATE_SHAPE: 'create_shape',
	    DUPLICATE_SHAPE: 'duplicate_shape',
	    DELETE_SHAPES: 'delete_shapes',
	    LOCK_SHAPE: 'lock_shape',
	    CHANGE_BACKGROUND_CONTENT: 'change_background_content',
	    UPDATE_CURRENT_SLIDE_THUMBNAIL: 'udpate_current_slide_thumbnail',
	    INIT_SLIDE: 'init_slide',
	    BRING_TO_FRONT: 'bring_to_front',
	    SEND_TO_BACK: 'send_to_back',
	    BRING_FORWARD: 'bring_forward',
	    SEND_BACKWARD: 'send_backward',
	    CHANGE_FILTER: 'change_filter',
	    CHANGE_SLIDE_DURATION: 'change_slide_duration',
	    CHANGE_ALTERNATIVE_TEXT: 'change_alternative_text',
	    CHANGE_STROKE_SIZE: 'change_stroke_size',
	    CHANGE_SHAPE_OPACITY: 'change_shape_opacity',
	    CHANGE_SHAPE_STROKE_OPACITY: 'change_shape_stroke_opacity',
	    CHANGE_SHAPE_FILL_COLOR: 'change_shape_fill_color',
	    CHANGE_SHAPE_STROKE_COLOR: 'change_shape_stroke_color',
	    CHANGE_TEXT_PROPERTIES: 'change_text_properties',
	    SET_SHORTCUTS_TARGET: 'set_shortcuts_target',
	    MOVE_SHAPE: 'move_shape',
	    UPDATE_TEXT_PROPERTIES: 'update_text_properties',
	    SET_CLONE_TARGET: 'set_clone_target',
	    CANVAS_UNDO_REDO_ACTION: 'canvas_undo_redo_action',
	    CHANGE_MOOD: 'change_mood',
	    SELECT_LAST_ADDED_SHAPE: 'select_last_added_shape',
	    UPDATE_TEXT_HEIGHT: 'update_text_height',
	    CHANGE_SHAPE_FILL_VISIBILITY: 'change_shape_fill_visibility',
	    CHANGE_IS_NEW_SHAPE: 'change_is_new_shape',
	    SET_SLIDE_SOUND: 'set_slide_sound',
	    SET_SLIDE_SOUND_EFFECT: 'set_slide_sound_effect',
	    CHANGE_INTERACTION_STATE: 'change_interaction_state',
	    UPDATE_CURRENT_SLIDE_MOODS: 'update_current_slide_moods',
	    OLD_TEXT_RESIZED: 'old_text_resized',
	    UPDATE_IMAGE_HEIGHT: 'update_image_height',
	    UPDATE_IMAGE_SIZE: 'update_image_size',
	    UPDATE_IMAGE_SIZE_WHEN_CHANGE_MOOD: 'update_image_size_when_change_mood',
	    UPDATE_HOTSPOT: 'update_hotspot',
	    CHANGE_SHAPES_POSITION: 'change_shapes_position',
	    SELECT_SHAPES_FROM_AREA: 'select_shape_from_area',
	    CREATE_GROUP: 'create_group',
	    UNGROUP: 'ungroup',
	    CHANGE_VIDEO_PROPERTIES: 'change_video_properties',
	    CHANGE_SLIDE_SOUND_VOLUME: 'change_slide_sound_volume',
	    ADD_ANIMATION: 'add_animation',
	    REMOVE_ANIMATION: 'remove_animation',
	    ANIMATE: 'animate',
	    UPDATE_CROPPING_HOTSPOT: 'update_cropping_hotspot',
	    UPDATE_STEM: 'update_stem',
	    CHANGE_SHAPE_TYPE: 'change_shape_type',
	    CHANGE_RICH_TEXT_CONTENT: 'change_rich_text_content',
	    CHANGE_TEXT_LINE_HEIGHT: 'change_text_line_height',
	    CHANGE_FLIP: 'change_flip',
	    INSERT_IMAGE_NODE: 'insert_image_node',
	    ADD_VIDEO_SHAPE_DURATION: 'add_video_shape_duration',
	    UPDATE_VIDEO_SHAPE: 'update_video_shape'
	};
	
	function setCurrentSlide(currentSlideIndex) {
	    return function (dispatch, getState) {
	        var state = getState();
	        var currentSlideModel = Object.assign({}, state.production.slides[currentSlideIndex]);
	        dispatch({ type: types.SET_CURRENT_SLIDE, currentSlideIndex: currentSlideIndex, currentSlideModel: currentSlideModel });
	    };
	}
	
	function updateShapePosition(uuid, newX, newY) {
	    return { type: types.UPDATE_SHAPE_POSITION, uuid: uuid, newX: newX, newY: newY };
	}
	
	function updateShapeSize(uuid, newWidth, newHeight, x, y, horizontalFlip, verticalFlip, cx, cy, cx1, cy1, cx2, cy2, cx3, cy3, cx4, cy4, cx5, cy5) {
	    return { type: types.UPDATE_SHAPE_SIZE, uuid: uuid, newWidth: newWidth, newHeight: newHeight, x: x, y: y, horizontalFlip: horizontalFlip, verticalFlip: verticalFlip, cx: cx, cy: cy, cx1: cx1, cy1: cy1, cx2: cx2, cy2: cy2, cx3: cx3, cy3: cy3, cx4: cx4, cy4: cy4, cx5: cx5, cy5: cy5 };
	}
	
	function updateShapeRotation(uuid, newRotation) {
	    return { type: types.UPDATE_SHAPE_ROTATION, uuid: uuid, newRotation: newRotation };
	}
	
	function updateNonRectangularShape(uuid, x1, y1, x2, y2, cx, cy) {
	    return { type: types.UPDATE_NON_RECTANGULAR_SHAPE, uuid: uuid, x1: x1, y1: y1, x2: x2, y2: y2, cx: cx, cy: cy };
	}
	
	function updateBubbleControlPoint(uuid, cx, cy) {
	    var pointType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'controlPoint';
	
	    return { type: types.UPDATE_BUBBLE_CONTROL_POINT, uuid: uuid, cx: cx, cy: cy, pointType: pointType };
	}
	
	function selectShape(uuid, isNew) {
	    return { type: types.SELECT_SHAPE, uuid: uuid, isNew: isNew };
	}
	
	function createShape(shapeModel) {
	    return { type: types.CREATE_SHAPE, shapeModel: shapeModel };
	}
	
	function changeBackgroundContent(newContent) {
	    return { type: types.CHANGE_BACKGROUND_CONTENT, newContent: newContent };
	}
	
	function updateCurrentSlideThumbnail(value) {
	    return { type: types.UPDATE_CURRENT_SLIDE_THUMBNAIL, value: value };
	}
	
	function initSlide() {
	    return { type: types.INIT_SLIDE };
	}
	
	function duplicateShape(model) {
	    return { type: types.DUPLICATE_SHAPE, model: model };
	}
	
	function deleteShape(models) {
	    return { type: types.DELETE_SHAPES, models: models };
	}
	
	function addVideoShapeDuration(shapeModel, duration) {
	    return { type: types.ADD_VIDEO_SHAPE_DURATION, shapeModel: shapeModel, duration: duration };
	}
	
	function updateVideoShape(uuid) {
	    return { type: types.UPDATE_VIDEO_SHAPE, uuid: uuid };
	}
	
	function lockShape(shapeModel) {
	    return { type: types.LOCK_SHAPE, shapeModel: shapeModel };
	}
	
	function bringToFront(shapeModel) {
	    return { type: types.BRING_TO_FRONT, shapeModel: shapeModel };
	}
	
	function sendToBack(shapeModel) {
	    return { type: types.SEND_TO_BACK, shapeModel: shapeModel };
	}
	
	function bringForward(shapeModel) {
	    return { type: types.BRING_FORWARD, shapeModel: shapeModel };
	}
	
	function sendBackward(shapeModel) {
	    return { type: types.SEND_BACKWARD, shapeModel: shapeModel };
	}
	
	function changeFilter(shapeModel, filter) {
	    return { type: types.CHANGE_FILTER, shapeModel: shapeModel, filter: filter };
	}
	
	function changeSlideDuration(duration) {
	    return { type: types.CHANGE_SLIDE_DURATION, duration: duration };
	}
	
	function changeAlternativeText(text) {
	    return { type: types.CHANGE_ALTERNATIVE_TEXT, text: text };
	}
	
	function changeStrokeSize(shapeModel, strokeSize) {
	    return { type: types.CHANGE_STROKE_SIZE, shapeModel: shapeModel, strokeSize: strokeSize };
	}
	
	function changeShapeOpacity(shapeModel, opacity) {
	    return { type: types.CHANGE_SHAPE_OPACITY, shapeModel: shapeModel, opacity: opacity };
	}
	
	function changeShapeStrokeOpacity(shapeModel, opacity) {
	    return { type: types.CHANGE_SHAPE_STROKE_OPACITY, shapeModel: shapeModel, opacity: opacity };
	}
	
	function changeShapeFillColor(shapeModel, color) {
	    return { type: types.CHANGE_SHAPE_FILL_COLOR, shapeModel: shapeModel, color: color };
	}
	
	function changeShapeStrokeColor(shapeModel, color) {
	    return { type: types.CHANGE_SHAPE_STROKE_COLOR, shapeModel: shapeModel, color: color };
	}
	
	function changeTextProperties(shapeModel, propertyType, newValue, isRichText) {
	    return { type: types.CHANGE_TEXT_PROPERTIES, shapeModel: shapeModel, propertyType: propertyType, newValue: newValue, isRichText: isRichText };
	}
	
	function setShortcutsTarget(isSlideCommand) {
	    return { type: types.SET_SHORTCUTS_TARGET, isSlideCommand: isSlideCommand };
	}
	
	function moveShape(uuid, offsetX, offsetY) {
	    return { type: types.MOVE_SHAPE, uuid: uuid, offsetX: offsetX, offsetY: offsetY };
	}
	
	function updateTextProperties(shapeModel, propertyType, stepOffset) {
	    return { type: types.UPDATE_TEXT_PROPERTIES, shapeModel: shapeModel, propertyType: propertyType, stepOffset: stepOffset };
	}
	
	function setCloneTarget(shapeModel) {
	    return { type: types.SET_CLONE_TARGET, shapeModel: shapeModel };
	}
	
	function updateCurrentSlideIndex(slideUid) {
	    return { type: types.UPDATE_CURRENT_SLIDE_INDEX, slideUid: slideUid };
	}
	
	function canvasUndoRedoAction(newState) {
	    return { type: types.CANVAS_UNDO_REDO_ACTION, newState: newState };
	}
	
	function changeMood(uuid, frameLabel) {
	    return { type: types.CHANGE_MOOD, uuid: uuid, frameLabel: frameLabel };
	}
	
	function selectLastAddedShape() {
	    return { type: types.SELECT_LAST_ADDED_SHAPE };
	}
	
	function updateTextHeight(uuid, newHeight, newWidth) {
	    return { type: types.UPDATE_TEXT_HEIGHT, uuid: uuid, newHeight: newHeight, newWidth: newWidth };
	}
	
	function changeShapeFillVisibility(uuid, isFillVisible) {
	    return { type: types.CHANGE_SHAPE_FILL_VISIBILITY, uuid: uuid, isFillVisible: isFillVisible };
	}
	
	function changeIsNewShape(uuid, isNew) {
	    return { type: types.CHANGE_IS_NEW_SHAPE, uuid: uuid, isNew: isNew };
	}
	
	function setSlideSound(sound) {
	    return { type: types.SET_SLIDE_SOUND, sound: sound };
	}
	
	function setSlideSoundEffect(sound) {
	    return { type: types.SET_SLIDE_SOUND_EFFECT, sound: sound };
	}
	
	function changeInteractionState(uuid, newState, moveState) {
	    return { type: types.CHANGE_INTERACTION_STATE, uuid: uuid, newState: newState, moveState: moveState };
	}
	
	function updateCurrentSlideMoods() {
	    return { type: types.UPDATE_CURRENT_SLIDE_MOODS };
	}
	
	function oldTextResized(uuid) {
	    return { type: types.OLD_TEXT_RESIZED, uuid: uuid };
	}
	
	function updateImageHeight(uuid, newHeight, updateWidth) {
	    return { type: types.UPDATE_IMAGE_HEIGHT, uuid: uuid, newHeight: newHeight, updateWidth: updateWidth };
	}
	
	function updateImageSize(uuid, newWidth, newHeight) {
	    return { type: types.UPDATE_IMAGE_SIZE, uuid: uuid, newWidth: newWidth, newHeight: newHeight };
	}
	
	function updateImageSizeWhenChangeMood(uuid, originalWidth, originalHeight) {
	    return { type: types.UPDATE_IMAGE_SIZE_WHEN_CHANGE_MOOD, uuid: uuid, originalWidth: originalWidth, originalHeight: originalHeight };
	}
	
	function updateHospot(uuid, hotspot) {
	    return { type: types.UPDATE_HOTSPOT, uuid: uuid, hotspot: hotspot };
	}
	
	function updateCroppingHospot(uuid, hotspot) {
	    return { type: types.UPDATE_CROPPING_HOTSPOT, uuid: uuid, hotspot: hotspot };
	}
	
	function changeShapesPosition(positions) {
	    return { type: types.CHANGE_SHAPES_POSITION, positions: positions };
	}
	
	function selectShapeFromArea(selection) {
	    return { type: types.SELECT_SHAPES_FROM_AREA, selection: selection };
	}
	
	function createGroup(groupModel) {
	    return { type: types.CREATE_GROUP, groupModel: groupModel };
	}
	
	function ungroup(groupModel, shapes) {
	    return { type: types.UNGROUP, groupModel: groupModel, shapes: shapes };
	}
	
	function changeVideoProperties(property, value) {
	    return { type: types.CHANGE_VIDEO_PROPERTIES, property: property, value: value };
	}
	
	function changeSlideSoundVolume(volume, isSoundEffect) {
	    return { type: types.CHANGE_SLIDE_SOUND_VOLUME, volume: volume, isSoundEffect: isSoundEffect };
	}
	
	function addAnimation(uuid, animation) {
	    return { type: types.ADD_ANIMATION, uuid: uuid, animation: animation };
	}
	
	function removeAnimation(uuid) {
	    return { type: types.REMOVE_ANIMATION, uuid: uuid };
	}
	
	function animate(shapes, animations) {
	    return { type: types.ANIMATE, shapes: shapes, animations: animations };
	}
	
	function updateStem(uuid, value) {
	    return { type: types.UPDATE_STEM, uuid: uuid, value: value };
	}
	
	function changeShapeType(uuid, value) {
	    return { type: types.CHANGE_SHAPE_TYPE, uuid: uuid, value: value };
	}
	
	function changeRichTextContent(uuid, value) {
	    return { type: types.CHANGE_RICH_TEXT_CONTENT, uuid: uuid, value: value };
	}
	
	function changeTextLineHeight(uuid, value) {
	    return { type: types.CHANGE_TEXT_LINE_HEIGHT, uuid: uuid, value: value };
	}
	
	function changeFlip(uuid, flipType) {
	    return { type: types.CHANGE_FLIP, uuid: uuid, flipType: flipType };
	}
	
	function insertImageNode(uuid, href, aspectRatio) {
	    return { type: types.INSERT_IMAGE_NODE, uuid: uuid, href: href, aspectRatio: aspectRatio };
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/actions/CurrentSlideActions.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/actions/CurrentSlideActions.js"); } } })();

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    // PREVIEW functionality
	    EDITOR: 'Editor',
	    PREVIEW: 'Preview',
	    PLAYER: 'Player',
	    VIDEO_EDITOR: 'VideoEditor',
	    AUDIO_EDITOR: 'AudioEditor',
	    DOWNLOAD: 'download',
	    PRINT: 'print',
	    PRINT_EDITOR: 'printEditor',
	    AUDIO_TOOL: 'audioTool',
	    AUDIO_TOOL_PLAYER: 'audioToolPlayer',
	    EXPORT_PLAYER: 'exportPlayer',
	    EXPORT_AUDIO_PLAYER: 'exportAudioPlayer',
	
	    // CONTEXT MENU functionality
	    OBJECT_CONTEXT_ADVANCED: 'Object_context_advanced',
	    OBJECT_CONTEXT_STYLING: 'Object_context_styling',
	    OBJECT_TEXT_STYLING: 'Object_text_styling',
	    TEXT_EDITOR: 'Text_editor',
	    MIND_MAP_MENU: 'Mind_map_menu',
	    OBJECT_CONTEXT_MOODS: 'Object_context_moods',
	    ANIMATION_CONTEXT: 'Animation_context',
	    SIZE_AND_POSITION_CONTEXT: 'Size_and_position_context',
	    SLIDE_CONTEXT_ADVANCED: 'Slide_context_advanced',
	    SLIDE_CONTEXT_STYLING: 'Slide_context_styling',
	    SLIDE_CONTEXT_MOODS: 'Slide_context_moods',
	    SLIDE_VISIBILITY: 'Slide_visibility',
	    SAVE_CONTEXT: 'Save_context',
	    SEARCH_CONTEXT: 'Search_context',
	    CONTEXT_NONE: 'Context_none',
	    ZOOM_SLIDE_CONTEXT: 'Zoom_slide_context',
	    LINE_CONTEXT: 'line_context',
	    FREEHAND_CONTEXT: 'freehand_context',
	
	    // Left menu
	    TEXT: 'Text',
	    RICH_TEXT: 'RichText',
	    FREEHAND: 'Freehand',
	    SHAPES: 'Shapes',
	    EFFECTS: 'Effects',
	    FRAMES: 'Frames',
	    MEDIA: 'Media',
	
	    FILL_STYLE: 'fill',
	    LINE_STYLE: 'line',
	
	    IMAGES: 'images',
	    SOUNDS: 'sounds',
	    VIDEOS: 'videos'
	};
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/constants/ModeConstants.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/constants/ModeConstants.js"); } } })();

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _SaveDataUploader = __webpack_require__(854);
	
	var _SaveDataUploader2 = _interopRequireDefault(_SaveDataUploader);
	
	var _ThumbnailDataUploader = __webpack_require__(855);
	
	var _ThumbnailDataUploader2 = _interopRequireDefault(_ThumbnailDataUploader);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _ThumbnailGenerator = __webpack_require__(144);
	
	var _ThumbnailGenerator2 = _interopRequireDefault(_ThumbnailGenerator);
	
	var _FineUploader = __webpack_require__(371);
	
	var _FineUploader2 = _interopRequireDefault(_FineUploader);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var saveManager = {
	    AUTOSAVE_TIME: _Configuration2.default.AUTOSAVE_TIME * 1000,
	    contentChanged: false,
	    autosaveCounter: 0,
	    hrefLocationForIOS: '',
	    refreshExportButton: undefined,
	    oldContentItemId: -1,
	    showSaveAsAlert: undefined,
	    timeForLastSave: -1,
	
	    init: function init() {
	        _FineUploader2.default.init();
	        _SaveDataUploader2.default.init();
	        _ThumbnailDataUploader2.default.init();
	    },
	
	
	    /********************* Data **********************/
	    getProductionData: function getProductionData() {
	        var state = Object.assign({}, _StoreManager2.default.getState());
	        var production = JSON.parse(JSON.stringify(state.production));
	        var audioEditor = JSON.parse(JSON.stringify(state.audioEditor));
	        var title = _AppParameters2.default.title;
	        var data = {};
	
	        if (!production.slides) return undefined;
	
	        if (!_AudioToolUtils2.default.isAudioTool()) {
	            data.storySound = production.storySound;
	            data.storySoundVolume = production.storySoundVolume;
	            data.hiddenAlerts = production.hiddenAlerts;
	
	            if (production.exportProperties) data.exportProperties = production.exportProperties;
	
	            if (state.menu.useImageAsBackground) data.useImageAsBackground = true;
	        }
	
	        data.theme = _AppParameters2.default.currentTheme;
	        data.title = title;
	        data.slides = this.checkSlides(production.slides);
	        data.currentFont = _TextEditorUtils2.default.currentFont;
	        data.currentFontSize = _TextEditorUtils2.default.currentFontSize;
	
	        if (_PlayController2.default.isAudioEditorAvailable()) data.audioEditor = this.checkTimelines(audioEditor);
	
	        var result = JSON.stringify(data);
	
	        return result;
	    },
	    checkTimelines: function checkTimelines(audioEditor) {
	        var newAudioEditor = {};
	        var i, j;
	        var timelines = audioEditor.timelines;
	
	        newAudioEditor.zoomValue = audioEditor.zoomValue >= 0 ? audioEditor.zoomValue : 1;
	        newAudioEditor.markerPosition = 0;
	        newAudioEditor.trackMenu = -1;
	        newAudioEditor.timelines = [];
	
	        for (i = 0; i < timelines.length; i++) {
	            var timeline = Object.assign({}, timelines[i]);
	            var audios = timeline.audios;
	            var newAudios = [];
	
	            delete timeline.isSelected;
	
	            for (j = 0; j < audios.length; j++) {
	                var audio = Object.assign({}, audios[j]);
	
	                delete audio.hrefBlob;
	                delete audio.showControlPoint;
	
	                if (audio.inPoint) audio.inPoint = Number(audio.inPoint.toFixed(3));
	
	                if (audio.outPoint) audio.outPoint = Number(audio.outPoint.toFixed(3));
	
	                if (audio.left) audio.left = Number(audio.left.toFixed(3));
	
	                if (audio.duration) audio.duration = Number(audio.duration.toFixed(3));
	
	                newAudios.push(audio);
	            }
	
	            timeline.audios = newAudios;
	            newAudioEditor.timelines.push(timeline);
	        }
	
	        return newAudioEditor;
	    },
	    checkSlides: function checkSlides(slides) {
	        var _this = this;
	
	        var newSlides = slides.map(function (slide) {
	            var newSlide = Object.assign({}, slide);
	            var shapes = newSlide.content;
	
	            for (var j = 0; j < shapes.length; j++) {
	                var shape = shapes[j];
	
	                if (shape) {
	                    _this.removeCacheBreaker(shape);
	                    _this.removeProperties(shape);
	                    _this.checkAnimations(shape);
	
	                    if (shape.type == _ShapeConstants2.default.GROUP) _this.removePropertiesFromGroup(shape);
	                }
	            }
	
	            if (newSlide.sound && newSlide.sound.indexOf('blob') != -1) newSlide.sound = '';
	
	            if (newSlide.soundWav && newSlide.soundWav.length > 0) newSlide.soundWav = '';
	
	            return newSlide;
	        });
	
	        return newSlides;
	    },
	    removeCacheBreaker: function removeCacheBreaker(shape) {
	        if (shape.xlinkHref && shape.xlinkHref.indexOf('?cacheBreaker') != -1) shape.xlinkHref = shape.xlinkHref.substring(0, shape.xlinkHref.indexOf('?cacheBreaker'));
	    },
	    removePropertiesFromGroup: function removePropertiesFromGroup(group) {
	        if (!group.shapes) return;
	
	        for (var i = 0; i < group.shapes.length; i++) {
	            var shape = group.shapes[i];
	
	            this.removeCacheBreaker(shape);
	
	            if (shape.type == _ShapeConstants2.default.GROUP) this.removePropertiesFromGroup(shape);
	
	            this.removeProperties(shape);
	        }
	    },
	    removeProperties: function removeProperties(shape) {
	        if (!shape) return;
	
	        delete shape.isSelected;
	        delete shape.isInteraction;
	        delete shape.moveState;
	        delete shape.isNew;
	        delete shape.path;
	
	        if (shape.filter == '') delete shape.filter;
	
	        if (shape.hotSpot == '') delete shape.hotSpot;
	
	        if (shape.logicalName == '') delete shape.logicalName;
	
	        if (shape.frameLabel == '') delete shape.frameLabel;
	
	        if (shape.xlinkHref == '') delete shape.xlinkHref;
	
	        if (shape.isLocked == false) delete shape.isLocked;
	
	        if (shape.x) shape.x = Number(shape.x.toFixed(2));
	
	        if (shape.y) shape.y = Number(shape.y.toFixed(2));
	
	        if (shape.width) shape.width = Number(shape.width.toFixed(2));
	
	        if (shape.height) shape.height = Number(shape.height.toFixed(2));
	
	        if (shape.cx) shape.cx = Number(shape.cx.toFixed(2));
	
	        if (shape.cy) shape.cy = Number(shape.cy.toFixed(2));
	    },
	    checkAnimations: function checkAnimations(shape) {
	        var animation = shape.animation;
	
	        if (animation) {
	            // animations should always have the initial position
	            if (animation.start_x != shape.x) shape.x = animation.start_x;
	
	            if (animation.start_y != shape.y) shape.y = animation.start_y;
	
	            if (animation.start_width != shape.width) shape.width = animation.start_width;
	
	            if (animation.start_height != shape.height) shape.height = animation.start_height;
	
	            if (animation.start_opacity != shape.opacity) shape.opacity = animation.start_opacity;
	
	            if (animation.start_rotation != shape.rotation) shape.rotation = animation.start_rotation;
	
	            if (animation.start_x1 != shape.x1) shape.x1 = animation.start_x1;
	
	            if (animation.start_y1 != shape.y1) shape.y1 = animation.start_y1;
	
	            if (animation.start_x2 != shape.x2) shape.x2 = animation.start_x2;
	
	            if (animation.start_y2 != shape.y2) shape.y2 = animation.start_y2;
	
	            if (animation.start_cx != shape.cx) shape.cx = animation.start_cx;
	
	            if (animation.start_cy != shape.cy) shape.cy = animation.start_cy;
	
	            if (animation.start_cx1 != shape.cx1) shape.cx1 = animation.start_cx1;
	
	            if (animation.start_cy1 != shape.cy1) shape.cy1 = animation.start_cy1;
	
	            if (animation.start_cx2 != shape.cx2) shape.cx2 = animation.start_cx2;
	
	            if (animation.start_cy2 != shape.cy2) shape.cy2 = animation.start_cy2;
	
	            if (animation.start_cx3 != shape.cx3) shape.cx3 = animation.start_cx3;
	
	            if (animation.start_cy3 != shape.cy3) shape.cy3 = animation.start_cy3;
	
	            if (animation.start_cx4 != shape.cx4) shape.cx4 = animation.start_cx4;
	
	            if (animation.start_cy4 != shape.cy4) shape.cy4 = animation.start_cy4;
	
	            if (animation.start_cx5 != shape.cx5) shape.cx5 = animation.start_cx5;
	
	            if (animation.start_cy5 != shape.cy5) shape.cy5 = animation.start_cy5;
	        }
	    },
	
	    /***********************************************************/
	
	    getMode: function getMode() {
	        var state = _StoreManager2.default.getState();
	        var mode = state.production.mode;
	
	        return mode;
	    },
	    dispatch: function dispatch() {
	        var store = _StoreManager2.default.getStore();
	
	        return store.dispatch;
	    },
	    saveContent: function saveContent() {
	        var autosave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (_Configuration2.default.LOAD_LOCAL == true) return;
	
	        var currentTime = new Date().getTime();
	
	        if (autosave === true && this.timeForLastSave > 0 && currentTime - this.timeForLastSave < 6 * 1000) // if by mistake an autosave occurs in max 6 seconds then don't do it
	            return;
	
	        if (this.timeForLastSave > 0) console.log('saveTime ' + (currentTime - this.timeForLastSave));
	
	        var dispatch = this.dispatch();
	        dispatch((0, _MenuActions.showSavePreloader)(true));
	
	        _ApiServiceUtils2.default.saveTime = currentTime;
	        this.timeForLastSave = currentTime;
	
	        if (autosave == false) this.storeData(autosave);else {
	            dispatch((0, _ProductionActions.updateCurrentSlide)());
	            setTimeout(this.storeDataWhenProductionDataIsReady.bind(this), 10);
	        }
	    },
	    storeDataWhenProductionDataIsReady: function storeDataWhenProductionDataIsReady() {
	        this.storeData(true);
	    },
	    storeData: function storeData(autosave) {
	        _ApiServiceUtils2.default.executeSafeApiCall(function () {
	            return this.executeStoreData(autosave);
	        }.bind(this), function () {
	            this.showExceptionAlert(1);
	        }.bind(this));
	    },
	    overrideProduction: function overrideProduction() {
	        if (_AppParameters2.default.title == 'aaa111') return 58530960; // hree Billy Goats;
	
	        if (_AppParameters2.default.title == 'aaa222') return 58517861; // Stone ages
	
	        if (_AppParameters2.default.title == 'aaa333') return 62344225; // Master Norway
	
	        return -1;
	    },
	    getContentItemId: function getContentItemId() {
	        var contentItemId = -1;
	
	        if (_AppParameters2.default.submitId > 0) {
	            // is a saved production
	            contentItemId = _AppParameters2.default.contentItemId;
	
	            if (!_AppParameters2.default.isAssignment) {
	                // if is not an assigned product
	                if (_AppParameters2.default.currentUserId > -1 && _AppParameters2.default.creatorUserId > -1 && _AppParameters2.default.currentUserId != _AppParameters2.default.creatorUserId) contentItemId = -1;
	            }
	        }
	
	        if (_AppParameters2.default.assignmentStatus && _AppParameters2.default.assignmentStatus == 'INVITED') // for the assigned productions which are not yet started
	            contentItemId = -1;
	
	        // it's when click on Create button from Exercises or Tools
	        if (_AppParameters2.default.isExercise) contentItemId = -1;
	
	        // there are new exercises (one of them can be bases on productions with content) so the new contentItemId should be -1 to not override the current one
	        if (_AppParameters2.default.submitId < 0) contentItemId = -1;
	
	        if (_AppParameters2.default.isMasterProduction == true || _AppParameters2.default.isMaster) // is a master production so it shouldn't be overriten
	            contentItemId = -1;
	
	        var overrideProduction = this.overrideProduction();
	
	        if (overrideProduction > 0) return overrideProduction;
	
	        return contentItemId;
	    },
	    executeStoreData: function executeStoreData(autosave) {
	        var _this2 = this;
	
	        var data = this.getProductionData();
	        var contentItemId = this.getContentItemId();
	        var submitId = _AppParameters2.default.submitId;
	        var isAudio = _AudioToolUtils2.default.isAudioTool() ? true : false;
	        var exerciseId = -1;
	
	        if (_AppParameters2.default.exerciseId > 0) exerciseId = _AppParameters2.default.exerciseId;
	
	        if (autosave == true) this.autosaveCounter = this.autosaveCounter + 1;else this.autosaveCounter = 0;
	
	        var autoSaveFlag = autosave;
	
	        if (this.autosaveCounter >= 20) {
	            // at every 20 autosaves we should do a proper save with revision and thumbnail
	            this.autosaveCounter = 0;
	            autoSaveFlag = false;
	        }
	
	        if (data == undefined || data == '' || data == ' ' || data == null) {
	            this.showExceptionAlert(2);
	            return;
	        }
	
	        var clipartReferenceId = _AppParameters2.default.clipartId;
	
	        if (Number.isInteger(clipartReferenceId) && clipartReferenceId > 0) {// it's ok
	            // the clipart it's an integer > 0
	        } else {
	            if (_Configuration2.default.IS_PROD() == true) clipartReferenceId = _Configuration2.default.DEFAULT_CLIPART_ID_PROD;else clipartReferenceId = _Configuration2.default.DEFAULT_CLIPART_ID;
	        }
	
	        if (clipartReferenceId == 111) {
	            if (_Configuration2.default.IS_PROD() == true) clipartReferenceId = _Configuration2.default.DEFAULT_CLIPART_ID_PROD;else clipartReferenceId = _Configuration2.default.DEFAULT_CLIPART_ID;
	        }
	
	        var thumbnailName;
	        var thumbnailS3Key;
	
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            if (_Configuration2.default.IS_PROD() == true) clipartReferenceId = _Configuration2.default.AUDIO_TOOL_CLIRPART_ID_PROD;else clipartReferenceId = _Configuration2.default.AUDIO_TOOL_CLIRPART_ID_STAGE;
	
	            var cloudfrontIndex = _AppParameters2.default.exerciseThumbnailUrl ? _AppParameters2.default.exerciseThumbnailUrl.indexOf('cloudfront.net/') : -1;
	            if (contentItemId == -1 && cloudfrontIndex > 0) {
	                thumbnailS3Key = _AppParameters2.default.exerciseThumbnailUrl.substring(cloudfrontIndex + 15);
	            }
	        } else {
	            // store thumbnail only for Cartoonist
	            if (!autoSaveFlag || autoSaveFlag && contentItemId == -1) {
	                // it's a normal save so a new revision is created ... or it's the first autosave (no contentItemId)
	                thumbnailName = this.getThumbnailName();
	                thumbnailS3Key = 'Cartoonist/' + _AppParameters2.default.currentUserId + '/' + thumbnailName;
	            }
	        }
	
	        this.oldContentItemId = contentItemId;
	
	        if (!_Configuration2.default.IS_PROD()) clipartReferenceId = 70810402;
	
	        if (this.isBigData(data)) {
	            var properties = {};
	
	            properties.title = _AppParameters2.default.title;
	            properties.contentItemId = contentItemId;
	            properties.submitId = submitId;
	            properties.exerciseId = exerciseId;
	            properties.clipartReferenceId = clipartReferenceId;
	            properties.autoSave = autoSaveFlag;
	            properties.thumbnailS3Key = thumbnailS3Key;
	
	            this.executeNewSave(data, properties);
	        } else {
	            _ApiService2.default.storeCartoonist(_AppParameters2.default.title, contentItemId, submitId, exerciseId, data, clipartReferenceId, thumbnailS3Key, autoSaveFlag, isAudio).then(function (response) {
	                return _this2.dataSaved(response);
	            }).catch(function (ex) {
	                _this2.showExceptionAlert(3);
	            });
	        }
	
	        if (thumbnailS3Key && !_AudioToolUtils2.default.isAudioTool()) _ThumbnailGenerator2.default.getProductionThumb(this.storeThumbnail.bind(this), thumbnailName);
	    },
	    resetAutosave: function resetAutosave() {
	        this.isContentChanged(false);
	    },
	    saveData: function saveData() {
	        this.saveContent();
	    },
	    saveAsData: function saveAsData() {
	        _AppParameters2.default.contentItemId = -1;
	        _AppParameters2.default.submitId = -1;
	        this.saveContent();
	    },
	    showExceptionAlert: function showExceptionAlert(type) {
	        var dispatch = this.dispatch();
	        dispatch((0, _MenuActions.showSavePreloader)(false));
	
	        // when a storing fails then stop autosave functionality
	        this.resetAutosave();
	
	        switch (type) {
	            case 1:
	                {
	                    // Lost sesssion ... default message
	                    dispatch((0, _MenuActions.showLostSessionAlert)(1));
	                    break;
	                }
	
	            case 2:
	                {
	                    // Bad Json data
	                    dispatch((0, _MenuActions.showLostSessionAlert)(2));
	                    break;
	                }
	
	            case 3:
	                {
	                    // Exception during storing flow
	                    dispatch((0, _MenuActions.showLostSessionAlert)(3));
	                    break;
	                }
	
	            case 4:
	                {
	                    // Exception on storing success response
	                    dispatch((0, _MenuActions.showLostSessionAlert)(4));
	                    break;
	                }
	        }
	    },
	    dataSaved: function dataSaved(response) {
	        if (response.contentItemId > 0) {
	            this.resetAutosave();
	
	            setTimeout(function () {
	                var dispatch = this.dispatch();
	                dispatch((0, _MenuActions.showSavePreloader)(false));
	            }.bind(this), 1000);
	
	            if (this.showSaveAsAlert) this.showSaveAsAlert();
	
	            this.showSaveAsAlert = undefined;
	
	            if (response.contentItemId) _AppParameters2.default.contentItemId = response.contentItemId;
	
	            if (response.submitId) {
	                if (_AppParameters2.default.submitId == -1 && response.stringId) {
	                    _AppParameters2.default.stringId = response.stringId;
	                    this.refreshAppWithNewLink();
	                }
	
	                _AppParameters2.default.submitId = response.submitId;
	                localStorage.setItem("lockedItemId", response.submitId);
	            }
	
	            _AppParameters2.default.assignmentStatus = 'CREATED';
	            _AppParameters2.default.isMaster = false;
	            _AppParameters2.default.isExercise = false;
	            _AppParameters2.default.isMasterProduction = false;
	            _AppParameters2.default.creatorUserId = _AppParameters2.default.currentUserId;
	
	            if (_AppParameters2.default.masterAssignmentId != -1) {
	                var masterAssignments = localStorage.getItem("masterAssignments");
	
	                if (masterAssignments && masterAssignments.indexOf(_AppParameters2.default.masterAssignmentId) != -1) {
	                    masterAssignments = masterAssignments.replace('' + _AppParameters2.default.masterAssignmentId + ',', '');
	                    localStorage.setItem("masterAssignments", masterAssignments);
	                    _AppParameters2.default.masterAssignmentId = -1;
	                }
	            }
	
	            if (this.refreshExportButton) this.refreshExportButton();
	        } else {
	            this.showExceptionAlert(4);
	        }
	    },
	    refreshAppWithNewLink: function refreshAppWithNewLink() {
	        var _this3 = this;
	
	        _ApiService2.default.getSessionProperties() // check if the user has session
	        .then(function (response) {
	            var url = window.location.origin + '/' + response.user.userHomePageURL + '/' + _AppParameters2.default.stringId + '/edit';
	
	            setTimeout(function () {
	                window.parent.history.pushState('', '', url);
	                // window.parent.location.href = url;
	            }.bind(_this3), 1000);
	        });
	    },
	    initAutoSave: function initAutoSave() {
	        this.resetAutosave();
	
	        if (this.getMode() == _ModeConstants2.default.EDITOR || _AudioToolUtils2.default.isAudioTool()) setInterval(this.autoSave.bind(this), this.AUTOSAVE_TIME);
	    },
	    autoSave: function autoSave() {
	        if (_Configuration2.default.LOAD_LOCAL == true) return;
	
	        if (_Configuration2.default.AUTOSAVE_AVAILABLE == false || this.contentChanged == false) return;
	
	        var mode = this.getMode;
	        if (mode == _ModeConstants2.default.PREVIEW || mode == _ModeConstants2.default.PLAYER || mode == _ModeConstants2.default.AUDIO_TOOL_PLAYER) return;
	
	        // should call here a new API for updating current revision and not create a new one
	        this.saveContent(true);
	    },
	    isContentChanged: function isContentChanged(value) {
	        this.contentChanged = value;
	
	        var newVal = String(value);
	
	        if (!newVal || newVal == '') newVal = 'false';
	
	        localStorage.setItem('cartoonistNeedsSave', newVal);
	    },
	
	
	    /*********** Saving thumbnail +*****************/
	    getThumbnailName: function getThumbnailName() {
	        var currentdate = new Date();
	        var minutes = currentdate.getMinutes();
	
	        if (minutes < 10) minutes = '0' + minutes;
	
	        var seconds = currentdate.getSeconds();
	
	        if (seconds < 10) seconds = '0' + seconds;
	
	        var title = '' + currentdate.getFullYear() + '-' + (currentdate.getMonth() + 1) + '-' + currentdate.getDate() + '_' + currentdate.getHours() + '_' + minutes + '_' + seconds + '_' + currentdate.getMilliseconds() + '.png';
	
	        return title;
	    },
	    storeThumbnail: function storeThumbnail(canvasObject, title) {
	        if (!canvasObject) return;
	
	        try {
	            if (!HTMLCanvasElement.prototype.toBlob) {
	                Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
	                    value: function value(callback, type, quality) {
	                        var canvas = this;
	                        setTimeout(function () {
	                            var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]),
	                                len = binStr.length,
	                                arr = new Uint8Array(len);
	
	                            for (var i = 0; i < len; i++) {
	                                arr[i] = binStr.charCodeAt(i);
	                            }
	
	                            callback(new Blob([arr], { type: type || 'image/png' }));
	                        });
	                    }
	                });
	            }
	        } catch (e) {
	            // possible error
	        }
	
	        try {
	            canvasObject.toBlob(function (blob) {
	                _ThumbnailDataUploader2.default.uploadFile(blob, title);
	            }.bind(this));
	        } catch (e) {
	            // possible error
	        }
	    },
	    uploadThumbnailSuccess: function uploadThumbnailSuccess(type, name, state) {
	        if (state && state.success == true) {} else {// error: the file wasn't stored on s3
	        }
	    },
	    uploadThumbnailError: function uploadThumbnailError() {},
	
	
	    /*********** Saving big data +*****************/
	    productionProperties: undefined,
	
	    isBigData: function isBigData(data) {
	        if (data && data.length > 900000) return true;else return false;
	    },
	    getFileName: function getFileName() {
	        var currentdate = new Date();
	        var minutes = currentdate.getMinutes();
	
	        if (minutes < 10) minutes = '0' + minutes;
	
	        var seconds = currentdate.getSeconds();
	
	        if (seconds < 10) seconds = '0' + seconds;
	
	        var title = '' + currentdate.getFullYear() + '-' + (currentdate.getMonth() + 1) + '-' + currentdate.getDate() + '_' + currentdate.getHours() + '_' + minutes + '_' + seconds + '.json';
	
	        return title;
	    },
	    getCurrentRevision: function getCurrentRevision(key) {
	        var prefix = 'Cartoonist/' + _AppParameters2.default.currentUserId + '/';
	
	        if (key && key.indexOf(prefix) != -1) {
	            key = key.replace(prefix, '');
	
	            return key;
	        } else return undefined;
	    },
	    executeNewSave: function executeNewSave(data, properties) {
	        var title = this.getFileName();
	        this.productionProperties = properties;
	        this.productionProperties.s3Key = 'Cartoonist/' + _AppParameters2.default.currentUserId + '/' + title;
	        this.productionProperties.usedContentIds = this.getUsedContentIds();
	
	        if (properties.autoSave) {
	            // it's autosave so should override current revision
	            var currentRevision = this.getCurrentRevision(_AppParameters2.default.s3key);
	
	            if (currentRevision) {
	                title = currentRevision;
	                this.productionProperties.s3Key = 'Cartoonist/' + _AppParameters2.default.currentUserId + '/' + title;
	            } else {
	                this.productionProperties.autoSave = false;
	            }
	        } else {// it's normal save so create a new revision
	
	        }
	
	        _AppParameters2.default.s3key = this.productionProperties.s3Key; // set the current revision for autoSave
	
	        var blob = new Blob([data], { type: 'application/json' });
	
	        _SaveDataUploader2.default.uploadFile(blob, title);
	    },
	    uploadSuccess: function uploadSuccess(type, name, state) {
	        if (state && state.success == true) {
	            this.doNewStoring();
	        } else {
	            // error: the file wasn't stored on s3
	            this.showExceptionAlert(3);
	        }
	    },
	    uploadError: function uploadError() {
	        this.showExceptionAlert(3);
	    },
	    doNewStoring: function doNewStoring() {
	        var _this4 = this;
	
	        var properties = this.productionProperties;
	
	        _ApiService2.default.storeBigDataCartoonist(properties.s3Key, properties.title, properties.contentItemId, properties.submitId, properties.exerciseId, properties.clipartReferenceId, properties.thumbnailS3Key, properties.autoSave, properties.usedContentIds).then(function (response) {
	            return _this4.dataSaved(response);
	        }).catch(function (ex) {
	            _this4.showExceptionAlert(3);
	        });
	    },
	    getUsedContentIds: function getUsedContentIds() {
	        var usedContentItemIds = [];
	        var state = _StoreManager2.default.getState();
	        var i, j, shape;
	
	        // audio editor
	        if (state.audioEditor && state.audioEditor.timelines) {
	            var timelines = state.audioEditor.timelines;
	
	            for (i = 0; i < timelines.length; i++) {
	                var audios = timelines[i].audios;
	
	                for (j = 0; j < audios.length; j++) {
	                    if (audios[j].contentItemId > 0) this.updateIds(usedContentItemIds, audios[j].contentItemId);
	                }
	            }
	        }
	
	        // story sound
	        if (state.storySound && state.storySound.contentItemId > 0) {
	            this.updateIds(usedContentItemIds, state.storySound.contentItemId);
	        }
	
	        // current slide
	        if (state.currentSlide && state.currentSlide.model) {
	            if (state.currentSlide.model.contentItemId > 0) this.updateIds(usedContentItemIds, state.currentSlide.model.contentItemId);
	
	            if (state.currentSlide.model.contentItemIdSoundEffect > 0) this.updateIds(usedContentItemIds, state.currentSlide.model.contentItemIdSoundEffect);
	
	            var shapes = state.currentSlide.model.content;
	
	            for (i = 0; i < shapes.length; i++) {
	                shape = shapes[i];
	
	                if (shape.contentItemId > 0) this.updateIds(usedContentItemIds, shape.contentItemId);
	            }
	        }
	
	        // slides
	        for (i = 0; i < state.slides; i++) {
	            var slide = state.slides[i];
	
	            if (slide.contentItemId > 0) this.updateIds(usedContentItemIds, slide.contentItemId);
	
	            if (slide.contentItemIdSoundEffect > 0) this.updateIds(usedContentItemIds, slide.contentItemIdSoundEffect);
	
	            for (j = 0; j < slide.content.length; j++) {
	                shape = slide.content[j];
	
	                if (shape.contentItemId > 0) this.updateIds(usedContentItemIds, shape.contentItemId);
	            }
	        }
	
	        return usedContentItemIds;
	    },
	    updateIds: function updateIds(array, item) {
	        if (array.indexOf(item) == -1) array.push(item);
	    }
	};
	
	exports.default = saveManager;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SaveManager.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SaveManager.js"); } } })();

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _uuid = __webpack_require__(68);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _UndoRedoActions = __webpack_require__(227);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _DurationUtils = __webpack_require__(140);
	
	var _DurationUtils2 = _interopRequireDefault(_DurationUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var audioEditorUtils = {
	    isControlPointAction: false,
	    isVolumeAction: false,
	    slidesPosition: undefined,
	    animationId: undefined,
	    markerUpdater: undefined,
	    refreshAllSlidesRenderers: false,
	
	    currentTrackMenu: -1,
	    maxZoom: 13,
	
	    getSlideWidth: function getSlideWidth(time) {
	        var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	        if (zoom != -1) return time * _Properties2.default.SLIDE_ITEM_WIDTH * zoom;else return time * _Properties2.default.SLIDE_ITEM_WIDTH * this.getZoomValue();
	    },
	    getZoomValue: function getZoomValue() {
	        var state = _StoreManager2.default.getState();
	        var zoom = state.audioEditor.zoomValue;
	        var value;
	        var listOfValues = [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 1.0, 1.2, 1.5, 1.7, 2.0, 2.2];
	
	        if (zoom == undefined) {
	            if (_AudioToolUtils2.default.isAudioTool()) value = 0.2;else value = 0.5;
	        } else value = listOfValues[zoom];
	
	        return value;
	    },
	    getTimelinesLength: function getTimelinesLength() {
	        var state = _StoreManager2.default.getState();
	        var timelines = state.audioEditor.timelines;
	
	        if (timelines) return timelines.length;else return 3;
	    },
	    getAudioEditorHeight: function getAudioEditorHeight() {
	        var offset = 35; // ruler height
	        return this.getTimelinesLength() * _AudioToolUtils2.default.timelineHeight() + offset;
	    },
	    getTimelineMaxTime: function getTimelineMaxTime() {
	        var maxWidth = this.getTimelineWidth();
	
	        return maxWidth / (_Properties2.default.SLIDE_ITEM_WIDTH * this.getZoomValue());
	    },
	    getTimelineWidth: function getTimelineWidth() {
	        var widthFromSlides = this.getTimelineWidthFromSlidesDuration();
	        var widthFromAudios = this.getTimelineWidthFromAudios();
	
	        if (widthFromAudios > widthFromSlides) return widthFromAudios;else return widthFromSlides;
	    },
	    getTimelineWidthFromSlidesDuration: function getTimelineWidthFromSlidesDuration() {
	        var state = _StoreManager2.default.getState();
	        var accordionWidth = state.accordion.width;
	
	        if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	        var windowWidth = state.production.windowWidth;
	
	        if (!(windowWidth > 0)) windowWidth = window.innerWidth;
	
	        var slidesTotalDuration = this.getSlidesMaxPosition();
	        var width = this.getSlideWidth(slidesTotalDuration);
	        var minimumWidth = windowWidth - accordionWidth - _AudioToolUtils2.default.buttonsHolderWidth();
	
	        if (width < minimumWidth) width = minimumWidth;
	
	        return width;
	    },
	    getTimelineWidthFromAudios: function getTimelineWidthFromAudios() {
	        return this.getSlideWidth(this.getTimelinesMaxPosition());
	    },
	    getSlidesMaxPosition: function getSlidesMaxPosition() {
	        var state = _StoreManager2.default.getState();
	        var currentIndex = state.currentSlide.currentSlideIndex;
	        var slides = state.production.slides;
	        var i;
	        var totalTime = 0;
	
	        for (i = 0; i < slides.length; i++) {
	            var time;
	
	            if (i == currentIndex) time = state.currentSlide.model.time;else time = slides[i].time;
	
	            totalTime = totalTime + time;
	        }
	
	        return totalTime;
	    },
	
	    maxPosition: -1,
	    getTimelinesMaxPosition: function getTimelinesMaxPosition(currentTimelines) {
	        var timelines;
	
	        if (currentTimelines) timelines = currentTimelines;else {
	            var audioEditor = _StoreManager2.default.getState().audioEditor;
	
	            if (audioEditor == undefined) return 0;
	
	            timelines = audioEditor.timelines;
	        }
	
	        var i;
	        var j;
	        var maxPos = 0;
	
	        for (i = 0; i < timelines.length; i++) {
	            var audios = timelines[i].audios;
	
	            for (j = 0; j < audios.length; j++) {
	                var pos = audios[j].left + audios[j].duration;
	
	                if (pos > maxPos) maxPos = pos;
	            }
	        }
	
	        this.maxPosition = maxPos;
	
	        return maxPos;
	    },
	    getExportTotalTime: function getExportTotalTime() {
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            var time = this.getTimelinesMaxPosition();
	
	            return Math.floor(time * 1000);
	        }
	
	        var slidesTime = this.getSlidesMaxPosition();
	        var totalTime;
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            var timelineTime = this.getTimelinesMaxPosition();
	            totalTime = Math.max(slidesTime, timelineTime);
	        } else {
	            totalTime = slidesTime;
	        }
	
	        return Math.floor(totalTime * 1000);
	    },
	    getTotalDuration: function getTotalDuration() {
	        var state = _StoreManager2.default.getState();
	        var currentIndex = state.currentSlide.currentSlideIndex;
	        var slides = state.production.slides;
	        var i;
	        var totalDuration = 0;
	
	        for (i = 0; i < slides.length; i++) {
	            var time;
	
	            if (i == currentIndex) time = state.currentSlide.model.time;else time = slides[i].time;
	
	            totalDuration = totalDuration + time;
	        }
	
	        return totalDuration;
	    },
	    getItemPosition: function getItemPosition(left) {
	        var totalTime = this.getTotalDuration();
	        var totalWidth = this.getSlideWidth(totalTime);
	
	        return totalWidth * left / totalTime;
	    },
	    getItemTimePosition: function getItemTimePosition(leftPos) {
	        var totalTime = this.getTotalDuration();
	        var totalWidth = this.getSlideWidth(totalTime);
	
	        return totalTime * leftPos / totalWidth;
	    },
	    getDelimitators: function getDelimitators() {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var currentIndex = state.currentSlide.currentSlideIndex;
	
	        if (slides.length > 0) {
	            var i;
	            var width = 0;
	            var delimitators = [];
	
	            for (i = 0; i < slides.length; i++) {
	                var time;
	
	                if (i == currentIndex) time = state.currentSlide.model.time;else time = slides[i].time;
	
	                width = width + this.getSlideWidth(time);
	                delimitators.push(width);
	            }
	
	            return delimitators;
	        } else return [];
	    },
	    getCurrentSlideWidth: function getCurrentSlideWidth() {
	        var state = _StoreManager2.default.getState();
	        var time = state.currentSlide.model.time;
	
	        return this.getSlideWidth(time);
	    },
	    getMarkerPositionForSlideIndex: function getMarkerPositionForSlideIndex() {
	        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var currentIndex = state.currentSlide.currentSlideIndex;
	
	        if (slides.length > 0) {
	            var i;
	            var currentTime = 0;
	            var delimitators = [];
	            var time;
	
	            for (i = 0; i < slides.length; i++) {
	                delimitators.push(currentTime);
	
	                if (i == currentIndex) time = state.currentSlide.model.time;else time = slides[i].time;
	
	                currentTime = currentTime + time;
	            }
	
	            if (index == -1) index = currentIndex;
	
	            return delimitators[index];
	        } else return -1;
	    },
	    checkMarkerPositionForCurrentSlide: function checkMarkerPositionForCurrentSlide() {
	        if (_PlayController2.default.isAudioEditorMode() && !_PlayController2.default.isPlaying) {
	            setTimeout(function () {
	                var dispatch = _StoreManager2.default.getStore().dispatch;
	                var currentMarkerPosition = this.getMarkerPositionForSlideIndex();
	                dispatch((0, _AudioEditorActions.setMarkerPosition)(currentMarkerPosition));
	            }.bind(this), 10);
	        }
	    },
	    getSlideItem: function getSlideItem(audio) {
	        var item = {};
	
	        item.title = audio.title;
	        item.href = audio.href;
	        item.uuid = _uuid2.default.v4();
	
	        if (_PlayController2.default.isAudioEditorMode()) {
	            item.left = audio.left;
	            item.outPoint = 0;
	
	            if (audio.durationInSeconds > 0) item.duration = audio.durationInSeconds; //keep real seconds
	            else item.duration = _DurationUtils2.default.transformDurationFromStringToSeconds(audio.duration);
	        } else {
	            if (audio.isStorySound) {
	                item.left = 0;
	                item.duration = this.getTotalDuration();
	            } else {
	                var delimitators = this.getDelimitators();
	                var state = _StoreManager2.default.getState();
	                var currentIndex = state.currentSlide.currentSlideIndex;
	                var position = 0;
	
	                if (currentIndex > 0) position = this.getItemTimePosition(delimitators[currentIndex - 1]);
	
	                item.left = position;
	                item.duration = state.currentSlide.model.time;
	            }
	        }
	
	        return item;
	    },
	    getStartColor: function getStartColor(index) {
	        var colors = ['#ff0038', '#0095de', '#f8c700', '#00d773', '#ff00ff', '#aa95ff', '#f8c7ff', '#d0d77f', '#ffa999', '#0f22df', '#f8a7a0', '#25d223', '#ff0038', '#0095de', '#f8c700', '#00d773', '#ff00ff', '#aa95ff', '#f8c7ff', '#d0d77f', '#ffa999', '#0f22df', '#f8a7a0', '#25d223'];
	
	        return colors[index];
	    },
	    getEndColor: function getEndColor(index) {
	        var colors = ['#ff0038', '#0095de', '#f8c700', '#00d773', '#ff00ff', '#aa95ff', '#f8c7ff', '#d0d77f', '#ffa999', '#0f22df', '#f8a7a0', '#25d223', '#ff0038', '#0095de', '#f8c700', '#00d773', '#ff00ff', '#aa95ff', '#f8c7ff', '#d0d77f', '#ffa999', '#0f22df', '#f8a7a0', '#25d223'];
	
	        return colors[index];
	    },
	    getGradient: function getGradient(index) {
	        if (this.isVolumeMute(index)) return '#999A9C';
	
	        return this.getStartColor(index);
	        return 'linear-gradient(to right, ' + this.getStartColor(index) + ' , ' + this.getEndColor(index) + ')';
	    },
	    getSoloIndex: function getSoloIndex() {
	        var state = _StoreManager2.default.getState();
	        var timelines = state.audioEditor.timelines;
	        var i;
	        var soloIndex = -1;
	
	        for (i = 0; i < timelines.length; i++) {
	            if (timelines[i].isSolo) soloIndex = i;
	        }
	
	        return soloIndex;
	    },
	    isVolumeMute: function isVolumeMute(index) {
	        var soloIndex = this.getSoloIndex();
	        var state = _StoreManager2.default.getState();
	        var timelines = state.audioEditor.timelines;
	
	        if (soloIndex >= 0) {
	            // is Solo activated
	            if (index == soloIndex) return false;else return true;
	        } else return timelines[index].isMute;
	    },
	    addItemToTimeline: function addItemToTimeline(item) {
	        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        _SaveManager2.default.isContentChanged(true);
	
	        var dropPosition = this.getItemDropPosition(item);
	        item.left = dropPosition.left;
	
	        if (_PlayController2.default.isAudioEditorMode()) {
	            dispatch((0, _AudioEditorActions.addAudioToTimeline)(dropPosition.index, item));
	        } else {
	            switch (type) {
	                case 0:
	                    {
	                        // Music: story sound
	                        item.isStorySound = true;
	                        dispatch((0, _AudioEditorActions.addAudioToTimeline)(2, item));
	                        break;
	                    }
	
	                case 1:
	                    {
	                        // Sound effect
	                        dispatch((0, _AudioEditorActions.addAudioToTimeline)(1, item));
	                        break;
	                    }
	
	                case 2:
	                    {
	                        // My sound
	                        dispatch((0, _AudioEditorActions.addAudioToTimeline)(1, item));
	                        break;
	                    }
	            }
	        }
	
	        _SaveManager2.default.isContentChanged(true);
	        this.checkTimelineWidth();
	        this.addActionToHistory();
	    },
	
	    lastIndex: -1,
	    getItemDropPosition: function getItemDropPosition(item) {
	        var isRecording = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var state = _StoreManager2.default.getState();
	        var markerPosition = isRecording ? item.left : state.audioEditor.markerPosition;
	        var timelines = state.audioEditor.timelines;
	        var position = {};
	        var i, j, audios;
	        var freeTimeline;
	        var currentItemDuration;
	        var noFreeTimeline = true;
	
	        if (item.durationInSeconds > 0) currentItemDuration = item.durationInSeconds;else {
	            if (item.duration > 0) currentItemDuration = item.duration;else currentItemDuration = _DurationUtils2.default.transformDurationFromStringToSeconds(item.duration);
	        }
	
	        position.left = markerPosition;
	        position.index = 0;
	
	        for (i = 0; i < timelines.length; i++) {
	            audios = timelines[i].audios;
	            freeTimeline = true;
	
	            for (j = 0; j < audios.length; j++) {
	                if (markerPosition >= audios[j].left && markerPosition <= audios[j].left + audios[j].duration) {
	                    // the marker it's already on top of an audio
	                    freeTimeline = false;
	                    break;
	                } else if (markerPosition + currentItemDuration > audios[j].left && audios[j].left + audios[j].duration > markerPosition) {
	                    // if the current item will be added at marker position then it will overlap the new audio
	                    freeTimeline = false;
	                    break;
	                }
	            }
	
	            if (freeTimeline) {
	                position.index = i;
	                noFreeTimeline = false;
	                break;
	            }
	        }
	
	        if (this.lastIndex != -1 && noFreeTimeline) position.index = this.lastIndex + 1;
	
	        if (position.index >= timelines.length) position.index = 0;
	
	        this.lastIndex = position.index;
	
	        return position;
	    },
	    getCurrentSlidePosition: function getCurrentSlidePosition(slideUid) {
	        var includeCurrentSlide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var i;
	        var currentTime = 0;
	
	        if (slideUid == '') slideUid = state.currentSlide.model.uuid;
	
	        for (i = 0; i < slides.length; i++) {
	            if (slides[i].uuid == slideUid) {
	                if (includeCurrentSlide) currentTime = currentTime + slides[i].time;
	
	                break;
	            } else currentTime = currentTime + slides[i].time;
	        }
	
	        return currentTime;
	    },
	    getSoundItemUids: function getSoundItemUids(title) {
	        if (title && title.indexOf('.mp3') > 0) title = title.replace('.mp3', '');
	
	        var audioEditor = _StoreManager2.default.getState().audioEditor;
	        var timelines = audioEditor.timelines;
	        var audios;
	        var i, j;
	        var uidArray = [];
	
	        for (i = 0; i < timelines.length; i++) {
	            audios = timelines[i].audios;
	
	            for (j = 0; j < audios.length; j++) {
	                if (audios[j] && audios[j].title && audios[j].title.indexOf(title) != -1) uidArray.push(audios[j].uuid);
	            }
	        }
	
	        return uidArray;
	    },
	
	    message: '',
	    addRecordedSoundToTimeline: function addRecordedSoundToTimeline(href, title, position) {
	        var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        _SaveManager2.default.isContentChanged(true);
	
	        var sound = {};
	
	        sound.href = href;
	        sound.title = title;
	        sound.left = position;
	        sound.showControlPoint = true;
	        sound.uuid = _uuid2.default.v4();
	
	        if (duration > 0) sound.duration = duration;else sound.duration = 1; // add default 1 second until the sound will be loaded to get the correct time
	
	        if (_PlayController2.default.isAudioEditorMode()) {
	            var dropPosition = this.getItemDropPosition(sound, true);
	            dispatch((0, _AudioEditorActions.addAudioToTimeline)(dropPosition.index, sound));
	        } else dispatch((0, _AudioEditorActions.addAudioToTimeline)(0, sound));
	
	        _SaveManager2.default.isContentChanged(true);
	        this.checkTimelineWidth();
	        this.addActionToHistory();
	
	        if (position != -1) dispatch((0, _AudioEditorActions.setMarkerPosition)(position));
	    },
	    transformToSeconds: function transformToSeconds(counter) {
	        var minutes = Math.floor(counter / 60);
	        var seconds = counter - minutes * 60;
	        var text = '';
	
	        if (minutes < 10) text = text + '0' + minutes;else text = text + minutes;
	
	        text = text + ':';
	
	        if (seconds < 10) text = text + '0' + seconds;else text = text + seconds;
	
	        return text;
	    },
	    getMarkerPosition: function getMarkerPosition() {
	        var state = _StoreManager2.default.getState();
	        var markerPosition = state.audioEditor.markerPosition;
	
	        if (markerPosition == undefined) return -1;else return markerPosition;
	    },
	    addActionToHistory: function addActionToHistory() {
	        setTimeout(function () {
	            var dispatch = _StoreManager2.default.getStore().dispatch;
	            dispatch((0, _UndoRedoActions.addNewActionToHistory)());
	        }.bind(this), 10);
	    },
	    getTimelineOffset: function getTimelineOffset() {
	        var offsetTime;
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (this.maxPosition > 4 * 60) offsetTime = 10;else offsetTime = 60 * 2;
	        } else {
	            if (this.maxPosition > 10 * 60) offsetTime = 30;else if (this.maxPosition < 5 * 60) offsetTime = 3 * 60;else offsetTime = 1 * 60;
	        }
	
	        return this.getSlideWidth(offsetTime);
	    },
	    checkTimelineWidth: function checkTimelineWidth() {
	        var updateScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var oldZoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	        var forceWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        if (!_PlayController2.default.isAudioEditorMode()) return;
	
	        setTimeout(function () {
	            var state = _StoreManager2.default.getState();
	            var dispatch = _StoreManager2.default.getStore().dispatch;
	            var oldWidth = state.audioEditor.timelineWidth;
	            var currentWidth = this.getTimelineWidth();
	            var timelineWidthChanged = false;
	            var offset = this.getTimelineOffset(currentWidth);
	
	            if (oldWidth < currentWidth || forceWidth) {
	                dispatch((0, _AudioEditorActions.setTimelineWidth)(currentWidth + offset));
	                timelineWidthChanged = true;
	                updateScroll = true;
	            }
	
	            if (oldZoom != -1) this.checkScrollForZoom();else {
	                if (updateScroll) this.checkScroll(timelineWidthChanged, currentWidth);
	            }
	
	            // only when the left menu si collapse/expanded
	            if (!this.isControlPointAction && !this.isVolumeAction && forceWidth) dispatch((0, _AudioEditorActions.refreshAudioTrack)(Math.random()));
	        }.bind(this), 5);
	    },
	
	    zoomTime: -1,
	    checkScrollForZoom: function checkScrollForZoom() {
	        if (this.zoomTime < 0 || new Date().getTime() - this.zoomTime > 2000) _PlayController2.default.getOldScrollPosition();
	
	        this.zoomTime = new Date().getTime();
	    },
	    checkScroll: function checkScroll(timelineWidthChanged) {
	        setTimeout(function () {
	            var comp = document.getElementById('slidesList');
	            var scrollPosition = this.getSlideWidth(this.getMarkerPosition());
	
	            if (!timelineWidthChanged) {
	                var state = _StoreManager2.default.getState();
	                var windowWidth = state.production.windowWidth;
	                var accordionWidth = state.accordion.width;
	                var visibleArea = windowWidth - accordionWidth - _AudioToolUtils2.default.buttonsHolderWidth() - this.getCurrentSlideWidth();
	
	                scrollPosition = scrollPosition - visibleArea;
	            }
	
	            if (comp) comp.scrollLeft = scrollPosition;
	        }.bind(this), 100);
	    },
	    getSelectedAudio: function getSelectedAudio() {
	        var audioEditor = _StoreManager2.default.getState().audioEditor;
	
	        if (audioEditor == undefined) return undefined;
	
	        var timelines = audioEditor.timelines;
	        var i;
	        var j;
	
	        for (i = 0; i < timelines.length; i++) {
	            var audios = timelines[i].audios;
	
	            for (j = 0; j < audios.length; j++) {
	                if (audios[j] && audios[j].showControlPoint) {
	                    return { model: audios[j], index: i };
	                }
	            }
	        }
	
	        return undefined;
	    },
	    updateMarker: function updateMarker() {
	        setTimeout(function () {
	            if (this.markerUpdater) this.markerUpdater();
	        }.bind(this), 10);
	    },
	    updateVolumePoints: function updateVolumePoints(points, oldInPoint, newInPoint, oldOutPoint, newOutPoint, newDuration) {
	        if (!points || points.length < 2) return undefined;
	
	        if (oldInPoint == newInPoint && oldOutPoint == newOutPoint) return points;
	
	        var offset;
	        var newPoints = [];
	        var i;
	        var isFirst = false;
	        var newVol;
	
	        if (!newInPoint) newInPoint = 0;
	
	        if (!newOutPoint) newOutPoint = 0;
	
	        if (!oldInPoint) oldInPoint = 0;
	
	        if (!oldOutPoint) oldOutPoint = 0;
	
	        if (oldInPoint != newInPoint) {
	            // left Arrow handling
	            offset = Math.abs(oldInPoint - newInPoint);
	
	            if (oldInPoint > newInPoint) {
	                // drag to the left
	                newPoints.push({ time: 0, vol: points[0].vol });
	
	                for (i = 0; i < points.length; i++) {
	                    newPoints.push({ time: points[i].time + offset, vol: points[i].vol });
	                }
	            } else {
	                // drag to the right
	                for (i = 0; i < points.length; i++) {
	                    if (points[i].time > offset) {
	                        if (!isFirst) {
	                            if (i > 0) newVol = this.getIntersectionPoint(points[i].time, points[i].vol, points[i - 1].time, points[i - 1].vol, offset);else newVol = points[i].vol;
	
	                            newPoints.push({ time: 0, vol: newVol });
	                        }
	
	                        newPoints.push({ time: points[i].time - offset, vol: points[i].vol });
	                        isFirst = true;
	                    }
	                }
	            }
	        } else {
	            // right Arrow handling
	            offset = Math.abs(oldOutPoint - newOutPoint);
	
	            if (oldOutPoint < newOutPoint) {
	                // drag to the left
	                for (i = 0; i < points.length; i++) {
	                    if (points[i].time < newDuration) {
	                        newPoints.push({ time: points[i].time, vol: points[i].vol });
	                    } else {
	                        if (i > 1) newVol = this.getIntersectionPoint(points[i].time, points[i].vol, points[i - 1].time, points[i - 1].vol, newDuration);else newVol = points[i].vol;
	
	                        newPoints.push({ time: newDuration, vol: newVol });
	                        break;
	                    }
	                }
	            } else {
	                // drag to the right
	                for (i = 0; i < points.length; i++) {
	                    newPoints.push({ time: points[i].time, vol: points[i].vol });
	                }
	
	                newPoints.push({ time: newDuration, vol: points[points.length - 1].vol });
	            }
	        }
	
	        return newPoints;
	    },
	    getControlPointsForSplitItems: function getControlPointsForSplitItems(points, leftDuration) {
	        var leftPoints = [];
	        var rightPoints = [];
	        var i;
	        var isFirst = false;
	
	        for (i = 0; i < points.length; i++) {
	            if (points[i].time > leftDuration) {
	                if (!isFirst) {
	                    if (points[i - 1] && points[i]) {
	                        var volume = this.getIntersectionPoint(points[i - 1].time, points[i - 1].vol, points[i].time, points[i].vol, leftDuration);
	
	                        leftPoints.push({ time: leftDuration, vol: volume });
	                        rightPoints.push({ time: 0, vol: volume });
	                    }
	                }
	
	                rightPoints.push({ time: points[i].time - leftDuration, vol: points[i].vol });
	
	                isFirst = true;
	            } else {
	                leftPoints.push(points[i]);
	            }
	        }
	
	        return { left: leftPoints, right: rightPoints };
	    },
	    getIntersectionPoint: function getIntersectionPoint(x1, y1, x2, y2, x) {
	        return ((x - x1) * (y2 - y1) + y1 * (x2 - x1)) / (x2 - x1);
	    },
	    extractContentItemId: function extractContentItemId(link) {
	        if (!link) return -1;
	
	        var index = link.indexOf('file/ci/');
	        var index2 = link.indexOf('/aaa');
	        var id = -1;
	
	        if (index > 0 && index2 > 0) id = link.substring(index + 8, index2);
	
	        return parseInt(id);
	    },
	    ensureHasContentItem: function ensureHasContentItem(audio) {
	        var contentItemId = this.extractContentItemId(audio.href);
	
	        if (contentItemId > 0) audio.contentItemId = contentItemId;
	    },
	    isAudioSelected: function isAudioSelected() {
	        var audioEditor = _StoreManager2.default.getState().audioEditor;
	
	        if (audioEditor == undefined) return false;
	
	        var timelines = audioEditor.timelines;
	        var i;
	
	        for (i = 0; i < timelines.length; i++) {
	            if (timelines[i].isSelected) return true;
	        }
	
	        return false;
	    },
	    checkAudioControlPoints: function checkAudioControlPoints(data) {
	        var timelines = data.timelines;
	        var i, j, k;
	
	        for (i = 0; i < timelines.length; i++) {
	            var audios = timelines[i].audios;
	
	            for (j = 0; j < audios.length; j++) {
	                var audio = audios[j];
	
	                if (audio.points) {
	                    var newPoints = [];
	                    var duration = audio.duration;
	
	                    for (k = 0; k < audio.points.length; k++) {
	                        var point = audio.points[k];
	
	                        if (point.time < 0 || point.time > duration) {
	                            // wrong
	                        } else {
	                            newPoints.push(point);
	                        }
	                    }
	
	                    audio.points = newPoints;
	                }
	            }
	        }
	
	        return data;
	    },
	    getMaxTimelines: function getMaxTimelines() {
	        var maxTimelines;
	
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            if (_PlatformDetection2.default.isIOS()) {
	                if (_PlatformDetection2.default.isIOSApp()) maxTimelines = 7;else maxTimelines = 5;
	            } else maxTimelines = 7;
	        } else maxTimelines = 5;
	
	        var maxTimelinesRelatedToHeight = this.getMaxTimelinesRelatedToHeight();
	
	        if (maxTimelinesRelatedToHeight < maxTimelines) return maxTimelinesRelatedToHeight;
	
	        return maxTimelines;
	    },
	    getMaxTimelinesRelatedToHeight: function getMaxTimelinesRelatedToHeight() {
	        // if (audioToolUtils.isAudioTool()) {
	        //     var windowHeight = storeManager.getState().production.windowHeight;
	        //     var freeHeight = windowHeight - 200;
	        //     var trackHeight = audioToolUtils.timelineHeight();
	        //
	        //     return Math.floor(freeHeight / trackHeight);
	        // } else
	        return 20;
	    },
	
	    addControlPointHandler: undefined
	};
	
	exports.default = audioEditorUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/utils/AudioEditorUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/utils/AudioEditorUtils.js"); } } })();

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    LOAD_LOCAL: false, // true - local/ false - from server(stage or prod)
	
	    CONTEXT: 'edit', // edit, player, print, printEditor, download, audioTool, audioToolPlayer, exportPlayer, exportAudioPlayer
	    LOAD_BLANK_PRODUCTION: true,
	    AUTOSAVE_AVAILABLE: true,
	    AUTOSAVE_TIME: 15, // defined in seconds
	    MEDIA_FILES_PAGE_LIMIT: 1500,
	    CANVAS_WIDTH: 800,
	    CANVAS_HEIGHT: 450,
	    SLIDE_DURATION: 4, // defined in seconds
	    SCREENSHOT_WIDTH: 400,
	    USE_WAVEFORM: true,
	    FIRST_PRELOADED_SLIDES: 2, // the rest of slide are preloaded in background
	
	    AUDIO_TOOL_CLIRPART_ID_STAGE: 75314197,
	    AUDIO_TOOL_CLIRPART_ID_PROD: 78231078,
	    MASTER_CLIPART_ID: 62348494,
	    MASTER_CLIPART_ID_PROD: 62348494,
	    DEFAULT_CLIPART_ID: 102264236, // Animals
	    DEFAULT_CLIPART_ID_PROD: 102264236, // Animals
	
	    IS_PROD: function IS_PROD() {
	        if (window.location.href.indexOf('stage') != -1) return false;else return true;
	    }
	};
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/constants/Configuration.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/constants/Configuration.js"); } } })();

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hoverManager = {
	    toolTip: undefined,
	    isRecording: false,
	
	    removeOldTooltip: function removeOldTooltip() {
	        if (this.toolTip && this.toolTip.parentNode) this.toolTip.parentNode.removeChild(this.toolTip);
	    },
	    getText: function getText(type) {
	        var text = '';
	        var useTranslation = true;
	
	        switch (type) {
	            case 'addSlide':
	                {
	                    text = _LocalesManager2.default.getCaption('addSlide', 'hover');
	                    break;
	                }
	            case 'preview':
	                {
	                    text = _LocalesManager2.default.getCaption('preview', 'hover');
	                    break;
	                }
	            case 'undo':
	                {
	                    text = _LocalesManager2.default.getCaption('undo', 'hover');
	                    break;
	                }
	            case 'redo':
	                {
	                    text = _LocalesManager2.default.getCaption('redo', 'hover');
	                    break;
	                }
	            case 'playSlide':
	                {
	                    text = _LocalesManager2.default.getCaption('playSlide', 'hover');
	                    break;
	                }
	            case 'stop':
	                {
	                    text = _LocalesManager2.default.getCaption('stop', 'hover');
	                    break;
	                }
	            case 'slideDuration':
	                {
	                    text = _LocalesManager2.default.getCaption('slideDuration', 'hover');
	                    break;
	                }
	            case 'resizeAccordion':
	                {
	                    text = _LocalesManager2.default.getCaption('resizeAccordion', 'hover');
	                    break;
	                }
	            case 'expandedListView':
	                {
	                    text = _LocalesManager2.default.getCaption('expandedListView', 'hover');
	                    break;
	                }
	            case 'collapsedListView':
	                {
	                    text = _LocalesManager2.default.getCaption('collapsedListView', 'hover');
	                    break;
	                }
	            case 'playSoundItem':
	                {
	                    text = _LocalesManager2.default.getCaption('playSoundItem', 'hover');
	                    break;
	                }
	            case 'saveButton':
	                {
	                    text = _LocalesManager2.default.getCaption('saveButton', 'hover');
	                    break;
	                }
	            case 'helpButton':
	                {
	                    text = _LocalesManager2.default.getCaption('helpButton', 'hover');
	                    break;
	                }
	            case 'searchButton':
	                {
	                    text = _LocalesManager2.default.getCaption('searchButton', 'hover');
	                    break;
	                }
	            case 'closeSearchButton':
	                {
	                    text = _LocalesManager2.default.getCaption('closeSearchButton', 'hover');
	                    break;
	                }
	            case 'uploadButton':
	                {
	                    text = _LocalesManager2.default.getCaption('UploadHover', 'myFiles');
	                    break;
	                }
	            case 'editShape':
	                {
	                    text = _LocalesManager2.default.getCaption('editShape', 'hover');
	                    break;
	                }
	            case 'editSlide':
	                {
	                    text = _LocalesManager2.default.getCaption('editSlide', 'hover');
	                    break;
	                }
	            case 'deleteSound':
	                {
	                    text = _LocalesManager2.default.getCaption('deleteSound', 'hover');
	                    break;
	                }
	            case 'volumeSound':
	                {
	                    text = _LocalesManager2.default.getCaption('volumeSound', 'hover');
	                    break;
	                }
	            case 'playSound':
	                {
	                    text = _LocalesManager2.default.getCaption('playSound', 'hover');
	                    break;
	                }
	
	            // Preview/Player mode
	            case 'firstSlide':
	                {
	                    text = _LocalesManager2.default.getCaption('firstSlide', 'hover');
	                    break;
	                }
	            case 'previousSlide':
	                {
	                    text = _LocalesManager2.default.getCaption('previousSlide', 'hover');
	                    break;
	                }
	            case 'previewModePlayCartoon':
	                {
	                    text = _LocalesManager2.default.getCaption('previewModePlayCartoon', 'hover');
	                    break;
	                }
	            case 'previewModePauseCartoon':
	                {
	                    text = _LocalesManager2.default.getCaption('previewModePauseCartoon', 'hover');
	                    break;
	                }
	            case 'nextSlide':
	                {
	                    text = _LocalesManager2.default.getCaption('nextSlide', 'hover');
	                    break;
	                }
	            case 'lastSlide':
	                {
	                    text = _LocalesManager2.default.getCaption('lastSlide', 'hover');
	                    break;
	                }
	            case 'exitPreview':
	                {
	                    text = _LocalesManager2.default.getCaption('exitPreview', 'hover');
	                    break;
	                }
	
	            case 'normalScreen':
	                {
	                    text = _LocalesManager2.default.getCaption('normalScreen', 'hover');
	                    break;
	                }
	
	            case 'fullScreen':
	                {
	                    text = _LocalesManager2.default.getCaption('fullScreen', 'hover');
	                    break;
	                }
	
	            // Video Editor
	            case 'playVideo':
	                {
	                    text = _LocalesManager2.default.getCaption('playVideo', 'hover');
	                    break;
	                }
	            case 'cancelVideo':
	                {
	                    text = _LocalesManager2.default.getCaption('cancelVideo', 'hover');
	                    break;
	                }
	            case 'okVideo':
	                {
	                    text = _LocalesManager2.default.getCaption('okVideo', 'hover');
	                    break;
	                }
	            case 'videoLeftTrim':
	                {
	                    text = _LocalesManager2.default.getCaption('videoLeftTrim', 'hover');
	                    break;
	                }
	            case 'videoRightTrim':
	                {
	                    text = _LocalesManager2.default.getCaption('videoRightTrim', 'hover');
	                    break;
	                }
	            case 'videoMinVolume':
	                {
	                    text = _LocalesManager2.default.getCaption('videoMinVolume', 'hover');
	                    break;
	                }
	            case 'videoMaxVolume':
	                {
	                    text = _LocalesManager2.default.getCaption('videoMaxVolume', 'hover');
	                    break;
	                }
	
	            // Audio Editor
	            case 'zoomMinus':
	                {
	                    text = _LocalesManager2.default.getCaption('zoomMinus', 'hover');
	                    break;
	                }
	            case 'zoomPlus':
	                {
	                    text = _LocalesManager2.default.getCaption('zoomPlus', 'hover');
	                    break;
	                }
	            case 'showRightMenu':
	                {
	                    text = _LocalesManager2.default.getCaption('showRightMenu', 'hover');
	                    break;
	                }
	            case 'hideRightMenu':
	                {
	                    text = _LocalesManager2.default.getCaption('hideRightMenu', 'hover');
	                    break;
	                }
	            case 'deleteAudioItem':
	                {
	                    text = _LocalesManager2.default.getCaption('deleteAudioItem', 'hover');
	                    break;
	                }
	            case 'splitAudio':
	                {
	                    text = _LocalesManager2.default.getCaption('splitAudio', 'hover');
	                    break;
	                }
	            case 'addControlPoint':
	                {
	                    text = _LocalesManager2.default.getCaption('addControlPoint', 'hover');
	                    break;
	                }
	            case 'playCartoon':
	                {
	                    text = _LocalesManager2.default.getCaption('playCartoon', 'hover');
	                    break;
	                }
	            case 'goToStart':
	                {
	                    text = _LocalesManager2.default.getCaption('goToStart', 'hover');
	                    break;
	                }
	            case 'goToEnd':
	                {
	                    text = _LocalesManager2.default.getCaption('goToEnd', 'hover');
	                    break;
	                }
	            case 'trackVolume':
	                {
	                    text = _LocalesManager2.default.getCaption('trackVolume', 'hover');
	                    break;
	                }
	            case 'audioLeftTrim':
	                {
	                    text = _LocalesManager2.default.getCaption('audioLeftTrim', 'hover');
	                    break;
	                }
	            case 'audioRightTrim':
	                {
	                    text = _LocalesManager2.default.getCaption('audioRightTrim', 'hover');
	                    break;
	                }
	            case 'slideTrim':
	                {
	                    text = _LocalesManager2.default.getCaption('slideTrim', 'hover');
	                    break;
	                }
	            case 'audioVolumePoint':
	                {
	                    text = _LocalesManager2.default.getCaption('audioVolumePoint', 'hover');
	                    break;
	                }
	            case 'trackSettings':
	                {
	                    text = _LocalesManager2.default.getCaption('trackSettings', 'hover');
	                    break;
	                }
	            case 'startAudio':
	                {
	                    text = _LocalesManager2.default.getCaption('startAudio', 'hover');
	                    break;
	                }
	            case 'backAudio':
	                {
	                    text = _LocalesManager2.default.getCaption('backAudio', 'hover');
	                    break;
	                }
	            case 'nextAudio':
	                {
	                    text = _LocalesManager2.default.getCaption('nextAudio', 'hover');
	                    break;
	                }
	            case 'endAudio':
	                {
	                    text = _LocalesManager2.default.getCaption('endAudio', 'hover');
	                    break;
	                }
	            case 'changeVolume':
	                {
	                    text = _LocalesManager2.default.getCaption('changeVolume', 'hover');
	                    break;
	                }
	
	            // old tooltips
	            case 'SplitClipHover':
	                {
	                    text = _LocalesManager2.default.getCaption('SplitClipHover', 'other');
	                    break;
	                }
	            case 'MySoundsTitle':
	                {
	                    text = _LocalesManager2.default.getCaption('MySoundsTitle', 'music');
	                    break;
	                }
	
	            // left main menu
	            case 'mainMenuText':
	                {
	                    text = _LocalesManager2.default.getCaption('mainMenuText', 'hover');
	                    break;
	                }
	            case 'mainMenuDrawing':
	                {
	                    text = _LocalesManager2.default.getCaption('mainMenuDrawing', 'hover');
	                    break;
	                }
	            case 'mainMenuShapes':
	                {
	                    text = _LocalesManager2.default.getCaption('mainMenuShapes', 'hover');
	                    break;
	                }
	            case 'mainMenuEffects':
	                {
	                    text = _LocalesManager2.default.getCaption('mainMenuEffects', 'hover');
	                    break;
	                }
	            case 'mainMenuFrames':
	                {
	                    text = _LocalesManager2.default.getCaption('mainMenuFrames', 'hover');
	                    break;
	                }
	            case 'mainMenuMedia':
	                {
	                    text = _LocalesManager2.default.getCaption('mainMenuMedia', 'hover');
	                    break;
	                }
	
	            /********************** Text Editor tool *********************/
	
	            case 'textBox':
	                {
	                    // text = 'Tekstboks uten ramme';
	                    text = _LocalesManager2.default.getCaption('TextBoxSimpleAriaLabel', 'other');
	                    break;
	                }
	            case 'textBoxSimple':
	                {
	                    // text = 'Tekstboks med ramme';
	                    text = _LocalesManager2.default.getCaption('TextBoxAriaLabel', 'other');
	                    break;
	                }
	            case 'speechBubble':
	                {
	                    // text = 'Snakkeboble';
	                    text = _LocalesManager2.default.getCaption('SpeechAriaLabel', 'other');
	                    break;
	                }
	            case 'thoughtBubble':
	                {
	                    // text = 'Tankeboble';
	                    text = _LocalesManager2.default.getCaption('ThoughtBubbleAriaLabel', 'other');
	                    break;
	                }
	            case 'screamBubble':
	                {
	                    // text = 'Ropeboble';
	                    text = _LocalesManager2.default.getCaption('ScreamBubbleAriaLabel', 'other');
	                    break;
	                }
	            case 'complexSpeechBubble':
	                {
	                    // text = 'Snakkeboble med flere haler';
	                    text = _LocalesManager2.default.getCaption('ComplexSpeechBubbleAriaLabel', 'other');
	                    break;
	                }
	
	            //buttons from the top area (Edit text): used for both tooltip and aria-label
	            case 'fontColor':
	                {
	                    if (!useTranslation) text = 'Font color';else text = _LocalesManager2.default.getCaption('fontColor', 'other');
	                    break;
	                }
	            case 'bold':
	                {
	                    if (!useTranslation) text = 'Bold';else text = _LocalesManager2.default.getCaption('bold', 'other');
	                    break;
	                }
	            case 'italic':
	                {
	                    if (!useTranslation) text = 'Italic';else text = _LocalesManager2.default.getCaption('italic', 'other');
	                    break;
	                }
	            case 'underline':
	                {
	                    if (!useTranslation) text = 'Underline';else text = _LocalesManager2.default.getCaption('underline', 'other');
	                    break;
	                }
	            case 'leftAlign':
	                {
	                    if (!useTranslation) text = 'Left align';else text = _LocalesManager2.default.getCaption('leftAlign', 'other');
	                    break;
	                }
	            case 'centerAlign':
	                {
	                    if (!useTranslation) text = 'Center align';else text = _LocalesManager2.default.getCaption('centerAlign', 'other');
	                    break;
	                }
	            case 'rightAlign':
	                {
	                    if (!useTranslation) text = 'Right align';else text = _LocalesManager2.default.getCaption('rightAlign', 'other');
	                    break;
	                }
	            case 'orderedList':
	                {
	                    if (!useTranslation) text = 'Ordered list';else text = _LocalesManager2.default.getCaption('orderedList', 'other');
	                    break;
	                }
	            case 'bulletList':
	                {
	                    if (!useTranslation) text = 'Bullet list';else text = _LocalesManager2.default.getCaption('bulletList', 'other');
	                    break;
	                }
	            case 'outdent':
	                {
	                    if (!useTranslation) text = 'Outdent';else text = _LocalesManager2.default.getCaption('outdent', 'other');
	                    break;
	                }
	            case 'ident':
	                {
	                    if (!useTranslation) text = 'Ident';else text = _LocalesManager2.default.getCaption('ident', 'other');
	                    break;
	                }
	            case 'superscript':
	                {
	                    if (!useTranslation) text = 'Superscript';else text = _LocalesManager2.default.getCaption('superscript', 'other');
	                    break;
	                }
	            case 'subscript':
	                {
	                    if (!useTranslation) text = 'Subscript';else text = _LocalesManager2.default.getCaption('subscript', 'other');
	                    break;
	                }
	            case 'lineHeight':
	                {
	                    if (!useTranslation) text = 'Line height';else text = _LocalesManager2.default.getCaption('lineHeight', 'other');
	                    break;
	                }
	
	            // used for the title of the top area
	            case 'editText':
	                {
	                    if (!useTranslation) text = 'Edit text';else text = _LocalesManager2.default.getCaption('editText', 'other');
	                    break;
	                }
	            // used for the title of the bottom area
	            case 'editTextElement':
	                {
	                    if (!useTranslation) text = 'Edit text element';else text = _LocalesManager2.default.getCaption('editTextElement', 'other');
	                    break;
	                }
	            // used for insert image holder title
	            case 'insertImageTitle':
	                {
	                    text = _LocalesManager2.default.getCaption('insertImageTitle', 'other');
	                    break;
	                }
	            // used for insert image button
	            case 'insertImage':
	                {
	                    text = _LocalesManager2.default.getCaption('insertImage', 'other');
	                    break;
	                }
	            // used for replace image button
	            case 'replaceImage':
	                {
	                    text = _LocalesManager2.default.getCaption('replaceImage', 'other');
	                    break;
	                }
	            // used for remove image button
	            case 'removeImage':
	                {
	                    text = _LocalesManager2.default.getCaption('removeImage', 'other');
	                    break;
	                }
	            // the title on top of the Fonts Selector
	            case 'fontTitle':
	                {
	                    if (!useTranslation) text = 'Font';else text = _LocalesManager2.default.getCaption('fontTitle', 'other');
	                    break;
	                }
	            // the title on top of the Font Size Selector
	            case 'sizeTitle':
	                {
	                    if (!useTranslation) text = 'Size';else text = _LocalesManager2.default.getCaption('sizeTitle', 'other');
	                    break;
	                }
	            // aria label title used for the "PlusMoreColors" under Palete color
	            case 'moreColors':
	                {
	                    if (!useTranslation) text = 'More colors';else text = _LocalesManager2.default.getCaption('moreColors', 'other');
	                    break;
	                }
	            // the label title for the ColorPicker (input with type=color)
	            case 'favoriteColor':
	                {
	                    if (!useTranslation) text = 'Select your favorite color';else text = _LocalesManager2.default.getCaption('favoriteColor', 'other');
	                    break;
	                }
	            // the title and aria-label for FILL button
	            case 'fillColor':
	                {
	                    if (!useTranslation) text = 'Fill';else text = _LocalesManager2.default.getCaption('fillColor', 'other');
	                    break;
	                }
	            // the title and aria-label for BORDER button
	            case 'borderColor':
	                {
	                    if (!useTranslation) text = 'Border color';else text = _LocalesManager2.default.getCaption('borderColor', 'other');
	                    break;
	                }
	            // aria-label title for MINUS button
	            case 'minus':
	                {
	                    if (!useTranslation) text = 'Decrease font size';else text = _LocalesManager2.default.getCaption('minus', 'other');
	                    break;
	                }
	            // aria-label title for PLUS button
	            case 'plus':
	                {
	                    if (!useTranslation) text = 'Increase font size';else text = _LocalesManager2.default.getCaption('plus', 'other');
	                    break;
	                }
	        }
	
	        return text;
	    },
	    show: function show(target, type) {
	        var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'top';
	        var useCurrentCaption = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	        var clientX = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
	
	        if (_PlatformDetection2.default.isIOS() || this.isRecording) return;
	
	        this.removeOldTooltip();
	        var text = this.getText(type);
	
	        if (useCurrentCaption) text = type;
	
	        if (text == '' || target == undefined) return;
	
	        var padding = 8;
	        var stemSize = 8;
	        var extraOffset = 0;
	
	        if (position == 'left' || position == 'right') {
	            stemSize = 5;
	
	            if (type == 'cancelVideo') extraOffset = 10;
	        }
	
	        this.toolTip = document.createElement('div');
	
	        this.toolTip.style.position = 'absolute';
	        this.toolTip.style.fontSize = '12px';
	        this.toolTip.style.background = _Properties2.default.RECORD_TOOLTIP_BACKGROUND;
	        this.toolTip.style.wordWrap = 'break-word';
	        this.toolTip.style.textAlign = 'center';
	        this.toolTip.style.padding = padding + 'px';
	        this.toolTip.style.borderRadius = '3px';
	        this.toolTip.style.color = 'white';
	        this.toolTip.style.display = 'block';
	        this.toolTip.style.pointerEvents = 'none';
	        this.toolTip.style.zIndex = 9999999;
	
	        var bounds = target.getBoundingClientRect();
	        var textWidth = _TextSizeUtils2.default.getSpanWidth(12, text);
	        var height = 14;
	        var realWidth = textWidth + 2 * padding;
	        var realHeight = height + 2 * padding;
	
	        this.toolTip.innerHTML = text;
	        this.toolTip.style.width = textWidth + 'px';
	        this.toolTip.style.height = height + 'px';
	
	        var stem = document.createElement('div');
	        var stemWidth = 2 * stemSize;
	
	        stem.style.position = 'absolute';
	        stem.style.display = 'block';
	        stem.style.borderStyle = 'solid';
	        stem.style.borderWidth = stemSize + 'px';
	
	        var offset = 2;
	
	        switch (position) {
	            case 'top':
	                {
	                    stem.style.borderTopColor = _Properties2.default.RECORD_TOOLTIP_BACKGROUND;
	                    stem.style.borderBottomColor = 'transparent';
	                    stem.style.borderLeftColor = 'transparent';
	                    stem.style.borderRightColor = 'transparent';
	
	                    var leftPositionValue;
	
	                    if (clientX > 0) leftPositionValue = clientX - realWidth / 2;else leftPositionValue = bounds.left + bounds.width / 2 - realWidth / 2;
	
	                    if (leftPositionValue < 0) leftPositionValue = 0;
	
	                    this.toolTip.style.left = leftPositionValue + 'px';
	                    this.toolTip.style.top = bounds.top - realHeight - stemSize - offset + 'px';
	
	                    stem.style.top = realHeight + 'px';
	                    stem.style.left = realWidth / 2 - stemWidth / 2 + 'px';
	                    break;
	                }
	            case 'bottom':
	                {
	                    stem.style.borderTopColor = 'transparent';
	                    stem.style.borderBottomColor = _Properties2.default.RECORD_TOOLTIP_BACKGROUND;
	                    stem.style.borderLeftColor = 'transparent';
	                    stem.style.borderRightColor = 'transparent';
	
	                    this.toolTip.style.left = bounds.left + bounds.width / 2 - realWidth / 2 + 'px';
	                    this.toolTip.style.top = bounds.top + bounds.height + stemSize + offset + 'px';
	
	                    stem.style.top = -2 * stemSize + 'px';
	                    stem.style.left = realWidth / 2 - stemWidth / 2 + 'px';
	                    break;
	                }
	            case 'left':
	                {
	                    stem.style.borderTopColor = 'transparent';
	                    stem.style.borderBottomColor = 'transparent';
	                    stem.style.borderLeftColor = _Properties2.default.RECORD_TOOLTIP_BACKGROUND;
	                    stem.style.borderRightColor = 'transparent';
	
	                    this.toolTip.style.left = bounds.left - realWidth - stemSize - offset + 'px';
	                    this.toolTip.style.top = bounds.top + bounds.height / 2 - realHeight / 2 - extraOffset + 'px';
	
	                    stem.style.top = realHeight / 2 - stemSize + 'px';
	                    stem.style.left = realWidth + 'px';
	                    break;
	                }
	            case 'right':
	                {
	                    stem.style.borderTopColor = 'transparent';
	                    stem.style.borderBottomColor = 'transparent';
	                    stem.style.borderLeftColor = 'transparent';
	                    stem.style.borderRightColor = _Properties2.default.RECORD_TOOLTIP_BACKGROUND;
	
	                    this.toolTip.style.left = bounds.left + bounds.width + stemSize + offset + 'px';
	                    this.toolTip.style.top = bounds.top + bounds.height / 2 - realHeight / 2 - extraOffset + 'px';
	
	                    stem.style.top = realHeight / 2 - stemSize + 'px';
	                    stem.style.left = -2 * stemSize + 'px';
	                    break;
	                }
	        }
	
	        this.toolTip.appendChild(stem);
	
	        document.body.appendChild(this.toolTip);
	    },
	    hide: function hide() {
	        if (_PlatformDetection2.default.isIOSApp()) return;
	
	        this.removeOldTooltip();
	    },
	    showHelpInfo: function showHelpInfo(target, type) {
	        this.removeOldTooltip();
	        var text = this.getText(type);
	
	        if (text == '' || target == undefined) return;
	
	        var padding = 20;
	        var stemSize = 10;
	        var extraOffset = 0;
	        var fontSize = 20;
	
	        this.toolTip = document.createElement('div');
	
	        this.toolTip.style.position = 'absolute';
	        this.toolTip.style.fontSize = fontSize + 'px';
	        this.toolTip.style.background = _Properties2.default.RECORD_TOOLTIP_BACKGROUND;
	        this.toolTip.style.wordWrap = 'break-word';
	        this.toolTip.style.textAlign = 'center';
	        this.toolTip.style.padding = padding + 'px';
	        this.toolTip.style.borderRadius = '3px';
	        this.toolTip.style.color = 'white';
	        this.toolTip.style.display = 'block';
	        this.toolTip.style.pointerEvents = 'none';
	
	        var bounds = target.getBoundingClientRect();
	        var textWidth = _TextSizeUtils2.default.getSpanWidth(fontSize, text);
	        var height = 24;
	        var realWidth = textWidth + 2 * padding;
	        var realHeight = height + 2 * padding;
	
	        this.toolTip.innerHTML = text;
	        this.toolTip.style.width = textWidth + 'px';
	        this.toolTip.style.height = height + 'px';
	
	        var stem = document.createElement('div');
	
	        stem.style.position = 'absolute';
	        stem.style.display = 'block';
	        stem.style.borderStyle = 'solid';
	        stem.style.borderWidth = stemSize + 'px';
	
	        var offset = 5;
	
	        stem.style.borderTopColor = 'transparent';
	        stem.style.borderBottomColor = 'transparent';
	        stem.style.borderLeftColor = _Properties2.default.RECORD_TOOLTIP_BACKGROUND;
	        stem.style.borderRightColor = 'transparent';
	
	        this.toolTip.style.left = bounds.left - realWidth - stemSize - offset + 'px';
	        this.toolTip.style.top = bounds.top + bounds.height / 2 - realHeight / 2 - extraOffset + 'px';
	
	        stem.style.top = realHeight / 2 - stemSize + 'px';
	        stem.style.left = realWidth + 'px';
	
	        this.toolTip.appendChild(stem);
	
	        document.body.appendChild(this.toolTip);
	    }
	};
	
	exports.default = hoverManager;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/HoverManager.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/HoverManager.js"); } } })();

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _MusicActions = __webpack_require__(91);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AudioConverter = __webpack_require__(231);
	
	var _AudioConverter2 = _interopRequireDefault(_AudioConverter);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _SlidesUtils = __webpack_require__(125);
	
	var _SlidesUtils2 = _interopRequireDefault(_SlidesUtils);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _AudioVolumeUtils = __webpack_require__(67);
	
	var _AudioVolumeUtils2 = _interopRequireDefault(_AudioVolumeUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playController = {
	    audioEditorWrapper: undefined,
	    MARKER_STEP: 10, // miliseconds
	    VOLUME_STEP: 50, // miliseconds
	    audios: [],
	    startDate: -1,
	    pauseDate: -1,
	    markerTimer: undefined,
	    volumeTimer: undefined,
	    startTime: -1,
	    startTimers: [],
	    endTimers: [],
	    endOfProductionTimer: undefined,
	    startSlideTimers: [],
	    endTime: -1,
	    refreshControlBar: undefined,
	    endSequenceCallback: undefined,
	    isPreview: true,
	    updateRecordingMenuButtons: undefined,
	    slideModels: [],
	    isPlaying: false,
	    executePlayPause: undefined,
	    executeStop: undefined,
	    changePlayState: undefined,
	    isFirstTimeOpened: false,
	    updateScrollForIOS: undefined,
	    startScroll: undefined,
	    moveScroll: undefined,
	    endScroll: undefined,
	    isRecording: false,
	    oldScrollPosition: -1,
	    FADE_LIMIT: 4000, // 4 seconds
	
	    getDispatch: function getDispatch() {
	        var store = _StoreManager2.default.getStore();
	        return store.dispatch;
	    },
	    isAudioEditorAvailable: function isAudioEditorAvailable() {
	        var timelines = this.getAudioTimelines();
	
	        if (timelines == undefined) return false;else return true;
	    },
	    isAudioEditorMode: function isAudioEditorMode() {
	        if (_AudioToolUtils2.default.isAudioTool()) return true;
	
	        var state = _StoreManager2.default.getState();
	
	        if (state.menu && state.menu.showAudioEditor == true) return true;else return false;
	    },
	    getAudioTimelines: function getAudioTimelines() {
	        var state = _StoreManager2.default.getState();
	
	        if (state.audioEditor == undefined) return undefined;
	
	        var timelines = state.audioEditor.timelines;
	
	        return timelines;
	    },
	    updateAudioElements: function updateAudioElements() {
	        var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
	
	        this.updateRefreshElementsStatus(true);
	
	        setTimeout(function () {
	            this.prepareAudios();
	        }.bind(this), offset);
	    },
	    getCorrectHref: function getCorrectHref(audioItem) {
	        if (audioItem.hrefBlob && audioItem.hrefBlob.length > 0) return audioItem.hrefBlob;else return _VideoUtils2.default.checkCacheBreaker(audioItem.href);
	    },
	    prepareAudios: function prepareAudios() {
	        if (!this.isAudioEditorAvailable()) {
	            this.updateRefreshElementsStatus(false);
	            return;
	        }
	
	        this.prepareContent();
	    },
	    useWaveForm: function useWaveForm() {
	        if (_PlatformDetection2.default.isIOS() || _PlatformDetection2.default.isChromeBook() || !_AudioToolUtils2.default.isAudioEditorTool()) return false;else return _Configuration2.default.USE_WAVEFORM;
	    },
	    prepareContent: function prepareContent() {
	        this.pauseAllAudios();
	        this.removeAudioElements();
	
	        this.audios = [];
	
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.prepareSounds();else {
	            var _wrapper = document.createElement('div');
	            this.audioEditorWrapper = _wrapper;
	            _wrapper.style.display = 'none';
	            document.body.appendChild(_wrapper);
	        }
	
	        var timelines = this.getAudioTimelines();
	        var i;
	        var j;
	        var href;
	
	        for (i = 0; i < timelines.length; i++) {
	            var audioItems = timelines[i].audios;
	
	            for (j = 0; j < audioItems.length; j++) {
	                href = this.getCorrectHref(audioItems[j]);
	
	                if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	                    _AudioVolumeUtils2.default.loadBufferForUrl(href, audioItems[j].uuid, this.audios);
	                } else {
	                    if (this.useWaveForm()) _AudioVolumeUtils2.default.loadBufferSound(href);
	
	                    var audioElement = document.createElement('audio');
	                    wrapper.appendChild(audioElement);
	
	                    audioElement.src = href;
	                    audioElement.preload = 'auto';
	                    audioElement.playsInline = true;
	                    audioElement.load();
	
	                    this.audios[audioItems[j].uuid] = audioElement;
	                }
	            }
	        }
	
	        this.updateRefreshElementsStatus(false);
	    },
	    updateRefreshElementsStatus: function updateRefreshElementsStatus(value) {
	        setTimeout(function () {
	            var dispatch = this.getDispatch();
	            dispatch((0, _AudioEditorActions.refreshAudioElements)(value));
	        }.bind(this), 5);
	    },
	    removeAudioElements: function removeAudioElements() {
	        var elem = this.audioEditorWrapper;
	
	        if (!elem) return;
	
	        var fc = elem.firstChild;
	
	        while (fc) {
	            elem.removeChild(fc);
	            fc = elem.firstChild;
	        }
	
	        if (elem && elem.parentElement) elem.parentElement.removeChild(elem);
	
	        this.audioEditorWrapper = undefined;
	    },
	    setStartTime: function setStartTime() {
	        var isRecording = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (this.isAudioEditorMode()) {
	            var markerPosition = _AudioEditorUtils2.default.getMarkerPosition();
	
	            if (markerPosition == -1) this.startTime = 0;else this.startTime = markerPosition;
	
	            if (!isRecording) {
	                if (this.startTime >= this.endTime || Math.abs(this.startTime - this.endTime) < 0.01) this.startTime = 0;
	            }
	        } else {
	            // is Preview/Player or Normal Editor mode
	            var state = _StoreManager2.default.getState();
	            var currentSlideIndex = state.currentSlide.currentSlideIndex;
	            var slideModel = this.slideModels[currentSlideIndex];
	
	            if (!this.isPreview) // is Normal Editor mode
	                this.endTime = slideModel.start + slideModel.duration;
	
	            if (this.startDate != -1 && this.pauseDate != -1) {
	                var timeOffset = this.pauseDate - this.startDate;
	
	                this.startTime = this.startTime + timeOffset / 1000;
	            } else this.startTime = slideModel.start;
	        }
	
	        this.startDate = new Date().getTime();
	    },
	    playMarker: function playMarker() {
	        var isRecording = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (isRecording) {
	            return; // remove for all because of CH-846
	
	            if (_AudioToolUtils2.default.isAudioTool()) // remove for AE tool
	                return;
	
	            if (_PlatformDetection2.default.isTouchableDevice()) // remove for Cartoonist for touchable devices
	                return;
	        }
	
	        this.markerTimer = setInterval(this.checkMarkerPosition.bind(this), this.MARKER_STEP);
	    },
	    checkMarkerPosition: function checkMarkerPosition() {
	        var dispatch = this.getDispatch();
	        var offset = (new Date().getTime() - this.startDate) / 1000;
	        var newPos = this.startTime + offset;
	
	        if (this.startTime == -1) {
	            this.clearTimers();
	
	            return;
	        }
	
	        dispatch((0, _AudioEditorActions.setMarkerPosition)(newPos));
	
	        if (this.isRecording) {
	            if (_AudioEditorUtils2.default.getSlideWidth(newPos) >= _StoreManager2.default.getState().audioEditor.timelineWidth - 20) {
	                // dispatch(setTimelineWidth(audioEditorUtils.getSlideWidth(newPos + 60)));
	            } else {
	                if (!_AudioToolUtils2.default.isAudioTool()) this.checkScrollPosition(newPos);
	            }
	        } else this.checkScrollPosition(newPos);
	    },
	    getIpadScrollPosition: function getIpadScrollPosition() {
	        var scrollComponent = document.getElementsByClassName('scrollForIOS')[0];
	
	        if (scrollComponent) {
	            var leftPos = scrollComponent.style.left;
	            var pos = parseFloat(leftPos.replace('px', '')) * -1;
	
	            if (pos >= 0) return pos;else return 0;
	        } else return 0;
	    },
	    getNormalScrollPosition: function getNormalScrollPosition() {
	        var comp = document.getElementById('slidesList');
	        var scrollPos = 0;
	
	        if (comp) scrollPos = comp.scrollLeft;
	
	        return scrollPos;
	    },
	    getScrollPosition: function getScrollPosition() {
	        if (_PlatformDetection2.default.isTouchableDevice()) return this.getIpadScrollPosition();else return this.getNormalScrollPosition();
	    },
	    updateScrollPosition: function updateScrollPosition() {
	        var offsetTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
	        var useOldScrollPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (!this.isAudioEditorMode() || _SlidesUtils2.default.startPosition != -1) return;
	
	        setTimeout(function () {
	            if (useOldScrollPosition && this.oldScrollPosition != -1) this.goToOldScrollPosition();else {
	                var newPos = _AudioEditorUtils2.default.getMarkerPosition();
	                this.checkScrollPosition(newPos, true);
	            }
	        }.bind(this), offsetTime);
	    },
	    goToOldScrollPosition: function goToOldScrollPosition() {
	        this.setScrollPosition(this.oldScrollPosition);
	    },
	    getOldScrollPosition: function getOldScrollPosition() {
	        this.oldScrollPosition = this.getScrollPosition();
	    },
	    checkScrollPosition: function checkScrollPosition(newPos) {
	        var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var scrollPos = this.getScrollPosition();
	        var state = _StoreManager2.default.getState();
	        var accordionWidth = state.accordion.width;
	        var windowWidth = state.production.windowWidth;
	
	        if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	        if (!(windowWidth > 0)) windowWidth = window.innerWidth;
	
	        var visibleWidth = windowWidth - _AudioToolUtils2.default.buttonsHolderWidth() - accordionWidth;
	        var currentPos = _AudioEditorUtils2.default.getSlideWidth(newPos);
	
	        if (forceUpdate) this.setScrollPosition(currentPos - visibleWidth / 2);else {
	            if (Math.abs(currentPos - scrollPos) > visibleWidth / 2) this.setScrollPosition(currentPos - visibleWidth / 2);
	        }
	    },
	    setScrollPosition: function setScrollPosition(position) {
	        if (_PlatformDetection2.default.isTouchableDevice()) {
	            if (this.updateScrollForIOS) this.updateScrollForIOS(position);
	        } else {
	            var comp = document.getElementById('slidesList');
	
	            if (comp) comp.scrollLeft = position;
	        }
	    },
	    resetScrollPosition: function resetScrollPosition() {
	        this.setScrollPosition(0);
	    },
	    getAvailableTimelines: function getAvailableTimelines(timelines) {
	        var isRecording = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (isRecording) return [];
	
	        var i;
	        var availableTimelines = [];
	
	        for (i = 0; i < timelines.length; i++) {
	            var timeline = timelines[i];
	
	            if (timeline.isSolo == true) {
	                return [i];
	            } else if (timeline.isMute == true) continue;
	
	            availableTimelines.push(i);
	        }
	
	        return availableTimelines;
	    },
	    play: function play() {
	        var isPreview = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var isRecording = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        // isRecording is currently unused since we removed play functionality while recording (CART-1370)
	        if (_AudioToolUtils2.default.isAudioTool() && _AudioEditorUtils2.default.getTimelinesMaxPosition() == 0 && !isRecording) return;
	
	        if (!_AudioToolUtils2.default.isAudioTool() && this.isAudioEditorMode()) _VideoUtils2.default.checkVideoList();
	
	        this.isRecording = isRecording;
	        this.isPreview = isPreview;
	        this.clearAll(true);
	
	        this.slideModels = this.getSlideModels();
	        this.setStartTime(isRecording);
	
	        var timelines = this.getAudioTimelines();
	        var avaialableTimelines = this.getAvailableTimelines(timelines, isRecording);
	
	        if (!this.isPreview && this.isAudioEditorMode()) // in Player/Preview the marker shouldn't be updated
	            this.playMarker(isRecording);
	
	        for (var i = 0; i < timelines.length; i++) {
	            if (avaialableTimelines.indexOf(i) != -1) this.playTimelineSequence(timelines[i].audios, timelines[i].volume);
	        }
	
	        this.playSlidesSequence(true, -1, isRecording);
	
	        if (!isRecording) this.startVolumeTimer();
	
	        this.isPlaying = true;
	    },
	    getSlideModels: function getSlideModels() {
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            if (!this.isRecording) {
	                this.endTime = _AudioEditorUtils2.default.getTimelinesMaxPosition();
	                var markerPosition = _AudioEditorUtils2.default.getMarkerPosition();
	
	                if (markerPosition >= this.endTime || Math.abs(markerPosition - this.endTime) < 0.1) markerPosition = 0;
	
	                this.endOfProductionTimer = setTimeout(function () {
	                    this.endOfProduction();
	                }.bind(this), (this.endTime - markerPosition) * 1000);
	            }
	
	            return [];
	        }
	
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var currentSlide = state.currentSlide;
	        var i;
	        var currentTime = 0;
	        var slide;
	        var model;
	        var videoModel;
	        var models = [];
	
	        for (i = 0; i < slides.length; i++) {
	            slide = slides[i];
	            model = {};
	
	            if (i == currentSlide.currentSlideIndex) {
	                model.duration = currentSlide.model.time;
	                videoModel = _VideoUtils2.default.getSlideVideoModel(currentSlide.model);
	            } else {
	                model.duration = slide.time;
	                videoModel = _VideoUtils2.default.getSlideVideoModel(slide);
	            }
	
	            model.start = currentTime;
	
	            if (videoModel) model.videoModel = videoModel;
	
	            currentTime = currentTime + model.duration;
	
	            models.push(model);
	        }
	
	        var timelinesMaxPos = _AudioEditorUtils2.default.getTimelinesMaxPosition();
	
	        if (timelinesMaxPos > currentTime) currentTime = timelinesMaxPos;
	
	        this.endTime = currentTime;
	
	        return models;
	    },
	    playSlidesSequence: function playSlidesSequence() {
	        var startPlaying = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        var markerPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	        var isRecording = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        if (_AudioToolUtils2.default.isAudioTool()) return;
	
	        this.updateCurrentSlideProperties();
	
	        var slideModels = this.slideModels;
	
	        if (!startPlaying) slideModels = this.getSlideModels();
	
	        var i;
	        var slideModel;
	        var startIndex = -1;
	        var id;
	        var markerPosition = this.startTime;
	        var forceMute = isRecording; // while recording the video volume should be zero
	
	        if (!startPlaying) {
	            if (markerPos > -1) markerPosition = markerPos;else markerPosition = _AudioEditorUtils2.default.getMarkerPosition();
	        }
	
	        for (i = 0; i < slideModels.length; i++) {
	            slideModel = slideModels[i];
	
	            if (markerPosition >= slideModel.start && markerPosition < slideModel.start + slideModel.duration) {
	                // start slide
	                startIndex = i;
	
	                if (this.isPreview || this.isAudioEditorMode()) this.goToSlideIndex(i);
	
	                this.prepareVideo(slideModel, markerPosition, startPlaying, forceMute, i);
	
	                if (!startPlaying) // when just click on the ruler bar to change the marker position
	                    return;else {
	                    if (!this.isPreview && !this.isAudioEditorMode()) // is normal mode
	                        break;else continue;
	                }
	            }
	
	            if (startIndex > -1 && i > startIndex) {
	                //set start timer
	                id = setTimeout(function (index, model) {
	                    if (!_AudioToolUtils2.default.isAudioTool()) {
	                        _VideoUtils2.default.pauseVideoPreview(false);
	
	                        if (!_VideoUtils2.default.isVideoBackground() && _VideoUtils2.default.isVideoShapes()) _VideoUtils2.default.pauseVideoShapesPreview(false);
	                    }
	
	                    this.goToSlideIndex(index);
	                    this.prepareVideo(model, -1, startPlaying, forceMute, index);
	                }.bind(this), (slideModel.start - markerPosition) * 1000, i, slideModel);
	
	                this.startSlideTimers.push(id);
	            }
	        }
	
	        if (!isRecording) {
	            this.endOfProductionTimer = setTimeout(function () {
	                this.endOfProduction();
	            }.bind(this), (this.endTime - markerPosition) * 1000);
	        }
	    },
	    prepareVideo: function prepareVideo(slideModel, markerPosition, startPlaying) {
	        var forceMute = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	        var index = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
	
	        if (_AudioToolUtils2.default.isAudioTool()) return;
	
	        var offset = 0;
	
	        if (markerPosition > 0) offset = markerPosition - slideModel.start;
	
	        _VideoUtils2.default.prepareVideo(slideModel.videoModel, offset, startPlaying, forceMute, index);
	        _AnimationManager2.default.startAnimations(false, offset * 1000, startPlaying);
	    },
	    updateCurrentSlideProperties: function updateCurrentSlideProperties() {
	        if (_AudioToolUtils2.default.isAudioTool()) return;
	
	        var dispatch = this.getDispatch();
	        dispatch((0, _ProductionActions.updateCurrentSlide)());
	    },
	    goToSlideIndex: function goToSlideIndex(index) {
	        if (_AudioToolUtils2.default.isAudioTool()) return;
	
	        var dispatch = this.getDispatch();
	        dispatch((0, _CurrentSlideActions.setCurrentSlide)(index));
	    },
	    getTotalVolume: function getTotalVolume() {
	        if (_AudioToolUtils2.default.isAudioPlayer()) {
	            var value = _StoreManager2.default.getState().audioEditor.volume;
	
	            if (value == undefined) value = 0.5;
	
	            return value;
	        } else return 1.0;
	    },
	    playTimelineSequence: function playTimelineSequence(audioItems, timelineVolume) {
	        if (audioItems == undefined || audioItems.length < 1) return;
	
	        var i;
	        var audio;
	        var markerPosition = this.startTime;
	
	        for (i = 0; i < audioItems.length; i++) {
	            audio = audioItems[i];
	
	            var timeoutStartPosition = audio.left - markerPosition;
	            var id;
	            var audioElement = this.audios[audio.uuid];
	
	            if (!audioElement) continue;
	
	            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.changeVolume(audio.uuid, 0);else audioElement.volume = 0;
	
	            if (timeoutStartPosition >= 0) {
	                // the marker is on the left of audio item
	                if (audio.inPoint == undefined) audioElement.currentTime = 0;else audioElement.currentTime = audio.inPoint; // this should be set in seconds
	
	                //set start timer
	                id = setTimeout(function (audioItem) {
	                    var localAudio = this.audios[audioItem.uuid];
	
	                    try {
	                        if (localAudio) {
	                            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) localAudio.play(0, localAudio.currentTime);else localAudio.play();
	                        }
	                    } catch (e) {
	                        // error
	                    }
	                }.bind(this), timeoutStartPosition * 1000, audio);
	
	                this.startTimers.push(id);
	
	                //set end timer
	                id = setTimeout(function (audioItem) {
	                    var localAudio = this.audios[audioItem.uuid];
	
	                    if (localAudio) {
	                        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.refreshSource(this.audios, audioItem.uuid);else localAudio.pause();
	                    }
	                }.bind(this), (timeoutStartPosition + audio.duration) * 1000, audio);
	
	                this.endTimers.push(id);
	            } else if (audio.left + audio.duration > markerPosition) {
	                // the marker is in the middle of audio item
	                if (audio.inPoint == undefined) audioElement.currentTime = markerPosition - audio.left;else audioElement.currentTime = audio.inPoint + (markerPosition - audio.left);
	
	                if (_AudioVolumeUtils2.default.useVolumeFunctionality()) audioElement.play(0.01, audioElement.currentTime);else audioElement.play();
	
	                // set end timer
	                id = setTimeout(function (audioItem) {
	                    var localAudio = this.audios[audioItem.uuid];
	
	                    if (localAudio) {
	                        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.refreshSource(this.audios, audioItem.uuid);else localAudio.pause();
	                    }
	                }.bind(this), (audio.left + audio.duration - markerPosition) * 1000, audio);
	
	                this.endTimers.push(id);
	            }
	        }
	    },
	    pause: function pause() {
	        var updateScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this.pauseDate = new Date().getTime();
	        this.clearAll(true);
	
	        if (updateScroll) this.updateScrollPosition(300, true);
	    },
	    stop: function stop() {
	        this.clearAll();
	
	        if (!this.isPreview) {
	            var dispatch = this.getDispatch();
	            dispatch((0, _AudioEditorActions.setMarkerPosition)(0));
	        }
	
	        this.resetProperties(true);
	    },
	    clearAll: function clearAll() {
	        var isPlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var resetTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (!_AudioToolUtils2.default.isAudioTool()) {
	            _VideoUtils2.default.pauseVideoPreview(resetTime);
	
	            if (!_VideoUtils2.default.isVideoBackground() && _VideoUtils2.default.isVideoShapes()) _VideoUtils2.default.pauseVideoShapesPreview(resetTime);
	        }
	
	        if (this.isPreview && this.refreshControlBar) this.refreshControlBar();
	
	        this.pauseAllAudios();
	        this.clearTimers();
	
	        this.isPlaying = false;
	
	        if (isPlay) _AnimationManager2.default.stopAnimations(false, false);else {
	            if (_AnimationManager2.default.isAnimationMode()) _AnimationManager2.default.stopAnimationIndEditMode();else _AnimationManager2.default.stopAnimations();
	
	            _VideoUtils2.default.refreshVideosInPlayMode();
	        }
	    },
	    pauseAllAudios: function pauseAllAudios() {
	        var key;
	
	        for (key in this.audios) {
	            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.refreshSource(this.audios, key);else this.audios[key].pause();
	        }
	    },
	    clearTimers: function clearTimers() {
	        var i;
	
	        for (i = 0; i < this.startTimers.length; i++) {
	            clearTimeout(this.startTimers[i]);
	        }for (i = 0; i < this.endTimers.length; i++) {
	            clearTimeout(this.endTimers[i]);
	        }for (i = 0; i < this.startSlideTimers.length; i++) {
	            clearTimeout(this.startSlideTimers[i]);
	        }if (this.markerTimer) clearInterval(this.markerTimer);
	
	        if (this.volumeTimer) clearInterval(this.volumeTimer);
	
	        if (this.endOfProductionTimer) clearTimeout(this.endOfProductionTimer);
	
	        this.startTimers = [];
	        this.endTimers = [];
	        this.startSlideTimers = [];
	    },
	    restart: function restart() {
	        if (_AudioToolUtils2.default.isAudioTool()) return;
	
	        this.goToSlideIndex(0);
	
	        setTimeout(function () {
	            _VideoUtils2.default.goToStartPosition();
	        }.bind(this), 10);
	    },
	    endOfProduction: function endOfProduction() {
	        var startModule = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            if (this.updateRecordingMenuButtons) this.updateRecordingMenuButtons();
	
	            this.clearAll();
	            this.resetProperties(false);
	            return;
	        }
	
	        if (this.isPreview) {
	            // is PREVIEW or PLAYER mode
	            _PreviewCommands2.default.isPlaying = false;
	
	            if (this.endSequenceCallback) this.endSequenceCallback();
	
	            if (!startModule) // when open audio editor module then should keep the current slide
	                this.restart(); // should go back to the first slide
	
	            this.clearAll();
	        } else {
	            // is recording menu or Advanced mode
	            if (this.updateRecordingMenuButtons) this.updateRecordingMenuButtons();
	
	            if (this.isAudioEditorMode() && !startModule) this.clearAll(false, true);else this.clearAll();
	        }
	
	        this.resetProperties(startModule);
	    },
	    resetProperties: function resetProperties() {
	        var isStop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var forceVideoUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        this.startDate = -1;
	        this.pauseDate = -1;
	        this.startTime = -1;
	
	        this.startTimers = [];
	        this.endTimers = [];
	        this.startSlideTimers = [];
	        this.markerTimer = undefined;
	        this.volumeTimer = undefined;
	        this.endOfProductionTimer = undefined;
	
	        if (forceVideoUpdate) {
	            // exit from AudioEditor mode to normal mode
	            if (!_AudioToolUtils2.default.isAudioTool()) _VideoUtils2.default.goToStartPosition();
	
	            return;
	        }
	
	        if (!this.isPreview) {
	            if (!this.isAudioEditorMode()) {
	                if (!_AudioToolUtils2.default.isAudioTool()) _VideoUtils2.default.goToStartPosition();
	            } else {
	                if (isStop) {
	                    if (!_AudioToolUtils2.default.isAudioTool()) {
	                        this.goToSlideIndex(0);
	                        _VideoUtils2.default.goToStartPosition();
	                    }
	
	                    this.resetScrollPosition();
	                }
	            }
	        }
	    },
	    resetPropertiesForPreview: function resetPropertiesForPreview() {
	        this.clearAll();
	        this.resetProperties();
	    },
	    changeMode: function changeMode() {
	        var startModule = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this.isPreview = false;
	
	        if (this.isAudioEditorAvailable()) {
	            this.updateCurrentSlideProperties();
	            this.clearAll();
	            this.resetProperties(false, true);
	            this.endOfProduction(startModule);
	
	            var dispatch = this.getDispatch();
	            dispatch((0, _AudioEditorActions.setMarkerPosition)(0));
	        }
	
	        _VideoUtils2.default.prepareMultipleVideos(startModule);
	        _AnimationManager2.default.stopAnimations();
	    },
	    checkAudioEditorMode: function checkAudioEditorMode() {
	        if (_AudioToolUtils2.default.isAudioTool()) return;
	
	        var dispatch = this.getDispatch();
	
	        if (!this.isAudioEditorAvailable()) dispatch((0, _MenuActions.showAdvancedModeAlert)(true));else this.toggleAudioEditorMode();
	    },
	    checkAudioEditorModeWhenOpenAudioMenus: function checkAudioEditorModeWhenOpenAudioMenus() {
	        var menuType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	        // 0 - story sound, 1 - slide sound, 2 - recording sound
	        this.openAudioTab(menuType);
	
	        if (this.isAudioEditorAvailable() && !this.isAudioEditorMode()) this.toggleAudioEditorMode(true, false);
	    },
	    openAudioTab: function openAudioTab(menuType) {
	        var dispatch = this.getDispatch();
	
	        if (!this.isAudioEditorAvailable()) {
	            if (menuType == 0 || menuType == 1) dispatch((0, _MenuActions.changeAudioTabIndex)(menuType));
	        }
	
	        if (menuType == 0 || menuType == 1) dispatch((0, _MenuActions.changeClipartCategory)(2));
	
	        _VideoUtils2.default.executeAction('reset');
	    },
	    toggleAudioEditorMode: function toggleAudioEditorMode() {
	        var forceToOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var hidePopups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        var dispatch = this.getDispatch();
	
	        dispatch((0, _AccordionActions.changeAcoordionWidth)(_Properties2.default.BROWSER_WIDTH));
	
	        var value = _StoreManager2.default.getState().menu.showAudioEditor;
	
	        if (value == undefined) value = false;
	
	        this.changeMode(!value);
	
	        if (!this.isAudioEditorAvailable()) this.convertStructure();
	
	        if (forceToOpen) value = false;
	
	        if (!value) {
	            setTimeout(function () {
	                dispatch((0, _AudioEditorActions.setTimelineWidth)(_AudioEditorUtils2.default.getTimelineWidth() + _AudioEditorUtils2.default.getTimelineOffset()));
	            }.bind(this), 8);
	        }
	
	        setTimeout(function () {
	
	            if (value == true) this.closeAudioTab();
	
	            dispatch((0, _MenuActions.showAudioEditor)(!value));
	
	            _HoverManager2.default.hide();
	
	            if (value == false) {
	                // enter Advanced mode
	                this.prepareAudios();
	
	                setTimeout(function () {
	                    var newPos = _AudioEditorUtils2.default.getMarkerPositionForSlideIndex();
	                    dispatch((0, _AudioEditorActions.setMarkerPosition)(newPos));
	                    this.checkScrollPosition(newPos);
	
	                    var isSearchContext = _StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SEARCH_CONTEXT;
	
	                    if (hidePopups && !isSearchContext) dispatch((0, _MenuActions.hideMenus)(_MenuType2.default.ALL_MENUS));
	
	                    this.isAudioTabFirstTimeOpened();
	                }.bind(this), 100);
	            }
	        }.bind(this), 10);
	    },
	    isAudioTabFirstTimeOpened: function isAudioTabFirstTimeOpened(showAudioEditor) {
	        var showAudioEditor = this.isAudioEditorMode();
	
	        if (showAudioEditor && !this.isFirstTimeOpened) {
	            setTimeout(function () {
	                var dispatch = this.getDispatch();
	
	                dispatch((0, _MenuActions.expandAudioList)(true, 'main'));
	
	                this.isFirstTimeOpened = true;
	            }.bind(this), 5);
	        }
	    },
	    prepareAudioTool: function prepareAudioTool() {
	        var dispatch = this.getDispatch();
	
	        if (_AudioToolUtils2.default.isAudioPlayer()) {
	            dispatch((0, _AudioEditorActions.setMarkerPosition)(0));
	            this.updateAudioElements();
	        } else {
	            dispatch((0, _AudioEditorActions.setMarkerPosition)(0));
	
	            dispatch((0, _AudioEditorActions.setTimelineWidth)(_AudioEditorUtils2.default.getTimelineWidth() + _AudioEditorUtils2.default.getTimelineOffset()));
	            this.prepareAudios();
	
	            dispatch((0, _MenuActions.expandAudioList)(true, 'main'));
	            dispatch((0, _MenuActions.changeClipartCategory)(2));
	
	            if (!_PlatformDetection2.default.isIOS()) dispatch((0, _MusicActions.changeMainAudioCategoryIndex)(0));
	
	            setTimeout(function () {
	                _AudioEditorUtils2.default.addActionToHistory(); // add first state to UNDO history
	            }.bind(this), 50);
	        }
	    },
	    closeAudioEditorMode: function closeAudioEditorMode() {
	        if (this.isAudioEditorAvailable()) {
	            var dispatch = this.getDispatch();
	            dispatch((0, _MenuActions.showAudioEditor)(false));
	            this.closeAudioTab();
	        }
	    },
	    closeAudioTab: function closeAudioTab() {
	        var dispatch = this.getDispatch();
	        dispatch((0, _MenuActions.changeClipartCategory)(0));
	    },
	    convertStructure: function convertStructure() {
	        this.updateCurrentSlideProperties();
	
	        setTimeout(function () {
	            var dispatch = this.getDispatch();
	            var data = _AudioConverter2.default.convert(_StoreManager2.default.getState().production.slides, _StoreManager2.default.getState().production.storySound);
	
	            if (_Configuration2.default.LOAD_LOCAL) data = this.getEmptyTimelines();
	
	            dispatch((0, _AudioEditorActions.initTimelines)(data));
	        }.bind(this), 4);
	    },
	    getEmptyTimelines: function getEmptyTimelines() {
	        var timelines = [];
	
	        // timelines.push({index: 0, volume: 1.0, audios: [{points: [{time:0, vol:1}, {time:1, vol:0.5}, {time:2, vol:0.8}, {time:4, vol:0.2}], uuid: uuid.v4(), title:'Song 1', href: 'https://d3b76ijxom7qfl.cloudfront.net/movieaudioeditor/1837740.mp3', left: 0, duration: 4.0, inPoint: 1.5238095238095237}]});
	        timelines.push({ index: 0, volume: 1.0, audios: [] });
	        timelines.push({ index: 1, volume: 1.0, audios: [] });
	        timelines.push({ index: 2, volume: 1.0, audios: [] });
	
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            timelines.push({ index: 3, volume: 1.0, audios: [] });
	            timelines.push({ index: 4, volume: 1.0, audios: [] });
	
	            if (_PlatformDetection2.default.isIOS() && !_PlatformDetection2.default.isIOSApp()) {// is IOS browser but not the app
	                // not include the last timeline
	            } else {
	                if (window.innerHeight >= 610) timelines.push({ index: 5, volume: 1.0, audios: [] });
	            }
	        }
	
	        return { timelines: timelines };
	    },
	    executeAction: function executeAction(action) {
	        switch (action) {
	            case 'play':
	                {
	                    if (this.executePlayPause) this.executePlayPause();
	                    break;
	                }
	
	            case 'stop':
	                {
	                    if (this.executeStop) this.executeStop();
	                    break;
	                }
	
	            case 'left':
	                {
	                    this.changeSelection();
	                    break;
	                }
	
	            case 'right':
	                {
	                    this.changeSelection(false);
	                    break;
	                }
	        }
	    },
	    changeSelection: function changeSelection() {
	        var isLeft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        var timelines = _StoreManager2.default.getState().audioEditor.timelines;
	        var i;
	
	        for (i = 0; i < timelines.length; i++) {
	            if (timelines[i].isSelected && timelines[i].audios.length > 1) {
	                var audios = timelines[i].audios;
	                var j;
	                var position = [];
	                var map = [];
	                var currentTarget = -1;
	
	                for (j = 0; j < audios.length; j++) {
	                    position.push(audios[j].left);
	                    map[audios[j].left] = audios[j].uuid;
	
	                    if (audios[j].showControlPoint) currentTarget = audios[j].left;
	                }
	
	                position.sort(function (a, b) {
	                    return a - b;
	                });
	
	                if (currentTarget != -1) {
	                    var index = position.indexOf(currentTarget);
	
	                    if (isLeft) index = index - 1;else index = index + 1;
	
	                    if (index >= 0 && index < audios.length) {
	                        var newUuid = map[position[index]];
	                        var dispatch = this.getDispatch();
	
	                        if (newUuid) dispatch((0, _AudioEditorActions.selectElement)(newUuid, true));
	                    }
	                }
	            }
	        }
	    },
	
	
	    // VOLUME functionality
	    getStartVolumeForItem: function getStartVolumeForItem(item) {
	        if (item.points && item.points[0]) return item.points[0].vol;else return 1;
	    },
	    startVolumeTimer: function startVolumeTimer() {
	        this.volumeTimer = setInterval(this.checkVolume.bind(this), this.VOLUME_STEP);
	    },
	    checkVolume: function checkVolume() {
	        var offset = (new Date().getTime() - this.startDate) / 1000;
	        var newPos = this.startTime + offset;
	
	        if (this.startTime == -1) {
	            this.clearTimers();
	
	            return;
	        }
	
	        this.setCorrectVolumeForPosition(newPos);
	    },
	    setCorrectVolumeForPosition: function setCorrectVolumeForPosition(position) {
	        var timelines = this.getAudioTimelines();
	        var i;
	
	        for (i = 0; i < timelines.length; i++) {
	            var audios = timelines[i].audios;
	            var j;
	            var timelineVolume = timelines[i].volume * this.getTotalVolume();
	
	            if (!(timelineVolume >= 0 && timelineVolume <= 1)) timelineVolume = 1;
	
	            for (j = 0; j < audios.length; j++) {
	                if (audios[j].left <= position && position <= audios[j].left + audios[j].duration) this.setVolumeForAudio(audios[j], position, timelineVolume);
	            }
	        }
	    },
	    setVolumeForAudio: function setVolumeForAudio(audio, position, timelineVolume) {
	        if (!this.audios) return;
	
	        var audioElement = this.audios[audio.uuid];
	
	        if (!audioElement) return;
	
	        var volume = 1;
	        var i;
	        var localPosition = position - audio.left;
	
	        if (audio.points) {
	            for (i = 0; i < audio.points.length; i++) {
	                if (audio.points[i].time == localPosition) {
	                    volume = audio.points[i].vol;
	                    break;
	                }
	
	                if (audio.points[i].time > localPosition && i > 0) {
	                    volume = _AudioEditorUtils2.default.getIntersectionPoint(audio.points[i - 1].time, audio.points[i - 1].vol, audio.points[i].time, audio.points[i].vol, localPosition);
	
	                    if (!(volume >= 0 && volume <= 1)) volume = 1;
	
	                    break;
	                }
	            }
	        }
	
	        volume = volume * timelineVolume;
	        var finalVolume = this.applyFadeOut(volume, position);
	
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.changeVolume(audio.uuid, finalVolume);else audioElement.volume = finalVolume;
	    },
	    applyFadeOut: function applyFadeOut(volume, position) {
	        return volume;
	
	        if (!this.isPreview) // fade out functionality should be available only for PREVIEW or PLAYER mode.
	            return volume;
	
	        var endTime = this.endTime;
	        var fadeDuration = this.FADE_LIMIT / 1000;
	        var remainingTime = endTime - position;
	
	        if (remainingTime > fadeDuration) return volume;
	
	        var fadePercent = remainingTime / fadeDuration;
	
	        return volume * fadePercent;
	    }
	};
	
	exports.default = playController;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/PlayController.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/PlayController.js"); } } })();

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var audioToolUtils = {
	    totalTime: -1,
	    trackWidth: -1,
	    audioPlayerKeyboardShortcutAction: undefined,
	
	    isAudioTool: function isAudioTool() {
	        if (_AppParameters2.default.context == _ModeConstants2.default.AUDIO_TOOL || _AppParameters2.default.context == _ModeConstants2.default.AUDIO_TOOL_PLAYER) return true;else return false;
	    },
	    isAudioEditorTool: function isAudioEditorTool() {
	        if (_AppParameters2.default.context == _ModeConstants2.default.AUDIO_TOOL) return true;else return false;
	    },
	    isAudioPlayer: function isAudioPlayer() {
	        if (_AppParameters2.default.context == _ModeConstants2.default.AUDIO_TOOL_PLAYER) return true;else return false;
	    },
	    getTimelineComponentTopOffset: function getTimelineComponentTopOffset() {
	        var listHeight = _Properties2.default.SLIDE_VIEWER_TOP_GAP * 5;
	        var normalSlideViewerHeight = _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT + listHeight + _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP;
	
	        return normalSlideViewerHeight + _Properties2.default.SLIDE_VIEWER_TOP_GAP;
	    },
	    buttonsHolderWidth: function buttonsHolderWidth() {
	        if (this.isAudioTool()) {
	            var value = _StoreManager2.default.getState().menu.buttonsHolderWidth;
	
	            if (value >= 0) return value;else {
	                if (_PlatformDetection2.default.isIOS()) return _Properties2.default.BUTTONS_HOLDER_COLLAPSED_WIDTH;else return _Properties2.default.BUTTONS_HOLDER_WIDTH;
	            }
	        } else return _Properties2.default.BUTTONS_HOLDER_WIDTH;
	    },
	    isLeftSideCollapsed: function isLeftSideCollapsed() {
	        var state = _StoreManager2.default.getState();
	        var buttonsHolderWidth = state.menu.buttonsHolderWidth;
	
	        if (!(buttonsHolderWidth > 0) && _PlatformDetection2.default.isIOS() && this.isAudioTool()) return true;
	
	        if (buttonsHolderWidth == _Properties2.default.BUTTONS_HOLDER_COLLAPSED_WIDTH) return true;else return false;
	    },
	    headerHeight: function headerHeight() {
	        if (_PlatformDetection2.default.isIOSApp()) return _Properties2.default.HEADER_HEIGHT_APP;else return _Properties2.default.HEADER_HEIGHT;
	    },
	    timelineHeight: function timelineHeight() {
	        if (this.isAudioTool()) return _Properties2.default.AUDIO_TIMELINE_BIG_HEIGHT;else return _Properties2.default.AUDIO_TIMELINE_HEIGHT;
	    },
	    checkTotalTime: function checkTotalTime(trackWidth) {
	        if (this.totalTime < 0) this.totalTime = _AudioEditorUtils2.default.getTimelinesMaxPosition();
	
	        if (this.trackWidth < 0) this.trackWidth = trackWidth;
	    },
	    getCurrentTime: function getCurrentTime(markerPosition) {
	        var addMilliseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        if (markerPosition > 0) {
	            var text = '';
	
	            var totalSeconds = parseInt(markerPosition);
	            var minutes = Math.floor(totalSeconds / 60);
	            var seconds = totalSeconds - minutes * 60;
	            var miliseconds = markerPosition - totalSeconds;
	            var endValue = addMilliseconds ? ':' : '';
	
	            miliseconds = Math.floor(miliseconds * 100);
	
	            if (minutes < 10) text = text + '0' + minutes + ':';else text = text + minutes + ':';
	
	            if (seconds < 10) text = text + '0' + seconds + endValue;else text = text + seconds + endValue;
	
	            if (addMilliseconds) {
	                if (miliseconds < 10) text = text + '0' + miliseconds;else text = text + miliseconds;
	            }
	
	            return text;
	        } else {
	            if (addMilliseconds) return '00:00:00';else return '00:00';
	        }
	    },
	    getTotalTime: function getTotalTime() {
	        return this.getCurrentTime(this.totalTime);
	    },
	    getMarkerPosition: function getMarkerPosition(markerPosition) {
	        return this.trackWidth * markerPosition / this.totalTime;
	    },
	    getMarkerTime: function getMarkerTime(markerPosition) {
	        return this.totalTime * markerPosition / this.trackWidth;
	    },
	    getGraphControlPointSize: function getGraphControlPointSize() {
	        if (_PlatformDetection2.default.isIOS()) return _Properties2.default.AUDIO_CONTROL_POINT_SIZE_IOS;else return _Properties2.default.AUDIO_CONTROL_POINT_SIZE;
	    },
	    getGraphControlLineSize: function getGraphControlLineSize() {
	        if (_PlatformDetection2.default.isIOS()) return _Properties2.default.LINE_HOLDER_HEIGHT_IOS;else return _Properties2.default.LINE_HOLDER_HEIGHT;
	    }
	};
	
	exports.default = audioToolUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioTool/utils/AudioToolUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioTool/utils/AudioToolUtils.js"); } } })();

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MenuActions = __webpack_require__(7);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioVolumeUtils = __webpack_require__(67);
	
	var _AudioVolumeUtils2 = _interopRequireDefault(_AudioVolumeUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var videoUtils = {
	    dispatch: undefined,
	    changeVideoBackground: false,
	    loadedVideo: undefined,
	    cacheBreaker: '?cacheBreaker=' + Math.random(),
	
	    checkCacheBreaker: function checkCacheBreaker(url) {
	        var isVideo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (isVideo) return url;
	
	        if (url && url.indexOf('file/ci') != -1 && url.indexOf('/aaa') != -1 && url.indexOf('/aaa?') == -1) return url + this.cacheBreaker;else return url;
	    },
	    init: function init(dispatch) {
	        this.dispatch = dispatch;
	
	        var video = document.getElementById('videoBackground');
	
	        if (!video) return;
	
	        video.ondurationchange = this.onVideoLoaded.bind(this);
	
	        var state = _StoreManager2.default.getState();
	        var background = state.currentSlide.model.content[0];
	
	        if (background && background.isVideo) this.updateVideoSrc(background);
	    },
	    onVideoLoaded: function onVideoLoaded() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        this.updateVideoPreloader(false);
	
	        if (!this.changeVideoBackground) return;
	
	        var video = document.getElementById('videoBackground');
	        var duration = video.duration;
	
	        if (duration > 0) {
	            this.dispatch((0, _CurrentSlideActions.changeSlideDuration)(duration));
	            this.changeToVideoEditorMode(video.currentSrc);
	            _HoverManager2.default.hide();
	        }
	
	        this.changeVideoBackground = false;
	
	        if (this.executeAutoPlay && this.executeAction) setTimeout(this.autoPlayVideo.bind(this), 100);
	
	        this.refreshVideoEditor();
	
	        this.executeAutoPlay = false;
	        this.loadedVideo = video.src;
	    },
	    changeToVideoEditorMode: function changeToVideoEditorMode(currentSrc) {
	        this.prepareMultipleVideos(false);
	        this.dispatch((0, _MenuActions.showVideoEditor)(true));
	
	        if (currentSrc && currentSrc.indexOf('file/ci') != -1) return;
	
	        this.dispatch((0, _MenuActions.changeClipartCategory)(1));
	    },
	    autoPlayVideo: function autoPlayVideo() {
	        if (this.executeAction) this.executeAction('play');
	
	        if (this.updateMarkerVisbility) this.updateMarkerVisbility(true);
	    },
	    updateVideoSrc: function updateVideoSrc(shapeModel) {
	        if (this.isMultipleVideo()) this.updateCurrentVideo();
	
	        var video = document.getElementById('videoBackground');
	
	        if (!video) return;
	
	        if (!shapeModel || !shapeModel.xlinkHref) {
	            video.src = undefined;
	            return;
	        }
	
	        var videoUrl = '';
	        var hostName = '';
	
	        if (!_Configuration2.default.LOAD_LOCAL && shapeModel.xlinkHref.indexOf('http') == -1) {
	            if (_Configuration2.default.IS_PROD()) hostName = 'https://www.creaza.com';else hostName = 'https://stage.creaza.com';
	        }
	
	        if (shapeModel.isVideo) videoUrl = hostName + shapeModel.xlinkHref;
	
	        videoUrl = this.getCorrectUrl(videoUrl);
	
	        if (video.src != videoUrl) {
	            if (videoUrl.length > 0) {
	                this.updateVideoPreloader(true);
	                video.src = this.checkCacheBreaker(videoUrl, true);
	
	                if (!_PlatformDetection2.default.isEdge()) video.load();
	
	                if (!this.showVideoEditor()) {
	                    this.updateStartPoint();
	
	                    setTimeout(function () {
	                        if (this.executeAction) this.executeAction('focus');
	                    }.bind(this), 1000);
	                } else {
	                    if (this.executeAction) this.executeAction('clear');
	                }
	            } else video.src = "";
	        }
	    },
	    refreshVideoEditor: function refreshVideoEditor() {
	        if (this.showVideoEditor()) {
	            this.isEditorInitialized = false;
	            this.markerPosition = -1;
	
	            this.dispatch((0, _MenuActions.refreshVideoEditor)(Math.random()));
	
	            var marker = document.getElementById('marker');
	
	            if (marker) marker.style.left = '0px';
	
	            this.updateStartPoint();
	        }
	    },
	    updateVideoPreloader: function updateVideoPreloader() {
	        var isVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var preloader = document.getElementById('videoPreloader');
	
	        if (!preloader || _PlayController2.default.isAudioEditorMode()) return;
	
	        if (isVisible) preloader.style.display = 'block';else preloader.style.display = 'none';
	    },
	    getBackgroundVideoVolume: function getBackgroundVideoVolume() {
	        var state = _StoreManager2.default.getState();
	        var background = state.currentSlide.model.content[0];
	
	        if (background && background.isVideo && background.volume >= 0) return background.volume;else return 0.5;
	    },
	    playVideoPreview: function playVideoPreview() {
	        var playOffset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	        this.clearTimer();
	
	        var video = document.getElementById('videoBackground');
	        var audio = document.getElementById('recordedAudio');
	
	        if (_PlatformDetection2.default.isIOS()) _AudioVolumeUtils2.default.changeVolume('videoBackground', this.getVolume());else video.volume = this.getVolume();
	
	        if (playOffset == 0) video.currentTime = this.getStartPoint();
	
	        if (audio && audio.duration > video.currentTime) audio.currentTime = video.currentTime;
	
	        this.playTimer = setTimeout(this.onPreviewVideoEnded.bind(this), this.getCurrentSlideDuration() * 1000 - playOffset);
	
	        video.play();
	
	        this.playPauseVideoShapes(true, playOffset === 0);
	    },
	    getCurrentSlideDuration: function getCurrentSlideDuration() {
	        var state = _StoreManager2.default.getState();
	        var time = state.currentSlide.model.time;
	
	        return time;
	    },
	    onPreviewVideoEnded: function onPreviewVideoEnded() {
	        if (this.isEditorInitialized) return;
	
	        if (this.updatePlayButtonHandler) this.updatePlayButtonHandler(false, true);
	
	        this.pauseVideoPreview(true);
	    },
	    pauseVideoPreview: function pauseVideoPreview() {
	        var resetTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this.clearTimer();
	
	        var video = this.getCurrentVideo();
	
	        if (!video) return;
	
	        video.pause();
	
	        if (resetTime) video.currentTime = 0;
	
	        this.playPauseVideoShapes(false, resetTime);
	    },
	    getPlayOffset: function getPlayOffset() {
	        var video = this.getCurrentVideo();
	
	        if (!video) return 0;
	
	        var startPoint = this.getStartPoint();
	
	        if (video.currentTime > startPoint) return (video.currentTime - startPoint) * 1000;else return 0;
	    },
	
	
	    /****************** Video shapes functionality **********************************************/
	    isVideoShapes: function isVideoShapes() {
	        return videoUtils.getMaxDurationFromVideoShapes() > 0;
	    },
	    playPauseVideoShapes: function playPauseVideoShapes(play) {
	        var resetTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	        if (videoUtils.isVideoShapes()) {
	            var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	
	            for (var i = 1; i < shapes.length; ++i) {
	                if (shapes[i].type === _ShapeConstants2.default.VIDEO) {
	                    var videoShape = document.getElementById('videoShape_' + shapes[i].uuid);
	
	                    if (videoShape) {
	                        if (play) {
	                            videoShape.play();
	
	                            if (resetTime) videoShape.currentTime = 0;else {
	                                if (offset > 0) videoShape.currentTime = offset;
	                            }
	                        } else {
	                            videoShape.pause();
	
	                            if (resetTime) videoShape.currentTime = 0;else {
	                                if (offset > 0) videoShape.currentTime = offset;
	                            }
	                        }
	
	                        this.dispatch((0, _CurrentSlideActions.updateVideoShape)(shapes[i].uuid));
	                    }
	                }
	            }
	        }
	    },
	    playVideoShapesPreview: function playVideoShapesPreview() {
	        var resetTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this.clearTimer();
	
	        var mainVideo = this.getMainVideoShape();
	
	        if (!mainVideo) return;
	
	        var audio = document.getElementById('recordedAudio');
	
	        if (audio && audio.duration > mainVideo.currentTime) audio.currentTime = mainVideo.currentTime;
	
	        var playOffset = resetTime ? 0 : mainVideo.currentTime * 1000;
	
	        this.playTimer = setTimeout(this.onPreviewVideoShapeEnded.bind(this), this.getCurrentSlideDuration() * 1000 - playOffset);
	
	        this.playPauseVideoShapes(true, resetTime);
	    },
	    onPreviewVideoShapeEnded: function onPreviewVideoShapeEnded() {
	        if (this.isEditorInitialized) return;
	
	        if (this.updatePlayButtonHandler) this.updatePlayButtonHandler(false, true);
	
	        this.pauseVideoShapesPreview(true);
	    },
	    pauseVideoShapesPreview: function pauseVideoShapesPreview() {
	        var resetTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this.clearTimer();
	
	        this.playPauseVideoShapes(false, resetTime);
	    },
	    getMainVideoShape: function getMainVideoShape() {
	        var mainVideoShape = this.getMaxDurationFromVideoShapes(true);
	
	        if (mainVideoShape) {
	            var video = document.getElementById('videoShape_' + mainVideoShape.uuid);
	
	            return video;
	        } else return undefined;
	    },
	    getMaxDurationFromVideoShapes: function getMaxDurationFromVideoShapes() {
	        var getMaxDurationVideoShape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var maxDuration = 0;
	        var videoShape = void 0;
	
	        for (var i = 1; i < shapes.length; ++i) {
	            if (shapes[i].type === _ShapeConstants2.default.VIDEO && shapes[i].duration > 0) {
	                if (shapes[i].duration > maxDuration) {
	                    maxDuration = shapes[i].duration;
	                    videoShape = shapes[i];
	                }
	            }
	        }
	
	        if (getMaxDurationVideoShape) return videoShape;else return maxDuration;
	    },
	    checkSlideDurationWhenAddVideoShape: function checkSlideDurationWhenAddVideoShape(duration) {
	        // the order for deciding the slide duration for a slide is: video, shape video with the long duration, recorded sound and media/effect sound
	        if (this.isVideoBackground()) return;
	
	        var maxDurationFromVideos = this.getMaxDurationFromVideoShapes();
	
	        if (duration > maxDurationFromVideos) this.dispatch((0, _CurrentSlideActions.changeSlideDuration)(duration));
	    },
	
	    /****************** EDITOR functionality ***************/
	    currentVideoVolume: 0,
	    currentTotalDuration: -1,
	    initialVideoVolume: -1,
	    initialLeftMarkerPosition: -1,
	    initialRightMarkerPosition: -1,
	    leftMarkerPosition: -1,
	    rightMarkerPosition: -1,
	    markerPosition: -1,
	    trackWidth: -1,
	    isEditorInitialized: false,
	    playTimer: undefined,
	    videoEndedCallback: undefined,
	    browserActiveButton: 0,
	    updatePlayButtonHandler: undefined,
	    playRegular: undefined,
	    markerUpdateHandler: undefined,
	    updateMarkerVisbility: undefined,
	    executeAction: undefined,
	    executeAutoPlay: false,
	    currentSlideModel: undefined,
	
	    updateContentFromCurrentSlide: function updateContentFromCurrentSlide() {
	        this.currentSlideModel = _StoreManager2.default.getState().currentSlide.model;
	    },
	    getInitialProperties: function getInitialProperties(trackWidth) {
	        if (this.isEditorInitialized && trackWidth == this.trackWidth) return;
	
	        var state = _StoreManager2.default.getState();
	        var background = state.currentSlide.model.content[0];
	
	        if (background && background.isVideo) {
	            if (this.isEditorInitialized && trackWidth > 0 && this.trackWidth > 0 && trackWidth != this.trackWidth) {
	                this.leftMarkerPosition = this.leftMarkerPosition * trackWidth / this.trackWidth;
	                this.rightMarkerPosition = this.rightMarkerPosition * trackWidth / this.trackWidth;
	                this.markerPosition = this.markerPosition * trackWidth / this.trackWidth;
	
	                this.initialLeftMarkerPosition = this.leftMarkerPosition;
	                this.initialRightMarkerPosition = this.rightMarkerPosition;
	
	                this.trackWidth = trackWidth;
	            } else {
	                this.trackWidth = trackWidth;
	                this.currentTotalDuration = this.getVideoTotalDuration();
	                this.currentVideoVolume = this.getBackgroundVideoVolume();
	                this.initialVideoVolume = this.currentVideoVolume;
	
	                if (background.inPoint >= 0) this.leftMarkerPosition = this.trackWidth * background.inPoint / this.currentTotalDuration;else this.leftMarkerPosition = 0;
	
	                this.initialLeftMarkerPosition = this.leftMarkerPosition;
	
	                if (background.outPoint >= 0) this.rightMarkerPosition = this.trackWidth * background.outPoint / this.currentTotalDuration;else this.rightMarkerPosition = this.trackWidth;
	
	                this.initialRightMarkerPosition = this.rightMarkerPosition;
	                this.markerPosition = this.leftMarkerPosition;
	            }
	        }
	
	        this.isEditorInitialized = true;
	
	        this.pauseVideoPreview();
	
	        if (!this.isVideoBackground() && this.isVideoShapes()) this.pauseVideoShapesPreview();
	
	        setTimeout(this.checkStartPoint.bind(this), 2);
	    },
	    checkStartPoint: function checkStartPoint() {
	        this.updateStartPoint();
	    },
	    resetCurrentProperties: function resetCurrentProperties() {
	        var updateStartPoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        this.clearTimer();
	        this.pauseBackgroundVideo();
	        this.currentVideoVolume = 0.5;
	        this.isEditorInitialized = false;
	        this.markerPosition = -1;
	        this.initialLeftMarkerPosition = -1;
	        this.initialRightMarkerPosition = -1;
	        this.leftMarkerPosition = -1;
	        this.rightMarkerPosition = -1;
	
	        if (updateStartPoint) setTimeout(this.updateStartPoint.bind(this), 500);
	    },
	    updateNewVideoProperties: function updateNewVideoProperties() {
	        var slideModelDuration = this.getCurrentSlideDuration();
	        var inPoint = this.getRealTimeInSeconds(this.leftMarkerPosition);
	        var outPoint = this.getRealTimeInSeconds(this.rightMarkerPosition);
	        var slideDuration = outPoint - inPoint;
	
	        if (this.currentVideoVolume != this.initialVideoVolume || this.leftMarkerPosition != this.initialLeftMarkerPosition || this.rightMarkerPosition != this.initialRightMarkerPosition || slideModelDuration != slideDuration) {
	            _SaveManager2.default.isContentChanged(true);
	
	            var videoProps = {};
	
	            videoProps.volume = this.currentVideoVolume;
	            videoProps.inPoint = inPoint;
	            videoProps.outPoint = outPoint;
	
	            this.dispatch((0, _CurrentSlideActions.changeVideoProperties)('all', videoProps));
	            this.dispatch((0, _CurrentSlideActions.changeSlideDuration)(outPoint - inPoint));
	        }
	    },
	    getVideoTotalDuration: function getVideoTotalDuration() {
	        var video = document.getElementById('videoBackground');
	
	        return video.duration.toFixed(3);
	    },
	    getEditVideoDuration: function getEditVideoDuration() {
	        var video = document.getElementById('videoBackground');
	        var currentTime = this.rightMarkerPosition - this.leftMarkerPosition;
	        var time;
	
	        if (currentTime > 0) time = this.currentTotalDuration * currentTime / this.trackWidth;else time = video.duration;
	
	        time = parseFloat(time.toFixed(2));
	
	        return this.convertTimeToStringFormat(time);
	    },
	    convertTimeToStringFormat: function convertTimeToStringFormat(time) {
	        time = parseFloat(time.toFixed(2));
	
	        var text = '';
	        var seconds = Math.floor(time);
	        var miliseconds = Math.floor((time - seconds) * 100);
	        var minutes = Math.floor(seconds / 60);
	        seconds = seconds - minutes * 60;
	
	        if (minutes < 10) text = text + '0' + minutes + ':';else text = text + minutes + ':';
	
	        if (seconds < 10) text = text + '0' + seconds + ':';else text = text + seconds + ':';
	
	        if (miliseconds < 10) text = text + '0' + miliseconds;else text = text + miliseconds;
	
	        return text;
	    },
	    getTimeInSeconds: function getTimeInSeconds(position) {
	        var time = position * this.currentTotalDuration / this.trackWidth;
	        return parseFloat(time.toFixed(1));
	    },
	    getRealTimeInSeconds: function getRealTimeInSeconds(position) {
	        var time = position * this.currentTotalDuration / this.trackWidth;
	        var fixedTime = parseFloat(time.toFixed(3));
	
	        if (fixedTime >= 0) return fixedTime;else return 0;
	    },
	    trackOffset: function trackOffset() {
	        return this.trackWidth / this.currentTotalDuration;
	    },
	    playBackgroundVideo: function playBackgroundVideo() {
	        this.clearTimer();
	
	        var video = document.getElementById('videoBackground');
	
	        if (_PlatformDetection2.default.isIOS()) _AudioVolumeUtils2.default.changeVolume('videoBackground', this.getVolume());else video.volume = this.getVolume();
	
	        video.currentTime = this.getCurrentPoint();
	
	        var duration = this.getOutPoint() - this.getCurrentPoint();
	        this.playTimer = setTimeout(this.onVideoEnded.bind(this), duration * 1000);
	
	        video.play();
	
	        if (this.markerUpdateHandler) this.markerUpdateHandler();
	    },
	    pauseBackgroundVideo: function pauseBackgroundVideo() {
	        var isEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this.clearTimer();
	
	        var video = document.getElementById('videoBackground');
	        video.pause();
	
	        if (this.markerUpdateHandler) this.markerUpdateHandler(false, isEnd);
	    },
	    onVideoEnded: function onVideoEnded() {
	        if (!this.isEditorInitialized) return;
	
	        if (this.videoEndedCallback) this.videoEndedCallback();
	
	        this.markerPosition = this.leftMarkerPosition;
	        this.pauseBackgroundVideo(true);
	
	        if (this.isEditorInitialized) {
	            var video = document.getElementById('videoBackground');
	            this.updateStartPoint();
	        }
	    },
	    clearTimer: function clearTimer() {
	        if (this.playTimer) clearTimeout(this.playTimer);
	    },
	    getVolume: function getVolume() {
	        var volume;
	
	        if (this.isEditorInitialized) volume = this.currentVideoVolume;else volume = this.getBackgroundVideoVolume();
	
	        if (volume >= 0 && volume <= 1) return volume;else return 0.5;
	    },
	    getStartPoint: function getStartPoint() {
	        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
	        var start;
	        var state = _StoreManager2.default.getState();
	        var background;
	
	        if (index == -1) background = state.currentSlide.model.content[0];else background = state.production.slides[index].content[0];
	
	        if (this.isEditorInitialized) start = this.getRealTimeInSeconds(this.leftMarkerPosition);else start = background.inPoint;
	
	        if (!start) start = 0;
	
	        return parseFloat(start);
	    },
	    getCurrentPoint: function getCurrentPoint() {
	        var currentPoint;
	
	        if (this.markerPosition >= this.leftMarkerPosition && this.markerPosition <= this.rightMarkerPosition) currentPoint = this.getRealTimeInSeconds(this.markerPosition);else currentPoint = this.getStartPoint();
	
	        if (!currentPoint || isNaN(currentPoint)) return 0;else return currentPoint;
	    },
	    getOutPoint: function getOutPoint() {
	        var end;
	        var state = _StoreManager2.default.getState();
	        var background = state.currentSlide.model.content[0];
	
	        if (this.isEditorInitialized) end = this.getRealTimeInSeconds(this.rightMarkerPosition);else end = background.outPoint;
	
	        if (!end) end = 0;
	
	        return parseFloat(end);
	    },
	    updateStartPoint: function updateStartPoint() {
	        var isOutPoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var stop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var video = document.getElementById('videoBackground');
	
	        if (video) {
	            if (isOutPoint) video.currentTime = this.getOutPoint();else {
	                if (stop) video.pause();
	
	                video.currentTime = this.getStartPoint();
	            }
	        }
	
	        if (this.updateMarkerVisbility) this.updateMarkerVisbility();
	    },
	    isVideoBackground: function isVideoBackground(slideModel) {
	        var state = _StoreManager2.default.getState();
	
	        if (!slideModel) slideModel = state.currentSlide.model;
	
	        if (!slideModel || !slideModel.content) return false;
	
	        var background = slideModel.content[0];
	
	        if (background && background.isVideo) return true;else return false;
	    },
	
	
	    /********************************* MARKER functionality ************************/
	    updateMarkerPosition: function updateMarkerPosition(position) {
	        if (position < this.leftMarkerPosition) position = this.leftMarkerPosition;
	
	        if (position > this.rightMarkerPosition) position = this.rightMarkerPosition;
	
	        this.markerPosition = position;
	
	        var video = document.getElementById('videoBackground');
	        video.currentTime = this.getRealTimeInSeconds(this.markerPosition);
	    },
	    getMarkerPosition: function getMarkerPosition() {
	        if (this.markerPosition < this.leftMarkerPosition) return this.leftMarkerPosition;
	
	        if (this.markerPosition > this.rightMarkerPosition) return this.rightMarkerPosition;
	
	        return this.markerPosition;
	    },
	    showVideoEditor: function showVideoEditor() {
	        var state = _StoreManager2.default.getState();
	
	        if (state.menu.showVideoEditor) return true;else return false;
	    },
	    splitClip: function splitClip() {
	        this.currentSlideModel = undefined;
	
	        var inPoint = this.getRealTimeInSeconds(this.leftMarkerPosition);
	        var outPoint = this.getRealTimeInSeconds(this.rightMarkerPosition);
	        var markerPoint = this.getCurrentPoint();
	        var firstSlideDuration = markerPoint - inPoint;
	        var secondSlideDuration = outPoint - markerPoint;
	
	        if (firstSlideDuration > 1.0 && secondSlideDuration > 1.0) {
	            _SaveManager2.default.isContentChanged(true);
	
	            this.addNewSlide(markerPoint, outPoint);
	
	            var videoProps = {};
	
	            videoProps.volume = this.currentVideoVolume;
	            videoProps.inPoint = inPoint;
	            videoProps.outPoint = markerPoint;
	
	            this.dispatch((0, _CurrentSlideActions.changeVideoProperties)('all', videoProps));
	            this.dispatch((0, _CurrentSlideActions.changeSlideDuration)(firstSlideDuration));
	
	            this.dispatch((0, _ProductionActions.updateCurrentSlide)());
	
	            if (this.executeAction) this.executeAction('reset');
	        }
	    },
	    addNewSlide: function addNewSlide(inPoint, outPoint) {
	        var state = _StoreManager2.default.getState();
	        var background = state.currentSlide.model.content[0];
	
	        var newContent = {};
	        newContent.logicalName = background.logicalName;
	        newContent.href = background.xlinkHref;
	        newContent.moods = [];
	        newContent.hotSpot = '';
	        newContent.frameLabel = '';
	
	        newContent.isVideo = true;
	        newContent.volume = this.currentVideoVolume;
	        newContent.inPoint = inPoint;
	        newContent.outPoint = outPoint;
	
	        if (background.contentItemId > 0) newContent.contentItemId = background.contentItemId;
	
	        var currentIndex = state.currentSlide.currentSlideIndex;
	        this.dispatch((0, _ProductionActions.addSplittedSlide)(currentIndex + 1, newContent));
	
	        _AudioEditorUtils2.default.addActionToHistory();
	        _SaveManager2.default.isContentChanged(true);
	    },
	    getBackgroundVideo: function getBackgroundVideo() {
	        var state = _StoreManager2.default.getState();
	        var background = state.currentSlide.model.content[0];
	
	        if (background && background.isVideo && background.xlinkHref) return background.xlinkHref;else return '';
	    },
	
	
	    refreshItemRenderer: undefined,
	
	    /******************* Player controller ***************************/
	    getCurrentVideo: function getCurrentVideo() {
	        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
	        var video;
	
	        if (this.isMultipleVideo()) {
	            if (index == -1) index = _StoreManager2.default.getState().currentSlide.currentSlideIndex;
	
	            video = document.getElementById('video_' + index);
	        } else video = document.getElementById('videoBackground');
	
	        return video;
	    },
	    getHostName: function getHostName() {
	        if (_Configuration2.default.IS_PROD()) return 'https://www.creaza.com';else return 'https://stage.creaza.com';
	    },
	    getCorrectUrl: function getCorrectUrl(url) {
	        var newUrl = '';
	
	        if (url && url.indexOf('file/ci') != -1) {
	            if (url.indexOf('www.creaza') == -1 && url.indexOf('stage.creaza') == -1) newUrl = this.getHostName();
	
	            newUrl = newUrl + url;
	        } else {
	            newUrl = url;
	        }
	
	        return newUrl;
	    },
	    getSlideVideoModel: function getSlideVideoModel(model) {
	        if (model == undefined) model = _StoreManager2.default.getState().currentSlide.model;
	
	        var videoModel;
	
	        if (!model) return videoModel;
	
	        var background = model.content[0];
	
	        if (background.isVideo && background.xlinkHref && background.xlinkHref.length > 0) {
	            videoModel = {};
	
	            videoModel.href = this.getCorrectUrl(background.xlinkHref);
	
	            if (background.inPoint == undefined) videoModel.inPoint = 0;else videoModel.inPoint = background.inPoint;
	
	            if (background.outPoint == undefined) videoModel.outPoint = 0;else videoModel.outPoint = background.outPoint;
	
	            if (background.volume == undefined) videoModel.volume = 0.5;else videoModel.volume = background.volume;
	        }
	
	        return videoModel;
	    },
	    playMultipleVideosSequence: function playMultipleVideosSequence(index, volume, startTime) {
	        var play = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var i;
	        var previousVideo;
	        var currentVideo;
	
	        for (i = 0; i < slides.length; i++) {
	            var videoElement = document.getElementById('video_' + i);
	
	            if (!videoElement) continue;
	
	            if (i == index) {
	                if (!(startTime >= 0)) startTime = 0;
	
	                if (videoElement.currentTime != startTime) videoElement.currentTime = startTime;
	
	                currentVideo = videoElement;
	
	                if (play) {
	                    videoElement.volume = volume;
	                    videoElement.play();
	                } else videoElement.pause();
	            } else {
	                videoElement.pause();
	
	                if (videoElement.style.display == 'block') previousVideo = videoElement;else videoElement.style.display = 'none';
	            }
	        }
	
	        if (currentVideo) currentVideo.style.display = 'block';
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (previousVideo) {
	                setTimeout(function (videoElem) {
	                    if (videoElem) videoElem.style.display = 'none';
	                }.bind(this), 250, previousVideo);
	            }
	        } else {
	            if (previousVideo) previousVideo.style.display = 'none';
	        }
	    },
	    playVideoFromSlideIndex: function playVideoFromSlideIndex(index) {
	        var playOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var play = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	        var startTime = this.getStartPoint(index);
	
	        if (playOffset > 0) startTime = startTime + playOffset;
	
	        this.playMultipleVideosSequence(index, this.getVolume(), startTime, play);
	
	        if (this.isVideoShapes()) this.playPauseVideoShapes(play, playOffset === 0); // TODO consider video shape inpoint when introduce video editor
	    },
	    prepareVideo: function prepareVideo(videoModel) {
	        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var play = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	        var forceMute = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	        var index = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
	
	        if (this.isVideoShapes()) {
	            //TODO when introduce inPoint should update it for all video shapes
	            if (play) this.playPauseVideoShapes(true, false, offset);else this.playPauseVideoShapes(false, false, offset);
	        }
	
	        var video = this.getCurrentVideo(index);
	        var isPlayMode = this.isMultipleVideo();
	
	        if (!videoModel) {
	            if (!isPlayMode) video.src = undefined;
	
	            return;
	        }
	
	        if (!video) return;
	
	        var videoVolume;
	
	        if (forceMute) videoVolume = 0;else videoVolume = videoModel.volume;
	
	        if (isPlayMode) {
	            // PLAYER, PREVIEW or ADVANCED AUDIO EDITOR mode
	            this.playMultipleVideosSequence(index, videoVolume, videoModel.inPoint + offset, play);
	        } else {
	            // EDITOR mode
	            video.volume = videoVolume;
	
	            if (video.src && video.src != videoModel.href) video.src = this.checkCacheBreaker(videoModel.href, true);
	
	            video.currentTime = videoModel.inPoint + offset;
	
	            if (play) video.play();
	        }
	    },
	    goToStartPosition: function goToStartPosition() {
	        var video = this.getCurrentVideo();
	
	        if (video) video.currentTime = this.getStartPoint();
	
	        if (this.isVideoShapes()) this.playPauseVideoShapes(false, true); //TODO consider inpoint for the video shapes when introduce video editor
	    },
	    goToPosition: function goToPosition(position) {
	        var video = this.getCurrentVideo();
	
	        if (video) video.currentTime = position;
	    },
	
	    /******************* Multiple videos ***************************/
	    isMultipleVideo: function isMultipleVideo() {
	        return _PreviewCommands2.default.isPlayMode() || _PlayController2.default.isAudioEditorMode();
	    },
	    getSlideVideoHref: function getSlideVideoHref(index) {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var background = slides[index].content[0];
	
	        if (background.isVideo && background.xlinkHref && background.xlinkHref.length > 0) {
	            if (background.xlinkHref.indexOf('http') == -1 && background.xlinkHref.indexOf('file/ci') != -1) return this.getVideoPrefix(background.xlinkHref) + background.xlinkHref;else return background.xlinkHref;
	        } else return '';
	    },
	    getVideoPrefix: function getVideoPrefix(url) {
	        if (url.indexOf('http') == -1) {
	            if (_Configuration2.default.IS_PROD()) return 'https://www.creaza.com';else return 'https://stage.creaza.com';
	        } else return '';
	    },
	    getMultipleVideosList: function getMultipleVideosList() {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var i;
	        var videos = [];
	
	        for (i = 0; i < slides.length; i++) {
	            videos.push(this.getSlideVideoHref(i));
	        }return videos;
	    },
	
	    videoList: [],
	    prepareMultipleVideos: function prepareMultipleVideos() {
	        var startModule = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        var videoWrapper = document.getElementById('multipleVideos');
	
	        if (videoWrapper) videoWrapper.innerHTML = '';
	
	        var oldVideo = document.getElementById('videoBackground');
	        this.videoList = [];
	
	        if (startModule) {
	            if (oldVideo) oldVideo.style.display = 'none';
	        } else {
	            if (oldVideo) oldVideo.style.display = 'block';
	
	            return;
	        }
	
	        this.updateVideos();
	        this.setInPoints();
	    },
	    updateCurrentVideo: function updateCurrentVideo() {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var currentIndex = state.currentSlide.currentSlideIndex;
	        var i;
	
	        for (i = 0; i < slides.length; i++) {
	            var video = document.getElementById('video_' + i);
	
	            if (video) {
	                if (i == currentIndex) {
	                    video.style.display = 'block';
	                    video.currentTime = this.getStartPoint(i);
	                } else video.style.display = 'none';
	            }
	        }
	    },
	    updateVideos: function updateVideos() {
	        var videoWrapper = document.getElementById('multipleVideos');
	
	        if (!videoWrapper) return;
	
	        videoWrapper.innerHTML = '';
	
	        var slidesVideos = this.getMultipleVideosList();
	        var i;
	        var currentIndex = _StoreManager2.default.getState().currentSlide.currentSlideIndex;
	        var videoHolder = document.createElement('div');
	
	        videoWrapper.appendChild(videoHolder);
	
	        for (i = 0; i < slidesVideos.length; i++) {
	            var videoHref = slidesVideos[i];
	            var videoElement;
	
	            if (videoHref != '') {
	                videoElement = document.createElement('VIDEO');
	                videoElement.id = 'video_' + i;
	                videoElement.style.position = 'absolute';
	                videoElement.style.top = '0px';
	                videoElement.style.left = '0px';
	                videoElement.style.width = '800px';
	                videoElement.style.height = '450px';
	                videoElement.className = 'audioItem';
	                videoElement.preload = 'auto';
	                videoElement.playsinline = true;
	                videoElement.src = this.checkCacheBreaker(this.getCorrectUrl(videoHref), true);
	
	                if (i != currentIndex) videoElement.style.display = 'none';
	
	                videoHolder.appendChild(videoElement);
	            }
	        }
	
	        this.videoList = slidesVideos;
	    },
	    checkVideoList: function checkVideoList() {
	        var currentList = this.getMultipleVideosList();
	        var oldList = this.videoList;
	        var i;
	        var updateVideoSequence = false;
	
	        if (currentList.length == oldList.length) {
	            for (i = 0; i < currentList.length; i++) {
	                if (currentList[i] != oldList[i]) {
	                    updateVideoSequence = true;
	                    break;
	                }
	            }
	        } else updateVideoSequence = true;
	
	        if (updateVideoSequence) this.updateVideos();
	    },
	    setInPoints: function setInPoints() {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	
	        for (var i = 0; i < slides.length; i++) {
	            var video = document.getElementById('video_' + i);
	
	            if (!video) continue;
	
	            if (_PlatformDetection2.default.isIOS()) {
	                try {
	                    video.play();
	
	                    setTimeout(function (videoElement, index) {
	                        videoElement.pause();
	                        videoElement.currentTime = this.getStartPoint(index);
	                    }.bind(this), 20, video, i);
	                } catch (e) {
	                    // error
	                }
	            } else {
	                video.currentTime = this.getStartPoint(i);
	            }
	        }
	    },
	    refreshVideosInPlayMode: function refreshVideosInPlayMode() {
	        var excludedVideo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
	        setTimeout(function () {
	            if (_PreviewCommands2.default.isPlayMode()) {
	                var state = _StoreManager2.default.getState();
	                var slides = state.production.slides;
	                var i;
	
	                for (i = 0; i < slides.length; i++) {
	                    var videoElement = document.getElementById('video_' + i);
	
	                    if (!videoElement || i == excludedVideo) continue;
	
	                    var startTime = this.getStartPoint(i);
	
	                    if (videoElement.currentTime != startTime) videoElement.currentTime = startTime;
	
	                    videoElement.pause();
	
	                    if (i == state.currentSlide.currentSlideIndex) videoElement.style.display = 'block';else videoElement.style.display = 'none';
	                }
	            }
	        }.bind(this), 20);
	    }
	};
	
	exports.default = videoUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/VideoUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/VideoUtils.js"); } } })();

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    SLIDE_MENU: 'slide_menu',
	    INSERT_MENU: 'insert_menu',
	    SHAPE_MENU: 'shape_menu',
	    CONTEXT_MENU: 'context_menu',
	    UNIVERSES_MENU: 'universes_menu',
	    ALL_MENUS: 'all_menus'
	};
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/constants/MenuType.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/constants/MenuType.js"); } } })();

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(28);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _ResumeSessionUtils = __webpack_require__(372);
	
	var _ResumeSessionUtils2 = _interopRequireDefault(_ResumeSessionUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiServiceUtils = {
	    saveTime: undefined,
	
	    isWrong: function isWrong() {
	        if ((_AppParameters2.default.context == 'edit' || _AppParameters2.default.context == 'audioTool') && (_AppParameters2.default.currentUserId == -1 || _AppParameters2.default.bundleVersion == undefined)) return true;else return false;
	    },
	    isSafeCall: function isSafeCall(response) {
	        if (_AppParameters2.default.isIcsx) return true;
	
	        if ((_AppParameters2.default.context == 'edit' || _AppParameters2.default.context == 'audioTool') && (_AppParameters2.default.currentUserId == -1 || _AppParameters2.default.bundleVersion == undefined)) return false;
	
	        if (_AppParameters2.default.currentUserId == -1 && (_AppParameters2.default.context == 'player' || _AppParameters2.default.context == 'audioToolPlayer' || _AppParameters2.default.context == 'exportPlayer' || _AppParameters2.default.context == 'exportAudioPlayer')) // it's a PUBLIC production
	            return true;
	
	        // response from a GetSessionInfo call
	        if (response) {
	            var currentUserId = response.userId;
	            var startUserId = _AppParameters2.default.currentUserId;
	
	            if (currentUserId > 0 && startUserId > 0 && currentUserId == startUserId) return true;else return false;
	        } else return false;
	    },
	    showLostSessionAlert: function showLostSessionAlert() {
	        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        var store = _StoreManager2.default.getStore();
	
	        if (value) store.dispatch((0, _MenuActions.showLostSessionAlert)(1));else store.dispatch((0, _MenuActions.showLostSessionAlert)(-1));
	    },
	    showNoAccessAlert: function showNoAccessAlert() {
	        var store = _StoreManager2.default.getStore();
	        store.dispatch((0, _MenuActions.hasNotAccess)(true));
	    },
	    initLostSessionTimer: function initLostSessionTimer() {
	        setInterval(this.checkInternetConnection.bind(this), 5 * 1000);
	
	        if (_Configuration2.default.LOAD_LOCAL == true) return;
	
	        _ResumeSessionUtils2.default.init();
	        setInterval(this.checkSession.bind(this), 20 * 1000);
	    },
	    checkSession: function checkSession() {
	        this.checkSavePreloader();
	
	        // apiService.getSessionInfo() // check if the user has session
	        //     .then(response => {
	        //         if (this.isSafeCall(response) == false) {
	        //             return this.showLostSessionAlert(true);
	        //         }
	        //     });
	    },
	    checkSavePreloader: function checkSavePreloader() {
	        var state = _StoreManager2.default.getState();
	        var isSavePreloader = state.menu.showSavePreloader;
	
	        if (isSavePreloader && isSavePreloader == true) {
	            var currentTime = this.getCurrentTime();
	
	            if (this.saveTime > 0 && currentTime - this.saveTime > 6 * 1000) {
	                var store = _StoreManager2.default.getStore();
	                store.dispatch((0, _MenuActions.showSavePreloader)(false));
	            }
	        }
	    },
	    getCurrentTime: function getCurrentTime() {
	        var date = new Date();
	        var currentTime = date.getTime();
	
	        return currentTime;
	    },
	    executeSafeApiCall: function executeSafeApiCall(callbackFunction) {
	        var _this = this;
	
	        var failCallbackFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	        if (_AppParameters2.default.isTest) {
	            if (callbackFunction) callbackFunction();
	
	            return;
	        }
	
	        _ApiService2.default.getSessionInfo() // check if the user has session
	        .then(function (response) {
	            if (_this.isSafeCall(response) == true) {
	                if (callbackFunction) callbackFunction();
	            } else {
	                if (failCallbackFunction) failCallbackFunction();
	
	                // Lost SessionAlert
	                _this.showLostSessionAlert(true);
	
	                return;
	            }
	        });
	    },
	    executeGetMediaFilesCall: function executeGetMediaFilesCall(parseMediaItems) {
	        var contentType = 'all';
	        _ApiService2.default.loadMediaFiles(contentType, _Configuration2.default.MEDIA_FILES_PAGE_LIMIT).then(function (result) {
	            var items = result.media;
	
	            if (parseMediaItems) parseMediaItems(items);
	        });
	    },
	
	
	    /*********** Internet connection *************/
	    checkInternetConnection: function checkInternetConnection() {
	        var store = _StoreManager2.default.getStore();
	
	        if (!window.navigator.onLine) {
	            store.dispatch((0, _MenuActions.showLostSessionAlert)(5));
	        } else {
	            var showLostSessionAlertValue = _StoreManager2.default.getState().menu.showLostSessionAlert;
	
	            if (showLostSessionAlertValue == 5) {
	                // it's an non internet connection alert
	                store.dispatch((0, _MenuActions.showLostSessionAlert)(-1));
	                // resumeSessionUtils.resumeSession();
	            }
	        }
	    },
	    getNoInternetConnectionAlertHeight: function getNoInternetConnectionAlertHeight() {
	        if (_StoreManager2.default.getState().menu.showLostSessionAlert == 5) return _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	        return 0;
	    }
	};
	
	exports.default = apiServiceUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ApiServiceUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ApiServiceUtils.js"); } } })();

/***/ },
/* 24 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _uuid = __webpack_require__(68);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var animationManager = {
	    allowAnimation: true,
	    target: undefined,
	    clone: undefined,
	    clonesArray: [],
	    isAnimationEditor: false,
	    rotationType: 1,
	
	    getDispatch: function getDispatch() {
	        var store = _StoreManager2.default.getStore();
	        return store.dispatch;
	    },
	    isAnimationMode: function isAnimationMode() {
	        return this.isAnimationEditor;
	    },
	    updateGroupShapesSize: function updateGroupShapesSize(shapeGroup, oldWidth, newWidth, oldHeight, newHeight) {
	        var i;
	        var shape;
	        var shapes = shapeGroup.shapes;
	        var newGroupedShapes = [];
	        var widthScale = newWidth / oldWidth;
	        var heightScale = newHeight / oldHeight;
	
	        for (i = 0; i < shapes.length; i++) {
	            shape = Object.assign({}, shapes[i]);
	
	            switch (shape.type) {
	                case _ShapeConstants2.default.LINE:
	                    {
	                        shape.x1 = shape.x1 * widthScale;
	                        shape.y1 = shape.y1 * heightScale;
	                        shape.x2 = shape.x2 * widthScale;
	                        shape.y2 = shape.y2 * heightScale;
	                        break;
	                    }
	
	                case _ShapeConstants2.default.CURVE:
	                    {
	                        shape.x1 = shape.x1 * widthScale;
	                        shape.y1 = shape.y1 * heightScale;
	                        shape.x2 = shape.x2 * widthScale;
	                        shape.y2 = shape.y2 * heightScale;
	                        shape.cx = shape.cx * widthScale;
	                        shape.cy = shape.cy * heightScale;
	                        break;
	                    }
	
	                default:
	                    {
	                        var oldW = shape.width;
	                        var oldH = shape.height;
	
	                        shape.x = shape.x * widthScale;
	                        shape.y = shape.y * heightScale;
	                        shape.width = shape.width * widthScale;
	                        shape.height = shape.height * heightScale;
	
	                        if (shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                            shape.cx = shape.cx * widthScale;
	                            shape.cy = shape.cy * heightScale;
	                            shape.path = undefined;
	
	                            if (shape.cx1 && shape.cy1) {
	                                shape.cx1 = shape.cx1 * widthScale;
	                                shape.cy1 = shape.cy1 * heightScale;
	                            }
	
	                            if (shape.cx2 && shape.cy2) {
	                                shape.cx2 = shape.cx2 * widthScale;
	                                shape.cy2 = shape.cy2 * heightScale;
	                            }
	
	                            if (shape.cx3 && shape.cy3) {
	                                shape.cx3 = shape.cx3 * widthScale;
	                                shape.cy3 = shape.cy3 * heightScale;
	                            }
	
	                            if (shape.cx4 && shape.cy4) {
	                                shape.cx4 = shape.cx4 * widthScale;
	                                shape.cy4 = shape.cy4 * heightScale;
	                            }
	
	                            if (shape.cx5 && shape.cy5) {
	                                shape.cx5 = shape.cx5 * widthScale;
	                                shape.cy5 = shape.cy5 * heightScale;
	                            }
	                        }
	
	                        if (shape.type == _ShapeConstants2.default.FREEHAND) {
	                            var points = shape.pathPoints;
	                            var j;
	
	                            for (j = 0; j < points.length; j++) {
	                                points[j].x = points[j].x * widthScale;
	                                points[j].y = points[j].y * heightScale;
	                            }
	                        }
	
	                        if (shape.type == _ShapeConstants2.default.GROUP) this.updateGroupShapesSize(shape, oldW, shape.width, oldH, shape.height);
	
	                        break;
	                    }
	            }
	
	            newGroupedShapes.push(shape);
	        }
	
	        shapeGroup.shapes = newGroupedShapes;
	    },
	    duplicateShape: function duplicateShape(model, animationStart, animation) {
	        var isSelected = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        var cloneShape = Object.assign({}, model);
	
	        cloneShape.uuid = _uuid2.default.v4();
	        cloneShape.isSelected = isSelected;
	
	        if (model.type == _ShapeConstants2.default.LINE || model.type == _ShapeConstants2.default.CURVE) {
	            if (animation) {
	                cloneShape.x1 = animation.x1;
	                cloneShape.y1 = animation.y1;
	                cloneShape.x2 = animation.x2;
	                cloneShape.y2 = animation.y2;
	            } else {
	                cloneShape.x1 = cloneShape.x1 + 10;
	                cloneShape.y1 = cloneShape.y1 + 10;
	                cloneShape.x2 = cloneShape.x2 + 10;
	                cloneShape.y2 = cloneShape.y2 + 10;
	            }
	
	            if (model.type == _ShapeConstants2.default.CURVE) {
	                if (animation) {
	                    cloneShape.cx = animation.cx;
	                    cloneShape.cy = animation.cy;
	                } else {
	                    cloneShape.cx = cloneShape.cx + 10;
	                    cloneShape.cy = cloneShape.cy + 10;
	                }
	            }
	        } else {
	            if (animation) {
	                cloneShape.x = animation.x;
	                cloneShape.y = animation.y;
	                cloneShape.width = animation.width;
	                cloneShape.height = animation.height;
	
	                if (model.type == _ShapeConstants2.default.SPEAK_BUBBLE || model.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || model.type == _ShapeConstants2.default.SCREAM_BUBBLE || model.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                    cloneShape.cx = animation.cx;
	                    cloneShape.cy = animation.cy;
	
	                    if (cloneShape.cx1) {
	                        cloneShape.cx1 = animation.cx1;
	                        cloneShape.cy1 = animation.cy1;
	                    }
	
	                    if (cloneShape.cx2) {
	                        cloneShape.cx2 = animation.cx2;
	                        cloneShape.cy2 = animation.cy2;
	                    }
	
	                    if (cloneShape.cx3) {
	                        cloneShape.cx3 = animation.cx3;
	                        cloneShape.cy3 = animation.cy3;
	                    }
	
	                    if (cloneShape.cx4) {
	                        cloneShape.cx4 = animation.cx4;
	                        cloneShape.cy4 = animation.cy4;
	                    }
	
	                    if (cloneShape.cx5) {
	                        cloneShape.cx5 = animation.cx5;
	                        cloneShape.cy5 = animation.cy5;
	                    }
	                }
	
	                if (model.type == _ShapeConstants2.default.SPEAK_BUBBLE || model.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || model.type == _ShapeConstants2.default.SCREAM_BUBBLE || model.type == _ShapeConstants2.default.THOUGHT_BUBBLE || model.type == _ShapeConstants2.default.TEXTBOX || model.type == _ShapeConstants2.default.TEXTBOXSIMPLE) cloneShape.fontSize = _TextSizeUtils2.default.getFontSize(cloneShape, cloneShape.width, cloneShape.height, animationStart.width, animationStart.height);
	            } else {
	                var gap = 20;
	                var newX = 0;
	                var freeLeftSide = cloneShape.x;
	                var freeRightSide = 800 - (cloneShape.x + cloneShape.width);
	
	                if (freeRightSide >= cloneShape.width + gap || freeRightSide >= freeLeftSide || Math.abs(freeRightSide - freeLeftSide) < 3) {
	                    // should be added to the right side
	                    newX = cloneShape.x + cloneShape.width + gap;
	
	                    if (newX + cloneShape.width > 800) newX = 800 - cloneShape.width;
	                } else {
	                    // should be added to the left side
	                    newX = cloneShape.x - cloneShape.width - gap;
	
	                    if (newX < 0) newX = 0;
	                }
	
	                if (model.type == _ShapeConstants2.default.SPEAK_BUBBLE || model.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || model.type == _ShapeConstants2.default.SCREAM_BUBBLE || model.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                    cloneShape.cx = cloneShape.cx + (newX - cloneShape.x);
	
	                    if (cloneShape.cx1) cloneShape.cx1 = cloneShape.cx1 + (newX - cloneShape.x);
	
	                    if (cloneShape.cx2) cloneShape.cx2 = cloneShape.cx2 + (newX - cloneShape.x);
	
	                    if (cloneShape.cx3) cloneShape.cx3 = cloneShape.cx3 + (newX - cloneShape.x);
	
	                    if (cloneShape.cx4) cloneShape.cx4 = cloneShape.cx4 + (newX - cloneShape.x);
	
	                    if (cloneShape.cx5) cloneShape.cx5 = cloneShape.cx5 + (newX - cloneShape.x);
	                }
	
	                cloneShape.x = newX;
	            }
	
	            if (cloneShape.type === _ShapeConstants2.default.GROUP) {
	                if (animationStart) this.updateGroupShapesSize(cloneShape, animationStart.width, cloneShape.width, animationStart.height, cloneShape.height);else this.updateGroupShapesSize(cloneShape, model.width, cloneShape.width, model.height, cloneShape.height);
	            }
	        }
	
	        if (animation) {
	            cloneShape.opacity = animation.opacity;
	            cloneShape.rotation = animation.rotation;
	        }
	
	        return cloneShape;
	    },
	    deleteAnimation: function deleteAnimation() {
	        var dispatch = this.getDispatch();
	
	        if (this.target) {
	            dispatch((0, _CurrentSlideActions.removeAnimation)(this.target.uuid));
	            _SaveManager2.default.isContentChanged(true);
	            _AudioEditorUtils2.default.addActionToHistory();
	        }
	
	        this.exitAnimationMode();
	    },
	    addAnimation: function addAnimation() {
	        var isAnimationMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (!this.target) return;
	
	        var clone = this.clone;
	
	        if (!clone) clone = this.cloneObject;
	
	        if (!this.clonesArray || this.clonesArray.length == 0) this.clonesArray = this.cloneObjectsArray;
	
	        if (!clone) return;
	
	        var dispatch = this.getDispatch();
	        var animation = {};
	        var i = void 0;
	        var points = [];
	
	        if (this.clonesArray.length > 0) {
	            for (i = 0; i < this.clonesArray.length; i++) {
	                var point = {};
	                var currentElement = this.clonesArray[i];
	
	                if (!(currentElement.opacity >= 0)) point.opacity = 1;else point.opacity = currentElement.opacity;
	
	                point.rotation = currentElement.rotation;
	
	                points.push(point);
	            }
	        }
	
	        if (this.target.type == _ShapeConstants2.default.LINE || this.target.type == _ShapeConstants2.default.CURVE) {
	            animation.start_x1 = this.target.x1;
	            animation.start_y1 = this.target.y1;
	            animation.start_x2 = this.target.x2;
	            animation.start_y2 = this.target.y2;
	
	            animation.end_x1 = clone.x1;
	            animation.end_y1 = clone.y1;
	            animation.end_x2 = clone.x2;
	            animation.end_y2 = clone.y2;
	
	            if (this.target.type == _ShapeConstants2.default.CURVE) {
	                animation.start_cx = this.target.cx;
	                animation.start_cy = this.target.cy;
	
	                animation.end_cx = clone.cx;
	                animation.end_cy = clone.cy;
	            }
	
	            for (i = 0; i < this.clonesArray.length; i++) {
	                points[i].x1 = this.clonesArray[i].x1;
	                points[i].y1 = this.clonesArray[i].y1;
	                points[i].x2 = this.clonesArray[i].x2;
	                points[i].y2 = this.clonesArray[i].y2;
	
	                if (this.target.type == _ShapeConstants2.default.CURVE) {
	                    points[i].cx = this.clonesArray[i].cx;
	                    points[i].cy = this.clonesArray[i].cy;
	                }
	            }
	        } else {
	            animation.start_x = this.target.x;
	            animation.start_y = this.target.y;
	            animation.start_width = this.target.width;
	            animation.start_height = this.target.height;
	
	            animation.end_x = clone.x;
	            animation.end_y = clone.y;
	            animation.end_width = clone.width;
	            animation.end_height = clone.height;
	
	            if (this.target.type == _ShapeConstants2.default.SPEAK_BUBBLE || this.target.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || this.target.type == _ShapeConstants2.default.SCREAM_BUBBLE || this.target.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                animation.start_cx = this.target.cx;
	                animation.start_cy = this.target.cy;
	                animation.end_cx = clone.cx;
	                animation.end_cy = clone.cy;
	
	                if (this.target.cx1) {
	                    animation.start_cx1 = this.target.cx1;
	                    animation.start_cy1 = this.target.cy1;
	                    animation.end_cx1 = clone.cx1;
	                    animation.end_cy1 = clone.cy1;
	                }
	
	                if (this.target.cx2) {
	                    animation.start_cx2 = this.target.cx2;
	                    animation.start_cy2 = this.target.cy2;
	                    animation.end_cx2 = clone.cx2;
	                    animation.end_cy2 = clone.cy2;
	                }
	
	                if (this.target.cx3) {
	                    animation.start_cx3 = this.target.cx3;
	                    animation.start_cy3 = this.target.cy3;
	                    animation.end_cx3 = clone.cx3;
	                    animation.end_cy3 = clone.cy3;
	                }
	
	                if (this.target.cx4) {
	                    animation.start_cx4 = this.target.cx4;
	                    animation.start_cy4 = this.target.cy4;
	                    animation.end_cx4 = clone.cx4;
	                    animation.end_cy4 = clone.cy4;
	                }
	
	                if (this.target.cx5) {
	                    animation.start_cx5 = this.target.cx5;
	                    animation.start_cy5 = this.target.cy5;
	                    animation.end_cx5 = clone.cx5;
	                    animation.end_cy5 = clone.cy5;
	                }
	            }
	
	            if (this.target.type == _ShapeConstants2.default.SPEAK_BUBBLE || this.target.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || this.target.type == _ShapeConstants2.default.SCREAM_BUBBLE || this.target.type == _ShapeConstants2.default.THOUGHT_BUBBLE || this.target.type == _ShapeConstants2.default.TEXTBOX || this.target.type == _ShapeConstants2.default.TEXTBOXSIMPLE) {
	                animation.start_fontSize = this.target.fontSize;
	                animation.end_fontSize = clone.fontSize;
	            }
	
	            for (i = 0; i < this.clonesArray.length; i++) {
	                points[i].x = this.clonesArray[i].x;
	                points[i].y = this.clonesArray[i].y;
	                points[i].width = this.clonesArray[i].width;
	                points[i].height = this.clonesArray[i].height;
	
	                if (this.target.type == _ShapeConstants2.default.SPEAK_BUBBLE || this.target.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || this.target.type == _ShapeConstants2.default.SCREAM_BUBBLE || this.target.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                    points[i].cx = this.clonesArray[i].cx;
	                    points[i].cy = this.clonesArray[i].cy;
	
	                    if (this.target.cx1) {
	                        points[i].cx1 = this.clonesArray[i].cx1;
	                        points[i].cy1 = this.clonesArray[i].cy1;
	                    }
	
	                    if (this.target.cx2) {
	                        points[i].cx2 = this.clonesArray[i].cx2;
	                        points[i].cy2 = this.clonesArray[i].cy2;
	                    }
	
	                    if (this.target.cx3) {
	                        points[i].cx3 = this.clonesArray[i].cx3;
	                        points[i].cy3 = this.clonesArray[i].cy3;
	                    }
	
	                    if (this.target.cx4) {
	                        points[i].cx4 = this.clonesArray[i].cx4;
	                        points[i].cy4 = this.clonesArray[i].cy4;
	                    }
	
	                    if (this.target.cx5) {
	                        points[i].cx5 = this.clonesArray[i].cx5;
	                        points[i].cy5 = this.clonesArray[i].cy5;
	                    }
	                }
	
	                if (this.target.type == _ShapeConstants2.default.SPEAK_BUBBLE || this.target.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || this.target.type == _ShapeConstants2.default.SCREAM_BUBBLE || this.target.type == _ShapeConstants2.default.THOUGHT_BUBBLE || this.target.type == _ShapeConstants2.default.TEXTBOX || this.target.type == _ShapeConstants2.default.TEXTBOXSIMPLE) {
	                    points[i].fontSize = this.clonesArray[i].fontSize;
	                }
	            }
	        }
	
	        animation.start_opacity = this.target.opacity;
	        animation.end_opacity = clone.opacity;
	
	        animation.start_rotation = this.target.rotation;
	        animation.end_rotation = clone.rotation;
	
	        animation.rotation_type = animationManager.rotationType;
	
	        if (points.length > 0) animation.points = points;
	
	        dispatch((0, _CurrentSlideActions.addAnimation)(this.target.uuid, animation));
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        if (!isAnimationMode) this.exitAnimationMode();
	    },
	    enterAnimationMode: function enterAnimationMode(shape) {
	        this.stopAnimations();
	
	        var dispatch = this.getDispatch();
	
	        dispatch((0, _CurrentSlideActions.selectShape)(''));
	        dispatch((0, _CurrentSlideActions.changeInteractionState)(shape.uuid, false, false));
	
	        this.isAnimationEditor = true;
	        this.target = shape;
	        this.initialAnimation = this.target.animation;
	        this.clone = undefined;
	        this.clonesArray = [];
	
	        var animationPoints = this.getAnimationPoints(shape.animation);
	
	        if (animationPoints.length === 0) this.clone = this.duplicateShape(shape, undefined, undefined, true);else if (animationPoints.length >= 2) {
	            this.clone = this.duplicateShape(shape, animationPoints[0], animationPoints[1]);
	
	            for (var i = 2; i < animationPoints.length; i++) {
	                var isSelected = i === animationPoints.length - 1;
	                this.clonesArray.push(this.duplicateShape(shape, animationPoints[i - 1], animationPoints[i], isSelected));
	            }
	        }
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.ANIMATION_CONTEXT));
	    },
	    exitAnimationMode: function exitAnimationMode() {
	        if (!this.isAnimationMode()) return;
	
	        this.isAnimationEditor = false;
	        this.target = undefined;
	        this.clone = undefined;
	        this.clonesArray = [];
	
	        setTimeout(function () {
	            var dispatch = this.getDispatch();
	            dispatch((0, _CurrentSlideActions.selectShape)(''));
	            dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	            dispatch((0, _MenuActions.updateCurrentSlideContent)(Math.random()));
	        }.bind(this), 15);
	    },
	
	
	    animationTimer: undefined,
	    STEP: 15,
	    startTime: 0,
	    currentTime: 0,
	    totalTime: 0,
	    pauseSoundStatus: undefined,
	    isAnimationTime: false,
	    initialAnimation: undefined,
	    cloneObject: undefined,
	    cloneObjectsArray: [],
	
	    startAnimationInEditMode: function startAnimationInEditMode() {
	        this.addAnimation(true);
	
	        this.cloneObject = this.clone;
	        this.clone = undefined;
	
	        this.cloneObjectsArray = this.clonesArray;
	        this.clonesArray = [];
	
	        var dispatch = this.getDispatch();
	        dispatch((0, _CurrentSlideActions.selectShape)(''));
	
	        setTimeout(function () {
	            this.startAnimations(true);
	        }.bind(this), 10);
	    },
	    clearAnimationsInEditMode: function clearAnimationsInEditMode() {
	        var isCancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (this.cloneObject) {
	            this.stopAnimations(false);
	
	            if (isCancel) {
	                var dispatch = this.getDispatch();
	                dispatch((0, _CurrentSlideActions.addAnimation)(this.target.uuid, this.initialAnimation));
	                _SaveManager2.default.isContentChanged(true);
	            }
	
	            this.clone = this.cloneObject;
	            this.cloneObject = undefined;
	            this.clonesArray = this.cloneObjectsArray;
	            this.cloneObjectsArray = [];
	
	            if (this.pauseSoundStatus) this.pauseSoundStatus();
	        }
	    },
	    stopAnimationIndEditMode: function stopAnimationIndEditMode() {
	        if (!this.cloneObject) return;
	
	        this.stopAnimations(false);
	
	        this.clone = this.cloneObject;
	        this.cloneObject = undefined;
	
	        this.clonesArray = this.cloneObjectsArray;
	        this.cloneObjectsArray = [];
	
	        if (this.pauseSoundStatus) this.pauseSoundStatus();
	
	        var dispatch = this.getDispatch();
	        dispatch((0, _CurrentSlideActions.selectShape)(''));
	        dispatch((0, _CurrentSlideActions.changeInteractionState)(this.target.uuid, true, true));
	
	        setTimeout(function () {
	            if (this.target) {
	                dispatch((0, _CurrentSlideActions.selectShape)(this.target.uuid, false, true));
	                dispatch((0, _CurrentSlideActions.changeInteractionState)(this.target.uuid, false, false));
	                dispatch((0, _MenuActions.refreshShapePosition)(this.target.uuid));
	            }
	        }.bind(this), 20);
	    },
	    updateCurrentTime: function updateCurrentTime() {
	        if (_PreviewCommands2.default.isEditorMode()) {
	            setTimeout(function () {
	                var model = _StoreManager2.default.getState().currentSlide.model;
	                var shapes = model.content;
	                var totalTime = model.time * 1000;
	                var animatedShape;
	
	                if (!shapes) return;
	
	                for (var i = 0; i < shapes.length; i++) {
	                    var shape = shapes[i];
	
	                    if (shape.animation) {
	                        animatedShape = shape;
	                        break;
	                    }
	                }
	
	                if (animatedShape) {
	                    var animation = animatedShape.animation;
	                    var startVal;
	                    var endVal;
	                    var currentVal;
	
	                    switch (true) {
	                        case animation.start_x != animation.end_x:
	                            {
	                                startVal = animation.start_x;
	                                endVal = animation.end_x;
	                                currentVal = animatedShape.x - startVal;
	                                break;
	                            }
	
	                        case animation.start_y != animation.end_y:
	                            {
	                                startVal = animation.start_y;
	                                endVal = animation.end_y;
	                                currentVal = animatedShape.y - startVal;
	                                break;
	                            }
	
	                        case animation.start_width != animation.end_width:
	                            {
	                                startVal = animation.start_width;
	                                endVal = animation.end_width;
	                                currentVal = animatedShape.width - startVal;
	                                break;
	                            }
	
	                        case animation.start_height != animation.end_height:
	                            {
	                                startVal = animation.start_height;
	                                endVal = animation.end_height;
	                                currentVal = animatedShape.height - startVal;
	                                break;
	                            }
	
	                        case animation.start_opacity != animation.end_opacity:
	                            {
	                                startVal = animation.start_opacity;
	                                endVal = animation.end_opacity;
	                                currentVal = animatedShape.opacity - startVal;
	                                break;
	                            }
	
	                        case animation.start_rotation != animation.end_rotation:
	                            {
	                                startVal = animation.start_rotation;
	                                endVal = animation.end_rotation;
	                                currentVal = animatedShape.rotation - startVal;
	                                break;
	                            }
	
	                        case animation.start_x1 != animation.end_x1:
	                            {
	                                startVal = animation.start_x1;
	                                endVal = animation.end_x1;
	                                currentVal = animatedShape.x1 - startVal;
	                                break;
	                            }
	
	                        case animation.start_y1 != animation.end_y1:
	                            {
	                                startVal = animation.start_y1;
	                                endVal = animation.end_y1;
	                                currentVal = animatedShape.y1 - startVal;
	                                break;
	                            }
	
	                        case animation.start_x2 != animation.end_x2:
	                            {
	                                startVal = animation.start_x2;
	                                endVal = animation.end_x2;
	                                currentVal = animatedShape.x2 - startVal;
	                                break;
	                            }
	
	                        case animation.start_y2 != animation.end_y2:
	                            {
	                                startVal = animation.start_y2;
	                                endVal = animation.end_y2;
	                                currentVal = animatedShape.y2 - startVal;
	                                break;
	                            }
	                    }
	
	                    var difference = Math.abs(endVal - startVal);
	
	                    if (difference > 0) this.currentTime = Math.floor(currentVal * totalTime / difference);
	                }
	            }.bind(this), 50);
	        }
	    },
	    startAnimations: function startAnimations() {
	        var isPause = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var startOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var startPlaying = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	        if (_PreviewCommands2.default.isEditorMode()) {
	            var dispatch = this.getDispatch();
	            dispatch((0, _CurrentSlideActions.selectShape)(''));
	        }
	
	        this.stopAnimations(isPause, false);
	
	        if (isPause) {
	            if (!this.currentTime) this.currentTime = 0;
	        } else this.currentTime = 0;
	
	        if (startOffset > 0) this.currentTime = startOffset;
	
	        var model = _StoreManager2.default.getState().currentSlide.model;
	        this.totalTime = model.time * 1000;
	        this.startTime = new Date().getTime();
	        this.isAnimationTime = true;
	
	        if (!startPlaying) {
	            // just click on the ruler and change the animation to the current position
	            if (startOffset != 0) this.animateShapes(true);
	        } else this.animationTimer = setInterval(this.animateShapes.bind(this), this.STEP);
	    },
	    exitPreview: function exitPreview() {
	        this.pauseSoundStatus = undefined;
	
	        setTimeout(function () {
	            this.doAnimations(true);
	        }.bind(this), 20);
	    },
	    stopAnimations: function stopAnimations() {
	        var isPause = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var updateStartPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        this.totalTime = 0;
	        this.isAnimationTime = false;
	
	        if (this.animationTimer) clearInterval(this.animationTimer);
	
	        if (!updateStartPosition) return;
	
	        if (!isPause) {
	            this.currentTime = 0;
	
	            if (!_PreviewCommands2.default.isPlayMode()) this.doAnimations(true);
	        }
	    },
	    animateShapes: function animateShapes() {
	        var useCurrentPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (!useCurrentPosition) {
	            var time = new Date().getTime();
	            this.currentTime = this.currentTime + (time - this.startTime);
	            this.startTime = time;
	        }
	
	        if (this.currentTime >= this.totalTime) {
	            if (this.isAnimationMode()) this.stopAnimationIndEditMode();else this.stopAnimations();
	
	            if (!_PlayController2.default.isAudioEditorMode() && _PreviewCommands2.default.isEditorMode()) {
	                if (this.pauseSoundStatus) this.pauseSoundStatus();
	            }
	        } else this.doAnimations();
	    },
	    isAnimatedSlide: function isAnimatedSlide() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	
	        if (!shapes) return false;
	
	        for (var i = 0; i < shapes.length; i++) {
	            if (shapes[i].animation) return true;
	        }
	
	        return false;
	    },
	    isScaleAnimation: function isScaleAnimation(shapeModel) {
	        if (_PlatformDetection2.default.isIOS() || _PlatformDetection2.default.isEdge() || shapeModel.type == _ShapeConstants2.default.GROUP || shapeModel.type == _ShapeConstants2.default.SCREAM_BUBBLE || shapeModel.type == _ShapeConstants2.default.THOUGHT_BUBBLE) return true;else return false;
	    },
	    getAnimationPoints: function getAnimationPoints(animation) {
	        if (!animation) return [];
	
	        var points = animation.points ? animation.points : [];
	        var animationPoints = [];
	        var point = void 0;
	        var i = void 0;
	
	        if (animation.start_x1 && animation.start_x2) {
	            point = {};
	            point.x1 = animation.start_x1;
	            point.y1 = animation.start_y1;
	            point.x2 = animation.start_x2;
	            point.y2 = animation.start_y2;
	
	            if (animation.start_cx) {
	                point.cx = animation.start_cx;
	                point.cy = animation.start_cy;
	            }
	
	            animationPoints.push(point);
	
	            point = {};
	            point.x1 = animation.end_x1;
	            point.y1 = animation.end_y1;
	            point.x2 = animation.end_x2;
	            point.y2 = animation.end_y2;
	
	            if (animation.end_cx) {
	                point.cx = animation.end_cx;
	                point.cy = animation.end_cy;
	            }
	
	            animationPoints.push(point);
	
	            for (i = 0; i < points.length; i++) {
	                point = {};
	                point.x1 = points[i].x1;
	                point.y1 = points[i].y1;
	                point.x2 = points[i].x2;
	                point.y2 = points[i].y2;
	
	                if (points[i].cx) {
	                    point.cx = points[i].cx;
	                    point.cy = points[i].cy;
	                }
	
	                animationPoints.push(point);
	            }
	        } else {
	            point = {};
	            point.x = animation.start_x;
	            point.y = animation.start_y;
	            point.width = animation.start_width;
	            point.height = animation.start_height;
	            point.cx = animation.start_cx;
	            point.cy = animation.start_cy;
	            point.cx1 = animation.start_cx1;
	            point.cy1 = animation.start_cy1;
	            point.cx2 = animation.start_cx2;
	            point.cy2 = animation.start_cy2;
	            point.cx3 = animation.start_cx3;
	            point.cy3 = animation.start_cy3;
	            point.cx4 = animation.start_cx4;
	            point.cy4 = animation.start_cy4;
	            point.cx5 = animation.start_cx5;
	            point.cy5 = animation.start_cy5;
	            point.fontSize = animation.start_fontSize;
	            animationPoints.push(point);
	
	            if (animation.rotation_type === 0) {
	                var p = Object.assign({}, point);
	                animationPoints.push(p);
	            } else {
	                point = {};
	                point.x = animation.end_x;
	                point.y = animation.end_y;
	                point.width = animation.end_width;
	                point.height = animation.end_height;
	                point.cx = animation.end_cx;
	                point.cy = animation.end_cy;
	                point.cx1 = animation.end_cx1;
	                point.cy1 = animation.end_cy1;
	                point.cx2 = animation.end_cx2;
	                point.cy2 = animation.end_cy2;
	                point.cx3 = animation.end_cx3;
	                point.cy3 = animation.end_cy3;
	                point.cx4 = animation.end_cx4;
	                point.cy4 = animation.end_cy4;
	                point.cx5 = animation.end_cx5;
	                point.cy5 = animation.end_cy5;
	                point.fontSize = animation.end_fontSize;
	                animationPoints.push(point);
	            }
	
	            for (i = 0; i < points.length; i++) {
	                point = {};
	                point.x = points[i].x;
	                point.y = points[i].y;
	                point.width = points[i].width;
	                point.height = points[i].height;
	                point.cx = points[i].cx;
	                point.cy = points[i].cy;
	                point.cx1 = points[i].cx1;
	                point.cy1 = points[i].cy1;
	                point.cx2 = points[i].cx2;
	                point.cy2 = points[i].cy2;
	                point.cx3 = points[i].cx3;
	                point.cy3 = points[i].cy3;
	                point.cx4 = points[i].cx4;
	                point.cy4 = points[i].cy4;
	                point.cx5 = points[i].cx5;
	                point.cy5 = points[i].cy5;
	                point.fontSize = points[i].fontSize;
	
	                animationPoints.push(point);
	            }
	        }
	
	        for (i = 0; i < animationPoints.length; i++) {
	            point = animationPoints[i];
	
	            if (i === 0) {
	                point.opacity = animation.start_opacity;
	                point.rotation = animation.start_rotation;
	            } else if (i === 1) {
	                point.opacity = animation.end_opacity;
	                point.rotation = animation.end_rotation;
	            } else {
	                point.opacity = points[i - 2].opacity;
	                point.rotation = points[i - 2].rotation;
	            }
	        }
	
	        return animationPoints;
	    },
	    getTargets: function getTargets(shape) {
	        var animationPoints = this.getAnimationPoints(shape.animation);
	        var targets = {};
	
	        if (animationPoints.length === 2) {
	            targets.start = animationPoints[0];
	            targets.end = animationPoints[1];
	            targets.currentSegment = 0;
	            targets.segmentsLength = 1;
	
	            return targets;
	        }
	
	        var segments = animationPoints.length - 1;
	        var timePerSegment = this.totalTime / segments;
	
	        for (var i = 0; i < segments; i++) {
	            if (this.currentTime >= i * timePerSegment && this.currentTime < (i + 1) * timePerSegment) {
	                targets.start = animationPoints[i];
	                targets.end = animationPoints[i + 1];
	                targets.currentSegment = i;
	                targets.segmentsLength = segments;
	
	                return targets;
	            }
	        }
	
	        return undefined;
	    },
	    doAnimations: function doAnimations() {
	        var setInitialPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var dispatch = this.getDispatch();
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var shape;
	        var i;
	        var animatedShapes = [];
	        var animations = [];
	
	        if (!shapes) return;
	
	        for (i = 0; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.animation) {
	                var animation = {};
	                var targets = this.getTargets(shape);
	
	                if (!targets && !setInitialPosition) return;
	
	                if (shape.type == _ShapeConstants2.default.LINE || shape.type == _ShapeConstants2.default.CURVE) {
	                    if (setInitialPosition) {
	                        if (shape.animation.start_x1) animation.x1 = shape.animation.start_x1;
	                    } else {
	                        if (targets.start.x1 && targets.end.x1 && targets.start.x1 !== targets.end.x1) animation.x1 = this.getCurrentValue(targets.start.x1, targets.end.x1, targets.segmentsLength, targets.currentSegment);
	                    }
	
	                    if (setInitialPosition) {
	                        if (shape.animation.start_y1) animation.y1 = shape.animation.start_y1;
	                    } else {
	                        if (targets.start.y1 && targets.end.y1 && targets.start.y1 !== targets.end.y1) animation.y1 = this.getCurrentValue(targets.start.y1, targets.end.y1, targets.segmentsLength, targets.currentSegment);
	                    }
	
	                    if (setInitialPosition) {
	                        if (shape.animation.start_x2) animation.x2 = shape.animation.start_x2;
	                    } else {
	                        if (targets.start.x2 && targets.end.x2 && targets.start.x2 !== targets.end.x2) animation.x2 = this.getCurrentValue(targets.start.x2, targets.end.x2, targets.segmentsLength, targets.currentSegment);
	                    }
	
	                    if (setInitialPosition) {
	                        if (shape.animation.start_y2) animation.y2 = shape.animation.start_y2;
	                    } else {
	                        if (targets.start.y2 && targets.end.y2 && targets.start.y2 !== targets.end.y2) animation.y2 = this.getCurrentValue(targets.start.y2, targets.end.y2, targets.segmentsLength, targets.currentSegment);
	                    }
	
	                    if (shape.type == _ShapeConstants2.default.CURVE) {
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cx) animation.cx = shape.animation.start_cx;
	                        } else {
	                            if (targets.start.cx && targets.end.cx && targets.start.cx !== targets.end.cx) animation.cx = this.getCurrentValue(targets.start.cx, targets.end.cx, targets.segmentsLength, targets.currentSegment);
	                        }
	
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cy) animation.cy = shape.animation.start_cy;
	                        } else {
	                            if (targets.start.cy && targets.end.cy && targets.start.cy !== targets.end.cy) animation.cy = this.getCurrentValue(targets.start.cy, targets.end.cy, targets.segmentsLength, targets.currentSegment);
	                        }
	                    }
	                } else {
	                    if (setInitialPosition) {
	                        if (shape.animation.start_x) animation.x = shape.animation.start_x;
	                    } else {
	                        if (shape.animation.rotation_type > 1) {
	                            animation.x = this.getCurrentValueForRotation(targets.start.x, targets.start.y, targets.end.x, targets.end.y, true);
	                        } else if (targets.start.x && targets.end.x && targets.start.x !== targets.end.x) animation.x = this.getCurrentValue(targets.start.x, targets.end.x, targets.segmentsLength, targets.currentSegment);
	                    }
	
	                    if (setInitialPosition) {
	                        if (shape.animation.start_y) animation.y = shape.animation.start_y;
	                    } else {
	                        if (shape.animation.rotation_type > 1) {
	                            animation.y = this.getCurrentValueForRotation(targets.start.x, targets.start.y, targets.end.x, targets.end.y, false);
	                        } else if (targets.start.y && targets.end.y && targets.start.y !== targets.end.y) animation.y = this.getCurrentValue(targets.start.y, targets.end.y, targets.segmentsLength, targets.currentSegment);
	                    }
	
	                    if (setInitialPosition) {
	                        if (shape.animation.start_width) animation.width = shape.animation.start_width;
	                    } else {
	                        if (targets.start.width && targets.end.width && targets.start.width !== targets.end.width) animation.width = this.getCurrentValue(targets.start.width, targets.end.width, targets.segmentsLength, targets.currentSegment);
	                    }
	
	                    if (setInitialPosition) {
	                        if (shape.animation.start_height) animation.height = shape.animation.start_height;
	                    } else {
	                        if (targets.start.height && targets.end.height && targets.start.height !== targets.end.height) animation.height = this.getCurrentValue(targets.start.height, targets.end.height, targets.segmentsLength, targets.currentSegment);
	                    }
	
	                    if (shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cx) animation.cx = shape.animation.start_cx;
	                        } else {
	                            if (shape.animation.rotation_type > 1) {
	                                animation.cx = this.getCurrentValueForRotation(targets.start.cx, targets.start.cy, targets.end.cx, targets.end.cy, true);
	                            } else if (targets.start.cx && targets.end.cx && targets.start.cx !== targets.end.cx) animation.cx = this.getCurrentValue(targets.start.cx, targets.end.cx, targets.segmentsLength, targets.currentSegment);
	                        }
	
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cy) animation.cy = shape.animation.start_cy;
	                        } else {
	                            if (shape.animation.rotation_type > 1) {
	                                animation.cy = this.getCurrentValueForRotation(targets.start.cx, targets.start.cy, targets.end.cx, targets.end.cy, false);
	                            } else if (targets.start.cy && targets.end.cy && targets.start.cy !== targets.end.cy) animation.cy = this.getCurrentValue(targets.start.cy, targets.end.cy, targets.segmentsLength, targets.currentSegment);
	                        }
	
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cx1) animation.cx1 = shape.animation.start_cx1;
	                        } else {
	                            if (shape.animation.rotation_type > 1 && targets.start.cx1 && targets.end.cx1) {
	                                animation.cx1 = this.getCurrentValueForRotation(targets.start.cx1, targets.start.cy1, targets.end.cx1, targets.end.cy1, true);
	                            } else if (targets.start.cx1 && targets.end.cx1 && targets.start.cx1 !== targets.end.cx1) animation.cx1 = this.getCurrentValue(targets.start.cx1, targets.end.cx1, targets.segmentsLength, targets.currentSegment);
	                        }
	
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cy1) animation.cy1 = shape.animation.start_cy1;
	                        } else {
	                            if (shape.animation.rotation_type > 1 && targets.start.cy1 && targets.end.cy1) {
	                                animation.cy1 = this.getCurrentValueForRotation(targets.start.cx1, targets.start.cy1, targets.end.cx1, targets.end.cy1, false);
	                            } else if (targets.start.cy1 && targets.end.cy1 && targets.start.cy1 !== targets.end.cy1) animation.cy1 = this.getCurrentValue(targets.start.cy1, targets.end.cy1, targets.segmentsLength, targets.currentSegment);
	                        }
	
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cx2) animation.cx2 = shape.animation.start_cx2;
	                        } else {
	                            if (shape.animation.rotation_type > 1 && targets.start.cx2 && targets.end.cx2) {
	                                animation.cx2 = this.getCurrentValueForRotation(targets.start.cx2, targets.start.cy2, targets.end.cx2, targets.end.cy2, true);
	                            } else if (targets.start.cx2 && targets.end.cx2 && targets.start.cx2 !== targets.end.cx2) animation.cx2 = this.getCurrentValue(targets.start.cx2, targets.end.cx2, targets.segmentsLength, targets.currentSegment);
	                        }
	
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cy2) animation.cy2 = shape.animation.start_cy2;
	                        } else {
	                            if (shape.animation.rotation_type > 1 && targets.start.cy2 && targets.end.cy2) {
	                                animation.cy2 = this.getCurrentValueForRotation(targets.start.cx2, targets.start.cy2, targets.end.cx2, targets.end.cy2, false);
	                            } else if (targets.start.cy2 && targets.end.cy2 && targets.start.cy2 !== targets.end.cy2) animation.cy2 = this.getCurrentValue(targets.start.cy2, targets.end.cy2, targets.segmentsLength, targets.currentSegment);
	                        }
	
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cx3) animation.cx3 = shape.animation.start_cx3;
	                        } else {
	                            if (shape.animation.rotation_type > 1 && targets.start.cx3 && targets.end.cx3) {
	                                animation.cx3 = this.getCurrentValueForRotation(targets.start.cx3, targets.start.cy3, targets.end.cx3, targets.end.cy3, true);
	                            } else if (targets.start.cx3 && targets.end.cx3 && targets.start.cx3 !== targets.end.cx3) animation.cx3 = this.getCurrentValue(targets.start.cx3, targets.end.cx3, targets.segmentsLength, targets.currentSegment);
	                        }
	
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cy3) animation.cy3 = shape.animation.start_cy3;
	                        } else {
	                            if (shape.animation.rotation_type > 1 && targets.start.cx3 && targets.end.cx3) {
	                                animation.cy3 = this.getCurrentValueForRotation(targets.start.cx3, targets.start.cy3, targets.end.cx3, targets.end.cy3, false);
	                            } else if (targets.start.cy3 && targets.end.cy3 && targets.start.cy3 !== targets.end.cy3) animation.cy3 = this.getCurrentValue(targets.start.cy3, targets.end.cy3, targets.segmentsLength, targets.currentSegment);
	                        }
	
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cx4) animation.cx4 = shape.animation.start_cx4;
	                        } else {
	                            if (shape.animation.rotation_type > 1 && targets.start.cx4 && targets.end.cx4) {
	                                animation.cx4 = this.getCurrentValueForRotation(targets.start.cx4, targets.start.cy4, targets.end.cx4, targets.end.cy4, true);
	                            } else if (targets.start.cx4 && targets.end.cx4 && targets.start.cx4 !== targets.end.cx4) animation.cx4 = this.getCurrentValue(targets.start.cx4, targets.end.cx4, targets.segmentsLength, targets.currentSegment);
	                        }
	
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cy4) animation.cy4 = shape.animation.start_cy4;
	                        } else {
	                            if (shape.animation.rotation_type > 1 && targets.start.cy4 && targets.end.cy4) {
	                                animation.cy4 = this.getCurrentValueForRotation(targets.start.cx4, targets.start.cy4, targets.end.cx4, targets.end.cy4, false);
	                            } else if (targets.start.cy4 && targets.end.cy4 && targets.start.cy4 !== targets.end.cy4) animation.cy4 = this.getCurrentValue(targets.start.cy4, targets.end.cy4, targets.segmentsLength, targets.currentSegment);
	                        }
	
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cx5) animation.cx5 = shape.animation.start_cx5;
	                        } else {
	                            if (shape.animation.rotation_type > 1 && targets.start.cx5 && targets.end.cx5) {
	                                animation.cx5 = this.getCurrentValueForRotation(targets.start.cx5, targets.start.cy5, targets.end.cx5, targets.end.cy5, true);
	                            } else if (targets.start.cx5 && targets.end.cx5 && targets.start.cx5 !== targets.end.cx5) animation.cx5 = this.getCurrentValue(targets.start.cx5, targets.end.cx5, targets.segmentsLength, targets.currentSegment);
	                        }
	
	                        if (setInitialPosition) {
	                            if (shape.animation.start_cy5) animation.cy5 = shape.animation.start_cy5;
	                        } else {
	                            if (shape.animation.rotation_type > 1 && targets.start.cy5 && targets.end.cy5) {
	                                animation.cy5 = this.getCurrentValueForRotation(targets.start.cx5, targets.start.cy5, targets.end.cx5, targets.end.cy5, false);
	                            } else if (targets.start.cy5 && targets.end.cy5 && targets.start.cy5 !== targets.end.cy5) animation.cy5 = this.getCurrentValue(targets.start.cy5, targets.end.cy5, targets.segmentsLength, targets.currentSegment);
	                        }
	                    }
	
	                    if (shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE || shape.type == _ShapeConstants2.default.TEXTBOX || shape.type == _ShapeConstants2.default.TEXTBOXSIMPLE) {
	                        if (setInitialPosition) {
	                            if (shape.animation.start_fontSize) animation.fontSize = shape.animation.start_fontSize;
	                        } else {
	                            if (targets.start.fontSize && targets.end.fontSize && targets.start.fontSize !== targets.end.fontSize) animation.fontSize = this.getCurrentValue(targets.start.fontSize, targets.end.fontSize, targets.segmentsLength, targets.currentSegment);
	                        }
	                    }
	                }
	
	                if (setInitialPosition) {
	                    if (shape.animation.start_opacity >= 0) animation.opacity = shape.animation.start_opacity;
	                } else {
	                    if (!isNaN(targets.start.opacity) && !isNaN(targets.end.opacity) && targets.start.opacity !== targets.end.opacity) animation.opacity = this.getCurrentValue(targets.start.opacity, targets.end.opacity, targets.segmentsLength, targets.currentSegment);
	                }
	
	                if (setInitialPosition) {
	                    if (shape.animation.start_rotation >= 0) animation.rotation = shape.animation.start_rotation;
	                } else {
	                    if (shape.animation.rotation_type === 2) {
	                        // rotation around external point but not rotating object
	                        if (shape.animation.start_rotation >= 0) animation.rotation = shape.animation.start_rotation;
	                    } else if (!isNaN(targets.start.rotation) && !isNaN(targets.end.rotation) && targets.start.rotation !== targets.end.rotation) animation.rotation = this.getCurrentValue(targets.start.rotation, targets.end.rotation, targets.segmentsLength, targets.currentSegment);
	                }
	
	                animatedShapes.push(shape.uuid);
	                animations[shape.uuid] = animation;
	            }
	        }
	
	        if (animatedShapes.length > 0) dispatch((0, _CurrentSlideActions.animate)(animatedShapes, animations));
	
	        if (setInitialPosition) dispatch((0, _ProductionActions.updateCurrentSlide)());
	    },
	    getCurrentValue: function getCurrentValue(startVal, endVal, segmentsLength, currentSegment) {
	        var dif = endVal - startVal;
	        var totalTime = this.totalTime / segmentsLength;
	        var currentTime = this.currentTime - currentSegment * totalTime;
	        var position = currentTime * dif / totalTime;
	
	        return startVal + position;
	    },
	    getInitialAngle: function getInitialAngle(x, y, centerX, centerY) {
	        var angle = 0;
	        var sinAlpha = void 0;
	        var radius = Math.sqrt((centerX - x) * (centerX - x) + (centerY - y) * (centerY - y)); // distance between 2 points
	
	        switch (true) {
	            case centerY === y && x > centerX:
	                {
	                    angle = 0;
	                    break;
	                }
	            case centerX === x && y < centerY:
	                {
	                    angle = 90;
	                    break;
	                }
	            case centerY === y && x < centerX:
	                {
	                    angle = 180;
	                    break;
	                }
	            case centerX === x && y > centerY:
	                {
	                    angle = 270;
	                    break;
	                }
	
	            case y > centerY && x > centerX:
	                {
	                    // C1
	                    sinAlpha = Math.abs(y - centerY) / radius;
	                    angle = Math.asin(sinAlpha);
	                    angle = angle * 180 / Math.PI; // convert from radians to degrees
	                    break;
	                }
	            case x < centerX && y < centerY:
	                {
	                    // C2
	                    sinAlpha = Math.abs(y - centerY) / radius;
	                    angle = Math.asin(sinAlpha);
	                    angle = 90 + angle * 180 / Math.PI; // convert from radians to degrees
	                    break;
	                }
	            case y > centerY && x < centerX:
	                {
	                    // C3
	                    sinAlpha = Math.abs(y - centerY) / radius;
	                    angle = Math.asin(sinAlpha);
	                    angle = 180 + angle * 180 / Math.PI; // convert from radians to degrees
	                    break;
	                }
	            case x > centerX && y > centerY:
	                {
	                    // C4
	                    sinAlpha = Math.abs(y - centerY) / radius;
	                    angle = Math.asin(sinAlpha);
	                    angle = 270 + angle * 180 / Math.PI; // convert from radians to degrees
	                    break;
	                }
	        }
	
	        return angle;
	    },
	    getCurrentValueForRotation: function getCurrentValueForRotation(x, y, centerX, centerY) {
	        var isX = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	        var dif = 360; // degrees
	        var stepAngle = this.currentTime * dif / this.totalTime;
	        var initialAngle = this.getInitialAngle(x, y, centerX, centerY);
	        var radius = Math.sqrt((centerX - x) * (centerX - x) + (centerY - y) * (centerY - y)); // distance between 2 points
	        var xDif = void 0;
	        var yDif = void 0;
	        var newPoint = {};
	        var currentAngle = initialAngle - stepAngle;
	        var radians = void 0;
	
	        if (currentAngle < 0) currentAngle = 360 + currentAngle;else if (currentAngle > 360) currentAngle = 360 - currentAngle;
	
	        switch (true) {
	            case currentAngle >= 0 && currentAngle < 90:
	                {
	                    // C1
	                    radians = Math.PI * currentAngle / 180;
	                    xDif = radius * Math.cos(radians);
	                    yDif = radius * Math.sin(radians);
	                    newPoint.x = centerX + xDif;
	                    newPoint.y = centerY - yDif;
	                    break;
	                }
	            case currentAngle >= 90 && currentAngle < 180:
	                {
	                    // C2
	                    currentAngle = 180 - currentAngle;
	                    radians = Math.PI * currentAngle / 180;
	                    xDif = radius * Math.cos(radians);
	                    yDif = radius * Math.sin(radians);
	                    newPoint.x = centerX - xDif;
	                    newPoint.y = centerY - yDif;
	                    break;
	                }
	            case currentAngle >= 180 && currentAngle < 270:
	                {
	                    // C3
	                    currentAngle = currentAngle - 180;
	                    radians = Math.PI * currentAngle / 180;
	                    xDif = radius * Math.cos(radians);
	                    yDif = radius * Math.sin(radians);
	                    newPoint.x = centerX - xDif;
	                    newPoint.y = centerY + yDif;
	                    break;
	                }
	            case currentAngle >= 270 && currentAngle < 360:
	                {
	                    // C4
	                    currentAngle = 360 - currentAngle;
	                    radians = Math.PI * currentAngle / 180;
	                    xDif = radius * Math.cos(radians);
	                    yDif = radius * Math.sin(radians);
	                    newPoint.x = centerX + xDif;
	                    newPoint.y = centerY + yDif;
	                    break;
	                }
	        }
	
	        if (isNaN(newPoint.x) || isNaN(newPoint.y)) {
	            newPoint = {};
	            newPoint.x = x;
	            newPoint.y = y;
	        }
	
	        if (isX) return newPoint.x;else return newPoint.y;
	    },
	    getLineProperties: function getLineProperties(x1, y1, x2, y2) {
	        var distance = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
	        var centerX = (x1 + x2) / 2;
	        var centerY = (y1 + y2) / 2;
	
	        var angle = Math.atan2(y1 - y2, x1 - x2);
	        var angleDegrees = angle * 180 / Math.PI;
	
	        var properties = {};
	
	        properties.width = distance;
	        properties.height = 4;
	        properties.top = centerY;
	        properties.left = centerX - distance / 2;
	        properties.rotation = angleDegrees;
	
	        return properties;
	    },
	    getAllAnimationTargets: function getAllAnimationTargets() {
	        var includeOriginal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        var clones = [];
	
	        if (!animationManager.clone) return clones;
	
	        if (includeOriginal) clones.push(animationManager.target);
	
	        clones.push(animationManager.clone);
	        clones = clones.concat(animationManager.clonesArray);
	
	        return clones;
	    },
	    replaceClone: function replaceClone(newShape) {
	        if (animationManager.clone && animationManager.clone.uuid === newShape.uuid) {
	            animationManager.clone = newShape;
	            return;
	        }
	
	        var clones = animationManager.clonesArray;
	
	        for (var i = 0; i < clones.length; i++) {
	            if (clones[i].uuid === newShape.uuid) clones[i] = newShape;
	        }
	    },
	    getCloneByUid: function getCloneByUid(uuid) {
	        var clones = animationManager.clonesArray;
	
	        for (var i = 0; i < clones.length; i++) {
	            if (clones[i].uuid === uuid) return clones[i];
	        }
	
	        return undefined;
	    },
	    onAddKeyHandler: function onAddKeyHandler(e) {
	        if (e.keyCode === 13) animationManager.onAddClick();
	    },
	    onAddClick: function onAddClick(e) {
	        if (e && _MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var shape = void 0;
	        var dispatch = animationManager.getDispatch();
	
	        if (animationManager.clonesArray.length > 0) shape = animationManager.clonesArray[animationManager.clonesArray.length - 1];else shape = animationManager.clone;
	        dispatch((0, _CurrentSlideActions.selectShape)(''));
	
	        var duplicatedShape = animationManager.duplicateShape(shape, undefined, undefined, true);
	
	        animationManager.clonesArray.push(duplicatedShape);
	        dispatch((0, _MenuActions.updateCurrentSlideContent)(Math.random()));
	        dispatch((0, _MenuActions.refreshShapePosition)(duplicatedShape.uuid));
	    },
	    onDeleteKeyHandler: function onDeleteKeyHandler(e) {
	        if (e.keyCode === 13) animationManager.onDeleteClick();
	    },
	    onDeleteClick: function onDeleteClick(e) {
	        if (e && _MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        animationManager.deleteClones();
	    },
	    deleteClones: function deleteClones() {
	        var deleteAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var dispatch = animationManager.getDispatch();
	        var shapeUuid = '';
	
	        if (animationManager.clonesArray.length > 0) {
	            if (deleteAll) animationManager.clonesArray = [];else {
	                animationManager.clonesArray = animationManager.clonesArray.slice(0, -1);
	
	                if (animationManager.clonesArray.length > 0) {
	                    shapeUuid = animationManager.clonesArray[animationManager.clonesArray.length - 1].uuid;
	                    dispatch((0, _CurrentSlideActions.selectShape)(shapeUuid));
	                } else if (animationManager.clone) {
	                    shapeUuid = animationManager.clone.uuid;
	                    dispatch((0, _CurrentSlideActions.selectShape)(shapeUuid));
	                }
	            }
	
	            dispatch((0, _MenuActions.updateCurrentSlideContent)(Math.random()));
	            dispatch((0, _MenuActions.refreshShapePosition)(shapeUuid));
	        }
	    },
	    getLine: function getLine(target, clone, index, length) {
	        var centerA = target.type == _ShapeConstants2.default.LINE || target.type == _ShapeConstants2.default.CURVE ? { x: Math.min(target.x1, target.x2) + Math.abs(target.x1 - target.x2) / 2, y: Math.min(target.y1, target.y2) + Math.abs(target.y1 - target.y2) / 2 } : { x: target.x + target.width / 2, y: target.y + target.height / 2 };
	        var centerB = clone.type == _ShapeConstants2.default.LINE || clone.type == _ShapeConstants2.default.CURVE ? { x: Math.min(clone.x1, clone.x2) + Math.abs(clone.x1 - clone.x2) / 2, y: Math.min(clone.y1, clone.y2) + Math.abs(clone.y1 - clone.y2) / 2 } : { x: clone.x + clone.width / 2, y: clone.y + clone.height / 2 };
	        var lineProperties = this.getLineProperties(centerA.x - 2, centerA.y - 2, centerB.x - 2, centerB.y - 2);
	        var radius = 15;
	        var addButtonRadius = _PlatformDetection2.default.isIOS() ? radius * 0.75 : radius * 0.5;
	        var letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
	
	        var textStyle = {
	            fontSize: 19,
	            fontWeight: 'bold',
	            color: 'black',
	            paddingLeft: 8,
	            paddingTop: 5,
	            zIndex: 1000
	        };
	        return _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement(
	                'g',
	                { pointerEvents: 'none' },
	                _react2.default.createElement(
	                    'g',
	                    { transform: 'translate(' + lineProperties.left + ' ' + lineProperties.top + ')' },
	                    _react2.default.createElement(
	                        'g',
	                        { transform: 'rotate(' + lineProperties.rotation + ' ' + lineProperties.width / 2 + ' ' + lineProperties.height / 2 + ')' },
	                        _react2.default.createElement('rect', {
	                            x: 0,
	                            y: 0,
	                            width: lineProperties.width,
	                            height: lineProperties.height,
	                            fill: '#dd5052'
	                        }),
	                        ';'
	                    )
	                ),
	                _react2.default.createElement('circle', { cx: centerA.x, cy: centerA.y, r: radius, fill: '#dd5052' }),
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: centerA.x - radius, y: centerA.y - radius, width: radius * 2, height: radius * 2 },
	                    _react2.default.createElement(
	                        'div',
	                        { style: textStyle },
	                        letters[index]
	                    )
	                ),
	                _react2.default.createElement('circle', { cx: centerB.x, cy: centerB.y, r: radius, fill: '#dd5052' }),
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: centerB.x - radius, y: centerB.y - radius, width: radius * 2, height: radius * 2 },
	                    _react2.default.createElement(
	                        'div',
	                        { style: textStyle },
	                        letters[index + 1]
	                    )
	                )
	            ),
	            window.location.href.indexOf('stage') !== -1 || window.location.href.indexOf('local') !== -1 ? _react2.default.createElement(
	                'g',
	                null,
	                index === length - 2 ? _react2.default.createElement(
	                    'g',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#', onClick: this.onAddClick, onTouchEnd: this.onAddClick, onKeyDown: this.onAddKeyHandler },
	                        _react2.default.createElement('circle', { cx: centerB.x + radius, cy: centerB.y + radius, r: addButtonRadius,
	                            fill: _TransformToolUtils.uiProperties.ROTATE_FILL_INACTIVE, strokeWidth: _TransformToolUtils.uiProperties.STROKE,
	                            stroke: _TransformToolUtils.uiProperties.ROTATE_STROKE_INACTIVE }),
	                        _react2.default.createElement('image', { xlinkHref: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg',
	                            x: centerB.x + radius - addButtonRadius, y: centerB.y + radius - addButtonRadius, width: 2 * addButtonRadius, height: 2 * addButtonRadius,
	                            preserveAspectRatio: 'none', pointerEvents: 'none' })
	                    )
	                ) : null,
	                index === length - 2 && index > 0 ? _react2.default.createElement(
	                    'g',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#', onClick: this.onDeleteClick, onTouchEnd: this.onDeleteClick, onKeyDown: this.onDeleteKeyHandler },
	                        _react2.default.createElement('circle', { cx: centerB.x - radius, cy: centerB.y + radius, r: addButtonRadius, fill: '#ff0000',
	                            strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: _TransformToolUtils.uiProperties.ROTATE_STROKE_ACTIVE }),
	                        _react2.default.createElement('image', { xlinkHref: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/textEditor/minus.svg',
	                            x: centerB.x - radius - addButtonRadius, y: centerB.y + radius - addButtonRadius, width: 2 * addButtonRadius, height: 2 * addButtonRadius,
	                            preserveAspectRatio: 'none', pointerEvents: 'none' })
	                    )
	                ) : null
	            ) : null
	        );
	    }
	};
	
	exports.default = animationManager;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/AnimationManager.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/AnimationManager.js"); } } })();

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    CHARACTER: 'Character',
	    IMAGE: 'Image',
	    BACKGROUND: 'Background',
	    RECTANGLE: 'Rectangle',
	    ELLIPSE: 'Ellipse',
	    LINE: 'Line',
	    CURVE: 'Curve',
	    FREEHAND: 'Freehand',
	    AUDIO: 'Audio',
	    TEXTBOX: 'TextBox',
	    TEXTBOXSIMPLE: 'TextBoxSimple',
	    SPEAK_BUBBLE: 'SpeakBubble',
	    COMPLEX_SPEAK_BUBBLE: 'ComplexSpeakBubble',
	    THOUGHT_BUBBLE: 'ThoughtBubble',
	    SCREAM_BUBBLE: 'ScreamBubble',
	    TRIANGLE: 'Triangle',
	    STAR: 'Star',
	    HEART: 'Heart',
	    VIDEO: 'Video',
	    GROUP: 'Group'
	};
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/constants/ShapeConstants.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/constants/ShapeConstants.js"); } } })();

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(66);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 30 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textSizeUtils = {
	    searchText: '',
	    textArea: undefined,
	    initTextArea: function initTextArea() {
	        if (this.textArea == undefined) {
	            this.textArea = document.createElement('textArea');
	            document.body.appendChild(this.textArea);
	        }
	    },
	    isValidSize: function isValidSize(y, newHeight) {
	        return true; // added for CH-875
	
	        if (_PlatformDetection2.default.isIOS()) return true;
	
	        if (y + newHeight > _Configuration2.default.CANVAS_HEIGHT + 10) return false;else return true;
	    },
	    updateTextWrapperSize: function updateTextWrapperSize(shapeModel, dispatch, isTextAdded) {
	        if (!shapeModel) return;
	
	        if (isTextAdded && shapeModel.width < _Properties2.default.TEXT_WIDTH * 1.6) {
	            if (_PlatformDetection2.default.isIOS()) {
	                var newWidth = 0;
	                var textLength = shapeModel.htmlText.length;
	
	                if (textLength <= 10) newWidth = 0;else {
	                    if (textLength >= 19) newWidth = _Properties2.default.TEXT_WIDTH * 1.6;else newWidth = shapeModel.width + 10 * (textLength - 10);
	                }
	
	                if (newWidth > 0) {
	                    dispatch((0, _CurrentSlideActions.updateTextHeight)(shapeModel.uuid, 0, newWidth));
	                    _SaveManager2.default.isContentChanged(true);
	                }
	            } else {
	                dispatch((0, _CurrentSlideActions.updateTextHeight)(shapeModel.uuid, 0, shapeModel.width + 10));
	                _SaveManager2.default.isContentChanged(true);
	            }
	        } else {
	            this.initTextArea();
	
	            this.setTextAreaProperties(this.textArea, shapeModel);
	
	            var height = this.textArea.scrollHeight;
	
	            if (height > 0) {
	                var newHeight = height + 2 * _Properties2.default.TEXT_PADDING + 2 * _Properties2.default.TEXT_INNER_PADDING + 10;
	
	                if (this.isValidSize(shapeModel.y, newHeight)) {
	                    dispatch((0, _CurrentSlideActions.updateTextHeight)(shapeModel.uuid, newHeight));
	                    _SaveManager2.default.isContentChanged(true);
	                } else {
	                    document.activeElement.blur();
	                }
	            }
	
	            if (_PlatformDetection2.default.isIOS()) {
	                document.body.removeChild(this.textArea);
	                this.textArea = undefined;
	            }
	        }
	    },
	
	    count: 0,
	    getFontSize: function getFontSize(shapeModel, newWidth, newHeight, startWidth, startHeight) {
	        // used to detect the maximum font size for a text wrapped in a specified area
	        if (shapeModel.isRichText) return this.currentFontSize;else return this.getFontSizeOld(shapeModel, newWidth, newHeight, startWidth, startHeight);
	    },
	    getFontSizeOld: function getFontSizeOld(shapeModel, newWidth, newHeight, startWidth, startHeight) {
	        this.initTextArea();
	
	        this.setTextAreaProperties(this.textArea, shapeModel);
	
	        var initialFontSize = shapeModel.fontSize;
	        var currentArea;
	
	        if (startWidth > 0) currentArea = startWidth * startHeight;else currentArea = shapeModel.width * shapeModel.height;
	
	        var newArea = newWidth * newHeight;
	        var i;
	        var newFontSize = -1;
	        var availableHeight = newHeight - 2 * _Properties2.default.TEXT_INNER_PADDING - 2 * _Properties2.default.TEXT_PADDING - 5;
	
	        if (currentArea > newArea) {
	            for (i = initialFontSize; i > _Properties2.default.MIN_FONT_SIZE; i--) {
	                this.textArea.style.fontSize = i + 'px';
	
	                if (this.textArea.scrollHeight <= availableHeight) {
	                    newFontSize = i;
	                    break;
	                }
	            }
	        } else {
	            for (i = initialFontSize + 1; i < _Properties2.default.MAX_FONT_SIZE; i++) {
	                this.textArea.style.fontSize = i + 'px';
	
	                if (this.textArea.scrollHeight >= availableHeight) {
	                    newFontSize = i - 1;
	                    break;
	                }
	            }
	        }
	
	        if (_PlatformDetection2.default.isIOS()) {
	            document.body.removeChild(this.textArea);
	            this.textArea = undefined;
	        }
	
	        return newFontSize;
	    },
	    updateFontSize: function updateFontSize(shapeModel, newWidth, newHeight, dispatch, endResize, startWidth, startHeight) {
	        if (shapeModel.isRichText) return;
	
	        if (_PlatformDetection2.default.isEdge() == true) {
	            if (endResize == true) {
	                this.count = 0;
	            } else {
	                this.count = this.count + 1;
	
	                if (this.count < 5) return;
	
	                this.count = 0;
	            }
	        }
	
	        var initialFontSize = shapeModel.fontSize;
	        var newFontSize = this.getFontSize(shapeModel, newWidth, newHeight, startWidth, startHeight);
	
	        if (newFontSize > 0 && initialFontSize != newFontSize) {
	            dispatch((0, _CurrentSlideActions.changeTextProperties)(shapeModel, 'fontSize', newFontSize));
	            _SaveManager2.default.isContentChanged(true);
	        }
	    },
	    setTextAreaProperties: function setTextAreaProperties(textArea, shapeModel) {
	        if (!shapeModel) return;
	
	        var bold = shapeModel.fontBold ? 'bold' : 'normal';
	        var italic = shapeModel.fontItalic ? 'italic' : 'normal';
	
	        textArea.style.width = shapeModel.width - 2 * _Properties2.default.TEXT_PADDING - 2 * _Properties2.default.TEXT_INNER_PADDING + 'px';
	        textArea.style.height = '5px';
	        textArea.style.overflow = 'hidden';
	        textArea.style.border = 'none';
	        textArea.style.outline = 'none';
	        textArea.style.padding = '0px';
	        textArea.style.fontSize = shapeModel.fontSize + 'px';
	        textArea.style.fontFamily = shapeModel.fontFamily;
	        textArea.style.fontStyle = italic;
	        textArea.style.fontWeight = bold;
	        textArea.style.textAlign = shapeModel.fontAlign;
	        textArea.style.opacity = 0;
	        textArea.style.padding = _Properties2.default.TEXT_INNER_PADDING;
	
	        var textProperties = this.textProperties(shapeModel);
	        textArea.style.lineHeight = textProperties.lineHeight;
	        textArea.style.wordSpacing = textProperties.wordSpacing;
	        textArea.textIdent = textProperties.textIdent;
	        textArea.letterSpacing = textProperties.letterSpacing;
	
	        textArea.value = shapeModel.htmlText;
	    },
	    getSpanWidth: function getSpanWidth(fontSize, text) {
	        var width;
	        var divElement = document.createElement('div');
	        document.body.appendChild(divElement);
	
	        divElement.style.position = 'absolute';
	        divElement.style.width = 'auto';
	        divElement.style.height = 'auto';
	        divElement.style.whiteSpace = 'nowrap';
	        divElement.style.fontSize = fontSize + 'px';
	        divElement.innerHTML = text;
	
	        width = divElement.clientWidth + 2;
	
	        document.body.removeChild(divElement);
	
	        return width;
	    },
	    getTextHeight: function getTextHeight(text, width, fontSize) {
	        return 30;
	    },
	    getTextAreaHeight: function getTextAreaHeight(text, width, fontSize) {
	        var height;
	        var divElement = document.createElement('textArea');
	        document.body.appendChild(divElement);
	
	        divElement.style.width = width + 'px';
	        divElement.style.height = '5px';
	        divElement.style.overflow = 'hidden';
	        divElement.style.border = 'none';
	        divElement.style.outline = 'none';
	        divElement.style.padding = '0px';
	        divElement.style.whiteSpace = 'nowrap';
	        divElement.style.fontSize = fontSize + 'px';
	        divElement.value = text;
	
	        var limit = divElement.scrollWidth % width;
	        var offset = 0;
	
	        if (limit > 20) offset = 1;
	
	        height = (Math.floor(divElement.scrollWidth / width) + offset) * 17;
	
	        document.body.removeChild(divElement);
	
	        return height;
	    },
	    textProperties: function textProperties(shapeModel) {
	        var properties = {};
	
	        properties.wordSpacing = -1;
	        properties.textIdent = 0;
	        properties.letterSpacing = 0;
	
	        if (shapeModel.lineHeight && shapeModel.lineHeight > 0) properties.lineHeight = shapeModel.lineHeight;else properties.lineHeight = 1.25;
	
	        properties.extraPadding = 2;
	
	        if (_PlatformDetection2.default.isEdge() || _PlatformDetection2.default.isFirefox() || _PlatformDetection2.default.isSafari()) properties.extraPadding = 5;
	
	        return properties;
	    },
	    correctRecordingTitle: function correctRecordingTitle(title) {
	        if (!title) return title;
	
	        if (title.indexOf('.mp3') != -1) title = title.replace('.mp3', '');
	
	        if (title.indexOf('January') != -1) title = title.replace('January', 'Jan');
	
	        if (title.indexOf('February') != -1) title = title.replace('February', 'Feb');
	
	        if (title.indexOf('March') != -1) title = title.replace('March', 'Mar');
	
	        if (title.indexOf('April') != -1) title = title.replace('April', 'Apr');
	
	        if (title.indexOf('June') != -1) title = title.replace('June', 'Jun');
	
	        if (title.indexOf('July') != -1) title = title.replace('July', 'Jul');
	
	        if (title.indexOf('August') != -1) title = title.replace('August', 'Aug');
	
	        if (title.indexOf('September') != -1) title = title.replace('September', 'Sep');
	
	        if (title.indexOf('October') != -1) title = title.replace('October', 'Oct');
	
	        if (title.indexOf('November') != -1) title = title.replace('November', 'Nov');
	
	        if (title.indexOf('December') != -1) title = title.replace('December', 'Dec');
	
	        return title;
	    },
	    isTextEditMode: function isTextEditMode() {
	        if (_PlatformDetection2.default.isIOS()) {
	            var activeElement = document.activeElement;
	
	            if (activeElement && (activeElement.className.indexOf('textShapes') != -1 || activeElement.className.indexOf('titleInput') != -1)) return true;else return false;
	        } else return false;
	    },
	    getHtmlText: function getHtmlText(shapeModel) {
	        if (shapeModel.isRichText) return shapeModel.htmlText;else {
	            var htmlText = '';
	
	            if (shapeModel.htmlText.length < 1) return '';
	
	            if (shapeModel.fontAlign != 'left') htmlText = htmlText + '<div style="text-align:' + shapeModel.fontAlign + ';">';
	
	            htmlText = htmlText + '<font face="' + shapeModel.fontFamily + '" color="' + shapeModel.fontColor + '">';
	
	            if (shapeModel.fontBold == true) htmlText = htmlText + '<b>';
	
	            if (shapeModel.fontItalic == true) htmlText = htmlText + '<i>';
	
	            if (shapeModel.fontUnderline == true) htmlText = htmlText + '<u>';
	
	            htmlText = htmlText + shapeModel.htmlText;
	
	            if (shapeModel.fontUnderline == true) htmlText = htmlText + '</u>';
	
	            if (shapeModel.fontItalic == true) htmlText = htmlText + '</i>';
	
	            if (shapeModel.fontBold == true) htmlText = htmlText + '</b>';
	
	            htmlText = htmlText + '</font>';
	
	            if (shapeModel.fontAlign != 'left') htmlText = htmlText + '</div>';
	
	            return htmlText;
	        }
	    },
	    componentToHex: function componentToHex(c) {
	        var hex = c.toString(16);
	        return hex.length == 1 ? "0" + hex : hex;
	    },
	    rgbToHex: function rgbToHex(r, g, b) {
	        return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
	    },
	    getHexaColor: function getHexaColor(rgbColor) {
	        rgbColor = rgbColor.replace('rgb(', '');
	        rgbColor = rgbColor.replace(')', '');
	        var array = rgbColor.split(',');
	
	        return this.rgbToHex(parseInt(array[0]), parseInt(array[1]), parseInt(array[2]));
	    },
	    getCorrectColor: function getCorrectColor(color) {
	        if (!color) return '#ffffff';
	
	        if (color && color.indexOf('rgb(') != -1) color = this.getHexaColor(color);
	
	        color = color.toLowerCase();
	
	        return color;
	    }
	};
	
	exports.default = textSizeUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/TextSizeUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/TextSizeUtils.js"); } } })();

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.types = undefined;
	exports.loadOldProduction = loadOldProduction;
	exports.loadNewProduction = loadNewProduction;
	exports.loadAudioProduction = loadAudioProduction;
	exports.contentXMLLoaded = contentXMLLoaded;
	exports.addSlide = addSlide;
	exports.updateCurrentSlide = updateCurrentSlide;
	exports.changeSlidePosition = changeSlidePosition;
	exports.shiftSlide = shiftSlide;
	exports.duplicateSlide = duplicateSlide;
	exports.duplicateSlideAtEndOfAnimation = duplicateSlideAtEndOfAnimation;
	exports.deleteSlide = deleteSlide;
	exports.setWindowSize = setWindowSize;
	exports.changeMode = changeMode;
	exports.setSlideCloneTarget = setSlideCloneTarget;
	exports.cloneSlide = cloneSlide;
	exports.productionUndoRedoAction = productionUndoRedoAction;
	exports.addStorySound = addStorySound;
	exports.changeStorySoundVolume = changeStorySoundVolume;
	exports.updateProductionMoods = updateProductionMoods;
	exports.changeSlideProperty = changeSlideProperty;
	exports.addSplittedSlide = addSplittedSlide;
	exports.setExportProperties = setExportProperties;
	
	var _CartoonistXMLParser = __webpack_require__(867);
	
	var types = exports.types = {
	    ADD_SLIDE: 'add_slide',
	    LOADED_OLD_PRODUCTION: 'loaded_old_production',
	    LOADED_NEW_PRODUCTION: 'loaded_new_production',
	    CONTENT_XML_LOADED: 'content_xml_loaded',
	    UPDATE_CURRENT_SLIDE: 'update_current_slide',
	    CHANGE_SLIDE_POSITION: 'change_slide_position',
	    DUPLICATE_SLIDE: 'duplicate_slide',
	    DUPLICATE_SLIDE_END_ANIMATION: 'duplicate_slide_end_animation',
	    DELETE_SLIDE: 'delete_slide',
	    SET_WINDOW_SIZE: 'set_window_size',
	    CHANGE_MODE: 'change_mode',
	    SHIFT_SLIDE: 'shift_slide',
	    SET_SLIDE_CLONE_TARGET: 'set_slide_clone_target',
	    CLONE_SLIDE: 'clone_slide',
	    PRODUCTION_UNDO_REDO_ACTION: 'production_undo_redo_action',
	    ADD_STORY_SOUND: 'add_story_sound',
	    CHANGE_STORY_SOUND_VOLUME: 'change_story_sound_volume',
	    UPDATE_PRODUCTION_MOODS: 'update_production_moods',
	    CHANGE_SLIDE_PROPERTY: 'change_slide_property',
	    ADD_SPLITTED_SLIDE: 'add_splitted_slide',
	    SET_EXPORT_PROPERTIES: 'set_exporter_properties'
	};
	
	function loadOldProduction() {
	    var production = (0, _CartoonistXMLParser.loadOldContent)();
	    return { type: types.LOADED_OLD_PRODUCTION, production: production };
	}
	
	function loadNewProduction(data) {
	    var production = (0, _CartoonistXMLParser.loadNewContent)(data);
	    return { type: types.LOADED_NEW_PRODUCTION, production: production };
	}
	
	function loadAudioProduction(data) {
	    var production = (0, _CartoonistXMLParser.loadAudioContent)(data);
	    return { type: types.LOADED_NEW_PRODUCTION, production: production };
	}
	
	function contentXMLLoaded(data) {
	    return { type: types.CONTENT_XML_LOADED, data: data };
	}
	
	function addSlide(index) {
	    return { type: types.ADD_SLIDE, index: index };
	}
	
	function updateCurrentSlide() {
	    return { type: types.UPDATE_CURRENT_SLIDE };
	}
	
	function changeSlidePosition(startPosition, endPosition) {
	    return { type: types.CHANGE_SLIDE_POSITION, startPosition: startPosition, endPosition: endPosition };
	}
	
	function shiftSlide(isLeft, currentPosition) {
	    return { type: types.SHIFT_SLIDE, isLeft: isLeft, currentPosition: currentPosition };
	}
	
	function duplicateSlide() {
	    return { type: types.DUPLICATE_SLIDE };
	}
	
	function duplicateSlideAtEndOfAnimation() {
	    return { type: types.DUPLICATE_SLIDE_END_ANIMATION };
	}
	
	function deleteSlide() {
	    return { type: types.DELETE_SLIDE };
	}
	
	function setWindowSize(width, height) {
	    return { type: types.SET_WINDOW_SIZE, width: width, height: height };
	}
	
	function changeMode(mode) {
	    return { type: types.CHANGE_MODE, mode: mode };
	}
	
	function setSlideCloneTarget(slide) {
	    return { type: types.SET_SLIDE_CLONE_TARGET, slide: slide };
	}
	
	function cloneSlide(target) {
	    return { type: types.CLONE_SLIDE, target: target };
	}
	
	function productionUndoRedoAction(newState) {
	    return { type: types.PRODUCTION_UNDO_REDO_ACTION, newState: newState };
	}
	
	function addStorySound(audioItem) {
	    return { type: types.ADD_STORY_SOUND, audioItem: audioItem };
	}
	
	function changeStorySoundVolume(volume) {
	    return { type: types.CHANGE_STORY_SOUND_VOLUME, volume: volume };
	}
	
	function updateProductionMoods() {
	    return { type: types.UPDATE_PRODUCTION_MOODS };
	}
	
	function changeSlideProperty(uuid, propertyType, propertyValue) {
	    return { type: types.CHANGE_SLIDE_PROPERTY, uuid: uuid, propertyType: propertyType, propertyValue: propertyValue };
	}
	
	function addSplittedSlide(index, videoModel) {
	    return { type: types.ADD_SPLITTED_SLIDE, index: index, videoModel: videoModel };
	}
	
	function setExportProperties(properties) {
	    return { type: types.SET_EXPORT_PROPERTIES, properties: properties };
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/actions/ProductionActions.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/actions/ProductionActions.js"); } } })();

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	var es5 = __webpack_require__(112);
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var l = 8;
	    while (l--) new FakeConstructor();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj instanceof Error ||
	        (obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string");
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	var hasEnvVariables = typeof process !== "undefined" &&
	    typeof process.env !== "undefined";
	
	function env(key) {
	    return hasEnvVariables ? process.env[key] : undefined;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	function domainBind(self, cb) {
	    return self.bind(cb);
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    hasEnvVariables: hasEnvVariables,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise,
	    domainBind: domainBind
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(90)))

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(157)('wks');
	var uid = __webpack_require__(105);
	var Symbol = __webpack_require__(24).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(301));
		else if(typeof define === 'function' && define.amd)
			define(["react", "react-dom"], factory);
		else if(typeof exports === 'object')
			exports["ReactDraggable"] = factory(require("react"), require("react-dom"));
		else
			root["ReactDraggable"] = factory(root["React"], root["ReactDOM"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_11__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		module.exports = __webpack_require__(1).default;
		module.exports.DraggableCore = __webpack_require__(17).default;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _propTypes = __webpack_require__(3);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _reactDom = __webpack_require__(11);
		
		var _reactDom2 = _interopRequireDefault(_reactDom);
		
		var _classnames = __webpack_require__(12);
		
		var _classnames2 = _interopRequireDefault(_classnames);
		
		var _domFns = __webpack_require__(13);
		
		var _positionFns = __webpack_require__(16);
		
		var _shims = __webpack_require__(14);
		
		var _DraggableCore = __webpack_require__(17);
		
		var _DraggableCore2 = _interopRequireDefault(_DraggableCore);
		
		var _log = __webpack_require__(19);
		
		var _log2 = _interopRequireDefault(_log);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		// $FlowIgnore
		
		
		/*:: import type {DraggableEventHandler} from './utils/types';*/
		/*:: type DraggableState = {
		  dragging: boolean,
		  dragged: boolean,
		  x: number, y: number,
		  slackX: number, slackY: number,
		  isElementSVG: boolean
		};*/
		
		
		//
		// Define <Draggable>
		//
		
		/*:: type ConstructorProps = {
		  position: { x: number, y: number },
		  defaultPosition: { x: number, y: number }
		};*/
		
		var Draggable = function (_React$Component) {
		  _inherits(Draggable, _React$Component);
		
		  function Draggable(props /*: ConstructorProps*/) {
		    _classCallCheck(this, Draggable);
		
		    var _this = _possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));
		
		    _this.onDragStart = function (e, coreData) {
		      (0, _log2.default)('Draggable: onDragStart: %j', coreData);
		
		      // Short-circuit if user's callback killed it.
		      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_this, coreData));
		      // Kills start event on core as well, so move handlers are never bound.
		      if (shouldStart === false) return false;
		
		      _this.setState({ dragging: true, dragged: true });
		    };
		
		    _this.onDrag = function (e, coreData) {
		      if (!_this.state.dragging) return false;
		      (0, _log2.default)('Draggable: onDrag: %j', coreData);
		
		      var uiData = (0, _positionFns.createDraggableData)(_this, coreData);
		
		      var newState /*: $Shape<DraggableState>*/ = {
		        x: uiData.x,
		        y: uiData.y
		      };
		
		      // Keep within bounds.
		      if (_this.props.bounds) {
		        // Save original x and y.
		        var _x = newState.x,
		            _y = newState.y;
		
		        // Add slack to the values used to calculate bound position. This will ensure that if
		        // we start removing slack, the element won't react to it right away until it's been
		        // completely removed.
		
		        newState.x += _this.state.slackX;
		        newState.y += _this.state.slackY;
		
		        // Get bound position. This will ceil/floor the x and y within the boundaries.
		        // $FlowBug
		
		        // Recalculate slack by noting how much was shaved by the boundPosition handler.
		        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_this, newState.x, newState.y);
		
		        var _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2);
		
		        newState.x = _getBoundPosition2[0];
		        newState.y = _getBoundPosition2[1];
		        newState.slackX = _this.state.slackX + (_x - newState.x);
		        newState.slackY = _this.state.slackY + (_y - newState.y);
		
		        // Update the event we fire to reflect what really happened after bounds took effect.
		        uiData.x = _x;
		        uiData.y = _y;
		        uiData.deltaX = newState.x - _this.state.x;
		        uiData.deltaY = newState.y - _this.state.y;
		      }
		
		      // Short-circuit if user's callback killed it.
		      var shouldUpdate = _this.props.onDrag(e, uiData);
		      if (shouldUpdate === false) return false;
		
		      _this.setState(newState);
		    };
		
		    _this.onDragStop = function (e, coreData) {
		      if (!_this.state.dragging) return false;
		
		      // Short-circuit if user's callback killed it.
		      var shouldStop = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_this, coreData));
		      if (shouldStop === false) return false;
		
		      (0, _log2.default)('Draggable: onDragStop: %j', coreData);
		
		      var newState /*: $Shape<DraggableState>*/ = {
		        dragging: false,
		        slackX: 0,
		        slackY: 0
		      };
		
		      // If this is a controlled component, the result of this operation will be to
		      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
		      var controlled = Boolean(_this.props.position);
		      if (controlled) {
		        var _this$props$position = _this.props.position,
		            _x2 = _this$props$position.x,
		            _y2 = _this$props$position.y;
		
		        newState.x = _x2;
		        newState.y = _y2;
		      }
		
		      _this.setState(newState);
		    };
		
		    _this.state = {
		      // Whether or not we are currently dragging.
		      dragging: false,
		
		      // Whether or not we have been dragged before.
		      dragged: false,
		
		      // Current transform x and y.
		      x: props.position ? props.position.x : props.defaultPosition.x,
		      y: props.position ? props.position.y : props.defaultPosition.y,
		
		      // Used for compensating for out-of-bounds drags
		      slackX: 0, slackY: 0,
		
		      // Can only determine if SVG after mounting
		      isElementSVG: false
		    };
		    return _this;
		  }
		
		  _createClass(Draggable, [{
		    key: 'componentWillMount',
		    value: function componentWillMount() {
		      if (this.props.position && !(this.props.onDrag || this.props.onStop)) {
		        // eslint-disable-next-line
		        console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
		      }
		    }
		  }, {
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      // Check to see if the element passed is an instanceof SVGElement
		      if (typeof SVGElement !== 'undefined' && _reactDom2.default.findDOMNode(this) instanceof SVGElement) {
		        this.setState({ isElementSVG: true });
		      }
		    }
		  }, {
		    key: 'componentWillReceiveProps',
		    value: function componentWillReceiveProps(nextProps /*: Object*/) {
		      // Set x/y if position has changed
		      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
		        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
		      }
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
		    }
		  }, {
		    key: 'render',
		    value: function render() /*: React.Element<any>*/ {
		      var _classNames;
		
		      var style = {},
		          svgTransform = null;
		
		      // If this is controlled, we don't want to move it - unless it's dragging.
		      var controlled = Boolean(this.props.position);
		      var draggable = !controlled || this.state.dragging;
		
		      var position = this.props.position || this.props.defaultPosition;
		      var transformOpts = {
		        // Set left if horizontal drag is enabled
		        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : position.x,
		
		        // Set top if vertical drag is enabled
		        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : position.y
		      };
		
		      // If this element was SVG, we use the `transform` attribute.
		      if (this.state.isElementSVG) {
		        svgTransform = (0, _domFns.createSVGTransform)(transformOpts);
		      } else {
		        // Add a CSS transform to move the element around. This allows us to move the element around
		        // without worrying about whether or not it is relatively or absolutely positioned.
		        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
		        // has a clean slate.
		        style = (0, _domFns.createCSSTransform)(transformOpts);
		      }
		
		      var _props = this.props,
		          defaultClassName = _props.defaultClassName,
		          defaultClassNameDragging = _props.defaultClassNameDragging,
		          defaultClassNameDragged = _props.defaultClassNameDragged;
		
		      // Mark with class while dragging
		
		      var className = (0, _classnames2.default)(this.props.children.props.className || '', defaultClassName, (_classNames = {}, _defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), _defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));
		
		      // Reuse the child provided
		      // This makes it flexible to use whatever element is wanted (div, ul, etc)
		      return _react2.default.createElement(
		        _DraggableCore2.default,
		        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
		        _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
		          className: className,
		          style: _extends({}, this.props.children.props.style, style),
		          transform: svgTransform
		        })
		      );
		    }
		  }]);
		
		  return Draggable;
		}(_react2.default.Component);
		
		Draggable.displayName = 'Draggable';
		Draggable.propTypes = _extends({}, _DraggableCore2.default.propTypes, {
		
		  /**
		   * `axis` determines which axis the draggable can move.
		   *
		   *  Note that all callbacks will still return data as normal. This only
		   *  controls flushing to the DOM.
		   *
		   * 'both' allows movement horizontally and vertically.
		   * 'x' limits movement to horizontal axis.
		   * 'y' limits movement to vertical axis.
		   * 'none' limits all movement.
		   *
		   * Defaults to 'both'.
		   */
		  axis: _propTypes2.default.oneOf(['both', 'x', 'y', 'none']),
		
		  /**
		   * `bounds` determines the range of movement available to the element.
		   * Available values are:
		   *
		   * 'parent' restricts movement within the Draggable's parent node.
		   *
		   * Alternatively, pass an object with the following properties, all of which are optional:
		   *
		   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
		   *
		   * All values are in px.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *         return (
		   *            <Draggable bounds={{right: 300, bottom: 300}}>
		   *              <div>Content</div>
		   *           </Draggable>
		   *         );
		   *       }
		   *   });
		   * ```
		   */
		  bounds: _propTypes2.default.oneOfType([_propTypes2.default.shape({
		    left: _propTypes2.default.number,
		    right: _propTypes2.default.number,
		    top: _propTypes2.default.number,
		    bottom: _propTypes2.default.number
		  }), _propTypes2.default.string, _propTypes2.default.oneOf([false])]),
		
		  defaultClassName: _propTypes2.default.string,
		  defaultClassNameDragging: _propTypes2.default.string,
		  defaultClassNameDragged: _propTypes2.default.string,
		
		  /**
		   * `defaultPosition` specifies the x and y that the dragged item should start at
		   *
		   * Example:
		   *
		   * ```jsx
		   *      let App = React.createClass({
		   *          render: function () {
		   *              return (
		   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
		   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
		   *                  </Draggable>
		   *              );
		   *          }
		   *      });
		   * ```
		   */
		  defaultPosition: _propTypes2.default.shape({
		    x: _propTypes2.default.number,
		    y: _propTypes2.default.number
		  }),
		
		  /**
		   * `position`, if present, defines the current position of the element.
		   *
		   *  This is similar to how form elements in React work - if no `position` is supplied, the component
		   *  is uncontrolled.
		   *
		   * Example:
		   *
		   * ```jsx
		   *      let App = React.createClass({
		   *          render: function () {
		   *              return (
		   *                  <Draggable position={{x: 25, y: 25}}>
		   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
		   *                  </Draggable>
		   *              );
		   *          }
		   *      });
		   * ```
		   */
		  position: _propTypes2.default.shape({
		    x: _propTypes2.default.number,
		    y: _propTypes2.default.number
		  }),
		
		  /**
		   * These properties should be defined on the child, not here.
		   */
		  className: _shims.dontSetMe,
		  style: _shims.dontSetMe,
		  transform: _shims.dontSetMe
		});
		Draggable.defaultProps = _extends({}, _DraggableCore2.default.defaultProps, {
		  axis: 'both',
		  bounds: false,
		  defaultClassName: 'react-draggable',
		  defaultClassNameDragging: 'react-draggable-dragging',
		  defaultClassNameDragged: 'react-draggable-dragged',
		  defaultPosition: { x: 0, y: 0 },
		  position: null
		});
		exports.default = Draggable;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
		  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
		    Symbol.for &&
		    Symbol.for('react.element')) ||
		    0xeac7;
		
		  var isValidElement = function(object) {
		    return typeof object === 'object' &&
		      object !== null &&
		      object.$$typeof === REACT_ELEMENT_TYPE;
		  };
		
		  // By explicitly using `prop-types` you are opting into new development behavior.
		  // http://fb.me/prop-types-in-prod
		  var throwOnDirectAccess = true;
		  module.exports = __webpack_require__(4)(isValidElement, throwOnDirectAccess);
		} else {
		  // By explicitly using `prop-types` you are opting into new production behavior.
		  // http://fb.me/prop-types-in-prod
		  module.exports = __webpack_require__(10)();
		}
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(5);
		var invariant = __webpack_require__(6);
		var warning = __webpack_require__(7);
		
		var ReactPropTypesSecret = __webpack_require__(8);
		var checkPropTypes = __webpack_require__(9);
		
		module.exports = function(isValidElement, throwOnDirectAccess) {
		  /* global Symbol */
		  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
		
		  /**
		   * Returns the iterator method function contained on the iterable object.
		   *
		   * Be sure to invoke the function with the iterable as context:
		   *
		   *     var iteratorFn = getIteratorFn(myIterable);
		   *     if (iteratorFn) {
		   *       var iterator = iteratorFn.call(myIterable);
		   *       ...
		   *     }
		   *
		   * @param {?object} maybeIterable
		   * @return {?function}
		   */
		  function getIteratorFn(maybeIterable) {
		    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
		    if (typeof iteratorFn === 'function') {
		      return iteratorFn;
		    }
		  }
		
		  /**
		   * Collection of methods that allow declaration and validation of props that are
		   * supplied to React components. Example usage:
		   *
		   *   var Props = require('ReactPropTypes');
		   *   var MyArticle = React.createClass({
		   *     propTypes: {
		   *       // An optional string prop named "description".
		   *       description: Props.string,
		   *
		   *       // A required enum prop named "category".
		   *       category: Props.oneOf(['News','Photos']).isRequired,
		   *
		   *       // A prop named "dialog" that requires an instance of Dialog.
		   *       dialog: Props.instanceOf(Dialog).isRequired
		   *     },
		   *     render: function() { ... }
		   *   });
		   *
		   * A more formal specification of how these methods are used:
		   *
		   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
		   *   decl := ReactPropTypes.{type}(.isRequired)?
		   *
		   * Each and every declaration produces a function with the same signature. This
		   * allows the creation of custom validation functions. For example:
		   *
		   *  var MyLink = React.createClass({
		   *    propTypes: {
		   *      // An optional string or URI prop named "href".
		   *      href: function(props, propName, componentName) {
		   *        var propValue = props[propName];
		   *        if (propValue != null && typeof propValue !== 'string' &&
		   *            !(propValue instanceof URI)) {
		   *          return new Error(
		   *            'Expected a string or an URI for ' + propName + ' in ' +
		   *            componentName
		   *          );
		   *        }
		   *      }
		   *    },
		   *    render: function() {...}
		   *  });
		   *
		   * @internal
		   */
		
		  var ANONYMOUS = '<<anonymous>>';
		
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
		  var ReactPropTypes = {
		    array: createPrimitiveTypeChecker('array'),
		    bool: createPrimitiveTypeChecker('boolean'),
		    func: createPrimitiveTypeChecker('function'),
		    number: createPrimitiveTypeChecker('number'),
		    object: createPrimitiveTypeChecker('object'),
		    string: createPrimitiveTypeChecker('string'),
		    symbol: createPrimitiveTypeChecker('symbol'),
		
		    any: createAnyTypeChecker(),
		    arrayOf: createArrayOfTypeChecker,
		    element: createElementTypeChecker(),
		    instanceOf: createInstanceTypeChecker,
		    node: createNodeChecker(),
		    objectOf: createObjectOfTypeChecker,
		    oneOf: createEnumTypeChecker,
		    oneOfType: createUnionTypeChecker,
		    shape: createShapeTypeChecker
		  };
		
		  /**
		   * inlined Object.is polyfill to avoid requiring consumers ship their own
		   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
		   */
		  /*eslint-disable no-self-compare*/
		  function is(x, y) {
		    // SameValue algorithm
		    if (x === y) {
		      // Steps 1-5, 7-10
		      // Steps 6.b-6.e: +0 != -0
		      return x !== 0 || 1 / x === 1 / y;
		    } else {
		      // Step 6.a: NaN == NaN
		      return x !== x && y !== y;
		    }
		  }
		  /*eslint-enable no-self-compare*/
		
		  /**
		   * We use an Error-like object for backward compatibility as people may call
		   * PropTypes directly and inspect their output. However, we don't use real
		   * Errors anymore. We don't inspect their stack anyway, and creating them
		   * is prohibitively expensive if they are created too often, such as what
		   * happens in oneOfType() for any type before the one that matched.
		   */
		  function PropTypeError(message) {
		    this.message = message;
		    this.stack = '';
		  }
		  // Make `instanceof Error` still work for returned errors.
		  PropTypeError.prototype = Error.prototype;
		
		  function createChainableTypeChecker(validate) {
		    if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
		      var manualPropTypeCallCache = {};
		      var manualPropTypeWarningCount = 0;
		    }
		    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
		      componentName = componentName || ANONYMOUS;
		      propFullName = propFullName || propName;
		
		      if (secret !== ReactPropTypesSecret) {
		        if (throwOnDirectAccess) {
		          // New behavior only for users of `prop-types` package
		          invariant(
		            false,
		            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		            'Use `PropTypes.checkPropTypes()` to call them. ' +
		            'Read more at http://fb.me/use-check-prop-types'
		          );
		        } else if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' && typeof console !== 'undefined') {
		          // Old behavior for people using React.PropTypes
		          var cacheKey = componentName + ':' + propName;
		          if (
		            !manualPropTypeCallCache[cacheKey] &&
		            // Avoid spamming the console because they are often not actionable except for lib authors
		            manualPropTypeWarningCount < 3
		          ) {
		            warning(
		              false,
		              'You are manually calling a React.PropTypes validation ' +
		              'function for the `%s` prop on `%s`. This is deprecated ' +
		              'and will throw in the standalone `prop-types` package. ' +
		              'You may be seeing this warning due to a third-party PropTypes ' +
		              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
		              propFullName,
		              componentName
		            );
		            manualPropTypeCallCache[cacheKey] = true;
		            manualPropTypeWarningCount++;
		          }
		        }
		      }
		      if (props[propName] == null) {
		        if (isRequired) {
		          if (props[propName] === null) {
		            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
		          }
		          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
		        }
		        return null;
		      } else {
		        return validate(props, propName, componentName, location, propFullName);
		      }
		    }
		
		    var chainedCheckType = checkType.bind(null, false);
		    chainedCheckType.isRequired = checkType.bind(null, true);
		
		    return chainedCheckType;
		  }
		
		  function createPrimitiveTypeChecker(expectedType) {
		    function validate(props, propName, componentName, location, propFullName, secret) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== expectedType) {
		        // `propValue` being instance of, say, date/regexp, pass the 'object'
		        // check, but we can offer a more precise error message here rather than
		        // 'of type `object`'.
		        var preciseType = getPreciseType(propValue);
		
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createAnyTypeChecker() {
		    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
		  }
		
		  function createArrayOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
		      }
		      var propValue = props[propName];
		      if (!Array.isArray(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
		      }
		      for (var i = 0; i < propValue.length; i++) {
		        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
		        if (error instanceof Error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createElementTypeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      if (!isValidElement(propValue)) {
		        var propType = getPropType(propValue);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createInstanceTypeChecker(expectedClass) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!(props[propName] instanceof expectedClass)) {
		        var expectedClassName = expectedClass.name || ANONYMOUS;
		        var actualClassName = getClassName(props[propName]);
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createEnumTypeChecker(expectedValues) {
		    if (!Array.isArray(expectedValues)) {
		      ({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
		
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      for (var i = 0; i < expectedValues.length; i++) {
		        if (is(propValue, expectedValues[i])) {
		          return null;
		        }
		      }
		
		      var valuesString = JSON.stringify(expectedValues);
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createObjectOfTypeChecker(typeChecker) {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (typeof typeChecker !== 'function') {
		        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
		      }
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
		      }
		      for (var key in propValue) {
		        if (propValue.hasOwnProperty(key)) {
		          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		          if (error instanceof Error) {
		            return error;
		          }
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createUnionTypeChecker(arrayOfTypeCheckers) {
		    if (!Array.isArray(arrayOfTypeCheckers)) {
		      ({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
		      return emptyFunction.thatReturnsNull;
		    }
		
		    function validate(props, propName, componentName, location, propFullName) {
		      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
		        var checker = arrayOfTypeCheckers[i];
		        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
		          return null;
		        }
		      }
		
		      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createNodeChecker() {
		    function validate(props, propName, componentName, location, propFullName) {
		      if (!isNode(props[propName])) {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function createShapeTypeChecker(shapeTypes) {
		    function validate(props, propName, componentName, location, propFullName) {
		      var propValue = props[propName];
		      var propType = getPropType(propValue);
		      if (propType !== 'object') {
		        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
		      }
		      for (var key in shapeTypes) {
		        var checker = shapeTypes[key];
		        if (!checker) {
		          continue;
		        }
		        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
		        if (error) {
		          return error;
		        }
		      }
		      return null;
		    }
		    return createChainableTypeChecker(validate);
		  }
		
		  function isNode(propValue) {
		    switch (typeof propValue) {
		      case 'number':
		      case 'string':
		      case 'undefined':
		        return true;
		      case 'boolean':
		        return !propValue;
		      case 'object':
		        if (Array.isArray(propValue)) {
		          return propValue.every(isNode);
		        }
		        if (propValue === null || isValidElement(propValue)) {
		          return true;
		        }
		
		        var iteratorFn = getIteratorFn(propValue);
		        if (iteratorFn) {
		          var iterator = iteratorFn.call(propValue);
		          var step;
		          if (iteratorFn !== propValue.entries) {
		            while (!(step = iterator.next()).done) {
		              if (!isNode(step.value)) {
		                return false;
		              }
		            }
		          } else {
		            // Iterator will provide entry [k,v] tuples rather than values.
		            while (!(step = iterator.next()).done) {
		              var entry = step.value;
		              if (entry) {
		                if (!isNode(entry[1])) {
		                  return false;
		                }
		              }
		            }
		          }
		        } else {
		          return false;
		        }
		
		        return true;
		      default:
		        return false;
		    }
		  }
		
		  function isSymbol(propType, propValue) {
		    // Native Symbol.
		    if (propType === 'symbol') {
		      return true;
		    }
		
		    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
		    if (propValue['@@toStringTag'] === 'Symbol') {
		      return true;
		    }
		
		    // Fallback for non-spec compliant Symbols which are polyfilled.
		    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
		      return true;
		    }
		
		    return false;
		  }
		
		  // Equivalent of `typeof` but with special handling for array and regexp.
		  function getPropType(propValue) {
		    var propType = typeof propValue;
		    if (Array.isArray(propValue)) {
		      return 'array';
		    }
		    if (propValue instanceof RegExp) {
		      // Old webkits (at least until Android 4.0) return 'function' rather than
		      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
		      // passes PropTypes.object.
		      return 'object';
		    }
		    if (isSymbol(propType, propValue)) {
		      return 'symbol';
		    }
		    return propType;
		  }
		
		  // This handles more types than `getPropType`. Only used for error messages.
		  // See `createPrimitiveTypeChecker`.
		  function getPreciseType(propValue) {
		    var propType = getPropType(propValue);
		    if (propType === 'object') {
		      if (propValue instanceof Date) {
		        return 'date';
		      } else if (propValue instanceof RegExp) {
		        return 'regexp';
		      }
		    }
		    return propType;
		  }
		
		  // Returns class name of the object, if any.
		  function getClassName(propValue) {
		    if (!propValue.constructor || !propValue.constructor.name) {
		      return ANONYMOUS;
		    }
		    return propValue.constructor.name;
		  }
		
		  ReactPropTypes.checkPropTypes = checkPropTypes;
		  ReactPropTypes.PropTypes = ReactPropTypes;
		
		  return ReactPropTypes;
		};
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		"use strict";
		
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 * 
		 */
		
		function makeEmptyFunction(arg) {
		  return function () {
		    return arg;
		  };
		}
		
		/**
		 * This function accepts and discards inputs; it has no side effects. This is
		 * primarily useful idiomatically for overridable function endpoints which
		 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
		 */
		var emptyFunction = function emptyFunction() {};
		
		emptyFunction.thatReturns = makeEmptyFunction;
		emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
		emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
		emptyFunction.thatReturnsNull = makeEmptyFunction(null);
		emptyFunction.thatReturnsThis = function () {
		  return this;
		};
		emptyFunction.thatReturnsArgument = function (arg) {
		  return arg;
		};
		
		module.exports = emptyFunction;
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright (c) 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
		
		'use strict';
		
		/**
		 * Use invariant() to assert state which your program assumes to be true.
		 *
		 * Provide sprintf-style format (only %s is supported) and arguments
		 * to provide information about what broke and what you were
		 * expecting.
		 *
		 * The invariant message will be stripped in production, but the invariant
		 * will remain to ensure logic does not differ in production.
		 */
		
		var validateFormat = function validateFormat(format) {};
		
		if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
		  validateFormat = function validateFormat(format) {
		    if (format === undefined) {
		      throw new Error('invariant requires an error message argument');
		    }
		  };
		}
		
		function invariant(condition, format, a, b, c, d, e, f) {
		  validateFormat(format);
		
		  if (!condition) {
		    var error;
		    if (format === undefined) {
		      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
		    } else {
		      var args = [a, b, c, d, e, f];
		      var argIndex = 0;
		      error = new Error(format.replace(/%s/g, function () {
		        return args[argIndex++];
		      }));
		      error.name = 'Invariant Violation';
		    }
		
		    error.framesToPop = 1; // we don't care about invariant's own frame
		    throw error;
		  }
		}
		
		module.exports = invariant;
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2014-2015, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 *
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(5);
		
		/**
		 * Similar to invariant but only logs a warning if the condition is not met.
		 * This can be used to log issues in development environments in critical
		 * paths. Removing the logging code for production environments will keep the
		 * same logic and follow the same code paths.
		 */
		
		var warning = emptyFunction;
		
		if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
		  (function () {
		    var printWarning = function printWarning(format) {
		      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		        args[_key - 1] = arguments[_key];
		      }
		
		      var argIndex = 0;
		      var message = 'Warning: ' + format.replace(/%s/g, function () {
		        return args[argIndex++];
		      });
		      if (typeof console !== 'undefined') {
		        console.error(message);
		      }
		      try {
		        // --- Welcome to debugging React ---
		        // This error was thrown as a convenience so that you can use this stack
		        // to find the callsite that caused this warning to fire.
		        throw new Error(message);
		      } catch (x) {}
		    };
		
		    warning = function warning(condition, format) {
		      if (format === undefined) {
		        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
		      }
		
		      if (format.indexOf('Failed Composite propType: ') === 0) {
		        return; // Ignore CompositeComponent proptype check.
		      }
		
		      if (!condition) {
		        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
		          args[_key2 - 2] = arguments[_key2];
		        }
		
		        printWarning.apply(undefined, [format].concat(args));
		      }
		    };
		  })();
		}
		
		module.exports = warning;
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		'use strict';
		
		var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
		
		module.exports = ReactPropTypesSecret;
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		'use strict';
		
		if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
		  var invariant = __webpack_require__(6);
		  var warning = __webpack_require__(7);
		  var ReactPropTypesSecret = __webpack_require__(8);
		  var loggedTypeFailures = {};
		}
		
		/**
		 * Assert that the values match with the type specs.
		 * Error messages are memorized and will only be shown once.
		 *
		 * @param {object} typeSpecs Map of name to a ReactPropType
		 * @param {object} values Runtime values that need to be type-checked
		 * @param {string} location e.g. "prop", "context", "child context"
		 * @param {string} componentName Name of the component for error messages.
		 * @param {?Function} getStack Returns the component stack.
		 * @private
		 */
		function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
		  if (({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
		    for (var typeSpecName in typeSpecs) {
		      if (typeSpecs.hasOwnProperty(typeSpecName)) {
		        var error;
		        // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.
		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
		          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
		        } catch (ex) {
		          error = ex;
		        }
		        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
		        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error.message] = true;
		
		          var stack = getStack ? getStack() : '';
		
		          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
		        }
		      }
		    }
		  }
		}
		
		module.exports = checkPropTypes;
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		/**
		 * Copyright 2013-present, Facebook, Inc.
		 * All rights reserved.
		 *
		 * This source code is licensed under the BSD-style license found in the
		 * LICENSE file in the root directory of this source tree. An additional grant
		 * of patent rights can be found in the PATENTS file in the same directory.
		 */
		
		'use strict';
		
		var emptyFunction = __webpack_require__(5);
		var invariant = __webpack_require__(6);
		
		module.exports = function() {
		  // Important!
		  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
		  function shim() {
		    invariant(
		      false,
		      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
		      'Use PropTypes.checkPropTypes() to call them. ' +
		      'Read more at http://fb.me/use-check-prop-types'
		    );
		  };
		  shim.isRequired = shim;
		  function getShim() {
		    return shim;
		  };
		  var ReactPropTypes = {
		    array: shim,
		    bool: shim,
		    func: shim,
		    number: shim,
		    object: shim,
		    string: shim,
		    symbol: shim,
		
		    any: shim,
		    arrayOf: getShim,
		    element: shim,
		    instanceOf: getShim,
		    node: shim,
		    objectOf: getShim,
		    oneOf: getShim,
		    oneOfType: getShim,
		    shape: getShim
		  };
		
		  ReactPropTypes.checkPropTypes = emptyFunction;
		  ReactPropTypes.PropTypes = ReactPropTypes;
		
		  return ReactPropTypes;
		};
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_11__;
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		  Copyright (c) 2016 Jed Watson.
		  Licensed under the MIT License (MIT), see
		  http://jedwatson.github.io/classnames
		*/
		/* global define */
		
		(function () {
			'use strict';
		
			var hasOwn = {}.hasOwnProperty;
		
			function classNames () {
				var classes = [];
		
				for (var i = 0; i < arguments.length; i++) {
					var arg = arguments[i];
					if (!arg) continue;
		
					var argType = typeof arg;
		
					if (argType === 'string' || argType === 'number') {
						classes.push(arg);
					} else if (Array.isArray(arg)) {
						classes.push(classNames.apply(null, arg));
					} else if (argType === 'object') {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					}
				}
		
				return classes.join(' ');
			}
		
			if (typeof module !== 'undefined' && module.exports) {
				module.exports = classNames;
			} else if (true) {
				// register as 'classnames', consistent with npm package name
				!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
					return classNames;
				}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			} else {
				window.classNames = classNames;
			}
		}());
	
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		exports.matchesSelector = matchesSelector;
		exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
		exports.addEvent = addEvent;
		exports.removeEvent = removeEvent;
		exports.outerHeight = outerHeight;
		exports.outerWidth = outerWidth;
		exports.innerHeight = innerHeight;
		exports.innerWidth = innerWidth;
		exports.offsetXYFromParent = offsetXYFromParent;
		exports.createCSSTransform = createCSSTransform;
		exports.createSVGTransform = createSVGTransform;
		exports.getTouch = getTouch;
		exports.getTouchIdentifier = getTouchIdentifier;
		exports.addUserSelectStyles = addUserSelectStyles;
		exports.removeUserSelectStyles = removeUserSelectStyles;
		exports.styleHacks = styleHacks;
		
		var _shims = __webpack_require__(14);
		
		var _getPrefix = __webpack_require__(15);
		
		var _getPrefix2 = _interopRequireDefault(_getPrefix);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
		
		/*:: import type {ControlPosition} from './types';*/
		
		
		var matchesSelectorFunc = '';
		function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
		  if (!matchesSelectorFunc) {
		    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
		      // $FlowIgnore: Doesn't think elements are indexable
		      return (0, _shims.isFunction)(el[method]);
		    });
		  }
		
		  // $FlowIgnore: Doesn't think elements are indexable
		  return el[matchesSelectorFunc].call(el, selector);
		}
		
		// Works up the tree to the draggable itself attempting to match selector.
		function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
		  var node = el;
		  do {
		    if (matchesSelector(node, selector)) return true;
		    if (node === baseNode) return false;
		    node = node.parentNode;
		  } while (node);
		
		  return false;
		}
		
		function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
		  if (!el) {
		    return;
		  }
		  if (el.attachEvent) {
		    el.attachEvent('on' + event, handler);
		  } else if (el.addEventListener) {
		    el.addEventListener(event, handler, true);
		  } else {
		    // $FlowIgnore: Doesn't think elements are indexable
		    el['on' + event] = handler;
		  }
		}
		
		function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
		  if (!el) {
		    return;
		  }
		  if (el.detachEvent) {
		    el.detachEvent('on' + event, handler);
		  } else if (el.removeEventListener) {
		    el.removeEventListener(event, handler, true);
		  } else {
		    // $FlowIgnore: Doesn't think elements are indexable
		    el['on' + event] = null;
		  }
		}
		
		function outerHeight(node /*: HTMLElement*/) /*: number*/ {
		  // This is deliberately excluding margin for our calculations, since we are using
		  // offsetTop which is including margin. See getBoundPosition
		  var height = node.clientHeight;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  height += (0, _shims.int)(computedStyle.borderTopWidth);
		  height += (0, _shims.int)(computedStyle.borderBottomWidth);
		  return height;
		}
		
		function outerWidth(node /*: HTMLElement*/) /*: number*/ {
		  // This is deliberately excluding margin for our calculations, since we are using
		  // offsetLeft which is including margin. See getBoundPosition
		  var width = node.clientWidth;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  width += (0, _shims.int)(computedStyle.borderLeftWidth);
		  width += (0, _shims.int)(computedStyle.borderRightWidth);
		  return width;
		}
		function innerHeight(node /*: HTMLElement*/) /*: number*/ {
		  var height = node.clientHeight;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  height -= (0, _shims.int)(computedStyle.paddingTop);
		  height -= (0, _shims.int)(computedStyle.paddingBottom);
		  return height;
		}
		
		function innerWidth(node /*: HTMLElement*/) /*: number*/ {
		  var width = node.clientWidth;
		  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
		  width -= (0, _shims.int)(computedStyle.paddingLeft);
		  width -= (0, _shims.int)(computedStyle.paddingRight);
		  return width;
		}
		
		// Get from offsetParent
		function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
		  var isBody = offsetParent === offsetParent.ownerDocument.body;
		  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();
		
		  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
		  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;
		
		  return { x: x, y: y };
		}
		
		function createCSSTransform(_ref) /*: Object*/ {
		  var x = _ref.x,
		      y = _ref.y;
		
		  // Replace unitless items with px
		  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix2.default), 'translate(' + x + 'px,' + y + 'px)');
		}
		
		function createSVGTransform(_ref3) /*: string*/ {
		  var x = _ref3.x,
		      y = _ref3.y;
		
		  return 'translate(' + x + ',' + y + ')';
		}
		
		function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
		  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
		    return identifier === t.identifier;
		  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
		    return identifier === t.identifier;
		  });
		}
		
		function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
		  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
		  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
		}
		
		// User-select Hacks:
		//
		// Useful for preventing blue highlights all over everything when dragging.
		var userSelectPrefix = (0, _getPrefix.getPrefix)('user-select');
		var userSelect = (0, _getPrefix.browserPrefixToStyle)('user-select', userSelectPrefix);
		var userSelectStyle = ';' + userSelect + ': none;';
		var userSelectReplaceRegExp = new RegExp(';?' + userSelect + ': none;'); // leading ; not present on IE
		
		// Note we're passing `document` b/c we could be iframed
		function addUserSelectStyles(body /*: HTMLElement*/) {
		  var style = body.getAttribute('style') || '';
		  if (userSelectReplaceRegExp.test(style)) return; // don't add twice
		  body.setAttribute('style', style + userSelectStyle);
		}
		
		function removeUserSelectStyles(body /*: HTMLElement*/) {
		  var style = body.getAttribute('style') || '';
		  body.setAttribute('style', style.replace(userSelectReplaceRegExp, ''));
		}
		
		function styleHacks() /*: Object*/ {
		  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		
		  // Workaround IE pointer events; see #51
		  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
		  return _extends({
		    touchAction: 'none'
		  }, childStyle);
		}
	
	/***/ },
	/* 14 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.findInArray = findInArray;
		exports.isFunction = isFunction;
		exports.isNum = isNum;
		exports.int = int;
		exports.dontSetMe = dontSetMe;
		
		// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
		function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
		  for (var i = 0, length = array.length; i < length; i++) {
		    if (callback.apply(callback, [array[i], i, array])) return array[i];
		  }
		}
		
		function isFunction(func /*: any*/) /*: boolean*/ {
		  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
		}
		
		function isNum(num /*: any*/) /*: boolean*/ {
		  return typeof num === 'number' && !isNaN(num);
		}
		
		function int(a /*: string*/) /*: number*/ {
		  return parseInt(a, 10);
		}
		
		function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
		  if (props[propName]) {
		    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
		  }
		}
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getPrefix = getPrefix;
		exports.browserPrefixToKey = browserPrefixToKey;
		exports.browserPrefixToStyle = browserPrefixToStyle;
		var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
		function getPrefix() /*: string*/ {
		  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
		
		  // Checking specifically for 'window.document' is for pseudo-browser server-side
		  // environments that define 'window' as the global context.
		  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
		  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';
		
		  var style = window.document.documentElement.style;
		
		  if (prop in style) return '';
		
		  for (var i = 0; i < prefixes.length; i++) {
		    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
		  }
		
		  return '';
		}
		
		function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
		  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
		}
		
		function browserPrefixToStyle(prop /*: string*/, prefix /*: string*/) /*: string*/ {
		  return prefix ? '-' + prefix.toLowerCase() + '-' + prop : prop;
		}
		
		function kebabToTitleCase(str /*: string*/) /*: string*/ {
		  var out = '';
		  var shouldCapitalize = true;
		  for (var i = 0; i < str.length; i++) {
		    if (shouldCapitalize) {
		      out += str[i].toUpperCase();
		      shouldCapitalize = false;
		    } else if (str[i] === '-') {
		      shouldCapitalize = true;
		    } else {
		      out += str[i];
		    }
		  }
		  return out;
		}
		
		// Default export is the prefix itself, like 'Moz', 'Webkit', etc
		// Note that you may have to re-test for certain things; for instance, Chrome 50
		// can handle unprefixed `transform`, but not unprefixed `user-select`
		exports.default = getPrefix();
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.getBoundPosition = getBoundPosition;
		exports.snapToGrid = snapToGrid;
		exports.canDragX = canDragX;
		exports.canDragY = canDragY;
		exports.getControlPosition = getControlPosition;
		exports.createCoreData = createCoreData;
		exports.createDraggableData = createDraggableData;
		
		var _shims = __webpack_require__(14);
		
		var _reactDom = __webpack_require__(11);
		
		var _reactDom2 = _interopRequireDefault(_reactDom);
		
		var _domFns = __webpack_require__(13);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		/*:: import type Draggable from '../Draggable';*/
		/*:: import type {Bounds, ControlPosition, DraggableData} from './types';*/
		/*:: import type DraggableCore from '../DraggableCore';*/
		function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
		  // If no bounds, short-circuit and move on
		  if (!draggable.props.bounds) return [x, y];
		
		  // Clone new bounds
		  var bounds = draggable.props.bounds;
		
		  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
		  var node = _reactDom2.default.findDOMNode(draggable);
		
		  if (typeof bounds === 'string') {
		    var ownerDocument = node.ownerDocument;
		
		    var ownerWindow = ownerDocument.defaultView;
		    var boundNode = void 0;
		    if (bounds === 'parent') {
		      boundNode = node.parentNode;
		    } else {
		      boundNode = ownerDocument.querySelector(bounds);
		      if (!boundNode) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
		    }
		    var nodeStyle = ownerWindow.getComputedStyle(node);
		    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
		    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
		    bounds = {
		      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
		      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
		      right: (0, _domFns.innerWidth)(boundNode) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
		      bottom: (0, _domFns.innerHeight)(boundNode) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
		    };
		  }
		
		  // Keep x and y below right and bottom limits...
		  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
		  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
		
		  // But above left and top limits.
		  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
		  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
		
		  return [x, y];
		}
		
		function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
		  var x = Math.round(pendingX / grid[0]) * grid[0];
		  var y = Math.round(pendingY / grid[1]) * grid[1];
		  return [x, y];
		}
		
		function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
		  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
		}
		
		function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
		  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
		}
		
		// Get {x, y} positions from event.
		function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
		  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
		  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
		  var node = _reactDom2.default.findDOMNode(draggableCore);
		  // User can provide an offsetParent if desired.
		  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
		  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent);
		}
		
		// Create an data object exposed by <DraggableCore>'s events
		function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
		  var state = draggable.state;
		  var isStart = !(0, _shims.isNum)(state.lastX);
		
		  if (isStart) {
		    // If this is our first move, use the x and y as last coords.
		    return {
		      node: _reactDom2.default.findDOMNode(draggable),
		      deltaX: 0, deltaY: 0,
		      lastX: x, lastY: y,
		      x: x, y: y
		    };
		  } else {
		    // Otherwise calculate proper values.
		    return {
		      node: _reactDom2.default.findDOMNode(draggable),
		      deltaX: x - state.lastX, deltaY: y - state.lastY,
		      lastX: state.lastX, lastY: state.lastY,
		      x: x, y: y
		    };
		  }
		}
		
		// Create an data exposed by <Draggable>'s events
		function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
		  return {
		    node: coreData.node,
		    x: draggable.state.x + coreData.deltaX,
		    y: draggable.state.y + coreData.deltaY,
		    deltaX: coreData.deltaX,
		    deltaY: coreData.deltaY,
		    lastX: draggable.state.x,
		    lastY: draggable.state.y
		  };
		}
		
		// A lot faster than stringify/parse
		function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
		  return {
		    left: bounds.left,
		    top: bounds.top,
		    right: bounds.right,
		    bottom: bounds.bottom
		  };
		}
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _propTypes = __webpack_require__(3);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _reactDom = __webpack_require__(11);
		
		var _reactDom2 = _interopRequireDefault(_reactDom);
		
		var _domFns = __webpack_require__(13);
		
		var _positionFns = __webpack_require__(16);
		
		var _shims = __webpack_require__(14);
		
		var _log = __webpack_require__(19);
		
		var _log2 = _interopRequireDefault(_log);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		// Simple abstraction for dragging events names.
		/*:: import type {EventHandler} from './utils/types';*/
		var eventsFor = {
		  touch: {
		    start: 'touchstart',
		    move: 'touchmove',
		    stop: 'touchend'
		  },
		  mouse: {
		    start: 'mousedown',
		    move: 'mousemove',
		    stop: 'mouseup'
		  }
		};
		
		// Default to mouse events.
		var dragEventFor = eventsFor.mouse;
		
		//
		// Define <DraggableCore>.
		//
		// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
		// work well with libraries that require more control over the element.
		//
		
		/*:: type CoreState = {
		  dragging: boolean,
		  lastX: number,
		  lastY: number,
		  touchIdentifier: ?number
		};*/
		
		var DraggableCore = function (_React$Component) {
		  _inherits(DraggableCore, _React$Component);
		
		  function DraggableCore() {
		    var _ref;
		
		    var _temp, _this, _ret;
		
		    _classCallCheck(this, DraggableCore);
		
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
		
		    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
		      dragging: false,
		      // Used while dragging to determine deltas.
		      lastX: NaN, lastY: NaN,
		      touchIdentifier: null
		    }, _this.handleDragStart = function (e) {
		      // Make it possible to attach event handlers on top of this one.
		      _this.props.onMouseDown(e);
		
		      // Only accept left-clicks.
		      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
		
		      // Get nodes. Be sure to grab relative document (could be iframed)
		      var domNode = _reactDom2.default.findDOMNode(_this);
		      var ownerDocument = domNode.ownerDocument;
		
		      // Short circuit if handle or cancel prop was provided and selector doesn't match.
		
		      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, domNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, domNode)) {
		        return;
		      }
		
		      // Set touch identifier in component state if this is a touch event. This allows us to
		      // distinguish between individual touches on multitouch screens by identifying which
		      // touchpoint was set to this element.
		      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
		      _this.setState({ touchIdentifier: touchIdentifier });
		
		      // Get the current drag point from the event. This is used as the offset.
		      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _this);
		      if (position == null) return; // not possible but satisfies flow
		      var x = position.x,
		          y = position.y;
		
		      // Create an event object with all the data parents need to make a decision here.
		
		      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
		
		      (0, _log2.default)('DraggableCore: handleDragStart: %j', coreEvent);
		
		      // Call event handler. If it returns explicit false, cancel.
		      (0, _log2.default)('calling', _this.props.onStart);
		      var shouldUpdate = _this.props.onStart(e, coreEvent);
		      if (shouldUpdate === false) return;
		
		      // Add a style to the body to disable user-select. This prevents text from
		      // being selected all over the page.
		      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument.body);
		
		      // Initiate dragging. Set the current x and y as offsets
		      // so we know how much we've moved during the drag. This allows us
		      // to drag elements around even if they have been moved, without issue.
		      _this.setState({
		        dragging: true,
		
		        lastX: x,
		        lastY: y
		      });
		
		      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
		      // this element. We use different events depending on whether or not we have detected that this
		      // is a touch-capable device.
		      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
		      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
		    }, _this.handleDrag = function (e) {
		
		      // Prevent scrolling on mobile devices, like ipad/iphone.
		      if (e.type === 'touchmove') e.preventDefault();
		
		      // Get the current drag point from the event. This is used as the offset.
		      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
		      if (position == null) return;
		      var x = position.x,
		          y = position.y;
		
		      // Snap to grid if prop has been provided
		
		      if (Array.isArray(_this.props.grid)) {
		        var deltaX = x - _this.state.lastX,
		            deltaY = y - _this.state.lastY;
		
		        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, deltaX, deltaY);
		
		        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);
		
		        deltaX = _snapToGrid2[0];
		        deltaY = _snapToGrid2[1];
		
		        if (!deltaX && !deltaY) return; // skip useless drag
		        x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
		      }
		
		      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
		
		      (0, _log2.default)('DraggableCore: handleDrag: %j', coreEvent);
		
		      // Call event handler. If it returns explicit false, trigger end.
		      var shouldUpdate = _this.props.onDrag(e, coreEvent);
		      if (shouldUpdate === false) {
		        try {
		          // $FlowIgnore
		          _this.handleDragStop(new MouseEvent('mouseup'));
		        } catch (err) {
		          // Old browsers
		          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
		          // I see why this insanity was deprecated
		          // $FlowIgnore
		          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		          _this.handleDragStop(event);
		        }
		        return;
		      }
		
		      _this.setState({
		        lastX: x,
		        lastY: y
		      });
		    }, _this.handleDragStop = function (e) {
		      if (!_this.state.dragging) return;
		
		      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
		      if (position == null) return;
		      var x = position.x,
		          y = position.y;
		
		      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);
		
		      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(_this),
		          ownerDocument = _ReactDOM$findDOMNode.ownerDocument;
		
		      // Remove user-select hack
		
		
		      if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument.body);
		
		      (0, _log2.default)('DraggableCore: handleDragStop: %j', coreEvent);
		
		      // Reset the el.
		      _this.setState({
		        dragging: false,
		        lastX: NaN,
		        lastY: NaN
		      });
		
		      // Call event handler
		      _this.props.onStop(e, coreEvent);
		
		      // Remove event handlers
		      (0, _log2.default)('DraggableCore: Removing handlers');
		      (0, _domFns.removeEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
		      (0, _domFns.removeEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
		    }, _this.onMouseDown = function (e) {
		      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
		
		      return _this.handleDragStart(e);
		    }, _this.onMouseUp = function (e) {
		      dragEventFor = eventsFor.mouse;
		
		      return _this.handleDragStop(e);
		    }, _this.onTouchStart = function (e) {
		      // We're on a touch device now, so change the event handlers
		      dragEventFor = eventsFor.touch;
		
		      return _this.handleDragStart(e);
		    }, _this.onTouchEnd = function (e) {
		      // We're on a touch device now, so change the event handlers
		      dragEventFor = eventsFor.touch;
		
		      return _this.handleDragStop(e);
		    }, _temp), _possibleConstructorReturn(_this, _ret);
		  }
		
		  _createClass(DraggableCore, [{
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
		      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
		      var _ReactDOM$findDOMNode2 = _reactDom2.default.findDOMNode(this),
		          ownerDocument = _ReactDOM$findDOMNode2.ownerDocument;
		
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
		      (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
		      if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument.body);
		    }
		
		    // Same as onMouseDown (start drag), but now consider this a touch device.
		
		  }, {
		    key: 'render',
		    value: function render() /*: React.Element<any>*/ {
		      // Reuse the child provided
		      // This makes it flexible to use whatever element is wanted (div, ul, etc)
		      return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
		        style: (0, _domFns.styleHacks)(this.props.children.props.style),
		
		        // Note: mouseMove handler is attached to document so it will still function
		        // when the user drags quickly and leaves the bounds of the element.
		        onMouseDown: this.onMouseDown,
		        onTouchStart: this.onTouchStart,
		        onMouseUp: this.onMouseUp,
		        onTouchEnd: this.onTouchEnd
		      });
		    }
		  }]);
		
		  return DraggableCore;
		}(_react2.default.Component);
		
		DraggableCore.displayName = 'DraggableCore';
		DraggableCore.propTypes = {
		  /**
		   * `allowAnyClick` allows dragging using any mouse button.
		   * By default, we only accept the left button.
		   *
		   * Defaults to `false`.
		   */
		  allowAnyClick: _propTypes2.default.bool,
		
		  /**
		   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
		   * with the exception of `onMouseDown`, will not fire.
		   */
		  disabled: _propTypes2.default.bool,
		
		  /**
		   * By default, we add 'user-select:none' attributes to the document body
		   * to prevent ugly text selection during drag. If this is causing problems
		   * for your app, set this to `false`.
		   */
		  enableUserSelectHack: _propTypes2.default.bool,
		
		  /**
		   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
		   * instead of using the parent node.
		   */
		  offsetParent: function offsetParent(props, propName) {
		    if (process.browser && props[propName] && props[propName].nodeType !== 1) {
		      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
		    }
		  },
		
		  /**
		   * `grid` specifies the x and y that dragging should snap to.
		   */
		  grid: _propTypes2.default.arrayOf(_propTypes2.default.number),
		
		  /**
		   * `handle` specifies a selector to be used as the handle that initiates drag.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *         return (
		   *            <Draggable handle=".handle">
		   *              <div>
		   *                  <div className="handle">Click me to drag</div>
		   *                  <div>This is some other content</div>
		   *              </div>
		   *           </Draggable>
		   *         );
		   *       }
		   *   });
		   * ```
		   */
		  handle: _propTypes2.default.string,
		
		  /**
		   * `cancel` specifies a selector to be used to prevent drag initialization.
		   *
		   * Example:
		   *
		   * ```jsx
		   *   let App = React.createClass({
		   *       render: function () {
		   *           return(
		   *               <Draggable cancel=".cancel">
		   *                   <div>
		   *                     <div className="cancel">You can't drag from here</div>
		   *                     <div>Dragging here works fine</div>
		   *                   </div>
		   *               </Draggable>
		   *           );
		   *       }
		   *   });
		   * ```
		   */
		  cancel: _propTypes2.default.string,
		
		  /**
		   * Called when dragging starts.
		   * If this function returns the boolean false, dragging will be canceled.
		   */
		  onStart: _propTypes2.default.func,
		
		  /**
		   * Called while dragging.
		   * If this function returns the boolean false, dragging will be canceled.
		   */
		  onDrag: _propTypes2.default.func,
		
		  /**
		   * Called when dragging stops.
		   * If this function returns the boolean false, the drag will remain active.
		   */
		  onStop: _propTypes2.default.func,
		
		  /**
		   * A workaround option which can be passed if onMouseDown needs to be accessed,
		   * since it'll always be blocked (as there is internal use of onMouseDown)
		   */
		  onMouseDown: _propTypes2.default.func,
		
		  /**
		   * These properties should be defined on the child, not here.
		   */
		  className: _shims.dontSetMe,
		  style: _shims.dontSetMe,
		  transform: _shims.dontSetMe
		};
		DraggableCore.defaultProps = {
		  allowAnyClick: false, // by default only accept left click
		  cancel: null,
		  disabled: false,
		  enableUserSelectHack: true,
		  offsetParent: null,
		  handle: null,
		  grid: null,
		  transform: null,
		  onStart: function onStart() {},
		  onDrag: function onDrag() {},
		  onStop: function onStop() {},
		  onMouseDown: function onMouseDown() {}
		};
		exports.default = DraggableCore;
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))
	
	/***/ },
	/* 18 */
	/***/ function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
		"use strict";
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = log;
		
		/*eslint no-console:0*/
		function log() {
		  var _console;
		
		  if ((undefined)) (_console = console).log.apply(_console, arguments);
		}
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=react-draggable.js.map

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _FullScreenManager = __webpack_require__(141);
	
	var _FullScreenManager2 = _interopRequireDefault(_FullScreenManager);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioVolumeUtils = __webpack_require__(67);
	
	var _AudioVolumeUtils2 = _interopRequireDefault(_AudioVolumeUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _SlidesPreloaderNew = __webpack_require__(243);
	
	var _SlidesPreloaderNew2 = _interopRequireDefault(_SlidesPreloaderNew);
	
	var _SlidesPreloader = __webpack_require__(375);
	
	var _SlidesPreloader2 = _interopRequireDefault(_SlidesPreloader);
	
	var _ToolTipManager = __webpack_require__(174);
	
	var _ToolTipManager2 = _interopRequireDefault(_ToolTipManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var previewCommands = {
	    fadeLimit: 4000, // 4 seconds
	    isPlaying: false,
	    refreshFunction: undefined,
	    storySoundVolume: 0.5,
	    forceUpdateForPlayButton: undefined,
	
	    changeSlideVar: undefined,
	    playbackPositionVar: undefined,
	    totalTime: 0,
	    startTime: 0,
	
	    getDispatch: function getDispatch() {
	        var store = _StoreManager2.default.getStore();
	        return store.dispatch;
	    },
	    isEditorMode: function isEditorMode() {
	        var state = _StoreManager2.default.getState();
	        var previewMode = state.production.mode;
	
	        if (previewMode == _ModeConstants2.default.EDITOR) return true;else return false;
	    },
	    isPlayMode: function isPlayMode() {
	        if (this.isEditorMode() == false || _AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) return true;else return false;
	    },
	    isPlayer: function isPlayer() {
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) return true;else return false;
	    },
	    goToFirstSlide: function goToFirstSlide() {
	        var enterPreviewMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var state = _StoreManager2.default.getState();
	        var slideIndex = state.currentSlide.currentSlideIndex;
	
	        if (slideIndex != 0) this.changeSlideToIndex(0);else {
	            if (enterPreviewMode) {
	                if (!_PlayController2.default.isAudioEditorAvailable()) this.loadSlideSound(slideIndex);
	            }
	        }
	    },
	    goToSlideIndex: function goToSlideIndex(index) {
	        var dispatch = this.getDispatch();
	        dispatch((0, _CurrentSlideActions.setCurrentSlide)(index));
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            this.isPlaying = false;
	        } else {
	            if (this.isPlaying == true) {
	                this.isPlaying = false;
	                this.playPauseStorySound();
	            } else this.loadSlideSound(index);
	        }
	    },
	    changeSlideToIndex: function changeSlideToIndex(index) {
	        var dispatch = this.getDispatch();
	        dispatch((0, _CurrentSlideActions.setCurrentSlide)(index));
	
	        if (!_PlayController2.default.isAudioEditorAvailable()) this.loadSlideSound(index);
	    },
	    setCoreProperties: function setCoreProperties(id) {
	        var element = document.getElementById(id);
	
	        if (!element) return;
	
	        element.setAttribute('crossOrigin', 'anonymous');
	    },
	    getStorySound: function getStorySound() {
	        var audio = document.getElementById('storySound');
	
	        if (!(this.storySoundVolume >= 0 && this.storySoundVolume <= 1)) this.storySoundVolume = 0.5;
	
	        if (audio && !_PlatformDetection2.default.isIOS()) audio.volume = this.storySoundVolume;
	
	        return audio;
	    },
	    isAudioAvailable: function isAudioAvailable(audio) {
	        if (audio) {
	            var readyState = audio.readyState;
	            var networkState = audio.networkState;
	
	            if (readyState == 0 || networkState == 3) return false;else return true;
	        } else return false;
	    },
	    clearOffSet: function clearOffSet() {
	        this.playTime = -1;
	        this.pauseTime = -1;
	        this.lastPausedSlideIndex = -1;
	        this.oldOffset = 0;
	    },
	    executeCommand: function executeCommand(type, volume) {
	        if (this.isPlaying && (type == 0 || type == 1 || type == 3 || type == 4)) // if is playing then you can change the slide position ... back,forward, first, end
	            return;
	
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var currentIndex = state.currentSlide.currentSlideIndex;
	
	        if (!_PlayController2.default.isAudioEditorAvailable()) {
	            if (volume == undefined) volume = 0.5;
	
	            this.storySoundVolume = volume;
	        }
	
	        switch (type) {
	            case 0:
	                {
	                    if (currentIndex > 0) {
	                        this.clearOffSet();
	                        this.goToSlideIndex(0);
	
	                        if (_PlayController2.default.isAudioEditorAvailable()) _PlayController2.default.resetPropertiesForPreview();else this.clearPreview();
	                    }
	                    break;
	                }
	            case 1:
	                {
	                    if (currentIndex > 0) {
	                        this.clearOffSet();
	                        this.goToSlideIndex(currentIndex - 1);
	
	                        if (_PlayController2.default.isAudioEditorAvailable()) _PlayController2.default.resetPropertiesForPreview();else this.clearPreview();
	                    }
	                    break;
	                }
	            case 2:
	                {
	                    if (_PlayController2.default.isAudioEditorAvailable()) this.playSequence();else this.playPauseStorySound(true);
	                    break;
	                }
	            case 3:
	                {
	                    if (currentIndex < slides.length - 1) {
	                        this.clearOffSet();
	                        this.goToSlideIndex(currentIndex + 1);
	
	                        if (_PlayController2.default.isAudioEditorAvailable()) _PlayController2.default.resetPropertiesForPreview();else this.clearPreview();
	                    }
	                    break;
	                }
	            case 4:
	                {
	                    if (currentIndex != slides.length - 1) {
	                        this.clearOffSet();
	                        this.goToSlideIndex(slides.length - 1);
	
	                        if (_PlayController2.default.isAudioEditorAvailable()) _PlayController2.default.resetPropertiesForPreview();else this.clearPreview();
	                    }
	                    break;
	                }
	            case 5:
	                {
	                    this.clearOffSet();
	                    if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) {
	                        _FullScreenManager2.default.goFullScreenMode();
	                    } else {
	                        this.exitPreview();
	                    }
	                    break;
	                }
	        }
	    },
	    goFullScreenMode: function goFullScreenMode() {
	        _FullScreenManager2.default.goFullScreenMode();
	    },
	    playSequence: function playSequence() {
	        if (this.isPlaying == false) {
	            this.isPlaying = true;
	            _PlayController2.default.play(true);
	        } else {
	            this.isPlaying = false;
	            _PlayController2.default.pause();
	        }
	    },
	    endSequence: function endSequence() {
	        if (this.refreshFunction) this.refreshFunction();
	    },
	    initSequence: function initSequence() {
	        _PlayController2.default.endSequenceCallback = this.endSequence;
	    },
	    slideDurationOffset: function slideDurationOffset() {
	        var ipadOffset = 0;
	
	        // if (platformDetection.isIOS() == true)
	        //     ipadOffset = 1;
	
	        return ipadOffset;
	    },
	    getSlideDuration: function getSlideDuration(value) {
	        var ipadOffset = this.slideDurationOffset();
	
	        if (value == undefined) return _Configuration2.default.SLIDE_DURATION + ipadOffset;else return value + ipadOffset;
	    },
	    exitPreview: function exitPreview() {
	        this.clearOffSet();
	        previewCommands.isPlaying = false;
	
	        _AnimationManager2.default.exitPreview();
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            _PlayController2.default.changeMode();
	        } else {
	            this.pauseStorySound(true);
	            this.clearPreview();
	        }
	
	        var dispatch = this.getDispatch();
	        dispatch((0, _ProductionActions.changeMode)(_ModeConstants2.default.EDITOR));
	
	        _VideoUtils2.default.updateStartPoint();
	
	        if (_VideoUtils2.default.isVideoShapes()) _VideoUtils2.default.playPauseVideoShapes(false, true);
	
	        _HoverManager2.default.hide();
	
	        if (_PlayController2.default.isAudioEditorAvailable()) _SlidesPreloaderNew2.default.exitPreview();else _SlidesPreloader2.default.exitPreview();
	    },
	    clearPreview: function clearPreview() {
	        if (_PlatformDetection2.default.isIOS() == false) this.clearFadeOutTimer();
	
	        if (this.changeSlideVar) clearTimeout(this.changeSlideVar);
	
	        if (this.refreshFunction) this.refreshFunction();
	
	        _AnimationManager2.default.stopAnimations();
	        _ToolTipManager2.default.resetToolTip();
	    },
	    getPlayOffset: function getPlayOffset(isAction, slideIndex) {
	        if (!isAction) return 0;
	
	        var videoSource = this.getSlideVideoSource(slideIndex);
	
	        if (videoSource && videoSource.length > 0) return _VideoUtils2.default.getPlayOffset();else //TODO: take into consideration the audio offset if the current slide has no video
	            return 0;
	    },
	    getPreviousSlidesOffset: function getPreviousSlidesOffset() {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var currentIndex = state.currentSlide.currentSlideIndex;
	        var i;
	        var offsetTime = 0;
	
	        for (i = 0; i < currentIndex; i++) {
	            offsetTime = offsetTime + slides[i].time;
	        }return offsetTime;
	    },
	
	
	    playTime: -1,
	    pauseTime: -1,
	    lastPausedSlideIndex: -1,
	    oldOffset: 0,
	
	    playPauseStorySound: function playPauseStorySound() {
	        var isAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var playState = this.isPlaying;
	        var state = _StoreManager2.default.getState();
	
	        if (playState == false) {
	            var currentSlideTime = state.currentSlide.model.time;
	            var playOffset = 0;
	
	            this.isPlaying = true;
	
	            if (isAction && this.playTime > 0 && this.pauseTime > 0 && this.pauseTime > this.playTime && state.currentSlide.currentSlideIndex == this.lastPausedSlideIndex) {
	                playOffset = (this.pauseTime - this.playTime) / 1000;
	                playOffset = Number(playOffset.toFixed(2));
	
	                if (this.oldOffset >= 0) playOffset = playOffset + this.oldOffset;
	
	                if (playOffset >= currentSlideTime) {
	                    playOffset = 0;
	                    this.oldOffset = 0;
	                } else this.oldOffset = playOffset;
	            }
	
	            this.playTime = new Date().getTime();
	
	            this.playStorySound(this.getPreviousSlidesOffset() + playOffset);
	            this.loadSlideSound(state.currentSlide.currentSlideIndex, playOffset);
	
	            this.changeSlideVar = setTimeout(this.goToNextSlide.bind(this), this.getSlideDuration(currentSlideTime) * 1000 - playOffset * 1000);
	
	            if (!_PlatformDetection2.default.isIOS()) this.checkFade();
	        } else {
	            if (isAction) {
	                this.pauseTime = new Date().getTime();
	                this.lastPausedSlideIndex = state.currentSlide.currentSlideIndex;
	                this.endPlayStorySound(state.currentSlide.currentSlideIndex);
	            } else this.endPlayStorySound();
	        }
	    },
	    endPlayStorySound: function endPlayStorySound() {
	        var excludedVideo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
	
	        if (!_PlatformDetection2.default.isIOS()) this.clearFadeOutTimer();
	
	        _AnimationManager2.default.stopAnimations();
	
	        this.isPlaying = false;
	        this.pauseStorySound(excludedVideo === -1);
	        this.stopSlideSounds();
	        _VideoUtils2.default.refreshVideosInPlayMode(excludedVideo);
	
	        if (this.refreshFunction) this.refreshFunction();
	    },
	    getPlaySoundPosition: function getPlaySoundPosition() {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var currentIndex = state.currentSlide.currentSlideIndex;
	        var totalTime = 0;
	        var i;
	        var slide;
	
	        for (i = 0; i < currentIndex; i++) {
	            slide = slides[i];
	
	            totalTime = totalTime + slide.time;
	        }
	
	        return totalTime;
	    },
	    playStorySound: function playStorySound() {
	        var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	        this.storySoundOperation('play', offset);
	    },
	    checkVideoStartPosition: function checkVideoStartPosition() {
	        var video = _VideoUtils2.default.getCurrentVideo();
	
	        if (video && video.currentSrc && video.currentSrc.length > 0) video.currentTime = _VideoUtils2.default.getStartPoint();
	    },
	    pauseStorySound: function pauseStorySound() {
	        var resetVideo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (_PlatformDetection2.default.isIOS() == false) this.clearFadeOutTimer();
	
	        if (this.changeSlideVar) clearTimeout(this.changeSlideVar);
	
	        this.storySoundOperation('pause');
	
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	            _AudioVolumeUtils2.default.executeMediaAction('slideSound', 0, false);
	            _AudioVolumeUtils2.default.executeMediaAction('slideSoundEffect', 0, false);
	        } else {
	            _AudioUtils2.default.pauseSound('slideSound');
	            _AudioUtils2.default.pauseSound('slideSoundEffect');
	        }
	
	        _AnimationManager2.default.stopAnimations();
	        _VideoUtils2.default.pauseVideoPreview(resetVideo);
	
	        if (!_VideoUtils2.default.isVideoBackground() && _VideoUtils2.default.isVideoShapes()) _VideoUtils2.default.pauseVideoShapesPreview(resetVideo);
	    },
	    endStorySound: function endStorySound() {
	        this.storySoundOperation('restart');
	    },
	    isPlayingAudio: function isPlayingAudio(audio) {
	        var isPlaying = audio.currentTime > 0 && !audio.paused && !audio.ended && audio.readyState > 2;
	
	        return isPlaying;
	    },
	    storySoundOperation: function storySoundOperation(state) {
	        var offsetTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        var audio = this.getStorySound();
	
	        if (!_AudioVolumeUtils2.default.useVolumeFunctionality() && this.isAudioAvailable(audio) == false) return;
	
	        switch (state) {
	            case 'play':
	                {
	                    if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('storySound', this.storySoundVolume, true, this.endStorySound);else {
	                        audio.currentTime = offsetTime;
	                        _AudioUtils2.default.playSound('storySound');
	                    }
	                    break;
	                }
	
	            case 'pause':
	                {
	                    if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('storySound', 0, false);else _AudioUtils2.default.pauseSound('storySound', true);
	                    break;
	                }
	
	            case 'restart':
	                {
	                    if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('storySound', 0, false);else {
	                        audio.currentTime = 0;
	                        _AudioUtils2.default.playSound('storySound');
	                    }
	                    break;
	                }
	        }
	    },
	    goToNextSlide: function goToNextSlide() {
	        if (this.isPlaying == false || this.isEditorMode() == true) return;
	
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var currentIndex = state.currentSlide.currentSlideIndex;
	
	        if (this.isPlaying) {
	            this.playTime = new Date().getTime();
	            this.oldOffset = 0;
	        }
	
	        if (currentIndex < slides.length - 1) {
	            var nextSlide = slides[currentIndex + 1];
	            this.changeSlideToIndex(currentIndex + 1);
	            this.changeSlideVar = setTimeout(this.goToNextSlide.bind(this), this.getSlideDuration(nextSlide.time) * 1000);
	        } else {
	            this.endPlayStorySound();
	        }
	    },
	
	    // Slide Sound functionality
	    getSlideSoundSource: function getSlideSoundSource(index) {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var audio;
	
	        if (slides[index].soundWav) audio = slides[index].soundWav;else audio = slides[index].sound;
	
	        if (audio && audio.length > 0) return audio;else return '';
	    },
	    getSlideSoundEffectSource: function getSlideSoundEffectSource(index) {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var audio = slides[index].soundEffect;
	
	        if (audio && audio.length > 0) return audio;else return '';
	    },
	    loadSlideSound: function loadSlideSound(index) {
	        var playOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        this.loadSlideVideo(index, playOffset);
	
	        if (this.isPlaying == false) return;
	
	        this.stopSlideSounds();
	
	        // Slide Sound
	        var audioSource = this.getSlideSoundSource(index);
	
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.loadAndPlaySound(audioSource, 'slideSound', _AudioUtils2.default.getSoundVolume('slideSound'));else {
	            _AudioUtils2.default.setSoundVolume('slideSound');
	            _AudioUtils2.default.playSlideSoundFromUrl(audioSource, playOffset);
	        }
	
	        // Slide Sound Effect
	        var audioEffectSource = this.getSlideSoundEffectSource(index);
	
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.loadAndPlaySound(audioEffectSource, 'slideSoundEffect', _AudioUtils2.default.getSoundVolume('slideSoundEffect'));else {
	            _AudioUtils2.default.setSoundVolume('slideSoundEffect');
	            _AudioUtils2.default.playSlideSoundEffectFromUrl(audioEffectSource, playOffset);
	        }
	
	        _AnimationManager2.default.startAnimations(false, playOffset * 1000);
	    },
	    stopSlideSounds: function stopSlideSounds() {
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	            _AudioVolumeUtils2.default.executeMediaAction('slideSound', 0, false);
	            _AudioVolumeUtils2.default.executeMediaAction('slideSoundEffect', 0, false);
	        } else {
	            _AudioUtils2.default.pauseSound('slideSound', true);
	            _AudioUtils2.default.pauseSound('slideSoundEffect', true);
	        }
	    },
	    getSlidesText: function getSlidesText() {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var index = state.currentSlide.currentSlideIndex + 1;
	
	        if (index > slides.length) index = slides.length;
	
	        return index + ' / ' + slides.length;
	    },
	
	
	    // Slide video functionality
	    getHostName: function getHostName() {
	        if (_Configuration2.default.IS_PROD()) return 'https://www.creaza.com';else return 'https://stage.creaza.com';
	    },
	    getCorrectUrl: function getCorrectUrl(url) {
	        var newUrl = '';
	
	        if (url && url.indexOf('file/ci') != -1) {
	            if (url.indexOf('www.creaza') == -1 && url.indexOf('stage.creaza') == -1) newUrl = this.getHostName();
	
	            newUrl = newUrl + url;
	        } else {
	            newUrl = url;
	        }
	
	        return newUrl;
	    },
	    getSlideVideoSource: function getSlideVideoSource(index) {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var background = slides[index].content[0];
	        var videoSource = '';
	
	        if (background.isVideo) videoSource = background.xlinkHref;
	
	        if (videoSource && videoSource.length > 0) return this.getCorrectUrl(videoSource);else return '';
	    },
	    loadSlideVideo: function loadSlideVideo(index) {
	        var playOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        _VideoUtils2.default.playVideoFromSlideIndex(index, playOffset, this.isPlaying);
	    },
	
	    // FADE OUT functionality
	    fadeOutAudio: function fadeOutAudio(percentVolume) {
	        var storySound = document.getElementById('storySound');
	
	        if (storySound) storySound.volume = this.storySoundVolume * percentVolume;
	
	        //const slideSound = document.getElementById('slideSound');
	        //slideSound.volume = 1 * percentVolume;
	    },
	    resetFadeOut: function resetFadeOut() {
	        var storySound = document.getElementById('storySound');
	
	        if (storySound && this.storySoundVolume > -1) storySound.volume = this.storySoundVolume;
	
	        //const slideSound = document.getElementById('slideSound');
	        //slideSound.volume = 1;
	    },
	    getFadeVolume: function getFadeVolume(remainingTime) {
	        if (remainingTime < 0 || remainingTime > this.fadeLimit) return 0;
	
	        var value = remainingTime / this.fadeLimit;
	
	        return value;
	    },
	    checkFade: function checkFade() {
	        this.clearFadeOutTimer();
	
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var currentIndex = state.currentSlide.currentSlideIndex;
	        var totalTime = 0;
	        var i;
	        var slide;
	        var offset = this.slideDurationOffset();
	
	        for (i = currentIndex; i < slides.length; i++) {
	            slide = slides[i];
	
	            totalTime = totalTime + slide.time + offset;
	        }
	
	        this.totalTime = totalTime * 1000;
	
	        var date = new Date();
	        this.startTime = date.getTime();
	        this.playbackPositionVar = setInterval(this.checkPlaybackPosition.bind(this), 100);
	
	        this.checkPlaybackPosition();
	    },
	    checkPlaybackPosition: function checkPlaybackPosition() {
	        var date = new Date();
	        var currentTime = date.getTime();
	        var playTime = currentTime - this.startTime;
	        var remainingTime = this.totalTime - playTime;
	
	        if (remainingTime <= this.fadeLimit) {
	            this.fadeOutAudio(this.getFadeVolume(remainingTime));
	        }
	    },
	    clearFadeOutTimer: function clearFadeOutTimer() {
	        if (this.playbackPositionVar) clearInterval(this.playbackPositionVar);
	
	        this.resetFadeOut();
	    }
	};
	
	exports.default = previewCommands;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/PreviewCommands.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/PreviewCommands.js"); } } })();

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ScrollableComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _reactScrollbar = __webpack_require__(911);
	
	var _reactScrollbar2 = _interopRequireDefault(_reactScrollbar);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _DragManager = __webpack_require__(107);
	
	var _DragManager2 = _interopRequireDefault(_DragManager);
	
	var _TimelineDragManager = __webpack_require__(137);
	
	var _TimelineDragManager2 = _interopRequireDefault(_TimelineDragManager);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HorizontalScrollBar = _react2.default.createClass({
	    displayName: 'HorizontalScrollBar',
	    getInitialState: function getInitialState() {
	        _PlayController2.default.updateScrollForIOS = this.updateScroll;
	        _PlayController2.default.startScroll = this.startScroll;
	        _PlayController2.default.moveScroll = this.moveScroll;
	        _PlayController2.default.endScroll = this.endScroll;
	
	        var startPos = this.getThumbPosition();
	
	        return {
	            currentX: startPos,
	            initialX: startPos,
	            scrollWidth: this.props.scrollWidth
	        };
	    },
	    startScroll: function startScroll(e) {
	        var globalX;
	
	        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0) globalX = e.nativeEvent.touches[0].clientX;
	
	        if (!globalX) return;
	
	        this.setState({
	            initialX: this.state.currentX,
	            startX: globalX
	        });
	    },
	    moveScroll: function moveScroll(e) {
	        var target = this.props.target;
	        var globalX;
	
	        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0) globalX = e.nativeEvent.touches[0].clientX;
	
	        if (!globalX || !this.state.startX) return;
	
	        var deltaX = -1 * (globalX - this.state.startX);
	        var thumbWidth = this.props.visibleWidth / this.props.scrollWidth * this.props.visibleWidth;
	        var scale = this.props.scrollWidth / this.props.visibleWidth;
	        var scrollPosition = this.state.initialX + deltaX;
	
	        if (scrollPosition < 0) scrollPosition = 0;
	
	        if (scrollPosition > this.props.visibleWidth - thumbWidth) scrollPosition = this.props.visibleWidth - thumbWidth;
	
	        this.setState({
	            currentX: scrollPosition
	        });
	
	        target.style.left = -(scrollPosition * scale - this.props.paddingLeft) + 'px';
	    },
	    endScroll: function endScroll() {
	        this.setState({
	            startX: undefined
	        });
	    },
	    onDragStart: function onDragStart() {
	        this.setState({
	            initialX: this.state.currentX
	        });
	    },
	    onDragMove: function onDragMove(e, coreEvent) {
	        var target = this.props.target;
	
	        var thumbWidth = this.props.visibleWidth / this.props.scrollWidth * this.props.visibleWidth;
	        var scale = this.props.scrollWidth / this.props.visibleWidth;
	        var scrollPosition = this.state.initialX + coreEvent.lastX;
	
	        if (scrollPosition < 0) scrollPosition = 0;
	
	        if (scrollPosition > this.props.visibleWidth - thumbWidth) scrollPosition = this.props.visibleWidth - thumbWidth;
	
	        this.setState({
	            currentX: scrollPosition
	        });
	
	        target.style.left = -(scrollPosition * scale - this.props.paddingLeft) + 'px';
	    },
	    onDragEnd: function onDragEnd() {
	        this.setState({
	            initialX: this.state.currentX
	        });
	    },
	    getThumbPosition: function getThumbPosition() {
	        var scaleFactor = this.props.visibleWidth / this.props.scrollWidth;
	        var currentSlideTime = _AudioEditorUtils2.default.getCurrentSlidePosition('', true);
	        var currentSlidePosition = _AudioEditorUtils2.default.getSlideWidth(currentSlideTime);
	        var leftSpace = currentSlidePosition - this.props.visibleWidth;
	        var thumbWidth = this.props.visibleWidth / this.props.scrollWidth * this.props.visibleWidth;
	        var thumbPosition = leftSpace * scaleFactor;
	
	        if (thumbPosition < 0) thumbPosition = 0;
	
	        if (thumbPosition > this.props.visibleWidth - thumbWidth) thumbPosition = this.props.visibleWidth - thumbWidth;
	
	        return thumbPosition;
	    },
	    checkScrollPosition: function checkScrollPosition() {
	        if (this.props.target) this.props.target.style.top = '5px';
	
	        if (this.state.scrollWidth != this.props.scrollWidth && this.props.scrollWidth > this.props.visibleWidth) {
	            setTimeout(function () {
	                var thumbPos = this.getThumbPosition();
	                var scale = this.props.scrollWidth / this.props.visibleWidth;
	
	                this.setState({
	                    scrollWidth: this.props.scrollWidth,
	                    currentX: thumbPos,
	                    initialX: thumbPos
	                });
	
	                this.props.target.style.left = -(thumbPos * scale - this.props.paddingLeft) + 'px';
	            }.bind(this), 5);
	        }
	    },
	    updateScroll: function updateScroll(position) {
	        var scaleFactor = this.props.visibleWidth / this.props.scrollWidth;
	        var thumbWidth = scaleFactor * this.props.visibleWidth;
	        var thumbPosition = position * scaleFactor;
	        var scale = this.props.scrollWidth / this.props.visibleWidth;
	
	        if (thumbPosition < 0) thumbPosition = 0;
	
	        if (thumbPosition > this.props.visibleWidth - thumbWidth) thumbPosition = this.props.visibleWidth - thumbWidth;
	
	        this.setState({
	            currentX: thumbPosition,
	            initialX: thumbPosition
	        });
	
	        if (this.props.target) this.props.target.style.left = -(thumbPosition * scale - this.props.paddingLeft) + 'px';
	    },
	    onClick: function onClick(e) {
	        if (e.nativeEvent.target.className.indexOf('react-draggable') != -1) return;
	
	        var localX;
	
	        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0) localX = e.nativeEvent.touches[0].clientX;else localX = e.clientX;
	
	        if (!localX) return;
	
	        var clientBoundingRect = this.refs.track.getBoundingClientRect();
	        var globalX = clientBoundingRect.left;
	
	        localX = localX - globalX;
	
	        var thumbWidth = this.props.visibleWidth / this.props.scrollWidth * this.props.visibleWidth;
	        var scale = this.props.scrollWidth / this.props.visibleWidth;
	
	        if (localX < 0) localX = 0;
	
	        if (localX > this.props.visibleWidth - thumbWidth) localX = this.props.visibleWidth - thumbWidth;
	
	        this.setState({
	            currentX: localX
	        });
	
	        this.props.target.style.left = -(localX * scale - this.props.paddingLeft) + 'px';
	    },
	    render: function render() {
	        this.checkScrollPosition();
	
	        var scrollStyle = {
	            // background: 'red',
	            height: 30,
	            width: this.props.visibleWidth,
	            position: 'fixed',
	            left: _AudioToolUtils2.default.buttonsHolderWidth(),
	            cursor: 'default',
	            userDrag: 'none',
	            bottom: 0,
	            borderRadius: 10,
	            boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)'
	        };
	
	        if (this.props.visibleWidth > this.props.scrollWidth) return _react2.default.createElement('div', { style: scrollStyle });
	
	        var scale = this.props.visibleWidth / this.props.scrollWidth;
	
	        var thumbStyle = {
	            height: 30,
	            width: this.props.visibleWidth * scale,
	            position: 'absolute',
	            cursor: 'default',
	            left: this.state.currentX,
	            borderRadius: 10,
	            boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.5)'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: scrollStyle, ref: 'track', onTouchStart: this.onClick, onClick: this.onClick },
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onDragStart, onDrag: this.onDragMove, onStop: this.onDragEnd },
	                _react2.default.createElement('div', { ref: 'thumb', style: thumbStyle })
	            )
	        );
	    }
	});
	
	var VerticalScrollBar = _react2.default.createClass({
	    displayName: 'VerticalScrollBar',
	    getInitialState: function getInitialState() {
	        var startPos = this.getThumbPosition();
	
	        return {
	            currentY: startPos,
	            initialY: startPos,
	            scrollHeight: this.props.scrollHeight
	        };
	    },
	    onDragStart: function onDragStart() {
	        this.setState({
	            initialY: this.state.currentY
	        });
	    },
	    onDragMove: function onDragMove(e, coreEvent) {
	        var target = this.props.target;
	
	        var thumbHeight = this.props.visibleHeight / this.props.scrollHeight * this.props.visibleHeight;
	        var scale = this.props.scrollHeight / this.props.visibleHeight;
	        var scrollPosition = this.state.initialY + coreEvent.lastY;
	
	        if (scrollPosition < 0) scrollPosition = 0;
	
	        if (scrollPosition > this.props.visibleHeight - thumbHeight) scrollPosition = this.props.visibleHeight - thumbHeight;
	
	        this.setState({
	            currentY: scrollPosition
	        });
	
	        target.style.top = -(scrollPosition * scale - this.props.paddingTop) + 'px';
	    },
	    onDragEnd: function onDragEnd() {
	        this.setState({
	            initialY: this.state.currentY
	        });
	    },
	    getThumbPosition: function getThumbPosition() {
	        return 0;
	    },
	    checkScrollPosition: function checkScrollPosition() {
	        // if (this.props.target)
	        //     this.props.target.style.top = '5px';
	
	        if (this.state.scrollHeight != this.props.scrollHeight && this.props.scrollHeight > this.props.visibleHeight) {
	            setTimeout(function () {
	                var thumbPos = this.getThumbPosition();
	                var scale = this.props.scrollHeight / this.props.visibleHeight;
	
	                this.setState({
	                    scrollHeight: this.props.scrollHeight,
	                    currentY: thumbPos,
	                    initialY: thumbPos
	                });
	
	                this.props.target.style.top = -(thumbPos * scale - this.props.paddingTop) + 'px';
	            }.bind(this), 5);
	        }
	    },
	    onClick: function onClick(e) {
	        if (e.nativeEvent.target.className.indexOf('react-draggable') != -1) return;
	
	        var localY;
	
	        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0) localY = e.nativeEvent.touches[0].clientY;else localY = e.clientY;
	
	        if (!localY) return;
	
	        var clientBoundingRect = this.refs.track.getBoundingClientRect();
	        var globalY = clientBoundingRect.top;
	
	        localY = localY - globalY;
	
	        var thumbHeight = this.props.visibleHeight / this.props.scrollHeight * this.props.visibleHeight;
	        var scale = this.props.scrollHeight / this.props.visibleHeight;
	
	        if (localY < 0) localY = 0;
	
	        if (localY > this.props.visibleHeight - thumbHeight) localY = this.props.visibleHeight - thumbHeight;
	
	        this.setState({
	            currentY: localY
	        });
	
	        this.props.target.style.top = -(localY * scale - this.props.paddingTop) + 'px';
	    },
	    render: function render() {
	        this.checkScrollPosition();
	
	        var topPos = this.props.top;
	
	        if (this.props.extraTopPadding > 0) topPos = topPos + this.props.extraTopPadding;
	
	        var scrollStyle = {
	            // background: 'red',
	            top: topPos,
	            width: _Properties2.default.AUDIO_BROWSER_SCROLL_WIDTH,
	            height: this.props.visibleHeight,
	            position: 'fixed',
	            cursor: 'default',
	            userDrag: 'none',
	            right: 0,
	            borderRadius: 10,
	            boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)'
	        };
	
	        if (this.props.visibleHeight > this.props.scrollHeight) return _react2.default.createElement('div', { style: scrollStyle });
	
	        var scale = this.props.visibleHeight / this.props.scrollHeight;
	
	        var thumbStyle = {
	            width: scrollStyle.width,
	            height: this.props.visibleHeight * scale,
	            position: 'absolute',
	            cursor: 'default',
	            top: this.state.currentY,
	            borderRadius: 10,
	            boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.5)'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: scrollStyle, ref: 'track', onTouchStart: this.onClick, onClick: this.onClick },
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onDragStart, onDrag: this.onDragMove, onStop: this.onDragEnd },
	                _react2.default.createElement('div', { ref: 'thumb', style: thumbStyle })
	            )
	        );
	    }
	});
	
	var ScrollableComponent = exports.ScrollableComponent = _react2.default.createClass({
	    displayName: 'ScrollableComponent',
	    getInitialState: function getInitialState() {
	        if (this.props.componentProperties.isHorizontal == true && this.props.componentProperties.id == 'slidesList') {
	            _DragManager2.default.moveScroll = this.updateScrollWhenDrag;
	            _TimelineDragManager2.default.moveScroll = this.updateScrollWhenDrag;
	        }
	
	        return {
	            currentY: 0,
	            initialY: 0,
	            thumbY: 0,
	            initialThumbY: 0,
	            scrollWidth: 0,
	            currentSlideIndex: -1
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        setTimeout(this.refreshView, 20);
	        document.addEventListener('keydown', this.onKeyDown);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('keydown', this.onKeyDown);
	    },
	    updateScrollWhenDrag: function updateScrollWhenDrag() {
	        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	        if (this.props.componentProperties.isHorizontal == true && this.props.componentProperties.id == 'slidesList') {
	            var scrollElement = this.refs.scrollElement;
	
	            if (scrollElement) {
	                var step = _Properties2.default.AUTO_SCROLL_STEP;
	
	                if (value > 0) scrollElement.scrollLeft = scrollElement.scrollLeft + step;else scrollElement.scrollLeft = scrollElement.scrollLeft - step;
	            }
	        }
	    },
	    isSlideCommand: function isSlideCommand() {
	        var state = _StoreManager2.default.getState();
	        var isSlideComand = state.currentSlide.isSlideCommand;
	
	        if (isSlideComand == true) return true;else return false;
	    },
	    getLastSlideWidth: function getLastSlideWidth() {
	        var isLeft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        var state = _StoreManager2.default.getState();
	        var currentIndex = state.currentSlide.currentSlideIndex;
	        var slides = state.production.slides;
	        var slide;
	
	        if (currentIndex > 0 && currentIndex < slides.length - 1) {
	            if (!isLeft) // right
	                currentIndex = currentIndex - 1;else // left
	                currentIndex = currentIndex + 1;
	
	            slide = slides[currentIndex];
	        }
	
	        if (slide) return _AudioEditorUtils2.default.getSlideWidth(slide.time);else return 0;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (this.props.componentProperties.isHorizontal == true && this.props.componentProperties.id == 'slidesList' && this.isSlideCommand()) {
	            var scrollElement = this.refs.scrollElement;
	
	            if (scrollElement) {
	                var scrollWidth = this.getScrollWidth();
	                var visibleWidth = this.props.componentProperties.width;
	                var thumbWidth = visibleWidth / scrollWidth * visibleWidth;
	                var elementsLength = this.props.componentProperties.elementsLength > 1 ? this.props.componentProperties.elementsLength : this.props.componentProperties.elements.length;
	                var step;
	
	                if (e.keyCode == 39) {
	                    // Right arrow
	                    step = _PlayController2.default.isAudioEditorMode() ? this.getLastSlideWidth(false) : (scrollWidth - thumbWidth) / elementsLength;
	                    scrollElement.scrollLeft = scrollElement.scrollLeft + step;
	                    e.preventDefault();
	                    return false;
	                } else if (e.keyCode == 37) {
	                    // Left arrow
	                    step = _PlayController2.default.isAudioEditorMode() ? this.getLastSlideWidth(true) : (scrollWidth - thumbWidth) / elementsLength;
	                    scrollElement.scrollLeft = scrollElement.scrollLeft - step;
	                    e.preventDefault();
	                    return false;
	                }
	            }
	        }
	    },
	    refreshView: function refreshView() {
	        this.forceUpdate();
	    },
	    getScrollWidth: function getScrollWidth() {
	        if (this.props.componentProperties.scrollWidth > 0) return this.props.componentProperties.scrollWidth;
	
	        var width = 0;
	
	        if (this.refs.scrollArea) width = this.refs.scrollArea.scrollWidth;
	
	        return width;
	    },
	    getScrollHeight: function getScrollHeight() {
	        if (this.props.componentProperties.scrollHeight > 0) return this.props.componentProperties.scrollHeight;
	
	        var height = 0;
	
	        if (this.refs.scrollArea) height = this.refs.scrollArea.scrollHeight;
	
	        return height;
	    },
	    onDragStart: function onDragStart() {
	        if (_PlatformDetection2.default.isTouchableDevice() == false) return;
	
	        this.setState({
	            initialY: this.state.currentY
	        });
	    },
	    onDragMove: function onDragMove(e, coreEvent) {
	        if (_PlatformDetection2.default.isTouchableDevice() == false) return;
	
	        this.move(coreEvent.lastY);
	    },
	    move: function move(offset) {
	        var scrollHeight = this.getScrollHeight() + this.props.componentProperties.paddingTop;
	        var visibleHeight = this.props.componentProperties.height;
	
	        if (visibleHeight >= scrollHeight) return;
	
	        var thumbHeight = visibleHeight / scrollHeight * visibleHeight;
	
	        var scrollAreaY = this.state.initialY + offset;
	
	        if (scrollAreaY > 0) scrollAreaY = 0;
	
	        if (scrollAreaY < -1 * (scrollHeight - visibleHeight)) scrollAreaY = -1 * (scrollHeight - visibleHeight);
	
	        var thumbPosition = -scrollAreaY * (visibleHeight - thumbHeight) / (scrollHeight - visibleHeight);
	
	        this.setState({
	            currentY: scrollAreaY,
	            thumbY: thumbPosition
	        });
	    },
	    onDragEnd: function onDragEnd() {
	        if (_PlatformDetection2.default.isTouchableDevice() == false) return;
	
	        this.setState({
	            initialY: this.state.currentY
	        });
	    },
	    scrollDragStart: function scrollDragStart() {
	        this.setState({
	            initialThumbY: this.state.thumbY,
	            initialY: this.state.currentY
	        });
	    },
	    scrollDragMove: function scrollDragMove(offset) {
	        var scrollHeight = this.getScrollHeight() + this.props.componentProperties.paddingTop;
	        var visibleHeight = this.props.componentProperties.height;
	
	        if (visibleHeight >= scrollHeight) return;
	
	        var thumbHeight = visibleHeight / scrollHeight * visibleHeight;
	        var thumbPosition = this.state.initialThumbY + offset;
	
	        if (thumbPosition < 0) thumbPosition = 0;
	
	        if (thumbPosition > visibleHeight - thumbHeight) thumbPosition = visibleHeight - thumbHeight;
	
	        var scale = (visibleHeight - thumbHeight) / (scrollHeight - visibleHeight);
	        var scrollAreaY = -thumbPosition / scale;
	
	        this.setState({
	            thumbY: thumbPosition,
	            currentY: scrollAreaY
	        });
	    },
	    scrollDragEnd: function scrollDragEnd() {
	        this.setState({
	            initialY: this.state.currentY
	        });
	    },
	    refreshScroll: function refreshScroll() {
	        this.forceUpdate();
	    },
	    checkScroll: function checkScroll() {
	        setTimeout(this.updateScrollPosition, 10);
	    },
	    updateScrollPosition: function updateScrollPosition() {
	        if (this.props.componentProperties.isHorizontal == true) {
	            var scrollWidth = this.getScrollWidth();
	            var currentSlideIndex = _StoreManager2.default.getState().currentSlide.currentSlideIndex;
	
	            if (this.state.scrollWidth > 0 && Math.abs(scrollWidth - this.state.scrollWidth) > 60 || _MouseUtils2.default.isKeyboardShortcut == true && currentSlideIndex != this.state.currentSlideIndex && this.state.currentSlideIndex > -1) {
	                var scrollElement = this.refs.scrollElement;
	                var state = _StoreManager2.default.getState();
	                var visibleWidth = this.props.componentProperties.width;
	                var currentSlidePosition = (_Properties2.default.SLIDE_ITEM_WIDTH + _Properties2.default.SLIDE_GAP) * (state.currentSlide.currentSlideIndex + 1);
	                var outsideOffset = currentSlidePosition - visibleWidth;
	
	                if (_PlatformDetection2.default.isTouchableDevice() == true) {
	                    if (this.refs.scrollView) this.refs.scrollView.scrollXTo(outsideOffset);
	                } else {
	                    if (scrollElement) scrollElement.scrollLeft = outsideOffset;
	                }
	            }
	
	            if (currentSlideIndex != this.state.currentSlideIndex) {
	                this.setState({
	                    currentSlideIndex: currentSlideIndex
	                });
	            }
	
	            if (scrollWidth != this.state.scrollWidth) {
	                this.setState({
	                    scrollWidth: scrollWidth
	                });
	            }
	        }
	
	        _MouseUtils2.default.isKeyboardShortcut = false;
	    },
	    isAudioEditor: function isAudioEditor() {
	        var componentProperties = this.props.componentProperties;
	
	        if (componentProperties.isAudioEditor == true) return true;else return false;
	    },
	    onScrollHandler: function onScrollHandler(e) {
	        var componentProperties = this.props.componentProperties;
	
	        if (componentProperties.usePagination) {
	            // keep the scrolling functionality
	        } else {
	            if (!_MasterUniverseUtils2.default.useThumbnailsLazyLoading()) return;
	        }
	
	        var scrollVisibleHeight = componentProperties.height;
	        var currentTarget = e.currentTarget;
	        var scrollTop = 0;
	        var scrollHeight = 0;
	
	        if (currentTarget && currentTarget.scrollTop) {
	            scrollTop = currentTarget.scrollTop;
	            scrollHeight = currentTarget.scrollHeight;
	        } else if (e.topPosition >= 0) {
	            scrollTop = e.topPosition;
	            scrollHeight = e.realHeight;
	        }
	
	        if (Math.abs(scrollHeight - scrollTop - scrollVisibleHeight) <= 20) {
	            // load new scroll page
	            if (componentProperties.uploadNewPage) componentProperties.uploadNewPage(scrollTop);
	        } else {
	            if (componentProperties.updateScrollHandler) componentProperties.updateScrollHandler(scrollTop);
	        }
	    },
	    render: function render() {
	        var componentProperties = this.props.componentProperties;
	        var height = componentProperties.height - componentProperties.paddingTop;
	
	        var backgroundColor = 'white';
	
	        if (componentProperties.backgroundColor != undefined) backgroundColor = componentProperties.backgroundColor;
	
	        var wrapperStyle = {
	            width: componentProperties.width - componentProperties.paddingLeft,
	            height: height,
	            top: componentProperties.top,
	            paddingTop: componentProperties.paddingTop,
	            paddingLeft: componentProperties.paddingLeft,
	            display: componentProperties.displayState,
	            backgroundColor: backgroundColor,
	            position: 'absolute',
	            overflowX: 'hidden',
	            overflowY: 'auto',
	            cursor: 'default',
	            userDrag: 'none'
	        };
	
	        var scrollAreaStyle = {
	            position: 'absolute'
	        };
	
	        var scroll;
	
	        if (componentProperties.isHorizontal == true) {
	            wrapperStyle.overflowX = 'scroll';
	            wrapperStyle.overflowY = 'hidden';
	            wrapperStyle.backgroundColor = undefined;
	            scrollAreaStyle.width = componentProperties.scrollWidth;
	        }
	
	        if (_PlatformDetection2.default.isTouchableDevice() == true) {
	            if (componentProperties.isHorizontal == true) {
	                var _scrollWidth = this.getScrollWidth() + componentProperties.paddingLeft;
	
	                wrapperStyle.overflowX = 'hidden';
	                wrapperStyle.display = 'contents';
	                wrapperStyle.backgroundColor = undefined;
	                scrollAreaStyle.width = _scrollWidth;
	
	                if (this.isAudioEditor()) {
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'scrollComponent', ref: 'scrollElement', style: wrapperStyle, id: componentProperties.id },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'scrollComponent scrollForIOS', ref: 'scrollArea', style: scrollAreaStyle },
	                            componentProperties.elements
	                        ),
	                        _react2.default.createElement(HorizontalScrollBar, { scrollWidth: _scrollWidth, visibleWidth: componentProperties.width, target: this.refs.scrollArea, paddingLeft: componentProperties.paddingLeft })
	                    );
	                }
	            } else {
	                if (this.isAudioEditor()) {
	                    wrapperStyle.overflowX = 'hidden';
	                    wrapperStyle.overflowY = 'hidden';
	                    wrapperStyle.backgroundColor = undefined;
	                    scrollAreaStyle.height = componentProperties.scrollHeight;
	
	                    var searchHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT + _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight();
	
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'scrollComponent', ref: 'scrollElement', style: wrapperStyle, id: componentProperties.id },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'scrollComponent scrollVerticalForIos', ref: 'scrollArea', style: scrollAreaStyle },
	                            componentProperties.elements
	                        ),
	                        _react2.default.createElement(VerticalScrollBar, { scrollHeight: componentProperties.scrollHeight, extraTopPadding: componentProperties.extraTopPadding, visibleHeight: componentProperties.height, top: componentProperties.top + searchHeight, target: this.refs.scrollArea, paddingTop: componentProperties.paddingTop })
	                    );
	                }
	
	                wrapperStyle.overflowY = 'hidden';
	                scrollAreaStyle.top = this.state.currentY + componentProperties.paddingTop;
	            }
	        }
	
	        var isTouchableNonAudioEditor = _PlatformDetection2.default.isTouchableDevice() && !this.isAudioEditor();
	        var isHorizontal = componentProperties.isHorizontal == true;
	
	        if (isTouchableNonAudioEditor) {
	            if (!isHorizontal) {
	                // Vertical
	                var componentWidth = componentProperties.width - componentProperties.paddingLeft;
	                var componentHeight = height;
	                var scrollHeight = 0;
	
	                if (componentProperties.scrollHeight > 0) scrollHeight = componentProperties.scrollHeight + componentProperties.paddingTop;
	
	                var myScrollbar = {
	                    width: componentWidth,
	                    height: componentHeight
	                };
	
	                var scrollParentStyle = {
	                    width: componentWidth
	                };
	
	                if (scrollHeight > 0) scrollParentStyle.height = scrollHeight;
	
	                wrapperStyle.overflowY = 'hidden';
	
	                var trackStyle = {
	                    opacity: 1,
	                    background: 'white',
	                    borderRadius: 10,
	                    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
	                    position: 'absolute'
	                };
	
	                var thumbStyle = {
	                    position: 'absolute',
	                    background: 'white',
	                    borderRadius: 10,
	                    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.5)'
	                };
	
	                if (_PlatformDetection2.default.isMixedDevice() == true && _PlatformDetection2.default.isIOS() == false) {
	                    trackStyle.width = 15;
	                    thumbStyle.width = 15;
	                }
	
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'scrollComponent', style: wrapperStyle, id: componentProperties.id },
	                    _react2.default.createElement(
	                        _reactScrollbar2.default,
	                        { style: myScrollbar, speed: 0.8, horizontal: false, smoothScrolling: true, stopScrollPropagation: true, onScroll: this.onScrollHandler, verticalContainerStyle: trackStyle, verticalScrollbarStyle: thumbStyle },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'scrollComponent', style: scrollParentStyle },
	                            componentProperties.elements
	                        )
	                    )
	                );
	            } else {
	                // Horizontal
	                var _componentWidth = componentProperties.width;
	                var _componentHeight = componentProperties.height;
	                var scrollWidth = componentProperties.scrollWidth;
	
	                var _myScrollbar = {
	                    width: _componentWidth,
	                    height: _componentHeight
	                };
	
	                var scrollParentStyle = {
	                    width: scrollWidth,
	                    height: _componentHeight,
	                    paddingTop: 5
	                };
	
	                var scrollStyle = {
	                    width: scrollWidth,
	                    height: _componentHeight
	                };
	
	                wrapperStyle.overflowX = 'hidden';
	                wrapperStyle.overflowY = 'hidden';
	
	                var hiddenTrackStyle = {
	                    opacity: 1,
	                    background: 'white',
	                    borderRadius: 10,
	                    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
	                    position: 'absolute',
	                    width: _componentWidth,
	                    height: 15,
	                    top: 69
	                };
	
	                var trackStyle = {
	                    opacity: 1,
	                    background: 'white',
	                    borderRadius: 10,
	                    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
	                    position: 'absolute'
	                };
	
	                var thumbStyle = {
	                    position: 'absolute',
	                    background: 'white',
	                    borderRadius: 10,
	                    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.5)'
	                };
	
	                trackStyle.height = 15;
	                trackStyle.bottom = 2;
	
	                thumbStyle.height = 15;
	
	                var isScrollBarEnabled = true;
	
	                if (_PlatformDetection2.default.isIOS() == true && _MouseUtils2.default.isActive() == true) isScrollBarEnabled = false;
	
	                this.checkScroll();
	                _MouseUtils2.default.refreshScrollFunction = this.refreshScroll;
	
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'scrollComponent', style: wrapperStyle, id: componentProperties.id },
	                    _react2.default.createElement(
	                        _reactScrollbar2.default,
	                        { ref: 'scrollView', style: _myScrollbar, contentStyle: scrollParentStyle, speed: 0.8, horizontal: isScrollBarEnabled, vertical: false, smoothScrolling: true, stopScrollPropagation: true, horizontalContainerStyle: trackStyle, horizontalScrollbarStyle: thumbStyle, swapWheelAxes: true },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'scrollComponent', style: scrollStyle },
	                            componentProperties.elements
	                        )
	                    ),
	                    _react2.default.createElement('div', { style: hiddenTrackStyle })
	                );
	            }
	        } else {
	            this.checkScroll();
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'scrollComponent', ref: 'scrollElement', style: wrapperStyle, id: componentProperties.id, onScroll: this.onScrollHandler },
	                _react2.default.createElement(
	                    _reactDraggable2.default,
	                    { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onDragStart, onDrag: this.onDragMove, onStop: this.onDragEnd },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'scrollComponent', ref: 'scrollArea', style: scrollAreaStyle },
	                        componentProperties.elements
	                    )
	                ),
	                scroll
	            );
	        }
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ScrollableComponent.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ScrollableComponent.js"); } } })();

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _AvailableFonts = __webpack_require__(175);
	
	var _AvailableFonts2 = _interopRequireDefault(_AvailableFonts);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MenuActions = __webpack_require__(7);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _MindMapUtils = __webpack_require__(85);
	
	var _MindMapUtils2 = _interopRequireDefault(_MindMapUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textEditorUtils = {
	    selectedTextShape: '',
	    isClick: false, // used to know if is click or drag-drop when move shape
	    isShapeAlreadySelected: false, // used to know if a shape is already selected or not before clicking on it
	    currentFont: _AvailableFonts2.default.defaultFont,
	    defaultFontSize: 24,
	    currentFontSize: 24,
	    savedSelection: undefined,
	    lastCursorPosition: -1, // used to know where the last click was done on text area
	
	    useRichText: function useRichText() {
	        if (_PlatformDetection2.default.isIOS()) // keep the old functionality for IOS
	            return false;
	
	        return true;
	
	        var testUsers = [15682463, 54719315, 54829736, 54829790, 54829795, 54829800];
	
	        if (!_Configuration2.default.IS_PROD() || _Configuration2.default.LOAD_LOCAL || _Configuration2.default.IS_PROD() && testUsers.indexOf(_AppParameters2.default.currentUserId) != -1) return true;else return false;
	    },
	    isTextEditorTool: function isTextEditorTool() {
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.TEXT_EDITOR) return true;else return false;
	    },
	    isInteractiveTextElementFocused: function isInteractiveTextElementFocused() {
	        var activeElement = document.activeElement;
	
	        if (activeElement && activeElement.id.indexOf('interactiveElement_') != -1) return true;else return false;
	    },
	    openTextEditorTool: function openTextEditorTool(shapeModel, keyboardCharacter) {
	        this.isClick = false;
	        this.resetActions();
	
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT || _StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        dispatch((0, _MenuActions.setContextTarget)(shapeModel, false));
	
	        _MouseUtils2.default.activeElement = shapeModel.uuid; // used for tab sequence
	
	        setTimeout(function () {
	            var textArea = document.getElementById('text_area_' + shapeModel.uuid);
	
	            if (textArea) {
	                textArea.style.cursor = 'text';
	                textArea.contentEditable = true;
	
	                textArea.focus();
	                this.setCursorAtLastPosition(textArea, shapeModel, keyboardCharacter);
	            }
	
	            this.selectedTextShape = shapeModel.uuid;
	
	            setTimeout(function () {
	                dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.TEXT_EDITOR));
	            }.bind(this), 2);
	        }.bind(this), 2);
	    },
	    setCursorAtLastPosition: function setCursorAtLastPosition(contentElement, shapeModel, keyboardCharacter) {
	        var revertUnderline = this.isUnderlineAction && !this.isUnderline; // when we try to revert underline, then the 'text-decoration-line == none' doesn't work to remove also the underline from the parent, so the new node with non-underline should be added outside of the parent node with underline to not inherit the underline property.
	        var revertSuper = this.isSuperAction && !this.isSuper;
	        var revertSub = this.isSubAction && !this.isSub;
	
	        if (this.savedSelection && !revertUnderline && !revertSuper && !revertSub) // set previous selection
	            this.restoreSelection(document.getElementById('text_area_' + shapeModel.uuid));else {
	            // add cursor at the end
	            var range = document.createRange();
	            var selection = window.getSelection();
	
	            if (contentElement.childNodes.length > 0 && !this.isUnderlineAction && !this.isSuperAction && !this.isSubAction) {
	                var lastChildren = this.getLastChildren(contentElement);
	
	                if (lastChildren) {
	                    if (lastChildren.length > 0) range.setStart(this.getLastChildren(contentElement), lastChildren.length);else range.setStart(this.getLastChildren(contentElement), 0);
	                }
	            } else range.setStart(contentElement, contentElement.childNodes.length);
	
	            range.collapse(true);
	            selection.removeAllRanges();
	            selection.addRange(range);
	        }
	
	        if (!keyboardCharacter) return;
	
	        if (this.isPrintableCharacter(keyboardCharacter.keyCode)) this.insertTextAtCursor(shapeModel, keyboardCharacter.key);
	    },
	    insertTextAtCursor: function insertTextAtCursor(shapeModel, text) {
	        var selection = window.getSelection();
	        var range = selection.getRangeAt(0);
	        range.deleteContents();
	
	        var node = document.createTextNode(text);
	        var span = document.createElement('span');
	
	        span.style.fontSize = this.currentFontSize + 'px';
	        span.style.fontFamily = this.currentFont;
	
	        if (this.isBoldAction) {
	            if (this.isBold) span.style['font-weight'] = 'bold';else span.style['font-weight'] = 'normal';
	        }
	
	        if (this.isItalicAction) {
	            if (this.isItalic) span.style['font-style'] = 'italic';else span.style['font-style'] = 'normal';
	        }
	
	        if (this.isUnderlineAction) {
	            if (this.isUnderline) span.style['text-decoration-line'] = 'underline';
	        }
	
	        if (this.isSuperAction) {
	            if (this.isSuper) span.style['vertical-align'] = 'super';
	        }
	
	        if (this.isSubAction) {
	            if (this.isSub) span.style['vertical-align'] = 'sub';
	        }
	
	        if (this.isFontColorAction && this.fontColor) span.style['color'] = this.fontColor;
	
	        span.appendChild(node);
	        range.insertNode(span);
	
	        for (var position = 0; position != text.length; position++) {
	            selection.modify('move', 'right', 'character');
	        }
	
	        this.updateShapeSize(shapeModel, _StoreManager2.default.getStore().dispatch);
	    },
	    getLastChildren: function getLastChildren(contentElement) {
	        if (contentElement.childNodes.length > 0) return this.getLastChildren(contentElement.childNodes[contentElement.childNodes.length - 1]);else return contentElement;
	    },
	    isPrintableCharacter: function isPrintableCharacter(keycode) {
	        if (keycode > 47 && keycode < 58 || // number keys
	        keycode > 64 && keycode < 91 || // letter keys
	        keycode > 95 && keycode < 112 || // numpad keys
	        keycode > 185 && keycode < 193 || // ;=,-./` (in order)
	        keycode > 218 && keycode < 223) // [\]' (in order)
	            return true;else return false;
	    },
	    saveSelection: function saveSelection(containerEl) {
	        var start = void 0;
	
	        if (window.getSelection && document.createRange) {
	            var range = window.getSelection().getRangeAt(0);
	            var preSelectionRange = range.cloneRange();
	
	            preSelectionRange.selectNodeContents(containerEl);
	            preSelectionRange.setEnd(range.startContainer, range.startOffset);
	            start = preSelectionRange.toString().length;
	
	            this.savedSelection = { start: start, end: start + range.toString().length };
	        } else if (document.selection) {
	            var selectedTextRange = document.selection.createRange();
	            var preSelectionTextRange = document.body.createTextRange();
	
	            preSelectionTextRange.moveToElementText(containerEl);
	            preSelectionTextRange.setEndPoint("EndToStart", selectedTextRange);
	
	            var _start = preSelectionTextRange.text.length;
	
	            this.savedSelection = { start: _start, end: _start + selectedTextRange.text.length };
	        }
	    },
	    restoreSelection: function restoreSelection(containerEl) {
	        var savedSel = this.savedSelection;
	
	        if (window.getSelection && document.createRange) {
	            var charIndex = 0,
	                range = document.createRange();
	            range.setStart(containerEl, 0);
	            range.collapse(true);
	            var nodeStack = [containerEl],
	                node = void 0,
	                foundStart = false,
	                stop = false;
	
	            while (!stop && (node = nodeStack.pop())) {
	                if (node.nodeType == 3) {
	                    var nextCharIndex = charIndex + node.length;
	                    if (!foundStart && savedSel.start >= charIndex && savedSel.start <= nextCharIndex) {
	                        range.setStart(node, savedSel.start - charIndex);
	                        foundStart = true;
	                    }
	                    if (foundStart && savedSel.end >= charIndex && savedSel.end <= nextCharIndex) {
	                        range.setEnd(node, savedSel.end - charIndex);
	                        stop = true;
	                    }
	                    charIndex = nextCharIndex;
	                } else {
	                    var i = node.childNodes.length;
	                    while (i--) {
	                        nodeStack.push(node.childNodes[i]);
	                    }
	                }
	            }
	
	            var sel = window.getSelection();
	            sel.removeAllRanges();
	            sel.addRange(range);
	        } else if (document.selection) {
	            var textRange = document.body.createTextRange();
	            textRange.moveToElementText(containerEl);
	            textRange.collapse(true);
	            textRange.moveEnd("character", savedSel.end);
	            textRange.moveStart("character", savedSel.start);
	            textRange.select();
	        }
	    },
	    checkForSizeAttribute: function checkForSizeAttribute(parentElement) {
	        var innerHtml = parentElement.innerHTML;
	
	        if (innerHtml && (innerHtml.indexOf('xxx-large') != -1 || innerHtml.indexOf('<img') != -1)) // the size was change when there was no text selection, so the "font-size: xxx-large" attribute was set there ORRRRR an image was inserted with copy/Paste
	            this.checkChildrenNodes(parentElement);
	
	        if (innerHtml && innerHtml.indexOf('<li') != -1) // check for the font-size of the first element inside of LI node
	            this.checkListNodes(parentElement);
	    },
	    checkChildrenNodes: function checkChildrenNodes(parentElement) {
	        var childNodes = parentElement.children;
	
	        if (childNodes && childNodes.length > 0) {
	            for (var i = 0; i < childNodes.length; i++) {
	                var node = childNodes[i];
	
	                if (node && node.style.fontSize && node.style.fontSize === 'xxx-large') node.style.fontSize = this.currentFontSize + 'px';
	
	                if (node && node.nodeName === 'IMG') node.remove();
	
	                this.checkChildrenNodes(node);
	            }
	        }
	    },
	    checkListNodes: function checkListNodes(parentElement) {
	        var childNodes = parentElement.children;
	
	        if (childNodes && childNodes.length > 0) {
	            for (var i = 0; i < childNodes.length; i++) {
	                var node = childNodes[i];
	
	                if (node && node.nodeName === 'LI') {
	                    var fontSize = this.getFontSizeFromFirstNode(node);
	
	                    if (fontSize > 0) node.style.fontSize = fontSize + 'px';
	
	                    if (node.parentNode.nodeName === 'OL' || node.parentNode.nodeName === 'UL') {
	                        node.parentNode.style['padding-left'] = '0px';
	                        node.parentNode.style['list-style-position'] = 'inside';
	                    }
	                }
	
	                this.checkListNodes(node);
	            }
	        }
	    },
	    getFontSizeFromFirstNode: function getFontSizeFromFirstNode(parentElement) {
	        var childNodes = parentElement.children;
	        var currentNodeFontSize = 0;
	
	        if (childNodes && childNodes.length > 0) {
	            var node = childNodes[0];
	
	            if (node && node.style.fontSize) currentNodeFontSize = parseInt(node.style.fontSize);
	
	            if (currentNodeFontSize > 0) return currentNodeFontSize;
	
	            return this.getFontSizeFromFirstNode(node);
	        }
	
	        return currentNodeFontSize;
	    },
	
	
	    isBoldAction: false,
	    isBold: false,
	    isItalicAction: false,
	    isItalic: false,
	    isUnderlineAction: false,
	    isUnderline: false,
	    isSuperAction: false,
	    isSuper: false,
	    isSubAction: false,
	    isSub: false,
	    isFontColorAction: false,
	    fontColor: undefined,
	    isFontFamilyAction: false,
	    fontFamily: undefined,
	    isFontSizeAction: false,
	    fontSize: undefined,
	
	    executeAction: function executeAction(index, value) {
	        // when click on Bold, Italic, Underline, Super, Sub, font Color button, font Family button
	        var selection = window.getSelection();
	
	        if (selection.anchorOffset === selection.extentOffset) // no text selected and only the cursor pointer
	            this.lastCursorPosition = selection.anchorOffset;else this.lastCursorPosition = -1;
	
	        this.saveSelection(document.getElementById('text_area_' + this.selectedTextShape));
	
	        switch (index) {
	            case 1:
	                {
	                    // bold
	                    if (this.isBoldAction) this.isBold = !this.isBold;else this.isBold = !this.isSelectedStyle('bold');
	
	                    this.isBoldAction = true;
	                    break;
	                }
	            case 2:
	                {
	                    // italic
	                    if (this.isItalicAction) this.isItalic = !this.isItalic;else this.isItalic = !this.isSelectedStyle('italic');
	
	                    this.isItalicAction = true;
	                    break;
	                }
	            case 3:
	                {
	                    // underline
	                    if (this.isUnderlineAction) this.isUnderline = !this.isUnderline;else this.isUnderline = !this.isSelectedStyle('underline');
	
	                    this.isUnderlineAction = true;
	                    break;
	                }
	            case 11:
	                {
	                    // super
	                    this.isSubAction = false;
	
	                    if (this.isSuperAction) this.isSuper = !this.isSuper;else this.isSuper = !this.isSelectedStyle('super');
	
	                    this.isSuperAction = true;
	                    break;
	                }
	            case 12:
	                {
	                    // sub
	                    this.isSuperAction = false;
	
	                    if (this.isSubAction) this.isSub = !this.isSub;else this.isSub = !this.isSelectedStyle('sub');
	
	                    this.isSubAction = true;
	                    break;
	                }
	            case 14:
	                {
	                    // font family
	                    this.fontFamily = value;
	                    this.isFontFamilyAction = true;
	                    break;
	                }
	            case 20:
	                {
	                    // font color
	                    this.fontColor = value;
	                    this.isFontColorAction = true;
	                    break;
	                }
	            case 15:
	                {
	                    // font size
	                    this.fontSize = value;
	                    this.isFontSizeAction = true;
	                    break;
	                }
	        }
	    },
	    isSelectedStyle: function isSelectedStyle(style) {
	        switch (style) {
	            case 'bold':
	                {
	                    if (this.isBoldAction) return this.isBold;
	
	                    break;
	                }
	            case 'italic':
	                {
	                    if (this.isItalicAction) return this.isItalic;
	
	                    break;
	                }
	            case 'underline':
	                {
	                    if (this.isUnderlineAction) return this.isUnderline;
	
	                    break;
	                }
	            case 'super':
	                {
	                    if (this.isSubAction) return false;
	
	                    if (this.isSuperAction) return this.isSuper;
	
	                    break;
	                }
	            case 'sub':
	                {
	                    if (this.isSuperAction) return false;
	
	                    if (this.isSubAction) return this.isSub;
	
	                    break;
	                }
	        }
	
	        var selection = window.getSelection();
	
	        if (!selection || !selection.anchorNode || selection.anchorNode.id && selection.anchorNode.id.indexOf('text_area') != -1) {
	            if (style === 'left') // default is leftAlignment ... so if no text-align style then let it selected
	                return true;else return false;
	        }
	
	        var parentNode = selection.anchorNode.parentNode;
	
	        return this.checkStyle(parentNode, style);
	    },
	    checkStyle: function checkStyle(nodeElement, style) {
	        if (nodeElement && nodeElement.nodeName === 'foreignObject') {
	            if (style === 'left') // default is leftAlignment ... so if no text-align style then let it selected
	                return true;else return false;
	        }
	
	        if (nodeElement && nodeElement.style) {
	            var cssValue = void 0;
	            var isSelected = false;
	
	            switch (style) {
	                case 'bold':
	                    {
	                        cssValue = nodeElement.style['font-weight'];
	
	                        if (cssValue) {
	                            if (cssValue === style) isSelected = true;
	                        } else return this.checkStyle(nodeElement.parentNode, style);
	                        break;
	                    }
	                case 'italic':
	                    {
	                        cssValue = nodeElement.style['font-style'];
	
	                        if (cssValue) {
	                            if (cssValue === style) isSelected = true;
	                        } else return this.checkStyle(nodeElement.parentNode, style);
	                        break;
	                    }
	                case 'underline':
	                    {
	                        cssValue = nodeElement.style['text-decoration-line'];
	
	                        if (cssValue) {
	                            if (cssValue === style) isSelected = true;
	                        } else return this.checkStyle(nodeElement.parentNode, style);
	                        break;
	                    }
	                case 'super':
	                case 'sub':
	                    {
	                        cssValue = nodeElement.style['vertical-align'];
	
	                        if (cssValue) {
	                            if (cssValue === style) isSelected = true;
	                        } else return this.checkStyle(nodeElement.parentNode, style);
	                        break;
	                    }
	                case 'left':
	                case 'center':
	                case 'right':
	                    {
	                        if (style === 'left') isSelected = true; // default is leftAlignment ... so if no text-align style then let it selected
	
	                        cssValue = nodeElement.style['text-align'];
	
	                        if (cssValue === 'left' || cssValue === 'center' || cssValue === 'right') {
	                            if (cssValue === style) isSelected = true;else isSelected = false;
	                        } else return this.checkStyle(nodeElement.parentNode, style);
	                        break;
	                    }
	                case 'OL':
	                case 'UL':
	                    {
	                        if (nodeElement.nodeName === style) isSelected = true;else return this.checkStyle(nodeElement.parentNode, style);
	                        break;
	                    }
	            }
	
	            return isSelected;
	        } else return false;
	    },
	    getCommandValue: function getCommandValue(style) {
	        switch (style) {
	            case 'fontname':
	                {
	                    if (this.isFontFamilyAction) return this.fontFamily;
	
	                    break;
	                }
	            case 'fontcolor':
	                {
	                    if (this.isFontColorAction) return this.fontColor;
	
	                    break;
	                }
	            case 'fontsize':
	                {
	                    if (this.isFontSizeAction) return this.fontSize;
	
	                    break;
	                }
	        }
	
	        var selection = window.getSelection();
	
	        if (!selection || !selection.anchorNode || selection.anchorNode.id && selection.anchorNode.id.indexOf('text_area') != -1) {
	            if (style === 'fontname') return this.currentFont;
	
	            if (style === 'fontcolor') return '#000000';
	
	            if (style === 'fontsize') return this.currentFontSize;
	        }
	
	        var parentNode = selection.anchorNode.parentNode;
	
	        return this.checkCommand(parentNode, style);
	    },
	    checkCommand: function checkCommand(nodeElement, style) {
	        if (nodeElement && nodeElement.nodeName === 'foreignObject') {
	            if (style === 'fontname') return this.currentFont;
	
	            if (style === 'fontcolor') return '#000000';
	
	            if (style === 'fontsize') return this.currentFontSize;
	        }
	
	        if (nodeElement && nodeElement.style) {
	            var cssValue = void 0;
	
	            switch (style) {
	                case 'fontname':
	                    {
	                        cssValue = nodeElement.style['font-family'];
	
	                        if (cssValue) return cssValue;else return this.checkCommand(nodeElement.parentNode, style);
	                        break;
	                    }
	                case 'fontcolor':
	                    {
	                        cssValue = nodeElement.style['color'];
	
	                        if (cssValue) return cssValue;else return this.checkCommand(nodeElement.parentNode, style);
	                        break;
	                    }
	                case 'fontsize':
	                    {
	                        cssValue = nodeElement.style['font-size'];
	
	                        if (cssValue) return parseInt(cssValue);else return this.checkCommand(nodeElement.parentNode, style);
	                        break;
	                    }
	            }
	
	            return '';
	        } else {
	            if (style === 'fontname') return this.currentFont;
	
	            if (style === 'fontcolor') return '#000000';
	
	            if (style === 'fontsize') return this.currentFontSize;
	        }
	    },
	    resetActions: function resetActions() {
	        this.isBoldAction = false;
	        this.isItalicAction = false;
	        this.isUnderlineAction = false;
	        this.isSuperAction = false;
	        this.isSubAction = false;
	        this.isFontColorAction = false;
	        this.isFontFamilyAction = false;
	        this.isFontSizeAction = false;
	
	        this.savedSelection = undefined;
	        this.lastCursorPosition = -1;
	    },
	    hasParentWithId: function hasParentWithId(target, parentId, level) {
	        if (target.id && target.id.indexOf(parentId) != -1) return true;
	
	        var i = void 0;
	
	        for (i = 0; i < level; i++) {
	            if (target.parentNode == undefined) {
	                return false;
	            } else {
	                target = target.parentNode;
	
	                if (target.id && target.id.indexOf(parentId) != -1) return true;
	            }
	        }
	
	        return false;
	    },
	    checkTextSelection: function checkTextSelection(e) {
	        if (e && e.target) {
	            if (e.target && e.target.offsetParent && e.target.offsetParent.nodeName && e.target.offsetParent.nodeName.indexOf('foreignObject') != -1 && e.target.offsetParent.innerHTML && e.target.offsetParent.innerHTML.indexOf(this.selectedTextShape) != -1) return;
	
	            if (this.hasParentWithId(e.target, 'textEditorTool', 14) || e.target.className.length > 0 && e.target.className.indexOf('menuButton') != -1) return;
	
	            if (this.hasParentWithId(e.target, 'shapeBound', 5)) return;
	
	            if (e.target.className && e.target.className.length > 0 && e.target.className.indexOf('undoRedo') != -1) // if it is a click on UNDO/REDO buttons
	                return;
	        }
	
	        this.closeTextEditor();
	    },
	    closeTextEditor: function closeTextEditor() {
	        if (this.selectedTextShape == '') return;
	
	        var activeTextArea = document.getElementById('text_area_' + this.selectedTextShape);
	
	        if (activeTextArea) {
	            var newValue = activeTextArea.innerHTML;
	
	            if (newValue) {
	                _StoreManager2.default.getStore().dispatch((0, _CurrentSlideActions.changeRichTextContent)(this.selectedTextShape, newValue));
	                _SaveManager2.default.isContentChanged(true);
	                _AudioEditorUtils2.default.addActionToHistory();
	            }
	
	            activeTextArea.contentEditable = false;
	            activeTextArea.style.cursor = 'default';
	        }
	
	        this.selectedTextShape = '';
	        this.resetActions();
	
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.TEXT_EDITOR) _StoreManager2.default.getStore().dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	
	
	    background: undefined,
	    initColorPickerBackground: function initColorPickerBackground() {
	        var appBounds = document.getElementById('app').getBoundingClientRect();
	
	        this.background = document.createElement('div');
	
	        this.background.addEventListener('click', this.onClickBackgroundHandler.bind(this));
	
	        this.background.style.position = 'absolute';
	        this.background.style.background = 'none';
	        this.background.style.display = 'block';
	        this.background.style.zIndex = 99999999;
	        this.background.style.left = appBounds.left + 'px';
	        this.background.style.top = appBounds.top + 'px';
	        this.background.style.width = appBounds.width + 'px';
	        this.background.style.height = appBounds.height + 'px';
	    },
	    onClickBackgroundHandler: function onClickBackgroundHandler() {
	        if (this.background && this.background.parentNode) this.background.parentNode.removeChild(this.background);
	    },
	    addColorPickerBackground: function addColorPickerBackground() {
	        if (!this.background) this.initColorPickerBackground();
	
	        document.body.appendChild(this.background);
	    },
	
	
	    textAreaElement: undefined,
	    updateSize: true,
	    updateShapeSize: function updateShapeSize(shapeModel, dispatch) {
	        if (!this.updateSize) {
	            this.updateSize = true;
	            return;
	        }
	
	        var originalTextArea = document.getElementById('text_area_' + shapeModel.uuid);
	
	        if (!originalTextArea) return;
	
	        if (!this.textAreaElement) this.textAreaElement = document.createElement('div');
	
	        document.body.appendChild(this.textAreaElement);
	
	        this.textAreaElement.innerHTML = originalTextArea.innerHTML;
	
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var textProperties = this.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	        var oldHeight = shapeModel.height;
	        var textAreaWidth = shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING;
	
	        if (shapeModel.imageNode && shapeModel.imageNode.length > 0 && shapeModel.aspectRatio > 0) {
	            var imageHeight = shapeModel.height - 2 * INNER_PADDING;
	            var maxWidth = textAreaWidth * 0.7;
	            var imageWidth = imageHeight * shapeModel.aspectRatio;
	
	            if (imageWidth > maxWidth) imageWidth = maxWidth;
	
	            textAreaWidth = textAreaWidth - imageWidth - INNER_PADDING;
	        }
	
	        this.textAreaElement.style.width = textAreaWidth + 'px';
	        this.textAreaElement.style.resize = 'none';
	        this.textAreaElement.style.overflow = 'hidden';
	        this.textAreaElement.style.padding = INNER_PADDING + 'px';
	        this.textAreaElement.style.border = 'none';
	        this.textAreaElement.style.outline = 'none';
	        this.textAreaElement.style.background = 'transparent';
	        this.textAreaElement.style.wordSpacing = textProperties.wordSpacing + 'px';
	        this.textAreaElement.style.letterSpacing = textProperties.letterSpacing + 'px';
	        this.textAreaElement.style.overflowWrap = 'break-word';
	
	        if (shapeModel.lineHeight > 0) this.textAreaElement.style.lineHeight = shapeModel.lineHeight;else {
	            if (textProperties.lineHeight != -1) this.textAreaElement.style.lineHeight = textProperties.lineHeight;
	        }
	
	        var currentHeight = this.textAreaElement.scrollHeight;
	
	        if (currentHeight > oldHeight) {
	            // update when the max height is reached
	            dispatch((0, _CurrentSlideActions.updateTextHeight)(shapeModel.uuid, currentHeight, 0));
	            _SaveManager2.default.isContentChanged(true);
	
	            _MindMapUtils2.default.updateShapePositionWhenResize(shapeModel);
	        }
	
	        document.body.removeChild(this.textAreaElement);
	    },
	    getHtmlText: function getHtmlText(shapeModel) {
	        return shapeModel.htmlText;
	    },
	    textProperties: function textProperties(shapeModel) {
	        var properties = {};
	
	        properties.wordSpacing = -1;
	        properties.textIdent = 0;
	        properties.letterSpacing = 0;
	
	        if (shapeModel.lineHeight && shapeModel.lineHeight > 0) properties.lineHeight = shapeModel.lineHeight;else properties.lineHeight = 1.25;
	
	        properties.extraPadding = 2;
	
	        if (_PlatformDetection2.default.isEdge() || _PlatformDetection2.default.isFirefox() || _PlatformDetection2.default.isSafari()) properties.extraPadding = 5;
	
	        return properties;
	    },
	    getCorrectColor: function getCorrectColor(color) {
	        if (!color) return '#000000';
	
	        if (color && color.indexOf('rgb(') != -1) color = _TextSizeUtils2.default.getHexaColor(color);
	
	        color = color.toLowerCase();
	
	        return color;
	    }
	};
	
	exports.default = textEditorUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/utils/TextEditorUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/utils/TextEditorUtils.js"); } } })();

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _SlideParserUtils = __webpack_require__(376);
	
	var _SlideParserUtils2 = _interopRequireDefault(_SlideParserUtils);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _uuid = __webpack_require__(68);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _DrawingUtils = __webpack_require__(108);
	
	var _DrawingUtils2 = _interopRequireDefault(_DrawingUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _ThumbnailGenerator = __webpack_require__(144);
	
	var _ThumbnailGenerator2 = _interopRequireDefault(_ThumbnailGenerator);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createShapes = {
	    useBackgroundAsImage: false,
	    useFrameAsImage: false,
	    useImageAsBackground: false,
	    useVideoAsBackground: true,
	
	    updateThumbnail: function updateThumbnail(dispatch) {
	        dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    createLine: function createLine(dispatch, path, drawingProperties) {
	        var shapeModel = {};
	        var globalPathPoints = _SlideParserUtils2.default.dataToPoints(path);
	
	        if (!(globalPathPoints.length > 1 && globalPathPoints[0].x && globalPathPoints[0].y && globalPathPoints[1].x && globalPathPoints[1].y)) return;
	
	        shapeModel.type = _ShapeConstants2.default.LINE;
	        shapeModel.x1 = globalPathPoints[0].x;
	        shapeModel.y1 = globalPathPoints[0].y;
	        shapeModel.x2 = globalPathPoints[1].x;
	        shapeModel.y2 = globalPathPoints[1].y;
	
	        this.addCommonProperties(shapeModel);
	        this.addStrokeProperties(shapeModel);
	
	        if (drawingProperties) {
	            shapeModel.strokeWidth = drawingProperties.strokeWidth;
	            shapeModel.stroke = drawingProperties.strokeColor;
	        } else {
	            shapeModel.strokeWidth = 3;
	        }
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        _SaveManager2.default.isContentChanged(true);
	
	        if (!drawingProperties) dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid));else _DrawingUtils2.default.addCurrentShape(shapeModel);
	    },
	    createFreehand: function createFreehand(dispatch, path, drawingProperties) {
	        var globalPathPoints = _SlideParserUtils2.default.dataToPoints(path);
	
	        if (globalPathPoints.length < 10) return;
	
	        var shapeModel = {};
	
	        shapeModel.type = _ShapeConstants2.default.FREEHAND;
	
	        this.addCommonProperties(shapeModel);
	        this.addFillProperties(shapeModel);
	        this.addStrokeProperties(shapeModel);
	
	        shapeModel.horizontalFlip = 1;
	        shapeModel.verticalFlip = 1;
	
	        var properties = _SlideParserUtils2.default.getFreehandSize(globalPathPoints);
	        var pathPoints = _SlideParserUtils2.default.converToLocalPathPoints(globalPathPoints, properties);
	
	        shapeModel.x = properties.x;
	        shapeModel.y = properties.y;
	        shapeModel.width = properties.width;
	        shapeModel.height = properties.height;
	        shapeModel.isNew = true;
	        shapeModel.pathPoints = pathPoints;
	
	        if (drawingProperties) {
	            shapeModel.strokeWidth = drawingProperties.strokeWidth;
	            shapeModel.stroke = drawingProperties.strokeColor;
	        } else {
	            shapeModel.strokeWidth = 3;
	        }
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        _SaveManager2.default.isContentChanged(true);
	
	        if (!drawingProperties) dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid));else _DrawingUtils2.default.addCurrentShape(shapeModel);
	    },
	    handleRectangularShape: function handleRectangularShape(shapeModel, topLeftPosition, dispatch) {
	        this.addCommonProperties(shapeModel);
	        this.addFillProperties(shapeModel);
	        this.addStrokeProperties(shapeModel);
	        this.addSize(shapeModel, false, topLeftPosition);
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid));
	        _SaveManager2.default.isContentChanged(true);
	    },
	    createRectangle: function createRectangle(dispatch, topLeftPosition) {
	        var shapeModel = {};
	
	        shapeModel.type = _ShapeConstants2.default.RECTANGLE;
	        this.handleRectangularShape(shapeModel, topLeftPosition, dispatch);
	    },
	    createTriangle: function createTriangle(dispatch, topLeftPosition) {
	        var shapeModel = {};
	
	        shapeModel.type = _ShapeConstants2.default.TRIANGLE;
	        this.handleRectangularShape(shapeModel, topLeftPosition, dispatch);
	    },
	    createStar: function createStar(dispatch, topLeftPosition) {
	        var shapeModel = {};
	
	        shapeModel.type = _ShapeConstants2.default.STAR;
	        this.handleRectangularShape(shapeModel, topLeftPosition, dispatch);
	    },
	    createHeart: function createHeart(dispatch, topLeftPosition) {
	        var shapeModel = {};
	
	        shapeModel.type = _ShapeConstants2.default.HEART;
	        this.handleRectangularShape(shapeModel, topLeftPosition, dispatch);
	    },
	    createEllipse: function createEllipse(dispatch, topLeftPosition) {
	        var size = _Properties2.default.SHAPE_SIZE;
	        var shapeModel = {};
	
	        shapeModel.type = _ShapeConstants2.default.ELLIPSE;
	
	        this.addCommonProperties(shapeModel);
	        this.addFillProperties(shapeModel);
	        this.addStrokeProperties(shapeModel);
	        this.addSize(shapeModel, false, topLeftPosition);
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid));
	        _SaveManager2.default.isContentChanged(true);
	    },
	    createCurve: function createCurve(dispatch, topLeftPosition) {
	        var size = _Properties2.default.SHAPE_SIZE;
	        var shapeModel = {};
	
	        shapeModel.type = _ShapeConstants2.default.CURVE;
	
	        if (topLeftPosition) {
	            shapeModel.x1 = topLeftPosition.x;
	            shapeModel.y1 = topLeftPosition.y;
	            shapeModel.x2 = topLeftPosition.x + size;
	            shapeModel.y2 = topLeftPosition.y + size;
	            shapeModel.cx = topLeftPosition.x + size;
	            shapeModel.cy = topLeftPosition.y;
	        } else {
	            shapeModel.x1 = _Configuration2.default.CANVAS_WIDTH / 2 - size / 2;
	            shapeModel.y1 = _Configuration2.default.CANVAS_HEIGHT / 2 - size / 2;
	            shapeModel.x2 = _Configuration2.default.CANVAS_WIDTH / 2 + size / 2;
	            shapeModel.y2 = _Configuration2.default.CANVAS_HEIGHT / 2 + size / 2;
	            shapeModel.cx = _Configuration2.default.CANVAS_WIDTH / 2 + size / 2;
	            shapeModel.cy = _Configuration2.default.CANVAS_HEIGHT / 2 - size / 2;
	        }
	
	        this.addStrokeProperties(shapeModel);
	        this.addCommonProperties(shapeModel);
	
	        shapeModel.strokeWidth = 3;
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid));
	        _SaveManager2.default.isContentChanged(true);
	    },
	    addTextProperties: function addTextProperties(shapeModel) {
	        if (!shapeModel.isRichText) {
	            shapeModel.fontFamily = _TextEditorUtils2.default.currentFont;
	            shapeModel.fontAlign = 'left';
	            shapeModel.fontBold = false;
	            shapeModel.fontItalic = false;
	            shapeModel.fontUnderline = false;
	        }
	
	        shapeModel.fontSize = 24;
	        shapeModel.fontColor = '#000000';
	        shapeModel.htmlText = '';
	        shapeModel.backgroundVisible = true;
	    },
	    addStrokeProperties: function addStrokeProperties(shapeModel, opacity) {
	        shapeModel.stroke = '#000000';
	        shapeModel.strokeWidth = 1;
	        if (opacity == 0) shapeModel.strokeOpacity = 0;else shapeModel.strokeOpacity = 1;
	    },
	    addFillProperties: function addFillProperties(shapeModel, opacity) {
	        shapeModel.fill = '#ffffff';
	
	        if (opacity == 0) shapeModel.fillOpacity = 0;else shapeModel.fillOpacity = 1;
	    },
	    addCommonProperties: function addCommonProperties(shapeModel) {
	        shapeModel.opacity = 1;
	        shapeModel.isSelected = false;
	        shapeModel.isLocked = false;
	        shapeModel.rotation = 0;
	        shapeModel.filter = '';
	        shapeModel.uuid = _uuid2.default.v4();
	    },
	    addSize: function addSize(shapeModel) {
	        var isText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var topLeftPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	        var size = _Properties2.default.SHAPE_SIZE;
	
	        if (isText == true) {
	            if (shapeModel.isRichText) {
	                shapeModel.width = _Properties2.default.RICH_TEXT_WIDTH;
	                shapeModel.height = _Properties2.default.RICH_TEXT_HEIGHT;
	            } else {
	                shapeModel.width = _Properties2.default.TEXT_WIDTH;
	                shapeModel.height = _Properties2.default.TEXT_HEIGHT;
	            }
	        } else {
	            shapeModel.width = size;
	            shapeModel.height = size;
	        }
	
	        shapeModel.x = _Configuration2.default.CANVAS_WIDTH / 2 - shapeModel.width / 2;
	        shapeModel.y = _Configuration2.default.CANVAS_HEIGHT / 2 - shapeModel.height / 2;
	
	        if (topLeftPosition) {
	            shapeModel.x = topLeftPosition.x;
	            shapeModel.y = topLeftPosition.y;
	        } else if (isText && shapeModel.isRichText) this.checkTopLeftPosition(shapeModel);
	    },
	    checkTopLeftPosition: function checkTopLeftPosition(shapeModel) {
	        var offset = 10;
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var i;
	        var textShapes = [];
	        var possiblePositions = [{ x: shapeModel.x, y: shapeModel.y }];
	        var count = 0;
	
	        for (i = 1; i < shapes.length; i++) {
	            if (shapes[i].type == _ShapeConstants2.default.TEXTBOX && shapes[i].isRichText) {
	                textShapes.push(shapes[i]);
	                count = count + 1;
	                possiblePositions.push({ x: shapeModel.x + count * offset, y: shapeModel.y + count * offset });
	            }
	        }
	
	        for (i = 0; i < possiblePositions.length; i++) {
	            var position = possiblePositions[i];
	            var isFree = true;
	
	            for (var j = 0; j < textShapes.length; j++) {
	                if (position.x == textShapes[j].x && position.y == textShapes[j].y) isFree = false;
	            }
	
	            if (isFree) {
	                shapeModel.x = position.x;
	                shapeModel.y = position.y;
	                break;
	            }
	        }
	    },
	    addText: function addText(shapeModel, topLeftPosition) {
	        this.addCommonProperties(shapeModel);
	
	        this.addFillProperties(shapeModel);
	        this.addStrokeProperties(shapeModel);
	
	        this.addTextProperties(shapeModel);
	        this.addSize(shapeModel, true, topLeftPosition);
	        this.addControlPointPosition(shapeModel);
	    },
	    addControlPointPosition: function addControlPointPosition(shapeModel) {
	        if (shapeModel.type != _ShapeConstants2.default.TEXTBOX && shapeModel.type != _ShapeConstants2.default.TEXTBOXSIMPLE) {
	            if (shapeModel.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE) {
	                shapeModel.cx = shapeModel.x;
	                shapeModel.cy = shapeModel.y + 2.6 * shapeModel.height;
	
	                shapeModel.cx1 = shapeModel.x + shapeModel.width;
	                shapeModel.cy1 = shapeModel.y + 2.6 * shapeModel.height;
	
	                if (shapeModel.isMindMap) {
	                    shapeModel.cx2 = shapeModel.x;
	                    shapeModel.cy2 = shapeModel.y - 1.6 * shapeModel.height;
	
	                    shapeModel.cx3 = shapeModel.x + shapeModel.width;
	                    shapeModel.cy3 = shapeModel.y - 1.6 * shapeModel.height;
	                }
	            } else {
	                shapeModel.cx = shapeModel.x + 0.3 * shapeModel.width;
	                shapeModel.cy = shapeModel.y + 1.6 * shapeModel.height;
	            }
	        }
	    },
	    createTextBox: function createTextBox(dispatch, topLeftPosition) {
	        var isRichText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	        var mindMapProperty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
	
	        var shapeModel = {};
	        shapeModel.type = _ShapeConstants2.default.TEXTBOX;
	        shapeModel.isRichText = isRichText;
	        shapeModel.isNew = true;
	
	        if (mindMapProperty) shapeModel.mindMapProperty = mindMapProperty;
	
	        this.addText(shapeModel, topLeftPosition);
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid, true));
	        _SaveManager2.default.isContentChanged(true);
	
	        this.updateFontMenu(dispatch, shapeModel);
	    },
	    createTextBoxSimple: function createTextBoxSimple(dispatch, topLeftPosition) {
	        var isRichText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        var shapeModel = {};
	        shapeModel.type = _ShapeConstants2.default.TEXTBOXSIMPLE;
	        shapeModel.isRichText = isRichText;
	        shapeModel.isNew = true;
	        this.addText(shapeModel, topLeftPosition);
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid, true));
	        _SaveManager2.default.isContentChanged(true);
	
	        this.updateFontMenu(dispatch, shapeModel);
	    },
	    createSpeachBubble: function createSpeachBubble(dispatch, topLeftPosition) {
	        var isRichText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        var shapeModel = {};
	        shapeModel.type = _ShapeConstants2.default.SPEAK_BUBBLE;
	        shapeModel.isRichText = isRichText;
	        shapeModel.isNew = true;
	        this.addText(shapeModel, topLeftPosition);
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid, true));
	        _SaveManager2.default.isContentChanged(true);
	
	        this.updateFontMenu(dispatch, shapeModel);
	    },
	    createComplexSpeachBubble: function createComplexSpeachBubble(dispatch, topLeftPosition) {
	        var isRichText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	        var isMindMap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        var shapeModel = {};
	        shapeModel.type = _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE;
	        shapeModel.isRichText = isRichText;
	        shapeModel.isMindMap = isMindMap;
	        shapeModel.isNew = true;
	        this.addText(shapeModel, topLeftPosition);
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid, true));
	        _SaveManager2.default.isContentChanged(true);
	
	        this.updateFontMenu(dispatch, shapeModel);
	    },
	    createMindMapShape: function createMindMapShape(dispatch, topLeftPosition) {
	        var isRichText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        this.createComplexSpeachBubble(dispatch, topLeftPosition, isRichText, true);
	    },
	    createScreamBubble: function createScreamBubble(dispatch, topLeftPosition) {
	        var isRichText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        var shapeModel = {};
	        shapeModel.type = _ShapeConstants2.default.SCREAM_BUBBLE;
	        shapeModel.isRichText = isRichText;
	        shapeModel.isNew = true;
	        this.addText(shapeModel, topLeftPosition);
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid, true));
	        _SaveManager2.default.isContentChanged(true);
	
	        this.updateFontMenu(dispatch, shapeModel);
	    },
	    createThoughtBubble: function createThoughtBubble(dispatch, topLeftPosition) {
	        var isRichText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        var shapeModel = {};
	        shapeModel.type = _ShapeConstants2.default.THOUGHT_BUBBLE;
	        shapeModel.isRichText = isRichText;
	        shapeModel.isNew = true;
	        this.addText(shapeModel, topLeftPosition);
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid, true));
	        _SaveManager2.default.isContentChanged(true);
	
	        this.updateFontMenu(dispatch, shapeModel);
	    },
	    updateFontMenu: function updateFontMenu(dispatch, shapeModel) {
	        dispatch((0, _MenuActions.setContextTarget)(shapeModel));
	        dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.SHAPE_MENU]));
	
	        setTimeout(function () {
	            if (!shapeModel.isRichText) dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.OBJECT_TEXT_STYLING));
	        }.bind(this), 20);
	    },
	    checkFontMenu: function checkFontMenu(dispatch, shapeModel) {
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) return;
	
	        this.updateFontMenu(dispatch, shapeModel);
	    },
	    createImage: function createImage(dispatch, item, topLeftPosition, mindMapProperty) {
	        var shapeModel = {};
	
	        this.dragDropTopLeftPosition = topLeftPosition;
	        shapeModel.type = _ShapeConstants2.default.IMAGE;
	        shapeModel.isNewImage = true;
	
	        if (mindMapProperty) shapeModel.mindMapProperty = mindMapProperty;
	
	        this.addCommonProperties(shapeModel);
	        this.addStrokeProperties(shapeModel, 0);
	        this.addFillProperties(shapeModel, 0);
	        this.setCorrectSize(shapeModel, parseFloat(item.width), parseFloat(item.height), topLeftPosition, item);
	
	        shapeModel.horizontalFlip = 1;
	        shapeModel.verticalFlip = 1;
	        shapeModel.isNewFlip = true;
	
	        if (item.contentItemId > 0) shapeModel.contentItemId = item.contentItemId;
	
	        shapeModel.xlinkHref = item.href;
	        shapeModel.logicalName = item.logicalName;
	
	        shapeModel.theme = item.theme;
	
	        if (topLeftPosition) shapeModel.hasTopLeftPosition = true;
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid));
	        _SaveManager2.default.isContentChanged(true);
	    },
	    setCorrectSize: function setCorrectSize(shapeModel, originalWidth, originalHeight, topLeftPosition, item) {
	        var size = _Properties2.default.IMAGE_SIZE;
	        var useOriginalSize = true;
	
	        _ThumbnailGenerator2.default.checkImageOriginalSize = true;
	
	        if (item && item.logicalTitle && item.logicalTitle.indexOf('props1.naturfag_5_7') != -1) {
	            size = 50;
	            _ThumbnailGenerator2.default.checkImageOriginalSize = false;
	        }
	
	        if (originalWidth > 0 && originalHeight > 0) {
	
	            if (useOriginalSize == true) {
	                shapeModel.width = originalWidth;
	                shapeModel.height = originalHeight;
	                shapeModel.isNewImage = false; // don't load image with ThumbnailGenerator
	            } else {
	                if (originalWidth > originalHeight) {
	                    shapeModel.width = size;
	                    shapeModel.height = size * originalHeight / originalWidth;
	                } else {
	                    shapeModel.height = size;
	                    shapeModel.width = size * originalWidth / originalHeight;
	                }
	            }
	        } else {
	            shapeModel.width = size;
	            shapeModel.height = size;
	        }
	
	        if (shapeModel.mindMapProperty) {
	            shapeModel.width = _Properties2.default.MIND_MAP_NODE_SIZE;
	            shapeModel.height = _Properties2.default.MIND_MAP_NODE_SIZE;
	        }
	
	        if (topLeftPosition) {
	            shapeModel.x = topLeftPosition.x;
	            shapeModel.y = topLeftPosition.y;
	        } else {
	            shapeModel.x = _Configuration2.default.CANVAS_WIDTH / 2 - shapeModel.width / 2;
	            shapeModel.y = _Configuration2.default.CANVAS_HEIGHT / 2 - shapeModel.height / 2;
	        }
	    },
	    createCharacter: function createCharacter(dispatch, item, topLeftPosition, mindMapProperty) {
	        var shapeModel = {};
	
	        this.dragDropTopLeftPosition = topLeftPosition;
	        shapeModel.type = _ShapeConstants2.default.CHARACTER;
	        shapeModel.isNewImage = true;
	
	        if (mindMapProperty) shapeModel.mindMapProperty = mindMapProperty;
	
	        this.addCommonProperties(shapeModel);
	        this.addStrokeProperties(shapeModel, 0);
	        this.addFillProperties(shapeModel, 0);
	        this.setCorrectSize(shapeModel, parseFloat(item.width), parseFloat(item.height), topLeftPosition, item);
	
	        shapeModel.horizontalFlip = 1;
	        shapeModel.verticalFlip = 1;
	        shapeModel.isNewFlip = true;
	
	        shapeModel.xlinkHref = item.href;
	        shapeModel.logicalName = item.logicalName;
	        shapeModel.moods = item.moods;
	        shapeModel.frameLabel = item.moods[0];
	
	        shapeModel.theme = item.theme;
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid));
	        _SaveManager2.default.isContentChanged(true);
	    },
	    createBackground: function createBackground() {
	        var shapeModel = {};
	
	        shapeModel.type = _ShapeConstants2.default.BACKGROUND;
	        shapeModel.hotSpot = '';
	        shapeModel.logicalName = '';
	        shapeModel.frameLabel = '';
	        shapeModel.xlinkHref = '';
	        shapeModel.moods = [];
	        shapeModel.stroke = '#000000';
	        shapeModel.strokeWidth = 1;
	        shapeModel.strokeOpacity = 0;
	        shapeModel.fill = '#ffffff';
	        shapeModel.fillOpacity = 1;
	        shapeModel.opacity = 1;
	        shapeModel.uuid = _uuid2.default.v4();
	
	        return shapeModel;
	    },
	    createBackgroundWithVideo: function createBackgroundWithVideo(videoModel) {
	        var shapeModel = {};
	
	        shapeModel.type = _ShapeConstants2.default.BACKGROUND;
	        shapeModel.hotSpot = '';
	        shapeModel.logicalName = videoModel.logicalName;
	        shapeModel.frameLabel = '';
	        shapeModel.xlinkHref = videoModel.href;
	        shapeModel.moods = [];
	        shapeModel.stroke = '#000000';
	        shapeModel.strokeWidth = 1;
	        shapeModel.strokeOpacity = 0;
	        shapeModel.fill = '#ffffff';
	        shapeModel.fillOpacity = 1;
	        shapeModel.uuid = _uuid2.default.v4();
	
	        if (videoModel.contentItemId > 0) shapeModel.contentItemId = videoModel.contentItemId;
	
	        shapeModel.isVideo = true;
	        shapeModel.volume = videoModel.volume;
	        shapeModel.inPoint = videoModel.inPoint;
	        shapeModel.outPoint = videoModel.outPoint;
	
	        return shapeModel;
	    },
	    createVideo: function createVideo(dispatch, item, topLeftPosition) {
	        var shapeModel = {};
	
	        shapeModel.type = _ShapeConstants2.default.VIDEO;
	
	        this.addCommonProperties(shapeModel);
	        this.addStrokeProperties(shapeModel, 0);
	
	        shapeModel.x = 100;
	        shapeModel.y = 100;
	        shapeModel.width = 300;
	        shapeModel.height = 300 * 9 / 16;
	
	        shapeModel.horizontalFlip = 1;
	        shapeModel.verticalFlip = 1;
	
	        if (item.contentItemId > 0) shapeModel.contentItemId = item.contentItemId;
	
	        shapeModel.xlinkHref = item.href;
	        shapeModel.duration = item.duration;
	
	        if (topLeftPosition) shapeModel.hasTopLeftPosition = true;
	
	        shapeModel.title = item.title;
	
	        dispatch((0, _CurrentSlideActions.createShape)(shapeModel));
	        this.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid));
	        _SaveManager2.default.isContentChanged(true);
	    },
	
	    dragDropTopLeftPosition: undefined,
	    getShapeIndex: function getShapeIndex(uuid) {
	        var state = _StoreManager2.default.getState();
	        var shapes;
	        var index = 0;
	
	        if (state && state.currentSlide && state.currentSlide.model && state.currentSlide.model.content) shapes = state.currentSlide.model.content;
	
	        if (!shapes) return 1;
	
	        for (var i = 0; i < shapes.length; i++) {
	            if (shapes[i].type == _ShapeConstants2.default.TEXTBOX || shapes[i].type == _ShapeConstants2.default.TEXTBOXSIMPLE || shapes[i].type == _ShapeConstants2.default.SPEAK_BUBBLE || shapes[i].type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shapes[i].type == _ShapeConstants2.default.SCREAM_BUBBLE || shapes[i].type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                index = index + 1;
	
	                if (shapes[i].uuid == uuid) return index;
	            }
	        }
	
	        return 1;
	    }
	};
	
	exports.default = createShapes;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/CreateShapes.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/CreateShapes.js"); } } })();

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ClipartParserJSONNew = __webpack_require__(168);
	
	var _ClipartParserJSONNew2 = _interopRequireDefault(_ClipartParserJSONNew);
	
	var _universesList = __webpack_require__(749);
	
	var _universesList2 = _interopRequireDefault(_universesList);
	
	var _themesList = __webpack_require__(748);
	
	var _themesList2 = _interopRequireDefault(_themesList);
	
	var _videoThemesList = __webpack_require__(750);
	
	var _videoThemesList2 = _interopRequireDefault(_videoThemesList);
	
	var _newTheme = __webpack_require__(746);
	
	var _newTheme2 = _interopRequireDefault(_newTheme);
	
	var _newThemeReloaded = __webpack_require__(747);
	
	var _newThemeReloaded2 = _interopRequireDefault(_newThemeReloaded);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _video_italy = __webpack_require__(751);
	
	var _video_italy2 = _interopRequireDefault(_video_italy);
	
	var _VideoClipartParserJSON = __webpack_require__(324);
	
	var _VideoClipartParserJSON2 = _interopRequireDefault(_VideoClipartParserJSON);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var masterUniverseUtils = {
	    universesArray: [],
	    themesArray: [],
	    videoThemesArray: [],
	    scrollPosition: 0,
	
	    useThumbnailsLazyLoading: function useThumbnailsLazyLoading() {
	        var usePagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (usePagination) return false;else return true;
	    },
	    language: function language() {
	        return _AppParameters2.default.locale;
	    },
	    getMainUniversesList: function getMainUniversesList() {
	        return this.universesArray;
	    },
	    getCurrentUniverseTitle: function getCurrentUniverseTitle() {
	        if (_AppParameters2.default.currentMainUniverse == '') return '';
	
	        var universeItem = this.universesArray[_AppParameters2.default.currentMainUniverse];
	
	        if (universeItem) {
	            if (!universeItem.translations) return universeItem.universe;else {
	                var translation = universeItem.translations[this.language()];
	
	                if (translation && translation.length > 0) return translation;else if (universeItem.translations['en_US']) return universeItem.translations['en_US'];else return universeItem.universe;
	            }
	        } else return '';
	    },
	    checkCurrentUniverse: function checkCurrentUniverse() {
	        if (_AppParameters2.default.currentTheme != '' && _AppParameters2.default.currentMainUniverse == '') {
	            for (var universe in this.themesArray) {
	                var themes = this.themesArray[universe];
	
	                for (var i = 0; i < themes.length; i++) {
	                    if (_AppParameters2.default.currentTheme == themes[i].name) {
	                        _AppParameters2.default.currentMainUniverse = universe;
	                        return;
	                    }
	                }
	            }
	        }
	    },
	    getCurrentThemes: function getCurrentThemes() {
	        if (_AppParameters2.default.currentMainUniverse == '') return [];
	
	        return this.themesArray[_AppParameters2.default.currentMainUniverse];
	    },
	    getAllThemes: function getAllThemes() {
	        var themes = [];
	
	        for (var universe in this.universesArray) {
	            themes = themes.concat(this.themesArray[universe]);
	        }
	
	        for (var i = 0; i < themes.length; i++) {
	            themes[i].currentTitle = this.getCurrentTitle(themes[i]);
	        }
	
	        themes = this.sortElementsByCurrentTitle(themes);
	
	        return themes;
	    },
	    getCurrentTitle: function getCurrentTitle(theme) {
	        if (!theme.translations) return theme.name;else {
	            var translation = theme.translations[this.language()];
	
	            if (translation && translation.length > 0) return translation;else if (theme.translations['en_US']) return theme.translations['en_US'];else return theme.name;
	        }
	    },
	    sortElementsByCurrentTitle: function sortElementsByCurrentTitle(array) {
	        array.sort(function (a, b) {
	            if (a.currentTitle < b.currentTitle) return -1;
	            if (a.currentTitle > b.currentTitle) return 1;
	
	            return 0;
	        });
	
	        return array;
	    },
	    getCurrentThemeTitle: function getCurrentThemeTitle() {
	        if (_AppParameters2.default.currentMainUniverse == '' || _AppParameters2.default.currentTheme == '') return '';
	
	        var array = this.themesArray[_AppParameters2.default.currentMainUniverse];
	
	        for (var i = 0; i < array.length; i++) {
	            if (array[i].name == _AppParameters2.default.currentTheme) {
	                var translation = array[i].translations[this.language()];
	
	                if (translation && translation.length > 0) return translation;else if (array[i].translations['en_US']) return array[i].translations['en_US'];else return array[i].name;
	            }
	        }
	
	        return '';
	    },
	    goToTheme: function goToTheme(themeName) {
	        if (!themeName || _AppParameters2.default.currentTheme == themeName) return;
	
	        this.changeTheme(themeName);
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        dispatch((0, _MenuActions.refreshThemeSelector)());
	    },
	    loadCartoonistEffects: function loadCartoonistEffects() {
	        var _this = this;
	
	        if (_Configuration2.default.LOAD_LOCAL) return;
	
	        if (_ClipartParserJSONNew2.default.cartoonistEffects) return;
	
	        _ApiService2.default.loadThemesFromUniverse('common').then(function (response) {
	            var commonThemes = response;
	            var effectsTheme;
	
	            for (var i = 0; i < commonThemes.length; i++) {
	                if (commonThemes[i].name.indexOf('effects') != -1) effectsTheme = commonThemes[i];
	            }
	
	            if (!effectsTheme) return;
	
	            var themeName = _this.getCurrentTitle(effectsTheme);
	
	            _ApiService2.default.loadCurrentTheme(effectsTheme.name).then(function (response) {
	                _ClipartParserJSONNew2.default.parseClipartModel(response, true, themeName);
	            });
	        });
	    },
	    loadTheme: function loadTheme() {
	        this.loadCartoonistEffects();
	        this.loadUniversesAndThemes();
	        this.loadVideoThemes();
	
	        if (_AppParameters2.default.currentTheme.length < 1) {
	            _ClipartParserJSONNew2.default.addClipartModelHandler({ items: [], captionKey: _AppParameters2.default.currentTheme });
	            return;
	        }
	
	        if (_Configuration2.default.LOAD_LOCAL) _ClipartParserJSONNew2.default.parseClipartModel(JSON.parse(_newTheme2.default.data));else this.executeGetThemeCall();
	    },
	    reloadTheme: function reloadTheme() {
	        if (_Configuration2.default.LOAD_LOCAL) _ClipartParserJSONNew2.default.parseClipartModel(JSON.parse(_newThemeReloaded2.default.data));else this.executeGetThemeCall();
	    },
	    getLocaleParameter: function getLocaleParameter() {
	        if (_AppParameters2.default.currentMainUniverse == 'alphabet_planet') {
	            if (_AppParameters2.default.locale == 'nn_NO' || _AppParameters2.default.locale == 'nb_NO' || _AppParameters2.default.locale == 'sv_SE') {
	                return _AppParameters2.default.locale;
	            } else return '';
	        }
	
	        return '';
	    },
	    executeGetThemeCall: function executeGetThemeCall() {
	        if (!_AppParameters2.default.currentTheme || _AppParameters2.default.currentTheme == '') return;
	
	        this.showPreloader(true);
	        _ApiServiceUtils2.default.executeSafeApiCall(function () {
	            var _this2 = this;
	
	            _ApiService2.default.loadCurrentTheme(_AppParameters2.default.currentTheme, this.getLocaleParameter()).then(function (response) {
	                _ClipartParserJSONNew2.default.parseClipartModel(response);
	
	                _this2.showPreloader(false);
	                _StoreManager2.default.getStore().dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.UNIVERSES_MENU]));
	            });
	        }.bind(this));
	    },
	    showPreloader: function showPreloader(value) {
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        dispatch((0, _MenuActions.showSavePreloader)(value));
	    },
	    loadUniversesAndThemes: function loadUniversesAndThemes() {
	        if (_Configuration2.default.LOAD_LOCAL) {
	            var array = JSON.parse(_universesList2.default.data);
	            this.parseUniverses(array);
	
	            array = JSON.parse(_themesList2.default.data);
	            this.parseThemes(array);
	        } else {
	            this.executeGetUniversesCall();
	            this.executeGetThemesCall();
	        }
	    },
	
	    isSpecialOrganization: false,
	    isDemoUser: function isDemoUser() {
	        if (this.isSpecialOrganization) return true;
	
	        var testUsers = [15682463, 54719315, 54829736, 54829790, 54829795, 54829800, 110850418, 111170430];
	        var isTestUser = false;
	
	        if (!_Configuration2.default.IS_PROD() || _Configuration2.default.LOAD_LOCAL || _Configuration2.default.IS_PROD() && testUsers.indexOf(_AppParameters2.default.currentUserId) != -1) isTestUser = true;
	
	        return isTestUser;
	    },
	    parseUniverses: function parseUniverses(array) {
	        var demoUniverses = ['alphabet_planet'];
	        var isDemo = this.isDemoUser();
	
	        for (var i = 0; i < array.length; i++) {
	            var universeName = array[i].universe;
	
	            if (isDemo) {
	                this.universesArray[universeName] = array[i]; // add all universes
	            } else {
	                // regular user
	                if (demoUniverses.indexOf(universeName) == -1) this.universesArray[universeName] = array[i];
	            }
	        }
	
	        this.checkCurrentUniverse();
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        dispatch((0, _MenuActions.refreshThemeSelector)());
	    },
	    parseThemes: function parseThemes(array) {
	        this.themesArray = this.getCategories(this.filterThemes(array));
	        this.checkCurrentUniverse();
	    },
	    filterThemes: function filterThemes(array) {
	        var isNorway = _AppParameters2.default.locale == 'nb_NO' || _AppParameters2.default.locale == 'nn_NO' ? true : false;
	        var isSwedish = _AppParameters2.default.locale == 'sv_SE' ? true : false;
	        var removedThemes = [];
	        var newArray = [];
	
	        if (!isNorway && !isSwedish) {
	            removedThemes = ['norge_i_dag', 'sverige_i_dag', 'elements_molecules_swe'];
	        } else {
	            if (isNorway) removedThemes = ['sverige_i_dag', 'elements_molecules_swe', 'ae_s_theme', 'oe_s_theme'];else removedThemes = ['norge_i_dag', 'elements_molecules', 'ae_theme', 'oe_theme', 'democracy'];
	        }
	
	        for (var i = 0; i < array.length; i++) {
	            if (removedThemes.indexOf(array[i].name) == -1) newArray.push(array[i]);
	        }
	
	        return newArray;
	    },
	    getCategories: function getCategories(array) {
	        var universesMap = [];
	
	        for (var i = 0; i < array.length; i++) {
	            var universe = array[i].universe;
	
	            if (!universesMap[universe]) universesMap[universe] = [];
	
	            universesMap[universe].push(array[i]);
	        }
	
	        for (var key in universesMap) {
	            universesMap[key] = this.sortElementsByPosition(universesMap[key]);
	        }
	
	        return universesMap;
	    },
	    sortElementsByPosition: function sortElementsByPosition(array) {
	        array.sort(function (a, b) {
	            return a.position - b.position;
	        });
	
	        return array;
	    },
	    executeGetUniversesCall: function executeGetUniversesCall() {
	        _ApiServiceUtils2.default.executeSafeApiCall(function () {
	            var _this3 = this;
	
	            _ApiService2.default.loadUniverses().then(function (response) {
	                _this3.parseUniverses(response);
	            });
	        }.bind(this));
	    },
	    executeGetThemesCall: function executeGetThemesCall() {
	        _ApiServiceUtils2.default.executeSafeApiCall(function () {
	            var _this4 = this;
	
	            _ApiService2.default.loadThemes().then(function (response) {
	                _this4.parseThemes(response);
	            });
	        }.bind(this));
	    },
	    changeMainUniverse: function changeMainUniverse(universe) {
	        _AppParameters2.default.currentMainUniverse = universe;
	        _AppParameters2.default.currentTheme = '';
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        dispatch((0, _MenuActions.showMainUniverse)(false));
	    },
	    changeTheme: function changeTheme(theme) {
	        _VideoUtils2.default.browserActiveButton = 0;
	        _AppParameters2.default.currentTheme = theme;
	        _AppParameters2.default.currentMainUniverse = '';
	        this.checkCurrentUniverse();
	
	        this.reloadTheme();
	    },
	    getCurrentVideoThemes: function getCurrentVideoThemes() {
	        return this.videoThemesArray;
	    },
	    loadVideoThemes: function loadVideoThemes() {
	        if (_Configuration2.default.LOAD_LOCAL) {
	            this.videoThemesArray = this.getAllVideoThemes();
	        } else {
	            this.executeGetVideoThemesCall();
	        }
	    },
	    getAllVideoThemes: function getAllVideoThemes(themes) {
	        var allVideoThemes;
	        var theme;
	        var i;
	
	        if (themes) allVideoThemes = themes;else allVideoThemes = JSON.parse(_videoThemesList2.default.data);
	
	        for (i = 0; i < allVideoThemes.length; i++) {
	            theme = allVideoThemes[i];
	
	            theme.isAvailable = true;
	            theme.href = 'https://s3.amazonaws.com/creaza-clipart/staticthumbs/master_universes/' + theme.name + '.jpg';
	            theme.title = this.getCurrentTitle(theme);
	        }
	
	        return allVideoThemes;
	    },
	    executeGetVideoThemesCall: function executeGetVideoThemesCall() {
	        _ApiServiceUtils2.default.executeSafeApiCall(function () {
	            var _this5 = this;
	
	            _ApiService2.default.listVideoThemes().then(function (response) {
	                _this5.videoThemesArray = _this5.getAllVideoThemes(response);
	            });
	        }.bind(this));
	    },
	    reloadVideoClipart: function reloadVideoClipart() {
	        if (_Configuration2.default.LOAD_LOCAL == false) {
	            _ApiServiceUtils2.default.executeSafeApiCall(this.executeReloadVideoClipart.bind(this));
	        } else {
	            _VideoClipartParserJSON2.default.parseClipartModel(JSON.parse(_video_italy2.default.data));
	        }
	
	        _VideoUtils2.default.browserActiveButton = 0;
	    },
	    executeReloadVideoClipart: function executeReloadVideoClipart() {
	        var _this6 = this;
	
	        if (!_AppParameters2.default.currentVideoTheme || _AppParameters2.default.currentVideoTheme == '') return;
	
	        this.showPreloader(true);
	        _ApiService2.default.loadVideoTheme(_AppParameters2.default.currentVideoTheme).then(function (response) {
	            _VideoClipartParserJSON2.default.parseClipartModel(response);
	
	            _this6.showPreloader(false);
	            _StoreManager2.default.getStore().dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.UNIVERSES_MENU]));
	        });
	    },
	    changeVideoTheme: function changeVideoTheme(theme) {
	        _VideoUtils2.default.browserActiveButton = 0;
	        _AppParameters2.default.currentVideoTheme = theme;
	
	        this.reloadVideoClipart();
	    },
	    autoselectClipart: function autoselectClipart(clipartCategory) {
	        if (clipartCategory == 0) // go to Cartoonist tab
	            this.changeTheme(_AppParameters2.default.currentTheme);else if (clipartCategory == 1) // go to Video tab
	            this.changeVideoTheme(_AppParameters2.default.currentVideoTheme);
	    },
	    getCurrentVideoThemeTitle: function getCurrentVideoThemeTitle() {
	        if (_AppParameters2.default.currentVideoTheme == '') return '';
	
	        var array = this.videoThemesArray;
	
	        for (var i = 0; i < array.length; i++) {
	            if (array[i].name == _AppParameters2.default.currentVideoTheme) return array[i].title;
	        }
	
	        return '';
	    }
	};
	
	exports.default = masterUniverseUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/MasterUniverseUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/MasterUniverseUtils.js"); } } })();

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initTimelines = initTimelines;
	exports.changeTimelineVolume = changeTimelineVolume;
	exports.changeZoom = changeZoom;
	exports.addAudioToTimeline = addAudioToTimeline;
	exports.selectElement = selectElement;
	exports.changeElementPosition = changeElementPosition;
	exports.dragAndCloneElement = dragAndCloneElement;
	exports.changeSolo = changeSolo;
	exports.changeMute = changeMute;
	exports.changeVolume = changeVolume;
	exports.deleteItem = deleteItem;
	exports.setMarkerPosition = setMarkerPosition;
	exports.splitAudio = splitAudio;
	exports.audioEditorUndoRedo = audioEditorUndoRedo;
	exports.setTimelineWidth = setTimelineWidth;
	exports.updateItem = updateItem;
	exports.updateSoundDuration = updateSoundDuration;
	exports.changeTitle = changeTitle;
	exports.setVolumePoints = setVolumePoints;
	exports.showTrackMenu = showTrackMenu;
	exports.addTrack = addTrack;
	exports.deleteTrack = deleteTrack;
	exports.refreshAudioTrack = refreshAudioTrack;
	exports.refreshAudioElements = refreshAudioElements;
	exports.moveBlock = moveBlock;
	exports.recordedDataIos = recordedDataIos;
	var types = exports.types = {
	    INIT_TIMELINES: 'init_timelines',
	    CHANGE_TIMELINE_VOLUME: 'change_timeline_volume',
	    CHANGE_ZOOM: 'change_zoom',
	    ADD_AUDIO_TO_TIMELINE: 'add_audio_to_timeline',
	    SELECT_ELEMENT: 'select_element',
	    CHANGE_ELEMENT_POSITION: 'change_element_position',
	    DRAG_AND_CLONE_ELEMENT: 'drag_and_clone_element',
	    CHANGE_SOLO: 'change_solo',
	    CHANGE_MUTE: 'change_mute',
	    DELETE_ITEM: 'detele_item',
	    SET_MARKER_POSITION: 'set_marker_position',
	    SPLIT_AUDIO: 'split_audio',
	    AUDIO_EDITOR_UNDO_REDO: 'audio_editor_undo_redo',
	    SET_TIMELINE_WIDTH: 'set_timeline_width',
	    UPDATE_ITEM: 'update_item',
	    UPDATE_SOUND_DURATION: 'update_sound_duration',
	    CHANGE_TITLE: 'change_title',
	    SET_VOLUME_POINTS: 'set_volume_points',
	    SHOW_TRACK_MENU: 'show_track_menu',
	    ADD_TRACK: 'add_track',
	    DELETE_TRACK: 'delete_track',
	    REFRESH_AUDIO_TRACK: 'refresh_audio_track',
	    CHANGE_VOLUME: 'change_volume',
	    REFRESH_AUDIO_ELEMENTS: 'refresh_audio_elements',
	    MOVE_BLOCK: 'move_block',
	    RECORDED_DATA_IOS: 'recorded_data_IOS'
	};
	
	function initTimelines(content) {
	    return { type: types.INIT_TIMELINES, content: content };
	}
	
	function changeTimelineVolume(index, volume) {
	    return { type: types.CHANGE_TIMELINE_VOLUME, index: index, volume: volume };
	}
	
	function changeZoom(value) {
	    return { type: types.CHANGE_ZOOM, value: value };
	}
	
	function addAudioToTimeline(index, audio) {
	    return { type: types.ADD_AUDIO_TO_TIMELINE, index: index, audio: audio };
	}
	
	function selectElement(uuid, value) {
	    return { type: types.SELECT_ELEMENT, uuid: uuid, value: value };
	}
	
	function changeElementPosition(properties) {
	    return { type: types.CHANGE_ELEMENT_POSITION, properties: properties };
	}
	
	function dragAndCloneElement(properties) {
	    return { type: types.DRAG_AND_CLONE_ELEMENT, properties: properties };
	}
	
	function changeSolo(index) {
	    return { type: types.CHANGE_SOLO, index: index };
	}
	
	function changeMute(index) {
	    return { type: types.CHANGE_MUTE, index: index };
	}
	
	function changeVolume(volume) {
	    return { type: types.CHANGE_VOLUME, volume: volume };
	}
	
	function deleteItem(uuid) {
	    return { type: types.DELETE_ITEM, uuid: uuid };
	}
	
	function setMarkerPosition(position) {
	    return { type: types.SET_MARKER_POSITION, position: position };
	}
	
	function splitAudio(audio, markerPosition) {
	    return { type: types.SPLIT_AUDIO, audio: audio, markerPosition: markerPosition };
	}
	
	function audioEditorUndoRedo(newState) {
	    return { type: types.AUDIO_EDITOR_UNDO_REDO, newState: newState };
	}
	
	function setTimelineWidth(width) {
	    return { type: types.SET_TIMELINE_WIDTH, width: width };
	}
	
	function updateItem(uuids, href) {
	    return { type: types.UPDATE_ITEM, uuids: uuids, href: href };
	}
	
	function updateSoundDuration(uuid, duration) {
	    return { type: types.UPDATE_SOUND_DURATION, uuid: uuid, duration: duration };
	}
	
	function changeTitle(index, title) {
	    return { type: types.CHANGE_TITLE, index: index, title: title };
	}
	
	function setVolumePoints(uuid, points) {
	    return { type: types.SET_VOLUME_POINTS, uuid: uuid, points: points };
	}
	
	function showTrackMenu(value) {
	    return { type: types.SHOW_TRACK_MENU, value: value };
	}
	
	function addTrack(index) {
	    return { type: types.ADD_TRACK, index: index };
	}
	
	function deleteTrack(index) {
	    return { type: types.DELETE_TRACK, index: index };
	}
	
	function refreshAudioTrack(value) {
	    return { type: types.REFRESH_AUDIO_TRACK, value: value };
	}
	
	function refreshAudioElements(value) {
	    return { type: types.REFRESH_AUDIO_ELEMENTS, value: value };
	}
	
	function moveBlock(array, offsetX, indexOffset) {
	    return { type: types.MOVE_BLOCK, array: array, offsetX: offsetX, indexOffset: indexOffset };
	}
	
	function recordedDataIos(data) {
	    return { type: types.RECORDED_DATA_IOS, data: data };
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/actions/AudioEditorActions.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/actions/AudioEditorActions.js"); } } })();

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InteractiveShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _ShapeAspectRatioUtils = __webpack_require__(374);
	
	var _ShapeAspectRatioUtils2 = _interopRequireDefault(_ShapeAspectRatioUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _TouchUtils = __webpack_require__(109);
	
	var _TouchUtils2 = _interopRequireDefault(_TouchUtils);
	
	var _MultiTouchUtils = __webpack_require__(851);
	
	var _MultiTouchUtils2 = _interopRequireDefault(_MultiTouchUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _MindMapUtils = __webpack_require__(85);
	
	var _MindMapUtils2 = _interopRequireDefault(_MindMapUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _MenuActions = __webpack_require__(7);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InteractiveShape = exports.InteractiveShape = _react2.default.createClass({
	    displayName: 'InteractiveShape',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        children: _react2.default.PropTypes.object.isRequired,
	        shapeModel: _react2.default.PropTypes.object.isRequired,
	        rotatable: _react2.default.PropTypes.bool,
	        isBubble: _react2.default.PropTypes.bool
	    },
	    getInitialState: function getInitialState() {
	        var rotation = this.props.shapeModel.rotation;
	
	        var rot = 0;
	
	        if (!isNaN(rotation)) rot = rotation;
	
	        return {
	            interaction: 'none',
	            rotation: rot,
	            scaleOffsetX: 1,
	            scaleOffsetY: 1,
	            translateOffsetX: 0,
	            translateOffsetY: 0,
	            trX: 0,
	            trY: 0,
	            cx: 0,
	            cy: 0,
	            cx1: 0,
	            cy1: 0,
	            cx2: 0,
	            cy2: 0,
	            cx3: 0,
	            cy3: 0,
	            cx4: 0,
	            cy4: 0,
	            cx5: 0,
	            cy5: 0,
	            startX: 0,
	            startY: 0,
	            startWidth: 0,
	            startHeight: 0,
	            horizontalFlip: 1,
	            verticalFlip: 1,
	            isMultiTouch: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isFirefox() == false) document.addEventListener('mouseout', this.onFocusOut);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        if (_PlatformDetection2.default.isFirefox() == false) document.removeEventListener('mouseout', this.onFocusOut);
	    },
	    onFocusOut: function onFocusOut(evt) {
	        var position = (0, _TransformToolUtils.getTouchPosition)(evt);
	
	        if (position.x < 2 || position.y < 2 || position.x > window.innerWidth - 2 || position.y > window.innerHeight - 2) {
	            if (this.isScaleInteraction() == true) this.onScaleShapeStopped();else if (this.state.interaction == 'move') this.onMoveShapeStopped();
	        }
	    },
	    updateScaleState: function updateScaleState(coreEvent) {
	        var width = this.state.startWidth;
	        var height = this.state.startHeight;
	
	        var rotation = this.props.shapeModel.rotation;
	
	        var newWidth = void 0;
	        var newHeight = void 0;
	        var tx = void 0;
	        var ty = void 0;
	        var id = this.getCorrectId(coreEvent.id);
	        var newDelta = (0, _TransformToolUtils.transformPointToRotatedSystem)({ x: coreEvent.lastX / this.scaleFactor(), y: coreEvent.lastY / this.scaleFactor() }, rotation);
	        var aspectRatio = height / width;
	        var useAspectRatio = false;
	
	        if (_ShapeAspectRatioUtils2.default.isShift == true || _ShapeAspectRatioUtils2.default.default && _ShapeAspectRatioUtils2.default.default.isShift == true) useAspectRatio = true;
	
	        var trX = newDelta.x;
	        var trY = newDelta.y;
	
	        switch (id) {
	            case 'topLeft':
	                {
	                    newWidth = width - newDelta.x;
	                    tx = newDelta.x;
	
	                    if (useAspectRatio == false) {
	                        newHeight = height - newDelta.y;
	                        ty = newDelta.y;
	                    } else {
	                        newHeight = newWidth * aspectRatio;
	                        ty = tx * aspectRatio;
	                        trY = ty;
	                    }
	                    break;
	                }
	            case 'topRight':
	                {
	                    newWidth = width + newDelta.x;
	                    tx = 0;
	
	                    if (useAspectRatio == false) {
	                        newHeight = height - newDelta.y;
	                        ty = newDelta.y;
	                    } else {
	                        newHeight = newWidth * aspectRatio;
	
	                        tx = 0;
	                        ty = -newDelta.x * aspectRatio;
	
	                        trX = newDelta.x;
	                        trY = -newDelta.x * aspectRatio;
	                    }
	                    break;
	                }
	            case 'bottomRight':
	                {
	                    newWidth = width + newDelta.x;
	                    tx = 0;
	
	                    if (useAspectRatio == false) {
	                        newHeight = height + newDelta.y;
	                        ty = 0;
	                    } else {
	                        newHeight = newWidth * aspectRatio;
	                        ty = tx * aspectRatio;
	                        trY = newDelta.x * aspectRatio;
	                    }
	                    break;
	                }
	            case 'bottomLeft':
	                {
	                    newWidth = width - newDelta.x;
	                    tx = newDelta.x;
	
	                    if (useAspectRatio == false) {
	                        newHeight = height + newDelta.y;
	                        ty = 0;
	                    } else {
	                        newHeight = newWidth * aspectRatio;
	
	                        tx = newDelta.x;
	                        ty = 0;
	
	                        trX = newDelta.x;
	                        trY = -newDelta.x * aspectRatio;
	                    }
	                    break;
	                }
	            case 'middleLeft':
	                {
	                    newWidth = width - newDelta.x;
	                    newHeight = height;
	                    tx = newDelta.x;
	
	                    ty = 0;
	                    trY = 0;
	                    break;
	                }
	            case 'middleRight':
	                {
	                    newWidth = width + newDelta.x;
	                    newHeight = height;
	                    tx = 0;
	
	                    ty = 0;
	                    trY = 0;
	                    break;
	                }
	            case 'middleTop':
	                {
	                    newWidth = width;
	                    newHeight = height - newDelta.y;
	                    ty = newDelta.y;
	
	                    tx = 0;
	                    trX = 0;
	                    break;
	                }
	            case 'middleBottom':
	                {
	                    newWidth = width;
	                    newHeight = height + newDelta.y;
	                    ty = 0;
	
	                    tx = 0;
	                    trX = 0;
	                    break;
	                }
	        }
	
	        return { newWidth: newWidth, newHeight: newHeight, tx: tx, ty: ty, id: id, trX: trX, trY: trY };
	    },
	    getCorrectId: function getCorrectId(id) {
	        var index = id.indexOf('_');
	
	        if (index != -1) return id.substring(0, index);else return id;
	    },
	    onScaleStart: function onScaleStart(e, coreEvent) {
	        e.preventDefault();
	        var shapeModel = this.props.shapeModel;
	
	
	        if (shapeModel.isLocked == true) return;
	
	        this.setState({
	            startX: shapeModel.x,
	            startY: shapeModel.y,
	            startWidth: shapeModel.width,
	            startHeight: shapeModel.height,
	            horizontalFlip: shapeModel.horizontalFlip,
	            verticalFlip: shapeModel.verticalFlip,
	            coreEventObject: undefined,
	            interaction: this.getCorrectId(coreEvent.node.id)
	        });
	
	        if ((0, _TransformToolUtils.isTextBubble)(shapeModel) == true) {
	            var controlPointState = {};
	
	            controlPointState.cx = shapeModel.cx;
	            controlPointState.cy = shapeModel.cy;
	
	            if (shapeModel.cx1 && shapeModel.cy1) {
	                controlPointState.cx1 = shapeModel.cx1;
	                controlPointState.cy1 = shapeModel.cy1;
	            }
	
	            if (shapeModel.cx2 && shapeModel.cy2) {
	                controlPointState.cx2 = shapeModel.cx2;
	                controlPointState.cy2 = shapeModel.cy2;
	            }
	
	            if (shapeModel.cx3 && shapeModel.cy3) {
	                controlPointState.cx3 = shapeModel.cx3;
	                controlPointState.cy3 = shapeModel.cy3;
	            }
	
	            if (shapeModel.cx4 && shapeModel.cy4) {
	                controlPointState.cx4 = shapeModel.cx4;
	                controlPointState.cy4 = shapeModel.cy4;
	            }
	
	            if (shapeModel.cx5 && shapeModel.cy5) {
	                controlPointState.cx5 = shapeModel.cx5;
	                controlPointState.cy5 = shapeModel.cy5;
	            }
	
	            this.setState(controlPointState);
	        }
	
	        this.props.dispatch((0, _CurrentSlideActions.changeInteractionState)(this.props.shapeModel.uuid, true));
	    },
	    onScaleDrag: function onScaleDrag(e, coreEvent) {
	        if (this.isScaleInteraction() == false) return;
	
	        if (this.props.shapeModel.isLocked == true) return;
	
	        var _props$shapeModel = this.props.shapeModel,
	            width = _props$shapeModel.width,
	            height = _props$shapeModel.height,
	            type = _props$shapeModel.type;
	
	        var coreEventObject = { lastX: coreEvent.lastX, lastY: coreEvent.lastY, id: coreEvent.node.id };
	
	        if ((0, _TransformToolUtils.useScaleFactor)(type)) {
	            var newPosition = this.updateScaleState(coreEventObject);
	
	            this.setState({
	                scaleOffsetX: newPosition.newWidth / width,
	                scaleOffsetY: newPosition.newHeight / height,
	                translateOffsetX: newPosition.tx,
	                translateOffsetY: newPosition.ty,
	                trX: newPosition.trX,
	                trY: newPosition.trY,
	                interaction: this.getCorrectId(newPosition.id),
	                coreEventObject: coreEventObject
	            });
	        } else {
	            this.setState({
	                interaction: this.getCorrectId(coreEvent.node.id)
	            });
	
	            this.scaleContent(coreEventObject);
	        }
	    },
	    scaleContent: function scaleContent(coreEvent) {
	        var endResize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	        var newPosition = this.updateScaleState(coreEvent);
	
	        var rotatedTranslation = (0, _TransformToolUtils.transformPointFromRotatedSystem)({ x: newPosition.trX, y: newPosition.trY }, shapeModel.rotation);
	
	        var oldCenterX = this.state.startX + this.state.startWidth / 2;
	        var oldCenterY = this.state.startY + this.state.startHeight / 2;
	
	        var newCenterX = oldCenterX + rotatedTranslation.x / 2;
	        var newCenterY = oldCenterY + rotatedTranslation.y / 2;
	
	        var newX = newCenterX - newPosition.newWidth / 2;
	        var newY = newCenterY - newPosition.newHeight / 2;
	
	        // flip functionality
	        var hf = !this.state.horizontalFlip ? 1 : this.state.horizontalFlip;
	        var vf = !this.state.verticalFlip ? 1 : this.state.verticalFlip;
	        var horizontalFlip = newPosition.newWidth < 0 ? -1 * hf : hf;
	        var verticalFlip = newPosition.newHeight < 0 ? -1 * vf : vf;
	
	        if ((0, _TransformToolUtils.isTextBox)(this.props.shapeModel)) {
	            horizontalFlip = 1;
	            verticalFlip = 1;
	        }
	
	        if (newPosition.newWidth < 0) newX = newX + newPosition.newWidth;
	
	        if (newPosition.newHeight < 0) newY = newY + newPosition.newHeight;
	
	        var cx, cy, cx1, cy1, cx2, cy2, cx3, cy3, cx4, cy4, cx5, cy5;
	
	        if ((0, _TransformToolUtils.isTextBubble)(shapeModel)) {
	            var newControlPoint = this.keepAspectRatioForControlPoint(newX, newY, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), this.state.cx, this.state.cy);
	            cx = newControlPoint.x;
	            cy = newControlPoint.y;
	
	            if (shapeModel.cx1 && shapeModel.cy1) {
	                newControlPoint = this.keepAspectRatioForControlPoint(newX, newY, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), this.state.cx1, this.state.cy1);
	                cx1 = newControlPoint.x;
	                cy1 = newControlPoint.y;
	            }
	
	            if (shapeModel.cx2 && shapeModel.cy2) {
	                newControlPoint = this.keepAspectRatioForControlPoint(newX, newY, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), this.state.cx2, this.state.cy2);
	                cx2 = newControlPoint.x;
	                cy2 = newControlPoint.y;
	            }
	
	            if (shapeModel.cx3 && shapeModel.cy3) {
	                newControlPoint = this.keepAspectRatioForControlPoint(newX, newY, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), this.state.cx3, this.state.cy3);
	                cx3 = newControlPoint.x;
	                cy3 = newControlPoint.y;
	            }
	
	            if (shapeModel.cx4 && shapeModel.cy4) {
	                newControlPoint = this.keepAspectRatioForControlPoint(newX, newY, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), this.state.cx4, this.state.cy4);
	                cx4 = newControlPoint.x;
	                cy4 = newControlPoint.y;
	            }
	
	            if (shapeModel.cx5 && shapeModel.cy5) {
	                newControlPoint = this.keepAspectRatioForControlPoint(newX, newY, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), this.state.cx5, this.state.cy5);
	                cx5 = newControlPoint.x;
	                cy5 = newControlPoint.y;
	            }
	        }
	
	        if (_PlatformDetection2.default.isIOS() == false) {
	            if ((0, _TransformToolUtils.isTextBox)(shapeModel)) {
	
	                if (Math.abs(newPosition.newWidth) < 25 || Math.abs(newPosition.newHeight) < 25) return;
	
	                _TextSizeUtils2.default.updateFontSize(shapeModel, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), dispatch, endResize);
	            }
	        }
	
	        dispatch((0, _CurrentSlideActions.updateShapeSize)(shapeModel.uuid, Math.abs(newPosition.newWidth), Math.abs(newPosition.newHeight), newX, newY, horizontalFlip, verticalFlip, cx, cy, cx1, cy1, cx2, cy2, cx3, cy3, cx4, cy4, cx5, cy5));
	
	        _MindMapUtils2.default.updateShapePositionWhenResize(shapeModel);
	
	        if (_PlatformDetection2.default.isIOS() == true && endResize == true) setTimeout(this.refreshShape.bind(this), 5);
	
	        _SaveManager2.default.isContentChanged(true);
	    },
	    refreshShapeAfterResize: function refreshShapeAfterResize() {
	        setTimeout(this.refreshShape.bind(this), 2);
	    },
	    refreshShape: function refreshShape() {
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	
	        if (shapeModel.type == _ShapeConstants2.default.CHARACTER || shapeModel.type == _ShapeConstants2.default.IMAGE) {
	            dispatch((0, _CurrentSlideActions.moveShape)(shapeModel.uuid, 1, 1));
	            dispatch((0, _CurrentSlideActions.moveShape)(shapeModel.uuid, -1, -1));
	        }
	    },
	    keepAspectRatioForControlPoint: function keepAspectRatioForControlPoint(x, y, width, height, cx, cy) {
	        var newX;
	        var newY;
	
	        if (cx < this.state.startX) newX = x + (cx - this.state.startX);else if (cx > this.state.startX + this.state.startWidth) newX = x + width + (cx - (this.state.startX + this.state.startWidth));else newX = x + (cx - this.state.startX);
	
	        if (cy < this.state.startY) newY = y + (cy - this.state.startY);else if (cy > this.state.startY + this.state.startHeight) newY = y + height + (cy - (this.state.startY + this.state.startHeight));else newY = y + (cy - this.state.startY);
	
	        return { x: newX, y: newY };
	    },
	    isScaleInteraction: function isScaleInteraction() {
	        switch (this.state.interaction) {
	            case 'topLeft':
	            case 'topRight':
	            case 'bottomLeft':
	            case 'bottomRight':
	            case 'middleTop':
	            case 'middleLeft':
	            case 'middleBottom':
	            case 'middleRight':
	                {
	                    return true;
	                }
	            default:
	                {
	                    return false;
	                }
	        }
	    },
	    onScaleShapeStopped: function onScaleShapeStopped(e) {
	        if (this.isScaleInteraction() == false) return;
	
	        if (e) e.preventDefault();
	
	        if (this.props.shapeModel.isLocked == true) return;
	
	        if ((0, _TransformToolUtils.useScaleFactor)(this.props.shapeModel.type) && this.state.coreEventObject) {
	            this.scaleContent(this.state.coreEventObject, true);
	        } else {
	            if (_PlatformDetection2.default.isIOS() == true) {
	                if ((0, _TransformToolUtils.isTextBox)(this.props.shapeModel)) _TextSizeUtils2.default.updateFontSize(this.props.shapeModel, Math.abs(this.props.shapeModel.width), Math.abs(this.props.shapeModel.height), this.props.dispatch, true, this.state.startWidth, this.state.startHeight);
	            }
	        }
	
	        this.setState({
	            scaleOffsetX: 1,
	            scaleOffsetY: 1,
	            translateOffsetX: 0,
	            translateOffsetY: 0,
	            trX: 0,
	            trY: 0,
	            interaction: 'none'
	        });
	
	        _AudioEditorUtils2.default.addActionToHistory();
	        this.props.dispatch((0, _CurrentSlideActions.changeInteractionState)(this.props.shapeModel.uuid, false));
	
	        this.updateThumbnail();
	
	        this.props.dispatch((0, _MenuActions.refreshShapePosition)(this.props.shapeModel.uuid));
	    },
	    updateThumbnail: function updateThumbnail() {
	        //return; // updating thumbnail causes a downtime so it affects the performance
	        var dispatch = this.props.dispatch;
	
	        dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    onControlPointStart: function onControlPointStart(e, coreEvent) {
	        e.preventDefault();
	        var shapeModel = this.props.shapeModel;
	
	
	        if (shapeModel.isLocked == true) return;
	
	        var stateObject = {};
	        var id = this.getCorrectId(coreEvent.node.id);
	
	        switch (id) {
	            case 'controlPoint':
	                {
	                    stateObject.cx = shapeModel.cx;
	                    stateObject.cy = shapeModel.cy;
	                    stateObject.interaction = id;
	                    break;
	                }
	
	            case 'controlPoint1':
	                {
	                    stateObject.cx1 = shapeModel.cx1;
	                    stateObject.cy1 = shapeModel.cy1;
	                    stateObject.interaction = id;
	                    break;
	                }
	
	            case 'controlPoint2':
	                {
	                    stateObject.cx2 = shapeModel.cx2;
	                    stateObject.cy2 = shapeModel.cy2;
	                    stateObject.interaction = id;
	                    break;
	                }
	
	            case 'controlPoint3':
	                {
	                    stateObject.cx3 = shapeModel.cx3;
	                    stateObject.cy3 = shapeModel.cy3;
	                    stateObject.interaction = id;
	                    break;
	                }
	
	            case 'controlPoint4':
	                {
	                    stateObject.cx4 = shapeModel.cx4;
	                    stateObject.cy4 = shapeModel.cy4;
	                    stateObject.interaction = id;
	                    break;
	                }
	
	            case 'controlPoint5':
	                {
	                    stateObject.cx5 = shapeModel.cx5;
	                    stateObject.cy5 = shapeModel.cy5;
	                    stateObject.interaction = id;
	                    break;
	                }
	        }
	
	        this.setState(stateObject);
	        this.props.dispatch((0, _CurrentSlideActions.changeInteractionState)(this.props.shapeModel.uuid, true));
	    },
	    onControlPointDrag: function onControlPointDrag(e, coreEvent) {
	        e.preventDefault();
	        var _props3 = this.props,
	            shapeModel = _props3.shapeModel,
	            dispatch = _props3.dispatch;
	
	
	        if (shapeModel.isLocked == true) return;
	
	        var stateCx, stateCy;
	        var id = this.getCorrectId(coreEvent.node.id);
	
	        switch (id) {
	            case 'controlPoint':
	                {
	                    stateCx = this.state.cx;
	                    stateCy = this.state.cy;
	                    break;
	                }
	
	            case 'controlPoint1':
	                {
	                    stateCx = this.state.cx1;
	                    stateCy = this.state.cy1;
	                    break;
	                }
	
	            case 'controlPoint2':
	                {
	                    stateCx = this.state.cx2;
	                    stateCy = this.state.cy2;
	                    break;
	                }
	
	            case 'controlPoint3':
	                {
	                    stateCx = this.state.cx3;
	                    stateCy = this.state.cy3;
	                    break;
	                }
	
	            case 'controlPoint4':
	                {
	                    stateCx = this.state.cx4;
	                    stateCy = this.state.cy4;
	                    break;
	                }
	
	            case 'controlPoint5':
	                {
	                    stateCx = this.state.cx5;
	                    stateCy = this.state.cy5;
	                    break;
	                }
	        }
	
	        dispatch((0, _CurrentSlideActions.updateBubbleControlPoint)(shapeModel.uuid, stateCx + coreEvent.lastX / this.scaleFactor(), stateCy + coreEvent.lastY / this.scaleFactor(), id));
	
	        _SaveManager2.default.isContentChanged(true);
	    },
	    onControlPointStop: function onControlPointStop(e, coreEvent) {
	        e.preventDefault();
	
	        var _props4 = this.props,
	            shapeModel = _props4.shapeModel,
	            dispatch = _props4.dispatch;
	
	
	        if (shapeModel.isLocked == true) return;
	
	        var stateCx, stateCy;
	        var id = this.getCorrectId(coreEvent.node.id);
	
	        switch (id) {
	            case 'controlPoint':
	                {
	                    stateCx = this.state.cx;
	                    stateCy = this.state.cy;
	                    break;
	                }
	
	            case 'controlPoint1':
	                {
	                    stateCx = this.state.cx1;
	                    stateCy = this.state.cy1;
	                    break;
	                }
	
	            case 'controlPoint2':
	                {
	                    stateCx = this.state.cx2;
	                    stateCy = this.state.cy2;
	                    break;
	                }
	
	            case 'controlPoint3':
	                {
	                    stateCx = this.state.cx3;
	                    stateCy = this.state.cy3;
	                    break;
	                }
	
	            case 'controlPoint4':
	                {
	                    stateCx = this.state.cx4;
	                    stateCy = this.state.cy4;
	                    break;
	                }
	
	            case 'controlPoint5':
	                {
	                    stateCx = this.state.cx5;
	                    stateCy = this.state.cy5;
	                    break;
	                }
	        }
	
	        dispatch((0, _CurrentSlideActions.updateBubbleControlPoint)(shapeModel.uuid, stateCx + coreEvent.lastX / this.scaleFactor(), stateCy + coreEvent.lastY / this.scaleFactor(), id));
	
	        this.setState({
	            interaction: 'none',
	            cx: 0,
	            cy: 0,
	            cx1: 0,
	            cy1: 0,
	            cx2: 0,
	            cy2: 0,
	            cx3: 0,
	            cy3: 0,
	            cx4: 0,
	            cy4: 0,
	            cx5: 0,
	            cy5: 0,
	            scaleOffsetX: 1,
	            scaleOffsetY: 1,
	            translateOffsetX: 0,
	            translateOffsetY: 0,
	            trX: 0,
	            trY: 0
	        });
	
	        _AudioEditorUtils2.default.addActionToHistory();
	        this.props.dispatch((0, _CurrentSlideActions.changeInteractionState)(this.props.shapeModel.uuid, false));
	
	        this.updateThumbnail();
	        _SaveManager2.default.isContentChanged(true);
	
	        this.props.dispatch((0, _MenuActions.refreshShapePosition)(this.props.shapeModel.uuid));
	
	        if (this.props.shapeModel.isMindMap && Math.abs(coreEvent.lastX) <= 2 && Math.abs(coreEvent.lastY) <= 2) // it's click (not drag-drop) on a mindMap node
	            this.openMindMapMenu(id);
	    },
	    openMindMapMenu: function openMindMapMenu(id) {
	        setTimeout(function () {
	            _MindMapUtils2.default.selectedMindMap = this.props.shapeModel.uuid;
	            _MindMapUtils2.default.selectedNode = id;
	
	            this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.MIND_MAP_MENU));
	        }.bind(this), 5);
	    },
	    onKeyDownHandler: function onKeyDownHandler(e) {
	        if (e.keyCode === 13) {
	            // ENTER
	            var id = this.getCorrectId(e.target.parentElement.id);
	
	            if (id && id.indexOf('controlPoint') != -1) this.openMindMapMenu(id);
	        }
	    },
	    onRotate: function onRotate(e) {
	        e.preventDefault();
	        var shapeModel = this.props.shapeModel;
	
	
	        if (shapeModel.isLocked == true) return;
	
	        var position = (0, _TransformToolUtils.getTouchPosition)(e);
	        var newRotation = (0, _TransformToolUtils.detectCurrentAngle)(shapeModel, position.x, position.y, this.props.scaleProperties);
	
	        if (this.state.interaction != 'rotate') this.props.dispatch((0, _CurrentSlideActions.changeInteractionState)(this.props.shapeModel.uuid, true));
	
	        this.setState({
	            rotation: newRotation,
	            interaction: 'rotate'
	        });
	    },
	    onRotationStopped: function onRotationStopped(e) {
	        e.preventDefault();
	        var _props5 = this.props,
	            shapeModel = _props5.shapeModel,
	            dispatch = _props5.dispatch;
	
	
	        if (shapeModel.isLocked == true) return;
	
	        var position = (0, _TransformToolUtils.getTouchPosition)(e);
	        var newRotation = (0, _TransformToolUtils.detectCurrentAngle)(shapeModel, position.x, position.y, this.props.scaleProperties);
	
	        dispatch((0, _CurrentSlideActions.updateShapeRotation)(shapeModel.uuid, newRotation));
	
	        this.setState({
	            rotation: newRotation,
	            interaction: 'none',
	            scaleOffsetX: 1,
	            scaleOffsetY: 1,
	            translateOffsetX: 0,
	            translateOffsetY: 0,
	            trX: 0,
	            trY: 0
	        });
	
	        dispatch((0, _MenuActions.refreshShapePosition)(this.props.shapeModel.uuid));
	
	        _AudioEditorUtils2.default.addActionToHistory();
	        this.props.dispatch((0, _CurrentSlideActions.changeInteractionState)(this.props.shapeModel.uuid, false));
	
	        this.updateThumbnail();
	        _SaveManager2.default.isContentChanged(true);
	    },
	    checkActiveElement: function checkActiveElement() {
	        if (_PlatformDetection2.default.isTouchableDevice() == true) {
	            var shapeModel = this.props.shapeModel;
	
	
	            if ((0, _TransformToolUtils.isTextBox)(shapeModel) == false) document.activeElement.blur();
	        }
	    },
	    updateZoomProperties: function updateZoomProperties(properties) {
	        this.setState({
	            scaleOffsetX: properties.scaleX,
	            scaleOffsetY: properties.scaleY,
	            translateOffsetX: properties.translationX,
	            translateOffsetY: properties.translationY,
	            trX: properties.translationX,
	            trY: properties.translationY
	        });
	    },
	    isTextEditorMode: function isTextEditorMode() {
	        var checkEditor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        // the new rich text views shouldn't be move-able while int TEXT EDITOR mode
	        if (_TextEditorUtils2.default.isTextEditorTool()) {
	            var isDifferentShape = _TextEditorUtils2.default.selectedTextShape != '' && _TextEditorUtils2.default.selectedTextShape != this.props.shapeModel.uuid;
	
	            if (isDifferentShape) {
	                if (checkEditor) _TextEditorUtils2.default.closeTextEditor();
	
	                return false;
	            } else return true;
	        } else return false;
	    },
	    onMoveShapeStart: function onMoveShapeStart(e) {
	        if (this.isTextEditorMode(true)) return;
	
	        _TextEditorUtils2.default.isClick = false;
	        _TextEditorUtils2.default.isShapeAlreadySelected = this.props.shapeModel.isSelected;
	
	        if (_AppParameters2.default.context == _ModeConstants2.default.PRINT) return;
	
	        var _props6 = this.props,
	            shapeModel = _props6.shapeModel,
	            dispatch = _props6.dispatch;
	
	
	        if (_PlatformDetection2.default.isIOS() == true && (0, _TransformToolUtils.isTextBox)(shapeModel)) _TouchUtils2.default.mouseDown();
	
	        this.checkActiveElement();
	        _MultiTouchUtils2.default.endZoom();
	
	        if (shapeModel.isLocked == true || shapeModel.isGrouped == true) {
	            e.preventDefault();
	            return;
	        }
	
	        this.setState({
	            interaction: 'move'
	        });
	
	        dispatch((0, _CurrentSlideActions.changeInteractionState)(this.props.shapeModel.uuid, true, true));
	
	        _SelectionManager2.default.checkSelection(shapeModel.uuid);
	        _SelectionManager2.default.updateInitialPositions(shapeModel.uuid);
	
	        _MindMapUtils2.default.updateInitialPositions();
	    },
	    onMoveShape: function onMoveShape(e, coreEvent) {
	        if (this.isTextEditorMode()) return;
	
	        if (this.state.interaction != 'move') return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (shapeModel.isLocked == true || shapeModel.isGrouped == true) {
	            e.preventDefault();
	            return;
	        }
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (_MultiTouchUtils2.default.isMultiTouch(e)) {
	                _MultiTouchUtils2.default.zoom(e, shapeModel, this.refreshShapeAfterResize, this.updateZoomProperties);
	
	                return;
	            } else _MultiTouchUtils2.default.endZoom();
	
	            if (_MultiTouchUtils2.default.isResizing) return;
	        }
	
	        var newDelta = (0, _TransformToolUtils.transformPointToRotatedSystem)({ x: coreEvent.lastX / this.scaleFactor(), y: coreEvent.lastY / this.scaleFactor() }, shapeModel.rotation);
	
	        this.setState({
	            translateOffsetX: newDelta.x,
	            translateOffsetY: newDelta.y
	        });
	
	        var offsetX = coreEvent.lastX / this.scaleFactor();
	        var offsetY = coreEvent.lastY / this.scaleFactor();
	
	        _SelectionManager2.default.moveShapes(offsetX, offsetY, shapeModel.uuid);
	        _MindMapUtils2.default.updateShapePosition(shapeModel, offsetX, offsetY);
	    },
	    onMoveShapeStopped: function onMoveShapeStopped(e, coreEvent) {
	        if (this.isTextEditorMode()) return;
	
	        _TextEditorUtils2.default.isClick = false;
	
	        var _props7 = this.props,
	            shapeModel = _props7.shapeModel,
	            dispatch = _props7.dispatch;
	
	
	        if (_PlatformDetection2.default.isIOS() == true && (0, _TransformToolUtils.isTextBox)(shapeModel)) _TouchUtils2.default.mouseUp();
	
	        if (shapeModel.isLocked == true || shapeModel.isGrouped == true) {
	            dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid));
	
	            if (e) e.preventDefault();
	
	            return;
	        }
	
	        _SaveManager2.default.isContentChanged(true);
	
	        var isMultiTouch = _PlatformDetection2.default.isIOS() && _MultiTouchUtils2.default.isResizing;
	
	        if (this.state.interaction != 'move') return;
	
	        if (e && !isMultiTouch) {
	            var newX = shapeModel.x + coreEvent.lastX / this.scaleFactor();
	            var newY = shapeModel.y + coreEvent.lastY / this.scaleFactor();
	
	            var offsetX = coreEvent.lastX / this.scaleFactor();
	            var offsetY = coreEvent.lastY / this.scaleFactor();
	
	            dispatch((0, _CurrentSlideActions.updateShapePosition)(shapeModel.uuid, newX, newY));
	
	            _MindMapUtils2.default.updateShapePosition(shapeModel, offsetX, offsetY);
	
	            dispatch((0, _MenuActions.refreshShapePosition)(this.props.shapeModel.uuid));
	
	            if (Math.abs(coreEvent.lastX) <= 2 && Math.abs(coreEvent.lastY) <= 2) _TextEditorUtils2.default.isClick = true;
	
	            _SelectionManager2.default.moveShapes(offsetX, offsetY, shapeModel.uuid);
	        }
	
	        //document.getElementById('mainFocus').focus();
	
	        dispatch((0, _CurrentSlideActions.changeInteractionState)(this.props.shapeModel.uuid, false, false));
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid));
	
	        if (isMultiTouch) {
	            _MultiTouchUtils2.default.zoom(e, shapeModel, this.refreshShapeAfterResize);
	            _AudioEditorUtils2.default.addActionToHistory();
	            this.updateThumbnail();
	
	            _MultiTouchUtils2.default.endZoom();
	
	            this.setState({
	                scaleOffsetX: 1,
	                scaleOffsetY: 1,
	                translateOffsetX: 0,
	                translateOffsetY: 0,
	                trX: 0,
	                trY: 0,
	                interaction: 'none',
	                isMultiTouch: false
	            });
	
	            return;
	        }
	
	        this.setState({
	            scaleOffsetX: 1,
	            scaleOffsetY: 1,
	            translateOffsetX: 0,
	            translateOffsetY: 0,
	            trX: 0,
	            trY: 0,
	            interaction: 'none',
	            isMultiTouch: false
	        });
	
	        if (!e) {
	            _AudioEditorUtils2.default.addActionToHistory();
	            this.updateThumbnail();
	        } else {
	            if (Math.abs(coreEvent.lastX / this.scaleFactor()) > 10 || Math.abs(coreEvent.lastY / this.scaleFactor() > 10)) {
	                _AudioEditorUtils2.default.addActionToHistory();
	                this.updateThumbnail();
	            }
	        }
	    },
	    scaleFactor: function scaleFactor() {
	        var canvasScale = this.props.scaleProperties.scale;
	        return canvasScale;
	    },
	    render: function render() {
	        var _props$shapeModel2 = this.props.shapeModel,
	            x = _props$shapeModel2.x,
	            y = _props$shapeModel2.y,
	            width = _props$shapeModel2.width,
	            height = _props$shapeModel2.height,
	            horizontalFlip = _props$shapeModel2.horizontalFlip,
	            verticalFlip = _props$shapeModel2.verticalFlip,
	            cx = _props$shapeModel2.cx,
	            cy = _props$shapeModel2.cy,
	            isLocked = _props$shapeModel2.isLocked;
	
	        var isSelected = this.props.shapeModel.isSelected;
	        var cx1, cy1, cx2, cy2, cx3, cy3, cx4, cy4, cx5, cy5;
	        var isMindMap = this.props.shapeModel.isMindMap;
	
	        if (this.props.shapeModel.cx1 && this.props.shapeModel.cy1) {
	            cx1 = this.props.shapeModel.cx1;
	            cy1 = this.props.shapeModel.cy1;
	        }
	
	        if (this.props.shapeModel.cx2 && this.props.shapeModel.cy2) {
	            cx2 = this.props.shapeModel.cx2;
	            cy2 = this.props.shapeModel.cy2;
	        }
	
	        if (this.props.shapeModel.cx3 && this.props.shapeModel.cy3) {
	            cx3 = this.props.shapeModel.cx3;
	            cy3 = this.props.shapeModel.cy3;
	        }
	
	        if (this.props.shapeModel.cx4 && this.props.shapeModel.cy4) {
	            cx4 = this.props.shapeModel.cx4;
	            cy4 = this.props.shapeModel.cy4;
	        }
	
	        if (this.props.shapeModel.cx5 && this.props.shapeModel.cy5) {
	            cx5 = this.props.shapeModel.cx5;
	            cy5 = this.props.shapeModel.cy5;
	        }
	
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) isSelected = false;
	
	        var isAnimation = _AnimationManager2.default.isAnimationMode();
	        var showElement = true;
	
	        if (this.props.shapeModel.type == _ShapeConstants2.default.VIDEO) showElement = false;
	
	        var scale = this.props.scaleProperties.scale;
	        var rotationDist = 35;
	
	        var rotation = this.props.shapeModel.rotation;
	
	        if (rotation == undefined) rotation = 0;
	
	        if (this.state.interaction == 'rotate') rotation = this.state.rotation;
	
	        var scX = this.state.scaleOffsetX;
	        var scY = this.state.scaleOffsetY;
	
	        if (_AnimationManager2.default.isScaleAnimation(this.props.shapeModel) && _AnimationManager2.default.isAnimationTime) {
	            if (this.props.shapeModel.animationWidth > 0 && this.props.shapeModel.animationWidth != width) scX = this.props.shapeModel.animationWidth / width;
	
	            if (this.props.shapeModel.animationHeight > 0 && this.props.shapeModel.animationHeight != height) scY = this.props.shapeModel.animationHeight / height;
	        }
	
	        var objectTransform = 'translate(' + this.state.translateOffsetX + ' ' + this.state.translateOffsetY + ') scale(' + scX + ' ' + scY + ')';
	        var rotateTransform = 'rotate(' + rotation + ' ' + width / 2 + ' ' + height / 2 + ')';
	        var pathPoints = void 0;
	        var translateTransform = 'translate(' + this.state.trX + ' ' + this.state.trY + ')';
	        var flipTransform = '';
	
	        if (horizontalFlip && verticalFlip) {
	            var flipTranslateX = horizontalFlip < 0 ? -width : 0;
	            var flipTranslateY = verticalFlip < 0 ? -height : 0;
	            flipTransform = 'scale(' + horizontalFlip + ' ' + verticalFlip + ') translate(' + flipTranslateX + ' ' + flipTranslateY + ')';
	        }
	
	        var isStage = window.location.href.indexOf('stage') !== -1 || window.location.href.indexOf('localhost') !== -1;
	        var simplePath = 'M0 0 L' + width + ' 0 L' + width + ' ' + height + ' L0 ' + height + ' Z';
	        var rotationPath = 'M' + width / 2 + ' 0 L' + width / 2 + ' -' + rotationDist / scale + ' M0 0 L' + width + ' 0 L' + width + ' ' + height + ' L0 ' + height + ' Z';
	        var showRotation = void 0;
	
	        if (this.props.rotatable && showElement) {
	            if (!isAnimation) {
	                pathPoints = rotationPath;
	                showRotation = true;
	            } else {
	                if (isStage) {
	                    pathPoints = rotationPath;
	                    showRotation = true;
	                } else {
	                    pathPoints = simplePath;
	                    showRotation = false;
	                }
	            }
	        } else {
	            pathPoints = simplePath;
	            showRotation = false;
	        }
	
	        var rotateFill = void 0;
	        var rotateStroke = void 0;
	
	        if (this.state.interaction == 'rotate') {
	            rotateFill = _TransformToolUtils.uiProperties.ROTATE_FILL_ACTIVE;
	            rotateStroke = _TransformToolUtils.uiProperties.ROTATE_STROKE_ACTIVE;
	        } else {
	            rotateFill = _TransformToolUtils.uiProperties.ROTATE_FILL_INACTIVE;
	            rotateStroke = _TransformToolUtils.uiProperties.ROTATE_STROKE_INACTIVE;
	        }
	
	        var cornerFill = void 0;
	        var cornerStroke = void 0;
	
	        if (this.state.interaction == 'topLeft' || this.state.interaction == 'topRight' || this.state.interaction == 'bottomRight' || this.state.interaction == 'bottomLeft' || this.state.interaction == 'middleLeft' || this.state.interaction == 'middleTop' || this.state.interaction == 'middleRight' || this.state.interaction == 'middleBottom' || this.state.interaction == 'controlPoint' || this.state.interaction == 'controlPoint1' || this.state.interaction == 'controlPoint2' || this.state.interaction == 'controlPoint3' || this.state.interaction == 'controlPoint4' || this.state.interaction == 'controlPoint5') {
	            cornerFill = _TransformToolUtils.uiProperties.CORNER_FILL_ACTIVE;
	            cornerStroke = _TransformToolUtils.uiProperties.CORNER_STROKE_ACTIVE;
	        } else {
	            cornerFill = _TransformToolUtils.uiProperties.CORNER_FILL_INACTIVE;
	            cornerStroke = _TransformToolUtils.uiProperties.CORNER_STROKE_INACTIVE;
	        }
	
	        var controlFill = void 0;
	        var controlStroke = void 0;
	
	        if (this.state.interaction == 'controlPoint' || this.state.interaction == 'controlPoint1' || this.state.interaction == 'controlPoint2' || this.state.interaction == 'controlPoint3' || this.state.interaction == 'controlPoint4' || this.state.interaction == 'controlPoint5') {
	            if (isMindMap) {
	                controlFill = _TransformToolUtils.uiProperties.ROTATE_FILL_ACTIVE;
	                controlStroke = _TransformToolUtils.uiProperties.ROTATE_STROKE_ACTIVE;
	            } else {
	                controlFill = _TransformToolUtils.uiProperties.CONTROL_FILL_ACTIVE;
	                controlStroke = _TransformToolUtils.uiProperties.CONTROL_STROKE_ACTIVE;
	            }
	        } else {
	            if (isMindMap) {
	                controlFill = _TransformToolUtils.uiProperties.ROTATE_FILL_INACTIVE;
	                controlStroke = _TransformToolUtils.uiProperties.ROTATE_STROKE_INACTIVE;
	            } else {
	                controlFill = _TransformToolUtils.uiProperties.CONTROL_FILL_INACTIVE;
	                controlStroke = _TransformToolUtils.uiProperties.CONTROL_STROKE_INACTIVE;
	            }
	        }
	
	        var radiusOffset = 0;
	
	        if (_PlatformDetection2.default.isIOS()) radiusOffset = 2;
	
	        var radius = (_TransformToolUtils.uiProperties.RADIUS + radiusOffset) / scale;
	        var rotationIconOffset = 4 / scale;
	        var lockScale = 2;
	
	        var isLockedVisible = false;
	
	        if (isSelected && isLocked && _PreviewCommands2.default.isEditorMode() == true) isLockedVisible = true;
	
	        var interactivity;
	
	        // in animation mode, only the shapes from the current animations should be clickable
	        if (_AnimationManager2.default.clone && !this.props.shapeModel.isGrouped) {
	            var clones = _AnimationManager2.default.getAllAnimationTargets();
	            var isInTargets = false;
	
	            for (var idx = 0; idx < clones.length; idx++) {
	                if (clones[idx].uuid === this.props.shapeModel.uuid) isInTargets = true;
	            }
	
	            if (!isInTargets) interactivity = 'none';
	        }
	
	        var extraRadius = radius;
	
	        return _react2.default.createElement(
	            'g',
	            { id: 'shapeBound_' + Math.random(), pointerEvents: interactivity, transform: 'translate(' + x + ' ' + y + ')' },
	            _react2.default.createElement(
	                'g',
	                { transform: rotateTransform },
	                _react2.default.createElement(
	                    'g',
	                    { transform: objectTransform },
	                    _react2.default.createElement(
	                        'g',
	                        { transform: flipTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMoveShapeStart, onDrag: this.onMoveShape, onStop: this.onMoveShapeStopped },
	                            _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
	                                x: 0,
	                                y: 0,
	                                ref: 'shapeView'
	                            })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'g',
	                { transform: rotateTransform },
	                isSelected && this.state.interaction == 'none' ? _react2.default.createElement('path', { stroke: _TransformToolUtils.uiProperties.PATH_COLOR, strokeWidth: _TransformToolUtils.uiProperties.STROKE, fill: 'none', d: pathPoints }) : null,
	                showRotation && isSelected && this.props.rotatable && showElement && (this.state.interaction == 'rotate' || this.state.interaction == 'none') ? _react2.default.createElement(
	                    'g',
	                    { transform: 'translate(' + (width / 2 - radius) + ' ' + (-(rotationDist / scale) - radius) + ')' },
	                    _react2.default.createElement(
	                        _reactDraggable2.default,
	                        { axis: 'none', position: { x: 0, y: 0 }, onDrag: this.onRotate, onStop: this.onRotationStopped },
	                        _react2.default.createElement(
	                            'g',
	                            null,
	                            _react2.default.createElement('circle', { cx: radius, cy: radius - extraRadius, r: radius, fill: rotateFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: rotateStroke }),
	                            _react2.default.createElement('image', { xlinkHref: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/rotate.png', x: rotationIconOffset, y: rotationIconOffset - extraRadius, width: radius * 2 - 2 * rotationIconOffset, height: radius * 2 - 2 * rotationIconOffset, preserveAspectRatio: 'none' })
	                        )
	                    )
	                ) : null,
	                isSelected ? _react2.default.createElement(
	                    'g',
	                    { transform: '' },
	                    this.state.interaction == 'none' || this.state.interaction == 'topLeft' ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleShapeStopped },
	                            _react2.default.createElement('circle', { id: 'topLeft_' + Math.random(), cx: 0 - extraRadius / 1.5, cy: 0 - extraRadius / 1.5, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	                        )
	                    ) : null,
	                    this.state.interaction == 'none' || this.state.interaction == 'topRight' ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleShapeStopped },
	                            _react2.default.createElement('circle', { id: 'topRight_' + Math.random(), cx: width + extraRadius / 1.5, cy: 0 - extraRadius / 1.5, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	                        )
	                    ) : null,
	                    this.state.interaction == 'none' || this.state.interaction == 'bottomRight' ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleShapeStopped },
	                            _react2.default.createElement('circle', { id: 'bottomRight_' + Math.random(), cx: width + extraRadius / 1.5, cy: height + extraRadius / 1.5, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	                        )
	                    ) : null,
	                    this.state.interaction == 'none' || this.state.interaction == 'bottomLeft' ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleShapeStopped },
	                            _react2.default.createElement('circle', { id: 'bottomLeft_' + Math.random(), cx: 0 - extraRadius / 1.5, cy: height + extraRadius / 1.5, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	                        )
	                    ) : null,
	                    !isAnimation && showElement && (this.state.interaction == 'none' || this.state.interaction == 'middleLeft') ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleShapeStopped },
	                            _react2.default.createElement('rect', { id: 'middleLeft_' + Math.random(), x: -radius - extraRadius, y: height / 2 - radius, width: 2 * radius, height: 2 * radius, rx: 3, ry: 3, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	                        )
	                    ) : null,
	                    !isAnimation && showElement && (this.state.interaction == 'none' || this.state.interaction == 'middleRight') ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleShapeStopped },
	                            _react2.default.createElement('rect', { id: 'middleRight_' + Math.random(), x: width - radius + extraRadius, y: height / 2 - radius, width: 2 * radius, height: 2 * radius, rx: 3, ry: 3, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	                        )
	                    ) : null,
	                    !isAnimation && showElement && (this.state.interaction == 'none' || this.state.interaction == 'middleTop') ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleShapeStopped },
	                            _react2.default.createElement('rect', { id: 'middleTop_' + Math.random(), x: width / 2 - radius, y: -radius - extraRadius, width: 2 * radius, height: 2 * radius, fill: cornerFill, rx: 3, ry: 3, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	                        )
	                    ) : null,
	                    !isAnimation && showElement && (this.state.interaction == 'none' || this.state.interaction == 'middleBottom') ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleShapeStopped },
	                            _react2.default.createElement('rect', { id: 'middleBottom_' + Math.random(), x: width / 2 - radius, y: height - radius + extraRadius, width: 2 * radius, height: 2 * radius, rx: 3, ry: 3, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	                        )
	                    ) : null,
	                    !isAnimation && this.props.isBubble && (this.state.interaction == 'none' || this.state.interaction == 'controlPoint') ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onControlPointStart, onDrag: this.onControlPointDrag, onStop: this.onControlPointStop },
	                            isMindMap ? _react2.default.createElement(
	                                'g',
	                                { id: 'controlPoint_' + Math.random() },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', onKeyDown: this.onKeyDownHandler },
	                                    _react2.default.createElement('circle', { cx: cx - x, cy: cy - y, r: radius, fill: controlFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: controlStroke })
	                                ),
	                                _react2.default.createElement('image', { xlinkHref: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg', x: cx - x - radius, y: cy - y - radius, width: radius * 2, height: radius * 2, preserveAspectRatio: 'none' })
	                            ) : _react2.default.createElement('circle', { id: 'controlPoint_' + Math.random(), cx: cx - x, cy: cy - y, r: radius, fill: controlFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: controlStroke })
	                        )
	                    ) : null,
	                    !isAnimation && this.props.isBubble && cx1 && cy1 && (this.state.interaction == 'none' || this.state.interaction == 'controlPoint1') ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onControlPointStart, onDrag: this.onControlPointDrag, onStop: this.onControlPointStop },
	                            isMindMap ? _react2.default.createElement(
	                                'g',
	                                { id: 'controlPoint1_' + Math.random() },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', onKeyDown: this.onKeyDownHandler },
	                                    _react2.default.createElement('circle', { cx: cx1 - x, cy: cy1 - y, r: radius, fill: controlFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: controlStroke })
	                                ),
	                                _react2.default.createElement('image', { xlinkHref: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg', x: cx1 - x - radius, y: cy1 - y - radius, width: radius * 2, height: radius * 2, preserveAspectRatio: 'none' })
	                            ) : _react2.default.createElement('circle', { id: 'controlPoint1_' + Math.random(), cx: cx1 - x, cy: cy1 - y, r: radius, fill: controlFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: controlStroke })
	                        )
	                    ) : null,
	                    !isAnimation && this.props.isBubble && cx2 && cy2 && (this.state.interaction == 'none' || this.state.interaction == 'controlPoint2') ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onControlPointStart, onDrag: this.onControlPointDrag, onStop: this.onControlPointStop },
	                            isMindMap ? _react2.default.createElement(
	                                'g',
	                                { id: 'controlPoint2_' + Math.random() },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', onKeyDown: this.onKeyDownHandler },
	                                    _react2.default.createElement('circle', { cx: cx2 - x, cy: cy2 - y, r: radius, fill: controlFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: controlStroke })
	                                ),
	                                _react2.default.createElement('image', { xlinkHref: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg', x: cx2 - x - radius, y: cy2 - y - radius, width: radius * 2, height: radius * 2, preserveAspectRatio: 'none' })
	                            ) : _react2.default.createElement('circle', { id: 'controlPoint2_' + Math.random(), cx: cx2 - x, cy: cy2 - y, r: radius, fill: controlFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: controlStroke })
	                        )
	                    ) : null,
	                    !isAnimation && this.props.isBubble && cx3 && cy3 && (this.state.interaction == 'none' || this.state.interaction == 'controlPoint3') ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onControlPointStart, onDrag: this.onControlPointDrag, onStop: this.onControlPointStop },
	                            isMindMap ? _react2.default.createElement(
	                                'g',
	                                { id: 'controlPoint3_' + Math.random() },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', onKeyDown: this.onKeyDownHandler },
	                                    _react2.default.createElement('circle', { cx: cx3 - x, cy: cy3 - y, r: radius, fill: controlFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: controlStroke })
	                                ),
	                                _react2.default.createElement('image', { xlinkHref: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg', x: cx3 - x - radius, y: cy3 - y - radius, width: radius * 2, height: radius * 2, preserveAspectRatio: 'none' })
	                            ) : _react2.default.createElement('circle', { id: 'controlPoint3_' + Math.random(), cx: cx3 - x, cy: cy3 - y, r: radius, fill: controlFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: controlStroke })
	                        )
	                    ) : null,
	                    !isAnimation && this.props.isBubble && cx4 && cy4 && (this.state.interaction == 'none' || this.state.interaction == 'controlPoint4') ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onControlPointStart, onDrag: this.onControlPointDrag, onStop: this.onControlPointStop },
	                            isMindMap ? _react2.default.createElement(
	                                'g',
	                                { id: 'controlPoint4_' + Math.random() },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', onKeyDown: this.onKeyDownHandler },
	                                    _react2.default.createElement('circle', { cx: cx4 - x, cy: cy4 - y, r: radius, fill: controlFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: controlStroke })
	                                ),
	                                _react2.default.createElement('image', { xlinkHref: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg', x: cx4 - x - radius, y: cy4 - y - radius, width: radius * 2, height: radius * 2, preserveAspectRatio: 'none' })
	                            ) : _react2.default.createElement('circle', { id: 'controlPoint4_' + Math.random(), cx: cx4 - x, cy: cy4 - y, r: radius, fill: controlFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: controlStroke })
	                        )
	                    ) : null,
	                    !isAnimation && this.props.isBubble && cx5 && cy5 && (this.state.interaction == 'none' || this.state.interaction == 'controlPoint5') ? _react2.default.createElement(
	                        'g',
	                        { transform: translateTransform },
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onControlPointStart, onDrag: this.onControlPointDrag, onStop: this.onControlPointStop },
	                            isMindMap ? _react2.default.createElement(
	                                'g',
	                                { id: 'controlPoint5_' + Math.random() },
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: '#', onKeyDown: this.onKeyDownHandler },
	                                    _react2.default.createElement('circle', { cx: cx5 - x, cy: cy5 - y, r: radius, fill: controlFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: controlStroke })
	                                ),
	                                _react2.default.createElement('image', { xlinkHref: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/textEditor/plus.svg', x: cx5 - x - radius, y: cy5 - y - radius, width: radius * 2, height: radius * 2, preserveAspectRatio: 'none' })
	                            ) : _react2.default.createElement('circle', { id: 'controlPoint5_' + Math.random(), cx: cx5 - x, cy: cy5 - y, r: radius, fill: controlFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: controlStroke })
	                        )
	                    ) : null
	                ) : null,
	                isLockedVisible ? _react2.default.createElement(
	                    'g',
	                    { transform: 'translate(' + (width / 2 - 10 / lockScale) + ' ' + (height / 2 - 12.5 / lockScale) + ') scale(' + 1 / lockScale + ' ' + 1 / lockScale + ')' },
	                    _react2.default.createElement('image', { xlinkHref: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/lock.png', x: '0', y: '0', width: '20px', height: '25px', preserveAspectRatio: 'none' })
	                ) : null
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/interactive/InteractiveShape.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/interactive/InteractiveShape.js"); } } })();

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(26)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(22);
	var IE8_DOM_DEFINE = __webpack_require__(265);
	var toPrimitive = __webpack_require__(78);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(43) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(77);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var DOMProperty = __webpack_require__(118);
	var ReactDOMComponentFlags = __webpack_require__(305);
	
	var invariant = __webpack_require__(19);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _queryString = __webpack_require__(300);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _environmentNames = __webpack_require__(244);
	
	var _environmentNames2 = _interopRequireDefault(_environmentNames);
	
	var _ErrorReporting = __webpack_require__(878);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global Promise */
	
	__webpack_require__(643).polyfill();
	__webpack_require__(668);
	
	exports.default = {
	    API_ROOT: '/ICSXapi/content/',
	
	    responseCategories: {
	        OK: 'OK',
	        NOT_LOGGED_IN: 'NOT_LOGGED_IN',
	        ENDPOINT_UNAVAILABLE: 'ENDPOINT_UNAVAILABLE',
	        SERVER_ERROR: 'SERVER_ERROR',
	        RESPONSE_PARSING_ERROR: 'RESPONSE_PARSING_ERROR',
	        FORBIDDEN: 'FORBIDDEN',
	        OFFLINE: 'OFFLINE',
	        OTHER: 'OTHER'
	
	    },
	
	    WORKFLOW_CALL_STATUS: {
	        OK: 'OK',
	        IN_PROGRESS: 'IN_PROGRESS',
	        WAITING_FOR_RETRY: 'WAITING_FOR_RETRY',
	        NOT_STARTED: 'NOT_STARTED'
	    },
	
	    getWindowLocation: function getWindowLocation() {
	        return window.location ? window.location : undefined;
	    },
	
	
	    /**
	     * Prepends the https://www.mydomain.com part of the url to the path passed in.
	     *
	     * @param {string} path Must start with a /!
	     * @returns {string}
	     */
	    prependDomain: function prependDomain(path) {
	        var location = this.getWindowLocation();
	        var hostname = location.hostname,
	            protocol = location.protocol,
	            port = location.port;
	
	        var methodAndHost = protocol + '//' + hostname;
	
	        if (port !== 80 && port !== 443) {
	            methodAndHost += ':' + port;
	        }
	
	        return '' + methodAndHost + path;
	    },
	
	    /**
	     * Tries to execute a request.
	     * Resolves with the parsed JSON body or rejects with normalized errors.
	     * State is updated to reflect current network, server, login status when relevant.
	     *
	     * @param {Request} request
	     * @return {Promise}
	     */
	    executeRequest: function executeRequest(request) {
	        var _this = this;
	
	        return fetch(request).then(function (response) {
	            return _this.handleApiResponse(response);
	        }).catch(function (ex) {
	            var isOfflineError = _this.isOfflineError(ex);
	
	            if (isOfflineError) {
	                _this.updateOnlineStatusIfNeeded(false);
	                throw { errorType: _this.responseCategories.OFFLINE, response: undefined, error: ex };
	            }
	
	            (0, _ErrorReporting.reportError)(ex);
	
	            throw ex;
	        });
	    },
	
	
	    /**
	     * Returns a Promise which resolves with the parsed JSON data or rejects with an object on this form:
	     * {
	     *      errorType,  // String
	     *      error,      // Original Error, if any, else undefined
	     *      response    // Original Response object
	     * }
	     * @param response
	     * @returns {Promise}
	     */
	    handleApiResponse: function handleApiResponse(response) {
	        var _this2 = this;
	
	        var loggedIn = this.isLoggedIn(response);
	        var online = this.isOnline(response);
	
	        this.updateLoggedInStatusIfNeeded(loggedIn);
	        this.updateOnlineStatusIfNeeded(online);
	
	        return new Promise(function (resolve, reject) {
	            var errorType = void 0,
	                error = void 0;
	
	            if (!online) {
	                errorType = _this2.responseCategories.ENDPOINT_UNAVAILABLE;
	            } else if (!loggedIn) {
	                errorType = _this2.responseCategories.NOT_LOGGED_IN;
	            } else if (response.status >= 500) {
	                errorType = _this2.responseCategories.SERVER_ERROR;
	            } else if (response.status >= 400) {
	                errorType = _this2.responseCategories.ENDPOINT_UNAVAILABLE;
	            } else if (response.status !== 200) {
	                errorType = _this2.responseCategories.OTHER;
	            }
	            if (!errorType) {
	                try {
	                    response.json().then(function (parsedData) {
	                        resolve(parsedData);
	                    }).catch(function (ex) {
	                        //reportError(ex);
	                        reject({ errorType: _this2.responseCategories.RESPONSE_PARSING_ERROR, response: response, error: ex });
	                    });
	                } catch (ex) {
	                    error = ex;
	                    errorType = _this2.responseCategories.RESPONSE_PARSING_ERROR;
	                }
	            }
	
	            if (errorType) {
	                reject({ errorType: errorType, error: error, response: response });
	            }
	        });
	    },
	
	
	    /**
	     * Retries a request a given number of times, at the specified interval.
	     *
	     * @param {Function} requestFunction Any function that returns a promise.
	     * @param retriesToDo
	     * @param msToWait
	     * @returns {Promise}
	     */
	    retryRequest: function retryRequest(requestFunction) {
	        var retriesToDo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
	        var msToWait = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.getDefaultInterval();
	
	        var retriesDone = 0;
	        var intervalHandle = void 0;
	
	        return new Promise(function (resolve, reject) {
	            intervalHandle = setInterval(function () {
	                retriesDone++;
	
	                requestFunction().then(function (res) {
	                    clearInterval(intervalHandle);
	                    resolve(res);
	                }).catch(function (ex) {
	                    // Ignore errors until we are at the final iteration.
	                    if (retriesDone === retriesToDo) {
	                        clearInterval(intervalHandle);
	                        reject(ex);
	                    }
	                });
	            }, msToWait);
	        });
	    },
	    getDefaultInterval: function getDefaultInterval() {
	        return ("production") === _environmentNames2.default.UNIT_TESTING ? 50 : 5000;
	    },
	
	
	    /**
	     * Checks if the response indicates that the user is not logged in.
	     *
	     * @param res
	     * @returns {boolean}
	     */
	    isLoggedIn: function isLoggedIn(res) {
	        return res.status !== 401;
	    },
	
	
	    /**
	     * TODO: Add actual checking. Just have to figure out the best way...
	     * @param res
	     * @returns {boolean}
	     */
	    isOnline: function isOnline(res) {
	        return res === res;
	    },
	    isOfflineError: function isOfflineError(error) {
	        if (error.message === 'Failed to fetch') {
	            return true;
	        }
	
	        return false;
	    },
	    updateOnlineStatusIfNeeded: function updateOnlineStatusIfNeeded() {},
	    updateLoggedInStatusIfNeeded: function updateLoggedInStatusIfNeeded() {},
	
	
	    /**
	     * If the error is on the format returned by ApiService.executeRequest
	     * @param error
	     * @returns {boolean}
	     */
	    isResponseError: function isResponseError(error) {
	        // All errors that have come from the handleApiResponse have a response property defined
	        // network failures are plain Error objects
	        return Object.prototype.hasOwnProperty.call(error, 'errorType');
	    },
	
	
	    /**
	     ********************************************************************************************
	     */
	    makeJsonPostRequest: function makeJsonPostRequest(url, data) {
	        var request = new Request(url, {
	            credentials: 'same-origin',
	            method: 'POST',
	            headers: { 'Content-Type': 'application/json' },
	            body: JSON.stringify(data)
	        });
	
	        return request;
	    },
	    makeFormDataPostRequest: function makeFormDataPostRequest(url) {
	        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        var formData = _queryString2.default.stringify(data);
	
	        var headers = new Headers();
	        headers.append('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
	
	        var request = new Request(url, {
	            body: formData,
	            credentials: 'same-origin',
	            headers: headers,
	            method: 'POST'
	        });
	
	        return request;
	    },
	    storeBigDataCartoonist: function storeBigDataCartoonist(s3Key, title, contentItemId, submitId, exerciseId, clipartReference, thumbnailS3Key, autosave, usedContentIds) {
	        var _this3 = this;
	
	        var url = this.API_ROOT + 'StoreCartoonistURL';
	        var data = {
	            s3Key: s3Key,
	            title: title,
	            contentItemId: contentItemId,
	            submitId: submitId,
	            exerciseId: exerciseId,
	            clipart_reference: clipartReference,
	            thumbnailS3Key: thumbnailS3Key,
	            autosave: autosave,
	            usedContentIds: usedContentIds
	        };
	
	        var request = this.makeFormDataPostRequest(url, data);
	
	        return this.executeRequest(request).catch(function () {
	            return _this3.retryRequest(function () {
	                return _this3.executeRequest(_this3.makeFormDataPostRequest(url, data));
	            });
	        });
	    },
	    storeCartoonist: function storeCartoonist(title, contentItemId, submitId, exerciseId, jsonData, clipartReference, thumbnailS3Key) {
	        var _this4 = this;
	
	        var autosave = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
	        var isAudio = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
	
	        var url = this.API_ROOT + 'StoreCartoonist';
	        var data = {
	            title: title,
	            contentItemId: contentItemId,
	            submitId: submitId,
	            exerciseId: exerciseId,
	            textcontent: jsonData,
	            clipart_reference: clipartReference,
	            thumbnailS3Key: thumbnailS3Key,
	            autosave: autosave,
	            isAudio: isAudio
	        };
	
	        var request = this.makeFormDataPostRequest(url, data);
	
	        return this.executeRequest(request).catch(function () {
	            return _this4.retryRequest(function () {
	                return _this4.executeRequest(_this4.makeFormDataPostRequest(url, data));
	            });
	        });
	    },
	    publish: function publish(submitId, isAudioJob) {
	        var _this5 = this;
	
	        var url = '/ICSXapi/work/Publish';
	        var data = {
	            setPublic: true,
	            exportDestination: 'homepage',
	            clipartId: 123456,
	            submitId: submitId,
	            isAudioJob: isAudioJob
	        };
	
	        var request = this.makeFormDataPostRequest(url, data);
	
	        return this.executeRequest(request).catch(function () {
	            return _this5.retryRequest(function () {
	                return _this5.executeRequest(_this5.makeFormDataPostRequest(url, data));
	            });
	        });
	    },
	    exportCartoonist: function exportCartoonist(submitId, textContent, duration) {
	        var _this6 = this;
	
	        var url = '/ICSXapi/work/Export';
	        var data = {
	            submitId: submitId,
	            textContent: textContent,
	            duration: duration
	        };
	
	        var request = this.makeFormDataPostRequest(url, data);
	
	        return this.executeRequest(request).catch(function () {
	            return _this6.retryRequest(function () {
	                return _this6.executeRequest(_this6.makeFormDataPostRequest(url, data));
	            });
	        });
	    },
	    unlockProduction: function unlockProduction(submitId) {
	        var _this7 = this;
	
	        var url = '/ICSXapi/work/UnLock';
	        var data = {
	            submitId: submitId
	        };
	
	        var request = this.makeFormDataPostRequest(url, data);
	
	        return this.executeRequest(request).catch(function () {
	            return _this7.retryRequest(function () {
	                return _this7.executeRequest(_this7.makeFormDataPostRequest(url, data));
	            });
	        });
	    },
	    storeBytes: function storeBytes(title, bytes) {
	        var _this8 = this;
	
	        var url = this.API_ROOT + 'StoreRecording';
	
	        var data = {
	            title: title,
	            data: bytes
	        };
	
	        var request = this.makeFormDataPostRequest(url, data);
	
	        return this.executeRequest(request).catch(function () {
	            return _this8.retryRequest(function () {
	                return _this8.executeRequest(_this8.makeFormDataPostRequest(url, data));
	            });
	        });
	    },
	    loadCartoonistContent: function loadCartoonistContent(contentRevisionId, contentItemId, submitId) {
	        var _this9 = this;
	
	        var path = this.API_ROOT + 'GetTextContent?contentRevisionId=' + contentRevisionId + '&contentItemId=' + contentItemId + '&submitId=' + submitId;
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this9.retryRequest(function () {
	                return _this9.executeRequest(request);
	            });
	        });
	    },
	    loadMediaFiles: function loadMediaFiles(contentType, itemsPerPage) {
	        var _this10 = this;
	
	        var path = this.API_ROOT + 'GetMediaFiles?type=' + contentType + '&hpp=' + itemsPerPage;
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this10.retryRequest(function () {
	                return _this10.executeRequest(request);
	            });
	        });
	    },
	    searchContent: function searchContent(text, lng, list, themeElementType) {
	        var _this11 = this;
	
	        var url = this.API_ROOT + 'SearchClipartContent';
	        var data = {
	            s: text,
	            lng: lng,
	            clipartList: list,
	            hpp: 1000
	        };
	
	        if (themeElementType) data.themeElementType = themeElementType;
	
	        var request = this.makeFormDataPostRequest(url, data);
	
	        return this.executeRequest(request).catch(function () {
	            return _this11.retryRequest(function () {
	                return _this11.executeRequest(_this11.makeFormDataPostRequest(url, data));
	            });
	        });
	    },
	    loadAssignmentFolder: function loadAssignmentFolder(id) {
	        var _this12 = this;
	
	        var path = '/ICSXapi/work/GetAssignmentMediaFiles?id=' + id;
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this12.retryRequest(function () {
	                return _this12.executeRequest(request);
	            });
	        });
	    },
	    getBlobFromBase64Url: function getBlobFromBase64Url(url) {
	        var request = new Request(url, { credentials: 'same-origin' });
	        return fetch(request).then(function (response) {
	            return response.blob().then(function (blob) {
	                return blob;
	            });
	        });
	    },
	    loadClipartJSON: function loadClipartJSON(contentItemId) {
	        var _this13 = this;
	
	        var path = this.API_ROOT + 'GetClipart?contentItemId=' + contentItemId;
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this13.retryRequest(function () {
	                return _this13.executeRequest(request);
	            });
	        });
	    },
	    getExercisesTitle: function getExercisesTitle(exerciseId) {
	        var _this14 = this;
	
	        var path = '/ICSXapi/work/Describe?id=' + exerciseId + '&type=exercise';
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this14.retryRequest(function () {
	                return _this14.executeRequest(request);
	            });
	        });
	    },
	    getSubmitTitle: function getSubmitTitle(submitId) {
	        var _this15 = this;
	
	        var path = '/ICSXapi/work/Get?id=' + submitId;
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this15.retryRequest(function () {
	                return _this15.executeRequest(request);
	            });
	        });
	    },
	    getAvailableCliparts: function getAvailableCliparts() {
	        var _this16 = this;
	
	        var path = '/ICSXapi/content/GetAvailableCliparts';
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this16.retryRequest(function () {
	                return _this16.executeRequest(request);
	            });
	        });
	    },
	    getBasicSessionProperties: function getBasicSessionProperties() {
	        var _this17 = this;
	
	        var path = '/ICSXapi/users/GetBasicSessionInfo';
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this17.retryRequest(function () {
	                return _this17.executeRequest(request);
	            });
	        });
	    },
	    getSessionProperties: function getSessionProperties() {
	        var _this18 = this;
	
	        var path = '/ICSXapi/users/GetSessionInfo';
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this18.retryRequest(function () {
	                return _this18.executeRequest(request);
	            });
	        });
	    },
	    getSessionInfo: function getSessionInfo() {
	        var _this19 = this;
	
	        var path = '/ICSXapi/users/HasActiveSession';
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this19.retryRequest(function () {
	                return _this19.executeRequest(request);
	            });
	        });
	    },
	    getLastUploadedMediaFileId: function getLastUploadedMediaFileId() {
	        var _this20 = this;
	
	        var path = '/ICSXapi/users/GetLastUploadedFile';
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this20.retryRequest(function () {
	                return _this20.executeRequest(request);
	            });
	        });
	    },
	    getUploadingMediaFileStatus: function getUploadingMediaFileStatus(contentItemId) {
	        var _this21 = this;
	
	        var path = '/ICSXapi/file/CheckStatus?contentItemId=' + contentItemId;
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this21.retryRequest(function () {
	                return _this21.executeRequest(request);
	            });
	        });
	    },
	    hasAccess: function hasAccess(contentItemId, contentRevisionId) {
	        var _this22 = this;
	
	        var path = '/ICSXapi/content/HasAccess?contentItemId=' + contentItemId + '&contentRevisionId=' + contentRevisionId;
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this22.retryRequest(function () {
	                return _this22.executeRequest(request);
	            });
	        });
	    },
	    getExportStatus: function getExportStatus(jobId) {
	        var _this23 = this;
	
	        var path = '/ICSXapi/work/GetExportStatus?jobId=' + jobId + '&cacheBreaker=' + Math.random();
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this23.retryRequest(function () {
	                return _this23.executeRequest(request);
	            });
	        });
	    },
	    getSessionToken: function getSessionToken() {
	        var _this24 = this;
	
	        var path = '/ICSXapi/exercise/RequestTokenCartoonist';
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this24.retryRequest(function () {
	                return _this24.executeRequest(request);
	            });
	        });
	    },
	    doLoginWithToken: function doLoginWithToken(token, id) {
	        var _this25 = this;
	
	        var path = '/ICSXapi/users/DoCartoonistAppLogin?token=' + token + '&id=' + id;
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this25.retryRequest(function () {
	                return _this25.executeRequest(request);
	            });
	        });
	    },
	    setItemProperty: function setItemProperty(itemProperty, userId, value) {
	        var _this26 = this;
	
	        var path = '/ICSXapi/metadata/SetItemValue?itemProperty=' + itemProperty + '&objectId=' + userId + '&value=' + encodeURIComponent(JSON.stringify(value)) + '&flushCache=true';
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this26.retryRequest(function () {
	                return _this26.executeRequest(request);
	            });
	        });
	    },
	    getVideoOriginals: function getVideoOriginals(ids) {
	        var _this27 = this;
	
	        var idsList = '';
	        var i;
	
	        for (i = 0; i < ids.length; i++) {
	            if (i == 0) idsList = idsList + 'ids=' + ids[i];else idsList = idsList + '&ids=' + ids[i];
	        }
	
	        var path = '/ICSXapi/content/GetVideoOriginals?' + idsList;
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this27.retryRequest(function () {
	                return _this27.executeRequest(request);
	            });
	        });
	    },
	    getSignedContent: function getSignedContent(ids) {
	        var _this28 = this;
	
	        var idsList = '';
	        var i;
	
	        for (i = 0; i < ids.length; i++) {
	            if (i == 0) idsList = idsList + 'ids=' + ids[i];else idsList = idsList + '&ids=' + ids[i];
	        }
	
	        var path = '/ICSXapi/content/GetSignedContentURLs?' + idsList;
	        var request = new Request(path, { credentials: 'same-origin' });
	
	        return this.executeRequest(request).catch(function () {
	            return _this28.retryRequest(function () {
	                return _this28.executeRequest(request);
	            });
	        });
	    },
	
	
	    /*******************  New universes+themes functionality *************************/
	    loadUniverses: function loadUniverses() {
	        var _this29 = this;
	
	        var path = 'https://api.creaza.com/content/list/universe';
	        var request = new Request(path);
	
	        return this.executeRequest(request).catch(function () {
	            return _this29.retryRequest(function () {
	                return _this29.executeRequest(request);
	            });
	        });
	    },
	    loadThemes: function loadThemes() {
	        var _this30 = this;
	
	        var path = 'https://api.creaza.com/content/list/theme';
	        var request = new Request(path);
	
	        return this.executeRequest(request).catch(function () {
	            return _this30.retryRequest(function () {
	                return _this30.executeRequest(request);
	            });
	        });
	    },
	    loadThemesFromUniverse: function loadThemesFromUniverse(universe) {
	        var _this31 = this;
	
	        var path = 'https://api.creaza.com/content/list/theme/' + universe;
	        var request = new Request(path);
	
	        return this.executeRequest(request).catch(function () {
	            return _this31.retryRequest(function () {
	                return _this31.executeRequest(request);
	            });
	        });
	    },
	    loadCurrentTheme: function loadCurrentTheme(theme, locale) {
	        var _this32 = this;
	
	        var path = locale && locale.length > 0 ? 'https://api.creaza.com/content/' + theme + '/' + locale : 'https://api.creaza.com/content/' + theme;
	        var request = new Request(path);
	
	        return this.executeRequest(request).catch(function () {
	            return _this32.retryRequest(function () {
	                return _this32.executeRequest(request);
	            });
	        });
	    },
	    searchNewContent: function searchNewContent(language, category, keyword, pageNumber, pageSize) {
	        var _this33 = this;
	
	        var path = 'https://api.creaza.com/content/search/' + language + '/' + category + '/' + keyword + '/' + pageNumber + '/' + pageSize;
	        var request = new Request(path);
	
	        return this.executeRequest(request).catch(function () {
	            return _this33.retryRequest(function () {
	                return _this33.executeRequest(request);
	            });
	        });
	    },
	    loadMoods: function loadMoods() {
	        var _this34 = this;
	
	        var path = 'https://api.creaza.com/content/translations/moods';
	        var request = new Request(path);
	
	        return this.executeRequest(request).catch(function () {
	            return _this34.retryRequest(function () {
	                return _this34.executeRequest(request);
	            });
	        });
	    },
	    loadThemeCategories: function loadThemeCategories() {
	        var _this35 = this;
	
	        var path = 'https://api.creaza.com/content/translations/categories';
	        var request = new Request(path);
	
	        return this.executeRequest(request).catch(function () {
	            return _this35.retryRequest(function () {
	                return _this35.executeRequest(request);
	            });
	        });
	    },
	    loadCartoonistCaptions: function loadCartoonistCaptions() {
	        var _this36 = this;
	
	        var path = 'https://api.creaza.com/content/translations/editor';
	        var request = new Request(path);
	
	        return this.executeRequest(request).catch(function () {
	            return _this36.retryRequest(function () {
	                return _this36.executeRequest(request);
	            });
	        });
	    },
	    listVideoThemes: function listVideoThemes() {
	        var _this37 = this;
	
	        var path = 'https://api.creaza.com/content/list/video-theme';
	        var request = new Request(path);
	
	        return this.executeRequest(request).catch(function () {
	            return _this37.retryRequest(function () {
	                return _this37.executeRequest(request);
	            });
	        });
	    },
	    loadVideoTheme: function loadVideoTheme(theme) {
	        var _this38 = this;
	
	        var path = 'https://api.creaza.com/content/video/' + theme;
	        var request = new Request(path);
	
	        return this.executeRequest(request).catch(function () {
	            return _this38.retryRequest(function () {
	                return _this38.executeRequest(request);
	            });
	        });
	    },
	    searchVideo: function searchVideo(language, keyword, pageNumber, pageSize) {
	        var _this39 = this;
	
	        var path = 'https://api.creaza.com/content/search/video/' + language + '/' + keyword + '/' + pageNumber + '/' + pageSize;
	        var request = new Request(path);
	
	        return this.executeRequest(request).catch(function () {
	            return _this39.retryRequest(function () {
	                return _this39.executeRequest(request);
	            });
	        });
	    }
	};
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/services/ApiService.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/services/ApiService.js"); } } })();

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(75);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 49 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var zoomUtils = {
	    currentHotspot: undefined,
	    currentBackgroundUid: undefined,
	    updateInitialPosition: true,
	
	    croppingTarget: undefined,
	    currentCroppingHotspot: undefined,
	    updateCurrentCroppingHotspot: undefined,
	    updateTransformTool: undefined,
	    updateCroppingInitialPosition: true,
	    croppingTargetRotation: 0,
	
	    closeZoom: function closeZoom() {
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        dispatch((0, _MenuActions.showZoomSlides)(false));
	        dispatch((0, _MenuActions.showCroppingMenu)(false));
	    },
	    isCroppingMode: function isCroppingMode() {
	        var state = _StoreManager2.default.getState();
	        var showCroppingMenu = state.menu && state.menu.showCroppingMenu;
	
	        if (showCroppingMenu == true) return true;else return false;
	    },
	    goToFullScreenMode: function goToFullScreenMode() {
	        var el = document.body;
	
	        // Supports most browsers and their versions.
	        var requestMethod = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullScreen;
	
	        if (requestMethod) {
	            // Native full screen.
	            requestMethod.call(el);
	        }
	    }
	};
	
	exports.default = zoomUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ZoomUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ZoomUtils.js"); } } })();

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setDrawState = setDrawState;
	exports.addClipartModel = addClipartModel;
	exports.setAccordionActiveButton = setAccordionActiveButton;
	exports.setMediaFilesDataProvider = setMediaFilesDataProvider;
	exports.changeAcoordionWidth = changeAcoordionWidth;
	exports.setActiveButton = setActiveButton;
	exports.setOldActiveButton = setOldActiveButton;
	var types = exports.types = {
	    STATE_DRAW: 'state_draw',
	    ADD_CLIPART_MODEL: 'add_clipart_model',
	    SET_ACCORDION_ACTIVE_BUTTON: 'set_accordion_active_button',
	    SET_MEDIA_FILES_DATA_PROVIDER: 'set_media_files_data_provider',
	    CHANGE_ACCORDION_WIDTH: 'change_accordion_width',
	    SET_ACTIVE_BUTTON: 'set_active_button',
	    SET_OLD_ACTIVE_BUTTON: 'set_old_active_button'
	};
	
	function setDrawState(state) {
	    return { type: types.STATE_DRAW, state: state };
	}
	
	function addClipartModel(clipartModel) {
	    return { type: types.ADD_CLIPART_MODEL, clipartModel: clipartModel };
	}
	
	function setAccordionActiveButton(buttonType) {
	    return { type: types.SET_ACCORDION_ACTIVE_BUTTON, buttonType: buttonType };
	}
	
	function setMediaFilesDataProvider(dataProvider) {
	    return { type: types.SET_MEDIA_FILES_DATA_PROVIDER, dataProvider: dataProvider };
	}
	
	function changeAcoordionWidth(width) {
	    return { type: types.CHANGE_ACCORDION_WIDTH, width: width };
	}
	
	function setActiveButton(value, isCollapsed) {
	    return { type: types.SET_ACTIVE_BUTTON, value: value, isCollapsed: isCollapsed };
	}
	
	function setOldActiveButton(value) {
	    return { type: types.SET_OLD_ACTIVE_BUTTON, value: value };
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/actions/AccordionActions.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/actions/AccordionActions.js"); } } })();

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.uiProperties = undefined;
	exports.detectCurrentAngle = detectCurrentAngle;
	exports.transformPointToRotatedSystem = transformPointToRotatedSystem;
	exports.transformPointFromRotatedSystem = transformPointFromRotatedSystem;
	exports.getTouchPosition = getTouchPosition;
	exports.isTextBubble = isTextBubble;
	exports.isTextBox = isTextBox;
	exports.useScaleFactor = useScaleFactor;
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uiProperties = exports.uiProperties = {
	    ROTATE_FILL_ACTIVE: '#46AFEF',
	    ROTATE_FILL_INACTIVE: '#69CD72',
	    ROTATE_STROKE_ACTIVE: '#FFFFFF',
	    ROTATE_STROKE_INACTIVE: '#FFFFFF',
	    CORNER_FILL_ACTIVE: '#FFFFFF',
	    CORNER_FILL_INACTIVE: '#46AFEF',
	    CORNER_STROKE_ACTIVE: '#46AFEF',
	    CORNER_STROKE_INACTIVE: '#FFFFFF',
	    CONTROL_FILL_ACTIVE: '#FFFFFF',
	    CONTROL_FILL_INACTIVE: '#FFDD5D',
	    CONTROL_STROKE_ACTIVE: '#FFDD5D',
	    CONTROL_STROKE_INACTIVE: '#FFFFFF',
	    PATH_COLOR: '#46AFEF',
	    RADIUS: 12,
	    STROKE: 1
	};
	
	function detectCurrentAngle(shapeModel, rotationX, rotationY, canvasProperties) {
	    var shapeCenter = { x: shapeModel.x + shapeModel.width / 2, y: shapeModel.y + shapeModel.height / 2 };
	    var angle = void 0;
	    var canvasScale = canvasProperties.scale;
	    var localPoint = { x: (rotationX - canvasProperties.topX) / canvasScale, y: (rotationY - canvasProperties.topY) / canvasScale };
	
	    angle = Math.atan2(localPoint.y - shapeCenter.y, localPoint.x - shapeCenter.x) * 180 / Math.PI;
	    angle = angle + 90;
	
	    return angle;
	}
	
	function transformPointToRotatedSystem(point, rotation) {
	    var radians = degreesToRadians(rotation);
	    var x = point.x * Math.cos(radians) + point.y * Math.sin(radians);
	    var y = -point.x * Math.sin(radians) + point.y * Math.cos(radians);
	
	    return { x: x, y: y };
	}
	
	function transformPointFromRotatedSystem(point, rotation) {
	    var radians = degreesToRadians(rotation);
	    var x = point.x * Math.cos(radians) - point.y * Math.sin(radians);
	    var y = point.x * Math.sin(radians) + point.y * Math.cos(radians);
	
	    return { x: x, y: y };
	}
	
	function degreesToRadians(angle) {
	    return angle * Math.PI / 180;
	}
	
	function getTouchPosition(e) {
	    if (e.clientX != undefined) {
	        // is MouseEvent
	        return { x: e.clientX, y: e.clientY };
	    } else {
	        if (e.touches && e.touches.length > 0) return { x: e.touches[0].clientX, y: e.touches[0].clientY };else if (e.changedTouches) return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
	    }
	
	    return { x: 0, y: 0 };
	}
	
	function isTextBubble(shapeModel) {
	    if (shapeModel.type == _ShapeConstants2.default.SPEAK_BUBBLE || shapeModel.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shapeModel.type == _ShapeConstants2.default.THOUGHT_BUBBLE || shapeModel.type == _ShapeConstants2.default.SCREAM_BUBBLE) return true;else return false;
	}
	
	function isTextBox(shapeModel) {
	    if (shapeModel == undefined) return false;
	
	    if (shapeModel.type == _ShapeConstants2.default.TEXTBOX || shapeModel.type == _ShapeConstants2.default.TEXTBOXSIMPLE || isTextBubble(shapeModel) == true) return true;else return false;
	}
	
	function useScaleFactor(type) {
	    if (type == _ShapeConstants2.default.FREEHAND || type == _ShapeConstants2.default.TEXTBOX || type == _ShapeConstants2.default.TEXTBOXSIMPLE || type == _ShapeConstants2.default.SCREAM_BUBBLE || type == _ShapeConstants2.default.THOUGHT_BUBBLE || type == _ShapeConstants2.default.SPEAK_BUBBLE || type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE) return false;else return true;
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/TransformToolUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/TransformToolUtils.js"); } } })();

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(910);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var audioUtils = {
	    // PLAY/PAUSE LOGIC START. Sometimes it can take a while for the playback to
	    // actually start (Seeking or something?) and we try to avoid pausing
	    // while being in the process of starting it (which can happen when seeking while playing)
	
	    endCurrentSlideTimer: undefined,
	    visitedAudioAlerts: [],
	    serverTimeOffset: 0,
	
	    getVisitedAlerts: function getVisitedAlerts() {
	        var _this = this;
	
	        _ApiService2.default.getBasicSessionProperties() // get server time
	        .then(function (response) {
	            if (response.serverTime > 0) _this.serverTimeOffset = response.serverTime - new Date().getTime();
	        });
	
	        _ApiService2.default.getSessionProperties() // check if the user has access
	        .then(function (response) {
	            if (response && response.user && response.user.audio_recording_popups) {
	                var object = response.user.audio_recording_popups;
	
	                if (object.show_popup_a == true) _this.visitedAudioAlerts.push(0);
	
	                if (object.show_popup_b == true) _this.visitedAudioAlerts.push(1);
	
	                if (object.show_popup_c == true) _this.visitedAudioAlerts.push(2);
	
	                if (object.show_popup_d == true) // video alert
	                    _this.visitedAudioAlerts.push(3);
	
	                if (object.show_popup_e == true) // Safari alert
	                    _this.visitedAudioAlerts.push(4);
	            }
	
	            if (response && response.user && response.user.allowAnimation == false) _AnimationManager2.default.allowAnimation = false;
	
	            if (response && response.user && (response.user.hasAbpAccess || response.user.organizationunit == 'Vettre skole' || response.user.organizationunit == 'Alfabetplaneten' || response.user.organizationunit == 'Årum skole')) _MasterUniverseUtils2.default.isSpecialOrganization = true;
	
	            _SaveManager2.default.init();
	        });
	    },
	    stopRestOfSounds: function stopRestOfSounds(currentSound) {
	        if (currentSound == 'slideSound' || currentSound == 'slideSoundEffect' || currentSound == 'storySound') return;
	
	        var audios = ['audioBrowserSound', 'musicSoundId', 'recordedAudio', 'audioEffect'];
	
	        for (var i = 0, len = audios.length; i < len; i++) {
	            if (audios[i] != currentSound) {
	                this.pauseSound(audios[i]);
	            }
	        }
	    },
	    playSound: function playSound(id) {
	        var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	        var audio = document.getElementById(id);
	
	        if (!audio) return;
	
	        if (this.isSoundLoaded(id) && !this.isPlayingAudio(audio)) {
	            //this.stopRestOfSounds(id);
	
	            if (position != -1 && audio.currentTime != position) audio.currentTime = position;
	
	            audio.play();
	
	            this.updateProperties(id, true);
	        }
	    },
	    pauseSound: function pauseSound(id) {
	        var forcePause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var audio = document.getElementById(id);
	        var isPlaying;
	
	        if (!audio) return;
	
	        if (forcePause) isPlaying = true;else isPlaying = this.isPlayingAudio(audio);
	
	        if (this.isSoundLoaded(id) && this.isPauseAvailable(id) && isPlaying) {
	            audio.pause();
	
	            if (forcePause) audio.currentTime = 0;
	
	            this.updateProperties(id, false);
	        }
	    },
	    isPlayingAudio: function isPlayingAudio(audio) {
	        var isPlaying = audio && audio.currentTime > 0 && !audio.paused && !audio.ended && audio.readyState > 2;
	
	        return isPlaying;
	    },
	    isPlaying: function isPlaying(id) {
	        var audio = document.getElementById(id);
	
	        return this.isPlayingAudio(audio);
	    },
	    changeSoundSource: function changeSoundSource(id, url) {
	        var playOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	        var audio = document.getElementById(id);
	
	        if (!audio || !url) return;
	
	        audio.src = _VideoUtils2.default.checkCacheBreaker(url);
	
	        if (playOffset > 0 && audio.duration > playOffset) audio.currentTime = playOffset;
	
	        if (_PlatformDetection2.default.isIOS()) audio.play();
	    },
	    updateProperties: function updateProperties(id, playValue) {
	        switch (id) {
	            case 'audioBrowserSound':
	                {
	                    if (this.updatePropsForContextSound) this.updatePropsForContextSound(playValue);
	
	                    if (playValue) this.isPreparingPlayForContextSound = true;
	
	                    break;
	                }
	
	            case 'musicSoundId':
	                {
	                    if (this.updatePropsForMusicSound) this.updatePropsForMusicSound(playValue);
	
	                    if (playValue) this.isPreparingPlayForMusicSound = true;
	
	                    break;
	                }
	
	            case 'recordedAudio':
	                {
	                    if (this.updatePropsForRecordedSound) this.updatePropsForRecordedSound(playValue);
	
	                    if (playValue) this.isPreparingPlayForRecordedSound = true;
	
	                    break;
	                }
	
	            case 'audioEffect':
	                {
	                    if (this.updateButtonsPlayStatus) this.updateButtonsPlayStatus(playValue, true);
	
	                    if (playValue) this.isPreparingPlayForAudioEffect = true;
	
	                    break;
	                }
	
	            case 'slideSound':
	                {
	                    if (playValue) this.isPreparingPlayForSlideSound = true;
	
	                    break;
	                }
	
	            case 'slideSoundEffect':
	                {
	                    if (playValue) this.isPreparingPlayForSlideSoundEffect = true;
	
	                    break;
	                }
	
	            case 'storySound':
	                {
	                    if (playValue) this.isPreparingPlayForStorySound = true;
	
	                    break;
	                }
	        }
	    },
	    isSoundLoaded: function isSoundLoaded(id) {
	        var value = false;
	
	        switch (id) {
	            case 'audioBrowserSound':
	                {
	                    value = this.isLoadedContentSound;
	                    break;
	                }
	
	            case 'musicSoundId':
	                {
	                    value = this.isLoadedMusicSound;
	                    break;
	                }
	
	            case 'recordedAudio':
	                {
	                    value = this.isLoadedRecordedSound;
	                    break;
	                }
	
	            case 'audioEffect':
	                {
	                    value = this.isLoadedAudioEffect;
	                    break;
	                }
	
	            case 'slideSound':
	                {
	                    value = this.isLoadedSlideSound;
	                    break;
	                }
	
	            case 'slideSoundEffect':
	                {
	                    value = this.isLoadedSlideSoundEffect;
	                    break;
	                }
	
	            case 'storySound':
	                {
	                    value = this.isLoadedStorySound;
	                    break;
	                }
	        }
	
	        return value;
	    },
	    isPauseAvailable: function isPauseAvailable(id) {
	        var value = false;
	
	        switch (id) {
	            case 'audioBrowserSound':
	                {
	                    value = !this.isPreparingPlayForContextSound;
	                    break;
	                }
	
	            case 'musicSoundId':
	                {
	                    value = !this.isPreparingPlayForMusicSound;
	                    break;
	                }
	
	            case 'recordedAudio':
	                {
	                    value = !this.isPreparingPlayForRecordedSound;
	                    break;
	                }
	
	            case 'audioEffect':
	                {
	                    value = !this.isPreparingPlayForAudioEffect;
	                    break;
	                }
	
	            case 'slideSound':
	                {
	                    value = !this.isPreparingPlayForSlideSound;
	                    break;
	                }
	
	            case 'slideSoundEffect':
	                {
	                    value = !this.isPreparingPlayForSlideSoundEffect;
	                    break;
	                }
	
	            case 'storySound':
	                {
	                    value = !this.isPreparingPlayForStorySound;
	                    break;
	                }
	        }
	
	        return value;
	    },
	
	
	    // ****************************************** Context Sound *********************************************************
	    isContentSoundInit: false,
	    updatePropsForContextSound: undefined,
	
	    currentSrcForContextSound: undefined,
	    isPreparingPlayForContextSound: false,
	    isLoadedContentSound: false,
	
	    initContextSound: function initContextSound() {
	        var audio = document.getElementById('audioBrowserSound');
	
	        if (audio && !this.isContentSoundInit) {
	            this.isContentSoundInit = true;
	
	            audio.ondurationchange = this.onContextSoundLoaded.bind(this);
	            audio.onended = this.onContextSoundEnded.bind(this);
	            audio.onplaying = this.onContextSoundPlay.bind(this);
	            audio.onpause = this.onContextSoundPlay.bind(this);
	        }
	    },
	    cleanContextSound: function cleanContextSound() {
	        this.isContentSoundInit = false;
	        this.updatePropsForContextSound = undefined;
	        this.isLoadedContentSound = false;
	        this.isPreparingPlayForContextSound = false;
	        this.currentSrcForContextSound = undefined;
	
	        var audio = document.getElementById('audioBrowserSound');
	
	        if (audio) {
	            audio.ondurationchange = undefined;
	            audio.onended = undefined;
	            audio.onplaying = undefined;
	            audio.onpause = undefined;
	        }
	    },
	    playSoundFromUrl: function playSoundFromUrl(url, updatePropsForContextSound) {
	        if (this.updatePropsForContextSound) this.updatePropsForContextSound(false);
	
	        this.updatePropsForContextSound = updatePropsForContextSound;
	
	        if (this.currentSrcForContextSound != url) {
	            this.currentSrcForContextSound = url;
	            this.isLoadedContentSound = false;
	            this.isPreparingPlayForContextSound = false;
	
	            this.changeSoundSource('audioBrowserSound', url);
	        } else {
	            this.playSound('audioBrowserSound');
	        }
	    },
	    onContextSoundPlay: function onContextSoundPlay() {
	        this.isPreparingPlayForContextSound = false;
	    },
	    onContextSoundEnded: function onContextSoundEnded() {
	        if (this.updatePropsForContextSound) this.updatePropsForContextSound(false);
	    },
	    onContextSoundLoaded: function onContextSoundLoaded() {
	        this.isLoadedContentSound = true;
	        this.playSound('audioBrowserSound');
	    },
	
	
	    // ****************************************** Music Sound *********************************************************
	    updatePropsForMusicSound: undefined,
	
	    currentSrcForMusicSound: undefined,
	    isPreparingPlayForMusicSound: false,
	    isLoadedMusicSound: false,
	
	    initMusicSound: function initMusicSound(updatePropsForMusicSound) {
	        this.updatePropsForMusicSound = updatePropsForMusicSound;
	
	        var audio = document.getElementById('musicSoundId');
	
	        audio.ondurationchange = this.onMusicSoundLoaded.bind(this);
	        audio.onplaying = this.onMusicSoundPlay.bind(this);
	        audio.onpause = this.onMusicSoundPlay.bind(this);
	        audio.onended = this.onMusicSoundEnded.bind(this);
	    },
	    cleanMusicSound: function cleanMusicSound() {
	        this.updatePropsForMusicSound = undefined;
	        this.currentSrcForMusicSound = undefined;
	        this.isPreparingPlayForMusicSound = false;
	        this.isLoadedMusicSound = false;
	
	        var audio = document.getElementById('musicSoundId');
	
	        if (audio) {
	            audio.ondurationchange = undefined;
	            audio.onplaying = undefined;
	            audio.onpause = undefined;
	            audio.onended = undefined;
	        }
	    },
	    updateHrefForMusicSound: function updateHrefForMusicSound(url) {
	        if (this.currentSrcForMusicSound != url) {
	            this.isPreparingPlayForMusicSound = false;
	            this.isLoadedMusicSound = false;
	        }
	
	        this.currentSrcForMusicSound = url;
	    },
	    onMusicSoundLoaded: function onMusicSoundLoaded() {
	        this.isLoadedMusicSound = true;
	
	        if (this.updatePropsForMusicSound) this.updatePropsForMusicSound(false);
	    },
	    onMusicSoundPlay: function onMusicSoundPlay() {
	        this.isPreparingPlayForMusicSound = false;
	    },
	    onMusicSoundEnded: function onMusicSoundEnded() {
	        if (this.updatePropsForMusicSound) this.updatePropsForMusicSound(false);
	    },
	
	
	    // ******************************************* Recorded Audio ****************************************************
	    updatePropsForRecordedSound: undefined,
	
	    currentSrcForRecordedSound: undefined,
	    isPreparingPlayForRecordedSound: false,
	    isLoadedRecordedSound: false,
	    updateSlideDuration: false,
	
	    initRecordedSound: function initRecordedSound(updatePropsForRecordedSound) {
	        this.updatePropsForRecordedSound = updatePropsForRecordedSound;
	
	        var audio = document.getElementById('recordedAudio');
	
	        audio.ondurationchange = this.onRecordedSoundLoaded.bind(this);
	        audio.onplaying = this.onRecordedSoundPlay.bind(this);
	        audio.onpause = this.onRecordedSoundPlay.bind(this);
	        audio.onended = this.onRecordedSoundEnded.bind(this);
	    },
	    cleanRecordingSound: function cleanRecordingSound() {
	        this.updatePropsForRecordedSound = undefined;
	        this.currentSrcForRecordedSound = undefined;
	        this.isPreparingPlayForRecordedSound = false;
	        this.isLoadedRecordedSound = false;
	
	        var audio = document.getElementById('recordedAudio');
	
	        if (audio) {
	            audio.ondurationchange = undefined;
	            audio.onplaying = undefined;
	            audio.onpause = undefined;
	            audio.onended = undefined;
	        }
	    },
	    updateHrefForRecordedSound: function updateHrefForRecordedSound(url) {
	        if (this.currentSrcForRecordedSound != url) {
	            this.isPreparingPlayForRecordedSound = false;
	            this.isLoadedRecordedSound = false;
	        }
	
	        this.currentSrcForRecordedSound = url;
	    },
	    onRecordedSoundPlay: function onRecordedSoundPlay() {
	        this.isPreparingPlayForRecordedSound = false;
	    },
	    onRecordedSoundLoaded: function onRecordedSoundLoaded() {
	        this.isLoadedRecordedSound = true;
	        audioUtils.updateSlideDuration = false;
	    },
	    onRecordedSoundEnded: function onRecordedSoundEnded() {
	        if (this.updatePropsForRecordedSound) this.updatePropsForRecordedSound(false, false, true);
	    },
	
	
	    // ******************************************* Audio Effects ****************************************************
	    updateButtonsPlayStatus: undefined,
	
	    currentSrcForAudioEffect: undefined,
	    isPreparingPlayForAudioEffect: false,
	    isLoadedAudioEffect: false,
	
	    initAudioEffect: function initAudioEffect(updateButtonsPlayStatus) {
	        this.updateButtonsPlayStatus = updateButtonsPlayStatus;
	
	        var audio = document.getElementById('audioEffect');
	
	        audio.ondurationchange = this.onAudioEffectLoaded.bind(this);
	        audio.onplaying = this.onAudioEffectPlay.bind(this);
	        audio.onpause = this.onAudioEffectPlay.bind(this);
	        audio.onended = this.onAudioEffectEnded.bind(this);
	    },
	    cleanAudioEffect: function cleanAudioEffect() {
	        this.updateButtonsPlayStatus = undefined;
	        this.currentSrcForAudioEffect = undefined;
	        this.isPreparingPlayForAudioEffect = false;
	        this.isLoadedAudioEffect = false;
	
	        var audio = document.getElementById('audioEffect');
	
	        if (audio) {
	            audio.ondurationchange = undefined;
	            audio.onplaying = undefined;
	            audio.onpause = undefined;
	            audio.onended = undefined;
	        }
	    },
	    updateHrefForAudioEffect: function updateHrefForAudioEffect(url) {
	        if (this.currentSrcForAudioEffect != url) {
	            this.isPreparingPlayForAudioEffect = false;
	            this.isLoadedAudioEffect = false;
	        }
	
	        this.currentSrcForAudioEffect = url;
	    },
	    onAudioEffectPlay: function onAudioEffectPlay() {
	        this.isPreparingPlayForAudioEffect = false;
	    },
	    onAudioEffectLoaded: function onAudioEffectLoaded() {
	        this.isLoadedAudioEffect = true;
	    },
	    onAudioEffectEnded: function onAudioEffectEnded() {
	        if (this.updateButtonsPlayStatus) this.updateButtonsPlayStatus(false, true, true);
	    },
	
	
	    // ******************************************* PLAYER -- slide sound ****************************************************
	    isPreparingPlayForSlideSound: false,
	    isLoadedSlideSound: false,
	    currentSrcForSlideSound: undefined,
	
	    initSlideSound: function initSlideSound() {
	        var audio = document.getElementById('slideSound');
	
	        audio.ondurationchange = this.onSlideSoundLoaded.bind(this);
	        audio.onplaying = this.onSlideSoundPlay.bind(this);
	        audio.onpause = this.onSlideSoundPlay.bind(this);
	    },
	    cleanSlideSound: function cleanSlideSound() {
	        this.isPreparingPlayForSlideSound = false;
	        this.isLoadedSlideSound = false;
	        this.currentSrcForSlideSound = undefined;
	
	        var audio = document.getElementById('slideSound');
	
	        if (audio) {
	            audio.ondurationchange = undefined;
	            audio.onplaying = undefined;
	            audio.onpause = undefined;
	        }
	    },
	    playSlideSoundFromUrl: function playSlideSoundFromUrl(url) {
	        var playOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        if (this.currentSrcForSlideSound != url) {
	            this.currentSrcForSlideSound = url;
	            this.isLoadedSlideSound = false;
	            this.isPreparingPlayForSlideSound = false;
	
	            this.changeSoundSource('slideSound', url, playOffset);
	        } else {
	            this.playSound('slideSound', playOffset);
	        }
	    },
	    onSlideSoundLoaded: function onSlideSoundLoaded() {
	        this.isLoadedSlideSound = true;
	        this.playSound('slideSound');
	    },
	    onSlideSoundPlay: function onSlideSoundPlay() {
	        this.isPreparingPlayForSlideSound = false;
	    },
	
	
	    // ******************************************* PLAYER -- slide sound effect ****************************************************
	    isPreparingPlayForSlideSoundEffect: false,
	    isLoadedSlideSoundEffect: false,
	    currentSrcForSlideSoundEffect: undefined,
	
	    initSlideSoundEffect: function initSlideSoundEffect() {
	        var audio = document.getElementById('slideSoundEffect');
	
	        audio.ondurationchange = this.onSlideSoundEffectLoaded.bind(this);
	        audio.onplaying = this.onSlideSoundEffectPlay.bind(this);
	        audio.onpause = this.onSlideSoundEffectPlay.bind(this);
	    },
	    cleanSlideSoundEffect: function cleanSlideSoundEffect() {
	        this.isPreparingPlayForSlideSoundEffect = false;
	        this.isLoadedSlideSoundEffect = false;
	        this.currentSrcForSlideSoundEffect = undefined;
	
	        var audio = document.getElementById('slideSoundEffect');
	
	        if (audio) {
	            audio.ondurationchange = undefined;
	            audio.onplaying = undefined;
	            audio.onpause = undefined;
	        }
	    },
	    playSlideSoundEffectFromUrl: function playSlideSoundEffectFromUrl(url) {
	        var playOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        if (this.currentSrcForSlideSoundEffect != url) {
	            this.currentSrcForSlideSoundEffect = url;
	            this.isLoadedSlideSoundEffect = false;
	            this.isPreparingPlayForSlideSoundEffect = false;
	
	            this.changeSoundSource('slideSoundEffect', url, playOffset);
	        } else {
	            this.playSound('slideSoundEffect', playOffset);
	        }
	    },
	    onSlideSoundEffectLoaded: function onSlideSoundEffectLoaded() {
	        this.isLoadedSlideSoundEffect = true;
	        this.playSound('slideSoundEffect');
	    },
	    onSlideSoundEffectPlay: function onSlideSoundEffectPlay() {
	        this.isPreparingPlayForSlideSoundEffect = false;
	    },
	
	
	    // ******************************************* PLAYER -- story sound ****************************************************
	    isPreparingPlayForStorySound: false,
	    isLoadedStorySound: false,
	    currentSrcForStorySound: undefined,
	    endStorySound: undefined,
	
	    initStorySound: function initStorySound(endStorySound) {
	        this.endStorySound = endStorySound;
	
	        var audio = document.getElementById('storySound');
	
	        audio.ondurationchange = this.onStorySoundLoaded.bind(this);
	        audio.onplaying = this.onStorySoundPlay.bind(this);
	        audio.onpause = this.onStorySoundPlay.bind(this);
	        audio.onended = this.onStorySoundEnded.bind(this);
	    },
	    cleanStorySound: function cleanStorySound() {
	        this.isPreparingPlayForStorySound = false;
	        this.isLoadedStorySound = false;
	        this.currentSrcForStorySound = undefined;
	
	        var audio = document.getElementById('storySound');
	
	        if (audio) {
	            audio.ondurationchange = undefined;
	            audio.onplaying = undefined;
	            audio.onpause = undefined;
	            audio.onended = undefined;
	        }
	    },
	    updateHrefForStorySound: function updateHrefForStorySound(url) {
	        if (this.currentSrcForStorySound != url) {
	            this.isPreparingPlayForStorySound = false;
	            this.isLoadedStorySound = false;
	        }
	
	        this.currentSrcForStorySound = url;
	    },
	    playStorySound: function playStorySound() {},
	    onStorySoundLoaded: function onStorySoundLoaded() {
	        this.isLoadedStorySound = true;
	    },
	    onStorySoundPlay: function onStorySoundPlay() {
	        this.isPreparingPlayForStorySound = false;
	    },
	    onStorySoundEnded: function onStorySoundEnded() {
	        if (this.endStorySound) this.endStorySound();
	    },
	
	
	    /********************************** utils ****************/
	
	    hasSlideSound: function hasSlideSound() {
	        var state = _StoreManager2.default.getState();
	        var slideSound = state.currentSlide.model.sound;
	        var slideSoundWav = state.currentSlide.model.soundWav;
	
	        if (slideSound && slideSound != '' || slideSoundWav && slideSoundWav != '') return true;else return false;
	    },
	    hasSlideSoundEffect: function hasSlideSoundEffect() {
	        var state = _StoreManager2.default.getState();
	        var slideSoundEffect = state.currentSlide.model.soundEffect;
	
	        if (slideSoundEffect && slideSoundEffect != '') return true;else return false;
	    },
	    slideSoundDuration: function slideSoundDuration() {
	        var audio = document.getElementById('recordedAudio');
	        var duration = audio.duration;
	
	        if (duration > 0) return duration;else return 0;
	    },
	    slideSoundEffectDuration: function slideSoundEffectDuration() {
	        var audio = document.getElementById('audioEffect');
	        var duration = audio.duration;
	
	        if (duration > 0) return duration;else return 0;
	    },
	    getSoundVolume: function getSoundVolume(id) {
	        var state = _StoreManager2.default.getState();
	        var volume;
	
	        if (id == 'recordedAudio' || id == 'slideSound') volume = state.currentSlide.model.soundVolume;
	
	        if (id == 'audioEffect' || id == 'slideSoundEffect') volume = state.currentSlide.model.soundEffectVolume;
	
	        if (volume) volume = parseFloat(volume);
	
	        if (volume >= 0) return volume;else return 0.5;
	    },
	    setSoundVolume: function setSoundVolume(id) {
	        var volume = this.getSoundVolume(id);
	        var audio = document.getElementById(id);
	
	        if (audio) audio.volume = volume;
	    },
	    restartAudio: function restartAudio(id) {
	        var audio = document.getElementById(id);
	
	        if (audio) audio.currentTime = 0;
	    },
	    clearAudioEvents: function clearAudioEvents() {
	        this.updateButtonsPlayStatus = undefined;
	
	        var audio = document.getElementById('audioEffect');
	
	        if (audio) {
	            audio.ondurationchange = undefined;
	            audio.onplaying = undefined;
	            audio.onpause = undefined;
	            audio.onended = undefined;
	        }
	
	        this.updatePropsForRecordedSound = undefined;
	
	        var recordedAudio = document.getElementById('recordedAudio');
	
	        if (recordedAudio) {
	            recordedAudio.ondurationchange = undefined;
	            recordedAudio.onplaying = undefined;
	            recordedAudio.onpause = undefined;
	            recordedAudio.onended = undefined;
	        }
	    }
	};
	
	exports.default = audioUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/AudioUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/AudioUtils.js"); } } })();

/***/ },
/* 57 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 58 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(44);
	var createDesc = __webpack_require__(101);
	module.exports = __webpack_require__(43) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var hide = __webpack_require__(59);
	var has = __webpack_require__(58);
	var SRC = __webpack_require__(105)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(74).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var fails = __webpack_require__(26);
	var defined = __webpack_require__(75);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectionManager = {
	    copiedCanvasElement: false,
	    currentSlide: undefined,
	    isMultipleSelection: false,
	    dispatch: undefined,
	    initialPositions: [],
	
	    checkControl: function checkControl(event) {
	        if (event.ctrlKey == true) this.isMultipleSelection = true;else this.isMultipleSelection = false;
	    },
	    selectAll: function selectAll() {
	        if (this.dispatch) this.dispatch((0, _CurrentSlideActions.selectShape)('selectAll'));
	    },
	    multipleSelection: function multipleSelection() {
	        if (this.isMultipleSelection == true) return true;
	
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var i;
	        var shape;
	        var count = 0;
	
	        for (i = 1; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.isLocked == true) continue;
	
	            if (shape.isSelected == true) count = count + 1;
	        }
	
	        if (count > 1) return true;else return false;
	    },
	    updateInitialPositions: function updateInitialPositions(currentShapeUid) {
	        this.initialPositions = [];
	
	        if (this.multipleSelection() == false) return;
	
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var i;
	        var shape;
	
	        for (i = 1; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.isLocked == true) continue;
	
	            if (shape.isSelected == true && shape.uuid != currentShapeUid) {
	                if (shape.type == _ShapeConstants2.default.LINE || shape.type == _ShapeConstants2.default.CURVE) {
	                    if (shape.type == _ShapeConstants2.default.CURVE) this.initialPositions[shape.uuid] = { x1: shape.x1, y1: shape.y1, x2: shape.x2, y2: shape.y2, cx: shape.cx, cy: shape.cy };else this.initialPositions[shape.uuid] = { x1: shape.x1, y1: shape.y1, x2: shape.x2, y2: shape.y2 };
	                } else {
	                    this.initialPositions[shape.uuid] = { x: shape.x, y: shape.y };
	                }
	            }
	        }
	    },
	    moveShapes: function moveShapes(offsetX, offsetY, currentShapeUid) {
	        if (this.multipleSelection() == false) return;
	
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var i;
	        var shape;
	        var positions = [];
	        var isEmpty = true;
	
	        for (i = 1; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.isLocked == true) continue;
	
	            if (shape.isSelected == true && shape.uuid != currentShapeUid) {
	                var position = this.initialPositions[shape.uuid];
	
	                if (position) {
	                    if (shape.type == _ShapeConstants2.default.LINE || shape.type == _ShapeConstants2.default.CURVE) {
	                        if (shape.type == _ShapeConstants2.default.LINE) positions[shape.uuid] = { x1: position.x1 + offsetX, y1: position.y1 + offsetY, x2: position.x2 + offsetX, y2: position.y2 + offsetY };else positions[shape.uuid] = { x1: position.x1 + offsetX, y1: position.y1 + offsetY, x2: position.x2 + offsetX, y2: position.y2 + offsetY, cx: position.cx + offsetX, cy: position.cy + offsetY };
	                    } else {
	                        positions[shape.uuid] = { x: position.x + offsetX, y: position.y + offsetY };
	                    }
	
	                    isEmpty = false;
	                }
	            }
	        }
	
	        if (isEmpty == false) {
	            this.dispatch((0, _CurrentSlideActions.changeShapesPosition)(positions));
	            _SaveManager2.default.isContentChanged(true);
	        }
	    },
	    selectShapesFromArea: function selectShapesFromArea(area) {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var i;
	        var shape;
	        var selection = [];
	
	        for (i = 1; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.type == _ShapeConstants2.default.LINE || shape.type == _ShapeConstants2.default.CURVE) {
	                if ((shape.x1 >= area.x && shape.x1 <= area.x + area.width || shape.x2 >= area.x && shape.x2 <= area.x + area.width) && (shape.y1 >= area.y && shape.y1 <= area.y + area.height || shape.y2 >= area.y && shape.y2 <= area.y + area.height)) {
	                    selection.push(shape.uuid);
	                }
	            } else {
	                if (shape.x + shape.width < area.x || area.x + area.width < shape.x || shape.y + shape.height < area.y || area.y + area.height < shape.y) {
	                    // no intersection
	                } else selection.push(shape.uuid);
	            }
	        }
	
	        if (shapes.length > 0) this.dispatch((0, _CurrentSlideActions.selectShapeFromArea)(selection));
	    },
	    getSelectedShapes: function getSelectedShapes() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var i;
	        var shape;
	        var selection = [];
	
	        for (i = 1; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.isSelected == true) selection.push(shape.uuid);
	        }
	
	        return selection;
	    },
	    getShapeWithUuid: function getShapeWithUuid(uuid) {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var i;
	        var shape;
	
	        for (i = 1; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.uuid == uuid) return shape;
	        }
	
	        return undefined;
	    },
	    isTextBoxSelected: function isTextBoxSelected() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var i;
	        var shapeModel;
	
	        for (i = 0; i < shapes.length; i++) {
	            shapeModel = shapes[i];
	
	            if (shapeModel.isSelected) {
	                if (shapeModel.type == _ShapeConstants2.default.TEXTBOX || shapeModel.type == _ShapeConstants2.default.TEXTBOXSIMPLE || shapeModel.type == _ShapeConstants2.default.SPEAK_BUBBLE || shapeModel.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shapeModel.type == _ShapeConstants2.default.SCREAM_BUBBLE || shapeModel.type == _ShapeConstants2.default.THOUGHT_BUBBLE) return true;
	            }
	        }
	
	        return false;
	    },
	    isSaveContext: function isSaveContext() {
	        var contextMode = _StoreManager2.default.getState().menu.contextMode;
	
	        if (contextMode == _ModeConstants2.default.SAVE_CONTEXT) return true;else return false;
	    },
	    checkSelection: function checkSelection(uuid) {
	        if (uuid == '') {
	            this.dispatch((0, _CurrentSlideActions.selectShape)(uuid));
	            return;
	        }
	
	        if (this.isMultipleSelection == true) return;
	
	        var selection = this.getSelectedShapes();
	
	        if (selection.indexOf(uuid) == -1) {
	            if (_PlatformDetection2.default.isIOS()) document.activeElement.blur();
	
	            this.dispatch((0, _CurrentSlideActions.selectShape)(''));
	        }
	    }
	};
	
	exports.default = selectionManager;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SelectionManager.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SelectionManager.js"); } } })();

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(132);
	var createDesc = __webpack_require__(101);
	var toIObject = __webpack_require__(65);
	var toPrimitive = __webpack_require__(78);
	var has = __webpack_require__(58);
	var IE8_DOM_DEFINE = __webpack_require__(265);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(43) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(58);
	var toObject = __webpack_require__(48);
	var IE_PROTO = __webpack_require__(196)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(131);
	var defined = __webpack_require__(75);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 66 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var audioVolumeUtils = {
	    audioContext: undefined,
	    gainNodes: [],
	    isInitialized: false,
	    isListnerAdded: false,
	    isActiveFunctionality: false,
	    buffers: [],
	    callBackDraws: [],
	    toolType: 1, // 0 - none, 1 - both AE and C, 2 - only C, 3 - only AE
	
	    isAvailableVolume: function isAvailableVolume() {
	        var toolTypeValue = this.toolType;
	
	        switch (toolTypeValue) {
	            case 0:
	                {
	                    return false;
	                    break;
	                }
	
	            case 1:
	                {
	                    return true;
	                    break;
	                }
	
	            case 2:
	                {
	                    return !_AudioToolUtils2.default.isAudioTool();
	                    break;
	                }
	
	            case 3:
	                {
	                    return _AudioToolUtils2.default.isAudioTool();
	                    break;
	                }
	        }
	    },
	    useVolumeFunctionality: function useVolumeFunctionality() {
	        if (this.isAvailableVolume()) return this.isActiveFunctionality;else return false;
	    },
	    addEventListener: function addEventListener() {
	        if (!this.isAvailableVolume()) return;
	
	        if (this.isListnerAdded) return;
	
	        this.isActiveFunctionality = _PlatformDetection2.default.isIOS();
	        this.isListnerAdded = true;
	
	        if (this.useVolumeFunctionality()) {
	            if (!this.audioContext) this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
	
	            this.init();
	
	            window.addEventListener('touchstart', this.init.bind(this));
	            // window.addEventListener('click', this.init.bind(this));
	        }
	    },
	    removeEventListener: function removeEventListener() {
	        if (this.useVolumeFunctionality()) {
	            window.removeEventListener('touchstart', this.init);
	            // window.removeEventListener('click', this.init);
	        }
	    },
	    reset: function reset() {
	        // should create a new context because something broke the old audio context when call reactNativeBridge.stopRecording()
	        return; // for NCA-169: it seems that after 4 recordings and reseting context, the new context can't be created anymore.
	
	        this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
	        this.isInitialized = false;
	
	        if (_PlayController2.default.isAudioEditorAvailable()) _PlayController2.default.updateAudioElements();
	    },
	    init: function init() {
	        if (this.isInitialized || !this.useVolumeFunctionality()) return;
	
	        if (!this.audioContext) this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
	
	        if (!this.audioContext) return;
	
	        if (this.audioContext.state === 'suspended') {
	            this.audioContext.resume();
	            setTimeout(this.playFirstTime.bind(this), 40);
	        } else {
	            this.playFirstTime();
	        }
	    },
	    playFirstTime: function playFirstTime() {
	        if (!this.audioContext) return;
	
	        this.isInitialized = true;
	
	        return;
	
	        var url = _AppParameters2.default.clipartBucket() + '/movieaudioeditor/1837856.mp3';
	
	        this.loadBufferSound(url, true);
	    },
	    loadBufferSound: function loadBufferSound(url) {
	        var autoplayBuffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (this.buffers[url]) return;
	
	        if (!this.audioContext) this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
	
	        var request = new XMLHttpRequest();
	        request.open('GET', url, true);
	        request.responseType = 'arraybuffer';
	        request.originalUrl = url;
	
	        // Decode asynchronously
	        request.onload = function () {
	            try {
	                this.audioContext.decodeAudioData(request.response, function (buffer) {
	                    if (autoplayBuffer) this.playBufferSound(buffer);else {
	                        var originalUrl = request.originalUrl;
	                        this.buffers[originalUrl] = buffer.getChannelData(0);
	
	                        if (this.callBackDraws[originalUrl]) {
	                            this.callBackDraws[originalUrl]();
	                            delete this.callBackDraws[originalUrl];
	                        }
	                    }
	                }.bind(this));
	            } catch (e) {
	                // error
	            }
	        }.bind(this);
	
	        request.send();
	    },
	    playBufferSound: function playBufferSound(buffer) {
	        var source = this.audioContext.createBufferSource();
	        source.buffer = buffer;
	
	        var gainNode;
	
	        if (!this.audioContext.createGain) this.audioContext.createGain = this.audioContext.createGainNode;
	
	        gainNode = this.audioContext.createGain();
	
	        source.connect(gainNode);
	        gainNode.connect(this.audioContext.destination);
	
	        gainNode.gain.value = 0;
	
	        if (!source.start) source.start = source.noteOn;
	
	        if (!source.start) source.start = source.play;
	
	        if (!source.stop) source.stop = source.noteOff;
	
	        source.start(0);
	    },
	    drawWaveform: function drawWaveform(buffer) {
	        var canvas = document.createElement('canvas');
	        canvas.width = 600;
	        canvas.height = 70;
	        canvas.style.position = 'absolute';
	        canvas.style.top = 136 + 'px';
	        canvas.style.left = 222 + 'px';
	        canvas.style.background = 'white';
	        document.body.appendChild(canvas);
	
	        var data = buffer.getChannelData(0),
	            width = canvas.width,
	            height = canvas.height,
	            ctx = canvas.getContext('2d'),
	            amp = height / 2;
	
	        // var step = Math.ceil( data.length / width );
	        // for(var i=0; i < width; i++){
	        //     var min = 1.0;
	        //     var max = -1.0;
	        //     for (var j=0; j<step; j++) {
	        //         var datum = data[(i*step)+j];
	        //         if (datum < min)
	        //             min = datum;
	        //         if (datum > max)
	        //             max = datum;
	        //     }
	        //     ctx.fillRect(i,(1+min)*amp,1,Math.max(1,(max-min)*amp));
	        // }
	
	        var x,
	            y,
	            i,
	            n = data.length;
	        ctx.strokeStyle = 'yellow';
	        ctx.fillStyle = '#303030';
	        ctx.fillRect(0, 0, width, height);
	        ctx.beginPath();
	        ctx.moveTo(0, amp);
	        for (i = 0; i < n; i++) {
	            x = i * width / n;
	            y = data[i] * amp + amp;
	            ctx.lineTo(x, y);
	        }
	        ctx.stroke();
	        ctx.closePath();
	    },
	
	
	    regularAudios: [],
	    regularAudioUrl: [],
	
	    prepareSounds: function prepareSounds() {
	        if (!this.useVolumeFunctionality()) return;
	
	        if (!this.audioContext) {
	            this.reset();
	            return;
	        }
	
	        this.gainNodes = [];
	    },
	    loadBufferForUrl: function loadBufferForUrl(url, uuid, audios, volume) {
	        if (url == '') return;
	
	        if (!this.audioContext) this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
	
	        var request = new XMLHttpRequest();
	        request.open('GET', url, true);
	        request.responseType = 'arraybuffer';
	        request.originalUrl = url;
	
	        // Decode asynchronously
	        request.onload = function () {
	            try {
	                this.audioContext.decodeAudioData(request.response, function (buffer) {
	                    this.createSourceContent(buffer, uuid, audios, volume);
	                }.bind(this));
	            } catch (e) {
	                // error
	            }
	        }.bind(this);
	
	        request.send();
	    },
	    createSourceContent: function createSourceContent(buffer, uuid, audios, volume) {
	        if (!this.audioContext) this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
	
	        var source = this.audioContext.createBufferSource();
	        source.buffer = buffer;
	
	        var gainNode;
	
	        if (!this.audioContext.createGain) this.audioContext.createGain = this.audioContext.createGainNode;
	
	        gainNode = this.audioContext.createGain();
	        gainNode.gain.value = 0;
	
	        source.connect(gainNode);
	        gainNode.connect(this.audioContext.destination);
	
	        if (!source.start) source.start = source.noteOn;
	
	        if (!source.start) source.start = source.play;
	
	        if (!source.stop) source.stop = source.noteOff;
	
	        source.play = source.start;
	        source.pause = source.stop;
	
	        this.gainNodes[uuid] = gainNode;
	        audios[uuid] = source;
	
	        if (volume >= 0) {
	            // should autoplay
	            this.executeMediaAction(uuid, volume, true);
	        }
	    },
	    refreshSource: function refreshSource(audios, key) {
	        // this will stop sound
	
	        if (!this.audioContext) this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
	
	        if (audios[key]) {
	            var buffer = audios[key].buffer;
	            audios[key].buffer = null;
	            this.createSourceContent(buffer, key, audios);
	        }
	    },
	    changeVolume: function changeVolume(uuid, volume) {
	        if (!this.useVolumeFunctionality() || !this.audioContext) return;
	
	        if (this.gainNodes && this.gainNodes[uuid]) {
	            this.gainNodes[uuid].gain.value = volume;
	        }
	    },
	    checkSound: function checkSound(url, uuid) {
	        if (url != '' && url != this.regularAudioUrl[uuid]) {
	            this.regularAudioUrl[uuid] = url;
	            this.loadBufferForUrl(url, uuid, this.regularAudios);
	        } else if (url == '' && this.regularAudioUrl[uuid]) {
	            this.regularAudioUrl[uuid] = '';
	            this.regularAudios[uuid] = undefined;
	        }
	    },
	    executeMediaAction: function executeMediaAction(uuid, volume, play, onEndAction) {
	        this.refreshSource(this.regularAudios, uuid);
	
	        if (play) {
	            var audio = this.regularAudios[uuid];
	
	            if (audio) {
	                this.changeVolume(uuid, volume);
	                audio.onended = onEndAction;
	                audio.play();
	            }
	        }
	    },
	    loadAndPlaySound: function loadAndPlaySound(url, uuid) {
	        var volume = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
	
	        if (url != '' && url != this.regularAudioUrl[uuid]) {
	            this.regularAudioUrl[uuid] = url;
	            this.loadBufferForUrl(url, uuid, this.regularAudios, volume);
	        } else {
	            if (url == '' && this.regularAudioUrl[uuid]) {
	                this.executeMediaAction(uuid, 0, false);
	                this.regularAudioUrl[uuid] = '';
	                this.regularAudios[uuid] = undefined;
	            } else this.executeMediaAction(uuid, volume, true);
	        }
	    }
	};
	
	exports.default = audioVolumeUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/AudioVolumeUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/AudioVolumeUtils.js"); } } })();

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	//     uuid.js
	//
	//     Copyright (c) 2010-2012 Robert Kieffer
	//     MIT License - http://opensource.org/licenses/mit-license.php
	
	// Unique ID creation requires a high quality random # generator.  We feature
	// detect to determine the best RNG source, normalizing to a function that
	// returns 128-bits of randomness, since that's what's usually required
	var _rng = __webpack_require__(938);
	
	// Maps for number <-> hex string conversion
	var _byteToHex = [];
	var _hexToByte = {};
	for (var i = 0; i < 256; i++) {
	  _byteToHex[i] = (i + 0x100).toString(16).substr(1);
	  _hexToByte[_byteToHex[i]] = i;
	}
	
	// **`parse()` - Parse a UUID into it's component bytes**
	function parse(s, buf, offset) {
	  var i = (buf && offset) || 0, ii = 0;
	
	  buf = buf || [];
	  s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
	    if (ii < 16) { // Don't overflow!
	      buf[i + ii++] = _hexToByte[oct];
	    }
	  });
	
	  // Zero out remaining bytes if string was short
	  while (ii < 16) {
	    buf[i + ii++] = 0;
	  }
	
	  return buf;
	}
	
	// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
	function unparse(buf, offset) {
	  var i = offset || 0, bth = _byteToHex;
	  return  bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	// random #'s we need to init node and clockseq
	var _seedBytes = _rng();
	
	// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	var _nodeId = [
	  _seedBytes[0] | 0x01,
	  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
	];
	
	// Per 4.2.2, randomize (14 bit) clockseq
	var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
	// Previous uuid creation time
	var _lastMSecs = 0, _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  var node = options.node || _nodeId;
	  for (var n = 0; n < 6; n++) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : unparse(b);
	}
	
	// **`v4()` - Generate random UUID**
	
	// See https://github.com/broofa/node-uuid for API details
	function v4(options, buf, offset) {
	  // Deprecated - 'format' argument, as supported in v1.2
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options == 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || _rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ii++) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || unparse(rnds);
	}
	
	// Export public API
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	uuid.parse = parse;
	uuid.unparse = unparse;
	
	module.exports = uuid;


/***/ },
/* 69 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(55);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(26);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(70);
	var IObject = __webpack_require__(131);
	var toObject = __webpack_require__(48);
	var toLength = __webpack_require__(45);
	var asc = __webpack_require__(181);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 74 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 75 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(4);
	var core = __webpack_require__(74);
	var fails = __webpack_require__(26);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 77 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(28);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(49);
	
	var CallbackQueue = __webpack_require__(303);
	var PooledClass = __webpack_require__(106);
	var ReactFeatureFlags = __webpack_require__(308);
	var ReactReconciler = __webpack_require__(119);
	var Transaction = __webpack_require__(164);
	
	var invariant = __webpack_require__(19);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _AccordionActions = __webpack_require__(51);
	
	var _DurationUtils = __webpack_require__(140);
	
	var _DurationUtils2 = _interopRequireDefault(_DurationUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var populateMediaFilesUtils = {
	    searchTime: 0,
	    dispatch: undefined,
	    contentItemIdForRecordedSound: undefined,
	
	    parseMediaItems: function parseMediaItems(items, dispatch) {
	        var isSoundTab = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        if (this.dispatch == undefined) {
	            this.dispatch = dispatch;
	            this.startMediaFilesRefreshTimer();
	        }
	
	        var mediaFilesdataProvider = this.getDataProvider(items);
	
	        if (!dispatch) dispatch = this.dispatch;
	
	        if (!dispatch) {
	            this.dispatch = _StoreManager2.default.getStore().dispatch;
	            dispatch = this.dispatch;
	        }
	
	        if (_AppParameters2.default.assignmentFolderId == -1) {
	            var currentDataProvider = _StoreManager2.default.getState().accordion.mediaFilesDataProvider;
	
	            if (isSoundTab && (!currentDataProvider || currentDataProvider && !currentDataProvider.imagesDataProvider)) {
	                dispatch((0, _AccordionActions.setMediaFilesDataProvider)({ soundsDataProvider: mediaFilesdataProvider.soundsDataProvider }));
	            } else {
	                dispatch((0, _AccordionActions.setMediaFilesDataProvider)({
	                    imagesDataProvider: mediaFilesdataProvider.imagesDataProvider,
	                    soundsDataProvider: mediaFilesdataProvider.soundsDataProvider,
	                    videosDataProvider: mediaFilesdataProvider.videosDataProvider
	                }));
	            }
	        } else {
	            var self = this;
	
	            _ApiServiceUtils2.default.executeSafeApiCall(function () {
	                var _this = this;
	
	                _ApiService2.default.loadAssignmentFolder(_AppParameters2.default.submitId).then(function (result) {
	                    var items = result.media;
	                    var assignmentDataProvider = _this.getDataProvider(items);
	
	                    self.mixData(dispatch, mediaFilesdataProvider, assignmentDataProvider);
	                });
	            }.bind(this));
	        }
	    },
	    mixData: function mixData(dispatch, myMediaFilesDataProvider, assignmenFolderDataProvider) {
	        var imagesDataProvider = [].concat(assignmenFolderDataProvider.imagesDataProvider, myMediaFilesDataProvider.imagesDataProvider);
	        var soundsDataProvider = [].concat(assignmenFolderDataProvider.soundsDataProvider, myMediaFilesDataProvider.soundsDataProvider);
	        var videosDataProvider = [].concat(assignmenFolderDataProvider.videosDataProvider, myMediaFilesDataProvider.videosDataProvider);
	
	        dispatch((0, _AccordionActions.setMediaFilesDataProvider)({ imagesDataProvider: imagesDataProvider, soundsDataProvider: soundsDataProvider, videosDataProvider: videosDataProvider }));
	    },
	    getDataProvider: function getDataProvider(items) {
	        if (!items) return [];
	
	        var images = [];
	        var sounds = [];
	        var videos = [];
	        var i = void 0,
	            k = void 0;
	        var monthsOfYear = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	        var host = '';
	
	        for (i = 0; i < items.length; i++) {
	            var element = {};
	            element.title = items[i].title;
	            element.status = items[i].status;
	
	            if (items[i].type == 'contentimage') {
	                element.contentItemId = items[i].id;
	                element.href = host + '/file/ci/' + items[i].id + '/img';
	                element.width = items[i].width;
	                element.height = items[i].height;
	
	                if (items[i].contentThumbURL) element.thumb = items[i].contentThumbURL;else element.thumb = host + '/file/ci/' + items[i].id + '/thumb/aaa';
	
	                images.push(element);
	            } else if (items[i].type == 'contentsound' || items[i].type == 'contentsoundrecording') {
	                element.contentItemId = items[i].id;
	                element.href = host + ('/file/ci/' + items[i].id + '/aaa');
	
	                if (items[i].duration != undefined) {
	                    element.duration = _DurationUtils2.default.transformDuration(items[i].duration);
	                    element.durationInSeconds = parseFloat(items[i].duration / 1000);
	                }
	
	                if (items[i].type == 'contentsoundrecording') element.isRecordedSound = true;else {
	                    for (k = 0; k < monthsOfYear.length; k++) {
	                        if (element.title.indexOf(monthsOfYear[k]) != -1) {
	                            element.isRecordedSound = true;
	                            break;
	                        }
	                    }
	                }
	
	                if (element.duration) sounds.push(element);
	            } else if (items[i].type == 'contentvideoh264') {
	                element.contentItemId = items[i].id;
	                element.href = host + '/file/ci/' + items[i].id + '/aaa';
	
	                if (items[i].contentThumbURL) element.thumb = items[i].contentThumbURL;else element.thumb = host + '/file/ci/' + items[i].id + '/thumb/aaa';
	
	                if (items[i].duration != undefined) {
	                    element.duration = _DurationUtils2.default.transformDuration(items[i].duration);
	                    element.durationInSeconds = parseFloat(items[i].duration / 1000);
	                }
	
	                videos.push(element);
	            }
	        }
	
	        var dataProvider = {};
	
	        dataProvider.imagesDataProvider = images;
	        dataProvider.soundsDataProvider = sounds;
	        dataProvider.videosDataProvider = videos;
	
	        return dataProvider;
	    },
	    getImagesDataProviderForTest: function getImagesDataProviderForTest() {
	        var array = [];
	        var object;
	
	        object = {};
	        object.href = 'http://stage.creaza.com/file/ci/74259683/img';
	        object.thumb = 'http://stage.creaza.com/file/ci/74259683/thumb/aaa';
	        object.title = 'Item1sssss';
	        object.contentItemId = 12345;
	        object.status = 'preparing';
	        object.width = 200;
	        object.height = 100;
	        array.push(object);
	
	        object = {};
	        object.href = 'http://stage.creaza.com/file/ci/59618267/img';
	        object.thumb = 'http://stage.creaza.com/file/ci/59618267/thumb/aaa';
	        object.title = 'Item2';
	        array.push(object);
	
	        object = {};
	        object.href = 'http://stage.creaza.com/file/ci/59613269/img';
	        object.thumb = 'http://stage.creaza.com/file/ci/59613269/thumb/aaa';
	        object.title = 'Item3';
	        array.push(object);
	
	        object = {};
	        object.href = 'http://stage.creaza.com/file/ci/59613267/img';
	        object.thumb = 'http://stage.creaza.com/file/ci/59613267/thumb/aaa';
	        object.title = 'Item4';
	        array.push(object);
	
	        object = {};
	        object.href = 'http://stage.creaza.com/file/ci/59606269/img';
	        object.thumb = 'http://stage.creaza.com/file/ci/59606269/thumb/aaa';
	        object.title = 'Item5';
	        array.push(object);
	
	        object = {};
	        object.href = 'http://stage.creaza.com/file/ci/59609278/img';
	        object.thumb = 'http://stage.creaza.com/file/ci/59609278/thumb/aaa';
	        object.title = 'Item6';
	        array.push(object);
	
	        object = {};
	        object.href = 'http://stage.creaza.com/file/ci/59609276/img';
	        object.thumb = 'http://stage.creaza.com/file/ci/59609276/thumb/aaa';
	        object.title = 'Item7';
	        array.push(object);
	
	        object = {};
	        object.href = 'http://stage.creaza.com/file/ci/59606277/img';
	        object.thumb = 'http://stage.creaza.com/file/ci/59606277/thumb/aaa';
	        object.title = 'Item8';
	        array.push(object);
	
	        object = {};
	        object.href = 'http://stage.creaza.com/file/ci/59606279/img';
	        object.thumb = 'http://stage.creaza.com/file/ci/59606279/thumb/aaa';
	        object.title = 'Item9';
	        array.push(object);
	
	        object = {};
	        object.href = 'http://stage.creaza.com/file/ci/59606281/img';
	        object.thumb = 'http://stage.creaza.com/file/ci/59606281/thumb/aaa';
	        object.title = 'Item10';
	        array.push(object);
	
	        array = array.concat(array);
	        array = array.concat(array);
	        array = array.concat(array);
	
	        return array;
	    },
	    getSoundsDataProviderForTest: function getSoundsDataProviderForTest() {
	        var array = [];
	        var object;
	
	        object = {};
	        object.duration = '01:21';
	        object.title = 'Sound1 asda asd asdas asda';
	        object.href = 'http://freesound.org/data/previews/405/405201_1106021-lq.mp3';
	        object.contentItemId = 1;
	        object.isRecordedSound = true;
	        array.push(object);
	
	        object = {};
	        object.duration = '00:18';
	        object.title = 'Sound2';
	        object.href = 'http://soundbible.com/mp3/baby-music-box_daniel-simion.mp3';
	        object.contentItemId = 2;
	        array.push(object);
	
	        object = {};
	        object.duration = '00:11';
	        object.title = 'Sound3';
	        object.href = '/file/ci/73563245/aaa';
	        object.contentItemId = 3;
	        array.push(object);
	
	        object = {};
	        object.duration = '00:29';
	        object.title = 'Sound4';
	        object.contentItemId = 4;
	        array.push(object);
	
	        object = {};
	        object.duration = '01:12';
	        object.title = 'Sound5';
	        object.contentItemId = 5;
	        object.isRecordedSound = true;
	        array.push(object);
	
	        object = {};
	        object.duration = '03:52';
	        object.title = 'Sound6';
	        object.contentItemId = 6;
	        array.push(object);
	
	        object = {};
	        object.duration = '01:02';
	        object.title = 'Sound7';
	        object.contentItemId = 7;
	        array.push(object);
	
	        object = {};
	        object.duration = '03:41';
	        object.title = 'Sound8';
	        object.contentItemId = 8;
	        object.isRecordedSound = true;
	        array.push(object);
	
	        object = {};
	        object.duration = '03:33';
	        object.title = 'Sound9';
	        object.contentItemId = 9;
	        array.push(object);
	
	        object = {};
	        object.duration = '04:22';
	        object.title = 'Sound10';
	        object.contentItemId = 10;
	        array.push(object);
	
	        object = {};
	        object.duration = '01:21';
	        object.title = 'Sound1 asda asd asdas asda';
	        object.href = 'http://freesound.org/data/previews/405/405201_1106021-lq.mp3';
	        object.contentItemId = 1;
	        object.isRecordedSound = true;
	        array.push(object);
	
	        object = {};
	        object.duration = '00:18';
	        object.title = 'Sound2';
	        object.href = 'http://soundbible.com/mp3/baby-music-box_daniel-simion.mp3';
	        object.contentItemId = 2;
	        array.push(object);
	
	        object = {};
	        object.duration = '00:11';
	        object.title = 'Sound3';
	        object.href = '/file/ci/73563245/aaa';
	        object.contentItemId = 3;
	        array.push(object);
	
	        object = {};
	        object.duration = '00:29';
	        object.title = 'Sound4';
	        object.contentItemId = 4;
	        array.push(object);
	
	        object = {};
	        object.duration = '01:12';
	        object.title = 'Sound5';
	        object.contentItemId = 5;
	        object.isRecordedSound = true;
	        array.push(object);
	
	        object = {};
	        object.duration = '03:52';
	        object.title = 'Sound6';
	        object.contentItemId = 6;
	        array.push(object);
	
	        object = {};
	        object.duration = '01:02';
	        object.title = 'Sound7';
	        object.contentItemId = 7;
	        array.push(object);
	
	        object = {};
	        object.duration = '03:41';
	        object.title = 'Sound8';
	        object.contentItemId = 8;
	        object.isRecordedSound = true;
	        array.push(object);
	
	        object = {};
	        object.duration = '03:33';
	        object.title = 'Sound9';
	        object.contentItemId = 9;
	        array.push(object);
	
	        object = {};
	        object.duration = '04:22';
	        object.title = 'Sound10';
	        object.contentItemId = 10;
	        array.push(object);
	
	        return array;
	    },
	    getVideosDataProviderForTest: function getVideosDataProviderForTest() {
	        var array = [];
	        var object;
	
	        object = {};
	        object.title = 'Video1';
	        object.status = 'preparing';
	        object.href = 'https://stage.creaza.com/file/ci/75385873/aaa';
	        object.thumb = 'http://stage.creaza.com/file/ci/75385873/thumb/aaa';
	        object.contentItemId = 59820349;
	        array.push(object);
	
	        object = {};
	        object.title = 'Roma';
	        object.status = 'preparing';
	        object.href = 'https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_roma_010.mp4';
	        object.thumb = 'https://d3b76ijxom7qfl.cloudfront.net/staticthumbs/video/creaza_italia_roma_010.jpg';
	        object.contentItemId = 75383569;
	        array.push(object);
	
	        return array;
	    },
	
	
	    // refresh MyMediaFiels with the new uploaded files
	
	    mediaFilesRefreshTimer: undefined,
	    checkStatusTimer: undefined,
	    lastUploadedFileId: -1,
	    extraTimer: undefined,
	    currentRefreshTime: -1,
	
	    stopRefreshTimers: function stopRefreshTimers() {
	        if (this.checkStatusTimer) clearInterval(this.checkStatusTimer);
	
	        if (this.mediaFilesRefreshTimer) clearInterval(this.mediaFilesRefreshTimer);
	    },
	    startMediaFilesRefreshTimer: function startMediaFilesRefreshTimer() {
	        // return; //removed this functionality for some performance tests
	
	        if (_Configuration2.default.LOAD_LOCAL == true) return;
	
	        this.stopRefreshTimers();
	        this.mediaFilesRefreshTimer = setInterval(this.onMediaFilesRefreshTimer.bind(this), 10 * 1000); // intial 5 seconds
	    },
	    onMediaFilesRefreshTimer: function onMediaFilesRefreshTimer() {
	        var self = this;
	
	        _ApiServiceUtils2.default.executeSafeApiCall(function () {
	            _ApiService2.default.getLastUploadedMediaFileId().then(function (response) {
	                if (response && response.contentItemId > 0) {
	                    self.lastUploadedFileId = response.contentItemId;
	                    self.startCheckStatusForCurrentUpload();
	                }
	            });
	        }.bind(this), function () {
	            this.stopRefreshTimers();
	        }.bind(this));
	    },
	    startCheckStatusForCurrentUpload: function startCheckStatusForCurrentUpload() {
	        this.cleartExtraTimer();
	        this.stopRefreshTimers();
	        this.checkStatusTimer = setInterval(this.onCheckStatus.bind(this), 5 * 1000); // initial 2 seconds
	    },
	    onCheckStatus: function onCheckStatus() {
	        if (this.lastUploadedFileId < 0) {
	            this.stopRefreshTimers();
	            return;
	        }
	
	        var self = this;
	
	        _ApiServiceUtils2.default.executeSafeApiCall(function () {
	            _ApiService2.default.getUploadingMediaFileStatus(this.lastUploadedFileId).then(function (response) {
	                var statusObject = response.status;
	
	                if (statusObject && (statusObject[self.lastUploadedFileId] == 'finished' || statusObject[self.lastUploadedFileId] == 'corrupt')) {
	                    self.refreshMediaFiles();
	                }
	            });
	
	            _ApiService2.default.getLastUploadedMediaFileId().then(function (response) {
	                if (response && response.contentItemId == -1) {
	                    // no files to be loaded ... then a refresh should be done
	                    self.refreshMediaFiles();
	                }
	            });
	        }.bind(this));
	    },
	    refreshMediaFiles: function refreshMediaFiles() {
	        this.lastUploadedFileId = -1;
	        this.startMediaFilesRefreshTimer(); // check for another possible uploaded file
	
	        _ApiServiceUtils2.default.executeSafeApiCall(this.executeGetMediaFilesCall.bind(this));
	
	        this.cleartExtraTimer();
	        this.currentRefreshTime = new Date().getTime();
	        this.extraTimer = setInterval(this.onExtraRefresh.bind(this), 7 * 1000);
	    },
	    onExtraRefresh: function onExtraRefresh() {
	        _ApiServiceUtils2.default.executeSafeApiCall(this.executeGetMediaFilesCall.bind(this));
	
	        var currentTime = new Date().getTime();
	
	        if (currentTime - this.currentRefreshTime > 2 * 60 * 1000) this.cleartExtraTimer();
	    },
	    cleartExtraTimer: function cleartExtraTimer() {
	        if (this.extraTimer) clearInterval(this.extraTimer);
	    },
	    executeGetMediaFilesCall: function executeGetMediaFilesCall() {
	        _ApiServiceUtils2.default.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
	    },
	    refreshMediaFilesAfterRecording: function refreshMediaFilesAfterRecording() {
	        this.executeGetMediaFilesCall();
	    },
	    cleanTimers: function cleanTimers() {
	        this.stopRefreshTimers();
	    },
	    restartRefreshTimers: function restartRefreshTimers() {
	        setTimeout(this.startMediaFilesRefreshTimer.bind(this), 6 * 1000);
	    }
	};
	
	exports.default = populateMediaFilesUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/PopulateMediaFilesUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/PopulateMediaFilesUtils.js"); } } })();

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(286);
	var $export = __webpack_require__(4);
	var shared = __webpack_require__(157)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(289))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(43)) {
	  var LIBRARY = __webpack_require__(97);
	  var global = __webpack_require__(24);
	  var fails = __webpack_require__(26);
	  var $export = __webpack_require__(4);
	  var $typed = __webpack_require__(159);
	  var $buffer = __webpack_require__(202);
	  var ctx = __webpack_require__(70);
	  var anInstance = __webpack_require__(95);
	  var propertyDesc = __webpack_require__(101);
	  var hide = __webpack_require__(59);
	  var redefineAll = __webpack_require__(102);
	  var toInteger = __webpack_require__(77);
	  var toLength = __webpack_require__(45);
	  var toIndex = __webpack_require__(284);
	  var toAbsoluteIndex = __webpack_require__(104);
	  var toPrimitive = __webpack_require__(78);
	  var has = __webpack_require__(58);
	  var classof = __webpack_require__(130);
	  var isObject = __webpack_require__(28);
	  var toObject = __webpack_require__(48);
	  var isArrayIter = __webpack_require__(188);
	  var create = __webpack_require__(98);
	  var getPrototypeOf = __webpack_require__(64);
	  var gOPN = __webpack_require__(99).f;
	  var getIterFn = __webpack_require__(205);
	  var uid = __webpack_require__(105);
	  var wks = __webpack_require__(34);
	  var createArrayMethod = __webpack_require__(73);
	  var createArrayIncludes = __webpack_require__(146);
	  var speciesConstructor = __webpack_require__(158);
	  var ArrayIterators = __webpack_require__(206);
	  var Iterators = __webpack_require__(113);
	  var $iterDetect = __webpack_require__(152);
	  var setSpecies = __webpack_require__(103);
	  var arrayFill = __webpack_require__(180);
	  var arrayCopyWithin = __webpack_require__(257);
	  var $DP = __webpack_require__(44);
	  var $GOPD = __webpack_require__(63);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(49);
	
	var PooledClass = __webpack_require__(106);
	
	var emptyFunction = __webpack_require__(66);
	var warning = __webpack_require__(29);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _ToolTipManager = __webpack_require__(174);
	
	var _ToolTipManager2 = _interopRequireDefault(_ToolTipManager);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mindMapUtils = {
	    selectedMindMap: undefined, // uuid
	    selectedNode: undefined, // controlPoint, controlPoint1, controlPoint2, etc
	    initialPositions: [],
	    insertImageTarget: undefined, // uuid of the mindmap where the image will be inserted
	
	    isMindMapMode: function isMindMapMode() {
	        if (this.selectedMindMap || this.insertImageTarget) return true;else return false;
	    },
	    reset: function reset() {
	        var resetContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this.selectedMindMap = undefined;
	        this.selectedNode = undefined;
	        this.initialPositions = [];
	        this.insertImageTarget = undefined;
	
	        if (resetContext) _StoreManager2.default.getStore().dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    isMindMapType: function isMindMapType(shapeModel) {
	        if (shapeModel.isMindMap || shapeModel.mindMapProperty) return true;else return false;
	    },
	    getCurrentShape: function getCurrentShape(uuid) {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i = void 0;
	        var target = void 0;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == uuid) {
	                target = shapes[i];
	                break;
	            }
	        }
	
	        return target;
	    },
	    getCurrentMindMap: function getCurrentMindMap(uuid) {
	        return this.getCurrentShape(uuid);
	    },
	    openSearch: function openSearch() {
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeCartoonistTabIndex)(0)); // Cartoons should be the first selected tab
	
	        setTimeout(function () {
	            dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.SEARCH_CONTEXT));
	        }.bind(this), 5);
	    },
	    openSearchForImageInsertion: function openSearchForImageInsertion(target) {
	        this.insertImageTarget = target;
	        this.openSearch();
	    },
	    getControlPointPosition: function getControlPointPosition(mindMapUid, nodeId) {
	        var mindMap = this.getCurrentMindMap(mindMapUid);
	        var currentCx = void 0;
	        var currentCy = void 0;
	
	        switch (nodeId) {
	            case 'controlPoint':
	                {
	                    currentCx = mindMap.cx;
	                    currentCy = mindMap.cy;
	                    break;
	                }
	            case 'controlPoint1':
	                {
	                    currentCx = mindMap.cx1;
	                    currentCy = mindMap.cy1;
	                    break;
	                }
	            case 'controlPoint2':
	                {
	                    currentCx = mindMap.cx2;
	                    currentCy = mindMap.cy2;
	                    break;
	                }
	            case 'controlPoint3':
	                {
	                    currentCx = mindMap.cx3;
	                    currentCy = mindMap.cy3;
	                    break;
	                }
	            case 'controlPoint4':
	                {
	                    currentCx = mindMap.cx4;
	                    currentCy = mindMap.cy4;
	                    break;
	                }
	            case 'controlPoint5':
	                {
	                    currentCx = mindMap.cx5;
	                    currentCy = mindMap.cy5;
	                    break;
	                }
	        }
	
	        return { cx: currentCx, cy: currentCy };
	    },
	    insertTextNode: function insertTextNode() {
	        var currentControlPoint = this.getControlPointPosition(this.selectedMindMap, this.selectedNode);
	
	        var topLeftPoint = { x: currentControlPoint.cx - _Properties2.default.RICH_TEXT_WIDTH / 2, y: currentControlPoint.cy - _Properties2.default.RICH_TEXT_HEIGHT / 2 };
	        var mindMapProperty = { parentMindMap: this.selectedMindMap, selectedNode: this.selectedNode };
	
	        _CreateShapes2.default.createTextBox(_StoreManager2.default.getStore().dispatch, topLeftPoint, true, mindMapProperty);
	
	        this.reset(true);
	    },
	    insertMediaNode: function insertMediaNode(item) {
	        var isCharacter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (this.insertImageTarget) {
	            this.preloadImage(this.insertImageTarget, item.href);
	        } else {
	            var dispatch = _StoreManager2.default.getStore().dispatch;
	            var currentControlPoint = this.getControlPointPosition(this.selectedMindMap, this.selectedNode);
	
	            var topLeftPoint = {
	                x: currentControlPoint.cx - _Properties2.default.MIND_MAP_NODE_SIZE / 2,
	                y: currentControlPoint.cy - _Properties2.default.MIND_MAP_NODE_SIZE / 2
	            };
	            var mindMapProperty = { parentMindMap: this.selectedMindMap, selectedNode: this.selectedNode };
	
	            if (isCharacter) _CreateShapes2.default.createCharacter(dispatch, item, topLeftPoint, mindMapProperty);else _CreateShapes2.default.createImage(dispatch, item, topLeftPoint, mindMapProperty);
	        }
	
	        this.reset(true);
	
	        _HoverManager2.default.hide();
	        _ToolTipManager2.default.hideToolTip();
	    },
	    preloadImage: function preloadImage(imageTarget, href) {
	        var imageObj = new Image();
	
	        imageObj.onload = function (e) {
	            var target = e.target;
	            var aspectRatio = target.width / target.height;
	            var dispatch = _StoreManager2.default.getStore().dispatch;
	
	            dispatch((0, _CurrentSlideActions.insertImageNode)(imageTarget, href, aspectRatio));
	        };
	
	        imageObj.src = _VideoUtils2.default.checkCacheBreaker(href);
	    },
	    removeImage: function removeImage(targetUid) {
	        _StoreManager2.default.getStore().dispatch((0, _CurrentSlideActions.insertImageNode)(targetUid, '', 1));
	    },
	    updateInitialPositions: function updateInitialPositions() {
	        this.initialPositions = [];
	
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var i = void 0;
	        var shape = void 0;
	
	        for (i = 1; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.isMindMap || shape.mindMapProperty) this.initialPositions[shape.uuid] = { x: shape.x, y: shape.y, width: shape.width, height: shape.height };
	        }
	    },
	    updateShapePosition: function updateShapePosition(shapeModel, offsetX, offsetY) {
	        if (shapeModel.mindMapProperty) // it's a node shape of a mind map
	            this.updateMindMapControlPointPosition(shapeModel, offsetX, offsetY);
	
	        if (shapeModel.isMindMap) // it's a mindMap so we should update the position of all nodes
	            this.updateMindMapNodesPosition(shapeModel, offsetX, offsetY);
	    },
	    updateMindMapControlPointPosition: function updateMindMapControlPointPosition(shapeModel, offsetX, offsetY) {
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        var centerX = void 0;
	        var centerY = void 0;
	
	        if (offsetX === undefined) {
	            centerX = shapeModel.x + shapeModel.width / 2;
	            centerY = shapeModel.y + shapeModel.height / 2;
	        } else {
	            var initialPosition = this.initialPositions[shapeModel.uuid];
	            var newX = initialPosition.x + offsetX;
	            var newY = initialPosition.y + offsetY;
	
	            centerX = newX + initialPosition.width / 2;
	            centerY = newY + initialPosition.height / 2;
	        }
	
	        dispatch((0, _CurrentSlideActions.updateBubbleControlPoint)(shapeModel.mindMapProperty.parentMindMap, centerX, centerY, shapeModel.mindMapProperty.selectedNode));
	    },
	    updateMindMapNodesPosition: function updateMindMapNodesPosition(mindMapShapeModel, offsetX, offsetY) {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        var i = void 0;
	        var shape = void 0;
	        var positions = [];
	        var isEmpty = true;
	
	        for (i = 1; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.mindMapProperty && shape.mindMapProperty.parentMindMap === mindMapShapeModel.uuid) {
	                // it's a node of the current mindMap
	                if (offsetX === undefined) {
	                    var currentControlPoint = this.getControlPointPosition(shape.mindMapProperty.parentMindMap, shape.mindMapProperty.selectedNode);
	
	                    if (currentControlPoint) {
	                        positions[shape.uuid] = { x: currentControlPoint.cx - shape.width / 2, y: currentControlPoint.cy - shape.height / 2 };
	                        isEmpty = false;
	                    }
	                } else {
	                    var position = this.initialPositions[shape.uuid];
	
	                    if (position) {
	                        positions[shape.uuid] = { x: position.x + offsetX, y: position.y + offsetY };
	                        isEmpty = false;
	                    }
	                }
	            }
	        }
	
	        if (isEmpty == false) {
	            dispatch((0, _CurrentSlideActions.changeShapesPosition)(positions));
	            _SaveManager2.default.isContentChanged(true);
	        }
	    },
	    moveShapeByKeyboard: function moveShapeByKeyboard(shapeModel, offsetX, offsetY) {
	        this.updateInitialPositions();
	        this.updateShapePosition(shapeModel, offsetX, offsetY);
	    },
	    updateShapePositionWhenResize: function updateShapePositionWhenResize(shapeModel) {
	        setTimeout(function () {
	            this.updateShapePosition(this.getCurrentShape(shapeModel.uuid));
	        }.bind(this), 3);
	    }
	};
	
	exports.default = mindMapUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/MindMapUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/MindMapUtils.js"); } } })();

/***/ },
/* 86 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var es5 = __webpack_require__(112);
	var Objectfreeze = es5.freeze;
	var util = __webpack_require__(33);
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(34)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(59)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(105)('meta');
	var isObject = __webpack_require__(28);
	var has = __webpack_require__(58);
	var setDesc = __webpack_require__(44).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(26)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 90 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.changeMainAudioCategoryIndex = changeMainAudioCategoryIndex;
	exports.changeSoundEffectsCategoryIndex = changeSoundEffectsCategoryIndex;
	exports.changeSecondAudioCategoryIndex = changeSecondAudioCategoryIndex;
	exports.addSoundClipartModel = addSoundClipartModel;
	exports.changeMusicContentIndex = changeMusicContentIndex;
	exports.changeSlideAudioIndex = changeSlideAudioIndex;
	var types = exports.types = {
	    CHANGE_MAIN_AUDIO_CATEGORY_INDEX: 'change_main_audio_category_index',
	    CHANGE_SECOND_AUDIO_CATEGORY_INDEX: 'change_second_audio_category_index',
	    ADD_SOUND_CLIPART_MODEL: 'add_sound_clipart_model',
	    CHANGE_MUSIC_CONTENT_INDEX: 'change_music_content_index',
	    CHANGE_SLIDE_AUDIO_INDEX: 'change_slide_audio_index',
	    CHANGE_SOUND_EFFECTS_CATEGORY_INDEX: 'change_sound_effects_category_index'
	};
	
	function changeMainAudioCategoryIndex(index) {
	    return { type: types.CHANGE_MAIN_AUDIO_CATEGORY_INDEX, index: index };
	}
	
	function changeSoundEffectsCategoryIndex(index) {
	    return { type: types.CHANGE_SOUND_EFFECTS_CATEGORY_INDEX, index: index };
	}
	
	function changeSecondAudioCategoryIndex(index) {
	    return { type: types.CHANGE_SECOND_AUDIO_CATEGORY_INDEX, index: index };
	}
	
	function addSoundClipartModel(clipartModel) {
	    return { type: types.ADD_SOUND_CLIPART_MODEL, clipartModel: clipartModel };
	}
	
	function changeMusicContentIndex(index) {
	    return { type: types.CHANGE_MUSIC_CONTENT_INDEX, index: index };
	}
	
	function changeSlideAudioIndex(index) {
	    return { type: types.CHANGE_SLIDE_AUDIO_INDEX, index: index };
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/actions/MusicActions.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/actions/MusicActions.js"); } } })();

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MenuCheckbox = exports.MenuInput = exports.SecondaryMenuButton = exports.PrimaryMenuButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrimaryMenuButton = exports.PrimaryMenuButton = _react2.default.createClass({
	    displayName: 'PrimaryMenuButton',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.clickHandler) this.props.clickHandler(this.props.type);
	    },
	    render: function render() {
	        var buttonStyle = {
	            borderRadius: '8px',
	            margin: '1% 0',
	            height: '35px',
	            backgroundColor: 'white',
	            maxWidth: '49%',
	            width: '100%',
	            border: '2px solid rgb(67, 67, 67)',
	            cursor: 'pointer'
	        };
	
	        var selectedButtonStyle = {
	            borderRadius: '8px',
	            margin: '1% 0',
	            height: '35px',
	            backgroundColor: 'rgb(67, 67, 67)',
	            color: 'white',
	            maxWidth: '49%',
	            width: '100%',
	            border: '2px solid rgb(67, 67, 67)',
	            cursor: 'pointer'
	        };
	
	        if (this.props.targets >= 2) {
	            var value = void 0;
	
	            if (this.props.targets > 5) value = 19;else value = Math.floor(100 / this.props.targets) - 1;
	
	            buttonStyle.maxWidth = value + '%';
	            selectedButtonStyle.maxWidth = value + '%';
	
	            buttonStyle.marginRight = '1%';
	            selectedButtonStyle.marginRight = '1%';
	        }
	
	        if (this.state.isOver == true) {
	            buttonStyle.borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            buttonStyle.color = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	
	            selectedButtonStyle.color = 'lightgoldenrodyellow';
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { id: this.props.id, 'aria-label': this.props.caption, style: this.props.isSelected ? selectedButtonStyle : buttonStyle, onClick: this.onClick, onTouchStart: this.onClick, 'aria-pressed': this.props.isToggleButton ? this.props.isSelected : undefined, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            this.props.caption
	        );
	    }
	});
	
	var SecondaryMenuButton = exports.SecondaryMenuButton = _react2.default.createClass({
	    displayName: 'SecondaryMenuButton',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.clickHandler) this.props.clickHandler(this.props.type);
	    },
	    render: function render() {
	        var buttonStyle = {
	            borderRadius: '20px',
	            margin: '1% 0',
	            height: '35px',
	            backgroundColor: '#E6E6E6',
	            maxWidth: '49%',
	            width: '100%',
	            border: '2px solid rgb(67, 67, 67)',
	            cursor: 'pointer'
	        };
	
	        if (this.state.isOver == true) {
	            buttonStyle.borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            buttonStyle.color = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { id: this.props.id, 'aria-label': this.props.caption, style: buttonStyle, onClick: this.onClick, onTouchStart: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            this.props.caption
	        );
	    }
	});
	
	var MenuInput = exports.MenuInput = _react2.default.createClass({
	    displayName: 'MenuInput',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onChangeHandler: function onChangeHandler() {
	        if (this.props.onChangeHandler) {
	            if (this.props.property && (this.props.xValue || this.props.yValue)) {
	                if (this.props.xValue) this.props.onChangeHandler(this.props.xValue, this.refs.inputField.value, this.props.property);else this.props.onChangeHandler(this.refs.inputField.value, this.props.yValue, this.props.property);
	            } else {
	                if (this.props.property) this.props.onChangeHandler(this.props.property, this.refs.inputField.value);else {
	                    if (this.props.xValue || this.props.yValue) {
	                        if (this.props.xValue) this.props.onChangeHandler(this.props.xValue, this.refs.inputField.value);else this.props.onChangeHandler(this.refs.inputField.value, this.props.yValue);
	                    } else this.props.onChangeHandler(this.refs.inputField.value);
	                }
	            }
	        }
	    },
	    onSetTextFocus: function onSetTextFocus() {
	        setTimeout(function () {
	            if (this.refs.inputField) {
	                this.refs.inputField.focus();
	                // this.refs.inputField.setSelectionRange(0, 100);
	            }
	        }.bind(this), 10);
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (this.props.onFocusHandler) this.props.onFocusHandler(this.props.property);
	    },
	    onBlurHandler: function onBlurHandler() {
	        if (this.props.onBlurHandler) this.props.onBlurHandler(this.props.property);
	    },
	    render: function render() {
	        var labelStyle = {
	            fontSize: '16px',
	            margin: '2% 0',
	            display: 'flex',
	            justifyContent: 'space-between',
	            width: '100%',
	            top: 0
	        };
	
	        var inputStyle = {
	            borderRadius: '5px',
	            fontSize: '18px',
	            border: '2px solid black',
	            background: 'transparent',
	            width: '50px'
	        };
	
	        if (this.state.isOver == true) {
	            inputStyle.color = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	        }
	
	        return _react2.default.createElement(
	            'label',
	            { style: labelStyle },
	            _react2.default.createElement(
	                'span',
	                { style: labelStyle },
	                this.props.labelText
	            ),
	            _react2.default.createElement('input', { id: this.props.id, style: inputStyle, ref: 'inputField', onChange: this.onChangeHandler, onTouchStart: this.onSetTextFocus, type: 'text', className: 'titleInput', value: this.props.isInt ? Math.round(parseInt(this.props.value)) || 0 : this.props.value, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onFocus: this.onFocusHandler, onBlur: this.onBlurHandler })
	        );
	    }
	});
	
	var MenuCheckbox = exports.MenuCheckbox = _react2.default.createClass({
	    displayName: 'MenuCheckbox',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.clickHandler) this.props.clickHandler();
	    },
	    render: function render() {
	        var labelStyle = {
	            fontSize: '16px',
	            margin: '2% 0',
	            display: 'flex',
	            justifyContent: 'space-between',
	            width: '100%',
	            top: 0
	        };
	
	        var caption = this.props.value ? _LocalesManager2.default.getCaption('On', 'sizePosMenu') : _LocalesManager2.default.getCaption('Off', 'sizePosMenu');
	
	        var buttonStyle = {
	            cursor: 'pointer'
	        };
	
	        if (this.state.isOver == true) {
	            buttonStyle.color = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	        }
	
	        return _react2.default.createElement(
	            'label',
	            { style: labelStyle },
	            _react2.default.createElement(
	                'span',
	                { style: labelStyle },
	                this.props.labelText
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: this.props.id, role: 'checkbox', style: buttonStyle, 'aria-label': caption, 'aria-checked': this.props.value, onClick: this.onClick, onTouchStart: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	                caption
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SizeAndPositionButtons.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SizeAndPositionButtons.js"); } } })();

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _TransitionsUtils = __webpack_require__(856);
	
	var _TransitionsUtils2 = _interopRequireDefault(_TransitionsUtils);
	
	var _DrawingUtils = __webpack_require__(108);
	
	var _DrawingUtils2 = _interopRequireDefault(_DrawingUtils);
	
	var _ColorUtils = __webpack_require__(240);
	
	var _ColorUtils2 = _interopRequireDefault(_ColorUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _SpeakBubbleUtils = __webpack_require__(139);
	
	var _SpeakBubbleUtils2 = _interopRequireDefault(_SpeakBubbleUtils);
	
	var _ScreamBubbleUtils = __webpack_require__(236);
	
	var _ScreamBubbleUtils2 = _interopRequireDefault(_ScreamBubbleUtils);
	
	var _ThoughtBubbleUtils = __webpack_require__(237);
	
	var _ThoughtBubbleUtils2 = _interopRequireDefault(_ThoughtBubbleUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _ExportUploader = __webpack_require__(850);
	
	var _ExportUploader2 = _interopRequireDefault(_ExportUploader);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var exporterUtils = {
	    slides: [],
	    videoIds: [],
	    videoMap: [],
	    storySound: undefined,
	    checkStatusTimer: undefined,
	    jobId: '',
	    timelines: undefined,
	    CANVAS_WIDTH: _Configuration2.default.CANVAS_WIDTH,
	    CANVAS_HEIGHT: _Configuration2.default.CANVAS_HEIGHT,
	    ANIMATION_SCALE_OFFSET: 10,
	    testLocalAnimation: false,
	
	    init: function init() {
	        _ExportUploader2.default.init();
	        this.setExportFlag(false);
	        window.addEventListener('message', this.onExport.bind(this));
	    },
	    removeEvent: function removeEvent() {
	        window.removeEventListener('message', this.onExport);
	    },
	    startExport: function startExport() {
	        this.setExportFlag(true);
	        this.onExport();
	    },
	    setExportFlag: function setExportFlag(value) {
	        return; // removed functionality for the moment.
	        if (_AppParameters2.default.contentItemId < 0) return;
	
	        if (!_PlatformDetection2.default.isIOS()) {
	            if (value) localStorage.setItem('isExportStarted_' + _AppParameters2.default.contentItemId, 'true');else localStorage.setItem('isExportStarted_' + _AppParameters2.default.contentItemId, 'false');
	        }
	    },
	    onExport: function onExport(event) {
	        if (event && event.data) _TransitionsUtils2.default.exportPropertiesFromPortal = event.data;
	
	        this.jobId = -1;
	        _ApiServiceUtils2.default.executeSafeApiCall(this.prepareDataForExport.bind(this), this.exportFailed.bind(this));
	    },
	    callExportJob: function callExportJob(data) {
	        var submitId = _AppParameters2.default.submitId;
	
	        var self = this;
	        var totalTime = _AudioEditorUtils2.default.getExportTotalTime();
	
	        _ApiService2.default.exportCartoonist(submitId, data, totalTime).then(function (response) {
	            if (response.jobId && response.jobId.length > 0) {
	                self.startCheckStatus(response.jobId, response.exportEstimation);
	            } else {
	                self.exportFailed();
	            }
	        });
	    },
	    stopTimer: function stopTimer() {
	        if (this.checkStatusTimer) clearInterval(this.checkStatusTimer);
	    },
	    isPlayer: function isPlayer() {
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER || _AppParameters2.default.getMode() == _ModeConstants2.default.AUDIO_TOOL_PLAYER) return true;else return false;
	    },
	    startCheckStatus: function startCheckStatus(jobId) {
	        var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10 * 1000;
	
	        if (this.isPlayer()) {
	            if (_PlatformDetection2.default.isIOSApp()) window.parent.setExportDuration(duration);else window.parent.postMessage(duration, '*');
	        }
	
	        this.jobId = jobId;
	        this.stopTimer();
	        this.checkStatusTimer = setInterval(this.onCheckStatus.bind(this), 10 * 1000);
	    },
	    onCheckStatus: function onCheckStatus() {
	        if (!(this.jobId && this.jobId.length > 0)) {
	            this.exportFailed();
	            return;
	        }
	
	        var self = this;
	
	        _ApiServiceUtils2.default.executeSafeApiCall(function () {
	            _ApiService2.default.getExportStatus(this.jobId).then(function (response) {
	                var contentItemId = response.contentItemId;
	
	                if (contentItemId > 0) self.exportFinished(contentItemId);
	            });
	        }.bind(this), this.exportFailed.bind(this));
	    },
	    exportFinished: function exportFinished(contentItemId) {
	        this.setExportFlag(false);
	        this.stopTimer();
	
	        if (this.isPlayer()) {
	            if (_PlatformDetection2.default.isIOSApp()) window.parent.exportDoneCallback();else window.parent.postMessage('exportDone', '*');
	        }
	    },
	    exportFailed: function exportFailed() {
	        this.setExportFlag(false);
	        this.stopTimer();
	
	        if (this.isPlayer()) {
	            if (_PlatformDetection2.default.isIOSApp()) window.parent.exportDoneCallback();else window.parent.postMessage('exportFailed', '*');
	        }
	    },
	    prepareDataForExport: function prepareDataForExport() {
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            this.getTimelines();
	            this.export();
	        } else {
	            this.slides = [];
	            this.videoIds = [];
	            this.videoMap = [];
	            this.storySound = undefined;
	
	            this.createSlideElements();
	
	            var self = this;
	
	            if (this.videoIds && this.videoIds.length > 0) {
	                _ApiService2.default.getVideoOriginals(this.videoIds).then(function (response) {
	                    self.createVideoMap(response);
	                });
	            } else {
	                this.export();
	            }
	        }
	    },
	    export: function _export() {
	        var data;
	
	        if (_AudioToolUtils2.default.isAudioTool()) data = this.createAudioXML();else data = this.createXML();
	
	        if (this.isBigData(data)) {
	            // it's a big export so upload the xml to s3
	            var jsonData = {};
	            jsonData.xml = data;
	            jsonData = JSON.stringify(jsonData);
	
	            var blob = new Blob([jsonData], { type: 'application/json' });
	
	            this.exportTitle = _SaveManager2.default.getFileName();
	            _ExportUploader2.default.uploadFile(blob, this.exportTitle);
	        } else this.callExportJob(data);
	    },
	
	    /***************** Big Export Data *********************/
	    exportTitle: '',
	    isBigData: function isBigData(data) {
	        if (data && data.length > 900000) return true;else return false;
	    },
	    uploadSuccess: function uploadSuccess(type, name, state) {
	        if (state && state.success == true) {
	            this.doBigExport();
	        } else {
	            // error: the file wasn't stored on s3
	            this.uploadError();
	        }
	    },
	    uploadError: function uploadError() {
	        alert('Export fail!');
	    },
	    doBigExport: function doBigExport() {
	        var bucket;
	
	        if (_Configuration2.default.IS_PROD() == true) bucket = 'creaza-content-json';else bucket = 'creaza-stage-content-json';
	
	        var data = 'https://s3-eu-west-1.amazonaws.com/' + bucket + '/Cartoonist/' + _AppParameters2.default.currentUserId + '/export/' + this.exportTitle;
	
	        this.callExportJob(data);
	    },
	
	    /*********************************************************/
	
	    getDurationMap: function getDurationMap(slides) {
	        var slideDuration = [];
	        var correctMap = [];
	        var i = 0;
	        var useTransitions = _TransitionsUtils2.default.useTransitions();
	        var prop = void 0;
	
	        for (i = 0; i < slides.length; i++) {
	            slideDuration.push(Math.floor(slides[i].time * 1000));
	        }if (!useTransitions || slides.length < 2) {
	            for (i = 0; i < slides.length; i++) {
	                prop = {};
	                prop.duration = slideDuration[i];
	                prop.addTransition = false;
	
	                correctMap.push(prop);
	            }
	
	            return correctMap;
	        }
	
	        for (i = 0; i < slides.length; i++) {
	            prop = {};
	            prop.duration = slideDuration[i];
	
	            if (i === slides.length - 1) // the last slide doesn't have transition
	                prop.addTransition = false;else prop.addTransition = true;
	
	            correctMap.push(prop);
	        }
	
	        return correctMap;
	    },
	    getPosition: function getPosition(duration, start, end, scaleFactor, position) {
	        var totalTime = duration + start + end;
	
	        return scaleFactor * position / totalTime;
	    },
	    addKenBurns: function addKenBurns(duration) {
	        var scaleFactor = 0.1; // the scale difference between start and end position
	        var min = 0;
	        var max = 1;
	        var noScaleTransition = Math.floor(Math.random() * (max - min + 1)) + min;
	        var transitionType = void 0;
	        var startTransitionTime = 0;
	        var endTransitionTime = 0;
	
	        if (noScaleTransition == 0) {
	            max = 7;
	            transitionType = Math.floor(Math.random() * (max - min + 1)) + min;
	
	            var exportWidth = 1920;
	            var exportHeight = 1080;
	            var scale = 1 + scaleFactor;
	            var startWidth = Math.floor(exportWidth * scale);
	            var endWidth = startWidth;
	            var startHeight = Math.floor(exportHeight * scale);
	            var endHeight = startHeight;
	            var startTop = -1 * (startHeight - exportHeight) / 2;
	            var endTop = startTop;
	            var startLeft = 0;
	            var endLeft = -1 * (startWidth - exportWidth);
	            var widthDifference = startWidth - exportWidth;
	            var heightDifference = startHeight - exportHeight;
	            var startXOffset = this.getPosition(duration, startTransitionTime, endTransitionTime, widthDifference, startTransitionTime);
	            var endXOffset = this.getPosition(duration, startTransitionTime, endTransitionTime, widthDifference, endTransitionTime);
	            var startYOffset = this.getPosition(duration, startTransitionTime, endTransitionTime, heightDifference, startTransitionTime);
	            var endYOffset = this.getPosition(duration, startTransitionTime, endTransitionTime, heightDifference, endTransitionTime);
	
	            endXOffset = endXOffset + startXOffset;
	            endYOffset = endYOffset + startYOffset;
	
	            switch (transitionType) {
	                case 0:
	                    {
	                        // N-S
	                        startTop = -heightDifference + startYOffset;
	                        endTop = 0 - endYOffset;
	
	                        startLeft = -widthDifference / 2;
	                        endLeft = -widthDifference / 2;
	                        break;
	                    }
	                case 1:
	                    {
	                        // S-N
	                        startTop = 0 - startYOffset;
	                        endTop = -heightDifference + endYOffset;
	
	                        startLeft = -widthDifference / 2;
	                        endLeft = -widthDifference / 2;
	                        break;
	                    }
	                case 2:
	                    {
	                        // E-W
	                        startTop = -heightDifference / 2;
	                        endTop = -heightDifference / 2;
	
	                        startLeft = 0 - startXOffset;
	                        endLeft = -widthDifference + endXOffset;
	                        break;
	                    }
	                case 3:
	                    {
	                        // W-E
	                        startTop = -heightDifference / 2;
	                        endTop = -heightDifference / 2;
	
	                        startLeft = -widthDifference + startXOffset;
	                        endLeft = 0 - endXOffset;
	                        break;
	                    }
	                case 4:
	                    {
	                        // NE-SW
	                        startTop = -heightDifference + startYOffset;
	                        endTop = 0 - endYOffset;
	
	                        startLeft = 0 - startXOffset;
	                        endLeft = -widthDifference + endXOffset;
	                        break;
	                    }
	                case 5:
	                    {
	                        // SW-NE
	                        startTop = 0 - startYOffset;
	                        endTop = -heightDifference + endYOffset;
	
	                        startLeft = -widthDifference + startXOffset;
	                        endLeft = 0 - endXOffset;
	                        break;
	                    }
	                case 6:
	                    {
	                        // NW-SE
	                        startTop = -heightDifference + startYOffset;
	                        endTop = 0 - endYOffset;
	
	                        startLeft = -widthDifference + startXOffset;
	                        endLeft = 0 - endXOffset;
	                        break;
	                    }
	                case 7:
	                    {
	                        // SE-NW
	                        startTop = 0 - startYOffset;
	                        endTop = -heightDifference + endYOffset;
	
	                        startLeft = 0 - startXOffset;
	                        endLeft = -widthDifference + endXOffset;
	                        break;
	                    }
	            }
	
	            return '<filter startWidth="' + startWidth + '" endWidth="' + endWidth + '" startHeight="' + startHeight + '" endHeight="' + endHeight + '" startTop="' + startTop + '" endTop="' + endTop + '" startLeft="' + startLeft + '" endLeft="' + endLeft + '" type="kenBurns"/>';
	        } else {
	            max = 17;
	            transitionType = Math.floor(Math.random() * (max - min + 1)) + min;
	
	            var type = 'scale';
	            var start;
	            var end;
	            var gravity = 'Center';
	
	            if (transitionType % 2 == 0) {
	                // zoom out -- decrease zoom
	                start = scaleFactor + 1 - this.getPosition(duration, startTransitionTime, endTransitionTime, scaleFactor, startTransitionTime);
	                end = scaleFactor + 1 - this.getPosition(duration, startTransitionTime, endTransitionTime, scaleFactor, startTransitionTime + duration);
	            } else {
	                // zoom in -- increase zoom
	                start = 1 + this.getPosition(duration, startTransitionTime, endTransitionTime, scaleFactor, startTransitionTime);
	                end = 1 + this.getPosition(duration, startTransitionTime, endTransitionTime, scaleFactor, startTransitionTime + duration);
	            }
	
	            switch (transitionType) {
	                case 0:
	                case 1:
	                    {
	                        gravity = 'NorthWest';
	                        break;
	                    }
	
	                case 2:
	                case 3:
	                    {
	                        gravity = 'North';
	                        break;
	                    }
	
	                case 4:
	                case 5:
	                    {
	                        gravity = 'NorthEast';
	                        break;
	                    }
	
	                case 6:
	                case 7:
	                    {
	                        gravity = 'West';
	                        break;
	                    }
	
	                case 8:
	                case 9:
	                    {
	                        gravity = 'Center';
	                        break;
	                    }
	
	                case 10:
	                case 11:
	                    {
	                        gravity = 'East';
	                        break;
	                    }
	
	                case 12:
	                case 13:
	                    {
	                        gravity = 'SouthWest';
	                        break;
	                    }
	
	                case 14:
	                case 15:
	                    {
	                        gravity = 'South';
	                        break;
	                    }
	
	                case 16:
	                case 17:
	                    {
	                        gravity = 'SouthEast';
	                        break;
	                    }
	            }
	
	            return '<animation type="' + type + '" startValue="' + start + '" endValue="' + end + '" gravity="' + gravity + '"/>';
	        }
	    },
	    getHtmls: function getHtmls() {
	        var slides = this.slides;
	        var i;
	        var slidesLayers = [];
	        var maxLayers = 0;
	
	        for (i = 0; i < slides.length; i++) {
	            var content = this.getHtmlForSlide(slides[i]);
	
	            if (content.htmls.length > maxLayers) maxLayers = content.htmls.length;
	
	            slidesLayers.push(content);
	        }
	
	        return { content: slidesLayers, maxLayers: maxLayers };
	    },
	    createXML: function createXML() {
	        var data = '<timeline version="1"><layers>';
	        var slides = this.slides;
	        var slide = void 0;
	        var i = void 0;
	        var j = void 0;
	        var hasSlideSounds = false;
	        var hasSlideSoundEffect = false;
	        var hasVideoBackground = false;
	        var totalTime = 0;
	        var isAudioEditor = _PlayController2.default.isAudioEditorAvailable();
	        var duration = void 0;
	        var transitions = [];
	        var useKenBurns = _TransitionsUtils2.default.useKenBurns();
	        var durationMap = this.getDurationMap(slides);
	        var contentForSlides = this.getHtmls();
	        var slidesLayers = contentForSlides.content;
	        var maxLayers = contentForSlides.maxLayers;
	        var htmlsForSlide = void 0;
	        var animationsForSlide = void 0;
	        var animatedShapesFromSlide = void 0;
	        var currentTime = 0;
	
	        for (i = 0; i < slides.length; i++) {
	            duration = durationMap[i].duration;
	            totalTime = totalTime + duration;
	
	            transitions.push(_TransitionsUtils2.default.getTransition());
	        }
	
	        /****************** Animation layers: at least one is default(the main layer with htmls) if there is no animation ************************************************/
	        if (maxLayers > 1) {
	            data = data + '<!-- ********** Animation layers ******* -->';
	
	            for (j = maxLayers - 1; j > 0; j--) {
	                data = data + '<layer>';
	
	                currentTime = 0;
	
	                // for j layer parse all slides and add correct content
	                for (i = 0; i < slides.length; i++) {
	                    slide = slides[i];
	                    var slideDuration = durationMap[i].duration;
	
	                    htmlsForSlide = slidesLayers[i].htmls;
	                    animationsForSlide = slidesLayers[i].animations;
	                    animatedShapesFromSlide = slidesLayers[i].animatedShapes;
	
	                    if (htmlsForSlide.length - 1 >= j) {
	                        // a layer from a slide should be added to the current layer
	                        if (animationsForSlide[j] !== 0) {
	                            var animation = animationsForSlide[j];
	                            var animationPoints = _AnimationManager2.default.getAnimationPoints(animation);
	
	                            for (var k = 0; k < animationPoints.length - 1; k++) {
	                                var slideDurationPerAnimation = animationPoints.length === 2 ? slideDuration : Math.floor(slideDuration / (animationPoints.length - 1));
	                                var currentTimePerAnimation = animationPoints.length > 2 ? currentTime + slideDurationPerAnimation * k : currentTime;
	                                var startAnimation = animationPoints[k];
	                                var endAnimation = animationPoints[k + 1];
	                                var originalShape = animatedShapesFromSlide[j];
	                                var currentHtmlForSlide = k > 0 ? this.getHtmlFromAnimation(originalShape, startAnimation) : htmlsForSlide[j];
	
	                                data = data + '<html begin="' + Math.floor(currentTimePerAnimation) + '" duration="' + slideDurationPerAnimation + '"><![CDATA[' + currentHtmlForSlide + ']]>';
	
	                                var defaultWidth = 1920; // the canvas size is 800x450 and the export view is 1920x1080
	                                var defaultHeight = 1080;
	                                var positionScaleX = defaultWidth / this.CANVAS_WIDTH;
	                                var positionScaleY = positionScaleX; // keep aspect ratio
	
	                                var scaleValueX = endAnimation.width / startAnimation.width;
	                                var scaleValueY = endAnimation.height / startAnimation.height;
	
	                                var offset = this.ANIMATION_SCALE_OFFSET;
	                                var shapeScaleX = startAnimation.width / (800 - 2 * offset);
	                                var shapeScaleY = startAnimation.height / (450 - 2 * offset);
	                                var shapeScale = 1;
	
	                                if (shapeScaleX > 1 || shapeScaleY > 1) shapeScale = Math.max(shapeScaleX, shapeScaleY);else {
	                                    if (originalShape.type === _ShapeConstants2.default.CHARACTER || originalShape.type === _ShapeConstants2.default.IMAGE || originalShape.type === _ShapeConstants2.default.RECTANGLE || originalShape.type === _ShapeConstants2.default.ELLIPSE || originalShape.type === _ShapeConstants2.default.HEART || originalShape.type === _ShapeConstants2.default.STAR || originalShape.type === _ShapeConstants2.default.TRIANGLE) shapeScale = Math.max(shapeScaleX, shapeScaleY);
	                                }
	
	                                var shapeXPosition = (400 - startAnimation.width / shapeScale / 2) * shapeScale;
	                                var shapeYPosition = (225 - startAnimation.height / shapeScale / 2) * shapeScale;
	
	                                //NOTE: - each animated shape is moved to the middle of canvas
	                                //       - the start canvas position is transformed into an image and that image is used for animations
	                                //       - if endWidth is double of startWidth, then the whole image is scaled to the right (the left-top will stay at 0-0)
	                                var startLeftPos = (startAnimation.x - shapeXPosition) * positionScaleX;
	                                var endLeftPos = (endAnimation.x - shapeXPosition * scaleValueX) * positionScaleX;
	
	                                var startTopPos = (startAnimation.y - shapeYPosition) * positionScaleY;
	                                var endTopPos = (endAnimation.y - shapeYPosition * scaleValueY) * positionScaleY;
	
	                                data = data + '<filter startWidth="' + defaultWidth * shapeScale + '" endWidth="' + defaultWidth * shapeScale * scaleValueX + '" startHeight="' + defaultHeight * shapeScale + '" endHeight="' + defaultHeight * shapeScale * scaleValueY + '" startTop="' + startTopPos + '" endTop="' + endTopPos + '" startLeft="' + startLeftPos + '" endLeft="' + endLeftPos + '" type="kenBurns"/>';
	
	                                if (startAnimation.opacity >= 0 && endAnimation.opacity >= 0 && startAnimation.opacity != endAnimation.opacity) {
	                                    data = data + '<opacity>';
	
	                                    data = data + '<entry time="0" value="' + startAnimation.opacity + '"/>';
	                                    data = data + '<entry time="' + slideDurationPerAnimation + '" value="' + endAnimation.opacity + '"/>';
	
	                                    data = data + '</opacity>';
	                                }
	
	                                data = data + '</html>';
	                            }
	                        } else {
	                            data = data + '<html begin="' + Math.floor(currentTime) + '" duration="' + slideDuration + '"><![CDATA[' + htmlsForSlide[j] + ']]>';
	                            data = data + '</html>';
	                        }
	                    } else {
	                        data = data + '<html begin="' + Math.floor(currentTime) + '" duration="' + slideDuration + '"></html>';
	                    }
	
	                    currentTime = currentTime + slideDuration;
	                }
	
	                data = data + '</layer>';
	            }
	        }
	
	        /*************************************************** layer used for video shapes  ************************************/
	        /*** the number of layers should be the maximum video shapes on a slide ************************************/
	        currentTime = 0;
	
	        var maxVideoShapesPerSlide = 0;
	
	        for (i = 0; i < slides.length; i++) {
	            slide = slides[i];
	
	            if (slide.videoShapes && slide.videoShapes.length > 0) {
	                if (slide.videoShapes.length > maxVideoShapesPerSlide) maxVideoShapesPerSlide = slide.videoShapes.length;
	            }
	        }
	
	        if (maxVideoShapesPerSlide > 0) {
	            // there is at least one video shape on a slide
	            data = data + '<!-- ********** Video shapes layers ******* -->';
	
	            for (i = 0; i < maxVideoShapesPerSlide; i++) {
	                currentTime = 0;
	                data = data + '<layer>';
	
	                for (j = 0; j < slides.length; j++) {
	                    slide = slides[j];
	                    duration = durationMap[j].duration;
	
	                    if (slide.videoShapes.length >= i + 1) {
	                        var videoShape = slide.videoShapes[i];
	                        data = data + '<video begin="' + Math.floor(currentTime) + '" duration="' + duration + '" src="' + videoShape.src + '" width="' + Math.floor(videoShape.width) + '" height="' + Math.floor(videoShape.height) + '" left="' + Math.floor(videoShape.left) + '" top="' + Math.floor(videoShape.top) + '" volume="0.5" inPoint="0"/>';
	                    } else data = data + '<html begin="' + Math.floor(currentTime) + '" duration="' + duration + '"/>';
	
	                    if (durationMap[j].addTransition) data = data + '<transition type="' + transitions[j] + '" duration="' + _TransitionsUtils2.default.TRANSITION_DURATION + '"/>';
	
	                    currentTime = currentTime + duration;
	                }
	
	                data = data + '</layer>';
	            }
	        }
	
	        /****************************** layer used for main HTML: background and the rest of inactive elements (no videos, audios or animated shapes) *********************/
	        data = data + '<!-- ********** HTML layer (the Main) ******* -->';
	        data = data + '<layer>';
	        currentTime = 0;
	
	        for (i = 0; i < slides.length; i++) {
	            slide = slides[i];
	
	            htmlsForSlide = slidesLayers[i].htmls;
	            var backgroundHtmlForSlide = htmlsForSlide[0];
	
	            duration = durationMap[i].duration;
	
	            var isVideoBackground = false;
	
	            if (slide.videoBackground && slide.videoBackground != '') isVideoBackground = true;
	
	            if (useKenBurns && !isVideoBackground) {
	                data = data + '<html begin="' + Math.floor(currentTime) + '" duration="' + duration + '"><![CDATA[' + backgroundHtmlForSlide + ']]>';
	                data = data + this.addKenBurns(duration);
	                data = data + '</html>';
	            } else data = data + '<html begin="' + Math.floor(currentTime) + '" duration="' + duration + '"><![CDATA[' + backgroundHtmlForSlide + ']]></html>';
	
	            if (durationMap[i].addTransition) data = data + '<transition type="' + transitions[i] + '" duration="' + _TransitionsUtils2.default.TRANSITION_DURATION + '"/>';
	
	            if (!isAudioEditor) {
	                if (slide.sound && slide.sound != '') hasSlideSounds = true;
	
	                if (slide.soundEffect && slide.soundEffect != '') hasSlideSoundEffect = true;
	            }
	
	            if (isVideoBackground) hasVideoBackground = true;
	
	            currentTime = currentTime + duration;
	        }
	
	        data = data + '</layer>';
	
	        /************************** layer used for videos used as backgrounds ********************************************/
	        currentTime = 0;
	
	        if (hasVideoBackground) {
	            data = data + '<!-- ********** Video backgrounds ******* -->';
	            data = data + '<layer>';
	
	            for (i = 0; i < slides.length; i++) {
	                slide = slides[i];
	                duration = durationMap[i].duration;
	
	                if (slide.videoBackground && slide.videoBackground != '') {
	                    var videoSrc = this.getCorrectUrl(slide.videoBackground);
	
	                    data = data + '<video begin="' + Math.floor(currentTime) + '" duration="' + duration + '" src="' + videoSrc + '" volume="' + slide.videoProperties.volume + '" inPoint="' + slide.videoProperties.inPoint + '"/>';
	                } else data = data + '<html begin="' + Math.floor(currentTime) + '" duration="' + duration + '"/>';
	
	                if (durationMap[i].addTransition) data = data + '<transition type="' + transitions[i] + '" duration="' + _TransitionsUtils2.default.TRANSITION_DURATION + '"/>';
	
	                currentTime = currentTime + duration;
	            }
	
	            data = data + '</layer>';
	        }
	
	        /**********************************************************************/
	
	        if (!isAudioEditor) {
	            // layer used for Slide sounds
	            currentTime = 0;
	
	            if (hasSlideSounds) {
	                data = data + '<layer>';
	
	                for (i = 0; i < slides.length; i++) {
	                    slide = slides[i];
	
	                    if (slide.sound && slide.sound != '') data = data + '<audio duration="' + Math.floor(slide.time * 1000) + '" src="' + this.getCorrectUrl(slide.sound) + '" begin="' + Math.floor(currentTime) + '" volume="' + slide.soundVolume + '"/>';
	
	                    currentTime = currentTime + Math.floor(slide.time * 1000);
	                }
	
	                data = data + '</layer>';
	            }
	
	            // layer used for Slide sound effects
	            currentTime = 0;
	
	            if (hasSlideSoundEffect) {
	                data = data + '<layer>';
	
	                for (i = 0; i < slides.length; i++) {
	                    slide = slides[i];
	
	                    if (slide.soundEffect && slide.soundEffect != '') data = data + '<audio duration="' + Math.floor(slide.time * 1000) + '" src="' + this.getCorrectUrl(slide.soundEffect) + '" begin="' + Math.floor(currentTime) + '" volume="' + slide.soundEffectVolume + '"/>';
	
	                    currentTime = currentTime + Math.floor(slide.time * 1000);
	                }
	
	                data = data + '</layer>';
	            }
	
	            // story sound layer
	            if (this.storySound) {
	                var fadeOutDuration = 4000;
	                var fadeOutEntries = 10;
	                var startFadeOut = totalTime - fadeOutDuration;
	                var entry = fadeOutDuration / fadeOutEntries;
	                var audio = document.getElementById('storySound');
	                var storySoundDuration = 0;
	
	                if (audio) storySoundDuration = Math.floor(audio.duration * 1000);
	
	                data = data + '<layer>';
	
	                if (storySoundDuration > 0 && storySoundDuration < totalTime) {
	                    var repeats = Math.floor(totalTime / storySoundDuration);
	
	                    for (i = 0; i < repeats; i++) {
	                        data = data + '<audio duration="' + storySoundDuration + '" src="' + this.getCorrectUrl(this.storySound.href) + '"/>';
	                    }
	
	                    totalTime = totalTime - repeats * storySoundDuration;
	
	                    if (totalTime <= fadeOutDuration) {
	                        fadeOutDuration = totalTime;
	                        startFadeOut = 0;
	                    } else {
	                        startFadeOut = totalTime - fadeOutDuration;
	                    }
	
	                    entry = fadeOutDuration / fadeOutEntries;
	                }
	
	                data = data + '<audio duration="' + Math.floor(totalTime) + '" src="' + this.getCorrectUrl(this.storySound.href) + '">';
	                data = data + '<volume>';
	                data = data + ('<entry time="' + 0 + '" value="' + this.storySound.volume + '" />');
	
	                if (startFadeOut > 0) data = data + ('<entry time="' + startFadeOut + '" value="' + this.storySound.volume + '" />');
	
	                for (i = 0; i < fadeOutEntries; i++) {
	                    var time = startFadeOut + (i + 1) * entry;
	                    var remainingTime = totalTime - time;
	                    var percent = remainingTime / fadeOutDuration;
	                    var value = this.storySound.volume * percent;
	
	                    data = data + ('<entry time="' + time + '" value="' + value + '" />');
	                }
	
	                data = data + '</volume>';
	                data = data + '</audio>';
	                data = data + '</layer>';
	            }
	        } else {
	            // is audio editor functionality
	            for (i = 0; i < this.timelines.length; i++) {
	                data = data + this.createTimelineLayer(this.timelines[i]);
	            }
	        }
	
	        data = data + '</layers></timeline>';
	
	        console.log(data);
	
	        return data;
	    },
	    createAudioXML: function createAudioXML() {
	        var i;
	        var data = '<timeline version="1"><layers>';
	
	        for (i = 0; i < this.timelines.length; i++) {
	            data = data + this.createTimelineLayer(this.timelines[i]);
	        }
	
	        data = data + '</layers></timeline>';
	
	        console.log(data);
	
	        return data;
	    },
	    createTimelineLayer: function createTimelineLayer(timeline) {
	        if (timeline.audios.length < 1) // no audio on the current timeline
	            return '';
	
	        var data = '<layer>';
	        var audios = timeline.audios;
	        var audio;
	        var timelineVolume = 1;
	        var i;
	
	        if (timeline.volume >= 0) timelineVolume = timeline.volume;
	
	        for (i = 0; i < audios.length; i++) {
	            audio = audios[i];
	
	            if (!audio.inPoint) audio.inPoint = 0;
	
	            if (!audio.outPoint) audio.outPoint = 0;
	
	            if (!audio.left) audio.left = 0;
	
	            if (audio.inPoint > 0) data = data + '<audio duration="' + Math.floor(audio.duration * 1000) + '" src="' + this.getCorrectUrl(audio.href) + '" inPoint="' + Math.floor(audio.inPoint * 1000) + '" begin="' + Math.floor(audio.left * 1000) + '">';else data = data + '<audio duration="' + Math.floor(audio.duration * 1000) + '" src="' + this.getCorrectUrl(audio.href) + '" begin="' + Math.floor(audio.left * 1000) + '">';
	
	            data = data + '<volume>';
	
	            data = data + this.getVolumeEntries(audio, timelineVolume);
	
	            data = data + '</volume>';
	            data = data + '</audio>';
	        }
	
	        data = data + '</layer>';
	
	        return data;
	    },
	    getCorrectVolume: function getCorrectVolume(volume) {
	        return volume.toFixed(2);
	    },
	    getVolumeEntries: function getVolumeEntries(audio, timelineVolume) {
	        var points = audio.points;
	        var data = '';
	        var j;
	        var currentPoint;
	        var pointsMap = [];
	        var newPoints = [];
	
	        if (points) {
	            // check to see if there are duplicates related to time position
	            for (j = 0; j < points.length; j++) {
	                currentPoint = points[j];
	                currentTime = Math.floor(currentPoint.time * 1000);
	
	                if (!pointsMap[currentTime]) {
	                    pointsMap[currentTime] = true;
	                    newPoints.push(currentPoint);
	                }
	            }
	
	            points = newPoints;
	        }
	
	        if (points == undefined || points.length < 2) points = [{ time: 0, vol: 1 }, { time: audio.duration, vol: 1 }];
	
	        if (points.length == 2 && points[0].vol == points[1].vol) {
	            // there are only 2 points with the same volume
	            data = data + ('<entry time="' + Math.floor(points[0].time * 1000) + '" value="' + this.getCorrectVolume(points[0].vol * timelineVolume) + '"/>');
	            data = data + ('<entry time="' + Math.floor(points[1].time * 1000) + '" value="' + this.getCorrectVolume(points[1].vol * timelineVolume) + '"/>');
	
	            return data;
	        }
	
	        var previousTime;
	        var currentTime;
	        var inPoint = 0;
	
	        if (audio.inPoint > 0) inPoint = Math.floor(audio.inPoint * 1000);
	
	        for (j = 0; j < points.length; j++) {
	            currentPoint = points[j];
	            currentTime = Math.floor(currentPoint.time * 1000);
	
	            if (previousTime >= 0 && previousTime == currentTime) {
	                //do nothing
	            } else {
	                data = data + ('<entry time="' + (currentTime - inPoint) + '" value="' + this.getCorrectVolume(currentPoint.vol * timelineVolume) + '"/>');
	                previousTime = currentTime;
	            }
	        }
	
	        return data;
	    },
	    getFadeOutFactor: function getFadeOutFactor(endTime, position) {
	        return 1; // removed fade-out functionality
	
	        var fadeDuration = _PlayController2.default.FADE_LIMIT;
	        var remainingTime = endTime - position;
	
	        if (remainingTime > fadeDuration) return 1;
	
	        return remainingTime / fadeDuration;
	    },
	    checkSlides: function checkSlides(slides) {
	        var slidesMaxPosition = _AudioEditorUtils2.default.getSlidesMaxPosition();
	        var timelineMaxPosition = _AudioEditorUtils2.default.getTimelinesMaxPosition();
	        var duration = timelineMaxPosition - slidesMaxPosition;
	
	        if (duration > 0) {
	            var emptySlide = {};
	            var background = {};
	
	            background.fill = '#ffffff';
	            background.fillOpacity = 1;
	            background.moods = [];
	            background.stroke = '#000000';
	            background.strokeOpacity = 0;
	            background.strokeWidth = 1;
	            background.type = 'Background';
	            background.uuid = '123';
	
	            emptySlide.contentItemId = -1;
	            emptySlide.initialized = true;
	            emptySlide.sound = '';
	            emptySlide.soundEffect = '';
	            emptySlide.soundEffectVolume = 0.5;
	            emptySlide.soundVolume = 0.5;
	            emptySlide.time = duration;
	            emptySlide.uuid = '123';
	            emptySlide.content = [background];
	
	            slides.push(emptySlide);
	        }
	
	        return slides;
	    },
	    createSlideElements: function createSlideElements() {
	        var data = this.getProductionData();
	        var slides = data.slides;
	        var slide;
	        var i;
	        var slideData;
	        var volume;
	        var isAudioEditor = _PlayController2.default.isAudioEditorAvailable();
	
	        if (isAudioEditor) slides = this.checkSlides(slides);
	
	        if (!isAudioEditor && data.storySound) {
	            var storySoundVolume = data.storySoundVolume;
	
	            if (!storySoundVolume) storySoundVolume = 0.5;
	
	            this.storySound = { href: data.storySound.href, volume: storySoundVolume };
	        }
	
	        for (i = 0; i < slides.length; i++) {
	            slide = slides[i];
	
	            slideData = {};
	
	            slideData.time = slide.time;
	            slideData.svg = this.createSVG(slide.content);
	            slideData.videoBackground = this.getBackgroundVideoFromSlide(slide);
	            slideData.videoProperties = this.getVideoProperties(slide);
	            slideData.fonts = this.getFontsFromSlide(slide.content);
	            slideData.videoShapes = this.getVideoShapesFromSlide(slide.content);
	
	            if (!isAudioEditor) {
	                slideData.sound = slide.sound;
	                slideData.soundEffect = slide.soundEffect;
	
	                // set sound volume
	                volume = slide.soundVolume;
	
	                if (!volume) volume = 0.5;
	
	                slideData.soundVolume = volume;
	
	                // set sound effect volume
	                volume = slide.soundEffectVolume;
	
	                if (!volume) volume = 0.5;
	
	                slideData.soundEffectVolume = volume;
	            }
	
	            this.slides.push(slideData);
	        }
	
	        if (isAudioEditor) this.timelines = data.audioEditor.timelines;
	    },
	
	
	    /*************************************************** Loading video stuff **********************************/
	    wrongVideos: [],
	    ensureIsOriginalVideo: function ensureIsOriginalVideo(url) {
	        if (url.indexOf('proxy') > 0) {
	            url = url.replace('proxy', 'original');
	        }
	
	        return url;
	    },
	    extractVideoId: function extractVideoId(link) {
	        var id;
	
	        if (!link) return id;
	
	        var index = link.indexOf('file/ci/');
	        var index2 = link.indexOf('/aaa');
	
	        if (index > 0 && index2 > 0) id = link.substring(index + 8, index2);
	
	        return id;
	    },
	    getHostName: function getHostName() {
	        if (_Configuration2.default.IS_PROD()) return 'https://www.creaza.com';else return 'https://stage.creaza.com';
	    },
	    getCorrectUrl: function getCorrectUrl(url) {
	        var securityCode = 'security_token_placeholder';
	        var newUrl = '';
	
	        if (url && url.indexOf('file/ci') != -1) {
	            if (url.indexOf('www.creaza') == -1 && url.indexOf('stage.creaza') == -1) newUrl = this.getHostName();
	
	            newUrl = newUrl + url;
	
	            if (url.indexOf('cacheBreaker') != -1) newUrl = newUrl + '&' + securityCode;else newUrl = newUrl + '?' + securityCode;
	        } else {
	            newUrl = url;
	        }
	
	        return newUrl;
	    },
	    getBackgroundVideoFromSlide: function getBackgroundVideoFromSlide(slide) {
	        var background = slide.content[0];
	
	        if (background.isVideo) {
	            var link = background.xlinkHref;
	            var id = this.extractVideoId(link);
	
	            if (id && this.videoIds.indexOf(id) < 0) this.videoIds.push(id);
	
	            return this.ensureIsOriginalVideo(link);
	        } else return '';
	    },
	    getVideoProperties: function getVideoProperties(slide) {
	        var properties = {};
	        var background = slide.content[0];
	
	        properties.volume = 0.5;
	
	        if (background.volume >= 0) properties.volume = background.volume;
	
	        properties.inPoint = 0;
	
	        if (background.inPoint) properties.inPoint = Math.floor(background.inPoint * 1000);
	
	        return properties;
	    },
	    getCorrectVideoShapeUrl: function getCorrectVideoShapeUrl(link) {
	        if (link && link.length > 0) {
	            var id = this.extractVideoId(link);
	
	            if (id && this.videoIds.indexOf(id) < 0) this.videoIds.push(id);
	
	            return this.getCorrectUrl(this.ensureIsOriginalVideo(link));
	        } else return '';
	    },
	    getVideoShapesFromSlide: function getVideoShapesFromSlide(shapes) {
	        var shape = void 0;
	        var videoShapes = [];
	        var scale = 1920 / _Configuration2.default.CANVAS_WIDTH; // 1920x1080 is the standard layer size while 800x450 is the Cartoonist canvas size
	
	        for (var i = 0; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.type == _ShapeConstants2.default.VIDEO) {
	                var videoElement = {};
	
	                videoElement.src = this.getCorrectVideoShapeUrl(shape.xlinkHref);
	                videoElement.width = shape.width * scale;
	                videoElement.height = shape.height * scale;
	                videoElement.left = shape.x * scale;
	                videoElement.top = shape.y * scale;
	
	                //TODO: add inPoint and volume like for "getVideoProperties" when will introduce videoEditor for video shapes
	
	                videoShapes.push(videoElement);
	            }
	        }
	
	        return videoShapes;
	    },
	    createVideoMap: function createVideoMap(data) {
	        // get a pair for each video between proxy and original videos
	        var array = data.mappings;
	        var i = void 0;
	
	        for (i = 0; i < array.length; i++) {
	            if (array[i].id) this.videoMap[array[i].id] = array[i].sourceFileId; // map[proxy] = original
	        }
	
	        // do a check to see if all the videos has pair (proxy-original) ... in case original is missing then use the proxy
	        for (i = 0; i < this.videoIds.length; i++) {
	            var proxyId = parseInt(this.videoIds[i]);
	
	            if (!this.videoMap[proxyId]) this.videoMap[proxyId] = proxyId;
	        }
	
	        this.loadOriginalVideos();
	    },
	    loadOriginalVideos: function loadOriginalVideos() {
	        var key;
	        var video;
	        var index = 0;
	        var videoLength = 0;
	
	        this.wrongVideos = [];
	
	        for (key in this.videoMap) {
	            video = document.createElement('video');
	            videoLength = videoLength + 1;
	
	            video.addEventListener('durationchange', function () {
	                index = index + 1;
	
	                if (index == videoLength) this.allVideosLoaded();
	            }.bind(this));
	
	            video.addEventListener('error', function (e) {
	                var id = this.extractVideoId(e.currentTarget.currentSrc);
	
	                if (id && id.length > 0) this.wrongVideos[id] = true;
	
	                index = index + 1;
	
	                if (index == videoLength) this.allVideosLoaded();
	            }.bind(this));
	
	            video.src = this.getHostName() + '/file/ci/' + this.videoMap[key] + '/aaa' + _VideoUtils2.default.cacheBreaker;
	            video.load();
	        }
	    },
	    allVideosLoaded: function allVideosLoaded() {
	        this.useOriginalLinksForVideos();
	    },
	    useOriginalLinksForVideos: function useOriginalLinksForVideos() {
	        var i = void 0;
	        var videoLink = void 0;
	        var id = void 0;
	        var originalId = void 0;
	        var videoShapes = void 0;
	
	        for (i = 0; i < this.slides.length; i++) {
	            videoLink = this.slides[i].videoBackground;
	
	            if (videoLink && videoLink.length > 0) {
	                id = this.extractVideoId(videoLink);
	
	                if (id && this.videoMap[id]) {
	                    originalId = this.videoMap[id];
	
	                    if (!this.wrongVideos[originalId]) this.slides[i].videoBackground = videoLink.replace(id, originalId);
	                } else {
	                    if (videoLink.indexOf('proxy') > 0) {
	                        this.slides[i].videoBackground = videoLink.replace('proxy', 'original');
	                    }
	                }
	            }
	
	            videoShapes = this.slides[i].videoShapes;
	
	            for (var j = 0; j < videoShapes.length; j++) {
	                videoLink = videoShapes[j].src;
	
	                if (videoLink && videoLink.length > 0) {
	                    id = this.extractVideoId(videoLink);
	
	                    if (id && this.videoMap[id]) {
	                        originalId = this.videoMap[id];
	
	                        if (!this.wrongVideos[originalId]) videoShapes[j].src = videoLink.replace(id, originalId);
	                    } else {
	                        if (videoLink.indexOf('proxy') > 0) {
	                            videoShapes[j].src = videoLink.replace('proxy', 'original');
	                        }
	                    }
	                }
	            }
	        }
	
	        this.export();
	    },
	    getProductionData: function getProductionData() {
	        var state = _StoreManager2.default.getState();
	        var production = state.production;
	        var title = _AppParameters2.default.title;
	        var data = {};
	
	        data.storySound = production.storySound;
	        data.storySoundVolume = production.storySoundVolume;
	        data.title = title;
	        data.slides = production.slides;
	        data.audioEditor = state.audioEditor;
	
	        return data;
	    },
	    getTimelines: function getTimelines() {
	        var state = _StoreManager2.default.getState();
	        this.timelines = state.audioEditor.timelines;
	    },
	    getFontsMap: function getFontsMap() {
	        var map = [];
	
	        map['AlfaSlabOne'] = 'AlfaSlabOneRegular';
	        map['Anton'] = 'AntonRegular';
	        map['ArchitectsDaughter'] = 'ArchitectsDaughter';
	        map['Bangers'] = 'BangersRegular';
	        map['BungeeShade'] = 'BungeeShadeRegular';
	        map['Cabin'] = 'CabinRegular';
	        map['CabinMedium'] = 'CabinMedium';
	        map['CaveatBrush'] = 'CaveatBrushRegular';
	        map['Creepster'] = 'CreepsterRegular';
	        map['Pangolin'] = 'PangolinRegular';
	        map['Peralta'] = 'PeraltaRegular';
	        map['PermanentMarker'] = 'PermanentMarker';
	        map['Raleway'] = 'RalewayRegular';
	        map['RalewayBlack'] = 'RalewayBlack';
	        map['RalewayThin'] = 'RalewayThin';
	        map['Shrikhand'] = 'ShrikhandRegular';
	        map['Sniglet'] = 'SnigletRegular';
	        map['SnigletExtra'] = 'SnigletExtraBold';
	        map['Sriracha'] = 'SrirachaRegular';
	
	        return map;
	    },
	    getHtmlForSlide: function getHtmlForSlide(slide) {
	        var fontsMap = this.getFontsMap();
	        var data = '<html>';
	        var i;
	        var htmls = [];
	        var fontUrl = 'https://creaza-cartoonist-svg.s3.amazonaws.com/cartoonist/fonts/';
	
	        data = data + '<head><meta charset="UTF-8">';
	
	        if (slide.fonts.length > 0) {
	            for (i = 0; i < slide.fonts.length; i++) {
	                if (slide.fonts[i] == 'Arial') {
	                    data = data + '<style> @font-face { font-family: Cabin;src: url(' + fontUrl + 'CabinRegular.ttf);}</style>';
	                } else data = data + '<style> @font-face { font-family: ' + slide.fonts[i] + ';src: url(' + fontUrl + fontsMap[slide.fonts[i]] + '.ttf);}</style>';
	            }
	        }
	
	        data = data + '</head>';
	
	        var svgs = slide.svg.svgs;
	
	        for (i = 0; i < svgs.length; i++) {
	            htmls.push(data + '<body><div>' + svgs[i] + '</div></body></html>');
	        }
	
	        return { htmls: htmls, animations: slide.svg.animations, animatedShapes: slide.svg.animatedShapes };
	    },
	    getFontsFromSlide: function getFontsFromSlide(shapes) {
	        var currentFonts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
	        var shape;
	        var i;
	        var fonts;
	        var fontsMap = this.getFontsMap();
	
	        if (currentFonts) fonts = currentFonts;else fonts = [];
	
	        for (i = 0; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.type == _ShapeConstants2.default.TEXTBOX || shape.type == _ShapeConstants2.default.TEXTBOXSIMPLE || shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                if (shape.isRichText) {
	                    var htmlText = _TextSizeUtils2.default.getHtmlText(shape);
	
	                    for (var key in fontsMap) {
	                        if (htmlText.indexOf(key) != -1) {
	                            if (fonts.indexOf(key) == -1) fonts.push(key);
	                        }
	                    }
	                } else {
	                    if (fonts.indexOf(shape.fontFamily) == -1) fonts.push(shape.fontFamily);
	                }
	            }
	
	            if (shape.type == _ShapeConstants2.default.GROUP) fonts = this.getFontsFromSlide(shape.shapes, fonts);
	        }
	
	        return fonts;
	    },
	
	
	    /******************************* Used for point to point animation *************************************/
	
	    getShapeAsStartAnimation: function getShapeAsStartAnimation(shape, startAnimation) {
	        if (startAnimation.x) shape.x = startAnimation.x;
	
	        if (startAnimation.y) shape.y = startAnimation.y;
	
	        if (startAnimation.width) shape.width = startAnimation.width;
	
	        if (startAnimation.height) shape.height = startAnimation.height;
	
	        if (startAnimation.fontSize) shape.fontSize = startAnimation.fontSize;
	
	        if (startAnimation.opacity) shape.opacity = startAnimation.opacity;
	
	        if (startAnimation.rotation) shape.rotation = startAnimation.rotation;
	
	        if (startAnimation.x1) shape.x1 = startAnimation.x1;
	
	        if (startAnimation.y1) shape.y1 = startAnimation.y1;
	
	        if (startAnimation.x2) shape.x2 = startAnimation.x2;
	
	        if (startAnimation.y2) shape.y2 = startAnimation.y2;
	
	        if (startAnimation.cx) shape.cx = startAnimation.cx;
	
	        if (startAnimation.cy) shape.cy = startAnimation.cy;
	
	        if (startAnimation.cx1) shape.cx1 = startAnimation.cx1;
	
	        if (startAnimation.cy1) shape.cy1 = startAnimation.cy1;
	
	        if (startAnimation.cx2) shape.cx2 = startAnimation.cx2;
	
	        if (startAnimation.cy2) shape.cy2 = startAnimation.cy2;
	
	        if (startAnimation.cx3) shape.cx3 = startAnimation.cx3;
	
	        if (startAnimation.cy3) shape.cy3 = startAnimation.cy3;
	
	        if (startAnimation.cx4) shape.cx4 = startAnimation.cx4;
	
	        if (startAnimation.cy4) shape.cy4 = startAnimation.cy4;
	
	        if (startAnimation.cx5) shape.cx5 = startAnimation.cx5;
	
	        if (startAnimation.cy5) shape.cy5 = startAnimation.cy5;
	
	        return shape;
	    },
	    getHtmlFromAnimation: function getHtmlFromAnimation(originalShape, startAnimation) {
	        var newShape = Object.assign({}, originalShape);
	
	        newShape = this.getShapeAsStartAnimation(newShape, startAnimation);
	
	        return this.getHtmlFromSingleShape(newShape);
	    },
	    getHtmlFromSingleShape: function getHtmlFromSingleShape(shape) {
	        var htmlData = '';
	
	        switch (shape.type) {
	            case _ShapeConstants2.default.CHARACTER:
	                {
	                    htmlData = htmlData + this.visitCharacter(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.IMAGE:
	                {
	                    htmlData = htmlData + this.visitImage(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.RECTANGLE:
	                {
	                    htmlData = htmlData + this.visitRectangle(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.TRIANGLE:
	                {
	                    htmlData = htmlData + this.visitTriangle(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.STAR:
	                {
	                    htmlData = htmlData + this.visitStar(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.HEART:
	                {
	                    htmlData = htmlData + this.visitHeart(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.ELLIPSE:
	                {
	                    htmlData = htmlData + this.visitEllipse(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.LINE:
	                {
	                    htmlData = htmlData + this.visitLine(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.CURVE:
	                {
	                    htmlData = htmlData + this.visitCurve(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.FREEHAND:
	                {
	                    htmlData = htmlData + this.visitFreehand(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.TEXTBOX:
	                {
	                    htmlData = htmlData + this.visitTextbox(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.TEXTBOXSIMPLE:
	                {
	                    htmlData = htmlData + this.visitTextboxSimple(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.SPEAK_BUBBLE:
	                {
	                    htmlData = htmlData + this.visitSpeakBubble(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE:
	                {
	                    htmlData = htmlData + this.visitComplexSpeakBubble(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.THOUGHT_BUBBLE:
	                {
	                    htmlData = htmlData + this.visitThoughtBubble(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.SCREAM_BUBBLE:
	                {
	                    htmlData = htmlData + this.visitScreamBubble(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.VIDEO:
	                {
	                    htmlData = htmlData + this.visitVideo(shape);
	                    break;
	                }
	            case _ShapeConstants2.default.GROUP:
	                {
	                    htmlData = htmlData + this.visitGroup(shape);
	                    break;
	                }
	        }
	
	        var viewBox = '0 0 ' + this.CANVAS_WIDTH + ' ' + this.CANVAS_HEIGHT;
	        var devs = '';
	
	        if (htmlData.indexOf('url(#') != -1) devs = '<defs><filter id="2" width="150%" height="150%"><feOffset result="offOut" in="SourceAlpha" dx="4" dy="4"/><feGaussianBlur result="blurOut" in="offOut" stdDeviation="4"/><feBlend in="SourceGraphic" in2="blurOut" mode="normal"/></filter><filter id="5" filterUnits="objectBoundingBox" x="0%" y="0%" width="100%" height="100%"><feColorMatrix values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  1 1 1 1 0"/></filter></defs>';
	
	        var svg = '<svg style="position:fixed; top:0; left:0; height:100%; width:100%" width="' + this.CANVAS_WIDTH + '" height="' + this.CANVAS_HEIGHT + '" viewBox="' + viewBox + '">' + devs + htmlData + '</svg>';
	
	        var data = '<html>';
	        var fontsMap = this.getFontsMap();
	        var i = void 0;
	        var fontUrl = 'https://creaza-cartoonist-svg.s3.amazonaws.com/cartoonist/fonts/';
	        var fonts = this.getFontsFromSlide([shape]);
	
	        data = data + '<head><meta charset="UTF-8">';
	
	        if (fonts.length > 0) {
	            for (i = 0; i < fonts.length; i++) {
	                if (fonts[i] == 'Arial') {
	                    data = data + '<style> @font-face { font-family: Cabin;src: url(' + fontUrl + 'CabinRegular.ttf);}</style>';
	                } else data = data + '<style> @font-face { font-family: ' + fonts[i] + ';src: url(' + fontUrl + fontsMap[fonts[i]] + '.ttf);}</style>';
	            }
	        }
	
	        data = data + '</head>';
	        data = data + '<body><div>' + svg + '</div></body></html>';
	
	        return data;
	    },
	
	
	    /********************************************************************/
	
	    getHtmlFromShapes: function getHtmlFromShapes(shapes) {
	        var isGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var shape;
	        var i;
	        var htmlData = '';
	        var layers = [];
	        var animations = [];
	        var animatedShapes = [];
	
	        for (i = 0; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (isGroup) // for the shapes inside of a group, the animations should not be considered
	                shape.animation = undefined;
	
	            switch (shape.type) {
	                case _ShapeConstants2.default.BACKGROUND:
	                    {
	                        htmlData = htmlData + this.visitBackground(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.CHARACTER:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitCharacter(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitCharacter(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.IMAGE:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitImage(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitImage(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.RECTANGLE:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitRectangle(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitRectangle(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.TRIANGLE:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitTriangle(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitTriangle(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.STAR:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitStar(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitStar(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.HEART:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitHeart(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitHeart(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.ELLIPSE:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitEllipse(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitEllipse(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.LINE:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitLine(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitLine(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.CURVE:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitCurve(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitCurve(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.FREEHAND:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitFreehand(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitFreehand(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.TEXTBOX:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitTextbox(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitTextbox(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.TEXTBOXSIMPLE:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitTextboxSimple(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitTextboxSimple(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.SPEAK_BUBBLE:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitSpeakBubble(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitSpeakBubble(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitComplexSpeakBubble(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitComplexSpeakBubble(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.THOUGHT_BUBBLE:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitThoughtBubble(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitThoughtBubble(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.SCREAM_BUBBLE:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitScreamBubble(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitScreamBubble(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.VIDEO:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitVideo(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitVideo(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.GROUP:
	                    {
	                        if (shape.animation) {
	                            if (htmlData.length > 0) {
	                                layers.push(htmlData);
	                                animations.push(0);
	                                animatedShapes.push(0);
	                            }
	
	                            htmlData = '' + this.visitGroup(shape);
	
	                            layers.push(htmlData);
	                            animations.push(shape.animation);
	                            animatedShapes.push(shape);
	                            htmlData = '';
	                        } else htmlData = htmlData + this.visitGroup(shape);
	                        break;
	                    }
	            }
	        }
	
	        if (htmlData.length > 0) {
	            layers.push(htmlData);
	            animations.push(0);
	            animatedShapes.push(0);
	        }
	
	        return { layers: layers, animations: animations, animatedShapes: animatedShapes };
	    },
	    createSVG: function createSVG(shapes) {
	        var htmlData = this.getHtmlFromShapes(shapes);
	        var layers = htmlData.layers;
	        var svgs = [];
	        var i;
	        var viewBox = '0 0 ' + this.CANVAS_WIDTH + ' ' + this.CANVAS_HEIGHT;
	        var devs = '';
	
	        for (i = 0; i < layers.length; i++) {
	            if (layers[i] && layers[i].indexOf('url(#') != -1) {
	                devs = '<defs><filter id="2" width="150%" height="150%"><feOffset result="offOut" in="SourceAlpha" dx="4" dy="4"/><feGaussianBlur result="blurOut" in="offOut" stdDeviation="4"/><feBlend in="SourceGraphic" in2="blurOut" mode="normal"/></filter><filter id="5" filterUnits="objectBoundingBox" x="0%" y="0%" width="100%" height="100%"><feColorMatrix values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  1 1 1 1 0"/></filter></defs>';
	                break;
	            }
	        }
	
	        for (i = 0; i < layers.length; i++) {
	            svgs.push('<svg style="position:fixed; top:0; left:0; height:100%; width:100%" width="' + this.CANVAS_WIDTH + '" height="' + this.CANVAS_HEIGHT + '" viewBox="' + viewBox + '">' + devs + layers[i] + '</svg>');
	        }
	
	        return { svgs: svgs, animations: htmlData.animations, animatedShapes: htmlData.animatedShapes };
	    },
	    getImageBoundingBox: function getImageBoundingBox(shapeModel) {
	        var imageBoundingBox = { x: 0, y: 0, width: this.CANVAS_WIDTH, height: this.CANVAS_HEIGHT };
	
	        if (shapeModel.orgWidth > 0 && shapeModel.orgWidth != this.CANVAS_WIDTH || shapeModel.orgHeight > 0 && shapeModel.orgHeight != this.CANVAS_HEIGHT) {
	            var scaleX = this.CANVAS_WIDTH / shapeModel.orgWidth;
	            var scaleY = this.CANVAS_HEIGHT / shapeModel.orgHeight;
	
	            if (scaleX < scaleY) {
	                imageBoundingBox.y = this.CANVAS_HEIGHT / 2 - scaleX * shapeModel.orgHeight / 2;
	                imageBoundingBox.height = scaleX * shapeModel.orgHeight;
	            } else {
	                imageBoundingBox.x = this.CANVAS_WIDTH / 2 - scaleY * shapeModel.orgWidth / 2;
	                imageBoundingBox.width = scaleY * shapeModel.orgWidth;
	            }
	        }
	
	        return imageBoundingBox;
	    },
	    getImagePosition: function getImagePosition(shapeModel) {
	        var hotspot = shapeModel.hotSpot;
	        var boundingBox = this.getImageBoundingBox(shapeModel);
	        var position = {};
	
	        if (hotspot == undefined || hotspot == '') {
	            position.x = boundingBox.x;
	            position.y = boundingBox.y;
	            position.width = boundingBox.width;
	            position.height = boundingBox.height;
	        } else {
	            var scale;
	
	            if (shapeModel.orgWidth > 0 && shapeModel.orgWidth != this.CANVAS_WIDTH || shapeModel.orgHeight > 0 && shapeModel.orgHeight != this.CANVAS_HEIGHT) {
	                scale = this.CANVAS_WIDTH / hotspot.width;
	
	                position.width = boundingBox.width * scale;
	                position.height = boundingBox.height * scale;
	
	                position.x = -hotspot.x * scale + boundingBox.x * scale;
	                position.y = -hotspot.y * scale + boundingBox.y * scale;
	            } else {
	                scale = this.CANVAS_WIDTH / hotspot.width;
	
	                position.width = this.CANVAS_WIDTH * scale;
	                position.height = position.width * 9 / 16;
	
	                position.x = -hotspot.x * scale;
	                position.y = -hotspot.y * scale;
	            }
	        }
	
	        position.x = position.x.toFixed(2);
	        position.y = position.y.toFixed(2);
	        position.width = position.width.toFixed(2);
	        position.height = position.height.toFixed(2);
	
	        return position;
	    },
	    basicShape: function basicShape(shapeModel) {
	        var rotation = shapeModel.rotation;
	        var data = void 0;
	
	        if (rotation == undefined) rotation = 0;
	
	        var rotateTransform = 'rotate(' + rotation + ' ' + shapeModel.width / 2 + ' ' + shapeModel.height / 2 + ')';
	        var flipTransform = '';
	
	        if (shapeModel.horizontalFlip && shapeModel.verticalFlip) {
	            var flipTranslateX = shapeModel.horizontalFlip < 0 ? -shapeModel.width : 0;
	            var flipTranslateY = shapeModel.verticalFlip < 0 ? -shapeModel.height : 0;
	            flipTransform = 'scale(' + shapeModel.horizontalFlip + ' ' + shapeModel.verticalFlip + ') translate(' + flipTranslateX + ' ' + flipTranslateY + ')';
	        }
	
	        data = '<g transform="translate(' + shapeModel.x + ' ' + shapeModel.y + ')">';
	
	        if (shapeModel.animation) {
	            var offset = this.ANIMATION_SCALE_OFFSET;
	            var scaleX = (800 - 2 * offset) / shapeModel.width;
	            var scaleY = (450 - 2 * offset) / shapeModel.height;
	            var scale = 1;
	
	            // for the animation, the shape is moved in the middle of canvas but with a scale to fit maximum possible inside of canvas area [800-10 (scale offset) / 450-10 (scale offset)]
	            // during the animation we apply the opposite scale to fit into the startWidth/startHeight position
	            if (scaleX < 1 || scaleY < 1) scale = Math.min(scaleX, scaleY);else {
	                if (shapeModel.type === _ShapeConstants2.default.CHARACTER || shapeModel.type === _ShapeConstants2.default.IMAGE || shapeModel.type === _ShapeConstants2.default.RECTANGLE || shapeModel.type === _ShapeConstants2.default.ELLIPSE || shapeModel.type === _ShapeConstants2.default.HEART || shapeModel.type === _ShapeConstants2.default.STAR || shapeModel.type === _ShapeConstants2.default.TRIANGLE) scale = Math.min(scaleX, scaleY);
	            }
	
	            if (this.testLocalAnimation) {
	                data = '<g id="background" x="0.00" y="0.00" width="800" height="450"><rect x="0.00" y="0.00" width="800" height="450" fill="#ffc600" fill-opacity="1"></rect><image x="0.00" y="0.00" width="800.00" height="450.00" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="undefined" preserveAspectRatio="none" opacity="1"></image><rect x="0" y="0" width="800" height="450" fill="none" stroke="#000000" stroke-width="2" stroke-opacity="0"></rect></g>';
	
	                data = data + ('<g transform="translate(' + (400 - shapeModel.width * scale / 2) + ' ' + (225 - shapeModel.height * scale / 2) + ') scale(' + scale + ' ' + scale + ')">');
	            } else data = '<g transform="translate(' + (400 - shapeModel.width * scale / 2) + ' ' + (225 - shapeModel.height * scale / 2) + ') scale(' + scale + ' ' + scale + ')">';
	        }
	
	        data = data + ('<g transform="' + rotateTransform + '">');
	        data = data + ('<g transform="' + flipTransform + '">');
	
	        return data;
	    },
	    visitBackground: function visitBackground(shapeModel) {
	        var canvasWidth = this.CANVAS_WIDTH;
	        var canvasHeight = this.CANVAS_HEIGHT;
	        var position = this.getImagePosition(shapeModel);
	        var fillValue = shapeModel.fill;
	
	        if (shapeModel.isVideo) fillValue = 'none';
	
	        var data = '<g id="background" x="0.00" y="0.00" width="' + canvasWidth + '" height="' + canvasHeight + '"><rect x="0.00" y="0.00" width="' + canvasWidth + '" height="' + canvasHeight + '" fill="' + fillValue + '" fill-opacity="' + shapeModel.fillOpacity + '"></rect><image x="' + position.x + '" y="' + position.y + '" width="' + position.width + '" height="' + position.height + '" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + this.getCorrectUrl(shapeModel.xlinkHref) + '" preserveAspectRatio="none" opacity="' + shapeModel.opacity + '"></image><rect x="0" y="0" width="' + canvasWidth + '" height="' + canvasHeight + '" fill="none" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth * 2 + '" stroke-opacity="' + shapeModel.strokeOpacity + '"></rect></g>';
	
	        return data;
	    },
	    visitCharacter: function visitCharacter(shapeModel) {
	        var clipPathObject;
	        var realWidth = shapeModel.width;
	        var realHeight = shapeModel.height;
	        var newShapeModel = shapeModel;
	        var x1 = 0;
	        var y1 = 0;
	        var clipId = 'hotSpot_' + shapeModel.uuid;
	        var clipPath = 'url(#' + clipId + ')';
	
	        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
	            realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
	            realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);
	
	            x1 = realWidth * shapeModel.hotSpot.x1 / 100;
	            y1 = realHeight * shapeModel.hotSpot.y1 / 100;
	            var x2 = realWidth * shapeModel.hotSpot.x2 / 100;
	            var y2 = realHeight * shapeModel.hotSpot.y2 / 100;
	
	            clipPathObject = '<clipPath id="' + clipId + '"> <rect x="' + x1 + '" y="' + y1 + '" width="' + (x2 - x1) + '" height="' + (y2 - y1) + '"></rect></clipPath>';
	        }
	
	        var filterName;
	        var filter;
	        var filterUrl;
	
	        if (newShapeModel.backgroundVisible == false || newShapeModel.fillOpacity == 0) {
	            // the filter shouldn't be visible
	        } else {
	            filterName = 'f_' + newShapeModel.uuid;
	            filterUrl = 'url(#' + filterName + ')';
	
	            filter = '<filter id="' + filterName + '"><feColorMatrix type=\'matrix\' values="' + _ColorUtils2.default.hexToMatrix(newShapeModel.fill) + '"/></filter>';
	        }
	
	        var data = this.basicShape(newShapeModel);
	
	        var opacityValue = newShapeModel.opacity;
	
	        if (newShapeModel.animation && newShapeModel.animation.start_opacity >= 0 && newShapeModel.animation.end_opacity >= 0 && newShapeModel.animation.start_opacity != newShapeModel.animation.end_opacity) opacityValue = 1;
	
	        data = data + ('<g x="0" y="0" opacity="' + opacityValue + '">');
	
	        if (filter) {
	            data = data + filter;
	            data = data + ('<g filter="' + filterUrl + '">');
	        }
	
	        if (clipPathObject) {
	            data = data + clipPathObject;
	            data = data + ('<g transform="translate(' + -x1 + ' ' + -y1 + ')">');
	            data = data + ('<image x="' + 0 + '" y="' + 0 + '" width="' + realWidth + '" height="' + realHeight + '" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + this.getCorrectUrl(newShapeModel.xlinkHref) + '" filter="' + newShapeModel.filter + '" preserveAspectRatio=\'none\' clip-path="' + clipPath + '"/>');
	            data = data + '</g>';
	        } else data = data + ('<image x="' + 0 + '" y="' + 0 + '" width="' + newShapeModel.width + '" height="' + newShapeModel.height + '" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + this.getCorrectUrl(newShapeModel.xlinkHref) + '" filter="' + newShapeModel.filter + '" preserveAspectRatio=\'none\' />');
	
	        data = data + ('<rect x="' + 0 + '" y="' + 0 + '" width="' + newShapeModel.width + '" height="' + newShapeModel.height + '" fill="none" stroke="' + newShapeModel.stroke + '" stroke-width="' + newShapeModel.strokeWidth + '" stroke-opacity="' + newShapeModel.strokeOpacity + '" />');
	
	        data = data + '</g></g></g></g>';
	
	        if (filter) data = data + '</g>';
	
	        return data;
	    },
	    visitImage: function visitImage(shapeModel) {
	        return this.visitCharacter(shapeModel);
	    },
	    visitRectangle: function visitRectangle(shapeModel) {
	        var data = this.basicShape(shapeModel);
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        data = data + ('<rect x="' + 0 + '" y="' + 0 + '" width="' + shapeModel.width + '" height="' + shapeModel.height + '" filter="' + shapeModel.filter + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" opacity="' + opacityValue + '" />');
	        data = data + '</g></g></g>';
	
	        return data;
	    },
	    visitTriangle: function visitTriangle(shapeModel) {
	        var data = this.basicShape(shapeModel);
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        var path = 'M' + shapeModel.width / 2 + ' 0 L' + shapeModel.width + ' ' + shapeModel.height + ' L0 ' + shapeModel.height + ' Z';
	
	        data = data + ('<g x="0" y="0" opacity="' + opacityValue + '">');
	        data = data + ('<path d="' + path + '" filter="' + shapeModel.filter + '" opacity="' + opacityValue + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	
	        data = data + '</g></g></g></g>';
	
	        return data;
	    },
	    visitStar: function visitStar(shapeModel) {
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        var points = _DrawingUtils2.default.calculateStarPoints(shapeModel);
	        var path = 'M' + points[0].x + ' ' + points[0].y + ' ';
	
	        var i;
	        for (i = 1; i < points.length; i++) {
	            path = path + 'L' + points[i].x + ' ' + points[i].y + ' ';
	        }
	
	        path = path + ' Z';
	
	        var data = this.basicShape(shapeModel);
	        data = data + ('<g x="0" y="0" opacity="' + opacityValue + '">');
	
	        data = data + ('<path d="' + path + '" filter="' + shapeModel.filter + '" opacity="' + opacityValue + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	
	        data = data + '</g></g></g></g>';
	
	        return data;
	    },
	    getHeartPath: function getHeartPath(shapeModel) {
	        var separator = ',';
	        var bottomXOffset = shapeModel.width / 20;
	        var bottomYOffset = shapeModel.height / 20;
	
	        var path = 'M' + (shapeModel.width / 2 + bottomXOffset) + separator + (shapeModel.height - bottomYOffset);
	
	        path = path + 'Q' + shapeModel.width / 2 + separator + shapeModel.height + separator + (shapeModel.width / 2 - bottomXOffset) + separator + (shapeModel.height - bottomYOffset);
	
	        var horizontalOffset = shapeModel.width / 10;
	        var verticalOffset = shapeModel.height / 2;
	
	        path = path + 'L' + horizontalOffset + separator + verticalOffset;
	
	        var rx = shapeModel.width / 6;
	        var ry = shapeModel.height / 6;
	        var xAxisRotation = 1;
	        var largeArcFlag = 0;
	        var sweepFlag = 1;
	        var endX = shapeModel.width / 2;
	        var endY = shapeModel.height / 8;
	
	        path = path + 'A' + rx + ',' + ry + ',' + xAxisRotation + ',' + largeArcFlag + ',' + sweepFlag + ',' + endX + ',' + endY;
	
	        endX = shapeModel.width - horizontalOffset;
	        endY = verticalOffset;
	
	        path = path + 'A' + rx + ',' + ry + ',' + xAxisRotation + ',' + largeArcFlag + ',' + sweepFlag + ',' + endX + ',' + endY;
	
	        path = path + 'Z';
	
	        return path;
	    },
	    visitHeart: function visitHeart(shapeModel) {
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        var path = this.getHeartPath(shapeModel);
	
	        var data = this.basicShape(shapeModel);
	        data = data + ('<g x="0" y="0" opacity="' + opacityValue + '">');
	
	        data = data + ('<path d="' + path + '" filter="' + shapeModel.filter + '" opacity="' + opacityValue + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	
	        data = data + '</g></g></g></g>';
	
	        return data;
	    },
	    visitEllipse: function visitEllipse(shapeModel) {
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        var data = this.basicShape(shapeModel);
	
	        data = data + ('<ellipse rx="' + shapeModel.width / 2 + '" ry="' + shapeModel.height / 2 + '" cx="' + shapeModel.width / 2 + '" cy="' + shapeModel.height / 2 + '" filter="' + shapeModel.filter + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" opacity="' + opacityValue + '" />');
	        data = data + '</g></g></g>';
	
	        return data;
	    },
	    visitLine: function visitLine(shapeModel) {
	        var x = Math.min(shapeModel.x1, shapeModel.x2);
	        var y = Math.min(shapeModel.y1, shapeModel.y2);
	
	        var data = '<g transform="translate(' + x + ' ' + y + ')">';
	
	        data = data + '<g>';
	        data = data + ('<rect x="' + 0 + '" y="' + 0 + '" width="' + Math.abs(shapeModel.x1 - shapeModel.x2) + '" height="' + Math.abs(shapeModel.y1 - shapeModel.y2) + '" fill="' + '#000000' + '" opacity="' + 0 + '" />');
	        data = data + ('<line x1="' + (shapeModel.x1 - x) + '" y1="' + (shapeModel.y1 - y) + '" x2="' + (shapeModel.x2 - x) + '" y2="' + (shapeModel.y2 - y) + '" filter="' + shapeModel.filter + '" opacity="' + shapeModel.opacity + '" fill=\'none\' stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	
	        data = data + '</g></g>';
	
	        return data;
	    },
	    createCurvePath: function createCurvePath(shapeModel) {
	        var x = Math.min(shapeModel.x1, shapeModel.x2);
	        var y = Math.min(shapeModel.y1, shapeModel.y2);
	        var path = 'M' + (shapeModel.x1 - x) + ',' + (shapeModel.y1 - y) + 'Q' + (shapeModel.cx - x) + ',' + (shapeModel.cy - y) + ',' + (shapeModel.x2 - x) + ',' + (shapeModel.y2 - y);
	
	        return path;
	    },
	    visitCurve: function visitCurve(shapeModel) {
	        var path = this.createCurvePath(shapeModel);
	
	        var x = Math.min(shapeModel.x1, shapeModel.x2);
	        var y = Math.min(shapeModel.y1, shapeModel.y2);
	
	        var data = '<g transform="translate(' + x + ' ' + y + ')">';
	        data = data + ('<path d="' + path + '" filter="' + shapeModel.filter + '" opacity="' + shapeModel.opacity + '" fill=\'#ffffff\' fill-opacity=\'0\' stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	
	        data = data + '</g>';
	
	        return data;
	    },
	    createFreehandPath: function createFreehandPath(shapeModel) {
	        var pathPoints = shapeModel.pathPoints;
	        var length = pathPoints.length;
	        var i = void 0;
	        var path = 'M' + pathPoints[0].x + ',' + pathPoints[0].y;
	
	        for (i = 0; i < length; i++) {
	            path = path + 'L' + pathPoints[i].x + ',' + pathPoints[i].y;
	        }
	
	        return path;
	    },
	    visitFreehand: function visitFreehand(shapeModel) {
	        var path = this.createFreehandPath(shapeModel);
	        var data = this.basicShape(shapeModel);
	
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        data = data + '<g>';
	
	        data = data + ('<rect x="' + 0 + '" y="' + 0 + '" width="' + shapeModel.width + '" height="' + shapeModel.height + '" fill="' + '#000000' + '" opacity="' + 0 + '" />');
	        data = data + ('<path d="' + path + '" filter="' + shapeModel.filter + '" opacity="' + opacityValue + '" fill=\'none\' stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	
	        data = data + '</g></g></g></g>';
	
	        return data;
	    },
	    getTextStyle: function getTextStyle(shapeModel) {
	        if (shapeModel.isRichText) return this.getTextStyleNew(shapeModel);else return this.getTextStyleOld(shapeModel);
	    },
	    getTextStyleNew: function getTextStyleNew(shapeModel) {
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var textProperties = _TextSizeUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	        var offset = 0;
	        var data = '';
	        var textAreaWidth = shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING + offset;
	        var textAreaHeight = shapeModel.height - 2 * PADDING - 2 * INNER_PADDING;
	        var paddingLeft = void 0;
	
	        if (shapeModel.imageNode && shapeModel.imageNode.length > 0 && shapeModel.aspectRatio > 0) {
	            var maxWidth = textAreaWidth * 0.7;
	            var imageWidth = textAreaHeight * shapeModel.aspectRatio;
	
	            if (imageWidth > maxWidth) imageWidth = maxWidth;
	
	            paddingLeft = 2 * INNER_PADDING + imageWidth;
	            textAreaWidth = textAreaWidth - INNER_PADDING - imageWidth;
	        }
	
	        data = data + 'width:' + textAreaWidth + 'px; ';
	        data = data + 'height:' + textAreaHeight + 'px; ';
	        data = data + 'resize: none; overflow: hidden; ';
	        data = data + 'padding: ' + INNER_PADDING + 'px; ';
	        data = data + 'border: none; outline: none; background: transparent; ';
	        data = data + 'word-spacing: ' + textProperties.wordSpacing + 'px; ';
	        data = data + 'letter-spacing: ' + textProperties.letterSpacing + 'px; ';
	        data = data + 'overflow-wrap: break-word; ';
	
	        if (shapeModel.lineHeight > 0) data = data + 'line-height: ' + shapeModel.lineHeight + '; ';else {
	            if (textProperties.lineHeight != -1) data = data + 'line-height: ' + textProperties.lineHeight + '; ';
	        }
	
	        if (paddingLeft > 0) data = data + 'padding-left: ' + paddingLeft + 'px; ';
	
	        return data;
	    },
	    getImageNode: function getImageNode(shapeModel) {
	        if (shapeModel.imageNode && shapeModel.imageNode.length > 0 && shapeModel.aspectRatio > 0) {
	            var textProperties = _TextSizeUtils2.default.textProperties(shapeModel);
	            var EXTRA_PADDING = textProperties.extraPadding;
	            var textAreaWidth = shapeModel.width - 2 * _Properties2.default.TEXT_INNER_PADDING + EXTRA_PADDING;
	            var textAreaHeight = shapeModel.height - 2 * _Properties2.default.TEXT_INNER_PADDING;
	            var maxWidth = textAreaWidth * 0.7;
	            var imageWidth = textAreaHeight * shapeModel.aspectRatio;
	
	            if (imageWidth > maxWidth) imageWidth = maxWidth;
	
	            return '<image x="' + _Properties2.default.TEXT_INNER_PADDING + '" y="' + _Properties2.default.TEXT_INNER_PADDING + '" height="' + textAreaHeight + '" width="' + imageWidth + '" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' + this.getCorrectUrl(shapeModel.imageNode) + '" preserveAspectRatio="none" />';
	        } else return '';
	    },
	    getTextStyleOld: function getTextStyleOld(shapeModel) {
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var bold = shapeModel.fontBold ? 'bold' : 'normal';
	        var italic = shapeModel.fontItalic ? 'italic' : 'normal';
	        var textProperties = _TextSizeUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	        var offset = 0;
	
	        var data = '';
	
	        data = data + 'width:' + (shapeModel.width - 2 * PADDING + EXTRA_PADDING + offset) + 'px; ';
	        data = data + 'height:' + (shapeModel.height - 2 * PADDING) + 'px; ';
	        data = data + 'resize: none; overflow: hidden; ';
	        data = data + 'padding: ' + INNER_PADDING + 'px; ';
	        data = data + 'border: none; outline: none; background: transparent; ';
	        data = data + 'font-family: ' + shapeModel.fontFamily + '; ';
	        data = data + 'font-size: ' + shapeModel.fontSize + 'px; ';
	        data = data + 'font-style: ' + italic + '; ';
	        data = data + 'font-weight: ' + bold + '; ';
	        data = data + 'text-align: ' + shapeModel.fontAlign + '; ';
	        data = data + 'word-spacing: ' + textProperties.wordSpacing + 'px; ';
	        data = data + 'letter-spacing: ' + textProperties.letterSpacing + 'px; ';
	        data = data + 'color: ' + shapeModel.fontColor + '; ';
	
	        if (textProperties.lineHeight != -1) data = data + 'line-height: ' + textProperties.lineHeight + '; ';
	
	        if (shapeModel.fontUnderline) data = data + 'text-decoration: underline; ';
	
	        return data;
	    },
	    encodeText: function encodeText(text) {
	        return text.replace(/[\x0b-\x0d]/g, '-'); // replace all the non printable characters (from 11 to 13 ascii code) with the - character
	    },
	    visitTextbox: function visitTextbox(shapeModel) {
	        var textStyle = this.getTextStyle(shapeModel);
	        var backgroundOpacity;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        var data = this.basicShape(shapeModel);
	
	        data = data + ('<g x="0" y="0" opacity="' + opacityValue + '">');
	
	        data = data + ('<rect x="' + 0 + '" y="' + 0 + '" width="' + shapeModel.width + '" height="' + shapeModel.height + '" rx="' + 15 + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '"/>');
	        data = data + ('<foreignObject x="' + PADDING + '" y="' + PADDING + '" width="' + (shapeModel.width - 2 * PADDING) + '" height="' + (shapeModel.height - 2 * PADDING) + '">');
	
	        if (shapeModel.isRichText) data = data + ('<div style="' + textStyle + '" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">' + this.encodeText(_TextSizeUtils2.default.getHtmlText(shapeModel)) + '</div>');else data = data + ('<textarea style="' + textStyle + '" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">' + this.encodeText(shapeModel.htmlText) + '</textarea>');
	
	        data = data + '</foreignObject ></g></g></g></g>';
	
	        return data;
	    },
	    visitTextboxSimple: function visitTextboxSimple(shapeModel) {
	        var textStyle = this.getTextStyle(shapeModel);
	        var PADDING = _Properties2.default.TEXT_PADDING;
	
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        var data = this.basicShape(shapeModel);
	
	        data = data + ('<g x="0" y="0" opacity="' + opacityValue + '">');
	        data = data + ('<foreignObject x="' + PADDING + '" y="' + PADDING + '" width="' + (shapeModel.width - 2 * PADDING) + '" height="' + (shapeModel.height - 2 * PADDING) + '">');
	
	        if (shapeModel.isRichText) data = data + ('<div style="' + textStyle + '" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">' + this.encodeText(_TextSizeUtils2.default.getHtmlText(shapeModel)) + '</div>');else data = data + ('<textarea style="' + textStyle + '" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">' + this.encodeText(shapeModel.htmlText) + '</textarea>');
	
	        data = data + '</foreignObject ></g></g></g></g>';
	
	        return data;
	    },
	    visitSpeakBubble: function visitSpeakBubble(shapeModel) {
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        var textStyle = this.getTextStyle(shapeModel);
	        var PADDING = _Properties2.default.TEXT_PADDING;
	
	        var path = _SpeakBubbleUtils2.default.getPath(shapeModel);
	        var data = this.basicShape(shapeModel);
	
	        data = data + ('<g x="0" y="0" opacity="' + opacityValue + '">');
	
	        data = data + ('<rect x="' + 0 + '" y="' + 0 + '" width="' + shapeModel.width + '" height="' + shapeModel.height + '" rx="' + 15 + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '"/>');
	        data = data + ('<path d="' + path + '" filter="' + shapeModel.filter + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	
	        data = data + ('<foreignObject x="' + PADDING + '" y="' + PADDING + '" width="' + (shapeModel.width - 2 * PADDING) + '" height="' + (shapeModel.height - 2 * PADDING) + '">');
	
	        if (shapeModel.isRichText) data = data + ('<div style="' + textStyle + '" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">' + this.encodeText(_TextSizeUtils2.default.getHtmlText(shapeModel)) + '</div>');else data = data + ('<textarea style="' + textStyle + '" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">' + this.encodeText(shapeModel.htmlText) + '</textarea>');
	
	        data = data + '</foreignObject ></g></g></g></g>';
	
	        return data;
	    },
	    visitComplexSpeakBubble: function visitComplexSpeakBubble(shapeModel) {
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        var textStyle = this.getTextStyle(shapeModel);
	        var PADDING = _Properties2.default.TEXT_PADDING;
	
	        var path = _SpeakBubbleUtils2.default.getPath(shapeModel);
	        var data = this.basicShape(shapeModel);
	
	        data = data + ('<g x="0" y="0" opacity="' + opacityValue + '">');
	
	        data = data + ('<rect x="' + 0 + '" y="' + 0 + '" width="' + shapeModel.width + '" height="' + shapeModel.height + '" rx="' + 15 + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '"/>');
	
	        var pathStrokeWidth = shapeModel.strokeWidth;
	
	        if (pathStrokeWidth < 2 && shapeModel.isMindMap) pathStrokeWidth = 2;
	
	        data = data + ('<path d="' + path + '" filter="' + shapeModel.filter + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + pathStrokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	
	        data = data + this.getImageNode(shapeModel);
	
	        data = data + ('<foreignObject x="' + PADDING + '" y="' + PADDING + '" width="' + (shapeModel.width - 2 * PADDING) + '" height="' + (shapeModel.height - 2 * PADDING) + '">');
	
	        if (shapeModel.isRichText) data = data + ('<div style="' + textStyle + '" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">' + this.encodeText(_TextSizeUtils2.default.getHtmlText(shapeModel)) + '</div>');else data = data + ('<textarea style="' + textStyle + '" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">' + this.encodeText(shapeModel.htmlText) + '</textarea>');
	
	        data = data + '</foreignObject ></g></g></g></g>';
	
	        return data;
	    },
	    visitScreamBubble: function visitScreamBubble(shapeModel) {
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        var textStyle = this.getTextStyle(shapeModel);
	        var PADDING = _Properties2.default.TEXT_PADDING;
	
	        var path = _ScreamBubbleUtils2.default.getPath(shapeModel);
	        var data = this.basicShape(shapeModel);
	
	        data = data + ('<g x="0" y="0" opacity="' + opacityValue + '">');
	
	        data = data + ('<path d="' + path + '" filter="' + shapeModel.filter + '" opacity="' + shapeModel.opacity + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	
	        data = data + ('<foreignObject x="' + PADDING + '" y="' + PADDING + '" width="' + (shapeModel.width - 2 * PADDING) + '" height="' + (shapeModel.height - 2 * PADDING) + '">');
	
	        if (shapeModel.isRichText) data = data + ('<div style="' + textStyle + '" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">' + this.encodeText(_TextSizeUtils2.default.getHtmlText(shapeModel)) + '</div>');else data = data + ('<textarea style="' + textStyle + '" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">' + this.encodeText(shapeModel.htmlText) + '</textarea>');
	
	        data = data + '</foreignObject ></g></g></g></g>';
	
	        return data;
	    },
	    visitThoughtBubble: function visitThoughtBubble(shapeModel) {
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        var textStyle = this.getTextStyle(shapeModel);
	        var PADDING = _Properties2.default.TEXT_PADDING;
	
	        var path = _ThoughtBubbleUtils2.default.getPath(shapeModel);
	        var stemObject = _ThoughtBubbleUtils2.default.getStemPoints(shapeModel);
	        var points = stemObject.points;
	        var radius = stemObject.radius;
	
	        var data = this.basicShape(shapeModel);
	
	        data = data + ('<g x="0" y="0" opacity="' + opacityValue + '">');
	
	        data = data + ('<ellipse rx="' + radius[0] + '" ry="' + radius[0] + '" cx="' + points[0].x + '" cy="' + points[0].y + '" filter="' + shapeModel.filter + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	        data = data + ('<ellipse rx="' + radius[1] + '" ry="' + radius[1] + '" cx="' + points[1].x + '" cy="' + points[1].y + '" filter="' + shapeModel.filter + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	        data = data + ('<ellipse rx="' + radius[2] + '" ry="' + radius[2] + '" cx="' + points[2].x + '" cy="' + points[2].y + '" filter="' + shapeModel.filter + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	        data = data + ('<path d="' + path + '" filter="' + shapeModel.filter + '" fill="' + shapeModel.fill + '" fill-opacity="' + backgroundOpacity + '" stroke="' + shapeModel.stroke + '" stroke-width="' + shapeModel.strokeWidth + '" stroke-opacity="' + shapeModel.strokeOpacity + '" preserveAspectRatio="none" />');
	
	        data = data + ('<foreignObject x="' + PADDING + '" y="' + PADDING + '" width="' + (shapeModel.width - 2 * PADDING) + '" height="' + (shapeModel.height - 2 * PADDING) + '">');
	
	        if (shapeModel.isRichText) data = data + ('<div style="' + textStyle + '" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">' + this.encodeText(_TextSizeUtils2.default.getHtmlText(shapeModel)) + '</div>');else data = data + ('<textarea style="' + textStyle + '" spellcheck="false" autocorrect="off" autocapitalize="off" autoComplete="off">' + this.encodeText(shapeModel.htmlText) + '</textarea>');
	
	        data = data + '</foreignObject ></g></g></g></g>';
	
	        return data;
	    },
	    visitGroup: function visitGroup(shapeModel) {
	        var opacityValue = shapeModel.opacity;
	
	        if (shapeModel.animation && shapeModel.animation.start_opacity >= 0 && shapeModel.animation.end_opacity >= 0 && shapeModel.animation.start_opacity != shapeModel.animation.end_opacity) opacityValue = 1;
	
	        var data = this.basicShape(shapeModel);
	        data = data + ('<g x="0" y="0" opacity="' + opacityValue + '">');
	
	        var shapesData = this.getHtmlFromShapes(shapeModel.shapes, true).layers[0];
	        data = data + shapesData;
	
	        data = data + '</g></g></g></g>';
	
	        return data;
	    },
	    visitVideo: function visitVideo(shapeModel) {}
	};
	
	exports.default = exporterUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ExporterUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ExporterUtils.js"); } } })();

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 95 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(70);
	var call = __webpack_require__(268);
	var isArrayIter = __webpack_require__(188);
	var anObject = __webpack_require__(22);
	var toLength = __webpack_require__(45);
	var getIterFn = __webpack_require__(205);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 97 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(22);
	var dPs = __webpack_require__(274);
	var enumBugKeys = __webpack_require__(184);
	var IE_PROTO = __webpack_require__(196)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(183)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(186).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(276);
	var hiddenKeys = __webpack_require__(184).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(276);
	var enumBugKeys = __webpack_require__(184);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 101 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(60);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(24);
	var dP = __webpack_require__(44);
	var DESCRIPTORS = __webpack_require__(43);
	var SPECIES = __webpack_require__(34)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(77);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 105 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dragManager = {
	    scaleProperties: undefined,
	    dragElement: undefined,
	    callBackFunction: undefined,
	    offsetPoint: undefined,
	    startPositionLeft: 0,
	    startPositionTop: 0,
	    isSlide: false,
	    gap: 0,
	    oldTime: 0,
	
	    getDragOffset: function getDragOffset(offsetPoint) {
	        var dragX = 0;
	        var dragY = 0;
	
	        if (offsetPoint != undefined) {
	            if (offsetPoint.x > 0) dragX = offsetPoint.x - this.startPositionLeft;
	
	            if (offsetPoint.y > 0) dragY = offsetPoint.y - this.startPositionTop;
	        }
	
	        if (dragX < 0) dragX = 0;
	
	        if (dragY < 0) dragY = 0;
	
	        return { x: dragX, y: dragY };
	    },
	    cloneCanvas: function cloneCanvas(oldCanvas) {
	        var newCanvas = document.createElement('canvas');
	        var context = newCanvas.getContext('2d');
	
	        newCanvas.width = oldCanvas.width;
	        newCanvas.height = oldCanvas.height;
	
	        context.drawImage(oldCanvas, 0, 0);
	
	        return newCanvas;
	    },
	    prepareClone: function prepareClone(target, callBackFunction, dragOffset) {
	        var isSlide = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        var date = new Date();
	        var currentTime = date.getTime();
	
	        if (currentTime - this.oldTime < 300) {
	            this.oldTime = currentTime;
	            return;
	        }
	
	        if (!target) return;
	
	        this.oldTime = currentTime;
	
	        if (this.dragElement && this.dragElement.parentNode) document.body.removeChild(this.dragElement);
	
	        if (target.nodeName == 'CANVAS') this.dragElement = this.cloneCanvas(target);else {
	            var holder = document.createElement('div');
	            holder.style.position = 'absolute';
	
	            var clone = target.cloneNode(true);
	            clone.style.position = 'absolute';
	            clone.style.left = '0px';
	            clone.style.paddingTop = '0px';
	            clone.style.paddingLeft = '0px';
	            clone.style.display = 'block';
	
	            var gapX = 5;
	            var gapY = 5;
	            var icon = document.createElement('div');
	            icon.id = 'dropIcon';
	            icon.style.position = 'absolute';
	            icon.style.borderColor = 'red';
	            icon.style.borderWidth = 4;
	            icon.style.borderStyle = 'solid';
	            icon.style.top = '0px';
	            icon.style.left = '0px';
	            icon.style.cursor = '-webkit-grabbing';
	
	            if (target.id && target.id.indexOf('ListItemRenderer') != -1) {
	                if (target.className == 'background') {
	                    clone.style.top = '12px';
	                    gapX = 7;
	                    gapY = 3;
	                } else {
	                    clone.style.top = '0px';
	                    gapX = 7;
	                    gapY = 7;
	                }
	            } else if (target.id && target.id.indexOf('MediaImagesItemRenderer') != -1) {
	                clone.style.top = '0px';
	                gapX = 11;
	                gapY = 11;
	            } else {
	                clone.style.top = '0px';
	            }
	
	            icon.style.width = target.clientWidth - gapX + 'px';
	            icon.style.height = target.clientHeight - gapY + 'px';
	
	            holder.appendChild(clone);
	            holder.appendChild(icon);
	
	            this.dragElement = holder;
	        }
	
	        document.body.appendChild(this.dragElement);
	
	        var globalPosition = target.getBoundingClientRect();
	
	        this.dragElement.style.position = 'absolute';
	        this.dragElement.style.opacity = 0;
	        this.startPositionLeft = globalPosition.left;
	        this.startPositionTop = globalPosition.top;
	
	        this.dragElement.style.left = this.startPositionLeft + 'px';
	        this.dragElement.style.top = this.startPositionTop + 'px';
	
	        this.callBackFunction = callBackFunction;
	        this.dragOffset = this.getDragOffset(dragOffset);
	        this.isSlide = isSlide;
	
	        this.clearScrollInverval();
	    },
	    onDragMove: function onDragMove(offsetX, offsetY, e) {
	        var target = this.dragElement;
	
	        if (target == undefined) return;
	
	        target.style.opacity = 0.8;
	        target.style.top = this.startPositionTop + offsetY + 'px';
	
	        var newLeftPos;
	
	        if (e) newLeftPos = _MouseUtils2.default.getTouchPosition(e).x - this.dragOffset.x;else newLeftPos = this.startPositionLeft + offsetX + this.gap;
	
	        if (this.isSlide) {
	            if (newLeftPos > this.getLeftLimit() && newLeftPos < this.getRightLimit()) target.style.left = newLeftPos + 'px';
	        } else target.style.left = newLeftPos + 'px';
	
	        this.checkPosition(offsetX, offsetY);
	
	        if (this.isSlide) this.checkScroll(offsetX, e);
	    },
	
	
	    moveScroll: undefined,
	    positionValue: 1,
	    scrollTimerVar: undefined,
	    checkScroll: function checkScroll(offsetX, e) {
	        var position = _MouseUtils2.default.getTouchPosition(e);
	
	        if (position.x > this.getLeftLimit() && position.x < this.getRightLimit()) {
	            this.clearScrollInverval();
	            return;
	        }
	
	        if (position.x >= this.getRightLimit()) {
	            if (!this.scrollTimerVar) {
	                this.positionValue = 1;
	                this.scrollTimerVar = setInterval(this.moveScrollAtInterval.bind(this), 100);
	                this.moveScroll();
	            }
	        } else if (position.x <= this.getLeftLimit()) {
	            if (!this.scrollTimerVar) {
	                this.positionValue = -1;
	                this.scrollTimerVar = setInterval(this.moveScrollAtInterval.bind(this), 100);
	                this.moveScroll(-1);
	            }
	        }
	    },
	    moveScrollAtInterval: function moveScrollAtInterval() {
	        this.moveScroll(this.positionValue);
	    },
	    clearScrollInverval: function clearScrollInverval() {
	        if (this.scrollTimerVar) clearInterval(this.scrollTimerVar);
	
	        this.scrollTimerVar = undefined;
	    },
	    getLeftLimit: function getLeftLimit() {
	        return _Properties2.default.BUTTONS_HOLDER_WIDTH;
	    },
	    getRightLimit: function getRightLimit() {
	        var state = _StoreManager2.default.getState();
	        var windowWidth = state.production.windowWidth;
	        var accordionWidth = state.accordion.width;
	
	        if (!(windowWidth > 0)) windowWidth = window.innerWidth;
	
	        if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	        return windowWidth - accordionWidth;
	    },
	    onDragEnd: function onDragEnd(offsetX, offsetY) {
	        if (this.dragElement == undefined) return;
	
	        this.checkDropPosition(offsetX, offsetY);
	
	        if (this.dragElement && this.dragElement.parentNode) document.body.removeChild(this.dragElement);
	
	        this.startPositionLeft = 0;
	        this.startPositionTop = 0;
	        this.dragElement = undefined;
	        this.offsetPoint = undefined;
	        this.isSlide = false;
	        this.gap = 0;
	
	        this.clearScrollInverval();
	    },
	    checkPosition: function checkPosition(offsetX, offsetY) {
	        var scaleProperties = this.scaleProperties;
	        var dragOffset = this.dragOffset;
	
	        var clientX = this.startPositionLeft + offsetX + dragOffset.x;
	        var clientY = this.startPositionTop + offsetY + dragOffset.y;
	        var icon = document.getElementById('dropIcon');
	
	        if (icon == undefined) return;
	
	        if (clientX >= scaleProperties.topX && clientX <= scaleProperties.topX + _Configuration2.default.CANVAS_WIDTH * scaleProperties.scale && clientY >= scaleProperties.topY && clientY <= scaleProperties.topY + _Configuration2.default.CANVAS_HEIGHT * scaleProperties.scale) {
	            icon.style.borderColor = 'green';
	        } else {
	            icon.style.borderColor = 'red';
	        }
	    },
	    checkDropPosition: function checkDropPosition(offsetX, offsetY) {
	        var range = 40;
	
	        if (Math.abs(offsetX) < range && Math.abs(offsetY) < range) {
	            // it's a click
	            if (this.callBackFunction != undefined) this.callBackFunction();
	
	            return;
	        }
	
	        if (this.isSlide == true) return;
	
	        var scaleProperties = this.scaleProperties;
	        var dragOffset = this.dragOffset;
	
	        var clientX = this.startPositionLeft + offsetX + dragOffset.x;
	        var clientY = this.startPositionTop + offsetY + dragOffset.y;
	
	        if (clientX >= scaleProperties.topX && clientX <= scaleProperties.topX + _Configuration2.default.CANVAS_WIDTH * scaleProperties.scale && clientY >= scaleProperties.topY && clientY <= scaleProperties.topY + _Configuration2.default.CANVAS_HEIGHT * scaleProperties.scale) {
	            var topLeftPosition = {};
	            var scale = scaleProperties.scale;
	            topLeftPosition.x = (clientX - scaleProperties.topX) / scale;
	            topLeftPosition.y = (clientY - scaleProperties.topY) / scale;
	
	            if (this.callBackFunction != undefined) this.callBackFunction(topLeftPosition);
	        }
	    },
	    getDropIndex: function getDropIndex(index, slides, offsetX, offsetY) {
	        if (!this.dragOffset) return -1;
	
	        var slideWidth = _Properties2.default.SLIDE_ITEM_WIDTH + _Properties2.default.SLIDE_GAP;
	        var slideHeight = 9 / 16 * slideWidth;
	        var currentYPosition = this.dragOffset.y + offsetY;
	
	        if (currentYPosition < 0 || currentYPosition > slideHeight) return -1;
	
	        var currentXPosition = offsetX;
	        var dropOffset = Math.floor(currentXPosition / slideWidth);
	        var localDif = Math.abs(offsetX) - Math.abs(dropOffset * slideWidth);
	
	        if (localDif > slideWidth / 2) {
	            dropOffset = dropOffset + 1;
	        }
	
	        if (offsetX < 0) dropOffset = dropOffset + 1;
	
	        var dropIndex = index + dropOffset;
	
	        if (dropIndex < 0) dropIndex = 0;
	
	        if (offsetX < 0 && dropIndex != index) this.gap = _Properties2.default.SLIDE_PADDING_DROP;else this.gap = 0;
	
	        return dropIndex;
	    },
	
	    clientX: -1,
	    getDropIndexNew: function getDropIndexNew(dragIndex, slides, offsetX, offsetY) {
	        var slideHeight = 9 / 16 * slideWidth;
	
	        if (!this.dragOffset) return 0;
	
	        var currentYPosition = this.dragOffset.y + offsetY;
	
	        if (currentYPosition < 0 || currentYPosition > slideHeight) return -1;
	
	        var i;
	        var slideWidth;
	        var start = 0;
	        var currentX = this.clientX + offsetX;
	        var dropIndex;
	
	        for (i = 0; i < slides.length; i++) {
	            if (!slides[i] || !slides[i].time) continue;
	
	            slideWidth = _AudioEditorUtils2.default.getSlideWidth(slides[i].time);
	
	            if (currentX >= start && currentX <= start + slideWidth) {
	                if (currentX < start + slideWidth / 2) dropIndex = i;else dropIndex = i + 1;
	
	                break;
	            }
	
	            start = start + slideWidth;
	        }
	
	        if (dropIndex < 0) dropIndex = 0;
	
	        if (dropIndex > slides.length - 1) dropIndex = slides.length - 1;
	
	        if (!dropIndex) {
	            if (offsetX > 0) return slides.length - 1;else return 0;
	        }
	
	        return dropIndex;
	    }
	};
	
	exports.default = dragManager;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/DragManager.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/DragManager.js"); } } })();

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _GroupManager = __webpack_require__(142);
	
	var _GroupManager2 = _interopRequireDefault(_GroupManager);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var drawingUtils = {
	    getTouchPosition: function getTouchPosition(e) {
	        if (e instanceof MouseEvent) {
	            return { x: e.clientX, y: e.clientY };
	        } else {
	            if (e.touches.length > 0) return { x: e.touches[0].clientX, y: e.touches[0].clientY };else return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
	        }
	    },
	    calculateStarPoints: function calculateStarPoints(shapeModel) {
	        var centerX = shapeModel.width / 2;
	        var centerY = shapeModel.height / 2;
	        var arms = 5;
	        var outerRadiusX = shapeModel.width / 2;
	        var outerRadiusY = shapeModel.height / 2;
	        var innerRadiusX = shapeModel.width / 5;
	        var innerRadiusY = shapeModel.height / 5;
	
	        var results = [];
	        var angle = Math.PI / arms;
	        var offsetAngle = -Math.PI / 2;
	        var i;
	
	        for (i = 0; i < 2 * arms; i++) {
	            // Use outer or inner radius depending on what iteration we are in.
	            var rx = (i & 1) == 0 ? outerRadiusX : innerRadiusX;
	            var ry = (i & 1) == 0 ? outerRadiusY : innerRadiusY;
	
	            var currX = centerX + Math.cos(offsetAngle + i * angle) * rx;
	            var currY = centerY + Math.sin(offsetAngle + i * angle) * ry;
	
	            results.push({ x: currX, y: currY });
	        }
	
	        return results;
	    },
	
	
	    /**************** Drawing functionality **************************/
	
	    currentShapes: [],
	    dispatch: undefined,
	
	    getDrawingProperties: function getDrawingProperties() {
	        var props = {};
	        var state = _StoreManager2.default.getState();
	        var strokeWidth = state.menu.strokeWidth;
	        var strokeColor = state.menu.strokeColor;
	
	        if (!strokeColor) strokeColor = 'black';
	
	        if (!strokeWidth) strokeWidth = 3;
	
	        props.strokeWidth = strokeWidth;
	        props.strokeColor = strokeColor;
	
	        return props;
	    },
	    addCurrentShape: function addCurrentShape(shape) {
	        if (!this.currentShapes) this.currentShapes = [];
	
	        this.currentShapes.push(shape);
	    },
	    clearShapes: function clearShapes() {
	        this.currentShapes = [];
	    },
	    deleteShapes: function deleteShapes() {
	        var shapes = [];
	        var i;
	
	        for (i = 0; i < this.currentShapes.length; i++) {
	            shapes.push(this.currentShapes[i].uuid);
	        }this.dispatch((0, _CurrentSlideActions.deleteShape)(shapes));
	        _SaveManager2.default.isContentChanged(true);
	    },
	    groupShapes: function groupShapes() {
	        if (this.currentShapes && this.currentShapes.length > 0) _GroupManager2.default.group(this.currentShapes);
	    },
	    executeAction: function executeAction(action) {
	        if (action == 'ok') {
	            var state = _StoreManager2.default.getState();
	            var groupDrawingShapes = state.menu.groupDrawingShapes;
	
	            if (groupDrawingShapes == undefined) groupDrawingShapes = true;
	
	            if (groupDrawingShapes) this.groupShapes();
	        } else {
	            // cancel
	            this.deleteShapes();
	        }
	
	        this.dispatch((0, _AccordionActions.setDrawState)('none'));
	        this.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	
	        this.clearShapes();
	    }
	};
	
	exports.default = drawingUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/DrawingUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/DrawingUtils.js"); } } })();

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var touchUtils = {
	    startTime: undefined,
	    endTime: undefined,
	
	    mouseDown: function mouseDown() {
	        this.startTime = new Date().getTime();
	    },
	    mouseUp: function mouseUp() {
	        this.endTime = new Date().getTime();
	    },
	    isLongInteraction: function isLongInteraction() {
	        if (isNaN(this.endTime) || isNaN(this.startTime)) return false;else {
	            var time = this.endTime - this.startTime;
	
	            if (time > 300) return true;else return false;
	        }
	    }
	};
	
	exports.default = touchUtils;
	module.exports = exports["default"];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/TouchUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/TouchUtils.js"); } } })();

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 112 */
/***/ function(module, exports) {

	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}


/***/ },
/* 113 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(44).f;
	var has = __webpack_require__(58);
	var TAG = __webpack_require__(34)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var defined = __webpack_require__(75);
	var fails = __webpack_require__(26);
	var spaces = __webpack_require__(200);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(28);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(212);
	var setInnerHTML = __webpack_require__(166);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(220);
	var setTextContent = __webpack_require__(321);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(19);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(717);
	var ReactInstrumentation = __webpack_require__(72);
	
	var warning = __webpack_require__(29);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var types = {
	    SESSION_SET_APP_READY: 'SESSION_SET_APP_READY',
	    SESSION_SET_CAPTIONS_LOADED: 'SESSION_SET_CAPTIONS_LOADED',
	    SESSION_SET_LANGUAGE: 'SESSION_SET_LANGUAGE',
	    SESSION_SET_REQUEST_PARAMETER_IDS: 'SESSION_SET_REQUEST_PARAMETER_IDS'
	};
	
	var sessionActions = {
	    types: types,
	
	    /**
	     * @param {object} parameterIds
	     * @returns {{type: string, parameterIds: object}}
	     */
	    setRequestParameterIds: function setRequestParameterIds(parameterIds) {
	        return { type: types.SESSION_SET_REQUEST_PARAMETER_IDS, parameterIds: parameterIds };
	    },
	
	
	    /**
	     * @returns {{type: string}}
	     */
	    setAppReady: function setAppReady() {
	        return { type: types.SESSION_SET_APP_READY };
	    },
	    setCaptionsLoaded: function setCaptionsLoaded() {
	        return { type: types.SESSION_SET_CAPTIONS_LOADED };
	    },
	    setLanguage: function setLanguage(language) {
	        return { type: types.SESSION_SET_LANGUAGE, language: language };
	    }
	};
	
	exports.default = sessionActions;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/actions/SessionActions.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/actions/SessionActions.js"); } } })();

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setDragTarget = setDragTarget;
	exports.setDropTarget = setDropTarget;
	exports.needsRefresh = needsRefresh;
	var types = exports.types = {
	    DRAG_INDEX: 'drag_index',
	    DROP_INDEX: 'drop_index',
	    NEEDS_REFRESH: 'needs_refresh'
	};
	
	function setDragTarget(index) {
	    return { type: types.DRAG_INDEX, index: index };
	}
	
	function setDropTarget(index) {
	    return { type: types.DROP_INDEX, index: index };
	}
	
	function needsRefresh(value) {
	    return { type: types.NEEDS_REFRESH, value: value };
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/actions/SlideViewerActions.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/actions/SlideViewerActions.js"); } } })();

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OnOffToggleButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OnOffToggleButton = exports.OnOffToggleButton = _react2.default.createClass({
	    displayName: 'OnOffToggleButton',
	    getInitialState: function getInitialState() {
	        return {
	            state: 'off',
	            isThumbOver: false
	        };
	    },
	    onThumbMouseIn: function onThumbMouseIn() {
	        this.setState({
	            isThumbOver: true
	        });
	    },
	    onThumbMouseOut: function onThumbMouseOut() {
	        this.setState({
	            isThumbOver: false
	        });
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 32 || e.keyCode == 13) // Space or Enter Key
	            this.onChangeValue();
	    },
	    onMouseDown: function onMouseDown() {
	        var leftString = this.refs.thumb.style.left;
	        var left = Number(leftString.substring(0, leftString.length - 2));
	
	        this.setState({
	            startPosition: left,
	            isON: this.isON()
	        });
	    },
	    updateThumbnail: function updateThumbnail() {
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    checkPosition: function checkPosition(deltaX) {
	        _SaveManager2.default.isContentChanged(true);
	
	        var newPosition = this.state.startPosition + deltaX;
	        var limit = this.props.properties.trackWidth / 2;
	        var value;
	
	        if (newPosition + this.props.properties.thumbSize / 2 > limit) {
	            value = true;
	            this.refs.thumb.style.left = this.props.properties.trackWidth - this.props.properties.thumbSize + 'px';
	        } else {
	            value = false;
	            this.refs.thumb.style.left = '0px';
	        }
	
	        if (this.props.properties.isBackgroundElement || this.props.properties.isMediaFilesElement) value = !value;
	
	        if (this.state.isON != value) {
	            if (this.props.properties.isDrawing) {
	                this.props.dispatch((0, _MenuActions.groupDrawingShapes)(value));
	            } else {
	                if (this.props.properties.isMediaFilesElement) {
	                    if (this.props.properties.isVideo) this.props.dispatch((0, _MenuActions.useVideoAsBackground)(!value));else this.props.dispatch((0, _MenuActions.useImageAsBackground)(!value));
	                } else {
	                    if (this.props.properties.isBackgroundElement) {
	                        if (this.props.properties.isFrame) this.props.dispatch((0, _MenuActions.useFrameAsImage)(value));else this.props.dispatch((0, _MenuActions.useBackgroundAsImage)(value));
	                    } else {
	                        this.props.dispatch((0, _CurrentSlideActions.changeShapeFillVisibility)(this.props.shapeModel.uuid, value));
	                        this.updateThumbnail();
	                        _AudioEditorUtils2.default.addActionToHistory();
	                    }
	                }
	            }
	
	            this.setState({
	                isON: value
	            });
	
	            this.forceUpdate();
	        }
	    },
	    onMouseMove: function onMouseMove(e, coreEvent) {
	        this.checkPosition(coreEvent.lastX);
	    },
	    onMouseUp: function onMouseUp(e, coreEvent) {
	        this.checkPosition(coreEvent.lastX);
	    },
	    isON: function isON() {
	        if (this.props.properties.isDrawing) {
	            return this.props.properties.groupDrawingShapes;
	        }
	
	        if (this.props.properties.isBackgroundElement) {
	            if (this.props.properties.isFrame) return !this.props.properties.useFrameAsImage;else return !this.props.properties.useBackgroundAsImage;
	        }
	
	        if (this.props.properties.isMediaFilesElement) {
	            if (this.props.properties.isVideo) return this.props.properties.useVideoAsBackground;else return this.props.properties.useImageAsBackground;
	        }
	
	        if (this.props.shapeModel == undefined) return false;
	
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var target;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                target = shapes[i];
	                break;
	            }
	        }if (target && target.backgroundVisible == false) return false;else return true;
	    },
	    onChangeValue: function onChangeValue() {
	        _SaveManager2.default.isContentChanged(true);
	
	        var value = !this.state.isON;
	
	        if (this.state.isON === undefined) {
	            if (this.props.properties.isMediaFilesElement && this.props.properties.isVideo) value = false;
	        }
	
	        if (this.props.properties.isDrawing) {
	            this.props.dispatch((0, _MenuActions.groupDrawingShapes)(value));
	        } else {
	            if (this.props.properties.isMediaFilesElement) {
	                if (this.props.properties.isVideo) this.props.dispatch((0, _MenuActions.useVideoAsBackground)(value));else this.props.dispatch((0, _MenuActions.useImageAsBackground)(value));
	            } else {
	                if (this.props.properties.isBackgroundElement) {
	                    if (this.props.properties.isFrame) this.props.dispatch((0, _MenuActions.useFrameAsImage)(value));else this.props.dispatch((0, _MenuActions.useBackgroundAsImage)(value));
	                } else {
	                    this.props.dispatch((0, _CurrentSlideActions.changeShapeFillVisibility)(this.props.shapeModel.uuid, value));
	                    this.updateThumbnail();
	                }
	            }
	        }
	
	        this.forceUpdate();
	
	        this.setState({
	            isON: value
	        });
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isThumbOver != nextState.isThumbOver || this.state.isON != nextState.isON || this.props.shapeModel != newProps.shapeModel || this.props.properties != newProps.properties) return true;else return false;
	    },
	    render: function render() {
	        var properties = this.props.properties;
	
	        var textWidth = 35;
	
	        var wrapperStyle = {
	            position: 'absolute',
	            left: properties.leftPosition,
	            top: properties.topPosition,
	            width: properties.trackWidth + textWidth,
	            height: properties.thumbSize,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var textStyle = {
	            position: 'absolute',
	            left: 0,
	            top: 4,
	            fontSize: 16,
	            cursor: 'default'
	        };
	
	        var buttonStyle = {
	            position: 'absolute',
	            left: textWidth,
	            top: 0
	        };
	
	        var thumbPosition = 0;
	        var stateValue = _LocalesManager2.default.getCaption('OFF', 'other');
	        var textValueOffset = 4;
	        var stateLeftPosition = this.props.properties.thumbSize + textValueOffset / 2;
	        var backgroundColor = '#A3A3A3';
	
	        if (this.isON() == true) {
	            thumbPosition = this.props.properties.trackWidth - this.props.properties.thumbSize;
	            stateValue = _LocalesManager2.default.getCaption('ON', 'other');
	            stateLeftPosition = textValueOffset;
	            backgroundColor = '#A5D3CF';
	        }
	
	        var backgroundStyle = {
	            position: 'absolute',
	            width: properties.trackWidth,
	            height: properties.trackHeight,
	            top: properties.thumbSize / 2 - properties.trackHeight / 2,
	            backgroundColor: backgroundColor,
	            borderRadius: 30
	        };
	
	        var thumbBorderSize = 2;
	        var thumbBorderColor = 'black';
	
	        if (this.state.isThumbOver == true) thumbBorderColor = '#2196F3';
	
	        var thumbStyle = {
	            position: 'absolute',
	            width: properties.thumbSize - 2 * thumbBorderSize,
	            height: properties.thumbSize - 2 * thumbBorderSize,
	            top: 0,
	            left: thumbPosition,
	            background: 'white',
	            borderStyle: 'solid',
	            borderColor: thumbBorderColor,
	            borderWidth: 2,
	            borderRadius: 50,
	            cursor: 'default',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial'
	        };
	
	        var textStateStyle = {
	            position: 'absolute',
	            left: stateLeftPosition,
	            top: 4,
	            fontSize: 14,
	            cursor: 'default'
	        };
	
	        var backgroundImageText;
	        var fillTextBackground;
	
	        if (properties.isMediaFilesElement || properties.isDrawing || properties.isBackgroundElement) {
	            if (properties.isDrawing) {
	                backgroundImageText = _react2.default.createElement(
	                    'span',
	                    { style: textStyle },
	                    _LocalesManager2.default.getCaption('group', 'drawing')
	                );
	            } else {
	                if (properties.isBackgroundElement) {
	                    backgroundImageText = _react2.default.createElement(
	                        'span',
	                        { style: textStyle },
	                        _LocalesManager2.default.getCaption('UseAsBackground', 'other')
	                    );
	                } else {
	                    if (properties.isVideo) backgroundImageText = _react2.default.createElement(
	                        'span',
	                        { style: textStyle },
	                        _LocalesManager2.default.getCaption('UseVideoAsBackground', 'other')
	                    );else backgroundImageText = _react2.default.createElement(
	                        'span',
	                        { style: textStyle },
	                        _LocalesManager2.default.getCaption('UseImageAsBackground', 'other')
	                    );
	                }
	            }
	
	            buttonStyle.left = 0;
	            textStyle.left = properties.trackWidth + 7;
	            textStyle.fontSize = 14;
	            wrapperStyle.width = properties.width;
	
	            if (_PlatformDetection2.default.isIOS()) {
	                textStyle.top = 6;
	                textStyle.fontSize = 12;
	                textStyle.left = textStyle.left - 5;
	            }
	        } else fillTextBackground = _react2.default.createElement(
	            'span',
	            { style: textStyle },
	            _LocalesManager2.default.getCaption('FillTextBackground', 'textStylingMenu')
	        );
	
	        var topFrame = {
	            position: 'absolute',
	            width: properties.trackWidth,
	            height: properties.trackHeight + 4
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: wrapperStyle },
	            fillTextBackground,
	            _react2.default.createElement(
	                'div',
	                { style: buttonStyle },
	                _react2.default.createElement('div', { ref: 'track', style: backgroundStyle }),
	                _react2.default.createElement(
	                    'span',
	                    { style: textStateStyle },
	                    stateValue
	                ),
	                _react2.default.createElement(
	                    _reactDraggable2.default,
	                    { axis: 'none', position: { x: 0, y: 0 }, onStop: this.onChangeValue },
	                    _react2.default.createElement('div', { style: topFrame })
	                ),
	                _react2.default.createElement(
	                    _reactDraggable2.default,
	                    { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	                    _react2.default.createElement('button', { id: this.props.id, 'aria-label': stateValue, ref: 'thumb', style: thumbStyle, onKeyDown: this.onKeyDown, onMouseOver: this.onThumbMouseIn, onMouseOut: this.onThumbMouseOut })
	                )
	            ),
	            backgroundImageText
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/OnOffToggleButton.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/OnOffToggleButton.js"); } } })();

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.VolumeSlider = exports.VolumeSliderContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var VolumeSliderContent = exports.VolumeSliderContent = _react2.default.createClass({
	    displayName: 'VolumeSliderContent',
	    getInitialState: function getInitialState() {
	        var steps = 10;
	        var props = this.getProperties();
	        var realStep = (props.trackHeight - props.thumbSize) / steps;
	
	        return {
	            step: realStep,
	            props: props,
	            isThumbOver: false,
	            isThumbActive: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.drawTrack();
	
	        if (_PlatformDetection2.default.isTouchableDevice()) {
	            this.refs.track.addEventListener('touchend', this.onTrackMouseDown);
	
	            if (_PlatformDetection2.default.isChromeBook()) this.refs.track.addEventListener('mousedown', this.onTrackMouseDown);
	        } else this.refs.track.addEventListener('mousedown', this.onTrackMouseDown);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.positionLeft != this.props.positionLeft) {
	            setTimeout(function () {
	                var props = this.getProperties();
	
	                this.setState({
	                    props: props
	                });
	            }.bind(this), 100);
	        }
	
	        if (nextProps.visible != this.props.visible && nextProps.visible) {
	            if (_PlatformDetection2.default.isIOS()) return;
	
	            setTimeout(function () {
	                var thumbElement = this.refs.thumb;
	
	                if (thumbElement) thumbElement.focus();
	            }.bind(this), 100);
	        }
	    },
	    drawTrack: function drawTrack() {
	        var canvas = this.refs.track;
	        var lineSize = 2;
	        canvas.width = this.state.props.trackWidth;
	        canvas.height = this.state.props.trackHeight;
	        var ctx = canvas.getContext('2d');
	
	        ctx.fillStyle = _Properties2.default.DURATION_SLIDER_COLOR;
	        ctx.fillRect(canvas.width / 2 - lineSize / 2, 0, lineSize, canvas.height);
	        ctx.fill();
	    },
	    getCurrentStep: function getCurrentStep(position) {
	        var floatValue = position / this.state.step;
	        var integerPart = parseInt(floatValue, 10);
	
	        var newPosition;
	
	        if (floatValue - integerPart > 0.5) newPosition = integerPart + 1;else newPosition = integerPart;
	
	        return newPosition;
	    },
	    getSliderPosition: function getSliderPosition(position) {
	        var newStep = this.getCurrentStep(position);
	        return this.state.props.start + newStep * this.state.step;
	    },
	    getSliderValue: function getSliderValue(position) {
	        var newStep = this.getCurrentStep(position);
	        return this.state.props.end - newStep * this.state.props.step;
	    },
	    onTrackMouseDown: function onTrackMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var newPosition = _MouseUtils2.default.getLocalPosition(e, this.refs.track) - this.state.props.thumbSize / 2;
	
	        if (newPosition < 0) newPosition = 0;
	
	        if (newPosition > this.state.props.trackHeight - this.state.props.thumbSize) newPosition = this.state.props.trackHeight - this.state.props.thumbSize;
	
	        var sliderPosition = this.getSliderPosition(newPosition);
	
	        this.refs.thumb.style.top = sliderPosition + 'px';
	
	        this.changeProperties(this.getSliderValue(newPosition));
	    },
	    onMouseDown: function onMouseDown() {
	        var topString = this.refs.thumb.style.top;
	        var top = Number(topString.substring(0, topString.length - 2));
	
	        this.setState({
	            startPosition: top,
	            currentPosition: top,
	            isThumbActive: true
	        });
	    },
	    onThumbMouseIn: function onThumbMouseIn() {
	        this.setState({
	            isThumbOver: true
	        });
	    },
	    onThumbMouseOut: function onThumbMouseOut() {
	        this.setState({
	            isThumbOver: false
	        });
	    },
	    checkPosition: function checkPosition(deltaY) {
	        var newPosition = this.state.startPosition + deltaY;
	        var topValue = 0;
	        var bottomValue = this.state.props.trackHeight - this.state.props.thumbSize;
	
	        if (newPosition < topValue) newPosition = topValue;else if (newPosition > bottomValue) newPosition = bottomValue;
	
	        var sliderPosition = this.getSliderPosition(newPosition);
	
	        if (sliderPosition != this.state.currentPosition) {
	
	            this.setState({
	                currentPosition: sliderPosition
	            });
	
	            var value = this.getSliderValue(this.state.currentPosition);
	
	            this.modifySoundVolume(value);
	            _SaveManager2.default.isContentChanged(true);
	        }
	    },
	    modifySoundVolume: function modifySoundVolume(value) {
	        value = value.toFixed(1);
	        value = parseFloat(value);
	
	        _SaveManager2.default.isContentChanged(true);
	
	        if (this.props.type == 'slideSound') {
	            this.props.dispatch((0, _CurrentSlideActions.changeSlideSoundVolume)(value));
	            _AudioEditorUtils2.default.addActionToHistory();
	            return;
	        }
	
	        if (this.props.type == 'slideSoundEffect') {
	            this.props.dispatch((0, _CurrentSlideActions.changeSlideSoundVolume)(value, true));
	            _AudioEditorUtils2.default.addActionToHistory();
	            return;
	        }
	
	        if (this.props.type == 'audioEditor') {
	            this.props.dispatch((0, _AudioEditorActions.changeTimelineVolume)(this.props.index, value));
	            _AudioEditorUtils2.default.addActionToHistory();
	            return;
	        }
	
	        if (this.props.type == 'audioToolPlayer') {
	            this.props.dispatch((0, _AudioEditorActions.changeVolume)(value));
	            return;
	        }
	
	        this.props.dispatch((0, _ProductionActions.changeStorySoundVolume)(value));
	        _AudioEditorUtils2.default.addActionToHistory();
	    },
	    onMouseMove: function onMouseMove(e, coreEvent, movement) {
	        if (movement) this.checkPosition(movement);else this.checkPosition(coreEvent.lastY);
	    },
	    onMouseUp: function onMouseUp(e, coreEvent) {
	        this.checkPosition(coreEvent.lastY);
	
	        this.setState({
	            isThumbActive: false
	        });
	    },
	    changeProperties: function changeProperties(newValue) {
	        if (newValue == undefined) return;
	
	        _SaveManager2.default.isContentChanged(true);
	
	        this.modifySoundVolume(newValue);
	    },
	    getThumbPosition: function getThumbPosition() {
	        var value = this.getSoundVolume();
	
	        if (value == undefined) value = 0.5;
	
	        return (1 - value) * 10 * this.state.step;
	    },
	    getSoundVolume: function getSoundVolume() {
	        if (this.props.type == 'slideSound') return this.props.soundVolume;
	
	        if (this.props.type == 'slideSoundEffect') return this.props.soundEffectVolume;
	
	        if (this.props.type == 'audioEditor') {
	            if (this.props.timelines[this.props.index] && this.props.timelines[this.props.index].isMute) return 0;else {
	                if (this.props.timelines[this.props.index]) return this.props.timelines[this.props.index].volume;else return 0;
	            }
	        }
	
	        if (this.props.type == 'audioToolPlayer') return this.props.volume;
	
	        return this.props.storySoundVolume;
	    },
	    getProperties: function getProperties() {
	        var props = {};
	        var hGap = 5;
	        var vGap = 10;
	        var volumeBottomPosition = 23;
	
	        if (_PlatformDetection2.default.isIOS()) props.thumbSize = 30;else props.thumbSize = 22;
	
	        props.normalThumbSize = 22;
	        props.width = 2 * hGap + props.normalThumbSize;
	        props.height = _Properties2.default.RECORDING_MENU_HEIGHT + _Properties2.default.CANVAS_VERTICAL_BOTTOM_PADDING + _Properties2.default.SLIDE_VIEWER_TOP_GAP + _Properties2.default.SLIDE_VIEWER_LIST_HEIGHT;
	        props.top = -props.height + _Properties2.default.ADD_MUSIC_BUTTON_HEIGHT;
	        props.left = 28;
	        props.vGap = vGap;
	        props.hGap = hGap;
	        props.trackHeight = props.height - 2 * vGap - volumeBottomPosition + 5;
	        props.trackWidth = props.width - 2 * hGap;
	        props.step = 0.1;
	        props.start = 0;
	        props.end = 1;
	        props.volumeTopPosition = props.height - volumeBottomPosition;
	
	        if (this.props.type == 'slideSound' || this.props.type == 'slideSoundEffect') {
	            props.left = props.left - 28;
	            props.top = props.top + 2;
	        } else if (this.props.type == 'audioEditor') {
	            props.left = props.left + 124;
	            props.top = props.top + 12;
	
	            if (_AudioToolUtils2.default.isAudioTool()) props.top = props.top + (_Properties2.default.AUDIO_TIMELINE_BIG_HEIGHT - _Properties2.default.AUDIO_TIMELINE_HEIGHT) / 2;
	        } else if (this.props.type == 'audioToolPlayer' || this.props.type == 'cartoonistUnexportedVolume') {
	            props.left = this.props.positionLeft;
	            props.top = -91;
	        }
	
	        return props;
	    },
	    onKeyDown: function onKeyDown(e) {
	        var delta = this.state.step;
	
	        if (e.keyCode == 38) {
	            // Up Key
	            this.onMouseDown();
	            setTimeout(function () {
	                this.onMouseMove(undefined, undefined, -delta);
	            }.bind(this), 10);
	        } else if (e.keyCode == 40) {
	            // Down Key
	            this.onMouseDown();
	            setTimeout(function () {
	                this.onMouseMove(undefined, undefined, delta);
	            }.bind(this), 10);
	        }
	
	        if (e.keyCode == 9 || e.keyCode == 27) {
	            // TAB or ESC
	            if (this.props.closeVolumeSliderHandler) this.props.closeVolumeSliderHandler();
	        }
	    },
	    render: function render() {
	        var _wrapperStyle;
	
	        var localProps = this.state.props;
	        var leftPos = localProps.left;
	
	        if (this.props.isCollapsed) {
	            leftPos = leftPos - (_Properties2.default.BUTTONS_HOLDER_WIDTH - _Properties2.default.BUTTONS_HOLDER_COLLAPSED_WIDTH);
	
	            if (this.props.type == 'audioEditor') leftPos = leftPos + 25;
	        }
	
	        var displayVisibility = 'none';
	
	        if (this.props.visible == true) displayVisibility = 'block';
	
	        var wrapperStyle = (_wrapperStyle = {
	            display: 'block',
	            position: 'absolute',
	            left: leftPos,
	            top: localProps.top,
	            width: localProps.width,
	            height: localProps.height
	        }, _defineProperty(_wrapperStyle, 'display', displayVisibility), _defineProperty(_wrapperStyle, 'cursor', 'default'), _wrapperStyle);
	
	        var backgroundStyle = {
	            position: 'absolute',
	            width: localProps.width - 2,
	            height: localProps.height - 2,
	            top: 0,
	            left: 0,
	            background: 'white',
	            borderStyle: 'solid',
	            borderColor: 'black',
	            borderWidth: 1,
	            borderRadius: 50,
	            cursor: 'default'
	        };
	
	        var holderStyle = {
	            position: 'absolute',
	            top: localProps.vGap,
	            left: localProps.hGap,
	            width: localProps.trackWidth,
	            height: localProps.trackHeight
	        };
	
	        var trackStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: localProps.trackWidth,
	            height: localProps.trackHeight,
	            cursor: 'default'
	        };
	
	        var thumbBorderSize = 2;
	        var thumbBorderColor = 'black';
	
	        if (this.state.isThumbOver == true || this.state.isThumbActive == true) thumbBorderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	
	        var thumbStyle = {
	            position: 'absolute',
	            width: localProps.thumbSize - 2 * thumbBorderSize,
	            height: localProps.thumbSize - 2 * thumbBorderSize,
	            left: (localProps.normalThumbSize - localProps.thumbSize) / 2,
	            top: this.getThumbPosition(),
	            background: 'white',
	            borderStyle: 'solid',
	            borderColor: thumbBorderColor,
	            borderWidth: 2,
	            borderRadius: 50,
	            cursor: 'default',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial'
	        };
	
	        var volumeIconStyle = {
	            position: 'absolute',
	            left: 11,
	            top: localProps.volumeTopPosition,
	            color: 'black'
	        };
	
	        var volumeIcon = 'fa fa-volume-down';
	        var soundVolume = this.getSoundVolume();
	
	        if (soundVolume == 0) volumeIcon = 'fa fa-volume-off';else if (soundVolume <= 0.5) volumeIcon = 'fa fa-volume-down';else if (soundVolume > 0.5) volumeIcon = 'fa fa-volume-up';
	
	        var volumeIconId = 'volumeIcon';
	        var id = 'volumeSlider';
	
	        if (this.props.type == 'slideSound') {
	            volumeIconId = 'volumeIcon1';
	            id = 'volumeSlider1';
	        } else if (this.props.type == 'slideSoundEffect') {
	            volumeIconId = 'volumeIcon2';
	            id = 'volumeSlider2';
	        }
	
	        if (_AudioToolUtils2.default.isAudioTool() && this.props.type == 'audioEditor' && this.props.index == 0) {
	            wrapperStyle.position = 'fixed';
	            wrapperStyle.top = 75;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'volumeSlider_' + Math.random(), style: wrapperStyle },
	            _react2.default.createElement('div', { style: backgroundStyle }),
	            _react2.default.createElement('i', { id: 'volumeIcon_' + Math.random(), style: volumeIconStyle, className: volumeIcon }),
	            _react2.default.createElement(
	                'div',
	                { style: holderStyle },
	                _react2.default.createElement('canvas', { ref: 'track', style: trackStyle }),
	                _react2.default.createElement(
	                    _reactDraggable2.default,
	                    { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	                    _react2.default.createElement('button', { 'aria-label': _LocalesManager2.default.getCaption('volumeSliderThumb', 'other'), className: 'sliderThumb', ref: 'thumb', style: thumbStyle, onKeyDown: this.onKeyDown, onMouseOver: this.onThumbMouseIn, onMouseOut: this.onThumbMouseOut })
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var storySoundVolume = state.production.storySoundVolume;
	    var soundVolume = state.currentSlide && state.currentSlide.model ? state.currentSlide.model.soundVolume : 1;
	    var soundEffectVolume = state.currentSlide && state.currentSlide.model ? state.currentSlide.model.soundEffectVolume : 1;
	    var timelines = state.audioEditor.timelines;
	    var volume = state.audioEditor.volume;
	
	    if (volume == undefined) volume = 0.5;
	
	    return {
	        storySoundVolume: storySoundVolume,
	        soundVolume: soundVolume,
	        soundEffectVolume: soundEffectVolume,
	        timelines: timelines,
	        volume: volume
	    };
	}
	
	var VolumeSlider = exports.VolumeSlider = (0, _reactRedux.connect)(mapStateToProps)(VolumeSliderContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/VolumeSlider.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/VolumeSlider.js"); } } })();

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moodsUtils = {
	    moods: [],
	    clipartModel: undefined,
	
	    addMood: function addMood(logicalName, moods) {
	        this.moods[logicalName] = moods;
	    },
	    getMoods: function getMoods(logicalName) {
	        return this.moods[logicalName];
	    },
	    updateProductionMoods: function updateProductionMoods() {
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _ProductionActions.updateProductionMoods)());
	        dispatch((0, _CurrentSlideActions.updateCurrentSlideMoods)());
	    },
	
	
	    previewContextMenu: _ModeConstants2.default.CONTEXT_NONE
	};
	
	exports.default = moodsUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/MoodsUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/MoodsUtils.js"); } } })();

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var slideUtils = {
	    startPosition: -1,
	    slideInitialPosition: -1,
	    currentArrow: -1,
	    startTime: -1,
	    slideOffset: 0,
	    videoModel: undefined,
	    slidesDurationMap: undefined,
	    updateAllThumbnails: false,
	    hideDescription: false,
	
	    initMap: function initMap() {
	        this.slidesDurationMap = [];
	        var currentIndex = _StoreManager2.default.getState().currentSlide.currentSlideIndex;
	        var slides = _StoreManager2.default.getState().production.slides;
	        var i;
	        var totalDuration = 0;
	
	        for (i = 0; i < slides.length; i++) {
	            this.slidesDurationMap.push(totalDuration);
	
	            if (currentIndex == i) totalDuration = totalDuration + _AudioEditorUtils2.default.getSlideWidth(_StoreManager2.default.getState().currentSlide.model.time);else totalDuration = totalDuration + _AudioEditorUtils2.default.getSlideWidth(slides[i].time);
	        }
	    },
	    generateSlideTitle: function generateSlideTitle(slides) {
	        var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	
	        var theSameName = false;
	        var slideTitle = void 0;
	        var tempTitle = 'Slide ';
	        var i = void 0;
	        var slide = void 0;
	
	        if (length != -1) {
	            if (length == 0) length = 1;
	            tempTitle = tempTitle + length;
	        } else tempTitle = tempTitle + (slides.length + 1);
	
	        for (i = 0; i < slides.length; i++) {
	            slide = slides[i];
	
	            if (slide.title == tempTitle) theSameName = true;
	        }
	
	        if (theSameName == true) slideTitle = this.generateSlideTitle(slides, length + 1);else slideTitle = tempTitle;
	
	        return slideTitle;
	    },
	    updateFreehandData: function updateFreehandData(slides) {
	        var i, j, k;
	
	        for (i = 0; i < slides.length; i++) {
	            var shapes = slides[i].content;
	
	            for (j = 0; j < shapes.length; j++) {
	                if (shapes[j].type == _ShapeConstants2.default.FREEHAND) {
	                    if (shapes[j].isNew) return;
	
	                    this.fixPoints(shapes[j].pathPoints);
	                } else if (shapes[j].type == _ShapeConstants2.default.GROUP) this.parseGroup(shapes[j]);
	            }
	        }
	    },
	    parseGroup: function parseGroup(group) {
	        var shapes = group.shapes;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].type == _ShapeConstants2.default.FREEHAND) {
	                if (shapes[i].isNew) return;
	
	                this.fixPoints(shapes[i].pathPoints);
	            }
	        }
	    },
	    fixPoints: function fixPoints(points) {
	        var k;
	
	        for (k = 0; k < points.length; k++) {
	            points[k].x = Number(points[k].x).toFixed(2);
	            points[k].y = Number(points[k].y).toFixed(2);
	        }
	    }
	};
	
	exports.default = slideUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SlidesUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SlidesUtils.js"); } } })();

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 127 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(251);
	
	var ReactBaseClasses = __webpack_require__(392);
	var ReactChildren = __webpack_require__(914);
	var ReactDOMFactories = __webpack_require__(915);
	var ReactElement = __webpack_require__(129);
	var ReactPropTypes = __webpack_require__(916);
	var ReactVersion = __webpack_require__(917);
	
	var createReactClass = __webpack_require__(918);
	var onlyChild = __webpack_require__(922);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(251);
	
	var ReactCurrentOwner = __webpack_require__(86);
	
	var warning = __webpack_require__(29);
	var canDefineProperty = __webpack_require__(396);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(394);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(69);
	var TAG = __webpack_require__(34)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(69);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 132 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var EventPluginRegistry = __webpack_require__(213);
	var EventPluginUtils = __webpack_require__(214);
	var ReactErrorUtils = __webpack_require__(218);
	
	var accumulateInto = __webpack_require__(314);
	var forEachAccumulated = __webpack_require__(315);
	var invariant = __webpack_require__(19);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(133);
	var EventPluginUtils = __webpack_require__(214);
	
	var accumulateInto = __webpack_require__(314);
	var forEachAccumulated = __webpack_require__(315);
	var warning = __webpack_require__(29);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 135 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(84);
	
	var getEventTarget = __webpack_require__(223);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _uuid = __webpack_require__(68);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _DurationUtils = __webpack_require__(140);
	
	var _DurationUtils2 = _interopRequireDefault(_DurationUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timelineDragManager = {
	    dragElement: undefined,
	    limits: undefined,
	    startX: undefined,
	    startY: undefined,
	    itemWidth: undefined,
	    dropIndex: -1,
	    dropPosition: -1,
	    isShift: false,
	    isKeyboardEventsInit: false,
	
	    getLimits: function getLimits(windowHeight, leftPos, topPos) {
	        this.limits = [];
	
	        var timelinesLength = _AudioEditorUtils2.default.getTimelinesLength();
	        var audioEditorHeight = timelinesLength * _AudioToolUtils2.default.timelineHeight() + 30;
	        var topGlobalLimit;
	        var i;
	
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            topGlobalLimit = _AudioToolUtils2.default.headerHeight() + _AudioToolUtils2.default.getTimelineComponentTopOffset();
	
	            if (_PlatformDetection2.default.isIOSApp()) topGlobalLimit = topGlobalLimit + _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        } else topGlobalLimit = windowHeight - audioEditorHeight;
	
	        for (i = 0; i <= timelinesLength; i++) {
	            this.limits.push(_AudioToolUtils2.default.timelineHeight() * i);
	        }this.startX = leftPos;
	        this.startY = topPos - topGlobalLimit;
	    },
	    getCssProperty: function getCssProperty(value) {
	        return Number(value.substring(0, value.length - 2));
	    },
	    addKeyboardEvents: function addKeyboardEvents() {
	        if (!this.isKeyboardEventsInit) {
	            document.addEventListener('keydown', this.onKeyDown.bind(this));
	            document.addEventListener('keyup', this.onKeyUp.bind(this));
	            this.isKeyboardEventsInit = true;
	        }
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.shiftKey) this.isShift = true;
	    },
	    onKeyUp: function onKeyUp(e) {
	        if (e.shiftKey) this.isShift = true;else this.isShift = false;
	    },
	    createClone: function createClone(target, windowHeight, leftPos, topPos, itemWidth) {
	        this.addKeyboardEvents();
	
	        var parent = document.getElementById('timeline');
	
	        if (this.dragElement && this.dragElement.parentNode) this.dragElement.parentNode.removeChild(this.dragElement);
	
	        this.getLimits(windowHeight, leftPos, topPos);
	
	        var holder = document.createElement('div');
	        holder.style.position = 'absolute';
	        holder.style.left = this.startX + 'px';
	        holder.style.top = this.startY + 'px';
	        // holder.style.cursor = '-webkit-grabbing';
	        holder.style.opacity = 0;
	
	        var clone = target.cloneNode(true);
	        clone.style.position = 'absolute';
	        clone.style.left = '0px';
	        clone.style.paddingTop = '0px';
	        clone.style.paddingLeft = '0px';
	        // clone.style.cursor = '-webkit-grabbing';
	        clone.style.display = 'block';
	        clone.style.height = this.getCssProperty(clone.style.height) - 2 + 'px';
	
	        holder.appendChild(clone);
	        this.dragElement = holder;
	
	        parent.appendChild(this.dragElement);
	
	        this.itemWidth = itemWidth;
	
	        this.clearScrollInverval();
	    },
	    move: function move(offsetX, offsetY, e) {
	        var target = this.dragElement;
	
	        if (target == undefined) return;
	
	        target.style.opacity = 0.8;
	
	        var newX = this.startX + offsetX;
	        var newY = this.startY + offsetY;
	        var i;
	
	        if (newY < this.limits[0]) {
	            newY = this.limits[0];
	            this.dropIndex = 0;
	        } else if (newY >= this.limits[this.limits.length - 1]) {
	            newY = this.limits[this.limits.length - 2];
	            this.dropIndex = this.limits.length - 2;
	        } else {
	            for (i = 0; i < this.limits.length - 1; i++) {
	                if (newY >= this.limits[i] && newY < this.limits[i + 1]) {
	                    newY = this.limits[i];
	                    this.dropIndex = i;
	                    break;
	                }
	            }
	        }
	
	        if (newX <= 0) newX = 0;
	
	        target.style.top = newY + 2 + 'px';
	        target.style.left = newX + 'px';
	
	        this.dropPosition = newX;
	
	        this.checkScroll(offsetX, e);
	    },
	
	
	    moveScroll: undefined,
	    positionValue: 1,
	    scrollTimerVar: undefined,
	    checkScroll: function checkScroll(offsetX, e) {
	        var position = _MouseUtils2.default.getTouchPosition(e);
	
	        if (position.x > this.getLeftLimit() && position.x < this.getRightLimit()) {
	            this.clearScrollInverval();
	            return;
	        }
	
	        if (position.x >= this.getRightLimit()) {
	            if (!this.scrollTimerVar) {
	                this.positionValue = 1;
	                this.scrollTimerVar = setInterval(this.moveScrollAtInterval.bind(this), 100);
	                this.moveScroll();
	            }
	        } else if (position.x <= this.getLeftLimit()) {
	            if (!this.scrollTimerVar) {
	                this.positionValue = -1;
	                this.scrollTimerVar = setInterval(this.moveScrollAtInterval.bind(this), 100);
	                this.moveScroll(-1);
	            }
	        }
	    },
	    moveScrollAtInterval: function moveScrollAtInterval() {
	        this.moveScroll(this.positionValue);
	
	        var leftPos = this.dragElement.style.left.replace('px', '');
	        leftPos = parseInt(leftPos);
	
	        if (this.positionValue > 0) this.dropPosition = leftPos + _Properties2.default.AUTO_SCROLL_STEP;else this.dropPosition = leftPos - _Properties2.default.AUTO_SCROLL_STEP;
	
	        if (this.dropPosition < 0) this.dropPosition = 0;
	
	        this.dragElement.style.left = this.dropPosition + 'px';
	    },
	    clearScrollInverval: function clearScrollInverval() {
	        if (this.scrollTimerVar) clearInterval(this.scrollTimerVar);
	
	        this.scrollTimerVar = undefined;
	    },
	    getLeftLimit: function getLeftLimit() {
	        return _AudioToolUtils2.default.buttonsHolderWidth();
	    },
	    getRightLimit: function getRightLimit() {
	        var state = _StoreManager2.default.getState();
	        var windowWidth = state.production.windowWidth;
	        var accordionWidth = state.accordion.width;
	
	        if (!(windowWidth > 0)) windowWidth = window.innerWidth;
	
	        if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	        return windowWidth - accordionWidth;
	    },
	    removeClone: function removeClone(dispatch, properties) {
	        if (this.dragElement && this.dragElement.parentNode) this.dragElement.parentNode.removeChild(this.dragElement);
	
	        if (this.isShift) this.dragAndClone(dispatch, properties);else this.setNewPosition(dispatch, properties);
	
	        this.clearScrollInverval();
	    },
	    dragAndClone: function dragAndClone(dispatch, properties) {
	        if (this.dropIndex != -1 && this.dropPosition != -1) {
	            properties.endIndex = this.dropIndex;
	            properties.audio.left = _AudioEditorUtils2.default.getItemTimePosition(this.dropPosition);
	
	            dispatch((0, _AudioEditorActions.setMarkerPosition)(properties.audio.left));
	            dispatch((0, _AudioEditorActions.dragAndCloneElement)(properties));
	
	            _SaveManager2.default.isContentChanged(true);
	            _AudioEditorUtils2.default.addActionToHistory();
	            _AudioEditorUtils2.default.checkTimelineWidth();
	        }
	
	        this.dropIndex = -1;
	        this.dropPosition = -1;
	    },
	    setNewPosition: function setNewPosition(dispatch, properties) {
	        if (this.dropIndex != -1 && this.dropPosition != -1) {
	            properties.endIndex = this.dropIndex;
	            properties.audio.left = _AudioEditorUtils2.default.getItemTimePosition(this.dropPosition);
	
	            if (!properties.audio.showControlPoint) dispatch((0, _AudioEditorActions.selectElement)(properties.audio.uuid, true));
	
	            dispatch((0, _AudioEditorActions.changeElementPosition)(properties));
	
	            setTimeout(this.checkMarkerPosition.bind(this), 10);
	
	            _SaveManager2.default.isContentChanged(true);
	            _AudioEditorUtils2.default.addActionToHistory();
	            _AudioEditorUtils2.default.checkTimelineWidth();
	        }
	
	        this.dropIndex = -1;
	        this.dropPosition = -1;
	    },
	    checkMarkerPosition: function checkMarkerPosition() {
	        var state = _StoreManager2.default.getState();
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        var markerPosition = state.audioEditor.markerPosition;
	        var markerLastPosition = _AudioEditorUtils2.default.getTimelinesMaxPosition();
	
	        if (markerPosition > markerLastPosition) dispatch((0, _AudioEditorActions.setMarkerPosition)(markerLastPosition));
	    },
	
	
	    //Drag-drop functionality for Audio menus
	    audioItem: undefined,
	    accordionWidth: -1,
	    windowWidth: -1,
	    windowHeight: -1,
	
	    createAudioClone: function createAudioClone() {
	        this.removeOldAudioItem();
	
	        var lineSize = 3;
	        var size = _AudioToolUtils2.default.timelineHeight();
	        var holder = document.createElement('div');
	        holder.style.position = 'absolute';
	        holder.style.left = this.startX + 'px';
	        holder.style.top = this.startY + 'px';
	        holder.style.width = size + 'px';
	        holder.style.height = size + 'px';
	        holder.style.background = 'red';
	        holder.style.opacity = 0;
	
	        var insideFrame = document.createElement('div');
	        insideFrame.style.position = 'absolute';
	        insideFrame.style.left = lineSize + 'px';
	        insideFrame.style.top = lineSize + 'px';
	        insideFrame.style.width = size - 2 * lineSize + 'px';
	        insideFrame.style.height = size - 2 * lineSize + 'px';
	        insideFrame.style.background = '#47AFE3';
	        holder.appendChild(insideFrame);
	
	        var iconSize = 40;
	        var icon = document.createElement('img');
	        icon.style.position = 'absolute';
	        icon.style.top = size / 2 - iconSize / 2 + 'px';
	        icon.style.left = size / 2 - iconSize / 2 + 'px';
	        icon.style.width = iconSize + 'px';
	        icon.style.height = iconSize + 'px';
	        icon.style.cursor = '-webkit-grabbing';
	        icon.setAttribute('src', _AppParameters2.default.RESOURCES_LOCATION() + 'assets/mySounds.png');
	
	        holder.appendChild(icon);
	
	        document.body.appendChild(holder);
	
	        this.dragElement = holder;
	    },
	    removeOldAudioItem: function removeOldAudioItem() {
	        if (this.dragElement && this.dragElement.parentNode) this.dragElement.parentNode.removeChild(this.dragElement);
	    },
	    clearAudioItem: function clearAudioItem() {
	        this.audioItem = undefined;
	    },
	    startAudioDrag: function startAudioDrag(e, item) {
	        if (!_PlayController2.default.isAudioEditorMode()) return;
	
	        this.audioItem = item;
	        var touchPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.startX = touchPosition.x;
	        this.startY = touchPosition.y;
	
	        this.getTimelinesLimits();
	        this.createAudioClone();
	    },
	    moveAudio: function moveAudio(e, coreEvent) {
	        if (!_PlayController2.default.isAudioEditorMode() || !this.audioItem) return;
	
	        var target = this.dragElement;
	
	        if (target == undefined) return;
	
	        target.style.opacity = 0.7;
	
	        target.style.left = this.startX + coreEvent.lastX + 'px';
	        target.style.top = this.startY + coreEvent.lastY + 'px';
	
	        this.checkPosition(this.startX + coreEvent.lastX, this.startY + coreEvent.lastY);
	    },
	    endAudioDrag: function endAudioDrag(e, coreEvent) {
	        if (!_PlayController2.default.isAudioEditorMode() || !this.audioItem) return;
	
	        this.checkPosition(this.startX + coreEvent.lastX, this.startY + coreEvent.lastY, true);
	
	        this.removeOldAudioItem();
	    },
	    getTimelinesLimits: function getTimelinesLimits() {
	        this.limits = [];
	
	        var state = _StoreManager2.default.getState();
	        var accordionWidth = state.accordion.width;
	
	        if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	        this.accordionWidth = accordionWidth;
	        this.windowWidth = state.production.windowWidth;
	        this.windowHeight = state.production.windowHeight;
	
	        var timelinesLength = _AudioEditorUtils2.default.getTimelinesLength();
	        var audioEditorHeight = timelinesLength * _AudioToolUtils2.default.timelineHeight() + 30;
	        var i;
	        var topGlobalLimit;
	
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            topGlobalLimit = _AudioToolUtils2.default.headerHeight() + _AudioToolUtils2.default.getTimelineComponentTopOffset();
	
	            if (_PlatformDetection2.default.isIOSApp()) topGlobalLimit = topGlobalLimit + _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        } else topGlobalLimit = this.windowHeight - audioEditorHeight;
	
	        for (i = 0; i <= timelinesLength; i++) {
	            this.limits.push(topGlobalLimit + _AudioToolUtils2.default.timelineHeight() * i);
	        }
	    },
	    checkPosition: function checkPosition(x, y) {
	        var isEndAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        var topLimit = this.limits[0];
	        var bottomLimit = this.limits[this.limits.length - 1];
	        var leftLimit = _AudioToolUtils2.default.buttonsHolderWidth();
	        var rightLimit = this.windowWidth - this.accordionWidth;
	
	        if (y > topLimit && y < bottomLimit && x > leftLimit && x < rightLimit) {
	            this.dragElement.style.background = 'green';
	
	            if (isEndAction) this.addItemToTimeline(x, y);
	        } else {
	            this.dragElement.style.background = 'red';
	        }
	    },
	    addItemToTimeline: function addItemToTimeline(x, y) {
	        var i;
	        var currentIndex = -1;
	
	        for (i = 0; i < this.limits.length - 1; i++) {
	            if (y >= this.limits[i] && y < this.limits[i + 1]) {
	                currentIndex = i;
	                break;
	            }
	        }
	
	        if (currentIndex < 0) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        var audio = {};
	
	        audio.uuid = _uuid2.default.v4();
	        audio.title = this.audioItem.title;
	        audio.href = this.audioItem.href;
	        audio.inPoint = 0;
	        audio.outPoint = 0;
	        audio.left = this.getLeftPosition(x); // added in seconds
	
	        if (this.audioItem.durationInSeconds > 0) audio.duration = this.audioItem.durationInSeconds;else audio.duration = _DurationUtils2.default.transformDurationFromStringToSeconds(this.audioItem.duration);
	
	        _PlayController2.default.getOldScrollPosition();
	        dispatch((0, _AudioEditorActions.addAudioToTimeline)(currentIndex, audio));
	        dispatch((0, _AudioEditorActions.setMarkerPosition)(audio.left));
	        _SaveManager2.default.isContentChanged(true);
	
	        _AudioEditorUtils2.default.addActionToHistory();
	        _AudioEditorUtils2.default.checkTimelineWidth();
	    },
	    getLeftPosition: function getLeftPosition(x) {
	        var localX = x - _AudioToolUtils2.default.buttonsHolderWidth();
	        var scrollPos = _PlayController2.default.getScrollPosition();
	
	        return _AudioEditorUtils2.default.getItemTimePosition(scrollPos + localX);
	    },
	
	
	    /****** Multiple selection **************/
	    multipleSelection: [],
	    originalPositions: [],
	    minLeftPos: -1,
	    dispatch: undefined,
	    blockClone: undefined,
	    minIndex: -1,
	    maxIndex: -1,
	
	    resetMultipleSelection: function resetMultipleSelection() {
	        this.multipleSelection = [];
	        this.removeBlockClone();
	    },
	    getMultipleSelection: function getMultipleSelection(start, end) {
	        if (!(start.x != end.x || start.y != end.y)) {
	            this.multipleSelection = [];
	            return;
	        }
	
	        var timelinesLength = _AudioEditorUtils2.default.getTimelinesLength();
	        var trackHeight = _AudioToolUtils2.default.timelineHeight();
	        var topLimit = Math.min(start.y, end.y);
	        var bottomLimit = Math.max(start.y, end.y);
	        var indexArary = [];
	        var i;
	
	        for (i = 0; i < timelinesLength; i++) {
	            var trackTopPos = i * trackHeight;
	            var trackBottomPos = (i + 1) * trackHeight;
	
	            if (topLimit <= trackTopPos && bottomLimit > trackTopPos || bottomLimit >= trackBottomPos && topLimit < trackBottomPos || topLimit >= trackTopPos && bottomLimit <= trackBottomPos) {
	                indexArary.push(i);
	            }
	        }
	
	        if (indexArary.length == 0) {
	            this.multipleSelection = [];
	            return;
	        }
	
	        this.originalPositions = [];
	        var state = _StoreManager2.default.getState();
	        var timelines = state.audioEditor.timelines;
	        var timeline;
	        var leftLimit = _AudioEditorUtils2.default.getItemTimePosition(Math.min(start.x, end.x));
	        var rightLimit = _AudioEditorUtils2.default.getItemTimePosition(Math.max(start.x, end.x));
	        var items = [];
	        var minLeft = -1;
	        var k;
	
	        this.minIndex = -1;
	        this.maxIndex = -1;
	
	        for (k = 0; k < indexArary.length; k++) {
	            var currentIndex = indexArary[k];
	            timeline = timelines[indexArary[k]];
	
	            for (i = 0; i < timeline.audios.length; i++) {
	                var audioLeftPos = timeline.audios[i].left;
	                var audioRightPos = timeline.audios[i].left + timeline.audios[i].duration;
	
	                if (leftLimit <= audioLeftPos && rightLimit > audioLeftPos || rightLimit >= audioRightPos && leftLimit < audioRightPos || leftLimit >= audioLeftPos && rightLimit <= audioRightPos) {
	                    items.push(timeline.audios[i].uuid);
	
	                    if (minLeft == -1) minLeft = timeline.audios[i].left;else minLeft = Math.min(minLeft, timeline.audios[i].left);
	
	                    this.originalPositions[timeline.audios[i].uuid] = { left: timeline.audios[i].left, index: currentIndex };
	
	                    if (this.minIndex == -1) {
	                        this.minIndex = currentIndex;
	                        this.maxIndex = currentIndex;
	                    } else {
	                        this.minIndex = Math.min(this.minIndex, currentIndex);
	                        this.maxIndex = Math.max(this.maxIndex, currentIndex);
	                    }
	                }
	            }
	        }
	
	        this.multipleSelection = items;
	        this.minLeftPos = minLeft;
	    },
	    isMultipleSelection: function isMultipleSelection(currentUid) {
	        if (this.multipleSelection.length > 1 && this.multipleSelection.indexOf(currentUid) != -1) return true;else return false;
	    },
	    prepareClone: function prepareClone() {
	        if (this.multipleSelection.length < 1) return;
	
	        var parent = document.getElementById('timeline');
	
	        if (parent && this.blockClone && this.blockClone.parentNode) parent.removeChild(this.blockClone);
	
	        var holder = document.createElement('div');
	        holder.style.position = 'absolute';
	        holder.style.left = this.startX + 'px';
	        holder.style.top = this.startY + 'px';
	        holder.style.opacity = 0;
	
	        for (var i = 0; i < this.multipleSelection.length; i++) {
	            var target = document.getElementById('clone_' + this.multipleSelection[i]);
	
	            if (!target) continue;
	
	            var clone = target.cloneNode(true);
	
	            clone.style.position = 'absolute';
	            clone.style.left = _AudioEditorUtils2.default.getSlideWidth(this.originalPositions[this.multipleSelection[i]].left - this.minLeftPos) + 'px';
	            clone.style.top = this.getInternalTopPos(this.multipleSelection[i]) + 'px';
	            clone.style.paddingTop = '0px';
	            clone.style.paddingLeft = '0px';
	            clone.style.display = 'block';
	            // clone.style.background = '#ffffff';
	            clone.style.height = this.getCssProperty(clone.style.height) - 2 + 'px';
	
	            holder.appendChild(clone);
	        }
	
	        this.blockClone = holder;
	
	        parent.appendChild(this.blockClone);
	    },
	    getInternalTopPos: function getInternalTopPos(uuid) {
	        var index = this.originalPositions[uuid].index - this.minIndex;
	        return _AudioToolUtils2.default.timelineHeight() * index;
	    },
	    startBlock: function startBlock(windowHeight, topPos, dispatch) {
	        this.dispatch = dispatch;
	
	        var leftPos = _AudioEditorUtils2.default.getItemPosition(this.minLeftPos);
	        this.getLimits(windowHeight, leftPos, topPos);
	        this.prepareClone();
	    },
	    moveBlockWithOffset: function moveBlockWithOffset(offsetX, offsetY, uuid) {
	        var target = this.blockClone;
	
	        if (target == undefined) return;
	
	        var properties = this.getCorrectPosition(offsetX, offsetY, uuid);
	
	        target.style.opacity = 0.8;
	        target.style.left = properties.x + 'px';
	        target.style.top = properties.y + 2 + 'px';
	    },
	    getCorrectPosition: function getCorrectPosition(offsetX, offsetY, uuid) {
	        var newX = this.startX + offsetX;
	        var newY = this.startY + offsetY;
	        var i;
	        var newIndex;
	        var internalTopOffset = this.getInternalTopPos(uuid);
	        var offsetIndex = this.maxIndex - this.minIndex;
	
	        newY = newY - internalTopOffset;
	
	        if (newY < this.limits[0]) {
	            newY = this.limits[0];
	            newIndex = 0;
	        } else if (newY >= this.limits[this.limits.length - offsetIndex - 1]) {
	            newY = this.limits[this.limits.length - offsetIndex - 2];
	            newIndex = this.limits.length - offsetIndex - 2;
	        } else {
	            for (i = 0; i < this.limits.length - 1; i++) {
	                if (newY >= this.limits[i] && newY < this.limits[i + 1]) {
	                    newY = this.limits[i];
	                    newIndex = i;
	                    break;
	                }
	            }
	        }
	
	        if (newX <= 0) newX = 0;
	
	        var props = {};
	        props.x = newX;
	        props.y = newY;
	        props.indexOffset = newIndex - this.minIndex;
	
	        return props;
	    },
	    removeBlockClone: function removeBlockClone() {
	        if (this.blockClone && this.blockClone.parentNode) this.blockClone.parentNode.removeChild(this.blockClone);
	    },
	    endBlock: function endBlock(offsetX, offsetY, uuid) {
	        this.removeBlockClone();
	        _SaveManager2.default.isContentChanged(true);
	
	        var properties = this.getCorrectPosition(offsetX, offsetY, uuid);
	        var offset = _AudioEditorUtils2.default.getItemTimePosition(properties.x - this.startX);
	
	        setTimeout(function () {
	            if (!this.dispatch) this.dispatch = _StoreManager2.default.getStore().dispatch;
	
	            this.dispatch((0, _AudioEditorActions.moveBlock)(this.multipleSelection, offset, properties.indexOffset));
	            _AudioEditorUtils2.default.addActionToHistory();
	        }.bind(this), 10);
	
	        setTimeout(function () {
	            this.updateBlockProperties(this.multipleSelection, offset, properties.indexOffset);
	        }.bind(this), 20);
	    },
	    updateBlockProperties: function updateBlockProperties(multipleSelection, leftOffset, indexOffset) {
	        this.minIndex = this.minIndex + indexOffset;
	        this.maxIndex = this.maxIndex + indexOffset;
	        this.minLeftPos = this.minLeftPos + leftOffset;
	
	        this.originalPositions = [];
	        var state = _StoreManager2.default.getState();
	        var timelines = state.audioEditor.timelines;
	
	        for (var i = 0; i < timelines.length; i++) {
	            var audios = timelines[i].audios;
	
	            for (var j = 0; j < audios.length; j++) {
	                if (multipleSelection.indexOf(audios[j].uuid) != -1) {
	                    this.originalPositions[audios[j].uuid] = { left: audios[j].left, index: i };
	                }
	            }
	        }
	    }
	};
	
	exports.default = timelineDragManager;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/utils/TimelineDragManager.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/utils/TimelineDragManager.js"); } } })();

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SoundItemRenderer = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _DurationUtils = __webpack_require__(140);
	
	var _DurationUtils2 = _interopRequireDefault(_DurationUtils);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _TimelineDragManager = __webpack_require__(137);
	
	var _TimelineDragManager2 = _interopRequireDefault(_TimelineDragManager);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AudioConverter = __webpack_require__(231);
	
	var _AudioConverter2 = _interopRequireDefault(_AudioConverter);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SoundItemRenderer = exports.SoundItemRenderer = _react2.default.createClass({
	    displayName: 'SoundItemRenderer',
	    getInitialState: function getInitialState() {
	        return {
	            isPlayOver: false,
	            isTitleOver: false,
	            isPlaying: false,
	            clientX: 0,
	            clientY: 0,
	            element1: undefined
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        _AudioUtils2.default.initContextSound();
	        this.initElements();
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        _AudioUtils2.default.cleanContextSound();
	    },
	    initElements: function initElements() {
	        var itemStyle = {
	            position: 'absolute',
	            backgroundColor: 'white',
	            width: this.props.accordionWidth,
	            height: _Properties2.default.SOUND_ITEM_HEIGHT,
	            top: this.props.index * (_Properties2.default.SOUND_ITEM_HEIGHT + _Properties2.default.SOUND_ITEMS_GAP),
	            left: 0
	        };
	
	        var borderColor;
	        var iconColor;
	        var backgroundColor = _Properties2.default.SOUND_ODD_COLOR;
	
	        if (this.props.index % 2 == 0) backgroundColor = _Properties2.default.SOUND_EVEN_COLOR;
	
	        if (this.state.isTitleOver == true) {
	            iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	        } else {
	            iconColor = 'black';
	            borderColor = backgroundColor;
	        }
	
	        var middlePadding = 10;
	        var titleWrapperWidth = this.props.accordionWidth - 2 * _Properties2.default.EFFECTS_PADDING - _Properties2.default.SOUND_ITEM_HEIGHT - middlePadding;
	
	        var titleWrapperStyle = {
	            width: titleWrapperWidth - 2,
	            height: _Properties2.default.SOUND_ITEM_HEIGHT - 2,
	            background: backgroundColor,
	            position: 'absolute',
	            left: _Properties2.default.EFFECTS_PADDING + _Properties2.default.SOUND_ITEM_HEIGHT + middlePadding,
	            top: 0,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid'
	        };
	
	        var durationWidth = 40;
	        var padding = 8;
	        var fontSize = 13;
	        var topPosition = 12;
	
	        var titleStyle = {
	            position: 'absolute',
	            left: padding,
	            top: topPosition,
	            width: titleWrapperWidth - 3 * padding - durationWidth,
	            fontSize: fontSize,
	            cursor: 'default',
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis'
	        };
	
	        var durationStyle = {
	            position: 'absolute',
	            right: padding,
	            top: topPosition,
	            width: durationWidth,
	            fontSize: fontSize,
	            cursor: 'default'
	        };
	
	        var duration = '(' + this.props.value.duration + ')';
	
	        var element1;
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            element1 = _react2.default.createElement(
	                'span',
	                { style: titleWrapperStyle, onMouseDown: this.onMouseDown, onMouseUp: this.onTitleMouseUp, onTouchStart: this.onMouseDown, onTouchEnd: this.onTitleMouseUp, onMouseOver: this.onTitleMouseIn, onMouseOut: this.onTitleMouseOut },
	                _react2.default.createElement(
	                    'span',
	                    { style: titleStyle },
	                    this.props.value.title
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { style: durationStyle },
	                    duration
	                )
	            );
	
	            this.setState({
	                itemStyle: itemStyle,
	                element1: element1
	            });
	        } else {
	            element1 = _react2.default.createElement(
	                'span',
	                { style: titleStyle },
	                this.props.value.title
	            );
	            var element2 = _react2.default.createElement(
	                'span',
	                { style: durationStyle },
	                duration
	            );
	
	            this.setState({
	                itemStyle: itemStyle,
	                element1: element1,
	                element2: element2
	            });
	        }
	    },
	    getButtonLabel: function getButtonLabel() {
	        if (_AppParameters2.default.locale.indexOf('NO') != -1) {
	            if (this.state.isPlaying) return _LocalesManager2.default.getCaption('stopp', 'other') + ' ' + this.props.value.title;else return _LocalesManager2.default.getCaption('spillAv', 'other') + ' ' + this.props.value.title;
	        } else {
	            if (this.state.isPlaying) return _LocalesManager2.default.getCaption('stopp', 'other') + ' ' + this.props.value.title;else return _LocalesManager2.default.getCaption('spillAv', 'other') + ' ' + this.props.value.title;
	        }
	    },
	    onPlayMouseIn: function onPlayMouseIn() {
	        if (_AppParameters2.default.locale.indexOf('NO') != -1) _HoverManager2.default.show(this.refs.play, this.getButtonLabel(), 'top', true);else _HoverManager2.default.show(this.refs.play, 'playSoundItem');
	
	        this.setState({
	            isPlayOver: true
	        });
	    },
	    onPlayMouseOut: function onPlayMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isPlayOver: false,
	            isTitleOver: false
	        });
	    },
	    onTitleMouseIn: function onTitleMouseIn() {
	        this.setState({
	            isTitleOver: true
	        });
	    },
	    onTitleMouseOut: function onTitleMouseOut() {
	        this.setState({
	            isPlayOver: false,
	            isTitleOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onTitleMouseUp: function onTitleMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlayController2.default.isAudioEditorAvailable()) return;
	
	        this.checkSound(e);
	    },
	    checkSound: function checkSound(e) {
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 10 && Math.abs(clientPosition.y - this.state.clientY) < 10) this.addSound();
	    },
	    onPlayMouseUp: function onPlayMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 10 && Math.abs(clientPosition.y - this.state.clientY) < 10) this.playSound();
	    },
	    onTitleClick: function onTitleClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.addSound();
	    },
	    onPlayClick: function onPlayClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.playSound();
	    },
	    updatePlayingStatus: function updatePlayingStatus(value) {
	        this.setState({
	            isPlaying: value
	        });
	
	        this.forceUpdate();
	    },
	    playSound: function playSound() {
	        if (!this.state.isPlaying) _AudioUtils2.default.playSoundFromUrl(this.props.value.href, this.updatePlayingStatus);else _AudioUtils2.default.pauseSound('audioBrowserSound');
	    },
	    addSound: function addSound() {
	        var sound = this.props.value;
	        var duration;
	
	        _SaveManager2.default.isContentChanged(true);
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            if (_PlayController2.default.isAudioEditorMode()) {
	                _PlayController2.default.getOldScrollPosition();
	                _AudioEditorUtils2.default.addItemToTimeline(sound, this.props.categoryIndex);
	            } else {
	                _PlayController2.default.toggleAudioEditorMode();
	
	                setTimeout(function () {
	                    _PlayController2.default.getOldScrollPosition();
	                    _AudioEditorUtils2.default.addItemToTimeline(sound, this.props.categoryIndex);
	                }.bind(this), 50);
	            }
	        } else {
	            if (this.props.isMediaSound == true) {
	                this.props.dispatch((0, _CurrentSlideActions.setSlideSoundEffect)(sound));
	                this.props.dispatch((0, _MenuActions.showAudioAlert)(1, sound.title));
	
	                // the order for deciding the slide duration for a slide is: video, shape video with the long duration, recorded sound and media/effect sound
	                if (!_VideoUtils2.default.isVideoBackground() && _VideoUtils2.default.getMaxDurationFromVideoShapes() === 0) {
	                    if (sound.duration && !_AudioUtils2.default.hasSlideSound()) {
	                        if (sound.durationInSeconds > 0) duration = sound.durationInSeconds;else duration = _DurationUtils2.default.transformDurationFromStringToSeconds(sound.duration);
	
	                        if (duration > 0) {
	                            this.props.dispatch((0, _CurrentSlideActions.changeSlideDuration)(duration));
	
	                            _AudioConverter2.default.addSoundDurationToMap(sound.href, duration);
	                        }
	                    }
	                }
	            } else {
	                this.props.dispatch((0, _ProductionActions.addStorySound)(sound));
	                this.props.dispatch((0, _MenuActions.showAudioAlert)(2, sound.title));
	
	                if (sound.durationInSeconds > 0) duration = sound.durationInSeconds;else duration = _DurationUtils2.default.transformDurationFromStringToSeconds(sound.duration);
	
	                if (duration > 0) _AudioConverter2.default.addSoundDurationToMap(sound.href, duration);
	            }
	
	            _AudioEditorUtils2.default.addActionToHistory();
	
	            if (_StoreManager2.default.getState().menu.contextMode != _ModeConstants2.default.SEARCH_CONTEXT) // if is Search menu then don't hide
	                this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	        }
	    },
	    onDrag: function onDrag(e) {
	        if (!_PlayController2.default.isAudioEditorAvailable()) return;
	
	        var target = e.target;
	
	        if (target && target.className && target.className.indexOf('playButton') != -1) {
	            _TimelineDragManager2.default.clearAudioItem();
	            return;
	        }
	
	        _TimelineDragManager2.default.startAudioDrag(e, this.props.value);
	    },
	    onMove: function onMove(e, coreEvent) {
	        if (!_PlayController2.default.isAudioEditorAvailable()) return;
	
	        _TimelineDragManager2.default.moveAudio(e, coreEvent);
	    },
	    onDrop: function onDrop(e, coreEvent) {
	        if (!_PlayController2.default.isAudioEditorAvailable()) return;
	
	        var target = e.target;
	        var type = _typeof(target.className);
	
	        if (target && target.className && type == 'string' && target.className.indexOf('playButton') != -1) {
	            return;
	        }
	
	        this.checkSound(e);
	        _TimelineDragManager2.default.endAudioDrag(e, coreEvent);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        var isPlaying = this.state.isPlaying;
	
	        if (this.state.element1 != nextState.element1 || this.state.isPlayOver != nextState.isPlayOver || this.state.isTitleOver != nextState.isTitleOver || isPlaying != this.state.isPlaying) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.element1 == undefined) return _react2.default.createElement('div', null);
	
	        var borderColor;
	        var iconColor;
	
	        if (this.state.isPlayOver == true) {
	            iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	        } else {
	            iconColor = 'black';
	            borderColor = _Properties2.default.SOUND_EVEN_COLOR;
	        }
	
	        var playButtonStyle = {
	            width: _Properties2.default.SOUND_ITEM_HEIGHT - 2,
	            height: _Properties2.default.SOUND_ITEM_HEIGHT - 2,
	            background: _Properties2.default.SOUND_EVEN_COLOR,
	            borderRadius: 50,
	            position: 'absolute',
	            left: _Properties2.default.EFFECTS_PADDING,
	            top: 0,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid'
	        };
	
	        var playIconSrc = 'fa fa-play';
	        var playIconLeftPosition = 16;
	
	        if (this.state.isPlaying) {
	            playIconSrc = 'fa fa-pause';
	            playIconLeftPosition = 14;
	        }
	
	        var playIconStyle = {
	            position: 'absolute',
	            top: 11,
	            left: playIconLeftPosition - 1,
	            color: iconColor
	        };
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	
	            return _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onDrag, onDrag: this.onMove, onStop: this.onDrop },
	                _react2.default.createElement(
	                    'div',
	                    { style: this.state.itemStyle },
	                    _react2.default.createElement(
	                        'div',
	                        { style: playButtonStyle, className: 'playButton', onMouseDown: this.onMouseDown, onMouseUp: this.onPlayMouseUp, onTouchStart: this.onMouseDown, onTouchEnd: this.onPlayMouseUp, onMouseOver: this.onPlayMouseIn, onMouseOut: this.onPlayMouseOut },
	                        _react2.default.createElement('i', { style: playIconStyle, className: playIconSrc + ' playButton' })
	                    ),
	                    this.state.element1
	                )
	            );
	        } else {
	            var backgroundColor = _Properties2.default.SOUND_ODD_COLOR;
	
	            if (this.props.index % 2 == 0) backgroundColor = _Properties2.default.SOUND_EVEN_COLOR;
	
	            if (this.state.isTitleOver == true) {
	                iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	                borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            } else {
	                iconColor = 'black';
	                borderColor = backgroundColor;
	            }
	
	            var middlePadding = 10;
	            var titleWrapperWidth = this.props.accordionWidth - 2 * _Properties2.default.EFFECTS_PADDING - _Properties2.default.SOUND_ITEM_HEIGHT - middlePadding;
	
	            var titleWrapperStyle = {
	                width: titleWrapperWidth - 2,
	                height: _Properties2.default.SOUND_ITEM_HEIGHT - 2,
	                background: backgroundColor,
	                position: 'absolute',
	                left: _Properties2.default.EFFECTS_PADDING + _Properties2.default.SOUND_ITEM_HEIGHT + middlePadding,
	                top: 0,
	                borderColor: borderColor,
	                borderWidth: 1,
	                borderStyle: 'solid',
	                margin: 0,
	                padding: 0,
	                boxSizing: 'initial',
	                fontSize: 'initial',
	                textAlign: 'left'
	            };
	
	            playButtonStyle.margin = 0;
	            playButtonStyle.padding = 0;
	            playButtonStyle.boxSizing = 'initial';
	            playButtonStyle.fontSize = 'initial';
	
	            var playButtonLabel = this.getButtonLabel();
	
	            return _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onDrag, onDrag: this.onMove, onStop: this.onDrop },
	                _react2.default.createElement(
	                    'div',
	                    { style: this.state.itemStyle },
	                    _react2.default.createElement(
	                        'button',
	                        { ref: 'play', 'aria-label': playButtonLabel, style: playButtonStyle, className: 'playButton', onClick: this.onPlayClick, onMouseDown: this.onMouseDown, onMouseUp: this.onPlayMouseUp, onTouchStart: this.onMouseDown, onTouchEnd: this.onPlayMouseUp, onMouseOver: this.onPlayMouseIn, onMouseOut: this.onPlayMouseOut },
	                        _react2.default.createElement('i', { style: playIconStyle, className: playIconSrc + ' playButton' })
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { 'aria-label': this.props.value.title, style: titleWrapperStyle, onClick: this.onTitleClick, onMouseDown: this.onMouseDown, onMouseUp: this.onTitleMouseUp, onTouchStart: this.onMouseDown, onTouchEnd: this.onTitleMouseUp, onMouseOver: this.onTitleMouseIn, onMouseOut: this.onTitleMouseOut },
	                        this.state.element1,
	                        this.state.element2
	                    )
	                )
	            );
	        }
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SoundItemRenderer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SoundItemRenderer.js"); } } })();

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _BubblesUtils = __webpack_require__(235);
	
	var _BubblesUtils2 = _interopRequireDefault(_BubblesUtils);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var speakBubbleUtils = {
	    sectorPosition: 15, // sector gap width (in percent)
	
	    getPath: function getPath(shapeModel) {
	        var shapePoints = this.createShapePoints(shapeModel);
	        var stemPoints = this.getStemPosition(shapeModel, shapePoints);
	
	        var path;
	
	        if (shapeModel.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE) path = this.createComplexPath(shapeModel, stemPoints);else path = this.createPath(shapeModel, stemPoints);
	
	        return path;
	    },
	    createPath: function createPath(shapeModel, points) {
	        if (points[0] == undefined || shapeModel == undefined) return '';
	
	        var data = 'M' + (points[0].x - shapeModel.x) + ',' + (points[0].y - shapeModel.y);
	        var length = points.length;
	        var i;
	        var point;
	
	        for (i = 1; i < length; i++) {
	            point = points[i];
	            point.x = point.x - shapeModel.x;
	            point.y = point.y - shapeModel.y;
	            data += 'L' + point.x + ',' + point.y;
	        }
	
	        return data;
	    },
	    createComplexPath: function createComplexPath(shapeModel, points) {
	        if (points[0] == undefined || shapeModel == undefined) return '';
	
	        var data = '';
	        var length = points.length;
	        var i;
	        var point;
	
	        for (i = 0; i < length; i++) {
	            point = points[i];
	            var x = point.x - shapeModel.x;
	            var y = point.y - shapeModel.y;
	
	            var type = 'L';
	
	            if (i % 3 == 0) type = 'M';
	
	            data += type + x + ',' + y;
	        }
	
	        return data;
	    },
	    createSectors: function createSectors(shapeModel) {
	        var x = shapeModel.x,
	            y = shapeModel.y,
	            width = shapeModel.width,
	            height = shapeModel.height;
	
	        var start = void 0;
	        var end = void 0;
	        var sectors = [];
	        var offset = 20;
	        var strokeOffset = shapeModel.isMindMap ? 0 : shapeModel.strokeWidth + 1;
	        var sectorPosition = shapeModel.isMindMap ? 0 : this.sectorPosition;
	
	        x = x + strokeOffset;
	        y = y + strokeOffset;
	        width = width - 2 * strokeOffset;
	        height = height - 2 * strokeOffset;
	
	        start = y + height * (100 - sectorPosition) / 100 - offset;
	        end = y + height - offset;
	        sectors.push(0);
	        sectors.push({ start: start, end: end });
	
	        start = x + width * (100 - sectorPosition) / 100 - offset;
	        end = x + width - offset;
	        sectors.push({ start: start, end: end });
	
	        start = x + offset;
	        end = x + width * sectorPosition / 100 + offset;
	        sectors.push({ start: start, end: end });
	
	        start = y + height * (100 - sectorPosition) / 100 - offset;
	        end = y + height - offset;
	        sectors.push({ start: start, end: end });
	
	        start = y + offset;
	        end = y + height * sectorPosition / 100 + offset;
	        sectors.push({ start: start, end: end });
	
	        start = x + offset;
	        end = x + width * sectorPosition / 100 + offset;
	        sectors.push({ start: start, end: end });
	
	        start = x + width * (100 - sectorPosition) / 100 - offset;
	        end = x + width - offset;
	        sectors.push({ start: start, end: end });
	
	        start = y + offset;
	        end = y + height * sectorPosition / 100 + offset;
	        sectors.push({ start: start, end: end });
	
	        return sectors;
	    },
	    createShapePoints: function createShapePoints(shapeModel) {
	        var x = shapeModel.x,
	            y = shapeModel.y,
	            width = shapeModel.width,
	            height = shapeModel.height;
	
	        var sectors = this.createSectors(shapeModel);
	        var points = [];
	        var strokeOffset = shapeModel.isMindMap ? 0 : shapeModel.strokeWidth / 2 + 1;
	
	        x = x + strokeOffset;
	        y = y + strokeOffset;
	        width = width - 2 * strokeOffset;
	        height = height - 2 * strokeOffset;
	
	        points.push({ x: x, y: y });
	        points.push({ x: sectors[6].start, y: y });
	        points.push({ x: sectors[6].end, y: y });
	        points.push({ x: sectors[6].end, y: y });
	        points.push({ x: sectors[7].start, y: y });
	        points.push({ x: sectors[7].end, y: y });
	        points.push({ x: sectors[7].end, y: y });
	        points.push({ x: width + x, y: y });
	        points.push({ x: width + x, y: sectors[8].start });
	        points.push({ x: width + x, y: sectors[8].end });
	        points.push({ x: width + x, y: sectors[8].end });
	        points.push({ x: width + x, y: sectors[1].start });
	        points.push({ x: width + x, y: sectors[1].end });
	        points.push({ x: width + x, y: sectors[1].end });
	        points.push({ x: width + x, y: height + y });
	        points.push({ x: sectors[2].end, y: height + y });
	        points.push({ x: sectors[2].start, y: height + y });
	        points.push({ x: sectors[2].start, y: height + y });
	        points.push({ x: sectors[3].end, y: height + y });
	        points.push({ x: sectors[3].start, y: height + y });
	        points.push({ x: sectors[3].start, y: height + y });
	        points.push({ x: x, y: height + y });
	        points.push({ x: x, y: sectors[4].end });
	        points.push({ x: x, y: sectors[4].start });
	        points.push({ x: x, y: sectors[4].start });
	        points.push({ x: x, y: sectors[5].end });
	        points.push({ x: x, y: sectors[5].start });
	        points.push({ x: x, y: sectors[5].start });
	        points.push({ x: x, y: y });
	
	        return points;
	    },
	    getStemPosition: function getStemPosition(shapeModel, points) {
	        var stemPoints = [];
	        var controlPoints = [];
	
	        controlPoints.push({ x: shapeModel.cx, y: shapeModel.cy });
	
	        if (shapeModel.cx1 && shapeModel.cy1) controlPoints.push({ x: shapeModel.cx1, y: shapeModel.cy1 });
	
	        if (shapeModel.cx2 && shapeModel.cy2) controlPoints.push({ x: shapeModel.cx2, y: shapeModel.cy2 });
	
	        if (shapeModel.cx3 && shapeModel.cy3) controlPoints.push({ x: shapeModel.cx3, y: shapeModel.cy3 });
	
	        if (shapeModel.cx4 && shapeModel.cy4) controlPoints.push({ x: shapeModel.cx4, y: shapeModel.cy4 });
	
	        if (shapeModel.cx5 && shapeModel.cy5) controlPoints.push({ x: shapeModel.cx5, y: shapeModel.cy5 });
	
	        for (var i = 0; i < controlPoints.length; i++) {
	            var currentSector = _BubblesUtils2.default.getActiveSector(shapeModel, controlPoints[i]);
	            var newIndex = -1;
	
	            switch (currentSector) {
	                case 1:
	                    {
	                        newIndex = 12;
	                        break;
	                    }
	                case 2:
	                    {
	                        newIndex = 16;
	                        break;
	                    }
	                case 3:
	                    {
	                        newIndex = 19;
	                        break;
	                    }
	                case 4:
	                    {
	                        newIndex = 23;
	                        break;
	                    }
	                case 5:
	                    {
	                        newIndex = 26;
	                        break;
	                    }
	                case 6:
	                    {
	                        newIndex = 2;
	                        break;
	                    }
	                case 7:
	                    {
	                        newIndex = 5;
	                        break;
	                    }
	                case 8:
	                    {
	                        newIndex = 9;
	                        break;
	                    }
	            }
	
	            stemPoints.push(points[newIndex - 1]);
	            stemPoints.push(controlPoints[i]);
	            stemPoints.push(points[newIndex + 1]);
	        }
	
	        return stemPoints;
	    }
	};
	
	exports.default = speakBubbleUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/utils/SpeakBubbleUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/utils/SpeakBubbleUtils.js"); } } })();

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _ReactNativeBridge = __webpack_require__(173);
	
	var _ReactNativeBridge2 = _interopRequireDefault(_ReactNativeBridge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var durationUtils = {
	    transformDuration: function transformDuration(duration) {
	        var totalSeconds = parseInt(duration / 1000);
	        var miliseconds = duration - totalSeconds * 1000;
	
	        if (miliseconds > 500) totalSeconds = totalSeconds + 1;
	
	        var minutes = parseInt(totalSeconds / 60);
	        var seconds = totalSeconds - minutes * 60;
	
	        var minValue;
	
	        if (minutes < 10) minValue = '0' + minutes;else minValue = '' + minutes;
	
	        var secValue;
	
	        if (seconds < 10) secValue = '0' + seconds;else secValue = '' + seconds;
	
	        return minValue + ':' + secValue;
	    },
	    transformDurationFromStringToSeconds: function transformDurationFromStringToSeconds(str) {
	        if (!str) return 0;
	
	        var elements = str.split(':');
	        var duration;
	
	        if (!elements || elements.length < 1) return 0;
	
	        var seconds = parseInt(elements[1]);
	        var minutes = parseInt(elements[0]);
	
	        duration = 60 * minutes + seconds;
	
	        return duration; //seconds
	    },
	
	
	    // Recording duration
	    recordingDurationVar: undefined,
	    endRecordingCallback: undefined,
	
	    startRecording: function startRecording(endRecordingCallback) {
	        this.endRecordingCallback = endRecordingCallback;
	        this.clearRecordingDuration();
	
	        var duration;
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (_AudioToolUtils2.default.isAudioTool()) duration = 5 * 60 * 1000; // 5min for AE tool
	            else duration = 2 * 60 * 1000; // 2min for Cartoonist tool
	        } else {
	            if (_PlatformDetection2.default.isChromeBook()) {
	                if (_AudioToolUtils2.default.isAudioTool()) duration = 10 * 60 * 1000; // 15min for AE tool
	                else duration = 2 * 60 * 1000; // 2min for Cartoonist tool
	            } else {
	                if (_AudioToolUtils2.default.isAudioTool()) duration = 15 * 60 * 1000; // 15min for AE tool
	                else duration = 2 * 60 * 1000; // 2min for Cartoonist tool
	            }
	        }
	
	        this.recordingDurationVar = setTimeout(this.stopRecording.bind(this), duration);
	    },
	    stopRecording: function stopRecording() {
	        this.clearRecordingDuration();
	
	        if (this.endRecordingCallback) this.endRecordingCallback();
	    },
	    clearRecordingDuration: function clearRecordingDuration() {
	        if (this.recordingDurationVar) clearTimeout(this.recordingDurationVar);
	    }
	};
	
	exports.default = durationUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/DurationUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/DurationUtils.js"); } } })();

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _screenfull = __webpack_require__(933);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fullScreenManager = {
	    isIOSFullScreen: false, //FULLSCREEN mode for IOS
	    fullScreenInitialized: false,
	    isOverControlBar: false,
	    isMouseMoved: false,
	    fullScreenTimerVar: undefined,
	    refreshFunction: undefined,
	    refreshExportPlayer: undefined,
	    isInitialized: false,
	
	    init: function init() {
	        // override for CH-661
	        _screenfull2.default.request = function (elem) {
	            var request = _screenfull2.default.raw.requestFullscreen;
	
	            elem = elem || document.documentElement;
	            elem[request]();
	        };
	
	        _screenfull2.default.on('change', this.changeFullScreen.bind(this));
	
	        this.isInitialized = true;
	    },
	    isIOSMode: function isIOSMode() {
	        if (_PlatformDetection2.default.isIOS() || _PlatformDetection2.default.isAndroid()) return true;
	
	        return false;
	
	        var isMobile = window.innerWidth < 800;
	
	        if (isMobile) return true;else return false;
	    },
	    isIOSFullScreenMode: function isIOSFullScreenMode() {
	        if (this.isIOSFullScreen) return true;
	
	        if (window.location && window.location.ancestorOrigins && window.location.ancestorOrigins[0] && window.location.ancestorOrigins[0].indexOf('portal') != -1) return false;
	
	        if (window.parent && window.parent.location && window.parent.location.href && window.parent.location.href.indexOf('isFullscreen=true') != -1) return true;else return false;
	    },
	    getCurrentPosition: function getCurrentPosition() {
	        var video = document.getElementById('exportedVideo');
	
	        if (!video) return 0;
	
	        return video.currentTime;
	    },
	    goFullScreenMode: function goFullScreenMode() {
	        if (!this.isIOSMode() && _AppParameters2.default.context != _ModeConstants2.default.EXPORT_AUDIO_PLAYER) this.addFullScreenEvents();
	
	        if (this.isIOSMode()) {
	            if (this.isIOSFullScreenMode()) {
	                // exit fullScreen mode
	                this.isIOSFullScreen = false;
	                this.isOverControlBar = false;
	                this.isMouseMoved = false;
	                this.clearFullScreenMouseMove();
	
	                window.location.href = _AppParameters2.default.playerHref;
	            } else {
	                // go to fullScreen mode
	                if (window.parent && window.parent.location) {
	                    this.isIOSFullScreen = true;
	                    this.isMouseMoved = true;
	
	                    if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) window.parent.location.href = _AppParameters2.default.iframeSrc + '&isFullscreen=true' + '&playerCurrentTime=' + this.getCurrentPosition();else window.parent.location.href = _AppParameters2.default.iframeSrc + '&isFullscreen=true';
	                }
	            }
	        } else {
	            if (!_screenfull2.default.enabled) return;
	
	            if (!this.isInitialized) this.init();
	
	            if (_screenfull2.default.isFullscreen) this.exitFullScreen();
	
	            var app = document.getElementById('app');
	            _screenfull2.default.toggle(app);
	        }
	    },
	    isFullScreenMode: function isFullScreenMode() {
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) {
	            if (this.isIOSMode()) return this.isIOSFullScreenMode();else return _screenfull2.default.isFullscreen;
	        } else return false;
	    },
	    addFullScreenEvents: function addFullScreenEvents() {
	        if (this.fullScreenInitialized == true) return;
	
	        if (!this.isIOSMode()) {
	            var controlBar = document.getElementById('previewMenu');
	            var canvas = document.getElementById('svgContainer');
	
	            controlBar.addEventListener('mouseover', this.onControlBarMouseOver.bind(this));
	            controlBar.addEventListener('mouseout', this.onControlBarMouseOut.bind(this));
	
	            canvas.addEventListener('mousemove', this.onCanvasMouseMove.bind(this));
	            this.fullScreenInitialized = true;
	        }
	    },
	    changeFullScreen: function changeFullScreen() {
	        if (!this.isFullScreenMode()) this.exitFullScreen();
	    },
	    addFullScreenEventsForIOS: function addFullScreenEventsForIOS() {
	        if (this.fullScreenInitialized == true) return;
	
	        var canvas = document.getElementById('svgContainer');
	
	        this.fullScreenInitialized = true;
	        this.isIOSFullScreen = true;
	        canvas.addEventListener('touchstart', this.onCanvasTouch.bind(this));
	
	        this.onCanvasTouch();
	    },
	    onCanvasTouch: function onCanvasTouch() {
	        if (this.isFullScreenMode() == false) return;
	
	        this.clearFullScreenMouseMove();
	        this.fullScreenTimerVar = setInterval(this.hideControlBar.bind(this), 6 * 1000);
	
	        this.isMouseMoved = true;
	        this.refreshControlBar();
	    },
	    onControlBarMouseOver: function onControlBarMouseOver() {
	        if (this.isFullScreenMode() == false) return;
	
	        this.isOverControlBar = true;
	        this.isMouseMoved = false;
	        this.refreshControlBar();
	    },
	    onControlBarMouseOut: function onControlBarMouseOut() {
	        if (this.isFullScreenMode() == false) return;
	
	        this.isOverControlBar = false;
	        this.isMouseMoved = false;
	        this.refreshControlBar();
	    },
	    onCanvasMouseMove: function onCanvasMouseMove() {
	        if (this.isFullScreenMode() == false) return;
	
	        if (this.isOverControlBar == true) return;
	
	        this.clearFullScreenMouseMove();
	
	        if (this.isMouseMoved == false) {
	            this.isMouseMoved = true;
	            this.refreshControlBar();
	        } else this.isMouseMoved = true;
	
	        this.hideCursor(false);
	
	        this.fullScreenTimerVar = setInterval(this.hideControlBar.bind(this), 3 * 1000);
	    },
	    hideControlBar: function hideControlBar() {
	        this.isMouseMoved = false;
	        this.refreshControlBar();
	        this.clearFullScreenMouseMove();
	        this.hideCursor();
	    },
	    hideCursor: function hideCursor() {
	        var hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        var container = document.getElementById('svgContainer');
	        if (container) {
	            if (hide) container.style.cursor = 'none';else container.style.cursor = 'default';
	        }
	    },
	    clearFullScreenMouseMove: function clearFullScreenMouseMove() {
	        if (this.fullScreenTimerVar) clearInterval(this.fullScreenTimerVar);
	    },
	    isControlBarVisible: function isControlBarVisible() {
	        if (this.isOverControlBar == true || this.isMouseMoved == true) return true;else return false;
	    },
	    refreshControlBar: function refreshControlBar() {
	        if (this.refreshFunction) this.refreshFunction();
	    },
	    exitFullScreen: function exitFullScreen() {
	        this.hideCursor(false);
	
	        if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) {
	            if (this.refreshExportPlayer) this.refreshExportPlayer();
	
	            if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) return;
	        }
	
	        this.isOverControlBar = false;
	        this.isMouseMoved = false;
	        this.clearFullScreenMouseMove();
	    }
	};
	
	exports.default = fullScreenManager;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/FullScreenManager.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/FullScreenManager.js"); } } })();

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _uuid = __webpack_require__(68);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var groupManager = {
	    dispatch: undefined,
	
	    getSelectedShapes: function getSelectedShapes() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var i;
	        var shape;
	        var selection = [];
	
	        for (i = 1; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.isSelected == true && !shape.isLocked) selection.push(shape);
	        }
	
	        return selection;
	    },
	    getLimitPoints: function getLimitPoints(limitPoints, currentX, currentY) {
	        limitPoints.xMin = Math.min(currentX, limitPoints.xMin);
	        limitPoints.xMax = Math.max(currentX, limitPoints.xMax);
	        limitPoints.yMin = Math.min(currentY, limitPoints.yMin);
	        limitPoints.yMax = Math.max(currentY, limitPoints.yMax);
	    },
	    groupUngroup: function groupUngroup() {
	        var shapes = this.getSelectedShapes();
	
	        if (shapes.length == 1 && shapes[0].type == _ShapeConstants2.default.GROUP) this.ungroup(shapes[0]);else if (shapes.length >= 2) this.group(shapes);
	
	        setTimeout(this.clearSelection, 400);
	    },
	    clearSelection: function clearSelection() {
	        _SelectionManager2.default.isMultipleSelection = false;
	    },
	    group: function group(shapes) {
	        var i;
	        var shape;
	        var limitPoints = { xMin: -1, yMin: -1, xMax: -1, yMax: -1 };
	
	        for (i = 0; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            if (shape.type == _ShapeConstants2.default.LINE || shape.type == _ShapeConstants2.default.CURVE) {
	                if (limitPoints.xMin == -1) {
	                    limitPoints = { xMin: shape.x1, yMin: shape.y1, xMax: shape.x1, yMax: shape.y1 };
	                }
	
	                this.getLimitPoints(limitPoints, shape.x1, shape.y1);
	                this.getLimitPoints(limitPoints, shape.x2, shape.y2);
	            } else {
	                if (limitPoints.xMin == -1) {
	                    limitPoints = { xMin: shape.x, yMin: shape.y, xMax: shape.x, yMax: shape.y };
	                }
	
	                this.getLimitPoints(limitPoints, shape.x, shape.y);
	                this.getLimitPoints(limitPoints, shape.x + shape.width, shape.y);
	                this.getLimitPoints(limitPoints, shape.x + shape.width, shape.y + shape.height);
	                this.getLimitPoints(limitPoints, shape.x, shape.y + shape.height);
	            }
	        }
	
	        var shapeGroup = {};
	        shapeGroup.type = _ShapeConstants2.default.GROUP;
	        shapeGroup.x = limitPoints.xMin;
	        shapeGroup.y = limitPoints.yMin;
	        shapeGroup.width = Math.abs(limitPoints.xMax - limitPoints.xMin);
	        shapeGroup.height = Math.abs(limitPoints.yMax - limitPoints.yMin);
	        shapeGroup.opacity = 1;
	        shapeGroup.isSelected = true;
	        shapeGroup.isLocked = false;
	        shapeGroup.rotation = 0;
	        shapeGroup.filter = '';
	        shapeGroup.uuid = _uuid2.default.v4();
	
	        var groupedShapes = [];
	
	        for (i = 0; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            var newShape = Object.assign({}, shape);
	            newShape.isSelected = false;
	            newShape.isGrouped = true;
	
	            if (shape.type == _ShapeConstants2.default.LINE || shape.type == _ShapeConstants2.default.CURVE) {
	                newShape.x1 = newShape.x1 - shapeGroup.x;
	                newShape.y1 = newShape.y1 - shapeGroup.y;
	                newShape.x2 = newShape.x2 - shapeGroup.x;
	                newShape.y2 = newShape.y2 - shapeGroup.y;
	
	                if (shape.type == _ShapeConstants2.default.CURVE) {
	                    newShape.cx = newShape.cx - shapeGroup.x;
	                    newShape.cy = newShape.cy - shapeGroup.y;
	                }
	            } else {
	                newShape.x = newShape.x - shapeGroup.x;
	                newShape.y = newShape.y - shapeGroup.y;
	
	                if (shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                    newShape.cx = newShape.cx - shapeGroup.x;
	                    newShape.cy = newShape.cy - shapeGroup.y;
	
	                    if (newShape.cx1) {
	                        newShape.cx1 = newShape.cx1 - shapeGroup.x;
	                        newShape.cy1 = newShape.cy1 - shapeGroup.y;
	                    }
	
	                    if (newShape.cx2) {
	                        newShape.cx2 = newShape.cx2 - shapeGroup.x;
	                        newShape.cy2 = newShape.cy2 - shapeGroup.y;
	                    }
	
	                    if (newShape.cx3) {
	                        newShape.cx3 = newShape.cx3 - shapeGroup.x;
	                        newShape.cy3 = newShape.cy3 - shapeGroup.y;
	                    }
	
	                    if (newShape.cx4) {
	                        newShape.cx4 = newShape.cx4 - shapeGroup.x;
	                        newShape.cy4 = newShape.cy4 - shapeGroup.y;
	                    }
	
	                    if (newShape.cx5) {
	                        newShape.cx5 = newShape.cx5 - shapeGroup.x;
	                        newShape.cy5 = newShape.cy5 - shapeGroup.y;
	                    }
	                }
	
	                //if (shape.type == shapeType.FREEHAND) {
	                //    var points = newShape.pathPoints;
	                //    var j;
	                //
	                //    for (j=0; j<points.length; j++) {
	                //        points[j].x = points[j].x - shapeGroup.x;
	                //        points[j].y = points[j].y - shapeGroup.y;
	                //    }
	                //}
	            }
	
	            groupedShapes.push(newShape);
	        }
	
	        shapeGroup.shapes = groupedShapes;
	
	        this.dispatch((0, _CurrentSlideActions.createGroup)(shapeGroup));
	        _AudioEditorUtils2.default.addActionToHistory();
	        _SaveManager2.default.isContentChanged(true);
	    },
	    ungroup: function ungroup(shapeGroup) {
	        var i;
	        var shapes = shapeGroup.shapes;
	        var shape;
	        var newShapes = [];
	        var ocx = shapeGroup.x + shapeGroup.width / 2;
	        var ocy = shapeGroup.y + shapeGroup.height / 2;
	        var rotatedPoint;
	
	        for (i = 0; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            var newShape = Object.assign({}, shape);
	            newShape.isSelected = true;
	            newShape.isGrouped = false;
	
	            if (newShape.type == _ShapeConstants2.default.LINE || newShape.type == _ShapeConstants2.default.CURVE) {
	                newShape.x1 = shapeGroup.x + newShape.x1;
	                newShape.y1 = shapeGroup.y + newShape.y1;
	                newShape.x2 = shapeGroup.x + newShape.x2;
	                newShape.y2 = shapeGroup.y + newShape.y2;
	
	                if (newShape.type == _ShapeConstants2.default.CURVE) {
	                    newShape.cx = shapeGroup.x + newShape.cx;
	                    newShape.cy = shapeGroup.y + newShape.cy;
	                }
	
	                if (shapeGroup.rotation > 0) {
	                    rotatedPoint = this.rotatePointAroundAnotherPoint(shapeGroup.rotation, newShape.x1, newShape.y1, ocx, ocy);
	                    newShape.x1 = rotatedPoint.x;
	                    newShape.y1 = rotatedPoint.y;
	
	                    rotatedPoint = this.rotatePointAroundAnotherPoint(shapeGroup.rotation, newShape.x2, newShape.y2, ocx, ocy);
	                    newShape.x2 = rotatedPoint.x;
	                    newShape.y2 = rotatedPoint.y;
	
	                    if (newShape.type == _ShapeConstants2.default.CURVE) {
	                        rotatedPoint = this.rotatePointAroundAnotherPoint(shapeGroup.rotation, newShape.cx, newShape.cy, ocx, ocy);
	                        newShape.cx = rotatedPoint.x;
	                        newShape.cy = rotatedPoint.y;
	                    }
	                }
	            } else {
	                newShape.x = shapeGroup.x + newShape.x;
	                newShape.y = shapeGroup.y + newShape.y;
	
	                var oldX = newShape.x;
	                var oldY = newShape.y;
	
	                if (newShape.type == _ShapeConstants2.default.SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.SCREAM_BUBBLE || newShape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                    newShape.cx = shapeGroup.x + newShape.cx;
	                    newShape.cy = shapeGroup.y + newShape.cy;
	
	                    if (newShape.cx1) {
	                        newShape.cx1 = shapeGroup.x + newShape.cx1;
	                        newShape.cy1 = shapeGroup.y + newShape.cy1;
	                    }
	
	                    if (newShape.cx2) {
	                        newShape.cx2 = shapeGroup.x + newShape.cx2;
	                        newShape.cy2 = shapeGroup.y + newShape.cy2;
	                    }
	
	                    if (newShape.cx3) {
	                        newShape.cx3 = shapeGroup.x + newShape.cx3;
	                        newShape.cy3 = shapeGroup.y + newShape.cy3;
	                    }
	
	                    if (newShape.cx4) {
	                        newShape.cx4 = shapeGroup.x + newShape.cx4;
	                        newShape.cy4 = shapeGroup.y + newShape.cy4;
	                    }
	
	                    if (newShape.cx5) {
	                        newShape.cx5 = shapeGroup.x + newShape.cx5;
	                        newShape.cy5 = shapeGroup.y + newShape.cy5;
	                    }
	                }
	
	                if (shapeGroup.rotation > 0) {
	                    newShape.rotation = newShape.rotation + shapeGroup.rotation;
	
	                    var cx = newShape.x + newShape.width / 2;
	                    var cy = newShape.y + newShape.height / 2;
	                    rotatedPoint = this.rotatePointAroundAnotherPoint(shapeGroup.rotation, cx, cy, ocx, ocy);
	
	                    newShape.x = rotatedPoint.x - newShape.width / 2;
	                    newShape.y = rotatedPoint.y - newShape.height / 2;
	
	                    if (newShape.type == _ShapeConstants2.default.SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.SCREAM_BUBBLE || newShape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                        newShape.rotation = 0;
	                        newShape.cx = newShape.cx + (newShape.x - oldX);
	                        newShape.cy = newShape.cy + (newShape.y - oldY);
	
	                        if (newShape.cx1) {
	                            newShape.cx1 = newShape.cx1 + (newShape.x - oldX);
	                            newShape.cy1 = newShape.cy1 + (newShape.y - oldY);
	                        }
	
	                        if (newShape.cx2) {
	                            newShape.cx2 = newShape.cx2 + (newShape.x - oldX);
	                            newShape.cy2 = newShape.cy2 + (newShape.y - oldY);
	                        }
	
	                        if (newShape.cx3) {
	                            newShape.cx3 = newShape.cx3 + (newShape.x - oldX);
	                            newShape.cy3 = newShape.cy3 + (newShape.y - oldY);
	                        }
	
	                        if (newShape.cx4) {
	                            newShape.cx4 = newShape.cx4 + (newShape.x - oldX);
	                            newShape.cy4 = newShape.cy4 + (newShape.y - oldY);
	                        }
	
	                        if (newShape.cx5) {
	                            newShape.cx5 = newShape.cx5 + (newShape.x - oldX);
	                            newShape.cy5 = newShape.cy5 + (newShape.y - oldY);
	                        }
	                    }
	
	                    if (newShape.type == _ShapeConstants2.default.TEXTBOX || newShape.type == _ShapeConstants2.default.TEXTBOXSIMPLE) newShape.rotation = 0;
	                }
	            }
	
	            newShapes.push(newShape);
	        }
	
	        this.dispatch((0, _CurrentSlideActions.ungroup)(shapeGroup, newShapes));
	        _AudioEditorUtils2.default.addActionToHistory();
	        _SaveManager2.default.isContentChanged(true);
	    },
	    rotatePointAroundAnotherPoint: function rotatePointAroundAnotherPoint(rotAng, x, y, ox, oy) {
	        var nx;
	        var ny;
	        var sinVal;
	        var cosVal;
	
	        rotAng = rotAng * (Math.PI / 180);
	        sinVal = Math.sin(rotAng);
	        cosVal = Math.cos(rotAng);
	
	        nx = (x - ox) * cosVal - (y - oy) * sinVal;
	        ny = (y - oy) * cosVal + (x - ox) * sinVal;
	
	        return { x: nx + ox, y: ny + oy };
	    }
	};
	
	exports.default = groupManager;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/GroupManager.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/GroupManager.js"); } } })();

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.checkKeyboardCommand = checkKeyboardCommand;
	exports.undoAction = undoAction;
	exports.redoAction = redoAction;
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _MenuActions = __webpack_require__(7);
	
	var _UndoRedoActions = __webpack_require__(227);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _SlideViewerActions = __webpack_require__(121);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _GroupManager = __webpack_require__(142);
	
	var _GroupManager2 = _interopRequireDefault(_GroupManager);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _DrawingUtils = __webpack_require__(108);
	
	var _DrawingUtils2 = _interopRequireDefault(_DrawingUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _SlidesUtils = __webpack_require__(125);
	
	var _SlidesUtils2 = _interopRequireDefault(_SlidesUtils);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _HelpUtils = __webpack_require__(172);
	
	var _HelpUtils2 = _interopRequireDefault(_HelpUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ExportPlayerController = __webpack_require__(241);
	
	var _ExportPlayerController2 = _interopRequireDefault(_ExportPlayerController);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	var _MindMapUtils = __webpack_require__(85);
	
	var _MindMapUtils2 = _interopRequireDefault(_MindMapUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isSlideCommand() {
	    var state = _StoreManager2.default.getState();
	    var isSlideComand = state.currentSlide.isSlideCommand;
	
	    if (isSlideComand == true) return true;else return false;
	}
	
	function isAudioEditorMode() {
	    var state = _StoreManager2.default.getState();
	    var showAudioEditor = state.menu.showAudioEditor;
	
	    if (showAudioEditor == true || _AudioToolUtils2.default.isAudioTool()) return true;else return false;
	}
	
	function getShapeTarget() {
	    var state = _StoreManager2.default.getState();
	    var target = state.currentSlide.shortcutsTarget;
	
	    return target;
	}
	
	function isAvailable(keyCode) {
	    var activeElement = document.activeElement;
	
	    if (activeElement && activeElement.nodeName == 'BUTTON' && keyCode == 32) // if is SPACE and a native button is selected then execute only the click on that button
	        return false;
	
	    // in TextEditorMode we shouldn't have the shourtcuts activate BUT only TAB
	    if (_TextEditorUtils2.default.isTextEditorTool()) return false;
	
	    if (_TextEditorUtils2.default.isInteractiveTextElementFocused() && keyCode == 70) // if F key is pressed then don't enter in FULLSCREEN mode and just enter to TEXT EDITOR TOOL
	        return false;
	
	    var state = _StoreManager2.default.getState();
	    var mode = state.production.mode;
	    var showAlternativeTextMenu = state.menu.showAlternativeTextMenu;
	
	    if (showAlternativeTextMenu) return false;
	
	    if (_AnimationManager2.default.isAnimationMode() && keyCode != 27 && keyCode != 13) return false;
	
	    if (keyCode == 70) // F --> fullScreen should be available for all tools either is Edit or Player mode
	        return true;
	
	    if (mode == _ModeConstants2.default.PLAYER || mode == _ModeConstants2.default.PREVIEW || _AudioToolUtils2.default.isAudioPlayer() || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) {
	        // it's Cartoonist Player/Preview or AudioPlayer or Cartoonist export or AudioEditor export
	        if (mode == _ModeConstants2.default.PREVIEW && keyCode == 27) // ESC - is used to exit from Preview mode
	            return true;
	
	        if (keyCode == 37 || keyCode == 39 || keyCode == 32) // Space, Left and Right arrow should be available
	            return true;else return false;
	    }
	
	    if (document.activeElement.className.indexOf('sliderThumb') != -1) return false;
	
	    return true;
	}
	
	function isDrawingMode() {
	    var state = _StoreManager2.default.getState();
	    var contextMode = state.menu.contextMode;
	
	    if (contextMode == _ModeConstants2.default.FREEHAND_CONTEXT || contextMode == _ModeConstants2.default.LINE_CONTEXT) return true;else return false;
	}
	
	function checkKeyboardCommand(event, dispatch) {
	    if (isAvailable(event.keyCode) == false) return;
	
	    if (isDurationFocus()) {
	        if (event.keyCode == 13) {
	            // ENTER
	            document.activeElement.blur();
	        }
	        return;
	    }
	
	    if (event.ctrlKey == true && event.shiftKey == false) {
	        switch (event.keyCode) {
	            case 90:
	                {
	                    // Ctrl + Z -- > Undo
	                    undoAction(dispatch);
	                    break;
	                }
	
	            case 89:
	                {
	                    // Ctrl + Y -- > Redo
	                    redoAction(dispatch);
	                    break;
	                }
	
	            case 67:
	                {
	                    // Ctrl + C -- > Copy
	                    if (isSlideCommand()) {
	                        copySlide(dispatch);
	                    } else {
	                        copyShape(dispatch);
	                    }
	                    break;
	                }
	
	            case 88:
	                {
	                    // Ctrl + X -- > Cut
	                    if (isSlideCommand()) {
	                        cutSlide(dispatch);
	                    } else {
	                        cutShape(dispatch);
	                    }
	                    break;
	                }
	
	            case 86:
	                {
	                    // Ctrl + V -- > Paste
	                    if (isSlideCommand() && !_SelectionManager2.default.copiedCanvasElement) {
	                        pasteSlide(dispatch);
	                    } else {
	                        pasteShape(dispatch);
	                    }
	                    break;
	                }
	
	            case 71:
	                {
	                    // Ctrl + G -- > Group/Ungroup
	                    _GroupManager2.default.groupUngroup();
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	
	            case 65:
	                {
	                    // CTRL + A --> Select all
	                    _SelectionManager2.default.selectAll();
	                    break;
	                }
	        }
	    } else if (event.ctrlKey == false && event.shiftKey == true) {
	        switch (event.keyCode) {
	            case 37:
	                {
	                    // LEFT --> MoveLeft with big step
	                    if (_PreviewCommands2.default.isEditorMode() == false) {
	                        return;
	                    }
	
	                    if (isSlideCommand() == true) {
	                        changeSlidePosition(dispatch, true);
	                    } else {
	                        changeShapePosition(dispatch, -_Properties2.default.MOVE_SHAPE_BIG_OFFSET, 0);
	                    }
	                    break;
	                }
	
	            case 39:
	                {
	                    // RIGHT --> MoveRight with big step
	                    if (_PreviewCommands2.default.isEditorMode() == false) {
	                        return;
	                    }
	
	                    if (isSlideCommand() == true) {
	                        changeSlidePosition(dispatch, false);
	                    } else {
	                        changeShapePosition(dispatch, _Properties2.default.MOVE_SHAPE_BIG_OFFSET, 0);
	                    }
	                    break;
	                }
	
	            case 38:
	                {
	                    // TOP --> MoveTop with big step
	                    if (isSlideCommand() == false) {
	                        changeShapePosition(dispatch, 0, -_Properties2.default.MOVE_SHAPE_BIG_OFFSET);
	                    }
	                    break;
	                }
	
	            case 40:
	                {
	                    // DOWN --> MoveDown with big step
	                    if (isSlideCommand() == false) {
	                        changeShapePosition(dispatch, 0, _Properties2.default.MOVE_SHAPE_BIG_OFFSET);
	                    }
	                    break;
	                }
	
	            case 83:
	                {
	                    // Shift + S -- > Save
	                    if (!isTextFocus()) openSaveMenu(dispatch);
	                    break;
	                }
	        }
	    } else if (event.ctrlKey == false && event.shiftKey == false && event.altKey == false) {
	        // No Shift and No Ctrl and No ALT
	        var state = _StoreManager2.default.getState();
	        var showZoomSlidesValue = state.menu.showZoomSlides;
	        var showCroppingMenuValue = state.menu.showCroppingMenu;
	        var isVideoEditor = state.menu.showVideoEditor;
	
	        switch (event.keyCode) {
	            case 107:
	                //+
	                if (showZoomSlidesValue) {
	                    updateSlideZoom("zoomIn");
	                }
	                break;
	            case 109:
	                //-
	                if (showZoomSlidesValue) {
	                    updateSlideZoom("zoomOut");
	                }
	                break;
	            case 37:
	                {
	                    // LEFT --> MoveLeft with normal step
	                    if (showZoomSlidesValue) {
	                        updateSlideZoom("left");
	                    }
	                    if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) {
	                        if (_ExportPlayerController2.default.keyboardShortcutAction) _ExportPlayerController2.default.keyboardShortcutAction('left');
	
	                        return;
	                    }
	
	                    if (_AudioToolUtils2.default.isAudioPlayer()) {
	                        if (_AudioToolUtils2.default.audioPlayerKeyboardShortcutAction) _AudioToolUtils2.default.audioPlayerKeyboardShortcutAction(1);
	
	                        return;
	                    }
	
	                    if (_PlayController2.default.isAudioEditorMode() && !isSlideCommand()) {
	                        _PlayController2.default.executeAction('left');
	                        return;
	                    }
	
	                    if (_PreviewCommands2.default.isEditorMode() == false) {
	                        _PreviewCommands2.default.executeCommand(1);
	                        return;
	                    }
	
	                    if (isSlideCommand() == true) {
	                        changeCurrentSlide(dispatch, true);
	                    } else {
	                        changeShapePosition(dispatch, -_Properties2.default.MOVE_SHAPE_OFFSET, 0);
	                    }
	                    break;
	                }
	
	            case 39:
	                {
	                    // RIGHT --> MoveRight with normal step
	                    if (showZoomSlidesValue) {
	                        updateSlideZoom("right");
	                    }
	
	                    if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) {
	                        if (_ExportPlayerController2.default.keyboardShortcutAction) _ExportPlayerController2.default.keyboardShortcutAction('right');
	
	                        return;
	                    }
	
	                    if (_AudioToolUtils2.default.isAudioPlayer()) {
	                        if (_AudioToolUtils2.default.audioPlayerKeyboardShortcutAction) _AudioToolUtils2.default.audioPlayerKeyboardShortcutAction(3);
	
	                        return;
	                    }
	
	                    if (_PlayController2.default.isAudioEditorMode() && !isSlideCommand()) {
	                        _PlayController2.default.executeAction('right');
	                        return;
	                    }
	
	                    if (_PreviewCommands2.default.isEditorMode() == false) {
	                        _PreviewCommands2.default.executeCommand(3);
	                        return;
	                    }
	
	                    if (isSlideCommand() == true) {
	                        changeCurrentSlide(dispatch, false);
	                    } else {
	                        changeShapePosition(dispatch, _Properties2.default.MOVE_SHAPE_OFFSET, 0);
	                    }
	                    break;
	                }
	
	            case 38:
	                {
	                    // TOP --> MoveTop with normal step
	                    if (showZoomSlidesValue) {
	                        updateSlideZoom("up");
	                    }
	
	                    if (isSlideCommand() == false) {
	                        changeShapePosition(dispatch, 0, -_Properties2.default.MOVE_SHAPE_OFFSET);
	                    }
	                    break;
	                }
	
	            case 40:
	                {
	                    // DOWN --> MoveDown with normal step
	                    if (showZoomSlidesValue) {
	                        updateSlideZoom("down");
	                    }
	
	                    if (isSlideCommand() == false) {
	                        changeShapePosition(dispatch, 0, _Properties2.default.MOVE_SHAPE_OFFSET);
	                    }
	                    break;
	                }
	
	            case 8: // BACKSPACE
	            case 46:
	                {
	                    // DELETE --> Delete element on canvas
	                    _HoverManager2.default.hide();
	
	                    var selection = getSelection();
	
	                    if (isAudioEditorMode() && !isTextFocus()) {
	                        if (selection == undefined || selection.length < 1) {
	                            dispatch((0, _AudioEditorActions.deleteItem)());
	                            _SaveManager2.default.isContentChanged(true);
	                            _AudioEditorUtils2.default.addActionToHistory();
	                            _AudioEditorUtils2.default.checkTimelineWidth();
	                            break;
	                        }
	                    }
	
	                    if (isSlideCommand() == false) {
	                        var element = document.activeElement;
	
	                        if ((selection == undefined || selection.length < 1) && element.className.indexOf('titleInput') == -1) {
	                            event.preventDefault();
	                        }
	
	                        if (isTextFocus()) {
	                            // it's an active text element so we shouldn't do something here
	                        } else deleteObject(dispatch);
	                    }
	                    break;
	                }
	
	            case 27:
	                {
	                    // Escape --> Exit PREVIEW mode
	                    if (_AnimationManager2.default.isAnimationMode()) {
	                        _AnimationManager2.default.clearAnimationsInEditMode(true);
	                        _AnimationManager2.default.exitAnimationMode();
	                        return;
	                    }
	
	                    if (isAudioEditorMode()) {
	                        _PlayController2.default.toggleAudioEditorMode();
	                        dispatch((0, _MenuActions.hideMenus)(_MenuType2.default.ALL_MENUS));
	                        break;
	                    }
	
	                    if (isDrawingMode()) {
	                        _DrawingUtils2.default.executeAction('cancel');
	                    } else {
	                        if (isVideoEditor) {
	                            _VideoUtils2.default.executeAction('cancel');
	                        } else {
	                            if (showZoomSlidesValue) {
	                                dispatch((0, _MenuActions.showZoomSlides)(false));
	                            } else if (showCroppingMenuValue) {
	                                dispatch((0, _ProductionActions.updateCurrentSlide)());
	                                dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	                                dispatch((0, _CurrentSlideActions.selectShape)(''));
	                                dispatch((0, _MenuActions.showCroppingMenu)(false));
	                            } else {
	                                _PreviewCommands2.default.exitPreview();
	                            }
	                        }
	                    }
	
	                    break;
	                }
	
	            case 13:
	                {
	                    // ENTER --> ZOOM IN
	                    if (_HelpUtils2.default.titleAlertVisible && _HelpUtils2.default.closeTitleAlert) {
	                        _HelpUtils2.default.closeTitleAlert();
	                        return;
	                    }
	
	                    /*if (animationManager.isAnimationMode()) {
	                        animationManager.clearAnimationsInEditMode();
	                        animationManager.addAnimation();
	                        saveManager.isContentChanged(true);
	                        return;
	                    }*/
	
	                    if (isVideoEditor) {
	                        _VideoUtils2.default.executeAction('ok');
	                        _SaveManager2.default.isContentChanged(true);
	                        return;
	                    }
	
	                    if (showZoomSlidesValue) {
	                        zoomIn(dispatch);
	                        return;
	                    }
	
	                    if (showCroppingMenuValue) {
	                        cropElement(dispatch);
	                        return;
	                    }
	
	                    if (_PlayController2.default.isAudioEditorAvailable() && !_SelectionManager2.default.isTextBoxSelected() && !_SelectionManager2.default.isSaveContext() && !isTextFocus()) {
	                        _PlayController2.default.executeAction('stop');
	                        return;
	                    }
	
	                    break;
	                }
	
	            case 32:
	                {
	                    // SPACE --> Play/Stop in Preview mode
	                    if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) {
	                        setTimeout(function () {
	                            if (_ExportPlayerController2.default.keyboardShortcutAction) _ExportPlayerController2.default.keyboardShortcutAction('space');
	                        }.bind(this), 30);
	
	                        return;
	                    }
	
	                    if (_AudioToolUtils2.default.isAudioPlayer()) {
	                        setTimeout(function () {
	                            if (_AudioToolUtils2.default.audioPlayerKeyboardShortcutAction) _AudioToolUtils2.default.audioPlayerKeyboardShortcutAction(2);
	                        }.bind(this), 30);
	
	                        return;
	                    }
	
	                    if (isVideoEditor) {
	                        _VideoUtils2.default.executeAction('play');
	                        return;
	                    }
	
	                    if (_PlayController2.default.isAudioEditorAvailable() && !_SelectionManager2.default.isTextBoxSelected() && !_SelectionManager2.default.isSaveContext() && !isTextFocus()) {
	                        _PlayController2.default.executeAction('play');
	
	                        if (_PreviewCommands2.default.forceUpdateForPlayButton) _PreviewCommands2.default.forceUpdateForPlayButton();
	
	                        return;
	                    }
	
	                    if (!_PlayController2.default.isAudioEditorAvailable()) {
	                        if (_PreviewCommands2.default.isEditorMode() == false) {
	                            _PreviewCommands2.default.executeCommand(2);
	
	                            if (_PreviewCommands2.default.forceUpdateForPlayButton) _PreviewCommands2.default.forceUpdateForPlayButton();
	                        } else {
	                            if (_VideoUtils2.default.isVideoBackground() && _VideoUtils2.default.playRegular && !_SelectionManager2.default.isTextBoxSelected() && !_SelectionManager2.default.isSaveContext() && !isTextFocus()) _VideoUtils2.default.playRegular();
	                        }
	                    }
	
	                    break;
	                }
	
	            case 70:
	                {
	                    // Ctrl + F -- > Fullscreen
	                    if (_PreviewCommands2.default.isPlayer()) {
	                        _PreviewCommands2.default.goFullScreenMode();
	                        return;
	                    }
	
	                    if (isTextFocus()) {
	                        // it's an active text element so we shouldn't do something here
	                    } else _ZoomUtils2.default.goToFullScreenMode();
	                    break;
	                }
	
	            case 67:
	                {
	                    // Command + C -- > Copy for MAC
	                    if (event.metaKey && _PlatformDetection2.default.isMac()) {
	                        if (isSlideCommand() == true) {
	                            copySlide(dispatch);
	                        } else {
	                            copyShape(dispatch);
	                        }
	                    }
	                    break;
	                }
	
	            case 88:
	                {
	                    // Command + X -- > Cut for MAC
	                    if (event.metaKey && _PlatformDetection2.default.isMac()) {
	                        if (isSlideCommand() == true) {
	                            cutSlide(dispatch);
	                        } else {
	                            cutShape(dispatch);
	                        }
	                    }
	                    break;
	                }
	
	            case 86:
	                {
	                    // Command + V -- > Paste for MAC
	                    if (event.metaKey && _PlatformDetection2.default.isMac()) {
	                        if (isSlideCommand() && !_SelectionManager2.default.copiedCanvasElement) {
	                            pasteSlide(dispatch);
	                        } else {
	                            pasteShape(dispatch);
	                        }
	                    }
	                    break;
	                }
	        }
	    } else if (event.altKey == true) {
	        // ALT key is down
	        switch (event.keyCode) {
	            case 66:
	                {
	                    // ALT + B -- > Bold
	                    changeFontProperties(dispatch, 'fontBold');
	                    break;
	                }
	
	            case 73:
	                {
	                    // ALT + I -- > Italic
	                    changeFontProperties(dispatch, 'fontItalic');
	                    break;
	                }
	
	            case 85:
	                {
	                    // ALT + U -- > Underline
	                    changeFontProperties(dispatch, 'fontUnderline');
	                    break;
	                }
	
	            case 187:
	                {
	                    // ALT++ --> Increase font size
	                    changeFontProperties(dispatch, 'fontSize', 1);
	                    break;
	                }
	
	            case 189:
	                {
	                    // ALT+- --> Decrease font size
	                    changeFontProperties(dispatch, 'fontSize', -1);
	                    break;
	                }
	        }
	    }
	}
	
	function zoomIn(dispatch) {
	    dispatch((0, _CurrentSlideActions.updateHospot)(_ZoomUtils2.default.currentBackgroundUid, _ZoomUtils2.default.currentHotspot));
	    _AudioEditorUtils2.default.addActionToHistory();
	    dispatch((0, _ProductionActions.updateCurrentSlide)());
	    dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    dispatch((0, _MenuActions.showZoomSlides)(false));
	    _SaveManager2.default.isContentChanged(true);
	}
	
	function cropElement(dispatch) {
	    dispatch((0, _CurrentSlideActions.updateCroppingHospot)(_ZoomUtils2.default.croppingTarget.uuid, _ZoomUtils2.default.currentCroppingHotspot));
	    _AudioEditorUtils2.default.addActionToHistory();
	    dispatch((0, _ProductionActions.updateCurrentSlide)());
	    dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    dispatch((0, _MenuActions.showCroppingMenu)(false));
	    _SaveManager2.default.isContentChanged(true);
	}
	
	function getSelection() {
	    var state = _StoreManager2.default.getState();
	    var shapes = state.currentSlide.model.content;
	    var i;
	    var selection = [];
	
	    for (i = 0; i < shapes.length; i++) {
	        if (shapes[i].isSelected == true) {
	            selection.push(shapes[i].uuid);
	        }
	    }return selection;
	}
	
	function getSelectedShape() {
	    var state = _StoreManager2.default.getState();
	    var shapes = state.currentSlide.model.content;
	    var i;
	    var target;
	
	    for (i = 0; i < shapes.length; i++) {
	        if (shapes[i].isSelected == true) {
	            target = shapes[i];
	            break;
	        }
	    }return target;
	}
	
	function deleteObject(dispatch) {
	    var state = _StoreManager2.default.getState();
	
	    if (state.menu.contextMode == _ModeConstants2.default.SAVE_CONTEXT) return;
	
	    var shapeModels = getSelection();
	
	    if (shapeModels == undefined || shapeModels.length < 1) return;
	
	    if (shapeModels.length == 1 && (0, _TransformToolUtils.isTextBox)(shapeModels[0]) == true) return;
	
	    dispatch((0, _CurrentSlideActions.deleteShape)(shapeModels));
	    dispatch((0, _CurrentSlideActions.selectShape)(''));
	    _AudioEditorUtils2.default.addActionToHistory();
	    updateThumbnail(dispatch);
	    _SaveManager2.default.isContentChanged(true);
	}
	
	function updateThumbnail(dispatch) {
	    dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	}
	
	function changeShapePosition(dispatch, offsetX, offsetY) {
	    var shapeModel = getSelectedShape();
	
	    if (shapeModel == undefined || isTextFocus()) return;
	
	    var state = _StoreManager2.default.getState();
	    var contextMode = state.menu.contextMode;
	
	    if (contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT) return;
	
	    dispatch((0, _CurrentSlideActions.moveShape)(shapeModel.uuid, offsetX, offsetY));
	    _MindMapUtils2.default.moveShapeByKeyboard(shapeModel, offsetX, offsetY);
	    _AudioEditorUtils2.default.addActionToHistory();
	    _SaveManager2.default.isContentChanged(true);
	}
	
	function changeCurrentSlide(dispatch, isLeftPosition) {
	    var state = _StoreManager2.default.getState();
	    var currentIndex = state.currentSlide.currentSlideIndex;
	    var slides = state.production.slides;
	
	    _MouseUtils2.default.isKeyboardShortcut = true;
	
	    if (isLeftPosition == true) {
	        if (currentIndex > 0) {
	            dispatch((0, _CurrentSlideActions.setCurrentSlide)(currentIndex - 1));
	            _AudioEditorUtils2.default.addActionToHistory();
	            _AudioEditorUtils2.default.checkMarkerPositionForCurrentSlide();
	        }
	    } else {
	        if (currentIndex < slides.length - 1) {
	            dispatch((0, _CurrentSlideActions.setCurrentSlide)(currentIndex + 1));
	            _AudioEditorUtils2.default.addActionToHistory();
	            _AudioEditorUtils2.default.checkMarkerPositionForCurrentSlide();
	        }
	    }
	
	    _SaveManager2.default.isContentChanged(true);
	}
	
	function changeSlidePosition(dispatch, isLeft) {
	    var state = _StoreManager2.default.getState();
	    var currentIndex = state.currentSlide.currentSlideIndex;
	    var slides = state.production.slides;
	    var newSlideIndex = -1;
	    var currentSlideUid = state.currentSlide.model.uuid;
	
	    if (isLeft == true) {
	        if (currentIndex > 0) {
	            dispatch((0, _ProductionActions.shiftSlide)(isLeft, currentIndex));
	            newSlideIndex = currentIndex - 1;
	        }
	    } else {
	        if (currentIndex < slides.length - 1) {
	            dispatch((0, _ProductionActions.shiftSlide)(isLeft, currentIndex));
	            newSlideIndex = currentIndex + 1;
	        }
	    }
	
	    if (newSlideIndex != -1) {
	        dispatch((0, _CurrentSlideActions.updateCurrentSlideIndex)(currentSlideUid));
	        _AudioEditorUtils2.default.addActionToHistory();
	        _ZoomUtils2.default.closeZoom();
	    }
	
	    _SaveManager2.default.isContentChanged(true);
	}
	
	function changeFontProperties(dispatch, propertyType, stepOffset) {
	    var shapeModel = getSelectedShape();
	
	    if (!shapeModel || !(0, _TransformToolUtils.isTextBox)(shapeModel)) return;
	
	    dispatch((0, _CurrentSlideActions.updateTextProperties)(shapeModel, propertyType, stepOffset));
	    _AudioEditorUtils2.default.addActionToHistory();
	
	    checkSize(dispatch);
	    _SaveManager2.default.isContentChanged(true);
	}
	
	function checkSize(dispatch) {
	    var shapeModel = getSelectedShape();
	
	    _TextSizeUtils2.default.updateTextWrapperSize(shapeModel, dispatch);
	}
	
	function copyShape(dispatch) {
	    var shapeModel = getShapeTarget();
	
	    if (shapeModel && _MindMapUtils2.default.isMindMapType(shapeModel)) return;
	
	    var state = _StoreManager2.default.getState();
	    _SelectionManager2.default.copiedCanvasElement = true;
	    _SelectionManager2.default.currentSlide = state.currentSlide.model;
	
	    if (shapeModel) {
	        dispatch((0, _CurrentSlideActions.setCloneTarget)(shapeModel));
	        _SaveManager2.default.isContentChanged(true);
	    }
	}
	
	function cutShape(dispatch) {
	    var shapeModel = getShapeTarget();
	
	    if (shapeModel && _MindMapUtils2.default.isMindMapType(shapeModel)) return;
	
	    var state = _StoreManager2.default.getState();
	    _SelectionManager2.default.copiedCanvasElement = true;
	    _SelectionManager2.default.currentSlide = state.currentSlide.model;
	
	    if (shapeModel) {
	        dispatch((0, _CurrentSlideActions.setCloneTarget)(shapeModel));
	
	        dispatch((0, _CurrentSlideActions.deleteShape)([shapeModel.uuid]));
	        dispatch((0, _CurrentSlideActions.selectShape)(''));
	        _AudioEditorUtils2.default.addActionToHistory();
	        updateThumbnail(dispatch);
	        _SaveManager2.default.isContentChanged(true);
	    }
	}
	
	function isDurationFocus() {
	    var isTextFocus = false;
	    var element = document.activeElement;
	
	    if (!element) return false;
	
	    var type = _typeof(element.className);
	
	    if (element && type == 'string' && element.className.indexOf('slideDuration') != -1) isTextFocus = true;
	
	    return isTextFocus;
	}
	
	function isTextFocus() {
	    var isTextFocus = false;
	    var element = document.activeElement;
	    var type = _typeof(element.className);
	
	    if (element && type == 'string' && (element.className.indexOf('textShapes') != -1 || element.className.indexOf('titleInput') != -1)) isTextFocus = true;
	
	    return isTextFocus;
	}
	
	function removeTextBoxesFocus() {
	    var elements = document.getElementsByClassName('textShapes');
	    var i;
	
	    for (i = 0; i < elements.length; i++) {
	        elements[i].blur();
	    }
	}
	
	function getCloneTarget() {
	    var state = _StoreManager2.default.getState();
	    var cloneTarget = state.currentSlide.cloneTarget;
	    var shapes = state.currentSlide.model.content;
	    var i;
	    var target;
	
	    if (cloneTarget == undefined) return target;
	
	    for (i = 0; i < shapes.length; i++) {
	        if (shapes[i].uuid == cloneTarget.uuid) target = shapes[i];
	    }if (!target) target = cloneTarget;
	
	    return target;
	}
	
	function pasteShape(dispatch) {
	    var state = _StoreManager2.default.getState();
	    var cloneTarget = getCloneTarget();
	
	    if (cloneTarget != undefined) {
	        if (_MindMapUtils2.default.isMindMapType(cloneTarget)) return;
	
	        removeTextBoxesFocus();
	
	        dispatch((0, _CurrentSlideActions.duplicateShape)(cloneTarget));
	        updateThumbnail(dispatch);
	
	        var shapesArray = state.currentSlide.model.content;
	        var lastDuplicatedShape = shapesArray[shapesArray.length - 1];
	        dispatch((0, _CurrentSlideActions.setCloneTarget)(lastDuplicatedShape));
	        _AudioEditorUtils2.default.addActionToHistory();
	        dispatch((0, _CurrentSlideActions.selectLastAddedShape)());
	        _SaveManager2.default.isContentChanged(true);
	    }
	}
	
	function getCurrentSlide() {
	    var state = _StoreManager2.default.getState();
	
	    return state.currentSlide.model;
	}
	
	function copySlide(dispatch) {
	    var slide = getCurrentSlide();
	
	    _SelectionManager2.default.copiedCanvasElement = false;
	    dispatch((0, _ProductionActions.setSlideCloneTarget)(slide));
	    _SaveManager2.default.isContentChanged(true);
	}
	
	function cutSlide(dispatch) {
	    var slide = getCurrentSlide();
	
	    dispatch((0, _CurrentSlideActions.selectShape)('slideFocus'));
	    dispatch((0, _ProductionActions.updateCurrentSlide)());
	
	    dispatch((0, _ProductionActions.setSlideCloneTarget)(slide));
	
	    var state = _StoreManager2.default.getState();
	    var slides = state.production.slides;
	    var newSlideIndex = void 0;
	
	    if (slides.length == 1) {
	        newSlideIndex = 0;
	    } else {
	        if (slides.length - 1 == state.currentSlide.currentSlideIndex) newSlideIndex = state.currentSlide.currentSlideIndex - 1;else newSlideIndex = state.currentSlide.currentSlideIndex;
	    }
	
	    _SelectionManager2.default.copiedCanvasElement = false;
	
	    dispatch((0, _ProductionActions.deleteSlide)());
	    dispatch((0, _CurrentSlideActions.setCurrentSlide)(newSlideIndex));
	    dispatch((0, _SlideViewerActions.needsRefresh)(true));
	    _AudioEditorUtils2.default.addActionToHistory();
	    _AudioEditorUtils2.default.checkMarkerPositionForCurrentSlide();
	    _AudioEditorUtils2.default.checkTimelineWidth(true);
	    _SaveManager2.default.isContentChanged(true);
	}
	
	function pasteSlide(dispatch) {
	    var state = _StoreManager2.default.getState();
	    var target = state.production.slideCloneTarget;
	
	    if (target) {
	        dispatch((0, _CurrentSlideActions.selectShape)('slideFocus'));
	        dispatch((0, _ProductionActions.updateCurrentSlide)());
	        dispatch((0, _ProductionActions.cloneSlide)(target));
	        dispatch((0, _CurrentSlideActions.setCurrentSlide)(state.currentSlide.currentSlideIndex + 1));
	        dispatch((0, _SlideViewerActions.needsRefresh)(true));
	        _AudioEditorUtils2.default.addActionToHistory();
	        _AudioEditorUtils2.default.checkMarkerPositionForCurrentSlide();
	        _AudioEditorUtils2.default.checkTimelineWidth(true);
	        _SaveManager2.default.isContentChanged(true);
	    }
	}
	
	function undoAction(dispatch) {
	    var state = _StoreManager2.default.getState();
	    var undoHistory = state.undoRedo.undo;
	
	    if (undoHistory && undoHistory.length > 0) {
	        dispatch((0, _UndoRedoActions.undo)());
	        setTimeout(updateStateToPresent, 10);
	        _SaveManager2.default.isContentChanged(true);
	    }
	}
	
	function redoAction(dispatch) {
	    var state = _StoreManager2.default.getState();
	    var redoHistory = state.undoRedo.redo;
	
	    if (redoHistory && redoHistory.length > 0) {
	        dispatch((0, _UndoRedoActions.redo)());
	        setTimeout(updateStateToPresent, 10);
	        _SaveManager2.default.isContentChanged(true);
	    }
	}
	
	function updateStateToPresent() {
	    var state = _StoreManager2.default.getState();
	    var present = state.undoRedo.present;
	    var dispatch = _StoreManager2.default.getStore().dispatch;
	
	    _SlidesUtils2.default.updateAllThumbnails = true;
	
	    dispatch((0, _CurrentSlideActions.canvasUndoRedoAction)(present));
	    dispatch((0, _ProductionActions.productionUndoRedoAction)(present));
	    dispatch((0, _AudioEditorActions.audioEditorUndoRedo)(present));
	
	    dispatch((0, _MenuActions.hideMenus)(_MenuType2.default.ALL_MENUS));
	    dispatch((0, _CurrentSlideActions.selectShape)('slideFocus'));
	    updateThumbnail(dispatch);
	
	    _SaveManager2.default.isContentChanged(true);
	}
	
	function openSaveMenu(dispatch) {
	    dispatch((0, _ProductionActions.updateCurrentSlide)());
	    dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.SAVE_CONTEXT));
	}
	
	function updateSlideZoom(zoomType) {
	    var event = new CustomEvent("ZoomTransformEvent", { detail: zoomType });
	    document.dispatchEvent(event);
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/KeyboardShortcuts.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/KeyboardShortcuts.js"); } } })();

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _DrawingUtils = __webpack_require__(108);
	
	var _DrawingUtils2 = _interopRequireDefault(_DrawingUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var thumbnailGenerator = {
	    canvasWidth: undefined,
	    canvasRealWidth: undefined,
	    shapes: undefined,
	    currentIndex: 0,
	    context: undefined,
	    loadCurrentAsset: false,
	    canvas: undefined,
	    thumbsList: [],
	    storeProductionThumbnailHandler: undefined,
	    isProductionThumb: false,
	    productionThumbKey: undefined,
	    mapIds: [],
	    checkImageOriginalSize: true,
	
	    /************************** Production thumb drawing ****************************************/
	    getFirstSlideModel: function getFirstSlideModel() {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	
	        return slides[0];
	    },
	    extractId: function extractId(link) {
	        var index = link.indexOf('file/ci/');
	        var index2 = link.indexOf('/aaa');
	        var id = -1;
	
	        if (index2 < 0) index2 = link.indexOf('/img');
	
	        if (index2 < 0) index2 = link.indexOf('/audio');
	
	        if (index > 0 && index2 > 0) id = link.substring(index + 8, index2);
	
	        return id;
	    },
	    getCorrectMediaSource: function getCorrectMediaSource(href) {
	        var id = this.extractId(href);
	
	        if (id != -1 && this.mapIds[id]) return this.mapIds[id];else return '';
	    },
	    checkShape: function checkShape(shape) {
	        var href = '';
	        var id = -1;
	
	        if (shape.type == _ShapeConstants2.default.BACKGROUND || shape.type == _ShapeConstants2.default.IMAGE || shape.type == _ShapeConstants2.default.CHARACTER) href = shape.xlinkHref;
	
	        if (href && href.length > 0) id = this.extractId(href);
	
	        return id;
	    },
	    getMyMediaFilesIds: function getMyMediaFilesIds(slideModel) {
	        var shapes = slideModel.content;
	        var ids = [];
	        var id;
	        var i, j;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].type == _ShapeConstants2.default.GROUP) {
	                var group = shapes[i];
	
	                for (j = 0; j < group.shapes.length; j++) {
	                    var shape = group.shapes[j];
	
	                    id = this.checkShape(shape);
	
	                    if (id != -1) ids.push(id);
	                }
	            } else {
	                id = this.checkShape(shapes[i]);
	
	                if (id != -1) ids.push(id);
	            }
	        }
	
	        return ids;
	    },
	    getProductionThumb: function getProductionThumb(callBackFunction, productionThumbKey) {
	        this.storeProductionThumbnailHandler = callBackFunction;
	        this.productionThumbKey = productionThumbKey;
	
	        var firstSlideThumb = document.createElement('canvas');
	        firstSlideThumb.width = _Configuration2.default.SCREENSHOT_WIDTH;
	        firstSlideThumb.height = _Configuration2.default.SCREENSHOT_WIDTH * 9 / 16;
	
	        this.isProductionThumb = true;
	
	        var firstSlideModel = this.getFirstSlideModel();
	        this.drawThumbnail(firstSlideThumb, firstSlideModel, false);
	    },
	    productionThumbReady: function productionThumbReady() {
	        this.isProductionThumb = false;
	
	        if (this.storeProductionThumbnailHandler) this.storeProductionThumbnailHandler(this.canvas, this.productionThumbKey);
	    },
	
	
	    /************************** Normal thumb drawing ****************************************/
	    drawThumbnail: function drawThumbnail(canvas, slideModel) {
	        var updateThumbsList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	        if (!canvas || !slideModel || !slideModel.content) return;
	
	        if (updateThumbsList == true) {
	            this.thumbsList.push({ canvas: canvas, slideModel: slideModel });
	
	            if (this.thumbsList.length > 1) // there are at least 2 items in queue
	                return;
	        }
	
	        this.canvas = canvas;
	        this.context = canvas.getContext('2d');
	        this.canvasRealWidth = canvas.width;
	        this.canvasWidth = this.isProductionThumb ? _Configuration2.default.SCREENSHOT_WIDTH : _Properties2.default.SLIDE_ITEM_WIDTH;
	        this.shapes = this.getAllShapes(slideModel.content);
	        this.currentIndex = 0;
	        this.loadCurrentAsset = false;
	
	        this.resetTransform();
	        //this.context.clearRect(0, 0, canvas.width, canvas.height);
	
	        this.parseShapes();
	    },
	    getAllShapes: function getAllShapes(shapes) {
	        var allShapes = [];
	        var i, j;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].type == _ShapeConstants2.default.GROUP) {
	                var group = shapes[i];
	
	                for (j = 0; j < group.shapes.length; j++) {
	                    var shape = Object.assign({}, group.shapes[j]);
	
	                    shape.x = shape.x + group.x;
	                    shape.y = shape.y + group.y;
	
	                    allShapes.push(shape);
	                }
	            } else {
	                allShapes.push(shapes[i]);
	            }
	        }
	
	        return allShapes;
	    },
	    resetTransform: function resetTransform() {
	        this.context.closePath();
	        this.context.setTransform(1, 0, 0, 1, 0, 0);
	    },
	    transformToLocalCoordinates: function transformToLocalCoordinates(value) {
	        var scale = this.canvasWidth / _Configuration2.default.CANVAS_WIDTH;
	
	        return value * scale;
	    },
	    degreesToRadians: function degreesToRadians(degrees) {
	        return degrees * (Math.PI / 180);
	    },
	    transformRGBtoRGBA: function transformRGBtoRGBA(color, opacity) {
	        var r = parseInt(color.substr(1, 2), 16);
	        var g = parseInt(color.substr(3, 2), 16);
	        var b = parseInt(color.substr(5, 2), 16);
	
	        return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
	    },
	    parseShapes: function parseShapes() {
	        if (this.shapes == undefined || this.shapes.length < 0) return;
	
	        var shapes = this.shapes;
	        var shape;
	        var i = this.currentIndex;
	
	        for (i; i < shapes.length; i++) {
	            shape = shapes[i];
	
	            this.resetTransform();
	
	            if (this.loadCurrentAsset == true) return;
	
	            switch (shape.type) {
	                case _ShapeConstants2.default.BACKGROUND:
	                    {
	                        this.drawBackground(shape);
	                        break;
	                    }
	                case _ShapeConstants2.default.VIDEO:
	                    {
	                        this.drawVideoShape(shape);
	                        break;
	                    }
	
	                case _ShapeConstants2.default.TRIANGLE:
	                case _ShapeConstants2.default.STAR:
	                case _ShapeConstants2.default.HEART:
	                case _ShapeConstants2.default.RECTANGLE:
	                case _ShapeConstants2.default.ELLIPSE:
	                    {
	                        this.drawRectangularShape(shape);
	                        this.currentIndex = this.currentIndex + 1;
	                        break;
	                    }
	
	                case _ShapeConstants2.default.IMAGE:
	                case _ShapeConstants2.default.CHARACTER:
	                    {
	                        this.drawImage(shape);
	                        break;
	                    }
	
	                case _ShapeConstants2.default.CURVE:
	                case _ShapeConstants2.default.LINE:
	                    {
	                        this.drawLineCurve(shape);
	                        this.currentIndex = this.currentIndex + 1;
	                        break;
	                    }
	
	                case _ShapeConstants2.default.FREEHAND:
	                    {
	                        this.drawFreehand(shape);
	                        this.currentIndex = this.currentIndex + 1;
	                        break;
	                    }
	
	                case _ShapeConstants2.default.TEXTBOX:
	                case _ShapeConstants2.default.TEXTBOXSIMPLE:
	                case _ShapeConstants2.default.SPEAK_BUBBLE:
	                case _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE:
	                case _ShapeConstants2.default.SCREAM_BUBBLE:
	                case _ShapeConstants2.default.THOUGHT_BUBBLE:
	                    {
	                        this.drawText(shape);
	                        this.currentIndex = this.currentIndex + 1;
	                        break;
	                    }
	            }
	        }
	
	        if (this.isProductionThumb) {
	            if (this.currentIndex >= shapes.length) this.productionThumbReady();
	        } else {
	            if (i >= shapes.length - 1) {
	                // this.completeCanvas();
	
	                if (this.thumbsList.length > 0) this.thumbsList.shift();
	
	                if (this.thumbsList.length > 0) {
	                    var object = this.thumbsList[0];
	
	                    //this.drawThumbnail(object.canvas, object.slideModel, false);
	                    setTimeout(this.drawThumbnail.bind(this), 300, object.canvas, object.slideModel, false);
	                }
	            }
	        }
	    },
	    completeCanvas: function completeCanvas() {
	        if (this.canvasRealWidth > this.canvasWidth) {
	            var steps = Math.floor(this.canvasRealWidth / this.canvasWidth);
	            var i;
	
	            if (steps > 0) {
	                var clone = this.cloneCanvas(this.canvas);
	                for (i = 0; i < steps; i++) {
	                    this.context.drawImage(clone, (i + 1) * this.canvasWidth, 0);
	                }
	            }
	        }
	    },
	    cloneCanvas: function cloneCanvas(oldCanvas) {
	        var newCanvas = document.createElement('canvas');
	        var context = newCanvas.getContext('2d');
	
	        newCanvas.width = this.canvasWidth;
	        newCanvas.height = oldCanvas.height;
	
	        context.drawImage(oldCanvas, 0, 0);
	
	        return newCanvas;
	    },
	    drawBackground: function drawBackground(shape) {
	        var width = this.canvasWidth;
	        var context = this.context;
	        var self = this;
	        var mediaSource;
	
	        context.beginPath();
	
	        if (shape.xlinkHref == undefined || shape.xlinkHref == '') {
	            context.rect(0, 0, width, width * 9 / 16);
	
	            if (shape.fillOpacity > 0) {
	                context.fillStyle = shape.fill;
	                context.fill();
	            }
	
	            if (shape.strokeOpacity > 0) {
	                context.lineWidth = this.transformToLocalCoordinates(shape.strokeWidth);
	                context.strokeStyle = shape.stroke;
	                context.stroke();
	            }
	
	            this.currentIndex = this.currentIndex + 1;
	        } else {
	            if (shape.isVideo) {
	                var video = document.createElement('video');
	
	                if (shape.inPoint > 0) video.currentTime = shape.inPoint;else video.currentTime = 0.1;
	
	                video.addEventListener('durationchange', function () {
	                    var time = 1000;
	
	                    if (_PlatformDetection2.default.isEdge() || _PlatformDetection2.default.isChromeBook()) time = 2 * time;
	
	                    setTimeout(function () {
	                        self.resetTransform();
	                        context.drawImage(this, 0, 0, width, width * 9 / 16);
	
	                        self.loadCurrentAsset = false;
	
	                        self.currentIndex = self.currentIndex + 1;
	                        self.parseShapes();
	                    }.bind(this), time);
	                });
	
	                video.addEventListener('error', function () {
	                    self.loadCurrentAsset = false;
	                    self.currentIndex = self.currentIndex + 1;
	
	                    self.parseShapes();
	                });
	
	                this.loadCurrentAsset = true;
	
	                if (!_Configuration2.default.LOAD_LOCAL && this.isProductionThumb) {
	                    video.setAttribute('crossOrigin', 'anonymous');
	
	                    mediaSource = this.getCorrectMediaSource(shape.xlinkHref);
	
	                    if (mediaSource.length > 0) video.src = _VideoUtils2.default.checkCacheBreaker(mediaSource);else video.src = this.checkBucket(_VideoUtils2.default.checkCacheBreaker(shape.xlinkHref));
	                } else video.src = _VideoUtils2.default.checkCacheBreaker(shape.xlinkHref);
	
	                video.load();
	            } else {
	                // load image from data url
	                var imageObj = new Image();
	
	                imageObj.onload = function () {
	                    self.resetTransform();
	
	                    if (shape.hotSpot != undefined && shape.hotSpot != '') {
	                        var hotspot = shape.hotSpot;
	                        var scale = _Configuration2.default.CANVAS_WIDTH / hotspot.width;
	                        var scaledWidth = width * scale;
	
	                        context.drawImage(this, -self.transformToLocalCoordinates(hotspot.x) * scale, -self.transformToLocalCoordinates(hotspot.y) * scale, scaledWidth, scaledWidth * 9 / 16);
	                    } else {
	                        context.drawImage(this, 0, 0, width, width * 9 / 16);
	                    }
	
	                    self.loadCurrentAsset = false;
	
	                    self.currentIndex = self.currentIndex + 1;
	                    self.parseShapes();
	                };
	
	                imageObj.onerror = function () {
	                    self.loadCurrentAsset = false;
	                    self.currentIndex = self.currentIndex + 1;
	                    console.log('ErrorLoadinBackground ***');
	
	                    self.parseShapes();
	                };
	
	                this.loadCurrentAsset = true;
	
	                if (!_Configuration2.default.LOAD_LOCAL && this.isProductionThumb) {
	                    imageObj.setAttribute('crossOrigin', 'anonymous');
	
	                    mediaSource = this.getCorrectMediaSource(shape.xlinkHref);
	
	                    if (mediaSource.length > 0) imageObj.src = _VideoUtils2.default.checkCacheBreaker(mediaSource);else imageObj.src = this.checkBucket(_VideoUtils2.default.checkCacheBreaker(shape.xlinkHref));
	                } else {
	                    imageObj.src = _VideoUtils2.default.checkCacheBreaker(shape.xlinkHref);
	                }
	            }
	        }
	    },
	    drawVideoShape: function drawVideoShape(shape) {
	        var context = this.context;
	        var self = this;
	        var mediaSource = void 0;
	
	        this.resetTransform();
	        context.beginPath();
	
	        var video = document.createElement('video');
	
	        if (shape.inPoint > 0) video.currentTime = shape.inPoint;else video.currentTime = 0.1;
	
	        video.addEventListener('durationchange', function () {
	            var shapeCenterX = self.transformToLocalCoordinates(shape.x + shape.width / 2);
	            var shapeCenterY = self.transformToLocalCoordinates(shape.y + shape.height / 2);
	            var width = self.transformToLocalCoordinates(shape.width);
	            var height = self.transformToLocalCoordinates(shape.height);
	            var time = 1000;
	
	            if (_PlatformDetection2.default.isEdge() || _PlatformDetection2.default.isChromeBook()) time = 2 * time;
	
	            setTimeout(function () {
	                self.resetTransform();
	                context.drawImage(this, shapeCenterX - width / 2, shapeCenterY - height / 2, width, height);
	
	                self.loadCurrentAsset = false;
	                self.currentIndex = self.currentIndex + 1;
	                self.parseShapes();
	            }.bind(this), time);
	        });
	
	        video.addEventListener('error', function () {
	            self.loadCurrentAsset = false;
	            self.currentIndex = self.currentIndex + 1;
	
	            self.parseShapes();
	        });
	
	        this.loadCurrentAsset = true;
	
	        if (!_Configuration2.default.LOAD_LOCAL && this.isProductionThumb) {
	            video.setAttribute('crossOrigin', 'anonymous');
	
	            mediaSource = this.getCorrectMediaSource(shape.xlinkHref);
	
	            if (mediaSource.length > 0) video.src = _VideoUtils2.default.checkCacheBreaker(mediaSource);else video.src = this.checkBucket(_VideoUtils2.default.checkCacheBreaker(shape.xlinkHref));
	        } else video.src = _VideoUtils2.default.checkCacheBreaker(shape.xlinkHref);
	
	        video.load();
	    },
	    checkBucket: function checkBucket(url) {
	        if (url.indexOf('s3-eu-west-1.amazonaws.com/creaza-cartoonist-svg') != -1) // for the svgs ... old url
	            url = url.replace('s3-eu-west-1.amazonaws.com/creaza-cartoonist-svg', 'd9e59cbjty4wx.cloudfront.net');
	
	        if (url.indexOf('creaza-cartoonist-svg.s3.eu-west-1.amazonaws.com') != -1) // for the svgs
	            url = url.replace('creaza-cartoonist-svg.s3.eu-west-1.amazonaws.com', 'd9e59cbjty4wx.cloudfront.net');
	
	        if (url.indexOf('d3b76ijxom7qfl.cloudfront.net') != -1) // for the library videos
	            url = url.replace('d3b76ijxom7qfl.cloudfront.net', 'creaza-clipart.s3.amazonaws.com');
	
	        return url;
	    },
	    drawRectangularShape: function drawRectangularShape(shape) {
	        var context = this.context;
	        var shapeCenterX = this.transformToLocalCoordinates(shape.x + shape.width / 2);
	        var shapeCenterY = this.transformToLocalCoordinates(shape.y + shape.height / 2);
	        var width = this.transformToLocalCoordinates(shape.width);
	        var height = this.transformToLocalCoordinates(shape.height);
	
	        context.beginPath();
	        context.translate(shapeCenterX, shapeCenterY);
	
	        if (shape.rotation > 0) {
	            context.rotate(this.degreesToRadians(shape.rotation));
	        }
	
	        switch (shape.type) {
	            case _ShapeConstants2.default.RECTANGLE:
	                {
	                    context.rect(-width / 2, -height / 2, width, height);
	                    break;
	                }
	            case _ShapeConstants2.default.ELLIPSE:
	                {
	                    if (CanvasRenderingContext2D.prototype.ellipse != undefined) context.ellipse(0, 0, width / 2, height / 2, 0, 0, 2 * Math.PI);
	                    break;
	                }
	            case _ShapeConstants2.default.TRIANGLE:
	                {
	                    var pointX = 0;
	                    var pointY = -height / 2;
	
	                    context.moveTo(pointX, pointY);
	
	                    pointX = width / 2;
	                    pointY = height / 2;
	
	                    context.lineTo(pointX, pointY);
	
	                    pointX = -width / 2;
	                    pointY = height / 2;
	
	                    context.lineTo(pointX, pointY);
	
	                    pointX = 0;
	                    pointY = -height / 2;
	
	                    context.lineTo(pointX, pointY);
	                    break;
	                }
	            case _ShapeConstants2.default.STAR:
	                {
	                    var points = [];
	                    var i;
	                    var point;
	                    var pathPoints = _DrawingUtils2.default.calculateStarPoints(shape);
	                    var newPoint;
	
	                    for (i = 0; i < pathPoints.length; i++) {
	                        point = pathPoints[i];
	
	                        newPoint = {};
	                        newPoint.x = -width / 2 + this.transformToLocalCoordinates(point.x);
	                        newPoint.y = -height / 2 + this.transformToLocalCoordinates(point.y);
	
	                        points.push(newPoint);
	                    }
	
	                    context.moveTo(points[0].x, points[0].y);
	
	                    for (i = 1; i < points.length; i++) {
	                        context.lineTo(points[i].x, points[i].y);
	                    }
	
	                    context.lineTo(points[0].x, points[0].y);
	                    break;
	                }
	            case _ShapeConstants2.default.HEART:
	                {
	                    if (CanvasRenderingContext2D.prototype.ellipse != undefined) context.ellipse(0, 0, width / 2, height / 2, 0, 0, 2 * Math.PI);
	                    break;
	                }
	        }
	
	        if (shape.fillOpacity > 0) {
	            context.fillStyle = this.transformRGBtoRGBA(shape.fill, shape.opacity);
	            context.fill();
	        }
	
	        if (shape.strokeOpacity > 0) {
	            context.lineWidth = this.transformToLocalCoordinates(shape.strokeWidth);
	            context.strokeStyle = this.transformRGBtoRGBA(shape.stroke, shape.opacity);
	            context.stroke();
	        }
	    },
	    drawImage: function drawImage(shape) {
	        this.resetTransform();
	
	        var context = this.context;
	        context.beginPath();
	
	        var self = this;
	
	        // load image from data url
	        var imageObj = new Image();
	
	        imageObj.onload = function (e) {
	            var shapeCenterX = self.transformToLocalCoordinates(shape.x + shape.width / 2);
	            var shapeCenterY = self.transformToLocalCoordinates(shape.y + shape.height / 2);
	            var width = self.transformToLocalCoordinates(shape.width);
	            var height = self.transformToLocalCoordinates(shape.height);
	
	            if (shape.hotSpot != undefined && shape.hotSpot != '') {
	                var hotspot = shape.hotSpot;
	                var imgWidth = e.target.width;
	                var imgHeight = e.target.height;
	
	                context.drawImage(this, hotspot.x1 * imgWidth / 100, hotspot.y1 * imgHeight / 100, (hotspot.x2 - hotspot.x1) * imgWidth / 100, (hotspot.y2 - hotspot.y1) * imgHeight / 100, shapeCenterX - width / 2, shapeCenterY - height / 2, width, height);
	            } else {
	                if (shape.rotation > 0) {
	                    context.translate(shapeCenterX, shapeCenterY);
	                    context.rotate(self.degreesToRadians(shape.rotation));
	
	                    context.drawImage(this, -width / 2, -height / 2, width, height);
	                } else {
	                    if (shape.horizontalFlip == -1 && shape.verticalFlip == -1) {
	                        context.translate(shapeCenterX, shapeCenterY);
	                        context.scale(-1, -1);
	
	                        context.drawImage(this, -width / 2, -height / 2, width, height);
	                    } else if (shape.horizontalFlip == -1) {
	                        context.translate(shapeCenterX, shapeCenterY);
	                        context.scale(-1, 1);
	
	                        context.drawImage(this, -width / 2, -height / 2, width, height);
	                    } else if (shape.verticalFlip == -1) {
	                        context.translate(shapeCenterX, shapeCenterY);
	                        context.scale(1, -1);
	
	                        context.drawImage(this, -width / 2, -height / 2, width, height);
	                    } else {
	                        context.drawImage(this, shapeCenterX - width / 2, shapeCenterY - height / 2, width, height);
	                    }
	                }
	            }
	
	            self.loadCurrentAsset = false;
	            self.currentIndex = self.currentIndex + 1;
	
	            self.parseShapes();
	        };
	
	        imageObj.onerror = function () {
	            self.loadCurrentAsset = false;
	            self.currentIndex = self.currentIndex + 1;
	            console.log('ErrorLoadinImage');
	
	            self.parseShapes();
	        };
	
	        this.loadCurrentAsset = true;
	
	        if (!_Configuration2.default.LOAD_LOCAL && this.isProductionThumb) {
	            imageObj.setAttribute('crossOrigin', 'anonymous');
	
	            var mediaSource = this.getCorrectMediaSource(shape.xlinkHref);
	
	            if (mediaSource.length > 0) imageObj.src = _VideoUtils2.default.checkCacheBreaker(mediaSource);else imageObj.src = this.checkBucket(_VideoUtils2.default.checkCacheBreaker(shape.xlinkHref));
	        } else {
	            imageObj.src = _VideoUtils2.default.checkCacheBreaker(shape.xlinkHref);
	        }
	    },
	    drawLineCurve: function drawLineCurve(shape) {
	        var context = this.context;
	        var x1 = this.transformToLocalCoordinates(shape.x1);
	        var y1 = this.transformToLocalCoordinates(shape.y1);
	        var x2 = this.transformToLocalCoordinates(shape.x2);
	        var y2 = this.transformToLocalCoordinates(shape.y2);
	
	        context.beginPath();
	        context.moveTo(x1, y1);
	
	        if (shape.type == _ShapeConstants2.default.CURVE) {
	            var cx = this.transformToLocalCoordinates(shape.cx);
	            var cy = this.transformToLocalCoordinates(shape.cy);
	
	            context.quadraticCurveTo(cx, cy, x2, y2);
	        } else {
	            context.lineTo(x2, y2);
	        }
	
	        if (shape.strokeOpacity > 0) {
	            context.lineWidth = this.transformToLocalCoordinates(shape.strokeWidth);
	            context.strokeStyle = this.transformRGBtoRGBA(shape.stroke, shape.opacity);
	        }
	
	        context.stroke();
	    },
	    drawFreehand: function drawFreehand(shape) {
	        var context = this.context;
	        var shapeCenterX = this.transformToLocalCoordinates(shape.x + shape.width / 2);
	        var shapeCenterY = this.transformToLocalCoordinates(shape.y + shape.height / 2);
	        var width = this.transformToLocalCoordinates(shape.width);
	        var height = this.transformToLocalCoordinates(shape.height);
	
	        context.beginPath();
	        context.translate(shapeCenterX, shapeCenterY);
	
	        if (shape.rotation > 0) {
	            context.rotate(this.degreesToRadians(shape.rotation));
	        }
	
	        var points = [];
	        var i;
	        var point;
	        var pathPoints = shape.pathPoints;
	        var newPoint;
	
	        for (i = 0; i < pathPoints.length; i++) {
	            point = pathPoints[i];
	
	            newPoint = {};
	            newPoint.x = -width / 2 + this.transformToLocalCoordinates(point.x);
	            newPoint.y = -height / 2 + this.transformToLocalCoordinates(point.y);
	
	            points.push(newPoint);
	        }
	
	        context.moveTo(points[0].x, points[0].y);
	
	        for (i = 1; i < points.length; i++) {
	            context.lineTo(points[i].x, points[i].y);
	        }
	
	        if (shape.strokeOpacity > 0) {
	            context.lineWidth = this.transformToLocalCoordinates(shape.strokeWidth);
	            context.strokeStyle = this.transformRGBtoRGBA(shape.stroke, shape.opacity);
	        }
	
	        context.stroke();
	    },
	    drawText: function drawText(shape) {
	        var context = this.context;
	        var x = this.transformToLocalCoordinates(shape.x);
	        var y = this.transformToLocalCoordinates(shape.y);
	        var width = this.transformToLocalCoordinates(shape.width);
	        var height = this.transformToLocalCoordinates(shape.height);
	        var offset = this.transformToLocalCoordinates(20);
	
	        context.beginPath();
	
	        context.moveTo(x + offset, y);
	        context.lineTo(x + width - 2 * offset, y);
	        context.quadraticCurveTo(x + width, y, x + width, y + offset);
	        context.lineTo(x + width, y + height - 2 * offset);
	        context.quadraticCurveTo(x + width, y + height, x + width - offset, y + height);
	        context.lineTo(x + offset, y + height);
	        context.quadraticCurveTo(x, y + height, x, y + height - offset);
	        context.lineTo(x, y + offset);
	        context.quadraticCurveTo(x, y, x + offset, y);
	
	        if (shape.fillOpacity > 0) {
	            context.fillStyle = this.transformRGBtoRGBA(shape.fill, shape.opacity);
	            context.fill();
	        }
	
	        if (shape.strokeOpacity > 0) {
	            context.lineWidth = this.transformToLocalCoordinates(shape.strokeWidth);
	            context.strokeStyle = this.transformRGBtoRGBA(shape.stroke, shape.opacity);
	            context.stroke();
	        }
	
	        // draw Text
	        var font = shape.fontSize - 5;
	
	        if (font < 1) font = 1;
	
	        var leftOffset = this.transformToLocalCoordinates(10);
	
	        context.font = this.transformToLocalCoordinates(font) + 'px' + ' ' + shape.fontFamily;
	        context.fillStyle = this.transformRGBtoRGBA(shape.fontColor, shape.opacity);
	        context.fillText(shape.htmlText, x + leftOffset, y + this.transformToLocalCoordinates(30), width - 2 * leftOffset);
	    },
	    checkImageAspectRatio: function checkImageAspectRatio(shapeModel, dispatch) {
	        var isMood = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        if (!this.checkImageOriginalSize) {
	            dispatch((0, _CurrentSlideActions.updateImageSize)(shapeModel.uuid, shapeModel.width, shapeModel.height));
	            return;
	        }
	
	        var imageObj = new Image();
	
	        imageObj.onload = function (e) {
	            var target = e.target;
	
	            if (shapeModel.mindMapProperty) {
	                // insert a mindMap node
	                var xCenter = shapeModel.x + shapeModel.width / 2;
	                var yCenter = shapeModel.y + shapeModel.height / 2;
	                var newWidth = void 0;
	                var newHeight = void 0;
	
	                if (target.width > target.height) {
	                    newWidth = _Configuration2.default.CANVAS_WIDTH / 8;
	                    newHeight = newWidth * (target.height / target.width);
	                } else {
	                    newHeight = _Configuration2.default.CANVAS_HEIGHT / 5;
	                    newWidth = newHeight * (target.width / target.height);
	                }
	
	                dispatch((0, _CurrentSlideActions.updateImageSize)(shapeModel.uuid, newWidth, newHeight));
	                dispatch((0, _CurrentSlideActions.updateShapePosition)(shapeModel.uuid, xCenter - newWidth / 2, yCenter - newHeight / 2));
	            } else {
	                if (isMood) dispatch((0, _CurrentSlideActions.updateImageSizeWhenChangeMood)(shapeModel.uuid, target.width, target.height));else {
	                    if (target.height > 400) dispatch((0, _CurrentSlideActions.updateImageSize)(shapeModel.uuid, 300 * target.width / target.height, 300));else if (target.width > 600) dispatch((0, _CurrentSlideActions.updateImageSize)(shapeModel.uuid, 300, 300 * target.height / target.width));else dispatch((0, _CurrentSlideActions.updateImageSize)(shapeModel.uuid, target.width, target.height));
	                }
	            }
	        };
	
	        imageObj.src = _VideoUtils2.default.checkCacheBreaker(shapeModel.xlinkHref);
	    },
	    drawVideoTimeline: function drawVideoTimeline(canvas) {
	        var context = canvas.getContext('2d');
	        var elementWidth = canvas.height * 16 / 9;
	        var video = document.getElementById('videoBackground');
	        var length = Math.floor(canvas.width / elementWidth);
	        var i;
	
	        for (i = 0; i < length; i++) {
	            context.drawImage(video, i * elementWidth, 0, elementWidth, canvas.height);
	        }
	
	        context.drawImage(video, length * elementWidth, 0, canvas.width - length * elementWidth, canvas.height);
	    }
	};
	
	exports.default = thumbnailGenerator;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ThumbnailGenerator.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ThumbnailGenerator.js"); } } })();

/***/ },
/* 145 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(65);
	var toLength = __webpack_require__(45);
	var toAbsoluteIndex = __webpack_require__(104);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(24);
	var $export = __webpack_require__(4);
	var redefine = __webpack_require__(60);
	var redefineAll = __webpack_require__(102);
	var meta = __webpack_require__(89);
	var forOf = __webpack_require__(96);
	var anInstance = __webpack_require__(95);
	var isObject = __webpack_require__(28);
	var fails = __webpack_require__(26);
	var $iterDetect = __webpack_require__(152);
	var setToStringTag = __webpack_require__(114);
	var inheritIfRequired = __webpack_require__(187);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(59);
	var redefine = __webpack_require__(60);
	var fails = __webpack_require__(26);
	var defined = __webpack_require__(75);
	var wks = __webpack_require__(34);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(22);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(69);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(28);
	var cof = __webpack_require__(69);
	var MATCH = __webpack_require__(34)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(34)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(97) || !__webpack_require__(26)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(24)[K];
	});


/***/ },
/* 154 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(55);
	var ctx = __webpack_require__(70);
	var forOf = __webpack_require__(96);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(4);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(22);
	var aFunction = __webpack_require__(55);
	var SPECIES = __webpack_require__(34)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var hide = __webpack_require__(59);
	var uid = __webpack_require__(105);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _baseWrapper = __webpack_require__(664);
	
	var _baseWrapper2 = _interopRequireDefault(_baseWrapper);
	
	var _s = __webpack_require__(666);
	
	var _s2 = _interopRequireDefault(_s);
	
	var _callbackNames = __webpack_require__(294);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FineUploaderS3 = function (_BaseWrapper) {
	    _inherits(FineUploaderS3, _BaseWrapper);
	
	    function FineUploaderS3(_ref) {
	        var options = _ref.options;
	
	        _classCallCheck(this, FineUploaderS3);
	
	        return _possibleConstructorReturn(this, (FineUploaderS3.__proto__ || Object.getPrototypeOf(FineUploaderS3)).call(this, {
	            callbackNames: _callbackNames.s3,
	            options: options,
	            qq: _s2.default,
	            type: 's3'
	        }));
	    }
	
	    return FineUploaderS3;
	}(_baseWrapper2.default);
	
	exports.default = FineUploaderS3;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(49);
	
	var EventPluginRegistry = __webpack_require__(213);
	var ReactEventEmitterMixin = __webpack_require__(709);
	var ViewportMetrics = __webpack_require__(313);
	
	var getVendorPrefixedEventName = __webpack_require__(741);
	var isEventSupported = __webpack_require__(224);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(136);
	var ViewportMetrics = __webpack_require__(313);
	
	var getEventModifierState = __webpack_require__(222);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(19);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 165 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	var DOMNamespaces = __webpack_require__(212);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(220);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ListItemRenderer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _DragManager = __webpack_require__(107);
	
	var _DragManager2 = _interopRequireDefault(_DragManager);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ToolTipManager = __webpack_require__(174);
	
	var _ToolTipManager2 = _interopRequireDefault(_ToolTipManager);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MenuActions = __webpack_require__(7);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MindMapUtils = __webpack_require__(85);
	
	var _MindMapUtils2 = _interopRequireDefault(_MindMapUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListItemRenderer = exports.ListItemRenderer = _react2.default.createClass({
	    displayName: 'ListItemRenderer',
	    getInitialState: function getInitialState() {
	        if (_MasterUniverseUtils2.default.useThumbnailsLazyLoading(this.props.usePagination)) {
	            return {
	                isOver: false,
	                clientX: 0,
	                clientY: 0,
	                scrollPosition: 0,
	                thumbnailLoaded: false
	            };
	        } else {
	            return {
	                isOver: false,
	                clientX: 0,
	                clientY: 0,
	                scrollPosition: 0,
	                thumbnailLoaded: true
	            };
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	    },
	    refreshForScroll: function refreshForScroll(position) {
	        if (!_MasterUniverseUtils2.default.useThumbnailsLazyLoading(this.props.usePagination)) return;
	
	        this.setState({
	            scrollPosition: position
	        });
	    },
	    initElements: function initElements() {
	        if (_MasterUniverseUtils2.default.useThumbnailsLazyLoading(this.props.usePagination)) this.props.addRefreshHandler(this.refreshForScroll, this.props.index);
	
	        var gap = 2;
	        var width = 100;
	
	        var itemRendererStyle = {
	            position: 'relative',
	            width: width,
	            textAlign: 'center',
	            display: 'inline-block',
	            paddingTop: gap,
	            paddingLeft: gap,
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            cursor: '-webkit-grab'
	        };
	
	        var thumbHolderWidth = width;
	        var thumbHolderHeight = width * 3 / 4;
	
	        var thumbHolderStyle = {
	            width: thumbHolderWidth,
	            height: thumbHolderHeight,
	            background: this.props.backgroundColor,
	            display: 'block',
	            top: 0
	        };
	
	        var imageStyle;
	        var imageWidth;
	        var imageHeight;
	
	        imageWidth = thumbHolderWidth;
	        imageHeight = thumbHolderHeight;
	
	        imageStyle = {
	            position: 'absolute',
	            width: imageWidth,
	            height: imageHeight,
	            left: thumbHolderWidth / 2 - imageWidth / 2 + 2,
	            top: thumbHolderHeight / 2 - imageHeight / 2,
	            display: 'block'
	        };
	
	        var frameDisplayState = void 0;
	
	        if (this.state.isOver == true) frameDisplayState = 'block';else frameDisplayState = 'none';
	
	        var boderWidth = 1;
	
	        var frameStyle = {
	            width: width,
	            height: width * 3 / 4 + 19 - 2 * boderWidth,
	            borderWidth: boderWidth,
	            borderStyle: 'solid',
	            borderColor: '#c05600',
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            display: frameDisplayState
	        };
	
	        var fontStyle = {
	            fontSize: 10,
	            height: 15,
	            width: width - 6,
	            paddingLeft: 3,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            background: 'white',
	            top: 0
	        };
	
	        var src = void 0;
	
	        if (this.props.isMedia) {
	            if (this.props.item.thumbnailUrl) src = this.props.item.thumbnailUrl;else src = this.props.item.thumb;
	        } else {
	            if (this.props.item && this.props.item.href && (this.props.item.href.indexOf('cartoonist_background_halloween') != -1 || this.props.item.href.indexOf('nature_dinosaurs_Trex_walking_01') != -1 || this.props.item.href.indexOf('easter_religious_angel_01') != -1)) {
	                src = this.props.item.href;
	            } else {
	                if (_AppParameters2.default.clipartId == 111 || this.props.isBackground && (_AppParameters2.default.clipartId == 75463385 || _AppParameters2.default.clipartId == 92167535) && this.props.item.href && this.props.item.href.indexOf('cartoonist_background_halloween') != -1) // for Halloween there is something wrong with the backgrounds generation
	                    src = this.props.item.href;else src = this.props.item.thumbnailUrl;
	            }
	        }
	
	        var visibleFrame = 'none';
	        var visibleBorder = 'none';
	        var dragOffset = 17;
	
	        if (this.props.isBackground) {
	            visibleFrame = 'block';
	
	            if (this.props.item.logicalName == '') visibleBorder = 'solid';
	
	            fontStyle.position = 'relative';
	            fontStyle.top = -8;
	            fontStyle.height = 13;
	            frameStyle.height = frameStyle.height - 12;
	            itemRendererStyle.paddingTop = 0;
	            itemRendererStyle.height = thumbHolderHeight + 5;
	            itemRendererStyle.marginTop = -11;
	
	            if (_PlatformDetection2.default.isTouchableDevice() == true) itemRendererStyle.marginTop = 0;
	
	            dragOffset = 5;
	        }
	
	        var offsetY = (imageWidth * 3 / 4 - imageWidth * 9 / 16) / 2;
	        var topBackground = {
	            position: 'absolute',
	            top: 0,
	            left: 2,
	            background: 'white',
	            width: imageWidth,
	            height: offsetY,
	            display: visibleFrame,
	            borderBottomStyle: visibleBorder,
	            borderBottomWidth: 1,
	            borderBottomColor: '#C0C0C0'
	        };
	
	        var bottomBackground = {
	            position: 'absolute',
	            top: imageHeight - offsetY,
	            left: 2,
	            background: 'white',
	            width: imageWidth,
	            height: offsetY,
	            display: visibleFrame,
	            borderTopStyle: visibleBorder,
	            borderTopWidth: 1,
	            borderTopColor: '#C0C0C0'
	        };
	
	        var draggleStyle = {
	            width: width,
	            height: width * 3 / 4 + dragOffset,
	            position: 'absolute',
	            top: 0,
	            background: 'red',
	            opacity: 0,
	            display: 'block'
	        };
	
	        var imageElement = _react2.default.createElement(
	            'span',
	            { style: thumbHolderStyle },
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', src: src, style: imageStyle }),
	            _react2.default.createElement('span', { style: topBackground }),
	            _react2.default.createElement('span', { style: bottomBackground })
	        );
	
	        var imageElementEmpty = _react2.default.createElement(
	            'span',
	            { style: thumbHolderStyle },
	            _react2.default.createElement('span', { style: imageStyle }),
	            _react2.default.createElement('span', { style: topBackground }),
	            _react2.default.createElement('span', { style: bottomBackground })
	        );
	
	        var fontElement = _react2.default.createElement(
	            'span',
	            { style: fontStyle },
	            this.getTitle()
	        );
	
	        var draggableElement = _react2.default.createElement(
	            _reactDraggable2.default,
	            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onDragStart, onDrag: this.onDragMove, onStop: this.onDragEnd },
	            _react2.default.createElement('span', { style: draggleStyle })
	        );
	
	        var uploadButton;
	
	        if (this.props.item && this.props.item.isUploadButton) {
	            var uploadItemRendererStyle = {
	                position: 'relative',
	                width: width,
	                paddingTop: gap,
	                paddingLeft: gap,
	                display: 'inline-block',
	                textAlign: 'center'
	            };
	
	            if (_PlatformDetection2.default.isIOS()) uploadItemRendererStyle.height = 60;
	
	            if (this.props.length < 2) {
	                uploadItemRendererStyle.height = 60;
	                uploadItemRendererStyle.paddingTop = 7;
	            }
	
	            var wrapperUploadButtonStyle = {
	                width: width,
	                height: this.props.isVideo ? 94 : 78,
	                textAlign: 'center',
	                display: 'block',
	                top: 0
	            };
	
	            var uploadIconStyle = {
	                position: 'absolute',
	                top: this.props.isVideo ? 10 : 0,
	                left: 21,
	                color: '#2DE102',
	                cursor: 'pointer'
	            };
	
	            if (_PlatformDetection2.default.isIOS()) {
	                uploadButton = _react2.default.createElement(
	                    'div',
	                    { style: uploadItemRendererStyle, onMouseDown: this.onUpload, onTouchStart: this.onUpload, onMouseOver: this.onUploadMouseIn, onMouseOut: this.onUploadMouseOut },
	                    _react2.default.createElement(
	                        'div',
	                        { style: wrapperUploadButtonStyle },
	                        _react2.default.createElement('i', { style: uploadIconStyle, id: 'uploadButton', className: 'fa fa-plus-circle fa-4x' })
	                    )
	                );
	            } else {
	                uploadItemRendererStyle.paddingRight = 0;
	                uploadItemRendererStyle.paddingBottom = 0;
	                uploadItemRendererStyle.boxSizing = 'initial';
	                uploadItemRendererStyle.fontSize = 'initial';
	                uploadItemRendererStyle.borderStyle = 'none';
	                uploadItemRendererStyle.background = 'none';
	
	                uploadButton = _react2.default.createElement(
	                    'button',
	                    { 'aria-label': _LocalesManager2.default.getCaption('UploadHover', 'myFiles'), style: uploadItemRendererStyle, onClick: this.onUpload, onTouchStart: this.onUpload, onMouseOver: this.onUploadMouseIn, onMouseOut: this.onUploadMouseOut },
	                    _react2.default.createElement(
	                        'span',
	                        { style: wrapperUploadButtonStyle },
	                        _react2.default.createElement('i', { style: uploadIconStyle, id: 'uploadButton', className: 'fa fa-plus-circle fa-4x' })
	                    )
	                );
	            }
	        }
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            var frameElement = _react2.default.createElement('div', { style: frameStyle });
	
	            this.setState({
	                imageElement: imageElement,
	                imageElementEmpty: imageElementEmpty,
	                fontElement: fontElement,
	                draggableElement: draggableElement,
	                itemRendererStyle: itemRendererStyle,
	                frameElement: frameElement,
	                uploadButton: uploadButton
	            });
	        } else {
	            this.setState({
	                imageElement: imageElement,
	                imageElementEmpty: imageElementEmpty,
	                fontElement: fontElement,
	                draggableElement: draggableElement,
	                itemRendererStyle: itemRendererStyle,
	                frameStyle: frameStyle,
	                uploadButton: uploadButton
	            });
	        }
	    },
	    onUpload: function onUpload(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e) || this.isDisabled()) return;
	
	        window.parent.postMessage('openUploader', '*');
	    },
	    onUploadMouseIn: function onUploadMouseIn() {
	        var button = document.getElementById('uploadButton');
	        _HoverManager2.default.show(button, 'uploadButton', 'right');
	    },
	    onUploadMouseOut: function onUploadMouseOut() {
	        _HoverManager2.default.hide();
	    },
	    onFocus: function onFocus() {
	        var type = 'ListItemRenderer';
	
	        if (this.props.isBackground == true) type = 'ListItemRendererBackground';
	
	        _ToolTipManager2.default.showToolTip(this.getTitle(), this.refs.itemRenderer, type, this.changeHoverState);
	    },
	    onBlur: function onBlur() {
	        _ToolTipManager2.default.hideToolTip();
	    },
	    onMouseIn: function onMouseIn() {
	        if (this.isDisabled()) {
	            this.setState({
	                isMouseIn: true,
	                thumbnailLoaded: true
	            });
	
	            return;
	        }
	
	        this.setState({
	            isOver: true,
	            thumbnailLoaded: true
	        });
	
	        var type = 'ListItemRenderer';
	
	        if (this.props.isBackground == true) type = 'ListItemRendererBackground';
	
	        _ToolTipManager2.default.showToolTip(this.getTitle(), this.refs.itemRenderer, type, this.changeHoverState);
	    },
	    onMouseOut: function onMouseOut() {
	        if (this.isDisabled()) {
	            this.setState({
	                isMouseIn: false,
	                thumbnailLoaded: true
	            });
	
	            return;
	        }
	
	        this.setState({
	            isOver: false,
	            thumbnailLoaded: true
	        });
	
	        _ToolTipManager2.default.hideToolTip();
	    },
	    changeHoverState: function changeHoverState(value) {
	        this.setState({
	            isOver: value,
	            thumbnailLoaded: true
	        });
	    },
	    changeFocusToShapeMenuButton: function changeFocusToShapeMenuButton() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var shapeMenuButton = document.getElementById('shapeMenuButton');
	
	            if (shapeMenuButton) shapeMenuButton.focus();
	        }.bind(this), 300);
	    },
	    createShape: function createShape(topLeftPosition) {
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        if (this.props.isVideo || this.props.item.href && this.props.item.href.indexOf('video') !== -1 && this.props.item.href.indexOf('svg') === -1) {
	            if (_CreateShapes2.default.useVideoAsBackground) this.setVideoAsBackground(this.props.item, dispatch);else _CreateShapes2.default.createVideo(dispatch, this.props.item, topLeftPosition);
	            return;
	        }
	
	        if (this.props.item && this.props.item.isPrint) {
	            // added for CART-1463 ... just printable items can behave as banckground image
	            this.setImageAsBackground(this.props.item, dispatch);
	            return;
	        }
	
	        if (this.props.isBackground) {
	            if (this.props.isMedia) {
	                // is MyImages from Search
	                if (_CreateShapes2.default.useImageAsBackground) this.setImageAsBackground(this.props.item, dispatch);else {
	                    if (_MindMapUtils2.default.isMindMapMode()) _MindMapUtils2.default.insertMediaNode(this.props.item);else _CreateShapes2.default.createImage(dispatch, this.props.item, topLeftPosition);
	
	                    this.changeFocusToShapeMenuButton();
	                }
	
	                return;
	            }
	
	            if (this.props.isFrame) {
	                // is Frames from Search
	                if (_CreateShapes2.default.useFrameAsImage) {
	                    if (this.props.item.moods && this.props.item.moods.length > 1) {
	                        _CreateShapes2.default.createCharacter(dispatch, this.props.item, topLeftPosition);
	                    } else {
	                        _CreateShapes2.default.createImage(dispatch, this.props.item, topLeftPosition);
	                    }
	
	                    this.changeFocusToShapeMenuButton();
	
	                    return;
	                }
	            } else {
	                // is Background from Search or from the theme
	                if (_CreateShapes2.default.useBackgroundAsImage && !this.props.item.noBackground) {
	                    if (this.props.item.moods && this.props.item.moods.length > 1) {
	                        _CreateShapes2.default.createCharacter(dispatch, this.props.item, topLeftPosition);
	                    } else {
	                        _CreateShapes2.default.createImage(dispatch, this.props.item, topLeftPosition);
	                    }
	
	                    this.changeFocusToShapeMenuButton();
	
	                    return;
	                }
	            }
	
	            var newContent = {};
	            newContent.logicalName = this.props.item.logicalName;
	            newContent.href = this.props.item.href;
	            newContent.moods = this.props.item.moods;
	            newContent.orgWidth = 0;
	            newContent.orgHeight = 0;
	
	            newContent.isVideo = false;
	            newContent.volume = 0.5;
	            newContent.inPoint = undefined;
	            newContent.outPoint = undefined;
	            newContent.theme = this.props.item.theme;
	
	            if (this.props.item.noBackground) {
	                newContent.fill = '#ffffff';
	                newContent.fillOpacity = 1;
	                newContent.stroke = '#ffffff';
	                newContent.strokeOpacity = 0;
	                newContent.logicalName = '';
	                newContent.href = '';
	                newContent.moods = [];
	            }
	
	            if (this.props.item.moods && this.props.item.moods.length > 0) newContent.frameLabel = this.props.item.moods[0];else newContent.frameLabel = ''; // TO DO: it's just for test until fix the moods problem
	
	            dispatch((0, _CurrentSlideActions.changeBackgroundContent)(newContent));
	            _CreateShapes2.default.updateThumbnail(dispatch);
	            _AudioEditorUtils2.default.addActionToHistory();
	            _SaveManager2.default.isContentChanged(true);
	
	            if (_PlatformDetection2.default.isEdge()) {
	                // CH-457: force to redraw again ... the second time works fine.
	                setTimeout(function () {
	                    _CreateShapes2.default.updateThumbnail(dispatch);
	                }, 300);
	            }
	        } else {
	            if (this.props.item.moods && this.props.item.moods.length > 1) {
	                if (_MindMapUtils2.default.isMindMapMode()) _MindMapUtils2.default.insertMediaNode(this.props.item, true);else _CreateShapes2.default.createCharacter(dispatch, this.props.item, topLeftPosition);
	            } else {
	                if (_MindMapUtils2.default.isMindMapMode()) _MindMapUtils2.default.insertMediaNode(this.props.item);else _CreateShapes2.default.createImage(dispatch, this.props.item, topLeftPosition);
	            }
	
	            this.changeFocusToShapeMenuButton();
	        }
	    },
	    setImageAsBackground: function setImageAsBackground(item, dispatch) {
	        var imageObj = new Image();
	        var self = this;
	
	        imageObj.onload = function (e) {
	            var orgWidth = e.target.width;
	            var orgHeight = e.target.height;
	
	            self.changeBackgroundProperties(item, dispatch, orgWidth, orgHeight);
	        };
	
	        imageObj.src = _VideoUtils2.default.checkCacheBreaker(item.href);
	    },
	    changeBackgroundProperties: function changeBackgroundProperties(item, dispatch, orgWidth, orgHeight) {
	        var newContent = {};
	        newContent.logicalName = item.logicalName;
	        newContent.href = item.href;
	        newContent.moods = [];
	        newContent.hotSpot = '';
	        newContent.frameLabel = '';
	        newContent.orgWidth = orgWidth;
	        newContent.orgHeight = orgHeight;
	
	        newContent.isVideo = false;
	        newContent.volume = 0.5;
	        newContent.inPoint = undefined;
	        newContent.outPoint = undefined;
	
	        if (item.contentItemId > 0) newContent.contentItemId = item.contentItemId;
	
	        dispatch((0, _CurrentSlideActions.changeBackgroundContent)(newContent));
	        _CreateShapes2.default.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        _SaveManager2.default.isContentChanged(true);
	    },
	    setVideoAsBackground: function setVideoAsBackground(item, dispatch) {
	        _VideoUtils2.default.updateContentFromCurrentSlide();
	
	        var newContent = {};
	        newContent.logicalName = item.logicalName;
	        newContent.href = item.href;
	        newContent.moods = [];
	        newContent.hotSpot = '';
	        newContent.frameLabel = '';
	
	        newContent.isVideo = true;
	        newContent.volume = 0.5;
	        newContent.inPoint = undefined;
	        newContent.outPoint = undefined;
	
	        if (item.contentItemId > 0) newContent.contentItemId = item.contentItemId;
	
	        _VideoUtils2.default.changeVideoBackground = true;
	
	        dispatch((0, _CurrentSlideActions.changeBackgroundContent)(newContent));
	        _CreateShapes2.default.updateThumbnail(dispatch);
	        dispatch((0, _MenuActions.showAudioAlert)(3));
	
	        if (_VideoUtils2.default.refreshItemRenderer) _VideoUtils2.default.refreshItemRenderer();
	
	        _VideoUtils2.default.refreshItemRenderer = this.refreshElement;
	    },
	    getTitle: function getTitle() {
	        if (this.props.item.title) return this.props.item.title;
	
	        var title = '';
	
	        if (this.props.item.noBackground == true) title = this.props.item.title;
	
	        return title;
	    },
	    isVideoItem: function isVideoItem(item) {
	        if (!item) return false;
	
	        if (item.href && item.href.indexOf('video') !== -1 && item.href.indexOf('svg') === -1) return true;
	
	        if (item.contentType && item.contentType.indexOf('video') != -1) return true;
	
	        return false;
	    },
	    rejectMouseDownEvent: function rejectMouseDownEvent(e) {
	        if (_PlatformDetection2.default.isChromeBook()) {
	            var currentTime = new Date().getTime();
	            var lastClickTime = _MouseUtils2.default.mouseDownTime;
	
	            if (lastClickTime != 0 && currentTime - lastClickTime < 100) return true;else return false;
	        } else return false;
	    },
	    onMouseDown: function onMouseDown(e) {
	        console.log('TestTime Mouse down : ' + new Date().getTime());
	
	        if (_MouseUtils2.default.rejectMouseEvent(e) || this.isDisabled() || this.rejectMouseDownEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	        _MouseUtils2.default.isDragEnd = false;
	
	        _ToolTipManager2.default.hideToolTip();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (this.isVideoItem(this.props.item) && _VideoUtils2.default.showVideoEditor()) {
	            var currentTime = new Date().getTime();
	
	            if (this.state.currentTime > 0 && currentTime - this.state.currentTime < 300) {
	                if (_VideoUtils2.default.loadedVideo && this.props.item.href == _VideoUtils2.default.loadedVideo) {
	                    _VideoUtils2.default.autoPlayVideo();
	                } else {
	                    _VideoUtils2.default.executeAutoPlay = true;
	                }
	            }
	
	            this.setState({
	                clientX: clientPosition.x,
	                clientY: clientPosition.y,
	                currentTime: currentTime,
	                thumbnailLoaded: true
	            });
	        } else {
	            this.setState({
	                clientX: clientPosition.x,
	                clientY: clientPosition.y,
	                thumbnailLoaded: true
	            });
	        }
	    },
	    rejectMouseUpEvent: function rejectMouseUpEvent(e) {
	        if (_PlatformDetection2.default.isChromeBook()) {
	            var currentTime = new Date().getTime();
	            var lastClickTime = _MouseUtils2.default.mouseUpTime;
	
	            if (lastClickTime != 0 && currentTime - lastClickTime < 100) return true;else return false;
	        } else return false;
	    },
	    onMouseUp: function onMouseUp(e) {
	        console.log('TestTime Mouse Up : ' + new Date().getTime());
	
	        if (_MouseUtils2.default.rejectMouseEvent(e) || this.isDisabled() || this.rejectMouseUpEvent(e)) return;
	
	        _MouseUtils2.default.mouseUpTime = new Date().getTime();
	
	        if (_MouseUtils2.default.isDragEnd == true) {
	            _MouseUtils2.default.isDragEnd = true;
	            return;
	        }
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.createShape();
	    },
	    onClick: function onClick() {
	        console.log('TestTime Click : ' + new Date().getTime());
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        _MouseUtils2.default.isDragEnd = false;
	
	        this.createShape();
	    },
	    isDisabled: function isDisabled() {
	        return false;
	    },
	    onDragStart: function onDragStart(e, coreEvent) {
	        console.log('TestTime Drag start : ' + new Date().getTime());
	
	        if (_PlatformDetection2.default.isTouchableDevice() == true || this.isDisabled()) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	        _MouseUtils2.default.isDragEnd = false;
	
	        _ToolTipManager2.default.hideToolTip();
	
	        var clone = this.refs.itemRenderer;
	
	        if (this.props.isBackground == true) clone.className = 'background';
	
	        _DragManager2.default.prepareClone(clone, this.createShape, (0, _TransformToolUtils.getTouchPosition)(e));
	    },
	    onDragMove: function onDragMove(e, coreEvent) {
	        if (_PlatformDetection2.default.isTouchableDevice() == true || this.isDisabled()) return;
	
	        _DragManager2.default.onDragMove(coreEvent.lastX, coreEvent.lastY);
	    },
	    onDragEnd: function onDragEnd(e, coreEvent) {
	        console.log('TestTime Drag end : ' + new Date().getTime());
	
	        if (_PlatformDetection2.default.isTouchableDevice() == true || this.isDisabled()) return;
	
	        _MouseUtils2.default.isDragEnd = true;
	
	        _DragManager2.default.onDragEnd(coreEvent.lastX, coreEvent.lastY);
	    },
	    isSelectionVisible: function isSelectionVisible() {
	        var backgroundVideo = _VideoUtils2.default.getBackgroundVideo();
	
	        if (this.isVideoItem(this.props.item) && backgroundVideo != '') {
	            if (this.props.item.href == backgroundVideo) {
	                if (_VideoUtils2.default.refreshItemRenderer == undefined) _VideoUtils2.default.refreshItemRenderer = this.refreshElement;
	
	                return true;
	            } else return false;
	        } else return false;
	    },
	    refreshElement: function refreshElement() {
	        this.forceUpdate();
	    },
	    useThumbnail: function useThumbnail() {
	        if (!_MasterUniverseUtils2.default.useThumbnailsLazyLoading(this.props.usePagination)) return true;
	
	        if (this.state.thumbnailLoaded) return true;
	
	        var defaultItemLines;
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (this.props.isSearch) defaultItemLines = 10;else defaultItemLines = 7;
	        } else {
	            if (this.props.isSearch) defaultItemLines = 12;else defaultItemLines = 12;
	        }
	
	        var state = _StoreManager2.default.getState();
	        var parentWidth = state.accordion.width;
	
	        if (parentWidth == undefined) parentWidth = _Properties2.default.BROWSER_WIDTH;
	
	        var itemHeight = this.props.isBackground || this.props.item.href && this.props.item.href.indexOf('video') !== -1 && this.props.item.href.indexOf('svg') === -1 ? 80 : 96; // 80 - backgrounds and videos, 96 - rest of ones
	        var itemWidth = 102;
	        var scrollWidth = 20;
	        var realWidth = parentWidth - scrollWidth;
	        var itemsPerLine = Math.floor(realWidth / itemWidth);
	        var minimListHeight = itemHeight * defaultItemLines;
	        var currentLine = Math.ceil((this.props.index + 1) / itemsPerLine);
	        var currentPosition = currentLine * itemHeight;
	        var scrollPosition = this.state.scrollPosition + minimListHeight;
	
	        if (currentPosition <= scrollPosition) {
	            setTimeout(function () {
	                this.setState({
	                    thumbnailLoaded: true
	                });
	            }.bind(this), 5);
	
	            return true;
	        } else return false;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (!this.state.thumbnailLoaded || this.state.imageElement != nextState.imageElement || this.state.isOver != nextState.isOver || this.state.frameStyle != nextState.frameStyle || this.state.isMouseIn != nextState.isMouseIn) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.imageElement == undefined) return _react2.default.createElement('div', null);
	
	        if (this.props.item && this.props.item.isUploadButton) {
	            return this.state.uploadButton;
	        }
	
	        var imgElement = this.useThumbnail() ? this.state.imageElement : this.state.imageElementEmpty;
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            return _react2.default.createElement(
	                'div',
	                { ref: 'itemRenderer', id: 'ListItemRenderer_' + this.props.index, style: this.state.itemRendererStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp },
	                imgElement,
	                this.state.fontElement,
	                this.state.frameElement,
	                this.state.draggableElement
	            );
	        } else {
	            var frameStyle = Object.assign({}, this.state.frameStyle);
	            var frameDisplayState = void 0;
	
	            if (this.state.isOver == true) frameDisplayState = 'block';else frameDisplayState = 'none';
	
	            frameStyle.display = frameDisplayState;
	
	            var style = Object.assign({}, this.state.itemRendererStyle);
	
	            if (this.isDisabled()) style.cursor = 'default';else style.cursor = '-webkit-grab';
	
	            var iconVisible;
	
	            if (this.isSelectionVisible()) iconVisible = 'block';else iconVisible = 'none';
	
	            var checkIconStyle = {
	                position: 'absolute',
	                bottom: 18,
	                right: 5,
	                display: iconVisible,
	                width: 25,
	                height: 25
	            };
	
	            style.paddingRight = 0;
	            style.paddingBottom = 0;
	            style.boxSizing = 'initial';
	            style.fontSize = 'initial';
	            style.borderStyle = 'none';
	            style.background = 'none';
	
	            return _react2.default.createElement(
	                'button',
	                { 'aria-label': this.getTitle(), ref: 'itemRenderer', id: 'ListItemRenderer_' + this.props.index, style: style, onClick: this.onClick, onFocus: this.onFocus, onBlur: this.onBlur, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp },
	                imgElement,
	                this.state.fontElement,
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: checkIconStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/selectedThemeHover.png' }),
	                _react2.default.createElement('span', { style: frameStyle }),
	                this.state.draggableElement
	            );
	        }
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/ListItemRenderer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/ListItemRenderer.js"); } } })();

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _ZipLoader = __webpack_require__(228);
	
	var _ZipLoader2 = _interopRequireDefault(_ZipLoader);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MoodsUtils = __webpack_require__(124);
	
	var _MoodsUtils2 = _interopRequireDefault(_MoodsUtils);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clipartParserJSONNew = {
	    cartoonistEffects: undefined,
	    frames: undefined,
	
	    parseClipartModel: function parseClipartModel(jsonObject) {
	        var isEffect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var effectsTitle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	        var isFrames = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        if (!jsonObject || jsonObject.length < 1) {
	            this.addClipartModelHandler({ items: [], captionKey: _AppParameters2.default.currentTheme });
	            return;
	        }
	
	        var categories = this.getCategories(jsonObject); // needs also to sort the categories by a categoryPosition property
	        var i;
	        var j;
	        var clipartModel = {};
	        var item;
	        var printCategory = void 0;
	
	        if (!isEffect) clipartModel.captionKey = categories[0].items[0].theme;
	
	        clipartModel.items = [];
	
	        for (i = 0; i < categories.length; i++) {
	            var object = categories[i];
	            var isPrint = false;
	
	            item = {};
	
	            if (isEffect) item.title = effectsTitle;else item.title = this.getCategoryTitle(object.caption, clipartModel.captionKey);
	
	            item.items = [];
	
	            for (j = 0; j < object.items.length; j++) {
	                var resourceObject = object.items[j];
	
	                if (resourceObject.hidden < 1) // don't add hidden elements
	                    continue;else {
	                    if (_Configuration2.default.IS_PROD() && resourceObject.hidden == 1) // 0 - hidden, 1 - only stage, 2 - stage and prod
	                        continue;
	                }
	
	                var resource = {};
	
	                resource.title = this.getTitle(resourceObject);
	                resource.logicalName = this.removeElementFromLogicalName(resourceObject.logicalname, '_svg'); // rename to logicalName
	
	                if (resourceObject.type === 'prints') {
	                    resource.isPrint = true;
	                    isPrint = true;
	                }
	
	                if (resourceObject.theme != 'cartoonist_effects') resource.theme = resourceObject.theme;
	
	                this.parseMoods(resource, resourceObject.moods);
	
	                this.buildHref(resource);
	                this.buildThumbnail(resource);
	
	                if (resourceObject.width > 0 && resourceObject.height > 0) {
	                    resource.width = resourceObject.width;
	                    resource.height = resourceObject.height;
	                }
	
	                if (this.isVisibleItem(resource)) item.items.push(resource);
	            }
	
	            if (isPrint) printCategory = item;else clipartModel.items.push(item);
	        }
	
	        if (printCategory) clipartModel.items.push(printCategory);
	
	        if (isFrames) {
	            this.frames = clipartModel.items[0];
	        } else if (isEffect) {
	            this.cartoonistEffects = clipartModel.items[0];
	        } else {
	            this.addClipartModelHandler(clipartModel);
	        }
	    },
	    isVisibleItem: function isVisibleItem(item) {
	        var isSwedish = _AppParameters2.default.locale == 'sv_SE' ? true : false;
	        var forbiddenElements = [];
	
	        if (isSwedish) forbiddenElements = ['alphabet_planet_ae_theme_characters_ae_upper', 'alphabet_planet_ae_theme_characters_ae_lower', 'alphabet_planet_oe_theme_characters_oe_upper', 'alphabet_planet_oe_theme_characters_oe_lower', 'alphabet_planet_ae_theme_house_front', 'alphabet_planet_oe_theme_house_front'];else forbiddenElements = ['alphabet_planet_ae_theme_alphabet_ae_upper_swedish', 'alphabet_planet_ae_theme_alphabet_ae_lower_swedish', 'alphabet_planet_oe_theme_alphabet_oe_upper_swedish', 'alphabet_planet_oe_theme_alphabet_oe_lower_swedish', 'alphabet_planet_ae_theme_house_front_swedish', 'alphabet_planet_oe_theme_backgrounds_house_front', 'alphabet_planet_oe_theme_house_front_sweedish'];
	
	        if (forbiddenElements.indexOf(item.logicalName) != -1) return false;else return true;
	    },
	    getCategoryTitle: function getCategoryTitle(category, themeName) {
	        var captionName = themeName + '_' + category;
	        var translation = _LocalesManager2.default.getThemeCategoryCaption(captionName);
	
	        if (translation != captionName) return translation;else return _LocalesManager2.default.getThemeCategoryCaption(category);
	    },
	    getTitle: function getTitle(item) {
	        if (!item.translations) return item.logicalname;else {
	            var translation = item.translations[_MasterUniverseUtils2.default.language()];
	
	            if (translation && translation.length > 0) return translation;else if (item.translations['en_US']) return item.translations['en_US'];else return item.logicalname;
	        }
	    },
	    getCategories: function getCategories(array) {
	        var categoriesMap = [];
	        var categories = [];
	        var categoriesArray = [];
	        var i;
	        var backgroundsItems = ['backgrounds'];
	        var charactersItems = ['people', 'characters'];
	        var propsItems = ['props', 'rekvisita', 'stone_age__props', 'bronze_age__props', 'iron_age__props'];
	        var backgroundsValue = '';
	        var charactersValue = '';
	        var propsValue = '';
	
	        for (i = 0; i < array.length; i++) {
	            var category = array[i].type;
	
	            if (!categoriesMap[category]) {
	                if (backgroundsItems.indexOf(category) != -1) backgroundsValue = category;else {
	                    if (charactersItems.indexOf(category) != -1) charactersValue = category;else {
	                        if (propsItems.indexOf(category) != -1) propsValue = category;else categoriesArray.push(category);
	                    }
	                }
	
	                categoriesMap[category] = { 'caption': category, 'items': [] };
	            }
	
	            categoriesMap[category].items.push(array[i]);
	        }
	
	        categoriesArray = categoriesArray.sort();
	
	        var firstCategories = [];
	
	        if (backgroundsValue != '') firstCategories = [backgroundsValue]; // backgrounds should be the first item
	
	        if (charactersValue != '') firstCategories.push(charactersValue);
	
	        categoriesArray = firstCategories.concat(categoriesArray); // characters should be the second item
	
	        if (propsValue != '') categoriesArray = categoriesArray.concat([propsValue]); // props should be the last item
	
	        for (i = 0; i < categoriesArray.length; i++) {
	            var key = categoriesArray[i];
	            categoriesMap[key].items = this.sortElementsByPosition(categoriesMap[key].items);
	            categories.push(categoriesMap[key]);
	        }
	
	        return categories;
	    },
	    sortElementsByPosition: function sortElementsByPosition(array) {
	        array.sort(function (a, b) {
	            return a.position - b.position;
	        });
	
	        return array;
	    },
	    parseMoods: function parseMoods(resource, moods) {
	        if (moods == undefined) resource.moods = [];else resource.moods = moods;
	    },
	    buildThumbnail: function buildThumbnail(resource) {
	        var thumbsPrefix = _AppParameters2.default.SVG_URL();
	        var mood = '';
	
	        if (resource.moods.length > 0) mood = resource.moods[0];
	
	        resource.thumbnailUrl = thumbsPrefix + 'thumbnails-content/' + resource.logicalName + '_' + mood + '_svg.png';
	    },
	    buildHref: function buildHref(resource) {
	        var hrefPrefix = _AppParameters2.default.SVG_URL();
	        var href = hrefPrefix + resource.logicalName;
	        var mood = '';
	
	        if (resource.moods.length > 0) mood = resource.moods[0];
	
	        href = href + '_' + mood + '.svg';
	
	        resource.href = href;
	    },
	    removeElementFromLogicalName: function removeElementFromLogicalName(logicalName, deletedElement) {
	        if (!logicalName) return '';
	
	        var index = logicalName.indexOf(deletedElement);
	
	        if (index > 0) logicalName = logicalName.substring(0, index);
	
	        if (logicalName.charAt(logicalName.length - 1) == '_') logicalName = logicalName.substring(0, logicalName.length - 1);
	
	        return logicalName;
	    },
	    addClipartModelHandler: function addClipartModelHandler(clipartModel) {
	        _MoodsUtils2.default.clipartModel = clipartModel;
	
	        var state = _StoreManager2.default.getState();
	
	        if (state.music.soundClipartModel == undefined) _ZipLoader2.default.loadData('audio');
	
	        this.updateClipartModelToState();
	    },
	    updateClipartModelToState: function updateClipartModelToState() {
	        var store = _StoreManager2.default.getStore();
	        store.dispatch((0, _AccordionActions.addClipartModel)(_MoodsUtils2.default.clipartModel));
	    },
	    parseSearchItems: function parseSearchItems(items, category) {
	        var i;
	        var props = [];
	        var characters = [];
	        var backgrounds = [];
	        var frames = [];
	        var effects = [];
	        var others = [];
	        var newItems = [];
	        var propsItems = ['props', 'rekvisita', 'stone_age__props', 'bronze_age__props', 'iron_age__props'];
	        var charactersItems = ['people', 'characters'];
	        var backgroundsItems = ['backgrounds'];
	
	        for (i = 0; i < items.length; i++) {
	            var resourceObject = items[i];
	            var resource = {};
	
	            resource.title = this.getTitle(resourceObject);
	            resource.logicalName = this.removeElementFromLogicalName(resourceObject.logicalname, '_svg'); // rename to logicalName
	
	            if (resourceObject.theme != 'cartoonist_effects') resource.theme = resourceObject.theme;
	
	            this.parseMoods(resource, resourceObject.moods);
	
	            this.buildHref(resource);
	            this.buildThumbnail(resource);
	
	            if (category == 'all') {
	                if (backgroundsItems.indexOf(resourceObject.type) != -1) {
	                    if (resourceObject.theme == 'frames') frames.push(resource);else backgrounds.push(resource);
	                } else {
	                    if (charactersItems.indexOf(resourceObject.type) != -1) {
	                        characters.push(resource);
	                    } else {
	                        if (propsItems.indexOf(resourceObject.type) != -1) {
	                            if (resourceObject.theme == 'cartoonist_effects') effects.push(resource);else props.push(resource);
	                        } else others.push(resource);
	                    }
	                }
	            } else {
	                newItems.push(resource);
	            }
	
	            if (items[i].type == "backgrounds") resource.isBackground = true;
	        }
	
	        if (category == 'all') {
	            newItems = props.concat(characters);
	            newItems = newItems.concat(backgrounds);
	            newItems = newItems.concat(frames);
	            newItems = newItems.concat(effects);
	            newItems = newItems.concat(others);
	
	            return newItems;
	        } else {
	            return newItems;
	        }
	    }
	};
	
	exports.default = clipartParserJSONNew;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/clipartUtils/ClipartParserJSONNew.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/clipartUtils/ClipartParserJSONNew.js"); } } })();

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioCategorySelectorNew = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MusicActions = __webpack_require__(91);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.changeCategory();
	
	        if (this.props.refresh) this.props.refresh();
	    },
	    onClick: function onClick(e) {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.changeCategory();
	
	        if (this.props.refresh) this.props.refresh();
	    },
	    changeCategory: function changeCategory() {
	        if (this.props.type == 'soundEffects') {
	            if (this.props.selectedIndex != this.props.index) {
	                this.props.dispatch((0, _MusicActions.changeSoundEffectsCategoryIndex)(this.props.index));
	                this.props.dispatch((0, _MenuActions.expandAudioList)(false, 'all'));
	            }
	        } else if (this.props.type == 'main') {
	            if (this.props.selectedIndex != this.props.index) {
	                this.props.dispatch((0, _MusicActions.changeMainAudioCategoryIndex)(this.props.index));
	                this.props.dispatch((0, _MenuActions.expandAudioList)(false, 'all'));
	
	                if (this.props.isAdvancedMenu) {
	                    if (this.props.index == 2) this.props.dispatch((0, _MusicActions.changeMusicContentIndex)(1));else this.props.dispatch((0, _MusicActions.changeMusicContentIndex)(0));
	                }
	            }
	        } else {
	            if (this.props.selectedIndex != this.props.index) {
	                this.props.dispatch((0, _MusicActions.changeSecondAudioCategoryIndex)(this.props.index));
	                this.props.dispatch((0, _MenuActions.expandAudioList)(false, 'all'));
	            }
	        }
	    },
	    render: function render() {
	        var iconColor;
	        var buttonColor;
	
	        if (this.state.isOver == true) {
	            iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	            buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	        } else {
	            iconColor = 'black';
	            buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	        }
	
	        var topPosition = this.props.index * _Properties2.default.EFFECTS_BUTTON_HEIGHT;
	        var cornerOffset = 14;
	        var scrollWidth = _Properties2.default.EFFECTS_PADDING;
	
	        if (this.props.dataProviderLength < 4) scrollWidth = 0;
	
	        var buttonWidth = this.props.accordionWidth - 2 * _Properties2.default.EFFECTS_PADDING - 2 * cornerOffset - scrollWidth;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: buttonWidth,
	            height: _Properties2.default.EFFECTS_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: _Properties2.default.BROWSER_LEFT_PADDING / 2,
	            top: topPosition,
	            color: 'white',
	            margin: 0,
	            paddingRight: 0,
	            paddingTop: 0,
	            paddingBottom: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none',
	            textAlign: 'left'
	        };
	
	        var iconVisible;
	        var rightPosition = 12;
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            fontSize: 14,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            width: buttonWidth - rightPosition - 20,
	            top: 0
	        };
	
	        if (this.props.dataProviderLength < 4) rightPosition = rightPosition + 6;
	
	        if (this.props.index == this.props.selectedIndex) iconVisible = 'block';else iconVisible = 'none';
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 13,
	            right: rightPosition,
	            color: iconColor,
	            display: iconVisible
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': this.props.value, style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onClick, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.value
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-check' })
	        );
	    }
	});
	
	var AudioCategorySelectorNew = exports.AudioCategorySelectorNew = _react2.default.createClass({
	    displayName: 'AudioCategorySelectorNew',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onExpand: function onExpand(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var isExpanded = this.props.isExpanded;
	
	        if (isExpanded == undefined) isExpanded = false;
	
	        this.refs.mainButton.blur();
	        this.props.dispatch((0, _MenuActions.expandAudioList)(!isExpanded, this.props.type));
	    },
	    refreshView: function refreshView() {
	        setTimeout(this.refresh, 3);
	    },
	    refresh: function refresh() {
	        this.forceUpdate();
	    },
	    render: function render() {
	        var elements = [];
	        var i;
	        var dataProvider = this.props.dataProvider;
	
	        for (i = 0; i < dataProvider.length; i++) {
	            elements.push(_react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, isAdvancedMenu: this.props.isAdvancedMenu, index: i, dataProviderLength: dataProvider.length, selectedIndex: this.props.selectedIndex, type: this.props.type, dispatch: this.props.dispatch, key: 'audioCategory' + dataProvider[i] + '_' + Math.random(), value: dataProvider[i], refresh: this.refreshView }));
	        }
	
	        var height = _Properties2.default.CATEGORY_SELECTOR_HEIGHT;
	        var listHeight;
	
	        var visibleItems = 8;
	
	        switch (true) {
	            case window.innerHeight <= 440:
	                {
	                    visibleItems = 3;
	                    break;
	                }
	
	            case window.innerHeight <= 495:
	                {
	                    visibleItems = 4;
	                    break;
	                }
	
	            case window.innerHeight <= 595:
	                {
	                    visibleItems = 5;
	                    break;
	                }
	
	            case window.innerHeight <= 650:
	                {
	                    visibleItems = 6;
	                    break;
	                }
	        }
	
	        if (this.props.dataProvider.length < visibleItems) listHeight = this.props.dataProvider.length * _Properties2.default.EFFECTS_BUTTON_HEIGHT;else listHeight = visibleItems * _Properties2.default.EFFECTS_BUTTON_HEIGHT;
	
	        if (this.props.isExpanded == true) height = height + listHeight + 4;
	
	        var display = 'none';
	
	        if (this.props.visible == true) display = 'block';
	
	        var categoryStyle = {
	            position: 'absolute',
	            top: this.props.top,
	            width: this.props.accordionWidth,
	            height: height,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            display: display,
	            zIndex: 10000
	        };
	
	        var borderColor;
	        var textColor;
	
	        if (this.state.isOver == true) {
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            textColor = borderColor;
	        } else {
	            borderColor = 'black';
	            textColor = 'black';
	        }
	
	        var buttonWidth = this.props.accordionWidth - 2 * _Properties2.default.EFFECTS_PADDING;
	        var buttonHeight = height - 2 * _Properties2.default.CATEGORY_SELECTOR_GAP;
	        var paddingLeft = 18;
	
	        var categoryButtonStyle = {
	            width: buttonWidth,
	            height: buttonHeight,
	            background: 'white',
	            position: 'absolute',
	            left: _Properties2.default.EFFECTS_PADDING,
	            top: _Properties2.default.CATEGORY_SELECTOR_GAP,
	            alignItems: 'center',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none',
	            textAlign: 'left'
	        };
	
	        var lineStyle = {
	            width: buttonWidth - 2 * paddingLeft,
	            height: 2,
	            background: borderColor,
	            position: 'absolute',
	            left: paddingLeft,
	            top: _Properties2.default.CATEGORY_SELECTOR_HEIGHT - 2 * _Properties2.default.CATEGORY_SELECTOR_GAP - 5
	        };
	
	        var icon;
	
	        if (this.props.isExpanded == true) icon = 'fa fa-angle-down';else icon = 'fa fa-angle-right';
	
	        var categoryIconStyle = {
	            position: 'absolute',
	            top: 12,
	            right: 21,
	            color: textColor
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            color: textColor,
	            cursor: 'default',
	            fontSize: 16,
	            top: 11,
	            paddingLeft: paddingLeft,
	            width: buttonWidth - 55,
	            height: 20,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis'
	        };
	
	        var listDisplay;
	
	        if (this.props.isExpanded == true) {
	            listDisplay = 'block';
	        } else {
	            listDisplay = 'none';
	        }
	
	        var listWidth = this.props.accordionWidth - 2 * _Properties2.default.EFFECTS_PADDING - 2 * _Properties2.default.EFFECTS_CORNER_GAP + 2;
	        var categoryListStyle = {
	            position: 'absolute',
	            width: listWidth,
	            height: _Properties2.default.EFFECTS_BUTTON_HEIGHT * visibleItems,
	            top: _Properties2.default.CATEGORY_SELECTOR_HEIGHT - _Properties2.default.CATEGORY_SELECTOR_GAP + 2,
	            left: _Properties2.default.EFFECTS_PADDING + _Properties2.default.EFFECTS_CORNER_GAP,
	            borderColor: _Properties2.default.EFFECTS_BUTTON_BORDER_COLOR,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            display: listDisplay,
	            overflowY: 'auto',
	            overflowX: 'hidden'
	        };
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = listWidth;
	        componentProperties.height = _Properties2.default.EFFECTS_BUTTON_HEIGHT * visibleItems;
	        componentProperties.scrollHeight = height = _Properties2.default.EFFECTS_BUTTON_HEIGHT * elements.length;
	        componentProperties.top = 0;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = elements;
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'categorySelector', style: categoryStyle },
	            _react2.default.createElement(
	                'button',
	                { ref: 'mainButton', 'aria-label': this.props.dataProvider[this.props.selectedIndex], style: categoryButtonStyle, onTouchEnd: this.onExpand, onClick: this.onExpand, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	                _react2.default.createElement(
	                    'span',
	                    { style: spanStyle },
	                    this.props.dataProvider[this.props.selectedIndex]
	                ),
	                _react2.default.createElement('i', { style: categoryIconStyle, className: icon }),
	                _react2.default.createElement('div', { style: lineStyle })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: categoryListStyle },
	                _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AudioCategorySelectorNew.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AudioCategorySelectorNew.js"); } } })();

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CustomSlider = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomSlider = exports.CustomSlider = _react2.default.createClass({
	    displayName: 'CustomSlider',
	    getInitialState: function getInitialState() {
	        var step = (this.props.properties.end - this.props.properties.start) / this.props.properties.step;
	        var realStep = (this.props.properties.width - this.props.properties.thumbSize) / step;
	
	        return {
	            step: realStep,
	            isThumbOver: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isTouchableDevice()) {
	            this.refs.track.addEventListener('touchend', this.onTrackMouseDown);
	
	            if (_PlatformDetection2.default.isChromeBook()) this.refs.track.addEventListener('mousedown', this.onTrackMouseDown);
	        } else this.refs.track.addEventListener('mousedown', this.onTrackMouseDown);
	    },
	    updateThumbnail: function updateThumbnail() {
	        this.props.properties.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    getCurrentStep: function getCurrentStep(position) {
	        var floatValue = position / this.state.step;
	        var integerPart = parseInt(floatValue, 10);
	
	        var newPosition;
	
	        if (floatValue - integerPart > 0.5) newPosition = integerPart + 1;else newPosition = integerPart;
	
	        return newPosition;
	    },
	    getSliderPosition: function getSliderPosition(position) {
	        var newStep = this.getCurrentStep(position);
	        return newStep * this.state.step;
	    },
	    getSliderValue: function getSliderValue(position) {
	        var newStep = this.getCurrentStep(position);
	        return this.props.properties.start + newStep * this.props.properties.step;
	    },
	    onTrackMouseDown: function onTrackMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var newPosition = _MouseUtils2.default.getLocalPosition(e, this.refs.track, false) - this.props.properties.thumbSize / 2;
	
	        if (isNaN(newPosition)) return;
	
	        if (newPosition < 0) newPosition = 0;
	
	        if (newPosition > this.props.properties.width - this.props.properties.thumbSize) newPosition = this.props.properties.width - this.props.properties.thumbSize;
	
	        var sliderPosition = this.getSliderPosition(newPosition);
	
	        this.refs.thumb.style.left = sliderPosition + 'px';
	
	        this.changeProperties(this.getSliderValue(newPosition));
	        this.updateThumbnail();
	    },
	    onMouseDown: function onMouseDown() {
	        var leftString = this.refs.thumb.style.left;
	        var left = Number(leftString.substring(0, leftString.length - 2));
	
	        this.setState({
	            startPosition: left,
	            currentPosition: left
	        });
	    },
	    checkPosition: function checkPosition(deltaX) {
	        var newPosition = this.state.startPosition + deltaX;
	        var leftValue = 0;
	        var rightValue = this.props.properties.width - this.props.properties.thumbSize;
	
	        if (newPosition - leftValue < 0.001) newPosition = leftValue;else if (newPosition > rightValue) newPosition = rightValue;
	
	        var sliderPosition = this.getSliderPosition(newPosition);
	
	        if (sliderPosition != this.state.currentPosition) {
	            this.refs.thumb.style.left = sliderPosition + 'px';
	
	            this.setState({
	                currentPosition: sliderPosition
	            });
	
	            this.changeProperties(this.getSliderValue(this.state.currentPosition));
	        }
	    },
	    onThumbMouseIn: function onThumbMouseIn() {
	        this.setState({
	            isThumbOver: true
	        });
	    },
	    onThumbMouseOut: function onThumbMouseOut() {
	        this.setState({
	            isThumbOver: false
	        });
	    },
	    onKeyDown: function onKeyDown(e) {
	        var delta = this.state.step;
	
	        if (delta < 0) delta = -1 * delta;
	
	        if (e.keyCode == 37) {
	            // Left Key
	            this.onMouseDown();
	            setTimeout(function () {
	                this.onMouseMove(undefined, undefined, -delta);
	            }.bind(this), 10);
	        } else if (e.keyCode == 39) {
	            // Right Key
	            this.onMouseDown();
	            setTimeout(function () {
	                this.onMouseMove(undefined, undefined, delta);
	            }.bind(this), 10);
	        }
	    },
	    onMouseMove: function onMouseMove(e, coreEvent, movement) {
	        if (movement) this.checkPosition(movement);else this.checkPosition(coreEvent.lastX);
	    },
	    onMouseUp: function onMouseUp(e, coreEvent) {
	        this.checkPosition(coreEvent.lastX);
	
	        this.updateThumbnail();
	    },
	    getTarget: function getTarget() {
	        return this.props.properties.target;
	    },
	    changeProperties: function changeProperties(newValue) {
	        if (newValue == undefined) return;
	
	        var shapeModel = this.getTarget();
	
	        if (this.props.properties.type == 'change_opacity') {
	            this.props.properties.dispatch((0, _CurrentSlideActions.changeShapeOpacity)(shapeModel, newValue));
	        } else if (this.props.properties.type == 'change_stroke') {
	            if (this.props.properties.isTextEditorTool) this.props.executeCommand('changeStrokeSize', newValue);else this.props.properties.dispatch((0, _CurrentSlideActions.changeStrokeSize)(shapeModel, newValue));
	        } else if (this.props.properties.type == 'change_rotation') {
	            this.props.properties.dispatch((0, _CurrentSlideActions.updateShapeRotation)(shapeModel.uuid, newValue));
	        }
	
	        _AudioEditorUtils2.default.addActionToHistory();
	        _SaveManager2.default.isContentChanged(true);
	    },
	    getThumbInitialPosition: function getThumbInitialPosition() {
	        var target = this.getTarget();
	        var value;
	
	        if (target) {
	            if (this.props.properties.type == 'change_stroke') {
	                if (target.strokeWidth >= 0 && target.strokeOpacity == 1) {
	                    value = (target.strokeWidth - this.props.properties.start) / this.props.properties.step * this.state.step;
	                } else value = 0;
	            } else if (this.props.properties.type == 'change_opacity') {
	                if (target.opacity == 1) value = 0;else {
	                    if (target.opacity >= 0) value = (target.opacity - this.props.properties.start) / this.props.properties.step * this.state.step;else value = 0;
	                }
	            } else if (this.props.properties.type == 'change_rotation') {
	                if (target.rotation >= 0) value = (target.rotation - this.props.properties.start) / this.props.properties.step * this.state.step;else value = 0;
	            }
	        } else value = 0;
	
	        if (value < 0) value = 0;
	
	        return value;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isThumbOver != nextState.isThumbOver || this.state.currentPosition != nextState.currentPosition || this.props.properties != newProps.properties) return true;else return false;
	    },
	    render: function render() {
	        var localProps = this.props.properties;
	
	        var wrapperStyle = {
	            position: 'absolute',
	            left: localProps.leftPosition,
	            top: localProps.topPosition,
	            width: localProps.width,
	            height: localProps.height,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            cursor: 'default'
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            width: localProps.width,
	            height: localProps.height,
	            cursor: 'default'
	        };
	
	        var thumbBorderSize = 2;
	        var thumbBorderColor = 'green';
	
	        if (this.state.isThumbOver == true || this.state.isThumbActive == true) thumbBorderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	
	        var thumbStyle = {
	            position: 'absolute',
	            width: localProps.thumbSize - 2 * thumbBorderSize,
	            height: localProps.thumbSize - 2 * thumbBorderSize,
	            left: this.getThumbInitialPosition(),
	            top: localProps.height / 2 - localProps.thumbSize / 2,
	            background: 'white',
	            borderStyle: 'solid',
	            borderColor: thumbBorderColor,
	            borderWidth: 2,
	            borderRadius: 50,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            cursor: 'pointer'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: wrapperStyle },
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', ref: 'track', style: backgroundStyle, src: localProps.backgroundHref }),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	                _react2.default.createElement('button', { id: this.props.id, 'aria-label': _LocalesManager2.default.getCaption('Opacity', 'advancedMenu'), className: 'sliderThumb', ref: 'thumb', style: thumbStyle, onKeyDown: this.onKeyDown, onMouseOver: this.onThumbMouseIn, onMouseOut: this.onThumbMouseOut })
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/CustomSlider.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/CustomSlider.js"); } } })();

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _FullScreenManager = __webpack_require__(141);
	
	var _FullScreenManager2 = _interopRequireDefault(_FullScreenManager);
	
	var _DragManager = __webpack_require__(107);
	
	var _DragManager2 = _interopRequireDefault(_DragManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canvasScale = {
	    getScaleProperties: function getScaleProperties(windowWidth, windowHeight, accordionWidth) {
	        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ModeConstants2.default.EDITOR;
	
	        var verticalTopGap = _Properties2.default.CANVAS_VERTICAL_TOP_PADDING;
	        var verticalBottomGap = _Properties2.default.CANVAS_VERTICAL_BOTTOM_PADDING;
	        var horizontalGap = _Properties2.default.CANVAS_HORIZONTAL_PADDING;
	        var navigationBarHeight = 0;
	
	        var isVideoEditor = mode == _ModeConstants2.default.VIDEO_EDITOR;
	        var isAudioEditor = mode == _ModeConstants2.default.AUDIO_EDITOR;
	
	        if (isVideoEditor) {
	            mode = _ModeConstants2.default.PREVIEW;
	        }
	
	        if (_PlatformDetection2.default.isIOSApp()) navigationBarHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER || mode == _ModeConstants2.default.PREVIEW) {
	            verticalTopGap = 0;
	            verticalBottomGap = 0;
	
	            if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) navigationBarHeight = 0;
	        } else {
	            navigationBarHeight = navigationBarHeight + _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight();
	        }
	
	        if (_PlatformDetection2.default.isIOS() == true) verticalTopGap = 0;
	
	        var browserWidth = 0;
	        var slideViewHeight = 0;
	        var recordingMenuHeight = 0;
	        var mainMenuWidth = 0;
	        var mainResizeButtonWith = 0;
	
	        if (mode == undefined || mode == _ModeConstants2.default.EDITOR || mode == _ModeConstants2.default.AUDIO_EDITOR) {
	            browserWidth = accordionWidth;
	            slideViewHeight = _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT + _Properties2.default.SLIDE_VIEWER_TOP_GAP + _Properties2.default.SLIDE_VIEWER_LIST_HEIGHT + _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP;
	
	            if (mode == _ModeConstants2.default.EDITOR) mainResizeButtonWith = _Properties2.default.MAIN_RESIZE_BUTTON_WIDTH;
	
	            mainMenuWidth = _Properties2.default.MAIN_MENU_WIDTH + mainResizeButtonWith;
	
	            if (isAudioEditor) slideViewHeight = slideViewHeight + _AudioEditorUtils2.default.getAudioEditorHeight();
	
	            recordingMenuHeight = _Properties2.default.RECORDING_MENU_HEIGHT;
	        } else {
	            if (isVideoEditor) browserWidth = accordionWidth;
	
	            if (_FullScreenManager2.default.isFullScreenMode()) slideViewHeight = 0;else slideViewHeight = _Properties2.default.PREVIEW_HEIGHT;
	        }
	
	        var freeWidth = windowWidth - 2 * horizontalGap - browserWidth - mainMenuWidth;
	        var freeHeight = windowHeight - verticalBottomGap - verticalTopGap - slideViewHeight - recordingMenuHeight - navigationBarHeight;
	        var scaleX = freeWidth / _Configuration2.default.CANVAS_WIDTH;
	        var scaleY = freeHeight / _Configuration2.default.CANVAS_HEIGHT;
	        var scale = Math.min(scaleX, scaleY);
	
	        var left = (_Configuration2.default.CANVAS_WIDTH * scale - _Configuration2.default.CANVAS_WIDTH) / 2;
	        var top = (_Configuration2.default.CANVAS_HEIGHT * scale - _Configuration2.default.CANVAS_HEIGHT) / 2;
	
	        var canvasProperties = {};
	
	        canvasProperties.scale = scale;
	
	        if (scaleX == scale) {
	            canvasProperties.left = left;
	            canvasProperties.top = top + (freeHeight - _Configuration2.default.CANVAS_HEIGHT * scale) / 2 + navigationBarHeight;
	
	            canvasProperties.topX = horizontalGap;
	
	            if (_PlatformDetection2.default.isIOS() && _FullScreenManager2.default.isFullScreenMode()) canvasProperties.topY = (freeHeight - _Configuration2.default.CANVAS_HEIGHT * scale - _Properties2.default.PREVIEW_HEIGHT) / 2; // on IOS the control bar will be always visible
	            else canvasProperties.topY = (freeHeight - _Configuration2.default.CANVAS_HEIGHT * scale) / 2 + navigationBarHeight;
	        } else {
	            canvasProperties.left = left + (freeWidth - _Configuration2.default.CANVAS_WIDTH * scale) / 2;
	            canvasProperties.top = top + verticalTopGap + navigationBarHeight;
	
	            canvasProperties.topX = (freeWidth - _Configuration2.default.CANVAS_WIDTH * scale) / 2;
	            canvasProperties.topY = verticalTopGap + navigationBarHeight;
	        }
	
	        _DragManager2.default.scaleProperties = canvasProperties;
	
	        return canvasProperties;
	    },
	    getPrintScaleProperties: function getPrintScaleProperties(windowWidth, windowHeight) {
	        var freeWidth = windowWidth;
	        var freeHeight = windowHeight;
	        var scaleX = freeWidth / _Configuration2.default.CANVAS_WIDTH;
	        var scaleY = freeHeight / _Configuration2.default.CANVAS_HEIGHT;
	        var scale = Math.min(scaleX, scaleY);
	
	        var left = (_Configuration2.default.CANVAS_WIDTH * scale - _Configuration2.default.CANVAS_WIDTH) / 2;
	        var top = (_Configuration2.default.CANVAS_HEIGHT * scale - _Configuration2.default.CANVAS_HEIGHT) / 2;
	
	        var canvasProperties = {};
	
	        canvasProperties.scale = scale;
	
	        if (scaleX == scale) {
	            canvasProperties.left = left;
	            canvasProperties.top = top + (freeHeight - _Configuration2.default.CANVAS_HEIGHT * scale) / 2;
	
	            canvasProperties.topX = 0;
	            canvasProperties.topY = (freeHeight - _Configuration2.default.CANVAS_HEIGHT * scale) / 2;
	        } else {
	            canvasProperties.left = left + (freeWidth - _Configuration2.default.CANVAS_WIDTH * scale) / 2;
	            canvasProperties.top = top;
	
	            canvasProperties.topX = (freeWidth - _Configuration2.default.CANVAS_WIDTH * scale) / 2;
	            canvasProperties.topY = 0;
	        }
	
	        return canvasProperties;
	    }
	};
	
	exports.default = canvasScale;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/CanvasScaleUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/CanvasScaleUtils.js"); } } })();

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpUtils = {
	    initialTitleChecked: false,
	    titleAlertVisible: false,
	    closeTitleAlert: undefined,
	
	    showHelpInfo: true,
	    isAdded: false,
	
	    checkHelpInfo: function checkHelpInfo() {
	        if (this.showHelpInfo && !this.isAdded) {
	            setTimeout(this.addHelpInfo.bind(this), 100);
	        }
	    },
	    addHelpInfo: function addHelpInfo() {
	        this.isAdded = true;
	        var target = document.getElementById('helpButton');
	
	        if (target) _HoverManager2.default.showHelpInfo(target, 'helpButton');
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            window.addEventListener('touchstart', this.onMouseDown.bind(this));
	        } else {
	            window.addEventListener('mousedown', this.onMouseDown.bind(this));
	        }
	    },
	    onMouseDown: function onMouseDown() {
	        if (!this.showHelpInfo) return;
	
	        _HoverManager2.default.hide();
	        this.showHelpInfo = false;
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            window.removeEventListener('touchstart', this.onMouseDown);
	        } else {
	            window.removeEventListener('mousedown', this.onMouseDown);
	        }
	    }
	};
	
	exports.default = helpUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/HelpUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/HelpUtils.js"); } } })();

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactNativeWebviewMessaging = __webpack_require__(377);
	
	var _reactNativeWebviewMessaging2 = _interopRequireDefault(_reactNativeWebviewMessaging);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reactNativeBridge = {
	    initRecordingHandler: undefined,
	    endRecording: undefined,
	    isRecording: false,
	    currentData: '',
	
	    isNewApp: true,
	    isIOSRecorderEnabled: false, // to be removed from code
	    isAudioTool: true,
	    isInitialized: false,
	    timerVar: undefined,
	    checkTimer: undefined,
	
	    init: function init(initRecordingHandler) {
	        this.initRecordingHandler = initRecordingHandler;
	
	        setTimeout(this.initProperties.bind(this), 3000);
	
	        _reactNativeWebviewMessaging2.default.on('text', this.onCheckAppType.bind(this));
	        _reactNativeWebviewMessaging2.default.send('IsRecordingEnabled');
	    },
	    onCheckAppType: function onCheckAppType(e) {
	        if (e == 'IsRecordingEnabled' || e == 'IsRecordingDisabled') this.isNewApp = false;
	    },
	    initProperties: function initProperties() {
	        if (!this.isNewApp) {
	            this.checkProperties();
	        } else {
	            // it's stage ... the new app
	            if (this.initRecordingHandler) this.initRecordingHandler();
	
	            window.addEventListener('message', this.getMessageFromRN.bind(this));
	        }
	    },
	    sendMessageToRN: function sendMessageToRN(message) {
	        if (!this.isNewApp) _reactNativeWebviewMessaging2.default.send(message);else {
	            window.ReactNativeWebView.postMessage(message);
	        }
	    },
	    startRecording: function startRecording() {
	        this.isRecording = true;
	        this.sendMessageToRN('StartRecording');
	    },
	    stopRecording: function stopRecording(endRecording) {
	        this.endRecording = endRecording;
	        this.isRecording = false;
	        this.sendMessageToRN('StopRecording');
	    },
	    getMessageFromRN: function getMessageFromRN(e) {
	        var message = e.data;
	
	        if (message == 'StartRecordingAvailable') {
	            // start recording:
	            if (!this.isRecording && this.endRecording) this.endRecording(undefined);
	        } else if (message.length > 50) {
	            // stopped recording: received blob content encoded as base64 chunks
	            this.getBase64Chunks(message);
	        }
	    },
	    getBase64Chunks: function getBase64Chunks(data) {
	        if (data.indexOf('all:') != -1) {
	            this.currentData = data.slice(4);
	            this.onRecordedBlobReceivedFromRN(this.currentData);
	        } else if (data.indexOf('start:') != -1) {
	            this.currentData = data.slice(6);
	            this.sendMessageToRN('SendData');
	        } else if (data.indexOf('end:') != -1) {
	            this.currentData = this.currentData + data.slice(4);
	            this.onRecordedBlobReceivedFromRN(this.currentData);
	        } else {
	            // is middle:
	            this.currentData = this.currentData + data.slice(7);
	            this.sendMessageToRN('SendData');
	        }
	    },
	    onRecordedBlobReceivedFromRN: function onRecordedBlobReceivedFromRN(base64Content) {
	        var useFetch = true;
	
	        if (useFetch) this.base64DataToBlobWithFetch(base64Content);else {
	            var blob = this.base64DataToBlob(base64Content);
	
	            if (this.endRecording && blob) this.endRecording(blob);
	        }
	    },
	    base64DataToBlobWithFetch: function base64DataToBlobWithFetch(data) {
	        var _this = this;
	
	        _ApiService2.default.getBlobFromBase64Url(data).then(function (blob) {
	            if (_this.endRecording && blob) _this.endRecording(blob);
	        });
	    },
	    base64DataToBlob: function base64DataToBlob(data) {
	        var binaryData = this.convertDataURIToBinary(data);
	        var blob = new Blob([binaryData], { type: 'audio/wav' });
	
	        return blob;
	    },
	    convertDataURIToBinary: function convertDataURIToBinary(dataURI) {
	        var BASE64_MARKER = ';base64,';
	        var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
	        var base64 = dataURI.substring(base64Index);
	        var raw = window.atob(base64);
	        var rawLength = raw.length;
	        var array = new Uint8Array(new ArrayBuffer(rawLength));
	
	        for (var i = 0; i < rawLength; i++) {
	            array[i] = raw.charCodeAt(i);
	        }
	
	        return array;
	    },
	    addAlert: function addAlert(text) {
	        var element = document.getElementById('alertHolder');
	
	        if (element && element.parentNode) element.parentNode.removeChild(element);
	
	        var dateSpan = document.createElement('div');
	        dateSpan.id = 'alertHolder';
	        dateSpan.innerHTML = text;
	        dateSpan.style.position = 'absolute';
	        dateSpan.style.left = '0px';
	        dateSpan.style.top = '0px';
	        dateSpan.style.display = 'block';
	        dateSpan.style.background = '#ff0000';
	
	        document.body.appendChild(dateSpan);
	    },
	    checkProperties: function checkProperties() {
	        if (!this.isInitialized) {
	            _reactNativeWebviewMessaging2.default.on('text', this.onMessageReceivedFromRN.bind(this));
	            _reactNativeWebviewMessaging2.default.on('custom-event-from-rn', this.onDataMessageReceivedFromRN.bind(this));
	
	            if (this.isAudioTool) {
	                this.checkTimer = setTimeout(this.responseTimeExpired.bind(this), 6 * 1000);
	
	                setTimeout(function () {
	                    this.sendMessageToRN('IsRecordingEnabled');
	                }.bind(this), 2 * 1000);
	            } else this.sendMessageToRN('IsRecordingEnabled');
	        } else {
	            if (this.isIOSRecorderEnabled) {
	                if (this.initRecordingHandler) this.initRecordingHandler();
	            } else {
	                this.enableRecording();
	            }
	        }
	
	        this.isInitialized = true;
	    },
	    onMessageReceivedFromRN: function onMessageReceivedFromRN(e) {
	        var textData = e;
	
	        // this.addAlert(textData + ' length === ' + textData.length);
	
	        switch (textData) {
	            case 'RecordingAvailable':
	                {
	                    this.timerVar = setTimeout(this.initRecorder.bind(this), 5 * 1000);
	                    break;
	                }
	
	            case 'StartRecordingAvailable':
	                {
	                    if (!this.isRecording && this.endRecording) this.endRecording(undefined);
	                    break;
	                }
	
	            case 'IsRecordingEnabled':
	                {
	                    this.isIOSRecorderEnabled = true;
	
	                    if (this.checkTimer) clearTimeout(this.checkTimer);
	
	                    if (this.initRecordingHandler) this.initRecordingHandler();
	                    break;
	                }
	
	            case 'IsRecordingDisabled':
	                {
	                    if (this.checkTimer) clearTimeout(this.checkTimer);
	
	                    this.enableRecording();
	                    break;
	                }
	        }
	    },
	    onDataMessageReceivedFromRN: function onDataMessageReceivedFromRN(data) {
	        this.onRecordedBlobReceivedFromRN(data.content);
	    },
	    enableRecording: function enableRecording() {
	        this.sendMessageToRN('EnableRecording');
	    },
	    responseTimeExpired: function responseTimeExpired() {
	        this.enableRecording();
	    },
	    initRecorder: function initRecorder() {
	        if (this.timerVar) clearTimeout(this.timerVar);
	
	        if (this.initRecordingHandler) this.initRecordingHandler();
	    }
	};
	
	exports.default = reactNativeBridge;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ReactNativeBridge.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ReactNativeBridge.js"); } } })();

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var toolTipManager = {
	    toolTip: undefined,
	    localPosition: 0,
	    changeHoverState: undefined,
	
	    init: function init() {
	        var holder = document.getElementById('toolTipHolder');
	        this.toolTip = document.createElement('div');
	        holder.addEventListener('mouseover', this.onMouseOver.bind(this));
	        holder.addEventListener('mouseout', this.onMouseOut.bind(this));
	
	        this.toolTip.style.position = 'absolute';
	        this.toolTip.style.fontSize = 11 + 'px';
	        this.toolTip.style.background = 'white';
	        this.toolTip.style.height = 40 + 'px';
	        this.toolTip.style.wordWrap = 'break-word';
	        this.toolTip.style.textAlign = 'center';
	        this.toolTip.style.paddingTop = 2 + 'px';
	        this.toolTip.style.paddingLeft = 5 + 'px';
	        this.toolTip.style.paddingRight = 5 + 'px';
	        this.toolTip.style.borderLeftStyle = 'solid';
	        this.toolTip.style.borderBottomStyle = 'solid';
	        this.toolTip.style.borderRightStyle = 'solid';
	        this.toolTip.style.borderColor = '#c05600';
	        this.toolTip.style.borderWidth = '1px';
	        this.toolTip.style.cursor = '-webkit-grab';
	        this.toolTip.style.zIndex = 999999;
	
	        holder.appendChild(this.toolTip);
	    },
	    showToolTip: function showToolTip(text, target, type, changeHoverState) {
	        if (this.toolTip == undefined) this.init();
	
	        this.changeHoverState = changeHoverState;
	        var bounds = target.getBoundingClientRect();
	
	        this.toolTip.style.display = 'block';
	        this.toolTip.innerHTML = text;
	        this.toolTip.style.left = bounds.left - this.localPosition + 'px';
	        this.toolTip.style.width = bounds.width - 2 * 6 + 'px';
	        this.toolTip.style.pointerEvents = 'none';
	
	        if (type == 'ListItemRendererBackground') this.toolTip.style.top = bounds.top + 66 + 'px';else this.toolTip.style.top = bounds.top + 78 + 'px';
	    },
	    hideToolTip: function hideToolTip() {
	        if (this.toolTip) this.toolTip.style.display = 'none';
	    },
	    onMouseOver: function onMouseOver() {
	        if (this.changeHoverState) this.changeHoverState(true);
	
	        if (this.toolTip) this.toolTip.style.display = 'block';
	    },
	    onMouseOut: function onMouseOut() {
	        if (this.changeHoverState) this.changeHoverState(false);
	
	        this.hideToolTip();
	    },
	    resetToolTip: function resetToolTip() {
	        this.toolTip = undefined;
	    }
	};
	
	exports.default = toolTipManager;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ToolTipManager.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ToolTipManager.js"); } } })();

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var availableFonts = {
	    defaultFont: 'Cabin',
	
	    getAvailableFonts: function getAvailableFonts() {
	        return ['AlfaSlabOne', 'Anton', 'Arial', 'ArchitectsDaughter', 'Bangers', 'BungeeShade', 'Cabin', 'CabinMedium', 'CaveatBrush', 'Creepster', 'Pangolin', 'Peralta', 'PermanentMarker', 'Raleway', 'RalewayBlack', 'RalewayThin', 'Shrikhand', 'Sniglet', 'SnigletExtra', 'Sriracha'];
	    }
	};
	
	exports.default = availableFonts;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/constants/AvailableFonts.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/constants/AvailableFonts.js"); } } })();

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(177);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(898);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(94);
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 178 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(300);
	
	var _runTransitionHook = __webpack_require__(250);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(111);
	
	var _deprecate = __webpack_require__(249);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(48);
	var toAbsoluteIndex = __webpack_require__(104);
	var toLength = __webpack_require__(45);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(438);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(44);
	var createDesc = __webpack_require__(101);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(28);
	var document = __webpack_require__(24).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 184 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(34)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(24).document;
	module.exports = document && document.documentElement;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(28);
	var setPrototypeOf = __webpack_require__(195).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(113);
	var ITERATOR = __webpack_require__(34)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(98);
	var descriptor = __webpack_require__(101);
	var setToStringTag = __webpack_require__(114);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(59)(IteratorPrototype, __webpack_require__(34)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(97);
	var $export = __webpack_require__(4);
	var redefine = __webpack_require__(60);
	var hide = __webpack_require__(59);
	var has = __webpack_require__(58);
	var Iterators = __webpack_require__(113);
	var $iterCreate = __webpack_require__(189);
	var setToStringTag = __webpack_require__(114);
	var getPrototypeOf = __webpack_require__(64);
	var ITERATOR = __webpack_require__(34)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 191 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 192 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var macrotask = __webpack_require__(201).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(69)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(55);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(28);
	var anObject = __webpack_require__(22);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(70)(Function.call, __webpack_require__(63).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(157)('keys');
	var uid = __webpack_require__(105);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(77);
	var defined = __webpack_require__(75);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(151);
	var defined = __webpack_require__(75);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(77);
	var defined = __webpack_require__(75);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 200 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(70);
	var invoke = __webpack_require__(266);
	var html = __webpack_require__(186);
	var cel = __webpack_require__(183);
	var global = __webpack_require__(24);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(69)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(24);
	var DESCRIPTORS = __webpack_require__(43);
	var LIBRARY = __webpack_require__(97);
	var $typed = __webpack_require__(159);
	var hide = __webpack_require__(59);
	var redefineAll = __webpack_require__(102);
	var fails = __webpack_require__(26);
	var anInstance = __webpack_require__(95);
	var toInteger = __webpack_require__(77);
	var toLength = __webpack_require__(45);
	var toIndex = __webpack_require__(284);
	var gOPN = __webpack_require__(99).f;
	var dP = __webpack_require__(44).f;
	var arrayFill = __webpack_require__(180);
	var setToStringTag = __webpack_require__(114);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var core = __webpack_require__(74);
	var LIBRARY = __webpack_require__(97);
	var wksExt = __webpack_require__(285);
	var defineProperty = __webpack_require__(44).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(130);
	var ITERATOR = __webpack_require__(34)('iterator');
	var Iterators = __webpack_require__(113);
	module.exports = __webpack_require__(74).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(88);
	var step = __webpack_require__(269);
	var Iterators = __webpack_require__(113);
	var toIObject = __webpack_require__(65);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(190)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 207 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cart-background":"cartoonistIcons__cart-background___S7I6H-sourceMap","cart-camera":"cartoonistIcons__cart-camera___3gDfh-sourceMap","cart-character":"cartoonistIcons__cart-character___3GyNs-sourceMap","cart-effect":"cartoonistIcons__cart-effect___jTp0j-sourceMap","cart-folder":"cartoonistIcons__cart-folder___1L6EX-sourceMap","cart-football":"cartoonistIcons__cart-football___2uOa0-sourceMap","cart-frame":"cartoonistIcons__cart-frame___1PuDa-sourceMap","cart-image":"cartoonistIcons__cart-image___MmhWv-sourceMap","cart-music":"cartoonistIcons__cart-music___3ikGf-sourceMap","cart-paint-brush":"cartoonistIcons__cart-paint-brush___1HTOG-sourceMap","cart-save":"cartoonistIcons__cart-save___2TB-s-sourceMap","cart-search":"cartoonistIcons__cart-search___1Yxw3-sourceMap","cart-shapes":"cartoonistIcons__cart-shapes___1Pi4s-sourceMap","cart-text-in-speechbubble":"cartoonistIcons__cart-text-in-speechbubble___K6m5x-sourceMap","cart-themes":"cartoonistIcons__cart-themes___h-eI5-sourceMap","cart-video-camera":"cartoonistIcons__cart-video-camera___250Ya-sourceMap","cart-video-play":"cartoonistIcons__cart-video-play___26QY_-sourceMap","cart-eyedropper":"cartoonistIcons__cart-eyedropper___3q33l-sourceMap","cart-droplet":"cartoonistIcons__cart-droplet___Jf_5z-sourceMap","cart-mic":"cartoonistIcons__cart-mic___3WUSe-sourceMap","cart-folder1":"cartoonistIcons__cart-folder1___1QQ7U-sourceMap","cart-folder-open":"cartoonistIcons__cart-folder-open___1i4Z_-sourceMap","cart-folder-plus":"cartoonistIcons__cart-folder-plus___1MGnp-sourceMap","cart-folder-upload":"cartoonistIcons__cart-folder-upload___3k_uB-sourceMap","cart-bin":"cartoonistIcons__cart-bin___1a_L4-sourceMap","cart-download":"cartoonistIcons__cart-download___1S1Kz-sourceMap","cart-upload":"cartoonistIcons__cart-upload___sdyso-sourceMap"};

/***/ },
/* 208 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 209 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(669),
	    getPrototype = __webpack_require__(671),
	    isObjectLike = __webpack_require__(676);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(117);
	var Danger = __webpack_require__(686);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactInstrumentation = __webpack_require__(72);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(220);
	var setInnerHTML = __webpack_require__(166);
	var setTextContent = __webpack_require__(321);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 212 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactErrorUtils = __webpack_require__(218);
	
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(29);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 215 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactPropTypesSecret = __webpack_require__(715);
	var propTypesFactory = __webpack_require__(297);
	
	var React = __webpack_require__(128);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(29);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(19);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactCurrentOwner = __webpack_require__(86);
	var ReactInstanceMap = __webpack_require__(135);
	var ReactInstrumentation = __webpack_require__(72);
	var ReactUpdates = __webpack_require__(79);
	
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(29);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 220 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 221 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 222 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 223 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 225 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(49);
	
	var emptyFunction = __webpack_require__(66);
	var warning = __webpack_require__(29);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.addNewActionToHistory = addNewActionToHistory;
	exports.undo = undo;
	exports.redo = redo;
	var types = exports.types = {
	    ADD_NEW_ACTION_TO_HISTORY: 'add_new_action_to_history',
	    UNDO: 'undo',
	    REDO: 'redo'
	};
	
	function addNewActionToHistory() {
	    return { type: types.ADD_NEW_ACTION_TO_HISTORY };
	}
	
	function undo() {
	    return { type: types.UNDO };
	}
	
	function redo() {
	    return { type: types.REDO };
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/actions/UndoRedoActions.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/actions/UndoRedoActions.js"); } } })();

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _SessionActions = __webpack_require__(120);
	
	var _SessionActions2 = _interopRequireDefault(_SessionActions);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _AudioClipartModel = __webpack_require__(370);
	
	var _AudioClipartModel2 = _interopRequireDefault(_AudioClipartModel);
	
	var _ExportPlayerController = __webpack_require__(241);
	
	var _ExportPlayerController2 = _interopRequireDefault(_ExportPlayerController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var zipLoader = {
	    loadData: function loadData(type) {
	        var store = _StoreManager2.default.getStore();
	
	        if (_AppParameters2.default.isPrintMode() || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) {
	            store.dispatch(_SessionActions2.default.setCaptionsLoaded());
	
	            if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER) _ExportPlayerController2.default.loadData();
	
	            return;
	        }
	
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.DOWNLOAD) return;
	
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) return;
	
	        if (type == 'cartoonist') return this.loadClipartJSON();else return this.loadAudioClipartJSON();
	    },
	    loadAudioClipartJSON: function loadAudioClipartJSON() {
	        _AudioClipartModel2.default.addToStateAudioClipart();
	    },
	    loadClipartJSON: function loadClipartJSON() {
	        _MasterUniverseUtils2.default.loadTheme();
	    }
	};
	
	exports.default = zipLoader;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/clipartUtils/ZipLoader.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/clipartUtils/ZipLoader.js"); } } })();

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AppLoader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appLoader = __webpack_require__(649);
	
	var _appLoader2 = _interopRequireDefault(_appLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppLoader = exports.AppLoader = _react2.default.createClass({
	    displayName: 'AppLoader',
	    render: function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: _appLoader2.default.loader },
	            _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-3x fa-fw margin-bottom' }),
	            _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                'Loading...'
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/appLoader/AppLoader.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/appLoader/AppLoader.js"); } } })();

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Loader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoaderContent = _react2.default.createClass({
	    displayName: 'LoaderContent',
	    render: function render() {
	        var visible = 'none';
	
	        if (this.props.showPreloader == true) visible = 'block';else return _react2.default.createElement('div', null);
	
	        if (_Configuration2.default.LOAD_LOCAL == true) visible = 'none';
	
	        var topBarHeight = 0;
	
	        if (_PlatformDetection2.default.isIOSApp()) topBarHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	        topBarHeight = topBarHeight + _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight();
	
	        var wrapperStyle = {
	            position: 'absolute',
	            background: '#333333',
	            opacity: 0.7,
	            top: topBarHeight,
	            left: 0,
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            display: visible,
	            zIndex: 20000
	        };
	
	        var size = 48;
	
	        var loaderStyle = {
	            position: 'absolute',
	            top: this.props.windowHeight / 2 - size / 2,
	            left: this.props.windowWidth / 2 - size / 2,
	            color: 'white'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: wrapperStyle },
	            _react2.default.createElement('i', { style: loaderStyle, className: 'fa fa-spinner fa-pulse fa-3x' })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var showPreloader = state.menu.showPreloader;
	
	    return {
	        showPreloader: showPreloader
	    };
	}
	
	var Loader = exports.Loader = (0, _reactRedux.connect)(mapStateToProps)(LoaderContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/appLoader/Loader.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/appLoader/Loader.js"); } } })();

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _SlidesPreloaderNew = __webpack_require__(243);
	
	var _SlidesPreloaderNew2 = _interopRequireDefault(_SlidesPreloaderNew);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _uuid = __webpack_require__(68);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var audioConverter = {
	    addSoundDurationToMap: function addSoundDurationToMap(audioHref, duration) {
	        if (_PlayController2.default.isAudioEditorAvailable()) return;
	
	        var durationMap = _SlidesPreloaderNew2.default.audioDurationMap;
	
	        if (durationMap[audioHref] > 0) return;else {
	            durationMap[audioHref] = duration;
	        }
	    },
	    getSound: function getSound(slide) {
	        var isEffect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        var href;
	        var title;
	        var hrefBlob;
	
	        if (isEffect) {
	            href = slide.soundEffect;
	            title = slide.soundEffectTitle;
	        } else {
	            if (slide.soundWav && slide.soundWav.length > 0) hrefBlob = slide.soundWav;
	
	            href = slide.sound;
	            title = slide.soundTitle;
	        }
	
	        if (href != undefined && href.length > 0 || hrefBlob != undefined && hrefBlob.length > 0) return { href: href, title: title, hrefBlob: hrefBlob };else return undefined;
	    },
	    getAudioItem: function getAudioItem(slide, currentPosition) {
	        var isEffect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	        var sound = this.getSound(slide, isEffect);
	
	        if (sound == undefined) return undefined;
	
	        var durationMap = _SlidesPreloaderNew2.default.audioDurationMap;
	        var realDuration = -1;
	
	        if (durationMap && durationMap[sound.href] > 0) realDuration = durationMap[sound.href];
	
	        var slideDuration = slide.time;
	        var item = {};
	
	        item.title = sound.title;
	        item.href = sound.href;
	        item.uuid = _uuid2.default.v4();
	        item.left = currentPosition;
	        item.inPoint = 0;
	
	        if (sound.hrefBlob) item.hrefBlob = sound.hrefBlob;
	
	        _AudioEditorUtils2.default.ensureHasContentItem(item);
	
	        if (realDuration > 0) {
	            if (realDuration < slideDuration) item.duration = realDuration;else {
	                if (realDuration > slideDuration) item.outPoint = realDuration - slideDuration;
	
	                item.duration = slideDuration;
	            }
	        } else item.duration = slideDuration;
	
	        return item;
	    },
	    getStorySound: function getStorySound(totalDuration, storySound) {
	        if (storySound && storySound.href && storySound.href.length > 0) {
	            var item = {};
	            var durationMap = _SlidesPreloaderNew2.default.audioDurationMap;
	            var realDuration = -1;
	
	            if (durationMap && durationMap[storySound.href] > 0) realDuration = durationMap[storySound.href];
	
	            item.title = storySound.title;
	            item.href = storySound.href;
	            item.uuid = _uuid2.default.v4();
	            item.left = 0;
	            item.inPoint = 0;
	            _AudioEditorUtils2.default.ensureHasContentItem(item);
	
	            if (realDuration > 0) {
	                if (realDuration < totalDuration) item.duration = realDuration;else {
	                    if (realDuration > totalDuration) item.outPoint = realDuration - totalDuration;
	
	                    item.duration = totalDuration;
	                }
	            } else item.duration = totalDuration;
	
	            return item;
	        } else return undefined;
	    },
	    convert: function convert(slides, storySound) {
	        var i;
	        var audioEditor = {};
	        var timelines = [];
	        var recordingTimeline = { index: 0, volume: 1, audios: [] };
	        var effectsTimeline = { index: 1, volume: 1, audios: [] };
	        var currentPosition = 0;
	        var audioItem;
	        var item;
	
	        for (i = 0; i < slides.length; i++) {
	            var slide = slides[i];
	
	            // add recorded sound
	            audioItem = this.getAudioItem(slide, currentPosition, false);
	
	            if (audioItem) recordingTimeline.audios.push(audioItem);
	
	            // add effect sound
	            audioItem = this.getAudioItem(slide, currentPosition, true);
	
	            if (audioItem) effectsTimeline.audios.push(audioItem);
	
	            currentPosition = currentPosition + slide.time;
	        }
	
	        timelines.push(recordingTimeline);
	        timelines.push(effectsTimeline);
	
	        // add story sound
	        var storySoundItem = this.getStorySound(currentPosition, storySound);
	        item = { index: 2, volume: 1, audios: [] };
	
	        if (storySound) {
	            item.audios.push(storySoundItem);
	        }
	
	        timelines.push(item);
	
	        audioEditor.markerPosition = -1;
	        audioEditor.zoomValue = 4;
	        audioEditor.timelines = timelines;
	        audioEditor.isOldProduction = true;
	
	        return audioEditor;
	    }
	};
	
	exports.default = audioConverter;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/utils/AudioConverter.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/utils/AudioConverter.js"); } } })();

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InternetExplorerAlert = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InternetExplorerAlert = exports.InternetExplorerAlert = _react2.default.createClass({
	    displayName: 'InternetExplorerAlert',
	    render: function render() {
	        var width = this.props.windowWidth - 200;
	        var height = 200;
	
	        var menuStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            top: this.props.windowHeight / 2 - height / 2,
	            left: this.props.windowWidth / 2 - width / 2
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            fontSize: 20,
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            textAlign: 'center',
	            cursor: 'default',
	            top: 0
	        };
	
	        //var text = locales.getCaption('internetExplorerAlert', 'other');
	        // for Internet Explorer for some reason the captions can't be loaded properly using i18Service
	        var text = 'INTERNET EXPLORER is not supported! Please load Cartoonist using Chrome, Firefox, Opera, Microsoft Edge or Safari!';
	
	        switch (_AppParameters2.default.locale) {
	            case 'en_US':
	                {
	                    break;
	                }
	            case 'da_DK':
	                {
	                    text = ' INTERNET EXPLORER understøttes ikke. Brug venligst Cartoonist med Chrome, Firefox, Opera, Microsoft Edge eller Safari! ';
	                    break;
	                }
	            case 'de_DE':
	                {
	                    text = 'INTERNET EXPLORER wird nicht unterstützt. Für Cartoonist nutzen Sie bitte Chrome, Firefox, Opera, Microsoft Edge oder Safari! ';
	                    break;
	                }
	            case 'es_ES':
	                {
	                    break;
	                }
	            case 'fi_FI':
	                {
	                    break;
	                }
	            case 'fr_FR':
	                {
	                    break;
	                }
	            case 'nl_NL':
	                {
	                    break;
	                }
	            case 'nb_NO':
	                {
	                    text = 'INTERNET EXPLORER støttes ikke! Vennligst bruk Chrome, Firefox, Microsoft Edge, Safari eller Opera. ';
	                    break;
	                }
	            case 'sv_SE':
	                {
	                    text = ' Internet Explorer stöds inte! Använd Cartoonist med Chrome, Firefox, Opera, Microsoft Edge eller Safari! ';
	                    break;
	                }
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/InternetExplorerAlert.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/InternetExplorerAlert.js"); } } })();

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NoAccessAlert = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoAccessAlert = exports.NoAccessAlert = _react2.default.createClass({
	    displayName: 'NoAccessAlert',
	    render: function render() {
	        var width = this.props.windowWidth - 200;
	        var height = 200;
	
	        var menuStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            top: this.props.windowHeight / 2 - height / 2,
	            left: this.props.windowWidth / 2 - width / 2
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            fontSize: 20,
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            textAlign: 'center',
	            cursor: 'default',
	            top: 0
	        };
	
	        var text = _LocalesManager2.default.getCaption('noAccessAlert', 'other');
	
	        if (!text || text == '' || text == 'other.noAccessAlert') text = "Sorry! You don't have permissions for this product.";
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/NoAccessAlert.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/NoAccessAlert.js"); } } })();

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ColorPallete = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _ColorElement = __webpack_require__(834);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColorPallete = exports.ColorPallete = _react2.default.createClass({
	    displayName: 'ColorPallete',
	    showColorPicker: function showColorPicker() {
	        setTimeout(function () {
	            _TextEditorUtils2.default.addColorPickerBackground();
	
	            this.refs.htmlColorPicker.click();
	        }.bind(this), 10);
	    },
	    onColorPickerChangeColor: function onColorPickerChangeColor() {
	        var color = _TextEditorUtils2.default.getCorrectColor(this.refs.htmlColorPicker.value);
	
	        this.props.executeCommand(this.props.type, color);
	    },
	    render: function render() {
	        var elementWidth = this.props.gridSize;
	        var height = 2 * elementWidth + 2 * this.props.topGap;
	
	        var menuStyle = {
	            position: 'absolute',
	            top: this.props.top,
	            left: 0,
	            width: this.props.width,
	            height: height
	        };
	
	        var listElements = [];
	
	        for (var i = 0; i < 20; i++) {
	            listElements.push(_react2.default.createElement(_ColorElement.ColorElement, { index: i, width: elementWidth, top: this.props.topGap, showColorPicker: this.showColorPicker, type: this.props.type, currentColor: this.props.currentColor, executeCommand: this.props.executeCommand, contextTarget: this.props.contextTarget, key: 'colorElement' + i }));
	        }
	
	        var colorPickerHolderStyle = {
	            position: 'absolute',
	            top: 50,
	            right: 0,
	            zIndex: 2000,
	            display: 'block',
	            pointerEvents: 'none'
	        };
	
	        var labelStyle = {
	            opacity: 0
	        };
	
	        var inputStyle = {
	            opacity: 0
	        };
	
	        var lineElement = void 0;
	
	        if (this.props.type === 'changeFontColor') {
	            var lineStyle = {
	                position: 'absolute',
	                width: this.props.width,
	                height: 1,
	                top: 2 * elementWidth + 2 * this.props.topGap,
	                backgroundColor: '#c4c4c4'
	            };
	
	            lineElement = _react2.default.createElement('div', { style: lineStyle });
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            listElements,
	            _react2.default.createElement(
	                'div',
	                { style: colorPickerHolderStyle },
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'htmlColorPicker', style: labelStyle },
	                    _HoverManager2.default.getText('favoriteColor')
	                ),
	                _react2.default.createElement('input', { type: 'color', id: 'htmlColorPicker', ref: 'htmlColorPicker', style: inputStyle, value: this.props.currentColor, onChange: this.onColorPickerChangeColor })
	            ),
	            lineElement
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/ColorPallete.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/ColorPallete.js"); } } })();

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var bubbleUtils = {
	    calculateSeparationAngles: function calculateSeparationAngles(shapeModel) {
	        var center = { x: shapeModel.x + shapeModel.width / 2, y: shapeModel.y + shapeModel.height / 2 };
	
	        // variables for the location of the corners relative to the center.
	        var rightAngle = 0;
	        var bottomAngle = 90;
	        var leftAngle = 180;
	        var topAngle = -90;
	        var upperRightAngle = Math.atan2(shapeModel.y - center.y, shapeModel.x + shapeModel.width - center.x) * 180 / Math.PI;
	        var lowerRightAngle = Math.atan2(shapeModel.y + shapeModel.height - center.y, shapeModel.x + shapeModel.width - center.x) * 180 / Math.PI;
	        var lowerLeftAngle = Math.atan2(shapeModel.y + shapeModel.height - center.y, shapeModel.x - center.x) * 180 / Math.PI;
	        var upperLeftAngle = Math.atan2(shapeModel.y - center.y, shapeModel.x - center.x) * 180 / Math.PI;
	
	        return {
	            rightAngle: rightAngle,
	            bottomAngle: bottomAngle,
	            leftAngle: leftAngle,
	            topAngle: topAngle,
	            upperRightAngle: upperRightAngle,
	            lowerRightAngle: lowerRightAngle,
	            lowerLeftAngle: lowerLeftAngle,
	            upperLeftAngle: upperLeftAngle
	        };
	    },
	    getActiveSector: function getActiveSector(shapeModel, point) {
	        var x = shapeModel.x,
	            y = shapeModel.y,
	            width = shapeModel.width,
	            height = shapeModel.height;
	
	        var separationAngle = this.calculateSeparationAngles(shapeModel);
	        var center = { x: x + width / 2, y: y + height / 2 };
	        var angle = Math.atan2(point.y - center.y, point.x - center.x) * 180 / Math.PI;
	
	        switch (true) {
	            case angle >= separationAngle.rightAngle && angle < separationAngle.lowerRightAngle:
	                {
	                    return 1;
	                }
	            case angle >= separationAngle.lowerRightAngle && angle < separationAngle.bottomAngle:
	                {
	                    return 2;
	                }
	            case angle >= separationAngle.bottomAngle && angle < separationAngle.lowerLeftAngle:
	                {
	                    return 3;
	                }
	            case angle >= separationAngle.lowerLeftAngle && angle <= separationAngle.leftAngle:
	                {
	                    return 4;
	                }
	            case angle >= -separationAngle.leftAngle && angle < separationAngle.upperLeftAngle:
	                {
	                    return 5;
	                }
	            case angle >= separationAngle.upperLeftAngle && angle < separationAngle.topAngle:
	                {
	                    return 6;
	                }
	            case angle >= separationAngle.topAngle && angle < separationAngle.upperRightAngle:
	                {
	                    return 7;
	                }
	            case angle >= separationAngle.upperRightAngle && angle < separationAngle.rightAngle:
	                {
	                    return 8;
	                }
	        }
	
	        return 0;
	    },
	    getFreeSector: function getFreeSector(shapeModel) {
	        var activeSectors = [];
	        var sector;
	
	        if (shapeModel.cx) {
	            sector = this.getActiveSector(shapeModel, { x: shapeModel.cx, y: shapeModel.cy });
	
	            if (activeSectors.indexOf(sector) == -1) activeSectors.push(sector);
	        }
	
	        if (shapeModel.cx1) {
	            sector = this.getActiveSector(shapeModel, { x: shapeModel.cx1, y: shapeModel.cy1 });
	
	            if (activeSectors.indexOf(sector) == -1) activeSectors.push(sector);
	        }
	
	        if (shapeModel.cx2) {
	            sector = this.getActiveSector(shapeModel, { x: shapeModel.cx2, y: shapeModel.cy2 });
	
	            if (activeSectors.indexOf(sector) == -1) activeSectors.push(sector);
	        }
	
	        if (shapeModel.cx3) {
	            sector = this.getActiveSector(shapeModel, { x: shapeModel.cx3, y: shapeModel.cy3 });
	
	            if (activeSectors.indexOf(sector) == -1) activeSectors.push(sector);
	        }
	
	        if (shapeModel.cx4) {
	            sector = this.getActiveSector(shapeModel, { x: shapeModel.cx4, y: shapeModel.cy4 });
	
	            if (activeSectors.indexOf(sector) == -1) activeSectors.push(sector);
	        }
	
	        if (activeSectors.indexOf(3) == -1) return 3;
	
	        if (activeSectors.indexOf(2) == -1) return 2;
	
	        if (activeSectors.indexOf(7) == -1) return 7;
	
	        if (activeSectors.indexOf(6) == -1) return 6;
	
	        if (activeSectors.indexOf(8) == -1) return 8;
	
	        if (activeSectors.indexOf(5) == -1) return 5;
	    },
	    getNewControlPoint: function getNewControlPoint(shapeModel) {
	        var point = {};
	        var sector = this.getFreeSector(shapeModel);
	        var xValue = 1;
	        var yValue = 1;
	
	        switch (sector) {
	            case 3:
	                {
	                    xValue = 0;
	                    yValue = 1.6;
	                    break;
	                }
	            case 2:
	                {
	                    xValue = 1;
	                    yValue = 1.6;
	                    break;
	                }
	            case 7:
	                {
	                    xValue = 1;
	                    yValue = -1;
	                    break;
	                }
	            case 6:
	                {
	                    xValue = 0;
	                    yValue = -1;
	                    break;
	                }
	            case 8:
	                {
	                    xValue = 1.6;
	                    yValue = 0;
	                    break;
	                }
	            case 5:
	                {
	                    xValue = -0.6;
	                    yValue = 0;
	                    break;
	                }
	        }
	
	        point.x = shapeModel.x + xValue * shapeModel.width;
	        point.y = shapeModel.y + yValue * shapeModel.height;
	
	        return point;
	    }
	};
	
	exports.default = bubbleUtils;
	module.exports = exports["default"];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/utils/BubblesUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/utils/BubblesUtils.js"); } } })();

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _BubblesUtils = __webpack_require__(235);
	
	var _BubblesUtils2 = _interopRequireDefault(_BubblesUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var screamBubbleUtils = {
	    minCogWidth: 10,
	    maxCogWidth: 10,
	    minCogHeight: 5,
	    maxCogHeight: 10,
	    cornerCogOffset: 5,
	
	    getPath: function getPath(shapeModel) {
	        var points = this.getPoints(shapeModel);
	        var path = this.createPath(points, shapeModel);
	
	        return path;
	    },
	    createPath: function createPath(points, shapeModel) {
	        var data = 'M' + (points[0].x - shapeModel.x) + ',' + (points[0].y - shapeModel.y);
	        var length = points.length;
	        var i;
	        var point;
	
	        for (i = 1; i < length; i++) {
	            point = points[i];
	            point.x = point.x - shapeModel.x;
	            point.y = point.y - shapeModel.y;
	            data += 'L' + point.x + ',' + point.y;
	        }
	
	        return data;
	    },
	    getNextStep: function getNextStep(point, shapeModel, direction) {
	        var x = shapeModel.x,
	            y = shapeModel.y,
	            width = shapeModel.width,
	            height = shapeModel.height;
	
	        var minX = Math.min(x, x + width) + this.cornerCogOffset;
	        var maxX = Math.max(x, x + width) - this.cornerCogOffset;
	        var minY = Math.min(y, y + height) + this.cornerCogOffset;
	        var maxY = Math.max(y, y + height) - this.cornerCogOffset;
	        var nextStep = void 0;
	
	        switch (direction) {
	            case 'right':
	                {
	                    nextStep = this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth) + point.x;
	
	                    if (nextStep < maxX) {
	                        if (maxX - nextStep < this.cornerCogOffset) {
	                            nextStep = maxX;
	                        }
	
	                        return { x: nextStep, y: point.y };
	                    } else {
	                        return { x: maxX, y: minY };
	                    }
	                    break;
	                }
	            case 'down':
	                {
	                    nextStep = this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth) + point.y;
	
	                    if (nextStep < maxY) {
	                        if (maxY - nextStep < this.cornerCogOffset) {
	                            nextStep = maxY;
	                        }
	
	                        return { x: point.x, y: nextStep };
	                    } else {
	                        return { x: maxX, y: maxY };
	                    }
	
	                    break;
	                }
	            case 'left':
	                {
	                    nextStep = point.x - this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth);
	
	                    if (nextStep > minX) {
	                        if (nextStep - minX < this.cornerCogOffset) {
	                            nextStep = minX;
	                        }
	
	                        return { x: nextStep, y: point.y };
	                    } else {
	                        return { x: minX, y: maxY };
	                    }
	
	                    break;
	                }
	            case 'up':
	                {
	                    nextStep = point.y - this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth);
	
	                    if (nextStep > minY) {
	                        if (nextStep - minY < this.cornerCogOffset) {
	                            nextStep = minY;
	                        }
	
	                        return { x: point.x, y: nextStep };
	                    } else {
	                        return { x: minX, y: minY };
	                    }
	
	                    break;
	                }
	        }
	    },
	    getPoints: function getPoints(shapeModel) {
	        var x = Math.min(shapeModel.x, shapeModel.x + shapeModel.width);
	        var y = Math.min(shapeModel.y, shapeModel.y + shapeModel.height);
	        var width = Math.abs(shapeModel.width);
	        var height = Math.abs(shapeModel.height);
	
	        // Variables that hold the index of the cog that will become a control point.
	        var firstRight = -1;
	        var lastRight = -1;
	        var firstDown = -1;
	        var lastDown = -1;
	        var firstLeft = -1;
	        var lastLeft = -1;
	        var firstUp = -1;
	        var lastUp = -1;
	
	        var direction = 'right';
	        var currentPoint = { x: x + this.cornerCogOffset, y: y };
	        var points = [];
	
	        points.push(currentPoint);
	
	        do {
	            var nextPoint = this.getNextStep(currentPoint, shapeModel, direction);
	            var cogTip = void 0;
	
	            switch (direction) {
	                case 'right':
	                    {
	                        cogTip = { x: (currentPoint.x + nextPoint.x) / 2, y: currentPoint.y - this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight) };
	
	                        points.push(cogTip);
	
	                        if (firstRight == -1) {
	                            firstRight = points.length - 1;
	                        }
	
	                        lastRight = points.length - 1;
	
	                        points.push(nextPoint);
	
	                        if (nextPoint.x == x + width - this.cornerCogOffset) {
	                            direction = 'down';
	
	                            points.push({ x: x + width + this.maxCogHeight, y: y - this.maxCogHeight });
	                            points.push({ x: x + width, y: y + this.cornerCogOffset });
	
	                            nextPoint = { x: x + width, y: y + this.cornerCogOffset };
	
	                            firstDown = points.length;
	                        }
	                        break;
	                    }
	                case 'down':
	                    {
	                        cogTip = { x: currentPoint.x + this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight), y: (currentPoint.y + nextPoint.y) / 2 };
	
	                        points.push(cogTip);
	                        lastDown = points.length - 1;
	
	                        points.push(nextPoint);
	
	                        if (nextPoint.y == y + height - this.cornerCogOffset) {
	                            direction = 'left';
	
	                            points.push({ x: x + width + this.maxCogHeight, y: y + height + this.maxCogHeight });
	                            points.push({ x: x + width - this.cornerCogOffset, y: y + height });
	
	                            nextPoint = { x: x + width - this.cornerCogOffset, y: y + height };
	
	                            firstLeft = points.length;
	                        }
	                        break;
	                    }
	                case 'left':
	                    {
	                        cogTip = { x: (currentPoint.x + nextPoint.x) / 2, y: currentPoint.y + this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight) };
	
	                        points.push(cogTip);
	                        lastLeft = points.length - 1;
	
	                        points.push(nextPoint);
	
	                        if (nextPoint.x == x + this.cornerCogOffset) {
	                            direction = 'up';
	
	                            points.push({ x: x - this.maxCogHeight, y: y + height + this.maxCogHeight });
	                            points.push({ x: x, y: y + height - this.cornerCogOffset });
	
	                            nextPoint = { x: x, y: y + height - this.cornerCogOffset };
	
	                            firstUp = points.length;
	                        }
	                        break;
	                    }
	                case 'up':
	                    {
	                        cogTip = { x: currentPoint.x - this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight), y: (currentPoint.y + nextPoint.y) / 2 };
	
	                        points.push(cogTip);
	                        lastUp = points.length - 1;
	
	                        points.push(nextPoint);
	
	                        if (nextPoint.y == y + this.cornerCogOffset) {
	                            direction = 'right';
	
	                            points.push({ x: x - this.maxCogHeight, y: y - this.maxCogHeight });
	                            points.push({ x: x + this.cornerCogOffset, y: y });
	
	                            nextPoint = { x: x, y: y };
	                        }
	                        break;
	                    }
	            }
	
	            currentPoint = nextPoint;
	        } while (currentPoint.x != x || currentPoint.y != y);
	
	        // add Stem position
	
	        var currentSector = _BubblesUtils2.default.getActiveSector(shapeModel, { x: shapeModel.cx, y: shapeModel.cy });
	
	        var newIndex = -1;
	        var step = 2;
	
	        switch (currentSector) {
	            case 1:
	                {
	                    newIndex = lastDown - step;
	                    break;
	                }
	            case 2:
	                {
	                    newIndex = firstLeft + step;
	                    break;
	                }
	            case 3:
	                {
	                    newIndex = lastLeft - step;
	                    break;
	                }
	            case 4:
	                {
	                    newIndex = firstUp + step;
	                    break;
	                }
	            case 5:
	                {
	                    newIndex = lastUp - step;
	                    break;
	                }
	            case 6:
	                {
	                    newIndex = firstRight + step;
	                    break;
	                }
	            case 7:
	                {
	                    newIndex = lastRight - step;
	                    break;
	                }
	            case 8:
	                {
	                    newIndex = firstDown + step;
	                    break;
	                }
	        }
	
	        if (points[newIndex]) {
	            points[newIndex].x = shapeModel.cx;
	            points[newIndex].y = shapeModel.cy;
	        }
	
	        return points;
	    },
	    randomIntFromInverval: function randomIntFromInverval(min, max) {
	        return Math.floor(Math.random() * (max - min + 1) + min);
	    }
	};
	
	exports.default = screamBubbleUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/utils/ScreamBubbleUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/utils/ScreamBubbleUtils.js"); } } })();

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var thoughtBubbleUtils = {
	    minCogWidth: 10,
	    maxCogWidth: 20,
	    minCogHeight: 10,
	    maxCogHeight: 20,
	
	    getPath: function getPath(shapeModel) {
	        var points = this.getPoints(shapeModel);
	        var path = this.createPath(points, shapeModel);
	
	        return path;
	    },
	    createPath: function createPath(points, shapeModel) {
	        var data = 'M' + (points[0].x - shapeModel.x) + ',' + (points[0].y - shapeModel.y);
	        var length = points.length;
	        var i;
	        var point;
	
	        for (i = 1; i < length; i = i + 2) {
	            point = points[i];
	
	            point.x = point.x - shapeModel.x;
	            point.y = point.y - shapeModel.y;
	            data += 'Q' + point.x + ',' + point.y;
	
	            point = points[i + 1];
	
	            point.x = point.x - shapeModel.x;
	            point.y = point.y - shapeModel.y;
	            data += ',' + point.x + ',' + point.y;
	        }
	
	        return data;
	    },
	    randomIntFromInverval: function randomIntFromInverval(min, max) {
	        return Math.floor(Math.random() * (max - min + 1) + min);
	    },
	    getNextStep: function getNextStep(point, direction, shapeModel) {
	        var x = shapeModel.x,
	            y = shapeModel.y,
	            width = shapeModel.width,
	            height = shapeModel.height;
	
	        var minX = Math.min(x, x + width);
	        var maxX = Math.max(x, x + width);
	        var minY = Math.min(y, y + height);
	        var maxY = Math.max(y, y + height);
	        var nextStep = void 0;
	
	        switch (direction) {
	            case 'right':
	                {
	                    nextStep = this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth) + point.x;
	
	                    if (nextStep < maxX) {
	                        if (maxX - nextStep < this.minCogWidth / 2) nextStep = maxX;
	
	                        return { x: nextStep, y: point.y };
	                    } else {
	                        return { x: maxX, y: minY };
	                    }
	                    break;
	                }
	            case 'down':
	                {
	                    nextStep = this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth) + point.y;
	
	                    if (nextStep < maxY) {
	                        if (maxY - nextStep < this.minCogWidth / 2) nextStep = maxY;
	
	                        return { x: point.x, y: nextStep };
	                    } else {
	                        return { x: maxX, y: maxY };
	                    }
	                    break;
	                }
	            case 'left':
	                {
	                    nextStep = point.x - this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth);
	
	                    if (nextStep > minX) {
	                        if (nextStep - minX < this.minCogWidth / 2) nextStep = minX;
	
	                        return { x: nextStep, y: point.y };
	                    } else {
	                        return { x: minX, y: maxY };
	                    }
	                    break;
	                }
	            case 'up':
	                {
	                    nextStep = point.y - this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth);
	
	                    if (nextStep > minY) {
	                        if (nextStep - minY < this.minCogWidth / 2) nextStep = minY;
	
	                        return { x: point.x, y: nextStep };
	                    } else {
	                        return { x: minX, y: minY };
	                    }
	                    break;
	                }
	        }
	    },
	    getPoints: function getPoints(shapeModel) {
	        var x = shapeModel.x,
	            y = shapeModel.y,
	            width = shapeModel.width,
	            height = shapeModel.height;
	
	        var direction = 'right';
	        var points = [];
	        var currentPoint = { x: x, y: y };
	        points.push(currentPoint);
	
	        do {
	            var nextPoint = this.getNextStep(currentPoint, direction, shapeModel);
	            var cogTip = void 0;
	
	            switch (direction) {
	                case 'right':
	                    {
	                        cogTip = { x: (currentPoint.x + nextPoint.x) / 2, y: currentPoint.y - this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight) };
	                        points.push(cogTip);
	                        points.push({ x: nextPoint.x, y: nextPoint.y });
	
	                        if (nextPoint.x == x + width) direction = 'down';
	                        break;
	                    }
	                case 'down':
	                    {
	                        cogTip = { x: currentPoint.x + this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight), y: (currentPoint.y + nextPoint.y) / 2 };
	                        points.push(cogTip);
	                        points.push({ x: nextPoint.x, y: nextPoint.y });
	
	                        if (nextPoint.y == y + height) direction = 'left';
	                        break;
	                    }
	                case 'left':
	                    {
	                        cogTip = { x: (currentPoint.x + nextPoint.x) / 2, y: currentPoint.y + this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight) };
	                        points.push(cogTip);
	                        points.push({ x: nextPoint.x, y: nextPoint.y });
	
	                        if (nextPoint.x == x) direction = 'up';
	                        break;
	                    }
	                case 'up':
	                    {
	                        cogTip = { x: currentPoint.x - this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight), y: (currentPoint.y + nextPoint.y) / 2 };
	                        points.push(cogTip);
	                        points.push({ x: nextPoint.x, y: nextPoint.y });
	
	                        if (nextPoint.y == y) direction = 'right';
	                        break;
	                    }
	            }
	
	            currentPoint = nextPoint;
	        } while (currentPoint.x != x || currentPoint.y != y);
	
	        return points;
	    },
	    getStemPoints: function getStemPoints(shapeModel) {
	        var center = { x: shapeModel.x + shapeModel.width / 2, y: shapeModel.y + shapeModel.height / 2 };
	        var stemStartLocation = { x: (center.x + shapeModel.cx) / 2, y: (center.y + shapeModel.cy) / 2 };
	        var xStep = (shapeModel.cx - stemStartLocation.x) / 2;
	        var yStep = (shapeModel.cy - stemStartLocation.y) / 2;
	        var radius = Math.abs(Math.min(shapeModel.width, shapeModel.height)) * 15 / 100;
	        var stemPoints = [];
	        var stemRadius = [];
	
	        stemPoints.push({ x: stemStartLocation.x - shapeModel.x, y: stemStartLocation.y - shapeModel.y });
	        stemPoints.push({ x: stemStartLocation.x + xStep - shapeModel.x, y: stemStartLocation.y + yStep - shapeModel.y });
	        stemPoints.push({ x: shapeModel.cx - shapeModel.x, y: shapeModel.cy - shapeModel.y });
	
	        stemRadius.push(radius);
	        stemRadius.push(radius / 2);
	        stemRadius.push(radius / 3);
	
	        return { points: stemPoints, radius: stemRadius };
	    }
	};
	
	exports.default = thoughtBubbleUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/utils/ThoughtBubbleUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/utils/ThoughtBubbleUtils.js"); } } })();

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var animator = {
	    element: undefined,
	    timer: undefined,
	
	    //opacity fade-in-and-out animation
	    TIMES: 3,
	    opacity: 1,
	    sign: -1,
	    cycles: 0,
	
	    //color animation
	    TIMES_COLOR: 4,
	    initialBackground: undefined,
	    counter: 0,
	    items: undefined,
	
	    startAnimation: function startAnimation(id) {
	        if (_PlayController2.default.isAudioEditorAvailable()) return;
	
	        this.startColorAnimation(id);
	    },
	
	
	    //color animation
	    startColorAnimation: function startColorAnimation(id) {
	        if (this.timer) clearInterval(this.timer);
	
	        this.timer = setInterval(this.changeColor.bind(this), 300);
	        this.element = document.getElementById(id);
	
	        if (id == 'slideSoundEffect') this.items = document.getElementsByClassName('slideSoundEffectAnimation');else if (id == 'slideSound') this.items = document.getElementsByClassName('slideSoundAnimation');else this.items = document.getElementsByClassName('colorAnimation');
	
	        this.counter = 0;
	    },
	    changeColor: function changeColor() {
	        this.counter = this.counter + 1;
	
	        var value = this.counter % 2;
	        value = parseFloat(value.toFixed(2));
	
	        if (!this.element) return;
	
	        var i;
	        if (value != 0) {
	            this.element.style.background = 'black';
	
	            if (this.items && this.items.length > 0) {
	                for (i = 0; i < this.items.length; i++) {
	                    this.items[i].style.color = 'white';
	                }
	            }
	        } else {
	            this.element.style.background = 'white';
	
	            if (this.items && this.items.length > 0) {
	                for (i = 0; i < this.items.length; i++) {
	                    this.items[i].style.color = 'black';
	                }
	            }
	        }
	
	        if (this.counter >= this.TIMES_COLOR && this.timer) {
	            clearInterval(this.timer);
	
	            this.element.style.background = 'white';
	
	            if (this.items && this.items.length > 0) {
	                for (i = 0; i < this.items.length; i++) {
	                    this.items[i].style.color = 'black';
	                }
	            }
	        }
	    },
	
	
	    // opacity animation
	    startOpacityAnimation: function startOpacityAnimation(item) {
	        _AudioEditorUtils2.default.animationId = undefined;
	
	        if (this.timer) clearInterval(this.timer);
	
	        if (this.element) this.element.style.opacity = 1;
	
	        this.timer = setInterval(this.changeAlpha.bind(this), 20);
	        this.element = item;
	        this.opacity = 1;
	        this.cycles = 0;
	        this.sign = -1;
	    },
	    changeAlpha: function changeAlpha() {
	        var opacity = this.opacity + this.sign / 10;
	        opacity = parseFloat(opacity.toFixed(2));
	
	        if (opacity == 0) {
	            this.sign = 1;
	            this.cycles = this.cycles + 1;
	        } else if (opacity == 1) this.sign = -1;
	
	        this.element.style.opacity = opacity;
	        this.opacity = opacity;
	
	        if (this.cycles == this.TIMES && opacity == 1 && this.timer) {
	            clearInterval(this.timer);
	        }
	    }
	};
	
	exports.default = animator;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/Animator.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/Animator.js"); } } })();

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _WebmRecorder = __webpack_require__(857);
	
	var _WebmRecorder2 = _interopRequireDefault(_WebmRecorder);
	
	var _RecorderPolyfill = __webpack_require__(852);
	
	var _RecorderPolyfill2 = _interopRequireDefault(_RecorderPolyfill);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var audioRecorder = {
	    audioContext: undefined,
	    recorder: undefined,
	    isInitProcess: false,
	    isRecordAvailable: false,
	    initHandler: undefined,
	    useWebmEncoder: true, //window.location.href.indexOf('stage') != -1,
	    usePolyFill: _PlatformDetection2.default.isSafari() || _PlatformDetection2.default.isEdge() || _PlatformDetection2.default.isChromeBook() || _PlatformDetection2.default.isMac(),
	
	    init: function init(initHandler) {
	        this.initHandler = initHandler;
	        this.isInitProcess = true;
	
	        // try {
	        //     this.useWebmEncoder = (MediaRecorder.isTypeSupported('audio/webm'));
	        // } catch (e) {
	        // }
	
	        try {
	            window.AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext;
	            window.URL = window.URL || window.webkitURL;
	
	            this.audioContext = new AudioContext();
	
	            // Older browsers might not implement mediaDevices at all, so we set an empty object first
	            if (navigator.mediaDevices === undefined) {
	                navigator.mediaDevices = {};
	            }
	
	            // Some browsers partially implement mediaDevices. We can't just assign an object
	            // with getUserMedia as it would overwrite existing properties.
	            // Here, we will just add the getUserMedia property if it's missing.
	            if (navigator.mediaDevices.getUserMedia === undefined) {
	                navigator.mediaDevices.getUserMedia = function (constraints) {
	
	                    // First get ahold of the legacy getUserMedia, if present
	                    var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
	
	                    // Some browsers just don't implement it - return a rejected promise with an error
	                    // to keep a consistent interface
	                    if (!getUserMedia) {
	                        return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
	                    }
	
	                    // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
	                    return new Promise(function (resolve, reject) {
	                        getUserMedia.call(navigator, constraints, resolve, reject);
	                    });
	                };
	            }
	
	            navigator.mediaDevices.getUserMedia({ audio: true }).then(this.startUserMedia.bind(this)).catch(this.handlerErrorUserMedia.bind(this));
	        } catch (e) {
	            this.handlerErrorUserMedia(e);
	        }
	    },
	    handlerErrorUserMedia: function handlerErrorUserMedia(err) {
	        var text = '';
	
	        if (err.name == "NotFoundError" || err.name == "DevicesNotFoundError") {
	            text = 'Required track is missing!';
	        } else if (err.name == "NotReadableError" || err.name == "TrackStartError") {
	            text = 'Webcam or microphone are already in use!';
	        } else if (err.name == "OverconstrainedError" || err.name == "ConstraintNotSatisfiedError") {
	            text = 'Constraints can not be satisfied by avb. devices!';
	        } else if (err.name == "NotAllowedError" || err.name == "PermissionDeniedError") {
	            text = 'Permission denied in browser!';
	        } else if (err.name == "TypeError" || err.name == "TypeError") {
	            text = 'Empty constraints object!';
	        } else {
	            //other errors
	            text = err.name;
	        }
	
	        alert(text);
	    },
	    startUserMedia: function startUserMedia(stream) {
	        var input = this.audioContext.createMediaStreamSource(stream);
	
	        console.log('Media stream created.');
	
	        // Create an Analyser - we need this for microphone level
	        var analyser = this.audioContext.createAnalyser();
	        input.connect(analyser);
	
	        // if (MediaRecorder.isTypeSupported('audio/webm')) {
	        this.recorder = _WebmRecorder2.default;
	        this.recorder.init(this.audioContext, input, stream, analyser);
	        // } else {
	        //     if (this.usePolyFill) {
	        //         this.recorder = recorderPolyfill;
	        //         this.recorder.init(this.audioContext, input, stream, analyser);
	        //     } else {
	        //         this.recorder = new Recorder(this.audioContext, input, stream, analyser);
	        //     }
	        // }
	
	        this.isInitProcess = false;
	        this.isRecordAvailable = true;
	
	        if (this.initHandler) this.initHandler();
	
	        console.log('Recorder initialised.');
	    },
	    startRecording: function startRecording() {
	        if (!this.recorder) return;
	
	        this.recorder.record();
	        console.log('Recording...');
	    },
	    stopRecording: function stopRecording(endRecording) {
	        if (!this.recorder) return;
	
	        this.recorder.stop(endRecording);
	        console.log('Stopped recording.');
	    },
	    getMicrophoneLevel: function getMicrophoneLevel() {
	        if (!this.recorder) return 0;
	
	        return this.recorder.microphoneLevel();
	    },
	    cancel: function cancel() {
	        if (this.recorder) this.recorder.cancelStream();
	    }
	};
	
	exports.default = audioRecorder;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/AudioRecorder.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/AudioRecorder.js"); } } })();

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var colorUtils = {
	    hexToRgb: function hexToRgb(fill) {
	        fill = fill.replace('#', '');
	        var hex = parseInt(fill, 16);
	
	        var r = hex >> 16;
	        var g = hex >> 8 & 0xFF;
	        var b = hex & 0xFF;
	
	        return { r: r, g: g, b: b };
	    },
	    hexToMatrix: function hexToMatrix(hex) {
	        var rgb = this.hexToRgb(hex);
	        var matrix = '';
	
	        matrix = matrix + '0 0 0 0 ' + rgb.r / 255;
	        matrix = matrix + ' 0 0 0 0 ' + rgb.g / 255;
	        matrix = matrix + ' 0 0 0 0 ' + rgb.b / 255;
	        matrix = matrix + ' 1 1 1 1 0';
	
	        return matrix;
	    }
	};
	
	exports.default = colorUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ColorUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ColorUtils.js"); } } })();

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _ExporterUtils = __webpack_require__(93);
	
	var _ExporterUtils2 = _interopRequireDefault(_ExporterUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var exportPlayerController = {
	    time: [],
	    trackWidth: 0,
	    MARKER_STEP: 10, // miliseconds
	    markerTimer: undefined,
	    keyboardShortcutAction: undefined,
	    startTime: -1,
	    startDate: -1,
	
	    loadData: function loadData() {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var isAudioEditor = _PlayController2.default.isAudioEditorAvailable();
	
	        if (isAudioEditor) slides = _ExporterUtils2.default.checkSlides(slides);
	
	        for (var i = 0; i < slides.length; i++) {
	            this.time.push(slides[i].time);
	        }
	    },
	    getVideoCurrentTime: function getVideoCurrentTime() {
	        var video = document.getElementById('exportedVideo');
	
	        if (!video) return 0;
	
	        return video.currentTime;
	    },
	    getVideoTotalTime: function getVideoTotalTime() {
	        var video = document.getElementById('exportedVideo');
	
	        if (!video) return 0;
	
	        return video.duration;
	    },
	    isPlaying: function isPlaying() {
	        var video = document.getElementById('exportedVideo');
	
	        if (!video) return false;
	
	        if (video.paused) return false;else return true;
	    },
	    getTotalTime: function getTotalTime() {
	        var addMilliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        return _AudioToolUtils2.default.getCurrentTime(this.getVideoTotalTime(), addMilliseconds);
	    },
	    getCurrentTime: function getCurrentTime() {
	        var addMilliseconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        return _AudioToolUtils2.default.getCurrentTime(this.getVideoCurrentTime(), addMilliseconds);
	    },
	    getMarkerPosition: function getMarkerPosition() {
	        return this.trackWidth * this.getVideoCurrentTime() / this.getVideoTotalTime();
	    },
	    getMarkerTime: function getMarkerTime(markerPosition) {
	        return this.getVideoTotalTime() * markerPosition / this.trackWidth;
	    },
	    setVideoPosition: function setVideoPosition(position) {
	        var video = document.getElementById('exportedVideo');
	
	        if (!video) return 0;
	
	        video.currentTime = position;
	    },
	    getVolume: function getVolume() {
	        var state = _StoreManager2.default.getState();
	        var volume = state.audioEditor.volume;
	
	        if (volume == undefined) volume = 0.5;
	
	        return volume;
	    },
	    updateVolume: function updateVolume() {
	        var video = document.getElementById('exportedVideo');
	
	        if (video) video.volume = this.getVolume();
	    },
	    play: function play() {
	        var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        var video = document.getElementById('exportedVideo');
	
	        if (!video) return;
	
	        if (start) {
	            this.playMarker();
	            video.volume = this.getVolume();
	            video.play();
	        } else {
	            video.pause();
	            this.clearTimer();
	        }
	    },
	    playMarker: function playMarker() {
	        this.clearTimer();
	        this.startTime = this.getVideoCurrentTime();
	        this.startDate = new Date().getTime();
	
	        this.markerTimer = setInterval(this.checkMarkerPosition.bind(this), this.MARKER_STEP);
	    },
	    checkMarkerPosition: function checkMarkerPosition() {
	        var dispatch = this.getDispatch();
	        var offset = (new Date().getTime() - this.startDate) / 1000;
	        var newPos = this.startTime + offset;
	
	        if (this.startTime < 0) {
	            this.clearTimer();
	
	            return;
	        }
	
	        dispatch((0, _AudioEditorActions.setMarkerPosition)(newPos));
	    },
	    getDispatch: function getDispatch() {
	        var store = _StoreManager2.default.getStore();
	        return store.dispatch;
	    },
	    clearTimer: function clearTimer() {
	        if (this.markerTimer) clearInterval(this.markerTimer);
	
	        this.startTime = -1;
	    },
	    getCurrentSlideIndex: function getCurrentSlideIndex() {
	        if (this.time.length == 1) return 0;
	
	        var currentPosition = this.getVideoCurrentTime();
	        var position = 0;
	        var index = 0;
	
	        if (currentPosition < 0.1) return 0;
	
	        if (currentPosition >= this.getVideoTotalTime()) return this.time.length - 1;
	
	        for (var i = 0; i < this.time.length; i++) {
	            var nextPosition = position + this.time[i];
	
	            if (currentPosition > position && currentPosition <= nextPosition) {
	                index = i;
	                break;
	            }
	
	            position = nextPosition;
	        }
	
	        if (index < 0) index = 0;
	
	        if (index > this.time.length - 1) index = this.time.length - 1;
	
	        return index;
	    },
	    getPreviousSlideTime: function getPreviousSlideTime() {
	        var currentIndex = this.getCurrentSlideIndex();
	        var nextIndex = currentIndex - 1;
	
	        if (nextIndex <= 0) return 0;
	
	        var time = 0;
	
	        for (var i = 0; i < nextIndex; i++) {
	            time = time + this.time[i];
	        }
	
	        var offset = 0.3;
	        time = time + offset;
	
	        return time;
	    },
	    getNextSlideTime: function getNextSlideTime() {
	        var isEndAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var currentIndex = this.getCurrentSlideIndex();
	        var nextIndex = currentIndex + 1;
	
	        if (this.time.length < 2) return 0;
	
	        if (nextIndex >= this.time.length || isEndAction) nextIndex = this.time.length - 1;
	
	        var time = 0;
	
	        for (var i = 0; i < nextIndex; i++) {
	            time = time + this.time[i];
	        }
	
	        var offset = 0.3;
	        time = time + offset;
	
	        return time;
	    },
	    getSlidesText: function getSlidesText() {
	        var index = this.getCurrentSlideIndex() + 1;
	
	        if (index > this.time.length) index = this.time.length;
	
	        return index + ' / ' + this.time.length;
	    }
	};
	
	exports.default = exportPlayerController;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ExportPlayerController.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ExportPlayerController.js"); } } })();

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recordedSoundUploadingUtils = {
	    isUploadingCurrentSound: false,
	    currentContentItemId: -1,
	    currentTile: '',
	    refreshTimer: -1,
	
	    startStoring: function startStoring() {
	        this.isUploadingCurrentSound = true;
	        _SaveManager2.default.isContentChanged(true);
	    },
	    stopStoring: function stopStoring() {
	        this.isUploadingCurrentSound = false;
	
	        setTimeout(function () {
	            _SaveManager2.default.saveContent(true);
	        }.bind(this), 500);
	    },
	    isContentChanged: function isContentChanged() {
	        if (this.isUploadingCurrentSound) return true;
	
	        return _SaveManager2.default.contentChanged;
	    }
	};
	
	exports.default = recordedSoundUploadingUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/RecordedSoundUploadingUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/RecordedSoundUploadingUtils.js"); } } })();

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _SessionActions = __webpack_require__(120);
	
	var _SessionActions2 = _interopRequireDefault(_SessionActions);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ExporterUtils = __webpack_require__(93);
	
	var _ExporterUtils2 = _interopRequireDefault(_ExporterUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var slidesPreloaderNew = {
	    isPreloaded: false,
	    firstPreloadedSlides: _Configuration2.default.FIRST_PRELOADED_SLIDES,
	    slidesImages: [],
	    audios: [],
	    slidesVideos: [],
	    currentSlideIndex: 0,
	    slidesLength: 0,
	    isEditor: false,
	    videoElements: [],
	
	    videoFromSlideLoaded: false,
	    currentSlideAssetsLength: 0,
	    currentSlideAssetsCounter: 0,
	    currentSlideAudiosLength: 0,
	    currentSlideAudiosCounter: 0,
	    audioDurationMap: [],
	
	    preloadAssets: function preloadAssets() {
	        var isEditor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this.isEditor = isEditor;
	
	        if (this.isPreloaded) return;
	
	        _ExporterUtils2.default.init();
	        _VideoUtils2.default.updateVideoPreloader(true);
	
	        this.createAssetsList();
	        this.prepareAssets();
	        this.startPreloading();
	
	        this.isPreloaded = true;
	    },
	    createAssetsList: function createAssetsList() {
	        this.firstPreloadedSlides = _Configuration2.default.FIRST_PRELOADED_SLIDES;
	        this.slidesImages = [];
	        this.audios = [];
	        this.slidesVideos = [];
	        this.currentSlideIndex = 0;
	        this.slidesLength = 0;
	        this.videoElements = [];
	        this.videoFromSlideLoaded = false;
	        this.currentSlideAssetsLength = 0;
	        this.currentSlideAssetsCounter = 0;
	        this.currentSlideAudiosLength = 0;
	        this.currentSlideAudiosCounter = 0;
	        this.audioDurationMap = [];
	
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var i;
	        var j;
	        var shapes;
	        var shape;
	        var assets = [];
	        var slidesAssets;
	
	        this.slidesLength = slides.length;
	
	        for (i = 0; i < slides.length; i++) {
	            shapes = slides[i].content;
	            slidesAssets = [];
	
	            // add all images from each slide
	            for (j = 0; j < shapes.length; j++) {
	                shape = shapes[j];
	
	                if (shape.type == _ShapeConstants2.default.BACKGROUND && shape.isVideo) continue;
	
	                //TODO -- should be included the assets from inside of a group
	                if (shape.type == _ShapeConstants2.default.BACKGROUND || shape.type == _ShapeConstants2.default.CHARACTER || shape.type == _ShapeConstants2.default.IMAGE) {
	                    if (shape.xlinkHref && shape.xlinkHref.length > 0 && assets.indexOf(shape.xlinkHref) < 0) {
	                        assets.push(shape.xlinkHref);
	                        slidesAssets.push(shape.xlinkHref);
	                    }
	                }
	            }
	
	            this.slidesImages.push(slidesAssets);
	
	            // videos
	            this.slidesVideos.push(_VideoUtils2.default.getSlideVideoHref(i));
	        }
	
	        // prepare audios
	        if (!_PlayController2.default.isAudioEditorAvailable()) return;
	
	        var timelines = state.audioEditor.timelines;
	        var audios = [];
	        var audioAssets = [];
	        var audioHrefs = [];
	
	        for (i = 0; i < timelines.length; i++) {
	            audios = timelines[i].audios;
	
	            for (j = 0; j < audios.length; j++) {
	                if (audioHrefs.indexOf(audios[j].href) < 0) {
	                    audioAssets.push(audios[j]);
	                    audioHrefs.push(audios[j].href);
	                }
	            }
	        }
	
	        var currentTime = 0;
	        var newTime = 0;
	        audios = [];
	
	        for (i = 0; i < slides.length; i++) {
	            newTime = currentTime + slides[i].time;
	
	            var slideAudios = [];
	            for (j = 0; j < audioAssets.length; j++) {
	                if (audioAssets[j].left >= currentTime && audioAssets[j].left < newTime) slideAudios.push(audioAssets[j].href);
	            }
	
	            currentTime = newTime;
	            this.audios.push(slideAudios);
	        }
	    },
	    prepareAssets: function prepareAssets() {
	        var wrapper = document.createElement('div');
	        wrapper.id = 'preloaderWrapper';
	        wrapper.style.display = 'none';
	        document.body.appendChild(wrapper);
	
	        this.videoElements = [];
	
	        var videoWrapper = document.getElementById('multipleVideos');
	
	        if (videoWrapper) videoWrapper.innerHTML = '';
	
	        var i;
	        var oldVideo = document.getElementById('videoBackground');
	        var currentIndex = _StoreManager2.default.getState().currentSlide.currentSlideIndex;
	        var videoHolder = document.createElement('div');
	
	        videoWrapper.appendChild(videoHolder);
	
	        if (oldVideo) oldVideo.style.display = 'none';
	
	        for (i = 0; i < this.slidesVideos.length; i++) {
	            var videoHref = this.slidesVideos[i];
	            var videoElement;
	
	            if (videoHref != '') {
	                videoElement = document.createElement('VIDEO');
	                videoElement.id = 'video_' + i;
	                videoElement.style.position = 'absolute';
	                videoElement.style.top = '0px';
	                videoElement.style.left = '0px';
	                videoElement.style.width = '800px';
	                videoElement.style.height = '450px';
	                videoElement.className = 'audioItem';
	                videoElement.preload = 'auto';
	                videoElement.playsinline = true;
	                videoElement.ondurationchange = this.onVideoItemLoaded.bind(this);
	                videoElement.currentTime = _VideoUtils2.default.getStartPoint(i);
	
	                if (i != currentIndex) videoElement.style.display = 'none';
	
	                videoHolder.appendChild(videoElement);
	            }
	
	            this.videoElements.push(videoElement);
	        }
	    },
	    startPreloading: function startPreloading() {
	        this.loadAssetsFromSlide(this.currentSlideIndex);
	    },
	    loadAssetsFromSlide: function loadAssetsFromSlide() {
	        var index = this.currentSlideIndex;
	
	        if (index >= this.slidesLength) {
	            // finished loading all the slides
	            this.endPreloading();
	            return;
	        }
	
	        this.videoFromSlideLoaded = false;
	
	        // video from slide
	        var videoHref = this.slidesVideos[index];
	
	        if (videoHref != '') this.loadVideo(videoHref, index);else this.videoFromSlideLoaded = true;
	
	        // all the images from the current slide
	        var assetsFromSlide = this.slidesImages[index];
	        var i;
	        var url;
	
	        this.currentSlideAssetsLength = assetsFromSlide.length;
	        this.currentSlideAssetsCounter = 0;
	
	        for (i = 0; i < assetsFromSlide.length; i++) {
	            url = assetsFromSlide[i];
	            this.loadImage(url);
	        }
	
	        // all the audios from the current slide
	        var audiosFromSlide = this.audios[index];
	
	        this.currentSlideAudiosLength = audiosFromSlide.length;
	        this.currentSlideAudiosCounter = 0;
	
	        for (i = 0; i < audiosFromSlide.length; i++) {
	            url = audiosFromSlide[i];
	            this.loadAudio(url);
	        }
	
	        this.checkIfCurrentSlideIsLoaded();
	    },
	
	
	    //videos
	    loadVideo: function loadVideo(url, index) {
	        var video = this.videoElements[index];
	        video.src = _VideoUtils2.default.checkCacheBreaker(_VideoUtils2.default.getCorrectUrl(url));
	    },
	    onVideoItemLoaded: function onVideoItemLoaded() {
	        console.log('Preloaded video');
	
	        this.videoFromSlideLoaded = true;
	        this.checkIfCurrentSlideIsLoaded();
	    },
	
	
	    // images
	    loadImage: function loadImage(url) {
	        var imageObj = new Image();
	        var self = this;
	
	        imageObj.onload = function () {
	            self.currentSlideAssetsCounter = self.currentSlideAssetsCounter + 1;
	            self.checkIfCurrentSlideIsLoaded();
	        };
	
	        imageObj.onerror = function () {
	            self.currentSlideAssetsCounter = self.currentSlideAssetsCounter + 1;
	            self.checkIfCurrentSlideIsLoaded();
	        };
	
	        imageObj.src = _VideoUtils2.default.checkCacheBreaker(url);
	
	        var preloaderWrapper = document.getElementById('preloaderWrapper');
	        preloaderWrapper.appendChild(imageObj);
	    },
	
	
	    // audios
	    loadAudio: function loadAudio(url) {
	        var audio = new Audio();
	        var self = this;
	
	        audio.ondurationchange = function () {
	            self.currentSlideAudiosCounter = self.currentSlideAudiosCounter + 1;
	            self.checkIfCurrentSlideIsLoaded();
	
	            self.audioDurationMap[url] = audio.duration;
	        };
	
	        audio.onerror = function () {
	            self.currentSlideAudiosCounter = self.currentSlideAudiosCounter + 1;
	            self.checkIfCurrentSlideIsLoaded();
	        };
	
	        audio.src = _VideoUtils2.default.checkCacheBreaker(url);
	        audio.load();
	
	        var preloaderWrapper = document.getElementById('preloaderWrapper');
	        preloaderWrapper.appendChild(audio);
	    },
	    checkIfCurrentSlideIsLoaded: function checkIfCurrentSlideIsLoaded() {
	        if (this.videoFromSlideLoaded && this.currentSlideAssetsCounter >= this.currentSlideAssetsLength && this.currentSlideAudiosCounter >= this.currentSlideAudiosLength) {
	            // all the content from current slide is loaded
	            this.currentSlideIndex = this.currentSlideIndex + 1;
	
	            this.checkPreloader();
	            this.loadAssetsFromSlide();
	        }
	    },
	    checkPreloader: function checkPreloader() {
	        if (this.slidesLength >= this.firstPreloadedSlides && this.currentSlideIndex >= this.firstPreloadedSlides || this.slidesLength < this.firstPreloadedSlides && this.currentSlideIndex >= this.slidesLength) {
	            var store = _StoreManager2.default.getStore();
	
	            if (!this.isEditor) store.dispatch(_SessionActions2.default.setCaptionsLoaded());
	        }
	    },
	    endPreloading: function endPreloading() {
	        var elem = document.getElementById('preloaderWrapper');
	
	        if (elem && elem.parentElement) elem.parentElement.removeChild(elem);
	
	        _VideoUtils2.default.updateVideoPreloader(false);
	
	        _VideoUtils2.default.setInPoints();
	    },
	    exitPreview: function exitPreview() {
	        var multipleVideosWrapper = document.getElementById('multipleVideos');
	
	        if (multipleVideosWrapper) multipleVideosWrapper.innerHTML = '';
	
	        this.isPreloaded = false;
	
	        var oldVideo = document.getElementById('videoBackground');
	
	        if (oldVideo) oldVideo.style.display = 'block';
	    }
	};
	
	exports.default = slidesPreloaderNew;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SlidesPreloaderNew.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SlidesPreloaderNew.js"); } } })();

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    PRODUCTION: 'production',
	    DEBUG: 'debug',
	    UNIT_TESTING: 'unit-testing',
	    DEVELOPMENT: 'development'
	};
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/environmentNames.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/environmentNames.js"); } } })();

/***/ },
/* 245 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(177);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(110);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(896);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(893);
	
	var _isActive2 = __webpack_require__(901);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(897);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(903);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ },
/* 248 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 251 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(399);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(931);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(930);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(929);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(398);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(400);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(937).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(253).setImmediate, __webpack_require__(253).clearImmediate))

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = __webpack_require__(33);
	var getKeys = __webpack_require__(112).keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var util = __webpack_require__(33);
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = __webpack_require__(87);
	var OperationalError = errors.OperationalError;
	var es5 = __webpack_require__(112);
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(69);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(48);
	var toAbsoluteIndex = __webpack_require__(104);
	var toLength = __webpack_require__(45);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(96);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(55);
	var toObject = __webpack_require__(48);
	var IObject = __webpack_require__(131);
	var toLength = __webpack_require__(45);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(55);
	var isObject = __webpack_require__(28);
	var invoke = __webpack_require__(266);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(44).f;
	var create = __webpack_require__(98);
	var redefineAll = __webpack_require__(102);
	var ctx = __webpack_require__(70);
	var anInstance = __webpack_require__(95);
	var forOf = __webpack_require__(96);
	var $iterDefine = __webpack_require__(190);
	var step = __webpack_require__(269);
	var setSpecies = __webpack_require__(103);
	var DESCRIPTORS = __webpack_require__(43);
	var fastKey = __webpack_require__(89).fastKey;
	var validate = __webpack_require__(116);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(130);
	var from = __webpack_require__(258);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(102);
	var getWeak = __webpack_require__(89).getWeak;
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(28);
	var anInstance = __webpack_require__(95);
	var forOf = __webpack_require__(96);
	var createArrayMethod = __webpack_require__(73);
	var $has = __webpack_require__(58);
	var validate = __webpack_require__(116);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(150);
	var isObject = __webpack_require__(28);
	var toLength = __webpack_require__(45);
	var ctx = __webpack_require__(70);
	var IS_CONCAT_SPREADABLE = __webpack_require__(34)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(43) && !__webpack_require__(26)(function () {
	  return Object.defineProperty(__webpack_require__(183)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 266 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(28);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(22);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 269 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(192);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 271 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 272 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(100);
	var gOPS = __webpack_require__(154);
	var pIE = __webpack_require__(132);
	var toObject = __webpack_require__(48);
	var IObject = __webpack_require__(131);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(26)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(44);
	var anObject = __webpack_require__(22);
	var getKeys = __webpack_require__(100);
	
	module.exports = __webpack_require__(43) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(65);
	var gOPN = __webpack_require__(99).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(58);
	var toIObject = __webpack_require__(65);
	var arrayIndexOf = __webpack_require__(146)(false);
	var IE_PROTO = __webpack_require__(196)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(100);
	var toIObject = __webpack_require__(65);
	var isEnum = __webpack_require__(132).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(99);
	var gOPS = __webpack_require__(154);
	var anObject = __webpack_require__(22);
	var Reflect = __webpack_require__(24).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(24).parseFloat;
	var $trim = __webpack_require__(115).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(200) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(24).parseInt;
	var $trim = __webpack_require__(115).trim;
	var ws = __webpack_require__(200);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 281 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(28);
	var newPromiseCapability = __webpack_require__(194);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(45);
	var repeat = __webpack_require__(199);
	var defined = __webpack_require__(75);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(77);
	var toLength = __webpack_require__(45);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(34);


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(261);
	var validate = __webpack_require__(116);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(147)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(43) && /./g.flags != 'g') __webpack_require__(44).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(149)
	});


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(261);
	var validate = __webpack_require__(116);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(147)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(73)(0);
	var redefine = __webpack_require__(60);
	var meta = __webpack_require__(89);
	var assign = __webpack_require__(273);
	var weak = __webpack_require__(263);
	var isObject = __webpack_require__(28);
	var fails = __webpack_require__(26);
	var validate = __webpack_require__(116);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(147)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 290 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"app":"App__app___3P8ep","audioItemRenderer":"App__audioItemRenderer___3gfZM"};

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(66);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 292 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 293 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.s3 = exports.traditional = exports.thenable = undefined;
	
	var _objectAssign = __webpack_require__(209);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var thenable = exports.thenable = ['onCancel', 'onPasteReceived', 'onSubmit', 'onSubmitDelete', 'onUpload', 'onUploadChunk', 'onValidate', 'onValidateBatch'];
	
	var traditional = exports.traditional = ['onAutoRetry', 'onCancel', 'onComplete', 'onAllComplete', 'onDelete', 'onDeleteComplete', 'onError', 'onManualRetry', 'onPasteReceived', 'onProgress', 'onResume', 'onSessionRequestComplete', 'onStatusChange', 'onSubmit', 'onSubmitDelete', 'onSubmitted', 'onTotalProgress', 'onUpload', 'onUploadChunk', 'onUploadChunkSuccess', 'onValidate', 'onValidateBatch'];
	
	var s3 = exports.s3 = (0, _objectAssign2.default)([], traditional, ['onCredentialsExpired']);

/***/ },
/* 295 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(675);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(679);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(678)();
	}


/***/ },
/* 299 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(934);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(694);


/***/ },
/* 302 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(106);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(118);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactInstrumentation = __webpack_require__(72);
	
	var quoteAttributeValueForBrowser = __webpack_require__(742);
	var warning = __webpack_require__(29);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 305 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(49);
	
	var LinkedValueUtils = __webpack_require__(216);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(79);
	
	var warning = __webpack_require__(29);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 307 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 308 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(19);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(702);
	
	var containsNode = __webpack_require__(654);
	var focusNode = __webpack_require__(292);
	var getActiveElement = __webpack_require__(293);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var DOMLazyTree = __webpack_require__(117);
	var DOMProperty = __webpack_require__(118);
	var React = __webpack_require__(128);
	var ReactBrowserEventEmitter = __webpack_require__(162);
	var ReactCurrentOwner = __webpack_require__(86);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactDOMContainerInfo = __webpack_require__(696);
	var ReactDOMFeatureFlags = __webpack_require__(698);
	var ReactFeatureFlags = __webpack_require__(308);
	var ReactInstanceMap = __webpack_require__(135);
	var ReactInstrumentation = __webpack_require__(72);
	var ReactMarkupChecksum = __webpack_require__(712);
	var ReactReconciler = __webpack_require__(119);
	var ReactUpdateQueue = __webpack_require__(219);
	var ReactUpdates = __webpack_require__(79);
	
	var emptyObject = __webpack_require__(160);
	var instantiateReactComponent = __webpack_require__(319);
	var invariant = __webpack_require__(19);
	var setInnerHTML = __webpack_require__(166);
	var shouldUpdateReactComponent = __webpack_require__(225);
	var warning = __webpack_require__(29);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var React = __webpack_require__(128);
	
	var invariant = __webpack_require__(19);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 313 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 315 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(312);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(46);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(49);
	
	var ReactCompositeComponent = __webpack_require__(693);
	var ReactEmptyComponent = __webpack_require__(307);
	var ReactHostComponent = __webpack_require__(309);
	
	var getNextDebugID = __webpack_require__(920);
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(29);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 320 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	var escapeTextContentForBrowser = __webpack_require__(165);
	var setInnerHTML = __webpack_require__(166);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactCurrentOwner = __webpack_require__(86);
	var REACT_ELEMENT_TYPE = __webpack_require__(708);
	
	var getIteratorFn = __webpack_require__(739);
	var invariant = __webpack_require__(19);
	var KeyEscapeUtils = __webpack_require__(215);
	var warning = __webpack_require__(29);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ZipLoader = __webpack_require__(228);
	
	var _ZipLoader2 = _interopRequireDefault(_ZipLoader);
	
	var _SessionActions = __webpack_require__(120);
	
	var _SessionActions2 = _interopRequireDefault(_SessionActions);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _newProduction = __webpack_require__(745);
	
	var _newProduction2 = _interopRequireDefault(_newProduction);
	
	var _audioProduction = __webpack_require__(744);
	
	var _audioProduction2 = _interopRequireDefault(_audioProduction);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _SessionUtils = __webpack_require__(373);
	
	var _SessionUtils2 = _interopRequireDefault(_SessionUtils);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _AudioVolumeUtils = __webpack_require__(67);
	
	var _AudioVolumeUtils2 = _interopRequireDefault(_AudioVolumeUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dataLoader = {
	    loadData: function loadData() {
	        if (_AudioToolUtils2.default.isAudioPlayer()) _AudioVolumeUtils2.default.addEventListener();
	
	        this.getParametersAndLoadCaptions();
	
	        // if (appParameters.currentUserId === 54719315 && appParameters.isMaster) { // PROD aleks2 user ... when open a master Cartoonist then the hardcoded production will be loaded
	        //     this.loadInitialMockData(true);
	        //     return;
	        // }
	
	        if (_Configuration2.default.LOAD_LOCAL) {
	            this.loadInitialMockData();
	        } else {
	            this.loadInitialData();
	        }
	    },
	    getParametersAndLoadCaptions: function getParametersAndLoadCaptions() {
	        _LocalesManager2.default.init();
	
	        if (!_SessionUtils2.default.parametersLoaded) _AppParameters2.default.getParameters();
	
	        if (_AppParameters2.default.isPrintMode() || _SessionUtils2.default.isLoginWithToken()) return;
	
	        if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) {
	            return;
	        }
	
	        this.setMode();
	    },
	    setMode: function setMode() {
	        var store = _StoreManager2.default.getStore();
	
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            if (_AppParameters2.default.getMode() == _ModeConstants2.default.AUDIO_TOOL) {
	                _ApiServiceUtils2.default.initLostSessionTimer(); // available only for EDITOR tools
	            }
	
	            return;
	        }
	
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.EDITOR) {
	            store.dispatch((0, _ProductionActions.changeMode)(_ModeConstants2.default.EDITOR));
	            store.dispatch((0, _MenuActions.showMenu)(_MenuType2.default.UNIVERSES_MENU));
	
	            _ApiServiceUtils2.default.initLostSessionTimer();
	        } else store.dispatch((0, _ProductionActions.changeMode)(_ModeConstants2.default.PLAYER));
	    },
	    loadInitialMockData: function loadInitialMockData() {
	        var forceBlankProduction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var store = _StoreManager2.default.getStore();
	        var xmlData;
	
	        if (forceBlankProduction || _Configuration2.default.LOAD_BLANK_PRODUCTION == false) {
	            if (_AudioToolUtils2.default.isAudioTool()) xmlData = _audioProduction2.default.data; // should create a separate xml for testing audio tool
	            else xmlData = _newProduction2.default.data;
	
	            xmlData = this.removeWrongNumbers(xmlData);
	        }
	
	        this.executeLoadingActions(xmlData).then(function () {
	            store.dispatch(_SessionActions2.default.setAppReady());
	        });
	    },
	    loadInitialData: function loadInitialData() {
	        var store = _StoreManager2.default.getStore();
	
	        if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) {
	            _ApiServiceUtils2.default.executeSafeApiCall(this.loadContent.bind(this));
	            return;
	        }
	
	        if (_AppParameters2.default.context == _ModeConstants2.default.DOWNLOAD) {
	            store.dispatch(_SessionActions2.default.setAppReady());
	            return;
	        }
	
	        if (_SessionUtils2.default.isLoginWithToken()) return;
	
	        if (_AppParameters2.default.isPrintMode() == true) {
	            this.loadContent();
	            return;
	        }
	
	        if (_ApiServiceUtils2.default.isWrong() == true) return;
	
	        _AudioUtils2.default.getVisitedAlerts();
	
	        var contentItemId = _AppParameters2.default.getContentItemId();
	
	        if (contentItemId == -1) {
	            // create a new production from Exercises
	            this.executeLoadingActions(undefined).then(function () {
	                store.dispatch(_SessionActions2.default.setAppReady());
	            });
	        } else {
	            // open a saved production or PLAYER
	            _ApiServiceUtils2.default.executeSafeApiCall(this.loadContent.bind(this));
	        }
	    },
	    loadContent: function loadContent() {
	        var _this = this;
	
	        if (_AppParameters2.default.isExternVideo) {
	            var store = _StoreManager2.default.getStore();
	            store.dispatch(_SessionActions2.default.setAppReady());
	
	            return;
	        }
	
	        _ApiService2.default.hasAccess(_AppParameters2.default.contentItemId, _AppParameters2.default.contentRevisionId) // check if the user has access
	        .then(function (response) {
	            if (response.access == true) {
	                _this.loadContentCall();
	            } else {
	                // No access alert
	                _ApiServiceUtils2.default.showNoAccessAlert();
	                return;
	            }
	        });
	    },
	    loadContentCall: function loadContentCall() {
	        var _this2 = this;
	
	        var store = _StoreManager2.default.getStore();
	
	        var submitId = _AppParameters2.default.submitId;
	
	        if (_AppParameters2.default.context != 'edit' && _AppParameters2.default.context != _ModeConstants2.default.AUDIO_TOOL) submitId = -1;
	
	        _ApiService2.default.loadCartoonistContent(_AppParameters2.default.contentRevisionId, _AppParameters2.default.contentItemId, submitId).then(function (content) {
	            if (content.data == '') {
	                // create a new production from Exercises
	                _this2.executeLoadingActions(undefined).then(function () {
	                    store.dispatch(_SessionActions2.default.setAppReady());
	                });
	
	                return;
	            } else return _this2.executeLoadingActions(content.data);
	        }).then(function () {
	            store.dispatch(_SessionActions2.default.setAppReady());
	        });
	    },
	    removeBlankSlides: function removeBlankSlides(content) {
	        if (content && content.indexOf(',{}') != -1) return content.replace(',{}', '');else if (content && content.indexOf('{},') != -1) return content.replace('{},', '');else return content;
	    },
	    removeWrongNumbers: function removeWrongNumbers(content) {
	        for (var i = 0; i < 5; i++) {
	            if (content && content.indexOf('e+45') != -1) content = content.replace('e+45', '');
	
	            if (content && content.indexOf('e-45') != -1) content = content.replace('e-45', '');
	        }
	
	        return content;
	    },
	    replaceOldSvgPath: function replaceOldSvgPath(content) {
	        if (!content) return content;
	
	        return content.replaceAll('s3-eu-west-1.amazonaws.com/creaza-cartoonist-svg', 'creaza-cartoonist-svg.s3.eu-west-1.amazonaws.com');
	    },
	    executeLoadingActions: function executeLoadingActions(content) {
	        if (content != undefined) content = unescape(content);
	
	        content = this.removeBlankSlides(content);
	        content = this.removeWrongNumbers(content);
	        content = this.replaceOldSvgPath(content);
	
	        _AppParameters2.default.checkType(content);
	
	        var store = _StoreManager2.default.getStore();
	        var currentSlide = 0;
	
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            return Promise.all([store.dispatch((0, _ProductionActions.loadAudioProduction)(content)), store.dispatch((0, _CurrentSlideActions.setCurrentSlide)(currentSlide)), _PlayController2.default.prepareAudioTool()]).then(function () {
	                if (_AudioToolUtils2.default.isAudioPlayer()) {
	                    return;
	                } else return _ZipLoader2.default.loadAudioClipartJSON();
	            });
	        } else {
	            if (_AppParameters2.default.isNewCartoonist == true) {
	                if (_AppParameters2.default.context != _ModeConstants2.default.EXPORT_PLAYER && _AppParameters2.default.context != _ModeConstants2.default.EXPORT_AUDIO_PLAYER) _PlayController2.default.updateAudioElements();
	
	                return Promise.all([store.dispatch((0, _ProductionActions.loadNewProduction)(content)), store.dispatch((0, _CurrentSlideActions.setCurrentSlide)(currentSlide))]).then(function () {
	                    return _ZipLoader2.default.loadData('cartoonist');
	                });
	            } else {
	                return Promise.all([store.dispatch((0, _ProductionActions.contentXMLLoaded)(content)), store.dispatch((0, _ProductionActions.loadOldProduction)()), store.dispatch((0, _CurrentSlideActions.setCurrentSlide)(currentSlide))]).then(function () {
	                    return _ZipLoader2.default.loadData('cartoonist');
	                });
	            }
	        }
	    }
	};
	
	exports.default = dataLoader;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/DataLoader.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/DataLoader.js"); } } })();

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MoodsUtils = __webpack_require__(124);
	
	var _MoodsUtils2 = _interopRequireDefault(_MoodsUtils);
	
	var _ZipLoader = __webpack_require__(228);
	
	var _ZipLoader2 = _interopRequireDefault(_ZipLoader);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _AccordionActions = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var videoClipartParserJSON = {
	    parseClipartModel: function parseClipartModel(arrayData) {
	        var categories = ['Video clips'];
	        var i;
	        var j;
	        var clipartModel = {};
	        var item;
	
	        clipartModel.captionKey = arrayData[0].theme;
	        _AppParameters2.default.currentVideoTheme = clipartModel.captionKey;
	
	        clipartModel.items = [];
	
	        for (i = 0; i < categories.length; i++) {
	            item = {};
	            item.title = categories[i];
	            item.items = [];
	
	            for (j = 0; j < arrayData.length; j++) {
	                var resourceObject = arrayData[j];
	
	                var resource = {};
	                resource.theme = resourceObject.theme;
	                resource.title = this.getTitle(resourceObject);
	                resource.href = 'https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/' + this.getCorrectTheme(resourceObject.theme) + '/' + resourceObject.logicalname + '.mp4';
	                resource.thumbnailUrl = 'https://d3b76ijxom7qfl.cloudfront.net/staticthumbs/video/' + resourceObject.logicalname + '.jpg';
	
	                item.items.push(resource);
	            }
	
	            clipartModel.items.push(item);
	        }
	
	        this.addClipartModelHandler(clipartModel);
	    },
	    getCorrectTheme: function getCorrectTheme(theme) {
	        if (theme.indexOf('italy') != -1 || theme.indexOf('morocco') != -1 || theme.indexOf('norway') != -1) return 'places';else return theme;
	    },
	    getTitle: function getTitle(item) {
	        if (!item.translations) return item.logicalname;else {
	            var translation = item.translations[_MasterUniverseUtils2.default.language()];
	
	            if (translation && translation.length > 0) return translation;else if (item.translations['en_US']) return item.translations['en_US'];else return item.logicalname;
	        }
	    },
	    addClipartModelHandler: function addClipartModelHandler(clipartModel) {
	        _MoodsUtils2.default.clipartModel = clipartModel;
	
	        var state = _StoreManager2.default.getState();
	
	        if (state.music.soundClipartModel == undefined) _ZipLoader2.default.loadData('audio');
	
	        this.updateClipartModelToState();
	    },
	    updateClipartModelToState: function updateClipartModelToState() {
	        var store = _StoreManager2.default.getStore();
	        store.dispatch((0, _AccordionActions.addClipartModel)(_MoodsUtils2.default.clipartModel));
	    },
	    parseSearchItems: function parseSearchItems(items) {
	        if (!items) return [];
	
	        var i;
	        var newItems = [];
	
	        for (i = 0; i < items.length; i++) {
	            var resourceObject = items[i];
	            var resource = {};
	
	            resource.theme = resourceObject.theme;
	            resource.title = this.getTitle(resourceObject);
	            resource.href = 'https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/' + this.getCorrectTheme(resourceObject.theme) + '/' + resourceObject.logicalname + '.mp4';
	            resource.thumbnailUrl = 'https://d3b76ijxom7qfl.cloudfront.net/staticthumbs/video/' + resourceObject.logicalname + '.jpg';
	
	            newItems.push(resource);
	        }
	
	        return newItems;
	    }
	};
	
	exports.default = videoClipartParserJSON;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/clipartUtils/VideoClipartParserJSON.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/clipartUtils/VideoClipartParserJSON.js"); } } })();

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioEditorControls = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _AudioElementVolume = __webpack_require__(761);
	
	var _AudioTrackMenu = __webpack_require__(765);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _SlideDurationSlider = __webpack_require__(343);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ZoomComponent = _react2.default.createClass({
	    displayName: 'ZoomComponent',
	    getInitialState: function getInitialState() {
	        return {
	            isMinusOver: false,
	            isPlusOver: false
	        };
	    },
	    onMinusMouseIn: function onMinusMouseIn() {
	        _HoverManager2.default.show(this.refs.minus, 'zoomMinus', 'right');
	
	        this.setState({
	            isMinusOver: true
	        });
	    },
	    onMinusMouseOut: function onMinusMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isMinusOver: false
	        });
	    },
	    onPlusMouseIn: function onPlusMouseIn() {
	        _HoverManager2.default.show(this.refs.plus, 'zoomPlus');
	
	        this.setState({
	            isPlusOver: true
	        });
	    },
	    onPlusMouseOut: function onPlusMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isPlusOver: false
	        });
	    },
	    onMinusClick: function onMinusClick(e) {
	        if (_PlayController2.default.isPlaying) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var zoom = this.getCurrrentZoomIndex();
	        var oldZoom = _AudioEditorUtils2.default.getZoomValue();
	
	        zoom = zoom - 1;
	
	        if (zoom < 0) zoom = 0;
	
	        this.props.dispatch((0, _AudioEditorActions.changeZoom)(zoom));
	        _AudioEditorUtils2.default.addActionToHistory();
	        _AudioEditorUtils2.default.checkTimelineWidth(true, oldZoom, true);
	        _SaveManager2.default.isContentChanged(true);
	    },
	    onPlusClick: function onPlusClick(e) {
	        if (_PlayController2.default.isPlaying) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var zoom = this.getCurrrentZoomIndex();
	        var oldZoom = _AudioEditorUtils2.default.getZoomValue();
	
	        zoom = zoom + 1;
	
	        if (zoom > _AudioEditorUtils2.default.maxZoom) zoom = _AudioEditorUtils2.default.maxZoom;
	
	        this.props.dispatch((0, _AudioEditorActions.changeZoom)(zoom));
	        _AudioEditorUtils2.default.addActionToHistory();
	        _AudioEditorUtils2.default.checkTimelineWidth(true, oldZoom, true);
	        _SaveManager2.default.isContentChanged(true);
	    },
	    getCurrrentZoomIndex: function getCurrrentZoomIndex() {
	        var state = _StoreManager2.default.getState();
	        var zoom = state.audioEditor.zoomValue;
	
	        if (zoom == undefined) {
	            if (_AudioToolUtils2.default.isAudioTool()) return 1;else return 4;
	        } else return zoom;
	    },
	    getText: function getText() {
	        var zoomValue = _AudioEditorUtils2.default.getZoomValue();
	
	        return '' + zoomValue * 100 + '%';
	    },
	    render: function render() {
	        var sliderProperties = {};
	        sliderProperties.topPosition = 0;
	        sliderProperties.leftPosition = 33;
	        sliderProperties.width = _Properties2.default.RECORGING_SLIDER_WIDTH + 30;
	        sliderProperties.height = _Properties2.default.RECORDING_BUTTON_HEIGHT;
	        sliderProperties.thumbSize = 20;
	        sliderProperties.start = 0;
	        sliderProperties.end = _AudioEditorUtils2.default.maxZoom;
	        sliderProperties.step = 1;
	        sliderProperties.dispatch = this.props.dispatch;
	        sliderProperties.isZoom = true;
	        sliderProperties.currentValue = this.getCurrrentZoomIndex();
	
	        var zoomHolderStyle = {
	            position: 'absolute',
	            top: _AudioToolUtils2.default.timelineHeight() * _AudioEditorUtils2.default.getTimelinesLength() + _Properties2.default.LINE_SIZE,
	            left: 0,
	            width: _AudioToolUtils2.default.buttonsHolderWidth(),
	            height: 30,
	            background: _Properties2.default.RECORDING_MENU_BACKGROUND
	        };
	
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            zoomHolderStyle.top = undefined;
	            zoomHolderStyle.bottom = 0;
	            zoomHolderStyle.position = 'fixed';
	        }
	
	        var color = '#272727';
	
	        if (this.state.isMinusOver) color = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	
	        var zoomMinusButton = {
	            position: 'absolute',
	            left: 7,
	            width: 24,
	            height: 24,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        var zoomMinus = {
	            position: 'absolute',
	            top: 6,
	            left: 6,
	            color: color
	        };
	
	        if (this.state.isPlusOver) color = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else color = '#272727';
	
	        var zoomPlusButton = {
	            position: 'absolute',
	            right: 7,
	            width: 24,
	            height: 24,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        var zoomPlus = {
	            position: 'absolute',
	            top: 6,
	            right: 6,
	            color: color
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: zoomHolderStyle },
	            _react2.default.createElement(
	                'button',
	                { ref: 'minus', style: zoomMinusButton, 'aria-label': _LocalesManager2.default.getCaption('zoomMinus', 'hover'), onMouseOver: this.onMinusMouseIn, onMouseOut: this.onMinusMouseOut, onTouchEnd: this.onMinusClick, onClick: this.onMinusClick },
	                _react2.default.createElement('i', { style: zoomMinus, className: 'fa fa-minus fa-1x' })
	            ),
	            _react2.default.createElement(_SlideDurationSlider.SlideDurationSlider, { properties: sliderProperties }),
	            _react2.default.createElement(
	                'button',
	                { ref: 'plus', style: zoomPlusButton, 'aria-label': _LocalesManager2.default.getCaption('zoomPlus', 'hover'), onMouseOver: this.onPlusMouseIn, onMouseOut: this.onPlusMouseOut, onTouchEnd: this.onPlusClick, onClick: this.onPlusClick },
	                _react2.default.createElement('i', { style: zoomPlus, className: 'fa fa-plus fa-1x' })
	            )
	        );
	    }
	});
	
	var AudioEditorControlsContent = _react2.default.createClass({
	    displayName: 'AudioEditorControlsContent',
	    render: function render() {
	        if (!this.props.timelines) return _react2.default.createElement('div', null);
	
	        var height = _AudioEditorUtils2.default.getAudioEditorHeight();
	        var listHeight = _AudioToolUtils2.default.isAudioTool() ? _Properties2.default.SLIDE_VIEWER_TOP_GAP * 5 : _Properties2.default.SLIDE_VIEWER_LIST_HEIGHT + _Properties2.default.SLIDE_VIEWER_TOP_GAP;
	        var normalSlideViewerHeight = _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT + listHeight + _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP;
	
	        var menuStyle = {
	            position: 'absolute',
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            top: normalSlideViewerHeight + _Properties2.default.SLIDE_VIEWER_TOP_GAP,
	            left: 0,
	            width: _AudioToolUtils2.default.buttonsHolderWidth(),
	            height: height
	        };
	
	        var timelines = [];
	        var i;
	        var maxTimelines = _AudioEditorUtils2.default.getMaxTimelinesRelatedToHeight();
	
	        for (i = 0; i < this.props.timelines.length; i++) {
	            if (i < maxTimelines) timelines.push(_react2.default.createElement(_AudioElementVolume.AudioElementVolume, { key: 'track_' + i, index: i, dispatch: this.props.dispatch, timeline: this.props.timelines[i], menuIndex: this.props.index }));
	        }
	
	        var zoomComponent = _react2.default.createElement(ZoomComponent, { dispatch: this.props.dispatch, zoomValue: this.props.zoomValue, topOffset: menuStyle.top, windowHeight: this.props.windowHeight });
	
	        if (_AudioToolUtils2.default.buttonsHolderWidth() == _Properties2.default.BUTTONS_HOLDER_COLLAPSED_WIDTH) zoomComponent = undefined;
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            timelines,
	            _react2.default.createElement(_AudioTrackMenu.AudioTrackMenu, { dispatch: this.props.dispatch }),
	            zoomComponent
	        );
	    }
	});
	
	function mapStateToProps(state) {
	    var timelines = state.audioEditor.timelines;
	    var zoomValue = state.audioEditor.zoomValue;
	    var index = state.audioEditor.trackMenu;
	
	    if (index == undefined) index = -1;
	
	    if (zoomValue == undefined) zoomValue = 4;
	
	    return {
	        timelines: timelines,
	        zoomValue: zoomValue,
	        index: index
	    };
	}
	
	var AudioEditorControls = exports.AudioEditorControls = (0, _reactRedux.connect)(mapStateToProps)(AudioEditorControlsContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioEditorControls.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioEditorControls.js"); } } })();

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioEditorTimeline = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AudioElement = __webpack_require__(760);
	
	var _Marker = __webpack_require__(766);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _reactRedux = __webpack_require__(10);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _TimelineDragManager = __webpack_require__(137);
	
	var _TimelineDragManager2 = _interopRequireDefault(_TimelineDragManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioEditorTimelineContent = _react2.default.createClass({
	    displayName: 'AudioEditorTimelineContent',
	    getInitialState: function getInitialState() {
	        return {
	            startPoint: undefined,
	            endPoint: undefined
	        };
	    },
	    onStart: function onStart(e) {
	        if (e.target.id == 'timeline' || e.target.parentNode.id == 'timeline' || e.target.parentNode.parentNode.id == 'timeline') {
	            if (_PlayController2.default.startScroll) _PlayController2.default.startScroll(e);
	        }
	    },
	    onMove: function onMove(e) {
	        if (e.target.id == 'timeline' || e.target.parentNode.id == 'timeline' || e.target.parentNode.parentNode.id == 'timeline') {
	            if (_PlayController2.default.moveScroll) _PlayController2.default.moveScroll(e);
	        }
	    },
	    onEnd: function onEnd() {
	        if (_PlayController2.default.endScroll) _PlayController2.default.endScroll();
	    },
	    onStartSelection: function onStartSelection(e) {
	        if (!(e.target && e.target.parentNode && e.target.parentNode.parentNode && e.target.parentNode.parentNode.id == 'timeline')) return;
	
	        var globalPoint = this.getGlobalPoint();
	        var touchPoint = (0, _TransformToolUtils.getTouchPosition)(e);
	        var scrollPos = _PlayController2.default.getScrollPosition();
	        var point = {};
	        point.x = touchPoint.x - globalPoint.left + scrollPos;
	        point.y = touchPoint.y - globalPoint.top;
	
	        if (!this.state.globalPoint) {
	            this.setState({
	                startPoint: point,
	                globalPoint: globalPoint,
	                scrolPosition: scrollPos
	            });
	        } else {
	            this.setState({
	                startPoint: point,
	                scrolPosition: scrollPos
	            });
	        }
	    },
	    onMoveSelection: function onMoveSelection(e) {
	        if (!this.state.startPoint) return;
	
	        var globalPoint = this.getGlobalPoint();
	        var touchPoint = (0, _TransformToolUtils.getTouchPosition)(e);
	        var point = {};
	        point.x = touchPoint.x - globalPoint.left + this.getScrollPos();
	        point.y = touchPoint.y - globalPoint.top;
	
	        this.setState({
	            endPoint: point
	        });
	    },
	    onEndSelection: function onEndSelection() {
	        if (this.state.startPoint && this.state.endPoint) _TimelineDragManager2.default.getMultipleSelection(this.state.startPoint, this.state.endPoint);else _TimelineDragManager2.default.resetMultipleSelection();
	
	        this.setState({
	            startPoint: undefined,
	            endPoint: undefined
	        });
	    },
	    getScrollPos: function getScrollPos() {
	        if (this.state.scrolPosition) return this.state.scrolPosition;else return _PlayController2.default.getScrollPosition();
	    },
	    getGlobalPoint: function getGlobalPoint() {
	        if (this.state.globalPoint) return this.state.globalPoint;else return this.refs.timeline.getBoundingClientRect();
	    },
	    getSelection: function getSelection() {
	        if (this.state && this.state.startPoint && this.state.endPoint) {
	            return { x: Math.min(this.state.startPoint.x, this.state.endPoint.x), y: Math.min(this.state.startPoint.y, this.state.endPoint.y), width: Math.abs(this.state.startPoint.x - this.state.endPoint.x), height: Math.abs(this.state.startPoint.y - this.state.endPoint.y) };
	        } else {
	            return undefined;
	        }
	    },
	    render: function render() {
	        var height = _AudioEditorUtils2.default.getAudioEditorHeight();
	        var listHeight = _AudioToolUtils2.default.isAudioTool() ? _Properties2.default.SLIDE_VIEWER_TOP_GAP * 5 : _Properties2.default.SLIDE_VIEWER_LIST_HEIGHT + _Properties2.default.SLIDE_VIEWER_TOP_GAP;
	        var normalSlideViewerHeight = _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT + listHeight + _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP;
	
	        var menuStyle = {
	            position: 'absolute',
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            top: normalSlideViewerHeight,
	            left: 0,
	            width: this.props.width,
	            height: height
	        };
	
	        var timelines = [];
	        var i;
	        var maxTimelines = _AudioEditorUtils2.default.getMaxTimelinesRelatedToHeight();
	
	        for (i = 0; i < this.props.timelines.length; i++) {
	            if (i < maxTimelines) timelines.push(_react2.default.createElement(_AudioElement.AudioElement, { buttonsHolderWidth: this.props.buttonsHolderWidth, key: 'timelineElement_' + i, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, width: this.props.width, index: i, timeline: this.props.timelines[i], zoomValue: this.props.zoomValue, dispatch: this.props.dispatch }));
	        }
	
	        var selection = this.getSelection();
	        var selector;
	
	        if (selection) {
	            var selectionStyle = {
	                position: 'absolute',
	                background: 'blue',
	                top: selection.y,
	                left: selection.x,
	                width: selection.width,
	                height: selection.height,
	                borderWidth: 2,
	                borderColor: 'red',
	                borderStyle: 'solid',
	                opacity: 0.3
	            };
	
	            selector = _react2.default.createElement('div', { style: selectionStyle });
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, ref: 'timeline', id: 'timeline', onTouchStart: this.onStart, onTouchMove: this.onMove, onTouchEnd: this.onEnd, onMouseDown: this.onStartSelection, onMouseMove: this.onMoveSelection, onMouseUp: this.onEndSelection },
	            timelines,
	            selector,
	            _react2.default.createElement(_Marker.Marker, { zoomValue: this.props.zoomValue, dispatch: this.props.dispatch })
	        );
	    }
	});
	
	function mapStateToProps(state) {
	    var timelines = state.audioEditor.timelines;
	    var currentSlideDuration = state.currentSlide && state.currentSlide.model ? state.currentSlide.model.time : 0;
	    var windowHeight = state.production.windowHeight;
	
	    if (!(windowHeight > 0)) windowHeight = window.innerHeight;
	
	    return {
	        timelines: timelines,
	        windowHeight: windowHeight,
	        currentSlideDuration: currentSlideDuration
	    };
	}
	
	var AudioEditorTimeline = exports.AudioEditorTimeline = (0, _reactRedux.connect)(mapStateToProps)(AudioEditorTimelineContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioEditorTimeline.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioEditorTimeline.js"); } } })();

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Ruler = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ruler = exports.Ruler = _react2.default.createClass({
	    displayName: 'Ruler',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlayController2.default.isPlaying) return;
	
	        var localX = e.nativeEvent.offsetX;
	
	        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0) localX = e.nativeEvent.touches[0].clientX - _AudioToolUtils2.default.buttonsHolderWidth() + _PlayController2.default.getIpadScrollPosition();
	
	        var markerPosition = _AudioEditorUtils2.default.getItemTimePosition(localX);
	        _PlayController2.default.playSlidesSequence(false, markerPosition);
	
	        this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(markerPosition));
	    },
	    hasMinValue: function hasMinValue() {
	        if (_AudioEditorUtils2.default.getZoomValue() < 0.4) return true;else return false;
	    },
	    render: function render() {
	        var rulerHeight = _Properties2.default.RULER_HEIGHT;
	        var listHeight = _AudioToolUtils2.default.isAudioTool() ? _Properties2.default.SLIDE_VIEWER_TOP_GAP * 5 : _Properties2.default.SLIDE_VIEWER_LIST_HEIGHT + _Properties2.default.SLIDE_VIEWER_TOP_GAP;
	        var normalSlideViewerHeight = _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT + listHeight + _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP;
	
	        var menuStyle = {
	            position: 'absolute',
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            top: normalSlideViewerHeight - rulerHeight,
	            left: 0,
	            width: this.props.width,
	            height: rulerHeight
	        };
	
	        var isMinimized = this.hasMinValue();
	        var steps = 10;
	
	        if (isMinimized) {
	            steps = 2;
	        }
	
	        var oneSecondWidth = _AudioEditorUtils2.default.getSlideWidth(1);
	        var lineSize = 1;
	        var breakSize = (oneSecondWidth - steps * lineSize) / steps;
	        var lineHeight = 5;
	        var length = Math.ceil(this.props.width / (lineSize + breakSize));
	        var i;
	        var elements = [];
	        var seconds = [];
	        var counter = 0;
	
	        for (i = 0; i < length; i++) {
	            var height = lineHeight;
	
	            if (i % steps == 0) {
	
	                // Set width and position of time indication
	                var spanWidth = 30;
	                var spanPositionTop = rulerHeight - lineHeight * 3 - 12;
	                var spanPositionLeft = i * (lineSize + breakSize) - spanWidth / 2;
	
	                var spanStyle = {
	                    position: 'absolute',
	                    fontSize: 10,
	                    fontWeight: 'bold',
	                    height: 10,
	                    width: spanWidth,
	                    top: spanPositionTop,
	                    left: spanPositionLeft,
	                    color: 'black',
	                    cursor: 'default',
	                    whiteSpace: 'nowrap',
	                    overflow: 'hidden',
	                    textOverflow: 'ellipsis',
	                    textAlign: 'center',
	                    pointerEvents: 'none'
	                };
	
	                if (isMinimized) {
	                    if (length - i > 2 && i % 10 == 0) {
	                        seconds.push(_react2.default.createElement(
	                            'span',
	                            { style: spanStyle, key: 'seconds' + counter },
	                            _AudioEditorUtils2.default.transformToSeconds(counter)
	                        ));
	                        height = height * 3;
	                    }
	                } else {
	                    if (length - i > 2) {
	                        seconds.push(_react2.default.createElement(
	                            'span',
	                            { style: spanStyle, key: 'seconds' + counter },
	                            _AudioEditorUtils2.default.transformToSeconds(counter)
	                        ));
	                        height = height * 3;
	                    }
	                }
	
	                counter = counter + 1;
	            }
	
	            // Dont render ticks for half seconds (shows 4 ticks instead of 9 between time indications on far zoom)
	            if (isMinimized && i % steps !== 0) continue;
	
	            var lineStyle = {
	                position: 'absolute',
	                width: lineSize,
	                height: height,
	                top: rulerHeight - height,
	                left: i * (lineSize + breakSize),
	                background: 'black',
	                pointerEvents: 'none'
	            };
	
	            elements.push(_react2.default.createElement('div', { style: lineStyle, key: 'ruler' + i }));
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, onTouchStart: this.onClick, onMouseDown: this.onClick },
	            elements,
	            seconds
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/Ruler.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/Ruler.js"); } } })();

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioAlert = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _reactRedux = __webpack_require__(10);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onButtonClick: function onButtonClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlatformDetection2.default.isSafariNonIOS()) {
	            this.props.dispatch((0, _MenuActions.showAudioAlert)(-2));
	            _PlatformDetection2.default.showSafariAlert = false;
	
	            if (_AudioUtils2.default.visitedAudioAlerts.indexOf(4) == -1) _AudioUtils2.default.visitedAudioAlerts.push(4);
	
	            if (this.props.hideAudioAlert) {
	                _ApiServiceUtils2.default.executeSafeApiCall(this.setProperties);
	            }
	
	            return;
	        }
	
	        this.props.dispatch((0, _MenuActions.showAudioAlert)(-1));
	
	        if (_AudioUtils2.default.visitedAudioAlerts.indexOf(this.props.audioAlert) == -1) _AudioUtils2.default.visitedAudioAlerts.push(this.props.audioAlert);
	
	        if (this.props.hideAudioAlert) {
	            _ApiServiceUtils2.default.executeSafeApiCall(this.setProperties);
	        }
	    },
	    setProperties: function setProperties() {
	        var _this = this;
	
	        _ApiService2.default.getSessionProperties() // check if the user has access
	        .then(function (response) {
	            var value = [];
	
	            if (response && response.user && response.user.audio_recording_popups) {
	                var elements = response.user.audio_recording_popups;
	
	                value.push({ show_popup_a: elements.show_popup_a });
	                value.push({ show_popup_b: elements.show_popup_b });
	                value.push({ show_popup_c: elements.show_popup_c });
	                value.push({ show_popup_d: elements.show_popup_d });
	                value.push({ show_popup_e: elements.show_popup_e });
	            } else {
	                value.push({ show_popup_a: false });
	                value.push({ show_popup_b: false });
	                value.push({ show_popup_c: false });
	                value.push({ show_popup_d: false });
	                value.push({ show_popup_e: false });
	            }
	
	            if (_this.props.audioAlert == 0) value[0].show_popup_a = true;
	
	            if (_this.props.audioAlert == 1) value[1].show_popup_b = true;
	
	            if (_this.props.audioAlert == 2) value[2].show_popup_c = true;
	
	            if (_this.props.audioAlert == 3) // video alert
	                value[3].show_popup_d = true;
	
	            if (_PlatformDetection2.default.isSafariNonIOS()) // Safari alert
	                value[4].show_popup_e = true;
	
	            _ApiService2.default.setItemProperty('audio_recording_popups', _AppParameters2.default.currentUserId, value);
	        });
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver) return true;else return false;
	    },
	    render: function render() {
	        var textColor;
	        var fillColor;
	
	        if (this.state.isOver == true) {
	            fillColor = _Properties2.default.SLIDE_VIEWER_BACKGROUND;
	            textColor = 'black';
	        } else {
	            textColor = 'white';
	            fillColor = '#444444';
	        }
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: fillColor,
	            width: _Properties2.default.DELETE_ALERT_BUTTON_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT,
	            top: this.props.topPosition,
	            left: this.props.leftPosition,
	            borderRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#333333',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            textAlign: 'left'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 6,
	            fontSize: 16,
	            width: _Properties2.default.DELETE_ALERT_BUTTON_WIDTH - 6,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            alignItems: 'center',
	            textAlign: 'center',
	            cursor: 'default',
	            color: textColor
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { id: 'audioAlertLastFocusableElement', 'aria-label': this.props.text, style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onButtonClick, onClick: this.onButtonClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var AudioAlertContent = _react2.default.createClass({
	    displayName: 'AudioAlertContent',
	    getInitialState: function getInitialState() {
	        return {
	            hideAudioAlert: false
	        };
	    },
	    onCheckBoxClick: function onCheckBoxClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var value = !this.state.hideAudioAlert;
	
	        this.setState({
	            hideAudioAlert: value
	        });
	    },
	    resetState: function resetState() {
	        if (this.state.hideAudioAlert == false) return;
	
	        setTimeout(function () {
	            this.setState({ hideAudioAlert: false });
	        }.bind(this), 3);
	    },
	    render: function render() {
	        var visible = 'none';
	        var showAlert = false;
	        var isSafariNonIOS = _PlatformDetection2.default.isSafariNonIOS();
	
	        if (isSafariNonIOS && _PlatformDetection2.default.showSafariAlert) {
	            if (_AudioUtils2.default.visitedAudioAlerts.indexOf(4) == -1) showAlert = true;
	        } else if (this.props.audioAlert >= 0 && _AudioUtils2.default.visitedAudioAlerts.indexOf(this.props.audioAlert) == -1) showAlert = true;
	
	        if (showAlert) visible = 'block';else {
	            this.resetState();
	            return _react2.default.createElement('div', null);
	        }
	
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            left: 0,
	            display: visible,
	            zIndex: 20000
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: 0,
	            left: 0,
	            opacity: 0.4
	        };
	
	        var alertHolderStyle = {
	            position: 'absolute',
	            top: this.props.windowHeight / 2 - (_Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT + _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT) / 2,
	            left: (this.props.windowWidth - _Properties2.default.BROWSER_WIDTH - 100) / 2 - _Properties2.default.DELETE_ALERT_WIDTH / 2
	        };
	
	        var topBarStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: _Properties2.default.DELETE_ALERT_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT,
	            top: 0,
	            left: 0,
	            borderTopLeftRadius: 3,
	            borderTopRightRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: _Properties2.default.DELETE_ALERT_BACKGROUND
	        };
	
	        var titleStyle = {
	            position: 'absolute',
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            top: 6,
	            fontSize: 22,
	            width: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            color: 'white'
	        };
	
	        var bottomBarStyle = {
	            position: 'absolute',
	            backgroundColor: 'white',
	            width: _Properties2.default.DELETE_ALERT_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT,
	            top: _Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT,
	            left: 0,
	            borderBottomLeftRadius: 3,
	            borderBottomRightRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: 'white'
	        };
	
	        var questionStyle = {
	            position: 'absolute',
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            top: 20,
	            fontSize: 16,
	            width: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            height: _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT - 3 * _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT,
	            cursor: 'default',
	            color: 'black',
	            whiteSpace: 'pre-line'
	        };
	
	        var buttonTopPosition = _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT - _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT;
	        var showMessageStyle = {
	            position: 'absolute',
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP + 28,
	            top: buttonTopPosition + 8,
	            fontSize: 16,
	            width: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_WIDTH - 50,
	            height: _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT,
	            cursor: 'default',
	            color: 'black',
	            whiteSpace: 'pre-line'
	        };
	
	        var title = _LocalesManager2.default.getCaption('AudioAlertTitle', 'audio');
	        var question = _LocalesManager2.default.getCaption('AudioAlertRecording', 'audio');
	        var okCaption = _LocalesManager2.default.getCaption('AudioAlertOk', 'audio');
	        var showMessage = _LocalesManager2.default.getCaption('ShowMessage', 'audio');
	
	        switch (this.props.audioAlert) {
	            case 0:
	                {
	                    question = _LocalesManager2.default.getCaption('AudioAlertRecording', 'audio');
	                    break;
	                }
	            case 1:
	                {
	                    question = '"' + this.props.audioTitle + '" ' + _LocalesManager2.default.getCaption('AudioAlertEffects', 'audio');
	                    break;
	                }
	            case 2:
	                {
	                    question = '"' + this.props.audioTitle + '" ' + _LocalesManager2.default.getCaption('AudioAlertStorySound', 'audio');
	                    break;
	                }
	            case 3:
	                {
	                    question = _LocalesManager2.default.getCaption('firstVideoMessage', 'other');
	                    title = _LocalesManager2.default.getCaption('VideoAlertTitle', 'audio');
	                    break;
	                }
	        }
	
	        var checkBoxSize = 18;
	        var checkBoxStyle = {
	            position: 'absolute',
	            width: checkBoxSize,
	            height: checkBoxSize,
	            top: buttonTopPosition + 6,
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            borderRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none'
	        };
	
	        var selectorStyle = {
	            position: 'absolute',
	            width: 10,
	            height: 10,
	            top: checkBoxSize / 2 - 10 / 2,
	            left: checkBoxSize / 2 - 10 / 2,
	            background: _Properties2.default.DELETE_ALERT_BACKGROUND
	        };
	
	        if (this.state.hideAudioAlert) selectorStyle.display = 'block';else selectorStyle.display = 'none';
	
	        if (isSafariNonIOS) {
	            title = _LocalesManager2.default.getCaption('SafariAlertTitle', 'other');
	            question = _LocalesManager2.default.getCaption('SafariAlertDescription', 'other');
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'audioAlert' },
	            _react2.default.createElement('div', { style: backgroundStyle }),
	            _react2.default.createElement(
	                'div',
	                { style: alertHolderStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: topBarStyle },
	                    _react2.default.createElement(
	                        'span',
	                        { style: titleStyle },
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: bottomBarStyle },
	                    _react2.default.createElement(
	                        'div',
	                        { style: questionStyle },
	                        question
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: showMessageStyle },
	                        showMessage
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { id: 'audioAlertFirstFocusableElement', 'aria-label': showMessage, style: checkBoxStyle, onTouchEnd: this.onCheckBoxClick, onClick: this.onCheckBoxClick },
	                        _react2.default.createElement('div', { style: selectorStyle })
	                    ),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, hideAudioAlert: this.state.hideAudioAlert, audioAlert: this.props.audioAlert, topPosition: buttonTopPosition, leftPosition: _Properties2.default.DELETE_ALERT_WIDTH - _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_WIDTH, text: okCaption })
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var audioAlert = state.menu.audioAlert;
	    var audioTitle = state.menu.audioTitle;
	
	    if (audioAlert == undefined) audioAlert = -1;
	
	    return {
	        audioAlert: audioAlert,
	        audioTitle: audioTitle
	    };
	}
	
	var AudioAlert = exports.AudioAlert = (0, _reactRedux.connect)(mapStateToProps)(AudioAlertContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AudioAlert.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AudioAlert.js"); } } })();

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ClipartSelectorListNew = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _ClipartSelectorButtonNew = __webpack_require__(781);
	
	var _ClipartSelectorButtonExpandedNew = __webpack_require__(780);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClipartSelectorListNewContent = _react2.default.createClass({
	    displayName: 'ClipartSelectorListNewContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            elements: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.clipartCategory != this.props.clipartCategory || nextProps.dataProvider != this.props.dataProvider || nextProps.isUniversesVisible != this.props.isUniversesVisible) {
	            setTimeout(this.refreshView, 50);
	
	            if (nextProps.isUniversesVisible) _MouseUtils2.default.setFocusSequence();
	        }
	    },
	    initElements: function initElements() {
	        var elements = this.getElements(false);
	        var videoElements = this.getElements(true);
	
	        this.setState({
	            elements: elements,
	            videoElements: videoElements
	        });
	    },
	    getElements: function getElements() {
	        var items = this.props.dataProvider ? this.props.dataProvider : _MasterUniverseUtils2.default.getCurrentThemes();
	        var item;
	        var elements = [];
	        var i;
	        var listType = this.getListStyle();
	
	        if (!items) return elements;
	
	        for (i = 0; i < items.length; i++) {
	            item = items[i];
	
	            if (listType == 'collapsed') elements.push(_react2.default.createElement(_ClipartSelectorButtonNew.ClipartSelectorButtonNew, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, index: i, item: item, key: 'clipartSelector_' + i + item.name }));else elements.push(_react2.default.createElement(_ClipartSelectorButtonExpandedNew.ClipartSelectorButtonExpandedNew, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, index: i, item: item, key: 'clipartSelector_' + i + item.name }));
	        }
	
	        return elements;
	    },
	    getButtonLabel: function getButtonLabel() {
	        if (this.getListStyle() == 'collapsed') return _LocalesManager2.default.getCaption('makeListExpanded', 'other');else return _LocalesManager2.default.getCaption('makeListCollapsed', 'other');
	    },
	    onMouseIn: function onMouseIn() {
	        var listStyle = this.getListStyle();
	
	        if (listStyle == 'collapsed') _HoverManager2.default.show(this.refs.listView, 'expandedListView', 'left');else _HoverManager2.default.show(this.refs.listView, 'collapsedListView', 'left');
	
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isOver: false
	        });
	    },
	    onChangeListStyle: function onChangeListStyle(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var listStyle = this.getListStyle();
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (listStyle == 'collapsed') sessionStorage.setItem('listStyle', 'exapanded');else sessionStorage.setItem('listStyle', 'collapsed');
	        } else {
	            if (listStyle == 'collapsed') localStorage.setItem('listStyle', 'exapanded');else localStorage.setItem('listStyle', 'collapsed');
	        }
	
	        setTimeout(this.refreshView, 10);
	    },
	    getListStyle: function getListStyle() {
	        var listStyle;
	
	        if (_PlatformDetection2.default.isIOS()) listStyle = sessionStorage.getItem('listStyle');else listStyle = localStorage.getItem('listStyle');
	
	        if (listStyle == 'collapsed') return 'collapsed';else return 'exapanded';
	    },
	    refreshView: function refreshView() {
	        this.initElements();
	        this.forceUpdate();
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.dataProvider != newProps.dataProvider || this.props.noHits != newProps.noHits || this.state.elements != nextState.elements || this.state.isOver != nextState.isOver || this.props.clipartCategory != newProps.clipartCategory || this.props.isUniversesVisible != newProps.isUniversesVisible || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        if (this.props.isUniversesVisible == false || this.state == undefined || this.state.elements == undefined) return _react2.default.createElement('div', null);
	
	        var topPadding = 33;
	        var bottomPadding = 10;
	        var topOffset = this.props.topOffset > 0 ? this.props.topOffset : 0;
	        var height = this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT - 2 * _Properties2.default.BROWSER_BUTTON_HEIGHT;
	        var top = _Properties2.default.CLIPART_BUTTON_HEIGHT + 2 * _Properties2.default.BROWSER_BUTTON_HEIGHT;
	
	        if (this.props.isSearch) {
	            top = _Properties2.default.SEARCH_HEIGHT() + topOffset;
	            height = this.props.windowHeight - top;
	        }
	
	        if (this.props.noHits) {
	            var divStyle = {
	                position: 'relative',
	                top: top,
	                width: this.props.width,
	                textAlign: 'center',
	                fontSize: '15px',
	                marginTop: 10
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { style: divStyle },
	                _LocalesManager2.default.getCaption('searchNoHits', 'other')
	            );
	        }
	
	        var listStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_COLOR,
	            width: this.props.accordionWidth,
	            height: height,
	            top: top,
	            left: 0,
	            overflowX: 'hidden',
	            overflowY: 'hidden'
	        };
	
	        var listType = this.getListStyle();
	        var itemHeight;
	
	        if (listType == 'collapsed') itemHeight = _Properties2.default.UNIVERSE_BUTTON_HEIGHT;else {
	            var scrollWidth = 15;
	            var hGap = 10;
	            var bottomGap = 14;
	            var textHeight = 17;
	            var buttonWidth = this.props.accordionWidth - 2 * hGap - scrollWidth;
	            itemHeight = buttonWidth * 9 / 16 + textHeight + bottomGap;
	        }
	
	        var items = this.state.elements;
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = height - topPadding - bottomPadding;
	        componentProperties.top = topPadding;
	        componentProperties.displayState = 'block';
	        componentProperties.scrollHeight = items.length * itemHeight;
	        componentProperties.elements = items;
	        componentProperties.backgroundColor = _Properties2.default.BROWSER_COLOR;
	
	        var iconSrc;
	        var ariaChecked = false;
	
	        if (listType == 'collapsed') {
	            if (this.state.isOver == true) {
	                iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/collapseListHover.png';
	            } else {
	                iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/collapseList.png';
	            }
	        } else {
	            if (this.state.isOver == true) {
	                iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/expandListHover.png';
	            } else {
	                iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/expandList.png';
	            }
	
	            ariaChecked = true;
	        }
	
	        var iconButtonStyle = {
	            position: 'absolute',
	            top: 7,
	            right: 25,
	            width: 35,
	            height: 35 * 26 / 46,
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            textAlign: 'left',
	            borderStyle: 'none',
	            background: 'none',
	            display: 'flex'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: 35,
	            height: 35 * 26 / 46
	        };
	
	        var expandCollpaseButton;
	
	        expandCollpaseButton = _react2.default.createElement(
	            'button',
	            { 'aria-label': this.getButtonLabel(), role: 'switch', 'aria-checked': ariaChecked, style: iconButtonStyle, ref: 'listView', onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onChangeListStyle, onClick: this.onChangeListStyle },
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: iconSrc })
	        );
	
	        return _react2.default.createElement(
	            'div',
	            { style: listStyle },
	            expandCollpaseButton,
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var accordionWidth = state.accordion.width;
	    var clipartCategory = state.menu.clipartCategory;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    if (clipartCategory == undefined) clipartCategory = 0;
	
	    return {
	        accordionWidth: accordionWidth,
	        clipartCategory: clipartCategory
	    };
	}
	
	var ClipartSelectorListNew = exports.ClipartSelectorListNew = (0, _reactRedux.connect)(mapStateToProps)(ClipartSelectorListNewContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorListNew.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorListNew.js"); } } })();

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ColorPicker = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColorPicker = exports.ColorPicker = _react2.default.createClass({
	    displayName: 'ColorPicker',
	    getInitialState: function getInitialState() {
	        var gradientAreaWidth = this.props.accordionWidth - 3 * _Properties2.default.STYLING_LEFT_GAP - _Properties2.default.RAINBOW_WIDTH;
	        var top = _Properties2.default.RAINBOW_HEIGHT / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2;
	        var left = gradientAreaWidth / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2;
	
	        return {
	            isThumbOver: false,
	            gradientTopStartPosition: top,
	            gradientTopCurrentPosition: top,
	            gradientLeftStartPosition: left,
	            gradientLeftCurrentPosition: left
	        };
	    },
	    onThumbMouseIn: function onThumbMouseIn() {
	        this.setState({
	            isThumbOver: true
	        });
	    },
	    onThumbMouseOut: function onThumbMouseOut() {
	        this.setState({
	            isThumbOver: false
	        });
	    },
	    onKeyDownRigthRainbow: function onKeyDownRigthRainbow(e) {
	        var delta = 2;
	
	        if (e.keyCode == 38) {
	            // Up Key
	            this.onSelectorStart();
	
	            setTimeout(function () {
	                this.onSelectorDrag(undefined, undefined, -delta);
	
	                setTimeout(function () {
	                    this.onSelectorStopped();
	                }.bind(this), 10);
	            }.bind(this), 10);
	        } else if (e.keyCode == 40) {
	            // Down Key
	            this.onSelectorStart();
	
	            setTimeout(function () {
	                this.onSelectorDrag(undefined, undefined, delta);
	
	                setTimeout(function () {
	                    this.onSelectorStopped();
	                }.bind(this), 10);
	            }.bind(this), 10);
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        this.refs.rainbow.addEventListener('mousedown', this.onTrackMouseDown);
	        this.refs.gradientAreaDiv.addEventListener('mousedown', this.onGradientAreaClick);
	        this.refs.gradientAreaDiv.addEventListener('touchstart', this.onGradientAreaClick);
	
	        this.drawRainbow();
	        this.drawGradientArea();
	        this.drawColorGradientSelector();
	    },
	    drawRainbow: function drawRainbow() {
	        var canvas = this.refs.rainbow;
	        canvas.width = _Properties2.default.RAINBOW_WIDTH;
	        canvas.height = _Properties2.default.RAINBOW_HEIGHT;
	        var ctx = canvas.getContext('2d');
	        var objGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
	
	        objGradient.addColorStop(0, 'red');
	        objGradient.addColorStop(1 / 6, 'orange');
	        objGradient.addColorStop(2 / 6, 'yellow');
	        objGradient.addColorStop(3 / 6, 'green');
	        objGradient.addColorStop(4 / 6, 'blue');
	        objGradient.addColorStop(5 / 6, 'Indigo');
	        objGradient.addColorStop(1, 'Violet');
	
	        ctx.fillStyle = objGradient;
	        ctx.fillRect(0, 0, canvas.width, canvas.height);
	        ctx.fill();
	    },
	    drawColorGradientSelector: function drawColorGradientSelector() {
	        var canvas = this.refs.colorGradientSelector;
	        canvas.width = canvas.height = _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE + _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH;
	        var ctx = canvas.getContext('2d');
	        var centerX = canvas.width / 2;
	        var centerY = canvas.height / 2;
	        var radius = _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2;
	
	        ctx.beginPath();
	
	        ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
	        ctx.fillStyle = 'white';
	        ctx.fill();
	
	        ctx.lineWidth = _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH;
	        ctx.strokeStyle = 'black';
	        ctx.stroke();
	
	        ctx.closePath();
	
	        ctx.beginPath();
	
	        ctx.arc(centerX, centerY, 4, 0, 2 * Math.PI, false);
	        ctx.fillStyle = '#0090E8';
	        ctx.fill();
	
	        ctx.closePath();
	    },
	    drawGradientArea: function drawGradientArea() {
	        var canvas = this.refs.colorGradientArea;
	        var gardientAreaWidth = this.props.accordionWidth - 3 * _Properties2.default.STYLING_LEFT_GAP - _Properties2.default.RAINBOW_WIDTH;
	        canvas.width = gardientAreaWidth;
	        canvas.height = _Properties2.default.RAINBOW_HEIGHT;
	
	        this.updateGradient('#048200');
	    },
	    updateGradient: function updateGradient(color) {
	        var canvas = this.refs.colorGradientArea;
	        var ctx = canvas.getContext('2d');
	
	        var gardientAreaWidth = this.props.accordionWidth - 3 * _Properties2.default.STYLING_LEFT_GAP - _Properties2.default.RAINBOW_WIDTH;
	
	        var grd = ctx.createLinearGradient(0, 0, gardientAreaWidth, _Properties2.default.RAINBOW_HEIGHT);
	        grd.addColorStop(0, 'black');
	        grd.addColorStop(0.3, 'white');
	        grd.addColorStop(0.7, color);
	        grd.addColorStop(1, 'black');
	        ctx.fillStyle = grd;
	        ctx.fillRect(0, 0, gardientAreaWidth, _Properties2.default.RAINBOW_HEIGHT);
	    },
	    onSelectorStart: function onSelectorStart() {
	        var topString = this.refs.rainbowSelector.style.top;
	        var top = Number(topString.substring(0, topString.length - 2));
	
	        this.setState({
	            startPosition: top,
	            currentPosition: top
	        });
	    },
	    onSelectorDrag: function onSelectorDrag(e, coreEvent, movement) {
	        var step = coreEvent ? coreEvent.lastY : movement;
	
	        var newPosition = this.state.startPosition + step;
	        var topValue = -_Properties2.default.RAINBOW_SELECTOR_SIZE / 2 - _Properties2.default.RAINBOW_SELECTOR_STROKE_WIDTH / 2 + 1;
	        var bottomValue = _Properties2.default.RAINBOW_HEIGHT - _Properties2.default.RAINBOW_SELECTOR_SIZE / 2 - _Properties2.default.RAINBOW_SELECTOR_STROKE_WIDTH / 2 - 1;
	
	        if (newPosition < topValue) newPosition = topValue;else if (newPosition > bottomValue) newPosition = bottomValue;
	
	        this.refs.rainbowSelector.style.top = newPosition + 'px';
	
	        this.setState({
	            currentPosition: newPosition
	        });
	    },
	    onSelectorStopped: function onSelectorStopped() {
	        var color = this.getGradientSelectedColor();
	        this.updateGradient(color);
	        this.changeColorProperties(color);
	    },
	    onTrackMouseDown: function onTrackMouseDown(e) {
	        var newPosition = e.offsetY - _Properties2.default.RAINBOW_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2;
	        this.refs.rainbowSelector.style.top = newPosition + 'px';
	
	        this.setState({
	            currentPosition: newPosition
	        });
	
	        this.onSelectorStopped();
	    },
	    getGradientSelectedColor: function getGradientSelectedColor() {
	        var canvas = this.refs.rainbow;
	        var ctx = canvas.getContext('2d');
	        var offset = _Properties2.default.RAINBOW_SELECTOR_SIZE / 2 + _Properties2.default.RAINBOW_SELECTOR_STROKE_WIDTH / 2;
	
	        var yPos = this.state.currentPosition + offset;
	
	        if (!yPos || isNaN(yPos) || yPos < 0) yPos = 1;else if (yPos >= canvas.height) yPos = canvas.height - 1;
	
	        var RGBcolor = ctx.getImageData(5, yPos, 1, 1).data;
	        var hexaColor = this.rgbToHex(RGBcolor[0], RGBcolor[1], RGBcolor[2]);
	
	        return hexaColor;
	    },
	    transformCssValue: function transformCssValue(value) {
	        var newValue = Number(value.substring(0, value.length - 2));
	
	        return newValue;
	    },
	    getOffset: function getOffset(e) {
	        if (e.offsetX >= 0) {
	            return { x: e.offsetX, y: e.offsetY };
	        } else {
	            var position = _MouseUtils2.default.getTouchPosition(e);
	
	            return { x: position.x - (window.innerWidth - this.props.accordionWidth + _Properties2.default.STYLING_LEFT_GAP), y: position.y - this.props.topPosition };
	        }
	    },
	    onGradientAreaClick: function onGradientAreaClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var offset = _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 + _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2;
	        var offsetVal = this.getOffset(e);
	
	        var x = offsetVal.x - offset;
	        var y = offsetVal.y - offset;
	
	        if (e.target == this.refs.colorGradientSelectorButton || e.target == this.refs.colorGradientSelector) {
	            x = x + this.transformCssValue(this.refs.colorGradientSelectorButton.style.left);
	            y = y + this.transformCssValue(this.refs.colorGradientSelectorButton.style.top);
	        }
	
	        this.refs.colorGradientSelectorButton.style.left = x + 'px';
	        this.refs.colorGradientSelectorButton.style.top = y + 'px';
	
	        this.setState({
	            gradientTopStartPosition: y,
	            gradientTopCurrentPosition: y,
	            gradientLeftStartPosition: x,
	            gradientLeftCurrentPosition: x
	        });
	    },
	    onGradientSelectorDrag: function onGradientSelectorDrag(e, coreEvent) {
	        var newTopPosition = this.state.gradientTopStartPosition + coreEvent.lastY;
	        var newLeftPosition = this.state.gradientLeftStartPosition + coreEvent.lastX;
	        var offset = 1;
	
	        var topValue = -_Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 + offset;
	        var bottomValue = _Properties2.default.RAINBOW_HEIGHT - _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 - offset;
	
	        var leftValue = -_Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 + offset;
	        var gardientAreaWidth = this.props.accordionWidth - 3 * _Properties2.default.STYLING_LEFT_GAP - _Properties2.default.RAINBOW_WIDTH;
	        var rightValue = gardientAreaWidth - _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 - offset;
	
	        if (newTopPosition >= topValue && newTopPosition <= bottomValue) {
	            this.refs.colorGradientSelectorButton.style.top = newTopPosition + 'px';
	            this.setState({
	                gradientTopCurrentPosition: newTopPosition
	            });
	        }
	
	        if (newLeftPosition >= leftValue && newLeftPosition <= rightValue) {
	            this.refs.colorGradientSelectorButton.style.left = newLeftPosition + 'px';
	            this.setState({
	                gradientLeftCurrentPosition: newLeftPosition
	            });
	        }
	    },
	    onGradientSelectorStopped: function onGradientSelectorStopped() {
	        var color = this.getSelectedColor();
	        this.changeColorProperties(color);
	    },
	    onKeyDownOnCanvas: function onKeyDownOnCanvas(e) {
	        var step = 1;
	        var xOffset = 0;
	        var yOffset = 0;
	
	        switch (true) {
	            case e.keyCode == 37:
	                {
	                    // LEFT
	                    xOffset = -step;
	                    break;
	                }
	            case e.keyCode == 38:
	                {
	                    // UP
	                    yOffset = -step;
	                    break;
	                }
	            case e.keyCode == 39:
	                {
	                    // RIGHT
	                    xOffset = step;
	                    break;
	                }
	            case e.keyCode == 40:
	                {
	                    // DOWN
	                    yOffset = step;
	                    break;
	                }
	        }
	
	        var newTopPosition = this.state.gradientTopStartPosition + yOffset;
	        var newLeftPosition = this.state.gradientLeftStartPosition + xOffset;
	
	        var offset = 1;
	        var topValue = -_Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 + offset;
	        var bottomValue = _Properties2.default.RAINBOW_HEIGHT - _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 - offset;
	        var leftValue = -_Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 + offset;
	        var gardientAreaWidth = this.props.accordionWidth - 3 * _Properties2.default.STYLING_LEFT_GAP - _Properties2.default.RAINBOW_WIDTH;
	        var rightValue = gardientAreaWidth - _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2 - offset;
	
	        if (newTopPosition < topValue) newTopPosition = topValue;
	
	        if (newTopPosition > bottomValue) newTopPosition = bottomValue;
	
	        if (newLeftPosition < leftValue) newLeftPosition = leftValue;
	
	        if (newLeftPosition > rightValue) newLeftPosition = rightValue;
	
	        this.refs.colorGradientSelectorButton.style.left = newLeftPosition + 'px';
	        this.refs.colorGradientSelectorButton.style.top = newTopPosition + 'px';
	
	        this.setState({
	            gradientTopStartPosition: newTopPosition,
	            gradientTopCurrentPosition: newTopPosition,
	            gradientLeftStartPosition: newLeftPosition,
	            gradientLeftCurrentPosition: newLeftPosition
	        });
	
	        setTimeout(function () {
	            var color = this.getSelectedColor();
	            this.changeColorProperties(color);
	        }.bind(this), 20);
	    },
	    getSelectedColor: function getSelectedColor() {
	        var canvas = this.refs.colorGradientArea;
	        var ctx = canvas.getContext('2d');
	        var offset = _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 + _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2;
	
	        var xPosition = this.state.gradientLeftCurrentPosition + offset;
	        var yPosition = this.state.gradientTopCurrentPosition + offset;
	
	        if (isNaN(xPosition)) xPosition = canvas.width / 2;else if (xPosition < 0) xPosition = 1;else if (xPosition >= canvas.width) xPosition = canvas.width - 1;
	
	        if (isNaN(yPosition)) yPosition = canvas.height / 2;else if (yPosition < 0) yPosition = 1;else if (yPosition >= canvas.height) yPosition = canvas.height - 1;
	
	        var imageData = ctx.getImageData(xPosition, yPosition, 1, 1);
	        var RGBcolor;
	
	        if (imageData == undefined) return '#ffffff';else {
	            RGBcolor = imageData.data;
	
	            var hexaColor = this.rgbToHex(RGBcolor[0], RGBcolor[1], RGBcolor[2]);
	
	            return hexaColor;
	        }
	    },
	    componentToHex: function componentToHex(c) {
	        var hex = c.toString(16);
	        return hex.length == 1 ? '0' + hex : hex;
	    },
	    rgbToHex: function rgbToHex(r, g, b) {
	        return '#' + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
	    },
	    changeColorProperties: function changeColorProperties(color) {
	        if (this.props.executeCommand) {
	            this.props.executeCommand(15, color);
	            return;
	        }
	
	        var shapeModel = this.props.shapeModel;
	
	        if (!shapeModel) return;
	
	        if (this.props.type == 'textProperties') {
	            this.props.dispatch((0, _CurrentSlideActions.changeTextProperties)(shapeModel, 'fontColor', color));
	        } else {
	            if (this.props.tab == _ModeConstants2.default.LINE_STYLE) {
	                if (shapeModel.stroke != color) this.props.dispatch((0, _CurrentSlideActions.changeShapeStrokeColor)(shapeModel, color));
	            } else {
	                if (shapeModel.fill != color) {
	                    this.props.dispatch((0, _CurrentSlideActions.changeShapeFillColor)(shapeModel, color));
	                    this.props.dispatch((0, _MenuActions.refreshVideoEditor)(Math.random()));
	                }
	            }
	        }
	
	        _AudioEditorUtils2.default.addActionToHistory();
	        _SaveManager2.default.isContentChanged(true);
	
	        this.updateThumbnail();
	    },
	    updateThumbnail: function updateThumbnail() {
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    render: function render() {
	        var colorPickerStyle = {
	            position: 'absolute',
	            top: this.props.topPosition,
	            left: 0,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.RAINBOW_HEIGHT
	        };
	
	        var gradientAreaWidth = this.props.accordionWidth - 3 * _Properties2.default.STYLING_LEFT_GAP - _Properties2.default.RAINBOW_WIDTH;
	
	        var colorGradientStyle = {
	            position: 'absolute',
	            top: 0,
	            left: _Properties2.default.STYLING_LEFT_GAP,
	            width: gradientAreaWidth,
	            height: _Properties2.default.RAINBOW_HEIGHT
	        };
	
	        var colorGradientAreaStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: gradientAreaWidth,
	            height: _Properties2.default.RAINBOW_HEIGHT
	        };
	
	        var colorGradientSelectorButtonStyle = {
	            position: 'absolute',
	            top: _Properties2.default.RAINBOW_HEIGHT / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2,
	            left: gradientAreaWidth / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE / 2 - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2,
	            width: _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE + _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH,
	            height: _Properties2.default.COLOR_GRADIENT_SELECTOR_SIZE + _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH,
	            background: 'none',
	            border: 'none'
	        };
	
	        var colorGradientSelectorStyle = {
	            position: 'absolute',
	            top: _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2,
	            left: _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH / 2,
	            width: colorGradientSelectorButtonStyle.width - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH,
	            height: colorGradientSelectorButtonStyle.height - _Properties2.default.COLOR_GRADIENT_SELECTOR_STROKE_WIDTH
	        };
	
	        var rainbowStyle = {
	            position: 'absolute',
	            top: 0,
	            left: this.props.accordionWidth - _Properties2.default.STYLING_LEFT_GAP - _Properties2.default.RAINBOW_WIDTH,
	            width: _Properties2.default.RAINBOW_WIDTH,
	            height: _Properties2.default.RAINBOW_HEIGHT
	        };
	
	        var rainbowImgStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: _Properties2.default.RAINBOW_WIDTH,
	            height: _Properties2.default.RAINBOW_HEIGHT
	        };
	
	        var thumbBorderSize = 2;
	        var thumbSize = _Properties2.default.RAINBOW_SELECTOR_SIZE - thumbBorderSize;
	        var thumbBorderColor = 'black';
	
	        if (this.state.isThumbOver == true) thumbBorderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	
	        var rainbowSelectorStyle = {
	            position: 'absolute',
	            top: _Properties2.default.RAINBOW_HEIGHT / 2 - thumbSize / 2,
	            left: -thumbSize / 2 + _Properties2.default.RAINBOW_WIDTH / 2 - thumbBorderSize,
	            width: thumbSize,
	            height: thumbSize,
	            background: 'white',
	            borderStyle: 'solid',
	            borderColor: thumbBorderColor,
	            borderWidth: 2,
	            borderRadius: 50,
	            cursor: 'default',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: colorPickerStyle },
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onDrag: this.onGradientSelectorDrag, onStop: this.onGradientSelectorStopped },
	                _react2.default.createElement(
	                    'div',
	                    { ref: 'gradientAreaDiv', style: colorGradientStyle },
	                    _react2.default.createElement('canvas', { ref: 'colorGradientArea', style: colorGradientAreaStyle }),
	                    _react2.default.createElement(
	                        'button',
	                        { 'aria-label': _LocalesManager2.default.getCaption('colorPickerThumb', 'other'), className: 'sliderThumb', style: colorGradientSelectorButtonStyle, onKeyDown: this.onKeyDownOnCanvas, ref: 'colorGradientSelectorButton' },
	                        _react2.default.createElement('canvas', { ref: 'colorGradientSelector', style: colorGradientSelectorStyle })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: rainbowStyle },
	                _react2.default.createElement('canvas', { ref: 'rainbow', style: rainbowImgStyle }),
	                _react2.default.createElement(
	                    _reactDraggable2.default,
	                    { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onSelectorStart, onDrag: this.onSelectorDrag, onStop: this.onSelectorStopped },
	                    _react2.default.createElement('button', { id: this.props.id, 'aria-label': _LocalesManager2.default.getCaption('colorPickerThumb', 'other'), ref: 'rainbowSelector', className: 'sliderThumb', style: rainbowSelectorStyle, onKeyDown: this.onKeyDownRigthRainbow, onMouseOver: this.onThumbMouseIn, onMouseOut: this.onThumbMouseOut })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ColorPicker.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ColorPicker.js"); } } })();

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ContextMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _ObjectContextAdvanced = __webpack_require__(805);
	
	var _AnimationContextMenu = __webpack_require__(774);
	
	var _StylingMenu = __webpack_require__(823);
	
	var _BackgroundVisibilityMenu = __webpack_require__(777);
	
	var _TextStylingMenu = __webpack_require__(826);
	
	var _SaveMenu = __webpack_require__(815);
	
	var _DrawingMenu = __webpack_require__(786);
	
	var _MoodsMenu = __webpack_require__(804);
	
	var _MindMapMenu = __webpack_require__(803);
	
	var _LeftTextMenu = __webpack_require__(796);
	
	var _LeftFreehandMenu = __webpack_require__(793);
	
	var _LeftShapesMenu = __webpack_require__(795);
	
	var _LeftEffectsMenu = __webpack_require__(791);
	
	var _LeftFramesMenu = __webpack_require__(792);
	
	var _LeftMediaMenu = __webpack_require__(794);
	
	var _SizeAndPositionMenu = __webpack_require__(818);
	
	var _TextEditorTool = __webpack_require__(828);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ContextMenuContent = _react2.default.createClass({
	    displayName: 'ContextMenuContent',
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        return;
	        if (nextProps && nextProps.registerUndoRedoAction == true && !_PlayController2.default.isAudioEditorMode()) {
	            _AudioEditorUtils2.default.addActionToHistory();
	        }
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        _AudioUtils2.default.cleanContextSound();
	    },
	    render: function render() {
	        if (!this.props.contextMode || this.props.contextMode == _ModeConstants2.default.CONTEXT_NONE || this.props.contextMode == _ModeConstants2.default.SEARCH_CONTEXT) return _react2.default.createElement('div', null);
	
	        var offset = 0;
	
	        if (this.props.contextMode == _ModeConstants2.default.SEARCH_CONTEXT) {
	            if (_AudioToolUtils2.default.isAudioTool()) offset = 0;else {
	                if (_PlatformDetection2.default.isIOS()) offset = 3 * _Properties2.default.CLIPART_BUTTON_HEIGHT;else offset = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	            }
	        }
	
	        if (this.props.contextMode == _ModeConstants2.default.TEXT || this.props.contextMode == _ModeConstants2.default.FREEHAND || this.props.contextMode == _ModeConstants2.default.SHAPES || this.props.contextMode == _ModeConstants2.default.EFFECTS || this.props.contextMode == _ModeConstants2.default.FRAMES || this.props.contextMode == _ModeConstants2.default.MEDIA) offset = _Properties2.default.SEARCH_HEIGHT();
	
	        offset = offset + _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight();
	
	        var menuStyle = {
	            position: 'absolute',
	            top: offset,
	            right: 0,
	            backgroundColor: 'white',
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight - offset,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            cursor: 'default',
	            zIndex: 15000
	        };
	
	        var menu;
	
	        switch (true) {
	            case this.props.contextMode == _ModeConstants2.default.LINE_CONTEXT || this.props.contextMode == _ModeConstants2.default.FREEHAND_CONTEXT:
	                {
	                    menu = _react2.default.createElement(_DrawingMenu.DrawingMenu, { accordionWidth: this.props.accordionWidth, contextMode: this.props.contextMode, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, groupDrawingShapes: this.props.groupDrawingShapes });
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.OBJECT_CONTEXT_ADVANCED:
	                {
	                    menu = _react2.default.createElement(_ObjectContextAdvanced.ObjectContextAdvanced, { accordionWidth: this.props.accordionWidth, contextMode: this.props.contextMode, contextTarget: this.props.contextTarget, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT:
	                {
	                    menu = _react2.default.createElement(_AnimationContextMenu.AnimationContextMenu, _defineProperty({ accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight, contextMode: this.props.contextMode, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth }, 'windowHeight', this.props.windowHeight));
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.OBJECT_CONTEXT_STYLING || this.props.contextMode == _ModeConstants2.default.SLIDE_CONTEXT_STYLING:
	                {
	                    menu = _react2.default.createElement(_StylingMenu.StylingMenu, { accordionWidth: this.props.accordionWidth, contextMode: this.props.contextMode, contextTarget: this.props.contextTarget, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.OBJECT_TEXT_STYLING:
	                {
	                    menu = _react2.default.createElement(_TextStylingMenu.TextStylingMenu, { contextTarget: this.props.contextTarget, accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.TEXT_EDITOR:
	                {
	                    menu = _react2.default.createElement(_TextEditorTool.TextEditorTool, { contextTarget: this.props.contextTarget, accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.SAVE_CONTEXT:
	                {
	                    menu = _react2.default.createElement(_SaveMenu.SaveMenu, { accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.OBJECT_CONTEXT_MOODS || this.props.contextMode == _ModeConstants2.default.SLIDE_CONTEXT_MOODS:
	                {
	                    var type = 'background';
	
	                    if (this.props.contextMode == _ModeConstants2.default.OBJECT_CONTEXT_MOODS) type = 'character';
	
	                    menu = _react2.default.createElement(_MoodsMenu.MoodsMenu, { accordionWidth: this.props.accordionWidth, type: type, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.MIND_MAP_MENU:
	                {
	                    menu = _react2.default.createElement(_MindMapMenu.MindMapMenu, { accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });
	                    break;
	                }
	            case this.props.contextMode === _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT:
	                {
	                    menu = _react2.default.createElement(_SizeAndPositionMenu.SizeAndPositionMenu, { accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });
	                    break;
	                }
	            case this.props.contextMode === _ModeConstants2.default.SLIDE_VISIBILITY:
	                {
	                    menu = _react2.default.createElement(_BackgroundVisibilityMenu.BackgroundVisibilityMenu, { accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, contextMode: this.props.contextMode });
	                    break;
	                }
	
	            // left menu
	            case this.props.contextMode == _ModeConstants2.default.TEXT:
	                {
	                    menu = _react2.default.createElement(_LeftTextMenu.LeftTextMenu, { accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.FREEHAND:
	                {
	                    menu = _react2.default.createElement(_LeftFreehandMenu.LeftFreehandMenu, { accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.SHAPES:
	                {
	                    menu = _react2.default.createElement(_LeftShapesMenu.LeftShapesMenu, { accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.EFFECTS:
	                {
	                    menu = _react2.default.createElement(_LeftEffectsMenu.LeftEffectsMenu, { accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - offset });
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.FRAMES:
	                {
	                    menu = _react2.default.createElement(_LeftFramesMenu.LeftFramesMenu, { accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - offset });
	                    break;
	                }
	            case this.props.contextMode == _ModeConstants2.default.MEDIA:
	                {
	                    menu = _react2.default.createElement(_LeftMediaMenu.LeftMediaMenu, { accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - offset });
	                    break;
	                }
	        }
	
	        var sound;
	
	        if (!_AudioToolUtils2.default.isAudioTool()) sound = _react2.default.createElement('audio', { id: 'audioBrowserSound', className: 'audioItem', preload: 'auto', playsInline: true });
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            sound,
	            menu
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var contextTarget = state.menu.contextTarget;
	    var registerUndoRedoAction = state.menu.registerUndoRedoAction;
	    var accordionWidth = state.accordion.width;
	    var contextMode = state.menu.contextMode;
	    var groupDrawingShapes = state.menu.groupDrawingShapes;
	    var clipartCategory = state.menu.clipartCategory;
	    var audioTabIndex = state.menu.audioTabIndex;
	    var cartoonistTabIndex = state.menu.cartoonistTabIndex;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    if (clipartCategory == undefined) clipartCategory = 0;
	
	    if (groupDrawingShapes == undefined) groupDrawingShapes = true;
	
	    if (audioTabIndex == undefined) audioTabIndex = 0;
	
	    if (cartoonistTabIndex == undefined) cartoonistTabIndex = 0;
	
	    return {
	        contextTarget: contextTarget,
	        registerUndoRedoAction: registerUndoRedoAction,
	        accordionWidth: accordionWidth,
	        contextMode: contextMode,
	        groupDrawingShapes: groupDrawingShapes,
	        clipartCategory: clipartCategory,
	        audioTabIndex: audioTabIndex,
	        cartoonistTabIndex: cartoonistTabIndex
	    };
	}
	
	var ContextMenu = exports.ContextMenu = (0, _reactRedux.connect)(mapStateToProps)(ContextMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ContextMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ContextMenu.js"); } } })();

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DeleteAlert = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _SlideViewerActions = __webpack_require__(121);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _reactRedux = __webpack_require__(10);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onButtonClick: function onButtonClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.showDeleteTrackAlert) this.deleteTrack();else if (this.props.showAdvancedModeAlert) this.advancedMode();else this.deleteSlideMode();
	    },
	    advancedMode: function advancedMode() {
	        if (this.props.index == 1) {
	            _PlayController2.default.toggleAudioEditorMode(true);
	            _AudioUtils2.default.clearAudioEvents();
	            _AudioEditorUtils2.default.addActionToHistory();
	        }
	
	        this.props.dispatch((0, _MenuActions.showAdvancedModeAlert)(false));
	    },
	    deleteSlideMode: function deleteSlideMode() {
	        if (this.props.index == 1) {
	            //YES, button
	            var state = _StoreManager2.default.getState();
	            var slides = state.production.slides;
	            var newSlideIndex = void 0;
	
	            if (slides.length == 1) {
	                newSlideIndex = 0;
	            } else {
	                if (slides.length - 1 == state.currentSlide.currentSlideIndex) newSlideIndex = state.currentSlide.currentSlideIndex - 1;else newSlideIndex = state.currentSlide.currentSlideIndex;
	            }
	
	            _PlayController2.default.getOldScrollPosition();
	
	            this.props.dispatch((0, _ProductionActions.deleteSlide)());
	            this.props.dispatch((0, _CurrentSlideActions.setCurrentSlide)(newSlideIndex));
	            this.props.dispatch((0, _SlideViewerActions.needsRefresh)(true));
	            _AudioEditorUtils2.default.addActionToHistory();
	            _AudioEditorUtils2.default.checkMarkerPositionForCurrentSlide();
	            _AudioEditorUtils2.default.checkTimelineWidth();
	
	            _PlayController2.default.updateScrollPosition(200, true);
	        }
	
	        this.props.dispatch((0, _MenuActions.showDeleteAlert)(false));
	    },
	    deleteTrack: function deleteTrack() {
	        if (this.props.index == 1) {
	            //YES, button
	            var trackMenuIndex = _AudioEditorUtils2.default.currentTrackMenu;
	
	            if (trackMenuIndex >= 0) this.props.dispatch((0, _AudioEditorActions.deleteTrack)(trackMenuIndex));
	        }
	
	        this.props.dispatch((0, _MenuActions.showDeleteTrackAlert)(false));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver) return true;else return false;
	    },
	    render: function render() {
	        var textColor;
	        var fillColor;
	
	        if (this.state.isOver == true) {
	            fillColor = _Properties2.default.SLIDE_VIEWER_BACKGROUND;
	            textColor = 'black';
	        } else if (this.props.index == 0) {
	            textColor = 'black';
	            fillColor = 'white';
	        } else {
	            textColor = 'white';
	            fillColor = '#444444';
	        }
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: fillColor,
	            width: _Properties2.default.DELETE_ALERT_BUTTON_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT,
	            top: this.props.topPosition,
	            left: this.props.leftPosition,
	            borderRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#333333',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            textAlign: 'left'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 6,
	            fontSize: 16,
	            width: _Properties2.default.DELETE_ALERT_BUTTON_WIDTH - 6,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            alignItems: 'center',
	            textAlign: 'center',
	            cursor: 'default',
	            color: textColor
	        };
	
	        var idValue;
	
	        if (this.props.index == 0) idValue = 'deleteAlertFirstFocusableElement';else idValue = 'deleteAlertLastFocusableElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, 'aria-label': this.props.text, style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onButtonClick, onClick: this.onButtonClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var DeleteAlertContent = _react2.default.createClass({
	    displayName: 'DeleteAlertContent',
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        return true;
	        if (this.props.showDeleteAlert != newProps.showDeleteAlert || this.props.showAdvancedModeAlert != newProps.showAdvancedModeAlert || this.props.showDeleteTrackAlert != newProps.showDeleteTrackAlert || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight) return true;else return false;
	    },
	    render: function render() {
	        var visible = 'none';
	
	        if (this.props.showDeleteAlert == true || this.props.showAdvancedModeAlert == true || this.props.showDeleteTrackAlert == true) visible = 'block';else return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            left: 0,
	            display: visible,
	            zIndex: 20000
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: 0,
	            left: 0,
	            opacity: _Properties2.default.DELETE_ALERT_BACKGROUND_OPACITY
	        };
	
	        var alertHolderStyle = {
	            position: 'absolute',
	            top: this.props.windowHeight / 2 - (_Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT + _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT) / 2,
	            left: this.props.windowWidth / 2 - _Properties2.default.DELETE_ALERT_WIDTH / 2
	        };
	
	        var topBarStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: _Properties2.default.DELETE_ALERT_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT,
	            top: 0,
	            left: 0,
	            borderTopLeftRadius: 3,
	            borderTopRightRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: _Properties2.default.DELETE_ALERT_BACKGROUND
	        };
	
	        var bottomBarStyle = {
	            position: 'absolute',
	            backgroundColor: 'white',
	            width: _Properties2.default.DELETE_ALERT_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT,
	            top: _Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT,
	            left: 0,
	            borderBottomLeftRadius: 3,
	            borderBottomRightRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: 'white'
	        };
	
	        var titleStyle = {
	            position: 'absolute',
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            top: 6,
	            fontSize: 22,
	            width: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            color: 'white'
	        };
	
	        var questionStyle = {
	            position: 'absolute',
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            top: 20,
	            fontSize: 16,
	            width: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            height: _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT - 3 * _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT,
	            cursor: 'default',
	            color: 'black',
	            whiteSpace: 'pre-line'
	        };
	
	        var title = _LocalesManager2.default.getCaption('DeleteAlertTitle', 'deleteAlert');
	        var question = _LocalesManager2.default.getCaption('DeleteAlertQuestion', 'deleteAlert');
	        var cancelCaption = _LocalesManager2.default.getCaption('DeleteAlertCancel', 'deleteAlert');
	        var okCaption = _LocalesManager2.default.getCaption('DeleteAlertYes', 'deleteAlert');
	
	        if (this.props.showAdvancedModeAlert) {
	            title = _LocalesManager2.default.getCaption('AdvancedModeTitle', 'deleteAlert');
	            question = _LocalesManager2.default.getCaption('AdvancedModeQuestion', 'deleteAlert');
	            okCaption = _LocalesManager2.default.getCaption('AdvancedModeYes', 'deleteAlert');
	        } else if (this.props.showDeleteTrackAlert) {
	            title = _LocalesManager2.default.getCaption('DeleteTrackAlertTitle', 'deleteAlert');
	            question = _LocalesManager2.default.getCaption('DeleteTrackAlertQuestion', 'deleteAlert');
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'deleteAlert' },
	            _react2.default.createElement('div', { style: backgroundStyle }),
	            _react2.default.createElement(
	                'div',
	                { style: alertHolderStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: topBarStyle },
	                    _react2.default.createElement(
	                        'span',
	                        { style: titleStyle },
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: bottomBarStyle },
	                    _react2.default.createElement(
	                        'div',
	                        { style: questionStyle },
	                        question
	                    ),
	                    _react2.default.createElement(Button, { showDeleteTrackAlert: this.props.showDeleteTrackAlert, showAdvancedModeAlert: this.props.showAdvancedModeAlert, dispatch: this.props.dispatch, topPosition: _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT - _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT, leftPosition: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP - 2 * _Properties2.default.DELETE_ALERT_BUTTON_WIDTH, index: 0, text: cancelCaption }),
	                    _react2.default.createElement(Button, { showDeleteTrackAlert: this.props.showDeleteTrackAlert, showAdvancedModeAlert: this.props.showAdvancedModeAlert, dispatch: this.props.dispatch, topPosition: _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT - _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT, leftPosition: _Properties2.default.DELETE_ALERT_WIDTH - _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_WIDTH, index: 1, text: okCaption })
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var showDeleteAlert = state.menu.showDeleteAlert;
	    var showAdvancedModeAlert = state.menu.showAdvancedModeAlert;
	    var showDeleteTrackAlert = state.menu.showDeleteTrackAlert;
	
	    return {
	        showDeleteAlert: showDeleteAlert,
	        showAdvancedModeAlert: showAdvancedModeAlert,
	        showDeleteTrackAlert: showDeleteTrackAlert
	    };
	}
	
	var DeleteAlert = exports.DeleteAlert = (0, _reactRedux.connect)(mapStateToProps)(DeleteAlertContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/DeleteAlert.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/DeleteAlert.js"); } } })();

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DescriptionMenu = exports.DescriptionMenuContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DescriptionMenuContent = exports.DescriptionMenuContent = _react2.default.createClass({
	    displayName: 'DescriptionMenuContent',
	    removeLink: function removeLink(description) {
	        if (!description) return '';
	
	        var index = description.indexOf('<a href=');
	
	        if (index != -1) {
	            description = description.substring(0, index);
	
	            index = description.indexOf('<br');
	
	            if (index != -1) description = description.substring(0, index);
	        }
	
	        return description;
	    },
	    render: function render() {
	        if (!this.props.showDescription) return _react2.default.createElement('div', null);
	
	        var width = 600;
	        var height = 250;
	        var center = (this.props.windowWidth - _Properties2.default.BROWSER_WIDTH) / 2;
	        var leftPosition = center - width / 2;
	        var topPosition = _Properties2.default.CLIPART_BUTTON_HEIGHT_OLD + _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight();
	
	        var menuStyle = {
	            position: 'absolute',
	            left: leftPosition,
	            top: topPosition + 12,
	            width: width,
	            height: height,
	            background: '#fafafa',
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            borderRadius: 20
	        };
	
	        var stemSize = _Properties2.default.RECORD_TOOLTIP_STEM_SIZE;
	
	        var stemStyle = {
	            position: 'absolute',
	            top: -2 * stemSize,
	            left: width / 2 - stemSize,
	            borderStyle: 'solid',
	            borderWidth: stemSize,
	            borderBottomColor: '#fafafa',
	            borderTopColor: 'transparent',
	            borderLeftColor: 'transparent',
	            borderRightColor: 'transparent'
	        };
	
	        var verticalGap = 50;
	        var horizontalGap = 10;
	
	        //thumb size 512x384
	        var thumbnailSrc = '/file/ci/' + _AppParameters2.default.navBarThumbnailId + '/thumb';
	        var thumbHeight = height - 2 * verticalGap;
	        var thumbWidth = thumbHeight * 512 / 384;
	
	        var titleStyle = {
	            position: 'absolute',
	            top: 20,
	            left: horizontalGap,
	            color: _Properties2.default.BROWSER_SELECTED_COLOR,
	            fontSize: 17,
	            fontWeight: 'bold',
	            width: width - thumbWidth - 3 * horizontalGap,
	            textAlign: 'left',
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var descriptionStyle = {
	            position: 'absolute',
	            top: 50,
	            left: horizontalGap,
	            color: _Properties2.default.BROWSER_SELECTED_COLOR,
	            fontSize: 12,
	            width: width - thumbWidth - 3 * horizontalGap,
	            height: height - 50 - 20,
	            textAlign: 'left',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var thumbnailStyle = {
	            position: 'absolute',
	            top: verticalGap,
	            right: horizontalGap,
	            width: thumbWidth,
	            height: thumbHeight
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'describeItem', style: menuStyle },
	            _react2.default.createElement('div', { className: 'describeItem', style: stemStyle }),
	            _react2.default.createElement(
	                'span',
	                { className: 'describeItem', style: titleStyle },
	                _AppParameters2.default.navBarTitle
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'describeItem', style: descriptionStyle },
	                this.removeLink(_AppParameters2.default.navBarDescription)
	            ),
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', className: 'describeItem', style: thumbnailStyle, src: thumbnailSrc })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var showDescription = state.menu.showDescription;
	
	    if (showDescription == undefined) showDescription = false;
	
	    return {
	        showDescription: showDescription
	    };
	}
	
	var DescriptionMenu = exports.DescriptionMenu = (0, _reactRedux.connect)(mapStateToProps)(DescriptionMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/DescriptionMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/DescriptionMenu.js"); } } })();

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ExitAlert = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _RecordedSoundUploadingUtils = __webpack_require__(242);
	
	var _RecordedSoundUploadingUtils2 = _interopRequireDefault(_RecordedSoundUploadingUtils);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onButtonClick: function onButtonClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.index == 1) {
	            //YES, button
	            var href = _SaveManager2.default.hrefLocationForIOS;
	
	            if (href.length > 0) window.location.href = href;
	        } else {
	            this.props.dispatch((0, _MenuActions.exitAlert)(false));
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver) return true;else return false;
	    },
	    render: function render() {
	        var textColor;
	        var fillColor;
	
	        if (this.state.isOver == true) {
	            fillColor = _Properties2.default.SLIDE_VIEWER_BACKGROUND;
	            textColor = 'black';
	        } else if (this.props.index == 0) {
	            textColor = 'black';
	            fillColor = 'white';
	        } else {
	            textColor = 'white';
	            fillColor = _Properties2.default.DELETE_ALERT_BACKGROUND;
	        }
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: fillColor,
	            width: _Properties2.default.DELETE_ALERT_BUTTON_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT,
	            top: this.props.topPosition,
	            left: this.props.leftPosition,
	            borderRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#333333'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 7,
	            fontSize: 16,
	            width: _Properties2.default.DELETE_ALERT_BUTTON_WIDTH - 6,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            alignItems: 'center',
	            textAlign: 'center',
	            cursor: 'default',
	            color: textColor
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onButtonClick, onClick: this.onButtonClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var ExitAlertContent = _react2.default.createClass({
	    displayName: 'ExitAlertContent',
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.exitAlert != newProps.exitAlert || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight) return true;else return false;
	    },
	    render: function render() {
	        if (!this.props.exitAlert) return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            left: 0,
	            zIndex: 20000
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: 0,
	            left: 0,
	            opacity: _Properties2.default.DELETE_ALERT_BACKGROUND_OPACITY
	        };
	
	        var alertHolderStyle = {
	            position: 'absolute',
	            top: this.props.windowHeight / 2 - _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT / 2,
	            left: this.props.windowWidth / 2 - _Properties2.default.DELETE_ALERT_WIDTH / 2
	        };
	
	        var bottomHeight = _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT - 100;
	        var bottomBarStyle = {
	            position: 'absolute',
	            backgroundColor: 'white',
	            width: _Properties2.default.DELETE_ALERT_WIDTH,
	            height: bottomHeight,
	            borderBottomLeftRadius: 3,
	            borderBottomRightRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: 'white'
	        };
	
	        var questionStyle = {
	            position: 'absolute',
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            top: 20,
	            fontSize: 16,
	            width: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            height: _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT - 3 * _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT,
	            cursor: 'default',
	            color: 'black',
	            whiteSpace: 'pre-line'
	        };
	
	        var alertMessage;
	
	        if (_RecordedSoundUploadingUtils2.default.isUploadingCurrentSound) alertMessage = _LocalesManager2.default.getCaption('ExitAlertUnsavedRecording', 'other');else alertMessage = _LocalesManager2.default.getCaption('ExitAlert', 'other');
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement('div', { style: backgroundStyle }),
	            _react2.default.createElement(
	                'div',
	                { style: alertHolderStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: bottomBarStyle },
	                    _react2.default.createElement(
	                        'div',
	                        { style: questionStyle },
	                        alertMessage
	                    ),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, topPosition: bottomHeight - _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT, leftPosition: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP - 2 * _Properties2.default.DELETE_ALERT_BUTTON_WIDTH, index: 0, text: _LocalesManager2.default.getCaption('DeleteAlertCancel', 'deleteAlert') }),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, topPosition: bottomHeight - _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT, leftPosition: _Properties2.default.DELETE_ALERT_WIDTH - _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_WIDTH, index: 1, text: _LocalesManager2.default.getCaption('Yes', 'other') })
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var exitAlert = state.menu.exitAlert;
	
	    if (exitAlert == undefined) exitAlert = false;
	
	    return {
	        exitAlert: exitAlert
	    };
	}
	
	var ExitAlert = exports.ExitAlert = (0, _reactRedux.connect)(mapStateToProps)(ExitAlertContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ExitAlert.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ExitAlert.js"); } } })();

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ExportAlert = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ExporterUtils = __webpack_require__(93);
	
	var _ExporterUtils2 = _interopRequireDefault(_ExporterUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            contentItemId: _AppParameters2.default.contentItemId,
	            isOver: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (this.props.index == 1) _SaveManager2.default.refreshExportButton = this.refreshExportButton;
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onButtonClick: function onButtonClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _SaveManager2.default.resetAutosave();
	        _SaveManager2.default.saveData();
	
	        if (this.props.index == 1) {
	            //YES, button
	            if (_AppParameters2.default.contentItemId > 0) {
	                _ExporterUtils2.default.startExport();
	                this.props.dispatch((0, _MenuActions.showExportAlert)(false));
	            }
	        } else {
	            this.props.dispatch((0, _MenuActions.showExportAlert)(false));
	        }
	    },
	    refreshExportButton: function refreshExportButton() {
	        if (this.props.index != 1) return;
	
	        _SaveManager2.default.refreshExportButton = undefined;
	
	        this.setState({
	            contentItemId: _AppParameters2.default.contentItemId
	        });
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.index == 1 && this.state.contentItemId == -1 && _AppParameters2.default.contentItemId > 0) return true;
	
	        if (this.state.isOver != nextState.isOver) return true;else return false;
	    },
	    render: function render() {
	        var textColor;
	        var fillColor;
	        var opacity = 1;
	        var tabIndexValue;
	
	        if (this.props.index == 1 && _AppParameters2.default.contentItemId < 0) {
	            opacity = 0.5;
	            tabIndexValue = '-1';
	        }
	
	        if (this.state.isOver == true) {
	            if (opacity == 0.5) {
	                textColor = 'white';
	                fillColor = _Properties2.default.DELETE_ALERT_BACKGROUND;
	            } else {
	                fillColor = _Properties2.default.SLIDE_VIEWER_BACKGROUND;
	                textColor = 'black';
	            }
	        } else if (this.props.index == 0) {
	            textColor = 'black';
	            fillColor = 'white';
	        } else {
	            textColor = 'white';
	            fillColor = '#555555';
	        }
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: fillColor,
	            width: _Properties2.default.DELETE_ALERT_BUTTON_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT,
	            top: this.props.topPosition,
	            left: this.props.leftPosition,
	            borderRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#333333',
	            opacity: opacity,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            textAlign: 'left'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 6,
	            fontSize: 16,
	            width: _Properties2.default.DELETE_ALERT_BUTTON_WIDTH - 6,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            alignItems: 'center',
	            textAlign: 'center',
	            cursor: 'default',
	            color: textColor
	        };
	
	        var idValue;
	
	        if (this.props.index == 0) idValue = 'exportFirstFocusableButton';else idValue = 'exportLastFocusableButton';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, tabIndex: tabIndexValue, 'aria-disabled': tabIndexValue == '-1' ? true : false, 'aria-label': this.props.text, style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onButtonClick, onClick: this.onButtonClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var CheckBox = _react2.default.createClass({
	    displayName: 'CheckBox',
	    onCheckBoxClick: function onCheckBoxClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var exportProperties = this.props.exportProperties;
	
	        if (!exportProperties) {
	            exportProperties = {};
	
	            exportProperties.addKenBurns = false;
	            exportProperties.addTransitions = false;
	            exportProperties.useCrossFade = false;
	            exportProperties.useRandom = false;
	        }
	
	        var isSelected = this.isSelected();
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    exportProperties.addKenBurns = !isSelected;
	                    break;
	                }
	            case 1:
	                {
	                    exportProperties.addTransitions = !isSelected;
	                    break;
	                }
	            case 2:
	                {
	                    if (!isSelected) {
	                        exportProperties.useCrossFade = true;
	                        exportProperties.useRandom = false;
	                    }
	                    break;
	                }
	            case 3:
	                {
	                    if (!isSelected) {
	                        exportProperties.useCrossFade = false;
	                        exportProperties.useRandom = true;
	                    }
	                    break;
	                }
	        }
	
	        if (exportProperties.addTransitions && !exportProperties.useCrossFade && !exportProperties.useRandom) exportProperties.useCrossFade = true;
	
	        this.props.dispatch((0, _ProductionActions.setExportProperties)(exportProperties));
	        _SaveManager2.default.isContentChanged(true);
	    },
	    isSelected: function isSelected() {
	        var exportProperties = this.props.exportProperties;
	
	        if (exportProperties) {
	            switch (this.props.index) {
	                case 0:
	                    {
	                        return exportProperties.addKenBurns;
	                    }
	                case 1:
	                    {
	                        return exportProperties.addTransitions;
	                    }
	                case 2:
	                    {
	                        return exportProperties.useCrossFade;
	                    }
	                case 3:
	                    {
	                        return exportProperties.useRandom;
	                    }
	            }
	        } else return false;
	    },
	    render: function render() {
	        var checkBoxSize = 18;
	        var yGap = checkBoxSize + 17;
	        var xGap = this.props.index == 2 || this.props.index == 3 ? 40 : 0;
	        var holderStyle = {
	            position: 'absolute',
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP + xGap,
	            top: this.props.top + yGap * this.props.index
	        };
	
	        var checkBoxStyle = {
	            position: 'absolute',
	            width: checkBoxSize,
	            height: checkBoxSize,
	            top: 0,
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            borderRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none'
	        };
	
	        var selectorStyle = {
	            position: 'absolute',
	            width: 10,
	            height: 10,
	            top: checkBoxSize / 2 - 10 / 2,
	            left: checkBoxSize / 2 - 10 / 2,
	            background: _Properties2.default.DELETE_ALERT_BACKGROUND
	        };
	
	        if (this.isSelected()) selectorStyle.display = 'block';else selectorStyle.display = 'none';
	
	        var questionStyle = {
	            position: 'absolute',
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP + checkBoxSize + 15,
	            top: 2,
	            fontSize: 16,
	            width: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            height: 70,
	            cursor: 'default',
	            color: 'black',
	            whiteSpace: 'pre-line'
	        };
	
	        if (this.props.index == 2 || this.props.index == 3) {
	            if (this.props.exportProperties && this.props.exportProperties.addTransitions) holderStyle.display = 'block';else holderStyle.display = 'none';
	        } else holderStyle.display = 'block';
	
	        var idValue;
	
	        if (this.props.index == 0) idValue = 'exportFirstFocusableCheckBox';
	
	        return _react2.default.createElement(
	            'div',
	            { style: holderStyle },
	            _react2.default.createElement(
	                'button',
	                { id: idValue, 'aria-label': this.props.text, style: checkBoxStyle, onTouchEnd: this.onCheckBoxClick, onClick: this.onCheckBoxClick },
	                _react2.default.createElement('div', { style: selectorStyle })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: questionStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var ExportAlertContent = _react2.default.createClass({
	    displayName: 'ExportAlertContent',
	    render: function render() {
	        var visible = 'none';
	
	        if (this.props.showExportAlert == true) visible = 'block';else return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            left: 0,
	            display: visible,
	            zIndex: 20000
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: 0,
	            left: 0,
	            opacity: _Properties2.default.DELETE_ALERT_BACKGROUND_OPACITY
	        };
	
	        var alertHolderStyle = {
	            position: 'absolute',
	            top: this.props.windowHeight / 2 - (_Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT + _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT) / 2,
	            left: this.props.windowWidth / 2 - _Properties2.default.DELETE_ALERT_WIDTH / 2
	        };
	
	        var topBarStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: _Properties2.default.DELETE_ALERT_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT,
	            top: 0,
	            left: 0,
	            borderTopLeftRadius: 3,
	            borderTopRightRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: _Properties2.default.DELETE_ALERT_BACKGROUND
	        };
	
	        var bottomBarStyle = {
	            position: 'absolute',
	            backgroundColor: 'white',
	            width: _Properties2.default.DELETE_ALERT_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT,
	            top: _Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT,
	            left: 0,
	            borderBottomLeftRadius: 3,
	            borderBottomRightRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: 'white'
	        };
	
	        var titleStyle = {
	            position: 'absolute',
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            top: 6,
	            fontSize: 22,
	            width: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            color: 'white'
	        };
	
	        var questionStyle = {
	            position: 'absolute',
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            top: 20,
	            fontSize: 16,
	            width: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            height: 70,
	            cursor: 'default',
	            color: 'black',
	            whiteSpace: 'pre-line'
	        };
	
	        var topCheckBox = questionStyle.top + questionStyle.height + 10;
	
	        var effectsHolderStyle = {
	            display: 'block'
	        };
	
	        if (_AudioToolUtils2.default.isAudioTool()) {
	            effectsHolderStyle.display = 'none';
	        }
	
	        var title = _LocalesManager2.default.getCaption('ExportAlertTitle', 'exportAlert');
	
	        if (_AudioToolUtils2.default.isAudioTool()) title = title.replace('MP4', 'MP3');
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'exportPopup' },
	            _react2.default.createElement('div', { style: backgroundStyle }),
	            _react2.default.createElement(
	                'div',
	                { style: alertHolderStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: topBarStyle },
	                    _react2.default.createElement(
	                        'span',
	                        { style: titleStyle },
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: bottomBarStyle },
	                    _react2.default.createElement(
	                        'div',
	                        { style: questionStyle },
	                        _LocalesManager2.default.getCaption('ExportAlertInfo', 'exportAlert')
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: effectsHolderStyle },
	                        _react2.default.createElement(CheckBox, { top: topCheckBox, text: _LocalesManager2.default.getCaption('useKenBurns', 'export'), index: 0, dispatch: this.props.dispatch, exportProperties: this.props.exportProperties }),
	                        _react2.default.createElement(CheckBox, { top: topCheckBox, text: _LocalesManager2.default.getCaption('addTransitions', 'export'), index: 1, dispatch: this.props.dispatch, exportProperties: this.props.exportProperties }),
	                        _react2.default.createElement(CheckBox, { top: topCheckBox, text: _LocalesManager2.default.getCaption('useCrossFade', 'export'), index: 2, dispatch: this.props.dispatch, exportProperties: this.props.exportProperties }),
	                        _react2.default.createElement(CheckBox, { top: topCheckBox, text: _LocalesManager2.default.getCaption('useRandom', 'export'), index: 3, dispatch: this.props.dispatch, exportProperties: this.props.exportProperties })
	                    ),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, topPosition: _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT - _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT, leftPosition: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP - 2 * _Properties2.default.DELETE_ALERT_BUTTON_WIDTH, index: 0, text: _LocalesManager2.default.getCaption('DeleteAlertCancel', 'deleteAlert') }),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, topPosition: _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT - _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT, leftPosition: _Properties2.default.DELETE_ALERT_WIDTH - _Properties2.default.DELETE_ALERT_BUTTON_GAP - _Properties2.default.DELETE_ALERT_BUTTON_WIDTH, index: 1, text: _LocalesManager2.default.getCaption('Export', 'exportAlert') })
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var showExportAlert = state.menu.showExportAlert;
	    var exportProperties = state.production.exportProperties;
	    var refresh = Math.random();
	
	    return {
	        showExportAlert: showExportAlert,
	        exportProperties: exportProperties,
	        refresh: refresh
	    };
	}
	
	var ExportAlert = exports.ExportAlert = (0, _reactRedux.connect)(mapStateToProps)(ExportAlertContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ExportAlert.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ExportAlert.js"); } } })();

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LostSessionAlert = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ResumeSessionUtils = __webpack_require__(372);
	
	var _ResumeSessionUtils2 = _interopRequireDefault(_ResumeSessionUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LostSessionAlertContent = _react2.default.createClass({
	    displayName: 'LostSessionAlertContent',
	    onClose: function onClose(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _ApiServiceUtils2.default.showLostSessionAlert(false);
	    },
	    checkApp: function checkApp() {
	        // added for NCA-101
	        if (_PlatformDetection2.default.isIOSApp() && this.props.showLostSessionAlert > 0 && this.props.showLostSessionAlert < 5) {
	            _ResumeSessionUtils2.default.resumeSession();
	        }
	    },
	    getAlertMessage: function getAlertMessage() {
	        var alertMessage = _LocalesManager2.default.getCaption('LostSessionAlert', 'other');
	
	        switch (this.props.showLostSessionAlert) {
	            case 1:
	                {
	                    // Lost sesssion ... default message
	                    alertMessage = _LocalesManager2.default.getCaption('LostSessionAlert', 'other');
	                    break;
	                }
	
	            case 2:
	                {
	                    // Bad Json data
	                    alertMessage = _LocalesManager2.default.getCaption('BadDataAlert', 'other');
	                    break;
	                }
	
	            case 3:
	                {
	                    // Exception during storing flow
	                    alertMessage = _LocalesManager2.default.getCaption('StoringServerErrorAlert', 'other');
	                    break;
	                }
	
	            case 4:
	                {
	                    // Exception on storing success response
	                    alertMessage = _LocalesManager2.default.getCaption('StoringBadResponseAlert', 'other');
	                    break;
	                }
	        }
	
	        return alertMessage;
	    },
	    isVisible: function isVisible() {
	        if (_PlatformDetection2.default.isIOSApp()) return false;
	
	        if (this.props.showLostSessionAlert > 0 && this.props.showLostSessionAlert < 5) // 5 is for NoInternetConnection
	            return true;else return false;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.showLostSessionAlert != newProps.showLostSessionAlert || this.props.windowHeight != newProps.windowHeight || this.props.windowWidth != newProps.windowWidth) return true;else return false;
	    },
	    render: function render() {
	        this.checkApp();
	
	        var visible = 'none';
	
	        if (this.isVisible()) visible = 'block';else return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            left: 0,
	            display: visible,
	            userSelect: 'none',
	            zIndex: 20000
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: 0,
	            left: 0,
	            opacity: _Properties2.default.DELETE_ALERT_BACKGROUND_OPACITY
	        };
	
	        var alertHeight = 250;
	        var alertHolderStyle = {
	            position: 'absolute',
	            top: this.props.windowHeight / 2 - _Properties2.default.DELETE_ALERT_BOTTOM_BAR_HEIGHT / 2,
	            left: this.props.windowWidth / 2 - _Properties2.default.DELETE_ALERT_WIDTH / 2,
	            width: _Properties2.default.DELETE_ALERT_WIDTH,
	            height: alertHeight,
	            backgroundColor: 'white',
	            border: 3,
	            borderStyle: 'solid',
	            borderWidth: 10,
	            borderColor: 'darkslategrey'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            left: _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            top: 25,
	            fontSize: 16,
	            fontStyle: 'italic',
	            width: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            height: alertHeight - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            cursor: 'default',
	            color: 'black',
	            whiteSpace: 'pre-line',
	            textAlign: 'center'
	        };
	
	        var cancelStyle = {
	            position: 'absolute',
	            left: 3 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            top: alertHeight - 40,
	            fontSize: 16,
	            fontWeight: 'bold',
	            width: _Properties2.default.DELETE_ALERT_WIDTH - 6 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            height: 30,
	            color: 'chocolate',
	            whiteSpace: 'pre-line',
	            textAlign: 'center',
	            cursor: 'pointer',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            width: 60,
	            height: 60,
	            left: _Properties2.default.DELETE_ALERT_WIDTH / 2 - 30,
	            top: alertHeight - 115
	        };
	
	        var alertMessage = this.getAlertMessage();
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'lostSessionAlert' },
	            _react2.default.createElement('div', { style: backgroundStyle }),
	            _react2.default.createElement(
	                'div',
	                { style: alertHolderStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: spanStyle },
	                    alertMessage
	                ),
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/error.png' }),
	                _react2.default.createElement(
	                    'button',
	                    { id: 'lostSessionAlertButton', 'aria-label': _LocalesManager2.default.getCaption('Continue', 'other'), style: cancelStyle, onTouchEnd: this.onClose, onClick: this.onClose },
	                    _LocalesManager2.default.getCaption('Continue', 'other')
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var showLostSessionAlert = state.menu.showLostSessionAlert;
	
	    return {
	        showLostSessionAlert: showLostSessionAlert
	    };
	}
	
	var LostSessionAlert = exports.LostSessionAlert = (0, _reactRedux.connect)(mapStateToProps)(LostSessionAlertContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LostSessionAlert.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LostSessionAlert.js"); } } })();

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NavigationBar = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _RecordedSoundUploadingUtils = __webpack_require__(242);
	
	var _RecordedSoundUploadingUtils2 = _interopRequireDefault(_RecordedSoundUploadingUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var hostName = 'https://stage.creaza.com';
	        var hrefLocation = '';
	
	        if (_Configuration2.default.IS_PROD()) hostName = 'https://www.creaza.com';
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Tools
	                    hrefLocation = hostName + '/home/tools';
	                    break;
	                }
	
	            case 1:
	                {
	                    // Activities
	                    hrefLocation = hostName + '/home/exercises';
	                    break;
	                }
	
	            case 2:
	                {
	                    // Portfolio
	                    hrefLocation = hostName + '/portfolio#/myWork';
	                    break;
	                }
	        }
	
	        if (_RecordedSoundUploadingUtils2.default.isContentChanged()) {
	            _SaveManager2.default.hrefLocationForIOS = hrefLocation;
	
	            var store = _StoreManager2.default.getStore();
	            store.dispatch((0, _MenuActions.exitAlert)(true));
	        } else {
	            window.location.href = hrefLocation;
	        }
	    },
	    getCaption: function getCaption() {
	        var caption;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Tools
	                    caption = _LocalesManager2.default.getCaption('Tools', 'other');
	                    break;
	                }
	
	            case 1:
	                {
	                    // Activities
	                    caption = _LocalesManager2.default.getCaption('Activities', 'other');
	                    break;
	                }
	
	            case 2:
	                {
	                    // Portfolio
	                    caption = _LocalesManager2.default.getCaption('MyCreaza', 'other');
	                    break;
	                }
	        }
	
	        return caption;
	    },
	    getLeftPos: function getLeftPos(buttonWidth) {
	        var position;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Tools
	                    position = 0;
	                    break;
	                }
	
	            case 1:
	                {
	                    // Activities
	                    position = buttonWidth;
	                    break;
	                }
	
	            case 2:
	                {
	                    // Portfolio
	                    position = this.props.windowWidth - _Properties2.default.BROWSER_WIDTH - _Properties2.default.INSERT_MENU_BUTTON_SIZE - buttonWidth;
	                    break;
	                }
	        }
	
	        return position;
	    },
	    render: function render() {
	        var describeBoxWidth = _Properties2.default.DESCRIBE_BOX_WIDTH;
	        var freeLeftArea = (this.props.windowWidth - _Properties2.default.BROWSER_WIDTH) / 2 - describeBoxWidth / 2;
	        var width = freeLeftArea / 2;
	        var height = _Properties2.default.CLIPART_BUTTON_HEIGHT_OLD;
	        var leftPos = this.getLeftPos(width);
	
	        var buttonStyle = {
	            position: 'absolute',
	            left: leftPos,
	            top: 0,
	            width: width,
	            height: height,
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none'
	        };
	
	        var textAlignment = 'center';
	
	        if (this.props.index == 1) textAlignment = 'left';
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 11,
	            color: _Properties2.default.BROWSER_SELECTED_COLOR,
	            fontSize: 15,
	            fontWeight: 'bold',
	            width: width,
	            textAlign: textAlignment,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.getCaption()
	            )
	        );
	    }
	});
	
	var DescribeBox = _react2.default.createClass({
	    displayName: 'DescribeBox',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var store = _StoreManager2.default.getStore();
	        var state = _StoreManager2.default.getState();
	        var showDescriptionValue = !state.menu.showDescription;
	
	        store.dispatch((0, _MenuActions.showDescription)(showDescriptionValue));
	    },
	    render: function render() {
	        var buttonWidth = 35;
	        var width = _Properties2.default.DESCRIBE_BOX_WIDTH;
	        var height = _Properties2.default.CLIPART_BUTTON_HEIGHT_OLD;
	        var leftPos = (this.props.windowWidth - _Properties2.default.BROWSER_WIDTH) / 2 - width / 2;
	
	        var buttonStyle = {
	            position: 'absolute',
	            left: leftPos,
	            top: 0,
	            width: width,
	            height: height,
	            background: _Properties2.default.BROWSER_SELECTED_COLOR,
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 11,
	            color: 'white',
	            fontWeight: 'bold',
	            fontSize: 15,
	            width: width - buttonWidth,
	            textAlign: 'center',
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var eyeButton = {
	            position: 'absolute',
	            left: width - buttonWidth,
	            top: 0,
	            width: buttonWidth,
	            height: height
	        };
	
	        var eyeIcon = {
	            position: 'absolute',
	            top: 10,
	            left: 4,
	            color: 'white'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'describeItem', style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick },
	            _react2.default.createElement(
	                'span',
	                { className: 'describeItem', style: spanStyle },
	                _AppParameters2.default.navBarTitle
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'describeItem', style: eyeButton },
	                _react2.default.createElement('i', { style: eyeIcon, className: 'fa fa-eye' })
	            )
	        );
	    }
	});
	
	var NavigationBar = exports.NavigationBar = _react2.default.createClass({
	    displayName: 'NavigationBar',
	    render: function render() {
	        var width = this.props.windowWidth;
	        var height = _Properties2.default.CLIPART_BUTTON_HEIGHT_OLD;
	        var topBarHeight = _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight();
	
	        var buttonStyle = {
	            position: 'absolute',
	            left: 0,
	            top: topBarHeight,
	            width: width,
	            height: height,
	            background: '#BDC5C8',
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none'
	        };
	
	        var buttons = [];
	
	        buttons.push(_react2.default.createElement(Button, { index: 0, windowWidth: this.props.windowWidth, key: 'navBar1' }));
	        buttons.push(_react2.default.createElement(Button, { index: 1, windowWidth: this.props.windowWidth, key: 'navBar2' }));
	        buttons.push(_react2.default.createElement(Button, { index: 2, windowWidth: this.props.windowWidth, key: 'navBar3' }));
	        buttons.push(_react2.default.createElement(DescribeBox, { windowWidth: this.props.windowWidth, key: 'navBar4' }));
	
	        return _react2.default.createElement(
	            'div',
	            { style: buttonStyle },
	            buttons
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/NavigationBar.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/NavigationBar.js"); } } })();

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NoInternetConnectionAlert = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoInternetConnectionAlertContent = _react2.default.createClass({
	    displayName: 'NoInternetConnectionAlertContent',
	    isVisible: function isVisible() {
	        if (this.props.showLostSessionAlert == 5) return true;else return false;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.showLostSessionAlert != newProps.showLostSessionAlert || this.props.windowHeight != newProps.windowHeight || this.props.windowWidth != newProps.windowWidth) return true;else return false;
	    },
	    render: function render() {
	        var visible = 'none';
	
	        if (this.isVisible()) visible = 'block';else return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.windowWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            background: '#e9ff48',
	            top: 0,
	            left: 0,
	            display: visible,
	            userSelect: 'none',
	            cursor: 'default',
	            fontSize: 16,
	            fontStyle: 'italic',
	            textAlign: 'center',
	            color: 'black',
	            zIndex: 20000
	        };
	
	        var iStyle = {
	            color: 'black',
	            paddingLeft: 10,
	            paddingRight: 10,
	            paddingTop: 10
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement('i', { style: iStyle, className: 'fa fa-exclamation-triangle fa-1x' }),
	            _LocalesManager2.default.getCaption('InternetConnectionAlert', 'other'),
	            _react2.default.createElement('i', { style: iStyle, className: 'fa fa-exclamation-triangle fa-1x' })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var showLostSessionAlert = state.menu.showLostSessionAlert;
	
	    return {
	        showLostSessionAlert: showLostSessionAlert
	    };
	}
	
	var NoInternetConnectionAlert = exports.NoInternetConnectionAlert = (0, _reactRedux.connect)(mapStateToProps)(NoInternetConnectionAlertContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/NoInternetConnectionAlert.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/NoInternetConnectionAlert.js"); } } })();

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ProductTitleAlert = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _HelpUtils = __webpack_require__(172);
	
	var _HelpUtils2 = _interopRequireDefault(_HelpUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        _HelpUtils2.default.closeTitleAlert = this.closeTitleAlert;
	
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onButtonClick: function onButtonClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.closeTitleAlert();
	    },
	    closeTitleAlert: function closeTitleAlert() {
	        var titleInput = document.getElementById('productionInitialTitle');
	
	        if (titleInput && titleInput.value.length > 0) _AppParameters2.default.title = titleInput.value;
	
	        _HelpUtils2.default.initialTitleChecked = true;
	        _HelpUtils2.default.titleAlertVisible = false;
	
	        if (this.props.refreshContent) this.props.refreshContent();
	    },
	    render: function render() {
	        var textColor;
	        var fillColor;
	
	        if (this.state.isOver == true) {
	            fillColor = _Properties2.default.SLIDE_VIEWER_BACKGROUND;
	            textColor = 'black';
	        } else {
	            textColor = 'black';
	            fillColor = '#f2f2f2';
	        }
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: fillColor,
	            width: _Properties2.default.DELETE_ALERT_BUTTON_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT,
	            top: this.props.topPosition,
	            left: this.props.leftPosition,
	            borderRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#333333'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 6,
	            fontSize: 16,
	            width: _Properties2.default.DELETE_ALERT_BUTTON_WIDTH - 6,
	            whiteSpace: 'nowrap',
	            display: 'block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            alignItems: 'center',
	            textAlign: 'center',
	            cursor: 'default',
	            color: textColor
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': this.props.text, 'data-dismiss': 'modal', id: 'productionInitialTitleButton', style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onButtonClick, onClick: this.onButtonClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var ProductTitleAlert = exports.ProductTitleAlert = _react2.default.createClass({
	    displayName: 'ProductTitleAlert',
	    getInitialState: function getInitialState() {
	        this.changeSelection();
	
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onInputClick: function onInputClick() {
	        this.changeFocus();
	    },
	    changeFocus: function changeFocus() {
	        var view = this.refs.productionTitle;
	
	        if (view) view.focus();
	    },
	    refresh: function refresh() {
	        this.forceUpdate();
	    },
	    getDefaultTitle: function getDefaultTitle() {
	        if (_AppParameters2.default.title == _AppParameters2.default.defaultTitle) {
	            var date = new Date();
	            var title = '';
	
	            if (_AppParameters2.default.title == 'Cartoonist') title = title + 'Cartoonist (';else title = title + 'AudioEditor (';
	
	            title = title + date.getFullYear() + '.';
	
	            if (date.getMonth() + 1 > 9) title = title + (date.getMonth() + 1) + '.';else title = title + '0' + (date.getMonth() + 1) + '.';
	
	            if (date.getDate() > 9) title = title + date.getDate() + ')';else title = title + '0' + date.getDate() + ')';
	
	            return title;
	        } else return _AppParameters2.default.title;
	    },
	    changeSelection: function changeSelection() {
	        if (_PlatformDetection2.default.isIOSApp()) return;
	
	        setTimeout(function () {
	            if (this.refs.productionTitle) {
	                this.refs.productionTitle.focus();
	                this.refs.productionTitle.setSelectionRange(0, 100);
	            }
	        }.bind(this), 100);
	    },
	    render: function render() {
	        var visible = 'none';
	
	        if (!_HelpUtils2.default.initialTitleChecked && _AppParameters2.default.isMaster && !_Configuration2.default.LOAD_LOCAL) visible = 'block';else return _react2.default.createElement('div', null);
	
	        _HelpUtils2.default.titleAlertVisible = true;
	
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            left: 0,
	            display: visible,
	            zIndex: 20000
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: 0,
	            left: 0,
	            opacity: _Properties2.default.DELETE_ALERT_BACKGROUND_OPACITY
	        };
	
	        var bottomBarHeight = 120;
	        var alertHolderStyle = {
	            position: 'absolute',
	            top: 200,
	            left: this.props.windowWidth / 2 - _Properties2.default.DELETE_ALERT_WIDTH / 2
	        };
	
	        var topBarStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: _Properties2.default.DELETE_ALERT_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT,
	            top: 0,
	            left: 0,
	            borderTopLeftRadius: 3,
	            borderTopRightRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: _Properties2.default.DELETE_ALERT_BACKGROUND
	        };
	
	        var bottomBarStyle = {
	            position: 'absolute',
	            backgroundColor: 'white',
	            width: _Properties2.default.DELETE_ALERT_WIDTH,
	            height: bottomBarHeight,
	            top: _Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT,
	            left: 0,
	            borderBottomLeftRadius: 3,
	            borderBottomRightRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: 'white'
	        };
	
	        var paddingLeft = 15;
	        var titleStyle = {
	            position: 'absolute',
	            left: paddingLeft,
	            top: 7,
	            fontSize: 20,
	            width: _Properties2.default.DELETE_ALERT_WIDTH - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            color: 'white'
	        };
	
	        var borderColor;
	        var textColor;
	
	        if (this.state.isOver == true) {
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            textColor = borderColor;
	        } else {
	            borderColor = 'black';
	            textColor = 'black';
	        }
	
	        var inputHolderStyle = {
	            width: topBarStyle.width - 2 * paddingLeft,
	            height: 30,
	            background: 'white',
	            position: 'absolute',
	            left: paddingLeft,
	            top: paddingLeft,
	            borderColor: borderColor,
	            borderWidth: 2,
	            borderStyle: 'solid',
	            alignItems: 'center',
	            border: 'none'
	        };
	
	        var inputStyle = {
	            position: 'absolute',
	            color: textColor,
	            top: 5,
	            paddingLeft: 10,
	            fontSize: 17,
	            width: inputHolderStyle.width - 2 * 10,
	            resize: 'none',
	            overflow: 'hidden',
	            background: 'transparent',
	            borderColor: borderColor,
	            borderRadius: 5
	        };
	
	        if (_PlatformDetection2.default.isIOS()) inputStyle.top = -3;
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, role: 'dialog', id: 'productionInitialTitleAlert' },
	            _react2.default.createElement('div', { style: backgroundStyle }),
	            _react2.default.createElement(
	                'div',
	                { style: alertHolderStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: topBarStyle },
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'productionInitialTitle', style: titleStyle },
	                        _LocalesManager2.default.getCaption('ProductionNameAlertTitle', 'other')
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: bottomBarStyle },
	                    _react2.default.createElement(
	                        'div',
	                        { style: inputHolderStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onInputClick },
	                        _react2.default.createElement('input', { type: 'text', ref: 'productionTitle', id: 'productionInitialTitle', className: 'titleInput', style: inputStyle, defaultValue: this.getDefaultTitle(), spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off' })
	                    ),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, topPosition: bottomBarHeight - paddingLeft - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT, leftPosition: bottomBarStyle.width - _Properties2.default.DELETE_ALERT_BUTTON_WIDTH - paddingLeft, refreshContent: this.refresh, text: 'OK' })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ProductTitleAlert.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ProductTitleAlert.js"); } } })();

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RecorderPopup = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _MenuActions = __webpack_require__(7);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AudioRecorder = __webpack_require__(239);
	
	var _AudioRecorder2 = _interopRequireDefault(_AudioRecorder);
	
	var _DurationUtils = __webpack_require__(140);
	
	var _DurationUtils2 = _interopRequireDefault(_DurationUtils);
	
	var _RecordingUtils = __webpack_require__(853);
	
	var _RecordingUtils2 = _interopRequireDefault(_RecordingUtils);
	
	var _ReactNativeBridge = __webpack_require__(173);
	
	var _ReactNativeBridge2 = _interopRequireDefault(_ReactNativeBridge);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _RecordedSoundUploadingUtils = __webpack_require__(242);
	
	var _RecordedSoundUploadingUtils2 = _interopRequireDefault(_RecordedSoundUploadingUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioVolumeUtils = __webpack_require__(67);
	
	var _AudioVolumeUtils2 = _interopRequireDefault(_AudioVolumeUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _PopulateMediaFilesUtils = __webpack_require__(80);
	
	var _PopulateMediaFilesUtils2 = _interopRequireDefault(_PopulateMediaFilesUtils);
	
	var _FineUploader = __webpack_require__(371);
	
	var _FineUploader2 = _interopRequireDefault(_FineUploader);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _AudioConverter = __webpack_require__(231);
	
	var _AudioConverter2 = _interopRequireDefault(_AudioConverter);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecorderPopupContent = _react2.default.createClass({
	    displayName: 'RecorderPopupContent',
	    getInitialState: function getInitialState() {
	        var width = 460;
	        var height = 195;
	
	        return {
	            isCancelOver: false,
	            isSaveOver: false,
	            isStartOver: false,
	            isPlayOver: false,
	            isPlaying: false,
	            currentX: (this.props.windowWidth - width) / 2,
	            currentY: (this.props.windowHeight - height) / 2,
	            currentState: 0 // 0 - start, 1 - stop, 2 - encoding, 3 - ready to use, 4 - storing, 5 - saving error
	        };
	    },
	    componentDidUpdate: function componentDidUpdate(prevProps) {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        if (!prevProps.showRecorder && this.props.showRecorder) {
	            var firstEl = document.getElementById("recordingFirstFocusableElement");
	            if (firstEl) {
	                firstEl.focus();
	            }
	        }
	    },
	    onCancelMouseIn: function onCancelMouseIn() {
	        this.setState({
	            isCancelOver: true
	        });
	    },
	    onCancelMouseOut: function onCancelMouseOut() {
	        this.setState({
	            isCancelOver: false
	        });
	    },
	    onPlayMouseIn: function onPlayMouseIn() {
	        this.setState({
	            isPlayOver: true
	        });
	    },
	    onPlayMouseOut: function onPlayMouseOut() {
	        this.setState({
	            isPlayOver: false
	        });
	    },
	    onSaveMouseIn: function onSaveMouseIn() {
	        this.setState({
	            isSaveOver: true
	        });
	    },
	    onSaveMouseOut: function onSaveMouseOut() {
	        this.setState({
	            isSaveOver: false
	        });
	    },
	    onStartMouseIn: function onStartMouseIn() {
	        this.setState({
	            isStartOver: true
	        });
	    },
	    onStartMouseOut: function onStartMouseOut() {
	        this.setState({
	            isStartOver: false
	        });
	    },
	    getDispatch: function getDispatch() {
	        return _StoreManager2.default.getStore().dispatch;
	    },
	    convertTimeToStringFormat: function convertTimeToStringFormat(time) {
	        time = time / 1000; //convert milliseconds to seconds
	        time = parseFloat(time.toFixed(3));
	
	        var text = '';
	        var seconds = Math.floor(time);
	        var miliseconds = Math.floor((time - seconds) * 1000);
	        var minutes = Math.floor(seconds / 60);
	        seconds = seconds - minutes * 60;
	
	        if (minutes < 10) text = text + '0' + minutes + ':';else text = text + minutes + ':';
	
	        if (seconds < 10) text = text + '0' + seconds + ':';else text = text + seconds + ':';
	
	        if (miliseconds < 10) text = text + '00' + miliseconds;else if (miliseconds < 100) text = text + '0' + miliseconds;else text = text + miliseconds;
	
	        return text;
	    },
	    close: function close() {
	        if (this.state.recordingTimer) clearInterval(this.state.recordingTimer);
	
	        this.setState({
	            currentState: 0,
	            blob: undefined
	        });
	
	        this.clearSoundElement();
	        this.getDispatch()((0, _MenuActions.showRecorder)(false));
	    },
	    onCancelClick: function onCancelClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.close();
	
	        if (_PlatformDetection2.default.isIOSApp()) _ReactNativeBridge2.default.stopRecording(undefined);else _AudioRecorder2.default.stopRecording(undefined);
	
	        _RecordingUtils2.default.removeRecordingPosition();
	        this.stopPlayingSequence();
	        _DurationUtils2.default.clearRecordingDuration();
	    },
	
	    /*************************** Play/Pause ********************************/
	    onPlayClick: function onPlayClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (!this.refs.audioElement) return;
	
	        if (this.state.isPlaying) {
	            this.refs.audioElement.pause();
	            this.refs.audioElement.currentTime = 0;
	        } else this.refs.audioElement.play();
	
	        this.setState({
	            isPlaying: !this.state.isPlaying
	        });
	    },
	    onAudioEnded: function onAudioEnded() {
	        this.setState({
	            isPlaying: false
	        });
	
	        if (this.refs.audioElement) this.refs.audioElement.currentTime = 0;
	    },
	    clearSoundElement: function clearSoundElement() {
	        this.setState({
	            isPlaying: false,
	            blob: undefined
	        });
	
	        if (!this.refs.audioElement) return;
	
	        if (this.state.isPlaying) this.refs.audioElement.pause();
	
	        if (this.refs.audioElement.src && this.refs.audioElement.src.length > 0) window.URL.revokeObjectURL(this.refs.audioElement.src);
	
	        this.refs.audioElement.currentTime = 0;
	        this.refs.audioElement.src = '';
	    },
	
	    /*************************** Recording ********************************/
	    onStartClick: function onStartClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.state.currentState == 0 || this.state.currentState == 3) {
	            // start recording
	            if (_PlatformDetection2.default.isIOSApp() == true) {
	                if (!_ReactNativeBridge2.default.isIOSRecorderEnabled) return;
	
	                _ReactNativeBridge2.default.startRecording();
	            } else {
	                if (!_AudioRecorder2.default.isRecordAvailable) return;
	
	                _AudioRecorder2.default.startRecording();
	            }
	
	            _PlayController2.default.getOldScrollPosition();
	            _DurationUtils2.default.startRecording(this.stopRecording);
	            _RecordingUtils2.default.setCurrentRecordingPosition();
	            this.startPlayingSequence();
	
	            if (this.state.recordingTimer) clearInterval(this.state.recordingTimer);
	
	            var recTimer = setInterval(this.onRecordingTimer, 50);
	
	            if (this.state.currentState == 3) this.clearSoundElement();
	
	            this.setState({
	                currentState: 1,
	                recordingTimer: recTimer,
	                startTime: new Date().getTime()
	            });
	        } else if (this.state.currentState == 1) {
	            // stop recording
	            this.stopRecording();
	        }
	    },
	    stopRecording: function stopRecording() {
	        // stops the recording flow
	        if (_PlatformDetection2.default.isIOSApp() == true) {
	            _ReactNativeBridge2.default.stopRecording(this.endRecording);
	        } else {
	            _AudioRecorder2.default.stopRecording(this.endRecording);
	        }
	
	        this.stopPlayingSequence();
	        _DurationUtils2.default.clearRecordingDuration();
	
	        if (this.state.recordingTimer) clearInterval(this.state.recordingTimer);
	
	        this.setState({
	            currentState: 2,
	            startEncodingTime: new Date().getTime(),
	            duration: this.convertTimeToStringFormat(new Date().getTime() - this.state.startTime),
	            realDuration: (new Date().getTime() - this.state.startTime) / 1000
	        });
	    },
	    endRecording: function endRecording(blob) {
	        console.log('Recording time = ' + this.state.realDuration + ' ----> Encoding time = ' + (new Date().getTime() - this.state.startEncodingTime) / 1000);
	
	        // should create a new context because something broke the old audio context when call reactNativeBridge.stopRecording()
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.reset();
	
	        var url = URL.createObjectURL(blob);
	
	        this.setState({
	            currentState: 3,
	            isPlaying: false,
	            blob: blob
	        });
	
	        if (this.refs.audioElement) this.refs.audioElement.src = url;
	    },
	    onRecordingTimer: function onRecordingTimer() {
	        if (this.refs.duration) this.refs.duration.textContent = this.convertTimeToStringFormat(new Date().getTime() - this.state.startTime);
	
	        var maxLevel = Math.floor(_AudioRecorder2.default.getMicrophoneLevel() / 4);
	
	        for (var i = 0; i < 10; i++) {
	            var element = this.refs['level_' + i];
	
	            if (!element) continue;
	
	            if (i <= maxLevel) element.style.background = '#69ac12';else element.style.background = '#dfe0d4';
	        }
	    },
	
	    /**************************** Saving *******************************/
	    onSaveClick: function onSaveClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.setState({
	            currentState: 4
	        });
	
	        if (_Configuration2.default.LOAD_LOCAL) return;
	
	        var recordingItem = _RecordingUtils2.default.getCurrentRecordingPosition();
	        var title = recordingItem.title;
	
	        _PopulateMediaFilesUtils2.default.stopRefreshTimers();
	        _RecordingUtils2.default.startUploadingTime = new Date().getTime();
	        _RecordedSoundUploadingUtils2.default.startStoring();
	
	        if (this.refs.title && this.refs.title.value && this.refs.title.value != title) title = this.refs.title.value;
	
	        if (title && title.indexOf('.mp3') < 1) title = title + '.mp3';
	
	        _FineUploader2.default.uploadFile(this.state.blob, title, this.uploadComplete);
	    },
	    uploadComplete: function uploadComplete(val, title, content) {
	        _PopulateMediaFilesUtils2.default.restartRefreshTimers();
	
	        if (content && content.contentItemId > 0) {
	            this.dataSaved(content.contentItemId, title);
	        } else {
	            this.setState({
	                currentState: 5
	            });
	        }
	    },
	    dataSaved: function dataSaved(contentItemId, title) {
	        console.log('Storing time is: ' + (new Date().getTime() - _RecordingUtils2.default.startUploadingTime) / 1000 + ' seconds');
	
	        if (_RecordedSoundUploadingUtils2.default.refreshTimer != -1) clearInterval(_RecordedSoundUploadingUtils2.default.refreshTimer);
	
	        _RecordedSoundUploadingUtils2.default.currentContentItemId = contentItemId;
	        _RecordedSoundUploadingUtils2.default.currentTile = title;
	        _RecordedSoundUploadingUtils2.default.refreshTimer = setInterval(this.checkFileStatus, 4 * 1000);
	    },
	    checkFileStatus: function checkFileStatus() {
	        var _this = this;
	
	        var id = _RecordedSoundUploadingUtils2.default.currentContentItemId;
	
	        _ApiService2.default.getSignedContent([id]).then(function (response) {
	            var soundUrl = response[id];
	
	            if (soundUrl && (soundUrl.indexOf('user-audios.s3.amazonaws') != -1 || soundUrl.indexOf('creaza-stage-upload.s3.amazonaws') != -1)) _this.dataCompleteUploaded();
	        });
	    },
	    dataCompleteUploaded: function dataCompleteUploaded() {
	        if (_RecordedSoundUploadingUtils2.default.refreshTimer != -1) clearInterval(_RecordedSoundUploadingUtils2.default.refreshTimer);
	
	        _RecordedSoundUploadingUtils2.default.refreshTimer = -1;
	
	        var contentItemId = _RecordedSoundUploadingUtils2.default.currentContentItemId;
	        var title = _RecordedSoundUploadingUtils2.default.currentTile;
	
	        if (contentItemId > 0) {
	            console.log('Complete uploading time is: ' + (new Date().getTime() - _RecordingUtils2.default.startUploadingTime) / 1000 + ' seconds');
	
	            var newUrl = '/file/ci/' + contentItemId + '/aaa';
	            var recordingItem;
	            var position;
	
	            if (_PlayController2.default.isAudioEditorAvailable()) {
	                recordingItem = _RecordingUtils2.default.getCurrentRecordingPosition();
	                position = recordingItem.position;
	                _AudioEditorUtils2.default.addRecordedSoundToTimeline(newUrl, title, position, this.state.realDuration);
	                _RecordingUtils2.default.removeRecordingPosition();
	
	                if (!_PlayController2.default.isAudioEditorMode()) _PlayController2.default.toggleAudioEditorMode(true);
	            } else {
	                recordingItem = _RecordingUtils2.default.getRecordingPositionWhenDataSaved(title);
	
	                var sound = {};
	                sound.contentItemId = contentItemId;
	                sound.href = newUrl;
	                sound.title = recordingItem.title;
	
	                position = recordingItem.position;
	
	                if (position != '' && position != _StoreManager2.default.getState().currentSlide.model.uuid) this.getDispatch()((0, _ProductionActions.changeSlideProperty)(position, 'sound', sound));else this.getDispatch()((0, _CurrentSlideActions.setSlideSound)(sound));
	
	                this.getDispatch()((0, _MenuActions.showAudioAlert)(0, title));
	                _AudioConverter2.default.addSoundDurationToMap(sound.href, this.state.realDuration);
	
	                this.addSlideDuration();
	            }
	
	            this.addToMyMediaFiles(contentItemId);
	
	            _RecordedSoundUploadingUtils2.default.stopStoring();
	            _SaveManager2.default.isContentChanged(true);
	            _AudioEditorUtils2.default.addActionToHistory();
	        } else _RecordedSoundUploadingUtils2.default.currentContentItemId = -1;
	
	        this.close();
	    },
	    addSlideDuration: function addSlideDuration() {
	        var duration = this.state.realDuration;
	
	        if (duration > 0 && !_PlayController2.default.isAudioEditorMode() && !_VideoUtils2.default.isVideoBackground()) {
	            duration = parseFloat(duration.toFixed(1));
	            this.getDispatch()((0, _CurrentSlideActions.changeSlideDuration)(duration));
	        }
	
	        _RecordingUtils2.default.removeRecordingPosition();
	    },
	    addToMyMediaFiles: function addToMyMediaFiles(contentItemId) {
	        var state = _StoreManager2.default.getState();
	        var mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
	
	        if (mediaFilesDataProvider != undefined) {
	            this.appendSound(contentItemId);
	        } else {
	            if (_Configuration2.default.LOAD_LOCAL == false) {
	                _ApiServiceUtils2.default.executeSafeApiCall(this.loadMyMediaFiles.bind(this));
	            }
	        }
	    },
	    appendSound: function appendSound(contentItemId) {
	        var state = _StoreManager2.default.getState();
	        var mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
	
	        if (contentItemId == undefined || mediaFilesDataProvider == undefined) return;
	
	        _RecordedSoundUploadingUtils2.default.currentContentItemId = -1;
	        var newDataProvider = {};
	        var sounds = mediaFilesDataProvider.soundsDataProvider;
	        var storedSound = {};
	
	        storedSound.contentItemId = contentItemId;
	        storedSound.href = '/file/ci/' + contentItemId + '/aaa';
	
	        var audio = this.refs.recordedAudio;
	        var duration = 0;
	        var recordingItem = _RecordingUtils2.default.getCurrentRecordingPosition();
	
	        if (audio) {
	            audio.src = storedSound.href;
	
	            setTimeout(function () {
	                duration = Math.ceil(audio.duration) * 1000;
	
	                storedSound.duration = _DurationUtils2.default.transformDuration(duration);
	                storedSound.title = recordingItem.title;
	                storedSound.isRecordedSound = true;
	
	                sounds.unshift(storedSound);
	
	                newDataProvider.soundsDataProvider = sounds;
	                newDataProvider.imagesDataProvider = mediaFilesDataProvider.imagesDataProvider;
	                newDataProvider.videosDataProvider = mediaFilesDataProvider.videosDataProvider;
	
	                this.getDispatch()((0, _AccordionActions.setMediaFilesDataProvider)(newDataProvider));
	            }.bind(this), 2000);
	        }
	    },
	    loadMyMediaFiles: function loadMyMediaFiles() {
	        _ApiServiceUtils2.default.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
	    },
	    parseMediaItems: function parseMediaItems(items) {
	        _PopulateMediaFilesUtils2.default.parseMediaItems(items, this.getDispatch());
	    },
	    getTitles: function getTitles() {
	        var titles = {};
	
	        titles.popupTitle = _LocalesManager2.default.getCaption('popupTitle', 'audioRecorder'); //'Sound Recorder';
	        titles.record = _LocalesManager2.default.getCaption('record', 'audioRecorder'); //'RECORD';
	        titles.stop = _LocalesManager2.default.getCaption('stop', 'audioRecorder'); //'STOP';
	        titles.play = _LocalesManager2.default.getCaption('play', 'audioRecorder'); //'Play';
	        titles.pause = _LocalesManager2.default.getCaption('pause', 'audioRecorder'); //'Stop';
	        titles.startRecording = _LocalesManager2.default.getCaption('startRecording', 'audioRecorder'); //"Start recording here";
	        titles.encoding = _LocalesManager2.default.getCaption('encoding', 'audioRecorder'); //"Encoding. Please wait until it's finished";
	        titles.uploading = _LocalesManager2.default.getCaption('uploading', 'audioRecorder'); //'Uploading file';
	        titles.recording = _LocalesManager2.default.getCaption('recording', 'audioRecorder'); //'Recording';
	        titles.microphone = _LocalesManager2.default.getCaption('microphone', 'audioRecorder'); //'Microphone';
	        titles.length = _LocalesManager2.default.getCaption('length', 'audioRecorder'); //'Length';
	        titles.time = _LocalesManager2.default.getCaption('time', 'audioRecorder'); //'Time';
	        titles.cancel = _LocalesManager2.default.getCaption('cancel', 'audioRecorder'); //'Cancel';
	        titles.save = _LocalesManager2.default.getCaption('save', 'audioRecorder'); //'Save';
	        titles.savingError = _LocalesManager2.default.getCaption('save', 'savingError'); //'Something went wrong with the audio storing. Please try again!';
	
	        return titles;
	    },
	
	    /**************************** Playing sequence ***************************/
	    startPlayingSequence: function startPlayingSequence() {
	        if (_AudioToolUtils2.default.isAudioTool()) return;
	
	        if (_PlayController2.default.isAudioEditorMode()) {
	            // this.playPauseForRecording(true); // removed for CART-1370 ... poor recording in advanced mode
	        } else this.startPlayingVideo();
	    },
	    stopPlayingSequence: function stopPlayingSequence() {
	        if (_AudioToolUtils2.default.isAudioTool()) return;
	
	        if (_PlayController2.default.isAudioEditorMode()) {
	            // this.playPauseForRecording(false); // removed for CART-1370 ... poor recording in advanced mode
	        } else this.stopPlayingVideo();
	    },
	    playPauseForRecording: function playPauseForRecording() {
	        var play = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (play) {
	            _PlayController2.default.getOldScrollPosition();
	            _PlayController2.default.play(false, true);
	            this.changePlayState(true);
	        } else {
	            _PlayController2.default.pause(true); // should update scroll position
	            this.changePlayState(false);
	        }
	    },
	    changePlayState: function changePlayState(value) {
	        if (_PlayController2.default.changePlayState) _PlayController2.default.changePlayState(value);
	    },
	    startPlayingVideo: function startPlayingVideo() {
	        if (this.isVideoVisible()) {
	            _VideoUtils2.default.playVideoPreview();
	            this.changePlayState(true);
	        } else {
	            if (this.isVideoShapes()) {
	                _VideoUtils2.default.playVideoShapesPreview(true);
	                this.changePlayState(true);
	            }
	        }
	    },
	    stopPlayingVideo: function stopPlayingVideo() {
	        if (this.isVideoVisible()) {
	            _VideoUtils2.default.pauseVideoPreview(true);
	            this.changePlayState(false);
	        } else {
	            if (this.isVideoShapes()) {
	                _VideoUtils2.default.pauseVideoShapesPreview(true);
	                this.changePlayState(false);
	            }
	        }
	    },
	    isVideoVisible: function isVideoVisible() {
	        return _VideoUtils2.default.isVideoBackground();
	    },
	    isVideoShapes: function isVideoShapes() {
	        return _VideoUtils2.default.isVideoShapes();
	    },
	
	    /**************************************************************************/
	    onDragStart: function onDragStart(e) {
	        this.setState({
	            initialX: this.state.currentX,
	            initialY: this.state.currentY
	        });
	    },
	    onDragMove: function onDragMove(e, coreEvent) {
	        this.setState({
	            currentX: this.state.initialX + coreEvent.lastX,
	            currentY: this.state.initialY + coreEvent.lastY
	        });
	    },
	
	    /**************************************************************************/
	    getTitleInputAriaLabel: function getTitleInputAriaLabel() {
	        var view = this.refs.title;
	
	        if (view) return view.value;else return _RecordingUtils2.default.getSoundTitle();
	    },
	    onChangeText: function onChangeText() {
	        this.forceUpdate();
	    },
	    render: function render() {
	        var visible = 'none';
	
	        if (this.props.showRecorder) visible = 'block';else return _react2.default.createElement('div', null);
	
	        var titles = this.getTitles();
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            left: 0,
	            display: visible,
	            userSelect: 'none',
	            cursor: 'default',
	            zIndex: 20000
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            width: menuStyle.width,
	            height: menuStyle.height,
	            background: '#434343',
	            top: 0,
	            left: 0,
	            userSelect: 'none',
	            cursor: 'default',
	            opacity: 0.4
	        };
	
	        var width = 460;
	        var height = 195;
	        var padding = 20;
	        var color = '#535248';
	        var fillColor;
	
	        var areaStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            background: 'white',
	            top: this.state.currentY,
	            left: this.state.currentX,
	            borderRadius: 4
	        };
	
	        var titleStyle = {
	            position: 'absolute',
	            left: padding,
	            top: padding,
	            fontSize: 24,
	            width: areaStyle.width - 2 * padding,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            color: color
	        };
	
	        if (this.state.isStartOver) fillColor = '#f5f5f5';else fillColor = '#f0f0ec';
	
	        var startRecording = {
	            position: 'absolute',
	            width: 70,
	            height: 70,
	            background: fillColor,
	            top: 65,
	            left: padding,
	            borderColor: '#a3a393',
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderRadius: 4,
	            cursor: 'pointer',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var recordTitleStyle = {
	            position: 'absolute',
	            left: 0,
	            bottom: 8,
	            fontSize: 12,
	            width: startRecording.width,
	            textAlign: 'center',
	            display: 'inline-block',
	            color: '#d11010'
	        };
	
	        var recordIconStyle = {
	            position: 'absolute',
	            top: 10,
	            left: 25,
	            width: 19,
	            height: 34
	        };
	
	        var arrowStyle = {
	            position: 'absolute',
	            top: startRecording.top + 30,
	            left: startRecording.left + startRecording.width + 20,
	            width: 34,
	            height: 12
	        };
	
	        var messageStyle = {
	            position: 'absolute',
	            left: arrowStyle.left + arrowStyle.width + 5,
	            top: arrowStyle.top - 4,
	            fontSize: 18,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            cursor: 'default',
	            color: color
	        };
	
	        if (this.state.isCancelOver) fillColor = '#f5f5f5';else fillColor = '#f0f0ec';
	
	        var cancelButtonStyle = {
	            position: 'absolute',
	            backgroundColor: fillColor,
	            width: 100,
	            height: 22,
	            paddingTop: 6,
	            bottom: padding,
	            right: padding,
	            color: '#4c4c4c',
	            fontSize: 14,
	            textAlign: 'center',
	            borderRadius: 4,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#d6d6d6',
	            cursor: 'pointer',
	            margin: 0,
	            paddingBottom: 0,
	            paddingLeft: 0,
	            paddingRight: 0,
	            boxSizing: 'initial',
	            display: 'grid'
	        };
	
	        var saveButton;
	        var leftPos = startRecording.left + startRecording.width + 10;
	        var microphoneHolder = {
	            position: 'absolute',
	            top: startRecording.top,
	            left: leftPos,
	            width: areaStyle.width - padding - leftPos,
	            height: startRecording.height,
	            display: 'none'
	        };
	
	        var leftSideStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: 100,
	            height: microphoneHolder.height
	        };
	
	        var micTitleStyle = {
	            position: 'absolute',
	            left: 0,
	            top: 5,
	            width: leftSideStyle.width,
	            fontSize: 16,
	            cursor: 'default',
	            color: color,
	            textAlign: 'right'
	        };
	
	        var durationTitleStyle = {
	            position: 'absolute',
	            left: 0,
	            bottom: 5,
	            width: leftSideStyle.width,
	            fontSize: 16,
	            cursor: 'default',
	            color: color,
	            textAlign: 'right'
	        };
	
	        var middleGap = 10;
	        var rightSideStyle = {
	            position: 'absolute',
	            top: 0,
	            left: leftSideStyle.width + middleGap,
	            width: microphoneHolder.width - leftSideStyle.width - middleGap,
	            height: microphoneHolder.height
	        };
	
	        var timeStyle = {
	            position: 'absolute',
	            left: 0,
	            bottom: 0,
	            width: rightSideStyle.width,
	            fontSize: 26,
	            cursor: 'default',
	            color: '#a5a797',
	            textAlign: 'left'
	        };
	
	        var microphoneLevelsElement;
	        var arrowHolder;
	        var encoderMessageHolder;
	        var recordintTitle;
	        var recordingIcon;
	        var durationText = '00:00:00:000';
	        var microphoneText = titles.microphone + ':';
	        var timeText = titles.time + ':';
	
	        switch (this.state.currentState) {
	            case 0:
	                {
	                    // Start recording
	                    recordingIcon = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/recorder/record-icon.png';
	                    recordintTitle = titles.record;
	
	                    arrowHolder = _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: arrowStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/recorder/record-arrow.png' }),
	                        _react2.default.createElement(
	                            'span',
	                            { style: messageStyle },
	                            titles.startRecording
	                        )
	                    );
	
	                    break;
	                }
	
	            case 1:
	                {
	                    // Stop recording
	                    recordingIcon = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/recorder/record-stop.png';
	                    recordintTitle = titles.stop;
	                    recordIconStyle.width = 26;
	                    recordIconStyle.height = 26;
	                    recordIconStyle.left = 22;
	                    recordIconStyle.top = 18;
	                    recordTitleStyle.color = '#535248';
	                    arrowStyle.display = 'none';
	                    messageStyle.display = 'none';
	                    microphoneHolder.display = 'block';
	
	                    var levelStyle = {
	                        position: 'absolute',
	                        left: 0,
	                        top: 10,
	                        width: rightSideStyle.width,
	                        height: 8,
	                        cursor: 'default',
	                        background: 'white',
	                        borderStyle: 'solid',
	                        borderWidth: 1,
	                        borderColor: '#dfe0d4'
	                    };
	
	                    var levels = [];
	                    var sliceWidth = (rightSideStyle.width - 11) / 10;
	
	                    for (var i = 0; i < 10; i++) {
	                        var levelElementStyle = {
	                            position: 'absolute',
	                            left: i * (sliceWidth + 1) + 1,
	                            top: 1,
	                            width: sliceWidth,
	                            height: 6,
	                            cursor: 'default',
	                            background: '#dfe0d4'
	                        };
	                        var levelElement = _react2.default.createElement('div', { ref: 'level_' + i, style: levelElementStyle, key: i });
	
	                        levels.push(levelElement);
	                    }
	
	                    microphoneLevelsElement = _react2.default.createElement(
	                        'div',
	                        { style: levelStyle },
	                        levels
	                    );
	
	                    break;
	                }
	
	            case 3:
	                {
	                    // Play/Pause sound
	                    microphoneText = titles.recording + ':';
	                    timeText = titles.length + ':';
	                    durationText = this.state.duration;
	                    microphoneHolder.display = 'block';
	                    recordingIcon = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/recorder/record-icon.png';
	                    recordintTitle = titles.record;
	
	                    var _titleStyle = {
	                        width: rightSideStyle.width,
	                        height: 27,
	                        background: 'white',
	                        borderRadius: 4,
	                        position: 'absolute',
	                        left: 0,
	                        top: 0,
	                        borderColor: '#a3a393',
	                        borderWidth: 1,
	                        borderStyle: 'solid',
	                        alignItems: 'center'
	                    };
	                    var inputStyle = {
	                        position: 'absolute',
	                        color: '#535248',
	                        top: 6,
	                        paddingLeft: 5,
	                        fontSize: 12,
	                        width: _titleStyle.width - 65,
	                        resize: 'none',
	                        overflow: 'hidden',
	                        border: 'none',
	                        outline: 'none',
	                        background: 'transparent'
	                    };
	
	                    if (this.state.isPlayOver) fillColor = '#f5f5f5';else fillColor = '#f0f0ec';
	
	                    var playButtonStyle = {
	                        position: 'absolute',
	                        backgroundColor: fillColor,
	                        width: 64,
	                        height: 23,
	                        right: 1,
	                        top: 1,
	                        color: '#535248',
	                        borderRadius: '2px 4px 4px 2px',
	                        fontSize: 14,
	                        textAlign: 'center',
	                        borderStyle: 'solid',
	                        borderWidth: 1,
	                        borderColor: '#a3a393',
	                        cursor: 'pointer',
	                        margin: 0,
	                        padding: 0,
	                        boxSizing: 'initial',
	                        display: 'grid'
	                    };
	
	                    var icon = 'fa fa-play';
	                    var playBtnText = titles.play;
	
	                    if (this.state.isPlaying) {
	                        icon = 'fa fa-pause';
	                        playBtnText = titles.pause;
	                    }
	
	                    var playIconStyle = {
	                        position: 'absolute',
	                        top: 5,
	                        left: 5,
	                        color: '#535248'
	                    };
	
	                    var spanStyle = {
	                        position: 'absolute',
	                        top: 5,
	                        left: 17,
	                        color: '#535248',
	                        fontSize: 13,
	                        width: playButtonStyle.width - 17,
	                        textAlign: 'center'
	                    };
	
	                    if (playBtnText && playBtnText.length > 6) {
	                        spanStyle.fontSize = 10;
	                        spanStyle.top = 6;
	                    }
	
	                    var fillOutFieldViewWidth = 150;
	                    var fillOutFieldViewStyle = {
	                        position: 'absolute',
	                        background: '#434343',
	                        width: fillOutFieldViewWidth,
	                        height: 30,
	                        top: 38,
	                        left: 6,
	                        borderRadius: 5,
	                        zIndex: 99999,
	                        pointerEvents: 'none'
	                    };
	
	                    var stemStyle = {
	                        position: 'absolute',
	                        borderWidth: 10,
	                        borderStyle: 'solid',
	                        borderBottomColor: '#434343',
	                        borderTopColor: 'transparent',
	                        borderLeftColor: 'transparent',
	                        borderRightColor: 'transparent',
	                        top: -20,
	                        left: fillOutFieldViewWidth / 2 - 10
	                    };
	
	                    var captionStyle = {
	                        position: 'absolute',
	                        color: 'white',
	                        wordWrap: 'break-word',
	                        textAlign: 'center',
	                        fontSize: 12,
	                        left: 5,
	                        top: 8,
	                        width: fillOutFieldViewWidth - 10
	                    };
	
	                    var fillOutFieldView;
	                    var isDisabled = false;
	
	                    if (this.refs.title && this.refs.title.value.length < 1) {
	                        fillOutFieldView = _react2.default.createElement(
	                            'div',
	                            { style: fillOutFieldViewStyle },
	                            _react2.default.createElement('div', { style: stemStyle }),
	                            _react2.default.createElement(
	                                'div',
	                                { style: captionStyle },
	                                'Please fill out this field!'
	                            )
	                        );
	
	                        isDisabled = true;
	                    }
	
	                    microphoneLevelsElement = _react2.default.createElement(
	                        'div',
	                        { style: _titleStyle },
	                        _react2.default.createElement('input', { type: 'text', 'aria-label': this.getTitleInputAriaLabel(), ref: 'title', className: 'titleInput', style: inputStyle, defaultValue: _RecordingUtils2.default.getSoundTitle(), onChange: this.onChangeText, spellCheck: 'true', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off' }),
	                        fillOutFieldView,
	                        _react2.default.createElement(
	                            'button',
	                            { 'aria-label': playBtnText, style: playButtonStyle, onMouseOver: this.onPlayMouseIn, onMouseOut: this.onPlayMouseOut, onTouchEnd: this.onPlayClick, onClick: this.onPlayClick },
	                            _react2.default.createElement('i', { style: playIconStyle, className: icon }),
	                            _react2.default.createElement(
	                                'span',
	                                { style: spanStyle },
	                                playBtnText
	                            )
	                        )
	                    );
	
	                    if (this.state.isSaveOver) fillColor = '#8a8a8a';else fillColor = '#6e6e6e';
	
	                    var saveButtonStyle = {
	                        position: 'absolute',
	                        backgroundColor: fillColor,
	                        width: 100,
	                        height: 22,
	                        paddingTop: 6,
	                        bottom: padding,
	                        right: padding + cancelButtonStyle.width + 10,
	                        color: 'white',
	                        fontSize: 14,
	                        textAlign: 'center',
	                        borderRadius: 4,
	                        borderStyle: 'solid',
	                        borderWidth: 1,
	                        borderColor: '#4d4d4d',
	                        boxShadow: 'inset 0 1px 0 #dbdbdb',
	                        cursor: 'pointer',
	                        margin: 0,
	                        paddingBottom: 0,
	                        paddingLeft: 0,
	                        paddingRight: 0,
	                        boxSizing: 'initial',
	                        display: 'grid'
	                    };
	
	                    var tabIndexValue = '';
	
	                    if (isDisabled) {
	                        saveButtonStyle.opacity = 0.5;
	                        saveButtonStyle.pointerEvents = 'none';
	                        tabIndexValue = '-1';
	                    }
	
	                    saveButton = _react2.default.createElement(
	                        'button',
	                        { tabIndex: tabIndexValue, 'aria-label': titles.save, style: saveButtonStyle, onMouseOver: this.onSaveMouseIn, onMouseOut: this.onSaveMouseOut, onTouchEnd: this.onSaveClick, onClick: this.onSaveClick },
	                        titles.save
	                    );
	                    break;
	                }
	
	            case 2: // Encoding
	            case 4: // Uploading
	            case 5:
	                {
	                    // Storing error
	                    var encoderMessageHolderStyle = {
	                        position: 'absolute',
	                        top: 75,
	                        left: padding,
	                        width: areaStyle.width - 2 * padding,
	                        height: 30
	                    };
	
	                    var loaderStyle = {
	                        position: 'absolute',
	                        top: 0,
	                        left: 0,
	                        color: color
	                    };
	
	                    var encodinTitleStyle = {
	                        position: 'absolute',
	                        left: 70,
	                        top: 14,
	                        fontSize: 18,
	                        width: encoderMessageHolderStyle.width - 70,
	                        textAlign: 'left',
	                        display: 'inline-block',
	                        color: color
	                    };
	
	                    var alertTitle = titles.encoding;
	
	                    if (this.state.currentState == 4) alertTitle = titles.uploading;else if (this.state.currentState == 5) {
	                        alertTitle = titles.savingError;
	                        encodinTitleStyle.top = 3;
	                    }
	
	                    encoderMessageHolder = _react2.default.createElement(
	                        'div',
	                        { style: encoderMessageHolderStyle },
	                        _react2.default.createElement('i', { style: loaderStyle, className: 'fa fa-spinner fa-pulse fa-3x' }),
	                        _react2.default.createElement(
	                            'span',
	                            { style: encodinTitleStyle },
	                            alertTitle
	                        )
	                    );
	
	                    startRecording.display = 'none';
	                    break;
	                }
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'recordingPopup' },
	            _react2.default.createElement('audio', { ref: 'audioElement', preload: 'auto', playsInline: true, onEnded: this.onAudioEnded }),
	            _react2.default.createElement('div', { style: backgroundStyle }),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onDragStart, onDrag: this.onDragMove, onStop: this.onDragMove },
	                _react2.default.createElement(
	                    'div',
	                    { style: areaStyle },
	                    _react2.default.createElement(
	                        'span',
	                        { style: titleStyle },
	                        titles.popupTitle
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        { id: 'recordingFirstFocusableElement', 'aria-label': recordintTitle, style: startRecording, onMouseOver: this.onStartMouseIn, onMouseOut: this.onStartMouseOut, onTouchEnd: this.onStartClick, onClick: this.onStartClick },
	                        _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: recordIconStyle, src: recordingIcon }),
	                        _react2.default.createElement(
	                            'span',
	                            { style: recordTitleStyle },
	                            recordintTitle
	                        )
	                    ),
	                    arrowHolder,
	                    encoderMessageHolder,
	                    _react2.default.createElement(
	                        'div',
	                        { style: microphoneHolder },
	                        _react2.default.createElement(
	                            'div',
	                            { style: leftSideStyle },
	                            _react2.default.createElement(
	                                'span',
	                                { style: micTitleStyle },
	                                microphoneText
	                            ),
	                            _react2.default.createElement(
	                                'span',
	                                { style: durationTitleStyle },
	                                timeText
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: rightSideStyle },
	                            microphoneLevelsElement,
	                            _react2.default.createElement(
	                                'span',
	                                { ref: 'duration', style: timeStyle },
	                                durationText
	                            )
	                        )
	                    ),
	                    saveButton,
	                    _react2.default.createElement(
	                        'button',
	                        { id: 'recordingLastFocusableElement', 'aria-label': titles.cancel, style: cancelButtonStyle, onMouseOver: this.onCancelMouseIn, onMouseOut: this.onCancelMouseOut, onTouchEnd: this.onCancelClick, onClick: this.onCancelClick },
	                        titles.cancel
	                    )
	                )
	            ),
	            ';'
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var showRecorder = state.menu.showRecorder;
	
	    return {
	        showRecorder: showRecorder
	    };
	}
	
	var RecorderPopup = exports.RecorderPopup = (0, _reactRedux.connect)(mapStateToProps)(RecorderPopupContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/RecorderPopup.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/RecorderPopup.js"); } } })();

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResizeAccordionButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _MenuActions = __webpack_require__(7);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResizeAccordionButtonContent = _react2.default.createClass({
	    displayName: 'ResizeAccordionButtonContent',
	    getInitialState: function getInitialState() {
	        return {
	            initialWidth: this.props.accordionWidth,
	            isOver: false
	        };
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        this.removeEvents();
	    },
	    addEvents: function addEvents() {
	        if (_PlatformDetection2.default.isTouchableDevice()) {
	            document.addEventListener('touchmove', this.onMouseMove);
	            document.addEventListener('touchend', this.onMouseUp);
	
	            if (_PlatformDetection2.default.isChromeBook()) {
	                document.addEventListener('mousemove', this.onMouseMove);
	                document.addEventListener('mouseup', this.onMouseUp);
	            }
	        } else {
	            document.addEventListener('mousemove', this.onMouseMove);
	            document.addEventListener('mouseup', this.onMouseUp);
	        }
	    },
	    removeEvents: function removeEvents() {
	        document.removeEventListener('touchmove', this.onMouseMove);
	        document.removeEventListener('touchend', this.onMouseUp);
	
	        document.removeEventListener('mousemove', this.onMouseMove);
	        document.removeEventListener('mouseup', this.onMouseUp);
	    },
	    onOver: function onOver() {
	        if (!this.isAudioEditor()) {
	            if (!this.state.isResizing) _HoverManager2.default.show(this.refs.holder, 'resizeAccordion');
	        } else {
	            if (this.props.isLeft) {
	                if (_AudioToolUtils2.default.isLeftSideCollapsed()) _HoverManager2.default.show(this.refs.holder, 'showRightMenu', 'right');else _HoverManager2.default.show(this.refs.holder, 'hideRightMenu');
	            } else {
	                if (this.isCollapsed()) _HoverManager2.default.show(this.refs.holder, 'showRightMenu', 'left');else _HoverManager2.default.show(this.refs.holder, 'hideRightMenu');
	            }
	        }
	
	        this.setState({
	            isOver: true
	        });
	    },
	    onOut: function onOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isOver: false
	        });
	    },
	    isCollapsed: function isCollapsed() {
	        if (this.props.accordionWidth > 0) return false;else return true;
	    },
	    onKeyDown: function onKeyDown(e) {
	        var delta = 10;
	        var newWidth = _StoreManager2.default.getState().accordion.width;
	        var maxLimit = 540;
	
	        if (!newWidth) newWidth = _Properties2.default.BROWSER_WIDTH;
	
	        if (e.keyCode == 37 || e.keyCode == 38) {
	            // Left/Up Key
	            newWidth = newWidth + delta;
	        } else if (e.keyCode == 39 || e.keyCode == 40) {
	            // Right/Down Key
	            newWidth = newWidth - delta;
	        }
	
	        if (newWidth < _Properties2.default.BROWSER_WIDTH) newWidth = _Properties2.default.BROWSER_WIDTH;else if (newWidth > maxLimit) newWidth = maxLimit;
	
	        this.props.dispatch((0, _AccordionActions.changeAcoordionWidth)(newWidth));
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (this.isAudioEditor()) {
	            if (this.props.isLeft) {
	                if (_AudioToolUtils2.default.isLeftSideCollapsed()) this.props.dispatch((0, _MenuActions.setButtonsHolderWidth)(_Properties2.default.BUTTONS_HOLDER_WIDTH));else this.props.dispatch((0, _MenuActions.setButtonsHolderWidth)(_Properties2.default.BUTTONS_HOLDER_COLLAPSED_WIDTH));
	            } else {
	                if (this.isCollapsed()) this.props.dispatch((0, _AccordionActions.changeAcoordionWidth)(_Properties2.default.BROWSER_WIDTH));else this.props.dispatch((0, _AccordionActions.changeAcoordionWidth)(0));
	            }
	
	            _AudioEditorUtils2.default.checkTimelineWidth(false, -1, true);
	
	            return;
	        }
	
	        e.preventDefault();
	
	        var position = (0, _TransformToolUtils.getTouchPosition)(e);
	
	        this.setState({
	            initialWidth: this.props.accordionWidth,
	            initialX: position.x,
	            isResizing: true
	        });
	
	        this.addEvents();
	
	        _HoverManager2.default.hide();
	    },
	    onMouseMove: function onMouseMove(e) {
	        if (this.isAudioEditor()) return;
	
	        e.preventDefault();
	
	        var position = (0, _TransformToolUtils.getTouchPosition)(e);
	
	        if (this.state.isResizing == true) {
	            var deltaX = this.state.initialX - position.x;
	            var newWidth = this.state.initialWidth + deltaX;
	            var maxLimit = 540;
	
	            if (newWidth < _Properties2.default.BROWSER_WIDTH) newWidth = _Properties2.default.BROWSER_WIDTH;else if (newWidth > maxLimit) newWidth = maxLimit;
	
	            this.props.dispatch((0, _AccordionActions.changeAcoordionWidth)(newWidth));
	        }
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_TextSizeUtils2.default.isTextEditMode()) return;
	
	        if (this.isAudioEditor()) return;
	
	        if (!_PlatformDetection2.default.isIOS()) e.preventDefault();
	
	        this.setState({
	            isResizing: false
	        });
	
	        this.removeEvents();
	    },
	    isAudioEditor: function isAudioEditor() {
	        if (_AudioToolUtils2.default.isAudioTool()) return true;else return this.props.showAudioEditor;
	    },
	    render: function render() {
	        if (this.props.contextMode == _ModeConstants2.default.FREEHAND_CONTEXT || this.props.contextMode == _ModeConstants2.default.LINE_CONTEXT || this.props.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) return _react2.default.createElement('div', null);
	
	        var buttonWidth = 35;
	        var buttonHeight = 35;
	        var toolBarWidth = _AudioToolUtils2.default.isAudioTool() ? 0 : _Properties2.default.MAIN_MENU_WIDTH;
	
	        var resizeButtonStyle = {
	            position: 'absolute',
	            top: this.props.windowHeight / 2 - buttonHeight / 2,
	            left: this.props.windowWidth - this.props.accordionWidth - buttonWidth - 5 - toolBarWidth,
	            width: buttonWidth,
	            height: buttonHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none',
	            borderRadius: 50,
	            background: 'white'
	        };
	
	        var iconColor = 'black';
	
	        if (this.state.isOver == true) iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	
	        var element1;
	        var iconStyle;
	
	        if (!this.isAudioEditor()) {
	            // is Cartoonist
	            var slideViewerHeight = _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT + _Properties2.default.SLIDE_VIEWER_LIST_HEIGHT + _Properties2.default.SLIDE_VIEWER_TOP_GAP + _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP;
	            buttonWidth = _Properties2.default.MAIN_RESIZE_BUTTON_WIDTH;
	            buttonHeight = 25;
	
	            resizeButtonStyle = {
	                position: 'absolute',
	                top: (this.props.windowHeight - slideViewerHeight) / 2 - buttonHeight / 2,
	                left: this.props.windowWidth - this.props.accordionWidth - toolBarWidth - buttonWidth,
	                width: buttonWidth,
	                height: buttonHeight,
	                overflowX: 'hidden',
	                overflowY: 'hidden',
	                cursor: 'e-resize',
	                userSelect: 'none',
	                WebkitUserSelect: 'none',
	                userDrag: 'none'
	            };
	
	            iconStyle = {
	                position: 'absolute',
	                top: 0,
	                left: 2
	            };
	
	            element1 = _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/expand_threeDots.svg' });
	        } else {
	            iconStyle = {
	                position: 'absolute',
	                top: 1,
	                left: 11,
	                color: iconColor,
	                cursor: 'default',
	                userSelect: 'none',
	                WebkitUserSelect: 'none',
	                userDrag: 'none'
	            };
	
	            var iconValue = 'fa fa-angle-left fa-2x';
	
	            if (!this.isCollapsed()) {
	                iconValue = 'fa fa-angle-right fa-2x';
	                iconStyle.left = 14;
	            }
	
	            var audioEditorHeight = _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT + _Properties2.default.SLIDE_VIEWER_LIST_HEIGHT + _Properties2.default.SLIDE_VIEWER_TOP_GAP + _AudioEditorUtils2.default.getAudioEditorHeight() + _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP;
	
	            if (_AudioToolUtils2.default.isAudioTool()) {
	                var topBarHeight = 0;
	
	                if (_PlatformDetection2.default.isIOSApp()) topBarHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	                topBarHeight = topBarHeight + _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight();
	
	                resizeButtonStyle.top = _Properties2.default.HEADER_HEIGHT + topBarHeight - buttonHeight;
	
	                if (this.props.isLeft) {
	                    if (_AudioToolUtils2.default.isLeftSideCollapsed()) {
	                        resizeButtonStyle.left = 70;
	                        iconValue = 'fa fa-angle-right fa-2x';
	                        iconStyle.left = 13;
	                    } else {
	                        resizeButtonStyle.left = _Properties2.default.BUTTONS_HOLDER_WIDTH;
	                        iconValue = 'fa fa-angle-left fa-2x';
	                        iconStyle.left = 11;
	                    }
	                }
	            } else resizeButtonStyle.top = (this.props.windowHeight - audioEditorHeight) / 2 - buttonHeight / 2;
	
	            element1 = _react2.default.createElement('i', { style: iconStyle, className: iconValue });
	        }
	
	        if (!this.isAudioEditor()) {
	            // is Cartoonist
	            resizeButtonStyle.boxSizing = 'initial';
	            resizeButtonStyle.fontSize = 'initial';
	            resizeButtonStyle.padding = 0;
	            resizeButtonStyle.margin = 0;
	            resizeButtonStyle.borderStyle = 'none';
	
	            return _react2.default.createElement(
	                'button',
	                { ref: 'holder', 'aria-label': _LocalesManager2.default.getCaption('resizeAccordion', 'hover'), style: resizeButtonStyle, onKeyDown: this.onKeyDown, onTouchStart: this.onMouseDown, onMouseDown: this.onMouseDown, onMouseOver: this.onOver, onMouseOut: this.onOut },
	                element1
	            );
	        } else {
	            resizeButtonStyle.boxSizing = 'initial';
	            resizeButtonStyle.fontSize = 'initial';
	            resizeButtonStyle.padding = 0;
	            resizeButtonStyle.margin = 0;
	            resizeButtonStyle.borderStyle = 'none';
	
	            var ariaLabel = '';
	
	            if (this.props.isLeft) {
	                if (_AudioToolUtils2.default.isLeftSideCollapsed()) ariaLabel = _LocalesManager2.default.getCaption('showRightMenu', 'hover');else ariaLabel = _LocalesManager2.default.getCaption('hideRightMenu', 'hover');
	            } else {
	                if (this.isCollapsed()) ariaLabel = _LocalesManager2.default.getCaption('showRightMenu', 'hover');else ariaLabel = _LocalesManager2.default.getCaption('hideRightMenu', 'hover');
	            }
	
	            return _react2.default.createElement(
	                'button',
	                { ref: 'holder', 'aria-label': ariaLabel, style: resizeButtonStyle, onTouchStart: this.onMouseDown, onClick: this.onMouseDown, onMouseOver: this.onOver, onMouseOut: this.onOut },
	                element1
	            );
	        }
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var contextMode = state.menu.contextMode;
	
	    return {
	        contextMode: contextMode
	    };
	}
	
	var ResizeAccordionButton = exports.ResizeAccordionButton = (0, _reactRedux.connect)(mapStateToProps)(ResizeAccordionButtonContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ResizeAccordionButton.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ResizeAccordionButton.js"); } } })();

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SearchMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ListItemRenderer = __webpack_require__(167);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _ClipartSelectorListNew = __webpack_require__(329);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _SoundItemRenderer = __webpack_require__(138);
	
	var _VideoClipartParserJSON = __webpack_require__(324);
	
	var _VideoClipartParserJSON2 = _interopRequireDefault(_VideoClipartParserJSON);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _PopulateMediaFilesUtils = __webpack_require__(80);
	
	var _PopulateMediaFilesUtils2 = _interopRequireDefault(_PopulateMediaFilesUtils);
	
	var _ClipartParserJSONNew = __webpack_require__(168);
	
	var _ClipartParserJSONNew2 = _interopRequireDefault(_ClipartParserJSONNew);
	
	var _OnOffToggleButton = __webpack_require__(122);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _cartoonistIcons = __webpack_require__(207);
	
	var _cartoonistIcons2 = _interopRequireDefault(_cartoonistIcons);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _MoodsUtils = __webpack_require__(124);
	
	var _MoodsUtils2 = _interopRequireDefault(_MoodsUtils);
	
	var _MindMapUtils = __webpack_require__(85);
	
	var _MindMapUtils2 = _interopRequireDefault(_MindMapUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClipartList = _react2.default.createClass({
	    displayName: 'ClipartList',
	    getInitialState: function getInitialState() {
	        return {
	            currentPage: 0,
	            oldElements: [],
	            dataProvider: this.props.dataProvider
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.searchObject != nextProps.searchObject || this.props.dataProvider != nextProps.dataProvider) {
	            _MasterUniverseUtils2.default.scrollPosition = 0;
	
	            this.setState({
	                currentPage: 0,
	                dataProvider: nextProps.dataProvider
	            });
	        }
	    },
	    uploadNewPage: function uploadNewPage(scrollTop) {
	        var _this = this;
	
	        if (Math.abs(scrollTop - _MasterUniverseUtils2.default.scrollPosition) < 40) return;
	
	        _MasterUniverseUtils2.default.scrollPosition = scrollTop;
	
	        var searchObject = this.props.searchObject;
	
	        if (!searchObject) return;
	
	        _ApiService2.default.searchNewContent(searchObject.locale, searchObject.category, searchObject.searchText, this.state.currentPage + 1, searchObject.pageSize).then(function (response) {
	            if (!response || response.length < 1) {
	                _this.setState({
	                    currentPage: _this.state.currentPage + 1
	                });
	            } else {
	                var newPageItems = _ClipartParserJSONNew2.default.parseSearchItems(response, searchObject.searchText, searchObject.category);
	                _this.setState({
	                    dataProvider: _this.state.dataProvider.concat(newPageItems),
	                    currentPage: _this.state.currentPage + 1
	                });
	            }
	        });
	    },
	    render: function render() {
	        var items = this.state.dataProvider ? this.state.dataProvider : this.props.dataProvider;
	        var isLoading = this.props.isLoading;
	
	        if (isLoading) {
	            var preloaderStyle = {
	                position: 'relative',
	                top: this.props.top,
	                fontSize: '15px',
	                marginLeft: this.props.width / 2 - 15
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { style: preloaderStyle },
	                _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-2x' })
	            );
	        } else {
	            if (this.props.isSearch && this.props.noHits) {
	                var divStyle = {
	                    position: 'relative',
	                    top: this.props.top,
	                    width: this.props.width,
	                    textAlign: 'center',
	                    fontSize: '15px'
	                };
	
	                return _react2.default.createElement(
	                    'div',
	                    { style: divStyle },
	                    _LocalesManager2.default.getCaption('searchNoHits', 'other')
	                );
	            }
	        }
	
	        var paddingTop = 12;
	        var paddingLeft = 3;
	        var componentProperties = {};
	        var elements = [];
	        var i = void 0;
	        var showBackgroundsButton = false;
	
	        for (i = 0; i < items.length; i++) {
	            var item = items[i];
	            var isBackground = false;
	
	            if (item.isBackground || item.logicalName && item.logicalName.indexOf('background') != -1 || item.href && item.href.indexOf('background') != -1) {
	                isBackground = true;
	                showBackgroundsButton = true;
	            }
	
	            var key = 'item_' + new Date().getTime() + '_' + i;
	
	            elements.push(_react2.default.createElement(_ListItemRenderer.ListItemRenderer, { item: item, key: key, isBackground: isBackground, usePagination: true, index: i, isSearch: true, parentWidth: this.props.width }));
	        }
	
	        componentProperties.paddingTop = paddingTop;
	        componentProperties.paddingLeft = paddingLeft;
	        componentProperties.width = this.props.width;
	        componentProperties.top = this.props.top;
	        componentProperties.displayState = 'inline-block';
	        componentProperties.height = this.props.height;
	        componentProperties.elements = elements;
	
	        componentProperties.usePagination = true;
	        componentProperties.uploadNewPage = this.uploadNewPage;
	
	        var onOffButton;
	
	        if (this.props.isBackgroundList && showBackgroundsButton) {
	            var topGap = 0;
	            var bottomGap = 0;
	            var onOffButtonProperties = {};
	
	            onOffButtonProperties.topPosition = componentProperties.top + topGap;
	            onOffButtonProperties.leftPosition = _Properties2.default.MY_MEDIA_FILES_GAP;
	            onOffButtonProperties.trackWidth = _Properties2.default.TOGGLE_TRACK_WIDTH;
	            onOffButtonProperties.trackHeight = _Properties2.default.TOGGLE_TRACK_HEIGHT;
	            onOffButtonProperties.thumbHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
	            onOffButtonProperties.thumbSize = _Properties2.default.TOGGLE_THUMB_SIZE;
	            onOffButtonProperties.dispatch = this.props.dispatch;
	            onOffButtonProperties.width = _Properties2.default.BROWSER_WIDTH - 2 * _Properties2.default.MY_MEDIA_FILES_GAP;
	
	            onOffButtonProperties.isBackgroundElement = true;
	            onOffButtonProperties.useBackgroundAsImage = this.props.useBackgroundAsImage;
	
	            onOffButton = _react2.default.createElement(_OnOffToggleButton.OnOffToggleButton, { properties: onOffButtonProperties, dispatch: this.props.dispatch });
	
	            var toggleButtonHeight = onOffButtonProperties.thumbSize + topGap + bottomGap;
	
	            componentProperties.top = componentProperties.top + toggleButtonHeight;
	            componentProperties.height = componentProperties.height - toggleButtonHeight;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            onOffButton,
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	var MediaList = _react2.default.createClass({
	    displayName: 'MediaList',
	    getInitialState: function getInitialState() {
	        return {
	            currentPage: 0,
	            dataProvider: this.props.dataProvider,
	            elements: this.getCurrentElements(this.props.dataProvider, 0)
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.dataProvider != nextProps.dataProvider) {
	            _MasterUniverseUtils2.default.scrollPosition = 0;
	
	            this.setState({
	                currentPage: 0,
	                dataProvider: nextProps.dataProvider,
	                elements: this.getCurrentElements(nextProps.dataProvider, 0)
	            });
	        }
	    },
	    uploadNewPage: function uploadNewPage(scrollTop) {
	        if (Math.abs(scrollTop - _MasterUniverseUtils2.default.scrollPosition) < 40) return;
	
	        _MasterUniverseUtils2.default.scrollPosition = scrollTop;
	
	        this.setState({
	            elements: this.getCurrentElements(this.state.dataProvider, this.state.currentPage + 1),
	            currentPage: this.state.currentPage + 1
	        });
	    },
	    getCurrentElements: function getCurrentElements(allElements, page) {
	        var hitsPerPage = 50;
	        var maxIndex = hitsPerPage * (page + 1);
	        var items = [];
	
	        for (var i = 0; i < allElements.length; i++) {
	            if (i < maxIndex) items.push(allElements[i]);else break;
	        }
	
	        return items;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.elements == undefined) return _react2.default.createElement('div', null);
	
	        var items = this.state.elements;
	        var isLoading = this.props.isLoading;
	
	        if (isLoading) {
	            var preloaderStyle = {
	                position: 'relative',
	                top: this.props.top,
	                fontSize: '15px',
	                marginLeft: this.props.width / 2 - 15
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { style: preloaderStyle },
	                _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-2x' })
	            );
	        } else {
	            if (this.props.isSearch && this.props.noHits) {
	                var divStyle = {
	                    position: 'relative',
	                    top: this.props.top,
	                    width: this.props.width,
	                    textAlign: 'center',
	                    fontSize: '15px'
	                };
	
	                return _react2.default.createElement(
	                    'div',
	                    { style: divStyle },
	                    _LocalesManager2.default.getCaption('searchNoHits', 'other')
	                );
	            }
	        }
	
	        if (!_PlatformDetection2.default.isIOSApp() && !_MindMapUtils2.default.isMindMapMode()) {
	            if (this.props.isMyMedia) items = [{ isUploadButton: true }].concat(items);
	        }
	
	        var paddingTop = 12;
	        var paddingLeft = 3;
	        var componentProperties = {};
	        var elements = [];
	        var i = void 0;
	
	        for (i = 0; i < items.length; i++) {
	            var item = items[i];
	            var key = 'item_' + new Date().getTime() + '_' + i;
	
	            elements.push(_react2.default.createElement(_ListItemRenderer.ListItemRenderer, { item: item, key: key, isFrame: this.props.isFrame, isBackground: this.props.isBackground, isMedia: this.props.isMedia, isVideo: this.props.isVideo, usePagination: true, index: i, isSearch: true, parentWidth: this.props.width }));
	        }
	
	        componentProperties.paddingTop = paddingTop;
	        componentProperties.paddingLeft = paddingLeft;
	        componentProperties.width = this.props.width;
	        componentProperties.top = this.props.top;
	        componentProperties.displayState = 'inline-block';
	        componentProperties.height = this.props.height;
	        componentProperties.elements = elements;
	
	        componentProperties.usePagination = true;
	        componentProperties.uploadNewPage = this.uploadNewPage;
	
	        var onOffButton;
	
	        if (this.props.isBackgroundList && !_MindMapUtils2.default.isMindMapMode()) {
	            var topGap = 0;
	            var bottomGap = 0;
	            var onOffButtonProperties = {};
	
	            onOffButtonProperties.topPosition = componentProperties.top + topGap;
	            onOffButtonProperties.leftPosition = _Properties2.default.MY_MEDIA_FILES_GAP;
	            onOffButtonProperties.trackWidth = _Properties2.default.TOGGLE_TRACK_WIDTH;
	            onOffButtonProperties.trackHeight = _Properties2.default.TOGGLE_TRACK_HEIGHT;
	            onOffButtonProperties.thumbHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
	            onOffButtonProperties.thumbSize = _Properties2.default.TOGGLE_THUMB_SIZE;
	            onOffButtonProperties.dispatch = this.props.dispatch;
	            onOffButtonProperties.width = _Properties2.default.BROWSER_WIDTH - 2 * _Properties2.default.MY_MEDIA_FILES_GAP;
	
	            if (this.props.isMedia) {
	                onOffButtonProperties.isMediaFilesElement = true;
	
	                if (this.props.isVideo) {
	                    onOffButtonProperties.useVideoAsBackground = this.props.useVideoAsBackground;
	                    onOffButtonProperties.isVideo = true;
	                } else {
	                    onOffButtonProperties.useImageAsBackground = this.props.useImageAsBackground;
	                    onOffButtonProperties.isVideo = false;
	                }
	            } else {
	                onOffButtonProperties.isBackgroundElement = true;
	                onOffButtonProperties.isFrame = true;
	                onOffButtonProperties.useFrameAsImage = this.props.useFrameAsImage;
	            }
	
	            onOffButton = _react2.default.createElement(_OnOffToggleButton.OnOffToggleButton, { properties: onOffButtonProperties, dispatch: this.props.dispatch });
	
	            var toggleButtonHeight = onOffButtonProperties.thumbSize + topGap + bottomGap;
	
	            componentProperties.top = componentProperties.top + toggleButtonHeight;
	            componentProperties.height = componentProperties.height - toggleButtonHeight;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            onOffButton,
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	var VideoThemesList = _react2.default.createClass({
	    displayName: 'VideoThemesList',
	    getInitialState: function getInitialState() {
	        return {
	            currentPage: 0,
	            oldElements: [],
	            dataProvider: this.props.dataProvider
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.searchObject != nextProps.searchObject || this.props.dataProvider != nextProps.dataProvider) {
	            _MasterUniverseUtils2.default.scrollPosition = 0;
	
	            this.setState({
	                currentPage: 0,
	                dataProvider: nextProps.dataProvider
	            });
	        }
	    },
	    uploadNewPage: function uploadNewPage(scrollTop) {
	        var _this2 = this;
	
	        if (Math.abs(scrollTop - _MasterUniverseUtils2.default.scrollPosition) < 40) return;
	
	        _MasterUniverseUtils2.default.scrollPosition = scrollTop;
	
	        var searchObject = this.props.searchObject;
	
	        if (!searchObject) return;
	
	        _ApiService2.default.searchVideo(searchObject.locale, searchObject.searchText, this.state.currentPage + 1, searchObject.pageSize).then(function (response) {
	            if (!response || response.length < 1) {
	                _this2.setState({
	                    currentPage: _this2.state.currentPage + 1
	                });
	            } else {
	                var newPageItems = _VideoClipartParserJSON2.default.parseSearchItems(response);
	                _this2.setState({
	                    dataProvider: _this2.state.dataProvider.concat(newPageItems),
	                    currentPage: _this2.state.currentPage + 1
	                });
	            }
	        });
	    },
	    render: function render() {
	        var items = this.state.dataProvider ? this.state.dataProvider : this.props.dataProvider;
	        var isLoading = this.props.isLoading;
	
	        if (isLoading) {
	            var preloaderStyle = {
	                position: 'relative',
	                top: this.props.top,
	                fontSize: '15px',
	                marginLeft: this.props.width / 2 - 15
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { style: preloaderStyle },
	                _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse fa-2x' })
	            );
	        } else {
	            if (this.props.isSearch && this.props.noHits) {
	                var divStyle = {
	                    position: 'relative',
	                    top: this.props.top,
	                    width: this.props.width,
	                    textAlign: 'center',
	                    fontSize: '15px'
	                };
	
	                return _react2.default.createElement(
	                    'div',
	                    { style: divStyle },
	                    _LocalesManager2.default.getCaption('searchNoHits', 'other')
	                );
	            }
	        }
	
	        var paddingTop = 12;
	        var paddingLeft = 3;
	        var componentProperties = {};
	        var elements = [];
	        var i = void 0;
	        var showBackgroundsButton = false;
	
	        for (i = 0; i < items.length; i++) {
	            var item = items[i];
	            var key = 'item_' + new Date().getTime() + '_' + i;
	
	            elements.push(_react2.default.createElement(_ListItemRenderer.ListItemRenderer, { item: item, key: key, isVideo: true, usePagination: true, index: i, isSearch: true, parentWidth: this.props.width }));
	        }
	
	        componentProperties.paddingTop = paddingTop;
	        componentProperties.paddingLeft = paddingLeft;
	        componentProperties.width = this.props.width;
	        componentProperties.top = this.props.top;
	        componentProperties.displayState = 'inline-block';
	        componentProperties.height = this.props.height;
	        componentProperties.elements = elements;
	
	        componentProperties.usePagination = true;
	        componentProperties.uploadNewPage = this.uploadNewPage;
	
	        var onOffButton;
	        var topGap = 0;
	        var bottomGap = 0;
	        var onOffButtonProperties = {};
	
	        onOffButtonProperties.topPosition = componentProperties.top + topGap;
	        onOffButtonProperties.leftPosition = _Properties2.default.MY_MEDIA_FILES_GAP;
	        onOffButtonProperties.trackWidth = _Properties2.default.TOGGLE_TRACK_WIDTH;
	        onOffButtonProperties.trackHeight = _Properties2.default.TOGGLE_TRACK_HEIGHT;
	        onOffButtonProperties.thumbHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
	        onOffButtonProperties.thumbSize = _Properties2.default.TOGGLE_THUMB_SIZE;
	        onOffButtonProperties.dispatch = this.props.dispatch;
	        onOffButtonProperties.width = _Properties2.default.BROWSER_WIDTH - 2 * _Properties2.default.MY_MEDIA_FILES_GAP;
	
	        onOffButtonProperties.isMediaFilesElement = true;
	        onOffButtonProperties.useVideoAsBackground = this.props.useVideoAsBackground;
	        onOffButtonProperties.isVideo = true;
	
	        onOffButton = _react2.default.createElement(_OnOffToggleButton.OnOffToggleButton, { properties: onOffButtonProperties, dispatch: this.props.dispatch });
	
	        var toggleButtonHeight = onOffButtonProperties.thumbSize + topGap + bottomGap;
	
	        componentProperties.top = componentProperties.top + toggleButtonHeight;
	        componentProperties.height = componentProperties.height - toggleButtonHeight;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            onOffButton,
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	var AudioList = _react2.default.createClass({
	    displayName: 'AudioList',
	    render: function render() {
	        if (this.props.isSearch && this.props.noHits) {
	            var divStyle = {
	                position: 'relative',
	                top: this.props.top,
	                width: this.props.width,
	                textAlign: 'center',
	                fontSize: '15px'
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { style: divStyle },
	                _LocalesManager2.default.getCaption('searchNoHits', 'other')
	            );
	        }
	
	        var elements = [];
	        var i;
	        var item;
	
	        for (i = 0; i < this.props.dataProvider.length; i++) {
	            item = this.props.dataProvider[i];
	            var key = 'item_' + new Date().getTime() + '_' + i;
	
	            elements.push(_react2.default.createElement(_SoundItemRenderer.SoundItemRenderer, { accordionWidth: this.props.accordionWidth, index: i, key: key, dispatch: this.props.dispatch, value: item, isMediaSound: this.props.isMediaSound }));
	        }
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = this.props.height;
	        componentProperties.top = this.props.top;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = elements;
	        componentProperties.scrollHeight = (_Properties2.default.SOUND_ITEM_HEIGHT + _Properties2.default.SOUND_ITEMS_GAP) * elements.length;
	
	        return _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties });
	    }
	});
	
	var CartoonistTabElement = _react2.default.createClass({
	    displayName: 'CartoonistTabElement',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    getCorrectIndex: function getCorrectIndex() {
	        var index = this.props.index;
	
	        if (_MindMapUtils2.default.isMindMapMode()) {
	            if (index === 3) // 4th element should be Effects
	                index = 5;
	
	            if (index === 4) // last tab should be MyImages
	                index = 7;
	        }
	
	        return index;
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        var tabIndex = this.props.cartoonistTabIndex;
	        var index = this.getCorrectIndex();
	
	        if (index != tabIndex) dispatch((0, _MenuActions.changeCartoonistTabIndex)(index));
	
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('closeButton');
	
	            if (element) element.focus();
	        }.bind(this), 100);
	    },
	    render: function render() {
	        var tabHeight = 50;
	        var topPosition = tabHeight * this.props.index;
	        var buttonColor;
	        var icon;
	        var color;
	        var tabIndex = this.props.cartoonistTabIndex;
	        var index = this.getCorrectIndex();
	
	        if (index == tabIndex) {
	            buttonColor = '#434343';
	            color = 'white';
	        } else {
	            if (this.state.isOver == true) {
	                buttonColor = '#F7F7F7';
	                color = '#2299D6';
	            } else {
	                buttonColor = 'white';
	                color = '#434343';
	            }
	        }
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.width,
	            height: tabHeight,
	            top: topPosition,
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none',
	            textAlign: 'left'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 17,
	            left: 40,
	            color: color,
	            fontSize: 15,
	            width: this.props.width - 50,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var text = void 0;
	
	        switch (index) {
	            case 0:
	                {
	                    text = _LocalesManager2.default.getCaption('SearchAll', 'other');
	                    icon = 'cart-search';
	                    break;
	                }
	            case 1:
	                {
	                    text = _LocalesManager2.default.getCaption('SearchProps', 'other');
	                    icon = 'cart-football';
	                    break;
	                }
	            case 2:
	                {
	                    text = _LocalesManager2.default.getCaption('SearchCharacters', 'other');
	                    icon = 'cart-character';
	                    break;
	                }
	            case 3:
	                {
	                    text = _LocalesManager2.default.getCaption('SearchBackgrounds', 'other');
	                    icon = 'cart-background';
	                    break;
	                }
	            case 4:
	                {
	                    text = _LocalesManager2.default.getCaption('SearchFrames', 'other');
	                    icon = 'cart-frame';
	                    break;
	                }
	            case 5:
	                {
	                    text = _LocalesManager2.default.getCaption('SearchEffects', 'other');
	                    icon = 'cart-effect';
	                    break;
	                }
	            case 6:
	                {
	                    text = _LocalesManager2.default.getCaption('SearchThemes', 'other');
	                    icon = 'cart-themes';
	                    break;
	                }
	            case 7:
	                {
	                    text = _LocalesManager2.default.getCaption('SearchMyImages', 'other');
	                    icon = 'cart-camera';
	                    break;
	                }
	            case 8:
	                {
	                    text = _LocalesManager2.default.getCaption('SearchMyVideos', 'other');
	                    icon = 'cart-video-camera';
	                    break;
	                }
	            case 9:
	                {
	                    text = _LocalesManager2.default.getCaption('SearchThemeVideos');
	                    icon = 'cart-video-play';
	                    break;
	                }
	            case 10:
	                {
	                    text = _LocalesManager2.default.getCaption('SearchAudios', 'other');
	                    icon = 'cart-music';
	                    break;
	                }
	        }
	        var iconStyle = {
	            position: 'absolute',
	            top: 17,
	            left: 15,
	            fontSize: 18,
	            color: color
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': text, style: tabStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement('i', { style: iconStyle, className: _cartoonistIcons2.default[icon] }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            )
	        );
	    }
	});
	
	var AudioTabElement = _react2.default.createClass({
	    displayName: 'AudioTabElement',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        var tabIndex = this.props.audioTabIndex;
	
	        if (this.props.index == tabIndex) dispatch((0, _MenuActions.changeAudioTabIndex)(-1));else dispatch((0, _MenuActions.changeAudioTabIndex)(this.props.index));
	    },
	    render: function render() {
	        var topPosition = _Properties2.default.BROWSER_BUTTON_HEIGHT * this.props.index + 1;
	        var buttonColor;
	        var textColor;
	        var icon;
	        var iconColor;
	        var tabIndex = this.props.audioTabIndex;
	
	        if (this.props.index == tabIndex) {
	            buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            textColor = '#F7F7F7';
	            icon = 'fa fa-angle-down';
	            iconColor = 'white';
	        } else {
	            icon = 'fa fa-angle-right';
	            iconColor = 'black';
	
	            if (this.state.isOver == true) {
	                buttonColor = _Properties2.default.BROWSER_HOVER_COLOR;
	                textColor = '#2299D6';
	            } else {
	                buttonColor = _Properties2.default.BROWSER_COLOR;
	                textColor = '#000000';
	            }
	        }
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.BROWSER_BUTTON_HEIGHT - 1,
	            paddingLeft: _Properties2.default.BROWSER_LEFT_PADDING,
	            top: topPosition,
	            color: 'white',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none',
	            margin: 0,
	            paddingTop: 0,
	            paddingRight: 0,
	            paddingBottom: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none',
	            textAlign: 'left'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 5,
	            color: textColor,
	            fontSize: 15,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 6,
	            right: _Properties2.default.BROWSER_LEFT_PADDING + _Properties2.default.BROWSER_ICON_RIGHT_PADDING,
	            color: iconColor
	        };
	
	        var text;
	
	        if (this.props.index == 0) text = _LocalesManager2.default.getCaption('StorySoundTab', 'music');else text = _LocalesManager2.default.getCaption('SlideSoundTab', 'music');
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': text, style: tabStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: icon })
	        );
	    }
	});
	
	var SearchMenuContent = _react2.default.createClass({
	    displayName: 'SearchMenuContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            dataProvider: [],
	            searchText: _TextSizeUtils2.default.searchText,
	            startText: _LocalesManager2.default.getCaption('searchText', 'other'),
	            startTextAbp: _LocalesManager2.default.getCaption('searchTextAbp', 'other'),
	            isLoading: false,
	            noHits: false,
	            myVideos: [],
	            titleWidth: this.getMaximumTitleWidth()
	        };
	    },
	    getMaximumTitleWidth: function getMaximumTitleWidth() {
	        var maxim = _TextSizeUtils2.default.getSpanWidth(15, _LocalesManager2.default.getCaption('SearchAll', 'other'));
	
	        maxim = Math.max(maxim, _TextSizeUtils2.default.getSpanWidth(15, _LocalesManager2.default.getCaption('SearchProps', 'other')));
	        maxim = Math.max(maxim, _TextSizeUtils2.default.getSpanWidth(15, _LocalesManager2.default.getCaption('SearchCharacters', 'other')));
	        maxim = Math.max(maxim, _TextSizeUtils2.default.getSpanWidth(15, _LocalesManager2.default.getCaption('SearchBackgrounds', 'other')));
	        maxim = Math.max(maxim, _TextSizeUtils2.default.getSpanWidth(15, _LocalesManager2.default.getCaption('SearchFrames', 'other')));
	        maxim = Math.max(maxim, _TextSizeUtils2.default.getSpanWidth(15, _LocalesManager2.default.getCaption('SearchEffects', 'other')));
	        maxim = Math.max(maxim, _TextSizeUtils2.default.getSpanWidth(15, _LocalesManager2.default.getCaption('SearchThemes', 'other')));
	        maxim = Math.max(maxim, _TextSizeUtils2.default.getSpanWidth(15, _LocalesManager2.default.getCaption('SearchMyImages', 'other')));
	        maxim = Math.max(maxim, _TextSizeUtils2.default.getSpanWidth(15, _LocalesManager2.default.getCaption('SearchMyVideos', 'other')));
	        maxim = Math.max(maxim, _TextSizeUtils2.default.getSpanWidth(15, _LocalesManager2.default.getCaption('SearchThemeVideos')));
	        maxim = Math.max(maxim, _TextSizeUtils2.default.getSpanWidth(15, _LocalesManager2.default.getCaption('SearchAudios', 'other')));
	
	        return maxim;
	    },
	    componentDidMount: function componentDidMount() {
	        this.ensureMyMediaFilesIsLoaded();
	        this.loadMyFramesTheme();
	
	        var isApiSearch = this.props.cartoonistTabIndex == 1 || this.props.cartoonistTabIndex == 2 || this.props.cartoonistTabIndex == 3 || this.props.cartoonistTabIndex == 9 || this.isAbpUniverse();
	
	        if (isApiSearch) // if it's all and no search then don't show items, otherwise (backgrounds, props, characters, clipart videos) should search for all these items
	            this.performSearch();else {
	            if (_TextSizeUtils2.default.searchText != '') this.performSearch();
	        }
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.contextMode === _ModeConstants2.default.SEARCH_CONTEXT && this.props.contextMode != nextProps.contextMode) this.startAnimation();
	
	        if (nextProps.contextMode === _ModeConstants2.default.SEARCH_CONTEXT && this.props.showVideoEditor !== nextProps.showVideoEditor && nextProps.showVideoEditor === false) this.startAnimation();
	
	        var doSearch = false;
	
	        if (this.isAbpUniverse() && this.props.contextMode != nextProps.contextMode && nextProps.contextMode == _ModeConstants2.default.SEARCH_CONTEXT && this.state.dataProvider && this.state.dataProvider.length == 0) doSearch = true;
	
	        if (this.props.cartoonistTabIndex != nextProps.cartoonistTabIndex || this.props.mediaFilesDataProvider != nextProps.mediaFilesDataProvider || doSearch) {
	            this.setState({
	                dataProvider: [],
	                noHits: false
	            });
	
	            setTimeout(function () {
	                this.performSearch();
	            }.bind(this), 10);
	        }
	
	        if (this.props.contextMode == _ModeConstants2.default.SEARCH_CONTEXT && nextProps.contextMode != _ModeConstants2.default.SEARCH_CONTEXT) this.clearSearch();
	    },
	    ensureMyMediaFilesIsLoaded: function ensureMyMediaFilesIsLoaded() {
	        var state = _StoreManager2.default.getState();
	        var mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
	
	        if (!mediaFilesDataProvider && !_Configuration2.default.LOAD_LOCAL) {
	            _ApiServiceUtils2.default.executeSafeApiCall(this.loadMyMediaFiles.bind(this));
	        }
	    },
	    loadMyFramesTheme: function loadMyFramesTheme() {
	        if (_Configuration2.default.LOAD_LOCAL) return;
	
	        if (_ClipartParserJSONNew2.default.frames) return;
	
	        _ApiServiceUtils2.default.executeSafeApiCall(function () {
	            _ApiService2.default.loadCurrentTheme('frames').then(function (response) {
	                _ClipartParserJSONNew2.default.parseClipartModel(response, false, '', true);
	            });
	        }.bind(this));
	    },
	    loadMyMediaFiles: function loadMyMediaFiles() {
	        _ApiServiceUtils2.default.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
	    },
	    parseMediaItems: function parseMediaItems(items) {
	        _PopulateMediaFilesUtils2.default.parseMediaItems(items, _StoreManager2.default.getStore().dispatch);
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    changeFocus: function changeFocus() {
	        var view = this.refs.searchInput;
	
	        if (view) {
	            view.focus();
	
	            if (view.value && view.value.length > 0) view.select();
	        }
	    },
	    onInputClick: function onInputClick(e) {
	        if (this.refs.searchInput && _TextSizeUtils2.default.searchText != '' && this.refs.searchInput.value != _TextSizeUtils2.default.searchText) {
	            this.refs.searchInput.value = _TextSizeUtils2.default.searchText;
	            this.performSearch();
	        } else {
	            if (this.isAbpUniverse()) this.performSearch();
	        }
	
	        this.changeFocus();
	
	        this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.SEARCH_CONTEXT));
	    },
	    onChangeText: function onChangeText() {
	        if (_TextSizeUtils2.default.searchText == '' || this.refs.searchInput.value == '') {
	            _TextSizeUtils2.default.searchText = this.refs.searchInput.value;
	
	            this.forceUpdate();
	        } else _TextSizeUtils2.default.searchText = this.refs.searchInput.value;
	
	        if (this.props.contextMode != _ModeConstants2.default.SEARCH_CONTEXT) {
	            this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.SEARCH_CONTEXT));
	
	            setTimeout(function () {
	                this.performSearch(true);
	            }.bind(this), 10);
	        } else this.performSearch(true);
	    },
	    getSounds: function getSounds() {
	        var clipartModel = _StoreManager2.default.getState().music.soundClipartModel;
	
	        if (!clipartModel) return [];
	
	        var i, j, k;
	        var mainItems = clipartModel.items;
	        var searchText = this.refs.searchInput.value.toLowerCase();
	        var array = [];
	        var title;
	
	        for (i = 0; i < mainItems.length; i++) {
	            var secondItems = mainItems[i].items;
	
	            for (j = 0; j < secondItems.length; j++) {
	                var finalItems = secondItems[j].items;
	
	                for (k = 0; k < finalItems.length; k++) {
	                    var element = finalItems[k];
	                    title = element.title.toLowerCase();
	
	                    if (title.indexOf(searchText) != -1) array.push(element);
	                }
	            }
	        }
	
	        var state = _StoreManager2.default.getState();
	        var mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
	
	        if (mediaFilesDataProvider) {
	            var mySounds = mediaFilesDataProvider.soundsDataProvider;
	
	            for (i = 0; i < mySounds.length; i++) {
	                if (mySounds && mySounds[i] && mySounds[i].title) {
	                    title = mySounds[i].title.toLowerCase();
	
	                    if (title.indexOf(searchText) != -1) array.push(mySounds[i]);
	                }
	            }
	        }
	
	        return array;
	    },
	    filterContent: function filterContent(array) {
	        var isThemes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (!this.refs.searchInput || this.refs.searchInput.value == '' || this.refs.searchInput.value == undefined) return array;else {
	            var searchText = this.refs.searchInput.value.toLowerCase();
	            var newArray = [];
	
	            for (var i = 0; i < array.length; i++) {
	                var title = isThemes ? this.getTitle(array[i]).toLowerCase() : array[i].title.toLowerCase();
	
	                if (title.indexOf(searchText) != -1) newArray.push(array[i]);
	            }
	
	            return newArray;
	        }
	    },
	    getThemes: function getThemes() {
	        var array = _MasterUniverseUtils2.default.getAllThemes();
	
	        return this.filterContent(array, true);
	    },
	    getEffects: function getEffects() {
	        if (!_ClipartParserJSONNew2.default.cartoonistEffects) return [];
	
	        var array = _ClipartParserJSONNew2.default.cartoonistEffects.items;
	
	        return this.filterContent(array);
	    },
	    getFrames: function getFrames() {
	        if (!_ClipartParserJSONNew2.default.frames) return [];
	
	        var array = _ClipartParserJSONNew2.default.frames.items;
	
	        return this.filterContent(array);
	    },
	    getMyImages: function getMyImages() {
	        var mediaFilesDataProvider = _StoreManager2.default.getState().accordion.mediaFilesDataProvider;
	
	        if (!mediaFilesDataProvider || !mediaFilesDataProvider.imagesDataProvider) {
	            this.ensureMyMediaFilesIsLoaded();
	            return [];
	        }
	
	        var array = mediaFilesDataProvider.imagesDataProvider;
	
	        return this.filterContent(array);
	    },
	    getMyVideos: function getMyVideos() {
	        var mediaFilesDataProvider = _StoreManager2.default.getState().accordion.mediaFilesDataProvider;
	
	        if (!mediaFilesDataProvider || !mediaFilesDataProvider.videosDataProvider) {
	            this.ensureMyMediaFilesIsLoaded();
	            return [];
	        }
	
	        var array = mediaFilesDataProvider.videosDataProvider;
	
	        return this.filterContent(array);
	    },
	    getTitle: function getTitle(item) {
	        if (!item.translations) return item.name;else {
	            var translation = item.translations[_MasterUniverseUtils2.default.language()];
	
	            if (translation && translation.length > 0) return translation;else if (item.translations['en_US']) return item.translations['en_US'];else return item.name;
	        }
	    },
	    doSearch: function doSearch() {
	        var isKeyboardEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this.setState({
	            isLoading: true
	        });
	
	        if (isKeyboardEvent) {
	            _PopulateMediaFilesUtils2.default.searchTime = new Date().getTime();
	
	            setTimeout(this.doSearchTimeout.bind(this), 2000);
	        } else {
	            this.executeSearchContentCall();
	        }
	    },
	    doSearchTimeout: function doSearchTimeout() {
	        var currentTime = new Date().getTime();
	
	        if (currentTime - _PopulateMediaFilesUtils2.default.searchTime >= 2000) {
	            this.executeSearchContentCall();
	        }
	    },
	    performSearch: function performSearch() {
	        var isKeyboardEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (_Configuration2.default.LOAD_LOCAL) {
	            if (this.props.cartoonistTabIndex == 8) this.setState({
	                dataProvider: _PopulateMediaFilesUtils2.default.getVideosDataProviderForTest()
	            });else this.setState({
	                dataProvider: _PopulateMediaFilesUtils2.default.getImagesDataProviderForTest()
	            });
	
	            return;
	        }
	
	        if (this.isAbpUniverse()) {
	            this.doSearch(isKeyboardEvent); // do search for abp content
	            return;
	        }
	
	        var noHitsValue = false;
	        var dataProvider;
	
	        if (this.isAudioTool()) {
	            dataProvider = this.getSounds();
	
	            if (!dataProvider || dataProvider.length < 1) noHitsValue = true;
	
	            this.setState({
	                dataProvider: dataProvider,
	                noHits: noHitsValue
	            });
	
	            return;
	        }
	
	        switch (true) {
	            case this.props.cartoonistTabIndex == 4:
	                {
	                    dataProvider = this.getFrames();
	                    break;
	                }
	            case this.props.cartoonistTabIndex == 5:
	                {
	                    dataProvider = this.getEffects();
	                    break;
	                }
	            case this.props.cartoonistTabIndex == 6:
	                {
	                    dataProvider = this.getThemes();
	                    break;
	                }
	            case this.props.cartoonistTabIndex == 7:
	                {
	                    dataProvider = this.getMyImages();
	                    break;
	                }
	            case this.props.cartoonistTabIndex == 8:
	                {
	                    // My videos
	                    dataProvider = this.getMyVideos();
	                    break;
	                }
	            case this.props.cartoonistTabIndex == 9:
	                {
	                    // Clipart Video
	                    // search for Video Clipart content ... here is needed for a search
	                    break;
	                }
	            case this.props.cartoonistTabIndex == 10:
	                {
	                    dataProvider = this.getSounds();
	                    break;
	                }
	        }
	
	        if (this.props.cartoonistTabIndex >= 4 && this.props.cartoonistTabIndex != 9) {
	            // no api call search is needed
	            if (!dataProvider || dataProvider.length < 1) noHitsValue = true;
	
	            this.setState({
	                dataProvider: dataProvider,
	                noHits: noHitsValue
	            });
	
	            return;
	        }
	
	        var isVideoClipart = this.props.cartoonistTabIndex == 9;
	
	        if (!isVideoClipart) {
	            var isApiSearch = this.props.cartoonistTabIndex == 1 || this.props.cartoonistTabIndex == 2 || this.props.cartoonistTabIndex == 3;
	
	            if (!isApiSearch) {
	                // if it's all category and no search on api then don't show items, otherwise (backgrounds, props, characters) show all items
	                if (!this.isSearchMode()) {
	                    setTimeout(function () {
	                        this.setState({
	                            dataProvider: [],
	                            noHits: false
	                        });
	                    }.bind(this), 50);
	
	                    return;
	                }
	            }
	        }
	
	        if (_Configuration2.default.LOAD_LOCAL) {
	            this.setState({
	                dataProvider: []
	            });
	        } else {
	            this.doSearch(isKeyboardEvent); // do search for backgrounds, props, characters and videos (clipart videos) and abp content
	        }
	    },
	    executeSearchContentCall: function executeSearchContentCall() {
	        var _this3 = this;
	
	        var searchValue = '';
	
	        if (this.refs.searchInput && this.refs.searchInput.value.length > 0) searchValue = this.refs.searchInput.value;
	
	        var isVideo = this.props.cartoonistTabIndex == 9;
	        var locale = _AppParameters2.default.locale;
	        var pageSize = 50;
	        var searchObject = {};
	
	        if (isVideo) {
	            _ApiService2.default.searchVideo(locale, searchValue, 0, pageSize).then(function (response) {
	                searchObject.locale = locale;
	                searchObject.searchText = searchValue;
	                searchObject.pageSize = pageSize;
	
	                if (!response || response.length < 1) {
	                    _this3.setState({
	                        dataProvider: [],
	                        isLoading: false,
	                        noHits: true
	                    });
	                } else {
	                    _this3.setState({
	                        dataProvider: _VideoClipartParserJSON2.default.parseSearchItems(response),
	                        isLoading: false,
	                        noHits: false,
	                        searchObject: searchObject
	                    });
	                }
	            });
	        } else {
	            var category = 'all';
	
	            if (this.props.cartoonistTabIndex == 3) category = 'backgrounds';else if (this.props.cartoonistTabIndex == 2) category = 'characters';else if (this.props.cartoonistTabIndex == 1) category = 'props';
	
	            if (this.isAbpUniverse()) category = 'abp';else {
	                if (this.props.cartoonistTabIndex >= 4) return;
	            }
	
	            _ApiService2.default.searchNewContent(locale, category, searchValue, 0, pageSize).then(function (response) {
	                searchObject.locale = locale;
	                searchObject.category = category;
	                searchObject.searchText = searchValue;
	                searchObject.pageSize = pageSize;
	
	                if (!response || response.length < 1) {
	                    _this3.setState({
	                        dataProvider: [],
	                        isLoading: false,
	                        noHits: true
	                    });
	                } else {
	                    _this3.setState({
	                        dataProvider: _ClipartParserJSONNew2.default.parseSearchItems(response, category),
	                        isLoading: false,
	                        noHits: false,
	                        searchObject: searchObject
	                    });
	                }
	            });
	        }
	    },
	    clearSearch: function clearSearch() {
	        setTimeout(function () {
	            if (this.refs.searchInput) this.refs.searchInput.value = '';
	
	            this.forceUpdate();
	        }.bind(this), 20);
	    },
	    isSearchMode: function isSearchMode() {
	        if (this.refs.searchInput && this.refs.searchInput.value.length > 0) return true;else return false;
	    },
	    isAudioTool: function isAudioTool() {
	        return _AudioToolUtils2.default.isAudioTool();
	    },
	    startAnimation: function startAnimation() {
	        if (this.isAudioTool()) return;
	
	        this.stopAnimation();
	
	        var animationTimer = setInterval(this.animationStep, 50);
	
	        this.setState({
	            animationTimer: animationTimer
	        });
	    },
	    animationStep: function animationStep() {
	        if (this.isAudioTool()) return;
	
	        var cartoonistMenu = this.refs.cartoonistMenu;
	
	        if (cartoonistMenu) {
	            var cartoonistMenuWidth = 200;
	
	            if (this.state.titleWidth > 0) {
	                cartoonistMenuWidth = 40 + this.state.titleWidth + 10;
	            }
	
	            var maxLeft = -cartoonistMenuWidth;
	            var step = 50;
	            var leftPos = cartoonistMenu.style.left.replace('px', '');
	            var newPos = leftPos - step;
	
	            if (newPos <= maxLeft) {
	                this.stopAnimation();
	                newPos = maxLeft;
	            }
	
	            cartoonistMenu.style.left = newPos + 'px';
	        }
	    },
	    stopAnimation: function stopAnimation() {
	        if (this.isAudioTool()) return;
	
	        if (this.state.animationTimer) clearInterval(this.state.animationTimer);
	    },
	    getTitleBarCaption: function getTitleBarCaption(index) {
	        var title = '';
	
	        if (this.isAbpUniverse()) return _LocalesManager2.default.getCaption('SearchAll', 'other');
	
	        switch (index) {
	            case 0:
	                {
	                    title = _LocalesManager2.default.getCaption('SearchAll', 'other');
	                    break;
	                }
	            case 1:
	                {
	                    title = _LocalesManager2.default.getCaption('SearchProps', 'other');
	                    break;
	                }
	            case 2:
	                {
	                    title = _LocalesManager2.default.getCaption('SearchCharacters', 'other');
	                    break;
	                }
	            case 3:
	                {
	                    title = _LocalesManager2.default.getCaption('SearchBackgrounds', 'other');
	                    break;
	                }
	            case 4:
	                {
	                    title = _LocalesManager2.default.getCaption('SearchFrames', 'other');
	                    break;
	                }
	            case 5:
	                {
	                    title = _LocalesManager2.default.getCaption('SearchEffects', 'other');
	                    break;
	                }
	            case 6:
	                {
	                    title = _LocalesManager2.default.getCaption('SearchThemes', 'other');
	                    break;
	                }
	            case 7:
	                {
	                    title = _LocalesManager2.default.getCaption('SearchMyImages', 'other');
	                    break;
	                }
	            case 8:
	                {
	                    title = _LocalesManager2.default.getCaption('SearchMyVideos', 'other');
	                    break;
	                }
	            case 9:
	                {
	                    title = _LocalesManager2.default.getCaption('SearchThemeVideos');
	                    break;
	                }
	            case 10:
	                {
	                    title = _LocalesManager2.default.getCaption('SearchAudios', 'other');
	                    break;
	                }
	        }
	
	        return title;
	    },
	    onCloseClick: function onCloseClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	        _MindMapUtils2.default.reset();
	    },
	    isAbpUniverse: function isAbpUniverse() {
	        if (_AppParameters2.default.currentMainUniverse == 'alphabet_planet') {
	            if (this.props.clipartCategory == 0) {
	                if (_MoodsUtils2.default.previewContextMenu == _ModeConstants2.default.CONTEXT_NONE) return true;else return false;
	            } else return false;
	        } else return false;
	    },
	    onDeleteClick: function onDeleteClick(e) {
	        if (e.clientX && e.clientY) {
	            var windowWidth = window.innerWidth;
	            var rightOffset = 15;
	            var buttonSize = 15;
	            var topOffset = 9;
	
	            if (e.clientX >= windowWidth - rightOffset - buttonSize && e.clientX <= windowWidth - rightOffset && e.clientY >= topOffset && e.clientY <= topOffset + buttonSize) {
	                _TextSizeUtils2.default.searchText = '';
	                this.refs.searchInput.value = '';
	
	                this.setState({
	                    dataProvider: [],
	                    noHits: false
	                });
	
	                this.performSearch(false);
	            }
	        }
	    },
	    render: function render() {
	        var isIOS = _PlatformDetection2.default.isIOS();
	
	        var clipartButtonHeight = _Properties2.default.SEARCH_HEIGHT();
	        var menuStyle = {
	            position: 'absolute',
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            right: 0,
	            width: this.props.accordionWidth,
	            height: clipartButtonHeight,
	            overflow: 'visible',
	            backgroundColor: 'white',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            zIndex: 15000
	        };
	
	        /*********************** search ******************************/
	
	        var borderColor;
	        var textColor;
	        var inputValue = '';
	
	        if (this.refs.searchInput && this.refs.searchInput.value) inputValue = this.refs.searchInput.value;
	
	        if (this.state.isOver == true) {
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            textColor = borderColor;
	        } else {
	            borderColor = 'black';
	            textColor = 'black';
	        }
	
	        var fontSize = 16;
	        var leftGap = 5;
	        var inputPadding = 5;
	
	        if (isIOS) {
	            leftGap = 4;
	            fontSize = 14;
	            inputPadding = 10;
	        }
	
	        var titleWidth = this.props.accordionWidth - 2 * leftGap;
	
	        var titleStyle = {
	            width: titleWidth,
	            height: 21,
	            position: 'absolute',
	            left: leftGap,
	            top: 5,
	            alignItems: 'center'
	        };
	
	        var labelWidth = 55;
	        var searchValue = _LocalesManager2.default.getCaption('searchLabel', 'other');
	
	        if (_AppParameters2.default.locale.indexOf('NO') != -1) labelWidth = 35;
	
	        var searchLabelStyle = {
	            color: 'black',
	            top: 0,
	            left: 0,
	            fontSize: fontSize,
	            width: labelWidth,
	            resize: 'none',
	            overflow: 'hidden',
	            border: 'none',
	            background: 'transparent',
	            display: 'inline-block',
	            marginTop: 1
	        };
	
	        var inputStyle = {
	            position: 'absolute',
	            color: textColor,
	            top: -1,
	            paddingLeft: inputPadding,
	            fontSize: fontSize,
	            width: titleWidth - inputPadding - labelWidth,
	            resize: 'none',
	            overflow: 'hidden',
	            background: 'transparent',
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#777777',
	            borderRadius: 5
	        };
	
	        if (isIOS) {
	            titleStyle.top = 9;
	            titleStyle.borderStyle = 'hidden';
	
	            searchLabelStyle.fontSize = 15;
	            inputStyle.fontSize = 15;
	            inputStyle.width = inputStyle.width + 10;
	            inputStyle.top = 0;
	        }
	
	        var lineStyle = {
	            position: 'absolute',
	            top: clipartButtonHeight,
	            width: '100%',
	            height: 1,
	            backgroundColor: '#434343',
	            display: this.props.contextMode == _ModeConstants2.default.SEARCH_CONTEXT ? 'block' : 'none'
	        };
	
	        var startTextValue = this.state.startText;
	
	        if (this.isAbpUniverse()) startTextValue = this.state.startTextAbp;
	
	        var searchElement = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'div',
	                { role: 'search', id: 'searchInputField', style: titleStyle, className: 'titleInput', onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onInputClick, onClick: this.onInputClick },
	                _react2.default.createElement(
	                    'label',
	                    { htmlFor: 'searchInputElement', style: searchLabelStyle },
	                    searchValue
	                ),
	                _react2.default.createElement('input', { placeholder: startTextValue, type: 'search', ref: 'searchInput', id: 'searchInputElement', onClick: this.onDeleteClick, defaultValue: this.state.searchText, className: 'titleInput', style: inputStyle, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onChange: this.onChangeText })
	            ),
	            _react2.default.createElement('div', { style: lineStyle })
	        );
	
	        if (this.props.contextMode != _ModeConstants2.default.SEARCH_CONTEXT) {
	            return _react2.default.createElement(
	                'div',
	                { style: menuStyle },
	                searchElement
	            );
	        }
	        /*********************** title bar ******************************/
	
	        var titleBar;
	
	        var titleBarStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: clipartButtonHeight
	        };
	
	        var titleBarSpanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        var caption = this.getTitleBarCaption(this.props.cartoonistTabIndex);
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            right: 28,
	            top: 4,
	            width: titleStyle.height,
	            height: titleStyle.height,
	            cursor: 'pointer',
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            background: 'none',
	            borderStyle: 'none',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 3,
	            right: 3,
	            cursor: 'pointer'
	        };
	
	        titleBar = _react2.default.createElement(
	            'div',
	            { style: titleBarStyle },
	            _react2.default.createElement(
	                'span',
	                { style: titleBarSpanStyle },
	                caption
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'closeButton', style: closeButtonStyle, 'aria-label': _LocalesManager2.default.getCaption('close', 'other'), onClick: this.onCloseClick, onTouchEnd: this.onCloseClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	
	        /*********************** accordion and list ******************************/
	
	        menuStyle.height = this.props.windowHeight;
	
	        var holderHeight = this.props.windowHeight;
	        var listTopPosition;
	        var listTopGap = 10;
	        var listBottomGap = 5;
	        var listElement;
	        var audioTab;
	        var cartoonistMenuWidth = 200;
	        var searchMenu;
	
	        if (this.state.titleWidth > 0) {
	            cartoonistMenuWidth = 40 + this.state.titleWidth + 10;
	        }
	
	        if (!this.isAudioTool() && !this.isAbpUniverse()) {
	            var cartoonistMenuStyle = {
	                position: 'absolute',
	                left: 0,
	                top: 0,
	                height: holderHeight,
	                width: cartoonistMenuWidth,
	                background: 'white',
	                zIndex: 1000,
	                borderRightColor: 'black',
	                borderRightStyle: 'solid',
	                borderRightWidth: 1,
	                boxShadow: '-2px 0px 8px'
	            };
	
	            if (_VideoUtils2.default.showVideoEditor()) {
	                // don't show menu
	            } else {
	                if (_MindMapUtils2.default.isMindMapMode()) {
	                    searchMenu = _react2.default.createElement(
	                        'div',
	                        { style: cartoonistMenuStyle, ref: 'cartoonistMenu' },
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 0, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 1, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 2, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 3, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 4, cartoonistTabIndex: this.props.cartoonistTabIndex })
	                    );
	                } else {
	                    searchMenu = _react2.default.createElement(
	                        'div',
	                        { style: cartoonistMenuStyle, ref: 'cartoonistMenu' },
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 0, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 1, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 2, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 3, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 4, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 5, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 6, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 7, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 8, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 9, cartoonistTabIndex: this.props.cartoonistTabIndex }),
	                        _react2.default.createElement(CartoonistTabElement, { width: cartoonistMenuWidth, index: 10, cartoonistTabIndex: this.props.cartoonistTabIndex })
	                    );
	                }
	            }
	
	            listTopPosition = clipartButtonHeight + listTopGap;
	        }
	
	        var titleBarHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	        listTopPosition = listTopPosition + titleBarHeight;
	
	        if (this.isAudioTool() || this.props.cartoonistTabIndex == 10) {
	            // audios list
	            var accordionStyle = {
	                position: 'absolute',
	                left: 0,
	                top: clipartButtonHeight + titleBarHeight
	            };
	
	            var isMediaSound = false;
	
	            if (_PlayController2.default.isAudioEditorAvailable()) {
	                listTopPosition = clipartButtonHeight + listTopGap;
	            } else {
	                audioTab = _react2.default.createElement(
	                    'div',
	                    { style: accordionStyle },
	                    _react2.default.createElement(AudioTabElement, { accordionWidth: this.props.accordionWidth, index: 0, audioTabIndex: this.props.audioTabIndex }),
	                    _react2.default.createElement(AudioTabElement, { accordionWidth: this.props.accordionWidth, index: 1, audioTabIndex: this.props.audioTabIndex })
	                );
	
	                listTopPosition = clipartButtonHeight + 2 * _Properties2.default.BROWSER_BUTTON_HEIGHT + listTopGap;
	
	                if (this.props.audioTabIndex == 1) isMediaSound = true;
	            }
	
	            listTopPosition = listTopPosition + titleBarHeight;
	
	            listElement = _react2.default.createElement(AudioList, { accordionWidth: this.props.accordionWidth, isSearch: this.isSearchMode(), noHits: this.state.noHits, isMediaSound: isMediaSound, top: listTopPosition, width: this.props.accordionWidth, height: holderHeight - listTopPosition - listBottomGap, windowHeight: this.props.windowHeight, dispatch: this.props.dispatch, dataProvider: this.state.dataProvider });
	        } else if (this.isAbpUniverse()) {
	            // abp
	            listTopPosition = clipartButtonHeight + titleBarHeight + listTopGap;
	
	            listElement = _react2.default.createElement(ClipartList, { isBackgroundList: true, dispatch: this.props.dispatch, searchObject: this.state.searchObject, isSearch: this.isSearchMode(), noHits: this.state.noHits, isLoading: this.state.isLoading, useBackgroundAsImage: this.props.useBackgroundAsImage, dataProvider: this.state.dataProvider, width: this.props.accordionWidth, top: listTopPosition, height: holderHeight - listTopPosition - listBottomGap });
	        } else if (this.props.cartoonistTabIndex == 6) // themes list
	            listElement = _react2.default.createElement(_ClipartSelectorListNew.ClipartSelectorListNew, { dataProvider: this.state.dataProvider, isSearch: true, noHits: this.state.noHits, dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight, isUniversesVisible: true, topOffset: titleBarHeight });else if (this.props.cartoonistTabIndex == 9) {
	            // VideoCliparts
	            listElement = _react2.default.createElement(VideoThemesList, { dispatch: this.props.dispatch, isLoading: this.state.isLoading, noHits: this.state.noHits, searchObject: this.state.searchObject, isSearch: this.isSearchMode(), dataProvider: this.state.dataProvider, width: this.props.accordionWidth, useVideoAsBackground: this.props.useVideoAsBackground, top: listTopPosition, height: holderHeight - listTopPosition - listBottomGap });
	        } else if (this.props.cartoonistTabIndex == 4 || this.props.cartoonistTabIndex == 5 || this.props.cartoonistTabIndex == 7 || this.props.cartoonistTabIndex == 8) {
	            // effects, frames, MyImages, MyVideos
	            listElement = _react2.default.createElement(MediaList, { isMyMedia: this.props.cartoonistTabIndex == 7 || this.props.cartoonistTabIndex == 8, isBackgroundList: this.props.cartoonistTabIndex == 4 || this.props.cartoonistTabIndex == 7 || this.props.cartoonistTabIndex == 8, dispatch: this.props.dispatch, isBackground: this.props.cartoonistTabIndex == 4 || this.props.cartoonistTabIndex == 7, isFrame: this.props.cartoonistTabIndex == 4, isMedia: this.props.cartoonistTabIndex == 7 || this.props.cartoonistTabIndex == 8, isVideo: this.props.cartoonistTabIndex == 8, useFrameAsImage: this.props.useFrameAsImage, useImageAsBackground: this.props.useImageAsBackground, useVideoAsBackground: this.props.useVideoAsBackground, isLoading: this.state.isLoading, noHits: this.state.noHits, isSearch: this.isSearchMode(), dataProvider: this.state.dataProvider, width: this.props.accordionWidth, top: listTopPosition, height: holderHeight - listTopPosition - listBottomGap });
	        } else {
	            // all content, backgrounds, characters, props
	            listElement = _react2.default.createElement(ClipartList, { isBackgroundList: this.props.cartoonistTabIndex == 0 || this.props.cartoonistTabIndex == 3, dispatch: this.props.dispatch, searchObject: this.state.searchObject, isSearch: this.isSearchMode(), noHits: this.state.noHits, isLoading: this.state.isLoading, useBackgroundAsImage: this.props.useBackgroundAsImage, dataProvider: this.state.dataProvider, width: this.props.accordionWidth, top: listTopPosition, height: holderHeight - listTopPosition - listBottomGap });
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            searchElement,
	            titleBar,
	            audioTab,
	            listElement,
	            searchMenu
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var contextMode = state.menu.contextMode;
	    var accordionWidth = state.accordion.width;
	    var audioTabIndex = state.menu.audioTabIndex;
	    var cartoonistTabIndex = state.menu.cartoonistTabIndex;
	    var useBackgroundAsImage = state.menu.useBackgroundAsImage;
	    var useFrameAsImage = state.menu.useFrameAsImage;
	    var useImageAsBackground = state.menu.useImageAsBackground;
	    var mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
	    var showVideoEditor = state.menu.showVideoEditor;
	    var clipartCategory = state.menu.clipartCategory;
	    var useVideoAsBackground = state.menu.useVideoAsBackground;
	
	    if (showVideoEditor == undefined) showVideoEditor = false;
	
	    if (useBackgroundAsImage == undefined) useBackgroundAsImage = false;
	
	    if (useFrameAsImage == undefined) useFrameAsImage = false;
	
	    if (useVideoAsBackground == undefined) useVideoAsBackground = true;
	
	    if (useImageAsBackground == undefined) useImageAsBackground = false;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    if (audioTabIndex == undefined) audioTabIndex = 0;
	
	    if (cartoonistTabIndex == undefined) cartoonistTabIndex = 0;
	
	    if (clipartCategory == undefined) clipartCategory = 0;
	
	    return {
	        accordionWidth: accordionWidth,
	        contextMode: contextMode,
	        audioTabIndex: audioTabIndex,
	        cartoonistTabIndex: cartoonistTabIndex,
	        useBackgroundAsImage: useBackgroundAsImage,
	        useFrameAsImage: useFrameAsImage,
	        useImageAsBackground: useImageAsBackground,
	        mediaFilesDataProvider: mediaFilesDataProvider,
	        showVideoEditor: showVideoEditor,
	        clipartCategory: clipartCategory,
	        useVideoAsBackground: useVideoAsBackground
	    };
	}
	
	var SearchMenu = exports.SearchMenu = (0, _reactRedux.connect)(mapStateToProps)(SearchMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SearchMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SearchMenu.js"); } } })();

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SlideDurationSlider = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideDurationSlider = exports.SlideDurationSlider = _react2.default.createClass({
	    displayName: 'SlideDurationSlider',
	    getInitialState: function getInitialState() {
	        var step = (this.props.properties.end - this.props.properties.start) / this.props.properties.step;
	        var realStep = (this.props.properties.width - this.props.properties.thumbSize) / step;
	
	        return {
	            step: realStep,
	            currentSlideIndex: -1,
	            isThumbOver: false,
	            isThumbActive: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.drawTrack();
	
	        if (_PlatformDetection2.default.isTouchableDevice()) {
	            this.refs.track.addEventListener('touchend', this.onTrackMouseDown);
	
	            if (_PlatformDetection2.default.isChromeBook()) this.refs.track.addEventListener('mousedown', this.onTrackMouseDown);
	        } else this.refs.track.addEventListener('mousedown', this.onTrackMouseDown);
	
	        if (this.props.properties.isVideo || this.props.properties.isZoom) this.setInitialPosition();
	    },
	    onThumbMouseIn: function onThumbMouseIn() {
	        this.setState({
	            isThumbOver: true
	        });
	    },
	    onThumbMouseOut: function onThumbMouseOut() {
	        this.setState({
	            isThumbOver: false
	        });
	    },
	    drawTrack: function drawTrack() {
	        var canvas = this.refs.track;
	        var lineSize = 4;
	        canvas.width = this.props.properties.width;
	        canvas.height = this.props.properties.height;
	        var ctx = canvas.getContext('2d');
	
	        if (this.props.properties.isVideo || this.props.properties.isZoom) ctx.fillStyle = '#272727';else ctx.fillStyle = _Properties2.default.DURATION_SLIDER_COLOR;
	
	        ctx.fillRect(0, canvas.height / 2 - lineSize / 2, canvas.width, lineSize);
	        ctx.fill();
	    },
	    getCurrentStep: function getCurrentStep(position) {
	        var floatValue = position / this.state.step;
	        var integerPart = parseInt(floatValue, 10);
	
	        var newPosition;
	
	        if (floatValue - integerPart > 0.5) newPosition = integerPart + 1;else newPosition = integerPart;
	
	        return newPosition;
	    },
	    getSliderPosition: function getSliderPosition(position) {
	        var newStep = this.getCurrentStep(position);
	        return newStep * this.state.step;
	    },
	    getSliderValue: function getSliderValue(position) {
	        var newStep = this.getCurrentStep(position);
	        return this.props.properties.start + newStep * this.props.properties.step;
	    },
	    onTrackMouseDown: function onTrackMouseDown(e) {
	        if (_PlayController2.default.isPlaying) return;
	
	        _PlayController2.default.getOldScrollPosition();
	
	        var newPosition = _MouseUtils2.default.getLocalPosition(e, this.refs.track, false) - this.props.properties.thumbSize / 2;
	
	        if (newPosition < 0) newPosition = 0;
	
	        if (newPosition > this.props.properties.width - this.props.properties.thumbSize) newPosition = this.props.properties.width - this.props.properties.thumbSize;
	
	        var sliderPosition = this.getSliderPosition(newPosition);
	
	        this.refs.thumb.style.left = sliderPosition + 'px';
	
	        this.changeProperties(this.getSliderValue(newPosition));
	    },
	    onKeyDown: function onKeyDown(e) {
	        var delta = 10;
	
	        if (e.keyCode == 37) {
	            // Left Key
	            this.onMouseDown();
	
	            setTimeout(function () {
	                this.onMouseUp(undefined, undefined, -delta);
	            }.bind(this), 10);
	        } else if (e.keyCode == 39) {
	            // Right Key
	            this.onMouseDown();
	
	            setTimeout(function () {
	                this.onMouseUp(undefined, undefined, delta);
	            }.bind(this), 10);
	        }
	    },
	    onMouseDown: function onMouseDown() {
	        if (_PlayController2.default.isPlaying) return;
	
	        _PlayController2.default.getOldScrollPosition();
	
	        var leftString = this.refs.thumb.style.left;
	        var left = Number(leftString.substring(0, leftString.length - 2));
	
	        this.setState({
	            startPosition: left,
	            currentPosition: left,
	            isThumbActive: true
	        });
	    },
	    checkPosition: function checkPosition(deltaX) {
	        var newPosition = this.state.startPosition + deltaX;
	        var leftValue = 0;
	        var rightValue = this.props.properties.width - this.props.properties.thumbSize;
	
	        if (newPosition < leftValue) newPosition = leftValue;else if (newPosition > rightValue) newPosition = rightValue;
	
	        var sliderPosition = this.getSliderPosition(newPosition);
	
	        if (sliderPosition != this.state.currentPosition) {
	            this.refs.thumb.style.left = sliderPosition + 'px';
	
	            this.setState({
	                currentPosition: sliderPosition
	            });
	
	            this.changeProperties(this.getSliderValue(this.state.currentPosition));
	        }
	    },
	    onMouseMove: function onMouseMove(e, coreEvent) {
	        if (_PlayController2.default.isPlaying) return;
	
	        this.checkPosition(coreEvent.lastX);
	    },
	    onMouseUp: function onMouseUp(e, coreEvent, movement) {
	        if (_PlayController2.default.isPlaying) return;
	
	        if (movement) this.checkPosition(movement);else this.checkPosition(coreEvent.lastX);
	
	        this.setState({
	            isThumbActive: false
	        });
	    },
	    changeProperties: function changeProperties(newValue) {
	        if (newValue == undefined) return;
	
	        if (_PlayController2.default.isPlaying) return;
	
	        _SaveManager2.default.isContentChanged(true);
	
	        if (this.props.properties.isZoom) {
	            var oldZoom = _AudioEditorUtils2.default.getZoomValue();
	            this.props.properties.dispatch((0, _AudioEditorActions.changeZoom)(newValue));
	            _AudioEditorUtils2.default.checkTimelineWidth(true, oldZoom, true);
	            return;
	        }
	
	        if (this.props.properties.isVideo) {
	            _VideoUtils2.default.currentVideoVolume = newValue / 10;
	        } else {
	            _AudioEditorUtils2.default.refreshAllSlidesRenderers = true;
	            this.props.properties.dispatch((0, _CurrentSlideActions.changeSlideDuration)(newValue));
	            _SaveManager2.default.isContentChanged(true);
	            _AudioEditorUtils2.default.checkTimelineWidth();
	
	            _PlayController2.default.updateCurrentSlideProperties();
	
	            _PlayController2.default.updateScrollPosition(100, true);
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.properties.isVideo || this.props.properties.isZoom) {
	            if (this.props.properties.currentValue != nextProps.properties.currentValue) setTimeout(this.setInitialPosition, 10);
	
	            return;
	        }
	
	        if (this.state.currentSlideIndex < 0 || this.state.currentSlideIndex != nextProps.properties.currentSlideIndex || this.props.properties.slideDuration != nextProps.properties.slideDuration) {
	            this.setState({
	                currentSlideIndex: nextProps.properties.currentSlideIndex
	            });
	
	            setTimeout(this.setInitialPosition, 10);
	        }
	    },
	    setInitialPosition: function setInitialPosition() {
	        if (this.refs.thumb) {
	            if (this.props.properties.isVideo || this.props.properties.isZoom) this.refs.thumb.style.left = (this.props.properties.currentValue - this.props.properties.start) * this.state.step + 'px';else this.refs.thumb.style.left = (this.props.properties.slideDuration - this.props.properties.start) * this.state.step + 'px';
	        }
	    },
	    render: function render() {
	        var localProps = this.props.properties;
	
	        var wrapperStyle = {
	            display: localProps.display,
	            position: 'absolute',
	            left: localProps.leftPosition,
	            top: localProps.topPosition,
	            width: localProps.width,
	            height: localProps.height,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            cursor: 'default'
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            width: localProps.width,
	            height: localProps.height,
	            cursor: 'default'
	        };
	
	        var thumbBorderSize = 2;
	        var thumbBorderColor = 'black';
	        var background = 'white';
	
	        if (localProps.isVideo || localProps.isZoom) thumbBorderColor = '#272727';
	
	        if (this.state.isThumbOver == true || this.state.isThumbActive == true) thumbBorderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	
	        if (localProps.isVideo || localProps.isZoom) background = thumbBorderColor;
	
	        var thumbStyle = {
	            position: 'absolute',
	            width: localProps.thumbSize - 2 * thumbBorderSize,
	            height: localProps.thumbSize - 2 * thumbBorderSize,
	            top: localProps.height / 2 - localProps.thumbSize / 2,
	            background: background,
	            borderStyle: 'solid',
	            borderColor: thumbBorderColor,
	            borderWidth: 2,
	            borderRadius: 50,
	            cursor: 'default',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'slider', style: wrapperStyle },
	            _react2.default.createElement('canvas', { className: 'slideDuration', ref: 'track', style: backgroundStyle }),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	                _react2.default.createElement('button', { id: 'durationThumbButton', 'aria-label': _LocalesManager2.default.getCaption('zoomSliderThumb', 'other'), className: 'slideDuration', ref: 'thumb', style: thumbStyle, onKeyDown: this.onKeyDown, onMouseOver: this.onThumbMouseIn, onMouseOut: this.onThumbMouseOut })
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SlideDurationSlider.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SlideDurationSlider.js"); } } })();

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CanvasPrint = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _SVGContainer = __webpack_require__(345);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CanvasPrint = exports.CanvasPrint = _react2.default.createClass({
	    displayName: 'CanvasPrint',
	    render: function render() {
	        var scaleProperties = this.props.scaleProperties;
	
	        var svgContainerStyle = {
	            backgroundColor: 'white',
	            margin: 0,
	            maxWidth: _Configuration2.default.CANVAS_WIDTH,
	            maxHeight: _Configuration2.default.CANVAS_HEIGHT,
	            float: 'none'
	        };
	
	        if (this.props.printTemplate == 0) {
	            var _scale = 0.7;
	            var vGap = 9;
	
	            if (this.props.index == 1) svgContainerStyle.marginTop = 0;else svgContainerStyle.marginTop = -(_Configuration2.default.CANVAS_HEIGHT - _Configuration2.default.CANVAS_HEIGHT * _scale) + vGap;
	
	            svgContainerStyle.transform = 'scale(' + _scale + ')';
	            svgContainerStyle.WebkitTransform = 'scale(' + _scale + ')';
	        } else {
	            var scale = 1.35;
	
	            svgContainerStyle.transform = 'scale(' + scale + ') rotate(' + 90 + 'deg)';
	            svgContainerStyle.WebkitTransform = 'scale(' + scale + ') rotate(' + 90 + 'deg)';
	
	            if (_PlatformDetection2.default.isFirefox() == true) svgContainerStyle.paddingLeft = 245;else if (_PlatformDetection2.default.isEdge() == true) {
	                svgContainerStyle.position = 'absolute';
	                svgContainerStyle.marginTop = 335;
	            } else svgContainerStyle.marginTop = 328;
	
	            svgContainerStyle.maxWidth = undefined;
	            svgContainerStyle.maxHeight = undefined;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'svgContainer', style: svgContainerStyle },
	            _react2.default.createElement(_SVGContainer.SVGContainer, { dispatch: this.props.dispatch, scaleProperties: scaleProperties, slideModelPrint: this.props.slideModel })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/CanvasPrint.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/CanvasPrint.js"); } } })();

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SVGContainer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _Background = __webpack_require__(843);
	
	var _Character = __webpack_require__(347);
	
	var _Image = __webpack_require__(354);
	
	var _Rectangle = __webpack_require__(356);
	
	var _Triangle = __webpack_require__(368);
	
	var _Star = __webpack_require__(361);
	
	var _Heart = __webpack_require__(353);
	
	var _Ellipse = __webpack_require__(351);
	
	var _Line = __webpack_require__(355);
	
	var _Curve = __webpack_require__(350);
	
	var _Freehand = __webpack_require__(352);
	
	var _TextBox = __webpack_require__(362);
	
	var _TextBoxSimple = __webpack_require__(364);
	
	var _SpeakBubble = __webpack_require__(359);
	
	var _ThoughtBubble = __webpack_require__(366);
	
	var _ScreamBubble = __webpack_require__(357);
	
	var _TextBoxRich = __webpack_require__(363);
	
	var _TextBoxSimpleRich = __webpack_require__(365);
	
	var _SpeakBubbleRich = __webpack_require__(360);
	
	var _ThoughtBubbleRich = __webpack_require__(367);
	
	var _ScreamBubbleRich = __webpack_require__(358);
	
	var _ComplexSpeakBubbleRich = __webpack_require__(349);
	
	var _Video = __webpack_require__(369);
	
	var _Group = __webpack_require__(844);
	
	var _ZoomTransformTool = __webpack_require__(842);
	
	var _CroppingTransformTool = __webpack_require__(841);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _ComplexSpeakBubble = __webpack_require__(348);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SVGContainerContent = _react2.default.createClass({
	    displayName: 'SVGContainerContent',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        slideModel: _react2.default.PropTypes.object.isRequired
	    },
	    getShape: function getShape(shape) {
	        var dispatch = this.props.dispatch;
	
	
	        switch (shape.type) {
	            case _ShapeConstants2.default.BACKGROUND:
	                return _react2.default.createElement(_Background.Background, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, showZoomSlides: this.props.showZoomSlides, key: shape.uuid });
	
	            case _ShapeConstants2.default.CHARACTER:
	                return _react2.default.createElement(_Character.Character, { shapeModel: shape, dispatch: dispatch, showCroppingMenu: this.props.showCroppingMenu, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	
	            case _ShapeConstants2.default.IMAGE:
	                return _react2.default.createElement(_Image.Image, { shapeModel: shape, dispatch: dispatch, showCroppingMenu: this.props.showCroppingMenu, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	
	            case _ShapeConstants2.default.RECTANGLE:
	                return _react2.default.createElement(_Rectangle.Rectangle, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	
	            case _ShapeConstants2.default.TRIANGLE:
	                return _react2.default.createElement(_Triangle.Triangle, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	
	            case _ShapeConstants2.default.STAR:
	                return _react2.default.createElement(_Star.Star, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	
	            case _ShapeConstants2.default.HEART:
	                return _react2.default.createElement(_Heart.Heart, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	
	            case _ShapeConstants2.default.ELLIPSE:
	                return _react2.default.createElement(_Ellipse.Ellipse, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	
	            case _ShapeConstants2.default.LINE:
	                return _react2.default.createElement(_Line.Line, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	
	            case _ShapeConstants2.default.CURVE:
	                return _react2.default.createElement(_Curve.Curve, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	
	            case _ShapeConstants2.default.FREEHAND:
	                return _react2.default.createElement(_Freehand.Freehand, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	
	            case _ShapeConstants2.default.GROUP:
	                {
	                    return _react2.default.createElement(_Group.Group, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	                }
	
	            case _ShapeConstants2.default.VIDEO:
	                {
	                    return _react2.default.createElement(_Video.Video, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	                }
	
	            case _ShapeConstants2.default.TEXTBOX:
	                {
	                    if (shape.isRichText) return _react2.default.createElement(_TextBoxRich.TextBoxRich, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });else return _react2.default.createElement(_TextBox.TextBox, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	                }
	
	            case _ShapeConstants2.default.TEXTBOXSIMPLE:
	                {
	                    if (shape.isRichText) return _react2.default.createElement(_TextBoxSimpleRich.TextBoxSimpleRich, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });else return _react2.default.createElement(_TextBoxSimple.TextBoxSimple, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	                }
	
	            case _ShapeConstants2.default.SPEAK_BUBBLE:
	                {
	                    if (shape.isRichText) return _react2.default.createElement(_SpeakBubbleRich.SpeakBubbleRich, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });else return _react2.default.createElement(_SpeakBubble.SpeakBubble, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	                }
	
	            case _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE:
	                {
	                    if (shape.isRichText) return _react2.default.createElement(_ComplexSpeakBubbleRich.ComplexSpeakBubbleRich, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });else return _react2.default.createElement(_ComplexSpeakBubble.ComplexSpeakBubble, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	                }
	
	            case _ShapeConstants2.default.THOUGHT_BUBBLE:
	                {
	                    if (shape.isRichText) return _react2.default.createElement(_ThoughtBubbleRich.ThoughtBubbleRich, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });else return _react2.default.createElement(_ThoughtBubble.ThoughtBubble, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	                }
	
	            case _ShapeConstants2.default.SCREAM_BUBBLE:
	                {
	                    if (shape.isRichText) return _react2.default.createElement(_ScreamBubbleRich.ScreamBubbleRich, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });else return _react2.default.createElement(_ScreamBubble.ScreamBubble, { shapeModel: shape, dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: shape.uuid });
	                }
	        }
	    },
	    render: function render() {
	        var _this = this;
	
	        var videos = [];
	        var dispatch = this.props.dispatch;
	
	
	        var slideModel;
	
	        if (this.props.slideModelPrint) slideModel = this.props.slideModelPrint;else slideModel = this.props.slideModel;
	
	        var shapes = [];
	
	        if (slideModel && slideModel.content) {
	            shapes = slideModel.content.map(function (shape) {
	                return _this.getShape(shape);
	            });
	        }
	
	        if (_AppParameters2.default.context != _ModeConstants2.default.PLAYER && _AppParameters2.default.context != _ModeConstants2.default.PRINT) {
	            shapes.push(_react2.default.createElement(_ZoomTransformTool.ZoomTransformTool, { dispatch: dispatch, scaleProperties: this.props.scaleProperties, backgroundModel: slideModel.content[0], key: 'ZoomTransformTool_' + slideModel.content[0].uuid }));
	            shapes.push(_react2.default.createElement(_CroppingTransformTool.CroppingTransformTool, { dispatch: dispatch, scaleProperties: this.props.scaleProperties, key: 'CroppingTransformTool' }));
	        }
	        var viewBox = '0 0 ' + _Configuration2.default.CANVAS_WIDTH + ' ' + _Configuration2.default.CANVAS_HEIGHT;
	
	        var animationElements = [];
	
	        if (_AnimationManager2.default.isAnimationMode() && _AnimationManager2.default.clone) {
	            var clones = _AnimationManager2.default.getAllAnimationTargets();
	
	            for (var i = 0; i < clones.length - 1; i++) {
	                var target = clones[i];
	                var clone = clones[i + 1];
	                var animationClone = this.getShape(clone);
	                var line = void 0;
	                var animationElement = void 0;
	
	                if (!target.isInteraction && !clone.isInteraction) line = _AnimationManager2.default.getLine(target, clone, i, clones.length);
	
	                animationElement = _react2.default.createElement(
	                    'g',
	                    { x: '0.00', y: '0.00', width: _Configuration2.default.CANVAS_WIDTH, height: _Configuration2.default.CANVAS_WIDTH, key: 'animationElement_' + i },
	                    animationClone,
	                    line
	                );
	
	                animationElements.push(animationElement);
	            }
	        }
	
	        return _react2.default.createElement(
	            'svg',
	            { id: 'canvas', role: 'img', 'aria-label': _LocalesManager2.default.getCaption('canvas', 'other'), width: _Configuration2.default.CANVAS_WIDTH, height: _Configuration2.default.CANVAS_HEIGHT, viewBox: viewBox },
	            _react2.default.createElement(
	                'defs',
	                null,
	                _react2.default.createElement(
	                    'filter',
	                    { id: '2', width: '150%', height: '150%' },
	                    _react2.default.createElement('feOffset', { result: 'offOut', 'in': 'SourceAlpha', dx: '4', dy: '4' }),
	                    _react2.default.createElement('feGaussianBlur', { result: 'blurOut', 'in': 'offOut', stdDeviation: '4' }),
	                    _react2.default.createElement('feBlend', { 'in': 'SourceGraphic', in2: 'blurOut', mode: 'normal' })
	                ),
	                _react2.default.createElement(
	                    'filter',
	                    { id: '5', filterUnits: 'objectBoundingBox', x: '0%', y: '0%', width: '100%', height: '100%' },
	                    _react2.default.createElement('feColorMatrix', { values: '0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  1 1 1 1 0' })
	                )
	            ),
	            shapes,
	            animationElements
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var slideModel = state.currentSlide.model;
	    var showCroppingMenu = state.menu.showCroppingMenu;
	    var showZoomSlides = state.menu.showZoomSlides;
	    var updateSlide = state.menu.updateSlide;
	
	    if (showZoomSlides == undefined) showZoomSlides = false;
	
	    if (showCroppingMenu == undefined) showCroppingMenu = false;
	
	    return {
	        slideModel: slideModel,
	        showZoomSlides: showZoomSlides,
	        showCroppingMenu: showCroppingMenu,
	        updateSlide: updateSlide
	    };
	}
	
	var SVGContainer = exports.SVGContainer = (0, _reactRedux.connect)(mapStateToProps)(SVGContainerContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/SVGContainer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/SVGContainer.js"); } } })();

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InteractiveNonRectangularShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _MenuActions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InteractiveNonRectangularShape = exports.InteractiveNonRectangularShape = _react2.default.createClass({
	    displayName: 'InteractiveNonRectangularShape',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        children: _react2.default.PropTypes.object.isRequired,
	        shapeModel: _react2.default.PropTypes.object.isRequired
	    },
	    getInitialState: function getInitialState() {
	        return {
	            interaction: 'none',
	            x1: 0,
	            y1: 0,
	            x2: 0,
	            y2: 0,
	            cx: 0,
	            cy: 0,
	            isMultipleSelection: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isFirefox() == false) document.addEventListener('mouseout', this.onFocusOut);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        if (_PlatformDetection2.default.isFirefox() == false) document.removeEventListener('mouseout', this.onFocusOut);
	    },
	    onFocusOut: function onFocusOut(evt) {
	        var position = (0, _TransformToolUtils.getTouchPosition)(evt);
	        if (position.x < 2 || position.y < 2 || position.x > window.innerWidth - 2 || position.y > window.innerHeight - 2) {
	            if (this.state.interaction == 'Start' || this.state.interaction == 'End' || this.state.interaction == 'Control') this.onResizeStopped();else if (this.state.interaction == 'move') this.onMoveShapeStopped();
	        }
	    },
	    getCorrectId: function getCorrectId(id) {
	        var index = id.indexOf('_');
	
	        if (index != -1) return id.substring(0, index);else return id;
	    },
	    setInitialPosition: function setInitialPosition(interaction) {
	        var shapeModel = this.props.shapeModel;
	
	
	        this.setState({
	            x1: parseFloat(shapeModel.x1),
	            y1: parseFloat(shapeModel.y1),
	            x2: parseFloat(shapeModel.x2),
	            y2: parseFloat(shapeModel.y2),
	            cx: parseFloat(shapeModel.cx),
	            cy: parseFloat(shapeModel.cy),
	            interaction: interaction,
	            isMultipleSelection: _SelectionManager2.default.multipleSelection()
	        });
	    },
	    updateThumbnail: function updateThumbnail() {
	        var dispatch = this.props.dispatch;
	
	        dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    onMoveShapeStart: function onMoveShapeStart(e) {
	        e.preventDefault();
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        if (shapeModel.isLocked == true || shapeModel.isGrouped == true) return;
	
	        this.setInitialPosition('move');
	        this.props.dispatch((0, _CurrentSlideActions.changeInteractionState)(this.props.shapeModel.uuid, true));
	
	        _SelectionManager2.default.checkSelection(shapeModel.uuid);
	        _SelectionManager2.default.updateInitialPositions(shapeModel.uuid);
	    },
	    onMoveShape: function onMoveShape(e, coreEvent) {
	        if (this.state.interaction != 'move') return;
	
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	
	        if (shapeModel.isLocked == true || shapeModel.isGrouped == true) return;
	
	        var xOffset = coreEvent.lastX / this.scaleFactor();
	        var yOffset = coreEvent.lastY / this.scaleFactor();
	
	        dispatch((0, _CurrentSlideActions.updateNonRectangularShape)(shapeModel.uuid, this.state.x1 + xOffset, this.state.y1 + yOffset, this.state.x2 + xOffset, this.state.y2 + yOffset, this.state.cx + xOffset, this.state.cy + yOffset));
	
	        if (this.state.isMultipleSelection) _SelectionManager2.default.moveShapes(xOffset, yOffset, shapeModel.uuid);
	
	        _SaveManager2.default.isContentChanged(true);
	    },
	    onMoveShapeStopped: function onMoveShapeStopped(e, coreEvent) {
	        this.props.dispatch((0, _CurrentSlideActions.changeInteractionState)(this.props.shapeModel.uuid, false));
	
	        var _props3 = this.props,
	            shapeModel = _props3.shapeModel,
	            dispatch = _props3.dispatch;
	
	
	        if (shapeModel.isLocked == true || shapeModel.isGrouped == true) {
	            dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid));
	
	            return;
	        }
	
	        if (this.state.interaction != 'move') return;
	
	        if (coreEvent) {
	            var offsetX = coreEvent.lastX / this.scaleFactor();
	            var offsetY = coreEvent.lastY / this.scaleFactor();
	
	            dispatch((0, _CurrentSlideActions.updateNonRectangularShape)(shapeModel.uuid, this.state.x1 + offsetX, this.state.y1 + offsetY, this.state.x2 + offsetX, this.state.y2 + offsetY, this.state.cx + offsetX, this.state.cy + offsetY));
	
	            _SelectionManager2.default.moveShapes(offsetX, offsetY, shapeModel.uuid);
	        }
	
	        dispatch((0, _CurrentSlideActions.selectShape)(shapeModel.uuid));
	
	        this.setState({
	            interaction: 'none',
	            x1: 0,
	            y1: 0,
	            x2: 0,
	            y2: 0,
	            cx: 0,
	            cy: 0,
	            isMultipleSelection: false
	        });
	
	        _AudioEditorUtils2.default.addActionToHistory();
	        this.updateThumbnail();
	        _SaveManager2.default.isContentChanged(true);
	
	        dispatch((0, _MenuActions.refreshShapePosition)(this.props.shapeModel.uuid));
	    },
	    onResizeStart: function onResizeStart(e, coreEvent) {
	        var shapeModel = this.props.shapeModel;
	
	        this.props.dispatch((0, _CurrentSlideActions.changeInteractionState)(this.props.shapeModel.uuid, true));
	
	        if (shapeModel.isLocked == true) return;
	
	        this.setInitialPosition(this.getCorrectId(coreEvent.node.id));
	    },
	    getNewPosition: function getNewPosition(coreEvent) {
	        var shapeModel = this.props.shapeModel;
	
	
	        var id = this.getCorrectId(coreEvent.node.id);
	        var x1 = shapeModel.x1;
	        var x2 = shapeModel.x2;
	        var y1 = shapeModel.y1;
	        var y2 = shapeModel.y2;
	        var cx = shapeModel.cx;
	        var cy = shapeModel.cy;
	
	        var offsetX = coreEvent.lastX / this.scaleFactor();
	        var offsetY = coreEvent.lastY / this.scaleFactor();
	
	        if (id == 'Start') {
	            x1 = this.state.x1 + offsetX;
	            y1 = this.state.y1 + offsetY;
	        } else if (id == 'End') {
	            x2 = this.state.x2 + offsetX;
	            y2 = this.state.y2 + offsetY;
	        } else if (id == 'Control') {
	            cx = this.state.cx + offsetX;
	            cy = this.state.cy + offsetY;
	        }
	
	        return {
	            x1: x1,
	            y1: y1,
	            x2: x2,
	            y2: y2,
	            cx: cx,
	            cy: cy
	        };
	    },
	    onResize: function onResize(e, coreEvent) {
	        if (this.state.interaction == 'none') return;
	
	        var _props4 = this.props,
	            shapeModel = _props4.shapeModel,
	            dispatch = _props4.dispatch;
	
	
	        if (shapeModel.isLocked == true) return;
	
	        var newPosition = this.getNewPosition(coreEvent);
	
	        dispatch((0, _CurrentSlideActions.updateNonRectangularShape)(shapeModel.uuid, newPosition.x1, newPosition.y1, newPosition.x2, newPosition.y2, newPosition.cx, newPosition.cy));
	
	        _SaveManager2.default.isContentChanged(true);
	    },
	    onResizeStopped: function onResizeStopped(e, coreEvent) {
	        if (this.state.interaction == 'none') return;
	
	        this.props.dispatch((0, _CurrentSlideActions.changeInteractionState)(this.props.shapeModel.uuid, false));
	        var _props5 = this.props,
	            shapeModel = _props5.shapeModel,
	            dispatch = _props5.dispatch;
	
	
	        if (shapeModel.isLocked == true) return;
	
	        if (coreEvent) {
	            var newPosition = this.getNewPosition(coreEvent);
	
	            dispatch((0, _CurrentSlideActions.updateNonRectangularShape)(shapeModel.uuid, newPosition.x1, newPosition.y1, newPosition.x2, newPosition.y2, newPosition.cx, newPosition.cy));
	        }
	
	        this.setState({
	            interaction: 'none',
	            x1: 0,
	            y1: 0,
	            x2: 0,
	            y2: 0,
	            cx: 0,
	            cy: 0
	        });
	
	        _AudioEditorUtils2.default.addActionToHistory();
	        this.updateThumbnail();
	        _SaveManager2.default.isContentChanged(true);
	
	        dispatch((0, _MenuActions.refreshShapePosition)(this.props.shapeModel.uuid));
	    },
	    scaleFactor: function scaleFactor() {
	        return this.props.scaleProperties.scale;
	    },
	    render: function render() {
	        var _props$shapeModel = this.props.shapeModel,
	            x1 = _props$shapeModel.x1,
	            y1 = _props$shapeModel.y1,
	            x2 = _props$shapeModel.x2,
	            y2 = _props$shapeModel.y2,
	            cx = _props$shapeModel.cx,
	            cy = _props$shapeModel.cy,
	            isLocked = _props$shapeModel.isLocked;
	
	        var isSelected = this.props.shapeModel.isSelected;
	
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) isSelected = false;
	
	        var cornerFill = void 0;
	        var cornerStroke = void 0;
	
	        if (this.state.interaction == 'Start' || this.state.interaction == 'End' || this.state.interaction == 'Control') {
	            cornerFill = _TransformToolUtils.uiProperties.CORNER_FILL_ACTIVE;
	            cornerStroke = _TransformToolUtils.uiProperties.CORNER_STROKE_ACTIVE;
	        } else {
	            cornerFill = _TransformToolUtils.uiProperties.CORNER_FILL_INACTIVE;
	            cornerStroke = _TransformToolUtils.uiProperties.CORNER_STROKE_INACTIVE;
	        }
	
	        var x = x1 && x2 ? Math.min(x1, x2) : 0;
	        var y = y1 && y2 ? Math.min(y1, y2) : 0;
	
	        var width = Math.abs(x1 - x2);
	        var height = Math.abs(y1 - y2);
	
	        var radiusOffset = 0;
	
	        if (_PlatformDetection2.default.isIOS()) radiusOffset = 2;
	
	        var scale = this.props.scaleProperties.scale;
	        var radius = (_TransformToolUtils.uiProperties.RADIUS + radiusOffset) / scale;
	        var lockScale = 2;
	
	        var isLockedVisible = false;
	
	        if (isSelected && isLocked && _PreviewCommands2.default.isEditorMode() == true) isLockedVisible = true;
	
	        var interactivity;
	
	        // in animation mode, only the shapes from the current animations should be clickable
	        if (_AnimationManager2.default.clone && !this.props.shapeModel.isGrouped) {
	            var clones = _AnimationManager2.default.getAllAnimationTargets();
	            var isInTargets = false;
	
	            for (var idx = 0; idx < clones.length; idx++) {
	                if (clones[idx].uuid === this.props.shapeModel.uuid) isInTargets = true;
	            }
	
	            if (!isInTargets) interactivity = 'none';
	        }
	
	        return _react2.default.createElement(
	            'g',
	            { pointerEvents: interactivity, transform: 'translate(' + x + ' ' + y + ')' },
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMoveShapeStart, onDrag: this.onMoveShape, onStop: this.onMoveShapeStopped },
	                _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
	                    x: 0,
	                    y: 0
	                })
	            ),
	            isSelected ? _react2.default.createElement(
	                'g',
	                { transform: '' },
	                this.state.interaction == 'none' || this.state.interaction == 'Start' ? _react2.default.createElement(
	                    _reactDraggable2.default,
	                    { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onResizeStart, onDrag: this.onResize, onStop: this.onResizeStopped },
	                    _react2.default.createElement('circle', { id: "Start_" + Math.random(), cx: x1 - x, cy: y1 - y, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	                ) : null,
	                this.state.interaction == 'none' || this.state.interaction == 'End' ? _react2.default.createElement(
	                    _reactDraggable2.default,
	                    { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onResizeStart, onDrag: this.onResize, onStop: this.onResizeStopped },
	                    _react2.default.createElement('circle', { id: "End_" + Math.random(), cx: x2 - x, cy: y2 - y, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	                ) : null
	            ) : null,
	            cx && cy && isSelected && (this.state.interaction == 'none' || this.state.interaction == 'Control') ? _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onResizeStart, onDrag: this.onResize, onStop: this.onResizeStopped },
	                _react2.default.createElement('circle', { id: "Control_" + Math.random(), cx: cx - x, cy: cy - y, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	            ) : null,
	            isLockedVisible ? _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + (width / 2 - 10 / lockScale) + ' ' + (height / 2 - 12.5 / lockScale) + ') scale(' + 1 / lockScale + ' ' + 1 / lockScale + ')' },
	                _react2.default.createElement('image', { xlinkHref: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/lock.png', x: '0', y: '0', width: '20px', height: '25px', preserveAspectRatio: 'none' })
	            ) : null
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/interactive/InteractiveNonRectangularShape.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/interactive/InteractiveNonRectangularShape.js"); } } })();

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Character = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _ColorUtils = __webpack_require__(240);
	
	var _ColorUtils2 = _interopRequireDefault(_ColorUtils);
	
	var _ThumbnailGenerator = __webpack_require__(144);
	
	var _ThumbnailGenerator2 = _interopRequireDefault(_ThumbnailGenerator);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Character = exports.Character = _react2.default.createClass({
	    displayName: 'Character',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        shapeModel: _react2.default.PropTypes.object.isRequired
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.shapeModel.xlinkHref != nextProps.shapeModel.xlinkHref) // change the mood
	            this.checkSize(true);
	    },
	    checkSize: function checkSize() {
	        var updateImageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (_PreviewCommands2.default.isPlayMode() == true) return;
	
	        setTimeout(this.checkImageSize, 5, updateImageSize);
	    },
	    checkImageSize: function checkImageSize() {
	        var updateImageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (updateImageSize) _ThumbnailGenerator2.default.checkImageAspectRatio(this.props.shapeModel, this.props.dispatch, true);else if (this.props.shapeModel.isNewImage == true) _ThumbnailGenerator2.default.checkImageAspectRatio(this.props.shapeModel, this.props.dispatch);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                if (shapes[i].isSelected == true) return true;else return false;
	            }
	        }return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties || this.props.showCroppingMenu != newProps.showCroppingMenu) return true;else return false;
	    },
	    render: function render() {
	        this.checkSize();
	
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        var filterName;
	        var filter;
	        var filterUrl;
	
	        if (shapeModel.backgroundVisible == false || shapeModel.fillOpacity == 0) {
	            // the filter shouldn't be visible
	        } else {
	            filterName = 'f_' + shapeModel.uuid;
	            filterUrl = 'url(#' + filterName + ')';
	
	            filter = _react2.default.createElement(
	                'filter',
	                { id: filterName },
	                _react2.default.createElement('feColorMatrix', { type: 'matrix', values: _ColorUtils2.default.hexToMatrix(shapeModel.fill) })
	            );
	        }
	
	        var clipPathObject;
	        var realWidth = shapeModel.width;
	        var realHeight = shapeModel.height;
	        var newShapeModel = shapeModel;
	        var x1 = 0;
	        var y1 = 0;
	        var clipId = 'hotSpot_' + shapeModel.uuid;
	        var clipPath = 'url(#' + clipId + ')';
	        var newX1 = 0;
	        var newY1 = 0;
	
	        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
	            realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
	            realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);
	
	            x1 = realWidth * shapeModel.hotSpot.x1 / 100;
	            y1 = realHeight * shapeModel.hotSpot.y1 / 100;
	            var x2 = realWidth * shapeModel.hotSpot.x2 / 100;
	            var y2 = realHeight * shapeModel.hotSpot.y2 / 100;
	
	            newX1 = x1;
	            newY1 = y1;
	
	            if (shapeModel.isNewFlip) {
	                if (shapeModel.isCropAndFlipHorizontal) newX1 = realWidth - x2;
	
	                if (shapeModel.isCropAndFlipVertical) newY1 = realHeight - y2;
	            }
	
	            if (_ZoomUtils2.default.isCroppingMode() && _ZoomUtils2.default.croppingTarget.uuid == shapeModel.uuid) {
	                newShapeModel = Object.assign({}, shapeModel);
	                newShapeModel.width = realWidth;
	                newShapeModel.height = realHeight;
	                newShapeModel.x = shapeModel.x - x1;
	                newShapeModel.y = shapeModel.y - y1;
	
	                x1 = 0;
	                y1 = 0;
	
	                newX1 = x1;
	                newY1 = y1;
	            } else {
	                clipPathObject = _react2.default.createElement(
	                    'clipPath',
	                    { id: clipId },
	                    _react2.default.createElement('rect', { x: newX1, y: newY1, width: x2 - x1, height: y2 - y1 })
	                );
	            }
	        }
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: newShapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + newShapeModel.x + ' ' + newShapeModel.y + ')', opacity: newShapeModel.opacity },
	                filter,
	                _react2.default.createElement(
	                    'g',
	                    { filter: filterUrl },
	                    clipPathObject,
	                    _react2.default.createElement(
	                        'g',
	                        { transform: 'translate(' + -newX1 + ' ' + -newY1 + ')' },
	                        _react2.default.createElement('image', {
	                            x: 0,
	                            y: 0,
	                            width: realWidth,
	                            height: realHeight,
	                            xlinkHref: newShapeModel.xlinkHref,
	                            filter: newShapeModel.filter,
	                            preserveAspectRatio: 'none',
	                            clipPath: clipPath
	                        })
	                    ),
	                    _react2.default.createElement('rect', {
	                        x: 0,
	                        y: 0,
	                        width: newShapeModel.width,
	                        height: newShapeModel.height,
	                        fill: 'none',
	                        stroke: newShapeModel.stroke,
	                        strokeWidth: newShapeModel.strokeWidth,
	                        strokeOpacity: newShapeModel.strokeOpacity
	                    }),
	                    !shapeModel.isGrouped ? _react2.default.createElement(
	                        'foreignObject',
	                        null,
	                        _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                    ) : null
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Character.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Character.js"); } } })();

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ComplexSpeakBubble = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _SpeakBubbleUtils = __webpack_require__(139);
	
	var _SpeakBubbleUtils2 = _interopRequireDefault(_SpeakBubbleUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _TouchUtils = __webpack_require__(109);
	
	var _TouchUtils2 = _interopRequireDefault(_TouchUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComplexSpeakBubble = exports.ComplexSpeakBubble = _react2.default.createClass({
	    displayName: 'ComplexSpeakBubble',
	
	    propTypes: {
	        shapeModel: _react2.default.PropTypes.object
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isTextHeightUpdated: false
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_PreviewCommands2.default.isPlayMode() == true) return;
	
	        if (!nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected && !_PlatformDetection2.default.isIOS()) // shape becomes unselected
	            this.clearTextSelection();
	
	        if (!_PlatformDetection2.default.isTouchableDevice()) return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) return;
	
	            if (shapeModel.isNew) {
	                this.changeFocus(true);
	                return;
	            }
	        }
	
	        if (shapeModel.moveState != nextProps.shapeModel.moveState || shapeModel.isNew != nextProps.shapeModel.isNew) {
	            if (nextProps.shapeModel.isSelected == true && (nextProps.shapeModel.moveState == false || nextProps.shapeModel.moveState == undefined)) {
	                if (_PlatformDetection2.default.isIOS() && _TouchUtils2.default.isLongInteraction() == true) return;
	
	                this.changeFocus(true);
	            }
	        }
	
	        if (!nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) // shape becomes unselected
	            this.changeFocus(false);
	    },
	    clearTextSelection: function clearTextSelection() {
	        if (this.refs.shapeTextArea) this.refs.shapeTextArea.selectionStart = this.refs.shapeTextArea.selectionEnd;
	    },
	    changeFocus: function changeFocus(isFocus) {
	        if (_PlatformDetection2.default.isIOS()) {
	            if (isFocus && !_AnimationManager2.default.isAnimationMode()) this.props.dispatch((0, _MenuActions.showTextEditor)(this.props.shapeModel));
	
	            return;
	        }
	
	        var view = this.refs.shapeTextArea;
	
	        if (view) {
	            if (isFocus == true) this.addFocus();else view.blur();
	        }
	    },
	    addFocus: function addFocus() {
	        var view = this.refs.shapeTextArea;
	
	        if (view) view.focus();
	    },
	    onChangeText: function onChangeText(e) {
	        if (_PreviewCommands2.default.isPlayMode() || _PlatformDetection2.default.isIOS()) return;
	
	        var newValue = e.target.value;
	
	        if (newValue == undefined) return;
	
	        this.props.dispatch((0, _CurrentSlideActions.changeTextProperties)(this.props.shapeModel, 'htmlText', newValue));
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        var isTextAdded = false;
	
	        if (newValue.length > this.props.shapeModel.htmlText.length && newValue.length > 10) isTextAdded = true;
	
	        setTimeout(this.checkSize, 50, isTextAdded);
	    },
	    checkIfIsNewShape: function checkIfIsNewShape() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (shapeModel.isNew == true) setTimeout(this.setTextAreaFocus, 10);
	    },
	    setTextAreaFocus: function setTextAreaFocus() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	        dispatch((0, _CurrentSlideActions.changeIsNewShape)(shapeModel.uuid, false));
	
	        if (!_PlatformDetection2.default.isIOS()) this.addFocus();
	    },
	    checkTextHeight: function checkTextHeight() {
	        var shapeModel = this.props.shapeModel;
	
	
	        if (!this.state.isTextHeightUpdated && !shapeModel.useLineHeightTextProperty) {
	            setTimeout(this.updateTextSize, 20);
	        }
	    },
	    updateTextSize: function updateTextSize() {
	        this.setState({
	            isTextHeightUpdated: true
	        });
	
	        this.checkSize();
	    },
	    checkSize: function checkSize() {
	        var isTextAdded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	        _TextSizeUtils2.default.updateTextWrapperSize(shapeModel, dispatch, isTextAdded);
	    },
	    onTextAreaClick: function onTextAreaClick() {
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT) return;
	
	        _CreateShapes2.default.checkFontMenu(this.props.dispatch, this.props.shapeModel);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	        if (currentSlide && currentSlide.model && currentSlide.model.content) {
	            var shapes = currentSlide.model.content;
	            var i;
	
	            for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                    if (shapes[i].isSelected == true) return true;else return false;
	                }
	            }return false;
	        }
	
	        return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	
	            this.checkTextLabel(false);
	        } else this.checkTextLabel(true);
	    },
	    checkTextLabel: function checkTextLabel() {
	        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        setTimeout(function () {
	            var textLabelElement = document.getElementById('textBoxLabel');
	
	            if (textLabelElement) {
	                if (show) textLabelElement.style.display = 'block';else textLabelElement.style.display = 'none';
	            }
	        }.bind(this), 10);
	    },
	    onFocusTextArea: function onFocusTextArea() {
	        if (document.activeElement == this.refs.shapeTextArea) this.checkTextLabel(true);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        this.checkIfIsNewShape();
	        this.checkTextHeight();
	
	        var _props3 = this.props,
	            shapeModel = _props3.shapeModel,
	            dispatch = _props3.dispatch;
	
	
	        var x = shapeModel.x;
	        var y = shapeModel.y;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var bold = shapeModel.fontBold ? 'bold' : 'normal';
	        var italic = shapeModel.fontItalic ? 'italic' : 'normal';
	        var textProperties = _TextSizeUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	
	        var textAreaStyle = {
	            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
	            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
	            resize: 'none',
	            overflow: 'hidden',
	            padding: INNER_PADDING,
	            border: 'none',
	            outline: 'none',
	            background: 'transparent',
	            fontFamily: shapeModel.fontFamily,
	            fontSize: shapeModel.fontSize,
	            fontStyle: italic,
	            fontWeight: bold,
	            color: shapeModel.fontColor,
	            textAlign: shapeModel.fontAlign,
	            wordSpacing: textProperties.wordSpacing,
	            letterSpacing: textProperties.letterSpacing,
	            textIdent: textProperties.textIdent
	        };
	
	        if (textProperties.lineHeight != -1) textAreaStyle.lineHeight = textProperties.lineHeight;
	
	        if (shapeModel.fontUnderline) textAreaStyle.textDecoration = 'underline';
	
	        var path = _SpeakBubbleUtils2.default.getPath(shapeModel);
	        shapeModel.path = path;
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var readOnlyValue = false;
	        var clone = _AnimationManager2.default.getCloneByUid(shapeModel.uuid);
	
	        if (!clone) clone = _AnimationManager2.default.clone;
	
	        if (_PlatformDetection2.default.isIOS() || clone && shapeModel.uuid == clone.uuid || _AnimationManager2.default.target && shapeModel.uuid == _AnimationManager2.default.target.uuid || _AppParameters2.default.isCartoonistPlayer()) {
	            readOnlyValue = true;
	            textAreaStyle.cursor = 'default';
	        }
	
	        var arabic = /[\u0600-\u06FF]/;
	
	        if (arabic.test(shapeModel.htmlText)) textAreaStyle.direction = 'rtl';
	
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var ariaLabelValue = _LocalesManager2.default.getCaption('tekst', 'other') + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var tabIndexValue;
	
	        if (!this.isShapeSelected()) tabIndexValue = -1;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, isBubble: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + x + ' ' + y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement('rect', { x: 0,
	                    y: 0,
	                    width: shapeModel.width,
	                    height: shapeModel.height,
	                    rx: 15,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity }),
	                _react2.default.createElement('path', {
	                    d: path,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none'
	                }),
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: PADDING, y: PADDING, width: shapeModel.width - 2 * PADDING, height: shapeModel.height - 2 * PADDING },
	                    !shapeModel.isGrouped ? _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown }) : null,
	                    _react2.default.createElement('textarea', { tabIndex: tabIndexValue, id: textAreaId, role: 'textbox', onFocus: this.onFocusTextArea, 'aria-label': ariaLabelValue, 'aria-multiline': 'true', className: 'textShapes', ref: 'shapeTextArea', style: textAreaStyle, value: shapeModel.htmlText, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onTouchEnd: this.onTextAreaClick, onMouseUp: this.onTextAreaClick, onChange: this.onChangeText, readOnly: readOnlyValue })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/ComplexSpeakBubble.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/ComplexSpeakBubble.js"); } } })();

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ComplexSpeakBubbleRich = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SpeakBubbleUtils = __webpack_require__(139);
	
	var _SpeakBubbleUtils2 = _interopRequireDefault(_SpeakBubbleUtils);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComplexSpeakBubbleRich = exports.ComplexSpeakBubbleRich = _react2.default.createClass({
	    displayName: 'ComplexSpeakBubbleRich',
	    componentDidMount: function componentDidMount() {
	        if (this.refs.shapeTextArea && this.props.shapeModel.htmlText) this.refs.shapeTextArea.innerHTML = _TextEditorUtils2.default.getHtmlText(this.props.shapeModel);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_TextEditorUtils2.default.isTextEditorTool()) return;
	
	        if (this.props.shapeModel.htmlText != nextProps.shapeModel.htmlText && this.refs.shapeTextArea) this.refs.shapeTextArea.innerHTML = _TextEditorUtils2.default.getHtmlText(nextProps.shapeModel);
	
	        // when a new shape is added to canvas, force focus to interactive element
	        if (this.props.shapeModel.isNew != nextProps.shapeModel.isNew) this.setFocusToInteractiveElement();
	
	        // when an element becomes selected (state 2) using multiple selection, the focus should be on interactiveElement to can have a keyDown event in case we type something to enter in Text Editor (state 3) because textArea is disabled at that time
	        if (nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected) this.setFocusToInteractiveElement();
	    },
	    setFocusToInteractiveElement: function setFocusToInteractiveElement() {
	        setTimeout(function () {
	            if (this.refs.focusableElement) // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
	                this.refs.focusableElement.focus();
	        }.bind(this), 2);
	    },
	    checkIfIsNewShape: function checkIfIsNewShape() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        if (shapeModel.isNew == true) setTimeout(function () {
	            dispatch((0, _CurrentSlideActions.changeIsNewShape)(shapeModel.uuid, false));
	        }.bind(this), 2);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	        if (currentSlide && currentSlide.model && currentSlide.model.content) {
	            var shapes = currentSlide.model.content;
	            var i;
	
	            for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                    if (shapes[i].isSelected == true) return true;else return false;
	                }
	            }return false;
	        }
	
	        return false;
	    },
	    isContentEditable: function isContentEditable() {
	        if (_AppParameters2.default.isCartoonistPlayer()) return false;
	
	        var clone = _AnimationManager2.default.getCloneByUid(this.props.shapeModel.uuid);
	
	        if (!clone) clone = _AnimationManager2.default.clone;
	
	        if (clone && this.props.shapeModel.uuid == clone.uuid || _AnimationManager2.default.target && this.props.shapeModel.uuid == _AnimationManager2.default.target.uuid) // non editable in animation mode
	            return false;
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) return true;else return false;
	    },
	
	
	    /************ text area *************/
	    onChangeText: function onChangeText(e) {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        if (e.nativeEvent && e.nativeEvent.inputType === 'insertFromPaste') {
	            var txt = this.refs.shapeTextArea.innerText;
	            this.refs.shapeTextArea.innerHTML = '<span style="font-family: Cabin; font-size: 24px; white-space: pre-wrap">' + txt + '</span>';
	        } else _TextEditorUtils2.default.checkForSizeAttribute(this.refs.shapeTextArea);
	
	        // console.log('aaaa ' + document.getElementById('text_area_' + this.props.shapeModel.uuid).innerHTML);
	
	        _TextEditorUtils2.default.resetActions();
	        _TextEditorUtils2.default.updateShapeSize(this.props.shapeModel, this.props.dispatch);
	    },
	    onTextAreaClick: function onTextAreaClick() {
	        var selection = window.getSelection();
	
	        if (selection.anchorOffset == selection.extentOffset && _TextEditorUtils2.default.lastCursorPosition >= 0 && selection.anchorOffset == _TextEditorUtils2.default.lastCursorPosition) {// no text selected and only the cursor pointer
	            // if a text size was changed while no text selection and you will click on the same cursor position, then we should use the selected text size
	        } else {
	            _TextEditorUtils2.default.resetActions();
	        }
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) // if the textEditor is opened then should refresh it at every click to can updated properly the right buttons
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	            }.bind(this), 5);else this.checkTextEditorTool();
	    },
	    checkTextEditorTool: function checkTextEditorTool() {
	        // check to see if TEXT EDITOR tool can be opened
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT || _StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) return;
	
	        if (!this.props.shapeModel.isSelected) return;
	
	        this.setFocusToInteractiveElement(); // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
	
	        if (_TextEditorUtils2.default.isClick && _TextEditorUtils2.default.isShapeAlreadySelected) _TextEditorUtils2.default.openTextEditorTool(this.props.shapeModel);
	    },
	    onFocusTextArea: function onFocusTextArea() {
	        this.onFocusHandler();
	    },
	    handleKeyDown: function handleKeyDown(e) {
	        // when a key is down on text area
	        if (e.keyCode === 27 && this.refs.shapeTextArea === document.activeElement) {
	            // ESCAPE when the focus is on text ... close TEXT EDITOR mode ... next TAB should go to the hamburger menu
	            _TextEditorUtils2.default.closeTextEditor();
	            return;
	        }
	
	        if (e.keyCode === 9) {
	            // when TAB is down, then the focus will go to the CLOSE button on the TEXT EDITOR tool.
	            var closeButtonOnTextEditorTool = document.getElementById('firstFocusableObjectForTextEditorTool');
	
	            if (closeButtonOnTextEditorTool) {
	                setTimeout(function () {
	                    closeButtonOnTextEditorTool.focus();
	                }.bind(this), 2);
	            }
	
	            return;
	        }
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) {
	            // The user might move the insertion point with the arrow keys, so this will update the selected text types (only) on arrow key presses.
	            var arrowKeys = [37, 38, 39, 40];
	
	            if (arrowKeys.includes(e.keyCode)) // if is textTool is opened and move arrow keys then update the right buttons
	                setTimeout(function () {
	                    _TextEditorUtils2.default.resetActions();
	                    this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	                }.bind(this), 10);
	        }
	    },
	
	
	    /*************** interactive element ***************/
	    onKeyDown: function onKeyDown(e) {
	        // when key down on the interactive element
	        if (e.ctrlKey == true || e.altKey == true) // when commands keys don't open TEXT EDITOR
	            return;
	
	        var arrowKeys = [9, 27, 8, 46, 37, 38, 39, 40, 16]; // TAB, ESCAPE, BACKSPACE ,DELETE and arrow keys, SHIFT
	
	        if (arrowKeys.includes(e.keyCode)) {
	            // some keys are used for removing shape, moving shape or to change the tab
	            _TextEditorUtils2.default.resetActions();
	            return;
	        }
	
	        if (document.activeElement.id.indexOf('interactiveElement') != -1) // if interactive element is selected
	            _TextEditorUtils2.default.openTextEditorTool(this.props.shapeModel, { key: e.key, keyCode: e.keyCode });
	    },
	    onFocusHandler: function onFocusHandler() {
	        // on focus interactive element
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) {
	                _TextEditorUtils2.default.closeTextEditor();
	                this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	            }
	        }
	
	        _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        this.checkTextLabel();
	    },
	    checkTextLabel: function checkTextLabel() {
	        setTimeout(function () {
	            var textLabelElement = document.getElementById('textBoxLabel');
	
	            if (textLabelElement) textLabelElement.style.display = 'block';
	        }.bind(this), 3);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        this.checkIfIsNewShape();
	
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	        var x = shapeModel.x;
	        var y = shapeModel.y;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var textProperties = _TextEditorUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	
	        var textAreaStyle = {
	            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
	            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
	            resize: 'none',
	            overflow: 'hidden',
	            padding: INNER_PADDING,
	            border: 'none',
	            outline: 'none',
	            background: 'transparent',
	            wordSpacing: textProperties.wordSpacing,
	            letterSpacing: textProperties.letterSpacing,
	            overflowWrap: 'break-word',
	            cursor: 'text'
	        };
	
	        if (shapeModel.lineHeight > 0) textAreaStyle.lineHeight = shapeModel.lineHeight;else {
	            if (textProperties.lineHeight != -1) textAreaStyle.lineHeight = textProperties.lineHeight;
	        }
	
	        var path = _SpeakBubbleUtils2.default.getPath(shapeModel);
	        shapeModel.path = path;
	
	        var backgroundOpacity = void 0;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var arabic = /[\u0600-\u06FF]/;
	
	        if (arabic.test(shapeModel.htmlText)) textAreaStyle.direction = 'rtl';
	
	        var isContentEditable = this.isContentEditable();
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var ariaLabelValue = _LocalesManager2.default.getCaption('tekst', 'other') + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var tabIndexValue = void 0;
	
	        if (!isContentEditable) textAreaStyle.cursor = 'default';
	
	        if (!this.isShapeSelected()) tabIndexValue = -1;
	
	        var isRotation = shapeModel.isMindMap ? false : true;
	        var strokeWidth = shapeModel.strokeWidth;
	
	        if (shapeModel.isMindMap && strokeWidth < 2) strokeWidth = 2;
	
	        var imageNode = void 0;
	
	        if (shapeModel.imageNode && shapeModel.imageNode.length > 0 && shapeModel.aspectRatio > 0) {
	            var maxWidth = textAreaStyle.width * 0.7;
	            var imageWidth = textAreaStyle.height * shapeModel.aspectRatio;
	
	            if (imageWidth > maxWidth) imageWidth = maxWidth;
	
	            imageNode = _react2.default.createElement('image', { x: INNER_PADDING, y: INNER_PADDING, height: textAreaStyle.height, width: imageWidth, xlinkHref: shapeModel.imageNode, preserveAspectRatio: 'none' });
	
	            textAreaStyle.paddingLeft = 2 * INNER_PADDING + imageWidth;
	            textAreaStyle.width = textAreaStyle.width - INNER_PADDING - imageWidth;
	        } else textAreaStyle.paddingLeft = INNER_PADDING;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: isRotation, isBubble: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + x + ' ' + y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement('rect', { x: 0,
	                    y: 0,
	                    width: shapeModel.width,
	                    height: shapeModel.height,
	                    rx: 15,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity }),
	                _react2.default.createElement('path', {
	                    d: path,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none'
	                }),
	                imageNode,
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: PADDING, y: PADDING, width: shapeModel.width - 2 * PADDING, height: shapeModel.height - 2 * PADDING },
	                    !shapeModel.isGrouped ? _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, ref: 'focusableElement', href: '', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown }) : null,
	                    _react2.default.createElement('div', { id: textAreaId, tabIndex: tabIndexValue, ref: 'shapeTextArea', className: 'textShapes', role: 'textbox', 'aria-label': ariaLabelValue, 'aria-multiline': 'true', style: textAreaStyle, contentEditable: isContentEditable, suppressContentEditableWarning: true, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onTouchEnd: this.onTextAreaClick, onMouseUp: this.onTextAreaClick, onKeyDown: this.handleKeyDown, onInput: this.onChangeText, onFocus: this.onFocusTextArea })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/ComplexSpeakBubbleRich.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/ComplexSpeakBubbleRich.js"); } } })();

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Curve = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InteractiveNonRectangularShape = __webpack_require__(346);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Curve = exports.Curve = _react2.default.createClass({
	    displayName: 'Curve',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        shapeModel: _react2.default.PropTypes.object.isRequired
	    },
	    createNewPath: function createNewPath(shapeModel) {
	        var x = Math.min(shapeModel.x1, shapeModel.x2);
	        var y = Math.min(shapeModel.y1, shapeModel.y2);
	        var path = 'M' + (shapeModel.x1 - x) + ',' + (shapeModel.y1 - y) + 'Q' + (shapeModel.cx - x) + ',' + (shapeModel.cy - y) + ',' + (shapeModel.x2 - x) + ',' + (shapeModel.y2 - y);
	
	        return path;
	    },
	    isShapeSelected: function isShapeSelected() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                if (shapes[i].isSelected == true) return true;else return false;
	            }
	        }return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        var path = this.createNewPath(shapeModel);
	
	        return _react2.default.createElement(
	            _InteractiveNonRectangularShape.InteractiveNonRectangularShape,
	            { shapeModel: shapeModel, dispatch: dispatch, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                null,
	                _react2.default.createElement('path', {
	                    d: path,
	                    filter: shapeModel.filter,
	                    opacity: shapeModel.opacity,
	                    fill: '#ffffff',
	                    fillOpacity: '0',
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none'
	                }),
	                !shapeModel.isGrouped ? _react2.default.createElement(
	                    'foreignObject',
	                    null,
	                    _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                ) : null
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Curve.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Curve.js"); } } })();

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Ellipse = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Ellipse = exports.Ellipse = _react2.default.createClass({
	    displayName: 'Ellipse',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        shapeModel: _react2.default.PropTypes.object.isRequired
	    },
	    isShapeSelected: function isShapeSelected() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                if (shapes[i].isSelected == true) return true;else return false;
	            }
	        }return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var clipPathObject;
	        var realWidth = shapeModel.width;
	        var realHeight = shapeModel.height;
	        var newShapeModel = shapeModel;
	        var x1 = 0;
	        var y1 = 0;
	        var clipId = 'hotSpot_' + shapeModel.uuid;
	        var clipPath = 'url(#' + clipId + ')';
	
	        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
	            realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
	            realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);
	
	            x1 = realWidth * shapeModel.hotSpot.x1 / 100;
	            y1 = realHeight * shapeModel.hotSpot.y1 / 100;
	            var x2 = realWidth * shapeModel.hotSpot.x2 / 100;
	            var y2 = realHeight * shapeModel.hotSpot.y2 / 100;
	
	            if (_ZoomUtils2.default.isCroppingMode() && _ZoomUtils2.default.croppingTarget.uuid == shapeModel.uuid) {
	                newShapeModel = Object.assign({}, shapeModel);
	                newShapeModel.width = realWidth;
	                newShapeModel.height = realHeight;
	                newShapeModel.x = shapeModel.x - x1;
	                newShapeModel.y = shapeModel.y - y1;
	
	                x1 = 0;
	                y1 = 0;
	            } else {
	                clipPathObject = _react2.default.createElement(
	                    'clipPath',
	                    { id: clipId },
	                    _react2.default.createElement('rect', { x: x1, y: y1, width: x2 - x1, height: y2 - y1 })
	                );
	            }
	        }
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: newShapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                null,
	                clipPathObject,
	                _react2.default.createElement(
	                    'g',
	                    { transform: 'translate(' + -x1 + ' ' + -y1 + ')' },
	                    _react2.default.createElement('ellipse', {
	                        rx: realWidth / 2,
	                        ry: realHeight / 2,
	                        cx: realWidth / 2,
	                        cy: realHeight / 2,
	                        filter: newShapeModel.filter,
	                        fill: newShapeModel.fill,
	                        fillOpacity: backgroundOpacity,
	                        stroke: newShapeModel.stroke,
	                        strokeWidth: newShapeModel.strokeWidth,
	                        strokeOpacity: newShapeModel.strokeOpacity,
	                        preserveAspectRatio: 'none',
	                        opacity: newShapeModel.opacity,
	                        clipPath: clipPath
	                    })
	                ),
	                !shapeModel.isGrouped ? _react2.default.createElement(
	                    'foreignObject',
	                    null,
	                    _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                ) : null
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Ellipse.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Ellipse.js"); } } })();

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Freehand = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Freehand = exports.Freehand = _react2.default.createClass({
	    displayName: 'Freehand',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        shapeModel: _react2.default.PropTypes.object.isRequired
	    },
	    createNewPath: function createNewPath(shapeModel) {
	        var pathPoints = shapeModel.pathPoints;
	        var length = pathPoints.length;
	        var i = void 0;
	        var path = 'M' + pathPoints[0].x + ',' + pathPoints[0].y;
	
	        for (i = 0; i < length; i++) {
	            path = path + 'L' + pathPoints[i].x + ',' + pathPoints[i].y;
	        }
	
	        return path;
	    },
	    isShapeSelected: function isShapeSelected() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                if (shapes[i].isSelected == true) return true;else return false;
	            }
	        }return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        var path = this.createNewPath(shapeModel);
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                null,
	                _react2.default.createElement('rect', {
	                    x: 0,
	                    y: 0,
	                    width: shapeModel.width,
	                    height: shapeModel.height,
	                    fill: '#000000',
	                    opacity: 0
	                }),
	                _react2.default.createElement('path', {
	                    d: path,
	                    filter: shapeModel.filter,
	                    opacity: shapeModel.opacity,
	                    fill: 'none',
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none'
	                }),
	                !shapeModel.isGrouped ? _react2.default.createElement(
	                    'foreignObject',
	                    null,
	                    _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                ) : null
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Freehand.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Freehand.js"); } } })();

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Heart = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Heart = exports.Heart = _react2.default.createClass({
	    displayName: 'Heart',
	    getHeartPath: function getHeartPath(shapeModel) {
	        var separator = ',';
	        var bottomXOffset = shapeModel.width / 20;
	        var bottomYOffset = shapeModel.height / 20;
	
	        var path = 'M' + (shapeModel.width / 2 + bottomXOffset) + separator + (shapeModel.height - bottomYOffset);
	
	        path = path + 'Q' + shapeModel.width / 2 + separator + shapeModel.height + separator + (shapeModel.width / 2 - bottomXOffset) + separator + (shapeModel.height - bottomYOffset);
	
	        var horizontalOffset = shapeModel.width / 10;
	        var verticalOffset = shapeModel.height / 2;
	
	        path = path + 'L' + horizontalOffset + separator + verticalOffset;
	
	        var rx = shapeModel.width / 6;
	        var ry = shapeModel.height / 6;
	        var xAxisRotation = 1;
	        var largeArcFlag = 0;
	        var sweepFlag = 1;
	        var endX = shapeModel.width / 2;
	        var endY = shapeModel.height / 8;
	
	        path = path + 'A' + rx + ',' + ry + ',' + xAxisRotation + ',' + largeArcFlag + ',' + sweepFlag + ',' + endX + ',' + endY;
	
	        endX = shapeModel.width - horizontalOffset;
	        endY = verticalOffset;
	
	        path = path + 'A' + rx + ',' + ry + ',' + xAxisRotation + ',' + largeArcFlag + ',' + sweepFlag + ',' + endX + ',' + endY;
	
	        path = path + 'Z';
	
	        return path;
	    },
	    isShapeSelected: function isShapeSelected() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                if (shapes[i].isSelected == true) return true;else return false;
	            }
	        }return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var clipPathObject;
	        var realWidth = shapeModel.width;
	        var realHeight = shapeModel.height;
	        var newShapeModel = shapeModel;
	        var x1 = 0;
	        var y1 = 0;
	        var clipId = 'hotSpot_' + shapeModel.uuid;
	        var clipPath = 'url(#' + clipId + ')';
	        var originalModel = shapeModel;
	
	        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
	            realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
	            realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);
	
	            x1 = realWidth * shapeModel.hotSpot.x1 / 100;
	            y1 = realHeight * shapeModel.hotSpot.y1 / 100;
	            var x2 = realWidth * shapeModel.hotSpot.x2 / 100;
	            var y2 = realHeight * shapeModel.hotSpot.y2 / 100;
	
	            originalModel = Object.assign({}, shapeModel);
	            originalModel.width = realWidth;
	            originalModel.height = realHeight;
	            originalModel.x = shapeModel.x - x1;
	            originalModel.y = shapeModel.y - y1;
	
	            if (_ZoomUtils2.default.isCroppingMode() && _ZoomUtils2.default.croppingTarget.uuid == shapeModel.uuid) {
	                newShapeModel = Object.assign({}, shapeModel);
	                newShapeModel.width = realWidth;
	                newShapeModel.height = realHeight;
	                newShapeModel.x = shapeModel.x - x1;
	                newShapeModel.y = shapeModel.y - y1;
	
	                x1 = 0;
	                y1 = 0;
	            } else {
	                clipPathObject = _react2.default.createElement(
	                    'clipPath',
	                    { id: clipId },
	                    _react2.default.createElement('rect', { x: x1, y: y1, width: x2 - x1, height: y2 - y1 })
	                );
	            }
	        }
	
	        var path = this.getHeartPath(originalModel);
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: newShapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                null,
	                clipPathObject,
	                _react2.default.createElement(
	                    'g',
	                    { opacity: newShapeModel.opacity, transform: 'translate(' + -x1 + ' ' + -y1 + ')' },
	                    _react2.default.createElement('path', {
	                        d: path,
	                        filter: newShapeModel.filter,
	                        opacity: newShapeModel.opacity,
	                        fill: newShapeModel.fill,
	                        fillOpacity: backgroundOpacity,
	                        stroke: newShapeModel.stroke,
	                        strokeWidth: newShapeModel.strokeWidth,
	                        strokeOpacity: newShapeModel.strokeOpacity,
	                        preserveAspectRatio: 'none',
	                        clipPath: clipPath
	                    })
	                ),
	                !shapeModel.isGrouped ? _react2.default.createElement(
	                    'foreignObject',
	                    null,
	                    _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                ) : null
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Heart.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Heart.js"); } } })();

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Image = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ThumbnailGenerator = __webpack_require__(144);
	
	var _ThumbnailGenerator2 = _interopRequireDefault(_ThumbnailGenerator);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _ColorUtils = __webpack_require__(240);
	
	var _ColorUtils2 = _interopRequireDefault(_ColorUtils);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Image = exports.Image = _react2.default.createClass({
	    displayName: 'Image',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        shapeModel: _react2.default.PropTypes.object.isRequired
	    },
	    checkSize: function checkSize() {
	        if (_PreviewCommands2.default.isPlayMode() == true) return;
	
	        setTimeout(this.checkImageSize, 5);
	    },
	    checkImageSize: function checkImageSize() {
	        if (this.props.shapeModel.isNewImage == true) _ThumbnailGenerator2.default.checkImageAspectRatio(this.props.shapeModel, this.props.dispatch);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                if (shapes[i].isSelected == true) return true;else return false;
	            }
	        }return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties || this.props.showCroppingMenu != newProps.showCroppingMenu) return true;else return false;
	    },
	    render: function render() {
	        this.checkSize();
	
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        var filterName;
	        var filter;
	        var filterUrl;
	
	        if (shapeModel.backgroundVisible == false || shapeModel.fillOpacity == 0) {
	            // the filter shouldn't be visible
	        } else {
	            filterName = 'f_' + shapeModel.uuid;
	            filterUrl = 'url(#' + filterName + ')';
	
	            filter = _react2.default.createElement(
	                'filter',
	                { id: filterName },
	                _react2.default.createElement('feColorMatrix', { type: 'matrix', values: _ColorUtils2.default.hexToMatrix(shapeModel.fill) })
	            );
	        }
	
	        var clipPathObject;
	        var realWidth = shapeModel.width;
	        var realHeight = shapeModel.height;
	        var newShapeModel = shapeModel;
	        var x1 = 0;
	        var y1 = 0;
	        var clipId = 'hotSpot_' + shapeModel.uuid;
	        var clipPath = 'url(#' + clipId + ')';
	        var newX1 = 0;
	        var newY1 = 0;
	
	        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
	            realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
	            realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);
	
	            x1 = realWidth * shapeModel.hotSpot.x1 / 100;
	            y1 = realHeight * shapeModel.hotSpot.y1 / 100;
	            var x2 = realWidth * shapeModel.hotSpot.x2 / 100;
	            var y2 = realHeight * shapeModel.hotSpot.y2 / 100;
	
	            newX1 = x1;
	            newY1 = y1;
	
	            if (shapeModel.isNewFlip) {
	                if (shapeModel.isCropAndFlipHorizontal) newX1 = realWidth - x2;
	
	                if (shapeModel.isCropAndFlipVertical) newY1 = realHeight - y2;
	            }
	
	            if (_ZoomUtils2.default.isCroppingMode()) {
	                newShapeModel = Object.assign({}, shapeModel);
	                newShapeModel.width = realWidth;
	                newShapeModel.height = realHeight;
	                newShapeModel.x = shapeModel.x - x1;
	                newShapeModel.y = shapeModel.y - y1;
	
	                x1 = 0;
	                y1 = 0;
	
	                newX1 = x1;
	                newY1 = y1;
	            } else {
	                clipPathObject = _react2.default.createElement(
	                    'clipPath',
	                    { id: clipId },
	                    _react2.default.createElement('rect', { x: newX1, y: newY1, width: x2 - x1, height: y2 - y1 })
	                );
	            }
	        }
	
	        var imageSrc = _VideoUtils2.default.checkCacheBreaker(newShapeModel.xlinkHref);
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: newShapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + newShapeModel.x + ' ' + newShapeModel.y + ')', opacity: newShapeModel.opacity },
	                filter,
	                _react2.default.createElement(
	                    'g',
	                    { filter: filterUrl },
	                    clipPathObject,
	                    _react2.default.createElement(
	                        'g',
	                        { transform: 'translate(' + -newX1 + ' ' + -newY1 + ')' },
	                        _react2.default.createElement('image', {
	                            x: 0,
	                            y: 0,
	                            width: realWidth,
	                            height: realHeight,
	                            xlinkHref: imageSrc,
	                            filter: newShapeModel.filter,
	                            preserveAspectRatio: 'none',
	                            clipPath: clipPath
	                        })
	                    ),
	                    _react2.default.createElement('rect', { x: 0,
	                        y: 0,
	                        width: newShapeModel.width,
	                        height: newShapeModel.height,
	                        fill: 'none',
	                        stroke: newShapeModel.stroke,
	                        strokeWidth: newShapeModel.strokeWidth,
	                        strokeOpacity: newShapeModel.strokeOpacity,
	                        preserveAspectRatio: 'none' }),
	                    !shapeModel.isGrouped ? _react2.default.createElement(
	                        'foreignObject',
	                        null,
	                        _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                    ) : null
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Image.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Image.js"); } } })();

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Line = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InteractiveNonRectangularShape = __webpack_require__(346);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Line = exports.Line = _react2.default.createClass({
	    displayName: 'Line',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        shapeModel: _react2.default.PropTypes.object.isRequired
	    },
	    isShapeSelected: function isShapeSelected() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                if (shapes[i].isSelected == true) return true;else return false;
	            }
	        }return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        var x = Math.min(shapeModel.x1, shapeModel.x2);
	        var y = Math.min(shapeModel.y1, shapeModel.y2);
	
	        return _react2.default.createElement(
	            _InteractiveNonRectangularShape.InteractiveNonRectangularShape,
	            { shapeModel: shapeModel, dispatch: dispatch, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                null,
	                _react2.default.createElement('rect', {
	                    x: 0,
	                    y: 0,
	                    width: Math.abs(shapeModel.x1 - shapeModel.x2),
	                    height: Math.abs(shapeModel.y1 - shapeModel.y2),
	                    fill: '#000000',
	                    opacity: 0
	                }),
	                _react2.default.createElement('line', {
	                    x1: shapeModel.x1 - x,
	                    y1: shapeModel.y1 - y,
	                    x2: shapeModel.x2 - x,
	                    y2: shapeModel.y2 - y,
	                    filter: shapeModel.filter,
	                    opacity: shapeModel.opacity,
	                    fill: 'none',
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none'
	                }),
	                !shapeModel.isGrouped ? _react2.default.createElement(
	                    'foreignObject',
	                    null,
	                    _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                ) : null
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Line.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Line.js"); } } })();

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Rectangle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Rectangle = exports.Rectangle = _react2.default.createClass({
	    displayName: 'Rectangle',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        shapeModel: _react2.default.PropTypes.object.isRequired
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    isShapeSelected: function isShapeSelected() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                if (shapes[i].isSelected == true) return true;else return false;
	            }
	        }return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        }
	    },
	    render: function render() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { x: shapeModel.x, y: shapeModel.y },
	                _react2.default.createElement('rect', {
	                    x: 0,
	                    y: 0,
	                    width: shapeModel.width,
	                    height: shapeModel.height,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none',
	                    opacity: shapeModel.opacity
	                }),
	                !shapeModel.isGrouped ? _react2.default.createElement(
	                    'foreignObject',
	                    null,
	                    _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                ) : null
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Rectangle.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Rectangle.js"); } } })();

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ScreamBubble = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _ScreamBubbleUtils = __webpack_require__(236);
	
	var _ScreamBubbleUtils2 = _interopRequireDefault(_ScreamBubbleUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _TouchUtils = __webpack_require__(109);
	
	var _TouchUtils2 = _interopRequireDefault(_TouchUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScreamBubble = exports.ScreamBubble = _react2.default.createClass({
	    displayName: 'ScreamBubble',
	
	    propTypes: {
	        shapeModel: _react2.default.PropTypes.object
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isTextHeightUpdated: false
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_PreviewCommands2.default.isPlayMode() == true) return;
	
	        if (!nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected && !_PlatformDetection2.default.isIOS()) // shape becomes unselected
	            this.clearTextSelection();
	
	        if (!_PlatformDetection2.default.isTouchableDevice()) return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) return;
	
	            if (shapeModel.isNew) {
	                this.changeFocus(true);
	                return;
	            }
	        }
	
	        if (shapeModel.moveState != nextProps.shapeModel.moveState || shapeModel.isNew != nextProps.shapeModel.isNew) {
	            if (nextProps.shapeModel.isSelected == true && (nextProps.shapeModel.moveState == false || nextProps.shapeModel.moveState == undefined)) {
	                if (_PlatformDetection2.default.isIOS() && _TouchUtils2.default.isLongInteraction() == true) return;
	
	                this.changeFocus(true);
	            }
	        }
	
	        if (!nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) // shape becomes unselected
	            this.changeFocus(false);
	    },
	    clearTextSelection: function clearTextSelection() {
	        if (this.refs.shapeTextArea) this.refs.shapeTextArea.selectionStart = this.refs.shapeTextArea.selectionEnd;
	    },
	    changeFocus: function changeFocus(isFocus) {
	        if (_PlatformDetection2.default.isIOS()) {
	            if (isFocus && !_AnimationManager2.default.isAnimationMode()) this.props.dispatch((0, _MenuActions.showTextEditor)(this.props.shapeModel));
	
	            return;
	        }
	
	        var view = this.refs.shapeTextArea;
	
	        if (view) {
	            if (isFocus == true) this.addFocus();else view.blur();
	        }
	    },
	    addFocus: function addFocus() {
	        var view = this.refs.shapeTextArea;
	
	        if (view) view.focus();
	    },
	    onChangeText: function onChangeText(e) {
	        if (_PreviewCommands2.default.isPlayMode() || _PlatformDetection2.default.isIOS()) return;
	
	        var newValue = e.target.value;
	
	        if (newValue == undefined) return;
	
	        this.props.dispatch((0, _CurrentSlideActions.changeTextProperties)(this.props.shapeModel, 'htmlText', newValue));
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        var isTextAdded = false;
	
	        if (newValue.length > this.props.shapeModel.htmlText.length && newValue.length > 10) isTextAdded = true;
	
	        setTimeout(this.checkSize, 50, isTextAdded);
	    },
	    checkIfIsNewShape: function checkIfIsNewShape() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (shapeModel.isNew == true) setTimeout(this.setTextAreaFocus, 10);
	    },
	    setTextAreaFocus: function setTextAreaFocus() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	        dispatch((0, _CurrentSlideActions.changeIsNewShape)(shapeModel.uuid, false));
	
	        if (!_PlatformDetection2.default.isIOS()) this.addFocus();
	    },
	    checkTextHeight: function checkTextHeight() {
	        var shapeModel = this.props.shapeModel;
	
	
	        if (!this.state.isTextHeightUpdated && !shapeModel.useLineHeightTextProperty) {
	            setTimeout(this.updateTextSize, 20);
	        }
	    },
	    updateTextSize: function updateTextSize() {
	        this.setState({
	            isTextHeightUpdated: true
	        });
	
	        this.checkSize();
	    },
	    checkSize: function checkSize() {
	        var isTextAdded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	        _TextSizeUtils2.default.updateTextWrapperSize(shapeModel, dispatch, isTextAdded);
	    },
	    onTextAreaClick: function onTextAreaClick() {
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT) return;
	
	        _CreateShapes2.default.checkFontMenu(this.props.dispatch, this.props.shapeModel);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	        if (currentSlide && currentSlide.model && currentSlide.model.content) {
	            var shapes = currentSlide.model.content;
	            var i;
	
	            for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                    if (shapes[i].isSelected == true) return true;else return false;
	                }
	            }return false;
	        }
	
	        return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	
	            this.checkTextLabel(false);
	        } else this.checkTextLabel(true);
	    },
	    checkTextLabel: function checkTextLabel() {
	        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        setTimeout(function () {
	            var textLabelElement = document.getElementById('textBoxLabel');
	
	            if (textLabelElement) {
	                if (show) textLabelElement.style.display = 'block';else textLabelElement.style.display = 'none';
	            }
	        }.bind(this), 10);
	    },
	    onFocusTextArea: function onFocusTextArea() {
	        if (document.activeElement == this.refs.shapeTextArea) this.checkTextLabel(true);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        this.checkIfIsNewShape();
	        this.checkTextHeight();
	
	        var _props3 = this.props,
	            shapeModel = _props3.shapeModel,
	            dispatch = _props3.dispatch;
	
	
	        var x = shapeModel.x;
	        var y = shapeModel.y;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var bold = shapeModel.fontBold ? 'bold' : 'normal';
	        var italic = shapeModel.fontItalic ? 'italic' : 'normal';
	        var textProperties = _TextSizeUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	
	        var textAreaStyle = {
	            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
	            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
	            resize: 'none',
	            overflow: 'hidden',
	            padding: INNER_PADDING,
	            border: 'none',
	            outline: 'none',
	            background: 'transparent',
	            fontFamily: shapeModel.fontFamily,
	            fontSize: shapeModel.fontSize,
	            fontStyle: italic,
	            fontWeight: bold,
	            color: shapeModel.fontColor,
	            textAlign: shapeModel.fontAlign,
	            wordSpacing: textProperties.wordSpacing,
	            letterSpacing: textProperties.letterSpacing,
	            textIdent: textProperties.textIdent
	        };
	
	        if (textProperties.lineHeight != -1) textAreaStyle.lineHeight = textProperties.lineHeight;
	
	        if (shapeModel.fontUnderline) textAreaStyle.textDecoration = 'underline';
	
	        var path = '';
	
	        if (!shapeModel.path) {
	            path = _ScreamBubbleUtils2.default.getPath(shapeModel);
	            shapeModel.path = path;
	        } else {
	            path = shapeModel.path;
	        }
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var readOnlyValue = false;
	        var clone = _AnimationManager2.default.getCloneByUid(shapeModel.uuid);
	
	        if (!clone) clone = _AnimationManager2.default.clone;
	
	        if (_PlatformDetection2.default.isIOS() || clone && shapeModel.uuid == clone.uuid || _AnimationManager2.default.target && shapeModel.uuid == _AnimationManager2.default.target.uuid || _AppParameters2.default.isCartoonistPlayer()) {
	            readOnlyValue = true;
	            textAreaStyle.cursor = 'default';
	        }
	
	        var arabic = /[\u0600-\u06FF]/;
	
	        if (arabic.test(shapeModel.htmlText)) textAreaStyle.direction = 'rtl';
	
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var ariaLabelValue = _LocalesManager2.default.getCaption('tekst', 'other') + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var tabIndexValue;
	
	        if (!this.isShapeSelected()) tabIndexValue = -1;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, isBubble: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + x + ' ' + y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement('path', {
	                    d: path,
	                    filter: shapeModel.filter,
	                    opacity: shapeModel.opacity,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none' }),
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: PADDING, y: PADDING, width: shapeModel.width - 2 * PADDING, height: shapeModel.height - 2 * PADDING },
	                    !shapeModel.isGrouped ? _react2.default.createElement(
	                        'foreignObject',
	                        null,
	                        _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                    ) : null,
	                    _react2.default.createElement('textarea', { tabIndex: tabIndexValue, id: textAreaId, role: 'textbox', onFocus: this.onFocusTextArea, 'aria-label': ariaLabelValue, 'aria-multiline': 'true', className: 'textShapes', ref: 'shapeTextArea', style: textAreaStyle, value: shapeModel.htmlText, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onTouchEnd: this.onTextAreaClick, onMouseUp: this.onTextAreaClick, onChange: this.onChangeText, readOnly: readOnlyValue })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/ScreamBubble.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/ScreamBubble.js"); } } })();

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ScreamBubbleRich = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ScreamBubbleUtils = __webpack_require__(236);
	
	var _ScreamBubbleUtils2 = _interopRequireDefault(_ScreamBubbleUtils);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScreamBubbleRich = exports.ScreamBubbleRich = _react2.default.createClass({
	    displayName: 'ScreamBubbleRich',
	    componentDidMount: function componentDidMount() {
	        if (this.refs.shapeTextArea && this.props.shapeModel.htmlText) this.refs.shapeTextArea.innerHTML = _TextEditorUtils2.default.getHtmlText(this.props.shapeModel);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_TextEditorUtils2.default.isTextEditorTool()) return;
	
	        if (this.props.shapeModel.htmlText != nextProps.shapeModel.htmlText && this.refs.shapeTextArea) this.refs.shapeTextArea.innerHTML = _TextEditorUtils2.default.getHtmlText(nextProps.shapeModel);
	
	        // when a new shape is added to canvas, force focus to interactive element
	        if (this.props.shapeModel.isNew != nextProps.shapeModel.isNew) this.setFocusToInteractiveElement();
	
	        // when an element becomes selected (state 2) using multiple selection, the focus should be on interactiveElement to can have a keyDown event in case we type something to enter in Text Editor (state 3) because textArea is disabled at that time
	        if (nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected) this.setFocusToInteractiveElement();
	    },
	    setFocusToInteractiveElement: function setFocusToInteractiveElement() {
	        setTimeout(function () {
	            if (this.refs.focusableElement) // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
	                this.refs.focusableElement.focus();
	        }.bind(this), 2);
	    },
	    checkIfIsNewShape: function checkIfIsNewShape() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        if (shapeModel.isNew == true) setTimeout(function () {
	            dispatch((0, _CurrentSlideActions.changeIsNewShape)(shapeModel.uuid, false));
	        }.bind(this), 2);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	        if (currentSlide && currentSlide.model && currentSlide.model.content) {
	            var shapes = currentSlide.model.content;
	            var i;
	
	            for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                    if (shapes[i].isSelected == true) return true;else return false;
	                }
	            }return false;
	        }
	
	        return false;
	    },
	    isContentEditable: function isContentEditable() {
	        if (_AppParameters2.default.isCartoonistPlayer()) return false;
	
	        var clone = _AnimationManager2.default.getCloneByUid(this.props.shapeModel.uuid);
	
	        if (!clone) clone = _AnimationManager2.default.clone;
	
	        if (clone && this.props.shapeModel.uuid == clone.uuid || _AnimationManager2.default.target && this.props.shapeModel.uuid == _AnimationManager2.default.target.uuid) // non editable in animation mode
	            return false;
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) return true;else return false;
	    },
	
	
	    /************ text area *************/
	    onChangeText: function onChangeText(e) {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        if (e.nativeEvent && e.nativeEvent.inputType === 'insertFromPaste') {
	            var txt = this.refs.shapeTextArea.innerText;
	            this.refs.shapeTextArea.innerHTML = '<span style="font-family: Cabin; font-size: 24px; white-space: pre-wrap">' + txt + '</span>';
	        } else _TextEditorUtils2.default.checkForSizeAttribute(this.refs.shapeTextArea);
	
	        // console.log('aaaa ' + document.getElementById('text_area_' + this.props.shapeModel.uuid).innerHTML);
	
	        _TextEditorUtils2.default.resetActions();
	        _TextEditorUtils2.default.updateShapeSize(this.props.shapeModel, this.props.dispatch);
	    },
	    onTextAreaClick: function onTextAreaClick() {
	        var selection = window.getSelection();
	
	        if (selection.anchorOffset == selection.extentOffset && _TextEditorUtils2.default.lastCursorPosition >= 0 && selection.anchorOffset == _TextEditorUtils2.default.lastCursorPosition) {// no text selected and only the cursor pointer
	            // if a text size was changed while no text selection and you will click on the same cursor position, then we should use the selected text size
	        } else {
	            _TextEditorUtils2.default.resetActions();
	        }
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) // if the textEditor is opened then should refresh it at every click to can updated properly the right buttons
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	            }.bind(this), 5);else this.checkTextEditorTool();
	    },
	    checkTextEditorTool: function checkTextEditorTool() {
	        // check to see if TEXT EDITOR tool can be opened
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT || _StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) return;
	
	        if (!this.props.shapeModel.isSelected) return;
	
	        this.setFocusToInteractiveElement(); // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
	
	        if (_TextEditorUtils2.default.isClick && _TextEditorUtils2.default.isShapeAlreadySelected) _TextEditorUtils2.default.openTextEditorTool(this.props.shapeModel);
	    },
	    onFocusTextArea: function onFocusTextArea() {
	        this.onFocusHandler();
	    },
	    handleKeyDown: function handleKeyDown(e) {
	        // when a key is down on text area
	        if (e.keyCode === 27 && this.refs.shapeTextArea === document.activeElement) {
	            // ESCAPE when the focus is on text ... close TEXT EDITOR mode ... next TAB should go to the hamburger menu
	            _TextEditorUtils2.default.closeTextEditor();
	            return;
	        }
	
	        if (e.keyCode === 9) {
	            // when TAB is down, then the focus will go to the CLOSE button on the TEXT EDITOR tool.
	            var closeButtonOnTextEditorTool = document.getElementById('firstFocusableObjectForTextEditorTool');
	
	            if (closeButtonOnTextEditorTool) {
	                setTimeout(function () {
	                    closeButtonOnTextEditorTool.focus();
	                }.bind(this), 2);
	            }
	
	            return;
	        }
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) {
	            // The user might move the insertion point with the arrow keys, so this will update the selected text types (only) on arrow key presses.
	            var arrowKeys = [37, 38, 39, 40];
	
	            if (arrowKeys.includes(e.keyCode)) // if is textTool is opened and move arrow keys then update the right buttons
	                setTimeout(function () {
	                    _TextEditorUtils2.default.resetActions();
	                    this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	                }.bind(this), 10);
	        }
	    },
	
	
	    /*************** interactive element ***************/
	    onKeyDown: function onKeyDown(e) {
	        // when key down on the interactive element
	        if (e.ctrlKey == true || e.altKey == true) // when commands keys don't open TEXT EDITOR
	            return;
	
	        var arrowKeys = [9, 27, 8, 46, 37, 38, 39, 40, 16]; // TAB, ESCAPE, BACKSPACE ,DELETE and arrow keys, SHIFT
	
	        if (arrowKeys.includes(e.keyCode)) {
	            // some keys are used for removing shape, moving shape or to change the tab
	            _TextEditorUtils2.default.resetActions();
	            return;
	        }
	
	        if (document.activeElement.id.indexOf('interactiveElement') != -1) // if interactive element is selected
	            _TextEditorUtils2.default.openTextEditorTool(this.props.shapeModel, { key: e.key, keyCode: e.keyCode });
	    },
	    onFocusHandler: function onFocusHandler() {
	        // on focus interactive element
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) {
	                _TextEditorUtils2.default.closeTextEditor();
	                this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	            }
	        }
	
	        _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        this.checkTextLabel();
	    },
	    checkTextLabel: function checkTextLabel() {
	        setTimeout(function () {
	            var textLabelElement = document.getElementById('textBoxLabel');
	
	            if (textLabelElement) textLabelElement.style.display = 'block';
	        }.bind(this), 3);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        this.checkIfIsNewShape();
	
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	        var x = shapeModel.x;
	        var y = shapeModel.y;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var textProperties = _TextEditorUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	
	        var textAreaStyle = {
	            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
	            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
	            resize: 'none',
	            overflow: 'hidden',
	            padding: INNER_PADDING,
	            border: 'none',
	            outline: 'none',
	            background: 'transparent',
	            wordSpacing: textProperties.wordSpacing,
	            letterSpacing: textProperties.letterSpacing,
	            overflowWrap: 'break-word',
	            cursor: 'text'
	        };
	
	        if (shapeModel.lineHeight > 0) textAreaStyle.lineHeight = shapeModel.lineHeight;else {
	            if (textProperties.lineHeight != -1) textAreaStyle.lineHeight = textProperties.lineHeight;
	        }
	
	        var path = '';
	
	        if (!shapeModel.path) {
	            path = _ScreamBubbleUtils2.default.getPath(shapeModel);
	            shapeModel.path = path;
	        } else {
	            path = shapeModel.path;
	        }
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var arabic = /[\u0600-\u06FF]/;
	
	        if (arabic.test(shapeModel.htmlText)) textAreaStyle.direction = 'rtl';
	
	        var isContentEditable = this.isContentEditable();
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var ariaLabelValue = _LocalesManager2.default.getCaption('tekst', 'other') + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var tabIndexValue;
	
	        if (!isContentEditable) textAreaStyle.cursor = 'default';
	
	        if (!this.isShapeSelected()) tabIndexValue = -1;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, isBubble: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + x + ' ' + y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement('path', {
	                    d: path,
	                    filter: shapeModel.filter,
	                    opacity: shapeModel.opacity,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none' }),
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: PADDING, y: PADDING, width: shapeModel.width - 2 * PADDING, height: shapeModel.height - 2 * PADDING },
	                    !shapeModel.isGrouped ? _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, ref: 'focusableElement', href: '', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown }) : null,
	                    _react2.default.createElement('div', { id: textAreaId, tabIndex: tabIndexValue, ref: 'shapeTextArea', className: 'textShapes', role: 'textbox', 'aria-label': ariaLabelValue, 'aria-multiline': 'true', style: textAreaStyle, contentEditable: isContentEditable, suppressContentEditableWarning: true, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onTouchEnd: this.onTextAreaClick, onMouseUp: this.onTextAreaClick, onKeyDown: this.handleKeyDown, onInput: this.onChangeText, onFocus: this.onFocusTextArea })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/ScreamBubbleRich.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/ScreamBubbleRich.js"); } } })();

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SpeakBubble = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _SpeakBubbleUtils = __webpack_require__(139);
	
	var _SpeakBubbleUtils2 = _interopRequireDefault(_SpeakBubbleUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _TouchUtils = __webpack_require__(109);
	
	var _TouchUtils2 = _interopRequireDefault(_TouchUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SpeakBubble = exports.SpeakBubble = _react2.default.createClass({
	    displayName: 'SpeakBubble',
	
	    propTypes: {
	        shapeModel: _react2.default.PropTypes.object
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isTextHeightUpdated: false
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_PreviewCommands2.default.isPlayMode() == true) return;
	
	        if (!nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected && !_PlatformDetection2.default.isIOS()) // shape becomes unselected
	            this.clearTextSelection();
	
	        if (!_PlatformDetection2.default.isTouchableDevice()) return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) return;
	
	            if (shapeModel.isNew) {
	                this.changeFocus(true);
	                return;
	            }
	        }
	
	        if (shapeModel.moveState != nextProps.shapeModel.moveState || shapeModel.isNew != nextProps.shapeModel.isNew) {
	            if (nextProps.shapeModel.isSelected == true && (nextProps.shapeModel.moveState == false || nextProps.shapeModel.moveState == undefined)) {
	                if (_PlatformDetection2.default.isIOS() && _TouchUtils2.default.isLongInteraction() == true) return;
	
	                this.changeFocus(true);
	            }
	        }
	
	        if (!nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) // shape becomes unselected
	            this.changeFocus(false);
	    },
	    clearTextSelection: function clearTextSelection() {
	        if (this.refs.shapeTextArea) this.refs.shapeTextArea.selectionStart = this.refs.shapeTextArea.selectionEnd;
	    },
	    changeFocus: function changeFocus(isFocus) {
	        if (_PlatformDetection2.default.isIOS()) {
	            if (isFocus && !_AnimationManager2.default.isAnimationMode()) this.props.dispatch((0, _MenuActions.showTextEditor)(this.props.shapeModel));
	
	            return;
	        }
	
	        var view = this.refs.shapeTextArea;
	
	        if (view) {
	            if (isFocus == true) this.addFocus();else view.blur();
	        }
	    },
	    addFocus: function addFocus() {
	        var view = this.refs.shapeTextArea;
	
	        if (view) view.focus();
	    },
	    onChangeText: function onChangeText(e) {
	        if (_PreviewCommands2.default.isPlayMode() || _PlatformDetection2.default.isIOS()) return;
	
	        var newValue = e.target.value;
	
	        if (newValue == undefined) return;
	
	        this.props.dispatch((0, _CurrentSlideActions.changeTextProperties)(this.props.shapeModel, 'htmlText', newValue));
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        var isTextAdded = false;
	
	        if (newValue.length > this.props.shapeModel.htmlText.length && newValue.length > 10) isTextAdded = true;
	
	        setTimeout(this.checkSize, 50, isTextAdded);
	    },
	    checkIfIsNewShape: function checkIfIsNewShape() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (shapeModel.isNew == true) setTimeout(this.setTextAreaFocus, 10);
	    },
	    setTextAreaFocus: function setTextAreaFocus() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	        dispatch((0, _CurrentSlideActions.changeIsNewShape)(shapeModel.uuid, false));
	
	        if (!_PlatformDetection2.default.isIOS()) this.addFocus();
	    },
	    checkTextHeight: function checkTextHeight() {
	        var shapeModel = this.props.shapeModel;
	
	
	        if (!this.state.isTextHeightUpdated && !shapeModel.useLineHeightTextProperty) {
	            setTimeout(this.updateTextSize, 20);
	        }
	    },
	    updateTextSize: function updateTextSize() {
	        this.setState({
	            isTextHeightUpdated: true
	        });
	
	        this.checkSize();
	    },
	    checkSize: function checkSize() {
	        var isTextAdded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	        _TextSizeUtils2.default.updateTextWrapperSize(shapeModel, dispatch, isTextAdded);
	    },
	    onTextAreaClick: function onTextAreaClick() {
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT) return;
	
	        _CreateShapes2.default.checkFontMenu(this.props.dispatch, this.props.shapeModel);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	        if (currentSlide && currentSlide.model && currentSlide.model.content) {
	            var shapes = currentSlide.model.content;
	            var i;
	
	            for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                    if (shapes[i].isSelected == true) return true;else return false;
	                }
	            }return false;
	        }
	
	        return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	
	            this.checkTextLabel(false);
	        } else this.checkTextLabel(true);
	    },
	    checkTextLabel: function checkTextLabel() {
	        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        setTimeout(function () {
	            var textLabelElement = document.getElementById('textBoxLabel');
	
	            if (textLabelElement) {
	                if (show) textLabelElement.style.display = 'block';else textLabelElement.style.display = 'none';
	            }
	        }.bind(this), 10);
	    },
	    onFocusTextArea: function onFocusTextArea() {
	        if (document.activeElement == this.refs.shapeTextArea) this.checkTextLabel(true);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        this.checkIfIsNewShape();
	        this.checkTextHeight();
	
	        var _props3 = this.props,
	            shapeModel = _props3.shapeModel,
	            dispatch = _props3.dispatch;
	
	
	        var x = shapeModel.x;
	        var y = shapeModel.y;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var bold = shapeModel.fontBold ? 'bold' : 'normal';
	        var italic = shapeModel.fontItalic ? 'italic' : 'normal';
	        var textProperties = _TextSizeUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	
	        var textAreaStyle = {
	            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
	            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
	            resize: 'none',
	            overflow: 'hidden',
	            padding: INNER_PADDING,
	            border: 'none',
	            outline: 'none',
	            background: 'transparent',
	            fontFamily: shapeModel.fontFamily,
	            fontSize: shapeModel.fontSize,
	            fontStyle: italic,
	            fontWeight: bold,
	            color: shapeModel.fontColor,
	            textAlign: shapeModel.fontAlign,
	            wordSpacing: textProperties.wordSpacing,
	            letterSpacing: textProperties.letterSpacing,
	            textIdent: textProperties.textIdent
	        };
	
	        if (textProperties.lineHeight != -1) textAreaStyle.lineHeight = textProperties.lineHeight;
	
	        if (shapeModel.fontUnderline) textAreaStyle.textDecoration = 'underline';
	
	        var path = '';
	
	        if (!(shapeModel.cx > shapeModel.x && shapeModel.cx < shapeModel.x + shapeModel.width && shapeModel.cy > shapeModel.y && shapeModel.cy < shapeModel.y + shapeModel.height)) {
	            path = _SpeakBubbleUtils2.default.getPath(shapeModel);
	            shapeModel.path = path;
	        }
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var readOnlyValue = false;
	        var clone = _AnimationManager2.default.getCloneByUid(shapeModel.uuid);
	
	        if (!clone) clone = _AnimationManager2.default.clone;
	
	        if (_PlatformDetection2.default.isIOS() || clone && shapeModel.uuid == clone.uuid || _AnimationManager2.default.target && shapeModel.uuid == _AnimationManager2.default.target.uuid || _AppParameters2.default.isCartoonistPlayer()) {
	            readOnlyValue = true;
	            textAreaStyle.cursor = 'default';
	        }
	
	        var arabic = /[\u0600-\u06FF]/;
	
	        if (arabic.test(shapeModel.htmlText)) textAreaStyle.direction = 'rtl';
	
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var ariaLabelValue = _LocalesManager2.default.getCaption('tekst', 'other') + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var tabIndexValue;
	
	        if (!this.isShapeSelected()) tabIndexValue = -1;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, isBubble: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + x + ' ' + y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement('rect', { x: 0,
	                    y: 0,
	                    width: shapeModel.width,
	                    height: shapeModel.height,
	                    rx: 15,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity }),
	                _react2.default.createElement('path', {
	                    d: path,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none'
	                }),
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: PADDING, y: PADDING, width: shapeModel.width - 2 * PADDING, height: shapeModel.height - 2 * PADDING },
	                    !shapeModel.isGrouped ? _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown }) : null,
	                    _react2.default.createElement('textarea', { tabIndex: tabIndexValue, id: textAreaId, role: 'textbox', onFocus: this.onFocusTextArea, 'aria-label': ariaLabelValue, 'aria-multiline': 'true', className: 'textShapes', ref: 'shapeTextArea', style: textAreaStyle, value: shapeModel.htmlText, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onTouchEnd: this.onTextAreaClick, onMouseUp: this.onTextAreaClick, onChange: this.onChangeText, readOnly: readOnlyValue })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/SpeakBubble.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/SpeakBubble.js"); } } })();

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SpeakBubbleRich = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SpeakBubbleUtils = __webpack_require__(139);
	
	var _SpeakBubbleUtils2 = _interopRequireDefault(_SpeakBubbleUtils);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SpeakBubbleRich = exports.SpeakBubbleRich = _react2.default.createClass({
	    displayName: 'SpeakBubbleRich',
	    componentDidMount: function componentDidMount() {
	        if (this.refs.shapeTextArea && this.props.shapeModel.htmlText) this.refs.shapeTextArea.innerHTML = _TextEditorUtils2.default.getHtmlText(this.props.shapeModel);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_TextEditorUtils2.default.isTextEditorTool()) return;
	
	        if (this.props.shapeModel.htmlText != nextProps.shapeModel.htmlText && this.refs.shapeTextArea) this.refs.shapeTextArea.innerHTML = _TextEditorUtils2.default.getHtmlText(nextProps.shapeModel);
	
	        // when a new shape is added to canvas, force focus to interactive element
	        if (this.props.shapeModel.isNew != nextProps.shapeModel.isNew) this.setFocusToInteractiveElement();
	
	        // when an element becomes selected (state 2) using multiple selection, the focus should be on interactiveElement to can have a keyDown event in case we type something to enter in Text Editor (state 3) because textArea is disabled at that time
	        if (nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected) this.setFocusToInteractiveElement();
	    },
	    setFocusToInteractiveElement: function setFocusToInteractiveElement() {
	        setTimeout(function () {
	            if (this.refs.focusableElement) // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
	                this.refs.focusableElement.focus();
	        }.bind(this), 2);
	    },
	    checkIfIsNewShape: function checkIfIsNewShape() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        if (shapeModel.isNew == true) setTimeout(function () {
	            dispatch((0, _CurrentSlideActions.changeIsNewShape)(shapeModel.uuid, false));
	        }.bind(this), 2);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	        if (currentSlide && currentSlide.model && currentSlide.model.content) {
	            var shapes = currentSlide.model.content;
	            var i;
	
	            for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                    if (shapes[i].isSelected == true) return true;else return false;
	                }
	            }return false;
	        }
	
	        return false;
	    },
	    isContentEditable: function isContentEditable() {
	        if (_AppParameters2.default.isCartoonistPlayer()) return false;
	
	        var clone = _AnimationManager2.default.getCloneByUid(this.props.shapeModel.uuid);
	
	        if (!clone) clone = _AnimationManager2.default.clone;
	
	        if (clone && this.props.shapeModel.uuid == clone.uuid || _AnimationManager2.default.target && this.props.shapeModel.uuid == _AnimationManager2.default.target.uuid) // non editable in animation mode
	            return false;
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) return true;else return false;
	    },
	
	
	    /************ text area *************/
	    onChangeText: function onChangeText(e) {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        if (e.nativeEvent && e.nativeEvent.inputType === 'insertFromPaste') {
	            var txt = this.refs.shapeTextArea.innerText;
	            this.refs.shapeTextArea.innerHTML = '<span style="font-family: Cabin; font-size: 24px; white-space: pre-wrap">' + txt + '</span>';
	        } else _TextEditorUtils2.default.checkForSizeAttribute(this.refs.shapeTextArea);
	
	        // console.log('aaaa ' + document.getElementById('text_area_' + this.props.shapeModel.uuid).innerHTML);
	
	        _TextEditorUtils2.default.resetActions();
	        _TextEditorUtils2.default.updateShapeSize(this.props.shapeModel, this.props.dispatch);
	    },
	    onTextAreaClick: function onTextAreaClick() {
	        var selection = window.getSelection();
	
	        if (selection.anchorOffset == selection.extentOffset && _TextEditorUtils2.default.lastCursorPosition >= 0 && selection.anchorOffset == _TextEditorUtils2.default.lastCursorPosition) {// no text selected and only the cursor pointer
	            // if a text size was changed while no text selection and you will click on the same cursor position, then we should use the selected text size
	        } else {
	            _TextEditorUtils2.default.resetActions();
	        }
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) // if the textEditor is opened then should refresh it at every click to can updated properly the right buttons
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	            }.bind(this), 5);else this.checkTextEditorTool();
	    },
	    checkTextEditorTool: function checkTextEditorTool() {
	        // check to see if TEXT EDITOR tool can be opened
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT || _StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) return;
	
	        if (!this.props.shapeModel.isSelected) return;
	
	        this.setFocusToInteractiveElement(); // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
	
	        if (_TextEditorUtils2.default.isClick && _TextEditorUtils2.default.isShapeAlreadySelected) _TextEditorUtils2.default.openTextEditorTool(this.props.shapeModel);
	    },
	    onFocusTextArea: function onFocusTextArea() {
	        this.onFocusHandler();
	    },
	    handleKeyDown: function handleKeyDown(e) {
	        // when a key is down on text area
	        if (e.keyCode === 27 && this.refs.shapeTextArea === document.activeElement) {
	            // ESCAPE when the focus is on text ... close TEXT EDITOR mode ... next TAB should go to the hamburger menu
	            _TextEditorUtils2.default.closeTextEditor();
	            return;
	        }
	
	        if (e.keyCode === 9) {
	            // when TAB is down, then the focus will go to the CLOSE button on the TEXT EDITOR tool.
	            var closeButtonOnTextEditorTool = document.getElementById('firstFocusableObjectForTextEditorTool');
	
	            if (closeButtonOnTextEditorTool) {
	                setTimeout(function () {
	                    closeButtonOnTextEditorTool.focus();
	                }.bind(this), 2);
	            }
	
	            return;
	        }
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) {
	            // The user might move the insertion point with the arrow keys, so this will update the selected text types (only) on arrow key presses.
	            var arrowKeys = [37, 38, 39, 40];
	
	            if (arrowKeys.includes(e.keyCode)) // if is textTool is opened and move arrow keys then update the right buttons
	                setTimeout(function () {
	                    _TextEditorUtils2.default.resetActions();
	                    this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	                }.bind(this), 10);
	        }
	    },
	
	
	    /*************** interactive element ***************/
	    onKeyDown: function onKeyDown(e) {
	        // when key down on the interactive element
	        if (e.ctrlKey == true || e.altKey == true) // when commands keys don't open TEXT EDITOR
	            return;
	
	        var arrowKeys = [9, 27, 8, 46, 37, 38, 39, 40, 16]; // TAB, ESCAPE, BACKSPACE ,DELETE and arrow keys, SHIFT
	
	        if (arrowKeys.includes(e.keyCode)) {
	            // some keys are used for removing shape, moving shape or to change the tab
	            _TextEditorUtils2.default.resetActions();
	            return;
	        }
	
	        if (document.activeElement.id.indexOf('interactiveElement') != -1) // if interactive element is selected
	            _TextEditorUtils2.default.openTextEditorTool(this.props.shapeModel, { key: e.key, keyCode: e.keyCode });
	    },
	    onFocusHandler: function onFocusHandler() {
	        // on focus interactive element
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) {
	                _TextEditorUtils2.default.closeTextEditor();
	                this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	            }
	        }
	
	        _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        this.checkTextLabel();
	    },
	    checkTextLabel: function checkTextLabel() {
	        setTimeout(function () {
	            var textLabelElement = document.getElementById('textBoxLabel');
	
	            if (textLabelElement) textLabelElement.style.display = 'block';
	        }.bind(this), 3);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        this.checkIfIsNewShape();
	
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	        var x = shapeModel.x;
	        var y = shapeModel.y;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var textProperties = _TextEditorUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	
	        var textAreaStyle = {
	            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
	            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
	            resize: 'none',
	            overflow: 'hidden',
	            padding: INNER_PADDING,
	            border: 'none',
	            outline: 'none',
	            background: 'transparent',
	            wordSpacing: textProperties.wordSpacing,
	            letterSpacing: textProperties.letterSpacing,
	            overflowWrap: 'break-word',
	            cursor: 'text'
	        };
	
	        if (shapeModel.lineHeight > 0) textAreaStyle.lineHeight = shapeModel.lineHeight;else {
	            if (textProperties.lineHeight != -1) textAreaStyle.lineHeight = textProperties.lineHeight;
	        }
	
	        var path = '';
	
	        if (!(shapeModel.cx > shapeModel.x && shapeModel.cx < shapeModel.x + shapeModel.width && shapeModel.cy > shapeModel.y && shapeModel.cy < shapeModel.y + shapeModel.height)) {
	            path = _SpeakBubbleUtils2.default.getPath(shapeModel);
	            shapeModel.path = path;
	        }
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var arabic = /[\u0600-\u06FF]/;
	
	        if (arabic.test(shapeModel.htmlText)) textAreaStyle.direction = 'rtl';
	
	        var isContentEditable = this.isContentEditable();
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var ariaLabelValue = _LocalesManager2.default.getCaption('tekst', 'other') + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var tabIndexValue;
	
	        if (!isContentEditable) textAreaStyle.cursor = 'default';
	
	        if (!this.isShapeSelected()) tabIndexValue = -1;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, isBubble: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + x + ' ' + y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement('rect', { x: 0,
	                    y: 0,
	                    width: shapeModel.width,
	                    height: shapeModel.height,
	                    rx: 15,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity }),
	                _react2.default.createElement('path', {
	                    d: path,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none'
	                }),
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: PADDING, y: PADDING, width: shapeModel.width - 2 * PADDING, height: shapeModel.height - 2 * PADDING },
	                    !shapeModel.isGrouped ? _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, ref: 'focusableElement', href: '', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown }) : null,
	                    _react2.default.createElement('div', { id: textAreaId, tabIndex: tabIndexValue, ref: 'shapeTextArea', className: 'textShapes', role: 'textbox', 'aria-label': ariaLabelValue, 'aria-multiline': 'true', style: textAreaStyle, contentEditable: isContentEditable, suppressContentEditableWarning: true, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onTouchEnd: this.onTextAreaClick, onMouseUp: this.onTextAreaClick, onKeyDown: this.handleKeyDown, onInput: this.onChangeText, onFocus: this.onFocusTextArea })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/SpeakBubbleRich.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/SpeakBubbleRich.js"); } } })();

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Star = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DrawingUtils = __webpack_require__(108);
	
	var _DrawingUtils2 = _interopRequireDefault(_DrawingUtils);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Star = exports.Star = _react2.default.createClass({
	    displayName: 'Star',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        shapeModel: _react2.default.PropTypes.object.isRequired
	    },
	    isShapeSelected: function isShapeSelected() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                if (shapes[i].isSelected == true) return true;else return false;
	            }
	        }return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var clipPathObject;
	        var realWidth = shapeModel.width;
	        var realHeight = shapeModel.height;
	        var newShapeModel = shapeModel;
	        var x1 = 0;
	        var y1 = 0;
	        var clipId = 'hotSpot_' + shapeModel.uuid;
	        var clipPath = 'url(#' + clipId + ')';
	        var originalModel = shapeModel;
	
	        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
	            realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
	            realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);
	
	            x1 = realWidth * shapeModel.hotSpot.x1 / 100;
	            y1 = realHeight * shapeModel.hotSpot.y1 / 100;
	            var x2 = realWidth * shapeModel.hotSpot.x2 / 100;
	            var y2 = realHeight * shapeModel.hotSpot.y2 / 100;
	
	            originalModel = Object.assign({}, shapeModel);
	            originalModel.width = realWidth;
	            originalModel.height = realHeight;
	            originalModel.x = shapeModel.x - x1;
	            originalModel.y = shapeModel.y - y1;
	
	            if (_ZoomUtils2.default.isCroppingMode() && _ZoomUtils2.default.croppingTarget.uuid == shapeModel.uuid) {
	                newShapeModel = Object.assign({}, shapeModel);
	                newShapeModel.width = realWidth;
	                newShapeModel.height = realHeight;
	                newShapeModel.x = shapeModel.x - x1;
	                newShapeModel.y = shapeModel.y - y1;
	
	                x1 = 0;
	                y1 = 0;
	            } else {
	                clipPathObject = _react2.default.createElement(
	                    'clipPath',
	                    { id: clipId },
	                    _react2.default.createElement('rect', { x: x1, y: y1, width: x2 - x1, height: y2 - y1 })
	                );
	            }
	        }
	
	        var points = _DrawingUtils2.default.calculateStarPoints(originalModel);
	        var path = 'M' + points[0].x + ' ' + points[0].y + ' ';
	
	        var i;
	        for (i = 1; i < points.length; i++) {
	            path = path + 'L' + points[i].x + ' ' + points[i].y + ' ';
	        }
	
	        path = path + ' Z';
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: newShapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                null,
	                clipPathObject,
	                _react2.default.createElement(
	                    'g',
	                    { opacity: newShapeModel.opacity, transform: 'translate(' + -x1 + ' ' + -y1 + ')' },
	                    _react2.default.createElement('path', {
	                        d: path,
	                        filter: newShapeModel.filter,
	                        opacity: newShapeModel.opacity,
	                        fill: newShapeModel.fill,
	                        fillOpacity: backgroundOpacity,
	                        stroke: newShapeModel.stroke,
	                        strokeWidth: newShapeModel.strokeWidth,
	                        strokeOpacity: newShapeModel.strokeOpacity,
	                        preserveAspectRatio: 'none',
	                        clipPath: clipPath
	                    })
	                ),
	                !shapeModel.isGrouped ? _react2.default.createElement(
	                    'foreignObject',
	                    null,
	                    _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                ) : null
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Star.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Star.js"); } } })();

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TextBox = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _TouchUtils = __webpack_require__(109);
	
	var _TouchUtils2 = _interopRequireDefault(_TouchUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextBox = exports.TextBox = _react2.default.createClass({
	    displayName: 'TextBox',
	
	    propTypes: {
	        shapeModel: _react2.default.PropTypes.object
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isTextHeightUpdated: false
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_PreviewCommands2.default.isPlayMode() == true) return;
	
	        if (!nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected && !_PlatformDetection2.default.isIOS()) // shape becomes unselected
	            this.clearTextSelection();
	
	        if (!_PlatformDetection2.default.isTouchableDevice()) return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) return;
	
	            if (shapeModel.isNew) {
	                this.changeFocus(true);
	                return;
	            }
	        }
	
	        if (shapeModel.moveState != nextProps.shapeModel.moveState || shapeModel.isNew != nextProps.shapeModel.isNew) {
	            if (nextProps.shapeModel.isSelected == true && (nextProps.shapeModel.moveState == false || nextProps.shapeModel.moveState == undefined)) {
	                if (_PlatformDetection2.default.isIOS() && _TouchUtils2.default.isLongInteraction() == true) return;
	
	                this.changeFocus(true);
	            }
	        }
	
	        if (!nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) // shape becomes unselected
	            this.changeFocus(false);
	    },
	    clearTextSelection: function clearTextSelection() {
	        if (this.refs.shapeTextArea) this.refs.shapeTextArea.selectionStart = this.refs.shapeTextArea.selectionEnd;
	    },
	    changeFocus: function changeFocus(isFocus) {
	        if (_PlatformDetection2.default.isIOS()) {
	            if (isFocus && !_AnimationManager2.default.isAnimationMode()) this.props.dispatch((0, _MenuActions.showTextEditor)(this.props.shapeModel));
	
	            return;
	        }
	
	        var view = this.refs.shapeTextArea;
	
	        if (view) {
	            if (isFocus == true) this.addFocus();else view.blur();
	        }
	    },
	    addFocus: function addFocus() {
	        var view = this.refs.shapeTextArea;
	
	        if (view) view.focus();
	    },
	    onChangeText: function onChangeText(e) {
	        if (_PreviewCommands2.default.isPlayMode() || _PlatformDetection2.default.isIOS()) return;
	
	        var newValue = e.target.value;
	
	        if (newValue == undefined) return;
	
	        this.props.dispatch((0, _CurrentSlideActions.changeTextProperties)(this.props.shapeModel, 'htmlText', newValue));
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        var isTextAdded = false;
	
	        if (newValue.length > this.props.shapeModel.htmlText.length && newValue.length > 10) isTextAdded = true;
	
	        setTimeout(this.checkSize, 50, isTextAdded);
	    },
	    checkIfIsNewShape: function checkIfIsNewShape() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (shapeModel.isNew == true) setTimeout(this.setTextAreaFocus, 10);
	    },
	    setTextAreaFocus: function setTextAreaFocus() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	        dispatch((0, _CurrentSlideActions.changeIsNewShape)(shapeModel.uuid, false));
	
	        if (!_PlatformDetection2.default.isIOS()) this.addFocus();
	    },
	    checkTextHeight: function checkTextHeight() {
	        var shapeModel = this.props.shapeModel;
	
	
	        if (!this.state.isTextHeightUpdated && !shapeModel.useLineHeightTextProperty) {
	            setTimeout(this.updateTextSize, 20);
	        }
	    },
	    updateTextSize: function updateTextSize() {
	        this.setState({
	            isTextHeightUpdated: true
	        });
	
	        this.checkSize();
	    },
	    checkSize: function checkSize() {
	        var isTextAdded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	        _TextSizeUtils2.default.updateTextWrapperSize(shapeModel, dispatch, isTextAdded);
	    },
	    onTextAreaClick: function onTextAreaClick() {
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT) return;
	
	        _CreateShapes2.default.checkFontMenu(this.props.dispatch, this.props.shapeModel);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	        if (currentSlide && currentSlide.model && currentSlide.model.content) {
	            var shapes = currentSlide.model.content;
	            var i;
	
	            for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                    if (shapes[i].isSelected == true) return true;else return false;
	                }
	            }return false;
	        }
	
	        return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	
	            this.checkTextLabel(false);
	        } else this.checkTextLabel(true);
	    },
	    checkTextLabel: function checkTextLabel() {
	        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        setTimeout(function () {
	            var textLabelElement = document.getElementById('textBoxLabel');
	
	            if (textLabelElement) {
	                if (show) textLabelElement.style.display = 'block';else textLabelElement.style.display = 'none';
	            }
	        }.bind(this), 10);
	    },
	    onFocusTextArea: function onFocusTextArea() {
	        if (document.activeElement == this.refs.shapeTextArea) this.checkTextLabel(true);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        this.checkIfIsNewShape();
	        this.checkTextHeight();
	
	        var _props3 = this.props,
	            shapeModel = _props3.shapeModel,
	            dispatch = _props3.dispatch;
	
	
	        var x = shapeModel.x;
	        var y = shapeModel.y;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var bold = shapeModel.fontBold ? 'bold' : 'normal';
	        var italic = shapeModel.fontItalic ? 'italic' : 'normal';
	        var textProperties = _TextSizeUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	
	        var textAreaStyle = {
	            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
	            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
	            resize: 'none',
	            overflow: 'hidden',
	            padding: INNER_PADDING,
	            border: 'none',
	            outline: 'none',
	            background: 'transparent',
	            fontFamily: shapeModel.fontFamily,
	            fontSize: shapeModel.fontSize,
	            fontStyle: italic,
	            fontWeight: bold,
	            color: shapeModel.fontColor,
	            textAlign: shapeModel.fontAlign,
	            wordSpacing: textProperties.wordSpacing,
	            letterSpacing: textProperties.letterSpacing,
	            textIdent: textProperties.textIdent
	        };
	
	        if (textProperties.lineHeight != -1) textAreaStyle.lineHeight = textProperties.lineHeight;
	
	        if (shapeModel.fontUnderline) textAreaStyle.textDecoration = 'underline';
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var readOnlyValue = false;
	        var clone = _AnimationManager2.default.getCloneByUid(shapeModel.uuid);
	
	        if (!clone) clone = _AnimationManager2.default.clone;
	
	        if (_PlatformDetection2.default.isIOS() || clone && shapeModel.uuid == clone.uuid || _AnimationManager2.default.target && shapeModel.uuid == _AnimationManager2.default.target.uuid || _AppParameters2.default.isCartoonistPlayer()) {
	            readOnlyValue = true;
	            textAreaStyle.cursor = 'default';
	        }
	
	        var arabic = /[\u0600-\u06FF]/;
	
	        if (arabic.test(shapeModel.htmlText)) textAreaStyle.direction = 'rtl';
	
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var ariaLabelValue = _LocalesManager2.default.getCaption('tekst', 'other') + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var tabIndexValue;
	
	        if (!this.isShapeSelected()) tabIndexValue = -1;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + x + ' ' + y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement('rect', { x: 0,
	                    y: 0,
	                    width: shapeModel.width,
	                    height: shapeModel.height,
	                    rx: 15,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity }),
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: PADDING, y: PADDING, width: shapeModel.width - 2 * PADDING, height: shapeModel.height - 2 * PADDING },
	                    !shapeModel.isGrouped ? _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown }) : null,
	                    _react2.default.createElement('textarea', { tabIndex: tabIndexValue, id: textAreaId, role: 'textbox', onFocus: this.onFocusTextArea, 'aria-label': ariaLabelValue, 'aria-multiline': 'true', className: 'textShapes', ref: 'shapeTextArea', style: textAreaStyle, value: shapeModel.htmlText, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onTouchEnd: this.onTextAreaClick, onMouseUp: this.onTextAreaClick, onChange: this.onChangeText, readOnly: readOnlyValue })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/TextBox.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/TextBox.js"); } } })();

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TextBoxRich = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextBoxRich = exports.TextBoxRich = _react2.default.createClass({
	    displayName: 'TextBoxRich',
	    componentDidMount: function componentDidMount() {
	        if (this.refs.shapeTextArea && this.props.shapeModel.htmlText) this.refs.shapeTextArea.innerHTML = _TextEditorUtils2.default.getHtmlText(this.props.shapeModel);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_TextEditorUtils2.default.isTextEditorTool()) return;
	
	        if (this.props.shapeModel.htmlText != nextProps.shapeModel.htmlText && this.refs.shapeTextArea) this.refs.shapeTextArea.innerHTML = _TextEditorUtils2.default.getHtmlText(nextProps.shapeModel);
	
	        // when a new shape is added to canvas, force focus to interactive element
	        if (this.props.shapeModel.isNew != nextProps.shapeModel.isNew) this.setFocusToInteractiveElement();
	
	        // when an element becomes selected (state 2) using multiple selection, the focus should be on interactiveElement to can have a keyDown event in case we type something to enter in Text Editor (state 3) because textArea is disabled at that time
	        if (nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected) this.setFocusToInteractiveElement();
	    },
	    setFocusToInteractiveElement: function setFocusToInteractiveElement() {
	        setTimeout(function () {
	            if (this.refs.focusableElement) // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
	                this.refs.focusableElement.focus();
	        }.bind(this), 2);
	    },
	    checkIfIsNewShape: function checkIfIsNewShape() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        if (shapeModel.isNew == true) setTimeout(function () {
	            dispatch((0, _CurrentSlideActions.changeIsNewShape)(shapeModel.uuid, false));
	        }.bind(this), 2);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	        if (currentSlide && currentSlide.model && currentSlide.model.content) {
	            var shapes = currentSlide.model.content;
	            var i;
	
	            for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                    if (shapes[i].isSelected == true) return true;else return false;
	                }
	            }return false;
	        }
	
	        return false;
	    },
	    isContentEditable: function isContentEditable() {
	        if (_AppParameters2.default.isCartoonistPlayer()) return false;
	
	        var clone = _AnimationManager2.default.getCloneByUid(this.props.shapeModel.uuid);
	
	        if (!clone) clone = _AnimationManager2.default.clone;
	
	        if (clone && this.props.shapeModel.uuid == clone.uuid || _AnimationManager2.default.target && this.props.shapeModel.uuid == _AnimationManager2.default.target.uuid) // non editable in animation mode
	            return false;
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) return true;else return false;
	    },
	
	
	    /************ text area *************/
	    onChangeText: function onChangeText(e) {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        if (e.nativeEvent && e.nativeEvent.inputType === 'insertFromPaste') {
	            var txt = this.refs.shapeTextArea.innerText;
	            this.refs.shapeTextArea.innerHTML = '<span style="font-family: Cabin; font-size: 24px; white-space: pre-wrap">' + txt + '</span>';
	        } else _TextEditorUtils2.default.checkForSizeAttribute(this.refs.shapeTextArea);
	
	        // console.log('aaaa ' + document.getElementById('text_area_' + this.props.shapeModel.uuid).innerHTML);
	
	        _TextEditorUtils2.default.resetActions();
	        _TextEditorUtils2.default.updateShapeSize(this.props.shapeModel, this.props.dispatch);
	    },
	    onTextAreaClick: function onTextAreaClick() {
	        var selection = window.getSelection();
	
	        if (selection.anchorOffset == selection.extentOffset && _TextEditorUtils2.default.lastCursorPosition >= 0 && selection.anchorOffset == _TextEditorUtils2.default.lastCursorPosition) {// no text selected and only the cursor pointer
	            // if a text size was changed while no text selection and you will click on the same cursor position, then we should use the selected text size
	        } else {
	            _TextEditorUtils2.default.resetActions();
	        }
	
	        console.log('aaaa ' + document.getElementById('text_area_' + this.props.shapeModel.uuid).innerHTML);
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) // if the textEditor is opened then should refresh it at every click to can updated properly the right buttons
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	            }.bind(this), 5);else this.checkTextEditorTool();
	    },
	    checkTextEditorTool: function checkTextEditorTool() {
	        // check to see if TEXT EDITOR tool can be opened
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT || _StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) return;
	
	        if (!this.props.shapeModel.isSelected) return;
	
	        this.setFocusToInteractiveElement(); // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
	
	        if (_TextEditorUtils2.default.isClick && _TextEditorUtils2.default.isShapeAlreadySelected) _TextEditorUtils2.default.openTextEditorTool(this.props.shapeModel);
	    },
	    onFocusTextArea: function onFocusTextArea() {
	        this.onFocusHandler();
	    },
	    handleKeyDown: function handleKeyDown(e) {
	        // when a key is down on text area
	        if (e.keyCode === 27 && this.refs.shapeTextArea === document.activeElement) {
	            // ESCAPE when the focus is on text ... close TEXT EDITOR mode ... next TAB should go to the hamburger menu
	            _TextEditorUtils2.default.closeTextEditor();
	            return;
	        }
	
	        if (e.keyCode === 9) {
	            // when TAB is down, then the focus will go to the CLOSE button on the TEXT EDITOR tool.
	            var closeButtonOnTextEditorTool = document.getElementById('firstFocusableObjectForTextEditorTool');
	
	            if (closeButtonOnTextEditorTool) {
	                setTimeout(function () {
	                    closeButtonOnTextEditorTool.focus();
	                }.bind(this), 2);
	            }
	
	            return;
	        }
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) {
	            // The user might move the insertion point with the arrow keys, so this will update the selected text types (only) on arrow key presses.
	            var arrowKeys = [37, 38, 39, 40];
	
	            if (arrowKeys.includes(e.keyCode)) // if is textTool is opened and move arrow keys then update the right buttons
	                setTimeout(function () {
	                    _TextEditorUtils2.default.resetActions();
	                    this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	                }.bind(this), 10);
	        }
	    },
	
	
	    /*************** interactive element ***************/
	    onKeyDown: function onKeyDown(e) {
	        // when key down on the interactive element
	        if (e.ctrlKey == true || e.altKey == true) // when commands keys don't open TEXT EDITOR
	            return;
	
	        var arrowKeys = [9, 27, 8, 46, 37, 38, 39, 40, 16]; // TAB, ESCAPE, BACKSPACE ,DELETE and arrow keys, SHIFT
	
	        if (arrowKeys.includes(e.keyCode)) {
	            // some keys are used for removing shape, moving shape or to change the tab
	            _TextEditorUtils2.default.resetActions();
	            return;
	        }
	
	        if (document.activeElement.id.indexOf('interactiveElement') != -1) // if interactive element is selected
	            _TextEditorUtils2.default.openTextEditorTool(this.props.shapeModel, { key: e.key, keyCode: e.keyCode });
	    },
	    onFocusHandler: function onFocusHandler() {
	        // on focus interactive element
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) {
	                _TextEditorUtils2.default.closeTextEditor();
	                this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	            }
	        }
	
	        _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        this.checkTextLabel();
	    },
	    checkTextLabel: function checkTextLabel() {
	        setTimeout(function () {
	            var textLabelElement = document.getElementById('textBoxLabel');
	
	            if (textLabelElement) textLabelElement.style.display = 'block';
	        }.bind(this), 3);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        this.checkIfIsNewShape();
	
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	        var x = shapeModel.x;
	        var y = shapeModel.y;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var textProperties = _TextEditorUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	
	        var textAreaStyle = {
	            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
	            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
	            resize: 'none',
	            overflow: 'hidden',
	            padding: INNER_PADDING,
	            border: 'none',
	            outline: 'none',
	            background: 'transparent',
	            wordSpacing: textProperties.wordSpacing,
	            letterSpacing: textProperties.letterSpacing,
	            overflowWrap: 'break-word',
	            cursor: 'text'
	        };
	
	        if (shapeModel.lineHeight > 0) textAreaStyle.lineHeight = shapeModel.lineHeight;else {
	            if (textProperties.lineHeight != -1) textAreaStyle.lineHeight = textProperties.lineHeight;
	        }
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var arabic = /[\u0600-\u06FF]/;
	
	        if (arabic.test(shapeModel.htmlText)) textAreaStyle.direction = 'rtl';
	
	        var isContentEditable = this.isContentEditable();
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var ariaLabelValue = _LocalesManager2.default.getCaption('tekst', 'other') + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var tabIndexValue;
	
	        if (!isContentEditable) textAreaStyle.cursor = 'default';
	
	        if (!this.isShapeSelected()) tabIndexValue = -1;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + x + ' ' + y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement('rect', { x: 0,
	                    y: 0,
	                    width: shapeModel.width,
	                    height: shapeModel.height,
	                    rx: 15,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity }),
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: PADDING, y: PADDING, width: shapeModel.width - 2 * PADDING, height: shapeModel.height - 2 * PADDING },
	                    !shapeModel.isGrouped ? _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, ref: 'focusableElement', href: '', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown }) : null,
	                    _react2.default.createElement('div', { id: textAreaId, tabIndex: tabIndexValue, ref: 'shapeTextArea', className: 'textShapes', role: 'textbox', 'aria-label': ariaLabelValue, 'aria-multiline': 'true', style: textAreaStyle, contentEditable: isContentEditable, suppressContentEditableWarning: true, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onTouchEnd: this.onTextAreaClick, onMouseUp: this.onTextAreaClick, onKeyDown: this.handleKeyDown, onInput: this.onChangeText, onFocus: this.onFocusTextArea })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/TextBoxRich.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/TextBoxRich.js"); } } })();

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TextBoxSimple = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _TouchUtils = __webpack_require__(109);
	
	var _TouchUtils2 = _interopRequireDefault(_TouchUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextBoxSimple = exports.TextBoxSimple = _react2.default.createClass({
	    displayName: 'TextBoxSimple',
	
	    propTypes: {
	        shapeModel: _react2.default.PropTypes.object
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isTextHeightUpdated: false
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_PreviewCommands2.default.isPlayMode() == true) return;
	
	        if (!nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected && !_PlatformDetection2.default.isIOS()) // shape becomes unselected
	            this.clearTextSelection();
	
	        if (!_PlatformDetection2.default.isTouchableDevice()) return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) return;
	
	            if (shapeModel.isNew) {
	                this.changeFocus(true);
	                return;
	            }
	        }
	
	        if (shapeModel.moveState != nextProps.shapeModel.moveState || shapeModel.isNew != nextProps.shapeModel.isNew) {
	            if (nextProps.shapeModel.isSelected == true && (nextProps.shapeModel.moveState == false || nextProps.shapeModel.moveState == undefined)) {
	                if (_PlatformDetection2.default.isIOS() && _TouchUtils2.default.isLongInteraction() == true) return;
	
	                this.changeFocus(true);
	            }
	        }
	
	        if (!nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) // shape becomes unselected
	            this.changeFocus(false);
	    },
	    clearTextSelection: function clearTextSelection() {
	        if (this.refs.shapeTextArea) this.refs.shapeTextArea.selectionStart = this.refs.shapeTextArea.selectionEnd;
	    },
	    changeFocus: function changeFocus(isFocus) {
	        if (_PlatformDetection2.default.isIOS()) {
	            if (isFocus && !_AnimationManager2.default.isAnimationMode()) this.props.dispatch((0, _MenuActions.showTextEditor)(this.props.shapeModel));
	
	            return;
	        }
	
	        var view = this.refs.shapeTextArea;
	
	        if (view) {
	            if (isFocus == true) this.addFocus();else view.blur();
	        }
	    },
	    addFocus: function addFocus() {
	        var view = this.refs.shapeTextArea;
	
	        if (view) view.focus();
	    },
	    onChangeText: function onChangeText(e) {
	        if (_PreviewCommands2.default.isPlayMode() || _PlatformDetection2.default.isIOS()) return;
	
	        var newValue = e.target.value;
	
	        if (newValue == undefined) return;
	
	        this.props.dispatch((0, _CurrentSlideActions.changeTextProperties)(this.props.shapeModel, 'htmlText', newValue));
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        var isTextAdded = false;
	
	        if (newValue.length > this.props.shapeModel.htmlText.length && newValue.length > 10) isTextAdded = true;
	
	        setTimeout(this.checkSize, 50, isTextAdded);
	    },
	    checkIfIsNewShape: function checkIfIsNewShape() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (shapeModel.isNew == true) setTimeout(this.setTextAreaFocus, 10);
	    },
	    setTextAreaFocus: function setTextAreaFocus() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	        dispatch((0, _CurrentSlideActions.changeIsNewShape)(shapeModel.uuid, false));
	
	        if (!_PlatformDetection2.default.isIOS()) this.addFocus();
	    },
	    checkTextHeight: function checkTextHeight() {
	        var shapeModel = this.props.shapeModel;
	
	
	        if (!this.state.isTextHeightUpdated && !shapeModel.useLineHeightTextProperty) {
	            setTimeout(this.updateTextSize, 20);
	        }
	    },
	    updateTextSize: function updateTextSize() {
	        this.setState({
	            isTextHeightUpdated: true
	        });
	
	        this.checkSize();
	    },
	    checkSize: function checkSize() {
	        var isTextAdded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	        _TextSizeUtils2.default.updateTextWrapperSize(shapeModel, dispatch, isTextAdded);
	    },
	    onTextAreaClick: function onTextAreaClick() {
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT) return;
	
	        _CreateShapes2.default.checkFontMenu(this.props.dispatch, this.props.shapeModel);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	        if (currentSlide && currentSlide.model && currentSlide.model.content) {
	            var shapes = currentSlide.model.content;
	            var i;
	
	            for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                    if (shapes[i].isSelected == true) return true;else return false;
	                }
	            }return false;
	        }
	
	        return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	
	            this.checkTextLabel(false);
	        } else this.checkTextLabel(true);
	    },
	    checkTextLabel: function checkTextLabel() {
	        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        setTimeout(function () {
	            var textLabelElement = document.getElementById('textBoxLabel');
	
	            if (textLabelElement) {
	                if (show) textLabelElement.style.display = 'block';else textLabelElement.style.display = 'none';
	            }
	        }.bind(this), 10);
	    },
	    onFocusTextArea: function onFocusTextArea() {
	        if (document.activeElement == this.refs.shapeTextArea) this.checkTextLabel(true);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        this.checkIfIsNewShape();
	        this.checkTextHeight();
	
	        var _props3 = this.props,
	            shapeModel = _props3.shapeModel,
	            dispatch = _props3.dispatch;
	
	
	        var x = shapeModel.x;
	        var y = shapeModel.y;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var bold = shapeModel.fontBold ? 'bold' : 'normal';
	        var italic = shapeModel.fontItalic ? 'italic' : 'normal';
	        var textProperties = _TextSizeUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	
	        var textAreaStyle = {
	            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
	            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
	            resize: 'none',
	            overflow: 'hidden',
	            padding: INNER_PADDING,
	            border: 'none',
	            outline: 'none',
	            background: 'transparent',
	            fontFamily: shapeModel.fontFamily,
	            fontSize: shapeModel.fontSize,
	            fontStyle: italic,
	            fontWeight: bold,
	            color: shapeModel.fontColor,
	            textAlign: shapeModel.fontAlign,
	            wordSpacing: textProperties.wordSpacing,
	            letterSpacing: textProperties.letterSpacing,
	            textIdent: textProperties.textIdent
	        };
	
	        if (textProperties.lineHeight != -1) textAreaStyle.lineHeight = textProperties.lineHeight;
	
	        if (shapeModel.fontUnderline) textAreaStyle.textDecoration = 'underline';
	
	        var readOnlyValue = false;
	        var clone = _AnimationManager2.default.getCloneByUid(shapeModel.uuid);
	
	        if (!clone) clone = _AnimationManager2.default.clone;
	
	        if (_PlatformDetection2.default.isIOS() || clone && shapeModel.uuid == clone.uuid || _AnimationManager2.default.target && shapeModel.uuid == _AnimationManager2.default.target.uuid || _AppParameters2.default.isCartoonistPlayer()) {
	            readOnlyValue = true;
	            textAreaStyle.cursor = 'default';
	        }
	
	        var arabic = /[\u0600-\u06FF]/;
	
	        if (arabic.test(shapeModel.htmlText)) textAreaStyle.direction = 'rtl';
	
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var ariaLabelValue = _LocalesManager2.default.getCaption('tekst', 'other') + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var tabIndexValue;
	
	        if (!this.isShapeSelected()) tabIndexValue = -1;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + x + ' ' + y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: PADDING, y: PADDING, width: shapeModel.width - 2 * PADDING, height: shapeModel.height - 2 * PADDING },
	                    !shapeModel.isGrouped ? _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown }) : null,
	                    _react2.default.createElement('textarea', { tabIndex: tabIndexValue, id: textAreaId, role: 'textbox', onFocus: this.onFocusTextArea, 'aria-label': ariaLabelValue, 'aria-multiline': 'true', className: 'textShapes', ref: 'shapeTextArea', style: textAreaStyle, value: shapeModel.htmlText, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onTouchEnd: this.onTextAreaClick, onMouseUp: this.onTextAreaClick, onChange: this.onChangeText, readOnly: readOnlyValue })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/TextBoxSimple.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/TextBoxSimple.js"); } } })();

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TextBoxSimpleRich = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextBoxSimpleRich = exports.TextBoxSimpleRich = _react2.default.createClass({
	    displayName: 'TextBoxSimpleRich',
	    componentDidMount: function componentDidMount() {
	        if (this.refs.shapeTextArea && this.props.shapeModel.htmlText) this.refs.shapeTextArea.innerHTML = _TextEditorUtils2.default.getHtmlText(this.props.shapeModel);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_TextEditorUtils2.default.isTextEditorTool()) return;
	
	        if (this.props.shapeModel.htmlText != nextProps.shapeModel.htmlText && this.refs.shapeTextArea) this.refs.shapeTextArea.innerHTML = _TextEditorUtils2.default.getHtmlText(nextProps.shapeModel);
	
	        // when a new shape is added to canvas, force focus to interactive element
	        if (this.props.shapeModel.isNew != nextProps.shapeModel.isNew) this.setFocusToInteractiveElement();
	
	        // when an element becomes selected (state 2) using multiple selection, the focus should be on interactiveElement to can have a keyDown event in case we type something to enter in Text Editor (state 3) because textArea is disabled at that time
	        if (nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected) this.setFocusToInteractiveElement();
	    },
	    setFocusToInteractiveElement: function setFocusToInteractiveElement() {
	        setTimeout(function () {
	            if (this.refs.focusableElement) // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
	                this.refs.focusableElement.focus();
	        }.bind(this), 2);
	    },
	    checkIfIsNewShape: function checkIfIsNewShape() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        if (shapeModel.isNew == true) setTimeout(function () {
	            dispatch((0, _CurrentSlideActions.changeIsNewShape)(shapeModel.uuid, false));
	        }.bind(this), 2);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	        if (currentSlide && currentSlide.model && currentSlide.model.content) {
	            var shapes = currentSlide.model.content;
	            var i;
	
	            for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                    if (shapes[i].isSelected == true) return true;else return false;
	                }
	            }return false;
	        }
	
	        return false;
	    },
	    isContentEditable: function isContentEditable() {
	        if (_AppParameters2.default.isCartoonistPlayer()) return false;
	
	        var clone = _AnimationManager2.default.getCloneByUid(this.props.shapeModel.uuid);
	
	        if (!clone) clone = _AnimationManager2.default.clone;
	
	        if (clone && this.props.shapeModel.uuid == clone.uuid || _AnimationManager2.default.target && this.props.shapeModel.uuid == _AnimationManager2.default.target.uuid) // non editable in animation mode
	            return false;
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) return true;else return false;
	    },
	
	
	    /************ text area *************/
	    onChangeText: function onChangeText(e) {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        if (e.nativeEvent && e.nativeEvent.inputType === 'insertFromPaste') {
	            var txt = this.refs.shapeTextArea.innerText;
	            this.refs.shapeTextArea.innerHTML = '<span style="font-family: Cabin; font-size: 24px; white-space: pre-wrap">' + txt + '</span>';
	        } else _TextEditorUtils2.default.checkForSizeAttribute(this.refs.shapeTextArea);
	
	        // console.log('aaaa ' + document.getElementById('text_area_' + this.props.shapeModel.uuid).innerHTML);
	
	        _TextEditorUtils2.default.resetActions();
	        _TextEditorUtils2.default.updateShapeSize(this.props.shapeModel, this.props.dispatch);
	    },
	    onTextAreaClick: function onTextAreaClick() {
	        var selection = window.getSelection();
	
	        if (selection.anchorOffset == selection.extentOffset && _TextEditorUtils2.default.lastCursorPosition >= 0 && selection.anchorOffset == _TextEditorUtils2.default.lastCursorPosition) {// no text selected and only the cursor pointer
	            // if a text size was changed while no text selection and you will click on the same cursor position, then we should use the selected text size
	        } else {
	            _TextEditorUtils2.default.resetActions();
	        }
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) // if the textEditor is opened then should refresh it at every click to can updated properly the right buttons
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	            }.bind(this), 5);else this.checkTextEditorTool();
	    },
	    checkTextEditorTool: function checkTextEditorTool() {
	        // check to see if TEXT EDITOR tool can be opened
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT || _StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) return;
	
	        if (!this.props.shapeModel.isSelected) return;
	
	        this.setFocusToInteractiveElement(); // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
	
	        if (_TextEditorUtils2.default.isClick && _TextEditorUtils2.default.isShapeAlreadySelected) _TextEditorUtils2.default.openTextEditorTool(this.props.shapeModel);
	    },
	    onFocusTextArea: function onFocusTextArea() {
	        this.onFocusHandler();
	    },
	    handleKeyDown: function handleKeyDown(e) {
	        // when a key is down on text area
	        if (e.keyCode === 27 && this.refs.shapeTextArea === document.activeElement) {
	            // ESCAPE when the focus is on text ... close TEXT EDITOR mode ... next TAB should go to the hamburger menu
	            _TextEditorUtils2.default.closeTextEditor();
	            return;
	        }
	
	        if (e.keyCode === 9) {
	            // when TAB is down, then the focus will go to the CLOSE button on the TEXT EDITOR tool.
	            var closeButtonOnTextEditorTool = document.getElementById('firstFocusableObjectForTextEditorTool');
	
	            if (closeButtonOnTextEditorTool) {
	                setTimeout(function () {
	                    closeButtonOnTextEditorTool.focus();
	                }.bind(this), 2);
	            }
	
	            return;
	        }
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) {
	            // The user might move the insertion point with the arrow keys, so this will update the selected text types (only) on arrow key presses.
	            var arrowKeys = [37, 38, 39, 40];
	
	            if (arrowKeys.includes(e.keyCode)) // if is textTool is opened and move arrow keys then update the right buttons
	                setTimeout(function () {
	                    _TextEditorUtils2.default.resetActions();
	                    this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	                }.bind(this), 10);
	        }
	    },
	
	
	    /*************** interactive element ***************/
	    onKeyDown: function onKeyDown(e) {
	        // when key down on the interactive element
	        if (e.ctrlKey == true || e.altKey == true) // when commands keys don't open TEXT EDITOR
	            return;
	
	        var arrowKeys = [9, 27, 8, 46, 37, 38, 39, 40, 16]; // TAB, ESCAPE, BACKSPACE ,DELETE and arrow keys, SHIFT
	
	        if (arrowKeys.includes(e.keyCode)) {
	            // some keys are used for removing shape, moving shape or to change the tab
	            _TextEditorUtils2.default.resetActions();
	            return;
	        }
	
	        if (document.activeElement.id.indexOf('interactiveElement') != -1) // if interactive element is selected
	            _TextEditorUtils2.default.openTextEditorTool(this.props.shapeModel, { key: e.key, keyCode: e.keyCode });
	    },
	    onFocusHandler: function onFocusHandler() {
	        // on focus interactive element
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) {
	                _TextEditorUtils2.default.closeTextEditor();
	                this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	            }
	        }
	
	        _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        this.checkTextLabel();
	    },
	    checkTextLabel: function checkTextLabel() {
	        setTimeout(function () {
	            var textLabelElement = document.getElementById('textBoxLabel');
	
	            if (textLabelElement) textLabelElement.style.display = 'block';
	        }.bind(this), 3);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        this.checkIfIsNewShape();
	
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	        var x = shapeModel.x;
	        var y = shapeModel.y;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var textProperties = _TextEditorUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	
	        var textAreaStyle = {
	            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
	            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
	            resize: 'none',
	            overflow: 'hidden',
	            padding: INNER_PADDING,
	            border: 'none',
	            outline: 'none',
	            background: 'transparent',
	            wordSpacing: textProperties.wordSpacing,
	            letterSpacing: textProperties.letterSpacing,
	            overflowWrap: 'break-word',
	            cursor: 'text'
	        };
	
	        if (shapeModel.lineHeight > 0) textAreaStyle.lineHeight = shapeModel.lineHeight;else {
	            if (textProperties.lineHeight != -1) textAreaStyle.lineHeight = textProperties.lineHeight;
	        }
	
	        var arabic = /[\u0600-\u06FF]/;
	
	        if (arabic.test(shapeModel.htmlText)) textAreaStyle.direction = 'rtl';
	
	        var isContentEditable = this.isContentEditable();
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var ariaLabelValue = _LocalesManager2.default.getCaption('tekst', 'other') + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var tabIndexValue;
	
	        if (!isContentEditable) textAreaStyle.cursor = 'default';
	
	        if (!this.isShapeSelected()) tabIndexValue = -1;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + x + ' ' + y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: PADDING, y: PADDING, width: shapeModel.width - 2 * PADDING, height: shapeModel.height - 2 * PADDING },
	                    !shapeModel.isGrouped ? _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, ref: 'focusableElement', href: '', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown }) : null,
	                    _react2.default.createElement('div', { id: textAreaId, tabIndex: tabIndexValue, ref: 'shapeTextArea', className: 'textShapes', role: 'textbox', 'aria-label': ariaLabelValue, 'aria-multiline': 'true', style: textAreaStyle, contentEditable: isContentEditable, suppressContentEditableWarning: true, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onTouchEnd: this.onTextAreaClick, onMouseUp: this.onTextAreaClick, onKeyDown: this.handleKeyDown, onInput: this.onChangeText, onFocus: this.onFocusTextArea })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/TextBoxSimpleRich.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/TextBoxSimpleRich.js"); } } })();

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ThoughtBubble = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _ThoughtBubbleUtils = __webpack_require__(237);
	
	var _ThoughtBubbleUtils2 = _interopRequireDefault(_ThoughtBubbleUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _TouchUtils = __webpack_require__(109);
	
	var _TouchUtils2 = _interopRequireDefault(_TouchUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThoughtBubble = exports.ThoughtBubble = _react2.default.createClass({
	    displayName: 'ThoughtBubble',
	
	    propTypes: {
	        shapeModel: _react2.default.PropTypes.object
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isTextHeightUpdated: false
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_PreviewCommands2.default.isPlayMode() == true) return;
	
	        if (!nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected && !_PlatformDetection2.default.isIOS()) // shape becomes unselected
	            this.clearTextSelection();
	
	        if (!_PlatformDetection2.default.isTouchableDevice()) return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) return;
	
	            if (shapeModel.isNew) {
	                this.changeFocus(true);
	                return;
	            }
	        }
	
	        if (shapeModel.moveState != nextProps.shapeModel.moveState || shapeModel.isNew != nextProps.shapeModel.isNew) {
	            if (nextProps.shapeModel.isSelected == true && (nextProps.shapeModel.moveState == false || nextProps.shapeModel.moveState == undefined)) {
	                if (_PlatformDetection2.default.isIOS() && _TouchUtils2.default.isLongInteraction() == true) return;
	
	                this.changeFocus(true);
	            }
	        }
	
	        if (!nextProps.shapeModel.isSelected && shapeModel.isSelected != nextProps.shapeModel.isSelected) // shape becomes unselected
	            this.changeFocus(false);
	    },
	    clearTextSelection: function clearTextSelection() {
	        if (this.refs.shapeTextArea) this.refs.shapeTextArea.selectionStart = this.refs.shapeTextArea.selectionEnd;
	    },
	    changeFocus: function changeFocus(isFocus) {
	        if (_PlatformDetection2.default.isIOS()) {
	            if (isFocus && !_AnimationManager2.default.isAnimationMode()) this.props.dispatch((0, _MenuActions.showTextEditor)(this.props.shapeModel));
	
	            return;
	        }
	
	        var view = this.refs.shapeTextArea;
	
	        if (view) {
	            if (isFocus == true) this.addFocus();else view.blur();
	        }
	    },
	    addFocus: function addFocus() {
	        var view = this.refs.shapeTextArea;
	
	        if (view) view.focus();
	    },
	    onChangeText: function onChangeText(e) {
	        if (_PreviewCommands2.default.isPlayMode() || _PlatformDetection2.default.isIOS()) return;
	
	        var newValue = e.target.value;
	
	        if (newValue == undefined) return;
	
	        this.props.dispatch((0, _CurrentSlideActions.changeTextProperties)(this.props.shapeModel, 'htmlText', newValue));
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        var isTextAdded = false;
	
	        if (newValue.length > this.props.shapeModel.htmlText.length && newValue.length > 10) isTextAdded = true;
	
	        setTimeout(this.checkSize, 50, isTextAdded);
	    },
	    checkIfIsNewShape: function checkIfIsNewShape() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        var shapeModel = this.props.shapeModel;
	
	
	        if (shapeModel.isNew == true) setTimeout(this.setTextAreaFocus, 10);
	    },
	    setTextAreaFocus: function setTextAreaFocus() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	        dispatch((0, _CurrentSlideActions.changeIsNewShape)(shapeModel.uuid, false));
	
	        if (!_PlatformDetection2.default.isIOS()) this.addFocus();
	    },
	    checkTextHeight: function checkTextHeight() {
	        var shapeModel = this.props.shapeModel;
	
	
	        if (!this.state.isTextHeightUpdated && !shapeModel.useLineHeightTextProperty) {
	            setTimeout(this.updateTextSize, 20);
	        }
	    },
	    updateTextSize: function updateTextSize() {
	        this.setState({
	            isTextHeightUpdated: true
	        });
	
	        this.checkSize();
	    },
	    checkSize: function checkSize() {
	        var isTextAdded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	        _TextSizeUtils2.default.updateTextWrapperSize(shapeModel, dispatch, isTextAdded);
	    },
	    onTextAreaClick: function onTextAreaClick() {
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT) return;
	
	        _CreateShapes2.default.checkFontMenu(this.props.dispatch, this.props.shapeModel);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	        if (currentSlide && currentSlide.model && currentSlide.model.content) {
	            var shapes = currentSlide.model.content;
	            var i;
	
	            for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                    if (shapes[i].isSelected == true) return true;else return false;
	                }
	            }return false;
	        }
	
	        return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	
	            this.checkTextLabel(false);
	        } else this.checkTextLabel(true);
	    },
	    checkTextLabel: function checkTextLabel() {
	        var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        setTimeout(function () {
	            var textLabelElement = document.getElementById('textBoxLabel');
	
	            if (textLabelElement) {
	                if (show) textLabelElement.style.display = 'block';else textLabelElement.style.display = 'none';
	            }
	        }.bind(this), 10);
	    },
	    onFocusTextArea: function onFocusTextArea() {
	        if (document.activeElement == this.refs.shapeTextArea) this.checkTextLabel(true);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        this.checkIfIsNewShape();
	        this.checkTextHeight();
	
	        var _props3 = this.props,
	            shapeModel = _props3.shapeModel,
	            dispatch = _props3.dispatch;
	
	
	        var x = shapeModel.x;
	        var y = shapeModel.y;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var bold = shapeModel.fontBold ? 'bold' : 'normal';
	        var italic = shapeModel.fontItalic ? 'italic' : 'normal';
	        var textProperties = _TextSizeUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	
	        var textAreaStyle = {
	            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
	            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
	            resize: 'none',
	            overflow: 'hidden',
	            padding: INNER_PADDING,
	            border: 'none',
	            outline: 'none',
	            background: 'transparent',
	            fontFamily: shapeModel.fontFamily,
	            fontSize: shapeModel.fontSize,
	            fontStyle: italic,
	            fontWeight: bold,
	            color: shapeModel.fontColor,
	            textAlign: shapeModel.fontAlign,
	            wordSpacing: textProperties.wordSpacing,
	            letterSpacing: textProperties.letterSpacing,
	            textIdent: textProperties.textIdent
	        };
	
	        if (textProperties.lineHeight != -1) textAreaStyle.lineHeight = textProperties.lineHeight;
	
	        if (shapeModel.fontUnderline) textAreaStyle.textDecoration = 'underline';
	
	        var path = '';
	        var points = void 0;
	        var radius = void 0;
	
	        if (!shapeModel.path) {
	            path = _ThoughtBubbleUtils2.default.getPath(shapeModel);
	            shapeModel.path = path;
	        } else {
	            path = shapeModel.path;
	        }
	
	        var stemObject = _ThoughtBubbleUtils2.default.getStemPoints(shapeModel);
	        points = stemObject.points;
	        radius = stemObject.radius;
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var readOnlyValue = false;
	        var clone = _AnimationManager2.default.getCloneByUid(shapeModel.uuid);
	
	        if (!clone) clone = _AnimationManager2.default.clone;
	
	        if (_PlatformDetection2.default.isIOS() || clone && shapeModel.uuid == clone.uuid || _AnimationManager2.default.target && shapeModel.uuid == _AnimationManager2.default.target.uuid || _AppParameters2.default.isCartoonistPlayer()) {
	            readOnlyValue = true;
	            textAreaStyle.cursor = 'default';
	        }
	
	        var arabic = /[\u0600-\u06FF]/;
	
	        if (arabic.test(shapeModel.htmlText)) textAreaStyle.direction = 'rtl';
	
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var ariaLabelValue = _LocalesManager2.default.getCaption('tekst', 'other') + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var tabIndexValue;
	
	        if (!this.isShapeSelected()) tabIndexValue = -1;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, isBubble: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + x + ' ' + y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement('ellipse', {
	                    rx: radius[0],
	                    ry: radius[0],
	                    cx: points[0].x,
	                    cy: points[0].y,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none' }),
	                _react2.default.createElement('ellipse', {
	                    rx: radius[1],
	                    ry: radius[1],
	                    cx: points[1].x,
	                    cy: points[1].y,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none' }),
	                _react2.default.createElement('ellipse', {
	                    rx: radius[2],
	                    ry: radius[2],
	                    cx: points[2].x,
	                    cy: points[2].y,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none' }),
	                _react2.default.createElement('path', {
	                    d: path,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none' }),
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: PADDING, y: PADDING, width: shapeModel.width - 2 * PADDING, height: shapeModel.height - 2 * PADDING },
	                    !shapeModel.isGrouped ? _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown }) : null,
	                    _react2.default.createElement('textarea', { tabIndex: tabIndexValue, id: textAreaId, role: 'textbox', onFocus: this.onFocusTextArea, 'aria-label': ariaLabelValue, 'aria-multiline': 'true', className: 'textShapes', ref: 'shapeTextArea', style: textAreaStyle, value: shapeModel.htmlText, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onTouchEnd: this.onTextAreaClick, onMouseUp: this.onTextAreaClick, onChange: this.onChangeText, readOnly: readOnlyValue })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/ThoughtBubble.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/ThoughtBubble.js"); } } })();

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ThoughtBubbleRich = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ThoughtBubbleUtils = __webpack_require__(237);
	
	var _ThoughtBubbleUtils2 = _interopRequireDefault(_ThoughtBubbleUtils);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThoughtBubbleRich = exports.ThoughtBubbleRich = _react2.default.createClass({
	    displayName: 'ThoughtBubbleRich',
	    componentDidMount: function componentDidMount() {
	        if (this.refs.shapeTextArea && this.props.shapeModel.htmlText) this.refs.shapeTextArea.innerHTML = _TextEditorUtils2.default.getHtmlText(this.props.shapeModel);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_TextEditorUtils2.default.isTextEditorTool()) return;
	
	        if (this.props.shapeModel.htmlText != nextProps.shapeModel.htmlText && this.refs.shapeTextArea) this.refs.shapeTextArea.innerHTML = _TextEditorUtils2.default.getHtmlText(nextProps.shapeModel);
	
	        // when a new shape is added to canvas, force focus to interactive element
	        if (this.props.shapeModel.isNew != nextProps.shapeModel.isNew) this.setFocusToInteractiveElement();
	
	        // when an element becomes selected (state 2) using multiple selection, the focus should be on interactiveElement to can have a keyDown event in case we type something to enter in Text Editor (state 3) because textArea is disabled at that time
	        if (nextProps.shapeModel.isSelected && this.props.shapeModel.isSelected != nextProps.shapeModel.isSelected) this.setFocusToInteractiveElement();
	    },
	    setFocusToInteractiveElement: function setFocusToInteractiveElement() {
	        setTimeout(function () {
	            if (this.refs.focusableElement) // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
	                this.refs.focusableElement.focus();
	        }.bind(this), 2);
	    },
	    checkIfIsNewShape: function checkIfIsNewShape() {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        if (shapeModel.isNew == true) setTimeout(function () {
	            dispatch((0, _CurrentSlideActions.changeIsNewShape)(shapeModel.uuid, false));
	        }.bind(this), 2);
	    },
	    isShapeSelected: function isShapeSelected() {
	        var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	        if (currentSlide && currentSlide.model && currentSlide.model.content) {
	            var shapes = currentSlide.model.content;
	            var i;
	
	            for (i = 0; i < shapes.length; i++) {
	                if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                    if (shapes[i].isSelected == true) return true;else return false;
	                }
	            }return false;
	        }
	
	        return false;
	    },
	    isContentEditable: function isContentEditable() {
	        if (_AppParameters2.default.isCartoonistPlayer()) return false;
	
	        var clone = _AnimationManager2.default.getCloneByUid(this.props.shapeModel.uuid);
	
	        if (!clone) clone = _AnimationManager2.default.clone;
	
	        if (clone && this.props.shapeModel.uuid == clone.uuid || _AnimationManager2.default.target && this.props.shapeModel.uuid == _AnimationManager2.default.target.uuid) // non editable in animation mode
	            return false;
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) return true;else return false;
	    },
	
	
	    /************ text area *************/
	    onChangeText: function onChangeText(e) {
	        if (_PreviewCommands2.default.isPlayMode()) return;
	
	        if (e.nativeEvent && e.nativeEvent.inputType === 'insertFromPaste') {
	            var txt = this.refs.shapeTextArea.innerText;
	            this.refs.shapeTextArea.innerHTML = '<span style="font-family: Cabin; font-size: 24px; white-space: pre-wrap">' + txt + '</span>';
	        } else _TextEditorUtils2.default.checkForSizeAttribute(this.refs.shapeTextArea);
	
	        // console.log('aaaa ' + document.getElementById('text_area_' + this.props.shapeModel.uuid).innerHTML);
	
	        _TextEditorUtils2.default.resetActions();
	        _TextEditorUtils2.default.updateShapeSize(this.props.shapeModel, this.props.dispatch);
	    },
	    onTextAreaClick: function onTextAreaClick() {
	        var selection = window.getSelection();
	
	        if (selection.anchorOffset == selection.extentOffset && _TextEditorUtils2.default.lastCursorPosition >= 0 && selection.anchorOffset == _TextEditorUtils2.default.lastCursorPosition) {// no text selected and only the cursor pointer
	            // if a text size was changed while no text selection and you will click on the same cursor position, then we should use the selected text size
	        } else {
	            _TextEditorUtils2.default.resetActions();
	        }
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) // if the textEditor is opened then should refresh it at every click to can updated properly the right buttons
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	            }.bind(this), 5);else this.checkTextEditorTool();
	    },
	    checkTextEditorTool: function checkTextEditorTool() {
	        // check to see if TEXT EDITOR tool can be opened
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT || _StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) return;
	
	        if (!this.props.shapeModel.isSelected) return;
	
	        this.setFocusToInteractiveElement(); // force focus to interactive element to can handle on KeyDown on it because we can't get key events on textArea while disabled
	
	        if (_TextEditorUtils2.default.isClick && _TextEditorUtils2.default.isShapeAlreadySelected) _TextEditorUtils2.default.openTextEditorTool(this.props.shapeModel);
	    },
	    onFocusTextArea: function onFocusTextArea() {
	        this.onFocusHandler();
	    },
	    handleKeyDown: function handleKeyDown(e) {
	        // when a key is down on text area
	        if (e.keyCode === 27 && this.refs.shapeTextArea === document.activeElement) {
	            // ESCAPE when the focus is on text ... close TEXT EDITOR mode ... next TAB should go to the hamburger menu
	            _TextEditorUtils2.default.closeTextEditor();
	            return;
	        }
	
	        if (e.keyCode === 9) {
	            // when TAB is down, then the focus will go to the CLOSE button on the TEXT EDITOR tool.
	            var closeButtonOnTextEditorTool = document.getElementById('firstFocusableObjectForTextEditorTool');
	
	            if (closeButtonOnTextEditorTool) {
	                setTimeout(function () {
	                    closeButtonOnTextEditorTool.focus();
	                }.bind(this), 2);
	            }
	
	            return;
	        }
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) {
	            // The user might move the insertion point with the arrow keys, so this will update the selected text types (only) on arrow key presses.
	            var arrowKeys = [37, 38, 39, 40];
	
	            if (arrowKeys.includes(e.keyCode)) // if is textTool is opened and move arrow keys then update the right buttons
	                setTimeout(function () {
	                    _TextEditorUtils2.default.resetActions();
	                    this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	                }.bind(this), 10);
	        }
	    },
	
	
	    /*************** interactive element ***************/
	    onKeyDown: function onKeyDown(e) {
	        // when key down on the interactive element
	        if (e.ctrlKey == true || e.altKey == true) // when commands keys don't open TEXT EDITOR
	            return;
	
	        var arrowKeys = [9, 27, 8, 46, 37, 38, 39, 40, 16]; // TAB, ESCAPE, BACKSPACE ,DELETE and arrow keys, SHIFT
	
	        if (arrowKeys.includes(e.keyCode)) {
	            // some keys are used for removing shape, moving shape or to change the tab
	            _TextEditorUtils2.default.resetActions();
	            return;
	        }
	
	        if (document.activeElement.id.indexOf('interactiveElement') != -1) // if interactive element is selected
	            _TextEditorUtils2.default.openTextEditorTool(this.props.shapeModel, { key: e.key, keyCode: e.keyCode });
	    },
	    onFocusHandler: function onFocusHandler() {
	        // on focus interactive element
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) {
	                _TextEditorUtils2.default.closeTextEditor();
	                this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	            }
	        }
	
	        _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        this.checkTextLabel();
	    },
	    checkTextLabel: function checkTextLabel() {
	        setTimeout(function () {
	            var textLabelElement = document.getElementById('textBoxLabel');
	
	            if (textLabelElement) textLabelElement.style.display = 'block';
	        }.bind(this), 3);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        this.checkIfIsNewShape();
	
	        var _props2 = this.props,
	            shapeModel = _props2.shapeModel,
	            dispatch = _props2.dispatch;
	
	        var x = shapeModel.x;
	        var y = shapeModel.y;
	        var PADDING = _Properties2.default.TEXT_PADDING;
	        var INNER_PADDING = _Properties2.default.TEXT_INNER_PADDING;
	        var textProperties = _TextEditorUtils2.default.textProperties(shapeModel);
	        var EXTRA_PADDING = textProperties.extraPadding;
	
	        var textAreaStyle = {
	            width: shapeModel.width - 2 * PADDING - 2 * INNER_PADDING + EXTRA_PADDING,
	            height: shapeModel.height - 2 * PADDING - 2 * INNER_PADDING,
	            resize: 'none',
	            overflow: 'hidden',
	            padding: INNER_PADDING,
	            border: 'none',
	            outline: 'none',
	            background: 'transparent',
	            wordSpacing: textProperties.wordSpacing,
	            letterSpacing: textProperties.letterSpacing,
	            overflowWrap: 'break-word',
	            cursor: 'text'
	        };
	
	        if (shapeModel.lineHeight > 0) textAreaStyle.lineHeight = shapeModel.lineHeight;else {
	            if (textProperties.lineHeight != -1) textAreaStyle.lineHeight = textProperties.lineHeight;
	        }
	
	        var path = '';
	        var points = void 0;
	        var radius = void 0;
	
	        if (!shapeModel.path) {
	            path = _ThoughtBubbleUtils2.default.getPath(shapeModel);
	            shapeModel.path = path;
	        } else {
	            path = shapeModel.path;
	        }
	
	        var stemObject = _ThoughtBubbleUtils2.default.getStemPoints(shapeModel);
	        points = stemObject.points;
	        radius = stemObject.radius;
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var arabic = /[\u0600-\u06FF]/;
	
	        if (arabic.test(shapeModel.htmlText)) textAreaStyle.direction = 'rtl';
	
	        var isContentEditable = this.isContentEditable();
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var ariaLabelValue = _LocalesManager2.default.getCaption('tekst', 'other') + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var tabIndexValue;
	
	        if (!isContentEditable) textAreaStyle.cursor = 'default';
	
	        if (!this.isShapeSelected()) tabIndexValue = -1;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, isBubble: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + x + ' ' + y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement('ellipse', {
	                    rx: radius[0],
	                    ry: radius[0],
	                    cx: points[0].x,
	                    cy: points[0].y,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none' }),
	                _react2.default.createElement('ellipse', {
	                    rx: radius[1],
	                    ry: radius[1],
	                    cx: points[1].x,
	                    cy: points[1].y,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none' }),
	                _react2.default.createElement('ellipse', {
	                    rx: radius[2],
	                    ry: radius[2],
	                    cx: points[2].x,
	                    cy: points[2].y,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none' }),
	                _react2.default.createElement('path', {
	                    d: path,
	                    filter: shapeModel.filter,
	                    fill: shapeModel.fill,
	                    fillOpacity: backgroundOpacity,
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity,
	                    preserveAspectRatio: 'none' }),
	                _react2.default.createElement(
	                    'foreignObject',
	                    { x: PADDING, y: PADDING, width: shapeModel.width - 2 * PADDING, height: shapeModel.height - 2 * PADDING },
	                    !shapeModel.isGrouped ? _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, ref: 'focusableElement', href: '', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown }) : null,
	                    _react2.default.createElement('div', { id: textAreaId, tabIndex: tabIndexValue, ref: 'shapeTextArea', className: 'textShapes', role: 'textbox', 'aria-label': ariaLabelValue, 'aria-multiline': 'true', style: textAreaStyle, contentEditable: isContentEditable, suppressContentEditableWarning: true, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onTouchEnd: this.onTextAreaClick, onMouseUp: this.onTextAreaClick, onKeyDown: this.handleKeyDown, onInput: this.onChangeText, onFocus: this.onFocusTextArea })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/ThoughtBubbleRich.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/ThoughtBubbleRich.js"); } } })();

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Triangle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Triangle = exports.Triangle = _react2.default.createClass({
	    displayName: 'Triangle',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        shapeModel: _react2.default.PropTypes.object.isRequired
	    },
	    isShapeSelected: function isShapeSelected() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                if (shapes[i].isSelected == true) return true;else return false;
	            }
	        }return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        var backgroundOpacity;
	
	        if (shapeModel.backgroundVisible == false) backgroundOpacity = 0;else backgroundOpacity = 1;
	
	        var clipPathObject;
	        var realWidth = shapeModel.width;
	        var realHeight = shapeModel.height;
	        var newShapeModel = shapeModel;
	        var x1 = 0;
	        var y1 = 0;
	        var clipId = 'hotSpot_' + shapeModel.uuid;
	        var clipPath = 'url(#' + clipId + ')';
	
	        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
	            realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
	            realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);
	
	            x1 = realWidth * shapeModel.hotSpot.x1 / 100;
	            y1 = realHeight * shapeModel.hotSpot.y1 / 100;
	            var x2 = realWidth * shapeModel.hotSpot.x2 / 100;
	            var y2 = realHeight * shapeModel.hotSpot.y2 / 100;
	
	            if (_ZoomUtils2.default.isCroppingMode() && _ZoomUtils2.default.croppingTarget.uuid == shapeModel.uuid) {
	                newShapeModel = Object.assign({}, shapeModel);
	                newShapeModel.width = realWidth;
	                newShapeModel.height = realHeight;
	                newShapeModel.x = shapeModel.x - x1;
	                newShapeModel.y = shapeModel.y - y1;
	
	                // x1=0;
	                // y1=0;
	            } else {
	                clipPathObject = _react2.default.createElement(
	                    'clipPath',
	                    { id: clipId },
	                    _react2.default.createElement('rect', { x: x1, y: y1, width: x2 - x1, height: y2 - y1 })
	                );
	            }
	        }
	
	        var path = 'M' + realWidth / 2 + ' 0 L' + realWidth + ' ' + realHeight + ' L0 ' + realHeight + ' Z';
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + newShapeModel.x + ' ' + newShapeModel.y + ')', opacity: shapeModel.opacity },
	                clipPathObject,
	                _react2.default.createElement(
	                    'g',
	                    { transform: 'translate(' + -x1 + ' ' + -y1 + ')' },
	                    _react2.default.createElement('path', {
	                        d: path,
	                        filter: newShapeModel.filter,
	                        opacity: newShapeModel.opacity,
	                        fill: newShapeModel.fill,
	                        fillOpacity: backgroundOpacity,
	                        stroke: newShapeModel.stroke,
	                        strokeWidth: newShapeModel.strokeWidth,
	                        strokeOpacity: newShapeModel.strokeOpacity,
	                        preserveAspectRatio: 'none',
	                        clipPath: clipPath })
	                ),
	                !shapeModel.isGrouped ? _react2.default.createElement(
	                    'foreignObject',
	                    null,
	                    _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                ) : null
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Triangle.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Triangle.js"); } } })();

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Video = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Video = exports.Video = _react2.default.createClass({
	    displayName: 'Video',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            isPlay: false,
	            isLoaded: false
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.shapeModel.refresh != nextProps.shapeModel.refresh) this.forceUpdate();
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut(e) {
	        if (e.relatedTarget && (e.relatedTarget === this.refs.playButton || e.relatedTarget === this.refs.buttonHolder)) return;
	
	        this.setState({
	            isOver: false
	        });
	    },
	    onVideoEnded: function onVideoEnded() {
	        if (this.refs.videoShape) this.refs.videoShape.currentTime = 0;
	
	        this.setState({
	            isPlay: false
	        });
	    },
	    onPlayPause: function onPlayPause() {
	        if (!this.refs.videoShape) return;
	
	        if (this.state.isPlay === true) this.refs.videoShape.pause();else this.refs.videoShape.play();
	
	        this.setState({
	            isPlay: !this.state.isPlay
	        });
	    },
	    onVideoLoaded: function onVideoLoaded() {
	        if (_PreviewCommands2.default.isPlayMode() || !this.refs.videoShape || this.state.isLoaded) return;
	
	        var duration = this.refs.videoShape.duration;
	
	        if (duration > 0) {
	            this.setState({
	                isLoaded: true
	            });
	
	            _VideoUtils2.default.checkSlideDurationWhenAddVideoShape(duration);
	            _StoreManager2.default.getStore().dispatch((0, _CurrentSlideActions.addVideoShapeDuration)(this.props.shapeModel, duration));
	        }
	    },
	    isShapeSelected: function isShapeSelected() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                if (shapes[i].isSelected == true) return true;else return false;
	            }
	        }return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        }
	    },
	    render: function render() {
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	        var playHolderSize = 26;
	
	        var playHolder = {
	            position: 'absolute',
	            width: playHolderSize,
	            height: playHolderSize,
	            cursor: '-webkit-grab',
	            background: 'white',
	            borderRadius: 4,
	            border: 'none'
	        };
	
	        var playBtn = {
	            position: 'absolute',
	            width: playHolderSize / 2,
	            height: playHolderSize / 2,
	            left: playHolderSize / 4,
	            top: playHolderSize / 4
	        };
	
	        var icon = void 0;
	
	        if (this.state.isPlay === true) icon = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/pause.png';else icon = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/play.png';
	
	        var showPlayButton = false;
	
	        if (_PreviewCommands2.default.isEditorMode() === false) showPlayButton = false;else {
	            var videoIsPlaying = this.refs.videoShape && !!(this.refs.videoShape.currentTime >= 0 && !this.refs.videoShape.paused && !this.refs.videoShape.ended);
	
	            if (videoIsPlaying) {
	                showPlayButton = this.state.isOver;
	            } else {
	                showPlayButton = !shapeModel.isInteraction || shapeModel.isInteraction && shapeModel.moveState;
	            }
	        }
	
	        var playAriaLabel = '';
	
	        if (this.state.isPlay) playAriaLabel = _LocalesManager2.default.getCaption('pause', 'audioRecorder');else playAriaLabel = _LocalesManager2.default.getCaption('play', 'audioRecorder');
	
	        var videoX = 0;
	        var videoY = 0;
	
	        if (_PlatformDetection2.default.isIOS()) {
	            showPlayButton = false;
	
	            videoX = shapeModel.x;
	            videoY = shapeModel.y;
	        }
	
	        var videoAriaLabel = 'Video';
	
	        if (shapeModel.title && shapeModel.title.length > 0) videoAriaLabel = videoAriaLabel + ' - ' + shapeModel.title;
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + shapeModel.x + ' ' + shapeModel.y + ')', opacity: shapeModel.opacity },
	                _react2.default.createElement(
	                    'g',
	                    null,
	                    _react2.default.createElement(
	                        'foreignObject',
	                        { x: videoX, y: videoY, width: shapeModel.width, height: shapeModel.height },
	                        _react2.default.createElement('video', { ref: 'videoShape', id: 'videoShape_' + shapeModel.uuid, 'aria-label': videoAriaLabel, width: shapeModel.width, height: shapeModel.height, src: _VideoUtils2.default.getCorrectUrl(shapeModel.xlinkHref), onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onEnded: this.onVideoEnded, onDurationChange: this.onVideoLoaded })
	                    ),
	                    !shapeModel.isGrouped ? _react2.default.createElement(
	                        'foreignObject',
	                        null,
	                        _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                    ) : null,
	                    showPlayButton ? _react2.default.createElement(
	                        'foreignObject',
	                        { ref: 'buttonHolder', x: shapeModel.width / 2 - playHolderSize / 2, y: shapeModel.height / 2 - playHolderSize / 2, width: playHolderSize, height: playHolderSize },
	                        _react2.default.createElement(
	                            'button',
	                            { ref: 'playButton', style: playHolder, 'aria-label': playAriaLabel, onClick: this.onPlayPause, onTouchStart: this.onPlayPause },
	                            _react2.default.createElement('img', { style: playBtn, src: icon })
	                        )
	                    ) : null
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Video.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Video.js"); } } })();

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MusicActions = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var audioClipartModel = {
	    subcategories: [0, 0, 0],
	
	    addToStateAudioClipart: function addToStateAudioClipart() {
	        var href = _AppParameters2.default.clipartBucket() + '/audioeditor/audioThree.json?cache=' + Math.random();
	
	        try {
	            var xhr = new XMLHttpRequest();
	            xhr.open('GET', href, true);
	
	            xhr.onload = function () {
	                this.appendToState(xhr.response);
	            }.bind(this);
	
	            xhr.send();
	        } catch (err) {
	            console.log('Error ' + err);
	        }
	    },
	    appendToState: function appendToState(data) {
	        var data = this.parseData(JSON.parse(data));
	        var store = _StoreManager2.default.getStore();
	
	        store.dispatch((0, _MusicActions.addSoundClipartModel)(data));
	    },
	    parseData: function parseData(data) {
	        var categories = data.categories;
	        var newCategories = [];
	
	        for (var i = 0; i < categories.length; i++) {
	            var themes = categories[i].themes;
	            var newThemes = [];
	
	            for (var j = 0; j < themes.length; j++) {
	                var tracks = themes[j].tracks;
	                var newTracks = [];
	
	                for (var k = 0; k < tracks.length; k++) {
	                    var element = {};
	
	                    element.title = this.getCorrectTitle(tracks[k].track_title);
	                    element.duration = tracks[k].duration;
	                    element.href = tracks[k].href;
	                    element.contentType = 'content_sound';
	                    element.contentItemId = -1;
	
	                    newTracks.push(element);
	                }
	
	                var themesElement = {};
	                themesElement.title = this.getCorrectTitle(themes[j].theme_title);
	                themesElement.items = newTracks;
	
	                newThemes.push(themesElement);
	            }
	
	            var categoryElement = {};
	            categoryElement.title = this.getCorrectTitle(categories[i].category_title);
	            categoryElement.items = newThemes;
	
	            newCategories.push(categoryElement);
	        }
	
	        var newData = {};
	        newData.title = data.sound_library_title;
	        newData.items = newCategories;
	
	        return newData;
	    },
	    getCorrectTitle: function getCorrectTitle(item) {
	        var title = '';
	
	        switch (_AppParameters2.default.locale) {
	            case 'en_US':
	                {
	                    title = item.us_EN;
	                    break;
	                }
	            case 'sv_SE':
	                {
	                    title = item.sv_SV;
	                    break;
	                }
	            case 'nb_NO':
	                {
	                    title = item.nb_NO;
	                    break;
	                }
	            case 'nn_NO':
	                {
	                    title = item.nn_NO;
	
	                    if (!title || title === '') title = item.nb_NO;
	                    break;
	                }
	        }
	
	        if (!title || title === '') title = item.us_EN;
	
	        return title;
	    }
	};
	
	exports.default = audioClipartModel;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/AudioClipartModel.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/AudioClipartModel.js"); } } })();

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _s = __webpack_require__(161);
	
	var _s2 = _interopRequireDefault(_s);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fineUploader = {
	    uploader: undefined,
	    completeCallback: undefined,
	
	    init: function init() {
	        var accessKey;
	        var bucket;
	        var arg = {};
	        var acceptedString = "application/vnd.rn-realmedia,application/x-shockwave-flash,audio/m4a,audio/webm,audio/mp3,audio/x-caf,audio/caf,audio/mpeg,audio/mpg,audio/ogg,audio/wav,audio/x-m4a,audio/x-mp3,audio/x-wav, audio/vnd.wave,image/bmp,image/gif,image/jpeg,image/jpeg,image/pjpeg,image/pjpeg,image/png,image/tif,image/tiff,image/x-bmp,image/x-citrix-pjpeg,image/x-png,image/x-tif,image/x-tiff,image/x-windows-bmp,sound/mpeg,video/3g2,video/3gp,video/3gpp,video/MP2T,video/MP2T_m2ts,video/avi,video/divx,video/mp4,video/mpeg,video/mpeg_mod,video/mpg,video/ogg,video/quicktime,video/webm,video/x-dv,video/x-flv,video/x-m4v,video/x-ms-wmv,video/x-msvideo,";
	
	        arg.options = {};
	        if (_Configuration2.default.IS_PROD() == true) {
	            accessKey = 'AKIAJYMW5PW6FZLDMV2Q';
	            bucket = 'creaza-upload';
	        } else {
	            accessKey = 'AKIAJW24ZO65AI7KR7BA';
	            bucket = 'creaza-stage-upload';
	        }
	
	        arg.options.autoUpload = true;
	        arg.options.request = { endpoint: 'https://s3-eu-west-1.amazonaws.com/' + bucket, accessKey: accessKey, clockDrift: _AudioUtils2.default.serverTimeOffset };
	        arg.options.signature = { endpoint: '/ICSXapi/file/SignS3Policy' };
	        arg.options.validation = { acceptFiles: acceptedString };
	        arg.options.uploadSuccess = { endpoint: '/ICSXapi/file/StoreUploadedRecording' };
	
	        this.uploader = new _s2.default(arg);
	        this.uploader.on('complete', this.onComplete.bind(this));
	        this.uploader.on('error', this.onFail.bind(this));
	    },
	    onComplete: function onComplete(var1, var2, var3) {
	        if (this.completeCallback) this.completeCallback(var1, var2, var3);
	    },
	    onFail: function onFail() {},
	    uploadFile: function uploadFile(blob, title, completeHandler) {
	        this.completeCallback = completeHandler;
	
	        var blobWrapper = { blob: blob, name: title };
	        this.uploader.methods.addFiles([blobWrapper]);
	    }
	};
	
	exports.default = fineUploader;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/FineUploader.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/FineUploader.js"); } } })();

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resumeSessionUtils = {
	    token: undefined,
	
	    init: function init() {
	        var _this = this;
	
	        if (!_PlatformDetection2.default.isIOSApp()) // resume session is available only for IOS app
	            return;
	
	        _ApiService2.default.getSessionToken().then(function (response) {
	            _this.token = response.token;
	        });
	    },
	    resumeSession: function resumeSession() {
	        if (!this.token) return;
	
	        _ApiService2.default.doLoginWithToken(this.token).then(function (response) {
	            return true;
	        });
	    }
	};
	
	exports.default = resumeSessionUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ResumeSessionUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ResumeSessionUtils.js"); } } })();

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _DataLoader = __webpack_require__(323);
	
	var _DataLoader2 = _interopRequireDefault(_DataLoader);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sessionUtils = {
	    parametersLoaded: false,
	
	    doLogin: function doLogin(token, id) {
	        var self = this;
	
	        _ApiService2.default.doLoginWithToken(token, id).then(function (response) {
	            return self.decodeResponse(response);
	        });
	    },
	    decodeResponse: function decodeResponse(response) {
	        if (!response) return;
	
	        this.parametersLoaded = true;
	
	        var exercise, content, assignment, title, description, clipartReference, thumbUrl, assignmentFolderId, assignmentSubmitId, exerciseId, contentItemId, languageId, navBarTitle, thumbnailId, assignmentStatus;
	
	        if (response.languageId) languageId = response.languageId;
	
	        if (response.assignmentId) assignmentFolderId = response.assignmentId;
	
	        if (response.assignmentSubmitId) assignmentSubmitId = response.assignmentSubmitId;
	
	        if (response.exercise) exercise = response.exercise;
	
	        if (response.content) content = response.content;
	
	        if (response.assignment) assignment = response.assignment;
	
	        if (response.status) assignmentStatus = response.status.toUpperCase();
	
	        if (exercise) {
	            if (exercise.title) title = exercise.title;
	
	            if (exercise.title) navBarTitle = exercise.title;
	
	            if (exercise.description) description = this.correctDescription(exercise.description);
	
	            if (exercise.clipartReference) clipartReference = exercise.clipartReference;
	
	            if (exercise.thumbUrl) thumbUrl = exercise.thumbUrl;
	
	            if (exercise.exerciseId) exerciseId = exercise.exerciseId;
	
	            if (exercise.contentId) contentItemId = exercise.contentId;
	
	            if (exercise.thumbnailId) thumbnailId = exercise.thumbnailId;
	        }
	
	        if (content) {
	            if (content.contentItemId) contentItemId = content.contentItemId;
	
	            if (content.title) title = content.title;
	
	            if (!description && content.description) description = this.correctDescription(content.description);
	
	            if (content.clipartReference) clipartReference = content.clipartReference;
	
	            if (!thumbUrl && content.thumbUrl) thumbUrl = content.thumbUrl;
	        }
	
	        if (assignment) {
	            if (assignment.title) title = assignment.title;
	
	            if (assignment.description) description = this.correctDescription(assignment.description);
	
	            if (assignment.thumbUrl) thumbUrl = assignment.thumbUrl;
	
	            if (!exerciseId) {
	                contentItemId = this.checkThumbUrl(thumbUrl);
	            }
	
	            exerciseId = -1;
	        }
	
	        _AppParameters2.default.locale = this.detectLanguage(languageId);
	        _AppParameters2.default.title = title;
	        _AppParameters2.default.navBarDescription = description;
	        _AppParameters2.default.assignmentStatus = assignmentStatus;
	
	        var clipartMap = this.getClipartOldMap();
	
	        if (clipartMap[clipartReference] > 0) clipartReference = clipartMap[clipartReference];
	
	        if (_AppParameters2.default.isMaster) contentItemId = -1;
	
	        if (_AppParameters2.default.isExercise && exercise) {
	            if (exercise.hasContent == true) {
	                // keep the contentItemId ... the exercise has already content.
	            } else contentItemId = -1;
	        }
	
	        if (_AppParameters2.default.isMaster || clipartReference == _Configuration2.default.MASTER_CLIPART_ID_PROD || clipartReference == 62315556 || contentItemId == 62344225) {
	            if (_AppParameters2.default.locale == 'sv_SE') clipartReference = 70622606; // Sweden universe
	            else clipartReference = _Configuration2.default.DEFAULT_CLIPART_ID_PROD;
	        }
	
	        _AppParameters2.default.clipartId = clipartReference;
	
	        if (!navBarTitle) _AppParameters2.default.navBarTitle = title;else _AppParameters2.default.navBarTitle = navBarTitle;
	
	        if (!thumbnailId) _AppParameters2.default.navBarThumbnailId = contentItemId;else _AppParameters2.default.navBarThumbnailId = thumbnailId;
	
	        if (exerciseId) _AppParameters2.default.exerciseId = exerciseId;
	
	        if (contentItemId) _AppParameters2.default.contentItemId = contentItemId;
	
	        if (assignmentSubmitId) _AppParameters2.default.submitId = assignmentSubmitId;
	
	        if (assignmentFolderId) _AppParameters2.default.assignmentFolderId = assignmentFolderId;
	
	        if (_AppParameters2.default.isAudioToken) _AppParameters2.default.context = 'audioTool';else _AppParameters2.default.context = 'edit';
	
	        _AppParameters2.default.token = '';
	
	        _DataLoader2.default.loadData();
	    },
	    getClipartOldMap: function getClipartOldMap() {
	        var map = [];
	
	        map[865484] = 64097358;
	        map[864117] = 64097333;
	        map[865653] = 64097360;
	        map[58517840] = 64097352;
	        map[58517249] = 64097356;
	        map[58517269] = 64097354;
	        map[50939446] = 64097339;
	        map[861760] = 64097319;
	        map[860983] = 64097345;
	        map[861267] = 64097325;
	        map[57921281] = 64097341;
	        map[72824623] = 72824623;
	        map[987397] = 64097329;
	        map[2737291] = 64097327;
	        map[76704778] = 76704778;
	        map[50882819] = 64097331;
	        map[75986175] = 75986175;
	        map[40538208] = 64097321;
	        map[55453759] = 64097343;
	        map[13702456] = 64097323;
	        map[867648] = 64097362;
	        map[860833] = 64097364;
	        map[947174] = 64097366;
	        map[4669695] = 64097335;
	        map[861151] = 64097337;
	        map[58528002] = 64097347;
	        map[860919] = 64097368;
	        map[75431019] = 75431019;
	
	        return map;
	    },
	    correctDescription: function correctDescription(description) {
	        if (description.indexOf('Template: ') != -1) description = description.replace('Template: ', '');
	
	        return description;
	    },
	    checkThumbUrl: function checkThumbUrl(url) {
	        if (!url) return undefined;
	
	        var firstIndex = url.indexOf('file/ci/'),
	            endIndex = url.indexOf('/thumb'),
	            contentItemId;
	
	        if (firstIndex != -1 && endIndex != -1) contentItemId = url.substring(firstIndex + 8, endIndex);
	
	        return contentItemId;
	    },
	    detectLanguage: function detectLanguage(id) {
	        var language = "en_US";
	
	        switch (id) {
	            case 1:
	                {
	                    language = "nb_NO";
	                    break;
	                }
	
	            case 2:
	                {
	                    language = "en_US";
	                    break;
	                }
	
	            case 3:
	                {
	                    language = "nn_NO";
	                    break;
	                }
	
	            case 4:
	                {
	                    language = "fr_FR";
	                    break;
	                }
	
	            case 6:
	                {
	                    language = "de_DE";
	                    break;
	                }
	
	            case 7:
	                {
	                    language = "nl_NL";
	                    break;
	                }
	
	            case 8:
	                {
	                    language = "sv_SE";
	                    break;
	                }
	
	            case 9:
	                {
	                    language = "da_DK";
	                    break;
	                }
	
	            case 11:
	                {
	                    language = "fi_FI";
	                    break;
	                }
	
	            case 12:
	                {
	                    language = "es_ES";
	                    break;
	                }
	        }
	
	        return language;
	    },
	    isLoginWithToken: function isLoginWithToken() {
	        if (_AppParameters2.default.token && _AppParameters2.default.token.length > 0) return true;else return false;
	    }
	};
	
	exports.default = sessionUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SessionUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SessionUtils.js"); } } })();

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var shapeAspectRatioUtils = {
	    isShift: true,
	
	    checkShift: function checkShift(event) {
	        return; // keep aspect ratio
	
	        if (event.shiftKey == true) this.isShift = true;else this.isShift = false;
	    }
	};
	
	exports.default = shapeAspectRatioUtils;
	module.exports = exports["default"];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ShapeAspectRatioUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ShapeAspectRatioUtils.js"); } } })();

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _SessionActions = __webpack_require__(120);
	
	var _SessionActions2 = _interopRequireDefault(_SessionActions);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ExporterUtils = __webpack_require__(93);
	
	var _ExporterUtils2 = _interopRequireDefault(_ExporterUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var slidesPreloader = {
	    isPreloaded: false,
	    firstPreloadedSlides: _Configuration2.default.FIRST_PRELOADED_SLIDES,
	    slidesImages: [],
	    slidesAudios: [],
	    slidesAudiosEffects: [],
	    slidesVideos: [],
	    storySound: undefined,
	    storyItem: undefined,
	    audioItem: undefined,
	    audioEffectItem: undefined,
	    currentSlideIndex: 0,
	    slidesLength: 0,
	    videoElements: [],
	
	    storySoundLoaded: false,
	    audioSlideLoaded: false,
	    audioSlideEffectLoaded: false,
	    videoFromSlideLoaded: false,
	    currentSlideAssetsLength: 0,
	    currentSlideAssetsCounter: 0,
	
	    preloadAssets: function preloadAssets() {
	        var isEditor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        this.isEditor = isEditor;
	
	        if (this.isPreloaded) return;
	
	        _ExporterUtils2.default.init();
	        _VideoUtils2.default.updateVideoPreloader(true);
	
	        this.createAssetsList();
	        this.prepareAssets();
	        this.startPreloading();
	
	        this.isPreloaded = true;
	    },
	    createAssetsList: function createAssetsList() {
	        this.slidesVideos = [];
	        this.slidesAudiosEffects = [];
	        this.slidesAudios = [];
	        this.slidesImages = [];
	        this.videoElements = [];
	        this.currentSlideIndex = 0;
	        this.currentSlideAssetsLength = 0;
	        this.currentSlideAssetsCounter = 0;
	        this.storySound = undefined;
	        this.storyItem = undefined;
	        this.audioEffectItem = undefined;
	        this.audioEffectItem = undefined;
	        this.storySoundLoaded = false;
	        this.audioSlideLoaded = false;
	        this.audioSlideEffectLoaded = false;
	        this.videoFromSlideLoaded = false;
	
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var i;
	        var j;
	        var shapes;
	        var shape;
	        var assets = [];
	        var slidesAssets;
	        var storySound = state.production.storySound;
	
	        if (storySound && storySound.href && storySound.href.length > 0) {
	            this.storySound = storySound.href;
	        }
	
	        this.slidesLength = slides.length;
	
	        for (i = 0; i < slides.length; i++) {
	            shapes = slides[i].content;
	            slidesAssets = [];
	
	            // add all images from each slide
	            for (j = 0; j < shapes.length; j++) {
	                shape = shapes[j];
	
	                if (shape.type == _ShapeConstants2.default.BACKGROUND && shape.isVideo) continue;
	
	                //TODO -- should be included the assets from inside of a group
	                if (shape.type == _ShapeConstants2.default.BACKGROUND || shape.type == _ShapeConstants2.default.CHARACTER || shape.type == _ShapeConstants2.default.IMAGE) {
	                    if (shape.xlinkHref && shape.xlinkHref.length > 0 && assets.indexOf(shape.xlinkHref) < 0) {
	                        assets.push(shape.xlinkHref);
	                        slidesAssets.push(shape.xlinkHref);
	                    }
	                }
	            }
	
	            this.slidesImages.push(slidesAssets);
	
	            // add audio
	            var slideAudio = this.getSlideSoundSource(i);
	            this.slidesAudios.push(slideAudio);
	
	            // add audio effects
	            var slideAudioEffect = this.getSlideEffectSoundSource(i);
	            this.slidesAudiosEffects.push(slideAudioEffect);
	
	            // videos
	            this.slidesVideos.push(_VideoUtils2.default.getSlideVideoHref(i));
	        }
	    },
	    getSlideSoundSource: function getSlideSoundSource(index) {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var audio = slides[index].sound;
	        var audioWav = slides[index].soundWav;
	
	        if (audioWav != undefined && audioWav.length > 0) return audioWav;else {
	            if (audio != undefined && audio.length > 0) return audio;else return '';
	        }
	    },
	    getSlideEffectSoundSource: function getSlideEffectSoundSource(index) {
	        var state = _StoreManager2.default.getState();
	        var slides = state.production.slides;
	        var audio = slides[index].soundEffect;
	
	        if (audio != undefined && audio.length > 0) return audio;else return '';
	    },
	    prepareAssets: function prepareAssets() {
	        if (this.storySound && !this.storyItem) {
	            this.storyItem = document.createElement('AUDIO');
	            document.body.appendChild(this.storyItem);
	            this.storyItem.ondurationchange = this.onStoryItemLoaded.bind(this);
	        }
	
	        if (!this.audioItem) {
	            this.audioItem = document.createElement('AUDIO');
	            document.body.appendChild(this.audioItem);
	            this.audioItem.ondurationchange = this.onAudioItemLoaded.bind(this);
	        }
	
	        if (!this.audioEffectItem) {
	            this.audioEffectItem = document.createElement('AUDIO');
	            document.body.appendChild(this.audioEffectItem);
	            this.audioEffectItem.ondurationchange = this.onAudioEffectItemLoaded.bind(this);
	        }
	
	        var wrapper = document.createElement('div');
	        wrapper.id = 'preloaderWrapper';
	        wrapper.style.display = 'none';
	        document.body.appendChild(wrapper);
	
	        this.videoElements = [];
	
	        var videoWrapper = document.getElementById('multipleVideos');
	        videoWrapper.innerHTML = '';
	
	        var i;
	        var oldVideo = document.getElementById('videoBackground');
	        var currentIndex = _StoreManager2.default.getState().currentSlide.currentSlideIndex;
	        var videoHolder = document.createElement('div');
	
	        videoWrapper.appendChild(videoHolder);
	
	        if (oldVideo) oldVideo.style.display = 'none';
	
	        for (i = 0; i < this.slidesVideos.length; i++) {
	            var videoHref = this.slidesVideos[i];
	            var videoElement;
	
	            if (videoHref != '') {
	                videoElement = document.createElement('VIDEO');
	                videoElement.id = 'video_' + i;
	                videoElement.style.position = 'absolute';
	                videoElement.style.top = '0px';
	                videoElement.style.left = '0px';
	                videoElement.style.width = '800px';
	                videoElement.style.height = '450px';
	                videoElement.className = 'audioItem';
	                videoElement.preload = 'auto';
	                videoElement.playsinline = true;
	                videoElement.ondurationchange = this.onVideoItemLoaded.bind(this);
	
	                if (i != currentIndex) videoElement.style.display = 'none';
	
	                videoHolder.appendChild(videoElement);
	            }
	
	            this.videoElements.push(videoElement);
	        }
	    },
	    startPreloading: function startPreloading() {
	        this.loadAssetsFromSlide(this.currentSlideIndex);
	    },
	    loadAssetsFromSlide: function loadAssetsFromSlide() {
	        var index = this.currentSlideIndex;
	
	        if (index >= this.slidesLength) {
	            // finished loading all the slides
	            this.endPreloading();
	            return;
	        }
	
	        this.audioSlideLoaded = false;
	        this.audioSlideEffectLoaded = false;
	        this.videoFromSlideLoaded = false;
	
	        // story sound
	        if (this.storySound && index == 0) {
	            this.storySoundLoaded = false;
	            this.loadStorySound(this.storySound);
	        } else {
	            this.storySoundLoaded = true;
	        }
	
	        // slide sound
	        var slideAudio = this.slidesAudios[index];
	
	        if (slideAudio != '') this.loadAudio(slideAudio);else this.audioSlideLoaded = true;
	
	        // slide sound effect
	        var slideAudioEffect = this.slidesAudiosEffects[index];
	
	        if (slideAudioEffect != '') this.loadAudioEffect(slideAudioEffect);else this.audioSlideEffectLoaded = true;
	
	        // video from slide
	        var videoHref = this.slidesVideos[index];
	
	        if (videoHref != '') this.loadVideo(videoHref, index);else this.videoFromSlideLoaded = true;
	
	        // all the images from the current slide
	        var assetsFromSlide = this.slidesImages[index];
	        var i;
	
	        this.currentSlideAssetsLength = assetsFromSlide.length;
	        this.currentSlideAssetsCounter = 0;
	
	        for (i = 0; i < assetsFromSlide.length; i++) {
	            var url = assetsFromSlide[i];
	            this.loadImage(url);
	        }
	
	        this.checkIfCurrentSlideIsLoaded();
	    },
	
	
	    // audios
	    loadStorySound: function loadStorySound(url) {
	        if (this.storyItem) {
	            var audio = this.storyItem;
	            audio.src = _VideoUtils2.default.checkCacheBreaker(url);
	        }
	    },
	    onStoryItemLoaded: function onStoryItemLoaded() {
	        console.log('Preloaded story sound');
	
	        this.storySoundLoaded = true;
	        this.checkIfCurrentSlideIsLoaded();
	    },
	    loadAudio: function loadAudio(url) {
	        var audio = this.audioItem;
	        audio.src = _VideoUtils2.default.checkCacheBreaker(url);
	    },
	    loadAudioEffect: function loadAudioEffect(url) {
	        var audio = this.audioEffectItem;
	        audio.src = _VideoUtils2.default.checkCacheBreaker(url);
	    },
	    onAudioItemLoaded: function onAudioItemLoaded() {
	        console.log('Preloaded audio');
	
	        this.audioSlideLoaded = true;
	        this.checkIfCurrentSlideIsLoaded();
	    },
	    onAudioEffectItemLoaded: function onAudioEffectItemLoaded() {
	        console.log('Preloaded audio effect');
	
	        this.audioSlideEffectLoaded = true;
	        this.checkIfCurrentSlideIsLoaded();
	    },
	
	
	    //videos
	    loadVideo: function loadVideo(url, index) {
	        var video = this.videoElements[index];
	        video.src = _VideoUtils2.default.checkCacheBreaker(_VideoUtils2.default.getCorrectUrl(url));
	    },
	    onVideoItemLoaded: function onVideoItemLoaded() {
	        console.log('Preloaded video');
	
	        if (!this.videoFromSlideLoaded) {
	            this.videoFromSlideLoaded = true;
	            this.checkIfCurrentSlideIsLoaded();
	        } else this.videoFromSlideLoaded = true;
	    },
	
	
	    // images
	    loadImage: function loadImage(url) {
	        var imageObj = new Image();
	        var self = this;
	
	        imageObj.onload = function () {
	            self.currentSlideAssetsCounter = self.currentSlideAssetsCounter + 1;
	            self.checkIfCurrentSlideIsLoaded();
	        };
	
	        imageObj.onerror = function () {
	            self.currentSlideAssetsCounter = self.currentSlideAssetsCounter + 1;
	            self.checkIfCurrentSlideIsLoaded();
	        };
	
	        imageObj.src = _VideoUtils2.default.checkCacheBreaker(url);
	
	        var preloaderWrapper = document.getElementById('preloaderWrapper');
	        preloaderWrapper.appendChild(imageObj);
	    },
	    checkIfCurrentSlideIsLoaded: function checkIfCurrentSlideIsLoaded() {
	        if (this.storySoundLoaded && this.audioSlideLoaded && this.audioSlideEffectLoaded && this.videoFromSlideLoaded && this.currentSlideAssetsCounter >= this.currentSlideAssetsLength) {
	            // all the content from current slide is loaded
	            this.currentSlideIndex = this.currentSlideIndex + 1;
	
	            this.checkPreloader();
	            this.loadAssetsFromSlide();
	        }
	    },
	    checkPreloader: function checkPreloader() {
	        if (this.slidesLength >= this.firstPreloadedSlides && this.currentSlideIndex >= this.firstPreloadedSlides || this.slidesLength < this.firstPreloadedSlides && this.currentSlideIndex >= this.slidesLength) {
	            var store = _StoreManager2.default.getStore();
	
	            if (!this.isEditor) store.dispatch(_SessionActions2.default.setCaptionsLoaded());
	        }
	    },
	    endPreloading: function endPreloading() {
	        _VideoUtils2.default.updateVideoPreloader(false);
	
	        if (this.storyItem && this.storyItem.parentNode) document.body.removeChild(this.storyItem);
	
	        if (this.audioItem && this.audioItem.parentNode) document.body.removeChild(this.audioItem);
	
	        if (this.audioEffectItem && this.audioEffectItem.parentNode) document.body.removeChild(this.audioEffectItem);
	
	        _VideoUtils2.default.setInPoints();
	    },
	    exitPreview: function exitPreview() {
	        var multipleVideosWrapper = document.getElementById('multipleVideos');
	
	        if (multipleVideosWrapper) multipleVideosWrapper.innerHTML = '';
	
	        this.isPreloaded = false;
	
	        var oldVideo = document.getElementById('videoBackground');
	
	        if (oldVideo) oldVideo.style.display = 'block';
	    }
	};
	
	exports.default = slidesPreloader;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SlidesPreloader.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SlidesPreloader.js"); } } })();

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _AvailableFonts = __webpack_require__(175);
	
	var _AvailableFonts2 = _interopRequireDefault(_AvailableFonts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var slideParserUtils = {
	    getRotation: function getRotation(transform) {
	
	        if (transform == '' || transform.length < 1) return 0;
	
	        var pattern = /[-|+]?[0-9]*\.?[0-9]+/;
	        var rotation = Number(pattern.exec(transform)[0]);
	
	        if (isNaN(rotation)) return 0;
	
	        if (rotation > 360) rotation = rotation - 360;
	
	        return rotation;
	    },
	    dataToToughtPoints: function dataToToughtPoints(path) {
	        var points = [];
	        var index = path.indexOf('Q');
	        var moveStr = path.substr(1, index - 1);
	        var lineStr = path.substr(index, path.length - index);
	        var x = void 0;
	        var y = void 0;
	        var line = void 0;
	        var moves = moveStr.split(',');
	        var lines = lineStr.split('Q');
	
	        lines = lines.splice(1, lines.length - 1);
	        x = Number(moves[0]);
	        y = Number(moves[1]);
	
	        points.push({ x: x, y: y });
	
	        var length = lines.length;
	        var i = void 0;
	
	        for (i = 0; i < length; i++) {
	            line = lines[i].split(',');
	            x = Number(line[0]);
	            y = Number(line[1]);
	            points.push({ x: x, y: y });
	
	            x = Number(line[2]);
	            y = Number(line[3]);
	            points.push({ x: x, y: y });
	        }
	
	        return points;
	    },
	    dataToPoints: function dataToPoints(data) {
	        var points = [];
	        var index = data.indexOf('L');
	        var moveStr = data.substr(1, index - 1);
	        var linesStr = data.substr(index, data.length - index);
	        var x = void 0;
	        var y = void 0;
	        var line = void 0;
	        var moves = moveStr.split(',');
	        var lines = linesStr.split('L');
	
	        lines = lines.splice(1, lines.length - 1);
	        x = Number(moves[0]).toFixed(2);
	        y = Number(moves[1]).toFixed(2);
	
	        points.push({ x: x, y: y });
	
	        var length = lines.length;
	        var i = void 0;
	
	        for (i = 0; i < length; i++) {
	            line = lines[i].split(',');
	            x = Number(line[0]).toFixed(2);
	            y = Number(line[1]).toFixed(2);
	
	            points.push({ x: x, y: y });
	        }
	
	        return points;
	    },
	    getFreehandSize: function getFreehandSize(pathPoints) {
	        var xMin = pathPoints[0].x;
	        var xMax = pathPoints[0].x;
	        var yMin = pathPoints[0].y;
	        var yMax = pathPoints[0].y;
	        var i = void 0;
	        var length = pathPoints.length;
	
	        for (i = 1; i < length; i++) {
	            xMax = Math.max(xMax, pathPoints[i].x);
	            xMin = Math.min(xMin, pathPoints[i].x);
	            yMax = Math.max(yMax, pathPoints[i].y);
	            yMin = Math.min(yMin, pathPoints[i].y);
	        }
	
	        return {
	            x: xMin,
	            y: yMin,
	            width: Math.abs(xMax - xMin),
	            height: Math.abs(yMax - yMin)
	        };
	    },
	    converToLocalPathPoints: function converToLocalPathPoints(pathPoints, properties) {
	        var i = void 0;
	        var length = pathPoints.length;
	        var newPathPoints = [];
	        var xValue;
	        var yValue;
	
	        for (i = 1; i < length; i++) {
	            xValue = pathPoints[i].x - properties.x;
	            yValue = pathPoints[i].y - properties.y;
	
	            newPathPoints.push({ x: xValue.toFixed(2), y: yValue.toFixed(2) });
	        }
	
	        return newPathPoints;
	    },
	    getTextProperties: function getTextProperties(textArea) {
	        var fontFamily = _AvailableFonts2.default.defaultFont;
	        var fontAlign = 'left';
	        var fontColor = '#000000';
	        var fontSize = 12;
	        var fontBold = false;
	        var fontItalic = false;
	        var fontUnderline = false;
	        var htmlText = textArea.textContent;
	
	        var p = textArea.firstChild;
	
	        if (p) {
	            fontAlign = String(p.getAttribute('ALIGN')).toLowerCase();
	
	            var font = p.firstChild;
	
	            if (font) {
	                fontFamily = font.getAttribute('FACE');
	                fontSize = parseFloat(font.getAttribute('SIZE'));
	                fontColor = font.getAttribute('COLOR');
	
	                var fontContent = font.toString();
	
	                if (fontContent.indexOf('<U>') > 0) fontUnderline = true;
	
	                if (fontContent.indexOf('<B>') > 0) fontBold = true;
	
	                if (fontContent.indexOf('<I>') > 0) fontItalic = true;
	            }
	        }
	
	        fontFamily = this.getCorrectFont(fontFamily);
	
	        return {
	            fontFamily: fontFamily,
	            fontAlign: fontAlign,
	            fontColor: fontColor,
	            fontSize: fontSize,
	            fontBold: fontBold,
	            fontItalic: fontItalic,
	            fontUnderline: fontUnderline,
	            htmlText: htmlText
	        };
	    },
	    getCorrectFont: function getCorrectFont(font) {
	        var fonts = _AvailableFonts2.default.getAvailableFonts();
	
	        if (fonts.indexOf(font) < 0) return _AvailableFonts2.default.defaultFont;else return font;
	    }
	};
	
	exports.default = slideParserUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/parser/utils/SlideParserUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/parser/utils/SlideParserUtils.js"); } } })();

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["react-native-webview-messaging"]=t():e["react-native-webview-messaging"]=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=2)}([function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});t.RN_MESSAGES_CHANNEL_PREFIX="f251c210-e7c9-42fa-bae3-b9352ec3722a"},function(e,t,n){"use strict";function r(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function i(e){return"function"==typeof e}function s(e){return"number"==typeof e}function o(e){return"object"===(void 0===e?"undefined":f(e))&&null!==e}function u(e){return void 0===e}var f="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};e.exports=r,r.EventEmitter=r,r.prototype._events=void 0,r.prototype._maxListeners=void 0,r.defaultMaxListeners=10,r.prototype.setMaxListeners=function(e){if(!s(e)||e<0||isNaN(e))throw TypeError("n must be a positive number");return this._maxListeners=e,this},r.prototype.emit=function(e){var t,n,r,s,f,l;if(this._events||(this._events={}),"error"===e&&(!this._events.error||o(this._events.error)&&!this._events.error.length)){if((t=arguments[1])instanceof Error)throw t;var a=new Error('Uncaught, unspecified "error" event. ('+t+")");throw a.context=t,a}if(n=this._events[e],u(n))return!1;if(i(n))switch(arguments.length){case 1:n.call(this);break;case 2:n.call(this,arguments[1]);break;case 3:n.call(this,arguments[1],arguments[2]);break;default:s=Array.prototype.slice.call(arguments,1),n.apply(this,s)}else if(o(n))for(s=Array.prototype.slice.call(arguments,1),l=n.slice(),r=l.length,f=0;f<r;f++)l[f].apply(this,s);return!0},r.prototype.addListener=function(e,t){var n;if(!i(t))throw TypeError("listener must be a function");return this._events||(this._events={}),this._events.newListener&&this.emit("newListener",e,i(t.listener)?t.listener:t),this._events[e]?o(this._events[e])?this._events[e].push(t):this._events[e]=[this._events[e],t]:this._events[e]=t,o(this._events[e])&&!this._events[e].warned&&(n=u(this._maxListeners)?r.defaultMaxListeners:this._maxListeners)&&n>0&&this._events[e].length>n&&(this._events[e].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[e].length),"function"==typeof console.trace&&console.trace()),this},r.prototype.on=r.prototype.addListener,r.prototype.once=function(e,t){function n(){this.removeListener(e,n),r||(r=!0,t.apply(this,arguments))}if(!i(t))throw TypeError("listener must be a function");var r=!1;return n.listener=t,this.on(e,n),this},r.prototype.removeListener=function(e,t){var n,r,s,u;if(!i(t))throw TypeError("listener must be a function");if(!this._events||!this._events[e])return this;if(n=this._events[e],s=n.length,r=-1,n===t||i(n.listener)&&n.listener===t)delete this._events[e],this._events.removeListener&&this.emit("removeListener",e,t);else if(o(n)){for(u=s;u-- >0;)if(n[u]===t||n[u].listener&&n[u].listener===t){r=u;break}if(r<0)return this;1===n.length?(n.length=0,delete this._events[e]):n.splice(r,1),this._events.removeListener&&this.emit("removeListener",e,t)}return this},r.prototype.removeAllListeners=function(e){var t,n;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[e]&&delete this._events[e],this;if(0===arguments.length){for(t in this._events)"removeListener"!==t&&this.removeAllListeners(t);return this.removeAllListeners("removeListener"),this._events={},this}if(n=this._events[e],i(n))this.removeListener(e,n);else if(n)for(;n.length;)this.removeListener(e,n[n.length-1]);return delete this._events[e],this},r.prototype.listeners=function(e){return this._events&&this._events[e]?i(this._events[e])?[this._events[e]]:this._events[e].slice():[]},r.prototype.listenerCount=function(e){if(this._events){var t=this._events[e];if(i(t))return 1;if(t)return t.length}return 0},r.listenerCount=function(e,t){return e.listenerCount(t)}},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function o(e,t){return JSON.stringify({type:e,payload:t})}var u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=function e(t,n,r){null===t&&(t=Function.prototype);var i=Object.getOwnPropertyDescriptor(t,n);if(void 0===i){var s=Object.getPrototypeOf(t);return null===s?void 0:e(s,n,r)}if("value"in i)return i.value;var o=i.get;if(void 0!==o)return o.call(r)},l=n(1),a=function(e){return e&&e.__esModule?e:{default:e}}(l),c=n(0),p=function(e){function t(){return r(this,t),i(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return s(t,e),u(t,[{key:"sendJSON",value:function(e){window.postMessage(c.RN_MESSAGES_CHANNEL_PREFIX+o("json",e))}},{key:"send",value:function(e){window.postMessage(c.RN_MESSAGES_CHANNEL_PREFIX+o("text",e))}},{key:"emit",value:function(e,n,r){f(t.prototype.__proto__||Object.getPrototypeOf(t.prototype),"emit",this).call(this,e,n),r||window.postMessage(c.RN_MESSAGES_CHANNEL_PREFIX+JSON.stringify({type:"event",meta:{eventName:e},payload:n}))}}]),t}(a.default);window.RNMessagesChannel=new p,e.exports=window.RNMessagesChannel}])});

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(298);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ },
/* 379 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(94);
	
	var _PatternUtils = __webpack_require__(126);
	
	var _InternalPropTypes = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(177);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(179);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(391);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(909);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(386);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(177);
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(179);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(391);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(178);
	
	var _DOMUtils = __webpack_require__(248);
	
	var _createHistory = __webpack_require__(390);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(127);
	
	var _PathUtils = __webpack_require__(111);
	
	var _ExecutionEnvironment = __webpack_require__(178);
	
	var _DOMUtils = __webpack_require__(248);
	
	var _DOMStateStorage = __webpack_require__(387);
	
	var _createDOMHistory = __webpack_require__(388);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(640);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(111);
	
	var _AsyncUtils = __webpack_require__(906);
	
	var _Actions = __webpack_require__(127);
	
	var _createLocation2 = __webpack_require__(908);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(250);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(249);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(178);
	
	var _PathUtils = __webpack_require__(111);
	
	var _runTransitionHook = __webpack_require__(250);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(249);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(145),
	    _assign = __webpack_require__(251);
	
	var ReactNoopUpdateQueue = __webpack_require__(395);
	
	var canDefineProperty = __webpack_require__(396);
	var emptyObject = __webpack_require__(160);
	var invariant = __webpack_require__(19);
	var lowPriorityWarning = __webpack_require__(921);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(145);
	
	var ReactCurrentOwner = __webpack_require__(86);
	
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(29);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 394 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(29);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 397 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var repeat = exports.repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	
	var pad = exports.pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	
	var formatTime = exports.formatTime = function formatTime(time) {
	  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use performance API if it's available in order to get better precision
	var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ },
/* 398 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(210);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(935);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 400 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 401 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 402 */
/***/ function(module, exports) {

	/*
	 * DOM Level 2
	 * Object DOMException
	 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
	 */
	
	function copy(src,dest){
		for(var p in src){
			dest[p] = src[p];
		}
	}
	/**
	^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
	^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
	 */
	function _extends(Class,Super){
		var pt = Class.prototype;
		if(Object.create){
			var ppt = Object.create(Super.prototype)
			pt.__proto__ = ppt;
		}
		if(!(pt instanceof Super)){
			function t(){};
			t.prototype = Super.prototype;
			t = new t();
			copy(pt,t);
			Class.prototype = pt = t;
		}
		if(pt.constructor != Class){
			if(typeof Class != 'function'){
				console.error("unknow Class:"+Class)
			}
			pt.constructor = Class
		}
	}
	var htmlns = 'http://www.w3.org/1999/xhtml' ;
	// Node Types
	var NodeType = {}
	var ELEMENT_NODE                = NodeType.ELEMENT_NODE                = 1;
	var ATTRIBUTE_NODE              = NodeType.ATTRIBUTE_NODE              = 2;
	var TEXT_NODE                   = NodeType.TEXT_NODE                   = 3;
	var CDATA_SECTION_NODE          = NodeType.CDATA_SECTION_NODE          = 4;
	var ENTITY_REFERENCE_NODE       = NodeType.ENTITY_REFERENCE_NODE       = 5;
	var ENTITY_NODE                 = NodeType.ENTITY_NODE                 = 6;
	var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
	var COMMENT_NODE                = NodeType.COMMENT_NODE                = 8;
	var DOCUMENT_NODE               = NodeType.DOCUMENT_NODE               = 9;
	var DOCUMENT_TYPE_NODE          = NodeType.DOCUMENT_TYPE_NODE          = 10;
	var DOCUMENT_FRAGMENT_NODE      = NodeType.DOCUMENT_FRAGMENT_NODE      = 11;
	var NOTATION_NODE               = NodeType.NOTATION_NODE               = 12;
	
	// ExceptionCode
	var ExceptionCode = {}
	var ExceptionMessage = {};
	var INDEX_SIZE_ERR              = ExceptionCode.INDEX_SIZE_ERR              = ((ExceptionMessage[1]="Index size error"),1);
	var DOMSTRING_SIZE_ERR          = ExceptionCode.DOMSTRING_SIZE_ERR          = ((ExceptionMessage[2]="DOMString size error"),2);
	var HIERARCHY_REQUEST_ERR       = ExceptionCode.HIERARCHY_REQUEST_ERR       = ((ExceptionMessage[3]="Hierarchy request error"),3);
	var WRONG_DOCUMENT_ERR          = ExceptionCode.WRONG_DOCUMENT_ERR          = ((ExceptionMessage[4]="Wrong document"),4);
	var INVALID_CHARACTER_ERR       = ExceptionCode.INVALID_CHARACTER_ERR       = ((ExceptionMessage[5]="Invalid character"),5);
	var NO_DATA_ALLOWED_ERR         = ExceptionCode.NO_DATA_ALLOWED_ERR         = ((ExceptionMessage[6]="No data allowed"),6);
	var NO_MODIFICATION_ALLOWED_ERR = ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ((ExceptionMessage[7]="No modification allowed"),7);
	var NOT_FOUND_ERR               = ExceptionCode.NOT_FOUND_ERR               = ((ExceptionMessage[8]="Not found"),8);
	var NOT_SUPPORTED_ERR           = ExceptionCode.NOT_SUPPORTED_ERR           = ((ExceptionMessage[9]="Not supported"),9);
	var INUSE_ATTRIBUTE_ERR         = ExceptionCode.INUSE_ATTRIBUTE_ERR         = ((ExceptionMessage[10]="Attribute in use"),10);
	//level2
	var INVALID_STATE_ERR        	= ExceptionCode.INVALID_STATE_ERR        	= ((ExceptionMessage[11]="Invalid state"),11);
	var SYNTAX_ERR               	= ExceptionCode.SYNTAX_ERR               	= ((ExceptionMessage[12]="Syntax error"),12);
	var INVALID_MODIFICATION_ERR 	= ExceptionCode.INVALID_MODIFICATION_ERR 	= ((ExceptionMessage[13]="Invalid modification"),13);
	var NAMESPACE_ERR            	= ExceptionCode.NAMESPACE_ERR           	= ((ExceptionMessage[14]="Invalid namespace"),14);
	var INVALID_ACCESS_ERR       	= ExceptionCode.INVALID_ACCESS_ERR      	= ((ExceptionMessage[15]="Invalid access"),15);
	
	
	function DOMException(code, message) {
		if(message instanceof Error){
			var error = message;
		}else{
			error = this;
			Error.call(this, ExceptionMessage[code]);
			this.message = ExceptionMessage[code];
			if(Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
		}
		error.code = code;
		if(message) this.message = this.message + ": " + message;
		return error;
	};
	DOMException.prototype = Error.prototype;
	copy(ExceptionCode,DOMException)
	/**
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
	 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
	 * The items in the NodeList are accessible via an integral index, starting from 0.
	 */
	function NodeList() {
	};
	NodeList.prototype = {
		/**
		 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
		 * @standard level1
		 */
		length:0, 
		/**
		 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
		 * @standard level1
		 * @param index  unsigned long 
		 *   Index into the collection.
		 * @return Node
		 * 	The node at the indexth position in the NodeList, or null if that is not a valid index. 
		 */
		item: function(index) {
			return this[index] || null;
		},
		toString:function(isHTML,nodeFilter){
			for(var buf = [], i = 0;i<this.length;i++){
				serializeToString(this[i],buf,isHTML,nodeFilter);
			}
			return buf.join('');
		}
	};
	function LiveNodeList(node,refresh){
		this._node = node;
		this._refresh = refresh
		_updateLiveList(this);
	}
	function _updateLiveList(list){
		var inc = list._node._inc || list._node.ownerDocument._inc;
		if(list._inc != inc){
			var ls = list._refresh(list._node);
			//console.log(ls.length)
			__set__(list,'length',ls.length);
			copy(ls,list);
			list._inc = inc;
		}
	}
	LiveNodeList.prototype.item = function(i){
		_updateLiveList(this);
		return this[i];
	}
	
	_extends(LiveNodeList,NodeList);
	/**
	 * 
	 * Objects implementing the NamedNodeMap interface are used to represent collections of nodes that can be accessed by name. Note that NamedNodeMap does not inherit from NodeList; NamedNodeMaps are not maintained in any particular order. Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index, but this is simply to allow convenient enumeration of the contents of a NamedNodeMap, and does not imply that the DOM specifies an order to these Nodes.
	 * NamedNodeMap objects in the DOM are live.
	 * used for attributes or DocumentType entities 
	 */
	function NamedNodeMap() {
	};
	
	function _findNodeIndex(list,node){
		var i = list.length;
		while(i--){
			if(list[i] === node){return i}
		}
	}
	
	function _addNamedNode(el,list,newAttr,oldAttr){
		if(oldAttr){
			list[_findNodeIndex(list,oldAttr)] = newAttr;
		}else{
			list[list.length++] = newAttr;
		}
		if(el){
			newAttr.ownerElement = el;
			var doc = el.ownerDocument;
			if(doc){
				oldAttr && _onRemoveAttribute(doc,el,oldAttr);
				_onAddAttribute(doc,el,newAttr);
			}
		}
	}
	function _removeNamedNode(el,list,attr){
		//console.log('remove attr:'+attr)
		var i = _findNodeIndex(list,attr);
		if(i>=0){
			var lastIndex = list.length-1
			while(i<lastIndex){
				list[i] = list[++i]
			}
			list.length = lastIndex;
			if(el){
				var doc = el.ownerDocument;
				if(doc){
					_onRemoveAttribute(doc,el,attr);
					attr.ownerElement = null;
				}
			}
		}else{
			throw DOMException(NOT_FOUND_ERR,new Error(el.tagName+'@'+attr))
		}
	}
	NamedNodeMap.prototype = {
		length:0,
		item:NodeList.prototype.item,
		getNamedItem: function(key) {
	//		if(key.indexOf(':')>0 || key == 'xmlns'){
	//			return null;
	//		}
			//console.log()
			var i = this.length;
			while(i--){
				var attr = this[i];
				//console.log(attr.nodeName,key)
				if(attr.nodeName == key){
					return attr;
				}
			}
		},
		setNamedItem: function(attr) {
			var el = attr.ownerElement;
			if(el && el!=this._ownerElement){
				throw new DOMException(INUSE_ATTRIBUTE_ERR);
			}
			var oldAttr = this.getNamedItem(attr.nodeName);
			_addNamedNode(this._ownerElement,this,attr,oldAttr);
			return oldAttr;
		},
		/* returns Node */
		setNamedItemNS: function(attr) {// raises: WRONG_DOCUMENT_ERR,NO_MODIFICATION_ALLOWED_ERR,INUSE_ATTRIBUTE_ERR
			var el = attr.ownerElement, oldAttr;
			if(el && el!=this._ownerElement){
				throw new DOMException(INUSE_ATTRIBUTE_ERR);
			}
			oldAttr = this.getNamedItemNS(attr.namespaceURI,attr.localName);
			_addNamedNode(this._ownerElement,this,attr,oldAttr);
			return oldAttr;
		},
	
		/* returns Node */
		removeNamedItem: function(key) {
			var attr = this.getNamedItem(key);
			_removeNamedNode(this._ownerElement,this,attr);
			return attr;
			
			
		},// raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
		
		//for level2
		removeNamedItemNS:function(namespaceURI,localName){
			var attr = this.getNamedItemNS(namespaceURI,localName);
			_removeNamedNode(this._ownerElement,this,attr);
			return attr;
		},
		getNamedItemNS: function(namespaceURI, localName) {
			var i = this.length;
			while(i--){
				var node = this[i];
				if(node.localName == localName && node.namespaceURI == namespaceURI){
					return node;
				}
			}
			return null;
		}
	};
	/**
	 * @see http://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490
	 */
	function DOMImplementation(/* Object */ features) {
		this._features = {};
		if (features) {
			for (var feature in features) {
				 this._features = features[feature];
			}
		}
	};
	
	DOMImplementation.prototype = {
		hasFeature: function(/* string */ feature, /* string */ version) {
			var versions = this._features[feature.toLowerCase()];
			if (versions && (!version || version in versions)) {
				return true;
			} else {
				return false;
			}
		},
		// Introduced in DOM Level 2:
		createDocument:function(namespaceURI,  qualifiedName, doctype){// raises:INVALID_CHARACTER_ERR,NAMESPACE_ERR,WRONG_DOCUMENT_ERR
			var doc = new Document();
			doc.implementation = this;
			doc.childNodes = new NodeList();
			doc.doctype = doctype;
			if(doctype){
				doc.appendChild(doctype);
			}
			if(qualifiedName){
				var root = doc.createElementNS(namespaceURI,qualifiedName);
				doc.appendChild(root);
			}
			return doc;
		},
		// Introduced in DOM Level 2:
		createDocumentType:function(qualifiedName, publicId, systemId){// raises:INVALID_CHARACTER_ERR,NAMESPACE_ERR
			var node = new DocumentType();
			node.name = qualifiedName;
			node.nodeName = qualifiedName;
			node.publicId = publicId;
			node.systemId = systemId;
			// Introduced in DOM Level 2:
			//readonly attribute DOMString        internalSubset;
			
			//TODO:..
			//  readonly attribute NamedNodeMap     entities;
			//  readonly attribute NamedNodeMap     notations;
			return node;
		}
	};
	
	
	/**
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
	 */
	
	function Node() {
	};
	
	Node.prototype = {
		firstChild : null,
		lastChild : null,
		previousSibling : null,
		nextSibling : null,
		attributes : null,
		parentNode : null,
		childNodes : null,
		ownerDocument : null,
		nodeValue : null,
		namespaceURI : null,
		prefix : null,
		localName : null,
		// Modified in DOM Level 2:
		insertBefore:function(newChild, refChild){//raises 
			return _insertBefore(this,newChild,refChild);
		},
		replaceChild:function(newChild, oldChild){//raises 
			this.insertBefore(newChild,oldChild);
			if(oldChild){
				this.removeChild(oldChild);
			}
		},
		removeChild:function(oldChild){
			return _removeChild(this,oldChild);
		},
		appendChild:function(newChild){
			return this.insertBefore(newChild,null);
		},
		hasChildNodes:function(){
			return this.firstChild != null;
		},
		cloneNode:function(deep){
			return cloneNode(this.ownerDocument||this,this,deep);
		},
		// Modified in DOM Level 2:
		normalize:function(){
			var child = this.firstChild;
			while(child){
				var next = child.nextSibling;
				if(next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE){
					this.removeChild(next);
					child.appendData(next.data);
				}else{
					child.normalize();
					child = next;
				}
			}
		},
	  	// Introduced in DOM Level 2:
		isSupported:function(feature, version){
			return this.ownerDocument.implementation.hasFeature(feature,version);
		},
	    // Introduced in DOM Level 2:
	    hasAttributes:function(){
	    	return this.attributes.length>0;
	    },
	    lookupPrefix:function(namespaceURI){
	    	var el = this;
	    	while(el){
	    		var map = el._nsMap;
	    		//console.dir(map)
	    		if(map){
	    			for(var n in map){
	    				if(map[n] == namespaceURI){
	    					return n;
	    				}
	    			}
	    		}
	    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
	    	}
	    	return null;
	    },
	    // Introduced in DOM Level 3:
	    lookupNamespaceURI:function(prefix){
	    	var el = this;
	    	while(el){
	    		var map = el._nsMap;
	    		//console.dir(map)
	    		if(map){
	    			if(prefix in map){
	    				return map[prefix] ;
	    			}
	    		}
	    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
	    	}
	    	return null;
	    },
	    // Introduced in DOM Level 3:
	    isDefaultNamespace:function(namespaceURI){
	    	var prefix = this.lookupPrefix(namespaceURI);
	    	return prefix == null;
	    }
	};
	
	
	function _xmlEncoder(c){
		return c == '<' && '&lt;' ||
	         c == '>' && '&gt;' ||
	         c == '&' && '&amp;' ||
	         c == '"' && '&quot;' ||
	         '&#'+c.charCodeAt()+';'
	}
	
	
	copy(NodeType,Node);
	copy(NodeType,Node.prototype);
	
	/**
	 * @param callback return true for continue,false for break
	 * @return boolean true: break visit;
	 */
	function _visitNode(node,callback){
		if(callback(node)){
			return true;
		}
		if(node = node.firstChild){
			do{
				if(_visitNode(node,callback)){return true}
	        }while(node=node.nextSibling)
	    }
	}
	
	
	
	function Document(){
	}
	function _onAddAttribute(doc,el,newAttr){
		doc && doc._inc++;
		var ns = newAttr.namespaceURI ;
		if(ns == 'http://www.w3.org/2000/xmlns/'){
			//update namespace
			el._nsMap[newAttr.prefix?newAttr.localName:''] = newAttr.value
		}
	}
	function _onRemoveAttribute(doc,el,newAttr,remove){
		doc && doc._inc++;
		var ns = newAttr.namespaceURI ;
		if(ns == 'http://www.w3.org/2000/xmlns/'){
			//update namespace
			delete el._nsMap[newAttr.prefix?newAttr.localName:'']
		}
	}
	function _onUpdateChild(doc,el,newChild){
		if(doc && doc._inc){
			doc._inc++;
			//update childNodes
			var cs = el.childNodes;
			if(newChild){
				cs[cs.length++] = newChild;
			}else{
				//console.log(1)
				var child = el.firstChild;
				var i = 0;
				while(child){
					cs[i++] = child;
					child =child.nextSibling;
				}
				cs.length = i;
			}
		}
	}
	
	/**
	 * attributes;
	 * children;
	 * 
	 * writeable properties:
	 * nodeValue,Attr:value,CharacterData:data
	 * prefix
	 */
	function _removeChild(parentNode,child){
		var previous = child.previousSibling;
		var next = child.nextSibling;
		if(previous){
			previous.nextSibling = next;
		}else{
			parentNode.firstChild = next
		}
		if(next){
			next.previousSibling = previous;
		}else{
			parentNode.lastChild = previous;
		}
		_onUpdateChild(parentNode.ownerDocument,parentNode);
		return child;
	}
	/**
	 * preformance key(refChild == null)
	 */
	function _insertBefore(parentNode,newChild,nextChild){
		var cp = newChild.parentNode;
		if(cp){
			cp.removeChild(newChild);//remove and update
		}
		if(newChild.nodeType === DOCUMENT_FRAGMENT_NODE){
			var newFirst = newChild.firstChild;
			if (newFirst == null) {
				return newChild;
			}
			var newLast = newChild.lastChild;
		}else{
			newFirst = newLast = newChild;
		}
		var pre = nextChild ? nextChild.previousSibling : parentNode.lastChild;
	
		newFirst.previousSibling = pre;
		newLast.nextSibling = nextChild;
		
		
		if(pre){
			pre.nextSibling = newFirst;
		}else{
			parentNode.firstChild = newFirst;
		}
		if(nextChild == null){
			parentNode.lastChild = newLast;
		}else{
			nextChild.previousSibling = newLast;
		}
		do{
			newFirst.parentNode = parentNode;
		}while(newFirst !== newLast && (newFirst= newFirst.nextSibling))
		_onUpdateChild(parentNode.ownerDocument||parentNode,parentNode);
		//console.log(parentNode.lastChild.nextSibling == null)
		if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
			newChild.firstChild = newChild.lastChild = null;
		}
		return newChild;
	}
	function _appendSingleChild(parentNode,newChild){
		var cp = newChild.parentNode;
		if(cp){
			var pre = parentNode.lastChild;
			cp.removeChild(newChild);//remove and update
			var pre = parentNode.lastChild;
		}
		var pre = parentNode.lastChild;
		newChild.parentNode = parentNode;
		newChild.previousSibling = pre;
		newChild.nextSibling = null;
		if(pre){
			pre.nextSibling = newChild;
		}else{
			parentNode.firstChild = newChild;
		}
		parentNode.lastChild = newChild;
		_onUpdateChild(parentNode.ownerDocument,parentNode,newChild);
		return newChild;
		//console.log("__aa",parentNode.lastChild.nextSibling == null)
	}
	Document.prototype = {
		//implementation : null,
		nodeName :  '#document',
		nodeType :  DOCUMENT_NODE,
		doctype :  null,
		documentElement :  null,
		_inc : 1,
		
		insertBefore :  function(newChild, refChild){//raises 
			if(newChild.nodeType == DOCUMENT_FRAGMENT_NODE){
				var child = newChild.firstChild;
				while(child){
					var next = child.nextSibling;
					this.insertBefore(child,refChild);
					child = next;
				}
				return newChild;
			}
			if(this.documentElement == null && newChild.nodeType == ELEMENT_NODE){
				this.documentElement = newChild;
			}
			
			return _insertBefore(this,newChild,refChild),(newChild.ownerDocument = this),newChild;
		},
		removeChild :  function(oldChild){
			if(this.documentElement == oldChild){
				this.documentElement = null;
			}
			return _removeChild(this,oldChild);
		},
		// Introduced in DOM Level 2:
		importNode : function(importedNode,deep){
			return importNode(this,importedNode,deep);
		},
		// Introduced in DOM Level 2:
		getElementById :	function(id){
			var rtv = null;
			_visitNode(this.documentElement,function(node){
				if(node.nodeType == ELEMENT_NODE){
					if(node.getAttribute('id') == id){
						rtv = node;
						return true;
					}
				}
			})
			return rtv;
		},
		
		//document factory method:
		createElement :	function(tagName){
			var node = new Element();
			node.ownerDocument = this;
			node.nodeName = tagName;
			node.tagName = tagName;
			node.childNodes = new NodeList();
			var attrs	= node.attributes = new NamedNodeMap();
			attrs._ownerElement = node;
			return node;
		},
		createDocumentFragment :	function(){
			var node = new DocumentFragment();
			node.ownerDocument = this;
			node.childNodes = new NodeList();
			return node;
		},
		createTextNode :	function(data){
			var node = new Text();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createComment :	function(data){
			var node = new Comment();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createCDATASection :	function(data){
			var node = new CDATASection();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createProcessingInstruction :	function(target,data){
			var node = new ProcessingInstruction();
			node.ownerDocument = this;
			node.tagName = node.target = target;
			node.nodeValue= node.data = data;
			return node;
		},
		createAttribute :	function(name){
			var node = new Attr();
			node.ownerDocument	= this;
			node.name = name;
			node.nodeName	= name;
			node.localName = name;
			node.specified = true;
			return node;
		},
		createEntityReference :	function(name){
			var node = new EntityReference();
			node.ownerDocument	= this;
			node.nodeName	= name;
			return node;
		},
		// Introduced in DOM Level 2:
		createElementNS :	function(namespaceURI,qualifiedName){
			var node = new Element();
			var pl = qualifiedName.split(':');
			var attrs	= node.attributes = new NamedNodeMap();
			node.childNodes = new NodeList();
			node.ownerDocument = this;
			node.nodeName = qualifiedName;
			node.tagName = qualifiedName;
			node.namespaceURI = namespaceURI;
			if(pl.length == 2){
				node.prefix = pl[0];
				node.localName = pl[1];
			}else{
				//el.prefix = null;
				node.localName = qualifiedName;
			}
			attrs._ownerElement = node;
			return node;
		},
		// Introduced in DOM Level 2:
		createAttributeNS :	function(namespaceURI,qualifiedName){
			var node = new Attr();
			var pl = qualifiedName.split(':');
			node.ownerDocument = this;
			node.nodeName = qualifiedName;
			node.name = qualifiedName;
			node.namespaceURI = namespaceURI;
			node.specified = true;
			if(pl.length == 2){
				node.prefix = pl[0];
				node.localName = pl[1];
			}else{
				//el.prefix = null;
				node.localName = qualifiedName;
			}
			return node;
		}
	};
	_extends(Document,Node);
	
	
	function Element() {
		this._nsMap = {};
	};
	Element.prototype = {
		nodeType : ELEMENT_NODE,
		hasAttribute : function(name){
			return this.getAttributeNode(name)!=null;
		},
		getAttribute : function(name){
			var attr = this.getAttributeNode(name);
			return attr && attr.value || '';
		},
		getAttributeNode : function(name){
			return this.attributes.getNamedItem(name);
		},
		setAttribute : function(name, value){
			var attr = this.ownerDocument.createAttribute(name);
			attr.value = attr.nodeValue = "" + value;
			this.setAttributeNode(attr)
		},
		removeAttribute : function(name){
			var attr = this.getAttributeNode(name)
			attr && this.removeAttributeNode(attr);
		},
		
		//four real opeartion method
		appendChild:function(newChild){
			if(newChild.nodeType === DOCUMENT_FRAGMENT_NODE){
				return this.insertBefore(newChild,null);
			}else{
				return _appendSingleChild(this,newChild);
			}
		},
		setAttributeNode : function(newAttr){
			return this.attributes.setNamedItem(newAttr);
		},
		setAttributeNodeNS : function(newAttr){
			return this.attributes.setNamedItemNS(newAttr);
		},
		removeAttributeNode : function(oldAttr){
			//console.log(this == oldAttr.ownerElement)
			return this.attributes.removeNamedItem(oldAttr.nodeName);
		},
		//get real attribute name,and remove it by removeAttributeNode
		removeAttributeNS : function(namespaceURI, localName){
			var old = this.getAttributeNodeNS(namespaceURI, localName);
			old && this.removeAttributeNode(old);
		},
		
		hasAttributeNS : function(namespaceURI, localName){
			return this.getAttributeNodeNS(namespaceURI, localName)!=null;
		},
		getAttributeNS : function(namespaceURI, localName){
			var attr = this.getAttributeNodeNS(namespaceURI, localName);
			return attr && attr.value || '';
		},
		setAttributeNS : function(namespaceURI, qualifiedName, value){
			var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
			attr.value = attr.nodeValue = "" + value;
			this.setAttributeNode(attr)
		},
		getAttributeNodeNS : function(namespaceURI, localName){
			return this.attributes.getNamedItemNS(namespaceURI, localName);
		},
		
		getElementsByTagName : function(tagName){
			return new LiveNodeList(this,function(base){
				var ls = [];
				_visitNode(base,function(node){
					if(node !== base && node.nodeType == ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)){
						ls.push(node);
					}
				});
				return ls;
			});
		},
		getElementsByTagNameNS : function(namespaceURI, localName){
			return new LiveNodeList(this,function(base){
				var ls = [];
				_visitNode(base,function(node){
					if(node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)){
						ls.push(node);
					}
				});
				return ls;
				
			});
		}
	};
	Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
	Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;
	
	
	_extends(Element,Node);
	function Attr() {
	};
	Attr.prototype.nodeType = ATTRIBUTE_NODE;
	_extends(Attr,Node);
	
	
	function CharacterData() {
	};
	CharacterData.prototype = {
		data : '',
		substringData : function(offset, count) {
			return this.data.substring(offset, offset+count);
		},
		appendData: function(text) {
			text = this.data+text;
			this.nodeValue = this.data = text;
			this.length = text.length;
		},
		insertData: function(offset,text) {
			this.replaceData(offset,0,text);
		
		},
		appendChild:function(newChild){
			throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR])
		},
		deleteData: function(offset, count) {
			this.replaceData(offset,count,"");
		},
		replaceData: function(offset, count, text) {
			var start = this.data.substring(0,offset);
			var end = this.data.substring(offset+count);
			text = start + text + end;
			this.nodeValue = this.data = text;
			this.length = text.length;
		}
	}
	_extends(CharacterData,Node);
	function Text() {
	};
	Text.prototype = {
		nodeName : "#text",
		nodeType : TEXT_NODE,
		splitText : function(offset) {
			var text = this.data;
			var newText = text.substring(offset);
			text = text.substring(0, offset);
			this.data = this.nodeValue = text;
			this.length = text.length;
			var newNode = this.ownerDocument.createTextNode(newText);
			if(this.parentNode){
				this.parentNode.insertBefore(newNode, this.nextSibling);
			}
			return newNode;
		}
	}
	_extends(Text,CharacterData);
	function Comment() {
	};
	Comment.prototype = {
		nodeName : "#comment",
		nodeType : COMMENT_NODE
	}
	_extends(Comment,CharacterData);
	
	function CDATASection() {
	};
	CDATASection.prototype = {
		nodeName : "#cdata-section",
		nodeType : CDATA_SECTION_NODE
	}
	_extends(CDATASection,CharacterData);
	
	
	function DocumentType() {
	};
	DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
	_extends(DocumentType,Node);
	
	function Notation() {
	};
	Notation.prototype.nodeType = NOTATION_NODE;
	_extends(Notation,Node);
	
	function Entity() {
	};
	Entity.prototype.nodeType = ENTITY_NODE;
	_extends(Entity,Node);
	
	function EntityReference() {
	};
	EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
	_extends(EntityReference,Node);
	
	function DocumentFragment() {
	};
	DocumentFragment.prototype.nodeName =	"#document-fragment";
	DocumentFragment.prototype.nodeType =	DOCUMENT_FRAGMENT_NODE;
	_extends(DocumentFragment,Node);
	
	
	function ProcessingInstruction() {
	}
	ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
	_extends(ProcessingInstruction,Node);
	function XMLSerializer(){}
	XMLSerializer.prototype.serializeToString = function(node,isHtml,nodeFilter){
		return nodeSerializeToString.call(node,isHtml,nodeFilter);
	}
	Node.prototype.toString = nodeSerializeToString;
	function nodeSerializeToString(isHtml,nodeFilter){
		var buf = [];
		var refNode = this.nodeType == 9?this.documentElement:this;
		var prefix = refNode.prefix;
		var uri = refNode.namespaceURI;
		
		if(uri && prefix == null){
			//console.log(prefix)
			var prefix = refNode.lookupPrefix(uri);
			if(prefix == null){
				//isHTML = true;
				var visibleNamespaces=[
				{namespace:uri,prefix:null}
				//{namespace:uri,prefix:''}
				]
			}
		}
		serializeToString(this,buf,isHtml,nodeFilter,visibleNamespaces);
		//console.log('###',this.nodeType,uri,prefix,buf.join(''))
		return buf.join('');
	}
	function needNamespaceDefine(node,isHTML, visibleNamespaces) {
		var prefix = node.prefix||'';
		var uri = node.namespaceURI;
		if (!prefix && !uri){
			return false;
		}
		if (prefix === "xml" && uri === "http://www.w3.org/XML/1998/namespace" 
			|| uri == 'http://www.w3.org/2000/xmlns/'){
			return false;
		}
		
		var i = visibleNamespaces.length 
		//console.log('@@@@',node.tagName,prefix,uri,visibleNamespaces)
		while (i--) {
			var ns = visibleNamespaces[i];
			// get namespace prefix
			//console.log(node.nodeType,node.tagName,ns.prefix,prefix)
			if (ns.prefix == prefix){
				return ns.namespace != uri;
			}
		}
		//console.log(isHTML,uri,prefix=='')
		//if(isHTML && prefix ==null && uri == 'http://www.w3.org/1999/xhtml'){
		//	return false;
		//}
		//node.flag = '11111'
		//console.error(3,true,node.flag,node.prefix,node.namespaceURI)
		return true;
	}
	function serializeToString(node,buf,isHTML,nodeFilter,visibleNamespaces){
		if(nodeFilter){
			node = nodeFilter(node);
			if(node){
				if(typeof node == 'string'){
					buf.push(node);
					return;
				}
			}else{
				return;
			}
			//buf.sort.apply(attrs, attributeSorter);
		}
		switch(node.nodeType){
		case ELEMENT_NODE:
			if (!visibleNamespaces) visibleNamespaces = [];
			var startVisibleNamespaces = visibleNamespaces.length;
			var attrs = node.attributes;
			var len = attrs.length;
			var child = node.firstChild;
			var nodeName = node.tagName;
			
			isHTML =  (htmlns === node.namespaceURI) ||isHTML 
			buf.push('<',nodeName);
			
			
			
			for(var i=0;i<len;i++){
				// add namespaces for attributes
				var attr = attrs.item(i);
				if (attr.prefix == 'xmlns') {
					visibleNamespaces.push({ prefix: attr.localName, namespace: attr.value });
				}else if(attr.nodeName == 'xmlns'){
					visibleNamespaces.push({ prefix: '', namespace: attr.value });
				}
			}
			for(var i=0;i<len;i++){
				var attr = attrs.item(i);
				if (needNamespaceDefine(attr,isHTML, visibleNamespaces)) {
					var prefix = attr.prefix||'';
					var uri = attr.namespaceURI;
					var ns = prefix ? ' xmlns:' + prefix : " xmlns";
					buf.push(ns, '="' , uri , '"');
					visibleNamespaces.push({ prefix: prefix, namespace:uri });
				}
				serializeToString(attr,buf,isHTML,nodeFilter,visibleNamespaces);
			}
			// add namespace for current node		
			if (needNamespaceDefine(node,isHTML, visibleNamespaces)) {
				var prefix = node.prefix||'';
				var uri = node.namespaceURI;
				var ns = prefix ? ' xmlns:' + prefix : " xmlns";
				buf.push(ns, '="' , uri , '"');
				visibleNamespaces.push({ prefix: prefix, namespace:uri });
			}
			
			if(child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)){
				buf.push('>');
				//if is cdata child node
				if(isHTML && /^script$/i.test(nodeName)){
					while(child){
						if(child.data){
							buf.push(child.data);
						}else{
							serializeToString(child,buf,isHTML,nodeFilter,visibleNamespaces);
						}
						child = child.nextSibling;
					}
				}else
				{
					while(child){
						serializeToString(child,buf,isHTML,nodeFilter,visibleNamespaces);
						child = child.nextSibling;
					}
				}
				buf.push('</',nodeName,'>');
			}else{
				buf.push('/>');
			}
			// remove added visible namespaces
			//visibleNamespaces.length = startVisibleNamespaces;
			return;
		case DOCUMENT_NODE:
		case DOCUMENT_FRAGMENT_NODE:
			var child = node.firstChild;
			while(child){
				serializeToString(child,buf,isHTML,nodeFilter,visibleNamespaces);
				child = child.nextSibling;
			}
			return;
		case ATTRIBUTE_NODE:
			return buf.push(' ',node.name,'="',node.value.replace(/[<&"]/g,_xmlEncoder),'"');
		case TEXT_NODE:
			return buf.push(node.data.replace(/[<&]/g,_xmlEncoder));
		case CDATA_SECTION_NODE:
			return buf.push( '<![CDATA[',node.data,']]>');
		case COMMENT_NODE:
			return buf.push( "<!--",node.data,"-->");
		case DOCUMENT_TYPE_NODE:
			var pubid = node.publicId;
			var sysid = node.systemId;
			buf.push('<!DOCTYPE ',node.name);
			if(pubid){
				buf.push(' PUBLIC "',pubid);
				if (sysid && sysid!='.') {
					buf.push( '" "',sysid);
				}
				buf.push('">');
			}else if(sysid && sysid!='.'){
				buf.push(' SYSTEM "',sysid,'">');
			}else{
				var sub = node.internalSubset;
				if(sub){
					buf.push(" [",sub,"]");
				}
				buf.push(">");
			}
			return;
		case PROCESSING_INSTRUCTION_NODE:
			return buf.push( "<?",node.target," ",node.data,"?>");
		case ENTITY_REFERENCE_NODE:
			return buf.push( '&',node.nodeName,';');
		//case ENTITY_NODE:
		//case NOTATION_NODE:
		default:
			buf.push('??',node.nodeName);
		}
	}
	function importNode(doc,node,deep){
		var node2;
		switch (node.nodeType) {
		case ELEMENT_NODE:
			node2 = node.cloneNode(false);
			node2.ownerDocument = doc;
			//var attrs = node2.attributes;
			//var len = attrs.length;
			//for(var i=0;i<len;i++){
				//node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
			//}
		case DOCUMENT_FRAGMENT_NODE:
			break;
		case ATTRIBUTE_NODE:
			deep = true;
			break;
		//case ENTITY_REFERENCE_NODE:
		//case PROCESSING_INSTRUCTION_NODE:
		////case TEXT_NODE:
		//case CDATA_SECTION_NODE:
		//case COMMENT_NODE:
		//	deep = false;
		//	break;
		//case DOCUMENT_NODE:
		//case DOCUMENT_TYPE_NODE:
		//cannot be imported.
		//case ENTITY_NODE:
		//case NOTATION_NODE：
		//can not hit in level3
		//default:throw e;
		}
		if(!node2){
			node2 = node.cloneNode(false);//false
		}
		node2.ownerDocument = doc;
		node2.parentNode = null;
		if(deep){
			var child = node.firstChild;
			while(child){
				node2.appendChild(importNode(doc,child,deep));
				child = child.nextSibling;
			}
		}
		return node2;
	}
	//
	//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
	//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
	function cloneNode(doc,node,deep){
		var node2 = new node.constructor();
		for(var n in node){
			var v = node[n];
			if(typeof v != 'object' ){
				if(v != node2[n]){
					node2[n] = v;
				}
			}
		}
		if(node.childNodes){
			node2.childNodes = new NodeList();
		}
		node2.ownerDocument = doc;
		switch (node2.nodeType) {
		case ELEMENT_NODE:
			var attrs	= node.attributes;
			var attrs2	= node2.attributes = new NamedNodeMap();
			var len = attrs.length
			attrs2._ownerElement = node2;
			for(var i=0;i<len;i++){
				node2.setAttributeNode(cloneNode(doc,attrs.item(i),true));
			}
			break;;
		case ATTRIBUTE_NODE:
			deep = true;
		}
		if(deep){
			var child = node.firstChild;
			while(child){
				node2.appendChild(cloneNode(doc,child,deep));
				child = child.nextSibling;
			}
		}
		return node2;
	}
	
	function __set__(object,key,value){
		object[key] = value
	}
	//do dynamic
	try{
		if(Object.defineProperty){
			Object.defineProperty(LiveNodeList.prototype,'length',{
				get:function(){
					_updateLiveList(this);
					return this.$$length;
				}
			});
			Object.defineProperty(Node.prototype,'textContent',{
				get:function(){
					return getTextContent(this);
				},
				set:function(data){
					switch(this.nodeType){
					case ELEMENT_NODE:
					case DOCUMENT_FRAGMENT_NODE:
						while(this.firstChild){
							this.removeChild(this.firstChild);
						}
						if(data || String(data)){
							this.appendChild(this.ownerDocument.createTextNode(data));
						}
						break;
					default:
						//TODO:
						this.data = data;
						this.value = data;
						this.nodeValue = data;
					}
				}
			})
			
			function getTextContent(node){
				switch(node.nodeType){
				case ELEMENT_NODE:
				case DOCUMENT_FRAGMENT_NODE:
					var buf = [];
					node = node.firstChild;
					while(node){
						if(node.nodeType!==7 && node.nodeType !==8){
							buf.push(getTextContent(node));
						}
						node = node.nextSibling;
					}
					return buf.join('');
				default:
					return node.nodeValue;
				}
			}
			__set__ = function(object,key,value){
				//console.log(value)
				object['$$'+key] = value
			}
		}
	}catch(e){//ie8
	}
	
	//if(typeof require == 'function'){
		exports.DOMImplementation = DOMImplementation;
		exports.XMLSerializer = XMLSerializer;
	//}


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var AudioContext = window.AudioContext || window.webkitAudioContext
	
	function createWorker (fn) {
	  var js = fn
	    .toString()
	    .replace(/^function\s*\(\)\s*{/, '')
	    .replace(/}$/, '')
	  var blob = new Blob([js])
	  return new Worker(URL.createObjectURL(blob))
	}
	
	function error (method) {
	  var event = new Event('error')
	  event.data = new Error('Wrong state for ' + method)
	  return event
	}
	
	var context, processor
	
	/**
	 * Audio Recorder with MediaRecorder API.
	 *
	 * @param {MediaStream} stream The audio stream to record.
	 *
	 * @example
	 * navigator.mediaDevices.getUserMedia({ audio: true }).then(function (stream) {
	 *   var recorder = new MediaRecorder(stream)
	 * })
	 *
	 * @class
	 */
	function MediaRecorder (stream) {
	  /**
	   * The `MediaStream` passed into the constructor.
	   * @type {MediaStream}
	   */
	  this.stream = stream
	
	  /**
	   * The current state of recording process.
	   * @type {"inactive"|"recording"|"paused"}
	   */
	  this.state = 'inactive'
	
	  this.em = document.createDocumentFragment()
	  this.encoder = createWorker(MediaRecorder.encoder)
	
	  var recorder = this
	  this.encoder.addEventListener('message', function (e) {
	    var event = new Event('dataavailable')
	    event.data = new Blob([e.data], { type: recorder.mimeType })
	    recorder.em.dispatchEvent(event)
	    if (recorder.state === 'inactive') {
	      recorder.em.dispatchEvent(new Event('stop'))
	    }
	  })
	}
	
	MediaRecorder.prototype = {
	  /**
	   * The MIME type that is being used for recording.
	   * @type {string}
	   */
	  mimeType: 'audio/wav',
	
	  /**
	   * Begins recording media.
	   *
	   * @param {number} [timeslice] The milliseconds to record into each `Blob`.
	   *                             If this parameter isn’t included, single `Blob`
	   *                             will be recorded.
	   *
	   * @return {undefined}
	   *
	   * @example
	   * recordButton.addEventListener('click', function () {
	   *   recorder.start()
	   * })
	   */
	  start: function start (timeslice) {
	    if (this.state !== 'inactive') {
	      return this.em.dispatchEvent(error('start'))
	    }
	
	    this.state = 'recording'
	
	    if (!context) {
	      context = new AudioContext()
	    }
	    this.clone = this.stream.clone()
	    var input = context.createMediaStreamSource(this.clone)
	
	    if (!processor) {
	      processor = context.createScriptProcessor(2048, 1, 1)
	    }
	
	    var recorder = this
	    processor.onaudioprocess = function (e) {
	      if (recorder.state === 'recording') {
	        recorder.encoder.postMessage([
	          'encode', e.inputBuffer.getChannelData(0)
	        ])
	      }
	    }
	
	    input.connect(processor)
	    processor.connect(context.destination)
	
	    this.em.dispatchEvent(new Event('start'))
	
	    if (timeslice) {
	      this.slicing = setInterval(function () {
	        if (recorder.state === 'recording') recorder.requestData()
	      }, timeslice)
	    }
	
	    return undefined
	  },
	
	  /**
	   * Stop media capture and raise `dataavailable` event with recorded data.
	   *
	   * @return {undefined}
	   *
	   * @example
	   * finishButton.addEventListener('click', function () {
	   *   recorder.stop()
	   * })
	   */
	  stop: function stop () {
	    if (this.state === 'inactive') {
	      return this.em.dispatchEvent(error('stop'))
	    }
	
	    this.requestData()
	    this.state = 'inactive'
	    this.clone.getTracks().forEach(function (track) {
	      track.stop()
	    })
	    return clearInterval(this.slicing)
	  },
	
	  /**
	   * Pauses recording of media streams.
	   *
	   * @return {undefined}
	   *
	   * @example
	   * pauseButton.addEventListener('click', function () {
	   *   recorder.pause()
	   * })
	   */
	  pause: function pause () {
	    if (this.state !== 'recording') {
	      return this.em.dispatchEvent(error('pause'))
	    }
	
	    this.state = 'paused'
	    return this.em.dispatchEvent(new Event('pause'))
	  },
	
	  /**
	   * Resumes media recording when it has been previously paused.
	   *
	   * @return {undefined}
	   *
	   * @example
	   * resumeButton.addEventListener('click', function () {
	   *   recorder.resume()
	   * })
	   */
	  resume: function resume () {
	    if (this.state !== 'paused') {
	      return this.em.dispatchEvent(error('resume'))
	    }
	
	    this.state = 'recording'
	    return this.em.dispatchEvent(new Event('resume'))
	  },
	
	  /**
	   * Raise a `dataavailable` event containing the captured media.
	   *
	   * @return {undefined}
	   *
	   * @example
	   * this.on('nextData', function () {
	   *   recorder.requestData()
	   * })
	   */
	  requestData: function requestData () {
	    if (this.state === 'inactive') {
	      return this.em.dispatchEvent(error('requestData'))
	    }
	
	    return this.encoder.postMessage(['dump', context.sampleRate])
	  },
	
	  /**
	   * Add listener for specified event type.
	   *
	   * @param {"start"|"stop"|"pause"|"resume"|"dataavailable"|"error"}
	   * type Event type.
	   * @param {function} listener The listener function.
	   *
	   * @return {undefined}
	   *
	   * @example
	   * recorder.addEventListener('dataavailable', function (e) {
	   *   audio.src = URL.createObjectURL(e.data)
	   * })
	   */
	  addEventListener: function addEventListener () {
	    this.em.addEventListener.apply(this.em, arguments)
	  },
	
	  /**
	   * Remove event listener.
	   *
	   * @param {"start"|"stop"|"pause"|"resume"|"dataavailable"|"error"}
	   * type Event type.
	   * @param {function} listener The same function used in `addEventListener`.
	   *
	   * @return {undefined}
	   */
	  removeEventListener: function removeEventListener () {
	    this.em.removeEventListener.apply(this.em, arguments)
	  },
	
	  /**
	   * Calls each of the listeners registered for a given event.
	   *
	   * @param {Event} event The event object.
	   *
	   * @return {boolean} Is event was no canceled by any listener.
	   */
	  dispatchEvent: function dispatchEvent () {
	    this.em.dispatchEvent.apply(this.em, arguments)
	  }
	}
	
	/**
	 * Returns `true` if the MIME type specified is one the polyfill can record.
	 *
	 * This polyfill supports `audio/wav` and `audio/mpeg`.
	 *
	 * @param {string} mimeType The mimeType to check.
	 *
	 * @return {boolean} `true` on `audio/wav` and `audio/mpeg` MIME type.
	 */
	MediaRecorder.isTypeSupported = function isTypeSupported (mimeType) {
	  return MediaRecorder.prototype.mimeType === mimeType
	}
	
	/**
	 * `true` if MediaRecorder can not be polyfilled in the current browser.
	 * @type {boolean}
	 *
	 * @example
	 * if (MediaRecorder.notSupported) {
	 *   showWarning('Audio recording is not supported in this browser')
	 * }
	 */
	MediaRecorder.notSupported = !navigator.mediaDevices || !AudioContext
	
	/**
	 * Converts RAW audio buffer to compressed audio files.
	 * It will be loaded to Web Worker.
	 * By default, WAVE encoder will be used.
	 * @type {function}
	 *
	 * @example
	 * MediaRecorder.prototype.mimeType = 'audio/ogg'
	 * MediaRecorder.encoder = oggEncoder
	 */
	MediaRecorder.encoder = __webpack_require__(404)
	
	module.exports = MediaRecorder


/***/ },
/* 404 */
/***/ function(module, exports) {

	// Copied from https://github.com/chris-rudmin/Recorderjs
	
	module.exports = function () {
	  var BYTES_PER_SAMPLE = 2
	
	  var recorded = []
	
	  function encode (buffer) {
	    var length = buffer.length
	    var data = new Uint8Array(length * BYTES_PER_SAMPLE)
	    for (var i = 0; i < length; i++) {
	      var index = i * BYTES_PER_SAMPLE
	      var sample = buffer[i]
	      if (sample > 1) {
	        sample = 1
	      } else if (sample < -1) {
	        sample = -1
	      }
	      sample = sample * 32768
	      data[index] = sample
	      data[index + 1] = sample >> 8
	    }
	    recorded.push(data)
	  }
	
	  function dump (sampleRate) {
	    var bufferLength = recorded.length ? recorded[0].length : 0
	    var length = recorded.length * bufferLength
	    var wav = new Uint8Array(44 + length)
	    var view = new DataView(wav.buffer)
	
	    // RIFF identifier 'RIFF'
	    view.setUint32(0, 1380533830, false)
	    // file length minus RIFF identifier length and file description length
	    view.setUint32(4, 36 + length, true)
	    // RIFF type 'WAVE'
	    view.setUint32(8, 1463899717, false)
	    // format chunk identifier 'fmt '
	    view.setUint32(12, 1718449184, false)
	    // format chunk length
	    view.setUint32(16, 16, true)
	    // sample format (raw)
	    view.setUint16(20, 1, true)
	    // channel count
	    view.setUint16(22, 1, true)
	    // sample rate
	    view.setUint32(24, sampleRate, true)
	    // byte rate (sample rate * block align)
	    view.setUint32(28, sampleRate * BYTES_PER_SAMPLE, true)
	    // block align (channel count * bytes per sample)
	    view.setUint16(32, BYTES_PER_SAMPLE, true)
	    // bits per sample
	    view.setUint16(34, 8 * BYTES_PER_SAMPLE, true)
	    // data chunk identifier 'data'
	    view.setUint32(36, 1684108385, false)
	    // data chunk length
	    view.setUint32(40, length, true)
	
	    for (var i = 0; i < recorded.length; i++) {
	      wav.set(recorded[i], i * bufferLength + 44)
	    }
	
	    recorded = []
	    postMessage(wav.buffer, [wav.buffer])
	  }
	
	  onmessage = function (e) {
	    if (e.data[0] === 'encode') {
	      encode(e.data[1])
	    } else {
	      dump(e.data[1])
	    }
	  }
	}


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(636);
	
	__webpack_require__(932);
	
	__webpack_require__(437);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 406 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = __webpack_require__(430);
	var Queue = __webpack_require__(427);
	var util = __webpack_require__(33);
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ },
/* 408 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = __webpack_require__(423)();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = __webpack_require__(33);
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (true) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	    if (true) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = __webpack_require__(33);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise._isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent._isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            promise._setWillBeCancelled();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this._isCancellable()) return;
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype._isCancellable = function() {
	    return this.isPending() && !this._isCancelled();
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this._isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};


/***/ },
/* 412 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = __webpack_require__(87).Warning;
	var util = __webpack_require__(33);
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
	var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (false ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    var self = this;
	    setTimeout(function() {
	        self._notifyUnhandledRejection();
	    }, 1);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        if (typeof CustomEvent === "function") {
	            var event = new CustomEvent("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new CustomEvent(name.toLowerCase(), {
	                    detail: event,
	                    cancelable: true
	                });
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else if (typeof Event === "function") {
	            var event = new Event("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new Event(name.toLowerCase(), {
	                    cancelable: true
	                });
	                domEvent.detail = event;
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else {
	            var event = document.createEvent("CustomEvent");
	            event.initCustomEvent("testingtheevent", false, true, {});
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = document.createEvent("CustomEvent");
	                domEvent.initCustomEvent(name.toLowerCase(), false, true,
	                    event);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        }
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	    return Promise;
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this._isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var handlerLine = "";
	        var creatorLine = "";
	        if (promiseCreated._trace) {
	            var traceLines = promiseCreated._trace.stack.split("\n");
	            var stack = cleanStack(traceLines);
	            for (var i = stack.length - 1; i >= 0; --i) {
	                var line = stack[i];
	                if (!nodeFramePattern.test(line)) {
	                    var lineMatches = line.match(parseLinePattern);
	                    if (lineMatches) {
	                        handlerLine  = "at " + lineMatches[1] +
	                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
	                    }
	                    break;
	                }
	            }
	
	            if (stack.length > 0) {
	                var firstUserLine = stack[0];
	                for (var i = 0; i < traceLines.length; ++i) {
	
	                    if (traceLines[i] === firstUserLine) {
	                        if (i > 0) {
	                            creatorLine = "\n" + traceLines[i - 1];
	                        }
	                        break;
	                    }
	                }
	
	            }
	        }
	        var msg = "a promise was created in a " + name +
	            "handler " + handlerLine + "but was not returned from it, " +
	            "see http://goo.gl/rRqMUw" +
	            creatorLine;
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0 && error.name != "SyntaxError") {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ },
/* 414 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};


/***/ },
/* 415 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	var PromiseAll = Promise.all;
	
	function promiseAllThis() {
	    return PromiseAll(this);
	}
	
	function PromiseMapSeries(promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
	}
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, this, undefined);
	};
	
	Promise.prototype.mapSeries = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, promises, undefined);
	};
	
	Promise.mapSeries = PromiseMapSeries;
	};
	


/***/ },
/* 416 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
	var util = __webpack_require__(33);
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	var catchFilter = __webpack_require__(254)(NEXT_FILTER);
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret === NEXT_FILTER) {
	            return ret;
	        } else if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise._isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	Promise.prototype.tapCatch = function (handlerOrPredicate) {
	    var len = arguments.length;
	    if(len === 1) {
	        return this._passThrough(handlerOrPredicate,
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    } else {
	         var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(new TypeError(
	                    "tapCatch statement predicate: "
	                    + "expecting an object but got " + util.classString(item)
	                ));
	            }
	        }
	        catchInstances.length = j;
	        var handler = arguments[i];
	        return this._passThrough(catchFilter(catchInstances, handler, this),
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    }
	
	};
	
	return PassThroughHandlerContext;
	};


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise,
	                          Proxyable,
	                          debug) {
	var errors = __webpack_require__(87);
	var TypeError = errors.TypeError;
	var util = __webpack_require__(33);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    if (debug.cancellation()) {
	        var internal = new Promise(INTERNAL);
	        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
	        this._promise = internal.lastly(function() {
	            return _finallyPromise;
	        });
	        internal._captureStackTrace();
	        internal._setOnCancel(this);
	    } else {
	        var promise = this._promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	    }
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	    this._yieldedPromise = null;
	    this._cancellationPhase = false;
	}
	util.inherits(PromiseSpawn, Proxyable);
	
	PromiseSpawn.prototype._isResolved = function() {
	    return this._promise === null;
	};
	
	PromiseSpawn.prototype._cleanup = function() {
	    this._promise = this._generator = null;
	    if (debug.cancellation() && this._finallyPromise !== null) {
	        this._finallyPromise._fulfill();
	        this._finallyPromise = null;
	    }
	};
	
	PromiseSpawn.prototype._promiseCancelled = function() {
	    if (this._isResolved()) return;
	    var implementsReturn = typeof this._generator["return"] !== "undefined";
	
	    var result;
	    if (!implementsReturn) {
	        var reason = new Promise.CancellationError(
	            "generator .return() sentinel");
	        Promise.coroutine.returnSentinel = reason;
	        this._promise._attachExtraTrace(reason);
	        this._promise._pushContext();
	        result = tryCatch(this._generator["throw"]).call(this._generator,
	                                                         reason);
	        this._promise._popContext();
	    } else {
	        this._promise._pushContext();
	        result = tryCatch(this._generator["return"]).call(this._generator,
	                                                          undefined);
	        this._promise._popContext();
	    }
	    this._cancellationPhase = true;
	    this._yieldedPromise = null;
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseFulfilled = function(value) {
	    this._yieldedPromise = null;
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseRejected = function(reason) {
	    this._yieldedPromise = null;
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._resultCancelled = function() {
	    if (this._yieldedPromise instanceof Promise) {
	        var promise = this._yieldedPromise;
	        this._yieldedPromise = null;
	        promise.cancel();
	    }
	};
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._promiseFulfilled(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    var promise = this._promise;
	    if (result === errorObj) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._rejectCallback(result.e, false);
	        }
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._resolveCallback(value);
	        }
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._promiseRejected(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise = maybePromise._target();
	        var bitField = maybePromise._bitField;
	        ;
	        if (((bitField & 50397184) === 0)) {
	            this._yieldedPromise = maybePromise;
	            maybePromise._proxy(this, null);
	        } else if (((bitField & 33554432) !== 0)) {
	            Promise._async.invoke(
	                this._promiseFulfilled, this, maybePromise._value()
	            );
	        } else if (((bitField & 16777216) !== 0)) {
	            Promise._async.invoke(
	                this._promiseRejected, this, maybePromise._reason()
	            );
	        } else {
	            this._promiseCancelled();
	        }
	    }
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        var ret = spawn.promise();
	        spawn._generator = generator;
	        spawn._promiseFulfilled(undefined);
	        return ret;
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
	         getDomain) {
	var util = __webpack_require__(33);
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (true) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", "async", code)
	                           (tryCatch, errorObj, Promise, async);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (true) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                            holder.asyncNeeded = false;
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	
	                if (!ret._isFateSealed()) {
	                    if (holder.asyncNeeded) {
	                        var domain = getDomain();
	                        if (domain !== null) {
	                            holder.fn = util.domainBind(domain, holder.fn);
	                        }
	                    }
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];};
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(33);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : util.domainBind(domain, fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = [];
	    async.invoke(this._asyncInit, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	
	MappingPromiseArray.prototype._asyncInit = function() {
	    this._init$(undefined, -2);
	};
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	
	    if (index < 0) {
	        index = (index * -1) - 1;
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return true;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return false;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var promise = this._promise;
	        var callback = this._callback;
	        var receiver = promise._boundValue();
	        promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        var promiseCreated = promise._popContext();
	        debug.checkForgottenReturns(
	            ret,
	            promiseCreated,
	            preservedValues !== null ? "Promise.filter" : "Promise.map",
	            promise
	        );
	        if (ret === errorObj) {
	            this._reject(ret.e);
	            return true;
	        }
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            var bitField = maybePromise._bitField;
	            ;
	            if (((bitField & 50397184) === 0)) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = maybePromise;
	                maybePromise._proxy(this, (index + 1) * -1);
	                return false;
	            } else if (((bitField & 33554432) !== 0)) {
	                ret = maybePromise._value();
	            } else if (((bitField & 16777216) !== 0)) {
	                this._reject(maybePromise._reason());
	                return true;
	            } else {
	                this._cancel();
	                return true;
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	        return true;
	    }
	    return false;
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	
	    var limit = 0;
	    if (options !== undefined) {
	        if (typeof options === "object" && options !== null) {
	            if (typeof options.concurrency !== "number") {
	                return Promise.reject(
	                    new TypeError("'concurrency' must be a number but it is " +
	                                    util.classString(options.concurrency)));
	            }
	            limit = options.concurrency;
	        } else {
	            return Promise.reject(new TypeError(
	                            "options argument must be an object but it is " +
	                             util.classString(options)));
	        }
	    }
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
	}
	
	Promise.prototype.map = function (fn, options) {
	    return map(this, fn, options, null);
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    return map(promises, fn, options, _filter);
	};
	
	
	};


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = __webpack_require__(33);
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise) {
	var util = __webpack_require__(33);
	var async = Promise._async;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var newReason = new Error(reason + "");
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
	                                                                     options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = __webpack_require__(33);
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = __webpack_require__(112);
	var Async = __webpack_require__(407);
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = __webpack_require__(87);
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = __webpack_require__(434)(Promise, INTERNAL);
	var PromiseArray =
	    __webpack_require__(424)(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = __webpack_require__(412)(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = __webpack_require__(413)(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    __webpack_require__(417)(Promise, tryConvertToPromise, NEXT_FILTER);
	var catchFilter = __webpack_require__(254)(NEXT_FILTER);
	var nodebackForPromise = __webpack_require__(255);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (self == null || self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	
	}
	
	function Promise(executor) {
	    if (executor !== INTERNAL) {
	        check(this, executor);
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._resolveFromExecutor(executor);
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("Catch statement predicate: " +
	                    "expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" &&
	                    util.domainBind(domain, handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setWillBeCancelled = function() {
	    this._bitField = this._bitField | 8388608;
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    if (executor === INTERNAL) return;
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	__webpack_require__(421)(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	__webpack_require__(408)(Promise, INTERNAL, tryConvertToPromise, debug);
	__webpack_require__(411)(Promise, PromiseArray, apiRejection, debug);
	__webpack_require__(414)(Promise);
	__webpack_require__(433)(Promise);
	__webpack_require__(419)(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
	Promise.Promise = Promise;
	Promise.version = "3.5.1";
	__webpack_require__(420)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(410)(Promise);
	__webpack_require__(436)(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
	__webpack_require__(435)(Promise, INTERNAL, debug);
	__webpack_require__(418)(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
	__webpack_require__(422)(Promise);
	__webpack_require__(425)(Promise, INTERNAL);
	__webpack_require__(426)(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	__webpack_require__(428)(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	__webpack_require__(429)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(431)(Promise, PromiseArray, debug);
	__webpack_require__(432)(Promise, PromiseArray, apiRejection);
	__webpack_require__(416)(Promise, INTERNAL);
	__webpack_require__(415)(Promise, INTERNAL);
	__webpack_require__(406)(Promise);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = __webpack_require__(33);
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    case -6: return new Map();
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise._isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = __webpack_require__(33);
	var nodebackForPromise = __webpack_require__(255);
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = __webpack_require__(87).TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (true) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn, _, multiArgs) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	    var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode);
	    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL",
	                        body)(
	                    Promise,
	                    fn,
	                    receiver,
	                    withAppended,
	                    maybeWrapAsError,
	                    nodebackForPromise,
	                    util.tryCatch,
	                    util.errorObj,
	                    util.notEnumerableProp,
	                    INTERNAL);
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise, multiArgs);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key,
	                                           fn, suffix, multiArgs);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver, multiArgs) {
	    return makeNodePromisified(callback, receiver, undefined,
	                                callback, null, multiArgs);
	}
	
	Promise.promisify = function (fn, options) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    options = Object(options);
	    var receiver = options.context === undefined ? THIS : options.context;
	    var multiArgs = !!options.multiArgs;
	    var ret = promisify(fn, receiver, multiArgs);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    options = Object(options);
	    var multiArgs = !!options.multiArgs;
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier,
	                multiArgs);
	            promisifyAll(value, suffix, filter, promisifier, multiArgs);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
	};
	};
	


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(33);
	var isObject = util.isObject;
	var es5 = __webpack_require__(112);
	var Es6Map;
	if (typeof Map === "function") Es6Map = Map;
	
	var mapToEntries = (function() {
	    var index = 0;
	    var size = 0;
	
	    function extractEntry(value, key) {
	        this[index] = value;
	        this[index + size] = key;
	        index++;
	    }
	
	    return function mapToEntries(map) {
	        size = map.size;
	        index = 0;
	        var ret = new Array(map.size * 2);
	        map.forEach(extractEntry, ret);
	        return ret;
	    };
	})();
	
	var entriesToMap = function(entries) {
	    var ret = new Es6Map();
	    var length = entries.length / 2 | 0;
	    for (var i = 0; i < length; ++i) {
	        var key = entries[length + i];
	        var value = entries[i];
	        ret.set(key, value);
	    }
	    return ret;
	};
	
	function PropertiesPromiseArray(obj) {
	    var isMap = false;
	    var entries;
	    if (Es6Map !== undefined && obj instanceof Es6Map) {
	        entries = mapToEntries(obj);
	        isMap = true;
	    } else {
	        var keys = es5.keys(obj);
	        var len = keys.length;
	        entries = new Array(len * 2);
	        for (var i = 0; i < len; ++i) {
	            var key = keys[i];
	            entries[i] = obj[key];
	            entries[i + len] = key;
	        }
	    }
	    this.constructor$(entries);
	    this._isMap = isMap;
	    this._init$(undefined, isMap ? -6 : -3);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val;
	        if (this._isMap) {
	            val = entriesToMap(this._values);
	        } else {
	            val = {};
	            var keyOffset = this.length();
	            for (var i = 0, len = this.length(); i < len; ++i) {
	                val[this._values[i + keyOffset]] = this._values[i];
	            }
	        }
	        this._resolve(val);
	        return true;
	    }
	    return false;
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 2);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};


/***/ },
/* 427 */
/***/ function(module, exports) {

	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(33);
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else {
	        promises = util.asArray(promises);
	        if (promises === null)
	            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 3);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(33);
	var tryCatch = util.tryCatch;
	
	function ReductionPromiseArray(promises, fn, initialValue, _each) {
	    this.constructor$(promises);
	    var domain = getDomain();
	    this._fn = domain === null ? fn : util.domainBind(domain, fn);
	    if (initialValue !== undefined) {
	        initialValue = Promise.resolve(initialValue);
	        initialValue._attachCancellationCallback(this);
	    }
	    this._initialValue = initialValue;
	    this._currentCancellable = null;
	    if(_each === INTERNAL) {
	        this._eachValues = Array(this._length);
	    } else if (_each === 0) {
	        this._eachValues = null;
	    } else {
	        this._eachValues = undefined;
	    }
	    this._promise._captureStackTrace();
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._gotAccum = function(accum) {
	    if (this._eachValues !== undefined && 
	        this._eachValues !== null && 
	        accum !== INTERNAL) {
	        this._eachValues.push(accum);
	    }
	};
	
	ReductionPromiseArray.prototype._eachComplete = function(value) {
	    if (this._eachValues !== null) {
	        this._eachValues.push(value);
	    }
	    return this._eachValues;
	};
	
	ReductionPromiseArray.prototype._init = function() {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function() {
	    this._resolve(this._eachValues !== undefined ? this._eachValues
	                                                 : this._initialValue);
	};
	
	ReductionPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	ReductionPromiseArray.prototype._resolve = function(value) {
	    this._promise._resolveCallback(value);
	    this._values = null;
	};
	
	ReductionPromiseArray.prototype._resultCancelled = function(sender) {
	    if (sender === this._initialValue) return this._cancel();
	    if (this._isResolved()) return;
	    this._resultCancelled$();
	    if (this._currentCancellable instanceof Promise) {
	        this._currentCancellable.cancel();
	    }
	    if (this._initialValue instanceof Promise) {
	        this._initialValue.cancel();
	    }
	};
	
	ReductionPromiseArray.prototype._iterate = function (values) {
	    this._values = values;
	    var value;
	    var i;
	    var length = values.length;
	    if (this._initialValue !== undefined) {
	        value = this._initialValue;
	        i = 0;
	    } else {
	        value = Promise.resolve(values[0]);
	        i = 1;
	    }
	
	    this._currentCancellable = value;
	
	    if (!value.isRejected()) {
	        for (; i < length; ++i) {
	            var ctx = {
	                accum: null,
	                value: values[i],
	                index: i,
	                length: length,
	                array: this
	            };
	            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
	        }
	    }
	
	    if (this._eachValues !== undefined) {
	        value = value
	            ._then(this._eachComplete, undefined, undefined, this, undefined);
	    }
	    value._then(completed, completed, undefined, value, this);
	};
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	
	function completed(valueOrReason, array) {
	    if (this.isFulfilled()) {
	        array._resolve(valueOrReason);
	    } else {
	        array._reject(valueOrReason);
	    }
	}
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	function gotAccum(accum) {
	    this.accum = accum;
	    this.array._gotAccum(accum);
	    var value = tryConvertToPromise(this.value, this.array._promise);
	    if (value instanceof Promise) {
	        this.array._currentCancellable = value;
	        return value._then(gotValue, undefined, undefined, this, undefined);
	    } else {
	        return gotValue.call(this, value);
	    }
	}
	
	function gotValue(value) {
	    var array = this.array;
	    var promise = array._promise;
	    var fn = tryCatch(array._fn);
	    promise._pushContext();
	    var ret;
	    if (array._eachValues !== undefined) {
	        ret = fn.call(promise._boundValue(), value, this.index, this.length);
	    } else {
	        ret = fn.call(promise._boundValue(),
	                              this.accum, value, this.index, this.length);
	    }
	    if (ret instanceof Promise) {
	        array._currentCancellable = ret;
	    }
	    var promiseCreated = promise._popContext();
	    debug.checkForgottenReturns(
	        ret,
	        promiseCreated,
	        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
	        promise
	    );
	    return ret;
	}
	};


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, setImmediate) {"use strict";
	var util = __webpack_require__(33);
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function" &&
	           typeof NativePromise.resolve === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            (window.navigator.standalone || window.cordova))) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	            toggleScheduled = true;
	            div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(90), __webpack_require__(253).setImmediate))

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	    function(Promise, PromiseArray, debug) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = __webpack_require__(33);
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 33554432;
	    ret._settledValueField = value;
	    return this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 16777216;
	    ret._settledValueField = reason;
	    return this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    debug.deprecated(".settle()", ".reflect()");
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return Promise.settle(this);
	};
	};


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = __webpack_require__(33);
	var RangeError = __webpack_require__(87).RangeError;
	var AggregateError = __webpack_require__(87).AggregateError;
	var isArray = util.isArray;
	var CANCELLATION = {};
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	        return true;
	    }
	    return false;
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._promiseCancelled = function () {
	    if (this._values instanceof Promise || this._values == null) {
	        return this._cancel();
	    }
	    this._addRejected(CANCELLATION);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._checkOutcome = function() {
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            if (this._values[i] !== CANCELLATION) {
	                e.push(this._values[i]);
	            }
	        }
	        if (e.length > 0) {
	            this._reject(e);
	        } else {
	            this._cancel();
	        }
	        return true;
	    }
	    return false;
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};


/***/ },
/* 433 */
/***/ function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled = function() {
	    return (this._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.__isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype._isCancelled = function() {
	    return this._target().__isCancelled();
	};
	
	Promise.prototype.isCancelled = function() {
	    return (this._target()._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = __webpack_require__(33);
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, debug) {
	var util = __webpack_require__(33);
	var TimeoutError = Promise.TimeoutError;
	
	function HandleWrapper(handle)  {
	    this.handle = handle;
	}
	
	HandleWrapper.prototype._resultCancelled = function() {
	    clearTimeout(this.handle);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (ms, value) {
	    var ret;
	    var handle;
	    if (value !== undefined) {
	        ret = Promise.resolve(value)
	                ._then(afterValue, null, null, ms, undefined);
	        if (debug.cancellation() && value instanceof Promise) {
	            ret._setOnCancel(value);
	        }
	    } else {
	        ret = new Promise(INTERNAL);
	        handle = setTimeout(function() { ret._fulfill(); }, +ms);
	        if (debug.cancellation()) {
	            ret._setOnCancel(new HandleWrapper(handle));
	        }
	        ret._captureStackTrace();
	    }
	    ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(ms, this);
	};
	
	var afterTimeout = function (promise, message, parent) {
	    var err;
	    if (typeof message !== "string") {
	        if (message instanceof Error) {
	            err = message;
	        } else {
	            err = new TimeoutError("operation timed out");
	        }
	    } else {
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._reject(err);
	
	    if (parent != null) {
	        parent.cancel();
	    }
	};
	
	function successClear(value) {
	    clearTimeout(this.handle);
	    return value;
	}
	
	function failureClear(reason) {
	    clearTimeout(this.handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret, parent;
	
	    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
	        if (ret.isPending()) {
	            afterTimeout(ret, message, parent);
	        }
	    }, ms));
	
	    if (debug.cancellation()) {
	        parent = this.then();
	        ret = parent._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	        ret._setOnCancel(handleWrapper);
	    } else {
	        ret = this._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	    }
	
	    return ret;
	};
	
	};


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext, INTERNAL, debug) {
	    var util = __webpack_require__(33);
	    var TypeError = __webpack_require__(87).TypeError;
	    var inherits = __webpack_require__(33).inherits;
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var NULL = {};
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = new Promise(INTERNAL);
	        function iterator() {
	            if (i >= len) return ret._fulfill();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret;
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return NULL;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== NULL
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    function ResourceList(length) {
	        this.length = length;
	        this.promise = null;
	        this[length-1] = null;
	    }
	
	    ResourceList.prototype._resultCancelled = function() {
	        var len = this.length;
	        for (var i = 0; i < len; ++i) {
	            var item = this[i];
	            if (item instanceof Promise) {
	                item.cancel();
	            }
	        }
	    };
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new ResourceList(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var reflectedResources = new Array(resources.length);
	        for (var i = 0; i < reflectedResources.length; ++i) {
	            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
	        }
	
	        var resultPromise = Promise.all(reflectedResources)
	            .then(function(inspections) {
	                for (var i = 0; i < inspections.length; ++i) {
	                    var inspection = inspections[i];
	                    if (inspection.isRejected()) {
	                        errorObj.e = inspection.error();
	                        return errorObj;
	                    } else if (!inspection.isFulfilled()) {
	                        resultPromise.cancel();
	                        return;
	                    }
	                    inspections[i] = inspection.value();
	                }
	                promise._pushContext();
	
	                fn = tryCatch(fn);
	                var ret = spreadArgs
	                    ? fn.apply(undefined, inspections) : fn(inspections);
	                var promiseCreated = promise._popContext();
	                debug.checkForgottenReturns(
	                    ret, promiseCreated, "Promise.using", promise);
	                return ret;
	            });
	
	        var promise = resultPromise.lastly(function() {
	            var inspection = new Promise.PromiseInspection(resultPromise);
	            return dispose(resources, inspection);
	        });
	        resources.promise = promise;
	        promise._setOnCancel(resources);
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 131072;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 131072) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~131072);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(444);
	module.exports = __webpack_require__(74).RegExp.escape;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(28);
	var isArray = __webpack_require__(150);
	var SPECIES = __webpack_require__(34)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(26);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(22);
	var toPrimitive = __webpack_require__(78);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(100);
	var gOPS = __webpack_require__(154);
	var pIE = __webpack_require__(132);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 442 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 443 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(4);
	var $re = __webpack_require__(442)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(257) });
	
	__webpack_require__(88)('copyWithin');


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $every = __webpack_require__(73)(4);
	
	$export($export.P + $export.F * !__webpack_require__(71)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Array', { fill: __webpack_require__(180) });
	
	__webpack_require__(88)('fill');


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $filter = __webpack_require__(73)(2);
	
	$export($export.P + $export.F * !__webpack_require__(71)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(4);
	var $find = __webpack_require__(73)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(88)(KEY);


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(4);
	var $find = __webpack_require__(73)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(88)(KEY);


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $forEach = __webpack_require__(73)(0);
	var STRICT = __webpack_require__(71)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(70);
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(48);
	var call = __webpack_require__(268);
	var isArrayIter = __webpack_require__(188);
	var toLength = __webpack_require__(45);
	var createProperty = __webpack_require__(182);
	var getIterFn = __webpack_require__(205);
	
	$export($export.S + $export.F * !__webpack_require__(152)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $indexOf = __webpack_require__(146)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(71)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(150) });


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(65);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(131) != Object || !__webpack_require__(71)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(65);
	var toInteger = __webpack_require__(77);
	var toLength = __webpack_require__(45);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(71)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $map = __webpack_require__(73)(1);
	
	$export($export.P + $export.F * !__webpack_require__(71)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var createProperty = __webpack_require__(182);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(26)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $reduce = __webpack_require__(259);
	
	$export($export.P + $export.F * !__webpack_require__(71)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $reduce = __webpack_require__(259);
	
	$export($export.P + $export.F * !__webpack_require__(71)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var html = __webpack_require__(186);
	var cof = __webpack_require__(69);
	var toAbsoluteIndex = __webpack_require__(104);
	var toLength = __webpack_require__(45);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(26)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $some = __webpack_require__(73)(3);
	
	$export($export.P + $export.F * !__webpack_require__(71)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(55);
	var toObject = __webpack_require__(48);
	var fails = __webpack_require__(26);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(71)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(103)('Array');


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(4);
	var toISOString = __webpack_require__(439);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(48);
	var toPrimitive = __webpack_require__(78);
	
	$export($export.P + $export.F * __webpack_require__(26)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(34)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(59)(proto, TO_PRIMITIVE, __webpack_require__(440));


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(60)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Function', { bind: __webpack_require__(260) });


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(28);
	var getPrototypeOf = __webpack_require__(64);
	var HAS_INSTANCE = __webpack_require__(34)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(44).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(44).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(43) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(4);
	var log1p = __webpack_require__(271);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(4);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(4);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(4);
	var sign = __webpack_require__(192);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(4);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(4);
	var $expm1 = __webpack_require__(191);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { fround: __webpack_require__(270) });


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(4);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(4);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(26)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(271) });


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { sign: __webpack_require__(192) });


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(4);
	var expm1 = __webpack_require__(191);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(26)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(4);
	var expm1 = __webpack_require__(191);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(24);
	var has = __webpack_require__(58);
	var cof = __webpack_require__(69);
	var inheritIfRequired = __webpack_require__(187);
	var toPrimitive = __webpack_require__(78);
	var fails = __webpack_require__(26);
	var gOPN = __webpack_require__(99).f;
	var gOPD = __webpack_require__(63).f;
	var dP = __webpack_require__(44).f;
	var $trim = __webpack_require__(115).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(98)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(43) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(60)(global, NUMBER, $Number);
	}


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(4);
	var _isFinite = __webpack_require__(24).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(267) });


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(4);
	var isInteger = __webpack_require__(267);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseFloat = __webpack_require__(279);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseInt = __webpack_require__(280);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toInteger = __webpack_require__(77);
	var aNumberValue = __webpack_require__(256);
	var repeat = __webpack_require__(199);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(26)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $fails = __webpack_require__(26);
	var aNumberValue = __webpack_require__(256);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(4);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(273) });


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(98) });


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(43), 'Object', { defineProperties: __webpack_require__(274) });


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(43), 'Object', { defineProperty: __webpack_require__(44).f });


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(28);
	var meta = __webpack_require__(89).onFreeze;
	
	__webpack_require__(76)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(65);
	var $getOwnPropertyDescriptor = __webpack_require__(63).f;
	
	__webpack_require__(76)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(76)('getOwnPropertyNames', function () {
	  return __webpack_require__(275).f;
	});


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(48);
	var $getPrototypeOf = __webpack_require__(64);
	
	__webpack_require__(76)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(28);
	
	__webpack_require__(76)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(28);
	
	__webpack_require__(76)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(28);
	
	__webpack_require__(76)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(4);
	$export($export.S, 'Object', { is: __webpack_require__(443) });


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(48);
	var $keys = __webpack_require__(100);
	
	__webpack_require__(76)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(28);
	var meta = __webpack_require__(89).onFreeze;
	
	__webpack_require__(76)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(28);
	var meta = __webpack_require__(89).onFreeze;
	
	__webpack_require__(76)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(4);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(195).set });


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(130);
	var test = {};
	test[__webpack_require__(34)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(60)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseFloat = __webpack_require__(279);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseInt = __webpack_require__(280);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(97);
	var global = __webpack_require__(24);
	var ctx = __webpack_require__(70);
	var classof = __webpack_require__(130);
	var $export = __webpack_require__(4);
	var isObject = __webpack_require__(28);
	var aFunction = __webpack_require__(55);
	var anInstance = __webpack_require__(95);
	var forOf = __webpack_require__(96);
	var speciesConstructor = __webpack_require__(158);
	var task = __webpack_require__(201).set;
	var microtask = __webpack_require__(193)();
	var newPromiseCapabilityModule = __webpack_require__(194);
	var perform = __webpack_require__(281);
	var promiseResolve = __webpack_require__(282);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(34)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(102)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(114)($Promise, PROMISE);
	__webpack_require__(103)(PROMISE);
	Wrapper = __webpack_require__(74)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(152)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(55);
	var anObject = __webpack_require__(22);
	var rApply = (__webpack_require__(24).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(26)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(4);
	var create = __webpack_require__(98);
	var aFunction = __webpack_require__(55);
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(28);
	var fails = __webpack_require__(26);
	var bind = __webpack_require__(260);
	var rConstruct = (__webpack_require__(24).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(44);
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(22);
	var toPrimitive = __webpack_require__(78);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(26)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(4);
	var gOPD = __webpack_require__(63).f;
	var anObject = __webpack_require__(22);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(22);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(189)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(63);
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(22);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(4);
	var getProto = __webpack_require__(64);
	var anObject = __webpack_require__(22);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(63);
	var getPrototypeOf = __webpack_require__(64);
	var has = __webpack_require__(58);
	var $export = __webpack_require__(4);
	var isObject = __webpack_require__(28);
	var anObject = __webpack_require__(22);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(22);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(278) });


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(22);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(4);
	var setProto = __webpack_require__(195);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(44);
	var gOPD = __webpack_require__(63);
	var getPrototypeOf = __webpack_require__(64);
	var has = __webpack_require__(58);
	var $export = __webpack_require__(4);
	var createDesc = __webpack_require__(101);
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(28);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var inheritIfRequired = __webpack_require__(187);
	var dP = __webpack_require__(44).f;
	var gOPN = __webpack_require__(99).f;
	var isRegExp = __webpack_require__(151);
	var $flags = __webpack_require__(149);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(43) && (!CORRECT_NEW || __webpack_require__(26)(function () {
	  re2[__webpack_require__(34)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(60)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(103)('RegExp');


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(148)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(148)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(148)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(148)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(151);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(287);
	var anObject = __webpack_require__(22);
	var $flags = __webpack_require__(149);
	var DESCRIPTORS = __webpack_require__(43);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(60)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(26)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(61)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(61)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(61)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(61)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $at = __webpack_require__(197)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(4);
	var toLength = __webpack_require__(45);
	var context = __webpack_require__(198);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(185)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(61)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(61)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(61)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var toAbsoluteIndex = __webpack_require__(104);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(4);
	var context = __webpack_require__(198);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(185)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(61)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(197)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(190)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(61)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(65);
	var toLength = __webpack_require__(45);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(199)
	});


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(61)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(4);
	var toLength = __webpack_require__(45);
	var context = __webpack_require__(198);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(185)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(61)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(61)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(61)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(115)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(24);
	var has = __webpack_require__(58);
	var DESCRIPTORS = __webpack_require__(43);
	var $export = __webpack_require__(4);
	var redefine = __webpack_require__(60);
	var META = __webpack_require__(89).KEY;
	var $fails = __webpack_require__(26);
	var shared = __webpack_require__(157);
	var setToStringTag = __webpack_require__(114);
	var uid = __webpack_require__(105);
	var wks = __webpack_require__(34);
	var wksExt = __webpack_require__(285);
	var wksDefine = __webpack_require__(204);
	var enumKeys = __webpack_require__(441);
	var isArray = __webpack_require__(150);
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(28);
	var toIObject = __webpack_require__(65);
	var toPrimitive = __webpack_require__(78);
	var createDesc = __webpack_require__(101);
	var _create = __webpack_require__(98);
	var gOPNExt = __webpack_require__(275);
	var $GOPD = __webpack_require__(63);
	var $DP = __webpack_require__(44);
	var $keys = __webpack_require__(100);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(99).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(132).f = $propertyIsEnumerable;
	  __webpack_require__(154).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(97)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(59)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $typed = __webpack_require__(159);
	var buffer = __webpack_require__(202);
	var anObject = __webpack_require__(22);
	var toAbsoluteIndex = __webpack_require__(104);
	var toLength = __webpack_require__(45);
	var isObject = __webpack_require__(28);
	var ArrayBuffer = __webpack_require__(24).ArrayBuffer;
	var speciesConstructor = __webpack_require__(158);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(26)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(103)(ARRAY_BUFFER);


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	$export($export.G + $export.W + $export.F * !__webpack_require__(159).ABV, {
	  DataView: __webpack_require__(202).DataView
	});


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(83)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(263);
	var validate = __webpack_require__(116);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(147)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(4);
	var flattenIntoArray = __webpack_require__(264);
	var toObject = __webpack_require__(48);
	var toLength = __webpack_require__(45);
	var aFunction = __webpack_require__(55);
	var arraySpeciesCreate = __webpack_require__(181);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(88)('flatMap');


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(4);
	var flattenIntoArray = __webpack_require__(264);
	var toObject = __webpack_require__(48);
	var toLength = __webpack_require__(45);
	var toInteger = __webpack_require__(77);
	var arraySpeciesCreate = __webpack_require__(181);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(88)('flatten');


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(4);
	var $includes = __webpack_require__(146)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(88)('includes');


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(4);
	var microtask = __webpack_require__(193)();
	var process = __webpack_require__(24).process;
	var isNode = __webpack_require__(69)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(4);
	var cof = __webpack_require__(69);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(4);
	
	$export($export.G, { global: __webpack_require__(24) });


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(155)('Map');


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(156)('Map');


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(4);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(262)('Map') });


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	var scale = __webpack_require__(272);
	var fround = __webpack_require__(270);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { scale: __webpack_require__(272) });


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(48);
	var aFunction = __webpack_require__(55);
	var $defineProperty = __webpack_require__(44);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(43) && $export($export.P + __webpack_require__(153), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(48);
	var aFunction = __webpack_require__(55);
	var $defineProperty = __webpack_require__(44);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(43) && $export($export.P + __webpack_require__(153), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(4);
	var $entries = __webpack_require__(277)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(4);
	var ownKeys = __webpack_require__(278);
	var toIObject = __webpack_require__(65);
	var gOPD = __webpack_require__(63);
	var createProperty = __webpack_require__(182);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(48);
	var toPrimitive = __webpack_require__(78);
	var getPrototypeOf = __webpack_require__(64);
	var getOwnPropertyDescriptor = __webpack_require__(63).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(43) && $export($export.P + __webpack_require__(153), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(48);
	var toPrimitive = __webpack_require__(78);
	var getPrototypeOf = __webpack_require__(64);
	var getOwnPropertyDescriptor = __webpack_require__(63).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(43) && $export($export.P + __webpack_require__(153), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(4);
	var $values = __webpack_require__(277)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(4);
	var global = __webpack_require__(24);
	var core = __webpack_require__(74);
	var microtask = __webpack_require__(193)();
	var OBSERVABLE = __webpack_require__(34)('observable');
	var aFunction = __webpack_require__(55);
	var anObject = __webpack_require__(22);
	var anInstance = __webpack_require__(95);
	var redefineAll = __webpack_require__(102);
	var hide = __webpack_require__(59);
	var forOf = __webpack_require__(96);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(103)('Observable');


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(4);
	var core = __webpack_require__(74);
	var global = __webpack_require__(24);
	var speciesConstructor = __webpack_require__(158);
	var promiseResolve = __webpack_require__(282);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(4);
	var newPromiseCapability = __webpack_require__(194);
	var perform = __webpack_require__(281);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(82);
	var anObject = __webpack_require__(22);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(82);
	var anObject = __webpack_require__(22);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(288);
	var from = __webpack_require__(258);
	var metadata = __webpack_require__(82);
	var anObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(64);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(82);
	var anObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(64);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(82);
	var anObject = __webpack_require__(22);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(82);
	var anObject = __webpack_require__(22);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(82);
	var anObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(64);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(82);
	var anObject = __webpack_require__(22);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(82);
	var anObject = __webpack_require__(22);
	var aFunction = __webpack_require__(55);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(155)('Set');


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(156)('Set');


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(4);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(262)('Set') });


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(4);
	var $at = __webpack_require__(197)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(4);
	var defined = __webpack_require__(75);
	var toLength = __webpack_require__(45);
	var isRegExp = __webpack_require__(151);
	var getFlags = __webpack_require__(149);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(189)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(4);
	var $pad = __webpack_require__(283);
	var userAgent = __webpack_require__(203);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(4);
	var $pad = __webpack_require__(283);
	var userAgent = __webpack_require__(203);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(115)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(115)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(204)('asyncIterator');


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(204)('observable');


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(4);
	
	$export($export.S, 'System', { global: __webpack_require__(24) });


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(155)('WeakMap');


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(156)('WeakMap');


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(155)('WeakSet');


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(156)('WeakSet');


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(206);
	var getKeys = __webpack_require__(100);
	var redefine = __webpack_require__(60);
	var global = __webpack_require__(24);
	var hide = __webpack_require__(59);
	var Iterators = __webpack_require__(113);
	var wks = __webpack_require__(34);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $task = __webpack_require__(201);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(24);
	var $export = __webpack_require__(4);
	var userAgent = __webpack_require__(203);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(564);
	__webpack_require__(503);
	__webpack_require__(505);
	__webpack_require__(504);
	__webpack_require__(507);
	__webpack_require__(509);
	__webpack_require__(514);
	__webpack_require__(508);
	__webpack_require__(506);
	__webpack_require__(516);
	__webpack_require__(515);
	__webpack_require__(511);
	__webpack_require__(512);
	__webpack_require__(510);
	__webpack_require__(502);
	__webpack_require__(513);
	__webpack_require__(517);
	__webpack_require__(518);
	__webpack_require__(470);
	__webpack_require__(472);
	__webpack_require__(471);
	__webpack_require__(520);
	__webpack_require__(519);
	__webpack_require__(490);
	__webpack_require__(500);
	__webpack_require__(501);
	__webpack_require__(491);
	__webpack_require__(492);
	__webpack_require__(493);
	__webpack_require__(494);
	__webpack_require__(495);
	__webpack_require__(496);
	__webpack_require__(497);
	__webpack_require__(498);
	__webpack_require__(499);
	__webpack_require__(473);
	__webpack_require__(474);
	__webpack_require__(475);
	__webpack_require__(476);
	__webpack_require__(477);
	__webpack_require__(478);
	__webpack_require__(479);
	__webpack_require__(480);
	__webpack_require__(481);
	__webpack_require__(482);
	__webpack_require__(483);
	__webpack_require__(484);
	__webpack_require__(485);
	__webpack_require__(486);
	__webpack_require__(487);
	__webpack_require__(488);
	__webpack_require__(489);
	__webpack_require__(551);
	__webpack_require__(556);
	__webpack_require__(563);
	__webpack_require__(554);
	__webpack_require__(546);
	__webpack_require__(547);
	__webpack_require__(552);
	__webpack_require__(557);
	__webpack_require__(559);
	__webpack_require__(542);
	__webpack_require__(543);
	__webpack_require__(544);
	__webpack_require__(545);
	__webpack_require__(548);
	__webpack_require__(549);
	__webpack_require__(550);
	__webpack_require__(553);
	__webpack_require__(555);
	__webpack_require__(558);
	__webpack_require__(560);
	__webpack_require__(561);
	__webpack_require__(562);
	__webpack_require__(465);
	__webpack_require__(467);
	__webpack_require__(466);
	__webpack_require__(469);
	__webpack_require__(468);
	__webpack_require__(454);
	__webpack_require__(452);
	__webpack_require__(458);
	__webpack_require__(455);
	__webpack_require__(461);
	__webpack_require__(463);
	__webpack_require__(451);
	__webpack_require__(457);
	__webpack_require__(448);
	__webpack_require__(462);
	__webpack_require__(446);
	__webpack_require__(460);
	__webpack_require__(459);
	__webpack_require__(453);
	__webpack_require__(456);
	__webpack_require__(445);
	__webpack_require__(447);
	__webpack_require__(450);
	__webpack_require__(449);
	__webpack_require__(464);
	__webpack_require__(206);
	__webpack_require__(536);
	__webpack_require__(541);
	__webpack_require__(287);
	__webpack_require__(537);
	__webpack_require__(538);
	__webpack_require__(539);
	__webpack_require__(540);
	__webpack_require__(521);
	__webpack_require__(286);
	__webpack_require__(288);
	__webpack_require__(289);
	__webpack_require__(576);
	__webpack_require__(565);
	__webpack_require__(566);
	__webpack_require__(571);
	__webpack_require__(574);
	__webpack_require__(575);
	__webpack_require__(569);
	__webpack_require__(572);
	__webpack_require__(570);
	__webpack_require__(573);
	__webpack_require__(567);
	__webpack_require__(568);
	__webpack_require__(522);
	__webpack_require__(523);
	__webpack_require__(524);
	__webpack_require__(525);
	__webpack_require__(526);
	__webpack_require__(529);
	__webpack_require__(527);
	__webpack_require__(528);
	__webpack_require__(530);
	__webpack_require__(531);
	__webpack_require__(532);
	__webpack_require__(533);
	__webpack_require__(535);
	__webpack_require__(534);
	__webpack_require__(579);
	__webpack_require__(577);
	__webpack_require__(578);
	__webpack_require__(620);
	__webpack_require__(623);
	__webpack_require__(622);
	__webpack_require__(624);
	__webpack_require__(625);
	__webpack_require__(621);
	__webpack_require__(626);
	__webpack_require__(627);
	__webpack_require__(601);
	__webpack_require__(604);
	__webpack_require__(600);
	__webpack_require__(598);
	__webpack_require__(599);
	__webpack_require__(602);
	__webpack_require__(603);
	__webpack_require__(585);
	__webpack_require__(619);
	__webpack_require__(584);
	__webpack_require__(618);
	__webpack_require__(630);
	__webpack_require__(632);
	__webpack_require__(583);
	__webpack_require__(617);
	__webpack_require__(629);
	__webpack_require__(631);
	__webpack_require__(582);
	__webpack_require__(628);
	__webpack_require__(581);
	__webpack_require__(586);
	__webpack_require__(587);
	__webpack_require__(588);
	__webpack_require__(589);
	__webpack_require__(590);
	__webpack_require__(592);
	__webpack_require__(591);
	__webpack_require__(593);
	__webpack_require__(594);
	__webpack_require__(595);
	__webpack_require__(597);
	__webpack_require__(596);
	__webpack_require__(606);
	__webpack_require__(607);
	__webpack_require__(608);
	__webpack_require__(609);
	__webpack_require__(611);
	__webpack_require__(610);
	__webpack_require__(613);
	__webpack_require__(612);
	__webpack_require__(614);
	__webpack_require__(615);
	__webpack_require__(616);
	__webpack_require__(580);
	__webpack_require__(605);
	__webpack_require__(635);
	__webpack_require__(634);
	__webpack_require__(633);
	module.exports = __webpack_require__(74);


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(638);
	
	var emptyObject = __webpack_require__(160);
	var _invariant = __webpack_require__(19);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 638 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * deep-diff.
	 * Licensed under the MIT License.
	 */
	;(function(root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.DeepDiff = factory();
	  }
	}(this, function(undefined) {
	  'use strict';
	
	  var $scope, conflict, conflictResolution = [];
	  if (typeof global === 'object' && global) {
	    $scope = global;
	  } else if (typeof window !== 'undefined') {
	    $scope = window;
	  } else {
	    $scope = {};
	  }
	  conflict = $scope.DeepDiff;
	  if (conflict) {
	    conflictResolution.push(
	      function() {
	        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
	          $scope.DeepDiff = conflict;
	          conflict = undefined;
	        }
	      });
	  }
	
	  // nodejs compatible on server side and in the browser.
	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	
	  function Diff(kind, path) {
	    Object.defineProperty(this, 'kind', {
	      value: kind,
	      enumerable: true
	    });
	    if (path && path.length) {
	      Object.defineProperty(this, 'path', {
	        value: path,
	        enumerable: true
	      });
	    }
	  }
	
	  function DiffEdit(path, origin, value) {
	    DiffEdit.super_.call(this, 'E', path);
	    Object.defineProperty(this, 'lhs', {
	      value: origin,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffEdit, Diff);
	
	  function DiffNew(path, value) {
	    DiffNew.super_.call(this, 'N', path);
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffNew, Diff);
	
	  function DiffDeleted(path, value) {
	    DiffDeleted.super_.call(this, 'D', path);
	    Object.defineProperty(this, 'lhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffDeleted, Diff);
	
	  function DiffArray(path, index, item) {
	    DiffArray.super_.call(this, 'A', path);
	    Object.defineProperty(this, 'index', {
	      value: index,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'item', {
	      value: item,
	      enumerable: true
	    });
	  }
	  inherits(DiffArray, Diff);
	
	  function arrayRemove(arr, from, to) {
	    var rest = arr.slice((to || from) + 1 || arr.length);
	    arr.length = from < 0 ? arr.length + from : from;
	    arr.push.apply(arr, rest);
	    return arr;
	  }
	
	  function realTypeOf(subject) {
	    var type = typeof subject;
	    if (type !== 'object') {
	      return type;
	    }
	
	    if (subject === Math) {
	      return 'math';
	    } else if (subject === null) {
	      return 'null';
	    } else if (Array.isArray(subject)) {
	      return 'array';
	    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
	      return 'date';
	    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
	      return 'regexp';
	    }
	    return 'object';
	  }
	
	  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
	    path = path || [];
	    var currentPath = path.slice(0);
	    if (typeof key !== 'undefined') {
	      if (prefilter) {
	        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
	        else if (typeof(prefilter) === 'object') {
	          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
	          if (prefilter.normalize) {
	            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
	            if (alt) {
	              lhs = alt[0];
	              rhs = alt[1];
	            }
	          }
	        }
	      }
	      currentPath.push(key);
	    }
	
	    // Use string comparison for regexes
	    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
	      lhs = lhs.toString();
	      rhs = rhs.toString();
	    }
	
	    var ltype = typeof lhs;
	    var rtype = typeof rhs;
	    if (ltype === 'undefined') {
	      if (rtype !== 'undefined') {
	        changes(new DiffNew(currentPath, rhs));
	      }
	    } else if (rtype === 'undefined') {
	      changes(new DiffDeleted(currentPath, lhs));
	    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
	      stack = stack || [];
	      if (stack.indexOf(lhs) < 0) {
	        stack.push(lhs);
	        if (Array.isArray(lhs)) {
	          var i, len = lhs.length;
	          for (i = 0; i < lhs.length; i++) {
	            if (i >= rhs.length) {
	              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
	            } else {
	              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
	            }
	          }
	          while (i < rhs.length) {
	            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
	          }
	        } else {
	          var akeys = Object.keys(lhs);
	          var pkeys = Object.keys(rhs);
	          akeys.forEach(function(k, i) {
	            var other = pkeys.indexOf(k);
	            if (other >= 0) {
	              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
	              pkeys = arrayRemove(pkeys, other);
	            } else {
	              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
	            }
	          });
	          pkeys.forEach(function(k) {
	            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
	          });
	        }
	        stack.length = stack.length - 1;
	      }
	    } else if (lhs !== rhs) {
	      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
	        changes(new DiffEdit(currentPath, lhs, rhs));
	      }
	    }
	  }
	
	  function accumulateDiff(lhs, rhs, prefilter, accum) {
	    accum = accum || [];
	    deepDiff(lhs, rhs,
	      function(diff) {
	        if (diff) {
	          accum.push(diff);
	        }
	      },
	      prefilter);
	    return (accum.length) ? accum : undefined;
	  }
	
	  function applyArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    } else {
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr = arrayRemove(arr, index);
	          break;
	        case 'E':
	        case 'N':
	          arr[index] = change.rhs;
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function applyChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i = -1,
	          last = change.path ? change.path.length - 1 : 0;
	      while (++i < last) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    }
	  }
	
	  function revertArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      // the structure of the object at the index has changed...
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          delete it[change.path[i]];
	          break;
	      }
	    } else {
	      // the array item is different...
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr[index] = change.lhs;
	          break;
	        case 'E':
	          arr[index] = change.lhs;
	          break;
	        case 'N':
	          arr = arrayRemove(arr, index);
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function revertChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i, u;
	      u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          // Array was modified...
	          // it will be an array...
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          // Item was deleted...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          // Item was edited...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          // Item is new...
	          delete it[change.path[i]];
	          break;
	      }
	    }
	  }
	
	  function applyDiff(target, source, filter) {
	    if (target && source) {
	      var onChange = function(change) {
	        if (!filter || filter(target, source, change)) {
	          applyChange(target, source, change);
	        }
	      };
	      deepDiff(target, source, onChange);
	    }
	  }
	
	  Object.defineProperties(accumulateDiff, {
	
	    diff: {
	      value: accumulateDiff,
	      enumerable: true
	    },
	    observableDiff: {
	      value: deepDiff,
	      enumerable: true
	    },
	    applyDiff: {
	      value: applyDiff,
	      enumerable: true
	    },
	    applyChange: {
	      value: applyChange,
	      enumerable: true
	    },
	    revertChange: {
	      value: revertChange,
	      enumerable: true
	    },
	    isConflict: {
	      value: function() {
	        return 'undefined' !== typeof conflict;
	      },
	      enumerable: true
	    },
	    noConflict: {
	      value: function() {
	        if (conflictResolution) {
	          conflictResolution.forEach(function(it) {
	            it();
	          });
	          conflictResolution = null;
	        }
	        return accumulateDiff;
	      },
	      enumerable: true
	    }
	  });
	
	  return accumulateDiff;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(642);
	var isArguments = __webpack_require__(641);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 641 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 642 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	var require;var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, global, module) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
	 * @version   3.0.2
	 */
	
	(function() {
	    "use strict";
	    function lib$es6$promise$utils$$objectOrFunction(x) {
	      return typeof x === 'function' || (typeof x === 'object' && x !== null);
	    }
	
	    function lib$es6$promise$utils$$isFunction(x) {
	      return typeof x === 'function';
	    }
	
	    function lib$es6$promise$utils$$isMaybeThenable(x) {
	      return typeof x === 'object' && x !== null;
	    }
	
	    var lib$es6$promise$utils$$_isArray;
	    if (!Array.isArray) {
	      lib$es6$promise$utils$$_isArray = function (x) {
	        return Object.prototype.toString.call(x) === '[object Array]';
	      };
	    } else {
	      lib$es6$promise$utils$$_isArray = Array.isArray;
	    }
	
	    var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
	    var lib$es6$promise$asap$$len = 0;
	    var lib$es6$promise$asap$$toString = {}.toString;
	    var lib$es6$promise$asap$$vertxNext;
	    var lib$es6$promise$asap$$customSchedulerFn;
	
	    var lib$es6$promise$asap$$asap = function asap(callback, arg) {
	      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
	      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
	      lib$es6$promise$asap$$len += 2;
	      if (lib$es6$promise$asap$$len === 2) {
	        // If len is 2, that means that we need to schedule an async flush.
	        // If additional callbacks are queued before the queue is flushed, they
	        // will be processed by this flush that we are scheduling.
	        if (lib$es6$promise$asap$$customSchedulerFn) {
	          lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
	        } else {
	          lib$es6$promise$asap$$scheduleFlush();
	        }
	      }
	    }
	
	    function lib$es6$promise$asap$$setScheduler(scheduleFn) {
	      lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
	    }
	
	    function lib$es6$promise$asap$$setAsap(asapFn) {
	      lib$es6$promise$asap$$asap = asapFn;
	    }
	
	    var lib$es6$promise$asap$$browserWindow = (typeof window !== 'undefined') ? window : undefined;
	    var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
	    var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
	    var lib$es6$promise$asap$$isNode = typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	    // test for web worker but not in IE10
	    var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== 'undefined' &&
	      typeof importScripts !== 'undefined' &&
	      typeof MessageChannel !== 'undefined';
	
	    // node
	    function lib$es6$promise$asap$$useNextTick() {
	      // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	      // see https://github.com/cujojs/when/issues/410 for details
	      return function() {
	        process.nextTick(lib$es6$promise$asap$$flush);
	      };
	    }
	
	    // vertx
	    function lib$es6$promise$asap$$useVertxTimer() {
	      return function() {
	        lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush);
	      };
	    }
	
	    function lib$es6$promise$asap$$useMutationObserver() {
	      var iterations = 0;
	      var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
	      var node = document.createTextNode('');
	      observer.observe(node, { characterData: true });
	
	      return function() {
	        node.data = (iterations = ++iterations % 2);
	      };
	    }
	
	    // web worker
	    function lib$es6$promise$asap$$useMessageChannel() {
	      var channel = new MessageChannel();
	      channel.port1.onmessage = lib$es6$promise$asap$$flush;
	      return function () {
	        channel.port2.postMessage(0);
	      };
	    }
	
	    function lib$es6$promise$asap$$useSetTimeout() {
	      return function() {
	        setTimeout(lib$es6$promise$asap$$flush, 1);
	      };
	    }
	
	    var lib$es6$promise$asap$$queue = new Array(1000);
	    function lib$es6$promise$asap$$flush() {
	      for (var i = 0; i < lib$es6$promise$asap$$len; i+=2) {
	        var callback = lib$es6$promise$asap$$queue[i];
	        var arg = lib$es6$promise$asap$$queue[i+1];
	
	        callback(arg);
	
	        lib$es6$promise$asap$$queue[i] = undefined;
	        lib$es6$promise$asap$$queue[i+1] = undefined;
	      }
	
	      lib$es6$promise$asap$$len = 0;
	    }
	
	    function lib$es6$promise$asap$$attemptVertx() {
	      try {
	        var r = require;
	        var vertx = __webpack_require__(943);
	        lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
	        return lib$es6$promise$asap$$useVertxTimer();
	      } catch(e) {
	        return lib$es6$promise$asap$$useSetTimeout();
	      }
	    }
	
	    var lib$es6$promise$asap$$scheduleFlush;
	    // Decide what async method to use to triggering processing of queued callbacks:
	    if (lib$es6$promise$asap$$isNode) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
	    } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
	    } else if (lib$es6$promise$asap$$isWorker) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
	    } else if (lib$es6$promise$asap$$browserWindow === undefined && "function" === 'function') {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertx();
	    } else {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
	    }
	
	    function lib$es6$promise$$internal$$noop() {}
	
	    var lib$es6$promise$$internal$$PENDING   = void 0;
	    var lib$es6$promise$$internal$$FULFILLED = 1;
	    var lib$es6$promise$$internal$$REJECTED  = 2;
	
	    var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	    function lib$es6$promise$$internal$$selfFulfillment() {
	      return new TypeError("You cannot resolve a promise with itself");
	    }
	
	    function lib$es6$promise$$internal$$cannotReturnOwn() {
	      return new TypeError('A promises callback cannot return that same promise.');
	    }
	
	    function lib$es6$promise$$internal$$getThen(promise) {
	      try {
	        return promise.then;
	      } catch(error) {
	        lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
	        return lib$es6$promise$$internal$$GET_THEN_ERROR;
	      }
	    }
	
	    function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	      try {
	        then.call(value, fulfillmentHandler, rejectionHandler);
	      } catch(e) {
	        return e;
	      }
	    }
	
	    function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
	       lib$es6$promise$asap$$asap(function(promise) {
	        var sealed = false;
	        var error = lib$es6$promise$$internal$$tryThen(then, thenable, function(value) {
	          if (sealed) { return; }
	          sealed = true;
	          if (thenable !== value) {
	            lib$es6$promise$$internal$$resolve(promise, value);
	          } else {
	            lib$es6$promise$$internal$$fulfill(promise, value);
	          }
	        }, function(reason) {
	          if (sealed) { return; }
	          sealed = true;
	
	          lib$es6$promise$$internal$$reject(promise, reason);
	        }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	        if (!sealed && error) {
	          sealed = true;
	          lib$es6$promise$$internal$$reject(promise, error);
	        }
	      }, promise);
	    }
	
	    function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
	      if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
	        lib$es6$promise$$internal$$fulfill(promise, thenable._result);
	      } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, thenable._result);
	      } else {
	        lib$es6$promise$$internal$$subscribe(thenable, undefined, function(value) {
	          lib$es6$promise$$internal$$resolve(promise, value);
	        }, function(reason) {
	          lib$es6$promise$$internal$$reject(promise, reason);
	        });
	      }
	    }
	
	    function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable) {
	      if (maybeThenable.constructor === promise.constructor) {
	        lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
	      } else {
	        var then = lib$es6$promise$$internal$$getThen(maybeThenable);
	
	        if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
	          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
	        } else if (then === undefined) {
	          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	        } else if (lib$es6$promise$utils$$isFunction(then)) {
	          lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
	        } else {
	          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	        }
	      }
	    }
	
	    function lib$es6$promise$$internal$$resolve(promise, value) {
	      if (promise === value) {
	        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFulfillment());
	      } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
	        lib$es6$promise$$internal$$handleMaybeThenable(promise, value);
	      } else {
	        lib$es6$promise$$internal$$fulfill(promise, value);
	      }
	    }
	
	    function lib$es6$promise$$internal$$publishRejection(promise) {
	      if (promise._onerror) {
	        promise._onerror(promise._result);
	      }
	
	      lib$es6$promise$$internal$$publish(promise);
	    }
	
	    function lib$es6$promise$$internal$$fulfill(promise, value) {
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
	
	      promise._result = value;
	      promise._state = lib$es6$promise$$internal$$FULFILLED;
	
	      if (promise._subscribers.length !== 0) {
	        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
	      }
	    }
	
	    function lib$es6$promise$$internal$$reject(promise, reason) {
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
	      promise._state = lib$es6$promise$$internal$$REJECTED;
	      promise._result = reason;
	
	      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
	    }
	
	    function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
	      var subscribers = parent._subscribers;
	      var length = subscribers.length;
	
	      parent._onerror = null;
	
	      subscribers[length] = child;
	      subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
	      subscribers[length + lib$es6$promise$$internal$$REJECTED]  = onRejection;
	
	      if (length === 0 && parent._state) {
	        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
	      }
	    }
	
	    function lib$es6$promise$$internal$$publish(promise) {
	      var subscribers = promise._subscribers;
	      var settled = promise._state;
	
	      if (subscribers.length === 0) { return; }
	
	      var child, callback, detail = promise._result;
	
	      for (var i = 0; i < subscribers.length; i += 3) {
	        child = subscribers[i];
	        callback = subscribers[i + settled];
	
	        if (child) {
	          lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
	        } else {
	          callback(detail);
	        }
	      }
	
	      promise._subscribers.length = 0;
	    }
	
	    function lib$es6$promise$$internal$$ErrorObject() {
	      this.error = null;
	    }
	
	    var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject();
	
	    function lib$es6$promise$$internal$$tryCatch(callback, detail) {
	      try {
	        return callback(detail);
	      } catch(e) {
	        lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
	        return lib$es6$promise$$internal$$TRY_CATCH_ERROR;
	      }
	    }
	
	    function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
	      var hasCallback = lib$es6$promise$utils$$isFunction(callback),
	          value, error, succeeded, failed;
	
	      if (hasCallback) {
	        value = lib$es6$promise$$internal$$tryCatch(callback, detail);
	
	        if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
	          failed = true;
	          error = value.error;
	          value = null;
	        } else {
	          succeeded = true;
	        }
	
	        if (promise === value) {
	          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
	          return;
	        }
	
	      } else {
	        value = detail;
	        succeeded = true;
	      }
	
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) {
	        // noop
	      } else if (hasCallback && succeeded) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      } else if (failed) {
	        lib$es6$promise$$internal$$reject(promise, error);
	      } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
	        lib$es6$promise$$internal$$fulfill(promise, value);
	      } else if (settled === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, value);
	      }
	    }
	
	    function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
	      try {
	        resolver(function resolvePromise(value){
	          lib$es6$promise$$internal$$resolve(promise, value);
	        }, function rejectPromise(reason) {
	          lib$es6$promise$$internal$$reject(promise, reason);
	        });
	      } catch(e) {
	        lib$es6$promise$$internal$$reject(promise, e);
	      }
	    }
	
	    function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
	      var enumerator = this;
	
	      enumerator._instanceConstructor = Constructor;
	      enumerator.promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	      if (enumerator._validateInput(input)) {
	        enumerator._input     = input;
	        enumerator.length     = input.length;
	        enumerator._remaining = input.length;
	
	        enumerator._init();
	
	        if (enumerator.length === 0) {
	          lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
	        } else {
	          enumerator.length = enumerator.length || 0;
	          enumerator._enumerate();
	          if (enumerator._remaining === 0) {
	            lib$es6$promise$$internal$$fulfill(enumerator.promise, enumerator._result);
	          }
	        }
	      } else {
	        lib$es6$promise$$internal$$reject(enumerator.promise, enumerator._validationError());
	      }
	    }
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._validateInput = function(input) {
	      return lib$es6$promise$utils$$isArray(input);
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._validationError = function() {
	      return new Error('Array Methods must be provided an Array');
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._init = function() {
	      this._result = new Array(this.length);
	    };
	
	    var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function() {
	      var enumerator = this;
	
	      var length  = enumerator.length;
	      var promise = enumerator.promise;
	      var input   = enumerator._input;
	
	      for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	        enumerator._eachEntry(input[i], i);
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function(entry, i) {
	      var enumerator = this;
	      var c = enumerator._instanceConstructor;
	
	      if (lib$es6$promise$utils$$isMaybeThenable(entry)) {
	        if (entry.constructor === c && entry._state !== lib$es6$promise$$internal$$PENDING) {
	          entry._onerror = null;
	          enumerator._settledAt(entry._state, i, entry._result);
	        } else {
	          enumerator._willSettleAt(c.resolve(entry), i);
	        }
	      } else {
	        enumerator._remaining--;
	        enumerator._result[i] = entry;
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function(state, i, value) {
	      var enumerator = this;
	      var promise = enumerator.promise;
	
	      if (promise._state === lib$es6$promise$$internal$$PENDING) {
	        enumerator._remaining--;
	
	        if (state === lib$es6$promise$$internal$$REJECTED) {
	          lib$es6$promise$$internal$$reject(promise, value);
	        } else {
	          enumerator._result[i] = value;
	        }
	      }
	
	      if (enumerator._remaining === 0) {
	        lib$es6$promise$$internal$$fulfill(promise, enumerator._result);
	      }
	    };
	
	    lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function(promise, i) {
	      var enumerator = this;
	
	      lib$es6$promise$$internal$$subscribe(promise, undefined, function(value) {
	        enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
	      }, function(reason) {
	        enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
	      });
	    };
	    function lib$es6$promise$promise$all$$all(entries) {
	      return new lib$es6$promise$enumerator$$default(this, entries).promise;
	    }
	    var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;
	    function lib$es6$promise$promise$race$$race(entries) {
	      /*jshint validthis:true */
	      var Constructor = this;
	
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	
	      if (!lib$es6$promise$utils$$isArray(entries)) {
	        lib$es6$promise$$internal$$reject(promise, new TypeError('You must pass an array to race.'));
	        return promise;
	      }
	
	      var length = entries.length;
	
	      function onFulfillment(value) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      }
	
	      function onRejection(reason) {
	        lib$es6$promise$$internal$$reject(promise, reason);
	      }
	
	      for (var i = 0; promise._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	        lib$es6$promise$$internal$$subscribe(Constructor.resolve(entries[i]), undefined, onFulfillment, onRejection);
	      }
	
	      return promise;
	    }
	    var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;
	    function lib$es6$promise$promise$resolve$$resolve(object) {
	      /*jshint validthis:true */
	      var Constructor = this;
	
	      if (object && typeof object === 'object' && object.constructor === Constructor) {
	        return object;
	      }
	
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	      lib$es6$promise$$internal$$resolve(promise, object);
	      return promise;
	    }
	    var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;
	    function lib$es6$promise$promise$reject$$reject(reason) {
	      /*jshint validthis:true */
	      var Constructor = this;
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	      lib$es6$promise$$internal$$reject(promise, reason);
	      return promise;
	    }
	    var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;
	
	    var lib$es6$promise$promise$$counter = 0;
	
	    function lib$es6$promise$promise$$needsResolver() {
	      throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	    }
	
	    function lib$es6$promise$promise$$needsNew() {
	      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	    }
	
	    var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;
	    /**
	      Promise objects represent the eventual result of an asynchronous operation. The
	      primary way of interacting with a promise is through its `then` method, which
	      registers callbacks to receive either a promise's eventual value or the reason
	      why the promise cannot be fulfilled.
	
	      Terminology
	      -----------
	
	      - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	      - `thenable` is an object or function that defines a `then` method.
	      - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	      - `exception` is a value that is thrown using the throw statement.
	      - `reason` is a value that indicates why a promise was rejected.
	      - `settled` the final resting state of a promise, fulfilled or rejected.
	
	      A promise can be in one of three states: pending, fulfilled, or rejected.
	
	      Promises that are fulfilled have a fulfillment value and are in the fulfilled
	      state.  Promises that are rejected have a rejection reason and are in the
	      rejected state.  A fulfillment value is never a thenable.
	
	      Promises can also be said to *resolve* a value.  If this value is also a
	      promise, then the original promise's settled state will match the value's
	      settled state.  So a promise that *resolves* a promise that rejects will
	      itself reject, and a promise that *resolves* a promise that fulfills will
	      itself fulfill.
	
	
	      Basic Usage:
	      ------------
	
	      ```js
	      var promise = new Promise(function(resolve, reject) {
	        // on success
	        resolve(value);
	
	        // on failure
	        reject(reason);
	      });
	
	      promise.then(function(value) {
	        // on fulfillment
	      }, function(reason) {
	        // on rejection
	      });
	      ```
	
	      Advanced Usage:
	      ---------------
	
	      Promises shine when abstracting away asynchronous interactions such as
	      `XMLHttpRequest`s.
	
	      ```js
	      function getJSON(url) {
	        return new Promise(function(resolve, reject){
	          var xhr = new XMLHttpRequest();
	
	          xhr.open('GET', url);
	          xhr.onreadystatechange = handler;
	          xhr.responseType = 'json';
	          xhr.setRequestHeader('Accept', 'application/json');
	          xhr.send();
	
	          function handler() {
	            if (this.readyState === this.DONE) {
	              if (this.status === 200) {
	                resolve(this.response);
	              } else {
	                reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	              }
	            }
	          };
	        });
	      }
	
	      getJSON('/posts.json').then(function(json) {
	        // on fulfillment
	      }, function(reason) {
	        // on rejection
	      });
	      ```
	
	      Unlike callbacks, promises are great composable primitives.
	
	      ```js
	      Promise.all([
	        getJSON('/posts'),
	        getJSON('/comments')
	      ]).then(function(values){
	        values[0] // => postsJSON
	        values[1] // => commentsJSON
	
	        return values;
	      });
	      ```
	
	      @class Promise
	      @param {function} resolver
	      Useful for tooling.
	      @constructor
	    */
	    function lib$es6$promise$promise$$Promise(resolver) {
	      this._id = lib$es6$promise$promise$$counter++;
	      this._state = undefined;
	      this._result = undefined;
	      this._subscribers = [];
	
	      if (lib$es6$promise$$internal$$noop !== resolver) {
	        if (!lib$es6$promise$utils$$isFunction(resolver)) {
	          lib$es6$promise$promise$$needsResolver();
	        }
	
	        if (!(this instanceof lib$es6$promise$promise$$Promise)) {
	          lib$es6$promise$promise$$needsNew();
	        }
	
	        lib$es6$promise$$internal$$initializePromise(this, resolver);
	      }
	    }
	
	    lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
	    lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
	    lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
	    lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
	    lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
	    lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
	    lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;
	
	    lib$es6$promise$promise$$Promise.prototype = {
	      constructor: lib$es6$promise$promise$$Promise,
	
	    /**
	      The primary way of interacting with a promise is through its `then` method,
	      which registers callbacks to receive either a promise's eventual value or the
	      reason why the promise cannot be fulfilled.
	
	      ```js
	      findUser().then(function(user){
	        // user is available
	      }, function(reason){
	        // user is unavailable, and you are given the reason why
	      });
	      ```
	
	      Chaining
	      --------
	
	      The return value of `then` is itself a promise.  This second, 'downstream'
	      promise is resolved with the return value of the first promise's fulfillment
	      or rejection handler, or rejected if the handler throws an exception.
	
	      ```js
	      findUser().then(function (user) {
	        return user.name;
	      }, function (reason) {
	        return 'default name';
	      }).then(function (userName) {
	        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	        // will be `'default name'`
	      });
	
	      findUser().then(function (user) {
	        throw new Error('Found user, but still unhappy');
	      }, function (reason) {
	        throw new Error('`findUser` rejected and we're unhappy');
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	        // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	      });
	      ```
	      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	
	      ```js
	      findUser().then(function (user) {
	        throw new PedagogicalException('Upstream error');
	      }).then(function (value) {
	        // never reached
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // The `PedgagocialException` is propagated all the way down to here
	      });
	      ```
	
	      Assimilation
	      ------------
	
	      Sometimes the value you want to propagate to a downstream promise can only be
	      retrieved asynchronously. This can be achieved by returning a promise in the
	      fulfillment or rejection handler. The downstream promise will then be pending
	      until the returned promise is settled. This is called *assimilation*.
	
	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // The user's comments are now available
	      });
	      ```
	
	      If the assimliated promise rejects, then the downstream promise will also reject.
	
	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // If `findCommentsByAuthor` fulfills, we'll have the value here
	      }, function (reason) {
	        // If `findCommentsByAuthor` rejects, we'll have the reason here
	      });
	      ```
	
	      Simple Example
	      --------------
	
	      Synchronous Example
	
	      ```javascript
	      var result;
	
	      try {
	        result = findResult();
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	
	      Errback Example
	
	      ```js
	      findResult(function(result, err){
	        if (err) {
	          // failure
	        } else {
	          // success
	        }
	      });
	      ```
	
	      Promise Example;
	
	      ```javascript
	      findResult().then(function(result){
	        // success
	      }, function(reason){
	        // failure
	      });
	      ```
	
	      Advanced Example
	      --------------
	
	      Synchronous Example
	
	      ```javascript
	      var author, books;
	
	      try {
	        author = findAuthor();
	        books  = findBooksByAuthor(author);
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```
	
	      Errback Example
	
	      ```js
	
	      function foundBooks(books) {
	
	      }
	
	      function failure(reason) {
	
	      }
	
	      findAuthor(function(author, err){
	        if (err) {
	          failure(err);
	          // failure
	        } else {
	          try {
	            findBoooksByAuthor(author, function(books, err) {
	              if (err) {
	                failure(err);
	              } else {
	                try {
	                  foundBooks(books);
	                } catch(reason) {
	                  failure(reason);
	                }
	              }
	            });
	          } catch(error) {
	            failure(err);
	          }
	          // success
	        }
	      });
	      ```
	
	      Promise Example;
	
	      ```javascript
	      findAuthor().
	        then(findBooksByAuthor).
	        then(function(books){
	          // found books
	      }).catch(function(reason){
	        // something went wrong
	      });
	      ```
	
	      @method then
	      @param {Function} onFulfilled
	      @param {Function} onRejected
	      Useful for tooling.
	      @return {Promise}
	    */
	      then: function(onFulfillment, onRejection) {
	        var parent = this;
	        var state = parent._state;
	
	        if (state === lib$es6$promise$$internal$$FULFILLED && !onFulfillment || state === lib$es6$promise$$internal$$REJECTED && !onRejection) {
	          return this;
	        }
	
	        var child = new this.constructor(lib$es6$promise$$internal$$noop);
	        var result = parent._result;
	
	        if (state) {
	          var callback = arguments[state - 1];
	          lib$es6$promise$asap$$asap(function(){
	            lib$es6$promise$$internal$$invokeCallback(state, child, callback, result);
	          });
	        } else {
	          lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
	        }
	
	        return child;
	      },
	
	    /**
	      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	      as the catch block of a try/catch statement.
	
	      ```js
	      function findAuthor(){
	        throw new Error('couldn't find that author');
	      }
	
	      // synchronous
	      try {
	        findAuthor();
	      } catch(reason) {
	        // something went wrong
	      }
	
	      // async with promises
	      findAuthor().catch(function(reason){
	        // something went wrong
	      });
	      ```
	
	      @method catch
	      @param {Function} onRejection
	      Useful for tooling.
	      @return {Promise}
	    */
	      'catch': function(onRejection) {
	        return this.then(null, onRejection);
	      }
	    };
	    function lib$es6$promise$polyfill$$polyfill() {
	      var local;
	
	      if (typeof global !== 'undefined') {
	          local = global;
	      } else if (typeof self !== 'undefined') {
	          local = self;
	      } else {
	          try {
	              local = Function('return this')();
	          } catch (e) {
	              throw new Error('polyfill failed because global object is unavailable in this environment');
	          }
	      }
	
	      var P = local.Promise;
	
	      if (P && Object.prototype.toString.call(P.resolve()) === '[object Promise]' && !P.cast) {
	        return;
	      }
	
	      local.Promise = lib$es6$promise$promise$$default;
	    }
	    var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;
	
	    var lib$es6$promise$umd$$ES6Promise = {
	      'Promise': lib$es6$promise$promise$$default,
	      'polyfill': lib$es6$promise$polyfill$$default
	    };
	
	    /* global define:true module:true window: true */
	    if ("function" === 'function' && __webpack_require__(939)['amd']) {
	      !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return lib$es6$promise$umd$$ES6Promise; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined' && module['exports']) {
	      module['exports'] = lib$es6$promise$umd$$ES6Promise;
	    } else if (typeof this !== 'undefined') {
	      this['ES6Promise'] = lib$es6$promise$umd$$ES6Promise;
	    }
	
	    lib$es6$promise$polyfill$$default();
	}).call(this);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90), (function() { return this; }()), __webpack_require__(401)(module)))

/***/ },
/* 644 */
/***/ function(module, exports) {

	//! TrackJS JavaScript error monitoring agent.
	//! COPYRIGHT (c) 2017 ALL RIGHTS RESERVED
	//! See License at https://trackjs.com/terms/
	(function(g,n,l){"use awesome";if(g.trackJs)g.console&&g.console.warn&&g.console.warn("TrackJS global conflict");else{var p=function(a,b){this.config=a;this.onError=b;a.enabled&&this.watch()};p.prototype={watch:function(){d.forEach(["EventTarget","Node","XMLHttpRequest"],function(a){d.has(g,a+".prototype.addEventListener")&&d.hasOwn(g[a].prototype,"addEventListener")&&this.wrapEventTarget(g[a].prototype)},this);this.wrapTimer("setTimeout");this.wrapTimer("setInterval")},wrap:function(a){function b(){try{return a.apply(this,
	arguments)}catch(b){throw c.onError("catch",b,{bindTime:e,bindStack:f}),d.wrapError(b);}}var c=this;try{if(!d.isFunction(a)||d.hasOwn(a,"__trackjs__"))return a;if(d.hasOwn(a,"__trackjs_state__"))return a.__trackjs_state__}catch(m){return a}var e,f;if(c.config.bindStack)try{throw Error();}catch(m){f=m.stack,e=d.isoNow()}for(var h in a)d.hasOwn(a,h)&&(b[h]=a[h]);b.prototype=a.prototype;b.__trackjs__=!0;return a.__trackjs_state__=b},wrapEventTarget:function(a){var b=this;d.has(a,"addEventListener.call")&&
	d.has(a,"removeEventListener.call")&&(d.patch(a,"addEventListener",function(a){return function(e,f,h,m){try{d.has(f,"handleEvent")&&(f.handleEvent=b.wrap(f.handleEvent))}catch(k){}return a.call(this,e,b.wrap(f),h,m)}}),d.patch(a,"removeEventListener",function(a){return function(b,f,h,d){try{f=f&&(f.__trackjs_state__||f)}catch(k){}return a.call(this,b,f,h,d)}}))},wrapTimer:function(a){var b=this;d.patch(g,a,function(a){return function(e,f){var h=Array.prototype.slice.call(arguments),m=h[0];d.isFunction(m)&&
	(h[0]=b.wrap(m));return d.has(a,"apply")?a.apply(this,h):a(h[0],h[1])}})}};var t=function(a){this.initCurrent(a)};t.prototype={current:{},initOnly:{cookie:!0,enabled:!0,token:!0,callback:{enabled:!0},console:{enabled:!0},navigation:{enabled:!0},network:{enabled:!0,fetch:!0},visitor:{enabled:!0},window:{enabled:!0,promise:!0}},defaults:{application:"",cookie:!1,dedupe:!0,enabled:!0,errorURL:"https://capture.trackjs.com/capture",errorNoSSLURL:"http://capture.trackjs.com/capture",faultURL:"https://usage.trackjs.com/fault.gif",
	onError:function(){return!0},serialize:function(a){function b(a){var c="<"+a.tagName.toLowerCase();a=a.attributes||[];for(var b=0;b<a.length;b++)c+=" "+a[b].name+'="'+a[b].value+'"';return c+">"}if(""===a)return"Empty String";if(a===l)return"undefined";if(d.isString(a)||d.isNumber(a)||d.isBoolean(a)||d.isFunction(a))return""+a;if(d.isElement(a))return b(a);var c;try{c=JSON.stringify(a,function(a,c){return c===l?"undefined":d.isNumber(c)&&isNaN(c)?"NaN":d.isError(c)?{name:c.name,message:c.message,
	stack:c.stack}:d.isElement(c)?b(c):c})}catch(f){c="";for(var e in a)a.hasOwnProperty(e)&&(c+=',"'+e+'":"'+a[e]+'"');c=c?"{"+c.replace(",","")+"}":"Unserializable Object"}return c.replace(/"undefined"/g,"undefined").replace(/"NaN"/g,"NaN")},sessionId:"",token:"",userId:"",version:"",callback:{enabled:!0,bindStack:!1},console:{enabled:!0,display:!0,error:!0,warn:!1,watch:["log","debug","info","warn","error"]},navigation:{enabled:!0},network:{enabled:!0,error:!0,fetch:!0},visitor:{enabled:!0},usageURL:"https://usage.trackjs.com/usage.gif",
	window:{enabled:!0,promise:!0}},initCurrent:function(a){if(this.validate(a,this.defaults,"config",{}))return this.current=d.defaultsDeep({},a,this.defaults),!0;this.current=d.defaultsDeep({},this.defaults);console.log("init current config",this.current);return!1},setCurrent:function(a){return this.validate(a,this.defaults,"config",this.initOnly)?(this.current=d.defaultsDeep({},a,this.current),!0):!1},validate:function(a,b,c,e){var f=!0;c=c||"";e=e||{};for(var h in a)if(a.hasOwnProperty(h))if(b.hasOwnProperty(h)){var d=
	typeof b[h];d!==typeof a[h]?(console.warn(c+"."+h+": property must be type "+d+"."),f=!1):"[object Array]"!==Object.prototype.toString.call(a[h])||this.validateArray(a[h],b[h],c+"."+h)?"[object Object]"===Object.prototype.toString.call(a[h])?f=this.validate(a[h],b[h],c+"."+h,e[h]):e.hasOwnProperty(h)&&(console.warn(c+"."+h+": property cannot be set after load."),f=!1):f=!1}else console.warn(c+"."+h+": property not supported."),f=!1;return f},validateArray:function(a,b,c){var e=!0;c=c||"";for(var f=
	0;f<a.length;f++)d.contains(b,a[f])||(console.warn(c+"["+f+"]: invalid value: "+a[f]+"."),e=!1);return e}};var u=function(a,b,c,e,f,h,d){this.util=a;this.log=b;this.onError=c;this.onFault=e;this.serialize=f;d.enabled&&(h.console=this.wrapConsoleObject(h.console,d))};u.prototype={wrapConsoleObject:function(a,b){a=a||{};var c=a.log||function(){},e=this,f;for(f=0;f<b.watch.length;f++)(function(f){var m=a[f]||c;a[f]=function(){try{var a=Array.prototype.slice.call(arguments);e.log.add("c",{timestamp:e.util.isoNow(),
	severity:f,message:e.serialize(1===a.length?a[0]:a)});if(b[f])if(d.isError(a[0])&&1===a.length)e.onError("console",a[0]);else try{throw Error(e.serialize(1===a.length?a[0]:a));}catch(c){e.onError("console",c)}b.display&&(e.util.hasFunction(m,"apply")?m.apply(this,a):m(a[0]))}catch(c){e.onFault(c)}}})(b.watch[f]);return a},report:function(){return this.log.all("c")}};var v=function(a,b,c,e,f){this.config=a;this.util=b;this.log=c;this.window=e;this.document=f;this.correlationId=this.token=null;this.initialize()};
	v.prototype={initialize:function(){this.token=this.getCustomerToken();this.correlationId=this.getCorrelationId()},getCustomerToken:function(){if(this.config.current.token)return this.config.current.token;var a=this.document.getElementsByTagName("script");return a[a.length-1].getAttribute("data-token")},getCorrelationId:function(){var a;if(!this.config.current.cookie)return this.util.uuid();try{a=this.document.cookie.replace(/(?:(?:^|.*;\s*)TrackJS\s*\=\s*([^;]*).*$)|^.*$/,"$1"),a||(a=this.util.uuid(),
	this.document.cookie="TrackJS="+a+"; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/")}catch(b){a=this.util.uuid()}return a},report:function(){return{application:this.config.current.application,correlationId:this.correlationId,sessionId:this.config.current.sessionId,token:this.token,userId:this.config.current.userId,version:this.config.current.version}}};var w=function(){this.loadedOn=(new Date).getTime();this.originalUrl=d.getLocation();this.referrer=n.referrer};w.prototype={discoverDependencies:function(){var a=
	{};g.jQuery&&g.jQuery.fn&&g.jQuery.fn.jquery&&(a.jQuery=g.jQuery.fn.jquery);g.jQuery&&g.jQuery.ui&&g.jQuery.ui.version&&(a.jQueryUI=g.jQuery.ui.version);g.angular&&g.angular.version&&g.angular.version.full&&(a.angular=g.angular.version.full);for(var b in g)if("_trackJs"!==b&&"_trackJS"!==b&&"_trackjs"!==b&&"webkitStorageInfo"!==b&&"webkitIndexedDB"!==b&&"top"!==b&&"parent"!==b&&"frameElement"!==b)try{if(g[b]){var c=g[b].version||g[b].Version||g[b].VERSION;"string"===typeof c&&(a[b]=c)}}catch(e){}return a},
	report:function(){return{age:(new Date).getTime()-this.loadedOn,dependencies:this.discoverDependencies(),originalUrl:this.originalUrl,referrer:this.referrer,userAgent:g.navigator.userAgent,viewportHeight:g.document.documentElement.clientHeight,viewportWidth:g.document.documentElement.clientWidth}}};var y=function(a){this.util=a;this.appender=[];this.maxLength=30};y.prototype={all:function(a){var b=[],c,e;for(e=0;e<this.appender.length;e++)(c=this.appender[e])&&c.category===a&&b.push(c.value);return b},
	clear:function(){this.appender.length=0},truncate:function(){this.appender.length>this.maxLength&&(this.appender=this.appender.slice(Math.max(this.appender.length-this.maxLength,0)))},add:function(a,b){var c=this.util.uuid();this.appender.push({key:c,category:a,value:b});this.truncate();return c},get:function(a,b){var c,e;for(e=0;e<this.appender.length;e++)if(c=this.appender[e],c.category===a&&c.key===b)return c.value;return!1}};var z=function(a,b){this.log=a;this.options=b;b.enabled&&this.watch()};
	z.prototype={isCompatible:function(a){a=a||g;return!d.has(a,"chrome.app.runtime")&&d.has(a,"addEventListener")&&d.has(a,"history.pushState")},record:function(a,b,c){this.log.add("h",{type:a,from:d.truncate(b,250),to:d.truncate(c,250),on:d.isoNow()})},report:function(){return this.log.all("h")},watch:function(){if(this.isCompatible()){var a=this,b=d.getLocationURL().relative;g.addEventListener("popstate",function(){var c=d.getLocationURL().relative;a.record("popState",b,c);b=c},!0);d.forEach(["pushState",
	"replaceState"],function(c){d.patch(history,c,function(e){return function(){b=d.getLocationURL().relative;var f=e.apply(this,arguments),h=d.getLocationURL().relative;a.record(c,b,h);b=h;return f}})})}}};var A=function(a,b,c,e,f,d){this.util=a;this.log=b;this.onError=c;this.onFault=e;this.window=f;this.options=d;d.enabled&&this.initialize(f)};A.prototype={initialize:function(a){a.XMLHttpRequest&&this.util.hasFunction(a.XMLHttpRequest.prototype.open,"apply")&&this.watchNetworkObject(a.XMLHttpRequest);
	a.XDomainRequest&&this.util.hasFunction(a.XDomainRequest.prototype.open,"apply")&&this.watchNetworkObject(a.XDomainRequest);this.options.fetch&&d.isWrappableFunction(a.fetch)&&this.watchFetch()},watchFetch:function(){var a=this.log,b=this.options,c=this.onError;d.patch(g,"fetch",function(e){return function(f,h){var m=f instanceof Request?f:new Request(f,h),k=e.apply(g,arguments);k.__trackjs_state__=a.add("n",{type:"fetch",startedOn:d.isoNow(),method:m.method,url:m.url});return k.then(function(e){var f=
	a.get("n",k.__trackjs_state__);f&&(d.defaults(f,{completedOn:d.isoNow(),statusCode:e.status,statusText:e.statusText}),b.error&&400<=e.status&&c("ajax",f.statusCode+" "+f.statusText+": "+f.method+" "+f.url));return e})["catch"](function(e){var f=a.get("n",k.__trackjs_state__);f&&(d.defaults(f,{completedOn:d.isoNow(),statusCode:0,statusText:(e||"").toString()}),b.error&&c("ajax",e));throw e;})}})},watchNetworkObject:function(a){var b=this,c=a.prototype.open,e=a.prototype.send;a.prototype.open=function(a,
	b){var e=(b||"").toString();0>e.indexOf("localhost:0")&&(this._trackJs={method:a,url:e});return c.apply(this,arguments)};a.prototype.send=function(){try{if(!this._trackJs)return e.apply(this,arguments);this._trackJs.logId=b.log.add("n",{type:"xhr",startedOn:b.util.isoNow(),method:this._trackJs.method,url:this._trackJs.url});b.listenForNetworkComplete(this)}catch(a){b.onFault(a)}return e.apply(this,arguments)};return a},listenForNetworkComplete:function(a){var b=this;b.window.ProgressEvent&&a.addEventListener&&
	a.addEventListener("readystatechange",function(){4===a.readyState&&b.finalizeNetworkEvent(a)},!0);a.addEventListener?a.addEventListener("load",function(){b.finalizeNetworkEvent(a);b.checkNetworkFault(a)},!0):setTimeout(function(){try{var c=a.onload;a.onload=function(){b.finalizeNetworkEvent(a);b.checkNetworkFault(a);"function"===typeof c&&b.util.hasFunction(c,"apply")&&c.apply(a,arguments)};var e=a.onerror;a.onerror=function(){b.finalizeNetworkEvent(a);b.checkNetworkFault(a);"function"===typeof oldOnError&&
	e.apply(a,arguments)}}catch(f){b.onFault(f)}},0)},finalizeNetworkEvent:function(a){if(a._trackJs){var b=this.log.get("n",a._trackJs.logId);b&&(b.completedOn=this.util.isoNow(),b.statusCode=1223==a.status?204:a.status,b.statusText=1223==a.status?"No Content":a.statusText)}},checkNetworkFault:function(a){if(this.options.error&&400<=a.status&&1223!=a.status){var b=a._trackJs||{};this.onError("ajax",a.status+" "+a.statusText+": "+b.method+" "+b.url)}},report:function(){return this.log.all("n")}};var q=
	function(a,b){this.util=a;this.config=b;this.disabled=!1;this.throttleStats={attemptCount:0,throttledCount:0,lastAttempt:(new Date).getTime()};g.JSON&&g.JSON.stringify||(this.disabled=!0)};q.prototype={errorEndpoint:function(a){var b=this.config.current.errorURL;this.util.testCrossdomainXhr()||-1!==g.location.protocol.indexOf("https")||(b=this.config.current.errorNoSSLURL);return b+"?token="+a},usageEndpoint:function(a){return this.appendObjectAsQuery(a,this.config.current.usageURL)},trackerFaultEndpoint:function(a){return this.appendObjectAsQuery(a,
	this.config.current.faultURL)},appendObjectAsQuery:function(a,b){b+="?";for(var c in a)a.hasOwnProperty(c)&&(b+=encodeURIComponent(c)+"="+encodeURIComponent(a[c])+"&");return b},getCORSRequest:function(a,b){var c;this.util.testCrossdomainXhr()?(c=new g.XMLHttpRequest,c.open(a,b),c.setRequestHeader("Content-Type","text/plain")):"undefined"!==typeof g.XDomainRequest?(c=new g.XDomainRequest,c.open(a,b)):c=null;return c},sendTrackerFault:function(a){this.throttle(a)||((new Image).src=this.trackerFaultEndpoint(a))},
	sendUsage:function(a){(new Image).src=this.usageEndpoint(a)},sendError:function(a,b){var c=this;if(!this.disabled&&!this.throttle(a))try{var e=this.getCORSRequest("POST",this.errorEndpoint(b));e.onreadystatechange=function(){4===e.readyState&&200!==e.status&&(c.disabled=!0)};e._trackJs=l;e.send(g.JSON.stringify(a))}catch(f){throw this.disabled=!0,f;}},throttle:function(a){var b=(new Date).getTime();this.throttleStats.attemptCount++;if(this.throttleStats.lastAttempt+1E3>=b){if(this.throttleStats.lastAttempt=
	b,10<this.throttleStats.attemptCount)return this.throttleStats.throttledCount++,!0}else a.throttled=this.throttleStats.throttledCount,this.throttleStats.attemptCount=0,this.throttleStats.lastAttempt=b,this.throttleStats.throttledCount=0;return!1}};var d=function(){function a(c,e,f,h){f=f||!1;h=h||0;d.forEach(e,function(e){d.forEach(d.keys(e),function(d){null===e[d]||e[d]===l?c[d]=e[d]:f&&10>h&&"[object Object]"===b(e[d])?(c[d]=c[d]||{},a(c[d],[e[d]],f,h+1)):c.hasOwnProperty(d)||(c[d]=e[d])})});return c}
	function b(a){return Object.prototype.toString.call(a)}return{addEventListenerSafe:function(a,b,f,d){a.addEventListener?a.addEventListener(b,f,d):a.attachEvent&&a.attachEvent("on"+b,f)},afterDocumentLoad:function(a){var b=!1;"complete"===n.readyState?d.defer(a):(d.addEventListenerSafe(n,"readystatechange",function(){"complete"!==n.readyState||b||(d.defer(a),b=!0)}),setTimeout(function(){b||(d.defer(a),b=!0)},1E4))},bind:function(a,b){return function(){return a.apply(b,Array.prototype.slice.call(arguments))}},
	contains:function(a,b){var f;for(f=0;f<a.length;f++)if(a[f]===b)return!0;return!1},defaults:function(c){return a(c,Array.prototype.slice.call(arguments,1),!1)},defaultsDeep:function(c){return a(c,Array.prototype.slice.call(arguments,1),!0)},defer:function(a,b){setTimeout(function(){a.apply(b)})},forEach:function(a,b,f){if(a.forEach)return a.forEach(b,f);for(var d=0;d<a.length;)b.call(f,a[d],d,a),d++},getLocation:function(){return g.location.toString().replace(/ /g,"%20")},getLocationURL:function(){return d.parseURL(d.getLocation())},
	has:function(a,b){try{for(var f=b.split("."),d=a,g=0;g<f.length;g++)if(d[f[g]])d=d[f[g]];else return!1;return!0}catch(k){return!1}},hasFunction:function(a,b){try{return!!a[b]}catch(f){return!1}},hasOwn:function(a,b){return Object.prototype.hasOwnProperty.call(a,b)},isArray:function(a){return"[object Array]"===b(a)},isBoolean:function(a){return"boolean"===typeof a||d.isObject(a)&&"[object Boolean]"===b(a)},isBrowserIE:function(a){a=a||g.navigator.userAgent;var b=a.match(/Trident\/([\d.]+)/);return b&&
	"7.0"===b[1]?11:(a=a.match(/MSIE ([\d.]+)/))?parseInt(a[1],10):!1},isBrowserSupported:function(){var a=this.isBrowserIE();return!a||8<=a},isError:function(a){if(!d.isObject(a))return!1;var e=b(a);return"[object Error]"===e||"[object DOMException]"===e||d.isString(a.name)&&d.isString(a.message)},isElement:function(a){return d.isObject(a)&&1===a.nodeType},isFunction:function(a){return!(!a||"function"!==typeof a)},isNumber:function(a){return"number"===typeof a||d.isObject(a)&&"[object Number]"===b(a)},
	isObject:function(a){return!(!a||"object"!==typeof a)},isString:function(a){return"string"===typeof a||!d.isArray(a)&&d.isObject(a)&&"[object String]"===b(a)},isWrappableFunction:function(a){return this.isFunction(a)&&this.hasFunction(a,"apply")},isoNow:function(){var a=new Date;return a.toISOString?a.toISOString():a.getUTCFullYear()+"-"+this.pad(a.getUTCMonth()+1)+"-"+this.pad(a.getUTCDate())+"T"+this.pad(a.getUTCHours())+":"+this.pad(a.getUTCMinutes())+":"+this.pad(a.getUTCSeconds())+"."+String((a.getUTCMilliseconds()/
	1E3).toFixed(3)).slice(2,5)+"Z"},keys:function(a){if(!d.isObject(a))return[];var b=[],f;for(f in a)a.hasOwnProperty(f)&&b.push(f);return b},noop:function(){},pad:function(a){a=String(a);1===a.length&&(a="0"+a);return a},parseURL:function(a){var b=a.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);if(!b)return{};b={protocol:b[2],host:b[4],path:b[5],query:b[6],hash:b[8]};b.origin=(b.protocol||"")+"://"+(b.host||"");b.relative=(b.path||"")+(b.query||"")+(b.hash||"");b.href=a;return b},
	patch:function(a,b,f){a[b]=f(a[b]||d.noop)},testCrossdomainXhr:function(){return"withCredentials"in new XMLHttpRequest},truncate:function(a,b){if(a.length<=b)return a;var f=a.length-b;return a.substr(0,b)+"...{"+f+"}"},tryGet:function(a,b){try{return a[b]}catch(f){}},uuid:function(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(a){var b=16*Math.random()|0;return("x"==a?b:b&3|8).toString(16)})},wrapError:function(a){if(a.innerError)return a;var b=Error("TrackJS Caught: "+(a.message||
	a));b.description="TrackJS Caught: "+a.description;b.file=a.file;b.line=a.line||a.lineNumber;b.column=a.column||a.columnNumber;b.stack=a.stack;b.innerError=a;return b}}}(),B=function(a,b,c,e,f,d){this.util=a;this.log=b;this.onError=c;this.onFault=e;this.options=d;this.document=f;d.enabled&&this.initialize(f)};B.prototype={initialize:function(a){var b=this.util.bind(this.onDocumentClicked,this),c=this.util.bind(this.onInputChanged,this);a.addEventListener?(a.addEventListener("click",b,!0),a.addEventListener("blur",
	c,!0)):a.attachEvent&&(a.attachEvent("onclick",b),a.attachEvent("onfocusout",c))},onDocumentClicked:function(a){try{var b=this.getElementFromEvent(a);b&&b.tagName&&(this.isDescribedElement(b,"a")||this.isDescribedElement(b,"button")||this.isDescribedElement(b,"input",["button","submit"])?this.writeVisitorEvent(b,"click"):this.isDescribedElement(b,"input",["checkbox","radio"])&&this.writeVisitorEvent(b,"input",b.value,b.checked))}catch(c){this.onFault(c)}},onInputChanged:function(a){try{var b=this.getElementFromEvent(a);
	if(b&&b.tagName)if(this.isDescribedElement(b,"textarea"))this.writeVisitorEvent(b,"input",b.value);else if(this.isDescribedElement(b,"select")&&b.options&&b.options.length)this.onSelectInputChanged(b);else this.isDescribedElement(b,"input")&&!this.isDescribedElement(b,"input",["button","submit","hidden","checkbox","radio"])&&this.writeVisitorEvent(b,"input",b.value)}catch(c){this.onFault(c)}},onSelectInputChanged:function(a){if(a.multiple)for(var b=0;b<a.options.length;b++)a.options[b].selected&&
	this.writeVisitorEvent(a,"input",a.options[b].value);else 0<=a.selectedIndex&&a.options[a.selectedIndex]&&this.writeVisitorEvent(a,"input",a.options[a.selectedIndex].value)},writeVisitorEvent:function(a,b,c,e){"password"===this.getElementType(a)&&(c=l);this.log.add("v",{timestamp:this.util.isoNow(),action:b,element:{tag:a.tagName.toLowerCase(),attributes:this.getElementAttributes(a),value:this.getMetaValue(c,e)}})},getElementFromEvent:function(a){return a.target||n.elementFromPoint(a.clientX,a.clientY)},
	isDescribedElement:function(a,b,c){if(a.tagName.toLowerCase()!==b.toLowerCase())return!1;if(!c)return!0;a=this.getElementType(a);for(b=0;b<c.length;b++)if(c[b]===a)return!0;return!1},getElementType:function(a){return(a.getAttribute("type")||"").toLowerCase()},getElementAttributes:function(a){for(var b={},c=0;c<a.attributes.length;c++)"value"!==a.attributes[c].name.toLowerCase()&&(b[a.attributes[c].name]=a.attributes[c].value);return b},getMetaValue:function(a,b){return a===l?l:{length:a.length,pattern:this.matchInputPattern(a),
	checked:b}},matchInputPattern:function(a){return""===a?"empty":/^[a-z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(a)?"email":/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(a)||/^(\d{4}[\/\-](0?[1-9]|1[012])[\/\-]0?[1-9]|[12][0-9]|3[01])$/.test(a)?"date":/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(a)?
	"usphone":/^\s*$/.test(a)?"whitespace":/^\d*$/.test(a)?"numeric":/^[a-zA-Z]*$/.test(a)?"alpha":/^[a-zA-Z0-9]*$/.test(a)?"alphanumeric":"characters"},report:function(){return this.log.all("v")}};var C=function(a,b,c,e,f){this.onError=a;this.onFault=b;this.serialize=c;f.enabled&&this.watchWindowErrors(e);f.promise&&this.watchPromiseErrors(e)};C.prototype={watchPromiseErrors:function(a){var b=this;a.addEventListener?a.addEventListener("unhandledrejection",function(a){a=a||{};a=a.detail?d.tryGet(a.detail,
	"reason"):d.tryGet(a,"reason");if(a!==l){if(!d.isError(a))try{throw Error(b.serialize(a));}catch(e){a=e}b.onError("promise",a)}}):a.onunhandledrejection=function(a){b.onError("promise",a)}},watchWindowErrors:function(a){var b=this;d.patch(a,"onerror",function(a){return function(e,f,d,g,k){try{k=k||{},k.message=k.message||b.serialize(e),k.name=k.name||"Error",k.line=k.line||parseInt(d,10)||null,k.column=k.column||parseInt(g,10)||null,"[object Event]"!==Object.prototype.toString.call(e)||f?k.file=k.file||
	b.serialize(f):k.file=(e.target||{}).src,b.onError("window",k)}catch(x){b.onFault(x)}a.apply(this,arguments)}})}};var D=function(a,b,c,e,f,h,g,k,x,l,n,p,q,t,u,v){try{if(this.window=t,this.document=u,this.util=d,this.onError=this.util.bind(this.onError,this),this.onFault=this.util.bind(this.onFault,this),this.serialize=this.util.bind(this.serialize,this),this.config=new e(a),this.transmitter=new n(this.util,this.config),this.log=new k(this.util),this.api=new b(this.config,this.util,this.onError,this.serialize),
	this.metadata=new x(this.serialize),this.environment=new g,this.customer=new h(this.config,this.util,this.log,this.window,this.document),this.customer.token&&(this.apiConsoleWatcher=new f(this.util,this.log,this.onError,this.onFault,this.serialize,this.api,this.config.defaults.console),this.config.current.enabled&&(this.windowConsoleWatcher=new f(this.util,this.log,this.onError,this.onFault,this.serialize,this.window,this.config.current.console),this.util.isBrowserSupported()))){this.callbackWatcher=
	new c(this.config.current.callback,this.onError,this.onFault);this.visitorWatcher=new p(this.util,this.log,this.onError,this.onFault,this.document,this.config.current.visitor);this.navigationWatcher=new v(this.log,this.config.current.navigation);this.networkWatcher=new l(this.util,this.log,this.onError,this.onFault,this.window,this.config.current.network);this.windowWatcher=new q(this.onError,this.onFault,this.serialize,this.window,this.config.current.window);var r=this;d.afterDocumentLoad(function(){r.transmitter.sendUsage({token:r.customer.token,
	correlationId:r.customer.correlationId,application:r.config.current.application,x:r.util.uuid()})})}}catch(w){this.onFault(w)}};D.prototype={reveal:function(){if(this.customer.token)return this.api.addMetadata=this.metadata.addMetadata,this.api.removeMetadata=this.metadata.removeMetadata,this.api;this.config.current.enabled&&this.window.console&&this.window.console.warn&&this.window.console.warn("TrackJS could not find a token");return l},onError:function(){var a,b=!1;return function(c,e,f){if(d.isBrowserSupported()&&
	this.config.current.enabled)try{if(f=f||{bindStack:null,bindTime:null,force:!1},e&&d.isError(e)||(e={name:"Error",message:this.serialize(e,f.force)}),-1===e.message.indexOf("TrackJS Caught"))if(b&&-1!==e.message.indexOf("Script error"))b=!1;else{var h=d.defaultsDeep({},{bindStack:f.bindStack,bindTime:f.bindTime,column:e.column||e.columnNumber,console:this.windowConsoleWatcher.report(),customer:this.customer.report(),entry:c,environment:this.environment.report(),file:e.file||e.fileName,line:e.line||
	e.lineNumber,message:e.message,metadata:this.metadata.report(),nav:this.navigationWatcher.report(),network:this.networkWatcher.report(),url:(g.location||"").toString(),stack:e.stack,timestamp:this.util.isoNow(),visitor:this.visitorWatcher.report(),version:"2.10.2"});if(!f.force)try{if(!this.config.current.onError(h,e))return}catch(l){h.console.push({timestamp:this.util.isoNow(),severity:"error",message:l.message});var m=this;setTimeout(function(){m.onError("catch",l,{force:!0})},0)}if(this.config.current.dedupe){var k=
	(h.message+h.stack).substr(0,1E4);if(k===a)return;a=k}this.log.clear();setTimeout(function(){b=!1});b=!0;this.transmitter.sendError(h,this.customer.token)}}catch(l){this.onFault(l)}}}(),onFault:function(a){var b=this.transmitter||new q;a=a||{};a={token:this.customer.token,file:a.file||a.fileName,msg:a.message||"unknown",stack:(a.stack||"unknown").substr(0,500),url:this.window.location,v:"2.10.2",h:"a36ab4356e67dd6bcde8ff31f71cc2801b24744d",x:this.util.uuid()};b.sendTrackerFault(a)},serialize:function(a,
	b){if(this.config.current.serialize&&!b)try{return this.config.current.serialize(a)}catch(c){this.onError("catch",c,{force:!0})}return this.config.defaults.serialize(a)}};p=new D(g._trackJs||g._trackJS||g._trackjs||{},function(a,b,c,e){return{attempt:function(a,e){try{var d=Array.prototype.slice.call(arguments,2);return a.apply(e||this,d)}catch(g){throw c("catch",g),b.wrapError(g);}},configure:function(b){return a.setCurrent(b)},track:function(a){var b=e(a);a=a||{};if(!a.stack)try{throw Error(b);
	}catch(d){a=d}c("direct",a)},watch:function(a,e){return function(){try{var d=Array.prototype.slice.call(arguments,0);return a.apply(e||this,d)}catch(g){throw c("catch",g),b.wrapError(g);}}},watchAll:function(a){var e=Array.prototype.slice.call(arguments,1),d;for(d in a)"function"===typeof a[d]&&(b.contains(e,d)||function(){var e=a[d];a[d]=function(){try{var a=Array.prototype.slice.call(arguments,0);return e.apply(this,a)}catch(d){throw c("catch",d),b.wrapError(d);}}}());return a},hash:"a36ab4356e67dd6bcde8ff31f71cc2801b24744d",
	version:"2.10.2"}},p,t,u,v,w,y,function(a){var b={};return{addMetadata:function(a,d){b[a]=d},removeMetadata:function(a){delete b[a]},report:function(){var c=[],d;for(d in b)b.hasOwnProperty(d)&&c.push({key:d,value:a(b[d])});return c},store:b}},A,q,B,C,g,n,z);g.trackJs=p.reveal()}})(window,document);
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = trackJs;

/***/ },
/* 645 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 646 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"app":"AppPrint__app___3biDE"};

/***/ },
/* 647 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"app":"AppPrintEditor__app___2DhEZ"};

/***/ },
/* 648 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"app":"AudioPlayerApp__app___qgWXb"};

/***/ },
/* 649 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loader":"appLoader__loader___38V1L"};

/***/ },
/* 650 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"nonDraggableElement":"base__nonDraggableElement___11kz-"};

/***/ },
/* 651 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 652 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(652);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(662);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	var createArrayFromMixed = __webpack_require__(655);
	var getMarkupWrap = __webpack_require__(657);
	var invariant = __webpack_require__(19);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 658 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 659 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(659);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 661 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(661);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 663 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _objectAssign = __webpack_require__(209);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _callbackProxy = __webpack_require__(665);
	
	var _callbackProxy2 = _interopRequireDefault(_callbackProxy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var callbackProxies = new WeakMap();
	
	var BaseWrapper = function () {
	    function BaseWrapper(_ref) {
	        var callbackNames = _ref.callbackNames,
	            options = _ref.options,
	            qq = _ref.qq,
	            type = _ref.type;
	
	        _classCallCheck(this, BaseWrapper);
	
	        var callbacks = options.callbacks || {};
	
	        var optionsSansCallbacks = (0, _objectAssign2.default)({}, options);
	        delete optionsSansCallbacks.callbacks;
	        this.options = optionsSansCallbacks;
	
	        callbackProxies.set(this, createCallbackProxies(callbackNames));
	
	        registerOptionsCallbacks({ callbacks: callbacks, callbackProxies: callbackProxies.get(this) });
	
	        this.methods = createFineUploader({
	            callbackProxies: callbackProxies.get(this),
	            options: optionsSansCallbacks,
	            qq: qq,
	            type: type
	        });
	
	        this.qq = qq;
	    }
	
	    _createClass(BaseWrapper, [{
	        key: 'off',
	        value: function off(name, callback) {
	            var normalizedName = normalizeCallbackName(name);
	            var proxy = callbackProxies.get(this)[normalizedName];
	
	            proxy.remove(callback);
	        }
	    }, {
	        key: 'on',
	        value: function on(name, callback) {
	            var normalizedName = normalizeCallbackName(name);
	            var proxy = callbackProxies.get(this)[normalizedName];
	
	            proxy.add(callback);
	        }
	    }]);
	
	    return BaseWrapper;
	}();
	
	exports.default = BaseWrapper;
	
	
	var createCallbackProxies = function createCallbackProxies(names) {
	    var proxyMap = {};
	
	    names.forEach(function (callbackName) {
	        proxyMap[callbackName] = new _callbackProxy2.default(callbackName);
	    });
	
	    return proxyMap;
	};
	
	var createFineUploader = function createFineUploader(_ref2) {
	    var callbackProxies = _ref2.callbackProxies,
	        options = _ref2.options,
	        qq = _ref2.qq,
	        type = _ref2.type;
	
	    var optionsCopy = (0, _objectAssign2.default)({ callbacks: {} }, options);
	
	    Object.keys(callbackProxies).forEach(function (callbackName) {
	        var proxy = callbackProxies[callbackName];
	
	        optionsCopy.callbacks[callbackName] = proxy.proxyFunction;
	    });
	
	    if (type === 'traditional') {
	        return new qq.FineUploaderBasic(optionsCopy);
	    } else {
	        return new qq[type].FineUploaderBasic(optionsCopy);
	    }
	};
	
	var normalizeCallbackName = function normalizeCallbackName(name) {
	    if (!name.match(/^on[A-Z]/)) {
	        return 'on' + name[0].toUpperCase() + name.slice(1);
	    }
	
	    return name;
	};
	
	var registerOptionsCallbacks = function registerOptionsCallbacks(_ref3) {
	    var callbacks = _ref3.callbacks,
	        callbackProxies = _ref3.callbackProxies;
	
	    Object.keys(callbacks).forEach(function (callbackName) {
	        var callbackProxy = callbackProxies[callbackName];
	
	        callbackProxy.add(callbacks[callbackName]);
	    });
	};

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _objectAssign = __webpack_require__(209);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _callbackNames = __webpack_require__(294);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var privateData = new WeakMap();
	var callbacks = new WeakMap();
	
	var CallbackProxy = function () {
	    function CallbackProxy(name) {
	        _classCallCheck(this, CallbackProxy);
	
	        callbacks.set(this, []);
	
	        privateData.set(this, {
	            name: name,
	            proxyFunction: getProxyFunction.call(this, { name: name })
	        });
	    }
	
	    _createClass(CallbackProxy, [{
	        key: 'add',
	        value: function add(callback) {
	            callbacks.get(this).push(callback);
	        }
	    }, {
	        key: 'remove',
	        value: function remove(callback) {
	            var index = callbacks.get(this).indexOf(callback);
	            if (index >= 0) {
	                callbacks.get(this).splice(index, 1);
	            }
	        }
	    }, {
	        key: 'name',
	        get: function get() {
	            return privateData.get(this).name;
	        }
	    }, {
	        key: 'proxyFunction',
	        get: function get() {
	            return privateData.get(this).proxyFunction;
	        }
	    }]);
	
	    return CallbackProxy;
	}();
	
	exports.default = CallbackProxy;
	
	
	var getProxyFunction = function getProxyFunction(_ref) {
	    var name = _ref.name;
	
	    var proxyClassContext = this;
	
	    return function () {
	        for (var _len = arguments.length, originalCallbackArguments = Array(_len), _key = 0; _key < _len; _key++) {
	            originalCallbackArguments[_key] = arguments[_key];
	        }
	
	        var isThenable = _callbackNames.thenable.indexOf(name) >= 0;
	        var registeredCallbacks = callbacks.get(proxyClassContext);
	        var callbackReturnValue = void 0;
	
	        if (isThenable) {
	            callbackReturnValue = executeThenableCallbacks({ registeredCallbacks: registeredCallbacks, originalCallbackArguments: originalCallbackArguments });
	        } else {
	            (0, _objectAssign2.default)([], registeredCallbacks).every(function (callback) {
	                var returnValue = callback.apply(null, originalCallbackArguments);
	
	                callbackReturnValue = returnValue;
	
	                return returnValue !== false;
	            });
	        }
	
	        return callbackReturnValue;
	    };
	};
	
	var executeThenableCallbacks = function executeThenableCallbacks(_ref2) {
	    var registeredCallbacks = _ref2.registeredCallbacks,
	        originalCallbackArguments = _ref2.originalCallbackArguments;
	
	    if (registeredCallbacks.length) {
	        return executeThenableCallback({
	            registeredCallbacks: (0, _objectAssign2.default)([], registeredCallbacks).reverse(),
	            originalCallbackArguments: originalCallbackArguments
	        });
	    }
	
	    return Promise.resolve();
	};
	
	var getResultToPass = function getResultToPass(_ref3) {
	    var newResult = _ref3.newResult,
	        previousResult = _ref3.previousResult;
	
	    if (newResult !== null && (typeof newResult === 'undefined' ? 'undefined' : _typeof(newResult)) === 'object') {
	        return (0, _objectAssign2.default)({}, previousResult || {}, newResult);
	    } else {
	        return newResult || previousResult;
	    }
	};
	
	var executeThenableCallback = function executeThenableCallback(_ref4) {
	    var registeredCallbacks = _ref4.registeredCallbacks,
	        originalCallbackArguments = _ref4.originalCallbackArguments,
	        previousResult = _ref4.previousResult;
	
	    return new Promise(function (resolve, reject) {
	        var callback = registeredCallbacks.pop();
	
	        var returnValue = callback.apply(null, originalCallbackArguments);
	
	        if (returnValue && returnValue.then) {
	            returnValue.then(function (result) {
	                var resultToPass = getResultToPass({ newResult: result, previousResult: previousResult });
	
	                if (registeredCallbacks.length) {
	                    executeThenableCallback({ registeredCallbacks: registeredCallbacks, originalCallbackArguments: originalCallbackArguments, previousResult: resultToPass }).then(resolve, reject);
	                } else {
	                    resolve(resultToPass);
	                }
	            }).catch(function (error) {
	                return reject(error);
	            });
	        } else if (returnValue === false) {
	            reject();
	        } else {
	            var resultToPass = getResultToPass({ newResult: returnValue, previousResult: previousResult });
	
	            if (registeredCallbacks.length) {
	                executeThenableCallback({ registeredCallbacks: registeredCallbacks, originalCallbackArguments: originalCallbackArguments, previousResult: resultToPass }).then(resolve, reject);
	            } else {
	                resolve(resultToPass);
	            }
	        }
	    });
	};

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(667);


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// Fine Uploader 5.15.6 - MIT licensed. http://fineuploader.com
	(function(global) {
	    var qq = function(element) {
	        "use strict";
	        return {
	            hide: function() {
	                element.style.display = "none";
	                return this;
	            },
	            attach: function(type, fn) {
	                if (element.addEventListener) {
	                    element.addEventListener(type, fn, false);
	                } else if (element.attachEvent) {
	                    element.attachEvent("on" + type, fn);
	                }
	                return function() {
	                    qq(element).detach(type, fn);
	                };
	            },
	            detach: function(type, fn) {
	                if (element.removeEventListener) {
	                    element.removeEventListener(type, fn, false);
	                } else if (element.attachEvent) {
	                    element.detachEvent("on" + type, fn);
	                }
	                return this;
	            },
	            contains: function(descendant) {
	                if (!descendant) {
	                    return false;
	                }
	                if (element === descendant) {
	                    return true;
	                }
	                if (element.contains) {
	                    return element.contains(descendant);
	                } else {
	                    return !!(descendant.compareDocumentPosition(element) & 8);
	                }
	            },
	            insertBefore: function(elementB) {
	                elementB.parentNode.insertBefore(element, elementB);
	                return this;
	            },
	            remove: function() {
	                element.parentNode.removeChild(element);
	                return this;
	            },
	            css: function(styles) {
	                if (element.style == null) {
	                    throw new qq.Error("Can't apply style to node as it is not on the HTMLElement prototype chain!");
	                }
	                if (styles.opacity != null) {
	                    if (typeof element.style.opacity !== "string" && typeof element.filters !== "undefined") {
	                        styles.filter = "alpha(opacity=" + Math.round(100 * styles.opacity) + ")";
	                    }
	                }
	                qq.extend(element.style, styles);
	                return this;
	            },
	            hasClass: function(name, considerParent) {
	                var re = new RegExp("(^| )" + name + "( |$)");
	                return re.test(element.className) || !!(considerParent && re.test(element.parentNode.className));
	            },
	            addClass: function(name) {
	                if (!qq(element).hasClass(name)) {
	                    element.className += " " + name;
	                }
	                return this;
	            },
	            removeClass: function(name) {
	                var re = new RegExp("(^| )" + name + "( |$)");
	                element.className = element.className.replace(re, " ").replace(/^\s+|\s+$/g, "");
	                return this;
	            },
	            getByClass: function(className, first) {
	                var candidates, result = [];
	                if (first && element.querySelector) {
	                    return element.querySelector("." + className);
	                } else if (element.querySelectorAll) {
	                    return element.querySelectorAll("." + className);
	                }
	                candidates = element.getElementsByTagName("*");
	                qq.each(candidates, function(idx, val) {
	                    if (qq(val).hasClass(className)) {
	                        result.push(val);
	                    }
	                });
	                return first ? result[0] : result;
	            },
	            getFirstByClass: function(className) {
	                return qq(element).getByClass(className, true);
	            },
	            children: function() {
	                var children = [], child = element.firstChild;
	                while (child) {
	                    if (child.nodeType === 1) {
	                        children.push(child);
	                    }
	                    child = child.nextSibling;
	                }
	                return children;
	            },
	            setText: function(text) {
	                element.innerText = text;
	                element.textContent = text;
	                return this;
	            },
	            clearText: function() {
	                return qq(element).setText("");
	            },
	            hasAttribute: function(attrName) {
	                var attrVal;
	                if (element.hasAttribute) {
	                    if (!element.hasAttribute(attrName)) {
	                        return false;
	                    }
	                    return /^false$/i.exec(element.getAttribute(attrName)) == null;
	                } else {
	                    attrVal = element[attrName];
	                    if (attrVal === undefined) {
	                        return false;
	                    }
	                    return /^false$/i.exec(attrVal) == null;
	                }
	            }
	        };
	    };
	    (function() {
	        "use strict";
	        qq.canvasToBlob = function(canvas, mime, quality) {
	            return qq.dataUriToBlob(canvas.toDataURL(mime, quality));
	        };
	        qq.dataUriToBlob = function(dataUri) {
	            var arrayBuffer, byteString, createBlob = function(data, mime) {
	                var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder, blobBuilder = BlobBuilder && new BlobBuilder();
	                if (blobBuilder) {
	                    blobBuilder.append(data);
	                    return blobBuilder.getBlob(mime);
	                } else {
	                    return new Blob([ data ], {
	                        type: mime
	                    });
	                }
	            }, intArray, mimeString;
	            if (dataUri.split(",")[0].indexOf("base64") >= 0) {
	                byteString = atob(dataUri.split(",")[1]);
	            } else {
	                byteString = decodeURI(dataUri.split(",")[1]);
	            }
	            mimeString = dataUri.split(",")[0].split(":")[1].split(";")[0];
	            arrayBuffer = new ArrayBuffer(byteString.length);
	            intArray = new Uint8Array(arrayBuffer);
	            qq.each(byteString, function(idx, character) {
	                intArray[idx] = character.charCodeAt(0);
	            });
	            return createBlob(arrayBuffer, mimeString);
	        };
	        qq.log = function(message, level) {
	            if (window.console) {
	                if (!level || level === "info") {
	                    window.console.log(message);
	                } else {
	                    if (window.console[level]) {
	                        window.console[level](message);
	                    } else {
	                        window.console.log("<" + level + "> " + message);
	                    }
	                }
	            }
	        };
	        qq.isObject = function(variable) {
	            return variable && !variable.nodeType && Object.prototype.toString.call(variable) === "[object Object]";
	        };
	        qq.isFunction = function(variable) {
	            return typeof variable === "function";
	        };
	        qq.isArray = function(value) {
	            return Object.prototype.toString.call(value) === "[object Array]" || value && window.ArrayBuffer && value.buffer && value.buffer.constructor === ArrayBuffer;
	        };
	        qq.isItemList = function(maybeItemList) {
	            return Object.prototype.toString.call(maybeItemList) === "[object DataTransferItemList]";
	        };
	        qq.isNodeList = function(maybeNodeList) {
	            return Object.prototype.toString.call(maybeNodeList) === "[object NodeList]" || maybeNodeList.item && maybeNodeList.namedItem;
	        };
	        qq.isString = function(maybeString) {
	            return Object.prototype.toString.call(maybeString) === "[object String]";
	        };
	        qq.trimStr = function(string) {
	            if (String.prototype.trim) {
	                return string.trim();
	            }
	            return string.replace(/^\s+|\s+$/g, "");
	        };
	        qq.format = function(str) {
	            var args = Array.prototype.slice.call(arguments, 1), newStr = str, nextIdxToReplace = newStr.indexOf("{}");
	            qq.each(args, function(idx, val) {
	                var strBefore = newStr.substring(0, nextIdxToReplace), strAfter = newStr.substring(nextIdxToReplace + 2);
	                newStr = strBefore + val + strAfter;
	                nextIdxToReplace = newStr.indexOf("{}", nextIdxToReplace + val.length);
	                if (nextIdxToReplace < 0) {
	                    return false;
	                }
	            });
	            return newStr;
	        };
	        qq.isFile = function(maybeFile) {
	            return window.File && Object.prototype.toString.call(maybeFile) === "[object File]";
	        };
	        qq.isFileList = function(maybeFileList) {
	            return window.FileList && Object.prototype.toString.call(maybeFileList) === "[object FileList]";
	        };
	        qq.isFileOrInput = function(maybeFileOrInput) {
	            return qq.isFile(maybeFileOrInput) || qq.isInput(maybeFileOrInput);
	        };
	        qq.isInput = function(maybeInput, notFile) {
	            var evaluateType = function(type) {
	                var normalizedType = type.toLowerCase();
	                if (notFile) {
	                    return normalizedType !== "file";
	                }
	                return normalizedType === "file";
	            };
	            if (window.HTMLInputElement) {
	                if (Object.prototype.toString.call(maybeInput) === "[object HTMLInputElement]") {
	                    if (maybeInput.type && evaluateType(maybeInput.type)) {
	                        return true;
	                    }
	                }
	            }
	            if (maybeInput.tagName) {
	                if (maybeInput.tagName.toLowerCase() === "input") {
	                    if (maybeInput.type && evaluateType(maybeInput.type)) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        };
	        qq.isBlob = function(maybeBlob) {
	            if (window.Blob && Object.prototype.toString.call(maybeBlob) === "[object Blob]") {
	                return true;
	            }
	        };
	        qq.isXhrUploadSupported = function() {
	            var input = document.createElement("input");
	            input.type = "file";
	            return input.multiple !== undefined && typeof File !== "undefined" && typeof FormData !== "undefined" && typeof qq.createXhrInstance().upload !== "undefined";
	        };
	        qq.createXhrInstance = function() {
	            if (window.XMLHttpRequest) {
	                return new XMLHttpRequest();
	            }
	            try {
	                return new ActiveXObject("MSXML2.XMLHTTP.3.0");
	            } catch (error) {
	                qq.log("Neither XHR or ActiveX are supported!", "error");
	                return null;
	            }
	        };
	        qq.isFolderDropSupported = function(dataTransfer) {
	            return dataTransfer.items && dataTransfer.items.length > 0 && dataTransfer.items[0].webkitGetAsEntry;
	        };
	        qq.isFileChunkingSupported = function() {
	            return !qq.androidStock() && qq.isXhrUploadSupported() && (File.prototype.slice !== undefined || File.prototype.webkitSlice !== undefined || File.prototype.mozSlice !== undefined);
	        };
	        qq.sliceBlob = function(fileOrBlob, start, end) {
	            var slicer = fileOrBlob.slice || fileOrBlob.mozSlice || fileOrBlob.webkitSlice;
	            return slicer.call(fileOrBlob, start, end);
	        };
	        qq.arrayBufferToHex = function(buffer) {
	            var bytesAsHex = "", bytes = new Uint8Array(buffer);
	            qq.each(bytes, function(idx, byt) {
	                var byteAsHexStr = byt.toString(16);
	                if (byteAsHexStr.length < 2) {
	                    byteAsHexStr = "0" + byteAsHexStr;
	                }
	                bytesAsHex += byteAsHexStr;
	            });
	            return bytesAsHex;
	        };
	        qq.readBlobToHex = function(blob, startOffset, length) {
	            var initialBlob = qq.sliceBlob(blob, startOffset, startOffset + length), fileReader = new FileReader(), promise = new qq.Promise();
	            fileReader.onload = function() {
	                promise.success(qq.arrayBufferToHex(fileReader.result));
	            };
	            fileReader.onerror = promise.failure;
	            fileReader.readAsArrayBuffer(initialBlob);
	            return promise;
	        };
	        qq.extend = function(first, second, extendNested) {
	            qq.each(second, function(prop, val) {
	                if (extendNested && qq.isObject(val)) {
	                    if (first[prop] === undefined) {
	                        first[prop] = {};
	                    }
	                    qq.extend(first[prop], val, true);
	                } else {
	                    first[prop] = val;
	                }
	            });
	            return first;
	        };
	        qq.override = function(target, sourceFn) {
	            var super_ = {}, source = sourceFn(super_);
	            qq.each(source, function(srcPropName, srcPropVal) {
	                if (target[srcPropName] !== undefined) {
	                    super_[srcPropName] = target[srcPropName];
	                }
	                target[srcPropName] = srcPropVal;
	            });
	            return target;
	        };
	        qq.indexOf = function(arr, elt, from) {
	            if (arr.indexOf) {
	                return arr.indexOf(elt, from);
	            }
	            from = from || 0;
	            var len = arr.length;
	            if (from < 0) {
	                from += len;
	            }
	            for (;from < len; from += 1) {
	                if (arr.hasOwnProperty(from) && arr[from] === elt) {
	                    return from;
	                }
	            }
	            return -1;
	        };
	        qq.getUniqueId = function() {
	            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
	                var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 3 | 8;
	                return v.toString(16);
	            });
	        };
	        qq.ie = function() {
	            return navigator.userAgent.indexOf("MSIE") !== -1 || navigator.userAgent.indexOf("Trident") !== -1;
	        };
	        qq.ie7 = function() {
	            return navigator.userAgent.indexOf("MSIE 7") !== -1;
	        };
	        qq.ie8 = function() {
	            return navigator.userAgent.indexOf("MSIE 8") !== -1;
	        };
	        qq.ie10 = function() {
	            return navigator.userAgent.indexOf("MSIE 10") !== -1;
	        };
	        qq.ie11 = function() {
	            return qq.ie() && navigator.userAgent.indexOf("rv:11") !== -1;
	        };
	        qq.edge = function() {
	            return navigator.userAgent.indexOf("Edge") >= 0;
	        };
	        qq.safari = function() {
	            return navigator.vendor !== undefined && navigator.vendor.indexOf("Apple") !== -1;
	        };
	        qq.chrome = function() {
	            return navigator.vendor !== undefined && navigator.vendor.indexOf("Google") !== -1;
	        };
	        qq.opera = function() {
	            return navigator.vendor !== undefined && navigator.vendor.indexOf("Opera") !== -1;
	        };
	        qq.firefox = function() {
	            return !qq.edge() && !qq.ie11() && navigator.userAgent.indexOf("Mozilla") !== -1 && navigator.vendor !== undefined && navigator.vendor === "";
	        };
	        qq.windows = function() {
	            return navigator.platform === "Win32";
	        };
	        qq.android = function() {
	            return navigator.userAgent.toLowerCase().indexOf("android") !== -1;
	        };
	        qq.androidStock = function() {
	            return qq.android() && navigator.userAgent.toLowerCase().indexOf("chrome") < 0;
	        };
	        qq.ios6 = function() {
	            return qq.ios() && navigator.userAgent.indexOf(" OS 6_") !== -1;
	        };
	        qq.ios7 = function() {
	            return qq.ios() && navigator.userAgent.indexOf(" OS 7_") !== -1;
	        };
	        qq.ios8 = function() {
	            return qq.ios() && navigator.userAgent.indexOf(" OS 8_") !== -1;
	        };
	        qq.ios800 = function() {
	            return qq.ios() && navigator.userAgent.indexOf(" OS 8_0 ") !== -1;
	        };
	        qq.ios = function() {
	            return navigator.userAgent.indexOf("iPad") !== -1 || navigator.userAgent.indexOf("iPod") !== -1 || navigator.userAgent.indexOf("iPhone") !== -1;
	        };
	        qq.iosChrome = function() {
	            return qq.ios() && navigator.userAgent.indexOf("CriOS") !== -1;
	        };
	        qq.iosSafari = function() {
	            return qq.ios() && !qq.iosChrome() && navigator.userAgent.indexOf("Safari") !== -1;
	        };
	        qq.iosSafariWebView = function() {
	            return qq.ios() && !qq.iosChrome() && !qq.iosSafari();
	        };
	        qq.preventDefault = function(e) {
	            if (e.preventDefault) {
	                e.preventDefault();
	            } else {
	                e.returnValue = false;
	            }
	        };
	        qq.toElement = function() {
	            var div = document.createElement("div");
	            return function(html) {
	                div.innerHTML = html;
	                var element = div.firstChild;
	                div.removeChild(element);
	                return element;
	            };
	        }();
	        qq.each = function(iterableItem, callback) {
	            var keyOrIndex, retVal;
	            if (iterableItem) {
	                if (window.Storage && iterableItem.constructor === window.Storage) {
	                    for (keyOrIndex = 0; keyOrIndex < iterableItem.length; keyOrIndex++) {
	                        retVal = callback(iterableItem.key(keyOrIndex), iterableItem.getItem(iterableItem.key(keyOrIndex)));
	                        if (retVal === false) {
	                            break;
	                        }
	                    }
	                } else if (qq.isArray(iterableItem) || qq.isItemList(iterableItem) || qq.isNodeList(iterableItem)) {
	                    for (keyOrIndex = 0; keyOrIndex < iterableItem.length; keyOrIndex++) {
	                        retVal = callback(keyOrIndex, iterableItem[keyOrIndex]);
	                        if (retVal === false) {
	                            break;
	                        }
	                    }
	                } else if (qq.isString(iterableItem)) {
	                    for (keyOrIndex = 0; keyOrIndex < iterableItem.length; keyOrIndex++) {
	                        retVal = callback(keyOrIndex, iterableItem.charAt(keyOrIndex));
	                        if (retVal === false) {
	                            break;
	                        }
	                    }
	                } else {
	                    for (keyOrIndex in iterableItem) {
	                        if (Object.prototype.hasOwnProperty.call(iterableItem, keyOrIndex)) {
	                            retVal = callback(keyOrIndex, iterableItem[keyOrIndex]);
	                            if (retVal === false) {
	                                break;
	                            }
	                        }
	                    }
	                }
	            }
	        };
	        qq.bind = function(oldFunc, context) {
	            if (qq.isFunction(oldFunc)) {
	                var args = Array.prototype.slice.call(arguments, 2);
	                return function() {
	                    var newArgs = qq.extend([], args);
	                    if (arguments.length) {
	                        newArgs = newArgs.concat(Array.prototype.slice.call(arguments));
	                    }
	                    return oldFunc.apply(context, newArgs);
	                };
	            }
	            throw new Error("first parameter must be a function!");
	        };
	        qq.obj2url = function(obj, temp, prefixDone) {
	            var uristrings = [], prefix = "&", add = function(nextObj, i) {
	                var nextTemp = temp ? /\[\]$/.test(temp) ? temp : temp + "[" + i + "]" : i;
	                if (nextTemp !== "undefined" && i !== "undefined") {
	                    uristrings.push(typeof nextObj === "object" ? qq.obj2url(nextObj, nextTemp, true) : Object.prototype.toString.call(nextObj) === "[object Function]" ? encodeURIComponent(nextTemp) + "=" + encodeURIComponent(nextObj()) : encodeURIComponent(nextTemp) + "=" + encodeURIComponent(nextObj));
	                }
	            };
	            if (!prefixDone && temp) {
	                prefix = /\?/.test(temp) ? /\?$/.test(temp) ? "" : "&" : "?";
	                uristrings.push(temp);
	                uristrings.push(qq.obj2url(obj));
	            } else if (Object.prototype.toString.call(obj) === "[object Array]" && typeof obj !== "undefined") {
	                qq.each(obj, function(idx, val) {
	                    add(val, idx);
	                });
	            } else if (typeof obj !== "undefined" && obj !== null && typeof obj === "object") {
	                qq.each(obj, function(prop, val) {
	                    add(val, prop);
	                });
	            } else {
	                uristrings.push(encodeURIComponent(temp) + "=" + encodeURIComponent(obj));
	            }
	            if (temp) {
	                return uristrings.join(prefix);
	            } else {
	                return uristrings.join(prefix).replace(/^&/, "").replace(/%20/g, "+");
	            }
	        };
	        qq.obj2FormData = function(obj, formData, arrayKeyName) {
	            if (!formData) {
	                formData = new FormData();
	            }
	            qq.each(obj, function(key, val) {
	                key = arrayKeyName ? arrayKeyName + "[" + key + "]" : key;
	                if (qq.isObject(val)) {
	                    qq.obj2FormData(val, formData, key);
	                } else if (qq.isFunction(val)) {
	                    formData.append(key, val());
	                } else {
	                    formData.append(key, val);
	                }
	            });
	            return formData;
	        };
	        qq.obj2Inputs = function(obj, form) {
	            var input;
	            if (!form) {
	                form = document.createElement("form");
	            }
	            qq.obj2FormData(obj, {
	                append: function(key, val) {
	                    input = document.createElement("input");
	                    input.setAttribute("name", key);
	                    input.setAttribute("value", val);
	                    form.appendChild(input);
	                }
	            });
	            return form;
	        };
	        qq.parseJson = function(json) {
	            if (window.JSON && qq.isFunction(JSON.parse)) {
	                return JSON.parse(json);
	            } else {
	                return eval("(" + json + ")");
	            }
	        };
	        qq.getExtension = function(filename) {
	            var extIdx = filename.lastIndexOf(".") + 1;
	            if (extIdx > 0) {
	                return filename.substr(extIdx, filename.length - extIdx);
	            }
	        };
	        qq.getFilename = function(blobOrFileInput) {
	            if (qq.isInput(blobOrFileInput)) {
	                return blobOrFileInput.value.replace(/.*(\/|\\)/, "");
	            } else if (qq.isFile(blobOrFileInput)) {
	                if (blobOrFileInput.fileName !== null && blobOrFileInput.fileName !== undefined) {
	                    return blobOrFileInput.fileName;
	                }
	            }
	            return blobOrFileInput.name;
	        };
	        qq.DisposeSupport = function() {
	            var disposers = [];
	            return {
	                dispose: function() {
	                    var disposer;
	                    do {
	                        disposer = disposers.shift();
	                        if (disposer) {
	                            disposer();
	                        }
	                    } while (disposer);
	                },
	                attach: function() {
	                    var args = arguments;
	                    this.addDisposer(qq(args[0]).attach.apply(this, Array.prototype.slice.call(arguments, 1)));
	                },
	                addDisposer: function(disposeFunction) {
	                    disposers.push(disposeFunction);
	                }
	            };
	        };
	    })();
	    (function() {
	        "use strict";
	        if (true) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	                return qq;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else if (typeof module !== "undefined" && module.exports) {
	            module.exports = qq;
	        } else {
	            global.qq = qq;
	        }
	    })();
	    (function() {
	        "use strict";
	        qq.Error = function(message) {
	            this.message = "[Fine Uploader " + qq.version + "] " + message;
	        };
	        qq.Error.prototype = new Error();
	    })();
	    qq.version = "5.15.6";
	    qq.supportedFeatures = function() {
	        "use strict";
	        var supportsUploading, supportsUploadingBlobs, supportsFileDrop, supportsAjaxFileUploading, supportsFolderDrop, supportsChunking, supportsResume, supportsUploadViaPaste, supportsUploadCors, supportsDeleteFileXdr, supportsDeleteFileCorsXhr, supportsDeleteFileCors, supportsFolderSelection, supportsImagePreviews, supportsUploadProgress;
	        function testSupportsFileInputElement() {
	            var supported = true, tempInput;
	            try {
	                tempInput = document.createElement("input");
	                tempInput.type = "file";
	                qq(tempInput).hide();
	                if (tempInput.disabled) {
	                    supported = false;
	                }
	            } catch (ex) {
	                supported = false;
	            }
	            return supported;
	        }
	        function isChrome21OrHigher() {
	            return (qq.chrome() || qq.opera()) && navigator.userAgent.match(/Chrome\/[2][1-9]|Chrome\/[3-9][0-9]/) !== undefined;
	        }
	        function isChrome14OrHigher() {
	            return (qq.chrome() || qq.opera()) && navigator.userAgent.match(/Chrome\/[1][4-9]|Chrome\/[2-9][0-9]/) !== undefined;
	        }
	        function isCrossOriginXhrSupported() {
	            if (window.XMLHttpRequest) {
	                var xhr = qq.createXhrInstance();
	                return xhr.withCredentials !== undefined;
	            }
	            return false;
	        }
	        function isXdrSupported() {
	            return window.XDomainRequest !== undefined;
	        }
	        function isCrossOriginAjaxSupported() {
	            if (isCrossOriginXhrSupported()) {
	                return true;
	            }
	            return isXdrSupported();
	        }
	        function isFolderSelectionSupported() {
	            return document.createElement("input").webkitdirectory !== undefined;
	        }
	        function isLocalStorageSupported() {
	            try {
	                return !!window.localStorage && qq.isFunction(window.localStorage.setItem);
	            } catch (error) {
	                return false;
	            }
	        }
	        function isDragAndDropSupported() {
	            var span = document.createElement("span");
	            return ("draggable" in span || "ondragstart" in span && "ondrop" in span) && !qq.android() && !qq.ios();
	        }
	        supportsUploading = testSupportsFileInputElement();
	        supportsAjaxFileUploading = supportsUploading && qq.isXhrUploadSupported();
	        supportsUploadingBlobs = supportsAjaxFileUploading && !qq.androidStock();
	        supportsFileDrop = supportsAjaxFileUploading && isDragAndDropSupported();
	        supportsFolderDrop = supportsFileDrop && isChrome21OrHigher();
	        supportsChunking = supportsAjaxFileUploading && qq.isFileChunkingSupported();
	        supportsResume = supportsAjaxFileUploading && supportsChunking && isLocalStorageSupported();
	        supportsUploadViaPaste = supportsAjaxFileUploading && isChrome14OrHigher();
	        supportsUploadCors = supportsUploading && (window.postMessage !== undefined || supportsAjaxFileUploading);
	        supportsDeleteFileCorsXhr = isCrossOriginXhrSupported();
	        supportsDeleteFileXdr = isXdrSupported();
	        supportsDeleteFileCors = isCrossOriginAjaxSupported();
	        supportsFolderSelection = isFolderSelectionSupported();
	        supportsImagePreviews = supportsAjaxFileUploading && window.FileReader !== undefined;
	        supportsUploadProgress = function() {
	            if (supportsAjaxFileUploading) {
	                return !qq.androidStock() && !qq.iosChrome();
	            }
	            return false;
	        }();
	        return {
	            ajaxUploading: supportsAjaxFileUploading,
	            blobUploading: supportsUploadingBlobs,
	            canDetermineSize: supportsAjaxFileUploading,
	            chunking: supportsChunking,
	            deleteFileCors: supportsDeleteFileCors,
	            deleteFileCorsXdr: supportsDeleteFileXdr,
	            deleteFileCorsXhr: supportsDeleteFileCorsXhr,
	            dialogElement: !!window.HTMLDialogElement,
	            fileDrop: supportsFileDrop,
	            folderDrop: supportsFolderDrop,
	            folderSelection: supportsFolderSelection,
	            imagePreviews: supportsImagePreviews,
	            imageValidation: supportsImagePreviews,
	            itemSizeValidation: supportsAjaxFileUploading,
	            pause: supportsChunking,
	            progressBar: supportsUploadProgress,
	            resume: supportsResume,
	            scaling: supportsImagePreviews && supportsUploadingBlobs,
	            tiffPreviews: qq.safari(),
	            unlimitedScaledImageSize: !qq.ios(),
	            uploading: supportsUploading,
	            uploadCors: supportsUploadCors,
	            uploadCustomHeaders: supportsAjaxFileUploading,
	            uploadNonMultipart: supportsAjaxFileUploading,
	            uploadViaPaste: supportsUploadViaPaste
	        };
	    }();
	    qq.isGenericPromise = function(maybePromise) {
	        "use strict";
	        return !!(maybePromise && maybePromise.then && qq.isFunction(maybePromise.then));
	    };
	    qq.Promise = function() {
	        "use strict";
	        var successArgs, failureArgs, successCallbacks = [], failureCallbacks = [], doneCallbacks = [], state = 0;
	        qq.extend(this, {
	            then: function(onSuccess, onFailure) {
	                if (state === 0) {
	                    if (onSuccess) {
	                        successCallbacks.push(onSuccess);
	                    }
	                    if (onFailure) {
	                        failureCallbacks.push(onFailure);
	                    }
	                } else if (state === -1) {
	                    onFailure && onFailure.apply(null, failureArgs);
	                } else if (onSuccess) {
	                    onSuccess.apply(null, successArgs);
	                }
	                return this;
	            },
	            done: function(callback) {
	                if (state === 0) {
	                    doneCallbacks.push(callback);
	                } else {
	                    callback.apply(null, failureArgs === undefined ? successArgs : failureArgs);
	                }
	                return this;
	            },
	            success: function() {
	                state = 1;
	                successArgs = arguments;
	                if (successCallbacks.length) {
	                    qq.each(successCallbacks, function(idx, callback) {
	                        callback.apply(null, successArgs);
	                    });
	                }
	                if (doneCallbacks.length) {
	                    qq.each(doneCallbacks, function(idx, callback) {
	                        callback.apply(null, successArgs);
	                    });
	                }
	                return this;
	            },
	            failure: function() {
	                state = -1;
	                failureArgs = arguments;
	                if (failureCallbacks.length) {
	                    qq.each(failureCallbacks, function(idx, callback) {
	                        callback.apply(null, failureArgs);
	                    });
	                }
	                if (doneCallbacks.length) {
	                    qq.each(doneCallbacks, function(idx, callback) {
	                        callback.apply(null, failureArgs);
	                    });
	                }
	                return this;
	            }
	        });
	    };
	    qq.BlobProxy = function(referenceBlob, onCreate) {
	        "use strict";
	        qq.extend(this, {
	            referenceBlob: referenceBlob,
	            create: function() {
	                return onCreate(referenceBlob);
	            }
	        });
	    };
	    qq.UploadButton = function(o) {
	        "use strict";
	        var self = this, disposeSupport = new qq.DisposeSupport(), options = {
	            acceptFiles: null,
	            element: null,
	            focusClass: "qq-upload-button-focus",
	            folders: false,
	            hoverClass: "qq-upload-button-hover",
	            ios8BrowserCrashWorkaround: false,
	            multiple: false,
	            name: "qqfile",
	            onChange: function(input) {},
	            title: null
	        }, input, buttonId;
	        qq.extend(options, o);
	        buttonId = qq.getUniqueId();
	        function createInput() {
	            var input = document.createElement("input");
	            input.setAttribute(qq.UploadButton.BUTTON_ID_ATTR_NAME, buttonId);
	            input.setAttribute("title", options.title);
	            self.setMultiple(options.multiple, input);
	            if (options.folders && qq.supportedFeatures.folderSelection) {
	                input.setAttribute("webkitdirectory", "");
	            }
	            if (options.acceptFiles) {
	                input.setAttribute("accept", options.acceptFiles);
	            }
	            input.setAttribute("type", "file");
	            input.setAttribute("name", options.name);
	            qq(input).css({
	                position: "absolute",
	                right: 0,
	                top: 0,
	                fontFamily: "Arial",
	                fontSize: qq.ie() && !qq.ie8() ? "3500px" : "118px",
	                margin: 0,
	                padding: 0,
	                cursor: "pointer",
	                opacity: 0
	            });
	            !qq.ie7() && qq(input).css({
	                height: "100%"
	            });
	            options.element.appendChild(input);
	            disposeSupport.attach(input, "change", function() {
	                options.onChange(input);
	            });
	            disposeSupport.attach(input, "mouseover", function() {
	                qq(options.element).addClass(options.hoverClass);
	            });
	            disposeSupport.attach(input, "mouseout", function() {
	                qq(options.element).removeClass(options.hoverClass);
	            });
	            disposeSupport.attach(input, "focus", function() {
	                qq(options.element).addClass(options.focusClass);
	            });
	            disposeSupport.attach(input, "blur", function() {
	                qq(options.element).removeClass(options.focusClass);
	            });
	            return input;
	        }
	        qq(options.element).css({
	            position: "relative",
	            overflow: "hidden",
	            direction: "ltr"
	        });
	        qq.extend(this, {
	            getInput: function() {
	                return input;
	            },
	            getButtonId: function() {
	                return buttonId;
	            },
	            setMultiple: function(isMultiple, optInput) {
	                var input = optInput || this.getInput();
	                if (options.ios8BrowserCrashWorkaround && qq.ios8() && (qq.iosChrome() || qq.iosSafariWebView())) {
	                    input.setAttribute("multiple", "");
	                } else {
	                    if (isMultiple) {
	                        input.setAttribute("multiple", "");
	                    } else {
	                        input.removeAttribute("multiple");
	                    }
	                }
	            },
	            setAcceptFiles: function(acceptFiles) {
	                if (acceptFiles !== options.acceptFiles) {
	                    input.setAttribute("accept", acceptFiles);
	                }
	            },
	            reset: function() {
	                if (input.parentNode) {
	                    qq(input).remove();
	                }
	                qq(options.element).removeClass(options.focusClass);
	                input = null;
	                input = createInput();
	            }
	        });
	        input = createInput();
	    };
	    qq.UploadButton.BUTTON_ID_ATTR_NAME = "qq-button-id";
	    qq.UploadData = function(uploaderProxy) {
	        "use strict";
	        var data = [], byUuid = {}, byStatus = {}, byProxyGroupId = {}, byBatchId = {};
	        function getDataByIds(idOrIds) {
	            if (qq.isArray(idOrIds)) {
	                var entries = [];
	                qq.each(idOrIds, function(idx, id) {
	                    entries.push(data[id]);
	                });
	                return entries;
	            }
	            return data[idOrIds];
	        }
	        function getDataByUuids(uuids) {
	            if (qq.isArray(uuids)) {
	                var entries = [];
	                qq.each(uuids, function(idx, uuid) {
	                    entries.push(data[byUuid[uuid]]);
	                });
	                return entries;
	            }
	            return data[byUuid[uuids]];
	        }
	        function getDataByStatus(status) {
	            var statusResults = [], statuses = [].concat(status);
	            qq.each(statuses, function(index, statusEnum) {
	                var statusResultIndexes = byStatus[statusEnum];
	                if (statusResultIndexes !== undefined) {
	                    qq.each(statusResultIndexes, function(i, dataIndex) {
	                        statusResults.push(data[dataIndex]);
	                    });
	                }
	            });
	            return statusResults;
	        }
	        qq.extend(this, {
	            addFile: function(spec) {
	                var status = spec.status || qq.status.SUBMITTING, id = data.push({
	                    name: spec.name,
	                    originalName: spec.name,
	                    uuid: spec.uuid,
	                    size: spec.size == null ? -1 : spec.size,
	                    status: status
	                }) - 1;
	                if (spec.batchId) {
	                    data[id].batchId = spec.batchId;
	                    if (byBatchId[spec.batchId] === undefined) {
	                        byBatchId[spec.batchId] = [];
	                    }
	                    byBatchId[spec.batchId].push(id);
	                }
	                if (spec.proxyGroupId) {
	                    data[id].proxyGroupId = spec.proxyGroupId;
	                    if (byProxyGroupId[spec.proxyGroupId] === undefined) {
	                        byProxyGroupId[spec.proxyGroupId] = [];
	                    }
	                    byProxyGroupId[spec.proxyGroupId].push(id);
	                }
	                data[id].id = id;
	                byUuid[spec.uuid] = id;
	                if (byStatus[status] === undefined) {
	                    byStatus[status] = [];
	                }
	                byStatus[status].push(id);
	                spec.onBeforeStatusChange && spec.onBeforeStatusChange(id);
	                uploaderProxy.onStatusChange(id, null, status);
	                return id;
	            },
	            retrieve: function(optionalFilter) {
	                if (qq.isObject(optionalFilter) && data.length) {
	                    if (optionalFilter.id !== undefined) {
	                        return getDataByIds(optionalFilter.id);
	                    } else if (optionalFilter.uuid !== undefined) {
	                        return getDataByUuids(optionalFilter.uuid);
	                    } else if (optionalFilter.status) {
	                        return getDataByStatus(optionalFilter.status);
	                    }
	                } else {
	                    return qq.extend([], data, true);
	                }
	            },
	            reset: function() {
	                data = [];
	                byUuid = {};
	                byStatus = {};
	                byBatchId = {};
	            },
	            setStatus: function(id, newStatus) {
	                var oldStatus = data[id].status, byStatusOldStatusIndex = qq.indexOf(byStatus[oldStatus], id);
	                byStatus[oldStatus].splice(byStatusOldStatusIndex, 1);
	                data[id].status = newStatus;
	                if (byStatus[newStatus] === undefined) {
	                    byStatus[newStatus] = [];
	                }
	                byStatus[newStatus].push(id);
	                uploaderProxy.onStatusChange(id, oldStatus, newStatus);
	            },
	            uuidChanged: function(id, newUuid) {
	                var oldUuid = data[id].uuid;
	                data[id].uuid = newUuid;
	                byUuid[newUuid] = id;
	                delete byUuid[oldUuid];
	            },
	            updateName: function(id, newName) {
	                data[id].name = newName;
	            },
	            updateSize: function(id, newSize) {
	                data[id].size = newSize;
	            },
	            setParentId: function(targetId, parentId) {
	                data[targetId].parentId = parentId;
	            },
	            getIdsInProxyGroup: function(id) {
	                var proxyGroupId = data[id].proxyGroupId;
	                if (proxyGroupId) {
	                    return byProxyGroupId[proxyGroupId];
	                }
	                return [];
	            },
	            getIdsInBatch: function(id) {
	                var batchId = data[id].batchId;
	                return byBatchId[batchId];
	            }
	        });
	    };
	    qq.status = {
	        SUBMITTING: "submitting",
	        SUBMITTED: "submitted",
	        REJECTED: "rejected",
	        QUEUED: "queued",
	        CANCELED: "canceled",
	        PAUSED: "paused",
	        UPLOADING: "uploading",
	        UPLOAD_RETRYING: "retrying upload",
	        UPLOAD_SUCCESSFUL: "upload successful",
	        UPLOAD_FAILED: "upload failed",
	        DELETE_FAILED: "delete failed",
	        DELETING: "deleting",
	        DELETED: "deleted"
	    };
	    (function() {
	        "use strict";
	        qq.basePublicApi = {
	            addBlobs: function(blobDataOrArray, params, endpoint) {
	                this.addFiles(blobDataOrArray, params, endpoint);
	            },
	            addInitialFiles: function(cannedFileList) {
	                var self = this;
	                qq.each(cannedFileList, function(index, cannedFile) {
	                    self._addCannedFile(cannedFile);
	                });
	            },
	            addFiles: function(data, params, endpoint) {
	                this._maybeHandleIos8SafariWorkaround();
	                var batchId = this._storedIds.length === 0 ? qq.getUniqueId() : this._currentBatchId, processBlob = qq.bind(function(blob) {
	                    this._handleNewFile({
	                        blob: blob,
	                        name: this._options.blobs.defaultName
	                    }, batchId, verifiedFiles);
	                }, this), processBlobData = qq.bind(function(blobData) {
	                    this._handleNewFile(blobData, batchId, verifiedFiles);
	                }, this), processCanvas = qq.bind(function(canvas) {
	                    var blob = qq.canvasToBlob(canvas);
	                    this._handleNewFile({
	                        blob: blob,
	                        name: this._options.blobs.defaultName + ".png"
	                    }, batchId, verifiedFiles);
	                }, this), processCanvasData = qq.bind(function(canvasData) {
	                    var normalizedQuality = canvasData.quality && canvasData.quality / 100, blob = qq.canvasToBlob(canvasData.canvas, canvasData.type, normalizedQuality);
	                    this._handleNewFile({
	                        blob: blob,
	                        name: canvasData.name
	                    }, batchId, verifiedFiles);
	                }, this), processFileOrInput = qq.bind(function(fileOrInput) {
	                    if (qq.isInput(fileOrInput) && qq.supportedFeatures.ajaxUploading) {
	                        var files = Array.prototype.slice.call(fileOrInput.files), self = this;
	                        qq.each(files, function(idx, file) {
	                            self._handleNewFile(file, batchId, verifiedFiles);
	                        });
	                    } else {
	                        this._handleNewFile(fileOrInput, batchId, verifiedFiles);
	                    }
	                }, this), normalizeData = function() {
	                    if (qq.isFileList(data)) {
	                        data = Array.prototype.slice.call(data);
	                    }
	                    data = [].concat(data);
	                }, self = this, verifiedFiles = [];
	                this._currentBatchId = batchId;
	                if (data) {
	                    normalizeData();
	                    qq.each(data, function(idx, fileContainer) {
	                        if (qq.isFileOrInput(fileContainer)) {
	                            processFileOrInput(fileContainer);
	                        } else if (qq.isBlob(fileContainer)) {
	                            processBlob(fileContainer);
	                        } else if (qq.isObject(fileContainer)) {
	                            if (fileContainer.blob && fileContainer.name) {
	                                processBlobData(fileContainer);
	                            } else if (fileContainer.canvas && fileContainer.name) {
	                                processCanvasData(fileContainer);
	                            }
	                        } else if (fileContainer.tagName && fileContainer.tagName.toLowerCase() === "canvas") {
	                            processCanvas(fileContainer);
	                        } else {
	                            self.log(fileContainer + " is not a valid file container!  Ignoring!", "warn");
	                        }
	                    });
	                    this.log("Received " + verifiedFiles.length + " files.");
	                    this._prepareItemsForUpload(verifiedFiles, params, endpoint);
	                }
	            },
	            cancel: function(id) {
	                this._handler.cancel(id);
	            },
	            cancelAll: function() {
	                var storedIdsCopy = [], self = this;
	                qq.extend(storedIdsCopy, this._storedIds);
	                qq.each(storedIdsCopy, function(idx, storedFileId) {
	                    self.cancel(storedFileId);
	                });
	                this._handler.cancelAll();
	            },
	            clearStoredFiles: function() {
	                this._storedIds = [];
	            },
	            continueUpload: function(id) {
	                var uploadData = this._uploadData.retrieve({
	                    id: id
	                });
	                if (!qq.supportedFeatures.pause || !this._options.chunking.enabled) {
	                    return false;
	                }
	                if (uploadData.status === qq.status.PAUSED) {
	                    this.log(qq.format("Paused file ID {} ({}) will be continued.  Not paused.", id, this.getName(id)));
	                    this._uploadFile(id);
	                    return true;
	                } else {
	                    this.log(qq.format("Ignoring continue for file ID {} ({}).  Not paused.", id, this.getName(id)), "error");
	                }
	                return false;
	            },
	            deleteFile: function(id) {
	                return this._onSubmitDelete(id);
	            },
	            doesExist: function(fileOrBlobId) {
	                return this._handler.isValid(fileOrBlobId);
	            },
	            drawThumbnail: function(fileId, imgOrCanvas, maxSize, fromServer, customResizeFunction) {
	                var promiseToReturn = new qq.Promise(), fileOrUrl, options;
	                if (this._imageGenerator) {
	                    fileOrUrl = this._thumbnailUrls[fileId];
	                    options = {
	                        customResizeFunction: customResizeFunction,
	                        maxSize: maxSize > 0 ? maxSize : null,
	                        scale: maxSize > 0
	                    };
	                    if (!fromServer && qq.supportedFeatures.imagePreviews) {
	                        fileOrUrl = this.getFile(fileId);
	                    }
	                    if (fileOrUrl == null) {
	                        promiseToReturn.failure({
	                            container: imgOrCanvas,
	                            error: "File or URL not found."
	                        });
	                    } else {
	                        this._imageGenerator.generate(fileOrUrl, imgOrCanvas, options).then(function success(modifiedContainer) {
	                            promiseToReturn.success(modifiedContainer);
	                        }, function failure(container, reason) {
	                            promiseToReturn.failure({
	                                container: container,
	                                error: reason || "Problem generating thumbnail"
	                            });
	                        });
	                    }
	                } else {
	                    promiseToReturn.failure({
	                        container: imgOrCanvas,
	                        error: "Missing image generator module"
	                    });
	                }
	                return promiseToReturn;
	            },
	            getButton: function(fileId) {
	                return this._getButton(this._buttonIdsForFileIds[fileId]);
	            },
	            getEndpoint: function(fileId) {
	                return this._endpointStore.get(fileId);
	            },
	            getFile: function(fileOrBlobId) {
	                return this._handler.getFile(fileOrBlobId) || null;
	            },
	            getInProgress: function() {
	                return this._uploadData.retrieve({
	                    status: [ qq.status.UPLOADING, qq.status.UPLOAD_RETRYING, qq.status.QUEUED ]
	                }).length;
	            },
	            getName: function(id) {
	                return this._uploadData.retrieve({
	                    id: id
	                }).name;
	            },
	            getParentId: function(id) {
	                var uploadDataEntry = this.getUploads({
	                    id: id
	                }), parentId = null;
	                if (uploadDataEntry) {
	                    if (uploadDataEntry.parentId !== undefined) {
	                        parentId = uploadDataEntry.parentId;
	                    }
	                }
	                return parentId;
	            },
	            getResumableFilesData: function() {
	                return this._handler.getResumableFilesData();
	            },
	            getSize: function(id) {
	                return this._uploadData.retrieve({
	                    id: id
	                }).size;
	            },
	            getNetUploads: function() {
	                return this._netUploaded;
	            },
	            getRemainingAllowedItems: function() {
	                var allowedItems = this._currentItemLimit;
	                if (allowedItems > 0) {
	                    return allowedItems - this._netUploadedOrQueued;
	                }
	                return null;
	            },
	            getUploads: function(optionalFilter) {
	                return this._uploadData.retrieve(optionalFilter);
	            },
	            getUuid: function(id) {
	                return this._uploadData.retrieve({
	                    id: id
	                }).uuid;
	            },
	            log: function(str, level) {
	                if (this._options.debug && (!level || level === "info")) {
	                    qq.log("[Fine Uploader " + qq.version + "] " + str);
	                } else if (level && level !== "info") {
	                    qq.log("[Fine Uploader " + qq.version + "] " + str, level);
	                }
	            },
	            pauseUpload: function(id) {
	                var uploadData = this._uploadData.retrieve({
	                    id: id
	                });
	                if (!qq.supportedFeatures.pause || !this._options.chunking.enabled) {
	                    return false;
	                }
	                if (qq.indexOf([ qq.status.UPLOADING, qq.status.UPLOAD_RETRYING ], uploadData.status) >= 0) {
	                    if (this._handler.pause(id)) {
	                        this._uploadData.setStatus(id, qq.status.PAUSED);
	                        return true;
	                    } else {
	                        this.log(qq.format("Unable to pause file ID {} ({}).", id, this.getName(id)), "error");
	                    }
	                } else {
	                    this.log(qq.format("Ignoring pause for file ID {} ({}).  Not in progress.", id, this.getName(id)), "error");
	                }
	                return false;
	            },
	            removeFileRef: function(id) {
	                this._handler.expunge(id);
	            },
	            reset: function() {
	                this.log("Resetting uploader...");
	                this._handler.reset();
	                this._storedIds = [];
	                this._autoRetries = [];
	                this._retryTimeouts = [];
	                this._preventRetries = [];
	                this._thumbnailUrls = [];
	                qq.each(this._buttons, function(idx, button) {
	                    button.reset();
	                });
	                this._paramsStore.reset();
	                this._endpointStore.reset();
	                this._netUploadedOrQueued = 0;
	                this._netUploaded = 0;
	                this._uploadData.reset();
	                this._buttonIdsForFileIds = [];
	                this._pasteHandler && this._pasteHandler.reset();
	                this._options.session.refreshOnReset && this._refreshSessionData();
	                this._succeededSinceLastAllComplete = [];
	                this._failedSinceLastAllComplete = [];
	                this._totalProgress && this._totalProgress.reset();
	            },
	            retry: function(id) {
	                return this._manualRetry(id);
	            },
	            scaleImage: function(id, specs) {
	                var self = this;
	                return qq.Scaler.prototype.scaleImage(id, specs, {
	                    log: qq.bind(self.log, self),
	                    getFile: qq.bind(self.getFile, self),
	                    uploadData: self._uploadData
	                });
	            },
	            setCustomHeaders: function(headers, id) {
	                this._customHeadersStore.set(headers, id);
	            },
	            setDeleteFileCustomHeaders: function(headers, id) {
	                this._deleteFileCustomHeadersStore.set(headers, id);
	            },
	            setDeleteFileEndpoint: function(endpoint, id) {
	                this._deleteFileEndpointStore.set(endpoint, id);
	            },
	            setDeleteFileParams: function(params, id) {
	                this._deleteFileParamsStore.set(params, id);
	            },
	            setEndpoint: function(endpoint, id) {
	                this._endpointStore.set(endpoint, id);
	            },
	            setForm: function(elementOrId) {
	                this._updateFormSupportAndParams(elementOrId);
	            },
	            setItemLimit: function(newItemLimit) {
	                this._currentItemLimit = newItemLimit;
	            },
	            setName: function(id, newName) {
	                this._uploadData.updateName(id, newName);
	            },
	            setParams: function(params, id) {
	                this._paramsStore.set(params, id);
	            },
	            setUuid: function(id, newUuid) {
	                return this._uploadData.uuidChanged(id, newUuid);
	            },
	            setStatus: function(id, newStatus) {
	                var fileRecord = this.getUploads({
	                    id: id
	                });
	                if (!fileRecord) {
	                    throw new qq.Error(id + " is not a valid file ID.");
	                }
	                switch (newStatus) {
	                  case qq.status.DELETED:
	                    this._onDeleteComplete(id, null, false);
	                    break;
	
	                  case qq.status.DELETE_FAILED:
	                    this._onDeleteComplete(id, null, true);
	                    break;
	
	                  default:
	                    var errorMessage = "Method setStatus called on '" + name + "' not implemented yet for " + newStatus;
	                    this.log(errorMessage);
	                    throw new qq.Error(errorMessage);
	                }
	            },
	            uploadStoredFiles: function() {
	                if (this._storedIds.length === 0) {
	                    this._itemError("noFilesError");
	                } else {
	                    this._uploadStoredFiles();
	                }
	            }
	        };
	        qq.basePrivateApi = {
	            _addCannedFile: function(sessionData) {
	                var self = this;
	                return this._uploadData.addFile({
	                    uuid: sessionData.uuid,
	                    name: sessionData.name,
	                    size: sessionData.size,
	                    status: qq.status.UPLOAD_SUCCESSFUL,
	                    onBeforeStatusChange: function(id) {
	                        sessionData.deleteFileEndpoint && self.setDeleteFileEndpoint(sessionData.deleteFileEndpoint, id);
	                        sessionData.deleteFileParams && self.setDeleteFileParams(sessionData.deleteFileParams, id);
	                        if (sessionData.thumbnailUrl) {
	                            self._thumbnailUrls[id] = sessionData.thumbnailUrl;
	                        }
	                        self._netUploaded++;
	                        self._netUploadedOrQueued++;
	                    }
	                });
	            },
	            _annotateWithButtonId: function(file, associatedInput) {
	                if (qq.isFile(file)) {
	                    file.qqButtonId = this._getButtonId(associatedInput);
	                }
	            },
	            _batchError: function(message) {
	                this._options.callbacks.onError(null, null, message, undefined);
	            },
	            _createDeleteHandler: function() {
	                var self = this;
	                return new qq.DeleteFileAjaxRequester({
	                    method: this._options.deleteFile.method.toUpperCase(),
	                    maxConnections: this._options.maxConnections,
	                    uuidParamName: this._options.request.uuidName,
	                    customHeaders: this._deleteFileCustomHeadersStore,
	                    paramsStore: this._deleteFileParamsStore,
	                    endpointStore: this._deleteFileEndpointStore,
	                    cors: this._options.cors,
	                    log: qq.bind(self.log, self),
	                    onDelete: function(id) {
	                        self._onDelete(id);
	                        self._options.callbacks.onDelete(id);
	                    },
	                    onDeleteComplete: function(id, xhrOrXdr, isError) {
	                        self._onDeleteComplete(id, xhrOrXdr, isError);
	                        self._options.callbacks.onDeleteComplete(id, xhrOrXdr, isError);
	                    }
	                });
	            },
	            _createPasteHandler: function() {
	                var self = this;
	                return new qq.PasteSupport({
	                    targetElement: this._options.paste.targetElement,
	                    callbacks: {
	                        log: qq.bind(self.log, self),
	                        pasteReceived: function(blob) {
	                            self._handleCheckedCallback({
	                                name: "onPasteReceived",
	                                callback: qq.bind(self._options.callbacks.onPasteReceived, self, blob),
	                                onSuccess: qq.bind(self._handlePasteSuccess, self, blob),
	                                identifier: "pasted image"
	                            });
	                        }
	                    }
	                });
	            },
	            _createStore: function(initialValue, _readOnlyValues_) {
	                var store = {}, catchall = initialValue, perIdReadOnlyValues = {}, readOnlyValues = _readOnlyValues_, copy = function(orig) {
	                    if (qq.isObject(orig)) {
	                        return qq.extend({}, orig);
	                    }
	                    return orig;
	                }, getReadOnlyValues = function() {
	                    if (qq.isFunction(readOnlyValues)) {
	                        return readOnlyValues();
	                    }
	                    return readOnlyValues;
	                }, includeReadOnlyValues = function(id, existing) {
	                    if (readOnlyValues && qq.isObject(existing)) {
	                        qq.extend(existing, getReadOnlyValues());
	                    }
	                    if (perIdReadOnlyValues[id]) {
	                        qq.extend(existing, perIdReadOnlyValues[id]);
	                    }
	                };
	                return {
	                    set: function(val, id) {
	                        if (id == null) {
	                            store = {};
	                            catchall = copy(val);
	                        } else {
	                            store[id] = copy(val);
	                        }
	                    },
	                    get: function(id) {
	                        var values;
	                        if (id != null && store[id]) {
	                            values = store[id];
	                        } else {
	                            values = copy(catchall);
	                        }
	                        includeReadOnlyValues(id, values);
	                        return copy(values);
	                    },
	                    addReadOnly: function(id, values) {
	                        if (qq.isObject(store)) {
	                            if (id === null) {
	                                if (qq.isFunction(values)) {
	                                    readOnlyValues = values;
	                                } else {
	                                    readOnlyValues = readOnlyValues || {};
	                                    qq.extend(readOnlyValues, values);
	                                }
	                            } else {
	                                perIdReadOnlyValues[id] = perIdReadOnlyValues[id] || {};
	                                qq.extend(perIdReadOnlyValues[id], values);
	                            }
	                        }
	                    },
	                    remove: function(fileId) {
	                        return delete store[fileId];
	                    },
	                    reset: function() {
	                        store = {};
	                        perIdReadOnlyValues = {};
	                        catchall = initialValue;
	                    }
	                };
	            },
	            _createUploadDataTracker: function() {
	                var self = this;
	                return new qq.UploadData({
	                    getName: function(id) {
	                        return self.getName(id);
	                    },
	                    getUuid: function(id) {
	                        return self.getUuid(id);
	                    },
	                    getSize: function(id) {
	                        return self.getSize(id);
	                    },
	                    onStatusChange: function(id, oldStatus, newStatus) {
	                        self._onUploadStatusChange(id, oldStatus, newStatus);
	                        self._options.callbacks.onStatusChange(id, oldStatus, newStatus);
	                        self._maybeAllComplete(id, newStatus);
	                        if (self._totalProgress) {
	                            setTimeout(function() {
	                                self._totalProgress.onStatusChange(id, oldStatus, newStatus);
	                            }, 0);
	                        }
	                    }
	                });
	            },
	            _createUploadButton: function(spec) {
	                var self = this, acceptFiles = spec.accept || this._options.validation.acceptFiles, allowedExtensions = spec.allowedExtensions || this._options.validation.allowedExtensions, button;
	                function allowMultiple() {
	                    if (qq.supportedFeatures.ajaxUploading) {
	                        if (self._options.workarounds.iosEmptyVideos && qq.ios() && !qq.ios6() && self._isAllowedExtension(allowedExtensions, ".mov")) {
	                            return false;
	                        }
	                        if (spec.multiple === undefined) {
	                            return self._options.multiple;
	                        }
	                        return spec.multiple;
	                    }
	                    return false;
	                }
	                button = new qq.UploadButton({
	                    acceptFiles: acceptFiles,
	                    element: spec.element,
	                    focusClass: this._options.classes.buttonFocus,
	                    folders: spec.folders,
	                    hoverClass: this._options.classes.buttonHover,
	                    ios8BrowserCrashWorkaround: this._options.workarounds.ios8BrowserCrash,
	                    multiple: allowMultiple(),
	                    name: this._options.request.inputName,
	                    onChange: function(input) {
	                        self._onInputChange(input);
	                    },
	                    title: spec.title == null ? this._options.text.fileInputTitle : spec.title
	                });
	                this._disposeSupport.addDisposer(function() {
	                    button.dispose();
	                });
	                self._buttons.push(button);
	                return button;
	            },
	            _createUploadHandler: function(additionalOptions, namespace) {
	                var self = this, lastOnProgress = {}, options = {
	                    debug: this._options.debug,
	                    maxConnections: this._options.maxConnections,
	                    cors: this._options.cors,
	                    paramsStore: this._paramsStore,
	                    endpointStore: this._endpointStore,
	                    chunking: this._options.chunking,
	                    resume: this._options.resume,
	                    blobs: this._options.blobs,
	                    log: qq.bind(self.log, self),
	                    preventRetryParam: this._options.retry.preventRetryResponseProperty,
	                    onProgress: function(id, name, loaded, total) {
	                        if (loaded < 0 || total < 0) {
	                            return;
	                        }
	                        if (lastOnProgress[id]) {
	                            if (lastOnProgress[id].loaded !== loaded || lastOnProgress[id].total !== total) {
	                                self._onProgress(id, name, loaded, total);
	                                self._options.callbacks.onProgress(id, name, loaded, total);
	                            }
	                        } else {
	                            self._onProgress(id, name, loaded, total);
	                            self._options.callbacks.onProgress(id, name, loaded, total);
	                        }
	                        lastOnProgress[id] = {
	                            loaded: loaded,
	                            total: total
	                        };
	                    },
	                    onComplete: function(id, name, result, xhr) {
	                        delete lastOnProgress[id];
	                        var status = self.getUploads({
	                            id: id
	                        }).status, retVal;
	                        if (status === qq.status.UPLOAD_SUCCESSFUL || status === qq.status.UPLOAD_FAILED) {
	                            return;
	                        }
	                        retVal = self._onComplete(id, name, result, xhr);
	                        if (retVal instanceof qq.Promise) {
	                            retVal.done(function() {
	                                self._options.callbacks.onComplete(id, name, result, xhr);
	                            });
	                        } else {
	                            self._options.callbacks.onComplete(id, name, result, xhr);
	                        }
	                    },
	                    onCancel: function(id, name, cancelFinalizationEffort) {
	                        var promise = new qq.Promise();
	                        self._handleCheckedCallback({
	                            name: "onCancel",
	                            callback: qq.bind(self._options.callbacks.onCancel, self, id, name),
	                            onFailure: promise.failure,
	                            onSuccess: function() {
	                                cancelFinalizationEffort.then(function() {
	                                    self._onCancel(id, name);
	                                });
	                                promise.success();
	                            },
	                            identifier: id
	                        });
	                        return promise;
	                    },
	                    onUploadPrep: qq.bind(this._onUploadPrep, this),
	                    onUpload: function(id, name) {
	                        self._onUpload(id, name);
	                        self._options.callbacks.onUpload(id, name);
	                    },
	                    onUploadChunk: function(id, name, chunkData) {
	                        self._onUploadChunk(id, chunkData);
	                        self._options.callbacks.onUploadChunk(id, name, chunkData);
	                    },
	                    onUploadChunkSuccess: function(id, chunkData, result, xhr) {
	                        self._onUploadChunkSuccess(id, chunkData);
	                        self._options.callbacks.onUploadChunkSuccess.apply(self, arguments);
	                    },
	                    onResume: function(id, name, chunkData) {
	                        return self._options.callbacks.onResume(id, name, chunkData);
	                    },
	                    onAutoRetry: function(id, name, responseJSON, xhr) {
	                        return self._onAutoRetry.apply(self, arguments);
	                    },
	                    onUuidChanged: function(id, newUuid) {
	                        self.log("Server requested UUID change from '" + self.getUuid(id) + "' to '" + newUuid + "'");
	                        self.setUuid(id, newUuid);
	                    },
	                    getName: qq.bind(self.getName, self),
	                    getUuid: qq.bind(self.getUuid, self),
	                    getSize: qq.bind(self.getSize, self),
	                    setSize: qq.bind(self._setSize, self),
	                    getDataByUuid: function(uuid) {
	                        return self.getUploads({
	                            uuid: uuid
	                        });
	                    },
	                    isQueued: function(id) {
	                        var status = self.getUploads({
	                            id: id
	                        }).status;
	                        return status === qq.status.QUEUED || status === qq.status.SUBMITTED || status === qq.status.UPLOAD_RETRYING || status === qq.status.PAUSED;
	                    },
	                    getIdsInProxyGroup: self._uploadData.getIdsInProxyGroup,
	                    getIdsInBatch: self._uploadData.getIdsInBatch
	                };
	                qq.each(this._options.request, function(prop, val) {
	                    options[prop] = val;
	                });
	                options.customHeaders = this._customHeadersStore;
	                if (additionalOptions) {
	                    qq.each(additionalOptions, function(key, val) {
	                        options[key] = val;
	                    });
	                }
	                return new qq.UploadHandlerController(options, namespace);
	            },
	            _fileOrBlobRejected: function(id) {
	                this._netUploadedOrQueued--;
	                this._uploadData.setStatus(id, qq.status.REJECTED);
	            },
	            _formatSize: function(bytes) {
	                if (bytes === 0) {
	                    return bytes + this._options.text.sizeSymbols[0];
	                }
	                var i = -1;
	                do {
	                    bytes = bytes / 1e3;
	                    i++;
	                } while (bytes > 999);
	                return Math.max(bytes, .1).toFixed(1) + this._options.text.sizeSymbols[i];
	            },
	            _generateExtraButtonSpecs: function() {
	                var self = this;
	                this._extraButtonSpecs = {};
	                qq.each(this._options.extraButtons, function(idx, extraButtonOptionEntry) {
	                    var multiple = extraButtonOptionEntry.multiple, validation = qq.extend({}, self._options.validation, true), extraButtonSpec = qq.extend({}, extraButtonOptionEntry);
	                    if (multiple === undefined) {
	                        multiple = self._options.multiple;
	                    }
	                    if (extraButtonSpec.validation) {
	                        qq.extend(validation, extraButtonOptionEntry.validation, true);
	                    }
	                    qq.extend(extraButtonSpec, {
	                        multiple: multiple,
	                        validation: validation
	                    }, true);
	                    self._initExtraButton(extraButtonSpec);
	                });
	            },
	            _getButton: function(buttonId) {
	                var extraButtonsSpec = this._extraButtonSpecs[buttonId];
	                if (extraButtonsSpec) {
	                    return extraButtonsSpec.element;
	                } else if (buttonId === this._defaultButtonId) {
	                    return this._options.button;
	                }
	            },
	            _getButtonId: function(buttonOrFileInputOrFile) {
	                var inputs, fileInput, fileBlobOrInput = buttonOrFileInputOrFile;
	                if (fileBlobOrInput instanceof qq.BlobProxy) {
	                    fileBlobOrInput = fileBlobOrInput.referenceBlob;
	                }
	                if (fileBlobOrInput && !qq.isBlob(fileBlobOrInput)) {
	                    if (qq.isFile(fileBlobOrInput)) {
	                        return fileBlobOrInput.qqButtonId;
	                    } else if (fileBlobOrInput.tagName.toLowerCase() === "input" && fileBlobOrInput.type.toLowerCase() === "file") {
	                        return fileBlobOrInput.getAttribute(qq.UploadButton.BUTTON_ID_ATTR_NAME);
	                    }
	                    inputs = fileBlobOrInput.getElementsByTagName("input");
	                    qq.each(inputs, function(idx, input) {
	                        if (input.getAttribute("type") === "file") {
	                            fileInput = input;
	                            return false;
	                        }
	                    });
	                    if (fileInput) {
	                        return fileInput.getAttribute(qq.UploadButton.BUTTON_ID_ATTR_NAME);
	                    }
	                }
	            },
	            _getNotFinished: function() {
	                return this._uploadData.retrieve({
	                    status: [ qq.status.UPLOADING, qq.status.UPLOAD_RETRYING, qq.status.QUEUED, qq.status.SUBMITTING, qq.status.SUBMITTED, qq.status.PAUSED ]
	                }).length;
	            },
	            _getValidationBase: function(buttonId) {
	                var extraButtonSpec = this._extraButtonSpecs[buttonId];
	                return extraButtonSpec ? extraButtonSpec.validation : this._options.validation;
	            },
	            _getValidationDescriptor: function(fileWrapper) {
	                if (fileWrapper.file instanceof qq.BlobProxy) {
	                    return {
	                        name: qq.getFilename(fileWrapper.file.referenceBlob),
	                        size: fileWrapper.file.referenceBlob.size
	                    };
	                }
	                return {
	                    name: this.getUploads({
	                        id: fileWrapper.id
	                    }).name,
	                    size: this.getUploads({
	                        id: fileWrapper.id
	                    }).size
	                };
	            },
	            _getValidationDescriptors: function(fileWrappers) {
	                var self = this, fileDescriptors = [];
	                qq.each(fileWrappers, function(idx, fileWrapper) {
	                    fileDescriptors.push(self._getValidationDescriptor(fileWrapper));
	                });
	                return fileDescriptors;
	            },
	            _handleCameraAccess: function() {
	                if (this._options.camera.ios && qq.ios()) {
	                    var acceptIosCamera = "image/*;capture=camera", button = this._options.camera.button, buttonId = button ? this._getButtonId(button) : this._defaultButtonId, optionRoot = this._options;
	                    if (buttonId && buttonId !== this._defaultButtonId) {
	                        optionRoot = this._extraButtonSpecs[buttonId];
	                    }
	                    optionRoot.multiple = false;
	                    if (optionRoot.validation.acceptFiles === null) {
	                        optionRoot.validation.acceptFiles = acceptIosCamera;
	                    } else {
	                        optionRoot.validation.acceptFiles += "," + acceptIosCamera;
	                    }
	                    qq.each(this._buttons, function(idx, button) {
	                        if (button.getButtonId() === buttonId) {
	                            button.setMultiple(optionRoot.multiple);
	                            button.setAcceptFiles(optionRoot.acceptFiles);
	                            return false;
	                        }
	                    });
	                }
	            },
	            _handleCheckedCallback: function(details) {
	                var self = this, callbackRetVal = details.callback();
	                if (qq.isGenericPromise(callbackRetVal)) {
	                    this.log(details.name + " - waiting for " + details.name + " promise to be fulfilled for " + details.identifier);
	                    return callbackRetVal.then(function(successParam) {
	                        self.log(details.name + " promise success for " + details.identifier);
	                        details.onSuccess(successParam);
	                    }, function() {
	                        if (details.onFailure) {
	                            self.log(details.name + " promise failure for " + details.identifier);
	                            details.onFailure();
	                        } else {
	                            self.log(details.name + " promise failure for " + details.identifier);
	                        }
	                    });
	                }
	                if (callbackRetVal !== false) {
	                    details.onSuccess(callbackRetVal);
	                } else {
	                    if (details.onFailure) {
	                        this.log(details.name + " - return value was 'false' for " + details.identifier + ".  Invoking failure callback.");
	                        details.onFailure();
	                    } else {
	                        this.log(details.name + " - return value was 'false' for " + details.identifier + ".  Will not proceed.");
	                    }
	                }
	                return callbackRetVal;
	            },
	            _handleNewFile: function(file, batchId, newFileWrapperList) {
	                var self = this, uuid = qq.getUniqueId(), size = -1, name = qq.getFilename(file), actualFile = file.blob || file, handler = this._customNewFileHandler ? this._customNewFileHandler : qq.bind(self._handleNewFileGeneric, self);
	                if (!qq.isInput(actualFile) && actualFile.size >= 0) {
	                    size = actualFile.size;
	                }
	                handler(actualFile, name, uuid, size, newFileWrapperList, batchId, this._options.request.uuidName, {
	                    uploadData: self._uploadData,
	                    paramsStore: self._paramsStore,
	                    addFileToHandler: function(id, file) {
	                        self._handler.add(id, file);
	                        self._netUploadedOrQueued++;
	                        self._trackButton(id);
	                    }
	                });
	            },
	            _handleNewFileGeneric: function(file, name, uuid, size, fileList, batchId) {
	                var id = this._uploadData.addFile({
	                    uuid: uuid,
	                    name: name,
	                    size: size,
	                    batchId: batchId
	                });
	                this._handler.add(id, file);
	                this._trackButton(id);
	                this._netUploadedOrQueued++;
	                fileList.push({
	                    id: id,
	                    file: file
	                });
	            },
	            _handlePasteSuccess: function(blob, extSuppliedName) {
	                var extension = blob.type.split("/")[1], name = extSuppliedName;
	                if (name == null) {
	                    name = this._options.paste.defaultName;
	                }
	                name += "." + extension;
	                this.addFiles({
	                    name: name,
	                    blob: blob
	                });
	            },
	            _handleDeleteSuccess: function(id) {
	                if (this.getUploads({
	                    id: id
	                }).status !== qq.status.DELETED) {
	                    var name = this.getName(id);
	                    this._netUploadedOrQueued--;
	                    this._netUploaded--;
	                    this._handler.expunge(id);
	                    this._uploadData.setStatus(id, qq.status.DELETED);
	                    this.log("Delete request for '" + name + "' has succeeded.");
	                }
	            },
	            _handleDeleteFailed: function(id, xhrOrXdr) {
	                var name = this.getName(id);
	                this._uploadData.setStatus(id, qq.status.DELETE_FAILED);
	                this.log("Delete request for '" + name + "' has failed.", "error");
	                if (!xhrOrXdr || xhrOrXdr.withCredentials === undefined) {
	                    this._options.callbacks.onError(id, name, "Delete request failed", xhrOrXdr);
	                } else {
	                    this._options.callbacks.onError(id, name, "Delete request failed with response code " + xhrOrXdr.status, xhrOrXdr);
	                }
	            },
	            _initExtraButton: function(spec) {
	                var button = this._createUploadButton({
	                    accept: spec.validation.acceptFiles,
	                    allowedExtensions: spec.validation.allowedExtensions,
	                    element: spec.element,
	                    folders: spec.folders,
	                    multiple: spec.multiple,
	                    title: spec.fileInputTitle
	                });
	                this._extraButtonSpecs[button.getButtonId()] = spec;
	            },
	            _initFormSupportAndParams: function() {
	                this._formSupport = qq.FormSupport && new qq.FormSupport(this._options.form, qq.bind(this.uploadStoredFiles, this), qq.bind(this.log, this));
	                if (this._formSupport && this._formSupport.attachedToForm) {
	                    this._paramsStore = this._createStore(this._options.request.params, this._formSupport.getFormInputsAsObject);
	                    this._options.autoUpload = this._formSupport.newAutoUpload;
	                    if (this._formSupport.newEndpoint) {
	                        this._options.request.endpoint = this._formSupport.newEndpoint;
	                    }
	                } else {
	                    this._paramsStore = this._createStore(this._options.request.params);
	                }
	            },
	            _isDeletePossible: function() {
	                if (!qq.DeleteFileAjaxRequester || !this._options.deleteFile.enabled) {
	                    return false;
	                }
	                if (this._options.cors.expected) {
	                    if (qq.supportedFeatures.deleteFileCorsXhr) {
	                        return true;
	                    }
	                    if (qq.supportedFeatures.deleteFileCorsXdr && this._options.cors.allowXdr) {
	                        return true;
	                    }
	                    return false;
	                }
	                return true;
	            },
	            _isAllowedExtension: function(allowed, fileName) {
	                var valid = false;
	                if (!allowed.length) {
	                    return true;
	                }
	                qq.each(allowed, function(idx, allowedExt) {
	                    if (qq.isString(allowedExt)) {
	                        var extRegex = new RegExp("\\." + allowedExt + "$", "i");
	                        if (fileName.match(extRegex) != null) {
	                            valid = true;
	                            return false;
	                        }
	                    }
	                });
	                return valid;
	            },
	            _itemError: function(code, maybeNameOrNames, item) {
	                var message = this._options.messages[code], allowedExtensions = [], names = [].concat(maybeNameOrNames), name = names[0], buttonId = this._getButtonId(item), validationBase = this._getValidationBase(buttonId), extensionsForMessage, placeholderMatch;
	                function r(name, replacement) {
	                    message = message.replace(name, replacement);
	                }
	                qq.each(validationBase.allowedExtensions, function(idx, allowedExtension) {
	                    if (qq.isString(allowedExtension)) {
	                        allowedExtensions.push(allowedExtension);
	                    }
	                });
	                extensionsForMessage = allowedExtensions.join(", ").toLowerCase();
	                r("{file}", this._options.formatFileName(name));
	                r("{extensions}", extensionsForMessage);
	                r("{sizeLimit}", this._formatSize(validationBase.sizeLimit));
	                r("{minSizeLimit}", this._formatSize(validationBase.minSizeLimit));
	                placeholderMatch = message.match(/(\{\w+\})/g);
	                if (placeholderMatch !== null) {
	                    qq.each(placeholderMatch, function(idx, placeholder) {
	                        r(placeholder, names[idx]);
	                    });
	                }
	                this._options.callbacks.onError(null, name, message, undefined);
	                return message;
	            },
	            _manualRetry: function(id, callback) {
	                if (this._onBeforeManualRetry(id)) {
	                    this._netUploadedOrQueued++;
	                    this._uploadData.setStatus(id, qq.status.UPLOAD_RETRYING);
	                    if (callback) {
	                        callback(id);
	                    } else {
	                        this._handler.retry(id);
	                    }
	                    return true;
	                }
	            },
	            _maybeAllComplete: function(id, status) {
	                var self = this, notFinished = this._getNotFinished();
	                if (status === qq.status.UPLOAD_SUCCESSFUL) {
	                    this._succeededSinceLastAllComplete.push(id);
	                } else if (status === qq.status.UPLOAD_FAILED) {
	                    this._failedSinceLastAllComplete.push(id);
	                }
	                if (notFinished === 0 && (this._succeededSinceLastAllComplete.length || this._failedSinceLastAllComplete.length)) {
	                    setTimeout(function() {
	                        self._onAllComplete(self._succeededSinceLastAllComplete, self._failedSinceLastAllComplete);
	                    }, 0);
	                }
	            },
	            _maybeHandleIos8SafariWorkaround: function() {
	                var self = this;
	                if (this._options.workarounds.ios8SafariUploads && qq.ios800() && qq.iosSafari()) {
	                    setTimeout(function() {
	                        window.alert(self._options.messages.unsupportedBrowserIos8Safari);
	                    }, 0);
	                    throw new qq.Error(this._options.messages.unsupportedBrowserIos8Safari);
	                }
	            },
	            _maybeParseAndSendUploadError: function(id, name, response, xhr) {
	                if (!response.success) {
	                    if (xhr && xhr.status !== 200 && !response.error) {
	                        this._options.callbacks.onError(id, name, "XHR returned response code " + xhr.status, xhr);
	                    } else {
	                        var errorReason = response.error ? response.error : this._options.text.defaultResponseError;
	                        this._options.callbacks.onError(id, name, errorReason, xhr);
	                    }
	                }
	            },
	            _maybeProcessNextItemAfterOnValidateCallback: function(validItem, items, index, params, endpoint) {
	                var self = this;
	                if (items.length > index) {
	                    if (validItem || !this._options.validation.stopOnFirstInvalidFile) {
	                        setTimeout(function() {
	                            var validationDescriptor = self._getValidationDescriptor(items[index]), buttonId = self._getButtonId(items[index].file), button = self._getButton(buttonId);
	                            self._handleCheckedCallback({
	                                name: "onValidate",
	                                callback: qq.bind(self._options.callbacks.onValidate, self, validationDescriptor, button),
	                                onSuccess: qq.bind(self._onValidateCallbackSuccess, self, items, index, params, endpoint),
	                                onFailure: qq.bind(self._onValidateCallbackFailure, self, items, index, params, endpoint),
	                                identifier: "Item '" + validationDescriptor.name + "', size: " + validationDescriptor.size
	                            });
	                        }, 0);
	                    } else if (!validItem) {
	                        for (;index < items.length; index++) {
	                            self._fileOrBlobRejected(items[index].id);
	                        }
	                    }
	                }
	            },
	            _onAllComplete: function(successful, failed) {
	                this._totalProgress && this._totalProgress.onAllComplete(successful, failed, this._preventRetries);
	                this._options.callbacks.onAllComplete(qq.extend([], successful), qq.extend([], failed));
	                this._succeededSinceLastAllComplete = [];
	                this._failedSinceLastAllComplete = [];
	            },
	            _onAutoRetry: function(id, name, responseJSON, xhr, callback) {
	                var self = this;
	                self._preventRetries[id] = responseJSON[self._options.retry.preventRetryResponseProperty];
	                if (self._shouldAutoRetry(id, name, responseJSON)) {
	                    var retryWaitPeriod = self._options.retry.autoAttemptDelay * 1e3;
	                    self._maybeParseAndSendUploadError.apply(self, arguments);
	                    self._options.callbacks.onAutoRetry(id, name, self._autoRetries[id]);
	                    self._onBeforeAutoRetry(id, name);
	                    self._uploadData.setStatus(id, qq.status.UPLOAD_RETRYING);
	                    self._retryTimeouts[id] = setTimeout(function() {
	                        self.log("Starting retry for " + name + "...");
	                        if (callback) {
	                            callback(id);
	                        } else {
	                            self._handler.retry(id);
	                        }
	                    }, retryWaitPeriod);
	                    return true;
	                }
	            },
	            _onBeforeAutoRetry: function(id, name) {
	                this.log("Waiting " + this._options.retry.autoAttemptDelay + " seconds before retrying " + name + "...");
	            },
	            _onBeforeManualRetry: function(id) {
	                var itemLimit = this._currentItemLimit, fileName;
	                if (this._preventRetries[id]) {
	                    this.log("Retries are forbidden for id " + id, "warn");
	                    return false;
	                } else if (this._handler.isValid(id)) {
	                    fileName = this.getName(id);
	                    if (this._options.callbacks.onManualRetry(id, fileName) === false) {
	                        return false;
	                    }
	                    if (itemLimit > 0 && this._netUploadedOrQueued + 1 > itemLimit) {
	                        this._itemError("retryFailTooManyItems");
	                        return false;
	                    }
	                    this.log("Retrying upload for '" + fileName + "' (id: " + id + ")...");
	                    return true;
	                } else {
	                    this.log("'" + id + "' is not a valid file ID", "error");
	                    return false;
	                }
	            },
	            _onCancel: function(id, name) {
	                this._netUploadedOrQueued--;
	                clearTimeout(this._retryTimeouts[id]);
	                var storedItemIndex = qq.indexOf(this._storedIds, id);
	                if (!this._options.autoUpload && storedItemIndex >= 0) {
	                    this._storedIds.splice(storedItemIndex, 1);
	                }
	                this._uploadData.setStatus(id, qq.status.CANCELED);
	            },
	            _onComplete: function(id, name, result, xhr) {
	                if (!result.success) {
	                    this._netUploadedOrQueued--;
	                    this._uploadData.setStatus(id, qq.status.UPLOAD_FAILED);
	                    if (result[this._options.retry.preventRetryResponseProperty] === true) {
	                        this._preventRetries[id] = true;
	                    }
	                } else {
	                    if (result.thumbnailUrl) {
	                        this._thumbnailUrls[id] = result.thumbnailUrl;
	                    }
	                    this._netUploaded++;
	                    this._uploadData.setStatus(id, qq.status.UPLOAD_SUCCESSFUL);
	                }
	                this._maybeParseAndSendUploadError(id, name, result, xhr);
	                return result.success ? true : false;
	            },
	            _onDelete: function(id) {
	                this._uploadData.setStatus(id, qq.status.DELETING);
	            },
	            _onDeleteComplete: function(id, xhrOrXdr, isError) {
	                var name = this.getName(id);
	                if (isError) {
	                    this._handleDeleteFailed(id, xhrOrXdr);
	                } else {
	                    this._handleDeleteSuccess(id);
	                }
	            },
	            _onInputChange: function(input) {
	                var fileIndex;
	                if (qq.supportedFeatures.ajaxUploading) {
	                    for (fileIndex = 0; fileIndex < input.files.length; fileIndex++) {
	                        this._annotateWithButtonId(input.files[fileIndex], input);
	                    }
	                    this.addFiles(input.files);
	                } else if (input.value.length > 0) {
	                    this.addFiles(input);
	                }
	                qq.each(this._buttons, function(idx, button) {
	                    button.reset();
	                });
	            },
	            _onProgress: function(id, name, loaded, total) {
	                this._totalProgress && this._totalProgress.onIndividualProgress(id, loaded, total);
	            },
	            _onSubmit: function(id, name) {},
	            _onSubmitCallbackSuccess: function(id, name) {
	                this._onSubmit.apply(this, arguments);
	                this._uploadData.setStatus(id, qq.status.SUBMITTED);
	                this._onSubmitted.apply(this, arguments);
	                if (this._options.autoUpload) {
	                    this._options.callbacks.onSubmitted.apply(this, arguments);
	                    this._uploadFile(id);
	                } else {
	                    this._storeForLater(id);
	                    this._options.callbacks.onSubmitted.apply(this, arguments);
	                }
	            },
	            _onSubmitDelete: function(id, onSuccessCallback, additionalMandatedParams) {
	                var uuid = this.getUuid(id), adjustedOnSuccessCallback;
	                if (onSuccessCallback) {
	                    adjustedOnSuccessCallback = qq.bind(onSuccessCallback, this, id, uuid, additionalMandatedParams);
	                }
	                if (this._isDeletePossible()) {
	                    this._handleCheckedCallback({
	                        name: "onSubmitDelete",
	                        callback: qq.bind(this._options.callbacks.onSubmitDelete, this, id),
	                        onSuccess: adjustedOnSuccessCallback || qq.bind(this._deleteHandler.sendDelete, this, id, uuid, additionalMandatedParams),
	                        identifier: id
	                    });
	                    return true;
	                } else {
	                    this.log("Delete request ignored for ID " + id + ", delete feature is disabled or request not possible " + "due to CORS on a user agent that does not support pre-flighting.", "warn");
	                    return false;
	                }
	            },
	            _onSubmitted: function(id) {},
	            _onTotalProgress: function(loaded, total) {
	                this._options.callbacks.onTotalProgress(loaded, total);
	            },
	            _onUploadPrep: function(id) {},
	            _onUpload: function(id, name) {
	                this._uploadData.setStatus(id, qq.status.UPLOADING);
	            },
	            _onUploadChunk: function(id, chunkData) {},
	            _onUploadChunkSuccess: function(id, chunkData) {
	                if (!this._preventRetries[id] && this._options.retry.enableAuto) {
	                    this._autoRetries[id] = 0;
	                }
	            },
	            _onUploadStatusChange: function(id, oldStatus, newStatus) {
	                if (newStatus === qq.status.PAUSED) {
	                    clearTimeout(this._retryTimeouts[id]);
	                }
	            },
	            _onValidateBatchCallbackFailure: function(fileWrappers) {
	                var self = this;
	                qq.each(fileWrappers, function(idx, fileWrapper) {
	                    self._fileOrBlobRejected(fileWrapper.id);
	                });
	            },
	            _onValidateBatchCallbackSuccess: function(validationDescriptors, items, params, endpoint, button) {
	                var errorMessage, itemLimit = this._currentItemLimit, proposedNetFilesUploadedOrQueued = this._netUploadedOrQueued;
	                if (itemLimit === 0 || proposedNetFilesUploadedOrQueued <= itemLimit) {
	                    if (items.length > 0) {
	                        this._handleCheckedCallback({
	                            name: "onValidate",
	                            callback: qq.bind(this._options.callbacks.onValidate, this, validationDescriptors[0], button),
	                            onSuccess: qq.bind(this._onValidateCallbackSuccess, this, items, 0, params, endpoint),
	                            onFailure: qq.bind(this._onValidateCallbackFailure, this, items, 0, params, endpoint),
	                            identifier: "Item '" + items[0].file.name + "', size: " + items[0].file.size
	                        });
	                    } else {
	                        this._itemError("noFilesError");
	                    }
	                } else {
	                    this._onValidateBatchCallbackFailure(items);
	                    errorMessage = this._options.messages.tooManyItemsError.replace(/\{netItems\}/g, proposedNetFilesUploadedOrQueued).replace(/\{itemLimit\}/g, itemLimit);
	                    this._batchError(errorMessage);
	                }
	            },
	            _onValidateCallbackFailure: function(items, index, params, endpoint) {
	                var nextIndex = index + 1;
	                this._fileOrBlobRejected(items[index].id, items[index].file.name);
	                this._maybeProcessNextItemAfterOnValidateCallback(false, items, nextIndex, params, endpoint);
	            },
	            _onValidateCallbackSuccess: function(items, index, params, endpoint) {
	                var self = this, nextIndex = index + 1, validationDescriptor = this._getValidationDescriptor(items[index]);
	                this._validateFileOrBlobData(items[index], validationDescriptor).then(function() {
	                    self._upload(items[index].id, params, endpoint);
	                    self._maybeProcessNextItemAfterOnValidateCallback(true, items, nextIndex, params, endpoint);
	                }, function() {
	                    self._maybeProcessNextItemAfterOnValidateCallback(false, items, nextIndex, params, endpoint);
	                });
	            },
	            _prepareItemsForUpload: function(items, params, endpoint) {
	                if (items.length === 0) {
	                    this._itemError("noFilesError");
	                    return;
	                }
	                var validationDescriptors = this._getValidationDescriptors(items), buttonId = this._getButtonId(items[0].file), button = this._getButton(buttonId);
	                this._handleCheckedCallback({
	                    name: "onValidateBatch",
	                    callback: qq.bind(this._options.callbacks.onValidateBatch, this, validationDescriptors, button),
	                    onSuccess: qq.bind(this._onValidateBatchCallbackSuccess, this, validationDescriptors, items, params, endpoint, button),
	                    onFailure: qq.bind(this._onValidateBatchCallbackFailure, this, items),
	                    identifier: "batch validation"
	                });
	            },
	            _preventLeaveInProgress: function() {
	                var self = this;
	                this._disposeSupport.attach(window, "beforeunload", function(e) {
	                    if (self.getInProgress()) {
	                        e = e || window.event;
	                        e.returnValue = self._options.messages.onLeave;
	                        return self._options.messages.onLeave;
	                    }
	                });
	            },
	            _refreshSessionData: function() {
	                var self = this, options = this._options.session;
	                if (qq.Session && this._options.session.endpoint != null) {
	                    if (!this._session) {
	                        qq.extend(options, {
	                            cors: this._options.cors
	                        });
	                        options.log = qq.bind(this.log, this);
	                        options.addFileRecord = qq.bind(this._addCannedFile, this);
	                        this._session = new qq.Session(options);
	                    }
	                    setTimeout(function() {
	                        self._session.refresh().then(function(response, xhrOrXdr) {
	                            self._sessionRequestComplete();
	                            self._options.callbacks.onSessionRequestComplete(response, true, xhrOrXdr);
	                        }, function(response, xhrOrXdr) {
	                            self._options.callbacks.onSessionRequestComplete(response, false, xhrOrXdr);
	                        });
	                    }, 0);
	                }
	            },
	            _sessionRequestComplete: function() {},
	            _setSize: function(id, newSize) {
	                this._uploadData.updateSize(id, newSize);
	                this._totalProgress && this._totalProgress.onNewSize(id);
	            },
	            _shouldAutoRetry: function(id, name, responseJSON) {
	                var uploadData = this._uploadData.retrieve({
	                    id: id
	                });
	                if (!this._preventRetries[id] && this._options.retry.enableAuto && uploadData.status !== qq.status.PAUSED) {
	                    if (this._autoRetries[id] === undefined) {
	                        this._autoRetries[id] = 0;
	                    }
	                    if (this._autoRetries[id] < this._options.retry.maxAutoAttempts) {
	                        this._autoRetries[id] += 1;
	                        return true;
	                    }
	                }
	                return false;
	            },
	            _storeForLater: function(id) {
	                this._storedIds.push(id);
	            },
	            _trackButton: function(id) {
	                var buttonId;
	                if (qq.supportedFeatures.ajaxUploading) {
	                    buttonId = this._handler.getFile(id).qqButtonId;
	                } else {
	                    buttonId = this._getButtonId(this._handler.getInput(id));
	                }
	                if (buttonId) {
	                    this._buttonIdsForFileIds[id] = buttonId;
	                }
	            },
	            _updateFormSupportAndParams: function(formElementOrId) {
	                this._options.form.element = formElementOrId;
	                this._formSupport = qq.FormSupport && new qq.FormSupport(this._options.form, qq.bind(this.uploadStoredFiles, this), qq.bind(this.log, this));
	                if (this._formSupport && this._formSupport.attachedToForm) {
	                    this._paramsStore.addReadOnly(null, this._formSupport.getFormInputsAsObject);
	                    this._options.autoUpload = this._formSupport.newAutoUpload;
	                    if (this._formSupport.newEndpoint) {
	                        this.setEndpoint(this._formSupport.newEndpoint);
	                    }
	                }
	            },
	            _upload: function(id, params, endpoint) {
	                var name = this.getName(id);
	                if (params) {
	                    this.setParams(params, id);
	                }
	                if (endpoint) {
	                    this.setEndpoint(endpoint, id);
	                }
	                this._handleCheckedCallback({
	                    name: "onSubmit",
	                    callback: qq.bind(this._options.callbacks.onSubmit, this, id, name),
	                    onSuccess: qq.bind(this._onSubmitCallbackSuccess, this, id, name),
	                    onFailure: qq.bind(this._fileOrBlobRejected, this, id, name),
	                    identifier: id
	                });
	            },
	            _uploadFile: function(id) {
	                if (!this._handler.upload(id)) {
	                    this._uploadData.setStatus(id, qq.status.QUEUED);
	                }
	            },
	            _uploadStoredFiles: function() {
	                var idToUpload, stillSubmitting, self = this;
	                while (this._storedIds.length) {
	                    idToUpload = this._storedIds.shift();
	                    this._uploadFile(idToUpload);
	                }
	                stillSubmitting = this.getUploads({
	                    status: qq.status.SUBMITTING
	                }).length;
	                if (stillSubmitting) {
	                    qq.log("Still waiting for " + stillSubmitting + " files to clear submit queue. Will re-parse stored IDs array shortly.");
	                    setTimeout(function() {
	                        self._uploadStoredFiles();
	                    }, 1e3);
	                }
	            },
	            _validateFileOrBlobData: function(fileWrapper, validationDescriptor) {
	                var self = this, file = function() {
	                    if (fileWrapper.file instanceof qq.BlobProxy) {
	                        return fileWrapper.file.referenceBlob;
	                    }
	                    return fileWrapper.file;
	                }(), name = validationDescriptor.name, size = validationDescriptor.size, buttonId = this._getButtonId(fileWrapper.file), validationBase = this._getValidationBase(buttonId), validityChecker = new qq.Promise();
	                validityChecker.then(function() {}, function() {
	                    self._fileOrBlobRejected(fileWrapper.id, name);
	                });
	                if (qq.isFileOrInput(file) && !this._isAllowedExtension(validationBase.allowedExtensions, name)) {
	                    this._itemError("typeError", name, file);
	                    return validityChecker.failure();
	                }
	                if (!this._options.validation.allowEmpty && size === 0) {
	                    this._itemError("emptyError", name, file);
	                    return validityChecker.failure();
	                }
	                if (size > 0 && validationBase.sizeLimit && size > validationBase.sizeLimit) {
	                    this._itemError("sizeError", name, file);
	                    return validityChecker.failure();
	                }
	                if (size > 0 && size < validationBase.minSizeLimit) {
	                    this._itemError("minSizeError", name, file);
	                    return validityChecker.failure();
	                }
	                if (qq.ImageValidation && qq.supportedFeatures.imagePreviews && qq.isFile(file)) {
	                    new qq.ImageValidation(file, qq.bind(self.log, self)).validate(validationBase.image).then(validityChecker.success, function(errorCode) {
	                        self._itemError(errorCode + "ImageError", name, file);
	                        validityChecker.failure();
	                    });
	                } else {
	                    validityChecker.success();
	                }
	                return validityChecker;
	            },
	            _wrapCallbacks: function() {
	                var self, safeCallback, prop;
	                self = this;
	                safeCallback = function(name, callback, args) {
	                    var errorMsg;
	                    try {
	                        return callback.apply(self, args);
	                    } catch (exception) {
	                        errorMsg = exception.message || exception.toString();
	                        self.log("Caught exception in '" + name + "' callback - " + errorMsg, "error");
	                    }
	                };
	                for (prop in this._options.callbacks) {
	                    (function() {
	                        var callbackName, callbackFunc;
	                        callbackName = prop;
	                        callbackFunc = self._options.callbacks[callbackName];
	                        self._options.callbacks[callbackName] = function() {
	                            return safeCallback(callbackName, callbackFunc, arguments);
	                        };
	                    })();
	                }
	            }
	        };
	    })();
	    (function() {
	        "use strict";
	        qq.FineUploaderBasic = function(o) {
	            var self = this;
	            this._options = {
	                debug: false,
	                button: null,
	                multiple: true,
	                maxConnections: 3,
	                disableCancelForFormUploads: false,
	                autoUpload: true,
	                request: {
	                    customHeaders: {},
	                    endpoint: "/server/upload",
	                    filenameParam: "qqfilename",
	                    forceMultipart: true,
	                    inputName: "qqfile",
	                    method: "POST",
	                    params: {},
	                    paramsInBody: true,
	                    totalFileSizeName: "qqtotalfilesize",
	                    uuidName: "qquuid"
	                },
	                validation: {
	                    allowedExtensions: [],
	                    sizeLimit: 0,
	                    minSizeLimit: 0,
	                    itemLimit: 0,
	                    stopOnFirstInvalidFile: true,
	                    acceptFiles: null,
	                    image: {
	                        maxHeight: 0,
	                        maxWidth: 0,
	                        minHeight: 0,
	                        minWidth: 0
	                    },
	                    allowEmpty: false
	                },
	                callbacks: {
	                    onSubmit: function(id, name) {},
	                    onSubmitted: function(id, name) {},
	                    onComplete: function(id, name, responseJSON, maybeXhr) {},
	                    onAllComplete: function(successful, failed) {},
	                    onCancel: function(id, name) {},
	                    onUpload: function(id, name) {},
	                    onUploadChunk: function(id, name, chunkData) {},
	                    onUploadChunkSuccess: function(id, chunkData, responseJSON, xhr) {},
	                    onResume: function(id, fileName, chunkData) {},
	                    onProgress: function(id, name, loaded, total) {},
	                    onTotalProgress: function(loaded, total) {},
	                    onError: function(id, name, reason, maybeXhrOrXdr) {},
	                    onAutoRetry: function(id, name, attemptNumber) {},
	                    onManualRetry: function(id, name) {},
	                    onValidateBatch: function(fileOrBlobData) {},
	                    onValidate: function(fileOrBlobData) {},
	                    onSubmitDelete: function(id) {},
	                    onDelete: function(id) {},
	                    onDeleteComplete: function(id, xhrOrXdr, isError) {},
	                    onPasteReceived: function(blob) {},
	                    onStatusChange: function(id, oldStatus, newStatus) {},
	                    onSessionRequestComplete: function(response, success, xhrOrXdr) {}
	                },
	                messages: {
	                    typeError: "{file} has an invalid extension. Valid extension(s): {extensions}.",
	                    sizeError: "{file} is too large, maximum file size is {sizeLimit}.",
	                    minSizeError: "{file} is too small, minimum file size is {minSizeLimit}.",
	                    emptyError: "{file} is empty, please select files again without it.",
	                    noFilesError: "No files to upload.",
	                    tooManyItemsError: "Too many items ({netItems}) would be uploaded.  Item limit is {itemLimit}.",
	                    maxHeightImageError: "Image is too tall.",
	                    maxWidthImageError: "Image is too wide.",
	                    minHeightImageError: "Image is not tall enough.",
	                    minWidthImageError: "Image is not wide enough.",
	                    retryFailTooManyItems: "Retry failed - you have reached your file limit.",
	                    onLeave: "The files are being uploaded, if you leave now the upload will be canceled.",
	                    unsupportedBrowserIos8Safari: "Unrecoverable error - this browser does not permit file uploading of any kind due to serious bugs in iOS8 Safari.  Please use iOS8 Chrome until Apple fixes these issues."
	                },
	                retry: {
	                    enableAuto: false,
	                    maxAutoAttempts: 3,
	                    autoAttemptDelay: 5,
	                    preventRetryResponseProperty: "preventRetry"
	                },
	                classes: {
	                    buttonHover: "qq-upload-button-hover",
	                    buttonFocus: "qq-upload-button-focus"
	                },
	                chunking: {
	                    enabled: false,
	                    concurrent: {
	                        enabled: false
	                    },
	                    mandatory: false,
	                    paramNames: {
	                        partIndex: "qqpartindex",
	                        partByteOffset: "qqpartbyteoffset",
	                        chunkSize: "qqchunksize",
	                        totalFileSize: "qqtotalfilesize",
	                        totalParts: "qqtotalparts"
	                    },
	                    partSize: 2e6,
	                    success: {
	                        endpoint: null
	                    }
	                },
	                resume: {
	                    enabled: false,
	                    recordsExpireIn: 7,
	                    paramNames: {
	                        resuming: "qqresume"
	                    }
	                },
	                formatFileName: function(fileOrBlobName) {
	                    return fileOrBlobName;
	                },
	                text: {
	                    defaultResponseError: "Upload failure reason unknown",
	                    fileInputTitle: "file input",
	                    sizeSymbols: [ "kB", "MB", "GB", "TB", "PB", "EB" ]
	                },
	                deleteFile: {
	                    enabled: false,
	                    method: "DELETE",
	                    endpoint: "/server/upload",
	                    customHeaders: {},
	                    params: {}
	                },
	                cors: {
	                    expected: false,
	                    sendCredentials: false,
	                    allowXdr: false
	                },
	                blobs: {
	                    defaultName: "misc_data"
	                },
	                paste: {
	                    targetElement: null,
	                    defaultName: "pasted_image"
	                },
	                camera: {
	                    ios: false,
	                    button: null
	                },
	                extraButtons: [],
	                session: {
	                    endpoint: null,
	                    params: {},
	                    customHeaders: {},
	                    refreshOnReset: true
	                },
	                form: {
	                    element: "qq-form",
	                    autoUpload: false,
	                    interceptSubmit: true
	                },
	                scaling: {
	                    customResizer: null,
	                    sendOriginal: true,
	                    orient: true,
	                    defaultType: null,
	                    defaultQuality: 80,
	                    failureText: "Failed to scale",
	                    includeExif: false,
	                    sizes: []
	                },
	                workarounds: {
	                    iosEmptyVideos: true,
	                    ios8SafariUploads: true,
	                    ios8BrowserCrash: false
	                }
	            };
	            qq.extend(this._options, o, true);
	            this._buttons = [];
	            this._extraButtonSpecs = {};
	            this._buttonIdsForFileIds = [];
	            this._wrapCallbacks();
	            this._disposeSupport = new qq.DisposeSupport();
	            this._storedIds = [];
	            this._autoRetries = [];
	            this._retryTimeouts = [];
	            this._preventRetries = [];
	            this._thumbnailUrls = [];
	            this._netUploadedOrQueued = 0;
	            this._netUploaded = 0;
	            this._uploadData = this._createUploadDataTracker();
	            this._initFormSupportAndParams();
	            this._customHeadersStore = this._createStore(this._options.request.customHeaders);
	            this._deleteFileCustomHeadersStore = this._createStore(this._options.deleteFile.customHeaders);
	            this._deleteFileParamsStore = this._createStore(this._options.deleteFile.params);
	            this._endpointStore = this._createStore(this._options.request.endpoint);
	            this._deleteFileEndpointStore = this._createStore(this._options.deleteFile.endpoint);
	            this._handler = this._createUploadHandler();
	            this._deleteHandler = qq.DeleteFileAjaxRequester && this._createDeleteHandler();
	            if (this._options.button) {
	                this._defaultButtonId = this._createUploadButton({
	                    element: this._options.button,
	                    title: this._options.text.fileInputTitle
	                }).getButtonId();
	            }
	            this._generateExtraButtonSpecs();
	            this._handleCameraAccess();
	            if (this._options.paste.targetElement) {
	                if (qq.PasteSupport) {
	                    this._pasteHandler = this._createPasteHandler();
	                } else {
	                    this.log("Paste support module not found", "error");
	                }
	            }
	            this._preventLeaveInProgress();
	            this._imageGenerator = qq.ImageGenerator && new qq.ImageGenerator(qq.bind(this.log, this));
	            this._refreshSessionData();
	            this._succeededSinceLastAllComplete = [];
	            this._failedSinceLastAllComplete = [];
	            this._scaler = qq.Scaler && new qq.Scaler(this._options.scaling, qq.bind(this.log, this)) || {};
	            if (this._scaler.enabled) {
	                this._customNewFileHandler = qq.bind(this._scaler.handleNewFile, this._scaler);
	            }
	            if (qq.TotalProgress && qq.supportedFeatures.progressBar) {
	                this._totalProgress = new qq.TotalProgress(qq.bind(this._onTotalProgress, this), function(id) {
	                    var entry = self._uploadData.retrieve({
	                        id: id
	                    });
	                    return entry && entry.size || 0;
	                });
	            }
	            this._currentItemLimit = this._options.validation.itemLimit;
	        };
	        qq.FineUploaderBasic.prototype = qq.basePublicApi;
	        qq.extend(qq.FineUploaderBasic.prototype, qq.basePrivateApi);
	    })();
	    qq.AjaxRequester = function(o) {
	        "use strict";
	        var log, shouldParamsBeInQueryString, queue = [], requestData = {}, options = {
	            acceptHeader: null,
	            validMethods: [ "PATCH", "POST", "PUT" ],
	            method: "POST",
	            contentType: "application/x-www-form-urlencoded",
	            maxConnections: 3,
	            customHeaders: {},
	            endpointStore: {},
	            paramsStore: {},
	            mandatedParams: {},
	            allowXRequestedWithAndCacheControl: true,
	            successfulResponseCodes: {
	                DELETE: [ 200, 202, 204 ],
	                PATCH: [ 200, 201, 202, 203, 204 ],
	                POST: [ 200, 201, 202, 203, 204 ],
	                PUT: [ 200, 201, 202, 203, 204 ],
	                GET: [ 200 ]
	            },
	            cors: {
	                expected: false,
	                sendCredentials: false
	            },
	            log: function(str, level) {},
	            onSend: function(id) {},
	            onComplete: function(id, xhrOrXdr, isError) {},
	            onProgress: null
	        };
	        qq.extend(options, o);
	        log = options.log;
	        if (qq.indexOf(options.validMethods, options.method) < 0) {
	            throw new Error("'" + options.method + "' is not a supported method for this type of request!");
	        }
	        function isSimpleMethod() {
	            return qq.indexOf([ "GET", "POST", "HEAD" ], options.method) >= 0;
	        }
	        function containsNonSimpleHeaders(headers) {
	            var containsNonSimple = false;
	            qq.each(containsNonSimple, function(idx, header) {
	                if (qq.indexOf([ "Accept", "Accept-Language", "Content-Language", "Content-Type" ], header) < 0) {
	                    containsNonSimple = true;
	                    return false;
	                }
	            });
	            return containsNonSimple;
	        }
	        function isXdr(xhr) {
	            return options.cors.expected && xhr.withCredentials === undefined;
	        }
	        function getCorsAjaxTransport() {
	            var xhrOrXdr;
	            if (window.XMLHttpRequest || window.ActiveXObject) {
	                xhrOrXdr = qq.createXhrInstance();
	                if (xhrOrXdr.withCredentials === undefined) {
	                    xhrOrXdr = new XDomainRequest();
	                    xhrOrXdr.onload = function() {};
	                    xhrOrXdr.onerror = function() {};
	                    xhrOrXdr.ontimeout = function() {};
	                    xhrOrXdr.onprogress = function() {};
	                }
	            }
	            return xhrOrXdr;
	        }
	        function getXhrOrXdr(id, suppliedXhr) {
	            var xhrOrXdr = requestData[id].xhr;
	            if (!xhrOrXdr) {
	                if (suppliedXhr) {
	                    xhrOrXdr = suppliedXhr;
	                } else {
	                    if (options.cors.expected) {
	                        xhrOrXdr = getCorsAjaxTransport();
	                    } else {
	                        xhrOrXdr = qq.createXhrInstance();
	                    }
	                }
	                requestData[id].xhr = xhrOrXdr;
	            }
	            return xhrOrXdr;
	        }
	        function dequeue(id) {
	            var i = qq.indexOf(queue, id), max = options.maxConnections, nextId;
	            delete requestData[id];
	            queue.splice(i, 1);
	            if (queue.length >= max && i < max) {
	                nextId = queue[max - 1];
	                sendRequest(nextId);
	            }
	        }
	        function onComplete(id, xdrError) {
	            var xhr = getXhrOrXdr(id), method = options.method, isError = xdrError === true;
	            dequeue(id);
	            if (isError) {
	                log(method + " request for " + id + " has failed", "error");
	            } else if (!isXdr(xhr) && !isResponseSuccessful(xhr.status)) {
	                isError = true;
	                log(method + " request for " + id + " has failed - response code " + xhr.status, "error");
	            }
	            options.onComplete(id, xhr, isError);
	        }
	        function getParams(id) {
	            var onDemandParams = requestData[id].additionalParams, mandatedParams = options.mandatedParams, params;
	            if (options.paramsStore.get) {
	                params = options.paramsStore.get(id);
	            }
	            if (onDemandParams) {
	                qq.each(onDemandParams, function(name, val) {
	                    params = params || {};
	                    params[name] = val;
	                });
	            }
	            if (mandatedParams) {
	                qq.each(mandatedParams, function(name, val) {
	                    params = params || {};
	                    params[name] = val;
	                });
	            }
	            return params;
	        }
	        function sendRequest(id, optXhr) {
	            var xhr = getXhrOrXdr(id, optXhr), method = options.method, params = getParams(id), payload = requestData[id].payload, url;
	            options.onSend(id);
	            url = createUrl(id, params, requestData[id].additionalQueryParams);
	            if (isXdr(xhr)) {
	                xhr.onload = getXdrLoadHandler(id);
	                xhr.onerror = getXdrErrorHandler(id);
	            } else {
	                xhr.onreadystatechange = getXhrReadyStateChangeHandler(id);
	            }
	            registerForUploadProgress(id);
	            xhr.open(method, url, true);
	            if (options.cors.expected && options.cors.sendCredentials && !isXdr(xhr)) {
	                xhr.withCredentials = true;
	            }
	            setHeaders(id);
	            log("Sending " + method + " request for " + id);
	            if (payload) {
	                xhr.send(payload);
	            } else if (shouldParamsBeInQueryString || !params) {
	                xhr.send();
	            } else if (params && options.contentType && options.contentType.toLowerCase().indexOf("application/x-www-form-urlencoded") >= 0) {
	                xhr.send(qq.obj2url(params, ""));
	            } else if (params && options.contentType && options.contentType.toLowerCase().indexOf("application/json") >= 0) {
	                xhr.send(JSON.stringify(params));
	            } else {
	                xhr.send(params);
	            }
	            return xhr;
	        }
	        function createUrl(id, params, additionalQueryParams) {
	            var endpoint = options.endpointStore.get(id), addToPath = requestData[id].addToPath;
	            if (addToPath != undefined) {
	                endpoint += "/" + addToPath;
	            }
	            if (shouldParamsBeInQueryString && params) {
	                endpoint = qq.obj2url(params, endpoint);
	            }
	            if (additionalQueryParams) {
	                endpoint = qq.obj2url(additionalQueryParams, endpoint);
	            }
	            return endpoint;
	        }
	        function getXhrReadyStateChangeHandler(id) {
	            return function() {
	                if (getXhrOrXdr(id).readyState === 4) {
	                    onComplete(id);
	                }
	            };
	        }
	        function registerForUploadProgress(id) {
	            var onProgress = options.onProgress;
	            if (onProgress) {
	                getXhrOrXdr(id).upload.onprogress = function(e) {
	                    if (e.lengthComputable) {
	                        onProgress(id, e.loaded, e.total);
	                    }
	                };
	            }
	        }
	        function getXdrLoadHandler(id) {
	            return function() {
	                onComplete(id);
	            };
	        }
	        function getXdrErrorHandler(id) {
	            return function() {
	                onComplete(id, true);
	            };
	        }
	        function setHeaders(id) {
	            var xhr = getXhrOrXdr(id), customHeaders = options.customHeaders, onDemandHeaders = requestData[id].additionalHeaders || {}, method = options.method, allHeaders = {};
	            if (!isXdr(xhr)) {
	                options.acceptHeader && xhr.setRequestHeader("Accept", options.acceptHeader);
	                if (options.allowXRequestedWithAndCacheControl) {
	                    if (!options.cors.expected || (!isSimpleMethod() || containsNonSimpleHeaders(customHeaders))) {
	                        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
	                        xhr.setRequestHeader("Cache-Control", "no-cache");
	                    }
	                }
	                if (options.contentType && (method === "POST" || method === "PUT")) {
	                    xhr.setRequestHeader("Content-Type", options.contentType);
	                }
	                qq.extend(allHeaders, qq.isFunction(customHeaders) ? customHeaders(id) : customHeaders);
	                qq.extend(allHeaders, onDemandHeaders);
	                qq.each(allHeaders, function(name, val) {
	                    xhr.setRequestHeader(name, val);
	                });
	            }
	        }
	        function isResponseSuccessful(responseCode) {
	            return qq.indexOf(options.successfulResponseCodes[options.method], responseCode) >= 0;
	        }
	        function prepareToSend(id, optXhr, addToPath, additionalParams, additionalQueryParams, additionalHeaders, payload) {
	            requestData[id] = {
	                addToPath: addToPath,
	                additionalParams: additionalParams,
	                additionalQueryParams: additionalQueryParams,
	                additionalHeaders: additionalHeaders,
	                payload: payload
	            };
	            var len = queue.push(id);
	            if (len <= options.maxConnections) {
	                return sendRequest(id, optXhr);
	            }
	        }
	        shouldParamsBeInQueryString = options.method === "GET" || options.method === "DELETE";
	        qq.extend(this, {
	            initTransport: function(id) {
	                var path, params, headers, payload, cacheBuster, additionalQueryParams;
	                return {
	                    withPath: function(appendToPath) {
	                        path = appendToPath;
	                        return this;
	                    },
	                    withParams: function(additionalParams) {
	                        params = additionalParams;
	                        return this;
	                    },
	                    withQueryParams: function(_additionalQueryParams_) {
	                        additionalQueryParams = _additionalQueryParams_;
	                        return this;
	                    },
	                    withHeaders: function(additionalHeaders) {
	                        headers = additionalHeaders;
	                        return this;
	                    },
	                    withPayload: function(thePayload) {
	                        payload = thePayload;
	                        return this;
	                    },
	                    withCacheBuster: function() {
	                        cacheBuster = true;
	                        return this;
	                    },
	                    send: function(optXhr) {
	                        if (cacheBuster && qq.indexOf([ "GET", "DELETE" ], options.method) >= 0) {
	                            params.qqtimestamp = new Date().getTime();
	                        }
	                        return prepareToSend(id, optXhr, path, params, additionalQueryParams, headers, payload);
	                    }
	                };
	            },
	            canceled: function(id) {
	                dequeue(id);
	            }
	        });
	    };
	    qq.UploadHandler = function(spec) {
	        "use strict";
	        var proxy = spec.proxy, fileState = {}, onCancel = proxy.onCancel, getName = proxy.getName;
	        qq.extend(this, {
	            add: function(id, fileItem) {
	                fileState[id] = fileItem;
	                fileState[id].temp = {};
	            },
	            cancel: function(id) {
	                var self = this, cancelFinalizationEffort = new qq.Promise(), onCancelRetVal = onCancel(id, getName(id), cancelFinalizationEffort);
	                onCancelRetVal.then(function() {
	                    if (self.isValid(id)) {
	                        fileState[id].canceled = true;
	                        self.expunge(id);
	                    }
	                    cancelFinalizationEffort.success();
	                });
	            },
	            expunge: function(id) {
	                delete fileState[id];
	            },
	            getThirdPartyFileId: function(id) {
	                return fileState[id].key;
	            },
	            isValid: function(id) {
	                return fileState[id] !== undefined;
	            },
	            reset: function() {
	                fileState = {};
	            },
	            _getFileState: function(id) {
	                return fileState[id];
	            },
	            _setThirdPartyFileId: function(id, thirdPartyFileId) {
	                fileState[id].key = thirdPartyFileId;
	            },
	            _wasCanceled: function(id) {
	                return !!fileState[id].canceled;
	            }
	        });
	    };
	    qq.UploadHandlerController = function(o, namespace) {
	        "use strict";
	        var controller = this, chunkingPossible = false, concurrentChunkingPossible = false, chunking, preventRetryResponse, log, handler, options = {
	            paramsStore: {},
	            maxConnections: 3,
	            chunking: {
	                enabled: false,
	                multiple: {
	                    enabled: false
	                }
	            },
	            log: function(str, level) {},
	            onProgress: function(id, fileName, loaded, total) {},
	            onComplete: function(id, fileName, response, xhr) {},
	            onCancel: function(id, fileName) {},
	            onUploadPrep: function(id) {},
	            onUpload: function(id, fileName) {},
	            onUploadChunk: function(id, fileName, chunkData) {},
	            onUploadChunkSuccess: function(id, chunkData, response, xhr) {},
	            onAutoRetry: function(id, fileName, response, xhr) {},
	            onResume: function(id, fileName, chunkData) {},
	            onUuidChanged: function(id, newUuid) {},
	            getName: function(id) {},
	            setSize: function(id, newSize) {},
	            isQueued: function(id) {},
	            getIdsInProxyGroup: function(id) {},
	            getIdsInBatch: function(id) {}
	        }, chunked = {
	            done: function(id, chunkIdx, response, xhr) {
	                var chunkData = handler._getChunkData(id, chunkIdx);
	                handler._getFileState(id).attemptingResume = false;
	                delete handler._getFileState(id).temp.chunkProgress[chunkIdx];
	                handler._getFileState(id).loaded += chunkData.size;
	                options.onUploadChunkSuccess(id, handler._getChunkDataForCallback(chunkData), response, xhr);
	            },
	            finalize: function(id) {
	                var size = options.getSize(id), name = options.getName(id);
	                log("All chunks have been uploaded for " + id + " - finalizing....");
	                handler.finalizeChunks(id).then(function(response, xhr) {
	                    log("Finalize successful for " + id);
	                    var normaizedResponse = upload.normalizeResponse(response, true);
	                    options.onProgress(id, name, size, size);
	                    handler._maybeDeletePersistedChunkData(id);
	                    upload.cleanup(id, normaizedResponse, xhr);
	                }, function(response, xhr) {
	                    var normaizedResponse = upload.normalizeResponse(response, false);
	                    log("Problem finalizing chunks for file ID " + id + " - " + normaizedResponse.error, "error");
	                    if (normaizedResponse.reset) {
	                        chunked.reset(id);
	                    }
	                    if (!options.onAutoRetry(id, name, normaizedResponse, xhr)) {
	                        upload.cleanup(id, normaizedResponse, xhr);
	                    }
	                });
	            },
	            handleFailure: function(chunkIdx, id, response, xhr) {
	                var name = options.getName(id);
	                log("Chunked upload request failed for " + id + ", chunk " + chunkIdx);
	                handler.clearCachedChunk(id, chunkIdx);
	                var responseToReport = upload.normalizeResponse(response, false), inProgressIdx;
	                if (responseToReport.reset) {
	                    chunked.reset(id);
	                } else {
	                    inProgressIdx = qq.indexOf(handler._getFileState(id).chunking.inProgress, chunkIdx);
	                    if (inProgressIdx >= 0) {
	                        handler._getFileState(id).chunking.inProgress.splice(inProgressIdx, 1);
	                        handler._getFileState(id).chunking.remaining.unshift(chunkIdx);
	                    }
	                }
	                if (!handler._getFileState(id).temp.ignoreFailure) {
	                    if (concurrentChunkingPossible) {
	                        handler._getFileState(id).temp.ignoreFailure = true;
	                        log(qq.format("Going to attempt to abort these chunks: {}. These are currently in-progress: {}.", JSON.stringify(Object.keys(handler._getXhrs(id))), JSON.stringify(handler._getFileState(id).chunking.inProgress)));
	                        qq.each(handler._getXhrs(id), function(ckid, ckXhr) {
	                            log(qq.format("Attempting to abort file {}.{}. XHR readyState {}. ", id, ckid, ckXhr.readyState));
	                            ckXhr.abort();
	                            ckXhr._cancelled = true;
	                        });
	                        handler.moveInProgressToRemaining(id);
	                        connectionManager.free(id, true);
	                    }
	                    if (!options.onAutoRetry(id, name, responseToReport, xhr)) {
	                        upload.cleanup(id, responseToReport, xhr);
	                    }
	                }
	            },
	            hasMoreParts: function(id) {
	                return !!handler._getFileState(id).chunking.remaining.length;
	            },
	            nextPart: function(id) {
	                var nextIdx = handler._getFileState(id).chunking.remaining.shift();
	                if (nextIdx >= handler._getTotalChunks(id)) {
	                    nextIdx = null;
	                }
	                return nextIdx;
	            },
	            reset: function(id) {
	                log("Server or callback has ordered chunking effort to be restarted on next attempt for item ID " + id, "error");
	                handler._maybeDeletePersistedChunkData(id);
	                handler.reevaluateChunking(id);
	                handler._getFileState(id).loaded = 0;
	            },
	            sendNext: function(id) {
	                var size = options.getSize(id), name = options.getName(id), chunkIdx = chunked.nextPart(id), chunkData = handler._getChunkData(id, chunkIdx), resuming = handler._getFileState(id).attemptingResume, inProgressChunks = handler._getFileState(id).chunking.inProgress || [];
	                if (handler._getFileState(id).loaded == null) {
	                    handler._getFileState(id).loaded = 0;
	                }
	                if (resuming && options.onResume(id, name, chunkData) === false) {
	                    chunked.reset(id);
	                    chunkIdx = chunked.nextPart(id);
	                    chunkData = handler._getChunkData(id, chunkIdx);
	                    resuming = false;
	                }
	                if (chunkIdx == null && inProgressChunks.length === 0) {
	                    chunked.finalize(id);
	                } else {
	                    log(qq.format("Sending chunked upload request for item {}.{}, bytes {}-{} of {}.", id, chunkIdx, chunkData.start + 1, chunkData.end, size));
	                    options.onUploadChunk(id, name, handler._getChunkDataForCallback(chunkData));
	                    inProgressChunks.push(chunkIdx);
	                    handler._getFileState(id).chunking.inProgress = inProgressChunks;
	                    if (concurrentChunkingPossible) {
	                        connectionManager.open(id, chunkIdx);
	                    }
	                    if (concurrentChunkingPossible && connectionManager.available() && handler._getFileState(id).chunking.remaining.length) {
	                        chunked.sendNext(id);
	                    }
	                    if (chunkData.blob.size === 0) {
	                        log(qq.format("Chunk {} for file {} will not be uploaded, zero sized chunk.", chunkIdx, id), "error");
	                        chunked.handleFailure(chunkIdx, id, "File is no longer available", null);
	                    } else {
	                        handler.uploadChunk(id, chunkIdx, resuming).then(function success(response, xhr) {
	                            log("Chunked upload request succeeded for " + id + ", chunk " + chunkIdx);
	                            handler.clearCachedChunk(id, chunkIdx);
	                            var inProgressChunks = handler._getFileState(id).chunking.inProgress || [], responseToReport = upload.normalizeResponse(response, true), inProgressChunkIdx = qq.indexOf(inProgressChunks, chunkIdx);
	                            log(qq.format("Chunk {} for file {} uploaded successfully.", chunkIdx, id));
	                            chunked.done(id, chunkIdx, responseToReport, xhr);
	                            if (inProgressChunkIdx >= 0) {
	                                inProgressChunks.splice(inProgressChunkIdx, 1);
	                            }
	                            handler._maybePersistChunkedState(id);
	                            if (!chunked.hasMoreParts(id) && inProgressChunks.length === 0) {
	                                chunked.finalize(id);
	                            } else if (chunked.hasMoreParts(id)) {
	                                chunked.sendNext(id);
	                            } else {
	                                log(qq.format("File ID {} has no more chunks to send and these chunk indexes are still marked as in-progress: {}", id, JSON.stringify(inProgressChunks)));
	                            }
	                        }, function failure(response, xhr) {
	                            chunked.handleFailure(chunkIdx, id, response, xhr);
	                        }).done(function() {
	                            handler.clearXhr(id, chunkIdx);
	                        });
	                    }
	                }
	            }
	        }, connectionManager = {
	            _open: [],
	            _openChunks: {},
	            _waiting: [],
	            available: function() {
	                var max = options.maxConnections, openChunkEntriesCount = 0, openChunksCount = 0;
	                qq.each(connectionManager._openChunks, function(fileId, openChunkIndexes) {
	                    openChunkEntriesCount++;
	                    openChunksCount += openChunkIndexes.length;
	                });
	                return max - (connectionManager._open.length - openChunkEntriesCount + openChunksCount);
	            },
	            free: function(id, dontAllowNext) {
	                var allowNext = !dontAllowNext, waitingIndex = qq.indexOf(connectionManager._waiting, id), connectionsIndex = qq.indexOf(connectionManager._open, id), nextId;
	                delete connectionManager._openChunks[id];
	                if (upload.getProxyOrBlob(id) instanceof qq.BlobProxy) {
	                    log("Generated blob upload has ended for " + id + ", disposing generated blob.");
	                    delete handler._getFileState(id).file;
	                }
	                if (waitingIndex >= 0) {
	                    connectionManager._waiting.splice(waitingIndex, 1);
	                } else if (allowNext && connectionsIndex >= 0) {
	                    connectionManager._open.splice(connectionsIndex, 1);
	                    nextId = connectionManager._waiting.shift();
	                    if (nextId >= 0) {
	                        connectionManager._open.push(nextId);
	                        upload.start(nextId);
	                    }
	                }
	            },
	            getWaitingOrConnected: function() {
	                var waitingOrConnected = [];
	                qq.each(connectionManager._openChunks, function(fileId, chunks) {
	                    if (chunks && chunks.length) {
	                        waitingOrConnected.push(parseInt(fileId));
	                    }
	                });
	                qq.each(connectionManager._open, function(idx, fileId) {
	                    if (!connectionManager._openChunks[fileId]) {
	                        waitingOrConnected.push(parseInt(fileId));
	                    }
	                });
	                waitingOrConnected = waitingOrConnected.concat(connectionManager._waiting);
	                return waitingOrConnected;
	            },
	            isUsingConnection: function(id) {
	                return qq.indexOf(connectionManager._open, id) >= 0;
	            },
	            open: function(id, chunkIdx) {
	                if (chunkIdx == null) {
	                    connectionManager._waiting.push(id);
	                }
	                if (connectionManager.available()) {
	                    if (chunkIdx == null) {
	                        connectionManager._waiting.pop();
	                        connectionManager._open.push(id);
	                    } else {
	                        (function() {
	                            var openChunksEntry = connectionManager._openChunks[id] || [];
	                            openChunksEntry.push(chunkIdx);
	                            connectionManager._openChunks[id] = openChunksEntry;
	                        })();
	                    }
	                    return true;
	                }
	                return false;
	            },
	            reset: function() {
	                connectionManager._waiting = [];
	                connectionManager._open = [];
	            }
	        }, simple = {
	            send: function(id, name) {
	                handler._getFileState(id).loaded = 0;
	                log("Sending simple upload request for " + id);
	                handler.uploadFile(id).then(function(response, optXhr) {
	                    log("Simple upload request succeeded for " + id);
	                    var responseToReport = upload.normalizeResponse(response, true), size = options.getSize(id);
	                    options.onProgress(id, name, size, size);
	                    upload.maybeNewUuid(id, responseToReport);
	                    upload.cleanup(id, responseToReport, optXhr);
	                }, function(response, optXhr) {
	                    log("Simple upload request failed for " + id);
	                    var responseToReport = upload.normalizeResponse(response, false);
	                    if (!options.onAutoRetry(id, name, responseToReport, optXhr)) {
	                        upload.cleanup(id, responseToReport, optXhr);
	                    }
	                });
	            }
	        }, upload = {
	            cancel: function(id) {
	                log("Cancelling " + id);
	                options.paramsStore.remove(id);
	                connectionManager.free(id);
	            },
	            cleanup: function(id, response, optXhr) {
	                var name = options.getName(id);
	                options.onComplete(id, name, response, optXhr);
	                if (handler._getFileState(id)) {
	                    handler._clearXhrs && handler._clearXhrs(id);
	                }
	                connectionManager.free(id);
	            },
	            getProxyOrBlob: function(id) {
	                return handler.getProxy && handler.getProxy(id) || handler.getFile && handler.getFile(id);
	            },
	            initHandler: function() {
	                var handlerType = namespace ? qq[namespace] : qq.traditional, handlerModuleSubtype = qq.supportedFeatures.ajaxUploading ? "Xhr" : "Form";
	                handler = new handlerType[handlerModuleSubtype + "UploadHandler"](options, {
	                    getDataByUuid: options.getDataByUuid,
	                    getName: options.getName,
	                    getSize: options.getSize,
	                    getUuid: options.getUuid,
	                    log: log,
	                    onCancel: options.onCancel,
	                    onProgress: options.onProgress,
	                    onUuidChanged: options.onUuidChanged
	                });
	                if (handler._removeExpiredChunkingRecords) {
	                    handler._removeExpiredChunkingRecords();
	                }
	            },
	            isDeferredEligibleForUpload: function(id) {
	                return options.isQueued(id);
	            },
	            maybeDefer: function(id, blob) {
	                if (blob && !handler.getFile(id) && blob instanceof qq.BlobProxy) {
	                    options.onUploadPrep(id);
	                    log("Attempting to generate a blob on-demand for " + id);
	                    blob.create().then(function(generatedBlob) {
	                        log("Generated an on-demand blob for " + id);
	                        handler.updateBlob(id, generatedBlob);
	                        options.setSize(id, generatedBlob.size);
	                        handler.reevaluateChunking(id);
	                        upload.maybeSendDeferredFiles(id);
	                    }, function(errorMessage) {
	                        var errorResponse = {};
	                        if (errorMessage) {
	                            errorResponse.error = errorMessage;
	                        }
	                        log(qq.format("Failed to generate blob for ID {}.  Error message: {}.", id, errorMessage), "error");
	                        options.onComplete(id, options.getName(id), qq.extend(errorResponse, preventRetryResponse), null);
	                        upload.maybeSendDeferredFiles(id);
	                        connectionManager.free(id);
	                    });
	                } else {
	                    return upload.maybeSendDeferredFiles(id);
	                }
	                return false;
	            },
	            maybeSendDeferredFiles: function(id) {
	                var idsInGroup = options.getIdsInProxyGroup(id), uploadedThisId = false;
	                if (idsInGroup && idsInGroup.length) {
	                    log("Maybe ready to upload proxy group file " + id);
	                    qq.each(idsInGroup, function(idx, idInGroup) {
	                        if (upload.isDeferredEligibleForUpload(idInGroup) && !!handler.getFile(idInGroup)) {
	                            uploadedThisId = idInGroup === id;
	                            upload.now(idInGroup);
	                        } else if (upload.isDeferredEligibleForUpload(idInGroup)) {
	                            return false;
	                        }
	                    });
	                } else {
	                    uploadedThisId = true;
	                    upload.now(id);
	                }
	                return uploadedThisId;
	            },
	            maybeNewUuid: function(id, response) {
	                if (response.newUuid !== undefined) {
	                    options.onUuidChanged(id, response.newUuid);
	                }
	            },
	            normalizeResponse: function(originalResponse, successful) {
	                var response = originalResponse;
	                if (!qq.isObject(originalResponse)) {
	                    response = {};
	                    if (qq.isString(originalResponse) && !successful) {
	                        response.error = originalResponse;
	                    }
	                }
	                response.success = successful;
	                return response;
	            },
	            now: function(id) {
	                var name = options.getName(id);
	                if (!controller.isValid(id)) {
	                    throw new qq.Error(id + " is not a valid file ID to upload!");
	                }
	                options.onUpload(id, name);
	                if (chunkingPossible && handler._shouldChunkThisFile(id)) {
	                    chunked.sendNext(id);
	                } else {
	                    simple.send(id, name);
	                }
	            },
	            start: function(id) {
	                var blobToUpload = upload.getProxyOrBlob(id);
	                if (blobToUpload) {
	                    return upload.maybeDefer(id, blobToUpload);
	                } else {
	                    upload.now(id);
	                    return true;
	                }
	            }
	        };
	        qq.extend(this, {
	            add: function(id, file) {
	                handler.add.apply(this, arguments);
	            },
	            upload: function(id) {
	                if (connectionManager.open(id)) {
	                    return upload.start(id);
	                }
	                return false;
	            },
	            retry: function(id) {
	                if (concurrentChunkingPossible) {
	                    handler._getFileState(id).temp.ignoreFailure = false;
	                }
	                if (connectionManager.isUsingConnection(id)) {
	                    return upload.start(id);
	                } else {
	                    return controller.upload(id);
	                }
	            },
	            cancel: function(id) {
	                var cancelRetVal = handler.cancel(id);
	                if (qq.isGenericPromise(cancelRetVal)) {
	                    cancelRetVal.then(function() {
	                        upload.cancel(id);
	                    });
	                } else if (cancelRetVal !== false) {
	                    upload.cancel(id);
	                }
	            },
	            cancelAll: function() {
	                var waitingOrConnected = connectionManager.getWaitingOrConnected(), i;
	                if (waitingOrConnected.length) {
	                    for (i = waitingOrConnected.length - 1; i >= 0; i--) {
	                        controller.cancel(waitingOrConnected[i]);
	                    }
	                }
	                connectionManager.reset();
	            },
	            getFile: function(id) {
	                if (handler.getProxy && handler.getProxy(id)) {
	                    return handler.getProxy(id).referenceBlob;
	                }
	                return handler.getFile && handler.getFile(id);
	            },
	            isProxied: function(id) {
	                return !!(handler.getProxy && handler.getProxy(id));
	            },
	            getInput: function(id) {
	                if (handler.getInput) {
	                    return handler.getInput(id);
	                }
	            },
	            reset: function() {
	                log("Resetting upload handler");
	                controller.cancelAll();
	                connectionManager.reset();
	                handler.reset();
	            },
	            expunge: function(id) {
	                if (controller.isValid(id)) {
	                    return handler.expunge(id);
	                }
	            },
	            isValid: function(id) {
	                return handler.isValid(id);
	            },
	            getResumableFilesData: function() {
	                if (handler.getResumableFilesData) {
	                    return handler.getResumableFilesData();
	                }
	                return [];
	            },
	            getThirdPartyFileId: function(id) {
	                if (controller.isValid(id)) {
	                    return handler.getThirdPartyFileId(id);
	                }
	            },
	            pause: function(id) {
	                if (controller.isResumable(id) && handler.pause && controller.isValid(id) && handler.pause(id)) {
	                    connectionManager.free(id);
	                    handler.moveInProgressToRemaining(id);
	                    return true;
	                }
	                return false;
	            },
	            isResumable: function(id) {
	                return !!handler.isResumable && handler.isResumable(id);
	            }
	        });
	        qq.extend(options, o);
	        log = options.log;
	        chunkingPossible = options.chunking.enabled && qq.supportedFeatures.chunking;
	        concurrentChunkingPossible = chunkingPossible && options.chunking.concurrent.enabled;
	        preventRetryResponse = function() {
	            var response = {};
	            response[options.preventRetryParam] = true;
	            return response;
	        }();
	        upload.initHandler();
	    };
	    qq.WindowReceiveMessage = function(o) {
	        "use strict";
	        var options = {
	            log: function(message, level) {}
	        }, callbackWrapperDetachers = {};
	        qq.extend(options, o);
	        qq.extend(this, {
	            receiveMessage: function(id, callback) {
	                var onMessageCallbackWrapper = function(event) {
	                    callback(event.data);
	                };
	                if (window.postMessage) {
	                    callbackWrapperDetachers[id] = qq(window).attach("message", onMessageCallbackWrapper);
	                } else {
	                    log("iframe message passing not supported in this browser!", "error");
	                }
	            },
	            stopReceivingMessages: function(id) {
	                if (window.postMessage) {
	                    var detacher = callbackWrapperDetachers[id];
	                    if (detacher) {
	                        detacher();
	                    }
	                }
	            }
	        });
	    };
	    qq.FormUploadHandler = function(spec) {
	        "use strict";
	        var options = spec.options, handler = this, proxy = spec.proxy, formHandlerInstanceId = qq.getUniqueId(), onloadCallbacks = {}, detachLoadEvents = {}, postMessageCallbackTimers = {}, isCors = options.isCors, inputName = options.inputName, getUuid = proxy.getUuid, log = proxy.log, corsMessageReceiver = new qq.WindowReceiveMessage({
	            log: log
	        });
	        function expungeFile(id) {
	            delete detachLoadEvents[id];
	            if (isCors) {
	                clearTimeout(postMessageCallbackTimers[id]);
	                delete postMessageCallbackTimers[id];
	                corsMessageReceiver.stopReceivingMessages(id);
	            }
	            var iframe = document.getElementById(handler._getIframeName(id));
	            if (iframe) {
	                iframe.setAttribute("src", "javascript:false;");
	                qq(iframe).remove();
	            }
	        }
	        function getFileIdForIframeName(iframeName) {
	            return iframeName.split("_")[0];
	        }
	        function initIframeForUpload(name) {
	            var iframe = qq.toElement("<iframe src='javascript:false;' name='" + name + "' />");
	            iframe.setAttribute("id", name);
	            iframe.style.display = "none";
	            document.body.appendChild(iframe);
	            return iframe;
	        }
	        function registerPostMessageCallback(iframe, callback) {
	            var iframeName = iframe.id, fileId = getFileIdForIframeName(iframeName), uuid = getUuid(fileId);
	            onloadCallbacks[uuid] = callback;
	            detachLoadEvents[fileId] = qq(iframe).attach("load", function() {
	                if (handler.getInput(fileId)) {
	                    log("Received iframe load event for CORS upload request (iframe name " + iframeName + ")");
	                    postMessageCallbackTimers[iframeName] = setTimeout(function() {
	                        var errorMessage = "No valid message received from loaded iframe for iframe name " + iframeName;
	                        log(errorMessage, "error");
	                        callback({
	                            error: errorMessage
	                        });
	                    }, 1e3);
	                }
	            });
	            corsMessageReceiver.receiveMessage(iframeName, function(message) {
	                log("Received the following window message: '" + message + "'");
	                var fileId = getFileIdForIframeName(iframeName), response = handler._parseJsonResponse(message), uuid = response.uuid, onloadCallback;
	                if (uuid && onloadCallbacks[uuid]) {
	                    log("Handling response for iframe name " + iframeName);
	                    clearTimeout(postMessageCallbackTimers[iframeName]);
	                    delete postMessageCallbackTimers[iframeName];
	                    handler._detachLoadEvent(iframeName);
	                    onloadCallback = onloadCallbacks[uuid];
	                    delete onloadCallbacks[uuid];
	                    corsMessageReceiver.stopReceivingMessages(iframeName);
	                    onloadCallback(response);
	                } else if (!uuid) {
	                    log("'" + message + "' does not contain a UUID - ignoring.");
	                }
	            });
	        }
	        qq.extend(this, new qq.UploadHandler(spec));
	        qq.override(this, function(super_) {
	            return {
	                add: function(id, fileInput) {
	                    super_.add(id, {
	                        input: fileInput
	                    });
	                    fileInput.setAttribute("name", inputName);
	                    if (fileInput.parentNode) {
	                        qq(fileInput).remove();
	                    }
	                },
	                expunge: function(id) {
	                    expungeFile(id);
	                    super_.expunge(id);
	                },
	                isValid: function(id) {
	                    return super_.isValid(id) && handler._getFileState(id).input !== undefined;
	                }
	            };
	        });
	        qq.extend(this, {
	            getInput: function(id) {
	                return handler._getFileState(id).input;
	            },
	            _attachLoadEvent: function(iframe, callback) {
	                var responseDescriptor;
	                if (isCors) {
	                    registerPostMessageCallback(iframe, callback);
	                } else {
	                    detachLoadEvents[iframe.id] = qq(iframe).attach("load", function() {
	                        log("Received response for " + iframe.id);
	                        if (!iframe.parentNode) {
	                            return;
	                        }
	                        try {
	                            if (iframe.contentDocument && iframe.contentDocument.body && iframe.contentDocument.body.innerHTML == "false") {
	                                return;
	                            }
	                        } catch (error) {
	                            log("Error when attempting to access iframe during handling of upload response (" + error.message + ")", "error");
	                            responseDescriptor = {
	                                success: false
	                            };
	                        }
	                        callback(responseDescriptor);
	                    });
	                }
	            },
	            _createIframe: function(id) {
	                var iframeName = handler._getIframeName(id);
	                return initIframeForUpload(iframeName);
	            },
	            _detachLoadEvent: function(id) {
	                if (detachLoadEvents[id] !== undefined) {
	                    detachLoadEvents[id]();
	                    delete detachLoadEvents[id];
	                }
	            },
	            _getIframeName: function(fileId) {
	                return fileId + "_" + formHandlerInstanceId;
	            },
	            _initFormForUpload: function(spec) {
	                var method = spec.method, endpoint = spec.endpoint, params = spec.params, paramsInBody = spec.paramsInBody, targetName = spec.targetName, form = qq.toElement("<form method='" + method + "' enctype='multipart/form-data'></form>"), url = endpoint;
	                if (paramsInBody) {
	                    qq.obj2Inputs(params, form);
	                } else {
	                    url = qq.obj2url(params, endpoint);
	                }
	                form.setAttribute("action", url);
	                form.setAttribute("target", targetName);
	                form.style.display = "none";
	                document.body.appendChild(form);
	                return form;
	            },
	            _parseJsonResponse: function(innerHtmlOrMessage) {
	                var response = {};
	                try {
	                    response = qq.parseJson(innerHtmlOrMessage);
	                } catch (error) {
	                    log("Error when attempting to parse iframe upload response (" + error.message + ")", "error");
	                }
	                return response;
	            }
	        });
	    };
	    qq.XhrUploadHandler = function(spec) {
	        "use strict";
	        var handler = this, namespace = spec.options.namespace, proxy = spec.proxy, chunking = spec.options.chunking, resume = spec.options.resume, chunkFiles = chunking && spec.options.chunking.enabled && qq.supportedFeatures.chunking, resumeEnabled = resume && spec.options.resume.enabled && chunkFiles && qq.supportedFeatures.resume, getName = proxy.getName, getSize = proxy.getSize, getUuid = proxy.getUuid, getEndpoint = proxy.getEndpoint, getDataByUuid = proxy.getDataByUuid, onUuidChanged = proxy.onUuidChanged, onProgress = proxy.onProgress, log = proxy.log;
	        function abort(id) {
	            qq.each(handler._getXhrs(id), function(xhrId, xhr) {
	                var ajaxRequester = handler._getAjaxRequester(id, xhrId);
	                xhr.onreadystatechange = null;
	                xhr.upload.onprogress = null;
	                xhr.abort();
	                ajaxRequester && ajaxRequester.canceled && ajaxRequester.canceled(id);
	            });
	        }
	        qq.extend(this, new qq.UploadHandler(spec));
	        qq.override(this, function(super_) {
	            return {
	                add: function(id, blobOrProxy) {
	                    if (qq.isFile(blobOrProxy) || qq.isBlob(blobOrProxy)) {
	                        super_.add(id, {
	                            file: blobOrProxy
	                        });
	                    } else if (blobOrProxy instanceof qq.BlobProxy) {
	                        super_.add(id, {
	                            proxy: blobOrProxy
	                        });
	                    } else {
	                        throw new Error("Passed obj is not a File, Blob, or proxy");
	                    }
	                    handler._initTempState(id);
	                    resumeEnabled && handler._maybePrepareForResume(id);
	                },
	                expunge: function(id) {
	                    abort(id);
	                    handler._maybeDeletePersistedChunkData(id);
	                    handler._clearXhrs(id);
	                    super_.expunge(id);
	                }
	            };
	        });
	        qq.extend(this, {
	            clearCachedChunk: function(id, chunkIdx) {
	                delete handler._getFileState(id).temp.cachedChunks[chunkIdx];
	            },
	            clearXhr: function(id, chunkIdx) {
	                var tempState = handler._getFileState(id).temp;
	                if (tempState.xhrs) {
	                    delete tempState.xhrs[chunkIdx];
	                }
	                if (tempState.ajaxRequesters) {
	                    delete tempState.ajaxRequesters[chunkIdx];
	                }
	            },
	            finalizeChunks: function(id, responseParser) {
	                var lastChunkIdx = handler._getTotalChunks(id) - 1, xhr = handler._getXhr(id, lastChunkIdx);
	                if (responseParser) {
	                    return new qq.Promise().success(responseParser(xhr), xhr);
	                }
	                return new qq.Promise().success({}, xhr);
	            },
	            getFile: function(id) {
	                return handler.isValid(id) && handler._getFileState(id).file;
	            },
	            getProxy: function(id) {
	                return handler.isValid(id) && handler._getFileState(id).proxy;
	            },
	            getResumableFilesData: function() {
	                var resumableFilesData = [];
	                handler._iterateResumeRecords(function(key, uploadData) {
	                    handler.moveInProgressToRemaining(null, uploadData.chunking.inProgress, uploadData.chunking.remaining);
	                    var data = {
	                        name: uploadData.name,
	                        remaining: uploadData.chunking.remaining,
	                        size: uploadData.size,
	                        uuid: uploadData.uuid
	                    };
	                    if (uploadData.key) {
	                        data.key = uploadData.key;
	                    }
	                    resumableFilesData.push(data);
	                });
	                return resumableFilesData;
	            },
	            isResumable: function(id) {
	                return !!chunking && handler.isValid(id) && !handler._getFileState(id).notResumable;
	            },
	            moveInProgressToRemaining: function(id, optInProgress, optRemaining) {
	                var inProgress = optInProgress || handler._getFileState(id).chunking.inProgress, remaining = optRemaining || handler._getFileState(id).chunking.remaining;
	                if (inProgress) {
	                    log(qq.format("Moving these chunks from in-progress {}, to remaining.", JSON.stringify(inProgress)));
	                    inProgress.reverse();
	                    qq.each(inProgress, function(idx, chunkIdx) {
	                        remaining.unshift(chunkIdx);
	                    });
	                    inProgress.length = 0;
	                }
	            },
	            pause: function(id) {
	                if (handler.isValid(id)) {
	                    log(qq.format("Aborting XHR upload for {} '{}' due to pause instruction.", id, getName(id)));
	                    handler._getFileState(id).paused = true;
	                    abort(id);
	                    return true;
	                }
	            },
	            reevaluateChunking: function(id) {
	                if (chunking && handler.isValid(id)) {
	                    var state = handler._getFileState(id), totalChunks, i;
	                    delete state.chunking;
	                    state.chunking = {};
	                    totalChunks = handler._getTotalChunks(id);
	                    if (totalChunks > 1 || chunking.mandatory) {
	                        state.chunking.enabled = true;
	                        state.chunking.parts = totalChunks;
	                        state.chunking.remaining = [];
	                        for (i = 0; i < totalChunks; i++) {
	                            state.chunking.remaining.push(i);
	                        }
	                        handler._initTempState(id);
	                    } else {
	                        state.chunking.enabled = false;
	                    }
	                }
	            },
	            updateBlob: function(id, newBlob) {
	                if (handler.isValid(id)) {
	                    handler._getFileState(id).file = newBlob;
	                }
	            },
	            _clearXhrs: function(id) {
	                var tempState = handler._getFileState(id).temp;
	                qq.each(tempState.ajaxRequesters, function(chunkId) {
	                    delete tempState.ajaxRequesters[chunkId];
	                });
	                qq.each(tempState.xhrs, function(chunkId) {
	                    delete tempState.xhrs[chunkId];
	                });
	            },
	            _createXhr: function(id, optChunkIdx) {
	                return handler._registerXhr(id, optChunkIdx, qq.createXhrInstance());
	            },
	            _getAjaxRequester: function(id, optChunkIdx) {
	                var chunkIdx = optChunkIdx == null ? -1 : optChunkIdx;
	                return handler._getFileState(id).temp.ajaxRequesters[chunkIdx];
	            },
	            _getChunkData: function(id, chunkIndex) {
	                var chunkSize = chunking.partSize, fileSize = getSize(id), fileOrBlob = handler.getFile(id), startBytes = chunkSize * chunkIndex, endBytes = startBytes + chunkSize >= fileSize ? fileSize : startBytes + chunkSize, totalChunks = handler._getTotalChunks(id), cachedChunks = this._getFileState(id).temp.cachedChunks, blob = cachedChunks[chunkIndex] || qq.sliceBlob(fileOrBlob, startBytes, endBytes);
	                cachedChunks[chunkIndex] = blob;
	                return {
	                    part: chunkIndex,
	                    start: startBytes,
	                    end: endBytes,
	                    count: totalChunks,
	                    blob: blob,
	                    size: endBytes - startBytes
	                };
	            },
	            _getChunkDataForCallback: function(chunkData) {
	                return {
	                    partIndex: chunkData.part,
	                    startByte: chunkData.start + 1,
	                    endByte: chunkData.end,
	                    totalParts: chunkData.count
	                };
	            },
	            _getLocalStorageId: function(id) {
	                var formatVersion = "5.0", name = getName(id), size = getSize(id), chunkSize = chunking.partSize, endpoint = getEndpoint(id);
	                return qq.format("qq{}resume{}-{}-{}-{}-{}", namespace, formatVersion, name, size, chunkSize, endpoint);
	            },
	            _getMimeType: function(id) {
	                return handler.getFile(id).type;
	            },
	            _getPersistableData: function(id) {
	                return handler._getFileState(id).chunking;
	            },
	            _getTotalChunks: function(id) {
	                if (chunking) {
	                    var fileSize = getSize(id), chunkSize = chunking.partSize;
	                    return Math.ceil(fileSize / chunkSize);
	                }
	            },
	            _getXhr: function(id, optChunkIdx) {
	                var chunkIdx = optChunkIdx == null ? -1 : optChunkIdx;
	                return handler._getFileState(id).temp.xhrs[chunkIdx];
	            },
	            _getXhrs: function(id) {
	                return handler._getFileState(id).temp.xhrs;
	            },
	            _iterateResumeRecords: function(callback) {
	                if (resumeEnabled) {
	                    qq.each(localStorage, function(key, item) {
	                        if (key.indexOf(qq.format("qq{}resume", namespace)) === 0) {
	                            var uploadData = JSON.parse(item);
	                            callback(key, uploadData);
	                        }
	                    });
	                }
	            },
	            _initTempState: function(id) {
	                handler._getFileState(id).temp = {
	                    ajaxRequesters: {},
	                    chunkProgress: {},
	                    xhrs: {},
	                    cachedChunks: {}
	                };
	            },
	            _markNotResumable: function(id) {
	                handler._getFileState(id).notResumable = true;
	            },
	            _maybeDeletePersistedChunkData: function(id) {
	                var localStorageId;
	                if (resumeEnabled && handler.isResumable(id)) {
	                    localStorageId = handler._getLocalStorageId(id);
	                    if (localStorageId && localStorage.getItem(localStorageId)) {
	                        localStorage.removeItem(localStorageId);
	                        return true;
	                    }
	                }
	                return false;
	            },
	            _maybePrepareForResume: function(id) {
	                var state = handler._getFileState(id), localStorageId, persistedData;
	                if (resumeEnabled && state.key === undefined) {
	                    localStorageId = handler._getLocalStorageId(id);
	                    persistedData = localStorage.getItem(localStorageId);
	                    if (persistedData) {
	                        persistedData = JSON.parse(persistedData);
	                        if (getDataByUuid(persistedData.uuid)) {
	                            handler._markNotResumable(id);
	                        } else {
	                            log(qq.format("Identified file with ID {} and name of {} as resumable.", id, getName(id)));
	                            onUuidChanged(id, persistedData.uuid);
	                            state.key = persistedData.key;
	                            state.chunking = persistedData.chunking;
	                            state.loaded = persistedData.loaded;
	                            state.attemptingResume = true;
	                            handler.moveInProgressToRemaining(id);
	                        }
	                    }
	                }
	            },
	            _maybePersistChunkedState: function(id) {
	                var state = handler._getFileState(id), localStorageId, persistedData;
	                if (resumeEnabled && handler.isResumable(id)) {
	                    localStorageId = handler._getLocalStorageId(id);
	                    persistedData = {
	                        name: getName(id),
	                        size: getSize(id),
	                        uuid: getUuid(id),
	                        key: state.key,
	                        chunking: state.chunking,
	                        loaded: state.loaded,
	                        lastUpdated: Date.now()
	                    };
	                    try {
	                        localStorage.setItem(localStorageId, JSON.stringify(persistedData));
	                    } catch (error) {
	                        log(qq.format("Unable to save resume data for '{}' due to error: '{}'.", id, error.toString()), "warn");
	                    }
	                }
	            },
	            _registerProgressHandler: function(id, chunkIdx, chunkSize) {
	                var xhr = handler._getXhr(id, chunkIdx), name = getName(id), progressCalculator = {
	                    simple: function(loaded, total) {
	                        var fileSize = getSize(id);
	                        if (loaded === total) {
	                            onProgress(id, name, fileSize, fileSize);
	                        } else {
	                            onProgress(id, name, loaded >= fileSize ? fileSize - 1 : loaded, fileSize);
	                        }
	                    },
	                    chunked: function(loaded, total) {
	                        var chunkProgress = handler._getFileState(id).temp.chunkProgress, totalSuccessfullyLoadedForFile = handler._getFileState(id).loaded, loadedForRequest = loaded, totalForRequest = total, totalFileSize = getSize(id), estActualChunkLoaded = loadedForRequest - (totalForRequest - chunkSize), totalLoadedForFile = totalSuccessfullyLoadedForFile;
	                        chunkProgress[chunkIdx] = estActualChunkLoaded;
	                        qq.each(chunkProgress, function(chunkIdx, chunkLoaded) {
	                            totalLoadedForFile += chunkLoaded;
	                        });
	                        onProgress(id, name, totalLoadedForFile, totalFileSize);
	                    }
	                };
	                xhr.upload.onprogress = function(e) {
	                    if (e.lengthComputable) {
	                        var type = chunkSize == null ? "simple" : "chunked";
	                        progressCalculator[type](e.loaded, e.total);
	                    }
	                };
	            },
	            _registerXhr: function(id, optChunkIdx, xhr, optAjaxRequester) {
	                var xhrsId = optChunkIdx == null ? -1 : optChunkIdx, tempState = handler._getFileState(id).temp;
	                tempState.xhrs = tempState.xhrs || {};
	                tempState.ajaxRequesters = tempState.ajaxRequesters || {};
	                tempState.xhrs[xhrsId] = xhr;
	                if (optAjaxRequester) {
	                    tempState.ajaxRequesters[xhrsId] = optAjaxRequester;
	                }
	                return xhr;
	            },
	            _removeExpiredChunkingRecords: function() {
	                var expirationDays = resume.recordsExpireIn;
	                handler._iterateResumeRecords(function(key, uploadData) {
	                    var expirationDate = new Date(uploadData.lastUpdated);
	                    expirationDate.setDate(expirationDate.getDate() + expirationDays);
	                    if (expirationDate.getTime() <= Date.now()) {
	                        log("Removing expired resume record with key " + key);
	                        localStorage.removeItem(key);
	                    }
	                });
	            },
	            _shouldChunkThisFile: function(id) {
	                var state = handler._getFileState(id);
	                if (!state.chunking) {
	                    handler.reevaluateChunking(id);
	                }
	                return state.chunking.enabled;
	            }
	        });
	    };
	    qq.DeleteFileAjaxRequester = function(o) {
	        "use strict";
	        var requester, options = {
	            method: "DELETE",
	            uuidParamName: "qquuid",
	            endpointStore: {},
	            maxConnections: 3,
	            customHeaders: function(id) {
	                return {};
	            },
	            paramsStore: {},
	            cors: {
	                expected: false,
	                sendCredentials: false
	            },
	            log: function(str, level) {},
	            onDelete: function(id) {},
	            onDeleteComplete: function(id, xhrOrXdr, isError) {}
	        };
	        qq.extend(options, o);
	        function getMandatedParams() {
	            if (options.method.toUpperCase() === "POST") {
	                return {
	                    _method: "DELETE"
	                };
	            }
	            return {};
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            acceptHeader: "application/json",
	            validMethods: [ "POST", "DELETE" ],
	            method: options.method,
	            endpointStore: options.endpointStore,
	            paramsStore: options.paramsStore,
	            mandatedParams: getMandatedParams(),
	            maxConnections: options.maxConnections,
	            customHeaders: function(id) {
	                return options.customHeaders.get(id);
	            },
	            log: options.log,
	            onSend: options.onDelete,
	            onComplete: options.onDeleteComplete,
	            cors: options.cors
	        }));
	        qq.extend(this, {
	            sendDelete: function(id, uuid, additionalMandatedParams) {
	                var additionalOptions = additionalMandatedParams || {};
	                options.log("Submitting delete file request for " + id);
	                if (options.method === "DELETE") {
	                    requester.initTransport(id).withPath(uuid).withParams(additionalOptions).send();
	                } else {
	                    additionalOptions[options.uuidParamName] = uuid;
	                    requester.initTransport(id).withParams(additionalOptions).send();
	                }
	            }
	        });
	    };
	    (function() {
	        function detectSubsampling(img) {
	            var iw = img.naturalWidth, ih = img.naturalHeight, canvas = document.createElement("canvas"), ctx;
	            if (iw * ih > 1024 * 1024) {
	                canvas.width = canvas.height = 1;
	                ctx = canvas.getContext("2d");
	                ctx.drawImage(img, -iw + 1, 0);
	                return ctx.getImageData(0, 0, 1, 1).data[3] === 0;
	            } else {
	                return false;
	            }
	        }
	        function detectVerticalSquash(img, iw, ih) {
	            var canvas = document.createElement("canvas"), sy = 0, ey = ih, py = ih, ctx, data, alpha, ratio;
	            canvas.width = 1;
	            canvas.height = ih;
	            ctx = canvas.getContext("2d");
	            ctx.drawImage(img, 0, 0);
	            data = ctx.getImageData(0, 0, 1, ih).data;
	            while (py > sy) {
	                alpha = data[(py - 1) * 4 + 3];
	                if (alpha === 0) {
	                    ey = py;
	                } else {
	                    sy = py;
	                }
	                py = ey + sy >> 1;
	            }
	            ratio = py / ih;
	            return ratio === 0 ? 1 : ratio;
	        }
	        function renderImageToDataURL(img, blob, options, doSquash) {
	            var canvas = document.createElement("canvas"), mime = options.mime || "image/jpeg", promise = new qq.Promise();
	            renderImageToCanvas(img, blob, canvas, options, doSquash).then(function() {
	                promise.success(canvas.toDataURL(mime, options.quality || .8));
	            });
	            return promise;
	        }
	        function maybeCalculateDownsampledDimensions(spec) {
	            var maxPixels = 5241e3;
	            if (!qq.ios()) {
	                throw new qq.Error("Downsampled dimensions can only be reliably calculated for iOS!");
	            }
	            if (spec.origHeight * spec.origWidth > maxPixels) {
	                return {
	                    newHeight: Math.round(Math.sqrt(maxPixels * (spec.origHeight / spec.origWidth))),
	                    newWidth: Math.round(Math.sqrt(maxPixels * (spec.origWidth / spec.origHeight)))
	                };
	            }
	        }
	        function renderImageToCanvas(img, blob, canvas, options, doSquash) {
	            var iw = img.naturalWidth, ih = img.naturalHeight, width = options.width, height = options.height, ctx = canvas.getContext("2d"), promise = new qq.Promise(), modifiedDimensions;
	            ctx.save();
	            if (options.resize) {
	                return renderImageToCanvasWithCustomResizer({
	                    blob: blob,
	                    canvas: canvas,
	                    image: img,
	                    imageHeight: ih,
	                    imageWidth: iw,
	                    orientation: options.orientation,
	                    resize: options.resize,
	                    targetHeight: height,
	                    targetWidth: width
	                });
	            }
	            if (!qq.supportedFeatures.unlimitedScaledImageSize) {
	                modifiedDimensions = maybeCalculateDownsampledDimensions({
	                    origWidth: width,
	                    origHeight: height
	                });
	                if (modifiedDimensions) {
	                    qq.log(qq.format("Had to reduce dimensions due to device limitations from {}w / {}h to {}w / {}h", width, height, modifiedDimensions.newWidth, modifiedDimensions.newHeight), "warn");
	                    width = modifiedDimensions.newWidth;
	                    height = modifiedDimensions.newHeight;
	                }
	            }
	            transformCoordinate(canvas, width, height, options.orientation);
	            if (qq.ios()) {
	                (function() {
	                    if (detectSubsampling(img)) {
	                        iw /= 2;
	                        ih /= 2;
	                    }
	                    var d = 1024, tmpCanvas = document.createElement("canvas"), vertSquashRatio = doSquash ? detectVerticalSquash(img, iw, ih) : 1, dw = Math.ceil(d * width / iw), dh = Math.ceil(d * height / ih / vertSquashRatio), sy = 0, dy = 0, tmpCtx, sx, dx;
	                    tmpCanvas.width = tmpCanvas.height = d;
	                    tmpCtx = tmpCanvas.getContext("2d");
	                    while (sy < ih) {
	                        sx = 0;
	                        dx = 0;
	                        while (sx < iw) {
	                            tmpCtx.clearRect(0, 0, d, d);
	                            tmpCtx.drawImage(img, -sx, -sy);
	                            ctx.drawImage(tmpCanvas, 0, 0, d, d, dx, dy, dw, dh);
	                            sx += d;
	                            dx += dw;
	                        }
	                        sy += d;
	                        dy += dh;
	                    }
	                    ctx.restore();
	                    tmpCanvas = tmpCtx = null;
	                })();
	            } else {
	                ctx.drawImage(img, 0, 0, width, height);
	            }
	            canvas.qqImageRendered && canvas.qqImageRendered();
	            promise.success();
	            return promise;
	        }
	        function renderImageToCanvasWithCustomResizer(resizeInfo) {
	            var blob = resizeInfo.blob, image = resizeInfo.image, imageHeight = resizeInfo.imageHeight, imageWidth = resizeInfo.imageWidth, orientation = resizeInfo.orientation, promise = new qq.Promise(), resize = resizeInfo.resize, sourceCanvas = document.createElement("canvas"), sourceCanvasContext = sourceCanvas.getContext("2d"), targetCanvas = resizeInfo.canvas, targetHeight = resizeInfo.targetHeight, targetWidth = resizeInfo.targetWidth;
	            transformCoordinate(sourceCanvas, imageWidth, imageHeight, orientation);
	            targetCanvas.height = targetHeight;
	            targetCanvas.width = targetWidth;
	            sourceCanvasContext.drawImage(image, 0, 0);
	            resize({
	                blob: blob,
	                height: targetHeight,
	                image: image,
	                sourceCanvas: sourceCanvas,
	                targetCanvas: targetCanvas,
	                width: targetWidth
	            }).then(function success() {
	                targetCanvas.qqImageRendered && targetCanvas.qqImageRendered();
	                promise.success();
	            }, promise.failure);
	            return promise;
	        }
	        function transformCoordinate(canvas, width, height, orientation) {
	            switch (orientation) {
	              case 5:
	              case 6:
	              case 7:
	              case 8:
	                canvas.width = height;
	                canvas.height = width;
	                break;
	
	              default:
	                canvas.width = width;
	                canvas.height = height;
	            }
	            var ctx = canvas.getContext("2d");
	            switch (orientation) {
	              case 2:
	                ctx.translate(width, 0);
	                ctx.scale(-1, 1);
	                break;
	
	              case 3:
	                ctx.translate(width, height);
	                ctx.rotate(Math.PI);
	                break;
	
	              case 4:
	                ctx.translate(0, height);
	                ctx.scale(1, -1);
	                break;
	
	              case 5:
	                ctx.rotate(.5 * Math.PI);
	                ctx.scale(1, -1);
	                break;
	
	              case 6:
	                ctx.rotate(.5 * Math.PI);
	                ctx.translate(0, -height);
	                break;
	
	              case 7:
	                ctx.rotate(.5 * Math.PI);
	                ctx.translate(width, -height);
	                ctx.scale(-1, 1);
	                break;
	
	              case 8:
	                ctx.rotate(-.5 * Math.PI);
	                ctx.translate(-width, 0);
	                break;
	
	              default:
	                break;
	            }
	        }
	        function MegaPixImage(srcImage, errorCallback) {
	            var self = this;
	            if (window.Blob && srcImage instanceof Blob) {
	                (function() {
	                    var img = new Image(), URL = window.URL && window.URL.createObjectURL ? window.URL : window.webkitURL && window.webkitURL.createObjectURL ? window.webkitURL : null;
	                    if (!URL) {
	                        throw Error("No createObjectURL function found to create blob url");
	                    }
	                    img.src = URL.createObjectURL(srcImage);
	                    self.blob = srcImage;
	                    srcImage = img;
	                })();
	            }
	            if (!srcImage.naturalWidth && !srcImage.naturalHeight) {
	                srcImage.onload = function() {
	                    var listeners = self.imageLoadListeners;
	                    if (listeners) {
	                        self.imageLoadListeners = null;
	                        setTimeout(function() {
	                            for (var i = 0, len = listeners.length; i < len; i++) {
	                                listeners[i]();
	                            }
	                        }, 0);
	                    }
	                };
	                srcImage.onerror = errorCallback;
	                this.imageLoadListeners = [];
	            }
	            this.srcImage = srcImage;
	        }
	        MegaPixImage.prototype.render = function(target, options) {
	            options = options || {};
	            var self = this, imgWidth = this.srcImage.naturalWidth, imgHeight = this.srcImage.naturalHeight, width = options.width, height = options.height, maxWidth = options.maxWidth, maxHeight = options.maxHeight, doSquash = !this.blob || this.blob.type === "image/jpeg", tagName = target.tagName.toLowerCase(), opt;
	            if (this.imageLoadListeners) {
	                this.imageLoadListeners.push(function() {
	                    self.render(target, options);
	                });
	                return;
	            }
	            if (width && !height) {
	                height = imgHeight * width / imgWidth << 0;
	            } else if (height && !width) {
	                width = imgWidth * height / imgHeight << 0;
	            } else {
	                width = imgWidth;
	                height = imgHeight;
	            }
	            if (maxWidth && width > maxWidth) {
	                width = maxWidth;
	                height = imgHeight * width / imgWidth << 0;
	            }
	            if (maxHeight && height > maxHeight) {
	                height = maxHeight;
	                width = imgWidth * height / imgHeight << 0;
	            }
	            opt = {
	                width: width,
	                height: height
	            }, qq.each(options, function(optionsKey, optionsValue) {
	                opt[optionsKey] = optionsValue;
	            });
	            if (tagName === "img") {
	                (function() {
	                    var oldTargetSrc = target.src;
	                    renderImageToDataURL(self.srcImage, self.blob, opt, doSquash).then(function(dataUri) {
	                        target.src = dataUri;
	                        oldTargetSrc === target.src && target.onload();
	                    });
	                })();
	            } else if (tagName === "canvas") {
	                renderImageToCanvas(this.srcImage, this.blob, target, opt, doSquash);
	            }
	            if (typeof this.onrender === "function") {
	                this.onrender(target);
	            }
	        };
	        qq.MegaPixImage = MegaPixImage;
	    })();
	    qq.ImageGenerator = function(log) {
	        "use strict";
	        function isImg(el) {
	            return el.tagName.toLowerCase() === "img";
	        }
	        function isCanvas(el) {
	            return el.tagName.toLowerCase() === "canvas";
	        }
	        function isImgCorsSupported() {
	            return new Image().crossOrigin !== undefined;
	        }
	        function isCanvasSupported() {
	            var canvas = document.createElement("canvas");
	            return canvas.getContext && canvas.getContext("2d");
	        }
	        function determineMimeOfFileName(nameWithPath) {
	            var pathSegments = nameWithPath.split("/"), name = pathSegments[pathSegments.length - 1].split("?")[0], extension = qq.getExtension(name);
	            extension = extension && extension.toLowerCase();
	            switch (extension) {
	              case "jpeg":
	              case "jpg":
	                return "image/jpeg";
	
	              case "png":
	                return "image/png";
	
	              case "bmp":
	                return "image/bmp";
	
	              case "gif":
	                return "image/gif";
	
	              case "tiff":
	              case "tif":
	                return "image/tiff";
	            }
	        }
	        function isCrossOrigin(url) {
	            var targetAnchor = document.createElement("a"), targetProtocol, targetHostname, targetPort;
	            targetAnchor.href = url;
	            targetProtocol = targetAnchor.protocol;
	            targetPort = targetAnchor.port;
	            targetHostname = targetAnchor.hostname;
	            if (targetProtocol.toLowerCase() !== window.location.protocol.toLowerCase()) {
	                return true;
	            }
	            if (targetHostname.toLowerCase() !== window.location.hostname.toLowerCase()) {
	                return true;
	            }
	            if (targetPort !== window.location.port && !qq.ie()) {
	                return true;
	            }
	            return false;
	        }
	        function registerImgLoadListeners(img, promise) {
	            img.onload = function() {
	                img.onload = null;
	                img.onerror = null;
	                promise.success(img);
	            };
	            img.onerror = function() {
	                img.onload = null;
	                img.onerror = null;
	                log("Problem drawing thumbnail!", "error");
	                promise.failure(img, "Problem drawing thumbnail!");
	            };
	        }
	        function registerCanvasDrawImageListener(canvas, promise) {
	            canvas.qqImageRendered = function() {
	                promise.success(canvas);
	            };
	        }
	        function registerThumbnailRenderedListener(imgOrCanvas, promise) {
	            var registered = isImg(imgOrCanvas) || isCanvas(imgOrCanvas);
	            if (isImg(imgOrCanvas)) {
	                registerImgLoadListeners(imgOrCanvas, promise);
	            } else if (isCanvas(imgOrCanvas)) {
	                registerCanvasDrawImageListener(imgOrCanvas, promise);
	            } else {
	                promise.failure(imgOrCanvas);
	                log(qq.format("Element container of type {} is not supported!", imgOrCanvas.tagName), "error");
	            }
	            return registered;
	        }
	        function draw(fileOrBlob, container, options) {
	            var drawPreview = new qq.Promise(), identifier = new qq.Identify(fileOrBlob, log), maxSize = options.maxSize, orient = options.orient == null ? true : options.orient, megapixErrorHandler = function() {
	                container.onerror = null;
	                container.onload = null;
	                log("Could not render preview, file may be too large!", "error");
	                drawPreview.failure(container, "Browser cannot render image!");
	            };
	            identifier.isPreviewable().then(function(mime) {
	                var dummyExif = {
	                    parse: function() {
	                        return new qq.Promise().success();
	                    }
	                }, exif = orient ? new qq.Exif(fileOrBlob, log) : dummyExif, mpImg = new qq.MegaPixImage(fileOrBlob, megapixErrorHandler);
	                if (registerThumbnailRenderedListener(container, drawPreview)) {
	                    exif.parse().then(function(exif) {
	                        var orientation = exif && exif.Orientation;
	                        mpImg.render(container, {
	                            maxWidth: maxSize,
	                            maxHeight: maxSize,
	                            orientation: orientation,
	                            mime: mime,
	                            resize: options.customResizeFunction
	                        });
	                    }, function(failureMsg) {
	                        log(qq.format("EXIF data could not be parsed ({}).  Assuming orientation = 1.", failureMsg));
	                        mpImg.render(container, {
	                            maxWidth: maxSize,
	                            maxHeight: maxSize,
	                            mime: mime,
	                            resize: options.customResizeFunction
	                        });
	                    });
	                }
	            }, function() {
	                log("Not previewable");
	                drawPreview.failure(container, "Not previewable");
	            });
	            return drawPreview;
	        }
	        function drawOnCanvasOrImgFromUrl(url, canvasOrImg, draw, maxSize, customResizeFunction) {
	            var tempImg = new Image(), tempImgRender = new qq.Promise();
	            registerThumbnailRenderedListener(tempImg, tempImgRender);
	            if (isCrossOrigin(url)) {
	                tempImg.crossOrigin = "anonymous";
	            }
	            tempImg.src = url;
	            tempImgRender.then(function rendered() {
	                registerThumbnailRenderedListener(canvasOrImg, draw);
	                var mpImg = new qq.MegaPixImage(tempImg);
	                mpImg.render(canvasOrImg, {
	                    maxWidth: maxSize,
	                    maxHeight: maxSize,
	                    mime: determineMimeOfFileName(url),
	                    resize: customResizeFunction
	                });
	            }, draw.failure);
	        }
	        function drawOnImgFromUrlWithCssScaling(url, img, draw, maxSize) {
	            registerThumbnailRenderedListener(img, draw);
	            qq(img).css({
	                maxWidth: maxSize + "px",
	                maxHeight: maxSize + "px"
	            });
	            img.src = url;
	        }
	        function drawFromUrl(url, container, options) {
	            var draw = new qq.Promise(), scale = options.scale, maxSize = scale ? options.maxSize : null;
	            if (scale && isImg(container)) {
	                if (isCanvasSupported()) {
	                    if (isCrossOrigin(url) && !isImgCorsSupported()) {
	                        drawOnImgFromUrlWithCssScaling(url, container, draw, maxSize);
	                    } else {
	                        drawOnCanvasOrImgFromUrl(url, container, draw, maxSize);
	                    }
	                } else {
	                    drawOnImgFromUrlWithCssScaling(url, container, draw, maxSize);
	                }
	            } else if (isCanvas(container)) {
	                drawOnCanvasOrImgFromUrl(url, container, draw, maxSize);
	            } else if (registerThumbnailRenderedListener(container, draw)) {
	                container.src = url;
	            }
	            return draw;
	        }
	        qq.extend(this, {
	            generate: function(fileBlobOrUrl, container, options) {
	                if (qq.isString(fileBlobOrUrl)) {
	                    log("Attempting to update thumbnail based on server response.");
	                    return drawFromUrl(fileBlobOrUrl, container, options || {});
	                } else {
	                    log("Attempting to draw client-side image preview.");
	                    return draw(fileBlobOrUrl, container, options || {});
	                }
	            }
	        });
	        this._testing = {};
	        this._testing.isImg = isImg;
	        this._testing.isCanvas = isCanvas;
	        this._testing.isCrossOrigin = isCrossOrigin;
	        this._testing.determineMimeOfFileName = determineMimeOfFileName;
	    };
	    qq.Exif = function(fileOrBlob, log) {
	        "use strict";
	        var TAG_IDS = [ 274 ], TAG_INFO = {
	            274: {
	                name: "Orientation",
	                bytes: 2
	            }
	        };
	        function parseLittleEndian(hex) {
	            var result = 0, pow = 0;
	            while (hex.length > 0) {
	                result += parseInt(hex.substring(0, 2), 16) * Math.pow(2, pow);
	                hex = hex.substring(2, hex.length);
	                pow += 8;
	            }
	            return result;
	        }
	        function seekToApp1(offset, promise) {
	            var theOffset = offset, thePromise = promise;
	            if (theOffset === undefined) {
	                theOffset = 2;
	                thePromise = new qq.Promise();
	            }
	            qq.readBlobToHex(fileOrBlob, theOffset, 4).then(function(hex) {
	                var match = /^ffe([0-9])/.exec(hex), segmentLength;
	                if (match) {
	                    if (match[1] !== "1") {
	                        segmentLength = parseInt(hex.slice(4, 8), 16);
	                        seekToApp1(theOffset + segmentLength + 2, thePromise);
	                    } else {
	                        thePromise.success(theOffset);
	                    }
	                } else {
	                    thePromise.failure("No EXIF header to be found!");
	                }
	            });
	            return thePromise;
	        }
	        function getApp1Offset() {
	            var promise = new qq.Promise();
	            qq.readBlobToHex(fileOrBlob, 0, 6).then(function(hex) {
	                if (hex.indexOf("ffd8") !== 0) {
	                    promise.failure("Not a valid JPEG!");
	                } else {
	                    seekToApp1().then(function(offset) {
	                        promise.success(offset);
	                    }, function(error) {
	                        promise.failure(error);
	                    });
	                }
	            });
	            return promise;
	        }
	        function isLittleEndian(app1Start) {
	            var promise = new qq.Promise();
	            qq.readBlobToHex(fileOrBlob, app1Start + 10, 2).then(function(hex) {
	                promise.success(hex === "4949");
	            });
	            return promise;
	        }
	        function getDirEntryCount(app1Start, littleEndian) {
	            var promise = new qq.Promise();
	            qq.readBlobToHex(fileOrBlob, app1Start + 18, 2).then(function(hex) {
	                if (littleEndian) {
	                    return promise.success(parseLittleEndian(hex));
	                } else {
	                    promise.success(parseInt(hex, 16));
	                }
	            });
	            return promise;
	        }
	        function getIfd(app1Start, dirEntries) {
	            var offset = app1Start + 20, bytes = dirEntries * 12;
	            return qq.readBlobToHex(fileOrBlob, offset, bytes);
	        }
	        function getDirEntries(ifdHex) {
	            var entries = [], offset = 0;
	            while (offset + 24 <= ifdHex.length) {
	                entries.push(ifdHex.slice(offset, offset + 24));
	                offset += 24;
	            }
	            return entries;
	        }
	        function getTagValues(littleEndian, dirEntries) {
	            var TAG_VAL_OFFSET = 16, tagsToFind = qq.extend([], TAG_IDS), vals = {};
	            qq.each(dirEntries, function(idx, entry) {
	                var idHex = entry.slice(0, 4), id = littleEndian ? parseLittleEndian(idHex) : parseInt(idHex, 16), tagsToFindIdx = tagsToFind.indexOf(id), tagValHex, tagName, tagValLength;
	                if (tagsToFindIdx >= 0) {
	                    tagName = TAG_INFO[id].name;
	                    tagValLength = TAG_INFO[id].bytes;
	                    tagValHex = entry.slice(TAG_VAL_OFFSET, TAG_VAL_OFFSET + tagValLength * 2);
	                    vals[tagName] = littleEndian ? parseLittleEndian(tagValHex) : parseInt(tagValHex, 16);
	                    tagsToFind.splice(tagsToFindIdx, 1);
	                }
	                if (tagsToFind.length === 0) {
	                    return false;
	                }
	            });
	            return vals;
	        }
	        qq.extend(this, {
	            parse: function() {
	                var parser = new qq.Promise(), onParseFailure = function(message) {
	                    log(qq.format("EXIF header parse failed: '{}' ", message));
	                    parser.failure(message);
	                };
	                getApp1Offset().then(function(app1Offset) {
	                    log(qq.format("Moving forward with EXIF header parsing for '{}'", fileOrBlob.name === undefined ? "blob" : fileOrBlob.name));
	                    isLittleEndian(app1Offset).then(function(littleEndian) {
	                        log(qq.format("EXIF Byte order is {} endian", littleEndian ? "little" : "big"));
	                        getDirEntryCount(app1Offset, littleEndian).then(function(dirEntryCount) {
	                            log(qq.format("Found {} APP1 directory entries", dirEntryCount));
	                            getIfd(app1Offset, dirEntryCount).then(function(ifdHex) {
	                                var dirEntries = getDirEntries(ifdHex), tagValues = getTagValues(littleEndian, dirEntries);
	                                log("Successfully parsed some EXIF tags");
	                                parser.success(tagValues);
	                            }, onParseFailure);
	                        }, onParseFailure);
	                    }, onParseFailure);
	                }, onParseFailure);
	                return parser;
	            }
	        });
	        this._testing = {};
	        this._testing.parseLittleEndian = parseLittleEndian;
	    };
	    qq.Identify = function(fileOrBlob, log) {
	        "use strict";
	        function isIdentifiable(magicBytes, questionableBytes) {
	            var identifiable = false, magicBytesEntries = [].concat(magicBytes);
	            qq.each(magicBytesEntries, function(idx, magicBytesArrayEntry) {
	                if (questionableBytes.indexOf(magicBytesArrayEntry) === 0) {
	                    identifiable = true;
	                    return false;
	                }
	            });
	            return identifiable;
	        }
	        qq.extend(this, {
	            isPreviewable: function() {
	                var self = this, identifier = new qq.Promise(), previewable = false, name = fileOrBlob.name === undefined ? "blob" : fileOrBlob.name;
	                log(qq.format("Attempting to determine if {} can be rendered in this browser", name));
	                log("First pass: check type attribute of blob object.");
	                if (this.isPreviewableSync()) {
	                    log("Second pass: check for magic bytes in file header.");
	                    qq.readBlobToHex(fileOrBlob, 0, 4).then(function(hex) {
	                        qq.each(self.PREVIEWABLE_MIME_TYPES, function(mime, bytes) {
	                            if (isIdentifiable(bytes, hex)) {
	                                if (mime !== "image/tiff" || qq.supportedFeatures.tiffPreviews) {
	                                    previewable = true;
	                                    identifier.success(mime);
	                                }
	                                return false;
	                            }
	                        });
	                        log(qq.format("'{}' is {} able to be rendered in this browser", name, previewable ? "" : "NOT"));
	                        if (!previewable) {
	                            identifier.failure();
	                        }
	                    }, function() {
	                        log("Error reading file w/ name '" + name + "'.  Not able to be rendered in this browser.");
	                        identifier.failure();
	                    });
	                } else {
	                    identifier.failure();
	                }
	                return identifier;
	            },
	            isPreviewableSync: function() {
	                var fileMime = fileOrBlob.type, isRecognizedImage = qq.indexOf(Object.keys(this.PREVIEWABLE_MIME_TYPES), fileMime) >= 0, previewable = false, name = fileOrBlob.name === undefined ? "blob" : fileOrBlob.name;
	                if (isRecognizedImage) {
	                    if (fileMime === "image/tiff") {
	                        previewable = qq.supportedFeatures.tiffPreviews;
	                    } else {
	                        previewable = true;
	                    }
	                }
	                !previewable && log(name + " is not previewable in this browser per the blob's type attr");
	                return previewable;
	            }
	        });
	    };
	    qq.Identify.prototype.PREVIEWABLE_MIME_TYPES = {
	        "image/jpeg": "ffd8ff",
	        "image/gif": "474946",
	        "image/png": "89504e",
	        "image/bmp": "424d",
	        "image/tiff": [ "49492a00", "4d4d002a" ]
	    };
	    qq.ImageValidation = function(blob, log) {
	        "use strict";
	        function hasNonZeroLimits(limits) {
	            var atLeastOne = false;
	            qq.each(limits, function(limit, value) {
	                if (value > 0) {
	                    atLeastOne = true;
	                    return false;
	                }
	            });
	            return atLeastOne;
	        }
	        function getWidthHeight() {
	            var sizeDetermination = new qq.Promise();
	            new qq.Identify(blob, log).isPreviewable().then(function() {
	                var image = new Image(), url = window.URL && window.URL.createObjectURL ? window.URL : window.webkitURL && window.webkitURL.createObjectURL ? window.webkitURL : null;
	                if (url) {
	                    image.onerror = function() {
	                        log("Cannot determine dimensions for image.  May be too large.", "error");
	                        sizeDetermination.failure();
	                    };
	                    image.onload = function() {
	                        sizeDetermination.success({
	                            width: this.width,
	                            height: this.height
	                        });
	                    };
	                    image.src = url.createObjectURL(blob);
	                } else {
	                    log("No createObjectURL function available to generate image URL!", "error");
	                    sizeDetermination.failure();
	                }
	            }, sizeDetermination.failure);
	            return sizeDetermination;
	        }
	        function getFailingLimit(limits, dimensions) {
	            var failingLimit;
	            qq.each(limits, function(limitName, limitValue) {
	                if (limitValue > 0) {
	                    var limitMatcher = /(max|min)(Width|Height)/.exec(limitName), dimensionPropName = limitMatcher[2].charAt(0).toLowerCase() + limitMatcher[2].slice(1), actualValue = dimensions[dimensionPropName];
	                    switch (limitMatcher[1]) {
	                      case "min":
	                        if (actualValue < limitValue) {
	                            failingLimit = limitName;
	                            return false;
	                        }
	                        break;
	
	                      case "max":
	                        if (actualValue > limitValue) {
	                            failingLimit = limitName;
	                            return false;
	                        }
	                        break;
	                    }
	                }
	            });
	            return failingLimit;
	        }
	        this.validate = function(limits) {
	            var validationEffort = new qq.Promise();
	            log("Attempting to validate image.");
	            if (hasNonZeroLimits(limits)) {
	                getWidthHeight().then(function(dimensions) {
	                    var failingLimit = getFailingLimit(limits, dimensions);
	                    if (failingLimit) {
	                        validationEffort.failure(failingLimit);
	                    } else {
	                        validationEffort.success();
	                    }
	                }, validationEffort.success);
	            } else {
	                validationEffort.success();
	            }
	            return validationEffort;
	        };
	    };
	    qq.Session = function(spec) {
	        "use strict";
	        var options = {
	            endpoint: null,
	            params: {},
	            customHeaders: {},
	            cors: {},
	            addFileRecord: function(sessionData) {},
	            log: function(message, level) {}
	        };
	        qq.extend(options, spec, true);
	        function isJsonResponseValid(response) {
	            if (qq.isArray(response)) {
	                return true;
	            }
	            options.log("Session response is not an array.", "error");
	        }
	        function handleFileItems(fileItems, success, xhrOrXdr, promise) {
	            var someItemsIgnored = false;
	            success = success && isJsonResponseValid(fileItems);
	            if (success) {
	                qq.each(fileItems, function(idx, fileItem) {
	                    if (fileItem.uuid == null) {
	                        someItemsIgnored = true;
	                        options.log(qq.format("Session response item {} did not include a valid UUID - ignoring.", idx), "error");
	                    } else if (fileItem.name == null) {
	                        someItemsIgnored = true;
	                        options.log(qq.format("Session response item {} did not include a valid name - ignoring.", idx), "error");
	                    } else {
	                        try {
	                            options.addFileRecord(fileItem);
	                            return true;
	                        } catch (err) {
	                            someItemsIgnored = true;
	                            options.log(err.message, "error");
	                        }
	                    }
	                    return false;
	                });
	            }
	            promise[success && !someItemsIgnored ? "success" : "failure"](fileItems, xhrOrXdr);
	        }
	        this.refresh = function() {
	            var refreshEffort = new qq.Promise(), refreshCompleteCallback = function(response, success, xhrOrXdr) {
	                handleFileItems(response, success, xhrOrXdr, refreshEffort);
	            }, requesterOptions = qq.extend({}, options), requester = new qq.SessionAjaxRequester(qq.extend(requesterOptions, {
	                onComplete: refreshCompleteCallback
	            }));
	            requester.queryServer();
	            return refreshEffort;
	        };
	    };
	    qq.SessionAjaxRequester = function(spec) {
	        "use strict";
	        var requester, options = {
	            endpoint: null,
	            customHeaders: {},
	            params: {},
	            cors: {
	                expected: false,
	                sendCredentials: false
	            },
	            onComplete: function(response, success, xhrOrXdr) {},
	            log: function(str, level) {}
	        };
	        qq.extend(options, spec);
	        function onComplete(id, xhrOrXdr, isError) {
	            var response = null;
	            if (xhrOrXdr.responseText != null) {
	                try {
	                    response = qq.parseJson(xhrOrXdr.responseText);
	                } catch (err) {
	                    options.log("Problem parsing session response: " + err.message, "error");
	                    isError = true;
	                }
	            }
	            options.onComplete(response, !isError, xhrOrXdr);
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            acceptHeader: "application/json",
	            validMethods: [ "GET" ],
	            method: "GET",
	            endpointStore: {
	                get: function() {
	                    return options.endpoint;
	                }
	            },
	            customHeaders: options.customHeaders,
	            log: options.log,
	            onComplete: onComplete,
	            cors: options.cors
	        }));
	        qq.extend(this, {
	            queryServer: function() {
	                var params = qq.extend({}, options.params);
	                options.log("Session query request.");
	                requester.initTransport("sessionRefresh").withParams(params).withCacheBuster().send();
	            }
	        });
	    };
	    qq.Scaler = function(spec, log) {
	        "use strict";
	        var self = this, customResizeFunction = spec.customResizer, includeOriginal = spec.sendOriginal, orient = spec.orient, defaultType = spec.defaultType, defaultQuality = spec.defaultQuality / 100, failedToScaleText = spec.failureText, includeExif = spec.includeExif, sizes = this._getSortedSizes(spec.sizes);
	        qq.extend(this, {
	            enabled: qq.supportedFeatures.scaling && sizes.length > 0,
	            getFileRecords: function(originalFileUuid, originalFileName, originalBlobOrBlobData) {
	                var self = this, records = [], originalBlob = originalBlobOrBlobData.blob ? originalBlobOrBlobData.blob : originalBlobOrBlobData, identifier = new qq.Identify(originalBlob, log);
	                if (identifier.isPreviewableSync()) {
	                    qq.each(sizes, function(idx, sizeRecord) {
	                        var outputType = self._determineOutputType({
	                            defaultType: defaultType,
	                            requestedType: sizeRecord.type,
	                            refType: originalBlob.type
	                        });
	                        records.push({
	                            uuid: qq.getUniqueId(),
	                            name: self._getName(originalFileName, {
	                                name: sizeRecord.name,
	                                type: outputType,
	                                refType: originalBlob.type
	                            }),
	                            blob: new qq.BlobProxy(originalBlob, qq.bind(self._generateScaledImage, self, {
	                                customResizeFunction: customResizeFunction,
	                                maxSize: sizeRecord.maxSize,
	                                orient: orient,
	                                type: outputType,
	                                quality: defaultQuality,
	                                failedText: failedToScaleText,
	                                includeExif: includeExif,
	                                log: log
	                            }))
	                        });
	                    });
	                    records.push({
	                        uuid: originalFileUuid,
	                        name: originalFileName,
	                        size: originalBlob.size,
	                        blob: includeOriginal ? originalBlob : null
	                    });
	                } else {
	                    records.push({
	                        uuid: originalFileUuid,
	                        name: originalFileName,
	                        size: originalBlob.size,
	                        blob: originalBlob
	                    });
	                }
	                return records;
	            },
	            handleNewFile: function(file, name, uuid, size, fileList, batchId, uuidParamName, api) {
	                var self = this, buttonId = file.qqButtonId || file.blob && file.blob.qqButtonId, scaledIds = [], originalId = null, addFileToHandler = api.addFileToHandler, uploadData = api.uploadData, paramsStore = api.paramsStore, proxyGroupId = qq.getUniqueId();
	                qq.each(self.getFileRecords(uuid, name, file), function(idx, record) {
	                    var blobSize = record.size, id;
	                    if (record.blob instanceof qq.BlobProxy) {
	                        blobSize = -1;
	                    }
	                    id = uploadData.addFile({
	                        uuid: record.uuid,
	                        name: record.name,
	                        size: blobSize,
	                        batchId: batchId,
	                        proxyGroupId: proxyGroupId
	                    });
	                    if (record.blob instanceof qq.BlobProxy) {
	                        scaledIds.push(id);
	                    } else {
	                        originalId = id;
	                    }
	                    if (record.blob) {
	                        addFileToHandler(id, record.blob);
	                        fileList.push({
	                            id: id,
	                            file: record.blob
	                        });
	                    } else {
	                        uploadData.setStatus(id, qq.status.REJECTED);
	                    }
	                });
	                if (originalId !== null) {
	                    qq.each(scaledIds, function(idx, scaledId) {
	                        var params = {
	                            qqparentuuid: uploadData.retrieve({
	                                id: originalId
	                            }).uuid,
	                            qqparentsize: uploadData.retrieve({
	                                id: originalId
	                            }).size
	                        };
	                        params[uuidParamName] = uploadData.retrieve({
	                            id: scaledId
	                        }).uuid;
	                        uploadData.setParentId(scaledId, originalId);
	                        paramsStore.addReadOnly(scaledId, params);
	                    });
	                    if (scaledIds.length) {
	                        (function() {
	                            var param = {};
	                            param[uuidParamName] = uploadData.retrieve({
	                                id: originalId
	                            }).uuid;
	                            paramsStore.addReadOnly(originalId, param);
	                        })();
	                    }
	                }
	            }
	        });
	    };
	    qq.extend(qq.Scaler.prototype, {
	        scaleImage: function(id, specs, api) {
	            "use strict";
	            if (!qq.supportedFeatures.scaling) {
	                throw new qq.Error("Scaling is not supported in this browser!");
	            }
	            var scalingEffort = new qq.Promise(), log = api.log, file = api.getFile(id), uploadData = api.uploadData.retrieve({
	                id: id
	            }), name = uploadData && uploadData.name, uuid = uploadData && uploadData.uuid, scalingOptions = {
	                customResizer: specs.customResizer,
	                sendOriginal: false,
	                orient: specs.orient,
	                defaultType: specs.type || null,
	                defaultQuality: specs.quality,
	                failedToScaleText: "Unable to scale",
	                sizes: [ {
	                    name: "",
	                    maxSize: specs.maxSize
	                } ]
	            }, scaler = new qq.Scaler(scalingOptions, log);
	            if (!qq.Scaler || !qq.supportedFeatures.imagePreviews || !file) {
	                scalingEffort.failure();
	                log("Could not generate requested scaled image for " + id + ".  " + "Scaling is either not possible in this browser, or the file could not be located.", "error");
	            } else {
	                qq.bind(function() {
	                    var record = scaler.getFileRecords(uuid, name, file)[0];
	                    if (record && record.blob instanceof qq.BlobProxy) {
	                        record.blob.create().then(scalingEffort.success, scalingEffort.failure);
	                    } else {
	                        log(id + " is not a scalable image!", "error");
	                        scalingEffort.failure();
	                    }
	                }, this)();
	            }
	            return scalingEffort;
	        },
	        _determineOutputType: function(spec) {
	            "use strict";
	            var requestedType = spec.requestedType, defaultType = spec.defaultType, referenceType = spec.refType;
	            if (!defaultType && !requestedType) {
	                if (referenceType !== "image/jpeg") {
	                    return "image/png";
	                }
	                return referenceType;
	            }
	            if (!requestedType) {
	                return defaultType;
	            }
	            if (qq.indexOf(Object.keys(qq.Identify.prototype.PREVIEWABLE_MIME_TYPES), requestedType) >= 0) {
	                if (requestedType === "image/tiff") {
	                    return qq.supportedFeatures.tiffPreviews ? requestedType : defaultType;
	                }
	                return requestedType;
	            }
	            return defaultType;
	        },
	        _getName: function(originalName, scaledVersionProperties) {
	            "use strict";
	            var startOfExt = originalName.lastIndexOf("."), versionType = scaledVersionProperties.type || "image/png", referenceType = scaledVersionProperties.refType, scaledName = "", scaledExt = qq.getExtension(originalName), nameAppendage = "";
	            if (scaledVersionProperties.name && scaledVersionProperties.name.trim().length) {
	                nameAppendage = " (" + scaledVersionProperties.name + ")";
	            }
	            if (startOfExt >= 0) {
	                scaledName = originalName.substr(0, startOfExt);
	                if (referenceType !== versionType) {
	                    scaledExt = versionType.split("/")[1];
	                }
	                scaledName += nameAppendage + "." + scaledExt;
	            } else {
	                scaledName = originalName + nameAppendage;
	            }
	            return scaledName;
	        },
	        _getSortedSizes: function(sizes) {
	            "use strict";
	            sizes = qq.extend([], sizes);
	            return sizes.sort(function(a, b) {
	                if (a.maxSize > b.maxSize) {
	                    return 1;
	                }
	                if (a.maxSize < b.maxSize) {
	                    return -1;
	                }
	                return 0;
	            });
	        },
	        _generateScaledImage: function(spec, sourceFile) {
	            "use strict";
	            var self = this, customResizeFunction = spec.customResizeFunction, log = spec.log, maxSize = spec.maxSize, orient = spec.orient, type = spec.type, quality = spec.quality, failedText = spec.failedText, includeExif = spec.includeExif && sourceFile.type === "image/jpeg" && type === "image/jpeg", scalingEffort = new qq.Promise(), imageGenerator = new qq.ImageGenerator(log), canvas = document.createElement("canvas");
	            log("Attempting to generate scaled version for " + sourceFile.name);
	            imageGenerator.generate(sourceFile, canvas, {
	                maxSize: maxSize,
	                orient: orient,
	                customResizeFunction: customResizeFunction
	            }).then(function() {
	                var scaledImageDataUri = canvas.toDataURL(type, quality), signalSuccess = function() {
	                    log("Success generating scaled version for " + sourceFile.name);
	                    var blob = qq.dataUriToBlob(scaledImageDataUri);
	                    scalingEffort.success(blob);
	                };
	                if (includeExif) {
	                    self._insertExifHeader(sourceFile, scaledImageDataUri, log).then(function(scaledImageDataUriWithExif) {
	                        scaledImageDataUri = scaledImageDataUriWithExif;
	                        signalSuccess();
	                    }, function() {
	                        log("Problem inserting EXIF header into scaled image.  Using scaled image w/out EXIF data.", "error");
	                        signalSuccess();
	                    });
	                } else {
	                    signalSuccess();
	                }
	            }, function() {
	                log("Failed attempt to generate scaled version for " + sourceFile.name, "error");
	                scalingEffort.failure(failedText);
	            });
	            return scalingEffort;
	        },
	        _insertExifHeader: function(originalImage, scaledImageDataUri, log) {
	            "use strict";
	            var reader = new FileReader(), insertionEffort = new qq.Promise(), originalImageDataUri = "";
	            reader.onload = function() {
	                originalImageDataUri = reader.result;
	                insertionEffort.success(qq.ExifRestorer.restore(originalImageDataUri, scaledImageDataUri));
	            };
	            reader.onerror = function() {
	                log("Problem reading " + originalImage.name + " during attempt to transfer EXIF data to scaled version.", "error");
	                insertionEffort.failure();
	            };
	            reader.readAsDataURL(originalImage);
	            return insertionEffort;
	        },
	        _dataUriToBlob: function(dataUri) {
	            "use strict";
	            var byteString, mimeString, arrayBuffer, intArray;
	            if (dataUri.split(",")[0].indexOf("base64") >= 0) {
	                byteString = atob(dataUri.split(",")[1]);
	            } else {
	                byteString = decodeURI(dataUri.split(",")[1]);
	            }
	            mimeString = dataUri.split(",")[0].split(":")[1].split(";")[0];
	            arrayBuffer = new ArrayBuffer(byteString.length);
	            intArray = new Uint8Array(arrayBuffer);
	            qq.each(byteString, function(idx, character) {
	                intArray[idx] = character.charCodeAt(0);
	            });
	            return this._createBlob(arrayBuffer, mimeString);
	        },
	        _createBlob: function(data, mime) {
	            "use strict";
	            var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder, blobBuilder = BlobBuilder && new BlobBuilder();
	            if (blobBuilder) {
	                blobBuilder.append(data);
	                return blobBuilder.getBlob(mime);
	            } else {
	                return new Blob([ data ], {
	                    type: mime
	                });
	            }
	        }
	    });
	    qq.ExifRestorer = function() {
	        var ExifRestorer = {};
	        ExifRestorer.KEY_STR = "ABCDEFGHIJKLMNOP" + "QRSTUVWXYZabcdef" + "ghijklmnopqrstuv" + "wxyz0123456789+/" + "=";
	        ExifRestorer.encode64 = function(input) {
	            var output = "", chr1, chr2, chr3 = "", enc1, enc2, enc3, enc4 = "", i = 0;
	            do {
	                chr1 = input[i++];
	                chr2 = input[i++];
	                chr3 = input[i++];
	                enc1 = chr1 >> 2;
	                enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	                enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	                enc4 = chr3 & 63;
	                if (isNaN(chr2)) {
	                    enc3 = enc4 = 64;
	                } else if (isNaN(chr3)) {
	                    enc4 = 64;
	                }
	                output = output + this.KEY_STR.charAt(enc1) + this.KEY_STR.charAt(enc2) + this.KEY_STR.charAt(enc3) + this.KEY_STR.charAt(enc4);
	                chr1 = chr2 = chr3 = "";
	                enc1 = enc2 = enc3 = enc4 = "";
	            } while (i < input.length);
	            return output;
	        };
	        ExifRestorer.restore = function(origFileBase64, resizedFileBase64) {
	            var expectedBase64Header = "data:image/jpeg;base64,";
	            if (!origFileBase64.match(expectedBase64Header)) {
	                return resizedFileBase64;
	            }
	            var rawImage = this.decode64(origFileBase64.replace(expectedBase64Header, ""));
	            var segments = this.slice2Segments(rawImage);
	            var image = this.exifManipulation(resizedFileBase64, segments);
	            return expectedBase64Header + this.encode64(image);
	        };
	        ExifRestorer.exifManipulation = function(resizedFileBase64, segments) {
	            var exifArray = this.getExifArray(segments), newImageArray = this.insertExif(resizedFileBase64, exifArray), aBuffer = new Uint8Array(newImageArray);
	            return aBuffer;
	        };
	        ExifRestorer.getExifArray = function(segments) {
	            var seg;
	            for (var x = 0; x < segments.length; x++) {
	                seg = segments[x];
	                if (seg[0] == 255 & seg[1] == 225) {
	                    return seg;
	                }
	            }
	            return [];
	        };
	        ExifRestorer.insertExif = function(resizedFileBase64, exifArray) {
	            var imageData = resizedFileBase64.replace("data:image/jpeg;base64,", ""), buf = this.decode64(imageData), separatePoint = buf.indexOf(255, 3), mae = buf.slice(0, separatePoint), ato = buf.slice(separatePoint), array = mae;
	            array = array.concat(exifArray);
	            array = array.concat(ato);
	            return array;
	        };
	        ExifRestorer.slice2Segments = function(rawImageArray) {
	            var head = 0, segments = [];
	            while (1) {
	                if (rawImageArray[head] == 255 & rawImageArray[head + 1] == 218) {
	                    break;
	                }
	                if (rawImageArray[head] == 255 & rawImageArray[head + 1] == 216) {
	                    head += 2;
	                } else {
	                    var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3], endPoint = head + length + 2, seg = rawImageArray.slice(head, endPoint);
	                    segments.push(seg);
	                    head = endPoint;
	                }
	                if (head > rawImageArray.length) {
	                    break;
	                }
	            }
	            return segments;
	        };
	        ExifRestorer.decode64 = function(input) {
	            var output = "", chr1, chr2, chr3 = "", enc1, enc2, enc3, enc4 = "", i = 0, buf = [];
	            var base64test = /[^A-Za-z0-9\+\/\=]/g;
	            if (base64test.exec(input)) {
	                throw new Error("There were invalid base64 characters in the input text.  " + "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='");
	            }
	            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	            do {
	                enc1 = this.KEY_STR.indexOf(input.charAt(i++));
	                enc2 = this.KEY_STR.indexOf(input.charAt(i++));
	                enc3 = this.KEY_STR.indexOf(input.charAt(i++));
	                enc4 = this.KEY_STR.indexOf(input.charAt(i++));
	                chr1 = enc1 << 2 | enc2 >> 4;
	                chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	                chr3 = (enc3 & 3) << 6 | enc4;
	                buf.push(chr1);
	                if (enc3 != 64) {
	                    buf.push(chr2);
	                }
	                if (enc4 != 64) {
	                    buf.push(chr3);
	                }
	                chr1 = chr2 = chr3 = "";
	                enc1 = enc2 = enc3 = enc4 = "";
	            } while (i < input.length);
	            return buf;
	        };
	        return ExifRestorer;
	    }();
	    qq.TotalProgress = function(callback, getSize) {
	        "use strict";
	        var perFileProgress = {}, totalLoaded = 0, totalSize = 0, lastLoadedSent = -1, lastTotalSent = -1, callbackProxy = function(loaded, total) {
	            if (loaded !== lastLoadedSent || total !== lastTotalSent) {
	                callback(loaded, total);
	            }
	            lastLoadedSent = loaded;
	            lastTotalSent = total;
	        }, noRetryableFiles = function(failed, retryable) {
	            var none = true;
	            qq.each(failed, function(idx, failedId) {
	                if (qq.indexOf(retryable, failedId) >= 0) {
	                    none = false;
	                    return false;
	                }
	            });
	            return none;
	        }, onCancel = function(id) {
	            updateTotalProgress(id, -1, -1);
	            delete perFileProgress[id];
	        }, onAllComplete = function(successful, failed, retryable) {
	            if (failed.length === 0 || noRetryableFiles(failed, retryable)) {
	                callbackProxy(totalSize, totalSize);
	                this.reset();
	            }
	        }, onNew = function(id) {
	            var size = getSize(id);
	            if (size > 0) {
	                updateTotalProgress(id, 0, size);
	                perFileProgress[id] = {
	                    loaded: 0,
	                    total: size
	                };
	            }
	        }, updateTotalProgress = function(id, newLoaded, newTotal) {
	            var oldLoaded = perFileProgress[id] ? perFileProgress[id].loaded : 0, oldTotal = perFileProgress[id] ? perFileProgress[id].total : 0;
	            if (newLoaded === -1 && newTotal === -1) {
	                totalLoaded -= oldLoaded;
	                totalSize -= oldTotal;
	            } else {
	                if (newLoaded) {
	                    totalLoaded += newLoaded - oldLoaded;
	                }
	                if (newTotal) {
	                    totalSize += newTotal - oldTotal;
	                }
	            }
	            callbackProxy(totalLoaded, totalSize);
	        };
	        qq.extend(this, {
	            onAllComplete: onAllComplete,
	            onStatusChange: function(id, oldStatus, newStatus) {
	                if (newStatus === qq.status.CANCELED || newStatus === qq.status.REJECTED) {
	                    onCancel(id);
	                } else if (newStatus === qq.status.SUBMITTING) {
	                    onNew(id);
	                }
	            },
	            onIndividualProgress: function(id, loaded, total) {
	                updateTotalProgress(id, loaded, total);
	                perFileProgress[id] = {
	                    loaded: loaded,
	                    total: total
	                };
	            },
	            onNewSize: function(id) {
	                onNew(id);
	            },
	            reset: function() {
	                perFileProgress = {};
	                totalLoaded = 0;
	                totalSize = 0;
	            }
	        });
	    };
	    qq.PasteSupport = function(o) {
	        "use strict";
	        var options, detachPasteHandler;
	        options = {
	            targetElement: null,
	            callbacks: {
	                log: function(message, level) {},
	                pasteReceived: function(blob) {}
	            }
	        };
	        function isImage(item) {
	            return item.type && item.type.indexOf("image/") === 0;
	        }
	        function registerPasteHandler() {
	            detachPasteHandler = qq(options.targetElement).attach("paste", function(event) {
	                var clipboardData = event.clipboardData;
	                if (clipboardData) {
	                    qq.each(clipboardData.items, function(idx, item) {
	                        if (isImage(item)) {
	                            var blob = item.getAsFile();
	                            options.callbacks.pasteReceived(blob);
	                        }
	                    });
	                }
	            });
	        }
	        function unregisterPasteHandler() {
	            if (detachPasteHandler) {
	                detachPasteHandler();
	            }
	        }
	        qq.extend(options, o);
	        registerPasteHandler();
	        qq.extend(this, {
	            reset: function() {
	                unregisterPasteHandler();
	            }
	        });
	    };
	    qq.FormSupport = function(options, startUpload, log) {
	        "use strict";
	        var self = this, interceptSubmit = options.interceptSubmit, formEl = options.element, autoUpload = options.autoUpload;
	        qq.extend(this, {
	            newEndpoint: null,
	            newAutoUpload: autoUpload,
	            attachedToForm: false,
	            getFormInputsAsObject: function() {
	                if (formEl == null) {
	                    return null;
	                }
	                return self._form2Obj(formEl);
	            }
	        });
	        function determineNewEndpoint(formEl) {
	            if (formEl.getAttribute("action")) {
	                self.newEndpoint = formEl.getAttribute("action");
	            }
	        }
	        function validateForm(formEl, nativeSubmit) {
	            if (formEl.checkValidity && !formEl.checkValidity()) {
	                log("Form did not pass validation checks - will not upload.", "error");
	                nativeSubmit();
	            } else {
	                return true;
	            }
	        }
	        function maybeUploadOnSubmit(formEl) {
	            var nativeSubmit = formEl.submit;
	            qq(formEl).attach("submit", function(event) {
	                event = event || window.event;
	                if (event.preventDefault) {
	                    event.preventDefault();
	                } else {
	                    event.returnValue = false;
	                }
	                validateForm(formEl, nativeSubmit) && startUpload();
	            });
	            formEl.submit = function() {
	                validateForm(formEl, nativeSubmit) && startUpload();
	            };
	        }
	        function determineFormEl(formEl) {
	            if (formEl) {
	                if (qq.isString(formEl)) {
	                    formEl = document.getElementById(formEl);
	                }
	                if (formEl) {
	                    log("Attaching to form element.");
	                    determineNewEndpoint(formEl);
	                    interceptSubmit && maybeUploadOnSubmit(formEl);
	                }
	            }
	            return formEl;
	        }
	        formEl = determineFormEl(formEl);
	        this.attachedToForm = !!formEl;
	    };
	    qq.extend(qq.FormSupport.prototype, {
	        _form2Obj: function(form) {
	            "use strict";
	            var obj = {}, notIrrelevantType = function(type) {
	                var irrelevantTypes = [ "button", "image", "reset", "submit" ];
	                return qq.indexOf(irrelevantTypes, type.toLowerCase()) < 0;
	            }, radioOrCheckbox = function(type) {
	                return qq.indexOf([ "checkbox", "radio" ], type.toLowerCase()) >= 0;
	            }, ignoreValue = function(el) {
	                if (radioOrCheckbox(el.type) && !el.checked) {
	                    return true;
	                }
	                return el.disabled && el.type.toLowerCase() !== "hidden";
	            }, selectValue = function(select) {
	                var value = null;
	                qq.each(qq(select).children(), function(idx, child) {
	                    if (child.tagName.toLowerCase() === "option" && child.selected) {
	                        value = child.value;
	                        return false;
	                    }
	                });
	                return value;
	            };
	            qq.each(form.elements, function(idx, el) {
	                if ((qq.isInput(el, true) || el.tagName.toLowerCase() === "textarea") && notIrrelevantType(el.type) && !ignoreValue(el)) {
	                    obj[el.name] = el.value;
	                } else if (el.tagName.toLowerCase() === "select" && !ignoreValue(el)) {
	                    var value = selectValue(el);
	                    if (value !== null) {
	                        obj[el.name] = value;
	                    }
	                }
	            });
	            return obj;
	        }
	    });
	    qq.CryptoJS = function(Math, undefined) {
	        var C = {};
	        var C_lib = C.lib = {};
	        var Base = C_lib.Base = function() {
	            function F() {}
	            return {
	                extend: function(overrides) {
	                    F.prototype = this;
	                    var subtype = new F();
	                    if (overrides) {
	                        subtype.mixIn(overrides);
	                    }
	                    if (!subtype.hasOwnProperty("init")) {
	                        subtype.init = function() {
	                            subtype.$super.init.apply(this, arguments);
	                        };
	                    }
	                    subtype.init.prototype = subtype;
	                    subtype.$super = this;
	                    return subtype;
	                },
	                create: function() {
	                    var instance = this.extend();
	                    instance.init.apply(instance, arguments);
	                    return instance;
	                },
	                init: function() {},
	                mixIn: function(properties) {
	                    for (var propertyName in properties) {
	                        if (properties.hasOwnProperty(propertyName)) {
	                            this[propertyName] = properties[propertyName];
	                        }
	                    }
	                    if (properties.hasOwnProperty("toString")) {
	                        this.toString = properties.toString;
	                    }
	                },
	                clone: function() {
	                    return this.init.prototype.extend(this);
	                }
	            };
	        }();
	        var WordArray = C_lib.WordArray = Base.extend({
	            init: function(words, sigBytes) {
	                words = this.words = words || [];
	                if (sigBytes != undefined) {
	                    this.sigBytes = sigBytes;
	                } else {
	                    this.sigBytes = words.length * 4;
	                }
	            },
	            toString: function(encoder) {
	                return (encoder || Hex).stringify(this);
	            },
	            concat: function(wordArray) {
	                var thisWords = this.words;
	                var thatWords = wordArray.words;
	                var thisSigBytes = this.sigBytes;
	                var thatSigBytes = wordArray.sigBytes;
	                this.clamp();
	                if (thisSigBytes % 4) {
	                    for (var i = 0; i < thatSigBytes; i++) {
	                        var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 255;
	                        thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
	                    }
	                } else if (thatWords.length > 65535) {
	                    for (var i = 0; i < thatSigBytes; i += 4) {
	                        thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
	                    }
	                } else {
	                    thisWords.push.apply(thisWords, thatWords);
	                }
	                this.sigBytes += thatSigBytes;
	                return this;
	            },
	            clamp: function() {
	                var words = this.words;
	                var sigBytes = this.sigBytes;
	                words[sigBytes >>> 2] &= 4294967295 << 32 - sigBytes % 4 * 8;
	                words.length = Math.ceil(sigBytes / 4);
	            },
	            clone: function() {
	                var clone = Base.clone.call(this);
	                clone.words = this.words.slice(0);
	                return clone;
	            },
	            random: function(nBytes) {
	                var words = [];
	                for (var i = 0; i < nBytes; i += 4) {
	                    words.push(Math.random() * 4294967296 | 0);
	                }
	                return new WordArray.init(words, nBytes);
	            }
	        });
	        var C_enc = C.enc = {};
	        var Hex = C_enc.Hex = {
	            stringify: function(wordArray) {
	                var words = wordArray.words;
	                var sigBytes = wordArray.sigBytes;
	                var hexChars = [];
	                for (var i = 0; i < sigBytes; i++) {
	                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
	                    hexChars.push((bite >>> 4).toString(16));
	                    hexChars.push((bite & 15).toString(16));
	                }
	                return hexChars.join("");
	            },
	            parse: function(hexStr) {
	                var hexStrLength = hexStr.length;
	                var words = [];
	                for (var i = 0; i < hexStrLength; i += 2) {
	                    words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
	                }
	                return new WordArray.init(words, hexStrLength / 2);
	            }
	        };
	        var Latin1 = C_enc.Latin1 = {
	            stringify: function(wordArray) {
	                var words = wordArray.words;
	                var sigBytes = wordArray.sigBytes;
	                var latin1Chars = [];
	                for (var i = 0; i < sigBytes; i++) {
	                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
	                    latin1Chars.push(String.fromCharCode(bite));
	                }
	                return latin1Chars.join("");
	            },
	            parse: function(latin1Str) {
	                var latin1StrLength = latin1Str.length;
	                var words = [];
	                for (var i = 0; i < latin1StrLength; i++) {
	                    words[i >>> 2] |= (latin1Str.charCodeAt(i) & 255) << 24 - i % 4 * 8;
	                }
	                return new WordArray.init(words, latin1StrLength);
	            }
	        };
	        var Utf8 = C_enc.Utf8 = {
	            stringify: function(wordArray) {
	                try {
	                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	                } catch (e) {
	                    throw new Error("Malformed UTF-8 data");
	                }
	            },
	            parse: function(utf8Str) {
	                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	            }
	        };
	        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	            reset: function() {
	                this._data = new WordArray.init();
	                this._nDataBytes = 0;
	            },
	            _append: function(data) {
	                if (typeof data == "string") {
	                    data = Utf8.parse(data);
	                }
	                this._data.concat(data);
	                this._nDataBytes += data.sigBytes;
	            },
	            _process: function(doFlush) {
	                var data = this._data;
	                var dataWords = data.words;
	                var dataSigBytes = data.sigBytes;
	                var blockSize = this.blockSize;
	                var blockSizeBytes = blockSize * 4;
	                var nBlocksReady = dataSigBytes / blockSizeBytes;
	                if (doFlush) {
	                    nBlocksReady = Math.ceil(nBlocksReady);
	                } else {
	                    nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	                }
	                var nWordsReady = nBlocksReady * blockSize;
	                var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	                if (nWordsReady) {
	                    for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                        this._doProcessBlock(dataWords, offset);
	                    }
	                    var processedWords = dataWords.splice(0, nWordsReady);
	                    data.sigBytes -= nBytesReady;
	                }
	                return new WordArray.init(processedWords, nBytesReady);
	            },
	            clone: function() {
	                var clone = Base.clone.call(this);
	                clone._data = this._data.clone();
	                return clone;
	            },
	            _minBufferSize: 0
	        });
	        var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	            cfg: Base.extend(),
	            init: function(cfg) {
	                this.cfg = this.cfg.extend(cfg);
	                this.reset();
	            },
	            reset: function() {
	                BufferedBlockAlgorithm.reset.call(this);
	                this._doReset();
	            },
	            update: function(messageUpdate) {
	                this._append(messageUpdate);
	                this._process();
	                return this;
	            },
	            finalize: function(messageUpdate) {
	                if (messageUpdate) {
	                    this._append(messageUpdate);
	                }
	                var hash = this._doFinalize();
	                return hash;
	            },
	            blockSize: 512 / 32,
	            _createHelper: function(hasher) {
	                return function(message, cfg) {
	                    return new hasher.init(cfg).finalize(message);
	                };
	            },
	            _createHmacHelper: function(hasher) {
	                return function(message, key) {
	                    return new C_algo.HMAC.init(hasher, key).finalize(message);
	                };
	            }
	        });
	        var C_algo = C.algo = {};
	        return C;
	    }(Math);
	    (function() {
	        var C = qq.CryptoJS;
	        var C_lib = C.lib;
	        var WordArray = C_lib.WordArray;
	        var C_enc = C.enc;
	        var Base64 = C_enc.Base64 = {
	            stringify: function(wordArray) {
	                var words = wordArray.words;
	                var sigBytes = wordArray.sigBytes;
	                var map = this._map;
	                wordArray.clamp();
	                var base64Chars = [];
	                for (var i = 0; i < sigBytes; i += 3) {
	                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
	                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 255;
	                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 255;
	                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
	                    for (var j = 0; j < 4 && i + j * .75 < sigBytes; j++) {
	                        base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 63));
	                    }
	                }
	                var paddingChar = map.charAt(64);
	                if (paddingChar) {
	                    while (base64Chars.length % 4) {
	                        base64Chars.push(paddingChar);
	                    }
	                }
	                return base64Chars.join("");
	            },
	            parse: function(base64Str) {
	                var base64StrLength = base64Str.length;
	                var map = this._map;
	                var paddingChar = map.charAt(64);
	                if (paddingChar) {
	                    var paddingIndex = base64Str.indexOf(paddingChar);
	                    if (paddingIndex != -1) {
	                        base64StrLength = paddingIndex;
	                    }
	                }
	                var words = [];
	                var nBytes = 0;
	                for (var i = 0; i < base64StrLength; i++) {
	                    if (i % 4) {
	                        var bits1 = map.indexOf(base64Str.charAt(i - 1)) << i % 4 * 2;
	                        var bits2 = map.indexOf(base64Str.charAt(i)) >>> 6 - i % 4 * 2;
	                        words[nBytes >>> 2] |= (bits1 | bits2) << 24 - nBytes % 4 * 8;
	                        nBytes++;
	                    }
	                }
	                return WordArray.create(words, nBytes);
	            },
	            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
	        };
	    })();
	    (function() {
	        var C = qq.CryptoJS;
	        var C_lib = C.lib;
	        var Base = C_lib.Base;
	        var C_enc = C.enc;
	        var Utf8 = C_enc.Utf8;
	        var C_algo = C.algo;
	        var HMAC = C_algo.HMAC = Base.extend({
	            init: function(hasher, key) {
	                hasher = this._hasher = new hasher.init();
	                if (typeof key == "string") {
	                    key = Utf8.parse(key);
	                }
	                var hasherBlockSize = hasher.blockSize;
	                var hasherBlockSizeBytes = hasherBlockSize * 4;
	                if (key.sigBytes > hasherBlockSizeBytes) {
	                    key = hasher.finalize(key);
	                }
	                key.clamp();
	                var oKey = this._oKey = key.clone();
	                var iKey = this._iKey = key.clone();
	                var oKeyWords = oKey.words;
	                var iKeyWords = iKey.words;
	                for (var i = 0; i < hasherBlockSize; i++) {
	                    oKeyWords[i] ^= 1549556828;
	                    iKeyWords[i] ^= 909522486;
	                }
	                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
	                this.reset();
	            },
	            reset: function() {
	                var hasher = this._hasher;
	                hasher.reset();
	                hasher.update(this._iKey);
	            },
	            update: function(messageUpdate) {
	                this._hasher.update(messageUpdate);
	                return this;
	            },
	            finalize: function(messageUpdate) {
	                var hasher = this._hasher;
	                var innerHash = hasher.finalize(messageUpdate);
	                hasher.reset();
	                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
	                return hmac;
	            }
	        });
	    })();
	    (function() {
	        var C = qq.CryptoJS;
	        var C_lib = C.lib;
	        var WordArray = C_lib.WordArray;
	        var Hasher = C_lib.Hasher;
	        var C_algo = C.algo;
	        var W = [];
	        var SHA1 = C_algo.SHA1 = Hasher.extend({
	            _doReset: function() {
	                this._hash = new WordArray.init([ 1732584193, 4023233417, 2562383102, 271733878, 3285377520 ]);
	            },
	            _doProcessBlock: function(M, offset) {
	                var H = this._hash.words;
	                var a = H[0];
	                var b = H[1];
	                var c = H[2];
	                var d = H[3];
	                var e = H[4];
	                for (var i = 0; i < 80; i++) {
	                    if (i < 16) {
	                        W[i] = M[offset + i] | 0;
	                    } else {
	                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                        W[i] = n << 1 | n >>> 31;
	                    }
	                    var t = (a << 5 | a >>> 27) + e + W[i];
	                    if (i < 20) {
	                        t += (b & c | ~b & d) + 1518500249;
	                    } else if (i < 40) {
	                        t += (b ^ c ^ d) + 1859775393;
	                    } else if (i < 60) {
	                        t += (b & c | b & d | c & d) - 1894007588;
	                    } else {
	                        t += (b ^ c ^ d) - 899497514;
	                    }
	                    e = d;
	                    d = c;
	                    c = b << 30 | b >>> 2;
	                    b = a;
	                    a = t;
	                }
	                H[0] = H[0] + a | 0;
	                H[1] = H[1] + b | 0;
	                H[2] = H[2] + c | 0;
	                H[3] = H[3] + d | 0;
	                H[4] = H[4] + e | 0;
	            },
	            _doFinalize: function() {
	                var data = this._data;
	                var dataWords = data.words;
	                var nBitsTotal = this._nDataBytes * 8;
	                var nBitsLeft = data.sigBytes * 8;
	                dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
	                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 4294967296);
	                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
	                data.sigBytes = dataWords.length * 4;
	                this._process();
	                return this._hash;
	            },
	            clone: function() {
	                var clone = Hasher.clone.call(this);
	                clone._hash = this._hash.clone();
	                return clone;
	            }
	        });
	        C.SHA1 = Hasher._createHelper(SHA1);
	        C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	    })();
	    (function(Math) {
	        var C = qq.CryptoJS;
	        var C_lib = C.lib;
	        var WordArray = C_lib.WordArray;
	        var Hasher = C_lib.Hasher;
	        var C_algo = C.algo;
	        var H = [];
	        var K = [];
	        (function() {
	            function isPrime(n) {
	                var sqrtN = Math.sqrt(n);
	                for (var factor = 2; factor <= sqrtN; factor++) {
	                    if (!(n % factor)) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	            function getFractionalBits(n) {
	                return (n - (n | 0)) * 4294967296 | 0;
	            }
	            var n = 2;
	            var nPrime = 0;
	            while (nPrime < 64) {
	                if (isPrime(n)) {
	                    if (nPrime < 8) {
	                        H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                    }
	                    K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	                    nPrime++;
	                }
	                n++;
	            }
	        })();
	        var W = [];
	        var SHA256 = C_algo.SHA256 = Hasher.extend({
	            _doReset: function() {
	                this._hash = new WordArray.init(H.slice(0));
	            },
	            _doProcessBlock: function(M, offset) {
	                var H = this._hash.words;
	                var a = H[0];
	                var b = H[1];
	                var c = H[2];
	                var d = H[3];
	                var e = H[4];
	                var f = H[5];
	                var g = H[6];
	                var h = H[7];
	                for (var i = 0; i < 64; i++) {
	                    if (i < 16) {
	                        W[i] = M[offset + i] | 0;
	                    } else {
	                        var gamma0x = W[i - 15];
	                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
	                        var gamma1x = W[i - 2];
	                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
	                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                    }
	                    var ch = e & f ^ ~e & g;
	                    var maj = a & b ^ a & c ^ b & c;
	                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
	                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
	                    var t1 = h + sigma1 + ch + K[i] + W[i];
	                    var t2 = sigma0 + maj;
	                    h = g;
	                    g = f;
	                    f = e;
	                    e = d + t1 | 0;
	                    d = c;
	                    c = b;
	                    b = a;
	                    a = t1 + t2 | 0;
	                }
	                H[0] = H[0] + a | 0;
	                H[1] = H[1] + b | 0;
	                H[2] = H[2] + c | 0;
	                H[3] = H[3] + d | 0;
	                H[4] = H[4] + e | 0;
	                H[5] = H[5] + f | 0;
	                H[6] = H[6] + g | 0;
	                H[7] = H[7] + h | 0;
	            },
	            _doFinalize: function() {
	                var data = this._data;
	                var dataWords = data.words;
	                var nBitsTotal = this._nDataBytes * 8;
	                var nBitsLeft = data.sigBytes * 8;
	                dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
	                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 4294967296);
	                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
	                data.sigBytes = dataWords.length * 4;
	                this._process();
	                return this._hash;
	            },
	            clone: function() {
	                var clone = Hasher.clone.call(this);
	                clone._hash = this._hash.clone();
	                return clone;
	            }
	        });
	        C.SHA256 = Hasher._createHelper(SHA256);
	        C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	    })(Math);
	    (function() {
	        if (typeof ArrayBuffer != "function") {
	            return;
	        }
	        var C = qq.CryptoJS;
	        var C_lib = C.lib;
	        var WordArray = C_lib.WordArray;
	        var superInit = WordArray.init;
	        var subInit = WordArray.init = function(typedArray) {
	            if (typedArray instanceof ArrayBuffer) {
	                typedArray = new Uint8Array(typedArray);
	            }
	            if (typedArray instanceof Int8Array || typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) {
	                typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	            }
	            if (typedArray instanceof Uint8Array) {
	                var typedArrayByteLength = typedArray.byteLength;
	                var words = [];
	                for (var i = 0; i < typedArrayByteLength; i++) {
	                    words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
	                }
	                superInit.call(this, words, typedArrayByteLength);
	            } else {
	                superInit.apply(this, arguments);
	            }
	        };
	        subInit.prototype = WordArray;
	    })();
	    qq.s3 = qq.s3 || {};
	    qq.s3.util = qq.s3.util || function() {
	        "use strict";
	        return {
	            ALGORITHM_PARAM_NAME: "x-amz-algorithm",
	            AWS_PARAM_PREFIX: "x-amz-meta-",
	            CREDENTIAL_PARAM_NAME: "x-amz-credential",
	            DATE_PARAM_NAME: "x-amz-date",
	            REDUCED_REDUNDANCY_PARAM_NAME: "x-amz-storage-class",
	            REDUCED_REDUNDANCY_PARAM_VALUE: "REDUCED_REDUNDANCY",
	            SERVER_SIDE_ENCRYPTION_PARAM_NAME: "x-amz-server-side-encryption",
	            SERVER_SIDE_ENCRYPTION_PARAM_VALUE: "AES256",
	            SESSION_TOKEN_PARAM_NAME: "x-amz-security-token",
	            V4_ALGORITHM_PARAM_VALUE: "AWS4-HMAC-SHA256",
	            V4_SIGNATURE_PARAM_NAME: "x-amz-signature",
	            CASE_SENSITIVE_PARAM_NAMES: [ "Cache-Control", "Content-Disposition", "Content-Encoding", "Content-MD5" ],
	            UNSIGNABLE_REST_HEADER_NAMES: [ "Cache-Control", "Content-Disposition", "Content-Encoding", "Content-MD5" ],
	            UNPREFIXED_PARAM_NAMES: [ "Cache-Control", "Content-Disposition", "Content-Encoding", "Content-MD5", "x-amz-server-side-encryption", "x-amz-server-side-encryption-aws-kms-key-id", "x-amz-server-side-encryption-customer-algorithm", "x-amz-server-side-encryption-customer-key", "x-amz-server-side-encryption-customer-key-MD5" ],
	            getBucket: function(endpoint) {
	                var patterns = [ /^(?:https?:\/\/)?([a-z0-9.\-_]+)\.s3(?:-[a-z0-9\-]+)?\.amazonaws\.com/i, /^(?:https?:\/\/)?s3(?:-[a-z0-9\-]+)?\.amazonaws\.com\/([a-z0-9.\-_]+)/i, /^(?:https?:\/\/)?([a-z0-9.\-_]+)/i ], bucket;
	                qq.each(patterns, function(idx, pattern) {
	                    var match = pattern.exec(endpoint);
	                    if (match) {
	                        bucket = match[1];
	                        return false;
	                    }
	                });
	                return bucket;
	            },
	            _getPrefixedParamName: function(name) {
	                if (qq.indexOf(qq.s3.util.UNPREFIXED_PARAM_NAMES, name) >= 0) {
	                    return name;
	                }
	                return qq.s3.util.AWS_PARAM_PREFIX + name;
	            },
	            getPolicy: function(spec) {
	                var policy = {}, conditions = [], bucket = spec.bucket, date = spec.date, drift = spec.clockDrift, key = spec.key, accessKey = spec.accessKey, acl = spec.acl, type = spec.type, expectedStatus = spec.expectedStatus, sessionToken = spec.sessionToken, params = spec.params, successRedirectUrl = qq.s3.util.getSuccessRedirectAbsoluteUrl(spec.successRedirectUrl), minFileSize = spec.minFileSize, maxFileSize = spec.maxFileSize, reducedRedundancy = spec.reducedRedundancy, region = spec.region, serverSideEncryption = spec.serverSideEncryption, signatureVersion = spec.signatureVersion;
	                policy.expiration = qq.s3.util.getPolicyExpirationDate(date, drift);
	                conditions.push({
	                    acl: acl
	                });
	                conditions.push({
	                    bucket: bucket
	                });
	                if (type) {
	                    conditions.push({
	                        "Content-Type": type
	                    });
	                }
	                if (expectedStatus) {
	                    conditions.push({
	                        success_action_status: expectedStatus.toString()
	                    });
	                }
	                if (successRedirectUrl) {
	                    conditions.push({
	                        success_action_redirect: successRedirectUrl
	                    });
	                }
	                if (reducedRedundancy) {
	                    conditions.push({});
	                    conditions[conditions.length - 1][qq.s3.util.REDUCED_REDUNDANCY_PARAM_NAME] = qq.s3.util.REDUCED_REDUNDANCY_PARAM_VALUE;
	                }
	                if (sessionToken) {
	                    conditions.push({});
	                    conditions[conditions.length - 1][qq.s3.util.SESSION_TOKEN_PARAM_NAME] = sessionToken;
	                }
	                if (serverSideEncryption) {
	                    conditions.push({});
	                    conditions[conditions.length - 1][qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_NAME] = qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_VALUE;
	                }
	                if (signatureVersion === 2) {
	                    conditions.push({
	                        key: key
	                    });
	                } else if (signatureVersion === 4) {
	                    conditions.push({});
	                    conditions[conditions.length - 1][qq.s3.util.ALGORITHM_PARAM_NAME] = qq.s3.util.V4_ALGORITHM_PARAM_VALUE;
	                    conditions.push({});
	                    conditions[conditions.length - 1].key = key;
	                    conditions.push({});
	                    conditions[conditions.length - 1][qq.s3.util.CREDENTIAL_PARAM_NAME] = qq.s3.util.getV4CredentialsString({
	                        date: date,
	                        key: accessKey,
	                        region: region
	                    });
	                    conditions.push({});
	                    conditions[conditions.length - 1][qq.s3.util.DATE_PARAM_NAME] = qq.s3.util.getV4PolicyDate(date, drift);
	                }
	                qq.each(params, function(name, val) {
	                    var awsParamName = qq.s3.util._getPrefixedParamName(name), param = {};
	                    if (qq.indexOf(qq.s3.util.UNPREFIXED_PARAM_NAMES, awsParamName) >= 0) {
	                        param[awsParamName] = val;
	                    } else {
	                        param[awsParamName] = encodeURIComponent(val);
	                    }
	                    conditions.push(param);
	                });
	                policy.conditions = conditions;
	                qq.s3.util.enforceSizeLimits(policy, minFileSize, maxFileSize);
	                return policy;
	            },
	            refreshPolicyCredentials: function(policy, newSessionToken) {
	                var sessionTokenFound = false;
	                qq.each(policy.conditions, function(oldCondIdx, oldCondObj) {
	                    qq.each(oldCondObj, function(oldCondName, oldCondVal) {
	                        if (oldCondName === qq.s3.util.SESSION_TOKEN_PARAM_NAME) {
	                            oldCondObj[oldCondName] = newSessionToken;
	                            sessionTokenFound = true;
	                        }
	                    });
	                });
	                if (!sessionTokenFound) {
	                    policy.conditions.push({});
	                    policy.conditions[policy.conditions.length - 1][qq.s3.util.SESSION_TOKEN_PARAM_NAME] = newSessionToken;
	                }
	            },
	            generateAwsParams: function(spec, signPolicyCallback) {
	                var awsParams = {}, customParams = spec.params, promise = new qq.Promise(), sessionToken = spec.sessionToken, drift = spec.clockDrift, type = spec.type, key = spec.key, accessKey = spec.accessKey, acl = spec.acl, expectedStatus = spec.expectedStatus, successRedirectUrl = qq.s3.util.getSuccessRedirectAbsoluteUrl(spec.successRedirectUrl), reducedRedundancy = spec.reducedRedundancy, region = spec.region, serverSideEncryption = spec.serverSideEncryption, signatureVersion = spec.signatureVersion, now = new Date(), log = spec.log, policyJson;
	                spec.date = now;
	                policyJson = qq.s3.util.getPolicy(spec);
	                awsParams.key = key;
	                if (type) {
	                    awsParams["Content-Type"] = type;
	                }
	                if (expectedStatus) {
	                    awsParams.success_action_status = expectedStatus;
	                }
	                if (successRedirectUrl) {
	                    awsParams.success_action_redirect = successRedirectUrl;
	                }
	                if (reducedRedundancy) {
	                    awsParams[qq.s3.util.REDUCED_REDUNDANCY_PARAM_NAME] = qq.s3.util.REDUCED_REDUNDANCY_PARAM_VALUE;
	                }
	                if (serverSideEncryption) {
	                    awsParams[qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_NAME] = qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_VALUE;
	                }
	                if (sessionToken) {
	                    awsParams[qq.s3.util.SESSION_TOKEN_PARAM_NAME] = sessionToken;
	                }
	                awsParams.acl = acl;
	                qq.each(customParams, function(name, val) {
	                    var awsParamName = qq.s3.util._getPrefixedParamName(name);
	                    if (qq.indexOf(qq.s3.util.UNPREFIXED_PARAM_NAMES, awsParamName) >= 0) {
	                        awsParams[awsParamName] = val;
	                    } else {
	                        awsParams[awsParamName] = encodeURIComponent(val);
	                    }
	                });
	                if (signatureVersion === 2) {
	                    awsParams.AWSAccessKeyId = accessKey;
	                } else if (signatureVersion === 4) {
	                    awsParams[qq.s3.util.ALGORITHM_PARAM_NAME] = qq.s3.util.V4_ALGORITHM_PARAM_VALUE;
	                    awsParams[qq.s3.util.CREDENTIAL_PARAM_NAME] = qq.s3.util.getV4CredentialsString({
	                        date: now,
	                        key: accessKey,
	                        region: region
	                    });
	                    awsParams[qq.s3.util.DATE_PARAM_NAME] = qq.s3.util.getV4PolicyDate(now, drift);
	                }
	                signPolicyCallback(policyJson).then(function(policyAndSignature, updatedAccessKey, updatedSessionToken) {
	                    awsParams.policy = policyAndSignature.policy;
	                    if (spec.signatureVersion === 2) {
	                        awsParams.signature = policyAndSignature.signature;
	                        if (updatedAccessKey) {
	                            awsParams.AWSAccessKeyId = updatedAccessKey;
	                        }
	                    } else if (spec.signatureVersion === 4) {
	                        awsParams[qq.s3.util.V4_SIGNATURE_PARAM_NAME] = policyAndSignature.signature;
	                    }
	                    if (updatedSessionToken) {
	                        awsParams[qq.s3.util.SESSION_TOKEN_PARAM_NAME] = updatedSessionToken;
	                    }
	                    promise.success(awsParams);
	                }, function(errorMessage) {
	                    errorMessage = errorMessage || "Can't continue further with request to S3 as we did not receive " + "a valid signature and policy from the server.";
	                    log("Policy signing failed.  " + errorMessage, "error");
	                    promise.failure(errorMessage);
	                });
	                return promise;
	            },
	            enforceSizeLimits: function(policy, minSize, maxSize) {
	                var adjustedMinSize = minSize < 0 ? 0 : minSize, adjustedMaxSize = maxSize <= 0 ? 9007199254740992 : maxSize;
	                if (minSize > 0 || maxSize > 0) {
	                    policy.conditions.push([ "content-length-range", adjustedMinSize.toString(), adjustedMaxSize.toString() ]);
	                }
	            },
	            getPolicyExpirationDate: function(date, drift) {
	                var adjustedDate = new Date(date.getTime() + drift);
	                return qq.s3.util.getPolicyDate(adjustedDate, 5);
	            },
	            getCredentialsDate: function(date) {
	                return date.getUTCFullYear() + "" + ("0" + (date.getUTCMonth() + 1)).slice(-2) + ("0" + date.getUTCDate()).slice(-2);
	            },
	            getPolicyDate: function(date, _minutesToAdd_) {
	                var minutesToAdd = _minutesToAdd_ || 0, pad, r;
	                date.setMinutes(date.getMinutes() + (minutesToAdd || 0));
	                if (Date.prototype.toISOString) {
	                    return date.toISOString();
	                } else {
	                    pad = function(number) {
	                        r = String(number);
	                        if (r.length === 1) {
	                            r = "0" + r;
	                        }
	                        return r;
	                    };
	                    return date.getUTCFullYear() + "-" + pad(date.getUTCMonth() + 1) + "-" + pad(date.getUTCDate()) + "T" + pad(date.getUTCHours()) + ":" + pad(date.getUTCMinutes()) + ":" + pad(date.getUTCSeconds()) + "." + String((date.getUTCMilliseconds() / 1e3).toFixed(3)).slice(2, 5) + "Z";
	                }
	            },
	            parseIframeResponse: function(iframe) {
	                var doc = iframe.contentDocument || iframe.contentWindow.document, queryString = doc.location.search, match = /bucket=(.+)&key=(.+)&etag=(.+)/.exec(queryString);
	                if (match) {
	                    return {
	                        bucket: match[1],
	                        key: match[2],
	                        etag: match[3].replace(/%22/g, "")
	                    };
	                }
	            },
	            getSuccessRedirectAbsoluteUrl: function(successRedirectUrl) {
	                if (successRedirectUrl) {
	                    var targetAnchorContainer = document.createElement("div"), targetAnchor;
	                    if (qq.ie7()) {
	                        targetAnchorContainer.innerHTML = "<a href='" + successRedirectUrl + "'></a>";
	                        targetAnchor = targetAnchorContainer.firstChild;
	                        return targetAnchor.href;
	                    } else {
	                        targetAnchor = document.createElement("a");
	                        targetAnchor.href = successRedirectUrl;
	                        targetAnchor.href = targetAnchor.href;
	                        return targetAnchor.href;
	                    }
	                }
	            },
	            getV4CredentialsString: function(spec) {
	                return spec.key + "/" + qq.s3.util.getCredentialsDate(spec.date) + "/" + spec.region + "/s3/aws4_request";
	            },
	            getV4PolicyDate: function(date, drift) {
	                var adjustedDate = new Date(date.getTime() + drift);
	                return qq.s3.util.getCredentialsDate(adjustedDate) + "T" + ("0" + adjustedDate.getUTCHours()).slice(-2) + ("0" + adjustedDate.getUTCMinutes()).slice(-2) + ("0" + adjustedDate.getUTCSeconds()).slice(-2) + "Z";
	            },
	            encodeQueryStringParam: function(param) {
	                var percentEncoded = encodeURIComponent(param);
	                percentEncoded = percentEncoded.replace(/[!'()]/g, escape);
	                percentEncoded = percentEncoded.replace(/\*/g, "%2A");
	                return percentEncoded.replace(/%20/g, "+");
	            },
	            uriEscape: function(string) {
	                var output = encodeURIComponent(string);
	                output = output.replace(/[^A-Za-z0-9_.~\-%]+/g, escape);
	                output = output.replace(/[*]/g, function(ch) {
	                    return "%" + ch.charCodeAt(0).toString(16).toUpperCase();
	                });
	                return output;
	            },
	            uriEscapePath: function(path) {
	                var parts = [];
	                qq.each(path.split("/"), function(idx, item) {
	                    parts.push(qq.s3.util.uriEscape(item));
	                });
	                return parts.join("/");
	            }
	        };
	    }();
	    (function() {
	        "use strict";
	        qq.nonTraditionalBasePublicApi = {
	            setUploadSuccessParams: function(params, id) {
	                this._uploadSuccessParamsStore.set(params, id);
	            },
	            setUploadSuccessEndpoint: function(endpoint, id) {
	                this._uploadSuccessEndpointStore.set(endpoint, id);
	            }
	        };
	        qq.nonTraditionalBasePrivateApi = {
	            _onComplete: function(id, name, result, xhr) {
	                var success = result.success ? true : false, self = this, onCompleteArgs = arguments, successEndpoint = this._uploadSuccessEndpointStore.get(id), successCustomHeaders = this._options.uploadSuccess.customHeaders, successMethod = this._options.uploadSuccess.method, cors = this._options.cors, promise = new qq.Promise(), uploadSuccessParams = this._uploadSuccessParamsStore.get(id), fileParams = this._paramsStore.get(id), onSuccessFromServer = function(successRequestResult) {
	                    delete self._failedSuccessRequestCallbacks[id];
	                    qq.extend(result, successRequestResult);
	                    qq.FineUploaderBasic.prototype._onComplete.apply(self, onCompleteArgs);
	                    promise.success(successRequestResult);
	                }, onFailureFromServer = function(successRequestResult) {
	                    var callback = submitSuccessRequest;
	                    qq.extend(result, successRequestResult);
	                    if (result && result.reset) {
	                        callback = null;
	                    }
	                    if (!callback) {
	                        delete self._failedSuccessRequestCallbacks[id];
	                    } else {
	                        self._failedSuccessRequestCallbacks[id] = callback;
	                    }
	                    if (!self._onAutoRetry(id, name, result, xhr, callback)) {
	                        qq.FineUploaderBasic.prototype._onComplete.apply(self, onCompleteArgs);
	                        promise.failure(successRequestResult);
	                    }
	                }, submitSuccessRequest, successAjaxRequester;
	                if (success && successEndpoint) {
	                    successAjaxRequester = new qq.UploadSuccessAjaxRequester({
	                        endpoint: successEndpoint,
	                        method: successMethod,
	                        customHeaders: successCustomHeaders,
	                        cors: cors,
	                        log: qq.bind(this.log, this)
	                    });
	                    qq.extend(uploadSuccessParams, self._getEndpointSpecificParams(id, result, xhr), true);
	                    fileParams && qq.extend(uploadSuccessParams, fileParams, true);
	                    submitSuccessRequest = qq.bind(function() {
	                        successAjaxRequester.sendSuccessRequest(id, uploadSuccessParams).then(onSuccessFromServer, onFailureFromServer);
	                    }, self);
	                    submitSuccessRequest();
	                    return promise;
	                }
	                return qq.FineUploaderBasic.prototype._onComplete.apply(this, arguments);
	            },
	            _manualRetry: function(id) {
	                var successRequestCallback = this._failedSuccessRequestCallbacks[id];
	                return qq.FineUploaderBasic.prototype._manualRetry.call(this, id, successRequestCallback);
	            }
	        };
	    })();
	    (function() {
	        "use strict";
	        qq.s3.FineUploaderBasic = function(o) {
	            var options = {
	                request: {
	                    accessKey: null,
	                    clockDrift: 0
	                },
	                objectProperties: {
	                    acl: "private",
	                    bucket: qq.bind(function(id) {
	                        return qq.s3.util.getBucket(this.getEndpoint(id));
	                    }, this),
	                    host: qq.bind(function(id) {
	                        return /(?:http|https):\/\/(.+)(?:\/.+)?/.exec(this._endpointStore.get(id))[1];
	                    }, this),
	                    key: "uuid",
	                    reducedRedundancy: false,
	                    region: "us-east-1",
	                    serverSideEncryption: false
	                },
	                credentials: {
	                    accessKey: null,
	                    secretKey: null,
	                    expiration: null,
	                    sessionToken: null
	                },
	                signature: {
	                    customHeaders: {},
	                    endpoint: null,
	                    version: 2
	                },
	                uploadSuccess: {
	                    endpoint: null,
	                    method: "POST",
	                    params: {},
	                    customHeaders: {}
	                },
	                iframeSupport: {
	                    localBlankPagePath: null
	                },
	                chunking: {
	                    partSize: 5242880
	                },
	                cors: {
	                    allowXdr: true
	                },
	                callbacks: {
	                    onCredentialsExpired: function() {}
	                }
	            };
	            qq.extend(options, o, true);
	            if (!this.setCredentials(options.credentials, true)) {
	                this._currentCredentials.accessKey = options.request.accessKey;
	            }
	            this._aclStore = this._createStore(options.objectProperties.acl);
	            qq.FineUploaderBasic.call(this, options);
	            this._uploadSuccessParamsStore = this._createStore(this._options.uploadSuccess.params);
	            this._uploadSuccessEndpointStore = this._createStore(this._options.uploadSuccess.endpoint);
	            this._failedSuccessRequestCallbacks = {};
	            this._cannedKeys = {};
	            this._cannedBuckets = {};
	            this._buckets = {};
	            this._hosts = {};
	        };
	        qq.extend(qq.s3.FineUploaderBasic.prototype, qq.basePublicApi);
	        qq.extend(qq.s3.FineUploaderBasic.prototype, qq.basePrivateApi);
	        qq.extend(qq.s3.FineUploaderBasic.prototype, qq.nonTraditionalBasePublicApi);
	        qq.extend(qq.s3.FineUploaderBasic.prototype, qq.nonTraditionalBasePrivateApi);
	        qq.extend(qq.s3.FineUploaderBasic.prototype, {
	            getBucket: function(id) {
	                if (this._cannedBuckets[id] == null) {
	                    return this._buckets[id];
	                }
	                return this._cannedBuckets[id];
	            },
	            getKey: function(id) {
	                if (this._cannedKeys[id] == null) {
	                    return this._handler.getThirdPartyFileId(id);
	                }
	                return this._cannedKeys[id];
	            },
	            reset: function() {
	                qq.FineUploaderBasic.prototype.reset.call(this);
	                this._failedSuccessRequestCallbacks = [];
	                this._buckets = {};
	                this._hosts = {};
	            },
	            setCredentials: function(credentials, ignoreEmpty) {
	                if (credentials && credentials.secretKey) {
	                    if (!credentials.accessKey) {
	                        throw new qq.Error("Invalid credentials: no accessKey");
	                    } else if (!credentials.expiration) {
	                        throw new qq.Error("Invalid credentials: no expiration");
	                    } else {
	                        this._currentCredentials = qq.extend({}, credentials);
	                        if (qq.isString(credentials.expiration)) {
	                            this._currentCredentials.expiration = new Date(credentials.expiration);
	                        }
	                    }
	                    return true;
	                } else if (!ignoreEmpty) {
	                    throw new qq.Error("Invalid credentials parameter!");
	                } else {
	                    this._currentCredentials = {};
	                }
	            },
	            setAcl: function(acl, id) {
	                this._aclStore.set(acl, id);
	            },
	            _createUploadHandler: function() {
	                var self = this, additionalOptions = {
	                    aclStore: this._aclStore,
	                    getBucket: qq.bind(this._determineBucket, this),
	                    getHost: qq.bind(this._determineHost, this),
	                    getKeyName: qq.bind(this._determineKeyName, this),
	                    iframeSupport: this._options.iframeSupport,
	                    objectProperties: this._options.objectProperties,
	                    signature: this._options.signature,
	                    clockDrift: this._options.request.clockDrift,
	                    validation: {
	                        minSizeLimit: this._options.validation.minSizeLimit,
	                        maxSizeLimit: this._options.validation.sizeLimit
	                    }
	                };
	                qq.override(this._endpointStore, function(super_) {
	                    return {
	                        get: function(id) {
	                            var endpoint = super_.get(id);
	                            if (endpoint.indexOf("http") < 0) {
	                                return "http://" + endpoint;
	                            }
	                            return endpoint;
	                        }
	                    };
	                });
	                qq.override(this._paramsStore, function(super_) {
	                    return {
	                        get: function(id) {
	                            var oldParams = super_.get(id), modifiedParams = {};
	                            qq.each(oldParams, function(name, val) {
	                                var paramName = name;
	                                if (qq.indexOf(qq.s3.util.CASE_SENSITIVE_PARAM_NAMES, paramName) < 0) {
	                                    paramName = paramName.toLowerCase();
	                                }
	                                modifiedParams[paramName] = qq.isFunction(val) ? val() : val;
	                            });
	                            return modifiedParams;
	                        }
	                    };
	                });
	                additionalOptions.signature.credentialsProvider = {
	                    get: function() {
	                        return self._currentCredentials;
	                    },
	                    onExpired: function() {
	                        var updateCredentials = new qq.Promise(), callbackRetVal = self._options.callbacks.onCredentialsExpired();
	                        if (qq.isGenericPromise(callbackRetVal)) {
	                            callbackRetVal.then(function(credentials) {
	                                try {
	                                    self.setCredentials(credentials);
	                                    updateCredentials.success();
	                                } catch (error) {
	                                    self.log("Invalid credentials returned from onCredentialsExpired callback! (" + error.message + ")", "error");
	                                    updateCredentials.failure("onCredentialsExpired did not return valid credentials.");
	                                }
	                            }, function(errorMsg) {
	                                self.log("onCredentialsExpired callback indicated failure! (" + errorMsg + ")", "error");
	                                updateCredentials.failure("onCredentialsExpired callback failed.");
	                            });
	                        } else {
	                            self.log("onCredentialsExpired callback did not return a promise!", "error");
	                            updateCredentials.failure("Unexpected return value for onCredentialsExpired.");
	                        }
	                        return updateCredentials;
	                    }
	                };
	                return qq.FineUploaderBasic.prototype._createUploadHandler.call(this, additionalOptions, "s3");
	            },
	            _determineObjectPropertyValue: function(id, property) {
	                var maybe = this._options.objectProperties[property], promise = new qq.Promise(), self = this;
	                if (qq.isFunction(maybe)) {
	                    maybe = maybe(id);
	                    if (qq.isGenericPromise(maybe)) {
	                        promise = maybe;
	                    } else {
	                        promise.success(maybe);
	                    }
	                } else if (qq.isString(maybe)) {
	                    promise.success(maybe);
	                }
	                promise.then(function success(value) {
	                    self["_" + property + "s"][id] = value;
	                }, function failure(errorMsg) {
	                    qq.log("Problem determining " + property + " for ID " + id + " (" + errorMsg + ")", "error");
	                });
	                return promise;
	            },
	            _determineBucket: function(id) {
	                return this._determineObjectPropertyValue(id, "bucket");
	            },
	            _determineHost: function(id) {
	                return this._determineObjectPropertyValue(id, "host");
	            },
	            _determineKeyName: function(id, filename) {
	                var promise = new qq.Promise(), keynameLogic = this._options.objectProperties.key, extension = qq.getExtension(filename), onGetKeynameFailure = promise.failure, onGetKeynameSuccess = function(keyname, extension) {
	                    var keynameToUse = keyname;
	                    if (extension !== undefined) {
	                        keynameToUse += "." + extension;
	                    }
	                    promise.success(keynameToUse);
	                };
	                switch (keynameLogic) {
	                  case "uuid":
	                    onGetKeynameSuccess(this.getUuid(id), extension);
	                    break;
	
	                  case "filename":
	                    onGetKeynameSuccess(filename);
	                    break;
	
	                  default:
	                    if (qq.isFunction(keynameLogic)) {
	                        this._handleKeynameFunction(keynameLogic, id, onGetKeynameSuccess, onGetKeynameFailure);
	                    } else {
	                        this.log(keynameLogic + " is not a valid value for the s3.keyname option!", "error");
	                        onGetKeynameFailure();
	                    }
	                }
	                return promise;
	            },
	            _handleKeynameFunction: function(keynameFunc, id, successCallback, failureCallback) {
	                var self = this, onSuccess = function(keyname) {
	                    successCallback(keyname);
	                }, onFailure = function(reason) {
	                    self.log(qq.format("Failed to retrieve key name for {}.  Reason: {}", id, reason || "null"), "error");
	                    failureCallback(reason);
	                }, keyname = keynameFunc.call(this, id);
	                if (qq.isGenericPromise(keyname)) {
	                    keyname.then(onSuccess, onFailure);
	                } else if (keyname == null) {
	                    onFailure();
	                } else {
	                    onSuccess(keyname);
	                }
	            },
	            _getEndpointSpecificParams: function(id, response, maybeXhr) {
	                var params = {
	                    key: this.getKey(id),
	                    uuid: this.getUuid(id),
	                    name: this.getName(id),
	                    bucket: this.getBucket(id)
	                };
	                if (maybeXhr && maybeXhr.getResponseHeader("ETag")) {
	                    params.etag = maybeXhr.getResponseHeader("ETag");
	                } else if (response.etag) {
	                    params.etag = response.etag;
	                }
	                return params;
	            },
	            _onSubmitDelete: function(id, onSuccessCallback) {
	                var additionalMandatedParams = {
	                    key: this.getKey(id),
	                    bucket: this.getBucket(id)
	                };
	                return qq.FineUploaderBasic.prototype._onSubmitDelete.call(this, id, onSuccessCallback, additionalMandatedParams);
	            },
	            _addCannedFile: function(sessionData) {
	                var id;
	                if (sessionData.s3Key == null) {
	                    throw new qq.Error("Did not find s3Key property in server session response.  This is required!");
	                } else {
	                    id = qq.FineUploaderBasic.prototype._addCannedFile.apply(this, arguments);
	                    this._cannedKeys[id] = sessionData.s3Key;
	                    this._cannedBuckets[id] = sessionData.s3Bucket;
	                }
	                return id;
	            }
	        });
	    })();
	    if (!window.Uint8ClampedArray) {
	        window.Uint8ClampedArray = function() {};
	    }
	    qq.s3.RequestSigner = function(o) {
	        "use strict";
	        var requester, thisSignatureRequester = this, pendingSignatures = {}, options = {
	            expectingPolicy: false,
	            method: "POST",
	            signatureSpec: {
	                drift: 0,
	                credentialsProvider: {},
	                endpoint: null,
	                customHeaders: {},
	                version: 2
	            },
	            maxConnections: 3,
	            endpointStore: {},
	            paramsStore: {},
	            cors: {
	                expected: false,
	                sendCredentials: false
	            },
	            log: function(str, level) {}
	        }, credentialsProvider, generateHeaders = function(signatureConstructor, signature, promise) {
	            var headers = signatureConstructor.getHeaders();
	            if (options.signatureSpec.version === 4) {
	                headers.Authorization = qq.s3.util.V4_ALGORITHM_PARAM_VALUE + " Credential=" + options.signatureSpec.credentialsProvider.get().accessKey + "/" + qq.s3.util.getCredentialsDate(signatureConstructor.getRequestDate()) + "/" + options.signatureSpec.region + "/" + "s3/aws4_request," + "SignedHeaders=" + signatureConstructor.getSignedHeaders() + "," + "Signature=" + signature;
	            } else {
	                headers.Authorization = "AWS " + options.signatureSpec.credentialsProvider.get().accessKey + ":" + signature;
	            }
	            promise.success(headers, signatureConstructor.getEndOfUrl());
	        }, v2 = {
	            getStringToSign: function(signatureSpec) {
	                return qq.format("{}\n{}\n{}\n\n{}/{}/{}", signatureSpec.method, signatureSpec.contentMd5 || "", signatureSpec.contentType || "", signatureSpec.headersStr || "\n", signatureSpec.bucket, signatureSpec.endOfUrl);
	            },
	            signApiRequest: function(signatureConstructor, headersStr, signatureEffort) {
	                var headersWordArray = qq.CryptoJS.enc.Utf8.parse(headersStr), headersHmacSha1 = qq.CryptoJS.HmacSHA1(headersWordArray, credentialsProvider.get().secretKey), headersHmacSha1Base64 = qq.CryptoJS.enc.Base64.stringify(headersHmacSha1);
	                generateHeaders(signatureConstructor, headersHmacSha1Base64, signatureEffort);
	            },
	            signPolicy: function(policy, signatureEffort, updatedAccessKey, updatedSessionToken) {
	                var policyStr = JSON.stringify(policy), policyWordArray = qq.CryptoJS.enc.Utf8.parse(policyStr), base64Policy = qq.CryptoJS.enc.Base64.stringify(policyWordArray), policyHmacSha1 = qq.CryptoJS.HmacSHA1(base64Policy, credentialsProvider.get().secretKey), policyHmacSha1Base64 = qq.CryptoJS.enc.Base64.stringify(policyHmacSha1);
	                signatureEffort.success({
	                    policy: base64Policy,
	                    signature: policyHmacSha1Base64
	                }, updatedAccessKey, updatedSessionToken);
	            }
	        }, v4 = {
	            getCanonicalQueryString: function(endOfUri) {
	                var queryParamIdx = endOfUri.indexOf("?"), canonicalQueryString = "", encodedQueryParams, encodedQueryParamNames, queryStrings;
	                if (queryParamIdx >= 0) {
	                    encodedQueryParams = {};
	                    queryStrings = endOfUri.substr(queryParamIdx + 1).split("&");
	                    qq.each(queryStrings, function(idx, queryString) {
	                        var nameAndVal = queryString.split("="), paramVal = nameAndVal[1];
	                        if (paramVal == null) {
	                            paramVal = "";
	                        }
	                        encodedQueryParams[encodeURIComponent(nameAndVal[0])] = encodeURIComponent(paramVal);
	                    });
	                    encodedQueryParamNames = Object.keys(encodedQueryParams).sort();
	                    encodedQueryParamNames.forEach(function(encodedQueryParamName, idx) {
	                        canonicalQueryString += encodedQueryParamName + "=" + encodedQueryParams[encodedQueryParamName];
	                        if (idx < encodedQueryParamNames.length - 1) {
	                            canonicalQueryString += "&";
	                        }
	                    });
	                }
	                return canonicalQueryString;
	            },
	            getCanonicalRequest: function(signatureSpec) {
	                return qq.format("{}\n{}\n{}\n{}\n{}\n{}", signatureSpec.method, v4.getCanonicalUri(signatureSpec.endOfUrl), v4.getCanonicalQueryString(signatureSpec.endOfUrl), signatureSpec.headersStr || "\n", v4.getSignedHeaders(signatureSpec.headerNames), signatureSpec.hashedContent);
	            },
	            getCanonicalUri: function(endOfUri) {
	                var path = endOfUri, queryParamIdx = endOfUri.indexOf("?");
	                if (queryParamIdx > 0) {
	                    path = endOfUri.substr(0, queryParamIdx);
	                }
	                return "/" + path;
	            },
	            getEncodedHashedPayload: function(body) {
	                var promise = new qq.Promise(), reader;
	                if (qq.isBlob(body)) {
	                    reader = new FileReader();
	                    reader.onloadend = function(e) {
	                        if (e.target.readyState === FileReader.DONE) {
	                            if (e.target.error) {
	                                promise.failure(e.target.error);
	                            } else {
	                                var wordArray = qq.CryptoJS.lib.WordArray.create(e.target.result);
	                                promise.success(qq.CryptoJS.SHA256(wordArray).toString());
	                            }
	                        }
	                    };
	                    reader.readAsArrayBuffer(body);
	                } else {
	                    body = body || "";
	                    promise.success(qq.CryptoJS.SHA256(body).toString());
	                }
	                return promise;
	            },
	            getScope: function(date, region) {
	                return qq.s3.util.getCredentialsDate(date) + "/" + region + "/s3/aws4_request";
	            },
	            getStringToSign: function(signatureSpec) {
	                var canonicalRequest = v4.getCanonicalRequest(signatureSpec), date = qq.s3.util.getV4PolicyDate(signatureSpec.date, signatureSpec.drift), hashedRequest = qq.CryptoJS.SHA256(canonicalRequest).toString(), scope = v4.getScope(signatureSpec.date, options.signatureSpec.region), stringToSignTemplate = "AWS4-HMAC-SHA256\n{}\n{}\n{}";
	                return {
	                    hashed: qq.format(stringToSignTemplate, date, scope, hashedRequest),
	                    raw: qq.format(stringToSignTemplate, date, scope, canonicalRequest)
	                };
	            },
	            getSignedHeaders: function(headerNames) {
	                var signedHeaders = "";
	                headerNames.forEach(function(headerName, idx) {
	                    signedHeaders += headerName.toLowerCase();
	                    if (idx < headerNames.length - 1) {
	                        signedHeaders += ";";
	                    }
	                });
	                return signedHeaders;
	            },
	            signApiRequest: function(signatureConstructor, headersStr, signatureEffort) {
	                var secretKey = credentialsProvider.get().secretKey, headersPattern = /.+\n.+\n(\d+)\/(.+)\/s3\/.+\n(.+)/, matches = headersPattern.exec(headersStr), dateKey, dateRegionKey, dateRegionServiceKey, signingKey;
	                dateKey = qq.CryptoJS.HmacSHA256(matches[1], "AWS4" + secretKey);
	                dateRegionKey = qq.CryptoJS.HmacSHA256(matches[2], dateKey);
	                dateRegionServiceKey = qq.CryptoJS.HmacSHA256("s3", dateRegionKey);
	                signingKey = qq.CryptoJS.HmacSHA256("aws4_request", dateRegionServiceKey);
	                generateHeaders(signatureConstructor, qq.CryptoJS.HmacSHA256(headersStr, signingKey), signatureEffort);
	            },
	            signPolicy: function(policy, signatureEffort, updatedAccessKey, updatedSessionToken) {
	                var policyStr = JSON.stringify(policy), policyWordArray = qq.CryptoJS.enc.Utf8.parse(policyStr), base64Policy = qq.CryptoJS.enc.Base64.stringify(policyWordArray), secretKey = credentialsProvider.get().secretKey, credentialPattern = /.+\/(.+)\/(.+)\/s3\/aws4_request/, credentialCondition = function() {
	                    var credential = null;
	                    qq.each(policy.conditions, function(key, condition) {
	                        var val = condition["x-amz-credential"];
	                        if (val) {
	                            credential = val;
	                            return false;
	                        }
	                    });
	                    return credential;
	                }(), matches, dateKey, dateRegionKey, dateRegionServiceKey, signingKey;
	                matches = credentialPattern.exec(credentialCondition);
	                dateKey = qq.CryptoJS.HmacSHA256(matches[1], "AWS4" + secretKey);
	                dateRegionKey = qq.CryptoJS.HmacSHA256(matches[2], dateKey);
	                dateRegionServiceKey = qq.CryptoJS.HmacSHA256("s3", dateRegionKey);
	                signingKey = qq.CryptoJS.HmacSHA256("aws4_request", dateRegionServiceKey);
	                signatureEffort.success({
	                    policy: base64Policy,
	                    signature: qq.CryptoJS.HmacSHA256(base64Policy, signingKey).toString()
	                }, updatedAccessKey, updatedSessionToken);
	            }
	        };
	        qq.extend(options, o, true);
	        credentialsProvider = options.signatureSpec.credentialsProvider;
	        function handleSignatureReceived(id, xhrOrXdr, isError) {
	            var responseJson = xhrOrXdr.responseText, pendingSignatureData = pendingSignatures[id], promise = pendingSignatureData.promise, signatureConstructor = pendingSignatureData.signatureConstructor, errorMessage, response;
	            delete pendingSignatures[id];
	            if (responseJson) {
	                try {
	                    response = qq.parseJson(responseJson);
	                } catch (error) {
	                    options.log("Error attempting to parse signature response: " + error, "error");
	                }
	            }
	            if (response && response.error) {
	                isError = true;
	                errorMessage = response.error;
	            } else if (response && response.invalid) {
	                isError = true;
	                errorMessage = "Invalid policy document or request headers!";
	            } else if (response) {
	                if (options.expectingPolicy && !response.policy) {
	                    isError = true;
	                    errorMessage = "Response does not include the base64 encoded policy!";
	                } else if (!response.signature) {
	                    isError = true;
	                    errorMessage = "Response does not include the signature!";
	                }
	            } else {
	                isError = true;
	                errorMessage = "Received an empty or invalid response from the server!";
	            }
	            if (isError) {
	                if (errorMessage) {
	                    options.log(errorMessage, "error");
	                }
	                promise.failure(errorMessage);
	            } else if (signatureConstructor) {
	                generateHeaders(signatureConstructor, response.signature, promise);
	            } else {
	                promise.success(response);
	            }
	        }
	        function getStringToSignArtifacts(id, version, requestInfo) {
	            var promise = new qq.Promise(), method = "POST", headerNames = [], headersStr = "", now = new Date(), endOfUrl, signatureSpec, toSign, generateStringToSign = function(requestInfo) {
	                var contentMd5, headerIndexesToRemove = [];
	                qq.each(requestInfo.headers, function(name) {
	                    headerNames.push(name);
	                });
	                headerNames.sort();
	                qq.each(headerNames, function(idx, headerName) {
	                    if (qq.indexOf(qq.s3.util.UNSIGNABLE_REST_HEADER_NAMES, headerName) < 0) {
	                        headersStr += headerName.toLowerCase() + ":" + requestInfo.headers[headerName].trim() + "\n";
	                    } else if (headerName === "Content-MD5") {
	                        contentMd5 = requestInfo.headers[headerName];
	                    } else {
	                        headerIndexesToRemove.unshift(idx);
	                    }
	                });
	                qq.each(headerIndexesToRemove, function(idx, headerIdx) {
	                    headerNames.splice(headerIdx, 1);
	                });
	                signatureSpec = {
	                    bucket: requestInfo.bucket,
	                    contentMd5: contentMd5,
	                    contentType: requestInfo.contentType,
	                    date: now,
	                    drift: options.signatureSpec.drift,
	                    endOfUrl: endOfUrl,
	                    hashedContent: requestInfo.hashedContent,
	                    headerNames: headerNames,
	                    headersStr: headersStr,
	                    method: method
	                };
	                toSign = version === 2 ? v2.getStringToSign(signatureSpec) : v4.getStringToSign(signatureSpec);
	                return {
	                    date: now,
	                    endOfUrl: endOfUrl,
	                    signedHeaders: version === 4 ? v4.getSignedHeaders(signatureSpec.headerNames) : null,
	                    toSign: version === 4 ? toSign.hashed : toSign,
	                    toSignRaw: version === 4 ? toSign.raw : toSign
	                };
	            };
	            switch (requestInfo.type) {
	              case thisSignatureRequester.REQUEST_TYPE.MULTIPART_ABORT:
	                method = "DELETE";
	                endOfUrl = qq.format("uploadId={}", requestInfo.uploadId);
	                break;
	
	              case thisSignatureRequester.REQUEST_TYPE.MULTIPART_INITIATE:
	                endOfUrl = "uploads";
	                break;
	
	              case thisSignatureRequester.REQUEST_TYPE.MULTIPART_COMPLETE:
	                endOfUrl = qq.format("uploadId={}", requestInfo.uploadId);
	                break;
	
	              case thisSignatureRequester.REQUEST_TYPE.MULTIPART_UPLOAD:
	                method = "PUT";
	                endOfUrl = qq.format("partNumber={}&uploadId={}", requestInfo.partNum, requestInfo.uploadId);
	                break;
	            }
	            endOfUrl = requestInfo.key + "?" + endOfUrl;
	            if (version === 4) {
	                v4.getEncodedHashedPayload(requestInfo.content).then(function(hashedContent) {
	                    requestInfo.headers["x-amz-content-sha256"] = hashedContent;
	                    requestInfo.headers.Host = requestInfo.host;
	                    requestInfo.headers["x-amz-date"] = qq.s3.util.getV4PolicyDate(now, options.signatureSpec.drift);
	                    requestInfo.hashedContent = hashedContent;
	                    promise.success(generateStringToSign(requestInfo));
	                }, function(err) {
	                    promise.failure(err);
	                });
	            } else {
	                promise.success(generateStringToSign(requestInfo));
	            }
	            return promise;
	        }
	        function determineSignatureClientSide(id, toBeSigned, signatureEffort, updatedAccessKey, updatedSessionToken) {
	            var updatedHeaders;
	            if (toBeSigned.signatureConstructor) {
	                if (updatedSessionToken) {
	                    updatedHeaders = toBeSigned.signatureConstructor.getHeaders();
	                    updatedHeaders[qq.s3.util.SESSION_TOKEN_PARAM_NAME] = updatedSessionToken;
	                    toBeSigned.signatureConstructor.withHeaders(updatedHeaders);
	                }
	                toBeSigned.signatureConstructor.getToSign(id).then(function(signatureArtifacts) {
	                    signApiRequest(toBeSigned.signatureConstructor, signatureArtifacts.stringToSign, signatureEffort);
	                }, function(err) {
	                    signatureEffort.failure(err);
	                });
	            } else {
	                updatedSessionToken && qq.s3.util.refreshPolicyCredentials(toBeSigned, updatedSessionToken);
	                signPolicy(toBeSigned, signatureEffort, updatedAccessKey, updatedSessionToken);
	            }
	        }
	        function signPolicy(policy, signatureEffort, updatedAccessKey, updatedSessionToken) {
	            if (options.signatureSpec.version === 4) {
	                v4.signPolicy(policy, signatureEffort, updatedAccessKey, updatedSessionToken);
	            } else {
	                v2.signPolicy(policy, signatureEffort, updatedAccessKey, updatedSessionToken);
	            }
	        }
	        function signApiRequest(signatureConstructor, headersStr, signatureEffort) {
	            if (options.signatureSpec.version === 4) {
	                v4.signApiRequest(signatureConstructor, headersStr, signatureEffort);
	            } else {
	                v2.signApiRequest(signatureConstructor, headersStr, signatureEffort);
	            }
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            acceptHeader: "application/json",
	            method: options.method,
	            contentType: "application/json; charset=utf-8",
	            endpointStore: {
	                get: function() {
	                    return options.signatureSpec.endpoint;
	                }
	            },
	            paramsStore: options.paramsStore,
	            maxConnections: options.maxConnections,
	            customHeaders: options.signatureSpec.customHeaders,
	            log: options.log,
	            onComplete: handleSignatureReceived,
	            cors: options.cors
	        }));
	        qq.extend(this, {
	            getSignature: function(id, toBeSigned) {
	                var params = toBeSigned, signatureConstructor = toBeSigned.signatureConstructor, signatureEffort = new qq.Promise(), queryParams;
	                if (options.signatureSpec.version === 4) {
	                    queryParams = {
	                        v4: true
	                    };
	                }
	                if (credentialsProvider.get().secretKey && qq.CryptoJS) {
	                    if (credentialsProvider.get().expiration.getTime() > Date.now()) {
	                        determineSignatureClientSide(id, toBeSigned, signatureEffort);
	                    } else {
	                        credentialsProvider.onExpired().then(function() {
	                            determineSignatureClientSide(id, toBeSigned, signatureEffort, credentialsProvider.get().accessKey, credentialsProvider.get().sessionToken);
	                        }, function(errorMsg) {
	                            options.log("Attempt to update expired credentials apparently failed! Unable to sign request.  ", "error");
	                            signatureEffort.failure("Unable to sign request - expired credentials.");
	                        });
	                    }
	                } else {
	                    options.log("Submitting S3 signature request for " + id);
	                    if (signatureConstructor) {
	                        signatureConstructor.getToSign(id).then(function(signatureArtifacts) {
	                            params = {
	                                headers: signatureArtifacts.stringToSignRaw
	                            };
	                            requester.initTransport(id).withParams(params).withQueryParams(queryParams).send();
	                        }, function(err) {
	                            options.log("Failed to construct signature. ", "error");
	                            signatureEffort.failure("Failed to construct signature.");
	                        });
	                    } else {
	                        requester.initTransport(id).withParams(params).withQueryParams(queryParams).send();
	                    }
	                    pendingSignatures[id] = {
	                        promise: signatureEffort,
	                        signatureConstructor: signatureConstructor
	                    };
	                }
	                return signatureEffort;
	            },
	            constructStringToSign: function(type, bucket, host, key) {
	                var headers = {}, uploadId, content, contentType, partNum, artifacts;
	                return {
	                    withHeaders: function(theHeaders) {
	                        headers = theHeaders;
	                        return this;
	                    },
	                    withUploadId: function(theUploadId) {
	                        uploadId = theUploadId;
	                        return this;
	                    },
	                    withContent: function(theContent) {
	                        content = theContent;
	                        return this;
	                    },
	                    withContentType: function(theContentType) {
	                        contentType = theContentType;
	                        return this;
	                    },
	                    withPartNum: function(thePartNum) {
	                        partNum = thePartNum;
	                        return this;
	                    },
	                    getToSign: function(id) {
	                        var sessionToken = credentialsProvider.get().sessionToken, promise = new qq.Promise(), adjustedDate = new Date(Date.now() + options.signatureSpec.drift);
	                        headers["x-amz-date"] = adjustedDate.toUTCString();
	                        if (sessionToken) {
	                            headers[qq.s3.util.SESSION_TOKEN_PARAM_NAME] = sessionToken;
	                        }
	                        getStringToSignArtifacts(id, options.signatureSpec.version, {
	                            bucket: bucket,
	                            content: content,
	                            contentType: contentType,
	                            headers: headers,
	                            host: host,
	                            key: key,
	                            partNum: partNum,
	                            type: type,
	                            uploadId: uploadId
	                        }).then(function(_artifacts_) {
	                            artifacts = _artifacts_;
	                            promise.success({
	                                headers: function() {
	                                    if (contentType) {
	                                        headers["Content-Type"] = contentType;
	                                    }
	                                    delete headers.Host;
	                                    return headers;
	                                }(),
	                                date: artifacts.date,
	                                endOfUrl: artifacts.endOfUrl,
	                                signedHeaders: artifacts.signedHeaders,
	                                stringToSign: artifacts.toSign,
	                                stringToSignRaw: artifacts.toSignRaw
	                            });
	                        }, function(err) {
	                            promise.failure(err);
	                        });
	                        return promise;
	                    },
	                    getHeaders: function() {
	                        return qq.extend({}, headers);
	                    },
	                    getEndOfUrl: function() {
	                        return artifacts && artifacts.endOfUrl;
	                    },
	                    getRequestDate: function() {
	                        return artifacts && artifacts.date;
	                    },
	                    getSignedHeaders: function() {
	                        return artifacts && artifacts.signedHeaders;
	                    }
	                };
	            }
	        });
	    };
	    qq.s3.RequestSigner.prototype.REQUEST_TYPE = {
	        MULTIPART_INITIATE: "multipart_initiate",
	        MULTIPART_COMPLETE: "multipart_complete",
	        MULTIPART_ABORT: "multipart_abort",
	        MULTIPART_UPLOAD: "multipart_upload"
	    };
	    qq.UploadSuccessAjaxRequester = function(o) {
	        "use strict";
	        var requester, pendingRequests = [], options = {
	            method: "POST",
	            endpoint: null,
	            maxConnections: 3,
	            customHeaders: {},
	            paramsStore: {},
	            cors: {
	                expected: false,
	                sendCredentials: false
	            },
	            log: function(str, level) {}
	        };
	        qq.extend(options, o);
	        function handleSuccessResponse(id, xhrOrXdr, isError) {
	            var promise = pendingRequests[id], responseJson = xhrOrXdr.responseText, successIndicator = {
	                success: true
	            }, failureIndicator = {
	                success: false
	            }, parsedResponse;
	            delete pendingRequests[id];
	            options.log(qq.format("Received the following response body to an upload success request for id {}: {}", id, responseJson));
	            try {
	                parsedResponse = qq.parseJson(responseJson);
	                if (isError || parsedResponse && (parsedResponse.error || parsedResponse.success === false)) {
	                    options.log("Upload success request was rejected by the server.", "error");
	                    promise.failure(qq.extend(parsedResponse, failureIndicator));
	                } else {
	                    options.log("Upload success was acknowledged by the server.");
	                    promise.success(qq.extend(parsedResponse, successIndicator));
	                }
	            } catch (error) {
	                if (isError) {
	                    options.log(qq.format("Your server indicated failure in its upload success request response for id {}!", id), "error");
	                    promise.failure(failureIndicator);
	                } else {
	                    options.log("Upload success was acknowledged by the server.");
	                    promise.success(successIndicator);
	                }
	            }
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            acceptHeader: "application/json",
	            method: options.method,
	            endpointStore: {
	                get: function() {
	                    return options.endpoint;
	                }
	            },
	            paramsStore: options.paramsStore,
	            maxConnections: options.maxConnections,
	            customHeaders: options.customHeaders,
	            log: options.log,
	            onComplete: handleSuccessResponse,
	            cors: options.cors
	        }));
	        qq.extend(this, {
	            sendSuccessRequest: function(id, spec) {
	                var promise = new qq.Promise();
	                options.log("Submitting upload success request/notification for " + id);
	                requester.initTransport(id).withParams(spec).send();
	                pendingRequests[id] = promise;
	                return promise;
	            }
	        });
	    };
	    qq.s3.InitiateMultipartAjaxRequester = function(o) {
	        "use strict";
	        var requester, pendingInitiateRequests = {}, options = {
	            filenameParam: "qqfilename",
	            method: "POST",
	            endpointStore: null,
	            paramsStore: null,
	            signatureSpec: null,
	            aclStore: null,
	            reducedRedundancy: false,
	            serverSideEncryption: false,
	            maxConnections: 3,
	            getContentType: function(id) {},
	            getBucket: function(id) {},
	            getHost: function(id) {},
	            getKey: function(id) {},
	            getName: function(id) {},
	            log: function(str, level) {}
	        }, getSignatureAjaxRequester;
	        qq.extend(options, o);
	        getSignatureAjaxRequester = new qq.s3.RequestSigner({
	            endpointStore: options.endpointStore,
	            signatureSpec: options.signatureSpec,
	            cors: options.cors,
	            log: options.log
	        });
	        function getHeaders(id) {
	            var bucket = options.getBucket(id), host = options.getHost(id), headers = {}, promise = new qq.Promise(), key = options.getKey(id), signatureConstructor;
	            headers["x-amz-acl"] = options.aclStore.get(id);
	            if (options.reducedRedundancy) {
	                headers[qq.s3.util.REDUCED_REDUNDANCY_PARAM_NAME] = qq.s3.util.REDUCED_REDUNDANCY_PARAM_VALUE;
	            }
	            if (options.serverSideEncryption) {
	                headers[qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_NAME] = qq.s3.util.SERVER_SIDE_ENCRYPTION_PARAM_VALUE;
	            }
	            headers[qq.s3.util.AWS_PARAM_PREFIX + options.filenameParam] = encodeURIComponent(options.getName(id));
	            qq.each(options.paramsStore.get(id), function(name, val) {
	                if (qq.indexOf(qq.s3.util.UNPREFIXED_PARAM_NAMES, name) >= 0) {
	                    headers[name] = val;
	                } else {
	                    headers[qq.s3.util.AWS_PARAM_PREFIX + name] = encodeURIComponent(val);
	                }
	            });
	            signatureConstructor = getSignatureAjaxRequester.constructStringToSign(getSignatureAjaxRequester.REQUEST_TYPE.MULTIPART_INITIATE, bucket, host, key).withContentType(options.getContentType(id)).withHeaders(headers);
	            getSignatureAjaxRequester.getSignature(id, {
	                signatureConstructor: signatureConstructor
	            }).then(promise.success, promise.failure);
	            return promise;
	        }
	        function handleInitiateRequestComplete(id, xhr, isError) {
	            var promise = pendingInitiateRequests[id], domParser = new DOMParser(), responseDoc = domParser.parseFromString(xhr.responseText, "application/xml"), uploadIdElements, messageElements, uploadId, errorMessage, status;
	            delete pendingInitiateRequests[id];
	            if (isError) {
	                status = xhr.status;
	                messageElements = responseDoc.getElementsByTagName("Message");
	                if (messageElements.length > 0) {
	                    errorMessage = messageElements[0].textContent;
	                }
	            } else {
	                uploadIdElements = responseDoc.getElementsByTagName("UploadId");
	                if (uploadIdElements.length > 0) {
	                    uploadId = uploadIdElements[0].textContent;
	                } else {
	                    errorMessage = "Upload ID missing from request";
	                }
	            }
	            if (uploadId === undefined) {
	                if (errorMessage) {
	                    options.log(qq.format("Specific problem detected initiating multipart upload request for {}: '{}'.", id, errorMessage), "error");
	                } else {
	                    options.log(qq.format("Unexplained error with initiate multipart upload request for {}.  Status code {}.", id, status), "error");
	                }
	                promise.failure("Problem initiating upload request.", xhr);
	            } else {
	                options.log(qq.format("Initiate multipart upload request successful for {}.  Upload ID is {}", id, uploadId));
	                promise.success(uploadId, xhr);
	            }
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            method: options.method,
	            contentType: null,
	            endpointStore: options.endpointStore,
	            maxConnections: options.maxConnections,
	            allowXRequestedWithAndCacheControl: false,
	            log: options.log,
	            onComplete: handleInitiateRequestComplete,
	            successfulResponseCodes: {
	                POST: [ 200 ]
	            }
	        }));
	        qq.extend(this, {
	            send: function(id) {
	                var promise = new qq.Promise();
	                getHeaders(id).then(function(headers, endOfUrl) {
	                    options.log("Submitting S3 initiate multipart upload request for " + id);
	                    pendingInitiateRequests[id] = promise;
	                    requester.initTransport(id).withPath(endOfUrl).withHeaders(headers).send();
	                }, promise.failure);
	                return promise;
	            }
	        });
	    };
	    qq.s3.CompleteMultipartAjaxRequester = function(o) {
	        "use strict";
	        var requester, pendingCompleteRequests = {}, options = {
	            method: "POST",
	            contentType: "text/xml",
	            endpointStore: null,
	            signatureSpec: null,
	            maxConnections: 3,
	            getBucket: function(id) {},
	            getHost: function(id) {},
	            getKey: function(id) {},
	            log: function(str, level) {}
	        }, getSignatureAjaxRequester;
	        qq.extend(options, o);
	        getSignatureAjaxRequester = new qq.s3.RequestSigner({
	            endpointStore: options.endpointStore,
	            signatureSpec: options.signatureSpec,
	            cors: options.cors,
	            log: options.log
	        });
	        function getHeaders(id, uploadId, body) {
	            var headers = {}, promise = new qq.Promise(), bucket = options.getBucket(id), host = options.getHost(id), signatureConstructor = getSignatureAjaxRequester.constructStringToSign(getSignatureAjaxRequester.REQUEST_TYPE.MULTIPART_COMPLETE, bucket, host, options.getKey(id)).withUploadId(uploadId).withContent(body).withContentType("application/xml; charset=UTF-8");
	            getSignatureAjaxRequester.getSignature(id, {
	                signatureConstructor: signatureConstructor
	            }).then(promise.success, promise.failure);
	            return promise;
	        }
	        function handleCompleteRequestComplete(id, xhr, isError) {
	            var promise = pendingCompleteRequests[id], domParser = new DOMParser(), bucket = options.getBucket(id), key = options.getKey(id), responseDoc = domParser.parseFromString(xhr.responseText, "application/xml"), bucketEls = responseDoc.getElementsByTagName("Bucket"), keyEls = responseDoc.getElementsByTagName("Key");
	            delete pendingCompleteRequests[id];
	            options.log(qq.format("Complete response status {}, body = {}", xhr.status, xhr.responseText));
	            if (isError) {
	                options.log(qq.format("Complete Multipart Upload request for {} failed with status {}.", id, xhr.status), "error");
	            } else {
	                if (bucketEls.length && keyEls.length) {
	                    if (bucketEls[0].textContent !== bucket) {
	                        isError = true;
	                        options.log(qq.format("Wrong bucket in response to Complete Multipart Upload request for {}.", id), "error");
	                    }
	                } else {
	                    isError = true;
	                    options.log(qq.format("Missing bucket and/or key in response to Complete Multipart Upload request for {}.", id), "error");
	                }
	            }
	            if (isError) {
	                promise.failure("Problem combining the file parts!", xhr);
	            } else {
	                promise.success({}, xhr);
	            }
	        }
	        function getCompleteRequestBody(etagEntries) {
	            var doc = document.implementation.createDocument(null, "CompleteMultipartUpload", null);
	            etagEntries.sort(function(a, b) {
	                return a.part - b.part;
	            });
	            qq.each(etagEntries, function(idx, etagEntry) {
	                var part = etagEntry.part, etag = etagEntry.etag, partEl = doc.createElement("Part"), partNumEl = doc.createElement("PartNumber"), partNumTextEl = doc.createTextNode(part), etagTextEl = doc.createTextNode(etag), etagEl = doc.createElement("ETag");
	                etagEl.appendChild(etagTextEl);
	                partNumEl.appendChild(partNumTextEl);
	                partEl.appendChild(partNumEl);
	                partEl.appendChild(etagEl);
	                qq(doc).children()[0].appendChild(partEl);
	            });
	            return new XMLSerializer().serializeToString(doc);
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            method: options.method,
	            contentType: "application/xml; charset=UTF-8",
	            endpointStore: options.endpointStore,
	            maxConnections: options.maxConnections,
	            allowXRequestedWithAndCacheControl: false,
	            log: options.log,
	            onComplete: handleCompleteRequestComplete,
	            successfulResponseCodes: {
	                POST: [ 200 ]
	            }
	        }));
	        qq.extend(this, {
	            send: function(id, uploadId, etagEntries) {
	                var promise = new qq.Promise(), body = getCompleteRequestBody(etagEntries);
	                getHeaders(id, uploadId, body).then(function(headers, endOfUrl) {
	                    options.log("Submitting S3 complete multipart upload request for " + id);
	                    pendingCompleteRequests[id] = promise;
	                    delete headers["Content-Type"];
	                    requester.initTransport(id).withPath(endOfUrl).withHeaders(headers).withPayload(body).send();
	                }, promise.failure);
	                return promise;
	            }
	        });
	    };
	    qq.s3.AbortMultipartAjaxRequester = function(o) {
	        "use strict";
	        var requester, options = {
	            method: "DELETE",
	            endpointStore: null,
	            signatureSpec: null,
	            maxConnections: 3,
	            getBucket: function(id) {},
	            getHost: function(id) {},
	            getKey: function(id) {},
	            log: function(str, level) {}
	        }, getSignatureAjaxRequester;
	        qq.extend(options, o);
	        getSignatureAjaxRequester = new qq.s3.RequestSigner({
	            endpointStore: options.endpointStore,
	            signatureSpec: options.signatureSpec,
	            cors: options.cors,
	            log: options.log
	        });
	        function getHeaders(id, uploadId) {
	            var headers = {}, promise = new qq.Promise(), bucket = options.getBucket(id), host = options.getHost(id), signatureConstructor = getSignatureAjaxRequester.constructStringToSign(getSignatureAjaxRequester.REQUEST_TYPE.MULTIPART_ABORT, bucket, host, options.getKey(id)).withUploadId(uploadId);
	            getSignatureAjaxRequester.getSignature(id, {
	                signatureConstructor: signatureConstructor
	            }).then(promise.success, promise.failure);
	            return promise;
	        }
	        function handleAbortRequestComplete(id, xhr, isError) {
	            var domParser = new DOMParser(), responseDoc = domParser.parseFromString(xhr.responseText, "application/xml"), errorEls = responseDoc.getElementsByTagName("Error"), awsErrorMsg;
	            options.log(qq.format("Abort response status {}, body = {}", xhr.status, xhr.responseText));
	            if (isError) {
	                options.log(qq.format("Abort Multipart Upload request for {} failed with status {}.", id, xhr.status), "error");
	            } else {
	                if (errorEls.length) {
	                    isError = true;
	                    awsErrorMsg = responseDoc.getElementsByTagName("Message")[0].textContent;
	                    options.log(qq.format("Failed to Abort Multipart Upload request for {}.  Error: {}", id, awsErrorMsg), "error");
	                } else {
	                    options.log(qq.format("Abort MPU request succeeded for file ID {}.", id));
	                }
	            }
	        }
	        requester = qq.extend(this, new qq.AjaxRequester({
	            validMethods: [ "DELETE" ],
	            method: options.method,
	            contentType: null,
	            endpointStore: options.endpointStore,
	            maxConnections: options.maxConnections,
	            allowXRequestedWithAndCacheControl: false,
	            log: options.log,
	            onComplete: handleAbortRequestComplete,
	            successfulResponseCodes: {
	                DELETE: [ 204 ]
	            }
	        }));
	        qq.extend(this, {
	            send: function(id, uploadId) {
	                getHeaders(id, uploadId).then(function(headers, endOfUrl) {
	                    options.log("Submitting S3 Abort multipart upload request for " + id);
	                    requester.initTransport(id).withPath(endOfUrl).withHeaders(headers).send();
	                });
	            }
	        });
	    };
	    qq.s3.XhrUploadHandler = function(spec, proxy) {
	        "use strict";
	        var getName = proxy.getName, log = proxy.log, clockDrift = spec.clockDrift, expectedStatus = 200, onGetBucket = spec.getBucket, onGetHost = spec.getHost, onGetKeyName = spec.getKeyName, filenameParam = spec.filenameParam, paramsStore = spec.paramsStore, endpointStore = spec.endpointStore, aclStore = spec.aclStore, reducedRedundancy = spec.objectProperties.reducedRedundancy, region = spec.objectProperties.region, serverSideEncryption = spec.objectProperties.serverSideEncryption, validation = spec.validation, signature = qq.extend({
	            region: region,
	            drift: clockDrift
	        }, spec.signature), handler = this, credentialsProvider = spec.signature.credentialsProvider, chunked = {
	            combine: function(id) {
	                var uploadId = handler._getPersistableData(id).uploadId, etagMap = handler._getPersistableData(id).etags, result = new qq.Promise();
	                requesters.completeMultipart.send(id, uploadId, etagMap).then(result.success, function failure(reason, xhr) {
	                    result.failure(upload.done(id, xhr).response, xhr);
	                });
	                return result;
	            },
	            done: function(id, xhr, chunkIdx) {
	                var response = upload.response.parse(id, xhr), etag;
	                if (response.success) {
	                    etag = xhr.getResponseHeader("ETag");
	                    if (!handler._getPersistableData(id).etags) {
	                        handler._getPersistableData(id).etags = [];
	                    }
	                    handler._getPersistableData(id).etags.push({
	                        part: chunkIdx + 1,
	                        etag: etag
	                    });
	                }
	            },
	            initHeaders: function(id, chunkIdx, blob) {
	                var headers = {}, bucket = upload.bucket.getName(id), host = upload.host.getName(id), key = upload.key.urlSafe(id), promise = new qq.Promise(), signatureConstructor = requesters.restSignature.constructStringToSign(requesters.restSignature.REQUEST_TYPE.MULTIPART_UPLOAD, bucket, host, key).withPartNum(chunkIdx + 1).withContent(blob).withUploadId(handler._getPersistableData(id).uploadId);
	                requesters.restSignature.getSignature(id + "." + chunkIdx, {
	                    signatureConstructor: signatureConstructor
	                }).then(promise.success, promise.failure);
	                return promise;
	            },
	            put: function(id, chunkIdx) {
	                var xhr = handler._createXhr(id, chunkIdx), chunkData = handler._getChunkData(id, chunkIdx), domain = spec.endpointStore.get(id), promise = new qq.Promise();
	                chunked.initHeaders(id, chunkIdx, chunkData.blob).then(function(headers, endOfUrl) {
	                    if (xhr._cancelled) {
	                        log(qq.format("Upload of item {}.{} cancelled. Upload will not start after successful signature request.", id, chunkIdx));
	                        promise.failure({
	                            error: "Chunk upload cancelled"
	                        });
	                    } else {
	                        var url = domain + "/" + endOfUrl;
	                        handler._registerProgressHandler(id, chunkIdx, chunkData.size);
	                        upload.track(id, xhr, chunkIdx).then(promise.success, promise.failure);
	                        xhr.open("PUT", url, true);
	                        var hasContentType = false;
	                        qq.each(headers, function(name, val) {
	                            if (name === "Content-Type") {
	                                hasContentType = true;
	                            }
	                            xhr.setRequestHeader(name, val);
	                        });
	                        if (!hasContentType) {
	                            xhr.setRequestHeader("Content-Type", "");
	                        }
	                        xhr.send(chunkData.blob);
	                    }
	                }, function() {
	                    promise.failure({
	                        error: "Problem signing the chunk!"
	                    }, xhr);
	                });
	                return promise;
	            },
	            send: function(id, chunkIdx) {
	                var promise = new qq.Promise();
	                chunked.setup(id).then(function() {
	                    chunked.put(id, chunkIdx).then(promise.success, promise.failure);
	                }, function(errorMessage, xhr) {
	                    promise.failure({
	                        error: errorMessage
	                    }, xhr);
	                });
	                return promise;
	            },
	            setup: function(id) {
	                var promise = new qq.Promise(), uploadId = handler._getPersistableData(id).uploadId, uploadIdPromise = new qq.Promise();
	                if (!uploadId) {
	                    handler._getPersistableData(id).uploadId = uploadIdPromise;
	                    requesters.initiateMultipart.send(id).then(function(uploadId) {
	                        handler._getPersistableData(id).uploadId = uploadId;
	                        uploadIdPromise.success(uploadId);
	                        promise.success(uploadId);
	                    }, function(errorMsg, xhr) {
	                        handler._getPersistableData(id).uploadId = null;
	                        promise.failure(errorMsg, xhr);
	                        uploadIdPromise.failure(errorMsg, xhr);
	                    });
	                } else if (uploadId instanceof qq.Promise) {
	                    uploadId.then(function(uploadId) {
	                        promise.success(uploadId);
	                    });
	                } else {
	                    promise.success(uploadId);
	                }
	                return promise;
	            }
	        }, requesters = {
	            abortMultipart: new qq.s3.AbortMultipartAjaxRequester({
	                endpointStore: endpointStore,
	                signatureSpec: signature,
	                cors: spec.cors,
	                log: log,
	                getBucket: function(id) {
	                    return upload.bucket.getName(id);
	                },
	                getHost: function(id) {
	                    return upload.host.getName(id);
	                },
	                getKey: function(id) {
	                    return upload.key.urlSafe(id);
	                }
	            }),
	            completeMultipart: new qq.s3.CompleteMultipartAjaxRequester({
	                endpointStore: endpointStore,
	                signatureSpec: signature,
	                cors: spec.cors,
	                log: log,
	                getBucket: function(id) {
	                    return upload.bucket.getName(id);
	                },
	                getHost: function(id) {
	                    return upload.host.getName(id);
	                },
	                getKey: function(id) {
	                    return upload.key.urlSafe(id);
	                }
	            }),
	            initiateMultipart: new qq.s3.InitiateMultipartAjaxRequester({
	                filenameParam: filenameParam,
	                endpointStore: endpointStore,
	                paramsStore: paramsStore,
	                signatureSpec: signature,
	                aclStore: aclStore,
	                reducedRedundancy: reducedRedundancy,
	                serverSideEncryption: serverSideEncryption,
	                cors: spec.cors,
	                log: log,
	                getContentType: function(id) {
	                    return handler._getMimeType(id);
	                },
	                getBucket: function(id) {
	                    return upload.bucket.getName(id);
	                },
	                getHost: function(id) {
	                    return upload.host.getName(id);
	                },
	                getKey: function(id) {
	                    return upload.key.urlSafe(id);
	                },
	                getName: function(id) {
	                    return getName(id);
	                }
	            }),
	            policySignature: new qq.s3.RequestSigner({
	                expectingPolicy: true,
	                signatureSpec: signature,
	                cors: spec.cors,
	                log: log
	            }),
	            restSignature: new qq.s3.RequestSigner({
	                endpointStore: endpointStore,
	                signatureSpec: signature,
	                cors: spec.cors,
	                log: log
	            })
	        }, simple = {
	            initParams: function(id) {
	                var customParams = paramsStore.get(id);
	                customParams[filenameParam] = getName(id);
	                return qq.s3.util.generateAwsParams({
	                    endpoint: endpointStore.get(id),
	                    clockDrift: clockDrift,
	                    params: customParams,
	                    type: handler._getMimeType(id),
	                    bucket: upload.bucket.getName(id),
	                    key: handler.getThirdPartyFileId(id),
	                    accessKey: credentialsProvider.get().accessKey,
	                    sessionToken: credentialsProvider.get().sessionToken,
	                    acl: aclStore.get(id),
	                    expectedStatus: expectedStatus,
	                    minFileSize: validation.minSizeLimit,
	                    maxFileSize: validation.maxSizeLimit,
	                    reducedRedundancy: reducedRedundancy,
	                    region: region,
	                    serverSideEncryption: serverSideEncryption,
	                    signatureVersion: signature.version,
	                    log: log
	                }, qq.bind(requesters.policySignature.getSignature, this, id));
	            },
	            send: function(id) {
	                var promise = new qq.Promise(), xhr = handler._createXhr(id), fileOrBlob = handler.getFile(id);
	                handler._registerProgressHandler(id);
	                upload.track(id, xhr).then(promise.success, promise.failure);
	                simple.setup(id, xhr, fileOrBlob).then(function(toSend) {
	                    log("Sending upload request for " + id);
	                    xhr.send(toSend);
	                }, promise.failure);
	                return promise;
	            },
	            setup: function(id, xhr, fileOrBlob) {
	                var formData = new FormData(), endpoint = endpointStore.get(id), url = endpoint, promise = new qq.Promise();
	                simple.initParams(id).then(function(awsParams) {
	                    xhr.open("POST", url, true);
	                    qq.obj2FormData(awsParams, formData);
	                    formData.append("file", fileOrBlob);
	                    promise.success(formData);
	                }, function(errorMessage) {
	                    promise.failure({
	                        error: errorMessage
	                    });
	                });
	                return promise;
	            }
	        }, upload = {
	            bucket: {
	                promise: function(id) {
	                    var promise = new qq.Promise(), cachedBucket = handler._getFileState(id).bucket;
	                    if (cachedBucket) {
	                        promise.success(cachedBucket);
	                    } else {
	                        onGetBucket(id).then(function(bucket) {
	                            handler._getFileState(id).bucket = bucket;
	                            promise.success(bucket);
	                        }, promise.failure);
	                    }
	                    return promise;
	                },
	                getName: function(id) {
	                    return handler._getFileState(id).bucket;
	                }
	            },
	            host: {
	                promise: function(id) {
	                    var promise = new qq.Promise(), cachedHost = handler._getFileState(id).host;
	                    if (cachedHost) {
	                        promise.success(cachedHost);
	                    } else {
	                        onGetHost(id).then(function(host) {
	                            handler._getFileState(id).host = host;
	                            promise.success(host);
	                        }, promise.failure);
	                    }
	                    return promise;
	                },
	                getName: function(id) {
	                    return handler._getFileState(id).host;
	                }
	            },
	            done: function(id, xhr) {
	                var response = upload.response.parse(id, xhr), isError = response.success !== true;
	                if (isError && upload.response.shouldReset(response.code)) {
	                    log("This is an unrecoverable error, we must restart the upload entirely on the next retry attempt.", "error");
	                    response.reset = true;
	                }
	                return {
	                    success: !isError,
	                    response: response
	                };
	            },
	            key: {
	                promise: function(id) {
	                    var promise = new qq.Promise(), key = handler.getThirdPartyFileId(id);
	                    if (key == null) {
	                        handler._setThirdPartyFileId(id, promise);
	                        onGetKeyName(id, getName(id)).then(function(keyName) {
	                            handler._setThirdPartyFileId(id, keyName);
	                            promise.success(keyName);
	                        }, function(errorReason) {
	                            handler._setThirdPartyFileId(id, null);
	                            promise.failure(errorReason);
	                        });
	                    } else if (qq.isGenericPromise(key)) {
	                        key.then(promise.success, promise.failure);
	                    } else {
	                        promise.success(key);
	                    }
	                    return promise;
	                },
	                urlSafe: function(id) {
	                    var encodedKey = handler.getThirdPartyFileId(id);
	                    return qq.s3.util.uriEscapePath(encodedKey);
	                }
	            },
	            response: {
	                parse: function(id, xhr) {
	                    var response = {}, parsedErrorProps;
	                    try {
	                        log(qq.format("Received response status {} with body: {}", xhr.status, xhr.responseText));
	                        if (xhr.status === expectedStatus) {
	                            response.success = true;
	                        } else {
	                            parsedErrorProps = upload.response.parseError(xhr.responseText);
	                            if (parsedErrorProps) {
	                                response.error = parsedErrorProps.message;
	                                response.code = parsedErrorProps.code;
	                            }
	                        }
	                    } catch (error) {
	                        log("Error when attempting to parse xhr response text (" + error.message + ")", "error");
	                    }
	                    return response;
	                },
	                parseError: function(awsResponseXml) {
	                    var parser = new DOMParser(), parsedDoc = parser.parseFromString(awsResponseXml, "application/xml"), errorEls = parsedDoc.getElementsByTagName("Error"), errorDetails = {}, codeEls, messageEls;
	                    if (errorEls.length) {
	                        codeEls = parsedDoc.getElementsByTagName("Code");
	                        messageEls = parsedDoc.getElementsByTagName("Message");
	                        if (messageEls.length) {
	                            errorDetails.message = messageEls[0].textContent;
	                        }
	                        if (codeEls.length) {
	                            errorDetails.code = codeEls[0].textContent;
	                        }
	                        return errorDetails;
	                    }
	                },
	                shouldReset: function(errorCode) {
	                    return errorCode === "EntityTooSmall" || errorCode === "InvalidPart" || errorCode === "InvalidPartOrder" || errorCode === "NoSuchUpload";
	                }
	            },
	            start: function(id, optChunkIdx) {
	                var promise = new qq.Promise();
	                upload.key.promise(id).then(function() {
	                    upload.bucket.promise(id).then(function() {
	                        upload.host.promise(id).then(function() {
	                            if (optChunkIdx == null) {
	                                simple.send(id).then(promise.success, promise.failure);
	                            } else {
	                                chunked.send(id, optChunkIdx).then(promise.success, promise.failure);
	                            }
	                        });
	                    });
	                }, function(errorReason) {
	                    promise.failure({
	                        error: errorReason
	                    });
	                });
	                return promise;
	            },
	            track: function(id, xhr, optChunkIdx) {
	                var promise = new qq.Promise();
	                xhr.onreadystatechange = function() {
	                    if (xhr.readyState === 4) {
	                        var result;
	                        if (optChunkIdx == null) {
	                            result = upload.done(id, xhr);
	                            promise[result.success ? "success" : "failure"](result.response, xhr);
	                        } else {
	                            chunked.done(id, xhr, optChunkIdx);
	                            result = upload.done(id, xhr);
	                            promise[result.success ? "success" : "failure"](result.response, xhr);
	                        }
	                    }
	                };
	                return promise;
	            }
	        };
	        qq.extend(this, {
	            uploadChunk: upload.start,
	            uploadFile: upload.start
	        });
	        qq.extend(this, new qq.XhrUploadHandler({
	            options: qq.extend({
	                namespace: "s3"
	            }, spec),
	            proxy: qq.extend({
	                getEndpoint: spec.endpointStore.get
	            }, proxy)
	        }));
	        qq.override(this, function(super_) {
	            return {
	                expunge: function(id) {
	                    var uploadId = handler._getPersistableData(id) && handler._getPersistableData(id).uploadId, existedInLocalStorage = handler._maybeDeletePersistedChunkData(id);
	                    if (uploadId !== undefined && existedInLocalStorage) {
	                        requesters.abortMultipart.send(id, uploadId);
	                    }
	                    super_.expunge(id);
	                },
	                finalizeChunks: function(id) {
	                    return chunked.combine(id);
	                },
	                _getLocalStorageId: function(id) {
	                    var baseStorageId = super_._getLocalStorageId(id), bucketName = upload.bucket.getName(id);
	                    return baseStorageId + "-" + bucketName;
	                }
	            };
	        });
	    };
	    qq.s3.FormUploadHandler = function(options, proxy) {
	        "use strict";
	        var handler = this, clockDrift = options.clockDrift, onUuidChanged = proxy.onUuidChanged, getName = proxy.getName, getUuid = proxy.getUuid, log = proxy.log, onGetBucket = options.getBucket, onGetKeyName = options.getKeyName, filenameParam = options.filenameParam, paramsStore = options.paramsStore, endpointStore = options.endpointStore, aclStore = options.aclStore, reducedRedundancy = options.objectProperties.reducedRedundancy, region = options.objectProperties.region, serverSideEncryption = options.objectProperties.serverSideEncryption, validation = options.validation, signature = options.signature, successRedirectUrl = options.iframeSupport.localBlankPagePath, credentialsProvider = options.signature.credentialsProvider, getSignatureAjaxRequester = new qq.s3.RequestSigner({
	            signatureSpec: signature,
	            cors: options.cors,
	            log: log
	        });
	        if (successRedirectUrl === undefined) {
	            throw new Error("successRedirectEndpoint MUST be defined if you intend to use browsers that do not support the File API!");
	        }
	        function isValidResponse(id, iframe) {
	            var response, endpoint = options.endpointStore.get(id), bucket = handler._getFileState(id).bucket, doc, innerHtml, responseData;
	            try {
	                doc = iframe.contentDocument || iframe.contentWindow.document;
	                innerHtml = doc.body.innerHTML;
	                responseData = qq.s3.util.parseIframeResponse(iframe);
	                if (responseData.bucket === bucket && responseData.key === qq.s3.util.encodeQueryStringParam(handler.getThirdPartyFileId(id))) {
	                    return true;
	                }
	                log("Response from AWS included an unexpected bucket or key name.", "error");
	            } catch (error) {
	                log("Error when attempting to parse form upload response (" + error.message + ")", "error");
	            }
	            return false;
	        }
	        function generateAwsParams(id) {
	            var customParams = paramsStore.get(id);
	            customParams[filenameParam] = getName(id);
	            return qq.s3.util.generateAwsParams({
	                endpoint: endpointStore.get(id),
	                clockDrift: clockDrift,
	                params: customParams,
	                bucket: handler._getFileState(id).bucket,
	                key: handler.getThirdPartyFileId(id),
	                accessKey: credentialsProvider.get().accessKey,
	                sessionToken: credentialsProvider.get().sessionToken,
	                acl: aclStore.get(id),
	                minFileSize: validation.minSizeLimit,
	                maxFileSize: validation.maxSizeLimit,
	                successRedirectUrl: successRedirectUrl,
	                reducedRedundancy: reducedRedundancy,
	                region: region,
	                serverSideEncryption: serverSideEncryption,
	                signatureVersion: signature.version,
	                log: log
	            }, qq.bind(getSignatureAjaxRequester.getSignature, this, id));
	        }
	        function createForm(id, iframe) {
	            var promise = new qq.Promise(), method = "POST", endpoint = options.endpointStore.get(id), fileName = getName(id);
	            generateAwsParams(id).then(function(params) {
	                var form = handler._initFormForUpload({
	                    method: method,
	                    endpoint: endpoint,
	                    params: params,
	                    paramsInBody: true,
	                    targetName: iframe.name
	                });
	                promise.success(form);
	            }, function(errorMessage) {
	                promise.failure(errorMessage);
	                handleFinishedUpload(id, iframe, fileName, {
	                    error: errorMessage
	                });
	            });
	            return promise;
	        }
	        function handleUpload(id) {
	            var iframe = handler._createIframe(id), input = handler.getInput(id), promise = new qq.Promise();
	            createForm(id, iframe).then(function(form) {
	                form.appendChild(input);
	                handler._attachLoadEvent(iframe, function(response) {
	                    log("iframe loaded");
	                    if (response) {
	                        if (response.success === false) {
	                            log("Amazon likely rejected the upload request", "error");
	                            promise.failure(response);
	                        }
	                    } else {
	                        response = {};
	                        response.success = isValidResponse(id, iframe);
	                        if (response.success === false) {
	                            log("A success response was received by Amazon, but it was invalid in some way.", "error");
	                            promise.failure(response);
	                        } else {
	                            qq.extend(response, qq.s3.util.parseIframeResponse(iframe));
	                            promise.success(response);
	                        }
	                    }
	                    handleFinishedUpload(id, iframe);
	                });
	                log("Sending upload request for " + id);
	                form.submit();
	                qq(form).remove();
	            }, promise.failure);
	            return promise;
	        }
	        function handleFinishedUpload(id, iframe) {
	            handler._detachLoadEvent(id);
	            iframe && qq(iframe).remove();
	        }
	        qq.extend(this, new qq.FormUploadHandler({
	            options: {
	                isCors: false,
	                inputName: "file"
	            },
	            proxy: {
	                onCancel: options.onCancel,
	                onUuidChanged: onUuidChanged,
	                getName: getName,
	                getUuid: getUuid,
	                log: log
	            }
	        }));
	        qq.extend(this, {
	            uploadFile: function(id) {
	                var name = getName(id), promise = new qq.Promise();
	                if (handler.getThirdPartyFileId(id)) {
	                    if (handler._getFileState(id).bucket) {
	                        handleUpload(id).then(promise.success, promise.failure);
	                    } else {
	                        onGetBucket(id).then(function(bucket) {
	                            handler._getFileState(id).bucket = bucket;
	                            handleUpload(id).then(promise.success, promise.failure);
	                        });
	                    }
	                } else {
	                    onGetKeyName(id, name).then(function(key) {
	                        onGetBucket(id).then(function(bucket) {
	                            handler._getFileState(id).bucket = bucket;
	                            handler._setThirdPartyFileId(id, key);
	                            handleUpload(id).then(promise.success, promise.failure);
	                        }, function(errorReason) {
	                            promise.failure({
	                                error: errorReason
	                            });
	                        });
	                    }, function(errorReason) {
	                        promise.failure({
	                            error: errorReason
	                        });
	                    });
	                }
	                return promise;
	            }
	        });
	    };
	})(window);
	//# sourceMappingURL=s3.fine-uploader.core.js.map

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(940);
	module.exports = self.fetch.bind(self);


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(296),
	    getRawTag = __webpack_require__(672),
	    objectToString = __webpack_require__(673);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 670 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(674);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(296);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 673 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 674 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(670);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 676 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(66);
	var invariant = __webpack_require__(19);
	var ReactPropTypesSecret = __webpack_require__(299);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(66);
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(29);
	var assign = __webpack_require__(680);
	
	var ReactPropTypesSecret = __webpack_require__(299);
	var checkPropTypes = __webpack_require__(677);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 680 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 681 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(46);
	
	var focusNode = __webpack_require__(292);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(134);
	var ExecutionEnvironment = __webpack_require__(57);
	var FallbackCompositionState = __webpack_require__(689);
	var SyntheticCompositionEvent = __webpack_require__(726);
	var SyntheticInputEvent = __webpack_require__(729);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(302);
	var ExecutionEnvironment = __webpack_require__(57);
	var ReactInstrumentation = __webpack_require__(72);
	
	var camelizeStyleName = __webpack_require__(653);
	var dangerousStyleValue = __webpack_require__(735);
	var hyphenateStyleName = __webpack_require__(660);
	var memoizeStringOnly = __webpack_require__(663);
	var warning = __webpack_require__(29);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(133);
	var EventPropagators = __webpack_require__(134);
	var ExecutionEnvironment = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(79);
	var SyntheticEvent = __webpack_require__(84);
	
	var inputValueTracking = __webpack_require__(318);
	var getEventTarget = __webpack_require__(223);
	var isEventSupported = __webpack_require__(224);
	var isTextInputElement = __webpack_require__(320);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var DOMLazyTree = __webpack_require__(117);
	var ExecutionEnvironment = __webpack_require__(57);
	
	var createNodesFromMarkup = __webpack_require__(656);
	var emptyFunction = __webpack_require__(66);
	var invariant = __webpack_require__(19);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 687 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(134);
	var ReactDOMComponentTree = __webpack_require__(46);
	var SyntheticMouseEvent = __webpack_require__(163);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(49);
	
	var PooledClass = __webpack_require__(106);
	
	var getTextContentAccessor = __webpack_require__(317);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(118);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(119);
	
	var instantiateReactComponent = __webpack_require__(319);
	var KeyEscapeUtils = __webpack_require__(215);
	var shouldUpdateReactComponent = __webpack_require__(225);
	var traverseAllChildren = __webpack_require__(322);
	var warning = __webpack_require__(29);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(393);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(211);
	var ReactDOMIDOperations = __webpack_require__(699);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(49);
	
	var React = __webpack_require__(128);
	var ReactComponentEnvironment = __webpack_require__(217);
	var ReactCurrentOwner = __webpack_require__(86);
	var ReactErrorUtils = __webpack_require__(218);
	var ReactInstanceMap = __webpack_require__(135);
	var ReactInstrumentation = __webpack_require__(72);
	var ReactNodeTypes = __webpack_require__(312);
	var ReactReconciler = __webpack_require__(119);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(160);
	var invariant = __webpack_require__(19);
	var shallowEqual = __webpack_require__(208);
	var shouldUpdateReactComponent = __webpack_require__(225);
	var warning = __webpack_require__(29);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactDefaultInjection = __webpack_require__(707);
	var ReactMount = __webpack_require__(311);
	var ReactReconciler = __webpack_require__(119);
	var ReactUpdates = __webpack_require__(79);
	var ReactVersion = __webpack_require__(720);
	
	var findDOMNode = __webpack_require__(736);
	var getHostComponentFromComposite = __webpack_require__(316);
	var renderSubtreeIntoContainer = __webpack_require__(743);
	var warning = __webpack_require__(29);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(49);
	
	var AutoFocusUtils = __webpack_require__(682);
	var CSSPropertyOperations = __webpack_require__(684);
	var DOMLazyTree = __webpack_require__(117);
	var DOMNamespaces = __webpack_require__(212);
	var DOMProperty = __webpack_require__(118);
	var DOMPropertyOperations = __webpack_require__(304);
	var EventPluginHub = __webpack_require__(133);
	var EventPluginRegistry = __webpack_require__(213);
	var ReactBrowserEventEmitter = __webpack_require__(162);
	var ReactDOMComponentFlags = __webpack_require__(305);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactDOMInput = __webpack_require__(700);
	var ReactDOMOption = __webpack_require__(701);
	var ReactDOMSelect = __webpack_require__(306);
	var ReactDOMTextarea = __webpack_require__(704);
	var ReactInstrumentation = __webpack_require__(72);
	var ReactMultiChild = __webpack_require__(713);
	var ReactServerRenderingTransaction = __webpack_require__(718);
	
	var emptyFunction = __webpack_require__(66);
	var escapeTextContentForBrowser = __webpack_require__(165);
	var invariant = __webpack_require__(19);
	var isEventSupported = __webpack_require__(224);
	var shallowEqual = __webpack_require__(208);
	var inputValueTracking = __webpack_require__(318);
	var validateDOMNesting = __webpack_require__(226);
	var warning = __webpack_require__(29);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(226);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(49);
	
	var DOMLazyTree = __webpack_require__(117);
	var ReactDOMComponentTree = __webpack_require__(46);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 698 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(211);
	var ReactDOMComponentTree = __webpack_require__(46);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(49);
	
	var DOMPropertyOperations = __webpack_require__(304);
	var LinkedValueUtils = __webpack_require__(216);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(79);
	
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(29);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(49);
	
	var React = __webpack_require__(128);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactDOMSelect = __webpack_require__(306);
	
	var warning = __webpack_require__(29);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	var getNodeForCharacterOffset = __webpack_require__(740);
	var getTextContentAccessor = __webpack_require__(317);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(49);
	
	var DOMChildrenOperations = __webpack_require__(211);
	var DOMLazyTree = __webpack_require__(117);
	var ReactDOMComponentTree = __webpack_require__(46);
	
	var escapeTextContentForBrowser = __webpack_require__(165);
	var invariant = __webpack_require__(19);
	var validateDOMNesting = __webpack_require__(226);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30),
	    _assign = __webpack_require__(49);
	
	var LinkedValueUtils = __webpack_require__(216);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(79);
	
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(29);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(49);
	
	var ReactUpdates = __webpack_require__(79);
	var Transaction = __webpack_require__(164);
	
	var emptyFunction = __webpack_require__(66);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(681);
	var BeforeInputEventPlugin = __webpack_require__(683);
	var ChangeEventPlugin = __webpack_require__(685);
	var DefaultEventPluginOrder = __webpack_require__(687);
	var EnterLeaveEventPlugin = __webpack_require__(688);
	var HTMLDOMPropertyConfig = __webpack_require__(690);
	var ReactComponentBrowserEnvironment = __webpack_require__(692);
	var ReactDOMComponent = __webpack_require__(695);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactDOMEmptyComponent = __webpack_require__(697);
	var ReactDOMTreeTraversal = __webpack_require__(705);
	var ReactDOMTextComponent = __webpack_require__(703);
	var ReactDefaultBatchingStrategy = __webpack_require__(706);
	var ReactEventListener = __webpack_require__(710);
	var ReactInjection = __webpack_require__(711);
	var ReactReconcileTransaction = __webpack_require__(716);
	var SVGDOMPropertyConfig = __webpack_require__(721);
	var SelectEventPlugin = __webpack_require__(722);
	var SimpleEventPlugin = __webpack_require__(723);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 708 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(133);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(49);
	
	var EventListener = __webpack_require__(291);
	var ExecutionEnvironment = __webpack_require__(57);
	var PooledClass = __webpack_require__(106);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(79);
	
	var getEventTarget = __webpack_require__(223);
	var getUnboundedScrollPosition = __webpack_require__(658);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(118);
	var EventPluginHub = __webpack_require__(133);
	var EventPluginUtils = __webpack_require__(214);
	var ReactComponentEnvironment = __webpack_require__(217);
	var ReactEmptyComponent = __webpack_require__(307);
	var ReactBrowserEventEmitter = __webpack_require__(162);
	var ReactHostComponent = __webpack_require__(309);
	var ReactUpdates = __webpack_require__(79);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(734);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactComponentEnvironment = __webpack_require__(217);
	var ReactInstanceMap = __webpack_require__(135);
	var ReactInstrumentation = __webpack_require__(72);
	
	var ReactCurrentOwner = __webpack_require__(86);
	var ReactReconciler = __webpack_require__(119);
	var ReactChildReconciler = __webpack_require__(691);
	
	var emptyFunction = __webpack_require__(66);
	var flattenChildren = __webpack_require__(737);
	var invariant = __webpack_require__(19);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 715 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(49);
	
	var CallbackQueue = __webpack_require__(303);
	var PooledClass = __webpack_require__(106);
	var ReactBrowserEventEmitter = __webpack_require__(162);
	var ReactInputSelection = __webpack_require__(310);
	var ReactInstrumentation = __webpack_require__(72);
	var Transaction = __webpack_require__(164);
	var ReactUpdateQueue = __webpack_require__(219);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(714);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(49);
	
	var PooledClass = __webpack_require__(106);
	var Transaction = __webpack_require__(164);
	var ReactInstrumentation = __webpack_require__(72);
	var ReactServerUpdateQueue = __webpack_require__(719);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(219);
	
	var warning = __webpack_require__(29);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 720 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 721 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(134);
	var ExecutionEnvironment = __webpack_require__(57);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactInputSelection = __webpack_require__(310);
	var SyntheticEvent = __webpack_require__(84);
	
	var getActiveElement = __webpack_require__(293);
	var isTextInputElement = __webpack_require__(320);
	var shallowEqual = __webpack_require__(208);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var EventListener = __webpack_require__(291);
	var EventPropagators = __webpack_require__(134);
	var ReactDOMComponentTree = __webpack_require__(46);
	var SyntheticAnimationEvent = __webpack_require__(724);
	var SyntheticClipboardEvent = __webpack_require__(725);
	var SyntheticEvent = __webpack_require__(84);
	var SyntheticFocusEvent = __webpack_require__(728);
	var SyntheticKeyboardEvent = __webpack_require__(730);
	var SyntheticMouseEvent = __webpack_require__(163);
	var SyntheticDragEvent = __webpack_require__(727);
	var SyntheticTouchEvent = __webpack_require__(731);
	var SyntheticTransitionEvent = __webpack_require__(732);
	var SyntheticUIEvent = __webpack_require__(136);
	var SyntheticWheelEvent = __webpack_require__(733);
	
	var emptyFunction = __webpack_require__(66);
	var getEventCharCode = __webpack_require__(221);
	var invariant = __webpack_require__(19);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(84);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(84);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(84);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(163);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(136);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(84);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(136);
	
	var getEventCharCode = __webpack_require__(221);
	var getEventKey = __webpack_require__(738);
	var getEventModifierState = __webpack_require__(222);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(136);
	
	var getEventModifierState = __webpack_require__(222);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(84);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(163);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 734 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(302);
	var warning = __webpack_require__(29);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(30);
	
	var ReactCurrentOwner = __webpack_require__(86);
	var ReactDOMComponentTree = __webpack_require__(46);
	var ReactInstanceMap = __webpack_require__(135);
	
	var getHostComponentFromComposite = __webpack_require__(316);
	var invariant = __webpack_require__(19);
	var warning = __webpack_require__(29);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(215);
	var traverseAllChildren = __webpack_require__(322);
	var warning = __webpack_require__(29);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(393);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(221);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 739 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 740 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(57);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(165);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(311);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.default = {
	   data: "{  \n   \"title\":\"AudioEditor111111\",\n   \"slides\":[  \n      {  \n         \"content\":[  \n            {  \n               \"type\":\"Background\",\n               \"hotSpot\":\"\",\n               \"logicalName\":\"\",\n               \"frameLabel\":\"\",\n               \"xlinkHref\":\"\",\n               \"moods\":[  \n\n               ],\n               \"stroke\":\"#000000\",\n               \"strokeWidth\":1,\n               \"strokeOpacity\":0,\n               \"fill\":\"#ffffff\",\n               \"fillOpacity\":1,\n               \"uuid\":\"9b2b6148-a865-4268-bfe9-753e99b7957d\"\n            }\n         ],\n         \"initialized\":true,\n         \"time\":4,\n         \"uuid\":\"b198b860-6e54-4e5e-b2d4-8ebe2600a617\",\n         \"contentItemId\":-1,\n         \"sound\":\"\",\n         \"soundEffect\":\"\",\n         \"soundVolume\":0.5,\n         \"soundEffectVolume\":0.5\n      }\n   ],\n   \"audioEditor\":{  \n      \"timelines\":[  \n         {  \n            \"index\":0,\n            \"volume\":1,\n            \"audios\":[  \n               {  \n                  \"uuid\":\"1ff05e77-b6f6-42b7-bcdd-955c14e2a329\",\n                  \"title\":\"Bell\",\n                  \"href\":\"https://d3b76ijxom7qfl.cloudfront.net/movieaudioeditor/1837856.mp3\",\n                  \"inPoint\":0,\n                  \"outPoint\":0,\n                  \"left\":6.761904761904762,\n                  \"duration\":8,\n                  \"showControlPoint\":false\n               }\n            ],\n            \"isSelected\":false\n         },\n         {  \n            \"index\":1,\n            \"volume\":1,\n            \"audios\":[  \n               {  \n                  \"title\":\"Car chase\",\n                  \"href\":\"https://d3b76ijxom7qfl.cloudfront.net/movieaudioeditor/16201446.mp3\",\n                  \"uuid\":\"4bcabf7e-4e43-40b6-a8f8-c90804c59664\",\n                  \"left\":0,\n                  \"outPoint\":38.22857142857143,\n                  \"duration\":17.771428571428572,\n                  \"showControlPoint\":false\n               }\n            ],\n            \"isSelected\":false\n         },\n         {  \n            \"index\":2,\n            \"volume\":1,\n            \"audios\":[  \n               {  \n                  \"uuid\":\"f0cf9c67-c929-4335-a966-bcf94e050da8\",\n                  \"title\":\"Closing door\",\n                  \"href\":\"https://d3b76ijxom7qfl.cloudfront.net/movieaudioeditor/3840295.mp3\",\n                  \"inPoint\":0,\n                  \"outPoint\":0,\n                  \"left\":4.3619047619047615,\n                  \"duration\":4,\n                  \"showControlPoint\":false\n               }\n            ],\n            \"isSelected\":false\n         },\n         {  \n            \"index\":3,\n            \"volume\":1,\n            \"audios\":[  \n               {  \n                  \"uuid\":\"7ea33717-521d-4e1f-b1b8-f8ef968820bd\",\n                  \"title\":\"Fog horn\",\n                  \"href\":\"https://d3b76ijxom7qfl.cloudfront.net/movieaudioeditor/3840397.mp3\",\n                  \"inPoint\":0,\n                  \"outPoint\":5.885714285714286,\n                  \"left\":3.1809523809523808,\n                  \"duration\":13.114285714285714,\n                  \"showControlPoint\":false\n               }\n            ],\n            \"isSelected\":false\n         },\n         {  \n            \"index\":4,\n            \"volume\":1,\n            \"audios\":[  \n               {  \n                  \"uuid\":\"81bf198a-c4f9-47ac-9523-4dfce4b5bf30\",\n                  \"title\":\"Siren\",\n                  \"href\":\"https://d3b76ijxom7qfl.cloudfront.net/movieaudioeditor/1837890.mp3\",\n                  \"inPoint\":0,\n                  \"outPoint\":12.342857142857143,\n                  \"left\":1.6571428571428573,\n                  \"duration\":15.657142857142857,\n                  \"showControlPoint\":true\n               }\n            ],\n            \"isSelected\":false\n         },\n         {  \n            \"index\":5,\n            \"volume\":1,\n            \"audios\":[  \n\n            ],\n            \"isSelected\":false\n         }\n      ],\n      \"markerPosition\":17.314285714285713,\n      \"timelineWidth\":1372,\n      \"refreshAudioTrack\":0.014986289186555313,\n      \"trackMenu\":-1,\n      \"zoomValue\":4\n   }\n}"
	};
	module.exports = exports["default"];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/docs/audioProduction.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/docs/audioProduction.js"); } } })();

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.default = {
	   data: "{\n   \"theme\":\"\",\n   \"title\":\"testVideo\",\n   \"slides\":[\n      {\n         \"content\":[\n            {\n               \"type\":\"Background\",\n               \"moods\":[\n                  \n               ],\n               \"stroke\":\"#000000\",\n               \"strokeWidth\":1,\n               \"strokeOpacity\":0,\n               \"fill\":\"#ffffff\",\n               \"fillOpacity\":1,\n               \"opacity\":1,\n               \"uuid\":\"86732c5c-86cb-4e65-85b2-be8d4066ae24\",\n               \"xlinkHref\":\"https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_roma_010.mp4\",\n               \"isVideo\":true,\n               \"volume\":0.5,\n               \"inPoint\":0,\n               \"outPoint\":4.752\n            },\n            {\n               \"type\":\"Video\",\n               \"opacity\":1,\n               \"rotation\":0,\n               \"uuid\":\"47642270-7f94-4b29-a700-aa4b6ef440a3\",\n               \"stroke\":\"#000000\",\n               \"strokeWidth\":1,\n               \"strokeOpacity\":0,\n               \"x\":100,\n               \"y\":100,\n               \"width\":300,\n               \"height\":168.75,\n               \"horizontalFlip\":1,\n               \"verticalFlip\":1,\n               \"xlinkHref\":\"https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_candelora_002.mp4\",\n               \"duration\":12.074667\n            }\n         ],\n         \"initialized\":true,\n         \"time\":4.752,\n         \"uuid\":\"5835b9f3-95e6-4d16-ba2b-aee2c169532c\",\n         \"contentItemId\":-1,\n         \"sound\":\"\",\n         \"soundEffect\":\"\",\n         \"soundVolume\":0.5,\n         \"soundEffectVolume\":0.5\n      },\n      {\n         \"content\":[\n            {\n               \"type\":\"Background\",\n               \"xlinkHref\":\"https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_carneval_003.mp4\",\n               \"moods\":[\n                  \n               ],\n               \"stroke\":\"#000000\",\n               \"strokeWidth\":1,\n               \"strokeOpacity\":0,\n               \"fill\":\"#ffffff\",\n               \"fillOpacity\":1,\n               \"opacity\":1,\n               \"uuid\":\"f3464649-0a89-4128-97db-79335d5a45ec\",\n               \"isVideo\":true,\n               \"volume\":0.5,\n               \"inPoint\":0,\n               \"outPoint\":4.558\n            },\n            {\n               \"type\":\"Video\",\n               \"opacity\":1,\n               \"rotation\":0,\n               \"uuid\":\"5e81adc1-2aa2-466b-bdfb-9314526a197f\",\n               \"stroke\":\"#000000\",\n               \"strokeWidth\":1,\n               \"strokeOpacity\":0,\n               \"x\":100,\n               \"y\":100,\n               \"width\":300,\n               \"height\":168.75,\n               \"horizontalFlip\":1,\n               \"verticalFlip\":1,\n               \"xlinkHref\":\"https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_candelora_001.mp4\",\n               \"duration\":20.074667\n            }\n         ],\n         \"initialized\":true,\n         \"time\":4.558,\n         \"uuid\":\"bcbbd422-36f7-4ce2-8d78-9d8b3b2ac60d\",\n         \"contentItemId\":-1,\n         \"sound\":\"\",\n         \"soundEffect\":\"\",\n         \"soundVolume\":0.5,\n         \"soundEffectVolume\":0.5\n      },\n      {\n         \"content\":[\n            {\n               \"type\":\"Background\",\n               \"xlinkHref\":\"https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_candelora_007.mp4\",\n               \"moods\":[\n                  \n               ],\n               \"stroke\":\"#000000\",\n               \"strokeWidth\":1,\n               \"strokeOpacity\":0,\n               \"fill\":\"#ffffff\",\n               \"fillOpacity\":1,\n               \"opacity\":1,\n               \"uuid\":\"96d3eef0-6758-48a0-8586-80755c2e9f3e\",\n               \"isVideo\":true,\n               \"volume\":0.5,\n               \"inPoint\":0,\n               \"outPoint\":4.266\n            },\n            {\n               \"type\":\"Video\",\n               \"opacity\":1,\n               \"rotation\":0,\n               \"uuid\":\"20f86b3e-fb20-435e-9bff-ab4d6b414686\",\n               \"stroke\":\"#000000\",\n               \"strokeWidth\":1,\n               \"strokeOpacity\":0,\n               \"x\":100,\n               \"y\":100,\n               \"width\":300,\n               \"height\":168.75,\n               \"horizontalFlip\":1,\n               \"verticalFlip\":1,\n               \"xlinkHref\":\"https://d3b76ijxom7qfl.cloudfront.net/cartoonist/video/proxy/places/creaza_italia_catania_001.mp4\",\n               \"duration\":9.066667\n            }\n         ],\n         \"initialized\":true,\n         \"time\":4.266,\n         \"uuid\":\"30fecc9e-fc24-4ebd-97af-2ee96c1333a6\",\n         \"contentItemId\":-1,\n         \"sound\":\"\",\n         \"soundEffect\":\"\",\n         \"soundVolume\":0.5,\n         \"soundEffectVolume\":0.5\n      }\n   ],\n   \"currentFont\":\"Cabin\",\n   \"currentFontSize\":24,\n   \"audioEditor\":{\n      \"zoomValue\":4,\n      \"markerPosition\":0,\n      \"trackMenu\":-1,\n      \"timelines\":[\n         {\n            \"index\":0,\n            \"volume\":1,\n            \"audios\":[\n               \n            ]\n         },\n         {\n            \"index\":1,\n            \"volume\":1,\n            \"audios\":[\n               \n            ]\n         },\n         {\n            \"index\":2,\n            \"volume\":1,\n            \"audios\":[\n               \n            ]\n         }\n      ]\n   }\n}"
	};
	module.exports = exports["default"];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/docs/newProduction.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/docs/newProduction.js"); } } })();

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.default = {
	   data: "[\n   {\n      \"id\":\"b2685d94-5f23-44e5-a51e-53930b74f2e7\",\n      \"logicalname\":\"sustainability_props_coal_\",\n      \"translations\":{\n         \"nb_NO\":\"Kullhaug\",\n         \"nn_NO\":\"Kolhaug\",\n         \"sv_SE\":\"K\xE5lh\xF6g\",\n         \"en_US\":\"Coal heap\",\n         \"da_DK\":\"Kulbjerg\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":244,\n      \"height\":150,\n      \"position\":12,\n      \"updated_at\":\"2021-10-20T14:18:32.355+00:00\"\n   },\n   {\n      \"id\":\"2627a401-1abc-46a6-9607-7156fff61823\",\n      \"logicalname\":\"cartoonist_background_sustainability_beach_01_\",\n      \"translations\":{\n         \"nb_NO\":\"Strand 01\",\n         \"nn_NO\":\"Strand 01\",\n         \"sv_SE\":\"Strand 01\",\n         \"en_US\":\"Beach 01\",\n         \"da_DK\":\"Strand 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":0,\n      \"updated_at\":\"2021-10-20T14:17:54.273+00:00\"\n   },\n   {\n      \"id\":\"7d37dcb2-00ce-481e-addf-d59f536d4470\",\n      \"logicalname\":\"cartoonist_background_sustainability_beach_02_\",\n      \"translations\":{\n         \"nb_NO\":\"Strand 02\",\n         \"nn_NO\":\"Strand 02\",\n         \"sv_SE\":\"Strand 02\",\n         \"en_US\":\"Beach 02\",\n         \"da_DK\":\"Strand 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":1,\n      \"updated_at\":\"2021-10-20T14:17:54.591+00:00\"\n   },\n   {\n      \"id\":\"ba993e7f-25bb-4ad1-b889-c77e1260249e\",\n      \"logicalname\":\"cartoonist_background_sustainability_beach_03_\",\n      \"translations\":{\n         \"nb_NO\":\"Strand 03\",\n         \"nn_NO\":\"Strand 03\",\n         \"sv_SE\":\"Strand 03\",\n         \"en_US\":\"Beach 03\",\n         \"da_DK\":\"Strand 03\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":2,\n      \"updated_at\":\"2021-10-20T14:17:55.004+00:00\"\n   },\n   {\n      \"id\":\"fc048c50-3ebf-4cbd-bd0a-42b721c7f70d\",\n      \"logicalname\":\"cartoonist_background_sustainability_city_01_\",\n      \"translations\":{\n         \"nb_NO\":\"By 01\",\n         \"nn_NO\":\"By 01\",\n         \"sv_SE\":\"Stad 01\",\n         \"en_US\":\"City 01\",\n         \"da_DK\":\"By 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":3,\n      \"updated_at\":\"2021-10-20T14:17:55.401+00:00\"\n   },\n   {\n      \"id\":\"e4cc5af5-e57f-4538-8dc5-dd5e58addc82\",\n      \"logicalname\":\"cartoonist_background_sustainability_city_02_\",\n      \"translations\":{\n         \"nb_NO\":\"By 02\",\n         \"nn_NO\":\"By 02\",\n         \"sv_SE\":\"Stad 02\",\n         \"en_US\":\"City 02\",\n         \"da_DK\":\"By 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":4,\n      \"updated_at\":\"2021-10-20T14:17:55.696+00:00\"\n   },\n   {\n      \"id\":\"9b9cf827-e824-4646-a2a2-884bedaaf88e\",\n      \"logicalname\":\"cartoonist_background_sustainability_coastal_town_01_\",\n      \"translations\":{\n         \"nb_NO\":\"Kystby 01\",\n         \"nn_NO\":\"Kystby 01\",\n         \"sv_SE\":\"Kuststad 01\",\n         \"en_US\":\"Coastal town 01\",\n         \"da_DK\":\"Kystby 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":5,\n      \"updated_at\":\"2021-10-20T14:17:55.979+00:00\"\n   },\n   {\n      \"id\":\"515e5bce-1d81-4564-91e1-168e1239a3c7\",\n      \"logicalname\":\"cartoonist_background_sustainability_coastal_town_02_\",\n      \"translations\":{\n         \"nb_NO\":\"Kystby 02\",\n         \"nn_NO\":\"Kystby 02\",\n         \"sv_SE\":\"Kuststad 02\",\n         \"en_US\":\"Coastal town 02\",\n         \"da_DK\":\"Kystby 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":6,\n      \"updated_at\":\"2021-10-20T14:17:56.415+00:00\"\n   },\n   {\n      \"id\":\"2f25502f-11b8-4b50-ab70-8d281cb110df\",\n      \"logicalname\":\"cartoonist_background_sustainability_coastal_town_03_\",\n      \"translations\":{\n         \"nb_NO\":\"Kystby 03\",\n         \"nn_NO\":\"Kystby 03\",\n         \"sv_SE\":\"Kuststad 03\",\n         \"en_US\":\"Coastal town 03\",\n         \"da_DK\":\"Kystby 03\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":7,\n      \"updated_at\":\"2021-10-20T14:17:56.707+00:00\"\n   },\n   {\n      \"id\":\"2f76ee92-910a-4135-b2f7-3a4632f6ad73\",\n      \"logicalname\":\"cartoonist_background_sustainability_desert-spreading_01_\",\n      \"translations\":{\n         \"nb_NO\":\"\xD8rken 01\",\n         \"nn_NO\":\"\xD8rken 01\",\n         \"sv_SE\":\"\xD6ken 01\",\n         \"en_US\":\"Desert 01\",\n         \"da_DK\":\"\xD8rken 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":8,\n      \"updated_at\":\"2021-10-20T14:17:56.993+00:00\"\n   },\n   {\n      \"id\":\"20140fbd-41ae-4853-84c5-65f551288b78\",\n      \"logicalname\":\"cartoonist_background_sustainability_desert-spreading_02_\",\n      \"translations\":{\n         \"nb_NO\":\"\xD8rken 02\",\n         \"nn_NO\":\"\xD8rken 02\",\n         \"sv_SE\":\"\xD6ken 02\",\n         \"en_US\":\"Desert 02\",\n         \"da_DK\":\"\xD8rken 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":9,\n      \"updated_at\":\"2021-10-20T14:17:57.547+00:00\"\n   },\n   {\n      \"id\":\"dad6609c-8b5d-421b-8d33-763902c4bb92\",\n      \"logicalname\":\"cartoonist_background_sustainability_desert-spreading_03_\",\n      \"translations\":{\n         \"nb_NO\":\"\xD8rken 03\",\n         \"nn_NO\":\"\xD8rken 03\",\n         \"sv_SE\":\"\xD6ken 03\",\n         \"en_US\":\"Desert 03\",\n         \"da_DK\":\"\xD8rken 03\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":10,\n      \"updated_at\":\"2021-10-20T14:17:57.844+00:00\"\n   },\n   {\n      \"id\":\"e6b03709-0c69-4391-8f80-aea70d8da028\",\n      \"logicalname\":\"cartoonist_background_sustainability_forest_01_\",\n      \"translations\":{\n         \"nb_NO\":\"Skog 01\",\n         \"nn_NO\":\"Skog 01\",\n         \"sv_SE\":\"Skog 01\",\n         \"en_US\":\"Forest 01\",\n         \"da_DK\":\"Skov 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":11,\n      \"updated_at\":\"2021-10-20T14:17:58.225+00:00\"\n   },\n   {\n      \"id\":\"02dcbd7f-be02-4288-95ca-18570c7838f4\",\n      \"logicalname\":\"cartoonist_background_sustainability_forest_02_\",\n      \"translations\":{\n         \"nb_NO\":\"Skog 02\",\n         \"nn_NO\":\"Skog 02\",\n         \"sv_SE\":\"Skog 02\",\n         \"en_US\":\"Forest 02\",\n         \"da_DK\":\"Skov 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":12,\n      \"updated_at\":\"2021-10-20T14:17:58.603+00:00\"\n   },\n   {\n      \"id\":\"50c08860-170a-46da-b771-b3722cf93877\",\n      \"logicalname\":\"cartoonist_background_sustainability_forest_03_\",\n      \"translations\":{\n         \"nb_NO\":\"Skog 03\",\n         \"nn_NO\":\"Skog 03\",\n         \"sv_SE\":\"Skog 03\",\n         \"en_US\":\"Forest 03\",\n         \"da_DK\":\"Skov 03\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":13,\n      \"updated_at\":\"2021-10-20T14:17:58.887+00:00\"\n   },\n   {\n      \"id\":\"06f977b9-6c35-41d5-8a3e-b9c155cf175a\",\n      \"logicalname\":\"cartoonist_background_sustainability_oilplatform_01_\",\n      \"translations\":{\n         \"nb_NO\":\"Oljerigg\",\n         \"nn_NO\":\"Oljerigg\",\n         \"sv_SE\":\"Oljerigg\",\n         \"en_US\":\"Oil rig\",\n         \"da_DK\":\"Boreplatform\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":14,\n      \"updated_at\":\"2021-10-20T14:17:59.194+00:00\"\n   },\n   {\n      \"id\":\"6dc35b89-1d60-42b6-918c-cfe344b30c27\",\n      \"logicalname\":\"cartoonist_background_sustainability_rainforest_01_\",\n      \"translations\":{\n         \"nb_NO\":\"Regnskog 01\",\n         \"nn_NO\":\"Regnskog 01\",\n         \"sv_SE\":\"Regnskog 01\",\n         \"en_US\":\"Rainforest 01\",\n         \"da_DK\":\"Regnskov 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":15,\n      \"updated_at\":\"2021-10-20T14:17:59.508+00:00\"\n   },\n   {\n      \"id\":\"71c3b8a2-9342-4247-a6b2-c098ece36157\",\n      \"logicalname\":\"cartoonist_background_sustainability_rainforest_02_\",\n      \"translations\":{\n         \"nb_NO\":\"Regnskog 02\",\n         \"nn_NO\":\"Regnskog 02\",\n         \"sv_SE\":\"Regnskog 02\",\n         \"en_US\":\"Rainforest 02\",\n         \"da_DK\":\"Regnskov 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":16,\n      \"updated_at\":\"2021-10-20T14:17:59.794+00:00\"\n   },\n   {\n      \"id\":\"fe52db6c-7f24-45be-8604-073286fdfe94\",\n      \"logicalname\":\"cartoonist_background_sustainability_rainforest_03_\",\n      \"translations\":{\n         \"nb_NO\":\"Regnskog 03\",\n         \"nn_NO\":\"Regnskog 03\",\n         \"sv_SE\":\"Regnskog 03\",\n         \"en_US\":\"Rainforest 03\",\n         \"da_DK\":\"Regnskov 03\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":17,\n      \"updated_at\":\"2021-10-20T14:18:00.215+00:00\"\n   },\n   {\n      \"id\":\"dc900d2d-f8ca-41be-b3b3-b209e13a588b\",\n      \"logicalname\":\"cartoonist_background_sustainability_slum_01_\",\n      \"translations\":{\n         \"nb_NO\":\"Slum\",\n         \"nn_NO\":\"Slum\",\n         \"sv_SE\":\"Slum \",\n         \"en_US\":\"Slum \",\n         \"da_DK\":\"Slumkvarter \"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":18,\n      \"updated_at\":\"2021-10-20T14:18:00.501+00:00\"\n   },\n   {\n      \"id\":\"ebe2b007-cfd0-43f6-831b-d6202e5d8673\",\n      \"logicalname\":\"cartoonist_background_sustainability_vindmills_01_\",\n      \"translations\":{\n         \"nb_NO\":\"Vindm\xF8lle\",\n         \"nn_NO\":\"Vindm\xF8lle\",\n         \"sv_SE\":\"Vindkraftverk\",\n         \"en_US\":\"Windmill\",\n         \"da_DK\":\"Vindm\xF8lle\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":19,\n      \"updated_at\":\"2021-10-20T14:18:00.805+00:00\"\n   },\n   {\n      \"id\":\"81494cd9-cf18-4c2b-9431-baf6ab3a9767\",\n      \"logicalname\":\"cartoonist_background_sustainability_waterfall_01_\",\n      \"translations\":{\n         \"nb_NO\":\"Foss 01\",\n         \"nn_NO\":\"Foss 01\",\n         \"sv_SE\":\"Vattenfall 01\",\n         \"en_US\":\"Waterfall 01\",\n         \"da_DK\":\"Vandfald 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":20,\n      \"updated_at\":\"2021-10-20T14:18:01.114+00:00\"\n   },\n   {\n      \"id\":\"2d94ee1d-3299-494b-bd7f-244b4119f36d\",\n      \"logicalname\":\"cartoonist_background_sustainability_waterfall_02_\",\n      \"translations\":{\n         \"nb_NO\":\"Foss 02\",\n         \"nn_NO\":\"Foss 02\",\n         \"sv_SE\":\"Vattenfall 02\",\n         \"en_US\":\"Waterfall 02\",\n         \"da_DK\":\"Vandfald 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":21,\n      \"updated_at\":\"2021-10-20T14:18:01.431+00:00\"\n   },\n   {\n      \"id\":\"467fcd7b-38f1-4ee9-89b3-b3a386fde12b\",\n      \"logicalname\":\"cartoonist_background_sustainability_waterfall_03_\",\n      \"translations\":{\n         \"nb_NO\":\"Foss 03\",\n         \"nn_NO\":\"Foss 03\",\n         \"sv_SE\":\"Vattenfall 03\",\n         \"en_US\":\"Waterfall 03\",\n         \"da_DK\":\"Vandfald 03\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"day\",\n         \"night\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":22,\n      \"updated_at\":\"2021-10-20T14:18:02.025+00:00\"\n   },\n   {\n      \"id\":\"756ea4ec-31c8-464a-ba72-4e1ccb718a87\",\n      \"logicalname\":\"cartoonist_background_sustainability_antarctica_01_\",\n      \"translations\":{\n         \"nb_NO\":\"Antarktis 01\",\n         \"nn_NO\":\"Antarktis 01\",\n         \"sv_SE\":\"Antarktis 01\",\n         \"en_US\":\"Antarctica 01\",\n         \"da_DK\":\"Antarktis 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":23,\n      \"updated_at\":\"2021-10-20T14:18:02.343+00:00\"\n   },\n   {\n      \"id\":\"ea9e0d10-bd77-40e3-9fa1-85c8401d05f0\",\n      \"logicalname\":\"cartoonist_background_sustainability_antarctica_02_\",\n      \"translations\":{\n         \"nb_NO\":\"Antarktis 02\",\n         \"nn_NO\":\"Antarktis 02\",\n         \"sv_SE\":\"Antarktis 02\",\n         \"en_US\":\"Antarctica 02\",\n         \"da_DK\":\"Antarktis 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":24,\n      \"updated_at\":\"2021-10-20T14:18:02.736+00:00\"\n   },\n   {\n      \"id\":\"4567e0da-d6f5-48dd-8d76-3d2af977dbe3\",\n      \"logicalname\":\"cartoonist_background_sustainability_antarctica_03_\",\n      \"translations\":{\n         \"nb_NO\":\"Antarktis 03\",\n         \"nn_NO\":\"Antarktis 03\",\n         \"sv_SE\":\"Antarktis 03\",\n         \"en_US\":\"Antarctica 03\",\n         \"da_DK\":\"Antarktis 03\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":25,\n      \"updated_at\":\"2021-10-20T14:18:03.027+00:00\"\n   },\n   {\n      \"id\":\"df3e3c97-27cd-4801-9aa8-920d93ac4a85\",\n      \"logicalname\":\"cartoonist_background_sustainability_arctic_01_\",\n      \"translations\":{\n         \"nb_NO\":\"Arktis 01\",\n         \"nn_NO\":\"Arktis 01\",\n         \"sv_SE\":\"Arktis 01\",\n         \"en_US\":\"Arctic 01\",\n         \"da_DK\":\"Arktis 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":26,\n      \"updated_at\":\"2021-10-20T14:18:03.319+00:00\"\n   },\n   {\n      \"id\":\"92153875-a49a-440b-8347-4c0f7539fa0b\",\n      \"logicalname\":\"cartoonist_background_sustainability_arctic_02_\",\n      \"translations\":{\n         \"nb_NO\":\"Arktis 02\",\n         \"nn_NO\":\"Arktis 02\",\n         \"sv_SE\":\"Arktis 02\",\n         \"en_US\":\"Arctic 02\",\n         \"da_DK\":\"Arktis 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":27,\n      \"updated_at\":\"2021-10-20T14:18:03.613+00:00\"\n   },\n   {\n      \"id\":\"413e86da-32f9-4a79-83d2-596f8201c08a\",\n      \"logicalname\":\"cartoonist_background_sustainability_arctic_03_\",\n      \"translations\":{\n         \"nb_NO\":\"Arktis 03\",\n         \"nn_NO\":\"Arktis 03\",\n         \"sv_SE\":\"Arktis 03\",\n         \"en_US\":\"Arctic 03\",\n         \"da_DK\":\"Arktis 03\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":28,\n      \"updated_at\":\"2021-10-20T14:18:03.917+00:00\"\n   },\n   {\n      \"id\":\"686a15fb-aa76-450a-946b-60bc3a862b76\",\n      \"logicalname\":\"cartoonist_background_sustainability_underwater_01_\",\n      \"translations\":{\n         \"nb_NO\":\"Under vann 01\",\n         \"nn_NO\":\"Under vatn 01\",\n         \"sv_SE\":\"Undervatten 01\",\n         \"en_US\":\"Underwater 01\",\n         \"da_DK\":\"Under vandet 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":29,\n      \"updated_at\":\"2021-10-20T14:18:04.314+00:00\"\n   },\n   {\n      \"id\":\"72b5ae00-c5a7-43ed-8dad-baff39025478\",\n      \"logicalname\":\"cartoonist_background_sustainability_underwater_02_\",\n      \"translations\":{\n         \"nb_NO\":\"Under vann 02\",\n         \"nn_NO\":\"Under vatn 02\",\n         \"sv_SE\":\"Undervatten 02\",\n         \"en_US\":\"Underwater 02\",\n         \"da_DK\":\"Under vandet 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":30,\n      \"updated_at\":\"2021-10-20T14:18:04.679+00:00\"\n   },\n   {\n      \"id\":\"20c378ce-edf4-43f9-a71e-8f1bd54e4e3d\",\n      \"logicalname\":\"cartoonist_background_sustainability_underwater_03_\",\n      \"translations\":{\n         \"nb_NO\":\"Under vann 03\",\n         \"nn_NO\":\"Under vatn 03\",\n         \"sv_SE\":\"Undervatten 03\",\n         \"en_US\":\"Underwater 03\",\n         \"da_DK\":\"Under vandet 03\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":450,\n      \"position\":31,\n      \"updated_at\":\"2021-10-20T14:18:04.969+00:00\"\n   },\n   {\n      \"id\":\"b875cd83-583e-49dd-ab22-00059eddf509\",\n      \"logicalname\":\"sustainability_boy_01_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Gutt 01 l\xF8per\",\n         \"nn_NO\":\"Gut 01 spring\",\n         \"sv_SE\":\"Pojke 01 springer\",\n         \"en_US\":\"Boy 01 running\",\n         \"da_DK\":\"Dreng 01 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":245,\n      \"height\":322,\n      \"position\":0,\n      \"updated_at\":\"2021-10-20T14:18:05.470+00:00\"\n   },\n   {\n      \"id\":\"5a4d7484-4eb0-4053-bf3e-3de05cfbea4e\",\n      \"logicalname\":\"sustainability_boy_01_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Gutt 01 sitter\",\n         \"nn_NO\":\"Gut 01 sit\",\n         \"sv_SE\":\"Pojke 01 sitter\",\n         \"en_US\":\"Boy 01 sitting\",\n         \"da_DK\":\"Dreng 01 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":167,\n      \"height\":303,\n      \"position\":1,\n      \"updated_at\":\"2021-10-20T14:18:05.762+00:00\"\n   },\n   {\n      \"id\":\"71f56a2f-20bd-4387-8e9b-f3b3a86dce51\",\n      \"logicalname\":\"sustainability_boy_01_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Gutt 01 st\xE5r\",\n         \"nn_NO\":\"Gut 01 st\xE5r\",\n         \"sv_SE\":\"Pojke 01 st\xE5r\",\n         \"en_US\":\"Boy 01 standing\",\n         \"da_DK\":\"Dreng 01 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":123,\n      \"height\":341,\n      \"position\":2,\n      \"updated_at\":\"2021-10-20T14:18:06.111+00:00\"\n   },\n   {\n      \"id\":\"f211f149-cc4b-43b1-8bb3-a01dab89d72f\",\n      \"logicalname\":\"sustainability_boy_01_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Gutt 01 g\xE5r\",\n         \"nn_NO\":\"Gut 01 g\xE5r\",\n         \"sv_SE\":\"Pojke 01 g\xE5r\",\n         \"en_US\":\"Boy 01 walking\",\n         \"da_DK\":\"Dreng 01 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":144,\n      \"height\":333,\n      \"position\":3,\n      \"updated_at\":\"2021-10-20T14:18:06.404+00:00\"\n   },\n   {\n      \"id\":\"827d3a2e-81b9-4b77-8dfb-bed54524261c\",\n      \"logicalname\":\"sustainability_boy_02_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Gutt 02 l\xF8per\",\n         \"nn_NO\":\"Gut 02 spring\",\n         \"sv_SE\":\"Pojke 02 springer\",\n         \"en_US\":\"Boy 02 running\",\n         \"da_DK\":\"Dreng 02 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":229,\n      \"height\":353,\n      \"position\":58,\n      \"updated_at\":\"2021-10-20T14:18:06.703+00:00\"\n   },\n   {\n      \"id\":\"5b3614ac-1512-4b97-aba3-645fde31490a\",\n      \"logicalname\":\"sustainability_boy_02_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Gutt 02 sitter\",\n         \"nn_NO\":\"Gut 02 sit\",\n         \"sv_SE\":\"Pojke 02 sitter\",\n         \"en_US\":\"Boy 02 sitting\",\n         \"da_DK\":\"Dreng 02 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":158,\n      \"height\":331,\n      \"position\":57,\n      \"updated_at\":\"2021-10-20T14:18:07.111+00:00\"\n   },\n   {\n      \"id\":\"4f38b271-5e99-439c-b6af-e0471fdb2d8c\",\n      \"logicalname\":\"sustainability_boy_02_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Gutt 02 st\xE5r\",\n         \"nn_NO\":\"Gut 02 st\xE5r\",\n         \"sv_SE\":\"Pojke 02 st\xE5r\",\n         \"en_US\":\"Boy 02 standing\",\n         \"da_DK\":\"Dreng 02 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":122,\n      \"height\":363,\n      \"position\":56,\n      \"updated_at\":\"2021-10-20T14:18:07.398+00:00\"\n   },\n   {\n      \"id\":\"70975553-65c3-4751-95a5-fcb9d4d27d6f\",\n      \"logicalname\":\"sustainability_boy_02_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Gutt 02 g\xE5r\",\n         \"nn_NO\":\"Gut 02 g\xE5r\",\n         \"sv_SE\":\"Pojke 02 g\xE5r\",\n         \"en_US\":\"Boy 02 walking\",\n         \"da_DK\":\"Dreng 02 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":143,\n      \"height\":354,\n      \"position\":55,\n      \"updated_at\":\"2021-10-20T14:18:07.688+00:00\"\n   },\n   {\n      \"id\":\"69564493-fb52-46f6-b8cc-505f20a760ce\",\n      \"logicalname\":\"sustainability_girl_01_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 01 l\xF8per\",\n         \"nn_NO\":\"Jente 01 spring\",\n         \"sv_SE\":\"Greta springer\",\n         \"en_US\":\"Girl 01 running\",\n         \"da_DK\":\"Pige 01 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":249,\n      \"height\":341,\n      \"position\":4,\n      \"updated_at\":\"2021-10-20T14:18:08.088+00:00\"\n   },\n   {\n      \"id\":\"f71f82f4-9edb-49d0-a5e4-30847dc721c0\",\n      \"logicalname\":\"sustainability_girl_01_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 01 sitter\",\n         \"nn_NO\":\"Jente 01 sit\",\n         \"sv_SE\":\"Greta sitter\",\n         \"en_US\":\"Girl 01 sitting\",\n         \"da_DK\":\"Pige 01 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":169,\n      \"height\":205,\n      \"position\":5,\n      \"updated_at\":\"2021-10-20T14:18:08.416+00:00\"\n   },\n   {\n      \"id\":\"f5d21337-7055-4ae4-8914-cf9fde4e2dcb\",\n      \"logicalname\":\"sustainability_girl_01_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 01 st\xE5r\",\n         \"nn_NO\":\"Jente 01 st\xE5r\",\n         \"sv_SE\":\"Greta st\xE5r\",\n         \"en_US\":\"Girl 01 standing\",\n         \"da_DK\":\"Pige 01 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":134,\n      \"height\":344,\n      \"position\":6,\n      \"updated_at\":\"2021-10-20T14:18:08.726+00:00\"\n   },\n   {\n      \"id\":\"83459bc4-68f0-437b-b4d2-38b987d17816\",\n      \"logicalname\":\"sustainability_girl_01_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 01 g\xE5r\",\n         \"nn_NO\":\"Jente 01 g\xE5r\",\n         \"sv_SE\":\"Greta g\xE5r\",\n         \"en_US\":\"Girl 01 walking\",\n         \"da_DK\":\"Pige 01 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":144,\n      \"height\":333,\n      \"position\":7,\n      \"updated_at\":\"2021-10-20T14:18:09.106+00:00\"\n   },\n   {\n      \"id\":\"8cb84ead-cad5-44d2-ba3b-b6596ca4289f\",\n      \"logicalname\":\"sustainability_girl_02_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 02 l\xF8per\",\n         \"nn_NO\":\"Jente 02 spring\",\n         \"sv_SE\":\"Flicka 02 springer\",\n         \"en_US\":\"Girl 02 running\",\n         \"da_DK\":\"Pige 02 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":242,\n      \"height\":342,\n      \"position\":54,\n      \"updated_at\":\"2021-10-20T14:18:09.431+00:00\"\n   },\n   {\n      \"id\":\"dea15555-4c4a-453a-b423-b90a3641654b\",\n      \"logicalname\":\"sustainability_girl_02_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 02 sitter\",\n         \"nn_NO\":\"Jente 02 sit\",\n         \"sv_SE\":\"Flicka 02 sitter\",\n         \"en_US\":\"Girl 02 sitting\",\n         \"da_DK\":\"Pige 02 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":162,\n      \"height\":291,\n      \"position\":53,\n      \"updated_at\":\"2021-10-20T14:18:09.782+00:00\"\n   },\n   {\n      \"id\":\"978e3e95-e34a-4e51-be3a-7e68add755ef\",\n      \"logicalname\":\"sustainability_girl_02_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 02 st\xE5r\",\n         \"nn_NO\":\"Jente 02 st\xE5r\",\n         \"sv_SE\":\"Flicka 02 st\xE5r\",\n         \"en_US\":\"Girl 02 standing\",\n         \"da_DK\":\"Pige 02 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":110,\n      \"height\":351,\n      \"position\":52,\n      \"updated_at\":\"2021-10-20T14:18:10.072+00:00\"\n   },\n   {\n      \"id\":\"ff1e92ae-3b9e-4377-aada-a57bb266cd4e\",\n      \"logicalname\":\"sustainability_girl_02_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 02 g\xE5r\",\n         \"nn_NO\":\"Jente 02 g\xE5r\",\n         \"sv_SE\":\"Flicka 02 g\xE5r\",\n         \"en_US\":\"Girl 02 walking\",\n         \"da_DK\":\"Pige 02 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":131,\n      \"height\":341,\n      \"position\":51,\n      \"updated_at\":\"2021-10-20T14:18:10.379+00:00\"\n   },\n   {\n      \"id\":\"dc0c4d16-2172-4c4f-a0f8-48d9294cd1cc\",\n      \"logicalname\":\"sustainability_girl_03_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 03 l\xF8per\",\n         \"nn_NO\":\"Jente 03 spring\",\n         \"sv_SE\":\"Flicka 03 springer\",\n         \"en_US\":\"Girl 03 running\",\n         \"da_DK\":\"Pige 03 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":173,\n      \"height\":315,\n      \"position\":50,\n      \"updated_at\":\"2021-10-20T14:18:10.805+00:00\"\n   },\n   {\n      \"id\":\"9463fe5b-fc1e-4eed-ae66-e75a81c39197\",\n      \"logicalname\":\"sustainability_girl_03_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 03 sitter\",\n         \"nn_NO\":\"Jente 03 sit\",\n         \"sv_SE\":\"Flicka 03 sitter\",\n         \"en_US\":\"Girl 03 sitting\",\n         \"da_DK\":\"Pige 03 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":175,\n      \"height\":297,\n      \"position\":49,\n      \"updated_at\":\"2021-10-20T14:18:11.150+00:00\"\n   },\n   {\n      \"id\":\"69663b3c-c102-4376-9f1a-b2fcadc8390f\",\n      \"logicalname\":\"sustainability_girl_03_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 03 st\xE5r\",\n         \"nn_NO\":\"Jente 03 st\xE5r\",\n         \"sv_SE\":\"Flicka 03 st\xE5r\",\n         \"en_US\":\"Girl 03 standing\",\n         \"da_DK\":\"Pige 03 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":135,\n      \"height\":334,\n      \"position\":48,\n      \"updated_at\":\"2021-10-20T14:18:11.542+00:00\"\n   },\n   {\n      \"id\":\"c5116613-7140-476e-8353-7ce610bd387a\",\n      \"logicalname\":\"sustainability_girl_03_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 03 g\xE5r\",\n         \"nn_NO\":\"Jente 03 g\xE5r\",\n         \"sv_SE\":\"Flicka 03 g\xE5r\",\n         \"en_US\":\"Girl 03 walking\",\n         \"da_DK\":\"Pige 03 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":135,\n      \"height\":309,\n      \"position\":47,\n      \"updated_at\":\"2021-10-20T14:18:11.839+00:00\"\n   },\n   {\n      \"id\":\"dde094ae-3562-4bea-ace3-5c7d05b5c61b\",\n      \"logicalname\":\"sustainability_girl_04_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 04 l\xF8per\",\n         \"nn_NO\":\"Jente 04 spring\",\n         \"sv_SE\":\"Flicka 04 springer\",\n         \"en_US\":\"Girl 04 running\",\n         \"da_DK\":\"Pige 04 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":201,\n      \"height\":333,\n      \"position\":46,\n      \"updated_at\":\"2021-10-20T14:18:12.136+00:00\"\n   },\n   {\n      \"id\":\"2c41f22e-9969-4497-beee-9065e2dc328d\",\n      \"logicalname\":\"sustainability_girl_04_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 04 sitter\",\n         \"nn_NO\":\"Jente 04 sit\",\n         \"sv_SE\":\"Flicka 04 sitter\",\n         \"en_US\":\"Girl 04 sitting\",\n         \"da_DK\":\"Pige 04 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":153,\n      \"height\":314,\n      \"position\":45,\n      \"updated_at\":\"2021-10-20T14:18:12.431+00:00\"\n   },\n   {\n      \"id\":\"2d0d32dd-2f32-45cd-b770-573cd7cf6e6b\",\n      \"logicalname\":\"sustainability_girl_04_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 04 st\xE5r\",\n         \"nn_NO\":\"Jente 04 st\xE5r\",\n         \"sv_SE\":\"Flicka 04 st\xE5r\",\n         \"en_US\":\"Girl 04 standing\",\n         \"da_DK\":\"Pige 04 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":109,\n      \"height\":349,\n      \"position\":44,\n      \"updated_at\":\"2021-10-20T14:18:12.863+00:00\"\n   },\n   {\n      \"id\":\"d98638d1-1126-4b8f-ab3f-38baf977b01b\",\n      \"logicalname\":\"sustainability_girl_04_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Jente 04 g\xE5r\",\n         \"nn_NO\":\"Jente 04 g\xE5r\",\n         \"sv_SE\":\"Flicka 04 g\xE5r\",\n         \"en_US\":\"Girl 04 walking\",\n         \"da_DK\":\"Pige 04 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":128,\n      \"height\":346,\n      \"position\":43,\n      \"updated_at\":\"2021-10-20T14:18:13.153+00:00\"\n   },\n   {\n      \"id\":\"0a4afb7b-9199-42c0-800f-aa306a19e1d3\",\n      \"logicalname\":\"sustainability_man_01_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 01 l\xF8per\",\n         \"nn_NO\":\"Mann 01 spring\",\n         \"sv_SE\":\"Man 01 springer\",\n         \"en_US\":\"Man 01 running\",\n         \"da_DK\":\"Mand 01 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":260,\n      \"height\":449,\n      \"position\":8,\n      \"updated_at\":\"2021-10-20T14:18:13.454+00:00\"\n   },\n   {\n      \"id\":\"b6b4f1c9-984b-4547-aee0-aacae8a15573\",\n      \"logicalname\":\"sustainability_man_01_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 01 sitter\",\n         \"nn_NO\":\"Mann 01 sit\",\n         \"sv_SE\":\"Man 01 sitter\",\n         \"en_US\":\"Man 01 sitting\",\n         \"da_DK\":\"Mand 01 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":299,\n      \"height\":353,\n      \"position\":9,\n      \"updated_at\":\"2021-10-20T14:18:13.857+00:00\"\n   },\n   {\n      \"id\":\"ea16ce50-0c93-4612-bb7e-99ba03a2cb79\",\n      \"logicalname\":\"sustainability_man_01_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 01 st\xE5r\",\n         \"nn_NO\":\"Mann 01 st\xE5r\",\n         \"sv_SE\":\"Man 01 st\xE5r\",\n         \"en_US\":\"Man 01 standing\",\n         \"da_DK\":\"Mand 01 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":140,\n      \"height\":461,\n      \"position\":10,\n      \"updated_at\":\"2021-10-20T14:18:14.150+00:00\"\n   },\n   {\n      \"id\":\"f7468567-e508-4a89-8dc2-d3ab17d56107\",\n      \"logicalname\":\"sustainability_man_01_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 01 g\xE5r\",\n         \"nn_NO\":\"Mann 01 g\xE5r\",\n         \"sv_SE\":\"Man 01 g\xE5r\",\n         \"en_US\":\"Man 01 walking\",\n         \"da_DK\":\"Mand 01 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":156,\n      \"height\":443,\n      \"position\":11,\n      \"updated_at\":\"2021-10-20T14:18:14.526+00:00\"\n   },\n   {\n      \"id\":\"8a3f98fd-17fc-4abc-8355-021e92e09748\",\n      \"logicalname\":\"sustainability_man_02_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 02 l\xF8per\",\n         \"nn_NO\":\"Mann 02 spring\",\n         \"sv_SE\":\"Man 02 springer\",\n         \"en_US\":\"Man 02 running\",\n         \"da_DK\":\"Mand 02 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":233,\n      \"height\":382,\n      \"position\":12,\n      \"updated_at\":\"2021-10-20T14:18:14.826+00:00\"\n   },\n   {\n      \"id\":\"a7c52316-bc22-4db0-abf3-a224daac378d\",\n      \"logicalname\":\"sustainability_man_02_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 02 sitter\",\n         \"nn_NO\":\"Mann 02 sit\",\n         \"sv_SE\":\"Man 02 sitter\",\n         \"en_US\":\"Man 02 sitting\",\n         \"da_DK\":\"Mand 02 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":214,\n      \"height\":358,\n      \"position\":13,\n      \"updated_at\":\"2021-10-20T14:18:15.215+00:00\"\n   },\n   {\n      \"id\":\"324193aa-cac8-4e3e-9969-0148ea5be8ef\",\n      \"logicalname\":\"sustainability_man_02_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 02 st\xE5r\",\n         \"nn_NO\":\"Mann 02 st\xE5r\",\n         \"sv_SE\":\"Man 02 st\xE5r\",\n         \"en_US\":\"Man 02 standing\",\n         \"da_DK\":\"Mand 02 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":137,\n      \"height\":409,\n      \"position\":14,\n      \"updated_at\":\"2021-10-20T14:18:15.510+00:00\"\n   },\n   {\n      \"id\":\"859a4124-e44b-485e-82dd-0fcd433ab9c3\",\n      \"logicalname\":\"sustainability_man_02_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 02 g\xE5r\",\n         \"nn_NO\":\"Mann 02 g\xE5r\",\n         \"sv_SE\":\"Man 02 g\xE5r\",\n         \"en_US\":\"Man 02 walking\",\n         \"da_DK\":\"Mand 02 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":171,\n      \"height\":398,\n      \"position\":15,\n      \"updated_at\":\"2021-10-20T14:18:15.813+00:00\"\n   },\n   {\n      \"id\":\"55a2c9df-00c0-4c52-a02f-3678821af9a2\",\n      \"logicalname\":\"sustainability_man_03_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 03 l\xF8per\",\n         \"nn_NO\":\"Mann 03 spring\",\n         \"sv_SE\":\"Man 03 springer\",\n         \"en_US\":\"Man 03 running\",\n         \"da_DK\":\"Mand 03 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":264,\n      \"height\":419,\n      \"position\":16,\n      \"updated_at\":\"2021-10-20T14:18:16.256+00:00\"\n   },\n   {\n      \"id\":\"c43963cf-4006-4b83-8360-df9c1ffde5f3\",\n      \"logicalname\":\"sustainability_man_03_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 03 sitter\",\n         \"nn_NO\":\"Mann 03 sit\",\n         \"sv_SE\":\"Man 03 sitter\",\n         \"en_US\":\"Man 03 sitting\",\n         \"da_DK\":\"Mand 03 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":218,\n      \"height\":385,\n      \"position\":17,\n      \"updated_at\":\"2021-10-20T14:18:16.540+00:00\"\n   },\n   {\n      \"id\":\"8100202b-3ee1-4413-9e39-14b7fa6a0a57\",\n      \"logicalname\":\"sustainability_man_03_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 03 st\xE5r\",\n         \"nn_NO\":\"Mann 03 st\xE5r\",\n         \"sv_SE\":\"Man 03 st\xE5r\",\n         \"en_US\":\"Man 03 standing\",\n         \"da_DK\":\"Mand 03 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":138,\n      \"height\":438,\n      \"position\":18,\n      \"updated_at\":\"2021-10-20T14:18:16.831+00:00\"\n   },\n   {\n      \"id\":\"277ba8df-1bc4-453b-a91b-6a8077919733\",\n      \"logicalname\":\"sustainability_man_03_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 03 g\xE5r\",\n         \"nn_NO\":\"Mann 03 g\xE5r\",\n         \"sv_SE\":\"Man 03 g\xE5r\",\n         \"en_US\":\"Man 03 walking\",\n         \"da_DK\":\"Mand 03 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":141,\n      \"height\":436,\n      \"position\":19,\n      \"updated_at\":\"2021-10-20T14:18:17.141+00:00\"\n   },\n   {\n      \"id\":\"7dc08f1c-3f8e-426f-88f8-9342bd8b05de\",\n      \"logicalname\":\"sustainability_man_04_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 04 l\xF8per\",\n         \"nn_NO\":\"Mann 04 spring\",\n         \"sv_SE\":\"Man 04 springer\",\n         \"en_US\":\"Man 04 running\",\n         \"da_DK\":\"Mand 04 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":234,\n      \"height\":357,\n      \"position\":20,\n      \"updated_at\":\"2021-10-20T14:18:17.584+00:00\"\n   },\n   {\n      \"id\":\"c63dedc1-d0d4-4f4b-a7c0-fb0fbc6704a3\",\n      \"logicalname\":\"sustainability_man_04_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 04 sitter\",\n         \"nn_NO\":\"Mann 04 sit\",\n         \"sv_SE\":\"Man 04 sitter\",\n         \"en_US\":\"Man 04 sitting\",\n         \"da_DK\":\"Mand 04 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":203,\n      \"height\":330,\n      \"position\":21,\n      \"updated_at\":\"2021-10-20T14:18:17.873+00:00\"\n   },\n   {\n      \"id\":\"604225f4-5661-49ee-a2b4-e59817ad19b4\",\n      \"logicalname\":\"sustainability_man_04_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 04 st\xE5r\",\n         \"nn_NO\":\"Mann 04 st\xE5r\",\n         \"sv_SE\":\"Man 04 st\xE5r\",\n         \"en_US\":\"Man 04 standing\",\n         \"da_DK\":\"Mand 04 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":137,\n      \"height\":408,\n      \"position\":22,\n      \"updated_at\":\"2021-10-20T14:18:18.185+00:00\"\n   },\n   {\n      \"id\":\"3216a462-ae2f-4748-ad05-fab07df3f2b8\",\n      \"logicalname\":\"sustainability_man_04_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 04 g\xE5r\",\n         \"nn_NO\":\"Mann 04 g\xE5r\",\n         \"sv_SE\":\"Man 04 g\xE5r\",\n         \"en_US\":\"Man 04 walking\",\n         \"da_DK\":\"Mand 04 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":162,\n      \"height\":401,\n      \"position\":23,\n      \"updated_at\":\"2021-10-20T14:18:18.498+00:00\"\n   },\n   {\n      \"id\":\"229858fa-71b7-488d-8aa4-cca357b56d6d\",\n      \"logicalname\":\"sustainability_man_05_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 05 l\xF8per\",\n         \"nn_NO\":\"Mann 05 spring\",\n         \"sv_SE\":\"Man 05 springer\",\n         \"en_US\":\"Man 05 running\",\n         \"da_DK\":\"Mand 05 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":232,\n      \"height\":392,\n      \"position\":42,\n      \"updated_at\":\"2021-10-20T14:18:18.819+00:00\"\n   },\n   {\n      \"id\":\"9000bfb9-8ed4-4d1e-b96e-f2c7d2410e2f\",\n      \"logicalname\":\"sustainability_man_05_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 05 sitter\",\n         \"nn_NO\":\"Mann 05 sit\",\n         \"sv_SE\":\"Man 05 sitter\",\n         \"en_US\":\"Man 05 sitting\",\n         \"da_DK\":\"Mand 05 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":173,\n      \"height\":324,\n      \"position\":41,\n      \"updated_at\":\"2021-10-20T14:18:19.115+00:00\"\n   },\n   {\n      \"id\":\"a8de1f1e-011e-4ef5-b7ac-47a589422f0f\",\n      \"logicalname\":\"sustainability_man_05_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 05 st\xE5r\",\n         \"nn_NO\":\"Mann 05 st\xE5r\",\n         \"sv_SE\":\"Man 05 st\xE5r\",\n         \"en_US\":\"Man 05 standing\",\n         \"da_DK\":\"Mand 05 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":203,\n      \"height\":400,\n      \"position\":40,\n      \"updated_at\":\"2021-10-20T14:18:19.426+00:00\"\n   },\n   {\n      \"id\":\"f57d165b-3327-4173-9ffd-bd94b4a9e006\",\n      \"logicalname\":\"sustainability_man_05_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Mann 05 g\xE5r\",\n         \"nn_NO\":\"Mann 05 g\xE5r\",\n         \"sv_SE\":\"Man 05 g\xE5r\",\n         \"en_US\":\"Man 05 walking\",\n         \"da_DK\":\"Mand 05 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":168,\n      \"height\":401,\n      \"position\":39,\n      \"updated_at\":\"2021-10-20T14:18:19.906+00:00\"\n   },\n   {\n      \"id\":\"32aa2100-a01c-4604-912b-1be9bf36548a\",\n      \"logicalname\":\"sustainability_woman_01_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Kvinne 01 l\xF8per\",\n         \"nn_NO\":\"Kvinne 01 spring\",\n         \"sv_SE\":\"Kvinna 01 springer\",\n         \"en_US\":\"Woman 01 running\",\n         \"da_DK\":\"Kvinde 01 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":235,\n      \"height\":377,\n      \"position\":24,\n      \"updated_at\":\"2021-10-20T14:18:20.202+00:00\"\n   },\n   {\n      \"id\":\"7b3bcea4-1e8b-42a3-a58b-0350ff0addce\",\n      \"logicalname\":\"sustainability_woman_01_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Kvinne 01 sitter\",\n         \"nn_NO\":\"Kvinne 01 sit\",\n         \"sv_SE\":\"Kvinna 01 sitter\",\n         \"en_US\":\"Woman 01 sitting\",\n         \"da_DK\":\"Kvinde 01 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":184,\n      \"height\":334,\n      \"position\":25,\n      \"updated_at\":\"2021-10-20T14:18:20.499+00:00\"\n   },\n   {\n      \"id\":\"e1e37442-a8e8-45cb-bf09-7d0bef647d4d\",\n      \"logicalname\":\"sustainability_woman_01_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Kvinne 01 st\xE5r\",\n         \"nn_NO\":\"Kvinne 01 st\xE5r\",\n         \"sv_SE\":\"Kvinna 01 st\xE5r\",\n         \"en_US\":\"Woman 01 standing\",\n         \"da_DK\":\"Kvinde 01 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":136,\n      \"height\":403,\n      \"position\":26,\n      \"updated_at\":\"2021-10-20T14:18:20.798+00:00\"\n   },\n   {\n      \"id\":\"f9b0c45d-9a9d-4373-a5a3-a3f5dc73febb\",\n      \"logicalname\":\"sustainability_woman_01_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Kvinne 01 g\xE5r\",\n         \"nn_NO\":\"Kvinne 01 g\xE5r\",\n         \"sv_SE\":\"Kvinna 01 g\xE5r\",\n         \"en_US\":\"Woman 01 walking\",\n         \"da_DK\":\"Kvinde 01 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":177,\n      \"height\":397,\n      \"position\":27,\n      \"updated_at\":\"2021-10-20T14:18:21.096+00:00\"\n   },\n   {\n      \"id\":\"0ecc281a-2627-4a5f-9fd4-8f417eb1f124\",\n      \"logicalname\":\"sustainability_woman_02_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Kvinne 02 l\xF8per\",\n         \"nn_NO\":\"Kvinne 02 spring\",\n         \"sv_SE\":\"Kvinna 02 springer\",\n         \"en_US\":\"Woman 02 running\",\n         \"da_DK\":\"Kvinde 02 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":219,\n      \"height\":383,\n      \"position\":38,\n      \"updated_at\":\"2021-10-20T14:18:21.389+00:00\"\n   },\n   {\n      \"id\":\"96586d4a-0904-492c-a419-6faf342d42ae\",\n      \"logicalname\":\"sustainability_woman_02_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Kvinne 02 sitter\",\n         \"nn_NO\":\"Kvinne 02 sit\",\n         \"sv_SE\":\"Kvinna 02 sitter\",\n         \"en_US\":\"Woman 02 sitting\",\n         \"da_DK\":\"Kvinde 02 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":207,\n      \"height\":345,\n      \"position\":37,\n      \"updated_at\":\"2021-10-20T14:18:21.763+00:00\"\n   },\n   {\n      \"id\":\"b45aa3d0-a778-495a-88b3-1b4e42276529\",\n      \"logicalname\":\"sustainability_woman_02_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Kvinne 02 st\xE5r\",\n         \"nn_NO\":\"Kvinne 02 st\xE5r\",\n         \"sv_SE\":\"Kvinna 02 st\xE5r\",\n         \"en_US\":\"Woman 02 standing\",\n         \"da_DK\":\"Kvinde 02 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":135,\n      \"height\":400,\n      \"position\":36,\n      \"updated_at\":\"2021-10-20T14:18:22.058+00:00\"\n   },\n   {\n      \"id\":\"e6692e49-de19-491c-bf45-3c9a57c63377\",\n      \"logicalname\":\"sustainability_woman_02_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Kvinne 02 g\xE5r\",\n         \"nn_NO\":\"Kvinne 02 g\xE5r\",\n         \"sv_SE\":\"Kvinna 02 g\xE5r\",\n         \"en_US\":\"Woman 02 walking\",\n         \"da_DK\":\"Kvinde 02 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":159,\n      \"height\":387,\n      \"position\":35,\n      \"updated_at\":\"2021-10-20T14:18:22.577+00:00\"\n   },\n   {\n      \"id\":\"1725cb99-5e76-4570-adb5-734a5f5dd7be\",\n      \"logicalname\":\"sustainability_child_01_running_\",\n      \"translations\":{\n         \"nb_NO\":\"Barn 01 l\xF8per\",\n         \"nn_NO\":\"Barn 01 spring\",\n         \"sv_SE\":\"Barn 01 springer\",\n         \"en_US\":\"Child 01 running\",\n         \"da_DK\":\"Barn 01 l\xF8ber\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":175,\n      \"height\":278,\n      \"position\":34,\n      \"updated_at\":\"2021-10-20T14:18:22.871+00:00\"\n   },\n   {\n      \"id\":\"367cd88d-d577-42f8-9ca8-f636e91c0c41\",\n      \"logicalname\":\"sustainability_child_01_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Barn 01 sitter\",\n         \"nn_NO\":\"Barn 01 sit\",\n         \"sv_SE\":\"Barn 01 sitter\",\n         \"en_US\":\"Child 01 sitting\",\n         \"da_DK\":\"Barn 01 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":137,\n      \"height\":263,\n      \"position\":33,\n      \"updated_at\":\"2021-10-20T14:18:23.238+00:00\"\n   },\n   {\n      \"id\":\"4f00ea75-e43c-40c1-b85b-25308f869517\",\n      \"logicalname\":\"sustainability_child_01_standing_\",\n      \"translations\":{\n         \"nb_NO\":\"Barn 01 st\xE5r\",\n         \"nn_NO\":\"Barn 01 st\xE5r\",\n         \"sv_SE\":\"Barn 01 St\xE5r\",\n         \"en_US\":\"Child 01 standing\",\n         \"da_DK\":\"Barn 01 st\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":96,\n      \"height\":286,\n      \"position\":32,\n      \"updated_at\":\"2021-10-20T14:18:23.612+00:00\"\n   },\n   {\n      \"id\":\"85ff7d81-5dd4-4208-9ae0-78eb5f413e0d\",\n      \"logicalname\":\"sustainability_child_01_walking_\",\n      \"translations\":{\n         \"nb_NO\":\"Barn 01 g\xE5r\",\n         \"nn_NO\":\"Born 01 g\xE5r\",\n         \"sv_SE\":\"Barn 01 G\xE5r\",\n         \"en_US\":\"Child 01 walking\",\n         \"da_DK\":\"Barn 01 g\xE5r\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"sad\",\n         \"angry\",\n         \"behind\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":114,\n      \"height\":276,\n      \"position\":31,\n      \"updated_at\":\"2021-10-20T14:18:23.902+00:00\"\n   },\n   {\n      \"id\":\"11c7c78b-3083-408a-9691-31ebe44e8378\",\n      \"logicalname\":\"sustainability_baby_01_sitting_\",\n      \"translations\":{\n         \"nb_NO\":\"Baby 01 sitter\",\n         \"nn_NO\":\"Baby 01 sit\",\n         \"sv_SE\":\"Bebis 01 Sitter\",\n         \"en_US\":\"Baby 01 sitting\",\n         \"da_DK\":\"Baby 01 sidder\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"curious\",\n         \"sleeping\",\n         \"crying\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":103,\n      \"height\":129,\n      \"position\":28,\n      \"updated_at\":\"2021-10-20T14:18:24.273+00:00\"\n   },\n   {\n      \"id\":\"41b860ec-5a30-4df7-ac75-ca15d92250ed\",\n      \"logicalname\":\"sustainability_baby_01_lying_\",\n      \"translations\":{\n         \"nb_NO\":\"Baby 01 ligger\",\n         \"nn_NO\":\"Baby 01 ligg\",\n         \"sv_SE\":\"Bebis 01 Ligger\",\n         \"en_US\":\"Baby 01 lying down\",\n         \"da_DK\":\"Baby 01 ligger ned\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"curious\",\n         \"sleeping\",\n         \"crying\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":150,\n      \"height\":84,\n      \"position\":29,\n      \"updated_at\":\"2021-10-20T14:18:24.729+00:00\"\n   },\n   {\n      \"id\":\"85c4daf9-dad3-4f00-a7c3-312ee50d5236\",\n      \"logicalname\":\"sustainability_baby_01_crawling_\",\n      \"translations\":{\n         \"nb_NO\":\"Baby 01 krabber\",\n         \"nn_NO\":\"Baby 01 krabbar\",\n         \"sv_SE\":\"Bebis 01 kryper\",\n         \"en_US\":\"Baby 01 crawling\",\n         \"da_DK\":\"Baby 01 kravler\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"people\",\n      \"moods\":[\n         \"normal\",\n         \"happy\",\n         \"curious\",\n         \"sleeping\",\n         \"crying\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":133,\n      \"height\":101,\n      \"position\":30,\n      \"updated_at\":\"2021-10-20T14:18:25.030+00:00\"\n   },\n   {\n      \"id\":\"1b8b0781-cb42-4541-9344-35d5fbebc75b\",\n      \"logicalname\":\"sustainability_props_bucket_\",\n      \"translations\":{\n         \"nb_NO\":\"B\xF8tte\",\n         \"nn_NO\":\"B\xF8tte\",\n         \"sv_SE\":\"Hink\",\n         \"en_US\":\"Bucket\",\n         \"da_DK\":\"Spand\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"01\",\n         \"02\",\n         \"03\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":70,\n      \"height\":72,\n      \"position\":0,\n      \"updated_at\":\"2021-10-20T14:18:25.485+00:00\"\n   },\n   {\n      \"id\":\"cb7f41c1-e8ba-45c2-aae8-e5b791a817f0\",\n      \"logicalname\":\"sustainability_props_bulldozer_\",\n      \"translations\":{\n         \"nb_NO\":\"Bulldoser\",\n         \"nn_NO\":\"Bulldosar\",\n         \"sv_SE\":\"Bulldozer\",\n         \"en_US\":\"Bulldozer\",\n         \"da_DK\":\"Bulldozer\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"01\",\n         \"02\",\n         \"03\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":404,\n      \"height\":181,\n      \"position\":1,\n      \"updated_at\":\"2021-10-20T14:18:25.778+00:00\"\n   },\n   {\n      \"id\":\"d74e91ce-7f94-4bb1-939f-d729a65d393f\",\n      \"logicalname\":\"sustainability_props_cow_\",\n      \"translations\":{\n         \"nb_NO\":\"Ku\",\n         \"nn_NO\":\"Ku\",\n         \"sv_SE\":\"Ko\",\n         \"en_US\":\"Cow\",\n         \"da_DK\":\"Ko\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"01\",\n         \"02\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":158,\n      \"height\":114,\n      \"position\":2,\n      \"updated_at\":\"2021-10-20T14:18:26.091+00:00\"\n   },\n   {\n      \"id\":\"6e4d2f42-2781-4cc8-891b-ebf9083c74b3\",\n      \"logicalname\":\"sustainability_props_polarbear_\",\n      \"translations\":{\n         \"nb_NO\":\"Isbj\xF8rn\",\n         \"nn_NO\":\"Isbj\xF8rn\",\n         \"sv_SE\":\"Isbj\xF6rn\",\n         \"en_US\":\"Polar bear\",\n         \"da_DK\":\"Isbj\xF8rn\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"01\",\n         \"02\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":185,\n      \"height\":97,\n      \"position\":3,\n      \"updated_at\":\"2021-10-20T14:18:26.400+00:00\"\n   },\n   {\n      \"id\":\"2c8e7eb0-d9f7-407e-9bb2-c5a75c2f8a82\",\n      \"logicalname\":\"sustainability_props_recycle_\",\n      \"translations\":{\n         \"nb_NO\":\"Resirkuleringssymbol\",\n         \"nn_NO\":\"Resirkuleringssymbol\",\n         \"sv_SE\":\"\xC5tervinning symbol\",\n         \"en_US\":\"Recycling symbol\",\n         \"da_DK\":\"Genbrugs symbol\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"01\",\n         \"02\",\n         \"03\",\n         \"04\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":86,\n      \"height\":84,\n      \"position\":4,\n      \"updated_at\":\"2021-10-20T14:18:26.805+00:00\"\n   },\n   {\n      \"id\":\"16d0f302-b6ae-4dca-abd1-047db54991f6\",\n      \"logicalname\":\"sustainability_props_solar-panel_\",\n      \"translations\":{\n         \"nb_NO\":\"Solpanel\",\n         \"nn_NO\":\"Solpanel\",\n         \"sv_SE\":\"Solpanel\",\n         \"en_US\":\"Solar panel\",\n         \"da_DK\":\"Solcelle\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"01\",\n         \"02\",\n         \"03\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":181,\n      \"height\":135,\n      \"position\":5,\n      \"updated_at\":\"2021-10-20T14:18:27.100+00:00\"\n   },\n   {\n      \"id\":\"dee4e5c8-5c38-4ed4-973a-37f50ba52b55\",\n      \"logicalname\":\"sustainability_props_whale_\",\n      \"translations\":{\n         \"nb_NO\":\"Hval\",\n         \"nn_NO\":\"Kval\",\n         \"sv_SE\":\"Val\",\n         \"en_US\":\"Whale\",\n         \"da_DK\":\"Hval\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"01\",\n         \"02\",\n         \"03\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":439,\n      \"height\":199,\n      \"position\":6,\n      \"updated_at\":\"2021-10-20T14:18:27.524+00:00\"\n   },\n   {\n      \"id\":\"2d88cbe7-0263-42fd-ac9c-44e28fba5b02\",\n      \"logicalname\":\"sustainability_props_plasticbottle_\",\n      \"translations\":{\n         \"nb_NO\":\"Plastflaske\",\n         \"nn_NO\":\"Plastflaske\",\n         \"sv_SE\":\"Plastflaska\",\n         \"en_US\":\"Plastic bottle\",\n         \"da_DK\":\"Plastikflaske\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"01\",\n         \"02\",\n         \"03\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":41,\n      \"height\":147,\n      \"position\":25,\n      \"updated_at\":\"2021-10-20T14:18:27.815+00:00\"\n   },\n   {\n      \"id\":\"22f64607-61bf-41fa-bce6-a6d065cd90ff\",\n      \"logicalname\":\"sustainability_props_salmon_\",\n      \"translations\":{\n         \"nb_NO\":\"Laks\",\n         \"nn_NO\":\"Laks\",\n         \"sv_SE\":\"Lax\",\n         \"en_US\":\"Salmon\",\n         \"da_DK\":\"Laks\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"01\",\n         \"02\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":154,\n      \"height\":56,\n      \"position\":26,\n      \"updated_at\":\"2021-10-20T14:18:28.103+00:00\"\n   },\n   {\n      \"id\":\"7a653854-6f4c-4ed2-9a89-03b20560ac38\",\n      \"logicalname\":\"sustainability_props_bat_flying_\",\n      \"translations\":{\n         \"nb_NO\":\"Flaggermus 01\",\n         \"nn_NO\":\"Flaggermus flygande\",\n         \"sv_SE\":\"Fladdermus 01\",\n         \"en_US\":\"Bat 01\",\n         \"da_DK\":\"Flagermus 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"01\",\n         \"02\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":702,\n      \"height\":395,\n      \"position\":30,\n      \"updated_at\":\"2021-10-20T14:18:28.395+00:00\"\n   },\n   {\n      \"id\":\"7d4c7159-d9b1-4f9f-987c-159717b0f0be\",\n      \"logicalname\":\"sustainability_props_bat_sleeping_\",\n      \"translations\":{\n         \"nb_NO\":\"Flaggermus 02\",\n         \"nn_NO\":\"Flaggermus sovande\",\n         \"sv_SE\":\"Fladdermus 02\",\n         \"en_US\":\"Bat 02\",\n         \"da_DK\":\"Flagermus 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"01\",\n         \"02\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":227,\n      \"height\":446,\n      \"position\":31,\n      \"updated_at\":\"2021-10-20T14:18:28.692+00:00\"\n   },\n   {\n      \"id\":\"9f7af6a2-9564-4ad2-b71d-9348374a7fa8\",\n      \"logicalname\":\"sustainability_props_virus_\",\n      \"translations\":{\n         \"nb_NO\":\"Virus\",\n         \"nn_NO\":\"Virus\",\n         \"sv_SE\":\"Virus\",\n         \"en_US\":\"Virus\",\n         \"da_DK\":\"Virus\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":468,\n      \"height\":472,\n      \"position\":33,\n      \"updated_at\":\"2021-10-20T14:18:29.088+00:00\"\n   },\n   {\n      \"id\":\"6fb03e5f-84a4-4a2f-ac6a-580fa9ee4a83\",\n      \"logicalname\":\"sustainability_props_facemask_\",\n      \"translations\":{\n         \"nb_NO\":\"Munnbind\",\n         \"nn_NO\":\"Ansiktsmaske\",\n         \"sv_SE\":\"Ansiktsmask\",\n         \"en_US\":\"Face mask\",\n         \"da_DK\":\"Ansigtsmaske\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":109,\n      \"height\":54,\n      \"position\":32,\n      \"updated_at\":\"2021-10-20T14:18:29.430+00:00\"\n   },\n   {\n      \"id\":\"c498da09-5af5-4ad0-a494-83fff4b90c50\",\n      \"logicalname\":\"sustainability_props_artificcial-meat_\",\n      \"translations\":{\n         \"nb_NO\":\"Kunstig kj\xF8tt\",\n         \"nn_NO\":\"Kunstig kj\xF8t\",\n         \"sv_SE\":\"Artificiellt k\xF6tt\",\n         \"en_US\":\"Artificial meat\",\n         \"da_DK\":\"Kunstigt k\xF8d\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":61,\n      \"height\":27,\n      \"position\":7,\n      \"updated_at\":\"2021-10-20T14:18:29.721+00:00\"\n   },\n   {\n      \"id\":\"64194d9e-5e68-4b0d-9ec8-694824147e69\",\n      \"logicalname\":\"sustainability_props_algae_food_\",\n      \"translations\":{\n         \"nb_NO\":\"Alger\",\n         \"nn_NO\":\"Algar\",\n         \"sv_SE\":\"Alger\",\n         \"en_US\":\"Algae\",\n         \"da_DK\":\"Alger\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":171,\n      \"height\":88,\n      \"position\":27,\n      \"updated_at\":\"2021-10-20T14:18:30.013+00:00\"\n   },\n   {\n      \"id\":\"5efe1b5d-1541-43ab-9438-747089d32850\",\n      \"logicalname\":\"sustainability_props_exhaust_\",\n      \"translations\":{\n         \"nb_NO\":\"Eksos\",\n         \"nn_NO\":\"Eksos\",\n         \"sv_SE\":\"Avgasr\xF6r\",\n         \"en_US\":\"Exhaust\",\n         \"da_DK\":\"Udst\xF8dning\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":585,\n      \"height\":404,\n      \"position\":28,\n      \"updated_at\":\"2021-10-20T14:18:30.319+00:00\"\n   },\n   {\n      \"id\":\"ddddc5fd-10c4-4984-8cee-ae1c0ff10195\",\n      \"logicalname\":\"sustainability_props_insect_food_\",\n      \"translations\":{\n         \"nb_NO\":\"Insekter\",\n         \"nn_NO\":\"Insekt\",\n         \"sv_SE\":\"Insekt\",\n         \"en_US\":\"Insect\",\n         \"da_DK\":\"Insekt\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":233,\n      \"height\":101,\n      \"position\":29,\n      \"updated_at\":\"2021-10-20T14:18:30.751+00:00\"\n   },\n   {\n      \"id\":\"3fdc804d-31e9-4b7f-bfc5-487bb533ee54\",\n      \"logicalname\":\"sustainability_props_car_01_\",\n      \"translations\":{\n         \"nb_NO\":\"Bensinbil 01\",\n         \"nn_NO\":\"Bensinbil 01\",\n         \"sv_SE\":\"Bensinbil 01\",\n         \"en_US\":\"Fossil fuel car 01\",\n         \"da_DK\":\"Benzinbil 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":367,\n      \"height\":111,\n      \"position\":8,\n      \"updated_at\":\"2021-10-20T14:18:31.083+00:00\"\n   },\n   {\n      \"id\":\"5ce2ffe2-95d4-4759-84aa-a8ce193d9aed\",\n      \"logicalname\":\"sustainability_props_car_02_\",\n      \"translations\":{\n         \"nb_NO\":\"Bensinbil 02\",\n         \"nn_NO\":\"Bensinbil 02\",\n         \"sv_SE\":\"Bensinbil 02\",\n         \"en_US\":\"Fossil fuel car 02\",\n         \"da_DK\":\"Benzinbil 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":287,\n      \"height\":125,\n      \"position\":9,\n      \"updated_at\":\"2021-10-20T14:18:31.389+00:00\"\n   },\n   {\n      \"id\":\"62b18867-a13b-459f-96ca-cb7ca0bed4af\",\n      \"logicalname\":\"sustainability_props_car_03_\",\n      \"translations\":{\n         \"nb_NO\":\"Elbil 01\",\n         \"nn_NO\":\"Elbil 01\",\n         \"sv_SE\":\"El-bil 01\",\n         \"en_US\":\"Electric car 01\",\n         \"da_DK\":\"Elbil 01\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":245,\n      \"height\":116,\n      \"position\":10,\n      \"updated_at\":\"2021-10-20T14:18:31.673+00:00\"\n   },\n   {\n      \"id\":\"6c5d3f8b-e797-4bfe-ae90-d88f2c417135\",\n      \"logicalname\":\"sustainability_props_car_04_\",\n      \"translations\":{\n         \"nb_NO\":\"Elbil 02\",\n         \"nn_NO\":\"Elbil 02\",\n         \"sv_SE\":\"El-bil 02\",\n         \"en_US\":\"Electric car 02\",\n         \"da_DK\":\"Elbil 02\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":239,\n      \"height\":105,\n      \"position\":11,\n      \"updated_at\":\"2021-10-20T14:18:32.064+00:00\"\n   },\n   {\n      \"id\":\"491001ff-7d6b-4616-b90d-ec67a55c730e\",\n      \"logicalname\":\"sustainability_props_fishing-boat_\",\n      \"translations\":{\n         \"nb_NO\":\"Fiskeb\xE5t\",\n         \"nn_NO\":\"Fiskeb\xE5t\",\n         \"sv_SE\":\"Fiskefartyg\",\n         \"en_US\":\"Fishing vessel\",\n         \"da_DK\":\"Fiskeb\xE5d\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":392,\n      \"height\":202,\n      \"position\":13,\n      \"updated_at\":\"2021-10-20T14:18:32.763+00:00\"\n   },\n   {\n      \"id\":\"d9cf36a1-cfc7-43c6-8fe5-aae2b40f44b6\",\n      \"logicalname\":\"sustainability_props_gasoline_\",\n      \"translations\":{\n         \"nb_NO\":\"Bensinfat\",\n         \"nn_NO\":\"Bensinfat\",\n         \"sv_SE\":\"Oljefat\",\n         \"en_US\":\"Gasoline drum\",\n         \"da_DK\":\"Benzin t\xF8nde\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":60,\n      \"height\":99,\n      \"position\":14,\n      \"updated_at\":\"2021-10-20T14:18:33.103+00:00\"\n   },\n   {\n      \"id\":\"11520d79-b6ef-4300-b9ee-4cb7b574c753\",\n      \"logicalname\":\"sustainability_props_happy-earth_\",\n      \"translations\":{\n         \"nb_NO\":\"Jordkloden (frisk)\",\n         \"nn_NO\":\"Jordkloden (frisk)\",\n         \"sv_SE\":\"Jorden (glad)\",\n         \"en_US\":\"Earth (healthy)\",\n         \"da_DK\":\"Jorden (sund)\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":296,\n      \"height\":293,\n      \"position\":15,\n      \"updated_at\":\"2021-10-20T14:18:33.430+00:00\"\n   },\n   {\n      \"id\":\"4382b4b5-de82-4dfe-851a-621ffe7b70be\",\n      \"logicalname\":\"sustainability_props_meat_\",\n      \"translations\":{\n         \"nb_NO\":\"Kj\xF8tt\",\n         \"nn_NO\":\"Kj\xF8t\",\n         \"sv_SE\":\"K\xF6tt\",\n         \"en_US\":\"Meat\",\n         \"da_DK\":\"K\xF8d\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":67,\n      \"height\":37,\n      \"position\":16,\n      \"updated_at\":\"2021-10-20T14:18:33.805+00:00\"\n   },\n   {\n      \"id\":\"62433fb2-8c51-45ed-9850-5236babbebf1\",\n      \"logicalname\":\"sustainability_props_oil_\",\n      \"translations\":{\n         \"nb_NO\":\"Oljefat\",\n         \"nn_NO\":\"Oljefat\",\n         \"sv_SE\":\"Oljetrumma\",\n         \"en_US\":\"Oil drum\",\n         \"da_DK\":\"Olie t\xF8nde\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":58,\n      \"height\":99,\n      \"position\":17,\n      \"updated_at\":\"2021-10-20T14:18:34.145+00:00\"\n   },\n   {\n      \"id\":\"301c76a4-019a-4081-9c84-7dc6aea54b30\",\n      \"logicalname\":\"sustainability_props_plane_\",\n      \"translations\":{\n         \"nb_NO\":\"Fly\",\n         \"nn_NO\":\"Fly\",\n         \"sv_SE\":\"Flygplan\",\n         \"en_US\":\"Airplane\",\n         \"da_DK\":\"Flyvemaskine\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":457,\n      \"height\":142,\n      \"position\":18,\n      \"updated_at\":\"2021-10-20T14:18:34.475+00:00\"\n   },\n   {\n      \"id\":\"f8fa86f6-2b4f-4f46-9d85-3b2ff7d24b09\",\n      \"logicalname\":\"sustainability_props_poison_\",\n      \"translations\":{\n         \"nb_NO\":\"T\xF8nne med giftig innhold\",\n         \"nn_NO\":\"T\xF8nne med giftig innhald\",\n         \"sv_SE\":\"Gifttrumma\",\n         \"en_US\":\"Poison drum\",\n         \"da_DK\":\"Gift t\xF8nde\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":59,\n      \"height\":99,\n      \"position\":19,\n      \"updated_at\":\"2021-10-20T14:18:34.813+00:00\"\n   },\n   {\n      \"id\":\"8455bb96-6360-48a8-8608-b9d456fa96e5\",\n      \"logicalname\":\"sustainability_props_sad-earth_\",\n      \"translations\":{\n         \"nb_NO\":\"Jordkloden (syk)\",\n         \"nn_NO\":\"Jordkloden (sjuk)\",\n         \"sv_SE\":\"Jorden (sjuk)\",\n         \"en_US\":\"Earth (sick)\",\n         \"da_DK\":\"Jorden (syg)\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":304,\n      \"height\":308,\n      \"position\":20,\n      \"updated_at\":\"2021-10-20T14:18:35.119+00:00\"\n   },\n   {\n      \"id\":\"084cfd57-2ef4-4378-987b-06c386b36175\",\n      \"logicalname\":\"sustainability_props_skeleton_\",\n      \"translations\":{\n         \"nb_NO\":\"Dyreskjelett\",\n         \"nn_NO\":\"Dyreskjelett\",\n         \"sv_SE\":\"Djurskelett\",\n         \"en_US\":\"Animal skeleton\",\n         \"da_DK\":\"Dyre skelet\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":220,\n      \"height\":97,\n      \"position\":21,\n      \"updated_at\":\"2021-10-20T14:18:35.414+00:00\"\n   },\n   {\n      \"id\":\"3437861e-61f8-4cb5-84b5-c3746758790a\",\n      \"logicalname\":\"sustainability_props_train_\",\n      \"translations\":{\n         \"nb_NO\":\"Tog\",\n         \"nn_NO\":\"Tog\",\n         \"sv_SE\":\"T\xE5g\",\n         \"en_US\":\"Train\",\n         \"da_DK\":\"Tog\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":1423,\n      \"height\":101,\n      \"position\":22,\n      \"updated_at\":\"2021-10-20T14:18:35.773+00:00\"\n   },\n   {\n      \"id\":\"2bb5f565-692a-4aa9-969c-5cbc1eb1ab83\",\n      \"logicalname\":\"sustainability_props_trunks_\",\n      \"translations\":{\n         \"nb_NO\":\"Trestammer\",\n         \"nn_NO\":\"Trestammar\",\n         \"sv_SE\":\"Tr\xE4dstammar\",\n         \"en_US\":\"Tree trunks\",\n         \"da_DK\":\"Tr\xE6stammer\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":396,\n      \"height\":151,\n      \"position\":23,\n      \"updated_at\":\"2021-10-20T14:18:36.097+00:00\"\n   },\n   {\n      \"id\":\"118d69fc-6f32-4297-b60a-ce7fdfcd3aa4\",\n      \"logicalname\":\"sustainability_props_vindmill_\",\n      \"translations\":{\n         \"nb_NO\":\"Vindm\xF8lle\",\n         \"nn_NO\":\"Vindm\xF8lle\",\n         \"sv_SE\":\"Vindkraftverk\",\n         \"en_US\":\"Windmill\",\n         \"da_DK\":\"Vindm\xF8lle\"\n      },\n      \"theme\":\"sustainable_development\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":156,\n      \"height\":291,\n      \"position\":24,\n      \"updated_at\":\"2021-10-20T14:18:36.398+00:00\"\n   }\n]"
	};
	module.exports = exports["default"];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/docs/newTheme.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/docs/newTheme.js"); } } })();

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.default = {
	   data: "[\n   {\n      \"id\":\"711297f6-2664-4176-bedb-46317ebb529b\",\n      \"logicalname\":\"Cartoonist_background_Middelalder_skog_\",\n      \"translations\":{\n         \"nb_NO\":\"Skog\",\n         \"sv_SE\":\"Skog\",\n         \"en_US\":\"Forest\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"dag\",\n         \"natt\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":600,\n      \"position\":3,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"3787a983-1b2b-4f0d-8ebf-81a30c37c224\",\n      \"logicalname\":\"content_image_2009.01.20.08.57.40_\",\n      \"translations\":{\n         \"nb_NO\":\"Hus\",\n         \"sv_SE\":\"Hus\",\n         \"en_US\":\"House\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"byhus\",\n         \"langhus\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":0,\n      \"height\":0,\n      \"position\":0,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"91107c71-21da-48ed-9644-d72f9c9c2a51\",\n      \"logicalname\":\"content_image_2008.12.10.16.31.17_\",\n      \"translations\":{\n         \"nb_NO\":\"Kniv\",\n         \"sv_SE\":\"Kniv\",\n         \"en_US\":\"Knife\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":0,\n      \"height\":0,\n      \"position\":0,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"e2facc97-a1be-466e-9602-afbd3264909d\",\n      \"logicalname\":\"content_image_2008.12.10.16.30.48_\",\n      \"translations\":{\n         \"nb_NO\":\"Bolle\",\n         \"sv_SE\":\"Sk\xE5l\",\n         \"en_US\":\"Bowl\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":0,\n      \"height\":0,\n      \"position\":0,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"37096a8c-9dad-40d6-bb2d-dd0dbb810a54\",\n      \"logicalname\":\"content_image_2008.12.10.16.29.27_\",\n      \"translations\":{\n         \"nb_NO\":\"Hund\",\n         \"fi_FI\":\"Koira\",\n         \"nn_NO\":\"Hund\",\n         \"sv_SE\":\"Hund\",\n         \"en_US\":\"Dog\",\n         \"da_DK\":\"Hund\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"animals\",\n      \"moods\":[\n         \"staar\",\n         \"ligger\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":247,\n      \"height\":155,\n      \"position\":1,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"1c2f4f7e-2213-46df-81fc-82c04db1a132\",\n      \"logicalname\":\"content_image_2009.01.20.08.56.59_\",\n      \"translations\":{\n         \"nb_NO\":\"Tigger bakfra\",\n         \"fi_FI\":\"Kerj\xE4l\xE4inen takaap\xE4in\",\n         \"nn_NO\":\"Tiggar bakfr\xE5\",\n         \"sv_SE\":\"Tiggare bakifr\xE5n\",\n         \"en_US\":\"Beggar backside view\",\n         \"da_DK\":\"Tigger bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":253,\n      \"height\":367,\n      \"position\":47,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"8c8558f9-db0b-407d-8f47-ad0ed9f805a6\",\n      \"logicalname\":\"ma_konge_sitter_trone_\",\n      \"translations\":{\n         \"nb_NO\":\"Konge p\xE5 trone\",\n         \"fi_FI\":\"Kuningas istuu valtaistuimella\",\n         \"nn_NO\":\"Konge p\xE5 trone\",\n         \"sv_SE\":\"Kung sittande p\xE5 tron\",\n         \"en_US\":\"King sitting on throne\",\n         \"da_DK\":\"Konge p\xE5 trone\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":231,\n      \"height\":354,\n      \"position\":48,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"6fd9dcdb-b9c1-44a0-a775-e83583e6c165\",\n      \"logicalname\":\"ma_konge_star_\",\n      \"translations\":{\n         \"nb_NO\":\"Konge st\xE5r\",\n         \"fi_FI\":\"Kuningas seisoo\",\n         \"nn_NO\":\"Konge st\xE5r\",\n         \"sv_SE\":\"Kung st\xE5ende\",\n         \"en_US\":\"King standing\",\n         \"da_DK\":\"Konge st\xE5ende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":264,\n      \"height\":408,\n      \"position\":49,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"ac0cd38f-1412-41f0-aff8-b1bd40e5c27c\",\n      \"logicalname\":\"content_image_2008.12.10.13.09.43_\",\n      \"translations\":{\n         \"nb_NO\":\"Bonde g\xE5r\",\n         \"fi_FI\":\"Talonpoika k\xE4velee\",\n         \"nn_NO\":\"Bonde g\xE5r\",\n         \"sv_SE\":\"Bonde g\xE5r\",\n         \"en_US\":\"Peasant walking\",\n         \"da_DK\":\"Bonde g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":190,\n      \"height\":344,\n      \"position\":0,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"0b1cc6fb-a435-40ac-a73f-19e035aaf9cb\",\n      \"logicalname\":\"content_image_2008.12.10.13.09.54_\",\n      \"translations\":{\n         \"nb_NO\":\"Bonde kneler\",\n         \"fi_FI\":\"Talonpoika polvistuu\",\n         \"nn_NO\":\"Bonde kneler\",\n         \"sv_SE\":\"Bonde kn\xE4b\xF6jer\",\n         \"en_US\":\"Peasant kneeling\",\n         \"da_DK\":\"Bonde kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":187,\n      \"height\":251,\n      \"position\":1,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"bdbf8354-2f98-4694-94ae-5162379bc912\",\n      \"logicalname\":\"content_image_2008.12.10.13.10.03_\",\n      \"translations\":{\n         \"nb_NO\":\"Bonde sitter\",\n         \"fi_FI\":\"Talonpoika istuu\",\n         \"nn_NO\":\"Bonde sit\",\n         \"sv_SE\":\"Bonde sitter\",\n         \"en_US\":\"Peasant sitting\",\n         \"da_DK\":\"Bonde sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":219,\n      \"height\":303,\n      \"position\":2,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"ad0e1798-c6d9-4e0b-9920-53aaa9fd0949\",\n      \"logicalname\":\"content_image_2008.12.10.13.10.15_\",\n      \"translations\":{\n         \"nb_NO\":\"Bonde st\xE5r\",\n         \"fi_FI\":\"Talonpoika seisoo\",\n         \"nn_NO\":\"Bonde st\xE5r\",\n         \"sv_SE\":\"Bonde st\xE5r\",\n         \"en_US\":\"Peasant standing\",\n         \"da_DK\":\"Bonde st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":186,\n      \"height\":355,\n      \"position\":3,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"b6b01a2d-6cc9-4d9c-ab2d-3d310549f156\",\n      \"logicalname\":\"content_image_2008.12.10.13.10.24_\",\n      \"translations\":{\n         \"nb_NO\":\"Bonde syk\",\n         \"fi_FI\":\"Talonpoika sairaana\",\n         \"nn_NO\":\"Bonde sjuk\",\n         \"sv_SE\":\"Bonde \xE4r sjuk\",\n         \"en_US\":\"Peasant sick\",\n         \"da_DK\":\"Bonde syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":360,\n      \"height\":181,\n      \"position\":4,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"a5acca2a-a087-4dc0-9970-05eb69f3ba18\",\n      \"logicalname\":\"content_image_2009.01.20.08.53.48_\",\n      \"translations\":{\n         \"nb_NO\":\"Bonde bakfra\",\n         \"fi_FI\":\"Talonpoika takaa\",\n         \"nn_NO\":\"Bonde bakfr\xE5\",\n         \"sv_SE\":\"Bonde bakifr\xE5n\",\n         \"en_US\":\"Peasant backside view\",\n         \"da_DK\":\"Bonde bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":163,\n      \"height\":334,\n      \"position\":5,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"e44417f0-1d25-434f-ab06-718b6edf8d57\",\n      \"logicalname\":\"content_image_2008.12.10.13.10.45_\",\n      \"translations\":{\n         \"nb_NO\":\"Bondebarn g\xE5r\",\n         \"fi_FI\":\"Maalaislapsi k\xE4velee\",\n         \"nn_NO\":\"Bondebarn g\xE5r\",\n         \"sv_SE\":\"Bondbarn g\xE5r\",\n         \"en_US\":\"Peasant child walking\",\n         \"da_DK\":\"Bondebarn g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":123,\n      \"height\":215,\n      \"position\":6,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"d6ef3e8d-d921-4333-b258-a864307e4f76\",\n      \"logicalname\":\"content_image_2008.12.10.13.10.55_\",\n      \"translations\":{\n         \"nb_NO\":\"Bondebarn l\xF8per\",\n         \"fi_FI\":\"Maalaislapsi juoksee\",\n         \"nn_NO\":\"Bondebarn spring\",\n         \"sv_SE\":\"Bondebarn springer\",\n         \"en_US\":\"Peasant child running\",\n         \"da_DK\":\"Bondebarn l\xF8ber\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":159,\n      \"height\":213,\n      \"position\":7,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"3106759a-ccc3-4582-937c-5a3867d17825\",\n      \"logicalname\":\"content_image_2008.12.10.13.11.03_\",\n      \"translations\":{\n         \"nb_NO\":\"Bondebarn sitter\",\n         \"fi_FI\":\"Maalaislapsi istuu\",\n         \"nn_NO\":\"Bondebarn sit\",\n         \"sv_SE\":\"Bondbarn sitter\",\n         \"en_US\":\"Peasant child sitting\",\n         \"da_DK\":\"Bondebarn sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":132,\n      \"height\":193,\n      \"position\":8,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"e1e692b9-7690-40c8-b082-b24913580267\",\n      \"logicalname\":\"content_image_2008.12.10.13.11.13_\",\n      \"translations\":{\n         \"nb_NO\":\"Bondebarn st\xE5r\",\n         \"fi_FI\":\"Maalaislapsi seisoo\",\n         \"nn_NO\":\"Bondebarn st\xE5r\",\n         \"sv_SE\":\"Bondbarn st\xE5r\",\n         \"en_US\":\"Peasant child standing\",\n         \"da_DK\":\"Bondebarn st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":149,\n      \"height\":222,\n      \"position\":9,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"9deb91e3-1c95-4f20-a559-2fe795fdc190\",\n      \"logicalname\":\"content_image_2008.12.10.13.11.24_\",\n      \"translations\":{\n         \"nb_NO\":\"Bondebarn syk\",\n         \"fi_FI\":\"Maalaislapsi sairaana\",\n         \"nn_NO\":\"Bondebarn sjuk\",\n         \"sv_SE\":\"Bondbarn \xE4r sjuk\",\n         \"en_US\":\"Peasant child sick\",\n         \"da_DK\":\"Bondebarn syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":213,\n      \"height\":104,\n      \"position\":10,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"24056986-e97f-488b-a61e-f96d03236c26\",\n      \"logicalname\":\"content_image_2009.01.20.08.53.59_\",\n      \"translations\":{\n         \"nb_NO\":\"Bondebarn bakfra\",\n         \"fi_FI\":\"Maalaislapsi takaap\xE4in\",\n         \"nn_NO\":\"Bondebarn bakfr\xE5\",\n         \"sv_SE\":\"Bondbarn bakifr\xE5n\",\n         \"en_US\":\"Peasant child backside view\",\n         \"da_DK\":\"Bondebarn bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"loeper\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":123,\n      \"height\":221,\n      \"position\":11,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"27874da9-11e8-4998-a127-b68709609c36\",\n      \"logicalname\":\"content_image_2008.12.10.13.11.41_\",\n      \"translations\":{\n         \"nb_NO\":\"Bondekone g\xE5r\",\n         \"fi_FI\":\"Maalaisnainen k\xE4velee\",\n         \"nn_NO\":\"Bondekone g\xE5r\",\n         \"sv_SE\":\"Bondhustru g\xE5r\",\n         \"en_US\":\"Peasant woman walking\",\n         \"da_DK\":\"Bondekone g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":237,\n      \"height\":355,\n      \"position\":12,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"054060fc-5188-411e-a079-65fabe68ccb9\",\n      \"logicalname\":\"Cartoonist_background_Middelalder_hus_int_\",\n      \"translations\":{\n         \"nb_NO\":\"Hus inne\",\n         \"fi_FI\":\"Talo sis\xE4lt\xE4\",\n         \"nn_NO\":\"Hus inne\",\n         \"sv_SE\":\"Hus insida\",\n         \"en_US\":\"House - inside\",\n         \"da_DK\":\"Hus inde\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"dag\",\n         \"natt\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":600,\n      \"position\":0,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"751bcad8-0efa-41ff-b3b9-07bb6a0924a1\",\n      \"logicalname\":\"Cartoonist_background_Middelalder_kloster_ext_\",\n      \"translations\":{\n         \"nb_NO\":\"Kloster\",\n         \"fi_FI\":\"Luostari\",\n         \"nn_NO\":\"Kloster\",\n         \"sv_SE\":\"Kloster\",\n         \"en_US\":\"Monastery\",\n         \"da_DK\":\"Kloster\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"dag\",\n         \"natt\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":600,\n      \"position\":1,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"75e80d2e-362d-4089-b490-cd54157eaf48\",\n      \"logicalname\":\"Cartoonist_background_Middelalder_by_ext_\",\n      \"translations\":{\n         \"nb_NO\":\"Middeladerby\",\n         \"fi_FI\":\"Keskiaikainen kaupunki\",\n         \"nn_NO\":\"Middelalderby\",\n         \"sv_SE\":\"Medeltidsstad\",\n         \"en_US\":\"Middle Ages town\",\n         \"da_DK\":\"Middelalderby\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"dag\",\n         \"natt\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":600,\n      \"position\":2,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"257cdf03-e81c-4b4e-9aee-1b44e02d3fd4\",\n      \"logicalname\":\"Cartoonist_background_Middelalder_murvegg_\",\n      \"translations\":{\n         \"nb_NO\":\"Murvegg\",\n         \"fi_FI\":\"Kivisein\xE4\",\n         \"nn_NO\":\"Murvegg\",\n         \"sv_SE\":\"Murad v\xE4gg\",\n         \"en_US\":\"Stone wall\",\n         \"da_DK\":\"Stenmur\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"dag\",\n         \"natt\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":600,\n      \"position\":3,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"15fd8686-178f-4a67-90cf-3922d59d7610\",\n      \"logicalname\":\"Cartoonist_background_Middelalder_Sthalvard_int_\",\n      \"translations\":{\n         \"nb_NO\":\"St Halvard kirke\",\n         \"fi_FI\":\"Pyh\xE4n Halvardin kirkko\",\n         \"nn_NO\":\"St Halvards kyrkje\",\n         \"sv_SE\":\"St Halvard kyrka\",\n         \"en_US\":\"St. Halvard's church\",\n         \"da_DK\":\"St. Halvard kirke\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"dag\",\n         \"natt\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":600,\n      \"position\":4,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"5bb350ab-f154-4a59-b440-0171462b7dd5\",\n      \"logicalname\":\"Cartoonist_background_Middelalder_torg_\",\n      \"translations\":{\n         \"nb_NO\":\"Torg\",\n         \"fi_FI\":\"Aukio\",\n         \"nn_NO\":\"Torg\",\n         \"sv_SE\":\"Torg\",\n         \"en_US\":\"Square\",\n         \"da_DK\":\"Torv\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"dag\",\n         \"natt\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":600,\n      \"position\":5,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"5dc7c61c-e691-4271-9e73-73caf3abbd1a\",\n      \"logicalname\":\"Cartoonist_background_Middelalder_landsbygd_\",\n      \"translations\":{\n         \"nb_NO\":\"Landsbygd\",\n         \"fi_FI\":\"Maaseutu\",\n         \"nn_NO\":\"Landsbygd\",\n         \"sv_SE\":\"Landsbygd\",\n         \"en_US\":\"Countryside\",\n         \"da_DK\":\"Landsby\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"dag\",\n         \"natt\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":600,\n      \"position\":6,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"e27ef7f0-8e5b-40c1-92bf-da27e1ca8ec6\",\n      \"logicalname\":\"cartoonist_background_ma_borg_\",\n      \"translations\":{\n         \"nb_NO\":\"Borg\",\n         \"fi_FI\":\"Linna\",\n         \"nn_NO\":\"Borg\",\n         \"sv_SE\":\"Slott\",\n         \"en_US\":\"Castle\",\n         \"da_DK\":\"Slot\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"dag\",\n         \"natt\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":600,\n      \"position\":7,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"41474f67-41d3-4bef-b4e9-bd4bcf5dbf40\",\n      \"logicalname\":\"cartoonist_background_ma_borggard_\",\n      \"translations\":{\n         \"nb_NO\":\"G\xE5rdsplass\",\n         \"fi_FI\":\"Piha\",\n         \"nn_NO\":\"Gardsplass\",\n         \"sv_SE\":\"G\xE5rd\",\n         \"en_US\":\"Courtyard\",\n         \"da_DK\":\"G\xE5rdsplads\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"dag\",\n         \"natt\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":600,\n      \"position\":8,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"93abc9ca-b841-4a6b-a1a8-64316a1a5ca1\",\n      \"logicalname\":\"cartoonist_background_ma_tronsal_\",\n      \"translations\":{\n         \"nb_NO\":\"Tronsal\",\n         \"fi_FI\":\"Valtaistuinsali\",\n         \"nn_NO\":\"Tronsal\",\n         \"sv_SE\":\"Tronrum\",\n         \"en_US\":\"Throne room\",\n         \"da_DK\":\"Tronsal\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"backgrounds\",\n      \"moods\":[\n         \"dag\",\n         \"natt\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":800,\n      \"height\":600,\n      \"position\":9,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"778b67ee-7b70-482e-9e64-66668c1e6fb6\",\n      \"logicalname\":\"content_image_2008.12.10.13.11.49_\",\n      \"translations\":{\n         \"nb_NO\":\"Bondekone kneler\",\n         \"fi_FI\":\"Maalaisnainen polvistuu\",\n         \"nn_NO\":\"Bondekone kneler\",\n         \"sv_SE\":\"Bondhustru kn\xE4b\xF6jer\",\n         \"en_US\":\"Peasant woman kneeling\",\n         \"da_DK\":\"Bondekone kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":188,\n      \"height\":265,\n      \"position\":13,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"85df620a-72cb-4326-bdc9-f3f7adcf4f6a\",\n      \"logicalname\":\"content_image_2008.12.10.13.08.31_\",\n      \"translations\":{\n         \"nb_NO\":\"Adelskvinne syk\",\n         \"fi_FI\":\"Aatelisnainen sairaana\",\n         \"nn_NO\":\"Adelskvinne sjuk\",\n         \"sv_SE\":\"Adelskvinna \xE4r sjuk\",\n         \"en_US\":\"Noblewoman sick\",\n         \"da_DK\":\"Adelskvinde syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":340,\n      \"height\":143,\n      \"position\":4,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"20543d40-9fb0-47c7-9a14-24cbbdf56137\",\n      \"logicalname\":\"content_image_2008.12.10.13.11.56_\",\n      \"translations\":{\n         \"nb_NO\":\"Bondekone sitter\",\n         \"fi_FI\":\"Maalaisnainen istuu\",\n         \"nn_NO\":\"Bondekone sit\",\n         \"sv_SE\":\"Bondhustru sitter\",\n         \"en_US\":\"Peasant woman sitting\",\n         \"da_DK\":\"Bondekone sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":194,\n      \"height\":328,\n      \"position\":14,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"530f33c8-e97f-45c4-abfa-220bf0e33d0d\",\n      \"logicalname\":\"content_image_2008.12.10.13.01.09_\",\n      \"translations\":{\n         \"nb_NO\":\"Adelskvinne g\xE5r\",\n         \"fi_FI\":\"Aatelisnainen k\xE4velee\",\n         \"nn_NO\":\"Adelskvinne g\xE5r\",\n         \"sv_SE\":\"Adelskvinna g\xE5r\",\n         \"en_US\":\"Noblewoman walking\",\n         \"da_DK\":\"Adelskvinde g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":196,\n      \"height\":338,\n      \"position\":0,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"46cd8261-3d43-42dd-b6a2-0b332b5c6155\",\n      \"logicalname\":\"content_image_2008.12.10.13.07.58_\",\n      \"translations\":{\n         \"nb_NO\":\"Adelskvinne kneler\",\n         \"fi_FI\":\"Aatelisnainen polvistuu\",\n         \"nn_NO\":\"Adelskvinne kneler\",\n         \"sv_SE\":\"Adelskvinna kn\xE4b\xF6jer\",\n         \"en_US\":\"Noblewoman kneeling\",\n         \"da_DK\":\"Adelskvinde kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":184,\n      \"height\":278,\n      \"position\":1,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"1885f7b4-6d62-4bd9-8c60-c63a735912c8\",\n      \"logicalname\":\"content_image_2008.12.10.13.08.10_\",\n      \"translations\":{\n         \"nb_NO\":\"Adelskvinne sitter\",\n         \"fi_FI\":\"Aatelisnainen istuu\",\n         \"nn_NO\":\"Adelskvinne sit\",\n         \"sv_SE\":\"Adelskvinna sitter\",\n         \"en_US\":\"Noblewoman sitting\",\n         \"da_DK\":\"Adelskvinde sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":167,\n      \"height\":297,\n      \"position\":2,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"6b3bd9d7-59aa-4b92-addc-85bb3f5c47ed\",\n      \"logicalname\":\"content_image_2008.12.10.13.08.20_\",\n      \"translations\":{\n         \"nb_NO\":\"Adelskvinne st\xE5r\",\n         \"fi_FI\":\"Aatelisnainen seisoo\",\n         \"nn_NO\":\"Adelskvinne st\xE5r\",\n         \"sv_SE\":\"Adelskvinna st\xE5r\",\n         \"en_US\":\"Noblewoman standing\",\n         \"da_DK\":\"Adelskvinde st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":201,\n      \"height\":337,\n      \"position\":3,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"bc75bd2e-a50c-4fcf-be73-ed9b212e8b7b\",\n      \"logicalname\":\"content_image_2009.01.20.08.53.11_\",\n      \"translations\":{\n         \"nb_NO\":\"Adelskvinne bakfra\",\n         \"fi_FI\":\"Aatelisnainen takaa\",\n         \"nn_NO\":\"Adelskvinne bakfr\xE5\",\n         \"sv_SE\":\"Adelskvinna bakifr\xE5n\",\n         \"en_US\":\"Noblewoman backside view\",\n         \"da_DK\":\"Adelskvinde bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":145,\n      \"height\":319,\n      \"position\":5,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"a76e1397-578c-4463-bfa2-67d1f134fe2f\",\n      \"logicalname\":\"content_image_2008.12.10.13.08.45_\",\n      \"translations\":{\n         \"nb_NO\":\"Adelsmann g\xE5r\",\n         \"fi_FI\":\"Aatelismies k\xE4velee\",\n         \"nn_NO\":\"Adelsmann g\xE5r\",\n         \"sv_SE\":\"Adelsman g\xE5r\",\n         \"en_US\":\"Nobleman walking\",\n         \"da_DK\":\"Adelsmand g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":213,\n      \"height\":370,\n      \"position\":6,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"101c484c-cef2-4238-b791-9a6f70d5fd28\",\n      \"logicalname\":\"content_image_2008.12.10.13.08.54_\",\n      \"translations\":{\n         \"nb_NO\":\"Adelsmann kneler\",\n         \"fi_FI\":\"Aatelismies polvistuu\",\n         \"nn_NO\":\"Adelsmann kneler\",\n         \"sv_SE\":\"Adelsman kn\xE4b\xF6jer\",\n         \"en_US\":\"Nobleman kneeling\",\n         \"da_DK\":\"Adelsmand kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":233,\n      \"height\":309,\n      \"position\":7,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"01c7001c-e4d4-4876-8006-134d1d1430dd\",\n      \"logicalname\":\"content_image_2008.12.10.13.09.01_\",\n      \"translations\":{\n         \"nb_NO\":\"Adelsmann sitter\",\n         \"fi_FI\":\"Aatelismies istuu\",\n         \"nn_NO\":\"Adelsmann sit\",\n         \"sv_SE\":\"Adelsman sitter\",\n         \"en_US\":\"Nobleman sitting\",\n         \"da_DK\":\"Adelsmand sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":214,\n      \"height\":326,\n      \"position\":8,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"efa11fbf-ceaf-495b-949a-7561e28c6fdd\",\n      \"logicalname\":\"content_image_2008.12.10.13.09.12_\",\n      \"translations\":{\n         \"nb_NO\":\"Adelsmann st\xE5r\",\n         \"fi_FI\":\"Aatelismies seisoo\",\n         \"nn_NO\":\"Adelsmann st\xE5r\",\n         \"sv_SE\":\"Adelsman st\xE5r\",\n         \"en_US\":\"Nobleman standing\",\n         \"da_DK\":\"Adelsmand st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":283,\n      \"height\":381,\n      \"position\":9,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"acc568ff-afad-4058-8865-f94a6a765a7c\",\n      \"logicalname\":\"content_image_2008.12.10.13.09.21_\",\n      \"translations\":{\n         \"nb_NO\":\"Adelsmann syk\",\n         \"fi_FI\":\"Aatelismies sairaana\",\n         \"nn_NO\":\"Adelsmann sjuk\",\n         \"sv_SE\":\"Adelsman \xE4r sjuk\",\n         \"en_US\":\"Nobleman sick\",\n         \"da_DK\":\"Adelsmand syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":364,\n      \"height\":132,\n      \"position\":10,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"32a583d1-f16d-4b73-8628-c6805aac155c\",\n      \"logicalname\":\"content_image_2009.01.20.08.53.37_\",\n      \"translations\":{\n         \"nb_NO\":\"Adelsmann bakfra\",\n         \"fi_FI\":\"Aatelismies takaap\xE4in\",\n         \"nn_NO\":\"Adelsmann bakfr\xE5\",\n         \"sv_SE\":\"Adelsman bakifr\xE5n\",\n         \"en_US\":\"Nobleman backside view\",\n         \"da_DK\":\"Adelsmand bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":223,\n      \"height\":372,\n      \"position\":11,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"8e290853-31a4-4bbc-b52c-0c12ab969830\",\n      \"logicalname\":\"content_image_2008.12.10.13.12.34_\",\n      \"translations\":{\n         \"nb_NO\":\"Borger g\xE5r\",\n         \"fi_FI\":\"Porvari k\xE4velee\",\n         \"nn_NO\":\"Borgar g\xE5r\",\n         \"sv_SE\":\"Borgare g\xE5r\",\n         \"en_US\":\"Townsman walking\",\n         \"da_DK\":\"Borger g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":207,\n      \"height\":358,\n      \"position\":12,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"7f823292-62ab-4a68-8a05-9b1d27bf651f\",\n      \"logicalname\":\"content_image_2008.12.10.13.12.41_\",\n      \"translations\":{\n         \"nb_NO\":\"Borger kneler\",\n         \"fi_FI\":\"Porvari polvistuu\",\n         \"nn_NO\":\"Borgar kneler\",\n         \"sv_SE\":\"Borgare kn\xE4b\xF6jer\",\n         \"en_US\":\"Townsman kneeling\",\n         \"da_DK\":\"Borger kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":234,\n      \"height\":286,\n      \"position\":13,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"44acb9e8-2d58-4dde-ae0d-601984440f94\",\n      \"logicalname\":\"content_image_2008.12.10.13.12.50_\",\n      \"translations\":{\n         \"nb_NO\":\"Borger sitter\",\n         \"fi_FI\":\"Porvari istuu\",\n         \"nn_NO\":\"Borger sit\",\n         \"sv_SE\":\"Borgare sitter\",\n         \"en_US\":\"Townsman sitting\",\n         \"da_DK\":\"Borger sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":184,\n      \"height\":335,\n      \"position\":14,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"c0f7f55b-d198-416b-a8be-567ebe35b11c\",\n      \"logicalname\":\"content_image_2008.12.10.13.12.57_\",\n      \"translations\":{\n         \"nb_NO\":\"Borger st\xE5r\",\n         \"fi_FI\":\"Porvari seisoo\",\n         \"nn_NO\":\"Borgar st\xE5r\",\n         \"sv_SE\":\"Borgare st\xE5r\",\n         \"en_US\":\"Townsman standing\",\n         \"da_DK\":\"Borger st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":198,\n      \"height\":369,\n      \"position\":15,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"3d7ca30c-68c2-44d3-b5e4-a32ab05ed0a1\",\n      \"logicalname\":\"content_image_2008.12.10.13.13.05_\",\n      \"translations\":{\n         \"nb_NO\":\"Borger syk\",\n         \"fi_FI\":\"Porvari sairaana\",\n         \"nn_NO\":\"Borgar sjuk\",\n         \"sv_SE\":\"Borgare \xE4r sjuk\",\n         \"en_US\":\"Townsman sick\",\n         \"da_DK\":\"Borger syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":344,\n      \"height\":213,\n      \"position\":16,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"da83266b-1402-430b-a4b7-98ab757b5d54\",\n      \"logicalname\":\"content_image_2009.01.20.08.54.24_\",\n      \"translations\":{\n         \"nb_NO\":\"Borger bakfra\",\n         \"fi_FI\":\"Porvari takaap\xE4in\",\n         \"nn_NO\":\"Borgar bakfr\xE5\",\n         \"sv_SE\":\"Borgare \xE4r bakifr\xE5n\",\n         \"en_US\":\"Townsman back view\",\n         \"da_DK\":\"Borger bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":188,\n      \"height\":366,\n      \"position\":17,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"587860f4-7f18-433e-94c5-1dbd0bf36314\",\n      \"logicalname\":\"content_image_2008.12.10.13.13.23_\",\n      \"translations\":{\n         \"nb_NO\":\"Borgerkvinne g\xE5r\",\n         \"fi_FI\":\"Porvarisnainen k\xE4velee\",\n         \"nn_NO\":\"Borgarkvinne g\xE5r\",\n         \"sv_SE\":\"Borgarkvinna g\xE5r\",\n         \"en_US\":\"Townswoman walking\",\n         \"da_DK\":\"Borgerkvinde g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":207,\n      \"height\":333,\n      \"position\":18,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"3ea6ca7e-0d0a-4fd1-a95c-0fd0bfa1c6de\",\n      \"logicalname\":\"content_image_2008.12.10.13.13.41_\",\n      \"translations\":{\n         \"nb_NO\":\"Borgerkvinne kneler\",\n         \"fi_FI\":\"Porvarisnainen polvistuu\",\n         \"nn_NO\":\"Borgarkvinne kneler\",\n         \"sv_SE\":\"Borgarkvinna kn\xE4b\xF6jer\",\n         \"en_US\":\"Townswoman kneeling\",\n         \"da_DK\":\"Borgerkvinde kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":190,\n      \"height\":298,\n      \"position\":19,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"54c01541-b352-48d1-adc2-010101aa9456\",\n      \"logicalname\":\"content_image_2008.12.10.13.13.48_\",\n      \"translations\":{\n         \"nb_NO\":\"Borgerkvinne sitter\",\n         \"fi_FI\":\"Porvarisnainen istuu\",\n         \"nn_NO\":\"Borgarkvinne sit\",\n         \"sv_SE\":\"Borgarkvinna sitter\",\n         \"en_US\":\"Townswoman sitting\",\n         \"da_DK\":\"Borgerkvinde sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":190,\n      \"height\":288,\n      \"position\":20,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"cbb67355-db5a-4d27-9307-8e405b06d723\",\n      \"logicalname\":\"content_image_2008.12.10.13.13.56_\",\n      \"translations\":{\n         \"nb_NO\":\"Borgerkvinne st\xE5r\",\n         \"fi_FI\":\"Porvarisnainen seisoo\",\n         \"nn_NO\":\"Borgarkvinne st\xE5r\",\n         \"sv_SE\":\"Borgarkvinna st\xE5r\",\n         \"en_US\":\"Townswoman standing\",\n         \"da_DK\":\"Borgerkvinde st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":219,\n      \"height\":330,\n      \"position\":21,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"b7346f68-93c4-471a-a4f2-42375f392b2e\",\n      \"logicalname\":\"content_image_2008.12.10.13.14.05_\",\n      \"translations\":{\n         \"nb_NO\":\"Borgerkvinne syk\",\n         \"fi_FI\":\"Porvarisnainen sairaana\",\n         \"nn_NO\":\"Borgarkvinne sjuk\",\n         \"sv_SE\":\"Borgarkvinna sjuk\",\n         \"en_US\":\"Townswoman sick\",\n         \"da_DK\":\"Borgerkvinde syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":337,\n      \"height\":164,\n      \"position\":22,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"59d73ffa-6188-4c6b-8e7b-fb3b1bc03243\",\n      \"logicalname\":\"content_image_2009.01.20.08.54.39_\",\n      \"translations\":{\n         \"nb_NO\":\"Borgerkvinne bakfra\",\n         \"fi_FI\":\"Porvarisnainen takaa\",\n         \"nn_NO\":\"Borgarkvinne bakfr\xE5\",\n         \"sv_SE\":\"Borgarkvinna bakifr\xE5n\",\n         \"en_US\":\"Townswoman backside view\",\n         \"da_DK\":\"Borgerkvinde bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":184,\n      \"height\":330,\n      \"position\":23,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"a9494ca5-ae3a-45a1-9ec8-dc1884a04a35\",\n      \"logicalname\":\"content_image_2008.12.10.13.14.33_\",\n      \"translations\":{\n         \"nb_NO\":\"H\xE5ndverker g\xE5r\",\n         \"fi_FI\":\"K\xE4sity\xF6l\xE4inen k\xE4velee\",\n         \"nn_NO\":\"Handverkar g\xE5r\",\n         \"sv_SE\":\"Hantverkare g\xE5r\",\n         \"en_US\":\"Artisan walking\",\n         \"da_DK\":\"H\xE5ndv\xE6rker g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":241,\n      \"height\":364,\n      \"position\":24,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"e8820426-036f-486b-91fa-d793da68cf59\",\n      \"logicalname\":\"content_image_2008.12.10.13.14.44_\",\n      \"translations\":{\n         \"nb_NO\":\"H\xE5ndverker kneler\",\n         \"fi_FI\":\"K\xE4sity\xF6l\xE4inen polvistuu\",\n         \"nn_NO\":\"Handverkar kneler\",\n         \"sv_SE\":\"Hantverkare kn\xE4b\xF6jer\",\n         \"en_US\":\"Artisan kneeling\",\n         \"da_DK\":\"H\xE5ndv\xE6rker kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":219,\n      \"height\":307,\n      \"position\":25,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"3377335c-587a-4445-94d2-2bc96c6f02b3\",\n      \"logicalname\":\"content_image_2008.12.10.13.14.56_\",\n      \"translations\":{\n         \"nb_NO\":\"H\xE5ndverker sitter\",\n         \"fi_FI\":\"K\xE4sity\xF6l\xE4inen istuu\",\n         \"nn_NO\":\"Handverkar sit\",\n         \"sv_SE\":\"Hantverkare sitter\",\n         \"en_US\":\"Artisan sitting\",\n         \"da_DK\":\"H\xE5ndv\xE6rker sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":188,\n      \"height\":331,\n      \"position\":26,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"9d700d8d-6f2d-47e0-aba1-d9614b3ddc90\",\n      \"logicalname\":\"content_image_2008.12.10.13.15.07_\",\n      \"translations\":{\n         \"nb_NO\":\"H\xE5ndverker st\xE5r\",\n         \"fi_FI\":\"K\xE4sity\xF6l\xE4inen seisoo\",\n         \"nn_NO\":\"Handverkar st\xE5r\",\n         \"sv_SE\":\"Hantverkare st\xE5r\",\n         \"en_US\":\"Artisan standing\",\n         \"da_DK\":\"H\xE5ndv\xE6rker st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":196,\n      \"height\":365,\n      \"position\":27,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"52a3f49c-cf8b-452a-90d7-408246743b9d\",\n      \"logicalname\":\"content_image_2008.12.10.13.15.20_\",\n      \"translations\":{\n         \"nb_NO\":\"H\xE5ndverker syk\",\n         \"fi_FI\":\"K\xE4sity\xF6l\xE4inen sairaana\",\n         \"nn_NO\":\"Handverkar sjuk\",\n         \"sv_SE\":\"Hantverkare \xE4r sjuk\",\n         \"en_US\":\"Artisan sick\",\n         \"da_DK\":\"H\xE5ndv\xE6rker syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":362,\n      \"height\":174,\n      \"position\":28,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"06a4900b-97b3-49d3-a233-457e1523f22e\",\n      \"logicalname\":\"content_image_2009.01.20.08.54.53_\",\n      \"translations\":{\n         \"nb_NO\":\"H\xE5ndverker bakfra\",\n         \"fi_FI\":\"K\xE4sity\xF6l\xE4inen takaa\",\n         \"nn_NO\":\"Handverkar bakfr\xE5\",\n         \"sv_SE\":\"Hantverkare bakifr\xE5n\",\n         \"en_US\":\"Artisan backside view\",\n         \"da_DK\":\"H\xE5ndv\xE6rker bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":218,\n      \"height\":356,\n      \"position\":29,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"e57e4464-f2f2-4e96-9760-8e182db28284\",\n      \"logicalname\":\"content_image_2008.12.10.13.15.42_\",\n      \"translations\":{\n         \"nb_NO\":\"Kj\xF8pmann g\xE5r\",\n         \"fi_FI\":\"Kauppias k\xE4velee\",\n         \"nn_NO\":\"Kj\xF8pmann g\xE5r\",\n         \"sv_SE\":\"K\xF6pman g\xE5r\",\n         \"en_US\":\"Merchant walking\",\n         \"da_DK\":\"K\xF8bmand g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":196,\n      \"height\":301,\n      \"position\":30,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"7e061ba6-5969-4df5-9d95-50b9e31d27ca\",\n      \"logicalname\":\"content_image_2008.12.10.13.15.49_\",\n      \"translations\":{\n         \"nb_NO\":\"Kj\xF8pmann kneler\",\n         \"fi_FI\":\"Kauppias polvistuu\",\n         \"nn_NO\":\"Kj\xF8pmann kneler\",\n         \"sv_SE\":\"K\xF6pman kn\xE4b\xF6jer\",\n         \"en_US\":\"Merchant kneeling\",\n         \"da_DK\":\"K\xF8bmand kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":222,\n      \"height\":249,\n      \"position\":31,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"f2cedfb4-9709-4528-99f2-db3c2b2aa16e\",\n      \"logicalname\":\"content_image_2008.12.10.13.15.56_\",\n      \"translations\":{\n         \"nb_NO\":\"Kj\xF8pmann sitter\",\n         \"fi_FI\":\"Kauppias istuu\",\n         \"nn_NO\":\"Kj\xF8pmann sit\",\n         \"sv_SE\":\"K\xF6pman sitter\",\n         \"en_US\":\"Merchant sitting\",\n         \"da_DK\":\"K\xF8bmand sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":195,\n      \"height\":280,\n      \"position\":32,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"bf80d48e-0147-4902-befe-84042cdba0ac\",\n      \"logicalname\":\"content_image_2008.12.10.13.16.04_\",\n      \"translations\":{\n         \"nb_NO\":\"Kj\xF8pmann st\xE5r\",\n         \"fi_FI\":\"Kauppias seisoo\",\n         \"nn_NO\":\"Kj\xF8pmann st\xE5r\",\n         \"sv_SE\":\"K\xF6pman st\xE5r\",\n         \"en_US\":\"Merchant standing\",\n         \"da_DK\":\"K\xF8bmand st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":214,\n      \"height\":296,\n      \"position\":33,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"460f4385-abef-475b-b4ce-954ac04306f3\",\n      \"logicalname\":\"ma_tre_\",\n      \"translations\":{\n         \"nb_NO\":\"Tre\",\n         \"fi_FI\":\"Tree\",\n         \"nn_NO\":\"Tre\",\n         \"sv_SE\":\"Tre\",\n         \"en_US\":\"Tree\",\n         \"da_DK\":\"Tree\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":384,\n      \"height\":529,\n      \"position\":24,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"03187add-8168-4c40-b5de-b4edba747266\",\n      \"logicalname\":\"ma_trone_\",\n      \"translations\":{\n         \"nb_NO\":\"Trone\",\n         \"fi_FI\":\"Valtaistuin\",\n         \"nn_NO\":\"Trone\",\n         \"sv_SE\":\"Tron\",\n         \"en_US\":\"Throne\",\n         \"da_DK\":\"Trone\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":235,\n      \"height\":408,\n      \"position\":25,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"d993f550-90f3-4cf6-8fde-f8dfee6d5de8\",\n      \"logicalname\":\"content_image_2008.12.10.13.16.11_\",\n      \"translations\":{\n         \"nb_NO\":\"Kj\xF8pmann syk\",\n         \"fi_FI\":\"Kauppias sairaana\",\n         \"nn_NO\":\"Kj\xF8pmann syk\",\n         \"sv_SE\":\"K\xF6pman sjuk\",\n         \"en_US\":\"Merchant sick\",\n         \"da_DK\":\"K\xF8bmand syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":294,\n      \"height\":99,\n      \"position\":34,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"f188631a-f7af-47c4-9cea-8fd9ec978062\",\n      \"logicalname\":\"content_image_2009.01.20.08.55.10_\",\n      \"translations\":{\n         \"nb_NO\":\"Kj\xF8pmann bakfra\",\n         \"fi_FI\":\"Kauppias takaap\xE4in\",\n         \"nn_NO\":\"Kj\xF8pmann bakfr\xE5\",\n         \"sv_SE\":\"K\xF6pman bakifr\xE5n\",\n         \"en_US\":\"Merchant bakside view\",\n         \"da_DK\":\"K\xF8bmand bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":223,\n      \"height\":293,\n      \"position\":35,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"2b737f04-ab97-438b-94f1-4014c4e7ed3f\",\n      \"logicalname\":\"content_image_2008.12.10.13.17.15_\",\n      \"translations\":{\n         \"nb_NO\":\"Musikant g\xE5r\",\n         \"fi_FI\":\"Musikantti k\xE4velee\",\n         \"nn_NO\":\"Musikant g\xE5r\",\n         \"sv_SE\":\"Musikant g\xE5r\",\n         \"en_US\":\"Minstrel walking\",\n         \"da_DK\":\"Musikant g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":195,\n      \"height\":337,\n      \"position\":36,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"90731aa6-a0f7-4113-a895-018cfb1b4d94\",\n      \"logicalname\":\"content_image_2008.12.10.13.17.22_\",\n      \"translations\":{\n         \"nb_NO\":\"Musikant kneler\",\n         \"fi_FI\":\"Musikantti polvistuu\",\n         \"nn_NO\":\"Musikant kneler\",\n         \"sv_SE\":\"Musikant kn\xE4b\xF6jer\",\n         \"en_US\":\"Minstrel kneeling\",\n         \"da_DK\":\"Musikant kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":171,\n      \"height\":267,\n      \"position\":37,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"26c926ed-94df-4c09-8941-a8933564c2d5\",\n      \"logicalname\":\"content_image_2008.12.10.13.17.30_\",\n      \"translations\":{\n         \"nb_NO\":\"Musikant sitter\",\n         \"fi_FI\":\"Musikantti istuu\",\n         \"nn_NO\":\"Musikant sit\",\n         \"sv_SE\":\"Musikant sitter\",\n         \"en_US\":\"Minstrel sitting\",\n         \"da_DK\":\"Musikant sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":199,\n      \"height\":306,\n      \"position\":38,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"bc580c22-0ac7-41a6-b5f3-76580db6a52d\",\n      \"logicalname\":\"content_image_2008.12.10.13.17.37_\",\n      \"translations\":{\n         \"nb_NO\":\"Musikant st\xE5r\",\n         \"fi_FI\":\"Musikantti seisoo\",\n         \"nn_NO\":\"Musikant st\xE5r\",\n         \"sv_SE\":\"Musikant st\xE5r\",\n         \"en_US\":\"Minstrel standing\",\n         \"da_DK\":\"Musikant st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":179,\n      \"height\":336,\n      \"position\":39,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"b0bff7a2-b4cb-4f40-a6a0-a193037b4742\",\n      \"logicalname\":\"content_image_2008.12.10.13.17.52_\",\n      \"translations\":{\n         \"nb_NO\":\"Musikant syk\",\n         \"fi_FI\":\"Musikantti sairaana\",\n         \"nn_NO\":\"Musikant sjuk\",\n         \"sv_SE\":\"Musikant \xE4r sjuk\",\n         \"en_US\":\"Minstrel sick\",\n         \"da_DK\":\"Musikant syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":333,\n      \"height\":134,\n      \"position\":40,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"8f4568ae-5125-4cfa-ad63-c9c6f158102c\",\n      \"logicalname\":\"content_image_2009.01.20.08.55.37_\",\n      \"translations\":{\n         \"nb_NO\":\"Musikkant bakfra\",\n         \"fi_FI\":\"Musikantti takaap\xE4in\",\n         \"nn_NO\":\"Musikkant bakfr\xE5\",\n         \"sv_SE\":\"Musikant bakifr\xE5n\",\n         \"en_US\":\"Minstrel backside view\",\n         \"da_DK\":\"Musikant bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":178,\n      \"height\":327,\n      \"position\":41,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"66a0a6fa-0938-4143-88e4-342daa1f1057\",\n      \"logicalname\":\"content_image_2008.12.10.13.23.21_\",\n      \"translations\":{\n         \"nb_NO\":\"Tigger g\xE5r\",\n         \"fi_FI\":\"Kerj\xE4l\xE4inen k\xE4velee\",\n         \"nn_NO\":\"Tiggar g\xE5r\",\n         \"sv_SE\":\"Tiggare g\xE5r\",\n         \"en_US\":\"Beggar walking\",\n         \"da_DK\":\"Tigger g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":270,\n      \"height\":364,\n      \"position\":42,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"2958f790-c677-43c5-96ef-6536cd1836f2\",\n      \"logicalname\":\"content_image_2008.12.10.13.23.28_\",\n      \"translations\":{\n         \"nb_NO\":\"Tigger kneler\",\n         \"fi_FI\":\"Kerj\xE4l\xE4inen polvistuu\",\n         \"nn_NO\":\"Tiggar kneler\",\n         \"sv_SE\":\"Tiggare kn\xE4b\xF6jer\",\n         \"en_US\":\"Beggar kneeling\",\n         \"da_DK\":\"Tigger kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":198,\n      \"height\":290,\n      \"position\":43,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"8620b2ba-2794-4ab4-8249-168c253c8130\",\n      \"logicalname\":\"content_image_2008.12.10.13.23.40_\",\n      \"translations\":{\n         \"nb_NO\":\"Tigger sitter\",\n         \"fi_FI\":\"Kerj\xE4l\xE4inen istuu\",\n         \"nn_NO\":\"Tiggar sit\",\n         \"sv_SE\":\"Tiggare sitter\",\n         \"en_US\":\"Beggar sitting\",\n         \"da_DK\":\"Tigger sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":325,\n      \"height\":306,\n      \"position\":44,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"5f08445f-697d-47d7-ae19-d9d73badc150\",\n      \"logicalname\":\"content_image_2008.12.10.13.23.49_\",\n      \"translations\":{\n         \"nb_NO\":\"Tigger st\xE5r\",\n         \"fi_FI\":\"Kerj\xE4l\xE4inen seisoo\",\n         \"nn_NO\":\"Tiggar st\xE5r\",\n         \"sv_SE\":\"Tiggare st\xE5r\",\n         \"en_US\":\"Beggar standing\",\n         \"da_DK\":\"Tigger st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":212,\n      \"height\":373,\n      \"position\":45,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"92613089-d21b-48c3-b255-fd23c59d7b31\",\n      \"logicalname\":\"content_image_2008.12.10.13.23.58_\",\n      \"translations\":{\n         \"nb_NO\":\"Tigger syk\",\n         \"fi_FI\":\"Kerj\xE4l\xE4inen sairaana\",\n         \"nn_NO\":\"Tiggar sjuk\",\n         \"sv_SE\":\"Tiggare \xE4r sjuk\",\n         \"en_US\":\"Beggar sick\",\n         \"da_DK\":\"Tigger syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"townspeople\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":392,\n      \"height\":181,\n      \"position\":46,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"553f48e5-f677-4196-b59a-2ad30f7fe5ac\",\n      \"logicalname\":\"content_image_2008.12.10.13.12.05_\",\n      \"translations\":{\n         \"nb_NO\":\"Bondekone st\xE5r\",\n         \"fi_FI\":\"Maalaisnainen seisoo\",\n         \"nn_NO\":\"Bondekone st\xE5r\",\n         \"sv_SE\":\"Bondhustru st\xE5r\",\n         \"en_US\":\"Peasant woman standing\",\n         \"da_DK\":\"Bondekone st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":214,\n      \"height\":351,\n      \"position\":15,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"19663506-e247-4d57-999c-b5b8b20fcc21\",\n      \"logicalname\":\"content_image_2008.12.10.13.12.12_\",\n      \"translations\":{\n         \"nb_NO\":\"Bondekone syk\",\n         \"fi_FI\":\"Maalaisnainen sairaana\",\n         \"nn_NO\":\"Bondekone sjuk\",\n         \"sv_SE\":\"Bondhustru \xE4r sjuk\",\n         \"en_US\":\"Peasant woman sick\",\n         \"da_DK\":\"Bondekone syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":373,\n      \"height\":153,\n      \"position\":16,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"8bbb0faf-e63c-49bf-ae1e-73b1f8306767\",\n      \"logicalname\":\"content_image_2009.01.20.08.54.10_\",\n      \"translations\":{\n         \"nb_NO\":\"Bondekone bakfra\",\n         \"fi_FI\":\"Maalaisnainen takaap\xE4in\",\n         \"nn_NO\":\"Bondekone bakfr\xE5\",\n         \"sv_SE\":\"Bondhustru bakifr\xE5n\",\n         \"en_US\":\"Peasant woman backside view\",\n         \"da_DK\":\"Bondekone bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":177,\n      \"height\":346,\n      \"position\":17,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"dff77227-5a72-4e3e-92d8-c6bc8cd543d0\",\n      \"logicalname\":\"content_image_2008.12.10.13.20.39_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbonde g\xE5r\",\n         \"fi_FI\":\"Suurtilallinen k\xE4velee\",\n         \"nn_NO\":\"Storbonde g\xE5r\",\n         \"sv_SE\":\"Storbonde g\xE5r\",\n         \"en_US\":\"Landowner walking\",\n         \"da_DK\":\"Storbonde g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":220,\n      \"height\":372,\n      \"position\":18,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"4401202b-e566-4520-a28f-5dc300aea58c\",\n      \"logicalname\":\"content_image_2008.12.10.13.20.45_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbonde kneler\",\n         \"fi_FI\":\"Suurtilallinen polvistuu\",\n         \"nn_NO\":\"Storbonde kneler\",\n         \"sv_SE\":\"Storbonde kn\xE4b\xF6jer\",\n         \"en_US\":\"Landowner kneeling\",\n         \"da_DK\":\"Storbonde kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":178,\n      \"height\":301,\n      \"position\":19,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"f7ed9e43-c07a-4205-a1d9-0b0dbeada1f0\",\n      \"logicalname\":\"content_image_2008.12.10.13.20.52_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbonde sitter\",\n         \"fi_FI\":\"Suurtilallinen istuu\",\n         \"nn_NO\":\"Storbonde sit\",\n         \"sv_SE\":\"Storbonde sitter\",\n         \"en_US\":\"Landowner sitting\",\n         \"da_DK\":\"Storbonde sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":236,\n      \"height\":342,\n      \"position\":20,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"0eba42a2-f6a4-4259-b718-92b16cce4a0f\",\n      \"logicalname\":\"content_image_2008.12.10.13.20.59_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbonde st\xE5r\",\n         \"fi_FI\":\"Suurtilallinen seisoo\",\n         \"nn_NO\":\"Storbonde st\xE5r\",\n         \"sv_SE\":\"Storbonde st\xE5r\",\n         \"en_US\":\"Landowner standing\",\n         \"da_DK\":\"Storbonde st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":198,\n      \"height\":371,\n      \"position\":21,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"34710a3c-c22a-4b80-ac20-cfedfdff20ff\",\n      \"logicalname\":\"content_image_2008.12.10.13.21.07_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbonde syk\",\n         \"fi_FI\":\"Suurtilallinen sairaana\",\n         \"nn_NO\":\"Storbonde sjuk\",\n         \"sv_SE\":\"Storbonde \xE4r sjuk\",\n         \"en_US\":\"Landowner sick\",\n         \"da_DK\":\"Storbonde syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":366,\n      \"height\":115,\n      \"position\":22,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"8b1c9009-1cef-4173-ab33-a541895838c5\",\n      \"logicalname\":\"content_image_2009.01.20.08.56.19_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbonde bakfra\",\n         \"fi_FI\":\"Suurtilallinen takaap\xE4in\",\n         \"nn_NO\":\"Storbonde bakfr\xE5\",\n         \"sv_SE\":\"Storbonde bakifr\xE5n\",\n         \"en_US\":\"Landowner backside view\",\n         \"da_DK\":\"Storbonde bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":256,\n      \"height\":369,\n      \"position\":23,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"7ce4ee37-a301-4e7b-9a7d-69c88fa878f2\",\n      \"logicalname\":\"content_image_2008.12.10.13.22.29_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbondebarn g\xE5r\",\n         \"fi_FI\":\"Suurtilallisen vaimo k\xE4velee\",\n         \"nn_NO\":\"Storbondebarn g\xE5r\",\n         \"sv_SE\":\"Storbondebarn g\xE5r\",\n         \"en_US\":\"Landowner's child walking\",\n         \"da_DK\":\"Storbondebarn g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":195,\n      \"height\":377,\n      \"position\":24,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"34ef52ab-3de5-4137-a6b3-6b7e7a16bb4d\",\n      \"logicalname\":\"content_image_2008.12.10.13.22.37_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbondekone kneler\",\n         \"fi_FI\":\"Suurtilallisen vaimo polvistuu\",\n         \"nn_NO\":\"Storbondekone kneler\",\n         \"sv_SE\":\"Storbondens hustru kn\xE4b\xF6jer\",\n         \"en_US\":\"Landowner's wife kneeling\",\n         \"da_DK\":\"Storbondekone kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":214,\n      \"height\":298,\n      \"position\":25,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"c69e4c5c-5d72-48e9-9b54-f4a0e8939c03\",\n      \"logicalname\":\"content_image_2008.12.10.13.22.46_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbondekone sitter\",\n         \"fi_FI\":\"Suurtilallisen vaimo istuu\",\n         \"nn_NO\":\"Storbondekone sit\",\n         \"sv_SE\":\"Storbondens hustru sitter\",\n         \"en_US\":\"Landowner's wife sitting\",\n         \"da_DK\":\"Storbondekone sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":213,\n      \"height\":356,\n      \"position\":26,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"ce275763-f218-4c84-89b0-5d7ff01bc217\",\n      \"logicalname\":\"content_image_2008.12.10.13.22.55_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbondekone st\xE5r\",\n         \"fi_FI\":\"Suurtilallisen vaimo seisoo\",\n         \"nn_NO\":\"Storbondekone st\xE5r\",\n         \"sv_SE\":\"Storbondehustru st\xE5r\",\n         \"en_US\":\"Landowner's wife standing\",\n         \"da_DK\":\"Storbondekone st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":236,\n      \"height\":367,\n      \"position\":27,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"c677121e-fbe2-43eb-86a2-eef515033c2d\",\n      \"logicalname\":\"content_image_2008.12.10.13.23.07_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbondekone syk\",\n         \"fi_FI\":\"Suurtilallisen vaimo sairaana\",\n         \"nn_NO\":\"Storbondekone sjuk\",\n         \"sv_SE\":\"Storbondens hustru \xE4r sjuk\",\n         \"en_US\":\"Landowner's wife sick\",\n         \"da_DK\":\"Storbondekone syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":382,\n      \"height\":114,\n      \"position\":28,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"25418c00-19b2-4711-b3da-ac78bc3f2fbe\",\n      \"logicalname\":\"content_image_2009.01.20.08.56.47_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbondekone bakfra\",\n         \"fi_FI\":\"Suurtilallisen vaimo takaap\xE4in\",\n         \"nn_NO\":\"Storbondekone bakfr\xE5\",\n         \"sv_SE\":\"Storbondehustru bakifr\xE5n\",\n         \"en_US\":\"Landowner's wife backside view\",\n         \"da_DK\":\"Storbondekone bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":198,\n      \"height\":358,\n      \"position\":29,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"47d20d06-e3b8-4bdb-91b5-81399fa14de5\",\n      \"logicalname\":\"content_image_2008.12.10.13.21.28_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbondekone g\xE5r\",\n         \"fi_FI\":\"Suurtilallisen vaimo k\xE4velee\",\n         \"nn_NO\":\"Storbondekone g\xE5r\",\n         \"sv_SE\":\"Storbondehustru g\xE5r\",\n         \"en_US\":\"Landowner's wife walking\",\n         \"da_DK\":\"Storbondekone g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":135,\n      \"height\":222,\n      \"position\":30,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"70031f3d-d81a-4392-9c3d-ccea9e184873\",\n      \"logicalname\":\"content_image_2008.12.10.13.21.43_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbondebarn l\xF8per\",\n         \"fi_FI\":\"Suurtilallisen lapsi juoksee\",\n         \"nn_NO\":\"Storbondebarn spring\",\n         \"sv_SE\":\"Storbondebarn springer\",\n         \"en_US\":\"Landowner's child running\",\n         \"da_DK\":\"Storbondebarn l\xF8ber\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":178,\n      \"height\":222,\n      \"position\":31,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"2755ed74-e18f-4d63-ae93-5afb548f649d\",\n      \"logicalname\":\"content_image_2008.12.10.13.21.51_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbondebarn sitter\",\n         \"fi_FI\":\"Suurtilallisen lapsi istuu\",\n         \"nn_NO\":\"Storbondebarn sit\",\n         \"sv_SE\":\"Storbondebarn sitter\",\n         \"en_US\":\"Landowner's child sitting\",\n         \"da_DK\":\"Storbondebarn sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":140,\n      \"height\":201,\n      \"position\":32,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"74d193c4-6a20-420e-b60d-d914a5ad396b\",\n      \"logicalname\":\"content_image_2008.12.10.13.22.01_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbondebarn st\xE5r\",\n         \"fi_FI\":\"Suurtilallisen lapsi seisoo\",\n         \"nn_NO\":\"Storbondebarn st\xE5r\",\n         \"sv_SE\":\"Storbondebarn st\xE5r\",\n         \"en_US\":\"Landowner's child standing\",\n         \"da_DK\":\"Storbondebarn st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":135,\n      \"height\":228,\n      \"position\":33,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"7ef09c75-833b-4eeb-b118-d82cd1fff10d\",\n      \"logicalname\":\"content_image_2008.12.10.13.22.12_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbondebarn syk\",\n         \"fi_FI\":\"Suurtilallisen lapsi sairaana\",\n         \"nn_NO\":\"Storbondebarn sjuk\",\n         \"sv_SE\":\"Storbondebarn \xE4r sjuk\",\n         \"en_US\":\"Landowner's child sick\",\n         \"da_DK\":\"Storbondebarn syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":218,\n      \"height\":122,\n      \"position\":34,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"9e56477c-0e52-4e3d-8458-3504d16cc584\",\n      \"logicalname\":\"content_image_2009.01.20.08.56.31_\",\n      \"translations\":{\n         \"nb_NO\":\"Storbondebarn bakfra\",\n         \"fi_FI\":\"Suurtilallisen lapsi takaap\xE4in\",\n         \"nn_NO\":\"Storbondebarn bakfr\xE5\",\n         \"sv_SE\":\"Storbondebarn bakifr\xE5n\",\n         \"en_US\":\"Landowner's child backside view\",\n         \"da_DK\":\"Storbondebarn bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"farmers\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"loeper\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":140,\n      \"height\":215,\n      \"position\":35,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"56524109-edd3-4e33-a4bf-9a8033b38967\",\n      \"logicalname\":\"content_image_2008.12.10.13.19.04_\",\n      \"translations\":{\n         \"nb_NO\":\"Pave g\xE5r\",\n         \"fi_FI\":\"Paavi k\xE4velee\",\n         \"nn_NO\":\"Pave g\xE5r\",\n         \"sv_SE\":\"P\xE5ve g\xE5r\",\n         \"en_US\":\"Pope walking\",\n         \"da_DK\":\"Pave g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":232,\n      \"height\":381,\n      \"position\":0,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"9b5c57e0-929e-4df7-8a5a-f4235f98b015\",\n      \"logicalname\":\"content_image_2008.12.10.13.19.12_\",\n      \"translations\":{\n         \"nb_NO\":\"Pave kneler\",\n         \"fi_FI\":\"Paavi polvistuu\",\n         \"nn_NO\":\"Pave kneler\",\n         \"sv_SE\":\"P\xE5ve kn\xE4b\xF6jer\",\n         \"en_US\":\"Pope kneeling\",\n         \"da_DK\":\"Pave kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":233,\n      \"height\":306,\n      \"position\":1,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"b6dd718c-bad9-4a07-ad09-bb8d95f159de\",\n      \"logicalname\":\"content_image_2008.12.10.13.19.19_\",\n      \"translations\":{\n         \"nb_NO\":\"Pave sitter\",\n         \"fi_FI\":\"Paavi istuu\",\n         \"nn_NO\":\"Pave sit\",\n         \"sv_SE\":\"P\xE5ve sitter\",\n         \"en_US\":\"Pope sitting\",\n         \"da_DK\":\"Pave sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":195,\n      \"height\":353,\n      \"position\":2,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"fb9067ee-4cd3-48ea-b70f-2ffc4cbd2486\",\n      \"logicalname\":\"content_image_2008.12.10.13.19.28_\",\n      \"translations\":{\n         \"nb_NO\":\"Pave st\xE5r\",\n         \"fi_FI\":\"Paavi seisoo\",\n         \"nn_NO\":\"Pave st\xE5r\",\n         \"sv_SE\":\"P\xE5ve st\xE5r\",\n         \"en_US\":\"Pope standing\",\n         \"da_DK\":\"Pave st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":235,\n      \"height\":387,\n      \"position\":3,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"2f312ec7-8841-4cfb-9c7a-5e80bfa0b0c7\",\n      \"logicalname\":\"content_image_2008.12.10.13.19.36_\",\n      \"translations\":{\n         \"nb_NO\":\"Pave syk\",\n         \"fi_FI\":\"Paavi sairaana\",\n         \"nn_NO\":\"Pave sjuk\",\n         \"sv_SE\":\"P\xE5ve \xE4r sjuk\",\n         \"en_US\":\"Pope sick\",\n         \"da_DK\":\"Pave syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":387,\n      \"height\":149,\n      \"position\":4,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"fd06d8c8-bc5b-4e32-9793-0834197f71c5\",\n      \"logicalname\":\"content_image_2009.01.20.08.55.59_\",\n      \"translations\":{\n         \"nb_NO\":\"Pave bakfra\",\n         \"fi_FI\":\"Paavi takaap\xE4in\",\n         \"nn_NO\":\"Pave bakfr\xE5\",\n         \"sv_SE\":\"P\xE5ve bakifr\xE5n\",\n         \"en_US\":\"Pope backside view\",\n         \"da_DK\":\"Pave bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":200,\n      \"height\":359,\n      \"position\":5,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"5f088f57-2b4b-4eea-bdea-77949a597a41\",\n      \"logicalname\":\"content_image_2008.12.10.13.19.50_\",\n      \"translations\":{\n         \"nb_NO\":\"Prest g\xE5r\",\n         \"fi_FI\":\"Pappi k\xE4velee\",\n         \"nn_NO\":\"Prest g\xE5r\",\n         \"sv_SE\":\"Pr\xE4st g\xE5r\",\n         \"en_US\":\"Priest walking\",\n         \"da_DK\":\"Pr\xE6st g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":197,\n      \"height\":362,\n      \"position\":6,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"9d92172c-2a1c-4c5a-bb81-ce52e3cc42a9\",\n      \"logicalname\":\"content_image_2008.12.10.13.19.59_\",\n      \"translations\":{\n         \"nb_NO\":\"Prest kneler\",\n         \"fi_FI\":\"Pappi polvistuu\",\n         \"nn_NO\":\"Prest kneler\",\n         \"sv_SE\":\"Pr\xE4st kn\xE4b\xF6jer\",\n         \"en_US\":\"Priest kneeling\",\n         \"da_DK\":\"Pr\xE6st kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":220,\n      \"height\":304,\n      \"position\":7,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"f2fc65e2-1b62-4225-b517-0c2a57c9cc6b\",\n      \"logicalname\":\"content_image_2008.12.10.13.20.06_\",\n      \"translations\":{\n         \"nb_NO\":\"Prest sitter\",\n         \"fi_FI\":\"Pappi istuu\",\n         \"nn_NO\":\"Prest sit\",\n         \"sv_SE\":\"Pr\xE4st sitter\",\n         \"en_US\":\"Priest sitting\",\n         \"da_DK\":\"Pr\xE6st sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":176,\n      \"height\":335,\n      \"position\":8,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"4027802a-09b1-479f-9318-62f22daf5916\",\n      \"logicalname\":\"content_image_2008.12.10.13.20.14_\",\n      \"translations\":{\n         \"nb_NO\":\"Prest st\xE5r\",\n         \"fi_FI\":\"Pappi seisoo\",\n         \"nn_NO\":\"Prest st\xE5r\",\n         \"sv_SE\":\"Pr\xE4st st\xE5r\",\n         \"en_US\":\"Priest standing\",\n         \"da_DK\":\"Pr\xE6st st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":191,\n      \"height\":362,\n      \"position\":9,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"f99b63b7-ca88-4ee5-8bf5-9ed433149c0c\",\n      \"logicalname\":\"content_image_2008.12.10.13.20.23_\",\n      \"translations\":{\n         \"nb_NO\":\"Prest syk\",\n         \"fi_FI\":\"Pappi sairaana\",\n         \"nn_NO\":\"Prest sjuk\",\n         \"sv_SE\":\"Pr\xE4st sjuk\",\n         \"en_US\":\"Priest sick\",\n         \"da_DK\":\"Pr\xE6st syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":362,\n      \"height\":137,\n      \"position\":10,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"a76086b6-eb5d-448c-8105-bb8b1a6bd865\",\n      \"logicalname\":\"content_image_2009.01.20.08.56.09_\",\n      \"translations\":{\n         \"nb_NO\":\"Prest bakfra\",\n         \"fi_FI\":\"Pappi takaap\xE4in\",\n         \"nn_NO\":\"Prest bakfr\xE5\",\n         \"sv_SE\":\"Pr\xE4st bakifr\xE5n\",\n         \"en_US\":\"Priest backside view\",\n         \"da_DK\":\"Pr\xE6st bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":216,\n      \"height\":359,\n      \"position\":11,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"95f093df-ff14-4494-8907-6e68b3ea46e2\",\n      \"logicalname\":\"content_image_2008.12.10.13.16.27_\",\n      \"translations\":{\n         \"nb_NO\":\"Munk g\xE5r\",\n         \"fi_FI\":\"Munkki k\xE4velee\",\n         \"nn_NO\":\"Munk g\xE5r\",\n         \"sv_SE\":\"Munk g\xE5r\",\n         \"en_US\":\"Monk walking\",\n         \"da_DK\":\"Munk g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":220,\n      \"height\":353,\n      \"position\":12,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"95dc9719-78ca-4e9a-9816-e69b6266f7b6\",\n      \"logicalname\":\"content_image_2008.12.10.13.16.34_\",\n      \"translations\":{\n         \"nb_NO\":\"Munk kneler\",\n         \"fi_FI\":\"Munkki polvistuu\",\n         \"nn_NO\":\"Munk kneler\",\n         \"sv_SE\":\"Munk kn\xE4b\xF6jer\",\n         \"en_US\":\"Monk kneeling\",\n         \"da_DK\":\"Munk kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":196,\n      \"height\":289,\n      \"position\":13,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"995be423-db53-4d51-9cc8-bf275ec08b9e\",\n      \"logicalname\":\"content_image_2008.12.10.13.16.42_\",\n      \"translations\":{\n         \"nb_NO\":\"Munk sitter\",\n         \"fi_FI\":\"Munkki istuu\",\n         \"nn_NO\":\"Munk sit\",\n         \"sv_SE\":\"Munk sitter\",\n         \"en_US\":\"Monk sitting\",\n         \"da_DK\":\"Munk sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":200,\n      \"height\":310,\n      \"position\":14,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"e0f4fd06-4acb-4c45-9382-62ca3aa72905\",\n      \"logicalname\":\"content_image_2008.12.10.13.16.50_\",\n      \"translations\":{\n         \"nb_NO\":\"Munk st\xE5r\",\n         \"fi_FI\":\"Munkki seisoo\",\n         \"nn_NO\":\"Munk st\xE5r\",\n         \"sv_SE\":\"Munk st\xE5r\",\n         \"en_US\":\"Monk standing\",\n         \"da_DK\":\"Munk st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":209,\n      \"height\":361,\n      \"position\":15,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"fb27e28a-52b1-4fe0-ad49-8e5415b1d8dc\",\n      \"logicalname\":\"content_image_2008.12.10.13.16.58_\",\n      \"translations\":{\n         \"nb_NO\":\"Munk syk\",\n         \"fi_FI\":\"Munkki sairaana\",\n         \"nn_NO\":\"Munk sjuk\",\n         \"sv_SE\":\"Munk \xE4r sjuk\",\n         \"en_US\":\"Monk sick\",\n         \"da_DK\":\"Munk syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":344,\n      \"height\":129,\n      \"position\":16,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"1059e6ed-bb7d-400f-a126-e9b5c6e7c4ed\",\n      \"logicalname\":\"content_image_2009.01.20.08.55.25_\",\n      \"translations\":{\n         \"nb_NO\":\"Munk bakfra\",\n         \"fi_FI\":\"Munkki takaap\xE4in\",\n         \"nn_NO\":\"Munk bakfr\xE5\",\n         \"sv_SE\":\"Munk bakifr\xE5n\",\n         \"en_US\":\"Monk backside view\",\n         \"da_DK\":\"Munk bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":252,\n      \"height\":336,\n      \"position\":17,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"a71586b6-63cc-42f3-a275-4c51e6ec8089\",\n      \"logicalname\":\"content_image_2008.12.10.13.18.13_\",\n      \"translations\":{\n         \"nb_NO\":\"Nonne g\xE5r\",\n         \"fi_FI\":\"Nunna k\xE4velee\",\n         \"nn_NO\":\"Nonne g\xE5r\",\n         \"sv_SE\":\"Nunna g\xE5r\",\n         \"en_US\":\"Nun walking\",\n         \"da_DK\":\"Nonne g\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":241,\n      \"height\":365,\n      \"position\":18,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"58d022bb-061f-42ab-98b1-6747447609f3\",\n      \"logicalname\":\"content_image_2008.12.10.13.18.20_\",\n      \"translations\":{\n         \"nb_NO\":\"Nonne kneler\",\n         \"fi_FI\":\"Nunna polvistuu\",\n         \"nn_NO\":\"Nonne kneler\",\n         \"sv_SE\":\"Nunna kn\xE4b\xF6jer\",\n         \"en_US\":\"Nun kneeling\",\n         \"da_DK\":\"Nonne kn\xE6ler\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":237,\n      \"height\":283,\n      \"position\":19,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"81e332a5-579d-4818-973d-4fecb10ee4fb\",\n      \"logicalname\":\"content_image_2008.12.10.13.18.27_\",\n      \"translations\":{\n         \"nb_NO\":\"Nonne sitter\",\n         \"fi_FI\":\"Nunna istuu\",\n         \"nn_NO\":\"Nonne sit\",\n         \"sv_SE\":\"Nunna sitter\",\n         \"en_US\":\"Nun sitting\",\n         \"da_DK\":\"Nonne sidder\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":190,\n      \"height\":338,\n      \"position\":20,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"b147b550-e474-4563-ae7c-45405c0311ca\",\n      \"logicalname\":\"content_image_2008.12.10.13.18.36_\",\n      \"translations\":{\n         \"nb_NO\":\"Nonne st\xE5r\",\n         \"fi_FI\":\"Nunna seisoo\",\n         \"nn_NO\":\"Nonne st\xE5r\",\n         \"sv_SE\":\"Nunna st\xE5r\",\n         \"en_US\":\"Nun standing\",\n         \"da_DK\":\"Nonne st\xE5r\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":224,\n      \"height\":365,\n      \"position\":21,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"5eab5b17-db14-4cdf-84fa-64980fbf9c93\",\n      \"logicalname\":\"content_image_2008.12.10.13.18.43_\",\n      \"translations\":{\n         \"nb_NO\":\"Nonne syk\",\n         \"fi_FI\":\"Nunna sairaana\",\n         \"nn_NO\":\"Nonne sjuk\",\n         \"sv_SE\":\"Nunna \xE4r sjuk\",\n         \"en_US\":\"Nun sick\",\n         \"da_DK\":\"Nonne syg\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":377,\n      \"height\":122,\n      \"position\":22,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"cf3e7fea-778c-4c7b-9806-d0c112bccd2a\",\n      \"logicalname\":\"content_image_2009.01.20.08.55.49_\",\n      \"translations\":{\n         \"nb_NO\":\"Nonne bakfra\",\n         \"fi_FI\":\"Nunna takaap\xE4in\",\n         \"nn_NO\":\"Nonne bakfr\xE5\",\n         \"sv_SE\":\"Nunna bakifr\xE5n\",\n         \"en_US\":\"Nun backside view\",\n         \"da_DK\":\"Nonne bagfra\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"clergy\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\",\n         \"kneler\",\n         \"sitter\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":236,\n      \"height\":363,\n      \"position\":23,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"a28a2967-e46d-46f9-b9f1-cd81f669f58a\",\n      \"logicalname\":\"ma_ridder1_star_\",\n      \"translations\":{\n         \"nb_NO\":\"Ridder 1 st\xE5r\",\n         \"fi_FI\":\"Ritari 1 reisoo\",\n         \"nn_NO\":\"Riddar 1 st\xE5r\",\n         \"sv_SE\":\"Riddare 1 st\xE5ende\",\n         \"en_US\":\"Knight 1 standing\",\n         \"da_DK\":\"Ridder 1 st\xE5ende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"forfra\",\n         \"bakfra\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":190,\n      \"height\":400,\n      \"position\":0,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"8d2180f9-531e-45b7-b316-a8a3f04bc3cc\",\n      \"logicalname\":\"ma_ridder1_gar_\",\n      \"translations\":{\n         \"nb_NO\":\"Ridder 1 g\xE5r\",\n         \"fi_FI\":\"Ritari 1 k\xE4velee\",\n         \"nn_NO\":\"Riddar 1 g\xE5r\",\n         \"sv_SE\":\"Riddare 1 g\xE5ende\",\n         \"en_US\":\"Knight 1 walking\",\n         \"da_DK\":\"Ridder 1 g\xE5ende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"forfra\",\n         \"bakfra\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":218,\n      \"height\":395,\n      \"position\":1,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"e8dd4a10-a1f7-4ddd-ae4f-3dedfd76cdc6\",\n      \"logicalname\":\"ma_ridder1_loper_\",\n      \"translations\":{\n         \"nb_NO\":\"Ridder 1 l\xF8per\",\n         \"fi_FI\":\"Ritari 1 juoksee\",\n         \"nn_NO\":\"Riddar 1 spring\",\n         \"sv_SE\":\"Riddare 1 springande\",\n         \"en_US\":\"Knight 1 running\",\n         \"da_DK\":\"Ridder 1 l\xF8bende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"forfra\",\n         \"bakfra\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":379,\n      \"height\":369,\n      \"position\":2,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"7b0db0ef-d44e-4119-adc9-02f0327fa89e\",\n      \"logicalname\":\"ma_ridder1_slass_\",\n      \"translations\":{\n         \"nb_NO\":\"Ridder 1 sloss\",\n         \"fi_FI\":\"Ritari 1 taistelee\",\n         \"nn_NO\":\"Riddar 1 sl\xE5st\",\n         \"sv_SE\":\"Riddare 1 stridande\",\n         \"en_US\":\"Knight 1 fighting\",\n         \"da_DK\":\"Ridder 1 k\xE6mpende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"forfra\",\n         \"bakfra\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":338,\n      \"height\":386,\n      \"position\":3,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"5bc37649-9470-455b-a5f3-b12866ba6b1d\",\n      \"logicalname\":\"ma_ridder1_kneler_\",\n      \"translations\":{\n         \"nb_NO\":\"Ridder 1 kneler\",\n         \"fi_FI\":\"Ritari 1 polvistuu\",\n         \"nn_NO\":\"Riddar 1 kneler\",\n         \"sv_SE\":\"Riddare 1 kn\xE4b\xF6jande\",\n         \"en_US\":\"Knight 1 kneeling\",\n         \"da_DK\":\"Ridder 1 kn\xE6lende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"forfra\",\n         \"bakfra\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":312,\n      \"height\":325,\n      \"position\":4,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"12dc190a-331c-496a-8aa6-b6652d537f34\",\n      \"logicalname\":\"ma_ridder1_til_hest_\",\n      \"translations\":{\n         \"nb_NO\":\"Ridder 1 til hest\",\n         \"fi_FI\":\"Ritari 1 hevosen sel\xE4ss\xE4\",\n         \"nn_NO\":\"Riddar 1 til hest\",\n         \"sv_SE\":\"Riddare 1 till h\xE4st\",\n         \"en_US\":\"Knight 1 on horse\",\n         \"da_DK\":\"Ridder 1 til hest\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":223,\n      \"height\":402,\n      \"position\":5,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"9916da9a-fcce-4a47-b7fd-007e93479e5e\",\n      \"logicalname\":\"ma_ridder2_star_\",\n      \"translations\":{\n         \"nb_NO\":\"Ridder 2 st\xE5r\",\n         \"fi_FI\":\"Ritari 2 reisoo\",\n         \"nn_NO\":\"Riddar 2 st\xE5r\",\n         \"sv_SE\":\"Riddare 2 st\xE5ende\",\n         \"en_US\":\"Knight 2 standing\",\n         \"da_DK\":\"Ridder 2 st\xE5ende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"forfra\",\n         \"bakfra\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":190,\n      \"height\":400,\n      \"position\":6,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"7e86cdb5-4d76-45fa-a62f-7c1008926c7d\",\n      \"logicalname\":\"ma_ridder2_gar_\",\n      \"translations\":{\n         \"nb_NO\":\"Ridder 2 g\xE5r\",\n         \"fi_FI\":\"Ritari 2 k\xE4velee\",\n         \"nn_NO\":\"Riddar 2 g\xE5r\",\n         \"sv_SE\":\"Riddare 2 g\xE5ende\",\n         \"en_US\":\"Knight 2 walking\",\n         \"da_DK\":\"Ridder 2 g\xE5ende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"forfra\",\n         \"bakfra\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":218,\n      \"height\":395,\n      \"position\":7,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"a9a0fb1e-ddf3-421e-9a46-316a3c123705\",\n      \"logicalname\":\"ma_ridder2_loper_\",\n      \"translations\":{\n         \"nb_NO\":\"Ridder 2 l\xF8per\",\n         \"fi_FI\":\"Ritari 2 juoksee\",\n         \"nn_NO\":\"Riddar 2 spring\",\n         \"sv_SE\":\"Riddare 2 springande\",\n         \"en_US\":\"Knight 2 running\",\n         \"da_DK\":\"Ridder 2 l\xF8bende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"forfra\",\n         \"bakfra\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":379,\n      \"height\":369,\n      \"position\":8,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"f870a8de-dd5b-461d-9b1b-fa253ee4651e\",\n      \"logicalname\":\"ma_ridder2_slass_\",\n      \"translations\":{\n         \"nb_NO\":\"Ridder 2 sloss\",\n         \"fi_FI\":\"Ritari 2 taistelee\",\n         \"nn_NO\":\"Riddar 2 sl\xE5st\",\n         \"sv_SE\":\"Riddare 2 stridande\",\n         \"en_US\":\"Knight 2 fighting\",\n         \"da_DK\":\"Ridder 2 k\xE6mpende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"forfra\",\n         \"bakfra\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":338,\n      \"height\":386,\n      \"position\":9,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"a78701b0-2a5a-4424-8da6-db6821bf6c56\",\n      \"logicalname\":\"ma_ridder2_kneler_\",\n      \"translations\":{\n         \"nb_NO\":\"Ridder 2 kneler\",\n         \"fi_FI\":\"Ritari 2 polvistuu\",\n         \"nn_NO\":\"Riddar 2 kneler\",\n         \"sv_SE\":\"Riddare 2 kn\xE4b\xF6jande\",\n         \"en_US\":\"Knight 2 kneeling\",\n         \"da_DK\":\"Ridder 2 kn\xE6lende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"forfra\",\n         \"bakfra\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":309,\n      \"height\":325,\n      \"position\":10,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"0738acff-75f3-4472-932e-220832399c1d\",\n      \"logicalname\":\"ma_ridder2_til_hest_\",\n      \"translations\":{\n         \"nb_NO\":\"Ridder 2 til hest\",\n         \"fi_FI\":\"Ritari 2 hevosen sel\xE4ss\xE4\",\n         \"nn_NO\":\"Riddar 2 til hest\",\n         \"sv_SE\":\"Riddare 2 till h\xE4st\",\n         \"en_US\":\"Knight 2 on horse\",\n         \"da_DK\":\"Ridder 2 til hest\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":223,\n      \"height\":402,\n      \"position\":11,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"a0177a73-df26-4944-a955-5838d2c932a5\",\n      \"logicalname\":\"ma_vepner_star_\",\n      \"translations\":{\n         \"nb_NO\":\"V\xE6pner st\xE5r\",\n         \"fi_FI\":\"Aseenkantaja seisoo\",\n         \"nn_NO\":\"V\xE6pnar st\xE5r\",\n         \"sv_SE\":\"V\xE4pnare st\xE5ende\",\n         \"en_US\":\"Squire standing\",\n         \"da_DK\":\"Junker st\xE5ende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":145,\n      \"height\":291,\n      \"position\":12,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"497a8bac-5099-4211-8cee-aed6a2778b7d\",\n      \"logicalname\":\"ma_vepner_gar_\",\n      \"translations\":{\n         \"nb_NO\":\"V\xE6pner g\xE5r\",\n         \"fi_FI\":\"Aseenkantaja k\xE4velee\",\n         \"nn_NO\":\"V\xE6pnar g\xE5r\",\n         \"sv_SE\":\"V\xE4pnare g\xE5ende\",\n         \"en_US\":\"Squire walking\",\n         \"da_DK\":\"Junker g\xE5ende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":160,\n      \"height\":284,\n      \"position\":13,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"856b93ce-9f29-4905-b2fa-a55e301bd125\",\n      \"logicalname\":\"ma_vepner_loper_\",\n      \"translations\":{\n         \"nb_NO\":\"V\xE6pner l\xF8per\",\n         \"fi_FI\":\"Aseenkantaja juoksee\",\n         \"nn_NO\":\"V\xE6pnar spring\",\n         \"sv_SE\":\"V\xE4pnare springande\",\n         \"en_US\":\"Squire running\",\n         \"da_DK\":\"Junker l\xF8bende\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"knights\",\n      \"moods\":[\n         \"normal\",\n         \"blid\",\n         \"lei\",\n         \"sint\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":202,\n      \"height\":268,\n      \"position\":14,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"4b0d696c-8921-4f16-af05-4d7e98f34efa\",\n      \"logicalname\":\"content_image_2008.12.10.16.29.18_\",\n      \"translations\":{\n         \"nb_NO\":\"Hest\",\n         \"fi_FI\":\"Horse\",\n         \"nn_NO\":\"Hest\",\n         \"sv_SE\":\"H\xE4st\",\n         \"en_US\":\"Horse\",\n         \"da_DK\":\"Horse\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"animals\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":454,\n      \"height\":399,\n      \"position\":0,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"fd687916-e27e-4a1a-9988-23f29dbba51d\",\n      \"logicalname\":\"content_image_2008.12.10.16.29.36_\",\n      \"translations\":{\n         \"nb_NO\":\"Ku\",\n         \"fi_FI\":\"Cow\",\n         \"nn_NO\":\"Ku\",\n         \"sv_SE\":\"Ko\",\n         \"en_US\":\"Cow\",\n         \"da_DK\":\"Cow\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"animals\",\n      \"moods\":[\n         \"staar\",\n         \"gaar\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":431,\n      \"height\":233,\n      \"position\":2,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"a376012f-40fd-4346-a005-ba434783d8c6\",\n      \"logicalname\":\"content_image_2008.12.10.16.33.36_\",\n      \"translations\":{\n         \"nb_NO\":\"Bord\",\n         \"fi_FI\":\"P\xF6yt\xE4\",\n         \"nn_NO\":\"Bord\",\n         \"sv_SE\":\"Bord\",\n         \"en_US\":\"Table\",\n         \"da_DK\":\"Bord\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"forfra\",\n         \"skraa\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":356,\n      \"height\":171,\n      \"position\":0,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"9882a3ea-2bff-4332-9c76-36b6bdf58426\",\n      \"logicalname\":\"content_image_2008.12.10.16.30.23_\",\n      \"translations\":{\n         \"nb_NO\":\"Br\xF8d\",\n         \"fi_FI\":\"Leip\xE4\",\n         \"nn_NO\":\"Br\xF8d\",\n         \"sv_SE\":\"Br\xF6d\",\n         \"en_US\":\"Bread\",\n         \"da_DK\":\"Br\xF8d\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":100,\n      \"height\":19,\n      \"position\":1,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"f7a8e225-face-4d45-a0b3-2e36691ade2c\",\n      \"logicalname\":\"content_image_2008.12.10.16.30.31_\",\n      \"translations\":{\n         \"nb_NO\":\"Kopp\",\n         \"fi_FI\":\"Kuppi\",\n         \"nn_NO\":\"Kopp\",\n         \"sv_SE\":\"Kopp\",\n         \"en_US\":\"Cup\",\n         \"da_DK\":\"Kop\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":38,\n      \"height\":50,\n      \"position\":2,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"8209205c-95ec-4e83-90e5-b12a2e31efe7\",\n      \"logicalname\":\"content_image_2008.12.10.16.31.08_\",\n      \"translations\":{\n         \"nb_NO\":\"Skje\",\n         \"fi_FI\":\"Lusikka\",\n         \"nn_NO\":\"Skei\",\n         \"sv_SE\":\"Sked\",\n         \"en_US\":\"Spoon\",\n         \"da_DK\":\"Ske\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":25,\n      \"height\":114,\n      \"position\":3,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"d0d84971-86c3-461c-a2aa-1123160d4a6e\",\n      \"logicalname\":\"content_image_2008.12.10.16.31.28_\",\n      \"translations\":{\n         \"nb_NO\":\"Peis\",\n         \"fi_FI\":\"Takka\",\n         \"nn_NO\":\"Peis\",\n         \"sv_SE\":\"Eldstad\",\n         \"en_US\":\"Fireplace\",\n         \"da_DK\":\"Pejs\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":193,\n      \"height\":115,\n      \"position\":4,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"8efec937-e960-4476-9513-4e0bcb859b4c\",\n      \"logicalname\":\"content_image_2008.12.10.16.32.38_\",\n      \"translations\":{\n         \"nb_NO\":\"Kam\",\n         \"fi_FI\":\"Kampa\",\n         \"nn_NO\":\"Kam\",\n         \"sv_SE\":\"Kam\",\n         \"en_US\":\"Comb\",\n         \"da_DK\":\"Kam\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":35,\n      \"height\":29,\n      \"position\":5,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"5b615ca7-1d57-4f0c-a322-34898d129ffe\",\n      \"logicalname\":\"content_image_2008.12.10.16.32.47_\",\n      \"translations\":{\n         \"nb_NO\":\"Rebec\",\n         \"fi_FI\":\"Luuttu\",\n         \"nn_NO\":\"Rebec\",\n         \"sv_SE\":\"Rebec\",\n         \"en_US\":\"Rebec\",\n         \"da_DK\":\"Rebec\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":133,\n      \"height\":105,\n      \"position\":6,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"598f55aa-cee0-4fad-952d-34530cfa0fcc\",\n      \"logicalname\":\"content_image_2008.12.10.16.33.18_\",\n      \"translations\":{\n         \"nb_NO\":\"Skinn\",\n         \"fi_FI\":\"Nahka\",\n         \"nn_NO\":\"Skinn\",\n         \"sv_SE\":\"L\xE4der\",\n         \"en_US\":\"Leather\",\n         \"da_DK\":\"L\xE6der\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"rull\",\n         \"aapent\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":224,\n      \"height\":183,\n      \"position\":7,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"d7eaea34-a87b-419b-8c1a-2b9216ed1027\",\n      \"logicalname\":\"content_image_2008.12.10.16.31.45_\",\n      \"translations\":{\n         \"nb_NO\":\"T\xF8nne\",\n         \"fi_FI\":\"Tynnyri\",\n         \"nn_NO\":\"T\xF8nne\",\n         \"sv_SE\":\"Tunna\",\n         \"en_US\":\"Casket\",\n         \"da_DK\":\"T\xF8nde\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":109,\n      \"height\":151,\n      \"position\":8,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"8048c08e-c394-4149-821c-a00f9b3f3be0\",\n      \"logicalname\":\"content_image_2008.12.10.16.34.20_\",\n      \"translations\":{\n         \"nb_NO\":\"Spade\",\n         \"fi_FI\":\"Shovel\",\n         \"nn_NO\":\"Spade\",\n         \"sv_SE\":\"Spade\",\n         \"en_US\":\"Shovel\",\n         \"da_DK\":\"Shovel\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":54,\n      \"height\":210,\n      \"position\":9,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"494dd0af-bca8-4908-a9e7-96ae7e4003cf\",\n      \"logicalname\":\"content_image_2008.12.10.16.32.03_\",\n      \"translations\":{\n         \"nb_NO\":\"H\xF8ygaffel\",\n         \"fi_FI\":\"Pitchfork\",\n         \"nn_NO\":\"H\xF8ygaffel\",\n         \"sv_SE\":\"H\xF6gaffel\",\n         \"en_US\":\"Pitchfork\",\n         \"da_DK\":\"Pitchfork\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":37,\n      \"height\":299,\n      \"position\":10,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"b560e680-dc03-46e9-bfea-5f29eee26dcb\",\n      \"logicalname\":\"content_image_2008.12.10.16.32.28_\",\n      \"translations\":{\n         \"nb_NO\":\"H\xF8y\",\n         \"fi_FI\":\"Hein\xE4\",\n         \"nn_NO\":\"H\xF8y\",\n         \"sv_SE\":\"H\xF6g\",\n         \"en_US\":\"Hay\",\n         \"da_DK\":\"H\xF8\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"hoey\",\n         \"flat\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":327,\n      \"height\":121,\n      \"position\":11,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"68aab3dd-f267-420a-b5b7-c897bd8dab29\",\n      \"logicalname\":\"content_image_2008.12.10.16.32.55_\",\n      \"translations\":{\n         \"nb_NO\":\"Vogn\",\n         \"fi_FI\":\"Vaunu\",\n         \"nn_NO\":\"Vogn\",\n         \"sv_SE\":\"Vagn\",\n         \"en_US\":\"Cart\",\n         \"da_DK\":\"Vogn\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":475,\n      \"height\":176,\n      \"position\":12,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"04ab09be-863a-4876-9b32-4785a922b133\",\n      \"logicalname\":\"content_image_2009.01.20.08.57.50_\",\n      \"translations\":{\n         \"nb_NO\":\"Korn\",\n         \"fi_FI\":\"Vilja\",\n         \"nn_NO\":\"Korn\",\n         \"sv_SE\":\"Korn\",\n         \"en_US\":\"Crops\",\n         \"da_DK\":\"Korn\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":162,\n      \"height\":144,\n      \"position\":13,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"b8bbdbeb-d75b-4cd2-bac6-cdc0aac5c98f\",\n      \"logicalname\":\"content_image_2009.01.20.08.57.58_\",\n      \"translations\":{\n         \"nb_NO\":\"Sigd\",\n         \"fi_FI\":\"Sirppi\",\n         \"nn_NO\":\"Sigd\",\n         \"sv_SE\":\"Sk\xE4ra\",\n         \"en_US\":\"Sickle\",\n         \"da_DK\":\"Segl\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":35,\n      \"height\":71,\n      \"position\":14,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"314fac86-c1aa-421c-b86a-070769272ad3\",\n      \"logicalname\":\"content_image_2008.12.10.16.34.34_\",\n      \"translations\":{\n         \"nb_NO\":\"Skriftestol\",\n         \"fi_FI\":\"Rippituoli\",\n         \"nn_NO\":\"Skriftestol\",\n         \"sv_SE\":\"Biktstol\",\n         \"en_US\":\"Confessional \",\n         \"da_DK\":\"Skriftestol\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \"forfra\",\n         \"skraa\"\n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":360,\n      \"height\":417,\n      \"position\":15,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"8f5842d6-f041-4bc8-99c2-f7fc618258a3\",\n      \"logicalname\":\"ma_lanse1_\",\n      \"translations\":{\n         \"nb_NO\":\"Lanse 1\",\n         \"fi_FI\":\"Peitsi 1\",\n         \"nn_NO\":\"Lanse 1\",\n         \"sv_SE\":\"Lans 2\",\n         \"en_US\":\"Lance 1\",\n         \"da_DK\":\"Lanse 1\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":520,\n      \"height\":36,\n      \"position\":16,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"7a0c91d6-40a7-4682-9459-bb2a359c4a82\",\n      \"logicalname\":\"ma_lanse2_\",\n      \"translations\":{\n         \"nb_NO\":\"Lanse 2\",\n         \"fi_FI\":\"Peitsi 2\",\n         \"nn_NO\":\"Lanse 2\",\n         \"sv_SE\":\"Lans 1\",\n         \"en_US\":\"Lance 2\",\n         \"da_DK\":\"Lanse 2\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":521,\n      \"height\":36,\n      \"position\":17,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"676470b3-9e96-4e38-b25b-6bbaa695ecde\",\n      \"logicalname\":\"ma_flagg1_\",\n      \"translations\":{\n         \"nb_NO\":\"Flagg 1\",\n         \"fi_FI\":\"Lippu 1\",\n         \"nn_NO\":\"Flagg 1\",\n         \"sv_SE\":\"Fana 2\",\n         \"en_US\":\"Flag 1\",\n         \"da_DK\":\"Flag 1\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":132,\n      \"height\":360,\n      \"position\":18,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"e593a47c-1b52-4df4-92e4-0ea95c3223b3\",\n      \"logicalname\":\"ma_flagg2_\",\n      \"translations\":{\n         \"nb_NO\":\"Flagg 2\",\n         \"fi_FI\":\"Lippu 2\",\n         \"nn_NO\":\"Flagg 2\",\n         \"sv_SE\":\"Fana 1\",\n         \"en_US\":\"Flag 2\",\n         \"da_DK\":\"Flag 2\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":132,\n      \"height\":360,\n      \"position\":19,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"ecc32bad-2098-4285-93f7-728db43692af\",\n      \"logicalname\":\"ma_skjold1_\",\n      \"translations\":{\n         \"nb_NO\":\"Skjold 1\",\n         \"fi_FI\":\"Kilpi 1\",\n         \"nn_NO\":\"Skjold 1\",\n         \"sv_SE\":\"Sk\xF6ld 1\",\n         \"en_US\":\"Shield 1\",\n         \"da_DK\":\"Skjold 1\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":126,\n      \"height\":199,\n      \"position\":20,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"f119ecbe-6157-42ec-9a98-ebb10add42df\",\n      \"logicalname\":\"ma_skjold2_\",\n      \"translations\":{\n         \"nb_NO\":\"Skjold 2\",\n         \"fi_FI\":\"Kilpi 2\",\n         \"nn_NO\":\"Skjold 2\",\n         \"sv_SE\":\"Sk\xF6ld 2\",\n         \"en_US\":\"Shield 2\",\n         \"da_DK\":\"Skjold 2\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":126,\n      \"height\":199,\n      \"position\":21,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"c06e9423-deed-43d3-b942-2d59ee90d85a\",\n      \"logicalname\":\"ma_sverd1_\",\n      \"translations\":{\n         \"nb_NO\":\"Sverd 1\",\n         \"fi_FI\":\"Miekka 1\",\n         \"nn_NO\":\"Sverd 1\",\n         \"sv_SE\":\"Sv\xE4rd 2\",\n         \"en_US\":\"Sword 1\",\n         \"da_DK\":\"Sv\xE6rd 1\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":63,\n      \"height\":285,\n      \"position\":22,\n      \"hidden\":2\n   },\n   {\n      \"id\":\"cb99e900-1016-49da-aacc-cc0974fd03f3\",\n      \"logicalname\":\"ma_sverd2_\",\n      \"translations\":{\n         \"nb_NO\":\"Sverd 2\",\n         \"fi_FI\":\"Miekka 2\",\n         \"nn_NO\":\"Sverd 2\",\n         \"sv_SE\":\"Sv\xE4rd 1\",\n         \"en_US\":\"Sword 2\",\n         \"da_DK\":\"Sv\xE6rd 2\"\n      },\n      \"theme\":\"middle_age\",\n      \"type\":\"props\",\n      \"moods\":[\n         \n      ],\n      \"tags\":[\n         \n      ],\n      \"width\":61,\n      \"height\":285,\n      \"position\":23,\n      \"hidden\":2\n   }\n]"
	};
	module.exports = exports["default"];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/docs/newThemeReloaded.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/docs/newThemeReloaded.js"); } } })();

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.default = {
	   data: "[\n   {\n      \"id\":\"6188f674-89af-48bc-b6ea-2dd7dc124cfd\",\n      \"name\":\"space\",\n      \"universe\":\"nature_science\",\n      \"translations\":{\n         \n      },\n      \"position\":2,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"77d6e7a4-870b-4bb8-a20e-ec61c65fc975\",\n      \"name\":\"dinosaurs\",\n      \"universe\":\"nature_science\",\n      \"translations\":{\n         \n      },\n      \"position\":3,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"ac8f7fb1-707e-4273-8927-53720fe23f68\",\n      \"name\":\"alloween\",\n      \"universe\":\"generic\",\n      \"translations\":{\n         \n      },\n      \"position\":3,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"a110a3b7-df09-4dcf-beff-9bca90c164e1\",\n      \"name\":\"christmas\",\n      \"universe\":\"generic\",\n      \"translations\":{\n         \n      },\n      \"position\":4,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"4b0705af-2c8e-4934-92cf-8fccd52d1943\",\n      \"name\":\"classic_cartoon_past\",\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      },\n      \"position\":0,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"26faeda9-720b-41a5-9b7e-d66ae76edc06\",\n      \"name\":\"classic_cartoon_present\",\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      },\n      \"position\":1,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"d7238ddf-10a1-48ce-a80d-03346d55b345\",\n      \"name\":\"classic_cartoon_future\",\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      },\n      \"position\":2,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"8a424dab-b65e-4a91-8df6-b18768de4a0f\",\n      \"name\":\"future\",\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      },\n      \"position\":3,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"d6197dcf-287a-4089-b1be-c495c8b64550\",\n      \"name\":\"manga\",\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      },\n      \"position\":4,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"24f29734-9086-4e93-abfb-500c0933c74e\",\n      \"name\":\"crazy\",\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      },\n      \"position\":5,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"1db47813-7170-4abb-8b2f-cc8062f9acd7\",\n      \"name\":\"norwegian_wood\",\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      },\n      \"position\":6,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"036c154f-285f-40b7-a090-97e102caf1df\",\n      \"name\":\"1001_nights\",\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      },\n      \"position\":7,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"97840354-e97c-4b58-a132-259ffea8669e\",\n      \"name\":\"little_red_riding_hood\",\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      },\n      \"position\":8,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"e18b0957-b4c6-4b78-a46f-f7cb5451b5e7\",\n      \"name\":\"three_billy_goats_gruff\",\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      },\n      \"position\":9,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"2a4f02f2-d790-4d31-aca5-b8b3df8a0217\",\n      \"name\":\"historical_figures_world\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":0,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"0e65e71e-2b87-4d09-83a2-ad432d273864\",\n      \"name\":\"international_politics_world\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":1,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"1c0420ff-439c-4b8d-8c81-63152a505fd2\",\n      \"name\":\"stone_age\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":2,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"da7f00f3-b6d5-4c43-83fd-7eeeab2cc3b4\",\n      \"name\":\"bronze_age\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":3,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"fde059ee-ad55-4964-91e8-2f6e29f1c837\",\n      \"name\":\"iron_age\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":4,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"6bf94cb4-23b0-4f0f-b6b8-fac892472b75\",\n      \"name\":\"egypt\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":5,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"5241609c-dac7-41af-a631-dda63ecd2af6\",\n      \"name\":\"ancient_greece\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":6,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"522cd220-1e82-4d53-be3b-92b0470319b3\",\n      \"name\":\"roman_empire\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":7,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"a026be5a-2961-4ccf-a840-48509bdb4a4e\",\n      \"name\":\"viking_age\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":8,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"45444c01-27cb-44bb-8496-562e434b8ed1\",\n      \"name\":\"world_war_2\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":11,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"8dd88b2d-a691-4409-b8e9-c6ea72b7f0a8\",\n      \"name\":\"post_war_period\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":12,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"f6b6f978-e6e2-4f95-bf68-59d74b6b6832\",\n      \"name\":\"18_19_century\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":9,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"2b69df46-0575-417b-a1ba-d4c5b7ffb5ea\",\n      \"name\":\"middle_age\",\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      },\n      \"position\":10,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"cbcac1e4-e41e-49f3-b9f4-31b7dbc5e219\",\n      \"name\":\"you_and_me\",\n      \"universe\":\"generic\",\n      \"translations\":{\n         \n      },\n      \"position\":1,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"26d23134-655b-449c-9207-77461367c725\",\n      \"name\":\"farm\",\n      \"universe\":\"generic\",\n      \"translations\":{\n         \n      },\n      \"position\":0,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"2eaf4998-1e0c-4046-b53f-1d64f8540278\",\n      \"name\":\"sustainable_development\",\n      \"universe\":\"nature_science\",\n      \"translations\":{\n         \n      },\n      \"position\":0,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"67874303-7f24-4f2f-bf78-ff09ce63ee6b\",\n      \"name\":\"biotechnology\",\n      \"universe\":\"nature_science\",\n      \"translations\":{\n         \n      },\n      \"position\":1,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"c2988776-5cd8-4533-bc4c-fb4756db1718\",\n      \"name\":\"insects\",\n      \"universe\":\"nature_science\",\n      \"translations\":{\n         \n      },\n      \"position\":4,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"10aca2a6-5d8a-479e-a2d0-fef074628b2f\",\n      \"name\":\"animals_and_landscapes\",\n      \"universe\":\"nature_science\",\n      \"translations\":{\n         \n      },\n      \"position\":5,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"c4c58a50-5ec6-47bf-b0ca-46ea1afe25e3\",\n      \"name\":\"body\",\n      \"universe\":\"nature_science\",\n      \"translations\":{\n         \n      },\n      \"position\":6,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"fa7f5a28-0e7b-477d-ae27-1f7cbabf5150\",\n      \"name\":\"science\",\n      \"universe\":\"nature_science\",\n      \"translations\":{\n         \n      },\n      \"position\":7,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"3c35a379-18e3-4fa5-9de9-bf066329854b\",\n      \"name\":\"candyland\",\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      },\n      \"position\":10,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"3ff13d2d-2a9b-405f-9ba7-961f6be3004d\",\n      \"name\":\"christmas_gospel\",\n      \"universe\":\"generic\",\n      \"translations\":{\n         \n      },\n      \"position\":5,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"57604f42-5d03-4a1d-8083-7b08b6df6f9e\",\n      \"name\":\"superheroes\",\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      },\n      \"position\":11,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"e2c3c647-c16e-48ab-bdfb-0e328c73311b\",\n      \"name\":\"identity\",\n      \"universe\":\"generic\",\n      \"translations\":{\n         \n      },\n      \"position\":6,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"24cbfe94-3097-4ae7-9262-c5d1cb21b9b8\",\n      \"name\":\"norge_i_dag\",\n      \"universe\":\"generic\",\n      \"translations\":{\n         \n      },\n      \"position\":7,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"16c14dd7-b7af-4406-8a12-c002703ef61c\",\n      \"name\":\"sverige_i_dag\",\n      \"universe\":\"generic\",\n      \"translations\":{\n         \n      },\n      \"position\":8,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"3affdc33-2c61-432a-8241-7b5a381f751e\",\n      \"name\":\"frames\",\n      \"universe\":\"generic\",\n      \"translations\":{\n         \n      },\n      \"position\":9,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"64ccf087-32a0-4592-afb6-63b7b44441c8\",\n      \"name\":\"easter_religious\",\n      \"universe\":\"generic\",\n      \"translations\":{\n         \n      },\n      \"position\":2,\n      \"hidden\":0\n   },\n   {\n      \"id\":\"b489a926-068b-4437-9fbe-5864fadaa9de\",\n      \"name\":\"easter_secular\",\n      \"universe\":\"generic\",\n      \"translations\":{\n         \n      },\n      \"position\":10,\n      \"hidden\":0\n   }\n]"
	};
	module.exports = exports["default"];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/docs/themesList.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/docs/themesList.js"); } } })();

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.default = {
	   data: "[\n   {\n      \"universe\":\"nature_science\",\n      \"translations\":{\n         \n      }\n   },\n   {\n      \"universe\":\"world_history\",\n      \"translations\":{\n         \n      }\n   },\n   {\n      \"universe\":\"fiction\",\n      \"translations\":{\n         \n      }\n   },\n   {\n      \"universe\":\"generic\",\n      \"translations\":{\n         \n      }\n   },\n   {\n      \"universe\":\"alphabet_planet\",\n      \"translations\":{\n         \n      }\n   }\n]"
	};
	module.exports = exports["default"];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/docs/universesList.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/docs/universesList.js"); } } })();

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.default = {
	   data: "[\n   {\n      \"id\":\"dfc97f0b-f217-428c-9c75-8438fb4e4f4f\",\n      \"name\":\"budapest\",\n      \"translations\":{\n         \"nb_NO\":\"Ungarn\",\n         \"nn_NO\":\"Ungarn\",\n         \"sv_SE\":\"Ungern\",\n         \"en_US\":\"Hungary\"\n      }\n   },\n   {\n      \"id\":\"29b4606c-0cef-46a7-bb4b-38cdb19aa38d\",\n      \"name\":\"loopable\",\n      \"translations\":{\n         \"nb_NO\":\"Repeterende bakgrunner\",\n         \"nn_NO\":\"Repeterande bakgrunnar\",\n         \"sv_SE\":\"Upprepande bakgrunder\",\n         \"en_US\":\"Loopable Backgrounds\"\n      }\n   },\n   {\n      \"id\":\"7b7fd4ee-6f46-42f2-b223-80b0e1e0e257\",\n      \"name\":\"istanbul\",\n      \"translations\":{\n         \"nb_NO\":\"Tyrkia\",\n         \"nn_NO\":\"Tyrkia\",\n         \"sv_SE\":\"Turkiet\",\n         \"en_US\":\"Turkey\"\n      }\n   },\n   {\n      \"id\":\"e0078830-6f11-41d6-99b8-4d8d03aac1b1\",\n      \"name\":\"animals\",\n      \"translations\":{\n         \"nb_NO\":\"Dyr\",\n         \"nn_NO\":\"Dyr\",\n         \"sv_SE\":\"Djur\",\n         \"en_US\":\"Animals\"\n      }\n   },\n   {\n      \"id\":\"aefbf04c-47a9-42ba-9d71-6a2281a40eb5\",\n      \"name\":\"paris\",\n      \"translations\":{\n         \"nb_NO\":\"Frankrike\",\n         \"nn_NO\":\"Frankrike\",\n         \"sv_SE\":\"Frankrike\",\n         \"en_US\":\"France\"\n      }\n   },\n   {\n      \"id\":\"6b562d0d-240e-4513-b43f-909993aada41\",\n      \"name\":\"barcelona\",\n      \"translations\":{\n         \"nb_NO\":\"Spania\",\n         \"nn_NO\":\"Spania\",\n         \"sv_SE\":\"Spanien\",\n         \"en_US\":\"Spain\"\n      }\n   },\n   {\n      \"id\":\"d9858b7f-65dc-45e4-8b07-1eb43ce8076d\",\n      \"name\":\"iceland\",\n      \"translations\":{\n         \"nb_NO\":\"Island\",\n         \"nn_NO\":\"Island\",\n         \"sv_SE\":\"Island\",\n         \"en_US\":\"Iceland\"\n      }\n   },\n   {\n      \"id\":\"73a47dbd-bcce-4b77-acd7-60b26c442b61\",\n      \"name\":\"mauritius\",\n      \"translations\":{\n         \"nb_NO\":\"Mauritius\",\n         \"nn_NO\":\"Mauritius\",\n         \"sv_SE\":\"Mauritius\",\n         \"en_US\":\"Mauritius\"\n      }\n   },\n   {\n      \"id\":\"2b01eeba-a1b1-4ffa-9d27-f47fe2f35ed1\",\n      \"name\":\"morocco\",\n      \"translations\":{\n         \"nb_NO\":\"Marokko\",\n         \"nn_NO\":\"Marokko\",\n         \"sv_SE\":\"Marocko\",\n         \"en_US\":\"Morocco\"\n      }\n   },\n   {\n      \"id\":\"ce6e96a1-0893-4e83-8062-ccde4c025f82\",\n      \"name\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Italia\",\n         \"nn_NO\":\"Italia\",\n         \"sv_SE\":\"Italien\",\n         \"en_US\":\"Italy\"\n      }\n   },\n   {\n      \"id\":\"c9fac56b-c21a-48fd-b155-020f7dcc8b88\",\n      \"name\":\"global\",\n      \"translations\":{\n         \"nb_NO\":\"Mennesker og natur\",\n         \"nn_NO\":\"Menneske og natur\",\n         \"sv_SE\":\"M\xE4nniskor och natur\",\n         \"en_US\":\"People And Nature\"\n      }\n   },\n   {\n      \"id\":\"0933509a-669a-4c82-a572-e45c93adeb40\",\n      \"name\":\"berlin\",\n      \"translations\":{\n         \"nb_NO\":\"Tyskland\",\n         \"nn_NO\":\"Tyskland\",\n         \"sv_SE\":\"Tyskland\",\n         \"en_US\":\"Germany\"\n      }\n   },\n   {\n      \"id\":\"22ddeaed-052b-44dd-9e90-d99f8cce4ad2\",\n      \"name\":\"london\",\n      \"translations\":{\n         \"nb_NO\":\"England\",\n         \"nn_NO\":\"England\",\n         \"sv_SE\":\"England\",\n         \"en_US\":\"England\"\n      }\n   },\n   {\n      \"id\":\"d29f46e7-800e-4977-94d1-fb7d43106fbc\",\n      \"name\":\"norway\",\n      \"translations\":{\n         \"nb_NO\":\"Norge\",\n         \"nn_NO\":\"Noreg\",\n         \"sv_SE\":\"Norge\",\n         \"en_US\":\"Norway\"\n      }\n   }\n]"
	};
	module.exports = exports["default"];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/docs/videoThemesList.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/docs/videoThemesList.js"); } } })();

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.default = {
	   data: "[\n   {\n      \"id\":\"754e81a6-d3e9-4c78-829f-354d34089914\",\n      \"logicalname\":\"creaza_italia_roma_010\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Tiberelven 2 (Roma)\",\n         \"nn_NO\":\"Tiberelva 2 (Roma)\",\n         \"sv_SE\":\"Tiber 2 (Rom)\",\n         \"en_US\":\"Tiber 2 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"9b1166e4-aa2b-4f86-a016-5bfd26801522\",\n      \"logicalname\":\"creaza_italia_candelora_001\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Kyndelsmesse 1 (Venezia)\",\n         \"nn_NO\":\"Kyndelsmesse 1 (Venezia)\",\n         \"sv_SE\":\"D\xEDa de la Candelaria 1 (Venedig)\",\n         \"en_US\":\"Candlemas 1 (Venice)\"\n      }\n   },\n   {\n      \"id\":\"71f50cf8-8986-4c6f-bd5c-9174ecd9d979\",\n      \"logicalname\":\"creaza_italia_candelora_002\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Kyndelsmesse 2 (Venezia)\",\n         \"nn_NO\":\"Kyndelsmesse 2 (Venezia)\",\n         \"sv_SE\":\"D\xEDa de la Candelaria 2 (Venedig)\",\n         \"en_US\":\"Candlemas 2 (Venice)\"\n      }\n   },\n   {\n      \"id\":\"a7a0025d-2ea2-4f4d-bc0c-4c22e3d702dc\",\n      \"logicalname\":\"creaza_italia_candelora_003\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Kyndelsmesse 3 (Venezia)\",\n         \"nn_NO\":\"Kyndelsmesse 3 (Venezia)\",\n         \"sv_SE\":\"D\xEDa de la Candelaria 3 (Venedig)\",\n         \"en_US\":\"Candlemas 3 (Venice)\"\n      }\n   },\n   {\n      \"id\":\"15e023f0-b9f2-4cc4-806d-a2188d01b3ee\",\n      \"logicalname\":\"creaza_italia_candelora_004\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Kyndelsmesse 4 (Venezia)\",\n         \"nn_NO\":\"Kyndelsmesse 4 (Venezia)\",\n         \"sv_SE\":\"D\xEDa de la Candelaria 4 (Venedig)\",\n         \"en_US\":\"Candlemas 4 (Venice)\"\n      }\n   },\n   {\n      \"id\":\"e54a263c-02ab-41e0-ae53-8298a7f2860a\",\n      \"logicalname\":\"creaza_italia_candelora_005\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Kyndelsmesse 5 (Venezia)\",\n         \"nn_NO\":\"Kyndelsmesse 5 (Venezia)\",\n         \"sv_SE\":\"D\xEDa de la Candelaria 5 (Venedig)\",\n         \"en_US\":\"Candlemas 5 (Venice)\"\n      }\n   },\n   {\n      \"id\":\"7267eac2-d601-4f33-8e55-ac0ffa086ffb\",\n      \"logicalname\":\"creaza_italia_candelora_006\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Kyndelsmesse 6 (Venezia)\",\n         \"nn_NO\":\"Kyndelsmesse 6 (Venezia)\",\n         \"sv_SE\":\"D\xEDa de la Candelaria 6 (Venedig)\",\n         \"en_US\":\"Candlemas 6 (Venice)\"\n      }\n   },\n   {\n      \"id\":\"1286e042-687e-4deb-aa00-5e28f46a8168\",\n      \"logicalname\":\"creaza_italia_candelora_007\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Kyndelsmesse 7 (Venezia)\",\n         \"nn_NO\":\"Kyndelsmesse 7 (Venezia)\",\n         \"sv_SE\":\"D\xEDa de la Candelaria 7 (Venedig)\",\n         \"en_US\":\"Candlemas 7 (Venice)\"\n      }\n   },\n   {\n      \"id\":\"7d99377a-127f-45d8-9e1e-eb056242ed39\",\n      \"logicalname\":\"creaza_italia_carneval_001\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Karneval (Italia)\",\n         \"nn_NO\":\"Karneval (Italia)\",\n         \"sv_SE\":\"Karneval (Italien)\",\n         \"en_US\":\"Carnival (Italy)\"\n      }\n   },\n   {\n      \"id\":\"0de56629-7316-4de5-9b01-a7632eb0a6cb\",\n      \"logicalname\":\"creaza_italia_carneval_002\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Karnevalsparade 1 (Italia)\",\n         \"nn_NO\":\"Karnevalsparade 1 (Italia)\",\n         \"sv_SE\":\"Karnevalparad 1 (Italien)\",\n         \"en_US\":\"Carnival parade 1 (Italy)\"\n      }\n   },\n   {\n      \"id\":\"541c9b7a-09bd-4be8-9526-02943e796b85\",\n      \"logicalname\":\"creaza_italia_carneval_003\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Karnevalsparade 2 (Italia)\",\n         \"nn_NO\":\"Karnevalsparade 2 (Italia)\",\n         \"sv_SE\":\"Karnevalparad 2 (Italien)\",\n         \"en_US\":\"Carnival parade 2 (Italy)\"\n      }\n   },\n   {\n      \"id\":\"68fbbce9-2ab6-4f54-b884-9adccbaea0f2\",\n      \"logicalname\":\"creaza_italia_carneval_004\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Karnevalsparade 3 (Italia)\",\n         \"nn_NO\":\"Karnevalsparade 3 (Italia)\",\n         \"sv_SE\":\"Karneval-parad 3 (Italien)\",\n         \"en_US\":\"Carnival parade 3 (Italy)\"\n      }\n   },\n   {\n      \"id\":\"e12476b5-61a5-4e1e-85f6-24342605b4e9\",\n      \"logicalname\":\"creaza_italia_carneval_005\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Karnevalsparade 4 (Italia)\",\n         \"nn_NO\":\"Karnevalsparade 4 (Italia)\",\n         \"sv_SE\":\"Karneval-parad 4 (Italien)\",\n         \"en_US\":\"Carnival parade 4 (Italy)\"\n      }\n   },\n   {\n      \"id\":\"2ffe8f14-3090-4d15-b693-2c95042beb08\",\n      \"logicalname\":\"creaza_italia_catania_001\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Duomo-plassen (Catania)\",\n         \"nn_NO\":\"Duomo-plassen (Catania)\",\n         \"sv_SE\":\"Piazza Duomo (Katania)\",\n         \"en_US\":\"Piazza Duomo (Catania)\"\n      }\n   },\n   {\n      \"id\":\"516be8c6-b124-477e-bcc1-30b2327e092d\",\n      \"logicalname\":\"creaza_italia_catania_002\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Biscari-palasset (Catania)\",\n         \"nn_NO\":\"Biscari-palasset (Catania)\",\n         \"sv_SE\":\"Palazzo Biscari (Kantania)\",\n         \"en_US\":\"Palazzo Biscari (Catania)\"\n      }\n   },\n   {\n      \"id\":\"a12c4077-68f3-4445-8de0-9b9421629b9b\",\n      \"logicalname\":\"creaza_italia_catania_003\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Marionetter (Catania)\",\n         \"nn_NO\":\"Marionettar (Catania)\",\n         \"sv_SE\":\"Dockor (Katania)\",\n         \"en_US\":\"Puppets (Catania)\"\n      }\n   },\n   {\n      \"id\":\"6111db96-4633-48c3-b74c-cac6ad16ce94\",\n      \"logicalname\":\"creaza_italia_catania_004\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Appelsinselger (Catania)\",\n         \"nn_NO\":\"Appelsinseljar (Catania)\",\n         \"sv_SE\":\"Apelsinf\xF6rs\xE4ljare (Katania)\",\n         \"en_US\":\"Orange salesman (Catania)\"\n      }\n   },\n   {\n      \"id\":\"ce3920eb-664b-4cac-b4b7-8f3725cb3a50\",\n      \"logicalname\":\"creaza_italia_catania_005\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Sankt Nikolas-kirken (Catania)\",\n         \"nn_NO\":\"Sankt Nikolas-kyrkja (Catania)\",\n         \"sv_SE\":\"San Nicolo kyrkan (Katania)\",\n         \"en_US\":\"The Church of San Nicolo (Catania)\"\n      }\n   },\n   {\n      \"id\":\"0d9c2c7c-ebbc-41ee-8dc0-3dc3c34f3b7a\",\n      \"logicalname\":\"creaza_italia_catania_008\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Sankt Agatha-katedralen (Catania)\",\n         \"nn_NO\":\"Sankt Agatha-katedralen (Catania)\",\n         \"sv_SE\":\"St. Agathas katedral (Catania)\",\n         \"en_US\":\"Cathedral of St. Agatha (Catania)\"\n      }\n   },\n   {\n      \"id\":\"9489eacc-561b-4be3-b863-7d212bca090b\",\n      \"logicalname\":\"creaza_italia_catania_009\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Fiskemarked 1 (Catania)\",\n         \"nn_NO\":\"Fiskemarknad 1 (Catania)\",\n         \"sv_SE\":\"Fiskmarknad1 (Katania)\",\n         \"en_US\":\"Fish market 1 (Catania)\"\n      }\n   },\n   {\n      \"id\":\"d29f1999-59fe-422b-9970-e5ecc606d850\",\n      \"logicalname\":\"creaza_italia_catania_010\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Fiskemarked 2 (Catania)\",\n         \"nn_NO\":\"Fiskemarknad 2 (Catania)\",\n         \"sv_SE\":\"Fiskmarknad 2 (Katania)\",\n         \"en_US\":\"Fish market 2 (Catania)\"\n      }\n   },\n   {\n      \"id\":\"dcc27e26-51cb-4dec-a277-7de698b560f0\",\n      \"logicalname\":\"creaza_italia_firenze_001\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Katedral (Firenze)\",\n         \"nn_NO\":\"Katedral (Firenze)\",\n         \"sv_SE\":\"Florens katedral (Florens)\",\n         \"en_US\":\"Florence Cathedral (Florence)\"\n      }\n   },\n   {\n      \"id\":\"f3299814-0ba0-4782-a912-23048d5bf230\",\n      \"logicalname\":\"creaza_italia_firenze_002\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Basilica di Santa Maria del Fiore (Firenze)\",\n         \"nn_NO\":\"Basilica di Santa Maria del Fiore (Firenze)\",\n         \"sv_SE\":\"Ponte Vecchio (Florens)\",\n         \"en_US\":\"Ponte Vecchio (Florence)\"\n      }\n   },\n   {\n      \"id\":\"21c15b50-a573-49f6-bec9-e5b4c9e4bc0a\",\n      \"logicalname\":\"creaza_italia_firenze_003\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Pinokkiodukker (Firenze)\",\n         \"nn_NO\":\"Pinokkiodukker (Firenze)\",\n         \"sv_SE\":\"Pinocchio (Florens)\",\n         \"en_US\":\"Pinocchio (Florence)\"\n      }\n   },\n   {\n      \"id\":\"22da785f-9701-487f-95b9-3e7720c95485\",\n      \"logicalname\":\"creaza_italia_firenze_004\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Brunelleschi, utsikt 1 (Firenze)\",\n         \"nn_NO\":\"Brunelleschi, utsikt 1 (Firenze)\",\n         \"sv_SE\":\"Brunelleschi utsikt 1 (Florens)\",\n         \"en_US\":\"Brunelleschi view 1 (Florence)\"\n      }\n   },\n   {\n      \"id\":\"bed456c5-3d54-482c-96ae-337a077dd50c\",\n      \"logicalname\":\"creaza_italia_firenze_005\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Ponte Vecchio, utsikt mot bro (firenze)\",\n         \"nn_NO\":\"Ponte Vecchio, utsikt mot bru (firenze)\",\n         \"sv_SE\":\"Ponte Vecchio, vy mot bron (Florens)\",\n         \"en_US\":\"Ponte Vecchio, view towards bridge (Florence)\"\n      }\n   },\n   {\n      \"id\":\"b251be11-1d8e-4f05-b483-513dc5f7d41a\",\n      \"logicalname\":\"creaza_italia_firenze_006\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Duer p\xE5 gaten (Firenze)\",\n         \"nn_NO\":\"Duer p\xE5 gata (Firenze)\",\n         \"sv_SE\":\"Duvor p\xE5 gatan (Florens)\",\n         \"en_US\":\"Pigeons on the street (Florence)\"\n      }\n   },\n   {\n      \"id\":\"386fbc2b-efa5-46f2-95df-dee58a238440\",\n      \"logicalname\":\"creaza_italia_firenze_007\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Signoria t\xE5rn (Firenze)\",\n         \"nn_NO\":\"Signoria t\xE5rn (Firenze)\",\n         \"sv_SE\":\"Signoria Tower (Florence)\",\n         \"en_US\":\"Signoria Tower (Florence)\"\n      }\n   },\n   {\n      \"id\":\"4120f595-ce2e-4c02-af07-a6c4a51b8a98\",\n      \"logicalname\":\"creaza_italia_firenze_008\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Brunelleschi, utsikt 2 (Firenze)\",\n         \"nn_NO\":\"Brunelleschi, utsikt 2 (Firenze)\",\n         \"sv_SE\":\"Brunelleschi utsikt 2 (Florens)\",\n         \"en_US\":\"Brunelleschi view 2 (Florence)\"\n      }\n   },\n   {\n      \"id\":\"8dc17583-8fac-4a5d-bfac-dd88e17092a2\",\n      \"logicalname\":\"creaza_italia_firenze_009\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"David-skulptur (Firenze)\",\n         \"nn_NO\":\"David-skulptur (Firenze)\",\n         \"sv_SE\":\"David (Florens)\",\n         \"en_US\":\"David (Florence)\"\n      }\n   },\n   {\n      \"id\":\"f8e9ef12-ab2c-45b4-9f8e-60166479a0b0\",\n      \"logicalname\":\"creaza_italia_firenze_010\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Brunelleschi, interi\xF8r (Firenze)\",\n         \"nn_NO\":\"Brunelleschi, inne (Firenze)\",\n         \"sv_SE\":\"Brunelleschi insida (Florens)\",\n         \"en_US\":\"Brunelleschi interior (Florence)\"\n      }\n   },\n   {\n      \"id\":\"a5e95ddb-739f-4128-8034-b07feeaaf4dd\",\n      \"logicalname\":\"creaza_italia_palermo_001\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Katedral, reflektert (Palermo)\",\n         \"nn_NO\":\"Katedral, refleksjon (Palermo)\",\n         \"sv_SE\":\"Reflektioner av katedral (Palermo)\",\n         \"en_US\":\"Cathedral reflection (Palermo)\"\n      }\n   },\n   {\n      \"id\":\"8d456a17-a4b4-46c4-9352-a2538f72a7c4\",\n      \"logicalname\":\"creaza_italia_palermo_002\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Vucciria-markedet (Palermo)\",\n         \"nn_NO\":\"Vucciria-marknaden (Palermo)\",\n         \"sv_SE\":\"Vucciria marknad (Palermo)\",\n         \"en_US\":\"Vucciria Market (Palermo)\"\n      }\n   },\n   {\n      \"id\":\"085b87df-af20-4109-9145-d8939d3d7b1c\",\n      \"logicalname\":\"creaza_italia_palermo_003\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Gatealter (Palermo)\",\n         \"nn_NO\":\"Gatealter (Palermo)\",\n         \"sv_SE\":\"V\xE4ggljus (Palermo)\",\n         \"en_US\":\"Wall shrine (Palermo)\"\n      }\n   },\n   {\n      \"id\":\"0b4bc844-a178-44a0-be65-1c4ca2650687\",\n      \"logicalname\":\"creaza_italia_palermo_004\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Santa Rosalia-fest 1 (Palermo)\",\n         \"nn_NO\":\"Santa Rosalia-fest 1 (Palermo)\",\n         \"sv_SE\":\"Rosfestivalen 1 (Palermo)\",\n         \"en_US\":\"Festa S. Rosalia 1 (Palermo)\"\n      }\n   },\n   {\n      \"id\":\"1759ec4c-515c-4e96-ba85-7ffe3f103bb3\",\n      \"logicalname\":\"creaza_italia_palermo_005\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Santa Rosalia-fest 2 (Palermo)\",\n         \"nn_NO\":\"Santa Rosalia-fest 2 (Palermo)\",\n         \"sv_SE\":\"Rosfestivalen 2 (Palermo)\",\n         \"en_US\":\"Festa S. Rosalia 2 (Palermo)\"\n      }\n   },\n   {\n      \"id\":\"f2f7cdb1-faa9-416c-8361-4d51c20a03be\",\n      \"logicalname\":\"creaza_italia_palermo_006\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Hestevogn (Palermo)\",\n         \"nn_NO\":\"Hestevogn (Palermo)\",\n         \"sv_SE\":\"H\xE4st och vagn (Palermo)\",\n         \"en_US\":\"Horse cart (Palermo)\"\n      }\n   },\n   {\n      \"id\":\"0420d62e-0c9f-4624-bb2e-9b3a36b85c56\",\n      \"logicalname\":\"creaza_italia_roma_001\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Tiberelven 1 (Roma)\",\n         \"nn_NO\":\"Tiberelva 1 (Roma)\",\n         \"sv_SE\":\"Tiber 1 (Rom)\",\n         \"en_US\":\"Tiber 1 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"58b57b3f-0467-4ef6-9ab6-f6d59b923e08\",\n      \"logicalname\":\"creaza_italia_roma_002\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Jupiter-statue (Roma)\",\n         \"nn_NO\":\"Jupiter-statue (Roma)\",\n         \"sv_SE\":\"Jupiter statyn (Rom)\",\n         \"en_US\":\"Jupiter statue (Rome)\"\n      }\n   },\n   {\n      \"id\":\"06c13146-ce54-40f9-859b-d4c40df34804\",\n      \"logicalname\":\"creaza_italia_roma_003\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Campidoglio-plassen 1 (Roma)\",\n         \"nn_NO\":\"Campidoglio-plassen 1 (Roma)\",\n         \"sv_SE\":\"Piazza del Campidoglio 1 (Rom)\",\n         \"en_US\":\"Piazza del Campidoglio 1 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"61f11987-d774-4b68-a4be-5799a3fe2b95\",\n      \"logicalname\":\"creaza_italia_roma_004\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Triumfbue (Roma)\",\n         \"nn_NO\":\"Triumfboge (Roma)\",\n         \"sv_SE\":\"Triumfb\xE5gen (Rom)\",\n         \"en_US\":\"Triumphal Arch (Rome)\"\n      }\n   },\n   {\n      \"id\":\"b520f556-4b35-432b-8b83-1b723eccddf9\",\n      \"logicalname\":\"creaza_italia_roma_005\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Petersplassen (Roma)\",\n         \"nn_NO\":\"Petersplassen (Roma)\",\n         \"sv_SE\":\"Petersplatsen (Rom)\",\n         \"en_US\":\"St. Peter's Square (Rome)\"\n      }\n   },\n   {\n      \"id\":\"82a855f9-cf21-4b84-800d-8bff329ed8ed\",\n      \"logicalname\":\"creaza_italia_roma_006\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Trajans\xF8ylen (Roma)\",\n         \"nn_NO\":\"Trajans\xF8yla (Roma)\",\n         \"sv_SE\":\"Trajanuskolonnen (Rom)\",\n         \"en_US\":\"Trajan's Column (Rome)\"\n      }\n   },\n   {\n      \"id\":\"6055f637-7df2-4a5b-8816-26697efe4450\",\n      \"logicalname\":\"creaza_italia_roma_007\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Forum Romanum (Roma)\",\n         \"nn_NO\":\"Forum Romanum (Roma)\",\n         \"sv_SE\":\"Forum Romanum (Rom)\",\n         \"en_US\":\"Forum Romanum (Rome)\"\n      }\n   },\n   {\n      \"id\":\"c5ce8207-7dee-4896-bada-c4751ec2a3a7\",\n      \"logicalname\":\"creaza_italia_roma_008\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Circus Maximus (Roma)\",\n         \"nn_NO\":\"Circus Maximus (Roma)\",\n         \"sv_SE\":\"Circus Maximus (Rom)\",\n         \"en_US\":\"Circus Maximus (Rome)\"\n      }\n   },\n   {\n      \"id\":\"cba049fb-6dcb-4733-beb4-89e02de95d62\",\n      \"logicalname\":\"creaza_italia_roma_009\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Campidoglio-plassen 2 (Roma)\",\n         \"nn_NO\":\"Campidoglio-plassen 2 (Roma)\",\n         \"sv_SE\":\"Piazza del Campidoglio 2 (Rom)\",\n         \"en_US\":\"Piazza del Campidoglio 2 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"7eb9a6d2-4346-4f09-b391-8f0935d3c011\",\n      \"logicalname\":\"creaza_italia_roma_011\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Peterskirken (Roma)\",\n         \"nn_NO\":\"Peterskyrkja (Roma)\",\n         \"sv_SE\":\"Peterskyrkan (Rom)\",\n         \"en_US\":\"St. Peter's Basilica (Rome)\"\n      }\n   },\n   {\n      \"id\":\"73afafac-18d0-4c05-bb28-629e3933b115\",\n      \"logicalname\":\"creaza_italia_roma_012\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Tiberelven 3 (Roma)\",\n         \"nn_NO\":\"Tiberelva 3 (Roma)\",\n         \"sv_SE\":\"Tiber 3 (Rom)\",\n         \"en_US\":\"Tiber 3 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"2fd29433-ffe0-4fc2-989a-68e605488e50\",\n      \"logicalname\":\"creaza_italia_roma_013\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Snurrende plakat (Roma)\",\n         \"nn_NO\":\"Snurrande plakat (Roma)\",\n         \"sv_SE\":\"Snurrande tavla (Rom)\",\n         \"en_US\":\"Revolving Poster (Rome)\"\n      }\n   },\n   {\n      \"id\":\"534f9212-d26b-41db-b8a2-4b78c2d4d2e9\",\n      \"logicalname\":\"creaza_italia_roma_014\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Tiberelven 4 (Roma)\",\n         \"nn_NO\":\"Tiberelva 4 (Roma)\",\n         \"sv_SE\":\"Tiber 4 (Rom)\",\n         \"en_US\":\"Tiber 4 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"de058146-3b3a-433d-b6ce-8ef16270477a\",\n      \"logicalname\":\"creaza_italia_roma_016\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Santa Maria Maggiore (Roma)\",\n         \"nn_NO\":\"Santa Maria Maggiore (Roma)\",\n         \"sv_SE\":\"Santa Maria Maggiore kyrka (Rom)\",\n         \"en_US\":\"Basilica Santa Maria Maggiore (Rome)\"\n      }\n   },\n   {\n      \"id\":\"39b03c8e-f8bd-4368-9dc3-a6fa7b5b872a\",\n      \"logicalname\":\"creaza_italia_roma_017\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Trajans marked (Roma)\",\n         \"nn_NO\":\"Trajan-marknadane (Roma)\",\n         \"sv_SE\":\"Trajanus Saluhallar (Rom)\",\n         \"en_US\":\"Trajan's Markets (Rome)\"\n      }\n   },\n   {\n      \"id\":\"62d7363e-9b33-423d-9a58-4f67616b1154\",\n      \"logicalname\":\"creaza_italia_roma_018\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Alter (Roma)\",\n         \"nn_NO\":\"Alter (Roma)\",\n         \"sv_SE\":\"Viktor Emanuel-monumentet (Rom)\",\n         \"en_US\":\"Altar (Rome)\"\n      }\n   },\n   {\n      \"id\":\"b97e61ef-e85b-46c9-907d-710bd4601628\",\n      \"logicalname\":\"creaza_italia_roma_019\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Pantheon, inne (Roma)\",\n         \"nn_NO\":\"Pantheon interl\xF8r (Roma)\",\n         \"sv_SE\":\"Pantheon insida (Rom)\",\n         \"en_US\":\"Pantheon, interior (Rome)\"\n      }\n   },\n   {\n      \"id\":\"a9f3feee-8a6d-42af-9fae-3965b121cc8c\",\n      \"logicalname\":\"creaza_italia_roma_020\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Pantheon, ute (Roma)\",\n         \"nn_NO\":\"Pantheon, ute (Roma)\",\n         \"sv_SE\":\"Pantheon, Utsida (Rom)\",\n         \"en_US\":\"Pantheon, exterior (Rome)\"\n      }\n   },\n   {\n      \"id\":\"3af7f12a-1a02-4eed-b6c8-011a3e7ae5b9\",\n      \"logicalname\":\"creaza_italia_roma_021\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Peterskirken interi\xF8r 1 (Roma)\",\n         \"nn_NO\":\"Peterskyrkja, inne 1 (Roma)\",\n         \"sv_SE\":\"Peterkyrkan, insida 1 (Rom)\",\n         \"en_US\":\"St. Peter's Basilica, interior 1 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"995f7a64-809f-4f2d-965b-e54398a78177\",\n      \"logicalname\":\"creaza_italia_roma_022\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Peterskirken, ute 1 (Roma)\",\n         \"nn_NO\":\"Peterskyrkja, ute 1 (Roma)\",\n         \"sv_SE\":\"Peterskyrkan, utsida 1 (Rom)\",\n         \"en_US\":\"St. Peter's Basilica, exterior 1 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"57b4be03-0100-4565-b356-ed40961ee117\",\n      \"logicalname\":\"creaza_italia_roma_023\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Peterskirken interi\xF8r 2 (Roma)\",\n         \"nn_NO\":\"Peterskyrkja, inne 2 (Roma)\",\n         \"sv_SE\":\"Peterskyrkan, insida 2 (Rom)\",\n         \"en_US\":\"St. Peter's Basilica, interior 2 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"b2598c5f-fee6-44af-81f4-13a21b0b20eb\",\n      \"logicalname\":\"creaza_italia_roma_024\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Peterskirken interi\xF8r 3 (Roma)\",\n         \"nn_NO\":\"Peterskyrkja, inne 3 (Roma)\",\n         \"sv_SE\":\"Peterskyrkan, insida 3 (Rom)\",\n         \"en_US\":\"St. Peter's Basilica, interior 3 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"67f3bc2e-e944-4e09-8ea1-fd77c87f9d1c\",\n      \"logicalname\":\"creaza_italia_roma_025\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Piet\xE0 (Roma)\",\n         \"nn_NO\":\"Piet\xE0 (Roma)\",\n         \"sv_SE\":\"Piet\xE0 (Rom)\",\n         \"en_US\":\"Piet\xE0 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"7498bb67-8184-4553-a65a-6e157324e5bd\",\n      \"logicalname\":\"creaza_italia_roma_026\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Peterskirken interi\xF8r 4 (Roma)\",\n         \"nn_NO\":\"Peterskyrkja, inne 4 (Roma)\",\n         \"sv_SE\":\"Peterskyrkan, insida 4 (Rom)\",\n         \"en_US\":\"St. Peter's Basilica, interior 4 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"436ce7f8-588e-4db6-a741-a0ef152128f7\",\n      \"logicalname\":\"creaza_italia_roma_027\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Peterskirken interi\xF8r 5 (Roma)\",\n         \"nn_NO\":\"Peterskyrkja, inne 5 (Roma)\",\n         \"sv_SE\":\"Peterskyrkan, insida 5 (Rom)\",\n         \"en_US\":\"St. Peter's Basilica, interior 5 (Rome)\"\n      }\n   },\n   {\n      \"id\":\"cbdc8b3e-e089-4785-9f65-1329615c667c\",\n      \"logicalname\":\"creaza_italia_venice_001\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Gondol ved Sospiri bro (Venezia)\",\n         \"nn_NO\":\"Gondol ved Sospiri bru (Venezia)\",\n         \"sv_SE\":\"Gondoler vid Sighs bro (Venedig)\",\n         \"en_US\":\"Gondolas at the Bridge of Sighs (Venice)\"\n      }\n   },\n   {\n      \"id\":\"1c3c060a-b8b1-49d9-bf9e-5ee9c4e9d0b4\",\n      \"logicalname\":\"creaza_italia_venice_002\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Gondoler foran San Giorgio 1 (Venezia)\",\n         \"nn_NO\":\"Gondolar framf\xF8re San Giorgio 1 (Venezia)\",\n         \"sv_SE\":\"Gondoler framf\xF6r St. George\u2019s basilika 1 (Venice)\",\n         \"en_US\":\"Gondolas in front of St. George\u2019s church 1 (Venice)\"\n      }\n   },\n   {\n      \"id\":\"0bd89321-a892-4f74-b57b-0795d0477984\",\n      \"logicalname\":\"creaza_italia_venice_003\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Gondoler foran San Giorgio 2 (Venezia)\",\n         \"nn_NO\":\"Gondolar framf\xF8re San Giorgio 2 (Venezia)\",\n         \"sv_SE\":\"Gondoler framf\xF6r St. George\u2019s basilika 2 (Venice)\",\n         \"en_US\":\"Gondolas in front of St. George\u2019s church 2 (Venice)\"\n      }\n   },\n   {\n      \"id\":\"efebbc36-5ff1-4c17-b83c-0bfd1908f387\",\n      \"logicalname\":\"creaza_italia_venice_004\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Fra San Marco-t\xE5rnet (Roma)\",\n         \"nn_NO\":\"Fr\xE5 San Marco-t\xE5rnet (Roma)\",\n         \"sv_SE\":\"Fr\xE5n San Marco Campanile (Venice)\",\n         \"en_US\":\"From St. Mark\u2019s Tower (Venice)\"\n      }\n   },\n   {\n      \"id\":\"a255512a-ff1c-494c-b8db-99c1cfe3b07a\",\n      \"logicalname\":\"creaza_italia_venice_005\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Canal Grande (Venezia)\",\n         \"nn_NO\":\"Canal Grande (Venezia)\",\n         \"sv_SE\":\"Stora kanalen (Venice)\",\n         \"en_US\":\"Grand Canal (Venice)\"\n      }\n   },\n   {\n      \"id\":\"fc2e7edc-2d6c-4d38-86c1-f7d5bf53cb23\",\n      \"logicalname\":\"creaza_italia_venice_006\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Kanal (Venezia)\",\n         \"nn_NO\":\"Kanal (Venezia)\",\n         \"sv_SE\":\"Kanaler (Venice)\",\n         \"en_US\":\"Canals (Venice)\"\n      }\n   },\n   {\n      \"id\":\"e58fdace-4757-4c40-b7e5-edb24dda5509\",\n      \"logicalname\":\"creaza_italia_venice_007\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Utsikt fra Dogana-broen (Venezia)\",\n         \"nn_NO\":\"Utsikt fr\xE5 Dogana-brua (Venezia)\",\n         \"sv_SE\":\"Vy fr\xE5n Dogana De Mare (Venice)\",\n         \"en_US\":\"View from Dogana Bridge (Venice)\"\n      }\n   },\n   {\n      \"id\":\"4afd5bba-a5fa-4050-8a86-e7565d7ec4d2\",\n      \"logicalname\":\"creaza_italia_venice_008\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Gondoler (Venezia)\",\n         \"nn_NO\":\"Gondolar (Venezia)\",\n         \"sv_SE\":\"Gondoler (Venice)\",\n         \"en_US\":\"Gondolas (Venice)\"\n      }\n   },\n   {\n      \"id\":\"3e96b7f4-304a-4e6f-be78-c788bae744c1\",\n      \"logicalname\":\"creaza_italia_venice_009\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Gondoler (Venezia)\",\n         \"nn_NO\":\"Gondolar (Venezia)\",\n         \"sv_SE\":\"Gondoler 2 (Venice)\",\n         \"en_US\":\"Gondolas (Venice)\"\n      }\n   },\n   {\n      \"id\":\"2d0db9e3-778f-40e2-a639-52421d89d4f4\",\n      \"logicalname\":\"creaza_italia_venice_010\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"San Marco-plassen (Venezia)\",\n         \"nn_NO\":\"San Marco-plassen (Venezia)\",\n         \"sv_SE\":\"Markusplatsen (Venice)\",\n         \"en_US\":\"St. Mark's Square (Venice)\"\n      }\n   },\n   {\n      \"id\":\"f015bf68-cab3-4611-994f-7ae455ab943d\",\n      \"logicalname\":\"creaza_italia_venice_011\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Inni San Giorgio-kirken (Venezia)\",\n         \"nn_NO\":\"San Giorgio-kyrkja, inne (Venezia)\",\n         \"sv_SE\":\"Insidan av St. George's Basilika (Venice)\",\n         \"en_US\":\"Interior of St. George's Church (Venice)\"\n      }\n   },\n   {\n      \"id\":\"c0958036-a314-4e8f-872e-9d22b3ce7cba\",\n      \"logicalname\":\"creaza_italia_venice_012\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Lite fiskemarked (Venezia)\",\n         \"nn_NO\":\"Liten fiskemarknad (Venezia)\",\n         \"sv_SE\":\"Liten fiskmarknad (Venice)\",\n         \"en_US\":\"Small fish market (Venice)\"\n      }\n   },\n   {\n      \"id\":\"bd99b535-c8bb-4bee-8e42-c2a8721dd31e\",\n      \"logicalname\":\"creaza_italia_venice_013\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Gondol (Venezia)\",\n         \"nn_NO\":\"Gondol (Venezia)\",\n         \"sv_SE\":\"En gondol (Venice)\",\n         \"en_US\":\"Gondola (Venice)\"\n      }\n   },\n   {\n      \"id\":\"0e9f8955-58cf-49be-8ba8-70327b4a5ad2\",\n      \"logicalname\":\"creaza_italia_venice_014\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Mot Realto-broen (Venezia)\",\n         \"nn_NO\":\"Mot Realto-brua (Venezia)\",\n         \"sv_SE\":\"Mot Rialtobron (Venice)\",\n         \"en_US\":\"Towards the Rialto Bridge (Venice)\"\n      }\n   },\n   {\n      \"id\":\"d6d964fd-fe2f-4d62-9867-b715fad8e0bc\",\n      \"logicalname\":\"creaza_italia_venice_015\",\n      \"theme\":\"italy\",\n      \"translations\":{\n         \"nb_NO\":\"Rialto-broen om natten (Venezia)\",\n         \"nn_NO\":\"Rialto-brua om natta (Venezia)\",\n         \"sv_SE\":\"Rialtobron p\xE5 natten (Venice)\",\n         \"en_US\":\"Rialto Bridge at night (Venice)\"\n      }\n   }\n]"
	};
	module.exports = exports["default"];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/docs/video_italy.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/docs/video_italy.js"); } } })();

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.App = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Browser = __webpack_require__(757);
	
	var _SlideViewer = __webpack_require__(847);
	
	var _Canvas = __webpack_require__(839);
	
	var _PreviewMenu = __webpack_require__(808);
	
	var _ResizeAccordionButton = __webpack_require__(341);
	
	var _ContextMenu = __webpack_require__(331);
	
	var _DeleteAlert = __webpack_require__(332);
	
	var _TextEditor = __webpack_require__(825);
	
	var _AudioAlert = __webpack_require__(328);
	
	var _ExportAlert = __webpack_require__(335);
	
	var _ProductTitleAlert = __webpack_require__(339);
	
	var _AlternativeTextForSlideMenu = __webpack_require__(773);
	
	var _DescriptionMenu = __webpack_require__(333);
	
	var _ExitAlert = __webpack_require__(334);
	
	var _MainMenu = __webpack_require__(797);
	
	var _RecorderPopup = __webpack_require__(340);
	
	var _LostSessionAlert = __webpack_require__(336);
	
	var _NoInternetConnectionAlert = __webpack_require__(338);
	
	var _AppLoader = __webpack_require__(229);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _App = __webpack_require__(290);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _CanvasScaleUtils = __webpack_require__(171);
	
	var _CanvasScaleUtils2 = _interopRequireDefault(_CanvasScaleUtils);
	
	var _Loader = __webpack_require__(230);
	
	var _NavigationBar = __webpack_require__(337);
	
	var _ZoomMenu = __webpack_require__(827);
	
	var _CroppingMenu = __webpack_require__(784);
	
	var _InternetExplorerAlert = __webpack_require__(232);
	
	var _NoAccessAlert = __webpack_require__(233);
	
	var _DownloadPage = __webpack_require__(785);
	
	var _SearchMenu = __webpack_require__(342);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _GroupManager = __webpack_require__(142);
	
	var _GroupManager2 = _interopRequireDefault(_GroupManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PopulateMediaFilesUtils = __webpack_require__(80);
	
	var _PopulateMediaFilesUtils2 = _interopRequireDefault(_PopulateMediaFilesUtils);
	
	var _ExporterUtils = __webpack_require__(93);
	
	var _ExporterUtils2 = _interopRequireDefault(_ExporterUtils);
	
	var _SlidesUtils = __webpack_require__(125);
	
	var _SlidesUtils2 = _interopRequireDefault(_SlidesUtils);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AudioVolumeUtils = __webpack_require__(67);
	
	var _AudioVolumeUtils2 = _interopRequireDefault(_AudioVolumeUtils);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppWrapper = _react2.default.createClass({
	    displayName: 'AppWrapper',
	
	    propTypes: {
	        children: _react2.default.PropTypes.object,
	        appReady: _react2.default.PropTypes.bool
	    },
	    getInitialState: function getInitialState() {
	        return {
	            originalWidth: -1,
	            originalHeight: -1
	        };
	    },
	    onScroll: function onScroll(e) {
	        e.preventDefault();
	        e.stopPropagation();
	        window.scrollTo(0, 0);
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) // Enter ... used to close the Keyboard on the iPads
	            window.scrollTo(0, 0);
	    },
	    onKeyDownHandler: function onKeyDownHandler(e) {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
	
	        if (!isTabPressed) {
	            return;
	        }
	
	        var modal;
	        var firstFocusableEl;
	        var lastFocusableEl;
	
	        modal = document.getElementById('exportPopup');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('exportFirstFocusableCheckBox');
	
	            if (!firstFocusableEl) firstFocusableEl = document.getElementById('exportFirstFocusableButton');
	
	            lastFocusableEl = document.getElementById('exportLastFocusableButton');
	        }
	
	        modal = document.getElementById('productionInitialTitleAlert');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('productionInitialTitle');
	            lastFocusableEl = document.getElementById('productionInitialTitleButton');
	        }
	
	        modal = document.getElementById('alternativeTextAlert');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('alternativeTextInput');
	            lastFocusableEl = document.getElementById('alternativeTextOkButton');
	        }
	
	        modal = document.getElementById('lostSessionAlert');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('lostSessionAlertButton');
	            lastFocusableEl = document.getElementById('lostSessionAlertButton');
	        }
	
	        modal = document.getElementById('deleteAlert');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('deleteAlertFirstFocusableElement');
	            lastFocusableEl = document.getElementById('deleteAlertLastFocusableElement');
	        }
	
	        modal = document.getElementById('audioAlert');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('audioAlertFirstFocusableElement');
	            lastFocusableEl = document.getElementById('audioAlertLastFocusableElement');
	        }
	
	        modal = document.getElementById('textEditorTool');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('firstFocusableObjectForTextEditorTool');
	            lastFocusableEl = document.getElementById('lastFocusableObjectForTextEditorTool');
	        }
	
	        modal = document.getElementById('recordingPopup');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('recordingFirstFocusableElement');
	            lastFocusableEl = document.getElementById('recordingLastFocusableElement');
	        }
	
	        modal = document.getElementById('zoomMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('zoomMenuFirstFocusableElement');
	            lastFocusableEl = document.getElementById('zoomMenuLastFocusableElement');
	        }
	
	        modal = document.getElementById('croppingMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('croppingMenuFirstFocusableElement');
	            lastFocusableEl = document.getElementById('croppingMenuLastFocusableElement');
	        }
	
	        modal = document.getElementById('leftTextMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('leftTextMenuFirstFocusabletElement');
	            lastFocusableEl = document.getElementById('leftTextMenuLastFocusableElement');
	        }
	
	        modal = document.getElementById('leftFreehandMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('leftFreehandtMenuFirstFocusabletElement');
	            lastFocusableEl = document.getElementById('leftFreehandtMenuLastFocusabletElement');
	        }
	
	        modal = document.getElementById('leftShapesMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('leftShapesMenuFirstFocusabletElement');
	            lastFocusableEl = document.getElementById('leftShapesMenuLastFocusabletElement');
	        }
	
	        modal = document.getElementById('moodsMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('firstFocusableObject');
	            lastFocusableEl = document.getElementById('moodsLastItem');
	        }
	
	        modal = document.getElementById('mindMapMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('firstFocusableObjectMindMapMenu');
	            lastFocusableEl = document.getElementById('mindMapLastItem');
	        }
	
	        modal = document.getElementById('rotationFlipMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('rotationFlipFirstItem');
	            lastFocusableEl = document.getElementById('rotationFlipLastItem');
	        }
	
	        modal = document.getElementById('sizeAndPositionMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('resizeFirstItem');
	            lastFocusableEl = document.getElementById('resizeLastItem');
	        }
	
	        modal = document.getElementById('saveMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('firstFocusableObject');
	            lastFocusableEl = document.getElementById('saveMenuLastFocusableElement');
	        }
	
	        modal = document.getElementById('textStylingMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('firstFocusableObjectForTextStylingMenu');
	            lastFocusableEl = document.getElementById('textStylingMenuLastFocusableElement');
	        }
	
	        modal = document.getElementById('stylingMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('firstFocusableObjectForStylingMenu');
	            lastFocusableEl = document.getElementById('stylingMenuLastFocusableElement');
	        }
	
	        modal = document.getElementById('backgroundVisibilityMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('firstFocusableObjectForBackgroundVisibilityMenu');
	            lastFocusableEl = document.getElementById('lastFocusableObjectForBackgroundVisibilityMenu');
	        }
	
	        modal = document.getElementById('animationMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('animationFirstFocusableObject');
	            lastFocusableEl = document.getElementById('animationMenuLastFocusableObject');
	        }
	
	        modal = document.getElementById('objectContextMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('firstFocusableObjectFromMoreMenu');
	            lastFocusableEl = document.getElementById('objectContextLastFocusableElement');
	        }
	
	        modal = document.getElementById('drawingMenu');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('firstFocusableElement');
	            lastFocusableEl = document.getElementById('drawingFreehandLastFocusableElement');
	        }
	
	        if (!firstFocusableEl || !lastFocusableEl) return;
	
	        if (e.shiftKey) /* shift + tab */{
	                if (document.activeElement === firstFocusableEl) {
	                    lastFocusableEl.focus();
	                    e.preventDefault();
	                }
	            } else /* tab */{
	                if (document.activeElement === lastFocusableEl) {
	                    firstFocusableEl.focus();
	                    e.preventDefault();
	                }
	            }
	    },
	    onMouseDown: function onMouseDown() {
	        _SlidesUtils2.default.updateAllThumbnails = false;
	    },
	    onUnload: function onUnload() {
	        if (_Configuration2.default.LOAD_LOCAL) return;
	
	        if (_AppParameters2.default.submitId > 0) {
	            _ApiService2.default.unlockProduction(_AppParameters2.default.submitId);
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        _AudioVolumeUtils2.default.addEventListener();
	        window.addEventListener('beforeunload', this.onUnload);
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            window.addEventListener('resize', this.onResizeApp);
	            window.addEventListener('touchstart', this.onMouseDown);
	
	            window.addEventListener('blur', this.onScroll);
	            window.addEventListener('focusout', this.onScroll);
	            document.addEventListener('keydown', this.onKeyDown);
	        } else {
	            window.addEventListener('resize', this.onResize);
	            window.addEventListener('mousedown', this.onMouseDown);
	            document.addEventListener('keydown', this.onKeyDownHandler);
	        }
	
	        var dispatch = this.props.dispatch;
	
	        dispatch((0, _ProductionActions.setWindowSize)(window.innerWidth, window.innerHeight));
	
	        _SelectionManager2.default.dispatch = dispatch;
	        _GroupManager2.default.dispatch = dispatch;
	
	        this.setState({
	            originalWidth: window.innerWidth,
	            originalHeight: window.innerHeight
	        });
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        _AudioVolumeUtils2.default.removeEventListener();
	        window.removeEventListener('beforeunload', this.onUnload);
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            window.removeEventListener('resize', this.onResizeApp);
	            window.removeEventListener('touchstart', this.onMouseDown);
	
	            window.removeEventListener('blur', this.onScroll);
	            window.removeEventListener('focusout', this.onScroll);
	            document.removeEventListener('keydown', this.onKeyDown);
	        } else {
	            window.removeEventListener('resize', this.onResize);
	            window.removeEventListener('mousedown', this.onMouseDown);
	            document.removeEventListener('keydown', this.onKeyDownHandler);
	        }
	
	        _PopulateMediaFilesUtils2.default.cleanTimers();
	        _ExporterUtils2.default.removeEvent();
	    },
	    onResizeApp: function onResizeApp() {
	        if (_PlatformDetection2.default.isIOS() && window.navigator.userAgent.match('CriOS')) {
	            // is Chrome on IOS
	            setTimeout(function () {
	                parent.location.reload();
	            }.bind(this), 100);
	
	            return;
	        }
	
	        if (this.state.originalWidth && this.state.originalHeight) {
	            if (this.state.originalWidth > this.state.originalHeight && window.innerWidth < window.innerHeight || this.state.originalWidth < this.state.originalHeight && window.innerWidth > window.innerHeight) {
	                _SaveManager2.default.saveData();
	
	                this.setState({
	                    originalWidth: window.innerWidth,
	                    originalHeight: window.innerHeight
	                });
	
	                setTimeout(this.onResize, 100);
	            }
	        }
	    },
	    onResize: function onResize() {
	        this.refreshView();
	    },
	    refreshView: function refreshView() {
	        var dispatch = this.props.dispatch;
	
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            if (window.innerWidth > window.innerHeight) dispatch((0, _ProductionActions.setWindowSize)(this.state.originalWidth, this.state.originalHeight));else dispatch((0, _ProductionActions.setWindowSize)(window.innerWidth, window.innerHeight));
	
	            setTimeout(this.updateView, 20);
	        } else {
	            dispatch((0, _ProductionActions.setWindowSize)(window.innerWidth, window.innerHeight));
	
	            setTimeout(this.updateView, 20);
	        }
	    },
	    updateView: function updateView() {
	        this.forceUpdate();
	    },
	    onAppMouseDown: function onAppMouseDown(e) {
	        _TextEditorUtils2.default.checkTextSelection(e);
	    },
	    onAppClick: function onAppClick(e) {
	        if (_TextSizeUtils2.default.isTextEditMode()) return;
	
	        if (!_PlatformDetection2.default.isIOSApp()) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var store = _StoreManager2.default.getStore();
	        var state = _StoreManager2.default.getState();
	        var showDescriptionValue = state.menu.showDescription;
	
	        if (showDescriptionValue && e.target.className != 'describeItem' && e.target.className != 'fa fa-eye') store.dispatch((0, _MenuActions.showDescription)(false));
	    },
	    render: function render() {
	        if (_PlatformDetection2.default.isIE() == true) {
	            if (this.props.captionsLoaded == true) return _react2.default.createElement(_InternetExplorerAlert.InternetExplorerAlert, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });else return _react2.default.createElement(_AppLoader.AppLoader, null);
	        }
	
	        if (this.props.captionsLoaded && _AppParameters2.default.context == _ModeConstants2.default.DOWNLOAD) return _react2.default.createElement(_DownloadPage.DownloadPage, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });
	
	        if (this.props.hasNotAccess == true) {
	            if (this.props.captionsLoaded == true) return _react2.default.createElement(_NoAccessAlert.NoAccessAlert, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });else return _react2.default.createElement(_AppLoader.AppLoader, null);
	        }
	
	        if (!this.props.appReady) {
	            return _react2.default.createElement(_AppLoader.AppLoader, null);
	        }
	
	        var appStyle = {
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            background: '#F2F2F2',
	            overflow: 'hidden',
	            position: 'absolute',
	            top: 0
	        };
	
	        var mode = this.props.mode;
	
	        if (this.props.showVideoEditor) mode = _ModeConstants2.default.VIDEO_EDITOR;else if (mode != _ModeConstants2.default.PLAYER && mode != _ModeConstants2.default.PREVIEW && this.props.showAudioEditor) mode = _ModeConstants2.default.AUDIO_EDITOR;
	
	        var tooltipStyle = {
	            position: 'absolute',
	            top: 0,
	            left: this.props.windowWidth - this.props.accordionWidth
	        };
	
	        var noInternetAlertHeight = _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight();
	        var scaleProperties = _CanvasScaleUtils2.default.getScaleProperties(this.props.windowWidth, this.props.windowHeight, this.props.accordionWidth, mode);
	        var elements = [];
	
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER || this.props.showVideoEditor) {
	            if (!this.props.showVideoEditor) // is PLAYER
	                elements.push(_react2.default.createElement(_PreviewMenu.PreviewMenu, { dispatch: this.props.dispatch, scaleProperties: scaleProperties, key: 'appElement0' }));else {
	                // is VIDEO EDITOR MODE
	                elements.push(_react2.default.createElement(_Browser.Browser, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, showVideoEditor: this.props.showVideoEditor, noInternetAlertHeight: noInternetAlertHeight, key: 'appElement1' }));
	                elements.push(_react2.default.createElement(_SearchMenu.SearchMenu, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement31' }));
	                elements.push(_react2.default.createElement(_SlideViewer.SlideViewer, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, showVideoEditor: this.props.showVideoEditor, key: 'appElement2' }));
	                elements.push(_react2.default.createElement(_ContextMenu.ContextMenu, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement3' }));
	                elements.push(_react2.default.createElement(_AudioAlert.AudioAlert, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement14' }));
	                elements.push(_react2.default.createElement('div', { id: 'toolTipHolder', key: 'appElement17', style: tooltipStyle }));
	            }
	        } else {
	            // EDITOR or PREVIEW mode
	            var extraHeight = 0;
	
	            if (_PlatformDetection2.default.isIOSApp()) {
	                extraHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT_OLD;
	                elements.push(_react2.default.createElement(_NavigationBar.NavigationBar, { key: 'appElement10', windowWidth: this.props.windowWidth }));
	            }
	
	            extraHeight = extraHeight + noInternetAlertHeight;
	
	            if (this.props.mode == _ModeConstants2.default.EDITOR) {
	                // EDITOR regular mode
	                if (_PlatformDetection2.default.isIOS() == false || this.props.showAudioEditor) elements.push(_react2.default.createElement(_ResizeAccordionButton.ResizeAccordionButton, { dispatch: this.props.dispatch, timelines: this.props.timelines, accordionWidth: this.props.accordionWidth, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, showAudioEditor: this.props.showAudioEditor, key: 'appElement0' }));
	
	                elements.push(_react2.default.createElement(_MainMenu.MainMenu, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, noInternetAlertHeight: noInternetAlertHeight, key: 'appElement00' }));
	                elements.push(_react2.default.createElement(_SearchMenu.SearchMenu, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement31' }));
	                elements.push(_react2.default.createElement(_Browser.Browser, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, noInternetAlertHeight: noInternetAlertHeight, key: 'appElement1' }));
	                elements.push(_react2.default.createElement(_SlideViewer.SlideViewer, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, showVideoEditor: this.props.showVideoEditor, key: 'appElement2' }));
	                elements.push(_react2.default.createElement(_ContextMenu.ContextMenu, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement3' }));
	                elements.push(_react2.default.createElement(_ZoomMenu.ZoomMenu, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement8' }));
	                elements.push(_react2.default.createElement(_CroppingMenu.CroppingMenu, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement28' }));
	                elements.push(_react2.default.createElement(_DeleteAlert.DeleteAlert, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement5' }));
	                elements.push(_react2.default.createElement(_AudioAlert.AudioAlert, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement14' }));
	                elements.push(_react2.default.createElement(_ExportAlert.ExportAlert, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement13' }));
	                elements.push(_react2.default.createElement(_ProductTitleAlert.ProductTitleAlert, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement15' }));
	                elements.push(_react2.default.createElement(_AlternativeTextForSlideMenu.AlternativeTextForSlideMenu, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement40' }));
	                elements.push(_react2.default.createElement(_RecorderPopup.RecorderPopup, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement20' }));
	                elements.push(_react2.default.createElement(_LostSessionAlert.LostSessionAlert, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement6' }));
	                elements.push(_react2.default.createElement(_NoInternetConnectionAlert.NoInternetConnectionAlert, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement18' }));
	                elements.push(_react2.default.createElement(_Loader.Loader, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - extraHeight, key: 'appElement7' }));
	                elements.push(_react2.default.createElement('div', { id: 'toolTipHolder', key: 'appElement17', style: tooltipStyle }));
	
	                if (_PlatformDetection2.default.isIOS()) elements.push(_react2.default.createElement(_TextEditor.TextEditor, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement21' }));
	            } else {
	                // PREVIEW mode
	                elements.push(_react2.default.createElement(_PreviewMenu.PreviewMenu, { dispatch: this.props.dispatch, scaleProperties: scaleProperties, key: 'appElement0' }));
	                elements.push(_react2.default.createElement(_Loader.Loader, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement7' }));
	            }
	
	            if (_PlatformDetection2.default.isIOSApp()) {
	                elements.push(_react2.default.createElement(_DescriptionMenu.DescriptionMenu, { key: 'appElement11', windowWidth: this.props.windowWidth }));
	                elements.push(_react2.default.createElement(_ExitAlert.ExitAlert, { key: 'appElement12', windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight }));
	            }
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'app', style: appStyle, className: _App2.default.app, onTouchEnd: this.onAppClick, onClick: this.onAppClick, onTouchStart: this.onAppMouseDown, onMouseDown: this.onAppMouseDown },
	            _react2.default.createElement(_Canvas.Canvas, { mode: this.props.mode, scaleProperties: scaleProperties, showVideoEditor: this.props.showVideoEditor, dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight }),
	            elements
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var store = _StoreManager2.default.getStore();
	    var mode = state.production.mode;
	    var windowWidth = state.production.windowWidth;
	    var windowHeight = state.production.windowHeight;
	    var accordionWidth = state.accordion.width;
	    var hasNotAccess = state.menu.hasNotAccess;
	    var showVideoEditor = state.menu.showVideoEditor;
	    var showAudioEditor = state.menu.showAudioEditor;
	    var timelines = state.audioEditor.timelines;
	    var showLostSessionAlert = state.menu.showLostSessionAlert;
	
	    if (!(windowWidth > 0)) windowWidth = window.innerWidth;
	
	    if (!(windowHeight > 0)) windowHeight = window.innerHeight;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    if (!hasNotAccess) hasNotAccess = false;
	
	    if (!showVideoEditor) showVideoEditor = false;
	
	    if (showAudioEditor == undefined) showAudioEditor = false;
	
	    return {
	        appReady: state.session.appReady && state.session.captionsLoaded,
	        dispatch: store.dispatch,
	        captionsLoaded: state.session.captionsLoaded,
	        accordionWidth: accordionWidth,
	        windowWidth: windowWidth,
	        windowHeight: windowHeight,
	        mode: mode,
	        hasNotAccess: hasNotAccess,
	        showVideoEditor: showVideoEditor,
	        showAudioEditor: showAudioEditor,
	        timelines: timelines,
	        showLostSessionAlert: showLostSessionAlert
	    };
	}
	
	var App = exports.App = (0, _reactRedux.connect)(mapStateToProps)(AppWrapper);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/App.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/App.js"); } } })();

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AppPrint = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _CanvasPrint = __webpack_require__(344);
	
	var _PrintMenu = __webpack_require__(809);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AppPrint = __webpack_require__(646);
	
	var _AppPrint2 = _interopRequireDefault(_AppPrint);
	
	var _CanvasScaleUtils = __webpack_require__(171);
	
	var _CanvasScaleUtils2 = _interopRequireDefault(_CanvasScaleUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppPrintWrapper = _react2.default.createClass({
	    displayName: 'AppPrintWrapper',
	    render: function render() {
	        if (this.props.slides == undefined) return _react2.default.createElement('div', null);
	
	        var scaleProperties = _CanvasScaleUtils2.default.getPrintScaleProperties(this.props.windowWidth, this.props.windowHeight);
	
	        var elements = [];
	        var slideModel;
	        var i;
	
	        var holderStyle = {
	            pageBreakAfter: 'always',
	            float: 'none'
	        };
	
	        if (this.props.printTemplate == 0) {
	            var pageElements = [];
	            var count = 0;
	
	            for (i = 0; i < this.props.slides.length; i++) {
	                count = count + 1;
	
	                slideModel = this.props.slides[i];
	                pageElements.push(_react2.default.createElement(_CanvasPrint.CanvasPrint, { printTemplate: this.props.printTemplate, slideModel: slideModel, index: count, dispatch: this.props.dispatch, scaleProperties: scaleProperties, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, key: 'appPrint' + i }));
	
	                if (count % 3 == 0) {
	                    elements.push(_react2.default.createElement(
	                        'div',
	                        { style: holderStyle },
	                        pageElements
	                    ));
	
	                    pageElements = [];
	                    count = 0;
	                }
	            }
	
	            if (count > 0) {
	                elements.push(_react2.default.createElement(
	                    'div',
	                    { style: holderStyle },
	                    pageElements
	                ));
	            }
	        } else {
	            for (i = 0; i < this.props.slides.length; i++) {
	                slideModel = this.props.slides[i];
	                elements.push(_react2.default.createElement(
	                    'div',
	                    { style: holderStyle, key: 'appPrintElements' + i },
	                    _react2.default.createElement(_CanvasPrint.CanvasPrint, { printTemplate: this.props.printTemplate, slideModel: slideModel, index: i, dispatch: this.props.dispatch, scaleProperties: scaleProperties, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight })
	                ));
	            }
	        }
	
	        var printMenu;
	
	        if (this.props.printMode == false) printMenu = _react2.default.createElement(_PrintMenu.PrintMenu, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, dispatch: this.props.dispatch });
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'app', className: _AppPrint2.default.app },
	            elements,
	            printMenu
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var store = _StoreManager2.default.getStore();
	    var slides = state.production.slides;
	    var windowWidth = state.production.windowWidth;
	    var windowHeight = state.production.windowHeight;
	    var printTemplate = state.menu.printTemplate;
	    var printMode = state.menu.printMode;
	
	    if (!(windowWidth > 0)) windowWidth = window.innerWidth;
	
	    if (!(windowHeight > 0)) windowHeight = window.innerHeight;
	
	    if (printTemplate == undefined) printTemplate = 0;
	
	    if (printMode == undefined) printMode = false;
	
	    return {
	        dispatch: store.dispatch,
	        windowWidth: windowWidth,
	        windowHeight: windowHeight,
	        slides: slides,
	        printTemplate: printTemplate,
	        printMode: printMode
	    };
	}
	
	var AppPrint = exports.AppPrint = (0, _reactRedux.connect)(mapStateToProps)(AppPrintWrapper);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/AppPrint.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/AppPrint.js"); } } })();

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AppPrintEditor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _CanvasPrint = __webpack_require__(344);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AppPrintEditor = __webpack_require__(647);
	
	var _AppPrintEditor2 = _interopRequireDefault(_AppPrintEditor);
	
	var _CanvasScaleUtils = __webpack_require__(171);
	
	var _CanvasScaleUtils2 = _interopRequireDefault(_CanvasScaleUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppPrintEditorWrapper = _react2.default.createClass({
	    displayName: 'AppPrintEditorWrapper',
	    openPrint: function openPrint() {
	        setTimeout(function () {
	            window.print();
	        }.bind(this), 3000);
	    },
	    render: function render() {
	        if (this.props.slides == undefined) return _react2.default.createElement('div', null);
	
	        var scaleProperties = _CanvasScaleUtils2.default.getPrintScaleProperties(this.props.windowWidth, this.props.windowHeight);
	
	        var elements = [];
	        var slideModel = void 0;
	        var i = void 0;
	
	        var holderStyle = {
	            pageBreakAfter: 'always',
	            float: 'none'
	        };
	
	        for (i = 0; i < this.props.slides.length; i++) {
	            slideModel = this.props.slides[i];
	            elements.push(_react2.default.createElement(
	                'div',
	                { style: holderStyle, key: 'appPrintElements' + i },
	                _react2.default.createElement(_CanvasPrint.CanvasPrint, { printTemplate: 1, slideModel: slideModel, index: i, dispatch: this.props.dispatch, scaleProperties: scaleProperties, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight })
	            ));
	        }
	
	        this.openPrint();
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'app', className: _AppPrintEditor2.default.app },
	            elements
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var store = _StoreManager2.default.getStore();
	    var slides = state.production.slides;
	    var windowWidth = state.production.windowWidth;
	    var windowHeight = state.production.windowHeight;
	
	    if (!(windowWidth > 0)) windowWidth = window.innerWidth;
	
	    if (!(windowHeight > 0)) windowHeight = window.innerHeight;
	
	    return {
	        dispatch: store.dispatch,
	        windowWidth: windowWidth,
	        windowHeight: windowHeight,
	        slides: slides
	    };
	}
	
	var AppPrintEditor = exports.AppPrintEditor = (0, _reactRedux.connect)(mapStateToProps)(AppPrintEditorWrapper);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/AppPrintEditor.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/AppPrintEditor.js"); } } })();

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioEditorApp = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _AudioTimelineComponent = __webpack_require__(767);
	
	var _ResizeAccordionButton = __webpack_require__(341);
	
	var _ContextMenu = __webpack_require__(331);
	
	var _AudioToolBrowser = __webpack_require__(776);
	
	var _AudioToolHeader = __webpack_require__(768);
	
	var _DeleteAlert = __webpack_require__(332);
	
	var _ExportAlert = __webpack_require__(335);
	
	var _RecorderPopup = __webpack_require__(340);
	
	var _ProductTitleAlert = __webpack_require__(339);
	
	var _DescriptionMenu = __webpack_require__(333);
	
	var _ExitAlert = __webpack_require__(334);
	
	var _LostSessionAlert = __webpack_require__(336);
	
	var _NoInternetConnectionAlert = __webpack_require__(338);
	
	var _AppLoader = __webpack_require__(229);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _MenuActions = __webpack_require__(7);
	
	var _App = __webpack_require__(290);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Loader = __webpack_require__(230);
	
	var _SaveButtonAudioEditor = __webpack_require__(814);
	
	var _NavigationBar = __webpack_require__(337);
	
	var _InternetExplorerAlert = __webpack_require__(232);
	
	var _NoAccessAlert = __webpack_require__(233);
	
	var _SearchMenu = __webpack_require__(342);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PopulateMediaFilesUtils = __webpack_require__(80);
	
	var _PopulateMediaFilesUtils2 = _interopRequireDefault(_PopulateMediaFilesUtils);
	
	var _ExporterUtils = __webpack_require__(93);
	
	var _ExporterUtils2 = _interopRequireDefault(_ExporterUtils);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _KeyboardShortcuts = __webpack_require__(143);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioVolumeUtils = __webpack_require__(67);
	
	var _AudioVolumeUtils2 = _interopRequireDefault(_AudioVolumeUtils);
	
	var _AudioAlert = __webpack_require__(328);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioEditorAppWrapper = _react2.default.createClass({
	    displayName: 'AudioEditorAppWrapper',
	
	    propTypes: {
	        children: _react2.default.PropTypes.object,
	        appReady: _react2.default.PropTypes.bool
	    },
	    getInitialState: function getInitialState() {
	        return {
	            originalWidth: -1,
	            originalHeight: -1
	        };
	    },
	    onScroll: function onScroll(e) {
	        e.preventDefault();
	        e.stopPropagation();
	        window.scrollTo(0, 0);
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) // Enter ... used to close the Keyboard on the iPads
	            window.scrollTo(0, 0);
	    },
	    onUnload: function onUnload() {
	        if (_Configuration2.default.LOAD_LOCAL) return;
	
	        if (_AppParameters2.default.submitId > 0) {
	            _ApiService2.default.unlockProduction(_AppParameters2.default.submitId);
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        var dispatch = this.props.dispatch;
	
	
	        _SaveManager2.default.initAutoSave();
	        _AudioVolumeUtils2.default.addEventListener();
	
	        window.addEventListener('beforeunload', this.onUnload);
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            window.addEventListener('orientationchange', this.onResizeApp);
	
	            window.addEventListener('blur', this.onScroll);
	            window.addEventListener('focusout', this.onScroll);
	            document.addEventListener('keydown', this.onKeyDown);
	        } else {
	            window.addEventListener('resize', this.onResize);
	            document.addEventListener('keydown', this.onKeyDownHandler);
	        }
	
	        dispatch((0, _ProductionActions.setWindowSize)(window.innerWidth, window.innerHeight));
	
	        this.setState({
	            originalWidth: window.innerWidth,
	            originalHeight: window.innerHeight
	        });
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        _AudioVolumeUtils2.default.removeEventListener();
	
	        window.removeEventListener('beforeunload', this.onUnload);
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            window.removeEventListener('orientationchange', this.onResizeApp);
	
	            window.removeEventListener('blur', this.onScroll);
	            window.removeEventListener('focusout', this.onScroll);
	            document.removeEventListener('keydown', this.onKeyDown);
	        } else {
	            window.removeEventListener('resize', this.onResize);
	            document.removeEventListener('keydown', this.onKeyDownHandler);
	        }
	
	        _PopulateMediaFilesUtils2.default.cleanTimers();
	        _ExporterUtils2.default.removeEvent();
	    },
	    onKeyDownHandler: function onKeyDownHandler(e) {
	        (0, _KeyboardShortcuts.checkKeyboardCommand)(e, this.props.dispatch);
	
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
	
	        if (!isTabPressed) {
	            return;
	        }
	
	        var modal;
	        var firstFocusableEl;
	        var lastFocusableEl;
	
	        modal = document.getElementById('exportPopup');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('exportFirstFocusableCheckBox');
	
	            if (!firstFocusableEl) firstFocusableEl = document.getElementById('exportFirstFocusableButton');
	
	            lastFocusableEl = document.getElementById('exportLastFocusableButton');
	        }
	
	        modal = document.getElementById('productionInitialTitleAlert');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('productionInitialTitle');
	            lastFocusableEl = document.getElementById('productionInitialTitleButton');
	        }
	
	        modal = document.getElementById('lostSessionAlert');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('lostSessionAlertButton');
	            lastFocusableEl = document.getElementById('lostSessionAlertButton');
	        }
	
	        modal = document.getElementById('deleteAlert');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('deleteAlertFirstFocusableElement');
	            lastFocusableEl = document.getElementById('deleteAlertLastFocusableElement');
	        }
	
	        modal = document.getElementById('audioAlert');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('audioAlertFirstFocusableElement');
	            lastFocusableEl = document.getElementById('audioAlertLastFocusableElement');
	        }
	
	        modal = document.getElementById('recordingPopup');
	
	        if (modal) {
	            firstFocusableEl = document.getElementById('recordingFirstFocusableElement');
	            lastFocusableEl = document.getElementById('recordingLastFocusableElement');
	        }
	
	        if (!firstFocusableEl || !lastFocusableEl) return;
	
	        if (e.shiftKey) /* shift + tab */{
	                if (document.activeElement === firstFocusableEl) {
	                    lastFocusableEl.focus();
	                    e.preventDefault();
	                }
	            } else /* tab */{
	                if (document.activeElement === lastFocusableEl) {
	                    firstFocusableEl.focus();
	                    e.preventDefault();
	                }
	            }
	    },
	    onResizeApp: function onResizeApp() {
	        _SaveManager2.default.saveData();
	        setTimeout(this.onResize, 100);
	    },
	    onResize: function onResize() {
	        this.refreshView();
	    },
	    refreshView: function refreshView() {
	        var dispatch = this.props.dispatch;
	
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            if (window.innerWidth > window.innerHeight) dispatch((0, _ProductionActions.setWindowSize)(this.state.originalWidth, this.state.originalHeight));else dispatch((0, _ProductionActions.setWindowSize)(window.innerWidth, window.innerHeight));
	
	            setTimeout(this.updateView, 20);
	        } else {
	            dispatch((0, _ProductionActions.setWindowSize)(window.innerWidth, window.innerHeight));
	
	            setTimeout(this.updateView, 20);
	        }
	    },
	    updateView: function updateView() {
	        this.forceUpdate();
	    },
	    onAppClick: function onAppClick(e) {
	        if (!_PlatformDetection2.default.isIOSApp()) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var store = _StoreManager2.default.getStore();
	        var state = _StoreManager2.default.getState();
	        var showDescriptionValue = state.menu.showDescription;
	
	        if (showDescriptionValue && e.target.className != 'describeItem' && e.target.className != 'fa fa-eye') store.dispatch((0, _MenuActions.showDescription)(false));
	    },
	    render: function render() {
	        if (_PlatformDetection2.default.isIE() == true) {
	            if (this.props.captionsLoaded == true) return _react2.default.createElement(_InternetExplorerAlert.InternetExplorerAlert, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });else return _react2.default.createElement(_AppLoader.AppLoader, null);
	        }
	
	        if (this.props.hasNotAccess == true) {
	            if (this.props.captionsLoaded == true) return _react2.default.createElement(_NoAccessAlert.NoAccessAlert, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });else return _react2.default.createElement(_AppLoader.AppLoader, null);
	        }
	
	        if (!this.props.appReady) {
	            return _react2.default.createElement(_AppLoader.AppLoader, null);
	        }
	
	        var appStyle = {
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            background: '#F2F2F2'
	        };
	
	        var elements = [];
	        var extraHeight = 0;
	        var noInternetAlertHeight = _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight();
	        var searchHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	        if (_PlatformDetection2.default.isIOS()) {
	            extraHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT_OLD;
	            searchHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT_OLD;
	
	            if (_PlatformDetection2.default.isIOSApp()) elements.push(_react2.default.createElement(_NavigationBar.NavigationBar, { key: 'appElement10', windowWidth: this.props.windowWidth }));
	        }
	
	        extraHeight = extraHeight + noInternetAlertHeight;
	
	        elements.push(_react2.default.createElement(_AudioToolHeader.AudioToolHeader, { width: this.props.windowWidth - this.props.accordionWidth, timelines: this.props.timelines, dispatch: this.props.dispatch, windowHeight: this.props.windowHeight - extraHeight, key: 'appElement1' }));
	        elements.push(_react2.default.createElement(_SaveButtonAudioEditor.SaveButtonAudioEditor, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement5' }));
	        elements.push(_react2.default.createElement(_SearchMenu.SearchMenu, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement31' }));
	        elements.push(_react2.default.createElement(_AudioToolBrowser.AudioToolBrowser, { height: this.props.windowHeight - noInternetAlertHeight - searchHeight, top: noInternetAlertHeight + searchHeight, accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowHeight: this.props.windowHeight - noInternetAlertHeight - searchHeight, key: 'appElement2' }));
	        elements.push(_react2.default.createElement(_AudioTimelineComponent.AudioTimelineComponent, { buttonsHolderWidth: this.props.buttonsHolderWidth, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - extraHeight, key: 'appElement3' }));
	        elements.push(_react2.default.createElement(_ResizeAccordionButton.ResizeAccordionButton, { buttonsHolderWidth: this.props.buttonsHolderWidth, isLeft: true, dispatch: this.props.dispatch, timelines: this.props.timelines, accordionWidth: this.props.accordionWidth, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - extraHeight, key: 'appElement15' }));
	        elements.push(_react2.default.createElement(_ResizeAccordionButton.ResizeAccordionButton, { buttonsHolderWidth: this.props.buttonsHolderWidth, dispatch: this.props.dispatch, timelines: this.props.timelines, accordionWidth: this.props.accordionWidth, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - extraHeight, key: 'appElement0' }));
	        elements.push(_react2.default.createElement(_ContextMenu.ContextMenu, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement4' }));
	        elements.push(_react2.default.createElement(_DeleteAlert.DeleteAlert, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement6' }));
	        elements.push(_react2.default.createElement(_AudioAlert.AudioAlert, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement14' }));
	        elements.push(_react2.default.createElement(_ExportAlert.ExportAlert, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement7' }));
	        elements.push(_react2.default.createElement(_ProductTitleAlert.ProductTitleAlert, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement13' }));
	        elements.push(_react2.default.createElement(_RecorderPopup.RecorderPopup, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement17' }));
	        elements.push(_react2.default.createElement(_LostSessionAlert.LostSessionAlert, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement8' }));
	        elements.push(_react2.default.createElement(_NoInternetConnectionAlert.NoInternetConnectionAlert, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight, key: 'appElement16' }));
	        elements.push(_react2.default.createElement(_Loader.Loader, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - extraHeight, key: 'appElement9' }));
	
	        if (_PlatformDetection2.default.isIOSApp()) {
	            elements.push(_react2.default.createElement(_DescriptionMenu.DescriptionMenu, { key: 'appElement11', windowWidth: this.props.windowWidth }));
	            elements.push(_react2.default.createElement(_ExitAlert.ExitAlert, { key: 'appElement12', windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight - noInternetAlertHeight }));
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'app', style: appStyle, className: _App2.default.app, onTouchEnd: this.onAppClick, onClick: this.onAppClick },
	            elements
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var store = _StoreManager2.default.getStore();
	    var windowWidth = state.production.windowWidth;
	    var windowHeight = state.production.windowHeight;
	    var accordionWidth = state.accordion.width;
	    var hasNotAccess = state.menu.hasNotAccess;
	    var timelines = state.audioEditor.timelines;
	    var soundClipartModel = state.music.soundClipartModel;
	    var buttonsHolderWidth = state.menu.buttonsHolderWidth;
	    var showLostSessionAlert = state.menu.showLostSessionAlert;
	
	    if (!(windowWidth > 0)) windowWidth = window.innerWidth;
	
	    if (!(windowHeight > 0)) windowHeight = window.innerHeight;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    if (!hasNotAccess) hasNotAccess = false;
	
	    if (buttonsHolderWidth == undefined) buttonsHolderWidth = _AudioToolUtils2.default.buttonsHolderWidth();
	
	    return {
	        appReady: state.session.appReady && state.session.captionsLoaded && soundClipartModel != undefined,
	        dispatch: store.dispatch,
	        captionsLoaded: state.session.captionsLoaded,
	        accordionWidth: accordionWidth,
	        windowWidth: windowWidth,
	        windowHeight: windowHeight,
	        hasNotAccess: hasNotAccess,
	        timelines: timelines,
	        buttonsHolderWidth: buttonsHolderWidth,
	        showLostSessionAlert: showLostSessionAlert
	    };
	}
	
	var AudioEditorApp = exports.AudioEditorApp = (0, _reactRedux.connect)(mapStateToProps)(AudioEditorAppWrapper);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/AudioEditorApp.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/AudioEditorApp.js"); } } })();

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioPlayerApp = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _AppLoader = __webpack_require__(229);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AudioPlayerApp = __webpack_require__(648);
	
	var _AudioPlayerApp2 = _interopRequireDefault(_AudioPlayerApp);
	
	var _InternetExplorerAlert = __webpack_require__(232);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _KeyboardShortcuts = __webpack_require__(143);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _NoAccessAlert = __webpack_require__(233);
	
	var _CanvasScaleUtils = __webpack_require__(171);
	
	var _CanvasScaleUtils2 = _interopRequireDefault(_CanvasScaleUtils);
	
	var _AudioToolPlayer = __webpack_require__(769);
	
	var _ExportPlayer = __webpack_require__(770);
	
	var _Loader = __webpack_require__(230);
	
	var _AudioVolumeUtils = __webpack_require__(67);
	
	var _AudioVolumeUtils2 = _interopRequireDefault(_AudioVolumeUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _FullScreenManager = __webpack_require__(141);
	
	var _FullScreenManager2 = _interopRequireDefault(_FullScreenManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioPlayerAppWrapper = _react2.default.createClass({
	    displayName: 'AudioPlayerAppWrapper',
	
	    propTypes: {
	        children: _react2.default.PropTypes.object,
	        appReady: _react2.default.PropTypes.bool
	    },
	    getInitialState: function getInitialState() {
	        return {
	            originalWidth: -1,
	            originalHeight: -1
	        };
	    },
	    onScroll: function onScroll(e) {
	        if (_PlatformDetection2.default.isIOSApp()) return;
	
	        e.preventDefault();
	        e.stopPropagation();
	
	        if (window.scrollY != 0) window.scrollTo(0, 0);
	    },
	    componentDidMount: function componentDidMount() {
	        setTimeout(function () {
	            try {
	                if (window.parent) {
	                    var iFrame = window.parent.document.getElementById('cartoonist-iframe');
	
	                    if (iFrame && iFrame.contentWindow) iFrame.contentWindow.focus();
	                }
	            } catch (e) {
	                // error
	            }
	        }.bind(this), 1000);
	
	        _AudioVolumeUtils2.default.addEventListener();
	        document.addEventListener('keydown', this.onKeyDown);
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            window.addEventListener('orientationchange', this.onResizeApp);
	            window.addEventListener('scroll', this.onScroll);
	        } else {
	            window.addEventListener('resize', this.onResize);
	        }
	
	        var dispatch = this.props.dispatch;
	
	        dispatch((0, _ProductionActions.setWindowSize)(window.innerWidth, window.innerHeight));
	
	        this.setState({
	            originalWidth: window.innerWidth,
	            originalHeight: window.innerHeight
	        });
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        _AudioVolumeUtils2.default.removeEventListener();
	        document.removeEventListener('keydown', this.onKeyDown);
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            window.removeEventListener('orientationchange', this.onResizeApp);
	            window.removeEventListener('scroll', this.onScroll);
	        } else {
	            window.removeEventListener('resize', this.onResize);
	        }
	    },
	    onKeyDown: function onKeyDown(e) {
	        (0, _KeyboardShortcuts.checkKeyboardCommand)(e, this.props.dispatch);
	    },
	    onResizeApp: function onResizeApp() {
	        setTimeout(this.onResize, 1 * 10);
	    },
	    onResize: function onResize() {
	        this.refreshView();
	    },
	    refreshView: function refreshView() {
	        var dispatch = this.props.dispatch;
	
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            if (window.innerWidth > window.innerHeight) dispatch((0, _ProductionActions.setWindowSize)(this.state.originalWidth, this.state.originalHeight));else dispatch((0, _ProductionActions.setWindowSize)(window.innerWidth, window.innerHeight));
	
	            setTimeout(this.updateView, 20);
	        } else {
	            dispatch((0, _ProductionActions.setWindowSize)(window.innerWidth, window.innerHeight));
	
	            setTimeout(this.updateView, 20);
	        }
	    },
	    updateView: function updateView() {
	        this.forceUpdate();
	    },
	    render: function render() {
	        if (_PlatformDetection2.default.isIE() == true) {
	            if (this.props.captionsLoaded == true) return _react2.default.createElement(_InternetExplorerAlert.InternetExplorerAlert, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });else return _react2.default.createElement(_AppLoader.AppLoader, null);
	        }
	
	        if (this.props.hasNotAccess == true) {
	            if (this.props.captionsLoaded == true) return _react2.default.createElement(_NoAccessAlert.NoAccessAlert, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight });else return _react2.default.createElement(_AppLoader.AppLoader, null);
	        }
	
	        if (!this.props.appReady) {
	            return _react2.default.createElement(_AppLoader.AppLoader, null);
	        }
	
	        var appStyle = {
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            background: '#F2F2F2'
	        };
	
	        var scaleProperties = _CanvasScaleUtils2.default.getPrintScaleProperties(this.props.windowWidth, this.props.windowHeight);
	
	        if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER || _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) {
	            if (_FullScreenManager2.default.isFullScreenMode()) appStyle.background = 'black';
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'app', style: appStyle, className: _AudioPlayerApp2.default.app },
	                _react2.default.createElement(_ExportPlayer.ExportPlayer, { dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight })
	            );
	        } else {
	            return _react2.default.createElement(
	                'div',
	                { id: 'app', style: appStyle, className: _AudioPlayerApp2.default.app },
	                _react2.default.createElement(_AudioToolPlayer.AudioToolPlayer, { dispatch: this.props.dispatch, scaleProperties: scaleProperties, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight }),
	                _react2.default.createElement(_Loader.Loader, { windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight })
	            );
	        }
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var store = _StoreManager2.default.getStore();
	    var windowWidth = state.production.windowWidth;
	    var windowHeight = state.production.windowHeight;
	    var hasNotAccess = state.menu.hasNotAccess;
	
	    if (!(windowWidth > 0)) windowWidth = window.innerWidth;
	
	    if (!(windowHeight > 0)) windowHeight = window.innerHeight;
	
	    if (!hasNotAccess) hasNotAccess = false;
	
	    return {
	        appReady: state.session.appReady && state.session.captionsLoaded,
	        dispatch: store.dispatch,
	        captionsLoaded: state.session.captionsLoaded,
	        windowWidth: windowWidth,
	        windowHeight: windowHeight,
	        hasNotAccess: hasNotAccess
	    };
	}
	
	var AudioPlayerApp = exports.AudioPlayerApp = (0, _reactRedux.connect)(mapStateToProps)(AudioPlayerAppWrapper);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/AudioPlayerApp.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/AudioPlayerApp.js"); } } })();

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Browser = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _List = __webpack_require__(759);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _PopulateMediaFilesUtils = __webpack_require__(80);
	
	var _PopulateMediaFilesUtils2 = _interopRequireDefault(_PopulateMediaFilesUtils);
	
	var _ToolTipManager = __webpack_require__(174);
	
	var _ToolTipManager2 = _interopRequireDefault(_ToolTipManager);
	
	var _BrowserButton = __webpack_require__(758);
	
	var _ClipartSelectorNew = __webpack_require__(783);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrowserContent = _react2.default.createClass({
	    displayName: 'BrowserContent',
	    getInitialState: function getInitialState() {
	        return {
	            activeButton: 0,
	            oldActiveButton: -1,
	            browserWidth: -1,
	            browserHeight: -1,
	            isCollapsed: false,
	            updateIsCollapsedAfterAnimation: false,
	            lists: [],
	            buttons: [],
	            noInternetAlertHeight: 0
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	    },
	    getTopButtonsOffset: function getTopButtonsOffset() {
	        if (this.props.clipartCategory == 0) return _Properties2.default.CLIPART_BUTTON_HEIGHT + 2 * _Properties2.default.BROWSER_BUTTON_HEIGHT;else return 2 * _Properties2.default.CLIPART_BUTTON_HEIGHT;
	    },
	    initElements: function initElements() {
	        var windowHeight = this.props.windowHeight - this.props.noInternetAlertHeight - this.clipartButtonHeight();
	        var tabStyle = {
	            position: 'absolute',
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight() + this.clipartButtonHeight(),
	            right: 0,
	            backgroundColor: 'white',
	            width: this.props.accordionWidth,
	            height: windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none'
	        };
	
	        // if (this.props.contextMode != undefined && this.props.contextMode != modeType.CONTEXT_NONE && this.props.contextMode != modeType.SEARCH_CONTEXT)
	        //     tabStyle.display = 'none';
	
	        var holderStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: this.props.accordionWidth,
	            height: windowHeight,
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none'
	        };
	
	        var clipartModel = this.props.clipartModel;
	
	        if (!clipartModel) {
	            return;
	        }
	
	        var items = clipartModel.items;
	
	        var lists = [];
	        var elements = [];
	        var i = void 0;
	        var count = 0;
	        var index = 0;
	        var item = void 0;
	        var topButtonsOffset = this.getTopButtonsOffset();
	        var listHeight = windowHeight - items.length * _Properties2.default.BROWSER_BUTTON_HEIGHT - topButtonsOffset;
	        var topPosition;
	        var listOffset = 0;
	
	        for (i = 0; i < items.length; i++) {
	            item = items[i];
	            count = count + 1;
	            var isBackground = false;
	            var dataProvider = [];
	
	            listOffset = 0;
	
	            if (_VideoUtils2.default.browserActiveButton != -1 && i > _VideoUtils2.default.browserActiveButton) listOffset = listHeight;
	
	            if (i === 0) isBackground = true;
	
	            topPosition = topButtonsOffset + _Properties2.default.BROWSER_BUTTON_HEIGHT * (i + 1) + listOffset;
	
	            dataProvider = item.items;
	
	            lists.push(_react2.default.createElement(_List.List, { topButtonsOffset: topButtonsOffset, key: '' + this.props.clipartCategory + count + '_' + Math.random(), windowHeight: windowHeight, index: i, dataProvider: dataProvider, itemsLength: items.length, top: topPosition, top2: topPosition - listOffset, isBackground: isBackground, dispatch: this.props.dispatch, clipartCategory: this.props.clipartCategory }));
	        }
	
	        for (i = 0; i < items.length; i++) {
	            item = items[i];
	            count = count + 1;
	            elements.push(_react2.default.createElement(_BrowserButton.BrowserButton, { topButtonsOffset: topButtonsOffset, dispatch: this.props.dispatch, windowHeight: windowHeight, length: items.length, index: index, text: this.getButtonTitle(item), key: '' + this.props.clipartCategory + count + '_' + Math.random() }));
	            index = index + 1;
	        }
	
	        var contentStyle = {};
	
	        if (_PlatformDetection2.default.isTouchableDevice() == true) contentStyle.position = 'fixed';
	
	        var clipartSelector = _react2.default.createElement(_ClipartSelectorNew.ClipartSelectorNew, { dispatch: this.props.dispatch, windowHeight: windowHeight });
	
	        this.setState({
	            tabStyle: tabStyle,
	            holderStyle: holderStyle,
	            contentStyle: contentStyle,
	            listsData: lists,
	            elements: elements,
	            clipartSelector: clipartSelector,
	            activeButton: _VideoUtils2.default.browserActiveButton,
	            oldActiveButton: -1
	        });
	
	        this.props.dispatch((0, _AccordionActions.setOldActiveButton)(-1));
	
	        if (_VideoUtils2.default.browserActiveButton == -1) this.props.dispatch((0, _AccordionActions.setActiveButton)(_VideoUtils2.default.browserActiveButton, true));else this.props.dispatch((0, _AccordionActions.setActiveButton)(_VideoUtils2.default.browserActiveButton, false));
	
	        setTimeout(this.updateElements, 100);
	    },
	    updateElements: function updateElements() {
	        if (!document.getElementById('buttons')) return;
	
	        var windowHeight = this.props.windowHeight - this.props.noInternetAlertHeight - this.clipartButtonHeight();
	        var buttons = Array.from(document.getElementById('buttons').childNodes);
	        var lists = Array.from(document.getElementById('content').childNodes);
	        var i = void 0;
	        var button = void 0;
	
	        for (i = 0; i < buttons.length; i++) {
	            button = buttons[i];
	            button.addEventListener('click', this.onElementClick);
	            button.addEventListener('touchend', this.onElementClick);
	        }
	
	        var state = _StoreManager2.default.getState();
	        var clipartModel = state.accordion.clipartModel;
	        var items = clipartModel.items;
	        var topButtonsOffset = this.getTopButtonsOffset();
	
	        this.setState({
	            themeName: clipartModel.captionKey,
	            referenceClipartId: clipartModel.referenceClipartId,
	            clipartCategory: this.props.clipartCategory,
	            items: items,
	            buttons: buttons,
	            lists: lists,
	            oldActiveButton: -1,
	            updateIsCollapsedAfterAnimation: false,
	            isCollapsed: false,
	            listHeight: windowHeight - buttons.length * _Properties2.default.BROWSER_BUTTON_HEIGHT - topButtonsOffset,
	            isAnimating: false,
	            initialY: 0
	        });
	    },
	    removeOldEvents: function removeOldEvents() {
	        var buttons = this.state.buttons;
	
	        if (buttons == undefined || buttons.length < 1) return;
	
	        var i = void 0;
	        var button = void 0;
	
	        for (i = 0; i < buttons.length; i++) {
	            button = buttons[i];
	            button.removeEventListener('click', this.onElementClick);
	            button.removeEventListener('touchend', this.onElementClick);
	        }
	    },
	    refreshNewContent: function refreshNewContent() {
	        this.removeOldEvents();
	        this.initElements();
	    },
	    refreshView: function refreshView() {
	        setTimeout(this.refreshNewContent, 100);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.state.browserWidth > 0 && this.state.browserHeight > 0 && (this.state.browserWidth != nextProps.windowWidth || this.state.browserHeight != nextProps.windowHeight)) setTimeout(this.changeCurrentTab, 10);
	
	        if (this.props.clipartModel != nextProps.clipartModel) this.refreshView();else if (this.state.noInternetAlertHeight != nextProps.noInternetAlertHeight || this.state.browserHeight != nextProps.windowHeight) this.refreshView();else if (this.state.clipartCategory != undefined && this.state.clipartCategory != nextProps.clipartCategory) this.refreshView();else if (this.state.themeName != undefined && this.state.themeName != nextProps.clipartModel.captionKey) this.refreshView();
	
	        this.setState({
	            browserWidth: nextProps.windowWidth,
	            browserHeight: nextProps.windowHeight,
	            noInternetAlertHeight: nextProps.noInternetAlertHeight
	        });
	    },
	    changeCurrentTab: function changeCurrentTab() {
	        this.props.dispatch((0, _AccordionActions.setActiveButton)(-1, true));
	
	        var i;
	        var button;
	        var buttons = this.state.buttons;
	        var topPosition;
	        var topButtonsOffset = this.getTopButtonsOffset();
	
	        for (i = 0; i < buttons.length; i++) {
	            topPosition = topButtonsOffset + _Properties2.default.BROWSER_BUTTON_HEIGHT * i;
	
	            button = buttons[i];
	
	            if (button) button.style.top = topPosition + 'px';
	
	            this.updateListPosition(button);
	        }
	
	        this.setState({
	            activeButton: -1,
	            isAnimating: false,
	            oldActiveButton: -1,
	            updateIsCollapsedAfterAnimation: false,
	            isCollapsed: true
	        });
	
	        this.props.dispatch((0, _AccordionActions.setOldActiveButton)(-1));
	    },
	    onElementClick: function onElementClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var activeButton = this.state.buttons.indexOf(e.currentTarget);
	        this.expandToTab(activeButton);
	    },
	    getMediaFilesDataProvider: function getMediaFilesDataProvider() {
	        return this.props.mediaFilesDataProvider;
	    },
	    checkMediaFiles: function checkMediaFiles(activeButton) {
	        var dataProvider = this.getMediaFilesDataProvider();
	
	        if (dataProvider && (dataProvider.imagesDataProvider && dataProvider.imagesDataProvider.length > 0 || dataProvider.videosDataProvider && dataProvider.videosDataProvider.length > 0)) return;
	
	        if (_Configuration2.default.LOAD_LOCAL == true) {
	            // FOR TEST
	            this.props.dispatch((0, _AccordionActions.setMediaFilesDataProvider)({ imagesDataProvider: _PopulateMediaFilesUtils2.default.getImagesDataProviderForTest(), soundsDataProvider: _PopulateMediaFilesUtils2.default.getSoundsDataProviderForTest(), videosDataProvider: _PopulateMediaFilesUtils2.default.getVideosDataProviderForTest() }));
	        } else {
	            if (activeButton == this.state.buttons.length - 1) {
	                _ApiServiceUtils2.default.executeSafeApiCall(this.executeGetMediaFilesCall.bind(this));
	            }
	        }
	    },
	    executeGetMediaFilesCall: function executeGetMediaFilesCall() {
	        _ApiServiceUtils2.default.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
	    },
	    parseMediaItems: function parseMediaItems(items) {
	        _PopulateMediaFilesUtils2.default.parseMediaItems(items, this.props.dispatch);
	    },
	    expandToTab: function expandToTab(tabIndex) {
	        if (tabIndex == this.state.buttons.length - 1) {
	            this.checkMediaFiles(tabIndex);
	        }
	
	        if (tabIndex == 0 && this.state.activeButton != tabIndex) this.updateListPosition(this.state.buttons[0]);
	
	        var isCollapsed = false;
	        var updateIsCollapsedAfterAnimation = false;
	
	        if (this.state.isCollapsed == true && tabIndex != this.state.buttons.length - 1) updateIsCollapsedAfterAnimation = true;
	
	        if (tabIndex == this.state.activeButton) {
	            if (tabIndex == this.state.buttons.length - 1) {
	                if (this.state.isCollapsed == false) isCollapsed = true;
	            } else {
	                tabIndex = this.state.buttons.length - 1;
	                isCollapsed = true;
	            }
	        }
	
	        var timer = setInterval(this.animate, 5);
	
	        var oldActiveButton = this.state.activeButton;
	
	        if (updateIsCollapsedAfterAnimation == true) {
	            this.setState({
	                oldActiveButton: oldActiveButton,
	                activeButton: tabIndex,
	                isAnimating: true,
	                timer: timer,
	                updateIsCollapsedAfterAnimation: true
	            });
	        } else {
	            this.setState({
	                oldActiveButton: oldActiveButton,
	                activeButton: tabIndex,
	                isAnimating: true,
	                timer: timer,
	                isCollapsed: isCollapsed
	            });
	        }
	
	        if (isCollapsed == true) {
	            this.props.dispatch((0, _AccordionActions.setActiveButton)(-1, isCollapsed));
	            _VideoUtils2.default.browserActiveButton = -1;
	        } else {
	            this.props.dispatch((0, _AccordionActions.setActiveButton)(tabIndex, isCollapsed));
	            _VideoUtils2.default.browserActiveButton = tabIndex;
	        }
	
	        this.detectDirection();
	        this.props.dispatch((0, _AccordionActions.setOldActiveButton)(oldActiveButton));
	    },
	    detectDirection: function detectDirection() {
	        var windowHeight = this.props.windowHeight - this.props.noInternetAlertHeight - this.clipartButtonHeight();
	        var offset = this.getTopButtonsOffset();
	        var correctPosition = _Properties2.default.BROWSER_BUTTON_HEIGHT * this.state.activeButton + offset;
	        var button = this.state.buttons[this.state.activeButton];
	        var buttons = this.state.buttons;
	        var sign = 1;
	        var buttonY = parseInt(button.style.top, 10);
	        var i = void 0;
	        var button2 = void 0;
	        var updateButtons = [];
	
	        if (buttonY == correctPosition) {
	            // go down
	            sign = 1;
	
	            for (i = this.state.activeButton + 1; i < buttons.length; i++) {
	                button2 = buttons[i];
	
	                if (!button2) continue;
	
	                var button2Y = parseInt(button2.style.top, 10);
	
	                if (button2Y != windowHeight - _Properties2.default.BROWSER_BUTTON_HEIGHT * (buttons.length - i)) updateButtons.push(button2);
	            }
	        } else {
	            // go up
	            sign = -1;
	
	            for (i = 0; i <= this.state.activeButton; i++) {
	                button2 = buttons[i];
	
	                if (!button2) continue;
	
	                var _button2Y = parseInt(button2.style.top, 10);
	
	                if (_button2Y != _Properties2.default.BROWSER_BUTTON_HEIGHT * i + offset) updateButtons.push(button2);
	            }
	        }
	
	        this.setState({
	            sign: sign,
	            updateButtons: updateButtons,
	            initialY: this.state.listHeight
	        });
	    },
	    animate: function animate() {
	        var windowHeight = this.props.windowHeight - this.props.noInternetAlertHeight - this.clipartButtonHeight();
	        var offset = this.getTopButtonsOffset();
	        var initialY = this.state.initialY - _Properties2.default.ANIMATION_STEP;
	        var i = void 0;
	        var updateButtons = this.state.updateButtons;
	        var button = void 0;
	        var buttons = this.state.buttons;
	
	        if (_PlatformDetection2.default.isIOS() == true) initialY = 0;
	
	        if (updateButtons == undefined) return;
	
	        if (initialY <= 0) {
	            for (i = 0; i < updateButtons.length; i++) {
	                button = updateButtons[i];
	
	                var index = buttons.indexOf(button);
	
	                if (this.state.sign < 0) button.style.top = offset + index * _Properties2.default.BROWSER_BUTTON_HEIGHT + 'px';else button.style.top = windowHeight - _Properties2.default.BROWSER_BUTTON_HEIGHT * (buttons.length - index) + 'px';
	
	                this.updateListPosition(button);
	            }
	
	            if (this.state.updateIsCollapsedAfterAnimation == true) {
	                this.setState({
	                    isAnimating: false,
	                    oldActiveButton: -1,
	                    updateIsCollapsedAfterAnimation: false,
	                    isCollapsed: false
	                });
	            } else {
	                this.setState({
	                    isAnimating: false,
	                    oldActiveButton: -1,
	                    updateIsCollapsedAfterAnimation: false
	                });
	            }
	
	            clearInterval(this.state.timer);
	
	            this.props.dispatch((0, _AccordionActions.setOldActiveButton)(-1));
	
	            return;
	        }
	
	        for (i = 0; i < updateButtons.length; i++) {
	            button = updateButtons[i];
	
	            var buttonY = parseInt(button.style.top, 10);
	
	            button.style.top = buttonY + this.state.sign * _Properties2.default.ANIMATION_STEP + 'px';
	            this.updateListPosition(button);
	        }
	
	        this.setState({
	            initialY: initialY
	        });
	    },
	    updateListPosition: function updateListPosition(button) {
	        var index = this.state.buttons.indexOf(button);
	        var list = this.state.lists[index];
	        var buttonY = parseInt(button.style.top, 10);
	        var activeButton = this.state.activeButton;
	
	        if (list) {
	            list.style.top = buttonY + _Properties2.default.BROWSER_BUTTON_HEIGHT + 'px';
	
	            if (activeButton == -1) list.style.display = 'none';else list.style.display = 'block';
	        }
	    },
	    onBrowserClick: function onBrowserClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	    },
	    getButtonTitle: function getButtonTitle(item) {
	        if (item.title) return item.title;
	    },
	    clipartButtonHeight: function clipartButtonHeight() {
	        if (_PlatformDetection2.default.isIOS()) return 40;else return _Properties2.default.CLIPART_BUTTON_HEIGHT;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.tabStyle == undefined) return _react2.default.createElement('div', null);
	
	        var windowHeight = this.props.windowHeight - this.props.noInternetAlertHeight - this.clipartButtonHeight();
	        var tabStyle = Object.assign({}, this.state.tabStyle);
	        tabStyle.width = this.props.accordionWidth;
	        tabStyle.top = _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight() + this.clipartButtonHeight();
	        tabStyle.height = windowHeight;
	
	        var holderStyle = Object.assign({}, this.state.holderStyle);
	        holderStyle.width = this.props.accordionWidth;
	        holderStyle.height = tabStyle.height;
	
	        _ToolTipManager2.default.localPosition = this.props.windowWidth - this.props.accordionWidth;
	
	        return _react2.default.createElement(
	            'div',
	            { style: tabStyle },
	            _react2.default.createElement(
	                'div',
	                { style: holderStyle, onClick: this.onBrowserClick, onTouchEnd: this.onBrowserClick },
	                _react2.default.createElement(
	                    'div',
	                    { id: 'content', style: this.state.contentStyle },
	                    this.state.listsData
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { id: 'buttons' },
	                    this.state.elements
	                )
	            ),
	            this.state.clipartSelector
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var accordionWidth = state.accordion.width;
	    var contextMode = state.menu.contextMode;
	    var mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
	    var clipartModel = state.accordion.clipartModel;
	    var clipartCategory = state.menu.clipartCategory;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    if (clipartCategory == undefined) clipartCategory = 0;
	
	    return {
	        accordionWidth: accordionWidth,
	        contextMode: contextMode,
	        mediaFilesDataProvider: mediaFilesDataProvider,
	        clipartModel: clipartModel,
	        clipartCategory: clipartCategory,
	        accordionActiveButton: state && state.accordion && state.accordion.accordionActiveButton
	    };
	}
	
	var Browser = exports.Browser = (0, _reactRedux.connect)(mapStateToProps)(BrowserContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/Browser.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/Browser.js"); } } })();

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BrowserButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BrowserButtonContent = _react2.default.createClass({
	    displayName: 'BrowserButtonContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth || this.props.windowHeight != newProps.windowHeight || this.props.activeButton != newProps.activeButton) return true;else return false;
	    },
	    render: function render() {
	        var topPosition = void 0;
	        var listHeight = this.props.windowHeight - this.props.topButtonsOffset - this.props.length * _Properties2.default.BROWSER_BUTTON_HEIGHT;
	        var listOffset = 0;
	
	        if (_VideoUtils2.default.browserActiveButton != -1 && this.props.index > _VideoUtils2.default.browserActiveButton) listOffset = listHeight;
	
	        topPosition = this.props.topButtonsOffset + _Properties2.default.BROWSER_BUTTON_HEIGHT * this.props.index + listOffset;
	
	        var buttonColor;
	        var textColor;
	        var icon;
	        var iconColor;
	
	        if (this.props.index == this.props.activeButton) {
	            buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            textColor = '#F7F7F7';
	            icon = 'fa fa-angle-down';
	            iconColor = 'white';
	        } else {
	            icon = 'fa fa-angle-right';
	            iconColor = 'black';
	
	            if (this.state.isOver == true) {
	                buttonColor = _Properties2.default.BROWSER_HOVER_COLOR;
	                textColor = '#2299D6';
	            } else {
	                buttonColor = _Properties2.default.BROWSER_COLOR;
	                textColor = '#000000';
	            }
	        }
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.BROWSER_BUTTON_HEIGHT,
	            paddingLeft: _Properties2.default.BROWSER_LEFT_PADDING,
	            top: topPosition,
	            color: 'white',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none',
	            margin: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            textAlign: 'left',
	            borderStyle: 'none',
	            paddingRight: 0,
	            paddingBottom: 0,
	            paddingTop: 0
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 5,
	            color: textColor,
	            fontSize: 15,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 6,
	            right: _Properties2.default.BROWSER_LEFT_PADDING + _Properties2.default.BROWSER_ICON_RIGHT_PADDING,
	            color: iconColor
	        };
	
	        var topLine = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: tabStyle.width,
	            height: 1,
	            background: 'white',
	            display: 'block'
	        };
	
	        var idValue;
	
	        if (this.props.index == 0) idValue = 'backgroundElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, 'aria-label': this.props.text, style: tabStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement('span', { style: topLine }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: icon })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var accordionWidth = state.accordion.width;
	    var activeButton = state.accordion.activeButton;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    if (activeButton == undefined) activeButton = 0;
	
	    return {
	        accordionWidth: accordionWidth,
	        activeButton: activeButton
	    };
	}
	
	var BrowserButton = exports.BrowserButton = (0, _reactRedux.connect)(mapStateToProps)(BrowserButtonContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/BrowserButton.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/BrowserButton.js"); } } })();

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.List = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _ListItemRenderer = __webpack_require__(167);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _OnOffToggleButton = __webpack_require__(122);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListContent = _react2.default.createClass({
	    displayName: 'ListContent',
	    getInitialState: function getInitialState() {
	        return {
	            elements: [],
	            refreshHandlers: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        _VideoUtils2.default.refreshItemRenderer = undefined;
	        this.initElements();
	    },
	    initElements: function initElements() {
	        var elements = [];
	        var items = this.props.dataProvider;
	        var noBackgroundTitle = _LocalesManager2.default.getCaption('NoBackground', 'other');
	
	        if (this.props.isBackground && items.length > 0) {
	            var item = items[items.length - 1];
	
	            if (item.blankBackground == true) {
	                // is already set
	            } else {
	                var noBackgroundItem = {};
	                noBackgroundItem.logicalName = '';
	                noBackgroundItem.title = noBackgroundTitle;
	                noBackgroundItem.noBackground = true;
	                noBackgroundItem.xlinkHref = '';
	                noBackgroundItem.frameLabel = '';
	                noBackgroundItem.moods = [];
	                noBackgroundItem.blankBackground = true;
	                noBackgroundItem.isVideo = false;
	
	                items.push(noBackgroundItem);
	            }
	        }
	
	        var i = void 0;
	        var backgroundColor = 'white';
	
	        if (_AppParameters2.default.newClipartId == 59681267 || _AppParameters2.default.default && _AppParameters2.default.default.newClipartId == 59681267) {
	            // Space universe ... workaround for CH-249
	            if (this.props.index == 3) backgroundColor = 'lightsteelblue';
	        }
	
	        for (i = 0; i < items.length; i++) {
	            var _item = items[i];
	            elements.push(_react2.default.createElement(_ListItemRenderer.ListItemRenderer, { item: _item, backgroundColor: backgroundColor, key: 'listElements' + (i + 1), isBackground: this.props.isBackground, isMediaFiles: this.props.isMediaFiles, index: i, addRefreshHandler: this.addRefreshHandler, parentWidth: this.props.width }));
	        }
	
	        this.setState({
	            elements: elements,
	            refreshHandlers: []
	        });
	    },
	    addRefreshHandler: function addRefreshHandler(handler, index) {
	        if (!_MasterUniverseUtils2.default.useThumbnailsLazyLoading()) return;
	
	        this.state.refreshHandlers[index] = handler;
	    },
	    updateScroll: function updateScroll(scrollTop) {
	        if (!_MasterUniverseUtils2.default.useThumbnailsLazyLoading()) return;
	
	        if (!this.state.refreshHandlers) return;
	
	        for (var i = 0; i < this.state.elements.length; i++) {
	            if (this.state.refreshHandlers[i]) this.state.refreshHandlers[i](scrollTop);
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        var dinamicDataProvider = this.props.activeButton != newProps.activeButton || this.props.oldActiveButton != newProps.oldActiveButton;
	
	        if (this.state.elements != nextState.elements || this.props.width != newProps.width || this.props.windowHeight != newProps.windowHeight || dinamicDataProvider || this.props.useBackgroundAsImage != newProps.useBackgroundAsImage || this.props.useVideoAsBackground != newProps.useVideoAsBackground) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.elements == undefined) return _react2.default.createElement('div', null);
	
	        var displayState = 'none';
	
	        if ((this.props.index == this.props.activeButton || this.props.index == this.props.oldActiveButton) && this.props.dataProvider.length > 0) displayState = 'inline-block';
	
	        var paddingTop = 5;
	        var paddingLeft = 3;
	
	        var componentProperties = {};
	        componentProperties.paddingTop = paddingTop;
	        componentProperties.paddingLeft = paddingLeft;
	        componentProperties.width = this.props.width;
	        componentProperties.top = this.props.top;
	        componentProperties.displayState = displayState;
	
	        var listHeight = this.props.windowHeight - this.props.itemsLength * _Properties2.default.BROWSER_BUTTON_HEIGHT - this.props.topButtonsOffset;
	        componentProperties.height = listHeight - 15;
	
	        if (this.props.isBackground && this.props.dataProvider.length > 0) {
	            if (_PlatformDetection2.default.isTouchableDevice() == false) componentProperties.paddingTop = 13;
	        }
	
	        if (_MasterUniverseUtils2.default.useThumbnailsLazyLoading()) {
	            if (this.props.index == this.props.activeButton) componentProperties.elements = this.state.elements;else componentProperties.elements = [];
	
	            componentProperties.updateScrollHandler = this.updateScroll;
	        } else {
	            componentProperties.elements = this.state.elements;
	        }
	
	        var onOffButton;
	
	        if (this.props.isBackground && this.props.clipartCategory === 0 || this.props.clipartCategory === 1) {
	            var topGap = 5;
	            var bottomGap = 2;
	            var onOffButtonProperties = {};
	
	            onOffButtonProperties.topPosition = componentProperties.top + topGap;
	            onOffButtonProperties.leftPosition = _Properties2.default.MY_MEDIA_FILES_GAP;
	            onOffButtonProperties.trackWidth = _Properties2.default.TOGGLE_TRACK_WIDTH;
	            onOffButtonProperties.trackHeight = _Properties2.default.TOGGLE_TRACK_HEIGHT;
	            onOffButtonProperties.thumbHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
	            onOffButtonProperties.thumbSize = _Properties2.default.TOGGLE_THUMB_SIZE;
	            onOffButtonProperties.dispatch = this.props.dispatch;
	            onOffButtonProperties.width = _Properties2.default.BROWSER_WIDTH - 2 * _Properties2.default.MY_MEDIA_FILES_GAP;
	
	            if (this.props.clipartCategory === 1) {
	                onOffButtonProperties.useVideoAsBackground = this.props.useVideoAsBackground;
	                onOffButtonProperties.isMediaFilesElement = true;
	                onOffButtonProperties.isVideo = true;
	            } else {
	                onOffButtonProperties.isBackgroundElement = true;
	                onOffButtonProperties.useBackgroundAsImage = this.props.useBackgroundAsImage;
	            }
	
	            onOffButton = _react2.default.createElement(_OnOffToggleButton.OnOffToggleButton, { properties: onOffButtonProperties, dispatch: this.props.dispatch });
	
	            var toggleButtonHeight = onOffButtonProperties.thumbSize + topGap + bottomGap;
	
	            componentProperties.top = componentProperties.top + toggleButtonHeight;
	            componentProperties.height = componentProperties.height - toggleButtonHeight;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                onOffButton,
	                _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	            );
	        } else {
	            return _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties });
	        }
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var accordionWidth = state.accordion.width;
	    var useBackgroundAsImage = state.menu.useBackgroundAsImage;
	    var useVideoAsBackground = state.menu.useVideoAsBackground;
	
	    if (useBackgroundAsImage == undefined) useBackgroundAsImage = false;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    if (useVideoAsBackground == undefined) useVideoAsBackground = true;
	
	    var activeButton = state.accordion.activeButton;
	    var oldActiveButton = state.accordion.oldActiveButton;
	
	    if (!activeButton || activeButton < 0) activeButton = 0;
	
	    if (!oldActiveButton) oldActiveButton = -1;
	
	    return {
	        width: accordionWidth,
	        activeButton: activeButton,
	        oldActiveButton: oldActiveButton,
	        useBackgroundAsImage: useBackgroundAsImage,
	        useVideoAsBackground: useVideoAsBackground
	    };
	}
	
	var List = exports.List = (0, _reactRedux.connect)(mapStateToProps)(ListContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/List.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/accordion/List.js"); } } })();

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioElement = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AudioTrack = __webpack_require__(764);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioElement = exports.AudioElement = _react2.default.createClass({
	    displayName: 'AudioElement',
	    getTrackTitle: function getTrackTitle() {
	        if (this.props.timeline.title && this.props.timeline.title.length > 0) return this.props.timeline.title;else {
	            var title = _LocalesManager2.default.getCaption('track_1', 'other');
	
	            if (title == undefined || title == '' || title.indexOf('other.') != -1) title = 'Track ' + (this.props.index + 1);else {
	                title = title.replace('1', '');
	                title = title + (this.props.index + 1);
	            }
	
	            return title;
	        }
	    },
	    render: function render() {
	        var height = _AudioToolUtils2.default.timelineHeight();
	        var menuStyle = {
	            position: 'absolute',
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            top: this.props.index * height,
	            left: 0,
	            width: this.props.width,
	            height: height
	        };
	
	        var lineSize = _Properties2.default.LINE_SIZE;
	        var topLineStyle = {
	            position: 'absolute',
	            width: menuStyle.width,
	            left: 0,
	            top: 0,
	            height: lineSize,
	            background: _Properties2.default.AUDIO_BORDER
	        };
	
	        var bottomLine;
	        var timelinesLength = _AudioEditorUtils2.default.getTimelinesLength();
	        var maxTimelines = _AudioEditorUtils2.default.getMaxTimelinesRelatedToHeight();
	
	        if (maxTimelines < timelinesLength) timelinesLength = maxTimelines;
	
	        if (this.props.index + 1 == timelinesLength) {
	            var bottomLineStyle = {
	                position: 'absolute',
	                width: menuStyle.width,
	                left: 0,
	                top: height,
	                height: lineSize,
	                background: _Properties2.default.AUDIO_BORDER
	            };
	
	            bottomLine = _react2.default.createElement('div', { style: bottomLineStyle });
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, 'aria-label': this.getTrackTitle() },
	            _react2.default.createElement(_AudioTrack.AudioTrack, { buttonsHolderWidth: this.props.buttonsHolderWidth, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, isMute: this.props.timeline.isMute, isSelected: this.props.timeline.isSelected, trackWidth: this.props.width, index: this.props.index, audios: this.props.timeline.audios, trackTitle: this.props.timeline.title, timelinesLength: timelinesLength, zoomValue: this.props.zoomValue, dispatch: this.props.dispatch }),
	            _react2.default.createElement('div', { style: topLineStyle }),
	            bottomLine
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioElement.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioElement.js"); } } })();

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioElementVolume = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _VolumeSlider = __webpack_require__(123);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioElementVolume = exports.AudioElementVolume = _react2.default.createClass({
	    displayName: 'AudioElementVolume',
	    getInitialState: function getInitialState() {
	        return {
	            isVolumeOver: false,
	            openVolumeSlider: false,
	            isSettingsOver: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('click', this.onCloseVolumeSlider);
	        document.addEventListener('touchend', this.onCloseVolumeSlider);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('click', this.onCloseVolumeSlider);
	        document.removeEventListener('touchend', this.onCloseVolumeSlider);
	    },
	    onMenuButtonMouseIn: function onMenuButtonMouseIn() {
	        if (_AudioToolUtils2.default.isLeftSideCollapsed()) _HoverManager2.default.show(this.refs.trackSettings, 'trackSettings', 'right');else _HoverManager2.default.show(this.refs.trackSettings, 'trackSettings');
	
	        this.setState({
	            isSettingsOver: true
	        });
	    },
	    onMenuButtonMouseOut: function onMenuButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isSettingsOver: false
	        });
	    },
	    onShowMenu: function onShowMenu(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var state = _StoreManager2.default.getState();
	
	        if (state.audioEditor.trackMenu == this.props.index) this.props.dispatch((0, _AudioEditorActions.showTrackMenu)(-1));else this.props.dispatch((0, _AudioEditorActions.showTrackMenu)(this.props.index));
	    },
	    onVolumeMouseIn: function onVolumeMouseIn() {
	        if (_AudioToolUtils2.default.isLeftSideCollapsed()) _HoverManager2.default.show(this.refs.volumeButton, 'trackVolume', 'right');else _HoverManager2.default.show(this.refs.volumeButton, 'trackVolume');
	
	        this.setState({
	            isVolumeOver: true
	        });
	    },
	    onVolumeMouseOut: function onVolumeMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isVolumeOver: false
	        });
	    },
	    closeVolumeSliderHandler: function closeVolumeSliderHandler() {
	        this.setState({
	            openVolumeSlider: false
	        });
	    },
	    onCloseVolumeSlider: function onCloseVolumeSlider(e) {
	        if (_TextSizeUtils2.default.isTextEditMode()) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (!_PlatformDetection2.default.isIOS()) {
	            if (!document.getElementById('htmlColorPicker')) e.preventDefault();
	        }
	
	        var target = e.target;
	
	        var volume = 'audioElementVolume_' + this.props.index;
	
	        if (target == undefined || target && target.id == volume || target.parentElement && target.parentElement.id == volume) return;
	
	        if (target.id == 'volumeIcon') {
	            this.setState({
	                openVolumeSlider: false
	            });
	
	            return;
	        }
	
	        if (target.id.indexOf('volumeSlider') != -1 || target.parentElement && target.parentElement.id.indexOf('volumeSlider') != -1 || target.parentElement && target.parentElement.parentElement && target.parentElement.parentElement.id.indexOf('volumeSlider') != -1) return;
	
	        this.setState({
	            openVolumeSlider: false
	        });
	    },
	    onOpenVolumeSlider: function onOpenVolumeSlider(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.setState({
	            openVolumeSlider: true
	        });
	    },
	    getSoundIcon: function getSoundIcon() {
	        var state = _StoreManager2.default.getState();
	        var soundVolume;
	        var timeline = state.audioEditor.timelines[this.props.index];
	
	        if (timeline) {
	            if (timeline.isMute) soundVolume = 0;else soundVolume = timeline.volume;
	        }
	
	        if (soundVolume == undefined) soundVolume = 0.5;
	
	        if (_AudioEditorUtils2.default.isVolumeMute(this.props.index)) return 'fa fa-volume-off';
	
	        var volumeIcon = 'fa fa-volume-down';
	
	        if (soundVolume == 0) volumeIcon = 'fa fa-volume-off';else if (soundVolume <= 0.5) volumeIcon = 'fa fa-volume-down';else if (soundVolume > 0.5) volumeIcon = 'fa fa-volume-up';
	
	        return volumeIcon;
	    },
	    onChangeText: function onChangeText(e) {
	        var newValue = e.target.value;
	
	        if (newValue == undefined) return;
	
	        this.props.dispatch((0, _AudioEditorActions.changeTitle)(this.props.index, newValue));
	    },
	    onBlur: function onBlur(e) {
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        if (e.target) e.target.setAttribute('disabled', '');
	
	        this.forceUpdate();
	    },
	    getText: function getText() {
	        var title = _LocalesManager2.default.getCaption('track_1', 'other');
	
	        if (title == undefined || title == '' || title.indexOf('other.') != -1) title = 'Track ' + (this.props.index + 1);else {
	            title = title.replace('1', '');
	            title = title + (this.props.index + 1);
	        }
	
	        if (this.props.timeline && this.props.timeline.title != undefined) title = this.props.timeline.title;
	
	        return title;
	    },
	    render: function render() {
	        var backgroundColor = '#999A9C';
	        var isTimelineSelected = this.props.timeline.isSelected;
	        var isMenuVisible = false;
	
	        if (this.props.menuIndex != -1) {
	            // is menu opened
	            if (this.props.menuIndex == this.props.index) isMenuVisible = true;
	        }
	
	        if (isTimelineSelected || isMenuVisible) backgroundColor = _Properties2.default.SLIDE_VIEWER_BACKGROUND;
	
	        var menuStyle = {
	            position: 'absolute',
	            top: this.props.index * _AudioToolUtils2.default.timelineHeight(),
	            left: 0,
	            width: _AudioToolUtils2.default.buttonsHolderWidth(),
	            height: _AudioToolUtils2.default.timelineHeight(),
	            background: backgroundColor
	        };
	
	        var gap = 12;
	        var text = this.getText();
	        var titleHeight = 20;
	        var titleStyle = {
	            position: 'absolute',
	            color: 'black',
	            top: menuStyle.height / 2 - titleHeight / 2,
	            left: 5,
	            paddingLeft: 3,
	            paddingRight: 3,
	            fontSize: 12,
	            width: 140,
	            height: titleHeight,
	            fontWeight: 'bold',
	            resize: 'none',
	            overflow: 'hidden',
	            border: 'none',
	            outline: 'none',
	            background: 'transparent'
	        };
	
	        var isActive = false;
	
	        if (isMenuVisible || document.activeElement == this.refs.titleInput) {
	            titleStyle.background = 'white';
	            isActive = true;
	        }
	
	        var verticalLineStyle = {
	            position: 'absolute',
	            width: _Properties2.default.LINE_SIZE,
	            left: menuStyle.width - _Properties2.default.LINE_SIZE,
	            top: 0,
	            height: menuStyle.height,
	            background: _Properties2.default.AUDIO_BORDER
	        };
	
	        var horizontalLineStyle = {
	            position: 'absolute',
	            width: menuStyle.width,
	            left: 0,
	            top: 0,
	            height: _Properties2.default.LINE_SIZE,
	            background: _Properties2.default.AUDIO_BORDER
	        };
	
	        var bottomLine;
	
	        if (this.props.index + 1 == _AudioEditorUtils2.default.getTimelinesLength()) {
	            var bottomLineStyle = {
	                position: 'absolute',
	                width: menuStyle.width,
	                left: 0,
	                top: menuStyle.height,
	                height: _Properties2.default.LINE_SIZE,
	                background: _Properties2.default.AUDIO_BORDER
	            };
	
	            bottomLine = _react2.default.createElement('div', { style: bottomLineStyle });
	        }
	
	        var iconColor;
	
	        if (this.state.isVolumeOver == true) iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else iconColor = 'black';
	
	        var volumeIconStyle = {
	            position: 'absolute',
	            top: 7,
	            left: 10,
	            color: iconColor
	        };
	
	        var volumeAreaSize = 30;
	        var volumeAreaStyle = {
	            position: 'absolute',
	            width: volumeAreaSize,
	            height: volumeAreaSize,
	            left: menuStyle.width - gap - volumeAreaSize,
	            top: menuStyle.height / 2 - volumeAreaSize / 2,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        // settings button
	        if (this.state.isSettingsOver == true) iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else iconColor = 'black';
	
	        var menuButtonStyle = {
	            position: 'absolute',
	            top: menuStyle.height / 2 - volumeAreaSize / 2,
	            left: menuStyle.width - gap - 2 * volumeAreaSize,
	            width: volumeAreaSize,
	            height: volumeAreaSize,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        var menuButtonIconStyle = {
	            position: 'absolute',
	            top: 7,
	            left: 9,
	            color: iconColor
	        };
	
	        var colorStyle = {
	            position: 'absolute',
	            top: 0,
	            left: menuStyle.width - 10,
	            width: 10,
	            height: menuStyle.height,
	            backgroundColor: _AudioEditorUtils2.default.getStartColor(this.props.index)
	        };
	
	        var isCollapsed = false;
	
	        if (_AudioToolUtils2.default.isLeftSideCollapsed()) {
	            titleStyle.display = 'none';
	            isCollapsed = true;
	        }
	
	        var soloStyle = {
	            position: 'absolute',
	            right: 22,
	            fontSize: 15,
	            fontWeight: 'bold',
	            top: 7,
	            display: 'none'
	        };
	
	        var muteStyle = {
	            position: 'absolute',
	            right: 22,
	            fontSize: 15,
	            fontWeight: 'bold',
	            bottom: 7,
	            display: 'none'
	        };
	
	        if (this.state.isVolumeOver == true) iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else iconColor = 'black';
	
	        var muteVolume = {
	            position: 'absolute',
	            right: 16,
	            fontSize: 13,
	            fontWeight: 'bold',
	            bottom: 28,
	            display: 'none',
	            color: iconColor
	        };
	
	        if (!_AudioToolUtils2.default.isAudioTool()) {
	            soloStyle.right = 24;
	            soloStyle.fontSize = 11;
	            soloStyle.top = 5;
	
	            muteStyle.right = 24;
	            muteStyle.fontSize = 11;
	            muteStyle.bottom = 5;
	
	            muteVolume.bottom = 18;
	        }
	
	        if (this.props.timeline.isSolo) soloStyle.display = 'block';
	
	        if (_AudioEditorUtils2.default.getSoloIndex() < 0 && this.props.timeline.isMute) muteStyle.display = 'block';
	
	        if (_AudioEditorUtils2.default.isVolumeMute(this.props.index)) muteVolume.display = 'block';
	
	        var labelValue = _LocalesManager2.default.getCaption('titleForTrack', 'other') + ' ' + (this.props.index + 1);
	        var labelStyle = {
	            position: 'absolute',
	            left: 5,
	            top: 7,
	            fontSize: 12,
	            width: 140,
	            whiteSpace: 'nowrap',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            color: 'black',
	            background: 'transparent',
	            display: 'none'
	        };
	
	        if (isActive) labelStyle.display = 'inline-block';
	
	        if (!_AudioToolUtils2.default.isAudioEditorTool() && isActive) {
	            // is Cartoonist
	            titleStyle.top = 6;
	            titleStyle.paddingTop = 17;
	
	            labelStyle.left = 7;
	            labelStyle.top = 9;
	            labelStyle.zIndex = 2;
	            labelStyle.color = '#2479be';
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement('div', { style: colorStyle }),
	            _react2.default.createElement(
	                'label',
	                { htmlFor: 'track_' + this.props.index, style: labelStyle },
	                labelValue
	            ),
	            _react2.default.createElement('input', { ref: 'titleInput', id: 'track_' + this.props.index, 'aria-label': labelValue, disabled: true, style: titleStyle, onChange: this.onChangeText, onBlur: this.onBlur, type: 'text', className: 'titleInput trackTitle_' + this.props.index, value: text, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off' }),
	            _react2.default.createElement(
	                'div',
	                { style: soloStyle },
	                'S'
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: muteStyle },
	                'M'
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: muteVolume },
	                'x'
	            ),
	            _react2.default.createElement(
	                'button',
	                { className: 'trackSettings', 'aria-label': text + ' ' + _LocalesManager2.default.getCaption('trackSettings', 'hover'), ref: 'trackSettings', style: menuButtonStyle, onTouchEnd: this.onShowMenu, onClick: this.onShowMenu, onMouseOver: this.onMenuButtonMouseIn, onMouseOut: this.onMenuButtonMouseOut },
	                _react2.default.createElement('i', { style: menuButtonIconStyle, className: 'fa fa-bars slideMenuButton trackSettings' })
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: 'volumeButton', 'aria-label': text + ' ' + _LocalesManager2.default.getCaption('trackVolume', 'hover'), id: 'audioElementVolume_' + this.props.index, style: volumeAreaStyle, onMouseOver: this.onVolumeMouseIn, onMouseOut: this.onVolumeMouseOut, onClick: this.onOpenVolumeSlider, onTouchEnd: this.onOpenVolumeSlider },
	                _react2.default.createElement('i', { style: volumeIconStyle, className: this.getSoundIcon() })
	            ),
	            _react2.default.createElement('div', { style: verticalLineStyle }),
	            _react2.default.createElement('div', { style: horizontalLineStyle }),
	            bottomLine,
	            _react2.default.createElement(_VolumeSlider.VolumeSlider, { dispatch: this.props.dispatch, isCollapsed: isCollapsed, visible: this.state.openVolumeSlider, type: 'audioEditor', index: this.props.index, closeVolumeSliderHandler: this.closeVolumeSliderHandler })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioElementVolume.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioElementVolume.js"); } } })();

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioGraph = exports.LineElement = exports.ControlPoint = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ControlPoint = exports.ControlPoint = _react2.default.createClass({
	    displayName: 'ControlPoint',
	    onMouseDown: function onMouseDown(e) {
	        _SaveManager2.default.isContentChanged(true);
	        _HoverManager2.default.hide();
	
	        if (this.props.controlPointDown) this.props.controlPointDown(this.props.index);
	
	        this.setState({
	            startX: this.props.x,
	            startY: this.props.y
	        });
	
	        _AudioEditorUtils2.default.isVolumeAction = true;
	    },
	    onMouseMove: function onMouseMove(e, coreEvent) {
	        _HoverManager2.default.hide();
	
	        var point = {};
	
	        if (this.props.index == 0 || this.props.index == this.props.length - 1) point.x = this.state.startX;else point.x = this.state.startX + coreEvent.lastX;
	
	        point.y = this.state.startY + coreEvent.lastY;
	
	        if (this.props.controlPointMove) this.props.controlPointMove(point);
	    },
	    onMouseUp: function onMouseUp(e) {
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.isVolumeAction = false;
	
	        if (this.props.controlPointUp) this.props.controlPointUp();
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        if (document.activeElement != this.refs.point) return;
	
	        var offset = 5;
	        var offsetX = 0;
	        var offsetY = 0;
	
	        switch (e.keyCode) {
	            case 37:
	                {
	                    // Left
	                    offsetX = -offset;
	                    break;
	                }
	            case 39:
	                {
	                    // Right
	                    offsetX = offset;
	                    break;
	                }
	            case 38:
	                {
	                    // Top
	                    offsetY = -offset;
	                    break;
	                }
	            case 40:
	                {
	                    // Down
	                    offsetY = offset;
	                    break;
	                }
	            case 9:
	                {
	                    // Tab --> should send focus to marker
	                    if (e.shiftKey) return;
	
	                    if (this.props.index == this.props.controlPointsLength - 1) {
	                        setTimeout(function () {
	                            var markerElement = document.getElementById('markerHead');
	
	                            if (markerElement) markerElement.focus();
	                        }.bind(this), 10);
	                    }
	                    break;
	                }
	        }
	
	        var point = {};
	
	        if (this.props.index == 0 || this.props.index == this.props.length - 1) point.x = this.props.x;else point.x = this.props.x + offsetX;
	
	        point.y = this.props.y + offsetY;
	
	        if (this.props.updateControlPointOnKeyDown) this.props.updateControlPointOnKeyDown(point, this.props.index);
	    },
	    onMouseIn: function onMouseIn() {
	        if (!_AudioEditorUtils2.default.isVolumeAction) {
	            if (_AudioToolUtils2.default.isLeftSideCollapsed()) _HoverManager2.default.show(this.refs.point, 'audioVolumePoint', 'right');else _HoverManager2.default.show(this.refs.point, 'audioVolumePoint');
	        }
	    },
	    onMouseOut: function onMouseOut() {
	        _HoverManager2.default.hide();
	    },
	    render: function render() {
	        var size = _AudioToolUtils2.default.getGraphControlPointSize();
	        var borderSize = _Properties2.default.VOLUME_CONTROL_LINE_SIZE;
	        var holderStyle = {
	            position: 'absolute',
	            width: size - 2 * borderSize,
	            height: size - 2 * borderSize,
	            left: this.props.x - size / 2,
	            top: this.props.y - size / 2,
	            background: 'white',
	            borderRadius: 50,
	            borderColor: 'black',
	            borderWidth: borderSize,
	            borderStyle: 'solid',
	            cursor: 'crosshair',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial'
	        };
	
	        var ariaLabelValue = _LocalesManager2.default.getCaption('volumeControlPointElement', 'other') + ' ' + this.props.index;
	        var tabIndexValue;
	
	        if (!this.props.isSelected) tabIndexValue = '-1';
	
	        return _react2.default.createElement(
	            _reactDraggable2.default,
	            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	            _react2.default.createElement('button', { ref: 'point', tabIndex: tabIndexValue, 'aria-label': ariaLabelValue, style: holderStyle, onKeyDown: this.onKeyDown, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut })
	        );
	    }
	});
	
	var LineElement = exports.LineElement = _react2.default.createClass({
	    displayName: 'LineElement',
	    setEvents: function setEvents() {
	        var add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        if (add) {
	            document.addEventListener('mousemove', this.onMouseMove);
	            document.addEventListener('mouseup', this.onMouseUp);
	
	            document.addEventListener('touchmove', this.onMouseMove);
	            document.addEventListener('touchend', this.onMouseUp);
	        } else {
	            document.removeEventListener('mousemove', this.onMouseMove);
	            document.removeEventListener('mouseup', this.onMouseUp);
	
	            document.removeEventListener('touchmove', this.onMouseMove);
	            document.removeEventListener('touchend', this.onMouseUp);
	        }
	    },
	    onMouseDown: function onMouseDown(e) {
	        _SaveManager2.default.isContentChanged(true);
	        var touchPosition = _MouseUtils2.default.getTouchPosition(e);
	        var newPoint = { x: touchPosition.x - this.props.globalPoint.x, y: touchPosition.y - this.props.globalPoint.y };
	
	        if (this.props.lineElementDown) this.props.lineElementDown(newPoint);
	
	        this.setState({
	            startX: newPoint.x,
	            startY: newPoint.y,
	            initialGlobalX: touchPosition.x,
	            initialGlobalY: touchPosition.y
	        });
	
	        _AudioEditorUtils2.default.isVolumeAction = true;
	        this.setEvents();
	    },
	    getCurrentPoint: function getCurrentPoint(e) {
	        var point = {};
	        var touchPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (this.state && this.state.startX && this.state.initialGlobalX) {
	            point.x = this.state.startX + (touchPosition.x - this.state.initialGlobalX);
	            point.y = this.state.startY + (touchPosition.y - this.state.initialGlobalY);
	        } else {
	            point.x = 0;
	            point.y = 0;
	        }
	
	        return point;
	    },
	    onMouseMove: function onMouseMove(e) {
	        var point = this.getCurrentPoint(e);
	
	        if (this.props.lineElementMove) this.props.lineElementMove(point);
	    },
	    onMouseUp: function onMouseUp() {
	        if (_TextSizeUtils2.default.isTextEditMode()) return;
	
	        _SaveManager2.default.isContentChanged(true);
	
	        if (this.props.lineElementUp) this.props.lineElementUp();
	
	        this.setState({
	            startX: undefined,
	            startY: undefined,
	            initialGlobalX: undefined,
	            initialGlobalY: undefined
	        });
	
	        this.setEvents(false);
	        _AudioEditorUtils2.default.isVolumeAction = false;
	    },
	    getLineProperties: function getLineProperties(x1, y1, x2, y2) {
	        var distance = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
	        var centerX = (x1 + x2) / 2;
	        var centerY = (y1 + y2) / 2;
	
	        var angle = Math.atan2(y1 - y2, x1 - x2);
	        var angleDegrees = angle * 180 / Math.PI;
	
	        var properties = {};
	
	        properties.width = distance;
	        properties.top = centerY;
	        properties.left = centerX - distance / 2;
	        properties.transform = 'rotate(' + angleDegrees + 'deg)';
	
	        return properties;
	    },
	    render: function render() {
	        var holderHeight = _AudioToolUtils2.default.getGraphControlLineSize();
	        var lineSize = _Properties2.default.LINE_SIZE;
	        var offset = holderHeight / 2;
	
	        var lineProperties = this.getLineProperties(this.props.x1, this.props.y1 - offset, this.props.x2, this.props.y2 - offset);
	        var holderStyle = {
	            position: 'absolute',
	            width: lineProperties.width,
	            height: holderHeight,
	            top: lineProperties.top,
	            left: lineProperties.left,
	            transform: lineProperties.transform,
	            cursor: 'crosshair',
	            display: 'block'
	        };
	
	        var lineStyle = {
	            position: 'absolute',
	            width: holderStyle.width,
	            height: lineSize,
	            top: holderStyle.height / 2 - lineSize / 2,
	            left: 0,
	            background: 'black',
	            display: 'block'
	        };
	
	        return _react2.default.createElement(
	            'span',
	            { style: holderStyle, onMouseDown: this.onMouseDown, onTouchStart: this.onMouseDown },
	            _react2.default.createElement('span', { style: lineStyle })
	        );
	    }
	});
	
	var AudioGraph = exports.AudioGraph = _react2.default.createClass({
	    displayName: 'AudioGraph',
	    getInitialState: function getInitialState() {
	        return {
	            currentPoint: undefined,
	            controlPoints: undefined
	        };
	    },
	    getInnerZoom: function getInnerZoom(time) {
	        var zoom = _AudioEditorUtils2.default.getZoomValue();
	        var itemWidth = _AudioEditorUtils2.default.getSlideWidth(time);
	        var innerWidth = itemWidth - _AudioToolUtils2.default.getGraphControlPointSize();
	
	        return innerWidth * zoom / itemWidth;
	    },
	    getCorrectedControlPoints: function getCorrectedControlPoints() {
	        if (this.props.audio.points) {
	            var points = [];
	            var i;
	            var point;
	            var duration = this.props.audio.duration;
	
	            for (i = 0; i < this.props.audio.points.length; i++) {
	                point = this.props.audio.points[i];
	
	                if (point.time < 0 || point.time > duration) {
	                    // something wrong
	                    if (point.time > duration && point.time - duration < 0.001) {
	                        point.time = duration;
	                        points.push(point);
	                    }
	                } else {
	                    points.push(point);
	                }
	            }
	
	            return points;
	        } else return undefined;
	    },
	    getControlPointsFromProps: function getControlPointsFromProps() {
	        var controlPoints = this.getCorrectedControlPoints();
	        var newPoints = [];
	        var i;
	        var innerZoom = this.getInnerZoom(this.props.audio.duration);
	        var topOffset = _Properties2.default.LINE_SIZE + _AudioToolUtils2.default.getGraphControlPointSize() / 2;
	        var leftOffset = _AudioToolUtils2.default.getGraphControlPointSize() / 2;
	
	        if (controlPoints == undefined || controlPoints.length < 2) {
	            newPoints = [];
	
	            newPoints.push({ x: leftOffset, y: topOffset });
	            newPoints.push({ x: _AudioEditorUtils2.default.getSlideWidth(this.props.audio.duration, innerZoom) + leftOffset, y: topOffset });
	
	            return newPoints;
	        }
	
	        for (i = 0; i < controlPoints.length; i++) {
	            var x = _AudioEditorUtils2.default.getSlideWidth(controlPoints[i].time, innerZoom) + leftOffset;
	            var y = this.getHeight() * (1 - controlPoints[i].vol) + topOffset;
	
	            newPoints.push({ x: x, y: y });
	        }
	
	        return this.sortElements(newPoints);
	    },
	    updateControlPointsToState: function updateControlPointsToState(controlPoints, currentPoint) {
	        var points = [].concat(controlPoints);
	        points.push(currentPoint);
	        points = this.sortElements(points);
	
	        var newPoints = [];
	        var i;
	        var dispatch = this.getDispatch();
	        var topOffset = _Properties2.default.LINE_SIZE + _AudioToolUtils2.default.getGraphControlPointSize() / 2;
	        var leftOffset = _AudioToolUtils2.default.getGraphControlPointSize() / 2;
	        var innerZoom = this.getInnerZoom(this.props.audio.duration);
	        var y;
	        var x;
	
	        for (i = 0; i < points.length; i++) {
	            if (points[i]) {
	                x = points[i].x - leftOffset;
	                var time = x / (innerZoom * _Properties2.default.SLIDE_ITEM_WIDTH);
	
	                y = points[i].y - topOffset;
	                var volume = 1 - y / this.getHeight();
	
	                newPoints.push({ time: time, vol: volume });
	            }
	        }
	
	        dispatch((0, _AudioEditorActions.setVolumePoints)(this.props.audio.uuid, newPoints));
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        this.setState({
	            controlPoints: undefined,
	            currentPoint: undefined
	        });
	    },
	    sortElements: function sortElements(array) {
	        array.sort(function (a, b) {
	            return a.x - b.x;
	        });
	
	        return array;
	    },
	    getHeight: function getHeight() {
	        return _AudioToolUtils2.default.timelineHeight() - _Properties2.default.LINE_SIZE - _AudioToolUtils2.default.getGraphControlPointSize();
	    },
	    checkControlPoint: function checkControlPoint(point) {
	        var topLimit = _Properties2.default.LINE_SIZE + _AudioToolUtils2.default.getGraphControlPointSize() / 2;
	        var bottomLimit = this.getHeight() + topLimit;
	        var leftLimit = _AudioToolUtils2.default.getGraphControlPointSize() / 2;
	        var rightLimit = _AudioEditorUtils2.default.getSlideWidth(this.props.audio.duration) - leftLimit;
	
	        if (point.y < topLimit) point.y = topLimit;
	
	        if (point.y > bottomLimit) point.y = bottomLimit;
	
	        if (point.x < leftLimit) point.x = leftLimit;
	
	        if (point.x > rightLimit) point.x = rightLimit;
	    },
	    getDispatch: function getDispatch() {
	        var store = _StoreManager2.default.getStore();
	        return store.dispatch;
	    },
	    getControlPoints: function getControlPoints() {
	        if (this.state.controlPoints) {
	            var points = [].concat(this.state.controlPoints);
	            points.push(this.state.currentPoint);
	
	            return this.sortElements(points);
	        } else {
	            return this.getControlPointsFromProps();
	        }
	    },
	    controlPointDown: function controlPointDown(index) {
	        _SaveManager2.default.isContentChanged(true);
	
	        var controlPointsArray = this.getControlPointsFromProps();
	        var currentPoint = controlPointsArray[index];
	        controlPointsArray.splice(index, 1);
	
	        this.setState({
	            currentPoint: currentPoint,
	            controlPoints: controlPointsArray
	        });
	    },
	    controlPointMove: function controlPointMove(currentPoint) {
	        this.checkControlPoint(currentPoint);
	
	        this.setState({
	            currentPoint: currentPoint
	        });
	    },
	    controlPointUp: function controlPointUp() {
	        _SaveManager2.default.isContentChanged(true);
	
	        setTimeout(function (controlPoints, currentPoint) {
	            this.updateControlPointsToState(controlPoints, currentPoint);
	        }.bind(this), 1, this.state.controlPoints, this.state.currentPoint);
	    },
	    updateControlPointOnKeyDown: function updateControlPointOnKeyDown(currentPointElement, index) {
	        _SaveManager2.default.isContentChanged(true);
	
	        var controlPointsArray = this.getControlPointsFromProps();
	        controlPointsArray.splice(index, 1);
	
	        this.checkControlPoint(currentPointElement);
	
	        setTimeout(function (controlPoints, currentPoint) {
	            this.updateControlPointsToState(controlPoints, currentPoint);
	        }.bind(this), 1, controlPointsArray, currentPointElement);
	    },
	    lineElementDown: function lineElementDown(point) {
	        var controlPointsArray = this.getControlPointsFromProps();
	        this.checkControlPoint(point);
	
	        this.setState({
	            currentPoint: point,
	            controlPoints: controlPointsArray
	        });
	    },
	    addControlPointHandler: function addControlPointHandler() {
	        var parentElement = document.getElementById(this.props.parentId);
	        var plusElement = document.getElementById('addVolumeControlPoint');
	
	        if (!parentElement || !plusElement) return;
	
	        var parentPosition = parentElement.getBoundingClientRect();
	        var plusPosition = plusElement.getBoundingClientRect();
	        var plusSize = 18;
	        var controlPointSize = 14;
	        var point = { x: plusPosition.left + plusSize / 2 - parentPosition.left, y: controlPointSize / 2 };
	        var controlPoints = this.getControlPointsFromProps();
	
	        this.checkControlPoint(point);
	        this.updateControlPointsToState(controlPoints, point);
	
	        this.forceUpdate();
	    },
	    render: function render() {
	        var controlPoints = this.getControlPoints();
	
	        if (controlPoints.length < 2 || _AudioEditorUtils2.default.isControlPointAction) return _react2.default.createElement('div', null);
	
	        if (this.props.isSelected) _AudioEditorUtils2.default.addControlPointHandler = this.addControlPointHandler;
	
	        var holderStyle = {
	            position: 'absolute',
	            display: 'block',
	            top: 0
	        };
	
	        var i;
	        var lines = [];
	        var points = [];
	
	        for (i = 0; i < controlPoints.length; i++) {
	            if (controlPoints[i]) points.push(_react2.default.createElement(ControlPoint, { key: 'point_' + i, length: controlPoints.length, x: controlPoints[i].x, y: controlPoints[i].y, index: i, isSelected: this.props.isSelected, controlPointsLength: controlPoints.length, controlPointDown: this.controlPointDown, controlPointMove: this.controlPointMove, controlPointUp: this.controlPointUp, updateControlPointOnKeyDown: this.updateControlPointOnKeyDown }));
	        }
	
	        for (i = 1; i < controlPoints.length; i++) {
	            if (controlPoints[i - 1] && controlPoints[i]) lines.push(_react2.default.createElement(LineElement, { key: 'line' + i, x1: controlPoints[i - 1].x, y1: controlPoints[i - 1].y, x2: controlPoints[i].x, y2: controlPoints[i].y, globalPoint: this.props.globalPoint, lineElementDown: this.lineElementDown, lineElementMove: this.controlPointMove, lineElementUp: this.controlPointUp }));
	        }
	
	        return _react2.default.createElement(
	            'span',
	            { style: holderStyle },
	            lines,
	            points
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioGraph.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioGraph.js"); } } })();

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioItemRenderer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _TimelineDragManager = __webpack_require__(137);
	
	var _TimelineDragManager2 = _interopRequireDefault(_TimelineDragManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _Animator = __webpack_require__(238);
	
	var _Animator2 = _interopRequireDefault(_Animator);
	
	var _AudioGraph = __webpack_require__(762);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _AudioVolumeUtils = __webpack_require__(67);
	
	var _AudioVolumeUtils2 = _interopRequireDefault(_AudioVolumeUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ControlPoint = _react2.default.createClass({
	    displayName: 'ControlPoint',
	    getInitialState: function getInitialState() {
	        return {
	            isThumbOver: false,
	            isThumbActive: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (this.props.setRightArrowUpdater) this.props.setRightArrowUpdater(this.updateRightArrow);
	    },
	    onThumbMouseIn: function onThumbMouseIn() {
	        if (!_AudioEditorUtils2.default.isControlPointAction) {
	            if (this.props.index == 0) _HoverManager2.default.show(this.refs.thumb, 'audioLeftTrim');else _HoverManager2.default.show(this.refs.thumb, 'audioRightTrim');
	        }
	
	        this.setState({
	            isThumbOver: true
	        });
	    },
	    onThumbMouseOut: function onThumbMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isThumbOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        _SaveManager2.default.isContentChanged(true);
	        _HoverManager2.default.hide();
	        _AudioEditorUtils2.default.isControlPointAction = true;
	
	        var touchPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            startClientX: touchPosition.x,
	            isThumbActive: true
	        });
	    },
	    onMouseMove: function onMouseMove(e) {
	        this.updateProperties(e);
	    },
	    onMouseUp: function onMouseUp(e) {
	        this.setState({
	            isThumbActive: false
	        });
	
	        _PlayController2.default.getOldScrollPosition();
	
	        setTimeout(function () {
	            this.updateProperties(e, true);
	        }.bind(this), 10);
	    },
	    updateProperties: function updateProperties(e) {
	        var isEndAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var touchPosition = _MouseUtils2.default.getTouchPosition(e);
	        var offsetX = touchPosition.x - this.state.startClientX;
	        var newProperties;
	
	        console.log(offsetX);
	
	        if (this.props.updateSize) newProperties = this.props.updateSize(offsetX, this.props.index, isEndAction);
	
	        if (this.props.index == 1 && !isEndAction && newProperties) {
	            // right arrow
	            this.refs.thumb.style.left = newProperties.width - _Properties2.default.ARROW_SIZE + 'px';
	        }
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode != 37 && e.keyCode != 39) return;
	
	        var isEndAction = true;
	        var offsetX = 2;
	
	        if (e.keyCode == 37) // Left Key
	            offsetX = -offsetX;
	
	        _SaveManager2.default.isContentChanged(true);
	        _PlayController2.default.getOldScrollPosition();
	
	        this.props.initStateForControlPointKeyHanlder();
	
	        setTimeout(function () {
	            var newProperties;
	
	            if (this.props.updateSize) newProperties = this.props.updateSize(offsetX, this.props.index, isEndAction);
	
	            if (this.props.index == 1 && !isEndAction && newProperties) {
	                // right arrow
	                this.refs.thumb.style.left = newProperties.width - _Properties2.default.ARROW_SIZE + 'px';
	            }
	        }.bind(this), 10);
	    },
	    updateRightArrow: function updateRightArrow(width) {
	        if (this.refs.thumb) this.refs.thumb.style.left = width - _Properties2.default.ARROW_SIZE + 'px';
	    },
	    render: function render() {
	        if (!this.props.showControlPoint) return _react2.default.createElement('div', null);
	
	        var height = _AudioToolUtils2.default.timelineHeight();
	        var leftPos = 0;
	        var iconSrc = 'fa fa-angle-left fa-2x';
	        var iconColor = 'white';
	
	        if (this.props.index == 1) {
	            leftPos = this.props.trackWidth - _Properties2.default.ARROW_SIZE;
	            iconSrc = 'fa fa-angle-right fa-2x';
	        }
	
	        var menuStyle = {
	            position: 'absolute',
	            left: leftPos,
	            top: 0,
	            width: _Properties2.default.ARROW_SIZE,
	            height: '100%',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            borderStyle: 'none',
	            background: 'none'
	        };
	
	        if (this.state.isThumbOver || this.state.isThumbActive) {
	            iconColor = 'black';
	        }
	
	        var lineStyle = {
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            width: _Properties2.default.ARROW_SIZE,
	            height: height,
	            background: 'black',
	            opacity: 0.25,
	            display: 'block'
	        };
	
	        var iconWidth = 12;
	        var iconHeight = 32;
	        var arrowIconStyle = {
	            position: 'absolute',
	            top: lineStyle.height / 2 - iconHeight / 2,
	            left: lineStyle.width / 2 - iconWidth / 2,
	            color: iconColor
	        };
	
	        var ariaLabelValue;
	
	        if (this.props.index == 0) ariaLabelValue = _LocalesManager2.default.getCaption('audioLeftTrim', 'hover');else ariaLabelValue = _LocalesManager2.default.getCaption('audioRightTrim', 'hover');
	
	        return _react2.default.createElement(
	            _reactDraggable2.default,
	            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	            _react2.default.createElement(
	                'button',
	                { 'aria-label': ariaLabelValue, ref: 'thumb', style: menuStyle, onKeyDown: this.onKeyDown, onMouseOver: this.onThumbMouseIn, onMouseOut: this.onThumbMouseOut },
	                _react2.default.createElement('span', { style: lineStyle }),
	                _react2.default.createElement('i', { style: arrowIconStyle, className: iconSrc })
	            )
	        );
	    }
	});
	
	var AudioItemRenderer = exports.AudioItemRenderer = _react2.default.createClass({
	    displayName: 'AudioItemRenderer',
	    getInitialState: function getInitialState() {
	        this.checkFocus();
	
	        return {
	            canvasWidth: -1
	        };
	    },
	    checkFocus: function checkFocus() {
	        setTimeout(function () {
	            if (_MouseUtils2.default.isFirstMarkerFocus) {
	                _MouseUtils2.default.isFirstMarkerFocus = false;
	                this.props.dispatch((0, _CurrentSlideActions.setShortcutsTarget)(true));
	            }
	        }.bind(this), 10);
	    },
	    onMouseIn: function onMouseIn(e) {
	        _HoverManager2.default.show(this.refs.waveform, this.props.audio.title, 'top', true, e.clientX);
	    },
	    onMouseOut: function onMouseOut() {
	        _HoverManager2.default.hide();
	    },
	    getPosition: function getPosition(position) {
	        return Number(position.substring(0, position.length - 2));
	    },
	    isInactiveArea: function isInactiveArea(e) {
	        if (e.nativeEvent.target.className.indexOf('inactiveArea') != -1) return true;else return false;
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (this.isInactiveArea(e)) return;
	
	        _SaveManager2.default.isContentChanged(true);
	        var left = _AudioEditorUtils2.default.getItemPosition(this.props.audio.left);
	        var durationWidth = _AudioEditorUtils2.default.getSlideWidth(this.props.audio.duration);
	
	        this.setState({
	            startLeftPosition: left,
	            startWidth: durationWidth
	        });
	
	        if (!_AudioEditorUtils2.default.isControlPointAction && !_AudioEditorUtils2.default.isVolumeAction) {
	            if (_TimelineDragManager2.default.isMultipleSelection(this.props.audio.uuid)) _TimelineDragManager2.default.startBlock(this.props.windowHeight, _MouseUtils2.default.getTouchPosition(e).y, this.props.dispatch);else {
	                _TimelineDragManager2.default.resetMultipleSelection();
	                _TimelineDragManager2.default.createClone(this.refs.clone, this.props.windowHeight, left, _MouseUtils2.default.getTouchPosition(e).y, durationWidth);
	            }
	        }
	    },
	    onMouseMove: function onMouseMove(e, coreEvent) {
	        if (_AudioEditorUtils2.default.isControlPointAction || _AudioEditorUtils2.default.isVolumeAction) return;
	
	        if (_TimelineDragManager2.default.isMultipleSelection(this.props.audio.uuid)) _TimelineDragManager2.default.moveBlockWithOffset(coreEvent.lastX, coreEvent.lastY, this.props.audio.uuid);else _TimelineDragManager2.default.move(coreEvent.lastX, coreEvent.lastY, e);
	    },
	    onMouseUp: function onMouseUp(e, coreEvent) {
	        if (_AudioEditorUtils2.default.isControlPointAction || _AudioEditorUtils2.default.isVolumeAction) {
	            _AudioEditorUtils2.default.isControlPointAction = false;
	            _AudioEditorUtils2.default.isVolumeAction = false;
	            return;
	        }
	
	        _AudioEditorUtils2.default.isControlPointAction = false;
	        _AudioEditorUtils2.default.isVolumeAction = false;
	
	        if (_TimelineDragManager2.default.isMultipleSelection(this.props.audio.uuid)) {
	            _SaveManager2.default.isContentChanged(true);
	            _PlayController2.default.getOldScrollPosition();
	            _TimelineDragManager2.default.endBlock(coreEvent.lastX, coreEvent.lastY, this.props.audio.uuid);
	        } else {
	            _TimelineDragManager2.default.resetMultipleSelection();
	
	            var properties = {};
	            var audio = Object.assign({}, this.props.audio);
	
	            audio.showControlPoint = true;
	            properties.audio = audio;
	            properties.startIndex = this.props.index;
	
	            _SaveManager2.default.isContentChanged(true);
	            _PlayController2.default.getOldScrollPosition();
	
	            setTimeout(function () {
	                if (!this.props.audio.showControlPoint) this.props.dispatch((0, _AudioEditorActions.selectElement)(this.props.audio.uuid, true));
	            }.bind(this), 5);
	
	            setTimeout(function () {
	                _TimelineDragManager2.default.removeClone(this.props.dispatch, properties);
	            }.bind(this), 10);
	        }
	    },
	    initStateForControlPointKeyHanlder: function initStateForControlPointKeyHanlder() {
	        var left = _AudioEditorUtils2.default.getItemPosition(this.props.audio.left);
	        var durationWidth = _AudioEditorUtils2.default.getSlideWidth(this.props.audio.duration);
	
	        this.setState({
	            startLeftPosition: left,
	            startWidth: durationWidth
	        });
	    },
	    updateSize: function updateSize(xOffset, arrow) {
	        var isEndAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        var newProperties = this.getCorrectPosition(xOffset, arrow);
	        var titleWidth = this.getTextWidth(newProperties.width);
	        _SaveManager2.default.isContentChanged(true);
	
	        if (isEndAction) {
	            var propertiesObject = {};
	            var audio = Object.assign({}, this.props.audio);
	
	            if (arrow == 0 || newProperties.updateLeft) audio.left = _AudioEditorUtils2.default.getItemTimePosition(newProperties.x);
	
	            if (arrow == 0) audio.inPoint = newProperties.inPoint;else audio.outPoint = newProperties.outPoint;
	
	            audio.duration = _AudioEditorUtils2.default.getItemTimePosition(newProperties.width);
	
	            propertiesObject.audio = audio;
	            propertiesObject.startIndex = this.props.index;
	            propertiesObject.endIndex = this.props.index;
	
	            if (!audio.showControlPoint) this.props.dispatch((0, _AudioEditorActions.selectElement)(audio.uuid, true));
	
	            this.props.dispatch((0, _AudioEditorActions.changeElementPosition)(propertiesObject));
	
	            _SaveManager2.default.isContentChanged(true);
	            _AudioEditorUtils2.default.addActionToHistory();
	
	            this.changeMarkerPosition(newProperties.x);
	
	            if (this.refs.waveform) {
	                if (newProperties.inPoint > 0) this.refs.waveform.style.left = -_AudioEditorUtils2.default.getSlideWidth(newProperties.inPoint) + 'px';else this.refs.waveform.style.left = '0px';
	            }
	
	            if (this.refs.textElement && this.refs.textElement.style) {
	                if (titleWidth > 0) this.refs.textElement.style.display = 'block';else this.refs.textElement.style.display = 'none';
	            }
	        } else {
	            if (arrow == 0 || newProperties.updateLeft) {
	                // LEFT arrow
	                this.refs.track.style.left = newProperties.x + 'px';
	
	                var inPointPos = this.props.audio.inPoint > 0 ? -_AudioEditorUtils2.default.getSlideWidth(this.props.audio.inPoint) : 0;
	                var leftPosition = _AudioEditorUtils2.default.getItemPosition(this.props.audio.left);
	
	                if (this.refs.waveform) this.refs.waveform.style.left = inPointPos + leftPosition - newProperties.x + 'px';
	            }
	
	            this.refs.track.style.width = newProperties.width + 'px';
	            this.refs.clone.style.width = newProperties.width + 'px';
	
	            if (titleWidth > 0) {
	                this.refs.textElement.style.width = titleWidth + 'px';
	
	                if (_AudioEditorUtils2.default.isControlPointAction) this.refs.textElement.style.display = 'none';else this.refs.textElement.style.display = 'block';
	            } else this.refs.textElement.style.display = 'none';
	
	            if (this.state.rightArrowUpdater && arrow == 0) // used only when the left arrow is moved
	                this.state.rightArrowUpdater(newProperties.width);
	        }
	
	        _AudioEditorUtils2.default.checkTimelineWidth();
	
	        return newProperties;
	    },
	    changeMarkerPosition: function changeMarkerPosition(position) {
	        this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(_AudioEditorUtils2.default.getItemTimePosition(position)));
	    },
	    getCorrectPosition: function getCorrectPosition(xOffset, arrow) {
	        var inPoint = this.props.audio.inPoint;
	        var outPoint = this.props.audio.outPoint;
	        var newInPoint = this.props.audio.inPoint;
	        var newOutPoint = this.props.audio.outPoint;
	
	        if (!inPoint) {
	            inPoint = 0;
	            newInPoint = 0;
	        } else inPoint = _AudioEditorUtils2.default.getSlideWidth(inPoint);
	
	        if (!outPoint) {
	            outPoint = 0;
	            newOutPoint = 0;
	        } else outPoint = _AudioEditorUtils2.default.getSlideWidth(outPoint);
	
	        var newX;
	        var newWidth;
	        var updateLeft = false;
	
	        if (arrow == 0) {
	            // LEFT ARROW
	            newX = this.state.startLeftPosition + xOffset;
	
	            if (xOffset < 0) {
	                // drag to left
	                if (Math.abs(xOffset) > inPoint) newX = newX + (Math.abs(xOffset) - inPoint);
	            } else {
	                // drag to right
	                if (this.state.startWidth - Math.abs(xOffset) < 2 * _Properties2.default.ARROW_SIZE) newX = this.state.startLeftPosition + this.state.startWidth - 2 * _Properties2.default.ARROW_SIZE;
	            }
	
	            newWidth = this.state.startWidth + (this.state.startLeftPosition - newX);
	            newInPoint = newInPoint - _AudioEditorUtils2.default.getItemTimePosition(newWidth - this.state.startWidth);
	
	            if (newInPoint < 0.001) newInPoint = 0;
	
	            if (newX < 0.001) newX = 0;
	        } else {
	            // RIGHT ARROW
	            newX = this.state.startLeftPosition;
	            newWidth = this.state.startWidth + xOffset;
	
	            if (xOffset < 0) {
	                // drag to left
	                if (this.state.startWidth - Math.abs(xOffset) < 2 * _Properties2.default.ARROW_SIZE) newWidth = 2 * _Properties2.default.ARROW_SIZE;
	            } else {
	                // drag to right
	                if (Math.abs(xOffset) > outPoint) newWidth = this.state.startWidth + outPoint;
	            }
	
	            if (newX < 0.001) {
	                newX = 0;
	
	                if (newWidth > this.props.trackWidth) newWidth = this.props.trackWidth;
	            }
	
	            newOutPoint = newOutPoint - _AudioEditorUtils2.default.getItemTimePosition(newWidth - this.state.startWidth);
	
	            if (newOutPoint < 0.001) newOutPoint = 0;
	        }
	
	        return { x: newX, width: newWidth, inPoint: newInPoint, outPoint: newOutPoint, updateLeft: updateLeft };
	    },
	    setRightArrowUpdater: function setRightArrowUpdater(updater) {
	        this.setState({
	            rightArrowUpdater: updater
	        });
	    },
	    getTextWidth: function getTextWidth(itemWidth, textSize) {
	        var textWidth = _Properties2.default.TITLE_WIDTH;
	
	        if (textSize > textWidth) textWidth = textSize;
	
	        var availableWidth = itemWidth - 2 * _Properties2.default.ARROW_SIZE - 2 * _Properties2.default.SOUND_GAP - 2 * 5;
	
	        if (textWidth > availableWidth) textWidth = availableWidth;
	
	        if (textWidth <= 20) textWidth = -1;
	
	        return textWidth;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        var canvasWidth = this.getCanvasWidth();
	
	        if (this.state.canvasWidth != canvasWidth) this.drawWaveform();
	    },
	    useWaveForm: function useWaveForm() {
	        return _PlayController2.default.useWaveForm();
	    },
	    drawWaveform: function drawWaveform() {
	        var canvas = this.refs.waveform;
	        var newCanvasWidth = this.getCanvasWidth();
	        var needsRefresh = this.state.canvasWidth < 0 || this.state.canvasWidth != newCanvasWidth;
	
	        if (!this.useWaveForm() || !canvas || !needsRefresh) return;
	
	        if (this.state.canvasWidth > 60000 || newCanvasWidth > 60000) return;
	
	        var audioUrl = this.props.audio.hrefBlob && this.props.audio.hrefBlob.length > 0 ? this.props.audio.hrefBlob : this.props.audio.href;
	        var data = _AudioVolumeUtils2.default.buffers[audioUrl];
	
	        if (data) {
	            this.setState({
	                canvasWidth: newCanvasWidth
	            });
	
	            var x,
	                y,
	                i,
	                n = data.length;
	            var width = canvas.width,
	                height = canvas.height,
	                ctx = canvas.getContext('2d'),
	                amp = height / 50,
	                colors = ['#ffbfcd', '#e8e9fe', '#fdf0cd', '#bff5de', '#ffcafc', '#e8e5fe', '#fef0fd', '#f4f4e1'];
	
	            ctx.strokeStyle = colors[this.props.index];
	            ctx.lineWidth = 6;
	            ctx.beginPath();
	            ctx.moveTo(0, amp);
	
	            for (i = 0; i < n; i++) {
	                if (i % 100 == 0) {
	                    x = i * width / n;
	                    y = data[i] * amp + height / 2;
	                    ctx.lineTo(x, y);
	                }
	            }
	
	            ctx.stroke();
	            ctx.closePath();
	        } else {
	            _AudioVolumeUtils2.default.callBackDraws[audioUrl] = this.drawWaveform;
	        }
	    },
	    getCanvasWidth: function getCanvasWidth() {
	        var inPoint = this.props.audio.inPoint > 0 ? _AudioEditorUtils2.default.getSlideWidth(this.props.audio.inPoint) : 0;
	        var outPoint = this.props.audio.outPoint > 0 ? _AudioEditorUtils2.default.getSlideWidth(this.props.audio.outPoint) : 0;
	        var duration = _AudioEditorUtils2.default.getSlideWidth(this.props.audio.duration);
	
	        return inPoint + duration + outPoint;
	    },
	    changeElementPosition: function changeElementPosition(type) {
	        var offset = 0.5; // seconds
	        var properties = {};
	        var skip = false;
	
	        properties.audio = Object.assign({}, this.props.audio);
	
	        switch (type) {
	            case 'left':
	                {
	                    // Left
	                    properties.endIndex = this.props.index;
	                    properties.audio.left = this.props.audio.left - offset;
	
	                    if (properties.audio.left < 0) {
	                        properties.audio.left = 0;
	                        skip = true;
	                    }
	                    break;
	                }
	            case 'right':
	                {
	                    // Right
	                    properties.endIndex = this.props.index;
	                    properties.audio.left = this.props.audio.left + offset;
	                    break;
	                }
	            case 'top':
	                {
	                    // Top
	                    properties.endIndex = this.props.index - 1;
	
	                    if (properties.endIndex < 0) {
	                        properties.endIndex = 0;
	                        skip = true;
	                    }
	                    break;
	                }
	            case 'down':
	                {
	                    // Down
	                    properties.endIndex = this.props.index + 1;
	
	                    if (properties.endIndex >= this.props.timelinesLength) {
	                        properties.endIndex = this.props.timelinesLength - 1;
	                        skip = true;
	                    }
	                    break;
	                }
	        }
	
	        if (skip) return;
	
	        _AudioEditorUtils2.default.isControlPointAction = false;
	        _AudioEditorUtils2.default.isVolumeAction = false;
	        _PlayController2.default.getOldScrollPosition();
	
	        properties.startIndex = this.props.index;
	        properties.isKeyboardAction = true;
	
	        this.props.dispatch((0, _AudioEditorActions.changeElementPosition)(properties));
	
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	        _AudioEditorUtils2.default.checkTimelineWidth();
	
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var audioItem = document.getElementById('audioItemElement_' + this.props.audio.uuid);
	
	            if (audioItem) audioItem.focus();
	        }.bind(this), 50);
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (document.activeElement != this.refs.track) return;
	
	        switch (e.keyCode) {
	            case 37:
	                {
	                    // Left
	                    this.changeElementPosition('left');
	                    break;
	                }
	            case 39:
	                {
	                    // Right
	                    this.changeElementPosition('right');
	                    break;
	                }
	            case 38:
	                {
	                    // Top
	                    this.changeElementPosition('top');
	                    break;
	                }
	            case 40:
	                {
	                    // Down
	                    this.changeElementPosition('down');
	                    break;
	                }
	            case 13:
	                {
	                    // Enter
	                    this.props.dispatch((0, _AudioEditorActions.selectElement)(this.props.audio.uuid, true));
	                    this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(this.props.audio.left));
	                    _PlayController2.default.isPreview = true;
	                    break;
	                }
	            case 46:
	                {
	                    // Delete
	                    this.props.dispatch((0, _AudioEditorActions.deleteItem)(this.props.audio.uuid));
	                    _PlayController2.default.isPreview = true;
	                    break;
	                }
	            case 27:
	                {
	                    // Escape
	                    this.props.dispatch((0, _AudioEditorActions.selectElement)());
	                    _PlayController2.default.isPreview = true;
	                    break;
	                }
	        }
	    },
	    getTrackTitle: function getTrackTitle() {
	        if (this.props.trackTitle && this.props.trackTitle.length > 0) return this.props.trackTitle;else {
	            var title = _LocalesManager2.default.getCaption('track_1', 'other');
	
	            if (title == undefined || title == '' || title.indexOf('other.') != -1) title = 'Track ' + (this.props.index + 1);else {
	                title = title.replace('1', '');
	                title = title + (this.props.index + 1);
	            }
	
	            return title;
	        }
	    },
	    render: function render() {
	        var height = _AudioToolUtils2.default.timelineHeight();
	        var leftPos = _AudioEditorUtils2.default.getItemPosition(this.props.audio.left);
	        var itemWidth = _AudioEditorUtils2.default.getSlideWidth(this.props.audio.duration);
	
	        var menuStyle = {
	            position: 'absolute',
	            left: leftPos,
	            width: itemWidth,
	            height: height,
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            borderStyle: 'none',
	            background: 'none',
	            display: 'flex'
	        };
	
	        var backgroundColor = _AudioEditorUtils2.default.getGradient(this.props.index);
	        var cloneStyle = {
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            width: itemWidth,
	            height: height,
	            background: backgroundColor,
	            cursor: '-webkit-grab',
	            overflow: 'hidden',
	            display: 'block'
	        };
	
	        var title = _TextSizeUtils2.default.correctRecordingTitle(this.props.audio.title);
	        var textWidth = _TextSizeUtils2.default.getSpanWidth(11, title);
	        var titleWidth = this.getTextWidth(itemWidth, textWidth);
	        var fontStyle = {
	            position: 'absolute',
	            fontSize: 11,
	            height: 17,
	            paddingTop: 3,
	            paddingLeft: 5,
	            paddingRight: 5,
	            width: titleWidth,
	            top: height / 2 - 20 / 2,
	            left: _Properties2.default.ARROW_SIZE + 5,
	            whiteSpace: 'nowrap',
	            overflow: 'hidden',
	            cursor: '-webkit-grab',
	            color: 'black',
	            background: 'white'
	        };
	
	        if (titleWidth < 0 || !this.props.audio.showControlPoint || _AudioEditorUtils2.default.isControlPointAction) fontStyle.display = 'none';
	
	        if (!_PlatformDetection2.default.isIOS()) {
	            if (_AudioEditorUtils2.default.animationId && this.props.audio.uuid == _AudioEditorUtils2.default.animationId && this.refs.track) _Animator2.default.startOpacityAnimation(this.refs.track);
	        }
	
	        var lineSize = 2;
	        var leftLineStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: lineSize,
	            height: height,
	            background: backgroundColor
	        };
	
	        if (this.props.audio.left != 0 && !this.props.audio.showControlPoint) leftLineStyle.background = _Properties2.default.SLIDE_VIEWER_BACKGROUND;
	
	        var globalPoint;
	
	        if (this.refs.track) {
	            var clientBoundingRect = this.refs.track.getBoundingClientRect();
	            globalPoint = { x: clientBoundingRect.left, y: clientBoundingRect.top };
	        }
	
	        var inPointWidth = this.props.audio.inPoint > 0 ? _AudioEditorUtils2.default.getSlideWidth(this.props.audio.inPoint) : 0;
	        var canvasStyle = {
	            position: 'absolute',
	            left: -inPointWidth
	        };
	
	        var canvasWidth = this.getCanvasWidth();
	
	        if (canvasWidth > 60000) canvasStyle.display = 'none';
	
	        var audioId = 'audioItemElement_' + this.props.audio.uuid;
	        var ariaLabelValue = this.getTrackTitle() + ' - ' + this.props.audio.title + ' ' + _LocalesManager2.default.getCaption('clipName', 'other') + ' ' + this.props.audioIndex;
	
	        return _react2.default.createElement(
	            _reactDraggable2.default,
	            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	            _react2.default.createElement(
	                'button',
	                { ref: 'track', id: audioId, 'aria-label': ariaLabelValue, 'aria-selected': this.props.audio.showControlPoint, className: 'audioItemRenderer', style: menuStyle, onKeyDown: this.onKeyDown },
	                _react2.default.createElement(
	                    'span',
	                    { ref: 'clone', style: cloneStyle, id: 'clone_' + this.props.audio.uuid },
	                    _react2.default.createElement('canvas', { ref: 'waveform', style: canvasStyle, width: canvasWidth, height: cloneStyle.height, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut }),
	                    _react2.default.createElement(
	                        'span',
	                        { ref: 'textElement', style: fontStyle },
	                        title
	                    )
	                ),
	                _react2.default.createElement('span', { style: leftLineStyle }),
	                _react2.default.createElement(ControlPoint, { index: 0, trackWidth: menuStyle.width, updateSize: this.updateSize, initStateForControlPointKeyHanlder: this.initStateForControlPointKeyHanlder, showControlPoint: this.props.audio.showControlPoint }),
	                _react2.default.createElement(ControlPoint, { index: 1, trackWidth: menuStyle.width, updateSize: this.updateSize, initStateForControlPointKeyHanlder: this.initStateForControlPointKeyHanlder, showControlPoint: this.props.audio.showControlPoint, setRightArrowUpdater: this.setRightArrowUpdater }),
	                _react2.default.createElement(_AudioGraph.AudioGraph, { audio: this.props.audio, globalPoint: globalPoint, parentId: audioId, isSelected: this.props.audio.showControlPoint })
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioItemRenderer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioItemRenderer.js"); } } })();

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioTrack = exports.AudioTrackContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AudioItemRenderer = __webpack_require__(763);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _reactRedux = __webpack_require__(10);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioTrackContent = exports.AudioTrackContent = _react2.default.createClass({
	    displayName: 'AudioTrackContent',
	    render: function render() {
	        var height = _AudioToolUtils2.default.timelineHeight();
	        var backgroundColor = _Properties2.default.SLIDE_VIEWER_BACKGROUND;
	
	        if (this.props.isSelected) backgroundColor = '#999A9C';
	
	        var menuStyle = {
	            position: 'absolute',
	            left: 0,
	            width: this.props.trackWidth,
	            height: height,
	            background: backgroundColor
	        };
	
	        var elements = [];
	        var i;
	
	        for (i = 0; i < this.props.audios.length; i++) {
	            elements.push(_react2.default.createElement(_AudioItemRenderer.AudioItemRenderer, { windowHeight: this.props.windowHeight, trackWidth: this.props.trackWidth, audio: this.props.audios[i], key: 'audioItem_' + this.props.index + '_' + this.props.audios[i].uuid, zoomValue: this.props.zoomValue, dispatch: this.props.dispatch, index: this.props.index, audioIndex: i, timelinesLength: this.props.timelinesLength }));
	        }
	
	        var lineSize = _Properties2.default.LINE_SIZE;
	        var delimitators = _AudioToolUtils2.default.isAudioTool() ? [] : _AudioEditorUtils2.default.getDelimitators();
	        var delmimitatorLines = [];
	        var i;
	        var offset = 10;
	
	        for (i = 0; i < delimitators.length; i++) {
	            var delimitatorStyle = {
	                position: 'absolute',
	                width: lineSize,
	                left: delimitators[i],
	                top: offset + 1,
	                height: height - 2 * offset,
	                background: '#C1C1C1'
	            };
	
	            delmimitatorLines.push(_react2.default.createElement('div', { style: delimitatorStyle, key: 'delimitator_' + this.props.index + '_' + i }));
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            delmimitatorLines,
	            elements
	        );
	    }
	});
	
	function mapStateToProps(state) {
	    var refreshAudioTrack = state.audioEditor.refreshAudioTrack;
	
	    return {
	        refreshAudioTrack: refreshAudioTrack
	    };
	}
	
	var AudioTrack = exports.AudioTrack = (0, _reactRedux.connect)(mapStateToProps)(AudioTrackContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioTrack.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioTrack.js"); } } })();

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioTrackMenu = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _MenuActions = __webpack_require__(7);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    getTimeline: function getTimeline(index) {
	        var state = _StoreManager2.default.getState();
	        var timelines = state.audioEditor.timelines;
	
	        return timelines[index];
	    },
	    isEmptyTrack: function isEmptyTrack(trackIndex) {
	        var state = _StoreManager2.default.getState();
	        var timelines = state.audioEditor.timelines;
	        var audios = timelines[trackIndex].audios;
	
	        if (audios && audios.length > 0) return false;else return true;
	    },
	    onTouchStart: function onTouchStart() {
	        if (this.props.index == 0) {
	            var buttonsHolderWidth = _StoreManager2.default.getState().menu.buttonsHolderWidth;
	            var isCollapsedDefault = _PlatformDetection2.default.isIOS() && !buttonsHolderWidth;
	
	            if (isCollapsedDefault || buttonsHolderWidth == _Properties2.default.BUTTONS_HOLDER_COLLAPSED_WIDTH) {
	                this.props.dispatch((0, _MenuActions.setButtonsHolderWidth)(_Properties2.default.BUTTONS_HOLDER_WIDTH));
	                _AudioEditorUtils2.default.checkTimelineWidth(false, -1, true);
	            }
	        }
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _AudioEditorUtils2.default.currentTrackMenu = this.props.trackIndex;
	        _SaveManager2.default.isContentChanged(true);
	
	        if (this.isDisabled()) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    this.setTitleFocus();
	                    break;
	                }
	            case 1:
	                {
	                    this.props.dispatch((0, _AudioEditorActions.changeSolo)(this.props.trackIndex));
	                    this.props.dispatch((0, _AudioEditorActions.refreshAudioTrack)(Math.random()));
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	            case 2:
	                {
	                    this.props.dispatch((0, _AudioEditorActions.changeMute)(this.props.trackIndex));
	                    this.props.dispatch((0, _AudioEditorActions.refreshAudioTrack)(Math.random()));
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	            case 3:
	                {
	                    this.props.dispatch((0, _AudioEditorActions.addTrack)(this.props.trackIndex));
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	            case 4:
	                {
	
	                    if (this.isEmptyTrack(this.props.trackIndex)) {
	                        this.props.dispatch((0, _AudioEditorActions.deleteTrack)(this.props.trackIndex));
	                        _SaveManager2.default.isContentChanged(true);
	                    } else this.props.dispatch((0, _MenuActions.showDeleteTrackAlert)(true));
	                    break;
	                }
	        }
	
	        _AudioEditorUtils2.default.addActionToHistory();
	    },
	    setTitleFocus: function setTitleFocus() {
	        var trackTitle = document.getElementsByClassName('trackTitle_' + this.props.trackIndex)[0];
	
	        if (trackTitle) {
	            trackTitle.removeAttribute('disabled');
	            trackTitle.focus();
	            trackTitle.setSelectionRange(0, 600);
	        }
	    },
	    getProperties: function getProperties() {
	        var prop;
	        var timeline = this.getTimeline(this.props.trackIndex);
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    prop = { title: _LocalesManager2.default.getCaption('renameTrack', 'other'), icon: 'fa fa-pencil' };
	                    break;
	                }
	            case 1:
	                {
	                    if (timeline.isSolo) prop = { title: _LocalesManager2.default.getCaption('unsoloTrack', 'other'), icon: 'fa fa-certificate' };else prop = { title: _LocalesManager2.default.getCaption('soloTrack', 'other'), icon: 'fa fa-certificate' };
	                    break;
	                }
	            case 2:
	                {
	                    if (timeline.isMute) prop = { title: _LocalesManager2.default.getCaption('unmuteTrack', 'other'), icon: 'fa fa-medium' };else prop = { title: _LocalesManager2.default.getCaption('muteTrack', 'other'), icon: 'fa fa-medium' };
	                    break;
	                }
	            case 3:
	                {
	                    prop = { title: _LocalesManager2.default.getCaption('addTrack', 'other'), icon: 'fa fa-plus' };
	                    break;
	                }
	            case 4:
	                {
	                    prop = { title: _LocalesManager2.default.getCaption('deleteTrack', 'other'), icon: 'fa fa-trash-o' };
	                    break;
	                }
	        }
	
	        return prop;
	    },
	    isDisabled: function isDisabled() {
	        if (this.props.index == 3) {
	            var timelines = _AudioEditorUtils2.default.getTimelinesLength();
	            var maxTimelines = _AudioEditorUtils2.default.getMaxTimelines();
	
	            if (timelines >= maxTimelines) return true;else return false;
	        } else return false;
	    },
	    render: function render() {
	        var buttonColor;
	        var textColor;
	        var opacity = 1;
	
	        if (this.isDisabled()) {
	            buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	            textColor = '#000000';
	            opacity = 0.5;
	        } else if (this.state.isOver == true) {
	            buttonColor = _Properties2.default.BROWSER_HOVER_COLOR;
	            textColor = '#2299D6';
	        } else {
	            buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	            textColor = '#000000';
	        }
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: _Properties2.default.BUTTONS_HOLDER_WIDTH,
	            height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT,
	            top: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT * this.props.index,
	            color: 'white',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none',
	            opacity: opacity,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 12,
	            left: 35,
	            color: textColor,
	            fontSize: 14,
	            width: tabStyle.width - 40,
	            height: 18,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            textAlign: 'left'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 11,
	            left: 10,
	            color: textColor
	        };
	
	        var prop = this.getProperties();
	        var iconElement;
	
	        if (this.props.index == 1 || this.props.index == 2) {
	            var letterStyle = {
	                position: 'absolute',
	                top: 12,
	                left: 10,
	                color: textColor,
	                fontSize: 16,
	                fontWeight: 'bold',
	                width: 12,
	                height: 18,
	                cursor: 'default'
	            };
	
	            if (this.props.index == 2) iconElement = _react2.default.createElement(
	                'span',
	                { style: letterStyle },
	                'M'
	            );else iconElement = _react2.default.createElement(
	                'span',
	                { style: letterStyle },
	                'S'
	            );
	        } else iconElement = _react2.default.createElement('i', { style: iconStyle, className: prop.icon });
	
	        var spanId = 'trackMenuButton_' + this.props.index;
	        var buttonId = this.props.index == 0 ? 'audioTrackMenuButton' : undefined;
	
	        return _react2.default.createElement(
	            'button',
	            { id: buttonId, style: tabStyle, 'aria-labelledby': spanId, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onClick, onTouchEnd: this.onClick, onTouchStart: this.onTouchStart, onMouseDown: this.onTouchStart },
	            iconElement,
	            _react2.default.createElement(
	                'span',
	                { id: spanId, style: spanStyle },
	                prop.title
	            )
	        );
	    }
	});
	
	var AudioTrackMenuContent = _react2.default.createClass({
	    displayName: 'AudioTrackMenuContent',
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('click', this.onCloseMenu);
	        document.addEventListener('touchend', this.onCloseMenu);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('click', this.onCloseMenu);
	        document.removeEventListener('touchend', this.onCloseMenu);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        if (this.props.index != nextProps.index && nextProps.index >= 0) {
	            setTimeout(function () {
	                var firstButton = document.getElementById('audioTrackMenuButton');
	
	                if (firstButton) firstButton.focus();
	            }.bind(this), 10);
	        }
	    },
	    onCloseMenu: function onCloseMenu(e) {
	        if (_TextSizeUtils2.default.isTextEditMode()) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (!_PlatformDetection2.default.isIOS()) {
	            if (!document.getElementById('htmlColorPicker')) e.preventDefault();
	        }
	
	        var target = e.target;
	        var type = _typeof(target.className);
	
	        if (type == 'string') {
	
	            if (target.className.indexOf('trackSettings') != -1) {// it's settings button
	            } else this.hideTrackMenu();
	        } else this.hideTrackMenu();
	    },
	    hideTrackMenu: function hideTrackMenu() {
	        var state = _StoreManager2.default.getState();
	
	        if (state.audioEditor.trackMenu != -1) this.props.dispatch((0, _AudioEditorActions.showTrackMenu)(-1));
	    },
	    render: function render() {
	        if (this.props.index == -1) return _react2.default.createElement('div', null);
	
	        var width = _Properties2.default.BUTTONS_HOLDER_WIDTH;
	        var height = 5 * _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT;
	        var top = this.props.index * _AudioToolUtils2.default.timelineHeight() - height;
	
	        if (_AudioToolUtils2.default.isAudioTool() && (this.props.index == 0 || this.props.index == 1 || this.props.index == 2)) top = (this.props.index + 1) * _AudioToolUtils2.default.timelineHeight();
	
	        var menuStyle = {
	            position: 'absolute',
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            top: top,
	            left: 0,
	            width: width,
	            height: height,
	            background: 'white'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(Button, { index: 0, trackIndex: this.props.index, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Button, { index: 1, trackIndex: this.props.index, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Button, { index: 2, trackIndex: this.props.index, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Button, { index: 3, trackIndex: this.props.index, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Button, { index: 4, trackIndex: this.props.index, dispatch: this.props.dispatch })
	        );
	    }
	});
	
	function mapStateToProps(state) {
	    var index = state.audioEditor.trackMenu;
	
	    if (index == undefined) index = -1;
	
	    return {
	        index: index
	    };
	}
	
	var AudioTrackMenu = exports.AudioTrackMenu = (0, _reactRedux.connect)(mapStateToProps)(AudioTrackMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioTrackMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/AudioTrackMenu.js"); } } })();

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Marker = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _reactRedux = __webpack_require__(10);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var MarkerContent = _react2.default.createClass({
	    displayName: 'MarkerContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            isSplitOver: false,
	            isThumbActive: false,
	            isControlPointOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onControlPointMouseIn: function onControlPointMouseIn() {
	        _HoverManager2.default.show(this.refs.addControlPoint, 'addControlPoint');
	
	        this.setState({
	            isControlPointOver: true
	        });
	    },
	    onControlPointMouseOut: function onControlPointMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isControlPointOver: false
	        });
	    },
	    onSplitMouseIn: function onSplitMouseIn() {
	        _HoverManager2.default.show(this.refs.split, 'splitAudio');
	
	        this.setState({
	            isSplitOver: true,
	            isOver: false
	        });
	    },
	    onSplitMouseOut: function onSplitMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isSplitOver: false,
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_PlayController2.default.isPlaying) return;
	
	        var touchPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            startPosition: this.props.markerPosition,
	            startClientX: touchPosition.x,
	            isThumbActive: true
	        });
	    },
	    onMouseMove: function onMouseMove(e) {
	        if (_PlayController2.default.isPlaying) return;
	
	        this.updatePosition(e);
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_PlayController2.default.isPlaying) return;
	
	        this.setState({
	            isThumbActive: false
	        });
	
	        this.updatePosition(e);
	    },
	    updatePosition: function updatePosition(e) {
	        var touchPosition = _MouseUtils2.default.getTouchPosition(e);
	        var offsetX = touchPosition.x - this.state.startClientX;
	        var newPosition = this.state.startPosition + _AudioEditorUtils2.default.getItemTimePosition(offsetX);
	
	        if (newPosition < 0) newPosition = 0;
	
	        var state = _StoreManager2.default.getState();
	        var timelineWidth = state.audioEditor.timelineWidth;
	        timelineWidth = _AudioEditorUtils2.default.getItemTimePosition(timelineWidth);
	
	        if (newPosition > timelineWidth) newPosition = timelineWidth;
	
	        this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(newPosition));
	    },
	    isSplitVisible: function isSplitVisible() {
	        if (_PlayController2.default.isPlaying || _AudioEditorUtils2.default.isControlPointAction) return false;
	
	        var markerPosition = this.props.markerPosition;
	        var selectedAudio = _AudioEditorUtils2.default.getSelectedAudio();
	
	        if (selectedAudio && markerPosition >= 0) {
	            var leftPos = selectedAudio.model.left;
	            var rightPos = leftPos + selectedAudio.model.duration;
	            var minimumSize = 2 * _Properties2.default.ARROW_SIZE + _Properties2.default.SPLIT_BUTTON_SIZE;
	            var itemWidth = _AudioEditorUtils2.default.getSlideWidth(selectedAudio.model.duration);
	
	            if (markerPosition > leftPos && markerPosition < rightPos && markerPosition - leftPos >= _Properties2.default.AUDIO_MINIMUM_LENGTH && rightPos - markerPosition >= _Properties2.default.AUDIO_MINIMUM_LENGTH && itemWidth > minimumSize) return true;else return false;
	        } else return false;
	    },
	    getSplitTopPosition: function getSplitTopPosition() {
	        var selectedAudio = _AudioEditorUtils2.default.getSelectedAudio();
	        var topPosition;
	        var timelineHeight = _AudioToolUtils2.default.timelineHeight();
	
	        if (selectedAudio) {
	            topPosition = selectedAudio.index * timelineHeight + (timelineHeight / 2 - _Properties2.default.DELETE_BUTTON_SIZE / 2) + _Properties2.default.RULER_HEIGHT + 1;
	        } else {
	            topPosition = timelineHeight / 2 - _Properties2.default.DELETE_BUTTON_SIZE / 2 + _Properties2.default.RULER_HEIGHT + 1;
	        }
	
	        return topPosition;
	    },
	    getAddControlPointPosition: function getAddControlPointPosition() {
	        var selectedAudio = _AudioEditorUtils2.default.getSelectedAudio();
	        var topPosition;
	        var timelineHeight = _AudioToolUtils2.default.timelineHeight();
	
	        if (selectedAudio) {
	            topPosition = selectedAudio.index * timelineHeight + _Properties2.default.RULER_HEIGHT + 1;
	        } else {
	            topPosition = timelineHeight / 2 - _Properties2.default.DELETE_BUTTON_SIZE / 2 + _Properties2.default.RULER_HEIGHT + 1;
	        }
	
	        return topPosition;
	    },
	    onAddControlPoint: function onAddControlPoint(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_AudioEditorUtils2.default.addControlPointHandler) _AudioEditorUtils2.default.addControlPointHandler();
	    },
	    onSplit: function onSplit(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var markerPosition = this.props.markerPosition;
	        var selectedAudio = _AudioEditorUtils2.default.getSelectedAudio();
	
	        setTimeout(function () {
	            this.props.dispatch((0, _AudioEditorActions.splitAudio)(selectedAudio.model, markerPosition));
	            _AudioEditorUtils2.default.addActionToHistory();
	            _SaveManager2.default.isContentChanged(true);
	
	            if (!_PlatformDetection2.default.isIOS()) {
	                setTimeout(function () {
	                    var markerElement = document.getElementById('markerHead');
	
	                    if (markerElement) markerElement.focus();
	                }.bind(this), 10);
	            }
	        }.bind(this), 10);
	
	        _SaveManager2.default.isContentChanged(true);
	    },
	    updateMarker: function updateMarker() {
	        this.forceUpdate();
	    },
	    onMarkerFocus: function onMarkerFocus() {
	        if (_MouseUtils2.default.isFirstMarkerFocus) {
	            _MouseUtils2.default.isFirstMarkerFocus = false;
	            this.props.dispatch((0, _CurrentSlideActions.setShortcutsTarget)(true));
	        }
	    },
	    onKeyDownOnMarker: function onKeyDownOnMarker(e) {
	        var step = 2;
	        var offsetX = 0;
	
	        switch (true) {
	            case e.keyCode == 37:
	                {
	                    // LEFT
	                    offsetX = -step;
	                    break;
	                }
	            case e.keyCode == 39:
	                {
	                    // RIGHT
	                    offsetX = step;
	                    break;
	                }
	        }
	
	        var newPosition = this.props.markerPosition + _AudioEditorUtils2.default.getItemTimePosition(offsetX);
	
	        if (newPosition < 0) newPosition = 0;
	
	        var state = _StoreManager2.default.getState();
	        var timelineWidth = state.audioEditor.timelineWidth;
	        timelineWidth = _AudioEditorUtils2.default.getItemTimePosition(timelineWidth);
	
	        if (newPosition > timelineWidth) newPosition = timelineWidth;
	
	        this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(newPosition));
	
	        setTimeout(function () {
	            var newPos = _AudioEditorUtils2.default.getMarkerPosition();
	            _PlayController2.default.checkScrollPosition(newPos, true);
	        }.bind(this), 100);
	    },
	    render: function render() {
	        if (this.props.markerPosition == -1) return _react2.default.createElement('div', null);
	
	        _AudioEditorUtils2.default.markerUpdater = this.updateMarker;
	
	        var timelinesLength = _AudioEditorUtils2.default.getTimelinesLength();
	        var maxTimelines = _AudioEditorUtils2.default.getMaxTimelinesRelatedToHeight();
	
	        if (maxTimelines < timelinesLength) timelinesLength = maxTimelines;
	
	        var rulerHeight = _Properties2.default.RULER_HEIGHT;
	        var timelineHeight = timelinesLength * _AudioToolUtils2.default.timelineHeight();
	        var width = 2;
	        var leftPos = _AudioEditorUtils2.default.getItemPosition(this.props.markerPosition);
	        var lineOffset = 5;
	        var lineHeight = timelineHeight + lineOffset;
	        var color = '#272727';
	
	        if (this.state.isOver || this.state.isThumbActive) color = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	
	        var menuStyle = {
	            position: 'absolute',
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            top: -rulerHeight,
	            left: leftPos
	        };
	
	        var lineStyle = {
	            position: 'absolute',
	            top: rulerHeight - lineOffset,
	            left: -width / 2,
	            width: width,
	            height: lineHeight
	        };
	
	        var headButtonStyle = {
	            position: 'absolute',
	            top: -3,
	            left: -9.15,
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            borderStyle: 'none',
	            background: 'none',
	            width: 18.3,
	            height: 32
	        };
	
	        var headStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            display: 'block'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            color: color
	        };
	
	        var circleStyle = {
	            position: 'absolute',
	            top: 5,
	            left: 0,
	            width: 14,
	            height: 14,
	            borderRadius: 50,
	            background: color,
	            display: 'block'
	        };
	
	        var lineSize = 10;
	        var lineBreak = 5;
	        var length = Math.ceil(lineHeight / (lineSize + lineBreak));
	        var i;
	        var elements = [];
	
	        for (i = 0; i < length; i++) {
	            var elementStyle = {
	                position: 'absolute',
	                width: width,
	                height: lineSize,
	                top: i * (lineSize + lineBreak),
	                left: 0,
	                background: color
	            };
	
	            elements.push(_react2.default.createElement('div', { style: elementStyle, key: 'marker_' + i }));
	        }
	
	        // Split button
	        var displayValue = 'none';
	
	        if (this.isSplitVisible()) displayValue = 'block';
	
	        var splitHeight = _Properties2.default.SPLIT_BUTTON_SIZE;
	        var spliHolderButtonStyle = {
	            position: 'absolute',
	            top: this.getSplitTopPosition(),
	            left: -splitHeight / 2,
	            display: displayValue,
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            borderStyle: 'none',
	            background: 'none',
	            width: 32,
	            height: 32
	        };
	
	        var spliHolderStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            display: 'block'
	        };
	
	        var splitSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/scissor_normal.svg';
	
	        if (this.state.isSplitOver) splitSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/scissor_hover.svg';
	
	        var spliIconStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: splitHeight,
	            height: splitHeight
	        };
	
	        // Add control point
	        if (this.state.isControlPointOver) color = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	
	        var btnSize = _AudioToolUtils2.default.getGraphControlPointSize();
	        var borderWidth = 2;
	        var addControlPointStyle = _defineProperty({
	            position: 'absolute',
	            top: this.getAddControlPointPosition(),
	            left: -btnSize / 2 - borderWidth,
	            display: displayValue,
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            background: 'white',
	            borderStyle: 'solid',
	            borderWidth: borderWidth,
	            borderColor: '#48b221',
	            borderRadius: 100,
	            width: btnSize,
	            height: btnSize
	        }, 'fontSize', 12);
	
	        var addControlPointIconStyle = {
	            position: 'absolute',
	            top: borderWidth,
	            left: borderWidth,
	            color: color
	        };
	
	        return _react2.default.createElement(
	            _reactDraggable2.default,
	            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	            _react2.default.createElement(
	                'div',
	                { style: menuStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: lineStyle },
	                    elements
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { id: 'markerHead', 'aria-label': _LocalesManager2.default.getCaption('markerLabel', 'other'), style: headButtonStyle, ref: 'audioMarker', onFocus: this.onMarkerFocus, onKeyDown: this.onKeyDownOnMarker, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	                    _react2.default.createElement(
	                        'span',
	                        { style: headStyle },
	                        _react2.default.createElement('span', { style: circleStyle }),
	                        _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-map-marker fa-2x' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { id: 'addVolumeControlPoint', 'aria-label': _LocalesManager2.default.getCaption('addControlPointLabel', 'other'), style: addControlPointStyle, ref: 'addControlPoint', onTouchStart: this.onAddControlPoint, onClick: this.onAddControlPoint, onMouseOver: this.onControlPointMouseIn, onMouseOut: this.onControlPointMouseOut },
	                    _react2.default.createElement('i', { style: addControlPointIconStyle, className: 'fa fa-plus' })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { 'aria-label': _LocalesManager2.default.getCaption('splitLabel', 'other'), style: spliHolderButtonStyle, onMouseOver: this.onSplitMouseIn, onMouseOut: this.onSplitMouseOut, onTouchStart: this.onSplit, onClick: this.onSplit },
	                    _react2.default.createElement(
	                        'span',
	                        { style: spliHolderStyle },
	                        _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', ref: 'split', style: spliIconStyle, src: splitSrc })
	                    )
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps(state) {
	    var markerPosition = state.audioEditor.markerPosition;
	    var timelines = state.audioEditor.timelines;
	
	    if (markerPosition == undefined) markerPosition = -1;
	
	    return {
	        markerPosition: markerPosition,
	        timelines: timelines
	    };
	}
	
	var Marker = exports.Marker = (0, _reactRedux.connect)(mapStateToProps)(MarkerContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/Marker.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioEditor/menus/Marker.js"); } } })();

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioTimelineComponent = exports.AudioTimelineComponentWrapper = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Timelines = __webpack_require__(771);
	
	var _AudioEditorControls = __webpack_require__(325);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioTimelineComponentWrapper = exports.AudioTimelineComponentWrapper = _react2.default.createClass({
	    displayName: 'AudioTimelineComponentWrapper',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	    },
	    render: function render() {
	        var width = this.props.windowWidth - this.props.accordionWidth;
	        var listHeight = this.props.windowHeight - _AudioToolUtils2.default.headerHeight() - _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP;
	        var timelinesListHeight = listHeight;
	        var minimumTimelineHeight = _AudioEditorUtils2.default.getAudioEditorHeight() + _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP + 20;
	
	        if (listHeight < minimumTimelineHeight) timelinesListHeight = minimumTimelineHeight;
	
	        var height = listHeight + _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP;
	        var topBarHeight = 0;
	
	        if (_PlatformDetection2.default.isIOSApp()) topBarHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT_OLD;
	
	        topBarHeight = topBarHeight + _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight();
	
	        var slideViewerStyle = {
	            position: 'absolute',
	            top: _AudioToolUtils2.default.headerHeight() + topBarHeight,
	            left: 0,
	            width: width,
	            height: height,
	            background: _Properties2.default.SLIDE_VIEWER_BACKGROUND,
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none',
	            overflowX: 'hidden',
	            overflowY: 'auto'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { ref: 'slideViewerWrapper', style: slideViewerStyle, onMouseDown: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement(_Timelines.Timelines, { buttonsHolderWidth: this.props.buttonsHolderWidth, listHeight: timelinesListHeight, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight }),
	            _react2.default.createElement(_AudioEditorControls.AudioEditorControls, { buttonsHolderWidth: this.props.buttonsHolderWidth, dispatch: this.props.dispatch, windowHeight: this.props.windowHeight })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var timelines = state.audioEditor.timelines;
	    var undo = state.undoRedo.undo;
	    var redo = state.undoRedo.redo;
	    var accordionWidth = state.accordion.width;
	    var contextMode = state.menu.contextMode;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    return {
	        undo: undo,
	        redo: redo,
	        accordionWidth: accordionWidth,
	        contextMode: contextMode,
	        timelines: timelines
	    };
	}
	
	var AudioTimelineComponent = exports.AudioTimelineComponent = (0, _reactRedux.connect)(mapStateToProps)(AudioTimelineComponentWrapper);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioTool/menus/AudioTimelineComponent.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioTool/menus/AudioTimelineComponent.js"); } } })();

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioToolHeader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AudioRecorder = __webpack_require__(239);
	
	var _AudioRecorder2 = _interopRequireDefault(_AudioRecorder);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _ReactNativeBridge = __webpack_require__(173);
	
	var _ReactNativeBridge2 = _interopRequireDefault(_ReactNativeBridge);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _KeyboardShortcuts = __webpack_require__(143);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioToolHeaderContent = _react2.default.createClass({
	    displayName: 'AudioToolHeaderContent',
	    getInitialState: function getInitialState() {
	        return {
	            isPlayButtonOver: false,
	            isStartButtonOver: false,
	            isEndButtonOver: false,
	            isRecordButtonOver: false,
	            isUndoOver: false,
	            isRedoOver: false,
	            isDeleteOver: false,
	            isPlaying: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        _PlayController2.default.updateRecordingMenuButtons = this.updateViewProperties;
	        _PlayController2.default.executePlayPause = this.executePlayPause;
	        _PlayController2.default.executeStop = this.executeStop;
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        _PlayController2.default.updateRecordingMenuButtons = undefined;
	        _PlayController2.default.executePlayPause = undefined;
	        _PlayController2.default.executeStop = undefined;
	    },
	    onPlayButtonMouseIn: function onPlayButtonMouseIn() {
	        _HoverManager2.default.show(this.refs.play, 'playCartoon');
	
	        this.setState({
	            isPlayButtonOver: true
	        });
	    },
	    onPlayButtonMouseOut: function onPlayButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isPlayButtonOver: false
	        });
	    },
	    onStartButtonMouseIn: function onStartButtonMouseIn() {
	        _HoverManager2.default.show(this.refs.start, 'startAudio');
	
	        this.setState({
	            isStartButtonOver: true
	        });
	    },
	    onStartButtonMouseOut: function onStartButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isStartButtonOver: false
	        });
	    },
	    onEndButtonMouseIn: function onEndButtonMouseIn() {
	        _HoverManager2.default.show(this.refs.end, 'endAudio');
	
	        this.setState({
	            isEndButtonOver: true
	        });
	    },
	    onEndButtonMouseOut: function onEndButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isEndButtonOver: false
	        });
	    },
	    onRecordButtonMouseIn: function onRecordButtonMouseIn() {
	        _HoverManager2.default.show(this.refs.recordingHolder, _LocalesManager2.default.getCaption('RecordSoundAlert', 'record'), 'top', true);
	
	        this.setState({
	            isRecordButtonOver: true
	        });
	    },
	    onRecordButtonMouseOut: function onRecordButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isRecordButtonOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	    },
	    onRecordDown: function onRecordDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlayController2.default.isPlaying || this.props.refreshAudioElements) return;
	
	        if (_PlatformDetection2.default.isIOSApp()) {
	            if (!_ReactNativeBridge2.default.isIOSRecorderEnabled) _ReactNativeBridge2.default.init(this.initRecording);else this.props.dispatch((0, _MenuActions.showRecorder)(true));
	        } else {
	            if (!_AudioRecorder2.default.isRecordAvailable) _AudioRecorder2.default.init(this.initRecording);else this.props.dispatch((0, _MenuActions.showRecorder)(true));
	        }
	    },
	    initRecording: function initRecording() {
	        if (_PlatformDetection2.default.isIOSApp()) _ReactNativeBridge2.default.isIOSRecorderEnabled = true;
	
	        this.props.dispatch((0, _MenuActions.showRecorder)(true));
	    },
	    executeStop: function executeStop() {
	        this.setState({
	            isPlaying: false
	        });
	
	        _PlayController2.default.stop();
	    },
	    onStart: function onStart(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.setState({
	            isPlaying: false
	        });
	
	        _PlayController2.default.stop();
	        var position = 0;
	        this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(position));
	        _PlayController2.default.checkScrollPosition(position, true);
	    },
	    onEnd: function onEnd(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.setState({
	            isPlaying: false
	        });
	
	        _PlayController2.default.stop();
	        var position = _AudioEditorUtils2.default.getTimelinesMaxPosition();
	        this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(position));
	        _PlayController2.default.checkScrollPosition(position);
	    },
	    onPlay: function onPlay(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.doNewPlay();
	    },
	    executePlayPause: function executePlayPause() {
	        this.doNewPlay();
	    },
	    doNewPlay: function doNewPlay() {
	        if (this.state.isPlaying) _PlayController2.default.pause();else _PlayController2.default.play();
	
	        this.togglePlayState();
	    },
	    togglePlayState: function togglePlayState() {
	        if (!this.state.isPlaying) {
	            this.setState({
	                isPlaying: true
	            });
	        } else {
	            this.setState({
	                isPlaying: false
	            });
	        }
	    },
	    updateViewProperties: function updateViewProperties() {
	        this.setState({
	            isPlaying: false
	        });
	
	        this.forceUpdate();
	    },
	    onUndoMouseIn: function onUndoMouseIn() {
	        _HoverManager2.default.show(this.refs.undo, 'undo');
	
	        this.setState({
	            isUndoOver: true
	        });
	    },
	    onUndoMouseOut: function onUndoMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isUndoOver: false
	        });
	    },
	    onRedoMouseIn: function onRedoMouseIn() {
	        _HoverManager2.default.show(this.refs.redo, 'redo');
	
	        this.setState({
	            isRedoOver: true
	        });
	    },
	    onRedoMouseOut: function onRedoMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isRedoOver: false
	        });
	    },
	    onUndo: function onUndo(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlayController2.default.isPlaying) return;
	
	        (0, _KeyboardShortcuts.undoAction)(this.props.dispatch);
	        _SaveManager2.default.isContentChanged(true);
	    },
	    onRedo: function onRedo(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlayController2.default.isPlaying) return;
	
	        (0, _KeyboardShortcuts.redoAction)(this.props.dispatch);
	        _SaveManager2.default.isContentChanged(true);
	    },
	    isUndoAvailable: function isUndoAvailable() {
	        var undo = this.props.undo;
	
	        if (undo && undo.length > 0) return true;else return false;
	    },
	    isRedoAvailable: function isRedoAvailable() {
	        var redo = this.props.redo;
	
	        if (redo && redo.length > 0) return true;else return false;
	    },
	    onDeleteMouseIn: function onDeleteMouseIn() {
	        _HoverManager2.default.show(this.refs.delete, 'deleteAudioItem');
	
	        this.setState({
	            isDeleteOver: true
	        });
	    },
	    onDeleteMouseOut: function onDeleteMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isDeleteOver: false
	        });
	    },
	    onDelete: function onDelete(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.props.dispatch((0, _AudioEditorActions.deleteItem)());
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.checkTimelineWidth();
	        _AudioEditorUtils2.default.addActionToHistory();
	    },
	    getCurrentTime: function getCurrentTime() {
	        return _AudioToolUtils2.default.getCurrentTime(this.props.markerPosition);
	    },
	    render: function render() {
	        var width = this.props.width;
	        var height = _AudioToolUtils2.default.headerHeight();
	        var topPosition = 45;
	        var buttonsHolderWidth = _Properties2.default.BUTTONS_HOLDER_WIDTH;
	        var topBarHeight = 0;
	
	        if (_PlatformDetection2.default.isIOSApp()) {
	            topBarHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT_OLD;
	            topPosition = 35;
	        }
	
	        topBarHeight = topBarHeight + _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight();
	
	        var menuStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.RECORDING_MENU_BACKGROUND,
	            width: width,
	            height: height,
	            top: topBarHeight,
	            left: 0,
	            cursor: 'default',
	            userSelect: 'none',
	            userDrag: 'none',
	            WebkitUserSelect: 'none'
	        };
	
	        var durationStyle = {
	            position: 'absolute',
	            backgroundColor: 'white',
	            width: buttonsHolderWidth - 2 * 30,
	            height: _Properties2.default.RECORDING_BUTTON_HEIGHT + 2 + 14,
	            top: topPosition - 7,
	            left: 20,
	            cursor: 'default',
	            userSelect: 'none',
	            userDrag: 'none',
	            WebkitUserSelect: 'none'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 6,
	            left: 0,
	            color: 'black',
	            fontSize: 26,
	            fontWeight: 'bold',
	            width: durationStyle.width,
	            height: durationStyle.height,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            textAlign: 'center'
	        };
	
	        // START button
	        var borderColor = 'white';
	        var iconColor;
	
	        if (this.state.isStartButtonOver == true) {
	            iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	        } else {
	            iconColor = 'black';
	        }
	
	        var startStyle = {
	            width: _Properties2.default.RECORDING_PLAY_BUTTON_WIDTH,
	            height: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            background: 'white',
	            position: 'absolute',
	            left: buttonsHolderWidth,
	            top: topPosition,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderRadius: 3,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var startIcon = 'fa fa-step-backward fa-1x';
	        var startIconStyle = {
	            position: 'absolute',
	            top: 6,
	            left: 21,
	            color: iconColor
	        };
	
	        // PLAY button
	        borderColor = 'white';
	
	        if (this.state.isPlayButtonOver == true) {
	            iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	        } else {
	            iconColor = 'black';
	        }
	
	        var playStyle = {
	            width: _Properties2.default.RECORDING_PLAY_BUTTON_WIDTH,
	            height: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            background: 'white',
	            position: 'absolute',
	            left: buttonsHolderWidth + _Properties2.default.RECORDING_GAP + _Properties2.default.RECORDING_PLAY_BUTTON_WIDTH,
	            top: topPosition,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderRadius: 3,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var playIcon = 'fa fa-play';
	        var playIconPosition = 24;
	
	        if (this.state.isPlaying) {
	            playIcon = 'fa fa-pause';
	            playIconPosition = 22;
	        }
	
	        var playIconStyle = {
	            position: 'absolute',
	            top: 6,
	            left: playIconPosition,
	            color: iconColor
	        };
	
	        var playTabIndex;
	
	        if (_AudioEditorUtils2.default.getTimelinesMaxPosition() == 0 || this.props.refreshAudioElements) {
	            // is Disabled
	            playStyle.borderColor = 'white';
	            playStyle.opacity = 0.5;
	            playIconStyle.color = 'black';
	            playIconStyle.left = 24;
	            playIcon = 'fa fa-play';
	            playTabIndex = '-1';
	        }
	
	        // END button
	        borderColor = 'white';
	
	        if (this.state.isEndButtonOver == true) {
	            iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	        } else {
	            iconColor = 'black';
	        }
	
	        var endStyle = {
	            width: _Properties2.default.RECORDING_PLAY_BUTTON_WIDTH,
	            height: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            background: 'white',
	            position: 'absolute',
	            left: buttonsHolderWidth + _Properties2.default.RECORDING_GAP * 2 + _Properties2.default.RECORDING_PLAY_BUTTON_WIDTH * 2,
	            top: topPosition,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderRadius: 3,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var endIcon = 'fa fa-step-forward';
	        var endIconStyle = {
	            position: 'absolute',
	            top: 6,
	            left: 21,
	            color: iconColor
	        };
	
	        // undo style
	        var opacity = 1;
	        var tabIndexUndo;
	
	        if (this.isUndoAvailable() == false) {
	            iconColor = 'black';
	            borderColor = 'white';
	            opacity = 0.6;
	            tabIndexUndo = '-1';
	        } else {
	            if (this.state.isUndoOver == true) {
	                iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	                borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            } else {
	                iconColor = 'black';
	                borderColor = 'white';
	            }
	        }
	
	        var undoStyle = {
	            width: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            height: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            background: 'white',
	            position: 'absolute',
	            left: endStyle.left + endStyle.width + 50,
	            top: topPosition,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderRadius: 50,
	            opacity: opacity,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var undoIconStyle = {
	            position: 'absolute',
	            top: 6,
	            left: 8,
	            color: iconColor
	        };
	
	        // redo style
	        var tabIndexRedo;
	
	        if (this.isRedoAvailable() == false) {
	            iconColor = 'black';
	            borderColor = 'white';
	            opacity = 0.6;
	            tabIndexRedo = '-1';
	        } else {
	            opacity = 1;
	
	            if (this.state.isRedoOver == true) {
	                iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	                borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            } else {
	                iconColor = 'black';
	                borderColor = 'white';
	            }
	        }
	
	        var redoStyle = {
	            width: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            height: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            background: 'white',
	            position: 'absolute',
	            left: undoStyle.left + _Properties2.default.RECORDING_GAP + undoStyle.width,
	            top: topPosition,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderRadius: 50,
	            opacity: opacity,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var redoIconStyle = {
	            position: 'absolute',
	            top: 6,
	            left: 8,
	            color: iconColor
	        };
	
	        // Delete audio
	        var isAudioSelected = _AudioEditorUtils2.default.isAudioSelected();
	        var opacity = 1.0;
	        var deleteSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/trash.svg';
	        var tabIndexDelete;
	
	        if (!isAudioSelected) {
	            opacity = 0.6;
	            tabIndexDelete = '-1';
	        } else {
	            if (this.state.isDeleteOver == true) deleteSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/trash_hover.svg';
	        }
	
	        var deleteSoundButtonStyle = {
	            width: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            height: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            background: _Properties2.default.ADD_MUSIC_BUTTON_BACKGROUND,
	            position: 'absolute',
	            left: redoStyle.left + redoStyle.width + 30,
	            top: topPosition,
	            borderColor: 'white',
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderRadius: 50,
	            opacity: opacity,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var deleteIconStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0
	        };
	
	        // RECORD Button
	        var recordButtonSize = _Properties2.default.RECORDING_BUTTON_HEIGHT;
	        var recordIcon;
	
	        if (this.state.isRecordButtonOver == true) recordIcon = 'assets/recordHover.png';else recordIcon = 'assets/record.png';
	
	        borderColor = 'red';
	
	        var leftPos = buttonsHolderWidth + (this.props.width - buttonsHolderWidth) / 2 - recordButtonSize / 2;
	        var recordMinPosition = deleteSoundButtonStyle.left + deleteSoundButtonStyle.width + 30;
	
	        if (leftPos < recordMinPosition) leftPos = recordMinPosition;
	
	        var recordStyle = {
	            width: recordButtonSize,
	            height: recordButtonSize,
	            position: 'absolute',
	            left: leftPos,
	            top: topPosition,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'transparent',
	            borderStyle: 'hidden',
	            borderWidth: 2,
	            borderRadius: 50
	        };
	
	        var recordIconStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: recordButtonSize,
	            height: recordButtonSize
	        };
	
	        var recordingHolderStyle = {};
	
	        if (_PlatformDetection2.default.isIOS()) recordStyle.left = deleteSoundButtonStyle.left + deleteSoundButtonStyle.width + 75;
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'recordingMenu', style: menuStyle, onMouseDown: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement(
	                'div',
	                { style: durationStyle },
	                _react2.default.createElement(
	                    'span',
	                    { style: spanStyle },
	                    this.getCurrentTime()
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: 'start', style: startStyle, 'aria-label': _LocalesManager2.default.getCaption('startAudio', 'hover'), onMouseOver: this.onStartButtonMouseIn, onMouseOut: this.onStartButtonMouseOut, onClick: this.onStart, onTouchEnd: this.onStart },
	                _react2.default.createElement('i', { style: startIconStyle, className: startIcon })
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: 'play', style: playStyle, 'aria-label': _LocalesManager2.default.getCaption('playCartoon', 'hover'), tabIndex: playTabIndex, 'aria-disabled': playTabIndex == '-1' ? true : false, onMouseOver: this.onPlayButtonMouseIn, onMouseOut: this.onPlayButtonMouseOut, onClick: this.onPlay, onTouchEnd: this.onPlay },
	                _react2.default.createElement('i', { style: playIconStyle, className: playIcon })
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: 'end', style: endStyle, 'aria-label': _LocalesManager2.default.getCaption('endAudio', 'hover'), onMouseOver: this.onEndButtonMouseIn, onMouseOut: this.onEndButtonMouseOut, onClick: this.onEnd, onTouchEnd: this.onEnd },
	                _react2.default.createElement('i', { style: endIconStyle, className: endIcon })
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: 'undo', style: undoStyle, tabIndex: tabIndexUndo, 'aria-disabled': tabIndexUndo == '-1' ? true : false, 'aria-label': _LocalesManager2.default.getCaption('undo', 'hover'), onTouchEnd: this.onUndo, onClick: this.onUndo, onMouseOver: this.onUndoMouseIn, onMouseOut: this.onUndoMouseOut },
	                _react2.default.createElement('i', { style: undoIconStyle, className: 'fa fa-undo' })
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: 'redo', style: redoStyle, tabIndex: tabIndexRedo, 'aria-disabled': tabIndexRedo == '-1' ? true : false, 'aria-label': _LocalesManager2.default.getCaption('redo', 'hover'), onTouchEnd: this.onRedo, onClick: this.onRedo, onMouseOver: this.onRedoMouseIn, onMouseOut: this.onRedoMouseOut },
	                _react2.default.createElement('i', { style: redoIconStyle, className: 'fa fa-repeat' })
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: 'delete', style: deleteSoundButtonStyle, tabIndex: tabIndexDelete, 'aria-disabled': tabIndexDelete == '-1' ? true : false, 'aria-label': _LocalesManager2.default.getCaption('deleteAudioItem', 'hover'), onMouseOver: this.onDeleteMouseIn, onMouseOut: this.onDeleteMouseOut, onTouchEnd: this.onDelete, onClick: this.onDelete },
	                _react2.default.createElement('img', { alt: _LocalesManager2.default.getCaption('deleteAudioItem', 'hover'), 'aria-hidden': 'true', style: deleteIconStyle, src: deleteSrc })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: recordingHolderStyle },
	                _react2.default.createElement(
	                    'button',
	                    { ref: 'recordingHolder', style: recordStyle, 'aria-label': _LocalesManager2.default.getCaption('RecordSoundAlert', 'record'), onMouseOver: this.onRecordButtonMouseIn, onMouseOut: this.onRecordButtonMouseOut, onClick: this.onRecordDown, onTouchStart: this.onRecordDown },
	                    _react2.default.createElement('img', { alt: _LocalesManager2.default.getCaption('RecordSoundAlert', 'record'), 'aria-hidden': 'true', style: recordIconStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + recordIcon })
	                )
	            ),
	            _react2.default.createElement('audio', { id: 'audioBrowserSound', className: 'audioItem', preload: 'auto', playsInline: true }),
	            _react2.default.createElement('audio', { ref: 'recordedAudio', className: 'audioItem', preload: 'auto', playsInline: true })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var undo = state.undoRedo.undo;
	    var redo = state.undoRedo.redo;
	    var timelines = state.audioEditor.timelines;
	    var markerPosition = state.audioEditor.markerPosition;
	    var refreshAudioElements = state.audioEditor.refreshAudioElements;
	
	    if (refreshAudioElements == undefined) refreshAudioElements = false;
	
	    return {
	        undo: undo,
	        redo: redo,
	        timelines: timelines,
	        markerPosition: markerPosition,
	        refreshAudioElements: refreshAudioElements
	    };
	}
	
	var AudioToolHeader = exports.AudioToolHeader = (0, _reactRedux.connect)(mapStateToProps)(AudioToolHeaderContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioTool/menus/AudioToolHeader.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioTool/menus/AudioToolHeader.js"); } } })();

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioToolPlayer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _VolumeSlider = __webpack_require__(123);
	
	var _ExporterUtils = __webpack_require__(93);
	
	var _ExporterUtils2 = _interopRequireDefault(_ExporterUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onButtonMouseIn: function onButtonMouseIn() {
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Start
	                    _HoverManager2.default.show(this.refs.holder, 'startAudio');
	                    break;
	                }
	            case 1:
	                {
	                    // Back with 10s
	                    _HoverManager2.default.show(this.refs.holder, 'backAudio');
	                    break;
	                }
	            case 2:
	                {
	                    // Play
	                    if (_PlayController2.default.isPlaying) _HoverManager2.default.show(this.refs.holder, 'previewModePauseCartoon');else _HoverManager2.default.show(this.refs.holder, 'previewModePlayCartoon');
	
	                    break;
	                }
	            case 3:
	                {
	                    // Next with 10s
	                    _HoverManager2.default.show(this.refs.holder, 'nextAudio');
	                    break;
	                }
	            case 4:
	                {
	                    // End
	                    _HoverManager2.default.show(this.refs.holder, 'endAudio');
	                    break;
	                }
	            case 5:
	                {
	                    // Volume
	                    _HoverManager2.default.show(this.refs.holder, 'changeVolume', 'left');
	                    break;
	                }
	        }
	
	        this.setState({
	            isOver: true
	        });
	    },
	    getButtonAriaLabel: function getButtonAriaLabel() {
	        var text = '';
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Start
	                    text = _LocalesManager2.default.getCaption('startAudio', 'hover');
	                    break;
	                }
	            case 1:
	                {
	                    // Back with 10s
	                    text = _LocalesManager2.default.getCaption('backAudio', 'hover');
	                    break;
	                }
	            case 2:
	                {
	                    // Play
	                    if (_PlayController2.default.isPlaying) text = _LocalesManager2.default.getCaption('previewModePauseCartoon', 'hover');else text = _LocalesManager2.default.getCaption('previewModePlayCartoon', 'hover');
	
	                    break;
	                }
	            case 3:
	                {
	                    // Next with 10s
	                    text = _LocalesManager2.default.getCaption('nextAudio', 'hover');
	                    break;
	                }
	            case 4:
	                {
	                    // End
	                    text = _LocalesManager2.default.getCaption('endAudio', 'hover');
	                    break;
	                }
	            case 5:
	                {
	                    // Volume
	                    text = _LocalesManager2.default.getCaption('changeVolume', 'hover');
	                    break;
	                }
	        }
	
	        return text;
	    },
	    onButtonMouseOut: function onButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isOver: false
	        });
	    },
	    rejectMouseUpEvent: function rejectMouseUpEvent() {
	        if (_PlatformDetection2.default.isChromeBook()) {
	            var currentTime = new Date().getTime();
	            var lastClickTime = _MouseUtils2.default.mouseUpTime;
	
	            if (lastClickTime != 0 && currentTime - lastClickTime < 100) return true;else return false;
	        } else return false;
	    },
	    onClick: function onClick() {
	        _HoverManager2.default.hide();
	
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        if (this.rejectMouseUpEvent()) return;
	
	        _MouseUtils2.default.mouseUpTime = new Date().getTime();
	
	        if (this.props.handleAction) this.props.handleAction(this.props.index);
	    },
	    onTouchEnd: function onTouchEnd() {
	        _HoverManager2.default.hide();
	
	        if (this.rejectMouseUpEvent()) return;
	
	        _MouseUtils2.default.mouseUpTime = new Date().getTime();
	
	        if (this.props.handleAction) this.props.handleAction(this.props.index);
	    },
	    getSoundIcon: function getSoundIcon() {
	        var state = _StoreManager2.default.getState();
	        var soundVolume = state.audioEditor.volume;
	
	        if (soundVolume == undefined) soundVolume = 0.5;
	
	        var volumeIcon = 'fa fa-volume-down fa-2x';
	
	        if (soundVolume == 0) volumeIcon = 'fa fa-volume-off fa-2x';else if (soundVolume <= 0.5) volumeIcon = 'fa fa-volume-down fa-2x';else if (soundVolume > 0.5) volumeIcon = 'fa fa-volume-up fa-2x';
	
	        return volumeIcon;
	    },
	    render: function render() {
	        var leftPosition;
	        var middle = this.props.barWidth / 2;
	        var isMobileValue = window.outerWidth < 450 && window.outerWidth > 0 || window.outerHeight < 450 && window.outerHeight > 0;
	        var buttonSize = isMobileValue ? 28 : _Properties2.default.PREVIEW_HEIGHT;
	        var gap = _Properties2.default.PREVIEW_BUTTONS_GAP * 2;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    leftPosition = middle - buttonSize / 2 - gap * 2 - buttonSize * 2;
	                    break;
	                }
	            case 1:
	                {
	                    leftPosition = middle - buttonSize / 2 - gap - buttonSize;
	                    break;
	                }
	            case 2:
	                {
	                    leftPosition = middle - buttonSize / 2;
	                    break;
	                }
	            case 3:
	                {
	                    leftPosition = middle + buttonSize / 2 + gap;
	                    break;
	                }
	            case 4:
	                {
	                    leftPosition = middle + buttonSize / 2 + gap * 2 + buttonSize;
	                    break;
	                }
	            case 5:
	                {
	                    leftPosition = this.props.barWidth - buttonSize - 25;
	                    break;
	                }
	        }
	
	        var buttonStyle = {
	            width: buttonSize,
	            height: _Properties2.default.PREVIEW_HEIGHT,
	            position: 'absolute',
	            left: leftPosition,
	            top: 0,
	            cursor: 'pointer',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        var iconSrc = this.props.src;
	
	        var iconSize = this.props.index == 2 ? _Properties2.default.PREVIEW_BUTTON_SIZE * 2 : _Properties2.default.PREVIEW_BUTTON_SIZE * 1.5;
	        var opacity = 1;
	        var iconStyle;
	        var iconElement;
	
	        if (this.state.isOver == true && !_PlatformDetection2.default.isIOS()) opacity = 0.4;
	
	        if (this.props.index == 5) {
	            // volume button
	            iconStyle = {
	                position: 'absolute',
	                top: 5,
	                left: 10,
	                color: '#4b4c4c',
	                opacity: opacity
	            };
	
	            iconElement = _react2.default.createElement('i', { style: iconStyle, className: this.getSoundIcon() });
	        } else {
	            iconStyle = {
	                position: 'absolute',
	                top: buttonSize / 2 - iconSize / 2,
	                left: buttonSize / 2 - iconSize / 2,
	                width: iconSize,
	                height: iconSize,
	                opacity: opacity
	            };
	
	            iconElement = _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: iconSrc });
	        }
	
	        var elementId = 'audioElementVolume_' + this.props.index;
	
	        if (this.props.index == 2) elementId = 'playButtonElement';
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': this.getButtonAriaLabel(), ref: 'holder', id: elementId, style: buttonStyle, onTouchEnd: this.onTouchEnd, onClick: this.onClick, onMouseOver: this.onButtonMouseIn, onMouseOut: this.onButtonMouseOut },
	            iconElement
	        );
	    }
	});
	
	var AudioToolPlayerContent = _react2.default.createClass({
	    displayName: 'AudioToolPlayerContent',
	    getInitialState: function getInitialState() {
	        return {
	            isPlaying: false,
	            isPlayheadOver: false,
	            openVolumeSlider: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        _ExporterUtils2.default.init();
	        _PlayController2.default.updateRecordingMenuButtons = this.updateButtons;
	        _AudioToolUtils2.default.audioPlayerKeyboardShortcutAction = this.handleAction;
	
	        document.addEventListener('mousedown', this.onCloseVolumeSlider);
	        document.addEventListener('touchstart', this.onCloseVolumeSlider);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('mousedown', this.onCloseVolumeSlider);
	        document.removeEventListener('touchstart', this.onCloseVolumeSlider);
	    },
	    onCloseVolumeSlider: function onCloseVolumeSlider(e) {
	        var target = e.target;
	
	        var volume = 'audioElementVolume_5';
	
	        if (target == undefined || target && target.id == volume || target.parentElement && target.parentElement.id == volume) return;
	
	        if (target.id && target.id.indexOf('volumeIcon') != -1) {
	            this.setState({
	                openVolumeSlider: false
	            });
	
	            return;
	        }
	
	        if (target.id.indexOf('volumeSlider') != -1 || target.parentElement && target.parentElement.id.indexOf('volumeSlider') != -1 || target.parentElement && target.parentElement.parentElement && target.parentElement.parentElement.id.indexOf('volumeSlider') != -1) return;
	
	        this.setState({
	            openVolumeSlider: false
	        });
	    },
	    updateButtons: function updateButtons() {
	        this.setState({
	            isPlaying: false
	        });
	    },
	    handleAction: function handleAction(index) {
	        if (index == 2) {
	            // Play
	            this.doPlay();
	            return;
	        }
	
	        if (index == 5) {
	            // Volume
	            this.setState({
	                openVolumeSlider: true
	            });
	            return;
	        }
	
	        if (this.state.isPlaying) _PlayController2.default.pause();
	
	        var newPosition;
	
	        switch (index) {
	            case 0:
	                {
	                    // Start
	                    newPosition = 0;
	                    break;
	                }
	            case 1:
	                {
	                    // back with 10s
	                    newPosition = this.props.markerPosition - 10;
	                    break;
	                }
	            case 3:
	                {
	                    // next with 10s
	                    newPosition = this.props.markerPosition + 10;
	                    break;
	                }
	            case 4:
	                {
	                    // end
	                    newPosition = _AudioToolUtils2.default.totalTime;
	                    break;
	                }
	        }
	
	        if (newPosition < 0) newPosition = 0;
	
	        if (newPosition > _AudioToolUtils2.default.totalTime) newPosition = _AudioToolUtils2.default.totalTime;
	
	        this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(newPosition));
	
	        if (this.state.isPlaying) _PlayController2.default.play();
	    },
	    doPlay: function doPlay() {
	        if (this.state.isPlaying) _PlayController2.default.pause();else _PlayController2.default.play();
	
	        this.togglePlayState();
	    },
	    togglePlayState: function togglePlayState() {
	        if (!this.state.isPlaying) {
	            this.setState({
	                isPlaying: true
	            });
	        } else {
	            this.setState({
	                isPlaying: false
	            });
	        }
	    },
	    onTrackClick: function onTrackClick(e) {
	        if (_PlayController2.default.isPlaying) return;
	
	        if (e.target && e.target.id == 'playHead') return;
	
	        var localX = e.nativeEvent.offsetX;
	
	        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0) localX = e.nativeEvent.touches[0].clientX - 130;
	
	        var markerPosition = _AudioToolUtils2.default.getMarkerTime(localX);
	        this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(markerPosition));
	    },
	    onMouseDown: function onMouseDown() {
	        var leftString = this.refs.thumb.style.left;
	        var left = Number(leftString.substring(0, leftString.length - 2)) + _Properties2.default.PLAYHEAD_SIZE / 2;
	
	        this.setState({
	            startPosition: left,
	            isThumbActive: true
	        });
	    },
	    onMouseMove: function onMouseMove(e, coreEvent) {
	        this.checkPosition(coreEvent.lastX);
	    },
	    onMouseUp: function onMouseUp(e, coreEvent) {
	        this.checkPosition(coreEvent.lastX);
	
	        this.setState({
	            isThumbActive: false
	        });
	    },
	    checkPosition: function checkPosition(deltaX) {
	        var newPosition = this.state.startPosition + deltaX;
	
	        if (newPosition < 0) newPosition = 0;else if (newPosition > _AudioToolUtils2.default.trackWidth) newPosition = _AudioToolUtils2.default.trackWidth;
	
	        this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(_AudioToolUtils2.default.getMarkerTime(newPosition)));
	    },
	    onPlayheadMouseIn: function onPlayheadMouseIn() {
	        this.setState({
	            isPlayheadOver: true
	        });
	    },
	    onPlayheadMouseOut: function onPlayheadMouseOut() {
	        this.setState({
	            isPlayheadOver: false
	        });
	    },
	    render: function render() {
	        var width = _Configuration2.default.CANVAS_WIDTH * this.props.scaleProperties.scale;
	        var height = _Configuration2.default.CANVAS_HEIGHT * this.props.scaleProperties.scale;
	
	        var menuStyle = {
	            position: 'absolute',
	            background: 'blue',
	            width: width,
	            height: height,
	            top: this.props.scaleProperties.topY,
	            left: this.props.scaleProperties.topX,
	            cursor: 'default',
	            userSelect: 'none',
	            userDrag: 'none'
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: menuStyle.width,
	            height: height - _Properties2.default.PLAYER_BAR_HEIGHT,
	            background: '#ffb02d'
	        };
	
	        // image size 367x258
	        var backgroundIconStyle = {
	            position: 'absolute',
	            top: backgroundStyle.height / 2 - 258 / 2,
	            left: width / 2 - 367 / 2
	        };
	
	        var src = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/audioPlayerBackground.png';
	
	        var barStyle = {
	            position: 'absolute',
	            top: height - _Properties2.default.PLAYER_BAR_HEIGHT,
	            left: 0,
	            width: width,
	            height: _Properties2.default.PLAYER_BAR_HEIGHT,
	            background: '#ebeae8'
	        };
	
	        var buttonsHolderStyle = {
	            position: 'absolute',
	            top: _Properties2.default.PLAYER_BAR_HEIGHT / 2,
	            left: 0,
	            width: width,
	            height: _Properties2.default.PLAYER_BAR_HEIGHT / 2
	        };
	
	        var controlBarStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: width,
	            height: _Properties2.default.PLAYER_BAR_HEIGHT / 2
	        };
	
	        var textHeight = 20;
	        var textWidth = 130;
	
	        var leftSpanStyle = {
	            color: 'black',
	            fontSize: 18,
	            cursor: 'default',
	            position: 'absolute',
	            textAlign: 'center',
	            width: textWidth,
	            height: textHeight,
	            left: 0,
	            top: controlBarStyle.height / 2 - textHeight / 2
	        };
	
	        var rightSpanStyle = {
	            color: 'black',
	            fontSize: 18,
	            cursor: 'default',
	            position: 'absolute',
	            textAlign: 'center',
	            width: textWidth,
	            height: textHeight,
	            left: width - textWidth,
	            top: controlBarStyle.height / 2 - textHeight / 2
	        };
	
	        var trackHeight = 10;
	        var playhedSize = _Properties2.default.PLAYHEAD_SIZE;
	        var trackStyle = {
	            position: 'absolute',
	            width: width - 2 * textWidth,
	            height: playhedSize,
	            left: textWidth,
	            top: controlBarStyle.height / 2 - playhedSize / 2
	        };
	
	        _AudioToolUtils2.default.checkTotalTime(trackStyle.width);
	        var currentPosition = _AudioToolUtils2.default.getMarkerPosition(this.props.markerPosition);
	        var trackNormalStyle = {
	            position: 'absolute',
	            background: '#898b8b',
	            width: trackStyle.width,
	            height: trackHeight,
	            left: 0,
	            top: trackStyle.height / 2 - trackHeight / 2
	        };
	
	        var trackShadowStyle = {
	            position: 'absolute',
	            background: '#00B3EC',
	            width: currentPosition,
	            height: trackHeight,
	            left: 0,
	            top: trackStyle.height / 2 - trackHeight / 2
	        };
	
	        var playheadStyle = {
	            position: 'absolute',
	            background: 'white',
	            width: playhedSize,
	            height: playhedSize,
	            left: currentPosition - playhedSize / 2,
	            top: trackStyle.height / 2 - playhedSize / 2,
	            borderRadius: 50,
	            boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
	            cursor: 'pointer'
	        };
	
	        if (this.state.isThumbActive || this.state.isPlayheadOver) playheadStyle.background = '#ffb02d';
	
	        var playSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/play.png';
	
	        if (this.state.isPlaying) playSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/pause.png';
	
	        var isMobileValue = window.outerWidth < 450 && window.outerWidth > 0 || window.outerHeight < 450 && window.outerHeight > 0;
	        var volumeSliderOffset = isMobileValue ? 57 : 67;
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(
	                'div',
	                { style: backgroundStyle },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: backgroundIconStyle, src: src })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: barStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: controlBarStyle },
	                    _react2.default.createElement(
	                        'span',
	                        { style: leftSpanStyle },
	                        _AudioToolUtils2.default.getCurrentTime(this.props.markerPosition)
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { style: rightSpanStyle },
	                        _AudioToolUtils2.default.getTotalTime()
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: trackStyle, onTouchStart: this.onTrackClick, onMouseDown: this.onTrackClick },
	                        _react2.default.createElement('div', { style: trackNormalStyle }),
	                        _react2.default.createElement('div', { style: trackShadowStyle }),
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	                            _react2.default.createElement('div', { style: playheadStyle, id: 'playHead', ref: 'thumb', onMouseOver: this.onPlayheadMouseIn, onMouseOut: this.onPlayheadMouseOut })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: buttonsHolderStyle },
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 0, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/start.png', barWidth: width, handleAction: this.handleAction }),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 1, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/goBack.svg', barWidth: width, handleAction: this.handleAction }),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 2, src: playSrc, barWidth: width, handleAction: this.handleAction }),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 3, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/goNext.svg', barWidth: width, handleAction: this.handleAction }),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 4, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/end.png', barWidth: width, handleAction: this.handleAction }),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 5, barWidth: width, handleAction: this.handleAction }),
	                    _react2.default.createElement(_VolumeSlider.VolumeSlider, { dispatch: this.props.dispatch, visible: this.state.openVolumeSlider, type: 'audioToolPlayer', positionLeft: width - volumeSliderOffset })
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var markerPosition = state.audioEditor.markerPosition;
	    var volume = state.audioEditor.volume;
	
	    if (!markerPosition) markerPosition = 0;
	
	    if (volume == undefined) volume = 0.5;
	
	    return {
	        markerPosition: markerPosition,
	        volume: volume
	    };
	}
	
	var AudioToolPlayer = exports.AudioToolPlayer = (0, _reactRedux.connect)(mapStateToProps)(AudioToolPlayerContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioTool/menus/AudioToolPlayer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioTool/menus/AudioToolPlayer.js"); } } })();

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ExportPlayer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _VolumeSlider = __webpack_require__(123);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _ExportPlayerController = __webpack_require__(241);
	
	var _ExportPlayerController2 = _interopRequireDefault(_ExportPlayerController);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _FullScreenManager = __webpack_require__(141);
	
	var _FullScreenManager2 = _interopRequireDefault(_FullScreenManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onButtonMouseIn: function onButtonMouseIn() {
	        var isAudioExport = _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Start
	                    if (isAudioExport) _HoverManager2.default.show(this.refs.holder, 'startAudio');else _HoverManager2.default.show(this.refs.holder, 'firstSlide');
	                    break;
	                }
	            case 1:
	                {
	                    // Back with 10s
	                    _HoverManager2.default.show(this.refs.holder, 'backAudio');
	                    break;
	                }
	            case 2:
	                {
	                    // Previous slide
	                    _HoverManager2.default.show(this.refs.holder, 'previousSlide');
	                    break;
	                }
	            case 3:
	                {
	                    // Play
	                    if (_ExportPlayerController2.default.isPlaying()) _HoverManager2.default.show(this.refs.holder, 'previewModePauseCartoon');else _HoverManager2.default.show(this.refs.holder, 'previewModePlayCartoon');
	
	                    break;
	                }
	            case 4:
	                {
	                    // Next slide
	                    _HoverManager2.default.show(this.refs.holder, 'nextSlide');
	                    break;
	                }
	            case 5:
	                {
	                    // Next with 10s
	                    _HoverManager2.default.show(this.refs.holder, 'nextAudio');
	                    break;
	                }
	            case 6:
	                {
	                    // End
	                    if (isAudioExport) _HoverManager2.default.show(this.refs.holder, 'endAudio');else _HoverManager2.default.show(this.refs.holder, 'lastSlide');
	                    break;
	                }
	            case 7:
	                {
	                    // Volume
	                    _HoverManager2.default.show(this.refs.holder, 'changeVolume');
	                    break;
	                }
	            case 8:
	                {
	                    if (this.props.src.indexOf('normalScreen') != -1) _HoverManager2.default.show(this.refs.holder, 'normalScreen');else _HoverManager2.default.show(this.refs.holder, 'fullScreen');
	                    break;
	                }
	        }
	
	        this.setState({
	            isOver: true
	        });
	    },
	    getButtonAriaLabel: function getButtonAriaLabel() {
	        var text = '';
	        var isAudioExport = _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Start
	                    if (isAudioExport) text = _LocalesManager2.default.getCaption('startAudio', 'hover');else text = _LocalesManager2.default.getCaption('firstSlide', 'hover');
	                    break;
	                }
	            case 1:
	                {
	                    // Back with 10s
	                    text = _LocalesManager2.default.getCaption('backAudio', 'hover');
	                    break;
	                }
	            case 2:
	                {
	                    // Previous slide
	                    text = _LocalesManager2.default.getCaption('previousSlide', 'hover');
	                    break;
	                }
	            case 3:
	                {
	                    // Play
	                    if (_ExportPlayerController2.default.isPlaying()) text = _LocalesManager2.default.getCaption('previewModePauseCartoon', 'hover');else text = _LocalesManager2.default.getCaption('previewModePlayCartoon', 'hover');
	
	                    break;
	                }
	            case 4:
	                {
	                    // Next slide
	                    text = _LocalesManager2.default.getCaption('nextSlide', 'hover');
	                    break;
	                }
	            case 5:
	                {
	                    // Next with 10s
	                    text = _LocalesManager2.default.getCaption('nextAudio', 'hover');
	                    break;
	                }
	            case 6:
	                {
	                    // End
	                    if (isAudioExport) text = _LocalesManager2.default.getCaption('endAudio', 'hover');else text = _LocalesManager2.default.getCaption('lastSlide', 'hover');
	                    break;
	                }
	            case 7:
	                {
	                    // Volume
	                    text = _LocalesManager2.default.getCaption('changeVolume', 'hover');
	                    break;
	                }
	            case 8:
	                {
	                    if (this.props.src.indexOf('normalScreen') != -1) text = _LocalesManager2.default.getCaption('normalScreen', 'hover');else text = _LocalesManager2.default.getCaption('fullScreen', 'hover');
	                    break;
	                }
	        }
	
	        return text;
	    },
	    onButtonMouseOut: function onButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isOver: false
	        });
	    },
	    rejectMouseUpEvent: function rejectMouseUpEvent() {
	        if (_PlatformDetection2.default.isChromeBook()) {
	            var currentTime = new Date().getTime();
	            var lastClickTime = _MouseUtils2.default.mouseUpTime;
	
	            if (lastClickTime != 0 && currentTime - lastClickTime < 100) return true;else return false;
	        } else return false;
	    },
	    onClick: function onClick() {
	        _HoverManager2.default.hide();
	
	        if (_PlatformDetection2.default.isIOS() || _PlatformDetection2.default.isAndroid()) return;
	
	        if (this.rejectMouseUpEvent()) return;
	
	        _MouseUtils2.default.mouseUpTime = new Date().getTime();
	
	        if (this.props.handleAction) this.props.handleAction(this.props.index);
	    },
	    onTouchEnd: function onTouchEnd() {
	        _HoverManager2.default.hide();
	
	        if (this.rejectMouseUpEvent()) return;
	
	        _MouseUtils2.default.mouseUpTime = new Date().getTime();
	
	        if (this.props.handleAction) this.props.handleAction(this.props.index);
	    },
	    getSoundIcon: function getSoundIcon() {
	        var state = _StoreManager2.default.getState();
	        var soundVolume = state.audioEditor.volume;
	
	        if (soundVolume == undefined) soundVolume = 0.5;
	
	        var volumeIcon = 'fa fa-volume-down fa-2x';
	
	        if (soundVolume == 0) volumeIcon = 'fa fa-volume-off fa-2x';else if (soundVolume <= 0.5) volumeIcon = 'fa fa-volume-down fa-2x';else if (soundVolume > 0.5) volumeIcon = 'fa fa-volume-up fa-2x';
	
	        return volumeIcon;
	    },
	    render: function render() {
	        var leftPosition;
	        var middle = this.props.barWidth / 2;
	        var isMobileValue = window.outerWidth < 450 && window.outerWidth > 0 || window.outerHeight < 450 && window.outerHeight > 0;
	        var gap = isMobileValue ? 5 : _Properties2.default.PREVIEW_BUTTONS_GAP;
	        var buttonSize = isMobileValue ? 28 : _Properties2.default.PREVIEW_HEIGHT;
	        var isAudioExport = _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    leftPosition = middle - buttonSize / 2 - gap * 2 - buttonSize * 2;
	                    break;
	                }
	            case 1:
	                {
	                    leftPosition = middle - buttonSize / 2 - gap * 1.5 - buttonSize;
	                    break;
	                }
	            case 2:
	                {
	                    leftPosition = middle - buttonSize / 2 - gap * 1.5 - buttonSize;
	                    break;
	                }
	            case 3:
	                {
	                    leftPosition = middle - buttonSize / 2;
	                    break;
	                }
	            case 4:
	                {
	                    leftPosition = middle + buttonSize / 2 + gap * 1.5;
	                    break;
	                }
	            case 5:
	                {
	                    leftPosition = middle + buttonSize / 2 + gap * 1.5;
	                    break;
	                }
	            case 6:
	                {
	                    leftPosition = middle + buttonSize / 2 + gap * 2 + buttonSize;
	                    break;
	                }
	            case 7:
	                {
	                    // volume
	                    if (isAudioExport) leftPosition = this.props.barWidth - buttonSize - 35;else {
	                        if (isMobileValue) leftPosition = this.props.barWidth - 2 * buttonSize - 15;else leftPosition = this.props.barWidth - 2 * buttonSize - 45;
	                    }
	                    break;
	                }
	            case 8:
	                {
	                    // fullscreen
	                    if (isAudioExport) leftPosition = 35;else {
	                        if (isMobileValue) leftPosition = this.props.barWidth - buttonSize - 5;else leftPosition = this.props.barWidth - buttonSize - 28;
	                    }
	                    break;
	                }
	        }
	
	        var buttonStyle = {
	            width: buttonSize,
	            height: _Properties2.default.PREVIEW_HEIGHT,
	            position: 'absolute',
	            left: leftPosition,
	            top: 0,
	            cursor: 'pointer',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        var iconSrc = this.props.src;
	        var opacity = 1;
	        var iconStyle;
	        var iconElement;
	        var iconSize = this.props.index == 3 ? _Properties2.default.PREVIEW_BUTTON_SIZE * 2 : _Properties2.default.PREVIEW_BUTTON_SIZE * 1.5;
	
	        if (!isAudioExport) iconSize = _Properties2.default.PREVIEW_BUTTON_SIZE;
	
	        if (this.state.isOver == true && !_PlatformDetection2.default.isIOS()) opacity = 0.4;
	
	        if (this.props.index == 7) {
	            // volume button
	            iconStyle = {
	                position: 'absolute',
	                top: 10,
	                left: 10,
	                color: '#4b4c4c',
	                opacity: opacity
	            };
	
	            iconElement = _react2.default.createElement('i', { style: iconStyle, className: this.getSoundIcon() });
	        } else {
	            if (this.props.index == 8) {
	                if (this.props.src.indexOf('normalScreen') != -1) iconSize = _Properties2.default.PREVIEW_BUTTON_SIZE * 2.2;else iconSize = _Properties2.default.PREVIEW_BUTTON_SIZE * 1.2;
	            }
	
	            iconStyle = {
	                position: 'absolute',
	                top: _Properties2.default.PREVIEW_HEIGHT / 2 - iconSize / 2,
	                left: buttonSize / 2 - iconSize / 2,
	                width: iconSize,
	                height: iconSize,
	                opacity: opacity
	            };
	
	            iconElement = _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: iconSrc });
	        }
	
	        var elementId = 'audioElementVolume_' + this.props.index;
	
	        if (this.props.index == 3) elementId = 'playButtonElement';
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': this.getButtonAriaLabel(), ref: 'holder', id: elementId, style: buttonStyle, onTouchEnd: this.onTouchEnd, onClick: this.onClick, onMouseOver: this.onButtonMouseIn, onMouseOut: this.onButtonMouseOut },
	            iconElement
	        );
	    }
	});
	
	var ExportPlayerContent = _react2.default.createClass({
	    displayName: 'ExportPlayerContent',
	    getInitialState: function getInitialState() {
	        return {
	            isPlaying: false,
	            isPlayheadOver: false,
	            openVolumeSlider: false,
	            isMediaLoaded: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.updateTrackWidth();
	        _FullScreenManager2.default.refreshExportPlayer = this.refreshWhenToogleFullScreen;
	        _FullScreenManager2.default.refreshFunction = this.refreshView;
	        _ExportPlayerController2.default.keyboardShortcutAction = this.handleKeyboardAction;
	
	        document.addEventListener('mousedown', this.onCloseVolumeSlider);
	        document.addEventListener('touchstart', this.onCloseVolumeSlider);
	
	        if (_PlatformDetection2.default.isIOS()) window.addEventListener('orientationchange', this.onResize);else window.addEventListener('resize', this.onResize);
	
	        if (_FullScreenManager2.default.isIOSMode() && _FullScreenManager2.default.isFullScreenMode()) _FullScreenManager2.default.addFullScreenEventsForIOS();
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('mousedown', this.onCloseVolumeSlider);
	        document.removeEventListener('touchstart', this.onCloseVolumeSlider);
	    },
	    onResize: function onResize() {
	        this.updateTrackWidth();
	        this.refreshView();
	    },
	    refreshView: function refreshView() {
	        this.forceUpdate();
	    },
	    updateTrackWidth: function updateTrackWidth() {
	        var properties = this.getPositionProperties();
	        _ExportPlayerController2.default.trackWidth = properties.w - 2 * this.getTextWidth();
	    },
	    onCloseVolumeSlider: function onCloseVolumeSlider(e) {
	        var target = e.target;
	
	        var volume = 'audioElementVolume_7';
	
	        if (target == undefined || target && target.id == volume || target.parentElement && target.parentElement.id == volume) return;
	
	        if (target.id && target.id.indexOf('volumeIcon') != -1) {
	            this.setState({
	                openVolumeSlider: false
	            });
	
	            return;
	        }
	
	        if (target.id.indexOf('volumeSlider') != -1 || target.parentElement && target.parentElement.id.indexOf('volumeSlider') != -1 || target.parentElement && target.parentElement.parentElement && target.parentElement.parentElement.id.indexOf('volumeSlider') != -1) return;
	
	        this.setState({
	            openVolumeSlider: false
	        });
	    },
	    updateButtons: function updateButtons() {
	        this.setState({
	            isPlaying: false
	        });
	    },
	    handleKeyboardAction: function handleKeyboardAction(value) {
	        var index = 3;
	
	        if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER) {
	            if (value == 'left') index = 2;else if (value == 'right') index = 4;
	        } else {
	            if (value == 'left') index = 1;else if (value == 'right') index = 5;
	        }
	
	        this.handleAction(index);
	    },
	    handleAction: function handleAction(index) {
	        if (index == 3) {
	            // Play
	            this.doPlay();
	            return;
	        }
	
	        if (index == 7) {
	            // Volume
	            this.setState({
	                openVolumeSlider: true
	            });
	
	            return;
	        }
	
	        var newPosition = 0;
	        var totalTime = _ExportPlayerController2.default.getVideoTotalTime();
	
	        switch (index) {
	            case 0:
	                {
	                    // Start
	                    newPosition = 0;
	                    break;
	                }
	            case 1:
	                {
	                    // back with 10s
	                    newPosition = this.props.markerPosition - 10;
	                    break;
	                }
	            case 2:
	                {
	                    // previous slide
	                    newPosition = _ExportPlayerController2.default.getPreviousSlideTime();
	                    break;
	                }
	            case 4:
	                {
	                    // next slide
	                    newPosition = _ExportPlayerController2.default.getNextSlideTime();
	                    break;
	                }
	            case 5:
	                {
	                    // next with 10s
	                    newPosition = this.props.markerPosition + 10;
	                    break;
	                }
	            case 6:
	                {
	                    // end
	                    if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_PLAYER) newPosition = _ExportPlayerController2.default.getNextSlideTime(true);else newPosition = totalTime;
	                    break;
	                }
	            case 8:
	                {
	                    // fullScreen
	                    _FullScreenManager2.default.goFullScreenMode();
	                    this.refreshWhenToogleFullScreen();
	                    return;
	                    break;
	                }
	        }
	
	        if (newPosition < 0) newPosition = 0;
	
	        if (newPosition > totalTime) newPosition = totalTime;
	
	        this.setNewPosition(newPosition);
	    },
	    refreshWhenToogleFullScreen: function refreshWhenToogleFullScreen() {
	        setTimeout(function () {
	            this.updateTrackWidth();
	            this.forceUpdate();
	        }.bind(this), 300);
	    },
	    setNewPosition: function setNewPosition(position) {
	        _ExportPlayerController2.default.setVideoPosition(position);
	        this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(position));
	    },
	    doPlay: function doPlay() {
	        _ExportPlayerController2.default.play(!this.state.isPlaying);
	        this.togglePlayState();
	    },
	    togglePlayState: function togglePlayState() {
	        if (!this.state.isPlaying) {
	            this.setState({
	                isPlaying: true
	            });
	        } else {
	            this.setState({
	                isPlaying: false
	            });
	        }
	    },
	    onTrackClick: function onTrackClick(e) {
	        if (e.target && e.target.id == 'playHead') return;
	
	        var localX = e.nativeEvent.offsetX;
	
	        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0) localX = e.nativeEvent.touches[0].clientX - this.getTextWidth();
	
	        var markerPosition = _ExportPlayerController2.default.getMarkerTime(localX);
	        this.setNewPosition(markerPosition);
	    },
	    onMouseDown: function onMouseDown() {
	        var leftString = this.refs.thumb.style.left;
	        var left = Number(leftString.substring(0, leftString.length - 2)) + _Properties2.default.PLAYHEAD_SIZE / 2;
	
	        this.setState({
	            startPosition: left,
	            isThumbActive: true
	        });
	    },
	    onMouseMove: function onMouseMove(e, coreEvent) {
	        this.checkPosition(coreEvent.lastX);
	    },
	    onMouseUp: function onMouseUp(e, coreEvent) {
	        this.checkPosition(coreEvent.lastX);
	
	        this.setState({
	            isThumbActive: false
	        });
	    },
	    checkPosition: function checkPosition(deltaX) {
	        var newPosition = this.state.startPosition + deltaX;
	
	        if (newPosition < 0) newPosition = 0;else if (newPosition > _ExportPlayerController2.default.trackWidth) newPosition = _ExportPlayerController2.default.trackWidth;
	
	        var markerPos = _ExportPlayerController2.default.getMarkerTime(newPosition);
	        this.setNewPosition(markerPos);
	    },
	    onPlayheadMouseIn: function onPlayheadMouseIn() {
	        this.setState({
	            isPlayheadOver: true
	        });
	    },
	    onPlayheadMouseOut: function onPlayheadMouseOut() {
	        this.setState({
	            isPlayheadOver: false
	        });
	    },
	    getVideoSrc: function getVideoSrc() {
	        var exportId = _AppParameters2.default.exportId;
	        var hostName = 'https://stage.creaza.com';
	
	        if (_Configuration2.default.LOAD_LOCAL == true) {
	            if (_AppParameters2.default.context == 'exportPlayer') exportId = 75410387; // Cartoonist
	            else exportId = 75412400; // AE
	        }
	
	        if (_Configuration2.default.IS_PROD() && !_Configuration2.default.LOAD_LOCAL) hostName = 'https://www.creaza.com';
	
	        return hostName + '/file/ci/' + exportId + '/aaa' + '?cacheBreaker=' + Math.random();
	    },
	    endMedia: function endMedia() {
	        this.setState({
	            isPlaying: false
	        });
	
	        _ExportPlayerController2.default.play(false);
	    },
	    onVideoLoaded: function onVideoLoaded() {
	        this.setState({
	            isMediaLoaded: true
	        });
	
	        if (this.state.isMediaLoaded) return;
	
	        if (_PlatformDetection2.default.isIOS()) {
	            var video = document.getElementById('exportedVideo');
	
	            if (!video) return;
	
	            try {
	                video.load();
	
	                if (_AppParameters2.default.playerCurrentTime > 0) {
	                    setTimeout(function (videoElement) {
	                        videoElement.currentTime = _AppParameters2.default.playerCurrentTime;
	                    }.bind(this), 200, video);
	                }
	            } catch (e) {
	                // error
	            }
	        }
	    },
	    getPositionProperties: function getPositionProperties() {
	        var height = this.props.windowHeight;
	        var scale = _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER || _FullScreenManager2.default.isFullScreenMode() ? height / _Configuration2.default.CANVAS_HEIGHT : (height - _Properties2.default.PLAYER_BAR_HEIGHT_FOR_CARTOONIST) / _Configuration2.default.CANVAS_HEIGHT;
	        var width = _Configuration2.default.CANVAS_WIDTH * scale;
	        var topY = 0;
	        var topX = (this.props.windowWidth - width) / 2;
	
	        if (width > this.props.windowWidth) {
	            width = this.props.windowWidth;
	            scale = width / _Configuration2.default.CANVAS_WIDTH;
	            height = _Configuration2.default.CANVAS_HEIGHT * scale;
	            topX = 0;
	            topY = (this.props.windowHeight - height) / 2;
	        }
	
	        return { w: width, h: height, x: topX, y: topY };
	    },
	    getTextWidth: function getTextWidth() {
	        var isAudio = _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER;
	        var textWidth = isAudio ? 130 : 70;
	
	        return textWidth;
	    },
	    render: function render() {
	        var _React$createElement, _React$createElement2;
	
	        var position = this.getPositionProperties();
	        var width = position.w;
	        var height = position.h;
	        var isAudio = _AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER;
	
	        var menuStyle = {
	            position: 'absolute',
	            width: position.w,
	            height: position.h,
	            top: position.y,
	            left: position.x,
	            cursor: 'default',
	            userSelect: 'none',
	            userDrag: 'none'
	        };
	
	        var controlBarOpacity = 1;
	
	        if (_AppParameters2.default.context != _ModeConstants2.default.EXPORT_AUDIO_PLAYER && _FullScreenManager2.default.isFullScreenMode() == true) {
	            // Cartoonist in fullScreen mode
	            if (_FullScreenManager2.default.isControlBarVisible() == false) controlBarOpacity = 0;else controlBarOpacity = 0.6;
	        }
	
	        var barStyle = {
	            position: 'absolute',
	            bottom: 0,
	            left: 0,
	            width: width,
	            height: isAudio ? _Properties2.default.PLAYER_BAR_HEIGHT : _Properties2.default.PLAYER_BAR_HEIGHT_FOR_CARTOONIST,
	            backgroundImage: 'linear-gradient(rgb(255, 176, 45), rgb(255, 255, 255), rgb(255, 176, 45))',
	            opacity: controlBarOpacity
	        };
	
	        var buttonsHolderStyle = {
	            position: 'absolute',
	            top: _Properties2.default.PLAYER_BAR_HEIGHT / 2,
	            left: 0,
	            width: width,
	            height: isAudio ? _Properties2.default.PLAYER_BAR_HEIGHT / 2 : _Properties2.default.PREVIEW_HEIGHT
	        };
	
	        var controlBarStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: width,
	            height: isAudio ? _Properties2.default.PLAYER_BAR_HEIGHT / 2 : _Properties2.default.PLAYHEAD_SIZE_FOR_CARTOONIST
	        };
	
	        var textHeight = isAudio ? 20 : 25;
	        var textWidth = this.getTextWidth();
	
	        var leftSpanStyle = {
	            color: 'black',
	            fontSize: 18,
	            cursor: 'default',
	            position: 'absolute',
	            textAlign: 'center',
	            width: textWidth,
	            height: textHeight,
	            left: 0,
	            top: controlBarStyle.height / 2 - textHeight / 2
	        };
	
	        var rightSpanStyle = {
	            color: 'black',
	            fontSize: 18,
	            cursor: 'default',
	            position: 'absolute',
	            textAlign: 'center',
	            width: textWidth,
	            height: textHeight,
	            left: width - textWidth,
	            top: controlBarStyle.height / 2 - textHeight / 2
	        };
	
	        var playhedSize = isAudio ? _Properties2.default.PLAYHEAD_SIZE : _Properties2.default.PLAYHEAD_SIZE_FOR_CARTOONIST;
	        var trackHeight = isAudio ? 10 : playhedSize;
	        var trackStyle = {
	            position: 'absolute',
	            width: width - 2 * textWidth,
	            height: playhedSize,
	            left: textWidth,
	            top: controlBarStyle.height / 2 - playhedSize / 2
	        };
	
	        var currentPosition = _ExportPlayerController2.default.getMarkerPosition();
	
	        if (!currentPosition) currentPosition = 0;
	
	        var trackNormalStyle = {
	            position: 'absolute',
	            background: '#898b8b',
	            width: trackStyle.width,
	            height: trackHeight,
	            left: 0,
	            top: trackStyle.height / 2 - trackHeight / 2
	        };
	
	        var trackShadowStyle = {
	            position: 'absolute',
	            background: '#00B3EC',
	            width: currentPosition,
	            height: trackHeight,
	            left: 0,
	            top: trackStyle.height / 2 - trackHeight / 2
	        };
	
	        var playheadStyle = {
	            position: 'absolute',
	            background: isAudio ? 'white' : '#4bade9',
	            width: playhedSize,
	            height: playhedSize,
	            left: currentPosition - playhedSize / 2,
	            top: trackStyle.height / 2 - playhedSize / 2,
	            borderRadius: 50,
	            boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
	            cursor: 'pointer'
	        };
	
	        if (this.state.isThumbActive || this.state.isPlayheadOver) {
	            if (isAudio) playheadStyle.background = '#ffb02d';else playheadStyle.background = '#4bbddd';
	        }
	
	        var playSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/play.png';
	
	        if (this.state.isPlaying) playSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/pause.png';
	
	        var videoHolderStyle = {
	            position: 'absolute',
	            left: 0,
	            width: menuStyle.width
	        };
	
	        var preloader;
	
	        if (!this.state || !this.state.isMediaLoaded) {
	            var wrapperStyle = {
	                position: 'absolute',
	                background: '#333333',
	                opacity: 0.5,
	                top: 0,
	                left: 0,
	                width: menuStyle.width,
	                height: menuStyle.height
	            };
	
	            var size = 48;
	
	            var loaderStyle = {
	                position: 'absolute',
	                top: wrapperStyle.height / 2 - size / 2,
	                left: wrapperStyle.width / 2 - size / 2,
	                color: 'white'
	            };
	
	            preloader = _react2.default.createElement(
	                'div',
	                { style: wrapperStyle },
	                _react2.default.createElement('i', { style: loaderStyle, className: 'fa fa-spinner fa-pulse fa-3x' })
	            );
	        }
	
	        var fullScreenSrc;
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (_PreviewCommands2.default.isIOSFullScreen) fullScreenSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/normalScreen.png';else fullScreenSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/fullScreen.png';
	        } else {
	            if (_FullScreenManager2.default.isFullScreenMode()) fullScreenSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/normalScreen.png';else fullScreenSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/fullScreen.png';
	        }
	
	        _ExportPlayerController2.default.updateVolume();
	
	        var isMobileValue = window.outerWidth < 450 && window.outerWidth > 0 || window.outerHeight < 450 && window.outerHeight > 0;
	        var audioBackground;
	        var backBtn;
	        var nextBtn;
	        var volumeSliderLeft = width - 71;
	        var slidesElement;
	
	        if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) {
	            var backgroundStyle = {
	                position: 'absolute',
	                top: 0,
	                left: 0,
	                width: menuStyle.width,
	                height: height - _Properties2.default.PLAYER_BAR_HEIGHT,
	                backgroundImage: 'linear-gradient(rgb(255, 176, 45), rgb(255, 255, 255), rgb(255, 176, 45))'
	            };
	
	            // image size 367x258
	            var backgroundIconStyle = {
	                position: 'absolute',
	                top: backgroundStyle.height / 2 - 258 / 2,
	                left: width / 2 - 367 / 2,
	                borderRadius: 100
	            };
	
	            var src = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/audioPlayerBackground.png';
	
	            audioBackground = _react2.default.createElement(
	                'div',
	                { style: backgroundStyle },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: backgroundIconStyle, src: src })
	            );
	
	            backBtn = _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 1, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/goBack.svg', barWidth: width, handleAction: this.handleAction });
	            nextBtn = _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 5, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/goNext.svg', barWidth: width, handleAction: this.handleAction });
	        } else {
	            backBtn = _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 2, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/back.png', barWidth: width, handleAction: this.handleAction });
	            nextBtn = _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 4, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/next.png', barWidth: width, handleAction: this.handleAction });
	
	            barStyle.backgroundImage = undefined;
	            barStyle.background = '#edeeef';
	
	            controlBarStyle.background = '#ffffff';
	            trackStyle.height = controlBarStyle.height;
	            trackStyle.top = 0;
	
	            trackNormalStyle.background = '#cfd0d1';
	            trackShadowStyle.background = '#4bade9';
	
	            leftSpanStyle.fontSize = 17;
	            leftSpanStyle.fontWeight = 'bold';
	            leftSpanStyle.top = 1;
	
	            rightSpanStyle.fontSize = 17;
	            rightSpanStyle.fontWeight = 'bold';
	            rightSpanStyle.top = 1;
	
	            if (isMobileValue) volumeSliderLeft = volumeSliderLeft - 5;else volumeSliderLeft = volumeSliderLeft - 60;
	
	            var slidesElementStyle = {
	                color: 'black',
	                fontSize: 17,
	                fontWeight: 'bold',
	                cursor: 'default',
	                position: 'absolute',
	                textAlign: 'center',
	                width: textWidth,
	                height: textHeight,
	                left: 0,
	                top: 13
	            };
	
	            slidesElement = _react2.default.createElement(
	                'span',
	                { style: slidesElementStyle },
	                _ExportPlayerController2.default.getSlidesText()
	            );
	
	            buttonsHolderStyle.top = trackHeight;
	        }
	
	        var startBtn = _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 0, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/start.png', barWidth: width, handleAction: this.handleAction });
	        var endBtn = _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 6, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/end.png', barWidth: width, handleAction: this.handleAction });
	
	        if (_AppParameters2.default.isExternVideo) {
	            startBtn = undefined;
	            endBtn = undefined;
	            backBtn = undefined;
	            nextBtn = undefined;
	            slidesElement = undefined;
	        }
	
	        var exportAudioFullScreen;
	        var exportCartoonistFullScreen;
	
	        if (_AppParameters2.default.context == _ModeConstants2.default.EXPORT_AUDIO_PLAYER) exportAudioFullScreen = _react2.default.createElement(Button, (_React$createElement = { dispatch: this.props.dispatch, index: 8, barWidth: width, src: fullScreenSrc }, _defineProperty(_React$createElement, 'barWidth', width), _defineProperty(_React$createElement, 'handleAction', this.handleAction), _React$createElement));else exportCartoonistFullScreen = _react2.default.createElement(Button, (_React$createElement2 = { dispatch: this.props.dispatch, index: 8, barWidth: width, src: fullScreenSrc }, _defineProperty(_React$createElement2, 'barWidth', width), _defineProperty(_React$createElement2, 'handleAction', this.handleAction), _React$createElement2));
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(
	                'div',
	                { style: videoHolderStyle, id: 'svgContainer' },
	                _react2.default.createElement(
	                    'video',
	                    { id: 'exportedVideo', width: '100%', onEnded: this.endMedia, onDurationChange: this.onVideoLoaded },
	                    _react2.default.createElement('source', { src: this.getVideoSrc() })
	                )
	            ),
	            audioBackground,
	            _react2.default.createElement(
	                'div',
	                { style: barStyle, id: 'previewMenu' },
	                _react2.default.createElement(
	                    'div',
	                    { style: controlBarStyle },
	                    _react2.default.createElement(
	                        'span',
	                        { style: leftSpanStyle },
	                        _ExportPlayerController2.default.getCurrentTime(isAudio)
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { style: rightSpanStyle },
	                        _ExportPlayerController2.default.getTotalTime(isAudio)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: trackStyle, onTouchStart: this.onTrackClick, onMouseDown: this.onTrackClick },
	                        _react2.default.createElement('div', { style: trackNormalStyle }),
	                        _react2.default.createElement('div', { style: trackShadowStyle }),
	                        _react2.default.createElement(
	                            _reactDraggable2.default,
	                            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	                            _react2.default.createElement('div', { style: playheadStyle, id: 'playHead', ref: 'thumb', onMouseOver: this.onPlayheadMouseIn, onMouseOut: this.onPlayheadMouseOut })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: buttonsHolderStyle },
	                    exportAudioFullScreen,
	                    startBtn,
	                    backBtn,
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 3, src: playSrc, barWidth: width, handleAction: this.handleAction }),
	                    nextBtn,
	                    endBtn,
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 7, barWidth: width, handleAction: this.handleAction }),
	                    exportCartoonistFullScreen,
	                    _react2.default.createElement(_VolumeSlider.VolumeSlider, { dispatch: this.props.dispatch, visible: this.state.openVolumeSlider, type: 'audioToolPlayer', positionLeft: volumeSliderLeft }),
	                    slidesElement
	                )
	            ),
	            preloader
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var markerPosition = state.audioEditor.markerPosition;
	    var volume = state.audioEditor.volume;
	
	    if (!markerPosition) markerPosition = 0;
	
	    if (volume == undefined) volume = 0.5;
	
	    return {
	        markerPosition: markerPosition,
	        volume: volume
	    };
	}
	
	var ExportPlayer = exports.ExportPlayer = (0, _reactRedux.connect)(mapStateToProps)(ExportPlayerContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioTool/menus/ExportPlayer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioTool/menus/ExportPlayer.js"); } } })();

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Timelines = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AudioEditorTimeline = __webpack_require__(326);
	
	var _Ruler = __webpack_require__(327);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimelinesContent = _react2.default.createClass({
	    displayName: 'TimelinesContent',
	    getInitialState: function getInitialState() {
	        return {
	            elements: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.zoomValue != nextProps.zoomValue || this.props.accordionWidth != nextProps.accordionWidth || this.props.timelineWidth != nextProps.timelineWidth || this.props.windowHeight != nextProps.windowHeight) {
	            if (this.props.accordionWidth != nextProps.accordionWidth) this.recreateElements(false);else {
	                if (this.props.timelineWidth != nextProps.timelineWidth) this.recreateElements(true, true);else this.recreateElements(true);
	            }
	        }
	    },
	    recreateElements: function recreateElements() {
	        var updateScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        var useOldScrollPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        setTimeout(this.refreshNewContent, 50, updateScroll, useOldScrollPosition);
	    },
	    refreshNewContent: function refreshNewContent() {
	        var updateScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        var useOldScrollPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        this.initElements(updateScroll, useOldScrollPosition);
	    },
	    initElements: function initElements(updateScroll) {
	        var useOldScrollPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var totalWidth = this.props.timelineWidth;
	
	        var holderStyle = {
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            width: totalWidth
	        };
	
	        var holder = _react2.default.createElement(
	            'div',
	            { style: holderStyle, key: 'audioEditor' },
	            _react2.default.createElement(_Ruler.Ruler, { buttonsHolderWidth: this.props.buttonsHolderWidth, width: totalWidth, zoomValue: this.props.zoomValue, dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(_AudioEditorTimeline.AudioEditorTimeline, { buttonsHolderWidth: this.props.buttonsHolderWidth, width: totalWidth, zoomValue: this.props.zoomValue, dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight })
	        );
	
	        var elements = [holder];
	
	        this.setState({
	            elements: elements
	        });
	
	        if (updateScroll && !_PlatformDetection2.default.isIOS()) {
	            _PlayController2.default.updateScrollPosition(300, true);
	        }
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (!_StoreManager2.default.getState().currentSlide.isSlideCommand) this.props.dispatch((0, _CurrentSlideActions.setShortcutsTarget)(true));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.elements != nextState.elements || this.props.accordionWidth != newProps.accordionWidth || this.props.refreshAudioTrack != newProps.refreshAudioTrack || this.props.windowWidth != newProps.windowWidth || this.props.zoomValue != newProps.zoomValue || this.props.timelineWidth != newProps.timelineWidth || this.props.listHeight != newProps.listHeight) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.elements == undefined) return _react2.default.createElement('div', null);
	
	        var listWidth = this.props.windowWidth - this.props.accordionWidth - _AudioToolUtils2.default.buttonsHolderWidth();
	
	        var listStyle = {
	            width: listWidth,
	            height: this.props.listHeight,
	            position: 'absolute',
	            overflowY: 'hidden',
	            overflowX: 'hidden',
	            left: _AudioToolUtils2.default.buttonsHolderWidth(),
	            top: _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT,
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            WebkitTouchCallout: 'none',
	            userDrag: 'none'
	        };
	
	        var componentProperties = {};
	
	        componentProperties.paddingTop = _Properties2.default.SLIDE_VIEWER_TOP_GAP;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = listWidth;
	        componentProperties.height = this.props.listHeight;
	        componentProperties.top = 0;
	        componentProperties.displayState = 'block';
	        componentProperties.isHorizontal = true;
	        componentProperties.elements = this.state.elements;
	        componentProperties.id = 'slidesList';
	        componentProperties.isAudioEditor = true;
	        componentProperties.scrollWidth = this.props.timelineWidth;
	
	        if (componentProperties.scrollWidth > componentProperties.width) componentProperties.scrollWidth = componentProperties.scrollWidth + 2;
	
	        return _react2.default.createElement(
	            'div',
	            { style: listStyle, onClick: this.onClick },
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var accordionWidth = state.accordion.width;
	    var uuid = Math.random();
	    var zoomValue = state.audioEditor.zoomValue;
	    var timelineWidth = state.audioEditor.timelineWidth;
	    var refreshAudioTrack = state.audioEditor.refreshAudioTrack;
	
	    if (zoomValue == undefined) zoomValue = 4;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    return {
	        accordionWidth: accordionWidth,
	        uuid: uuid,
	        zoomValue: zoomValue,
	        timelineWidth: timelineWidth,
	        refreshAudioTrack: refreshAudioTrack
	    };
	}
	
	var Timelines = exports.Timelines = (0, _reactRedux.connect)(mapStateToProps)(TimelinesContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/audioTool/menus/Timelines.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/audioTool/menus/Timelines.js"); } } })();

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AdvancedSoundsBrowser = exports.AdvancedSoundsBrowserContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AudioCategorySelectorNew = __webpack_require__(169);
	
	var _SoundItemRenderer = __webpack_require__(138);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _PopulateMediaFilesUtils = __webpack_require__(80);
	
	var _PopulateMediaFilesUtils2 = _interopRequireDefault(_PopulateMediaFilesUtils);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _MusicActions = __webpack_require__(91);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioList = _react2.default.createClass({
	    displayName: 'AudioList',
	    getInitialState: function getInitialState() {
	        return {
	            elements: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var currentItem;
	        var nextItem;
	
	        if (this.props.dataProvider[0]) currentItem = this.props.dataProvider[0].title;
	
	        if (nextProps.dataProvider[0]) nextItem = nextProps.dataProvider[0].title;
	
	        if (currentItem != nextItem) this.recreateElements();
	    },
	    recreateElements: function recreateElements() {
	        setTimeout(this.refreshNewContent, 50);
	    },
	    refreshNewContent: function refreshNewContent() {
	        this.initElements();
	    },
	    initElements: function initElements() {
	        var elements = [];
	        var i;
	        var item;
	
	        for (i = 0; i < this.props.dataProvider.length; i++) {
	            item = this.props.dataProvider[i];
	            elements.push(_react2.default.createElement(_SoundItemRenderer.SoundItemRenderer, { accordionWidth: this.props.accordionWidth, categoryIndex: this.props.categoryIndex, index: i, key: 'audioBrowser' + item.title + '_' + Math.random(), dispatch: this.props.dispatch, value: item }));
	        }
	
	        this.setState({
	            elements: elements
	        });
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.elements != nextState.elements || this.props.secondCategoryVisible != newProps.secondCategoryVisible || this.props.windowHeight != newProps.windowHeight || this.props.dataProvider != newProps.dataProvider) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.elements == undefined) return _react2.default.createElement('div', null);
	
	        var categoryHeight = 0;
	        var topPosition = this.props.buttonsHeight;
	        var bottomPadding = 8;
	        var topPadding = _Properties2.default.CATEGORY_SELECTOR_GAP;
	        var topButtonsPosition = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	        if (_PlatformDetection2.default.isIOS()) {
	            topButtonsPosition = 3 * _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        }
	
	        if (this.props.categoryVisible == true) {
	            categoryHeight = _Properties2.default.CATEGORY_SELECTOR_HEIGHT;
	            topPosition = topPosition + categoryHeight;
	            topPadding = 0;
	        }
	
	        topPosition = topPosition + topPadding;
	        var uploadButtonHeight = 0;
	
	        if (this.props.showUploadButton) {
	            uploadButtonHeight = 50;
	            topPosition = topPosition + uploadButtonHeight;
	        }
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = this.props.height - categoryHeight - bottomPadding - 3 * _Properties2.default.BROWSER_BUTTON_HEIGHT - topPadding - uploadButtonHeight;
	        componentProperties.top = topPosition;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = this.state.elements;
	        componentProperties.isAudioEditor = true;
	        componentProperties.extraTopPadding = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        componentProperties.scrollHeight = (_Properties2.default.SOUND_ITEM_HEIGHT + _Properties2.default.SOUND_ITEMS_GAP) * this.state.elements.length;
	
	        return _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties });
	    }
	});
	
	var TabElement = _react2.default.createClass({
	    displayName: 'TabElement',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        var state = _StoreManager2.default.getState();
	        var selectedIndex = state.music.mainAudioCategoryIndex;
	
	        if (this.props.index == selectedIndex) dispatch((0, _MusicActions.changeMainAudioCategoryIndex)(-1));else dispatch((0, _MusicActions.changeMainAudioCategoryIndex)(this.props.index));
	    },
	    render: function render() {
	
	        var topPosition = this.props.topPosition;
	        var buttonColor;
	        var textColor;
	        var icon;
	        var iconColor;
	
	        if (this.props.index == this.props.selectedIndex) {
	            buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            textColor = '#F7F7F7';
	            icon = 'fa fa-angle-down';
	            iconColor = 'white';
	        } else {
	            icon = 'fa fa-angle-right';
	            iconColor = 'black';
	
	            if (this.state.isOver == true) {
	                buttonColor = _Properties2.default.BROWSER_HOVER_COLOR;
	                textColor = '#2299D6';
	            } else {
	                buttonColor = _Properties2.default.BROWSER_COLOR;
	                textColor = '#000000';
	            }
	        }
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth - 1,
	            height: _Properties2.default.BROWSER_BUTTON_HEIGHT,
	            top: topPosition,
	            color: 'white',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            textAlign: 'left',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 5,
	            left: _Properties2.default.BROWSER_LEFT_PADDING,
	            color: textColor,
	            fontSize: 15,
	            width: this.props.accordionWidth - 4 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 6,
	            right: _Properties2.default.BROWSER_ICON_RIGHT_PADDING,
	            color: iconColor
	        };
	
	        var topLine = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: tabStyle.width,
	            height: 1,
	            background: 'white'
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': this.props.title, style: tabStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement('div', { style: topLine }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.title
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: icon })
	        );
	    }
	});
	
	var AdvancedSoundsBrowserContent = exports.AdvancedSoundsBrowserContent = _react2.default.createClass({
	    displayName: 'AdvancedSoundsBrowserContent',
	    getInitialState: function getInitialState() {
	        return {
	            isMyMediaFilesCallDone: false
	        };
	    },
	    getClipartModel: function getClipartModel() {
	        var clipartModel = _StoreManager2.default.getState().music.soundClipartModel;
	        return clipartModel;
	    },
	    getMySoundsCategories: function getMySoundsCategories() {
	        var dataProvider = [];
	
	        dataProvider.push(_LocalesManager2.default.getCaption('UploadedSounds', 'music'));
	        dataProvider.push(_LocalesManager2.default.getCaption('RecordedSounds', 'music'));
	
	        return dataProvider;
	    },
	    getSelectorDataProvider: function getSelectorDataProvider(type) {
	        var clipartModel = this.getClipartModel();
	
	        if (!clipartModel) return [];
	
	        var clipartModelItems = clipartModel.items;
	        var dataProvider = [];
	        var i;
	
	        if (type == 'main') {
	            dataProvider.push(clipartModelItems[0].title);
	            dataProvider.push(clipartModelItems[1].title);
	            dataProvider.push(_LocalesManager2.default.getCaption('MySoundsContent', 'music'));
	        } else {
	            var mainIndex = this.getSelectedIndex('main');
	
	            if (mainIndex >= 0) {} else mainIndex = 0;
	
	            var itemsObject = clipartModelItems[mainIndex];
	
	            if (itemsObject === undefined) return dataProvider;
	
	            var subcategoryItems = itemsObject.items;
	
	            for (i = 0; i < subcategoryItems.length; i++) {
	                dataProvider.push(subcategoryItems[i].title);
	            }
	        }
	
	        return dataProvider;
	    },
	    getSelectedIndex: function getSelectedIndex(type) {
	        var index;
	
	        if (type == 'main') {
	            index = this.props.mainAudioCategoryIndex;
	        } else {
	            index = this.props.secondAudioCategoryIndex;
	        }
	
	        if (index == undefined || isNaN(index)) index = 0;
	
	        return index;
	    },
	    getMusicDataProvider: function getMusicDataProvider(mainIndex) {
	        var clipartModel = this.getClipartModel();
	
	        if (!clipartModel) return [];
	
	        var clipartModelItems = clipartModel.items;
	
	        if (clipartModelItems == undefined) return [];
	
	        if (mainIndex == -1) return [];
	
	        var secondIndex = this.getSelectedIndex('second');
	        var subcategoryItems = clipartModelItems[mainIndex].items;
	
	        if (subcategoryItems == undefined) return [];
	
	        var dataProvider = [];
	        var contentItems = subcategoryItems[secondIndex].items;
	        var i;
	
	        for (i = 0; i < contentItems.length; i++) {
	            dataProvider.push(contentItems[i]);
	        }
	
	        return dataProvider;
	    },
	    filterMySounds: function filterMySounds(dataProvider) {
	        var category = this.getSelectedIndex('second');
	        var i;
	        var array = [];
	
	        for (i = 0; i < dataProvider.length; i++) {
	            if (category == 1) {
	                // recorded sounds
	                if (dataProvider[i].isRecordedSound) array.push(dataProvider[i]);
	            } else {
	                if (!dataProvider[i].isRecordedSound) array.push(dataProvider[i]);
	            }
	        }
	
	        return array;
	    },
	    getMySoundsDataProvider: function getMySoundsDataProvider() {
	        var dataProvider = this.props.mediaFilesDataProvider;
	
	        if (dataProvider && dataProvider.soundsDataProvider && dataProvider.soundsDataProvider.length > 0) return this.filterMySounds(dataProvider.soundsDataProvider);else {
	            if (this.state.isMyMediaFilesCallDone == true) return [];
	
	            setTimeout(this.loadData, 2);
	
	            return [];
	        }
	    },
	    loadData: function loadData() {
	        if (_Configuration2.default.LOAD_LOCAL == true) {
	            // FOR TEST
	            this.props.dispatch((0, _AccordionActions.setMediaFilesDataProvider)({ imagesDataProvider: _PopulateMediaFilesUtils2.default.getImagesDataProviderForTest(), soundsDataProvider: _PopulateMediaFilesUtils2.default.getSoundsDataProviderForTest() }));
	        } else {
	            this.setState({ isMyMediaFilesCallDone: true });
	            _ApiServiceUtils2.default.executeSafeApiCall(this.loadMyMediaFiles.bind(this));
	        }
	    },
	    loadMyMediaFiles: function loadMyMediaFiles() {
	        _ApiServiceUtils2.default.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
	    },
	    parseMediaItems: function parseMediaItems(items) {
	        _PopulateMediaFilesUtils2.default.parseMediaItems(items, this.props.dispatch, true);
	        this.setState({ isMyMediaFilesCallDone: false });
	    },
	    category: function category() {
	        if (this.props.mainAudioCategoryIndex == undefined) return -1;else return this.props.mainAudioCategoryIndex;
	    },
	    getContentDataProvider: function getContentDataProvider() {
	        var category = this.category();
	
	        if (category == 0 || category == 1) return this.getMusicDataProvider(category);else return this.getMySoundsDataProvider();
	    },
	    isCategoryVisible: function isCategoryVisible() {
	        var category = this.category();
	
	        if (category == 0 || category == 1) return true;else return false;
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var target = e.target;
	        if (this.hasParentWithId(target, 'categorySelector', 7) == false) {
	            this.props.dispatch((0, _MenuActions.expandAudioList)(false, 'all'));
	        }
	
	        setTimeout(this.refreshView, 5);
	    },
	    hasParentWithId: function hasParentWithId(target, parentId, level) {
	        if (target.id == parentId) return true;
	
	        var i;
	
	        for (i = 0; i < level; i++) {
	            if (target.parentNode == undefined) {
	                return false;
	            } else {
	                target = target.parentNode;
	
	                if (target.id == parentId) return true;
	            }
	        }
	
	        return false;
	    },
	    getTabTopPosition: function getTabTopPosition(index, length, selectedIndex) {
	        var topPosition = _Properties2.default.BROWSER_BUTTON_HEIGHT * index;
	        var clipartButtonHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	        if (_AudioToolUtils2.default.isAudioTool()) clipartButtonHeight = 0;
	
	        if (selectedIndex != 0 && selectedIndex != 1 && selectedIndex != 2) {
	            topPosition = index * _Properties2.default.BROWSER_BUTTON_HEIGHT;
	        } else {
	            if (index <= selectedIndex) topPosition = index * _Properties2.default.BROWSER_BUTTON_HEIGHT;else topPosition = this.props.windowHeight - clipartButtonHeight - _Properties2.default.BROWSER_BUTTON_HEIGHT * (length - index);
	        }
	
	        return topPosition;
	    },
	    refreshView: function refreshView() {
	        this.forceUpdate();
	    },
	    onUpload: function onUpload(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        window.parent.postMessage('openUploader', '*');
	    },
	    onMouseIn: function onMouseIn() {
	        var button = document.getElementById('uploadButton');
	        _HoverManager2.default.show(button, 'uploadButton');
	    },
	    onMouseOut: function onMouseOut() {
	        _HoverManager2.default.hide();
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.mediaFilesDataProvider != newProps.mediaFilesDataProvider || this.props.musicContentIndex != newProps.musicContentIndex || this.props.secondAudioCategoryIndex != newProps.secondAudioCategoryIndex || this.props.mainAudioCategoryIndex != newProps.mainAudioCategoryIndex || this.props.secondAudioCategoryIsExpanded != newProps.secondAudioCategoryIsExpanded || this.props.accordionWidth != newProps.accordionWidth || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.mainAudioCategoryIsExpanded != newProps.mainAudioCategoryIsExpanded) return true;else return false;
	    },
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            top: this.props.top,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.height,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white',
	            outlineColor: 'white',
	            outlineWidth: 1,
	            outlineStyle: 'solid'
	        };
	
	        if (_AudioToolUtils2.default.isAudioTool()) menuStyle.outlineWidth = 0;
	
	        var leftPosition = 0;
	
	        if (this.props.accordionWidth > _Properties2.default.BROWSER_WIDTH) leftPosition = (this.props.accordionWidth - _Properties2.default.BROWSER_WIDTH) / 2;
	
	        var elementsHolder = {
	            position: 'absolute',
	            top: 0,
	            left: leftPosition,
	            width: this.props.accordionWidth,
	            height: this.props.height,
	            cursor: 'default',
	            overflowX: 'auto',
	            overflowY: 'hidden'
	        };
	
	        var mainDataProvider = this.getSelectorDataProvider('main');
	        var i;
	        var tabs = [];
	
	        for (i = 0; i < mainDataProvider.length; i++) {
	            tabs.push(_react2.default.createElement(TabElement, { key: 'tabElement_' + i, accordionWidth: this.props.accordionWidth, topPosition: this.getTabTopPosition(i, mainDataProvider.length, this.props.mainAudioCategoryIndex), title: mainDataProvider[i], index: i, selectedIndex: this.props.mainAudioCategoryIndex, windowHeight: this.props.windowHeight }));
	        }
	
	        var list;
	        var categorySelector;
	        var uploadButton;
	
	        if (this.props.mainAudioCategoryIndex == 0 || this.props.mainAudioCategoryIndex == 1 || this.props.mainAudioCategoryIndex == 2) {
	            var buttonsHeight = (this.props.mainAudioCategoryIndex + 1) * _Properties2.default.BROWSER_BUTTON_HEIGHT;
	            var dataProvider = this.props.mainAudioCategoryIndex == 2 ? this.getMySoundsCategories() : this.getSelectorDataProvider('second');
	            var showUploadButton = !_PlatformDetection2.default.isIOSApp() && this.props.mainAudioCategoryIndex == 2 && (!this.props.secondAudioCategoryIndex || this.props.secondAudioCategoryIndex == 0);
	
	            list = _react2.default.createElement(AudioList, { accordionWidth: _Properties2.default.BROWSER_WIDTH, showUploadButton: showUploadButton, buttonsHeight: buttonsHeight, categoryVisible: true, height: this.props.height, categoryIndex: this.props.mainAudioCategoryIndex, windowHeight: this.props.windowHeight, dispatch: this.props.dispatch, dataProvider: this.getContentDataProvider() });
	            categorySelector = _react2.default.createElement(_AudioCategorySelectorNew.AudioCategorySelectorNew, { top: buttonsHeight, accordionWidth: _Properties2.default.BROWSER_WIDTH, type: 'second', isAdvancedMenu: true, visible: true, isExpanded: this.props.secondAudioCategoryIsExpanded, selectedIndex: this.getSelectedIndex('second'), dataProvider: dataProvider, dispatch: this.props.dispatch });
	
	            if (showUploadButton) {
	                if (_PlatformDetection2.default.isIOS()) {
	                    var uploadIconStyle = {
	                        position: 'absolute',
	                        top: 145,
	                        left: _Properties2.default.BROWSER_WIDTH / 2 - 42 / 2,
	                        color: '#2DE102'
	                    };
	
	                    uploadButton = _react2.default.createElement('i', { id: 'uploadButton', style: uploadIconStyle, className: 'fa fa-plus-circle fa-3x', onMouseDown: this.onUpload, onTouchStart: this.onUpload, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut });
	                } else {
	                    var uploadButtonStyle = {
	                        position: 'absolute',
	                        top: 145,
	                        left: _Properties2.default.BROWSER_WIDTH / 2 - 42 / 2,
	                        margin: 0,
	                        padding: 0,
	                        boxSizing: 'initial',
	                        fontSize: 'initial',
	                        borderStyle: 'none',
	                        width: 41,
	                        height: 48,
	                        background: 'none'
	                    };
	
	                    var uploadIconPlusStyle = {
	                        position: 'absolute',
	                        top: 0,
	                        left: 0,
	                        color: '#2DE102'
	                    };
	
	                    uploadButton = _react2.default.createElement(
	                        'button',
	                        { id: 'uploadButton', 'aria-label': _LocalesManager2.default.getCaption('UploadHover', 'myFiles'), style: uploadButtonStyle, onClick: this.onUpload, onTouchStart: this.onUpload, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	                        _react2.default.createElement('i', { style: uploadIconPlusStyle, className: 'fa fa-plus-circle fa-3x' })
	                    );
	                }
	            }
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { ref: 'audioBrowser', style: menuStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement(
	                'div',
	                { style: elementsHolder },
	                tabs,
	                categorySelector,
	                uploadButton,
	                list
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	
	    var mainAudioCategoryIsExpanded = state.menu.mainAudioCategoryIsExpanded;
	    var secondAudioCategoryIsExpanded = state.menu.secondAudioCategoryIsExpanded;
	    var mainAudioCategoryIndex = state.music.mainAudioCategoryIndex;
	    var secondAudioCategoryIndex = state.music.secondAudioCategoryIndex;
	    var musicContentIndex = state.music.musicContentIndex;
	    var mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
	
	    return {
	        mainAudioCategoryIsExpanded: mainAudioCategoryIsExpanded,
	        secondAudioCategoryIsExpanded: secondAudioCategoryIsExpanded,
	        mainAudioCategoryIndex: mainAudioCategoryIndex,
	        secondAudioCategoryIndex: secondAudioCategoryIndex,
	        musicContentIndex: musicContentIndex,
	        mediaFilesDataProvider: mediaFilesDataProvider
	    };
	}
	
	var AdvancedSoundsBrowser = exports.AdvancedSoundsBrowser = (0, _reactRedux.connect)(mapStateToProps)(AdvancedSoundsBrowserContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AdvancedSoundsBrowser.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AdvancedSoundsBrowser.js"); } } })();

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AlternativeTextForSlideMenu = exports.AlternativeTextForSlideMenuContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _reactRedux = __webpack_require__(10);
	
	var _MenuActions = __webpack_require__(7);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onButtonClick: function onButtonClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.index == 1) {
	            // OK button
	            var textInput = document.getElementById('alternativeTextInput');
	
	            if (textInput && textInput.value.length > 0) this.props.dispatch((0, _CurrentSlideActions.changeAlternativeText)(textInput.value));else this.props.dispatch((0, _CurrentSlideActions.changeAlternativeText)(''));
	        }
	
	        this.props.dispatch((0, _MenuActions.showAlternativeTextMenu)(false));
	    },
	    render: function render() {
	        var textColor;
	        var fillColor;
	
	        if (this.state.isOver == true) {
	            fillColor = _Properties2.default.SLIDE_VIEWER_BACKGROUND;
	            textColor = 'black';
	        } else {
	            textColor = 'black';
	            fillColor = '#f2f2f2';
	        }
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: fillColor,
	            width: _Properties2.default.DELETE_ALERT_BUTTON_WIDTH,
	            height: _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT,
	            top: this.props.topPosition,
	            left: this.props.leftPosition,
	            borderRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#333333'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 6,
	            fontSize: 16,
	            width: _Properties2.default.DELETE_ALERT_BUTTON_WIDTH - 6,
	            whiteSpace: 'nowrap',
	            display: 'block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            alignItems: 'center',
	            textAlign: 'center',
	            cursor: 'default',
	            color: textColor
	        };
	
	        var buttonId = this.props.index == 1 ? 'alternativeTextOkButton' : undefined;
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': this.props.text, id: buttonId, style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onButtonClick, onClick: this.onButtonClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var AlternativeTextForSlideMenuContent = exports.AlternativeTextForSlideMenuContent = _react2.default.createClass({
	    displayName: 'AlternativeTextForSlideMenuContent',
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps && nextProps.showAlternativeTextMenu == true && this.props.showAlternativeTextMenu != nextProps.showAlternativeTextMenu) {
	            setTimeout(function () {
	                this.changeFocus();
	            }.bind(this), 10);
	        }
	    },
	    getInitialState: function getInitialState() {
	        this.changeSelection();
	
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onInputClick: function onInputClick() {
	        this.changeFocus();
	    },
	    changeFocus: function changeFocus() {
	        var view = this.refs.alternativeTextInput;
	
	        if (view) view.focus();
	    },
	    getDefaultTitle: function getDefaultTitle() {
	        if (this.props.alternativeText) return this.props.alternativeText;else return '';
	    },
	    changeSelection: function changeSelection() {
	        if (_PlatformDetection2.default.isIOSApp()) return;
	
	        setTimeout(function () {
	            if (this.refs.alternativeTextInput) {
	                this.refs.alternativeTextInput.focus();
	                this.refs.alternativeTextInput.setSelectionRange(0, 100);
	            }
	        }.bind(this), 100);
	    },
	    render: function render() {
	        var visible = 'none';
	
	        if (this.props.showAlternativeTextMenu == true) visible = 'block';else return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            left: 0,
	            display: visible,
	            zIndex: 20000
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: 0,
	            left: 0,
	            opacity: _Properties2.default.DELETE_ALERT_BACKGROUND_OPACITY
	        };
	
	        var bottomBarHeight = 120;
	        var alertWidth = this.props.windowWidth * 0.8;
	        var alertHolderStyle = {
	            position: 'absolute',
	            top: 200,
	            left: this.props.windowWidth / 2 - alertWidth / 2
	        };
	
	        var topBarStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: alertWidth,
	            height: _Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT,
	            top: 0,
	            left: 0,
	            borderTopLeftRadius: 3,
	            borderTopRightRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: _Properties2.default.DELETE_ALERT_BACKGROUND
	        };
	
	        var bottomBarStyle = {
	            position: 'absolute',
	            backgroundColor: 'white',
	            width: alertWidth,
	            height: bottomBarHeight,
	            top: _Properties2.default.DELETE_ALERT_TOP_BAR_HEIGHT,
	            left: 0,
	            borderBottomLeftRadius: 3,
	            borderBottomRightRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: 'white'
	        };
	
	        var paddingLeft = 15;
	        var titleStyle = {
	            position: 'absolute',
	            left: paddingLeft,
	            top: 7,
	            fontSize: 20,
	            width: alertWidth - 2 * _Properties2.default.DELETE_ALERT_BUTTON_GAP,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            color: 'white'
	        };
	
	        var borderColor;
	        var textColor;
	
	        if (this.state.isOver == true) {
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            textColor = borderColor;
	        } else {
	            borderColor = 'black';
	            textColor = 'black';
	        }
	
	        var inputHolderStyle = {
	            width: topBarStyle.width - 2 * paddingLeft,
	            height: 30,
	            background: 'white',
	            position: 'absolute',
	            left: paddingLeft,
	            top: paddingLeft,
	            borderColor: borderColor,
	            borderWidth: 2,
	            borderStyle: 'solid',
	            alignItems: 'center',
	            border: 'none'
	        };
	
	        var inputStyle = {
	            position: 'absolute',
	            color: textColor,
	            top: 5,
	            paddingLeft: 10,
	            fontSize: 17,
	            width: inputHolderStyle.width - 2 * 10,
	            resize: 'none',
	            overflow: 'hidden',
	            background: 'transparent',
	            borderColor: borderColor,
	            borderRadius: 5
	        };
	
	        if (_PlatformDetection2.default.isIOS()) inputStyle.top = -3;
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, role: 'dialog', id: 'alternativeTextAlert' },
	            _react2.default.createElement('div', { style: backgroundStyle }),
	            _react2.default.createElement(
	                'div',
	                { style: alertHolderStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: topBarStyle },
	                    _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'alternativeTextInput', style: titleStyle },
	                        _LocalesManager2.default.getCaption('AlternativeTextMenuTitle', 'other')
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: bottomBarStyle },
	                    _react2.default.createElement(
	                        'div',
	                        { style: inputHolderStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onInputClick },
	                        _react2.default.createElement('input', { type: 'text', ref: 'alternativeTextInput', id: 'alternativeTextInput', className: 'titleInput', style: inputStyle, defaultValue: this.getDefaultTitle(), spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off' })
	                    ),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 0, topPosition: bottomBarHeight - paddingLeft - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT, leftPosition: bottomBarStyle.width - 2 * _Properties2.default.DELETE_ALERT_BUTTON_WIDTH - 2 * paddingLeft, text: _LocalesManager2.default.getCaption('Cancel', 'save') }),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 1, topPosition: bottomBarHeight - paddingLeft - _Properties2.default.DELETE_ALERT_BUTTON_HEIGHT, leftPosition: bottomBarStyle.width - _Properties2.default.DELETE_ALERT_BUTTON_WIDTH - paddingLeft, text: 'OK' })
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var showAlternativeTextMenu = state.menu.showAlternativeTextMenu;
	    var alternativeText = state.currentSlide.model.alternativeText;
	
	    return {
	        showAlternativeTextMenu: showAlternativeTextMenu,
	        alternativeText: alternativeText
	    };
	}
	
	var AlternativeTextForSlideMenu = exports.AlternativeTextForSlideMenu = (0, _reactRedux.connect)(mapStateToProps)(AlternativeTextForSlideMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AlternativeTextForSlideMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AlternativeTextForSlideMenu.js"); } } })();

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AnimationContextMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _SizeAndPositionButtons = __webpack_require__(92);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            position: 'absolute',
	            top: 6,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                _LocalesManager2.default.getCaption('AnimationMenuTitle', 'other')
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.index == 1 && _AnimationManager2.default.target && !_AnimationManager2.default.target.animation) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    _AnimationManager2.default.clearAnimationsInEditMode();
	                    _AnimationManager2.default.addAnimation();
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	
	            case 1:
	                {
	                    _AnimationManager2.default.clearAnimationsInEditMode();
	                    _AnimationManager2.default.deleteAnimation();
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	
	            case 2:
	                {
	                    _AnimationManager2.default.clearAnimationsInEditMode(true);
	                    _AnimationManager2.default.exitAnimationMode();
	                    break;
	                }
	        }
	    },
	    render: function render() {
	        var iconColor;
	        var buttonColor;
	        var buttonHeight = 50;
	        var opacity = 1;
	        var tabIndexValue;
	
	        if (this.props.index == 0) {
	            if (this.state.isOver == true) {
	                iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	            } else {
	                iconColor = 'black';
	                buttonColor = '#48A5E5';
	            }
	        } else if (this.props.index == 1 && _AnimationManager2.default.target && !_AnimationManager2.default.target.animation) {
	            opacity = 0.5;
	            buttonColor = 'gainsboro';
	            tabIndexValue = '-1';
	        } else {
	            if (this.state.isOver == true) {
	                iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	            } else {
	                iconColor = 'black';
	                buttonColor = '#DCDCDC';
	            }
	        }
	
	        var topPosition = this.props.windowHeight - (buttonHeight + 5) * (3 - this.props.index);
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth,
	            height: buttonHeight,
	            top: topPosition,
	            display: 'flex',
	            opacity: opacity,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            fontSize: 18,
	            textAlign: 'center',
	            width: buttonStyle.width,
	            paddingTop: 14,
	            top: 0
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { id: this.props.id, 'aria-label': this.props.text, tabIndex: tabIndexValue, 'aria-disabled': tabIndexValue == '-1' ? true : false, style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var AnimationContextMenuContent = _react2.default.createClass({
	    displayName: 'AnimationContextMenuContent',
	    getInitialState: function getInitialState() {
	        var rotationType = 1;
	        var targets = this.getTargets();
	
	        if (_AnimationManager2.default.target && _AnimationManager2.default.target.rotationType > 0) rotationType = _AnimationManager2.default.target.rotationType;
	
	        return {
	            selectedFrame: targets.length - 1,
	            targets: targets,
	            rotationType: rotationType
	        };
	    },
	    getTargets: function getTargets() {
	        var animationTargets = _AnimationManager2.default.getAllAnimationTargets();
	        var targets = [];
	        var target = void 0;
	        var item = void 0;
	
	        for (var i = 0; i < animationTargets.length; i++) {
	            target = animationTargets[i];
	
	            item = {};
	            item.x = target.x;
	            item.y = target.y;
	            item.width = target.width;
	            item.height = target.height;
	            item.opacity = target.opacity * 100;
	            item.rotation = target.rotation;
	            item.uuid = target.uuid;
	            targets.push(item);
	        }
	
	        return targets;
	    },
	    getSelectedFrame: function getSelectedFrame(targets, refreshValue) {
	        if (refreshValue && refreshValue.indexOf('_') !== -1) {
	            var uuid = refreshValue.split('_')[0];
	
	            for (var i = 0; i < targets.length; i++) {
	                if (targets[i].uuid === uuid) return i;
	            }
	
	            return this.state.selectedFrame;
	        } else return this.state.selectedFrame;
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.refreshShapePosition != nextProps.refreshShapePosition) {
	            var targets = this.getTargets();
	            var selectedFrame = void 0;
	
	            if (targets.length - 1 < this.state.selectedFrame) selectedFrame = targets.length - 1;else selectedFrame = this.getSelectedFrame(targets, nextProps.refreshShapePosition);
	
	            this.setState({
	                targets: this.getTargets(),
	                selectedFrame: selectedFrame
	            });
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('animationFirstFocusableObject');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    getShapeByIndex: function getShapeByIndex(index) {
	        var animationTargets = _AnimationManager2.default.getAllAnimationTargets();
	
	        return animationTargets[index];
	    },
	    getCurrentShape: function getCurrentShape() {
	        return this.getShapeByIndex(this.state.selectedFrame);
	    },
	    save: function save() {
	        _AnimationManager2.default.addAnimation(true);
	    },
	    onOpacityChange: function onOpacityChange(value) {
	        var opacity = parseInt(value);
	
	        if (isNaN(opacity)) opacity = 0;
	
	        if (opacity <= 100) {
	            var dispatch = _StoreManager2.default.getStore().dispatch;
	            var newState = Object.assign({}, this.state);
	            newState.targets[this.state.selectedFrame].opacity = opacity;
	            this.setState(newState);
	            dispatch((0, _CurrentSlideActions.changeShapeOpacity)(this.getCurrentShape(), opacity / 100));
	            this.save();
	        }
	    },
	    onPositionChange: function onPositionChange(x, y) {
	        x = parseInt(x);
	        y = parseInt(y);
	
	        var uuid = this.getCurrentShape().uuid;
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        var newState = Object.assign({}, this.state);
	        newState.targets[this.state.selectedFrame].x = x;
	        newState.targets[this.state.selectedFrame].y = y;
	        this.setState(newState);
	        dispatch((0, _CurrentSlideActions.updateShapePosition)(uuid, x, y));
	        this.save();
	    },
	    onRotationChange: function onRotationChange(rotation) {
	        rotation = parseInt(rotation);
	
	        if (rotation >= 0) {
	            var dispatch = _StoreManager2.default.getStore().dispatch;
	            var newState = Object.assign({}, this.state);
	            newState.targets[this.state.selectedFrame].rotation = rotation;
	            this.setState(newState);
	            dispatch((0, _CurrentSlideActions.updateShapeRotation)(this.getCurrentShape().uuid, rotation));
	            this.save();
	        }
	    },
	    onZoom: function onZoom(type) {
	        var shapeModel = this.getCurrentShape();
	        var hasChanged = false;
	
	        var aspectRatio = shapeModel.height / shapeModel.width;
	        var newHeight = shapeModel.height;
	        var newWidth = shapeModel.width;
	
	        if (type === "in") {
	            if (shapeModel.width > 10 && shapeModel.height > aspectRatio * 10) {
	                newWidth = shapeModel.width - 10;
	                newHeight = shapeModel.height - aspectRatio * 10;
	                hasChanged = true;
	            }
	        } else {
	            //out
	            newWidth = shapeModel.width + 10;
	            newHeight = shapeModel.height + aspectRatio * 10;
	            hasChanged = true;
	        }
	
	        if (hasChanged) {
	            var dispatch = _StoreManager2.default.getStore().dispatch;
	            var newState = Object.assign({}, this.state);
	            newState.targets[this.state.selectedFrame].width = newWidth;
	            newState.targets[this.state.selectedFrame].height = newHeight;
	            this.setState(newState);
	            dispatch((0, _CurrentSlideActions.updateShapeSize)(shapeModel.uuid, newWidth, newHeight, shapeModel.x, shapeModel.y));
	            this.save();
	        }
	    },
	    onClickPrimaryButton: function onClickPrimaryButton(type) {
	        if (type === this.state.selectedFrame) return;
	
	        this.setState({
	            selectedFrame: type
	        });
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        var animationTargets = _AnimationManager2.default.getAllAnimationTargets();
	
	        if (animationTargets[type]) dispatch((0, _CurrentSlideActions.selectShape)(animationTargets[type].uuid));
	    },
	    onRotationTypeClick: function onRotationTypeClick(type) {
	        _AnimationManager2.default.rotationType = type;
	
	        if (type === 0 || type === 1 || type === 2) _AnimationManager2.default.deleteClones(true);
	
	        this.setState({
	            rotationType: type
	        });
	    },
	    render: function render() {
	        if (this.props.contextMode != _ModeConstants2.default.ANIMATION_CONTEXT) return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white',
	            cursor: 'default'
	        };
	
	        var wrapper = {
	            height: this.props.windowHeight - 165,
	            overflowY: 'auto',
	            overflowX: 'hidden'
	        };
	
	        var inputAreaStyle = {
	            marginTop: '40px',
	            padding: '0 8px'
	        };
	
	        var currentShape = this.getCurrentShape();
	        var opacity = currentShape.opacity * 100;
	        var rotation = currentShape.rotation;
	
	        var smallTextStyle = {
	            fontSize: '12px',
	            textAlign: 'center'
	        };
	
	        var buttonWrapperStyle = {
	            display: 'flex',
	            flexWrap: 'wrap',
	            marginTop: '10px',
	            justifyContent: 'space-between'
	        };
	
	        var topButtonsWrapperStyle = {
	            display: 'block',
	            marginTop: '10px'
	        };
	
	        var lineStyle = {
	            width: '100%',
	            height: 1,
	            background: 'black',
	            marginTop: 5
	        };
	
	        var targets = this.state.targets;
	        var letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
	        var buttons = [];
	        var id = void 0;
	        var i = void 0;
	
	        for (i = 0; i < targets.length; i++) {
	            if (i === 0) id = 'animationFirstFocusableObject';
	
	            buttons.push(_react2.default.createElement(_SizeAndPositionButtons.PrimaryMenuButton, { id: id, clickHandler: this.onClickPrimaryButton,
	                type: i, isToggleButton: true, isSelected: this.state.selectedFrame === i, caption: letters[i], key: 'primary_' + i, targets: targets.length }));
	        }
	
	        var rotationButtonsWrapperStyle = {
	            display: 'flex',
	            flexWrap: 'wrap',
	            justifyContent: 'space-between'
	        };
	
	        var rotationButtons = [];
	
	        for (i = 0; i < 4; i++) {
	            rotationButtons.push(_react2.default.createElement(_SizeAndPositionButtons.PrimaryMenuButton, { clickHandler: this.onRotationTypeClick,
	                type: i, isToggleButton: true, isSelected: this.state.rotationType === i, caption: letters[i], key: 'rotationType_' + i, targets: 4 }));
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'animationMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(
	                'div',
	                { style: wrapper },
	                _react2.default.createElement(
	                    'div',
	                    { style: inputAreaStyle },
	                    _react2.default.createElement(
	                        'h3',
	                        { style: smallTextStyle },
	                        _LocalesManager2.default.getCaption('SelectFrame', 'advancedMenu')
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: topButtonsWrapperStyle },
	                        buttons
	                    ),
	                    _react2.default.createElement('div', { style: lineStyle }),
	                    _react2.default.createElement(
	                        'h3',
	                        { style: smallTextStyle },
	                        _LocalesManager2.default.getCaption('Opacity', 'advancedMenu')
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: buttonWrapperStyle },
	                        _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true,
	                            labelText: _LocalesManager2.default.getCaption('OpacityValue', 'advancedMenu') + '(0-100)',
	                            value: opacity, onChangeHandler: this.onOpacityChange })
	                    ),
	                    _react2.default.createElement('div', { style: lineStyle }),
	                    _react2.default.createElement(
	                        'h3',
	                        { style: smallTextStyle },
	                        _LocalesManager2.default.getCaption('Position', 'advancedMenu')
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: buttonWrapperStyle },
	                        _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Xposition', 'advancedMenu'),
	                            value: currentShape.x, yValue: currentShape.y,
	                            onChangeHandler: this.onPositionChange }),
	                        _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Yposition', 'advancedMenu'),
	                            value: currentShape.y, xValue: currentShape.x,
	                            onChangeHandler: this.onPositionChange })
	                    ),
	                    _react2.default.createElement('div', { style: lineStyle }),
	                    _react2.default.createElement(
	                        'h3',
	                        { style: smallTextStyle },
	                        _LocalesManager2.default.getCaption('Zoom', 'advancedMenu')
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: buttonWrapperStyle },
	                        _react2.default.createElement(_SizeAndPositionButtons.SecondaryMenuButton, { clickHandler: this.onZoom, type: 'in',
	                            caption: _LocalesManager2.default.getCaption('ZoomIn', 'advancedMenu') }),
	                        _react2.default.createElement(_SizeAndPositionButtons.SecondaryMenuButton, { clickHandler: this.onZoom, type: 'out',
	                            caption: _LocalesManager2.default.getCaption('ZoomOut', 'advancedMenu') })
	                    ),
	                    window.location.href.indexOf('stage') !== -1 || window.location.href.indexOf('localhost') !== -1 ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('div', { style: lineStyle }),
	                        _react2.default.createElement(
	                            'h3',
	                            { style: smallTextStyle },
	                            _LocalesManager2.default.getCaption('Rotation', 'sizePosMenu')
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: buttonWrapperStyle },
	                            _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true,
	                                labelText: _LocalesManager2.default.getCaption('SetRotationInDegrees', 'sizePosMenu'),
	                                value: rotation, onChangeHandler: this.onRotationChange })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: rotationButtonsWrapperStyle },
	                            rotationButtons
	                        )
	                    ) : null
	                )
	            ),
	            _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight, index: 0,
	                text: _LocalesManager2.default.getCaption('Ok', 'other') }),
	            _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight, index: 1,
	                text: _LocalesManager2.default.getCaption('Delete', 'other') }),
	            _react2.default.createElement(Button, { id: 'animationMenuLastFocusableObject', accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight, index: 2, text: _LocalesManager2.default.getCaption('Cancel', 'other') })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var refreshShapePosition = state.menu.refreshShapePosition;
	
	    return {
	        refreshShapePosition: refreshShapePosition
	    };
	}
	
	var AnimationContextMenu = exports.AnimationContextMenu = (0, _reactRedux.connect)(mapStateToProps)(AnimationContextMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AnimationContextMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AnimationContextMenu.js"); } } })();

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioTab = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _MenuActions = __webpack_require__(7);
	
	var _SlideSoundsBrowser = __webpack_require__(820);
	
	var _StorySoundsBrowser = __webpack_require__(822);
	
	var _AdvancedSoundsBrowser = __webpack_require__(772);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _VideoUtils2.default.executeAction('reset');
	        _PlayController2.default.checkAudioEditorMode();
	    },
	    render: function render() {
	        var textColor;
	        var gap = _Properties2.default.AUDIO_EDITOR_BUTTON_GAP;
	
	        if (this.state.isOver) textColor = '#2299D6';else textColor = 'white';
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth - 2 * gap,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            left: gap,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        if (this.props.audioTabIndex == 0 || this.props.audioTabIndex == 1) tabStyle.bottom = gap;else tabStyle.top = 2 * _Properties2.default.BROWSER_BUTTON_HEIGHT + gap;
	
	        var spanStyle = {
	            color: textColor,
	            fontSize: 15,
	            position: 'absolute',
	            top: 6,
	            width: tabStyle.width - 4,
	            left: 2,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            textAlign: 'center',
	            cursor: 'default'
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': _LocalesManager2.default.getCaption('AudioEditMode', 'save'), style: tabStyle, onClick: this.onClick, onTouchEnd: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                _LocalesManager2.default.getCaption('AudioEditMode', 'save')
	            )
	        );
	    }
	});
	
	var TabElement = _react2.default.createClass({
	    displayName: 'TabElement',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        var state = _StoreManager2.default.getState();
	        var audioTabIndex = state.menu.audioTabIndex;
	
	        if (this.props.index == audioTabIndex) dispatch((0, _MenuActions.changeAudioTabIndex)(-1));else dispatch((0, _MenuActions.changeAudioTabIndex)(this.props.index));
	    },
	    render: function render() {
	        var topPosition = _Properties2.default.BROWSER_BUTTON_HEIGHT * this.props.index;
	
	        if (this.props.audioTabIndex == 0 && this.props.index == 1) {
	            topPosition = this.props.windowHeight - 2 * _Properties2.default.CLIPART_BUTTON_HEIGHT - 2 * _Properties2.default.AUDIO_EDITOR_BUTTON_GAP - _Properties2.default.BROWSER_BUTTON_HEIGHT;
	        }
	
	        var buttonColor;
	        var textColor;
	        var icon;
	        var iconColor;
	
	        if (this.props.index == this.props.audioTabIndex) {
	            buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            textColor = '#F7F7F7';
	            icon = 'fa fa-angle-down';
	            iconColor = 'white';
	        } else {
	            icon = 'fa fa-angle-right';
	            iconColor = 'black';
	
	            if (this.state.isOver == true) {
	                buttonColor = _Properties2.default.BROWSER_HOVER_COLOR;
	                textColor = '#2299D6';
	            } else {
	                buttonColor = _Properties2.default.BROWSER_COLOR;
	                textColor = '#000000';
	            }
	        }
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth - 1,
	            height: _Properties2.default.BROWSER_BUTTON_HEIGHT,
	            paddingLeft: _Properties2.default.BROWSER_LEFT_PADDING,
	            top: topPosition,
	            color: 'white',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none',
	            margin: 0,
	            paddingRight: 0,
	            paddingTop: 0,
	            paddingBottom: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            textAlign: 'left',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 5,
	            color: textColor,
	            fontSize: 15,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 6,
	            right: _Properties2.default.BROWSER_LEFT_PADDING + _Properties2.default.BROWSER_ICON_RIGHT_PADDING,
	            color: iconColor
	        };
	
	        var text;
	
	        if (this.props.index == 0) text = _LocalesManager2.default.getCaption('StorySoundTab', 'music');else text = _LocalesManager2.default.getCaption('SlideSoundTab', 'music');
	
	        var topLine = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: tabStyle.width,
	            height: 1,
	            background: 'white'
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': text, style: tabStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement('div', { style: topLine }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: icon })
	        );
	    }
	});
	
	var AudioTabContent = _react2.default.createClass({
	    displayName: 'AudioTabContent',
	    render: function render() {
	        var tabStyle = {
	            position: 'absolute',
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            top: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            background: 'white'
	        };
	
	        var top;
	        var height;
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            top = 0;
	            height = tabStyle.height;
	
	            return _react2.default.createElement(
	                'div',
	                { style: tabStyle },
	                _react2.default.createElement('audio', { id: 'audioBrowserSound', className: 'audioItem', preload: 'auto', playsInline: true }),
	                _react2.default.createElement(_AdvancedSoundsBrowser.AdvancedSoundsBrowser, { height: height, top: top, accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowHeight: this.props.windowHeight })
	            );
	        } else {
	            if (this.props.clipartCategory != 2) return _react2.default.createElement('div', null);
	
	            var browserElement;
	
	            if (this.props.audioTabIndex == 0 || this.props.audioTabIndex == 1) {
	                height = tabStyle.height - 2 * _Properties2.default.BROWSER_BUTTON_HEIGHT - 2 * _Properties2.default.AUDIO_EDITOR_BUTTON_GAP - _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	                if (this.props.audioTabIndex == 1) {
	                    top = 2 * _Properties2.default.BROWSER_BUTTON_HEIGHT;
	
	                    browserElement = _react2.default.createElement(_SlideSoundsBrowser.SlideSoundsBrowser, { height: height, top: top, accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowHeight: this.props.windowHeight });
	                } else {
	                    top = _Properties2.default.BROWSER_BUTTON_HEIGHT;
	
	                    browserElement = _react2.default.createElement(_StorySoundsBrowser.StorySoundsBrowser, { height: height, top: top, accordionWidth: this.props.accordionWidth, dispatch: this.props.dispatch, windowHeight: this.props.windowHeight });
	                }
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { style: tabStyle },
	                _react2.default.createElement('audio', { id: 'audioBrowserSound', className: 'audioItem', preload: 'auto', playsInline: true }),
	                _react2.default.createElement(TabElement, { accordionWidth: this.props.accordionWidth, index: 0, audioTabIndex: this.props.audioTabIndex, windowHeight: this.props.windowHeight }),
	                _react2.default.createElement(TabElement, { accordionWidth: this.props.accordionWidth, index: 1, audioTabIndex: this.props.audioTabIndex, windowHeight: this.props.windowHeight }),
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, audioTabIndex: this.props.audioTabIndex }),
	                browserElement
	            );
	        }
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var clipartCategory = state.menu.clipartCategory;
	    var audioTabIndex = state.menu.audioTabIndex;
	    var showAudioEditor = state.menu.showAudioEditor;
	
	    if (clipartCategory == undefined) clipartCategory = 0;
	
	    if (audioTabIndex == undefined) audioTabIndex = -1;
	
	    return {
	        clipartCategory: clipartCategory,
	        audioTabIndex: audioTabIndex,
	        showAudioEditor: showAudioEditor
	    };
	}
	
	var AudioTab = exports.AudioTab = (0, _reactRedux.connect)(mapStateToProps)(AudioTabContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AudioTab.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AudioTab.js"); } } })();

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AudioToolBrowser = exports.AudioToolBrowserContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AudioCategorySelectorNew = __webpack_require__(169);
	
	var _SoundItemRenderer = __webpack_require__(138);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _PopulateMediaFilesUtils = __webpack_require__(80);
	
	var _PopulateMediaFilesUtils2 = _interopRequireDefault(_PopulateMediaFilesUtils);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _MusicActions = __webpack_require__(91);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioList = _react2.default.createClass({
	    displayName: 'AudioList',
	    getInitialState: function getInitialState() {
	        return {
	            elements: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.dataProvider != nextProps.dataProvider) this.recreateElements();
	    },
	    recreateElements: function recreateElements() {
	        setTimeout(this.refreshNewContent, 50);
	    },
	    refreshNewContent: function refreshNewContent() {
	        this.initElements();
	    },
	    initElements: function initElements() {
	        var elements = [];
	        var i;
	        var item;
	
	        for (i = 0; i < this.props.dataProvider.length; i++) {
	            item = this.props.dataProvider[i];
	            elements.push(_react2.default.createElement(_SoundItemRenderer.SoundItemRenderer, { accordionWidth: this.props.accordionWidth, categoryIndex: this.props.categoryIndex, index: i, key: 'audioBrowser' + item.title + '_' + i, dispatch: this.props.dispatch, value: item }));
	        }
	
	        this.setState({
	            elements: elements
	        });
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.elements != nextState.elements || this.props.secondCategoryVisible != newProps.secondCategoryVisible || this.props.windowHeight != newProps.windowHeight || this.props.dataProvider != newProps.dataProvider) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.elements == undefined) return _react2.default.createElement('div', null);
	
	        var categoryHeight = 0;
	        var topPosition = this.props.buttonsHeight;
	        var bottomPadding = 8;
	        var topPadding = _Properties2.default.CATEGORY_SELECTOR_GAP;
	        var topButtonsPosition = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	        if (this.props.categoryVisible == true) {
	            categoryHeight = _Properties2.default.CATEGORY_SELECTOR_HEIGHT;
	            topPosition = topPosition + categoryHeight;
	            topPadding = 0;
	        }
	
	        if (_PlatformDetection2.default.isIOS()) {
	            topButtonsPosition = 3 * _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        }
	
	        topPosition = topPosition + topPadding;
	        var uploadButtonHeight = 0;
	
	        if (this.props.showUploadButton) {
	            uploadButtonHeight = 50;
	            topPosition = topPosition + uploadButtonHeight;
	        }
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = this.props.height - categoryHeight - bottomPadding - topButtonsPosition - topPadding - uploadButtonHeight;
	        componentProperties.top = topPosition;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = this.state.elements;
	        componentProperties.isAudioEditor = true;
	        componentProperties.scrollHeight = (_Properties2.default.SOUND_ITEM_HEIGHT + _Properties2.default.SOUND_ITEMS_GAP) * this.state.elements.length;
	
	        return _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties });
	    }
	});
	
	var TabElement = _react2.default.createClass({
	    displayName: 'TabElement',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	        var state = _StoreManager2.default.getState();
	        var selectedIndex = state.music.mainAudioCategoryIndex;
	
	        if (this.props.index == selectedIndex) {
	            if (_PlatformDetection2.default.isIOS()) dispatch((0, _MusicActions.changeMainAudioCategoryIndex)(-1));
	        } else dispatch((0, _MusicActions.changeMainAudioCategoryIndex)(this.props.index));
	    },
	    render: function render() {
	        var isIos = _PlatformDetection2.default.isIOS();
	        var buttonColor;
	        var textColor;
	        var icon;
	        var iconColor;
	        var topPosition = isIos ? this.props.topPosition : 0;
	        var buttonWidth = isIos ? this.props.accordionWidth : (this.props.accordionWidth - 3) / 3;
	        var leftPosition = isIos ? 0 : this.props.index * buttonWidth + this.props.index;
	        var buttonHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        var padding = isIos ? _Properties2.default.BROWSER_LEFT_PADDING : 0;
	
	        if (this.props.index == this.props.selectedIndex) {
	            buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            textColor = '#F7F7F7';
	            icon = 'fa fa-angle-down';
	            iconColor = 'white';
	        } else {
	            icon = 'fa fa-angle-right';
	            iconColor = 'black';
	
	            if (this.state.isOver == true) {
	                buttonColor = _Properties2.default.BROWSER_HOVER_COLOR;
	                textColor = '#2299D6';
	            } else {
	                if (isIos) buttonColor = _Properties2.default.BROWSER_COLOR;else buttonColor = _Properties2.default.SOUND_EVEN_COLOR;
	
	                textColor = '#000000';
	            }
	        }
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: buttonWidth,
	            height: buttonHeight,
	            top: topPosition,
	            left: leftPosition,
	            color: 'white',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 5,
	            left: padding,
	            color: textColor,
	            fontSize: 15,
	            width: buttonWidth - 4 * padding,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var iconElement;
	
	        if (isIos) {
	            var iconStyle = {
	                position: 'absolute',
	                top: 11,
	                right: _Properties2.default.BROWSER_ICON_RIGHT_PADDING,
	                color: iconColor
	            };
	
	            iconElement = _react2.default.createElement('i', { style: iconStyle, className: icon });
	        } else {
	            spanStyle.textAlign = 'center';
	        }
	
	        if (isIos) {
	            tabStyle.outlineColor = 'white';
	            tabStyle.outlineWidth = 1;
	            tabStyle.outlineStyle = 'solid';
	
	            return _react2.default.createElement(
	                'div',
	                { style: tabStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement(
	                    'span',
	                    { style: spanStyle },
	                    this.props.title
	                ),
	                iconElement
	            );
	        } else {
	            tabStyle.margin = 0;
	            tabStyle.padding = 0;
	            tabStyle.boxSizing = 'initial';
	            tabStyle.fontSize = 'initial';
	            tabStyle.borderStyle = 'none';
	
	            return _react2.default.createElement(
	                'button',
	                { style: tabStyle, 'aria-label': this.props.title, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement(
	                    'span',
	                    { style: spanStyle },
	                    this.props.title
	                ),
	                iconElement
	            );
	        }
	    }
	});
	
	var AudioToolBrowserContent = exports.AudioToolBrowserContent = _react2.default.createClass({
	    displayName: 'AudioToolBrowserContent',
	    getInitialState: function getInitialState() {
	        return {
	            isMyMediaFilesCallDone: false
	        };
	    },
	    getClipartModel: function getClipartModel() {
	        var clipartModel = _StoreManager2.default.getState().music.soundClipartModel;
	        return clipartModel;
	    },
	    getMySoundsCategories: function getMySoundsCategories() {
	        var dataProvider = [];
	
	        dataProvider.push(_LocalesManager2.default.getCaption('UploadedSounds', 'music'));
	        dataProvider.push(_LocalesManager2.default.getCaption('RecordedSounds', 'music'));
	
	        return dataProvider;
	    },
	    getSelectorDataProvider: function getSelectorDataProvider(type) {
	        var clipartModel = this.getClipartModel();
	
	        if (!clipartModel) return [];
	
	        var clipartModelItems = clipartModel.items;
	        var dataProvider = [];
	        var i;
	
	        if (type == 'main') {
	            dataProvider.push(clipartModelItems[0].title);
	            dataProvider.push(clipartModelItems[1].title);
	            dataProvider.push(_LocalesManager2.default.getCaption('MySoundsContent', 'music'));
	        } else {
	            var mainIndex = this.getSelectedIndex('main');
	
	            if (mainIndex >= 0) {} else mainIndex = 0;
	
	            var itemsObject = clipartModelItems[mainIndex];
	
	            if (itemsObject === undefined) return dataProvider;
	
	            var subcategoryItems = itemsObject.items;
	
	            for (i = 0; i < subcategoryItems.length; i++) {
	                dataProvider.push(subcategoryItems[i].title);
	            }
	        }
	
	        return dataProvider;
	    },
	    getSelectedIndex: function getSelectedIndex(type) {
	        var index;
	
	        if (type == 'main') {
	            index = this.props.mainAudioCategoryIndex;
	        } else {
	            index = this.props.secondAudioCategoryIndex;
	        }
	
	        if (index == undefined || isNaN(index)) index = 0;
	
	        return index;
	    },
	    getMusicDataProvider: function getMusicDataProvider(mainIndex) {
	        var clipartModel = this.getClipartModel();
	
	        if (!clipartModel) return [];
	
	        var clipartModelItems = clipartModel.items;
	
	        if (clipartModelItems == undefined) return [];
	
	        if (mainIndex == -1) return [];
	
	        var secondIndex = this.getSelectedIndex('second');
	        var subcategoryItems = clipartModelItems[mainIndex].items;
	
	        if (subcategoryItems == undefined) return [];
	
	        var dataProvider = [];
	        var contentItems = subcategoryItems[secondIndex].items;
	        var i;
	
	        for (i = 0; i < contentItems.length; i++) {
	            dataProvider.push(contentItems[i]);
	        }
	
	        return dataProvider;
	    },
	    filterMySounds: function filterMySounds(dataProvider) {
	        var category = this.getSelectedIndex('second');
	        var i;
	        var array = [];
	
	        for (i = 0; i < dataProvider.length; i++) {
	            if (category == 1) {
	                // recorded sounds
	                if (dataProvider[i] && dataProvider[i].isRecordedSound) array.push(dataProvider[i]);
	            } else {
	                if (dataProvider[i] && !dataProvider[i].isRecordedSound) array.push(dataProvider[i]);
	            }
	        }
	
	        return array;
	    },
	    getMySoundsDataProvider: function getMySoundsDataProvider() {
	        var dataProvider = this.props.mediaFilesDataProvider;
	
	        if (dataProvider && dataProvider.soundsDataProvider && dataProvider.soundsDataProvider.length > 0) return this.filterMySounds(dataProvider.soundsDataProvider);else {
	            if (this.state.isMyMediaFilesCallDone == true) return [];
	
	            setTimeout(this.loadData, 2);
	
	            return [];
	        }
	    },
	    loadData: function loadData() {
	        if (_Configuration2.default.LOAD_LOCAL == true) {
	            // FOR TEST
	            this.props.dispatch((0, _AccordionActions.setMediaFilesDataProvider)({ imagesDataProvider: _PopulateMediaFilesUtils2.default.getImagesDataProviderForTest(), soundsDataProvider: _PopulateMediaFilesUtils2.default.getSoundsDataProviderForTest() }));
	        } else {
	            this.setState({ isMyMediaFilesCallDone: true });
	            _ApiServiceUtils2.default.executeSafeApiCall(this.loadMyMediaFiles.bind(this));
	        }
	    },
	    loadMyMediaFiles: function loadMyMediaFiles() {
	        _ApiServiceUtils2.default.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
	    },
	    parseMediaItems: function parseMediaItems(items) {
	        _PopulateMediaFilesUtils2.default.parseMediaItems(items, this.props.dispatch, true);
	        this.setState({ isMyMediaFilesCallDone: false });
	    },
	    category: function category() {
	        if (this.props.mainAudioCategoryIndex == undefined) return -1;else return this.props.mainAudioCategoryIndex;
	    },
	    getContentDataProvider: function getContentDataProvider() {
	        var category = this.category();
	
	        if (category == 0 || category == 1) return this.getMusicDataProvider(category);else return this.getMySoundsDataProvider();
	    },
	    isCategoryVisible: function isCategoryVisible() {
	        var category = this.category();
	
	        if (category == 0 || category == 1) return true;else return false;
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var target = e.target;
	        if (this.hasParentWithId(target, 'categorySelector', 7) == false) {
	            this.props.dispatch((0, _MenuActions.expandAudioList)(false, 'all'));
	        }
	
	        setTimeout(this.refreshView, 5);
	    },
	    hasParentWithId: function hasParentWithId(target, parentId, level) {
	        if (target.id == parentId) return true;
	
	        var i;
	
	        for (i = 0; i < level; i++) {
	            if (target.parentNode == undefined) {
	                return false;
	            } else {
	                target = target.parentNode;
	
	                if (target.id == parentId) return true;
	            }
	        }
	
	        return false;
	    },
	    getTabTopPosition: function getTabTopPosition(index, length, selectedIndex) {
	        var topPosition = _Properties2.default.CLIPART_BUTTON_HEIGHT * index;
	        var clipartButtonHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	        if (_AudioToolUtils2.default.isAudioTool()) clipartButtonHeight = 0;
	
	        if (selectedIndex != 0 && selectedIndex != 1 && selectedIndex != 2) {
	            topPosition = index * _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        } else {
	            if (index <= selectedIndex) topPosition = index * _Properties2.default.CLIPART_BUTTON_HEIGHT;else topPosition = this.props.windowHeight - clipartButtonHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT * (length - index);
	        }
	
	        return topPosition;
	    },
	    refreshView: function refreshView() {
	        this.forceUpdate();
	    },
	    onUpload: function onUpload(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        window.parent.postMessage('openUploader', '*');
	    },
	    onMouseIn: function onMouseIn() {
	        var button = document.getElementById('uploadButton');
	        _HoverManager2.default.show(button, 'uploadButton');
	    },
	    onMouseOut: function onMouseOut() {
	        _HoverManager2.default.hide();
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.mediaFilesDataProvider != newProps.mediaFilesDataProvider || this.props.musicContentIndex != newProps.musicContentIndex || this.props.secondAudioCategoryIndex != newProps.secondAudioCategoryIndex || this.props.mainAudioCategoryIndex != newProps.mainAudioCategoryIndex || this.props.secondAudioCategoryIsExpanded != newProps.secondAudioCategoryIsExpanded || this.props.accordionWidth != newProps.accordionWidth || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.mainAudioCategoryIsExpanded != newProps.mainAudioCategoryIsExpanded || this.props.contextMode != newProps.contextMode) return true;else return false;
	    },
	    render: function render() {
	        if (this.props.contextMode == _ModeConstants2.default.SEARCH_CONTEXT) return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            top: this.props.top,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.height,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white',
	            outlineColor: 'white',
	            outlineWidth: 1,
	            outlineStyle: 'solid'
	        };
	
	        if (_AudioToolUtils2.default.isAudioTool()) menuStyle.outlineWidth = 0;
	
	        var leftPosition = 0;
	
	        if (this.props.accordionWidth > _Properties2.default.BROWSER_WIDTH) leftPosition = (this.props.accordionWidth - _Properties2.default.BROWSER_WIDTH) / 2;
	
	        var elementsHolder = {
	            position: 'absolute',
	            top: 0,
	            left: leftPosition,
	            width: this.props.accordionWidth,
	            height: this.props.height,
	            cursor: 'default',
	            overflowX: 'auto',
	            overflowY: 'hidden'
	        };
	
	        var mainDataProvider = this.getSelectorDataProvider('main');
	        var i;
	        var tabs = [];
	
	        for (i = 0; i < mainDataProvider.length; i++) {
	            tabs.push(_react2.default.createElement(TabElement, { key: 'tabElement_' + i, accordionWidth: this.props.accordionWidth, topPosition: this.getTabTopPosition(i, mainDataProvider.length, this.props.mainAudioCategoryIndex), title: mainDataProvider[i], index: i, selectedIndex: this.props.mainAudioCategoryIndex, windowHeight: this.props.windowHeight }));
	        }
	
	        var list;
	        var categorySelector;
	        var uploadButton;
	
	        if (this.props.mainAudioCategoryIndex == 0 || this.props.mainAudioCategoryIndex == 1 || this.props.mainAudioCategoryIndex == 2) {
	            var buttonsHeight = _PlatformDetection2.default.isIOS() ? (this.props.mainAudioCategoryIndex + 1) * _Properties2.default.CLIPART_BUTTON_HEIGHT : _Properties2.default.CLIPART_BUTTON_HEIGHT;
	            var dataProvider = this.props.mainAudioCategoryIndex == 2 ? this.getMySoundsCategories() : this.getSelectorDataProvider('second');
	            var showUploadButton = !_PlatformDetection2.default.isIOSApp() && this.props.mainAudioCategoryIndex == 2 && (!this.props.secondAudioCategoryIndex || this.props.secondAudioCategoryIndex == 0);
	
	            list = _react2.default.createElement(AudioList, { accordionWidth: _Properties2.default.BROWSER_WIDTH, buttonsHeight: buttonsHeight, showUploadButton: showUploadButton, categoryVisible: true, height: this.props.height, categoryIndex: this.props.mainAudioCategoryIndex, windowHeight: this.props.windowHeight, dispatch: this.props.dispatch, dataProvider: this.getContentDataProvider() });
	            categorySelector = _react2.default.createElement(_AudioCategorySelectorNew.AudioCategorySelectorNew, { top: buttonsHeight, accordionWidth: _Properties2.default.BROWSER_WIDTH, type: 'second', isAdvancedMenu: true, visible: true, isExpanded: this.props.secondAudioCategoryIsExpanded, selectedIndex: this.getSelectedIndex('second'), dataProvider: dataProvider, dispatch: this.props.dispatch });
	
	            if (showUploadButton) {
	                if (_PlatformDetection2.default.isIOS()) {
	                    var uploadIconStyle = {
	                        position: 'absolute',
	                        top: 85,
	                        left: _Properties2.default.BROWSER_WIDTH / 2 - 42 / 2,
	                        color: '#2DE102'
	                    };
	
	                    uploadIconStyle.top = uploadIconStyle.top + 2 * _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	                    uploadButton = _react2.default.createElement('i', { id: 'uploadButton', style: uploadIconStyle, className: 'fa fa-plus-circle fa-3x', onMouseDown: this.onUpload, onTouchStart: this.onUpload, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut });
	                } else {
	                    var uploadButtonStyle = {
	                        position: 'absolute',
	                        top: 85,
	                        left: _Properties2.default.BROWSER_WIDTH / 2 - 42 / 2,
	                        margin: 0,
	                        padding: 0,
	                        boxSizing: 'initial',
	                        fontSize: 'initial',
	                        borderStyle: 'none',
	                        width: 41,
	                        height: 48,
	                        background: 'none'
	                    };
	
	                    var uploadIconPlusStyle = {
	                        position: 'absolute',
	                        top: 0,
	                        left: 0,
	                        color: '#2DE102'
	                    };
	
	                    uploadButton = _react2.default.createElement(
	                        'button',
	                        { id: 'uploadButton', 'aria-label': _LocalesManager2.default.getCaption('UploadHover', 'myFiles'),
	                            style: uploadButtonStyle, onClick: this.onUpload, onTouchStart: this.onUpload,
	                            onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	                        _react2.default.createElement('i', { style: uploadIconPlusStyle, className: 'fa fa-plus-circle fa-3x' })
	                    );
	                }
	            }
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { ref: 'audioBrowser', style: menuStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement(
	                'div',
	                { style: elementsHolder },
	                tabs,
	                categorySelector,
	                uploadButton,
	                list
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	
	    var mainAudioCategoryIsExpanded = state.menu.mainAudioCategoryIsExpanded;
	    var secondAudioCategoryIsExpanded = state.menu.secondAudioCategoryIsExpanded;
	    var mainAudioCategoryIndex = state.music.mainAudioCategoryIndex;
	    var secondAudioCategoryIndex = state.music.secondAudioCategoryIndex;
	    var musicContentIndex = state.music.musicContentIndex;
	    var mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
	    var contextMode = state.menu.contextMode;
	
	    return {
	        mainAudioCategoryIsExpanded: mainAudioCategoryIsExpanded,
	        secondAudioCategoryIsExpanded: secondAudioCategoryIsExpanded,
	        mainAudioCategoryIndex: mainAudioCategoryIndex,
	        secondAudioCategoryIndex: secondAudioCategoryIndex,
	        musicContentIndex: musicContentIndex,
	        mediaFilesDataProvider: mediaFilesDataProvider,
	        contextMode: contextMode
	    };
	}
	
	var AudioToolBrowser = exports.AudioToolBrowser = (0, _reactRedux.connect)(mapStateToProps)(AudioToolBrowserContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AudioToolBrowser.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/AudioToolBrowser.js"); } } })();

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BackgroundVisibilityMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _CustomSlider = __webpack_require__(170);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            position: 'absolute',
	            top: 6,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            right: 28,
	            top: 4,
	            width: 22,
	            height: 22,
	            cursor: 'pointer',
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            background: 'none',
	            borderStyle: 'none',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 3,
	            right: 3,
	            cursor: 'pointer'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                _LocalesManager2.default.getCaption('BackgroundVisibilityMenuTitle', 'stylingMenu')
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'firstFocusableObjectForBackgroundVisibilityMenu', style: closeButtonStyle, 'aria-label': _LocalesManager2.default.getCaption('close', 'other'), onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var BackgroundVisibilityMenu = exports.BackgroundVisibilityMenu = _react2.default.createClass({
	    displayName: 'BackgroundVisibilityMenu',
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('firstFocusableObjectForBackgroundVisibilityMenu');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.contextTarget != newProps.contextTarget || this.props.contextMode != newProps.contextMode || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        if (this.props.contextMode != _ModeConstants2.default.SLIDE_VISIBILITY) return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white',
	            cursor: 'default'
	        };
	
	        var opacityProperties = {};
	        opacityProperties.topPosition = 50;
	        opacityProperties.leftPosition = _Properties2.default.BROWSER_LEFT_PADDING;
	        opacityProperties.width = _Properties2.default.BROWSER_WIDTH - 2 * _Properties2.default.BROWSER_LEFT_PADDING;
	        opacityProperties.height = _Properties2.default.STYLING_SLIDER_HEIGHT;
	        opacityProperties.backgroundHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/opacitySlider.png';
	        opacityProperties.thumbHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
	        opacityProperties.thumbSize = _Properties2.default.STYLING_THUMB_SIZE;
	        opacityProperties.start = 1;
	        opacityProperties.end = 0;
	        opacityProperties.step = 0.1;
	        opacityProperties.target = _StoreManager2.default.getState().currentSlide.model.content[0];
	        opacityProperties.dispatch = this.props.dispatch;
	        opacityProperties.type = 'change_opacity';
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'backgroundVisibilityMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(_CustomSlider.CustomSlider, { properties: opacityProperties, id: 'lastFocusableObjectForBackgroundVisibilityMenu' })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/BackgroundVisibilityMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/BackgroundVisibilityMenu.js"); } } })();

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ClipartSelectorButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClipartSelectorButtonContent = _react2.default.createClass({
	    displayName: 'ClipartSelectorButtonContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        if (this.isAvailable() == false) return;
	
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        if (this.isAvailable() == false) return;
	
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (this.isAvailable() == false) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (this.isAvailable() == false) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.changeUniverse();
	    },
	    onClick: function onClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.changeUniverse();
	    },
	    changeUniverse: function changeUniverse() {
	        var currentVideoTheme = _AppParameters2.default.currentVideoTheme;
	
	        if (currentVideoTheme != this.props.value.name) {
	            _AppParameters2.default.currentVideoTheme = this.props.value.name;
	            _MasterUniverseUtils2.default.reloadVideoClipart();
	        }
	
	        this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.UNIVERSES_MENU]));
	    },
	    isAvailable: function isAvailable() {
	        return this.props.value.isAvailable;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var buttonColor;
	        var textColor;
	
	        if (this.state.isOver == true) {
	            buttonColor = _Properties2.default.BROWSER_HOVER_COLOR;
	            textColor = '#2299D6';
	        } else {
	            buttonColor = _Properties2.default.BROWSER_COLOR;
	            textColor = '#000000';
	        }
	
	        if (this.isAvailable() == false) {
	            buttonColor = 'lightgrey';
	            textColor = 'white';
	        }
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.UNIVERSE_BUTTON_HEIGHT,
	            paddingLeft: _Properties2.default.BROWSER_LEFT_PADDING,
	            top: this.props.index * _Properties2.default.UNIVERSE_BUTTON_HEIGHT,
	            color: 'white',
	            margin: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            textAlign: 'left',
	            borderStyle: 'none',
	            paddingRight: 0,
	            paddingBottom: 0,
	            paddingTop: 0
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            color: textColor,
	            fontSize: 15,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            top: 9
	        };
	
	        var iconVisible;
	
	        if (this.props.value.name == _AppParameters2.default.currentVideoTheme) iconVisible = 'block';else iconVisible = 'none';
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 11,
	            right: 60,
	            color: textColor,
	            display: iconVisible
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': this.props.value.title, style: tabStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp, onClick: this.onClick, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.value.title
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-check' })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var accordionWidth = state.accordion.width;
	    var clipartCategory = state.menu.clipartCategory;
	    var isVideoClipart = false;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    if (clipartCategory == 1) isVideoClipart = true;
	
	    return {
	        accordionWidth: accordionWidth,
	        isVideoClipart: isVideoClipart
	    };
	}
	
	var ClipartSelectorButton = exports.ClipartSelectorButton = (0, _reactRedux.connect)(mapStateToProps)(ClipartSelectorButtonContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorButton.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorButton.js"); } } })();

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ClipartSelectorButtonExpanded = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClipartSelectorButtonExpandedContent = _react2.default.createClass({
	    displayName: 'ClipartSelectorButtonExpandedContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        if (this.isAvailable() == false) return;
	
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        if (this.isAvailable() == false) return;
	
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (this.isAvailable() == false) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (this.isAvailable() == false) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.changeUniverse();
	    },
	    onClick: function onClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.changeUniverse();
	    },
	    changeUniverse: function changeUniverse() {
	        var currentVideoTheme = _AppParameters2.default.currentVideoTheme;
	
	        if (currentVideoTheme != this.props.value.name) {
	            _AppParameters2.default.currentVideoTheme = this.props.value.name;
	            _MasterUniverseUtils2.default.reloadVideoClipart();
	        }
	
	        this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.UNIVERSES_MENU]));
	    },
	    isAvailable: function isAvailable() {
	        return this.props.value.isAvailable;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var textColor;
	        var iconSrc;
	
	        if (this.state.isOver == true) {
	            textColor = '#2299D6';
	            iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/selectedThemeHover.png';
	        } else {
	            textColor = '#000000';
	            iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/selectedTheme.png';
	        }
	
	        var scrollWidth = 15;
	        var hGap = 10;
	        var bottomGap = 14;
	        var textHeight = 17;
	        var buttonWidth = this.props.accordionWidth - 2 * hGap - scrollWidth;
	        var buttonHeight = buttonWidth * 9 / 16 + textHeight + bottomGap;
	
	        var tabStyle = {
	            position: 'absolute',
	            width: buttonWidth,
	            height: buttonHeight,
	            top: this.props.index * buttonHeight,
	            left: hGap,
	            cursor: 'pointer',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            borderStyle: 'none',
	            background: 'none',
	            display: 'flex',
	            textAlign: 'left'
	        };
	
	        var disabledArea = 'none';
	
	        if (this.isAvailable() == false) {
	            textColor = 'lightgrey';
	            disabledArea = 'block';
	        }
	
	        var spanStyle = {
	            position: 'absolute',
	            color: textColor,
	            fontSize: 13,
	            width: this.props.accordionWidth - 2 * hGap - scrollWidth - 5,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            top: 0
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: textHeight,
	            left: 0,
	            width: buttonWidth,
	            height: buttonWidth * 9 / 16
	        };
	
	        var iconVisible;
	
	        if (this.props.value.name == _AppParameters2.default.currentVideoTheme) iconVisible = 'block';else iconVisible = 'none';
	
	        var checkIconStyle = {
	            position: 'absolute',
	            bottom: 19,
	            right: 5,
	            display: iconVisible,
	            width: 40,
	            height: 40
	        };
	
	        var disabledStyle = {
	            position: 'absolute',
	            top: textHeight,
	            left: 0,
	            width: buttonWidth,
	            height: buttonWidth * 9 / 16,
	            background: 'white',
	            opacity: 0.5,
	            display: disabledArea
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': this.props.value.title, style: tabStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp, onClick: this.onClick, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.value.title
	            ),
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: this.props.href }),
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: checkIconStyle, src: iconSrc }),
	            _react2.default.createElement('div', { style: disabledStyle })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var accordionWidth = state.accordion.width;
	    var clipartCategory = state.menu.clipartCategory;
	    var isVideoClipart = false;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    if (clipartCategory == 1) isVideoClipart = true;
	
	    return {
	        accordionWidth: accordionWidth,
	        isVideoClipart: isVideoClipart
	    };
	}
	
	var ClipartSelectorButtonExpanded = exports.ClipartSelectorButtonExpanded = (0, _reactRedux.connect)(mapStateToProps)(ClipartSelectorButtonExpandedContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorButtonExpanded.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorButtonExpanded.js"); } } })();

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ClipartSelectorButtonExpandedNew = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var ClipartSelectorButtonExpandedContentNew = _react2.default.createClass({
	    displayName: 'ClipartSelectorButtonExpandedContentNew',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        if (this.isAvailable() == false) return;
	
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        if (this.isAvailable() == false) return;
	
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (this.isAvailable() == false) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (this.isAvailable() == false) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.changeUniverse();
	    },
	    onClick: function onClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.changeUniverse();
	    },
	    changeUniverse: function changeUniverse() {
	        var currentTheme = _AppParameters2.default.currentTheme;
	
	        if (currentTheme != this.props.item.name) {
	            _MasterUniverseUtils2.default.changeTheme(this.props.item.name);
	            this.props.dispatch((0, _MenuActions.showSavePreloader)(true));
	        }
	
	        this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	        this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.UNIVERSES_MENU]));
	
	        _MouseUtils2.default.setFocusSequence();
	    },
	    isAvailable: function isAvailable() {
	        if (_Configuration2.default.LOAD_LOCAL) return true;
	
	        // if ((configuration.IS_PROD() && this.props.item.hidden == 2) || (!configuration.IS_PROD() && this.props.item.hidden == 1))
	        if (this.props.item.hidden > 0) return true;else return false;
	    },
	    getTitle: function getTitle() {
	        var item = this.props.item;
	
	        if (!item.translations) return item.name;else {
	            var translation = item.translations[_MasterUniverseUtils2.default.language()];
	
	            if (translation && translation.length > 0) return translation;else if (item.translations['en_US']) return item.translations['en_US'];else return item.name;
	        }
	    },
	    getThumbnail: function getThumbnail() {
	        return 'https://svg-cartoonist.creaza.com/thumbnails-theme/' + this.props.item.name + '.png';
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var _React$createElement;
	
	        var textColor;
	        var iconSrc;
	
	        if (this.state.isOver == true) {
	            textColor = '#2299D6';
	            iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/selectedThemeHover.png';
	        } else {
	            textColor = '#000000';
	            iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/selectedTheme.png';
	        }
	
	        var scrollWidth = 15;
	        var hGap = 10;
	        var bottomGap = 14;
	        var textHeight = 17;
	        var buttonWidth = this.props.accordionWidth - 2 * hGap - scrollWidth;
	        var buttonHeight = buttonWidth * 9 / 16 + textHeight + bottomGap;
	
	        var tabStyle = {
	            position: 'absolute',
	            width: buttonWidth,
	            height: buttonHeight,
	            top: this.props.index * buttonHeight,
	            left: hGap,
	            cursor: 'pointer',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            borderStyle: 'none',
	            background: 'none',
	            display: 'flex',
	            textAlign: 'left'
	        };
	
	        var disabledArea = 'none';
	
	        if (this.isAvailable() == false) {
	            textColor = 'lightgrey';
	            disabledArea = 'block';
	        }
	
	        var spanStyle = {
	            position: 'absolute',
	            color: textColor,
	            fontSize: 13,
	            width: this.props.accordionWidth - 2 * hGap - scrollWidth - 5,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            top: 0
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: textHeight,
	            left: 0,
	            width: buttonWidth,
	            height: buttonWidth * 9 / 16
	        };
	
	        var iconVisible;
	
	        if (this.props.item.name == _AppParameters2.default.currentTheme) iconVisible = 'block';else iconVisible = 'none';
	
	        var checkIconStyle = {
	            position: 'absolute',
	            bottom: 19,
	            right: 5,
	            display: iconVisible,
	            width: 40,
	            height: 40
	        };
	
	        var disabledStyle = {
	            position: 'absolute',
	            top: textHeight,
	            left: 0,
	            width: buttonWidth,
	            height: buttonWidth * 9 / 16,
	            background: 'white',
	            opacity: 0.5,
	            display: disabledArea
	        };
	
	        var idValue;
	
	        if (this.props.index == 0) idValue = 'firstThemeElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, 'aria-label': this.getTitle(), style: tabStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp, onClick: this.onClick, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.getTitle()
	            ),
	            _react2.default.createElement('img', (_React$createElement = { alt: '', 'aria-hidden': 'true' }, _defineProperty(_React$createElement, 'alt', this.getTitle()), _defineProperty(_React$createElement, 'style', iconStyle), _defineProperty(_React$createElement, 'src', this.getThumbnail()), _React$createElement)),
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: checkIconStyle, src: iconSrc }),
	            _react2.default.createElement('div', { style: disabledStyle })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var accordionWidth = state.accordion.width;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    return {
	        accordionWidth: accordionWidth
	    };
	}
	
	var ClipartSelectorButtonExpandedNew = exports.ClipartSelectorButtonExpandedNew = (0, _reactRedux.connect)(mapStateToProps)(ClipartSelectorButtonExpandedContentNew);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorButtonExpandedNew.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorButtonExpandedNew.js"); } } })();

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ClipartSelectorButtonNew = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClipartSelectorButtonNewContent = _react2.default.createClass({
	    displayName: 'ClipartSelectorButtonNewContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        if (this.isAvailable() == false) return;
	
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        if (this.isAvailable() == false) return;
	
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (this.isAvailable() == false) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (this.isAvailable() == false) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.changeUniverse();
	    },
	    onClick: function onClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.changeUniverse();
	    },
	    changeUniverse: function changeUniverse() {
	        var currentTheme = _AppParameters2.default.currentTheme;
	
	        if (currentTheme != this.props.item.name) {
	            _MasterUniverseUtils2.default.changeTheme(this.props.item.name);
	            this.props.dispatch((0, _MenuActions.showSavePreloader)(true));
	        }
	
	        this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	        this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.UNIVERSES_MENU]));
	
	        _MouseUtils2.default.setFocusSequence();
	    },
	    isAvailable: function isAvailable() {
	        if (_Configuration2.default.LOAD_LOCAL) return true;
	
	        // if ((configuration.IS_PROD() && this.props.item.hidden == 2) || (!configuration.IS_PROD() && this.props.item.hidden == 1))
	        if (this.props.item.hidden > 0) return true;else return false;
	    },
	    getTitle: function getTitle() {
	        var item = this.props.item;
	
	        if (!item.translations) return item.name;else {
	            var translation = item.translations[_MasterUniverseUtils2.default.language()];
	
	            if (translation && translation.length > 0) return translation;else if (item.translations['en_US']) return item.translations['en_US'];else return item.name;
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var buttonColor;
	        var textColor;
	
	        if (this.state.isOver == true) {
	            buttonColor = _Properties2.default.BROWSER_HOVER_COLOR;
	            textColor = '#2299D6';
	        } else {
	            buttonColor = _Properties2.default.BROWSER_COLOR;
	            textColor = '#000000';
	        }
	
	        if (this.isAvailable() == false) {
	            buttonColor = 'lightgrey';
	            textColor = 'white';
	        }
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.UNIVERSE_BUTTON_HEIGHT,
	            paddingLeft: _Properties2.default.BROWSER_LEFT_PADDING,
	            top: this.props.index * _Properties2.default.UNIVERSE_BUTTON_HEIGHT,
	            color: 'white',
	            margin: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            textAlign: 'left',
	            borderStyle: 'none',
	            paddingRight: 0,
	            paddingBottom: 0,
	            paddingTop: 0
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            color: textColor,
	            fontSize: 15,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            top: 9
	        };
	
	        var iconVisible;
	
	        if (this.props.item.name == _AppParameters2.default.currentTheme) iconVisible = 'block';else iconVisible = 'none';
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 11,
	            right: 60,
	            color: textColor,
	            display: iconVisible
	        };
	
	        var idValue;
	
	        if (this.props.index == 0) idValue = 'firstThemeElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, 'aria-label': this.getTitle(), style: tabStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp, onClick: this.onClick, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.getTitle()
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-check' })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var accordionWidth = state.accordion.width;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    return {
	        accordionWidth: accordionWidth
	    };
	}
	
	var ClipartSelectorButtonNew = exports.ClipartSelectorButtonNew = (0, _reactRedux.connect)(mapStateToProps)(ClipartSelectorButtonNewContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorButtonNew.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorButtonNew.js"); } } })();

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ClipartSelectorList = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _ClipartSelectorButton = __webpack_require__(778);
	
	var _ClipartSelectorButtonExpanded = __webpack_require__(779);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClipartSelectorListContent = _react2.default.createClass({
	    displayName: 'ClipartSelectorListContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            videoElements: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	    },
	    initElements: function initElements() {
	        var videoElements = this.getElements();
	
	        this.setState({
	            videoElements: videoElements
	        });
	    },
	    getElements: function getElements() {
	        var items = _MasterUniverseUtils2.default.getCurrentVideoThemes();
	        var item;
	        var elements = [];
	        var i;
	        var listType = this.getListStyle();
	        var isVideoTag = 'isVideo';
	
	        for (i = 0; i < items.length; i++) {
	            item = items[i];
	
	            if (listType == 'collapsed') elements.push(_react2.default.createElement(_ClipartSelectorButton.ClipartSelectorButton, { href: items[i].href, dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, index: i, value: item, key: 'clipartSelector' + isVideoTag + i }));else elements.push(_react2.default.createElement(_ClipartSelectorButtonExpanded.ClipartSelectorButtonExpanded, { href: items[i].href, dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, index: i, value: item, key: 'clipartSelector' + isVideoTag + i }));
	        }
	
	        return elements;
	    },
	    onMouseIn: function onMouseIn() {
	        var listStyle = this.getListStyle();
	
	        if (listStyle == 'collapsed') _HoverManager2.default.show(this.refs.listView, 'expandedListView', 'left');else _HoverManager2.default.show(this.refs.listView, 'collapsedListView', 'left');
	
	        this.setState({
	            isOver: true
	        });
	    },
	    getButtonLabel: function getButtonLabel() {
	        if (this.getListStyle() == 'collapsed') _LocalesManager2.default.getCaption('expandedListView', 'hover');else _LocalesManager2.default.getCaption('collapsedListView', 'hover');
	    },
	    onMouseOut: function onMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isOver: false
	        });
	    },
	    onChangeListStyle: function onChangeListStyle(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var listStyle = this.getListStyle();
	
	        if (_PlatformDetection2.default.isIOS()) {
	            if (listStyle == 'collapsed') sessionStorage.setItem('listStyle', 'exapanded');else sessionStorage.setItem('listStyle', 'collapsed');
	        } else {
	            if (listStyle == 'collapsed') localStorage.setItem('listStyle', 'exapanded');else localStorage.setItem('listStyle', 'collapsed');
	        }
	
	        setTimeout(this.refreshView, 10);
	    },
	    getListStyle: function getListStyle() {
	        var listStyle;
	
	        if (_PlatformDetection2.default.isIOS()) listStyle = sessionStorage.getItem('listStyle');else listStyle = localStorage.getItem('listStyle');
	
	        if (listStyle == 'collapsed') return 'collapsed';else return 'exapanded';
	    },
	    refreshView: function refreshView() {
	        this.initElements();
	        this.forceUpdate();
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.videoElements != nextState.videoElements || this.state.isOver != nextState.isOver || this.props.isUniversesVisible != newProps.isUniversesVisible || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        if (this.props.isUniversesVisible == false || this.state == undefined || this.state.videoElements == undefined) return _react2.default.createElement('div', null);
	
	        var topPadding = 33;
	        var bottomPadding = 10;
	
	        var listStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_COLOR,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight - 2 * _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            top: 2 * _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            left: 0,
	            overflowX: 'hidden',
	            overflowY: 'hidden'
	        };
	
	        var listType = this.getListStyle();
	        var itemHeight;
	
	        if (listType == 'collapsed') itemHeight = _Properties2.default.UNIVERSE_BUTTON_HEIGHT;else {
	            var scrollWidth = 15;
	            var hGap = 10;
	            var bottomGap = 14;
	            var textHeight = 17;
	            var buttonWidth = this.props.accordionWidth - 2 * hGap - scrollWidth;
	            itemHeight = buttonWidth * 9 / 16 + textHeight + bottomGap;
	        }
	
	        var elements = this.state.videoElements;
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = this.props.windowHeight - 2 * _Properties2.default.CLIPART_BUTTON_HEIGHT - topPadding - bottomPadding;
	        componentProperties.top = topPadding;
	        componentProperties.displayState = 'block';
	        componentProperties.scrollHeight = elements.length * itemHeight;
	        componentProperties.elements = elements;
	        componentProperties.backgroundColor = _Properties2.default.BROWSER_COLOR;
	
	        var iconSrc;
	
	        if (listType == 'collapsed') {
	            if (this.state.isOver == true) {
	                iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/collapseListHover.png';
	            } else {
	                iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/collapseList.png';
	            }
	        } else {
	            if (this.state.isOver == true) {
	                iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/expandListHover.png';
	            } else {
	                iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/expandList.png';
	            }
	        }
	
	        var iconButtonStyle = {
	            position: 'absolute',
	            top: 7,
	            right: 25,
	            width: 35,
	            height: 35 * 26 / 46,
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            textAlign: 'left',
	            borderStyle: 'none',
	            background: 'none',
	            display: 'flex'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: 35,
	            height: 35 * 26 / 46
	        };
	
	        var expandCollpaseButton;
	
	        // expandCollpaseButton =
	        //     <button aria-label={this.getButtonLabel()} style={iconButtonStyle} ref='listView' onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onChangeListStyle} onClick={this.onChangeListStyle}>
	        //         <img alt='' aria-hidden='true' style={iconStyle} src={iconSrc}/>
	        //     </button>;
	
	        return _react2.default.createElement(
	            'div',
	            { style: listStyle },
	            expandCollpaseButton,
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var accordionWidth = state.accordion.width;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    return {
	        accordionWidth: accordionWidth
	    };
	}
	
	var ClipartSelectorList = exports.ClipartSelectorList = (0, _reactRedux.connect)(mapStateToProps)(ClipartSelectorListContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorList.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorList.js"); } } })();

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ClipartSelectorNew = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ClipartSelectorListNew = __webpack_require__(329);
	
	var _MainUniversesList = __webpack_require__(799);
	
	var _ClipartSelectorList = __webpack_require__(782);
	
	var _AudioTab = __webpack_require__(775);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UniverseButton = _react2.default.createClass({
	    displayName: 'UniverseButton',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var isMainUniverse = _StoreManager2.default.getState().menu.isMainUniverse;
	        this.props.dispatch((0, _MenuActions.showMainUniverse)(!isMainUniverse));
	
	        _MouseUtils2.default.setFocusSequence();
	    },
	    getColor: function getColor() {
	        var color = _Properties2.default.BROWSER_SELECTED_COLOR;
	
	        switch (_AppParameters2.default.currentMainUniverse) {
	            case 'nature_science':
	                {
	                    // green
	                    color = 'rgb(15, 232, 171)';
	                    break;
	                }
	
	            case 'world_history':
	                {
	                    //yellow
	                    color = 'rgb(255, 243, 128)';
	                    break;
	                }
	
	            case 'fiction':
	                {
	                    // red
	                    color = 'rgb(243, 146, 163)';
	                    break;
	                }
	
	            case 'generic':
	                {
	                    // blue
	                    color = 'rgb(140, 200, 223)';
	                    break;
	                }
	
	            case 'alphabet_planet':
	                {
	                    // blue
	                    color = '#9252da';
	                    break;
	                }
	        }
	
	        return color;
	    },
	    getTextColor: function getTextColor() {
	        if (_AppParameters2.default.currentMainUniverse != '' && _AppParameters2.default.currentMainUniverse != 'alphabet_planet') return '#2e2e2e';else return 'white';
	    },
	    render: function render() {
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: this.getColor(),
	            width: this.props.accordionWidth,
	            height: _Properties2.default.BROWSER_BUTTON_HEIGHT - 1,
	            paddingLeft: 20,
	            top: _Properties2.default.CLIPART_BUTTON_HEIGHT + 1,
	            cursor: 'pointer',
	            margin: 0,
	            paddingRight: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none',
	            textAlign: 'left'
	        };
	
	        var spanStyle = {
	            color: this.getTextColor(),
	            fontSize: 14,
	            position: 'absolute',
	            top: 6,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'pointer'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 6,
	            right: _Properties2.default.BROWSER_LEFT_PADDING + _Properties2.default.BROWSER_ICON_RIGHT_PADDING,
	            color: this.getTextColor()
	        };
	
	        var title;
	        var universeTitle = _MasterUniverseUtils2.default.getCurrentUniverseTitle();
	
	        if (universeTitle.indexOf('- ') != -1) universeTitle = universeTitle.replaceAll('- ', '');
	
	        if (_AppParameters2.default.currentMainUniverse == '') {
	            title = _LocalesManager2.default.getCaption('PleaseSelectUniverse', 'other');
	
	            if (!title || title == 'null' || title.length < 1) title = 'Please select a universe!';
	        } else {
	            title = _LocalesManager2.default.getCaption('UniverseName', 'other');
	
	            if (!title || title == 'null' || title.length < 1) title = 'Universe:';
	
	            title = title + ' ' + universeTitle;
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': title, style: tabStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                title
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-angle-down' })
	        );
	    }
	});
	
	var ThemeButton = _react2.default.createClass({
	    displayName: 'ThemeButton',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var isUniversesVisible = _StoreManager2.default.getState().menu.isUniversesVisible;
	
	        if (isUniversesVisible) this.props.dispatch((0, _MenuActions.hideMenus)(_MenuType2.default.ALL_MENUS));else this.props.dispatch((0, _MenuActions.showMenu)(_MenuType2.default.UNIVERSES_MENU));
	
	        _MouseUtils2.default.setFocusSequence();
	    },
	    getColor: function getColor() {
	        var color = _Properties2.default.BROWSER_SELECTED_COLOR;
	
	        switch (_AppParameters2.default.currentMainUniverse) {
	            case 'nature_science':
	                {
	                    // green
	                    color = 'rgb(15, 232, 171)';
	                    break;
	                }
	
	            case 'world_history':
	                {
	                    //yellow
	                    color = 'rgb(255, 243, 128)';
	                    break;
	                }
	
	            case 'fiction':
	                {
	                    // red
	                    color = 'rgb(243, 146, 163)';
	                    break;
	                }
	
	            case 'generic':
	                {
	                    // blue
	                    color = 'rgb(140, 200, 223)';
	                    break;
	                }
	
	            case 'alphabet_planet':
	                {
	                    // purple
	                    color = '#9252da';
	                    break;
	                }
	        }
	
	        return color;
	    },
	    getTextColor: function getTextColor() {
	        if (_AppParameters2.default.currentMainUniverse != '' && _AppParameters2.default.currentMainUniverse != 'alphabet_planet') return '#2e2e2e';else return 'white';
	    },
	    render: function render() {
	        if (this.props.isMainUniverse) return _react2.default.createElement('div', null);
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: this.getColor(),
	            width: this.props.accordionWidth,
	            height: _Properties2.default.BROWSER_BUTTON_HEIGHT - 1,
	            paddingLeft: 20,
	            top: _Properties2.default.CLIPART_BUTTON_HEIGHT + _Properties2.default.BROWSER_BUTTON_HEIGHT + 1,
	            cursor: 'pointer',
	            margin: 0,
	            paddingRight: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none',
	            textAlign: 'left'
	        };
	
	        var spanStyle = {
	            color: this.getTextColor(),
	            fontSize: 14,
	            position: 'absolute',
	            top: 6,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'pointer'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 6,
	            right: _Properties2.default.BROWSER_LEFT_PADDING + _Properties2.default.BROWSER_ICON_RIGHT_PADDING,
	            color: this.getTextColor()
	        };
	
	        var themeTitle = _MasterUniverseUtils2.default.getCurrentThemeTitle();
	        var title;
	
	        if (_AppParameters2.default.currentTheme == '') {
	            title = _LocalesManager2.default.getCaption('PleaseSelectTheme', 'other');
	
	            if (!title || title == 'null' || title.length < 1) title = 'Please select a theme!';
	        } else {
	            title = _LocalesManager2.default.getCaption('ThemeName', 'other');
	
	            if (!title || title == 'null' || title.length < 1) title = 'Theme:';
	
	            title = title + ' ' + themeTitle;
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': title, style: tabStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                title
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-angle-down' })
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.props.dispatch((0, _MenuActions.changeClipartCategory)(this.props.index));
	
	        if (this.props.index == 2) {
	            // audio
	            if (_PlayController2.default.isAudioEditorAvailable()) _PlayController2.default.toggleAudioEditorMode(true);
	
	            _VideoUtils2.default.executeAction('reset');
	            this.props.dispatch((0, _MenuActions.changeCartoonistTabIndex)(10));
	        } else if (this.props.index == 1) {
	            // video
	            if (_AppParameters2.default.currentVideoTheme == '') {
	                this.props.dispatch((0, _MenuActions.showMainUniverse)(true));
	            } else _MasterUniverseUtils2.default.autoselectClipart(this.props.index);
	
	            this.props.dispatch((0, _MenuActions.changeCartoonistTabIndex)(9));
	        } else {
	            // cartoonist
	            if (_AppParameters2.default.currentMainUniverse == '' && _AppParameters2.default.currentTheme == '') this.props.dispatch((0, _MenuActions.showMainUniverse)(true));else if (_AppParameters2.default.currentTheme == '') this.props.dispatch((0, _MenuActions.showMainUniverse)(false));
	
	            if (_AppParameters2.default.currentTheme != '') _MasterUniverseUtils2.default.autoselectClipart(this.props.index);
	
	            this.props.dispatch((0, _MenuActions.changeCartoonistTabIndex)(0));
	        }
	    },
	    render: function render() {
	        var buttonsLength = 3;
	        var position = this.props.accordionWidth / buttonsLength * this.props.index;
	        var color;
	        var textColor;
	
	        if (this.props.index == this.props.clipartCategory) color = _Properties2.default.BROWSER_SELECTED_COLOR;else color = _Properties2.default.RECORDING_MENU_BACKGROUND;
	
	        if (this.state.isOver) {
	            textColor = '#2299D6';
	        } else {
	            if (color == _Properties2.default.BROWSER_SELECTED_COLOR) textColor = 'white';else textColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	        }
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: color,
	            width: this.props.accordionWidth / buttonsLength,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            left: position,
	            top: 0,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        var lineStyle = {
	            position: 'absolute',
	            backgroundColor: 'white',
	            width: 2,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            left: tabStyle.width - 2,
	            top: 0,
	            display: 'block'
	        };
	
	        if (this.props.index == 2) lineStyle.display = 'none';
	
	        var spanStyle = {
	            color: textColor,
	            fontSize: 15,
	            position: 'absolute',
	            top: 6,
	            width: this.props.accordionWidth / buttonsLength - 4,
	            left: 2,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            textAlign: 'center',
	            cursor: 'default'
	        };
	
	        var text;
	
	        if (this.props.index == 0) text = _LocalesManager2.default.getCaption('cartoonsCategory', 'other');else if (this.props.index == 1) text = _LocalesManager2.default.getCaption('videoCategory', 'other');else text = _LocalesManager2.default.getCaption('audioCategory', 'other');
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': text, style: tabStyle, onClick: this.onClick, onTouchEnd: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement('span', { style: lineStyle }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            )
	        );
	    }
	});
	
	var ExpandedButton = _react2.default.createClass({
	    displayName: 'ExpandedButton',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (!this.isSearch()) {
	            if (!this.props.iosButtonsExpanded) {
	                this.props.dispatch((0, _MenuActions.expandClipartIOSButtons)(true));
	                return;
	            }
	
	            this.props.dispatch((0, _MenuActions.expandClipartIOSButtons)(false));
	        }
	
	        this.props.dispatch((0, _MenuActions.changeClipartCategory)(this.props.index));
	
	        if (this.props.index == 2) {
	            if (_PlayController2.default.isAudioEditorAvailable()) _PlayController2.default.toggleAudioEditorMode(true);
	
	            _VideoUtils2.default.executeAction('reset');
	        } else this.props.dispatch((0, _MenuActions.showMenu)(_MenuType2.default.UNIVERSES_MENU));
	
	        _MasterUniverseUtils2.default.autoselectClipart(this.props.index);
	    },
	    isSearch: function isSearch() {
	        return _StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SEARCH_CONTEXT;
	    },
	    render: function render() {
	        if (!this.isSearch() && !this.props.iosButtonsExpanded && this.props.index != this.props.clipartCategory) {
	            // is collapsed
	            return _react2.default.createElement('div', null);
	        }
	
	        var position = _Properties2.default.CLIPART_BUTTON_HEIGHT * this.props.index;
	        var color;
	        var textColor;
	
	        if (!this.isSearch() && !this.props.iosButtonsExpanded) position = 0;
	
	        if (this.props.index == this.props.clipartCategory) color = _Properties2.default.BROWSER_SELECTED_COLOR;else color = _Properties2.default.RECORDING_MENU_BACKGROUND;
	
	        if (color == _Properties2.default.BROWSER_SELECTED_COLOR) textColor = 'white';else textColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: color,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            left: 0,
	            top: position
	        };
	
	        var lineSize = 1;
	        var lineStyle = {
	            position: 'absolute',
	            backgroundColor: 'white',
	            width: tabStyle.width,
	            height: lineSize,
	            left: 0,
	            top: tabStyle.height - lineSize,
	            display: 'block'
	        };
	
	        var gap = 20;
	        var spanStyle = {
	            color: textColor,
	            fontSize: 15,
	            position: 'absolute',
	            top: 6,
	            width: this.props.accordionWidth - 2 * gap,
	            left: gap,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            textAlign: 'left',
	            cursor: 'default'
	        };
	
	        var text;
	
	        if (this.props.index == 0) text = _LocalesManager2.default.getCaption('cartoonsCategory', 'other');else if (this.props.index == 1) text = _LocalesManager2.default.getCaption('videoCategory', 'other');else text = _LocalesManager2.default.getCaption('audioCategory', 'other');
	
	        var button;
	
	        if (!this.props.iosButtonsExpanded && !this.isSearch()) {
	            var iconStyle = {
	                position: 'absolute',
	                top: 6,
	                right: 18,
	                color: 'white',
	                cursor: 'default',
	                userSelect: 'none',
	                WebkitUserSelect: 'none',
	                userDrag: 'none'
	            };
	
	            button = _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-angle-down' });
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: tabStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            ),
	            button,
	            _react2.default.createElement('span', { style: lineStyle })
	        );
	    }
	});
	
	var ClipartButton = _react2.default.createClass({
	    displayName: 'ClipartButton',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.isUniversesVisible == true) this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.UNIVERSES_MENU]));else this.props.dispatch((0, _MenuActions.showMenu)(_MenuType2.default.UNIVERSES_MENU));
	    },
	    render: function render() {
	        var tabStyle = {
	            position: 'absolute',
	            backgroundColor: this.props.color,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            paddingLeft: 20,
	            top: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            margin: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            textAlign: 'left',
	            borderStyle: 'none',
	            paddingRight: 0,
	            paddingBottom: 0,
	            paddingTop: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            position: 'absolute',
	            top: 6,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 6,
	            right: _Properties2.default.BROWSER_LEFT_PADDING + _Properties2.default.BROWSER_ICON_RIGHT_PADDING,
	            color: 'white'
	        };
	
	        var title;
	
	        if (_AppParameters2.default.currentVideoTheme == '') {
	            title = _LocalesManager2.default.getCaption('PleaseSelectTheme', 'other');
	
	            if (!title || title == 'null' || title.length < 1) title = 'Please select a theme!';
	        } else {
	            title = _MasterUniverseUtils2.default.getCurrentVideoThemeTitle();
	        }
	
	        var topLine = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: tabStyle.width,
	            height: 1,
	            background: 'white',
	            display: 'block'
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': title, style: tabStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement('span', { style: topLine }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                title
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-angle-down' })
	        );
	    }
	});
	
	var ClipartSelectorNewContent = _react2.default.createClass({
	    displayName: 'ClipartSelectorNewContent',
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            top: 0,
	            left: 0
	        };
	
	        var buttonsHolder;
	        var listHolder;
	
	        if (_PlatformDetection2.default.isIOS() && this.props.contextMode == _ModeConstants2.default.SEARCH_CONTEXT) {
	            // not include list
	        } else {
	            if (this.props.clipartCategory == 0) {
	                if (this.props.isMainUniverse) listHolder = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(UniverseButton, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, isMainUniverse: this.props.isMainUniverse }),
	                    _react2.default.createElement(_MainUniversesList.MainUniversesList, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight, refreshValue: this.props.refreshValue })
	                );else listHolder = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(UniverseButton, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, isMainUniverse: this.props.isMainUniverse }),
	                    _react2.default.createElement(ThemeButton, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, isUniversesVisible: this.props.isUniversesVisible }),
	                    _react2.default.createElement(_ClipartSelectorListNew.ClipartSelectorListNew, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight, isUniversesVisible: this.props.isUniversesVisible })
	                );
	            } else if (this.props.clipartCategory == 1) {
	                listHolder = _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(ClipartButton, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, color: _Properties2.default.BROWSER_SELECTED_COLOR, isUniversesVisible: this.props.isUniversesVisible }),
	                    _react2.default.createElement(_ClipartSelectorList.ClipartSelectorList, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight, isUniversesVisible: this.props.isUniversesVisible })
	                );
	            } else {
	                listHolder = _react2.default.createElement(_AudioTab.AudioTab, { accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight, dispatch: this.props.dispatch });
	            }
	        }
	
	        if (_PlatformDetection2.default.isIOS()) {
	            buttonsHolder = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(ExpandedButton, { accordionWidth: this.props.accordionWidth, index: 0, dispatch: this.props.dispatch, clipartCategory: this.props.clipartCategory, iosButtonsExpanded: this.props.iosButtonsExpanded }),
	                _react2.default.createElement(ExpandedButton, { accordionWidth: this.props.accordionWidth, index: 1, dispatch: this.props.dispatch, clipartCategory: this.props.clipartCategory, iosButtonsExpanded: this.props.iosButtonsExpanded }),
	                _react2.default.createElement(ExpandedButton, { accordionWidth: this.props.accordionWidth, index: 2, dispatch: this.props.dispatch, clipartCategory: this.props.clipartCategory, iosButtonsExpanded: this.props.iosButtonsExpanded })
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'universesSelector', style: menuStyle },
	                listHolder,
	                buttonsHolder
	            );
	        } else {
	            buttonsHolder = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 0, dispatch: this.props.dispatch, clipartCategory: this.props.clipartCategory }),
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 1, dispatch: this.props.dispatch, clipartCategory: this.props.clipartCategory }),
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 2, dispatch: this.props.dispatch, clipartCategory: this.props.clipartCategory })
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { id: 'universesSelector', style: menuStyle },
	                buttonsHolder,
	                listHolder
	            );
	        }
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var isUniversesVisible = state.menu.isUniversesVisible;
	    var isMainUniverse = state.menu.isMainUniverse;
	    var accordionWidth = state.accordion.width;
	    var clipartCategory = state.menu.clipartCategory;
	    var iosButtonsExpanded = state.menu.iosButtonsExpanded;
	    var contextMode = state.menu.contextMode;
	    var refreshValue = state.menu.refreshValue;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    if (isUniversesVisible == undefined) isUniversesVisible = false;
	
	    if (clipartCategory == undefined) clipartCategory = 0;
	
	    if (iosButtonsExpanded == undefined) iosButtonsExpanded = false;
	
	    if (isMainUniverse == undefined) isMainUniverse = true;
	
	    return {
	        isUniversesVisible: isUniversesVisible,
	        accordionWidth: accordionWidth,
	        clipartCategory: clipartCategory,
	        iosButtonsExpanded: iosButtonsExpanded,
	        contextMode: contextMode,
	        isMainUniverse: isMainUniverse,
	        refreshValue: refreshValue
	    };
	}
	
	var ClipartSelectorNew = exports.ClipartSelectorNew = (0, _reactRedux.connect)(mapStateToProps)(ClipartSelectorNewContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorNew.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ClipartSelectorNew.js"); } } })();

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CroppingMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _reactRedux = __webpack_require__(10);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _SizeAndPositionButtons = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                _LocalesManager2.default.getCaption('CroppingMenuTitle')
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        setTimeout(function () {
	            _ZoomUtils2.default.updateCroppingInitialPosition = true;
	        }.bind(this), 200);
	
	        if (!_ZoomUtils2.default.croppingTarget) {
	            _ZoomUtils2.default.croppingTargetRotation = 0;
	            this.props.dispatch((0, _MenuActions.showCroppingMenu)(false));
	            return;
	        }
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // CROPPING ELEMENT
	                    setTimeout(function () {
	                        this.props.dispatch((0, _CurrentSlideActions.updateCroppingHospot)(_ZoomUtils2.default.croppingTarget.uuid, _ZoomUtils2.default.currentCroppingHotspot));
	                        _AudioEditorUtils2.default.addActionToHistory();
	                        this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	                        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	                        this.props.dispatch((0, _MenuActions.showCroppingMenu)(false));
	                        _SaveManager2.default.isContentChanged(true);
	                    }.bind(this), 10);
	                    break;
	                }
	
	            case 1:
	                {
	                    // RESET CROPPING
	                    if (this.isResetEnabled() == true) {
	                        _SaveManager2.default.isContentChanged(true);
	                        this.props.dispatch((0, _CurrentSlideActions.updateCroppingHospot)(_ZoomUtils2.default.croppingTarget.uuid, ''));
	                        _AudioEditorUtils2.default.addActionToHistory();
	                        this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	                        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	                        this.props.dispatch((0, _MenuActions.showCroppingMenu)(false));
	                        _ZoomUtils2.default.currentCroppingHotspot = undefined;
	                    }
	                    break;
	                }
	
	            case 2:
	                {
	                    // CANCEL
	                    this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	                    this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	                    this.props.dispatch((0, _CurrentSlideActions.selectShape)(''));
	                    this.props.dispatch((0, _MenuActions.showCroppingMenu)(false));
	                    break;
	                }
	        }
	
	        if (_ZoomUtils2.default.croppingTargetRotation != 0) {
	            this.props.dispatch((0, _CurrentSlideActions.updateShapeRotation)(_ZoomUtils2.default.croppingTarget.uuid, _ZoomUtils2.default.croppingTargetRotation));
	            _ZoomUtils2.default.croppingTargetRotation = 0;
	        }
	    },
	    isResetEnabled: function isResetEnabled() {
	        if (this.props.index != 1) return false;
	
	        var shapeModel = _ZoomUtils2.default.croppingTarget;
	
	        if (shapeModel && shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') return true;else return false;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var iconColor;
	        var buttonColor;
	        var tabIndexValue;
	
	        if (this.props.index == 0) {
	            if (this.state.isOver == true) {
	                iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	            } else {
	                iconColor = 'black';
	                buttonColor = '#48A5E5';
	            }
	        } else if (this.props.index == 1 && this.isResetEnabled() == false) {
	            iconColor = '#CFCFCF';
	            buttonColor = '#EEEEEE';
	            tabIndexValue = '-1';
	        } else {
	            if (this.state.isOver == true) {
	                iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	            } else {
	                iconColor = 'black';
	                buttonColor = '#DCDCDC';
	            }
	        }
	
	        var topPosition = 5 + this.props.index * (_Properties2.default.OBJECT_ADVANCED_BUTTON_HEIGHT + 5);
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth - _Properties2.default.BROWSER_LEFT_PADDING,
	            height: _Properties2.default.OBJECT_ADVANCED_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: _Properties2.default.BROWSER_LEFT_PADDING,
	            top: topPosition,
	            color: 'white',
	            paddingTop: 0,
	            paddingBottom: 0,
	            paddingRight: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            fontSize: 18,
	            textAlign: 'center',
	            width: buttonStyle.width,
	            top: 0
	        };
	
	        var buttonId;
	
	        if (this.props.index == 0) buttonId = 'croppingMenuFirstFocusableElement';
	
	        if (this.props.index == 2) buttonId = 'croppingMenuLastFocusableElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: buttonId, 'aria-label': this.props.text, tabIndex: tabIndexValue, 'aria-disabled': tabIndexValue == '-1' ? true : false, style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var CroppingMenuContent = _react2.default.createClass({
	    displayName: 'CroppingMenuContent',
	    getInitialState: function getInitialState() {
	        return {
	            currentAlert: 'none'
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.refreshShapePosition != nextProps.refreshShapePosition) {
	            this.forceUpdate();
	            return;
	        }
	
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('croppingMenuFirstFocusableElement');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    getHotSpot: function getHotSpot() {
	        var shapeModel = this.getContextTarget();
	
	        if (!shapeModel) return {};
	
	        if (_ZoomUtils2.default.currentCroppingHotspot && _ZoomUtils2.default.currentCroppingHotspot.x1 >= 0) return _ZoomUtils2.default.currentCroppingHotspot;
	
	        if (shapeModel.hotSpot) {
	            return {
	                x1: shapeModel.hotSpot.x1,
	                x2: shapeModel.hotSpot.x2,
	                y1: shapeModel.hotSpot.y1,
	                y2: shapeModel.hotSpot.y2
	            };
	        } else {
	            return {
	                x1: 0,
	                x2: 100,
	                y1: 0,
	                y2: 100
	            };
	        }
	    },
	    getContextTarget: function getContextTarget() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	
	        for (var i = 1; i < shapes.length; i++) {
	            if (shapes[i].uuid === _ZoomUtils2.default.croppingTarget.uuid) return shapes[i];
	        }
	
	        return _ZoomUtils2.default.croppingTarget;
	    },
	    changeCrop: function changeCrop(property, value) {
	        if (_ZoomUtils2.default.updateCurrentCroppingHotspot) {
	            value = parseInt(value);
	            var absoluteValue = Math.abs(value) || 0;
	            _ZoomUtils2.default.updateCurrentCroppingHotspot(property, absoluteValue);
	        }
	    },
	    onFocusHandler: function onFocusHandler(property) {
	        this.setState({
	            currentAlert: property
	        });
	    },
	    onBlurHandler: function onBlurHandler(property) {
	        this.checkCorrectValue(property);
	
	        this.setState({
	            currentAlert: 'none'
	        });
	    },
	    checkCorrectValue: function checkCorrectValue(property) {
	        var minSize = 30;
	        var realShape = this.getRealShapeSize(_ZoomUtils2.default.croppingTarget);
	        var localHotSpot = { x1: _ZoomUtils2.default.currentCroppingHotspot.x1, x2: _ZoomUtils2.default.currentCroppingHotspot.x2, y1: _ZoomUtils2.default.currentCroppingHotspot.y1, y2: _ZoomUtils2.default.currentCroppingHotspot.y2 };
	        var xMinLimitPercents = Math.ceil(minSize * 100 / realShape.width);
	        var yMinLimitPercents = Math.ceil(minSize * 100 / realShape.height);
	
	        switch (property) {
	            case 'x1':
	                {
	                    if (localHotSpot.x1 + xMinLimitPercents > localHotSpot.x2) localHotSpot.x1 = localHotSpot.x2 - xMinLimitPercents;
	                    break;
	                }
	            case 'x2':
	                {
	                    if (localHotSpot.x2 > 100) localHotSpot.x2 = 100;
	
	                    if (localHotSpot.x2 - xMinLimitPercents < localHotSpot.x1) localHotSpot.x2 = localHotSpot.x1 + xMinLimitPercents;
	                    break;
	                }
	            case 'y1':
	                {
	                    if (localHotSpot.y1 + yMinLimitPercents > localHotSpot.y2) localHotSpot.y1 = localHotSpot.y2 - yMinLimitPercents;
	                    break;
	                }
	            case 'y2':
	                {
	                    if (localHotSpot.y2 > 100) localHotSpot.y2 = 100;
	
	                    if (localHotSpot.y2 - yMinLimitPercents < localHotSpot.y1) localHotSpot.y2 = localHotSpot.y1 + yMinLimitPercents;
	                    break;
	                }
	        }
	
	        _ZoomUtils2.default.currentCroppingHotspot = localHotSpot;
	
	        if (_ZoomUtils2.default.updateTransformTool) _ZoomUtils2.default.updateTransformTool();
	    },
	    getAlertTopPosition: function getAlertTopPosition() {
	        var value = 0;
	
	        switch (this.state.currentAlert) {
	            case 'x1':
	                {
	                    value = -2;
	                    break;
	                }
	            case 'x2':
	                {
	                    value = 40;
	                    break;
	                }
	            case 'y1':
	                {
	                    value = 83;
	                    break;
	                }
	            case 'y2':
	                {
	                    value = 125;
	                    break;
	                }
	        }
	
	        return value;
	    },
	    getRealShapeSize: function getRealShapeSize(shapeModel) {
	        var newShape;
	
	        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
	            var realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
	            var realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);
	            var x1 = realWidth * shapeModel.hotSpot.x1 / 100;
	            var y1 = realHeight * shapeModel.hotSpot.y1 / 100;
	            newShape = {};
	
	            newShape.width = realWidth;
	            newShape.height = realHeight;
	            newShape.x = shapeModel.x - x1;
	            newShape.y = shapeModel.y - y1;
	        } else newShape = shapeModel;
	
	        return newShape;
	    },
	    getAlertRange: function getAlertRange() {
	        var minSize = 30;
	        var realShape = this.getRealShapeSize(_ZoomUtils2.default.croppingTarget);
	        var localHotSpot = { x1: _ZoomUtils2.default.currentCroppingHotspot.x1, x2: _ZoomUtils2.default.currentCroppingHotspot.x2, y1: _ZoomUtils2.default.currentCroppingHotspot.y1, y2: _ZoomUtils2.default.currentCroppingHotspot.y2 };
	        var xMinLimitPercents = Math.ceil(minSize * 100 / realShape.width);
	        var yMinLimitPercents = Math.ceil(minSize * 100 / realShape.height);
	        var range = '';
	
	        switch (this.state.currentAlert) {
	            case 'x1':
	                {
	                    range = '0 - ' + Math.floor(localHotSpot.x2 - xMinLimitPercents);
	                    break;
	                }
	            case 'x2':
	                {
	                    range = '' + Math.ceil(localHotSpot.x1 + xMinLimitPercents) + ' - 100';
	                    break;
	                }
	            case 'y1':
	                {
	                    range = '0 - ' + Math.floor(localHotSpot.y2 - yMinLimitPercents);
	                    break;
	                }
	            case 'y2':
	                {
	                    range = '' + Math.ceil(localHotSpot.y1 + yMinLimitPercents) + ' - 100';
	                    break;
	                }
	        }
	
	        return range;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth || this.props.showCroppingMenu != newProps.showCroppingMenu || this.state.currentAlert != nextState.currentAlert) return true;else return false;
	    },
	    render: function render() {
	        if (this.props.showCroppingMenu == false) return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white',
	            zIndex: 20000
	        };
	
	        var buttonsHolderStyle = {
	            position: 'absolute',
	            top: _Properties2.default.CLIPART_BUTTON_HEIGHT
	        };
	
	        var smallTextStyle = {
	            fontSize: '12px',
	            marginTop: '15px',
	            marginBottom: '-5px'
	        };
	
	        var buttonWrapperStyle = {
	            display: 'flex',
	            flexWrap: 'wrap',
	            marginTop: '10px',
	            justifyContent: 'space-between'
	        };
	
	        var hotSpot = this.getHotSpot();
	
	        var gap = 10;
	        var bottomStyle = {
	            position: 'absolute',
	            top: 200,
	            marginLeft: gap,
	            marginRight: gap
	        };
	
	        var alertHeight = 30;
	        var fillOutFieldViewWidth = menuStyle.width - 2 * gap;
	        var fillOutFieldViewStyle = {
	            position: 'absolute',
	            background: '#434343',
	            width: fillOutFieldViewWidth,
	            height: alertHeight,
	            top: this.getAlertTopPosition(),
	            left: 0,
	            borderRadius: 5,
	            zIndex: 99999,
	            pointerEvents: 'none'
	        };
	
	        var stemStyle = {
	            position: 'absolute',
	            borderWidth: 10,
	            borderStyle: 'solid',
	            borderBottomColor: 'transparent',
	            borderTopColor: '#434343',
	            borderLeftColor: 'transparent',
	            borderRightColor: 'transparent',
	            top: alertHeight,
	            left: fillOutFieldViewWidth - 50
	        };
	
	        var captionStyle = {
	            position: 'absolute',
	            color: 'white',
	            wordWrap: 'break-word',
	            textAlign: 'center',
	            fontSize: 12,
	            left: 5,
	            top: 8,
	            width: fillOutFieldViewWidth - 10
	        };
	
	        var fillOutFieldView;
	        var isFocus = this.state.currentAlert != 'none';
	
	        if (isFocus) {
	            var alertText = _LocalesManager2.default.getCaption('cropingAlertMessage', 'other') + ' ' + this.getAlertRange();
	
	            fillOutFieldView = _react2.default.createElement(
	                'div',
	                { style: fillOutFieldViewStyle, role: 'alert' },
	                _react2.default.createElement('div', { style: stemStyle }),
	                _react2.default.createElement(
	                    'div',
	                    { style: captionStyle },
	                    alertText
	                )
	            );
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'croppingMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(
	                'div',
	                { style: buttonsHolderStyle },
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 0, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('SetCropping') }),
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 1, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('ResetCropping') }),
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 2, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Cancel', 'save') })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: bottomStyle },
	                _react2.default.createElement(
	                    'h3',
	                    { style: smallTextStyle },
	                    _LocalesManager2.default.getCaption('Crop', 'sizePosMenu')
	                ),
	                fillOutFieldView,
	                _react2.default.createElement(
	                    'div',
	                    { style: buttonWrapperStyle },
	                    _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('CropLeft', 'sizePosMenu') + ' (%)', value: hotSpot.x1, property: 'x1', onChangeHandler: this.changeCrop, onFocusHandler: this.onFocusHandler, onBlurHandler: this.onBlurHandler }),
	                    _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('CropRight', 'sizePosMenu') + ' (%)', value: hotSpot.x2, property: 'x2', onChangeHandler: this.changeCrop, onFocusHandler: this.onFocusHandler, onBlurHandler: this.onBlurHandler }),
	                    _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('CropTop', 'sizePosMenu') + ' (%)', value: hotSpot.y1, property: 'y1', onChangeHandler: this.changeCrop, onFocusHandler: this.onFocusHandler, onBlurHandler: this.onBlurHandler }),
	                    _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('CropBottom', 'sizePosMenu') + ' (%)', value: hotSpot.y2, property: 'y2', onChangeHandler: this.changeCrop, onFocusHandler: this.onFocusHandler, onBlurHandler: this.onBlurHandler })
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var showCroppingMenu = state.menu.showCroppingMenu;
	    var refreshShapePosition = state.menu.refreshShapePosition;
	
	    if (showCroppingMenu == undefined) showCroppingMenu = false;
	
	    return {
	        showCroppingMenu: showCroppingMenu,
	        refreshShapePosition: refreshShapePosition
	    };
	}
	
	var CroppingMenu = exports.CroppingMenu = (0, _reactRedux.connect)(mapStateToProps)(CroppingMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/CroppingMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/CroppingMenu.js"); } } })();

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DownloadPage = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _DownloadUtils = __webpack_require__(849);
	
	var _DownloadUtils2 = _interopRequireDefault(_DownloadUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onButtonClick: function onButtonClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.index == 1) {
	            // Go back to Dashboard
	            if (!_AppParameters2.default.isExportTab) window.location.href = _AppParameters2.default.backToDashboardLink;else {
	                if (_Configuration2.default.IS_PROD()) window.location.href = 'https://www.creaza.com/portfolio/myFiles/exported#/myFiles/exported';else window.location.href = 'https://stage.creaza.com/portfolio/myFiles/exported#/myFiles/exported';
	            }
	        } else {
	            // Export video
	            this.props.updateState(true, false);
	
	            _DownloadUtils2.default.download(_AppParameters2.default.downloadId);
	        }
	    },
	    render: function render() {
	        var textColor;
	        var fillColor;
	
	        if (this.state.isOver) {
	            fillColor = _Properties2.default.SLIDE_VIEWER_BACKGROUND;
	            textColor = 'black';
	        } else {
	            textColor = 'black';
	            fillColor = 'white';
	        }
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: fillColor,
	            width: this.props.width,
	            height: this.props.height,
	            top: this.props.topPosition,
	            left: this.props.leftPosition,
	            borderRadius: 10,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#333333'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 20,
	            fontSize: 18,
	            width: this.props.width - 6,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            alignItems: 'center',
	            textAlign: 'center',
	            cursor: 'default',
	            color: textColor
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onButtonClick, onClick: this.onButtonClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var DownloadPage = exports.DownloadPage = _react2.default.createClass({
	    displayName: 'DownloadPage',
	    getInitialState: function getInitialState() {
	        return {
	            isDownloadStarted: false,
	            isDownloadFinished: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        _DownloadUtils2.default.downloadFinishedCallback = this.downloadFinished;
	        _DownloadUtils2.default.checkType();
	    },
	    downloadFinished: function downloadFinished() {
	        this.setState({
	            isDownloadStarted: false,
	            isDownloadFinished: true
	        });
	    },
	    updateState: function updateState(isDownloadStarted, isDownloadFinished) {
	        this.setState({
	            isDownloadStarted: isDownloadStarted,
	            isDownloadFinished: isDownloadFinished
	        });
	    },
	    render: function render() {
	        var width = this.props.windowWidth - 200;
	        var height = 200;
	        var buttonWidth = 200;
	        var buttonHeight = 60;
	        var gap = 20;
	        var topPosition;
	
	        var menuStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            top: this.props.windowHeight / 2 - height / 2,
	            left: this.props.windowWidth / 2 - width / 2
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            fontSize: 20,
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            textAlign: 'center',
	            cursor: 'default',
	            top: 0
	        };
	
	        topPosition = height - buttonHeight - gap;
	
	        var elements = [];
	        var text;
	        var goBackPosition;
	        var downloadPosition;
	
	        if (this.state.isDownloadStarted) {
	            text = _LocalesManager2.default.getCaption('downloadStarted', 'download');
	
	            var size = 48;
	
	            var loaderStyle = {
	                position: 'absolute',
	                top: height - buttonHeight - gap,
	                left: width / 2 - size / 2,
	                color: 'black'
	            };
	
	            elements.push(_react2.default.createElement('i', { style: loaderStyle, key: 'download3', className: 'fa fa-spinner fa-pulse fa-3x' }));
	        } else if (this.state.isDownloadFinished) {
	            text = _LocalesManager2.default.getCaption('finished', 'download');
	            goBackPosition = width / 2 - buttonWidth / 2;
	            elements.push(_react2.default.createElement(Button, { topPosition: topPosition, leftPosition: goBackPosition, width: buttonWidth, height: buttonHeight, index: 1, updateState: this.updateState, key: 'download3', text: _LocalesManager2.default.getCaption('backToDashboardAfterDownload', 'download') }));
	        } else {
	            text = _LocalesManager2.default.getCaption('downloadToCameraRoll', 'download');
	            downloadPosition = width / 2 - gap / 2 - buttonWidth;
	            goBackPosition = width / 2 + gap / 2;
	            elements.push(_react2.default.createElement(Button, { topPosition: topPosition, leftPosition: downloadPosition, width: buttonWidth, height: buttonHeight, index: 0, updateState: this.updateState, key: 'download1', text: _LocalesManager2.default.getCaption('download', 'download') }));
	            elements.push(_react2.default.createElement(Button, { topPosition: topPosition, leftPosition: goBackPosition, width: buttonWidth, height: buttonHeight, index: 1, updateState: this.updateState, key: 'download2', text: _LocalesManager2.default.getCaption('backToDashboard', 'download') }));
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            ),
	            elements
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/DownloadPage.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/DownloadPage.js"); } } })();

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DrawingMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _DrawingUtils = __webpack_require__(108);
	
	var _DrawingUtils2 = _interopRequireDefault(_DrawingUtils);
	
	var _OnOffToggleButton = __webpack_require__(122);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        var title;
	
	        if (this.props.contextMode == _ModeConstants2.default.FREEHAND_CONTEXT) title = _LocalesManager2.default.getCaption('freehand', 'drawing');else title = _LocalesManager2.default.getCaption('line', 'drawing');
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                title
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Cancel
	                    _DrawingUtils2.default.executeAction('cancel');
	                    break;
	                }
	
	            case 1:
	                {
	                    // OK
	                    _DrawingUtils2.default.executeAction('ok');
	                    break;
	                }
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth || this.props.windowHeight != newProps.windowHeight) return true;else return false;
	    },
	    render: function render() {
	        var textColor;
	        var buttonColor;
	
	        if (this.props.index == 1) {
	            if (this.state.isOver == true) {
	                textColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	            } else {
	                textColor = 'black';
	                buttonColor = '#48A5E5';
	            }
	        } else {
	            if (this.state.isOver == true) {
	                textColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	            } else {
	                textColor = 'black';
	                buttonColor = '#DCDCDC';
	            }
	        }
	
	        var buttonWidth = this.props.accordionWidth;
	        var buttonHeight = 50;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: buttonWidth,
	            height: buttonHeight,
	            display: 'flex',
	            alignItems: 'center',
	            left: 0,
	            top: this.props.windowHeight - (this.props.index + 1) * (buttonHeight + 5),
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            color: textColor,
	            fontSize: 18,
	            position: 'absolute',
	            width: buttonWidth,
	            cursor: 'default',
	            textAlign: 'center',
	            top: 14
	        };
	
	        var idValue = this.props.index == 1 ? 'firstFocusableObject' : 'drawingFreehandLastFocusableElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, 'aria-label': this.props.text, style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var Element = _react2.default.createClass({
	    displayName: 'Element',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    getStrokeWidth: function getStrokeWidth() {
	        var strokeWidth = 3;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    strokeWidth = 11;
	                    break;
	                }
	            case 1:
	                {
	                    strokeWidth = 9;
	                    break;
	                }
	            case 2:
	                {
	                    strokeWidth = 7;
	                    break;
	                }
	            case 3:
	                {
	                    strokeWidth = 5;
	                    break;
	                }
	            case 4:
	                {
	                    strokeWidth = 3;
	                    break;
	                }
	        }
	
	        return strokeWidth;
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.index < 5) this.props.dispatch((0, _MenuActions.changeDrawingProperties)('strokeWidth', this.getStrokeWidth()));else this.props.dispatch((0, _MenuActions.changeDrawingProperties)('strokeColor', this.props.fillColor));
	    },
	    isSelected: function isSelected() {
	        var drawingProperties = _DrawingUtils2.default.getDrawingProperties();
	
	        if (this.props.index < 5) {
	            var strokeWidth = this.getStrokeWidth();
	
	            if (drawingProperties.strokeWidth == strokeWidth) return true;else return false;
	        } else {
	            if (this.props.fillColor == drawingProperties.strokeColor) return true;else return false;
	        }
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    render: function render() {
	        var opacity = 1;
	
	        if (this.state.isOver) opacity = 0.5;
	
	        var color = this.props.borderColor;
	        var borderSize = this.props.borderSize;
	
	        if (this.isSelected()) {
	            color = _Properties2.default.CONTEXT_HOVER_COLOR;
	            borderSize = 4;
	        }
	
	        var elementStyle = {
	            position: 'absolute',
	            width: this.props.radius * 2,
	            height: this.props.radius * 2,
	            background: this.props.fillColor,
	            borderColor: color,
	            borderWidth: borderSize,
	            borderStyle: 'solid',
	            borderRadius: 50,
	            left: this.props.centerX - this.props.radius,
	            top: this.props.centerY - this.props.radius,
	            opacity: opacity,
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial'
	        };
	
	        var ariaLabel = '';
	
	        if (this.props.index < 5) ariaLabel = _LocalesManager2.default.getCaption('changeLineSize', 'other');else ariaLabel = _LocalesManager2.default.getCaption('changeLineColor', 'other');
	
	        return _react2.default.createElement('button', { 'aria-label': ariaLabel, style: elementStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut });
	    }
	});
	
	var DrawingMenu = exports.DrawingMenu = _react2.default.createClass({
	    displayName: 'DrawingMenu',
	    componentDidMount: function componentDidMount() {
	        _DrawingUtils2.default.dispatch = this.props.dispatch;
	
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('firstFocusableObject');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        setTimeout(this.updateView, 10);
	    },
	    updateView: function updateView() {
	        var state = _StoreManager2.default.getState();
	        var contextMode = state.menu.contextMode;
	
	        if (contextMode == _ModeConstants2.default.FREEHAND_CONTEXT || contextMode == _ModeConstants2.default.LINE_CONTEXT) this.forceUpdate();
	    },
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var radiusSize = [];
	        var startRadius = 28;
	        var radiusOffset = 4;
	        var i;
	        var xPositions = [];
	        var leftPos = 63;
	        var leftPosForFill = 80;
	        var gap = 10;
	        var gapColor = 25;
	
	        if (_PlatformDetection2.default.isIOS()) {
	            startRadius = 24;
	            leftPos = 30;
	            gap = 8;
	            leftPosForFill = 37;
	        }
	
	        var currentX = leftPos;
	        var radius = startRadius;
	
	        for (i = 0; i < 5; i++) {
	            xPositions.push(currentX);
	            radiusSize.push(radius);
	
	            currentX = currentX + 2 * radius + gap;
	            radius = radius - radiusOffset;
	        }
	
	        var onOffButtonProperties = {};
	
	        onOffButtonProperties.leftPosition = _Properties2.default.MY_MEDIA_FILES_GAP;
	        onOffButtonProperties.trackWidth = _Properties2.default.TOGGLE_TRACK_WIDTH;
	        onOffButtonProperties.trackHeight = _Properties2.default.TOGGLE_TRACK_HEIGHT;
	        onOffButtonProperties.thumbHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
	        onOffButtonProperties.thumbSize = _Properties2.default.TOGGLE_THUMB_SIZE;
	        onOffButtonProperties.dispatch = this.props.dispatch;
	        onOffButtonProperties.width = _Properties2.default.BROWSER_WIDTH - 2 * _Properties2.default.MY_MEDIA_FILES_GAP;
	        onOffButtonProperties.topPosition = _Properties2.default.CLIPART_BUTTON_HEIGHT + 20;
	
	        onOffButtonProperties.isDrawing = true;
	        onOffButtonProperties.groupDrawingShapes = this.props.groupDrawingShapes;
	
	        var brushStyle = {
	            position: 'absolute',
	            top: onOffButtonProperties.topPosition + 40,
	            left: this.props.accordionWidth / 2 - 15,
	            color: 'black'
	        };
	
	        var pencilStyle = {
	            position: 'absolute',
	            top: 420,
	            left: this.props.accordionWidth / 2 - 15,
	            color: 'black'
	        };
	
	        var strokeSizeTopPosition = 510;
	        var offsetY = 0;
	        var offsetY2 = 0;
	        var offsetY3 = 0;
	
	        if (strokeSizeTopPosition + radiusSize[0] > this.props.windowHeight - 2 * 55 - 10) {
	            brushStyle.top = brushStyle.top - 15;
	            pencilStyle.top = pencilStyle.top - 80;
	            offsetY = 30;
	            offsetY2 = 40;
	            offsetY3 = 90;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, onTouchEnd: this.onClick, onClick: this.onClick, id: 'drawingMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth, contextMode: this.props.contextMode }),
	            _react2.default.createElement(_OnOffToggleButton.OnOffToggleButton, { id: 'firstFocusableElement', properties: onOffButtonProperties, dispatch: this.props.dispatch }),
	            _react2.default.createElement('i', { style: brushStyle, className: 'fa fa-tint fa-3x' }),
	            _react2.default.createElement('i', { style: pencilStyle, className: 'fa fa-pencil fa-3x' }),
	            _react2.default.createElement(Element, { index: 5, radius: startRadius, fillColor: '#3F53AA', borderColor: '#3F53AA', borderSize: 2, centerX: leftPosForFill, centerY: 190 - offsetY, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 6, radius: startRadius, fillColor: '#EA4033', borderColor: '#EA4033', borderSize: 2, centerX: leftPosForFill + 2 * startRadius + gapColor, centerY: 190 - offsetY, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 7, radius: startRadius, fillColor: '#FFFFFF', borderColor: '#868686', borderSize: 2, centerX: leftPosForFill + 4 * startRadius + 2 * gapColor, centerY: 190 - offsetY, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 8, radius: startRadius, fillColor: '#5DB547', borderColor: '#5DB547', borderSize: 2, centerX: leftPosForFill, centerY: 270 - offsetY2, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 9, radius: startRadius, fillColor: '#F08734', borderColor: '#F08734', borderSize: 2, centerX: leftPosForFill + 2 * startRadius + gapColor, centerY: 270 - offsetY2, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 10, radius: startRadius, fillColor: '#868686', borderColor: '#868686', borderSize: 2, centerX: leftPosForFill + 4 * startRadius + 2 * gapColor, centerY: 270 - offsetY2, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 11, radius: startRadius, fillColor: '#F1F12D', borderColor: '#F1F12D', borderSize: 2, centerX: leftPosForFill, centerY: 340 - offsetY2, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 12, radius: startRadius, fillColor: '#8B3492', borderColor: '#8B3492', borderSize: 2, centerX: leftPosForFill + 2 * startRadius + gapColor, centerY: 340 - offsetY2, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 13, radius: startRadius, fillColor: 'black', borderColor: '#010101', borderSize: 2, centerX: leftPosForFill + 4 * startRadius + 2 * gapColor, centerY: 340 - offsetY2, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 0, radius: radiusSize[0], fillColor: 'black', borderColor: 'black', borderSize: 2, centerX: xPositions[0], centerY: strokeSizeTopPosition - offsetY3, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 1, radius: radiusSize[1], fillColor: 'black', borderColor: 'black', borderSize: 2, centerX: xPositions[1], centerY: strokeSizeTopPosition - offsetY3, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 2, radius: radiusSize[2], fillColor: 'black', borderColor: 'black', borderSize: 2, centerX: xPositions[2], centerY: strokeSizeTopPosition - offsetY3, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 3, radius: radiusSize[3], fillColor: 'black', borderColor: 'black', borderSize: 2, centerX: xPositions[3], centerY: strokeSizeTopPosition - offsetY3, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Element, { index: 4, radius: radiusSize[4], fillColor: 'black', borderColor: 'black', borderSize: 2, centerX: xPositions[4], centerY: strokeSizeTopPosition - offsetY3, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Button, { index: 1, text: _LocalesManager2.default.getCaption('DrawingOk', 'other'), dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight }),
	            _react2.default.createElement(Button, { index: 0, text: _LocalesManager2.default.getCaption('Cancel', 'save'), dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/DrawingMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/DrawingMenu.js"); } } })();

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EffectsMenu = exports.EffectsMenuContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    selectedFilter: function selectedFilter() {
	        if (!this.props.contextTarget) return 2;
	
	        return this.props.selectedEffect;
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    updateThumbnail: function updateThumbnail() {
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var selectedFilter = this.selectedFilter();
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Shadow
	                    if (selectedFilter != 0) {
	                        this.props.dispatch((0, _CurrentSlideActions.changeFilter)(this.props.contextTarget, ''));
	                        setTimeout(this.addShadow, 3);
	                    }
	                    break;
	                }
	
	            case 1:
	                {
	                    // Silhouette
	                    if (selectedFilter != 1) {
	                        this.props.dispatch((0, _CurrentSlideActions.changeFilter)(this.props.contextTarget, ''));
	                        setTimeout(this.addSilhouette, 3);
	                    }
	                    break;
	                }
	
	            case 2:
	                {
	                    // None
	                    if (selectedFilter != 2) this.props.dispatch((0, _CurrentSlideActions.changeFilter)(this.props.contextTarget, ''));
	                    break;
	                }
	        }
	
	        _AudioEditorUtils2.default.addActionToHistory();
	        _SaveManager2.default.isContentChanged(true);
	
	        this.updateThumbnail();
	    },
	    addShadow: function addShadow() {
	        this.props.dispatch((0, _CurrentSlideActions.changeFilter)(this.props.contextTarget, 'url(#2)'));
	        _SaveManager2.default.isContentChanged(true);
	    },
	    addSilhouette: function addSilhouette() {
	        this.props.dispatch((0, _CurrentSlideActions.changeFilter)(this.props.contextTarget, 'url(#5)'));
	        _SaveManager2.default.isContentChanged(true);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth || this.props.selectedEffect != newProps.selectedEffect || this.props.contextTarget != newProps.contextTarget) return true;else return false;
	    },
	    render: function render() {
	        var iconColor;
	        var buttonColor;
	
	        if (this.state.isOver == true) {
	            iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	            buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	        } else {
	            iconColor = 'black';
	            buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	        }
	
	        var topPosition = this.props.index * _Properties2.default.EFFECTS_BUTTON_HEIGHT;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth - 3 * _Properties2.default.EFFECTS_PADDING - 2 * 14,
	            height: _Properties2.default.EFFECTS_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: _Properties2.default.BROWSER_LEFT_PADDING,
	            top: topPosition,
	            color: 'white',
	            margin: 0,
	            paddingRight: 0,
	            paddingTop: 0,
	            paddingBottom: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none',
	            textAlign: 'left'
	        };
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            fontSize: 15,
	            top: 0
	        };
	
	        var iconVisible;
	
	        if (this.props.index == this.selectedFilter()) iconVisible = 'block';else iconVisible = 'none';
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 11,
	            right: 20,
	            color: iconColor,
	            display: iconVisible
	        };
	
	        var idValue;
	
	        if (this.props.index == 2) idValue = 'objectContextLastFocusableElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, 'aria-label': this.props.text, style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-check' })
	        );
	    }
	});
	
	var EffectsMenuContent = exports.EffectsMenuContent = _react2.default.createClass({
	    displayName: 'EffectsMenuContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onExpand: function onExpand(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var isExpanded = !this.props.effectsListIsExpanded;
	
	        this.props.dispatch((0, _MenuActions.expandEffectsList)(isExpanded));
	    },
	    onListChanged: function onListChanged(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        setTimeout(this.refreshView, 6);
	    },
	    refreshView: function refreshView() {
	        this.forceUpdate();
	    },
	    selectedFilter: function selectedFilter() {
	        if (!this.props.contextTarget) return 2;
	
	        var state = _StoreManager2.default.getState();
	        var uuid = this.props.contextTarget.uuid;
	        var shapes = state.currentSlide.model.content;
	        var i;
	        var target;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == uuid) {
	                target = shapes[i];
	                break;
	            }
	        }
	
	        if (target == undefined || target.filter == undefined) return 2;
	
	        var filterIndex;
	        var filter = target.filter;
	
	        if (filter.length < 1) // None
	            filterIndex = 2;else {
	            if (filter.indexOf('2') != -1) // Shadow
	                filterIndex = 0;else if (filter.indexOf('5') != -1) // Silhouette
	                filterIndex = 1;else filterIndex = 2;
	        }
	
	        return filterIndex;
	    },
	    getSelectedEffectTitle: function getSelectedEffectTitle() {
	        var index = this.selectedFilter();
	        var effectTitle;
	
	        switch (index) {
	            case 0:
	                {
	                    effectTitle = _LocalesManager2.default.getCaption('Shadow', 'advancedMenu');
	                    break;
	                }
	            case 1:
	                {
	                    effectTitle = _LocalesManager2.default.getCaption('Silhouette', 'advancedMenu');
	                    break;
	                }
	            case 2:
	                {
	                    effectTitle = _LocalesManager2.default.getCaption('None', 'advancedMenu');
	                    break;
	                }
	        }
	
	        return effectTitle;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.contextTarget != newProps.contextTarget || this.props.accordionWidth != newProps.accordionWidth || this.props.effectsListIsExpanded != newProps.effectsListIsExpanded) return true;else return false;
	    },
	    render: function render() {
	        var topPadding = 5;
	        var gap = 2;
	        var buttonTopPosition = _Properties2.default.OBJECT_ADVANCED_MIDDLE_GAP + 6;
	
	        var effectsStyle = {
	            position: 'absolute',
	            top: this.props.top + topPadding,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.EFFECTS_BUTTON_HEIGHT * 4 + topPadding + gap + 1 + buttonTopPosition,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var titleHolderStyle = {
	            position: 'absolute',
	            top: 0,
	            left: _Properties2.default.EFFECTS_PADDING
	        };
	
	        var frontIconStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            color: 'black'
	        };
	
	        var titleStyle = {
	            position: 'absolute',
	            color: 'black',
	            cursor: 'default',
	            fontSize: 16,
	            top: 0,
	            left: 25
	        };
	
	        var borderColor;
	        var textColor;
	
	        if (this.state.isOver == true) {
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            textColor = borderColor;
	        } else {
	            borderColor = _Properties2.default.EFFECTS_BUTTON_BORDER_COLOR;
	            textColor = 'black';
	        }
	
	        var effectsButtonStyle = {
	            width: this.props.accordionWidth - 2 * _Properties2.default.EFFECTS_PADDING,
	            height: _Properties2.default.EFFECTS_BUTTON_HEIGHT,
	            background: 'white',
	            borderRadius: 50,
	            position: 'absolute',
	            left: _Properties2.default.EFFECTS_PADDING,
	            top: buttonTopPosition,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            alignItems: 'center',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            textAlign: 'left'
	        };
	
	        var icon;
	
	        if (this.props.effectsListIsExpanded == true) icon = 'fa fa-angle-down';else icon = 'fa fa-angle-right';
	
	        var effectsIconStyle = {
	            position: 'absolute',
	            top: 12,
	            right: 21,
	            color: textColor
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            color: textColor,
	            cursor: 'default',
	            fontSize: 16,
	            top: 11,
	            paddingLeft: 24
	        };
	
	        var elements = [];
	        var listDisplay;
	
	        if (this.props.effectsListIsExpanded == true) {
	            var selectedEffect = this.selectedFilter();
	
	            elements.push(_react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 0, selectedEffect: selectedEffect, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, key: 'Shadow', text: _LocalesManager2.default.getCaption('Shadow', 'advancedMenu') }));
	            elements.push(_react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 1, selectedEffect: selectedEffect, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, key: 'Silhouette', text: _LocalesManager2.default.getCaption('Silhouette', 'advancedMenu') }));
	            elements.push(_react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 2, selectedEffect: selectedEffect, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, key: 'None', text: _LocalesManager2.default.getCaption('None', 'advancedMenu') }));
	            listDisplay = 'block';
	        } else {
	            listDisplay = 'none';
	        }
	
	        var effectsListStyle = {
	            position: 'absolute',
	            width: this.props.accordionWidth - 2 * _Properties2.default.EFFECTS_PADDING - 2 * _Properties2.default.EFFECTS_CORNER_GAP + 2,
	            height: _Properties2.default.EFFECTS_BUTTON_HEIGHT * 3,
	            top: _Properties2.default.EFFECTS_BUTTON_HEIGHT + 2 + buttonTopPosition,
	            left: _Properties2.default.EFFECTS_PADDING + _Properties2.default.EFFECTS_CORNER_GAP,
	            borderColor: _Properties2.default.EFFECTS_BUTTON_BORDER_COLOR,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            display: listDisplay
	        };
	
	        var idVal = this.props.id;
	
	        if (this.props.effectsListIsExpanded == true) idVal = '';
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'effectsMenu', style: effectsStyle },
	            _react2.default.createElement(
	                'div',
	                { style: titleHolderStyle },
	                _react2.default.createElement('i', { style: frontIconStyle, className: 'fa fa-magic' }),
	                _react2.default.createElement(
	                    'span',
	                    { style: titleStyle },
	                    _LocalesManager2.default.getCaption('EffectsTitle', 'advancedMenu')
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: idVal, 'aria-label': this.getSelectedEffectTitle(), style: effectsButtonStyle, onTouchEnd: this.onExpand, onClick: this.onExpand, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	                _react2.default.createElement(
	                    'span',
	                    { style: spanStyle },
	                    this.getSelectedEffectTitle()
	                ),
	                _react2.default.createElement('i', { style: effectsIconStyle, className: icon })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: effectsListStyle, onTouchEnd: this.onListChanged, onClick: this.onListChanged },
	                elements
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var effectsListIsExpanded = state.menu.effectsListIsExpanded;
	
	    return {
	        effectsListIsExpanded: effectsListIsExpanded
	    };
	}
	
	var EffectsMenu = exports.EffectsMenu = (0, _reactRedux.connect)(mapStateToProps)(EffectsMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/EffectsMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/EffectsMenu.js"); } } })();

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FlipView = undefined;
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SizeAndPositionButtons = __webpack_require__(92);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FlipView = exports.FlipView = _react2.default.createClass({
	    displayName: 'FlipView',
	    getContextTarget: function getContextTarget() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	
	        for (var i = 1; i < shapes.length; i++) {
	            if (shapes[i].uuid === this.props.shapeModel.uuid) return shapes[i];
	        }
	
	        return this.props.shapeModel;
	    },
	    changeFlip: function changeFlip(flipType) {
	        var shapeModel = this.getContextTarget();
	
	        if (!shapeModel) return;
	
	        //Update the voice arrow on speaking bubbles
	        if (shapeModel.type === _ShapeConstants2.default.SPEAK_BUBBLE || shapeModel.type === _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shapeModel.type === _ShapeConstants2.default.THOUGHT_BUBBLE || shapeModel.type === _ShapeConstants2.default.SCREAM_BUBBLE) {
	            var newCx = shapeModel.cx;
	            var newCy = shapeModel.cy;
	
	            if (flipType === "horizontalFlip") {
	                newCx = shapeModel.x + shapeModel.width - (shapeModel.cx - shapeModel.x);
	                this.props.dispatch((0, _CurrentSlideActions.updateBubbleControlPoint)(shapeModel.uuid, newCx, newCy));
	            } else {
	                //verticalFlip
	                //newCy = shapeModel.y + shapeModel.y + shapeModel.width - shapeModel.cy;
	                newCy = shapeModel.y + shapeModel.height - (shapeModel.cy - shapeModel.y);
	                this.props.dispatch((0, _CurrentSlideActions.updateBubbleControlPoint)(shapeModel.uuid, newCx, newCy));
	            }
	        } else {
	            this.props.dispatch((0, _CurrentSlideActions.changeFlip)(shapeModel.uuid, flipType));
	        }
	
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	        this.forceUpdate();
	    },
	    render: function render() {
	        var smallTextStyle = {
	            fontSize: '12px',
	            marginTop: '15px',
	            marginBottom: '-5px'
	        };
	
	        var buttonWrapperStyle = {
	            display: 'flex',
	            flexWrap: 'wrap',
	            marginTop: '10px',
	            justifyContent: 'space-between'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { style: smallTextStyle },
	                _LocalesManager2.default.getCaption('Reflect', 'sizePosMenu')
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: buttonWrapperStyle },
	                _react2.default.createElement(_SizeAndPositionButtons.SecondaryMenuButton, { clickHandler: this.changeFlip, type: 'horizontalFlip', caption: _LocalesManager2.default.getCaption('FlipHorizontal', 'sizePosMenu') }),
	                _react2.default.createElement(_SizeAndPositionButtons.SecondaryMenuButton, { id: 'resizeLastItem', clickHandler: this.changeFlip, type: 'verticalFlip', caption: _LocalesManager2.default.getCaption('FlipVertical', 'sizePosMenu') })
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/FlipView.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/FlipView.js"); } } })();

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FontsSelector = exports.FontsSelectorContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AvailableFonts = __webpack_require__(175);
	
	var _AvailableFonts2 = _interopRequireDefault(_AvailableFonts);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.changeTextProperties();
	    },
	    onButtonClick: function onButtonClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.changeTextProperties();
	    },
	    updateThumbnail: function updateThumbnail() {
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    changeTextProperties: function changeTextProperties() {
	        if (this.props.executeCommand) {
	            this.props.executeCommand(14, this.props.value);
	            return;
	        }
	
	        this.props.dispatch((0, _CurrentSlideActions.changeTextProperties)(this.props.shapeModel, 'fontFamily', this.props.value));
	        _AudioEditorUtils2.default.addActionToHistory();
	        this.updateThumbnail();
	        _SaveManager2.default.isContentChanged(true);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.shapeModel != newProps.shapeModel || this.props.selectedIndex != newProps.selectedIndex || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var iconColor;
	        var buttonColor;
	
	        if (this.state.isOver == true) {
	            iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	            buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	        } else {
	            iconColor = 'black';
	            buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	        }
	
	        var topPosition = this.props.index * _Properties2.default.EFFECTS_BUTTON_HEIGHT;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth - 3 * _Properties2.default.EFFECTS_PADDING - 2 * 14,
	            height: _Properties2.default.EFFECTS_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: _Properties2.default.BROWSER_LEFT_PADDING / 2,
	            top: topPosition,
	            color: 'white',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            fontSize: 20,
	            fontFamily: this.props.value,
	            top: 0
	        };
	
	        var iconVisible;
	
	        if (this.props.index == this.props.selectedIndex) iconVisible = 'block';else iconVisible = 'none';
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 13,
	            right: 10,
	            color: iconColor,
	            display: iconVisible
	        };
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            spanStyle.fontSize = 18;
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': this.props.value, style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onButtonClick, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.value
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-check' })
	        );
	    }
	});
	
	var FontsSelectorContent = exports.FontsSelectorContent = _react2.default.createClass({
	    displayName: 'FontsSelectorContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onExpand: function onExpand(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var isExpanded = !this.props.fontsListIsExpanded;
	        this.props.dispatch((0, _MenuActions.expandFontsList)(isExpanded));
	    },
	    onListChanged: function onListChanged(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        setTimeout(this.refreshView, 6);
	    },
	    checkSize: function checkSize() {
	        if (this.props.isRichTextEditor) return;
	
	        var shapeModel = this.getCurrentShape();
	
	        _TextSizeUtils2.default.updateTextWrapperSize(shapeModel, this.props.dispatch);
	    },
	    refreshView: function refreshView() {
	        this.checkSize();
	        this.forceUpdate();
	    },
	    getCurrentShape: function getCurrentShape() {
	        if (this.props.isRichTextEditor) return undefined;
	
	        var state = _StoreManager2.default.getState();
	        var uuid = this.props.contextTarget.uuid;
	        var shapes = state.currentSlide.model.content;
	        var i;
	        var target;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == uuid) {
	                target = shapes[i];
	                break;
	            }
	        }
	
	        return target;
	    },
	    getCurrentFontFamily: function getCurrentFontFamily() {
	        if (this.props.fontName) return this.props.fontName;
	
	        var target = this.getCurrentShape();
	
	        if (target) return target.fontFamily;else {
	            return 'Sniglet';
	        }
	    },
	    getFontsDataProvider: function getFontsDataProvider() {
	        return _AvailableFonts2.default.getAvailableFonts();
	    },
	    getCurrentFontTopPosition: function getCurrentFontTopPosition(currentFont) {
	        var top = 7;
	
	        switch (currentFont) {
	            case 'Sriracha':
	                {
	                    top = 0;
	                    break;
	                }
	
	            case 'Shrikhand':
	                {
	                    top = 4;
	                    break;
	                }
	
	            case 'PermanentMarker':
	                {
	                    top = 3;
	                    break;
	                }
	
	            case 'Peralta':
	                {
	                    top = 5;
	                    break;
	                }
	
	            case 'CaveatBrush':
	                {
	                    top = 5;
	                    break;
	                }
	
	            case 'Bangers':
	                {
	                    top = 8;
	                    break;
	                }
	
	            case 'ArchitectsDaughter':
	                {
	                    top = 5;
	                    break;
	                }
	
	            case 'Anton':
	                {
	                    top = 3;
	                    break;
	                }
	
	            case 'AlfaSlabOne':
	                {
	                    top = 5;
	                    break;
	                }
	
	            case 'BungeeShade':
	                {
	                    if (_PlatformDetection2.default.isChromeBook()) top = 0;else top = -8;
	                    break;
	                }
	        }
	
	        return top;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.fontsListIsExpanded != newProps.fontsListIsExpanded || this.props.contextTarget != newProps.contextTarget || this.props.fontName != newProps.fontName) return true;else return false;
	    },
	    render: function render() {
	        var currentFontFamily = this.getCurrentFontFamily();
	        var height = _Properties2.default.EFFECTS_BUTTON_HEIGHT + 2;
	
	        var visibleItems = 10;
	
	        if (_PlatformDetection2.default.isIOS() || _PlatformDetection2.default.isMac()) visibleItems = 15;
	
	        if (this.props.fontsListIsExpanded == true) height = height + visibleItems * _Properties2.default.EFFECTS_BUTTON_HEIGHT + 4;
	
	        var fontsStyle = {
	            position: 'absolute',
	            top: this.props.top,
	            left: 0,
	            width: this.props.accordionWidth,
	            height: height,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white',
	            zIndex: 10000
	        };
	
	        if (this.props.isRichTextEditor) fontsStyle.backgroundColor = '#BDC5C8';
	
	        var borderColor;
	        var textColor;
	
	        if (this.state.isOver == true) {
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            textColor = borderColor;
	        } else {
	            borderColor = 'black';
	            textColor = 'black';
	        }
	
	        var fontsButtonStyle = {
	            width: this.props.accordionWidth - 2 * _Properties2.default.EFFECTS_PADDING,
	            height: _Properties2.default.EFFECTS_BUTTON_HEIGHT,
	            background: 'white',
	            borderRadius: 50,
	            position: 'absolute',
	            left: _Properties2.default.EFFECTS_PADDING,
	            top: 0,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            alignItems: 'center',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            textAlign: 'left'
	        };
	
	        var icon;
	
	        if (this.props.fontsListIsExpanded == true) icon = 'fa fa-angle-down';else icon = 'fa fa-angle-right';
	
	        var fontsIconStyle = {
	            position: 'absolute',
	            top: 12,
	            right: 21,
	            color: textColor
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            color: textColor,
	            cursor: 'default',
	            fontSize: 21,
	            top: this.getCurrentFontTopPosition(currentFontFamily),
	            paddingLeft: 20,
	            fontFamily: currentFontFamily
	        };
	
	        var elements = [];
	        var listDisplay;
	        var dataProvider;
	
	        if (this.props.fontsListIsExpanded == true) {
	            var i;
	            dataProvider = this.getFontsDataProvider();
	            var selectedIndex = -1;
	
	            for (i = 0; i < dataProvider.length; i++) {
	                if (currentFontFamily == dataProvider[i]) selectedIndex = i;
	
	                elements.push(_react2.default.createElement(Button, { executeCommand: this.props.executeCommand, accordionWidth: this.props.accordionWidth, index: i, dispatch: this.props.dispatch, shapeModel: this.props.contextTarget, key: 'font' + dataProvider[i], value: dataProvider[i], selectedIndex: selectedIndex }));
	            }
	
	            listDisplay = 'block';
	        } else {
	            listDisplay = 'none';
	        }
	
	        var fontsListStyle = {
	            position: 'absolute',
	            width: this.props.accordionWidth - 2 * _Properties2.default.EFFECTS_PADDING - 2 * _Properties2.default.EFFECTS_CORNER_GAP + 2,
	            height: _Properties2.default.EFFECTS_BUTTON_HEIGHT * visibleItems,
	            top: _Properties2.default.EFFECTS_BUTTON_HEIGHT + 2,
	            left: _Properties2.default.EFFECTS_PADDING + _Properties2.default.EFFECTS_CORNER_GAP,
	            borderColor: _Properties2.default.EFFECTS_BUTTON_BORDER_COLOR,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            display: listDisplay,
	            overflowY: 'hidden',
	            overflowX: 'hidden'
	        };
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = fontsListStyle.width;
	        componentProperties.height = fontsListStyle.height;
	        componentProperties.scrollHeight = dataProvider != undefined ? dataProvider.length * _Properties2.default.EFFECTS_BUTTON_HEIGHT : 0;
	        componentProperties.top = 0;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = elements;
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            spanStyle.fontSize = 18;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'fontsMenu', style: fontsStyle },
	            _react2.default.createElement(
	                'button',
	                { 'aria-label': _LocalesManager2.default.getCaption('fontSelector', 'other'), style: fontsButtonStyle, onTouchEnd: this.onExpand, onClick: this.onExpand, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	                _react2.default.createElement(
	                    'span',
	                    { style: spanStyle },
	                    currentFontFamily
	                ),
	                _react2.default.createElement('i', { style: fontsIconStyle, className: icon })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: fontsListStyle, onTouchEnd: this.onListChanged, onClick: this.onListChanged },
	                _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var fontsListIsExpanded = state.menu.fontsListIsExpanded;
	
	    return {
	        fontsListIsExpanded: fontsListIsExpanded
	    };
	}
	
	var FontsSelector = exports.FontsSelector = (0, _reactRedux.connect)(mapStateToProps)(FontsSelectorContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/FontsSelector.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/FontsSelector.js"); } } })();

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.GroupButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _GroupManager = __webpack_require__(142);
	
	var _GroupManager2 = _interopRequireDefault(_GroupManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupButtonContent = _react2.default.createClass({
	    displayName: 'GroupButtonContent',
	    getInitialState: function getInitialState() {
	        return {
	            isMenuButtonOver: false
	        };
	    },
	    onMenuButtonMouseIn: function onMenuButtonMouseIn() {
	        this.setState({
	            isMenuButtonOver: true
	        });
	    },
	    onMenuButtonMouseOut: function onMenuButtonMouseOut() {
	        this.setState({
	            isMenuButtonOver: false
	        });
	    },
	    onGroupElements: function onGroupElements(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _GroupManager2.default.groupUngroup();
	    },
	    getSelectedShapes: function getSelectedShapes() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	        var selection = [];
	
	        if (!shapes) return selection;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].isSelected == true) selection.push(shapes[i]);
	        }return selection;
	    },
	    getPosition: function getPosition(shapeModel) {
	        var scaleProperties = this.props.scaleProperties;
	        var i;
	        var selectedShapes = this.getSelectedShapes();
	        var xMin, xMax, yMin, yMax;
	
	        for (i = 0; i < selectedShapes.length; i++) {
	            if (i == 0) {
	                if (selectedShapes[i].type == _ShapeConstants2.default.LINE || selectedShapes[i].type == _ShapeConstants2.default.CURVE) {
	                    xMin = Math.min(selectedShapes[i].x1, selectedShapes[i].x2);
	                    xMax = Math.max(selectedShapes[i].x1, selectedShapes[i].x2);
	
	                    yMin = Math.min(selectedShapes[i].y1, selectedShapes[i].y2);
	                    yMax = Math.max(selectedShapes[i].y1, selectedShapes[i].y2);
	                } else {
	                    xMin = selectedShapes[i].x;
	                    xMax = selectedShapes[i].x + selectedShapes[i].width;
	
	                    yMin = selectedShapes[i].y;
	                    yMax = selectedShapes[i].y + selectedShapes[i].height;
	                }
	            } else {
	                if (selectedShapes[i].type == _ShapeConstants2.default.LINE || selectedShapes[i].type == _ShapeConstants2.default.CURVE) {
	                    var minVal = Math.min(selectedShapes[i].x1, selectedShapes[i].x2);
	                    var maxVal = Math.max(selectedShapes[i].x1, selectedShapes[i].x2);
	
	                    if (minVal < xMin) xMin = minVal;
	
	                    if (maxVal > xMax) xMax = maxVal;
	
	                    minVal = Math.min(selectedShapes[i].y1, selectedShapes[i].y2);
	                    maxVal = Math.max(selectedShapes[i].y1, selectedShapes[i].y2);
	
	                    if (minVal < yMin) yMin = minVal;
	
	                    if (maxVal > yMax) yMax = maxVal;
	                } else {
	                    if (selectedShapes[i].x < xMin) xMin = selectedShapes[i].x;
	
	                    if (selectedShapes[i].x + selectedShapes[i].width > xMax) xMax = selectedShapes[i].x + selectedShapes[i].width;
	
	                    if (selectedShapes[i].y < yMin) yMin = selectedShapes[i].y;
	
	                    if (selectedShapes[i].y + selectedShapes[i].height > yMax) yMax = selectedShapes[i].y + selectedShapes[i].height;
	                }
	            }
	        }
	
	        var centerX = xMin + (xMax - xMin) / 2;
	        var centerY = yMin + (yMax - yMin) / 2;
	        var limitTop = scaleProperties.topY;
	        var limitBottom = scaleProperties.topY + 450 * scaleProperties.scale;
	        var limitLeft = scaleProperties.topX;
	        var limitRight = scaleProperties.topX + 800 * scaleProperties.scale;
	
	        var newPos = { left: scaleProperties.topX + centerX * scaleProperties.scale - _Properties2.default.GROUP_BUTTON_WIDTH / 2, top: scaleProperties.topY + centerY * scaleProperties.scale - _Properties2.default.GROUP_BUTTON_HEIGHT / 2 };
	
	        if (newPos.left < limitLeft || newPos.left + _Properties2.default.GROUP_BUTTON_WIDTH > limitRight) newPos.left = limitLeft + (limitRight - limitLeft) / 2 - _Properties2.default.GROUP_BUTTON_WIDTH / 2;
	
	        if (newPos.top < limitTop || newPos.top + _Properties2.default.GROUP_BUTTON_HEIGHT > limitBottom) newPos.top = limitTop + (limitBottom - limitTop) / 2 - _Properties2.default.GROUP_BUTTON_HEIGHT / 2;
	
	        return newPos;
	    },
	    render: function render() {
	        var selectedShapes = this.getSelectedShapes();
	
	        if (selectedShapes.length <= 1 || _AnimationManager2.default.clone) return _react2.default.createElement('div', null);
	
	        var menuButtonFrameColor;
	        var textColor;
	
	        if (this.state.isMenuButtonOver == true) {
	            menuButtonFrameColor = _Properties2.default.SLIDE_FRAME_HOVER_COLOR;
	            textColor = menuButtonFrameColor;
	        } else {
	            menuButtonFrameColor = '#dadada';
	            textColor = 'black';
	        }
	
	        var position = this.getPosition();
	        var menuButtonStyle = {
	            position: 'absolute',
	            top: position.top,
	            left: position.left,
	            width: _Properties2.default.GROUP_BUTTON_WIDTH,
	            height: _Properties2.default.GROUP_BUTTON_HEIGHT,
	            background: '#f3f3f3',
	            borderWidth: 2,
	            borderStyle: 'solid',
	            borderColor: menuButtonFrameColor,
	            borderRadius: 5,
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            cursor: 'pointer'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 10,
	            left: 5,
	            width: menuButtonStyle.width - 10,
	            height: 20,
	            color: textColor,
	            textAlign: 'center',
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            fontSize: 16,
	            fontWeight: 'bold'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuButtonStyle, onTouchEnd: this.onGroupElements, onClick: this.onGroupElements, onMouseOver: this.onMenuButtonMouseIn, onMouseOut: this.onMenuButtonMouseOut },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                _LocalesManager2.default.getCaption('GroupButton', 'other')
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var slideModel = state.currentSlide.model;
	
	    return {
	        slideModel: slideModel
	    };
	}
	
	var GroupButton = exports.GroupButton = (0, _reactRedux.connect)(mapStateToProps)(GroupButtonContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/GroupButton.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/GroupButton.js"); } } })();

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LeftEffectsMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _ClipartParserJSONNew = __webpack_require__(168);
	
	var _ClipartParserJSONNew2 = _interopRequireDefault(_ClipartParserJSONNew);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _ListItemRenderer = __webpack_require__(167);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MenuActions = __webpack_require__(7);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        var caption = _LocalesManager2.default.getCaption('mainMenuEffects', 'hover');
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            width: 24,
	            height: 24,
	            top: 3,
	            right: 28,
	            cursor: 'pointer',
	            borderStyle: 'none',
	            background: 'none'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 4,
	            right: 4,
	            cursor: 'pointer'
	        };
	
	        var ariaLabel = _LocalesManager2.default.getCaption('exit', 'other') + ' ' + caption;
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                caption
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'firstFocusableObject', 'aria-label': ariaLabel, style: closeButtonStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var List = _react2.default.createClass({
	    displayName: 'List',
	    getInitialState: function getInitialState() {
	        return {
	            currentPage: 0,
	            dataProvider: this.props.dataProvider,
	            elements: this.getCurrentElements(this.props.dataProvider, 0)
	        };
	    },
	    uploadNewPage: function uploadNewPage(scrollTop) {
	        if (Math.abs(scrollTop - _MasterUniverseUtils2.default.scrollPosition) < 40) return;
	
	        _MasterUniverseUtils2.default.scrollPosition = scrollTop;
	
	        this.setState({
	            elements: this.getCurrentElements(this.state.dataProvider, this.state.currentPage + 1),
	            currentPage: this.state.currentPage + 1
	        });
	    },
	    getCurrentElements: function getCurrentElements(allElements, page) {
	        var hitsPerPage = 50;
	        var maxIndex = hitsPerPage * (page + 1);
	        var items = [];
	
	        for (var i = 0; i < allElements.length; i++) {
	            if (i < maxIndex) items.push(allElements[i]);else break;
	        }
	
	        return items;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.elements == undefined) return _react2.default.createElement('div', null);
	
	        var items = this.state.elements;
	        var paddingTop = 12;
	        var paddingLeft = 3;
	        var componentProperties = {};
	        var elements = [];
	        var i = void 0;
	
	        for (i = 0; i < items.length; i++) {
	            var item = items[i];
	            var key = 'item_' + Math.random() + '_' + i;
	
	            elements.push(_react2.default.createElement(_ListItemRenderer.ListItemRenderer, { item: item, key: key, isBackground: false, usePagination: true, index: i, parentWidth: this.props.width }));
	        }
	
	        componentProperties.paddingTop = paddingTop;
	        componentProperties.paddingLeft = paddingLeft;
	        componentProperties.width = this.props.width;
	        componentProperties.top = this.props.top;
	        componentProperties.displayState = 'inline-block';
	        componentProperties.height = this.props.height;
	        componentProperties.elements = elements;
	
	        componentProperties.usePagination = true;
	        componentProperties.uploadNewPage = this.uploadNewPage;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	var LeftEffectsMenu = exports.LeftEffectsMenu = _react2.default.createClass({
	    displayName: 'LeftEffectsMenu',
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('firstFocusableObject');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    getEffects: function getEffects() {
	        if (!_ClipartParserJSONNew2.default.cartoonistEffects) return [];
	
	        var array = _ClipartParserJSONNew2.default.cartoonistEffects.items;
	
	        return array;
	    },
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var gap = 10;
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'leftEffectsMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(List, { dispatch: this.props.dispatch, dataProvider: this.getEffects(), width: this.props.accordionWidth, top: gap + _Properties2.default.CLIPART_BUTTON_HEIGHT, height: this.props.windowHeight - gap - _Properties2.default.CLIPART_BUTTON_HEIGHT })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LeftEffectsMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LeftEffectsMenu.js"); } } })();

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LeftFramesMenu = exports.LeftFramesMenuContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _ClipartParserJSONNew = __webpack_require__(168);
	
	var _ClipartParserJSONNew2 = _interopRequireDefault(_ClipartParserJSONNew);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _OnOffToggleButton = __webpack_require__(122);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _ListItemRenderer = __webpack_require__(167);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _MenuActions = __webpack_require__(7);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        var caption = _LocalesManager2.default.getCaption('mainMenuFrames', 'hover');
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            width: 24,
	            height: 24,
	            top: 3,
	            right: 28,
	            cursor: 'pointer',
	            borderStyle: 'none',
	            background: 'none'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 4,
	            right: 4,
	            cursor: 'pointer'
	        };
	
	        var ariaLabel = _LocalesManager2.default.getCaption('exit', 'other') + ' ' + caption;
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                caption
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'firstFocusableObject', 'aria-label': ariaLabel, style: closeButtonStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var List = _react2.default.createClass({
	    displayName: 'List',
	    getInitialState: function getInitialState() {
	        return {
	            currentPage: 0,
	            dataProvider: this.props.dataProvider,
	            elements: this.getCurrentElements(this.props.dataProvider, 0)
	        };
	    },
	    uploadNewPage: function uploadNewPage(scrollTop) {
	        if (Math.abs(scrollTop - _MasterUniverseUtils2.default.scrollPosition) < 40) return;
	
	        _MasterUniverseUtils2.default.scrollPosition = scrollTop;
	
	        this.setState({
	            elements: this.getCurrentElements(this.state.dataProvider, this.state.currentPage + 1),
	            currentPage: this.state.currentPage + 1
	        });
	    },
	    getCurrentElements: function getCurrentElements(allElements, page) {
	        var hitsPerPage = 50;
	        var maxIndex = hitsPerPage * (page + 1);
	        var items = [];
	
	        for (var i = 0; i < allElements.length; i++) {
	            if (i < maxIndex) items.push(allElements[i]);else break;
	        }
	
	        return items;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.elements == undefined) return _react2.default.createElement('div', null);
	
	        var items = this.state.elements;
	        var paddingTop = 12;
	        var paddingLeft = 3;
	        var componentProperties = {};
	        var elements = [];
	        var i = void 0;
	
	        for (i = 0; i < items.length; i++) {
	            var item = items[i];
	            var key = 'item_' + Math.random() + '_' + i;
	
	            elements.push(_react2.default.createElement(_ListItemRenderer.ListItemRenderer, { item: item, key: key, isFrame: true, isBackground: true, usePagination: true, index: i, isSearch: true, parentWidth: this.props.width }));
	        }
	
	        componentProperties.paddingTop = paddingTop;
	        componentProperties.paddingLeft = paddingLeft;
	        componentProperties.width = this.props.width;
	        componentProperties.top = this.props.top;
	        componentProperties.displayState = 'inline-block';
	        componentProperties.height = this.props.height;
	        componentProperties.elements = elements;
	
	        componentProperties.usePagination = true;
	        componentProperties.uploadNewPage = this.uploadNewPage;
	
	        var onOffButton;
	
	        if (this.props.isBackgroundList) {
	            var topGap = 0;
	            var bottomGap = 0;
	            var onOffButtonProperties = {};
	
	            onOffButtonProperties.topPosition = componentProperties.top + topGap;
	            onOffButtonProperties.leftPosition = _Properties2.default.MY_MEDIA_FILES_GAP;
	            onOffButtonProperties.trackWidth = _Properties2.default.TOGGLE_TRACK_WIDTH;
	            onOffButtonProperties.trackHeight = _Properties2.default.TOGGLE_TRACK_HEIGHT;
	            onOffButtonProperties.thumbHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
	            onOffButtonProperties.thumbSize = _Properties2.default.TOGGLE_THUMB_SIZE;
	            onOffButtonProperties.dispatch = this.props.dispatch;
	            onOffButtonProperties.width = _Properties2.default.BROWSER_WIDTH - 2 * _Properties2.default.MY_MEDIA_FILES_GAP;
	
	            onOffButtonProperties.isBackgroundElement = true;
	            onOffButtonProperties.isFrame = true;
	            onOffButtonProperties.useFrameAsImage = this.props.useFrameAsImage;
	
	            onOffButton = _react2.default.createElement(_OnOffToggleButton.OnOffToggleButton, { properties: onOffButtonProperties, dispatch: this.props.dispatch });
	
	            var toggleButtonHeight = onOffButtonProperties.thumbSize + topGap + bottomGap;
	
	            componentProperties.top = componentProperties.top + toggleButtonHeight;
	            componentProperties.height = componentProperties.height - toggleButtonHeight;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            onOffButton,
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	var LeftFramesMenuContent = exports.LeftFramesMenuContent = _react2.default.createClass({
	    displayName: 'LeftFramesMenuContent',
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('firstFocusableObject');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    getFrames: function getFrames() {
	        if (!_ClipartParserJSONNew2.default.frames) return [];
	
	        var array = _ClipartParserJSONNew2.default.frames.items;
	
	        return array;
	    },
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var gap = 10;
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(List, { isBackgroundList: true, dispatch: this.props.dispatch, useFrameAsImage: this.props.useFrameAsImage, dataProvider: this.getFrames(), width: this.props.accordionWidth, top: gap + _Properties2.default.CLIPART_BUTTON_HEIGHT, height: this.props.windowHeight - gap - _Properties2.default.CLIPART_BUTTON_HEIGHT })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var useFrameAsImage = state.menu.useFrameAsImage;
	
	    if (useFrameAsImage == undefined) useFrameAsImage = false;
	
	    return {
	        useFrameAsImage: useFrameAsImage
	    };
	}
	
	var LeftFramesMenu = exports.LeftFramesMenu = (0, _reactRedux.connect)(mapStateToProps)(LeftFramesMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LeftFramesMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LeftFramesMenu.js"); } } })();

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LeftFreehandMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        var caption = _LocalesManager2.default.getCaption('mainMenuDrawing', 'hover');
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            width: 24,
	            height: 24,
	            top: 3,
	            right: 28,
	            cursor: 'pointer',
	            borderStyle: 'none',
	            background: 'none'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 4,
	            right: 4,
	            cursor: 'pointer'
	        };
	
	        var ariaLabel = _LocalesManager2.default.getCaption('exit', 'other') + ' ' + caption;
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                caption
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'leftFreehandtMenuFirstFocusabletElement', 'aria-label': ariaLabel, style: closeButtonStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // freehand
	                    this.setCurrentState(_ModeConstants2.default.FREEHAND_CONTEXT);
	                    break;
	                }
	
	            case 1:
	                {
	                    // line
	                    this.setCurrentState(_ModeConstants2.default.LINE_CONTEXT);
	                    break;
	                }
	        }
	    },
	    setCurrentState: function setCurrentState(type) {
	        var dispatch = this.props.dispatch;
	
	        dispatch((0, _AccordionActions.setDrawState)(type));
	
	        if (type == _ModeConstants2.default.LINE_CONTEXT || type == _ModeConstants2.default.FREEHAND_CONTEXT) {
	            dispatch((0, _MenuActions.changeContextMode)(type));
	            dispatch((0, _CurrentSlideActions.selectShape)(''));
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.state.isMouseIn != nextState.isMouseIn) return true;else return false;
	    },
	    render: function render() {
	        var _buttonStyle;
	
	        var buttonWidth = this.props.buttonWidth;
	        var buttonHeight = this.props.buttonHeight;
	        var frameDisplayState;
	        var frameColor;
	        var iconSrc = this.props.src;
	
	        if (this.state.isOver == true) {
	            frameDisplayState = 'block';
	            frameColor = _Properties2.default.SLIDE_FRAME_HOVER_COLOR;
	        } else {
	            frameDisplayState = 'none';
	            frameColor = 'black';
	        }
	
	        var buttonStyle = (_buttonStyle = {
	            position: 'absolute',
	            left: this.props.left,
	            top: this.props.top,
	            width: buttonWidth,
	            height: buttonHeight,
	            background: 'white',
	            cursor: '-webkit-grab',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        }, _defineProperty(_buttonStyle, 'background', 'none'), _defineProperty(_buttonStyle, 'display', 'flex'), _defineProperty(_buttonStyle, 'borderStyle', 'none'), _buttonStyle);
	
	        var boderWidth = 2;
	
	        var frameStyle = {
	            position: 'absolute',
	            width: buttonWidth - 2 * boderWidth,
	            height: buttonHeight - 2 * boderWidth,
	            borderWidth: boderWidth,
	            borderStyle: 'solid',
	            borderColor: frameColor,
	            top: 0,
	            display: frameDisplayState
	        };
	
	        var iconWidth = buttonWidth;
	        var leftPos = 0;
	        var topPos = 0;
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            iconWidth = 55;
	            leftPos = 17;
	            topPos = 0;
	        }
	
	        var iconStyle = {
	            position: 'absolute',
	            width: iconWidth,
	            left: leftPos,
	            top: topPos
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: buttonHeight - 35,
	            width: buttonWidth - 10,
	            textAlign: 'center',
	            left: 5,
	            fontSize: 14,
	            color: frameColor
	        };
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            spanStyle.fontSize = 12;
	            spanStyle.top = buttonHeight - 20;
	        }
	
	        var idValue = this.props.index == 0 ? 'firstFocusableObject' : 'leftFreehandtMenuLastFocusabletElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, ref: 'itemRenderer', 'aria-label': this.props.text, style: buttonStyle, onClick: this.onMouseDown, onTouchStart: this.onMouseDown, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: iconSrc }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            ),
	            _react2.default.createElement('div', { style: frameStyle })
	        );
	    }
	});
	
	var LeftFreehandMenu = exports.LeftFreehandMenu = _react2.default.createClass({
	    displayName: 'LeftFreehandMenu',
	    getInitialState: function getInitialState() {
	        return {
	            buttons: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('firstFocusableObject');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    initElements: function initElements() {
	        var buttons = [];
	        var leftGap = 20;
	        var middleGap = 10;
	
	        if (_PlatformDetection2.default.isIOS() == true) leftGap = 18;
	
	        var buttonWidth = (_Properties2.default.BROWSER_WIDTH - 2 * leftGap - middleGap) / 2;
	        var buttonHeight = buttonWidth - 20;
	
	        buttons.push(_react2.default.createElement(Button, { index: 0, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Freehand', 'shapes'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/freehand.png', buttonWidth: buttonWidth, buttonHeight: buttonHeight, left: leftGap, top: leftGap, key: 'shapesMenu0' }));
	        buttons.push(_react2.default.createElement(Button, { index: 1, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Line', 'shapes'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/line.png', buttonWidth: buttonWidth, buttonHeight: buttonHeight, left: leftGap + middleGap + buttonWidth, top: leftGap, key: 'shapesMenu1' }));
	
	        this.setState({
	            buttons: buttons
	        });
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.buttons != nextState.buttons || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.buttons == undefined) return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var listHeight = this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        var componentProperties = {};
	        var leftGap = 20;
	        var middleGap = 10;
	
	        if (_PlatformDetection2.default.isIOS() == true) leftGap = 18;
	
	        var buttonWidth = (_Properties2.default.BROWSER_WIDTH - 2 * leftGap - middleGap) / 2;
	        var buttonHeight = buttonWidth - 20;
	
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = listHeight;
	        componentProperties.top = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        componentProperties.elements = this.state.buttons;
	        componentProperties.scrollHeight = buttonHeight + 2 * middleGap;
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'leftFreehandMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LeftFreehandMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LeftFreehandMenu.js"); } } })();

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LeftMediaMenu = exports.LeftMediaMenuContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _MediaImagesList = __webpack_require__(801);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MenuActions = __webpack_require__(7);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _OnOffToggleButton = __webpack_require__(122);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        var caption = _LocalesManager2.default.getCaption('mainMenuMedia', 'hover');
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            width: 24,
	            height: 24,
	            top: 3,
	            right: 28,
	            cursor: 'pointer',
	            borderStyle: 'none',
	            background: 'none'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 4,
	            right: 4,
	            cursor: 'pointer'
	        };
	
	        var ariaLabel = _LocalesManager2.default.getCaption('exit', 'other') + ' ' + caption;
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                caption
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'firstFocusableObject', 'aria-label': ariaLabel, style: closeButtonStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    this.props.dispatch((0, _MenuActions.selectMyMediaCategory)(_ModeConstants2.default.IMAGES));
	                    this.props.dispatch((0, _MenuActions.changeCartoonistTabIndex)(7));
	                    break;
	                }
	
	            case 1:
	                {
	                    this.props.dispatch((0, _MenuActions.selectMyMediaCategory)(_ModeConstants2.default.VIDEOS));
	                    this.props.dispatch((0, _MenuActions.changeCartoonistTabIndex)(8));
	                    break;
	                }
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.category != newProps.category) return true;else return false;
	    },
	    render: function render() {
	        var iconColor;
	        var buttonColor;
	        var videoSelected = false;
	
	        if (this.props.category && this.props.category == _ModeConstants2.default.VIDEOS) videoSelected = true;
	
	        if (this.props.index == 0) {
	            // IMAGES button
	            if (videoSelected == false) {
	                iconColor = 'white';
	                buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            } else {
	                if (this.state.isOver == true) {
	                    iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                    buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	                } else {
	                    iconColor = 'black';
	                    buttonColor = '#D7D7D7';
	                }
	            }
	        } else {
	            // VIDEO button
	            if (videoSelected == true) {
	                iconColor = 'white';
	                buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            } else {
	                if (this.state.isOver == true) {
	                    iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                    buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	                } else {
	                    iconColor = 'black';
	                    buttonColor = '#D7D7D7';
	                }
	            }
	        }
	
	        var topPosition = 0;
	        var left = this.props.index == 0 ? 0 : _Properties2.default.BROWSER_WIDTH / 2;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: _Properties2.default.BROWSER_WIDTH / 2,
	            height: _Properties2.default.BROWSER_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            left: left,
	            top: topPosition,
	            color: 'white',
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#FFFFFF',
	            cursor: 'pointer'
	        };
	
	        var spanStyle = {
	            color: iconColor,
	            fontSize: 16,
	            position: 'absolute',
	            width: buttonStyle.width - 2 * 5,
	            left: 5,
	            top: 5,
	            whiteSpace: 'nowrap',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            textAlign: 'center',
	            cursor: 'pointer'
	        };
	
	        var text = this.props.text;
	
	        if (this.props.index == 0) {
	            text = _LocalesManager2.default.getCaption('ImagesButton', 'myFiles');
	        } else {
	            text = _LocalesManager2.default.getCaption('VideosButton', 'myFiles');
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { style: buttonStyle, 'aria-label': text, onClick: this.onClick, onTouchStart: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            )
	        );
	    }
	});
	
	var LeftMediaMenuContent = exports.LeftMediaMenuContent = _react2.default.createClass({
	    displayName: 'LeftMediaMenuContent',
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('firstFocusableObject');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.myMediaCategory != newProps.myMediaCategory || this.props.useImageAsBackground != newProps.useImageAsBackground || this.props.useVideoAsBackground != newProps.useVideoAsBackground || this.props.accordionWidth != newProps.accordionWidth || this.props.windowHeight != newProps.windowHeight || this.props.mediaFilesDataProvider != newProps.mediaFilesDataProvider) return true;else return false;
	    },
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var listHeight = this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        var mediaMenuStyle = {
	            position: 'absolute',
	            top: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            width: this.props.accordionWidth,
	            height: listHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var dataProvider = [];
	        var isVideo = false;
	
	        if (this.props.myMediaCategory == _ModeConstants2.default.IMAGES) {
	            if (this.props.mediaFilesDataProvider) dataProvider = this.props.mediaFilesDataProvider.imagesDataProvider;
	        } else {
	            if (this.props.mediaFilesDataProvider) dataProvider = this.props.mediaFilesDataProvider.videosDataProvider;
	
	            isVideo = true;
	        }
	
	        if (!_PlatformDetection2.default.isIOSApp()) dataProvider = [{ isUploadButton: true }].concat(dataProvider);
	
	        var onOffButtonProperties = {};
	        var onOffButton;
	        var gap = 5;
	
	        onOffButtonProperties.topPosition = _Properties2.default.BROWSER_BUTTON_HEIGHT + gap;
	        onOffButtonProperties.leftPosition = _Properties2.default.MY_MEDIA_FILES_GAP;
	        onOffButtonProperties.trackWidth = _Properties2.default.TOGGLE_TRACK_WIDTH;
	        onOffButtonProperties.trackHeight = _Properties2.default.TOGGLE_TRACK_HEIGHT;
	        onOffButtonProperties.thumbHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
	        onOffButtonProperties.thumbSize = _Properties2.default.TOGGLE_THUMB_SIZE;
	        onOffButtonProperties.dispatch = this.props.dispatch;
	        onOffButtonProperties.width = _Properties2.default.BROWSER_WIDTH - 2 * _Properties2.default.MY_MEDIA_FILES_GAP;
	
	        onOffButtonProperties.isMediaFilesElement = true;
	
	        if (isVideo) {
	            onOffButtonProperties.useVideoAsBackground = this.props.useVideoAsBackground;
	            onOffButtonProperties.isVideo = true;
	            onOffButton = _react2.default.createElement(_OnOffToggleButton.OnOffToggleButton, { properties: onOffButtonProperties, dispatch: this.props.dispatch, shapeModel: this.props.contextTarget });
	        } else {
	            onOffButtonProperties.useImageAsBackground = this.props.useImageAsBackground;
	            onOffButtonProperties.isVideo = false;
	            onOffButton = _react2.default.createElement(_OnOffToggleButton.OnOffToggleButton, { properties: onOffButtonProperties, dispatch: this.props.dispatch, shapeModel: this.props.contextTarget });
	        }
	
	        var buttonsHolder = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(Button, { index: 0, category: this.props.myMediaCategory, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Button, { index: 1, category: this.props.myMediaCategory, dispatch: this.props.dispatch })
	        );
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'leftMediaMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(
	                'div',
	                { style: mediaMenuStyle },
	                buttonsHolder,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    onOffButton
	                ),
	                _react2.default.createElement(_MediaImagesList.MediaImagesList, { isVideo: isVideo, accordionWidth: this.props.accordionWidth, dataProvider: dataProvider, height: listHeight, gap: gap })
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var myMediaCategory = state.menu.myMediaCategory;
	    var useImageAsBackground = state.menu.useImageAsBackground;
	    var useVideoAsBackground = state.menu.useVideoAsBackground;
	    var accordionWidth = state.accordion.width;
	    var mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
	
	    if (myMediaCategory == undefined) myMediaCategory = _ModeConstants2.default.IMAGES;
	
	    if (useImageAsBackground == undefined) useImageAsBackground = false;
	
	    if (useVideoAsBackground == undefined) useVideoAsBackground = true;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    return {
	        myMediaCategory: myMediaCategory,
	        useImageAsBackground: useImageAsBackground,
	        useVideoAsBackground: useVideoAsBackground,
	        accordionWidth: accordionWidth,
	        mediaFilesDataProvider: mediaFilesDataProvider
	    };
	}
	
	var LeftMediaMenu = exports.LeftMediaMenu = (0, _reactRedux.connect)(mapStateToProps)(LeftMediaMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LeftMediaMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LeftMediaMenu.js"); } } })();

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LeftShapesMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _DragManager = __webpack_require__(107);
	
	var _DragManager2 = _interopRequireDefault(_DragManager);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        var caption = _LocalesManager2.default.getCaption('mainMenuShapes', 'hover');
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            width: 24,
	            height: 24,
	            top: 3,
	            right: 28,
	            cursor: 'pointer',
	            borderStyle: 'none',
	            background: 'none'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 4,
	            right: 4,
	            cursor: 'pointer'
	        };
	
	        var ariaLabel = _LocalesManager2.default.getCaption('exit', 'other') + ' ' + caption;
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                caption
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'leftShapesMenuFirstFocusabletElement', 'aria-label': ariaLabel, style: closeButtonStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlatformDetection2.default.isTouchableDevice() == true) {
	            var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	            this.setState({
	                clientX: clientPosition.x,
	                clientY: clientPosition.y
	            });
	        }
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.createShape();
	    },
	    onMouseClick: function onMouseClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.createShape();
	    },
	    createShape: function createShape(topLeftPosition) {
	        var dispatch = this.props.dispatch;
	
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // rectangle
	                    _CreateShapes2.default.createRectangle(dispatch, topLeftPosition);
	                    break;
	                }
	
	            case 1:
	                {
	                    // ellipse
	                    _CreateShapes2.default.createEllipse(dispatch, topLeftPosition);
	                    break;
	                }
	
	            case 2:
	                {
	                    // curve
	                    _CreateShapes2.default.createCurve(dispatch, topLeftPosition);
	                    break;
	                }
	
	            case 3:
	                {
	                    // triangle
	                    _CreateShapes2.default.createTriangle(dispatch, topLeftPosition);
	                    break;
	                }
	
	            case 4:
	                {
	                    // Star
	                    _CreateShapes2.default.createStar(dispatch, topLeftPosition);
	                    break;
	                }
	
	            case 5:
	                {
	                    // Heart
	                    _CreateShapes2.default.createHeart(dispatch, topLeftPosition);
	                    break;
	                }
	        }
	
	        this.changeFocusToShapeMenuButton();
	    },
	    changeFocusToShapeMenuButton: function changeFocusToShapeMenuButton() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var shapeMenuButton = document.getElementById('shapeMenuButton');
	
	            if (shapeMenuButton) shapeMenuButton.focus();
	        }.bind(this), 100);
	    },
	    onDragStart: function onDragStart(e) {
	        if (_PlatformDetection2.default.isTouchableDevice() == true) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clone = this.refs.itemRenderer;
	
	        _DragManager2.default.prepareClone(clone, this.createShape, (0, _TransformToolUtils.getTouchPosition)(e));
	    },
	    onDragMove: function onDragMove(e, coreEvent) {
	        if (_PlatformDetection2.default.isTouchableDevice() == true) return;
	
	        _DragManager2.default.onDragMove(coreEvent.lastX, coreEvent.lastY);
	    },
	    onDragEnd: function onDragEnd(e, coreEvent) {
	        if (_PlatformDetection2.default.isTouchableDevice() == true) return;
	
	        _DragManager2.default.onDragEnd(coreEvent.lastX, coreEvent.lastY);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.state.isMouseIn != nextState.isMouseIn) return true;else return false;
	    },
	    render: function render() {
	        var buttonWidth = this.props.buttonWidth;
	        var buttonHeight = this.props.buttonHeight;
	        var frameDisplayState;
	        var frameColor;
	        var iconSrc = this.props.src;
	
	        if (this.state.isOver == true) {
	            frameDisplayState = 'block';
	            frameColor = _Properties2.default.SLIDE_FRAME_HOVER_COLOR;
	        } else {
	            frameDisplayState = 'none';
	            frameColor = 'black';
	        }
	
	        var buttonStyle = {
	            position: 'absolute',
	            left: this.props.left,
	            top: this.props.top,
	            width: buttonWidth,
	            height: buttonHeight,
	            background: 'white',
	            cursor: '-webkit-grab',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            display: 'flex',
	            borderStyle: 'none'
	        };
	
	        var boderWidth = 2;
	
	        var frameStyle = {
	            position: 'absolute',
	            width: buttonWidth - 2 * boderWidth,
	            height: buttonHeight - 2 * boderWidth,
	            borderWidth: boderWidth,
	            borderStyle: 'solid',
	            borderColor: frameColor,
	            top: 0,
	            display: frameDisplayState
	        };
	
	        var iconWidth = 75;
	        var leftPos = 30;
	        var topPos = 10;
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            iconWidth = 55;
	            leftPos = 17;
	            topPos = 0;
	        }
	
	        var iconStyle = {
	            position: 'absolute',
	            width: iconWidth,
	            left: leftPos,
	            top: topPos
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: buttonHeight - 35,
	            width: buttonWidth - 10,
	            textAlign: 'center',
	            left: 5,
	            fontSize: 14,
	            color: frameColor
	        };
	
	        var draggableStyle = {
	            position: 'absolute',
	            width: buttonWidth,
	            height: buttonHeight,
	            top: 0,
	            background: 'red',
	            opacity: 0,
	            display: 'block'
	        };
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            spanStyle.fontSize = 12;
	            spanStyle.top = buttonHeight - 20;
	        }
	
	        var idValue = this.props.index == 0 ? 'firstFocusableObject' : undefined;
	
	        if (this.props.index == 5) idValue = 'leftShapesMenuLastFocusabletElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, ref: 'itemRenderer', 'aria-label': this.props.text, style: buttonStyle, onClick: this.onMouseClick, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: iconSrc }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            ),
	            _react2.default.createElement('div', { style: frameStyle }),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onDragStart, onDrag: this.onDragMove, onStop: this.onDragEnd },
	                _react2.default.createElement('div', { style: draggableStyle })
	            )
	        );
	    }
	});
	
	var LeftShapesMenu = exports.LeftShapesMenu = _react2.default.createClass({
	    displayName: 'LeftShapesMenu',
	    getInitialState: function getInitialState() {
	        return {
	            buttons: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('firstFocusableObject');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    initElements: function initElements() {
	        var buttons = [];
	        var leftGap = 20;
	        var middleGap = 10;
	
	        if (_PlatformDetection2.default.isIOS() == true) leftGap = 18;
	
	        var buttonWidth = (_Properties2.default.BROWSER_WIDTH - 2 * leftGap - middleGap) / 2;
	        var buttonHeight = buttonWidth - 20;
	
	        buttons.push(_react2.default.createElement(Button, { index: 0, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Rectangle', 'shapes'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/rectangle.png', buttonWidth: buttonWidth, buttonHeight: buttonHeight, left: leftGap, top: leftGap, key: 'shapesMenu3' }));
	        buttons.push(_react2.default.createElement(Button, { index: 1, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Ellipse', 'shapes'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/ellipse.png', buttonWidth: buttonWidth, buttonHeight: buttonHeight, left: leftGap + middleGap + buttonWidth, top: leftGap, key: 'shapesMenu4' }));
	        buttons.push(_react2.default.createElement(Button, { index: 2, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Curve', 'shapes'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/curve.png', buttonWidth: buttonWidth, buttonHeight: buttonHeight, left: leftGap, top: leftGap + middleGap + buttonHeight, key: 'shapesMenu5' }));
	        buttons.push(_react2.default.createElement(Button, { index: 3, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Triangle', 'shapes'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/triangle.png', buttonWidth: buttonWidth, buttonHeight: buttonHeight, left: leftGap + middleGap + buttonWidth, top: leftGap + middleGap + buttonHeight, key: 'shapesMenu6' }));
	        buttons.push(_react2.default.createElement(Button, { index: 4, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Star', 'shapes'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/star.png', buttonWidth: buttonWidth, buttonHeight: buttonHeight, left: leftGap, top: leftGap + 2 * middleGap + 2 * buttonHeight, key: 'shapesMenu7' }));
	        buttons.push(_react2.default.createElement(Button, { index: 5, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Heart', 'shapes'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/heart.png', buttonWidth: buttonWidth, buttonHeight: buttonHeight, left: leftGap + middleGap + buttonWidth, top: leftGap + 2 * middleGap + 2 * buttonHeight, key: 'shapesMenu8' }));
	
	        this.setState({
	            buttons: buttons
	        });
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.buttons != nextState.buttons || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.buttons == undefined) return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var listHeight = this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        var componentProperties = {};
	        var leftGap = 20;
	        var middleGap = 10;
	
	        if (_PlatformDetection2.default.isIOS() == true) leftGap = 18;
	
	        var buttonWidth = (_Properties2.default.BROWSER_WIDTH - 2 * leftGap - middleGap) / 2;
	        var buttonHeight = buttonWidth - 20;
	
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = listHeight;
	        componentProperties.top = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        componentProperties.elements = this.state.buttons;
	        componentProperties.scrollHeight = 3 * buttonHeight + 5 * middleGap;
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'leftShapesMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LeftShapesMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LeftShapesMenu.js"); } } })();

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LeftTextMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _DragManager = __webpack_require__(107);
	
	var _DragManager2 = _interopRequireDefault(_DragManager);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        var caption = _LocalesManager2.default.getCaption('mainMenuText', 'hover');
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            width: 24,
	            height: 24,
	            top: 3,
	            right: 28,
	            cursor: 'pointer',
	            borderStyle: 'none',
	            background: 'none'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 4,
	            right: 4,
	            cursor: 'pointer'
	        };
	
	        var ariaLabel = _LocalesManager2.default.getCaption('exit', 'other') + ' ' + caption;
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                caption
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'leftTextMenuFirstFocusabletElement', 'aria-label': ariaLabel, style: closeButtonStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    createShape: function createShape(topLeftPosition) {
	        var dispatch = this.props.dispatch;
	
	        var isRichText = _TextEditorUtils2.default.useRichText();
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    _CreateShapes2.default.createTextBoxSimple(dispatch, topLeftPosition, isRichText);
	                    break;
	                }
	
	            case 1:
	                {
	                    _CreateShapes2.default.createTextBox(dispatch, topLeftPosition, isRichText);
	                    break;
	                }
	
	            case 2:
	                {
	                    _CreateShapes2.default.createSpeachBubble(dispatch, topLeftPosition, isRichText);
	                    break;
	                }
	
	            case 3:
	                {
	                    _CreateShapes2.default.createThoughtBubble(dispatch, topLeftPosition, isRichText);
	                    break;
	                }
	
	            case 4:
	                {
	                    _CreateShapes2.default.createScreamBubble(dispatch, topLeftPosition, isRichText);
	                    break;
	                }
	
	            case 5:
	                {
	                    _CreateShapes2.default.createComplexSpeachBubble(dispatch, topLeftPosition, isRichText);
	                    break;
	                }
	
	            case 6:
	                {
	                    _CreateShapes2.default.createMindMapShape(dispatch, topLeftPosition, isRichText);
	                    break;
	                }
	        }
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlatformDetection2.default.isIOS()) {
	            this.createShape();
	            return;
	        }
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.createShape();
	    },
	    onMouseClick: function onMouseClick(e) {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.createShape();
	    },
	    onDragStart: function onDragStart(e, coreEvent) {
	        if (_PlatformDetection2.default.isTouchableDevice() == true) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clone = this.refs.itemRenderer;
	
	        _DragManager2.default.prepareClone(clone, this.createShape, (0, _TransformToolUtils.getTouchPosition)(e));
	    },
	    onDragMove: function onDragMove(e, coreEvent) {
	        if (_PlatformDetection2.default.isTouchableDevice() == true) return;
	
	        _DragManager2.default.onDragMove(coreEvent.lastX, coreEvent.lastY);
	    },
	    onDragEnd: function onDragEnd(e, coreEvent) {
	        if (_PlatformDetection2.default.isTouchableDevice() == true) return;
	
	        _DragManager2.default.onDragEnd(coreEvent.lastX, coreEvent.lastY);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.state.isMouseIn != nextState.isMouseIn) return true;else return false;
	    },
	    getButtonAriaLabel: function getButtonAriaLabel() {
	        var text = '';
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // text = 'Tekstboks uten ramme';
	                    text = _LocalesManager2.default.getCaption('TextBoxSimpleAriaLabel', 'other');
	                    break;
	                }
	
	            case 1:
	                {
	                    // text = 'Tekstboks med ramme';
	                    text = _LocalesManager2.default.getCaption('TextBoxAriaLabel', 'other');
	                    break;
	                }
	
	            case 2:
	                {
	                    // text = 'Snakkeboble';
	                    text = _LocalesManager2.default.getCaption('SpeechAriaLabel', 'other');
	                    break;
	                }
	
	            case 3:
	                {
	                    // text = 'Tankeboble';
	                    text = _LocalesManager2.default.getCaption('ThoughtBubbleAriaLabel', 'other');
	                    break;
	                }
	
	            case 4:
	                {
	                    // text = 'Ropeboble';
	                    text = _LocalesManager2.default.getCaption('ScreamBubbleAriaLabel', 'other');
	                    break;
	                }
	
	            case 5:
	                {
	                    // text = 'Snakkeboble med flere haler';
	                    text = _LocalesManager2.default.getCaption('ComplexSpeechBubbleAriaLabel', 'other');
	                    break;
	                }
	
	            case 6:
	                {
	                    text = _LocalesManager2.default.getCaption('MindMapShape', 'text');
	                    break;
	                }
	        }
	
	        return text;
	    },
	    render: function render() {
	        var horizontalGap = 40;
	
	        if (_PlatformDetection2.default.isIOS() == true) horizontalGap = 20;
	
	        var topPadding = 0;
	        var verticalGap = 15;
	        var buttonWidth = (_Properties2.default.BROWSER_WIDTH - 3 * horizontalGap) / 2;
	        var buttonHeight = buttonWidth;
	        var leftPosition;
	        var topPosition;
	
	        if (this.props.index == 0 || this.props.index == 2 || this.props.index == 4 || this.props.index == 6) leftPosition = horizontalGap;else leftPosition = 2 * horizontalGap + buttonWidth;
	
	        if (this.props.index == 0 || this.props.index == 1) topPosition = verticalGap + topPadding;else if (this.props.index == 2 || this.props.index == 3) topPosition = 2 * verticalGap + buttonHeight + topPadding;else if (this.props.index == 4 || this.props.index == 5) topPosition = 3 * verticalGap + 2 * buttonHeight + topPadding;else topPosition = 4 * verticalGap + 3 * buttonHeight + topPadding;
	
	        var frameDisplayState;
	        var frameColor;
	
	        if (this.state.isOver == true) {
	            frameDisplayState = 'block';
	            frameColor = _Properties2.default.SLIDE_FRAME_HOVER_COLOR;
	        } else {
	            frameDisplayState = 'none';
	            frameColor = 'black';
	        }
	
	        var boderWidth = 2;
	
	        var frameStyle = {
	            position: 'absolute',
	            width: buttonWidth - 2 * boderWidth,
	            height: buttonHeight - 2 * boderWidth,
	            borderWidth: boderWidth,
	            borderStyle: 'solid',
	            borderColor: frameColor,
	            top: 0,
	            display: frameDisplayState
	        };
	
	        var buttonStyle = {
	            position: 'absolute',
	            left: leftPosition,
	            top: topPosition,
	            width: buttonWidth,
	            height: buttonHeight,
	            cursor: '-webkit-grab',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            display: 'flex',
	            borderStyle: 'none'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            width: buttonWidth,
	            height: buttonHeight
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            width: buttonWidth - 10,
	            textAlign: 'center',
	            left: 5,
	            top: 30,
	            fontSize: 14,
	            cursor: 'default',
	            color: frameColor
	        };
	
	        var draggableStyle = {
	            position: 'absolute',
	            width: buttonWidth,
	            height: buttonHeight,
	            top: 0,
	            background: 'red',
	            opacity: 0
	        };
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            spanStyle.fontSize = 12;
	            spanStyle.top = 20;
	        }
	
	        var idValue;
	
	        if (this.props.index == 6) idValue = 'leftTextMenuLastFocusableElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, ref: 'itemRenderer', 'aria-label': this.getButtonAriaLabel(), style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onMouseClick, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp },
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: this.props.src }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            ),
	            _react2.default.createElement('div', { style: frameStyle }),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onDragStart, onDrag: this.onDragMove, onStop: this.onDragEnd },
	                _react2.default.createElement('div', { style: draggableStyle })
	            )
	        );
	    }
	});
	
	var LeftTextMenu = exports.LeftTextMenu = _react2.default.createClass({
	    displayName: 'LeftTextMenu',
	    getInitialState: function getInitialState() {
	        return {
	            buttons: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('leftTextMenuFirstFocusabletElement');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    initElements: function initElements() {
	        var buttons = [];
	
	        buttons.push(_react2.default.createElement(Button, { index: 0, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('TextSimple', 'text'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/simpleText.png', key: 'textMenu0' }));
	        buttons.push(_react2.default.createElement(Button, { index: 1, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('TextShape', 'text'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/textBoxIcon.png', key: 'textMenu1' }));
	        buttons.push(_react2.default.createElement(Button, { index: 2, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('SpeechShape', 'text'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/speachBubble.png', key: 'textMenu2' }));
	        buttons.push(_react2.default.createElement(Button, { index: 3, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('ThoughtShape', 'text'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/thoughtBubble.png', key: 'textMenu3' }));
	        buttons.push(_react2.default.createElement(Button, { index: 4, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('ScreamShape', 'text'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/screamBubble.png', key: 'textMenu4' }));
	        buttons.push(_react2.default.createElement(Button, { index: 5, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('ComplexSpeechShape', 'text'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/complexSpeachBubble.png', key: 'textMenu5' }));
	
	        if (_TextEditorUtils2.default.useRichText()) buttons.push(_react2.default.createElement(Button, { index: 6, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('MindMapShape', 'text'), src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/mindMap.png', key: 'textMenu6' }));
	
	        this.setState({
	            buttons: buttons
	        });
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.buttons != nextState.buttons || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.buttons == undefined) return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var listHeight = this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        var componentProperties = {};
	
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = listHeight;
	        componentProperties.top = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = this.state.buttons;
	
	        var verticalGap = 5;
	        var horizontalGap = _PlatformDetection2.default.isIOS() ? 10 : 20;
	        var buttonWidth = (_Properties2.default.BROWSER_WIDTH - 3 * horizontalGap) / 2;
	
	        componentProperties.scrollHeight = 3 * buttonWidth + 3 * verticalGap;
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'leftTextMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LeftTextMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/LeftTextMenu.js"); } } })();

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MainMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _SaveButton = __webpack_require__(813);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _cartoonistIcons = __webpack_require__(207);
	
	var _cartoonistIcons2 = _interopRequireDefault(_cartoonistIcons);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Text menu
	                    _HoverManager2.default.show(this.refs.button, 'mainMenuText', 'left');
	                    break;
	                }
	            case 1:
	                {
	                    // Drawing
	                    _HoverManager2.default.show(this.refs.button, 'mainMenuDrawing', 'left');
	                    break;
	                }
	            case 2:
	                {
	                    // Shapes
	                    _HoverManager2.default.show(this.refs.button, 'mainMenuShapes', 'left');
	                    break;
	                }
	            case 3:
	                {
	                    // Frames
	                    _HoverManager2.default.show(this.refs.button, 'mainMenuFrames', 'left');
	                    break;
	                }
	            case 4:
	                {
	                    // Effects
	                    _HoverManager2.default.show(this.refs.button, 'mainMenuEffects', 'left');
	                    break;
	                }
	            case 5:
	                {
	                    // Media
	                    _HoverManager2.default.show(this.refs.button, 'mainMenuMedia', 'left');
	                    break;
	                }
	        }
	
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Text
	                    dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.TEXT));
	                    break;
	                }
	            case 1:
	                {
	                    // Drawing
	                    dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.FREEHAND));
	                    break;
	                }
	            case 2:
	                {
	                    // Shapes
	                    dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.SHAPES));
	                    break;
	                }
	            case 3:
	                {
	                    // Frames
	                    dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.FRAMES));
	                    dispatch((0, _MenuActions.changeCartoonistTabIndex)(4));
	                    break;
	                }
	            case 4:
	                {
	                    // Effects
	                    dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.EFFECTS));
	                    dispatch((0, _MenuActions.changeCartoonistTabIndex)(5));
	                    break;
	                }
	            case 5:
	                {
	                    // Media
	                    dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.MEDIA));
	                    var myMediaCategory = _StoreManager2.default.getState().menu.myMediaCategory;
	
	                    if (myMediaCategory == undefined) myMediaCategory = _ModeConstants2.default.IMAGES;
	
	                    if (myMediaCategory == _ModeConstants2.default.IMAGES) dispatch((0, _MenuActions.changeCartoonistTabIndex)(7));else dispatch((0, _MenuActions.changeCartoonistTabIndex)(8));
	                    break;
	                }
	        }
	
	        if (this.props.accordionWidth == 0) dispatch((0, _AccordionActions.changeAcoordionWidth)(_Properties2.default.BROWSER_WIDTH));
	    },
	    isSelected: function isSelected() {
	        var state = _StoreManager2.default.getState();
	        var contextMode = state.menu.contextMode;
	        var isSelected = false;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Text
	                    isSelected = contextMode == _ModeConstants2.default.TEXT;
	                    break;
	                }
	            case 1:
	                {
	                    // Drawing
	                    isSelected = contextMode == _ModeConstants2.default.FREEHAND;
	                    break;
	                }
	            case 2:
	                {
	                    // Shapes
	                    isSelected = contextMode == _ModeConstants2.default.SHAPES;
	                    break;
	                }
	            case 3:
	                {
	                    // Frames
	                    isSelected = contextMode == _ModeConstants2.default.FRAMES;
	                    break;
	                }
	            case 4:
	                {
	                    // Effects
	                    isSelected = contextMode == _ModeConstants2.default.EFFECTS;
	                    break;
	                }
	            case 5:
	                {
	                    // Media
	                    isSelected = contextMode == _ModeConstants2.default.MEDIA;
	                    break;
	                }
	        }
	
	        return isSelected;
	    },
	    render: function render() {
	        var tabHeight = 60;
	        var iconTopPosition = 19;
	        var src;
	        var color;
	        var iconColor;
	
	        if (this.props.menuHeight < 370) {
	            tabHeight = 36;
	            iconTopPosition = 4;
	        } else if (this.props.menuHeight < 420) {
	            tabHeight = 40;
	            iconTopPosition = 8;
	        } else if (this.props.menuHeight < 485) {
	            tabHeight = 50;
	            iconTopPosition = 12;
	        }
	
	        var topPosition = tabHeight * this.props.index;
	
	        if (this.isSelected()) {
	            color = '#2377bb';
	            iconColor = 'white';
	        } else {
	            color = 'white';
	
	            if (this.state.isOver) iconColor = '#2377bb';else iconColor = 'black';
	        }
	
	        var tabStyle = {
	            position: 'absolute',
	            width: this.props.width,
	            height: tabHeight,
	            top: topPosition,
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none',
	            cursor: 'pointer',
	            background: color,
	            borderStyle: 'none'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: iconTopPosition,
	            left: 7,
	            fontSize: 23,
	            color: iconColor
	        };
	
	        var ariaLabel = '';
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    src = 'cart-text-in-speechbubble';
	                    ariaLabel = _LocalesManager2.default.getCaption('mainMenuText', 'hover');
	                    break;
	                }
	            case 1:
	                {
	                    src = 'cart-paint-brush';
	                    ariaLabel = _LocalesManager2.default.getCaption('mainMenuDrawing', 'hover');
	                    break;
	                }
	            case 2:
	                {
	                    src = 'cart-shapes';
	                    ariaLabel = _LocalesManager2.default.getCaption('mainMenuShapes', 'hover');
	                    break;
	                }
	            case 3:
	                {
	                    src = 'cart-frame';
	                    ariaLabel = _LocalesManager2.default.getCaption('mainMenuFrames', 'hover');
	                    break;
	                }
	            case 4:
	                {
	                    src = 'cart-effect';
	                    ariaLabel = _LocalesManager2.default.getCaption('mainMenuEffects', 'hover');
	                    break;
	                }
	            case 5:
	                {
	                    src = 'cart-folder';
	                    ariaLabel = _LocalesManager2.default.getCaption('mainMenuMedia', 'hover');
	                    break;
	                }
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { ref: 'button', 'aria-label': ariaLabel, style: tabStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement('i', { style: iconStyle, className: _cartoonistIcons2.default[src] })
	        );
	    }
	});
	
	var MainMenuContent = _react2.default.createClass({
	    displayName: 'MainMenuContent',
	    render: function render() {
	        var windowHeight = this.props.windowHeight - this.props.noInternetAlertHeight;
	        var slideViewHeight = _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT + _Properties2.default.SLIDE_VIEWER_TOP_GAP + _Properties2.default.SLIDE_VIEWER_LIST_HEIGHT + _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP;
	
	        if (this.props.showAudioEditor) slideViewHeight = slideViewHeight + _AudioEditorUtils2.default.getAudioEditorHeight();
	
	        var menuStyle = {
	            position: 'absolute',
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            left: this.props.windowWidth - this.props.accordionWidth - _Properties2.default.MAIN_MENU_WIDTH,
	            width: _Properties2.default.MAIN_MENU_WIDTH,
	            height: windowHeight - slideViewHeight,
	            backgroundColor: '#ffffff',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            boxShadow: '2px 0px 8px'
	        };
	
	        var elementsStyle = {
	            position: 'absolute',
	            top: 125
	        };
	
	        if (menuStyle.height <= 330) elementsStyle.top = 110;
	
	        var rightLineStyle = {
	            position: 'absolute',
	            top: 0,
	            width: 1,
	            height: menuStyle.height,
	            left: menuStyle.width - 1,
	            boxShadow: '0px 0px 10px'
	        };
	
	        if (this.props.contextMode == _ModeConstants2.default.LINE_CONTEXT || this.props.contextMode == _ModeConstants2.default.FREEHAND_CONTEXT || this.props.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) {
	            menuStyle.pointerEvents = 'none';
	            menuStyle.opacity = 0.5;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(_SaveButton.SaveButton, { dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight }),
	            _react2.default.createElement(
	                'div',
	                { style: elementsStyle },
	                _react2.default.createElement(Button, { width: _Properties2.default.MAIN_MENU_WIDTH, index: 0, accordionWidth: this.props.accordionWidth, menuHeight: menuStyle.height }),
	                _react2.default.createElement(Button, { width: _Properties2.default.MAIN_MENU_WIDTH, index: 1, accordionWidth: this.props.accordionWidth, menuHeight: menuStyle.height }),
	                _react2.default.createElement(Button, { width: _Properties2.default.MAIN_MENU_WIDTH, index: 2, accordionWidth: this.props.accordionWidth, menuHeight: menuStyle.height }),
	                _react2.default.createElement(Button, { width: _Properties2.default.MAIN_MENU_WIDTH, index: 3, accordionWidth: this.props.accordionWidth, menuHeight: menuStyle.height }),
	                _react2.default.createElement(Button, { width: _Properties2.default.MAIN_MENU_WIDTH, index: 4, accordionWidth: this.props.accordionWidth, menuHeight: menuStyle.height }),
	                _react2.default.createElement(Button, { width: _Properties2.default.MAIN_MENU_WIDTH, index: 5, accordionWidth: this.props.accordionWidth, menuHeight: menuStyle.height })
	            ),
	            _react2.default.createElement('div', { style: rightLineStyle })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var contextMode = state.menu.contextMode;
	    var accordionWidth = state.accordion.width;
	    var showAudioEditor = state.menu.showAudioEditor;
	    var timelines = state.audioEditor.timelines;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    return {
	        contextMode: contextMode,
	        accordionWidth: accordionWidth,
	        showAudioEditor: showAudioEditor,
	        timelines: timelines
	    };
	}
	
	var MainMenu = exports.MainMenu = (0, _reactRedux.connect)(mapStateToProps)(MainMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MainMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MainMenu.js"); } } })();

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MainUniverseItemRenderer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MenuActions = __webpack_require__(7);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainUniverseItemRendererContent = _react2.default.createClass({
	    displayName: 'MainUniverseItemRendererContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.changeUniverse();
	    },
	    onClick: function onClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.changeUniverse();
	    },
	    changeUniverse: function changeUniverse() {
	        var currentMainUniverse = _AppParameters2.default.currentMainUniverse;
	
	        if (currentMainUniverse != this.props.item.universe) {
	            _MasterUniverseUtils2.default.changeMainUniverse(this.props.item.universe);
	        } else {
	            this.props.dispatch((0, _MenuActions.showMainUniverse)(false));
	        }
	
	        _MouseUtils2.default.setFocusSequence();
	    },
	    getTitle: function getTitle() {
	        var universeItem = this.props.item;
	
	        if (!universeItem.translations) return universeItem.universe;else {
	            var translation = universeItem.translations[_MasterUniverseUtils2.default.language()];
	
	            if (translation && translation.length > 0) return translation;else if (universeItem.translations['en_US']) return universeItem.translations['en_US'];else return universeItem.universe;
	        }
	    },
	    getThumbnail: function getThumbnail() {
	        return 'https://svg-cartoonist.creaza.com/thumbnails/universe_' + this.props.item.universe + '.png';
	    },
	    getColor: function getColor() {
	        var color = _Properties2.default.BROWSER_SELECTED_COLOR;
	
	        switch (this.props.item.universe) {
	            case 'nature_science':
	                {
	                    // green
	                    color = '#52d856';
	                    break;
	                }
	
	            case 'world_history':
	                {
	                    //yellow
	                    color = '#f9c758';
	                    break;
	                }
	
	            case 'fiction':
	                {
	                    // red
	                    color = '#ec5871';
	                    break;
	                }
	
	            case 'generic':
	                {
	                    // blue
	                    color = '#58bced';
	                    break;
	                }
	
	            case 'alphabet_planet':
	                {
	                    // purple
	                    color = '#9252da';
	                    break;
	                }
	        }
	
	        return color;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth || this.props.refreshValue != newProps.refreshValue || this.props.listHeight != newProps.listHeight) return true;else return false;
	    },
	    render: function render() {
	        var textColor;
	        var iconSrc;
	
	        if (this.state.isOver == true) {
	            textColor = '#dddddd';
	            iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/selectedThemeHover.png';
	        } else {
	            textColor = 'white';
	            iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/selectedTheme.png';
	        }
	
	        var aspectRatio = 1 / 3;
	        var scrollWidth = 15;
	        var hGap = 10;
	        var bottomGap = 10;
	        var buttonWidth = this.props.accordionWidth - 2 * hGap - scrollWidth;
	        var buttonHeight = buttonWidth * aspectRatio + bottomGap;
	        var listHeight = this.props.listHeight;
	        var itemsLength = this.props.itemsLength;
	        var scrollHeight = buttonHeight * itemsLength;
	        var extraItemHeight = 0;
	        var realButtonHeight = buttonHeight;
	
	        if (scrollHeight < listHeight) {
	            var newButtonHeight = listHeight / itemsLength;
	            extraItemHeight = newButtonHeight - buttonHeight;
	            realButtonHeight = realButtonHeight + extraItemHeight;
	        }
	
	        var tabStyle = {
	            position: 'absolute',
	            width: buttonWidth,
	            height: realButtonHeight,
	            top: this.props.index * realButtonHeight,
	            left: hGap,
	            cursor: 'pointer',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            textAlign: 'left',
	            borderStyle: 'none',
	            background: 'none',
	            display: 'flex'
	        };
	
	        var spanStyle = {
	            position: 'relative',
	            color: textColor,
	            fontSize: 34,
	            width: this.props.accordionWidth - 2 * hGap - scrollWidth - 5,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            top: '5%',
	            textAlign: 'center',
	            fontFamily: 'Arial',
	            fontWeight: 'bold',
	            textShadow: '0px 0px 10px black',
	            cursor: 'pointer'
	        };
	
	        var imageStyle = {
	            position: 'absolute',
	            top: extraItemHeight,
	            left: 0,
	            width: buttonWidth,
	            height: buttonHeight - bottomGap,
	            cursor: 'pointer'
	        };
	
	        var iconVisible;
	
	        if (this.props.item.universe == _AppParameters2.default.currentMainUniverse) iconVisible = 'block';else iconVisible = 'none';
	
	        var checkIconStyle = {
	            position: 'absolute',
	            top: 5,
	            right: 5,
	            display: iconVisible,
	            width: 30,
	            height: 30
	        };
	
	        if (_PlatformDetection2.default.isIOS()) {
	            spanStyle.fontSize = 24;
	            checkIconStyle.top = 3;
	            checkIconStyle.right = 3;
	            checkIconStyle.width = 25;
	            checkIconStyle.height = 25;
	        }
	
	        var extraItemStyle = {
	            position: 'absolute',
	            top: 0,
	            width: buttonWidth,
	            height: extraItemHeight,
	            background: this.getColor()
	        };
	
	        var universeTitle = this.getTitle();
	
	        if (universeTitle.indexOf(' ') != -1) {
	            universeTitle = universeTitle.replaceAll(' ', '\n');
	
	            if (universeTitle.indexOf('The') != -1) universeTitle = universeTitle.replace('\n', ' ');
	
	            spanStyle.whiteSpace = 'break-spaces';
	            spanStyle.top = '3%';
	        }
	
	        var idValue;
	
	        if (this.props.index == 0) idValue = 'firstUniverseElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, 'aria-label': universeTitle, style: tabStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchStart: this.onMouseDown, onClick: this.onClick, onTouchEnd: this.onMouseUp, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp },
	            _react2.default.createElement('div', { style: extraItemStyle }),
	            _react2.default.createElement('img', { alt: universeTitle, style: imageStyle, src: this.getThumbnail() }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                universeTitle
	            ),
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: checkIconStyle, src: iconSrc })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var accordionWidth = state.accordion.width;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    return {
	        accordionWidth: accordionWidth
	    };
	}
	
	var MainUniverseItemRenderer = exports.MainUniverseItemRenderer = (0, _reactRedux.connect)(mapStateToProps)(MainUniverseItemRendererContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MainUniverseItemRenderer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MainUniverseItemRenderer.js"); } } })();

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MainUniversesList = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _MainUniverseItemRenderer = __webpack_require__(798);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainUniversesListContent = _react2.default.createClass({
	    displayName: 'MainUniversesListContent',
	    getInitialState: function getInitialState() {
	        return {
	            elements: [],
	            windowHeight: this.props.windowHeight
	        };
	    },
	    checkElements: function checkElements() {
	        if (this.state && this.state.elements.length > 0 && this.state.windowHeight == this.props.windowHeight) return;
	
	        setTimeout(function () {
	            var elements = this.getElements();
	
	            this.setState({
	                elements: elements,
	                windowHeight: this.props.windowHeight
	            });
	        }.bind(this), 10);
	    },
	    getElements: function getElements() {
	        var items = _MasterUniverseUtils2.default.getMainUniversesList();
	        var elementsLength = Object.keys(items).length;
	        var item;
	        var elements = [];
	        var key;
	        var i = 0;
	        var listHeight = this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT - _Properties2.default.BROWSER_BUTTON_HEIGHT - 10 - 10;
	
	        for (key in items) {
	            item = items[key];
	            elements.push(_react2.default.createElement(_MainUniverseItemRenderer.MainUniverseItemRenderer, { dispatch: this.props.dispatch, listHeight: listHeight, itemsLength: elementsLength, accordionWidth: this.props.accordionWidth, index: i, item: item, refreshValue: this.props.refreshValue, key: 'mainUniverseSelector' + i }));
	            i = i + 1;
	        }
	
	        return elements;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.elements != nextState.elements || this.props.isUniversesVisible != newProps.isUniversesVisible || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth || this.props.refreshValue != newProps.refreshValue) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.elements == undefined) return _react2.default.createElement('div', null);
	
	        this.checkElements();
	
	        var listStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_COLOR,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT - _Properties2.default.BROWSER_BUTTON_HEIGHT,
	            top: _Properties2.default.CLIPART_BUTTON_HEIGHT + _Properties2.default.BROWSER_BUTTON_HEIGHT,
	            left: 0,
	            overflowX: 'hidden',
	            overflowY: 'hidden'
	        };
	
	        var topPadding = 10;
	        var bottomPadding = 10;
	        var items = this.state.elements;
	        var scrollWidth = 15;
	        var hGap = 10;
	        var bottomGap = 10;
	        var buttonWidth = this.props.accordionWidth - 2 * hGap - scrollWidth;
	        var itemHeight = buttonWidth * 1 / 3 + bottomGap;
	        var listHeight = this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT - _Properties2.default.BROWSER_BUTTON_HEIGHT - topPadding - bottomPadding;
	        var scrollHeight = items.length * itemHeight;
	
	        if (scrollHeight < listHeight) scrollHeight = listHeight;
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.top = topPadding;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = items;
	        componentProperties.backgroundColor = _Properties2.default.BROWSER_COLOR;
	        componentProperties.height = listHeight;
	        componentProperties.scrollHeight = scrollHeight;
	
	        return _react2.default.createElement(
	            'div',
	            { style: listStyle },
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var accordionWidth = state.accordion.width;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    return {
	        accordionWidth: accordionWidth
	    };
	}
	
	var MainUniversesList = exports.MainUniversesList = (0, _reactRedux.connect)(mapStateToProps)(MainUniversesListContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MainUniversesList.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MainUniversesList.js"); } } })();

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MediaImagesItemRenderer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _DragManager = __webpack_require__(107);
	
	var _DragManager2 = _interopRequireDefault(_DragManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaImagesItemRenderer = exports.MediaImagesItemRenderer = _react2.default.createClass({
	    displayName: 'MediaImagesItemRenderer',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0,
	            element: undefined,
	            scrollPosition: 0
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	    },
	    onImageLoaded: function onImageLoaded(e) {
	        var imageWidth = e.currentTarget.width;
	        var imageHeight = e.currentTarget.height;
	        var gap = 3;
	        var width = 100;
	        var height = width * 3 / 4;
	
	        width = width - gap;
	        height = height - gap;
	
	        if (imageWidth > width) {
	            var image = e.currentTarget;
	            var newHeight = width * (imageHeight / imageWidth);
	
	            image.style.position = 'absolute';
	            image.style.left = '0px';
	            image.style.width = width + 'px';
	            image.style.height = newHeight + 'px';
	            image.style.top = (height - newHeight) / 2 + 'px';
	        }
	    },
	    onVideoLoaded: function onVideoLoaded(e) {
	        var imageWidth = e.currentTarget.videoWidth;
	        var imageHeight = e.currentTarget.videoHeight;
	        var gap = 3;
	        var width = 100;
	        var height = width * 3 / 4;
	
	        width = width - gap;
	        height = height - gap;
	
	        if (imageWidth > imageHeight && imageWidth > width) {
	            var image = e.currentTarget;
	            var newHeight = width * (imageHeight / imageWidth);
	
	            image.style.position = 'absolute';
	            image.style.left = '0px';
	            image.style.width = width + 'px';
	            image.style.height = newHeight + 'px';
	            image.style.top = (height - newHeight) / 2 + 'px';
	        }
	    },
	    initElements: function initElements() {
	        var gap = 3;
	        var width = 100;
	        var height = width * 3 / 4 + 15;
	
	        var itemRendererStyle = {
	            position: 'relative',
	            width: width,
	            height: height,
	            paddingTop: gap,
	            paddingLeft: gap,
	            display: 'inline-block',
	            textAlign: 'center',
	            cursor: '-webkit-grab'
	        };
	
	        width = width - gap;
	        height = height - gap;
	
	        var wrapperStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            background: 'aliceblue',
	            textAlign: 'center',
	            top: 0,
	            display: 'block'
	        };
	
	        var imageStyle = {
	            height: height
	        };
	
	        var frameDisplayState = void 0;
	
	        if (this.state.isOver == true) frameDisplayState = 'block';else frameDisplayState = 'none';
	
	        var boderWidth = 2;
	
	        var frameStyle = {
	            width: width - 2 * boderWidth,
	            height: height - 2 * boderWidth,
	            borderWidth: boderWidth,
	            borderStyle: 'solid',
	            borderColor: _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR,
	            position: 'absolute',
	            top: 0,
	            display: frameDisplayState
	        };
	
	        var draggableStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            top: 2,
	            background: 'red',
	            opacity: 0,
	            display: 'block'
	        };
	
	        if (!this.props.item) return;
	
	        var element1;
	        var thumb;
	
	        var src = this.props.item.thumb;
	        // var src = 'https://stage.creaza.com/file/ci/58153319/thumb/aaa';
	
	        if (this.props.item.status == 'preparing' || this.props.item.status == 'corrupt') {
	            var loaderStyle = {
	                position: 'absolute',
	                top: 20,
	                left: 35,
	                color: 'black'
	            };
	
	            if (this.props.item.href && this.props.item.href.length > 0) {
	                if (this.props.isVideo) {
	                    if (!_PlatformDetection2.default.isIOS() && this.props.item.status == 'preparing') thumb = _react2.default.createElement('video', { src: this.props.item.href, style: imageStyle, onLoadedData: this.onVideoLoaded });else thumb = _react2.default.createElement('i', { style: loaderStyle, className: 'fa fa-spinner fa-pulse fa-2x' });
	                } else thumb = _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', src: this.props.item.href, style: imageStyle, onLoad: this.onImageLoaded });
	            } else {
	                thumb = _react2.default.createElement('i', { style: loaderStyle, className: 'fa fa-spinner fa-pulse fa-2x' });
	            }
	        } else thumb = _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', src: src, style: imageStyle, onLoad: this.onImageLoaded });
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            element1 = _react2.default.createElement(
	                'div',
	                { style: wrapperStyle },
	                thumb,
	                _react2.default.createElement('div', { style: frameStyle })
	            );
	        } else {
	            element1 = thumb;
	        }
	
	        var element2 = _react2.default.createElement(
	            _reactDraggable2.default,
	            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onDragStart, onDrag: this.onDragMove, onStop: this.onDragEnd },
	            _react2.default.createElement('span', { style: draggableStyle })
	        );
	
	        var uploadButton;
	
	        if (this.props.item && this.props.item.isUploadButton) {
	            var uploadItemRendererStyle = {
	                position: 'relative',
	                width: width,
	                paddingTop: gap,
	                paddingLeft: gap,
	                display: 'inline-block',
	                textAlign: 'center'
	            };
	
	            if (_PlatformDetection2.default.isIOS()) uploadItemRendererStyle.height = 60;
	
	            if (this.props.length < 2) {
	                uploadItemRendererStyle.height = 60;
	                uploadItemRendererStyle.paddingTop = 7;
	            }
	
	            var wrapperUploadButtonStyle = {
	                position: 'absolute',
	                width: width,
	                height: height,
	                textAlign: 'center',
	                display: 'block',
	                top: 0
	            };
	
	            var uploadIconStyle = {
	                position: 'absolute',
	                top: 4,
	                left: 21,
	                color: '#2DE102'
	            };
	
	            if (_PlatformDetection2.default.isIOS()) {
	                uploadButton = _react2.default.createElement(
	                    'div',
	                    { style: uploadItemRendererStyle, id: 'uploadButton', onMouseDown: this.onUpload, onTouchStart: this.onUpload, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	                    _react2.default.createElement(
	                        'div',
	                        { style: wrapperUploadButtonStyle },
	                        _react2.default.createElement('i', { style: uploadIconStyle, className: 'fa fa-plus-circle fa-4x' })
	                    )
	                );
	            } else {
	                uploadItemRendererStyle.width = itemRendererStyle.width;
	                uploadItemRendererStyle.height = itemRendererStyle.height;
	                uploadItemRendererStyle.paddingTop = gap;
	                uploadItemRendererStyle.paddingLeft = gap;
	                uploadItemRendererStyle.paddingRight = 0;
	                uploadItemRendererStyle.paddingBottom = 0;
	                uploadItemRendererStyle.boxSizing = 'initial';
	                uploadItemRendererStyle.fontSize = 'initial';
	                uploadItemRendererStyle.borderStyle = 'none';
	                uploadItemRendererStyle.background = 'none';
	                uploadItemRendererStyle.top = -4;
	                wrapperUploadButtonStyle.top = 0;
	
	                uploadButton = _react2.default.createElement(
	                    'button',
	                    { 'aria-label': _LocalesManager2.default.getCaption('UploadHover', 'myFiles'), style: uploadItemRendererStyle, id: 'uploadButton', onClick: this.onUpload, onTouchStart: this.onUpload, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	                    _react2.default.createElement(
	                        'span',
	                        { style: wrapperUploadButtonStyle },
	                        _react2.default.createElement('i', { style: uploadIconStyle, className: 'fa fa-plus-circle fa-4x' })
	                    )
	                );
	            }
	        }
	
	        var fontStyle = {
	            fontSize: 10,
	            height: 15,
	            width: width - 6,
	            paddingLeft: 3,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            position: 'absolute',
	            bottom: 0,
	            left: 0
	        };
	
	        if (_PlatformDetection2.default.isIOS() == true) fontStyle.bottom = 8;
	
	        var fontElement = _react2.default.createElement(
	            'span',
	            { style: fontStyle },
	            this.getTitle()
	        );
	
	        this.setState({
	            itemRendererStyle: itemRendererStyle,
	            wrapperStyle: wrapperStyle,
	            element1: element1,
	            element2: element2,
	            uploadButton: uploadButton,
	            fontElement: fontElement
	        });
	    },
	    getTitle: function getTitle() {
	        if (this.props.item.title) return this.props.item.title;
	
	        var title = '';
	
	        if (this.props.item.noBackground == true) title = this.props.item.title;
	
	        return title;
	    },
	    onMouseIn: function onMouseIn() {
	        if (this.isDisabled()) {
	            this.setState({
	                isMouseIn: true
	            });
	
	            return;
	        }
	
	        this.setState({
	            isOver: true
	        });
	
	        if (this.props.item.isUploadButton) {
	            var button = document.getElementById('uploadButton');
	            _HoverManager2.default.show(button, 'uploadButton');
	        }
	    },
	    onMouseOut: function onMouseOut() {
	        _HoverManager2.default.hide();
	
	        if (this.isDisabled()) {
	            this.setState({
	                isMouseIn: false
	            });
	
	            return;
	        }
	
	        this.setState({
	            isOver: false
	        });
	    },
	    changeFocusToShapeMenuButton: function changeFocusToShapeMenuButton() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var shapeMenuButton = document.getElementById('shapeMenuButton');
	
	            if (shapeMenuButton) shapeMenuButton.focus();
	        }.bind(this), 300);
	    },
	    createShape: function createShape(topLeftPosition) {
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        if (this.props.isVideo) {
	            if (_CreateShapes2.default.useVideoAsBackground) this.setVideoAsBackground(this.props.item, dispatch);else _CreateShapes2.default.createVideo(dispatch, this.props.item, topLeftPosition);
	        } else {
	            if (_CreateShapes2.default.useImageAsBackground) this.setImageAsBackground(this.props.item, dispatch);else _CreateShapes2.default.createImage(dispatch, this.props.item, topLeftPosition);
	
	            this.changeFocusToShapeMenuButton();
	        }
	    },
	    setVideoAsBackground: function setVideoAsBackground(item, dispatch) {
	        _VideoUtils2.default.updateContentFromCurrentSlide();
	
	        var newContent = {};
	        newContent.logicalName = item.logicalName;
	        newContent.href = item.href;
	        newContent.moods = [];
	        newContent.hotSpot = '';
	        newContent.frameLabel = '';
	
	        newContent.isVideo = true;
	        newContent.volume = 0.5;
	        newContent.inPoint = undefined;
	        newContent.outPoint = undefined;
	
	        if (item.contentItemId > 0) newContent.contentItemId = item.contentItemId;
	
	        _VideoUtils2.default.changeVideoBackground = true;
	
	        dispatch((0, _CurrentSlideActions.changeBackgroundContent)(newContent));
	        _CreateShapes2.default.updateThumbnail(dispatch);
	        dispatch((0, _MenuActions.showAudioAlert)(3));
	    },
	    setImageAsBackground: function setImageAsBackground(item, dispatch) {
	        var imageObj = new Image();
	        var self = this;
	
	        imageObj.onload = function (e) {
	            var orgWidth = e.target.width;
	            var orgHeight = e.target.height;
	
	            self.changeBackgroundProperties(item, dispatch, orgWidth, orgHeight);
	        };
	
	        imageObj.src = _VideoUtils2.default.checkCacheBreaker(item.href);
	    },
	    changeBackgroundProperties: function changeBackgroundProperties(item, dispatch, orgWidth, orgHeight) {
	        var newContent = {};
	        newContent.logicalName = item.logicalName;
	        newContent.href = item.href;
	        newContent.moods = [];
	        newContent.hotSpot = '';
	        newContent.frameLabel = '';
	        newContent.orgWidth = orgWidth;
	        newContent.orgHeight = orgHeight;
	
	        newContent.isVideo = false;
	        newContent.volume = 0.5;
	        newContent.inPoint = undefined;
	        newContent.outPoint = undefined;
	
	        if (item.contentItemId > 0) newContent.contentItemId = item.contentItemId;
	
	        dispatch((0, _CurrentSlideActions.changeBackgroundContent)(newContent));
	        _CreateShapes2.default.updateThumbnail(dispatch);
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        _SaveManager2.default.isContentChanged(true);
	    },
	    onUpload: function onUpload(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e) || this.isDisabled()) return;
	
	        window.parent.postMessage('openUploader', '*');
	    },
	    rejectMouseDownEvent: function rejectMouseDownEvent(e) {
	        if (_PlatformDetection2.default.isChromeBook()) {
	            var currentTime = new Date().getTime();
	            var lastClickTime = _MouseUtils2.default.mouseDownTime;
	
	            if (lastClickTime != 0 && currentTime - lastClickTime < 100) return true;else return false;
	        } else return false;
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e) || this.isDisabled() || this.rejectMouseDownEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	        _MouseUtils2.default.isDragEnd = false;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    isDisabled: function isDisabled() {
	        if (!this.props.isVideo && _VideoUtils2.default.showVideoEditor()) return true;else return false;
	    },
	    onClick: function onClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        _MouseUtils2.default.isDragEnd = false;
	
	        this.createShape();
	    },
	    rejectMouseUpEvent: function rejectMouseUpEvent(e) {
	        if (_PlatformDetection2.default.isChromeBook()) {
	            var currentTime = new Date().getTime();
	            var lastClickTime = _MouseUtils2.default.mouseUpTime;
	
	            if (lastClickTime != 0 && currentTime - lastClickTime < 100) return true;else return false;
	        } else return false;
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e) || this.isDisabled() || this.rejectMouseUpEvent(e)) return;
	
	        _MouseUtils2.default.mouseUpTime = new Date().getTime();
	
	        if (_MouseUtils2.default.isDragEnd == true) {
	            _MouseUtils2.default.isDragEnd = true;
	            return;
	        }
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.createShape();
	    },
	    onDragStart: function onDragStart(e, coreEvent) {
	        if (_PlatformDetection2.default.isTouchableDevice() == true || this.isDisabled()) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	        _MouseUtils2.default.isDragEnd = false;
	
	        var clone = this.refs.itemRenderer;
	
	        _DragManager2.default.prepareClone(clone, this.createShape, (0, _TransformToolUtils.getTouchPosition)(e));
	    },
	    onDragMove: function onDragMove(e, coreEvent) {
	        if (_PlatformDetection2.default.isTouchableDevice() == true || this.isDisabled()) return;
	
	        _DragManager2.default.onDragMove(coreEvent.lastX, coreEvent.lastY);
	    },
	    onDragEnd: function onDragEnd(e, coreEvent) {
	        if (_PlatformDetection2.default.isTouchableDevice() == true || this.isDisabled()) return;
	
	        _MouseUtils2.default.isDragEnd = true;
	
	        _DragManager2.default.onDragEnd(coreEvent.lastX, coreEvent.lastY);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.element1 != nextState.element1 || this.state.isOver != nextState.isOver || this.props.isVideo != newProps.isVideo || this.state.isMouseIn != nextState.isMouseIn) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.element1 == undefined) return _react2.default.createElement('div', null);
	
	        if (this.props.item && this.props.item.isUploadButton) {
	            return this.state.uploadButton;
	        }
	
	        var thumbnailElement = this.state.element1;
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            return _react2.default.createElement(
	                'div',
	                { ref: 'itemRenderer', id: 'MediaImagesItemRenderer_' + Math.random(), style: this.state.itemRendererStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp },
	                thumbnailElement,
	                this.state.fontElement,
	                this.state.element2
	            );
	        } else {
	            var width = 100;
	            var height = width * 3 / 4 + 15;
	            var frameDisplayState = void 0;
	
	            if (this.state.isOver == true) frameDisplayState = 'block';else frameDisplayState = 'none';
	
	            var boderWidth = 2;
	
	            var frameStyle = {
	                width: width - 3 * boderWidth,
	                height: height - 3 * boderWidth,
	                borderWidth: boderWidth,
	                borderStyle: 'solid',
	                borderColor: _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR,
	                position: 'absolute',
	                top: 0,
	                display: frameDisplayState
	            };
	
	            var style = Object.assign({}, this.state.itemRendererStyle);
	
	            if (this.isDisabled()) style.cursor = 'default';else style.cursor = '-webkit-grab';
	
	            style.margin = 0;
	            style.paddingRight = 0;
	            style.paddingBottom = 0;
	            style.boxSizing = 'initial';
	            style.fontSize = 'initial';
	            style.borderStyle = 'none';
	            style.background = 'none';
	
	            return _react2.default.createElement(
	                'button',
	                { 'aria-label': this.getTitle(), ref: 'itemRenderer', id: 'MediaImagesItemRenderer_' + Math.random(), style: style, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onClick, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp },
	                _react2.default.createElement(
	                    'span',
	                    { style: this.state.wrapperStyle },
	                    thumbnailElement,
	                    this.state.fontElement,
	                    _react2.default.createElement('span', { style: frameStyle })
	                ),
	                ';',
	                this.state.element2
	            );
	        }
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MediaImagesItemRenderer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MediaImagesItemRenderer.js"); } } })();

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MediaImagesList = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MediaImagesItemRenderer = __webpack_require__(800);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _PopulateMediaFilesUtils = __webpack_require__(80);
	
	var _PopulateMediaFilesUtils2 = _interopRequireDefault(_PopulateMediaFilesUtils);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaImagesList = exports.MediaImagesList = _react2.default.createClass({
	    displayName: 'MediaImagesList',
	    getInitialState: function getInitialState() {
	        return {
	            currentPage: 0,
	            elements: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.dataProvider && nextProps.dataProvider.length == 1) this.recreateElements();else if (nextProps.dataProvider && nextProps.dataProvider.length > 1 && nextProps.dataProvider[1] != undefined && this.shouldRefreshDataProvider(this.props.dataProvider, nextProps.dataProvider)) this.recreateElements();
	    },
	    shouldRefreshDataProvider: function shouldRefreshDataProvider(oldData, newData) {
	        if (!oldData || !newData) return false;
	
	        if (oldData.length != newData.length) return true;else {
	            var length = newData.length;
	
	            if (length > 15) length = 15;
	
	            for (var i = 0; i < length; i++) {
	                if (oldData[i] && newData[i] && oldData[i].status != newData[i].status) return true;
	            }
	
	            return false;
	        }
	    },
	    recreateElements: function recreateElements() {
	        setTimeout(this.refreshNewContent, 50);
	    },
	    refreshNewContent: function refreshNewContent() {
	        this.initElements();
	    },
	    initElements: function initElements() {
	        var elements = [];
	        var items = this.props.dataProvider == undefined ? [] : this.props.dataProvider;
	        var i = void 0;
	
	        if (_Configuration2.default.LOAD_LOCAL) {
	            if (this.props.isVideo) items = _PopulateMediaFilesUtils2.default.getVideosDataProviderForTest();else items = _PopulateMediaFilesUtils2.default.getImagesDataProviderForTest();
	        }
	
	        var dif = '_images_';
	
	        if (this.props.isVideo == true) dif = '_videos_';
	
	        for (i = 0; i < items.length; i++) {
	            var item = items[i];
	            elements.push(_react2.default.createElement(_MediaImagesItemRenderer.MediaImagesItemRenderer, { length: items.length, isVideo: this.props.isVideo, index: i, usePagination: true, parentWidth: this.props.accordionWidth, item: item, key: 'mediaImages' + dif + (i + 1) + Math.random() }));
	        }
	
	        _MasterUniverseUtils2.default.scrollPosition = 0;
	
	        this.setState({
	            currentPage: 0,
	            allElements: elements,
	            elements: this.getCurrentElements(elements, 0)
	        });
	    },
	    getCurrentElements: function getCurrentElements(allElements, page) {
	        var hitsPerPage = 50;
	        var maxIndex = hitsPerPage * (page + 1);
	        var items = [];
	
	        for (var i = 0; i < allElements.length; i++) {
	            if (i < maxIndex) items.push(allElements[i]);else break;
	        }
	
	        return items;
	    },
	    uploadNewPage: function uploadNewPage(scrollTop) {
	        if (Math.abs(scrollTop - _MasterUniverseUtils2.default.scrollPosition) < 40) return;
	
	        _MasterUniverseUtils2.default.scrollPosition = scrollTop;
	
	        var allElements = this.state.allElements ? this.state.allElements : [];
	
	        this.setState({
	            elements: this.getCurrentElements(allElements, this.state.currentPage + 1),
	            currentPage: this.state.currentPage + 1
	        });
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state && this.state.elements != nextState.elements || this.props.accordionWidth != newProps.accordionWidth || this.props.isVideo != newProps.isVideo || this.shouldRefreshDataProvider(this.props.dataProvider, newProps.dataProvider) || this.props.height != newProps.height) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.elements == undefined) return _react2.default.createElement('div', null);
	
	        var displayState = 'none';
	
	        if (this.props.dataProvider && this.props.dataProvider.length > 0) displayState = 'inline-block';
	
	        var topPosition = _Properties2.default.BROWSER_BUTTON_HEIGHT + this.props.gap;
	
	        topPosition = topPosition + _Properties2.default.TOGGLE_TRACK_HEIGHT + this.props.gap + 2;
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 5;
	        componentProperties.paddingLeft = 3;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = this.props.height - topPosition;
	        componentProperties.top = topPosition;
	        componentProperties.displayState = displayState;
	        componentProperties.elements = this.state.elements;
	
	        componentProperties.usePagination = true;
	        componentProperties.uploadNewPage = this.uploadNewPage;
	
	        return _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties });
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MediaImagesList.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MediaImagesList.js"); } } })();

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MediaSoundsList = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SoundItemRenderer = __webpack_require__(138);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaSoundsList = exports.MediaSoundsList = _react2.default.createClass({
	    displayName: 'MediaSoundsList',
	    getInitialState: function getInitialState() {
	        return {
	            elements: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var currentItem;
	        var nextItem;
	
	        if (this.props.dataProvider && this.props.dataProvider[0]) currentItem = this.props.dataProvider[0].title;
	
	        if (nextProps.dataProvider && nextProps.dataProvider[0]) nextItem = nextProps.dataProvider[0].title;
	
	        if (currentItem != nextItem || this.props.accordionWidth != nextProps.accordionWidth) this.recreateElements();
	    },
	    recreateElements: function recreateElements() {
	        setTimeout(this.refreshNewContent, 50);
	    },
	    refreshNewContent: function refreshNewContent() {
	        this.initElements();
	    },
	    initElements: function initElements() {
	        var elements = [];
	        var items = this.props.dataProvider;
	        var i = void 0;
	
	        if (items && items.length > 0) {
	            for (i = 0; i < items.length; i++) {
	                var item = items[i];
	                elements.push(_react2.default.createElement(_SoundItemRenderer.SoundItemRenderer, { accordionWidth: this.props.accordionWidth, index: i, key: 'soundsList' + item.contentItemId + '_' + Math.random(), dispatch: this.props.dispatch, value: item, isMediaSound: true }));
	            }
	        }
	
	        this.setState({
	            elements: elements
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        setTimeout(this.refreshView, 5);
	    },
	    refreshView: function refreshView() {
	        this.forceUpdate();
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.elements != nextState.elements || this.props.accordionWidth != newProps.accordionWidth || this.props.dataProvider != newProps.dataProvider || this.props.height != newProps.height) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.elements == undefined || this.props.dataProvider == undefined) return _react2.default.createElement('div', null);
	
	        var displayState = 'none';
	
	        if (this.props.dataProvider && this.props.dataProvider.length > 0) displayState = 'inline-block';
	
	        var topPosition;
	        var clipartButtonHeight = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        var buttonHeight = _Properties2.default.STYLING_BUTTON_HEIGHT;
	        var topExtraPadding = 5;
	        var bottomExtraPadding = _Properties2.default.MY_MEDIA_FILES_GAP;
	
	        if (this.props.categoriesVisible) topPosition = clipartButtonHeight + buttonHeight + _Properties2.default.MY_MEDIA_FILES_GAP + _Properties2.default.EFFECTS_BUTTON_HEIGHT + _Properties2.default.MY_MEDIA_FILES_GAP + topExtraPadding;else topPosition = clipartButtonHeight + buttonHeight + _Properties2.default.MY_MEDIA_FILES_GAP + topExtraPadding;
	
	        if (this.props.isAudioTab) {
	            topExtraPadding = 0;
	            bottomExtraPadding = 0;
	            buttonHeight = _Properties2.default.BROWSER_BUTTON_HEIGHT;
	
	            if (this.props.categoriesVisible) topPosition = buttonHeight + _Properties2.default.CATEGORY_SELECTOR_HEIGHT;else topPosition = buttonHeight + _Properties2.default.MY_MEDIA_FILES_GAP + topExtraPadding;
	        }
	
	        if (this.props.showUploadButton) topPosition = topPosition + 50;
	
	        var listStyle = {
	            width: this.props.accordionWidth,
	            height: this.props.height - topPosition - bottomExtraPadding,
	            backgroundColor: 'white',
	            position: 'absolute',
	            top: topPosition,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            display: displayState
	        };
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = this.props.height - topPosition - _Properties2.default.MY_MEDIA_FILES_GAP;
	        componentProperties.top = 0;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = this.state.elements;
	        componentProperties.scrollHeight = (_Properties2.default.SOUND_ITEM_HEIGHT + _Properties2.default.SOUND_ITEMS_GAP) * this.state.elements.length;
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'listWrapper', style: listStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MediaSoundsList.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MediaSoundsList.js"); } } })();

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MindMapMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MindMapUtils = __webpack_require__(85);
	
	var _MindMapUtils2 = _interopRequireDefault(_MindMapUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	        _MindMapUtils2.default.reset();
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        var caption = _LocalesManager2.default.getCaption('MindMapMenuTitle', 'other');
	        var closeButtonStyle = {
	            position: 'absolute',
	            right: 28,
	            top: 4,
	            width: 22,
	            height: 22,
	            cursor: 'pointer',
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            background: 'none',
	            borderStyle: 'none',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 3,
	            right: 3,
	            cursor: 'pointer'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                caption
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'firstFocusableObjectMindMapMenu', style: closeButtonStyle, 'aria-label': _LocalesManager2.default.getCaption('close', 'other'), onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.insertNode();
	    },
	    onClick: function onClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.insertNode();
	    },
	    insertNode: function insertNode() {
	        if (this.props.index === 0) _MindMapUtils2.default.insertTextNode();else _MindMapUtils2.default.openSearch();
	    },
	    render: function render() {
	        var width = _Properties2.default.MOOD_ITEM_SIZE;
	        var textHeight = 20;
	        var height = width * 3 / 4 + textHeight;
	
	        var buttonStyle = {
	            position: 'absolute',
	            top: this.props.index * height + (this.props.index + 1) * _Properties2.default.MOOD_ITEM_GAP,
	            left: (this.props.accordionWidth - _Properties2.default.MOOD_ITEM_SIZE) / 2,
	            width: width,
	            height: height,
	            background: '#f3f3f3',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none',
	            cursor: 'pointer'
	        };
	
	        var borderColor = void 0;
	        var iconColor = 'black';
	
	        if (this.state.isOver == true) {
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            iconColor = borderColor;
	        } else borderColor = _Properties2.default.SLIDE_VIEWER_BACKGROUND;
	
	        var borderWidth = 2;
	
	        var frameStyle = {
	            width: width - 2 * borderWidth,
	            height: height - 2 * borderWidth,
	            borderWidth: borderWidth,
	            borderStyle: 'solid',
	            borderColor: borderColor,
	            position: 'absolute',
	            top: 0,
	            cursor: 'pointer'
	        };
	
	        var textPadding = 3;
	
	        var titleStyle = {
	            fontSize: 16,
	            height: textHeight,
	            width: width - 2 * textPadding,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            textAlign: 'center',
	            position: 'absolute',
	            left: textPadding,
	            top: 10,
	            cursor: 'pointer',
	            color: iconColor
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 30,
	            left: 32,
	            color: iconColor,
	            fontSize: 100
	        };
	
	        var idValue = void 0;
	        var text = void 0;
	        var icon = 'fa fa-picture-o';
	
	        if (this.props.index === 1) {
	            idValue = 'mindMapLastItem';
	            text = _LocalesManager2.default.getCaption('MindMapSetImageNode', 'other');
	        } else {
	            text = _LocalesManager2.default.getCaption('MindMapSetTextNode', 'other');
	            icon = 'fa fa-commenting-o';
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, 'aria-label': text, style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp, onClick: this.onClick },
	            _react2.default.createElement(
	                'span',
	                { style: titleStyle },
	                text
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: icon }),
	            _react2.default.createElement('div', { style: frameStyle })
	        );
	    }
	});
	
	var MindMapMenu = exports.MindMapMenu = _react2.default.createClass({
	    displayName: 'MindMapMenu',
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('firstFocusableObjectMindMapMenu');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps) {
	        if (this.props.accordionWidth != newProps.accordionWidth || this.props.type != newProps.type || this.props.contextTarget != newProps.contextTarget || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight) return true;else return false;
	    },
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var shapeModel = this.props.contextTarget;
	        var elements = [];
	        var componentProperties = {};
	
	        elements.push(_react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 0, key: 'element1', shapeModel: shapeModel, dispatch: this.props.dispatch }));
	        elements.push(_react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 1, key: 'element2', shapeModel: shapeModel, dispatch: this.props.dispatch }));
	
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT - 10;
	        componentProperties.top = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = elements;
	        componentProperties.scrollHeight = 2 * 154 + 20;
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'mindMapMenu', style: menuStyle },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth, type: this.props.type }),
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MindMapMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MindMapMenu.js"); } } })();

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MoodsMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MenuActions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        var caption;
	
	        if (this.props.type == 'background') caption = _LocalesManager2.default.getCaption('Mode', 'shapeMenu');else caption = _LocalesManager2.default.getCaption('Moods', 'shapeMenu');
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            right: 28,
	            top: 4,
	            width: 22,
	            height: 22,
	            cursor: 'pointer',
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            background: 'none',
	            borderStyle: 'none',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 3,
	            right: 3,
	            cursor: 'pointer'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                caption
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'firstFocusableObject', style: closeButtonStyle, 'aria-label': _LocalesManager2.default.getCaption('close', 'other'), onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.changeMood();
	    },
	    onClick: function onClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.changeMood();
	    },
	    changeMood: function changeMood() {
	        var shapeModel = this.getCurrentTarget();
	
	        if (!shapeModel) return;
	
	        _SaveManager2.default.isContentChanged(true);
	
	        if (this.props.value != shapeModel.frameLabel) {
	            this.props.dispatch((0, _CurrentSlideActions.changeMood)(this.props.shapeModel.uuid, this.props.value));
	            _AudioEditorUtils2.default.addActionToHistory();
	            this.updateThumbnail();
	
	            // hack for refreshing characters on IOS after changing mood
	            if (_PlatformDetection2.default.isIOS() == true) this.refreshShape();
	        }
	    },
	    refreshShape: function refreshShape() {
	        _SaveManager2.default.isContentChanged(true);
	        var shapeModel = this.getCurrentTarget();
	        this.props.dispatch((0, _CurrentSlideActions.updateShapePosition)(this.props.shapeModel.uuid, shapeModel.x + 1, shapeModel.y));
	        setTimeout(this.revertPosition, 10);
	    },
	    revertPosition: function revertPosition() {
	        var shapeModel = this.getCurrentTarget();
	
	        _SaveManager2.default.isContentChanged(true);
	
	        if (shapeModel) this.props.dispatch((0, _CurrentSlideActions.updateShapePosition)(this.props.shapeModel.uuid, shapeModel.x - 1, shapeModel.y));
	    },
	    updateThumbnail: function updateThumbnail() {
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    getCurrentTarget: function getCurrentTarget() {
	        var state = _StoreManager2.default.getState();
	        var uuid = this.props.shapeModel.uuid;
	        var shapes = state.currentSlide.model.content;
	        var i;
	        var target;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == uuid) {
	                target = shapes[i];
	                break;
	            }
	        }
	
	        return target;
	    },
	    getSrc: function getSrc() {
	        return _AppParameters2.default.SVG_URL() + (this.props.shapeModel.logicalName + '_' + this.props.value + '.svg');
	    },
	    render: function render() {
	        var width = _Properties2.default.MOOD_ITEM_SIZE;
	        var textHeight = 20;
	        var height = width * 3 / 4 + textHeight;
	
	        var buttonStyle = {
	            position: 'absolute',
	            top: this.props.index * height + (this.props.index + 1) * _Properties2.default.MOOD_ITEM_GAP,
	            left: (this.props.accordionWidth - _Properties2.default.MOOD_ITEM_SIZE) / 2,
	            width: width,
	            height: height,
	            background: '#f3f3f3',
	            cursor: 'default',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        var topOffset = this.props.shapeModel && this.props.shapeModel.type == 'Background' ? 0 : 10;
	        var imageStyle = {
	            width: _Properties2.default.MOOD_ITEM_SIZE,
	            height: _Properties2.default.MOOD_ITEM_SIZE * 3 / 4 - 2 * topOffset,
	            top: topOffset,
	            left: 0,
	            position: 'absolute'
	        };
	
	        var borderColor;
	
	        if (this.state.isOver == true) borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else borderColor = _Properties2.default.SLIDE_VIEWER_BACKGROUND;
	
	        var borderWidth = 2;
	
	        var frameStyle = {
	            width: width - 2 * borderWidth,
	            height: height - 2 * borderWidth,
	            borderWidth: borderWidth,
	            borderStyle: 'solid',
	            borderColor: borderColor,
	            position: 'absolute',
	            top: 0,
	            cursor: 'default'
	        };
	
	        var textPadding = 3;
	
	        var titleStyle = {
	            fontSize: 15,
	            height: textHeight,
	            width: width - 2 * textPadding,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            textAlign: 'center',
	            position: 'absolute',
	            left: textPadding,
	            bottom: 0
	        };
	
	        var checkVisibility;
	        var shapeModel = this.getCurrentTarget();
	
	        if (shapeModel && this.props.value == shapeModel.frameLabel) checkVisibility = 'block';else checkVisibility = 'none';
	
	        var selectionStyle = {
	            position: 'absolute',
	            top: 5,
	            right: 8,
	            color: 'black',
	            display: checkVisibility
	        };
	
	        var moodTranslation = _LocalesManager2.default.getMoodsCaption(this.props.value);
	
	        var idValue;
	
	        if (this.props.index == this.props.lastItem) idValue = 'moodsLastItem';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, 'aria-label': moodTranslation, style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp, onClick: this.onClick },
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: imageStyle, src: this.getSrc() }),
	            _react2.default.createElement('i', { style: selectionStyle, className: 'fa fa-check' }),
	            _react2.default.createElement(
	                'span',
	                { style: titleStyle },
	                moodTranslation
	            ),
	            _react2.default.createElement('div', { style: frameStyle })
	        );
	    }
	});
	
	var MoodsMenu = exports.MoodsMenu = _react2.default.createClass({
	    displayName: 'MoodsMenu',
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('firstFocusableObject');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    getShapeModel: function getShapeModel() {
	        var state = _StoreManager2.default.getState();
	        var shapeModel;
	
	        if (this.props.type == 'background') shapeModel = state.currentSlide.model.content[0];else shapeModel = this.props.contextTarget;
	
	        return shapeModel;
	    },
	    getMoods: function getMoods() {
	        var shapeModel = this.getShapeModel();
	
	        if (shapeModel.moods) return shapeModel.moods;else return [];
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        setTimeout(this.refreshView, 10);
	    },
	    refreshView: function refreshView() {
	        this.forceUpdate();
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.accordionWidth != newProps.accordionWidth || this.props.type != newProps.type || this.props.contextTarget != newProps.contextTarget || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight) return true;else return false;
	    },
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var elements = [];
	        var moods = this.getMoods();
	        var shapeModel = this.getShapeModel();
	        var i;
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT - 10;
	        componentProperties.top = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        componentProperties.displayState = 'block';
	
	        for (i = 0; i < moods.length; i++) {
	            elements.push(_react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: i, key: 'moods' + moods[i], value: moods[i], lastItem: moods.length - 1, shapeModel: shapeModel, dispatch: this.props.dispatch }));
	        }
	
	        componentProperties.elements = elements;
	        componentProperties.scrollHeight = elements.length * 154 + 20;
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'moodsMenu', style: menuStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth, type: this.props.type }),
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MoodsMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/MoodsMenu.js"); } } })();

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ObjectContextAdvanced = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _EffectsMenu = __webpack_require__(787);
	
	var _CustomSlider = __webpack_require__(170);
	
	var _MenuActions = __webpack_require__(7);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            position: 'absolute',
	            top: 6,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            width: 21,
	            height: 21,
	            top: 4,
	            right: 27,
	            cursor: 'pointer',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 3,
	            left: 3
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                _LocalesManager2.default.getCaption('AdvancedMenuTitle', 'advancedMenu')
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'firstFocusableObjectFromMoreMenu', 'aria-label': _LocalesManager2.default.getCaption('close', 'other'), style: closeButtonStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    updateThumbnail: function updateThumbnail() {
	        setTimeout(this.updateThumb, 10);
	    },
	    updateThumb: function updateThumb() {
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // lock button
	                    this.props.dispatch((0, _CurrentSlideActions.lockShape)(this.props.contextTarget));
	                    this.forceUpdate();
	                    this.updateThumbnail();
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	
	            case 1:
	                {
	                    // bring to front
	                    if (this.isCommandAvailable(1)) {
	                        this.props.dispatch((0, _CurrentSlideActions.bringToFront)(this.props.contextTarget));
	                        this.updateThumbnail();
	                        _SaveManager2.default.isContentChanged(true);
	                    }
	                    break;
	                }
	
	            case 2:
	                {
	                    // send to back
	                    if (this.isCommandAvailable(2)) {
	                        this.props.dispatch((0, _CurrentSlideActions.sendToBack)(this.props.contextTarget));
	                        this.updateThumbnail();
	                        _SaveManager2.default.isContentChanged(true);
	                    }
	                    break;
	                }
	
	            case 3:
	                {
	                    // bring forward
	                    if (this.isCommandAvailable(3)) {
	                        this.props.dispatch((0, _CurrentSlideActions.bringForward)(this.props.contextTarget));
	                        this.updateThumbnail();
	                        _SaveManager2.default.isContentChanged(true);
	                    }
	                    break;
	                }
	
	            case 4:
	                {
	                    // send backward
	                    if (this.isCommandAvailable(4)) {
	                        this.props.dispatch((0, _CurrentSlideActions.sendBackward)(this.props.contextTarget));
	                        this.updateThumbnail();
	                        _SaveManager2.default.isContentChanged(true);
	                    }
	                    break;
	                }
	        }
	
	        _AudioEditorUtils2.default.addActionToHistory();
	    },
	    isCommandAvailable: function isCommandAvailable(index) {
	        var state = _StoreManager2.default.getState();
	        var uuid = this.props.contextTarget.uuid;
	        var shapes = state.currentSlide.model.content;
	        var i;
	        var targetPosition;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == uuid) {
	                targetPosition = i;
	                break;
	            }
	        }
	
	        switch (index) {
	            case 1: // bring to front
	            case 3:
	                // bring forward
	                {
	                    if (targetPosition < shapes.length - 1) return true;
	                    break;
	                }
	
	            case 2: // send to back
	            case 4:
	                // send backward
	                {
	                    if (targetPosition > 1) return true;
	                    break;
	                }
	        }
	
	        return false;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.contextTarget != newProps.contextTarget || this.props.isLocked != newProps.isLocked) return true;else return false;
	    },
	    render: function render() {
	        var iconColor;
	        var buttonColor;
	
	        if (this.state.isOver == true) {
	            iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	            buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	        } else {
	            iconColor = 'black';
	            buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	        }
	
	        var topPosition = this.props.index * _Properties2.default.OBJECT_ADVANCED_BUTTON_HEIGHT;
	
	        if (this.props.index == 7) {
	            topPosition = 6 * _Properties2.default.OBJECT_ADVANCED_BUTTON_HEIGHT + _Properties2.default.OBJECT_ADVANCED_MIDDLE_GAP;
	            iconColor = 'black';
	            buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	        }
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth - _Properties2.default.BROWSER_LEFT_PADDING,
	            height: _Properties2.default.OBJECT_ADVANCED_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: _Properties2.default.BROWSER_LEFT_PADDING,
	            top: topPosition,
	            color: 'white',
	            margin: 0,
	            paddingRight: 0,
	            paddingTop: 0,
	            paddingBottom: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            fontSize: 16,
	            paddingLeft: 22,
	            top: 0
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 16,
	            color: iconColor
	        };
	
	        var icon = this.props.icon;
	        var text = this.props.text;
	
	        if (this.props.index == 0 && this.props.isLocked == true) {
	            text = _LocalesManager2.default.getCaption('UnlockObject', 'advancedMenu');
	            icon = 'fa fa-unlock';
	        }
	
	        var tabIndexValue;
	
	        if (this.props.isLocked && this.props.index != 0) tabIndexValue = '-1';
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': text, tabIndex: tabIndexValue, 'aria-disabled': tabIndexValue == '-1' ? true : false, style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement('i', { style: iconStyle, className: icon }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            )
	        );
	    }
	});
	
	var InactiveArea = _react2.default.createClass({
	    displayName: 'InactiveArea',
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.accordionWidth != newProps.accordionWidth || this.props.windowHeight != newProps.windowHeight) return true;else return false;
	    },
	    render: function render() {
	        var top = _Properties2.default.OBJECT_ADVANCED_BUTTON_HEIGHT;
	
	        var inactiveAreaStyle = {
	            position: 'absolute',
	            top: top,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight - top,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white',
	            opacity: 0.5
	        };
	
	        return _react2.default.createElement('div', { style: inactiveAreaStyle });
	    }
	});
	
	var ObjectContextAdvanced = exports.ObjectContextAdvanced = _react2.default.createClass({
	    displayName: 'ObjectContextAdvanced',
	    componentDidMount: function componentDidMount() {
	        this.refs.contextAdvancedWrapper.addEventListener('click', this.onClick);
	        this.refs.contextAdvancedWrapper.addEventListener('touchend', this.onClick);
	
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('firstFocusableObjectFromMoreMenu');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    isLocked: function isLocked() {
	        var state = _StoreManager2.default.getState();
	        var uuid = this.props.contextTarget.uuid;
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == uuid) return shapes[i].isLocked;
	        }
	
	        return false;
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var target = e.target;
	        if (target.id != 'effectsMenu' && target.parentNode.id != 'effectsMenu' && target.parentNode.parentNode.id != 'effectsMenu' && target.parentNode.parentNode.parentNode.id != 'effectsMenu') this.props.dispatch((0, _MenuActions.expandEffectsList)(false));
	
	        setTimeout(this.refreshView, 5);
	    },
	    refreshView: function refreshView() {
	        this.forceUpdate();
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.contextTarget != newProps.contextTarget || this.props.contextMode != newProps.contextMode || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        if (this.props.contextMode != _ModeConstants2.default.OBJECT_CONTEXT_ADVANCED) return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white',
	            cursor: 'default'
	        };
	
	        var topPosition = 5 * _Properties2.default.OBJECT_ADVANCED_BUTTON_HEIGHT + _Properties2.default.OBJECT_ADVANCED_MIDDLE_GAP / 2;
	
	        var topLineStyle = {
	            position: 'absolute',
	            backgroundColor: '#E1E1E1',
	            height: 1,
	            width: _Properties2.default.BROWSER_WIDTH - 2 * _Properties2.default.BROWSER_LEFT_PADDING,
	            marginLeft: _Properties2.default.BROWSER_LEFT_PADDING,
	            top: topPosition
	        };
	
	        var isLocked = this.isLocked();
	        var elements = [];
	
	        topPosition = topPosition + _Properties2.default.OBJECT_ADVANCED_MIDDLE_GAP;
	
	        var spanOpacityStyle = {
	            position: 'absolute',
	            left: _Properties2.default.BROWSER_LEFT_PADDING,
	            top: topPosition,
	            cursor: 'default'
	        };
	
	        topPosition = topPosition + _Properties2.default.OBJECT_ADVANCED_MIDDLE_GAP + 5;
	
	        var opacityProperties = {};
	        opacityProperties.topPosition = topPosition;
	        opacityProperties.leftPosition = _Properties2.default.BROWSER_LEFT_PADDING;
	        opacityProperties.width = _Properties2.default.BROWSER_WIDTH - 2 * _Properties2.default.BROWSER_LEFT_PADDING;
	        opacityProperties.height = _Properties2.default.STYLING_SLIDER_HEIGHT;
	        opacityProperties.backgroundHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/opacitySlider.png';
	        opacityProperties.thumbHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
	        opacityProperties.thumbSize = _Properties2.default.STYLING_THUMB_SIZE;
	        opacityProperties.start = 1;
	        opacityProperties.end = 0;
	        opacityProperties.step = 0.1;
	        opacityProperties.target = this.props.contextTarget;
	        opacityProperties.dispatch = this.props.dispatch;
	        opacityProperties.type = 'change_opacity';
	
	        topPosition = topPosition + _Properties2.default.STYLING_SLIDER_HEIGHT + _Properties2.default.OBJECT_ADVANCED_MIDDLE_GAP;
	
	        var bottomLineStyle = {
	            position: 'absolute',
	            backgroundColor: '#E1E1E1',
	            height: 1,
	            width: _Properties2.default.BROWSER_WIDTH - 2 * _Properties2.default.BROWSER_LEFT_PADDING,
	            marginLeft: _Properties2.default.BROWSER_LEFT_PADDING,
	            top: topPosition
	        };
	
	        topPosition = topPosition + _Properties2.default.OBJECT_ADVANCED_MIDDLE_GAP;
	
	        elements.push(_react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, isLocked: isLocked, index: 0, icon: 'fa fa-lock', text: _LocalesManager2.default.getCaption('LockObject', 'advancedMenu'), key: 'context0' }));
	        elements.push(_react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, isLocked: isLocked, index: 1, icon: 'fa fa-arrow-circle-up', text: _LocalesManager2.default.getCaption('BringToFront', 'advancedMenu'), key: 'context1' }));
	        elements.push(_react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, isLocked: isLocked, index: 2, icon: 'fa fa-arrow-circle-down', text: _LocalesManager2.default.getCaption('SendToBack', 'advancedMenu'), key: 'context2' }));
	        elements.push(_react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, isLocked: isLocked, index: 3, icon: 'fa fa-arrow-circle-o-up', text: _LocalesManager2.default.getCaption('BringForward', 'advancedMenu'), key: 'context3' }));
	        elements.push(_react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, isLocked: isLocked, index: 4, icon: 'fa fa-arrow-circle-o-down', text: _LocalesManager2.default.getCaption('SendBackward', 'advancedMenu'), key: 'context4' }));
	        elements.push(_react2.default.createElement('div', { style: topLineStyle, key: 'context5' }));
	        elements.push(_react2.default.createElement(
	            'span',
	            { key: 'context6', style: spanOpacityStyle },
	            _LocalesManager2.default.getCaption('Opacity', 'advancedMenu')
	        ));
	        elements.push(_react2.default.createElement(_CustomSlider.CustomSlider, { key: 'context7', properties: opacityProperties }));
	        elements.push(_react2.default.createElement('div', { key: 'context8', style: bottomLineStyle }));
	        elements.push(_react2.default.createElement(_EffectsMenu.EffectsMenu, { id: 'objectContextLastFocusableElement', accordionWidth: _Properties2.default.BROWSER_WIDTH, key: 'context9', dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, top: topPosition }));
	
	        if (isLocked == true) elements.push(_react2.default.createElement(InactiveArea, { accordionWidth: this.props.accordionWidth, windowHeight: this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT, key: 'context11' }));
	
	        var height = topPosition + 50;
	
	        var leftPosition = 0;
	
	        if (this.props.accordionWidth > _Properties2.default.BROWSER_WIDTH) leftPosition = (this.props.accordionWidth - _Properties2.default.BROWSER_WIDTH) / 2;
	
	        var holderStyle = {
	            position: 'absolute',
	            top: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            left: leftPosition,
	            height: this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            width: this.props.accordionWidth,
	            overflowY: 'auto',
	            overflowX: 'hidden',
	            cursor: 'default'
	        };
	
	        var elementsWrapperStyle = {
	            position: 'absolute',
	            top: 0,
	            height: height,
	            width: _Properties2.default.BROWSER_WIDTH,
	            cursor: 'default'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { ref: 'contextAdvancedWrapper', style: menuStyle, id: 'objectContextMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(
	                'div',
	                { style: holderStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: elementsWrapperStyle },
	                    elements
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ObjectContextAdvanced.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ObjectContextAdvanced.js"); } } })();

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PositionView = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SizeAndPositionButtons = __webpack_require__(92);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _reactRedux = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PositionViewContent = _react2.default.createClass({
	    displayName: 'PositionViewContent',
	    getInitialState: function getInitialState() {
	        var shapeModel = this.getContextTarget();
	
	        if (shapeModel.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE) {
	            return {
	                x: shapeModel.x,
	                y: shapeModel.y,
	                type: shapeModel.type,
	                cx: shapeModel.cx,
	                cy: shapeModel.cy,
	                cx1: shapeModel.cx1,
	                cy1: shapeModel.cy1,
	                cx2: shapeModel.cx2,
	                cy2: shapeModel.cy2,
	                cx3: shapeModel.cx3,
	                cy3: shapeModel.cy3,
	                cx4: shapeModel.cx4,
	                cy4: shapeModel.cy4,
	                cx5: shapeModel.cx5,
	                cy5: shapeModel.cy5
	            };
	        } else {
	            return {
	                x: shapeModel.x,
	                y: shapeModel.y,
	                type: shapeModel.type,
	                cx: shapeModel.cx,
	                cy: shapeModel.cy
	            };
	        }
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.refreshShapePosition != nextProps.refreshShapePosition) {
	            var contextTarget = this.getContextTarget();
	
	            if (this.state.type === _ShapeConstants2.default.SPEAK_BUBBLE || this.state.type === _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || this.state.type === _ShapeConstants2.default.THOUGHT_BUBBLE || this.state.type === _ShapeConstants2.default.SCREAM_BUBBLE) {
	                if (this.state.type === _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE) this.setState({ x: contextTarget.x, y: contextTarget.y, cx: contextTarget.cx, cy: contextTarget.cy, cx1: contextTarget.cx1, cy1: contextTarget.cy1, cx2: contextTarget.cx2, cy2: contextTarget.cy2, cx3: contextTarget.cx3, cy3: contextTarget.cy3, cx4: contextTarget.cx4, cy4: contextTarget.cy4, cx5: contextTarget.cx5, cy5: contextTarget.cy5 });else this.setState({ x: contextTarget.x, y: contextTarget.y, cx: contextTarget.cx, cy: contextTarget.cy });
	            } else this.setState({ x: contextTarget.x, y: contextTarget.y });
	        }
	    },
	    getContextTarget: function getContextTarget() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	
	        for (var i = 1; i < shapes.length; i++) {
	            if (shapes[i].uuid === this.props.shapeModel.uuid) return shapes[i];
	        }
	
	        return this.props.shapeModel;
	    },
	    changePosition: function changePosition(x, y) {
	        var newX = parseInt(x) || 0;
	        var newY = parseInt(y) || 0;
	
	        var shapeModel = this.props.shapeModel;
	        this.setState({ x: newX, y: newY });
	
	        this.props.dispatch((0, _CurrentSlideActions.updateShapePosition)(shapeModel.uuid, newX, newY));
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    changeBubbleControlPoint: function changeBubbleControlPoint(cx, cy, property) {
	        var newX = parseInt(cx) || 0;
	        var newY = parseInt(cy) || 0;
	
	        var shapeModel = this.props.shapeModel;
	
	        switch (property) {
	            case 'controlPoint':
	                {
	                    this.setState({ cx: newX, cy: newY });
	                    break;
	                }
	            case 'controlPoint1':
	                {
	                    this.setState({ cx1: newX, cy1: newY });
	                    break;
	                }
	            case 'controlPoint2':
	                {
	                    this.setState({ cx2: newX, cy2: newY });
	                    break;
	                }
	            case 'controlPoint3':
	                {
	                    this.setState({ cx3: newX, cy3: newY });
	                    break;
	                }
	            case 'controlPoint4':
	                {
	                    this.setState({ cx4: newX, cy4: newY });
	                    break;
	                }
	            case 'controlPoint5':
	                {
	                    this.setState({ cx5: newX, cy5: newY });
	                    break;
	                }
	        }
	
	        this.props.dispatch((0, _CurrentSlideActions.updateBubbleControlPoint)(shapeModel.uuid, newX, newY, property));
	
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    render: function render() {
	        var smallTextStyle = {
	            fontSize: '12px',
	            marginTop: '15px',
	            marginBottom: '-5px'
	        };
	
	        var buttonWrapperStyle = {
	            display: 'flex',
	            flexWrap: 'wrap',
	            marginTop: '10px',
	            justifyContent: 'space-between'
	        };
	
	        var idValue1;
	        var idValue2;
	
	        if (this.state.type === _ShapeConstants2.default.SPEAK_BUBBLE || this.state.type === _ShapeConstants2.default.THOUGHT_BUBBLE || this.state.type === _ShapeConstants2.default.SCREAM_BUBBLE) {
	            idValue2 = "resizeLastItem";
	        } else if (this.state.type != _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE) idValue1 = "resizeLastItem";
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { style: smallTextStyle },
	                _LocalesManager2.default.getCaption('Position', 'sizePosMenu')
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: buttonWrapperStyle },
	                _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Xposition', 'sizePosMenu'), value: this.state.x, yValue: this.state.y, onChangeHandler: this.changePosition }),
	                _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { id: idValue1, isInt: true, labelText: _LocalesManager2.default.getCaption('Yposition', 'sizePosMenu'), value: this.state.y, xValue: this.state.x, onChangeHandler: this.changePosition })
	            ),
	            this.state.type === _ShapeConstants2.default.SPEAK_BUBBLE || this.state.type === _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || this.state.type === _ShapeConstants2.default.THOUGHT_BUBBLE || this.state.type === _ShapeConstants2.default.SCREAM_BUBBLE ? _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    { style: smallTextStyle },
	                    _LocalesManager2.default.getCaption('ControlPoint', 'sizePosMenu')
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: buttonWrapperStyle },
	                    _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Xposition', 'sizePosMenu'), value: this.state.cx, yValue: this.state.cy, property: 'controlPoint', onChangeHandler: this.changeBubbleControlPoint }),
	                    _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { id: idValue2, isInt: true, labelText: _LocalesManager2.default.getCaption('Yposition', 'sizePosMenu'), value: this.state.cy, xValue: this.state.cx, property: 'controlPoint', onChangeHandler: this.changeBubbleControlPoint })
	                ),
	                this.state.type === _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE ? _react2.default.createElement(
	                    'div',
	                    null,
	                    this.props.shapeModel.cx1 ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { style: smallTextStyle },
	                            _LocalesManager2.default.getCaption('ControlPoint', 'sizePosMenu') + ' 2'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: buttonWrapperStyle },
	                            _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Xposition', 'sizePosMenu'), value: this.state.cx1, yValue: this.state.cy1, property: 'controlPoint1', onChangeHandler: this.changeBubbleControlPoint }),
	                            _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { id: !this.props.shapeModel.cx2 ? 'resizeLastItem' : undefined, isInt: true, labelText: _LocalesManager2.default.getCaption('Yposition', 'sizePosMenu'), value: this.state.cy1, xValue: this.state.cx1, property: 'controlPoint1', onChangeHandler: this.changeBubbleControlPoint })
	                        )
	                    ) : null,
	                    this.props.shapeModel.cx2 ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { style: smallTextStyle },
	                            _LocalesManager2.default.getCaption('ControlPoint', 'sizePosMenu') + ' 3'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: buttonWrapperStyle },
	                            _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Xposition', 'sizePosMenu'), value: this.state.cx2, yValue: this.state.cy2, property: 'controlPoint2', onChangeHandler: this.changeBubbleControlPoint }),
	                            _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { id: !this.props.shapeModel.cx3 ? 'resizeLastItem' : undefined, isInt: true, labelText: _LocalesManager2.default.getCaption('Yposition', 'sizePosMenu'), value: this.state.cy2, xValue: this.state.cx2, property: 'controlPoint2', onChangeHandler: this.changeBubbleControlPoint })
	                        )
	                    ) : null,
	                    this.props.shapeModel.cx3 ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { style: smallTextStyle },
	                            _LocalesManager2.default.getCaption('ControlPoint', 'sizePosMenu') + ' 4'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: buttonWrapperStyle },
	                            _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Xposition', 'sizePosMenu'), value: this.state.cx3, yValue: this.state.cy3, property: 'controlPoint3', onChangeHandler: this.changeBubbleControlPoint }),
	                            _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { id: !this.props.shapeModel.cx4 ? 'resizeLastItem' : undefined, isInt: true, labelText: _LocalesManager2.default.getCaption('Yposition', 'sizePosMenu'), value: this.state.cy3, xValue: this.state.cx3, property: 'controlPoint3', onChangeHandler: this.changeBubbleControlPoint })
	                        )
	                    ) : null,
	                    this.props.shapeModel.cx4 ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { style: smallTextStyle },
	                            _LocalesManager2.default.getCaption('ControlPoint', 'sizePosMenu') + ' 5'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: buttonWrapperStyle },
	                            _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Xposition', 'sizePosMenu'), value: this.state.cx4, yValue: this.state.cy4, property: 'controlPoint4', onChangeHandler: this.changeBubbleControlPoint }),
	                            _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { id: !this.props.shapeModel.cx5 ? 'resizeLastItem' : undefined, isInt: true, labelText: _LocalesManager2.default.getCaption('Yposition', 'sizePosMenu'), value: this.state.cy4, xValue: this.state.cx4, property: 'controlPoint4', onChangeHandler: this.changeBubbleControlPoint })
	                        )
	                    ) : null,
	                    this.props.shapeModel.cx5 ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h3',
	                            { style: smallTextStyle },
	                            _LocalesManager2.default.getCaption('ControlPoint', 'sizePosMenu') + ' 6'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: buttonWrapperStyle },
	                            _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Xposition', 'sizePosMenu'), value: this.state.cx5, yValue: this.state.cy5, property: 'controlPoint5', onChangeHandler: this.changeBubbleControlPoint }),
	                            _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { id: 'resizeLastItem', isInt: true, labelText: _LocalesManager2.default.getCaption('Yposition', 'sizePosMenu'), value: this.state.cy5, xValue: this.state.cx5, property: 'controlPoint5', onChangeHandler: this.changeBubbleControlPoint })
	                        )
	                    ) : null
	                ) : null
	            ) : null
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var refreshShapePosition = state.menu.refreshShapePosition;
	
	    return {
	        refreshShapePosition: refreshShapePosition
	    };
	}
	
	var PositionView = exports.PositionView = (0, _reactRedux.connect)(mapStateToProps)(PositionViewContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/PositionView.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/PositionView.js"); } } })();

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PositionViewLineAndCurve = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SizeAndPositionButtons = __webpack_require__(92);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _reactRedux = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PositionViewLineAndCurveContent = _react2.default.createClass({
	    displayName: 'PositionViewLineAndCurveContent',
	    getInitialState: function getInitialState() {
	        var shapeModel = this.getContextTarget();
	
	        if (shapeModel.type === _ShapeConstants2.default.CURVE) {
	            return {
	                type: shapeModel.type,
	                x1: shapeModel.x1,
	                y1: shapeModel.y1,
	                x2: shapeModel.x2,
	                y2: shapeModel.y2,
	                cx: shapeModel.cx,
	                cy: shapeModel.cy
	            };
	        } else {
	            return {
	                type: shapeModel.type,
	                x1: shapeModel.x1,
	                y1: shapeModel.y1,
	                x2: shapeModel.x2,
	                y2: shapeModel.y2
	            };
	        }
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.refreshShapePosition != nextProps.refreshShapePosition) {
	            var contextTarget = this.getContextTarget();
	
	            if (this.state.type === _ShapeConstants2.default.CURVE) this.setState({ x1: contextTarget.x1, y1: contextTarget.y1, x2: contextTarget.x2, y2: contextTarget.y2, cx: contextTarget.cx, cy: contextTarget.cy });else this.setState({ x1: contextTarget.x1, y1: contextTarget.y1, x2: contextTarget.x2, y2: contextTarget.y2 });
	        }
	    },
	    getContextTarget: function getContextTarget() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	
	        for (var i = 1; i < shapes.length; i++) {
	            if (shapes[i].uuid === this.props.shapeModel.uuid) return shapes[i];
	        }
	
	        return this.props.shapeModel;
	    },
	    changePosition: function changePosition(name, value) {
	        var shapeModel = this.getContextTarget();
	
	        if (!shapeModel) return;
	
	        value = parseInt(value) || 0;
	        var isChanged = false;
	
	        switch (name) {
	            case 'x1':
	                {
	                    // x1
	                    if (shapeModel.x1 != value) {
	                        isChanged = true;
	                        this.setState({ x1: value });
	                        this.props.dispatch((0, _CurrentSlideActions.updateNonRectangularShape)(shapeModel.uuid, value, shapeModel.y1, shapeModel.x2, shapeModel.y2, shapeModel.cx, shapeModel.cy));
	                    }
	                    break;
	                }
	            case 'y1':
	                {
	                    // y1
	                    if (shapeModel.y1 != value) {
	                        isChanged = true;
	                        this.setState({ y1: value });
	                        this.props.dispatch((0, _CurrentSlideActions.updateNonRectangularShape)(shapeModel.uuid, shapeModel.x1, value, shapeModel.x2, shapeModel.y2, shapeModel.cx, shapeModel.cy));
	                    }
	                    break;
	                }
	            case 'x2':
	                {
	                    // x2
	                    if (shapeModel.x2 != value) {
	                        isChanged = true;
	                        this.setState({ x2: value });
	                        this.props.dispatch((0, _CurrentSlideActions.updateNonRectangularShape)(shapeModel.uuid, shapeModel.x1, shapeModel.y1, value, shapeModel.y2, shapeModel.cx, shapeModel.cy));
	                    }
	                    break;
	                }
	            case 'y2':
	                {
	                    // y2
	                    if (shapeModel.y2 != value) {
	                        isChanged = true;
	                        this.setState({ y2: value });
	                        this.props.dispatch((0, _CurrentSlideActions.updateNonRectangularShape)(shapeModel.uuid, shapeModel.x1, shapeModel.y1, shapeModel.x2, value, shapeModel.cx, shapeModel.cy));
	                    }
	                    break;
	                }
	            case 'cx':
	                {
	                    // cx
	                    if (shapeModel.cx != value) {
	                        isChanged = true;
	                        this.setState({ cx: value });
	                        this.props.dispatch((0, _CurrentSlideActions.updateNonRectangularShape)(shapeModel.uuid, shapeModel.x1, shapeModel.y1, shapeModel.x2, shapeModel.y2, value, shapeModel.cy));
	                    }
	                    break;
	                }
	            case 'cy':
	                {
	                    // cy
	                    if (shapeModel.cy != value) {
	                        isChanged = true;
	                        this.setState({ cy: value });
	                        this.props.dispatch((0, _CurrentSlideActions.updateNonRectangularShape)(shapeModel.uuid, shapeModel.x1, shapeModel.y1, shapeModel.x2, shapeModel.y2, shapeModel.cx, value));
	                    }
	                    break;
	                }
	        }
	
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    render: function render() {
	        var smallTextStyle = {
	            fontSize: '12px',
	            marginTop: '15px',
	            marginBottom: '-5px'
	        };
	
	        var buttonWrapperStyle = {
	            display: 'flex',
	            flexWrap: 'wrap',
	            marginTop: '10px',
	            justifyContent: 'space-between'
	        };
	
	        var idValue1;
	        var idValue2;
	
	        if (this.state.type === _ShapeConstants2.default.CURVE) {
	            idValue2 = "resizeLastItem";
	        } else idValue1 = "resizeLastItem";
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { style: smallTextStyle },
	                _LocalesManager2.default.getCaption('StartPoint', 'sizePosMenu')
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: buttonWrapperStyle },
	                _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Xposition', 'sizePosMenu'), value: this.state.x1, property: 'x1', onChangeHandler: this.changePosition }),
	                _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Yposition', 'sizePosMenu'), value: this.state.y1, property: 'y1', onChangeHandler: this.changePosition })
	            ),
	            _react2.default.createElement(
	                'h3',
	                { style: smallTextStyle },
	                _LocalesManager2.default.getCaption('EndPoint', 'sizePosMenu')
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: buttonWrapperStyle },
	                _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Xposition', 'sizePosMenu'), value: this.state.x2, property: 'x2', onChangeHandler: this.changePosition }),
	                _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { id: idValue1, isInt: true, labelText: _LocalesManager2.default.getCaption('Yposition', 'sizePosMenu'), value: this.state.y2, property: 'y2', onChangeHandler: this.changePosition })
	            ),
	            this.state.type === _ShapeConstants2.default.CURVE ? _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    { style: smallTextStyle },
	                    _LocalesManager2.default.getCaption('ControlPoint', 'sizePosMenu')
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: buttonWrapperStyle },
	                    _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Xposition', 'sizePosMenu'), value: this.state.cx, property: 'cx', onChangeHandler: this.changePosition }),
	                    _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { id: idValue2, isInt: true, labelText: _LocalesManager2.default.getCaption('Yposition', 'sizePosMenu'), value: this.state.cy, property: 'cy', onChangeHandler: this.changePosition })
	                )
	            ) : null
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var refreshShapePosition = state.menu.refreshShapePosition;
	
	    return {
	        refreshShapePosition: refreshShapePosition
	    };
	}
	
	var PositionViewLineAndCurve = exports.PositionViewLineAndCurve = (0, _reactRedux.connect)(mapStateToProps)(PositionViewLineAndCurveContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/PositionViewLineAndCurve.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/PositionViewLineAndCurve.js"); } } })();

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PreviewMenu = exports.PreviewMenuContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _reactRedux = __webpack_require__(10);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SlidesPreloader = __webpack_require__(375);
	
	var _SlidesPreloader2 = _interopRequireDefault(_SlidesPreloader);
	
	var _SlidesPreloaderNew = __webpack_require__(243);
	
	var _SlidesPreloaderNew2 = _interopRequireDefault(_SlidesPreloaderNew);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	var _FullScreenManager = __webpack_require__(141);
	
	var _FullScreenManager2 = _interopRequireDefault(_FullScreenManager);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioVolumeUtils = __webpack_require__(67);
	
	var _AudioVolumeUtils2 = _interopRequireDefault(_AudioVolumeUtils);
	
	var _VolumeSlider = __webpack_require__(123);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        if (this.props.index == 2) _PreviewCommands2.default.forceUpdateForPlayButton = this.forceUpdateForPlayButton;
	
	        return {
	            isOver: false
	        };
	    },
	    onButtonMouseIn: function onButtonMouseIn() {
	        switch (this.props.index) {
	            case 0:
	                {
	                    _HoverManager2.default.show(this.refs.holder, 'firstSlide');
	                    break;
	                }
	            case 1:
	                {
	                    _HoverManager2.default.show(this.refs.holder, 'previousSlide');
	                    break;
	                }
	            case 2:
	                {
	                    if (_PlayController2.default.isPlaying) _HoverManager2.default.show(this.refs.holder, 'previewModePauseCartoon');else _HoverManager2.default.show(this.refs.holder, 'previewModePlayCartoon');
	                    break;
	                }
	            case 3:
	                {
	                    _HoverManager2.default.show(this.refs.holder, 'nextSlide');
	                    break;
	                }
	            case 4:
	                {
	                    _HoverManager2.default.show(this.refs.holder, 'lastSlide');
	                    break;
	                }
	            case 5:
	                {
	                    if (this.props.src.indexOf('normalScreen') != -1) _HoverManager2.default.show(this.refs.holder, 'normalScreen');else if (this.props.src.indexOf('fullScreen') != -1) _HoverManager2.default.show(this.refs.holder, 'fullScreen');else _HoverManager2.default.show(this.refs.holder, 'exitPreview');
	                    break;
	                }
	            case 7:
	                {
	                    // Volume
	                    _HoverManager2.default.show(this.refs.holder, 'changeVolume');
	                    break;
	                }
	        }
	
	        this.setState({
	            isOver: true
	        });
	    },
	    getButtonAriaLabel: function getButtonAriaLabel() {
	        var text = '';
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    text = _LocalesManager2.default.getCaption('firstSlide', 'hover');
	                    break;
	                }
	            case 1:
	                {
	                    text = _LocalesManager2.default.getCaption('previousSlide', 'hover');
	                    break;
	                }
	            case 2:
	                {
	                    if (_PlayController2.default.isPlaying) text = _LocalesManager2.default.getCaption('previewModePauseCartoon', 'hover');else text = _LocalesManager2.default.getCaption('previewModePlayCartoon', 'hover');
	                    break;
	                }
	            case 3:
	                {
	                    text = _LocalesManager2.default.getCaption('nextSlide', 'hover');
	                    break;
	                }
	            case 4:
	                {
	                    text = _LocalesManager2.default.getCaption('lastSlide', 'hover');
	                    break;
	                }
	            case 5:
	                {
	                    if (this.props.src.indexOf('normalScreen') != -1) text = _LocalesManager2.default.getCaption('normalScreen', 'hover');else if (this.props.src.indexOf('fullScreen') != -1) text = _LocalesManager2.default.getCaption('fullScreen', 'hover');else text = _LocalesManager2.default.getCaption('exitPreview', 'hover');
	                    break;
	                }
	            case 7:
	                {
	                    // Volume
	                    text = _LocalesManager2.default.getCaption('changeVolume', 'hover');
	                    break;
	                }
	        }
	
	        return text;
	    },
	    onButtonMouseOut: function onButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.index == 7) {
	            if (this.props.handleVolume) this.props.handleVolume();
	        } else {
	            _PreviewCommands2.default.executeCommand(this.props.index, this.props.volume);
	
	            if (this.props.index == 2) {
	                // Update icon for pause/play button
	                this.props.refreshView();
	            }
	        }
	    },
	    forceUpdateForPlayButton: function forceUpdateForPlayButton() {
	        this.forceUpdate();
	    },
	    getSoundIcon: function getSoundIcon() {
	        var state = _StoreManager2.default.getState();
	        var soundVolume = state.production.storySoundVolume;
	
	        if (soundVolume == undefined) soundVolume = 0.5;
	
	        var volumeIcon = 'fa fa-volume-down fa-2x';
	
	        if (soundVolume == 0) volumeIcon = 'fa fa-volume-off fa-2x';else if (soundVolume <= 0.5) volumeIcon = 'fa fa-volume-down fa-2x';else if (soundVolume > 0.5) volumeIcon = 'fa fa-volume-up fa-2x';
	
	        return volumeIcon;
	    },
	    render: function render() {
	        var leftPosition;
	        var middle = this.props.menuWidth / 2;
	        var isMobileValue = window.outerWidth < 450 && window.outerWidth > 0 || window.outerHeight < 450 && window.outerHeight > 0;
	        var buttonSize = isMobileValue ? 28 : _Properties2.default.PREVIEW_HEIGHT;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    leftPosition = middle - buttonSize / 2 - _Properties2.default.PREVIEW_BUTTONS_GAP * 2 - buttonSize * 2;
	                    break;
	                }
	            case 1:
	                {
	                    leftPosition = middle - buttonSize / 2 - _Properties2.default.PREVIEW_BUTTONS_GAP - buttonSize;
	                    break;
	                }
	            case 2:
	                {
	                    leftPosition = middle - buttonSize / 2;
	                    break;
	                }
	            case 3:
	                {
	                    leftPosition = middle + buttonSize / 2 + _Properties2.default.PREVIEW_BUTTONS_GAP;
	                    break;
	                }
	            case 4:
	                {
	                    leftPosition = middle + buttonSize / 2 + _Properties2.default.PREVIEW_BUTTONS_GAP * 2 + buttonSize;
	                    break;
	                }
	            case 5:
	                {
	                    leftPosition = this.props.menuWidth - buttonSize - _Properties2.default.PREVIEW_BUTTONS_GAP;
	                    break;
	                }
	            case 7:
	                {
	                    leftPosition = this.props.menuWidth - 2 * buttonSize - 2 * _Properties2.default.PREVIEW_BUTTONS_GAP;
	                    break;
	                }
	        }
	
	        var scale = 1;
	        var offset = 0;
	
	        if (_AppParameters2.default.getMode() != _ModeConstants2.default.PLAYER) {
	            if (this.props.index == 5) // is close button
	                scale = 166 / 123;
	        } else {
	            if (_FullScreenManager2.default.isFullScreenMode() && this.props.index == 5) offset = 12;
	        }
	
	        var buttonStyle = {
	            width: buttonSize,
	            height: _Properties2.default.PREVIEW_HEIGHT,
	            position: 'absolute',
	            left: leftPosition,
	            top: 0,
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        var iconSrc = this.props.src;
	
	        if (this.props.index == 2) {
	            if (!_PreviewCommands2.default.isPlaying) {
	                iconSrc = this.props.src;
	            } else iconSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/pause';
	        }
	
	        iconSrc = iconSrc + '.png';
	
	        var iconWidth = _Properties2.default.PREVIEW_BUTTON_SIZE * scale + offset;
	        var iconHeight = _Properties2.default.PREVIEW_BUTTON_SIZE + offset;
	        var opacity = 1;
	
	        if (this.state.isOver == true) opacity = 0.4;
	
	        var iconStyle = {
	            position: 'absolute',
	            top: _Properties2.default.PREVIEW_HEIGHT / 2 - iconHeight / 2,
	            left: buttonSize / 2 - iconWidth / 2,
	            width: iconWidth,
	            height: iconHeight,
	            opacity: opacity
	        };
	
	        if (_PreviewCommands2.default.isPlaying && this.props.index != 2 && this.props.index != 5 && this.props.index != 7) {
	            iconStyle.opacity = 0.4;
	            buttonStyle.pointerEvents = 'none';
	        }
	
	        var iconElement;
	
	        if (this.props.index == 7) {
	            // volume button
	            iconStyle = {
	                position: 'absolute',
	                top: 11,
	                left: 10,
	                color: '#4b4c4c',
	                opacity: opacity
	            };
	
	            iconElement = _react2.default.createElement('i', { style: iconStyle, className: this.getSoundIcon() });
	        } else {
	            iconElement = _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: iconSrc });
	        }
	
	        var elementId = 'audioElementVolume_' + this.props.index;
	
	        if (this.props.index == 2) elementId = 'playButtonElement';
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': this.getButtonAriaLabel(), ref: 'holder', id: elementId, style: buttonStyle, onTouchStart: this.onClick, onClick: this.onClick, onMouseOver: this.onButtonMouseIn, onMouseOut: this.onButtonMouseOut },
	            iconElement
	        );
	    }
	});
	
	var PreviewMenuContent = exports.PreviewMenuContent = _react2.default.createClass({
	    displayName: 'PreviewMenuContent',
	    getInitialState: function getInitialState() {
	        setTimeout(this.initPlayer, 10);
	
	        return {
	            isMounted: false,
	            openVolumeSlider: false
	        };
	    },
	    initPlayer: function initPlayer() {
	        _PlayController2.default.updateAudioElements();
	        _PreviewCommands2.default.goToFirstSlide(true);
	    },
	    componentDidMount: function componentDidMount() {
	        this.setState({
	            isMounted: true
	        });
	
	        document.addEventListener('mousedown', this.onCloseVolumeSlider);
	        document.addEventListener('touchstart', this.onCloseVolumeSlider);
	
	        if (!_PlayController2.default.isAudioEditorAvailable()) {
	            if (!_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	                _AudioUtils2.default.initSlideSound();
	                _AudioUtils2.default.initSlideSoundEffect();
	                _AudioUtils2.default.initStorySound(this.onStorySoundEnd);
	            }
	        } else {
	            _PreviewCommands2.default.initSequence();
	        }
	
	        _PreviewCommands2.default.refreshFunction = this.refreshView;
	        _FullScreenManager2.default.refreshFunction = this.refreshView;
	        _PlayController2.default.refreshControlBar = this.refreshView;
	
	        if (_FullScreenManager2.default.isIOSMode() && _FullScreenManager2.default.isFullScreenMode()) _FullScreenManager2.default.addFullScreenEventsForIOS();
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('mousedown', this.onCloseVolumeSlider);
	        document.removeEventListener('touchstart', this.onCloseVolumeSlider);
	
	        if (!_PlayController2.default.isAudioEditorAvailable()) {
	            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	                _AudioVolumeUtils2.default.executeMediaAction('storySound', 0, false);
	                _AudioVolumeUtils2.default.executeMediaAction('slideSound', 0, false);
	                _AudioVolumeUtils2.default.executeMediaAction('slideSoundEffect', 0, false);
	            } else {
	                _AudioUtils2.default.cleanSlideSound();
	                _AudioUtils2.default.cleanSlideSoundEffect();
	                _AudioUtils2.default.cleanStorySound();
	            }
	        }
	    },
	    handleVolume: function handleVolume() {
	        this.setState({
	            openVolumeSlider: true
	        });
	    },
	    onCloseVolumeSlider: function onCloseVolumeSlider(e) {
	        var target = e.target;
	
	        var volume = 'audioElementVolume_7';
	
	        if (target == undefined || target && target.id == volume || target.parentElement && target.parentElement.id == volume) return;
	
	        if (target.id && target.id.indexOf('volumeIcon') != -1) {
	            this.setState({
	                openVolumeSlider: false
	            });
	
	            return;
	        }
	
	        if (target.id.indexOf('volumeSlider') != -1 || target.parentElement && target.parentElement.id.indexOf('volumeSlider') != -1 || target.parentElement && target.parentElement.parentElement && target.parentElement.parentElement.id.indexOf('volumeSlider') != -1) return;
	
	        this.setState({
	            openVolumeSlider: false
	        });
	    },
	    getSoundSource: function getSoundSource() {
	        var val;
	
	        if (this.props.storySound) val = this.props.storySound.href;
	
	        val = _VideoUtils2.default.checkCacheBreaker(val);
	
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.checkSound(val, 'storySound');else _AudioUtils2.default.updateHrefForStorySound(val);
	
	        return val;
	    },
	    onStorySoundEnd: function onStorySoundEnd() {
	        if (_PreviewCommands2.default.isPlaying) {
	            _PreviewCommands2.default.endStorySound();
	        }
	    },
	    refreshView: function refreshView() {
	        if (this.state.isMounted == true) this.forceUpdate();
	    },
	    preloadAssets: function preloadAssets() {
	        setTimeout(this.preload, 3);
	    },
	    preload: function preload() {
	        if (_PlayController2.default.isAudioEditorAvailable()) _SlidesPreloaderNew2.default.preloadAssets(true);else _SlidesPreloader2.default.preloadAssets(true);
	    },
	    render: function render() {
	        this.preloadAssets();
	
	        var width = _Configuration2.default.CANVAS_WIDTH * this.props.scaleProperties.scale;
	        var previewHeight = _Properties2.default.PREVIEW_HEIGHT;
	        var controlBarOpacity = 1;
	        var controlBarVisible = 1;
	
	        if (_FullScreenManager2.default.isFullScreenMode() == true) {
	            controlBarOpacity = 0.6;
	
	            if (_FullScreenManager2.default.isControlBarVisible() == false) controlBarVisible = 0;
	        }
	
	        var menuStyle = {
	            position: 'absolute',
	            width: width,
	            height: _Properties2.default.PREVIEW_HEIGHT,
	            top: this.props.windowHeight - previewHeight,
	            left: this.props.scaleProperties.topX,
	            opacity: controlBarVisible,
	            cursor: 'default',
	            userSelect: 'none',
	            userDrag: 'none'
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            backgroundColor: '#edeeef',
	            width: width,
	            opacity: controlBarOpacity,
	            height: _Properties2.default.PREVIEW_HEIGHT,
	            top: 0,
	            left: 0
	        };
	
	        var elements = [];
	        var closeSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/close';
	
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) {
	            if (_PlatformDetection2.default.isIOS()) {
	                if (_PreviewCommands2.default.isIOSFullScreen) closeSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/normalScreen';else closeSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/fullScreen';
	            } else {
	                if (_FullScreenManager2.default.isFullScreenMode()) closeSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/normalScreen';else closeSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/fullScreen';
	            }
	        }
	
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, volume: this.props.storySoundVolume, index: 0, key: 'preview0', src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/start', menuWidth: width, refreshView: this.refreshView }));
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, volume: this.props.storySoundVolume, index: 1, key: 'preview1', src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/back', menuWidth: width, refreshView: this.refreshView }));
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, volume: this.props.storySoundVolume, index: 2, key: 'preview2', src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/play', menuWidth: width, refreshView: this.refreshView }));
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, volume: this.props.storySoundVolume, index: 3, key: 'preview3', src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/next', menuWidth: width, refreshView: this.refreshView }));
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, volume: this.props.storySoundVolume, index: 4, key: 'preview4', src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/player/end', menuWidth: width, refreshView: this.refreshView }));
	
	        var fullScreenButton;
	
	        if (_AppParameters2.default.isEmbedded == true) {
	            // not include fullScreen button
	        } else {
	            fullScreenButton = _react2.default.createElement(Button, { dispatch: this.props.dispatch, volume: this.props.storySoundVolume, index: 5, key: 'preview5', src: closeSrc, menuWidth: width });
	        }
	
	        var soundsHolder;
	
	        if (!_PlayController2.default.isAudioEditorAvailable()) {
	            soundsHolder = _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('audio', { id: 'storySound', className: 'audioItem', src: this.getSoundSource(), preload: 'auto', playsInline: true }),
	                _react2.default.createElement('audio', { id: 'slideSound', className: 'audioItem', preload: 'auto', playsInline: true }),
	                _react2.default.createElement('audio', { id: 'slideSoundEffect', className: 'audioItem', preload: 'auto', playsInline: true })
	            );
	        }
	
	        var slidesElementStyle = {
	            color: 'black',
	            fontSize: 17,
	            fontWeight: 'bold',
	            cursor: 'default',
	            position: 'absolute',
	            textAlign: 'center',
	            width: 70,
	            height: 100,
	            left: 0,
	            top: 13
	        };
	
	        if (_PreviewCommands2.default.isPlayMode()) {
	            var slidesElement = _react2.default.createElement(
	                'span',
	                { style: slidesElementStyle, key: 'preview9' },
	                _PreviewCommands2.default.getSlidesText()
	            );
	            elements.push(slidesElement);
	
	            elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, volume: this.props.storySoundVolume, index: 7, key: 'preview7', menuWidth: width, handleVolume: this.handleVolume }));
	
	            var isMobileValue = window.outerWidth < 450 && window.outerWidth > 0 || window.outerHeight < 450 && window.outerHeight > 0;
	            var volumeSliderOffset = isMobileValue ? 85 : 102;
	
	            var slider = _react2.default.createElement(_VolumeSlider.VolumeSlider, { dispatch: this.props.dispatch, visible: this.state.openVolumeSlider, type: 'cartoonistUnexportedVolume', positionLeft: width - volumeSliderOffset, key: 'preview10' });
	            elements.push(slider);
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'previewMenu', style: menuStyle },
	            soundsHolder,
	            _react2.default.createElement('div', { style: backgroundStyle }),
	            _react2.default.createElement(
	                'div',
	                null,
	                elements,
	                fullScreenButton
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var storySound = state.production.storySound;
	    var storySoundVolume = state.production.storySoundVolume;
	    var windowHeight = state.production.windowHeight;
	    var currentSlideIndex = state.currentSlide.currentSlideIndex;
	
	    if (!(windowHeight > 0)) windowHeight = window.innerHeight;
	
	    return {
	        storySound: storySound,
	        storySoundVolume: storySoundVolume,
	        windowHeight: windowHeight,
	        currentSlideIndex: currentSlideIndex
	    };
	}
	
	var PreviewMenu = exports.PreviewMenu = (0, _reactRedux.connect)(mapStateToProps)(PreviewMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/PreviewMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/PreviewMenu.js"); } } })();

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PrintMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MenuActions = __webpack_require__(7);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.width,
	            height: this.props.height,
	            top: this.props.top,
	            left: this.props.left,
	            cursor: 'default',
	            userSelect: 'none',
	            userDrag: 'none',
	            WebkitUserSelect: 'none'
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 11,
	            paddingLeft: 10,
	            paddingTop: 5
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                _LocalesManager2.default.getCaption('PrintMenuTitle', 'other')
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    this.props.dispatch((0, _MenuActions.printTemplate)(0));
	                    break;
	                }
	            case 1:
	                {
	                    this.props.dispatch((0, _MenuActions.printTemplate)(1));
	                    break;
	                }
	        }
	
	        this.props.dispatch((0, _MenuActions.printMode)(true));
	
	        setTimeout(this.openPrint, 1000);
	    },
	    openPrint: function openPrint() {
	        window.print();
	    },
	    render: function render() {
	
	        var color = 'black';
	
	        if (this.state.isOver == true) color = '#2196F3';
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: 'white',
	            width: this.props.width,
	            height: this.props.height,
	            display: 'flex',
	            alignItems: 'center',
	            top: this.props.top,
	            left: this.props.left,
	            color: 'white',
	            borderStyle: 'solid',
	            borderWidth: 3,
	            borderColor: color
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: this.props.width,
	            height: this.props.height
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: this.props.src })
	        );
	    }
	});
	
	var PrintMenu = exports.PrintMenu = _react2.default.createClass({
	    displayName: 'PrintMenu',
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var buttonWidth = 140;
	        var buttonHeight = 210;
	        var gap = 25;
	        var holderWidth = 3 * gap + 2 * buttonWidth;
	        var holderHeight = 2 * gap + buttonHeight;
	
	        var buttonsHolderStyle = {
	            position: 'absolute',
	            top: this.props.windowHeight / 2 - holderHeight / 2,
	            left: this.props.windowWidth / 2 - holderWidth / 2,
	            width: holderWidth,
	            height: holderHeight,
	            backgroundColor: '#D7D7D7'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(Title, { width: holderWidth, height: 50, top: this.props.windowHeight / 2 - holderHeight / 2 - 50, left: this.props.windowWidth / 2 - holderWidth / 2 }),
	            _react2.default.createElement(
	                'div',
	                { style: buttonsHolderStyle },
	                _react2.default.createElement(Button, { index: 0, width: buttonWidth, height: buttonHeight, left: gap, top: gap, dispatch: this.props.dispatch, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/template1.png' }),
	                _react2.default.createElement(Button, { index: 1, width: buttonWidth, height: buttonHeight, left: gap * 2 + buttonWidth, top: gap, dispatch: this.props.dispatch, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/template2.png' })
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/PrintMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/PrintMenu.js"); } } })();

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RecordingMenu = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MenuActions = __webpack_require__(7);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(10);
	
	var _AudioRecorder = __webpack_require__(239);
	
	var _AudioRecorder2 = _interopRequireDefault(_AudioRecorder);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _SoundElement = __webpack_require__(821);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	var _Animator = __webpack_require__(238);
	
	var _Animator2 = _interopRequireDefault(_Animator);
	
	var _ReactNativeBridge = __webpack_require__(173);
	
	var _ReactNativeBridge2 = _interopRequireDefault(_ReactNativeBridge);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioVolumeUtils = __webpack_require__(67);
	
	var _AudioVolumeUtils2 = _interopRequireDefault(_AudioVolumeUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecordingMenuContent = _react2.default.createClass({
	    displayName: 'RecordingMenuContent',
	    getInitialState: function getInitialState() {
	        return {
	            isPlayButtonOver: false,
	            isStopButtonOver: false,
	            isRecordButtonOver: false,
	            isDurationButtonOver: false,
	            isMySoundsOver: false,
	            isExpanded: false,
	            isPlaying: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('mouseup', this.onCheckExpand);
	        document.addEventListener('touchend', this.onCheckExpand);
	
	        if (!_PlayController2.default.isAudioEditorAvailable()) {
	            if (!_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	                _AudioUtils2.default.initRecordedSound(this.updatePlayingStatus);
	                _AudioUtils2.default.initAudioEffect(this.updatePlayingStatus);
	            }
	
	            _AnimationManager2.default.pauseSoundStatus = this.pauseSoundStatus;
	        }
	
	        _VideoUtils2.default.updatePlayButtonHandler = this.updatePlayingStatusFromVideo;
	        _VideoUtils2.default.playRegular = this.doPlay;
	        _PlayController2.default.updateRecordingMenuButtons = this.updateViewProperties;
	
	        _PlayController2.default.executePlayPause = this.executePlayPause;
	        _PlayController2.default.executeStop = this.executeStop;
	        _PlayController2.default.changePlayState = this.changePlayState;
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('mouseup', this.onCheckExpand);
	        document.removeEventListener('touchend', this.onCheckExpand);
	
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	            _AudioVolumeUtils2.default.executeMediaAction('recordedAudio', 0, false);
	            _AudioVolumeUtils2.default.executeMediaAction('audioEffect', 0, false);
	        } else {
	            _AudioUtils2.default.cleanRecordingSound();
	            _AudioUtils2.default.cleanAudioEffect();
	        }
	
	        _VideoUtils2.default.updatePlayButtonHandler = undefined;
	        _VideoUtils2.default.playRegular = undefined;
	        _PlayController2.default.updateRecordingMenuButtons = undefined;
	
	        _PlayController2.default.executePlayPause = undefined;
	        _PlayController2.default.executeStop = undefined;
	        _PlayController2.default.changePlayState = undefined;
	    },
	    onMySoundsMouseIn: function onMySoundsMouseIn() {
	        _HoverManager2.default.show(this.refs.mySoundsHolder, 'MySoundsTitle');
	
	        this.setState({
	            isMySoundsOver: true
	        });
	    },
	    onMySoundsMouseOut: function onMySoundsMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isMySoundsOver: false
	        });
	    },
	    onPlayButtonMouseIn: function onPlayButtonMouseIn() {
	        if (_PlayController2.default.isAudioEditorMode()) _HoverManager2.default.show(this.refs.play, 'playCartoon');else _HoverManager2.default.show(this.refs.play, 'playSlide');
	
	        this.setState({
	            isPlayButtonOver: true
	        });
	    },
	    onPlayButtonMouseOut: function onPlayButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isPlayButtonOver: false
	        });
	    },
	    onStopButtonMouseIn: function onStopButtonMouseIn() {
	        _HoverManager2.default.show(this.refs.stop, 'stop');
	
	        this.setState({
	            isStopButtonOver: true
	        });
	    },
	    onStopButtonMouseOut: function onStopButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isStopButtonOver: false
	        });
	    },
	    onRecordButtonMouseIn: function onRecordButtonMouseIn() {
	        _HoverManager2.default.show(this.refs.recordingHolder, _LocalesManager2.default.getCaption('RecordSoundAlert', 'record'), 'top', true);
	
	        this.setState({
	            isRecordButtonOver: true
	        });
	    },
	    onRecordButtonMouseOut: function onRecordButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isRecordButtonOver: false
	        });
	    },
	    onDurationButtonMouseIn: function onDurationButtonMouseIn() {
	        _HoverManager2.default.show(this.refs.duration, 'slideDuration');
	
	        this.setState({
	            isDurationButtonOver: true
	        });
	    },
	    onDurationButtonMouseOut: function onDurationButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isDurationButtonOver: false
	        });
	    },
	    onDurationClick: function onDurationClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        if (_PlayController2.default.isPlaying) return;
	
	        if (_VideoUtils2.default.isVideoBackground() && !_VideoUtils2.default.showVideoEditor()) {
	            _VideoUtils2.default.changeToVideoEditorMode();
	
	            _HoverManager2.default.hide();
	        }
	    },
	    onDurationClickByKeyboard: function onDurationClickByKeyboard() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000 || document.activeElement != this.refs.durationButton) return;
	
	        if (!_PlayController2.default.isPlaying) {
	
	            if (_VideoUtils2.default.isVideoBackground() && !_VideoUtils2.default.showVideoEditor()) {
	                _VideoUtils2.default.changeToVideoEditorMode();
	
	                _HoverManager2.default.hide();
	            }
	        }
	
	        this.expand();
	    },
	    onCheckExpand: function onCheckExpand(e) {
	        if (_TextSizeUtils2.default.isTextEditMode()) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var target = e.target;
	
	        if (target) {
	            var type = _typeof(target.className);
	
	            if (type == 'string') {
	                if (target.className.indexOf('slideDurationInput') < 0) {
	                    this.setState({
	                        isExpanded: false
	                    });
	                }
	            } else {
	                this.setState({
	                    isExpanded: false
	                });
	            }
	        }
	    },
	    onExpand: function onExpand(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.expand();
	    },
	    expand: function expand() {
	        var isExpanded = this.state.isExpanded;
	        this.setState({
	            isExpanded: !isExpanded
	        });
	    },
	    onOpenMySounds: function onOpenMySounds(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _PlayController2.default.checkAudioEditorModeWhenOpenAudioMenus(1);
	    },
	    onClick: function onClick(e) {
	        if (e.target && e.target.parentElement && e.target.parentElement.id == 'mySounds') return;
	
	        if (!_AnimationManager2.default.isAnimationMode()) this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.currentSlideIndex != nextProps.currentSlideIndex) {
	            this.setState({
	                isExpanded: false
	            });
	
	            this.stopSound();
	        }
	    },
	    onRecordDown: function onRecordDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlayController2.default.isPlaying || this.props.refreshAudioElements) return;
	
	        if (_PlatformDetection2.default.isIOSApp()) {
	            if (!_ReactNativeBridge2.default.isIOSRecorderEnabled) _ReactNativeBridge2.default.init(this.initRecording);else this.props.dispatch((0, _MenuActions.showRecorder)(true));
	        } else {
	            if (!_AudioRecorder2.default.isRecordAvailable) _AudioRecorder2.default.init(this.initRecording);else this.props.dispatch((0, _MenuActions.showRecorder)(true));
	        }
	    },
	    initRecording: function initRecording() {
	        if (_PlatformDetection2.default.isIOSApp()) _ReactNativeBridge2.default.isIOSRecorderEnabled = true;
	
	        this.props.dispatch((0, _MenuActions.showRecorder)(true));
	    },
	    stopSound: function stopSound() {
	        // used when click on another slide while playing the old one
	        if (this.isSoundVisible()) {
	            if (this.state.isPlaying) {
	                if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('recordedAudio', 0, false);else _AudioUtils2.default.pauseSound('recordedAudio');
	            }
	        }
	
	        if (this.isSoundEffectVisible()) {
	            if (this.state.isPlaying) {
	                if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('audioEffect', 0, false);else _AudioUtils2.default.pauseSound('audioEffect');
	            }
	        }
	
	        if (this.isVideoVisible()) {
	            if (this.state.isPlaying) _VideoUtils2.default.pauseVideoPreview();
	        } else {
	            if (this.isVideoShapeVisible()) {
	                if (this.state.isPlaying) _VideoUtils2.default.pauseVideoShapesPreview();
	            }
	        }
	    },
	    changePlayState: function changePlayState(value) {
	        this.setState({
	            isPlaying: value
	        });
	    },
	    getStartOffset: function getStartOffset() {
	        return _VideoUtils2.default.getPlayOffset();
	    },
	    executeStop: function executeStop() {
	        this.setState({
	            isPlaying: false
	        });
	
	        if (_PlayController2.default.isAudioEditorAvailable()) _PlayController2.default.stop();
	    },
	    onStop: function onStop(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_AnimationManager2.default.isAnimationMode()) {
	            _AnimationManager2.default.stopAnimationIndEditMode();
	        } else if (_AnimationManager2.default.isAnimatedSlide()) {
	            _AnimationManager2.default.stopAnimations();
	        }
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            this.setState({
	                isPlaying: false
	            });
	
	            _PlayController2.default.stop();
	
	            return;
	        }
	
	        this.clearEndSlideTimer();
	
	        this.setState({
	            isPlaying: false
	        });
	
	        if (this.isSoundVisible()) {
	            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	                _AudioVolumeUtils2.default.executeMediaAction('recordedAudio', 0, false);
	            } else {
	                _AudioUtils2.default.pauseSound('recordedAudio');
	                var audio = document.getElementById('recordedAudio');
	
	                if (audio) audio.currentTime = 0;
	            }
	        }
	
	        if (this.isSoundEffectVisible()) {
	            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	                _AudioVolumeUtils2.default.executeMediaAction('audioEffect', 0, false);
	            } else {
	                _AudioUtils2.default.pauseSound('audioEffect');
	                var audioEffect = document.getElementById('audioEffect');
	
	                if (audioEffect) audioEffect.currentTime = 0;
	            }
	        }
	
	        if (this.isVideoVisible()) {
	            _VideoUtils2.default.pauseVideoPreview(true);
	        } else {
	            if (this.isVideoShapeVisible()) {
	                _VideoUtils2.default.pauseVideoShapesPreview(true);
	            }
	        }
	    },
	    isPlayAvailable: function isPlayAvailable() {
	        if (this.isSoundVisible() || this.isSoundEffectVisible() || this.isVideoVisible() || this.isVideoShapeVisible() || _AnimationManager2.default.isAnimatedSlide() || _AnimationManager2.default.isAnimationMode()) return true;else return false;
	    },
	    onPlay: function onPlay(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlayController2.default.isAudioEditorAvailable()) this.doNewPlay();else this.doPlay();
	    },
	    executePlayPause: function executePlayPause() {
	        if (_PlayController2.default.isAudioEditorAvailable()) this.doNewPlay();
	    },
	    doNewPlay: function doNewPlay() {
	        if (this.state.isPlaying) _PlayController2.default.pause();else _PlayController2.default.play();
	
	        if (_AnimationManager2.default.isAnimationMode()) {
	            if (!this.state.isPlaying) {
	                // play
	                _AnimationManager2.default.startAnimationInEditMode();
	            } else {
	                // pause
	                _AnimationManager2.default.stopAnimationIndEditMode();
	            }
	        } else if (_AnimationManager2.default.isAnimatedSlide()) {
	            if (!this.state.isPlaying) {
	                // play
	                _AnimationManager2.default.startAnimations(true);
	            } else {
	                // pause
	                _AnimationManager2.default.stopAnimations(true);
	            }
	        }
	
	        this.togglePlayState();
	    },
	    onEndSlideTime: function onEndSlideTime() {
	        if (this.state.isPlaying) {
	            if (this.isSoundVisible()) {
	                if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	                    _AudioVolumeUtils2.default.executeMediaAction('recordedAudio', 0, false);
	                } else {
	                    _AudioUtils2.default.pauseSound('recordedAudio', true);
	                    _AudioUtils2.default.restartAudio('recordedAudio');
	                }
	            }
	
	            if (this.isSoundEffectVisible()) {
	                if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	                    _AudioVolumeUtils2.default.executeMediaAction('audioEffect', 0, false);
	                } else {
	                    _AudioUtils2.default.pauseSound('audioEffect', true);
	                    _AudioUtils2.default.restartAudio('audioEffect');
	                }
	            }
	
	            if (this.isVideoVisible()) _VideoUtils2.default.pauseVideoPreview(true);else {
	                if (this.isVideoShapeVisible()) _VideoUtils2.default.pauseVideoShapesPreview(true);
	            }
	
	            this.setState({
	                isPlaying: false
	            });
	
	            if (_AnimationManager2.default.isAnimatedSlide()) _AnimationManager2.default.stopAnimations();
	
	            this.forceUpdate();
	        }
	    },
	    clearEndSlideTimer: function clearEndSlideTimer() {
	        if (_AudioUtils2.default.endCurrentSlideTimer) clearTimeout(_AudioUtils2.default.endCurrentSlideTimer);
	    },
	    doPlay: function doPlay() {
	        if (!this.isPlayAvailable()) return;
	
	        var offset = this.getStartOffset();
	        this.clearEndSlideTimer();
	
	        if (!this.state.isPlaying) {
	            // will do a play
	            var slideTime = _StoreManager2.default.getState().currentSlide.model.time;
	            var recordedAudio = document.getElementById('recordedAudio');
	            var audioEffect = document.getElementById('audioEffect');
	
	            if (Math.abs(recordedAudio.duration - slideTime) > 1 || Math.abs(audioEffect.duration - slideTime) > 1) _AudioUtils2.default.endCurrentSlideTimer = setTimeout(this.onEndSlideTime, slideTime * 1000);else _AudioUtils2.default.endCurrentSlideTimer = undefined;
	        } else {
	            _AudioUtils2.default.endCurrentSlideTimer = undefined;
	        }
	
	        if (this.isVideoVisible()) {
	            if (!this.state.isPlaying) {
	                _VideoUtils2.default.playVideoPreview(offset);
	            } else {
	                _VideoUtils2.default.pauseVideoPreview();
	            }
	        } else {
	            if (this.isVideoShapeVisible()) {
	                if (!this.state.isPlaying) {
	                    _VideoUtils2.default.playVideoShapesPreview();
	                } else {
	                    _VideoUtils2.default.pauseVideoShapesPreview();
	                }
	            }
	        }
	
	        if (this.isSoundVisible()) {
	            if (!this.state.isPlaying) {
	                if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	                    _AudioVolumeUtils2.default.executeMediaAction('recordedAudio', _AudioUtils2.default.getSoundVolume('recordedAudio'), true, this.onEndSound);
	                } else {
	                    _AudioUtils2.default.setSoundVolume('recordedAudio');
	                    _AudioUtils2.default.playSound('recordedAudio');
	                }
	            } else {
	                if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('recordedAudio', 0, false);else _AudioUtils2.default.pauseSound('recordedAudio');
	            }
	        }
	
	        if (this.isSoundEffectVisible()) {
	            if (!this.state.isPlaying) {
	                if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	                    _AudioVolumeUtils2.default.executeMediaAction('audioEffect', _AudioUtils2.default.getSoundVolume('audioEffect'), true, this.onEndSound);
	                } else {
	                    _AudioUtils2.default.setSoundVolume('audioEffect');
	                    _AudioUtils2.default.playSound('audioEffect');
	                }
	            } else {
	                if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('audioEffect', 0, false);else _AudioUtils2.default.pauseSound('audioEffect');
	            }
	        }
	
	        if (_AnimationManager2.default.isAnimationMode()) {
	            if (!this.state.isPlaying) {
	                // play
	                _AnimationManager2.default.startAnimationInEditMode();
	            } else {
	                // pause
	                _AnimationManager2.default.stopAnimationIndEditMode();
	            }
	        } else if (_AnimationManager2.default.isAnimatedSlide()) {
	            if (!this.state.isPlaying) {
	                // play
	                _AnimationManager2.default.startAnimations(true);
	            } else {
	                // pause
	                _AnimationManager2.default.stopAnimations(true);
	            }
	        }
	
	        this.togglePlayState();
	    },
	    togglePlayState: function togglePlayState() {
	        if (!this.state.isPlaying) {
	            this.setState({
	                isPlaying: true
	            });
	        } else {
	            this.setState({
	                isPlaying: false
	            });
	        }
	    },
	    updatePlayingStatus: function updatePlayingStatus(value) {
	        var isSoundEffect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var isEnded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        if (this.isSoundVisible() && isSoundEffect) return;
	
	        if (_AudioUtils2.default.endCurrentSlideTimer) return;
	
	        if (!value && this.isSoundVisible()) {
	            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('recordedAudio', 0, false);else _AudioUtils2.default.pauseSound('recordedAudio');
	        }
	
	        if (!value && this.isSoundEffectVisible()) {
	            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('audioEffect', 0, false);else _AudioUtils2.default.pauseSound('audioEffect');
	        }
	
	        if (isEnded) {
	            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	                _AudioVolumeUtils2.default.executeMediaAction('recordedAudio', 0, false);
	                _AudioVolumeUtils2.default.executeMediaAction('audioEffect', 0, false);
	            } else {
	                _AudioUtils2.default.restartAudio('recordedAudio');
	                _AudioUtils2.default.restartAudio('audioEffect');
	            }
	        }
	
	        this.setState({
	            isPlaying: value
	        });
	
	        this.forceUpdate();
	    },
	    onEndSound: function onEndSound() {
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	            _AudioVolumeUtils2.default.executeMediaAction('recordedAudio', 0, false);
	            _AudioVolumeUtils2.default.executeMediaAction('audioEffect', 0, false);
	        }
	
	        this.pauseSoundStatus();
	    },
	    pauseSoundStatus: function pauseSoundStatus() {
	        this.setState({
	            isPlaying: false
	        });
	    },
	    updatePlayingStatusFromVideo: function updatePlayingStatusFromVideo(value) {
	        var isEnded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (!value && this.isSoundVisible()) {
	            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('recordedAudio', 0, false);else _AudioUtils2.default.pauseSound('recordedAudio');
	        }
	
	        if (!value && this.isSoundEffectVisible()) {
	            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('audioEffect', 0, false);else _AudioUtils2.default.pauseSound('audioEffect');
	        }
	
	        if (isEnded) {
	            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	                _AudioVolumeUtils2.default.executeMediaAction('recordedAudio', 0, false);
	                _AudioVolumeUtils2.default.executeMediaAction('audioEffect', 0, false);
	            } else {
	                _AudioUtils2.default.restartAudio('recordedAudio');
	                _AudioUtils2.default.restartAudio('audioEffect');
	            }
	        }
	
	        this.setState({
	            isPlaying: value
	        });
	
	        if (!value) {
	            var video = document.getElementById('videoBackground');
	            video.currentTime = _VideoUtils2.default.getStartPoint();
	        }
	
	        this.forceUpdate();
	    },
	    isSoundVisible: function isSoundVisible() {
	        var audioSource = this.getAudioSource();
	
	        if (audioSource && audioSource != '') return true;else return false;
	    },
	    isSoundEffectVisible: function isSoundEffectVisible() {
	        var audioSource = this.getAudioEffectSource();
	
	        if (audioSource && audioSource != '') return true;else return false;
	    },
	    isVideoVisible: function isVideoVisible() {
	        return _VideoUtils2.default.isVideoBackground();
	    },
	    isVideoShapeVisible: function isVideoShapeVisible() {
	        return _VideoUtils2.default.isVideoShapes();
	    },
	    getAudioSource: function getAudioSource() {
	        var value;
	
	        if (this.props.soundWav != undefined && this.props.soundWav != '' && this.props.soundWav.length > 0) value = this.props.soundWav;else if (this.props.sound != undefined && this.props.sound != '' && this.props.sound.length > 0) value = this.props.sound;
	
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.checkSound(value, 'recordedAudio');else _AudioUtils2.default.updateHrefForRecordedSound(value);
	
	        return value;
	    },
	    getAudioEffectSource: function getAudioEffectSource() {
	        var value;
	
	        if (this.props.soundEffect != undefined && this.props.soundEffect != '' && this.props.soundEffect.length > 0) value = this.props.soundEffect;
	
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.checkSound(value, 'audioEffect');else _AudioUtils2.default.updateHrefForAudioEffect(value);
	
	        return value;
	    },
	    refreshView: function refreshView() {
	        this.forceUpdate();
	    },
	    updateViewProperties: function updateViewProperties() {
	        this.setState({
	            isPlaying: false
	        });
	
	        this.refreshView();
	    },
	    onInputBlur: function onInputBlur() {
	        var duration = parseFloat(this.refs.textDuration.value);
	
	        if (duration > 0) {
	            _AudioEditorUtils2.default.refreshAllSlidesRenderers = true;
	
	            duration = parseFloat(duration.toFixed(1));
	            this.props.dispatch((0, _CurrentSlideActions.changeSlideDuration)(duration));
	
	            _SaveManager2.default.isContentChanged(true);
	            _AudioEditorUtils2.default.checkTimelineWidth();
	            _PlayController2.default.updateCurrentSlideProperties();
	            _PlayController2.default.updateScrollPosition(100, true);
	            _SaveManager2.default.isContentChanged(true);
	        }
	
	        this.forceUpdate();
	    },
	    onChangeText: function onChangeText() {
	        var tenMinutes = 600; //seconds
	        if (this.refs.textDuration.value > tenMinutes) this.refs.textDuration.value = tenMinutes;
	
	        this.forceUpdate();
	    },
	    updateDurationText: function updateDurationText() {
	        if (this.isDurationFocus()) return;
	
	        setTimeout(function () {
	            var duration;
	
	            if (this.props.duration) duration = parseFloat(this.props.duration);
	
	            var textValue = duration ? duration.toFixed(1) : 0;
	
	            if (this.refs && this.refs.textDuration && textValue > 0) this.refs.textDuration.value = textValue;
	        }.bind(this), 10);
	    },
	    isExpandedState: function isExpandedState() {
	        return this.isDurationFocus();
	    },
	    isDurationFocus: function isDurationFocus() {
	        if (document.activeElement == this.refs.textDuration) return true;else return false;
	    },
	    onSetTextFocus: function onSetTextFocus() {
	        _PlayController2.default.getOldScrollPosition();
	
	        setTimeout(function () {
	            if (this.refs.textDuration) {
	                this.refs.textDuration.focus();
	                // this.refs.textDuration.setSelectionRange(0, 100);
	            }
	        }.bind(this), 10);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (newProps.currentSlideIndex == this.props.currentSlideIndex) {
	            if (newProps.soundEffect && this.props.soundEffect != newProps.soundEffect) {
	                _Animator2.default.startAnimation('slideSoundEffect');
	                return true;
	            }
	
	            if (newProps.soundWav && newProps.soundWav.length > 0) {
	                if (this.props.soundWav != newProps.soundWav) _Animator2.default.startAnimation('slideSound');
	            } else if (newProps.sound && this.props.sound != newProps.sound) {
	                _Animator2.default.startAnimation('slideSound');
	            }
	        }
	
	        return true;
	    },
	    render: function render() {
	        if (this.props.mode == _ModeConstants2.default.PREVIEW || this.props.showVideoEditor) return _react2.default.createElement('div', null);
	
	        var width = _Configuration2.default.CANVAS_WIDTH * this.props.scaleProperties.scale;
	        var height = _Properties2.default.RECORDING_MENU_HEIGHT;
	        var borderSize = 1;
	
	        var menuStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.RECORDING_MENU_BACKGROUND,
	            width: width,
	            height: height,
	            top: this.props.scaleProperties.topY + _Configuration2.default.CANVAS_HEIGHT * this.props.scaleProperties.scale,
	            left: this.props.scaleProperties.topX,
	            cursor: 'default',
	            userSelect: 'none',
	            userDrag: 'none',
	            WebkitUserSelect: 'none'
	        };
	
	        if (this.props.contextMode == _ModeConstants2.default.LINE_CONTEXT || this.props.contextMode == _ModeConstants2.default.FREEHAND_CONTEXT) {
	            menuStyle.pointerEvents = 'none';
	            menuStyle.opacity = 0.5;
	        }
	
	        // PLAY button
	        var borderColor = 'white';
	        var iconColor;
	        var tabIndexPlay;
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            if (this.state.isPlayButtonOver == true) {
	                iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	                borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            } else {
	                iconColor = 'black';
	            }
	        } else {
	            if (!this.isPlayAvailable()) {
	                iconColor = _Properties2.default.RECORDING_MENU_BACKGROUND;
	                tabIndexPlay = '-1';
	            } else if (this.state.isPlayButtonOver == true) {
	                iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	                borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            } else {
	                iconColor = 'black';
	            }
	        }
	
	        var playStyle = {
	            width: _Properties2.default.RECORDING_PLAY_BUTTON_WIDTH,
	            height: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            background: 'white',
	            position: 'absolute',
	            left: _Properties2.default.RECORDING_GAP,
	            top: (_Properties2.default.RECORDING_MENU_HEIGHT - _Properties2.default.RECORDING_BUTTON_HEIGHT) / 2 - borderSize,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderRadius: 3,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var playIcon = 'fa fa-play';
	        var playIconPosition = 24;
	
	        if (this.state.isPlaying) {
	            playIcon = 'fa fa-pause';
	            playIconPosition = 22;
	        }
	
	        var playIconStyle = {
	            position: 'absolute',
	            top: 6,
	            left: playIconPosition,
	            color: iconColor
	        };
	
	        // STOP button
	        borderColor = 'white';
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            if (this.state.isStopButtonOver == true) {
	                iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	                borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            } else {
	                iconColor = 'black';
	            }
	        } else {
	            if (!this.isPlayAvailable()) {
	                iconColor = _Properties2.default.RECORDING_MENU_BACKGROUND;
	            } else if (this.state.isStopButtonOver == true) {
	                iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	                borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            } else {
	                iconColor = 'black';
	            }
	        }
	
	        var stopStyle = {
	            width: _Properties2.default.RECORDING_PLAY_BUTTON_WIDTH,
	            height: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            background: 'white',
	            position: 'absolute',
	            left: _Properties2.default.RECORDING_GAP * 2 + _Properties2.default.RECORDING_PLAY_BUTTON_WIDTH,
	            top: (_Properties2.default.RECORDING_MENU_HEIGHT - _Properties2.default.RECORDING_BUTTON_HEIGHT) / 2 - borderSize,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderRadius: 3,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var stopIcon = 'fa fa-stop';
	        var stopIconStyle = {
	            position: 'absolute',
	            top: 6,
	            left: 21,
	            color: iconColor
	        };
	
	        // RECORD Button
	        var recordMiddleGap = 8;
	        var recordButtonSize = _Properties2.default.RECORDING_BUTTON_HEIGHT;
	        var recordButtonLeftPos = width / 2 - recordButtonSize - recordMiddleGap / 2;
	        var recordIcon;
	
	        if (this.state.isRecordButtonOver == true) recordIcon = 'assets/recordHover.png';else recordIcon = 'assets/record.png';
	
	        borderColor = 'red';
	
	        var recordStyle = {
	            width: recordButtonSize,
	            height: recordButtonSize,
	            position: 'absolute',
	            left: recordButtonLeftPos,
	            top: (_Properties2.default.RECORDING_MENU_HEIGHT - recordButtonSize) / 2,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            borderStyle: 'none',
	            borderRadius: 100
	        };
	
	        var recordIconStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: recordButtonSize,
	            height: recordButtonSize
	        };
	
	        // DURATION button
	        if (this.state.isDurationButtonOver == true) {
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	        } else {
	            borderColor = 'white';
	            iconColor = _Properties2.default.DURATION_SLIDER_COLOR;
	        }
	
	        var durationWidth;
	        var offset = 0;
	
	        if (this.isExpandedState()) {
	            durationWidth = _Properties2.default.RECORDING_DURATION_BUTTON_EXPANDED + 15;
	            offset = _Properties2.default.RECORGING_SLIDER_WIDTH + 10;
	        } else durationWidth = _Properties2.default.RECORDING_DURATION_BUTTON_WIDTH;
	
	        var durationLabelStyle = {
	            display: !this.isExpandedState() ? "none" : "inline-block",
	            marginTop: "5px",
	            paddingLeft: "5px",
	            fontSize: "14px"
	        };
	
	        var durationStyle = {
	            width: durationWidth,
	            height: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            background: 'white',
	            position: 'absolute',
	            left: width - _Properties2.default.RECORDING_GAP - durationWidth,
	            top: (_Properties2.default.RECORDING_MENU_HEIGHT - _Properties2.default.RECORDING_BUTTON_HEIGHT) / 2 - borderSize,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderRadius: 30,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var durationWrapperStyle = {
	            position: 'absolute',
	            width: _Properties2.default.RECORDING_DURATION_BUTTON_WIDTH,
	            height: _Properties2.default.RECORDING_BUTTON_HEIGHT,
	            top: 0,
	            left: offset
	        };
	
	        var durationIconStyle = {
	            color: 'black',
	            marginLeft: '8px',
	            marginTop: '6px'
	        };
	
	        var durationSpanStyle = {
	            fontSize: 12,
	            height: 20,
	            width: 35,
	            whiteSpace: 'nowrap',
	            cursor: 'default',
	            position: 'absolute',
	            top: 3,
	            left: 28,
	            color: 'black',
	            textAlign: 'center',
	            border: 'none'
	        };
	
	        if (_PlatformDetection2.default.isIOS()) {
	            durationSpanStyle.left = 27;
	            durationSpanStyle.height = 16;
	            durationSpanStyle.width = 24;
	        }
	
	        var sliderVisibility;
	
	        if (this.isExpandedState()) sliderVisibility = 'flex';else sliderVisibility = 'none';
	
	        var sliderProperties = {};
	        sliderProperties.topPosition = 0;
	        sliderProperties.leftPosition = 12;
	        sliderProperties.width = _Properties2.default.RECORGING_SLIDER_WIDTH;
	        sliderProperties.height = _Properties2.default.RECORDING_BUTTON_HEIGHT;
	        sliderProperties.thumbSize = _Properties2.default.STYLING_THUMB_SIZE - 2;
	        sliderProperties.start = 1;
	        sliderProperties.end = 30;
	        sliderProperties.step = 1;
	        sliderProperties.dispatch = this.props.dispatch;
	        sliderProperties.display = sliderVisibility;
	        sliderProperties.slideDuration = this.props.duration;
	        sliderProperties.currentSlideIndex = this.props.currentSlideIndex;
	
	        // MySounds button
	        var mySoundsStyle = {
	            position: 'absolute',
	            left: width / 2 + recordMiddleGap / 2,
	            top: (_Properties2.default.RECORDING_MENU_HEIGHT - recordButtonSize) / 2,
	            width: recordButtonSize,
	            height: recordButtonSize,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            borderStyle: 'none',
	            borderRadius: 100
	        };
	
	        var mySoundsIconStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: recordButtonSize,
	            height: recordButtonSize
	        };
	
	        var recordingHolderStyle = {};
	        var mySoundsIcon;
	
	        if (this.state.isMySoundsOver == true) mySoundsIcon = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/mySoundsHover.png';else mySoundsIcon = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/mySounds.png';
	
	        var audioRecorded;
	        var audioEffect;
	        var recordedSound;
	        var effectSound;
	
	        if (!_PlayController2.default.isAudioEditorAvailable()) {
	            audioRecorded = _react2.default.createElement('audio', { id: 'recordedAudio', ref: 'audio', src: this.getAudioSource(), className: 'audioItem', preload: 'auto', playsInline: true });
	            audioEffect = _react2.default.createElement('audio', { id: 'audioEffect', src: this.getAudioEffectSource(), className: 'audioItem', preload: 'auto', playsInline: true });
	
	            recordedSound = _react2.default.createElement(_SoundElement.SoundElement, { dispatch: this.props.dispatch, scaleProperties: this.props.scaleProperties, audioSource: this.getAudioSource(), soundTitle: this.props.soundTitle, updateViewProperties: this.updateViewProperties, isSoundEffect: false });
	            effectSound = _react2.default.createElement(_SoundElement.SoundElement, { dispatch: this.props.dispatch, scaleProperties: this.props.scaleProperties, audioSource: this.getAudioEffectSource(), soundTitle: this.props.soundEffectTitle, updateViewProperties: this.updateViewProperties, isSoundEffect: true });
	        }
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            mySoundsStyle.display = 'none';
	            recordStyle.left = width / 2 - recordButtonSize / 2;
	        }
	
	        this.updateDurationText();
	
	        var tabIndexMiddleElements;
	
	        if (this.props.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) {
	            recordingHolderStyle.pointerEvents = 'none';
	            recordingHolderStyle.opacity = 0.5;
	
	            mySoundsStyle.pointerEvents = 'none';
	            mySoundsStyle.opacity = 0.5;
	
	            tabIndexMiddleElements = '-1';
	        }
	
	        var playAriaLabel = '';
	
	        if (_PlayController2.default.isAudioEditorMode()) playAriaLabel = _LocalesManager2.default.getCaption('playCartoon', 'hover');else playAriaLabel = _LocalesManager2.default.getCaption('playSlide', 'hover');
	
	        var tabIndexValue;
	
	        if (document.activeElement.id == 'durationThumbButton') tabIndexValue = '-1';
	
	        var fillOutFieldViewWidth = 150;
	        var fillOutFieldViewStyle = {
	            position: 'absolute',
	            background: '#434343',
	            width: fillOutFieldViewWidth,
	            height: 30,
	            top: 36,
	            left: -27,
	            borderRadius: 5,
	            zIndex: 99999,
	            pointerEvents: 'none'
	        };
	
	        var stemStyle = {
	            position: 'absolute',
	            borderWidth: 10,
	            borderStyle: 'solid',
	            borderBottomColor: '#434343',
	            borderTopColor: 'transparent',
	            borderLeftColor: 'transparent',
	            borderRightColor: 'transparent',
	            top: -20,
	            left: fillOutFieldViewWidth / 2 - 10
	        };
	
	        var captionStyle = {
	            position: 'absolute',
	            color: 'white',
	            wordWrap: 'break-word',
	            textAlign: 'center',
	            fontSize: 12,
	            left: 5,
	            top: 8,
	            width: fillOutFieldViewWidth - 10
	        };
	
	        var fillOutFieldView;
	        var isEmptyTitle = this.refs.textDuration && this.refs.textDuration.value.length < 1;
	        var isNaNValue = this.refs.textDuration && isNaN(this.refs.textDuration.value);
	
	        if (isEmptyTitle || isNaNValue) {
	            var alertText = isEmptyTitle ? _LocalesManager2.default.getCaption('emptyInput', 'other') : _LocalesManager2.default.getCaption('notANumberInput', 'other');
	
	            if (alertText.indexOf('other') != -1) alertText = isEmptyTitle ? 'Please fill out this field!' : 'The value is not correct!';
	
	            fillOutFieldView = _react2.default.createElement(
	                'div',
	                { style: fillOutFieldViewStyle },
	                _react2.default.createElement('div', { style: stemStyle }),
	                _react2.default.createElement(
	                    'div',
	                    { style: captionStyle },
	                    alertText
	                )
	            );
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'recordingMenu', style: menuStyle, onMouseDown: this.onClick, onTouchEnd: this.onClick },
	            audioRecorded,
	            audioEffect,
	            _react2.default.createElement(
	                'button',
	                { ref: 'play', tabIndex: tabIndexPlay, 'aria-disabled': tabIndexPlay == '-1' ? true : false, 'aria-label': playAriaLabel, style: playStyle, onMouseOver: this.onPlayButtonMouseIn, onMouseOut: this.onPlayButtonMouseOut, onClick: this.onPlay, onTouchEnd: this.onPlay },
	                _react2.default.createElement('i', { style: playIconStyle, className: playIcon })
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: 'stop', tabIndex: tabIndexPlay, 'aria-disabled': tabIndexPlay == '-1' ? true : false, 'aria-label': _LocalesManager2.default.getCaption('stop', 'hover'), style: stopStyle, onMouseOver: this.onStopButtonMouseIn, onMouseOut: this.onStopButtonMouseOut, onClick: this.onStop, onTouchEnd: this.onStop },
	                _react2.default.createElement('i', { style: stopIconStyle, className: stopIcon })
	            ),
	            recordedSound,
	            effectSound,
	            _react2.default.createElement(
	                'div',
	                { style: recordingHolderStyle },
	                _react2.default.createElement(
	                    'button',
	                    { ref: 'recordingHolder', tabIndex: tabIndexMiddleElements, 'aria-disabled': tabIndexMiddleElements == '-1' ? true : false, 'aria-label': _LocalesManager2.default.getCaption('RecordSoundAlert', 'record'), style: recordStyle, onMouseOver: this.onRecordButtonMouseIn, onMouseOut: this.onRecordButtonMouseOut, onClick: this.onRecordDown, onTouchStart: this.onRecordDown },
	                    _react2.default.createElement('img', { alt: _LocalesManager2.default.getCaption('RecordSoundAlert', 'record'), 'aria-hidden': 'true', style: recordIconStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + recordIcon })
	                )
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'mySounds', ref: 'mySoundsHolder', tabIndex: tabIndexMiddleElements, 'aria-disabled': tabIndexMiddleElements == '-1' ? true : false, 'aria-label': _LocalesManager2.default.getCaption('MySoundsTitle', 'music'), style: mySoundsStyle, onTouchEnd: this.onOpenMySounds, onClick: this.onOpenMySounds, onMouseOver: this.onMySoundsMouseIn, onMouseOut: this.onMySoundsMouseOut },
	                _react2.default.createElement('img', { alt: _LocalesManager2.default.getCaption('MySoundsTitle', 'music'), 'aria-hidden': 'true', style: mySoundsIconStyle, src: mySoundsIcon })
	            ),
	            _react2.default.createElement(
	                'div',
	                { ref: 'durationButton', className: 'slideDuration', style: durationStyle, onMouseOver: this.onDurationButtonMouseIn, onMouseOut: this.onDurationButtonMouseOut, onTouchStart: this.onDurationClick, onMouseDown: this.onDurationClick, onClick: this.onDurationClickByKeyboard },
	                _react2.default.createElement('i', { 'aria-hidden': true, style: durationIconStyle, className: 'fa fa-clock-o slideDuration', onTouchEnd: this.onSetTextFocus, onMouseDown: this.onSetTextFocus }),
	                _react2.default.createElement(
	                    'label',
	                    { style: durationLabelStyle, htmlFor: 'slideDurationInput' },
	                    _LocalesManager2.default.getCaption('slideDurationInputLabel', 'other')
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'slideDuration slideDurationInput', style: durationWrapperStyle, onTouchStart: this.onExpand, onMouseDown: this.onExpand },
	                    _react2.default.createElement('input', { id: 'slideDurationInput', type: 'text', ref: 'textDuration', className: 'slideDuration titleInput', style: durationSpanStyle, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off', onChange: this.onChangeText, onTouchStart: this.onSetTextFocus, onMouseDown: this.onSetTextFocus, onBlur: this.onInputBlur, onFocus: this.onCheckExpand }),
	                    fillOutFieldView
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { id: 'qq-template' },
	                _react2.default.createElement('div', { id: 'qq-template2' })
	            )
	        );
	    }
	});
	
	function mapStateToProps(state) {
	    var duration = state.currentSlide.model.time;
	    var currentSlideIndex = state.currentSlide.currentSlideIndex;
	    var soundEffect = state.currentSlide.model.soundEffect;
	    var sound = state.currentSlide.model.sound;
	    var soundWav = state.currentSlide.model.soundWav;
	    var slideModel = state.currentSlide.model;
	    var soundTitle = state.currentSlide.model.soundTitle;
	    var soundEffectTitle = state.currentSlide.model.soundEffectTitle;
	    var showVideoEditor = state.menu.showVideoEditor;
	    var contextMode = state.menu.contextMode;
	    var refreshAudioElements = state.audioEditor.refreshAudioElements;
	
	    if (refreshAudioElements == undefined) refreshAudioElements = false;
	
	    if (!soundTitle) soundTitle = '';
	
	    if (!soundEffectTitle) soundEffectTitle = '';
	
	    if (!showVideoEditor) showVideoEditor = false;
	
	    return {
	        duration: duration,
	        currentSlideIndex: currentSlideIndex,
	        sound: sound,
	        soundWav: soundWav,
	        slideModel: slideModel,
	        soundTitle: soundTitle,
	        showVideoEditor: showVideoEditor,
	        soundEffectTitle: soundEffectTitle,
	        soundEffect: soundEffect,
	        contextMode: contextMode,
	        refreshAudioElements: refreshAudioElements
	    };
	}
	
	var RecordingMenu = exports.RecordingMenu = (0, _reactRedux.connect)(mapStateToProps)(RecordingMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/RecordingMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/RecordingMenu.js"); } } })();

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ResizeView = exports.ResizeViewContent = undefined;
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SizeAndPositionButtons = __webpack_require__(92);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _reactRedux = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResizeViewContent = exports.ResizeViewContent = _react2.default.createClass({
	    displayName: 'ResizeViewContent',
	    getInitialState: function getInitialState() {
	        var shapeModel = this.getContextTarget();
	
	        return {
	            width: shapeModel.width,
	            height: shapeModel.height,
	            lockedRatio: true
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.refreshShapePosition != nextProps.refreshShapePosition) {
	            var contextTarget = this.getContextTarget();
	
	            this.setState({ width: contextTarget.width, height: contextTarget.height });
	        }
	    },
	    getContextTarget: function getContextTarget() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	
	        for (var i = 1; i < shapes.length; i++) {
	            if (shapes[i].uuid === this.props.shapeModel.uuid) return shapes[i];
	        }
	
	        return this.props.shapeModel;
	    },
	    updateAttribute: function updateAttribute(name, value) {
	        var shapeModel = this.getContextTarget();
	        if (!shapeModel) {
	            return;
	        }
	
	        value = parseInt(value);
	        var isChanged = false;
	        var absoluteValue = Math.abs(value) || 0;
	        var lockedRatio = this.state.lockedRatio;
	
	        switch (name) {
	            case 'width':
	                {
	                    if (shapeModel.width !== absoluteValue) {
	                        var height = lockedRatio && this.state.height ? absoluteValue / this.state.width * this.state.height : this.state.height + 0.1;
	
	                        if (height !== this.state.height || absoluteValue !== this.state.width) {
	                            this.setState({ width: absoluteValue, height: height });
	                        }
	
	                        isChanged = true;
	                        this.props.dispatch((0, _CurrentSlideActions.updateShapeSize)(shapeModel.uuid, absoluteValue, height, shapeModel.x, shapeModel.y));
	                    }
	                    break;
	                }
	            case 'height':
	                {
	                    if (shapeModel.height !== absoluteValue) {
	                        var width = lockedRatio && this.state.width ? absoluteValue / this.state.height * this.state.width : this.state.width + 0.1;
	
	                        if (width !== this.state.width || absoluteValue !== this.state.height) {
	                            this.setState({ height: absoluteValue, width: width });
	                        }
	                        isChanged = true;
	                        this.props.dispatch((0, _CurrentSlideActions.updateShapeSize)(shapeModel.uuid, width, absoluteValue, shapeModel.x, shapeModel.y));
	                    }
	                    break;
	                }
	        }
	
	        if (isChanged) {
	            _SaveManager2.default.isContentChanged(true);
	            _AudioEditorUtils2.default.addActionToHistory();
	            this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	            this.forceUpdate();
	        }
	    },
	    onCheckBoxClick: function onCheckBoxClick() {
	        this.setState({
	            lockedRatio: !this.state.lockedRatio
	        });
	    },
	    render: function render() {
	        var smallTextStyle = {
	            fontSize: '12px',
	            marginTop: '15px',
	            marginBottom: '-5px'
	        };
	
	        var buttonWrapperStyle = {
	            display: 'flex',
	            flexWrap: 'wrap',
	            marginTop: '10px',
	            justifyContent: 'space-between'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { style: smallTextStyle },
	                _LocalesManager2.default.getCaption('Size', 'sizePosMenu')
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: buttonWrapperStyle },
	                _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Width', 'sizePosMenu'), value: this.state.width, property: 'width', onChangeHandler: this.updateAttribute }),
	                _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { isInt: true, labelText: _LocalesManager2.default.getCaption('Height', 'sizePosMenu'), value: this.state.height, property: 'height', onChangeHandler: this.updateAttribute }),
	                _react2.default.createElement(_SizeAndPositionButtons.MenuCheckbox, { id: 'resizeLastItem', labelText: _LocalesManager2.default.getCaption('LockRatio', 'sizePosMenu'), value: this.state.lockedRatio, clickHandler: this.onCheckBoxClick })
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var refreshShapePosition = state.menu.refreshShapePosition;
	
	    return {
	        refreshShapePosition: refreshShapePosition
	    };
	}
	
	var ResizeView = exports.ResizeView = (0, _reactRedux.connect)(mapStateToProps)(ResizeViewContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ResizeView.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ResizeView.js"); } } })();

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RotationView = undefined;
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SizeAndPositionButtons = __webpack_require__(92);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _reactRedux = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RotationViewContent = _react2.default.createClass({
	    displayName: 'RotationViewContent',
	    getInitialState: function getInitialState() {
	        var shapeModel = this.getContextTarget();
	
	        return {
	            rotation: shapeModel.rotation
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.refreshShapePosition != nextProps.refreshShapePosition) {
	            var contextTarget = this.getContextTarget();
	
	            this.setState({ rotation: contextTarget.rotation });
	        }
	    },
	    getContextTarget: function getContextTarget() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	
	        for (var i = 1; i < shapes.length; i++) {
	            if (shapes[i].uuid === this.props.shapeModel.uuid) return shapes[i];
	        }
	
	        return this.props.shapeModel;
	    },
	    changeRotation: function changeRotation(rotation) {
	        var shapeModel = this.getContextTarget();
	
	        if (!shapeModel) return;
	
	        if (shapeModel.rotation !== rotation) {
	            this.props.dispatch((0, _CurrentSlideActions.updateShapeRotation)(shapeModel.uuid, rotation));
	            _SaveManager2.default.isContentChanged(true);
	            _AudioEditorUtils2.default.addActionToHistory();
	            this.setState({ rotation: rotation });
	            this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	            this.forceUpdate();
	        }
	    },
	    render: function render() {
	        var smallTextStyle = {
	            fontSize: '12px',
	            marginTop: '15px',
	            marginBottom: '-5px'
	        };
	
	        var buttonWrapperStyle = {
	            display: 'flex',
	            flexWrap: 'wrap',
	            marginTop: '10px',
	            justifyContent: 'space-between'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'h3',
	                { style: smallTextStyle },
	                _LocalesManager2.default.getCaption('Rotation', 'sizePosMenu')
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: buttonWrapperStyle },
	                _react2.default.createElement(_SizeAndPositionButtons.SecondaryMenuButton, { clickHandler: this.changeRotation, type: 0, caption: _LocalesManager2.default.getCaption('RotateTo', 'sizePosMenu') + ' 0°' }),
	                _react2.default.createElement(_SizeAndPositionButtons.SecondaryMenuButton, { clickHandler: this.changeRotation, type: 90, caption: _LocalesManager2.default.getCaption('RotateTo', 'sizePosMenu') + ' 90°' }),
	                _react2.default.createElement(_SizeAndPositionButtons.SecondaryMenuButton, { clickHandler: this.changeRotation, type: 180, caption: _LocalesManager2.default.getCaption('RotateTo', 'sizePosMenu') + ' 180°' }),
	                _react2.default.createElement(_SizeAndPositionButtons.SecondaryMenuButton, { clickHandler: this.changeRotation, type: 270, caption: _LocalesManager2.default.getCaption('RotateTo', 'sizePosMenu') + ' 270°' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: buttonWrapperStyle },
	                _react2.default.createElement(_SizeAndPositionButtons.MenuInput, { id: 'resizeLastItem', isInt: true, labelText: _LocalesManager2.default.getCaption('SetRotationInDegrees', 'sizePosMenu'), value: this.state.rotation, onChangeHandler: this.changeRotation })
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var refreshShapePosition = state.menu.refreshShapePosition;
	
	    return {
	        refreshShapePosition: refreshShapePosition
	    };
	}
	
	var RotationView = exports.RotationView = (0, _reactRedux.connect)(mapStateToProps)(RotationViewContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/RotationView.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/RotationView.js"); } } })();

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SaveButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _HelpUtils = __webpack_require__(172);
	
	var _HelpUtils2 = _interopRequireDefault(_HelpUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SaveButtonContent = _react2.default.createClass({
	    displayName: 'SaveButtonContent',
	    getInitialState: function getInitialState() {
	        return {
	            isSaveButtonOver: false,
	            isHelpButtonOver: false
	        };
	    },
	    onSaveMouseIn: function onSaveMouseIn() {
	        _HoverManager2.default.show(this.refs.holder, 'saveButton', 'left');
	
	        this.setState({
	            isSaveButtonOver: true
	        });
	    },
	    onSaveMouseOut: function onSaveMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isSaveButtonOver: false
	        });
	    },
	    onSaveClick: function onSaveClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _ZoomUtils2.default.closeZoom();
	
	        if (document.activeElement) document.activeElement.blur();
	
	        if (_PlayController2.default.isAudioEditorMode()) this.props.dispatch((0, _AccordionActions.changeAcoordionWidth)(_Properties2.default.BROWSER_WIDTH));
	
	        if (_AppParameters2.default.context != _ModeConstants2.default.AUDIO_TOOL) this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	
	        this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.SAVE_CONTEXT));
	    },
	    onHelpMouseIn: function onHelpMouseIn() {
	        _HoverManager2.default.show(this.refs.help, 'helpButton', 'left');
	
	        this.setState({
	            isHelpButtonOver: true
	        });
	    },
	    onHelpMouseOut: function onHelpMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isHelpButtonOver: false
	        });
	    },
	    onHelpClick: function onHelpClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var url;
	
	        if (_AppParameters2.default.locale.indexOf('nb_NO') != -1 || _AppParameters2.default.locale.indexOf('nn_NO') != -1) url = 'https://web.creaza.com/no/help/cartoonist';else if (_AppParameters2.default.locale.indexOf('sv_SE') != -1) url = 'https://web.creaza.com/se/help/skapatecknadserie';else url = 'https://web.creaza.com/en/help/create-a-cartoon';
	
	        window.open(url, '_blank');
	    },
	    render: function render() {
	        if (!_AudioToolUtils2.default.isAudioTool()) _HelpUtils2.default.checkHelpInfo();
	
	        var isIOS = _PlatformDetection2.default.isIOS();
	        var width = _Properties2.default.MAIN_MENU_WIDTH;
	        var height = isIOS ? 40 : _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        var iconColor;
	
	        if (this.state.isSaveButtonOver == true) iconColor = '#c0c0c0';else iconColor = 'white';
	
	        var holderStyle = {
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            width: width,
	            height: height,
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none'
	        };
	
	        var saveButtonStyle = {
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            width: width,
	            height: height,
	            background: _Properties2.default.INSERT_MENU_BUTTON_COLOR,
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            cursor: 'pointer',
	            borderStyle: 'none'
	        };
	
	        var saveIconStyle = {
	            position: 'absolute',
	            top: isIOS ? 12 : 7,
	            left: 12,
	            color: iconColor,
	            fontSize: 16
	        };
	
	        var preloaderVisible = 'none';
	
	        if (this.props.showSavePreloader == true || _Configuration2.default.LOAD_LOCAL) preloaderVisible = 'block';
	
	        var preloaderHolderStyle = {
	            position: 'absolute',
	            left: 0,
	            top: isIOS ? 75 : 70,
	            display: preloaderVisible
	        };
	
	        var preloaderStyle = {
	            position: 'absolute',
	            top: 6,
	            left: 2,
	            color: 'black'
	        };
	
	        var src;
	
	        // if (this.state.isHelpButtonOver == true)
	        src = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/mainMenu_help.svg';
	        // else
	        //     src = appParameters.RESOURCES_LOCATION() + 'assets/tutorial.svg';
	
	        var linkStyle = {
	            position: 'absolute',
	            top: isIOS ? 47 : 37,
	            width: _Properties2.default.MAIN_MENU_WIDTH,
	            height: 20,
	            left: 0,
	            cursor: 'pointer'
	        };
	
	        var helpStyle = {
	            position: 'relative',
	            top: 0,
	            width: _Properties2.default.MAIN_MENU_WIDTH,
	            height: 20,
	            left: 0
	        };
	
	        var preloaderClass = 'fa fa-spinner fa-pulse fa-2x';
	
	        if (_AudioToolUtils2.default.isAudioTool() || _PlatformDetection2.default.isIOSApp()) helpStyle.display = 'none';
	
	        return _react2.default.createElement(
	            'div',
	            { style: holderStyle },
	            _react2.default.createElement(
	                'button',
	                { ref: 'holder', 'aria-label': _LocalesManager2.default.getCaption('SaveMenuTitle', 'save'), style: saveButtonStyle, onTouchEnd: this.onSaveClick, onClick: this.onSaveClick, onMouseOver: this.onSaveMouseIn, onMouseOut: this.onSaveMouseOut },
	                _react2.default.createElement('i', { style: saveIconStyle, className: 'fa fa-floppy-o' })
	            ),
	            _react2.default.createElement(
	                'a',
	                { id: 'helpButton', ref: 'help', 'aria-label': _LocalesManager2.default.getCaption('helpButton', 'hover'), style: linkStyle, href: '', onTouchEnd: this.onHelpClick, onClick: this.onHelpClick, onMouseOver: this.onHelpMouseIn, onMouseOut: this.onHelpMouseOut },
	                _react2.default.createElement('img', { alt: _LocalesManager2.default.getCaption('helpButton', 'hover'), 'aria-hidden': 'true', style: helpStyle, src: src })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: preloaderHolderStyle },
	                _react2.default.createElement('i', { style: preloaderStyle, className: preloaderClass })
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var showSavePreloader = state.menu.showSavePreloader;
	    var contextMode = state.menu.contextMode;
	
	    return {
	        showSavePreloader: showSavePreloader,
	        contextMode: contextMode
	    };
	}
	
	var SaveButton = exports.SaveButton = (0, _reactRedux.connect)(mapStateToProps)(SaveButtonContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SaveButton.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SaveButton.js"); } } })();

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SaveButtonAudioEditor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _HelpUtils = __webpack_require__(172);
	
	var _HelpUtils2 = _interopRequireDefault(_HelpUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SaveButtonAudioEditorContent = _react2.default.createClass({
	    displayName: 'SaveButtonAudioEditorContent',
	    getInitialState: function getInitialState() {
	        return {
	            isSaveButtonOver: false,
	            isHelpButtonOver: false
	        };
	    },
	    onSaveMouseIn: function onSaveMouseIn() {
	        _HoverManager2.default.show(this.refs.holder, 'saveButton', 'left');
	
	        this.setState({
	            isSaveButtonOver: true
	        });
	    },
	    onSaveMouseOut: function onSaveMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isSaveButtonOver: false
	        });
	    },
	    onSaveClick: function onSaveClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _ZoomUtils2.default.closeZoom();
	
	        if (document.activeElement) document.activeElement.blur();
	
	        if (_PlayController2.default.isAudioEditorMode()) this.props.dispatch((0, _AccordionActions.changeAcoordionWidth)(_Properties2.default.BROWSER_WIDTH));
	
	        if (_AppParameters2.default.context != _ModeConstants2.default.AUDIO_TOOL) this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	
	        this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.SAVE_CONTEXT));
	    },
	    onHelpMouseIn: function onHelpMouseIn() {
	        _HoverManager2.default.show(this.refs.help, 'helpButton', 'left');
	
	        this.setState({
	            isHelpButtonOver: true
	        });
	    },
	    onHelpMouseOut: function onHelpMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isHelpButtonOver: false
	        });
	    },
	    onHelpClick: function onHelpClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var url;
	
	        if (_AppParameters2.default.locale.indexOf('nb_NO') != -1 || _AppParameters2.default.locale.indexOf('nn_NO') != -1) url = 'https://web.creaza.com/no/help/cartoonist';else if (_AppParameters2.default.locale.indexOf('sv_SE') != -1) url = 'https://web.creaza.com/se/help/skapatecknadserie';else url = 'https://web.creaza.com/en/help/create-a-cartoon';
	
	        window.open(url, '_blank');
	    },
	    render: function render() {
	        if (this.props.contextMode == _ModeConstants2.default.FREEHAND_CONTEXT || this.props.contextMode == _ModeConstants2.default.LINE_CONTEXT || this.props.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) return _react2.default.createElement('div', null);
	
	        if (!_AudioToolUtils2.default.isAudioTool()) _HelpUtils2.default.checkHelpInfo();
	
	        var width = _Properties2.default.INSERT_MENU_BUTTON_SIZE - 10;
	        var height = _Properties2.default.CLIPART_BUTTON_HEIGHT;
	        var iconColor;
	
	        if (_PlatformDetection2.default.isIOS()) {
	            width = _Properties2.default.INSERT_MENU_BUTTON_SIZE;
	            height = height + 10;
	        }
	
	        if (this.state.isSaveButtonOver == true) iconColor = '#c0c0c0';else iconColor = 'white';
	
	        var topBarHeight = _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight();
	
	        var holderStyle = {
	            position: 'absolute',
	            left: this.props.windowWidth - this.props.accordionWidth - width,
	            top: topBarHeight,
	            width: width,
	            height: height,
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            zIndex: 1000
	        };
	
	        var saveButtonStyle = {
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            width: width,
	            height: height,
	            background: _Properties2.default.INSERT_MENU_BUTTON_COLOR,
	            borderTopLeftRadius: 50,
	            borderBottomLeftRadius: 50,
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        var saveIconStyle = {
	            position: 'absolute',
	            top: 7,
	            left: 11,
	            color: iconColor
	        };
	
	        var preloaderBackground = _Properties2.default.INSERT_MENU_BUTTON_COLOR;
	        var preloaderVisible = 'none';
	
	        if (this.props.showSavePreloader == true) preloaderVisible = 'block';
	
	        var saveSoundPreloader = {
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            width: width,
	            height: height,
	            background: preloaderBackground,
	            borderColor: _Properties2.default.INSERT_MENU_BUTTON_COLOR,
	            borderTopLeftRadius: 50,
	            borderBottomLeftRadius: 50,
	            display: preloaderVisible
	        };
	
	        var savePreloaderStyle = {
	            position: 'absolute',
	            top: 6,
	            left: 9,
	            color: 'white'
	        };
	
	        var src;
	
	        if (this.state.isHelpButtonOver == true) src = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/tutorial_hover.svg';else src = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/tutorial.svg';
	
	        var helpStyle = {
	            position: 'absolute',
	            top: 32,
	            width: 26,
	            height: 26,
	            left: 3
	        };
	
	        var preloaderClass = 'fa fa-spinner fa-pulse fa-1x';
	
	        if (_AudioToolUtils2.default.isAudioTool() || _PlatformDetection2.default.isIOSApp()) helpStyle.display = 'none';
	
	        if (_PlatformDetection2.default.isIOS()) {
	            saveIconStyle.left = 16;
	            savePreloaderStyle.left = 13;
	            helpStyle.left = 6;
	
	            saveIconStyle.top = 11;
	            savePreloaderStyle.top = 4;
	            savePreloaderStyle.left = 6;
	            helpStyle.width = 33;
	            helpStyle.height = 33;
	            helpStyle.top = height + 4;
	
	            preloaderClass = 'fa fa-spinner fa-pulse fa-2x';
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: holderStyle },
	            _react2.default.createElement(
	                'button',
	                { ref: 'holder', 'aria-label': _LocalesManager2.default.getCaption('SaveMenuTitle', 'save'), style: saveButtonStyle, onTouchEnd: this.onSaveClick, onClick: this.onSaveClick, onMouseOver: this.onSaveMouseIn, onMouseOut: this.onSaveMouseOut },
	                _react2.default.createElement('i', { style: saveIconStyle, className: 'fa fa-floppy-o' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: saveSoundPreloader },
	                _react2.default.createElement('i', { style: savePreloaderStyle, className: preloaderClass })
	            ),
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: helpStyle, id: 'helpButton', ref: 'help', src: src, onTouchEnd: this.onHelpClick, onClick: this.onHelpClick, onMouseOver: this.onHelpMouseIn, onMouseOut: this.onHelpMouseOut })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var showSavePreloader = state.menu.showSavePreloader;
	    var contextMode = state.menu.contextMode;
	
	    return {
	        showSavePreloader: showSavePreloader,
	        contextMode: contextMode
	    };
	}
	
	var SaveButtonAudioEditor = exports.SaveButtonAudioEditor = (0, _reactRedux.connect)(mapStateToProps)(SaveButtonAudioEditorContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SaveButtonAudioEditor.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SaveButtonAudioEditor.js"); } } })();

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SaveMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            width: 24,
	            height: 24,
	            top: 3,
	            right: 28,
	            cursor: 'pointer',
	            borderStyle: 'none',
	            background: 'none'
	        };
	
	        var closeStyle = {
	            position: 'relative',
	            width: 15,
	            top: 2,
	            left: -2
	        };
	
	        if (_PlatformDetection2.default.isIOS()) {
	            titleStyle.height = _Properties2.default.CLIPART_BUTTON_HEIGHT_OLD;
	            spanStyle.top = 11;
	            closeButtonStyle.top = 8;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                _LocalesManager2.default.getCaption('SaveMenuTitle', 'save')
	            ),
	            _react2.default.createElement(
	                'button',
	                { 'aria-label': _LocalesManager2.default.getCaption('close', 'other'), id: 'firstFocusableObject', style: closeButtonStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	
	        this.setSaveTitle();
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // SAVE
	                    _SaveManager2.default.saveData();
	                    break;
	                }
	
	            case 1:
	                {
	                    // SAVE AS
	                    if (this.props.showSaveAsAlert) _SaveManager2.default.showSaveAsAlert = this.props.showSaveAsAlert;
	
	                    _SaveManager2.default.saveAsData();
	                    break;
	                }
	
	            case 2:
	                {
	                    // EXPORT
	                    _AnimationManager2.default.stopAnimations();
	                    _SaveManager2.default.saveData();
	                    this.props.dispatch((0, _MenuActions.showExportAlert)(true));
	                    // exporterUtils.prepareDataForExport();
	                    break;
	                }
	
	            case 3:
	                {
	                    // PRINT
	                    _SaveManager2.default.saveData();
	
	                    setTimeout(function () {
	                        window.open('/creaza/cartoonist/index.jsp?id=' + _AppParameters2.default.contentItemId + '&cartoonistVersion=' + _AppParameters2.default.bundleVersion + '&context=printEditor', '_blank');
	                        this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	                    }.bind(this), 2000);
	                    break;
	                }
	
	            case 4:
	                {
	                    // CANCEL
	                    this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	                    break;
	                }
	        }
	
	        if (_PlatformDetection2.default.isIOS()) document.activeElement.blur();
	    },
	    setSaveTitle: function setSaveTitle() {
	        var titleInput = document.getElementById('productionTitle');
	
	        if (titleInput) _AppParameters2.default.title = titleInput.value;
	    },
	    getSrc: function getSrc() {
	        var icon;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    icon = 'fa fa-floppy-o';
	                    break;
	                }
	            case 1:
	                {
	                    icon = 'fa fa-clone';
	                    break;
	                }
	            case 2:
	                {
	                    icon = 'fa fa-download';
	                    break;
	                }
	            case 3:
	                {
	                    icon = 'fa fa-print';
	                    break;
	                }
	            case 4:
	                {
	                    icon = 'fa fa-window-close-o';
	                    break;
	                }
	        }
	
	        return icon;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth || this.props.isDisabled != newProps.isDisabled) return true;else return false;
	    },
	    render: function render() {
	        var textColor;
	        var buttonColor;
	
	        if (this.state.isOver == true) {
	            textColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	            buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	        } else {
	            textColor = 'black';
	            buttonColor = 'white';
	        }
	
	        var gap = 20;
	
	        if (_PlatformDetection2.default.isIOS() == true) gap = 5;
	
	        var buttonWidth = this.props.accordionWidth - 2 * gap;
	        var buttonHeight = _Properties2.default.TEXT_STYLING_BUTTON_HEIGHT + 10;
	        var buttonIndex = this.props.index;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: buttonWidth,
	            height: buttonHeight,
	            display: 'flex',
	            alignItems: 'center',
	            left: gap,
	            top: buttonIndex * (buttonHeight + 1),
	            borderStyle: 'none',
	            padding: 0,
	            cursor: 'pointer'
	        };
	
	        var tabIndexValue = '';
	
	        if (this.props.isDisabled) {
	            buttonStyle.opacity = 0.5;
	            buttonStyle.pointerEvents = 'none';
	            tabIndexValue = '-1';
	        }
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 14,
	            left: 10,
	            color: textColor,
	            fontSize: 16
	        };
	
	        var padding = 35;
	        var spanStyle = {
	            color: textColor,
	            fontSize: 15,
	            position: 'absolute',
	            top: 12,
	            height: 20,
	            width: buttonWidth - padding,
	            whiteSpace: 'nowrap',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            textAlign: 'center',
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: padding
	        };
	
	        var iconElement;
	
	        if (this.props.index == 2) {
	            iconStyle.width = 18;
	            var exportIcon = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exportBtn.png';
	
	            if (this.state.isOver) exportIcon = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exportBtnHover.png';
	
	            iconElement = _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: exportIcon });
	        } else iconElement = _react2.default.createElement('i', { 'aria-hidden': 'true', style: iconStyle, className: this.getSrc() });
	
	        var title = this.props.text;
	
	        if (_AudioToolUtils2.default.isAudioTool()) title = title.replace('MP4', 'MP3');
	
	        var idValue = this.props.index == 3 ? 'saveMenuLastFocusableElement' : undefined;
	
	        return _react2.default.createElement(
	            'button',
	            { tabIndex: tabIndexValue, id: idValue, style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            iconElement,
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                title
	            )
	        );
	    }
	});
	
	var SaveMenu = exports.SaveMenu = _react2.default.createClass({
	    displayName: 'SaveMenu',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            isSaveAsAlert: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('firstFocusableObject');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onInputClick: function onInputClick() {
	        this.changeFocus();
	    },
	    changeFocus: function changeFocus() {
	        var view = this.refs.productionTitle;
	
	        if (view) {
	            view.focus();
	        }
	    },
	    getTitleInputAriaLabel: function getTitleInputAriaLabel() {
	        var view = this.refs.productionTitle;
	
	        if (view) return view.value;else return _AppParameters2.default.title;
	    },
	    onChangeText: function onChangeText() {
	        this.forceUpdate();
	    },
	    showSaveAsAlert: function showSaveAsAlert() {
	        this.setState({
	            isSaveAsAlert: true
	        });
	
	        setInterval(this.closeSaveAsAlert.bind(this), 5000);
	    },
	    closeSaveAsAlert: function closeSaveAsAlert() {
	        this.setState({
	            isSaveAsAlert: false
	        });
	    },
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var borderColor;
	        var textColor;
	
	        if (this.state.isOver == true) {
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            textColor = borderColor;
	        } else {
	            borderColor = 'black';
	            textColor = 'black';
	        }
	
	        var fontSize = 16;
	        var leftGap = _Properties2.default.STYLING_LEFT_GAP;
	        var inputPadding = 14;
	        var inputTopPosition = 7;
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            leftGap = 4;
	            fontSize = 14;
	            inputPadding = 9;
	            inputTopPosition = 3;
	        }
	
	        var titleWidth = this.props.accordionWidth - 2 * leftGap;
	
	        var titleStyle = {
	            width: titleWidth,
	            height: _Properties2.default.TEXT_STYLING_BUTTON_HEIGHT,
	            background: 'white',
	            borderRadius: 50,
	            position: 'absolute',
	            left: leftGap,
	            top: _Properties2.default.CLIPART_BUTTON_HEIGHT + _Properties2.default.STYLING_TOP_GAP,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            alignItems: 'center'
	        };
	
	        var inputStyle = {
	            position: 'absolute',
	            color: textColor,
	            top: inputTopPosition,
	            paddingLeft: inputPadding,
	            fontSize: fontSize,
	            width: titleWidth - 2 * inputPadding,
	            resize: 'none',
	            overflow: 'hidden',
	            border: 'none',
	            outline: 'none',
	            background: 'transparent'
	        };
	
	        var buttonsHolderStyle = {
	            position: 'absolute',
	            top: _Properties2.default.CLIPART_BUTTON_HEIGHT + 2 * _Properties2.default.STYLING_TOP_GAP + _Properties2.default.TEXT_STYLING_BUTTON_HEIGHT
	        };
	
	        var fillOutFieldViewWidth = 150;
	        var fillOutFieldViewStyle = {
	            position: 'absolute',
	            background: '#434343',
	            width: fillOutFieldViewWidth,
	            height: 30,
	            top: 45,
	            left: 20,
	            borderRadius: 5,
	            zIndex: 99999,
	            pointerEvents: 'none'
	        };
	
	        var stemStyle = {
	            position: 'absolute',
	            borderWidth: 10,
	            borderStyle: 'solid',
	            borderBottomColor: '#434343',
	            borderTopColor: 'transparent',
	            borderLeftColor: 'transparent',
	            borderRightColor: 'transparent',
	            top: -20,
	            left: fillOutFieldViewWidth / 2 - 10
	        };
	
	        var captionStyle = {
	            position: 'absolute',
	            color: 'white',
	            wordWrap: 'break-word',
	            textAlign: 'center',
	            fontSize: 12,
	            left: 5,
	            top: 8,
	            width: fillOutFieldViewWidth - 10
	        };
	
	        var fillOutFieldView;
	        var isDisabled = false;
	        var isEmptyTitle = this.refs.productionTitle && this.refs.productionTitle.value.length < 1;
	
	        if (isEmptyTitle || this.state.isSaveAsAlert) {
	            var alertText = isEmptyTitle ? _LocalesManager2.default.getCaption('FillOutThisField', 'other') : _LocalesManager2.default.getCaption('TheCopyHasBeenDone', 'other');
	
	            if (this.state.isSaveAsAlert) fillOutFieldViewStyle.top = 145;
	
	            fillOutFieldView = _react2.default.createElement(
	                'div',
	                { style: fillOutFieldViewStyle },
	                _react2.default.createElement('div', { style: stemStyle }),
	                _react2.default.createElement(
	                    'div',
	                    { style: captionStyle },
	                    alertText
	                )
	            );
	
	            if (isEmptyTitle) isDisabled = true;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'saveMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(
	                'div',
	                { style: titleStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onInputClick },
	                _react2.default.createElement('input', { type: 'text', 'aria-label': this.getTitleInputAriaLabel(), ref: 'productionTitle', id: 'productionTitle', className: 'titleInput', onChange: this.onChangeText, style: inputStyle, defaultValue: _AppParameters2.default.title, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off' }),
	                fillOutFieldView
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: buttonsHolderStyle },
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, isDisabled: isDisabled, index: 0, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Save', 'save') }),
	                _react2.default.createElement(Button, { showSaveAsAlert: this.showSaveAsAlert, accordionWidth: this.props.accordionWidth, isDisabled: isDisabled, index: 1, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('SaveAs', 'save') }),
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 2, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Export', 'save') }),
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 3, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Print', 'save') }),
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 4, dispatch: this.props.dispatch, text: _LocalesManager2.default.getCaption('Cancel', 'save') })
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SaveMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SaveMenu.js"); } } })();

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ShapeMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _GroupManager = __webpack_require__(142);
	
	var _GroupManager2 = _interopRequireDefault(_GroupManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	var _MindMapUtils = __webpack_require__(85);
	
	var _MindMapUtils2 = _interopRequireDefault(_MindMapUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onButtonClick: function onButtonClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // change moods
	                    this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.OBJECT_CONTEXT_MOODS));
	                    break;
	                }
	
	            case 1:
	                {
	                    //duplicate shape
	                    _SelectionManager2.default.currentSlide = undefined;
	                    this.props.dispatch((0, _CurrentSlideActions.duplicateShape)(this.props.contextTarget));
	                    _AudioEditorUtils2.default.addActionToHistory();
	                    this.props.dispatch((0, _CurrentSlideActions.selectLastAddedShape)());
	                    this.updateThumbnail();
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	
	            case 2:
	                {
	                    // delete shape
	                    this.props.dispatch((0, _CurrentSlideActions.deleteShape)([this.props.contextTarget.uuid]));
	                    this.props.dispatch((0, _CurrentSlideActions.selectShape)(''));
	                    _AudioEditorUtils2.default.addActionToHistory();
	                    this.updateThumbnail();
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	
	            case 3:
	                {
	                    // change style
	                    this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.OBJECT_CONTEXT_STYLING));
	                    break;
	                }
	
	            case 4:
	                {
	                    // text Styling
	                    if (this.props.contextTarget) {
	                        this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.OBJECT_TEXT_STYLING));
	
	                        if (!_PlatformDetection2.default.isIOS()) {
	                            setTimeout(function () {
	                                var element = document.getElementById('firstFocusableObjectForTextStylingMenu');
	
	                                if (element) element.focus();
	                            }.bind(this), 30);
	                        }
	                    }
	                    break;
	                }
	
	            case 5:
	                {
	                    // advanced option
	                    this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.OBJECT_CONTEXT_ADVANCED));
	                    break;
	                }
	
	            case 7:
	                {
	                    // Animation
	                    if (_AnimationManager2.default.allowAnimation) _AnimationManager2.default.enterAnimationMode(this.props.contextTarget);else return;
	                    break;
	                }
	
	            case 8:
	                {
	                    // Ungroup
	                    _GroupManager2.default.groupUngroup();
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	
	            case 9:
	                {
	                    // Go to theme
	                    _MouseUtils2.default.isCanvasAction = true;
	                    _MasterUniverseUtils2.default.goToTheme(this.props.contextTarget.theme);
	                    this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                    return;
	                }
	
	            case 10:
	                {
	                    // Cropping menu
	                    _ZoomUtils2.default.updateCroppingInitialPosition = true;
	                    _ZoomUtils2.default.croppingTarget = this.props.contextTarget;
	
	                    if (_ZoomUtils2.default.croppingTarget.rotation != 0) {
	                        _ZoomUtils2.default.croppingTargetRotation = _ZoomUtils2.default.croppingTarget.rotation;
	                        this.props.dispatch((0, _CurrentSlideActions.updateShapeRotation)(_ZoomUtils2.default.croppingTarget.uuid, 0));
	                    }
	
	                    this.props.dispatch((0, _CurrentSlideActions.selectShape)(''));
	                    this.props.dispatch((0, _MenuActions.showCroppingMenu)(true));
	                    break;
	                }
	            case 11:
	                {
	                    // Add stem for Complex Speech bubble
	                    this.props.dispatch((0, _CurrentSlideActions.updateStem)(this.props.contextTarget.uuid, 'add'));
	                    break;
	                }
	            case 12:
	                {
	                    // Delete stem for Complex Speech bubble
	                    this.props.dispatch((0, _CurrentSlideActions.updateStem)(this.props.contextTarget.uuid, 'delete'));
	                    break;
	                }
	            case 13:
	                {
	                    // Open TextEditor tool and add text focus
	                    _TextEditorUtils2.default.openTextEditorTool(this.props.contextTarget);
	                    break;
	                }
	            case 14:
	                {
	                    // Size and position menu
	                    this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.SIZE_AND_POSITION_CONTEXT));
	                    break;
	                }
	        }
	
	        this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.SHAPE_MENU]));
	    },
	    updateThumbnail: function updateThumbnail() {
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 27) {
	            // ESCAPE
	            if (_MouseUtils2.default.activeElement.length > 0) {
	                var element = document.getElementById('interactiveElement_' + _MouseUtils2.default.activeElement);
	
	                if (element) element.focus();
	
	                this.props.dispatch((0, _MenuActions.setContextTarget)(_MouseUtils2.default.activeElement, false));
	            }
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.contextTarget != newProps.contextTarget) return true;else return false;
	    },
	    render: function render() {
	        var backgroundColor = void 0;
	
	        if (this.state.isOver == true) {
	            backgroundColor = _Properties2.default.BROWSER_HOVER_COLOR;
	        } else {
	            backgroundColor = _Properties2.default.SLIDE_MENU_COLOR;
	        }
	
	        var paddingLeft = 10;
	
	        var buttonStyle = {
	            width: this.props.width - paddingLeft,
	            height: this.props.height,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: paddingLeft,
	            backgroundColor: backgroundColor,
	            paddingTop: 0,
	            paddingBottom: 0,
	            paddingRight: 0,
	            margin: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            paddingLeft: 8,
	            fontSize: 14,
	            cursor: 'default',
	            top: 0
	        };
	
	        var tabIndexValue;
	
	        if (this.props.index == 7 && !_AnimationManager2.default.allowAnimation) {
	            buttonStyle.opacity = 0.3;
	            tabIndexValue = '-1';
	        }
	
	        var idValue;
	
	        if (this.props.isFirstElement) idValue = 'shapeMenuFirstElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, 'aria-label': this.props.text, tabIndex: tabIndexValue, 'aria-disabled': tabIndexValue == '-1' ? true : false, style: buttonStyle, onKeyDown: this.onKeyDown, onTouchEnd: this.onButtonClick, onClick: this.onButtonClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement('i', { className: this.props.src }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var ShapeMenuContent = _react2.default.createClass({
	    displayName: 'ShapeMenuContent',
	    isTextShape: function isTextShape(shapeModel) {
	        if (shapeModel.type == _ShapeConstants2.default.TEXTBOX || shapeModel.type == _ShapeConstants2.default.TEXTBOXSIMPLE || shapeModel.type == _ShapeConstants2.default.SPEAK_BUBBLE || shapeModel.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shapeModel.type == _ShapeConstants2.default.SCREAM_BUBBLE || shapeModel.type == _ShapeConstants2.default.THOUGHT_BUBBLE) return true;else return false;
	    },
	    isLocked: function isLocked() {
	        return this.props.contextTarget.isLocked;
	    },
	    correctPosition: function correctPosition(x, y, width, height) {
	        var newX;
	        var newY;
	        var leftLimit = this.props.scaleProperties.topX;
	        var rightLimit = this.props.scaleProperties.topX + this.props.scaleProperties.scale * _Configuration2.default.CANVAS_WIDTH;
	        var topLimit = this.props.scaleProperties.topY;
	        var bottomLimit = this.props.scaleProperties.topY + this.props.scaleProperties.scale * _Configuration2.default.CANVAS_HEIGHT;
	
	        if (x + width > rightLimit) newX = rightLimit - width;else if (x < leftLimit) newX = leftLimit;else newX = x;
	
	        if (y + height > bottomLimit) newY = bottomLimit - height;else if (y < topLimit) newY = topLimit;else newY = y;
	
	        return { x: newX, y: newY };
	    },
	    detectMenuPosition: function detectMenuPosition(shapeModel, width, height) {
	        var leftPosition;
	        var topPosition;
	        var scaleProperties = this.props.scaleProperties;
	        var scale = this.props.scaleProperties.scale;
	        var radius = _TransformToolUtils.uiProperties.RADIUS;
	
	        if (shapeModel.type == _ShapeConstants2.default.LINE || shapeModel.type == _ShapeConstants2.default.CURVE) {
	            var position1 = { left: scaleProperties.topX + shapeModel.x1 * scale + radius / 2, top: scaleProperties.topY + shapeModel.y1 * scale + radius / 2 };
	            var position2 = { left: scaleProperties.topX + shapeModel.x2 * scale + radius / 2, top: scaleProperties.topY + shapeModel.y2 * scale + radius / 2 };
	            var position;
	            var opositePosition;
	
	            var topLimit = scaleProperties.topY;
	            var leftLimit = scaleProperties.topX;
	            var rightLimit = leftLimit + _Configuration2.default.CANVAS_WIDTH * scale;
	            var bottomLimit = topLimit + _Configuration2.default.CANVAS_HEIGHT * scale;
	
	            if (shapeModel.x1 < shapeModel.x2) {
	                position = position2;
	                opositePosition = position1;
	            } else {
	                position = position1;
	                opositePosition = position2;
	            }
	
	            if (position.left > rightLimit || position.left < leftLimit || position.top < topLimit || position.top > bottomLimit) position = opositePosition;
	
	            leftPosition = position.left;
	            topPosition = position.top;
	        } else {
	            leftPosition = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scale;
	            topPosition = scaleProperties.topY + shapeModel.y * scale + radius;
	        }
	
	        var pos = this.correctPosition(leftPosition, topPosition, width, height);
	        return { x: pos.x, y: pos.y };
	    },
	    getTheme: function getTheme() {
	        var theme = this.props.contextTarget.theme;
	
	        if (theme != _AppParameters2.default.currentTheme) return theme;else return undefined;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.contextTarget != newProps.contextTarget || this.props.isShapeMenuVisible != newProps.isShapeMenuVisible) return true;else return false;
	    },
	    render: function render() {
	        var contextTarget = this.props.contextTarget;
	
	        if (this.props.mode == _ModeConstants2.default.PREVIEW || !contextTarget) return _react2.default.createElement('div', null);
	
	        var height = _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT * 5;
	        var theme = this.getTheme();
	
	        if (theme) height = height + _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT;
	
	        height = height + _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT; // image manipulation button ... SizeAndPositionMenu
	
	        if (contextTarget && (contextTarget.moods && contextTarget.moods.length > 1 || this.isTextShape(contextTarget) == true && contextTarget.type != _ShapeConstants2.default.TEXTBOXSIMPLE)) height = height + _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT;
	
	        if (contextTarget.type == _ShapeConstants2.default.GROUP) height = height + _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT;
	
	        if (contextTarget.type == _ShapeConstants2.default.CHARACTER || contextTarget.type == _ShapeConstants2.default.IMAGE || contextTarget.type == _ShapeConstants2.default.ELLIPSE || contextTarget.type == _ShapeConstants2.default.TRIANGLE || contextTarget.type == _ShapeConstants2.default.STAR || contextTarget.type == _ShapeConstants2.default.HEART) height = height + _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT;
	
	        if (contextTarget.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE) {
	            if (contextTarget.cx5 == undefined) height = height + _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT;
	
	            if (contextTarget.cx2 != undefined) height = height + _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT;
	        }
	
	        if (contextTarget.isRichText) // for old text shapes was a button for font properties and a button for fill/stroke ... now will be only one for TextEditorTool
	            height = height - _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT;
	
	        var isMindMapType = _MindMapUtils2.default.isMindMapType(contextTarget);
	
	        if (isMindMapType) // COPY and ANIMATION options should be available for the mindMap or mindMap nodes
	            height = height - 2 * _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT;
	
	        var width = _Properties2.default.SHAPE_MENU_WIDTH;
	
	        var leftPosition = 0;
	        var topPosition = 0;
	        var visibility;
	
	        if (contextTarget && this.props.isShapeMenuVisible == true) {
	            visibility = 'block';
	
	            var position = this.detectMenuPosition(contextTarget, width, height);
	            leftPosition = position.x;
	            topPosition = position.y;
	        } else visibility = 'none';
	
	        if (contextTarget.type === _ShapeConstants2.default.VIDEO) height = _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT;
	
	        var menuStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            top: topPosition,
	            left: leftPosition,
	            display: visibility,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderColor: _Properties2.default.MENUS_BORDER_COLOR,
	            userSelect: 'none',
	            WebkitUserSelect: 'none'
	        };
	
	        var lineStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.MENUS_BORDER_COLOR,
	            height: 1,
	            width: width
	        };
	
	        var elements = [];
	        var foundFirstElement = false;
	        var firstElementValue = false;
	
	        // SizeAndPositionMenu
	        firstElementValue = !foundFirstElement ? true : false;
	        foundFirstElement = true;
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, isFirstElement: firstElementValue, index: 14, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('SizeAndPosition', 'shapeMenu'), src: 'fa fa-arrows-alt', key: 'shapesMenu16' }));
	
	        if (contextTarget.isRichText) {
	            firstElementValue = !foundFirstElement ? true : false;
	            foundFirstElement = true;
	
	            elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, isFirstElement: firstElementValue, index: 13, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('EditText', 'shapeMenu'), src: 'fa fa-font', key: 'shapesMenu13' }));
	        }
	
	        if (contextTarget && contextTarget.moods && contextTarget.moods.length > 1) {
	            firstElementValue = !foundFirstElement ? true : false;
	            foundFirstElement = true;
	
	            elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, isFirstElement: firstElementValue, index: 0, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('Moods', 'shapeMenu'), src: 'fa fa-smile-o', key: 'shapesMenu0' }));
	        }
	
	        if (!isMindMapType) {
	            elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 1, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('Duplicate', 'shapeMenu'), src: 'fa fa-files-o', key: 'shapesMenu1' }));
	            elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 7, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('Animation', 'shapeMenu'), src: 'fa fa-certificate', key: 'shapesMenu7' }));
	        }
	
	        if (contextTarget.type == _ShapeConstants2.default.CHARACTER || contextTarget.type == _ShapeConstants2.default.IMAGE || contextTarget.type == _ShapeConstants2.default.ELLIPSE || contextTarget.type == _ShapeConstants2.default.TRIANGLE || contextTarget.type == _ShapeConstants2.default.STAR || contextTarget.type == _ShapeConstants2.default.HEART) {
	            elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 10, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('Masking', 'other'), src: 'fa fa-crop', key: 'shapesMenu10' }));
	        }
	
	        if (contextTarget.type != _ShapeConstants2.default.TEXTBOXSIMPLE && !contextTarget.isRichText) // Border/Fill styling
	            elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 3, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('Styling', 'shapeMenu'), src: 'fa fa-paint-brush', key: 'shapesMenu3' }));
	
	        if (this.isTextShape(contextTarget) == true && !contextTarget.isRichText) // font styling for old text shapes
	            elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 4, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('TextStyling', 'shapeMenu'), src: 'fa fa-font', key: 'shapesMenu4' }));
	
	        if (contextTarget.type == _ShapeConstants2.default.GROUP) elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 8, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('Ungroup', 'shapeMenu'), src: 'fa fa-object-ungroup', key: 'shapesMenu8' }));
	
	        if (contextTarget.type == _ShapeConstants2.default.BACKGROUND || contextTarget.type == _ShapeConstants2.default.CHARACTER || contextTarget.type == _ShapeConstants2.default.IMAGE) {
	            if (theme) {
	                elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 9, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('Theme', 'other'), src: 'fa fa-magic', key: 'shapesMenu9' }));
	            }
	        }
	
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 5, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('Advanced', 'shapeMenu'), src: 'fa fa-cog', key: 'shapesMenu6' }));
	
	        if (contextTarget.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE) {
	            if (contextTarget.cx5 == undefined) elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 11, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('AddStem', 'shapeMenu'), src: 'fa fa-plus', key: 'shapesMenu11' }));
	
	            if (contextTarget.cx2 != undefined) elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 12, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('DeleteStem', 'shapeMenu'), src: 'fa fa-minus', key: 'shapesMenu12' }));
	        }
	
	        elements.push(_react2.default.createElement('div', { style: lineStyle, key: 'shapesMenu5' }));
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 2, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('Delete', 'shapeMenu'), src: 'fa fa-trash-o', key: 'shapesMenu2' }));
	
	        var display = 'none';
	
	        if (this.isLocked() == true) display = 'block';
	
	        var disabledAreaStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: width,
	            height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT * (elements.length - 3),
	            background: 'white',
	            opacity: 0.5,
	            display: display
	        };
	
	        if (contextTarget.type === _ShapeConstants2.default.VIDEO) {
	            elements = [];
	
	            elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, isFirstElement: true, index: 2, width: width, height: _Properties2.default.SHAPE_MENU_BUTTON_HEIGHT, contextTarget: this.props.contextTarget, text: _LocalesManager2.default.getCaption('Delete', 'shapeMenu'), src: 'fa fa-trash-o', key: 'shapesMenu2' }));
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            elements,
	            _react2.default.createElement('div', { style: disabledAreaStyle })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var contextTarget = state.menu.contextTarget;
	    var isShapeMenuVisible = state.menu.isShapeMenuVisible;
	
	    return {
	        contextTarget: contextTarget,
	        isShapeMenuVisible: isShapeMenuVisible
	    };
	}
	
	var ShapeMenu = exports.ShapeMenu = (0, _reactRedux.connect)(mapStateToProps)(ShapeMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ShapeMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ShapeMenu.js"); } } })();

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ShapeMenuButton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MenuActions = __webpack_require__(7);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShapeMenuButtonContent = _react2.default.createClass({
	    displayName: 'ShapeMenuButtonContent',
	    getInitialState: function getInitialState() {
	        return {
	            isMenuButtonOver: false
	        };
	    },
	    onMenuButtonMouseIn: function onMenuButtonMouseIn() {
	        _HoverManager2.default.show(this.refs.shapeMenuButton, 'editShape');
	
	        this.setState({
	            isMenuButtonOver: true
	        });
	    },
	    onMenuButtonMouseOut: function onMenuButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isMenuButtonOver: false
	        });
	    },
	    onOpenMenu: function onOpenMenu(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlatformDetection2.default.isTouchableDevice() == true) {
	            document.activeElement.blur();
	        }
	
	        if (!document.getElementById('htmlColorPicker')) e.preventDefault();
	
	        _TextEditorUtils2.default.closeTextEditor();
	
	        var dispatch = this.props.dispatch;
	        var shapeModel = this.getSelectedShape();
	        dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	        dispatch((0, _MenuActions.setContextTarget)(shapeModel));
	    },
	    getSelectedShape: function getSelectedShape() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	        var target;
	
	        if (!shapes) return target;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].isSelected == true) {
	                target = shapes[i];
	                break;
	            }
	        }return target;
	    },
	    getShapePosition: function getShapePosition(shapeModel) {
	        var scaleProperties = this.props.scaleProperties;
	        var position = { left: 0, top: 0 };
	        var radius = _TransformToolUtils.uiProperties.RADIUS;
	        var buttonSize = _Properties2.default.SHAPE_MENU_BUTTON_SIZE;
	        var scale = scaleProperties.scale;
	
	        if (shapeModel.type == _ShapeConstants2.default.LINE || shapeModel.type == _ShapeConstants2.default.CURVE) {
	            var position1 = { left: scaleProperties.topX + shapeModel.x1 * scale + radius / 2, top: scaleProperties.topY + shapeModel.y1 * scale + radius / 2 };
	            var position2 = { left: scaleProperties.topX + shapeModel.x2 * scale + radius / 2, top: scaleProperties.topY + shapeModel.y2 * scale + radius / 2 };
	            var opositePosition;
	
	            var topLimit = scaleProperties.topY;
	            var leftLimit = scaleProperties.topX;
	            var rightLimit = leftLimit + _Configuration2.default.CANVAS_WIDTH * scale;
	            var bottomLimit = topLimit + _Configuration2.default.CANVAS_HEIGHT * scale;
	
	            if (shapeModel.x1 < shapeModel.x2) {
	                position = position2;
	                opositePosition = position1;
	            } else {
	                position = position1;
	                opositePosition = position2;
	            }
	
	            if (position.left > rightLimit || position.left < leftLimit || position.top < topLimit || position.top > bottomLimit) position = opositePosition;
	
	            return position;
	        }
	
	        //if (shapeModel.rotation > 0) {
	        //    position.left = scaleProperties.topX  + (shapeModel.x  + shapeModel.width / 2) * scale - buttonSize / 2;
	        //    position.top = scaleProperties.topY + (shapeModel.y + shapeModel.height / 2) * scale - buttonSize / 2;
	        //
	        //    return position;
	        //}
	
	        var offset = 12;
	
	        if (_PlatformDetection2.default.isIOS()) offset = 20;
	
	        if (shapeModel.width > _Configuration2.default.CANVAS_WIDTH && shapeModel.height > _Configuration2.default.CANVAS_HEIGHT) {
	            position.left = scaleProperties.topX + _Configuration2.default.CANVAS_WIDTH * scale - buttonSize;
	            position.top = scaleProperties.topY;
	        } else if (shapeModel.y < 0 && shapeModel.y + shapeModel.height > _Configuration2.default.CANVAS_HEIGHT) {
	            if (shapeModel.x + shapeModel.width + buttonSize > _Configuration2.default.CANVAS_WIDTH) // move to TopLeft
	                position.left = scaleProperties.topX + shapeModel.x * scale - buttonSize - offset;else position.left = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scaleProperties.scale + offset;
	        } else {
	            if (shapeModel.y < 0 && shapeModel.x + shapeModel.width + buttonSize > _Configuration2.default.CANVAS_WIDTH) {
	                // move to BottomLeft
	                position.left = scaleProperties.topX + shapeModel.x * scale - buttonSize - offset;
	                position.top = scaleProperties.topY + (shapeModel.y + shapeModel.height) * scale - radius - buttonSize;
	            } else if (shapeModel.y < 0) {
	                // move to BottomRight
	                position.left = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scale + offset;
	                position.top = scaleProperties.topY + (shapeModel.y + shapeModel.height) * scale - radius - buttonSize;
	            } else if (shapeModel.x + shapeModel.width + buttonSize > _Configuration2.default.CANVAS_WIDTH) {
	                // move to TopLeft
	                position.left = scaleProperties.topX + shapeModel.x * scale - buttonSize - offset;
	                position.top = scaleProperties.topY + shapeModel.y * scale + radius;
	            } else {
	                // move to TopRight (Normal)
	                position.left = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scale + offset;
	                position.top = scaleProperties.topY + shapeModel.y * scale + radius;
	            }
	        }
	
	        if (position.left < scaleProperties.topX) position.left = scaleProperties.topX + offset;
	
	        if (position.left > scaleProperties.topX + _Configuration2.default.CANVAS_WIDTH * scale - buttonSize - offset) position.left = scaleProperties.topX + _Configuration2.default.CANVAS_WIDTH * scale - buttonSize - offset;
	
	        if (position.top < scaleProperties.topY) position.top = scaleProperties.topY + offset;
	
	        if (position.top > scaleProperties.topY + _Configuration2.default.CANVAS_HEIGHT * scale - buttonSize - offset) position.top = scaleProperties.topY + _Configuration2.default.CANVAS_HEIGHT * scale - buttonSize - offset;
	
	        return position;
	    },
	    render: function render() {
	        var shapeModel = this.getSelectedShape();
	
	        if (shapeModel == undefined || shapeModel.isInteraction == true || _SelectionManager2.default.multipleSelection() == true || _AnimationManager2.default.clone) return _react2.default.createElement('div', null);
	
	        var menuButtonFrameColor;
	
	        if (this.state.isMenuButtonOver == true) menuButtonFrameColor = _Properties2.default.SLIDE_FRAME_HOVER_COLOR;else menuButtonFrameColor = 'black';
	
	        var position = this.getShapePosition(shapeModel);
	
	        var menuButtonStyle = {
	            position: 'absolute',
	            top: position.top,
	            left: position.left,
	            width: _Properties2.default.SLIDE_MENU_BUTTON_SIZE,
	            height: _Properties2.default.SLIDE_MENU_BUTTON_SIZE,
	            background: 'white',
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderColor: menuButtonFrameColor,
	            borderRadius: 3,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var menuButtonIconStyle = {
	            position: 'absolute',
	            top: 7,
	            left: 9,
	            color: menuButtonFrameColor
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { id: 'shapeMenuButton', className: 'menuButton', 'aria-label': _LocalesManager2.default.getCaption('editShape', 'hover'), style: menuButtonStyle, onTouchEnd: this.onOpenMenu, ref: 'shapeMenuButton', onClick: this.onOpenMenu, onMouseOver: this.onMenuButtonMouseIn, onMouseOut: this.onMenuButtonMouseOut },
	            _react2.default.createElement('i', { style: menuButtonIconStyle, className: 'fa fa-bars menuButton' })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var slideModel = state.currentSlide.model;
	
	    return {
	        slideModel: slideModel
	    };
	}
	
	var ShapeMenuButton = exports.ShapeMenuButton = (0, _reactRedux.connect)(mapStateToProps)(ShapeMenuButtonContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ShapeMenuButton.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ShapeMenuButton.js"); } } })();

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SizeAndPositionMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _RotationView = __webpack_require__(812);
	
	var _PositionView = __webpack_require__(806);
	
	var _ResizeView = __webpack_require__(811);
	
	var _FlipView = __webpack_require__(788);
	
	var _SizeAndPositionButtons = __webpack_require__(92);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _PositionViewLineAndCurve = __webpack_require__(807);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SELECTED_VIEW_POSITION = 'selected_view_position';
	var SELECTED_VIEW_ROTATION = 'selected_view_rotation';
	var SELECTED_VIEW_SIZE = 'selected_view_size';
	var SELECTED_VIEW_FLIP = 'selected_view_flip';
	
	/*
	TODO after uu:
	- Reintroduce curve
	- Reintroduce complex bubbles
	    - Complex bubbles: Add support for speech bubble arrow position
	    - Complex bubbles: Make flip horizontally work for figures and speech bubbles
	- Add back slider for slide duration
	- Add sliders to some of the new menu inputs (for instance opacity)
	 */
	var SizeAndPositionMenu = exports.SizeAndPositionMenu = _react2.default.createClass({
	    displayName: 'SizeAndPositionMenu',
	    getInitialState: function getInitialState() {
	        return {
	            selectedViewType: SELECTED_VIEW_POSITION,
	            key: 0
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('resizeFirstItem');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    onCloseClick: function onCloseClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    onClickButton: function onClickButton(type) {
	        this.setState({
	            selectedViewType: type
	        });
	    },
	    render: function render() {
	        var mainHolderSytle = {
	            height: '100%',
	            overflowX: 'hidden',
	            overflowY: 'auto'
	        };
	
	        var titleStyle = {
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var caption = _LocalesManager2.default.getCaption('SizeAndPositionTitle', 'shapeMenu');
	
	        var headingStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: '-6px'
	        };
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            right: 28,
	            top: 4,
	            width: 22,
	            height: 22,
	            cursor: 'pointer',
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            background: 'none',
	            borderStyle: 'none',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 3,
	            right: 3,
	            cursor: 'pointer'
	        };
	
	        var wrapperStyle = {
	            margin: '4%'
	        };
	
	        var buttonWrapperStyle = {
	            display: 'flex',
	            flexWrap: 'wrap',
	            marginTop: '10px',
	            justifyContent: 'space-between'
	        };
	
	        var isNonRectangular = this.props.contextTarget.type == _ShapeConstants2.default.LINE || this.props.contextTarget.type == _ShapeConstants2.default.CURVE;
	        var isComplexSpeechBubble = this.props.contextTarget.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE;
	
	        return _react2.default.createElement(
	            'div',
	            { key: this.state.key, id: 'sizeAndPositionMenu', style: mainHolderSytle },
	            _react2.default.createElement(
	                'div',
	                { style: titleStyle },
	                _react2.default.createElement(
	                    'h2',
	                    { style: headingStyle },
	                    caption
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { id: 'resizeFirstItem', style: closeButtonStyle, 'aria-label': _LocalesManager2.default.getCaption('close', 'other'), onClick: this.onCloseClick, onTouchStart: this.onCloseClick },
	                    _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	                )
	            ),
	            isNonRectangular == false ? _react2.default.createElement(
	                'div',
	                { style: wrapperStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: buttonWrapperStyle },
	                    _react2.default.createElement(_SizeAndPositionButtons.PrimaryMenuButton, { clickHandler: this.onClickButton, type: SELECTED_VIEW_POSITION, isSelected: this.state.selectedViewType === SELECTED_VIEW_POSITION, caption: _LocalesManager2.default.getCaption('Position', 'sizePosMenu') }),
	                    _react2.default.createElement(_SizeAndPositionButtons.PrimaryMenuButton, { clickHandler: this.onClickButton, type: SELECTED_VIEW_ROTATION, isSelected: this.state.selectedViewType === SELECTED_VIEW_ROTATION, caption: _LocalesManager2.default.getCaption('Rotation', 'sizePosMenu') }),
	                    _react2.default.createElement(_SizeAndPositionButtons.PrimaryMenuButton, { clickHandler: this.onClickButton, type: SELECTED_VIEW_SIZE, isSelected: this.state.selectedViewType === SELECTED_VIEW_SIZE, caption: _LocalesManager2.default.getCaption('Size', 'sizePosMenu') }),
	                    !isComplexSpeechBubble ? _react2.default.createElement(_SizeAndPositionButtons.PrimaryMenuButton, { clickHandler: this.onClickButton, type: SELECTED_VIEW_FLIP, isSelected: this.state.selectedViewType === SELECTED_VIEW_FLIP, caption: _LocalesManager2.default.getCaption('Reflect', 'sizePosMenu') }) : null
	                ),
	                this.state.selectedViewType === SELECTED_VIEW_POSITION ? _react2.default.createElement(_PositionView.PositionView, { shapeModel: this.props.contextTarget, dispatch: this.props.dispatch }) : null,
	                this.state.selectedViewType === SELECTED_VIEW_ROTATION ? _react2.default.createElement(_RotationView.RotationView, { shapeModel: this.props.contextTarget, dispatch: this.props.dispatch }) : null,
	                this.state.selectedViewType === SELECTED_VIEW_SIZE ? _react2.default.createElement(_ResizeView.ResizeView, { shapeModel: this.props.contextTarget, dispatch: this.props.dispatch }) : null,
	                this.state.selectedViewType === SELECTED_VIEW_FLIP ? _react2.default.createElement(_FlipView.FlipView, { shapeModel: this.props.contextTarget, dispatch: this.props.dispatch }) : null
	            ) : null,
	            isNonRectangular == true ? _react2.default.createElement(
	                'div',
	                { style: wrapperStyle },
	                _react2.default.createElement(_PositionViewLineAndCurve.PositionViewLineAndCurve, { shapeModel: this.props.contextTarget, dispatch: this.props.dispatch })
	            ) : null
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SizeAndPositionMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SizeAndPositionMenu.js"); } } })();

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SlideMenu = exports.SlideMenuContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _SlideViewerActions = __webpack_require__(121);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MenuActions = __webpack_require__(7);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onButtonClick: function onButtonClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // change moods
	                    this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.SLIDE_CONTEXT_MOODS));
	                    break;
	                }
	
	            case 1:
	                {
	                    //duplicate slide
	                    var state = _StoreManager2.default.getState();
	
	                    this.props.dispatch((0, _CurrentSlideActions.selectShape)('slideFocus'));
	                    this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	                    this.props.dispatch((0, _ProductionActions.duplicateSlide)());
	                    this.props.dispatch((0, _CurrentSlideActions.setCurrentSlide)(state.currentSlide.currentSlideIndex + 1));
	                    this.props.dispatch((0, _SlideViewerActions.needsRefresh)(true));
	                    _AudioEditorUtils2.default.addActionToHistory();
	                    _AudioEditorUtils2.default.checkMarkerPositionForCurrentSlide();
	                    _AudioEditorUtils2.default.checkTimelineWidth(true);
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	
	            case 7:
	                {
	                    //duplicate slide at the end of animations
	                    var _state = _StoreManager2.default.getState();
	
	                    this.props.dispatch((0, _CurrentSlideActions.selectShape)('slideFocus'));
	                    this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	                    this.props.dispatch((0, _ProductionActions.duplicateSlideAtEndOfAnimation)());
	                    this.props.dispatch((0, _CurrentSlideActions.setCurrentSlide)(_state.currentSlide.currentSlideIndex + 1));
	                    this.props.dispatch((0, _SlideViewerActions.needsRefresh)(true));
	                    _AudioEditorUtils2.default.addActionToHistory();
	                    _AudioEditorUtils2.default.checkMarkerPositionForCurrentSlide();
	                    _AudioEditorUtils2.default.checkTimelineWidth(true);
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	
	            case 2:
	                {
	                    // delete slide
	                    this.props.dispatch((0, _CurrentSlideActions.selectShape)('slideFocus'));
	                    this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	                    _SaveManager2.default.isContentChanged(true);
	
	                    if (this.isBlankSlide() == true) {
	                        var _state2 = _StoreManager2.default.getState();
	                        var slides = _state2.production.slides;
	                        var newSlideIndex = void 0;
	
	                        if (slides.length == 1) {
	                            newSlideIndex = 0;
	                        } else {
	                            if (slides.length - 1 == _state2.currentSlide.currentSlideIndex) newSlideIndex = _state2.currentSlide.currentSlideIndex - 1;else newSlideIndex = _state2.currentSlide.currentSlideIndex;
	                        }
	
	                        this.props.dispatch((0, _ProductionActions.deleteSlide)());
	                        this.props.dispatch((0, _CurrentSlideActions.setCurrentSlide)(newSlideIndex));
	                        this.props.dispatch((0, _SlideViewerActions.needsRefresh)(true));
	                        _AudioEditorUtils2.default.addActionToHistory();
	                        _AudioEditorUtils2.default.checkMarkerPositionForCurrentSlide();
	                        _AudioEditorUtils2.default.checkTimelineWidth(true);
	                    } else {
	                        this.props.dispatch((0, _MenuActions.showDeleteAlert)(true));
	                    }
	
	                    break;
	                }
	
	            case 3:
	                {
	                    // change style
	                    this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.SLIDE_CONTEXT_STYLING));
	                    break;
	                }
	
	            case 4:
	                {
	                    // Zoom slide
	                    this.props.dispatch((0, _CurrentSlideActions.selectShape)(''));
	                    this.props.dispatch((0, _MenuActions.showZoomSlides)(true));
	                    break;
	                }
	
	            case 5:
	                {
	                    // Edit video
	                    var video = document.getElementById('videoBackground');
	                    var videoSrc = video ? video.currentSrc : undefined;
	
	                    _VideoUtils2.default.changeToVideoEditorMode(videoSrc);
	                    _HoverManager2.default.hide();
	                    break;
	                }
	
	            case 6:
	                {
	                    // Audio
	                    _PlayController2.default.checkAudioEditorModeWhenOpenAudioMenus(1);
	                    break;
	                }
	
	            case 8:
	                {
	                    // No Background
	                    var newContent = {};
	                    newContent.logicalName = '';
	                    newContent.href = '';
	                    newContent.moods = [];
	                    newContent.orgWidth = 0;
	                    newContent.orgHeight = 0;
	                    newContent.isVideo = false;
	                    newContent.volume = 0.5;
	                    newContent.inPoint = undefined;
	                    newContent.outPoint = undefined;
	                    newContent.fill = '#ffffff';
	                    newContent.fillOpacity = 1;
	                    newContent.stroke = '#ffffff';
	                    newContent.strokeOpacity = 0;
	                    newContent.frameLabel = '';
	
	                    this.props.dispatch((0, _CurrentSlideActions.changeBackgroundContent)(newContent));
	                    _CreateShapes2.default.updateThumbnail(this.props.dispatch);
	                    _AudioEditorUtils2.default.addActionToHistory();
	                    _SaveManager2.default.isContentChanged(true);
	
	                    if (_PlatformDetection2.default.isEdge()) {
	                        // CH-457: force to redraw again ... the second time works fine.
	                        setTimeout(function () {
	                            _CreateShapes2.default.updateThumbnail(this.props.dispatch);
	                        }.bind(this), 300);
	                    }
	                    break;
	                }
	
	            case 9:
	                {
	                    // Go to theme
	                    _MasterUniverseUtils2.default.goToTheme(this.props.theme);
	
	                    break;
	                }
	
	            case 10:
	                {
	                    // Alternative text
	                    this.props.dispatch((0, _MenuActions.showAlternativeTextMenu)(true));
	
	                    break;
	                }
	
	            case 11:
	                {
	                    // Background opacity
	                    this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.SLIDE_VISIBILITY));
	
	                    break;
	                }
	        }
	    },
	    isBlankSlide: function isBlankSlide() {
	        var state = _StoreManager2.default.getState();
	        var currentSlide = state.currentSlide;
	        var shapes = currentSlide.model.content;
	
	        if (shapes.length > 1) // there are a few shapes on canvas
	            return false;else {
	            var background = shapes[0];
	
	            if (background.strokeOpacity > 0 && background.strokeWidth > 0 || background.logicalName && background.logicalName != '' || background.frameLabel && background.frameLabel != '' || background.fill && background.fill != '#ffffff') return false;else return true;
	        }
	    },
	    render: function render() {
	        var backgroundColor = void 0;
	
	        if (this.state.isOver == true) {
	            backgroundColor = _Properties2.default.BROWSER_HOVER_COLOR;
	        } else {
	            backgroundColor = _Properties2.default.SLIDE_MENU_COLOR;
	        }
	
	        var paddingLeft = 10;
	
	        var buttonStyle = {
	            width: this.props.width - paddingLeft,
	            height: this.props.height,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: paddingLeft,
	            backgroundColor: backgroundColor,
	            paddingTop: 0,
	            paddingBottom: 0,
	            paddingRight: 0,
	            margin: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            paddingLeft: 8,
	            fontSize: 14,
	            cursor: 'default',
	            top: 0
	        };
	        var buttonId = undefined;
	
	        if (this.props.index == 1) buttonId = 'duplicateSlideButton';else if (this.props.index == 2) buttonId = 'deleteSlideButton';
	
	        return _react2.default.createElement(
	            'button',
	            { id: buttonId, 'aria-label': this.props.text, style: buttonStyle, onTouchEnd: this.onButtonClick, onClick: this.onButtonClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement('i', { className: this.props.src }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var SlideMenuContent = exports.SlideMenuContent = _react2.default.createClass({
	    displayName: 'SlideMenuContent',
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.slideMenuLeftPosition != nextProps.slideMenuLeftPosition && this.props.slideMenuLeftPosition < 0) {
	            if (_PlatformDetection2.default.isIOS()) return;
	
	            setTimeout(function () {
	                var firstButton = document.getElementById('duplicateSlideButton');
	
	                if (firstButton) firstButton.focus();
	            }.bind(this), 10);
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('keydown', this.onKeyDownHandler);
	    },
	    onKeyDownHandler: function onKeyDownHandler(e) {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
	
	        if (!isTabPressed) return;
	
	        var firstFocusableEl = document.getElementById('duplicateSlideButton');
	        var lastFocusableEl = document.getElementById('deleteSlideButton');
	        var slideMenuButton = document.getElementById('slideMenuButton_' + this.props.currentSlideIndex);
	
	        if (!firstFocusableEl || !lastFocusableEl || !slideMenuButton) return;
	
	        if (e.shiftKey) /* shift + tab */{
	                if (document.activeElement === firstFocusableEl) {
	                    slideMenuButton.focus();
	                    e.preventDefault();
	                }
	            } else /* tab */{
	                if (document.activeElement === lastFocusableEl) {
	                    slideMenuButton.focus();
	                    e.preventDefault();
	                }
	            }
	    },
	    hasMoods: function hasMoods() {
	        var state = _StoreManager2.default.getState();
	
	        if (!state.currentSlide || !state.currentSlide.model || !state.currentSlide.model.content) return false;
	
	        var background = state.currentSlide.model.content[0];
	
	        if (background && background.moods && background.moods.length > 1) return true;else return false;
	    },
	    isVideo: function isVideo() {
	        var state = _StoreManager2.default.getState();
	        var background = state.currentSlide.model.content[0];
	
	        if (background && background.isVideo) return true;else return false;
	    },
	    hasLogicalName: function hasLogicalName() {
	        var state = _StoreManager2.default.getState();
	        var background = state.currentSlide.model.content[0];
	
	        if (background.isVideo) return false;
	
	        if (background && background.xlinkHref && background.xlinkHref.length > 1) return true;else return false;
	    },
	    getTheme: function getTheme() {
	        var state = _StoreManager2.default.getState();
	        var background = state.currentSlide.model.content[0];
	
	        if (background.theme) {
	            if (background.theme != _AppParameters2.default.currentTheme) return background.theme;else return undefined;
	        } else return undefined;
	    },
	    isBlankSlide: function isBlankSlide() {
	        var state = _StoreManager2.default.getState();
	        var currentSlide = state.currentSlide;
	        var shapes = currentSlide.model.content;
	
	        var background = shapes[0];
	
	        if (background.strokeOpacity > 0 && background.strokeWidth > 0 || background.logicalName && background.logicalName != '' || background.frameLabel && background.frameLabel != '' || background.fill && background.fill != '#ffffff') return false;else return true;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.slideMenuLeftPosition != newProps.slideMenuLeftPosition) return true;else return false;
	    },
	    render: function render() {
	        var isAnimatedSlide = _AnimationManager2.default.isAnimatedSlide();
	        var isBlank = this.isBlankSlide();
	        var width = _Properties2.default.SLIDE_MENU_WIDTH * 2;
	        var height = void 0;
	        var theme = this.getTheme();
	
	        if (isAnimatedSlide) width = _Properties2.default.SLIDE_MENU_WIDTH * 3;else {
	            if (!isBlank) width = _Properties2.default.SLIDE_MENU_WIDTH * 2;
	        }
	
	        if (this.hasMoods() == true && this.hasLogicalName() == true) {
	            height = _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT * 6;
	        } else if (this.hasMoods() || this.hasLogicalName() || this.isVideo()) {
	            height = _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT * 5;
	        } else {
	            height = _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT * 4;
	        }
	
	        if (isAnimatedSlide) height = height + _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT;
	
	        if (!isBlank) height = height + _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT;
	
	        if (theme) height = height + _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT;
	
	        height = height + _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT; // alternative text button
	        height = height + _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT; // background opacity
	
	        var leftPosition = 0;
	        var visibility;
	
	        if (this.props.slideMenuLeftPosition > 0) {
	            visibility = 'block';
	            leftPosition = this.props.slideMenuLeftPosition;
	        } else visibility = 'none';
	
	        var menuStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            top: -height + _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT + _Properties2.default.SLIDE_VIEWER_TOP_GAP - 2,
	            left: leftPosition - 1,
	            display: visibility,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderColor: _Properties2.default.MENUS_BORDER_COLOR,
	            userSelect: 'none',
	            WebkitUserSelect: 'none'
	        };
	
	        var elements = [];
	
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 1, width: width, height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT, text: _LocalesManager2.default.getCaption('Duplicate', 'shapeMenu'), src: 'fa fa-files-o', key: 'slideMenu1' }));
	
	        if (this.hasMoods()) elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 0, width: width, height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT, text: _LocalesManager2.default.getCaption('Mode', 'shapeMenu'), src: 'fa fa-smile-o', key: 'slideMenu0' }));
	
	        if (this.isVideo()) elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 5, width: width, height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT, text: _LocalesManager2.default.getCaption('EditVideo', 'shapeMenu'), src: 'fa fa-pencil', key: 'slideMenu5' }));
	
	        if (isAnimatedSlide) elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 7, width: width, height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT, text: _LocalesManager2.default.getCaption('DuplicateForAnimations', 'shapeMenu'), src: 'fa fa-files-o', key: 'slideMenu7' }));
	
	        if (this.hasLogicalName() == true) elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 4, width: width, height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT, text: _LocalesManager2.default.getCaption('Zoom', 'shapeMenu'), src: 'fa fa-search', key: 'slideMenu4' }));
	
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 6, width: width, height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT, text: _LocalesManager2.default.getCaption('Audio', 'shapeMenu'), src: 'fa fa-music', key: 'slideMenu6' }));
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 3, width: width, height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT, text: _LocalesManager2.default.getCaption('Styling', 'shapeMenu'), src: 'fa fa-paint-brush', key: 'slideMenu3' }));
	
	        if (this.hasLogicalName() == true) elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 11, width: width, height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT, text: _LocalesManager2.default.getCaption('BackgroundVisibility', 'shapeMenu'), src: 'fa fa-adjust', key: 'slideMenu21' }));
	
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 10, width: width, height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT, text: _LocalesManager2.default.getCaption('AlternativeText', 'shapeMenu'), src: 'fa fa-commenting', key: 'slideMenu20' }));
	
	        if (!isBlank) {
	            elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 8, width: width, height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT, text: _LocalesManager2.default.getCaption('ClearBackground', 'shapeMenu'), src: 'fa fa-eraser', key: 'slideMenu8' }));
	
	            if (theme) {
	                elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, theme: theme, index: 9, width: width, height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT, text: _LocalesManager2.default.getCaption('Theme', 'other'), src: 'fa fa-magic', key: 'slideMenu9' }));
	            }
	        }
	
	        elements.push(_react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 2, width: width, height: _Properties2.default.SLIDE_MENU_BUTTON_HEIGHT, text: _LocalesManager2.default.getCaption('Delete', 'shapeMenu'), src: 'fa fa-trash-o', key: 'slideMenu2' }));
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            elements
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var slideMenuLeftPosition = state.menu.slideMenuLeftPosition;
	    var currentSlideIndex = state.currentSlide.currentSlideIndex;
	
	    return {
	        slideMenuLeftPosition: slideMenuLeftPosition,
	        currentSlideIndex: currentSlideIndex
	    };
	}
	
	var SlideMenu = exports.SlideMenu = (0, _reactRedux.connect)(mapStateToProps)(SlideMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SlideMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SlideMenu.js"); } } })();

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SlideSoundsBrowser = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _PopulateMediaFilesUtils = __webpack_require__(80);
	
	var _PopulateMediaFilesUtils2 = _interopRequireDefault(_PopulateMediaFilesUtils);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _MediaSoundsList = __webpack_require__(802);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _MusicActions = __webpack_require__(91);
	
	var _AudioCategorySelectorNew = __webpack_require__(169);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MenuActions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    this.props.dispatch((0, _MusicActions.changeSlideAudioIndex)(0));
	                    break;
	                }
	
	            case 1:
	                {
	                    this.props.dispatch((0, _MusicActions.changeSlideAudioIndex)(1));
	                    break;
	                }
	        }
	
	        this.props.dispatch((0, _MenuActions.expandAudioList)(false, this.props.type));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.category != newProps.category || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var iconColor;
	        var buttonColor;
	        var effectsSelected = false;
	
	        if (this.props.category == 0) effectsSelected = true;
	
	        if (this.props.index == 0) {
	            // Effects button
	            if (effectsSelected == true) {
	                iconColor = 'white';
	                buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            } else {
	                if (this.state.isOver == true) {
	                    iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                    buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	                } else {
	                    iconColor = 'black';
	                    buttonColor = '#D7D7D7';
	                }
	            }
	        } else {
	            // My sounds button
	            if (effectsSelected == false) {
	                iconColor = 'white';
	                buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            } else {
	                if (this.state.isOver == true) {
	                    iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                    buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	                } else {
	                    iconColor = 'black';
	                    buttonColor = '#D7D7D7';
	                }
	            }
	        }
	
	        var topPosition = 0;
	        var left = this.props.index == 0 ? 0 : this.props.accordionWidth / 2;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth / 2 - 2,
	            height: _Properties2.default.BROWSER_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            left: left,
	            top: topPosition,
	            color: 'white',
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#FFFFFF',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            width: buttonStyle.width - 2 * 5,
	            fontSize: 15,
	            position: 'absolute',
	            left: 5,
	            top: 6,
	            whiteSpace: 'nowrap',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            textAlign: 'center'
	        };
	
	        var text = this.props.text;
	
	        if (this.props.index == 0) {
	            text = _LocalesManager2.default.getCaption('SoundEffects', 'music');
	        } else {
	            text = _LocalesManager2.default.getCaption('MySoundsContent', 'music');
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': text, style: buttonStyle, onClick: this.onClick, onTouchStart: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            )
	        );
	    }
	});
	
	var SlideSoundsBrowserContent = _react2.default.createClass({
	    displayName: 'SlideSoundsBrowserContent',
	    componentDidMount: function componentDidMount() {
	        var dataProvider = this.props.mediaFilesDataProvider;
	
	        if (dataProvider != undefined) {
	            return;
	        }
	
	        if (_Configuration2.default.LOAD_LOCAL == true) {
	            // FOR TEST
	            this.props.dispatch((0, _AccordionActions.setMediaFilesDataProvider)({ imagesDataProvider: _PopulateMediaFilesUtils2.default.getImagesDataProviderForTest(), soundsDataProvider: _PopulateMediaFilesUtils2.default.getSoundsDataProviderForTest() }));
	        } else {
	            _ApiServiceUtils2.default.executeSafeApiCall(this.loadMyMediaFiles.bind(this));
	        }
	    },
	    loadMyMediaFiles: function loadMyMediaFiles() {
	        _ApiServiceUtils2.default.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
	    },
	    parseMediaItems: function parseMediaItems(items) {
	        _PopulateMediaFilesUtils2.default.parseMediaItems(items, this.props.dispatch, true);
	    },
	    getDataProvider: function getDataProvider() {
	        if (this.props.slideAudioIndex == 0) {
	            // effects
	            var soundClipartModel = this.props.soundClipartModel;
	
	            if (soundClipartModel) {
	                var newDataProvider = [];
	
	                if (soundClipartModel && soundClipartModel.items[1]) {
	                    var soundEffects = soundClipartModel.items[1];
	                    newDataProvider = soundEffects.items[this.props.soundEffectsCategoryIndex].items;
	                }
	
	                return newDataProvider;
	            } else return [];
	        } else {
	            // my sounds
	            var dataProvider = this.props.mediaFilesDataProvider;
	
	            if (dataProvider != undefined) {
	                return this.filterMySounds(dataProvider.soundsDataProvider);
	            } else return undefined;
	        }
	    },
	    filterMySounds: function filterMySounds(dataProvider) {
	        var category = this.getSelectedIndex('second');
	        var i;
	        var array = [];
	
	        for (i = 0; i < dataProvider.length; i++) {
	            if (category == 1) {
	                // recorded sounds
	                if (dataProvider[i].isRecordedSound) array.push(dataProvider[i]);
	            } else {
	                if (!dataProvider[i].isRecordedSound) array.push(dataProvider[i]);
	            }
	        }
	
	        return array;
	    },
	    getSelectedIndex: function getSelectedIndex() {
	        var index = this.props.soundEffectsCategoryIndex;
	
	        if (index == undefined || isNaN(index)) index = 0;
	
	        return index;
	    },
	    isCategorySelectorVisible: function isCategorySelectorVisible() {
	        if (this.props.slideAudioIndex == 0) return true;else return false;
	    },
	    getMySoundsCategories: function getMySoundsCategories() {
	        var dataProvider = [];
	
	        dataProvider.push(_LocalesManager2.default.getCaption('UploadedSounds', 'music'));
	        dataProvider.push(_LocalesManager2.default.getCaption('RecordedSounds', 'music'));
	
	        return dataProvider;
	    },
	    getSelectorDataProvider: function getSelectorDataProvider() {
	        var clipartModel = this.props.soundClipartModel;
	
	        if (!clipartModel) return [];
	
	        var dataProvider = [];
	
	        if (clipartModel && clipartModel.items[1]) {
	            //Sound Effects
	            var subcategoryItems = clipartModel.items[1].items;
	
	            for (var i = 0; i < subcategoryItems.length; i++) {
	                dataProvider.push(subcategoryItems[i].title);
	            }
	        }
	
	        return dataProvider;
	    },
	    onUpload: function onUpload(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        window.parent.postMessage('openUploader', '*');
	    },
	    onMouseIn: function onMouseIn() {
	        var button = document.getElementById('uploadButton');
	        _HoverManager2.default.show(button, 'uploadButton');
	    },
	    onMouseOut: function onMouseOut() {
	        _HoverManager2.default.hide();
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.mediaFilesDataProvider != newProps.mediaFilesDataProvider || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth || this.props.slideAudioIndex != newProps.slideAudioIndex || this.props.soundEffectsCategoryIsExpanded != newProps.soundEffectsCategoryIsExpanded || this.props.soundEffectsCategoryIndex != newProps.soundEffectsCategoryIndex) return true;else return false;
	    },
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            top: this.props.top,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.height,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var selectorTopPosition = _Properties2.default.BROWSER_BUTTON_HEIGHT;
	        var height = this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT - 2 * _Properties2.default.BROWSER_BUTTON_HEIGHT - 2 * _Properties2.default.AUDIO_EDITOR_BUTTON_GAP - _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	        var uploadButton;
	        var showUploadButton = !_PlatformDetection2.default.isIOSApp() && this.props.slideAudioIndex == 1 && (!this.props.soundEffectsCategoryIndex || this.props.soundEffectsCategoryIndex == 0);
	
	        if (showUploadButton) {
	            if (_PlatformDetection2.default.isIOS()) {
	                var uploadIconStyle = {
	                    position: 'absolute',
	                    top: 85,
	                    left: _Properties2.default.BROWSER_WIDTH / 2 - 42 / 2,
	                    color: '#2DE102'
	                };
	
	                uploadButton = _react2.default.createElement('i', { id: 'uploadButton', style: uploadIconStyle, className: 'fa fa-plus-circle fa-3x', onMouseDown: this.onUpload, onTouchStart: this.onUpload, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut });
	            } else {
	                var uploadButtonStyle = {
	                    position: 'absolute',
	                    top: 85,
	                    left: _Properties2.default.BROWSER_WIDTH / 2 - 42 / 2,
	                    margin: 0,
	                    padding: 0,
	                    boxSizing: 'initial',
	                    fontSize: 'initial',
	                    borderStyle: 'none',
	                    width: 41,
	                    height: 48,
	                    background: 'none'
	                };
	
	                var uploadIconPlusStyle = {
	                    position: 'absolute',
	                    top: 0,
	                    left: 0,
	                    color: '#2DE102'
	                };
	
	                uploadButton = _react2.default.createElement(
	                    'button',
	                    { id: 'uploadButton', 'aria-label': _LocalesManager2.default.getCaption('UploadHover', 'myFiles'), style: uploadButtonStyle, onClick: this.onUpload, onTouchStart: this.onUpload, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	                    _react2.default.createElement('i', { style: uploadIconPlusStyle, className: 'fa fa-plus-circle fa-3x' })
	                );
	            }
	        }
	
	        var dataProvider = this.props.slideAudioIndex == 1 ? this.getMySoundsCategories() : this.getSelectorDataProvider();
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, type: 'soundEffects', index: 0, category: this.props.slideAudioIndex, dispatch: this.props.dispatch }),
	            _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, type: 'soundEffects', index: 1, category: this.props.slideAudioIndex, dispatch: this.props.dispatch }),
	            _react2.default.createElement(_AudioCategorySelectorNew.AudioCategorySelectorNew, { accordionWidth: this.props.accordionWidth, isAdvancedMenu: true, type: 'soundEffects', visible: true, isExpanded: this.props.soundEffectsCategoryIsExpanded, selectedIndex: this.getSelectedIndex(), dataProvider: dataProvider, dispatch: this.props.dispatch, top: selectorTopPosition }),
	            uploadButton,
	            _react2.default.createElement(_MediaSoundsList.MediaSoundsList, { accordionWidth: this.props.accordionWidth, dataProvider: this.getDataProvider(), showUploadButton: showUploadButton, isAudioTab: true, height: height, categoriesVisible: true, dispatch: this.props.dispatch })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
	    var slideAudioIndex = state.music.slideAudioIndex;
	    var soundClipartModel = state.music.soundClipartModel;
	    var soundEffectsCategoryIsExpanded = state.menu.soundEffectsCategoryIsExpanded;
	    var soundEffectsCategoryIndex = state.music.soundEffectsCategoryIndex;
	
	    if (!slideAudioIndex) slideAudioIndex = 0;
	
	    if (!soundEffectsCategoryIndex || isNaN(soundEffectsCategoryIndex)) soundEffectsCategoryIndex = 0;
	
	    return {
	        mediaFilesDataProvider: mediaFilesDataProvider,
	        slideAudioIndex: slideAudioIndex,
	        soundClipartModel: soundClipartModel,
	        soundEffectsCategoryIsExpanded: soundEffectsCategoryIsExpanded,
	        soundEffectsCategoryIndex: soundEffectsCategoryIndex
	    };
	}
	
	var SlideSoundsBrowser = exports.SlideSoundsBrowser = (0, _reactRedux.connect)(mapStateToProps)(SlideSoundsBrowserContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SlideSoundsBrowser.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SlideSoundsBrowser.js"); } } })();

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SoundElement = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _VolumeSlider = __webpack_require__(123);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SoundElement = exports.SoundElement = _react2.default.createClass({
	    displayName: 'SoundElement',
	    getInitialState: function getInitialState() {
	        return {
	            isCloseOver: false,
	            isVolumeOver: false,
	            openVolumeSlider: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('click', this.onCloseVolumeSlider);
	        document.addEventListener('touchend', this.onCloseVolumeSlider);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('click', this.onCloseVolumeSlider);
	        document.removeEventListener('touchend', this.onCloseVolumeSlider);
	    },
	    onCloseMouseIn: function onCloseMouseIn() {
	        _HoverManager2.default.show(this.refs.deleteSound, 'deleteSound');
	
	        this.setState({
	            isCloseOver: true
	        });
	    },
	    onCloseMouseOut: function onCloseMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isCloseOver: false
	        });
	    },
	    onVolumeMouseIn: function onVolumeMouseIn() {
	        _HoverManager2.default.show(this.refs.volumeSound, 'volumeSound');
	
	        this.setState({
	            isVolumeOver: true
	        });
	    },
	    onVolumeMouseOut: function onVolumeMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isVolumeOver: false
	        });
	    },
	    onOpenVolumeSlider: function onOpenVolumeSlider(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.setState({
	            openVolumeSlider: true
	        });
	    },
	    onCloseVolumeSlider: function onCloseVolumeSlider(e) {
	        if (_TextSizeUtils2.default.isTextEditMode()) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (!_PlatformDetection2.default.isIOS()) {
	            if (!document.getElementById('htmlColorPicker')) e.preventDefault();
	        }
	
	        var target = e.target;
	
	        var volume = 'volume1';
	
	        if (this.props.isSoundEffect) volume = 'volume2';
	
	        if (target.id == volume) return;
	
	        if (target.id && target.id.indexOf('volumeIcon') != -1) {
	            this.setState({
	                openVolumeSlider: false
	            });
	
	            return;
	        }
	
	        if (target.id.indexOf('volumeSlider') != -1 || target.parentElement && target.parentElement.id.indexOf('volumeSlider') != -1 || target.parentElement && target.parentElement.parentElement && target.parentElement.parentElement.id.indexOf('volumeSlider') != -1) return;
	
	        this.setState({
	            openVolumeSlider: false
	        });
	    },
	    isSoundVisible: function isSoundVisible() {
	        var audioSource = this.props.audioSource;
	
	        if (audioSource) return true;else return false;
	    },
	    onRemoveSound: function onRemoveSound(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var duration;
	
	        if (!_VideoUtils2.default.isVideoBackground()) {
	            if (this.props.isSoundEffect) {
	                if (!_AudioUtils2.default.hasSlideSound()) this.props.dispatch((0, _CurrentSlideActions.changeSlideDuration)(_Configuration2.default.SLIDE_DURATION));else {
	                    // set slide sound duration
	                    duration = _AudioUtils2.default.slideSoundDuration();
	
	                    if (duration > 0) this.props.dispatch((0, _CurrentSlideActions.changeSlideDuration)(duration));
	                }
	            }
	
	            if (!this.props.isSoundEffect) {
	                if (!_AudioUtils2.default.hasSlideSoundEffect()) this.props.dispatch((0, _CurrentSlideActions.changeSlideDuration)(_Configuration2.default.SLIDE_DURATION));else {
	                    // set slide effect duration
	                    duration = _AudioUtils2.default.slideSoundEffectDuration();
	
	                    if (duration > 0) this.props.dispatch((0, _CurrentSlideActions.changeSlideDuration)(duration));
	                }
	            }
	        }
	
	        _SaveManager2.default.isContentChanged(true);
	
	        var emptySound = {};
	        emptySound.href = '';
	        emptySound.contentItemId = -1;
	        emptySound.title = '';
	
	        if (this.props.isSoundEffect) {
	            _AudioUtils2.default.pauseSound("audioEffect");
	            this.props.dispatch((0, _CurrentSlideActions.setSlideSoundEffect)(emptySound));
	        } else {
	            _AudioUtils2.default.pauseSound('recordedAudio');
	            this.props.dispatch((0, _CurrentSlideActions.setSlideSound)(emptySound));
	        }
	
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        if (this.props.updateViewProperties) this.props.updateViewProperties();
	    },
	    getSoundIcon: function getSoundIcon() {
	        var state = _StoreManager2.default.getState();
	        var soundVolume;
	
	        if (this.props.isSoundEffect) soundVolume = state.currentSlide.model.soundEffectVolume;else soundVolume = state.currentSlide.model.soundVolume;
	
	        if (!soundVolume) soundVolume = 0.5;
	
	        var volumeIcon = 'fa fa-volume-down';
	
	        if (soundVolume == 0) volumeIcon = 'fa fa-volume-off';else if (soundVolume <= 0.5) volumeIcon = 'fa fa-volume-down';else if (soundVolume > 0.5) volumeIcon = 'fa fa-volume-up';
	
	        return volumeIcon;
	    },
	    render: function render() {
	        var width = _Configuration2.default.CANVAS_WIDTH * this.props.scaleProperties.scale;
	        var recordMiddleGap = 8;
	        var recordButtonSize = _Properties2.default.RECORDING_BUTTON_HEIGHT;
	        var soundVisibility = 'none';
	        var titleVisibility = 'none';
	        var soundTitle = _TextSizeUtils2.default.correctRecordingTitle(this.props.soundTitle);
	        var titleWidth = _TextSizeUtils2.default.getSpanWidth(12, soundTitle);
	        var soundWidth = _Properties2.default.RECORDING_SOUND_BUTTON_WIDTH + titleWidth;
	        var recordButtonLeftPos = width / 2 - recordButtonSize - recordMiddleGap / 2;
	        var borderSize = 1;
	        var iconColor;
	        var leftPos = recordButtonLeftPos - recordMiddleGap - soundWidth;
	
	        if (this.props.isSoundEffect) leftPos = recordButtonLeftPos + 2 * recordMiddleGap + 2 * recordButtonSize;
	
	        if (this.isSoundVisible()) soundVisibility = 'block';
	
	        if (soundTitle.length > 0) {
	            titleVisibility = 'block';
	        }
	
	        var soundStyle = {
	            width: soundWidth,
	            height: _Properties2.default.RECORDING_BUTTON_HEIGHT + 2,
	            background: _Properties2.default.ADD_MUSIC_BUTTON_BACKGROUND,
	            position: 'absolute',
	            left: leftPos,
	            top: (_Properties2.default.RECORDING_MENU_HEIGHT - _Properties2.default.RECORDING_BUTTON_HEIGHT) / 2 - borderSize,
	            borderRadius: 20,
	            display: soundVisibility
	        };
	
	        var soundTitleStyle = {
	            fontSize: 12,
	            height: 20,
	            width: titleWidth,
	            whiteSpace: 'nowrap',
	            cursor: 'default',
	            position: 'absolute',
	            top: 9,
	            left: 32,
	            color: 'black',
	            textAlign: 'center',
	            display: titleVisibility
	        };
	
	        if (this.state.isCloseOver == true) iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else iconColor = 'black';
	
	        var closeIconStyle = {
	            position: 'absolute',
	            top: 7,
	            left: soundStyle.width - 23,
	            color: iconColor
	        };
	
	        var closeAreaStyle = {
	            position: 'absolute',
	            width: 32,
	            height: 30,
	            left: soundStyle.width - 32,
	            top: 0,
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        var animationType = 'slideSoundAnimation';
	        var type = 'slideSound';
	        var volume = 'volume1';
	
	        if (this.props.isSoundEffect) {
	            animationType = 'slideSoundEffectAnimation';
	            type = 'slideSoundEffect';
	            volume = 'volume2';
	        }
	
	        if (this.state.isVolumeOver == true) iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else iconColor = 'black';
	
	        var volumeIconStyle = {
	            position: 'absolute',
	            top: 7,
	            left: 11,
	            color: iconColor
	        };
	
	        var volumeAreaStyle = {
	            position: 'absolute',
	            width: 24,
	            height: 30,
	            left: 2,
	            top: 0,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        var iconType = this.getSoundIcon();
	
	        return _react2.default.createElement(
	            'div',
	            { id: type, style: soundStyle },
	            _react2.default.createElement('i', { style: volumeIconStyle, className: iconType + ' ' + animationType }),
	            _react2.default.createElement('button', { 'aria-label': _LocalesManager2.default.getCaption('volumeSound', 'hover'), ref: 'volumeSound', id: volume, style: volumeAreaStyle, onMouseOver: this.onVolumeMouseIn, onMouseOut: this.onVolumeMouseOut, onClick: this.onOpenVolumeSlider, onTouchEnd: this.onOpenVolumeSlider }),
	            _react2.default.createElement(
	                'span',
	                { className: animationType, style: soundTitleStyle },
	                soundTitle
	            ),
	            _react2.default.createElement('i', { style: closeIconStyle, className: 'fa fa-close ' + animationType }),
	            _react2.default.createElement('button', { 'aria-label': _LocalesManager2.default.getCaption('deleteSound', 'hover'), ref: 'deleteSound', style: closeAreaStyle, onMouseOver: this.onCloseMouseIn, onMouseOut: this.onCloseMouseOut, onClick: this.onRemoveSound, onTouchEnd: this.onRemoveSound }),
	            _react2.default.createElement(_VolumeSlider.VolumeSlider, { dispatch: this.props.dispatch, visible: this.state.openVolumeSlider, type: type })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SoundElement.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/SoundElement.js"); } } })();

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.StorySoundsBrowser = exports.StorySoundsBrowserContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AudioCategorySelectorNew = __webpack_require__(169);
	
	var _SoundItemRenderer = __webpack_require__(138);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MusicActions = __webpack_require__(91);
	
	var _AccordionActions = __webpack_require__(51);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _PopulateMediaFilesUtils = __webpack_require__(80);
	
	var _PopulateMediaFilesUtils2 = _interopRequireDefault(_PopulateMediaFilesUtils);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    this.props.dispatch((0, _MusicActions.changeMusicContentIndex)(0));
	                    break;
	                }
	
	            case 1:
	                {
	                    this.props.dispatch((0, _MusicActions.changeMusicContentIndex)(1));
	                    break;
	                }
	        }
	
	        this.props.dispatch((0, _MenuActions.expandAudioList)(false, this.props.type));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.category != newProps.category || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var iconColor;
	        var buttonColor;
	        var mySoundsSelected = false;
	
	        if (this.props.category == 1) mySoundsSelected = true;
	
	        if (this.props.index == 0) {
	            // Music button
	            if (mySoundsSelected == false) {
	                iconColor = 'white';
	                buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            } else {
	                if (this.state.isOver == true) {
	                    iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                    buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	                } else {
	                    iconColor = 'black';
	                    buttonColor = '#D7D7D7';
	                }
	            }
	        } else {
	            // My Sounds button
	            if (mySoundsSelected == true) {
	                iconColor = 'white';
	                buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            } else {
	                if (this.state.isOver == true) {
	                    iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                    buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	                } else {
	                    iconColor = 'black';
	                    buttonColor = '#D7D7D7';
	                }
	            }
	        }
	
	        var topPosition = 0;
	        var left = this.props.index == 0 ? 0 : this.props.accordionWidth / 2;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth / 2 - 2,
	            height: _Properties2.default.BROWSER_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            left: left,
	            top: topPosition,
	            color: 'white',
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#FFFFFF',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            fontSize: 15,
	            position: 'absolute',
	            width: buttonStyle.width - 2 * 5,
	            left: 5,
	            top: 6,
	            whiteSpace: 'nowrap',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            textAlign: 'center'
	        };
	
	        var text = this.props.text;
	
	        if (this.props.index == 0) {
	            text = _LocalesManager2.default.getCaption('MusicContent', 'music');
	        } else {
	            text = _LocalesManager2.default.getCaption('MySoundsContent', 'music');
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': text, style: buttonStyle, onClick: this.onClick, onTouchStart: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            )
	        );
	    }
	});
	
	var AudioList = _react2.default.createClass({
	    displayName: 'AudioList',
	    getInitialState: function getInitialState() {
	        return {
	            elements: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var currentItem;
	        var nextItem;
	
	        if (this.props.dataProvider[0]) currentItem = this.props.dataProvider[0].title;
	
	        if (nextProps.dataProvider[0]) nextItem = nextProps.dataProvider[0].title;
	
	        if (currentItem != nextItem || this.props.accordionWidth != nextProps.accordionWidth) this.recreateElements();
	    },
	    recreateElements: function recreateElements() {
	        setTimeout(this.refreshNewContent, 50);
	    },
	    refreshNewContent: function refreshNewContent() {
	        this.initElements();
	    },
	    initElements: function initElements() {
	        var elements = [];
	        var i;
	        var item;
	
	        for (i = 0; i < this.props.dataProvider.length; i++) {
	            item = this.props.dataProvider[i];
	            elements.push(_react2.default.createElement(_SoundItemRenderer.SoundItemRenderer, { accordionWidth: this.props.accordionWidth, index: i, key: 'audioBrowser' + item.title + '_' + Math.random(), dispatch: this.props.dispatch, value: item }));
	        }
	
	        this.setState({
	            elements: elements
	        });
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.elements != nextState.elements || this.props.categoriesVisible != newProps.categoriesVisible || this.props.windowHeight != newProps.windowHeight || this.props.dataProvider != newProps.dataProvider) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.elements == undefined) return _react2.default.createElement('div', null);
	
	        var buttonsHolderHeight = _Properties2.default.BROWSER_BUTTON_HEIGHT;
	        var categoriesHeight = 0;
	        var topPosition = buttonsHolderHeight;
	        var bottomPadding = 8;
	        var topPadding = _Properties2.default.CATEGORY_SELECTOR_GAP;
	
	        if (this.props.categoriesVisible == true) {
	            categoriesHeight = _Properties2.default.CATEGORY_SELECTOR_HEIGHT;
	            topPosition = topPosition + categoriesHeight;
	            topPadding = 0;
	        } else topPosition = topPosition + _Properties2.default.MY_MEDIA_FILES_GAP;
	
	        topPosition = topPosition + topPadding;
	
	        if (this.props.showUploadButton) topPosition = topPosition + 50;
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = this.props.accordionWidth;
	        componentProperties.height = this.props.height - topPosition - bottomPadding;
	        componentProperties.top = topPosition;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = this.state.elements;
	        componentProperties.scrollHeight = (_Properties2.default.SOUND_ITEM_HEIGHT + _Properties2.default.SOUND_ITEMS_GAP) * this.state.elements.length;
	
	        return _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties });
	    }
	});
	
	var StorySoundsBrowserContent = exports.StorySoundsBrowserContent = _react2.default.createClass({
	    displayName: 'StorySoundsBrowserContent',
	    getInitialState: function getInitialState() {
	        return {
	            isMyMediaFilesCallDone: false
	        };
	    },
	    getClipartModel: function getClipartModel() {
	        var clipartModel = _StoreManager2.default.getState().music.soundClipartModel;
	        return clipartModel;
	    },
	    getMySoundsCategories: function getMySoundsCategories() {
	        var dataProvider = [];
	
	        dataProvider.push(_LocalesManager2.default.getCaption('UploadedSounds', 'music'));
	        dataProvider.push(_LocalesManager2.default.getCaption('RecordedSounds', 'music'));
	
	        return dataProvider;
	    },
	    getSelectorDataProvider: function getSelectorDataProvider(type) {
	        var clipartModel = this.getClipartModel();
	
	        if (!clipartModel) return [];
	
	        var clipartModelItems = clipartModel.items;
	        var dataProvider = [];
	        var i;
	
	        if (type == 'main') {
	            dataProvider.push(clipartModelItems[0].title);
	            dataProvider.push(clipartModelItems[1].title);
	        } else {
	            var mainIndex = 0;
	
	            if (mainIndex >= 0) {} else mainIndex = 0;
	
	            var itemsObject = clipartModelItems[mainIndex];
	
	            if (itemsObject == undefined) return dataProvider;
	
	            var subcategoryItems = itemsObject.items;
	
	            for (i = 0; i < subcategoryItems.length; i++) {
	                dataProvider.push(subcategoryItems[i].title);
	            }
	        }
	
	        return dataProvider;
	    },
	    onUpload: function onUpload(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        window.parent.postMessage('openUploader', '*');
	    },
	    onMouseIn: function onMouseIn() {
	        var button = document.getElementById('uploadButton');
	        _HoverManager2.default.show(button, 'uploadButton');
	    },
	    onMouseOut: function onMouseOut() {
	        _HoverManager2.default.hide();
	    },
	    getSelectedIndex: function getSelectedIndex(type) {
	        var index;
	
	        if (type == 'main') {
	            index = this.props.mainAudioCategoryIndex;
	        } else {
	            index = this.props.secondAudioCategoryIndex;
	        }
	
	        if (index == undefined || isNaN(index)) index = 0;
	
	        return index;
	    },
	    getMusicDataProvider: function getMusicDataProvider() {
	        var clipartModel = this.getClipartModel();
	
	        if (!clipartModel) return [];
	
	        var clipartModelItems = clipartModel.items;
	
	        if (clipartModelItems == undefined) return [];
	
	        var mainIndex = this.getSelectedIndex('main');
	        var secondIndex = this.getSelectedIndex('second');
	        var subcategoryItems = clipartModelItems[mainIndex].items;
	
	        if (subcategoryItems == undefined) return [];
	
	        var dataProvider = [];
	        var contentItems = subcategoryItems[secondIndex].items;
	        var i;
	
	        for (i = 0; i < contentItems.length; i++) {
	            dataProvider.push(contentItems[i]);
	        }
	
	        return dataProvider;
	    },
	    filterMySounds: function filterMySounds(dataProvider) {
	        var category = this.getSelectedIndex('second');
	        var i;
	        var array = [];
	
	        for (i = 0; i < dataProvider.length; i++) {
	            if (category == 1) {
	                // recorded sounds
	                if (dataProvider[i].isRecordedSound) array.push(dataProvider[i]);
	            } else {
	                if (!dataProvider[i].isRecordedSound) array.push(dataProvider[i]);
	            }
	        }
	
	        return array;
	    },
	    getMySoundsDataProvider: function getMySoundsDataProvider() {
	        var dataProvider = this.props.mediaFilesDataProvider;
	
	        if (dataProvider && dataProvider.soundsDataProvider && dataProvider.soundsDataProvider.length > 0) return this.filterMySounds(dataProvider.soundsDataProvider);else {
	            if (this.state.isMyMediaFilesCallDone == true) return [];
	
	            setTimeout(this.loadData, 2);
	
	            return [];
	        }
	    },
	    loadData: function loadData() {
	        if (_Configuration2.default.LOAD_LOCAL == true) {
	            // FOR TEST
	            this.props.dispatch((0, _AccordionActions.setMediaFilesDataProvider)({ imagesDataProvider: _PopulateMediaFilesUtils2.default.getImagesDataProviderForTest(), soundsDataProvider: _PopulateMediaFilesUtils2.default.getSoundsDataProviderForTest() }));
	        } else {
	            this.setState({ isMyMediaFilesCallDone: true });
	            _ApiServiceUtils2.default.executeSafeApiCall(this.loadMyMediaFiles.bind(this));
	        }
	    },
	    loadMyMediaFiles: function loadMyMediaFiles() {
	        _ApiServiceUtils2.default.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
	    },
	    parseMediaItems: function parseMediaItems(items) {
	        _PopulateMediaFilesUtils2.default.parseMediaItems(items, this.props.dispatch, true);
	        this.setState({ isMyMediaFilesCallDone: false });
	    },
	    category: function category() {
	        if (this.props.musicContentIndex == undefined || this.props.musicContentIndex == 0) return 0;else return 1;
	    },
	    getContentDataProvider: function getContentDataProvider() {
	        if (this.category() == 0) return this.getMusicDataProvider();else return this.getMySoundsDataProvider();
	    },
	    isCategorySelectorVisible: function isCategorySelectorVisible() {
	        if (this.category() == 0) return true;else return false;
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var target = e.target;
	        if (this.hasParentWithId(target, 'categorySelector', 7) == false) {
	            this.props.dispatch((0, _MenuActions.expandAudioList)(false, 'all'));
	        }
	
	        setTimeout(this.refreshView, 5);
	    },
	    hasParentWithId: function hasParentWithId(target, parentId, level) {
	        if (target.id == parentId) return true;
	
	        var i;
	
	        for (i = 0; i < level; i++) {
	            if (target.parentNode == undefined) {
	                return false;
	            } else {
	                target = target.parentNode;
	
	                if (target.id == parentId) return true;
	            }
	        }
	
	        return false;
	    },
	    refreshView: function refreshView() {
	        this.forceUpdate();
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.mediaFilesDataProvider != newProps.mediaFilesDataProvider || this.props.musicContentIndex != newProps.musicContentIndex || this.props.secondAudioCategoryIndex != newProps.secondAudioCategoryIndex || this.props.mainAudioCategoryIndex != newProps.mainAudioCategoryIndex || this.props.secondAudioCategoryIsExpanded != newProps.secondAudioCategoryIsExpanded || this.props.accordionWidth != newProps.accordionWidth || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.mainAudioCategoryIsExpanded != newProps.mainAudioCategoryIsExpanded) return true;else return false;
	    },
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            top: this.props.top,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.height,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var buttonsHolderStyle = {
	            position: 'absolute',
	            top: 0
	        };
	
	        var selectorTopPosition = _Properties2.default.BROWSER_BUTTON_HEIGHT;
	        var height = this.props.windowHeight - _Properties2.default.CLIPART_BUTTON_HEIGHT - 2 * _Properties2.default.BROWSER_BUTTON_HEIGHT - 2 * _Properties2.default.AUDIO_EDITOR_BUTTON_GAP - _Properties2.default.CLIPART_BUTTON_HEIGHT;
	
	        var uploadButton;
	        var showUploadButton = !_PlatformDetection2.default.isIOSApp() && this.props.musicContentIndex == 1 && (!this.props.secondAudioCategoryIndex || this.props.secondAudioCategoryIndex == 0);
	
	        if (showUploadButton) {
	            if (_PlatformDetection2.default.isIOS()) {
	                var uploadIconStyle = {
	                    position: 'absolute',
	                    top: 85,
	                    left: _Properties2.default.BROWSER_WIDTH / 2 - 42 / 2,
	                    color: '#2DE102'
	                };
	
	                uploadButton = _react2.default.createElement('i', { id: 'uploadButton', style: uploadIconStyle, className: 'fa fa-plus-circle fa-3x', onMouseDown: this.onUpload, onTouchStart: this.onUpload, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut });
	            } else {
	                var uploadButtonStyle = {
	                    position: 'absolute',
	                    top: 85,
	                    left: _Properties2.default.BROWSER_WIDTH / 2 - 42 / 2,
	                    margin: 0,
	                    padding: 0,
	                    boxSizing: 'initial',
	                    fontSize: 'initial',
	                    borderStyle: 'none',
	                    width: 41,
	                    height: 48,
	                    background: 'none'
	                };
	
	                var uploadIconPlusStyle = {
	                    position: 'absolute',
	                    top: 0,
	                    left: 0,
	                    color: '#2DE102'
	                };
	
	                uploadButton = _react2.default.createElement(
	                    'button',
	                    { id: 'uploadButton', 'aria-label': _LocalesManager2.default.getCaption('UploadHover', 'myFiles'), style: uploadButtonStyle, onClick: this.onUpload, onTouchStart: this.onUpload, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	                    _react2.default.createElement('i', { style: uploadIconPlusStyle, className: 'fa fa-plus-circle fa-3x' })
	                );
	            }
	        }
	
	        var dataProvider = this.props.musicContentIndex == 1 ? this.getMySoundsCategories() : this.getSelectorDataProvider('second');
	
	        return _react2.default.createElement(
	            'div',
	            { ref: 'audioBrowser', style: menuStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	            _react2.default.createElement(
	                'div',
	                { style: buttonsHolderStyle },
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, type: 'second', index: 0, category: this.props.musicContentIndex, dispatch: this.props.dispatch }),
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, type: 'second', index: 1, category: this.props.musicContentIndex, dispatch: this.props.dispatch })
	            ),
	            _react2.default.createElement(_AudioCategorySelectorNew.AudioCategorySelectorNew, { top: selectorTopPosition, accordionWidth: this.props.accordionWidth, type: 'second', isAdvancedMenu: true, visible: true, isExpanded: this.props.secondAudioCategoryIsExpanded, selectedIndex: this.getSelectedIndex('second'), dataProvider: dataProvider, dispatch: this.props.dispatch }),
	            uploadButton,
	            _react2.default.createElement(AudioList, { accordionWidth: this.props.accordionWidth, categoriesVisible: true, height: height, showUploadButton: showUploadButton, windowHeight: this.props.windowHeight, dispatch: this.props.dispatch, dataProvider: this.getContentDataProvider() })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	
	    var mainAudioCategoryIsExpanded = state.menu.mainAudioCategoryIsExpanded;
	    var secondAudioCategoryIsExpanded = state.menu.secondAudioCategoryIsExpanded;
	    var mainAudioCategoryIndex = state.music.mainAudioCategoryIndex;
	    var secondAudioCategoryIndex = state.music.secondAudioCategoryIndex;
	    var musicContentIndex = state.music.musicContentIndex;
	    var mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
	
	    return {
	        mainAudioCategoryIsExpanded: mainAudioCategoryIsExpanded,
	        secondAudioCategoryIsExpanded: secondAudioCategoryIsExpanded,
	        mainAudioCategoryIndex: mainAudioCategoryIndex,
	        secondAudioCategoryIndex: secondAudioCategoryIndex,
	        musicContentIndex: musicContentIndex,
	        mediaFilesDataProvider: mediaFilesDataProvider
	    };
	}
	
	var StorySoundsBrowser = exports.StorySoundsBrowser = (0, _reactRedux.connect)(mapStateToProps)(StorySoundsBrowserContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/StorySoundsBrowser.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/StorySoundsBrowser.js"); } } })();

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.StylingMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _CustomSlider = __webpack_require__(170);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ColorPicker = __webpack_require__(330);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _OnOffToggleButton = __webpack_require__(122);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            position: 'absolute',
	            top: 6,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            right: 28,
	            top: 4,
	            width: 22,
	            height: 22,
	            cursor: 'pointer',
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            background: 'none',
	            borderStyle: 'none',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 3,
	            right: 3,
	            cursor: 'pointer'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                _LocalesManager2.default.getCaption('StylingMenuTitle', 'stylingMenu')
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'firstFocusableObjectForStylingMenu', style: closeButtonStyle, 'aria-label': _LocalesManager2.default.getCaption('close', 'other'), onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    this.props.dispatch((0, _MenuActions.changeStyleTab)(_ModeConstants2.default.FILL_STYLE));
	                    break;
	                }
	
	            case 1:
	                {
	                    this.props.dispatch((0, _MenuActions.changeStyleTab)(_ModeConstants2.default.LINE_STYLE));
	                    break;
	                }
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.tab != newProps.tab || this.props.contextTarget != newProps.contextTarget) return true;else return false;
	    },
	    render: function render() {
	        var iconColor;
	        var buttonColor;
	        var isLineSelected = false;
	
	        if (this.props.tab && this.props.tab == _ModeConstants2.default.LINE_STYLE) isLineSelected = true;
	
	        if (this.props.index == 0) {
	            // Fill button
	            if (isLineSelected == false) {
	                iconColor = 'white';
	                buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            } else {
	                if (this.state.isOver == true) {
	                    iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                    buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	                } else {
	                    iconColor = 'black';
	                    buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	                }
	            }
	        } else {
	            // Line button
	            if (isLineSelected == true) {
	                iconColor = 'white';
	                buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	            } else {
	                if (this.state.isOver == true) {
	                    iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                    buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	                } else {
	                    iconColor = 'black';
	                    buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	                }
	            }
	        }
	
	        var topPosition = _Properties2.default.CLIPART_BUTTON_HEIGHT + _Properties2.default.STYLING_TOP_GAP;
	        var left = this.props.index == 0 ? _Properties2.default.STYLING_LEFT_GAP : this.props.accordionWidth / 2;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth / 2 - _Properties2.default.STYLING_LEFT_GAP,
	            height: _Properties2.default.STYLING_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            left: left,
	            top: topPosition,
	            color: 'white',
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#333333',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial'
	        };
	
	        var cornerRadius = 8;
	
	        if (this.props.index == 0) {
	            buttonStyle.borderTopLeftRadius = cornerRadius;
	            buttonStyle.borderBottomLeftRadius = cornerRadius;
	        } else if (this.props.index == 1) {
	            buttonStyle.borderTopRightRadius = cornerRadius;
	            buttonStyle.borderBottomRightRadius = cornerRadius;
	        }
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            fontSize: 16,
	            position: 'absolute',
	            left: 60,
	            top: 13
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            left: 40,
	            color: iconColor
	        };
	
	        var icon;
	        var text = this.props.text;
	
	        if (this.props.index == 0) {
	            text = _LocalesManager2.default.getCaption('FillButton', 'stylingMenu');
	            icon = 'fa fa-square';
	            iconStyle.top = 14;
	        } else {
	            text = _LocalesManager2.default.getCaption('LineButton', 'stylingMenu');
	            icon = 'fa fa-minus';
	            iconStyle.top = 18;
	        }
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            iconStyle.left = 10;
	            spanStyle.fontSize = 14;
	            spanStyle.left = 29;
	            spanStyle.top = 13;
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': text, style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement('i', { style: iconStyle, className: icon }),
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            )
	        );
	    }
	});
	
	var StylingMenuContent = _react2.default.createClass({
	    displayName: 'StylingMenuContent',
	    componentDidMount: function componentDidMount() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('firstFocusableObjectForStylingMenu');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    getTarget: function getTarget() {
	        var shapeModel;
	
	        if (this.props.contextMode == _ModeConstants2.default.SLIDE_CONTEXT_STYLING) {
	            var state = _StoreManager2.default.getState();
	            shapeModel = state.currentSlide.model.content[0];
	        } else {
	            shapeModel = this.props.contextTarget;
	        }
	
	        return shapeModel;
	    },
	    getType: function getType(shapeModel) {
	        if (this.props.contextMode == _ModeConstants2.default.SLIDE_CONTEXT_STYLING && _VideoUtils2.default.isVideoBackground()) return 'FillAndLine';
	
	        if (shapeModel.type == _ShapeConstants2.default.GROUP) {
	            var shapes = shapeModel.shapes;
	            var isStrokeOnly = true;
	
	            for (var i = 0; i < shapes.length; i++) {
	                if (shapes[i].type == _ShapeConstants2.default.FREEHAND || shapes[i].type == _ShapeConstants2.default.CURVE || shapes[i].type == _ShapeConstants2.default.LINE) {} else {
	                    isStrokeOnly = false;
	                    break;
	                }
	            }
	
	            if (isStrokeOnly) return 'Line';else return 'FillAndLine';
	        }
	
	        if (shapeModel.type == _ShapeConstants2.default.RECTANGLE || shapeModel.type == _ShapeConstants2.default.TRIANGLE || shapeModel.type == _ShapeConstants2.default.STAR || shapeModel.type == _ShapeConstants2.default.HEART || shapeModel.type == _ShapeConstants2.default.ELLIPSE || shapeModel.type == _ShapeConstants2.default.BACKGROUND || shapeModel.type == _ShapeConstants2.default.CHARACTER || shapeModel.type == _ShapeConstants2.default.IMAGE || this.isTextElement(shapeModel) == true) return 'FillAndLine';else return 'Line';
	    },
	    isTextElement: function isTextElement(shapeModel) {
	        if (shapeModel.type == _ShapeConstants2.default.TEXTBOX || shapeModel.type == _ShapeConstants2.default.TEXTBOXSIMPLE || shapeModel.type == _ShapeConstants2.default.SPEAK_BUBBLE || shapeModel.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shapeModel.type == _ShapeConstants2.default.SCREAM_BUBBLE || shapeModel.type == _ShapeConstants2.default.THOUGHT_BUBBLE) return true;else return false;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.tab != newProps.tab || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.contextMode != newProps.contextMode || this.props.accordionWidth != newProps.accordionWidth || this.props.contextTarget != newProps.contextTarget || this.props.currentSlideModel != newProps.currentSlideModel) return true;else return false;
	    },
	    render: function render() {
	        if (this.props.contextMode != _ModeConstants2.default.OBJECT_CONTEXT_STYLING && this.props.contextMode != _ModeConstants2.default.SLIDE_CONTEXT_STYLING) return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white',
	            cursor: 'default'
	        };
	
	        var contextTarget = this.getTarget();
	        var type = this.getType(contextTarget);
	        var buttonsDisplayState = 'none';
	        var topPosition = _Properties2.default.CLIPART_BUTTON_HEIGHT + _Properties2.default.STYLING_TOP_GAP;
	
	        if (type == 'FillAndLine') {
	            buttonsDisplayState = 'block';
	            topPosition = _Properties2.default.CLIPART_BUTTON_HEIGHT + 2 * _Properties2.default.STYLING_TOP_GAP + _Properties2.default.STYLING_BUTTON_HEIGHT;
	        }
	
	        var buttonsWrapperStyle = {
	            display: buttonsDisplayState
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            left: _Properties2.default.STYLING_LEFT_GAP,
	            top: topPosition,
	            cursor: 'default'
	        };
	
	        topPosition = topPosition + 30;
	        var colorPickerTopPosition = topPosition;
	
	        topPosition = topPosition + _Properties2.default.RAINBOW_HEIGHT + _Properties2.default.STYLING_TOP_GAP;
	
	        var spanThicknessStyle = {
	            position: 'absolute',
	            left: _Properties2.default.STYLING_LEFT_GAP,
	            top: topPosition,
	            cursor: 'default'
	        };
	
	        topPosition = topPosition + _Properties2.default.STYLING_TOP_GAP + 5;
	
	        var startVal = 0;
	
	        if (contextTarget.type == _ShapeConstants2.default.LINE || contextTarget.type == _ShapeConstants2.default.FREEHAND || contextTarget.type == _ShapeConstants2.default.CURVE) startVal = 1;
	
	        var thicknessProperties = {};
	        thicknessProperties.topPosition = topPosition;
	        thicknessProperties.leftPosition = _Properties2.default.STYLING_LEFT_GAP;
	        thicknessProperties.width = _Properties2.default.BROWSER_WIDTH - 2 * _Properties2.default.STYLING_LEFT_GAP;
	        thicknessProperties.height = _Properties2.default.STYLING_SLIDER_HEIGHT;
	        thicknessProperties.backgroundHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/strokeSlider.png';
	        thicknessProperties.thumbHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
	        thicknessProperties.thumbSize = _Properties2.default.STYLING_THUMB_SIZE;
	        thicknessProperties.start = startVal;
	        thicknessProperties.end = 10;
	        thicknessProperties.step = 1;
	        thicknessProperties.target = contextTarget;
	        thicknessProperties.dispatch = this.props.dispatch;
	        thicknessProperties.type = 'change_stroke';
	
	        var lineStyleHolderVisible = 'none';
	        var text = _LocalesManager2.default.getCaption('FillColor', 'stylingMenu');
	        var operationType = _ModeConstants2.default.FILL_STYLE;
	
	        if (this.props.tab == _ModeConstants2.default.LINE_STYLE || type == 'Line') {
	            lineStyleHolderVisible = 'block';
	            text = _LocalesManager2.default.getCaption('LineColor', 'stylingMenu');
	            operationType = _ModeConstants2.default.LINE_STYLE;
	        }
	
	        var lineStyleHolder = {
	            display: lineStyleHolderVisible
	        };
	
	        var onOffButtonProperties = {};
	        onOffButtonProperties.topPosition = colorPickerTopPosition + _Properties2.default.RAINBOW_HEIGHT + _Properties2.default.STYLING_TOP_GAP;
	        onOffButtonProperties.leftPosition = _Properties2.default.BROWSER_LEFT_PADDING;
	        onOffButtonProperties.trackWidth = _Properties2.default.TOGGLE_TRACK_WIDTH;
	        onOffButtonProperties.trackHeight = _Properties2.default.TOGGLE_TRACK_HEIGHT;
	        onOffButtonProperties.thumbHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
	        onOffButtonProperties.thumbSize = _Properties2.default.TOGGLE_THUMB_SIZE;
	        onOffButtonProperties.target = contextTarget;
	        onOffButtonProperties.dispatch = this.props.dispatch;
	
	        var onOffVisibility = 'none';
	
	        if ((this.isTextElement(contextTarget) == true || contextTarget.type == _ShapeConstants2.default.ELLIPSE || contextTarget.type == _ShapeConstants2.default.RECTANGLE || contextTarget.type == _ShapeConstants2.default.CHARACTER || contextTarget.type == _ShapeConstants2.default.IMAGE || contextTarget.type == _ShapeConstants2.default.TRIANGLE || contextTarget.type == _ShapeConstants2.default.STAR || contextTarget.type == _ShapeConstants2.default.HEART) && this.props.tab == _ModeConstants2.default.FILL_STYLE) onOffVisibility = 'block';
	
	        var onOffButtonHolderStyle = {
	            display: onOffVisibility
	        };
	
	        var leftPosition = 0;
	
	        if (this.props.accordionWidth > _Properties2.default.BROWSER_WIDTH) leftPosition = (this.props.accordionWidth - _Properties2.default.BROWSER_WIDTH) / 2;
	
	        var elementsHolder = {
	            position: 'absolute',
	            top: 0,
	            left: leftPosition,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            cursor: 'default'
	        };
	
	        var lastFocusalbeId1 = operationType == _ModeConstants2.default.LINE_STYLE ? 'stylingMenuLastFocusableElement' : undefined;
	        var lastFocusalbeId2 = onOffVisibility == 'block' ? 'stylingMenuLastFocusableElement' : undefined;
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'stylingMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(
	                'div',
	                { style: elementsHolder },
	                _react2.default.createElement(
	                    'div',
	                    { style: buttonsWrapperStyle },
	                    _react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, index: 0, tab: this.props.tab, dispatch: this.props.dispatch, contextTarget: contextTarget }),
	                    _react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, index: 1, tab: this.props.tab, dispatch: this.props.dispatch, contextTarget: contextTarget })
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { style: spanStyle },
	                    text
	                ),
	                _react2.default.createElement(_ColorPicker.ColorPicker, { accordionWidth: _Properties2.default.BROWSER_WIDTH, tab: operationType, topPosition: colorPickerTopPosition, shapeModel: contextTarget, dispatch: this.props.dispatch }),
	                _react2.default.createElement(
	                    'div',
	                    { style: lineStyleHolder },
	                    _react2.default.createElement(
	                        'span',
	                        { style: spanThicknessStyle },
	                        _LocalesManager2.default.getCaption('LineThickness', 'stylingMenu')
	                    ),
	                    _react2.default.createElement(_CustomSlider.CustomSlider, { id: lastFocusalbeId1, properties: thicknessProperties })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: onOffButtonHolderStyle },
	                    _react2.default.createElement(_OnOffToggleButton.OnOffToggleButton, { id: lastFocusalbeId2, properties: onOffButtonProperties, dispatch: this.props.dispatch, shapeModel: contextTarget })
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var tab = state.menu.tab;
	    var currentSlideModel = state.currentSlide.model;
	
	    return {
	        tab: tab,
	        currentSlideModel: currentSlideModel
	    };
	}
	
	var StylingMenu = exports.StylingMenu = (0, _reactRedux.connect)(mapStateToProps)(StylingMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/StylingMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/StylingMenu.js"); } } })();

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TextBoxLabel = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextBoxLabelContent = _react2.default.createClass({
	    displayName: 'TextBoxLabelContent',
	    getSelectedShape: function getSelectedShape() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	        var target;
	
	        if (!shapes) return target;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].isSelected == true) {
	                target = shapes[i];
	                break;
	            }
	        }return target;
	    },
	    getShapePosition: function getShapePosition(shapeModel, labelHeight) {
	        var scaleProperties = this.props.scaleProperties;
	        var position = { left: 0, top: 0 };
	        var scale = scaleProperties.scale;
	        var buttonSize = _Properties2.default.SHAPE_MENU_BUTTON_SIZE;
	        var radius = _TransformToolUtils.uiProperties.RADIUS;
	        var offset = 12;
	
	        if (shapeModel.rotation > 0) {
	            if (shapeModel.width > _Configuration2.default.CANVAS_WIDTH && shapeModel.height > _Configuration2.default.CANVAS_HEIGHT) {
	                position.left = scaleProperties.topX + _Configuration2.default.CANVAS_WIDTH * scale - buttonSize;
	                position.top = scaleProperties.topY;
	            } else if (shapeModel.y < 0 && shapeModel.y + shapeModel.height > _Configuration2.default.CANVAS_HEIGHT) {
	                if (shapeModel.x + shapeModel.width + buttonSize > _Configuration2.default.CANVAS_WIDTH) // move to TopLeft
	                    position.left = scaleProperties.topX + shapeModel.x * scale - buttonSize - offset;else position.left = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scaleProperties.scale + offset;
	            } else {
	                if (shapeModel.y < 0 && shapeModel.x + shapeModel.width + buttonSize > _Configuration2.default.CANVAS_WIDTH) {
	                    // move to BottomLeft
	                    position.left = scaleProperties.topX + shapeModel.x * scale - buttonSize - offset;
	                    position.top = scaleProperties.topY + (shapeModel.y + shapeModel.height) * scale - radius - buttonSize;
	                } else if (shapeModel.y < 0) {
	                    // move to BottomRight
	                    position.left = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scale + offset;
	                    position.top = scaleProperties.topY + (shapeModel.y + shapeModel.height) * scale - radius - buttonSize;
	                } else if (shapeModel.x + shapeModel.width + buttonSize > _Configuration2.default.CANVAS_WIDTH) {
	                    // move to TopLeft
	                    position.left = scaleProperties.topX + shapeModel.x * scale - buttonSize - offset;
	                    position.top = scaleProperties.topY + shapeModel.y * scale + radius;
	                } else {
	                    // move to TopRight (Normal)
	                    position.left = scaleProperties.topX + (shapeModel.x + shapeModel.width) * scale + offset;
	                    position.top = scaleProperties.topY + shapeModel.y * scale + radius;
	                }
	            }
	
	            position.top = position.top - labelHeight - 1;
	        } else {
	            position.left = scaleProperties.topX + shapeModel.x * scale + 5;
	            position.top = scaleProperties.topY + shapeModel.y * scale - labelHeight - 2;
	        }
	
	        if (position.left < scaleProperties.topX) position.left = scaleProperties.topX + offset;
	
	        if (position.left > scaleProperties.topX + _Configuration2.default.CANVAS_WIDTH * scale - labelHeight - offset) position.left = scaleProperties.topX + _Configuration2.default.CANVAS_WIDTH * scale - labelHeight - offset;
	
	        if (position.top < scaleProperties.topY) position.top = scaleProperties.topY + offset;
	
	        if (position.top > scaleProperties.topY + _Configuration2.default.CANVAS_HEIGHT * scale - labelHeight - offset) position.top = scaleProperties.topY + _Configuration2.default.CANVAS_HEIGHT * scale - labelHeight - offset;
	
	        return position;
	    },
	    render: function render() {
	        var shapeModel = this.getSelectedShape();
	
	        if (shapeModel == undefined || _PlatformDetection2.default.isIOS()) return _react2.default.createElement('div', null);
	
	        var isTextShape = shapeModel.type == _ShapeConstants2.default.TEXTBOX || shapeModel.type == _ShapeConstants2.default.TEXTBOXSIMPLE || shapeModel.type == _ShapeConstants2.default.SPEAK_BUBBLE || shapeModel.type == _ShapeConstants2.default.SCREAM_BUBBLE || shapeModel.type == _ShapeConstants2.default.THOUGHT_BUBBLE || shapeModel.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE;
	
	        if (!isTextShape || shapeModel.isInteraction == true || shapeModel.type == _ShapeConstants2.default.VIDEO || _SelectionManager2.default.multipleSelection() == true || _AnimationManager2.default.clone) return _react2.default.createElement('div', null);
	
	        var shapeIndex = _CreateShapes2.default.getShapeIndex(shapeModel.uuid);
	        var text = _LocalesManager2.default.getCaption('tekst', 'other');
	        var ariaLabelValue = text + ' ' + shapeIndex;
	        var textAreaId = 'text_area_' + shapeModel.uuid;
	        var labelHeight = 20;
	        var position = this.getShapePosition(shapeModel, labelHeight);
	
	        var labelStyle = {
	            position: 'absolute',
	            background: '#055685',
	            borderRadius: 10,
	            color: 'white',
	            fontSize: 12,
	            top: position.top,
	            left: position.left,
	            paddingLeft: 7,
	            paddingRight: 7,
	            paddingTop: 2,
	            paddingBottom: 2,
	            display: 'block'
	        };
	
	        return _react2.default.createElement(
	            'label',
	            { id: 'textBoxLabel', 'aria-label': ariaLabelValue, htmlFor: textAreaId, style: labelStyle },
	            ariaLabelValue
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var slideModel = state.currentSlide.model;
	
	    return {
	        slideModel: slideModel
	    };
	}
	
	var TextBoxLabel = exports.TextBoxLabel = (0, _reactRedux.connect)(mapStateToProps)(TextBoxLabelContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/TextBoxLabel.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/TextBoxLabel.js"); } } })();

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TextEditor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    onButtonClick: function onButtonClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        if (this.props.index == 1 && this.props.changeTextContent) this.props.changeTextContent();
	
	        dispatch((0, _MenuActions.showTextEditor)(undefined));
	        dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	    },
	    render: function render() {
	        var textColor;
	        var fillColor;
	
	        if (this.props.index == 0) {
	            textColor = 'black';
	            fillColor = 'white';
	        } else {
	            textColor = 'white';
	            fillColor = _Properties2.default.DELETE_ALERT_BACKGROUND;
	        }
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: fillColor,
	            width: 100,
	            height: 30,
	            top: 10,
	            left: this.props.index == 0 ? 30 : undefined,
	            right: this.props.index == 1 ? 30 : undefined,
	            borderRadius: 3,
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#333333',
	            cursor: 'pointer'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            top: 6,
	            fontSize: 16,
	            width: buttonStyle.width - 6,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            alignItems: 'center',
	            textAlign: 'center',
	            cursor: 'pointer',
	            color: textColor
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: buttonStyle, onTouchEnd: this.onButtonClick, onClick: this.onButtonClick },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var TextEditorContent = _react2.default.createClass({
	    displayName: 'TextEditorContent',
	    componentDidMount: function componentDidMount() {
	        document.body.ontouchend = this.changeFocus;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (!this.props.shapeTextModel && nextProps.shapeTextModel) this.checkSelection();
	    },
	    checkSelection: function checkSelection() {
	        setTimeout(function () {
	            var textArea = document.getElementById('textEditorArea');
	
	            if (textArea && textArea.innerText && textArea.innerText.length > 0) {
	                var range = document.createRange();
	                var sel = window.getSelection();
	
	                range.setStart(textArea.childNodes[0], textArea.innerText.length);
	                range.collapse(true);
	
	                sel.removeAllRanges();
	                sel.addRange(range);
	            }
	        }, 20);
	    },
	    onInputClick: function onInputClick() {
	        this.changeFocus();
	    },
	    changeFocus: function changeFocus() {
	        var textArea = document.getElementById('textEditorArea');
	
	        if (textArea) textArea.focus();
	    },
	    changeTextContent: function changeTextContent() {
	        var newValue = this.refs.textArea.innerText;
	
	        if (newValue == undefined) return;
	
	        if (newValue != this.props.shapeTextModel.htmlText) {
	            // change text data
	            var dispatch = _StoreManager2.default.getStore().dispatch;
	
	            dispatch((0, _CurrentSlideActions.changeTextProperties)(this.props.shapeTextModel, 'htmlText', newValue));
	            _SaveManager2.default.isContentChanged(true);
	
	            setTimeout(this.checkSize, 50, this.props.shapeTextModel.uuid);
	        }
	    },
	    checkSize: function checkSize(uuid) {
	        var shapeTextModel = _SelectionManager2.default.getShapeWithUuid(uuid);
	        _TextSizeUtils2.default.updateTextWrapperSize(shapeTextModel, _StoreManager2.default.getStore().dispatch, true);
	
	        setTimeout(function () {
	            var shape = _SelectionManager2.default.getShapeWithUuid(uuid);
	            _TextSizeUtils2.default.updateTextWrapperSize(shape, _StoreManager2.default.getStore().dispatch, false);
	        }, 50);
	    },
	    render: function render() {
	        var visible = 'none';
	
	        if (this.props.shapeTextModel) visible = 'block';else return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            left: 0,
	            display: visible,
	            zIndex: 20000
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.DELETE_ALERT_BACKGROUND,
	            width: this.props.windowWidth,
	            height: this.props.windowHeight,
	            top: 0,
	            left: 0,
	            opacity: 0.7
	        };
	
	        var leftGap = 100;
	        var topGap = 100;
	        var componentStyle = {
	            position: 'absolute',
	            background: 'white',
	            width: this.props.windowWidth - 2 * leftGap,
	            height: this.props.windowHeight - 2 * topGap,
	            top: 50,
	            left: leftGap,
	            borderRadius: 15
	        };
	
	        if (_PlatformDetection2.default.isIOS() && !_PlatformDetection2.default.isIOSApp()) componentStyle.top = 10;
	
	        var topBarStyle = {
	            position: 'absolute',
	            width: componentStyle.width,
	            height: 50,
	            top: 0,
	            left: 0,
	            background: '#BDC5C8',
	            borderTopLeftRadius: 15,
	            borderTopRightRadius: 15
	        };
	
	        var titleStyle = {
	            position: 'absolute',
	            top: 17,
	            width: 200,
	            left: topBarStyle.width / 2 - 100,
	            fontSize: 17,
	            fontWeight: 'bold',
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            alignItems: 'center',
	            textAlign: 'center',
	            cursor: 'default',
	            color: 'black'
	        };
	
	        var textGap = 20;
	        var topAreaStyle = {
	            position: 'absolute',
	            width: topBarStyle.width - 2 * textGap,
	            height: componentStyle.height - topBarStyle.height - 2 * textGap,
	            top: topBarStyle.height + textGap / 2,
	            padding: textGap / 2,
	            left: textGap / 2,
	            background: 'white',
	            cursor: 'text',
	            outline: 'none',
	            fontSize: 25,
	            whiteSpace: 'pre-line'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement('div', { style: backgroundStyle }),
	            _react2.default.createElement(
	                'div',
	                { style: componentStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: topBarStyle },
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 0, text: _LocalesManager2.default.getCaption('cancel', 'textEditor'), changeTextContent: this.changeTextContent }),
	                    _react2.default.createElement(Button, { dispatch: this.props.dispatch, index: 1, text: _LocalesManager2.default.getCaption('done', 'textEditor'), changeTextContent: this.changeTextContent }),
	                    _react2.default.createElement(
	                        'span',
	                        { style: titleStyle },
	                        _LocalesManager2.default.getCaption('addTextMessage', 'textEditor')
	                    )
	                ),
	                _react2.default.createElement(
	                    'span',
	                    { className: 'textShapes', ref: 'textArea', id: 'textEditorArea', style: topAreaStyle, contentEditable: true, suppressContentEditableWarning: true, onTouchEnd: this.onInputClick, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off' },
	                    this.props.shapeTextModel.htmlText
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var shapeTextModel = state.menu.textShapeTarget;
	
	    return {
	        shapeTextModel: shapeTextModel
	    };
	}
	
	var TextEditor = exports.TextEditor = (0, _reactRedux.connect)(mapStateToProps)(TextEditorContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/TextEditor.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/TextEditor.js"); } } })();

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TextStylingMenu = undefined;
	
	var _React$createClass;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _ColorPicker = __webpack_require__(330);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _FontsSelector = __webpack_require__(789);
	
	var _MenuActions = __webpack_require__(7);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var dispatch = _StoreManager2.default.getStore().dispatch;
	
	        dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            position: 'absolute',
	            top: 6,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var closeButtonStyle = {
	            position: 'absolute',
	            right: 28,
	            top: 4,
	            width: 22,
	            height: 22,
	            cursor: 'pointer',
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            background: 'none',
	            borderStyle: 'none',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var closeStyle = {
	            position: 'absolute',
	            width: 15,
	            top: 3,
	            right: 3,
	            cursor: 'pointer'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                _LocalesManager2.default.getCaption('TextStylingMenuTitle', 'textStylingMenu')
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: 'firstFocusableObjectForTextStylingMenu', style: closeButtonStyle, 'aria-label': _LocalesManager2.default.getCaption('close', 'other'), onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var shapeModel = this.getCurrentTarget();
	        var propertyType;
	        var newValue;
	
	        if (!shapeModel) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    propertyType = 'fontBold';
	                    newValue = !shapeModel.fontBold;
	                    break;
	                }
	
	            case 1:
	                {
	                    propertyType = 'fontItalic';
	                    newValue = !shapeModel.fontItalic;
	                    break;
	                }
	
	            case 2:
	                {
	                    propertyType = 'fontUnderline';
	                    newValue = !shapeModel.fontUnderline;
	                    break;
	                }
	
	            case 3:
	                {
	                    propertyType = 'fontAlign';
	                    newValue = 'left';
	                    break;
	                }
	
	            case 4:
	                {
	                    propertyType = 'fontAlign';
	                    newValue = 'center';
	                    break;
	                }
	
	            case 5:
	                {
	                    propertyType = 'fontAlign';
	                    newValue = 'right';
	                    break;
	                }
	        }
	
	        this.props.dispatch((0, _CurrentSlideActions.changeTextProperties)(shapeModel, propertyType, newValue));
	        _AudioEditorUtils2.default.addActionToHistory();
	        this.updateThumbnail();
	        _SaveManager2.default.isContentChanged(true);
	
	        setTimeout(this.checkSize, 50);
	    },
	    updateThumbnail: function updateThumbnail() {
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	    },
	    checkSize: function checkSize() {
	        var dispatch = this.props.dispatch;
	
	        var shapeModel = this.getCurrentTarget();
	
	        _TextSizeUtils2.default.updateTextWrapperSize(shapeModel, dispatch);
	    },
	    isSelected: function isSelected() {
	        var shapeModel = this.getCurrentTarget();
	        var isSelected = false;
	
	        if (!shapeModel) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Bold
	                    if (shapeModel.fontBold == true) isSelected = true;
	                    break;
	                }
	            case 1:
	                {
	                    // Italic
	                    if (shapeModel.fontItalic == true) isSelected = true;
	                    break;
	                }
	            case 2:
	                {
	                    // Underline
	                    if (shapeModel.fontUnderline == true) isSelected = true;
	                    break;
	                }
	            case 3:
	            case 4:
	            case 5:
	                {
	                    // Align
	                    if (shapeModel.fontAlign == undefined && this.props.index == 3) isSelected = true;else {
	                        if (this.props.index == 3 && shapeModel.fontAlign == 'left') isSelected = true;else if (this.props.index == 4 && shapeModel.fontAlign == 'center') isSelected = true;else if (this.props.index == 5 && shapeModel.fontAlign == 'right') isSelected = true;
	                    }
	                    break;
	                }
	        }
	
	        return isSelected;
	    },
	    getCurrentTarget: function getCurrentTarget() {
	        var state = _StoreManager2.default.getState();
	        var uuid = this.props.shapeModel.uuid;
	        var shapes = state.currentSlide.model.content;
	        var i;
	        var target;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == uuid) {
	                target = shapes[i];
	                break;
	            }
	        }
	
	        return target;
	    },
	    render: function render() {
	        var iconColor;
	        var buttonColor;
	
	        if (this.isSelected() == true) {
	            iconColor = 'white';
	            buttonColor = _Properties2.default.BROWSER_SELECTED_COLOR;
	        } else {
	            if (this.state.isOver == true) {
	                iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	            } else {
	                iconColor = 'black';
	                buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	            }
	        }
	
	        var buttonWidth = (this.props.accordionWidth - 2 * _Properties2.default.STYLING_LEFT_GAP) / 3;
	        var index = this.props.index > 2 ? this.props.index - 3 : this.props.index;
	        var left = _Properties2.default.STYLING_LEFT_GAP + index * buttonWidth;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: buttonWidth,
	            height: _Properties2.default.TEXT_STYLING_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            left: left,
	            top: 0,
	            color: 'white',
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: 'black',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial'
	        };
	
	        var cornerRadius = 8;
	
	        if (this.props.index == 0 || this.props.index == 3) {
	            buttonStyle.borderTopLeftRadius = cornerRadius;
	            buttonStyle.borderBottomLeftRadius = cornerRadius;
	        } else if (this.props.index == 2 || this.props.index == 5) {
	            buttonStyle.borderTopRightRadius = cornerRadius;
	            buttonStyle.borderBottomRightRadius = cornerRadius;
	        }
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 9,
	            left: 40,
	            color: iconColor
	        };
	
	        var icon = this.props.icon;
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            iconStyle.left = 25;
	        }
	
	        var ariaLabel;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Bold
	                    ariaLabel = _LocalesManager2.default.getCaption('bold', 'other');
	                    break;
	                }
	            case 1:
	                {
	                    // Italic
	                    ariaLabel = _LocalesManager2.default.getCaption('italic', 'other');
	                    break;
	                }
	            case 2:
	                {
	                    // Underline
	                    ariaLabel = _LocalesManager2.default.getCaption('underline', 'other');
	                    break;
	                }
	            case 3:
	                {
	                    // Left
	                    ariaLabel = _LocalesManager2.default.getCaption('leftAlignment', 'other');
	                    break;
	                }
	            case 4:
	                {
	                    // Center
	                    ariaLabel = _LocalesManager2.default.getCaption('centerAlignment', 'other');
	                    break;
	                }
	            case 5:
	                {
	                    // Right
	                    ariaLabel = _LocalesManager2.default.getCaption('rightAlignment', 'other');
	                    break;
	                }
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': ariaLabel, style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement('i', { style: iconStyle, className: icon })
	        );
	    }
	});
	
	var TextStylingMenu = exports.TextStylingMenu = _react2.default.createClass((_React$createClass = {
	    displayName: 'TextStylingMenu',
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('keydown', this.onKeyDownHandler);
	    },
	    onKeyDownHandler: function onKeyDownHandler(e) {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
	
	        if (!isTabPressed) return;
	
	        setTimeout(function () {
	            if (document.activeElement.id.indexOf('shapeMenuButton') != -1) return;
	
	            if (!this.hasParentWithId(document.activeElement, 'textStylingMenu', 8)) {
	                var element = document.getElementById('firstFocusableObjectForTextStylingMenu');
	
	                if (element) element.focus();
	            }
	        }.bind(this), 20);
	    },
	    hasParentWithId: function hasParentWithId(target, parentId, level) {
	        if (target.id == parentId) return true;
	
	        var i;
	
	        for (i = 0; i < level; i++) {
	            if (target.parentNode == undefined) {
	                return false;
	            } else {
	                target = target.parentNode;
	
	                if (target.id == parentId) return true;
	            }
	        }
	
	        return false;
	    },
	    refreshView: function refreshView() {
	        this.forceUpdate();
	    },
	    isBackgroundVisible: function isBackgroundVisible() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var target;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                target = shapes[i];
	                break;
	            }
	        }if (target.backgroundVisible == false) return false;else return true;
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var target = e.target;
	        if (!(this.hasParentWithId(target, 'fontsMenu', 6) == true || target.parentNode.className == 'scrollComponent' || target.parentNode.parentNode.className == 'scrollComponent')) this.props.dispatch((0, _MenuActions.expandFontsList)(false));
	
	        this.forceUpdate();
	    }
	}, _defineProperty(_React$createClass, 'hasParentWithId', function hasParentWithId(target, parentId, level) {
	    if (target.id == parentId) return true;
	
	    var i;
	
	    for (i = 0; i < level; i++) {
	        if (target.parentNode == undefined) {
	            return false;
	        } else {
	            target = target.parentNode;
	
	            if (target.id == parentId) return true;
	        }
	    }
	
	    return false;
	}), _defineProperty(_React$createClass, 'shouldComponentUpdate', function shouldComponentUpdate(newProps, nextState) {
	    if (this.props.contextTarget != newProps.contextTarget || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	}), _defineProperty(_React$createClass, 'render', function render() {
	    var menuStyle = {
	        position: 'absolute',
	        top: 0,
	        right: 0,
	        width: this.props.accordionWidth,
	        height: this.props.windowHeight,
	        overflowX: 'hidden',
	        overflowY: 'hidden',
	        backgroundColor: 'white'
	    };
	
	    var topPosition = _Properties2.default.CLIPART_BUTTON_HEIGHT + 2 * _Properties2.default.STYLING_TOP_GAP + _Properties2.default.EFFECTS_BUTTON_HEIGHT;
	
	    var fontStyle = {
	        position: 'absolute',
	        top: topPosition
	    };
	
	    topPosition = topPosition + _Properties2.default.TEXT_STYLING_BUTTON_HEIGHT + _Properties2.default.STYLING_TOP_GAP;
	
	    var alignStyle = {
	        position: 'absolute',
	        top: topPosition
	    };
	
	    topPosition = topPosition + _Properties2.default.TEXT_STYLING_BUTTON_HEIGHT + _Properties2.default.STYLING_TOP_GAP;
	
	    var colorPickerTopPosition = topPosition;
	
	    var leftPosition = 0;
	
	    if (this.props.accordionWidth > _Properties2.default.BROWSER_WIDTH) leftPosition = (this.props.accordionWidth - _Properties2.default.BROWSER_WIDTH) / 2;
	
	    var elementsHolder = {
	        position: 'absolute',
	        top: 0,
	        left: leftPosition,
	        width: this.props.accordionWidth,
	        height: this.props.windowHeight,
	        cursor: 'default',
	        overflowX: 'auto'
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { id: 'textStylingMenu', style: menuStyle, onTouchStart: this.onClick, onMouseDown: this.onClick },
	        _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	        _react2.default.createElement(
	            'div',
	            { style: elementsHolder },
	            _react2.default.createElement(_FontsSelector.FontsSelector, { accordionWidth: _Properties2.default.BROWSER_WIDTH, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, top: _Properties2.default.CLIPART_BUTTON_HEIGHT + _Properties2.default.STYLING_TOP_GAP }),
	            _react2.default.createElement(
	                'div',
	                { style: fontStyle, onClick: this.refreshView },
	                _react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, index: 0, dispatch: this.props.dispatch, shapeModel: this.props.contextTarget, icon: 'fa fa-bold' }),
	                _react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, index: 1, dispatch: this.props.dispatch, shapeModel: this.props.contextTarget, icon: 'fa fa-italic' }),
	                _react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, index: 2, dispatch: this.props.dispatch, shapeModel: this.props.contextTarget, icon: 'fa fa-underline' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: alignStyle, onClick: this.refreshView },
	                _react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, index: 3, dispatch: this.props.dispatch, shapeModel: this.props.contextTarget, icon: 'fa fa-align-left' }),
	                _react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, index: 4, dispatch: this.props.dispatch, shapeModel: this.props.contextTarget, icon: 'fa fa-align-center' }),
	                _react2.default.createElement(Button, { accordionWidth: _Properties2.default.BROWSER_WIDTH, index: 5, dispatch: this.props.dispatch, shapeModel: this.props.contextTarget, icon: 'fa fa-align-right' })
	            ),
	            _react2.default.createElement(_ColorPicker.ColorPicker, { id: 'textStylingMenuLastFocusableElement', accordionWidth: _Properties2.default.BROWSER_WIDTH, tab: this.props.tab, topPosition: colorPickerTopPosition, shapeModel: this.props.contextTarget, dispatch: this.props.dispatch, type: 'textProperties' })
	        )
	    );
	}), _React$createClass));
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/TextStylingMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/TextStylingMenu.js"); } } })();

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ZoomMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _reactRedux = __webpack_require__(10);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _ApiServiceUtils = __webpack_require__(23);
	
	var _ApiServiceUtils2 = _interopRequireDefault(_ApiServiceUtils);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 20,
	            top: 0
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            cursor: 'default',
	            position: 'absolute',
	            top: 6
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                _LocalesManager2.default.getCaption('Title', 'zoom')
	            )
	        );
	    }
	});
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // ZOOM
	                    this.props.dispatch((0, _CurrentSlideActions.updateHospot)(_ZoomUtils2.default.currentBackgroundUid, _ZoomUtils2.default.currentHotspot));
	                    _AudioEditorUtils2.default.addActionToHistory();
	                    this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	                    this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	                    this.props.dispatch((0, _MenuActions.showZoomSlides)(false));
	                    _SaveManager2.default.isContentChanged(true);
	                    break;
	                }
	
	            case 1:
	                {
	                    // RESET ZOOM
	                    if (this.isResetEnabled() == true) {
	                        _SaveManager2.default.isContentChanged(true);
	                        this.props.dispatch((0, _CurrentSlideActions.updateHospot)(_ZoomUtils2.default.currentBackgroundUid, ''));
	                        _AudioEditorUtils2.default.addActionToHistory();
	                        this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	                        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	                        this.props.dispatch((0, _MenuActions.showZoomSlides)(false));
	                    }
	                    break;
	                }
	
	            case 2:
	                {
	                    // CANCEL
	                    this.props.dispatch((0, _MenuActions.showZoomSlides)(false));
	                    break;
	                }
	        }
	    },
	    isResetEnabled: function isResetEnabled() {
	        if (this.props.index != 1) return false;
	
	        var state = _StoreManager2.default.getState();
	        var background = state.currentSlide.model.content[0];
	
	        if (background.hotSpot != undefined && background.hotSpot != '') return true;else return false;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth) return true;else return false;
	    },
	    render: function render() {
	        var iconColor;
	        var buttonColor;
	        var tabIndexValue;
	
	        if (this.props.index == 0) {
	            if (this.state.isOver == true) {
	                iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	            } else {
	                iconColor = 'black';
	                buttonColor = '#48A5E5';
	            }
	        } else if (this.props.index == 1 && this.isResetEnabled() == false) {
	            iconColor = '#CFCFCF';
	            buttonColor = '#EEEEEE';
	            tabIndexValue = '-1';
	        } else {
	            if (this.state.isOver == true) {
	                iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	                buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	            } else {
	                iconColor = 'black';
	                buttonColor = '#DCDCDC';
	            }
	        }
	
	        var topPosition = 5 + this.props.index * (_Properties2.default.OBJECT_ADVANCED_BUTTON_HEIGHT + 5);
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.accordionWidth - _Properties2.default.BROWSER_LEFT_PADDING,
	            height: _Properties2.default.OBJECT_ADVANCED_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: _Properties2.default.BROWSER_LEFT_PADDING,
	            top: topPosition,
	            color: 'white',
	            margin: 0,
	            paddingTop: 0,
	            paddingBottom: 0,
	            paddingRight: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            fontSize: 18,
	            textAlign: 'center',
	            width: buttonStyle.width
	        };
	
	        var buttonId;
	
	        if (this.props.index == 0) buttonId = 'zoomMenuFirstFocusableElement';
	
	        if (this.props.index == 2) buttonId = 'zoomMenuLastFocusableElement';
	
	        return _react2.default.createElement(
	            'button',
	            { id: buttonId, 'aria-label': this.props.text, tabIndex: tabIndexValue, 'aria-disabled': tabIndexValue == '-1' ? true : false, style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onKeyDown: this.onKeyDown },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.text
	            )
	        );
	    }
	});
	
	var ZoomMenuContent = _react2.default.createClass({
	    displayName: 'ZoomMenuContent',
	    componentWillReceiveProps: function componentWillReceiveProps() {
	        if (_PlatformDetection2.default.isIOS()) return;
	
	        setTimeout(function () {
	            var element = document.getElementById('zoomMenuFirstFocusableElement');
	
	            if (element) element.focus();
	        }.bind(this), 30);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth || this.props.showZoomSlides != newProps.showZoomSlides) return true;else return false;
	    },
	    render: function render() {
	        if (this.props.showZoomSlides == false) return _react2.default.createElement('div', null);
	
	        var menuStyle = {
	            position: 'absolute',
	            top: _ApiServiceUtils2.default.getNoInternetConnectionAlertHeight(),
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white',
	            zIndex: 20000
	        };
	
	        var buttonsHolderStyle = {
	            position: 'absolute',
	            top: _Properties2.default.CLIPART_BUTTON_HEIGHT
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle, id: 'zoomMenu' },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth }),
	            _react2.default.createElement(
	                'div',
	                { style: buttonsHolderStyle },
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 0, dispatch: this.props.dispatch, icon: 'fa fa-search', text: _LocalesManager2.default.getCaption('SetZoom', 'zoom') }),
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 1, dispatch: this.props.dispatch, icon: 'fa fa-trash-o', text: _LocalesManager2.default.getCaption('ResetZoom', 'zoom') }),
	                _react2.default.createElement(Button, { accordionWidth: this.props.accordionWidth, index: 2, dispatch: this.props.dispatch, icon: 'fa fa-times-circle-o', text: _LocalesManager2.default.getCaption('Cancel', 'save') })
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var showZoomSlides = state.menu.showZoomSlides;
	
	    if (showZoomSlides == undefined) showZoomSlides = false;
	
	    return {
	        showZoomSlides: showZoomSlides
	    };
	}
	
	var ZoomMenu = exports.ZoomMenu = (0, _reactRedux.connect)(mapStateToProps)(ZoomMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ZoomMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/ZoomMenu.js"); } } })();

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TextEditorTool = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _MenuActions = __webpack_require__(7);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _EditTextArea = __webpack_require__(830);
	
	var _TextBoxArea = __webpack_require__(832);
	
	var _CollorButtonsArea = __webpack_require__(829);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	var _InsertImageArea = __webpack_require__(831);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Title = _react2.default.createClass({
	    displayName: 'Title',
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    render: function render() {
	        var titleStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.BROWSER_SELECTED_COLOR,
	            width: this.props.accordionWidth,
	            height: _Properties2.default.CLIPART_BUTTON_HEIGHT,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 10,
	            top: this.props.topPosition
	        };
	
	        var spanStyle = {
	            color: 'white',
	            fontSize: 16,
	            position: 'absolute',
	            top: 6,
	            width: this.props.accordionWidth - 3 * _Properties2.default.BROWSER_LEFT_PADDING,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        var text = void 0;
	        var rightElement = void 0;
	
	        if (this.props.topPosition === 0 && !this.props.insertImage) {
	            var closeButtonStyle = {
	                position: 'absolute',
	                right: 18,
	                top: 4,
	                width: 22,
	                height: 22,
	                cursor: 'pointer',
	                userDrag: 'none',
	                WebkitUserSelect: 'none',
	                userSelect: 'none',
	                background: 'none',
	                borderStyle: 'none',
	                margin: 0,
	                padding: 0,
	                boxSizing: 'initial',
	                fontSize: 'initial'
	            };
	
	            var closeStyle = {
	                position: 'absolute',
	                width: 15,
	                top: 4,
	                right: 4,
	                cursor: 'pointer',
	                zIndex: 1000
	            };
	
	            text = _HoverManager2.default.getText('editText');
	
	            rightElement = _react2.default.createElement(
	                'button',
	                { id: 'firstFocusableObjectForTextEditorTool', style: closeButtonStyle, 'aria-label': _LocalesManager2.default.getCaption('close', 'other'), onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: closeStyle, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png' })
	            );
	        } else {
	            var iconStyle = {
	                position: 'absolute',
	                width: 15,
	                top: 7,
	                right: 20,
	                cursor: 'default',
	                color: 'white'
	            };
	
	            if (this.props.insertImage) text = _HoverManager2.default.getText('insertImageTitle');else text = _HoverManager2.default.getText('editTextElement');
	
	            rightElement = _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-angle-down' });
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: titleStyle },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                text
	            ),
	            rightElement
	        );
	    }
	});
	
	var TextEditorToolContent = _react2.default.createClass({
	    displayName: 'TextEditorToolContent',
	    getInitialState: function getInitialState() {
	        return {
	            fontColorsExpanded: false,
	            shapeType: this.props.contextTarget.type,
	            fillStrokeMenu: 'none'
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.checkDefaultFont();
	
	        document.addEventListener('keydown', this.onKeyDownHandler);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('keydown', this.onKeyDownHandler);
	    },
	    onKeyDownHandler: function onKeyDownHandler(e) {
	        if (e.keyCode === 9 || e.keyCode === 13) // TAB or ENTER
	            return;
	
	        if (_TextEditorUtils2.default.selectedTextShape === '') return;
	
	        if (document.activeElement.id && document.activeElement.id.indexOf('text_area_' + _TextEditorUtils2.default.selectedTextShape) != -1) return;
	
	        if (e.keyCode === 27) {
	            // Escape
	            this.props.dispatch((0, _MenuActions.expandFontsList)(false));
	            this.props.dispatch((0, _MenuActions.expandFontSizeList)(false));
	            this.props.dispatch((0, _MenuActions.expandFontLineHeight)(false));
	
	            this.setTextFocus();
	        } else if (_TextEditorUtils2.default.isPrintableCharacter(e.keyCode)) {
	            // printable character
	            this.props.dispatch((0, _MenuActions.expandFontsList)(false));
	            this.props.dispatch((0, _MenuActions.expandFontSizeList)(false));
	            this.props.dispatch((0, _MenuActions.expandFontLineHeight)(false));
	
	            this.setTextFocus({ key: e.key, keyCode: e.keyCode });
	        }
	    },
	    checkDefaultFont: function checkDefaultFont() {
	        // Force styling with css
	        try {
	            document.execCommand("styleWithCSS", false, true);
	        } catch (e) {
	            try {
	                document.execCommand("useCSS", false, true);
	            } catch (er) {}
	        }
	
	        this.executeButtonCommand(14, _TextEditorUtils2.default.currentFont); // set font to the current one ... Cabin is default if nothing was set on a new production
	        this.executeButtonCommand(16, _TextEditorUtils2.default.currentFontSize, true);
	    },
	    onEditorClick: function onEditorClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var target = e.target;
	
	        if (!(this.hasParentWithId(target, 'fontsMenu', 6) === true || target.parentNode.className === 'scrollComponent' || target.parentNode.parentNode.className === 'scrollComponent')) this.props.dispatch((0, _MenuActions.expandFontsList)(false));
	
	        if (!(this.hasParentWithId(target, 'fontSizeMenu', 6) === true || target.parentNode.className === 'scrollComponent' || target.parentNode.parentNode.className === 'scrollComponent')) this.props.dispatch((0, _MenuActions.expandFontSizeList)(false));
	
	        if (!(this.hasParentWithId(target, 'fontLineHeightMenu', 3) === true || target.className === 'lineHeightButton' || target.parentNode.className === 'scrollComponent' || target.parentNode.parentNode.className === 'scrollComponent')) this.props.dispatch((0, _MenuActions.expandFontLineHeight)(false));
	    },
	    hasParentWithId: function hasParentWithId(target, parentId, level) {
	        if (target.id === parentId) return true;
	
	        var i = void 0;
	
	        for (i = 0; i < level; i++) {
	            if (target.parentNode === undefined) {
	                return false;
	            } else {
	                target = target.parentNode;
	
	                if (target.id === parentId) return true;
	            }
	        }
	
	        return false;
	    },
	    forceUpdateTextEditor: function forceUpdateTextEditor(value) {
	        if (value && value.length > 0) {
	            this.setState({
	                fillStrokeMenu: value
	            });
	        }
	
	        setTimeout(function () {
	            this.forceUpdate();
	        }.bind(this), 5);
	    },
	    setTextFocus: function setTextFocus(keyboardCharacter) {
	        setTimeout(function () {
	            var textArea = document.getElementById('text_area_' + this.props.contextTarget.uuid);
	
	            if (textArea) {
	                textArea.focus();
	
	                if (keyboardCharacter) _TextEditorUtils2.default.setCursorAtLastPosition(textArea, this.props.contextTarget, keyboardCharacter);
	            }
	        }.bind(this), 5);
	    },
	    getContextTarget: function getContextTarget() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	
	        for (var i = 1; i < shapes.length; i++) {
	            if (shapes[i].uuid === this.props.contextTarget.uuid) return shapes[i];
	        }
	
	        return this.props.contextTarget;
	    },
	    executeChangeShapeTypeCommand: function executeChangeShapeTypeCommand(uuid, type) {
	        _TextEditorUtils2.default.resetActions();
	
	        if (type === this.state.type) return;
	
	        var textArea = document.getElementById('text_area_' + uuid);
	
	        _TextEditorUtils2.default.saveSelection(textArea);
	
	        if (textArea) {
	            var newValue = textArea.innerHTML;
	
	            if (newValue != undefined) {
	                this.props.dispatch((0, _CurrentSlideActions.changeRichTextContent)(uuid, newValue));
	                _SaveManager2.default.isContentChanged(true);
	            }
	        }
	
	        setTimeout(function () {
	            this.props.dispatch((0, _CurrentSlideActions.changeShapeType)(uuid, type));
	
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.refreshTextEditorTool)());
	                this.forceUpdateTextEditor();
	
	                _TextEditorUtils2.default.restoreSelection(document.getElementById('text_area_' + uuid));
	                this.checkDefaultFont();
	            }.bind(this), 30);
	        }.bind(this), 5);
	
	        this.setState({
	            shapeType: type
	        });
	    },
	    executeColorPickerCommand: function executeColorPickerCommand(type, value) {
	        var contextTarget = this.getContextTarget();
	
	        switch (type) {
	            case 'changeShapeFillVisibility':
	                {
	                    this.props.dispatch((0, _CurrentSlideActions.changeShapeFillVisibility)(contextTarget.uuid, false));
	                    break;
	                }
	            case 'changeShapeFillColor':
	                {
	                    this.props.dispatch((0, _CurrentSlideActions.changeShapeFillVisibility)(contextTarget.uuid, true));
	                    this.props.dispatch((0, _CurrentSlideActions.changeShapeFillColor)(contextTarget, value));
	                    break;
	                }
	            case 'changeShapeStrokeOpacity':
	                {
	                    this.props.dispatch((0, _CurrentSlideActions.changeShapeStrokeOpacity)(contextTarget, 0));
	                    break;
	                }
	            case 'changeShapeStrokeColor':
	                {
	                    this.props.dispatch((0, _CurrentSlideActions.changeShapeStrokeColor)(contextTarget, value));
	                    break;
	                }
	            case 'changeFontColor':
	                {
	                    this.executeButtonCommand(17, value);
	                    break;
	                }
	            case 'changeStrokeSize':
	                {
	                    if (contextTarget.strokeWidth != value) this.props.dispatch((0, _CurrentSlideActions.changeStrokeSize)(contextTarget, value));
	                    break;
	                }
	        }
	
	        this.forceUpdateTextEditor();
	    },
	    executeButtonCommand: function executeButtonCommand(index, value) {
	        var useCurrentFontSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	        switch (index) {
	            // line 1
	            case 0:
	                {
	                    // open Font color pallete
	                    break;
	                }
	
	            case 1:
	                {
	                    // bold
	                    document.execCommand('bold', false, undefined);
	                    break;
	                }
	            case 2:
	                {
	                    // italic
	                    document.execCommand('italic', false);
	                    break;
	                }
	            case 3:
	                {
	                    // underline
	                    document.execCommand('underline', false);
	                    break;
	                }
	
	            case 4:
	                {
	                    // left aling
	                    document.execCommand('justifyleft', false, undefined);
	                    break;
	                }
	            case 5:
	                {
	                    // center aling
	                    document.execCommand('justifycenter', false, undefined);
	                    break;
	                }
	            case 6:
	                {
	                    // right aling
	                    document.execCommand('justifyright', false, undefined);
	                    break;
	                }
	
	            // line 2
	            case 7:
	                {
	                    // ordered list
	                    document.execCommand('insertorderedlist', false);
	                    break;
	                }
	            case 8:
	                {
	                    // point list
	                    document.execCommand('insertunorderedlist', false);
	                    break;
	                }
	            case 9:
	                {
	                    // increase indent
	                    document.execCommand('indent', false);
	                    break;
	                }
	            case 10:
	                {
	                    // decrease indent
	                    document.execCommand('outdent', false);
	                    break;
	                }
	
	            case 11:
	                {
	                    // superscript
	                    document.execCommand('superscript', false);
	                    break;
	                }
	            case 12:
	                {
	                    // subscript
	                    document.execCommand('subscript', false);
	                    break;
	                }
	
	            case 13:
	                {
	                    // show Line height menu
	                    var isExpanded = !this.props.fontLineHeightIsExpanded;
	                    this.props.dispatch((0, _MenuActions.expandFontLineHeight)(isExpanded));
	                    break;
	                }
	
	            // line 0
	            case 14:
	                {
	                    // font family
	                    _TextEditorUtils2.default.currentFont = value;
	                    document.execCommand('fontname', false, value);
	                    break;
	                }
	
	            case 15: // decrease font
	            case 16:
	                {
	                    // increase font or add it from the expanded list
	                    var currentFontSize = useCurrentFontSize ? value : _TextEditorUtils2.default.getCommandValue('fontsize');
	                    var selection = window.getSelection();
	
	                    _TextEditorUtils2.default.currentFontSize = currentFontSize;
	                    _TextEditorUtils2.default.updateSize = false;
	
	                    document.execCommand('fontsize', false, '7'); // values from 1 to 7
	
	                    if (selection.anchorOffset === selection.extentOffset) {
	                        // no text selected and only the cursor pointer
	                        _TextEditorUtils2.default.updateSize = true; // update shape size only when fontSize attribute is set properly
	                    } else {
	                        // at least 1 character selected
	                        var currentElement = selection.anchorNode.parentNode;
	                        currentElement.removeAttribute('size');
	                        currentElement.style.fontSize = currentFontSize + 'px';
	
	                        _TextEditorUtils2.default.updateSize = true; // update shape size only when fontSize attribute is set properly
	                        _TextEditorUtils2.default.updateShapeSize(this.props.contextTarget, this.props.dispatch);
	                    }
	
	                    break;
	                }
	
	            case 17:
	                {
	                    // font color
	                    document.execCommand('forecolor', false, value);
	                    break;
	                }
	
	            case 18:
	                {
	                    // change line height
	                    this.props.dispatch((0, _CurrentSlideActions.changeTextLineHeight)(this.props.contextTarget.uuid, value));
	
	                    setTimeout(function () {
	                        _TextEditorUtils2.default.updateShapeSize(this.getContextTarget(), this.props.dispatch); // get new shapeModel from the main state after the lineHeight is changed
	                    }.bind(this), 1);
	                    break;
	                }
	        }
	
	        this.forceUpdateTextEditor();
	    },
	    checkFontColors: function checkFontColors(value) {
	        this.setState({
	            fontColorsExpanded: value
	        });
	    },
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            top: 0,
	            right: 0,
	            width: this.props.accordionWidth,
	            height: this.props.windowHeight,
	            overflowX: 'hidden',
	            overflowY: 'hidden',
	            backgroundColor: 'white'
	        };
	
	        var target = this.getContextTarget();
	        var topExtraPadding = 5;
	        var gridSize = 34;
	        var lineElementTopPadding = 15;
	        var lineHeight = gridSize + lineElementTopPadding;
	        var leftGap = (this.props.accordionWidth - 9 * gridSize) / 2;
	        var width = this.props.accordionWidth - 2 * leftGap;
	        var palleteColorHeight = this.state.fontColorsExpanded ? 2 * gridSize + 2 * lineElementTopPadding : 0;
	        var topHolderHeight = 3 * lineHeight + palleteColorHeight + lineElementTopPadding;
	
	        var fillStrokeMenuHolder = {
	            position: 'absolute',
	            top: 2 * _Properties2.default.CLIPART_BUTTON_HEIGHT + topExtraPadding + topHolderHeight,
	            left: leftGap,
	            width: width
	        };
	
	        var elementWidth = Math.floor(width / 6);
	        var collorButtonsAreaTop = elementWidth + 2 * lineElementTopPadding;
	        var insertImageHolder = void 0;
	
	        if (target.type === _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE && target.isMindMap) {
	            var insertImageHolderTop = fillStrokeMenuHolder.top + 143;
	
	            if (this.state.fillStrokeMenu === 'changeShapeFillColor') insertImageHolderTop = insertImageHolderTop + 72;else if (this.state.fillStrokeMenu === 'changeShapeStrokeColor') insertImageHolderTop = insertImageHolderTop + 130;
	
	            var insertImageHolderStyle = {
	                position: 'absolute',
	                top: insertImageHolderTop,
	                width: this.props.accordionWidth
	            };
	
	            insertImageHolder = _react2.default.createElement(
	                'div',
	                { style: insertImageHolderStyle },
	                _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth, topPosition: 0, insertImage: true }),
	                _react2.default.createElement(_InsertImageArea.InsertImageArea, { top: _Properties2.default.CLIPART_BUTTON_HEIGHT + lineElementTopPadding, width: this.props.accordionWidth, gridSize: gridSize, contextTarget: target, forceUpdateTextEditor: this.forceUpdateTextEditor })
	            );
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'textEditorTool', style: menuStyle, onTouchStart: this.onEditorClick, onMouseDown: this.onEditorClick },
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth, topPosition: 0, dispatch: this.props.dispatch }),
	            _react2.default.createElement(_EditTextArea.EditTextArea, { width: width, height: topHolderHeight, top: _Properties2.default.CLIPART_BUTTON_HEIGHT + topExtraPadding, gridSize: gridSize, lineElementTopPadding: lineElementTopPadding, gap: leftGap, palleteColorHeight: palleteColorHeight, checkFontColors: this.checkFontColors, executeCommand: this.executeButtonCommand, executeColorPickerCommand: this.executeColorPickerCommand, fontLineHeightIsExpanded: this.props.fontLineHeightIsExpanded, contextTarget: target, forceUpdateTextEditor: this.forceUpdateTextEditor }),
	            _react2.default.createElement(Title, { accordionWidth: this.props.accordionWidth, topPosition: _Properties2.default.CLIPART_BUTTON_HEIGHT + topExtraPadding + topHolderHeight }),
	            _react2.default.createElement(
	                'div',
	                { style: fillStrokeMenuHolder },
	                _react2.default.createElement(_TextBoxArea.TextBoxArea, { executeCommand: this.executeChangeShapeTypeCommand, width: width, topGap: lineElementTopPadding, elementWidth: elementWidth, contextTarget: target }),
	                _react2.default.createElement(_CollorButtonsArea.CollorButtonsArea, { top: collorButtonsAreaTop, width: width, topGap: lineElementTopPadding, gridSize: gridSize, forceUpdateTextEditor: this.forceUpdateTextEditor, executeCommand: this.executeColorPickerCommand, contextTarget: target, dispatch: this.props.dispatch })
	            ),
	            insertImageHolder
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var refreshTextEditorTool = state.menu.refreshTextEditorTool;
	    var fontLineHeightIsExpanded = state.menu.fontLineHeightIsExpanded;
	
	    return {
	        refreshTextEditorTool: refreshTextEditorTool,
	        fontLineHeightIsExpanded: fontLineHeightIsExpanded
	    };
	}
	
	var TextEditorTool = exports.TextEditorTool = (0, _reactRedux.connect)(mapStateToProps)(TextEditorToolContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/TextEditorTool.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/TextEditorTool.js"); } } })();

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CollorButtonsArea = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _ColorPallete = __webpack_require__(234);
	
	var _BorderStyleArea = __webpack_require__(833);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditShapeButton = _react2.default.createClass({
	    displayName: 'EditShapeButton',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var value = this.props.index === this.props.selectedButton ? -1 : this.props.index;
	
	        this.props.selectButton(value);
	
	        this.setState({
	            isOver: false
	        });
	    },
	    getLefPosition: function getLefPosition() {
	        var leftPosition = 0;
	        var buttonSize = this.props.width;
	        var gap = this.props.gap;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    leftPosition = 0;
	                    break;
	                }
	            case 1:
	                {
	                    leftPosition = buttonSize + gap;
	                    break;
	                }
	        }
	
	        return leftPosition;
	    },
	    isSelected: function isSelected() {
	        var value = false;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Fill color
	                    return this.props.selectedButton === 0;
	                }
	            case 1:
	                {
	                    // Stroke color
	                    return this.props.selectedButton === 1;
	                }
	        }
	
	        return value;
	    },
	    getLabel: function getLabel() {
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Fill color
	                    return _HoverManager2.default.getText('fillColor');
	                }
	            case 1:
	                {
	                    // Stroke color
	                    return _HoverManager2.default.getText('borderColor');
	                }
	        }
	    },
	    getIcon: function getIcon() {
	        var host = void 0;
	
	        if (_Configuration2.default.LOAD_LOCAL === true) host = '';else host = _AppParameters2.default.RESOURCES_LOCATION();
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // Fill color
	                    return host + 'assets/textEditor/fillColor';
	                }
	            case 1:
	                {
	                    // Stroke color
	                    return host + 'assets/textEditor/strokeColor';
	                }
	        }
	    },
	    render: function render() {
	        var buttonWidth = this.props.width;
	        var buttonHeight = this.props.height;
	        var isSelected = this.isSelected();
	        var backgroundColor = isSelected ? '#0078a3' : this.state.isOver ? '#edefff' : '#f9f9f9';
	        var textColor = isSelected ? '#ffffff' : '#000000';
	
	        var buttonStyle = {
	            position: 'absolute',
	            top: 0,
	            width: buttonWidth,
	            height: buttonHeight,
	            left: this.getLefPosition(),
	            cursor: 'pointer',
	            background: backgroundColor,
	            borderRadius: 4,
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#c4c4c4'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 1,
	            left: 5,
	            width: 23,
	            height: 23,
	            pointerEvents: 'none'
	        };
	
	        var spanElement = void 0;
	
	        if (this.props.index === 2) {
	            iconStyle.width = 30;
	            iconStyle.height = 30;
	            iconStyle.top = 2;
	        } else {
	            var colorHeight = 4;
	            var colorStyle = {
	                position: 'absolute',
	                bottom: colorHeight - 2,
	                left: 5,
	                width: 23,
	                height: colorHeight,
	                background: this.props.currentColor,
	                borderRadius: 50,
	                borderStyle: 'solid',
	                borderWidth: 1,
	                borderColor: '#c4c4c4',
	                pointerEvents: 'none'
	            };
	
	            spanElement = _react2.default.createElement('span', { style: colorStyle });
	        }
	
	        var titleStyle = {
	            position: 'absolute',
	            top: 10,
	            right: 0,
	            width: buttonWidth - 30,
	            fontSize: 11,
	            color: textColor,
	            textAlign: 'center',
	            pointerEvents: 'none'
	        };
	
	        var icon = this.getIcon();
	
	        if (isSelected) icon = icon + '_white.svg';else icon = icon + '.svg';
	
	        return _react2.default.createElement(
	            'button',
	            { id: this.props.id, 'aria-label': this.getLabel(), style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: icon }),
	            spanElement,
	            _react2.default.createElement(
	                'span',
	                { style: titleStyle },
	                this.getLabel()
	            )
	        );
	    }
	});
	
	var CollorButtonsArea = exports.CollorButtonsArea = _react2.default.createClass({
	    displayName: 'CollorButtonsArea',
	    getInitialState: function getInitialState() {
	        return {
	            selectedButton: -1,
	            selectedMenu: 'none'
	        };
	    },
	    showMenu: function showMenu(value) {
	        this.setState({
	            selectedMenu: value
	        });
	    },
	    selectButton: function selectButton(value) {
	        var val = value === this.state.selectedButton ? -1 : value;
	        var menuValue = 'none';
	
	        this.setState({
	            selectedButton: val
	        });
	
	        switch (val) {
	            case -1:
	                {
	                    menuValue = 'none';
	                    break;
	                }
	            case 0:
	                {
	                    menuValue = 'changeShapeFillColor';
	                    break;
	                }
	            case 1:
	                {
	                    menuValue = 'changeShapeStrokeColor';
	                    break;
	                }
	        }
	
	        this.showMenu(menuValue);
	        this.props.forceUpdateTextEditor(menuValue);
	    },
	    getCurrentColor: function getCurrentColor(type) {
	        var color = '#000000';
	
	        if (type === 'changeShapeFillColor') color = this.props.contextTarget.fill;else {
	            if (type === 'changeShapeStrokeColor') color = this.props.contextTarget.stroke;
	        }
	
	        color = _TextSizeUtils2.default.getCorrectColor(color);
	
	        return color;
	    },
	    render: function render() {
	        var isSimpleBox = this.props.contextTarget.type === _ShapeConstants2.default.TEXTBOXSIMPLE ? true : false;
	
	        if (isSimpleBox) return _react2.default.createElement('div', null);
	
	        var gap = 10;
	        var elementWidth = Math.floor((this.props.width - gap) / 2);
	        var elementHeight = this.props.gridSize;
	
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.width,
	            top: this.props.top
	        };
	
	        var buttonsHolderStyle = {
	            position: 'absolute',
	            top: this.props.topGap
	        };
	
	        var colorElementSize = this.props.width / 10;
	        var menuElement = void 0;
	        var idValue = void 0;
	
	        if (this.state.selectedMenu === 'changeShapeFillColor') {
	            menuElement = _react2.default.createElement(_ColorPallete.ColorPallete, { type: this.state.selectedMenu, currentColor: this.getCurrentColor(this.state.selectedMenu), executeCommand: this.props.executeCommand, top: this.props.topGap + elementHeight, topGap: this.props.topGap, width: this.props.width, gridSize: colorElementSize, contextTarget: this.props.contextTarget, forceUpdateTextEditor: this.props.forceUpdateTextEditor });
	        } else if (this.state.selectedMenu === 'changeShapeStrokeColor') {
	            menuElement = _react2.default.createElement(_BorderStyleArea.BorderStyleArea, { top: elementHeight + this.props.topGap, width: this.props.width, executeCommand: this.props.executeCommand, contextTarget: this.props.contextTarget, type: this.state.selectedMenu, currentColor: this.getCurrentColor(this.state.selectedMenu), topGap: this.props.topGap, gridSize: colorElementSize, dispatch: this.props.dispatch, forceUpdateTextEditor: this.props.forceUpdateTextEditor });
	        } else {
	            if (!this.props.contextTarget.isMindMap) idValue = 'lastFocusableObjectForTextEditorTool';
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(
	                'div',
	                { style: buttonsHolderStyle },
	                _react2.default.createElement(EditShapeButton, { index: 0, selectedButton: this.state.selectedButton, selectButton: this.selectButton, currentColor: this.getCurrentColor('changeShapeFillColor'), width: elementWidth, height: elementHeight, gap: gap }),
	                _react2.default.createElement(EditShapeButton, { index: 1, selectedButton: this.state.selectedButton, selectButton: this.selectButton, currentColor: this.getCurrentColor('changeShapeStrokeColor'), width: elementWidth, height: elementHeight, gap: gap, id: idValue })
	            ),
	            menuElement
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/CollorButtonsArea.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/CollorButtonsArea.js"); } } })();

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.EditTextArea = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _FontMenu = __webpack_require__(836);
	
	var _FontSizeView = __webpack_require__(837);
	
	var _FontLineHeightMenu = __webpack_require__(835);
	
	var _ColorPallete = __webpack_require__(234);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            isButtonSelected: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        switch (this.props.index) {
	            // line 1
	            case 0:
	                {
	                    // A
	                    _HoverManager2.default.show(this.refs.button, 'fontColor', 'top');
	                    break;
	                }
	
	            case 1:
	                {
	                    // B
	                    _HoverManager2.default.show(this.refs.button, 'bold', 'top');
	                    break;
	                }
	            case 2:
	                {
	                    // I
	                    _HoverManager2.default.show(this.refs.button, 'italic', 'top');
	                    break;
	                }
	            case 3:
	                {
	                    // U
	                    _HoverManager2.default.show(this.refs.button, 'underline', 'top');
	                    break;
	                }
	
	            case 4:
	                {
	                    // Left align
	                    _HoverManager2.default.show(this.refs.button, 'leftAlign', 'top');
	                    break;
	                }
	            case 5:
	                {
	                    // Center align
	                    _HoverManager2.default.show(this.refs.button, 'centerAlign', 'top');
	                    break;
	                }
	            case 6:
	                {
	                    // Right align
	                    _HoverManager2.default.show(this.refs.button, 'rightAlign', 'left');
	                    break;
	                }
	
	            /*** line 2 ****/
	
	            case 7:
	                {
	                    _HoverManager2.default.show(this.refs.button, 'orderedList', 'top');
	                    break;
	                }
	            case 8:
	                {
	                    _HoverManager2.default.show(this.refs.button, 'bulletList', 'top');
	                    break;
	                }
	            case 9:
	                {
	                    _HoverManager2.default.show(this.refs.button, 'ident', 'top');
	                    break;
	                }
	            case 10:
	                {
	                    _HoverManager2.default.show(this.refs.button, 'outdent', 'top');
	                    break;
	                }
	
	            case 11:
	                {
	                    _HoverManager2.default.show(this.refs.button, 'superscript', 'top');
	                    break;
	                }
	            case 12:
	                {
	                    _HoverManager2.default.show(this.refs.button, 'subscript', 'top');
	                    break;
	                }
	
	            case 13:
	                {
	                    _HoverManager2.default.show(this.refs.button, 'lineHeight', 'left');
	                    break;
	                }
	        }
	
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (e.target && e.target.className.length > 0 && e.target.className.indexOf('lineHeightButton') != -1) return;
	
	        if (this.props.index === 0) {
	            this.props.showColorPallete(!this.state.isButtonSelected);
	
	            this.setState({
	                isButtonSelected: !this.state.isButtonSelected
	            });
	        }
	
	        _TextEditorUtils2.default.executeAction(this.props.index);
	        this.props.executeCommand(this.props.index);
	
	        this.updateButtonFocus();
	    },
	    updateButtonFocus: function updateButtonFocus() {
	        setTimeout(function () {
	            this.refs.button.focus();
	        }.bind(this), 100);
	    },
	    getLefPosition: function getLefPosition() {
	        var leftPosition = 0;
	        var buttonSize = this.props.buttonSize;
	
	        switch (this.props.index) {
	            // line 1
	            case 0:
	                {
	                    // A
	                    leftPosition = buttonSize * 0;
	                    break;
	                }
	
	            case 1:
	                {
	                    // B
	                    leftPosition = buttonSize * 2;
	                    break;
	                }
	            case 2:
	                {
	                    // I
	                    leftPosition = buttonSize * 3;
	                    break;
	                }
	            case 3:
	                {
	                    // U
	                    leftPosition = buttonSize * 4;
	                    break;
	                }
	
	            case 4:
	                {
	                    // Left align
	                    leftPosition = buttonSize * 6;
	                    break;
	                }
	            case 5:
	                {
	                    // Center align
	                    leftPosition = buttonSize * 7;
	                    break;
	                }
	            case 6:
	                {
	                    // Right align
	                    leftPosition = buttonSize * 8;
	                    break;
	                }
	
	            // line 2
	            case 7:
	                {
	                    // orderedList
	                    leftPosition = buttonSize * 0;
	                    break;
	                }
	            case 8:
	                {
	                    // bulletList
	                    leftPosition = buttonSize * 1;
	                    break;
	                }
	            case 9:
	                {
	                    // ident
	                    leftPosition = buttonSize * 2;
	                    break;
	                }
	            case 10:
	                {
	                    // outdent
	                    leftPosition = buttonSize * 3;
	                    break;
	                }
	
	            case 11:
	                {
	                    // superscript
	                    leftPosition = buttonSize * 5;
	                    break;
	                }
	            case 12:
	                {
	                    // subscript
	                    leftPosition = buttonSize * 6;
	                    break;
	                }
	
	            case 13:
	                {
	                    // lineHeight
	                    leftPosition = buttonSize * 8;
	                    break;
	                }
	        }
	
	        return leftPosition;
	    },
	    isSelected: function isSelected() {
	        var value = false;
	
	        switch (this.props.index) {
	            // line 1
	            case 0:
	                {
	                    // A
	                    return this.state.isButtonSelected;
	                    break;
	                }
	
	            case 1:
	                {
	                    // B
	                    value = _TextEditorUtils2.default.isSelectedStyle('bold');
	                    break;
	                }
	            case 2:
	                {
	                    // I
	                    value = _TextEditorUtils2.default.isSelectedStyle('italic');
	                    break;
	                }
	            case 3:
	                {
	                    // U
	                    value = _TextEditorUtils2.default.isSelectedStyle('underline');
	                    break;
	                }
	
	            case 4:
	                {
	                    // Left align
	                    value = _TextEditorUtils2.default.isSelectedStyle('left');
	                    break;
	                }
	            case 5:
	                {
	                    // Center align
	                    value = _TextEditorUtils2.default.isSelectedStyle('center');
	                    break;
	                }
	            case 6:
	                {
	                    // Right align
	                    value = _TextEditorUtils2.default.isSelectedStyle('right');
	                    break;
	                }
	
	            // line 2
	            case 7:
	                {
	                    // orderedList
	                    value = _TextEditorUtils2.default.isSelectedStyle('OL');
	                    break;
	                }
	            case 8:
	                {
	                    // bulletList
	                    value = _TextEditorUtils2.default.isSelectedStyle('UL');
	                    break;
	                }
	            case 9:
	                {
	                    // ident
	                    value = false;
	                    break;
	                }
	            case 10:
	                {
	                    // outdent
	                    value = false;
	                    break;
	                }
	
	            case 11:
	                {
	                    // superscript
	                    value = _TextEditorUtils2.default.isSelectedStyle('super');
	                    break;
	                }
	            case 12:
	                {
	                    // subscript
	                    value = _TextEditorUtils2.default.isSelectedStyle('sub');
	                    break;
	                }
	
	            case 13:
	                {
	                    // lineHeight
	                    return false;
	                    break;
	                }
	        }
	
	        return value;
	    },
	    getAriaLabel: function getAriaLabel() {
	        switch (this.props.index) {
	            case 0:
	                {
	                    // A
	                    return _HoverManager2.default.getText('fontColor');
	                }
	            case 1:
	                {
	                    // B
	                    return _HoverManager2.default.getText('bold');
	                }
	            case 2:
	                {
	                    // I
	                    return _HoverManager2.default.getText('italic');
	                }
	            case 3:
	                {
	                    // U
	                    return _HoverManager2.default.getText('underline');
	                }
	            case 4:
	                {
	                    // Left align
	                    return _HoverManager2.default.getText('leftAlign');
	                }
	            case 5:
	                {
	                    // Center align
	                    return _HoverManager2.default.getText('centerAlign');
	                }
	            case 6:
	                {
	                    // Right align
	                    return _HoverManager2.default.getText('rightAlign');
	                }
	            case 7:
	                {
	                    return _HoverManager2.default.getText('orderedList');
	                }
	            case 8:
	                {
	                    return _HoverManager2.default.getText('bulletList');
	                }
	            case 9:
	                {
	                    return _HoverManager2.default.getText('ident');
	                }
	            case 10:
	                {
	                    return _HoverManager2.default.getText('outdent');
	                }
	            case 11:
	                {
	                    return _HoverManager2.default.getText('superscript');
	                }
	            case 12:
	                {
	                    return _HoverManager2.default.getText('subscript');
	                }
	            case 13:
	                {
	                    return _HoverManager2.default.getText('lineHeight');
	                }
	        }
	
	        return '';
	    },
	    getIcon: function getIcon() {
	        var host = void 0;
	
	        if (_Configuration2.default.LOAD_LOCAL === true) host = '';else host = _AppParameters2.default.RESOURCES_LOCATION();
	
	        switch (this.props.index) {
	            // line 1
	            case 0:
	                {
	                    // A
	                    return host + 'assets/textEditor/fontColor';
	                }
	
	            case 1:
	                {
	                    // B
	                    return host + 'assets/textEditor/bold';
	                }
	            case 2:
	                {
	                    // I
	                    return host + 'assets/textEditor/italic';
	                }
	            case 3:
	                {
	                    // U
	                    return host + 'assets/textEditor/underline';
	                }
	
	            case 4:
	                {
	                    // Left align
	                    return host + 'assets/textEditor/left';
	                }
	            case 5:
	                {
	                    // Center align
	                    return host + 'assets/textEditor/center';
	                }
	            case 6:
	                {
	                    // Right align
	                    return host + 'assets/textEditor/right';
	                }
	
	            // line 2
	            case 7:
	                {
	                    // orderedList
	                    return host + 'assets/textEditor/listOrdered';
	                }
	            case 8:
	                {
	                    // bulletList
	                    return host + 'assets/textEditor/listUnordered';
	                }
	            case 9:
	                {
	                    // indent
	                    return host + 'assets/textEditor/indent';
	                }
	            case 10:
	                {
	                    // outdent
	                    return host + 'assets/textEditor/outdent';
	                }
	
	            case 11:
	                {
	                    // superscript
	                    return host + 'assets/textEditor/sup';
	                }
	            case 12:
	                {
	                    // subscript
	                    return host + 'assets/textEditor/sub';
	                }
	
	            case 13:
	                {
	                    // lineHeight
	                    return host + 'assets/textEditor/lineHeight';
	                }
	        }
	
	        return '';
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement.id.indexOf('subscriptButton') != -1) _StoreManager2.default.getStore().dispatch((0, _MenuActions.expandFontLineHeight)(false));
	
	        if (document.activeElement.id.indexOf('fontColorButton') != -1) _StoreManager2.default.getStore().dispatch((0, _MenuActions.expandFontSizeList)(false));
	    },
	    render: function render() {
	        var buttonWidth = this.props.buttonSize;
	        var buttonHeight = this.props.buttonSize;
	        var gap = 2;
	        var isSelected = this.isSelected();
	
	        var buttonStyle = {
	            position: 'absolute',
	            top: this.props.top,
	            width: buttonWidth,
	            height: buttonHeight,
	            left: this.getLefPosition(),
	            cursor: 'pointer',
	            background: '#f9f9f9',
	            borderRadius: 4,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        var middleStyle = {
	            position: 'absolute',
	            top: gap,
	            width: buttonWidth - 2 * gap,
	            height: buttonHeight - 2 * gap,
	            left: gap,
	            cursor: 'pointer',
	            borderRadius: 2,
	            background: isSelected ? '#0078a3' : this.state.isOver ? '#edefff' : '#f9f9f9'
	        };
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: middleStyle.width,
	            height: middleStyle.height,
	            pointerEvents: 'none'
	        };
	
	        var buttonId = void 0;
	        var colorBar = void 0;
	
	        switch (true) {
	            case this.props.index === 0:
	                {
	                    buttonId = 'fontColorButton';
	                    break;
	                }
	            case this.props.index === 12:
	                {
	                    buttonId = 'subscriptButton';
	                    break;
	                }
	            case this.props.index === 13:
	                {
	                    buttonId = 'fontLineHeightMenu';
	                    break;
	                }
	        }
	
	        if (this.props.index === 0) {
	            iconStyle.width = 27;
	            iconStyle.height = 27;
	            iconStyle.top = -2;
	            iconStyle.left = 1;
	
	            var colorBarStyle = {
	                position: 'absolute',
	                width: buttonWidth - 2 * gap - 2 * gap - 2,
	                height: 4,
	                background: this.props.currentColor,
	                left: gap,
	                bottom: 2,
	                borderRadius: 50,
	                borderStyle: 'solid',
	                borderWidth: 1,
	                borderColor: '#c4c4c4'
	            };
	
	            colorBar = _react2.default.createElement('span', { id: 'colorBar', style: colorBarStyle });
	        }
	
	        var icon = this.getIcon();
	
	        if (isSelected) icon = icon + '_white.svg';else icon = icon + '.svg';
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': this.getAriaLabel(), id: buttonId, ref: 'button', style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onFocus: this.onFocusHandler },
	            _react2.default.createElement(
	                'span',
	                { style: middleStyle },
	                _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: icon }),
	                colorBar
	            )
	        );
	    }
	});
	
	var EditTextArea = exports.EditTextArea = _react2.default.createClass({
	    displayName: 'EditTextArea',
	    getInitialState: function getInitialState() {
	        return {
	            show: false
	        };
	    },
	    showColorPallete: function showColorPallete(value) {
	        this.setState({
	            show: value
	        });
	
	        this.props.checkFontColors(value);
	    },
	    getCurrentColor: function getCurrentColor() {
	        var color = _TextEditorUtils2.default.getCommandValue('fontcolor');
	
	        color = _TextEditorUtils2.default.getCorrectColor(color);
	
	        return color;
	    },
	    render: function render() {
	        var gridSize = this.props.gridSize;
	        var lineElementTopPadding = this.props.lineElementTopPadding;
	        var lineHeight = gridSize + lineElementTopPadding;
	        var gap = this.props.gap;
	        var width = this.props.width;
	        var colorElementSize = width / 10;
	
	        var menuStyle = {
	            position: 'absolute',
	            top: this.props.top,
	            left: gap,
	            width: width,
	            height: this.props.height
	        };
	
	        var line1Style = { // font-selector and size
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: width,
	            height: lineHeight
	        };
	
	        var line2Style = { // font color, bold, italic, etc
	            position: 'absolute',
	            top: line1Style.top + line1Style.height,
	            left: 0,
	            width: width,
	            height: lineHeight
	        };
	
	        var line3Style = { // alignment, identation, etc
	            position: 'absolute',
	            top: line2Style.top + line2Style.height,
	            left: 0,
	            width: width,
	            height: lineHeight
	        };
	
	        var fontTitleStyle = {
	            position: 'absolute',
	            top: 3,
	            left: 0,
	            fontSize: 12,
	            fontWeight: 'bold',
	            color: '#606060'
	        };
	
	        var sizeTitleStyle = {
	            position: 'absolute',
	            top: 3,
	            left: line1Style.width - 3 * gridSize,
	            fontSize: 12,
	            fontWeight: 'bold',
	            color: '#606060'
	        };
	
	        var currentColor = this.getCurrentColor();
	        var fontColorPallete = void 0;
	
	        if (this.state.show) {
	            line3Style.top = 2 * lineHeight + this.props.palleteColorHeight;
	
	            fontColorPallete = _react2.default.createElement(_ColorPallete.ColorPallete, { type: 'changeFontColor', currentColor: currentColor, top: 2 * lineHeight, topGap: lineElementTopPadding, width: width, gridSize: colorElementSize, executeCommand: this.props.executeColorPickerCommand, contextTarget: this.props.contextTarget, forceUpdateTextEditor: this.props.forceUpdateTextEditor });
	        }
	
	        var lineHeightMenu = void 0;
	
	        if (this.props.fontLineHeightIsExpanded) lineHeightMenu = _react2.default.createElement(_FontLineHeightMenu.FontLineHeightMenu, { top: lineElementTopPadding + gridSize, contextTarget: this.props.contextTarget, executeCommand: this.props.executeCommand });
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(
	                'div',
	                { style: line1Style },
	                _react2.default.createElement(
	                    'div',
	                    { style: fontTitleStyle },
	                    _HoverManager2.default.getText('fontTitle')
	                ),
	                _react2.default.createElement(_FontMenu.FontMenu, { width: 5 * gridSize, top: lineElementTopPadding, buttonSize: gridSize, contextTarget: this.props.contextTarget, executeCommand: this.props.executeCommand, fontName: _TextEditorUtils2.default.getCommandValue('fontname') }),
	                _react2.default.createElement(
	                    'div',
	                    { style: sizeTitleStyle },
	                    _HoverManager2.default.getText('sizeTitle')
	                ),
	                _react2.default.createElement(_FontSizeView.FontSizeView, { refresh: Math.random(), buttonSize: gridSize, top: lineElementTopPadding, left: line1Style.width - 3 * gridSize, contextTarget: this.props.contextTarget, executeCommand: this.props.executeCommand })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: line2Style },
	                _react2.default.createElement(Button, { index: 0, currentColor: currentColor, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-amazon', holderWidth: this.props.width, showColorPallete: this.showColorPallete, executeCommand: this.props.executeCommand }),
	                _react2.default.createElement(Button, { index: 1, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-bold', holderWidth: this.props.width, executeCommand: this.props.executeCommand }),
	                _react2.default.createElement(Button, { index: 2, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-italic', holderWidth: this.props.width, executeCommand: this.props.executeCommand }),
	                _react2.default.createElement(Button, { index: 3, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-underline', holderWidth: this.props.width, executeCommand: this.props.executeCommand }),
	                _react2.default.createElement(Button, { index: 4, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-align-left', holderWidth: this.props.width, executeCommand: this.props.executeCommand }),
	                _react2.default.createElement(Button, { index: 5, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-align-center', holderWidth: this.props.width, executeCommand: this.props.executeCommand }),
	                _react2.default.createElement(Button, { index: 6, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-align-right', holderWidth: this.props.width, executeCommand: this.props.executeCommand })
	            ),
	            fontColorPallete,
	            _react2.default.createElement(
	                'div',
	                { style: line3Style },
	                _react2.default.createElement(Button, { index: 7, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-list-ol', holderWidth: this.props.width, executeCommand: this.props.executeCommand }),
	                _react2.default.createElement(Button, { index: 8, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-list-ul', holderWidth: this.props.width, executeCommand: this.props.executeCommand }),
	                _react2.default.createElement(Button, { index: 9, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-indent', holderWidth: this.props.width, executeCommand: this.props.executeCommand }),
	                _react2.default.createElement(Button, { index: 10, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-outdent', holderWidth: this.props.width, executeCommand: this.props.executeCommand }),
	                _react2.default.createElement(Button, { index: 11, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-superscript', holderWidth: this.props.width, executeCommand: this.props.executeCommand }),
	                _react2.default.createElement(Button, { index: 12, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-subscript', holderWidth: this.props.width, executeCommand: this.props.executeCommand }),
	                _react2.default.createElement(Button, { index: 13, top: lineElementTopPadding, buttonSize: gridSize, icon: 'fa fa-text-height', holderWidth: this.props.width, executeCommand: this.props.executeCommand, contextTarget: this.props.contextTarget }),
	                lineHeightMenu
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/EditTextArea.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/EditTextArea.js"); } } })();

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InsertImageArea = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _MindMapUtils = __webpack_require__(85);
	
	var _MindMapUtils2 = _interopRequireDefault(_MindMapUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.index === 0) _MindMapUtils2.default.openSearchForImageInsertion(this.props.contextTarget.uuid);else {
	            _MindMapUtils2.default.removeImage(this.props.contextTarget.uuid);
	
	            if (this.props.forceUpdateTextEditor) this.props.forceUpdateTextEditor();
	
	            var firstFocusableElement = document.getElementById('firstFocusableObjectForTextEditorTool');
	
	            if (firstFocusableElement) firstFocusableElement.focus();
	        }
	    },
	    getLefPosition: function getLefPosition() {
	        var leftPosition = 0;
	        var buttonSize = this.props.width;
	        var gap = this.props.gap;
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    leftPosition = 0;
	                    break;
	                }
	            case 1:
	                {
	                    leftPosition = buttonSize + gap;
	                    break;
	                }
	        }
	
	        return leftPosition;
	    },
	    getLabel: function getLabel() {
	        if (this.props.index === 0) {
	            if (this.props.contextTarget.imageNode && this.props.contextTarget.imageNode.length > 0) return _HoverManager2.default.getText('replaceImage');else return _HoverManager2.default.getText('insertImage');
	        } else return _HoverManager2.default.getText('removeImage');
	    },
	    getIcon: function getIcon() {
	        switch (this.props.index) {
	            case 0:
	                {
	                    // insert image
	                    return 'fa fa-picture-o';
	                }
	            case 1:
	                {
	                    // delete image
	                    return 'fa fa-trash';
	                }
	        }
	    },
	    render: function render() {
	        var buttonWidth = this.props.width;
	        var buttonHeight = this.props.height;
	        var backgroundColor = this.state.isOver ? '#edefff' : '#f9f9f9';
	        var opacity = 1;
	        var idValue = void 0;
	        var tabIndexValue = void 0;
	
	        if (this.props.contextTarget.imageNode && this.props.contextTarget.imageNode.length > 0) {
	            // is already an image inserted
	            if (this.props.index === 1) idValue = 'lastFocusableObjectForTextEditorTool';
	        } else {
	            if (this.props.index === 0) {
	                idValue = 'lastFocusableObjectForTextEditorTool';
	            } else {
	                tabIndexValue = '-1';
	                opacity = 0.5;
	            }
	        }
	
	        var buttonStyle = {
	            position: 'absolute',
	            top: 0,
	            width: buttonWidth,
	            height: buttonHeight,
	            left: this.getLefPosition(),
	            cursor: 'pointer',
	            background: backgroundColor,
	            borderRadius: 4,
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            borderStyle: 'solid',
	            borderWidth: 1,
	            borderColor: '#c4c4c4',
	            opacity: opacity
	        };
	
	        if (opacity === 0.5) buttonStyle.pointerEvents = 'none';
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 5,
	            left: 5,
	            fontSize: 21,
	            pointerEvents: 'none'
	        };
	
	        var titleStyle = {
	            position: 'absolute',
	            top: 10,
	            right: 0,
	            width: buttonWidth - 33,
	            fontSize: 12,
	            color: '#000000',
	            textAlign: 'center',
	            pointerEvents: 'none'
	        };
	
	        var icon = this.getIcon();
	        var label = this.getLabel();
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, tabIndex: tabIndexValue, 'aria-disabled': tabIndexValue == '-1' ? true : false, 'aria-label': label, style: buttonStyle, onTouchEnd: this.onClick, onClick: this.onClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	            _react2.default.createElement('i', { style: iconStyle, className: icon }),
	            _react2.default.createElement(
	                'span',
	                { style: titleStyle },
	                label
	            )
	        );
	    }
	});
	
	var InsertImageArea = exports.InsertImageArea = _react2.default.createClass({
	    displayName: 'InsertImageArea',
	    render: function render() {
	        var gap = 10;
	        var elementWidth = Math.floor((this.props.width - 3 * gap) / 2);
	
	        var menuStyle = {
	            position: 'absolute',
	            top: this.props.top,
	            left: gap
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(Button, { index: 0, width: elementWidth, height: this.props.gridSize, gap: gap, contextTarget: this.props.contextTarget, forceUpdateTextEditor: this.props.forceUpdateTextEditor }),
	            _react2.default.createElement(Button, { index: 1, width: elementWidth, height: this.props.gridSize, gap: gap, contextTarget: this.props.contextTarget, forceUpdateTextEditor: this.props.forceUpdateTextEditor })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/InsertImageArea.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/InsertImageArea.js"); } } })();

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TextBoxArea = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _ShapeTypeElement = __webpack_require__(838);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextBoxArea = exports.TextBoxArea = _react2.default.createClass({
	    displayName: 'TextBoxArea',
	    render: function render() {
	        var elementWidth = this.props.elementWidth;
	        var menuStyle = {
	            position: 'absolute',
	            width: this.props.width,
	            top: 0
	        };
	
	        var buttonsHolderStyle = {
	            position: 'absolute',
	            top: this.props.topGap
	        };
	
	        var lineStyle = {
	            position: 'absolute',
	            width: this.props.width,
	            height: 1,
	            top: elementWidth + 2 * this.props.topGap,
	            left: 0,
	            backgroundColor: '#c4c4c4'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(
	                'div',
	                { style: buttonsHolderStyle },
	                _react2.default.createElement(_ShapeTypeElement.ShapeTypeElement, { id: 'textBoxSimpleButton', index: 0, executeCommand: this.props.executeCommand, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, type: _ShapeConstants2.default.TEXTBOXSIMPLE, width: elementWidth, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/simpleText.png' }),
	                _react2.default.createElement(_ShapeTypeElement.ShapeTypeElement, { index: 1, executeCommand: this.props.executeCommand, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, type: _ShapeConstants2.default.TEXTBOX, width: elementWidth, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/textBoxIcon.png' }),
	                _react2.default.createElement(_ShapeTypeElement.ShapeTypeElement, { index: 2, executeCommand: this.props.executeCommand, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, type: _ShapeConstants2.default.SPEAK_BUBBLE, width: elementWidth, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/speachBubble.png' }),
	                _react2.default.createElement(_ShapeTypeElement.ShapeTypeElement, { index: 3, executeCommand: this.props.executeCommand, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, type: _ShapeConstants2.default.THOUGHT_BUBBLE, width: elementWidth, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/thoughtBubble.png' }),
	                _react2.default.createElement(_ShapeTypeElement.ShapeTypeElement, { index: 4, executeCommand: this.props.executeCommand, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, type: _ShapeConstants2.default.SCREAM_BUBBLE, width: elementWidth, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/screamBubble.png' }),
	                _react2.default.createElement(_ShapeTypeElement.ShapeTypeElement, { index: 5, executeCommand: this.props.executeCommand, dispatch: this.props.dispatch, contextTarget: this.props.contextTarget, type: _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE, width: elementWidth, src: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/complexSpeachBubble.png' })
	            ),
	            _react2.default.createElement('div', { style: lineStyle })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/TextBoxArea.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/TextBoxArea.js"); } } })();

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BorderStyleArea = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _ColorPallete = __webpack_require__(234);
	
	var _CustomSlider = __webpack_require__(170);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BorderStyleArea = exports.BorderStyleArea = _react2.default.createClass({
	    displayName: 'BorderStyleArea',
	    render: function render() {
	        var sliderHeight = _Properties2.default.STYLING_SLIDER_HEIGHT;
	        var menuStyle = {
	            position: 'absolute',
	            top: this.props.top,
	            left: 0,
	            width: this.props.width
	        };
	
	        var thicknessProperties = {};
	        thicknessProperties.topPosition = 2 * this.props.topGap + 2 * this.props.gridSize;
	        thicknessProperties.leftPosition = 0;
	        thicknessProperties.width = this.props.width;
	        thicknessProperties.height = sliderHeight;
	        thicknessProperties.backgroundHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/strokeSlider.png';
	        thicknessProperties.thumbHref = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
	        thicknessProperties.thumbSize = _Properties2.default.STYLING_THUMB_SIZE;
	        thicknessProperties.start = 0;
	        thicknessProperties.end = 10;
	        thicknessProperties.step = 1;
	        thicknessProperties.target = this.props.contextTarget;
	        thicknessProperties.dispatch = this.props.dispatch;
	        thicknessProperties.type = 'change_stroke';
	        thicknessProperties.isTextEditorTool = true;
	
	        var idValue = void 0;
	
	        if (!this.props.contextTarget.isMindMap) idValue = 'lastFocusableObjectForTextEditorTool';
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(_ColorPallete.ColorPallete, { type: this.props.type, currentColor: this.props.currentColor, executeCommand: this.props.executeCommand, top: 0, topGap: this.props.topGap, width: this.props.width, gridSize: this.props.gridSize, contextTarget: this.props.contextTarget, forceUpdateTextEditor: this.props.forceUpdateTextEditor }),
	            _react2.default.createElement(_CustomSlider.CustomSlider, { id: idValue, properties: thicknessProperties, executeCommand: this.props.executeCommand })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/BorderStyleArea.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/BorderStyleArea.js"); } } })();

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ColorElement = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColorElement = exports.ColorElement = _react2.default.createClass({
	    displayName: 'ColorElement',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    getColors: function getColors() {
	        var colorsArray = ['#c43025', '#eb1000', '#fe8b2e', '#f8fd32', '#008a27', '#1d7db4', '#9760a4', '#4a4c72', '#000000', '#ffffff', '#c0706e', '#ff9794', '#fcbc8d', '#fbfd8d', '#61df7e', '#7abae1', '#eca6fa', '#a0a7f1', '#969ba2'];
	        var color = this.props.currentColor;
	
	        if (colorsArray.indexOf(color) === -1) // if the color was selected with the colorPicker then we should replace the first bottom color with the correct one
	            colorsArray[10] = color;
	
	        return colorsArray;
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.props.index === 19) {
	            // open the colorPicker
	            this.props.showColorPicker();
	            return;
	        }
	
	        var colors = this.getColors();
	        var selectedColor = colors[this.props.index];
	
	        if (this.props.type === 'changeShapeFillColor') {
	            if (this.props.index === 0) this.props.executeCommand('changeShapeFillVisibility');else this.props.executeCommand('changeShapeFillColor', selectedColor);
	        } else if (this.props.type === 'changeShapeStrokeColor') {
	            if (this.props.index === 0) this.props.executeCommand('changeShapeStrokeOpacity');else this.props.executeCommand('changeShapeStrokeColor', selectedColor);
	        } else {
	            // Font color
	            _TextEditorUtils2.default.executeAction(20, selectedColor);
	            this.props.executeCommand('changeFontColor', selectedColor);
	        }
	    },
	    isSelected: function isSelected() {
	        var index = void 0;
	        var colors = this.getColors();
	
	        if (this.props.type === 'changeShapeFillColor') {
	            if (!this.props.contextTarget.backgroundVisible) {
	                if (this.props.index === 0) return true;
	            } else {
	                index = colors.indexOf(this.props.contextTarget.fill);
	
	                if (index === this.props.index) return true;
	            }
	        } else if (this.props.type === 'changeShapeStrokeColor') {
	            // stroke
	            if (this.props.contextTarget.strokeOpacity === 0) {
	                if (this.props.index === 0) return true;
	            } else {
	                index = colors.indexOf(this.props.contextTarget.stroke);
	
	                if (index === this.props.index) return true;
	            }
	        } else {
	            // Font Color
	            index = colors.indexOf(this.props.currentColor);
	
	            if (index === this.props.index) return true;
	        }
	
	        return false;
	    },
	    getIcon: function getIcon() {
	        var host = void 0;
	
	        if (_Configuration2.default.LOAD_LOCAL === true) host = '';else host = _AppParameters2.default.RESOURCES_LOCATION();
	
	        switch (this.props.index) {
	            case 0:
	                {
	                    // No fill
	                    return host + 'assets/textEditor/noFill.png';
	                }
	            case 19:
	                {
	                    // Plus
	                    return host + 'assets/textEditor/plus.svg';
	                }
	        }
	
	        return '';
	    },
	    render: function render() {
	        var elementGap = 2;
	        var size = this.props.width - elementGap;
	        var topPosition = this.props.index < 10 ? 0 : size + elementGap;
	        var index = this.props.index > 9 ? this.props.index - 10 : this.props.index;
	        var leftPosition = index * (size + elementGap);
	
	        topPosition = topPosition + this.props.top;
	
	        var elementStyle = {
	            position: 'absolute',
	            width: size,
	            height: size,
	            top: topPosition,
	            left: leftPosition,
	            backgroundColor: 'white',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none',
	            cursor: 'pointer'
	        };
	
	        if (this.state.isOver) {
	            elementStyle.backgroundColor = '#edefff';
	            elementStyle.borderRadius = 5;
	            elementStyle.borderWidth = 1;
	            elementStyle.borderStyle = 'solid';
	            elementStyle.borderColor = '#9ea2fd';
	        } else if (this.isSelected()) {
	            elementStyle.backgroundColor = '#edefff';
	            elementStyle.borderRadius = 5;
	            elementStyle.borderWidth = 1;
	            elementStyle.borderStyle = 'solid';
	            elementStyle.borderColor = '#2377bb';
	        }
	
	        var gap = 3;
	        var colors = this.getColors();
	        var centerStyle = {
	            position: 'absolute',
	            width: size - 2 * gap,
	            height: size - 2 * gap,
	            top: gap,
	            left: gap,
	            backgroundColor: colors[this.props.index],
	            display: 'block',
	            borderRadius: 50
	        };
	
	        var isNoFillButton = false;
	
	        if ((this.props.type === 'changeShapeFillColor' || this.props.type === 'changeShapeStrokeColor') && this.props.index === 0) isNoFillButton = true;
	
	        if (index === 9 || index === 19) {
	            // white or plus element
	            centerStyle.borderColor = '#c4c4c4';
	            centerStyle.borderStyle = 'solid';
	            centerStyle.borderWidth = 1;
	            centerStyle.top = centerStyle.top - 1;
	            centerStyle.left = centerStyle.left - 1;
	        }
	
	        var idValue = 'colorElement_' + this.props.index;
	        var iconElement = void 0;
	
	        if (this.props.index === 19 || isNoFillButton) {
	            var iconStyle = {
	                position: 'absolute',
	                top: -1,
	                left: -1,
	                width: 25,
	                height: 25,
	                pointerEvents: 'none'
	            };
	
	            iconElement = _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: this.getIcon() });
	        }
	
	        var ariaLabelValue = void 0;
	
	        if (this.props.index === 19) {
	            ariaLabelValue = _HoverManager2.default.getText('moreColors');
	
	            if (this.props.type === 'changeShapeFillColor') {
	                if (!this.props.contextTarget.isMindMap) idValue = 'lastFocusableObjectForTextEditorTool';
	            }
	        } else ariaLabelValue = colors[this.props.index];
	
	        return _react2.default.createElement(
	            'button',
	            { id: idValue, 'aria-label': ariaLabelValue, style: elementStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onClick, onClick: this.onClick },
	            _react2.default.createElement(
	                'span',
	                { style: centerStyle },
	                iconElement
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/ColorElement.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/ColorElement.js"); } } })();

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FontLineHeightMenu = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _MenuActions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.changeTextProperties();
	    },
	    onButtonClick: function onButtonClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.changeTextProperties();
	    },
	    changeTextProperties: function changeTextProperties() {
	        if (this.props.executeCommand) {
	            _StoreManager2.default.getStore().dispatch((0, _MenuActions.expandFontLineHeight)(false));
	
	            this.props.executeCommand(18, this.props.value);
	            this.props.refresh();
	
	            setTimeout(function () {
	                var lineHeightButton = document.getElementById('fontLineHeightMenu');
	
	                if (lineHeightButton) lineHeightButton.focus();
	            }.bind(this), 10);
	        }
	    },
	    render: function render() {
	        var iconColor = void 0;
	        var buttonColor = void 0;
	
	        if (this.state.isOver === true) {
	            iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	            buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	        } else {
	            iconColor = 'black';
	            buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	        }
	
	        var topPosition = this.props.index * this.props.height;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.width,
	            height: this.props.height,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 15,
	            top: topPosition,
	            color: 'white',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            fontSize: 17,
	            fontFamily: this.props.value,
	            top: 0
	        };
	
	        var iconVisible = void 0;
	
	        if (this.props.index === this.props.selectedIndex) iconVisible = 'block';else iconVisible = 'none';
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 4,
	            right: 10,
	            color: iconColor,
	            display: iconVisible
	        };
	
	        if (_PlatformDetection2.default.isIOS() === true) {
	            spanStyle.fontSize = 18;
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { 'aria-label': this.props.value, ref: 'button', className: 'lineHeightButton', style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onButtonClick, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp },
	            _react2.default.createElement(
	                'span',
	                { className: 'lineHeightButton', style: spanStyle },
	                this.props.value
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-check lineHeightButton' })
	        );
	    }
	});
	
	var FontLineHeightMenuContent = _react2.default.createClass({
	    displayName: 'FontLineHeightMenuContent',
	    onExpand: function onExpand(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var isExpanded = !this.props.fontLineHeightIsExpanded;
	        this.props.dispatch((0, _MenuActions.expandFontLineHeight)(isExpanded));
	    },
	    getCurrentLineSize: function getCurrentLineSize() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	        var lineHeight = void 0;
	
	        for (var i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid === this.props.contextTarget.uuid) {
	                lineHeight = shapes[i].lineHeight;
	                break;
	            }
	        }
	
	        if (!lineHeight) lineHeight = 1.25;
	
	        return lineHeight;
	    },
	    refreshView: function refreshView() {
	        setTimeout(function () {
	            this.forceUpdate();
	        }.bind(this), 5);
	    },
	    render: function render() {
	        var dataProvider = [0.25, 0.5, 0.75, 1.0, 1.25, 1.50, 1.75, 2.0];
	        var currentLineSize = this.getCurrentLineSize();
	        var menuWidth = 80;
	        var visibleItems = 8;
	        var buttonHeight = 25;
	
	        var menuStyle = {
	            position: 'absolute',
	            width: menuWidth,
	            height: buttonHeight * visibleItems,
	            top: this.props.top,
	            right: 0,
	            borderColor: _Properties2.default.EFFECTS_BUTTON_BORDER_COLOR,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            display: listDisplay,
	            overflowY: 'hidden',
	            overflowX: 'hidden',
	            zIndex: 1100
	        };
	
	        var elements = [];
	        var listDisplay = void 0;
	
	        if (this.props.fontLineHeightIsExpanded === true) {
	            var i = void 0;
	            var selectedIndex = -1;
	
	            for (i = 0; i < dataProvider.length; i++) {
	                if (currentLineSize === dataProvider[i]) selectedIndex = i;
	
	                elements.push(_react2.default.createElement(Button, { refresh: this.refreshView, contextTarget: this.props.contextTarget, height: buttonHeight, width: menuWidth, index: i, dispatch: this.props.dispatch, key: 'lineHeight' + dataProvider[i], value: dataProvider[i], selectedIndex: selectedIndex, executeCommand: this.props.executeCommand }));
	            }
	
	            listDisplay = 'block';
	        } else {
	            listDisplay = 'none';
	        }
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = menuStyle.width;
	        componentProperties.height = menuStyle.height;
	        componentProperties.scrollHeight = dataProvider != undefined ? dataProvider.length * buttonHeight : 0;
	        componentProperties.top = 0;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = elements;
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var fontLineHeightIsExpanded = state.menu.fontLineHeightIsExpanded;
	
	    return {
	        fontLineHeightIsExpanded: fontLineHeightIsExpanded
	    };
	}
	
	var FontLineHeightMenu = exports.FontLineHeightMenu = (0, _reactRedux.connect)(mapStateToProps)(FontLineHeightMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/FontLineHeightMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/FontLineHeightMenu.js"); } } })();

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FontMenu = exports.FontMenuContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _AvailableFonts = __webpack_require__(175);
	
	var _AvailableFonts2 = _interopRequireDefault(_AvailableFonts);
	
	var _MenuActions = __webpack_require__(7);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.changeTextProperties();
	    },
	    onButtonClick: function onButtonClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.changeTextProperties();
	    },
	    changeTextProperties: function changeTextProperties() {
	        if (this.props.executeCommand) {
	            _StoreManager2.default.getStore().dispatch((0, _MenuActions.expandFontsList)(false));
	
	            _TextEditorUtils2.default.executeAction(14, this.props.value);
	            this.props.executeCommand(14, this.props.value);
	            this.props.refresh();
	
	            setTimeout(function () {
	                var fontMenuButton = document.getElementById('fontsMenuButton');
	
	                if (fontMenuButton) fontMenuButton.focus();
	            }.bind(this), 10);
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.shapeModel != newProps.shapeModel || this.props.isSelected != newProps.isSelected) return true;else return false;
	    },
	    render: function render() {
	        var iconColor = void 0;
	        var buttonColor = void 0;
	
	        if (this.state.isOver == true) {
	            iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	            buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	        } else {
	            iconColor = 'black';
	            buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	        }
	
	        var topPosition = this.props.index * this.props.height;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: 200,
	            height: this.props.height,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: _Properties2.default.BROWSER_LEFT_PADDING / 2,
	            top: topPosition,
	            color: 'white',
	            borderStyle: 'none',
	            cursor: 'pointer'
	        };
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            fontSize: 17,
	            fontFamily: this.props.value,
	            top: 0,
	            pointerEvents: 'none'
	        };
	
	        var iconVisible = void 0;
	
	        if (this.props.isSelected) iconVisible = 'block';else iconVisible = 'none';
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 11,
	            right: 14,
	            color: iconColor,
	            display: iconVisible,
	            pointerEvents: 'none'
	        };
	
	        if (_PlatformDetection2.default.isIOS() == true) {
	            spanStyle.fontSize = 18;
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { ref: 'button', 'aria-label': this.props.value, style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onButtonClick, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.value
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-check' })
	        );
	    }
	});
	
	var FontMenuContent = exports.FontMenuContent = _react2.default.createClass({
	    displayName: 'FontMenuContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onExpand: function onExpand(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var isExpanded = !this.props.fontsListIsExpanded;
	        this.props.dispatch((0, _MenuActions.expandFontsList)(isExpanded));
	    },
	    onListChanged: function onListChanged(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        setTimeout(this.refreshView, 6);
	    },
	    refreshView: function refreshView() {
	        setTimeout(function () {
	            this.forceUpdate();
	        }.bind(this), 5);
	    },
	    getFontsDataProvider: function getFontsDataProvider() {
	        return _AvailableFonts2.default.getAvailableFonts();
	    },
	    getCurrentFontTopPosition: function getCurrentFontTopPosition(currentFont) {
	        var top = 6;
	
	        switch (currentFont) {
	            case 'BungeeShade':
	                {
	                    if (_PlatformDetection2.default.isChromeBook()) top = 1;else top = -6;
	                    break;
	                }
	
	            case 'Sriracha':
	                {
	                    top = 1;
	                    break;
	                }
	
	            case 'ArchitectsDaughter':
	            case 'Anton':
	            case 'PermanentMarker':
	                {
	                    top = 4;
	                    break;
	                }
	
	            case 'Cabin':
	            case 'CabinMedium':
	                {
	                    top = 6;
	                    break;
	                }
	
	            case 'Arial':
	            case 'Creepster':
	                {
	                    top = 7;
	                    break;
	                }
	
	            case 'AlfaSlabOne':
	                {
	                    top = 5;
	                    break;
	                }
	            case 'Bangers':
	                {
	                    top = 8;
	                    break;
	                }
	        }
	
	        return top;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isOver != nextState.isOver || this.props.fontsListIsExpanded != newProps.fontsListIsExpanded || this.props.contextTarget != newProps.contextTarget || this.props.fontName != newProps.fontName) return true;else return false;
	    },
	    render: function render() {
	        var currentFontFamily = this.props.fontName;
	        var height = this.props.buttonSize;
	        var menuWidth = this.props.width;
	        var buttonHeight = this.props.buttonSize;
	        var borderWidth = 2;
	        var visibleItems = 16;
	
	        if (this.props.fontsListIsExpanded == true) height = height + visibleItems * buttonHeight + 2 * borderWidth;
	
	        var fontsStyle = {
	            position: 'absolute',
	            top: this.props.top > 0 ? this.props.top : 0,
	            left: 0,
	            width: menuWidth + 2 * borderWidth,
	            height: height,
	            overflowY: 'hidden',
	            backgroundColor: 'white',
	            zIndex: 1000,
	            display: 'table',
	            cursor: 'pointer'
	        };
	
	        var borderColor = void 0;
	        var textColor = void 0;
	
	        if (this.state.isOver == true) {
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            textColor = borderColor;
	        } else {
	            borderColor = '#e7e7e7';
	            textColor = 'black';
	        }
	
	        var fontsButtonStyle = {
	            width: menuWidth - 2 * borderWidth,
	            height: buttonHeight - 2 * borderWidth,
	            background: 'white',
	            borderRadius: 5,
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            borderColor: borderColor,
	            borderWidth: borderWidth,
	            borderStyle: 'solid',
	            alignItems: 'center',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            textAlign: 'left',
	            cursor: 'pointer'
	        };
	
	        var icon = void 0;
	
	        if (this.props.fontsListIsExpanded == true) icon = 'fa fa-angle-down';else icon = 'fa fa-angle-right';
	
	        var fontsIconStyle = {
	            position: 'absolute',
	            top: 7,
	            right: 7,
	            color: textColor,
	            pointerEvents: 'none'
	        };
	
	        var spanStyle = {
	            position: 'absolute',
	            color: textColor,
	            cursor: 'default',
	            fontSize: 15,
	            top: this.getCurrentFontTopPosition(currentFontFamily),
	            paddingLeft: 5,
	            fontFamily: currentFontFamily,
	            pointerEvents: 'none'
	        };
	
	        var elements = [];
	        var listDisplay = void 0;
	        var dataProvider = void 0;
	
	        if (this.props.fontsListIsExpanded == true) {
	            dataProvider = this.getFontsDataProvider();
	
	            for (var i = 0; i < dataProvider.length; i++) {
	                var isSelected = false;
	
	                if (currentFontFamily == dataProvider[i]) isSelected = true;
	
	                elements.push(_react2.default.createElement(Button, { executeCommand: this.props.executeCommand, refresh: this.refreshView, height: buttonHeight, accordionWidth: menuWidth, index: i, dispatch: this.props.dispatch, shapeModel: this.props.contextTarget, key: 'font' + dataProvider[i], value: dataProvider[i], isSelected: isSelected }));
	            }
	
	            listDisplay = 'block';
	        } else {
	            listDisplay = 'none';
	        }
	
	        var fontsListStyle = {
	            position: 'absolute',
	            width: 6 * this.props.buttonSize,
	            height: buttonHeight * visibleItems,
	            top: buttonHeight + 2,
	            left: 0,
	            borderColor: _Properties2.default.EFFECTS_BUTTON_BORDER_COLOR,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            display: listDisplay,
	            overflowY: 'hidden',
	            overflowX: 'hidden'
	        };
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = fontsListStyle.width;
	        componentProperties.height = fontsListStyle.height;
	        componentProperties.scrollHeight = dataProvider != undefined ? dataProvider.length * buttonHeight : 0;
	        componentProperties.top = 0;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = elements;
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'fontsMenu', style: fontsStyle },
	            _react2.default.createElement(
	                'button',
	                { id: 'fontsMenuButton', 'aria-label': _LocalesManager2.default.getCaption('fontSelector', 'other'), style: fontsButtonStyle, onTouchEnd: this.onExpand, onClick: this.onExpand, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut },
	                _react2.default.createElement(
	                    'span',
	                    { style: spanStyle },
	                    currentFontFamily
	                ),
	                _react2.default.createElement('i', { style: fontsIconStyle, className: icon })
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: fontsListStyle, onTouchEnd: this.onListChanged, onClick: this.onListChanged },
	                _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var fontsListIsExpanded = state.menu.fontsListIsExpanded;
	
	    return {
	        fontsListIsExpanded: fontsListIsExpanded
	    };
	}
	
	var FontMenu = exports.FontMenu = (0, _reactRedux.connect)(mapStateToProps)(FontMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/FontMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/FontMenu.js"); } } })();

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FontSizeView = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _MenuActions = __webpack_require__(7);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = _react2.default.createClass({
	    displayName: 'Button',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            clientX: 0,
	            clientY: 0
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _MouseUtils2.default.mouseDownTime = new Date().getTime();
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        this.setState({
	            clientX: clientPosition.x,
	            clientY: clientPosition.y
	        });
	    },
	    onMouseUp: function onMouseUp(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var clientPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        if (Math.abs(clientPosition.x - this.state.clientX) < 5 && Math.abs(clientPosition.y - this.state.clientY) < 5) this.changeTextProperties();
	    },
	    onButtonClick: function onButtonClick() {
	        var downTime = new Date().getTime() - _MouseUtils2.default.mouseDownTime;
	
	        if (downTime < 1000) return;
	
	        this.changeTextProperties();
	    },
	    changeTextProperties: function changeTextProperties() {
	        if (this.props.executeCommand) {
	            _StoreManager2.default.getStore().dispatch((0, _MenuActions.expandFontSizeList)(false));
	
	            _TextEditorUtils2.default.executeAction(15, this.props.value);
	            this.props.executeCommand(15, this.props.value, true);
	            this.props.refreshView();
	
	            setTimeout(function () {
	                var fontSizeButton = document.getElementById('fontSizeMiddle');
	
	                if (fontSizeButton) fontSizeButton.focus();
	            }.bind(this), 10);
	        }
	    },
	    render: function render() {
	        var iconColor = void 0;
	        var buttonColor = void 0;
	
	        if (this.state.isOver === true) {
	            iconColor = _Properties2.default.CONTEXT_HOVER_COLOR;
	            buttonColor = _Properties2.default.SLIDE_MENU_HOVER_COLOR;
	        } else {
	            iconColor = 'black';
	            buttonColor = _Properties2.default.SLIDE_MENU_COLOR;
	        }
	
	        var topPosition = this.props.index * this.props.height;
	
	        var buttonStyle = {
	            position: 'absolute',
	            backgroundColor: buttonColor,
	            width: this.props.width,
	            height: this.props.height,
	            display: 'flex',
	            alignItems: 'center',
	            paddingLeft: 15,
	            top: topPosition,
	            color: 'white',
	            borderStyle: 'none'
	        };
	
	        var spanStyle = {
	            color: iconColor,
	            cursor: 'default',
	            fontSize: 17,
	            fontFamily: this.props.value,
	            top: 0
	        };
	
	        var iconVisible = void 0;
	
	        if (this.props.index === this.props.selectedIndex) iconVisible = 'block';else iconVisible = 'none';
	
	        var iconStyle = {
	            position: 'absolute',
	            top: 4,
	            right: 37,
	            color: iconColor,
	            display: iconVisible
	        };
	
	        if (_PlatformDetection2.default.isIOS() === true) {
	            spanStyle.fontSize = 18;
	        }
	
	        return _react2.default.createElement(
	            'button',
	            { ref: 'sizeButton', 'aria-label': this.props.value, style: buttonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onButtonClick, onTouchStart: this.onMouseDown, onTouchEnd: this.onMouseUp, onMouseDown: this.onMouseDown, onMouseUp: this.onMouseUp },
	            _react2.default.createElement(
	                'span',
	                { style: spanStyle },
	                this.props.value
	            ),
	            _react2.default.createElement('i', { style: iconStyle, className: 'fa fa-check' })
	        );
	    }
	});
	
	var FontSizeViewContent = _react2.default.createClass({
	    displayName: 'FontSizeViewContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOverLeft: false,
	            isOverRight: false,
	            isOverCenter: false
	        };
	    },
	    onMouseInLeft: function onMouseInLeft() {
	        this.setState({
	            isOverLeft: true
	        });
	    },
	    onMouseOutLeft: function onMouseOutLeft() {
	        this.setState({
	            isOverLeft: false
	        });
	    },
	    onMouseInRight: function onMouseInRight() {
	        this.setState({
	            isOverRight: true
	        });
	    },
	    onMouseOutRight: function onMouseOutRight() {
	        this.setState({
	            isOverRight: false
	        });
	    },
	    onMouseInCenter: function onMouseInCenter() {
	        this.setState({
	            isOverCenter: true
	        });
	    },
	    onMouseOutCenter: function onMouseOutCenter() {
	        this.setState({
	            isOverCenter: false
	        });
	    },
	    onLeftClick: function onLeftClick() {
	        var currentFontSize = _TextEditorUtils2.default.getCommandValue('fontsize') - 1;
	
	        if (currentFontSize < 5) currentFontSize = 5;
	
	        _TextEditorUtils2.default.executeAction(15, currentFontSize);
	
	        this.props.executeCommand(15);
	        this.refreshView(1);
	        this.updateButtonFocus(this.refs.leftButton);
	    },
	    onRightClick: function onRightClick() {
	        var currentFontSize = _TextEditorUtils2.default.getCommandValue('fontsize') + 1;
	
	        _TextEditorUtils2.default.executeAction(15, currentFontSize);
	
	        this.props.executeCommand(16);
	        this.refreshView(2);
	        this.updateButtonFocus(this.refs.rightButton);
	    },
	    refreshView: function refreshView() {
	        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	        setTimeout(function () {
	            this.forceUpdate();
	        }.bind(this), 10);
	    },
	    onExpand: function onExpand(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var isExpanded = !this.props.fontSizeListIsExpanded;
	        this.props.dispatch((0, _MenuActions.expandFontSizeList)(isExpanded));
	        this.updateButtonFocus(this.refs.fontSizeInput);
	    },
	    updateButtonFocus: function updateButtonFocus(button) {
	        setTimeout(function () {
	            button.focus();
	        }.bind(this), 100);
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement === this.refs.leftButton) {
	            _StoreManager2.default.getStore().dispatch((0, _MenuActions.expandFontsList)(false));
	            _StoreManager2.default.getStore().dispatch((0, _MenuActions.expandFontSizeList)(false));
	        }
	    },
	    render: function render() {
	        var dataProvider = [12, 14, 18, 24, 30, 36, 48, 60, 72, 96];
	        var currentFontSize = _TextEditorUtils2.default.getCommandValue('fontsize');
	        var height = this.props.buttonSize;
	        var borderWidth = 2;
	        var menuWidth = 3 * this.props.buttonSize;
	        var visibleItems = 10;
	        var buttonHeight = 25;
	        var holderHeight = this.props.buttonSize - 2 * borderWidth;
	
	        if (this.props.fontSizeListIsExpanded === true) height = height + visibleItems * buttonHeight + 4;
	
	        var menuStyle = {
	            position: 'absolute',
	            top: this.props.top,
	            left: this.props.left,
	            width: menuWidth,
	            height: height,
	            zIndex: 1100
	        };
	
	        /********* left element *************/
	
	        var leftStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: this.props.buttonSize - 2 * borderWidth,
	            height: holderHeight,
	            background: '#f9f9f9',
	            borderTopLeftRadius: 5,
	            borderBottomLeftRadius: 5,
	            borderWidth: borderWidth,
	            borderStyle: 'solid',
	            borderColor: '#e7e7e7',
	            cursor: 'pointer',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            zIndex: 20
	        };
	
	        var minusStyle = {
	            position: 'absolute',
	            top: -14,
	            left: 7,
	            height: 20,
	            fontSize: 45,
	            color: '#5f5f5f'
	        };
	
	        if (this.state.isOverLeft) leftStyle.backgroundColor = '#edefff';
	
	        /********* center element *************/
	
	        var middleStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 32,
	            width: this.props.buttonSize,
	            height: holderHeight,
	            background: '#ffffff',
	            borderWidth: borderWidth,
	            borderColor: '#e7e7e7',
	            borderTopStyle: 'solid',
	            borderBottomStyle: 'solid',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            cursor: 'pointer'
	        };
	
	        var fontSizeStyle = {
	            position: 'absolute',
	            width: middleStyle.width,
	            top: 0,
	            left: 0,
	            height: middleStyle.height - borderWidth,
	            color: 'black',
	            fontSize: 15,
	            fontWeight: 'bold',
	            resize: 'none',
	            overflow: 'hidden',
	            background: 'transparent',
	            border: 'none',
	            textAlign: 'center',
	            paddingLeft: 0,
	            paddingRight: 0,
	            cursor: 'pointer'
	        };
	
	        if (this.state.isOverCenter) fontSizeStyle.fontSize = 17;
	
	        var fontSizeInputAriaLabel = currentFontSize;
	
	        if (this.refs.fontSizeInput) fontSizeInputAriaLabel = this.refs.fontSizeInput.value;
	
	        /********* right element *************/
	
	        var rightStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 64,
	            width: this.props.buttonSize - 2 * borderWidth,
	            height: holderHeight,
	            background: '#f9f9f9',
	            borderTopRightRadius: 5,
	            borderBottomRightRadius: 5,
	            borderWidth: borderWidth,
	            borderColor: '#e7e7e7',
	            borderStyle: 'solid',
	            fontSize: 25,
	            cursor: 'pointer',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial'
	        };
	
	        var plusStyle = {
	            position: 'absolute',
	            top: -7,
	            left: 3,
	            height: 20,
	            fontSize: 40,
	            color: '#5f5f5f'
	        };
	
	        if (this.state.isOverRight) rightStyle.backgroundColor = '#edefff';
	
	        /********* expanded *************/
	
	        var elements = [];
	        var listDisplay = void 0;
	
	        if (this.props.fontSizeListIsExpanded === true) {
	            var i = void 0;
	            var selectedIndex = -1;
	
	            for (i = 0; i < dataProvider.length; i++) {
	                if (currentFontSize === dataProvider[i]) selectedIndex = i;
	
	                elements.push(_react2.default.createElement(Button, { executeCommand: this.props.executeCommand, refreshView: this.refreshView, height: buttonHeight, width: menuWidth, index: i, dispatch: this.props.dispatch, shapeModel: this.props.contextTarget, key: 'font' + dataProvider[i], value: dataProvider[i], selectedIndex: selectedIndex }));
	            }
	
	            listDisplay = 'block';
	        } else {
	            listDisplay = 'none';
	        }
	
	        var fontSizeListStyle = {
	            position: 'absolute',
	            width: menuWidth,
	            height: buttonHeight * visibleItems,
	            top: holderHeight + 2,
	            left: 0,
	            borderColor: _Properties2.default.EFFECTS_BUTTON_BORDER_COLOR,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            display: listDisplay,
	            overflowY: 'hidden',
	            overflowX: 'hidden'
	        };
	
	        var componentProperties = {};
	        componentProperties.paddingTop = 0;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = fontSizeListStyle.width;
	        componentProperties.height = fontSizeListStyle.height;
	        componentProperties.scrollHeight = dataProvider != undefined ? dataProvider.length * buttonHeight : 0;
	        componentProperties.top = 0;
	        componentProperties.displayState = 'block';
	        componentProperties.elements = elements;
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'fontSizeMenu', style: menuStyle },
	            _react2.default.createElement(
	                'button',
	                { ref: 'leftButton', 'aria-label': _HoverManager2.default.getText('minus'), style: leftStyle, onMouseOver: this.onMouseInLeft, onMouseOut: this.onMouseOutLeft, onTouchEnd: this.onLeftClick, onClick: this.onLeftClick, onFocus: this.onFocusHandler },
	                _react2.default.createElement(
	                    'span',
	                    { style: minusStyle },
	                    '-'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: middleStyle, onMouseOver: this.onMouseInCenter, onMouseOut: this.onMouseOutCenter, onTouchEnd: this.onExpand, onClick: this.onExpand },
	                _react2.default.createElement('input', { ref: 'fontSizeInput', id: 'fontSizeMiddle', type: 'button', style: fontSizeStyle, 'aria-label': fontSizeInputAriaLabel, defaultValue: currentFontSize, spellCheck: 'false', autoCorrect: 'off', autoCapitalize: 'off', autoComplete: 'off' })
	            ),
	            _react2.default.createElement(
	                'button',
	                { ref: 'rightButton', 'aria-label': _HoverManager2.default.getText('plus'), style: rightStyle, onMouseOver: this.onMouseInRight, onMouseOut: this.onMouseOutRight, onTouchEnd: this.onRightClick, onClick: this.onRightClick },
	                _react2.default.createElement(
	                    'span',
	                    { style: plusStyle },
	                    '+'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: fontSizeListStyle, onTouchEnd: this.onListChanged, onClick: this.onListChanged },
	                _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var fontSizeListIsExpanded = state.menu.fontSizeListIsExpanded;
	
	    return {
	        fontSizeListIsExpanded: fontSizeListIsExpanded
	    };
	}
	
	var FontSizeView = exports.FontSizeView = (0, _reactRedux.connect)(mapStateToProps)(FontSizeViewContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/FontSizeView.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/FontSizeView.js"); } } })();

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ShapeTypeElement = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _MenuActions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShapeTypeElement = exports.ShapeTypeElement = _react2.default.createClass({
	    displayName: 'ShapeTypeElement',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	
	        if (this.props.index === 5) _HoverManager2.default.show(this.refs.button, this.getAriaLabel(), 'left', true);else _HoverManager2.default.show(this.refs.button, this.getAriaLabel(), 'bottom', true);
	    },
	    onMouseOut: function onMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isOver: false
	        });
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.props.executeCommand(this.props.contextTarget.uuid, this.props.type);
	        this.updateButtonFocus();
	    },
	    updateButtonFocus: function updateButtonFocus() {
	        setTimeout(function () {
	            this.refs.button.focus();
	        }.bind(this), 100);
	    },
	    getContextTarget: function getContextTarget() {
	        var shapes = _StoreManager2.default.getState().currentSlide.model.content;
	
	        for (var i = 1; i < shapes.length; i++) {
	            if (shapes[i].uuid === this.props.contextTarget.uuid) return shapes[i];
	        }
	
	        return this.props.contextTarget;
	    },
	    getAriaLabel: function getAriaLabel() {
	        switch (this.props.index) {
	            case 0:
	                {
	                    return _HoverManager2.default.getText('textBox');
	                }
	            case 1:
	                {
	                    return _HoverManager2.default.getText('textBoxSimple');
	                }
	            case 2:
	                {
	                    return _HoverManager2.default.getText('speechBubble');
	                }
	            case 3:
	                {
	                    return _HoverManager2.default.getText('thoughtBubble');
	                }
	            case 4:
	                {
	                    return _HoverManager2.default.getText('screamBubble');
	                }
	            case 5:
	                {
	                    return _HoverManager2.default.getText('complexSpeechBubble');
	                }
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement.id.indexOf('textBoxSimpleButton') != -1) _StoreManager2.default.getStore().dispatch((0, _MenuActions.expandFontLineHeight)(false));
	    },
	    render: function render() {
	        var gap = 2;
	        var width = this.props.width - gap;
	        var contextTarget = this.getContextTarget();
	        var elementStyle = {
	            position: 'absolute',
	            top: 0,
	            left: this.props.index * (width + gap),
	            width: width,
	            height: width,
	            backgroundColor: 'white',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            lineHeight: 1.72222,
	            borderStyle: 'none',
	            cursor: 'pointer'
	        };
	
	        if (this.state.isOver) {
	            elementStyle.backgroundColor = '#edefff';
	            elementStyle.borderRadius = 5;
	            elementStyle.borderWidth = 1;
	            elementStyle.borderStyle = 'solid';
	            elementStyle.borderColor = '#9ea2fd';
	        } else if (contextTarget.type === this.props.type) {
	            elementStyle.backgroundColor = '#edefff';
	            elementStyle.borderRadius = 5;
	            elementStyle.borderWidth = 1;
	            elementStyle.borderStyle = 'solid';
	            elementStyle.borderColor = '#2377bb';
	        }
	
	        var iconStyle = {
	            position: 'absolute',
	            width: elementStyle.width - 2 * 3,
	            left: 3,
	            top: 5
	        };
	
	        return _react2.default.createElement(
	            'button',
	            { ref: 'button', id: this.props.id, 'aria-label': this.getAriaLabel(), style: elementStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onTouchEnd: this.onClick, onClick: this.onClick, onFocus: this.onFocusHandler },
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: iconStyle, src: this.props.src })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/ShapeTypeElement.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/menus/textEditorTool/components/subcomponents/ShapeTypeElement.js"); } } })();

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Canvas = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RecordingMenu = __webpack_require__(810);
	
	var _SVGContainer = __webpack_require__(345);
	
	var _DrawArea = __webpack_require__(840);
	
	var _ShapeMenu = __webpack_require__(816);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MenuActions = __webpack_require__(7);
	
	var _KeyboardShortcuts = __webpack_require__(143);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _ShapeAspectRatioUtils = __webpack_require__(374);
	
	var _ShapeAspectRatioUtils2 = _interopRequireDefault(_ShapeAspectRatioUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ShapeMenuButton = __webpack_require__(817);
	
	var _TextBoxLabel = __webpack_require__(824);
	
	var _GroupButton = __webpack_require__(790);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _VideoEditor = __webpack_require__(861);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Canvas = exports.Canvas = _react2.default.createClass({
	    displayName: 'Canvas',
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('keydown', this.onKeyDown);
	        document.addEventListener('keyup', this.onKeyUp);
	
	        setTimeout(function () {
	            try {
	                if (window.parent) {
	                    var iFrame = window.parent.document.getElementById('cartoonist-iframe');
	
	                    if (iFrame && iFrame.contentWindow) iFrame.contentWindow.focus();
	                }
	            } catch (e) {
	                // error
	            }
	        }.bind(this), 1000);
	
	        if (this.props.mode == _ModeConstants2.default.EDITOR) {
	            _AudioEditorUtils2.default.addActionToHistory(); // add first state to UNDO history
	            _SaveManager2.default.initAutoSave();
	        }
	
	        _VideoUtils2.default.init(this.props.dispatch);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('keydown', this.onKeyDown);
	        document.removeEventListener('keyup', this.onKeyUp);
	    },
	    onKeyDown: function onKeyDown(e) {
	        (0, _KeyboardShortcuts.checkKeyboardCommand)(e, this.props.dispatch);
	        _ShapeAspectRatioUtils2.default.checkShift(e);
	        _SelectionManager2.default.checkControl(e);
	
	        var element = document.activeElement;
	        var isActiveTextElement = false;
	
	        if (element && (element.className == 'textShapes' || element.className == 'titleInput')) isActiveTextElement = true;
	
	        if (_PlayController2.default.isAudioEditorMode() && !isActiveTextElement && (e.keyCode == 37 || e.keyCode == 39)) {
	            // left or right arrows should not scroll in Advanced mode
	            e.stopPropagation();
	            e.preventDefault();
	            return false;
	        }
	
	        if (e.keyCode == 8 && _PlatformDetection2.default.isFirefox()) {
	            // is Backspace key and is Firefox
	            if (!isActiveTextElement) {
	                e.stopPropagation();
	                e.preventDefault();
	                return false;
	            }
	        }
	    },
	    onKeyUp: function onKeyUp(e) {
	        _ShapeAspectRatioUtils2.default.checkShift(e);
	        _SelectionManager2.default.checkControl(e);
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_AnimationManager2.default.isAnimationMode()) return;
	
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) return;
	
	        var target = e.target;
	
	        if (target.id == 'menuButton' || target.parentNode.id == 'menuButton' || target.parentNode.parentNode.id == 'menuButton') return;
	
	        if (target.className == 'textShapes') return;
	
	        if (_StoreManager2.default.getState().menu.contextMode == _ModeConstants2.default.SIZE_AND_POSITION_CONTEXT) return;
	
	        this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	    },
	    render: function render() {
	        var scaleProperties = this.props.scaleProperties;
	        var scaleTransform = 'scale(' + scaleProperties.scale + ')';
	
	        var svgContainerStyle = {
	            position: 'absolute',
	            transform: scaleTransform,
	            WebkitTransform: scaleTransform,
	            margin: 0,
	            top: scaleProperties.top,
	            left: scaleProperties.left,
	            maxWidth: _Configuration2.default.CANVAS_WIDTH,
	            maxHeight: _Configuration2.default.CANVAS_HEIGHT,
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none'
	        };
	
	        if (this.props.showVideoEditor) svgContainerStyle.display = 'none';
	
	        var elements = [];
	
	        if (_AppParameters2.default.getMode() != _ModeConstants2.default.PLAYER && this.props.mode == _ModeConstants2.default.EDITOR && !this.props.showVideoEditor) {
	            elements.push(_react2.default.createElement(_TextBoxLabel.TextBoxLabel, { dispatch: this.props.dispatch, scaleProperties: scaleProperties, key: 'canvas5' }));
	            elements.push(_react2.default.createElement(_ShapeMenuButton.ShapeMenuButton, { dispatch: this.props.dispatch, scaleProperties: scaleProperties, key: 'canvas0' }));
	            elements.push(_react2.default.createElement(_ShapeMenu.ShapeMenu, { dispatch: this.props.dispatch, scaleProperties: scaleProperties, key: 'canvas1' }));
	            elements.push(_react2.default.createElement(_GroupButton.GroupButton, { dispatch: this.props.dispatch, scaleProperties: scaleProperties, key: 'canvas4' }));
	            elements.push(_react2.default.createElement(_RecordingMenu.RecordingMenu, { dispatch: this.props.dispatch, scaleProperties: scaleProperties, mode: this.props.mode, key: 'canvas2' }));
	        }
	
	        var videoBackgroundHolder;
	        var videoButtonsHolder;
	
	        videoBackgroundHolder = _react2.default.createElement(_VideoEditor.VideoEditor, { scaleProperties: scaleProperties, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, windowHeight: this.props.windowHeight, accordionWidth: this.props.accordionWidth });
	
	        var videoHolderStyle = {
	            position: 'absolute',
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            top: 0,
	            left: 0
	        };
	
	        videoButtonsHolder = _react2.default.createElement('div', { id: 'videoHolder', style: videoHolderStyle });
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            videoBackgroundHolder,
	            _react2.default.createElement(
	                'div',
	                { id: 'svgContainer', style: svgContainerStyle, onClick: this.onClick, onTouchEnd: this.onClick },
	                _react2.default.createElement(_SVGContainer.SVGContainer, { dispatch: this.props.dispatch, scaleProperties: scaleProperties }),
	                _react2.default.createElement(_DrawArea.DrawArea, { dispatch: this.props.dispatch, scaleProperties: scaleProperties, mode: this.props.mode })
	            ),
	            videoButtonsHolder,
	            elements
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/Canvas.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/Canvas.js"); } } })();

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DrawArea = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _DrawingUtils = __webpack_require__(108);
	
	var _DrawingUtils2 = _interopRequireDefault(_DrawingUtils);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DrawAreaContent = _react2.default.createClass({
	    displayName: 'DrawAreaContent',
	    getInitialState: function getInitialState() {
	        return {
	            path: '',
	            points: [],
	            draw: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('touchend', this.onStop);
	        document.addEventListener('mouseup', this.onStop);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('touchend', this.onStop);
	        document.removeEventListener('mouseup', this.onStop);
	    },
	    onStart: function onStart(e) {
	        e.preventDefault();
	
	        if (this.props.drawState == 'none') return;
	
	        this.setState({
	            path: '',
	            points: [],
	            draw: true
	        });
	    },
	    onMove: function onMove(e) {
	        e.preventDefault();
	
	        if (this.state.draw == false) return;
	
	        var newPath = '';
	        var point = this.convertPoint(_DrawingUtils2.default.getTouchPosition(e));
	        var type = this.props.drawState;
	        var pathPoints = this.state.points;
	
	        if (type == _ModeConstants2.default.LINE_CONTEXT) {
	            if (this.state.path.length < 1) {
	                newPath = 'M' + point.x + ',' + point.y;
	            } else {
	                newPath = 'M' + pathPoints[0].x + ',' + pathPoints[0].y + 'L' + point.x + ',' + point.y;
	            }
	        } else if (type == _ModeConstants2.default.FREEHAND_CONTEXT) {
	            if (this.state.path.length < 1) newPath = 'M' + point.x + ',' + point.y;else newPath = this.state.path + ',L' + point.x + ',' + point.y;
	        }
	
	        pathPoints.push(point);
	
	        this.setState({
	            path: newPath,
	            points: pathPoints
	        });
	
	        this.drawObject(type);
	    },
	    convertPoint: function convertPoint(point) {
	        var topX = this.props.scaleProperties.topX;
	        var topY = this.props.scaleProperties.topY;
	        var scale = this.props.scaleProperties.scale;
	
	        var xValue = (point.x - topX) / scale;
	        var yValue = (point.y - topY) / scale;
	
	        return { x: xValue.toFixed(2), y: yValue.toFixed(2) };
	    },
	    drawObject: function drawObject(type) {
	        var points = this.state.points;
	
	        if (points.length < 2) return;
	
	        var drawingProperties = _DrawingUtils2.default.getDrawingProperties();
	        var c = document.getElementById('drawCanvas');
	        var ctx = c.getContext('2d');
	        var i;
	        var point = points[0];
	
	        this.clearCanvas();
	
	        ctx.beginPath();
	        ctx.lineWidth = drawingProperties.strokeWidth;
	        ctx.strokeStyle = drawingProperties.strokeColor;
	        ctx.moveTo(point.x, point.y);
	
	        if (type == _ModeConstants2.default.LINE_CONTEXT) {
	            point = points[points.length - 1];
	            ctx.lineTo(point.x, point.y);
	        } else {
	            for (i = 1; i < points.length; i++) {
	                point = points[i];
	                ctx.lineTo(point.x, point.y);
	            }
	        }
	
	        ctx.stroke();
	    },
	    clearCanvas: function clearCanvas() {
	        var c = document.getElementById('drawCanvas');
	
	        if (c == undefined) return;
	
	        var ctx = c.getContext('2d');
	        ctx.clearRect(0, 0, c.width, c.height);
	    },
	    onStop: function onStop(e) {
	        if (_TextSizeUtils2.default.isTextEditMode()) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (this.state.draw == true) {
	            if (!_PlatformDetection2.default.isIOS()) e.preventDefault();
	
	            var dispatch = this.props.dispatch;
	
	
	            var type = this.props.drawState;
	
	            if (type == _ModeConstants2.default.LINE_CONTEXT) {
	                _CreateShapes2.default.createLine(dispatch, this.state.path, _DrawingUtils2.default.getDrawingProperties());
	            } else if (type == _ModeConstants2.default.FREEHAND_CONTEXT) {
	                _CreateShapes2.default.createFreehand(dispatch, this.state.path, _DrawingUtils2.default.getDrawingProperties());
	            }
	
	            this.clearCanvas();
	
	            this.setState({
	                path: '',
	                points: [],
	                draw: false
	            });
	        }
	    },
	    render: function render() {
	        if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER || this.props.mode == _ModeConstants2.default.PREVIEW) {
	            var drawAreaPreviewStyle = {
	                position: 'absolute',
	                width: _Configuration2.default.CANVAS_WIDTH,
	                height: _Configuration2.default.CANVAS_HEIGHT,
	                top: 0,
	                left: 0,
	                display: 'block'
	            };
	
	            return _react2.default.createElement('div', { style: drawAreaPreviewStyle });
	        }
	
	        var displayState;
	
	        if (this.props.drawState == undefined || this.props.drawState == 'none') {
	            displayState = 'none';
	            return _react2.default.createElement('div', null);
	        } else displayState = 'block';
	
	        var drawAreaStyle = {
	            position: 'absolute',
	            width: _Configuration2.default.CANVAS_WIDTH,
	            height: _Configuration2.default.CANVAS_HEIGHT,
	            top: 0,
	            left: 0,
	            display: displayState,
	            cursor: 'crosshair'
	        };
	
	        var backgroundAreaStyle = {
	            position: 'absolute',
	            width: _Configuration2.default.CANVAS_WIDTH,
	            height: _Configuration2.default.CANVAS_HEIGHT,
	            top: 0,
	            left: 0,
	            background: 'white',
	            opacity: 0.1
	        };
	
	        var canvasStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: drawAreaStyle },
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onStart, onDrag: this.onMove },
	                _react2.default.createElement(
	                    'div',
	                    { ref: 'drawingArea' },
	                    _react2.default.createElement('canvas', { id: 'drawCanvas', width: _Configuration2.default.CANVAS_WIDTH, height: _Configuration2.default.CANVAS_HEIGHT, style: canvasStyle })
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var drawState = state.accordion.drawState;
	
	    return {
	        drawState: drawState
	    };
	}
	
	var DrawArea = exports.DrawArea = (0, _reactRedux.connect)(mapStateToProps)(DrawAreaContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/DrawArea.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/DrawArea.js"); } } })();

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CroppingTransformTool = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _MenuActions = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CroppingTransformTool = exports.CroppingTransformTool = _react2.default.createClass({
	    displayName: 'CroppingTransformTool',
	    getInitialState: function getInitialState() {
	        var hotspot = this.getCurrentHotspot();
	        _ZoomUtils2.default.currentCroppingHotspot = hotspot;
	        _ZoomUtils2.default.updateCurrentCroppingHotspot = this.updateCurrentHotspotFromInputValue;
	        _ZoomUtils2.default.updateTransformTool = this.updateTransformTool;
	
	        return {
	            x: hotspot.x,
	            y: hotspot.y,
	            width: hotspot.width,
	            height: hotspot.height,
	            startX: -1,
	            startY: -1,
	            startWidth: -1,
	            startHeight: -1
	        };
	    },
	    refreshInitialPosition: function refreshInitialPosition() {
	        setTimeout(this.updateCroppingInitialPosition, 1);
	    },
	    updateCroppingInitialPosition: function updateCroppingInitialPosition() {
	        var hotspot = this.getCurrentHotspot();
	
	        this.setState({
	            x: hotspot.x,
	            y: hotspot.y,
	            width: hotspot.width,
	            height: hotspot.height
	        });
	
	        _ZoomUtils2.default.updateCroppingInitialPosition = false;
	
	        setTimeout(this.updateHotspot, 5);
	    },
	    onScaleStart: function onScaleStart(e) {
	        e.preventDefault();
	
	        this.setState({
	            startX: this.state.x,
	            startY: this.state.y,
	            startWidth: this.state.width,
	            startHeight: this.state.height
	        });
	
	        _ZoomUtils2.default.updateCroppingInitialPosition = false;
	    },
	    onScaleDrag: function onScaleDrag(e, coreEvent) {
	        e.preventDefault();
	
	        var id = coreEvent.node.id;
	        var x = this.state.startX;
	        var y = this.state.startY;
	        var width = this.state.startWidth;
	        var height = this.state.startHeight;
	
	        switch (id) {
	            case 'topLeft':
	                {
	                    x = this.state.startX + coreEvent.lastX / this.scaleFactor();
	                    y = this.state.startY + coreEvent.lastY / this.scaleFactor();
	                    width = this.state.startWidth - coreEvent.lastX / this.scaleFactor();
	                    height = this.state.startHeight - coreEvent.lastY / this.scaleFactor();
	
	                    break;
	                }
	
	            case 'topRight':
	                {
	                    y = this.state.startY + coreEvent.lastY / this.scaleFactor();
	                    width = this.state.startWidth + coreEvent.lastX / this.scaleFactor();
	                    height = this.state.startHeight - coreEvent.lastY / this.scaleFactor();
	
	                    break;
	                }
	
	            case 'bottomLeft':
	                {
	                    x = this.state.startX + coreEvent.lastX / this.scaleFactor();
	                    width = this.state.startWidth - coreEvent.lastX / this.scaleFactor();
	                    height = this.state.startHeight + coreEvent.lastY / this.scaleFactor();
	
	                    break;
	                }
	
	            case 'bottomRight':
	                {
	                    width = this.state.startWidth + coreEvent.lastX / this.scaleFactor();
	                    height = this.state.startHeight + coreEvent.lastY / this.scaleFactor();
	
	                    break;
	                }
	        }
	
	        var minSize = 30;
	        var realShape = this.getRealShapeSize(_ZoomUtils2.default.croppingTarget);
	
	        if (x < realShape.x) x = realShape.x;
	
	        if (y < realShape.y) y = realShape.y;
	
	        if (x + width > realShape.x + realShape.width) width = realShape.x + realShape.width - x;
	
	        if (y + height > realShape.y + realShape.height) height = realShape.y + realShape.height - y;
	
	        if (width >= minSize && height >= minSize) {
	            this.setState({
	                x: x,
	                y: y,
	                width: width,
	                height: height
	            });
	        }
	    },
	    onScaleStopped: function onScaleStopped() {
	        this.updateHotspot();
	        _StoreManager2.default.getStore().dispatch((0, _MenuActions.refreshShapePosition)());
	    },
	    getRealShapeSize: function getRealShapeSize(shapeModel) {
	        var newShape;
	
	        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
	            var realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
	            var realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);
	            var x1 = realWidth * shapeModel.hotSpot.x1 / 100;
	            var y1 = realHeight * shapeModel.hotSpot.y1 / 100;
	            newShape = {};
	
	            newShape.width = realWidth;
	            newShape.height = realHeight;
	            newShape.x = shapeModel.x - x1;
	            newShape.y = shapeModel.y - y1;
	        } else newShape = shapeModel;
	
	        return newShape;
	    },
	    updateHotspot: function updateHotspot() {
	        var hotspotX1 = this.state.x;
	        var hotspotY1 = this.state.y;
	        var hotspotX2 = hotspotX1 + this.state.width;
	        var hotspotY2 = hotspotY1 + this.state.height;
	        var newShape = this.getRealShapeSize(_ZoomUtils2.default.croppingTarget);
	
	        var shapeX1 = newShape.x;
	        var shapeY1 = newShape.y;
	        var shapeX2 = shapeX1 + newShape.width;
	        var shapeY2 = shapeY1 + newShape.height;
	        var realHotspot;
	
	        if (shapeX1 >= hotspotX2 || shapeX2 <= hotspotX1 || shapeY1 >= hotspotY2 || shapeY2 <= hotspotY1) {
	            // no hotspot
	        } else {
	            realHotspot = {};
	
	            if (hotspotX1 <= shapeX1) realHotspot.x1 = 0;else realHotspot.x1 = (hotspotX1 - shapeX1) * 100 / newShape.width;
	
	            if (hotspotX2 >= shapeX2) realHotspot.x2 = 100;else realHotspot.x2 = (hotspotX2 - shapeX1) * 100 / newShape.width;
	
	            if (hotspotY1 <= shapeY1) realHotspot.y1 = 0;else realHotspot.y1 = (hotspotY1 - shapeY1) * 100 / newShape.height;
	
	            if (hotspotY2 >= shapeY2) realHotspot.y2 = 100;else realHotspot.y2 = (hotspotY2 - shapeY1) * 100 / newShape.height;
	        }
	
	        _ZoomUtils2.default.currentCroppingHotspot = realHotspot;
	    },
	    getCurrentHotspot: function getCurrentHotspot() {
	        var hotspotModel = {};
	        var shapeModel = _ZoomUtils2.default.croppingTarget;
	
	        if (shapeModel) {
	            hotspotModel.x = shapeModel.x;
	            hotspotModel.width = shapeModel.width;
	            hotspotModel.y = shapeModel.y;
	            hotspotModel.height = shapeModel.height;
	        } else {
	            hotspotModel.width = 400;
	            hotspotModel.height = 400 * 9 / 16;
	            hotspotModel.x = 200;
	            hotspotModel.y = 450 / 2 - hotspotModel.height / 2;
	        }
	
	        return hotspotModel;
	    },
	    updateCurrentHotspotFromInputValue: function updateCurrentHotspotFromInputValue(property, value) {
	        var minSize = 30;
	        var realShape = this.getRealShapeSize(_ZoomUtils2.default.croppingTarget);
	        var localHotSpot = { x1: _ZoomUtils2.default.currentCroppingHotspot.x1, x2: _ZoomUtils2.default.currentCroppingHotspot.x2, y1: _ZoomUtils2.default.currentCroppingHotspot.y1, y2: _ZoomUtils2.default.currentCroppingHotspot.y2 };
	        var xMinLimitPercents = Math.ceil(minSize * 100 / realShape.width);
	        var yMinLimitPercents = Math.ceil(minSize * 100 / realShape.height);
	
	        switch (property) {
	            case 'x1':
	                {
	                    localHotSpot.x1 = value;
	
	                    if (localHotSpot.x1 + xMinLimitPercents > localHotSpot.x2) localHotSpot.x1 = localHotSpot.x2 - xMinLimitPercents;
	                    break;
	                }
	            case 'x2':
	                {
	                    if (value > 100) value = 100;
	
	                    localHotSpot.x2 = value;
	                    break;
	                }
	            case 'y1':
	                {
	                    localHotSpot.y1 = value;
	
	                    if (localHotSpot.y1 + yMinLimitPercents > localHotSpot.y2) localHotSpot.y1 = localHotSpot.y2 - yMinLimitPercents;
	                    break;
	                }
	            case 'y2':
	                {
	                    if (value > 100) value = 100;
	
	                    localHotSpot.y2 = value;
	                    break;
	                }
	        }
	
	        _ZoomUtils2.default.currentCroppingHotspot = localHotSpot;
	
	        this.updateTransformTool();
	
	        _StoreManager2.default.getStore().dispatch((0, _MenuActions.refreshShapePosition)());
	    },
	    updateTransformTool: function updateTransformTool() {
	        var minSize = 30;
	        var realShape = this.getRealShapeSize(_ZoomUtils2.default.croppingTarget);
	        var localHotSpot = { x1: _ZoomUtils2.default.currentCroppingHotspot.x1, x2: _ZoomUtils2.default.currentCroppingHotspot.x2, y1: _ZoomUtils2.default.currentCroppingHotspot.y1, y2: _ZoomUtils2.default.currentCroppingHotspot.y2 };
	
	        var x = realShape.x + realShape.width * localHotSpot.x1 / 100;
	        var y = realShape.y + realShape.height * localHotSpot.y1 / 100;
	        var width = realShape.width * (localHotSpot.x2 - localHotSpot.x1) / 100;
	        var height = realShape.height * (localHotSpot.y2 - localHotSpot.y1) / 100;
	
	        if (x < realShape.x) x = realShape.x;
	
	        if (y < realShape.y) y = realShape.y;
	
	        if (x + width > realShape.x + realShape.width) width = realShape.x + realShape.width - x;
	
	        if (y + height > realShape.y + realShape.height) height = realShape.y + realShape.height - y;
	
	        if (width >= minSize && height >= minSize) {
	            this.setState({
	                x: x,
	                y: y,
	                width: width,
	                height: height
	            });
	        }
	    },
	    onMoveStart: function onMoveStart(e) {
	        e.preventDefault();
	
	        this.setState({
	            startX: this.state.x,
	            startY: this.state.y
	        });
	
	        _ZoomUtils2.default.updateCroppingInitialPosition = false;
	    },
	    onMoveDrag: function onMoveDrag(e, coreEvent) {
	        e.preventDefault();
	
	        var x = this.state.startX + coreEvent.lastX / this.scaleFactor();
	        var y = this.state.startY + coreEvent.lastY / this.scaleFactor();
	        var width = this.state.width;
	        var height = this.state.height;
	        var realShape = this.getRealShapeSize(_ZoomUtils2.default.croppingTarget);
	
	        if (x < realShape.x) x = realShape.x;
	
	        if (y < realShape.y) y = realShape.y;
	
	        if (x + width > realShape.x + realShape.width) x = realShape.x + realShape.width - width;
	
	        if (y + height > realShape.y + realShape.height) y = realShape.y + realShape.height - height;
	
	        this.setState({
	            x: x,
	            y: y
	        });
	    },
	    onMoveStopped: function onMoveStopped() {
	        this.updateHotspot();
	    },
	    scaleFactor: function scaleFactor() {
	        var canvasScale = this.props.scaleProperties.scale;
	        return canvasScale;
	    },
	    isVisible: function isVisible() {
	        var state = _StoreManager2.default.getState();
	        var showCroppingMenu = state.menu.showCroppingMenu;
	
	        if (showCroppingMenu == undefined || showCroppingMenu == false) return false;else return true;
	    },
	    render: function render() {
	        if (this.isVisible() == false) return _react2.default.createElement('g', null);
	
	        if (_ZoomUtils2.default.updateCroppingInitialPosition == true) this.refreshInitialPosition();
	
	        var x = this.state.x;
	        var y = this.state.y;
	        var width = this.state.width;
	        var height = this.state.height;
	        var scale = this.props.scaleProperties.scale;
	
	        var pathPoints = 'M0 0 L' + width + ' 0 L' + width + ' ' + height + ' L0 ' + height + ' Z';
	
	        var cornerFill = _TransformToolUtils.uiProperties.CORNER_FILL_INACTIVE;
	        var cornerStroke = _TransformToolUtils.uiProperties.CORNER_STROKE_INACTIVE;
	
	        var canvasWidth = _Configuration2.default.CANVAS_WIDTH;
	        var canvasHeight = _Configuration2.default.CANVAS_HEIGHT;
	
	        var radiusOffset = 0;
	
	        if (_PlatformDetection2.default.isIOS()) radiusOffset = 2;
	
	        var radius = (_TransformToolUtils.uiProperties.RADIUS + radiusOffset) / scale;
	        var extraRadius = radius;
	
	        return _react2.default.createElement(
	            'g',
	            { transform: 'translate(' + x + ' ' + y + ')' },
	            _react2.default.createElement('rect', { x: -x, y: -y, width: x, height: canvasHeight, fill: '#000000', fillOpacity: 0.5 }),
	            _react2.default.createElement('rect', { x: width, y: -y, width: canvasWidth - x - width, height: canvasHeight, fill: '#000000', fillOpacity: 0.5 }),
	            _react2.default.createElement('rect', { x: 0, y: -y, width: width, height: y, fill: '#000000', fillOpacity: 0.5 }),
	            _react2.default.createElement('rect', { x: 0, y: height, width: width, height: canvasHeight - y - height, fill: '#000000', fillOpacity: 0.5 }),
	            _react2.default.createElement('path', { stroke: _TransformToolUtils.uiProperties.PATH_COLOR, strokeWidth: _TransformToolUtils.uiProperties.STROKE, fill: 'none', d: pathPoints }),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMoveStart, onDrag: this.onMoveDrag, onStop: this.onMoveStopped },
	                _react2.default.createElement('rect', { x: 0, y: 0, width: this.state.width, height: this.state.height, fill: '#000000', fillOpacity: 0 })
	            ),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleStopped },
	                _react2.default.createElement('circle', { id: 'topLeft', cx: 0 - extraRadius / 1.5, cy: 0 - extraRadius / 1.5, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	            ),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleStopped },
	                _react2.default.createElement('circle', { id: 'topRight', cx: width + extraRadius / 1.5, cy: 0 - extraRadius / 1.5, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	            ),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleStopped },
	                _react2.default.createElement('circle', { id: 'bottomRight', cx: width + extraRadius / 1.5, cy: height + extraRadius / 1.5, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	            ),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleStopped },
	                _react2.default.createElement('circle', { id: 'bottomLeft', cx: 0 - extraRadius / 1.5, cy: height + extraRadius / 1.5, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/interactive/CroppingTransformTool.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/interactive/CroppingTransformTool.js"); } } })();

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ZoomTransformTool = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ZoomTransformTool = exports.ZoomTransformTool = _react2.default.createClass({
	    displayName: 'ZoomTransformTool',
	    getInitialState: function getInitialState() {
	        var hotspot = this.getCurrentHotspot();
	        _ZoomUtils2.default.currentHotspot = hotspot;
	        _ZoomUtils2.default.currentBackgroundUid = this.props.backgroundModel.uuid;
	
	        return {
	            x: hotspot.x,
	            y: hotspot.y,
	            width: hotspot.width,
	            height: hotspot.height,
	            startX: -1,
	            startY: -1,
	            startWidth: -1,
	            startHeight: -1
	        };
	    },
	    zoomEventListener: function zoomEventListener(e) {
	        var interval = 10;
	        var aspectRatio = 9 / 16;
	        var hasChanged = false;
	
	        if (e.detail === "zoomIn") {
	            this.setState({ width: this.state.width + interval, height: this.state.height + aspectRatio * interval });
	            hasChanged = true;
	        } else if (e.detail === "zoomOut") {
	            if (this.state.width > interval && this.state.height > aspectRatio * interval) {
	                this.setState({ width: this.state.width - interval, height: this.state.height - aspectRatio * interval });
	                hasChanged = true;
	            }
	        } else if (e.detail === "left") {
	            this.setState({ x: this.state.x - interval });
	            hasChanged = true;
	        } else if (e.detail === "right") {
	            this.setState({ x: this.state.x + interval });
	            hasChanged = true;
	        } else if (e.detail === "up") {
	            this.setState({ y: this.state.y - interval });
	            hasChanged = true;
	        } else if (e.detail === "down") {
	            this.setState({ y: this.state.y + 20 });
	            hasChanged = true;
	        }
	
	        if (hasChanged) {
	            this.updateHotspot();
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        document.addEventListener("ZoomTransformEvent", this.zoomEventListener);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener("ZoomTransformEvent", this.zoomEventListener);
	    },
	    getCurrentHotspot: function getCurrentHotspot() {
	        var hotspot = this.props.backgroundModel.hotSpot;
	        var hotspotModel = {};
	
	        if (hotspot == undefined || hotspot == '') {
	            hotspotModel.width = 400;
	            hotspotModel.height = 400 * 9 / 16;
	            hotspotModel.x = 200;
	            hotspotModel.y = 450 / 2 - hotspotModel.height / 2;
	        } else {
	            hotspotModel.x = hotspot.x;
	            hotspotModel.y = hotspot.y;
	            hotspotModel.width = hotspot.width;
	            hotspotModel.height = hotspot.height;
	        }
	
	        return hotspotModel;
	    },
	    refreshInitialPosition: function refreshInitialPosition() {
	        setTimeout(this.updateInitialPosition, 1);
	    },
	    updateInitialPosition: function updateInitialPosition() {
	        var hotspot = this.getCurrentHotspot();
	        _ZoomUtils2.default.currentHotspot = hotspot;
	        _ZoomUtils2.default.currentBackgroundUid = this.props.backgroundModel.uuid;
	
	        this.setState({
	            x: hotspot.x,
	            y: hotspot.y,
	            width: hotspot.width,
	            height: hotspot.height
	        });
	
	        _ZoomUtils2.default.updateInitialPosition = false;
	    },
	    onScaleStart: function onScaleStart(e) {
	        e.preventDefault();
	
	        this.setState({
	            startX: this.state.x,
	            startY: this.state.y,
	            startWidth: this.state.width,
	            startHeight: this.state.height
	        });
	
	        _ZoomUtils2.default.updateInitialPosition = false;
	    },
	    onScaleDrag: function onScaleDrag(e, coreEvent) {
	        e.preventDefault();
	
	        var id = coreEvent.node.id;
	        var x = this.state.startX;
	        var y = this.state.startY;
	        var width = this.state.startWidth;
	        var height = this.state.startHeight;
	        var minWidth = 100;
	
	        switch (id) {
	            case 'topLeft':
	                {
	                    x = this.state.startX + coreEvent.lastX / this.scaleFactor();
	                    y = this.state.startY + coreEvent.lastY / this.scaleFactor();
	                    width = this.state.startWidth - coreEvent.lastX / this.scaleFactor();
	
	                    break;
	                }
	
	            case 'topRight':
	                {
	                    width = this.state.startWidth + coreEvent.lastX / this.scaleFactor();
	                    y = this.state.startY + coreEvent.lastY / this.scaleFactor();
	
	                    break;
	                }
	
	            case 'bottomLeft':
	                {
	                    x = this.state.startX + coreEvent.lastX / this.scaleFactor();
	                    width = this.state.startWidth - coreEvent.lastX / this.scaleFactor();
	
	                    break;
	                }
	
	            case 'bottomRight':
	                {
	                    width = this.state.startWidth + coreEvent.lastX / this.scaleFactor();
	
	                    break;
	                }
	        }
	
	        height = width * 9 / 16;
	
	        if (x >= 0 && width >= minWidth && x + width <= _Configuration2.default.CANVAS_WIDTH && y + height <= _Configuration2.default.CANVAS_HEIGHT && y >= 0) {
	            this.setState({
	                x: x,
	                y: y,
	                width: width,
	                height: height
	            });
	        }
	    },
	    onScaleStopped: function onScaleStopped() {
	        this.updateHotspot();
	    },
	    updateHotspot: function updateHotspot() {
	        var hotspot = {};
	        hotspot.x = this.state.x;
	        hotspot.y = this.state.y;
	        hotspot.width = this.state.width;
	        hotspot.height = this.state.height;
	
	        _ZoomUtils2.default.currentHotspot = hotspot;
	        _ZoomUtils2.default.currentBackgroundUid = this.props.backgroundModel.uuid;
	    },
	    onMoveStart: function onMoveStart(e) {
	        e.preventDefault();
	
	        this.setState({
	            startX: this.state.x,
	            startY: this.state.y
	        });
	
	        _ZoomUtils2.default.updateInitialPosition = false;
	    },
	    onMoveDrag: function onMoveDrag(e, coreEvent) {
	        e.preventDefault();
	
	        var x = this.state.startX + coreEvent.lastX / this.scaleFactor();
	        var y = this.state.startY + coreEvent.lastY / this.scaleFactor();
	
	        if (x < 0) x = 0;
	
	        if (x + this.state.width > _Configuration2.default.CANVAS_WIDTH) x = _Configuration2.default.CANVAS_WIDTH - this.state.width;
	
	        if (y < 0) y = 0;
	
	        if (y + this.state.height > _Configuration2.default.CANVAS_HEIGHT) y = _Configuration2.default.CANVAS_HEIGHT - this.state.height;
	
	        this.setState({
	            x: x,
	            y: y
	        });
	    },
	    onMoveStopped: function onMoveStopped() {
	        this.updateHotspot();
	    },
	    scaleFactor: function scaleFactor() {
	        var canvasScale = this.props.scaleProperties.scale;
	        return canvasScale;
	    },
	    isVisible: function isVisible() {
	        var state = _StoreManager2.default.getState();
	        var showZoomSlides = state.menu.showZoomSlides;
	
	        if (showZoomSlides == undefined || showZoomSlides == false || this.props.backgroundModel == undefined) return false;else return true;
	    },
	    render: function render() {
	        if (this.isVisible() == false) return _react2.default.createElement('g', null);
	
	        if (_ZoomUtils2.default.updateInitialPosition == true) this.refreshInitialPosition();
	
	        var x = this.state.x;
	        var y = this.state.y;
	        var width = this.state.width;
	        var height = this.state.height;
	        var scale = this.props.scaleProperties.scale;
	
	        var pathPoints = 'M0 0 L' + width + ' 0 L' + width + ' ' + height + ' L0 ' + height + ' Z';
	
	        var cornerFill = _TransformToolUtils.uiProperties.CORNER_FILL_INACTIVE;
	        var cornerStroke = _TransformToolUtils.uiProperties.CORNER_STROKE_INACTIVE;
	
	        var radius = _TransformToolUtils.uiProperties.RADIUS * 1.3 / scale;
	        var bigRadius = _TransformToolUtils.uiProperties.RADIUS * 2 / scale;
	
	        var canvasWidth = _Configuration2.default.CANVAS_WIDTH;
	        var canvasHeight = _Configuration2.default.CANVAS_HEIGHT;
	
	        return _react2.default.createElement(
	            'g',
	            { transform: 'translate(' + x + ' ' + y + ')' },
	            _react2.default.createElement('rect', { x: -this.state.x, y: -this.state.y, width: this.state.x, height: canvasHeight, fill: '#000000', fillOpacity: 0.5 }),
	            _react2.default.createElement('rect', { x: this.state.width, y: -this.state.y, width: canvasWidth - this.state.x - this.state.width, height: canvasHeight, fill: '#000000', fillOpacity: 0.5 }),
	            _react2.default.createElement('rect', { x: 0, y: -this.state.y, width: this.state.width, height: this.state.y, fill: '#000000', fillOpacity: 0.5 }),
	            _react2.default.createElement('rect', { x: 0, y: this.state.height, width: this.state.width, height: canvasHeight - this.state.y - this.state.height, fill: '#000000', fillOpacity: 0.5 }),
	            _react2.default.createElement('path', { stroke: _TransformToolUtils.uiProperties.PATH_COLOR, strokeWidth: _TransformToolUtils.uiProperties.STROKE, fill: 'none', d: pathPoints }),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMoveStart, onDrag: this.onMoveDrag, onStop: this.onMoveStopped },
	                _react2.default.createElement('rect', { x: 0, y: 0, width: this.state.width, height: this.state.height, fill: '#000000', fillOpacity: 0 })
	            ),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleStopped },
	                _react2.default.createElement('circle', { id: 'topLeft', cx: 0, cy: 0, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	            ),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleStopped },
	                _react2.default.createElement('circle', { id: 'topRight', cx: width, cy: 0, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	            ),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleStopped },
	                _react2.default.createElement('circle', { id: 'bottomRight', cx: width, cy: height, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	            ),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onScaleStart, onDrag: this.onScaleDrag, onStop: this.onScaleStopped },
	                _react2.default.createElement('circle', { id: 'bottomLeft', cx: 0, cy: height, r: radius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke })
	            ),
	            _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMoveStart, onDrag: this.onMoveDrag, onStop: this.onMoveStopped },
	                _react2.default.createElement(
	                    'g',
	                    null,
	                    _react2.default.createElement('circle', { id: 'center', cx: width / 2, cy: height / 2, r: bigRadius, fill: cornerFill, strokeWidth: _TransformToolUtils.uiProperties.STROKE, stroke: cornerStroke }),
	                    _react2.default.createElement('image', { xlinkHref: _AppParameters2.default.RESOURCES_LOCATION() + 'assets/moveArrows.png', x: width / 2 - 8, y: height / 2 - 8, width: '16px', height: '16px', preserveAspectRatio: 'none' })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/interactive/ZoomTransformTool.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/interactive/ZoomTransformTool.js"); } } })();

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Background = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _PreviewCommands = __webpack_require__(36);
	
	var _PreviewCommands2 = _interopRequireDefault(_PreviewCommands);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Background = exports.Background = _react2.default.createClass({
	    displayName: 'Background',
	
	    propTypes: {
	        shapeModel: _react2.default.PropTypes.object
	    },
	    getInitialState: function getInitialState() {
	        return {
	            startPoint: undefined,
	            endPoint: undefined
	        };
	    },
	    onMouseDown: function onMouseDown(e) {
	        if (_PreviewCommands2.default.isPlayMode() == true || _AnimationManager2.default.isAnimationMode()) return;
	
	        this.clearSelection();
	
	        var touchPoint = (0, _TransformToolUtils.getTouchPosition)(e);
	        var point = {};
	        point.x = (touchPoint.x - this.props.scaleProperties.topX) / this.props.scaleProperties.scale;
	        point.y = (touchPoint.y - this.props.scaleProperties.topY) / this.props.scaleProperties.scale;
	
	        this.setState({
	            startPoint: point
	        });
	    },
	    onMouseMove: function onMouseMove(e) {
	        if (_PreviewCommands2.default.isPlayMode() == true || _AnimationManager2.default.isAnimationMode()) return;
	
	        var touchPoint = (0, _TransformToolUtils.getTouchPosition)(e);
	        var point = {};
	        point.x = (touchPoint.x - this.props.scaleProperties.topX) / this.props.scaleProperties.scale;
	        point.y = (touchPoint.y - this.props.scaleProperties.topY) / this.props.scaleProperties.scale;
	
	        this.setState({
	            endPoint: point
	        });
	    },
	    onMouseUp: function onMouseUp() {
	        if (_PreviewCommands2.default.isPlayMode() == true || _AnimationManager2.default.isAnimationMode()) return;
	
	        if (this.state && this.state.startPoint && this.state.endPoint) {
	            var selection = { x: Math.min(this.state.startPoint.x, this.state.endPoint.x), y: Math.min(this.state.startPoint.y, this.state.endPoint.y), width: Math.abs(this.state.startPoint.x - this.state.endPoint.x), height: Math.abs(this.state.startPoint.y - this.state.endPoint.y) };
	            _SelectionManager2.default.selectShapesFromArea(selection);
	        }
	
	        this.setState({
	            startPoint: undefined,
	            endPoint: undefined
	        });
	    },
	    getSelection: function getSelection() {
	        if (this.state && this.state.startPoint && this.state.endPoint) {
	            return { x: Math.min(this.state.startPoint.x, this.state.endPoint.x), y: Math.min(this.state.startPoint.y, this.state.endPoint.y), width: Math.abs(this.state.startPoint.x - this.state.endPoint.x), height: Math.abs(this.state.startPoint.y - this.state.endPoint.y) };
	        } else {
	            return undefined;
	        }
	    },
	    getImageBoundingBox: function getImageBoundingBox() {
	        var shapeModel = this.props.shapeModel;
	        var imageBoundingBox = { x: 0, y: 0, width: _Configuration2.default.CANVAS_WIDTH, height: _Configuration2.default.CANVAS_HEIGHT };
	
	        if (shapeModel.orgWidth > 0 && shapeModel.orgWidth != _Configuration2.default.CANVAS_WIDTH || shapeModel.orgHeight > 0 && shapeModel.orgHeight != _Configuration2.default.CANVAS_HEIGHT) {
	            var scaleX = _Configuration2.default.CANVAS_WIDTH / shapeModel.orgWidth;
	            var scaleY = _Configuration2.default.CANVAS_HEIGHT / shapeModel.orgHeight;
	
	            if (scaleX < scaleY) {
	                imageBoundingBox.y = _Configuration2.default.CANVAS_HEIGHT / 2 - scaleX * shapeModel.orgHeight / 2;
	                imageBoundingBox.height = scaleX * shapeModel.orgHeight;
	            } else {
	                imageBoundingBox.x = _Configuration2.default.CANVAS_WIDTH / 2 - scaleY * shapeModel.orgWidth / 2;
	                imageBoundingBox.width = scaleY * shapeModel.orgWidth;
	            }
	        }
	
	        return imageBoundingBox;
	    },
	    getImagePosition: function getImagePosition() {
	        var shapeModel = this.props.shapeModel;
	        var hotspot = this.props.shapeModel.hotSpot;
	        var boundingBox = this.getImageBoundingBox();
	        var position = {};
	
	        if (this.props.showZoomSlides == true || hotspot == undefined || hotspot == '') {
	            position.x = boundingBox.x;
	            position.y = boundingBox.y;
	            position.width = boundingBox.width;
	            position.height = boundingBox.height;
	        } else {
	            var scale;
	
	            if (shapeModel.orgWidth > 0 && shapeModel.orgWidth != _Configuration2.default.CANVAS_WIDTH || shapeModel.orgHeight > 0 && shapeModel.orgHeight != _Configuration2.default.CANVAS_HEIGHT) {
	                scale = _Configuration2.default.CANVAS_WIDTH / hotspot.width;
	
	                position.width = boundingBox.width * scale;
	                position.height = boundingBox.height * scale;
	
	                position.x = -hotspot.x * scale + boundingBox.x * scale;
	                position.y = -hotspot.y * scale + boundingBox.y * scale;
	            } else {
	                scale = _Configuration2.default.CANVAS_WIDTH / hotspot.width;
	
	                position.width = _Configuration2.default.CANVAS_WIDTH * scale;
	                position.height = position.width * 9 / 16;
	
	                position.x = -hotspot.x * scale;
	                position.y = -hotspot.y * scale;
	            }
	        }
	
	        return position;
	    },
	    clearSelection: function clearSelection() {
	        if (_AnimationManager2.default.isAnimationMode()) return;
	
	        var dispatch = this.props.dispatch;
	
	
	        _SelectionManager2.default.checkSelection('');
	
	        _MouseUtils2.default.isCanvasAction = true;
	        dispatch((0, _MenuActions.hideMenus)(_MenuType2.default.ALL_MENUS));
	
	        if (_PlatformDetection2.default.isTouchableDevice() == true) {
	            document.activeElement.blur();
	        }
	    },
	    updateVideo: function updateVideo() {
	        if (!_PreviewCommands2.default.isPlayMode()) _VideoUtils2.default.updateVideoSrc(this.props.shapeModel);
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.startPoint != nextState.startPoint || this.state.endPoint != nextState.endPoint || this.props.shapeModel != newProps.shapeModel || this.props.showZoomSlides != newProps.showZoomSlides || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        var shapeModel = this.props.shapeModel;
	
	        var canvasWidth = _Configuration2.default.CANVAS_WIDTH;
	        var canvasHeight = _Configuration2.default.CANVAS_HEIGHT;
	        var position = this.getImagePosition();
	        var selection = this.getSelection();
	        var fillOpacity = shapeModel.fillOpacity;
	        var imageStyle;
	        var selectionElement;
	
	        if (selection) selectionElement = _react2.default.createElement('rect', { x: selection.x, y: selection.y, width: selection.width, height: selection.height, fill: '#0000FF', fillOpacity: 0.1, stroke: '#0000FF', strokeWidth: 1, strokeOpacity: 0.3 });
	
	        if (shapeModel.isVideo) {
	            fillOpacity = 0;
	
	            imageStyle = { display: 'none' };
	        }
	
	        this.updateVideo();
	
	        var href = _VideoUtils2.default.checkCacheBreaker(shapeModel.xlinkHref);
	        var opacityValue = shapeModel.opacity >= 0 ? shapeModel.opacity : 1;
	
	        if (_AppParameters2.default.context == _ModeConstants2.default.PRINT) {
	            return _react2.default.createElement(
	                'g',
	                { id: 'background', x: '0.00', y: '0.00', width: canvasWidth, height: canvasHeight },
	                _react2.default.createElement('rect', { x: '0.00', y: '0.00', width: canvasWidth, height: canvasHeight, fill: shapeModel.fill, fillOpacity: fillOpacity }),
	                _react2.default.createElement('image', { x: position.x, y: position.y, width: position.width, height: position.height, xlinkHref: href, fillOpacity: fillOpacity, preserveAspectRatio: 'none', style: imageStyle, opacity: opacityValue }),
	                _react2.default.createElement('rect', { x: '0', y: '0', width: canvasWidth, height: canvasHeight, fill: 'none', stroke: shapeModel.stroke, strokeWidth: shapeModel.strokeWidth * 2, strokeOpacity: shapeModel.strokeOpacity })
	            );
	        } else {
	            return _react2.default.createElement(
	                _reactDraggable2.default,
	                { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	                _react2.default.createElement(
	                    'g',
	                    { id: 'background', x: '0.00', y: '0.00', width: canvasWidth, height: canvasHeight },
	                    _react2.default.createElement('rect', { x: '0.00', y: '0.00', width: canvasWidth, height: canvasHeight, fill: shapeModel.fill, fillOpacity: fillOpacity }),
	                    _react2.default.createElement('image', { x: position.x, y: position.y, width: position.width, height: position.height, xlinkHref: href, fillOpacity: fillOpacity, preserveAspectRatio: 'none', style: imageStyle, opacity: opacityValue }),
	                    _react2.default.createElement('rect', { x: '0', y: '0', width: canvasWidth, height: canvasHeight, fill: 'none', stroke: shapeModel.stroke, strokeWidth: shapeModel.strokeWidth * 2, strokeOpacity: shapeModel.strokeOpacity }),
	                    selectionElement
	                )
	            );
	        }
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Background.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Background.js"); } } })();

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Group = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InteractiveShape = __webpack_require__(42);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _Character = __webpack_require__(347);
	
	var _Image = __webpack_require__(354);
	
	var _Rectangle = __webpack_require__(356);
	
	var _Triangle = __webpack_require__(368);
	
	var _Star = __webpack_require__(361);
	
	var _Heart = __webpack_require__(353);
	
	var _Ellipse = __webpack_require__(351);
	
	var _Line = __webpack_require__(355);
	
	var _Curve = __webpack_require__(350);
	
	var _Freehand = __webpack_require__(352);
	
	var _TextBox = __webpack_require__(362);
	
	var _TextBoxSimple = __webpack_require__(364);
	
	var _SpeakBubble = __webpack_require__(359);
	
	var _ThoughtBubble = __webpack_require__(366);
	
	var _ScreamBubble = __webpack_require__(357);
	
	var _TextBoxRich = __webpack_require__(363);
	
	var _TextBoxSimpleRich = __webpack_require__(365);
	
	var _SpeakBubbleRich = __webpack_require__(360);
	
	var _ThoughtBubbleRich = __webpack_require__(367);
	
	var _ScreamBubbleRich = __webpack_require__(358);
	
	var _Video = __webpack_require__(369);
	
	var _ComplexSpeakBubble = __webpack_require__(348);
	
	var _ComplexSpeakBubbleRich = __webpack_require__(349);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Group = exports.Group = _react2.default.createClass({
	    displayName: 'Group',
	
	    propTypes: {
	        dispatch: _react2.default.PropTypes.func.isRequired,
	        shapeModel: _react2.default.PropTypes.object.isRequired
	    },
	    isShapeSelected: function isShapeSelected() {
	        var state = _StoreManager2.default.getState();
	        var shapes = state.currentSlide.model.content;
	        var i;
	
	        for (i = 0; i < shapes.length; i++) {
	            if (shapes[i].uuid == this.props.shapeModel.uuid) {
	                if (shapes[i].isSelected == true) return true;else return false;
	            }
	        }return false;
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode == 13) {
	            // ENTER
	            setTimeout(function () {
	                this.props.dispatch((0, _MenuActions.hideMenus)([_MenuType2.default.ALL_MENUS]));
	                this.props.dispatch((0, _MenuActions.setContextTarget)(this.props.shapeModel));
	
	                setTimeout(function () {
	                    var buttonMenu = document.getElementById('shapeMenuFirstElement');
	
	                    if (buttonMenu) buttonMenu.focus();
	                }.bind(this), 20);
	            }.bind(this), 20);
	        }
	    },
	    onFocusHandler: function onFocusHandler() {
	        if (document.activeElement == this.refs.focusableElement) {
	            if (!this.isShapeSelected()) this.props.dispatch((0, _CurrentSlideActions.selectShape)(this.props.shapeModel.uuid));
	
	            _MouseUtils2.default.activeElement = this.props.shapeModel.uuid;
	        }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.shapeModel != newProps.shapeModel || this.props.scaleProperties != newProps.scaleProperties) return true;else return false;
	    },
	    render: function render() {
	        var _this = this;
	
	        var _props = this.props,
	            shapeModel = _props.shapeModel,
	            dispatch = _props.dispatch;
	
	
	        var shapes = shapeModel.shapes.map(function (shape, index) {
	            switch (shape.type) {
	                case _ShapeConstants2.default.CHARACTER:
	                    return _react2.default.createElement(_Character.Character, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	
	                case _ShapeConstants2.default.IMAGE:
	                    return _react2.default.createElement(_Image.Image, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	
	                case _ShapeConstants2.default.RECTANGLE:
	                    return _react2.default.createElement(_Rectangle.Rectangle, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	
	                case _ShapeConstants2.default.TRIANGLE:
	                    return _react2.default.createElement(_Triangle.Triangle, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	
	                case _ShapeConstants2.default.STAR:
	                    return _react2.default.createElement(_Star.Star, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	
	                case _ShapeConstants2.default.HEART:
	                    return _react2.default.createElement(_Heart.Heart, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	
	                case _ShapeConstants2.default.ELLIPSE:
	                    return _react2.default.createElement(_Ellipse.Ellipse, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	
	                case _ShapeConstants2.default.LINE:
	                    return _react2.default.createElement(_Line.Line, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	
	                case _ShapeConstants2.default.CURVE:
	                    return _react2.default.createElement(_Curve.Curve, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	
	                case _ShapeConstants2.default.FREEHAND:
	                    return _react2.default.createElement(_Freehand.Freehand, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	
	                case _ShapeConstants2.default.TEXTBOX:
	                    {
	                        if (shape.isRichText) return _react2.default.createElement(_TextBoxRich.TextBoxRich, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });else return _react2.default.createElement(_TextBox.TextBox, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	                    }
	
	                case _ShapeConstants2.default.TEXTBOXSIMPLE:
	                    {
	                        if (shape.isRichText) return _react2.default.createElement(_TextBoxSimpleRich.TextBoxSimpleRich, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });else return _react2.default.createElement(_TextBoxSimple.TextBoxSimple, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	                    }
	
	                case _ShapeConstants2.default.SPEAK_BUBBLE:
	                    {
	                        if (shape.isRichText) return _react2.default.createElement(_SpeakBubbleRich.SpeakBubbleRich, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });else return _react2.default.createElement(_SpeakBubble.SpeakBubble, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	                    }
	
	                case _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE:
	                    {
	                        if (shape.isRichText) return _react2.default.createElement(_ComplexSpeakBubbleRich.ComplexSpeakBubbleRich, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });else return _react2.default.createElement(_ComplexSpeakBubble.ComplexSpeakBubble, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	                    }
	
	                case _ShapeConstants2.default.THOUGHT_BUBBLE:
	                    {
	                        if (shape.isRichText) return _react2.default.createElement(_ThoughtBubbleRich.ThoughtBubbleRich, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });else return _react2.default.createElement(_ThoughtBubble.ThoughtBubble, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	                    }
	
	                case _ShapeConstants2.default.SCREAM_BUBBLE:
	                    {
	                        if (shape.isRichText) return _react2.default.createElement(_ScreamBubbleRich.ScreamBubbleRich, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });else return _react2.default.createElement(_ScreamBubble.ScreamBubble, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	                    }
	
	                case _ShapeConstants2.default.VIDEO:
	                    {
	                        return _react2.default.createElement(_Video.Video, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	                    }
	
	                case _ShapeConstants2.default.GROUP:
	                    {
	                        return _react2.default.createElement(Group, { shapeModel: shape, dispatch: dispatch, scaleProperties: _this.props.scaleProperties, key: shape.uuid });
	                    }
	            }
	        });
	
	        return _react2.default.createElement(
	            _InteractiveShape.InteractiveShape,
	            { shapeModel: shapeModel, dispatch: dispatch, rotatable: true, scaleProperties: this.props.scaleProperties },
	            _react2.default.createElement(
	                'g',
	                { transform: 'translate(' + shapeModel.x + ' ' + shapeModel.y + ')', opacity: shapeModel.opacity },
	                shapes,
	                _react2.default.createElement('rect', {
	                    x: 0,
	                    y: 0,
	                    width: shapeModel.width,
	                    height: shapeModel.height,
	                    fill: 'none',
	                    stroke: shapeModel.stroke,
	                    strokeWidth: shapeModel.strokeWidth,
	                    strokeOpacity: shapeModel.strokeOpacity
	                }),
	                _react2.default.createElement(
	                    'foreignObject',
	                    null,
	                    _react2.default.createElement('a', { id: 'interactiveElement_' + this.props.shapeModel.uuid, href: '', ref: 'focusableElement', onFocus: this.onFocusHandler, onKeyDown: this.onKeyDown })
	                )
	            )
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Group.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slide/shapes/Group.js"); } } })();

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MusicMenu = exports.MusicMenuContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _VolumeSlider = __webpack_require__(123);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _Animator = __webpack_require__(238);
	
	var _Animator2 = _interopRequireDefault(_Animator);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _AudioVolumeUtils = __webpack_require__(67);
	
	var _AudioVolumeUtils2 = _interopRequireDefault(_AudioVolumeUtils);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MusicMenuContent = exports.MusicMenuContent = _react2.default.createClass({
	    displayName: 'MusicMenuContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            isCloseOver: false,
	            isPlayOver: false,
	            isVolumeOver: false,
	            isSoundTitleOver: false,
	            openVolumeSlider: false,
	            isPlaying: false,
	            isDeleteOver: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('click', this.onCloseVolumeSlider);
	        document.addEventListener('touchend', this.onCloseVolumeSlider);
	
	        if (!_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioUtils2.default.initMusicSound(this.updatePlayingStatus);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('click', this.onCloseVolumeSlider);
	        document.removeEventListener('touchend', this.onCloseVolumeSlider);
	
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('storySoundItem', 0, false);else _AudioUtils2.default.cleanMusicSound();
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.currentSlideIndex != nextProps.currentSlideIndex) {
	            this.stopSound();
	        }
	    },
	    onDeleteMouseIn: function onDeleteMouseIn() {
	        _HoverManager2.default.show(this.refs.delete, 'deleteAudioItem');
	
	        this.setState({
	            isDeleteOver: true
	        });
	    },
	    onDeleteMouseOut: function onDeleteMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isDeleteOver: false
	        });
	    },
	    onDelete: function onDelete(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.props.dispatch((0, _AudioEditorActions.deleteItem)());
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	        _AudioEditorUtils2.default.checkTimelineWidth();
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false
	        });
	    },
	    onSoundTitleMouseIn: function onSoundTitleMouseIn() {
	        this.setState({
	            isSoundTitleOver: true
	        });
	    },
	    onSoundTitleMouseOut: function onSoundTitleMouseOut() {
	        this.setState({
	            isSoundTitleOver: false
	        });
	    },
	    onCloseMouseIn: function onCloseMouseIn() {
	        _HoverManager2.default.show(this.refs.deleteSound, 'deleteSound', 'right');
	
	        this.setState({
	            isCloseOver: true
	        });
	    },
	    onCloseMouseOut: function onCloseMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isCloseOver: false
	        });
	    },
	    onPlayMouseIn: function onPlayMouseIn() {
	        _HoverManager2.default.show(this.refs.playSound, 'playSound');
	
	        this.setState({
	            isPlayOver: true
	        });
	    },
	    onPlayMouseOut: function onPlayMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isPlayOver: false
	        });
	    },
	    onVolumeMouseIn: function onVolumeMouseIn() {
	        _HoverManager2.default.show(this.refs.volumeSound, 'volumeSound');
	
	        this.setState({
	            isVolumeOver: true
	        });
	    },
	    onVolumeMouseOut: function onVolumeMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isVolumeOver: false
	        });
	    },
	    onCloseVolumeSlider: function onCloseVolumeSlider(e) {
	        if (_TextSizeUtils2.default.isTextEditMode()) return;
	
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (!_PlatformDetection2.default.isIOS()) {
	            if (!document.getElementById('htmlColorPicker')) e.preventDefault();
	        }
	
	        var target = e.target;
	
	        if (target.id == 'volume') return;
	
	        if (target.id && target.id.indexOf('volumeIcon') != -1) {
	            this.setState({
	                openVolumeSlider: false
	            });
	
	            return;
	        }
	
	        if (target.id.indexOf('volumeSlider') != -1 || target.parentElement && target.parentElement.id.indexOf('volumeSlider') != -1 || target.parentElement && target.parentElement.parentElement && target.parentElement.parentElement.id.indexOf('volumeSlider') != -1) return;
	
	        this.setState({
	            openVolumeSlider: false
	        });
	    },
	    onOpenVolumeSlider: function onOpenVolumeSlider(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.setState({
	            openVolumeSlider: true
	        });
	    },
	    onOpenAudioBrowser: function onOpenAudioBrowser(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _ZoomUtils2.default.closeZoom();
	
	        this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	
	        if (!_PlayController2.default.isAudioEditorMode()) _PlayController2.default.checkAudioEditorModeWhenOpenAudioMenus(0);else _PlayController2.default.toggleAudioEditorMode();
	    },
	    onClose: function onClose(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.props.dispatch((0, _ProductionActions.addStorySound)(undefined));
	        _SaveManager2.default.isContentChanged(true);
	    },
	    stopSound: function stopSound() {
	        if (this.state.isPlaying) {
	            if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('storySoundItem', 0, false);else _AudioUtils2.default.pauseSound('musicSoundId');
	        }
	    },
	    onPlay: function onPlay(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var volume = _StoreManager2.default.getState().production.storySoundVolume;
	
	        if (volume == undefined) volume = 0.5;
	
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) {
	            _AudioVolumeUtils2.default.executeMediaAction('storySoundItem', volume, !this.state.isPlaying, this.onEndSound);
	            this.updatePlayingStatus(!this.state.isPlaying);
	        } else {
	            var audio = this.refs.audio;
	
	            if (audio) audio.volume = volume;
	
	            if (!this.state.isPlaying) _AudioUtils2.default.playSound('musicSoundId');else _AudioUtils2.default.pauseSound('musicSoundId');
	        }
	    },
	    onEndSound: function onEndSound() {
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.executeMediaAction('audioStory', 0, false);
	
	        this.updatePlayingStatus(false);
	    },
	    updatePlayingStatus: function updatePlayingStatus(value) {
	        this.setState({
	            isPlaying: value
	        });
	
	        this.forceUpdate();
	    },
	    showStorySound: function showStorySound() {
	        if (this.props.storySound != undefined) return true;else return false;
	    },
	    getTitle: function getTitle() {
	        if (this.props.storySound) return this.props.storySound.title;else return '';
	    },
	    getSoundSource: function getSoundSource() {
	        var value;
	
	        if (this.props.storySound) value = this.props.storySound.href;
	
	        if (_AudioVolumeUtils2.default.useVolumeFunctionality()) _AudioVolumeUtils2.default.checkSound(value, 'storySoundItem');else _AudioUtils2.default.updateHrefForMusicSound(value);
	
	        return value;
	    },
	    getSoundIcon: function getSoundIcon() {
	        var soundVolume = this.props.storySoundVolume;
	
	        if (!soundVolume) soundVolume = 0.5;else soundVolume = parseFloat(soundVolume);
	
	        var volumeIcon = 'fa fa-volume-down';
	
	        if (soundVolume == 0) volumeIcon = 'fa fa-volume-off';else if (soundVolume <= 0.5) volumeIcon = 'fa fa-volume-down';else if (soundVolume > 0.5) volumeIcon = 'fa fa-volume-up';
	
	        return volumeIcon;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.props.storySound != newProps.storySound && newProps.storySound != undefined) _Animator2.default.startAnimation('storySoundItem');
	
	        if (newProps.isPlaying != this.state.isPlaying || this.state.isOver != nextState.isOver || this.state.isCloseOver != nextState.isCloseOver || this.state.isPlayOver != nextState.isPlayOver || this.state.isVolumeOver != nextState.isVolumeOver || this.state.isSoundTitleOver != nextState.isSoundTitleOver || this.state.openVolumeSlider != nextState.openVolumeSlider || this.props.storySound != newProps.storySound || this.props.currentSlideIndex != newProps.currentSlideIndex || this.props.timelines != newProps.timelines) return true;else return false;
	    },
	    render: function render() {
	        var menuWidth = _AudioToolUtils2.default.buttonsHolderWidth() - 2 * _Properties2.default.BUTTONS_HOLDER_LEFT_GAP;
	        var slideViewerHeight = _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT + _Properties2.default.SLIDE_VIEWER_TOP_GAP + _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP + _Properties2.default.SLIDE_VIEWER_LIST_HEIGHT;
	        var originalHolderWidh = menuWidth;
	
	        var menuStyle = {
	            position: 'absolute',
	            width: menuWidth,
	            height: _Properties2.default.ADD_MUSIC_BUTTON_HEIGHT,
	            left: _Properties2.default.BUTTONS_HOLDER_LEFT_GAP,
	            top: slideViewerHeight - _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP - _Properties2.default.ADD_MUSIC_BUTTON_HEIGHT,
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none'
	        };
	
	        var borderColor;
	        var iconColor;
	
	        if (this.state.isOver == true) {
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	        } else {
	            borderColor = _Properties2.default.ADD_MUSIC_BUTTON_BACKGROUND;
	            iconColor = 'black';
	        }
	
	        var addMusicTitleLeftPosition = 33;
	        var musicButtonCaption = _LocalesManager2.default.getCaption('AddMusic', 'music');
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            if (!_PlayController2.default.isAudioEditorMode()) musicButtonCaption = _LocalesManager2.default.getCaption('OpenAudioMode', 'music');else musicButtonCaption = _LocalesManager2.default.getCaption('CloseAudioMode', 'music');
	        }
	
	        var addMusicButtonStyle = {
	            width: menuWidth,
	            height: _Properties2.default.ADD_MUSIC_BUTTON_HEIGHT,
	            background: _Properties2.default.ADD_MUSIC_BUTTON_BACKGROUND,
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            borderRadius: 20,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            borderStyle: 'none'
	        };
	
	        var offset = 0;
	
	        if (_PlatformDetection2.default.isChromeBook() == true) offset = 2;
	
	        var musicIconStyle = {
	            position: 'absolute',
	            top: 5 + offset,
	            left: 13,
	            color: iconColor
	        };
	
	        var spanStyle = {
	            fontSize: 12,
	            height: 20,
	            width: menuWidth - addMusicTitleLeftPosition - 5,
	            position: 'absolute',
	            top: 7,
	            left: addMusicTitleLeftPosition,
	            color: iconColor,
	            whiteSpace: 'nowrap',
	            display: 'inline-block',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default'
	        };
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            if (_PlayController2.default.isAudioEditorMode()) {
	                menuWidth = menuWidth - _Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH - _Properties2.default.BUTTONS_HOLDER_LEFT_GAP;
	                addMusicButtonStyle.width = menuWidth;
	            }
	
	            musicIconStyle.display = 'none';
	            spanStyle.width = menuWidth - 10;
	            spanStyle.left = 5;
	            spanStyle.textAlign = 'center';
	        }
	
	        // story sound
	        var storySoundDisplayState = 'none';
	
	        if (this.showStorySound() == true) storySoundDisplayState = 'block';
	
	        var title = this.getTitle();
	        var titleLeftPosition = 64;
	
	        var storySoundButtonStyle = {
	            width: menuWidth,
	            height: _Properties2.default.ADD_MUSIC_BUTTON_HEIGHT,
	            background: _Properties2.default.ADD_MUSIC_BUTTON_BACKGROUND,
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            borderRadius: 20,
	            display: storySoundDisplayState
	        };
	
	        if (this.state.isPlayOver == true) iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else iconColor = 'black';
	
	        var playIconStyle = {
	            position: 'absolute',
	            top: 5,
	            left: 12,
	            color: iconColor
	        };
	
	        if (this.state.isVolumeOver == true) iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else iconColor = 'black';
	
	        var volumeIconStyle = {
	            position: 'absolute',
	            top: 5,
	            left: 39,
	            color: iconColor
	        };
	
	        if (this.state.isSoundTitleOver == true) iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else iconColor = 'black';
	
	        var soundTitleStyle = {
	            fontSize: 12,
	            height: 20,
	            width: menuWidth - 95,
	            position: 'absolute',
	            top: 7,
	            left: titleLeftPosition,
	            cursor: 'default',
	            color: iconColor,
	            whiteSpace: 'nowrap',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis'
	        };
	
	        var playIconSrc = 'fa fa-play';
	
	        if (this.state.isPlaying) playIconSrc = 'fa fa-pause';
	
	        var playAreaStyle = {
	            position: 'absolute',
	            width: 28,
	            height: 30,
	            left: 0,
	            top: 0,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        var volumeAreaStyle = {
	            position: 'absolute',
	            width: 28,
	            height: 30,
	            left: 30,
	            top: 0,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        if (this.state.isCloseOver == true) iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else iconColor = 'black';
	
	        var closeIconStyle = {
	            position: 'absolute',
	            top: 5,
	            left: 183,
	            color: iconColor
	        };
	
	        var closeAreaStyle = {
	            position: 'absolute',
	            width: 30,
	            height: 30,
	            left: 176,
	            top: 0,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        var iconType = this.getSoundIcon();
	
	        var storySoundElement;
	        var deleteSoundButton;
	
	        if (!_PlayController2.default.isAudioEditorAvailable()) {
	            storySoundElement = _react2.default.createElement(
	                'div',
	                { ref: 'storySound', id: 'storySoundItem', style: storySoundButtonStyle },
	                _react2.default.createElement('i', { style: playIconStyle, className: playIconSrc + ' colorAnimation' }),
	                _react2.default.createElement('button', { 'aria-label': _LocalesManager2.default.getCaption('playSound', 'hover'), ref: 'playSound', style: playAreaStyle, onClick: this.onPlay, onTouchEnd: this.onPlay, onMouseOver: this.onPlayMouseIn, onMouseOut: this.onPlayMouseOut }),
	                _react2.default.createElement('i', { style: volumeIconStyle, className: iconType + ' colorAnimation' }),
	                _react2.default.createElement('button', { 'aria-label': _LocalesManager2.default.getCaption('volumeSound', 'hover'), ref: 'volumeSound', id: 'volume', style: volumeAreaStyle, onMouseOver: this.onVolumeMouseIn, onMouseOut: this.onVolumeMouseOut, onClick: this.onOpenVolumeSlider, onTouchEnd: this.onOpenVolumeSlider }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'colorAnimation', style: soundTitleStyle, onClick: this.onOpenAudioBrowser, onTouchEnd: this.onOpenAudioBrowser, onMouseOver: this.onSoundTitleMouseIn, onMouseOut: this.onSoundTitleMouseOut },
	                    title
	                ),
	                _react2.default.createElement('i', { style: closeIconStyle, className: 'fa fa-close colorAnimation' }),
	                _react2.default.createElement('button', { 'aria-label': _LocalesManager2.default.getCaption('deleteSound', 'hover'), ref: 'deleteSound', style: closeAreaStyle, onClick: this.onClose, onTouchEnd: this.onClose, onMouseOver: this.onCloseMouseIn, onMouseOut: this.onCloseMouseOut }),
	                _react2.default.createElement(_VolumeSlider.VolumeSlider, { dispatch: this.props.dispatch, visible: this.state.openVolumeSlider })
	            );
	        } else {
	            if (_PlayController2.default.isAudioEditorMode()) {
	                var isAudioSelected = _AudioEditorUtils2.default.isAudioSelected();
	                var opacity = 1.0;
	                var deleteSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/trash.svg';
	                var tabIndexDelete;
	
	                if (!isAudioSelected) {
	                    opacity = 0.6;
	                    tabIndexDelete = '-1';
	                } else {
	                    if (this.state.isDeleteOver == true) deleteSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/trash_hover.svg';
	                }
	
	                var deleteSoundButtonStyle = {
	                    width: _Properties2.default.ADD_MUSIC_BUTTON_HEIGHT,
	                    height: _Properties2.default.ADD_MUSIC_BUTTON_HEIGHT,
	                    background: _Properties2.default.ADD_MUSIC_BUTTON_BACKGROUND,
	                    position: 'absolute',
	                    left: originalHolderWidh - _Properties2.default.ADD_MUSIC_BUTTON_HEIGHT - (_Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH - _Properties2.default.ADD_MUSIC_BUTTON_HEIGHT) / 2,
	                    top: 0,
	                    borderRadius: 50,
	                    opacity: opacity,
	                    margin: 0,
	                    padding: 0,
	                    boxSizing: 'initial',
	                    fontSize: 'initial',
	                    borderStyle: 'none'
	                };
	
	                var deleteIconStyle = {
	                    position: 'absolute',
	                    top: 0,
	                    left: 0
	                };
	
	                deleteSoundButton = _react2.default.createElement(
	                    'button',
	                    { tabIndex: tabIndexDelete, 'aria-disabled': tabIndexDelete == '-1' ? true : false, 'aria-label': _LocalesManager2.default.getCaption('deleteAudioItem', 'hover'), ref: 'delete', style: deleteSoundButtonStyle, onMouseOver: this.onDeleteMouseIn, onMouseOut: this.onDeleteMouseOut, onTouchStart: this.onDelete, onClick: this.onDelete },
	                    _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: deleteIconStyle, src: deleteSrc })
	                );
	            }
	        }
	
	        var tabIndexValue;
	
	        if (storySoundElement && storySoundDisplayState == 'block') tabIndexValue = '-1';
	
	        return _react2.default.createElement(
	            'div',
	            { id: 'storySoundHolder', style: menuStyle },
	            _react2.default.createElement('audio', { src: this.getSoundSource(), ref: 'audio', id: 'musicSoundId', className: 'audioItem', preload: 'auto', playsInline: true }),
	            _react2.default.createElement(
	                'button',
	                { tabIndex: tabIndexValue, 'aria-disabled': tabIndexValue == '-1' ? true : false, 'aria-label': musicButtonCaption, ref: 'addMusic', style: addMusicButtonStyle, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, onClick: this.onOpenAudioBrowser, onTouchEnd: this.onOpenAudioBrowser },
	                _react2.default.createElement('i', { style: musicIconStyle, className: 'fa fa-music' }),
	                _react2.default.createElement(
	                    'span',
	                    { style: spanStyle },
	                    musicButtonCaption
	                )
	            ),
	            storySoundElement,
	            deleteSoundButton
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var storySound = state.production.storySound;
	    var storySoundVolume = state.production.storySoundVolume;
	    var currentSlideIndex = state.currentSlide.currentSlideIndex;
	    var showAudioEditor = state.menu.showAudioEditor;
	    var timelines = state.audioEditor.timelines;
	
	    return {
	        storySound: storySound,
	        currentSlideIndex: currentSlideIndex,
	        storySoundVolume: storySoundVolume,
	        showAudioEditor: showAudioEditor,
	        timelines: timelines
	    };
	}
	
	var MusicMenu = exports.MusicMenu = (0, _reactRedux.connect)(mapStateToProps)(MusicMenuContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slideViewer/MusicMenu.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slideViewer/MusicMenu.js"); } } })();

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SlideItemRenderer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _TransformToolUtils = __webpack_require__(52);
	
	var _DragManager = __webpack_require__(107);
	
	var _DragManager2 = _interopRequireDefault(_DragManager);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _SlideViewerActions = __webpack_require__(121);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MenuActions = __webpack_require__(7);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _ThumbnailGenerator = __webpack_require__(144);
	
	var _ThumbnailGenerator2 = _interopRequireDefault(_ThumbnailGenerator);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _SlidesUtils = __webpack_require__(125);
	
	var _SlidesUtils2 = _interopRequireDefault(_SlidesUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ControlPoint = _react2.default.createClass({
	    displayName: 'ControlPoint',
	    getInitialState: function getInitialState() {
	        return {
	            isThumbOver: false
	        };
	    },
	    isActiveThumb: function isActiveThumb() {
	        if (_SlidesUtils2.default.currentArrow == this.props.index) return true;else return false;
	    },
	    onThumbMouseIn: function onThumbMouseIn() {
	        if (!this.isActiveThumb()) {
	            _HoverManager2.default.show(this.refs.thumb, 'slideTrim');
	
	            this.setState({
	                isThumbOver: true
	            });
	        }
	    },
	    onThumbMouseOut: function onThumbMouseOut() {
	        if (!this.isActiveThumb()) {
	            _HoverManager2.default.hide();
	
	            this.setState({
	                isThumbOver: false
	            });
	        }
	    },
	    onMouseDown: function onMouseDown(e) {
	        _HoverManager2.default.hide();
	        _PlayController2.default.getOldScrollPosition();
	
	        var touchPosition = _MouseUtils2.default.getTouchPosition(e);
	
	        _SlidesUtils2.default.startPosition = touchPosition.x;
	        _SlidesUtils2.default.currentArrow = this.props.index;
	        _SlidesUtils2.default.startTime = _StoreManager2.default.getState().currentSlide.model.time;
	        _SlidesUtils2.default.videoModel = _VideoUtils2.default.getSlideVideoModel();
	        _SlidesUtils2.default.slideOffset = 0;
	        _SlidesUtils2.default.slideInitialPosition = _AudioEditorUtils2.default.getMarkerPositionForSlideIndex();
	
	        _SlidesUtils2.default.initMap();
	    },
	    onMouseMove: function onMouseMove(e) {
	        this.updateProperties(e);
	    },
	    onMouseUp: function onMouseUp(e) {
	        this.updateProperties(e, true);
	
	        _AudioEditorUtils2.default.checkTimelineWidth();
	        _AudioEditorUtils2.default.addActionToHistory();
	        _SaveManager2.default.isContentChanged(true);
	        this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	        this.props.dispatch((0, _AudioEditorActions.refreshAudioTrack)(Math.random()));
	
	        _PlayController2.default.updateScrollPosition(300);
	
	        this.setState({
	            isThumbOver: false
	        });
	    },
	    onKeyDown: function onKeyDown(e) {
	        if (e.keyCode != 37 && e.keyCode != 39) return;
	
	        var offsetX = 2;
	        var controlPointPosition = this.refs.thumb.getBoundingClientRect();
	
	        _PlayController2.default.getOldScrollPosition();
	
	        _SlidesUtils2.default.startPosition = controlPointPosition.left;
	        _SlidesUtils2.default.currentArrow = this.props.index;
	        _SlidesUtils2.default.startTime = _StoreManager2.default.getState().currentSlide.model.time;
	        _SlidesUtils2.default.videoModel = _VideoUtils2.default.getSlideVideoModel();
	        _SlidesUtils2.default.slideOffset = 0;
	        _SlidesUtils2.default.slideInitialPosition = _AudioEditorUtils2.default.getMarkerPositionForSlideIndex();
	
	        _SlidesUtils2.default.initMap();
	
	        if (e.keyCode == 37) // Left Key
	            this.updateProperties(undefined, true, -offsetX);else this.updateProperties(undefined, true, offsetX);
	
	        _AudioEditorUtils2.default.checkTimelineWidth();
	        _AudioEditorUtils2.default.addActionToHistory();
	        _SaveManager2.default.isContentChanged(true);
	        this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	        this.props.dispatch((0, _AudioEditorActions.refreshAudioTrack)(Math.random()));
	
	        _PlayController2.default.updateScrollPosition(300);
	    },
	    clearProperties: function clearProperties() {
	        _SlidesUtils2.default.startPosition = -1;
	        _SlidesUtils2.default.videoModel = undefined;
	        _SlidesUtils2.default.currentArrow = -1;
	        _SlidesUtils2.default.slideOffset = 0;
	        _SlidesUtils2.default.slideInitialPosition = -1;
	    },
	    updateProperties: function updateProperties(e) {
	        var isEndAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	        var offsetX;
	
	        if (e) {
	            var touchPosition = _MouseUtils2.default.getTouchPosition(e);
	            offsetX = touchPosition.x - _SlidesUtils2.default.startPosition;
	        } else offsetX = offset;
	
	        if (this.props.index == 0) offsetX = offsetX * -1;
	
	        var timeOffset = _AudioEditorUtils2.default.getItemTimePosition(offsetX);
	        var newTime = _SlidesUtils2.default.startTime + timeOffset;
	        var limit = _AudioEditorUtils2.default.getItemTimePosition(_Properties2.default.ARROW_SIZE * 2);
	
	        if (newTime < limit) newTime = limit;
	
	        if (_SlidesUtils2.default.videoModel) {
	            var inPoint = _SlidesUtils2.default.videoModel.inPoint;
	            var outPoint = _SlidesUtils2.default.videoModel.outPoint;
	            var videoDuration = parseFloat(_VideoUtils2.default.getVideoTotalDuration());
	            var maxDuration;
	
	            if (outPoint == 0) outPoint = videoDuration;
	
	            if (this.props.index == 0) {
	                // left arrow
	                maxDuration = outPoint;
	            } else {
	                // right arrow
	                maxDuration = videoDuration - inPoint;
	            }
	
	            if (newTime > maxDuration) newTime = maxDuration;
	
	            if (isEndAction) {
	                var videoProps = {};
	
	                videoProps.volume = _SlidesUtils2.default.videoModel.volume;
	
	                if (this.props.index == 0) {
	                    videoProps.inPoint = outPoint - newTime;
	                    videoProps.outPoint = outPoint;
	                } else {
	                    videoProps.inPoint = inPoint;
	                    videoProps.outPoint = inPoint + newTime;
	                }
	
	                this.props.dispatch((0, _CurrentSlideActions.changeVideoProperties)('all', videoProps));
	            }
	
	            if (this.props.index == 0) _VideoUtils2.default.goToPosition(outPoint - newTime);else _VideoUtils2.default.goToPosition(inPoint + newTime);
	        }
	
	        if (this.props.index == 0 && newTime != _SlidesUtils2.default.startTime) _SlidesUtils2.default.slideOffset = _AudioEditorUtils2.default.getSlideWidth(_SlidesUtils2.default.startTime - newTime);else _SlidesUtils2.default.slideOffset = 0;
	
	        if (isEndAction) {
	            if (_SlidesUtils2.default.slideInitialPosition >= 0) {
	                if (this.props.index == 1) this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(_SlidesUtils2.default.slideInitialPosition + newTime));else this.props.dispatch((0, _AudioEditorActions.setMarkerPosition)(_SlidesUtils2.default.slideInitialPosition));
	            }
	
	            this.clearProperties();
	        }
	
	        this.props.dispatch((0, _CurrentSlideActions.changeSlideDuration)(newTime));
	        _SaveManager2.default.isContentChanged(true);
	    },
	    render: function render() {
	        var height = this.props.height;
	        var leftPos = this.props.offset;
	        var iconSrc = 'fa fa-angle-left fa-2x';
	        var iconColor = 'white';
	
	        if (this.props.index == 1) {
	            leftPos = this.props.offset + this.props.width - _Properties2.default.ARROW_SIZE;
	            iconSrc = 'fa fa-angle-right fa-2x';
	        }
	
	        var menuStyle = {
	            position: 'absolute',
	            left: leftPos,
	            top: 0,
	            width: _Properties2.default.ARROW_SIZE,
	            height: '100%',
	            display: 'block',
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            borderStyle: 'none',
	            background: 'none'
	        };
	
	        if (this.state.isThumbOver || this.isActiveThumb()) {
	            iconColor = 'black';
	        }
	
	        var lineStyle = {
	            position: 'absolute',
	            left: 0,
	            top: 0,
	            width: _Properties2.default.ARROW_SIZE,
	            height: height,
	            background: 'black',
	            opacity: 0.25,
	            display: 'block'
	        };
	
	        var iconWidth = 12;
	        var iconHeight = 32;
	        var arrowIconStyle = {
	            position: 'absolute',
	            top: lineStyle.height / 2 - iconHeight / 2,
	            left: lineStyle.width / 2 - iconWidth / 2,
	            color: iconColor
	        };
	
	        return _react2.default.createElement(
	            _reactDraggable2.default,
	            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	            _react2.default.createElement(
	                'button',
	                { ref: 'thumb', 'aria-label': _LocalesManager2.default.getCaption('slideTrim', 'hover'), onKeyDown: this.onKeyDown, style: menuStyle, onMouseOver: this.onThumbMouseIn, onMouseOut: this.onThumbMouseOut, className: 'slideElement' },
	                _react2.default.createElement('span', { style: lineStyle, className: 'slideElement' }),
	                _react2.default.createElement('i', { style: arrowIconStyle, className: iconSrc + ' slideElement' })
	            )
	        );
	    }
	});
	
	var SlideItemRendererContent = _react2.default.createClass({
	    displayName: 'SlideItemRendererContent',
	    getInitialState: function getInitialState() {
	        return {
	            isOver: false,
	            isMenuButtonOver: false,
	            isThumbInitialized: false,
	            isDrag: false
	        };
	    },
	    onMouseIn: function onMouseIn() {
	        this.setState({
	            isOver: true
	        });
	    },
	    onMouseOut: function onMouseOut() {
	        this.setState({
	            isOver: false,
	            isMenuButtonOver: false
	        });
	    },
	    onMenuButtonMouseIn: function onMenuButtonMouseIn() {
	        _HoverManager2.default.show(this.refs.editSlide, 'editSlide');
	
	        this.setState({
	            isMenuButtonOver: true
	        });
	    },
	    onMenuButtonMouseOut: function onMenuButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isMenuButtonOver: false
	        });
	    },
	    componentDidMount: function componentDidMount() {
	        if (this.props.initialized == false) {
	            this.props.dispatch((0, _CurrentSlideActions.initSlide)());
	            this.updateSlideThumbnail();
	        } else if (this.state.isThumbInitialized == false) {
	            this.updateSlideThumbnail();
	
	            if (_PlatformDetection2.default.isEdge()) {
	                setTimeout(function () {
	                    this.updateSlideThumbnail();
	                }.bind(this), 500);
	            }
	        }
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (_SlidesUtils2.default.updateAllThumbnails) {
	            setTimeout(function () {
	                this.updateSlideThumbnail();
	            }.bind(this), 50);
	            return;
	        }
	
	        if (this.props.index == this.props.currentIndex) {
	            if (nextProps.updateThumbnail == true) this.updateSlideThumbnail();
	        }
	    },
	    updateSlideThumbnail: function updateSlideThumbnail() {
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(false));
	        this.takeSnapshot();
	    },
	    takeSnapshot: function takeSnapshot() {
	        _ThumbnailGenerator2.default.drawThumbnail(this.refs.thumb, this.getSlideModel(), true, this.checkExtraThumbnail);
	
	        if (this.state.isThumbInitialized == false) {
	            this.setState({
	                isThumbInitialized: true
	            });
	        }
	    },
	    changeSlide: function changeSlide() {
	        var state = _StoreManager2.default.getState();
	        var store = _StoreManager2.default.getStore();
	        var currentSlide = state.currentSlide;
	
	        _PlayController2.default.getOldScrollPosition();
	
	        if (this.props.index != currentSlide.currentSlideIndex) {
	            store.dispatch((0, _CurrentSlideActions.selectShape)('slideFocus'));
	            store.dispatch((0, _ProductionActions.updateCurrentSlide)());
	            store.dispatch((0, _CurrentSlideActions.setCurrentSlide)(this.props.index));
	            _AudioEditorUtils2.default.addActionToHistory();
	            _AudioEditorUtils2.default.checkMarkerPositionForCurrentSlide();
	        }
	
	        if (this.props.initialized == false) {
	            store.dispatch((0, _CurrentSlideActions.initSlide)());
	            this.updateSlideThumbnail();
	        }
	    },
	    onShowMenu: function onShowMenu(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlayController2.default.isPlaying) return;
	
	        _ZoomUtils2.default.closeZoom();
	
	        var state = _StoreManager2.default.getState();
	        var menuPosition = state.menu.slideMenuLeftPosition;
	
	        if (menuPosition >= 0) this.props.dispatch((0, _MenuActions.changeSlideMenuPosition)(-1));else {
	            var bounds = this.refs.slideItem.getBoundingClientRect();
	            this.props.dispatch((0, _MenuActions.changeSlideMenuPosition)(bounds.left));
	        }
	    },
	    getSlideModel: function getSlideModel() {
	        if (this.props.index == this.props.currentIndex) {
	            var state = _StoreManager2.default.getState();
	
	            return state.currentSlide.model;
	        } else {
	            return this.props.slides[this.props.index];
	        }
	    },
	    onSlideClick: function onSlideClick() {
	        // when the slide is focused with TAB/ALT+TAB and press Enter or Space
	        this.changeSlide();
	    },
	    startDrag: function startDrag(touchPosition) {
	        var store = _StoreManager2.default.getStore();
	        store.dispatch((0, _SlideViewerActions.setDragTarget)(this.props.index));
	
	        var clone = this.refs.thumb;
	        _DragManager2.default.prepareClone(clone, this.changeSlide, touchPosition, true);
	    },
	    onDragStart: function onDragStart(e, coreEvent) {
	        if (_PlayController2.default.isPlaying) return;
	
	        this.props.dispatch((0, _MenuActions.changeSlideMenuPosition)(-1));
	        this.props.dispatch((0, _CurrentSlideActions.setShortcutsTarget)(true));
	        _PlayController2.default.getOldScrollPosition();
	
	        this.setState({ isDrag: true });
	
	        if (_PlayController2.default.isAudioEditorMode()) {
	            if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0) _DragManager2.default.clientX = e.nativeEvent.touches[0].clientX - _AudioToolUtils2.default.buttonsHolderWidth() + _PlayController2.default.getScrollPosition();else _DragManager2.default.clientX = e.clientX - _AudioToolUtils2.default.buttonsHolderWidth() + _PlayController2.default.getScrollPosition();
	        }
	
	        if (_MouseUtils2.default.isActive() == false) {
	            _MouseUtils2.default.pressDownAndHold(this.startDrag, (0, _TransformToolUtils.getTouchPosition)(e), this.changeSlide);
	            return;
	        }
	
	        this.startDrag((0, _TransformToolUtils.getTouchPosition)(e));
	    },
	    dragOver: function dragOver(offsetX, offsetY) {
	        var store = _StoreManager2.default.getStore();
	        var slides = _StoreManager2.default.getState().production.slides;
	        var index = void 0;
	
	        if (this.props.showAudioEditor && _PlayController2.default.isAudioEditorAvailable()) index = _DragManager2.default.getDropIndexNew(this.props.dragIndex, slides, offsetX, offsetY);else index = _DragManager2.default.getDropIndex(this.props.dragIndex, slides, offsetX, offsetY);
	
	        if (this.props.dropIndex != index) store.dispatch((0, _SlideViewerActions.setDropTarget)(index));
	    },
	    onDragMove: function onDragMove(e, coreEvent) {
	        if (_MouseUtils2.default.isActive() == false) {
	            return;
	        }
	
	        if (_PlayController2.default.isPlaying) return;
	
	        this.dragOver(coreEvent.lastX, coreEvent.lastY);
	        _DragManager2.default.onDragMove(coreEvent.lastX, coreEvent.lastY, e);
	    },
	    endDrop: function endDrop(coreEvent) {
	        var store = _StoreManager2.default.getStore();
	
	        _ZoomUtils2.default.closeZoom();
	
	        if (Math.abs(coreEvent.lastX) < 20 && Math.abs(coreEvent.lastY) < 20) {
	            // it's click event so we have to change the current slide
	        } else if (this.props.dragIndex > -1 && this.props.dropIndex > -1 && this.props.dragIndex != this.props.dropIndex) {
	            var state = _StoreManager2.default.getState();
	            var currentSlideUid = state.currentSlide.model.uuid;
	
	            store.dispatch((0, _ProductionActions.changeSlidePosition)(this.props.dragIndex, this.props.dropIndex));
	            store.dispatch((0, _CurrentSlideActions.updateCurrentSlideIndex)(currentSlideUid));
	
	            if (_PlayController2.default.isAudioEditorMode()) store.dispatch((0, _CurrentSlideActions.setCurrentSlide)(this.props.dropIndex));
	
	            _AudioEditorUtils2.default.addActionToHistory();
	            _SaveManager2.default.isContentChanged(true);
	            _AudioEditorUtils2.default.checkMarkerPositionForCurrentSlide();
	        }
	
	        store.dispatch((0, _SlideViewerActions.setDragTarget)(-1));
	        store.dispatch((0, _SlideViewerActions.setDropTarget)(-1));
	        store.dispatch((0, _AudioEditorActions.refreshAudioTrack)(Math.random()));
	    },
	    onDragEnd: function onDragEnd(e, coreEvent) {
	        if (_PlayController2.default.isPlaying) return;
	
	        this.setState({ isDrag: false });
	
	        if (_MouseUtils2.default.isActive() == false) {
	            _MouseUtils2.default.resetSlidePositionMode(coreEvent.lastX, coreEvent.lastY);
	            return;
	        }
	
	        this.dragOver(coreEvent.lastX, coreEvent.lastY);
	
	        _DragManager2.default.onDragEnd(coreEvent.lastX, coreEvent.lastY);
	        this.endDrop(coreEvent);
	        _MouseUtils2.default.resetSlidePositionMode();
	    },
	    checkExtraThumbnail: function checkExtraThumbnail(width, originalWidth) {
	        if (this.props.showAudioEditor) {
	            if (this.refs.extraThumb) {
	                setTimeout(function () {
	                    var parent = this.refs.thumb;
	                    var destination = this.refs.extraThumb;
	
	                    if (!destination) return;
	
	                    var newCavasWidth = width - originalWidth;
	                    var steps = Math.ceil(newCavasWidth / originalWidth);
	                    var i;
	
	                    if (steps > 0) {
	                        var context = destination.getContext('2d');
	
	                        for (i = 0; i < steps; i++) {
	                            context.drawImage(parent, i * originalWidth, 0);
	                        }
	                    }
	                }.bind(this), 300);
	            }
	        }
	    },
	    render: function render() {
	        var originalWidth = _Properties2.default.SLIDE_ITEM_WIDTH;
	        var width = _Properties2.default.SLIDE_ITEM_WIDTH;
	        var paddingDrop = _Properties2.default.SLIDE_PADDING_DROP;
	        var height = originalWidth * 9 / 16;
	        var padding = _Properties2.default.SLIDE_GAP / 2;
	        var paddingLeft = void 0;
	        var extraSize = 0;
	        var offset = 0;
	
	        if (this.state.isDrag) extraSize = 2 * _Properties2.default.SLIDE_VIEWER_TOP_GAP;
	
	        if (this.props.dragIndex > -1 && this.props.dropIndex > -1) {
	            if (this.props.index == this.props.dropIndex && this.props.dragIndex != this.props.dropIndex && this.props.dragIndex + 1 != this.props.dropIndex) paddingLeft = paddingDrop;else paddingLeft = padding;
	        } else {
	            paddingLeft = padding;
	        }
	
	        var itemRendererStyle = {
	            position: 'relative',
	            width: width,
	            height: height,
	            textAlign: 'center',
	            display: 'inline-block',
	            marginRight: padding,
	            marginLeft: paddingLeft
	        };
	
	        var itemRendererSliderStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial',
	            background: 'none',
	            borderStyle: 'none'
	        };
	
	        if (this.props.showAudioEditor && _PlayController2.default.isAudioEditorAvailable()) {
	            if (this.props.currentIndex == this.props.index && _SlidesUtils2.default.slideOffset != 0) {
	                if (_SlidesUtils2.default.slideOffset > 0) {
	                    width = _AudioEditorUtils2.default.getSlideWidth(_SlidesUtils2.default.startTime) - _SlidesUtils2.default.slideOffset;
	                    offset = _SlidesUtils2.default.slideOffset;
	                } else {
	                    width = _AudioEditorUtils2.default.getSlideWidth(_SlidesUtils2.default.startTime) - _SlidesUtils2.default.slideOffset;
	                }
	            } else width = _AudioEditorUtils2.default.getSlideWidth(this.props.time);
	
	            itemRendererStyle = {
	                position: 'absolute',
	                width: width,
	                height: height,
	                textAlign: 'center',
	                top: 0,
	                left: _AudioEditorUtils2.default.slidesPosition[this.props.index],
	                background: _Properties2.default.SLIDE_VIEWER_BACKGROUND
	            };
	
	            if (offset > 0) itemRendererStyle.paddingLeft = offset;else {
	                if (offset == 0 && this.props.dragIndex > -1 && this.props.dropIndex > -1) {
	                    if (this.props.index == this.props.dropIndex && this.props.dragIndex != this.props.dropIndex && this.props.dragIndex + 1 != this.props.dropIndex) itemRendererStyle.paddingLeft = paddingDrop;
	                }
	            }
	
	            if (this.props.index > this.props.currentIndex && _SlidesUtils2.default.slideOffset > 0) itemRendererStyle.left = _SlidesUtils2.default.slidesDurationMap[this.props.index];else if (this.props.index >= this.props.currentIndex && _SlidesUtils2.default.slideOffset < 0) {
	                if (this.props.index == this.props.currentIndex) itemRendererStyle.left = _SlidesUtils2.default.slidesDurationMap[this.props.index] + _SlidesUtils2.default.slideOffset;else itemRendererStyle.left = _SlidesUtils2.default.slidesDurationMap[this.props.index];
	            }
	
	            extraSize = 0;
	        }
	
	        var frameDisplayState = void 0;
	        var frameColor = void 0;
	        var menuButtonDisplayState = void 0;
	
	        if (this.props.currentIndex == this.props.index) {
	            frameDisplayState = 'block';
	            menuButtonDisplayState = 'block';
	            frameColor = _Properties2.default.SLIDE_FRAME_SELECTED_COLOR;
	        } else {
	            if (this.state.isOver == true && _PlatformDetection2.default.isIOS() == false) {
	                frameDisplayState = 'block';
	                frameColor = _Properties2.default.SLIDE_FRAME_HOVER_COLOR;
	            } else {
	                frameDisplayState = 'none';
	            }
	            menuButtonDisplayState = 'none';
	        }
	
	        var boderWidth = 2;
	
	        if (this.state.isDrag) {
	            frameDisplayState = 'none';
	            menuButtonDisplayState = 'none';
	        }
	
	        var frameStyle = {
	            width: width - 2 * boderWidth,
	            height: height - 2 * boderWidth,
	            borderWidth: boderWidth,
	            borderStyle: 'solid',
	            borderColor: frameColor,
	            position: 'absolute',
	            top: 0,
	            display: frameDisplayState
	        };
	
	        var holderStyle = {
	            position: 'absolute',
	            top: 0,
	            display: 'block'
	        };
	
	        var menuButtonFrameColor;
	
	        if (this.state.isMenuButtonOver == true) menuButtonFrameColor = _Properties2.default.SLIDE_FRAME_HOVER_COLOR;else menuButtonFrameColor = 'black';
	
	        var thumbWidth = originalWidth;
	        var leftPos = thumbWidth - (_Properties2.default.SLIDE_MENU_BUTTON_RIGHT_PADDING + padding) - _Properties2.default.SLIDE_MENU_BUTTON_SIZE + offset;
	
	        if (width < originalWidth) thumbWidth = width;
	
	        if (_PlayController2.default.isAudioEditorMode()) {
	            if (width < _Properties2.default.SLIDE_MENU_BUTTON_SIZE + 2 * _Properties2.default.ARROW_SIZE) {
	                menuButtonDisplayState = 'none';
	            } else if (width < originalWidth + _Properties2.default.ARROW_SIZE) {
	                leftPos = width - _Properties2.default.ARROW_SIZE - _Properties2.default.SLIDE_MENU_BUTTON_SIZE + offset;
	            }
	        }
	
	        var menuButtonStyle = {
	            position: 'absolute',
	            top: (height - _Properties2.default.SLIDE_MENU_BUTTON_SIZE) / 2,
	            left: leftPos,
	            width: _Properties2.default.SLIDE_MENU_BUTTON_SIZE,
	            height: _Properties2.default.SLIDE_MENU_BUTTON_SIZE,
	            display: menuButtonDisplayState,
	            background: 'white',
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderColor: menuButtonFrameColor,
	            borderRadius: 3,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var menuButtonIconStyle = {
	            position: 'absolute',
	            top: 7,
	            left: 9,
	            color: menuButtonFrameColor
	        };
	
	        var borderOffset = 2;
	
	        var thumbStyle = {
	            position: 'absolute',
	            top: -extraSize / 2,
	            left: -extraSize / 2,
	            width: thumbWidth - borderOffset + extraSize,
	            height: height - borderOffset + extraSize,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderColor: 'lightgray',
	            backgroundColor: '#FFFFFF'
	        };
	
	        var draggableItemStyle = {
	            position: 'absolute',
	            width: width,
	            height: height,
	            top: 0,
	            background: 'red',
	            opacity: 0,
	            display: 'block'
	        };
	
	        var extraCanvas;
	        var extraFrame;
	
	        if (_PlayController2.default.isAudioEditorMode() && width > originalWidth) {
	            var extraCanvasWidth = width - originalWidth;
	            var extraThumbStyle = {
	                position: 'absolute',
	                top: 0,
	                left: originalWidth,
	                width: extraCanvasWidth - borderOffset,
	                height: height - borderOffset,
	                borderWidth: 1,
	                borderStyle: 'solid',
	                borderColor: 'lightgray',
	                backgroundColor: '#FFFFFF'
	            };
	
	            extraCanvas = _react2.default.createElement('canvas', { ref: 'extraThumb', width: extraCanvasWidth - 2, height: height - 2, style: extraThumbStyle, className: 'slideElement' });
	
	            var extraFrameStyle = {
	                position: 'absolute',
	                top: 1,
	                left: originalWidth,
	                width: extraCanvasWidth,
	                height: height - borderOffset,
	                backgroundColor: '#000000',
	                opacity: 0.4,
	                display: 'block'
	            };
	
	            extraFrame = _react2.default.createElement('span', { style: extraFrameStyle, className: 'slideElement' });
	
	            this.checkExtraThumbnail(width, originalWidth);
	        }
	
	        var leftArrow;
	        var rightArrow;
	        var leftExtraPadding = 0;
	
	        if (itemRendererStyle.paddingLeft > 0 && _SlidesUtils2.default.slideOffset == 0) leftExtraPadding = itemRendererStyle.paddingLeft;
	
	        if (_PlayController2.default.isAudioEditorMode() && this.props.currentIndex == this.props.index) {
	            leftArrow = _react2.default.createElement(ControlPoint, { width: width, height: height, offset: offset + leftExtraPadding, index: 0, dispatch: this.props.dispatch });
	            rightArrow = _react2.default.createElement(ControlPoint, { width: width, height: height, offset: offset, index: 1, dispatch: this.props.dispatch });
	        }
	
	        var ariaLabelValue = _LocalesManager2.default.getCaption('slide', 'other') + ' ' + (this.props.index + 1);
	        var slideMenuButtonId = 'slideMenuButton_' + this.props.index;
	
	        return _react2.default.createElement(
	            'div',
	            { style: itemRendererStyle },
	            _react2.default.createElement(
	                'button',
	                { 'aria-label': ariaLabelValue, style: itemRendererSliderStyle, ref: 'item', onClick: this.onSlideClick, onMouseOver: this.onMouseIn, onMouseOut: this.onMouseOut, className: 'slideElement' },
	                _react2.default.createElement(
	                    'span',
	                    { ref: 'slideItem', style: holderStyle, className: 'slideElement' },
	                    _react2.default.createElement('canvas', { name: 'slideThumbnail', ref: 'thumb', width: originalWidth - 2, height: height - 2, style: thumbStyle, className: 'slideElement' }),
	                    extraCanvas,
	                    extraFrame,
	                    _react2.default.createElement('span', { style: frameStyle, className: 'slideElement' })
	                ),
	                _react2.default.createElement(
	                    _reactDraggable2.default,
	                    { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onDragStart, onDrag: this.onDragMove, onStop: this.onDragEnd },
	                    _react2.default.createElement('span', { style: draggableItemStyle, className: 'slideElement' })
	                ),
	                leftArrow,
	                rightArrow
	            ),
	            _react2.default.createElement(
	                'button',
	                { id: slideMenuButtonId, 'aria-label': _LocalesManager2.default.getCaption('editSlide', 'hover'), className: 'slideMenuButton slideElement', ref: 'editSlide', style: menuButtonStyle, onTouchEnd: this.onShowMenu, onClick: this.onShowMenu, onMouseOver: this.onMenuButtonMouseIn, onMouseOut: this.onMenuButtonMouseOut },
	                _react2.default.createElement('i', { style: menuButtonIconStyle, className: 'fa fa-bars slideMenuButton slideElement' })
	            )
	        );
	    }
	});
	
	function mapStateToProps(state) {
	    var dragIndex = state.slideViewer.dragIndex;
	    var dropIndex = state.slideViewer.dropIndex;
	    var currentIndex = state.currentSlide.currentSlideIndex;
	    var updateThumbnail = state.currentSlide.updateThumbnail;
	    var initialized = state.currentSlide.model.initialized;
	    var isClone = state.currentSlide.model.isClone;
	    var slides = state.production.slides;
	    var currentSlideModel = state.currentSlide.model;
	    var store = _StoreManager2.default.getStore();
	
	    return {
	        dragIndex: dragIndex,
	        dropIndex: dropIndex,
	        currentIndex: currentIndex,
	        updateThumbnail: updateThumbnail,
	        initialized: initialized,
	        isClone: isClone,
	        dispatch: store.dispatch,
	        slides: slides,
	        currentSlideModel: currentSlideModel
	    };
	}
	
	var SlideItemRenderer = exports.SlideItemRenderer = (0, _reactRedux.connect)(mapStateToProps)(SlideItemRendererContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slideViewer/SlideItemRenderer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slideViewer/SlideItemRenderer.js"); } } })();

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SlideViewer = exports.SlideViewerContent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _SlidesList = __webpack_require__(848);
	
	var _AudioEditorControls = __webpack_require__(325);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _SlideMenu = __webpack_require__(819);
	
	var _MusicMenu = __webpack_require__(845);
	
	var _SlideViewerActions = __webpack_require__(121);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _MenuActions = __webpack_require__(7);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _KeyboardShortcuts = __webpack_require__(143);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideViewerContent = exports.SlideViewerContent = _react2.default.createClass({
	    displayName: 'SlideViewerContent',
	    getInitialState: function getInitialState() {
	        return {
	            isPreviewButtonOver: false,
	            isAddButtonOver: false,
	            isUndoOver: false,
	            isRedoOver: false
	        };
	    },
	    onPreviewButtonMouseIn: function onPreviewButtonMouseIn() {
	        _HoverManager2.default.show(this.refs.preview, 'preview');
	
	        this.setState({
	            isPreviewButtonOver: true
	        });
	    },
	    onPreviewButtonMouseOut: function onPreviewButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isPreviewButtonOver: false,
	            isAddButtonOver: false
	        });
	    },
	    onAddButtonMouseIn: function onAddButtonMouseIn() {
	        _HoverManager2.default.show(this.refs.addSlide, 'addSlide');
	
	        this.setState({
	            isAddButtonOver: true
	        });
	    },
	    onAddButtonMouseOut: function onAddButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isPreviewButtonOver: false,
	            isAddButtonOver: false
	        });
	    },
	    onUndoMouseIn: function onUndoMouseIn() {
	        _HoverManager2.default.show(this.refs.undo, 'undo');
	
	        this.setState({
	            isUndoOver: true
	        });
	    },
	    onUndoMouseOut: function onUndoMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isUndoOver: false
	        });
	    },
	    onRedoMouseIn: function onRedoMouseIn() {
	        _HoverManager2.default.show(this.refs.redo, 'redo');
	
	        this.setState({
	            isRedoOver: true
	        });
	    },
	    onRedoMouseOut: function onRedoMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isRedoOver: false
	        });
	    },
	    componentDidMount: function componentDidMount() {
	        this.refs.slideViewerWrapper.addEventListener("click", this.onSlidesViewerClick);
	        this.refs.slideViewerWrapper.addEventListener("touchend", this.onSlidesViewerClick);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.needsRefresh == true) setTimeout(this.refreshView, 10);
	    },
	    refreshView: function refreshView() {
	        //force renderer
	        this.forceUpdate();
	
	        var dispatch = this.props.dispatch;
	
	        dispatch((0, _SlideViewerActions.needsRefresh)(false));
	    },
	    addNewSlide: function addNewSlide(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlayController2.default.isPlaying) return;
	
	        if (_PlayController2.default.isAudioEditorMode()) _PlayController2.default.getOldScrollPosition();
	
	        var state = _StoreManager2.default.getState();
	        var currentSlide = state.currentSlide;
	        var currentIndex = currentSlide.currentSlideIndex;
	        var dispatch = this.props.dispatch;
	
	
	        _ZoomUtils2.default.closeZoom();
	
	        dispatch((0, _CurrentSlideActions.selectShape)('slideFocus'));
	        dispatch((0, _ProductionActions.updateCurrentSlide)());
	        dispatch((0, _ProductionActions.addSlide)(currentIndex + 1));
	        dispatch((0, _CurrentSlideActions.setCurrentSlide)(currentIndex + 1));
	        _AudioEditorUtils2.default.checkMarkerPositionForCurrentSlide();
	        _AudioEditorUtils2.default.checkTimelineWidth(true);
	
	        this.refreshView();
	        _AudioEditorUtils2.default.addActionToHistory();
	        _SaveManager2.default.isContentChanged(true);
	        dispatch((0, _AudioEditorActions.refreshAudioTrack)(Math.random()));
	    },
	    changeMode: function changeMode(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        _ZoomUtils2.default.closeZoom();
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            _PlayController2.default.changeMode();
	        }
	
	        _VideoUtils2.default.updateStartPoint(false, true);
	
	        var dispatch = this.props.dispatch;
	
	        dispatch((0, _CurrentSlideActions.selectShape)('slideFocus'));
	        dispatch((0, _ProductionActions.updateCurrentSlide)());
	        dispatch((0, _ProductionActions.changeMode)(_ModeConstants2.default.PREVIEW));
	        _PlayController2.default.closeAudioEditorMode();
	
	        _HoverManager2.default.hide();
	    },
	    onSlidesViewerClick: function onSlidesViewerClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        var types = [_MenuType2.default.CONTEXT_MENU, _MenuType2.default.INSERT_MENU, _MenuType2.default.SHAPE_MENU, _MenuType2.default.UNIVERSES_MENU];
	
	        if (e.target.className.indexOf('slideMenuButton') == -1) types.push(_MenuType2.default.SLIDE_MENU);
	
	        if (e.target.className.indexOf('eye') != -1 || e.target.className.indexOf('preview') != -1) _MouseUtils2.default.isCanvasAction = true;
	
	        if (_TextEditorUtils2.default.isTextEditorTool() && e.target.className.indexOf('undoRedo') != -1) // not hide text Editor menu when clicking on UNDO/REDO buttons
	            return;
	
	        this.props.dispatch((0, _MenuActions.hideMenus)(types));
	    },
	    onUndo: function onUndo(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlayController2.default.isPlaying) return;
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) {
	            // the undo redo should be used for the text element when it has focus
	            document.execCommand('undo', false, null);
	            return;
	        }
	
	        _ZoomUtils2.default.closeZoom();
	
	        (0, _KeyboardShortcuts.undoAction)(this.props.dispatch);
	    },
	    onRedo: function onRedo(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_PlayController2.default.isPlaying) return;
	
	        if (_TextEditorUtils2.default.isTextEditorTool()) {
	            // the undo redo should be used for the text element when it has focus
	            document.execCommand('redo', false, null);
	            return;
	        }
	
	        _ZoomUtils2.default.closeZoom();
	
	        (0, _KeyboardShortcuts.redoAction)(this.props.dispatch);
	    },
	    isUndoAvailable: function isUndoAvailable() {
	        if (_TextEditorUtils2.default.isTextEditorTool()) // for text editing the undo/redo buttons should be always available
	            return true;
	
	        var undo = this.props.undo;
	
	        if (undo && undo.length > 0) return true;else return false;
	    },
	    isRedoAvailable: function isRedoAvailable() {
	        if (_TextEditorUtils2.default.isTextEditorTool()) // for text editing the undo/redo buttons should be always available
	            return true;
	
	        var redo = this.props.redo;
	
	        if (redo && redo.length > 0) return true;else return false;
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.isPreviewButtonOver != nextState.isPreviewButtonOver || this.state.isAddButtonOver != nextState.isAddButtonOver || this.state.isUndoOver != nextState.isUndoOver || this.state.isRedoOver != nextState.isRedoOver || this.props.accordionWidth != newProps.accordionWidth || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.needsRefresh != newProps.needsRefresh || this.props.showVideoEditor != newProps.showVideoEditor || this.props.undo != newProps.undo || this.props.redo != newProps.redo || this.props.undo != newProps.undo || this.props.contextMode != newProps.contextMode || this.props.showAudioEditor != newProps.showAudioEditor || this.props.timelines != newProps.timelines) return true;else return false;
	    },
	    render: function render() {
	        var width = this.props.windowWidth - this.props.accordionWidth;
	        var listHeight = _Properties2.default.SLIDE_VIEWER_LIST_HEIGHT + _Properties2.default.SLIDE_VIEWER_TOP_GAP;
	
	        if (this.props.showAudioEditor) listHeight = listHeight + _AudioEditorUtils2.default.getAudioEditorHeight();
	
	        var height = _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT + listHeight + _Properties2.default.SLIDE_VIEWER_BOTTOM_GAP;
	
	        var display = 'block';
	
	        if (this.props.showVideoEditor) display = 'none';
	
	        var slideViewerStyle = {
	            position: 'absolute',
	            top: this.props.windowHeight - height,
	            left: 0,
	            width: width,
	            height: height,
	            background: _Properties2.default.SLIDE_VIEWER_BACKGROUND,
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            userDrag: 'none',
	            display: display
	        };
	
	        if (this.props.contextMode == _ModeConstants2.default.LINE_CONTEXT || this.props.contextMode == _ModeConstants2.default.FREEHAND_CONTEXT || this.props.contextMode == _ModeConstants2.default.ANIMATION_CONTEXT) {
	            slideViewerStyle.pointerEvents = 'none';
	            slideViewerStyle.opacity = 0.5;
	        }
	
	        var buttonsHolderStyle = {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            width: _AudioToolUtils2.default.buttonsHolderWidth(),
	            height: height
	        };
	
	        var iconColor;
	        var borderColor;
	
	        if (this.state.isPreviewButtonOver == true) {
	            iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	        } else {
	            iconColor = 'black';
	            borderColor = 'white';
	        }
	
	        var buttonsTopPadding = _Properties2.default.BUTTONS_HOLDER_TOP_GAP;
	
	        var previewStyle = {
	            width: _Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH,
	            height: _Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH,
	            background: 'white',
	            borderRadius: 50,
	            position: 'absolute',
	            left: _AudioToolUtils2.default.buttonsHolderWidth() - _Properties2.default.BUTTONS_HOLDER_LEFT_GAP - 2 * _Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH - _Properties2.default.SLIDE_VIEWER_BUTTONS_GAP,
	            top: buttonsTopPadding,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var offset = 0;
	
	        if (_PlatformDetection2.default.isChromeBook() == true) offset = 0;
	
	        var previewIconStyle = {
	            position: 'absolute',
	            top: 12 + offset,
	            left: 12,
	            color: iconColor
	        };
	
	        if (this.state.isAddButtonOver == true) {
	            iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	        } else {
	            iconColor = 'black';
	            borderColor = 'white';
	        }
	
	        var addSlideStyle = {
	            width: _Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH,
	            height: _Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH,
	            background: 'white',
	            position: 'absolute',
	            left: _AudioToolUtils2.default.buttonsHolderWidth() - _Properties2.default.BUTTONS_HOLDER_LEFT_GAP - _Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH,
	            top: buttonsTopPadding,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var addIconStyle = {
	            position: 'absolute',
	            top: 13 + offset,
	            left: 14,
	            color: iconColor
	        };
	
	        // undo style
	        var opacity = 1;
	        var tabIndexUndo;
	
	        if (this.isUndoAvailable() == false) {
	            iconColor = 'black';
	            borderColor = 'white';
	            opacity = 0.6;
	            tabIndexUndo = '-1';
	        } else {
	            if (this.state.isUndoOver == true) {
	                iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	                borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            } else {
	                iconColor = 'black';
	                borderColor = 'white';
	            }
	        }
	
	        var undoStyle = {
	            width: _Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH,
	            height: _Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH,
	            background: 'white',
	            position: 'absolute',
	            left: _Properties2.default.BUTTONS_HOLDER_LEFT_GAP,
	            top: buttonsTopPadding,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderRadius: 50,
	            opacity: opacity,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var undoIconStyle = {
	            position: 'absolute',
	            top: 13,
	            left: 13,
	            color: iconColor
	        };
	
	        // redo style
	        var tabIndexRedo;
	
	        if (this.isRedoAvailable() == false) {
	            iconColor = 'black';
	            borderColor = 'white';
	            opacity = 0.6;
	            tabIndexRedo = '-1';
	        } else {
	            opacity = 1;
	
	            if (this.state.isRedoOver == true) {
	                iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	                borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	            } else {
	                iconColor = 'black';
	                borderColor = 'white';
	            }
	        }
	
	        var redoStyle = {
	            width: _Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH,
	            height: _Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH,
	            background: 'white',
	            position: 'absolute',
	            left: _Properties2.default.BUTTONS_HOLDER_LEFT_GAP + _Properties2.default.SLIDE_VIEWER_BUTTON_WIDTH + _Properties2.default.SLIDE_VIEWER_BUTTONS_GAP,
	            top: buttonsTopPadding,
	            borderColor: borderColor,
	            borderWidth: 1,
	            borderStyle: 'solid',
	            borderRadius: 50,
	            opacity: opacity,
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var redoIconStyle = {
	            position: 'absolute',
	            top: 13,
	            left: 13,
	            color: iconColor
	        };
	
	        var element;
	
	        if (this.props.showAudioEditor) {
	            element = _react2.default.createElement(_AudioEditorControls.AudioEditorControls, { dispatch: this.props.dispatch });
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { ref: 'slideViewerWrapper', style: slideViewerStyle },
	            _react2.default.createElement(
	                'div',
	                { style: buttonsHolderStyle },
	                _react2.default.createElement(
	                    'button',
	                    { ref: 'undo', 'aria-label': _LocalesManager2.default.getCaption('undo', 'hover'), tabIndex: tabIndexUndo, className: 'undoRedo', 'aria-disabled': tabIndexUndo == '-1' ? true : false, style: undoStyle, onTouchEnd: this.onUndo, onClick: this.onUndo, onMouseOver: this.onUndoMouseIn, onMouseOut: this.onUndoMouseOut },
	                    _react2.default.createElement('i', { style: undoIconStyle, className: 'fa fa-undo undoRedo' })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { ref: 'redo', 'aria-label': _LocalesManager2.default.getCaption('redo', 'hover'), tabIndex: tabIndexRedo, className: 'undoRedo', 'aria-disabled': tabIndexRedo == '-1' ? true : false, style: redoStyle, onTouchEnd: this.onRedo, onClick: this.onRedo, onMouseOver: this.onRedoMouseIn, onMouseOut: this.onRedoMouseOut },
	                    _react2.default.createElement('i', { style: redoIconStyle, className: 'fa fa-repeat undoRedo' })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { ref: 'preview', 'aria-label': _LocalesManager2.default.getCaption('preview', 'hover'), className: 'preview', style: previewStyle, onTouchEnd: this.changeMode, onClick: this.changeMode, onMouseOver: this.onPreviewButtonMouseIn, onMouseOut: this.onPreviewButtonMouseOut },
	                    _react2.default.createElement('i', { style: previewIconStyle, className: 'fa fa-eye' })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { ref: 'addSlide', 'aria-label': _LocalesManager2.default.getCaption('addSlide', 'hover'), style: addSlideStyle, onTouchEnd: this.addNewSlide, onClick: this.addNewSlide, onMouseOver: this.onAddButtonMouseIn, onMouseOut: this.onAddButtonMouseOut },
	                    _react2.default.createElement('i', { style: addIconStyle, className: 'fa fa-plus' })
	                ),
	                _react2.default.createElement(_MusicMenu.MusicMenu, { dispatch: this.props.dispatch })
	            ),
	            element,
	            _react2.default.createElement(_SlidesList.SlidesList, { listHeight: listHeight, dispatch: this.props.dispatch, windowWidth: this.props.windowWidth, showAudioEditor: this.props.showAudioEditor }),
	            _react2.default.createElement(_SlideMenu.SlideMenu, { dispatch: this.props.dispatch })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var timelines = state.audioEditor.timelines;
	    var needsRefresh = state.slideViewer.needsRefresh;
	    var undo = state.undoRedo.undo;
	    var redo = state.undoRedo.redo;
	    var accordionWidth = state.accordion.width;
	    var contextMode = state.menu.contextMode;
	    var showAudioEditor = state.menu.showAudioEditor;
	
	    if (showAudioEditor == undefined) showAudioEditor = false;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    return {
	        needsRefresh: needsRefresh,
	        undo: undo,
	        redo: redo,
	        accordionWidth: accordionWidth,
	        contextMode: contextMode,
	        showAudioEditor: showAudioEditor,
	        timelines: timelines
	    };
	}
	
	var SlideViewer = exports.SlideViewer = (0, _reactRedux.connect)(mapStateToProps)(SlideViewerContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slideViewer/SlideViewer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slideViewer/SlideViewer.js"); } } })();

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SlidesList = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _SlideItemRenderer = __webpack_require__(846);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ScrollableComponent = __webpack_require__(37);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _AudioEditorTimeline = __webpack_require__(326);
	
	var _Ruler = __webpack_require__(327);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _AudioToolUtils = __webpack_require__(18);
	
	var _AudioToolUtils2 = _interopRequireDefault(_AudioToolUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlidesListContent = _react2.default.createClass({
	    displayName: 'SlidesListContent',
	    getInitialState: function getInitialState() {
	        return {
	            elements: [],
	            order: this.getSlidesOrder(this.props.slides)
	        };
	    },
	    getSlidesOrder: function getSlidesOrder(slides) {
	        var order = '';
	        var i;
	
	        if (slides == undefined) return order;
	
	        for (i = 0; i < slides.length; i++) {
	            if (slides[i]) order = order + slides[i].uuid;
	        }
	
	        return order;
	    },
	    componentDidMount: function componentDidMount() {
	        this.initElements();
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var newOrder = this.getSlidesOrder(nextProps.slides);
	        var currentSlideTimeChanged = this.props.currentSlideTime != nextProps.currentSlideTime;
	
	        if (!_PlayController2.default.isAudioEditorMode()) currentSlideTimeChanged = false;
	
	        if (this.state.order != newOrder || this.props.showAudioEditor != nextProps.showAudioEditor || currentSlideTimeChanged || this.props.accordionWidth != nextProps.accordionWidth || this.props.timelineWidth != nextProps.timelineWidth) {
	            if (this.props.accordionWidth != nextProps.accordionWidth) this.recreateElements(false);else {
	                if (this.props.timelineWidth != nextProps.timelineWidth) this.recreateElements(true, true);else this.recreateElements(true);
	            }
	        }
	    },
	    recreateElements: function recreateElements() {
	        var updateScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        var useOldScrollPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        setTimeout(this.refreshNewContent, 50, updateScroll, useOldScrollPosition);
	    },
	    refreshNewContent: function refreshNewContent() {
	        var updateScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        var useOldScrollPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        this.initElements(updateScroll, useOldScrollPosition);
	    },
	    initElements: function initElements(updateScroll) {
	        var useOldScrollPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var elements = [];
	        var items = this.props.slides;
	        var i = void 0;
	        var item = void 0;
	        var slidesPosition = [];
	        var totalWidth = 0;
	        var currentIndex = _StoreManager2.default.getState().currentSlide.currentSlideIndex;
	        var time;
	
	        for (i = 0; i < items.length; i++) {
	            item = items[i];
	
	            if (currentIndex == i) time = _StoreManager2.default.getState().currentSlide.model.time;else time = item.time;
	
	            if (_AudioEditorUtils2.default.refreshAllSlidesRenderers && this.props.showAudioEditor) elements.push(_react2.default.createElement(_SlideItemRenderer.SlideItemRenderer, { index: i, item: item, key: item.uuid, forceRefresh: Math.random(), showAudioEditor: this.props.showAudioEditor, zoomValue: this.props.zoomValue, time: time }));else elements.push(_react2.default.createElement(_SlideItemRenderer.SlideItemRenderer, { index: i, item: item, key: item.uuid, showAudioEditor: this.props.showAudioEditor, zoomValue: this.props.zoomValue, time: time }));
	
	            slidesPosition.push(totalWidth);
	            totalWidth = totalWidth + _AudioEditorUtils2.default.getSlideWidth(time);
	        }
	
	        _AudioEditorUtils2.default.refreshAllSlidesRenderers = false;
	
	        if (_PlayController2.default.isAudioEditorAvailable() && this.props.showAudioEditor) {
	            totalWidth = this.props.timelineWidth;
	            _AudioEditorUtils2.default.slidesPosition = slidesPosition;
	
	            var holderStyle = {
	                position: 'absolute',
	                left: 0,
	                top: 0,
	                width: totalWidth
	            };
	
	            var holder = _react2.default.createElement(
	                'div',
	                { style: holderStyle, key: 'audioEditor' },
	                elements,
	                _react2.default.createElement(_Ruler.Ruler, { width: totalWidth, zoomValue: this.props.zoomValue, dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth }),
	                _react2.default.createElement(_AudioEditorTimeline.AudioEditorTimeline, { width: totalWidth, zoomValue: this.props.zoomValue, dispatch: this.props.dispatch, accordionWidth: this.props.accordionWidth })
	            );
	
	            elements = [holder];
	        }
	
	        this.setState({
	            elements: elements,
	            order: this.getSlidesOrder(this.props.slides)
	        });
	
	        if (updateScroll) {
	            _PlayController2.default.updateScrollPosition(300, useOldScrollPosition);
	        }
	    },
	    onClick: function onClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (e.target && e.target.className.indexOf('slideElement') != -1) this.props.dispatch((0, _CurrentSlideActions.setShortcutsTarget)(true));else this.props.dispatch((0, _CurrentSlideActions.setShortcutsTarget)(false));
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(newProps, nextState) {
	        if (this.state.elements != nextState.elements || this.props.accordionWidth != newProps.accordionWidth || this.props.windowWidth != newProps.windowWidth || this.props.slides != newProps.slides || this.props.dropIndex != newProps.dropIndex || this.props.needsRefresh != newProps.needsRefresh || this.props.showAudioEditor != newProps.showAudioEditor || this.props.zoomValue != newProps.zoomValue || this.props.currentSlideTime != newProps.currentSlideTime || this.props.timelineWidth != newProps.timelineWidth || this.props.timelines != newProps.timelines) return true;else return false;
	    },
	    render: function render() {
	        if (this.state == undefined || this.state.elements == undefined) return _react2.default.createElement('div', null);
	
	        var listWidth = this.props.windowWidth - this.props.accordionWidth - _AudioToolUtils2.default.buttonsHolderWidth();
	
	        var listStyle = {
	            width: listWidth,
	            height: this.props.listHeight,
	            position: 'absolute',
	            overflowY: 'hidden',
	            overflowX: 'hidden',
	            left: _AudioToolUtils2.default.buttonsHolderWidth(),
	            top: _Properties2.default.SLIDE_VIEWER_TOP_LINE_HEIGHT,
	            userDrag: 'none'
	        };
	
	        var paddingDrop = 0;
	
	        if (this.props.dropIndex >= 0) paddingDrop = _Properties2.default.SLIDE_PADDING_DROP;
	
	        var listScrollWidth = this.state.elements.length * (_Properties2.default.SLIDE_ITEM_WIDTH + _Properties2.default.SLIDE_GAP) + paddingDrop;
	
	        var componentProperties = {};
	        componentProperties.paddingTop = _Properties2.default.SLIDE_VIEWER_TOP_GAP;
	        componentProperties.paddingLeft = 0;
	        componentProperties.width = listWidth;
	        componentProperties.scrollWidth = listScrollWidth;
	        componentProperties.height = this.props.listHeight;
	        componentProperties.top = 0;
	        componentProperties.displayState = 'block';
	        componentProperties.isHorizontal = true;
	        componentProperties.id = 'slidesList';
	        componentProperties.isAudioEditor = false;
	        componentProperties.elements = this.state.elements;
	
	        if (_PlayController2.default.isAudioEditorAvailable() && this.props.showAudioEditor) componentProperties.elementsLength = this.props.slides.length;
	
	        if (this.props.showAudioEditor) {
	            componentProperties.isAudioEditor = true;
	            componentProperties.scrollWidth = this.props.timelineWidth;
	
	            if (componentProperties.scrollWidth > componentProperties.width) componentProperties.scrollWidth = componentProperties.scrollWidth + 2;
	        } else {
	            if (_PlatformDetection2.default.isTouchableDevice()) componentProperties.paddingTop = 0;
	        }
	
	        return _react2.default.createElement(
	            'div',
	            { style: listStyle, onClick: this.onClick },
	            _react2.default.createElement(_ScrollableComponent.ScrollableComponent, { componentProperties: componentProperties })
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var dropIndex = state.slideViewer.dropIndex;
	    var slides = state.production.slides ? state.production.slides : [];
	    var accordionWidth = state.accordion.width;
	    var needsRefresh = state.slideViewer.needsRefresh;
	    var uuid = Math.random();
	    var zoomValue = state.audioEditor.zoomValue;
	    var currentSlideTime = state.currentSlide && state.currentSlide.model ? state.currentSlide.model.time : 0;
	    var timelineWidth = state.audioEditor.timelineWidth;
	    var timelines = state.audioEditor.timelines;
	
	    if (zoomValue == undefined) zoomValue = 4;
	
	    if (accordionWidth == undefined) accordionWidth = _Properties2.default.BROWSER_WIDTH;
	
	    return {
	        dropIndex: dropIndex,
	        slides: slides,
	        accordionWidth: accordionWidth,
	        needsRefresh: needsRefresh,
	        uuid: uuid,
	        zoomValue: zoomValue,
	        currentSlideTime: currentSlideTime,
	        timelineWidth: timelineWidth,
	        timelines: timelines
	    };
	}
	
	var SlidesList = exports.SlidesList = (0, _reactRedux.connect)(mapStateToProps)(SlidesListContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/slideViewer/SlidesList.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/slideViewer/SlidesList.js"); } } })();

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactNativeWebviewMessaging = __webpack_require__(377);
	
	var _reactNativeWebviewMessaging2 = _interopRequireDefault(_reactNativeWebviewMessaging);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var downloadUtils = {
	    downloadFinishedCallback: undefined,
	    isNewApp: true,
	    isInitialized: false,
	
	    checkType: function checkType() {
	        return;
	        _reactNativeWebviewMessaging2.default.on('text', this.onCheckAppType.bind(this));
	        _reactNativeWebviewMessaging2.default.send('IsRecordingEnabled');
	    },
	    onCheckAppType: function onCheckAppType(e) {
	        if (e == 'IsRecordingEnabled' || e == 'IsRecordingDisabled') this.isNewApp = false;
	    },
	    download: function download(downloadId) {
	        var _this = this;
	
	        if (!this.isInitialized) {
	            if (!this.isNewApp) _reactNativeWebviewMessaging2.default.on('text', this.onMessageReceivedFromRN.bind(this));else window.addEventListener('message', this.getMessageFromRN.bind(this));
	
	            this.isInitialized = true;
	        }
	
	        // var videoUrl;
	        //
	        // if (configuration.IS_PROD())
	        //     videoUrl = 'https://www.creaza.com/file/ci/' + downloadId + '/';
	        // else
	        //     videoUrl = 'https://stage.creaza.com/file/ci/' + downloadId + '/';
	        //
	        // var message = 'Download=' + videoUrl;
	        //
	        // if (!this.isNewApp)
	        //     RNMsgChannel.send(message);
	        // else
	        //     window.postMessage(message);
	
	        _ApiService2.default.getSignedContent([downloadId]).then(function (response) {
	            var videoUrl = response[downloadId];
	            var message = 'Download=' + videoUrl;
	
	            if (!_this.isNewApp) _reactNativeWebviewMessaging2.default.send(message);else window.ReactNativeWebView.postMessage(message);
	        });
	    },
	    onMessageReceivedFromRN: function onMessageReceivedFromRN(text) {
	        if (text == 'DownloadFinished' && this.downloadFinishedCallback) {
	            this.downloadFinishedCallback();
	        }
	    },
	    getMessageFromRN: function getMessageFromRN(e) {
	        var text = e.data;
	
	        if (text == 'DownloadFinished' && this.downloadFinishedCallback) this.downloadFinishedCallback();
	    }
	};
	
	exports.default = downloadUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/DownloadUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/DownloadUtils.js"); } } })();

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _s = __webpack_require__(161);
	
	var _s2 = _interopRequireDefault(_s);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	var _ExporterUtils = __webpack_require__(93);
	
	var _ExporterUtils2 = _interopRequireDefault(_ExporterUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var exportUploader = {
	    uploader: undefined,
	
	    init: function init() {
	        var accessKey;
	        var bucket;
	        var acceptedString = 'application/json';
	        var arg = {};
	
	        arg.options = {};
	        if (_Configuration2.default.IS_PROD() == true) {
	            accessKey = 'AKIAJYMW5PW6FZLDMV2Q';
	            bucket = 'creaza-content-json';
	        } else {
	            accessKey = 'AKIAJW24ZO65AI7KR7BA';
	            bucket = 'creaza-stage-content-json';
	        }
	
	        arg.options.autoUpload = true;
	        arg.options.request = { endpoint: 'https://s3-eu-west-1.amazonaws.com/' + bucket, accessKey: accessKey, clockDrift: _AudioUtils2.default.serverTimeOffset };
	        arg.options.signature = { endpoint: '/ICSXapi/file/SignS3Policy' };
	        arg.options.validation = { acceptFiles: acceptedString };
	
	        arg.options.objectProperties = {
	            key: function key(fileId) {
	                return 'Cartoonist/' + _AppParameters2.default.currentUserId + '/export/' + this.getName(fileId);
	            }
	        };
	
	        this.uploader = new _s2.default(arg);
	        this.uploader.on('complete', this.onComplete.bind(this));
	        this.uploader.on('error', this.onFail.bind(this));
	    },
	    onComplete: function onComplete(type, name, state) {
	        _ExporterUtils2.default.uploadSuccess(type, name, state);
	    },
	    onFail: function onFail() {
	        _ExporterUtils2.default.uploadError();
	    },
	    uploadFile: function uploadFile(blob, title) {
	        var blobWrapper = { blob: blob, name: title };
	
	        this.uploader.methods.addFiles([blobWrapper]);
	    }
	};
	
	exports.default = exportUploader;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ExportUploader.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ExportUploader.js"); } } })();

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var multiTouchUtils = {
	    initialZoomLine: -1,
	    initialCenter: undefined,
	    initialBounds: undefined,
	    previousBounds: undefined,
	    isResizing: false,
	
	    zoom: function zoom(event, shapeModel, refreshShape) {
	        var updateZoomProperties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
	
	        this.isResizing = true;
	
	        if (this.initialZoomLine == -1) {
	            this.initialZoomLine = this.getZoomLine(event);
	            this.initialCenter = { x: shapeModel.x + shapeModel.width / 2, y: shapeModel.y + shapeModel.height / 2 };
	            this.initialBounds = { x: shapeModel.x, y: shapeModel.y, width: shapeModel.width, height: shapeModel.height };
	            return;
	        }
	
	        if (!updateZoomProperties && this.previousBounds) {
	            _StoreManager2.default.getStore().dispatch((0, _CurrentSlideActions.updateShapeSize)(shapeModel.uuid, this.previousBounds.width, this.previousBounds.height, this.previousBounds.x, this.previousBounds.y, shapeModel.horizontalFlip, shapeModel.verticalFlip));
	
	            if (refreshShape) refreshShape();
	
	            _SaveManager2.default.isContentChanged(true);
	
	            return;
	        }
	
	        var currentZoomLine = this.getZoomLine(event);
	        var offSet = currentZoomLine - this.initialZoomLine;
	
	        var newBounds = {};
	        newBounds.width = this.initialBounds.width + offSet;
	        newBounds.height = newBounds.width * this.initialBounds.height / this.initialBounds.width;
	
	        if (this.isValidSize(newBounds.width, newBounds.height)) {
	            newBounds.x = this.initialCenter.x - newBounds.width / 2;
	            newBounds.y = this.initialCenter.y - newBounds.height / 2;
	
	            var properties = {};
	            properties.scaleX = newBounds.width / this.initialBounds.width;
	            properties.scaleY = newBounds.height / this.initialBounds.height;
	            properties.translationX = newBounds.x - this.initialBounds.x;
	            properties.translationY = newBounds.y - this.initialBounds.y;
	
	            if (updateZoomProperties) updateZoomProperties(properties);
	
	            this.previousBounds = newBounds;
	        }
	    },
	    endZoom: function endZoom() {
	        this.isResizing = false;
	        this.initialZoomLine = -1;
	    },
	    isValidSize: function isValidSize(newWidth, newHeight) {
	        var minSize = 30;
	
	        if (newWidth < minSize || newHeight < minSize) {
	            return false;
	        } else return true;
	    },
	    isMultiTouch: function isMultiTouch(event) {
	        if (event.clientX != undefined) {
	            // is MouseEvent
	            return false;
	        } else {
	            if (event.touches.length > 1 || event.changedTouches.length > 1) return true;
	        }
	
	        return false;
	    },
	    getZoomLine: function getZoomLine(event) {
	        var touches = this.getTouchPoints(event);
	
	        if (touches.length >= 2) {
	            return this.distanceBetweenTwoPoints(touches[0], touches[1]);
	        } else return -1;
	    },
	    getTouchPoints: function getTouchPoints(event) {
	        if (event.touches && event.touches.length > 1) return [{ x: event.touches[0].clientX, y: event.touches[0].clientY }, { x: event.touches[1].clientX, y: event.touches[1].clientY }];else if (event.changedTouches && event.changedTouches.length > 1) return [{ x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY }, { x: event.changedTouches[1].clientX, y: event.changedTouches[1].clientY }];
	
	        return [];
	    },
	    distanceBetweenTwoPoints: function distanceBetweenTwoPoints(point1, point2) {
	        if (!point1 || !point2) return 0;
	
	        return Math.sqrt((point1.x - point2.x) * (point1.x - point2.x) + (point1.y - point2.y) * (point1.y - point2.y));
	    }
	};
	
	exports.default = multiTouchUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/MultiTouchUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/MultiTouchUtils.js"); } } })();

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _index = __webpack_require__(403);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recorderPolyfill = {
	    analyser: undefined,
	    mediaRecorder: undefined,
	    endRecording: undefined,
	    audioContext: undefined,
	
	    init: function init(audioContext, source, stream, analyser) {
	        this.analyser = analyser;
	        this.audioContext = audioContext;
	
	        try {
	            this.mediaRecorder = new _index2.default(stream);
	            this.mediaRecorder.addEventListener('dataavailable', this.handleDataAvailable.bind(this));
	        } catch (e) {
	            alert('Exception while creating MediaRecorder Polyfill!');
	        }
	    },
	    record: function record() {
	        if (this.mediaRecorder) this.mediaRecorder.start();
	    },
	    stop: function stop(endRecording) {
	        this.endRecording = endRecording;
	
	        if (this.mediaRecorder) this.mediaRecorder.stop();
	    },
	    handleDataAvailable: function handleDataAvailable(event) {
	        if (event.data && event.data.size > 0) {
	            var blob = new Blob([event.data], { 'type': event.data.type }); // audio/wav
	
	            if (this.endRecording) this.endRecording(blob);
	        }
	    },
	    microphoneLevel: function microphoneLevel() {
	        var array = new Uint8Array(this.analyser.frequencyBinCount);
	        this.analyser.getByteFrequencyData(array);
	
	        return this.getAverageVolume(array);
	    },
	    getAverageVolume: function getAverageVolume(array) {
	        var values = 0;
	        var average;
	        var i;
	        var length = array.length;
	
	        // get all the frequency amplitudes
	        for (i = 0; i < length; i++) {
	            values += array[i];
	        }
	
	        average = values / length;
	
	        return average;
	    },
	    cancelStream: function cancelStream() {}
	};
	
	exports.default = recorderPolyfill;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/RecorderPolyfill.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/RecorderPolyfill.js"); } } })();

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recordingUtils = {
	    recordingPositions: [],
	    startUploadingTime: -1,
	
	    setCurrentRecordingPosition: function setCurrentRecordingPosition() {
	        var position = this.getRecordingPosition();
	        var title = this.getSoundTitle();
	
	        this.recordingPositions.push({ position: position, title: title });
	    },
	    removeRecordingPosition: function removeRecordingPosition() {
	        if (this.recordingPositions.length > 0) this.recordingPositions.shift();
	    },
	    getCurrentRecordingPosition: function getCurrentRecordingPosition() {
	        if (this.recordingPositions && this.recordingPositions.length > 0) return this.recordingPositions[this.recordingPositions.length - 1];else return '';
	    },
	    getRecordingPositionWhenDataSaved: function getRecordingPositionWhenDataSaved(title) {
	        if (title && title.indexOf('.mp3') > 0) title = title.replace('.mp3', '');
	
	        if (this.recordingPositions && this.recordingPositions.length > 0) {
	            var i;
	            var newPositions = [];
	            var currentPosition;
	
	            for (i = 0; i < this.recordingPositions.length; i++) {
	                if (this.recordingPositions[i].title.indexOf(title) != -1) currentPosition = this.recordingPositions[i];else newPositions.push(this.recordingPositions[i]);
	            }
	
	            // ensure is the first item
	            if (currentPosition) {
	                this.recordingPositions = [currentPosition].concat(newPositions);
	
	                return currentPosition;
	            } else return this.recordingPositions[0];
	        } else return '';
	    },
	    getRecordingPosition: function getRecordingPosition() {
	        var position;
	
	        if (_PlayController2.default.isAudioEditorAvailable()) {
	            if (!_PlayController2.default.isAudioEditorMode()) position = _AudioEditorUtils2.default.getCurrentSlidePosition(_StoreManager2.default.getState().currentSlide.model.uuid);else {
	                var markerPosition = _AudioEditorUtils2.default.getMarkerPosition();
	
	                if (!markerPosition || markerPosition == -1) position = 0;else position = markerPosition;
	            }
	        } else position = _StoreManager2.default.getState().currentSlide.model.uuid;
	
	        return position;
	    },
	    getSoundTitle: function getSoundTitle() {
	        var currentdate = new Date();
	        var monthsOfYear = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	        var month = currentdate.getMonth();
	        var monthString = monthsOfYear[month];
	
	        var minutes = currentdate.getMinutes();
	
	        if (minutes < 10) minutes = '0' + minutes;
	
	        var seconds = currentdate.getSeconds();
	
	        if (seconds < 10) seconds = '0' + seconds;
	
	        var title = currentdate.getDate() + ' ' + monthString + ' ' + currentdate.getFullYear() + ' - ' + currentdate.getHours() + ':' + minutes + ':' + seconds + '.mp3';
	
	        return title;
	    }
	};
	
	exports.default = recordingUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/RecordingUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/RecordingUtils.js"); } } })();

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _s = __webpack_require__(161);
	
	var _s2 = _interopRequireDefault(_s);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var saveDataUploader = {
	    uploader: undefined,
	
	    init: function init() {
	        var accessKey;
	        var bucket;
	        var acceptedString = 'application/json';
	        var arg = {};
	
	        arg.options = {};
	        if (_Configuration2.default.IS_PROD() == true) {
	            accessKey = 'AKIAJYMW5PW6FZLDMV2Q';
	            bucket = 'creaza-content-json';
	        } else {
	            accessKey = 'AKIAJW24ZO65AI7KR7BA';
	            bucket = 'creaza-stage-content-json';
	        }
	
	        arg.options.autoUpload = true;
	        arg.options.request = { endpoint: 'https://s3-eu-west-1.amazonaws.com/' + bucket, accessKey: accessKey, clockDrift: _AudioUtils2.default.serverTimeOffset };
	        arg.options.signature = { endpoint: '/ICSXapi/file/SignS3Policy' };
	        arg.options.validation = { acceptFiles: acceptedString };
	
	        arg.options.objectProperties = {
	            key: function key(fileId) {
	                return 'Cartoonist/' + _AppParameters2.default.currentUserId + '/' + this.getName(fileId);
	            }
	        };
	
	        this.uploader = new _s2.default(arg);
	        this.uploader.on('complete', this.onComplete.bind(this));
	        this.uploader.on('error', this.onFail.bind(this));
	    },
	    onComplete: function onComplete(type, name, state) {
	        _SaveManager2.default.uploadSuccess(type, name, state);
	    },
	    onFail: function onFail() {
	        _SaveManager2.default.uploadError();
	    },
	    uploadFile: function uploadFile(blob, title) {
	        var blobWrapper = { blob: blob, name: title };
	
	        this.uploader.methods.addFiles([blobWrapper]);
	    }
	};
	
	exports.default = saveDataUploader;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SaveDataUploader.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/SaveDataUploader.js"); } } })();

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _s = __webpack_require__(161);
	
	var _s2 = _interopRequireDefault(_s);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var thumbnailDataUploader = {
	    uploader: undefined,
	
	    init: function init() {
	        var accessKey;
	        var bucket;
	        var acceptedString = 'image/png';
	        var arg = {};
	        var prefix;
	
	        arg.options = {};
	        if (_Configuration2.default.IS_PROD() == true) {
	            accessKey = 'AKIAJYMW5PW6FZLDMV2Q';
	            bucket = 'creaza-thumbnails';
	            prefix = 'https://s3.amazonaws.com/';
	        } else {
	            accessKey = 'AKIAJW24ZO65AI7KR7BA';
	            bucket = 'creaza-stage-thumbnails';
	            prefix = 'https://s3-eu-west-1.amazonaws.com/';
	        }
	
	        arg.options.autoUpload = true;
	        arg.options.request = { endpoint: prefix + bucket, accessKey: accessKey, clockDrift: _AudioUtils2.default.serverTimeOffset };
	        arg.options.signature = { endpoint: '/ICSXapi/file/SignS3Policy' };
	        arg.options.validation = { acceptFiles: acceptedString };
	
	        arg.options.objectProperties = {
	            key: function key(fileId) {
	                return 'Cartoonist/' + _AppParameters2.default.currentUserId + '/' + this.getName(fileId);
	            }
	        };
	
	        this.uploader = new _s2.default(arg);
	        this.uploader.on('complete', this.onComplete.bind(this));
	        this.uploader.on('error', this.onFail.bind(this));
	    },
	    onComplete: function onComplete(type, name, state) {
	        _SaveManager2.default.uploadThumbnailSuccess(type, name, state);
	    },
	    onFail: function onFail() {
	        _SaveManager2.default.uploadThumbnailError();
	    },
	    uploadFile: function uploadFile(blob, title) {
	        var blobWrapper = { blob: blob, name: title };
	
	        this.uploader.methods.addFiles([blobWrapper]);
	    }
	};
	
	exports.default = thumbnailDataUploader;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ThumbnailDataUploader.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/ThumbnailDataUploader.js"); } } })();

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transitionsUtils = {
	    TRANSITION_DURATION: 1000, // 1 second
	    SLIDE_MINIM_DURATION: 1000, // 1 second
	
	    WIPE_LEFT: 'wipeLeft',
	    PATTERN_SQUARE: 'patternSquare',
	    FLY_EYE: 'flyEye',
	    PATTERN_DOT_LARGE: 'patternDotLarge',
	    RADIAL: 'radial',
	    GRID_CIRCLE: 'gridCircle',
	    ANIMATION_BIRDS: 'animationBirds',
	    ANIMATION_RAINBOW: 'animationRainbow',
	    ANIMATION_ORNAMENTAL_FORM: 'animationOrnamentalForm',
	    CROSS_FADE: 'crossFade',
	    D_TILE_HORIZONTAL: '3dTileHorizontal',
	    PATTERN_STARE: 'patternStare',
	    SWAP: 'swap',
	    D_FLIP_VERTICAL: '3dFlipVertical',
	    FADE_WHITE: 'fadeThroughWhite',
	    ANIMTAION_CURTAINS: 'animationCurtains',
	    GRID_SLIDING: 'gridSliding',
	    PATERN_CROSS: 'patternCross',
	    CROSS_HATCH: 'crossHatch',
	    ANIMATION_PARASOL: 'animationParasol',
	    RIPPLE: 'ripple',
	    SLIDE: 'slide',
	    GRID_SEQUENTIAL: 'gridSequential',
	    GRID_FALLING: 'gridFalling',
	    PATTERN_BUBBLE: 'patternBubble',
	    D_HORIZONTAL_FLIP: '3dFlipHorizontal',
	    PATTERN_DIAMOND: 'patternDiamond',
	    PUZZLE_RIGHT: 'puzzleRight',
	    DIRECTIONAL_WIPE: 'directionalWipe',
	    PATTERN_BLOCK: 'patternBlock',
	    WIPE_UP: 'wipeUp',
	    PATTERN_ORIENTAL: 'patternOriental',
	    ANIMATION_FILM_STRIP: 'animationFilmstrip',
	    GRID_DIAGONAL: 'gridDiagonal',
	    ATMOSPHERIC: 'atmospheric',
	    FADE_BLACK: 'fadeThroughBlack',
	    PATTERN_LINE: 'patternLine',
	    MOSAIC: 'mosaic',
	    PAPER_PLANE: 'animationPaperPlane',
	    D_CUBE_HORIZONTAL: '3dCubeHorizontal',
	    CROSS_DISOLVE: 'crossDissolve',
	    WIPE_DOWN: 'wipeDown',
	    GRID_RANDOM: 'gridRandom',
	    BURN: 'burn',
	    WIPE_RIGHT: 'wipeRight',
	    D_CUBE_VERTICAL: '3dCubeVertical',
	    PAGE_CURL: 'pageCurl',
	    D_TILE_VERTICAL: '3dTileVertical',
	    PATTERN_DOT_SMALL: 'patternDotSmall',
	    CROSS_ZOOM: 'crossZoom',
	
	    exportPropertiesFromPortal: undefined,
	
	    useTransitions: function useTransitions() {
	        var exportProperties = this.getExportProperties();
	
	        if (exportProperties && exportProperties.addTransitions) return true;else return false;
	    },
	    getTransition: function getTransition() {
	        var exportProperties = this.getExportProperties();
	
	        if (exportProperties && exportProperties.useRandom) {
	            var array = [this.CROSS_ZOOM, this.D_TILE_VERTICAL, this.WIPE_LEFT, this.MOSAIC, this.D_HORIZONTAL_FLIP, this.D_CUBE_VERTICAL, this.CROSS_DISOLVE, this.RADIAL, this.BURN, this.RIPPLE, this.SLIDE];
	            var item = array[Math.floor(Math.random() * array.length)];
	
	            return item;
	        } else {
	            return this.CROSS_FADE;
	        }
	    },
	    useKenBurns: function useKenBurns() {
	        var exportProperties = this.getExportProperties();
	
	        if (exportProperties && exportProperties.addKenBurns) return true;else return false;
	    },
	    getExportProperties: function getExportProperties() {
	        var state = _StoreManager2.default.getState();
	        var exportProperties = state.production.exportProperties;
	
	        if (this.exportPropertiesFromPortal && (typeof this.exportPropertiesFromPortal === 'string' || this.exportPropertiesFromPortal instanceof String) && this.exportPropertiesFromPortal.indexOf('StartExport_') != -1) {
	            // it's Portal export
	            exportProperties = {};
	
	            var array = this.exportPropertiesFromPortal.split('_');
	            var selection = array[1];
	
	            if (selection && selection.length == 4) {
	                if (selection.charAt(0) == '1') exportProperties.addKenBurns = true;else exportProperties.addKenBurns = false;
	
	                if (selection.charAt(1) == '1') exportProperties.addTransitions = true;else exportProperties.addTransitions = false;
	
	                if (selection.charAt(2) == '1') exportProperties.useCrossFade = true;else exportProperties.useCrossFade = false;
	
	                if (selection.charAt(3) == '1') exportProperties.useRandom = true;else exportProperties.useRandom = false;
	            }
	        }
	
	        return exportProperties;
	    }
	};
	
	exports.default = transitionsUtils;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/TransitionsUtils.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/TransitionsUtils.js"); } } })();

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var webmRecorder = {
	    analyser: undefined,
	    mediaRecorder: undefined,
	    endRecording: undefined,
	    audioContext: undefined,
	    isChrome: false,
	    isFirefox: false,
	
	    init: function init(audioContext, source, stream, analyser) {
	        this.analyser = analyser;
	        this.audioContext = audioContext;
	
	        var ua = window.navigator.userAgent.toLowerCase();
	        this.isChrome = ua.indexOf('chrome') >= 0 && ua.indexOf('edg') === -1;
	        this.isFirefox = ua.indexOf('firefox') > 0;
	
	        try {
	            this.mediaRecorder = new MediaRecorder(stream);
	            this.mediaRecorder.ondataavailable = this.handleDataAvailable.bind(this);
	        } catch (e) {
	            alert('Exception while creating MediaRecorder!');
	        }
	    },
	    record: function record() {
	        if (this.mediaRecorder && !(this.mediaRecorder.state == 'recording')) this.mediaRecorder.start();
	    },
	    stop: function stop(endRecording) {
	        this.endRecording = endRecording;
	
	        if (this.mediaRecorder && this.mediaRecorder.state == 'recording') this.mediaRecorder.stop();
	    },
	    handleDataAvailable: function handleDataAvailable(event) {
	        if (event.data && event.data.size > 0) {
	            var blob = new Blob([event.data], { type: 'audio/mp3' }); // or { 'type' : 'audio/ogg; codecs=opus' }
	
	            if (this.endRecording) this.endRecording(blob);
	        }
	    },
	    microphoneLevel: function microphoneLevel() {
	        var array = new Uint8Array(this.analyser.frequencyBinCount);
	        this.analyser.getByteFrequencyData(array);
	
	        return this.getAverageVolume(array);
	    },
	    getAverageVolume: function getAverageVolume(array) {
	        var values = 0;
	        var average;
	        var i;
	        var length = array.length;
	
	        // get all the frequency amplitudes
	        for (i = 0; i < length; i++) {
	            values += array[i];
	        }
	
	        average = values / length;
	
	        return average;
	    },
	    cancelStream: function cancelStream() {
	        if (this.stream) {
	            if (this.isChrome || this.isFirefox) {
	                this.stream.getAudioTracks()[0].stop();
	            } else {
	                this.stream.stop();
	            }
	
	            this.stream = null;
	
	            if (this.audioContext.close) {
	                this.audioContext.close();
	            } else {
	                this.audioContext = null;
	            }
	        }
	    }
	};
	
	exports.default = webmRecorder;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/WebmRecorder.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/utils/WebmRecorder.js"); } } })();

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ControlPoint = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _reactDraggable = __webpack_require__(35);
	
	var _reactDraggable2 = _interopRequireDefault(_reactDraggable);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MenuActions = __webpack_require__(7);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ControlPointContent = _react2.default.createClass({
	    displayName: 'ControlPointContent',
	    getInitialState: function getInitialState() {
	        return {
	            thumbSize: 26,
	            isThumbOver: false,
	            isThumbActive: false
	        };
	    },
	    onThumbMouseIn: function onThumbMouseIn() {
	        if (this.props.index == 0) _HoverManager2.default.show(this.refs.videoControlPoint, 'videoLeftTrim');else _HoverManager2.default.show(this.refs.videoControlPoint, 'videoRightTrim', 'bottom');
	
	        this.setState({
	            isThumbOver: true
	        });
	    },
	    onThumbMouseOut: function onThumbMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isThumbOver: false
	        });
	    },
	    getPosition: function getPosition(position) {
	        return Number(position.substring(0, position.length - 2));
	    },
	    onMouseDown: function onMouseDown() {
	        var isKeyboard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        var left = this.getPosition(this.refs.thumb.style.left);
	
	        if (isKeyboard) {
	            this.setState({
	                startPosition: left,
	                isThumbActive: false
	            });
	        } else {
	            this.setState({
	                startPosition: left,
	                isThumbActive: true
	            });
	        }
	    },
	    onMouseMove: function onMouseMove(e, coreEvent, movement) {
	        if (movement) this.checkPosition(movement);else this.checkPosition(coreEvent.lastX);
	
	        this.updateVideoControlPoint();
	    },
	    onMouseUp: function onMouseUp(e, coreEvent) {
	        this.checkPosition(coreEvent.lastX);
	
	        this.setState({
	            isThumbActive: false
	        });
	
	        this.updateVideoControlPoint();
	    },
	    onKeyDown: function onKeyDown(e) {
	        var delta = 5;
	
	        if (e.keyCode == 37) {
	            // Left Key
	            this.onMouseDown(true);
	            setTimeout(function () {
	                this.onMouseMove(undefined, undefined, -delta);
	            }.bind(this), 10);
	        } else if (e.keyCode == 39) {
	            // Right Key
	            this.onMouseDown(true);
	            setTimeout(function () {
	                this.onMouseMove(undefined, undefined, delta);
	            }.bind(this), 10);
	        }
	    },
	    updateVideoControlPoint: function updateVideoControlPoint() {
	        if (this.props.index == 1) _VideoUtils2.default.updateStartPoint(true);else _VideoUtils2.default.updateStartPoint();
	    },
	    checkPosition: function checkPosition(deltaX) {
	        var newPosition = this.state.startPosition + deltaX;
	
	        if (newPosition < 0) newPosition = 0;
	
	        if (newPosition > this.props.trackWidth) newPosition = this.props.trackWidth;
	
	        var offSet = _VideoUtils2.default.trackOffset();
	
	        if (this.props.index == 0) {
	            // is left marker
	            if (_VideoUtils2.default.rightMarkerPosition - newPosition < offSet) newPosition = _VideoUtils2.default.rightMarkerPosition - offSet;
	
	            _VideoUtils2.default.leftMarkerPosition = newPosition;
	        } else {
	            if (newPosition - _VideoUtils2.default.leftMarkerPosition < offSet) newPosition = _VideoUtils2.default.leftMarkerPosition + offSet;
	
	            _VideoUtils2.default.rightMarkerPosition = newPosition;
	        }
	
	        this.forceUpdate();
	        this.props.dispatch((0, _MenuActions.updateControlPoint)(Math.random()));
	
	        this.refs.thumb.style.left = newPosition + 'px';
	
	        _VideoUtils2.default.markerPosition = _VideoUtils2.default.leftMarkerPosition;
	
	        var marker = document.getElementById('marker');
	        marker.style.left = _VideoUtils2.default.markerPosition + 'px';
	        _SaveManager2.default.isContentChanged(true);
	    },
	    getText: function getText() {
	        var time;
	
	        if (this.props.index == 0) time = _VideoUtils2.default.getRealTimeInSeconds(_VideoUtils2.default.leftMarkerPosition);else time = _VideoUtils2.default.getRealTimeInSeconds(_VideoUtils2.default.rightMarkerPosition);
	
	        return _VideoUtils2.default.convertTimeToStringFormat(time);
	    },
	    getLeftPosition: function getLeftPosition() {
	        if (this.props.index == 0) return _VideoUtils2.default.leftMarkerPosition;else return _VideoUtils2.default.rightMarkerPosition;
	    },
	    render: function render() {
	        var lineOffset = 12;
	        var thumbSize = this.state.thumbSize;
	        var lineWidth = 2;
	        var lineHeight = this.props.trackHeight + lineOffset;
	        var topPosition = -1 * (lineOffset + thumbSize / 2);
	        var topLinePosition = thumbSize / 2;
	        var topThumbPosition = -thumbSize / 2;
	
	        if (this.props.index == 1) {
	            topPosition = 0;
	            topThumbPosition = lineHeight;
	            topLinePosition = 0;
	        }
	
	        var buttonStyle = {
	            position: 'absolute',
	            top: topPosition,
	            left: this.getLeftPosition()
	        };
	
	        var borderColor = 'white';
	        var borderWidth = 2;
	
	        if (this.state.isThumbOver || this.state.isThumbActive) borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	
	        var thumbStyle = {
	            position: 'absolute',
	            left: -thumbSize / 2 - borderWidth,
	            top: topThumbPosition,
	            width: thumbSize,
	            height: thumbSize,
	            background: borderColor,
	            borderRadius: 50,
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            borderColor: borderColor,
	            borderWidth: borderWidth,
	            borderStyle: 'solid',
	            margin: 0,
	            padding: 0,
	            boxSizing: 'initial',
	            fontSize: 'initial'
	        };
	
	        var lineStyle = {
	            position: 'absolute',
	            left: -lineWidth / 2,
	            top: topLinePosition,
	            width: lineWidth,
	            height: lineHeight,
	            background: borderColor,
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none'
	        };
	
	        var idName = 'leftVideoControlPoint';
	        var textCenter = 'left';
	        var textWidth = 95;
	        var textPos = -(thumbSize / 2 + textWidth);
	        var textTopPos = -9;
	
	        if (this.props.index == 1) {
	            idName = 'rightVideoControlPoint';
	            textCenter = 'right';
	            textPos = thumbSize / 2;
	            textTopPos = lineHeight + thumbSize / 2 - 9;
	        }
	
	        var textValue = this.getText();
	
	        var textStyle = {
	            position: 'absolute',
	            top: textTopPos,
	            left: textPos,
	            color: 'white',
	            fontSize: 19,
	            width: textWidth,
	            whiteSpace: 'nowrap',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            textAlign: textCenter
	        };
	
	        var ariaLabel;
	
	        if (this.props.index == 0) ariaLabel = _LocalesManager2.default.getCaption('videoLeftTrim', 'hover');else ariaLabel = _LocalesManager2.default.getCaption('videoRightTrim', 'hover');
	
	        return _react2.default.createElement(
	            _reactDraggable2.default,
	            { axis: 'none', position: { x: 0, y: 0 }, onStart: this.onMouseDown, onDrag: this.onMouseMove, onStop: this.onMouseUp },
	            _react2.default.createElement(
	                'div',
	                { ref: 'thumb', id: idName, style: buttonStyle },
	                _react2.default.createElement('div', { style: lineStyle }),
	                _react2.default.createElement('button', { 'aria-label': ariaLabel, ref: 'videoControlPoint', style: thumbStyle, onKeyDown: this.onKeyDown, onMouseOver: this.onThumbMouseIn, onMouseOut: this.onThumbMouseOut }),
	                _react2.default.createElement(
	                    'span',
	                    { style: textStyle },
	                    textValue
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var updateValue = state.menu.updateValue;
	
	    return {
	        updateValue: updateValue
	    };
	}
	
	var ControlPoint = exports.ControlPoint = (0, _reactRedux.connect)(mapStateToProps)(ControlPointContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/ControlPoint.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/ControlPoint.js"); } } })();

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ShadowArea = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShadowAreaContent = _react2.default.createClass({
	    displayName: 'ShadowAreaContent',
	    render: function render() {
	        var width;
	        var leftPosition;
	
	        if (this.props.index == 0) {
	            width = _VideoUtils2.default.leftMarkerPosition;
	            leftPosition = 0;
	        } else {
	            width = this.props.trackWidth - _VideoUtils2.default.rightMarkerPosition;
	            leftPosition = _VideoUtils2.default.rightMarkerPosition;
	        }
	        var shadowStyle = {
	            position: 'absolute',
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            width: width,
	            height: this.props.trackHeight,
	            opacity: 0.6,
	            background: 'black',
	            left: leftPosition
	        };
	
	        return _react2.default.createElement('div', { style: shadowStyle });
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var updateValue = state.menu.updateValue;
	
	    return {
	        updateValue: updateValue
	    };
	}
	
	var ShadowArea = exports.ShadowArea = (0, _reactRedux.connect)(mapStateToProps)(ShadowAreaContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/ShadowArea.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/ShadowArea.js"); } } })();

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.TotalDurationView = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TotalDurationViewContent = _react2.default.createClass({
	    displayName: 'TotalDurationViewContent',
	    render: function render() {
	        var width = this.props.buttonSize * 2;
	        var height = _Properties2.default.PREVIEW_HEIGHT;
	
	        var timeButtonStyle = {
	            position: 'absolute',
	            left: _Configuration2.default.CANVAS_WIDTH * this.props.scaleProperties.scale / 2 - width / 2,
	            top: this.props.windowHeight - height - this.props.scaleProperties.topY,
	            width: width,
	            height: height,
	            background: 'white',
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none'
	        };
	
	        var offset = 1;
	        var timeStyle = {
	            position: 'absolute',
	            top: 12,
	            left: offset,
	            color: '#272727',
	            fontSize: 22,
	            width: width - 2 * offset,
	            whiteSpace: 'nowrap',
	            overflow: 'hidden',
	            textOverflow: 'ellipsis',
	            cursor: 'default',
	            textAlign: 'center'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: timeButtonStyle },
	            _react2.default.createElement(
	                'span',
	                { style: timeStyle },
	                _VideoUtils2.default.getEditVideoDuration()
	            )
	        );
	    }
	});
	
	function mapStateToProps() {
	    var state = _StoreManager2.default.getState();
	    var updateValue = state.menu.updateValue;
	
	    return {
	        updateValue: updateValue
	    };
	}
	
	var TotalDurationView = exports.TotalDurationView = (0, _reactRedux.connect)(mapStateToProps)(TotalDurationViewContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/TotalDurationView.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/TotalDurationView.js"); } } })();

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.VideoEditor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(10);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _VolumeBar = __webpack_require__(864);
	
	var _VideoTrack = __webpack_require__(863);
	
	var _TotalDurationView = __webpack_require__(860);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _MenuActions = __webpack_require__(7);
	
	var _ProductionActions = __webpack_require__(32);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoEditorContent = _react2.default.createClass({
	    displayName: 'VideoEditorContent',
	    getInitialState: function getInitialState() {
	        return {
	            isPlayButtonOver: false,
	            isPlaying: false,
	            isCancelOver: false,
	            isOkOver: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        _VideoUtils2.default.videoEndedCallback = this.onVideoEnded;
	        _VideoUtils2.default.executeAction = this.executeAction;
	    },
	    onCancelMouseIn: function onCancelMouseIn() {
	        _HoverManager2.default.show(this.refs.cancel, 'cancelVideo', 'left');
	
	        this.setState({
	            isCancelOver: true
	        });
	    },
	    clearEditorElements: function clearEditorElements() {
	        var updateStartPoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	        this.setState({
	            isPlayButtonOver: false,
	            isPlaying: false,
	            isCancelOver: false,
	            isOkOver: false
	        });
	
	        _VideoUtils2.default.resetCurrentProperties(updateStartPoint);
	
	        this.updatePlayButtonFocus();
	    },
	    updatePlayButtonFocus: function updatePlayButtonFocus() {
	        setTimeout(function () {
	            if (this.refs.play) this.refs.play.focus();
	        }.bind(this), 500);
	    },
	    resetAction: function resetAction() {
	        this.clearEditorElements();
	        this.props.dispatch((0, _CurrentSlideActions.updateCurrentSlideThumbnail)(true));
	        this.props.dispatch((0, _MenuActions.showVideoEditor)(false));
	
	        _HoverManager2.default.hide();
	    },
	    onCancelMouseOut: function onCancelMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isCancelOver: false
	        });
	    },
	    onCancelClick: function onCancelClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.executeCancelAction();
	    },
	    executeCancelAction: function executeCancelAction() {
	        this.addPreviewBackgroundState();
	
	        _AudioEditorUtils2.default.checkTimelineWidth();
	        this.resetAction();
	
	        _PlayController2.default.updateScrollPosition(500);
	        _VideoUtils2.default.currentSlideModel = undefined;
	
	        _SaveManager2.default.isContentChanged(true);
	        _SaveManager2.default.autoSave();
	    },
	    addPreviewBackgroundState: function addPreviewBackgroundState() {
	        if (_VideoUtils2.default.currentSlideModel) {
	            var slide = _VideoUtils2.default.currentSlideModel;
	            var background = slide.content[0];
	            var newContent = {};
	
	            newContent.href = background.xlinkHref;
	
	            if (background.logicalName) newContent.logicalName = background.logicalName;
	
	            if (background.contentItemId) newContent.contentItemId = background.contentItemId;
	
	            if (background.frameLabel) newContent.frameLabel = background.frameLabel;
	
	            if (background.moods) newContent.moods = background.moods;
	
	            if (background.hotSpot) newContent.hotSpot = background.hotSpot;
	
	            if (background.theme) newContent.theme = background.theme;
	
	            if (background.isVideo) {
	                newContent.isVideo = background.isVideo;
	                newContent.volume = background.volume;
	                newContent.inPoint = background.inPoint;
	                newContent.outPoint = background.outPoint;
	            }
	
	            if (background.orgWidth >= 0) {
	                newContent.orgWidth = background.orgWidth;
	                newContent.orgHeight = background.orgHeight;
	            }
	
	            if (background.fill) {
	                newContent.fill = background.fill;
	                newContent.fillOpacity = background.fillOpacity;
	            }
	
	            if (background.stroke) {
	                newContent.stroke = background.stroke;
	                newContent.strokeOpacity = background.strokeOpacity;
	            }
	
	            this.props.dispatch((0, _CurrentSlideActions.changeBackgroundContent)(newContent));
	            this.props.dispatch((0, _CurrentSlideActions.changeSlideDuration)(slide.time));
	        }
	    },
	    onOkMouseIn: function onOkMouseIn() {
	        _HoverManager2.default.show(this.refs.ok, 'okVideo');
	
	        this.setState({
	            isOkOver: true
	        });
	    },
	    onOkMouseOut: function onOkMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isOkOver: false
	        });
	    },
	    onCanvasClick: function onCanvasClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        if (_StoreManager2.default.getState().menu.contextMode != _ModeConstants2.default.SEARCH_CONTEXT) // if is Search menu then don't hide
	            this.props.dispatch((0, _MenuActions.changeContextMode)(_ModeConstants2.default.CONTEXT_NONE));
	    },
	    onOkClick: function onOkClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.executeOkAction();
	    },
	    executeOkAction: function executeOkAction() {
	        _AudioEditorUtils2.default.refreshAllSlidesRenderers = true;
	        _VideoUtils2.default.updateNewVideoProperties();
	        this.props.dispatch((0, _ProductionActions.updateCurrentSlide)());
	
	        _AudioEditorUtils2.default.checkTimelineWidth();
	
	        this.resetAction();
	
	        _PlayController2.default.updateScrollPosition(500);
	        _SaveManager2.default.isContentChanged(true);
	        _AudioEditorUtils2.default.addActionToHistory();
	
	        setTimeout(function () {
	            _VideoUtils2.default.prepareMultipleVideos(false);
	        }.bind(this), 500);
	
	        _VideoUtils2.default.currentSlideModel = undefined;
	    },
	    onPlayButtonMouseIn: function onPlayButtonMouseIn() {
	        _HoverManager2.default.show(this.refs.play, 'playVideo');
	
	        this.setState({
	            isPlayButtonOver: true
	        });
	    },
	    onPlayButtonMouseOut: function onPlayButtonMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isPlayButtonOver: false
	        });
	    },
	    onPlay: function onPlay(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.executePlayAction();
	    },
	    executePlayAction: function executePlayAction() {
	        if (!this.state.isPlaying) _VideoUtils2.default.playBackgroundVideo();else _VideoUtils2.default.pauseBackgroundVideo();
	
	        this.setState({
	            isPlaying: !this.state.isPlaying
	        });
	    },
	    executeAction: function executeAction(action) {
	        switch (action) {
	            case 'play':
	                {
	                    this.executePlayAction();
	                    break;
	                }
	            case 'ok':
	                {
	                    this.executeOkAction();
	                    break;
	                }
	            case 'cancel':
	                {
	                    this.executeCancelAction();
	                    break;
	                }
	            case 'reset':
	                {
	                    this.resetAction();
	                    break;
	                }
	            case 'clear':
	                {
	                    this.clearEditorElements(false);
	                    break;
	                }
	            case 'focus':
	                {
	                    this.updatePlayButtonFocus();
	                    break;
	                }
	        }
	    },
	    onVideoEnded: function onVideoEnded() {
	        this.setState({
	            isPlaying: false
	        });
	    },
	    getScaleFactor: function getScaleFactor() {
	        var freeHeight = this.props.scaleProperties.scale * _Configuration2.default.CANVAS_HEIGHT - 10 - 170;
	        return freeHeight / _Configuration2.default.CANVAS_HEIGHT;
	    },
	    render: function render() {
	        var scaleProperties = this.props.scaleProperties;
	        var menuStyle = {
	            position: 'absolute',
	            cursor: 'default',
	            userSelect: 'none',
	            WebkitUserSelect: 'none',
	            top: scaleProperties.topY,
	            left: scaleProperties.topX,
	            width: _Configuration2.default.CANVAS_WIDTH * scaleProperties.scale,
	            height: _Configuration2.default.CANVAS_HEIGHT * scaleProperties.scale
	        };
	
	        var appElement = document.getElementById('app');
	        var scaleFactor = scaleProperties.scale;
	
	        if (this.props.showVideoEditor) {
	            scaleFactor = this.getScaleFactor();
	            menuStyle.backgroundColor = '#707070';
	
	            if (appElement) appElement.style.backgroundColor = '#707070';
	        } else {
	            if (appElement) appElement.style.backgroundColor = '#F2F2F2';
	        }
	
	        var videoScaleTransform = 'scale(' + scaleFactor + ')';
	        var letPosition = (_Configuration2.default.CANVAS_WIDTH * scaleFactor - _Configuration2.default.CANVAS_WIDTH) / 2;
	        var topPosition = (_Configuration2.default.CANVAS_HEIGHT * scaleFactor - _Configuration2.default.CANVAS_HEIGHT) / 2;
	
	        var videoHolderStyle = {
	            position: 'absolute',
	            top: topPosition,
	            left: letPosition,
	            width: _Configuration2.default.CANVAS_WIDTH,
	            height: _Configuration2.default.CANVAS_HEIGHT,
	            transform: videoScaleTransform,
	            WebkitTransform: videoScaleTransform
	        };
	
	        if (this.props.showVideoEditor) {
	            videoHolderStyle.left = letPosition + (_Configuration2.default.CANVAS_WIDTH * scaleProperties.scale - _Configuration2.default.CANVAS_WIDTH * scaleFactor) / 2;
	            videoHolderStyle.top = topPosition + 10;
	
	            _VideoUtils2.default.getInitialProperties(_Configuration2.default.CANVAS_WIDTH * scaleFactor);
	
	            var buttonSize = 60;
	            var trackHeight = 50;
	            var borderColor;
	            var iconColor;
	            var trackLeft = (_Configuration2.default.CANVAS_WIDTH * scaleProperties.scale - _Configuration2.default.CANVAS_WIDTH * scaleFactor) / 2;
	            var trackBarPosition = _Configuration2.default.CANVAS_HEIGHT * scaleProperties.scale - 110;
	            var buttonTopPosition = trackBarPosition - (buttonSize - trackHeight) / 2;
	            var buttonGap = (trackLeft - buttonSize) / 2 - 2;
	            var srcCancel = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit.png';
	
	            //CANCEL button
	            if (this.state.isCancelOver) {
	                iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	                srcCancel = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/exit_edit_hover.png';
	            } else {
	                iconColor = 'white';
	            }
	
	            var offset = (this.props.windowWidth - this.props.accordionWidth - _Configuration2.default.CANVAS_WIDTH * scaleProperties.scale) / 2;
	            var cancelButtonStyle = {
	                position: 'absolute',
	                left: _Configuration2.default.CANVAS_WIDTH * scaleProperties.scale - buttonSize + offset,
	                top: 11 - scaleProperties.topY,
	                width: 40,
	                height: 40,
	                userDrag: 'none',
	                WebkitUserSelect: 'none',
	                userSelect: 'none',
	                margin: 0,
	                padding: 0,
	                fontSize: 'initial',
	                boxSizing: 'initial',
	                borderStyle: 'none',
	                background: 'none'
	            };
	
	            var cancelIconStyle = {
	                position: 'absolute',
	                top: 3,
	                left: 4,
	                color: iconColor
	            };
	
	            //OK button
	            if (this.state.isOkOver) {
	                borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	                iconColor = borderColor;
	            } else {
	                borderColor = 'white';
	                iconColor = '#272727';
	            }
	
	            var okButtonStyle = {
	                position: 'absolute',
	                left: _Configuration2.default.CANVAS_WIDTH * scaleProperties.scale - buttonSize - buttonGap,
	                top: buttonTopPosition,
	                width: buttonSize,
	                height: buttonSize,
	                background: 'white',
	                borderRadius: 50,
	                userDrag: 'none',
	                WebkitUserSelect: 'none',
	                userSelect: 'none',
	                borderColor: borderColor,
	                borderWidth: 2,
	                borderStyle: 'solid',
	                margin: 0,
	                padding: 0,
	                fontSize: 'initial',
	                boxSizing: 'initial'
	            };
	
	            var okStyle = {
	                position: 'absolute',
	                top: 15,
	                left: 15,
	                color: iconColor
	            };
	
	            //play button
	            if (this.state.isPlayButtonOver == true) {
	                borderColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
	                iconColor = borderColor;
	            } else {
	                borderColor = 'white';
	                iconColor = '#272727';
	            }
	
	            var playStyle = {
	                position: 'absolute',
	                left: buttonGap,
	                top: buttonTopPosition,
	                width: buttonSize,
	                height: buttonSize,
	                background: 'white',
	                borderRadius: 50,
	                userDrag: 'none',
	                WebkitUserSelect: 'none',
	                userSelect: 'none',
	                borderColor: borderColor,
	                borderWidth: 2,
	                borderStyle: 'solid',
	                margin: 0,
	                padding: 0,
	                fontSize: 'initial',
	                boxSizing: 'initial'
	            };
	
	            var playIcon = 'fa fa-play fa-2x';
	            var playIconPosition = 21;
	
	            if (this.state.isPlaying) {
	                playIcon = 'fa fa-pause fa-2x';
	                playIconPosition = 17;
	            }
	
	            var playIconStyle = {
	                position: 'absolute',
	                top: 14,
	                left: playIconPosition,
	                color: iconColor
	            };
	
	            var size = 48;
	
	            var loaderStyle = {
	                position: 'absolute',
	                top: videoHolderStyle.height / 2 - size / 2,
	                left: videoHolderStyle.width / 2 - size / 2,
	                color: 'white',
	                display: 'none'
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { style: menuStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: videoHolderStyle, onTouchEnd: this.onCanvasClick, onClick: this.onCanvasClick },
	                    _react2.default.createElement('video', { id: 'videoBackground', width: _Configuration2.default.CANVAS_WIDTH, height: _Configuration2.default.CANVAS_HEIGHT, className: 'audioItem', playsInline: true }),
	                    _react2.default.createElement('i', { id: 'videoPreloader', style: loaderStyle, className: 'fa fa-spinner fa-pulse fa-2x' })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { 'aria-label': _LocalesManager2.default.getCaption('cancelVideo', 'hover'), ref: 'cancel', style: cancelButtonStyle, onTouchEnd: this.onCancelClick, onClick: this.onCancelClick, onMouseOver: this.onCancelMouseIn, onMouseOut: this.onCancelMouseOut },
	                    _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', style: cancelIconStyle, src: srcCancel })
	                ),
	                _react2.default.createElement(
	                    'button',
	                    { 'aria-label': _LocalesManager2.default.getCaption('playVideo', 'hover'), ref: 'play', style: playStyle, onMouseOver: this.onPlayButtonMouseIn, onMouseOut: this.onPlayButtonMouseOut, onClick: this.onPlay, onTouchEnd: this.onPlay },
	                    _react2.default.createElement('i', { style: playIconStyle, className: playIcon })
	                ),
	                _react2.default.createElement(_VideoTrack.VideoTrack, { dispatch: this.props.dispatch, width: _Configuration2.default.CANVAS_WIDTH * scaleFactor, height: 50, globalLeft: trackLeft + menuStyle.left, left: trackLeft, top: trackBarPosition, refreshVideoEditor: this.props.refreshVideoEditor }),
	                _react2.default.createElement(
	                    'button',
	                    { 'aria-label': _LocalesManager2.default.getCaption('okVideo', 'hover'), ref: 'ok', style: okButtonStyle, onTouchEnd: this.onOkClick, onClick: this.onOkClick, onMouseOver: this.onOkMouseIn, onMouseOut: this.onOkMouseOut },
	                    _react2.default.createElement('i', { style: okStyle, className: 'fa fa-check fa-2x' })
	                ),
	                _react2.default.createElement(_VolumeBar.VolumeBar, { scaleProperties: scaleProperties, refreshVideoEditor: this.props.refreshVideoEditor, windowHeight: this.props.windowHeight, windowWidth: this.props.windowWidth, accordionWidth: this.props.accordionWidth }),
	                _react2.default.createElement(_TotalDurationView.TotalDurationView, { buttonSize: trackHeight, scaleProperties: scaleProperties, refreshVideoEditor: this.props.refreshVideoEditor, windowHeight: this.props.windowHeight })
	            );
	        } else {
	            var _size = 48;
	
	            var _loaderStyle = {
	                position: 'absolute',
	                top: videoHolderStyle.height / 2 - _size / 2,
	                left: videoHolderStyle.width / 2 - _size / 2,
	                color: 'black',
	                display: 'none'
	            };
	
	            var fillColor = this.props.currentSlide && this.props.currentSlide.model ? this.props.currentSlide.model.content[0].fill : '#ffffff';
	            videoHolderStyle.background = fillColor;
	
	            return _react2.default.createElement(
	                'div',
	                { style: menuStyle },
	                _react2.default.createElement(
	                    'div',
	                    { style: videoHolderStyle },
	                    _react2.default.createElement('video', { id: 'videoBackground', width: _Configuration2.default.CANVAS_WIDTH, height: _Configuration2.default.CANVAS_HEIGHT, className: 'audioItem', preload: 'auto', playsInline: true }),
	                    _react2.default.createElement('div', { id: 'multipleVideos' }),
	                    _react2.default.createElement('i', { id: 'videoPreloader', style: _loaderStyle, className: 'fa fa-spinner fa-pulse fa-2x' })
	                )
	            );
	        }
	    }
	});
	
	function mapStateToProps(state) {
	    var showVideoEditor = state.menu.showVideoEditor;
	    var refreshVideoEditor = state.menu.refreshVideoEditor;
	    var currentSlide = state.currentSlide;
	
	    if (!showVideoEditor) showVideoEditor = false;
	
	    return {
	        showVideoEditor: showVideoEditor,
	        refreshVideoEditor: refreshVideoEditor,
	        currentSlide: currentSlide
	    };
	}
	
	var VideoEditor = exports.VideoEditor = (0, _reactRedux.connect)(mapStateToProps)(VideoEditorContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/VideoEditor.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/VideoEditor.js"); } } })();

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.VideoMarker = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoMarker = exports.VideoMarker = _react2.default.createClass({
	    displayName: 'VideoMarker',
	    getInitialState: function getInitialState() {
	        return {
	            isMarkerVisible: false,
	            isMouseDown: false,
	            isSplitVisible: false,
	            isSplitOver: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.refs.track.addEventListener('touchstart', this.onMouseDown);
	        document.addEventListener('touchmove', this.onMouseMove);
	        document.addEventListener('touchend', this.onMouseUp);
	
	        this.refs.track.addEventListener('mousedown', this.onMouseDown);
	        document.addEventListener('mousemove', this.onMouseMove);
	        document.addEventListener('mouseup', this.onMouseUp);
	
	        _VideoUtils2.default.markerUpdateHandler = this.updateMarker;
	        _VideoUtils2.default.updateMarkerVisbility = this.updateMarkerVisbility;
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        this.refs.track.removeEventListener('touchstart', this.onMouseDown);
	        document.removeEventListener('touchmove', this.onMouseMove);
	        document.removeEventListener('touchend', this.onMouseUp);
	
	        this.refs.track.removeEventListener('mousedown', this.onMouseDown);
	        document.removeEventListener('mousemove', this.onMouseMove);
	        document.removeEventListener('mouseup', this.onMouseUp);
	
	        _VideoUtils2.default.markerUpdateHandler = undefined;
	        _VideoUtils2.default.updateMarkerVisbility = undefined;
	    },
	    onSplitMouseIn: function onSplitMouseIn() {
	        _HoverManager2.default.show(this.refs.split, 'SplitClipHover');
	
	        this.setState({
	            isSplitOver: true
	        });
	    },
	    onSplitMouseOut: function onSplitMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isSplitOver: false
	        });
	    },
	    updateMarker: function updateMarker() {
	        var isStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	        var isEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (isStart) this.start();else this.stop(isEnd);
	    },
	    start: function start() {
	        if (this.state.intervalVar) clearInterval(this.state.intervalVar);
	
	        var markerPosition = _VideoUtils2.default.getMarkerPosition();
	        var intervalTime = 10;
	        var distance = _VideoUtils2.default.rightMarkerPosition - markerPosition;
	        var time = (_VideoUtils2.default.getOutPoint() - _VideoUtils2.default.getCurrentPoint()) * 1000;
	        var offSet = distance * intervalTime / time;
	        var intervalVar = setInterval(this.setPosition, intervalTime);
	
	        this.setState({
	            intervalVar: intervalVar,
	            offSet: offSet,
	            currentPosition: markerPosition,
	            isMarkerVisible: true,
	            isSplitVisible: false
	        });
	    },
	    stop: function stop(isEnd) {
	        if (this.state.intervalVar) clearInterval(this.state.intervalVar);
	
	        if (!isEnd) _VideoUtils2.default.markerPosition = this.state.currentPosition;else _VideoUtils2.default.markerPosition = _VideoUtils2.default.leftMarkerPosition;
	
	        if (this.refs.marker) {
	            this.refs.marker.style.left = _VideoUtils2.default.markerPosition + 'px';
	            this.refs.split.style.left = _VideoUtils2.default.markerPosition + this.splitOffset() + 'px';
	        }
	    },
	    setPosition: function setPosition() {
	        var position = this.state.currentPosition + this.state.offSet;
	
	        this.setState({
	            currentPosition: position
	        });
	
	        this.refs.marker.style.left = position + 'px';
	        this.refs.split.style.left = position + this.splitOffset() + 'px';
	    },
	    onMouseDown: function onMouseDown(e) {
	        var position = _MouseUtils2.default.getTouchPosition(e);
	        var offset;
	
	        if (e.offsetX >= 0) offset = e.offsetX;else offset = position.x - this.props.globalLeft;
	
	        this.moveMarker(offset);
	
	        this.setState({
	            isMouseDown: true,
	            clientX: position.x,
	            startPosition: _VideoUtils2.default.markerPosition,
	            isSplitVisible: true
	        });
	    },
	    onMouseMove: function onMouseMove(e) {
	        if (this.state.isMouseDown) {
	            var globalPosition = _MouseUtils2.default.getTouchPosition(e);
	            var position = this.state.startPosition + (globalPosition.x - this.state.clientX);
	            this.moveMarker(position);
	        }
	    },
	    onMouseUp: function onMouseUp() {
	        if (_TextSizeUtils2.default.isTextEditMode()) return;
	
	        this.setState({
	            isMouseDown: false
	        });
	    },
	    moveMarker: function moveMarker(position) {
	        var newPosition = position;
	
	        if (newPosition > _VideoUtils2.default.leftMarkerPosition && newPosition < _VideoUtils2.default.rightMarkerPosition) {
	            this.refs.marker.style.left = newPosition + 'px';
	            this.refs.split.style.left = newPosition + this.splitOffset() + 'px';
	
	            _VideoUtils2.default.updateMarkerPosition(newPosition);
	
	            this.updateMarkerVisbility(true);
	        }
	    },
	    splitOffset: function splitOffset() {
	        return -14.5;
	    },
	    updateMarkerVisbility: function updateMarkerVisbility() {
	        var isVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (!isVisible) {
	            this.setState({
	                isMarkerVisible: isVisible,
	                isSplitVisible: false
	            });
	        } else {
	            this.setState({
	                isMarkerVisible: isVisible
	            });
	        }
	    },
	    onSplitClick: function onSplitClick() {
	        _VideoUtils2.default.splitClip();
	    },
	    render: function render() {
	        var divStyle = {
	            position: 'absolute',
	            userDrag: 'none',
	            WebkitUserSelect: 'none',
	            userSelect: 'none',
	            width: this.props.trackWidth,
	            height: this.props.trackHeight
	        };
	
	        var backgroundStyle = {
	            position: 'absolute',
	            width: this.props.trackWidth,
	            height: this.props.trackHeight
	        };
	
	        var isVisible = 'none';
	
	        if (this.state.isMarkerVisible) isVisible = 'block';
	
	        var markerStyle = {
	            position: 'absolute',
	            width: 3,
	            height: this.props.trackHeight,
	            background: '#272727',
	            display: isVisible
	        };
	
	        var splitSrc = _AppParameters2.default.RESOURCES_LOCATION() + 'assets/split.png';
	
	        isVisible = 'none';
	
	        if (this.state.isSplitVisible) isVisible = 'block';
	
	        var splitStyle = {
	            position: 'absolute',
	            height: 40,
	            top: -40,
	            left: 0,
	            display: isVisible
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: divStyle },
	            _react2.default.createElement('img', { alt: '', 'aria-hidden': 'true', ref: 'split', style: splitStyle, src: splitSrc, onTouchEnd: this.onSplitClick, onMouseDown: this.onSplitClick, onMouseOver: this.onSplitMouseIn, onMouseOut: this.onSplitMouseOut }),
	            _react2.default.createElement('div', { ref: 'marker', id: 'marker', style: markerStyle }),
	            _react2.default.createElement('canvas', { ref: 'track', style: backgroundStyle })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/VideoMarker.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/VideoMarker.js"); } } })();

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.VideoTrack = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _ControlPoint = __webpack_require__(858);
	
	var _ShadowArea = __webpack_require__(859);
	
	var _VideoMarker = __webpack_require__(862);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoTrack = exports.VideoTrack = _react2.default.createClass({
	    displayName: 'VideoTrack',
	    render: function render() {
	        var menuStyle = {
	            position: 'absolute',
	            backgroundColor: '#BEBEBE',
	            width: this.props.width,
	            height: this.props.height,
	            top: this.props.top,
	            left: this.props.left,
	            cursor: 'default',
	            userSelect: 'none',
	            userDrag: 'none',
	            WebkitUserSelect: 'none'
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(_VideoMarker.VideoMarker, { trackHeight: this.props.height, trackWidth: this.props.width, globalLeft: this.props.globalLeft, refreshVideoEditor: this.props.refreshVideoEditor }),
	            _react2.default.createElement(_ShadowArea.ShadowArea, { trackHeight: this.props.height, trackWidth: this.props.width, index: 0, refreshVideoEditor: this.props.refreshVideoEditor }),
	            _react2.default.createElement(_ShadowArea.ShadowArea, { trackHeight: this.props.height, trackWidth: this.props.width, index: 1, refreshVideoEditor: this.props.refreshVideoEditor }),
	            _react2.default.createElement(_ControlPoint.ControlPoint, { dispatch: this.props.dispatch, trackHeight: this.props.height, leftPosition: _VideoUtils2.default.leftMarkerPosition, trackWidth: this.props.width, index: 0, dragButtonSize: 42, refreshVideoEditor: this.props.refreshVideoEditor }),
	            _react2.default.createElement(_ControlPoint.ControlPoint, { dispatch: this.props.dispatch, trackHeight: this.props.height, leftPosition: _VideoUtils2.default.rightMarkerPosition, trackWidth: this.props.width, index: 1, dragButtonSize: 42, refreshVideoEditor: this.props.refreshVideoEditor })
	        );
	    }
	});
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/VideoTrack.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/VideoTrack.js"); } } })();

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.VolumeBar = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _reactRedux = __webpack_require__(10);
	
	var _SlideDurationSlider = __webpack_require__(343);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _VideoUtils = __webpack_require__(20);
	
	var _VideoUtils2 = _interopRequireDefault(_VideoUtils);
	
	var _HoverManager = __webpack_require__(16);
	
	var _HoverManager2 = _interopRequireDefault(_HoverManager);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VolumeBarContent = _react2.default.createClass({
	    displayName: 'VolumeBarContent',
	    getInitialState: function getInitialState() {
	        return {
	            isVolumeDownOver: false,
	            isVolumeUpOver: false,
	            currentVolume: _VideoUtils2.default.currentVideoVolume
	        };
	    },
	    onVolumeDownMouseIn: function onVolumeDownMouseIn() {
	        _HoverManager2.default.show(this.refs.minVolume, 'videoMinVolume');
	
	        this.setState({
	            isVolumeDownOver: true
	        });
	    },
	    onVolumeDownMouseOut: function onVolumeDownMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isVolumeDownOver: false
	        });
	    },
	    onVolumeDownClick: function onVolumeDownClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.setState({
	            currentVolume: 0
	        });
	
	        _VideoUtils2.default.currentVideoVolume = 0;
	    },
	    onVolumeUpMouseIn: function onVolumeUpMouseIn() {
	        _HoverManager2.default.show(this.refs.maxVolume, 'videoMaxVolume');
	
	        this.setState({
	            isVolumeUpOver: true
	        });
	    },
	    onVolumeUpMouseOut: function onVolumeUpMouseOut() {
	        _HoverManager2.default.hide();
	
	        this.setState({
	            isVolumeUpOver: false
	        });
	    },
	    onVolumeUpClick: function onVolumeUpClick(e) {
	        if (_MouseUtils2.default.rejectMouseEvent(e)) return;
	
	        this.setState({
	            currentVolume: 1
	        });
	
	        _VideoUtils2.default.currentVideoVolume = 1.0;
	    },
	    render: function render() {
	        if (!this.props.showVideoEditor) return _react2.default.createElement('div', null);
	
	        var width = this.props.windowWidth - this.props.accordionWidth;
	        var height = _Properties2.default.PREVIEW_HEIGHT;
	
	        var menuStyle = {
	            position: 'absolute',
	            backgroundColor: _Properties2.default.RECORDING_MENU_BACKGROUND,
	            width: width,
	            height: height,
	            top: this.props.windowHeight - height - this.props.scaleProperties.topY,
	            left: -(width - _Configuration2.default.CANVAS_WIDTH * this.props.scaleProperties.scale) / 2,
	            cursor: 'default',
	            userSelect: 'none',
	            userDrag: 'none',
	            WebkitUserSelect: 'none'
	        };
	
	        var iconColor;
	        var sliderWidth = 190;
	        var sliderHolderStyle = {
	            position: 'absolute',
	            width: sliderWidth,
	            height: height,
	            top: 0,
	            left: width - sliderWidth
	        };
	
	        var sliderProperties = {};
	        sliderProperties.topPosition = (height - _Properties2.default.RECORDING_BUTTON_HEIGHT) / 2;
	        sliderProperties.leftPosition = 35;
	        sliderProperties.width = _Properties2.default.RECORGING_SLIDER_WIDTH;
	        sliderProperties.height = _Properties2.default.RECORDING_BUTTON_HEIGHT;
	        sliderProperties.thumbSize = _Properties2.default.STYLING_THUMB_SIZE - 2;
	        sliderProperties.start = 0;
	        sliderProperties.end = 10;
	        sliderProperties.step = 1;
	        sliderProperties.dispatch = this.props.dispatch;
	        sliderProperties.isVideo = true;
	        sliderProperties.currentValue = _VideoUtils2.default.currentVideoVolume * 10;
	
	        if (this.state.isVolumeDownOver == true) iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else iconColor = '#272727';
	
	        var volumeIconDownButton = {
	            position: 'absolute',
	            width: 32,
	            height: 32,
	            left: 0,
	            top: 7,
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            borderStyle: 'none',
	            background: 'none'
	        };
	
	        var volumeIconDown = {
	            position: 'absolute',
	            left: 7,
	            top: 0,
	            color: iconColor
	        };
	
	        if (this.state.isVolumeUpOver == true) iconColor = _Properties2.default.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;else iconColor = '#272727';
	
	        var volumeIconUpButton = {
	            position: 'absolute',
	            width: 32,
	            height: 32,
	            left: 35 + _Properties2.default.RECORGING_SLIDER_WIDTH + 10,
	            top: 7,
	            margin: 0,
	            padding: 0,
	            fontSize: 'initial',
	            boxSizing: 'initial',
	            borderStyle: 'none',
	            background: 'none'
	        };
	
	        var volumeIconUp = {
	            position: 'absolute',
	            left: 1,
	            top: 0,
	            color: iconColor
	        };
	
	        return _react2.default.createElement(
	            'div',
	            { style: menuStyle },
	            _react2.default.createElement(
	                'div',
	                { style: sliderHolderStyle },
	                _react2.default.createElement(
	                    'button',
	                    { 'aria-label': _LocalesManager2.default.getCaption('videoMinVolume', 'hover'), style: volumeIconDownButton, onMouseOver: this.onVolumeDownMouseIn, onMouseOut: this.onVolumeDownMouseOut, onClick: this.onVolumeDownClick, onTouchEnd: this.onVolumeDownClick },
	                    _react2.default.createElement('i', { ref: 'minVolume', style: volumeIconDown, className: 'fa fa-volume-off fa-2x' })
	                ),
	                _react2.default.createElement(_SlideDurationSlider.SlideDurationSlider, { properties: sliderProperties, refreshVideoEditor: this.props.refreshVideoEditor }),
	                _react2.default.createElement(
	                    'button',
	                    { 'aria-label': _LocalesManager2.default.getCaption('videoMaxVolume', 'hover'), style: volumeIconUpButton, onMouseOver: this.onVolumeUpMouseIn, onMouseOut: this.onVolumeUpMouseOut, onClick: this.onVolumeUpClick, onTouchEnd: this.onVolumeUpClick },
	                    _react2.default.createElement('i', { ref: 'maxVolume', style: volumeIconUp, className: 'fa fa-volume-up fa-2x' })
	                )
	            )
	        );
	    }
	});
	
	function mapStateToProps(state) {
	    var showVideoEditor = state.menu.showVideoEditor;
	
	    if (!showVideoEditor) showVideoEditor = false;
	
	    return {
	        showVideoEditor: showVideoEditor
	    };
	}
	
	var VolumeBar = exports.VolumeBar = (0, _reactRedux.connect)(mapStateToProps)(VolumeBarContent);
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/VolumeBar.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/components/videoEditor/VolumeBar.js"); } } })();

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(301);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(900);
	
	var _reactRedux = __webpack_require__(10);
	
	var _App = __webpack_require__(752);
	
	var _AudioEditorApp = __webpack_require__(755);
	
	var _AudioPlayerApp = __webpack_require__(756);
	
	var _AppPrint = __webpack_require__(753);
	
	var _AppPrintEditor = __webpack_require__(754);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _DataLoader = __webpack_require__(323);
	
	var _DataLoader2 = _interopRequireDefault(_DataLoader);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _LocalesManager = __webpack_require__(9);
	
	var _LocalesManager2 = _interopRequireDefault(_LocalesManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(650);
	__webpack_require__(645);
	__webpack_require__(651);
	__webpack_require__(207);
	
	window.Promise = __webpack_require__(409);
	
	Promise.config({
	    warnings: false
	});
	
	var store = _StoreManager2.default.configureAndSetStore({});
	
	_Properties2.default.init();
	
	if (_PlatformDetection2.default.isIE() == true) _LocalesManager2.default.init();else _DataLoader2.default.loadData();
	
	var routes;
	
	switch (_AppParameters2.default.context) {
	    case _ModeConstants2.default.PRINT:
	        {
	            routes = _react2.default.createElement(_reactRouter.Route, { path: '/', component: _AppPrint.AppPrint });
	            break;
	        }
	    case _ModeConstants2.default.PRINT_EDITOR:
	        {
	            routes = _react2.default.createElement(_reactRouter.Route, { path: '/', component: _AppPrintEditor.AppPrintEditor });
	            break;
	        }
	    case _ModeConstants2.default.AUDIO_TOOL:
	        {
	            routes = _react2.default.createElement(_reactRouter.Route, { path: '/', component: _AudioEditorApp.AudioEditorApp });
	            break;
	        }
	
	    case _ModeConstants2.default.EXPORT_PLAYER:
	    case _ModeConstants2.default.EXPORT_AUDIO_PLAYER:
	    case _ModeConstants2.default.AUDIO_TOOL_PLAYER:
	        {
	            routes = _react2.default.createElement(_reactRouter.Route, { path: '/', component: _AudioPlayerApp.AudioPlayerApp });
	            break;
	        }
	
	    default:
	        {
	            routes = _react2.default.createElement(_reactRouter.Route, { path: '/', component: _App.App });
	        }
	}
	
	_reactDom2.default.render(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(
	        _reactRouter.Router,
	        { history: _reactRouter.hashHistory },
	        routes
	    )
	), document.getElementById('wrapper'));
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/index.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/index.js"); } } })();

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseSlide = parseSlide;
	exports.parseSlideMetadata = parseSlideMetadata;
	exports.parseSlideSVG = parseSlideSVG;
	exports.parseShape = parseShape;
	exports.parseCurve = parseCurve;
	exports.parseLine = parseLine;
	exports.parseEllipse = parseEllipse;
	exports.parseRectangle = parseRectangle;
	exports.parseImage = parseImage;
	exports.parseCharacter = parseCharacter;
	exports.parseBackground = parseBackground;
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _uuid = __webpack_require__(68);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _SlideParserUtils = __webpack_require__(376);
	
	var _SlideParserUtils2 = _interopRequireDefault(_SlideParserUtils);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseSlide(slideElement) {
	    var metadata = parseSlideMetadata(slideElement);
	    var svgData = parseSlideSVG(slideElement.getElementsByTagName('svg')[0]);
	
	    return Object.assign({}, metadata, { content: svgData }, { initialized: false }, { time: _Configuration2.default.SLIDE_DURATION });
	}
	
	function parseSlideMetadata(slideElement) {
	    var title = slideElement.getElementsByTagName('title')[0].textContent;
	    return {
	        title: title
	    };
	}
	
	function parseSlideSVG(svgElement) {
	    var shapes = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = Array.from(svgElement.childNodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var shapeNode = _step.value;
	
	            if (shapeNode.nodeType !== 1) {
	                continue;
	            }
	            var shapeObject = parseShape(shapeNode);
	            if (shapeObject) {
	                shapes.push(shapeObject);
	            }
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    return shapes;
	}
	
	function parseShape(shapeNode) {
	    var localName = shapeNode.localName;
	    var insperaClassName = shapeNode.getAttribute('inspera:className');
	
	    switch (true) {
	        case localName === 'g' && insperaClassName === _ShapeConstants2.default.BACKGROUND:
	            return parseBackground(shapeNode);
	
	        case localName === 'image' && insperaClassName === _ShapeConstants2.default.CHARACTER:
	            return parseCharacter(shapeNode);
	
	        case localName === 'image' && insperaClassName === _ShapeConstants2.default.IMAGE:
	            return parseImage(shapeNode);
	
	        case localName === 'rect':
	            return parseRectangle(shapeNode);
	
	        case localName === 'ellipse':
	            return parseEllipse(shapeNode);
	
	        case localName === 'line':
	            return parseLine(shapeNode);
	
	        case localName === 'path' && insperaClassName === _ShapeConstants2.default.CURVE:
	            return parseCurve(shapeNode);
	
	        case localName === 'path' && insperaClassName === _ShapeConstants2.default.FREEHAND:
	            return parseFreehand(shapeNode);
	
	        case localName === 'g' && insperaClassName === _ShapeConstants2.default.TEXTBOX:
	            return parseTextBox(shapeNode);
	
	        case localName === 'g' && insperaClassName === _ShapeConstants2.default.SPEAK_BUBBLE:
	            return parseSpeakBubble(shapeNode);
	
	        case localName === 'g' && insperaClassName === _ShapeConstants2.default.SCREAM_BUBBLE:
	            return parseScreamBubble(shapeNode);
	
	        case localName === 'g' && insperaClassName === _ShapeConstants2.default.THOUGHT_BUBBLE:
	            return parseThoughtBubble(shapeNode);
	    }
	}
	
	function offsetY() {
	    return 0;
	}
	
	function parseStroke(shapeNode) {
	    var stroke = shapeNode.getAttribute('stroke');
	    var strokeWidth = parseFloat(shapeNode.getAttribute('stroke-width'));
	    var strokeOpacity = parseFloat(shapeNode.getAttribute('stroke-opacity'));
	
	    return {
	        stroke: stroke,
	        strokeWidth: strokeWidth,
	        strokeOpacity: strokeOpacity
	    };
	}
	
	function parseFill(shapeNode) {
	    var fill = shapeNode.getAttribute('fill');
	    var fillOpacity = parseFloat(shapeNode.getAttribute('fill-opacity'));
	
	    fillOpacity = 1;
	
	    if (fill == undefined || fill == 'none') fill = '#ffffff';
	
	    return {
	        fill: fill,
	        fillOpacity: fillOpacity
	    };
	}
	
	function parseGenericShape(shapeNode) {
	    var x = parseFloat(shapeNode.getAttribute('x'));
	    var y = parseFloat(shapeNode.getAttribute('y')) + offsetY();
	    var width = parseFloat(shapeNode.getAttribute('width'));
	    var height = parseFloat(shapeNode.getAttribute('height'));
	    var opacity = parseFloat(shapeNode.getAttribute('opacity'));
	    var filter = shapeNode.getAttribute('filter');
	    var rotation = _SlideParserUtils2.default.getRotation(shapeNode.getAttribute('transform'));
	    var isLocked = shapeNode.getAttribute('inspera:isLocked');
	    var Z = Number(shapeNode.getAttribute('inspera:Z'));
	
	    var isSelected = false;
	
	    var strokeData = parseStroke(shapeNode);
	    var fillData = parseFill(shapeNode);
	
	    if (opacity == undefined || isNaN(opacity)) opacity = 1;
	
	    if (isLocked == undefined || isNaN(isLocked) || isLocked == '') isLocked = false;
	
	    var data = {
	        uuid: _uuid2.default.v4(),
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        opacity: opacity,
	        filter: filter,
	        rotation: rotation,
	        isLocked: isLocked,
	        Z: Z,
	        isSelected: isSelected
	    };
	
	    return Object.assign({}, strokeData, fillData, data);
	}
	
	function parseFreehand(shapeNode) {
	    var strokeData = parseStroke(shapeNode);
	    var type = _ShapeConstants2.default.FREEHAND;
	    var Z = Number(shapeNode.getAttribute('inspera:Z'));
	    var d = shapeNode.getAttribute('d');
	    var opacity = parseFloat(shapeNode.getAttribute('opacity'));
	    var filter = shapeNode.getAttribute('filter');
	    var isLocked = shapeNode.getAttribute('inspera:isLocked');
	    var rotation = _SlideParserUtils2.default.getRotation(shapeNode.getAttribute('transform'));
	
	    var isSelected = false;
	
	    var globalPathPoints = _SlideParserUtils2.default.dataToPoints(d);
	    var properties = _SlideParserUtils2.default.getFreehandSize(globalPathPoints);
	    var pathPoints = _SlideParserUtils2.default.converToLocalPathPoints(globalPathPoints, properties);
	    var x = properties.x;
	    var y = properties.y + offsetY();
	    var width = properties.width;
	    var height = properties.height;
	
	    var horizontalFlip = shapeNode.getAttribute('inspera:isHorizontalFlip') == 'true' ? -1 : 1;
	    var verticalFlip = shapeNode.getAttribute('inspera:isVerticalFlip') == 'true' ? -1 : 1;
	
	    if (opacity == undefined || isNaN(opacity)) opacity = 1;
	
	    var data = {
	        uuid: _uuid2.default.v4(),
	        type: type,
	        pathPoints: pathPoints,
	        Z: Z,
	        opacity: opacity,
	        filter: filter,
	        isLocked: isLocked,
	        rotation: rotation,
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        isSelected: isSelected,
	        horizontalFlip: horizontalFlip,
	        verticalFlip: verticalFlip
	    };
	
	    return Object.assign({}, strokeData, data);
	}
	
	function parseCurve(shapeNode) {
	    var strokeData = parseStroke(shapeNode);
	    var type = _ShapeConstants2.default.CURVE;
	    var Z = Number(shapeNode.getAttribute('inspera:Z'));
	    var d = shapeNode.getAttribute('d');
	    var opacity = parseFloat(shapeNode.getAttribute('opacity'));
	    var filter = shapeNode.getAttribute('filter');
	    var isLocked = shapeNode.getAttribute('inspera:isLocked');
	
	    var isSelected = false;
	
	    var pathPoints = _SlideParserUtils2.default.dataToToughtPoints(d);
	    var x1 = pathPoints[0].x;
	    var y1 = pathPoints[0].y + offsetY();
	    var x2 = pathPoints[2].x;
	    var y2 = pathPoints[2].y + offsetY();
	    var cx = pathPoints[1].x;
	    var cy = pathPoints[1].y + offsetY();
	
	    if (opacity == undefined || isNaN(opacity)) opacity = 1;
	
	    var data = {
	        uuid: _uuid2.default.v4(),
	        type: type,
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2,
	        cx: cx,
	        cy: cy,
	        Z: Z,
	        opacity: opacity,
	        filter: filter,
	        isLocked: isLocked,
	        isSelected: isSelected
	    };
	
	    return Object.assign({}, strokeData, data);
	}
	
	function parseLine(shapeNode) {
	    var strokeData = parseStroke(shapeNode);
	    var type = _ShapeConstants2.default.LINE;
	    var x1 = Number(shapeNode.getAttribute('x1'));
	    var y1 = Number(shapeNode.getAttribute('y1')) + offsetY();
	    var x2 = Number(shapeNode.getAttribute('x2'));
	    var y2 = Number(shapeNode.getAttribute('y2')) + offsetY();
	    var Z = Number(shapeNode.getAttribute('inspera:Z'));
	    var opacity = parseFloat(shapeNode.getAttribute('opacity'));
	    var filter = shapeNode.getAttribute('filter');
	    var isLocked = shapeNode.getAttribute('inspera:isLocked');
	
	    var isSelected = false;
	
	    if (opacity == undefined || isNaN(opacity)) opacity = 1;
	
	    var data = {
	        uuid: _uuid2.default.v4(),
	        type: type,
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2,
	        Z: Z,
	        opacity: opacity,
	        filter: filter,
	        isLocked: isLocked,
	        isSelected: isSelected
	    };
	
	    return Object.assign({}, strokeData, data);
	}
	
	function parseEllipse(shapeNode) {
	    var genericData = parseGenericShape(shapeNode);
	
	    var type = _ShapeConstants2.default.ELLIPSE;
	    var cx = Number(shapeNode.getAttribute('cx'));
	    var cy = Number(shapeNode.getAttribute('cy')) + offsetY();
	    var rx = Number(shapeNode.getAttribute('rx'));
	    var ry = Number(shapeNode.getAttribute('ry'));
	
	    var width = rx * 2;
	    var height = ry * 2;
	    var x = Number((cx - rx).toFixed(2));
	    var y = Number((cy - ry).toFixed(2));
	
	    var data = {
	        type: type,
	        rx: rx,
	        ry: ry,
	        cx: cx,
	        cy: cy,
	        x: x,
	        y: y,
	        width: width,
	        height: height
	    };
	
	    return Object.assign({}, genericData, data);
	}
	
	function parseTextBox(shapeNode) {
	    var textArea = shapeNode.getElementsByTagName('textArea')[0];
	    var rect = shapeNode.getElementsByTagName('rect')[0];
	
	    var x = parseFloat(textArea.getAttribute('x'));
	    var y = parseFloat(textArea.getAttribute('y')) + offsetY();
	    var width = parseFloat(textArea.getAttribute('width'));
	    var height = parseFloat(textArea.getAttribute('height'));
	
	    var type = _ShapeConstants2.default.TEXTBOX;
	    var opacity = parseFloat(shapeNode.getAttribute('opacity'));
	    var filter = shapeNode.getAttribute('filter');
	    var isLocked = shapeNode.getAttribute('inspera:isLocked');
	    var Z = shapeNode.getAttribute('inspera:Z');
	    var backgroundVisible = true;
	
	    var isSelected = false;
	
	    var strokeData = parseStroke(rect);
	    var fillData = parseFill(rect);
	    var textElements = _SlideParserUtils2.default.getTextProperties(textArea);
	
	    if (opacity == undefined || isNaN(opacity)) opacity = 1;
	
	    var data = {
	        uuid: _uuid2.default.v4(),
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        type: type,
	        opacity: opacity,
	        filter: filter,
	        isLocked: isLocked,
	        Z: Z,
	        backgroundVisible: backgroundVisible,
	        isSelected: isSelected
	    };
	
	    return Object.assign({}, strokeData, fillData, textElements, data);
	}
	
	function parseBubble(shapeNode) {
	    var textArea = shapeNode.getElementsByTagName('textArea')[0];
	    var path = shapeNode.getElementsByTagName('path')[0];
	
	    var strokeData = parseStroke(path);
	    var fillData = parseFill(path);
	
	    var x = parseFloat(textArea.getAttribute('x'));
	    var y = parseFloat(textArea.getAttribute('y')) + offsetY();
	    var width = parseFloat(textArea.getAttribute('width'));
	    var height = parseFloat(textArea.getAttribute('height'));
	
	    var opacity = parseFloat(shapeNode.getAttribute('opacity'));
	    var filter = shapeNode.getAttribute('filter');
	    var isLocked = shapeNode.getAttribute('inspera:isLocked');
	    var Z = shapeNode.getAttribute('inspera:Z');
	    var backgroundVisible = true;
	
	    var isSelected = false;
	
	    var cx = parseFloat(shapeNode.getAttribute('inspera:controlPointX'));
	    var cy = parseFloat(shapeNode.getAttribute('inspera:controlPointY'));
	    var textElements = _SlideParserUtils2.default.getTextProperties(textArea);
	
	    if (opacity == undefined || isNaN(opacity)) opacity = 1;
	
	    var data = {
	        uuid: _uuid2.default.v4(),
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        opacity: opacity,
	        filter: filter,
	        isLocked: isLocked,
	        Z: Z,
	        backgroundVisible: backgroundVisible,
	        cx: cx,
	        cy: cy,
	        isSelected: isSelected
	    };
	
	    return Object.assign({}, strokeData, fillData, textElements, data);
	}
	
	function parseSpeakBubble(shapeNode) {
	    var bubbleData = parseBubble(shapeNode);
	    var type = _ShapeConstants2.default.SPEAK_BUBBLE;
	
	    var data = {
	        type: type
	    };
	
	    return Object.assign({}, bubbleData, data);
	}
	
	function parseScreamBubble(shapeNode) {
	    var bubbleData = parseBubble(shapeNode);
	    var type = _ShapeConstants2.default.SCREAM_BUBBLE;
	
	    var data = {
	        type: type
	    };
	
	    return Object.assign({}, bubbleData, data);
	}
	
	function parseThoughtBubble(shapeNode) {
	    var bubbleData = parseBubble(shapeNode);
	    var type = _ShapeConstants2.default.THOUGHT_BUBBLE;
	
	    var data = {
	        type: type
	    };
	
	    return Object.assign({}, bubbleData, data);
	}
	
	function parseRectangle(shapeNode) {
	    var genericData = parseGenericShape(shapeNode);
	
	    var type = _ShapeConstants2.default.RECTANGLE;
	    var data = {
	        type: type
	    };
	
	    return Object.assign({}, genericData, data);
	}
	
	function parseImage(shapeNode) {
	    var genericData = parseGenericShape(shapeNode);
	
	    var type = _ShapeConstants2.default.IMAGE;
	    var logicalName = shapeNode.getAttribute('inspera:logicalName');
	    var horizontalFlip = shapeNode.getAttribute('inspera:isHorizontalFlip') == 'true' ? -1 : 1;
	    var verticalFlip = shapeNode.getAttribute('inspera:isVerticalFlip') == 'true' ? -1 : 1;
	
	    var imageType = shapeNode.getAttribute('inspera:imageType');
	    var src = shapeNode.getAttribute('inspera:src');
	
	    var host = '';
	
	    var contentItemId = shapeNode.getAttribute('inspera:contentItemId');
	    var xlinkHref = host + '/file/ci/' + contentItemId + '/img';
	
	    if (imageType && imageType.indexOf('swf') != -1 || src && src.indexOf('swf') != -1) xlinkHref = _AppParameters2.default.SVG_URL() + (logicalName + '_.svg');
	
	    genericData.fillOpacity = 0;
	
	    var imageData = {
	        type: type,
	        logicalName: logicalName,
	        xlinkHref: xlinkHref,
	        horizontalFlip: horizontalFlip,
	        verticalFlip: verticalFlip
	    };
	
	    return Object.assign({}, genericData, imageData);
	}
	
	function parseCharacter(shapeNode) {
	    var genericData = parseGenericShape(shapeNode);
	
	    var type = _ShapeConstants2.default.CHARACTER;
	    var logicalName = shapeNode.getAttribute('inspera:logicalName');
	    var frameLabel = shapeNode.getAttribute('inspera:frameLabel');
	    var xlinkHref = _AppParameters2.default.SVG_URL() + (logicalName + '_' + frameLabel + '.svg');
	    var horizontalFlip = shapeNode.getAttribute('inspera:isHorizontalFlip') == 'true' ? -1 : 1;
	    var verticalFlip = shapeNode.getAttribute('inspera:isVerticalFlip') == 'true' ? -1 : 1;
	
	    var moods = []; // TO DO: get correct moods
	    genericData.fillOpacity = 0;
	
	    var characterData = {
	        type: type,
	        logicalName: logicalName,
	        frameLabel: frameLabel,
	        xlinkHref: xlinkHref,
	        moods: moods,
	        horizontalFlip: horizontalFlip,
	        verticalFlip: verticalFlip
	    };
	
	    return Object.assign({}, genericData, characterData);
	}
	
	function parseBackground(shapeNode) {
	    var type = _ShapeConstants2.default.BACKGROUND;
	    var hotSpot = shapeNode.getAttribute('inspera:hotSpot');
	
	    var imageNode = shapeNode.getElementsByTagName('image')[0];
	    var logicalName = imageNode.getAttribute('inspera:logicalName');
	    var frameLabel = imageNode.getAttribute('inspera:frameLabel');
	    var xlinkHref = _AppParameters2.default.SVG_URL() + (logicalName + '_' + frameLabel + '.svg');
	
	    var fillRect = shapeNode.getElementsByTagName('rect')[0];
	    var fill = fillRect.getAttribute('fill');
	    var fillOpacity = Number(fillRect.getAttribute('fill-opacity'));
	
	    if (fillOpacity == undefined || fillOpacity == NaN) fillOpacity = 1;
	
	    var strokeRect = shapeNode.getElementsByTagName('rect')[1];
	    var stroke = strokeRect.getAttribute('stroke');
	    var strokeOpacity = Number(strokeRect.getAttribute('stroke-opacity'));
	    var strokeWidth = Number(strokeRect.getAttribute('stroke-width'));
	
	    var moods = []; // TO DO: get correct moods
	
	    return {
	        uuid: _uuid2.default.v4(),
	        type: type,
	        logicalName: logicalName,
	        frameLabel: frameLabel,
	        xlinkHref: xlinkHref,
	        hotSpot: hotSpot,
	        moods: moods,
	        fill: fill,
	        fillOpacity: fillOpacity,
	        stroke: stroke,
	        strokeOpacity: strokeOpacity,
	        strokeWidth: strokeWidth
	    };
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/parser/CartoonistSlideParser.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/parser/CartoonistSlideParser.js"); } } })();

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createSlideModel = createSlideModel;
	exports.loadNewContent = loadNewContent;
	exports.loadAudioContent = loadAudioContent;
	exports.loadOldContent = loadOldContent;
	exports.parseCartoonistXML = parseCartoonistXML;
	exports.parseStructureMetadata = parseStructureMetadata;
	
	var _xmldom = __webpack_require__(941);
	
	var _CartoonistSlideParser = __webpack_require__(866);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _uuid = __webpack_require__(68);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _SlidesUtils = __webpack_require__(125);
	
	var _SlidesUtils2 = _interopRequireDefault(_SlidesUtils);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _MasterUniverseUtils = __webpack_require__(40);
	
	var _MasterUniverseUtils2 = _interopRequireDefault(_MasterUniverseUtils);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	var _PlatformDetection = __webpack_require__(6);
	
	var _PlatformDetection2 = _interopRequireDefault(_PlatformDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setAudioEditorState(data) {
	    var dispatch = _StoreManager2.default.getStore().dispatch;
	
	    var newData = {};
	
	    newData.timelines = data.timelines;
	    newData.zoomValue = data.zoomValue;
	
	    dispatch((0, _AudioEditorActions.initTimelines)(newData));
	}
	
	function createSlideModel() {
	    var slide = {};
	    var backgroundModel = _CreateShapes2.default.createBackground();
	
	    slide.content = [backgroundModel];
	    slide.initialized = true;
	    slide.time = _Configuration2.default.SLIDE_DURATION;
	    slide.uuid = _uuid2.default.v4();
	    slide.contentItemId = -1; // contentItemId for sound
	    slide.sound = '';
	    slide.soundEffect = '';
	    slide.soundVolume = 0.5;
	    slide.soundEffectVolume = 0.5;
	
	    return slide;
	}
	
	function checkNodeStyle(shapeModel, parentNode) {
	    if (parentNode.childNodes && parentNode.childNodes.length > 0) {
	        var firstElement = parentNode.childNodes[0];
	
	        if (firstElement.style && firstElement.style['font-family']) shapeModel.fontFamily = firstElement.style['font-family'];
	
	        if (firstElement.style && firstElement.style['font-size']) shapeModel.fontSize = parseInt(firstElement.style['font-size']);
	
	        if (firstElement.style && firstElement.style['color']) shapeModel.fontColor = firstElement.style['color'];
	
	        if (firstElement.style && firstElement.style['font-weight']) shapeModel.fontBold = firstElement.style['font-weight'];
	
	        if (firstElement.style && firstElement.style['font-style']) shapeModel.fontItalic = firstElement.style['font-style'];
	
	        if (firstElement.style && firstElement.style['text-decoration-line']) shapeModel.fontUnderline = firstElement.style['text-decoration-line'];
	
	        if (firstElement.style && firstElement.style['text-align']) shapeModel.fontAlign = firstElement.style['text-align'];
	
	        checkNodeStyle(shapeModel, firstElement);
	    }
	}
	
	function convertNewTextShapeToOld(shapeModel) {
	    shapeModel.isRichText = undefined;
	
	    if (shapeModel.imageNode) {
	        shapeModel.imageNode = '';
	        shapeModel.aspectRatio = 1;
	    }
	
	    var divElement = document.createElement('div');
	
	    document.body.appendChild(divElement);
	
	    divElement.innerHTML = shapeModel.htmlText;
	
	    shapeModel.fontFamily = _TextEditorUtils2.default.currentFont;
	    shapeModel.fontSize = _TextEditorUtils2.default.currentFontSize;
	    shapeModel.fontAlign = 'left';
	    shapeModel.fontBold = false;
	    shapeModel.fontItalic = false;
	    shapeModel.fontUnderline = false;
	    shapeModel.fontColor = '#000000';
	
	    shapeModel.htmlText = divElement.innerText;
	
	    checkNodeStyle(shapeModel, divElement);
	
	    document.body.removeChild(divElement);
	
	    return shapeModel;
	}
	
	function checkForOldTextShapes(slides) {
	    if (_PlatformDetection2.default.isIOS()) {
	        var newSlides = [];
	
	        for (var i = 0; i < slides.length; i++) {
	            var currentSlide = slides[i];
	            var shapes = currentSlide.content;
	            var newShapes = [];
	
	            for (var j = 0; j < shapes.length; j++) {
	                var currentShape = shapes[j];
	
	                if (currentShape.isRichText) currentShape = convertNewTextShapeToOld(currentShape);
	
	                newShapes.push(currentShape);
	            }
	
	            currentSlide.content = newShapes;
	            newSlides.push(currentSlide);
	        }
	
	        return newSlides;
	    } else return slides;
	}
	
	function loadNewContent(data) {
	    var production = {};
	
	    if (data == undefined) {
	        var slide = createSlideModel();
	        production.title = _AppParameters2.default.title;
	        production.slides = [slide];
	    } else {
	        // added this one to fix a production
	        data = data.replace(/\n/g, "");
	        data = data.replace('"Triton"', "'Triton'");
	        data = data.replace('Kreuzer_"Bl', 'Kreuzer_Bl');
	        data = data.replace('cher".jpg', 'cher.jpg');
	
	        var wrongIndex = data.indexOf('#');
	
	        if (wrongIndex > 0 && wrongIndex < 40) data = data.replace('#', '');
	
	        data = JSON.parse(data);
	
	        var slides = data.slides;
	        _SlidesUtils2.default.updateFreehandData(slides);
	
	        if (!_AppParameters2.default.isMaster) {
	            if (data.theme) _AppParameters2.default.currentTheme = data.theme;
	
	            if (_AppParameters2.default.currentTheme != '') {
	                _MasterUniverseUtils2.default.checkCurrentUniverse();
	            }
	        }
	
	        production.slides = checkForOldTextShapes(slides);
	        production.storySoundVolume = data.storySoundVolume;
	        production.storySound = data.storySound;
	        production.hiddenAlerts = data.hiddenAlerts;
	        production.title = _AppParameters2.default.title;
	
	        if (data.currentFont && data.currentFont.length > 0) _TextEditorUtils2.default.currentFont = data.currentFont;
	
	        if (data.currentFontSize && data.currentFontSize.length > 0) _TextEditorUtils2.default.currentFontSize = parseInt(data.currentFontSize);
	
	        if (data.exportProperties) production.exportProperties = data.exportProperties;
	
	        if (data.audioEditor) setAudioEditorState(data.audioEditor);
	    }
	
	    return production;
	}
	
	function loadAudioContent(data) {
	    var production = {};
	
	    if (data == undefined) {
	        var slide = createSlideModel();
	        production.title = _AppParameters2.default.title;
	        production.slides = [slide];
	
	        setAudioEditorState(_PlayController2.default.getEmptyTimelines());
	    } else {
	        data = JSON.parse(data);
	
	        production.title = _AppParameters2.default.title;
	        production.slides = data.slides;
	
	        if (data.audioEditor) setAudioEditorState(data.audioEditor);
	    }
	
	    return production;
	}
	
	function loadOldContent() {
	    var state = _StoreManager2.default.getState();
	    var data;
	
	    if (state.production.data != undefined) data = unescape(state.production.data);
	
	    return parseCartoonistXML(data);
	}
	
	function parseCartoonistXML(xmlAsString) {
	    var slides;
	    var metadata;
	    var slide;
	
	    if (xmlAsString == undefined) {
	        metadata = { title: _AppParameters2.default.title };
	
	        slide = createSlideModel();
	        slides = { slides: [slide] };
	    } else {
	        var rootDocument = new _xmldom.DOMParser().parseFromString(xmlAsString, 'text/xml');
	        var cartoonistRootElement = rootDocument.getElementsByTagName('structureElement')[0];
	
	        if (cartoonistRootElement == undefined) {
	            metadata = { title: _AppParameters2.default.title };
	
	            slide = createSlideModel();
	            slides = { slides: [slide] };
	        } else {
	            metadata = parseStructureMetadata(cartoonistRootElement);
	            slides = parseSlides(cartoonistRootElement);
	        }
	    }
	
	    return Object.assign({}, metadata, slides);
	}
	
	function parseStructureMetadata(cartoonistRootElement) {
	    var title = cartoonistRootElement.getElementsByTagName('title')[0].textContent;
	
	    if (_SaveManager2.default.getContentItemId() < 0 && _AppParameters2.default.contentRevisionId < 0 && _AppParameters2.default.isIcsx == false) {// it's an exercise
	    } else {
	        _AppParameters2.default.title = title;
	    }
	
	    return {
	        title: title
	    };
	}
	
	function parseSlides(cartoonistRootElement) {
	    var slides = [];
	    var elements = cartoonistRootElement.getElementsByTagName('structureElement');
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	        for (var _iterator = Array.from(elements)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var element = _step.value;
	
	            var slideObject = (0, _CartoonistSlideParser.parseSlide)(element);
	
	            slideObject.uuid = _uuid2.default.v4();
	
	            slides.push(slideObject);
	        }
	    } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	    } finally {
	        try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	            }
	        } finally {
	            if (_didIteratorError) {
	                throw _iteratorError;
	            }
	        }
	    }
	
	    if (slides.length < 1) slides.push(createSlideModel());
	
	    return {
	        slides: slides
	    };
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/parser/CartoonistXMLParser.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/parser/CartoonistXMLParser.js"); } } })();

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.addClipartModel = addClipartModel;
	exports.setAccordionActiveButton = setAccordionActiveButton;
	exports.setMediaFilesDataProvider = setMediaFilesDataProvider;
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	
	    switch (action.type) {
	        case _AccordionActions.types.STATE_DRAW:
	            return Object.assign({}, state, { drawState: action.state });
	
	        case _AccordionActions.types.ADD_CLIPART_MODEL:
	            {
	                return addClipartModel(state, action.clipartModel);
	            }
	
	        case _AccordionActions.types.SET_ACCORDION_ACTIVE_BUTTON:
	            {
	                return setAccordionActiveButton(state, action.buttonType);
	            }
	
	        case _AccordionActions.types.SET_MEDIA_FILES_DATA_PROVIDER:
	            {
	                return setMediaFilesDataProvider(state, action.dataProvider);
	            }
	
	        case _AccordionActions.types.CHANGE_ACCORDION_WIDTH:
	            return Object.assign({}, state, { width: action.width });
	
	        case _AccordionActions.types.SET_ACTIVE_BUTTON:
	            return Object.assign({}, state, { activeButton: action.value }, { isCollapsed: action.isCollapsed });
	
	        case _AccordionActions.types.SET_OLD_ACTIVE_BUTTON:
	            return Object.assign({}, state, { oldActiveButton: action.value });
	
	        default:
	            return state;
	    }
	};
	
	var _AccordionActions = __webpack_require__(51);
	
	function addClipartModel(state, clipartModel) {
	    return Object.assign({}, state, {
	        clipartModel: clipartModel
	    });
	}
	
	function setAccordionActiveButton(state, buttonType) {
	    return Object.assign({}, state, {
	        accordionActiveButton: buttonType
	    });
	}
	
	function setMediaFilesDataProvider(state, dataProvider) {
	    return Object.assign({}, state, {
	        mediaFilesDataProvider: dataProvider
	    });
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/reducers/AccordionReducer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/reducers/AccordionReducer.js"); } } })();

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initTimelines = initTimelines;
	exports.changeTimelineVolume = changeTimelineVolume;
	exports.addRecordedDataIOS = addRecordedDataIOS;
	exports.changeTitle = changeTitle;
	exports.changeZoomValue = changeZoomValue;
	exports.showTrackMenu = showTrackMenu;
	exports.addAudioToTimeline = addAudioToTimeline;
	exports.setVolumePoints = setVolumePoints;
	exports.deleteItem = deleteItem;
	exports.updateSoundDuration = updateSoundDuration;
	exports.updateItem = updateItem;
	exports.selectElement = selectElement;
	exports.moveBlock = moveBlock;
	exports.dragAndCloneElement = dragAndCloneElement;
	exports.changeElementPosition = changeElementPosition;
	exports.changeSolo = changeSolo;
	exports.changeMute = changeMute;
	exports.addTrack = addTrack;
	exports.deleteTrack = deleteTrack;
	exports.setMarkerPosition = setMarkerPosition;
	exports.splitAudio = splitAudio;
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _AudioEditorActions.types.INIT_TIMELINES:
	            {
	                return initTimelines(state, action.content);
	            }
	
	        case _AudioEditorActions.types.SET_TIMELINE_WIDTH:
	            {
	                return Object.assign({}, state, { timelineWidth: action.width });
	            }
	
	        case _AudioEditorActions.types.CHANGE_VOLUME:
	            {
	                return Object.assign({}, state, { volume: action.volume });
	            }
	
	        case _AudioEditorActions.types.CHANGE_TIMELINE_VOLUME:
	            {
	                return changeTimelineVolume(state, action.index, action.volume);
	            }
	
	        case _AudioEditorActions.types.RECORDED_DATA_IOS:
	            {
	                return addRecordedDataIOS(state, action.data);
	            }
	
	        case _AudioEditorActions.types.CHANGE_TITLE:
	            {
	                return changeTitle(state, action.index, action.title);
	            }
	
	        case _AudioEditorActions.types.CHANGE_ZOOM:
	            {
	                return changeZoomValue(state, action.value);
	            }
	
	        case _AudioEditorActions.types.ADD_AUDIO_TO_TIMELINE:
	            {
	                return addAudioToTimeline(state, action.index, action.audio);
	            }
	
	        case _AudioEditorActions.types.SELECT_ELEMENT:
	            {
	                return selectElement(state, action.uuid, action.value);
	            }
	
	        case _AudioEditorActions.types.DRAG_AND_CLONE_ELEMENT:
	            {
	                return dragAndCloneElement(state, action.properties);
	            }
	
	        case _AudioEditorActions.types.CHANGE_ELEMENT_POSITION:
	            {
	                return changeElementPosition(state, action.properties);
	            }
	
	        case _AudioEditorActions.types.MOVE_BLOCK:
	            {
	                return moveBlock(state, action.array, action.offsetX, action.indexOffset);
	            }
	
	        case _AudioEditorActions.types.CHANGE_SOLO:
	            {
	                return changeSolo(state, action.index);
	            }
	
	        case _AudioEditorActions.types.CHANGE_MUTE:
	            {
	                return changeMute(state, action.index);
	            }
	
	        case _AudioEditorActions.types.DELETE_ITEM:
	            {
	                return deleteItem(state, action.uuid);
	            }
	
	        case _AudioEditorActions.types.UPDATE_ITEM:
	            {
	                return updateItem(state, action.uuids, action.href);
	            }
	
	        case _AudioEditorActions.types.UPDATE_SOUND_DURATION:
	            {
	                return updateSoundDuration(state, action.uuid, action.duration);
	            }
	
	        case _AudioEditorActions.types.SET_MARKER_POSITION:
	            {
	                return setMarkerPosition(state, action.position);
	            }
	
	        case _AudioEditorActions.types.SPLIT_AUDIO:
	            {
	                return splitAudio(state, action.audio, action.markerPosition);
	            }
	
	        case _AudioEditorActions.types.AUDIO_EDITOR_UNDO_REDO:
	            {
	                return audioEditorUndoRedo(state, action.newState);
	            }
	
	        case _AudioEditorActions.types.SET_VOLUME_POINTS:
	            {
	                return setVolumePoints(state, action.uuid, action.points);
	            }
	
	        case _AudioEditorActions.types.SHOW_TRACK_MENU:
	            {
	                return showTrackMenu(state, action.value);
	            }
	
	        case _AudioEditorActions.types.ADD_TRACK:
	            {
	                return addTrack(state, action.index);
	            }
	
	        case _AudioEditorActions.types.DELETE_TRACK:
	            {
	                return deleteTrack(state, action.index);
	            }
	
	        case _AudioEditorActions.types.REFRESH_AUDIO_TRACK:
	            {
	                return Object.assign({}, state, { refreshAudioTrack: action.value });
	            }
	
	        case _AudioEditorActions.types.REFRESH_AUDIO_ELEMENTS:
	            {
	                return Object.assign({}, state, { refreshAudioElements: action.value });
	            }
	
	        default:
	            return state;
	    }
	};
	
	var _AudioEditorActions = __webpack_require__(41);
	
	var _AudioEditorUtils = __webpack_require__(14);
	
	var _AudioEditorUtils2 = _interopRequireDefault(_AudioEditorUtils);
	
	var _uuid = __webpack_require__(68);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _PlayController = __webpack_require__(17);
	
	var _PlayController2 = _interopRequireDefault(_PlayController);
	
	var _TimelineDragManager = __webpack_require__(137);
	
	var _TimelineDragManager2 = _interopRequireDefault(_TimelineDragManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initTimelines(state, audioEditorState) {
	    if (audioEditorState) {
	        return Object.assign({}, state, _AudioEditorUtils2.default.checkAudioControlPoints(audioEditorState));
	    } else {
	        var timelines = state.timelines;
	
	        if (timelines == undefined) timelines = _PlayController2.default.getEmptyTimelines();
	
	        return Object.assign({}, state, {
	            timelines: timelines
	        });
	    }
	}
	
	function changeTimelineVolume(state, index, volume) {
	    var timelines = state.timelines;
	    var soloIndex = _AudioEditorUtils2.default.getSoloIndex();
	
	    var newTimelines = timelines.map(function (timeline) {
	        var newTimeline = Object.assign({}, timeline);
	
	        if (newTimeline.index == index) {
	            newTimeline.volume = volume;
	            newTimeline.isMute = false;
	        }
	
	        if (soloIndex >= 0 && soloIndex != index) {
	            // a track it's Solo and the current changed volume is for other track than the SOLO one
	            newTimeline.isSolo = false; // make all tracks unSolo
	        }
	
	        return newTimeline;
	    });
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function addRecordedDataIOS(state, data) {
	    var timelines = state.timelines;
	
	    var newTimelines = timelines.map(function (timeline) {
	        var newTimeline = Object.assign({}, timeline);
	
	        if (newTimeline.index == 0) {
	            newTimeline.recordedDataIos = data;
	        }
	
	        return newTimeline;
	    });
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function changeTitle(state, index, title) {
	    var timelines = state.timelines;
	
	    var newTimelines = timelines.map(function (timeline) {
	        var newTimeline = Object.assign({}, timeline);
	
	        if (newTimeline.index == index) newTimeline.title = title;
	
	        return newTimeline;
	    });
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function changeZoomValue(state, value) {
	    return Object.assign({}, state, {
	        zoomValue: value
	    });
	}
	
	function showTrackMenu(state, value) {
	    return Object.assign({}, state, {
	        trackMenu: value
	    });
	}
	
	function addAudioToTimeline(state, index, audio) {
	    var timelines = state.timelines;
	    var i;
	    var newTimelines = [];
	    var item;
	
	    if (audio.duration > 0) item = audio;else item = _AudioEditorUtils2.default.getSlideItem(audio);
	
	    if (_PlayController2.default.isAudioEditorMode()) _AudioEditorUtils2.default.animationId = item.uuid;
	
	    for (i = 0; i < timelines.length; i++) {
	        var newTimeline = Object.assign({}, timelines[i]);
	        var newAudios = [];
	
	        newTimeline.isSelected = false;
	
	        for (var j = 0; j < newTimeline.audios.length; j++) {
	            var audioItem = Object.assign({}, newTimeline.audios[j]);
	
	            if (audioItem.uuid != item.uuid) {
	                if (i == index && item.left == audioItem.left) {
	                    // remove the old item
	                } else {
	                    audioItem.showControlPoint = false;
	                    newAudios.push(audioItem);
	                }
	            }
	        }
	
	        if (i == index) {
	            item.showControlPoint = true;
	            _AudioEditorUtils2.default.ensureHasContentItem(item);
	
	            newAudios.push(item);
	            newTimeline.isSelected = true;
	        }
	
	        newTimeline.audios = newAudios;
	
	        newTimelines.push(newTimeline);
	    }
	
	    _AudioEditorUtils2.default.updateMarker();
	    _PlayController2.default.updateAudioElements();
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function setVolumePoints(state, uuid, points) {
	    var timelines = state.timelines;
	    var i;
	    var j;
	    var newTimelines = [];
	
	    for (i = 0; i < timelines.length; i++) {
	        var newTimeline = Object.assign({}, timelines[i]);
	        var audios = timelines[i].audios;
	        var newAudios = [];
	
	        for (j = 0; j < audios.length; j++) {
	            var audio = Object.assign({}, audios[j]);
	
	            if (audio.uuid == uuid) audio.points = points;
	
	            newAudios.push(audio);
	        }
	
	        newTimeline.audios = newAudios;
	        newTimelines.push(newTimeline);
	    }
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function deleteItem(state, uuid) {
	    var timelines = state.timelines;
	    var i;
	    var j;
	    var newTimelines = [];
	    var currentItem;
	
	    if (timelines == undefined) return Object.assign({}, state);
	
	    for (i = 0; i < timelines.length; i++) {
	        var newTimeline = Object.assign({}, timelines[i]);
	        var audios = timelines[i].audios;
	        var newAudios = [];
	
	        newTimeline.isSelected = false;
	
	        for (j = 0; j < audios.length; j++) {
	            var audio = Object.assign({}, audios[j]);
	
	            if (uuid) {
	                if (audio.uuid == uuid) {
	                    currentItem = audio;
	                } else {
	                    newAudios.push(audio);
	                }
	            } else {
	                if (audio.showControlPoint == true) {
	                    if (document.activeElement.id.indexOf('audioItemElement') != -1) {
	                        if (document.activeElement.id != 'audioItemElement_' + audio.uuid) newAudios.push(audio);else currentItem = audio;
	                    } else currentItem = audio;
	                } else {
	                    newAudios.push(audio);
	                }
	            }
	        }
	
	        newTimeline.audios = newAudios;
	        newTimelines.push(newTimeline);
	    }
	
	    _AudioEditorUtils2.default.updateMarker();
	    _PlayController2.default.updateAudioElements();
	
	    var markerLastPosition = _AudioEditorUtils2.default.getTimelinesMaxPosition(newTimelines);
	
	    if (currentItem && markerLastPosition < currentItem.left + currentItem.duration) {
	        return Object.assign({}, state, {
	            timelines: newTimelines,
	            markerPosition: markerLastPosition
	        });
	    } else {
	        return Object.assign({}, state, {
	            timelines: newTimelines
	        });
	    }
	}
	
	function updateSoundDuration(state, uuid, duration) {
	    // change the href for the item when a recording is done: change blob url with the correct one from the server
	    var timelines = state.timelines;
	    var i;
	    var j;
	    var newTimelines = [];
	
	    if (timelines == undefined) return Object.assign({}, state);
	
	    for (i = 0; i < timelines.length; i++) {
	        var newTimeline = Object.assign({}, timelines[i]);
	        var audios = timelines[i].audios;
	        var newAudios = [];
	
	        for (j = 0; j < audios.length; j++) {
	            var audio = Object.assign({}, audios[j]);
	
	            if (audio && audio.uuid == uuid && duration > 0 && duration != audio.duration) {
	                audio.duration = duration;
	            }
	
	            newAudios.push(audio);
	        }
	
	        newTimeline.audios = newAudios;
	        newTimelines.push(newTimeline);
	    }
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function updateItem(state, uuids, newHref) {
	    // change the href for the item when a recording is done: change blob url with the correct one from the server
	    var timelines = state.timelines;
	    var i;
	    var j;
	    var newTimelines = [];
	
	    if (timelines == undefined) return Object.assign({}, state);
	
	    for (i = 0; i < timelines.length; i++) {
	        var newTimeline = Object.assign({}, timelines[i]);
	        var audios = timelines[i].audios;
	        var newAudios = [];
	
	        for (j = 0; j < audios.length; j++) {
	            var audio = Object.assign({}, audios[j]);
	
	            if (audio && uuids && newHref && uuids.indexOf(audio.uuid) != -1) {
	                audio.href = newHref;
	                _AudioEditorUtils2.default.ensureHasContentItem(audio);
	            }
	
	            newAudios.push(audio);
	        }
	
	        newTimeline.audios = newAudios;
	        newTimelines.push(newTimeline);
	    }
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function selectElement(state, uuid, value) {
	    var timelines = state.timelines;
	    var i;
	    var j;
	    var newTimelines = [];
	
	    for (i = 0; i < timelines.length; i++) {
	        var newTimeline = Object.assign({}, timelines[i]);
	        var audios = timelines[i].audios;
	        var newAudios = [];
	        var currentAudio = undefined;
	
	        newTimeline.isSelected = false;
	
	        for (j = 0; j < audios.length; j++) {
	            var audio = Object.assign({}, audios[j]);
	
	            if (audio.uuid == uuid) {
	                audio.showControlPoint = value;
	                currentAudio = audio;
	                newTimeline.isSelected = true;
	            } else {
	                audio.showControlPoint = false;
	                newAudios.push(audio);
	            }
	        }
	
	        if (currentAudio) newAudios.push(currentAudio);
	
	        newTimeline.audios = newAudios;
	        newTimelines.push(newTimeline);
	    }
	
	    _AudioEditorUtils2.default.updateMarker();
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function moveBlock(state, array, offsetX, indexOffset) {
	    var timelines = state.timelines;
	    var i;
	    var j;
	    var newTimelines = [];
	    var newTimeline;
	    var block = [];
	    var newAudios = [];
	    var audios;
	    var selectedTrack = -1;
	
	    for (i = 0; i < timelines.length; i++) {
	        newTimeline = Object.assign({}, timelines[i]);
	        audios = newTimeline.audios;
	        newAudios = [];
	        var removedItems = [];
	
	        if (newTimeline.isSelected) selectedTrack = i + indexOffset;
	
	        for (j = 0; j < audios.length; j++) {
	            var audio = Object.assign({}, audios[j]);
	
	            if (array.indexOf(audio.uuid) != -1) {
	                audio.left = _TimelineDragManager2.default.originalPositions[audio.uuid].left + offsetX;
	                removedItems.push(audio);
	            } else newAudios.push(audio);
	        }
	
	        if (removedItems.length > 0) block[i + indexOffset] = removedItems;
	
	        newTimeline.isSelected = false;
	        newTimeline.audios = newAudios;
	
	        newTimelines.push(newTimeline);
	    }
	
	    var finalTimelines = [];
	
	    for (i = 0; i < newTimelines.length; i++) {
	        newTimeline = newTimelines[i];
	
	        if (i == selectedTrack) newTimeline.isSelected = true;
	
	        if (block[i]) {
	            newTimeline.audios = newTimeline.audios.concat(block[i]);
	        }
	
	        finalTimelines.push(newTimeline);
	    }
	
	    return Object.assign({}, state, {
	        timelines: finalTimelines
	    });
	}
	
	function dragAndCloneElement(state, properties) {
	    var currentTimelines = JSON.parse(JSON.stringify(state.timelines));
	    var i;
	    var j;
	    var newTimelines = [];
	    var newTimeline;
	    var currentAudio;
	
	    for (i = 0; i < currentTimelines.length; i++) {
	        if (properties.startIndex == i) {
	            newTimeline = Object.assign({}, currentTimelines[i]);
	            var audios = currentTimelines[i].audios;
	            var newAudios = [];
	
	            for (j = 0; j < audios.length; j++) {
	                var audio = Object.assign({}, audios[j]);
	
	                if (audio.uuid == properties.audio.uuid) {
	                    currentAudio = Object.assign({}, audios[j]);
	
	                    currentAudio.uuid = _uuid2.default.v4();
	                    currentAudio.showControlPoint = true;
	                    audio.showControlPoint = false;
	
	                    if (properties.audio.left >= 0) currentAudio.left = properties.audio.left;
	                }
	
	                newAudios.push(audio);
	            }
	
	            newTimeline.isSelected = false;
	            newTimeline.audios = newAudios;
	
	            newTimelines.push(newTimeline);
	        } else {
	            newTimelines.push(currentTimelines[i]);
	        }
	    }
	
	    var endTimelines = [];
	
	    if (currentAudio) {
	        for (i = 0; i < newTimelines.length; i++) {
	            if (properties.endIndex == i) {
	                newTimeline = Object.assign({}, newTimelines[i]);
	                _AudioEditorUtils2.default.ensureHasContentItem(currentAudio);
	                newTimeline.audios.push(currentAudio);
	
	                newTimeline.isSelected = true;
	                endTimelines.push(newTimeline);
	            } else {
	                endTimelines.push(newTimelines[i]);
	            }
	        }
	
	        newTimelines = endTimelines;
	    }
	
	    _AudioEditorUtils2.default.updateMarker();
	    _PlayController2.default.updateAudioElements();
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function changeElementPosition(state, properties) {
	    var currentTimelines = JSON.parse(JSON.stringify(state.timelines));
	    var i;
	    var j;
	    var newTimelines = [];
	    var newTimeline;
	    var currentAudio;
	
	    for (i = 0; i < currentTimelines.length; i++) {
	        if (properties.startIndex == i) {
	            newTimeline = Object.assign({}, currentTimelines[i]);
	            var audios = currentTimelines[i].audios;
	            var newAudios = [];
	
	            for (j = 0; j < audios.length; j++) {
	                var audio = Object.assign({}, audios[j]);
	
	                if (audio.uuid == properties.audio.uuid) {
	                    if (properties.audio.left >= 0) audio.left = properties.audio.left;
	
	                    if (audio.points) audio.points = _AudioEditorUtils2.default.updateVolumePoints(audio.points, audio.inPoint, properties.audio.inPoint, audio.outPoint, properties.audio.outPoint, properties.audio.duration);
	
	                    if (properties.audio.inPoint >= 0) audio.inPoint = properties.audio.inPoint;
	
	                    if (properties.audio.outPoint >= 0) audio.outPoint = properties.audio.outPoint;
	
	                    audio.duration = properties.audio.duration;
	
	                    if (!properties.isKeyboardAction) audio.showControlPoint = true;
	
	                    currentAudio = audio;
	                } else newAudios.push(audio);
	            }
	
	            newTimeline.isSelected = false;
	            newTimeline.audios = newAudios;
	
	            newTimelines.push(newTimeline);
	        } else {
	            newTimelines.push(currentTimelines[i]);
	        }
	    }
	
	    var endTimelines = [];
	
	    if (currentAudio) {
	        for (i = 0; i < newTimelines.length; i++) {
	            if (properties.endIndex == i) {
	                newTimeline = Object.assign({}, newTimelines[i]);
	                _AudioEditorUtils2.default.ensureHasContentItem(currentAudio);
	                newTimeline.audios.push(currentAudio);
	
	                if (!properties.isKeyboardAction) newTimeline.isSelected = true;
	
	                endTimelines.push(newTimeline);
	            } else {
	                endTimelines.push(newTimelines[i]);
	            }
	        }
	
	        newTimelines = endTimelines;
	    }
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function changeSolo(state, index) {
	    var timelines = state.timelines;
	    var i;
	    var newTimelines = [];
	
	    for (i = 0; i < timelines.length; i++) {
	        var newTimeline = Object.assign({}, timelines[i]);
	
	        if (i == index) {
	            if (newTimeline.isSolo == true) newTimeline.isSolo = false;else newTimeline.isSolo = true;
	        } else {
	            newTimeline.isSolo = false;
	        }
	
	        newTimelines.push(newTimeline);
	    }
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function changeMute(state, index) {
	    var timelines = state.timelines;
	    var i;
	    var newTimelines = [];
	
	    for (i = 0; i < timelines.length; i++) {
	        var newTimeline = Object.assign({}, timelines[i]);
	
	        if (i == index) {
	            if (newTimeline.isMute == true) newTimeline.isMute = false;else newTimeline.isMute = true;
	        }
	
	        newTimelines.push(newTimeline);
	    }
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function addTrack(state, currentIndex) {
	    var timelines = state.timelines;
	    var i;
	    var newTimelines = [];
	    var newTimeline = { index: currentIndex + 1, volume: 1.0, audios: [] };
	    var maxTimelines = _AudioEditorUtils2.default.getMaxTimelines();
	
	    if (timelines.length >= maxTimelines) return Object.assign({}, state);
	
	    for (i = 0; i < timelines.length; i++) {
	        var timeline = Object.assign({}, timelines[i]);
	
	        if (i > currentIndex) {
	            timeline.index = timeline.index + 1;
	        }
	
	        newTimelines.push(timeline);
	
	        if (i == currentIndex) newTimelines.push(newTimeline);
	    }
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function deleteTrack(state, currentIndex) {
	    var timelines = state.timelines;
	    var i;
	    var newTimelines = [];
	    var emptyTimeline = { index: 0, volume: 1.0, audios: [] };
	
	    if (timelines.length == 1) {
	        newTimelines.push(emptyTimeline);
	    } else {
	        for (i = 0; i < timelines.length; i++) {
	            var timeline = Object.assign({}, timelines[i]);
	
	            if (i > currentIndex) {
	                timeline.index = timeline.index - 1;
	            }
	
	            if (i != currentIndex) newTimelines.push(timeline);
	        }
	    }
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function setMarkerPosition(state, position) {
	    return Object.assign({}, state, { markerPosition: position });
	}
	
	function splitAudio(state, target, markerPosition) {
	    var timelines = state.timelines;
	    var i;
	    var j;
	    var newTimelines = [];
	
	    for (i = 0; i < timelines.length; i++) {
	        var newTimeline = Object.assign({}, timelines[i]);
	        var audios = newTimeline.audios;
	        var newAudios = [];
	        var leftItem;
	        var rightItem;
	
	        for (j = 0; j < audios.length; j++) {
	            var audio = Object.assign({}, audios[j]);
	
	            if (audio.uuid == target.uuid) {
	                leftItem = Object.assign({}, audio);
	                leftItem.duration = markerPosition - audio.left;
	                leftItem.uuid = _uuid2.default.v4();
	                leftItem.showControlPoint = true;
	                leftItem.points = undefined;
	                _AudioEditorUtils2.default.ensureHasContentItem(leftItem);
	
	                if (audio.outPoint >= 0) leftItem.outPoint = audio.outPoint + (audio.left + audio.duration) - markerPosition;else leftItem.outPoint = audio.left + audio.duration - markerPosition;
	
	                rightItem = Object.assign({}, audio);
	                rightItem.duration = audio.left + audio.duration - markerPosition;
	                rightItem.left = audio.left + leftItem.duration;
	                rightItem.uuid = _uuid2.default.v4();
	                rightItem.showControlPoint = false;
	                rightItem.points = undefined;
	                _AudioEditorUtils2.default.ensureHasContentItem(rightItem);
	
	                if (rightItem.inPoint >= 0) rightItem.inPoint = audio.inPoint + leftItem.duration;else rightItem.inPoint = leftItem.duration;
	
	                if (audio.points && audio.points.length > 1) {
	                    var controlPoints = _AudioEditorUtils2.default.getControlPointsForSplitItems(audio.points, leftItem.duration);
	
	                    leftItem.points = controlPoints.left;
	                    rightItem.points = controlPoints.right;
	                }
	            } else {
	                newAudios.push(audio);
	            }
	        }
	
	        if (leftItem && rightItem) {
	            newAudios.push(leftItem);
	            newAudios.push(rightItem);
	
	            leftItem = undefined;
	            rightItem = undefined;
	        }
	
	        newTimeline.audios = newAudios;
	        newTimelines.push(newTimeline);
	    }
	
	    _PlayController2.default.updateAudioElements(10);
	
	    return Object.assign({}, state, {
	        timelines: newTimelines
	    });
	}
	
	function audioEditorUndoRedo(state, appState) {
	    var newState = appState.audioEditor;
	
	    _PlayController2.default.updateAudioElements();
	
	    return Object.assign({}, state, newState);
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/reducers/AudioEditorReducer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/reducers/AudioEditorReducer.js"); } } })();

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.animate = animate;
	exports.updateShapeRotation = updateShapeRotation;
	exports.updateTransformToolProperties = updateTransformToolProperties;
	exports.updateNonRectangularShape = updateNonRectangularShape;
	exports.changeShapesPosition = changeShapesPosition;
	exports.setNewShapePosition = setNewShapePosition;
	exports.moveShape = moveShape;
	exports.updateStem = updateStem;
	exports.updateBubbleControlPoint = updateBubbleControlPoint;
	exports.selectShapesFromArea = selectShapesFromArea;
	exports.selectShape = selectShape;
	exports.changeInteractionState = changeInteractionState;
	exports.createGroup = createGroup;
	exports.ungroup = ungroup;
	exports.createShape = createShape;
	exports.changeVideoProperties = changeVideoProperties;
	exports.changeBackgroundContent = changeBackgroundContent;
	exports.selectLastAddedShape = selectLastAddedShape;
	exports.updateTextHeight = updateTextHeight;
	exports.updateCurrentSlideIndex = updateCurrentSlideIndex;
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _CurrentSlideActions.types.SET_CURRENT_SLIDE:
	            {
	                _AnimationManager2.default.updateCurrentTime();
	
	                return Object.assign({}, state, {
	                    currentSlideIndex: action.currentSlideIndex,
	                    updateThumbnail: false,
	                    model: action.currentSlideModel
	                });
	            }
	
	        case _CurrentSlideActions.types.UPDATE_CURRENT_SLIDE_INDEX:
	            {
	                return updateCurrentSlideIndex(state, action.slideUid);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_SHAPE_POSITION:
	            {
	                return setNewShapePosition(state, action.uuid, action.newX, action.newY);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_SHAPE_SIZE:
	            {
	                return updateTransformToolProperties(state, action.uuid, action.newWidth, action.newHeight, action.x, action.y, action.horizontalFlip, action.verticalFlip, action.cx, action.cy, action.cx1, action.cy1, action.cx2, action.cy2, action.cx3, action.cy3, action.cx4, action.cy4, action.cx5, action.cy5);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_SHAPE_ROTATION:
	            {
	                return updateShapeRotation(state, action.uuid, action.newRotation);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_NON_RECTANGULAR_SHAPE:
	            {
	                return updateNonRectangularShape(state, action.uuid, action.x1, action.y1, action.x2, action.y2, action.cx, action.cy);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_BUBBLE_CONTROL_POINT:
	            {
	                return updateBubbleControlPoint(state, action.uuid, action.cx, action.cy, action.pointType);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_STEM:
	            {
	                return updateStem(state, action.uuid, action.value);
	            }
	
	        case _CurrentSlideActions.types.SELECT_SHAPE:
	            {
	                return selectShape(state, action.uuid, action.isNew);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_INTERACTION_STATE:
	            {
	                return changeInteractionState(state, action.uuid, action.newState, action.moveState);
	            }
	
	        case _CurrentSlideActions.types.CREATE_SHAPE:
	            {
	                return createShape(state, action.shapeModel);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_BACKGROUND_CONTENT:
	            {
	                return changeBackgroundContent(state, action.newContent);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_CURRENT_SLIDE_THUMBNAIL:
	            {
	                return updateCurrentSlideThumbnail(state, action.value);
	            }
	
	        case _CurrentSlideActions.types.DUPLICATE_SHAPE:
	            {
	                return duplicateShape(state, action.model);
	            }
	
	        case _CurrentSlideActions.types.DELETE_SHAPES:
	            {
	                return deleteShape(state, action.models);
	            }
	
	        case _CurrentSlideActions.types.LOCK_SHAPE:
	            {
	                return lockShape(state, action.shapeModel);
	            }
	
	        case _CurrentSlideActions.types.ADD_VIDEO_SHAPE_DURATION:
	            {
	                return addVideoShapeDuration(state, action.shapeModel, action.duration);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_VIDEO_SHAPE:
	            {
	                return updateVideoShape(state, action.uuid);
	            }
	
	        case _CurrentSlideActions.types.INIT_SLIDE:
	            {
	                return initSlide(state);
	            }
	
	        case _CurrentSlideActions.types.BRING_TO_FRONT:
	            {
	                return bringToFront(state, action.shapeModel);
	            }
	
	        case _CurrentSlideActions.types.SEND_TO_BACK:
	            {
	                return sendToBack(state, action.shapeModel);
	            }
	
	        case _CurrentSlideActions.types.BRING_FORWARD:
	            {
	                return bringForward(state, action.shapeModel);
	            }
	
	        case _CurrentSlideActions.types.SEND_BACKWARD:
	            {
	                return sendBackward(state, action.shapeModel);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_FILTER:
	            {
	                return changeFilter(state, action.shapeModel, action.filter);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_SLIDE_DURATION:
	            {
	                return changeSlideDuration(state, action.duration);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_ALTERNATIVE_TEXT:
	            {
	                return changeAlternativeText(state, action.text);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_STROKE_SIZE:
	            {
	                return changeStrokeSize(state, action.shapeModel, action.strokeSize);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_SHAPE_OPACITY:
	            {
	                return changeShapeOpacity(state, action.shapeModel, action.opacity);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_SHAPE_STROKE_OPACITY:
	            {
	                return changeShapeStrokeOpacity(state, action.shapeModel, action.opacity);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_SHAPE_FILL_COLOR:
	            {
	                return changeShapeFillColor(state, action.shapeModel, action.color);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_SHAPE_STROKE_COLOR:
	            {
	                return changeShapeStrokeColor(state, action.shapeModel, action.color);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_TEXT_PROPERTIES:
	            {
	                return changeTextProperties(state, action.shapeModel, action.propertyType, action.newValue, action.isRichText);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_RICH_TEXT_CONTENT:
	            {
	                return changeRichTextContent(state, action.uuid, action.value);
	            }
	
	        case _CurrentSlideActions.types.SET_SHORTCUTS_TARGET:
	            {
	                return setShortcutsTarget(state, action.isSlideCommand);
	            }
	
	        case _CurrentSlideActions.types.MOVE_SHAPE:
	            {
	                return moveShape(state, action.uuid, action.offsetX, action.offsetY);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_TEXT_PROPERTIES:
	            {
	                return updateTextProperties(state, action.shapeModel, action.propertyType, action.stepOffset);
	            }
	
	        case _CurrentSlideActions.types.SET_CLONE_TARGET:
	            {
	                return setCloneTarget(state, action.shapeModel);
	            }
	
	        case _CurrentSlideActions.types.CANVAS_UNDO_REDO_ACTION:
	            {
	                return canvasUndoRedoAction(state, action.newState);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_MOOD:
	            {
	                return changeMood(state, action.uuid, action.frameLabel);
	            }
	
	        case _CurrentSlideActions.types.SELECT_LAST_ADDED_SHAPE:
	            {
	                return selectLastAddedShape(state);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_TEXT_HEIGHT:
	            {
	                return updateTextHeight(state, action.uuid, action.newHeight, action.newWidth);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_SHAPE_FILL_VISIBILITY:
	            {
	                return changeShapeFillVisibility(state, action.uuid, action.isFillVisible);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_IS_NEW_SHAPE:
	            {
	                return changeIsNewShape(state, action.uuid, action.isNew);
	            }
	
	        case _CurrentSlideActions.types.OLD_TEXT_RESIZED:
	            {
	                return oldTextResized(state, action.uuid);
	            }
	
	        case _CurrentSlideActions.types.SET_SLIDE_SOUND:
	            {
	                return setSlideSound(state, action.sound);
	            }
	
	        case _CurrentSlideActions.types.SET_SLIDE_SOUND_EFFECT:
	            {
	                return setSlideSoundEffect(state, action.sound);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_CURRENT_SLIDE_MOODS:
	            {
	                return updateCurrentSlideMoods(state);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_IMAGE_HEIGHT:
	            {
	                return updateImageHeight(state, action.uuid, action.newHeight, action.updateWidth);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_IMAGE_SIZE:
	            {
	                return updateImageSize(state, action.uuid, action.newWidth, action.newHeight);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_IMAGE_SIZE_WHEN_CHANGE_MOOD:
	            {
	                return updateImageSizeWhenChangeMood(state, action.uuid, action.originalWidth, action.originalHeight);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_HOTSPOT:
	            {
	                return updateHotspot(state, action.uuid, action.hotspot);
	            }
	
	        case _CurrentSlideActions.types.INSERT_IMAGE_NODE:
	            {
	                return insertImageNode(state, action.uuid, action.href, action.aspectRatio);
	            }
	
	        case _CurrentSlideActions.types.UPDATE_CROPPING_HOTSPOT:
	            {
	                return updateCroppingHotspot(state, action.uuid, action.hotspot);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_SHAPES_POSITION:
	            {
	                return changeShapesPosition(state, action.positions);
	            }
	
	        case _CurrentSlideActions.types.SELECT_SHAPES_FROM_AREA:
	            {
	                return selectShapesFromArea(state, action.selection);
	            }
	
	        case _CurrentSlideActions.types.CREATE_GROUP:
	            {
	                return createGroup(state, action.groupModel);
	            }
	
	        case _CurrentSlideActions.types.UNGROUP:
	            {
	                return ungroup(state, action.groupModel, action.shapes);
	            }
	
	        case _CurrentSlideActions.types.ADD_ANIMATION:
	            {
	                return addAnimation(state, action.uuid, action.animation);
	            }
	
	        case _CurrentSlideActions.types.REMOVE_ANIMATION:
	            {
	                return removeAnimation(state, action.uuid);
	            }
	
	        case _CurrentSlideActions.types.ANIMATE:
	            {
	                return animate(state, action.shapes, action.animations);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_FLIP:
	            {
	                return changeFlip(state, action.uuid, action.flipType);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_VIDEO_PROPERTIES:
	            {
	                return changeVideoProperties(state, action.property, action.value);
	            }
	
	        case _CurrentSlideActions.types.CHANGE_SLIDE_SOUND_VOLUME:
	            return changeSlideSoundVolume(state, action.volume, action.isSoundEffect);
	
	        case _CurrentSlideActions.types.CHANGE_SHAPE_TYPE:
	            return changeShapeType(state, action.uuid, action.value);
	
	        case _CurrentSlideActions.types.CHANGE_TEXT_LINE_HEIGHT:
	            return changeTextLineHeight(state, action.uuid, action.value);
	
	        default:
	            return state;
	    }
	};
	
	var _CurrentSlideActions = __webpack_require__(11);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _uuid = __webpack_require__(68);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MoodsUtils = __webpack_require__(124);
	
	var _MoodsUtils2 = _interopRequireDefault(_MoodsUtils);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _SelectionManager = __webpack_require__(62);
	
	var _SelectionManager2 = _interopRequireDefault(_SelectionManager);
	
	var _AudioUtils = __webpack_require__(56);
	
	var _AudioUtils2 = _interopRequireDefault(_AudioUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	var _BubblesUtils = __webpack_require__(235);
	
	var _BubblesUtils2 = _interopRequireDefault(_BubblesUtils);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	var _Properties = __webpack_require__(3);
	
	var _Properties2 = _interopRequireDefault(_Properties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContent(state, uuid) {
	    var clone = _AnimationManager2.default.getCloneByUid(uuid);
	
	    if (_AnimationManager2.default.clone && clone) return [clone];
	
	    if (_AnimationManager2.default.clone && _AnimationManager2.default.clone.uuid == uuid) return [_AnimationManager2.default.clone];else return state.model.content;
	}
	
	function animate(state, shapes, animations) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shapes.indexOf(shape.uuid) != -1) {
	            var newShape = Object.assign({}, shape);
	            var animation = animations[shape.uuid];
	
	            if (shape.type == _ShapeConstants2.default.LINE || shape.type == _ShapeConstants2.default.CURVE) {
	                if (animation.x1) newShape.x1 = animation.x1;
	
	                if (animation.y1) newShape.y1 = animation.y1;
	
	                if (animation.x2) newShape.x2 = animation.x2;
	
	                if (animation.y2) newShape.y2 = animation.y2;
	
	                if (shape.type == _ShapeConstants2.default.CURVE) {
	                    if (animation.cx) newShape.cx = animation.cx;
	
	                    if (animation.cy) newShape.cy = animation.cy;
	                }
	            } else {
	                if (animation.x) newShape.x = animation.x;
	
	                if (animation.y) newShape.y = animation.y;
	
	                var oldWidth = newShape.width;
	                var oldHeight = newShape.height;
	
	                if (_AnimationManager2.default.isScaleAnimation(newShape)) {
	                    if (animation.width) newShape.animationWidth = animation.width;
	
	                    if (animation.height) newShape.animationHeight = animation.height;
	                } else {
	                    if (animation.width) newShape.width = animation.width;
	
	                    if (animation.height) newShape.height = animation.height;
	                }
	
	                if (shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                    if (animation.cx) newShape.cx = animation.cx;
	
	                    if (animation.cy) newShape.cy = animation.cy;
	
	                    if (animation.cx1) newShape.cx1 = animation.cx1;
	
	                    if (animation.cy1) newShape.cy1 = animation.cy1;
	
	                    if (animation.cx2) newShape.cx2 = animation.cx2;
	
	                    if (animation.cy2) newShape.cy2 = animation.cy2;
	
	                    if (animation.cx3) newShape.cx3 = animation.cx3;
	
	                    if (animation.cy3) newShape.cy3 = animation.cy3;
	
	                    if (animation.cx4) newShape.cx4 = animation.cx4;
	
	                    if (animation.cy4) newShape.cy4 = animation.cy4;
	
	                    if (animation.cx5) newShape.cx5 = animation.cx5;
	
	                    if (animation.cy5) newShape.cy5 = animation.cy5;
	                }
	
	                if (shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.TEXTBOX || shape.type == _ShapeConstants2.default.TEXTBOXSIMPLE) newShape.fontSize = animation.fontSize;else if (shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                    if (!_AnimationManager2.default.isScaleAnimation(shape)) newShape.fontSize = animation.fontSize;
	                }
	
	                if (newShape.type == _ShapeConstants2.default.GROUP) updateGroupShapesSize(newShape, oldWidth, newShape.width, oldHeight, newShape.height, false);
	            }
	
	            if (animation.opacity >= 0) newShape.opacity = animation.opacity;
	
	            if (animation.rotation >= 0) newShape.rotation = animation.rotation;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function removeAnimation(state, uuid) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.animation = undefined;
	            newShape.opacity = 1.0;
	            newShape.rotation = 0;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function addAnimation(state, uuid, animation) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            if (!animation) {
	                newShape.animation = undefined;
	                return newShape;
	            }
	
	            if (!(animation.start_opacity >= 0)) animation.start_opacity = 1;
	
	            if (!(animation.end_opacity >= 0)) animation.end_opacity = 1;
	
	            if (!(animation.start_rotation >= 0)) animation.start_rotation = 0;
	
	            if (!(animation.end_rotation >= 0)) animation.end_rotation = 0;
	
	            newShape.animation = animation;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeShapeOpacity(state, shapeModel, opacity) {
	    var clone = _AnimationManager2.default.getCloneByUid(shapeModel.uuid);
	
	    if (!clone) clone = _AnimationManager2.default.clone;
	
	    if (clone && shapeModel.uuid === clone.uuid) {
	        var newShape = Object.assign({}, clone);
	        newShape.opacity = opacity;
	
	        _AnimationManager2.default.replaceClone(newShape);
	    }
	
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === shapeModel.uuid) {
	            var _newShape = Object.assign({}, shape);
	
	            _newShape.opacity = opacity;
	
	            if (_newShape.animation) setAnimationStartProperties(_newShape);
	
	            if (_AnimationManager2.default.target && _newShape.uuid === _AnimationManager2.default.target.uuid) _AnimationManager2.default.target = _newShape;
	
	            return _newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateShapeRotation(state, uuid, newRotation) {
	    var content = getContent(state, uuid);
	    var clone = void 0;
	
	    var newContent = content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            if (newRotation < 0) newRotation = 360 + newRotation;
	
	            newShape.rotation = newRotation;
	
	            if (_AnimationManager2.default.isAnimationMode()) {
	                clone = _AnimationManager2.default.getCloneByUid(newShape.uuid);
	
	                if (!clone) clone = _AnimationManager2.default.clone;
	
	                if (clone && newShape.uuid === clone.uuid) _AnimationManager2.default.replaceClone(newShape);
	
	                if (_AnimationManager2.default.target && _AnimationManager2.default.target.uuid == uuid) _AnimationManager2.default.target = newShape;
	            } else {
	                if (newShape.animation) setAnimationStartProperties(newShape);
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    clone = _AnimationManager2.default.getCloneByUid(uuid);
	
	    if (!clone) clone = _AnimationManager2.default.clone;
	
	    if (clone && clone.uuid == uuid) newContent = state.model.content;
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function generateNewPathPoints(pathPoints, oldWidth, newWidth, oldHeight, newHeight) {
	    var i = void 0;
	    var length = pathPoints.length;
	    var newPathPoints = [];
	
	    for (i = 0; i < length; i++) {
	        newPathPoints.push({ x: pathPoints[i].x * newWidth / oldWidth, y: pathPoints[i].y * newHeight / oldHeight });
	    }
	
	    return newPathPoints;
	}
	
	function updateCurrentSlideMoods(state) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.type === _ShapeConstants2.default.BACKGROUND || shape.type == _ShapeConstants2.default.CHARACTER) {
	            var newShape = Object.assign({}, shape);
	            newShape.moods = _MoodsUtils2.default.getMoods(newShape.logicalName);
	
	            if (newShape.type == _ShapeConstants2.default.BACKGROUND && newShape.moods && newShape.moods.length > 0) {
	                if (newShape.logicalName != undefined && newShape.logicalName.length > 0 && (newShape.frameLabel == undefined || newShape.frameLabel.length < 1)) newShape.frameLabel = 'dag';
	                newShape.xlinkHref = _AppParameters2.default.SVG_URL() + (newShape.logicalName + '_' + newShape.frameLabel + '.svg');
	                newShape.hotSpot = '';
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateHotspot(state, uuid, hotspot) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.type === _ShapeConstants2.default.BACKGROUND && shape.uuid == uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.hotSpot = hotspot;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function insertImageNode(state, uuid, href, aspectRatio) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid == uuid) {
	            var newShape = Object.assign({}, shape);
	
	            var imageHeight = shape.height - 2 * _Properties2.default.TEXT_INNER_PADDING;
	            var imageWidth = void 0;
	            var newShapeWidth = void 0;
	
	            if (shape.imageNode && shape.imageNode.length > 0) {
	                // the shape already has an image node
	                imageWidth = imageHeight * shape.aspectRatio;
	                newShapeWidth = shape.width - imageWidth - _Properties2.default.TEXT_INNER_PADDING; // the shape width after removing image
	
	                if (href && href.length > 0) {
	                    // replace the shape
	                    imageWidth = imageHeight * aspectRatio; // new image width
	                    newShapeWidth = newShapeWidth + imageWidth + _Properties2.default.TEXT_INNER_PADDING; // resize width after adding the new image
	                }
	            } else {
	                imageWidth = imageHeight * aspectRatio;
	                newShapeWidth = shape.width + imageWidth + _Properties2.default.TEXT_INNER_PADDING;
	            }
	
	            newShape.width = newShapeWidth;
	            newShape.imageNode = href;
	            newShape.aspectRatio = aspectRatio;
	
	            return newShape;
	        }
	
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeFlip(state, uuid, flipType) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid == uuid) {
	            var newShape = Object.assign({}, shape);
	
	            if (flipType == 'horizontalFlip') {
	                if (!newShape.horizontalFlip || newShape.horizontalFlip == 1) newShape.horizontalFlip = -1;else newShape.horizontalFlip = 1;
	            } else {
	                if (!newShape.verticalFlip || newShape.verticalFlip == 1) newShape.verticalFlip = -1;else newShape.verticalFlip = 1;
	            }
	
	            return newShape;
	        }
	
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateCroppingHotspot(state, uuid, hotspot) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid == uuid) {
	            var newShape = Object.assign({}, shape);
	            var x1, x2, y1, y2;
	
	            if (newShape.hotSpot != undefined && newShape.hotSpot != '') {
	                // update hotspot for a shape with already hotspot
	                var realWidth = shape.width * 100 / (shape.hotSpot.x2 - shape.hotSpot.x1);
	                var realHeight = shape.height * 100 / (shape.hotSpot.y2 - shape.hotSpot.y1);
	
	                x1 = realWidth * shape.hotSpot.x1 / 100;
	                y1 = realHeight * shape.hotSpot.y1 / 100;
	                x2 = realWidth * shape.hotSpot.x2 / 100;
	                y2 = realHeight * shape.hotSpot.y2 / 100;
	
	                var realShapeSize = {};
	                realShapeSize.width = realWidth;
	                realShapeSize.height = realHeight;
	                realShapeSize.x = shape.x - x1;
	                realShapeSize.y = shape.y - y1;
	
	                if (hotspot == '') {
	                    // remove hotspot
	                    newShape.x = realShapeSize.x;
	                    newShape.y = realShapeSize.y;
	                    newShape.width = realShapeSize.width;
	                    newShape.height = realShapeSize.height;
	                    newShape.hotSpot = '';
	
	                    newShape.isCropAndFlipHorizontal = false;
	                    newShape.isCropAndFlipVertical = false;
	                } else {
	                    // add a new hotspot
	                    newShape.hotSpot = hotspot;
	
	                    x1 = realShapeSize.width * hotspot.x1 / 100;
	                    y1 = realShapeSize.height * hotspot.y1 / 100;
	                    x2 = realShapeSize.width * hotspot.x2 / 100;
	                    y2 = realShapeSize.height * hotspot.y2 / 100;
	
	                    newShape.x = realShapeSize.x + x1;
	                    newShape.y = realShapeSize.y + y1;
	                    newShape.width = x2 - x1;
	                    newShape.height = y2 - y1;
	
	                    if (newShape.horizontalFlip == -1) newShape.isCropAndFlipHorizontal = true;else newShape.isCropAndFlipHorizontal = false;
	
	                    if (newShape.verticalFlip == -1) newShape.isCropAndFlipVertical = true;else newShape.isCropAndFlipVertical = false;
	                }
	            } else {
	                // add hotspot first time for the original shape
	                if (hotspot == '') newShape.hotSpot = '';else {
	                    newShape.hotSpot = hotspot;
	
	                    var x1 = shape.width * hotspot.x1 / 100;
	                    var y1 = shape.height * hotspot.y1 / 100;
	                    var x2 = shape.width * hotspot.x2 / 100;
	                    var y2 = shape.height * hotspot.y2 / 100;
	
	                    newShape.x = shape.x + x1;
	                    newShape.y = shape.y + y1;
	                    newShape.width = x2 - x1;
	                    newShape.height = y2 - y1;
	
	                    if (newShape.horizontalFlip == -1) newShape.isCropAndFlipHorizontal = true;else newShape.isCropAndFlipHorizontal = false;
	
	                    if (newShape.verticalFlip == -1) newShape.isCropAndFlipVertical = true;else newShape.isCropAndFlipVertical = false;
	                }
	            }
	            return newShape;
	        }
	
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateGroupShapesSize(shapeGroup, oldWidth, newWidth, oldHeight, newHeight) {
	    var updatePath = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
	
	    var i;
	    var shape;
	    var shapes = shapeGroup.shapes;
	    var newGroupedShapes = [];
	    var widthScale = newWidth / oldWidth;
	    var heightScale = newHeight / oldHeight;
	
	    for (i = 0; i < shapes.length; i++) {
	        shape = Object.assign({}, shapes[i]);
	
	        switch (shape.type) {
	            case _ShapeConstants2.default.LINE:
	                {
	                    shape.x1 = shape.x1 * widthScale;
	                    shape.y1 = shape.y1 * heightScale;
	                    shape.x2 = shape.x2 * widthScale;
	                    shape.y2 = shape.y2 * heightScale;
	                    break;
	                }
	
	            case _ShapeConstants2.default.CURVE:
	                {
	                    shape.x1 = shape.x1 * widthScale;
	                    shape.y1 = shape.y1 * heightScale;
	                    shape.x2 = shape.x2 * widthScale;
	                    shape.y2 = shape.y2 * heightScale;
	                    shape.cx = shape.cx * widthScale;
	                    shape.cy = shape.cy * heightScale;
	                    break;
	                }
	
	            default:
	                {
	                    var oldW = shape.width;
	                    var oldH = shape.height;
	
	                    shape.x = shape.x * widthScale;
	                    shape.y = shape.y * heightScale;
	                    shape.width = shape.width * widthScale;
	                    shape.height = shape.height * heightScale;
	
	                    if (shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                        shape.cx = shape.cx * widthScale;
	                        shape.cy = shape.cy * heightScale;
	
	                        if (shape.cx1) {
	                            shape.cx1 = shape.cx1 * widthScale;
	                            shape.cy1 = shape.cy1 * heightScale;
	                        }
	
	                        if (shape.cx2) {
	                            shape.cx2 = shape.cx2 * widthScale;
	                            shape.cy2 = shape.cy2 * heightScale;
	                        }
	
	                        if (shape.cx3) {
	                            shape.cx3 = shape.cx3 * widthScale;
	                            shape.cy3 = shape.cy3 * heightScale;
	                        }
	
	                        if (shape.cx4) {
	                            shape.cx4 = shape.cx4 * widthScale;
	                            shape.cy4 = shape.cy4 * heightScale;
	                        }
	
	                        if (shape.cx5) {
	                            shape.cx5 = shape.cx5 * widthScale;
	                            shape.cy5 = shape.cy5 * heightScale;
	                        }
	
	                        if (updatePath) shape.path = undefined;
	                    }
	
	                    if (shape.type == _ShapeConstants2.default.FREEHAND) {
	                        var points = shape.pathPoints;
	                        var j;
	
	                        for (j = 0; j < points.length; j++) {
	                            points[j].x = points[j].x * widthScale;
	                            points[j].y = points[j].y * heightScale;
	                        }
	                    }
	
	                    if (shape.type == _ShapeConstants2.default.GROUP) updateGroupShapesSize(shape, oldW, shape.width, oldH, shape.height);
	                    break;
	                }
	        }
	
	        newGroupedShapes.push(shape);
	    }
	
	    shapeGroup.shapes = newGroupedShapes;
	}
	
	function updateTransformToolProperties(state, uuid, newWidth, newHeight, x, y, horizontalFlip, verticalFlip, cx, cy, cx1, cy1, cx2, cy2, cx3, cy3, cx4, cy4, cx5, cy5) {
	    var content = getContent(state, uuid);
	    var clone = void 0;
	
	    var newContent = content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	            var oldWidth = newShape.width;
	            var oldHeight = newShape.height;
	            newShape.width = newWidth;
	            newShape.height = newHeight;
	            newShape.x = x;
	            newShape.y = y;
	
	            if (horizontalFlip != undefined) newShape.horizontalFlip = horizontalFlip;
	
	            if (verticalFlip != undefined) newShape.verticalFlip = verticalFlip;
	
	            if (shape.type == _ShapeConstants2.default.FREEHAND) {
	                newShape.pathPoints = generateNewPathPoints(newShape.pathPoints, oldWidth, newShape.width, oldHeight, newShape.height);
	            } else if (shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                newShape.path = undefined;
	            }
	
	            if (cx != undefined && cy != undefined) {
	                newShape.cx = cx;
	                newShape.cy = cy;
	
	                if (cx1 && cy1) {
	                    newShape.cx1 = cx1;
	                    newShape.cy1 = cy1;
	                }
	
	                if (cx2 && cy2) {
	                    newShape.cx2 = cx2;
	                    newShape.cy2 = cy2;
	                }
	
	                if (cx3 && cy3) {
	                    newShape.cx3 = cx3;
	                    newShape.cy3 = cy3;
	                }
	
	                if (cx4 && cy4) {
	                    newShape.cx4 = cx4;
	                    newShape.cy4 = cy4;
	                }
	
	                if (cx5 && cy5) {
	                    newShape.cx5 = cx5;
	                    newShape.cy5 = cy5;
	                }
	
	                if (newShape.type == _ShapeConstants2.default.SCREAM_BUBBLE || newShape.type == _ShapeConstants2.default.SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE) newShape.path = undefined;
	            }
	
	            if (newShape.type == _ShapeConstants2.default.GROUP) updateGroupShapesSize(newShape, oldWidth, newWidth, oldHeight, newHeight);
	
	            if (newShape.type === _ShapeConstants2.default.VIDEO) {
	                if (newShape.x < 0) newShape.x = 0;
	
	                if (newShape.x + newShape.width > _Configuration2.default.CANVAS_WIDTH) newShape.x = _Configuration2.default.CANVAS_WIDTH - newShape.width;
	
	                if (newShape.y < 0) newShape.y = 0;
	
	                if (newShape.y + newShape.height > _Configuration2.default.CANVAS_HEIGHT) newShape.y = _Configuration2.default.CANVAS_HEIGHT - newShape.height;
	            }
	
	            if (_AnimationManager2.default.isAnimationMode()) {
	                clone = _AnimationManager2.default.getCloneByUid(newShape.uuid);
	
	                if (!clone) clone = _AnimationManager2.default.clone;
	
	                if (clone && newShape.uuid === clone.uuid) _AnimationManager2.default.replaceClone(newShape);
	
	                if (_AnimationManager2.default.target && _AnimationManager2.default.target.uuid == uuid) _AnimationManager2.default.target = newShape;
	            } else {
	                if (newShape.animation) setAnimationStartProperties(newShape);
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    clone = _AnimationManager2.default.getCloneByUid(uuid);
	
	    if (!clone) clone = _AnimationManager2.default.clone;
	
	    if (clone && clone.uuid == uuid) newContent = state.model.content;
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateNonRectangularShape(state, uuid, x1, y1, x2, y2, cx, cy) {
	    var content = getContent(state, uuid);
	    var clone = void 0;
	
	    var newContent = content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	            newShape.x1 = x1;
	            newShape.y1 = y1;
	            newShape.x2 = x2;
	            newShape.y2 = y2;
	
	            if (shape.type == _ShapeConstants2.default.CURVE) {
	                newShape.cx = cx;
	                newShape.cy = cy;
	            }
	
	            if (_AnimationManager2.default.isAnimationMode()) {
	                clone = _AnimationManager2.default.getCloneByUid(newShape.uuid);
	
	                if (!clone) clone = _AnimationManager2.default.clone;
	
	                if (clone && newShape.uuid === clone.uuid) _AnimationManager2.default.replaceClone(newShape);
	
	                if (_AnimationManager2.default.target && _AnimationManager2.default.target.uuid == uuid) _AnimationManager2.default.target = newShape;
	            } else {
	                if (newShape.animation) setAnimationStartProperties(newShape);
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    clone = _AnimationManager2.default.getCloneByUid(uuid);
	
	    if (!clone) clone = _AnimationManager2.default.clone;
	
	    if (clone && clone.uuid == uuid) newContent = state.model.content;
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeShapesPosition(state, positions) {
	    var newContent = state.model.content.map(function (shape) {
	        if (positions[shape.uuid]) {
	            var newShape = Object.assign({}, shape);
	            var position = positions[shape.uuid];
	
	            if (shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                newShape.cx = newShape.cx + (position.x - newShape.x);
	                newShape.cy = newShape.cy + (position.y - newShape.y);
	
	                if (newShape.cx1) {
	                    newShape.cx1 = newShape.cx1 + (position.x - newShape.x);
	                    newShape.cy1 = newShape.cy1 + (position.y - newShape.y);
	                }
	
	                if (newShape.cx2) {
	                    newShape.cx2 = newShape.cx2 + (position.x - newShape.x);
	                    newShape.cy2 = newShape.cy2 + (position.y - newShape.y);
	                }
	
	                if (newShape.cx3) {
	                    newShape.cx3 = newShape.cx3 + (position.x - newShape.x);
	                    newShape.cy3 = newShape.cy3 + (position.y - newShape.y);
	                }
	
	                if (newShape.cx4) {
	                    newShape.cx4 = newShape.cx4 + (position.x - newShape.x);
	                    newShape.cy4 = newShape.cy4 + (position.y - newShape.y);
	                }
	
	                if (newShape.cx5) {
	                    newShape.cx5 = newShape.cx5 + (position.x - newShape.x);
	                    newShape.cy5 = newShape.cy5 + (position.y - newShape.y);
	                }
	            }
	
	            if (shape.type == _ShapeConstants2.default.LINE || shape.type == _ShapeConstants2.default.CURVE) {
	                newShape.x1 = position.x1;
	                newShape.y1 = position.y1;
	                newShape.x2 = position.x2;
	                newShape.y2 = position.y2;
	
	                if (shape.type == _ShapeConstants2.default.CURVE) {
	                    newShape.cx = position.cx;
	                    newShape.cy = position.cy;
	                }
	            } else {
	                newShape.x = position.x;
	                newShape.y = position.y;
	            }
	
	            return newShape;
	        }
	
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function setAnimationStartProperties(shape) {
	    var animationObject = JSON.parse(JSON.stringify(shape.animation));
	
	    if (shape.animation.start_x !== undefined) animationObject.start_x = shape.x;
	
	    if (shape.animation.start_y !== undefined) animationObject.start_y = shape.y;
	
	    if (shape.animation.start_width !== undefined) animationObject.start_width = shape.width;
	
	    if (shape.animation.start_height !== undefined) animationObject.start_height = shape.height;
	
	    if (shape.animation.start_x1 !== undefined) animationObject.start_x1 = shape.x1;
	
	    if (shape.animation.start_y1 !== undefined) animationObject.start_y1 = shape.y1;
	
	    if (shape.animation.start_x2 !== undefined) animationObject.start_x2 = shape.x2;
	
	    if (shape.animation.start_y2 !== undefined) animationObject.start_y2 = shape.y2;
	
	    if (shape.animation.start_cx !== undefined) animationObject.start_cx = shape.cx;
	
	    if (shape.animation.start_cy !== undefined) animationObject.start_cy = shape.cy;
	
	    if (shape.animation.start_opacity !== undefined) animationObject.start_opacity = shape.opacity;
	
	    if (shape.animation.start_rotation !== undefined) animationObject.start_rotation = shape.rotation;
	
	    if (shape.animation.start_cx1 !== undefined) animationObject.start_cx1 = shape.cx1;
	
	    if (shape.animation.start_cy1 !== undefined) animationObject.start_cy1 = shape.cy1;
	
	    if (shape.animation.start_cx2 !== undefined) animationObject.start_cx2 = shape.cx2;
	
	    if (shape.animation.start_cy2 !== undefined) animationObject.start_cy2 = shape.cy2;
	
	    if (shape.animation.start_cx3 !== undefined) animationObject.start_cx3 = shape.cx3;
	
	    if (shape.animation.start_cy3 !== undefined) animationObject.start_cy3 = shape.cy3;
	
	    if (shape.animation.start_cx4 !== undefined) animationObject.start_cx4 = shape.cx4;
	
	    if (shape.animation.start_cy4 !== undefined) animationObject.start_cy4 = shape.cy4;
	
	    if (shape.animation.start_cx5 !== undefined) animationObject.start_cx5 = shape.cx5;
	
	    if (shape.animation.start_cy5 !== undefined) animationObject.start_cy5 = shape.cy5;
	
	    shape.animation = animationObject;
	}
	
	function setNewShapePosition(state, uuid, newX, newY) {
	    var content = getContent(state, uuid);
	    var clone = void 0;
	
	    var newContent = content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            if (shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                newShape.cx = newShape.cx + (newX - newShape.x);
	                newShape.cy = newShape.cy + (newY - newShape.y);
	
	                if (shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE) {
	                    if (newShape.cx1 && newShape.cy1) {
	                        newShape.cx1 = newShape.cx1 + (newX - newShape.x);
	                        newShape.cy1 = newShape.cy1 + (newY - newShape.y);
	                    }
	
	                    if (newShape.cx2 && newShape.cy2) {
	                        newShape.cx2 = newShape.cx2 + (newX - newShape.x);
	                        newShape.cy2 = newShape.cy2 + (newY - newShape.y);
	                    }
	
	                    if (newShape.cx3 && newShape.cy3) {
	                        newShape.cx3 = newShape.cx3 + (newX - newShape.x);
	                        newShape.cy3 = newShape.cy3 + (newY - newShape.y);
	                    }
	
	                    if (newShape.cx4 && newShape.cy4) {
	                        newShape.cx4 = newShape.cx4 + (newX - newShape.x);
	                        newShape.cy4 = newShape.cy4 + (newY - newShape.y);
	                    }
	
	                    if (newShape.cx5 && newShape.cy5) {
	                        newShape.cx5 = newShape.cx5 + (newX - newShape.x);
	                        newShape.cy5 = newShape.cy5 + (newY - newShape.y);
	                    }
	                }
	            }
	
	            var isPositionChanged = newShape.x != newX || newShape.y != newY;
	
	            newShape.x = newX;
	            newShape.y = newY;
	
	            if (newShape.type === _ShapeConstants2.default.VIDEO) {
	                if (newShape.x < 0) newShape.x = 0;
	
	                if (newShape.x + newShape.width > _Configuration2.default.CANVAS_WIDTH) newShape.x = _Configuration2.default.CANVAS_WIDTH - newShape.width;
	
	                if (newShape.y < 0) newShape.y = 0;
	
	                if (newShape.y + newShape.height > _Configuration2.default.CANVAS_HEIGHT) newShape.y = _Configuration2.default.CANVAS_HEIGHT - newShape.height;
	            }
	
	            if (_AnimationManager2.default.isAnimationMode()) {
	                clone = _AnimationManager2.default.getCloneByUid(newShape.uuid);
	
	                if (!clone) clone = _AnimationManager2.default.clone;
	
	                if (clone && newShape.uuid === clone.uuid) _AnimationManager2.default.replaceClone(newShape);
	
	                if (_AnimationManager2.default.target && _AnimationManager2.default.target.uuid == uuid) _AnimationManager2.default.target = newShape;
	            } else {
	                if (newShape.animation && isPositionChanged) setAnimationStartProperties(newShape);
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    clone = _AnimationManager2.default.getCloneByUid(uuid);
	
	    if (!clone) clone = _AnimationManager2.default.clone;
	
	    if (clone && clone.uuid == uuid) newContent = state.model.content;
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function moveShape(state, uuid, offsetX, offsetY) {
	    var content = getContent(state, uuid);
	    var clone = void 0;
	
	    var newContent = content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            if (shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                newShape.cx = newShape.cx + offsetX;
	                newShape.cy = newShape.cy + offsetY;
	
	                if (newShape.cx1) {
	                    newShape.cx1 = newShape.cx1 + offsetX;
	                    newShape.cy1 = newShape.cy1 + offsetY;
	                }
	
	                if (newShape.cx2) {
	                    newShape.cx2 = newShape.cx2 + offsetX;
	                    newShape.cy2 = newShape.cy2 + offsetY;
	                }
	
	                if (newShape.cx3) {
	                    newShape.cx3 = newShape.cx3 + offsetX;
	                    newShape.cy3 = newShape.cy3 + offsetY;
	                }
	
	                if (newShape.cx4) {
	                    newShape.cx4 = newShape.cx4 + offsetX;
	                    newShape.cy4 = newShape.cy4 + offsetY;
	                }
	
	                if (newShape.cx5) {
	                    newShape.cx5 = newShape.cx5 + offsetX;
	                    newShape.cy5 = newShape.cy5 + offsetY;
	                }
	            }
	
	            newShape.x = newShape.x + offsetX;
	            newShape.y = newShape.y + offsetY;
	
	            if (_AnimationManager2.default.isAnimationMode()) {
	                clone = _AnimationManager2.default.getCloneByUid(newShape.uuid);
	
	                if (!clone) clone = _AnimationManager2.default.clone;
	
	                if (clone && newShape.uuid === clone.uuid) _AnimationManager2.default.replaceClone(newShape);
	
	                if (_AnimationManager2.default.target && _AnimationManager2.default.target.uuid == uuid) _AnimationManager2.default.target = newShape;
	            }
	
	            return newShape;
	        }
	
	        return shape;
	    });
	
	    clone = _AnimationManager2.default.getCloneByUid(uuid);
	
	    if (!clone) clone = _AnimationManager2.default.clone;
	
	    if (clone && clone.uuid == uuid) newContent = state.model.content;
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateStem(state, uuid, type) {
	    var content = getContent(state, uuid);
	
	    var newContent = content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            if (type == 'add') {
	                var newPoint = _BubblesUtils2.default.getNewControlPoint(newShape);
	
	                if (newShape.cx2 == undefined) {
	                    newShape.cx2 = newPoint.x;
	                    newShape.cy2 = newPoint.y;
	                } else if (newShape.cx3 == undefined) {
	                    newShape.cx3 = newPoint.x;
	                    newShape.cy3 = newPoint.y;
	                } else if (newShape.cx4 == undefined) {
	                    newShape.cx4 = newPoint.x;
	                    newShape.cy4 = newPoint.y;
	                } else if (newShape.cx5 == undefined) {
	                    newShape.cx5 = newPoint.x;
	                    newShape.cy5 = newPoint.y;
	                }
	            } else if (type == 'delete') {
	                if (newShape.cx5 != undefined) {
	                    newShape.cx5 = undefined;
	                    newShape.cx5 = undefined;
	                } else if (newShape.cx4 != undefined) {
	                    newShape.cx5 = undefined;
	                    newShape.cx4 = undefined;
	                } else if (newShape.cx3 != undefined) {
	                    newShape.cx3 = undefined;
	                    newShape.cx3 = undefined;
	                } else if (newShape.cx2 != undefined) {
	                    newShape.cx2 = undefined;
	                    newShape.cx2 = undefined;
	                }
	            }
	
	            if (newShape.type == _ShapeConstants2.default.SCREAM_BUBBLE || newShape.type == _ShapeConstants2.default.SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE) newShape.path = undefined;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var clone = _AnimationManager2.default.getCloneByUid(uuid);
	
	    if (!clone) clone = _AnimationManager2.default.clone;
	
	    if (clone && clone.uuid == uuid) newContent = state.model.content;
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateBubbleControlPoint(state, uuid, cx, cy) {
	    var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'controlPoint';
	
	    var content = getContent(state, uuid);
	    var clone = void 0;
	
	    var newContent = content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            switch (type) {
	                case 'controlPoint':
	                    {
	                        newShape.cx = cx;
	                        newShape.cy = cy;
	                        break;
	                    }
	
	                case 'controlPoint1':
	                    {
	                        newShape.cx1 = cx;
	                        newShape.cy1 = cy;
	                        break;
	                    }
	
	                case 'controlPoint2':
	                    {
	                        newShape.cx2 = cx;
	                        newShape.cy2 = cy;
	                        break;
	                    }
	
	                case 'controlPoint3':
	                    {
	                        newShape.cx3 = cx;
	                        newShape.cy3 = cy;
	                        break;
	                    }
	
	                case 'controlPoint4':
	                    {
	                        newShape.cx4 = cx;
	                        newShape.cy4 = cy;
	                        break;
	                    }
	
	                case 'controlPoint5':
	                    {
	                        newShape.cx5 = cx;
	                        newShape.cy5 = cy;
	                        break;
	                    }
	            }
	
	            if (newShape.type == _ShapeConstants2.default.SCREAM_BUBBLE || newShape.type == _ShapeConstants2.default.SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE) newShape.path = undefined;
	
	            if (_AnimationManager2.default.isAnimationMode()) {
	                clone = _AnimationManager2.default.getCloneByUid(newShape.uuid);
	
	                if (!clone) clone = _AnimationManager2.default.clone;
	
	                if (clone && newShape.uuid === clone.uuid) _AnimationManager2.default.replaceClone(newShape);
	
	                if (_AnimationManager2.default.target && _AnimationManager2.default.target.uuid == uuid) _AnimationManager2.default.target = newShape;
	            } else {
	                if (newShape.animation) setAnimationStartProperties(newShape);
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    clone = _AnimationManager2.default.getCloneByUid(uuid);
	
	    if (!clone) clone = _AnimationManager2.default.clone;
	
	    if (clone && clone.uuid == uuid) newContent = state.model.content;
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function selectShapesFromArea(state, selection) {
	    if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) return;
	
	    var newContent = state.model.content.map(function (shape) {
	        var newShape = Object.assign({}, shape);
	        if (selection.indexOf(shape.uuid) > -1) {
	            newShape.isSelected = true;
	            return newShape;
	        } else return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel,
	        shortcutsTarget: undefined,
	        isSlideCommand: false
	    });
	}
	
	function selectShape(state, uuid) {
	    var isNew = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) return;
	
	    if (_AnimationManager2.default.isAnimationMode()) {
	        var animationTargets = _AnimationManager2.default.getAllAnimationTargets(false);
	        var clonesArray = [];
	        var firstClone = void 0;
	
	        for (var i = 0; i < animationTargets.length; i++) {
	            var newClone = Object.assign({}, animationTargets[i]);
	
	            if (newClone.uuid === uuid) newClone.isSelected = true;else newClone.isSelected = false;
	
	            if (i === 0) firstClone = newClone;else clonesArray.push(newClone);
	        }
	
	        _AnimationManager2.default.clone = firstClone;
	        _AnimationManager2.default.clonesArray = clonesArray;
	    }
	
	    var shortcutsTarget;
	
	    var newContent = state.model.content.map(function (shape) {
	        var newShape = Object.assign({}, shape);
	
	        if (uuid == 'selectAll' || uuid == '' || uuid == 'slideFocus') {
	            var selection = false;
	
	            if (uuid == 'selectAll') selection = true;
	
	            if (shape.type != _ShapeConstants2.default.BACKGROUND) {
	                newShape.isSelected = selection;
	                shortcutsTarget = undefined;
	
	                return newShape;
	            } else {
	                return shape;
	            }
	        } else {
	            if (uuid == shape.uuid) {
	                if (!shape.isSelected) {
	                    newShape.isSelected = true;
	                }
	
	                if (shape.type == _ShapeConstants2.default.TEXTBOX || shape.type == _ShapeConstants2.default.TEXTBOXSIMPLE || shape.type == _ShapeConstants2.default.SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || shape.type == _ShapeConstants2.default.SCREAM_BUBBLE || shape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                    newShape.isNew = isNew;
	                }
	
	                shortcutsTarget = newShape;
	            } else {
	                if (_SelectionManager2.default.multipleSelection() == true) {
	                    return shape;
	                } else {
	                    if (shape.isSelected) newShape.isSelected = false;else return shape;
	                }
	            }
	
	            return newShape;
	        }
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    var isSlideCommand = false;
	
	    if (uuid == 'slideFocus') isSlideCommand = true;
	
	    return Object.assign({}, state, {
	        model: newModel,
	        shortcutsTarget: shortcutsTarget,
	        isSlideCommand: isSlideCommand
	    });
	}
	
	function changeInteractionState(state, uuid, newState) {
	    var moveState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) return;
	
	    var content = getContent(state, uuid);
	    var clone = void 0;
	
	    var newContent = content.map(function (shape) {
	        var newShape = Object.assign({}, shape);
	
	        if (shape.uuid === uuid) {
	            newShape.isInteraction = newState;
	            newShape.moveState = moveState;
	
	            if (_AnimationManager2.default.isAnimationMode()) {
	                clone = _AnimationManager2.default.getCloneByUid(newShape.uuid);
	
	                if (!clone) clone = _AnimationManager2.default.clone;
	
	                if (clone && newShape.uuid === clone.uuid) _AnimationManager2.default.replaceClone(newShape);
	
	                if (_AnimationManager2.default.target && _AnimationManager2.default.target.uuid == uuid) _AnimationManager2.default.target = newShape;
	            }
	        }
	
	        return newShape;
	    });
	
	    clone = _AnimationManager2.default.getCloneByUid(uuid);
	
	    if (!clone) clone = _AnimationManager2.default.clone;
	
	    if (clone && clone.uuid == uuid) newContent = state.model.content;
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function createGroup(state, shapeModel) {
	    var groupedShapes = [];
	    var i = void 0;
	
	    for (i = 0; i < shapeModel.shapes.length; i++) {
	        groupedShapes[shapeModel.shapes[i].uuid] = true;
	    }
	
	    var shapesArray = state.model.content;
	    var newContent = [];
	
	    for (i = 0; i < shapesArray.length; i++) {
	        if (groupedShapes[shapesArray[i].uuid] == true) {} else {
	            newContent.push(shapesArray[i]);
	        }
	    }
	
	    newContent.push(shapeModel);
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function ungroup(state, groupModel, shapes) {
	    var currentSlideShapes = state.model.content;
	    var i;
	    var newShapes = [];
	
	    for (i = 0; i < currentSlideShapes.length; i++) {
	        if (currentSlideShapes[i].uuid != groupModel.uuid) newShapes.push(currentSlideShapes[i]);
	    }
	
	    newShapes = newShapes.concat(shapes);
	
	    var newModel = Object.assign({}, state.model, {
	        content: newShapes
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function createShape(state, shapeModel) {
	    var shapesArray = state.model.content;
	    shapesArray.push(shapeModel);
	
	    var newModel = Object.assign({}, state.model, {
	        content: shapesArray
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeVideoProperties(state, property, value) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.type === _ShapeConstants2.default.BACKGROUND && shape.isVideo) {
	            var newShape = Object.assign({}, shape);
	
	            switch (property) {
	                case 'volume':
	                    {
	                        newShape.volume = value;
	                        break;
	                    }
	
	                case 'inPoint':
	                    {
	                        newShape.inPoint = value;
	                        break;
	                    }
	
	                case 'outPoint':
	                    {
	                        newShape.outPoint = value;
	                        break;
	                    }
	
	                case 'all':
	                    {
	                        newShape.volume = value.volume;
	                        newShape.inPoint = value.inPoint;
	                        newShape.outPoint = value.outPoint;
	                        break;
	                    }
	            }
	
	            return newShape;
	        }
	
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeBackgroundContent(state, newProperties) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.type === _ShapeConstants2.default.BACKGROUND) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.contentItemId = newProperties.contentItemId;
	            newShape.xlinkHref = newProperties.href;
	            newShape.logicalName = newProperties.logicalName;
	            newShape.frameLabel = newProperties.frameLabel;
	            newShape.moods = newProperties.moods;
	            newShape.hotSpot = '';
	            newShape.theme = newProperties.theme;
	
	            newShape.isVideo = newProperties.isVideo;
	            newShape.volume = newProperties.volume;
	            newShape.inPoint = newProperties.inPoint;
	            newShape.outPoint = newProperties.outPoint;
	
	            if (newProperties.orgWidth >= 0) {
	                newShape.orgWidth = newProperties.orgWidth;
	                newShape.orgHeight = newProperties.orgHeight;
	            }
	
	            if (newProperties.fill) {
	                newShape.fill = newProperties.fill;
	                newShape.fillOpacity = newProperties.fillOpacity;
	            }
	
	            if (newProperties.stroke) {
	                newShape.stroke = newProperties.stroke;
	                newShape.strokeOpacity = newProperties.strokeOpacity;
	            }
	
	            if (newProperties.frameLabel) newShape.frameLabel = newProperties.frameLabel;
	
	            if (newShape.xlinkHref && newShape.xlinkHref.indexOf('file/ci') != -1) {
	                // it's an image or video from myMediaFiles
	                newShape.fill = '#000000'; // make bacground black
	                newShape.fillOpacity = 1;
	            } else {
	                newShape.fill = '#ffffff';
	            }
	
	            return newShape;
	        }
	
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateCurrentSlideThumbnail(state, value) {
	    return Object.assign({}, state, {
	        updateThumbnail: value
	    });
	}
	
	function initSlide(state) {
	    var slideModel = Object.assign({}, state.model, {
	        initialized: true,
	        isClone: false
	    });
	
	    return Object.assign({}, state, {
	        model: slideModel
	    });
	}
	
	function duplicateGroup(shapeGroup) {
	    shapeGroup = Object.assign({}, shapeGroup);
	    shapeGroup.uuid = _uuid2.default.v4();
	
	    var i;
	    var shape;
	    var shapes = shapeGroup.shapes;
	    var newGroupedShapes = [];
	
	    for (i = 0; i < shapes.length; i++) {
	        shape = Object.assign({}, shapes[i]);
	        shape.uuid = _uuid2.default.v4();
	
	        if (shape.type == _ShapeConstants2.default.GROUP) shape = duplicateGroup(shape);
	
	        newGroupedShapes.push(shape);
	    }
	
	    shapeGroup.shapes = newGroupedShapes;
	
	    return shapeGroup;
	}
	
	function duplicateShape(state, model) {
	    var shapesArray = state.model.content;
	    var cloneShape = Object.assign({}, model);
	
	    cloneShape.uuid = _uuid2.default.v4();
	    cloneShape.isNew = true;
	
	    if (cloneShape.type == _ShapeConstants2.default.GROUP) cloneShape = duplicateGroup(cloneShape);
	
	    var offset = 10;
	
	    if (_SelectionManager2.default.currentSlide != undefined && state.model.uuid != _SelectionManager2.default.currentSlide.uuid) offset = 0;
	
	    if (model.type == _ShapeConstants2.default.LINE || model.type == _ShapeConstants2.default.CURVE) {
	        cloneShape.x1 = cloneShape.x1 + offset;
	        cloneShape.y1 = cloneShape.y1 + offset;
	        cloneShape.x2 = cloneShape.x2 + offset;
	        cloneShape.y2 = cloneShape.y2 + offset;
	
	        if (model.type == _ShapeConstants2.default.CURVE) {
	            cloneShape.cx = cloneShape.cx + offset;
	            cloneShape.cy = cloneShape.cy + offset;
	        }
	    } else {
	        cloneShape.x = cloneShape.x + offset;
	        cloneShape.y = cloneShape.y + offset;
	
	        if (cloneShape.cx) {
	            cloneShape.cx = cloneShape.cx + offset;
	            cloneShape.cy = cloneShape.cy + offset;
	        }
	
	        if (cloneShape.cx1) {
	            cloneShape.cx1 = cloneShape.cx1 + offset;
	            cloneShape.cy1 = cloneShape.cy1 + offset;
	        }
	
	        if (cloneShape.cx2) {
	            cloneShape.cx2 = cloneShape.cx2 + offset;
	            cloneShape.cy2 = cloneShape.cy2 + offset;
	        }
	
	        if (cloneShape.cx3) {
	            cloneShape.cx3 = cloneShape.cx3 + offset;
	            cloneShape.cy3 = cloneShape.cy3 + offset;
	        }
	
	        if (cloneShape.cx4) {
	            cloneShape.cx4 = cloneShape.cx4 + offset;
	            cloneShape.cy4 = cloneShape.cy4 + offset;
	        }
	
	        if (cloneShape.cx5) {
	            cloneShape.cx5 = cloneShape.cx5 + offset;
	            cloneShape.cy5 = cloneShape.cy5 + offset;
	        }
	    }
	
	    shapesArray.push(cloneShape);
	
	    var newModel = Object.assign({}, state.model, {
	        content: shapesArray
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function deleteShape(state, models) {
	    var newShapes = [];
	    var shapesArray = state.model.content;
	    var i;
	
	    for (i = 0; i < shapesArray.length; i++) {
	        if (models.indexOf(shapesArray[i].uuid) == -1) newShapes.push(shapesArray[i]);
	    }
	
	    var newModel = Object.assign({}, state.model, {
	        content: newShapes
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function addVideoShapeDuration(state, shapeModel, duration) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === shapeModel.uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.duration = duration;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateVideoShape(state, uuid) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.refresh = new Date().getTime();
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function lockShape(state, shapeModel) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === shapeModel.uuid) {
	            var newShape = Object.assign({}, shape);
	
	            var lockValue = newShape.isLocked;
	
	            if (lockValue == undefined) lockValue = false;
	
	            newShape.isLocked = !lockValue;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function bringToFront(state, shapeModel) {
	    var shapes = state.model.content;
	    var newShapes = [];
	    var firstShapes = [];
	    var lastShape;
	    var i;
	    var shape;
	
	    for (i = 0; i < shapes.length; i++) {
	        shape = shapes[i];
	
	        if (shape.uuid != shapeModel.uuid) firstShapes.push(shape);else lastShape = shape;
	    }
	
	    newShapes = newShapes.concat(firstShapes);
	    newShapes.push(lastShape);
	
	    var newModel = Object.assign({}, state.model, {
	        content: newShapes
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function sendToBack(state, shapeModel) {
	    var shapes = state.model.content;
	    var newShapes = [];
	    var firstShapes = [];
	    var lastShapes = [];
	    var i;
	    var shape;
	
	    for (i = 0; i < shapes.length; i++) {
	        shape = shapes[i];
	
	        if (shape.type == _ShapeConstants2.default.BACKGROUND || shape.uuid == shapeModel.uuid) firstShapes.push(shape);else lastShapes.push(shape);
	    }
	
	    newShapes = newShapes.concat(firstShapes);
	    newShapes = newShapes.concat(lastShapes);
	
	    var newModel = Object.assign({}, state.model, {
	        content: newShapes
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function bringForward(state, shapeModel) {
	    var shapes = state.model.content;
	    var newShapes = [];
	    var i;
	    var shape;
	
	    for (i = 0; i < shapes.length; i++) {
	        shape = shapes[i];
	
	        if (shape.uuid != shapeModel.uuid) newShapes.push(shape);else {
	            if (i + 1 < shapes.length) {
	                newShapes.push(shapes[i + 1]);
	            }
	
	            newShapes.push(shapes[i]);
	            i = i + 1;
	        }
	    }
	
	    var newModel = Object.assign({}, state.model, {
	        content: newShapes
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function sendBackward(state, shapeModel) {
	    var shapes = state.model.content;
	    var newShapes = [];
	    var lastShapes = [];
	    var i;
	    var shape;
	    var index = -1;
	
	    for (i = 0; i < shapes.length; i++) {
	        shape = shapes[i];
	
	        if (shape.uuid == shapeModel.uuid) {
	            index = i;
	
	            if (index == 1) break;
	        }
	
	        if (index != -1 && i > index) lastShapes.push(shape);
	    }
	
	    if (index == 1) newShapes = shapes;else {
	        for (i = 0; i < index - 1; i++) {
	            shape = shapes[i];
	            newShapes.push(shape);
	        }
	
	        newShapes.push(shapes[index]);
	        newShapes.push(shapes[index - 1]);
	        newShapes = newShapes.concat(lastShapes);
	    }
	
	    var newModel = Object.assign({}, state.model, {
	        content: newShapes
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeFilter(state, shapeModel, filter) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === shapeModel.uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.filter = filter;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeSlideDuration(state, duration) {
	    var newModel = Object.assign({}, state.model, {
	        time: duration
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeAlternativeText(state, text) {
	    var newModel = Object.assign({}, state.model, {
	        alternativeText: text
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeShapeStrokeOpacity(state, shapeModel, opacity) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === shapeModel.uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.strokeOpacity = opacity;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeStrokeSize(state, shapeModel, strokeSize) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === shapeModel.uuid) {
	            var newShape = Object.assign({}, shape);
	
	            if (newShape.type == 'Group') {
	                var shapes = newShape.shapes;
	                newShape.shapes = [];
	
	                for (var i = 0; i < shapes.length; i++) {
	                    var shape = Object.assign({}, shapes[i]);
	
	                    shape.strokeWidth = strokeSize;
	
	                    if (shape.strokeOpacity == 0) shape.strokeOpacity = 1;
	
	                    newShape.shapes.push(shape);
	                }
	            } else {
	                newShape.strokeWidth = strokeSize;
	
	                if (newShape.strokeOpacity == 0) newShape.strokeOpacity = 1;
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeShapeFillColor(state, shapeModel, color) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === shapeModel.uuid) {
	            var newShape = Object.assign({}, shape);
	
	            if (newShape.type == 'Group') {
	                var shapes = newShape.shapes;
	                newShape.shapes = [];
	
	                for (var i = 0; i < shapes.length; i++) {
	                    var shape = Object.assign({}, shapes[i]);
	
	                    shape.fill = color;
	                    shape.fillOpacity = 1;
	
	                    newShape.shapes.push(shape);
	                }
	            } else {
	                newShape.fill = color;
	                newShape.fillOpacity = 1;
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeShapeStrokeColor(state, shapeModel, color) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === shapeModel.uuid) {
	            var newShape = Object.assign({}, shape);
	
	            if (newShape.type == 'Group') {
	                var shapes = newShape.shapes;
	                newShape.shapes = [];
	
	                for (var i = 0; i < shapes.length; i++) {
	                    var shape = Object.assign({}, shapes[i]);
	
	                    shape.stroke = color;
	
	                    if (shape.strokeOpacity == 0) shape.strokeOpacity = 1;
	
	                    newShape.shapes.push(shape);
	                }
	            } else {
	                newShape.stroke = color;
	
	                if (newShape.strokeOpacity == 0) newShape.strokeOpacity = 1;
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeRichTextContent(state, uuid, htmlText) {
	    var content = getContent(state, uuid);
	    var clone = void 0;
	
	    var newContent = content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.htmlText = htmlText;
	            newShape.isRichText = true;
	
	            if (_AnimationManager2.default.isAnimationMode()) {
	                clone = _AnimationManager2.default.getCloneByUid(newShape.uuid);
	
	                if (!clone) clone = _AnimationManager2.default.clone;
	
	                if (clone && newShape.uuid === clone.uuid) _AnimationManager2.default.replaceClone(newShape);
	
	                if (_AnimationManager2.default.target && _AnimationManager2.default.target.uuid == uuid) _AnimationManager2.default.target = newShape;
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    clone = _AnimationManager2.default.getCloneByUid(uuid);
	
	    if (!clone) clone = _AnimationManager2.default.clone;
	
	    if (clone && clone.uuid == uuid) newContent = state.model.content;
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeTextProperties(state, shapeModel, propertyType, newValue) {
	    var isRichText = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	    var content = getContent(state, shapeModel.uuid);
	    var clone = void 0;
	
	    var newContent = content.map(function (shape) {
	        if (shape.uuid === shapeModel.uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.useLineHeightTextProperty = true;
	
	            switch (propertyType) {
	                case 'fontBold':
	                    {
	                        newShape.fontBold = newValue;
	                        break;
	                    }
	                case 'fontItalic':
	                    {
	                        newShape.fontItalic = newValue;
	                        break;
	                    }
	                case 'fontUnderline':
	                    {
	                        newShape.fontUnderline = newValue;
	                        break;
	                    }
	                case 'fontAlign':
	                    {
	                        newShape.fontAlign = newValue;
	                        break;
	                    }
	
	                case 'fontColor':
	                    {
	                        newShape.fontColor = newValue;
	                        break;
	                    }
	
	                case 'htmlText':
	                    {
	                        newShape.htmlText = newValue;
	
	                        if (isRichText == true) newShape.isRichText = true;
	                        break;
	                    }
	
	                case 'fontFamily':
	                    {
	                        _TextEditorUtils2.default.currentFont = newValue;
	                        newShape.fontFamily = newValue;
	                        break;
	                    }
	
	                case 'fontSize':
	                    {
	                        newShape.fontSize = newValue;
	                        break;
	                    }
	            }
	
	            if (_AnimationManager2.default.isAnimationMode()) {
	                clone = _AnimationManager2.default.getCloneByUid(newShape.uuid);
	
	                if (!clone) clone = _AnimationManager2.default.clone;
	
	                if (clone && newShape.uuid === clone.uuid) _AnimationManager2.default.replaceClone(newShape);
	
	                if (_AnimationManager2.default.target && _AnimationManager2.default.target.uuid == shapeModel.uuid) _AnimationManager2.default.target = newShape;
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    clone = _AnimationManager2.default.getCloneByUid(shapeModel.uuid);
	
	    if (!clone) clone = _AnimationManager2.default.clone;
	
	    if (clone && clone.uuid == shapeModel.uuid) newContent = state.model.content;
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function setShortcutsTarget(state, isSlideCommand) {
	    return Object.assign({}, state, {
	        isSlideCommand: isSlideCommand
	    });
	}
	
	function updateTextProperties(state, shapeModel, propertyType, stepOffset) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === shapeModel.uuid) {
	            var newShape = Object.assign({}, shape);
	
	            switch (propertyType) {
	                case 'fontBold':
	                    {
	                        newShape.fontBold = !newShape.fontBold;
	                        break;
	                    }
	                case 'fontItalic':
	                    {
	                        newShape.fontItalic = !newShape.fontItalic;
	                        break;
	                    }
	                case 'fontUnderline':
	                    {
	                        newShape.fontUnderline = !newShape.fontUnderline;
	                        break;
	                    }
	                case 'fontSize':
	                    {
	                        var newSize = newShape.fontSize + stepOffset;
	                        if (newSize > 10 && newSize < 60) newShape.fontSize = newSize;
	                        break;
	                    }
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function setCloneTarget(state, shapeModel) {
	    return Object.assign({}, state, {
	        cloneTarget: shapeModel
	    });
	}
	
	function canvasUndoRedoAction(state, appState) {
	    var newCurrentSlideState = appState.currentSlide;
	
	    return Object.assign({}, state, {
	        cloneTarget: undefined,
	        model: newCurrentSlideState.model,
	        isSlideCommand: false,
	        currentSlideIndex: newCurrentSlideState.currentSlideIndex,
	        shortcutsTarget: undefined,
	        updateThumbnail: false
	    });
	}
	
	function changeMood(state, uuid, frameLabel) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.frameLabel = frameLabel;
	            newShape.xlinkHref = _AppParameters2.default.SVG_URL() + (shape.logicalName + '_' + frameLabel + '.svg');
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function selectLastAddedShape(state) {
	    if (_AppParameters2.default.getMode() == _ModeConstants2.default.PLAYER) return;
	
	    var shortcutsTarget;
	    var index = -1;
	    var lastIndex = state.model.content.length - 1;
	
	    var newContent = state.model.content.map(function (shape) {
	        index = index + 1;
	        var newShape = Object.assign({}, shape);
	
	        if (index === lastIndex) {
	            if (!shape.isSelected) {
	                newShape.isSelected = true;
	            }
	            shortcutsTarget = newShape;
	        } else {
	            if (shape.isSelected) newShape.isSelected = false;else return shape;
	        }
	
	        return newShape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel,
	        shortcutsTarget: shortcutsTarget,
	        isSlideCommand: false
	    });
	}
	
	function updateImageSize(state, uuid, newWidth, newHeight) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.isNewImage = false;
	            newShape.width = newWidth;
	            newShape.height = newHeight;
	
	            if (_CreateShapes2.default.dragDropTopLeftPosition) {
	                newShape.x = _CreateShapes2.default.dragDropTopLeftPosition.x;
	                newShape.y = _CreateShapes2.default.dragDropTopLeftPosition.y;
	            } else {
	                newShape.x = _Configuration2.default.CANVAS_WIDTH / 2 - newShape.width / 2;
	                newShape.y = _Configuration2.default.CANVAS_HEIGHT / 2 - newShape.height / 2;
	            }
	
	            return newShape;
	        }
	
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateImageSizeWhenChangeMood(state, uuid, originalWidth, origianlHeight) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.isNewImage = false;
	            newShape.height = newShape.width * (origianlHeight / originalWidth);
	
	            return newShape;
	        }
	
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateImageHeight(state, uuid, newHeight, updateWidth) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.isNewImage = false;
	
	            if (newHeight > 0) {
	                if (updateWidth) {
	                    newShape.height = newShape.width;
	                    newShape.width = newHeight;
	                } else {
	                    newShape.height = newHeight;
	                }
	
	                if (newShape.hasTopLeftPosition == true) {
	                    // not change top left position ... it's a drag-and-drop
	                } else {
	                    newShape.x = _Configuration2.default.CANVAS_WIDTH / 2 - newShape.width / 2;
	                    newShape.y = _Configuration2.default.CANVAS_HEIGHT / 2 - newShape.height / 2;
	                }
	            }
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeIsNewShape(state, uuid, isNew) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.isNew = isNew;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeShapeType(state, uuid, type) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.type = type;
	
	            newShape.cx = undefined;
	            newShape.cy = undefined;
	            newShape.cx1 = undefined;
	            newShape.cy1 = undefined;
	            newShape.path = undefined;
	
	            _CreateShapes2.default.addControlPointPosition(newShape);
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeTextLineHeight(state, uuid, lineHeight) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.lineHeight = lineHeight;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function oldTextResized(state, uuid) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.oldTextResized = true;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function setSlideSound(state, sound) {
	    _AudioUtils2.default.updateSlideDuration = true;
	
	    var newModel;
	
	    if (sound.href == '') {
	        newModel = Object.assign({}, state.model, {
	            contentItemId: -1,
	            sound: '',
	            soundWav: '',
	            soundTitle: ''
	        });
	    } else {
	        if (sound.contentItemId == -1) {
	            newModel = Object.assign({}, state.model, {
	                contentItemId: sound.contentItemId,
	                soundTitle: sound.title,
	                soundWav: sound.href
	            });
	        } else {
	            newModel = Object.assign({}, state.model, {
	                contentItemId: sound.contentItemId,
	                soundTitle: sound.title,
	                sound: sound.href
	            });
	        }
	    }
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function setSlideSoundEffect(state, sound) {
	    _AudioUtils2.default.updateSlideDuration = true;
	
	    var newModel;
	
	    if (sound.href == '') {
	        newModel = Object.assign({}, state.model, {
	            contentItemIdSoundEffect: -1,
	            soundEffect: '',
	            soundEffectTitle: ''
	        });
	    } else {
	        newModel = Object.assign({}, state.model, {
	            contentItemIdSoundEffect: sound.contentItemId,
	            soundEffectTitle: sound.title,
	            soundEffect: sound.href
	        });
	    }
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateTextHeight(state, uuid, newHeight, newWidth) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            if (newShape.type == _ShapeConstants2.default.SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.SCREAM_BUBBLE || newShape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                newShape.path = undefined;
	
	                if (shape.cy > shape.y && !newWidth) {
	                    var oldBottomY = shape.y + shape.height;
	                    var newBottomY = shape.y + newHeight;
	                    var controlPointOffset = shape.cy - oldBottomY;
	
	                    newShape.cy = newBottomY + controlPointOffset;
	
	                    if (newShape.cy1) {
	                        controlPointOffset = shape.cy1 - oldBottomY;
	                        newShape.cy1 = newBottomY + controlPointOffset;
	                    }
	                }
	            }
	
	            if (newWidth > 0 && newHeight > 0) {
	                newShape.width = newWidth;
	                newShape.height = newHeight;
	            } else if (newWidth > 0) newShape.width = newWidth;else newShape.height = newHeight;
	
	            newShape.useLineHeightTextProperty = true;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function changeShapeFillVisibility(state, uuid, isFillVisible) {
	    var newContent = state.model.content.map(function (shape) {
	        if (shape.uuid === uuid) {
	            var newShape = Object.assign({}, shape);
	
	            newShape.backgroundVisible = isFillVisible;
	
	            return newShape;
	        }
	        return shape;
	    });
	
	    var newModel = Object.assign({}, state.model, {
	        content: newContent
	    });
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	function updateCurrentSlideIndex(state, slideUid) {
	    var productionState = _StoreManager2.default.getState();
	    var slides = productionState.production.slides;
	    var i;
	    var newIndex = 0;
	
	    for (i = 0; i < slides.length; i++) {
	        if (slides[i].uuid == slideUid) {
	            newIndex = i;
	            break;
	        }
	    }
	
	    return Object.assign({}, state, {
	        currentSlideIndex: newIndex
	    });
	}
	
	function changeSlideSoundVolume(state, volume, isSoundEffect) {
	    var newModel;
	
	    if (isSoundEffect) {
	        newModel = Object.assign({}, state.model, {
	            soundEffectVolume: volume
	        });
	    } else {
	        newModel = Object.assign({}, state.model, {
	            soundVolume: volume
	        });
	    }
	
	    return Object.assign({}, state, {
	        model: newModel
	    });
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/reducers/CurrentSlideReducer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/reducers/CurrentSlideReducer.js"); } } })();

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	
	    switch (action.type) {
	
	        case _MenuActions.types.CHANGE_SLIDE_MENU_POSITION:
	            {
	                return Object.assign({}, state, { slideMenuLeftPosition: action.left });
	            }
	
	        case _MenuActions.types.SET_BUTTONS_HOLDER_WIDTH:
	            {
	                return Object.assign({}, state, { buttonsHolderWidth: action.value });
	            }
	
	        case _MenuActions.types.SET_CONTEXT_TARGET:
	            {
	                return Object.assign({}, state, { contextTarget: action.model, isShapeMenuVisible: action.visibleShapeMenu });
	            }
	
	        case _MenuActions.types.CHANGE_CONTEXT_MODE:
	            {
	                if (action.mode != _ModeConstants2.default.SEARCH_CONTEXT) _MoodsUtils2.default.previewContextMenu = action.mode;
	
	                return Object.assign({}, state, { contextMode: action.mode, tab: _ModeConstants2.default.FILL_STYLE });
	            }
	
	        case _MenuActions.types.HIDE_MENUS:
	            {
	                return hideMenus(state, action.menuTypes);
	            }
	
	        case _MenuActions.types.SHOW_MENU:
	            {
	                return showMenu(state, action.menuType);
	            }
	
	        case _MenuActions.types.SHOW_MAIN_UNIVERSE:
	            {
	                return showMainUniverse(state, action.value);
	            }
	
	        case _MenuActions.types.CHANGE_STYLE_TAB:
	            {
	                return changeStyleTab(state, action.selectedTab);
	            }
	
	        case _MenuActions.types.EXPAND_EFFECTS_LIST:
	            {
	                return expandEffectsList(state, action.isExpanded);
	            }
	
	        case _MenuActions.types.EXPAND_FONTS_LIST:
	            {
	                return expandFontsList(state, action.isExpanded);
	            }
	
	        case _MenuActions.types.EXPAND_FONT_SIZE_LIST:
	            {
	                return expandFontSizeList(state, action.isExpanded);
	            }
	
	        case _MenuActions.types.EXPAND_FONT_LINE_HEIGHT:
	            {
	                return expandFontLineHeight(state, action.isExpanded);
	            }
	
	        case _MenuActions.types.EXPAND_AUDIO_LIST:
	            {
	                return expandAudioList(state, action.isExpanded, action.listType);
	            }
	
	        case _MenuActions.types.SELECT_MY_MEDIA_CATEGORY:
	            {
	                return selectMyMediaCategory(state, action.category);
	            }
	
	        case _MenuActions.types.SHOW_DELETE_ALERT:
	            {
	                return Object.assign({}, state, { showDeleteAlert: action.value });
	            }
	
	        case _MenuActions.types.SHOW_ALTERNATIVE_TEXT_MENU:
	            {
	                return Object.assign({}, state, { showAlternativeTextMenu: action.value });
	            }
	        case _MenuActions.types.SHOW_DELETE_TRACK_ALERT:
	            {
	                return Object.assign({}, state, { showDeleteTrackAlert: action.value });
	            }
	
	        case _MenuActions.types.SHOW_RECORDER:
	            {
	                return Object.assign({}, state, { showRecorder: action.value });
	            }
	
	        case _MenuActions.types.SHOW_ADVANCED_MODE_ALERT:
	            {
	                return Object.assign({}, state, { showAdvancedModeAlert: action.value });
	            }
	
	        case _MenuActions.types.SHOW_EXPORT_ALERT:
	            {
	                return Object.assign({}, state, { showExportAlert: action.value });
	            }
	
	        case _MenuActions.types.SHOW_LOST_SESSION_ALERT:
	            {
	                return Object.assign({}, state, { showLostSessionAlert: action.value });
	            }
	
	        case _MenuActions.types.SHOW_PRELOADER:
	            {
	                return Object.assign({}, state, { showPreloader: action.value });
	            }
	
	        case _MenuActions.types.PRINT_MODE:
	            {
	                return Object.assign({}, state, { printMode: action.value });
	            }
	
	        case _MenuActions.types.PRINT_TEMPLATE:
	            {
	                return Object.assign({}, state, { printTemplate: action.value });
	            }
	
	        case _MenuActions.types.SHOW_SAVE_PRELOADER:
	            {
	                return Object.assign({}, state, { showSavePreloader: action.value });
	            }
	
	        case _MenuActions.types.USE_IMAGE_AS_BACKGROUND:
	            {
	                _CreateShapes2.default.useImageAsBackground = action.value;
	                return Object.assign({}, state, { useImageAsBackground: action.value });
	            }
	
	        case _MenuActions.types.USE_BACKGROUND_AS_IMAGE:
	            {
	                _CreateShapes2.default.useBackgroundAsImage = action.value;
	                return Object.assign({}, state, { useBackgroundAsImage: action.value });
	            }
	
	        case _MenuActions.types.USE_FRAME_AS_IMAGE:
	            {
	                _CreateShapes2.default.useFrameAsImage = action.value;
	                return Object.assign({}, state, { useFrameAsImage: action.value });
	            }
	
	        case _MenuActions.types.USE_VIDEO_AS_BACKGROUND:
	            {
	                _CreateShapes2.default.useVideoAsBackground = action.value;
	                return Object.assign({}, state, { useVideoAsBackground: action.value });
	            }
	
	        case _MenuActions.types.SHOW_ZOOM_SLIDES:
	            {
	                return showZoomSlides(state, action.value);
	            }
	
	        case _MenuActions.types.SHOW_CROPPING_MENU:
	            {
	                return showCroppingMenu(state, action.value);
	            }
	
	        case _MenuActions.types.SET_RECORDING_STATUS:
	            {
	                return Object.assign({}, state, { recordingStatus: action.recordingStatus });
	            }
	
	        case _MenuActions.types.SHOW_DESCRIPTION:
	            {
	                return Object.assign({}, state, { showDescription: action.value });
	            }
	
	        case _MenuActions.types.EXIT_ALERT:
	            {
	                return Object.assign({}, state, { exitAlert: action.value });
	            }
	
	        case _MenuActions.types.HAS_NOT_ACCESS:
	            {
	                return Object.assign({}, state, { hasNotAccess: action.value });
	            }
	
	        case _MenuActions.types.CHANGE_CLIPART_CATEGORY:
	            {
	                return Object.assign({}, state, { clipartCategory: action.value });
	            }
	
	        case _MenuActions.types.SHOW_VIDEO_EDITOR:
	            {
	                return Object.assign({}, state, { showVideoEditor: action.value });
	            }
	
	        case _MenuActions.types.UPDATE_CONTROL_POINT:
	            {
	                return Object.assign({}, state, { updateValue: action.value });
	            }
	
	        case _MenuActions.types.REFRESH_VIDEO_EDITOR:
	            {
	                return Object.assign({}, state, { refreshVideoEditor: action.value });
	            }
	
	        case _MenuActions.types.GROUP_DRAWING_SHAPES:
	            {
	                return Object.assign({}, state, { groupDrawingShapes: action.value });
	            }
	
	        case _MenuActions.types.CHANGE_DRAWING_PROPERTIES:
	            {
	                return changeDrawingProperties(state, action.property, action.value);
	            }
	
	        case _MenuActions.types.SHOW_AUDIO_EDITOR:
	            {
	                return Object.assign({}, state, { showAudioEditor: action.value });
	            }
	
	        case _MenuActions.types.CHANGE_AUDIO_TAB_INDEX:
	            {
	                return Object.assign({}, state, { audioTabIndex: action.index });
	            }
	
	        case _MenuActions.types.CHANGE_CARTOONIST_TAB_INDEX:
	            {
	                return Object.assign({}, state, { cartoonistTabIndex: action.index });
	            }
	
	        case _MenuActions.types.EXPAND_CLIPART_IOS_BUTTONS:
	            {
	                return Object.assign({}, state, { iosButtonsExpanded: action.value });
	            }
	
	        case _MenuActions.types.SHOW_AUDIO_ALERT:
	            {
	                return Object.assign({}, state, { audioAlert: action.value, audioTitle: action.title });
	            }
	
	        case _MenuActions.types.UPDATE_CURRENT_SLIDE_CONTENT:
	            {
	                return Object.assign({}, state, { updateSlide: action.value });
	            }
	
	        case _MenuActions.types.SHOW_TEXT_EDITOR:
	            {
	                // used to only show the TEXT EDITOR for ios
	                return Object.assign({}, state, { textShapeTarget: action.textShape });
	            }
	
	        case _MenuActions.types.REFRESH_THEME_SELECTOR:
	            {
	                return Object.assign({}, state, { refreshValue: Math.random() });
	            }
	
	        case _MenuActions.types.REFRESH_TEXT_EDITOR_TOOL:
	            {
	                return Object.assign({}, state, { refreshTextEditorTool: new Date().getTime() });
	            }
	
	        case _MenuActions.types.REFRESH_SHAPE_POSITION:
	            {
	                var refreshValue = '';
	
	                if (action.uuid && action.uuid.length > 0) refreshValue = refreshValue + action.uuid + '_' + new Date().getTime();else refreshValue = refreshValue + new Date().getTime();
	
	                return Object.assign({}, state, { refreshShapePosition: refreshValue });
	            }
	
	        default:
	            return state;
	    }
	};
	
	var _MenuActions = __webpack_require__(7);
	
	var _MenuType = __webpack_require__(21);
	
	var _MenuType2 = _interopRequireDefault(_MenuType);
	
	var _ModeConstants = __webpack_require__(12);
	
	var _ModeConstants2 = _interopRequireDefault(_ModeConstants);
	
	var _ZoomUtils = __webpack_require__(50);
	
	var _ZoomUtils2 = _interopRequireDefault(_ZoomUtils);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _MouseUtils = __webpack_require__(5);
	
	var _MouseUtils2 = _interopRequireDefault(_MouseUtils);
	
	var _MoodsUtils = __webpack_require__(124);
	
	var _MoodsUtils2 = _interopRequireDefault(_MoodsUtils);
	
	var _TextEditorUtils = __webpack_require__(38);
	
	var _TextEditorUtils2 = _interopRequireDefault(_TextEditorUtils);
	
	var _MindMapUtils = __webpack_require__(85);
	
	var _MindMapUtils2 = _interopRequireDefault(_MindMapUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hideMenus(state, types) {
	    if (state.contextMode == _ModeConstants2.default.LINE_CONTEXT || state.contextMode == _ModeConstants2.default.FREEHAND_CONTEXT) return state;
	
	    var mainMenus = [_ModeConstants2.default.SEARCH_CONTEXT, _ModeConstants2.default.TEXT, _ModeConstants2.default.FREEHAND, _ModeConstants2.default.SHAPES, _ModeConstants2.default.FRAMES, _ModeConstants2.default.EFFECTS, _ModeConstants2.default.MEDIA];
	    var i;
	    var shapeMenu;
	    var slideMenu;
	    var contextMenu;
	    var effectsList;
	    var universesMenu;
	    var isContextMenuVisible = false;
	    var hideContextMenu = false;
	    var registerUndoRedoAction = false;
	    var updateUniversesMenu = true;
	    var clipartCategory = _StoreManager2.default.getState().menu.clipartCategory;
	
	    if (!clipartCategory || clipartCategory == 0 || clipartCategory == 1) {
	        if (!clipartCategory || clipartCategory == 0) {
	            if (_AppParameters2.default.currentMainUniverse == '' || _AppParameters2.default.currentTheme == '') updateUniversesMenu = false;
	        } else if (clipartCategory == 1) {
	            if (_AppParameters2.default.currentVideoTheme == '') updateUniversesMenu = false;
	        }
	    }
	
	    if (state.contextMode != undefined && state.contextMode != _ModeConstants2.default.CONTEXT_NONE) isContextMenuVisible = true;
	
	    if (types == _MenuType2.default.ALL_MENUS) types = [_MenuType2.default.ALL_MENUS];
	
	    _MindMapUtils2.default.reset();
	
	    for (i = 0; i < types.length; i++) {
	        if (types[i] == _MenuType2.default.ALL_MENUS) {
	            shapeMenu = { isShapeMenuVisible: false };
	            contextMenu = { contextMode: _ModeConstants2.default.CONTEXT_NONE };
	            slideMenu = { slideMenuLeftPosition: -1 };
	            hideContextMenu = true;
	            effectsList = { effectsListIsExpanded: false, fontsListIsExpanded: false, fontSizeListIsExpanded: false, fontLineHeightIsExpanded: false, mainAudioCategoryIsExpanded: false, secondAudioCategoryIsExpanded: false, soundEffectsCategoryIsExpanded: false, iosButtonsExpanded: false };
	
	            if (updateUniversesMenu) universesMenu = { isUniversesVisible: false, isMainUniverse: false };
	
	            if (mainMenus.indexOf(state.contextMode) != -1 && !_MouseUtils2.default.isCanvasAction) contextMenu = undefined;
	
	            if (_TextEditorUtils2.default.selectedTextShape != '') contextMenu = undefined;
	
	            break;
	        }
	
	        if (types[i] == _MenuType2.default.SHAPE_MENU) {
	            shapeMenu = { isShapeMenuVisible: false };
	        }
	
	        if (types[i] == _MenuType2.default.SLIDE_MENU) {
	            slideMenu = { slideMenuLeftPosition: -1 };
	        }
	
	        if (types[i] == _MenuType2.default.UNIVERSES_MENU) {
	            if (updateUniversesMenu) universesMenu = { isUniversesVisible: false, isMainUniverse: false };
	        }
	
	        if (types[i] == _MenuType2.default.CONTEXT_MENU) {
	            contextMenu = { contextMode: _ModeConstants2.default.CONTEXT_NONE };
	            effectsList = { effectsListIsExpanded: false, fontsListIsExpanded: false, fontSizeListIsExpanded: false, fontLineHeightIsExpanded: false, mainAudioCategoryIsExpanded: false, secondAudioCategoryIsExpanded: false, soundEffectsCategoryIsExpanded: false };
	            hideContextMenu = true;
	
	            if (mainMenus.indexOf(state.contextMode) != -1 && !_MouseUtils2.default.isCanvasAction) contextMenu = undefined;
	
	            if (_TextEditorUtils2.default.selectedTextShape != '') contextMenu = undefined;
	        }
	    }
	
	    if (isContextMenuVisible && hideContextMenu) registerUndoRedoAction = true;
	
	    _MouseUtils2.default.isCanvasAction = false;
	    _MoodsUtils2.default.previewContextMenu = _ModeConstants2.default.CONTEXT_NONE;
	
	    return Object.assign({}, state, shapeMenu, slideMenu, contextMenu, effectsList, universesMenu, { registerUndoRedoAction: registerUndoRedoAction });
	}
	
	function showMenu(state, type) {
	    var menu;
	
	    if (type == _MenuType2.default.SHAPE_MENU) menu = { isShapeMenuVisible: true };
	
	    if (type == _MenuType2.default.UNIVERSES_MENU) menu = { isUniversesVisible: true };
	
	    return Object.assign({}, state, menu);
	}
	
	function showMainUniverse(state, value) {
	    return Object.assign({}, state, { isMainUniverse: value, isUniversesVisible: true });
	}
	
	function changeStyleTab(state, type) {
	    return Object.assign({}, state, { tab: type });
	}
	
	function expandEffectsList(state, isExpanded) {
	    return Object.assign({}, state, { effectsListIsExpanded: isExpanded });
	}
	
	function expandFontsList(state, isExpanded) {
	    return Object.assign({}, state, { fontsListIsExpanded: isExpanded });
	}
	
	function expandFontSizeList(state, isExpanded) {
	    return Object.assign({}, state, { fontSizeListIsExpanded: isExpanded });
	}
	
	function expandFontLineHeight(state, isExpanded) {
	    return Object.assign({}, state, { fontLineHeightIsExpanded: isExpanded });
	}
	
	function selectMyMediaCategory(state, category) {
	    return Object.assign({}, state, { myMediaCategory: category });
	}
	
	function expandAudioList(state, isExpanded, listType) {
	    if (listType == 'all') return Object.assign({}, state, { mainAudioCategoryIsExpanded: false, secondAudioCategoryIsExpanded: false, soundEffectsCategoryIsExpanded: false });else {
	        if (listType == 'soundEffects') return Object.assign({}, state, {
	            soundEffectsCategoryIsExpanded: isExpanded
	        });else if (listType == 'main') return Object.assign({}, state, {
	            mainAudioCategoryIsExpanded: isExpanded,
	            secondAudioCategoryIsExpanded: false
	        });else return Object.assign({}, state, {
	            mainAudioCategoryIsExpanded: false,
	            secondAudioCategoryIsExpanded: isExpanded
	        });
	    }
	}
	
	function showZoomSlides(state, value) {
	    if (value == false) _ZoomUtils2.default.updateInitialPosition = true;
	
	    return Object.assign({}, state, { showZoomSlides: value });
	}
	
	function showCroppingMenu(state, value) {
	    return Object.assign({}, state, { showCroppingMenu: value });
	}
	
	function changeDrawingProperties(state, property, value) {
	    if (property == 'strokeWidth') return Object.assign({}, state, { strokeWidth: value });else return Object.assign({}, state, { strokeColor: value });
	}
	
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/reducers/MenuReducer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/reducers/MenuReducer.js"); } } })();

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.addSoundClipartModel = addSoundClipartModel;
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	
	    switch (action.type) {
	
	        case _MusicActions.types.CHANGE_MAIN_AUDIO_CATEGORY_INDEX:
	            {
	                var subcategoryIndex = _AudioClipartModel2.default.subcategories[action.index];
	                return Object.assign({}, state, { mainAudioCategoryIndex: action.index, secondAudioCategoryIndex: subcategoryIndex });
	            }
	
	        case _MusicActions.types.CHANGE_SOUND_EFFECTS_CATEGORY_INDEX:
	            {
	                return Object.assign({}, state, { soundEffectsCategoryIndex: action.index });
	            }
	
	        case _MusicActions.types.CHANGE_SECOND_AUDIO_CATEGORY_INDEX:
	            {
	                _AudioClipartModel2.default.subcategories[state.mainAudioCategoryIndex] = action.index;
	                return Object.assign({}, state, { secondAudioCategoryIndex: action.index });
	            }
	
	        case _MusicActions.types.ADD_SOUND_CLIPART_MODEL:
	            {
	                return addSoundClipartModel(state, action.clipartModel);
	            }
	
	        case _MusicActions.types.CHANGE_MUSIC_CONTENT_INDEX:
	            {
	                return Object.assign({}, state, { musicContentIndex: action.index });
	            }
	
	        case _MusicActions.types.CHANGE_SLIDE_AUDIO_INDEX:
	            {
	                return Object.assign({}, state, { slideAudioIndex: action.index });
	            }
	
	        default:
	            return state;
	    }
	};
	
	var _MusicActions = __webpack_require__(91);
	
	var _AudioClipartModel = __webpack_require__(370);
	
	var _AudioClipartModel2 = _interopRequireDefault(_AudioClipartModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addSoundClipartModel(state, clipartModel) {
	    return Object.assign({}, state, {
	        soundClipartModel: clipartModel
	    });
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/reducers/MusicReducer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/reducers/MusicReducer.js"); } } })();

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	
	    switch (action.type) {
	        case _ProductionActions.types.LOADED_NEW_PRODUCTION:
	            return Object.assign({}, state, action.production);
	
	        case _ProductionActions.types.LOADED_OLD_PRODUCTION:
	            return Object.assign({}, state, action.production);
	
	        case _ProductionActions.types.CONTENT_XML_LOADED:
	            return Object.assign({}, state, { data: action.data });
	
	        case _ProductionActions.types.ADD_SLIDE:
	            return addSlide(state, action.index);
	
	        case _ProductionActions.types.ADD_SPLITTED_SLIDE:
	            return addSplittedSlide(state, action.index, action.videoModel);
	
	        case _ProductionActions.types.UPDATE_CURRENT_SLIDE:
	            return updateCurrentSlide(state);
	
	        case _ProductionActions.types.CHANGE_SLIDE_POSITION:
	            return changeSlidePosition(state, action.startPosition, action.endPosition);
	
	        case _ProductionActions.types.DUPLICATE_SLIDE:
	            return duplicateSlide(state);
	
	        case _ProductionActions.types.DUPLICATE_SLIDE_END_ANIMATION:
	            return duplicateSlideAtEndOfAnimation(state);
	
	        case _ProductionActions.types.DELETE_SLIDE:
	            return deleteSlide(state);
	
	        case _ProductionActions.types.SET_WINDOW_SIZE:
	            return setWindowSize(state, action.width, action.height);
	
	        case _ProductionActions.types.CHANGE_MODE:
	            return changeMode(state, action.mode);
	
	        case _ProductionActions.types.SHIFT_SLIDE:
	            return shiftSlide(state, action.isLeft, action.currentPosition);
	
	        case _ProductionActions.types.SET_SLIDE_CLONE_TARGET:
	            return setSlideCloneTarget(state, action.slide);
	
	        case _ProductionActions.types.CLONE_SLIDE:
	            return cloneSlide(state, action.target);
	
	        case _ProductionActions.types.PRODUCTION_UNDO_REDO_ACTION:
	            return productionUndoRedoAction(state, action.newState);
	
	        case _ProductionActions.types.ADD_STORY_SOUND:
	            return addStorySound(state, action.audioItem);
	
	        case _ProductionActions.types.CHANGE_STORY_SOUND_VOLUME:
	            return changeStorySoundVolume(state, action.volume);
	
	        case _ProductionActions.types.UPDATE_PRODUCTION_MOODS:
	            return updateProductionMoods(state);
	
	        case _ProductionActions.types.CHANGE_SLIDE_PROPERTY:
	            return changeSlideProperty(state, action.uuid, action.propertyType, action.propertyValue);
	
	        case _ProductionActions.types.SET_EXPORT_PROPERTIES:
	            return setExportProperties(state, action.properties);
	
	        default:
	            return state;
	    }
	};
	
	var _ProductionActions = __webpack_require__(32);
	
	var _CreateShapes = __webpack_require__(39);
	
	var _CreateShapes2 = _interopRequireDefault(_CreateShapes);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _SlidesUtils = __webpack_require__(125);
	
	var _SlidesUtils2 = _interopRequireDefault(_SlidesUtils);
	
	var _MoodsUtils = __webpack_require__(124);
	
	var _MoodsUtils2 = _interopRequireDefault(_MoodsUtils);
	
	var _ShapeConstants = __webpack_require__(27);
	
	var _ShapeConstants2 = _interopRequireDefault(_ShapeConstants);
	
	var _uuid = __webpack_require__(68);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _Configuration = __webpack_require__(15);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _AppParameters = __webpack_require__(8);
	
	var _AppParameters2 = _interopRequireDefault(_AppParameters);
	
	var _TextSizeUtils = __webpack_require__(31);
	
	var _TextSizeUtils2 = _interopRequireDefault(_TextSizeUtils);
	
	var _AnimationManager = __webpack_require__(25);
	
	var _AnimationManager2 = _interopRequireDefault(_AnimationManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createSlideModel(videoModel) {
	    var slide = {};
	    var backgroundModel;
	
	    if (videoModel) {
	        backgroundModel = _CreateShapes2.default.createBackgroundWithVideo(videoModel);
	    } else {
	        backgroundModel = _CreateShapes2.default.createBackground();
	    }
	
	    slide.content = [backgroundModel];
	    slide.initialized = true;
	    slide.time = _Configuration2.default.SLIDE_DURATION;
	    slide.uuid = _uuid2.default.v4();
	    slide.contentItemId = -1; // contentItemId for sound
	    slide.sound = '';
	    slide.soundEffect = '';
	    slide.soundVolume = 0.5;
	    slide.soundEffectVolume = 0.5;
	
	    if (videoModel) slide.time = videoModel.outPoint - videoModel.inPoint;
	
	    return slide;
	}
	
	function addSlide(state, index) {
	    var slides = state.slides;
	    var slide = createSlideModel();
	
	    slides.splice(index, 0, slide);
	
	    return Object.assign({}, state, {
	        slides: slides
	    });
	}
	
	function addSplittedSlide(state, index, videoModel) {
	    var slides = state.slides;
	    var slide = createSlideModel(videoModel);
	
	    slides.splice(index, 0, slide);
	
	    return Object.assign({}, state, {
	        slides: slides
	    });
	}
	
	function updateCurrentSlide(state) {
	    var slides = state.slides;
	    var currentSlide = _StoreManager2.default.getState().currentSlide;
	    var slideModel = currentSlide.model;
	
	    slides[currentSlide.currentSlideIndex] = slideModel;
	
	    return Object.assign({}, state, {
	        slides: slides
	    });
	}
	
	// drag target should be inserted before dropIndex
	function changeSlidePosition(state, dragIndex, dropIndex) {
	    var slides = state.slides;
	    var newSlides = [];
	    var i = void 0;
	    var target = slides[dragIndex];
	
	    if (target == undefined || dropIndex < 0 || dragIndex == dropIndex) newSlides = slides;else {
	        var dropTarget = slides[dropIndex];
	
	        for (i = 0; i < slides.length; i++) {
	
	            if (i == dragIndex) continue;
	
	            newSlides.push(slides[i]);
	        }
	
	        if (dropIndex >= slides.length - 1) newSlides.push(target);else {
	            var dropTargetIndex = newSlides.indexOf(dropTarget);
	            newSlides.splice(dropTargetIndex, 0, target);
	        }
	    }
	
	    return Object.assign({}, state, {
	        slides: newSlides
	    });
	}
	
	function shiftSlide(state, isLeft, currentPosition) {
	    var slides = state.slides;
	    var newSlides = [];
	    var i = void 0;
	    var limit = void 0;
	
	    // first limit -- the left one
	    if (isLeft == true) {
	        limit = currentPosition - 1;
	    } else {
	        limit = currentPosition;
	    }
	
	    for (i = 0; i < limit; i++) {
	        newSlides.push(slides[i]);
	    }
	
	    // second limit -- the right one
	    if (isLeft == true) {
	        limit = currentPosition;
	        newSlides.push(slides[currentPosition]);
	        newSlides.push(slides[currentPosition - 1]);
	    } else {
	        limit = currentPosition + 1;
	        newSlides.push(slides[currentPosition + 1]);
	        newSlides.push(slides[currentPosition]);
	    }
	
	    for (i = limit + 1; i < slides.length; i++) {
	        newSlides.push(slides[i]);
	    }
	
	    return Object.assign({}, state, {
	        slides: newSlides
	    });
	}
	
	function updateProductionMoods(state) {
	    var slides = state.slides;
	    var newSlides = [];
	    var i;
	    var slide;
	
	    for (i = 0; i < slides.length; i++) {
	        slide = Object.assign({}, slides[i]);
	
	        var shapes = slide.content;
	        var j;
	        var shape;
	        var newShapes = [];
	
	        for (j = 0; j < shapes.length; j++) {
	            shape = shapes[j];
	
	            if (shape.type == _ShapeConstants2.default.CHARACTER || shape.type == _ShapeConstants2.default.BACKGROUND) {
	                shape = Object.assign({}, shape);
	                shape.moods = _MoodsUtils2.default.getMoods(shape.logicalName);
	
	                if (shape.type == _ShapeConstants2.default.BACKGROUND && shape.moods && shape.moods.length > 0) {
	                    if (shape.logicalName != undefined && shape.logicalName.length > 0 && (shape.frameLabel == undefined || shape.frameLabel.length < 1)) shape.frameLabel = 'dag';
	                    shape.xlinkHref = _AppParameters2.default.SVG_URL() + (shape.logicalName + '_' + shape.frameLabel + '.svg');
	                }
	            }
	
	            newShapes.push(shape);
	        }
	
	        slide.content = newShapes;
	        newSlides.push(slide);
	    }
	
	    return Object.assign({}, state, {
	        slides: newSlides
	    });
	}
	
	function deleteSlide(state) {
	    var slides = state.slides;
	    var currentSlideIndex = _StoreManager2.default.getState().currentSlide.currentSlideIndex;
	
	    slides.splice(currentSlideIndex, 1);
	
	    if (slides.length == 0) {
	        var slide = createSlideModel();
	        slide.isClone = true;
	        slide.initialized = false;
	        slides.push(slide);
	    }
	
	    return Object.assign({}, state, {
	        slides: slides
	    });
	}
	
	function setWindowSize(state, width, height) {
	    return Object.assign({}, state, { windowWidth: width, windowHeight: height });
	}
	
	function changeMode(state, mode) {
	    return Object.assign({}, state, {
	        mode: mode
	    });
	}
	
	function setSlideCloneTarget(state, slide) {
	    return Object.assign({}, state, {
	        slideCloneTarget: slide
	    });
	}
	
	function duplicateSlideAtEndOfAnimation(state) {
	    var slides = state.slides;
	    var currentSlideIndex = _StoreManager2.default.getState().currentSlide.currentSlideIndex;
	    var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	    var newSlide = {};
	    newSlide.initialized = false;
	    newSlide.time = currentSlide.model.time;
	    newSlide.uuid = _uuid2.default.v4();
	
	    var shapes = currentSlide.model.content;
	
	    var newShapes = shapes.map(function (shape) {
	        var newShape = JSON.parse(JSON.stringify(shape));
	        newShape.uuid = _uuid2.default.v4();
	
	        if (newShape.animation) {
	            var animationPoints = _AnimationManager2.default.getAnimationPoints(newShape.animation);
	            var animationStart = animationPoints[animationPoints.length - 2];
	            var animationEnd = animationPoints[animationPoints.length - 1];
	
	            if (newShape.type == _ShapeConstants2.default.LINE || newShape.type == _ShapeConstants2.default.CURVE) {
	                if (animationEnd.x1) newShape.x1 = animationEnd.x1;
	
	                if (animationEnd.y1) newShape.y1 = animationEnd.y1;
	
	                if (animationEnd.x2) newShape.x2 = animationEnd.x2;
	
	                if (animationEnd.y2) newShape.y2 = animationEnd.y2;
	
	                if (newShape.type == _ShapeConstants2.default.CURVE) {
	                    if (animationEnd.cx) newShape.cx = animationEnd.cx;
	
	                    if (animationEnd.cy) newShape.cy = animationEnd.cy;
	                }
	            } else {
	                if (animationEnd.x) newShape.x = animationEnd.x;
	
	                if (animationEnd.y) newShape.y = animationEnd.y;
	
	                if (animationEnd.width) newShape.width = animationEnd.width;
	
	                if (animationEnd.height) newShape.height = animationEnd.height;
	
	                if (newShape.type == _ShapeConstants2.default.SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.SCREAM_BUBBLE || newShape.type == _ShapeConstants2.default.THOUGHT_BUBBLE) {
	                    if (animationEnd.cx) newShape.cx = animationEnd.cx;
	
	                    if (animationEnd.cy) newShape.cy = animationEnd.cy;
	
	                    if (animationEnd.cx1) newShape.cx1 = animationEnd.cx1;
	
	                    if (animationEnd.cy1) newShape.cy1 = animationEnd.cy1;
	
	                    if (animationEnd.cx2) newShape.cx2 = animationEnd.cx2;
	
	                    if (animationEnd.cy2) newShape.cy2 = animationEnd.cy2;
	
	                    if (animationEnd.cx3) newShape.cx3 = animationEnd.cx3;
	
	                    if (animationEnd.cy3) newShape.cy3 = animationEnd.cy3;
	
	                    if (animationEnd.cx4) newShape.cx4 = animationEnd.cx4;
	
	                    if (animationEnd.cy4) newShape.cy4 = animationEnd.cy4;
	
	                    if (animationEnd.cx5) newShape.cx5 = animationEnd.cx5;
	
	                    if (animationEnd.cy5) newShape.cy5 = animationEnd.cy5;
	                }
	
	                if (newShape.type == _ShapeConstants2.default.SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.COMPLEX_SPEAK_BUBBLE || newShape.type == _ShapeConstants2.default.SCREAM_BUBBLE || newShape.type == _ShapeConstants2.default.THOUGHT_BUBBLE || newShape.type == _ShapeConstants2.default.TEXTBOX || newShape.type == _ShapeConstants2.default.TEXTBOXSIMPLE) newShape.fontSize = _TextSizeUtils2.default.getFontSize(newShape, newShape.width, newShape.height, animationStart.width, animationStart.height);
	            }
	
	            if (animationEnd.opacity >= 0) newShape.opacity = animationEnd.opacity;
	
	            if (animationEnd.rotation >= 0) newShape.rotation = animationEnd.rotation;
	
	            newShape.animation = undefined;
	        }
	
	        return newShape;
	    });
	
	    newSlide.content = newShapes;
	
	    slides.splice(currentSlideIndex + 1, 0, newSlide);
	
	    return Object.assign({}, state, {
	        slides: slides
	    });
	}
	
	function duplicateSlide(state) {
	    var slides = state.slides;
	    var currentSlideIndex = _StoreManager2.default.getState().currentSlide.currentSlideIndex;
	    var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	    var newSlide = {};
	    newSlide.initialized = false;
	    newSlide.time = currentSlide.model.time;
	    newSlide.uuid = _uuid2.default.v4();
	
	    var shapes = currentSlide.model.content;
	    var mindMapsUidsList = [];
	
	    var newShapes = shapes.map(function (shape) {
	        var newShape = JSON.parse(JSON.stringify(shape));
	
	        var newUid = _uuid2.default.v4();
	
	        if (shape.isMindMap) mindMapsUidsList[shape.uuid] = newUid;else {
	            if (shape.mindMapProperty && mindMapsUidsList[shape.mindMapProperty.parentMindMap]) newShape.mindMapProperty.parentMindMap = mindMapsUidsList[shape.mindMapProperty.parentMindMap];
	        }
	
	        newShape.uuid = newUid;
	        return newShape;
	    });
	
	    newSlide.content = newShapes;
	
	    slides.splice(currentSlideIndex + 1, 0, newSlide);
	
	    return Object.assign({}, state, {
	        slides: slides
	    });
	}
	
	function cloneSlide(state, target) {
	    var slides = state.slides;
	    var currentSlideIndex = _StoreManager2.default.getState().currentSlide.currentSlideIndex;
	    var currentSlide = _StoreManager2.default.getState().currentSlide;
	
	    var newSlide = {};
	    newSlide.title = _SlidesUtils2.default.generateSlideTitle(slides);
	    newSlide.initialized = false;
	    newSlide.time = currentSlide.model.time;
	
	    var shapes = target.content;
	    var mindMapsUidsList = [];
	
	    var newShapes = shapes.map(function (shape) {
	        var newShape = JSON.parse(JSON.stringify(shape));
	
	        var newUid = _uuid2.default.v4();
	
	        if (shape.isMindMap) mindMapsUidsList[shape.uuid] = newUid;else {
	            if (shape.mindMapProperty && mindMapsUidsList[shape.mindMapProperty.parentMindMap]) newShape.mindMapProperty.parentMindMap = mindMapsUidsList[shape.mindMapProperty.parentMindMap];
	        }
	
	        newShape.uuid = newUid;
	        return newShape;
	    });
	
	    newSlide.content = newShapes;
	
	    slides.splice(currentSlideIndex + 1, 0, newSlide);
	
	    return Object.assign({}, state, {
	        slides: slides
	    });
	}
	
	function productionUndoRedoAction(state, appState) {
	    var newProductionState = appState.production;
	
	    return Object.assign({}, state, {
	        slides: newProductionState.slides,
	        storySound: newProductionState.storySound
	    });
	}
	
	function addStorySound(state, audioItem) {
	    if (audioItem && audioItem.contentItemId && audioItem.contentItemId < 1000) audioItem.contentItemId = -1;
	
	    return Object.assign({}, state, {
	        storySound: audioItem
	    });
	}
	
	function changeStorySoundVolume(state, volume) {
	    return Object.assign({}, state, {
	        storySoundVolume: volume
	    });
	}
	
	function setExportProperties(state, properties) {
	    return Object.assign({}, state, {
	        exportProperties: properties
	    });
	}
	
	function changeSlideProperty(state, uuid, propertyType, propertyValue) {
	    var slides = state.slides;
	    var newSlides = [];
	    var i;
	    var slide;
	
	    for (i = 0; i < slides.length; i++) {
	        slide = Object.assign({}, slides[i]);
	
	        if (slide.uuid == uuid) {
	            if (propertyType == 'sound') {
	                if (propertyValue.href == '') {
	                    slide.contentItemId = -1;
	                    slide.sound = '';
	                    slide.soundWav = '';
	                    slide.soundTitle = '';
	                } else {
	                    if (propertyValue.contentItemId == -1) {
	                        slide.contentItemId = propertyValue.contentItemId;
	                        slide.soundWav = propertyValue.href;
	                        slide.soundTitle = propertyValue.title;
	                    } else {
	                        slide.contentItemId = propertyValue.contentItemId;
	                        slide.sound = propertyValue.href;
	                        slide.soundTitle = propertyValue.title;
	                    }
	                }
	            } else {
	                if (!slide.content[0].isVideo) // if the video is attached to a slide then, the duration shouldn't be changed by a sound
	                    slide.time = propertyValue;
	            }
	        }
	
	        newSlides.push(slide);
	    }
	
	    return Object.assign({}, state, {
	        slides: newSlides
	    });
	}
	
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/reducers/ProductionReducer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/reducers/ProductionReducer.js"); } } })();

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redux = __webpack_require__(252);
	
	var _ProductionReducer = __webpack_require__(873);
	
	var _ProductionReducer2 = _interopRequireDefault(_ProductionReducer);
	
	var _CurrentSlideReducer = __webpack_require__(870);
	
	var _CurrentSlideReducer2 = _interopRequireDefault(_CurrentSlideReducer);
	
	var _AccordionReducer = __webpack_require__(868);
	
	var _AccordionReducer2 = _interopRequireDefault(_AccordionReducer);
	
	var _SessionReducer = __webpack_require__(875);
	
	var _SessionReducer2 = _interopRequireDefault(_SessionReducer);
	
	var _SlideViewerReducer = __webpack_require__(876);
	
	var _SlideViewerReducer2 = _interopRequireDefault(_SlideViewerReducer);
	
	var _MenuReducer = __webpack_require__(871);
	
	var _MenuReducer2 = _interopRequireDefault(_MenuReducer);
	
	var _UndoRedoReducer = __webpack_require__(877);
	
	var _UndoRedoReducer2 = _interopRequireDefault(_UndoRedoReducer);
	
	var _MusicReducer = __webpack_require__(872);
	
	var _MusicReducer2 = _interopRequireDefault(_MusicReducer);
	
	var _AudioEditorReducer = __webpack_require__(869);
	
	var _AudioEditorReducer2 = _interopRequireDefault(_AudioEditorReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	    production: _ProductionReducer2.default,
	    currentSlide: _CurrentSlideReducer2.default,
	    accordion: _AccordionReducer2.default,
	    session: _SessionReducer2.default,
	    slideViewer: _SlideViewerReducer2.default,
	    menu: _MenuReducer2.default,
	    undoRedo: _UndoRedoReducer2.default,
	    music: _MusicReducer2.default,
	    audioEditor: _AudioEditorReducer2.default
	});
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/reducers/Reducer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/reducers/Reducer.js"); } } })();

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _SessionActions.types.SESSION_SET_REQUEST_PARAMETER_IDS:
	            return Object.assign({}, state, {
	                requestParameterIds: action.parameterIds
	            });
	
	        case _SessionActions.types.SESSION_SET_APP_READY:
	            return Object.assign({}, state, {
	                appReady: true
	            });
	
	        case _SessionActions.types.SESSION_SET_CAPTIONS_LOADED:
	            return Object.assign({}, state, {
	                captionsLoaded: true
	            });
	
	        case _SessionActions.types.SESSION_SET_LANGUAGE:
	            return Object.assign({}, state, { language: action.language });
	
	        default:
	            return state;
	    }
	};
	
	var _SessionActions = __webpack_require__(120);
	
	var defaultState = {
	    appReady: false,
	    navigationLock: { isLocked: false, reason: null, owner: null }
	};
	
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/reducers/SessionReducer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/reducers/SessionReducer.js"); } } })();

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	
	    switch (action.type) {
	        case _SlideViewerActions.types.DRAG_INDEX:
	            return Object.assign({}, state, { dragIndex: action.index });
	
	        case _SlideViewerActions.types.DROP_INDEX:
	            return Object.assign({}, state, { dropIndex: action.index });
	
	        case _SlideViewerActions.types.NEEDS_REFRESH:
	            return Object.assign({}, state, { needsRefresh: action.value });
	
	        default:
	            return state;
	    }
	};
	
	var _SlideViewerActions = __webpack_require__(121);
	
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/reducers/SlideViewerReducer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/reducers/SlideViewerReducer.js"); } } })();

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	
	    switch (action.type) {
	        case _UndoRedoActions.types.ADD_NEW_ACTION_TO_HISTORY:
	            return addNewActionToHistory(state);
	
	        case _UndoRedoActions.types.UNDO:
	            return undo(state);
	
	        case _UndoRedoActions.types.REDO:
	            return redo(state);
	
	        default:
	            return state;
	    }
	};
	
	var _UndoRedoActions = __webpack_require__(227);
	
	var _StoreManager = __webpack_require__(2);
	
	var _StoreManager2 = _interopRequireDefault(_StoreManager);
	
	var _SaveManager = __webpack_require__(13);
	
	var _SaveManager2 = _interopRequireDefault(_SaveManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addNewActionToHistory(state) {
	    var undo = state.undo;
	    var present = state.present;
	    var appState = getCurrentState();
	
	    if (present == undefined) {
	        undo = [];
	    } else {
	        undo.push(present);
	        _SaveManager2.default.isContentChanged(true);
	    }
	
	    present = appState;
	
	    return Object.assign({}, state, { undo: undo, redo: [], present: present });
	}
	
	function getCurrentState() {
	    var currentState = _StoreManager2.default.getState();
	    var newState = {};
	
	    newState.production = {};
	    newState.production.slides = cloneArray(currentState.production.slides);
	    newState.production.title = currentState.production.title;
	    newState.production.mode = currentState.production.mode;
	    newState.production.windowWidth = currentState.production.windowWidth;
	    newState.production.windowHeight = currentState.production.windowHeight;
	    newState.production.storySound = currentState.production.storySound;
	
	    newState.currentSlide = {};
	    newState.currentSlide.currentSlideIndex = currentState.currentSlide.currentSlideIndex;
	    newState.currentSlide.model = {};
	    newState.currentSlide.model.initialized = currentState.currentSlide.model.initialized;
	    newState.currentSlide.model.uuid = currentState.currentSlide.model.uuid;
	    newState.currentSlide.model.time = currentState.currentSlide.model.time;
	
	    newState.currentSlide.model.soundEffect = currentState.currentSlide.model.soundEffect;
	    newState.currentSlide.model.soundEffectTitle = currentState.currentSlide.model.soundEffectTitle;
	    newState.currentSlide.model.contentItemIdSoundEffect = currentState.currentSlide.model.contentItemIdSoundEffect;
	    newState.currentSlide.model.sound = currentState.currentSlide.model.sound;
	    newState.currentSlide.model.soundTitle = currentState.currentSlide.model.soundTitle;
	    newState.currentSlide.model.contentItemId = currentState.currentSlide.model.contentItemId;
	
	    newState.currentSlide.model.content = cloneArray(currentState.currentSlide.model.content);
	
	    if (currentState.audioEditor && currentState.audioEditor.timelines) {
	        newState.audioEditor = {};
	        newState.audioEditor.timelines = cloneArray(currentState.audioEditor.timelines);
	
	        if (currentState.audioEditor.zoomValue) newState.audioEditor.zoomValue = currentState.audioEditor.zoomValue;else newState.audioEditor.zoomValue = 4;
	    }
	
	    return newState;
	}
	
	function cloneArray(array) {
	    var newItems = [];
	
	    for (var i = 0; i < array.length; i++) {
	        var newItem = Object.assign({}, array[i]);
	        newItems.push(newItem);
	    }
	
	    return newItems;
	}
	
	function undo(state) {
	    var undo = state.undo;
	    var redo = state.redo;
	    var present = state.present;
	
	    if (undo.length > 0) {
	        redo.unshift(present);
	        present = undo[undo.length - 1];
	        undo.pop();
	        _SaveManager2.default.isContentChanged(true);
	    }
	
	    return Object.assign({}, state, { undo: undo, redo: redo, present: present });
	}
	
	function redo(state) {
	    var undo = state.undo;
	    var redo = state.redo;
	    var present = state.present;
	
	    if (redo.length > 0) {
	        undo.push(present);
	        present = redo[0];
	        redo.splice(0, 1);
	        _SaveManager2.default.isContentChanged(true);
	    }
	
	    return Object.assign({}, state, { undo: undo, redo: redo, present: present });
	}
	
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/reducers/UndoRedoReducer.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/reducers/UndoRedoReducer.js"); } } })();

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.logToExternalErrorTracking = logToExternalErrorTracking;
	exports.reportError = reportError;
	exports.configureTrackJs = configureTrackJs;
	exports.configureErrorLogging = configureErrorLogging;
	
	var _uuid = __webpack_require__(68);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _environmentNames = __webpack_require__(244);
	
	var _environmentNames2 = _interopRequireDefault(_environmentNames);
	
	var _ApiService = __webpack_require__(47);
	
	var _ApiService2 = _interopRequireDefault(_ApiService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trackJs = void 0;
	if (("production") === _environmentNames2.default.PRODUCTION) {
	    trackJs = __webpack_require__(644);
	}
	
	function formatResponseError(error) {
	    if (error.response) {
	        return { status: error.response.status, url: error.response.url };
	    }
	    return error;
	}
	
	function discardError(error) {
	    var errorIsDefined = error && error !== '';
	    if (!errorIsDefined) {
	        return true;
	    }
	
	    var errorIsResponseError = _ApiService2.default.isResponseError(error);
	    if (errorIsResponseError) {
	        if (error.errorType === _ApiService2.default.responseCategories.OFFLINE || error.errorType === _ApiService2.default.responseCategories.TIMEOUT || error.errorType === _ApiService2.default.responseCategories.FORBIDDEN || error.errorType === _ApiService2.default.responseCategories.NOT_LOGGED_IN) {
	            return true;
	        }
	        if (error.response && error.response.url.includes('NotifyClientEvent')) {
	            return true;
	        }
	    }
	
	    return false;
	}
	
	function logToExternalErrorTracking(error, hash) {
	    var formattedError = error;
	
	    if (discardError(error)) {
	        return;
	    }
	
	    // For response errors we build a simplified object since TrackJS doesn't keep all values of the error objects
	    if (_ApiService2.default.isResponseError(error)) {
	        formattedError = JSON.stringify(formatResponseError(error)) + ' - ' + hash;
	    }
	
	    if (trackJs) {
	        trackJs.track(formattedError);
	    }
	}
	
	function getErrorHash() {
	    var hash = _uuid2.default.v4();
	    return typeof hash === 'string' ? hash.substring(0, 8) : undefined;
	}
	
	function logResponseError(error) {
	    var hash = getErrorHash();
	
	    logToExternalErrorTracking(error, hash);
	}
	
	/**
	 * Directly reporting errors to trackJs and Live Monitor as promises are swallowing the errors
	 * http://jamesknelson.com/are-es6-promises-swallowing-your-errors/
	 * @param error
	 */
	function reportError(error) {
	    var isUnitTestEnv = ("production") === _environmentNames2.default.UNIT_TESTING;
	    if (isUnitTestEnv) {
	        return;
	    }
	
	    if (discardError(error)) {
	        return;
	    }
	
	    if (_ApiService2.default.isResponseError(error)) {
	        logResponseError(error);
	    } else {
	        // For non-response errors we still need to make sure they get logged to TrackJS
	        logToExternalErrorTracking(error);
	    }
	}
	
	function configureTrackJs() {
	    if (trackJs) {
	        trackJs.configure({
	            onError: function onError(payload) {
	                // TrackJS fails with HTTP 413 if the report is too big
	                payload.console = payload.console.slice(Math.max(payload.console.length - 10, 0));
	
	                return true;
	            }
	        });
	    }
	}
	
	function configureErrorLogging() {
	    window.addEventListener('unhandledrejection', function (event) {
	        var reason = event.detail ? event.detail.reason : event.reason;
	        reportError(reason);
	    });
	}
	
	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/services/ErrorReporting.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/services/ErrorReporting.js"); } } })();

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var createProdLogger = function createProdLogger() {
	    return function (next) {
	        return function (action) {
	            var actionType = action.type;
	            window.console.log('action:', actionType);
	            return next(action);
	        };
	    };
	};
	
	exports.default = createProdLogger;
	module.exports = exports['default'];

	 ;(function register() { /* react-hot-loader/webpack */ if (false) { if (typeof __REACT_HOT_LOADER__ === 'undefined') { return; } /* eslint-disable camelcase, no-undef */ var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : module.exports; /* eslint-enable camelcase, no-undef */ if (typeof webpackExports === 'function') { __REACT_HOT_LOADER__.register(webpackExports, 'module.exports', "/build/cartoonist-prod/creaza-cartoonist/src/store/middleware/ProdLogger.js"); return; } /* eslint-disable no-restricted-syntax */ for (var key in webpackExports) { /* eslint-enable no-restricted-syntax */ if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) { continue; } var namedExport = void 0; try { namedExport = webpackExports[key]; } catch (err) { continue; } __REACT_HOT_LOADER__.register(namedExport, key, "/build/cartoonist-prod/creaza-cartoonist/src/store/middleware/ProdLogger.js"); } } })();

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(298);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(378);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(379);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(378);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(882);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(883);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(379);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(210);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(295);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 882 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(252);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(380);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(381);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(94);
	
	var _InternalPropTypes = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(94);
	
	var _InternalPropTypes = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(389);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(179);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(247);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(110);
	
	var _RouterContext = __webpack_require__(176);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(94);
	
	var _RouterUtils = __webpack_require__(382);
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(176);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(245);
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(176);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(907);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(384);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(126);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(245);
	
	var _makeStateWithLocation = __webpack_require__(385);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(126);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(389);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(384);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(94);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(246);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(126);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(891);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(380);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(885);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(905);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(886);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(887);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(381);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(889);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(884);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(888);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(890);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(904);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(176);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(892);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(902);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(386);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(894);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(895);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(899);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(383);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(126);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(127);
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(383);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(247);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(94);
	
	var _RouterUtils = __webpack_require__(382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(245);
	
	var _makeStateWithLocation = __webpack_require__(385);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(126);
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(179);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(247);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(53);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(295);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 906 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(127);
	
	var _PathUtils = __webpack_require__(111);
	
	var _ExecutionEnvironment = __webpack_require__(178);
	
	var _DOMUtils = __webpack_require__(248);
	
	var _DOMStateStorage = __webpack_require__(387);
	
	var _createDOMHistory = __webpack_require__(388);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(127);
	
	var _PathUtils = __webpack_require__(111);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(54);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(111);
	
	var _Actions = __webpack_require__(127);
	
	var _createHistory = __webpack_require__(390);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.ScrollArea=t(require("react")):e.ScrollArea=t(e.React)}(this,function(e){return function(e){function t(o){if(n[o])return n[o].exports;var r=n[o]={exports:{},id:o,loaded:!1};return e[o].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),n(31);var r=n(13),i=o(r);t.default=i.default},function(t,n){t.exports=e},function(e,t,n){e.exports=n(19)()},function(e,t){"use strict";function n(e){var t={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]="number"==typeof e[n]?e[n]:e[n].val);return t}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t,n){(function(t){(function(){var n,o,r;"undefined"!=typeof performance&&null!==performance&&performance.now?e.exports=function(){return performance.now()}:"undefined"!=typeof t&&null!==t&&t.hrtime?(e.exports=function(){return(n()-r)/1e6},o=t.hrtime,n=function(){var e;return e=o(),1e9*e[0]+e[1]},r=n()):Date.now?(e.exports=function(){return Date.now()-r},r=Date.now()):(e.exports=function(){return(new Date).getTime()-r},r=(new Date).getTime())}).call(this)}).call(t,n(10))},function(e,t,n){(function(t){for(var o=n(23),r="undefined"==typeof window?t:window,i=["moz","webkit"],a="AnimationFrame",l=r["request"+a],s=r["cancel"+a]||r["cancelRequest"+a],u=0;!l&&u<i.length;u++)l=r[i[u]+"Request"+a],s=r[i[u]+"Cancel"+a]||r[i[u]+"CancelRequest"+a];if(!l||!s){var c=0,f=0,p=[],d=1e3/60;l=function(e){if(0===p.length){var t=o(),n=Math.max(0,d-(t-c));c=n+t,setTimeout(function(){var e=p.slice(0);p.length=0;for(var t=0;t<e.length;t++)if(!e[t].cancelled)try{e[t].callback(c)}catch(e){setTimeout(function(){throw e},0)}},Math.round(n))}return p.push({handle:++f,callback:e,cancelled:!1}),f},s=function(e){for(var t=0;t<p.length;t++)p[t].handle===e&&(p[t].cancelled=!0)}}e.exports=function(e){return l.call(r,e)},e.exports.cancel=function(){s.apply(r,arguments)},e.exports.polyfill=function(e){e||(e=r),e.requestAnimationFrame=l,e.cancelAnimationFrame=s}}).call(t,function(){return this}())},function(e,t){"use strict";function n(e){var t={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=0);return t}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t){"use strict";function n(e,t,n){for(var o in t)if(Object.prototype.hasOwnProperty.call(t,o)){if(0!==n[o])return!1;var r="number"==typeof t[o]?t[o]:t[o].val;if(e[o]!==r)return!1}return!0}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t){"use strict";function n(e,t,n,r,i,a,l){var s=-i*(t-r),u=-a*n,c=s+u,f=n+c*e,p=t+f*e;return Math.abs(f)<l&&Math.abs(p-r)<l?(o[0]=r,o[1]=0,o):(o[0]=p,o[1]=f,o)}t.__esModule=!0,t.default=n;var o=[0,0];e.exports=t.default},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e){return p?f.default.findDOMNode(e):e}function i(){d||p||(d=!0,console.error("With React 0.14 and later versions, you no longer need to wrap <ScrollArea> child into a function."))}function a(){!d&&p&&(d=!0,console.error("With React 0.13, you need to wrap <ScrollArea> child into a function."))}function l(e){return e<0?0:e}function s(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(e){return e},n={};for(var o in e)e.hasOwnProperty(o)&&(n[o]=t(e[o]));return n}function u(e){var t=e.version;if("string"!=typeof t)return!0;var n=t.split("."),o=parseInt(n[0],10),r=parseInt(n[1],10);return 0===o&&13===r}Object.defineProperty(t,"__esModule",{value:!0}),t.findDOMNode=r,t.warnAboutFunctionChild=i,t.warnAboutElementChild=a,t.positiveOrZero=l,t.modifyObjValues=s,t.isReact13=u;var c=n(1),f=o(c),p=u(f.default),d=!1},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function r(e){if(c===setTimeout)return setTimeout(e,0);if((c===n||!c)&&setTimeout)return c=setTimeout,setTimeout(e,0);try{return c(e,0)}catch(t){try{return c.call(null,e,0)}catch(t){return c.call(this,e,0)}}}function i(e){if(f===clearTimeout)return clearTimeout(e);if((f===o||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function a(){y&&d&&(y=!1,d.length?h=d.concat(h):v=-1,h.length&&l())}function l(){if(!y){var e=r(a);y=!0;for(var t=h.length;t;){for(d=h,h=[];++v<t;)d&&d[v].run();v=-1,t=h.length}d=null,y=!1,i(e)}}function s(e,t){this.fun=e,this.array=t}function u(){}var c,f,p=e.exports={};!function(){try{c="function"==typeof setTimeout?setTimeout:n}catch(e){c=n}try{f="function"==typeof clearTimeout?clearTimeout:o}catch(e){f=o}}();var d,h=[],y=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];h.push(new s(e,t)),1!==h.length||y||r(l)},s.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=u,p.addListener=u,p.once=u,p.off=u,p.removeListener=u,p.removeAllListeners=u,p.emit=u,p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){"use strict";t.__esModule=!0,t.default={noWobble:{stiffness:170,damping:26},gentle:{stiffness:120,damping:14},wobbly:{stiffness:180,damping:12},stiff:{stiffness:210,damping:20}},e.exports=t.default},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e.default:e}t.__esModule=!0;var r=n(24);t.Motion=o(r);var i=n(25);t.StaggeredMotion=o(i);var a=n(26);t.TransitionMotion=o(a);var l=n(29);t.spring=o(l);var s=n(11);t.presets=o(s);var u=n(3);t.stripStyle=o(u);var c=n(28);t.reorderKeys=o(c)},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),c=n(1),f=o(c),p=n(2),d=o(p),h=n(18),y=o(h),v=n(12),m=n(9),b=n(14),S=o(b),g={wheel:"wheel",api:"api",touch:"touch",touchEnd:"touchEnd",mousemove:"mousemove",keyPress:"keypress"},w=function(e){function t(e){r(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={topPosition:0,leftPosition:0,realHeight:0,containerHeight:0,realWidth:0,containerWidth:0},n.scrollArea={refresh:function(){n.setSizesToState()},scrollTop:function(){n.scrollTop()},scrollBottom:function(){n.scrollBottom()},scrollYTo:function(e){n.scrollYTo(e)},scrollLeft:function(){n.scrollLeft()},scrollRight:function(){n.scrollRight()},scrollXTo:function(e){n.scrollXTo(e)}},n.evntsPreviousValues={clientX:0,clientY:0,deltaX:0,deltaY:0},n.bindedHandleWindowResize=n.handleWindowResize.bind(n),n}return a(t,e),u(t,[{key:"getChildContext",value:function(){return{scrollArea:this.scrollArea}}},{key:"componentDidMount",value:function(){this.props.contentWindow&&this.props.contentWindow.addEventListener("resize",this.bindedHandleWindowResize),this.lineHeightPx=(0,y.default)((0,m.findDOMNode)(this.content)),this.setSizesToState()}},{key:"componentWillUnmount",value:function(){this.props.contentWindow&&this.props.contentWindow.removeEventListener("resize",this.bindedHandleWindowResize)}},{key:"componentDidUpdate",value:function(){this.setSizesToState()}},{key:"render",value:function(){var e=this,t=this.props,n=t.children,o=t.className,r=t.contentClassName,i=t.ownerDocument,a=this.props.smoothScrolling&&(this.state.eventType===g.wheel||this.state.eventType===g.api||this.state.eventType===g.touchEnd||this.state.eventType===g.keyPress),l=this.canScrollY()?f.default.createElement(S.default,{ownerDocument:i,realSize:this.state.realHeight,containerSize:this.state.containerHeight,position:this.state.topPosition,onMove:this.handleScrollbarMove.bind(this),onPositionChange:this.handleScrollbarYPositionChange.bind(this),containerStyle:this.props.verticalContainerStyle,scrollbarStyle:this.props.verticalScrollbarStyle,smoothScrolling:a,minScrollSize:this.props.minScrollSize,onFocus:this.focusContent.bind(this),type:"vertical"}):null,u=this.canScrollX()?f.default.createElement(S.default,{ownerDocument:i,realSize:this.state.realWidth,containerSize:this.state.containerWidth,position:this.state.leftPosition,onMove:this.handleScrollbarMove.bind(this),onPositionChange:this.handleScrollbarXPositionChange.bind(this),containerStyle:this.props.horizontalContainerStyle,scrollbarStyle:this.props.horizontalScrollbarStyle,smoothScrolling:a,minScrollSize:this.props.minScrollSize,onFocus:this.focusContent.bind(this),type:"horizontal"}):null;"function"==typeof n?((0,m.warnAboutFunctionChild)(),n=n()):(0,m.warnAboutElementChild)();var c="scrollarea "+(o||""),p="scrollarea-content "+(r||""),d={marginTop:-this.state.topPosition,marginLeft:-this.state.leftPosition},h=a?(0,m.modifyObjValues)(d,function(e){return(0,v.spring)(e)}):d;return f.default.createElement(v.Motion,{style:h},function(t){return f.default.createElement("div",{ref:function(t){return e.wrapper=t},className:c,style:e.props.style,onWheel:e.handleWheel.bind(e)},f.default.createElement("div",{ref:function(t){return e.content=t},style:s({},e.props.contentStyle,t),className:p,onTouchStart:e.handleTouchStart.bind(e),onTouchMove:e.handleTouchMove.bind(e),onTouchEnd:e.handleTouchEnd.bind(e),onKeyDown:e.handleKeyDown.bind(e),tabIndex:e.props.focusableTabIndex},n),l,u)})}},{key:"setStateFromEvent",value:function(e,t){this.props.onScroll&&this.props.onScroll(e),this.setState(s({},e,{eventType:t}))}},{key:"handleTouchStart",value:function(e){var t=e.touches;if(1===t.length){var n=t[0],o=n.clientX,r=n.clientY;this.eventPreviousValues=s({},this.eventPreviousValues,{clientY:r,clientX:o,timestamp:Date.now()})}}},{key:"handleTouchMove",value:function(e){this.canScroll()&&(e.preventDefault(),e.stopPropagation());var t=e.touches;if(1===t.length){var n=t[0],o=n.clientX,r=n.clientY,i=this.eventPreviousValues.clientY-r,a=this.eventPreviousValues.clientX-o;this.eventPreviousValues=s({},this.eventPreviousValues,{deltaY:i,deltaX:a,clientY:r,clientX:o,timestamp:Date.now()}),this.setStateFromEvent(this.composeNewState(-a,-i))}}},{key:"handleTouchEnd",value:function(e){var t=this.eventPreviousValues,n=t.deltaX,o=t.deltaY,r=t.timestamp;"undefined"==typeof n&&(n=0),"undefined"==typeof o&&(o=0),Date.now()-r<200&&this.setStateFromEvent(this.composeNewState(10*-n,10*-o),g.touchEnd),this.eventPreviousValues=s({},this.eventPreviousValues,{deltaY:0,deltaX:0})}},{key:"handleScrollbarMove",value:function(e,t){this.setStateFromEvent(this.composeNewState(t,e))}},{key:"handleScrollbarXPositionChange",value:function(e){this.scrollXTo(e)}},{key:"handleScrollbarYPositionChange",value:function(e){this.scrollYTo(e)}},{key:"handleWheel",value:function(e){var t=e.deltaY,n=e.deltaX;if(this.props.swapWheelAxes){var o=[n,t];t=o[0],n=o[1]}1===e.deltaMode&&(t*=this.lineHeightPx,n*=this.lineHeightPx),t*=this.props.speed,n*=this.props.speed;var r=this.composeNewState(-n,-t);(r.topPosition&&this.state.topPosition!==r.topPosition||r.leftPosition&&this.state.leftPosition!==r.leftPosition||this.props.stopScrollPropagation)&&(e.preventDefault(),e.stopPropagation()),this.setStateFromEvent(r,g.wheel),this.focusContent()}},{key:"handleKeyDown",value:function(e){if("input"!==e.target.tagName.toLowerCase()&&"textarea"!==e.target.tagName.toLowerCase()&&!e.target.isContentEditable){var t=0,n=0,o=this.lineHeightPx?this.lineHeightPx:10;switch(e.keyCode){case 33:t=this.state.containerHeight-o;break;case 34:t=-this.state.containerHeight+o;break;case 37:n=o;break;case 38:t=o;break;case 39:n=-o;break;case 40:t=-o}if(0!==t||0!==n){var r=this.composeNewState(n,t);e.preventDefault(),e.stopPropagation(),this.setStateFromEvent(r,g.keyPress)}}}},{key:"handleWindowResize",value:function(){var e=this.computeSizes();e=this.getModifiedPositionsIfNeeded(e),this.setStateFromEvent(e)}},{key:"composeNewState",value:function(e,t){var n=this.computeSizes();return this.canScrollY(n)?n.topPosition=this.computeTopPosition(t,n):n.topPosition=0,this.canScrollX(n)&&(n.leftPosition=this.computeLeftPosition(e,n)),n}},{key:"computeTopPosition",value:function(e,t){var n=this.state.topPosition-e;return this.normalizeTopPosition(n,t)}},{key:"computeLeftPosition",value:function(e,t){var n=this.state.leftPosition-e;return this.normalizeLeftPosition(n,t)}},{key:"normalizeTopPosition",value:function(e,t){return e>t.realHeight-t.containerHeight&&(e=t.realHeight-t.containerHeight),e<0&&(e=0),e}},{key:"normalizeLeftPosition",value:function(e,t){return e>t.realWidth-t.containerWidth?e=t.realWidth-t.containerWidth:e<0&&(e=0),e}},{key:"computeSizes",value:function(){var e=this.content.offsetHeight,t=this.wrapper.offsetHeight,n=this.content.offsetWidth,o=this.wrapper.offsetWidth;return{realHeight:e,containerHeight:t,realWidth:n,containerWidth:o}}},{key:"setSizesToState",value:function(){var e=this.computeSizes();e.realHeight===this.state.realHeight&&e.realWidth===this.state.realWidth||this.setStateFromEvent(this.getModifiedPositionsIfNeeded(e))}},{key:"scrollTop",value:function(){this.scrollYTo(0)}},{key:"scrollBottom",value:function(){this.scrollYTo(this.state.realHeight-this.state.containerHeight)}},{key:"scrollLeft",value:function(){this.scrollXTo(0)}},{key:"scrollRight",value:function(){this.scrollXTo(this.state.realWidth-this.state.containerWidth)}},{key:"scrollYTo",value:function(e){if(this.canScrollY()){var t=this.normalizeTopPosition(e,this.computeSizes());this.setStateFromEvent({topPosition:t},g.api)}}},{key:"scrollXTo",value:function(e){if(this.canScrollX()){var t=this.normalizeLeftPosition(e,this.computeSizes());this.setStateFromEvent({leftPosition:t},g.api)}}},{key:"canScrollY",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.state,t=e.realHeight>e.containerHeight;return t&&this.props.vertical}},{key:"canScrollX",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.state,t=e.realWidth>e.containerWidth;return t&&this.props.horizontal}},{key:"canScroll",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.state;return this.canScrollY(e)||this.canScrollX(e)}},{key:"getModifiedPositionsIfNeeded",value:function(e){var t=e.realHeight-e.containerHeight;this.state.topPosition>=t&&(e.topPosition=this.canScrollY(e)?(0,m.positiveOrZero)(t):0);var n=e.realWidth-e.containerWidth;return this.state.leftPosition>=n&&(e.leftPosition=this.canScrollX(e)?(0,m.positiveOrZero)(n):0),e}},{key:"focusContent",value:function(){this.content&&(0,m.findDOMNode)(this.content).focus()}}]),t}(f.default.Component);t.default=w,w.childContextTypes={scrollArea:d.default.object},w.propTypes={className:d.default.string,style:d.default.object,speed:d.default.number,contentClassName:d.default.string,contentStyle:d.default.object,vertical:d.default.bool,verticalContainerStyle:d.default.object,verticalScrollbarStyle:d.default.object,horizontal:d.default.bool,horizontalContainerStyle:d.default.object,horizontalScrollbarStyle:d.default.object,onScroll:d.default.func,contentWindow:d.default.any,ownerDocument:d.default.any,smoothScrolling:d.default.bool,minScrollSize:d.default.number,swapWheelAxes:d.default.bool,stopScrollPropagation:d.default.bool,focusableTabIndex:d.default.number},w.defaultProps={speed:1,vertical:!0,horizontal:!0,smoothScrolling:!1,swapWheelAxes:!1,contentWindow:"object"===("undefined"==typeof window?"undefined":l(window))?window:void 0,ownerDocument:"object"===("undefined"==typeof document?"undefined":l(document))?document:void 0,focusableTabIndex:1}},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},s=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),u=n(1),c=o(u),f=n(2),p=o(f),d=n(12),h=n(9),y=function(e){function t(e){r(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e)),o=n.calculateState(e);return n.state={position:o.position,scrollSize:o.scrollSize,isDragging:!1,lastClientPosition:0},"vertical"===e.type?n.bindedHandleMouseMove=n.handleMouseMoveForVertical.bind(n):n.bindedHandleMouseMove=n.handleMouseMoveForHorizontal.bind(n),n.bindedHandleMouseUp=n.handleMouseUp.bind(n),n}return a(t,e),s(t,[{key:"componentDidMount",value:function(){this.props.ownerDocument&&(this.props.ownerDocument.addEventListener("mousemove",this.bindedHandleMouseMove),this.props.ownerDocument.addEventListener("mouseup",this.bindedHandleMouseUp))}},{key:"componentWillReceiveProps",value:function(e){this.setState(this.calculateState(e))}},{key:"componentWillUnmount",value:function(){this.props.ownerDocument&&(this.props.ownerDocument.removeEventListener("mousemove",this.bindedHandleMouseMove),this.props.ownerDocument.removeEventListener("mouseup",this.bindedHandleMouseUp))}},{key:"calculateFractionalPosition",value:function(e,t,n){var o=e-t;return 1-(o-n)/o}},{key:"calculateState",value:function(e){var t=this.calculateFractionalPosition(e.realSize,e.containerSize,e.position),n=e.containerSize*e.containerSize/e.realSize,o=n<e.minScrollSize?e.minScrollSize:n,r=(e.containerSize-o)*t;return{scrollSize:o,position:Math.round(r)}}},{key:"render",value:function(){var e=this,t=this.props,n=t.smoothScrolling,o=t.isDragging,r=t.type,i=t.scrollbarStyle,a=t.containerStyle,s="horizontal"===r,u="vertical"===r,f=this.createScrollStyles(),p=n?(0,h.modifyObjValues)(f,function(e){return(0,d.spring)(e)}):f,y="scrollbar-container "+(o?"active":"")+" "+(s?"horizontal":"")+" "+(u?"vertical":"");return c.default.createElement(d.Motion,{style:p},function(t){return c.default.createElement("div",{className:y,style:a,onMouseDown:e.handleScrollBarContainerClick.bind(e),ref:function(t){return e.scrollbarContainer=t}},c.default.createElement("div",{className:"scrollbar",style:l({},i,t),onMouseDown:e.handleMouseDown.bind(e)}))})}},{key:"handleScrollBarContainerClick",value:function(e){e.preventDefault();var t=this.computeMultiplier(),n=this.isVertical()?e.clientY:e.clientX,o=this.scrollbarContainer.getBoundingClientRect(),r=o.top,i=o.left,a=this.isVertical()?r:i,l=n-a,s=this.props.containerSize*this.props.containerSize/this.props.realSize;this.setState({isDragging:!0,lastClientPosition:n}),this.props.onPositionChange((l-s/2)/t)}},{key:"handleMouseMoveForHorizontal",value:function(e){var t=this.computeMultiplier();if(this.state.isDragging){e.preventDefault();var n=this.state.lastClientPosition-e.clientX;this.setState({lastClientPosition:e.clientX}),this.props.onMove(0,n/t)}}},{key:"handleMouseMoveForVertical",value:function(e){var t=this.computeMultiplier();if(this.state.isDragging){e.preventDefault();var n=this.state.lastClientPosition-e.clientY;this.setState({lastClientPosition:e.clientY}),this.props.onMove(n/t,0)}}},{key:"handleMouseDown",value:function(e){e.preventDefault(),e.stopPropagation();var t=this.isVertical()?e.clientY:e.clientX;this.setState({isDragging:!0,lastClientPosition:t}),this.props.onFocus()}},{key:"handleMouseUp",value:function(e){this.state.isDragging&&(e.preventDefault(),this.setState({isDragging:!1}))}},{key:"createScrollStyles",value:function(){return"vertical"===this.props.type?{height:this.state.scrollSize,marginTop:this.state.position}:{width:this.state.scrollSize,marginLeft:this.state.position}}},{key:"computeMultiplier",value:function(){return this.props.containerSize/this.props.realSize}},{key:"isVertical",value:function(){return"vertical"===this.props.type}}]),t}(c.default.Component);y.propTypes={onMove:p.default.func,onPositionChange:p.default.func,onFocus:p.default.func,realSize:p.default.number,containerSize:p.default.number,position:p.default.number,containerStyle:p.default.object,scrollbarStyle:p.default.object,type:p.default.oneOf(["vertical","horizontal"]),ownerDocument:p.default.any,smoothScrolling:p.default.bool,minScrollSize:p.default.number},y.defaultProps={type:"vertical",smoothScrolling:!1},t.default=y},function(e,t){var n=function(e,t,n){return n=window.getComputedStyle,(n?n(e):e.currentStyle)[t.replace(/-(\w)/gi,function(e,t){return t.toUpperCase()})]};e.exports=n},function(e,t,n){t=e.exports=n(17)(),t.push([e.id,".scrollarea-content{margin:0;padding:0;overflow:hidden;position:relative}.scrollarea-content:focus{outline:0}.scrollarea{position:relative;overflow:hidden}.scrollarea .scrollbar-container{position:absolute;background:none;opacity:.1;z-index:9999;-webkit-transition:all .4s;transition:all .4s}.scrollarea .scrollbar-container.horizontal{width:100%;height:10px;left:0;bottom:0}.scrollarea .scrollbar-container.horizontal .scrollbar{width:20px;height:8px;background:#000;margin-top:1px}.scrollarea .scrollbar-container.vertical{width:10px;height:100%;right:0;top:0}.scrollarea .scrollbar-container.vertical .scrollbar{width:8px;height:20px;background:#000;margin-left:1px}.scrollarea .scrollbar-container.active,.scrollarea .scrollbar-container:hover{background:gray;opacity:.6!important}.scrollarea:hover .scrollbar-container{opacity:.3}",""])},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var n=this[t];n[2]?e.push("@media "+n[2]+"{"+n[1]+"}"):e.push(n[1])}return e.join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var o={},r=0;r<this.length;r++){var i=this[r][0];"number"==typeof i&&(o[i]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&o[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),e.push(a))}},e}},function(e,t,n){function o(e){var t=r(e,"line-height"),n=parseFloat(t,10);if(t===n+""){var o=e.style.lineHeight;e.style.lineHeight=t+"em",t=r(e,"line-height"),n=parseFloat(t,10),o?e.style.lineHeight=o:delete e.style.lineHeight}if(t.indexOf("pt")!==-1?(n*=4,n/=3):t.indexOf("mm")!==-1?(n*=96,n/=25.4):t.indexOf("cm")!==-1?(n*=96,n/=2.54):t.indexOf("in")!==-1?n*=96:t.indexOf("pc")!==-1&&(n*=16),n=Math.round(n),"normal"===t){var i=e.nodeName,a=document.createElement(i);a.innerHTML="&nbsp;";var l=r(e,"font-size");a.style.fontSize=l;var s=document.body;s.appendChild(a);var u=a.offsetHeight;n=u,s.removeChild(a)}return n}var r=n(15);e.exports=o},function(e,t,n){"use strict";var o=n(21),r=n(22),i=n(20);e.exports=function(){function e(e,t,n,o,a,l){l!==i&&r(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=o,n.PropTypes=n,n}},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t){"use strict";function n(e){return function(){return e}}var o=function(){};o.thatReturns=n,o.thatReturnsFalse=n(!1),o.thatReturnsTrue=n(!0),o.thatReturnsNull=n(null),o.thatReturnsThis=function(){return this},o.thatReturnsArgument=function(e){return e},e.exports=o},function(e,t,n){"use strict";function o(e,t,n,o,i,a,l,s){if(r(t),!e){var u;if(void 0===t)u=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[n,o,i,a,l,s],f=0;u=new Error(t.replace(/%s/g,function(){return c[f++]})),u.name="Invariant Violation"}throw u.framesToPop=1,u}}var r=function(e){};e.exports=o},function(e,t,n){(function(t){(function(){var n,o,r,i,a,l;"undefined"!=typeof performance&&null!==performance&&performance.now?e.exports=function(){return performance.now()}:"undefined"!=typeof t&&null!==t&&t.hrtime?(e.exports=function(){return(n()-a)/1e6},o=t.hrtime,n=function(){var e;return e=o(),1e9*e[0]+e[1]},i=n(),l=1e9*t.uptime(),a=i-l):Date.now?(e.exports=function(){return Date.now()-r},r=Date.now()):(e.exports=function(){return(new Date).getTime()-r},r=(new Date).getTime())}).call(this)}).call(t,n(10))},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}t.__esModule=!0;var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),s=n(6),u=o(s),c=n(3),f=o(c),p=n(8),d=o(p),h=n(4),y=o(h),v=n(5),m=o(v),b=n(7),S=o(b),g=n(1),w=o(g),P=n(2),T=o(P),k=1e3/60,O=function(e){function t(n){var o=this;r(this,t),e.call(this,n),this.wasAnimating=!1,this.animationID=null,this.prevTime=0,this.accumulatedTime=0,this.unreadPropStyle=null,this.clearUnreadPropStyle=function(e){var t=!1,n=o.state,r=n.currentStyle,i=n.currentVelocity,l=n.lastIdealStyle,s=n.lastIdealVelocity;for(var u in e)if(Object.prototype.hasOwnProperty.call(e,u)){var c=e[u];"number"==typeof c&&(t||(t=!0,r=a({},r),i=a({},i),l=a({},l),s=a({},s)),r[u]=c,i[u]=0,l[u]=c,s[u]=0)}t&&o.setState({currentStyle:r,currentVelocity:i,lastIdealStyle:l,lastIdealVelocity:s})},this.startAnimationIfNecessary=function(){o.animationID=m.default(function(e){var t=o.props.style;if(S.default(o.state.currentStyle,t,o.state.currentVelocity))return o.wasAnimating&&o.props.onRest&&o.props.onRest(),o.animationID=null,o.wasAnimating=!1,void(o.accumulatedTime=0);o.wasAnimating=!0;var n=e||y.default(),r=n-o.prevTime;if(o.prevTime=n,o.accumulatedTime=o.accumulatedTime+r,o.accumulatedTime>10*k&&(o.accumulatedTime=0),0===o.accumulatedTime)return o.animationID=null,void o.startAnimationIfNecessary();var i=(o.accumulatedTime-Math.floor(o.accumulatedTime/k)*k)/k,a=Math.floor(o.accumulatedTime/k),l={},s={},u={},c={};for(var f in t)if(Object.prototype.hasOwnProperty.call(t,f)){var p=t[f];if("number"==typeof p)u[f]=p,c[f]=0,l[f]=p,s[f]=0;else{for(var h=o.state.lastIdealStyle[f],v=o.state.lastIdealVelocity[f],m=0;m<a;m++){var b=d.default(k/1e3,h,v,p.val,p.stiffness,p.damping,p.precision);h=b[0],v=b[1]}var g=d.default(k/1e3,h,v,p.val,p.stiffness,p.damping,p.precision),w=g[0],P=g[1];u[f]=h+(w-h)*i,c[f]=v+(P-v)*i,l[f]=h,s[f]=v}}o.animationID=null,o.accumulatedTime-=a*k,o.setState({currentStyle:u,currentVelocity:c,lastIdealStyle:l,lastIdealVelocity:s}),o.unreadPropStyle=null,o.startAnimationIfNecessary()})},this.state=this.defaultState()}return i(t,e),l(t,null,[{key:"propTypes",value:{defaultStyle:T.default.objectOf(T.default.number),style:T.default.objectOf(T.default.oneOfType([T.default.number,T.default.object])).isRequired,children:T.default.func.isRequired,onRest:T.default.func},enumerable:!0}]),t.prototype.defaultState=function(){var e=this.props,t=e.defaultStyle,n=e.style,o=t||f.default(n),r=u.default(o);return{currentStyle:o,currentVelocity:r,lastIdealStyle:o,lastIdealVelocity:r}},t.prototype.componentDidMount=function(){this.prevTime=y.default(),this.startAnimationIfNecessary()},t.prototype.componentWillReceiveProps=function(e){null!=this.unreadPropStyle&&this.clearUnreadPropStyle(this.unreadPropStyle),this.unreadPropStyle=e.style,null==this.animationID&&(this.prevTime=y.default(),this.startAnimationIfNecessary())},t.prototype.componentWillUnmount=function(){null!=this.animationID&&(m.default.cancel(this.animationID),this.animationID=null)},t.prototype.render=function(){var e=this.props.children(this.state.currentStyle);return e&&w.default.Children.only(e)},t}(w.default.Component);t.default=O,e.exports=t.default},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e,t,n){for(var o=0;o<e.length;o++)if(!g.default(e[o],t[o],n[o]))return!1;return!0}t.__esModule=!0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},s=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),u=n(6),c=o(u),f=n(3),p=o(f),d=n(8),h=o(d),y=n(4),v=o(y),m=n(5),b=o(m),S=n(7),g=o(S),w=n(1),P=o(w),T=n(2),k=o(T),O=1e3/60,M=function(e){function t(n){var o=this;r(this,t),e.call(this,n),this.animationID=null,this.prevTime=0,this.accumulatedTime=0,this.unreadPropStyles=null,this.clearUnreadPropStyle=function(e){for(var t=o.state,n=t.currentStyles,r=t.currentVelocities,i=t.lastIdealStyles,a=t.lastIdealVelocities,s=!1,u=0;u<e.length;u++){var c=e[u],f=!1;for(var p in c)if(Object.prototype.hasOwnProperty.call(c,p)){var d=c[p];"number"==typeof d&&(f||(f=!0,s=!0,n[u]=l({},n[u]),r[u]=l({},r[u]),i[u]=l({},i[u]),a[u]=l({},a[u])),n[u][p]=d,r[u][p]=0,i[u][p]=d,a[u][p]=0)}}s&&o.setState({currentStyles:n,currentVelocities:r,lastIdealStyles:i,lastIdealVelocities:a})},this.startAnimationIfNecessary=function(){o.animationID=b.default(function(e){
	var t=o.props.styles(o.state.lastIdealStyles);if(a(o.state.currentStyles,t,o.state.currentVelocities))return o.animationID=null,void(o.accumulatedTime=0);var n=e||v.default(),r=n-o.prevTime;if(o.prevTime=n,o.accumulatedTime=o.accumulatedTime+r,o.accumulatedTime>10*O&&(o.accumulatedTime=0),0===o.accumulatedTime)return o.animationID=null,void o.startAnimationIfNecessary();for(var i=(o.accumulatedTime-Math.floor(o.accumulatedTime/O)*O)/O,l=Math.floor(o.accumulatedTime/O),s=[],u=[],c=[],f=[],p=0;p<t.length;p++){var d=t[p],y={},m={},b={},S={};for(var g in d)if(Object.prototype.hasOwnProperty.call(d,g)){var w=d[g];if("number"==typeof w)y[g]=w,m[g]=0,b[g]=w,S[g]=0;else{for(var P=o.state.lastIdealStyles[p][g],T=o.state.lastIdealVelocities[p][g],k=0;k<l;k++){var M=h.default(O/1e3,P,T,w.val,w.stiffness,w.damping,w.precision);P=M[0],T=M[1]}var x=h.default(O/1e3,P,T,w.val,w.stiffness,w.damping,w.precision),I=x[0],D=x[1];y[g]=P+(I-P)*i,m[g]=T+(D-T)*i,b[g]=P,S[g]=T}}c[p]=y,f[p]=m,s[p]=b,u[p]=S}o.animationID=null,o.accumulatedTime-=l*O,o.setState({currentStyles:c,currentVelocities:f,lastIdealStyles:s,lastIdealVelocities:u}),o.unreadPropStyles=null,o.startAnimationIfNecessary()})},this.state=this.defaultState()}return i(t,e),s(t,null,[{key:"propTypes",value:{defaultStyles:k.default.arrayOf(k.default.objectOf(k.default.number)),styles:k.default.func.isRequired,children:k.default.func.isRequired},enumerable:!0}]),t.prototype.defaultState=function(){var e=this.props,t=e.defaultStyles,n=e.styles,o=t||n().map(p.default),r=o.map(function(e){return c.default(e)});return{currentStyles:o,currentVelocities:r,lastIdealStyles:o,lastIdealVelocities:r}},t.prototype.componentDidMount=function(){this.prevTime=v.default(),this.startAnimationIfNecessary()},t.prototype.componentWillReceiveProps=function(e){null!=this.unreadPropStyles&&this.clearUnreadPropStyle(this.unreadPropStyles),this.unreadPropStyles=e.styles(this.state.lastIdealStyles),null==this.animationID&&(this.prevTime=v.default(),this.startAnimationIfNecessary())},t.prototype.componentWillUnmount=function(){null!=this.animationID&&(b.default.cancel(this.animationID),this.animationID=null)},t.prototype.render=function(){var e=this.props.children(this.state.currentStyles);return e&&P.default.Children.only(e)},t}(P.default.Component);t.default=M,e.exports=t.default},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e,t,n){var o=t;return null==o?e.map(function(e,t){return{key:e.key,data:e.data,style:n[t]}}):e.map(function(e,t){for(var r=0;r<o.length;r++)if(o[r].key===e.key)return{key:o[r].key,data:o[r].data,style:n[t]};return{key:e.key,data:e.data,style:n[t]}})}function l(e,t,n,o){if(o.length!==t.length)return!1;for(var r=0;r<o.length;r++)if(o[r].key!==t[r].key)return!1;for(var r=0;r<o.length;r++)if(!k.default(e[r],t[r].style,n[r]))return!1;return!0}function s(e,t,n,o,r,i,a,l,s){for(var u=b.default(o,r,function(e,o){var r=t(o);return null==r?(n({key:o.key,data:o.data}),null):k.default(i[e],r,a[e])?(n({key:o.key,data:o.data}),null):{key:o.key,data:o.data,style:r}}),c=[],f=[],d=[],h=[],y=0;y<u.length;y++){for(var v=u[y],m=null,S=0;S<o.length;S++)if(o[S].key===v.key){m=S;break}if(null==m){var g=e(v);c[y]=g,d[y]=g;var w=p.default(v.style);f[y]=w,h[y]=w}else c[y]=i[m],d[y]=l[m],f[y]=a[m],h[y]=s[m]}return[u,c,f,d,h]}t.__esModule=!0;var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),f=n(6),p=o(f),d=n(3),h=o(d),y=n(8),v=o(y),m=n(27),b=o(m),S=n(4),g=o(S),w=n(5),P=o(w),T=n(7),k=o(T),O=n(1),M=o(O),x=n(2),I=o(x),D=1e3/60,_=function(e){function t(n){var o=this;r(this,t),e.call(this,n),this.unmounting=!1,this.animationID=null,this.prevTime=0,this.accumulatedTime=0,this.unreadPropStyles=null,this.clearUnreadPropStyle=function(e){for(var t=s(o.props.willEnter,o.props.willLeave,o.props.didLeave,o.state.mergedPropsStyles,e,o.state.currentStyles,o.state.currentVelocities,o.state.lastIdealStyles,o.state.lastIdealVelocities),n=t[0],r=t[1],i=t[2],a=t[3],l=t[4],c=0;c<e.length;c++){var f=e[c].style,p=!1;for(var d in f)if(Object.prototype.hasOwnProperty.call(f,d)){var h=f[d];"number"==typeof h&&(p||(p=!0,r[c]=u({},r[c]),i[c]=u({},i[c]),a[c]=u({},a[c]),l[c]=u({},l[c]),n[c]={key:n[c].key,data:n[c].data,style:u({},n[c].style)}),r[c][d]=h,i[c][d]=0,a[c][d]=h,l[c][d]=0,n[c].style[d]=h)}}o.setState({currentStyles:r,currentVelocities:i,mergedPropsStyles:n,lastIdealStyles:a,lastIdealVelocities:l})},this.startAnimationIfNecessary=function(){o.unmounting||(o.animationID=P.default(function(e){if(!o.unmounting){var t=o.props.styles,n="function"==typeof t?t(a(o.state.mergedPropsStyles,o.unreadPropStyles,o.state.lastIdealStyles)):t;if(l(o.state.currentStyles,n,o.state.currentVelocities,o.state.mergedPropsStyles))return o.animationID=null,void(o.accumulatedTime=0);var r=e||g.default(),i=r-o.prevTime;if(o.prevTime=r,o.accumulatedTime=o.accumulatedTime+i,o.accumulatedTime>10*D&&(o.accumulatedTime=0),0===o.accumulatedTime)return o.animationID=null,void o.startAnimationIfNecessary();for(var u=(o.accumulatedTime-Math.floor(o.accumulatedTime/D)*D)/D,c=Math.floor(o.accumulatedTime/D),f=s(o.props.willEnter,o.props.willLeave,o.props.didLeave,o.state.mergedPropsStyles,n,o.state.currentStyles,o.state.currentVelocities,o.state.lastIdealStyles,o.state.lastIdealVelocities),p=f[0],d=f[1],h=f[2],y=f[3],m=f[4],b=0;b<p.length;b++){var S=p[b].style,w={},P={},T={},k={};for(var O in S)if(Object.prototype.hasOwnProperty.call(S,O)){var M=S[O];if("number"==typeof M)w[O]=M,P[O]=0,T[O]=M,k[O]=0;else{for(var x=y[b][O],I=m[b][O],_=0;_<c;_++){var j=v.default(D/1e3,x,I,M.val,M.stiffness,M.damping,M.precision);x=j[0],I=j[1]}var C=v.default(D/1e3,x,I,M.val,M.stiffness,M.damping,M.precision),z=C[0],E=C[1];w[O]=x+(z-x)*u,P[O]=I+(E-I)*u,T[O]=x,k[O]=I}}y[b]=T,m[b]=k,d[b]=w,h[b]=P}o.animationID=null,o.accumulatedTime-=c*D,o.setState({currentStyles:d,currentVelocities:h,lastIdealStyles:y,lastIdealVelocities:m,mergedPropsStyles:p}),o.unreadPropStyles=null,o.startAnimationIfNecessary()}}))},this.state=this.defaultState()}return i(t,e),c(t,null,[{key:"propTypes",value:{defaultStyles:I.default.arrayOf(I.default.shape({key:I.default.string.isRequired,data:I.default.any,style:I.default.objectOf(I.default.number).isRequired})),styles:I.default.oneOfType([I.default.func,I.default.arrayOf(I.default.shape({key:I.default.string.isRequired,data:I.default.any,style:I.default.objectOf(I.default.oneOfType([I.default.number,I.default.object])).isRequired}))]).isRequired,children:I.default.func.isRequired,willEnter:I.default.func,willLeave:I.default.func,didLeave:I.default.func},enumerable:!0},{key:"defaultProps",value:{willEnter:function(e){return h.default(e.style)},willLeave:function(){return null},didLeave:function(){}},enumerable:!0}]),t.prototype.defaultState=function(){var e=this.props,t=e.defaultStyles,n=e.styles,o=e.willEnter,r=e.willLeave,i=e.didLeave,a="function"==typeof n?n(t):n,l=void 0;l=null==t?a:t.map(function(e){for(var t=0;t<a.length;t++)if(a[t].key===e.key)return a[t];return e});var u=null==t?a.map(function(e){return h.default(e.style)}):t.map(function(e){return h.default(e.style)}),c=null==t?a.map(function(e){return p.default(e.style)}):t.map(function(e){return p.default(e.style)}),f=s(o,r,i,l,a,u,c,u,c),d=f[0],y=f[1],v=f[2],m=f[3],b=f[4];return{currentStyles:y,currentVelocities:v,lastIdealStyles:m,lastIdealVelocities:b,mergedPropsStyles:d}},t.prototype.componentDidMount=function(){this.prevTime=g.default(),this.startAnimationIfNecessary()},t.prototype.componentWillReceiveProps=function(e){this.unreadPropStyles&&this.clearUnreadPropStyle(this.unreadPropStyles);var t=e.styles;"function"==typeof t?this.unreadPropStyles=t(a(this.state.mergedPropsStyles,this.unreadPropStyles,this.state.lastIdealStyles)):this.unreadPropStyles=t,null==this.animationID&&(this.prevTime=g.default(),this.startAnimationIfNecessary())},t.prototype.componentWillUnmount=function(){this.unmounting=!0,null!=this.animationID&&(P.default.cancel(this.animationID),this.animationID=null)},t.prototype.render=function(){var e=a(this.state.mergedPropsStyles,this.unreadPropStyles,this.state.currentStyles),t=this.props.children(e);return t&&M.default.Children.only(t)},t}(M.default.Component);t.default=_,e.exports=t.default},function(e,t){"use strict";function n(e,t,n){for(var o={},r=0;r<e.length;r++)o[e[r].key]=r;for(var i={},r=0;r<t.length;r++)i[t[r].key]=r;for(var a=[],r=0;r<t.length;r++)a[r]=t[r];for(var r=0;r<e.length;r++)if(!Object.prototype.hasOwnProperty.call(i,e[r].key)){var l=n(r,e[r]);null!=l&&a.push(l)}return a.sort(function(e,n){var r=i[e.key],a=i[n.key],l=o[e.key],s=o[n.key];if(null!=r&&null!=a)return i[e.key]-i[n.key];if(null!=l&&null!=s)return o[e.key]-o[n.key];if(null!=r){for(var u=0;u<t.length;u++){var c=t[u].key;if(Object.prototype.hasOwnProperty.call(o,c)){if(r<i[c]&&s>o[c])return-1;if(r>i[c]&&s<o[c])return 1}}return 1}for(var u=0;u<t.length;u++){var c=t[u].key;if(Object.prototype.hasOwnProperty.call(o,c)){if(a<i[c]&&l>o[c])return 1;if(a>i[c]&&l<o[c])return-1}}return-1})}t.__esModule=!0,t.default=n,e.exports=t.default},function(e,t,n){"use strict";function o(){}t.__esModule=!0,t.default=o;e.exports=t.default},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}function r(e,t){return i({},s,t,{val:e})}t.__esModule=!0;var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e};t.default=r;var a=n(11),l=o(a),s=i({},l.default.noWobble,{precision:.01});e.exports=t.default},function(e,t,n){function o(e,t){for(var n=0;n<e.length;n++){var o=e[n],r=d[o.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](o.parts[i]);for(;i<o.parts.length;i++)r.parts.push(u(o.parts[i],t))}else{for(var a=[],i=0;i<o.parts.length;i++)a.push(u(o.parts[i],t));d[o.id]={id:o.id,refs:1,parts:a}}}}function r(e){for(var t=[],n={},o=0;o<e.length;o++){var r=e[o],i=r[0],a=r[1],l=r[2],s=r[3],u={css:a,media:l,sourceMap:s};n[i]?n[i].parts.push(u):t.push(n[i]={id:i,parts:[u]})}return t}function i(e,t){var n=v(),o=S[S.length-1];if("top"===e.insertAt)o?o.nextSibling?n.insertBefore(t,o.nextSibling):n.appendChild(t):n.insertBefore(t,n.firstChild),S.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(t)}}function a(e){e.parentNode.removeChild(e);var t=S.indexOf(e);t>=0&&S.splice(t,1)}function l(e){var t=document.createElement("style");return t.type="text/css",i(e,t),t}function s(e){var t=document.createElement("link");return t.rel="stylesheet",i(e,t),t}function u(e,t){var n,o,r;if(t.singleton){var i=b++;n=m||(m=l(t)),o=c.bind(null,n,i,!1),r=c.bind(null,n,i,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=s(t),o=p.bind(null,n),r=function(){a(n),n.href&&URL.revokeObjectURL(n.href)}):(n=l(t),o=f.bind(null,n),r=function(){a(n)});return o(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;o(e=t)}else r()}}function c(e,t,n,o){var r=n?"":o.css;if(e.styleSheet)e.styleSheet.cssText=g(t,r);else{var i=document.createTextNode(r),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(i,a[t]):e.appendChild(i)}}function f(e,t){var n=t.css,o=t.media;if(o&&e.setAttribute("media",o),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}function p(e,t){var n=t.css,o=t.sourceMap;o&&(n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */");var r=new Blob([n],{type:"text/css"}),i=e.href;e.href=URL.createObjectURL(r),i&&URL.revokeObjectURL(i)}var d={},h=function(e){var t;return function(){return"undefined"==typeof t&&(t=e.apply(this,arguments)),t}},y=h(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),v=h(function(){return document.head||document.getElementsByTagName("head")[0]}),m=null,b=0,S=[];e.exports=function(e,t){t=t||{},"undefined"==typeof t.singleton&&(t.singleton=y()),"undefined"==typeof t.insertAt&&(t.insertAt="bottom");var n=r(e);return o(n,t),function(e){for(var i=[],a=0;a<n.length;a++){var l=n[a],s=d[l.id];s.refs--,i.push(s)}if(e){var u=r(e);o(u,t)}for(var a=0;a<i.length;a++){var s=i[a];if(0===s.refs){for(var c=0;c<s.parts.length;c++)s.parts[c]();delete d[s.id]}}}};var g=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t,n){var o=n(16);"string"==typeof o&&(o=[[e.id,o,""]]);n(30)(o,{});o.locals&&(e.exports=o.locals)}])});

/***/ },
/* 912 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(145);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(913);
	var ReactElement = __webpack_require__(129);
	
	var emptyFunction = __webpack_require__(66);
	var traverseAllChildren = __webpack_require__(923);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(129);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(129),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(297);
	
	module.exports = factory(isValidElement);

/***/ },
/* 917 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(392),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(129),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(395);
	var factory = __webpack_require__(637);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 919 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 920 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(145);
	
	var ReactElement = __webpack_require__(129);
	
	var invariant = __webpack_require__(19);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(145);
	
	var ReactCurrentOwner = __webpack_require__(86);
	var REACT_ELEMENT_TYPE = __webpack_require__(394);
	
	var getIteratorFn = __webpack_require__(919);
	var invariant = __webpack_require__(19);
	var KeyEscapeUtils = __webpack_require__(912);
	var warning = __webpack_require__(29);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.printBuffer = printBuffer;
	
	var _helpers = __webpack_require__(397);
	
	var _diff = __webpack_require__(926);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get log level string based on supplied params
	 *
	 * @param {string | function | object} level - console[level]
	 * @param {object} action - selected action
	 * @param {array} payload - selected payload
	 * @param {string} type - log entry type
	 *
	 * @returns {string} level
	 */
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
	    case 'object':
	      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case 'function':
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	function defaultTitleFormatter(options) {
	  var timestamp = options.timestamp,
	      duration = options.duration;
	
	
	  return function (action, time, took) {
	    var parts = ['action'];
	
	    parts.push('%c' + String(action.type));
	    if (timestamp) parts.push('%c@ ' + time);
	    if (duration) parts.push('%c(in ' + took.toFixed(2) + ' ms)');
	
	    return parts.join(' ');
	  };
	}
	
	function printBuffer(buffer, options) {
	  var logger = options.logger,
	      actionTransformer = options.actionTransformer,
	      _options$titleFormatt = options.titleFormatter,
	      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
	      collapsed = options.collapsed,
	      colors = options.colors,
	      level = options.level,
	      diff = options.diff;
	
	
	  buffer.forEach(function (logEntry, key) {
	    var started = logEntry.started,
	        startedTime = logEntry.startedTime,
	        action = logEntry.action,
	        prevState = logEntry.prevState,
	        error = logEntry.error;
	    var took = logEntry.took,
	        nextState = logEntry.nextState;
	
	    var nextEntry = buffer[key + 1];
	
	    if (nextEntry) {
	      nextState = nextEntry.prevState;
	      took = nextEntry.started - started;
	    }
	
	    // Message
	    var formattedAction = actionTransformer(action);
	    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
	      return nextState;
	    }, action, logEntry) : collapsed;
	
	    var formattedTime = (0, _helpers.formatTime)(startedTime);
	    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : '';
	    var headerCSS = ['color: gray; font-weight: lighter;'];
	    headerCSS.push(titleCSS);
	    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
	    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
	    var title = titleFormatter(formattedAction, formattedTime, took);
	
	    // Render
	    try {
	      if (isCollapsed) {
	        if (colors.title) logger.groupCollapsed.apply(logger, ['%c ' + title].concat(headerCSS));else logger.groupCollapsed(title);
	      } else {
	        if (colors.title) logger.group.apply(logger, ['%c ' + title].concat(headerCSS));else logger.group(title);
	      }
	    } catch (e) {
	      logger.log(title);
	    }
	
	    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
	    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
	    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
	    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');
	
	    if (prevStateLevel) {
	      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
	    }
	
	    if (actionLevel) {
	      if (colors.action) logger[actionLevel]('%c action    ', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action    ', formattedAction);
	    }
	
	    if (error && errorLevel) {
	      if (colors.error) logger[errorLevel]('%c error     ', 'color: ' + colors.error(error, prevState) + '; font-weight: bold;', error);else logger[errorLevel]('error     ', error);
	    }
	
	    if (nextStateLevel) {
	      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
	    }
	
	    if (diff) {
	      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
	    }
	
	    try {
	      logger.groupEnd();
	    } catch (e) {
	      logger.log('\u2014\u2014 log end \u2014\u2014');
	    }
	  });
	}

/***/ },
/* 925 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  level: "log",
	  logger: console,
	  logErrors: true,
	  collapsed: undefined,
	  predicate: undefined,
	  duration: false,
	  timestamp: true,
	  stateTransformer: function stateTransformer(state) {
	    return state;
	  },
	  actionTransformer: function actionTransformer(action) {
	    return action;
	  },
	  errorTransformer: function errorTransformer(error) {
	    return error;
	  },
	  colors: {
	    title: function title() {
	      return "inherit";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  },
	  diff: false,
	  diffPredicate: undefined,
	
	  // Deprecated options
	  transformer: undefined
	};
	module.exports = exports["default"];

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = diffLogger;
	
	var _deepDiff = __webpack_require__(639);
	
	var _deepDiff2 = _interopRequireDefault(_deepDiff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// https://github.com/flitbit/diff#differences
	var dictionary = {
	  'E': {
	    color: '#2196F3',
	    text: 'CHANGED:'
	  },
	  'N': {
	    color: '#4CAF50',
	    text: 'ADDED:'
	  },
	  'D': {
	    color: '#F44336',
	    text: 'DELETED:'
	  },
	  'A': {
	    color: '#2196F3',
	    text: 'ARRAY:'
	  }
	};
	
	function style(kind) {
	  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
	}
	
	function render(diff) {
	  var kind = diff.kind,
	      path = diff.path,
	      lhs = diff.lhs,
	      rhs = diff.rhs,
	      index = diff.index,
	      item = diff.item;
	
	
	  switch (kind) {
	    case 'E':
	      return [path.join('.'), lhs, '\u2192', rhs];
	    case 'N':
	      return [path.join('.'), rhs];
	    case 'D':
	      return [path.join('.')];
	    case 'A':
	      return [path.join('.') + '[' + index + ']', item];
	    default:
	      return [];
	  }
	}
	
	function diffLogger(prevState, newState, logger, isCollapsed) {
	  var diff = (0, _deepDiff2.default)(prevState, newState);
	
	  try {
	    if (isCollapsed) {
	      logger.groupCollapsed('diff');
	    } else {
	      logger.group('diff');
	    }
	  } catch (e) {
	    logger.log('diff');
	  }
	
	  if (diff) {
	    diff.forEach(function (elem) {
	      var kind = elem.kind;
	
	      var output = render(elem);
	
	      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
	    });
	  } else {
	    logger.log('\u2014\u2014 no diff \u2014\u2014');
	  }
	
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logger = exports.defaults = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _core = __webpack_require__(924);
	
	var _helpers = __webpack_require__(397);
	
	var _defaults = __webpack_require__(925);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates logger with following options
	 *
	 * @namespace
	 * @param {object} options - options for logger
	 * @param {string | function | object} options.level - console[level]
	 * @param {boolean} options.duration - print duration of each action?
	 * @param {boolean} options.timestamp - print timestamp with each action?
	 * @param {object} options.colors - custom colors
	 * @param {object} options.logger - implementation of the `console` API
	 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @param {boolean} options.collapsed - is group collapsed?
	 * @param {boolean} options.predicate - condition which resolves logger behavior
	 * @param {function} options.stateTransformer - transform state before print
	 * @param {function} options.actionTransformer - transform action before print
	 * @param {function} options.errorTransformer - transform error before print
	 *
	 * @returns {function} logger middleware
	 */
	function createLogger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var loggerOptions = _extends({}, _defaults2.default, options);
	
	  var logger = loggerOptions.logger,
	      transformer = loggerOptions.transformer,
	      stateTransformer = loggerOptions.stateTransformer,
	      errorTransformer = loggerOptions.errorTransformer,
	      predicate = loggerOptions.predicate,
	      logErrors = loggerOptions.logErrors,
	      diffPredicate = loggerOptions.diffPredicate;
	
	  // Return if 'console' object is not defined
	
	  if (typeof logger === 'undefined') {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  if (transformer) {
	    console.error('Option \'transformer\' is deprecated, use \'stateTransformer\' instead!'); // eslint-disable-line no-console
	  }
	
	  // Detect if 'createLogger' was passed directly to 'applyMiddleware'.
	  if (options.getState && options.dispatch) {
	    // eslint-disable-next-line no-console
	    console.error('[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n\n// Logger with default options\nimport { logger } from \'redux-logger\'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n\n\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from \'redux-logger\'\n\nconst logger = createLogger({\n  // ...options\n});\n\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n');
	
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  var logBuffer = [];
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // Exit early if predicate function returns 'false'
	        if (typeof predicate === 'function' && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	        logBuffer.push(logEntry);
	
	        logEntry.started = _helpers.timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = void 0;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = _helpers.timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
	
	        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
	        logBuffer.length = 0;
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	var defaultLogger = createLogger();
	
	exports.defaults = _defaults2.default;
	exports.logger = defaultLogger;
	exports.default = createLogger;
	module.exports = exports['default'];


/***/ },
/* 928 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(398);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 930 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(399);
	
	var _isPlainObject = __webpack_require__(210);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(400);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 932 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 933 */
/***/ function(module, exports) {

	/*!
	* screenfull
	* v3.3.2 - 2017-10-27
	* (c) Sindre Sorhus; MIT License
	*/
	(function () {
		'use strict';
	
		var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
		var isCommonjs = typeof module !== 'undefined' && module.exports;
		var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;
	
		var fn = (function () {
			var val;
	
			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// New WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				// Old WebKit (Safari 5.1)
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];
	
			var i = 0;
			var l = fnMap.length;
			var ret = {};
	
			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0; i < val.length; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}
	
			return false;
		})();
	
		var eventNameMap = {
			change: fn.fullscreenchange,
			error: fn.fullscreenerror
		};
	
		var screenfull = {
			request: function (elem) {
				var request = fn.requestFullscreen;
	
				elem = elem || document.documentElement;
	
				// Work around Safari 5.1 bug: reports support for
				// keyboard in fullscreen even though it doesn't.
				// Browser sniffing, since the alternative with
				// setTimeout is even worse.
				if (/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) {
					elem[request]();
				} else {
					elem[request](keyboardAllowed && Element.ALLOW_KEYBOARD_INPUT);
				}
			},
			exit: function () {
				document[fn.exitFullscreen]();
			},
			toggle: function (elem) {
				if (this.isFullscreen) {
					this.exit();
				} else {
					this.request(elem);
				}
			},
			onchange: function (callback) {
				this.on('change', callback);
			},
			onerror: function (callback) {
				this.on('error', callback);
			},
			on: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.addEventListener(eventName, callback, false);
				}
			},
			off: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.removeEventListener(eventName, callback, false);
				}
			},
			raw: fn
		};
	
		if (!fn) {
			if (isCommonjs) {
				module.exports = false;
			} else {
				window.screenfull = false;
			}
	
			return;
		}
	
		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			enabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});
	
		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	})();


/***/ },
/* 934 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(936);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(401)(module)))

/***/ },
/* 936 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 937 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 938 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	var rng;
	
	var crypto = global.crypto || global.msCrypto; // for IE 11
	if (crypto && crypto.getRandomValues) {
	  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
	  // Moderately fast, high quality
	  var _rnds8 = new Uint8Array(16);
	  rng = function whatwgRNG() {
	    crypto.getRandomValues(_rnds8);
	    return _rnds8;
	  };
	}
	
	if (!rng) {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var  _rnds = new Array(16);
	  rng = function() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return _rnds;
	  };
	}
	
	module.exports = rng;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 939 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 940 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  var support = {
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob();
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = xhr.getAllResponseHeaders().trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers;
	  self.Request = Request;
	  self.Response = Response;
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return;
	      }
	
	      xhr.onload = function() {
	        var status = (xhr.status === 1223) ? 204 : xhr.status
	        if (status < 100 || status > 599) {
	          reject(new TypeError('Network request failed'))
	          return
	        }
	        var options = {
	          status: status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	function DOMParser(options){
		this.options = options ||{locator:{}};
		
	}
	DOMParser.prototype.parseFromString = function(source,mimeType){
		var options = this.options;
		var sax =  new XMLReader();
		var domBuilder = options.domBuilder || new DOMHandler();//contentHandler and LexicalHandler
		var errorHandler = options.errorHandler;
		var locator = options.locator;
		var defaultNSMap = options.xmlns||{};
		var entityMap = {'lt':'<','gt':'>','amp':'&','quot':'"','apos':"'"}
		if(locator){
			domBuilder.setDocumentLocator(locator)
		}
		
		sax.errorHandler = buildErrorHandler(errorHandler,domBuilder,locator);
		sax.domBuilder = options.domBuilder || domBuilder;
		if(/\/x?html?$/.test(mimeType)){
			entityMap.nbsp = '\xa0';
			entityMap.copy = '\xa9';
			defaultNSMap['']= 'http://www.w3.org/1999/xhtml';
		}
		defaultNSMap.xml = defaultNSMap.xml || 'http://www.w3.org/XML/1998/namespace';
		if(source){
			sax.parse(source,defaultNSMap,entityMap);
		}else{
			sax.errorHandler.error("invalid doc source");
		}
		return domBuilder.doc;
	}
	function buildErrorHandler(errorImpl,domBuilder,locator){
		if(!errorImpl){
			if(domBuilder instanceof DOMHandler){
				return domBuilder;
			}
			errorImpl = domBuilder ;
		}
		var errorHandler = {}
		var isCallback = errorImpl instanceof Function;
		locator = locator||{}
		function build(key){
			var fn = errorImpl[key];
			if(!fn && isCallback){
				fn = errorImpl.length == 2?function(msg){errorImpl(key,msg)}:errorImpl;
			}
			errorHandler[key] = fn && function(msg){
				fn('[xmldom '+key+']\t'+msg+_locator(locator));
			}||function(){};
		}
		build('warning');
		build('error');
		build('fatalError');
		return errorHandler;
	}
	
	//console.log('#\n\n\n\n\n\n\n####')
	/**
	 * +ContentHandler+ErrorHandler
	 * +LexicalHandler+EntityResolver2
	 * -DeclHandler-DTDHandler 
	 * 
	 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
	 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
	 */
	function DOMHandler() {
	    this.cdata = false;
	}
	function position(locator,node){
		node.lineNumber = locator.lineNumber;
		node.columnNumber = locator.columnNumber;
	}
	/**
	 * @see org.xml.sax.ContentHandler#startDocument
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
	 */ 
	DOMHandler.prototype = {
		startDocument : function() {
	    	this.doc = new DOMImplementation().createDocument(null, null, null);
	    	if (this.locator) {
	        	this.doc.documentURI = this.locator.systemId;
	    	}
		},
		startElement:function(namespaceURI, localName, qName, attrs) {
			var doc = this.doc;
		    var el = doc.createElementNS(namespaceURI, qName||localName);
		    var len = attrs.length;
		    appendElement(this, el);
		    this.currentElement = el;
		    
			this.locator && position(this.locator,el)
		    for (var i = 0 ; i < len; i++) {
		        var namespaceURI = attrs.getURI(i);
		        var value = attrs.getValue(i);
		        var qName = attrs.getQName(i);
				var attr = doc.createAttributeNS(namespaceURI, qName);
				this.locator &&position(attrs.getLocator(i),attr);
				attr.value = attr.nodeValue = value;
				el.setAttributeNode(attr)
		    }
		},
		endElement:function(namespaceURI, localName, qName) {
			var current = this.currentElement
			var tagName = current.tagName;
			this.currentElement = current.parentNode;
		},
		startPrefixMapping:function(prefix, uri) {
		},
		endPrefixMapping:function(prefix) {
		},
		processingInstruction:function(target, data) {
		    var ins = this.doc.createProcessingInstruction(target, data);
		    this.locator && position(this.locator,ins)
		    appendElement(this, ins);
		},
		ignorableWhitespace:function(ch, start, length) {
		},
		characters:function(chars, start, length) {
			chars = _toString.apply(this,arguments)
			//console.log(chars)
			if(chars){
				if (this.cdata) {
					var charNode = this.doc.createCDATASection(chars);
				} else {
					var charNode = this.doc.createTextNode(chars);
				}
				if(this.currentElement){
					this.currentElement.appendChild(charNode);
				}else if(/^\s*$/.test(chars)){
					this.doc.appendChild(charNode);
					//process xml
				}
				this.locator && position(this.locator,charNode)
			}
		},
		skippedEntity:function(name) {
		},
		endDocument:function() {
			this.doc.normalize();
		},
		setDocumentLocator:function (locator) {
		    if(this.locator = locator){// && !('lineNumber' in locator)){
		    	locator.lineNumber = 0;
		    }
		},
		//LexicalHandler
		comment:function(chars, start, length) {
			chars = _toString.apply(this,arguments)
		    var comm = this.doc.createComment(chars);
		    this.locator && position(this.locator,comm)
		    appendElement(this, comm);
		},
		
		startCDATA:function() {
		    //used in characters() methods
		    this.cdata = true;
		},
		endCDATA:function() {
		    this.cdata = false;
		},
		
		startDTD:function(name, publicId, systemId) {
			var impl = this.doc.implementation;
		    if (impl && impl.createDocumentType) {
		        var dt = impl.createDocumentType(name, publicId, systemId);
		        this.locator && position(this.locator,dt)
		        appendElement(this, dt);
		    }
		},
		/**
		 * @see org.xml.sax.ErrorHandler
		 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
		 */
		warning:function(error) {
			console.warn('[xmldom warning]\t'+error,_locator(this.locator));
		},
		error:function(error) {
			console.error('[xmldom error]\t'+error,_locator(this.locator));
		},
		fatalError:function(error) {
			console.error('[xmldom fatalError]\t'+error,_locator(this.locator));
		    throw error;
		}
	}
	function _locator(l){
		if(l){
			return '\n@'+(l.systemId ||'')+'#[line:'+l.lineNumber+',col:'+l.columnNumber+']'
		}
	}
	function _toString(chars,start,length){
		if(typeof chars == 'string'){
			return chars.substr(start,length)
		}else{//java sax connect width xmldom on rhino(what about: "? && !(chars instanceof String)")
			if(chars.length >= start+length || start){
				return new java.lang.String(chars,start,length)+'';
			}
			return chars;
		}
	}
	
	/*
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
	 * used method of org.xml.sax.ext.LexicalHandler:
	 *  #comment(chars, start, length)
	 *  #startCDATA()
	 *  #endCDATA()
	 *  #startDTD(name, publicId, systemId)
	 *
	 *
	 * IGNORED method of org.xml.sax.ext.LexicalHandler:
	 *  #endDTD()
	 *  #startEntity(name)
	 *  #endEntity(name)
	 *
	 *
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
	 * IGNORED method of org.xml.sax.ext.DeclHandler
	 * 	#attributeDecl(eName, aName, type, mode, value)
	 *  #elementDecl(name, model)
	 *  #externalEntityDecl(name, publicId, systemId)
	 *  #internalEntityDecl(name, value)
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
	 * IGNORED method of org.xml.sax.EntityResolver2
	 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
	 *  #resolveEntity(publicId, systemId)
	 *  #getExternalSubset(name, baseURI)
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
	 * IGNORED method of org.xml.sax.DTDHandler
	 *  #notationDecl(name, publicId, systemId) {};
	 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
	 */
	"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g,function(key){
		DOMHandler.prototype[key] = function(){return null}
	})
	
	/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */
	function appendElement (hander,node) {
	    if (!hander.currentElement) {
	        hander.doc.appendChild(node);
	    } else {
	        hander.currentElement.appendChild(node);
	    }
	}//appendChild and setAttributeNS are preformance key
	
	//if(typeof require == 'function'){
		var XMLReader = __webpack_require__(942).XMLReader;
		var DOMImplementation = exports.DOMImplementation = __webpack_require__(402).DOMImplementation;
		exports.XMLSerializer = __webpack_require__(402).XMLSerializer ;
		exports.DOMParser = DOMParser;
	//}


/***/ },
/* 942 */
/***/ function(module, exports) {

	//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
	//[5]   	Name	   ::=   	NameStartChar (NameChar)*
	var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]///\u10000-\uEFFFF
	var nameChar = new RegExp("[\\-\\.0-9"+nameStartChar.source.slice(1,-1)+"\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
	var tagNamePattern = new RegExp('^'+nameStartChar.source+nameChar.source+'*(?:\:'+nameStartChar.source+nameChar.source+'*)?$');
	//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
	//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
	
	//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
	//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
	var S_TAG = 0;//tag name offerring
	var S_ATTR = 1;//attr name offerring 
	var S_ATTR_SPACE=2;//attr name end and space offer
	var S_EQ = 3;//=space?
	var S_ATTR_NOQUOT_VALUE = 4;//attr value(no quot value only)
	var S_ATTR_END = 5;//attr value end and no space(quot end)
	var S_TAG_SPACE = 6;//(attr value end || tag end ) && (space offer)
	var S_TAG_CLOSE = 7;//closed el<el />
	
	function XMLReader(){
		
	}
	
	XMLReader.prototype = {
		parse:function(source,defaultNSMap,entityMap){
			var domBuilder = this.domBuilder;
			domBuilder.startDocument();
			_copy(defaultNSMap ,defaultNSMap = {})
			parse(source,defaultNSMap,entityMap,
					domBuilder,this.errorHandler);
			domBuilder.endDocument();
		}
	}
	function parse(source,defaultNSMapCopy,entityMap,domBuilder,errorHandler){
		function fixedFromCharCode(code) {
			// String.prototype.fromCharCode does not supports
			// > 2 bytes unicode chars directly
			if (code > 0xffff) {
				code -= 0x10000;
				var surrogate1 = 0xd800 + (code >> 10)
					, surrogate2 = 0xdc00 + (code & 0x3ff);
	
				return String.fromCharCode(surrogate1, surrogate2);
			} else {
				return String.fromCharCode(code);
			}
		}
		function entityReplacer(a){
			var k = a.slice(1,-1);
			if(k in entityMap){
				return entityMap[k]; 
			}else if(k.charAt(0) === '#'){
				return fixedFromCharCode(parseInt(k.substr(1).replace('x','0x')))
			}else{
				errorHandler.error('entity not found:'+a);
				return a;
			}
		}
		function appendText(end){//has some bugs
			if(end>start){
				var xt = source.substring(start,end).replace(/&#?\w+;/g,entityReplacer);
				locator&&position(start);
				domBuilder.characters(xt,0,end-start);
				start = end
			}
		}
		function position(p,m){
			while(p>=lineEnd && (m = linePattern.exec(source))){
				lineStart = m.index;
				lineEnd = lineStart + m[0].length;
				locator.lineNumber++;
				//console.log('line++:',locator,startPos,endPos)
			}
			locator.columnNumber = p-lineStart+1;
		}
		var lineStart = 0;
		var lineEnd = 0;
		var linePattern = /.*(?:\r\n?|\n)|.*$/g
		var locator = domBuilder.locator;
		
		var parseStack = [{currentNSMap:defaultNSMapCopy}]
		var closeMap = {};
		var start = 0;
		while(true){
			try{
				var tagStart = source.indexOf('<',start);
				if(tagStart<0){
					if(!source.substr(start).match(/^\s*$/)){
						var doc = domBuilder.doc;
		    			var text = doc.createTextNode(source.substr(start));
		    			doc.appendChild(text);
		    			domBuilder.currentElement = text;
					}
					return;
				}
				if(tagStart>start){
					appendText(tagStart);
				}
				switch(source.charAt(tagStart+1)){
				case '/':
					var end = source.indexOf('>',tagStart+3);
					var tagName = source.substring(tagStart+2,end);
					var config = parseStack.pop();
					if(end<0){
						
		        		tagName = source.substring(tagStart+2).replace(/[\s<].*/,'');
		        		//console.error('#@@@@@@'+tagName)
		        		errorHandler.error("end tag name: "+tagName+' is not complete:'+config.tagName);
		        		end = tagStart+1+tagName.length;
		        	}else if(tagName.match(/\s</)){
		        		tagName = tagName.replace(/[\s<].*/,'');
		        		errorHandler.error("end tag name: "+tagName+' maybe not complete');
		        		end = tagStart+1+tagName.length;
					}
					//console.error(parseStack.length,parseStack)
					//console.error(config);
					var localNSMap = config.localNSMap;
					var endMatch = config.tagName == tagName;
					var endIgnoreCaseMach = endMatch || config.tagName&&config.tagName.toLowerCase() == tagName.toLowerCase()
			        if(endIgnoreCaseMach){
			        	domBuilder.endElement(config.uri,config.localName,tagName);
						if(localNSMap){
							for(var prefix in localNSMap){
								domBuilder.endPrefixMapping(prefix) ;
							}
						}
						if(!endMatch){
			            	errorHandler.fatalError("end tag name: "+tagName+' is not match the current start tagName:'+config.tagName );
						}
			        }else{
			        	parseStack.push(config)
			        }
					
					end++;
					break;
					// end elment
				case '?':// <?...?>
					locator&&position(tagStart);
					end = parseInstruction(source,tagStart,domBuilder);
					break;
				case '!':// <!doctype,<![CDATA,<!--
					locator&&position(tagStart);
					end = parseDCC(source,tagStart,domBuilder,errorHandler);
					break;
				default:
					locator&&position(tagStart);
					var el = new ElementAttributes();
					var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
					//elStartEnd
					var end = parseElementStartPart(source,tagStart,el,currentNSMap,entityReplacer,errorHandler);
					var len = el.length;
					
					
					if(!el.closed && fixSelfClosed(source,end,el.tagName,closeMap)){
						el.closed = true;
						if(!entityMap.nbsp){
							errorHandler.warning('unclosed xml attribute');
						}
					}
					if(locator && len){
						var locator2 = copyLocator(locator,{});
						//try{//attribute position fixed
						for(var i = 0;i<len;i++){
							var a = el[i];
							position(a.offset);
							a.locator = copyLocator(locator,{});
						}
						//}catch(e){console.error('@@@@@'+e)}
						domBuilder.locator = locator2
						if(appendElement(el,domBuilder,currentNSMap)){
							parseStack.push(el)
						}
						domBuilder.locator = locator;
					}else{
						if(appendElement(el,domBuilder,currentNSMap)){
							parseStack.push(el)
						}
					}
					
					
					
					if(el.uri === 'http://www.w3.org/1999/xhtml' && !el.closed){
						end = parseHtmlSpecialContent(source,end,el.tagName,entityReplacer,domBuilder)
					}else{
						end++;
					}
				}
			}catch(e){
				errorHandler.error('element parse error: '+e)
				//errorHandler.error('element parse error: '+e);
				end = -1;
				//throw e;
			}
			if(end>start){
				start = end;
			}else{
				//TODO: 这里有可能sax回退，有位置错误风险
				appendText(Math.max(tagStart,start)+1);
			}
		}
	}
	function copyLocator(f,t){
		t.lineNumber = f.lineNumber;
		t.columnNumber = f.columnNumber;
		return t;
	}
	
	/**
	 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
	 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
	 */
	function parseElementStartPart(source,start,el,currentNSMap,entityReplacer,errorHandler){
		var attrName;
		var value;
		var p = ++start;
		var s = S_TAG;//status
		while(true){
			var c = source.charAt(p);
			switch(c){
			case '=':
				if(s === S_ATTR){//attrName
					attrName = source.slice(start,p);
					s = S_EQ;
				}else if(s === S_ATTR_SPACE){
					s = S_EQ;
				}else{
					//fatalError: equal must after attrName or space after attrName
					throw new Error('attribute equal must after attrName');
				}
				break;
			case '\'':
			case '"':
				if(s === S_EQ || s === S_ATTR //|| s == S_ATTR_SPACE
					){//equal
					if(s === S_ATTR){
						errorHandler.warning('attribute value must after "="')
						attrName = source.slice(start,p)
					}
					start = p+1;
					p = source.indexOf(c,start)
					if(p>0){
						value = source.slice(start,p).replace(/&#?\w+;/g,entityReplacer);
						el.add(attrName,value,start-1);
						s = S_ATTR_END;
					}else{
						//fatalError: no end quot match
						throw new Error('attribute value no end \''+c+'\' match');
					}
				}else if(s == S_ATTR_NOQUOT_VALUE){
					value = source.slice(start,p).replace(/&#?\w+;/g,entityReplacer);
					//console.log(attrName,value,start,p)
					el.add(attrName,value,start);
					//console.dir(el)
					errorHandler.warning('attribute "'+attrName+'" missed start quot('+c+')!!');
					start = p+1;
					s = S_ATTR_END
				}else{
					//fatalError: no equal before
					throw new Error('attribute value must after "="');
				}
				break;
			case '/':
				switch(s){
				case S_TAG:
					el.setTagName(source.slice(start,p));
				case S_ATTR_END:
				case S_TAG_SPACE:
				case S_TAG_CLOSE:
					s =S_TAG_CLOSE;
					el.closed = true;
				case S_ATTR_NOQUOT_VALUE:
				case S_ATTR:
				case S_ATTR_SPACE:
					break;
				//case S_EQ:
				default:
					throw new Error("attribute invalid close char('/')")
				}
				break;
			case ''://end document
				//throw new Error('unexpected end of input')
				errorHandler.error('unexpected end of input');
				if(s == S_TAG){
					el.setTagName(source.slice(start,p));
				}
				return p;
			case '>':
				switch(s){
				case S_TAG:
					el.setTagName(source.slice(start,p));
				case S_ATTR_END:
				case S_TAG_SPACE:
				case S_TAG_CLOSE:
					break;//normal
				case S_ATTR_NOQUOT_VALUE://Compatible state
				case S_ATTR:
					value = source.slice(start,p);
					if(value.slice(-1) === '/'){
						el.closed  = true;
						value = value.slice(0,-1)
					}
				case S_ATTR_SPACE:
					if(s === S_ATTR_SPACE){
						value = attrName;
					}
					if(s == S_ATTR_NOQUOT_VALUE){
						errorHandler.warning('attribute "'+value+'" missed quot(")!!');
						el.add(attrName,value.replace(/&#?\w+;/g,entityReplacer),start)
					}else{
						if(currentNSMap[''] !== 'http://www.w3.org/1999/xhtml' || !value.match(/^(?:disabled|checked|selected)$/i)){
							errorHandler.warning('attribute "'+value+'" missed value!! "'+value+'" instead!!')
						}
						el.add(value,value,start)
					}
					break;
				case S_EQ:
					throw new Error('attribute value missed!!');
				}
	//			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
				return p;
			/*xml space '\x20' | #x9 | #xD | #xA; */
			case '\u0080':
				c = ' ';
			default:
				if(c<= ' '){//space
					switch(s){
					case S_TAG:
						el.setTagName(source.slice(start,p));//tagName
						s = S_TAG_SPACE;
						break;
					case S_ATTR:
						attrName = source.slice(start,p)
						s = S_ATTR_SPACE;
						break;
					case S_ATTR_NOQUOT_VALUE:
						var value = source.slice(start,p).replace(/&#?\w+;/g,entityReplacer);
						errorHandler.warning('attribute "'+value+'" missed quot(")!!');
						el.add(attrName,value,start)
					case S_ATTR_END:
						s = S_TAG_SPACE;
						break;
					//case S_TAG_SPACE:
					//case S_EQ:
					//case S_ATTR_SPACE:
					//	void();break;
					//case S_TAG_CLOSE:
						//ignore warning
					}
				}else{//not space
	//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
	//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
					switch(s){
					//case S_TAG:void();break;
					//case S_ATTR:void();break;
					//case S_ATTR_NOQUOT_VALUE:void();break;
					case S_ATTR_SPACE:
						var tagName =  el.tagName;
						if(currentNSMap[''] !== 'http://www.w3.org/1999/xhtml' || !attrName.match(/^(?:disabled|checked|selected)$/i)){
							errorHandler.warning('attribute "'+attrName+'" missed value!! "'+attrName+'" instead2!!')
						}
						el.add(attrName,attrName,start);
						start = p;
						s = S_ATTR;
						break;
					case S_ATTR_END:
						errorHandler.warning('attribute space is required"'+attrName+'"!!')
					case S_TAG_SPACE:
						s = S_ATTR;
						start = p;
						break;
					case S_EQ:
						s = S_ATTR_NOQUOT_VALUE;
						start = p;
						break;
					case S_TAG_CLOSE:
						throw new Error("elements closed character '/' and '>' must be connected to");
					}
				}
			}//end outer switch
			//console.log('p++',p)
			p++;
		}
	}
	/**
	 * @return true if has new namespace define
	 */
	function appendElement(el,domBuilder,currentNSMap){
		var tagName = el.tagName;
		var localNSMap = null;
		//var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
		var i = el.length;
		while(i--){
			var a = el[i];
			var qName = a.qName;
			var value = a.value;
			var nsp = qName.indexOf(':');
			if(nsp>0){
				var prefix = a.prefix = qName.slice(0,nsp);
				var localName = qName.slice(nsp+1);
				var nsPrefix = prefix === 'xmlns' && localName
			}else{
				localName = qName;
				prefix = null
				nsPrefix = qName === 'xmlns' && ''
			}
			//can not set prefix,because prefix !== ''
			a.localName = localName ;
			//prefix == null for no ns prefix attribute 
			if(nsPrefix !== false){//hack!!
				if(localNSMap == null){
					localNSMap = {}
					//console.log(currentNSMap,0)
					_copy(currentNSMap,currentNSMap={})
					//console.log(currentNSMap,1)
				}
				currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
				a.uri = 'http://www.w3.org/2000/xmlns/'
				domBuilder.startPrefixMapping(nsPrefix, value) 
			}
		}
		var i = el.length;
		while(i--){
			a = el[i];
			var prefix = a.prefix;
			if(prefix){//no prefix attribute has no namespace
				if(prefix === 'xml'){
					a.uri = 'http://www.w3.org/XML/1998/namespace';
				}if(prefix !== 'xmlns'){
					a.uri = currentNSMap[prefix || '']
					
					//{console.log('###'+a.qName,domBuilder.locator.systemId+'',currentNSMap,a.uri)}
				}
			}
		}
		var nsp = tagName.indexOf(':');
		if(nsp>0){
			prefix = el.prefix = tagName.slice(0,nsp);
			localName = el.localName = tagName.slice(nsp+1);
		}else{
			prefix = null;//important!!
			localName = el.localName = tagName;
		}
		//no prefix element has default namespace
		var ns = el.uri = currentNSMap[prefix || ''];
		domBuilder.startElement(ns,localName,tagName,el);
		//endPrefixMapping and startPrefixMapping have not any help for dom builder
		//localNSMap = null
		if(el.closed){
			domBuilder.endElement(ns,localName,tagName);
			if(localNSMap){
				for(prefix in localNSMap){
					domBuilder.endPrefixMapping(prefix) 
				}
			}
		}else{
			el.currentNSMap = currentNSMap;
			el.localNSMap = localNSMap;
			//parseStack.push(el);
			return true;
		}
	}
	function parseHtmlSpecialContent(source,elStartEnd,tagName,entityReplacer,domBuilder){
		if(/^(?:script|textarea)$/i.test(tagName)){
			var elEndStart =  source.indexOf('</'+tagName+'>',elStartEnd);
			var text = source.substring(elStartEnd+1,elEndStart);
			if(/[&<]/.test(text)){
				if(/^script$/i.test(tagName)){
					//if(!/\]\]>/.test(text)){
						//lexHandler.startCDATA();
						domBuilder.characters(text,0,text.length);
						//lexHandler.endCDATA();
						return elEndStart;
					//}
				}//}else{//text area
					text = text.replace(/&#?\w+;/g,entityReplacer);
					domBuilder.characters(text,0,text.length);
					return elEndStart;
				//}
				
			}
		}
		return elStartEnd+1;
	}
	function fixSelfClosed(source,elStartEnd,tagName,closeMap){
		//if(tagName in closeMap){
		var pos = closeMap[tagName];
		if(pos == null){
			//console.log(tagName)
			pos =  source.lastIndexOf('</'+tagName+'>')
			if(pos<elStartEnd){//忘记闭合
				pos = source.lastIndexOf('</'+tagName)
			}
			closeMap[tagName] =pos
		}
		return pos<elStartEnd;
		//} 
	}
	function _copy(source,target){
		for(var n in source){target[n] = source[n]}
	}
	function parseDCC(source,start,domBuilder,errorHandler){//sure start with '<!'
		var next= source.charAt(start+2)
		switch(next){
		case '-':
			if(source.charAt(start + 3) === '-'){
				var end = source.indexOf('-->',start+4);
				//append comment source.substring(4,end)//<!--
				if(end>start){
					domBuilder.comment(source,start+4,end-start-4);
					return end+3;
				}else{
					errorHandler.error("Unclosed comment");
					return -1;
				}
			}else{
				//error
				return -1;
			}
		default:
			if(source.substr(start+3,6) == 'CDATA['){
				var end = source.indexOf(']]>',start+9);
				domBuilder.startCDATA();
				domBuilder.characters(source,start+9,end-start-9);
				domBuilder.endCDATA() 
				return end+3;
			}
			//<!DOCTYPE
			//startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId) 
			var matchs = split(source,start);
			var len = matchs.length;
			if(len>1 && /!doctype/i.test(matchs[0][0])){
				var name = matchs[1][0];
				var pubid = len>3 && /^public$/i.test(matchs[2][0]) && matchs[3][0]
				var sysid = len>4 && matchs[4][0];
				var lastMatch = matchs[len-1]
				domBuilder.startDTD(name,pubid && pubid.replace(/^(['"])(.*?)\1$/,'$2'),
						sysid && sysid.replace(/^(['"])(.*?)\1$/,'$2'));
				domBuilder.endDTD();
				
				return lastMatch.index+lastMatch[0].length
			}
		}
		return -1;
	}
	
	
	
	function parseInstruction(source,start,domBuilder){
		var end = source.indexOf('?>',start);
		if(end){
			var match = source.substring(start,end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
			if(match){
				var len = match[0].length;
				domBuilder.processingInstruction(match[1], match[2]) ;
				return end+2;
			}else{//error
				return -1;
			}
		}
		return -1;
	}
	
	/**
	 * @param source
	 */
	function ElementAttributes(source){
		
	}
	ElementAttributes.prototype = {
		setTagName:function(tagName){
			if(!tagNamePattern.test(tagName)){
				throw new Error('invalid tagName:'+tagName)
			}
			this.tagName = tagName
		},
		add:function(qName,value,offset){
			if(!tagNamePattern.test(qName)){
				throw new Error('invalid attribute:'+qName)
			}
			this[this.length++] = {qName:qName,value:value,offset:offset}
		},
		length:0,
		getLocalName:function(i){return this[i].localName},
		getLocator:function(i){return this[i].locator},
		getQName:function(i){return this[i].qName},
		getURI:function(i){return this[i].uri},
		getValue:function(i){return this[i].value}
	//	,getIndex:function(uri, localName)){
	//		if(localName){
	//			
	//		}else{
	//			var qName = uri
	//		}
	//	},
	//	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
	//	getType:function(uri,localName){}
	//	getType:function(i){},
	}
	
	
	
	
	function _set_proto_(thiz,parent){
		thiz.__proto__ = parent;
		return thiz;
	}
	if(!(_set_proto_({},_set_proto_.prototype) instanceof _set_proto_)){
		_set_proto_ = function(thiz,parent){
			function p(){};
			p.prototype = parent;
			p = new p();
			for(parent in thiz){
				p[parent] = thiz[parent];
			}
			return p;
		}
	}
	
	function split(source,start){
		var match;
		var buf = [];
		var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
		reg.lastIndex = start;
		reg.exec(source);//skip <
		while(match = reg.exec(source)){
			buf.push(match);
			if(match[1])return buf;
		}
	}
	
	exports.XMLReader = XMLReader;
	


/***/ },
/* 943 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/